
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("gJN0g", function(module, exports) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.41
   Copyright © 2012-2025 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.41', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HONOR = 'Honor', HUAWEI = 'Huawei', LENOVO = 'Lenovo', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', NVIDIA = 'Nvidia', ONEPLUS = 'OnePlus', OPERA = 'Opera', OPPO = 'OPPO', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /(daum)apps[\/ ]([\w\.]+)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser/Ladybird
                /\b(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /\b((amd|x|x86[-_]?|wow|win)64)\b/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i,
                /\b((i[346]|x)86)(pc)?\b/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((ppc|powerpc)(64)?)( mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                / sun4\w[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /honor([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HONOR
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
                /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
                / ([\w ]+) miui\/v?\d/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2(\d{3}a?))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    strMapper,
                    {
                        'OnePlus': [
                            '304',
                            '403',
                            '203'
                        ],
                        '*': OPPO
                    }
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
                /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LENOVO
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(nokia) (t[12][01])/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
                /nokia[-_ ]?(([-\w\. ]*))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ],
                [
                    VENDOR,
                    'Nokia'
                ]
            ],
            [
                // Google
                /(pixel (c|tablet))\b/i // Google Pixel C/Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Archos
                /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
                /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /archos ([\w ]+)( b|\))/i,
                /; (ac[3-6]\d\w{2,8})( b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Archos'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(imo) (tab \w+)/i,
                /(infinix) (x1101b?)/i // Infinix XPad
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i // Nvidia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(shield \w+ tv)/i // Nvidia Shield TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mi(tv|box)-?\w+) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                // SmartTV from Unidentified Vendors
                /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield)( bui|\))/i // Nvidia Portable
            ],
            [
                MODEL,
                [
                    VENDOR,
                    NVIDIA
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation \w+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i,
                /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i // Asus ZenWatch / LG Watch / Pixel Watch
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(ow(?:19|20)?we?[1-3]{1,3})/i // Oppo Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    OPPO
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(opwwe\d{3})/i // OnePlus Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ONEPLUS
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(moto 360)/i // Motorola 360
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(smartwatch 3)/i // Sony SmartWatch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(g watch r)/i // LG G Watch R
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(homepod).+mac os/i // Apple HomePod
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /windows iot/i
            ],
            [
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([\w\. -]+)( bui|\))/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i // LibWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /ladybird\//i
            ],
            [
                [
                    NAME,
                    'LibWeb'
                ]
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(ubuntu) ([\w\.]+) like android/i // Ubuntu Touch
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Touch'
                ],
                VERSION
            ],
            [
                // Android/Blackberry/WebOS/QNX/Bada/RIM/KaiOS/Maemo/MeeGo/S40/Sailfish OS/OpenHarmony/Tizen
                /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

});

parcelRegister("cRN1p", function(module, exports) {

var $3IE7e = parcelRequire("3IE7e");


var $iDrrr = parcelRequire("iDrrr");


var $bTZ0F = parcelRequire("bTZ0F");





var $bH6Zn = parcelRequire("bH6Zn");

let $0bccc562011c3eb0$var$pe = null;
function $0bccc562011c3eb0$export$619cdeadfd90f3e4() {
    if (typeof PerformanceObserver !== 'function') // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($0bccc562011c3eb0$var$pe !== null) return $0bccc562011c3eb0$var$pe;
    const performanceObserverCallback = (list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift) (0, $bH6Zn.EntriesBuffer)[(0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $bTZ0F.PerformanceObserverEntryTypes).LongTask) (0, $bH6Zn.EntriesBuffer)[(0, $bTZ0F.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $0bccc562011c3eb0$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $0bccc562011c3eb0$var$pe;
}


function $216fd9ef087f9b1e$export$768ccc3ab7bac3ea() {
    (0, $0bccc562011c3eb0$export$619cdeadfd90f3e4)()?.observe({
        type: (0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}






function $e622a59c3434b36e$export$54fb8b6aaf70ec9c() {
    (0, $0bccc562011c3eb0$export$619cdeadfd90f3e4)()?.observe({
        type: (0, $bTZ0F.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}


function $e226cd08862f770e$export$5ecf2aafafee3e0() {
    (0, $216fd9ef087f9b1e$export$768ccc3ab7bac3ea)();
    (0, $e622a59c3434b36e$export$54fb8b6aaf70ec9c)();
}



var $jtTx3 = parcelRequire("jtTx3");


var $1AQyp = parcelRequire("1AQyp");

function $7c43f85c7225d6cd$export$e6a07a94f3e112d4(sinkFn) {
    for (const { interactionId: interactionId, data: data } of (0, $1AQyp.interactionBufferState).interactionBuffer)sinkFn(interactionId, data);
    (0, $1AQyp.interactionBufferState).interactionBuffer.length = 0;
    (0, $1AQyp.interactionBufferState).bufferInteractionData = sinkFn;
}



var $aK89A = parcelRequire("aK89A");


var $8fj6C = parcelRequire("8fj6C");


var $a33Aa = parcelRequire("a33Aa");







const $305e427ed9de0327$var$nameCache = new WeakMap();
function $305e427ed9de0327$var$getAttributeSelector(element, attributeName) {
    const attrValue = element.getAttribute(attributeName);
    if (!attrValue) return '';
    return `[${attributeName}="${attrValue}"]`;
}
function $305e427ed9de0327$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch  {
        return false;
    }
}
function $305e427ed9de0327$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $305e427ed9de0327$var$getUniqueSelector(selectorConfig, element) {
    let currentElement = element;
    const parts = [];
    const MAX_DEPTH = 3;
    let currentDepth = 0;
    while(currentElement && currentElement.localName !== 'body' && currentDepth <= MAX_DEPTH){
        const tagName = currentElement.localName;
        let selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $305e427ed9de0327$var$isValidSelector(`#${currentElement.id}`)) selectorPart += `#${currentElement.id}`;
        else if (selectorConfig.dataVC) selectorPart += $305e427ed9de0327$var$getAttributeSelector(currentElement, 'data-vc');
        else if (selectorConfig.testId) selectorPart += $305e427ed9de0327$var$getAttributeSelector(currentElement, 'data-testid') || $305e427ed9de0327$var$getAttributeSelector(currentElement, 'data-test-id');
        else if (selectorConfig.role) selectorPart += $305e427ed9de0327$var$getAttributeSelector(currentElement, 'role');
        else if (selectorConfig.className && currentElement.className) {
            const classNames = Array.from(currentElement.classList).join('.');
            if (classNames) {
                if ($305e427ed9de0327$var$isValidSelector(`.${classNames}`)) selectorPart += `.${classNames}`;
            }
        }
        parts.unshift(selectorPart);
        const potentialSelector = parts.join(' > ').trim();
        if (potentialSelector && $305e427ed9de0327$var$isSelectorUnique(potentialSelector)) return potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    const potentialSelector = parts.join(' > ').trim();
    if (!potentialSelector) return 'unknown';
    else if (!$305e427ed9de0327$var$isSelectorUnique(potentialSelector)) {
        const parentElement = element.parentElement;
        if (parentElement) return `${potentialSelector}:nth-child`; // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $305e427ed9de0327$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return 'error';
    const cachedName = $305e427ed9de0327$var$nameCache.get(element);
    if (cachedName) return cachedName;
    const uniqueSelector = $305e427ed9de0327$var$getUniqueSelector(selectorConfig, element);
    $305e427ed9de0327$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $305e427ed9de0327$export$2e2bcd8739ae039 = $305e427ed9de0327$var$getElementName;


const $011da34d4894e558$var$DEFAULT_SELECTOR_CONFIG = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $011da34d4894e558$var$resolveSelectorConfig() {
    return (0, $jtTx3.getSelectorConfig)() ?? $011da34d4894e558$var$DEFAULT_SELECTOR_CONFIG;
}
function $011da34d4894e558$var$getTestIdName(memoizedProps) {
    if (memoizedProps['data-testid']) return `[data-testid=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-test-id']) return `[data-test-id=${memoizedProps['data-testid']}]`;
    else if (memoizedProps['data-vc']) return `[data-vc=${memoizedProps['data-vc']}]`;
    return null;
}
function $011da34d4894e558$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps['name']) return `UFOSegment[name=${memoizedProps['name']}]`;
    return componentName;
}
function $011da34d4894e558$var$getReactComponentHierarchy(element) {
    const componentHierarchy = [];
    function traverseFiber(fiber) {
        let currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                const componentName = currentFiber.type.displayName || currentFiber.type.name;
                if (componentName && componentName.length > 2 && !componentName.includes('Listener') && !componentName.includes('Provider')) {
                    if (componentName === 'UFOSegment') {
                        componentHierarchy.push($011da34d4894e558$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                const dataIdInfo = $011da34d4894e558$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    const reactFiberKey = Object.keys(element).find((key)=>key.startsWith('__reactFiber$'));
    if (reactFiberKey) {
        const fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(' > ');
}
const $011da34d4894e558$export$e6be05b411ce21a6 = (entry)=>{
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction?.type === 'press') {
        if (!interaction.responsiveness?.experimentalInputToNextPaint) {
            interaction.responsiveness = {
                ...interaction.responsiveness,
                experimentalInputToNextPaint: interaction.responsiveness?.experimentalInputToNextPaint || entry.duration,
                inputDelay: interaction.responsiveness?.inputDelay || entry.processingStart - entry.startTime
            };
            if (interaction.ufoName === 'unknown') {
                if (entry.target) interaction.unknownElementHierarchy = $011da34d4894e558$var$getReactComponentHierarchy(entry.target);
                interaction.unknownElementName = (0, $305e427ed9de0327$export$2e2bcd8739ae039)($011da34d4894e558$var$resolveSelectorConfig(), entry.target);
            }
        }
    }
};


let $58b82a44163eda99$var$performanceEventObserver;
const $58b82a44163eda99$export$17afbba0f16b4b19 = ()=>{
    $58b82a44163eda99$var$performanceEventObserver = $58b82a44163eda99$var$performanceEventObserver || new PerformanceObserver((entries)=>{
        const list = entries.getEntries();
        for (const entry of list)if (entry.name === 'click') (0, $011da34d4894e558$export$e6be05b411ce21a6)(entry);
    });
    return $58b82a44163eda99$var$performanceEventObserver;
};



var $ogRoY = parcelRequire("ogRoY");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $34MZN = parcelRequire("34MZN");


var $dUAp3 = parcelRequire("dUAp3");





var $bC8sq = parcelRequire("bC8sq");

const $52c3b12aaa825dc6$var$ABORT_ERROR_NAMES = new Set([
    'AbortError'
]);
const $52c3b12aaa825dc6$var$ABORT_ERROR_MESSAGES = [
    'The operation was aborted',
    'auth_window_closed'
];
// Only treated as abort when combined with AuthError name — the same string
// can appear in other error messages (e.g. 403 response bodies) where it
// should not be classified as abort.
const $52c3b12aaa825dc6$var$AUTH_ERROR_ABORT_MESSAGES = [
    'access_denied'
];
// AuthError is thrown by @atlaskit/outbound-auth-flow-client during OAuth flows
// (e.g. connecting third-party apps like GitHub or Bitbucket to Jira).
// User-initiated outcomes (closing the popup, denying consent) are classified
// as abort; server/config failures are classified as auth.
const $52c3b12aaa825dc6$var$AUTH_ERROR_NAMES = new Set([
    'AuthError'
]);
const $52c3b12aaa825dc6$var$CHUNK_LOAD_ERROR_NAMES = new Set([
    'ChunkLoadError'
]);
const $52c3b12aaa825dc6$var$CHUNK_LOAD_ERROR_MESSAGES = [
    'Unable to fetch manifest',
    'dynamically imported module',
    'Importing a module script failed'
];
const $52c3b12aaa825dc6$var$NETWORK_CLIENT_ERROR_NAMES = new Set([
    'NetworkError',
    'Network error'
]);
const $52c3b12aaa825dc6$var$NETWORK_CLIENT_ERROR_MESSAGES = [
    'Failed to fetch',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'server with the specified hostname could not be found',
    'The network connection was lost',
    'The request timed out',
    'connection failure',
    'CloseEvent: Ping timeout',
    'Curl Error: Failure when receiving data from the peer'
];
const $52c3b12aaa825dc6$var$NETWORK_SERVER_ERROR_MESSAGES = [
    '... is not valid JSON',
    'in JSON at position 0',
    'JSON.parse: unexpected character',
    'JSON.parse: unexpected end of data',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'cannot parse response',
    'Syntax or http error'
];
function $52c3b12aaa825dc6$var$matchesCategory(error) {
    const name = error.name ?? '';
    const message = error.message ?? '';
    if ($52c3b12aaa825dc6$var$ABORT_ERROR_NAMES.has(name) || $52c3b12aaa825dc6$var$ABORT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern)) || // OAuth Abort errors
    $52c3b12aaa825dc6$var$AUTH_ERROR_NAMES.has(name) && $52c3b12aaa825dc6$var$AUTH_ERROR_ABORT_MESSAGES.some((pattern)=>message.includes(pattern))) return 'abort';
    if ($52c3b12aaa825dc6$var$AUTH_ERROR_NAMES.has(name)) return 'auth';
    if ($52c3b12aaa825dc6$var$CHUNK_LOAD_ERROR_NAMES.has(name) || $52c3b12aaa825dc6$var$CHUNK_LOAD_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'chunk-load';
    if ($52c3b12aaa825dc6$var$NETWORK_CLIENT_ERROR_NAMES.has(name) || $52c3b12aaa825dc6$var$NETWORK_CLIENT_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-client';
    if ($52c3b12aaa825dc6$var$NETWORK_SERVER_ERROR_MESSAGES.some((pattern)=>message.includes(pattern))) return 'network-server';
    return null;
}
function $52c3b12aaa825dc6$export$17e837b2daecf805(error) {
    const directMatch = $52c3b12aaa825dc6$var$matchesCategory(error);
    if (directMatch) return directMatch;
    if (typeof error === 'object' && error !== null && 'cause' in error && error.cause instanceof Error) {
        const cause = error.cause;
        const causeMatch = $52c3b12aaa825dc6$var$matchesCategory(cause);
        if (causeMatch) return causeMatch;
    }
    return 'product';
}


let $19532a315fc91766$var$sinkHandlerFn = ()=>{};
function $19532a315fc91766$export$e5fa3ac6dc44efff(fn) {
    $19532a315fc91766$var$sinkHandlerFn = fn;
}
const $19532a315fc91766$var$RELAY_NETWORK_ERRORS_NAME = 'RelayNetwork';
const $19532a315fc91766$export$1a949ef92fd30eca = (error)=>error.name === $19532a315fc91766$var$RELAY_NETWORK_ERRORS_NAME;
const $19532a315fc91766$var$isErrorObject = (error)=>typeof error === 'object' && error !== null;
const $19532a315fc91766$var$getErrorStatusCode = (error)=>{
    if (!$19532a315fc91766$var$isErrorObject(error)) return undefined;
    if ($19532a315fc91766$export$1a949ef92fd30eca(error)) return error.source?.errors?.[0]?.extensions?.statusCode;
    if ('statusCode' in error && typeof error.statusCode === 'number') return error.statusCode;
    return undefined;
};
const $19532a315fc91766$var$getErrorTraceId = (error)=>$19532a315fc91766$var$isErrorObject(error) && 'traceId' in error && typeof error.traceId === 'string' ? error.traceId : undefined;
function $19532a315fc91766$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    const activeInteraction = (0, $a33Aa.getActiveInteraction)();
    const currentTime = performance.now();
    const baseErrorData = {
        errorType: error.name || 'Error',
        errorMessage: error.message?.slice(0, 100) || 'Unknown error',
        timestamp: currentTime,
        errorCategory: (0, $52c3b12aaa825dc6$export$17e837b2daecf805)(error)
    };
    const errorData = {
        ...baseErrorData,
        statusCode: additionalAttributes?.statusCode ?? $19532a315fc91766$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (0, $34MZN.getActiveTrace)()?.traceId ?? $19532a315fc91766$var$getErrorTraceId(error),
        teamName: additionalAttributes?.teamName,
        packageName: additionalAttributes?.packageName,
        errorBoundaryId: additionalAttributes?.errorBoundaryId,
        errorHash: additionalAttributes?.errorHash,
        fallbackType: additionalAttributes?.fallbackType
    };
    // Calculate time since previous interaction
    const timeSincePreviousInteraction = (0, $a33Aa.PreviousInteractionLog).timestamp != null ? currentTime - (0, $a33Aa.PreviousInteractionLog).timestamp : null;
    const context = {
        labelStack: labelStack ?? null,
        activeInteractionName: activeInteraction?.ufoName ?? null,
        activeInteractionId: activeInteraction?.id ?? null,
        activeInteractionType: activeInteraction?.type ?? null,
        previousInteractionId: (0, $a33Aa.PreviousInteractionLog).id ?? null,
        previousInteractionName: (0, $a33Aa.PreviousInteractionLog).name ?? null,
        previousInteractionType: (0, $a33Aa.PreviousInteractionLog).type ?? null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (0, $bC8sq.default).current ?? null
    };
    $19532a315fc91766$var$sinkHandlerFn(errorData, context);
}
const $19532a315fc91766$export$79ee0f0d40355053 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useReportTerminalError(error, additionalAttributes) {
    const $ = (0, $bDgLe.c)(8);
    const interactionContext = (0, $dUAp3.useInteractionContext)();
    const hasReportedRef = (0, $cozmU.useRef)(false);
    let t0;
    if ($[0] !== additionalAttributes || $[1] !== error || $[2] !== interactionContext?.labelStack) {
        t0 = ()=>{
            if (error && !hasReportedRef.current) {
                hasReportedRef.current = true;
                $19532a315fc91766$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
            }
        };
        $[0] = additionalAttributes;
        $[1] = error;
        $[2] = interactionContext?.labelStack;
        $[3] = t0;
    } else t0 = $[3];
    const t1 = interactionContext?.labelStack;
    let t2;
    if ($[4] !== additionalAttributes || $[5] !== error || $[6] !== t1) {
        t2 = [
            error,
            additionalAttributes,
            t1
        ];
        $[4] = additionalAttributes;
        $[5] = error;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    (0, $cozmU.useEffect)(t0, t2);
} : function useReportTerminalError(error, additionalAttributes) {
    const interactionContext = (0, $dUAp3.useInteractionContext)();
    const hasReportedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $19532a315fc91766$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext?.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext?.labelStack
    ]);
};



var $2tbpa = parcelRequire("2tbpa");


var $bHUUH = parcelRequire("bHUUH");




const $27122965bb3ffe64$var$getNativeScheduler = ()=>{
    const nativeScheduler = globalThis.scheduler;
    return typeof nativeScheduler?.postTask === 'function' ? nativeScheduler : undefined;
};
/**
 * Schedules `work` at idle priority using native browser APIs, in order of preference:
 * `requestIdleCallback`, then `scheduler.postTask` with `background` priority, then
 * `setTimeout(work, 0)` (e.g. Safari or SSR, where neither API is available).
 */ function $27122965bb3ffe64$var$scheduleNativeIdleTask(work) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(work);
        return;
    }
    const nativeScheduler = $27122965bb3ffe64$var$getNativeScheduler();
    if (nativeScheduler) {
        nativeScheduler.postTask(work, {
            priority: 'background'
        });
        return;
    }
    setTimeout(work, 0);
}
/**
 * Schedules `work` to run at idle priority.
 *
 * When `platform_ufo_native_task_scheduling` is enabled, uses native browser scheduling instead of
 * the `scheduler` npm package, which is being removed for React 19 compatibility.
 */ function $27122965bb3ffe64$var$scheduleIdleCallback(work) {
    if ((0, $iDrrr.fg)('platform_ufo_native_task_scheduling')) {
        $27122965bb3ffe64$var$scheduleNativeIdleTask(work);
        return;
    }
    (0, $bHUUH.unstable_scheduleCallback)((0, $bHUUH.unstable_IdlePriority), work);
}
var $27122965bb3ffe64$export$2e2bcd8739ae039 = $27122965bb3ffe64$var$scheduleIdleCallback;


let $5c686aa3f898d78f$var$initialized = false;
function $5c686aa3f898d78f$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $27122965bb3ffe64$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $a33Aa.sinkInteractionHandler)(sinkFn);
}
function $5c686aa3f898d78f$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $a33Aa.sinkPostInteractionLogHandler)((logOutput)=>{
        (0, $27122965bb3ffe64$export$2e2bcd8739ae039)(()=>{
            const payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $5c686aa3f898d78f$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $19532a315fc91766$export$e5fa3ac6dc44efff)((errorData, context)=>{
        (0, $27122965bb3ffe64$export$2e2bcd8739ae039)(()=>{
            const payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $5c686aa3f898d78f$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then((payloads)=>{
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                const devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads?.forEach((payload)=>{
                    if (typeof devToolObserver === 'function') devToolObserver?.(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch((error)=>{
                throw error;
            });
        }
        (0, $27122965bb3ffe64$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $7c43f85c7225d6cd$export$e6a07a94f3e112d4)(sinkFn);
}




function $5c686aa3f898d78f$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    if ($5c686aa3f898d78f$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $jtTx3.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $jtTx3.isUFOEnabled)()) {
        $5c686aa3f898d78f$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $ogRoY.initialisePressureObserver)();
    (0, $ogRoY.initialiseMemoryObserver)();
    if ((0, $iDrrr.fg)('platform_ufo_enable_otel_context_manager')) {
        // Configure global OTel context manager
        const contextManager = new (0, $aK89A.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $aK89A.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $3IE7e.context).setGlobalContextManager(contextManager);
    }
    if (config.vc?.enabled) {
        const vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            // Use centralised getter so the FedRAMP override (forces every
            // selector field to false) is applied consistently.
            selectorConfig: (0, $jtTx3.getSelectorConfig)(),
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $a33Aa.postInteractionLog).initializeVCObserver(vcOptions);
    }
    (0, $8fj6C.setupHiddenTimingCapture)();
    (0, $e226cd08862f770e$export$5ecf2aafafee3e0)();
    if ((0, $iDrrr.fg)('platform_ufo_soft_nav_paint_metrics')) (0, $2tbpa.ensureSoftNavigationObserved)();
    (0, $8fj6C.setupThrottleDetection)();
    $5c686aa3f898d78f$var$initialized = true;
    if (typeof PerformanceObserver !== 'undefined') {
        const observer = (0, $58b82a44163eda99$export$17afbba0f16b4b19)();
        observer.observe({
            type: 'event',
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("6R8n4")),
        (parcelRequire("iP1ZM")),
        (parcelRequire("cviBU")),
        (parcelRequire("eTb2c"))
    ]).then(([awc, payloadPackage, extraPayloadPackage, createPostInteractionLogPayloadPackage, createTerminalErrorPayloadPackage])=>{
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then((client)=>{
            const instance = client.getInstance();
            $5c686aa3f898d78f$var$sinkInteraction(instance, payloadPackage);
            if (config?.terminalErrors?.enabled) $5c686aa3f898d78f$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $5c686aa3f898d78f$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $5c686aa3f898d78f$var$sinkExtraSearchPageInteraction(instance, extraPayloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            $5c686aa3f898d78f$var$sinkInteraction(awc, payloadPackage);
            if (config?.terminalErrors?.enabled) $5c686aa3f898d78f$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config.postInteractionLog?.enabled) $5c686aa3f898d78f$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config?.extraSearchPageInteraction?.enabled) $5c686aa3f898d78f$var$sinkExtraSearchPageInteraction(awc, extraPayloadPackage);
        }
    });
}
module.exports["init"] = $5c686aa3f898d78f$export$2cd8252107eb640b;

});

parcelRegister("ogRoY", function(module, exports) {
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $2d6e535ff0126aa2$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
let $2d6e535ff0126aa2$var$pressureRecordBuffer = [];
let $2d6e535ff0126aa2$var$pressureObserver = null;
let $2d6e535ff0126aa2$var$memoryRecordBuffer = [];
let $2d6e535ff0126aa2$var$memoryInterval;
function $2d6e535ff0126aa2$export$6c1060bed5fea050() {
    $2d6e535ff0126aa2$var$pressureRecordBuffer.length = 0;
}
function $2d6e535ff0126aa2$export$aa672c7221b183b0() {
    $2d6e535ff0126aa2$var$memoryRecordBuffer.length = 0;
}
function $2d6e535ff0126aa2$export$ec86686c1d2e65bc(filter) {
    $2d6e535ff0126aa2$var$pressureRecordBuffer = $2d6e535ff0126aa2$var$pressureRecordBuffer.filter(({ time: time })=>time > filter);
}
function $2d6e535ff0126aa2$export$c0142ac82f5d0c28(filter) {
    $2d6e535ff0126aa2$var$memoryRecordBuffer = $2d6e535ff0126aa2$var$memoryRecordBuffer.filter(({ time: time })=>time > filter);
}
function $2d6e535ff0126aa2$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!('PressureObserver' in globalThis)) return null;
        const pressureStateCount = $2d6e535ff0126aa2$var$pressureRecordBuffer.reduce((pressureReport, { time: time, state: state })=>{
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        const pressureStateTotal = Object.values(pressureStateCount).reduce((total, count)=>total + count) || 1;
        $2d6e535ff0126aa2$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch  {
        return null;
    }
}
function $2d6e535ff0126aa2$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $2d6e535ff0126aa2$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!('memory' in performance)) return null;
        const accumulatedMemoryUsage = $2d6e535ff0126aa2$var$memoryRecordBuffer.reduce((acc, snapshot)=>{
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        const memoryStateReport = {
            jsHeapSizeLimitInMB: $2d6e535ff0126aa2$var$convertBytesToMegabytes($2d6e535ff0126aa2$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $2d6e535ff0126aa2$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $2d6e535ff0126aa2$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $2d6e535ff0126aa2$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch  {
        return null;
    }
}
function $2d6e535ff0126aa2$export$117ebc554c6e9f2f() {
    try {
        if ('PressureObserver' in globalThis) {
            $2d6e535ff0126aa2$var$pressureObserver = new PressureObserver((records)=>{
                if ($2d6e535ff0126aa2$var$pressureRecordBuffer.length + records.length <= $2d6e535ff0126aa2$var$BUFFER_MAX_LENGTH) $2d6e535ff0126aa2$var$pressureRecordBuffer.push(...records);
            });
            $2d6e535ff0126aa2$var$pressureObserver.observe('cpu', {
                sampleInterval: 100
            }).catch(()=>{
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $2d6e535ff0126aa2$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ('memory' in performance) $2d6e535ff0126aa2$var$memoryInterval = setInterval(()=>{
            // another check of `performance.memory` availability to satisfy typescript
            if ('memory' in performance) {
                const memory = performance.memory;
                if ($2d6e535ff0126aa2$var$memoryRecordBuffer.length <= $2d6e535ff0126aa2$var$BUFFER_MAX_LENGTH) $2d6e535ff0126aa2$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch  {
    /* do nothing, this is a best efforts metric */ }
}
function $2d6e535ff0126aa2$export$10899ada382f2ae3() {
    clearInterval($2d6e535ff0126aa2$var$memoryInterval);
}
function $2d6e535ff0126aa2$export$b9fdd785f0fc1d40() {
    $2d6e535ff0126aa2$var$pressureObserver?.disconnect();
}
module.exports["createPressureStateReport"] = $2d6e535ff0126aa2$export$1f0ff35da084986e;
module.exports["createMemoryStateReport"] = $2d6e535ff0126aa2$export$3b47ebb9832b4e24;
module.exports["initialisePressureObserver"] = $2d6e535ff0126aa2$export$117ebc554c6e9f2f;
module.exports["initialiseMemoryObserver"] = $2d6e535ff0126aa2$export$a3271f53e91faab7;

});

parcelRegister("2tbpa", function(module, exports) {

var $bH6Zn = parcelRequire("bH6Zn");

const $d89b5b1c9fbcc848$var$MAX_TRACKED_SOFT_NAVIGATIONS = 20;
// A soft navigation's startTime is the interaction that triggered it, so it comes slightly before
// the UFO transition starts. Ignore soft navigations that started too long before the transition,
// as they most likely belong to an earlier navigation.
const $d89b5b1c9fbcc848$var$MAX_SOFT_NAVIGATION_LEAD_TIME = 1000;
// Only plain timestamps are kept, so long-lived sessions don't retain the painted DOM elements.
const $d89b5b1c9fbcc848$var$softNavigations = new (0, $bH6Zn.BufferWithMaxLength)($d89b5b1c9fbcc848$var$MAX_TRACKED_SOFT_NAVIGATIONS);
let $d89b5b1c9fbcc848$var$observer = null;
// Same check as web-vitals' checkSoftNavsEnabled (src/lib/softNavs.ts).
function $d89b5b1c9fbcc848$var$isSoftNavigationSupported() {
    return (globalThis.PerformanceObserver?.supportedEntryTypes?.includes('soft-navigation') ?? false) && // Older implementations expose the value as an attribute rather than the method. Only the
    // method shipped to stable.
    typeof globalThis.PerformanceSoftNavigation?.prototype?.getLargestInteractionContentfulPaint === 'function';
}
// Each contentful paint is larger than the one before, so the latest one is the LCP.
function $d89b5b1c9fbcc848$var$setLargestContentfulPaint(softNavigation, entry) {
    const paint = entry?.largestContentfulPaint;
    // `||` rather than `??` on purpose: renderTime is 0 when the browser withholds it (e.g. cross-origin
    // images without Timing-Allow-Origin), and no real paint here can happen at time 0.
    const paintTime = paint?.renderTime || paint?.loadTime;
    if (softNavigation !== undefined && paintTime) softNavigation.largestContentfulPaint = paintTime;
}
function $d89b5b1c9fbcc848$var$handleEntries(entries) {
    entries.forEach((entry)=>{
        if (entry.entryType === 'soft-navigation') {
            const softNavigationEntry = entry;
            const softNavigation = {
                interactionId: softNavigationEntry.interactionId,
                startTime: softNavigationEntry.startTime,
                // presentationTime is null where unsupported, and a paint after an interaction can't be at 0.
                firstContentfulPaint: softNavigationEntry.presentationTime || softNavigationEntry.paintTime || undefined
            };
            $d89b5b1c9fbcc848$var$softNavigations.push(softNavigation);
            // Paints for this interaction that happened before the soft navigation was detected.
            $d89b5b1c9fbcc848$var$setLargestContentfulPaint(softNavigation, softNavigationEntry.getLargestInteractionContentfulPaint?.());
        } else if (entry.entryType === 'interaction-contentful-paint') {
            // These are emitted for any interaction that paints, not only soft navigations, so only keep
            // the ones for a tracked soft navigation.
            const contentfulPaint = entry;
            $d89b5b1c9fbcc848$var$setLargestContentfulPaint($d89b5b1c9fbcc848$var$softNavigations.getAll().find((softNavigation)=>softNavigation.interactionId === contentfulPaint.interactionId), contentfulPaint);
        }
    });
}
function $d89b5b1c9fbcc848$var$findSoftNavigation(start) {
    return $d89b5b1c9fbcc848$var$softNavigations.getAll().reduce((match, softNavigation)=>{
        if (softNavigation.startTime <= start && softNavigation.startTime >= start - $d89b5b1c9fbcc848$var$MAX_SOFT_NAVIGATION_LEAD_TIME && (match === undefined || match.startTime < softNavigation.startTime)) return softNavigation;
        return match;
    }, undefined);
}
function $d89b5b1c9fbcc848$export$e064a2fa755ff6f2() {
    if ($d89b5b1c9fbcc848$var$observer !== null || !$d89b5b1c9fbcc848$var$isSoftNavigationSupported()) return;
    try {
        $d89b5b1c9fbcc848$var$observer = new PerformanceObserver((list)=>$d89b5b1c9fbcc848$var$handleEntries(list.getEntries()));
        $d89b5b1c9fbcc848$var$observer.observe({
            type: 'soft-navigation',
            buffered: true
        });
        if (PerformanceObserver.supportedEntryTypes.includes('interaction-contentful-paint')) $d89b5b1c9fbcc848$var$observer.observe({
            type: 'interaction-contentful-paint',
            buffered: true
        });
    } catch  {
        // A later observe() can throw after an earlier one succeeded, so stop the half-started observer
        // rather than leaving it filling the buffers while the next call starts another one.
        $d89b5b1c9fbcc848$var$observer?.disconnect();
        $d89b5b1c9fbcc848$var$observer = null;
    }
}
function $d89b5b1c9fbcc848$export$e0d5520cde609f66(start) {
    // UFO init runs before jira-spa installs its platform flag resolver, so fg() there skips Jira's
    // overrides (e.g. ?fg=) and can read the un-overridden value. Soft navigations only happen once
    // the page has loaded, and buffered entries replay the ones from before the observer started.
    $d89b5b1c9fbcc848$export$e064a2fa755ff6f2();
    if ($d89b5b1c9fbcc848$var$observer === null) return {};
    $d89b5b1c9fbcc848$var$handleEntries($d89b5b1c9fbcc848$var$observer.takeRecords());
    const softNavigation = $d89b5b1c9fbcc848$var$findSoftNavigation(start);
    if (softNavigation === undefined) return {};
    const metrics = {};
    if (softNavigation.firstContentfulPaint) metrics.fcp = Math.round(Math.max(softNavigation.firstContentfulPaint - start, 0));
    if (softNavigation.largestContentfulPaint) metrics.lcp = Math.round(Math.max(softNavigation.largestContentfulPaint - start, 0));
    return metrics;
}
module.exports["ensureSoftNavigationObserved"] = $d89b5b1c9fbcc848$export$e064a2fa755ff6f2;
module.exports["getSoftNavigationPaintMetrics"] = $d89b5b1c9fbcc848$export$e0d5520cde609f66;

});

parcelRegister("6R8n4", function(module, exports) {

let $4fde2fa913ae880c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4fde2fa913ae880c$var$load("4foH1"),
    $4fde2fa913ae880c$var$load("5thEc")
]).then(()=>parcelRequire('7lFgX'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("iP1ZM", function(module, exports) {

let $db3e89af46ce6792$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $db3e89af46ce6792$var$load("4foH1"),
    $db3e89af46ce6792$var$load("bi1KD")
]).then(()=>parcelRequire('bWwjK'));

});

parcelRegister("cviBU", function(module, exports) {

let $91a6d0ec7ef7c3ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91a6d0ec7ef7c3ed$var$load("6ELUz").then(()=>parcelRequire('4bvKY'));

});

parcelRegister("eTb2c", function(module, exports) {

let $ad6ec2fb10b99076$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad6ec2fb10b99076$var$load("ktVny").then(()=>parcelRequire('PlEDs'));

});

parcelRegister("hvG5K", function(module, exports) {

var $jtTx3 = parcelRequire("jtTx3");

const $f4295f5b6913962f$var$defaultAllowedParams = [
    'operationName',
    'operation',
    'q'
];
function $f4295f5b6913962f$var$getAllowedParams() {
    const config = (0, $jtTx3.getConfig)();
    return config?.allowedResourcesParams || $f4295f5b6913962f$var$defaultAllowedParams;
}
function $f4295f5b6913962f$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== 'string') return urlString;
        const url = new URL(urlString);
        const params = new URLSearchParams(url.search);
        const allowedParams = $f4295f5b6913962f$var$getAllowedParams();
        for (const [key] of params)if (!allowedParams.includes(key)) url.searchParams.delete(key);
        return url.toString();
    } catch  {
        return urlString;
    }
}
let $f4295f5b6913962f$var$config = {
    mapResources: (url)=>url,
    sanitiseEndpoints: (url)=>{
        return $f4295f5b6913962f$var$handleQueryParams(url);
    }
};
function $f4295f5b6913962f$export$8d21e34596265fa2(resourceTimingConfig) {
    const newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: (url)=>{
            const sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $f4295f5b6913962f$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $f4295f5b6913962f$var$config = newConfig;
}
function $f4295f5b6913962f$export$44487a86467333c3() {
    return $f4295f5b6913962f$var$config;
}
module.exports["configure"] = $f4295f5b6913962f$export$8d21e34596265fa2;
module.exports["getConfig"] = $f4295f5b6913962f$export$44487a86467333c3;

});

parcelRegister("59ylD", function(module, exports) {

var $6mcTh = parcelRequire("6mcTh");

const $93805df410f14b67$var$getPerformanceObject = ()=>(window ?? {}).performance;
const $93805df410f14b67$var$getPerformanceObserverObject = ()=>(window ?? {}).PerformanceObserver;
const $93805df410f14b67$export$bea963256235a63e = {
    timings: [],
    maxSize: 1000,
    observer: null,
    transformResource (entry) {
        const duration = (0, $6mcTh.roundEpsilon)(entry.duration);
        // prioritising atl-edge
        const totalBackendTimeEntry = entry.serverTiming?.find((timing)=>timing.name === 'atl-edge') || entry.serverTiming?.find(// timing name should come from per-product config in the future
        (timing)=>timing.name === 'total' || timing.name === 'filter-request-papi');
        const serverTime = totalBackendTimeEntry ? (0, $6mcTh.roundEpsilon)(totalBackendTimeEntry.duration) : undefined;
        const networkTime = serverTime ? duration - serverTime : undefined;
        return {
            name: entry.name,
            initiatorType: entry.initiatorType,
            transferSize: entry.transferSize,
            startTime: (0, $6mcTh.roundEpsilon)(entry.startTime),
            duration: (0, $6mcTh.roundEpsilon)(entry.duration),
            fetchStart: (0, $6mcTh.roundEpsilon)(entry.fetchStart || 0),
            workerStart: (0, $6mcTh.roundEpsilon)(entry.workerStart || 0),
            responseStart: (0, $6mcTh.roundEpsilon)(entry.responseStart || 0),
            requestStart: (0, $6mcTh.roundEpsilon)(entry.requestStart || 0),
            serverTime: serverTime,
            networkTime: networkTime,
            encodedSize: (0, $6mcTh.roundEpsilon)(entry.encodedBodySize),
            decodedSize: (0, $6mcTh.roundEpsilon)(entry.decodedBodySize)
        };
    },
    start () {
        const performance = $93805df410f14b67$var$getPerformanceObject();
        const PerformanceObserver = $93805df410f14b67$var$getPerformanceObserverObject();
        if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') return;
        if ($93805df410f14b67$export$bea963256235a63e.observer) return;
        const resources = performance.getEntriesByType?.('resource');
        if (resources) $93805df410f14b67$export$bea963256235a63e.timings = resources.map((resource)=>$93805df410f14b67$export$bea963256235a63e.transformResource(resource));
        $93805df410f14b67$export$bea963256235a63e.observer = new PerformanceObserver($93805df410f14b67$export$bea963256235a63e.addTimings);
        $93805df410f14b67$export$bea963256235a63e.observer.observe({
            entryTypes: [
                'resource'
            ]
        });
    },
    stop () {
        if ($93805df410f14b67$export$bea963256235a63e.observer) {
            $93805df410f14b67$export$bea963256235a63e.observer.disconnect();
            $93805df410f14b67$export$bea963256235a63e.observer = null;
        }
        $93805df410f14b67$export$bea963256235a63e.timings = [];
    },
    addTimings (list) {
        const entries = list.getEntries().map((entry)=>$93805df410f14b67$export$bea963256235a63e.transformResource(entry));
        const overflow = $93805df410f14b67$export$bea963256235a63e.timings.length + entries.length;
        if (overflow > $93805df410f14b67$export$bea963256235a63e.maxSize) {
            const fieldsToRemove = overflow - $93805df410f14b67$export$bea963256235a63e.maxSize;
            $93805df410f14b67$export$bea963256235a63e.timings.splice(0, fieldsToRemove);
        }
        $93805df410f14b67$export$bea963256235a63e.timings.push(...entries);
    }
};
function $93805df410f14b67$var$isValidTiming(timing, startTime, endTime) {
    return timing.startTime >= startTime && timing.startTime + timing.duration <= endTime;
}
function $93805df410f14b67$export$4138a729ef1db028(startTime, endTime) {
    const performance = $93805df410f14b67$var$getPerformanceObject();
    const PerformanceObserver = $93805df410f14b67$var$getPerformanceObserverObject();
    if (!PerformanceObserver || !$93805df410f14b67$export$bea963256235a63e.observer) {
        const resources = performance?.getEntriesByType('resource');
        if (resources) return resources.filter((timing)=>$93805df410f14b67$var$isValidTiming(timing, startTime, endTime));
        return null;
    }
    return $93805df410f14b67$export$bea963256235a63e.timings.filter((timing)=>$93805df410f14b67$var$isValidTiming(timing, startTime, endTime));
}
module.exports["resourceTimingBuffer"] = $93805df410f14b67$export$bea963256235a63e;
module.exports["filterResourceTimings"] = $93805df410f14b67$export$4138a729ef1db028;

});

parcelRegister("6mcTh", function(module, exports) {
function $c49b1eda1fa8e6a5$export$56014375de40214b(num, places = 3) {
    const factor = Math.pow(10, places);
    return Math.round((num + Number.EPSILON) * factor) / factor;
}
module.exports["roundEpsilon"] = $c49b1eda1fa8e6a5$export$56014375de40214b;

});

parcelRegister("e1XeN", function(module, exports) {
const $1dac3feda03e5fd0$var$NESTED_METRIC_SEPARATOR = '/';
function $1dac3feda03e5fd0$var$filterEntry(entry) {
    return !(!entry || typeof entry !== 'object' || entry.startTime < 0 || entry.duration < 0);
}
function $1dac3feda03e5fd0$var$mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration),
        ...entry.size ? {
            size: Math.round(entry.size)
        } : {}
    };
}
const $1dac3feda03e5fd0$var$SSR_PREFIX = 'ssr';
function $1dac3feda03e5fd0$var$mapKey(key) {
    if (key === 'total') return $1dac3feda03e5fd0$var$SSR_PREFIX;
    return `${$1dac3feda03e5fd0$var$SSR_PREFIX}${$1dac3feda03e5fd0$var$NESTED_METRIC_SEPARATOR}${key}`;
}
let $1dac3feda03e5fd0$var$config;
function $1dac3feda03e5fd0$export$8d21e34596265fa2(ssrConfig) {
    $1dac3feda03e5fd0$var$config = ssrConfig;
}
function $1dac3feda03e5fd0$var$getPerformanceNavigationTiming() {
    // getEntriesByType doesn't change the returned type based on the given type key
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return performance.getEntriesByType('navigation')?.[0];
}
function $1dac3feda03e5fd0$var$getServerTimingsByName() {
    const serverTimingsByName = Object.fromEntries($1dac3feda03e5fd0$var$getPerformanceNavigationTiming()?.serverTiming?.map((timing)=>[
            timing.name,
            timing
        ]) ?? []);
    return serverTimingsByName;
}
/**
 * If we have the edge's view of ttfb and the clients view as well, then we should take the gap between them as
 * the offset to use foe edge start time.
 * This will simulate the network delays between the client and the edge as an edge startTime increase
 */ function $1dac3feda03e5fd0$var$getEdgeOffset(edgeTtfb) {
    const clientTtfb = $1dac3feda03e5fd0$var$getPerformanceNavigationTiming()?.responseStart;
    if (edgeTtfb == null || clientTtfb == null) return 0;
    return clientTtfb - edgeTtfb;
}
function $1dac3feda03e5fd0$export$5300d1b82e594615() {
    const serverTimingsByName = $1dac3feda03e5fd0$var$getServerTimingsByName();
    const edgeTotalDuration = serverTimingsByName['cdn-downstream-fbl']?.duration ?? serverTimingsByName['atl-edge']?.duration;
    if (!edgeTotalDuration) return null;
    const edgeOffset = $1dac3feda03e5fd0$var$getEdgeOffset(edgeTotalDuration);
    const cfInternalDuration = (serverTimingsByName['cdn-upstream-dns']?.duration || 0) + (serverTimingsByName['cdn-upstream-connect']?.duration || 0);
    const cfUpstreamDuration = (serverTimingsByName['cdn-upstream-fbl']?.duration || 0) - cfInternalDuration;
    const cfDownstreamDuration = (serverTimingsByName['cdn-downstream-fbl']?.duration || 0) - (serverTimingsByName['cdn-upstream-fbl']?.duration || 0);
    const atlEdgeDuration = serverTimingsByName['atl-edge']?.duration;
    const cfToAtlEdgeNetworkDuration = cfUpstreamDuration - atlEdgeDuration;
    const edgeTimings = {
        edge: {
            startTime: edgeOffset,
            duration: edgeTotalDuration
        }
    };
    if (typeof serverTimingsByName['cdn-downstream-fbl'] !== 'undefined') {
        edgeTimings['edge/cf'] = {
            startTime: edgeOffset,
            duration: serverTimingsByName['cdn-downstream-fbl']?.duration
        };
        edgeTimings['edge/cf/internal'] = {
            startTime: edgeOffset,
            duration: cfInternalDuration
        };
        edgeTimings['edge/cf/upstream'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfUpstreamDuration
        };
        edgeTimings['edge/cf/downstream'] = {
            startTime: edgeOffset + cfInternalDuration + cfUpstreamDuration,
            duration: cfDownstreamDuration
        };
    }
    if (typeof serverTimingsByName['atl-edge'] !== 'undefined') {
        edgeTimings['edge/atl-edge'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/atl-edge/internal'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: serverTimingsByName['atl-edge-internal']?.duration
        };
        edgeTimings['edge/atl-edge/ttfb'] = {
            startTime: edgeOffset + cfInternalDuration + cfToAtlEdgeNetworkDuration,
            duration: atlEdgeDuration
        };
        edgeTimings['edge/cf/upstream/network'] = {
            startTime: edgeOffset + cfInternalDuration,
            duration: cfToAtlEdgeNetworkDuration
        };
    }
    // we need a timer here to prevent UFO pipeline from shifting SSR timers to start at 0
    edgeTimings?.edge && edgeOffset && Object.assign(edgeTimings, {
        'client-network': {
            startTime: 0,
            duration: edgeOffset
        }
    });
    return edgeTimings;
}
function $1dac3feda03e5fd0$export$bf7408e83532dcd0() {
    const defaultSSRTimings = $1dac3feda03e5fd0$export$5300d1b82e594615() || {};
    let configTimings = {};
    if (typeof $1dac3feda03e5fd0$var$config?.getTimings === 'function') configTimings = $1dac3feda03e5fd0$var$config.getTimings();
    const ssrTimings = Object.entries({
        ...configTimings,
        ...defaultSSRTimings
    }).reduce((acc, entry)=>{
        if ($1dac3feda03e5fd0$var$filterEntry(entry[1])) acc[$1dac3feda03e5fd0$var$mapKey(entry[0])] = $1dac3feda03e5fd0$var$mapEntry(entry[1]);
        return acc;
    }, {});
    return ssrTimings;
}
function $1dac3feda03e5fd0$export$c7ad864055e75537() {
    return !!$1dac3feda03e5fd0$var$config?.getDoneMark();
}
function $1dac3feda03e5fd0$export$5eade9354185583d() {
    return $1dac3feda03e5fd0$var$config?.getSsrPhaseSuccess?.();
}
function $1dac3feda03e5fd0$export$3def7672244bab0c() {
    return $1dac3feda03e5fd0$var$config?.getDoneMark() ?? undefined;
}
function $1dac3feda03e5fd0$export$1c4a9b5e6e22393d() {
    if (!$1dac3feda03e5fd0$var$config?.getFeatureFlags) return undefined;
    try {
        return $1dac3feda03e5fd0$var$config.getFeatureFlags() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
function $1dac3feda03e5fd0$export$eb7c400973493903() {
    if (!$1dac3feda03e5fd0$var$config?.getSsrSuccessBreakdown) return undefined;
    try {
        return $1dac3feda03e5fd0$var$config.getSsrSuccessBreakdown() ?? undefined;
    // eslint-disable-next-line no-empty
    } catch  {}
    return undefined;
}
module.exports["configure"] = $1dac3feda03e5fd0$export$8d21e34596265fa2;
module.exports["getSSRTimings"] = $1dac3feda03e5fd0$export$bf7408e83532dcd0;
module.exports["getSSRSuccess"] = $1dac3feda03e5fd0$export$c7ad864055e75537;
module.exports["getSSRPhaseSuccess"] = $1dac3feda03e5fd0$export$5eade9354185583d;
module.exports["getSSRDoneTime"] = $1dac3feda03e5fd0$export$3def7672244bab0c;
module.exports["getSSRFeatureFlags"] = $1dac3feda03e5fd0$export$1c4a9b5e6e22393d;
module.exports["getSSRSuccessBreakdown"] = $1dac3feda03e5fd0$export$eb7c400973493903;

});

parcelRegister("8NKQ9", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

function $a4751f753e6ca8b5$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $a4751f753e6ca8b5$export$fc6227831ee7c7(start, stop, buffer) {
    const layoutShifts = buffer.getAll().filter((_entry)=>{
        const entry = _entry;
        const isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        const allSourcesHaveSameRects = entry?.sources?.every(({ previousRect: previousRect, currentRect: currentRect })=>$a4751f753e6ca8b5$var$isSameRects(previousRect, currentRect));
        return isWithinObservationWindow && !allSourcesHaveSameRects;
    });
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}



var $bTZ0F = parcelRequire("bTZ0F");

const $74866bc0fffe4757$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $74866bc0fffe4757$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $74866bc0fffe4757$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $74866bc0fffe4757$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $74866bc0fffe4757$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}



var $bH6Zn = parcelRequire("bH6Zn");

function $1b702fc4e26ce2a2$export$b46cecdf698e4bb5({ start: start, stop: stop }) {
    const tbt = (0, $74866bc0fffe4757$export$2d6e933b35bd3407)(start, stop, (0, $bH6Zn.EntriesBuffer)[(0, $bTZ0F.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $a4751f753e6ca8b5$export$fc6227831ee7c7)(start, stop, (0, $bH6Zn.EntriesBuffer)[(0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
}



var $jtTx3 = parcelRequire("jtTx3");


var $eJGKV = parcelRequire("eJGKV");


var $jaPlx = parcelRequire("jaPlx");

function $aa7b2fb681640924$export$843fc9e1585a1854(interaction) {
    const { start: start, end: end } = interaction;
    const config = (0, $jtTx3.getConfig)();
    const interactionStatus = (0, $eJGKV.default)(interaction);
    const pageVisibilityUpToTTAI = (0, $jaPlx.default)(interaction);
    const tti = interaction.apdex?.[0]?.stopTime;
    const ttai = interactionStatus.originalInteractionStatus === 'SUCCEEDED' && pageVisibilityUpToTTAI === 'visible' ? Math.round(end - start) : undefined;
    const PPSMetricsAtTTI = tti !== undefined ? (0, $1b702fc4e26ce2a2$export$b46cecdf698e4bb5)({
        start: start,
        stop: tti
    }) : null;
    const PPSMetricsAtTTAI = ttai !== undefined ? (0, $1b702fc4e26ce2a2$export$b46cecdf698e4bb5)({
        start: start,
        stop: interaction.end
    }) : null;
    if ((0, $iDrrr.fg)('platform_ufo_remove_deprecated_config_fields')) {
        if (PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
    } else {
        if (config?.shouldCalculateLighthouseMetricsFromTTAI && PPSMetricsAtTTAI !== null) return PPSMetricsAtTTAI;
        if (PPSMetricsAtTTI !== null) return {
            ...PPSMetricsAtTTI,
            'metrics@ttai': PPSMetricsAtTTAI
        };
    }
    return {};
}
module.exports["getPPSMetrics"] = $aa7b2fb681640924$export$843fc9e1585a1854;

});

parcelRegister("eJGKV", function(module, exports) {
function $a14f8ea47a9ffd85$var$getInteractionStatus(interaction) {
    let originalInteractionStatus = interaction.abortReason ? 'ABORTED' : 'SUCCEEDED';
    const hasErrors = interaction.errors.length > 0;
    originalInteractionStatus = hasErrors ? 'FAILED' : originalInteractionStatus;
    // `overrideStatus` is to be deprecated - https://product-fabric.atlassian.net/browse/AFO-3760
    return {
        originalInteractionStatus: originalInteractionStatus,
        overrideStatus: originalInteractionStatus
    };
}
var $a14f8ea47a9ffd85$export$2e2bcd8739ae039 = $a14f8ea47a9ffd85$var$getInteractionStatus;
module.exports["default"] = $a14f8ea47a9ffd85$export$2e2bcd8739ae039;

});

parcelRegister("jaPlx", function(module, exports) {

var $8fj6C = parcelRequire("8fj6C");

function $19697b792760aa26$var$getPageVisibilityUpToTTAI(interaction) {
    const { start: start, end: end } = interaction;
    return (0, $8fj6C.getPageVisibilityState)(start, end);
}
var $19697b792760aa26$export$2e2bcd8739ae039 = $19697b792760aa26$var$getPageVisibilityUpToTTAI;
module.exports["default"] = $19697b792760aa26$export$2e2bcd8739ae039;

});

parcelRegister("9eE57", function(module, exports) {

var $ge2sX = parcelRequire("ge2sX");


var $04e9M = parcelRequire("04e9M");


var $5ZqQS = parcelRequire("5ZqQS");

const $e8c3b9e45ae9a31e$export$1a717feb4df1a945 = (names)=>{
    if (window.performance?.clearMarks) names.forEach((name)=>window.performance.clearMarks(name));
};
const $e8c3b9e45ae9a31e$export$1c64491a086778ac = (name)=>{
    if (window.performance?.getEntriesByType) {
        const entries = window.performance.getEntriesByType(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce = (name)=>{
    if (window.performance?.getEntriesByName) {
        const entries = window.performance.getEntriesByName(name);
        return entries && entries[0];
    }
};
const $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d = (a, b)=>{
    const entryA = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(a);
    const entryB = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(b);
    if (entryA && entryB) return Math.abs(entryA.startTime - entryB.startTime);
    return undefined;
};
const $e8c3b9e45ae9a31e$export$f45af69d005a6ed = (name)=>{
    const mark = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(name);
    if (mark) return mark.startTime;
    return undefined;
};
const $e8c3b9e45ae9a31e$export$91b34dd9e71ad666 = ({ subject: subject, subjectId: subjectId = '' })=>{
    const startMark = `${subject}.${subjectId}.start`;
    const endMark = `${subject}.${subjectId}.end`;
    $e8c3b9e45ae9a31e$export$1a717feb4df1a945([
        startMark,
        endMark
    ]);
    window.performance?.mark?.(startMark);
};
// Filter out feature flags with falsy values to save user bandwidth
const $e8c3b9e45ae9a31e$var$filterFeatureFlags = (flags = {})=>Object.keys(flags).filter((key)=>flags[key]).reduce((acc, key)=>{
        acc[key] = flags[key];
        return acc;
    }, {});
const $e8c3b9e45ae9a31e$var$performanceEnd = async ({ details: details, subject: subject, subjectId: subjectId, includeFeatureFlags: includeFeatureFlags })=>{
    const endMark = `${subject}.${subjectId}.end`;
    window.performance?.mark?.(endMark);
    const duration = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d(`${subject}.${subjectId}.start`, endMark);
    if (duration === undefined) return;
    try {
        const analyticsClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const sessionDataPromise = includeFeatureFlags ? (0, $ge2sX.getSessionData)() : Promise.resolve({
            featureFlags: {}
        });
        const [client, { featureFlags: featureFlags }] = await Promise.all([
            analyticsClientPromise,
            sessionDataPromise
        ]);
        const filteredFeatureFlags = $e8c3b9e45ae9a31e$var$filterFeatureFlags(featureFlags);
        client.sendOperationalEvent({
            tags: [
                'performance'
            ],
            source: 'confluence-frontend',
            action: 'done',
            actionSubject: subject,
            actionSubjectId: subjectId,
            attributes: {
                featureFlags: filteredFeatureFlags,
                duration: duration,
                ...details
            }
        });
    } catch (ex) {
        // This is a catch-all no-op, to prevent analytics component from screwing
        // up the user experience in case of any unexpected errors.
        (0, $5ZqQS.getMonitoringClient)().submitError(ex, {
            attribution: 'unknown'
        });
    }
};
const $e8c3b9e45ae9a31e$export$9cbdebb35a11386 = ({ subject: subject, subjectId: subjectId = '', details: details = {}, includeFeatureFlags: includeFeatureFlags = false })=>{
    const endMarkExists = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce(`${subject}.${subjectId}.end`);
    if (!endMarkExists) $e8c3b9e45ae9a31e$var$performanceEnd({
        details: details,
        includeFeatureFlags: includeFeatureFlags,
        subject: subject,
        subjectId: subjectId
    });
};
module.exports["clearMarks"] = $e8c3b9e45ae9a31e$export$1a717feb4df1a945;
module.exports["getEntryByName"] = $e8c3b9e45ae9a31e$export$3d0d5c80a64856ce;
module.exports["measureMarks"] = $e8c3b9e45ae9a31e$export$1e1f137ae5aa949d;
module.exports["getMark"] = $e8c3b9e45ae9a31e$export$f45af69d005a6ed;
module.exports["perfMarkStart"] = $e8c3b9e45ae9a31e$export$91b34dd9e71ad666;
module.exports["perfMarkEnd"] = $e8c3b9e45ae9a31e$export$9cbdebb35a11386;

});

parcelRegister("8Lf0D", function(module, exports) {
/**
 * Auto Incrementing ID
 *
 * Basic ID generation using a global integer
 */ class $35e1d987475b995b$export$1545ba9ccf1841ab {
    /**
   * ID
   *
   * Returns a stringified auto-incrementing ID
   */ ID() {
        return (++this.incrementor).toString();
    }
    /**
   * Reset
   *
   * Returns the incrementor to its original state
   */ reset() {
        this.incrementor = -1;
    }
    constructor(){
        this.incrementor = -1;
    }
}
module.exports["AutoIncrementingID"] = $35e1d987475b995b$export$1545ba9ccf1841ab;

});

parcelRegister("jy3Cx", function(module, exports) {
/**
 * Cache
 *
 * A generic cache designed to house just about anything. You can implement
 * your own type-safe LRU or just use it as a hash table
 */ class $f95e45deccc3ce2b$export$94affb487e701bf2 {
    /**
   * Data
   *
   * Returns the entirety of the cache
   */ get data() {
        return this._cache;
    }
    /**
   * Get
   *
   * Returns a cache value by key
   */ get(key) {
        return this._cache[key];
    }
    /**
   * Has
   *
   * Returns whether or not a given key exists in the cache
   */ has(key) {
        return this._cache.hasOwnProperty(key);
    }
    /**
   * Set
   *
   * Overrides the value of a given key with the specified value
   */ set(key, value) {
        this._cache[key] = value;
    }
    /**
   * Delete
   *
   * Deletes the specified cache key
   */ delete(key) {
        delete this._cache[key];
    }
    /**
   * Keys
   *
   * Returns all currently set cache keys
   */ get keys() {
        return Object.keys(this._cache);
    }
    /**
   * Values
   *
   * Returns all cached values
   */ get values() {
        return Object.values(this._cache);
    }
    /**
   * Clear
   *
   * Clears all cached values
   */ clear() {
        this._cache = {};
    }
    constructor(cache){
        this._cache = void 0;
        this._cache = cache || {};
    }
}
module.exports["Cache"] = $f95e45deccc3ce2b$export$94affb487e701bf2;

});

parcelRegister("5leFG", function(module, exports) {

var $jy3Cx = parcelRequire("jy3Cx");


var $bPw0L = parcelRequire("bPw0L");

class $e398c0accbc425cf$export$5087227eb54526 extends Map {
    /**
   * Stream
   *
   * Adds a stream of messages to the bus and invokes active
   * subscriptions to the corresponding message types
   */ async stream(events) {
        if (!events.length) return;
        const hash = {};
        for (const event of events){
            if (event.type in hash) hash[event.type].push(event);
            else hash[event.type] = [
                event
            ];
            this.cache(event.type, event);
        }
        await Promise.all(Object.keys(hash).map((key)=>{
            return this.dispatch(key, hash[key]);
        }));
    }
    /**
   * On
   *
   * Allows for registering listeners to incoming message types. Simply
   * pass the message type you wish to receive notifications for and
   * a callback to invoke
   */ on(event, callback) {
        const index = this.get(event) || new (0, $bPw0L.EventIndex)();
        const ID = index.subscribe(callback);
        this.set(event, index);
        return ID;
    }
    /**
   * Off
   *
   * Removes an event listener by event-name and ID
   */ off(event, ID) {
        const index = this.get(event);
        if (index) {
            index.unsubscribe(ID);
            if (index.size === 0) this.delete(event);
        }
    }
    /**
   * Dispatch
   *
   * Invokes all subscriptions for a given event type. Each listener
   * receives its corresponding messages as an argument
   */ async dispatch(event, ...params) {
        const index = this.get(event);
        if (index) await index.dispatch(params);
    }
    /**
   * Cache
   *
   * When caching is enabled, the Event Bus can act as a
   * database for historical message accumulation. To enable
   * this feature, pass `enableCache: true` to the constructor
   */ cache(key, value) {
        if (!this.enableCache) return;
        const values = this.Cache.get(key) || [];
        values.push(value);
        this.Cache.set(key, values);
    }
    constructor(cache){
        super();
        this.enableCache = false;
        this.Cache = new (0, $jy3Cx.Cache)();
        if (cache) this.enableCache = true;
    }
}
module.exports["EventBus"] = $e398c0accbc425cf$export$5087227eb54526;

});

parcelRegister("bPw0L", function(module, exports) {

var $8Lf0D = parcelRequire("8Lf0D");

class $93598c3fbf25b38d$export$8a9c48e07ede8c4b extends Map {
    /**
   * Subscribe
   *
   * Adds a subscription to the index and returns a unique
   * identifier
   */ subscribe(listener) {
        const ID = this.IDs.ID();
        this.set(ID, listener);
        return ID;
    }
    /**
   * Unsubscribe
   *
   * Removes a subscription from the index by ID
   */ unsubscribe(ID) {
        this.delete(ID);
    }
    /**
   * Dispatch
   *
   * Dispatches events to their registered listeners
   */ async dispatch(messages) {
        for (const [_, listener] of this)await Promise.resolve(listener(...messages));
    }
    constructor(...args){
        super(...args);
        this.IDs = new (0, $8Lf0D.AutoIncrementingID)();
    }
}
module.exports["EventIndex"] = $93598c3fbf25b38d$export$8a9c48e07ede8c4b;

});

parcelRegister("lXQLs", function(module, exports) {
const $feab3ea7dc0c8aa0$export$b471d97e795847e1 = (resourceTimings)=>{
    let hasScriptEntries = false;
    let hasNextHopProtocolProperty = false;
    for (const entry of resourceTimings){
        if (entry.initiatorType !== 'script') continue;
        hasScriptEntries = true;
        // Skip cache hits. Cached resources have transferSize === 0 and the browser reports
        // nextHopProtocol as "" since no network hop occurred.
        if (entry.transferSize === 0) continue;
        if ('nextHopProtocol' in entry) {
            hasNextHopProtocolProperty = true;
            if (entry.nextHopProtocol) return entry.nextHopProtocol;
        }
    }
    if (!hasScriptEntries || !hasNextHopProtocolProperty) return 'unsupported';
    return 'unknown';
};
module.exports["getHTTPProtocol"] = $feab3ea7dc0c8aa0$export$b471d97e795847e1;

});

parcelRegister("7W9kD", function(module, exports) {

var $blsdD = parcelRequire("blsdD");

const $9f0ae7ee0cebc5b7$var$registrations = new Map();
// Bound the addition to the existing UFO payload, even on tenants with many apps.
const $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS = 50;
const $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b = (element, source, extensionId)=>{
    if (!extensionId || !window.ResizeObserver) return;
    $9f0ae7ee0cebc5b7$var$registrations.get(element)?.stop?.();
    const registration = {
        source: source,
        extensionId: extensionId
    };
    $9f0ae7ee0cebc5b7$var$registrations.set(element, registration);
    registration.stop = (0, $blsdD.observeElementDimensions)(element, (dimensions)=>{
        registration.dimensions = dimensions;
    });
    return ()=>{
        if ($9f0ae7ee0cebc5b7$var$registrations.get(element) !== registration) return;
        registration.stop?.();
        $9f0ae7ee0cebc5b7$var$registrations.delete(element);
    };
};
const $9f0ae7ee0cebc5b7$export$e4b460b98000468c = ()=>{
    const groups = new Map();
    for (const [element, { source: source, extensionId: extensionId, dimensions: dimensions }] of $9f0ae7ee0cebc5b7$var$registrations){
        if (!element.isConnected || !dimensions) continue;
        const group = groups.get(source) ?? new Map();
        group.set(extensionId, {
            ...dimensions
        });
        groups.set(source, group);
    }
    let reported = 0;
    let omitted = 0;
    const extensionDimensions = Object.fromEntries(Array.from(groups, ([source, dimensions])=>[
            source,
            Object.fromEntries(Array.from(dimensions).filter(()=>{
                if (reported < $9f0ae7ee0cebc5b7$var$MAX_REPORTED_EXTENSIONS) {
                    reported++;
                    return true;
                }
                omitted++;
                return false;
            }))
        ]));
    return {
        extensionDimensions: extensionDimensions,
        ...omitted ? {
            extensionDimensionsOmittedCount: omitted
        } : {}
    };
};
module.exports["observeExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$dbee8f9a070db66b;
module.exports["getExtensionDimensions"] = $9f0ae7ee0cebc5b7$export$e4b460b98000468c;

});

parcelRegister("blsdD", function(module, exports) {
const $91a4a128f3ac2264$var$observations = new Map();
let $91a4a128f3ac2264$var$observer;
function $91a4a128f3ac2264$export$4d315c8c80147824(element, listener) {
    if (typeof window === 'undefined' || !window.ResizeObserver) return;
    $91a4a128f3ac2264$var$observer ?? ($91a4a128f3ac2264$var$observer = new ResizeObserver((entries)=>{
        for (const { target: target, contentRect: { height: height, width: width } } of entries){
            const observation = $91a4a128f3ac2264$var$observations.get(target);
            if (!observation || !Number.isFinite(height) || !Number.isFinite(width) || height < 0 || width < 0) continue;
            const dimensions = {
                height: Math.round(height),
                width: Math.round(width)
            };
            if (observation.dimensions?.height === dimensions.height && observation.dimensions?.width === dimensions.width) continue;
            observation.dimensions = dimensions;
            observation.listeners.forEach((notify)=>notify(dimensions));
        }
    }));
    let observation = $91a4a128f3ac2264$var$observations.get(element);
    if (!observation) {
        observation = {
            listeners: new Set()
        };
        $91a4a128f3ac2264$var$observations.set(element, observation);
        $91a4a128f3ac2264$var$observer.observe(element);
    }
    observation.listeners.add(listener);
    if (observation.dimensions) listener(observation.dimensions);
    return ()=>{
        if (!observation.listeners.delete(listener) || observation.listeners.size) return;
        $91a4a128f3ac2264$var$observer?.unobserve(element);
        $91a4a128f3ac2264$var$observations.delete(element);
        if (!$91a4a128f3ac2264$var$observations.size) {
            $91a4a128f3ac2264$var$observer?.disconnect();
            $91a4a128f3ac2264$var$observer = undefined;
        }
    };
}
module.exports["observeElementDimensions"] = $91a4a128f3ac2264$export$4d315c8c80147824;

});

parcelRegister("cG9jM", function(module, exports) {

let $93b0a2a7f13bc525$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $93b0a2a7f13bc525$var$load("e4siW"),
    $93b0a2a7f13bc525$var$load("76XJy")
]).then(()=>parcelRequire('a4qOe'));

});

parcelRegister("gKr8t", function(module, exports) {

var $9B4fQ = parcelRequire("9B4fQ");


var $10d5H = parcelRequire("10d5H");


var $gDvLV = parcelRequire("gDvLV");


var $2bfWW = parcelRequire("2bfWW");


var $cC0P5 = parcelRequire("cC0P5");


var $adWn1 = parcelRequire("adWn1");


var $9jPdT = parcelRequire("9jPdT");




var $iMHGI = parcelRequire("iMHGI");


var $8xqRi = parcelRequire("8xqRi");


var $3cnNA = parcelRequire("3cnNA");



var $11MAl = parcelRequire("11MAl");


var $5c4nm = parcelRequire("5c4nm");

let $6d0c6b833ab477dd$var$apolloClient = null;
const $6d0c6b833ab477dd$var$wrappedFetch = (0, $iMHGI.createWrappedFetch)();
const $6d0c6b833ab477dd$export$ed315e0c0d70f648 = 'agg';
const $6d0c6b833ab477dd$var$fragmentMatcher = new (0, $cC0P5.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: {
        __schema: {
            types: (0, (/*@__PURE__*/$parcel$interopDefault($adWn1)))
        }
    }
});
const $6d0c6b833ab477dd$export$8ddb56c88a6a3feb = new (0, $5c4nm.BroadcastConfigurableInMemoryCache)({
    fragmentMatcher: $6d0c6b833ab477dd$var$fragmentMatcher
});
const $6d0c6b833ab477dd$export$73fc90876f9d2053 = ()=>{
    $6d0c6b833ab477dd$var$apolloClient = null;
};
const $6d0c6b833ab477dd$export$13fdb03e350a572c = ()=>{
    // Use mock gateway Apollo client in tests
    if (window.MOCK_GATEWAY_APOLLO_CLIENT) return window.MOCK_GATEWAY_APOLLO_CLIENT;
    if (!$6d0c6b833ab477dd$var$apolloClient) {
        $6d0c6b833ab477dd$var$apolloClient = $6d0c6b833ab477dd$var$createApolloClient();
        window.GLOBAL_APOLLO_AGG_CLIENT = $6d0c6b833ab477dd$var$apolloClient;
    }
    return $6d0c6b833ab477dd$var$apolloClient;
};
const $6d0c6b833ab477dd$export$37f39450dbfec1a7 = (query)=>(0, $gDvLV.getOperationAST)(query)?.operation === 'subscription' && // Subscriptions must never open WebSockets during SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    true;
const $6d0c6b833ab477dd$var$createLinks = ()=>{
    const links = [
        (0, $9jPdT.createOnErrorLink)()
    ];
    const subscriptionLinks = [];
    links.push((0, $11MAl.SSRClientLink)($6d0c6b833ab477dd$export$ed315e0c0d70f648, $6d0c6b833ab477dd$export$8ddb56c88a6a3feb));
    subscriptionLinks.push((0, $3cnNA.AttachExtensionsLink));
    subscriptionLinks.push((0, $8xqRi.getAGGWebSocketLinkInstance)());
    links.push(new (0, $2bfWW.HttpLink)({
        credentials: 'include',
        uri: '/gateway/api/graphql',
        fetch: $6d0c6b833ab477dd$var$wrappedFetch
    }));
    return (0, $10d5H.split)(({ query: query })=>$6d0c6b833ab477dd$export$37f39450dbfec1a7(query), // WebSocket link for subscriptions
    (0, $10d5H.from)(subscriptionLinks), // HTTP link for non-subscription operations
    (0, $10d5H.from)(links));
};
const $6d0c6b833ab477dd$var$createApolloClient = ()=>{
    if (typeof window['__APOLLO_AGG_STATE__'] === 'object') $6d0c6b833ab477dd$export$8ddb56c88a6a3feb.restore(window['__APOLLO_AGG_STATE__']);
    const client = new (0, $9B4fQ.ApolloClient)({
        // Prevent cache and network query to refresh when they are already preloaded on server-side.
        // Refreshing data will cause component to fallback to loading state.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        ssrMode: Boolean(undefined),
        connectToDevTools: false,
        link: (0, $10d5H.from)([
            $6d0c6b833ab477dd$var$createLinks()
        ]),
        cache: $6d0c6b833ab477dd$export$8ddb56c88a6a3feb
    });
    // This is not actual API from Apollo. This field is read in next/packages/ssr-app/src/module-replacements/apollo-client.js
    client.__isAGGClient = true;
    return client;
};
module.exports["apolloAGGCache"] = $6d0c6b833ab477dd$export$8ddb56c88a6a3feb;
module.exports["getAGGClient"] = $6d0c6b833ab477dd$export$13fdb03e350a572c;

});

parcelRegister("8xqRi", function(module, exports) {

var $4cvLo = parcelRequire("4cvLo");

function $aa9065bb91596100$export$91893b414ff080f2() {
    let WEBSOCKET_URL;
    WEBSOCKET_URL = `wss://${window?.location?.host}/gateway/api/graphql/subscriptions`;
    return WEBSOCKET_URL;
}
let $aa9065bb91596100$var$wsLink;
function $aa9065bb91596100$export$4b71fe053d09625a() {
    const WEBSOCKET_URL = $aa9065bb91596100$export$91893b414ff080f2();
    if (!$aa9065bb91596100$var$wsLink) $aa9065bb91596100$var$wsLink = new (0, $4cvLo.GraphQLWSLink)({
        url: ()=>{
            return WEBSOCKET_URL;
        },
        shouldRetry: ()=>{
            return true;
        },
        keepAlive: (0, $4cvLo.KEEP_ALIVE),
        retryAttempts: 5
    });
    return $aa9065bb91596100$var$wsLink;
}
module.exports["getAGGWebSocketLinkInstance"] = $aa9065bb91596100$export$4b71fe053d09625a;

});

parcelRegister("4cvLo", function(module, exports) {

var $bKqeQ = parcelRequire("bKqeQ");


var $10d5H = parcelRequire("10d5H");


var $bPh6H = parcelRequire("bPh6H");


var $7m1pr = parcelRequire("7m1pr");


var $04e9M = parcelRequire("04e9M");


var $dbZMH = parcelRequire("dbZMH");


var $ac4MN = parcelRequire("ac4MN");


var $bBofs = parcelRequire("bBofs");

const $fca9c472df15863c$export$e9ff5bb5c39478ed = 600000;
class $fca9c472df15863c$export$b26b2f8eae2af9a extends (0, $10d5H.ApolloLink) {
    request(operation) {
        // Add null check for operation.getContext to prevent "Cannot read properties of undefined" errors
        const context = operation.getContext?.() || {};
        // context is coming from a previous link since we are using apollo v2
        // subscriptions does not have context or extensions in some cases
        return new (0, $10d5H.Observable)((observer)=>{
            const subscription = this.client.subscribe({
                ...operation,
                query: (0, $bPh6H.print)(operation.query),
                extensions: context?.extensions
            }, {
                next: (result)=>{
                    // Transform null data to empty object
                    const transformedResult = {
                        ...result,
                        data: result.data === null ? {} : result.data
                    };
                    observer.next(transformedResult);
                },
                complete: observer.complete.bind(observer),
                error: (err)=>{
                    if (this.closedInfo && !this.closedInfo?.wasClean && !err?.message) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                        client.sendOperationalEvent({
                            source: 'confluence-AGGWebSocketLink',
                            actionSubject: 'webSocket',
                            action: 'closed-socket-error',
                            attributes: {
                                reason: this.closedInfo?.reason,
                                code: this.closedInfo?.code,
                                wasClean: this.closedInfo?.wasClean
                            }
                        });
                    });
                    if (err instanceof Error) return observer.error(err);
                    return observer.error(new (0, $7m1pr.RelayError)({
                        graphQLErrors: Array.isArray(err) ? err : [
                            err
                        ]
                    }));
                }
            });
            // keep track of the subscription so we can unsubscribe later
            this.replayQueries[operation.operationName] = {
                unsubscribe: subscription,
                query: (0, $bPh6H.print)(operation.query)
            };
            return subscription;
        });
    }
    constructor(options){
        super();
        this.client = void 0;
        this.internetConnectionState = 'healthy';
        this.timedOut = null;
        this.closedInfo = null;
        this.replayQueries = {};
        this.currentGetInternetConnectionStatePromise = null;
        this.onConnected = (_socket, _payload, wasRetry)=>{
            (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                client.sendOperationalEvent({
                    source: 'confluence-AGGWebSocketLink',
                    actionSubject: 'webSocket',
                    action: wasRetry ? 'reconnected' : 'connected'
                });
            });
        };
        this.verifyAndUpdateInternetHealth = async ()=>{
            this.currentGetInternetConnectionStatePromise = this.currentGetInternetConnectionStatePromise || (0, $dbZMH.getInternetConnectionState)();
            const internetHealthState = await this.currentGetInternetConnectionStatePromise;
            this.internetConnectionState = internetHealthState;
            this.currentGetInternetConnectionStatePromise = null;
        };
        this.verifyAndUpdateInternetHealthUntilHealthy = async ()=>{
            await this.verifyAndUpdateInternetHealth();
            if (this.internetConnectionState === 'healthy') return;
            else this.client?.terminate();
            await new Promise((resolve)=>{
                setTimeout(resolve, 500);
            });
            return this.verifyAndUpdateInternetHealthUntilHealthy();
        };
        this.retryWait = async (retries)=>{
            const retryDelayRange = await (0, $ac4MN.getDelayRangeFromGraphqlWebsocketState)(retries);
            // This is the logic reused from legacy WebSocket with a check verifyAndUpdateInternetHealthUntilHealthy
            // If the internet connection is healthy then we can retry, otherwise we do not need to retry
            // We subtract the time spent waiting to reconnect from the exponential backoff
            const startedAt = Date.now();
            await this.verifyAndUpdateInternetHealthUntilHealthy();
            // since we took some time to verify internet health, reduce the exponential backoff
            const msCheckingInternetHealth = Date.now() - startedAt;
            const retryDelay = (0, $ac4MN.getBackOffDelay)({
                range: retryDelayRange,
                timeSpent: msCheckingInternetHealth
            });
            // monitor status looks at if a user is idle or hidden to determine the retry delay
            await new Promise((resolve)=>{
                let timeoutId = setTimeout(resolve, retryDelay);
                const newRetryDelayRange = (0, $bBofs.calculateBackOffRange)({
                    status: 'active',
                    attemptsCount: retries
                });
                const msAlreadyWaited = Date.now() - startedAt;
                const newRetryDelay = (0, $ac4MN.getBackOffDelay)({
                    range: newRetryDelayRange,
                    timeSpent: msAlreadyWaited
                });
                const actualReconnectionDelay = Math.max(newRetryDelay - msAlreadyWaited, 0);
                // Clear old timeout and set a new one with the updated delay
                clearTimeout(timeoutId);
                timeoutId = setTimeout(resolve, actualReconnectionDelay);
            });
        };
        this.client = (0, $bKqeQ.createClient)({
            ...options,
            retryWait: this.retryWait,
            on: {
                connected: this.onConnected,
                closed: (info)=>{
                    this.closedInfo = info;
                },
                ping: (received)=>{
                    if (!received /* sent */ ) this.timedOut = setTimeout(()=>{
                        // unsubscribe so that we can reconnect with new arguments
                        for(const key in this.replayQueries)// unsubscribes queries so that we can reconnect with new arguments
                        if (this.replayQueries[key]) {
                            this.replayQueries[key].unsubscribe();
                            delete this.replayQueries[key];
                        }
                        this.client.terminate();
                    }, $fca9c472df15863c$export$e9ff5bb5c39478ed / 2);
                },
                pong: (received)=>{
                    if (received && this.timedOut !== null) clearTimeout(this.timedOut);
                }
            }
        });
    }
}
module.exports["KEEP_ALIVE"] = $fca9c472df15863c$export$e9ff5bb5c39478ed;
module.exports["GraphQLWSLink"] = $fca9c472df15863c$export$b26b2f8eae2af9a;

});

parcelRegister("dbZMH", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getInternetConnectionState.ts when we move to Relay.
 */ // partially copied from Trello modified to use confluences network check
const $3d23f6bbdf409903$export$ddfffe3f5c167fa6 = async ()=>{
    // we can early return unhealthy if offline for navigator, but we cant if onLine.
    // That's because you can be online, but be waiting for VPN connection or something
    // else that blocks actually allowing internet.
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!navigator.onLine) return 'unhealthy';
    for(let i = 0; i < 3; i++){
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        if (!navigator.onLine) return 'unhealthy';
        // stagger it a little because of flakey VPN's and firewalls
        await new Promise((res)=>setTimeout(res, 1000));
    }
    // we got 3 good attempts, safe to say healthy
    return 'healthy';
};
module.exports["getInternetConnectionState"] = $3d23f6bbdf409903$export$ddfffe3f5c167fa6;

});

parcelRegister("ac4MN", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/getBackOffDelay.ts when we move to Relay.
 */ // copied from Trello

var $bBofs = parcelRequire("bBofs");

function $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(start, end) {
    const spread = end - start;
    return Math.floor(start + Math.random() * spread);
}
const $5a87cb4548ea235b$export$73e02b3a26ecb0d7 = ({ range: range, timeSpent: timeSpent = 0 })=>{
    const [lowerBound, upperBound] = range;
    const delay = $5a87cb4548ea235b$export$ffd8c9a5b80f1e57(lowerBound, upperBound);
    return Math.max(delay - timeSpent, 0);
};
const $5a87cb4548ea235b$export$ac8ba6656a385f56 = async (retries)=>{
    /**
	 * We're overriding the status multipliers here to make the reconnection
	 * back-off less aggressive. To reduce client
	 * reconnect load on graphql-subscriptions.
	 * The default status multipliers are: { active: 1, idle: 10 }.
	 */ const activeMultiplier = 1;
    let status = 'idle';
    if (typeof window !== 'undefined') // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    status = document.visibilityState === 'visible' ? 'active' : 'idle';
    else status = 'idle';
    return (0, $bBofs.calculateBackOffRange)({
        status: status,
        attemptsCount: retries,
        statusMultipliersOverride: {
            active: activeMultiplier,
            idle: 10
        }
    });
};
module.exports["getBackOffDelay"] = $5a87cb4548ea235b$export$73e02b3a26ecb0d7;
module.exports["getDelayRangeFromGraphqlWebsocketState"] = $5a87cb4548ea235b$export$ac8ba6656a385f56;

});

parcelRegister("bBofs", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/calculateBackOffRange.ts when we move to Relay.
 */ // copied from Trello

var $11y02 = parcelRequire("11y02");

function $35212ac5bc2e900f$export$de85ae9dfb4a57bc({ status: status, attemptsCount: attemptsCount, statusMultipliersOverride: statusMultipliersOverride, jitterStatusMultipliersOverride: jitterStatusMultipliersOverride, connectionHealth: connectionHealth = 'base', baseLowerBoundOverride: baseLowerBoundOverride, baseUpperBoundOverride: baseUpperBoundOverride, maxDelayOverride: maxDelayOverride }) {
    const [baseLowerBound, baseUpperBound] = (0, $11y02.getReconnectDelayBounds)(connectionHealth);
    const maxDelay = maxDelayOverride ?? (0, $11y02.getMaxDelay)({
        status: status,
        connectionHealth: connectionHealth
    });
    const statusMultipliers = statusMultipliersOverride ?? (0, $11y02.getDefaultStatusMultipliers)();
    const jitterStatusMultipliers = jitterStatusMultipliersOverride ?? (0, $11y02.jitterStatusMultipliers);
    const attemptsMultiplier = Math.pow(2, attemptsCount);
    const totalMultiplier = statusMultipliers[status] * attemptsMultiplier;
    const jitterMultiplier = jitterStatusMultipliers[status];
    const maxFirstActiveDelay = 2000;
    const maxFirstIdleDelay = 60000;
    let tempUpperOverride;
    if (attemptsCount > 0) tempUpperOverride = undefined;
    else if (status === 'active') tempUpperOverride = maxFirstActiveDelay;
    else tempUpperOverride = maxFirstIdleDelay;
    const lowerBound = (baseLowerBoundOverride ?? baseLowerBound) * totalMultiplier;
    const upperBound = tempUpperOverride ?? (baseUpperBoundOverride ?? baseUpperBound) * totalMultiplier * jitterMultiplier;
    return [
        Math.min(lowerBound, maxDelay),
        Math.min(upperBound, maxDelay)
    ];
}
module.exports["calculateBackOffRange"] = $35212ac5bc2e900f$export$de85ae9dfb4a57bc;

});

parcelRegister("11y02", function(module, exports) {
/**
 * This will be removed in favour of @confluence/relay-network/src/backOffConfig.ts when we move to Relay.
 */ // copied from Trello
const $0b8d464841156fc9$var$TEN_MINUTES_IN_MS = 600000;
const $0b8d464841156fc9$export$d89658363be37383 = ({ status: status, connectionHealth: connectionHealth })=>{
    const maxDelays = {
        active: {
            base: 64000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        },
        idle: {
            base: 450000,
            serverIncident: $0b8d464841156fc9$var$TEN_MINUTES_IN_MS
        }
    };
    return maxDelays[status][connectionHealth];
};
const $0b8d464841156fc9$export$1b131e77a0e75a0a = ()=>({
        active: 1,
        idle: 15
    });
const $0b8d464841156fc9$export$a1d6d3ff41cd93e9 = {
    active: 1,
    idle: 2
};
const $0b8d464841156fc9$export$e5680a2329370bd3 = (connectionHealth)=>{
    const bounds = {
        base: [
            800,
            2000
        ],
        serverIncident: [
            800,
            4000
        ]
    };
    return bounds[connectionHealth];
};
module.exports["getMaxDelay"] = $0b8d464841156fc9$export$d89658363be37383;
module.exports["getDefaultStatusMultipliers"] = $0b8d464841156fc9$export$1b131e77a0e75a0a;
module.exports["jitterStatusMultipliers"] = $0b8d464841156fc9$export$a1d6d3ff41cd93e9;
module.exports["getReconnectDelayBounds"] = $0b8d464841156fc9$export$e5680a2329370bd3;

});

parcelRegister("3cnNA", function(module, exports) {

var $10d5H = parcelRequire("10d5H");

const $eb414ef0fc36a486$export$51a2bb897a605125 = new (0, $10d5H.ApolloLink)((operation, forward)=>{
    if (operation.variables && operation.variables.__extensions) {
        operation.setContext({
            extensions: operation.variables.__extensions
        });
        // remove the property since it's not an actual valid variable
        delete operation.variables.__extensions;
    }
    return forward(operation);
});
module.exports["AttachExtensionsLink"] = $eb414ef0fc36a486$export$51a2bb897a605125;

});

parcelRegister("1E17N", function(module, exports) {

let $132a663b7640cb52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $132a663b7640cb52$var$load("gSXIX").then(()=>parcelRequire('kWFOs'));

});

parcelRegister("igNpi", function(module, exports) {

var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $9SZCg = parcelRequire("9SZCg");


var $bjG4U = parcelRequire("bjG4U");


var $6E8wG = parcelRequire("6E8wG");

class $9cc86fa76e4862e6$export$ecb92ae593a5eb65 {
    get(variables) {
        return this.readers.get((0, $eqEJl.createOperationDescriptor)((0, $9SZCg.default), variables).request.identifier);
    }
    preload(variables, config, storeOnly = false) {
        const identifier = (0, $eqEJl.createOperationDescriptor)((0, $9SZCg.default), variables).request.identifier;
        const existing = this.entries.get(identifier);
        if (existing && !existing.execution.failed && !existing.execution.disposed) {
            if (!existing.execution.settled || this.environment.check(existing.execution.operation).status === 'available') return existing.execution;
        }
        const execution = new (0, $6E8wG.PersonalizationQueryReference)(this.environment, variables, config, storeOnly);
        const entry = {
            execution: execution,
            views: [],
            pendingReaders: new Set(),
            readers: 0,
            unclaimed: true
        };
        this.entries.set(identifier, entry);
        this.allEntries.add(entry);
        // Cache-only hydration must publish references synchronously before React starts.
        if (execution.settled) this.publish(entry);
        else execution.ready.then(()=>this.publish(entry));
        return execution;
    }
    publish(entry) {
        const { execution: execution } = entry;
        if (execution.disposed || execution.failed || execution.hasUnscopedErrors) return;
        const variables = execution.variables;
        const identity = {
            cloudId: variables.cloudId,
            contentId: variables.contentId,
            spaceKey: variables.spaceKey,
            isBlog: variables.catchupContentType === 'BLOGPOST' || variables.recommendationEntityType === 'blogpost'
        };
        // Readers select only their group. A Loom field error cannot poison a presence read.
        const groups = [
            ...variables.includePresenceSettings ? [
                {
                    presence: true
                }
            ] : [],
            ...variables.includeRecommendations ? [
                {
                    recommendations: {
                        experience: variables.recommendationExperience
                    }
                }
            ] : [],
            ...variables.includeAIFloatingContextMenu ? [
                {
                    catchup: true
                }
            ] : []
        ];
        for (const group of groups){
            const selected = (0, $bjG4U.buildViewPagePersonalizationVariables)(identity, group);
            const view = {
                variables: selected,
                reference: (0, $6SsN4.loadQuery)(this.environment, (0, $9SZCg.default), selected, {
                    fetchPolicy: 'store-only'
                }),
                disposed: false
            };
            entry.views.push(view);
            entry.pendingReaders.add(view);
            this.entryByReader.set(view, entry);
            this.readers.set((0, $eqEJl.createOperationDescriptor)((0, $9SZCg.default), selected).request.identifier, view);
        }
        this.notify();
    }
    retain(view) {
        const entry = this.entryByReader.get(view);
        if (!entry || view.disposed) return ()=>{};
        entry.readers++;
        entry.pendingReaders.delete(view);
        entry.unclaimed = entry.pendingReaders.size > 0;
        let released = false;
        return ()=>{
            if (released) return;
            released = true;
            entry.readers--;
            queueMicrotask(()=>{
                if (!entry.readers && !entry.unclaimed) this.remove(entry);
            });
        };
    }
    /** Called at navigation start, including navigation away and cancellation by a newer route. */ beginPreload() {
        this.hydrationCleanup?.();
        this.hydrationCleanup = undefined;
        for (const entry of this.allEntries){
            entry.unclaimed = false;
            entry.pendingReaders.clear();
            if (!entry.readers) this.remove(entry);
        }
    }
    getHydrationVariables() {
        const variables = [];
        for (const { execution: execution } of this.entries.values())if (execution.settled && !execution.disposed && !execution.failed && !execution.hasUnscopedErrors) variables.push(execution.variables);
        return variables;
    }
    setHydrationCleanup(cleanup) {
        this.hydrationCleanup?.();
        this.hydrationCleanup = cleanup;
    }
    remove(entry) {
        this.allEntries.delete(entry);
        const identifier = entry.execution.operation.request.identifier;
        if (this.entries.get(identifier) === entry) this.entries.delete(identifier);
        for (const view of entry.views){
            const key = (0, $eqEJl.createOperationDescriptor)((0, $9SZCg.default), view.variables).request.identifier;
            if (this.readers.get(key) === view) this.readers.delete(key);
            view.disposed = true;
            view.reference.dispose();
        }
        entry.execution.dispose();
        this.notify();
    }
    notify() {
        $9cc86fa76e4862e6$var$listeners.get(this.environment)?.forEach((listener)=>listener());
    }
    constructor(environment){
        this.environment = environment;
        this.entries = new Map();
        this.allEntries = new Set();
        this.readers = new Map();
        this.entryByReader = new WeakMap();
        this.hydrationCleanup = void 0;
    }
}
const $9cc86fa76e4862e6$var$owners = new WeakMap();
const $9cc86fa76e4862e6$var$listeners = new WeakMap();
function $9cc86fa76e4862e6$export$e20a2c2cb6c2ee74(environment) {
    return $9cc86fa76e4862e6$var$owners.get(environment);
}
function $9cc86fa76e4862e6$export$e453f26fae43710d(environment) {
    let owner = $9cc86fa76e4862e6$var$owners.get(environment);
    if (!owner) {
        owner = new $9cc86fa76e4862e6$export$ecb92ae593a5eb65(environment);
        $9cc86fa76e4862e6$var$owners.set(environment, owner);
    }
    return owner;
}
function $9cc86fa76e4862e6$export$48b931ef07f36b8(environment, listener) {
    let subscriptions = $9cc86fa76e4862e6$var$listeners.get(environment);
    if (!subscriptions) {
        subscriptions = new Set();
        $9cc86fa76e4862e6$var$listeners.set(environment, subscriptions);
    }
    subscriptions.add(listener);
    return ()=>{
        subscriptions.delete(listener);
    };
}
module.exports["getPersonalizationQueryOwner"] = $9cc86fa76e4862e6$export$e20a2c2cb6c2ee74;
module.exports["getOrCreatePersonalizationQueryOwner"] = $9cc86fa76e4862e6$export$e453f26fae43710d;
module.exports["subscribePersonalizationQueryOwner"] = $9cc86fa76e4862e6$export$48b931ef07f36b8;

});

parcelRegister("9SZCg", function(module, exports) {
/**
 * @generated SignedSource<<7f04d37cdf4ad0ede96174e6b4a88306>>
 * @relayHash 220e81da920208aff34e40582f078295
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5a83ff1206bb8bcee263f8c6ac3a2b5fe6fce5cb1e3693af05a243470e999487
const $5f372913b3f00924$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "catchupContentType"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAIFloatingContextMenu"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeLoom"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMeetingRecorderEligibility"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeOnboardingState"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePresenceSettings"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRecommendations"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "onboardingKeys"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "recommendationEntityType"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "recommendationExperience"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "recommendationSpaceId"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v14 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v15 = {
        "args": [
            v14 /*: any*/ 
        ],
        "concreteType": "ConfluenceLoomEntryPoints",
        "kind": "LinkedField",
        "name": "confluence_loomEntryPoints",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isLoomEntryPointsEnabled"
            }
        ]
    }, v16 = [
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v17 = {
        "condition": "includeMeetingRecorderEligibility",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": v16 /*: any*/ ,
                "concreteType": "LoomSettings",
                "kind": "LinkedField",
                "name": "loom_settings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "meetingRecordingsAvailable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "meetingNotesEligible"
                    }
                ]
            },
            {
                "args": v16 /*: any*/ ,
                "concreteType": "LoomConnectedCalendar",
                "kind": "LinkedField",
                "name": "loom_connectedCalendars",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "guid"
                    }
                ]
            }
        ]
    }, v18 = {
        "concreteType": "ConfluenceTenantContext",
        "kind": "LinkedField",
        "name": "confluence_tenantContext",
        "plural": false,
        "selections": [
            {
                "concreteType": "LicensedProduct",
                "kind": "LinkedField",
                "name": "licensedProducts",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "licenseStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "productKey"
                    }
                ]
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "id"
    }, v20 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v19 /*: any*/ 
        ]
    }, v21 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "recommendationEntityType"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "recommendationExperience"
        }
    ], v22 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "recommendationSpaceId"
        }
    ], v23 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "onboardingKeys"
        }
    ], v24 = [
        {
            "kind": "Variable",
            "name": "contentId",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "contentType",
            "variableName": "catchupContentType"
        }
    ], v25 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        }
    ], v26 = {
        "kind": "ScalarField",
        "name": "key"
    }, v27 = {
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": {
                "throwOnFieldError": true
            },
            "name": "ViewPagePersonalizationQuery",
            "selections": [
                {
                    "condition": "includeLoom",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "InlineDataFragmentSpread",
                                        "name": "loomPersonalization_entryPoints",
                                        "selections": [
                                            v15 /*: any*/ ,
                                            v17 /*: any*/ 
                                        ],
                                        "argumentDefinitions": [
                                            {
                                                "kind": "RootArgument",
                                                "name": "cloudId"
                                            },
                                            {
                                                "kind": "RootArgument",
                                                "name": "includeMeetingRecorderEligibility"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "InlineDataFragmentSpread",
                                        "name": "loomPersonalization_tenant",
                                        "selections": [
                                            v18 /*: any*/ 
                                        ],
                                        "argumentDefinitions": []
                                    }
                                ]
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "loom"
                        }
                    ]
                },
                {
                    "condition": "includeRecommendations",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v20 /*: any*/ ,
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "RecommendedPages",
                            "kind": "LinkedField",
                            "name": "getRecommendedPages",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "EndOfPageRecommendation_recommendedPagesReader"
                                }
                            ]
                        },
                        {
                            "args": v22 /*: any*/ ,
                            "concreteType": "RecommendedPagesSpaceStatus",
                            "kind": "LinkedField",
                            "name": "getRecommendedPagesSpaceStatus",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "EndOfPageRecommendation_spaceStatusReader"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeOnboardingState",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "OnboardingState",
                            "kind": "LinkedField",
                            "name": "onboardingState",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "onboardingState_state"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeAIFloatingContextMenu",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v24 /*: any*/ ,
                            "concreteType": "CatchupLastViewedTimeResponse",
                            "kind": "LinkedField",
                            "name": "catchupGetLastViewedTime",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "useDynamicSplitButton_catchupLastViewedTimeReader"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includePresenceSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v25 /*: any*/ ,
                            "concreteType": "ConfluenceTeamPresence",
                            "kind": "LinkedField",
                            "name": "confluence_teamPresenceContentSetting",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ContentHeaderPresence_contentSettingReader"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v9 /*: any*/ ,
                v8 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ViewPagePersonalizationQuery",
            "selections": [
                {
                    "condition": "includeLoom",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v15 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ 
                    ]
                },
                {
                    "condition": "includeRecommendations",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        v20 /*: any*/ ,
                        {
                            "args": v21 /*: any*/ ,
                            "concreteType": "RecommendedPages",
                            "kind": "LinkedField",
                            "name": "getRecommendedPages",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "RecommendedPagesItem",
                                    "kind": "LinkedField",
                                    "name": "recommendedPages",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "title"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "subType"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "creatorId"
                                                },
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "ownedBy",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "__typename"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "alias": "emoji",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "key",
                                                            "value": "emoji-title-published"
                                                        }
                                                    ],
                                                    "concreteType": "PaginatedJsonContentPropertyList",
                                                    "kind": "LinkedField",
                                                    "name": "properties",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JsonContentProperty",
                                                            "kind": "LinkedField",
                                                            "name": "nodes",
                                                            "plural": true,
                                                            "selections": [
                                                                v19 /*: any*/ ,
                                                                v26 /*: any*/ ,
                                                                v27 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "strategy"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v22 /*: any*/ ,
                            "concreteType": "RecommendedPagesSpaceStatus",
                            "kind": "LinkedField",
                            "name": "getRecommendedPagesSpaceStatus",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "recommendedPagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "defaultBehavior"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeOnboardingState",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v23 /*: any*/ ,
                            "concreteType": "OnboardingState",
                            "kind": "LinkedField",
                            "name": "onboardingState",
                            "plural": true,
                            "selections": [
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeAIFloatingContextMenu",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v24 /*: any*/ ,
                            "concreteType": "CatchupLastViewedTimeResponse",
                            "kind": "LinkedField",
                            "name": "catchupGetLastViewedTime",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastViewedTimeISO"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includePresenceSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v25 /*: any*/ ,
                            "concreteType": "ConfluenceTeamPresence",
                            "kind": "LinkedField",
                            "name": "confluence_teamPresenceContentSetting",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isEnabledOnContentView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "220e81da920208aff34e40582f078295",
            "id": "5a83ff1206bb8bcee263f8c6ac3a2b5fe6fce5cb1e3693af05a243470e999487",
            "metadata": {},
            "name": "ViewPagePersonalizationQuery",
            "operationKind": "query",
            "text": "query ViewPagePersonalizationQuery($contentId:ID!,$spaceKey:String!,$cloudId:ID!,$catchupContentType:CatchupContentType!,$recommendationEntityType:String!,$recommendationExperience:String!,$recommendationSpaceId:ID!,$onboardingKeys:[String],$includeRecommendations:Boolean=false,$includeOnboardingState:Boolean=false,$includeAIFloatingContextMenu:Boolean=false,$includePresenceSettings:Boolean=false,$includeLoom:Boolean=false,$includeMeetingRecorderEligibility:Boolean!){...loomPersonalization_entryPoints@include(if:$includeLoom)\n  ...loomPersonalization_tenant@include(if:$includeLoom),space(key:$spaceKey)@include(if:$includeRecommendations){id}\n  getRecommendedPages(entityType:$recommendationEntityType,entityId:$contentId,experience:$recommendationExperience)@include(if:$includeRecommendations){...EndOfPageRecommendation_recommendedPagesReader}\n  getRecommendedPagesSpaceStatus(entityId:$recommendationSpaceId)@include(if:$includeRecommendations){...EndOfPageRecommendation_spaceStatusReader},onboardingState(key:$onboardingKeys)@include(if:$includeOnboardingState){...onboardingState_state},catchupGetLastViewedTime(contentId:$contentId,contentType:$catchupContentType)@include(if:$includeAIFloatingContextMenu){...useDynamicSplitButton_catchupLastViewedTimeReader},confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey)@include(if:$includePresenceSettings){...ContentHeaderPresence_contentSettingReader}}fragment ContentHeaderPresence_contentSettingReader on ConfluenceTeamPresence{isEnabledOnContentView}fragment EndOfPageRecommendation_recommendedPagesReader on RecommendedPages{recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy}}fragment EndOfPageRecommendation_spaceStatusReader on RecommendedPagesSpaceStatus{recommendedPagesEnabled,defaultBehavior}fragment loomPersonalization_entryPoints on Query{confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}fragment loomPersonalization_tenant on Query{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}fragment onboardingState_state on OnboardingState{key,value}fragment useDynamicSplitButton_catchupLastViewedTimeReader on CatchupLastViewedTimeResponse{lastViewedTimeISO}"
        }
    };
}();
$5f372913b3f00924$var$node.hash = "2317e847bd4a7be5764c66d64e219490";
var $5f372913b3f00924$export$2e2bcd8739ae039 = $5f372913b3f00924$var$node;
module.exports["default"] = $5f372913b3f00924$export$2e2bcd8739ae039;

});

parcelRegister("bjG4U", function(module, exports) {
function $dc73dfbd1aacc85c$export$ad9484362db9e2b0({ cloudId: cloudId, contentId: contentId, spaceKey: spaceKey, isBlog: isBlog }, groups) {
    return {
        cloudId: cloudId,
        contentId: contentId,
        spaceKey: spaceKey,
        includeLoom: !!groups.loom,
        includeMeetingRecorderEligibility: groups.loom?.includeMeetingRecorderEligibility ?? false,
        includeRecommendations: !!groups.recommendations,
        recommendationEntityType: groups.recommendations ? isBlog ? 'blogpost' : 'page' : '',
        recommendationExperience: groups.recommendations?.experience ?? '',
        // The legacy space-status query takes the space key, despite the scaffold variable's name.
        recommendationSpaceId: groups.recommendations ? spaceKey : '',
        includeOnboardingState: !!groups.onboarding || !!groups.omnibar,
        onboardingKeys: groups.onboarding || groups.omnibar ? [
            ...new Set([
                ...groups.onboarding?.keys ?? [],
                ...groups.omnibar?.keys ?? []
            ])
        ] : undefined,
        includeAIFloatingContextMenu: !!groups.catchup,
        catchupContentType: groups.catchup && isBlog ? 'BLOGPOST' : 'PAGE',
        includePresenceSettings: !!groups.presence
    };
}
module.exports["buildViewPagePersonalizationVariables"] = $dc73dfbd1aacc85c$export$ad9484362db9e2b0;

});

parcelRegister("6E8wG", function(module, exports) {

var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $9SZCg = parcelRequire("9SZCg");

class $b05a3db7fae5de23$export$b8bb98331c7ececf {
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        this.unsubscribe();
        this.reference.dispose();
        this.finish();
    }
    constructor(environment, variables, networkCacheConfig, storeOnly = false){
        this.variables = variables;
        this.reference = void 0;
        this.ready = void 0;
        this.operation = void 0;
        this.errors = [];
        this.hasUnscopedErrors = false;
        this.failed = false;
        this.settled = false;
        this.disposed = false;
        this.finish = void 0;
        this.unsubscribe = ()=>{};
        this.operation = (0, $eqEJl.createOperationDescriptor)((0, $9SZCg.default), variables);
        let resolveReady = ()=>{};
        this.ready = new Promise((resolve)=>{
            resolveReady = resolve;
        });
        this.finish = ()=>{
            this.settled = true;
            resolveReady();
        };
        this.reference = (0, $6SsN4.loadQuery)(environment, (0, $9SZCg.default), variables, {
            fetchPolicy: storeOnly ? 'store-only' : 'store-or-network',
            networkCacheConfig: networkCacheConfig
        });
        const subscription = this.reference.source?.subscribe({
            next: (response)=>{
                const errors = (Array.isArray(response) ? response : [
                    response
                ]).flatMap((payload)=>'errors' in payload ? payload.errors ?? [] : []);
                this.hasUnscopedErrors || (this.hasUnscopedErrors = errors.some(({ path: path })=>!path?.length));
                this.errors = [
                    ...this.errors,
                    ...errors
                ];
            },
            error: ()=>{
                this.failed = true;
                this.finish();
            },
            complete: this.finish
        });
        this.unsubscribe = ()=>subscription?.unsubscribe();
        if (!this.reference.source) this.finish();
    }
}
module.exports["PersonalizationQueryReference"] = $b05a3db7fae5de23$export$b8bb98331c7ececf;

});

parcelRegister("kEZox", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $1ydBT = parcelRequire("1ydBT");


var $gfau1 = parcelRequire("gfau1");

class $52306873530fe7fb$export$a613a584c68ef13f {
    notify() {
        $52306873530fe7fb$var$listeners.get(this.environment)?.forEach((listener)=>listener());
    }
    beginPreload() {
        this.hydrationCleanup?.();
        this.hydrationCleanup = undefined;
        this.releaseUnclaimed();
    }
    getHydrationVariables() {
        const query = this.pending?.query;
        return query?.settled && !query.error && !query.disposed ? query.variables : undefined;
    }
    setHydrationCleanup(cleanup) {
        this.hydrationCleanup?.();
        this.hydrationCleanup = cleanup;
    }
    get(variables) {
        return this.entries.get((0, $eqEJl.createOperationDescriptor)((0, $1ydBT.default), variables).request.identifier)?.query;
    }
    preload(variables, fetchPolicy = 'store-or-network') {
        const existing = this.get(variables);
        if (existing && !existing.disposed && !existing.error && (fetchPolicy !== 'network-only' || !existing.settled)) return existing;
        this.releaseUnclaimed();
        const query = new (0, $gfau1.ConversationQueryReference)(this.environment, variables, fetchPolicy);
        const entry = {
            query: query,
            readers: 0
        };
        this.entries.set(query.identifier, entry);
        this.entriesByReference.set(query, entry);
        this.pending = entry;
        this.notify();
        return query;
    }
    retain(query) {
        const entry = this.entriesByReference.get(query);
        if (!entry || query.disposed) // A superseded render may reach its effect after its preload was cancelled.
        // It must not resurrect that execution or invalidate the current owner.
        return ()=>{};
        entry.readers++;
        this.hydrationCleanup?.();
        this.hydrationCleanup = undefined;
        if (this.pending === entry) this.pending = undefined;
        let released = false;
        return ()=>{
            if (released) return;
            released = true;
            entry.readers--;
            // A Strict Mode effect replay can immediately acquire the same reference.
            queueMicrotask(()=>{
                if (entry.readers === 0 && this.pending !== entry) this.remove(entry);
            });
        };
    }
    releaseUnclaimed() {
        if (this.pending && this.pending.readers === 0) this.remove(this.pending);
        this.pending = undefined;
    }
    remove(entry) {
        if (this.entries.get(entry.query.identifier) === entry) {
            this.entries.delete(entry.query.identifier);
            this.notify();
        }
        entry.query.dispose();
    }
    constructor(environment){
        this.environment = environment;
        this.entries = new Map();
        this.entriesByReference = new WeakMap();
        this.pending = void 0;
        this.hydrationCleanup = void 0;
    }
}
const $52306873530fe7fb$var$owners = new WeakMap();
const $52306873530fe7fb$var$listeners = new WeakMap();
function $52306873530fe7fb$export$9f3e4a8f3a02df64(environment, listener) {
    let subscriptions = $52306873530fe7fb$var$listeners.get(environment);
    if (!subscriptions) {
        subscriptions = new Set();
        $52306873530fe7fb$var$listeners.set(environment, subscriptions);
    }
    subscriptions.add(listener);
    return ()=>{
        subscriptions.delete(listener);
    };
}
function $52306873530fe7fb$export$18067d6bf0009185(environment) {
    let owner = $52306873530fe7fb$var$owners.get(environment);
    if (!owner) {
        owner = new $52306873530fe7fb$export$a613a584c68ef13f(environment);
        $52306873530fe7fb$var$owners.set(environment, owner);
    }
    return owner;
}
function $52306873530fe7fb$export$56c143153516a087(environment) {
    return $52306873530fe7fb$var$owners.get(environment);
}
module.exports["subscribeConversationQueryOwner"] = $52306873530fe7fb$export$9f3e4a8f3a02df64;
module.exports["getOrCreateConversationQueryOwner"] = $52306873530fe7fb$export$18067d6bf0009185;
module.exports["getConversationQueryOwner"] = $52306873530fe7fb$export$56c143153516a087;

});

parcelRegister("1ydBT", function(module, exports) {
/**
 * @generated SignedSource<<8bf3e558a6ab7f9cbe727ebec14e7660>>
 * @relayHash 6268a05e132ec3982e53079d2aba0f1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ce1d7cffa61983594faed4d537e36e9aeef26539ed557ceaf1f6c2812ed8f78f
const $4edc52e24113851d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "focusedCommentId"
    }, v3 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeCommentReactions"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCommentThreads"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeConversationData"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFocusedComment"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v8 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v9 = [
        {
            "kind": "Literal",
            "name": "confluenceCommentFilter",
            "value": {
                "commentState": "UNRESOLVED",
                "commentType": "FOOTER"
            }
        },
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ROOT"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        v8 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": [
                "FOOTER"
            ]
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "type"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v14 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = [
        v18 /*: any*/ 
    ], v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v19 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v21 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v22 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v19 /*: any*/ 
    }, v23 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v24 = {
        "kind": "ScalarField",
        "name": "editui"
    }, v25 = {
        "kind": "ScalarField",
        "name": "webui"
    }, v26 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v25 /*: any*/ 
        ]
    }, v27 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v28 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v29 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v30 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v31 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v27 /*: any*/ ,
                            v28 /*: any*/ ,
                            v29 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v27 /*: any*/ ,
                            v28 /*: any*/ ,
                            v29 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v32 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v33 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v34 = {
        "condition": "includeCommentReactions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    v8 /*: any*/ 
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            v10 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v35 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "number"
    }, v37 = {
        "kind": "ScalarField",
        "name": "when"
    }, v38 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ ,
                    v15 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            },
            v17 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v10 /*: any*/ 
                ]
            },
            v21 /*: any*/ ,
            v22 /*: any*/ ,
            v23 /*: any*/ ,
            v26 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v33 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v11 /*: any*/ ,
                            v12 /*: any*/ ,
                            v13 /*: any*/ ,
                            v16 /*: any*/ ,
                            v14 /*: any*/ 
                        ]
                    },
                    v20 /*: any*/ ,
                    v21 /*: any*/ ,
                    v22 /*: any*/ ,
                    v23 /*: any*/ ,
                    v26 /*: any*/ ,
                    v31 /*: any*/ ,
                    v32 /*: any*/ ,
                    v33 /*: any*/ ,
                    v34 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            v35 /*: any*/ ,
                            v36 /*: any*/ ,
                            v37 /*: any*/ 
                        ]
                    },
                    v17 /*: any*/ 
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v11 /*: any*/ ,
                            v15 /*: any*/ ,
                            v12 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v36 /*: any*/ ,
                    v37 /*: any*/ 
                ]
            },
            v34 /*: any*/ 
        ]
    }, v39 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v40 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "pageId"
    }, v41 = [
        v40 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "current",
                "archived",
                "draft"
            ]
        }
    ], v42 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "focusedCommentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v43 = [
        {
            "kind": "Literal",
            "name": "current",
            "value": true
        }
    ], v44 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v45 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v46 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v10 /*: any*/ ,
            v45 /*: any*/ 
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v48 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v35 /*: any*/ ,
            v37 /*: any*/ ,
            v36 /*: any*/ 
        ]
    }, v49 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v25 /*: any*/ ,
            v24 /*: any*/ 
        ]
    }, v50 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v14 /*: any*/ ,
            v13 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v10 /*: any*/ ,
            v20 /*: any*/ ,
            v22 /*: any*/ ,
            v23 /*: any*/ ,
            v47 /*: any*/ ,
            v33 /*: any*/ ,
            v48 /*: any*/ ,
            v49 /*: any*/ ,
            v50 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "includeCommentThreads",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageConversation_commentThreads"
                                            }
                                        ],
                                        "type": "PaginatedCommentList"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "conversationCommentThreads"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeConversationData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ViewPageConversation_currentUser"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "conversationCurrentUser"
                        },
                        {
                            "args": v41 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ViewPageConversation_contentPermission"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeFocusedComment",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "focusedInlineComment",
                            "args": v42 /*: any*/ ,
                            "concreteType": "PaginatedCommentList",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ViewPageConversation_focusedInlineComment"
                                }
                            ]
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ViewPageConversation_focusedInlineCommentContext"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "focusedInlineCommentContext"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v7 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "selections": [
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        v38 /*: any*/ ,
                        v39 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                },
                {
                    "condition": "includeConversationData",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "user",
                            "args": v43 /*: any*/ ,
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        v44 /*: any*/ ,
                                        v18 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        },
                        {
                            "args": v41 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v45 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v16 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeFocusedComment",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "focusedInlineComment",
                            "args": v42 /*: any*/ ,
                            "concreteType": "PaginatedCommentList",
                            "kind": "LinkedField",
                            "name": "comments",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Comment",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v48 /*: any*/ ,
                                                v49 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        v10 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v33 /*: any*/ ,
                                        v48 /*: any*/ ,
                                        v49 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v51 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "focusedContent",
                            "args": [
                                v40 /*: any*/ 
                            ],
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v45 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "user",
                            "args": v43 /*: any*/ ,
                            "concreteType": "AtlassianUser",
                            "kind": "LinkedField",
                            "name": "confluence_atlassianUser",
                            "plural": false,
                            "selections": [
                                v10 /*: any*/ ,
                                v12 /*: any*/ ,
                                {
                                    "concreteType": "AtlassianUserPhoto",
                                    "kind": "LinkedField",
                                    "name": "photos",
                                    "plural": true,
                                    "selections": [
                                        v18 /*: any*/ ,
                                        v44 /*: any*/ 
                                    ]
                                }
                            ],
                            "storageKey": "confluence_atlassianUser(current:true)"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6268a05e132ec3982e53079d2aba0f1b",
            "id": "ce1d7cffa61983594faed4d537e36e9aeef26539ed557ceaf1f6c2812ed8f78f",
            "metadata": {},
            "name": "ObjectCommentContainerPreloadObjectCommentsQuery",
            "operationKind": "query",
            "text": "query ObjectCommentContainerPreloadObjectCommentsQuery($pageId:ID!,$contentStatus:[GraphQLContentStatus],$first:Long,$includeCommentReactions:Boolean=true,$includeConversationData:Boolean=false,$includeCommentThreads:Boolean=false,$focusedCommentId:ID,$includeFocusedComment:Boolean=false){...ViewPageConversation_currentUser@include(if:$includeConversationData)\n  content(id:$pageId,status:[\"current\",\"archived\",\"draft\"])@include(if:$includeConversationData){nodes{...ViewPageConversation_contentPermission,id}},comments(pageId:$pageId,contentStatus:$contentStatus,depth:ROOT,first:$first,type:[FOOTER],confluenceCommentFilter:{commentState:UNRESOLVED,commentType:FOOTER}){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename,...ViewPageConversation_commentThreads@include(if:$includeCommentThreads)},focusedInlineComment:comments(commentId:$focusedCommentId,depth:ALL,type:UNRESOLVED)@include(if:$includeFocusedComment){...ViewPageConversation_focusedInlineComment}\n  ...ViewPageConversation_focusedInlineCommentContext@include(if:$includeFocusedComment)}fragment ViewPageConversation_commentThreads on PaginatedCommentList{nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeCommentReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when},contributors{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}},totalCount,__typename}fragment ViewPageConversation_contentPermission on Content{id,type,operations{operation,targetType},space{id,operations{operation,targetType}},history{createdBy{__typename,...on KnownUser{accountId}}}}fragment ViewPageConversation_currentUser on Query{user:confluence_atlassianUser(current:true){id,displayName,photos{isPrimary,value}}}fragment ViewPageConversation_focusedInlineComment on PaginatedCommentList{nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}}fragment ViewPageConversation_focusedInlineCommentContext on Query{focusedContent:content(id:$pageId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$4edc52e24113851d$var$node.hash = "2cfe5fc37f71ef70f39b17155896292b";
var $4edc52e24113851d$export$2e2bcd8739ae039 = $4edc52e24113851d$var$node;
module.exports["default"] = $4edc52e24113851d$export$2e2bcd8739ae039;

});

parcelRegister("gfau1", function(module, exports) {

var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $gnyNQ = parcelRequire("gnyNQ");


var $7m1pr = parcelRequire("7m1pr");


var $1ydBT = parcelRequire("1ydBT");

class $f0e361a4edb63764$export$cb023a8b0688f1e2 {
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        this.unsubscribe();
        this.reference.dispose();
        // Cancellation must also release a preloader waiting for completion.
        this.finish();
    }
    constructor(environment, variables, fetchPolicy = 'store-or-network'){
        this.environment = environment;
        this.reference = void 0;
        this.ready = void 0;
        this.identifier = void 0;
        this.variables = void 0;
        this.error = void 0;
        this.settled = false;
        this.failed = false;
        this.disposed = false;
        this.finish = void 0;
        this.unsubscribe = ()=>{};
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $1ydBT.default), variables);
        this.identifier = operation.request.identifier;
        this.variables = {
            ...variables,
            ...operation.request.variables
        };
        let resolveReady = ()=>{};
        this.ready = new Promise((resolve)=>{
            resolveReady = resolve;
        });
        this.finish = ()=>{
            this.settled = true;
            resolveReady();
        };
        this.reference = (0, $6SsN4.loadQuery)(environment, (0, $1ydBT.default), this.variables, {
            fetchPolicy: fetchPolicy,
            // Preserve the attribution supplied by the previous route preloader.
            networkCacheConfig: {
                metadata: {
                    headers: (0, $gnyNQ.getAtlAttributionHeader)()
                }
            }
        });
        let graphQLErrors = [];
        const subscription = this.reference.source?.subscribe({
            next: (response)=>{
                graphQLErrors = [
                    ...graphQLErrors,
                    ...(Array.isArray(response) ? response : [
                        response
                    ]).flatMap((payload)=>payload.errors ?? [])
                ];
                if (graphQLErrors.length) this.error = new (0, $7m1pr.RelayError)({
                    graphQLErrors: graphQLErrors
                });
            },
            error: (failure)=>{
                this.failed = true;
                const payloads = Array.isArray(failure) ? failure.filter((0, $7m1pr.isRelayGraphQLError)) : (0, $7m1pr.isRelayGraphQLError)(failure) ? [
                    failure
                ] : failure instanceof Error && 'source' in failure && typeof failure.source === 'object' && failure.source !== null && 'errors' in failure.source && Array.isArray(failure.source.errors) ? failure.source.errors.filter((0, $7m1pr.isRelayGraphQLError)) : [];
                this.error = (0, $7m1pr.isRelayError)(failure) ? failure : new (0, $7m1pr.RelayError)({
                    graphQLErrors: [
                        ...graphQLErrors,
                        ...payloads
                    ],
                    networkError: payloads.length ? undefined : failure instanceof Error ? failure : new Error(String(failure))
                });
                this.finish();
            },
            complete: this.finish
        });
        this.unsubscribe = ()=>subscription?.unsubscribe();
        if (!this.reference.source) this.finish();
    }
}
module.exports["ConversationQueryReference"] = $f0e361a4edb63764$export$cb023a8b0688f1e2;

});

parcelRegister("dYU3e", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");


var $95rLf = parcelRequire("95rLf");


var $86okN = parcelRequire("86okN");


var $fEmGS = parcelRequire("fEmGS");


var $c0rhi = parcelRequire("c0rhi");


var $iffSy = parcelRequire("iffSy");



var $7Lnfv = parcelRequire("7Lnfv");


var $2GGOW = parcelRequire("2GGOW");


var $5oHEP = parcelRequire("5oHEP");


var $iYld5 = parcelRequire("iYld5");



var $gnyNQ = parcelRequire("gnyNQ");

const $48ba6fb41a85dc7e$var$addExtraInfoToError = (error, extraInfo)=>{
    try {
        const existingExtraInfo = Reflect.get(error, 'extraInfo');
        const existingExtraInfoObject = typeof existingExtraInfo === 'object' && existingExtraInfo !== null ? existingExtraInfo : undefined;
        Reflect.set(error, 'extraInfo', {
            ...existingExtraInfoObject,
            ...extraInfo
        });
    } catch  {
    // Some error shapes can be non-extensible. Extra info is best-effort diagnostics.
    }
};
const $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors = (errors, extraInfo)=>{
    errors?.forEach((error)=>{
        $48ba6fb41a85dc7e$var$addExtraInfoToError(error, extraInfo);
    });
};
const $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors = (result)=>{
    // Preloading is "fire and forget" operation on a client as well, so we can mute
    // some known errors, but we can't really do anything about them as they're not
    // make it to the Apollo cache anyway and therefore don't pop at where they can
    // be handled.
    const hasErrors = result?.errors?.length > 0;
    result?.errors?.forEach((error)=>{
        if ((0, $2GGOW.isUnauthorizedError)(error) || (0, $95rLf.isExpectedApolloError)(error) || (0, $iYld5.isNotFoundSpaceError)(error) || (0, $5oHEP.isNotFoundError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    });
    return hasErrors;
};
function $48ba6fb41a85dc7e$export$2fa187e846a241c4({ query: _query, variables: variables, fetchPolicy: /**
   * How to preload with fresh data correctly.
   * In preloader: query with fetchPolicy: "network-only"
   */ fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'all', context: context, client: client = window.GLOBAL_APOLLO_CLIENT, __callerPackage__: __callerPackage__, relayQueryPreloadRetention: relayQueryPreloadRetention }) {
    const query = (0, $86okN.toDocumentNode)(_query);
    const name = (0, $7Lnfv.getOperationName)(query);
    // Detect if this is an agg call by checking if the client is the AGG client
    // The AGG client is created with createWrappedFetch({ isForAggOnly: true })
    const isForAggOnly = client === window.GLOBAL_APOLLO_AGG_CLIENT || client?.__isAGGClient === true;
    const preloaderErrorExtraInfo = {
        operationName: name ?? 'unknown',
        callerPackage: __callerPackage__
    };
    const queryContext = {
        ...context
    };
    queryContext.headers = {
        ...context?.headers,
        ...(0, $gnyNQ.getAtlAttributionHeader)()
    };
    if (window.__SSR_REACT_STREAMING__) {
        queryContext.preload = true;
        queryContext.originalQuery = query;
    }
    return (0, $c0rhi.queryInterop)({
        query: _query,
        variables: variables,
        errorPolicy: errorPolicy,
        fetchPolicy: fetchPolicy,
        context: queryContext,
        interopApolloAggClient: isForAggOnly,
        __callerPackage__: __callerPackage__,
        relayQueryPreloadRetention: relayQueryPreloadRetention
    }).then((result)=>{
        const errors = result.error?.graphQLErrors;
        if (result.error) $48ba6fb41a85dc7e$var$addExtraInfoToError(result.error, preloaderErrorExtraInfo);
        $48ba6fb41a85dc7e$var$addExtraInfoToGraphQLErrors(errors, preloaderErrorExtraInfo);
        const interopResult = {
            data: result.data,
            errors: errors
        };
        const hasErrors = $48ba6fb41a85dc7e$var$muteExpectedGraphQLErrors(interopResult);
        return {
            data: result.data ?? null,
            errors: errors,
            hasErrors: hasErrors
        };
    });
}
function $48ba6fb41a85dc7e$export$96f737ecfefc9918(options) {
    return $48ba6fb41a85dc7e$export$2fa187e846a241c4({
        ...options,
        query: options.query,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
function $48ba6fb41a85dc7e$export$eb834b3aa63d4199(options) {
    if ((0, $iffSy.isRelayEnabled)(options.__callerPackage__)) (0, $fEmGS.writeQueryInterop)({
        ...options,
        __callerPackage__: options.__callerPackage__
    });
    else {
        const client = options.client || window.GLOBAL_APOLLO_CLIENT;
        if (client) client.writeQuery({
            ...options,
            query: (0, $86okN.toDocumentNode)(options.query)
        });
    }
}
function $48ba6fb41a85dc7e$export$5e270d77b1b480de(options) {
    $48ba6fb41a85dc7e$export$eb834b3aa63d4199({
        ...options,
        client: window.GLOBAL_APOLLO_AGG_CLIENT
    });
}
module.exports["query"] = $48ba6fb41a85dc7e$export$2fa187e846a241c4;
module.exports["queryAgg"] = $48ba6fb41a85dc7e$export$96f737ecfefc9918;
module.exports["writeAggQuery"] = $48ba6fb41a85dc7e$export$5e270d77b1b480de;

});

parcelRegister("95rLf", function(module, exports) {
const $4470315d103298df$export$288e4801a340fb3c = (error)=>{
    if (error) return error.graphQLErrors?.every($4470315d103298df$var$isExpectedGraphqlError);
    return false;
};
const $4470315d103298df$var$isExpectedGraphqlError = (error)=>{
    return $4470315d103298df$export$6ce1d41e4cf63857(error) || $4470315d103298df$export$33c833057c8824dc(error) || $4470315d103298df$export$76a44867d527fcf4(error) || $4470315d103298df$export$fd9ba55aefe8e8a5(error);
};
const $4470315d103298df$export$6ce1d41e4cf63857 = (error)=>{
    return error.message?.includes('Space not found');
};
const $4470315d103298df$export$fd9ba55aefe8e8a5 = (error)=>{
    return error.message?.includes('Cannot find space with id:');
};
const $4470315d103298df$export$33c833057c8824dc = (error)=>{
    return error.message?.includes('Not permitted to view space with id:');
};
const $4470315d103298df$export$76a44867d527fcf4 = (error)=>{
    return error.message?.includes('User not permitted to access Confluence');
};
module.exports["isExpectedApolloError"] = $4470315d103298df$export$288e4801a340fb3c;

});

parcelRegister("fEmGS", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $bqzdu = parcelRequire("bqzdu");


var $aSAi6 = parcelRequire("aSAi6");


var $9xOXQ = parcelRequire("9xOXQ");


var $7M67g = parcelRequire("7M67g");

function $f0827a369f0dafa9$export$f97bd2548c77448c(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    const source = (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? 'relay' : 'apollo';
    // Relay builds field storage keys from the operation's *resolved* variables, so a query declaring
    // `$first: Int = 20` normalizes under `field(...,first:20)` even when the caller omits `first`.
    // Resolving the artifact's declared defaults here keeps every Relay write below on the same
    // records Relay normalized and the UI subscribes to; using the raw variables would silently
    // write to a sibling record nobody reads. See getRelayOperationVariablesWithDefaults.
    const variables = (0, $7M67g.getRelayOperationVariablesWithDefaults)(params.query, params.variables);
    // Inside a Relay-native optimistic layer (commitMutation optimisticUpdater/updater), route the
    // write onto the provided store proxy so it participates in Relay's disposable layer instead of
    // committing permanently. This upserts records (incl. connection list changes) via the store
    // proxy — the capability the in-place path lacks — so no snapshot/replay rollback is needed;
    // Relay reverts the whole layer atomically.
    const ambientStore = (0, $bqzdu.getAmbientStoreProxy)();
    if (ambientStore && source === 'relay' && params.data) {
        const queryNode = params.query;
        const selections = queryNode?.operation?.selections;
        if (selections) {
            (0, $9xOXQ.writeQueryPayloadToStore)(ambientStore, // Normalization selections are a superset of the reader selections the primitive walks
            // (scalar/linked/inline-fragment/condition); matches the cast in writeQueryInteropRelay.
            selections, params.data, variables);
            return;
        }
    }
    if (source === 'relay') $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables);
    else $f0827a369f0dafa9$var$writeQueryInteropApollo(params);
}
function $f0827a369f0dafa9$var$writeQueryInteropRelay(params, variables) {
    const relayEnv = window.GLOBAL_RELAY_ENV;
    const { query: query, data: data } = params;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for writeQueryInterop; ${params.__callerPackage__}.`);
    if (!data) return false;
    let didWrite = false;
    relayEnv.commitUpdate((storeProxy)=>{
        const root = storeProxy.getRoot();
        if (!root) return;
        const queryNode = query;
        const queryFields = queryNode?.operation?.selections;
        if (queryFields) didWrite = (0, $aSAi6.writeQueryFields)(root, queryFields, data, variables);
    });
    if (!didWrite) {
        // If no existing Relay records were updated, fall back to Relay's normal payload
        // write path. Invalid Relay artifacts should still throw here, preserving the
        // original writeQueryInterop failure behavior.
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(query), variables);
        relayEnv.commitPayload(operation, data);
        didWrite = true;
    }
    return didWrite;
}
function $f0827a369f0dafa9$var$writeQueryInteropApollo(params) {
    window['GLOBAL_APOLLO_CLIENT'].writeQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
    return true;
}
module.exports["writeQueryInterop"] = $f0827a369f0dafa9$export$f97bd2548c77448c;

});

parcelRegister("aSAi6", function(module, exports) {

var $2ItkX = parcelRequire("2ItkX");

function $52093bfafa102098$export$77bf2d076cc42a0e(record, fields, data, variables) {
    if (!record || !$52093bfafa102098$var$isObjectRecord(data)) return false;
    // Relay commitUpdate is not transactional. Preflight the selection tree before
    // writing so list rewrites that require Relay normalization fall through to
    // commitPayload instead of committing partial in-place updates.
    if (!$52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables)) return false;
    return $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables);
}
function $52093bfafa102098$var$canWriteQueryFields(record, fields, data, variables) {
    for (const field of fields){
        if (field.kind === 'Condition') {
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude && !$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'InlineFragment') {
            if (!$52093bfafa102098$var$canWriteQueryFields(record, field.selections, data, variables)) return false;
            continue;
        }
        if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            if (!Object.prototype.hasOwnProperty.call(data, responseKey)) continue;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) return false;
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords || fieldData.length !== existingRecords.length) return false;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    if (item == null) continue;
                    if (!$52093bfafa102098$var$isObjectRecord(item)) return false;
                    const existingRecord = existingRecords[index];
                    if (!existingRecord || $52093bfafa102098$var$hasDifferentRecordId(existingRecord, item)) return false;
                    if (!$52093bfafa102098$var$canWriteQueryFields(existingRecord, linkedField.selections, item, variables)) return false;
                }
                continue;
            }
            if (!$52093bfafa102098$var$isObjectRecord(fieldData)) return false;
            const linkedRecord = record.getLinkedRecord(fieldKey);
            if (!linkedRecord || $52093bfafa102098$var$hasDifferentRecordId(linkedRecord, fieldData)) return false;
            if (!$52093bfafa102098$var$canWriteQueryFields(linkedRecord, linkedField.selections, fieldData, variables)) return false;
            continue;
        }
        if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && !$52093bfafa102098$var$isRelaySetValue(scalarValue)) return false;
            continue;
        }
    }
    return true;
}
function $52093bfafa102098$var$writeQueryFieldsUnsafe(record, fields, data, variables) {
    let didWrite = false;
    for (const field of fields){
        if (field.kind === 'Condition') {
            // Honour @include/@skip so conditional fields (e.g. userPreferences) get written.
            const conditionValue = variables[field.condition];
            const shouldInclude = field.passingValue ? conditionValue : !conditionValue;
            if (shouldInclude) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        } else if (field.kind === 'InlineFragment') didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(record, field.selections, data, variables) || didWrite;
        else if (field.kind === 'LinkedField') {
            const linkedField = field;
            const responseKey = linkedField.alias ?? linkedField.name;
            const fieldData = data[responseKey];
            if (fieldData == null || !linkedField.selections) continue;
            const fieldKey = (0, $2ItkX.getRelayFieldStorageKey)(linkedField, variables);
            if (linkedField.plural) {
                if (!Array.isArray(fieldData)) continue;
                // Read plural fields with getLinkedRecords; the singular getter throws on
                // plural data. Missing/changed list records are handled by the commitPayload
                // fallback so this in-place path only updates known records.
                const existingRecords = record.getLinkedRecords(fieldKey);
                if (!existingRecords) continue;
                for(let index = 0; index < fieldData.length; index++){
                    const item = fieldData[index];
                    const existingRecord = existingRecords[index];
                    if (existingRecord && $52093bfafa102098$var$isObjectRecord(item)) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(existingRecord, linkedField.selections, item, variables) || didWrite;
                }
            } else if ($52093bfafa102098$var$isObjectRecord(fieldData)) {
                const linkedRecord = record.getLinkedRecord(fieldKey);
                if (linkedRecord) didWrite = $52093bfafa102098$var$writeQueryFieldsUnsafe(linkedRecord, linkedField.selections, fieldData, variables) || didWrite;
            }
        } else if (field.kind === 'ScalarField') {
            const scalarField = field;
            const responseKey = scalarField.alias ?? scalarField.name;
            const scalarValue = data[responseKey];
            if (scalarValue !== undefined && $52093bfafa102098$var$isRelaySetValue(scalarValue)) {
                record.setValue(scalarValue, (0, $2ItkX.getRelayFieldStorageKey)(scalarField, variables));
                didWrite = true;
            }
        }
    }
    return didWrite;
}
function $52093bfafa102098$var$getRecordIdFromData(data) {
    const id = data.id;
    return typeof id === 'string' || typeof id === 'number' ? String(id) : null;
}
function $52093bfafa102098$var$hasDifferentRecordId(record, data) {
    const id = $52093bfafa102098$var$getRecordIdFromData(data);
    return Boolean(id && record.getDataID() !== id);
}
function $52093bfafa102098$var$isObjectRecord(value) {
    return Boolean(value && typeof value === 'object' && !Array.isArray(value));
}
function $52093bfafa102098$var$isRelaySetValue(value) {
    if (Array.isArray(value)) // Relay scalar arrays can contain nulls, but undefined elements are not valid setValue payloads.
    return value.every((item)=>item !== undefined && $52093bfafa102098$var$isRelaySetValue(item));
    return value === null || typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
} /* eslint-enable @atlassian/perf-linting/no-quadratic-complexity */ 
module.exports["writeQueryFields"] = $52093bfafa102098$export$77bf2d076cc42a0e;

});

parcelRegister("7Lnfv", function(module, exports) {
const $b5dd42974905c1cd$var$QUERY_NAME_MATCHER = /query\s+(\w+).*?\{/;
const $b5dd42974905c1cd$export$974b1060e58e0a3f = {
    data: null,
    hasErrors: false
};
function $b5dd42974905c1cd$var$isOperationDefinition(definition) {
    return definition.kind === 'OperationDefinition';
}
function $b5dd42974905c1cd$export$41bca9dc6871dd4e(query) {
    if (typeof query === 'string') {
        const match = query.match($b5dd42974905c1cd$var$QUERY_NAME_MATCHER);
        if (match) return match[1];
    } else // GraphQL document AST:
    return (query.definitions || []).filter($b5dd42974905c1cd$var$isOperationDefinition).map((definition)=>definition.name).filter((name)=>name != null)[0]?.value;
    return undefined;
}
module.exports["getOperationName"] = $b5dd42974905c1cd$export$41bca9dc6871dd4e;

});

parcelRegister("2GGOW", function(module, exports) {
const $325950d02840df51$export$55152de1f925fd05 = (error)=>error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
module.exports["isUnauthorizedError"] = $325950d02840df51$export$55152de1f925fd05;

});

parcelRegister("5oHEP", function(module, exports) {
const $e2c1a953aef26c23$export$6ccdb59d3479f4f1 = (error)=>error?.extensions?.statusCode === 404;
module.exports["isNotFoundError"] = $e2c1a953aef26c23$export$6ccdb59d3479f4f1;

});

parcelRegister("iYld5", function(module, exports) {
const $0682584c931be143$export$bb4f02e6ef6f6e17 = (error)=>error?.message?.includes('Cannot find space');
module.exports["isNotFoundSpaceError"] = $0682584c931be143$export$bb4f02e6ef6f6e17;

});

parcelRegister("dGmBZ", function(module, exports) {
/**
 * @generated SignedSource<<44fdf0eb74547d6eb1f9bee5f520d783>>
 * @relayHash cf00f621a086b403c5421169f9d6882a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9daef5b3511dc6423d07aaa0ac2a5682a1753f19645547b82de31b08b5e8fd84
const $819504ce5ddad46c$var$node = function() {
    var v0 = {
        "defaultValue": 40,
        "kind": "LocalArgument",
        "name": "blogFirst"
    }, v1 = {
        "defaultValue": "metadata.createdDate desc",
        "kind": "LocalArgument",
        "name": "blogOrderBy"
    }, v2 = {
        "defaultValue": [
            "current",
            "draft"
        ],
        "kind": "LocalArgument",
        "name": "blogStatuses"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeBlogTree"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCombinedLinks"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeHomepageTreeVariant"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePageTree"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePersistentInviteLicense"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSharedSpaceDetails"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSpaceCreationEligibility"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSpaceCurationCount"
    }, v13 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSpaceViewsPersistence"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v19 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v20 = {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
    }, v21 = [
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v22 = {
        "kind": "ScalarField",
        "name": "id"
    }, v23 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v24 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v25 = [
        v24 /*: any*/ 
    ], v26 = [
        {
            "kind": "Literal",
            "name": "includeHidden",
            "value": true
        }
    ], v27 = {
        "kind": "ScalarField",
        "name": "webItemKey"
    }, v28 = {
        "kind": "ScalarField",
        "name": "webItemCompleteKey"
    }, v29 = {
        "kind": "ScalarField",
        "name": "title"
    }, v30 = {
        "kind": "ScalarField",
        "name": "url"
    }, v31 = {
        "kind": "ScalarField",
        "name": "position"
    }, v32 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v33 = {
        "kind": "ScalarField",
        "name": "path"
    }, v34 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "width"
            },
            {
                "kind": "ScalarField",
                "name": "height"
            },
            {
                "kind": "ScalarField",
                "name": "isDefault"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "iconClass"
    }, v36 = {
        "kind": "ScalarField",
        "name": "hidden"
    }, v37 = {
        "kind": "ScalarField",
        "name": "canHide"
    }, v38 = {
        "kind": "ScalarField",
        "name": "tooltip"
    }, v39 = {
        "kind": "ScalarField",
        "name": "linkIdentifier"
    }, v40 = {
        "kind": "ScalarField",
        "name": "type"
    }, v41 = {
        "args": v26 /*: any*/ ,
        "concreteType": "SpaceSidebarLink",
        "kind": "LinkedField",
        "name": "main",
        "plural": true,
        "selections": [
            v22 /*: any*/ ,
            v27 /*: any*/ ,
            v28 /*: any*/ ,
            v29 /*: any*/ ,
            v30 /*: any*/ ,
            v31 /*: any*/ ,
            v32 /*: any*/ ,
            v34 /*: any*/ ,
            v35 /*: any*/ ,
            v36 /*: any*/ ,
            v37 /*: any*/ ,
            v38 /*: any*/ ,
            v39 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "storageKey": "main(includeHidden:true)"
    }, v42 = {
        "concreteType": "SpaceSidebarLink",
        "kind": "LinkedField",
        "name": "quick",
        "plural": true,
        "selections": [
            v22 /*: any*/ ,
            v30 /*: any*/ ,
            v31 /*: any*/ ,
            v29 /*: any*/ ,
            v32 /*: any*/ 
        ]
    }, v43 = [
        v19 /*: any*/ ,
        v24 /*: any*/ 
    ], v44 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v45 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v46 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v47 = {
        "condition": "includeCombinedLinks",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "combinedSpaceSidebarLinks",
                "args": v43 /*: any*/ ,
                "concreteType": "ConfluenceSpaceNavigationLinks",
                "kind": "LinkedField",
                "name": "confluence_spaceNavigationLinks",
                "plural": false,
                "selections": [
                    v41 /*: any*/ ,
                    v42 /*: any*/ ,
                    {
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "first",
                                "value": 100
                            }
                        ],
                        "concreteType": "ConfluenceShortcutSmartLinkConnection",
                        "kind": "LinkedField",
                        "name": "enrichedQuick",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ConfluenceShortcutSmartLink",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    v22 /*: any*/ ,
                                    v31 /*: any*/ ,
                                    v32 /*: any*/ ,
                                    v30 /*: any*/ ,
                                    v29 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "customTitle"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "emojiTitle"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "canView"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "resolved"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "product"
                                    },
                                    v44 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "resourceType"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "iconUrl"
                                    }
                                ]
                            },
                            {
                                "concreteType": "ConfluencePageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                    v45 /*: any*/ ,
                                    v46 /*: any*/ 
                                ]
                            }
                        ],
                        "storageKey": "enrichedQuick(first:100)"
                    }
                ]
            }
        ]
    }, v48 = [
        v20 /*: any*/ 
    ], v49 = {
        "kind": "ScalarField",
        "name": "key"
    }, v50 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
            v22 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "didContainUserContent"
    }, v53 = {
        "kind": "ScalarField",
        "name": "name"
    }, v54 = {
        "kind": "ScalarField",
        "name": "status"
    }, v55 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            v33 /*: any*/ 
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "homepageId"
    }, v57 = {
        "kind": "ScalarField",
        "name": "isAdmin"
    }, v58 = {
        "kind": "ScalarField",
        "name": "isFavourited"
    }, v59 = {
        "kind": "ScalarField",
        "name": "isWatched"
    }, v60 = {
        "kind": "ScalarField",
        "name": "containsExternalCollaborators"
    }, v61 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v62 = {
        "concreteType": "SpaceHistory",
        "kind": "LinkedField",
        "name": "history",
        "plural": false,
        "selections": [
            v61 /*: any*/ 
        ]
    }, v63 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v64 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v65 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v66 = [
        v63 /*: any*/ ,
        v64 /*: any*/ ,
        v65 /*: any*/ 
    ], v67 = {
        "kind": "FragmentSpread",
        "name": "PageTreeQuery_ptpage"
    }, v68 = [
        v46 /*: any*/ ,
        v45 /*: any*/ 
    ], v69 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": v68 /*: any*/ 
    }, v70 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v46 /*: any*/ 
        ]
    }, v71 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v67 /*: any*/ 
            ]
        },
        v70 /*: any*/ 
    ], v72 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v71 /*: any*/ 
    }, v73 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v71 /*: any*/ 
    }, v74 = [
        v67 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
                v69 /*: any*/ ,
                {
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v67 /*: any*/ ,
                        v72 /*: any*/ ,
                        v73 /*: any*/ 
                    ]
                }
            ]
        },
        v72 /*: any*/ ,
        v73 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "children",
            "plural": false,
            "selections": v71 /*: any*/ 
        }
    ], v75 = [
        v63 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        v64 /*: any*/ ,
        v24 /*: any*/ ,
        v65 /*: any*/ 
    ], v76 = [
        v63 /*: any*/ ,
        v64 /*: any*/ ,
        v24 /*: any*/ ,
        v65 /*: any*/ 
    ], v77 = [
        v67 /*: any*/ ,
        v73 /*: any*/ 
    ], v78 = [
        v24 /*: any*/ ,
        v65 /*: any*/ 
    ], v79 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "blogFirst"
        },
        {
            "kind": "Variable",
            "name": "orderby",
            "variableName": "blogOrderBy"
        },
        v24 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "blogStatuses"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "blogpost"
        }
    ], v80 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": v68 /*: any*/ 
    }, v81 = {
        "kind": "ScalarField",
        "name": "value"
    }, v82 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v81 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v83 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v84 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v85 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v86 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v85 /*: any*/ 
    }, v87 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor",
                    "jira-planner-connection"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v22 /*: any*/ ,
                    v49 /*: any*/ ,
                    v81 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
    }, v88 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v89 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v22 /*: any*/ ,
                v29 /*: any*/ ,
                v54 /*: any*/ ,
                v82 /*: any*/ ,
                v83 /*: any*/ ,
                v84 /*: any*/ ,
                v40 /*: any*/ ,
                v44 /*: any*/ ,
                v86 /*: any*/ ,
                v87 /*: any*/ ,
                v88 /*: any*/ 
            ]
        },
        v70 /*: any*/ 
    ], v90 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v89 /*: any*/ 
    }, v91 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v89 /*: any*/ 
    }, v92 = [
        v22 /*: any*/ ,
        v29 /*: any*/ ,
        v54 /*: any*/ ,
        v82 /*: any*/ ,
        v83 /*: any*/ ,
        v84 /*: any*/ ,
        v40 /*: any*/ ,
        v44 /*: any*/ ,
        v86 /*: any*/ ,
        v87 /*: any*/ ,
        v88 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
                v69 /*: any*/ ,
                {
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v22 /*: any*/ ,
                        v29 /*: any*/ ,
                        v54 /*: any*/ ,
                        v82 /*: any*/ ,
                        v83 /*: any*/ ,
                        v84 /*: any*/ ,
                        v40 /*: any*/ ,
                        v44 /*: any*/ ,
                        v86 /*: any*/ ,
                        v87 /*: any*/ ,
                        v88 /*: any*/ ,
                        v90 /*: any*/ ,
                        v91 /*: any*/ 
                    ]
                }
            ]
        },
        v90 /*: any*/ ,
        v91 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "children",
            "plural": false,
            "selections": v89 /*: any*/ 
        }
    ], v93 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v94 = [
        v22 /*: any*/ ,
        v29 /*: any*/ ,
        v54 /*: any*/ ,
        v82 /*: any*/ ,
        v83 /*: any*/ ,
        v84 /*: any*/ ,
        v40 /*: any*/ ,
        v44 /*: any*/ ,
        v86 /*: any*/ ,
        v87 /*: any*/ ,
        v88 /*: any*/ ,
        v91 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceNavigationQuery",
            "selections": [
                {
                    "condition": "includeSpaceCreationEligibility",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "creationEligibilitySpace",
                            "args": v21 /*: any*/ ,
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SpaceCreationEligibility_space"
                                }
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeHomepageTreeVariant",
                            "variableName": "includeHomepageTreeVariant"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePageTree",
                            "variableName": "includePageTree"
                        },
                        {
                            "kind": "Variable",
                            "name": "isSuperAdmin",
                            "variableName": "isSuperAdmin"
                        },
                        {
                            "kind": "Variable",
                            "name": "paginationLimit",
                            "variableName": "paginationLimit"
                        },
                        {
                            "kind": "Variable",
                            "name": "ptStatuses",
                            "variableName": "ptStatuses"
                        },
                        v24 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "PageTreeInitialData_query"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "blogFirst",
                            "variableName": "blogFirst"
                        },
                        {
                            "kind": "Variable",
                            "name": "blogOrderBy",
                            "variableName": "blogOrderBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "blogStatuses",
                            "variableName": "blogStatuses"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeBlogTree",
                            "variableName": "includeBlogTree"
                        },
                        v24 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "BlogTreeInitialData_query"
                },
                {
                    "condition": "includeSpaceCurationCount",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "useFetchSuggestionCount_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "spaceCurationSuggestionCount"
                        }
                    ]
                },
                {
                    "condition": "includePersistentInviteLicense",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "License",
                            "kind": "LinkedField",
                            "name": "license",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "PersistentInviteEligibleQuery_license"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SpaceMoreActionsMenuSpaceTools_license"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeCombinedLinks",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v25 /*: any*/ ,
                            "concreteType": "SpaceSidebarLinks",
                            "kind": "LinkedField",
                            "name": "spaceSidebarLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SpaceLinks_spaceSidebarLinks"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ShortcutsSection_spaceSidebarLinks"
                                },
                                v41 /*: any*/ ,
                                v42 /*: any*/ 
                            ]
                        }
                    ]
                },
                v47 /*: any*/ ,
                {
                    "args": v48 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeSharedSpaceDetails",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "SpaceDetail_space"
                                            }
                                        ],
                                        "type": "Space"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "sharedSpaceDetail"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "useIsUserViewingSpaceAsAnon_space"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "PersistentInviteEligibleQuery_space"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ExternalCollaboratorsSpaceInformationMessage_space"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "isLicensed",
                                    "variableName": "isLicensed"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "SpaceHeader_space"
                        },
                        v22 /*: any*/ ,
                        v49 /*: any*/ ,
                        v50 /*: any*/ ,
                        v51 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "SpaceOperationsFragment"
                        },
                        v52 /*: any*/ ,
                        {
                            "kind": "FragmentSpread",
                            "name": "useSpaceViewsData_space"
                        },
                        v53 /*: any*/ ,
                        v40 /*: any*/ ,
                        v54 /*: any*/ ,
                        v55 /*: any*/ ,
                        v56 /*: any*/ ,
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        v57 /*: any*/ ,
                                        v58 /*: any*/ ,
                                        v59 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v60 /*: any*/ ,
                        v62 /*: any*/ ,
                        {
                            "condition": "includeHomepageTreeVariant",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v66 /*: any*/ ,
                                    "concreteType": "PTPage",
                                    "kind": "LinkedField",
                                    "name": "pageTree",
                                    "plural": false,
                                    "selections": v74 /*: any*/ 
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includePageTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "currentPage",
                            "args": v75 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v74 /*: any*/ 
                        },
                        {
                            "alias": "rootPageTree",
                            "args": v76 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v77 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeHomepageTreeVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "homepageRootPageTree",
                            "args": v78 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v77 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeBlogTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "blogPosts",
                            "args": v79 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v80 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "BlogTreeRootComponent_content"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceViewsPersistence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "UserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "useSpaceViewsOptionsPersistence_userPreferences"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v18 /*: any*/ ,
                v14 /*: any*/ ,
                v9 /*: any*/ ,
                v12 /*: any*/ ,
                v4 /*: any*/ ,
                v17 /*: any*/ ,
                v16 /*: any*/ ,
                v15 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v5 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v13 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceNavigationQuery",
            "selections": [
                v23 /*: any*/ ,
                {
                    "args": v48 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v22 /*: any*/ ,
                        v50 /*: any*/ ,
                        v51 /*: any*/ ,
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAnonymouslyAuthorized"
                                },
                                v57 /*: any*/ 
                            ]
                        },
                        v53 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "externalCollaboratorCount"
                        },
                        v49 /*: any*/ ,
                        v40 /*: any*/ ,
                        v54 /*: any*/ ,
                        v55 /*: any*/ ,
                        v60 /*: any*/ ,
                        v52 /*: any*/ ,
                        v56 /*: any*/ ,
                        v62 /*: any*/ ,
                        {
                            "condition": "includeHomepageTreeVariant",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v66 /*: any*/ ,
                                    "concreteType": "PTPage",
                                    "kind": "LinkedField",
                                    "name": "pageTree",
                                    "plural": false,
                                    "selections": v92 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "includeSharedSpaceDetails",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v93 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                },
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "homepage",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        v40 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isLicensed",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "SpaceUserMetadata",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        v58 /*: any*/ ,
                                        v59 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceCreationEligibility",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "creationEligibilitySpace",
                            "args": v21 /*: any*/ ,
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v49 /*: any*/ ,
                                v22 /*: any*/ ,
                                v93 /*: any*/ ,
                                {
                                    "concreteType": "SpaceTypeSettings",
                                    "kind": "LinkedField",
                                    "name": "spaceTypeSettings",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "EnabledContentTypes",
                                            "kind": "LinkedField",
                                            "name": "enabledContentTypes",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isLivePagesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isWhiteboardsEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isDatabasesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isBlogsEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEmbedsEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isSlidesEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFoldersEnabled"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v52 /*: any*/ ,
                                v51 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includePageTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "currentPage",
                            "args": v75 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v92 /*: any*/ 
                        },
                        {
                            "alias": "rootPageTree",
                            "args": v76 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v94 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeHomepageTreeVariant",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "homepageRootPageTree",
                            "args": v78 /*: any*/ ,
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "ptpage",
                            "plural": false,
                            "selections": v94 /*: any*/ 
                        }
                    ]
                },
                {
                    "condition": "includeBlogTree",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "alias": "blogPosts",
                            "args": v79 /*: any*/ ,
                            "concreteType": "PaginatedContentListWithChild",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v80 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        v84 /*: any*/ ,
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "emoji-title-published",
                                                        "emoji-title-draft",
                                                        "editor"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v49 /*: any*/ ,
                                                        v81 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                                        },
                                        {
                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": v85 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastModifiedDate"
                                                },
                                                v61 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeSpaceCurationCount",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v43 /*: any*/ ,
                            "kind": "ScalarField",
                            "name": "confluence_remoteObjectSuggestionCount"
                        }
                    ]
                },
                {
                    "condition": "includePersistentInviteLicense",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "License",
                            "kind": "LinkedField",
                            "name": "license",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "licenseConsumingUserCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "trialEndDate"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeCombinedLinks",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": v25 /*: any*/ ,
                            "concreteType": "SpaceSidebarLinks",
                            "kind": "LinkedField",
                            "name": "spaceSidebarLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v26 /*: any*/ ,
                                    "concreteType": "SpaceSidebarLink",
                                    "kind": "LinkedField",
                                    "name": "main",
                                    "plural": true,
                                    "selections": [
                                        v22 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        v36 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v32 /*: any*/ ,
                                        v34 /*: any*/ ,
                                        v35 /*: any*/ ,
                                        v37 /*: any*/ ,
                                        v38 /*: any*/ ,
                                        v39 /*: any*/ ,
                                        v40 /*: any*/ 
                                    ],
                                    "storageKey": "main(includeHidden:true)"
                                },
                                v42 /*: any*/ 
                            ]
                        }
                    ]
                },
                v47 /*: any*/ ,
                {
                    "condition": "includeSpaceViewsPersistence",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "UserPreferences",
                            "kind": "LinkedField",
                            "name": "userPreferences",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v25 /*: any*/ ,
                                    "kind": "ScalarField",
                                    "name": "spaceViewsPersistence"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "cf00f621a086b403c5421169f9d6882a",
            "id": "9daef5b3511dc6423d07aaa0ac2a5682a1753f19645547b82de31b08b5e8fd84",
            "metadata": {},
            "name": "SpaceNavigationQuery",
            "operationKind": "query",
            "text": "query SpaceNavigationQuery($cloudId:ID!,$spaceKey:String!,$isLicensed:Boolean!,$includePersistentInviteLicense:Boolean=false,$includeSpaceCurationCount:Boolean=false,$contentId:ID,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean=false,$includePageTree:Boolean=false,$includeHomepageTreeVariant:Boolean=false,$includeBlogTree:Boolean=false,$blogFirst:Int=40,$blogOrderBy:String=\"metadata.createdDate desc\",$blogStatuses:[String]=[\"current\",\"draft\"],$includeSpaceViewsPersistence:Boolean=false,$includeSharedSpaceDetails:Boolean=false,$includeSpaceCreationEligibility:Boolean=false,$includeCombinedLinks:Boolean=false){creationEligibilitySpace:space(cloudId:$cloudId,key:$spaceKey)@include(if:$includeSpaceCreationEligibility){...SpaceCreationEligibility_space,id},user:confluence_atlassianUser(current:true){id,confluence{permissionType}},...PageTreeInitialData_query_4jV106,...BlogTreeInitialData_query_2C9WBt,...useFetchSuggestionCount_query@include(if:$includeSpaceCurationCount),license@include(if:$includePersistentInviteLicense){...PersistentInviteEligibleQuery_license,...SpaceMoreActionsMenuSpaceTools_license},spaceSidebarLinks(spaceKey:$spaceKey)@skip(if:$includeCombinedLinks){...SpaceLinks_spaceSidebarLinks,...ShortcutsSection_spaceSidebarLinks,main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},combinedSpaceSidebarLinks:confluence_spaceNavigationLinks(cloudId:$cloudId,spaceKey:$spaceKey)@include(if:$includeCombinedLinks){main(includeHidden:true){id,webItemKey,webItemCompleteKey,title,url,position,styleClass,icon{path,width,height,isDefault},iconClass,hidden,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass},enrichedQuick(first:100){nodes{id,position,styleClass,url,title,customTitle,emojiTitle,canView,resolved,product,subType,resourceType,iconUrl},pageInfo{endCursor,hasNextPage}}},space(key:$spaceKey){...SpaceDetail_space@include(if:$includeSharedSpaceDetails),...useIsUserViewingSpaceAsAnon_space,...PersistentInviteEligibleQuery_space,...ExternalCollaboratorsSpaceInformationMessage_space,...SpaceHeader_space_3F1fcg,id,key,homepage{id},operations{operation,targetType},...SpaceOperationsFragment,didContainUserContent,...useSpaceViewsData_space,name,type,status,icon{path},homepageId,currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},containsExternalCollaborators,history{createdDate},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{...BlogTreeRootComponent_content,id}},userPreferences@include(if:$includeSpaceViewsPersistence){...useSpaceViewsOptionsPersistence_userPreferences}}fragment BlogTreeInitialData_query_2C9WBt on Query{blogPosts:content(spaceKey:$spaceKey,type:\"blogpost\",first:$blogFirst,orderby:$blogOrderBy,status:$blogStatuses)@include(if:$includeBlogTree){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}fragment BlogTreeRootComponent_content on Content{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}fragment ContextualCreateContentButton_space on Space{id,operations{operation,targetType}}fragment ExternalCollaboratorsSpaceInformationMessage_space on Space{id,name,externalCollaboratorCount,currentUser{isAdmin}}fragment FooterCreateButtons_space on Space{id,key,alias,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}fragment PageTreeInitialData_query_4jV106 on Query{currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n      hasInheritedRestrictions@include(if:$isSuperAdmin),nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin),previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n              hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n          hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin)},pageInfo{hasNextPage}}}}fragment PageTreeQuery_ptpage on PTPage{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n  hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}}fragment PersistentInviteEligibleQuery_license on License{licenseConsumingUserCount,trialEndDate}fragment PersistentInviteEligibleQuery_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment ShortcutsSection_spaceSidebarLinks on SpaceSidebarLinks{quick{id,url,position,title,styleClass}}fragment SpaceCreationEligibility_space on Space{key,...FooterCreateButtons_space,...useSpaceEnabledContentTypes_space,...ContextualCreateContentButton_space}fragment SpaceDetail_space on Space{id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}fragment SpaceHeader_space_3F1fcg on Space{id,key,name,type,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators}fragment SpaceLinks_spaceSidebarLinks on SpaceSidebarLinks{main(includeHidden:true){id,webItemCompleteKey,position,hidden}}fragment SpaceMoreActionsMenuSpaceTools_license on License{trialEndDate}fragment SpaceOperationsFragment on Space{id,operations{operation,targetType}}fragment useFetchSuggestionCount_query on Query{confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}fragment useIsUserViewingSpaceAsAnon_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment useSpaceEnabledContentTypes_space on Space{id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}fragment useSpaceViewsData_space on Space{id,homepage{id},operations{operation,targetType}}fragment useSpaceViewsOptionsPersistence_userPreferences on UserPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}"
        }
    };
}();
$819504ce5ddad46c$var$node.hash = "315ce42de29430a25fb46473ad283874";
var $819504ce5ddad46c$export$2e2bcd8739ae039 = $819504ce5ddad46c$var$node;
module.exports["default"] = $819504ce5ddad46c$export$2e2bcd8739ae039;

});

parcelRegister("i1Dx5", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $dGmBZ = parcelRequire("dGmBZ");


var $7MZIz = parcelRequire("7MZIz");

class $1ac87ef5bde60ed4$export$681882dbe9ee66f5 {
    beginPreload() {
        this.hydrationCleanup?.();
        this.hydrationCleanup = undefined;
        this.releaseUnclaimed();
        return ++this.generation;
    }
    isCurrentPreload(generation) {
        return this.generation === generation;
    }
    getHydrationVariables() {
        const query = this.pending?.query;
        return query?.settled && !query.error && !query.disposed ? query.variables : undefined;
    }
    setHydrationCleanup(cleanup) {
        this.hydrationCleanup?.();
        this.hydrationCleanup = cleanup;
    }
    get(variables) {
        return this.entries.get((0, $eqEJl.createOperationDescriptor)((0, $dGmBZ.default), variables).request.identifier)?.query;
    }
    preload(variables) {
        const existing = this.get(variables);
        if (existing && !existing.disposed && !existing.error) return existing;
        this.releaseUnclaimed();
        const query = new (0, $7MZIz.SpaceNavigationQueryReference)(this.environment, variables);
        const entry = {
            query: query,
            readers: 0
        };
        this.entries.set(query.identifier, entry);
        this.entriesByReference.set(query, entry);
        this.pending = entry;
        return query;
    }
    retain(query) {
        const entry = this.entriesByReference.get(query);
        if (!entry || query.disposed) // A superseded render may reach its effect after its preload was cancelled.
        // It must not resurrect that execution or invalidate the current owner.
        return ()=>{};
        entry.readers++;
        this.hydrationCleanup?.();
        this.hydrationCleanup = undefined;
        if (this.pending === entry) this.pending = undefined;
        let released = false;
        return ()=>{
            if (released) return;
            released = true;
            entry.readers--;
            // A Strict Mode effect replay can immediately acquire the same reference.
            queueMicrotask(()=>{
                if (entry.readers === 0 && this.pending !== entry) this.remove(entry);
            });
        };
    }
    releaseUnclaimed() {
        if (this.pending && this.pending.readers === 0) this.remove(this.pending);
        this.pending = undefined;
    }
    remove(entry) {
        if (this.entries.get(entry.query.identifier) === entry) this.entries.delete(entry.query.identifier);
        entry.query.dispose();
    }
    constructor(environment){
        this.environment = environment;
        this.entries = new Map();
        this.entriesByReference = new WeakMap();
        this.pending = void 0;
        this.hydrationCleanup = void 0;
        this.generation = 0;
    }
}
const $1ac87ef5bde60ed4$var$owners = new WeakMap();
function $1ac87ef5bde60ed4$export$295dffbcb6e32054(environment) {
    let owner = $1ac87ef5bde60ed4$var$owners.get(environment);
    if (!owner) {
        owner = new $1ac87ef5bde60ed4$export$681882dbe9ee66f5(environment);
        $1ac87ef5bde60ed4$var$owners.set(environment, owner);
    }
    return owner;
}
function $1ac87ef5bde60ed4$export$149c437cba9daf17(environment) {
    return $1ac87ef5bde60ed4$var$owners.get(environment);
}
module.exports["getOrCreateSpaceNavigationQueryOwner"] = $1ac87ef5bde60ed4$export$295dffbcb6e32054;
module.exports["getSpaceNavigationQueryOwner"] = $1ac87ef5bde60ed4$export$149c437cba9daf17;

});

parcelRegister("7MZIz", function(module, exports) {

var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $7m1pr = parcelRequire("7m1pr");


var $dGmBZ = parcelRequire("dGmBZ");

class $613e6bc62e959e15$export$2be457a3941a6c80 {
    dispose() {
        if (this.disposed) return;
        this.disposed = true;
        this.unsubscribe();
        this.reference.dispose();
        // Cancellation must also release a preloader waiting for completion.
        this.finish();
    }
    constructor(environment, variables){
        this.environment = environment;
        this.reference = void 0;
        this.ready = void 0;
        this.identifier = void 0;
        this.variables = void 0;
        this.error = void 0;
        this.settled = false;
        this.failed = false;
        this.disposed = false;
        this.finish = void 0;
        this.unsubscribe = ()=>{};
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $dGmBZ.default), variables);
        this.identifier = operation.request.identifier;
        this.variables = {
            ...variables,
            ...operation.request.variables
        };
        let resolveReady = ()=>{};
        this.ready = new Promise((resolve)=>{
            resolveReady = resolve;
        });
        this.finish = ()=>{
            this.settled = true;
            resolveReady();
        };
        this.reference = (0, $6SsN4.loadQuery)(environment, (0, $dGmBZ.default), this.variables, {
            fetchPolicy: 'store-or-network'
        });
        let graphQLErrors = [];
        const subscription = this.reference.source?.subscribe({
            next: (response)=>{
                graphQLErrors = [
                    ...graphQLErrors,
                    ...(Array.isArray(response) ? response : [
                        response
                    ]).flatMap((payload)=>payload.errors ?? [])
                ];
                if (graphQLErrors.length) this.error = new (0, $7m1pr.RelayError)({
                    graphQLErrors: graphQLErrors
                });
            },
            error: (failure)=>{
                this.failed = true;
                const payloads = Array.isArray(failure) ? failure.filter((0, $7m1pr.isRelayGraphQLError)) : (0, $7m1pr.isRelayGraphQLError)(failure) ? [
                    failure
                ] : failure instanceof Error && 'source' in failure && typeof failure.source === 'object' && failure.source !== null && 'errors' in failure.source && Array.isArray(failure.source.errors) ? failure.source.errors.filter((0, $7m1pr.isRelayGraphQLError)) : [];
                this.error = (0, $7m1pr.isRelayError)(failure) ? failure : new (0, $7m1pr.RelayError)({
                    graphQLErrors: [
                        ...graphQLErrors,
                        ...payloads
                    ],
                    networkError: payloads.length ? undefined : failure instanceof Error ? failure : new Error(String(failure))
                });
                this.finish();
            },
            complete: this.finish
        });
        this.unsubscribe = ()=>subscription?.unsubscribe();
        if (!this.reference.source) this.finish();
    }
}
module.exports["SpaceNavigationQueryReference"] = $613e6bc62e959e15$export$2be457a3941a6c80;

});

parcelRegister("lyWac", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");


var $3mugH = parcelRequire("3mugH");

// Mirrors GraphqlErrorProcessor's mark. Read through the global symbol registry rather than
// importing `isErrorMarkedAsHandled`, because ~20 test files mock
// `@confluence/graphql-error-processor` partially and a new import here would break all of them.
// The registry is the same mechanism GraphqlErrorProcessor relies on to share the mark across the
// preloader and main-app bundles, and `ignores errors already marked as handled` in this module's
// tests exercises the real `markErrorAsHandled`, so the key cannot drift unnoticed.
const $6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL = Symbol.for('error marked as handled');
function $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) {
    return typeof error === 'object' && error !== null && Boolean(error[$6e8f7926b945fe5e$var$HANDLED_ERROR_MARK_SYMBOL]);
}
const $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError = (error)=>error?.extensions?.data?.authorized === false;
/**
 * A page the viewer is not allowed to see is a normal SSR outcome, not a defect — the render falls
 * back to the restricted-content screen. `query()` marks these as handled when a preloader resolves
 * with its query result, but a task that *rejects* with a permission error (or resolves with the
 * error itself) never passes through that path, so the handled mark alone does not keep restricted
 * pages out of the SSR prepare errors.
 *
 * Covers both status codes of the permission contract — 401 (unauthenticated) and 403 (not
 * permitted) — plus the legacy `extensions.data.authorized === false` shape, matching
 * `@confluence/unauthorized-error-boundary`. `isStatusCodeError` walks `graphQLErrors`,
 * `networkError` and `originalError`, so a rejected ApolloError wrapping a 403 is recognised too.
 * `@confluence/error-types` is used rather than the boundary's copy of this predicate to keep React
 * out of the preloader bundle.
 *
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */ function $6e8f7926b945fe5e$var$isPermissionError(error) {
    const candidate = error;
    return (0, $aMcHK.isStatusCodeError)(candidate, '403', $6e8f7926b945fe5e$var$isLegacyUnauthorizedGraphQLError) || (0, $aMcHK.isStatusCodeError)(candidate, '401');
}
/**
 * Errors that are an expected outcome of preloading and must not be reported as SSR prepare errors.
 */ function $6e8f7926b945fe5e$var$isExpectedPreloadError(error) {
    return $6e8f7926b945fe5e$var$isErrorMarkedAsHandled(error) || $6e8f7926b945fe5e$var$isPermissionError(error);
}
function $6e8f7926b945fe5e$var$expandErrorToErrors(error) {
    // Error from createDataFetcherForSuspense might have nested errors
    const errors = [
        error
    ];
    if (Array.isArray(error.otherErrors)) errors.push(...error.otherErrors);
    delete error.otherErrors;
    return errors;
}
/**
 * `query()` and `queryAgg()` resolve to `{ data, errors, hasErrors }` rather than rejecting or
 * resolving to an `Error`, so a preloader that returns its result object straight into the task
 * list would otherwise slip past the `instanceof Error` checks below.
 */ function $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) {
    return typeof value === 'object' && value !== null && value.hasErrors === true && Array.isArray(value.errors);
}
/**
 * Only surfaces errors nobody has claimed. `query()` marks the expected ones (unauthorized,
 * not-found, and other known shapes) as handled before resolving, and those still come back with
 * `hasErrors: true` — reporting them here would turn every restricted or missing page into a bogus
 * SSR prepare error, since preloaders like `preloadPageStatusQuery` return their result object
 * straight into the task list.
 *
 * Filtering happens here, before the conversion below, because `new Error(message)` drops
 * `extensions` — the only place the permission status code lives on a plain GraphQL error object.
 */ function $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(result) {
    const unhandledErrors = [];
    for (const error of result.errors ?? []){
        if ($6e8f7926b945fe5e$var$isExpectedPreloadError(error)) continue;
        unhandledErrors.push(error instanceof Error ? error : new Error(String(error?.message ?? error)));
    }
    return unhandledErrors;
}
function $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(fulfilledValue) {
    if (fulfilledValue instanceof Error) return $6e8f7926b945fe5e$var$expandErrorToErrors(fulfilledValue);
    if (Array.isArray(fulfilledValue)) return fulfilledValue.flatMap((value)=>value instanceof Error || $6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(value) ? $6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(value) : []);
    if ($6e8f7926b945fe5e$var$isPreloaderQueryResultWithErrors(fulfilledValue)) return $6e8f7926b945fe5e$var$collectUnhandledQueryErrors(fulfilledValue);
    return [];
}
async function $6e8f7926b945fe5e$export$ba9c3910d56be969(values) {
    if (!Array.isArray(values)) values = [
        values
    ];
    return Promise.allSettled(values).then((results)=>{
        const errors = [];
        for (const result of results){
            if (result.status === 'rejected') errors.push(...$6e8f7926b945fe5e$var$expandErrorToErrors(result.reason));
            else if (result.status === 'fulfilled') errors.push(...$6e8f7926b945fe5e$var$collectErrorsFromFulfilledValue(result.value));
        }
        // Drop the expected outcomes — already-handled and permission errors — so a restricted page
        // does not report a prepare error. Rejections and error values are filtered here rather than
        // at each collection site so that every path is held to the same rule; query results are
        // filtered earlier, while their `extensions` are still intact.
        const reportableErrors = errors.filter((error)=>!$6e8f7926b945fe5e$var$isExpectedPreloadError(error));
        if (reportableErrors.length > 0) {
            // Errors on preloader functions are not meant to break anything.
            // But we still want to know them...
            for (const error of reportableErrors)(0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Error caught by waitForAllReturnWhenError: ${error.message}`));
            return reportableErrors;
        }
    });
}
module.exports["waitForAllReturnWhenError"] = $6e8f7926b945fe5e$export$ba9c3910d56be969;

});

parcelRegister("3mugH", function(module, exports) {

var $lrjR8 = parcelRequire("lrjR8");

const $d967841d02dde0d1$export$17bc715070d0e7ef = new (0, $lrjR8.SSRPrepareErrorsClient)();
module.exports["ssrPrepareErrorsClient"] = $d967841d02dde0d1$export$17bc715070d0e7ef;

});

parcelRegister("lrjR8", function(module, exports) {
class $7cc20c0ac0ad5b24$export$622a2782a1f9c63 {
    submitError(e, errorData = {}) {
        let additional = {};
        // Not actually importing the error class to avoid circular dependency
        const response = // RateLimitedError or BadStatusError
        e?.response || // Apollo Error
        e?.networkError?.response;
        if (response) additional = {
            response: {
                url: response.url,
                status: response.status,
                statusText: response.statusText
            }
        };
        this.errors.push({
            error: {
                message: e.message,
                stack: e.stack
            },
            meta: errorData,
            ...additional
        });
    }
    getErrors() {
        return this.errors;
    }
    constructor(){
        this.errors = void 0;
        this.errors = [];
    }
}
module.exports["SSRPrepareErrorsClient"] = $7cc20c0ac0ad5b24$export$622a2782a1f9c63;

});

parcelRegister("bPDOf", function(module, exports) {
const $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575 = {
    hasSeenAIFCSpotlight: 'aifc-onboarding:hasSeenAIFCSpotlight',
    isAIFCSpotlightActive: 'aifc-onboarding:isAIFCSpotlightActive',
    hasSeenWhiteboardSmartCreateSpotlight: 'aifc-onboarding:hasSeenWhiteboardSmartCreateSpotlight',
    hasSeenTrackChangesStreamingSpotlight: 'aifc-onboarding:hasSeenTrackChangesStreamingSpotlight',
    isAIFCChatSpotlightActive: 'aifc-onboarding:isAIFCChatSpotlightActive',
    hasSeenAIFCChatSpotlight: 'aifc-onboarding:hasSeenAIFCChatSpotlight',
    hasSeenDeeplinkReturnSpotlight: 'aifc-onboarding:hasSeenDeeplinkReturnSpotlight',
    hasSeenTwcAifcOnboarding: 'aifc-onboarding:hasSeenTwcAifcOnboarding'
};
const $4fc1e4c0ecd68c6d$export$6024bf9594f957fe = Object.values($4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575);
module.exports["AIFC_ONBOARDING_STATE_KEYS"] = $4fc1e4c0ecd68c6d$export$dcf613c5ca1d0575;
module.exports["AIFCOnboardingKeys"] = $4fc1e4c0ecd68c6d$export$6024bf9594f957fe;

});

parcelRegister("3FO8k", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $f57eaca72a825a54$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$f57eaca72a825a54$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $f57eaca72a825a54$export$2e2bcd8739ae039 = $f57eaca72a825a54$var$node;
module.exports["default"] = $f57eaca72a825a54$export$2e2bcd8739ae039;

});

parcelRegister("9fLxI", function(module, exports) {
async function $2552b7855153149c$export$573ee875a39e7e73({ spaceKey: spaceKey } = {
    spaceKey: undefined
}) {
    if (spaceKey) {
        var _window;
        const extensionManifestSpaceaware = (_window = window).__EXTENSION_MANIFEST_SPACEAWARE__ || (_window.__EXTENSION_MANIFEST_SPACEAWARE__ = {});
        if (!extensionManifestSpaceaware[spaceKey]) extensionManifestSpaceaware[spaceKey] = $2552b7855153149c$var$fetchExtensionManifests(spaceKey);
        return extensionManifestSpaceaware[spaceKey];
    }
    if (!window.__EXTENSION_MANIFEST__) window.__EXTENSION_MANIFEST__ = $2552b7855153149c$var$fetchExtensionManifests();
    return window.__EXTENSION_MANIFEST__;
}
function $2552b7855153149c$var$fetchExtensionManifests(spaceKey) {
    /* oxlint-disable-next-line eslint-core/no-restricted-syntax */ // eslint-disable-next-line check-credentials-option/has-credentials-option,no-restricted-syntax
    return fetch(`/wiki/plugins/macrobrowser/browse-macros.action?detailed=true&origin=extension-provider${spaceKey ? `&spaceKey=${spaceKey}` : ''}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json());
}
module.exports["getExtensionManifest"] = $2552b7855153149c$export$573ee875a39e7e73;

});

parcelRegister("l6Xaz", function(module, exports) {
const $372ebd682f0fb003$var$SCRIPT_REGEX = /<script([^>]*)\/*>/gi;
// @ts-expect-error - TS1503 Typescript 5.9.2 upgrade
const $372ebd682f0fb003$var$QUOTES_REGEX = RegExp("^([\"']*)(?<value>.*?)\\1$");
const $372ebd682f0fb003$var$SPACE_REGEX = /\s+/;
function $372ebd682f0fb003$export$79fe7bf3ba344d67(tags, linksMode = false, matcher = $372ebd682f0fb003$var$SCRIPT_REGEX) {
    // Parse <script key="value">/script> into { key: "value" }
    if (linksMode) return Array.isArray(tags) ? tags.map((t)=>({
            src: t
        })) : [];
    if (typeof tags !== 'string') return [];
    const result = [];
    for (const [, attributes] of tags.matchAll(matcher))result.push(Object.fromEntries(attributes.split($372ebd682f0fb003$var$SPACE_REGEX).filter((pair)=>pair).map((pair)=>{
        const pos = pair.indexOf('=');
        if (pos !== -1) {
            const key = pair.substring(0, pos);
            const rawValue = pair.substring(pos + 1);
            const match = rawValue.match($372ebd682f0fb003$var$QUOTES_REGEX);
            const value = match?.groups?.value ?? rawValue;
            return [
                key,
                value
            ];
        } else return [
            pair,
            pair
        ];
    })));
    return result;
}
function $372ebd682f0fb003$export$a0d21c5c067fafcf(attributes) {
    // Convert { key: value } to key="value"
    const result = Object.entries(attributes).map(([key, value])=>value && key !== value ? `${key}="${value}"` : key).join(' ');
    return result ? ` ${result}` : '';
}
function $372ebd682f0fb003$export$eccc4243452442c6(tags) {
    // Jquery is always loaded in packages/confluence-frontend-server/templates/html/dashboard-spa-container.js
    // So we need to remove it from the superbatch tags
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).filter((attrs)=>attrs['data-wrm-key'] !== 'com.atlassian.plugins.jquery:jquery').map((attrs)=>`<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attrs)}></script>`).join('\n');
}
function $372ebd682f0fb003$export$a26b30913d2c455f(tags) {
    return $372ebd682f0fb003$export$79fe7bf3ba344d67(tags).map((attributes)=>{
        attributes['defer'] = 'defer';
        return `<script${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}></script>`;
    }).join('\n');
}
const $372ebd682f0fb003$var$srcExtractor = /src=["'](.*?)["']/gi;
function $372ebd682f0fb003$export$7ffad14b7106f714(jsTags) {
    if (!jsTags) return '';
    return [
        ...jsTags.matchAll($372ebd682f0fb003$var$srcExtractor)
    ].map((match)=>match[1]).filter((src)=>!!src).map((src)=>`<link rel="preload" href="${src}" as="script">`).join('\n');
}
function $372ebd682f0fb003$export$893dc3b18722ac51(resource, asyncScript = false) {
    const nonce = window.__SSR_NONCE_VALUE__;
    const attributes = Array.isArray(resource?.attributes) ? Object.fromEntries(resource.attributes.map((attr)=>[
            attr.key,
            attr.value
        ])) : resource.attributes || {};
    if (resource.type === 'css') return `<link rel="stylesheet" nonce="${nonce}" href="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)} />`;
    else if (resource.type === 'js') return `<script nonce="${nonce}" src="${resource.url}"${$372ebd682f0fb003$export$a0d21c5c067fafcf(attributes)}${asyncScript ? ' async fetchpriority="high"' : ''}></script>`;
    return '';
}
module.exports["parseScriptTags"] = $372ebd682f0fb003$export$79fe7bf3ba344d67;
module.exports["removeJquery"] = $372ebd682f0fb003$export$eccc4243452442c6;
module.exports["deferScript"] = $372ebd682f0fb003$export$a26b30913d2c455f;
module.exports["convertSuperBatchResourceToTags"] = $372ebd682f0fb003$export$893dc3b18722ac51;

});

parcelRegister("d6NtA", function(module, exports) {
var $54fed5011c3efebd$export$c32b36f46293e67b = /*#__PURE__*/ function(MicrosEnvironmentType) {
    MicrosEnvironmentType["local"] = "local";
    MicrosEnvironmentType["dev"] = "dev";
    MicrosEnvironmentType["staging"] = "staging";
    MicrosEnvironmentType["prod"] = "prod";
    return MicrosEnvironmentType;
}({});
const $54fed5011c3efebd$export$6dd1bbd39f571125 = ()=>false;
const $54fed5011c3efebd$export$23da1d24a38b0bde = ()=>globalThis.ssrContext.environmentType === "staging";
const $54fed5011c3efebd$export$64471597a28217e6 = ()=>$54fed5011c3efebd$export$6dd1bbd39f571125() || $54fed5011c3efebd$export$23da1d24a38b0bde() || globalThis.ssrContext.environmentType === "dev";
const $54fed5011c3efebd$export$4bd44a2aa29d3d6e = ()=>globalThis.ssrContext.environment;
const $54fed5011c3efebd$export$1038046b28a1d92e = ()=>globalThis.ssrContext.environmentType;
const $54fed5011c3efebd$export$94e128262c4fa6c3 = ()=>globalThis.ssrContext.entryScriptVersionId;
const $54fed5011c3efebd$export$4caa72c46cbac3be = ()=>globalThis.ssrContext?.runtimeImageVersion ?? 'unknown';
const $54fed5011c3efebd$export$7d4093513f0cae50 = ()=>globalThis.ssrContext?.isInShadow === true;
function $54fed5011c3efebd$export$bcbc3e9e1c9133d4() {
    return globalThis.ssrContext.isInIC === true;
}
function $54fed5011c3efebd$export$4b05536c6e03cc69() {
    return globalThis.ssrContext?.isInFedramp === true;
}
function $54fed5011c3efebd$export$9cbc7f94bfb6210() {
    return globalThis.ssrContext.icName;
}
function $54fed5011c3efebd$export$eb7aff7f8b96b11f() {
    return globalThis.ssrContext.isInGCP === true;
}
function $54fed5011c3efebd$export$f0bc966c9609c798() {
    return globalThis.ssrContext.cellName;
}
module.exports["isLocal"] = $54fed5011c3efebd$export$6dd1bbd39f571125;

});

parcelRegister("8nle6", function(module, exports) {
$parcel$export(module.exports, "preloadSpaceDetail", () => (parcelRequire("5SzHz")).preloadSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetail", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetail);
$parcel$export(module.exports, "preloadPersonalSpaceDetailsQuery", () => (parcelRequire("jLyos")).preloadPersonalSpaceDetailsQuery);
$parcel$export(module.exports, "ConfluenceSpaceType", () => (parcelRequire("cdsKI")).ConfluenceSpaceType);
/* eslint-disable check-multiple-entry-point-exports/check-multiple-entry-point-exports */ 
var $jmjWc = parcelRequire("jmjWc");


var $5SzHz = parcelRequire("5SzHz");


var $jLyos = parcelRequire("jLyos");


var $cdsKI = parcelRequire("cdsKI");


const $b92195a33e0fb686$export$f10aab7c26f92d55 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7NksR",
    name: "SpaceTargetSelect",
    loader: async ()=>(await (parcelRequire("lK4z5"))).SpaceTargetSelect
});
module.exports["SpaceTargetSelect"] = $b92195a33e0fb686$export$f10aab7c26f92d55;

});

parcelRegister("5SzHz", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $dYU3e = parcelRequire("dYU3e");


var $4ZxLt = parcelRequire("4ZxLt");

const $01831239f93415a0$var$getEmptyResult = ()=>Promise.resolve({
        data: null,
        loading: false,
        error: null
    });
const $01831239f93415a0$export$ec3af86ec6a1dfc6 = async (spaceKey = '', { includeSpaceTypeSettings: includeSpaceTypeSettings = false } = {})=>{
    if (spaceKey) return (0, $dYU3e.query)({
        query: (0, $4ZxLt.default),
        variables: {
            spaceKey: spaceKey,
            includeSpaceTypeSettings: includeSpaceTypeSettings
        },
        __callerPackage__: "space-utils"
    });
    return $01831239f93415a0$var$getEmptyResult();
};
const $01831239f93415a0$export$2403e25f29f92c16 = async (spaceKey = '', options)=>{
    return $01831239f93415a0$export$ec3af86ec6a1dfc6(spaceKey, options);
};
module.exports["fetchSpaceDetail"] = $01831239f93415a0$export$ec3af86ec6a1dfc6;
module.exports["preloadSpaceDetail"] = $01831239f93415a0$export$2403e25f29f92c16;

});

parcelRegister("4ZxLt", function(module, exports) {
/**
 * @generated SignedSource<<76836bee9d3181bb32ece1357a68e03f>>
 * @relayHash 8503b5ca122c8b61cd10af1b1c2004c9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b
const $cc63beb8a5381fdf$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSpaceTypeSettings"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "dataClassificationTags"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "condition": "includeSpaceTypeSettings",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SpaceTypeSettings",
                            "kind": "LinkedField",
                            "name": "spaceTypeSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EnabledContentTypes",
                                    "kind": "LinkedField",
                                    "name": "enabledContentTypes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isLivePagesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isWhiteboardsEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDatabasesEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isSlidesEnabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useSpaceDetailQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8503b5ca122c8b61cd10af1b1c2004c9",
            "id": "3c7b8d2b5f3c58e629f5312f857084ff8cca4d4f415ebf6ae267632bf35e1a6b",
            "metadata": {},
            "name": "useSpaceDetailQuery",
            "operationKind": "query",
            "text": "query useSpaceDetailQuery($spaceKey:String,$includeSpaceTypeSettings:Boolean!){space(key:$spaceKey){id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path},spaceTypeSettings@include(if:$includeSpaceTypeSettings){enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled,isSlidesEnabled}}}}"
        }
    };
}();
$cc63beb8a5381fdf$var$node.hash = "591d4790bc30ed0352bb44ad552d45cb";
var $cc63beb8a5381fdf$export$2e2bcd8739ae039 = $cc63beb8a5381fdf$var$node;
module.exports["default"] = $cc63beb8a5381fdf$export$2e2bcd8739ae039;

});

parcelRegister("jLyos", function(module, exports) {

var $a2WOL = parcelRequire("a2WOL");


var $dYU3e = parcelRequire("dYU3e");

const $51133d1487ddd8f7$export$945871a9cdda3d0b = (0, $a2WOL.default);
const $51133d1487ddd8f7$export$88da34a67bdae7e0 = ()=>{
    return (0, $dYU3e.query)({
        query: $51133d1487ddd8f7$export$945871a9cdda3d0b,
        __callerPackage__: "space-utils"
    });
};
module.exports["preloadPersonalSpaceDetailsQuery"] = $51133d1487ddd8f7$export$945871a9cdda3d0b;
module.exports["preloadPersonalSpaceDetail"] = $51133d1487ddd8f7$export$88da34a67bdae7e0;

});

parcelRegister("a2WOL", function(module, exports) {
/**
 * @generated SignedSource<<99c90ef1034a28215bdf926b84b02699>>
 * @relayHash 0616a22c791eb8d27cd97c38dbbaaaed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb
const $fb9284d373020379$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "dataClassificationTags"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadPersonalSpaceDetailsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "0616a22c791eb8d27cd97c38dbbaaaed",
            "id": "fdab4f721e30e106cb6e937af7ef465a8e7ce5047eb501ede326a1f7618e0cbb",
            "metadata": {},
            "name": "preloadPersonalSpaceDetailsQuery",
            "operationKind": "query",
            "text": "query preloadPersonalSpaceDetailsQuery{user:confluence_atlassianUser(current:true){id,confluence{space{id,key,dataClassificationTags}}}}"
        }
    };
}();
$fb9284d373020379$var$node.hash = "a2cf47cae3a68d2f66118a725dfea818";
var $fb9284d373020379$export$2e2bcd8739ae039 = $fb9284d373020379$var$node;
module.exports["default"] = $fb9284d373020379$export$2e2bcd8739ae039;

});

parcelRegister("cdsKI", function(module, exports) {
var $56af74994ed7dcb5$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["ALL"] = "ALL";
    ConfluenceSpaceType["ALL_EXCEPT_PERSONAL"] = "ALL_EXCEPT_PERSONAL";
    ConfluenceSpaceType["ALL_EXCEPT_SPECIFIC"] = "ALL_EXCEPT_SPECIFIC";
    ConfluenceSpaceType["PERSONAL"] = "PERSONAL";
    ConfluenceSpaceType["SPECIFIC"] = "SPECIFIC";
    return ConfluenceSpaceType;
}({});
module.exports["ConfluenceSpaceType"] = $56af74994ed7dcb5$export$2fabe69f8125d5a7;

});

parcelRegister("lK4z5", function(module, exports) {

let $fd416f5749313e31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fd416f5749313e31$var$load("9TOep"),
    $fd416f5749313e31$var$load("bncmK"),
    $fd416f5749313e31$var$load("7EorR"),
    $fd416f5749313e31$var$load("7qpjD")
]).then(()=>parcelRequire('bgmQP'));

});

parcelRegister("kyH1y", function(module, exports) {

var $jevsd = parcelRequire("jevsd");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/workspace/manifest.ts
var $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jevsd.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $jevsd.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $ef785b50c9b3efca$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $ef785b50c9b3efca$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};
module.exports["ConfluenceWorkspaceAri"] = $ef785b50c9b3efca$export$d47d8a7e69df1865;

});

parcelRegister("jevsd", function(module, exports) {
// src/confluence/workspace/types.ts
var $e007b94796479ac0$export$19f1a63686ec0369 = "confluence", $e007b94796479ac0$export$f1c423a93fbc71 = "workspace";
module.exports["ConfluenceWorkspaceAriResourceOwner"] = $e007b94796479ac0$export$19f1a63686ec0369;
module.exports["ConfluenceWorkspaceAriResourceType"] = $e007b94796479ac0$export$f1c423a93fbc71;

});

parcelRegister("2khPJ", function(module, exports) {

var $aQ0yV = parcelRequire("aQ0yV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/user/manifest.ts
var $1b1b4861ffbabf45$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $aQ0yV.IdentityUserAriResourceOwner),
    resourceType: (0, $aQ0yV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $1b1b4861ffbabf45$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $9j37t.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $1b1b4861ffbabf45$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $1b1b4861ffbabf45$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts), this._userId = opts.resourceIdSegmentValues.userId;
    }
};
module.exports["IdentityUserAri"] = $1b1b4861ffbabf45$export$1e9d09c2be53e55e;

});

parcelRegister("aQ0yV", function(module, exports) {
// src/identity/user/types.ts
var $7e3f325f95b56bab$export$b4c14c54282a779d = "identity", $7e3f325f95b56bab$export$e9b50e20f4fbfb71 = "user";
module.exports["IdentityUserAriResourceOwner"] = $7e3f325f95b56bab$export$b4c14c54282a779d;
module.exports["IdentityUserAriResourceType"] = $7e3f325f95b56bab$export$e9b50e20f4fbfb71;

});

parcelRegister("iQzVo", function(module, exports) {
const $ac3059bce5b9a0ea$export$7bed14e1f2921c0a = {
    ENROLMENT_DATE: 'twcg-1489:enrolmentDate',
    SPOTLIGHT_SHOWN: 'twcg-1489:spotlightShown',
    PROMO_DISMISSED: 'twcg-1489:promoDismissed'
};
const $ac3059bce5b9a0ea$export$461c2b41206d7875 = Object.values($ac3059bce5b9a0ea$export$7bed14e1f2921c0a);
module.exports["TWCG_1489_CONNECTOR_ONBOARDING"] = $ac3059bce5b9a0ea$export$7bed14e1f2921c0a;
module.exports["Twcg1489ConnectorOnboardingKeys"] = $ac3059bce5b9a0ea$export$461c2b41206d7875;

});

parcelRegister("ljH80", function(module, exports) {
/**
 * @generated SignedSource<<def63672abb49c009b08c3310289a240>>
 * @relayHash 3645f14258aaf6df779f3874a7b10083
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 794380e9c61483adc5407aecc7ee4f9434dbddfd1b24827095cb41bca86c6bd6
const $761d928d522d0b4f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "teamType"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConnectorOnboardingTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConnectorOnboardingTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3645f14258aaf6df779f3874a7b10083",
            "id": "794380e9c61483adc5407aecc7ee4f9434dbddfd1b24827095cb41bca86c6bd6",
            "metadata": {},
            "name": "useConnectorOnboardingTeamTypeQuery",
            "operationKind": "query",
            "text": "query useConnectorOnboardingTeamTypeQuery($userId:ID!){user(accountId:$userId){__typename,...on AtlassianAccountUser{extendedProfile{teamType}},id}}"
        }
    };
}();
$761d928d522d0b4f$var$node.hash = "a2ab021a37664174ea5177e550544833";
var $761d928d522d0b4f$export$2e2bcd8739ae039 = $761d928d522d0b4f$var$node;
module.exports["default"] = $761d928d522d0b4f$export$2e2bcd8739ae039;

});

parcelRegister("iGpO4", function(module, exports) {
/**
 * @generated SignedSource<<583af0bf5d1397e9bb81877c0829a09c>>
 * @relayHash ed1c7ead1865251e45173593feb0b728
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1
const $dba60705293b2bec$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "resourceId"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orgId",
                    "variableName": "orgId"
                },
                {
                    "kind": "Variable",
                    "name": "resourceId",
                    "variableName": "resourceId"
                }
            ],
            "concreteType": "AdminConnectorConnection",
            "kind": "LinkedField",
            "name": "admin_getAllDataSources",
            "plural": false,
            "selections": [
                {
                    "concreteType": "AdminConnectorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "AdminConnector",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "concreteType": "AdminDataSource",
                                    "kind": "LinkedField",
                                    "name": "datasources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "enabled"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useConnectorStatesQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useConnectorStatesQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "ed1c7ead1865251e45173593feb0b728",
            "id": "b96b68ccc999039ea351e31941246e5bb0c0400a30e73f61b5c8a6ce57245ae1",
            "metadata": {},
            "name": "useConnectorStatesQuery",
            "operationKind": "query",
            "text": "query useConnectorStatesQuery($orgId:ID!,$resourceId:ID!,$first:Int){admin_getAllDataSources(orgId:$orgId,resourceId:$resourceId,first:$first){edges{node{type,datasources{enabled}}}}}"
        }
    };
}();
$dba60705293b2bec$var$node.hash = "c1e906a9d592c8090d7d5864937f0dbe";
var $dba60705293b2bec$export$2e2bcd8739ae039 = $dba60705293b2bec$var$node;
module.exports["default"] = $dba60705293b2bec$export$2e2bcd8739ae039;

});

parcelRegister("dBcar", function(module, exports) {

var $5AFnD = parcelRequire("5AFnD");

const $3c94963df51c0e13$export$d181855fa20a3bb3 = 'smart-folder-consumer:hasDismissedIntroduction';
const $3c94963df51c0e13$export$e027a04475c3a4f2 = 'smart-folder-consumer:hasCreatedSmartFolder';
const $3c94963df51c0e13$export$4ddca8f5712d2331 = 'onboarding-state:';
const $3c94963df51c0e13$export$f35f2899eb1390e3 = 'peopleNudge';
const $3c94963df51c0e13$export$532485ca1547f1aa = 'legacy';
const $3c94963df51c0e13$export$31c8494ea74d2536 = 'introWorkflow';
const $3c94963df51c0e13$export$1f72e9a162b3795b = 'firstSpaceSelected';
const $3c94963df51c0e13$export$6315bee451a9fcc6 = 'teamSpaceCreated';
const $3c94963df51c0e13$export$c4e14780cf349e73 = 'xflowSpaceCreated';
const $3c94963df51c0e13$export$275d3dda87d2fa7a = 'nthUserOnboardingCompletedTimestamp';
const $3c94963df51c0e13$export$da223e550b96c9d6 = 'help';
const $3c94963df51c0e13$export$ffb6b379ff35f9e = 'onboardingIntents';
const $3c94963df51c0e13$export$d3276a0d758ffd2b = 'isFoundingAdmin';
const $3c94963df51c0e13$export$756b1a5a6b2488c3 = 'isSampleContentV2SpotlightVisible';
const $3c94963df51c0e13$export$8e5a8e09b19b20a8 = 'isMoreActionsTourVisible';
const $3c94963df51c0e13$export$2e10b71f921ae144 = 'isMoreActionsHintVisible';
const $3c94963df51c0e13$export$82fe49566957c443 = 'landOnPath';
const $3c94963df51c0e13$export$f6c79e39ab4496db = 'templateOnboardingViewedTime';
const $3c94963df51c0e13$export$49ac0bbeb4be0a06 = {
    ONBOARDING_INTENT_EXPERIENCES_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    ONBOARDING_EXPERIENCE_ELIGIBLE: 'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_VIEWED_AT: 'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    ONBOARDING_INTENT_EXPERIENCES_LAND_NEW_HOME_CLOSED: 'onboarding-intent-experiences:onboardingIntentExperienceLandClosed'
};
const $3c94963df51c0e13$export$6167e5b70dfd11d9 = {
    MODAL_SEEN: 'onboarding-reverse-trial:isModalSeen'
};
const $3c94963df51c0e13$export$49c044e5e3ccc2af = {
    EXPERIMENT_ELIGIBLE: 'templates-collection:isTaggedForTemplatesCollectionExperiment',
    EXPERIMENT_DISMISSED: 'templates-collection:isTemplatesSectionDismissed'
};
const $3c94963df51c0e13$export$dcbccfe8799c3c7b = {
    IS_DISMISSED: 'space-getting-started-tour:tourIsDismissed'
};
const $3c94963df51c0e13$export$305c55ea55928edf = {
    HAS_INVITE_CAPABILITIES: 'persistent-invite:hasInviteCapabilities'
};
const $3c94963df51c0e13$export$8b7e53c326da02ac = 'improvedGetStartedPath';
const $3c94963df51c0e13$export$cfc1794f56ac0d83 = 'improvedGetStartedWhiteboardPath';
const $3c94963df51c0e13$export$39a89660e80fa1a = 'isRedactionsTourVisible';
const $3c94963df51c0e13$export$b99b309b286adebc = 'nav4:isNav4GlobalSpotlightDismissed';
const $3c94963df51c0e13$export$20b0548cf5859d6 = 'nav4:isNav4SpaceTourDismissed';
const $3c94963df51c0e13$export$4d93dfc1d8538d55 = 'nav4:isNav4CollapseReminderSpotlightDismissed';
const $3c94963df51c0e13$export$94a4264abda026cc = 'creation-focused-nav:shouldShowSpotlight';
const $3c94963df51c0e13$export$f0597adb063e4c38 = 'creation-focused-nav:startTime';
const $3c94963df51c0e13$export$7ed75560092630f6 = {
    IS_SPOTLIGHT_DISMISS: 'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    PULSE_SEEN_AT: 'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt'
};
const $3c94963df51c0e13$export$6c014427ebb0cbae = {
    HAS_SEEN_SPLASH_MODAL: 'create-with-rovo-announcement-splash:hasSeenSplashModal'
};
const $3c94963df51c0e13$export$ebacd4ef7f5400e2 = {
    CHAT_AUTO_OPENED: 'welcome-from-rovo:chatAutoOpened'
};
const $3c94963df51c0e13$export$d1ec748fb682ca97 = {
    NTH_USER_SELECTED_CONTENT_TYPE: 'nth-user-setup:nthUserSelectedContentType',
    NTH_USER_CONTENT_TYPE_SPOTLIGHT_SEEN: 'nth-user-setup:nthUserContentTypeSpotlightSeen',
    NTH_USER_CONTENT_TYPE_POPULAR_CONTENT_FOUND: 'nth-user-setup:nthUserContentTypePopularContentFound',
    NTH_USER_CONTENT_TYPE_LANDING_CONTENT_ID: 'nth-user-setup:nthUserContentTypeLandingContentId'
};
const $3c94963df51c0e13$export$1a3a43cef0acd011 = {
    PROMPT_DISMISSED: 'prompt-whiteboard-competitor-link:isPromptDismissed'
};
const $3c94963df51c0e13$export$5b471e2344a37be7 = {
    DISMISSED: 'prompt-database-competitor-link:isPromptDatabaseDismissed'
};
const $3c94963df51c0e13$export$c81223a0ce3b63df = {
    HAS_AUTO_FOLLOWED_SPACES: 'nth-user-auto-follow-spaces:hasAutoFollowedSpaces'
};
const $3c94963df51c0e13$export$f1328b04dc902e1f = {
    REVAMPED_BPQA_SHOWN_AT: 'land-users-in-editor-with-revamped-bpqa:revampedBpqaShownAt'
};
const $3c94963df51c0e13$export$e986b94fd54d134 = {
    SELECTED_TEMPLATES: 'use-cases-nth-user-onboarding:selectedTemplates',
    VIEWED_AT: 'use-cases-nth-user-onboarding:viewedAt',
    DISMISSED_HEADER: 'use-cases-nth-user-onboarding:headerDismissed',
    VIEWED_HEADER: 'use-cases-nth-user-onboarding:headerViewedAt'
};
const $3c94963df51c0e13$export$bbdc3607431bd9d3 = {
    EMOJI_TITLE_DISCOVERED: 'auto-page-emoji:emojiTitleDiscovered'
};
const $3c94963df51c0e13$export$94df39cf9e5d9804 = {
    TRENDING_PAGES: 'cross-join-nth-user-onboarding:trendingPages',
    DISMISSED: 'cross-join-nth-user-onboarding:dismissed'
};
const $3c94963df51c0e13$export$bfeb2da96277b623 = {
    INTRO_WORKFLOW: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$31c8494ea74d2536}`,
    LEGACY_ONBOARDING_STATE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$532485ca1547f1aa}`,
    IS_FOUNDING_ADMIN: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$d3276a0d758ffd2b}`,
    IS_SAMPLE_CONTENT_V2_SPOTLIGHT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$756b1a5a6b2488c3}`,
    LAND_ON_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$82fe49566957c443}`,
    TEAM_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$6315bee451a9fcc6}`,
    IS_MORE_ACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8e5a8e09b19b20a8}`,
    IS_MORE_ACTIONS_HINT_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$2e10b71f921ae144}`,
    IMPROVED_GET_STARTED_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$8b7e53c326da02ac}`,
    IMPROVED_GET_STARTED_WHITEBOARD_PATH: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$cfc1794f56ac0d83}`,
    IS_REDACTIONS_TOUR_VISIBLE: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$39a89660e80fa1a}`,
    XFLOW_SPACE_CREATED: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$c4e14780cf349e73}`,
    TEMPLATE_ONBOARDING_VIEWED_TIME: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$f6c79e39ab4496db}`,
    NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP: `${$3c94963df51c0e13$export$4ddca8f5712d2331}${$3c94963df51c0e13$export$275d3dda87d2fa7a}`
};
const $3c94963df51c0e13$export$1660a2d7c2fff354 = '__complete__';
const $3c94963df51c0e13$export$66aa87593037fd4a = $3c94963df51c0e13$export$bfeb2da96277b623.LEGACY_ONBOARDING_STATE;
const $3c94963df51c0e13$export$d4f5dd2b883b8982 = [
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38
];
const $3c94963df51c0e13$export$7a13c575f2c75084 = [
    $3c94963df51c0e13$export$d181855fa20a3bb3,
    $3c94963df51c0e13$export$e027a04475c3a4f2,
    ...Object.values($3c94963df51c0e13$export$49ac0bbeb4be0a06),
    ...Object.values($3c94963df51c0e13$export$6167e5b70dfd11d9),
    ...Object.values($3c94963df51c0e13$export$49c044e5e3ccc2af),
    ...Object.values($3c94963df51c0e13$export$dcbccfe8799c3c7b),
    ...Object.values($3c94963df51c0e13$export$305c55ea55928edf),
    $3c94963df51c0e13$export$b99b309b286adebc,
    $3c94963df51c0e13$export$20b0548cf5859d6,
    $3c94963df51c0e13$export$4d93dfc1d8538d55,
    $3c94963df51c0e13$export$94a4264abda026cc,
    $3c94963df51c0e13$export$f0597adb063e4c38,
    ...Object.values($3c94963df51c0e13$export$7ed75560092630f6),
    ...Object.values($3c94963df51c0e13$export$6c014427ebb0cbae),
    ...Object.values($3c94963df51c0e13$export$ebacd4ef7f5400e2),
    ...Object.values($3c94963df51c0e13$export$d1ec748fb682ca97),
    ...Object.values($3c94963df51c0e13$export$1a3a43cef0acd011),
    ...Object.values($3c94963df51c0e13$export$5b471e2344a37be7),
    ...Object.values($3c94963df51c0e13$export$bfeb2da96277b623),
    ...Object.values($3c94963df51c0e13$export$c81223a0ce3b63df),
    ...Object.values($3c94963df51c0e13$export$f1328b04dc902e1f),
    ...Object.values($3c94963df51c0e13$export$e986b94fd54d134),
    ...Object.values($3c94963df51c0e13$export$bbdc3607431bd9d3),
    ...Object.values($3c94963df51c0e13$export$94df39cf9e5d9804),
    (0, $5AFnD.LOOM_NUDGE_REMIND_ME),
    (0, $5AFnD.LOOM_NUDGE_LAST_SHOWN_AT)
];
module.exports["SMART_FOLDER_CONSUMER_ONBOARDING_DISMISSED"] = $3c94963df51c0e13$export$d181855fa20a3bb3;
module.exports["SMART_FOLDER_CONSUMER_ONBOARDING_HAS_CREATED"] = $3c94963df51c0e13$export$e027a04475c3a4f2;
module.exports["ONBOARDING_INTENT_EXPERIENCES"] = $3c94963df51c0e13$export$49ac0bbeb4be0a06;
module.exports["TEMPLATES_COLLECTION"] = $3c94963df51c0e13$export$49c044e5e3ccc2af;
module.exports["PERSISTENT_INVITE"] = $3c94963df51c0e13$export$305c55ea55928edf;
module.exports["IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED"] = $3c94963df51c0e13$export$4d93dfc1d8538d55;
module.exports["CREATION_FOCUSED_NAV_SHOULD_SHOW_SPOTLIGHT"] = $3c94963df51c0e13$export$94a4264abda026cc;
module.exports["CREATION_FOCUSED_NAV_START_TIME"] = $3c94963df51c0e13$export$f0597adb063e4c38;
module.exports["CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH"] = $3c94963df51c0e13$export$6c014427ebb0cbae;
module.exports["WELCOME_FROM_ROVO_CHAT"] = $3c94963df51c0e13$export$ebacd4ef7f5400e2;
module.exports["NTH_USER_SETUP_CONTENT_TYPE"] = $3c94963df51c0e13$export$d1ec748fb682ca97;
module.exports["PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED"] = $3c94963df51c0e13$export$1a3a43cef0acd011;
module.exports["NTH_USER_AUTO_FOLLOW_SPACES"] = $3c94963df51c0e13$export$c81223a0ce3b63df;
module.exports["LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA"] = $3c94963df51c0e13$export$f1328b04dc902e1f;
module.exports["USE_CASES_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$e986b94fd54d134;
module.exports["NTH_USER_EMOJI_TITLE_DISCOVERED"] = $3c94963df51c0e13$export$bbdc3607431bd9d3;
module.exports["CROSS_JOIN_NTH_USER_ONBOARDING"] = $3c94963df51c0e13$export$94df39cf9e5d9804;
module.exports["ONBOARDING_EXPERIENCES"] = $3c94963df51c0e13$export$bfeb2da96277b623;
module.exports["COMPLETE"] = $3c94963df51c0e13$export$1660a2d7c2fff354;
module.exports["NAV_EXPERIMENT_ONBOARDING_KEYS"] = $3c94963df51c0e13$export$d4f5dd2b883b8982;
module.exports["OnboardingKeys"] = $3c94963df51c0e13$export$7a13c575f2c75084;

});

parcelRegister("5AFnD", function(module, exports) {
const $00e2d16f0c5935d6$export$477408ab8b02b670 = 'twcg-2202-loom-nudge:remindMe';
const $00e2d16f0c5935d6$export$c98b33a7293cedf4 = 'twcg-2202-loom-nudge:lastShownAt';
module.exports["LOOM_NUDGE_REMIND_ME"] = $00e2d16f0c5935d6$export$477408ab8b02b670;
module.exports["LOOM_NUDGE_LAST_SHOWN_AT"] = $00e2d16f0c5935d6$export$c98b33a7293cedf4;

});

parcelRegister("d9tcB", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $adbc8f20ade62008$export$9d38595f26d62a61 = /*#__PURE__*/ function(AccessStatus) {
    AccessStatus["ANONYMOUS_ACCESS"] = "ANONYMOUS_ACCESS";
    AccessStatus["EXTERNAL_COLLABORATOR_ACCESS"] = "EXTERNAL_COLLABORATOR_ACCESS";
    AccessStatus["EXTERNAL_SHARE_ACCESS"] = "EXTERNAL_SHARE_ACCESS";
    AccessStatus["LICENSED_ADMIN_ACCESS"] = "LICENSED_ADMIN_ACCESS";
    AccessStatus["LICENSED_USE_ACCESS"] = "LICENSED_USE_ACCESS";
    AccessStatus["NOT_PERMITTED"] = "NOT_PERMITTED";
    AccessStatus["UNLICENSED_AUTHENTICATED_ACCESS"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return AccessStatus;
}({});
var $adbc8f20ade62008$export$68577d543b14ae02 = /*#__PURE__*/ function(ConfluenceEdition) {
    ConfluenceEdition["FREE"] = "FREE";
    ConfluenceEdition["PREMIUM"] = "PREMIUM";
    ConfluenceEdition["STANDARD"] = "STANDARD";
    return ConfluenceEdition;
}({});
var $adbc8f20ade62008$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["DEVELOPMENT"] = "DEVELOPMENT";
    Environment["PRODUCTION"] = "PRODUCTION";
    Environment["STAGING"] = "STAGING";
    return Environment;
}({});
module.exports["AccessStatus"] = $adbc8f20ade62008$export$9d38595f26d62a61;
module.exports["ConfluenceEdition"] = $adbc8f20ade62008$export$68577d543b14ae02;

});

parcelRegister("cwUrm", function(module, exports) {
const $47cf4dda49ee363d$export$ed52cc3670515af7 = (cloudId)=>({
        tenantId: cloudId,
        product: 'confluence'
    });
module.exports["buildInvitedAppShortcutsRecommendationsVariables"] = $47cf4dda49ee363d$export$ed52cc3670515af7;

});

parcelRegister("4YUBg", function(module, exports) {
/**
 * @generated SignedSource<<c911df138434165e1df56a149c5ed87d>>
 * @relayHash 3c5abea4712e217d7b3561b0c6d826bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 15d301edc65d7aefa1614dec08095e50e15a8fc962561db8174cca939aad4ec8
const $a43ff53f7d2c5ff0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "product"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v2 = [
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "product",
                    "variableName": "product"
                },
                {
                    "kind": "Variable",
                    "name": "tenantId",
                    "variableName": "tenantId"
                },
                {
                    "kind": "Literal",
                    "name": "useCase",
                    "value": "invitedAppShortcuts"
                }
            ],
            "kind": "ObjectValue",
            "name": "context"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "entityId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "reasons"
    }, v6 = {
        "kind": "ScalarField",
        "name": "score"
    }, v7 = {
        "concreteType": "GrowthRecContextResult",
        "kind": "LinkedField",
        "name": "context",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "tenantId"
            },
            {
                "kind": "ScalarField",
                "name": "product"
            },
            {
                "kind": "ScalarField",
                "name": "useCase"
            },
            {
                "kind": "ScalarField",
                "name": "sessionId"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "identifier"
    }, v9 = {
        "kind": "ScalarField",
        "name": "message"
    }, v10 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v11 = {
        "kind": "ScalarField",
        "name": "errorType"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "selections": [
                {
                    "concreteType": "GrowthRecQuery",
                    "kind": "LinkedField",
                    "name": "growthRecommendations",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "recommendations",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "data",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ 
                                    ],
                                    "type": "GrowthRecRecommendations"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "QueryError"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3c5abea4712e217d7b3561b0c6d826bb",
            "id": "15d301edc65d7aefa1614dec08095e50e15a8fc962561db8174cca939aad4ec8",
            "metadata": {},
            "name": "InvitedAppShortcutsRecommendationsQuery",
            "operationKind": "query",
            "text": "query InvitedAppShortcutsRecommendationsQuery($tenantId:ID,$product:String!){growthRecommendations{recommendations(context:{tenantId:$tenantId,product:$product,useCase:\"invitedAppShortcuts\"}){__typename,...on GrowthRecRecommendations{data{__typename,entityId,reasons,score},context{tenantId,product,useCase,sessionId}},...on QueryError{identifier,message,extensions{__typename,statusCode,errorType}}}}}"
        }
    };
}();
$a43ff53f7d2c5ff0$var$node.hash = "186413c3c978a3bb94c6bc4b5f252e32";
var $a43ff53f7d2c5ff0$export$2e2bcd8739ae039 = $a43ff53f7d2c5ff0$var$node;
module.exports["default"] = $a43ff53f7d2c5ff0$export$2e2bcd8739ae039;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $iEfsZ = parcelRequire("iEfsZ");


var $eSLr0 = parcelRequire("eSLr0");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
const $2272f3d6a41ef128$var$isSystemBatchLocation = (location)=>location.length === 2 && location.includes((0, $eSLr0.SYSTEM_HEADER_LEFT)) && location.includes((0, $eSLr0.SYSTEM_USER));
const $2272f3d6a41ef128$var$filterSectionsByLocations = (webItemSections, locations)=>webItemSections.filter((section)=>locations.some((location)=>section?.id?.startsWith(`${location}/`)));
const $2272f3d6a41ef128$var$writeWebItemLocationCache = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $iEfsZ.default),
        variables: {
            location: null,
            locations: locations,
            contentId: contentId,
            spaceKey: spaceKey,
            version: version
        },
        data: {
            webItemSections: webItemSections
        },
        __callerPackage__: "web-item-location"
    });
};
const $2272f3d6a41ef128$var$writeWebItemLocationEntries = ({ locations: locations, contentId: contentId, spaceKey: spaceKey, version: version, webItemSections: webItemSections })=>{
    locations.forEach((location)=>{
        (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: location,
                locations: [],
                contentId: contentId,
                spaceKey: spaceKey,
                version: version
            },
            data: {
                webItemSections: $2272f3d6a41ef128$var$filterSectionsByLocations(webItemSections, [
                    location
                ])
            },
            __callerPackage__: "web-item-location"
        });
    });
};
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null, context: context } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        },
        context: context,
        __callerPackage__: "web-item-location"
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            },
            __callerPackage__: "web-item-location"
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    const result = (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables,
        context: context,
        __callerPackage__: "web-item-location"
    });
    if (Array.isArray(location)) {
        const shouldWriteSystemBatchEntries = (0, $6mKj3.expValEquals)('web_item_query_batch_system_call', 'isEnabled', true) && $2272f3d6a41ef128$var$isSystemBatchLocation(location);
        if (shouldWriteSystemBatchEntries) result.then(({ data: data })=>{
            if (!data?.webItemSections) return;
            $2272f3d6a41ef128$var$writeWebItemLocationCache({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
            $2272f3d6a41ef128$var$writeWebItemLocationEntries({
                locations: location,
                contentId: contentId,
                spaceKey: spaceKey,
                version: version,
                webItemSections: data.webItemSections
            });
        });
    }
    return result;
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<723e491a15ec21972dd962ca0e8f8ba8>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("iEfsZ", function(module, exports) {
/**
 * @generated SignedSource<<50efd21e0db5811e6867b792d80a2f0a>>
 * @relayHash 0006505c7639efb87b37fdf9e06ba577
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173
const $7f80a392f18860bd$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "label"
    }, v7 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v8 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "version"
                }
            ],
            "concreteType": "WebSection",
            "kind": "LinkedField",
            "name": "webItemSections",
            "plural": true,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "cacheKey"
                },
                v7 /*: any*/ ,
                {
                    "concreteType": "WebItem",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "completeKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasCondition"
                        },
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "height"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "width"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        {
                            "concreteType": "MapOfStringToString",
                            "kind": "LinkedField",
                            "name": "params",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "moduleKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "section"
                        },
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "tooltip"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "url"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "urlWithoutContextPath"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "weight"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebItemLocationQuery",
            "selections": v8 /*: any*/ 
        },
        "params": {
            "cacheID": "0006505c7639efb87b37fdf9e06ba577",
            "id": "80be86e03026fa8a830d5e044cf1c52c928ef2f41b95e7043d2c72827ef95173",
            "metadata": {},
            "name": "WebItemLocationQuery",
            "operationKind": "query",
            "text": "query WebItemLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String,$version:Int){webItemSections(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}"
        }
    };
}();
$7f80a392f18860bd$var$node.hash = "8e88912bf23040d88bbeb5c8cadae7c2";
var $7f80a392f18860bd$export$2e2bcd8739ae039 = $7f80a392f18860bd$var$node;
module.exports["default"] = $7f80a392f18860bd$export$2e2bcd8739ae039;

});

parcelRegister("eSLr0", function(module, exports) {
// web items
const $0673dc41d4591954$export$b1fc939aa7feb92f = 'system.content.action';
const $0673dc41d4591954$export$cc265e0ec08cd67d = 'system.content.button';
const $0673dc41d4591954$export$d2beebd05fcd6f70 = 'system.dashboard';
const $0673dc41d4591954$export$9aacf4bfaa57e6fc = 'system.content.byline';
const $0673dc41d4591954$export$1b2697f8e6fa897f = 'system.content.metadata';
const $0673dc41d4591954$export$53635c098825d80c = 'system.attachment';
const $0673dc41d4591954$export$b55f44bb0675280a = 'system.attachment.metadata';
const $0673dc41d4591954$export$932fbff4e94f11bd = 'system.attachment.history';
const $0673dc41d4591954$export$76fccc09e967256f = 'page.metadata.banner';
const $0673dc41d4591954$export$630f26f93c0b82dc = 'system.header/left';
const $0673dc41d4591954$export$67f0ff836865be9e = 'system.header/left.button.group';
const $0673dc41d4591954$export$ac6c373b69972f05 = 'system.help/pages';
const $0673dc41d4591954$export$1835f2a2eaa3b55b = 'system.user';
const $0673dc41d4591954$export$8fc5196f34e2202a = 'system.admin';
const $0673dc41d4591954$export$e83e042e2b565918 = 'system.editor.precursor.buttons';
const $0673dc41d4591954$export$2a98a7a0b026585a = 'system.create.dialog/content';
const $0673dc41d4591954$export$9022327d826319c7 = 'system.create.space.dialog/content';
const $0673dc41d4591954$export$b7555e81ec195340 = 'page.view.selection/action-panel';
const $0673dc41d4591954$export$dbd4ce8bddb36f82 = 'atl.dashboard.secondary';
const $0673dc41d4591954$export$78738b07c213d412 = 'atl.general';
const $0673dc41d4591954$export$45c1e55ebc7a8070 = 'atl.footer';
const $0673dc41d4591954$export$e1325689a3e8f66b = 'atl.page.metadata.banner';
const $0673dc41d4591954$export$e8a1b6a55853b054 = 'atl.page.content.footer.actions';
const $0673dc41d4591954$export$488204faf384ca14 = 'atl.editor.savebar';
const $0673dc41d4591954$export$c7ef8755b728af2b = 'system.admin/siteadministration';
const $0673dc41d4591954$export$a7876e82ed48f038 = 'system.admin/security';
module.exports["TOOLS_MENU_CONTAINER"] = $0673dc41d4591954$export$b1fc939aa7feb92f;
module.exports["PAGE_BUTTONS"] = $0673dc41d4591954$export$cc265e0ec08cd67d;
module.exports["SYSTEM_CONTENT_BYLINE"] = $0673dc41d4591954$export$9aacf4bfaa57e6fc;
module.exports["SYSTEM_CONTENT_METADATA"] = $0673dc41d4591954$export$1b2697f8e6fa897f;
module.exports["SYSTEM_ATTACHMENT"] = $0673dc41d4591954$export$53635c098825d80c;
module.exports["SYSTEM_ATTACHMENT_METADATA"] = $0673dc41d4591954$export$b55f44bb0675280a;
module.exports["SYSTEM_ATTACHMENT_HISTORY"] = $0673dc41d4591954$export$932fbff4e94f11bd;
module.exports["PAGE_METADATA_BANNER"] = $0673dc41d4591954$export$76fccc09e967256f;
module.exports["SYSTEM_HEADER_LEFT"] = $0673dc41d4591954$export$630f26f93c0b82dc;
module.exports["SYSTEM_HELP"] = $0673dc41d4591954$export$ac6c373b69972f05;
module.exports["SYSTEM_USER"] = $0673dc41d4591954$export$1835f2a2eaa3b55b;
module.exports["SYSTEM_ADMIN"] = $0673dc41d4591954$export$8fc5196f34e2202a;
module.exports["SYSTEM_EDITOR_PRECURSOR_BUTTONS"] = $0673dc41d4591954$export$e83e042e2b565918;
module.exports["CREATE_DIALOG"] = $0673dc41d4591954$export$2a98a7a0b026585a;
module.exports["CREATE_SPACE_DIALOG"] = $0673dc41d4591954$export$9022327d826319c7;
module.exports["ACTION_PANEL"] = $0673dc41d4591954$export$b7555e81ec195340;
module.exports["DASHBOARD_SECONDARY"] = $0673dc41d4591954$export$dbd4ce8bddb36f82;
module.exports["ATL_GENERAL"] = $0673dc41d4591954$export$78738b07c213d412;
module.exports["ATL_FOOTER"] = $0673dc41d4591954$export$45c1e55ebc7a8070;
module.exports["ATL_PAGE_METADATA"] = $0673dc41d4591954$export$e1325689a3e8f66b;
module.exports["ATL_PAGE_CONTENT_FOOTER_ACTIONS"] = $0673dc41d4591954$export$e8a1b6a55853b054;
module.exports["ATL_EDITOR_SAVEBAR"] = $0673dc41d4591954$export$488204faf384ca14;

});

parcelRegister("8dUjs", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");


var $eSLr0 = parcelRequire("eSLr0");


var $7Ndnw = parcelRequire("7Ndnw");


var $5tgcI = parcelRequire("5tgcI");

const $84cd59e06a85be4f$export$a9c446837cd59ef8 = [
    (0, $5tgcI.SPACES_KEY),
    (0, $5tgcI.PEOPLE_KEY),
    (0, $5tgcI.DISCOVER_KEY)
];
const $84cd59e06a85be4f$export$a56df56fab66279e = ({ edition: edition, accessStatus: accessStatus })=>{
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const hideAutomation = edition !== 'PREMIUM' || !isAdmin;
    const notAllowedWebItems = [
        ...$84cd59e06a85be4f$export$a9c446837cd59ef8,
        hideAutomation ? (0, $5tgcI.AUTOMATION_KEY) : ''
    ];
    return {
        webItemParams: {
            location: (0, $eSLr0.SYSTEM_HEADER_LEFT),
            notAllowedWebItems: notAllowedWebItems
        },
        forgeExtensionParams: {
            moduleType: (0, $7Ndnw.FORGE_MODULE_GLOBAL_PAGE),
            spaceKey: ''
        }
    };
};
module.exports["getGlobalAppsParams"] = $84cd59e06a85be4f$export$a56df56fab66279e;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$3d2f468c166bad70 = 'confluence:attachmentAction';
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$3d2f468c166bad70,
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_ATTACHMENT_ACTION"] = $af2b0e533822f413$export$3d2f468c166bad70;
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("5tgcI", function(module, exports) {
const $696759caf06ef68c$export$af39e4edc5e74 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-spaces-link';
const $696759caf06ef68c$export$97c436ccc42cbac9 = 'com.atlassian.confluence.plugins.confluence-space-ia:header-people-link';
const $696759caf06ef68c$export$3a7ae658938afc39 = 'com.atlassian.plugins.atlassian-connect-plugin:com.atlassian.confluence.emcee__enduser-discover';
const $696759caf06ef68c$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:header-automation-link';
const $696759caf06ef68c$export$8a23ae6ca6b0c9ee = 'com.atlassian.confluence.extra.team-calendars:header-mycalendar-link';
const $696759caf06ef68c$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics__analytics-instance-settings-menu-item-adg3';
const $696759caf06ef68c$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:com.addonengine.analytics.moderate__analytics-instance-settings-menu-item-adg3';
module.exports["SPACES_KEY"] = $696759caf06ef68c$export$af39e4edc5e74;
module.exports["PEOPLE_KEY"] = $696759caf06ef68c$export$97c436ccc42cbac9;
module.exports["DISCOVER_KEY"] = $696759caf06ef68c$export$3a7ae658938afc39;
module.exports["AUTOMATION_KEY"] = $696759caf06ef68c$export$ee99bc1ad01a63ae;
module.exports["CALENDAR_KEY"] = $696759caf06ef68c$export$8a23ae6ca6b0c9ee;
module.exports["ANALYTICS_KEY"] = $696759caf06ef68c$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $696759caf06ef68c$export$6c3d789a4f56bea2;

});

parcelRegister("hPkGG", function(module, exports) {
/**
 * @generated SignedSource<<5efd4a44b24bb87c092d4fc494599337>>
 * @relayHash ee5a91706bc8d2c36266138f1556fa8e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a
const $62aeb16db236e807$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ownerAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "entityAri",
                    "variableName": "entityAri"
                },
                {
                    "kind": "Variable",
                    "name": "ownerAri",
                    "variableName": "ownerAri"
                }
            ],
            "concreteType": "SettingsNavigationCustomisation",
            "kind": "LinkedField",
            "name": "settings_navigationCustomisation",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SettingsMenuItemConnection",
                    "kind": "LinkedField",
                    "name": "sidebar",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SettingsMenuItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "menuId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "visible"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "GlobalNavigationComponentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ee5a91706bc8d2c36266138f1556fa8e",
            "id": "7f7a8c5a405e165722f55d2fb38fba615d09b5f4c08ede00a7a9fe5741f08c7a",
            "metadata": {},
            "name": "GlobalNavigationComponentQuery",
            "operationKind": "query",
            "text": "query GlobalNavigationComponentQuery($entityAri:ID!,$ownerAri:ID!){settings_navigationCustomisation(entityAri:$entityAri,ownerAri:$ownerAri){id,sidebar{nodes{menuId,visible}}}}"
        }
    };
}();
$62aeb16db236e807$var$node.hash = "0e74e77d53a00c9095e60ae7930a7cf3";
var $62aeb16db236e807$export$2e2bcd8739ae039 = $62aeb16db236e807$var$node;
module.exports["default"] = $62aeb16db236e807$export$2e2bcd8739ae039;

});

parcelRegister("aQN68", function(module, exports) {
/**
 * @generated SignedSource<<4397834310e821608aae72d6cd602b23>>
 * @relayHash efbccdac5bb753d6ce419c019fa1aaca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439
const $ede2af096215976f$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "efbccdac5bb753d6ce419c019fa1aaca",
            "id": "2c716a297065a0b32d13d0ef655d0af2eb808e17bfd7325a7ecbc232e2971439",
            "metadata": {},
            "name": "useLicensedProductsQueryForGlobalAppShortcutsQuery",
            "operationKind": "query",
            "text": "query useLicensedProductsQueryForGlobalAppShortcutsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$ede2af096215976f$var$node.hash = "4173fb2f98b7988a84dc02df0399a348";
var $ede2af096215976f$export$2e2bcd8739ae039 = $ede2af096215976f$var$node;
module.exports["default"] = $ede2af096215976f$export$2e2bcd8739ae039;

});

parcelRegister("cbHql", function(module, exports) {
/**
 * @generated SignedSource<<ca53475eaec9df41a732c9e6f52f225d>>
 * @relayHash c67b40e0841cbe3641e147b8f635e291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5
const $40163854596f3729$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceEditorSettings",
                    "kind": "LinkedField",
                    "name": "confluenceEditorSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "toolbarDockingInitialPosition"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "EditorPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c67b40e0841cbe3641e147b8f635e291",
            "id": "8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5",
            "metadata": {},
            "name": "EditorPreferencesQuery",
            "operationKind": "query",
            "text": "query EditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
        }
    };
}();
$40163854596f3729$var$node.hash = "49dd5f6cf6c26477ad455a4c7f501e60";
var $40163854596f3729$export$2e2bcd8739ae039 = $40163854596f3729$var$node;
module.exports["default"] = $40163854596f3729$export$2e2bcd8739ae039;

});

parcelRegister("9sGCn", function(module, exports) {

var $5RVp4 = parcelRequire("5RVp4");


var $5tydj = parcelRequire("5tydj");


var $kBBRP = parcelRequire("kBBRP");


var $b22Ya = parcelRequire("b22Ya");


var $dOBRD = parcelRequire("dOBRD");


var $fFmJj = parcelRequire("fFmJj");


var $ge2sX = parcelRequire("ge2sX");

var $416a341702253f60$var$Client = /*#__PURE__*/ function(Client) {
    Client["CC_GRAPHQL"] = "Cc graphql client";
    Client["AGG_GRAPHQL"] = "Agg graphql client";
    return Client;
}($416a341702253f60$var$Client || {});
const $416a341702253f60$var$FRAGMENTS_BY_TYPE = [
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        fragment: (0, $b22Ya.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'Content',
        // If we don't have `status` cached but do have `subType` cached, this ensures we still fast load it. We prefer fast loading live docs even if we're uncertain whether they're archived.
        fragment: (0, $kBBRP.default)
    },
    {
        client: "Cc graphql client",
        gqlType: 'PTPage',
        fragment: (0, $5tydj.default)
    },
    {
        // Search query uses agg graphql client
        client: "Agg graphql client",
        gqlType: 'SearchConfluencePageBlogAttachment',
        fragment: (0, $5RVp4.default)
    }
];
const $416a341702253f60$export$b4dacd1dfdee469b = (0, $dOBRD.default)((contentId)=>{
    if (!contentId) // When content id does not exist, return undefined values
    return {
        subType: undefined,
        isArchived: undefined,
        gqlType: undefined
    };
    const cloudId = (0, $ge2sX.getCloudId)();
    let subType;
    let isArchived = undefined;
    let gqlTypeUsed;
    $416a341702253f60$var$FRAGMENTS_BY_TYPE.some(({ client: client, gqlType: gqlType, fragment: fragment })=>{
        // readFragment throws an error if it finds the item in the cache without both id and subtype, so we wrap in try/catch
        try {
            let id = `${gqlType}:${contentId}`;
            if (gqlType === 'SearchConfluencePageBlogAttachment') // Search graphql query includes the ARI in the id
            id = `${gqlType}:ari:cloud:confluence:${cloudId}:page/${contentId}`;
            const fragmentData = (0, $fFmJj.readFragmentInterop)({
                id: id,
                fragment: fragment,
                interopApolloAggClient: client === "Agg graphql client",
                __callerPackage__: "live-pages-utils"
            });
            if (fragmentData && 'subType' in fragmentData && fragmentData.subType) {
                subType = fragmentData.subType;
                isArchived = 'status' in fragmentData && fragmentData.status ? fragmentData.status?.toLowerCase?.() === 'archived' : undefined;
                gqlTypeUsed = gqlType;
                return true;
            } else if (fragmentData && 'subtype' in fragmentData && fragmentData.subtype) {
                // In search graphql query's response, subtype exists as an inline fragment on ConfluencePage
                subType = fragmentData.subtype?.toLowerCase?.();
                gqlTypeUsed = gqlType;
                return true;
            }
        } catch  {}
    });
    return {
        subType: subType,
        isArchived: isArchived,
        gqlType: gqlTypeUsed
    };
});
const $416a341702253f60$export$d56c32e9e73f8f9b = ()=>$416a341702253f60$export$b4dacd1dfdee469b.clear();
module.exports["getCachedPageData"] = $416a341702253f60$export$b4dacd1dfdee469b;
module.exports["clearMemoizedCachedPageData"] = $416a341702253f60$export$d56c32e9e73f8f9b;

});

parcelRegister("5RVp4", function(module, exports) {
/**
 * @generated SignedSource<<9964ae8171b6e20649f2fca9a76ff96a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d1b5c3b39238b90e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeSearchFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "LinkedField",
            "name": "confluenceEntity",
            "plural": false,
            "selections": [
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        }
                    ],
                    "type": "ConfluencePage"
                }
            ]
        }
    ],
    "type": "SearchConfluencePageBlogAttachment"
};
$d1b5c3b39238b90e$var$node.hash = "029b00b42bd8ba9e9b5ecf4947b241c2";
var $d1b5c3b39238b90e$export$2e2bcd8739ae039 = $d1b5c3b39238b90e$var$node;
module.exports["default"] = $d1b5c3b39238b90e$export$2e2bcd8739ae039;

});

parcelRegister("5tydj", function(module, exports) {
/**
 * @generated SignedSource<<06b30fff81deb6c9145868aacd1b6057>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $019558c9ca245006$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypePageTreeFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "PTPage"
};
$019558c9ca245006$var$node.hash = "7ccb76f2a832d90b6f167fe96a11f5a9";
var $019558c9ca245006$export$2e2bcd8739ae039 = $019558c9ca245006$var$node;
module.exports["default"] = $019558c9ca245006$export$2e2bcd8739ae039;

});

parcelRegister("kBBRP", function(module, exports) {
/**
 * @generated SignedSource<<ba803410513b2e2b6e70f77d471effb5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6f66d8210bca9b3e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataSubTypeContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        }
    ],
    "type": "Content"
};
$6f66d8210bca9b3e$var$node.hash = "03b28a640aee18909db0a4f3575e7f08";
var $6f66d8210bca9b3e$export$2e2bcd8739ae039 = $6f66d8210bca9b3e$var$node;
module.exports["default"] = $6f66d8210bca9b3e$export$2e2bcd8739ae039;

});

parcelRegister("b22Ya", function(module, exports) {
/**
 * @generated SignedSource<<3f51ca78fc05b3943b12ce8587361a0d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f9170d170545992b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "getCachedPageDataContentFragment",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "subType"
        },
        {
            "kind": "ScalarField",
            "name": "status"
        }
    ],
    "type": "Content"
};
$f9170d170545992b$var$node.hash = "b940ae3a5484e1099f106d12713d37f5";
var $f9170d170545992b$export$2e2bcd8739ae039 = $f9170d170545992b$var$node;
module.exports["default"] = $f9170d170545992b$export$2e2bcd8739ae039;

});

parcelRegister("3y1ko", function(module, exports) {

var $xwvlW = parcelRequire("xwvlW");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $f7B1p = parcelRequire("f7B1p");

async function $4c06255176f911bc$export$632d1cf1f5c6210f() {
    let enabled = false;
    try {
        const res = await (0, $f7B1p.cfetch)('/wiki/rest/confluenceshortcuts/latest/enabled');
        if (res.ok) enabled = await res.text() === 'true';
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error fetching keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
    return window.__SHORTCUT_ENABLED__ = enabled;
}
async function $4c06255176f911bc$export$abcdd924245fc03a() {
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    if (isLoggedIn && isLicensed) return await $4c06255176f911bc$export$632d1cf1f5c6210f();
    return false;
}
module.exports["fetchShortcutEnabledState"] = $4c06255176f911bc$export$632d1cf1f5c6210f;
module.exports["preloadShortcutEnabledState"] = $4c06255176f911bc$export$abcdd924245fc03a;

});

parcelRegister("hXDOc", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $cozmU.useRef)(null);
    const preloadRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Only the everything mode proceeds to data preloading.
        if (preloadOptions?.preloadingMode !== "everything") return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $cozmU.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $cozmU.isValidElement)(children) ? /*#__PURE__*/ (0, $cozmU.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("gVWsk", function(module, exports) {
function $a5a63f3e365d7e09$export$1c4065b3a9f04cf2(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}
module.exports["isJSONDocNode"] = $a5a63f3e365d7e09$export$1c4065b3a9f04cf2;

});

parcelRegister("cUB5n", function(module, exports) {

var $2TTFH = parcelRequire("2TTFH");

const $e002af656dcf6977$var$parsedAdfByContent = (0, $2TTFH.createAdfDerivationMemo)(2);
const $e002af656dcf6977$var$parse = (adfString)=>{
    try {
        return {
            ok: true,
            doc: JSON.parse(adfString)
        };
    } catch (error) {
        return {
            ok: false,
            error: error instanceof Error ? error : new Error('Failed to parse ADF')
        };
    }
};
const $e002af656dcf6977$export$a56d8cc81690f0df = (contentId, adfString)=>{
    return $e002af656dcf6977$var$parsedAdfByContent.derive(contentId, adfString, ()=>$e002af656dcf6977$var$parse(adfString));
};
const $e002af656dcf6977$export$12c00d9f2aef8d16 = (contentId, adfString, doc)=>{
    $e002af656dcf6977$var$parsedAdfByContent.set(contentId, adfString, {
        ok: true,
        doc: doc
    });
};
module.exports["getOrParseContentBodyAdf"] = $e002af656dcf6977$export$a56d8cc81690f0df;
module.exports["seedContentBodyAdfCache"] = $e002af656dcf6977$export$12c00d9f2aef8d16;

});

parcelRegister("2TTFH", function(module, exports) {
// A generic cross-instance memo for an expensive derivation of a page's ADF,
// shared so N consumers of the same document parse + walk it once, not N times.
// Keyed by a small id (e.g. contentId) with a reference-compared `token` (e.g.
// the ADF string) — the multi-MB body is never hashed or used as a Map key, and
// a new document version is a natural miss.
const $e20b61f673ca0f0b$var$DEFAULT_MAX_ENTRIES = 4;
const $e20b61f673ca0f0b$export$b7c51a1bf63861b2 = (maxEntries = $e20b61f673ca0f0b$var$DEFAULT_MAX_ENTRIES)=>{
    const store = new Map();
    const set = (key, token, value)=>{
        if (store.has(key)) store.delete(key);
        else if (store.size >= maxEntries) {
            const oldest = store.keys().next().value;
            if (oldest !== undefined) store.delete(oldest);
        }
        store.set(key, {
            token: token,
            value: value
        });
    };
    return {
        derive: (key, token, compute)=>{
            const existing = store.get(key);
            if (existing && Object.is(existing.token, token)) {
                // Re-insert to mark most-recently-used (Map preserves insertion order).
                store.delete(key);
                store.set(key, existing);
                return existing.value;
            }
            const value = compute();
            set(key, token, value);
            return value;
        },
        clear: ()=>{
            store.clear();
        },
        set: set
    };
};
module.exports["createAdfDerivationMemo"] = $e20b61f673ca0f0b$export$b7c51a1bf63861b2;

});

parcelRegister("wPrRK", function(module, exports) {


var $9WAeG = parcelRequire("9WAeG");


var $1xpoY = parcelRequire("1xpoY");



const $0a25e88d230f5014$export$df0dc85e162077fe = 500;
const $0a25e88d230f5014$export$e4579551e9b7b973 = async (name, task, timeout, skipSignal)=>{
    let timer = null;
    const slowQueryGuardTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_slow_query_guard_timeout', $0a25e88d230f5014$export$df0dc85e162077fe);
    const finalTimeout = Math.max(timeout, slowQueryGuardTimeout);
    const timeoutPromise = new Promise((resolve)=>{
        timer = setTimeout(()=>{
            resolve(false);
        }, finalTimeout);
    });
    const runTask = async ()=>{
        const run = async ()=>{
            await (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/slowQueryGuard:${name}`, task);
            if (timer) clearTimeout(timer);
            return true;
        };
        return run();
    };
    return Promise.race(skipSignal ? [
        timeoutPromise,
        skipSignal.then(()=>true),
        runTask()
    ] : [
        timeoutPromise,
        runTask()
    ]);
};
module.exports["SLOW_QUERY_DEFAULT_TIMEOUT"] = $0a25e88d230f5014$export$df0dc85e162077fe;
module.exports["slowQueryGuard"] = $0a25e88d230f5014$export$e4579551e9b7b973;

});

parcelRegister("kquO1", function(module, exports) {

var $05daj = parcelRequire("05daj");


var $7Sm4c = parcelRequire("7Sm4c");


var $dYU3e = parcelRequire("dYU3e");


var $8tmcF = parcelRequire("8tmcF");


var $3mugH = parcelRequire("3mugH");

const $16ec8c3b2306adb8$var$PRELOAD_TIMEOUT_MS = 500;
const $16ec8c3b2306adb8$var$TIMED_OUT = Symbol('outgoing-links-preload-timed-out');
const $16ec8c3b2306adb8$export$a0681264c37c98d4 = (0, $05daj.default);
const $16ec8c3b2306adb8$var$runQuery = (contentId)=>(0, $dYU3e.query)({
        query: $16ec8c3b2306adb8$export$a0681264c37c98d4,
        variables: {
            contentId: contentId
        },
        __callerPackage__: "connectors"
    });
const $16ec8c3b2306adb8$var$reportUnavailable = (reason, cause)=>{
    (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Outgoing links preload unavailable: ${reason}`, {
        cause: cause
    }), {
        operation: 'preload-outgoing-links',
        reason: reason
    });
    if (cause instanceof Error) (0, $7Sm4c.markErrorAsHandled)(cause);
};
const $16ec8c3b2306adb8$export$57bfcc710803f40e = async (contentId)=>{
    try {
        const promise = $16ec8c3b2306adb8$var$runQuery(contentId);
        const result = await (0, $8tmcF.timeGuard)(()=>promise, $16ec8c3b2306adb8$var$TIMED_OUT, $16ec8c3b2306adb8$var$PRELOAD_TIMEOUT_MS);
        if (result === $16ec8c3b2306adb8$var$TIMED_OUT) {
            $16ec8c3b2306adb8$var$reportUnavailable('timeout');
            return;
        }
        if (result.hasErrors || result.errors?.length) $16ec8c3b2306adb8$var$reportUnavailable('query-error', result.errors?.[0]);
    } catch (cause) {
        $16ec8c3b2306adb8$var$reportUnavailable('query-error', cause);
    }
};
module.exports["OutgoingLinksQuery"] = $16ec8c3b2306adb8$export$a0681264c37c98d4;
module.exports["preloadOutgoingLinks"] = $16ec8c3b2306adb8$export$57bfcc710803f40e;

});

parcelRegister("05daj", function(module, exports) {
/**
 * @generated SignedSource<<9b82e025502749d65398a1224a13d8b3>>
 * @relayHash fec3092eee5be8002a509e6d3be00bc6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ab71c9a12a0be2c8e5d9d99b7deecbd0116bb7ce35f6af9111a2fe2f1177c3c
const $be4a7160c946b27a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "OutgoingLinks",
                            "kind": "LinkedField",
                            "name": "outgoingLinks",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 50
                                        }
                                    ],
                                    "concreteType": "ConfluenceExternalLinkConnection",
                                    "kind": "LinkedField",
                                    "name": "externalOutgoingLinks",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceExternalLink",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "url"
                                                }
                                            ]
                                        }
                                    ],
                                    "storageKey": "externalOutgoingLinks(first:50)"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadOutgoingLinksQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadOutgoingLinksQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fec3092eee5be8002a509e6d3be00bc6",
            "id": "1ab71c9a12a0be2c8e5d9d99b7deecbd0116bb7ce35f6af9111a2fe2f1177c3c",
            "metadata": {},
            "name": "preloadOutgoingLinksQuery",
            "operationKind": "query",
            "text": "query preloadOutgoingLinksQuery($contentId:ID!){content(id:$contentId){nodes{id,outgoingLinks{externalOutgoingLinks(first:50){nodes{url}}}}}}"
        }
    };
}();
$be4a7160c946b27a$var$node.hash = "62d400bfa3bd0d225066bef6f6f82860";
var $be4a7160c946b27a$export$2e2bcd8739ae039 = $be4a7160c946b27a$var$node;
module.exports["default"] = $be4a7160c946b27a$export$2e2bcd8739ae039;

});

parcelRegister("8tmcF", function(module, exports) {
function $5c639d7819ef31f1$export$baa85236a0d673f4(task, returnValueOnTimeout, timeout) {
    return Promise.race([
        task(),
        new Promise((resolve)=>setTimeout(()=>{
                resolve(typeof returnValueOnTimeout === 'function' ? returnValueOnTimeout() : returnValueOnTimeout);
            }, timeout))
    ]);
}
module.exports["timeGuard"] = $5c639d7819ef31f1$export$baa85236a0d673f4;

});

parcelRegister("7Z6Kn", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");


var $bFDX4 = parcelRequire("bFDX4");


var $7LI3Q = parcelRequire("7LI3Q");

// Deliberately excludes generic network failures ("Failed to fetch" / "NetworkError" /
// "Load failed") - those should keep being reported.
const $a01e8cf371b2bee2$var$KNOWN_EXPECTED_ERROR_MESSAGES = [
    'not listed in the IP allowlist',
    'Auth category: UNAUTHENTICATED is not allowed in service knowledge_discovery',
    'does not support customer accounts',
    'Step-up authentication is required',
    'rate limit exceeded'
];
const $a01e8cf371b2bee2$var$matchesKnownExpectedMessage = (errorLike)=>$a01e8cf371b2bee2$var$KNOWN_EXPECTED_ERROR_MESSAGES.some((message)=>errorLike.message?.includes(message));
const $a01e8cf371b2bee2$export$21b43c296a9131a5 = (error)=>{
    if (!error) return false;
    const isExpectedMessage = error.graphQLErrors?.length ? error.graphQLErrors.every($a01e8cf371b2bee2$var$matchesKnownExpectedMessage) : $a01e8cf371b2bee2$var$matchesKnownExpectedMessage(error);
    if (isExpectedMessage) return true;
    return (0, $7LI3Q.isUnauthorizedError)(error) || (0, $aMcHK.isStatusCodeError)(error, '403') || (0, $bFDX4.isTooManyRequestsError)(error);
};
module.exports["isExpectedAutohighlightsError"] = $a01e8cf371b2bee2$export$21b43c296a9131a5;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});

parcelRegister("hpnxK", function(module, exports) {
const $88d658a04ba6cccf$export$bb4f02e6ef6f6e17 = (error)=>error.message?.includes('Cannot find space');
const $88d658a04ba6cccf$export$8e8597efbb5c0cd8 = (error)=>{
    const { extensions: extensions, path: path } = error;
    if (extensions?.errorSource !== 'GRAPHQL_GATEWAY' || extensions.classification !== 'CustomerAccountsNotSupportedException' || String(extensions.statusCode) !== '403') return false;
    return extensions.service === 'knowledge_discovery' && (!path?.length || path[0] === 'knowledgeDiscovery') || extensions.service === 'confluence_analytics' && (!path?.length || path[0] === 'contentAnalyticsViewers');
};
// These root fields have permissions independent of reading the page. Do not include `space`:
// its denial still participates in the existing space/access-link handling.
const $88d658a04ba6cccf$var$OPTIONAL_CONTENT_ROOTS = new Set([
    'contentAnalyticsViewers',
    'knowledgeDiscovery'
]);
function $88d658a04ba6cccf$export$faccf771e61fd3dc(error, requestedContentId, resolvedContentId) {
    const { extensions: extensions, path: path } = error;
    const data = extensions?.data;
    const isPermissionError = String(extensions?.statusCode) === '403' || typeof data === 'object' && data !== null && 'authorized' in data && data.authorized === false;
    if (!isPermissionError) return 'other';
    const root = path?.[0];
    if (root === 'content' || root === 'spaceHomepage') return 'content-permission';
    // Never use missing content or the previous page's cache data to dismiss a failure.
    if (requestedContentId && requestedContentId === resolvedContentId && (typeof root === 'string' && $88d658a04ba6cccf$var$OPTIONAL_CONTENT_ROOTS.has(root) || $88d658a04ba6cccf$export$8e8597efbb5c0cd8(error))) return 'optional-permission';
    // A sibling field's denial does not establish a content denial, even if we do not yet
    // know how its consumer should recover. Retain the error without restricting the route.
    if (typeof root === 'string') return 'sibling-permission';
    // Pathless failures stay conservative; status alone cannot prove their scope.
    return 'unscoped-permission';
}
// The observed gateway IncorrectAuthException has neither a path nor a structured service
// field. Require its exact service-specific message and metadata; status/message alone
// must never establish scope for an otherwise ambiguous permission failure.
const $88d658a04ba6cccf$var$isPathlessAutohighlightsAuthError = (error)=>!error.path?.length && error.extensions?.errorSource === 'GRAPHQL_GATEWAY' && error.extensions.classification === 'IncorrectAuthException' && String(error.extensions.statusCode) === '403' && error.extensions.presentedAuth === 'UNAUTHENTICATED' && error.message === 'Auth category: UNAUTHENTICATED is not allowed in service knowledge_discovery';
function $88d658a04ba6cccf$export$4c76316533298e6a(error, requestedContentId, resolvedContentId) {
    return Boolean(requestedContentId && requestedContentId === resolvedContentId && (error.path?.[0] === 'knowledgeDiscovery' && (error.path.length === 1 || error.path[1] === 'keyPhrases') || $88d658a04ba6cccf$var$isPathlessAutohighlightsAuthError(error)));
}
module.exports["isNotFoundSpaceError"] = $88d658a04ba6cccf$export$bb4f02e6ef6f6e17;
module.exports["isUnsupportedCustomerAccountFieldError"] = $88d658a04ba6cccf$export$8e8597efbb5c0cd8;
module.exports["classifyContentPermissionError"] = $88d658a04ba6cccf$export$faccf771e61fd3dc;
module.exports["isContentAutohighlightsError"] = $88d658a04ba6cccf$export$4c76316533298e6a;

});

parcelRegister("3qGQ7", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $1ddb1afb9a8b0771$var$DEFAULT_BYLINE_CONTRIBUTORS_FETCH_LIMIT = 4;
const $1ddb1afb9a8b0771$var$createSharedVariables = ({ userId: userId, cloudId: cloudId, spaceKey: spaceKey, versionOverride: versionOverride, isSSR: isSSR, preloadLabels: preloadLabels = false, includeAgentTrustReceiptData: includeAgentTrustReceiptData = false, includeAutomationDiscoveries: includeAutomationDiscoveries = false, includeAudioContent: includeAudioContent = false, includeRendererAssetsMedia: includeRendererAssetsMedia = false, includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome = false, includeMetadata: includeMetadata = false, includeClassification: includeClassification = false, includeContentHeader: includeContentHeader = false, includeSmartCreateFeedback: includeSmartCreateFeedback = false, includeContentHeaderAccess: includeContentHeaderAccess = false, includeFabricEditorEligibility: includeFabricEditorEligibility = false, includeReactions: includeReactions = false, includeRestrictions: includeRestrictions = false, includeRestrictionAncestors: includeRestrictionAncestors = false, useContentModeFragment: useContentModeFragment = false, autohighlightsQueryVariables: autohighlightsQueryVariables })=>({
        spaceKey: spaceKey,
        versionOverride: versionOverride,
        isSSR: isSSR,
        ...cloudId && (0, $6mKj3.expValEquals)('platform_editor_mention_rovo', 'isEnabled', true) ? {
            includeRovoMentionIdentity: true,
            cloudId: cloudId
        } : {},
        useNewContentTopper: true,
        ...preloadLabels || includeMetadata ? {
            preloadLabels: true
        } : {},
        ...includeAgentTrustReceiptData ? {
            includeAgentTrustReceiptData: true
        } : {},
        ...includeAutomationDiscoveries ? {
            includeAutomationDiscoveries: true
        } : {},
        ...includeAudioContent ? {
            includeAudioContent: true
        } : {},
        ...includeRendererAssetsMedia ? {
            includeRendererAssetsMedia: true
        } : {},
        ...includeRendererAssetsCustomChrome ? {
            includeRendererAssetsCustomChrome: true
        } : {},
        ...includeClassification || includeMetadata ? {
            includeClassification: true
        } : {},
        ...(includeClassification || includeMetadata) && (0, $6mKj3.expValEquals)('confluence_classification_level_v2', 'isEnabled', true) ? {
            useClassificationLevelV2: true
        } : {},
        ...includeContentHeader ? {
            includeContentHeader: true
        } : {},
        ...includeSmartCreateFeedback ? {
            includeSmartCreateFeedback: true
        } : {},
        ...includeContentHeaderAccess ? {
            includeContentHeaderAccess: true
        } : {},
        ...includeFabricEditorEligibility ? {
            includeFabricEditorEligibility: true
        } : {},
        ...includeReactions ? {
            includeReactions: true
        } : {},
        ...includeRestrictions ? {
            includeRestrictions: true
        } : {},
        ...includeRestrictionAncestors ? {
            includeRestrictionAncestors: true
        } : {},
        ...useContentModeFragment ? {
            useContentModeFragment: true
        } : {},
        ...autohighlightsQueryVariables && !(userId?.startsWith('qm:') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) ? {
            includeAutohighlights: true,
            autohighlightsEntityAri: autohighlightsQueryVariables.entityAri,
            autohighlightsWorkspaceId: autohighlightsQueryVariables.workspaceId
        } : {}
    });
const $1ddb1afb9a8b0771$var$createAgentSessionVariables = (agentSessionsUserId)=>agentSessionsUserId ? {
        agentSessionsPropertyKey: `cc-agent-mention-sessions:${agentSessionsUserId}`,
        fetchAgentSessionsMarker: true
    } : {};
const $1ddb1afb9a8b0771$var$createBylineVariables = (includeBylineContributors = false)=>includeBylineContributors ? {
        includeBylineContributors: true,
        bylineContributorsLimit: $1ddb1afb9a8b0771$var$DEFAULT_BYLINE_CONTRIBUTORS_FETCH_LIMIT
    } : {};
// Customer accounts have site-specific qm: IDs and are unsupported by these AGG services.
// Keep this exclusion inside the document experiment; standalone queries are unchanged.
const $1ddb1afb9a8b0771$var$createAnalyticsBylineVariables = (includeAnalyticsByline = false, userId)=>includeAnalyticsByline && !(userId?.startsWith('qm:') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) ? {
        includeAnalyticsByline: true
    } : {};
const $1ddb1afb9a8b0771$var$createConnectionAncestorVariables = (includeConnectionAncestors = false)=>includeConnectionAncestors ? {
        includeConnectionAncestors: true
    } : {};
const $1ddb1afb9a8b0771$export$5aa9cbe79a3cf3 = ({ contentId: contentId, agentSessionsUserId: agentSessionsUserId, includeBylineContributors: includeBylineContributors, includeConnectionAncestors: includeConnectionAncestors, includeAnalyticsByline: includeAnalyticsByline, includeContentHeaderPublicLink: includeContentHeaderPublicLink, includeRendererAssetsDsp: includeRendererAssetsDsp, rendererAssetsDspAction: rendererAssetsDspAction, externalLabelsQueryVariables: externalLabelsQueryVariables, rovoActivationQueryVariables: rovoActivationQueryVariables, ...sharedOptions })=>({
        contentId: contentId,
        ...$1ddb1afb9a8b0771$var$createSharedVariables(sharedOptions),
        ...$1ddb1afb9a8b0771$var$createAgentSessionVariables(agentSessionsUserId),
        ...$1ddb1afb9a8b0771$var$createBylineVariables(includeBylineContributors),
        ...$1ddb1afb9a8b0771$var$createConnectionAncestorVariables(includeConnectionAncestors),
        ...$1ddb1afb9a8b0771$var$createAnalyticsBylineVariables(includeAnalyticsByline, sharedOptions.userId),
        ...includeContentHeaderPublicLink ? {
            includeContentHeaderPublicLink: true
        } : {},
        ...includeRendererAssetsDsp ? {
            includeRendererAssetsDsp: true,
            rendererAssetsDspAction: rendererAssetsDspAction || 'PAGE_EXPORT'
        } : {},
        // Managed (external) labels: emit the include flag and args only when the
        // feature is on for this content. `externalLabelsCloudId`/`externalLabelsAri`
        // are declared nullable-with-default (`ID = ""`) on `ContentUnifiedQuery`, so
        // omitting them here is safe — GraphQL supplies the default, and a
        // nullable-with-default variable still satisfies the fragment's non-null
        // `ID!` argument via the variable-usage rule. Mirrors the autohighlights
        // pattern so omitting consumers get an unchanged variables object.
        ...externalLabelsQueryVariables ? {
            includeExternalLabels: true,
            externalLabelsCloudId: externalLabelsQueryVariables.cloudId,
            externalLabelsAri: externalLabelsQueryVariables.ari
        } : {},
        ...rovoActivationQueryVariables ? {
            includeRovoActivation: true,
            rovoActivationCloudId: rovoActivationQueryVariables.cloudId
        } : {}
    });
const $1ddb1afb9a8b0771$export$85ff462ea4060e8a = ({ contentId: contentId, includeBylineContributors: includeBylineContributors, includeAnalyticsByline: includeAnalyticsByline, includeContentHeaderPublicLink: includeContentHeaderPublicLink, includeRendererAssetsDsp: includeRendererAssetsDsp, rendererAssetsDspAction: rendererAssetsDspAction, ...sharedOptions })=>({
        contentId: contentId,
        ...$1ddb1afb9a8b0771$var$createSharedVariables(sharedOptions),
        ...$1ddb1afb9a8b0771$var$createBylineVariables(includeBylineContributors),
        ...$1ddb1afb9a8b0771$var$createAnalyticsBylineVariables(includeAnalyticsByline, sharedOptions.userId),
        ...includeContentHeaderPublicLink ? {
            includeContentHeaderPublicLink: true
        } : {},
        ...includeRendererAssetsDsp ? {
            includeRendererAssetsDsp: true,
            rendererAssetsDspAction: rendererAssetsDspAction || 'PAGE_EXPORT'
        } : {}
    });
const $1ddb1afb9a8b0771$export$2021e0be086a965a = ({ spaceKey: spaceKey, agentSessionsUserId: agentSessionsUserId, includeBylineContributors: includeBylineContributors, includeConnectionAncestors: includeConnectionAncestors, ...sharedOptions })=>({
        ...$1ddb1afb9a8b0771$var$createSharedVariables({
            ...sharedOptions,
            spaceKey: spaceKey
        }),
        spaceKey: spaceKey,
        ...$1ddb1afb9a8b0771$var$createAgentSessionVariables(agentSessionsUserId),
        ...includeBylineContributors ? {
            includeBylineContributors: true
        } : {},
        ...$1ddb1afb9a8b0771$var$createConnectionAncestorVariables(includeConnectionAncestors)
    });
module.exports["createContentUnifiedQueryVariables"] = $1ddb1afb9a8b0771$export$5aa9cbe79a3cf3;
module.exports["createContentBlogUnifiedQueryVariables"] = $1ddb1afb9a8b0771$export$85ff462ea4060e8a;
module.exports["createContentUnifiedWithSpaceKeyQueryVariables"] = $1ddb1afb9a8b0771$export$2021e0be086a965a;

});

parcelRegister("hNtOj", function(module, exports) {

var $etu7G = parcelRequire("etu7G");

const $120c25b1424bdefe$export$c82fe4eede9104df = new (0, $etu7G.SSRPermissionsErrorHandler)();
module.exports["ssrPermissionsErrorHandler"] = $120c25b1424bdefe$export$c82fe4eede9104df;

});

parcelRegister("etu7G", function(module, exports) {
class $c6d83b8df27b1c26$export$e70f491dc46ba2ed {
    markSSRPreloadPermissionError(route, error) {
        this.hasSSRPreloadPermissionsErrorForRoute = route;
        if (error) this.errorType = error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
    }
    getRestrictedRoute() {
        return this.hasSSRPreloadPermissionsErrorForRoute || window.__SSR_RESTRICTED_PAGE__?.route || null;
    }
    getErrorType() {
        return this.errorType || window.__SSR_RESTRICTED_PAGE__?.errorType || null;
    }
    constructor(){
        this.hasSSRPreloadPermissionsErrorForRoute = void 0;
        this.errorType = void 0;
        this.hasSSRPreloadPermissionsErrorForRoute = null;
        this.errorType = null;
    }
}
module.exports["SSRPermissionsErrorHandler"] = $c6d83b8df27b1c26$export$e70f491dc46ba2ed;

});

parcelRegister("b2p4s", function(module, exports) {
/**
 * @generated SignedSource<<4e480f3ff7d119a77ec41231b6b4ab42>>
 * @relayHash aa12b95dc97d2068b03de4a55dcec507
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c
const $ac606d0e22e5c37c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"editor\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NotFoundContainerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "aa12b95dc97d2068b03de4a55dcec507",
            "id": "0ef2c27ad493d782c86e25177000afba538c3c0eb50c460bf6d939aa03f2139c",
            "metadata": {},
            "name": "NotFoundContainerQuery",
            "operationKind": "query",
            "text": "query NotFoundContainerQuery($contentId:ID!,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,links{webui},properties(key:\"editor\"){nodes{id,key,value}}}}}"
        }
    };
}();
$ac606d0e22e5c37c$var$node.hash = "df3b0c202e5cf0f97257fa8a583747bc";
var $ac606d0e22e5c37c$export$2e2bcd8739ae039 = $ac606d0e22e5c37c$var$node;
module.exports["default"] = $ac606d0e22e5c37c$export$2e2bcd8739ae039;

});

parcelRegister("cS4kb", function(module, exports) {
const $5b142abb1411e5f7$var$UNKNOWN = 'unknown';
function $5b142abb1411e5f7$var$sanitizeUrl(url) {
    try {
        const urlObject = new URL(url);
        const hostname = urlObject.hostname;
        const pathname = urlObject.pathname;
        const firstPathSegment = pathname.split('/')[1];
        return firstPathSegment ? `${hostname}/${firstPathSegment}` : hostname;
    } catch  {
        return '';
    }
}
function $5b142abb1411e5f7$export$8071740a02e53ce2(link) {
    if (link.includes('/jira/') || link.includes('/servicedesk/') || link.includes('/helpcenter/') || link.includes('/projects/')) return 'jira';
    else if (link.includes('/wiki/')) return 'confluence';
    else if (link.includes('bitbucket')) return 'bitbucket';
    else if (link.includes('atlassian') || link.includes('jira-dev')) {
        // eslint-disable-next-line no-console
        console.log(`Resolving other atlassian link type: ${$5b142abb1411e5f7$var$sanitizeUrl(link)}`);
        return 'otherAtlassian';
    }
    return 'thirdParty';
}
function $5b142abb1411e5f7$export$70b802114e3b3d52(smartLinks) {
    return Object.values(smartLinks.reduce((acc, smartLink)=>{
        try {
            var _acc, _hostname;
            const hostname = new URL(smartLink.resourceUrl).hostname;
            ((_acc = acc)[_hostname = hostname] || (_acc[_hostname] = [])).push(smartLink);
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
            var _acc1, _UNKNOWN;
            ((_acc1 = acc)[_UNKNOWN = $5b142abb1411e5f7$var$UNKNOWN] || (_acc1[_UNKNOWN] = [])).push(smartLink);
        }
        return acc;
    }, {}));
}
function $5b142abb1411e5f7$export$9f4b5e6e623e6720(smartLinksGroups, max) {
    const result = [];
    for (const smartLinks of smartLinksGroups){
        if (smartLinks.length <= max) result.push(smartLinks);
        else for(let i = 0; i < smartLinks.length; i += max)result.push(smartLinks.slice(i, i + max));
    }
    return result;
}
function $5b142abb1411e5f7$export$3e7fb54d0ef2df07(smartLinksGroups, min) {
    const result = [];
    const smallThirdPartyBatches = [];
    for (const smartLinks of smartLinksGroups)if (smartLinks.length >= min || $5b142abb1411e5f7$export$8071740a02e53ce2(smartLinks[0].resourceUrl) !== 'thirdParty') result.push(smartLinks);
    else smallThirdPartyBatches.push(...smartLinks);
    if (smallThirdPartyBatches.length > 0) result.push(smallThirdPartyBatches);
    return result;
}
function $5b142abb1411e5f7$export$8c4674ec524aaf2c(resourceUrl) {
    const type = $5b142abb1411e5f7$export$8071740a02e53ce2(resourceUrl);
    switch(type){
        case 'jira':
        case 'confluence':
        case 'bitbucket':
        case 'otherAtlassian':
            return true;
        default:
            return false;
    }
}
module.exports["getLinkType"] = $5b142abb1411e5f7$export$8071740a02e53ce2;
module.exports["groupSmartLinksByHostname"] = $5b142abb1411e5f7$export$70b802114e3b3d52;
module.exports["splitLinksIntoBatches"] = $5b142abb1411e5f7$export$9f4b5e6e623e6720;
module.exports["mergeSmallThirdPartyBatches"] = $5b142abb1411e5f7$export$3e7fb54d0ef2df07;
module.exports["isFirstPartyLink"] = $5b142abb1411e5f7$export$8c4674ec524aaf2c;

});

parcelRegister("fyUox", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $1Y111 = parcelRequire("1Y111");


var $zalpJ = parcelRequire("zalpJ");

const $bf604cb6b214d1ef$var$preloadHomepageId = async (spaceKey)=>{
    const res = await (0, $dYU3e.query)({
        query: (0, $zalpJ.PreloadHomepageIdQuery),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "content-topper"
    });
    return res?.data?.space?.homepage?.id;
};
const $bf604cb6b214d1ef$var$preloadTitleContentProperty = (contentId, fetchPolicy = 'cache-first')=>(0, $dYU3e.query)({
        query: (0, $1Y111.default),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: fetchPolicy,
        __callerPackage__: "content-topper"
    });
const $bf604cb6b214d1ef$export$a65164d365713802 = async ({ contentId: contentId, contentIdPromise: contentIdPromise, spaceKey: spaceKey, fetchPolicy: fetchPolicy = 'cache-first' })=>{
    const promises = [];
    if (!contentId) {
        const homepageIdPromise = contentIdPromise || $bf604cb6b214d1ef$var$preloadHomepageId(spaceKey);
        promises.push(homepageIdPromise.then((homepageId)=>{
            return homepageId ? $bf604cb6b214d1ef$var$preloadTitleContentProperty(homepageId) : Promise.resolve({});
        }));
    } else promises.push($bf604cb6b214d1ef$var$preloadTitleContentProperty(contentId, fetchPolicy));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};
module.exports["preloadPageTitleContentProperties"] = $bf604cb6b214d1ef$export$a65164d365713802;

});

parcelRegister("1Y111", function(module, exports) {
/**
 * @generated SignedSource<<c93173dea6bc8ed379cb4b9b29fb2a88>>
 * @relayHash 6af15886385d86202fbacd0200dc99eb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0
const $66bccefa41a7dece$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "6af15886385d86202fbacd0200dc99eb",
            "id": "2ea0830d2908f5128944c3441d9d519bbd473f098af90ea4fb9f9816c899f8a0",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPageQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPageQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$66bccefa41a7dece$var$node.hash = "9a5b243b4d944acf33577dfb16711cea";
var $66bccefa41a7dece$export$2e2bcd8739ae039 = $66bccefa41a7dece$var$node;
module.exports["default"] = $66bccefa41a7dece$export$2e2bcd8739ae039;

});

parcelRegister("zalpJ", function(module, exports) {

var $4lSsc = parcelRequire("4lSsc");


var $eB536 = parcelRequire("eB536");


var $1Y111 = parcelRequire("1Y111");


var $jtuBN = parcelRequire("jtuBN");


var $jVylI = parcelRequire("jVylI");


var $gzIc1 = parcelRequire("gzIc1");

'use no memo';
const $20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery = (0, $1Y111.default);
const $20e32f1deb8c1fe0$export$e114ec4e88c7fe33 = (0, $eB536.default);
const $20e32f1deb8c1fe0$export$c9b63bbfd869a91 = (0, $4lSsc.default);
const $20e32f1deb8c1fe0$export$cef8b8531fa62d5f = (data)=>{
    const titlePropertyContent = data?.content?.nodes?.[0]?.pageTitlePublished?.nodes?.find((node)=>node?.key == 'page-title-property-published');
    const coverPictureWidth = data?.content?.nodes?.[0]?.metadata?.frontend?.coverPictureWidth || (0, $jVylI.COVERPICTUREWIDTH).FULL;
    if (titlePropertyContent?.value) try {
        return {
            titleContentProperties: (0, $gzIc1.contentPropertyHelper)(titlePropertyContent),
            coverPictureWidth: coverPictureWidth
        };
    } catch  {
        return {
            titleContentProperties: (0, $jVylI.defaultPropertyValue),
            coverPictureWidth: coverPictureWidth
        };
    }
    else return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: coverPictureWidth
    };
};
const $20e32f1deb8c1fe0$var$QUERY_OPTIONS = (contentId)=>({
        variables: {
            contentId: contentId,
            status: [
                'current',
                'archived',
                'draft'
            ]
        },
        fetchPolicy: 'cache-first'
    });
const $20e32f1deb8c1fe0$export$9e9d248809e028e8 = ({ contentId: contentId })=>{
    const options = $20e32f1deb8c1fe0$var$QUERY_OPTIONS(contentId);
    const { data: data, error: error, loading: loading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($20e32f1deb8c1fe0$var$UseTitleContentPropertiesForPublishedPageQuery, {
        variables: options.variables,
        skip: !contentId,
        __callerPackage__: "content-topper"
    });
    if (!loading && data && !error) {
        const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f(data);
        return {
            titleContentProperties: titleContentProperties,
            coverPictureWidth: coverPictureWidth
        };
    }
    return {
        titleContentProperties: (0, $jVylI.defaultPropertyValue),
        coverPictureWidth: (0, $jVylI.COVERPICTUREWIDTH).FULL
    };
};
module.exports["useTitleContentPropertiesForPublishedPage_content"] = $20e32f1deb8c1fe0$export$e114ec4e88c7fe33;
module.exports["PreloadHomepageIdQuery"] = $20e32f1deb8c1fe0$export$c9b63bbfd869a91;
module.exports["getTitleContentProperty"] = $20e32f1deb8c1fe0$export$cef8b8531fa62d5f;
module.exports["useTitleContentPropertiesForPublishedPage"] = $20e32f1deb8c1fe0$export$9e9d248809e028e8;

});

parcelRegister("4lSsc", function(module, exports) {
/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb
const $f70a6e2cb787614b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
            "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
            "metadata": {},
            "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
        }
    };
}();
$f70a6e2cb787614b$var$node.hash = "57678666b7eece7bec595c782b54d686";
var $f70a6e2cb787614b$export$2e2bcd8739ae039 = $f70a6e2cb787614b$var$node;
module.exports["default"] = $f70a6e2cb787614b$export$2e2bcd8739ae039;

});

parcelRegister("eB536", function(module, exports) {
/**
 * @generated SignedSource<<f3aa298d710112bdac45cdae3936c970>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3cc0a8cff50ad3c7$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useTitleContentPropertiesForPublishedPage_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            },
            {
                "alias": "pageTitleDraft",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-draft"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v1 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-draft\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3cc0a8cff50ad3c7$var$node.hash = "6913c519b951b36b57b6c77657b055fd";
var $3cc0a8cff50ad3c7$export$2e2bcd8739ae039 = $3cc0a8cff50ad3c7$var$node;
module.exports["default"] = $3cc0a8cff50ad3c7$export$2e2bcd8739ae039;

});

parcelRegister("jVylI", function(module, exports) {
var $341ba7bb7f83b82d$export$18feebdc268a3ef1 = /*#__PURE__*/ function(TitleAlignmentType) {
    TitleAlignmentType["LEFT"] = "LEFT";
    TitleAlignmentType["CENTER"] = "CENTER";
    return TitleAlignmentType;
}({});
const $341ba7bb7f83b82d$export$f5c76f9de4274e9b = {
    titleLayoutAlignment: "LEFT",
    titlePropertySubtitle: '',
    titlePropertySubtitleEnabled: false,
    titlePropertyBylineEnabled: false,
    titlePropertyEmojiEnabled: true,
    headerImageStylingEnabled: false
};
var $341ba7bb7f83b82d$export$f84f565b1b747c24 = /*#__PURE__*/ function(COVERPICTUREWIDTH) {
    COVERPICTUREWIDTH["FULL"] = "full";
    COVERPICTUREWIDTH["FIXED"] = "fixed";
    return COVERPICTUREWIDTH;
}({});
module.exports["TitleAlignmentType"] = $341ba7bb7f83b82d$export$18feebdc268a3ef1;
module.exports["defaultPropertyValue"] = $341ba7bb7f83b82d$export$f5c76f9de4274e9b;
module.exports["COVERPICTUREWIDTH"] = $341ba7bb7f83b82d$export$f84f565b1b747c24;

});

parcelRegister("gzIc1", function(module, exports) {

var $jVylI = parcelRequire("jVylI");

const $bda1e030ddde07df$export$e2d610ec02a291e1 = (jsonProperty)=>{
    let value;
    try {
        value = JSON.parse(jsonProperty.value);
        // objects returned from the content property can be double stringified
        const quoteMatches = value.match(/"/g);
        const quoteCount = quoteMatches ? quoteMatches.length : 0;
        // if quoteCount != null this means that the object is double wrapped as a string and needs to be parsed again
        if (quoteCount) try {
            value = JSON.parse(value);
        } catch (error) {
            value = (0, $jVylI.defaultPropertyValue);
            throw new Error(`unable to parse value: ${error.message}`);
        }
    } catch (error) {
        value = (0, $jVylI.defaultPropertyValue);
        throw error;
    }
    return value;
};
module.exports["contentPropertyHelper"] = $bda1e030ddde07df$export$e2d610ec02a291e1;

});

parcelRegister("gKMkU", function(module, exports) {

var $7Ba23 = parcelRequire("7Ba23");


var $aiN0O = parcelRequire("aiN0O");


var $dYU3e = parcelRequire("dYU3e");


var $hu6Tz = parcelRequire("hu6Tz");

const $7309ff12be989147$export$a95d48b280e02650 = ({ contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType })=>{
    return (0, $dYU3e.queryAgg)({
        query: $7309ff12be989147$export$133357fbca043a2d,
        variables: (0, $hu6Tz.getAutohighlightsQueryVariables)({
            contentId: contentId,
            cloudId: cloudId,
            activationId: activationId,
            contentType: contentType
        }),
        __callerPackage__: "contextual-reading-aids"
    });
};
const $7309ff12be989147$export$f4a8d1adced1d4b2 = (0, $aiN0O.default);
const $7309ff12be989147$export$133357fbca043a2d = (0, $7Ba23.default);
module.exports["preloadAutohighlights"] = $7309ff12be989147$export$a95d48b280e02650;
module.exports["preloadAutohighlightsQueryFragment"] = $7309ff12be989147$export$f4a8d1adced1d4b2;

});

parcelRegister("7Ba23", function(module, exports) {
/**
 * @generated SignedSource<<b8ed35fa23788eaea0d1eb92471e7f05>>
 * @relayHash 2820a095ae7566b0d9e48bbf4b073a4b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c97859d83625338169d38498096c0e05b0ed89a36118e4c759690c6b37f1e1b3
const $13f118fd299fdf03$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entityAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inputText"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraAssigneeAccountId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraReporterAccountId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "workspaceId"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAri"
        },
        {
            "kind": "Variable",
            "name": "inputText",
            "variableName": "inputText"
        },
        {
            "kind": "Variable",
            "name": "jiraAssigneeAccountId",
            "variableName": "jiraAssigneeAccountId"
        },
        {
            "kind": "Variable",
            "name": "jiraReporterAccountId",
            "variableName": "jiraReporterAccountId"
        },
        {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "workspaceId"
        }
    ], v6 = {
        "concreteType": "KnowledgeDiscoveryQueryApi",
        "kind": "LinkedField",
        "name": "knowledgeDiscovery",
        "plural": false,
        "selections": [
            {
                "args": v5 /*: any*/ ,
                "kind": "LinkedField",
                "name": "keyPhrases",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "keyPhrase"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "category"
                                    }
                                ]
                            }
                        ],
                        "type": "KnowledgeDiscoveryKeyPhraseConnection"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "message"
                            }
                        ],
                        "type": "QueryError"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "preloadAutohighlightsQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "args": v5 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "preloadAutohighlightsQuery_query"
                            }
                        ],
                        "type": "Query"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "autohighlightsQueryFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "preloadAutohighlightsQuery",
            "selections": [
                v6 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "2820a095ae7566b0d9e48bbf4b073a4b",
            "id": "c97859d83625338169d38498096c0e05b0ed89a36118e4c759690c6b37f1e1b3",
            "metadata": {},
            "name": "preloadAutohighlightsQuery",
            "operationKind": "query",
            "text": "query preloadAutohighlightsQuery($entityAri:String!,$workspaceId:String!,$jiraReporterAccountId:String,$jiraAssigneeAccountId:String,$inputText:KnowledgeDiscoveryKeyPhraseInputText){knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}},...preloadAutohighlightsQuery_query_3JqkOF}fragment preloadAutohighlightsQuery_query_3JqkOF on Query{knowledgeDiscovery{keyPhrases(entityAri:$entityAri,workspaceId:$workspaceId,jiraReporterAccountId:$jiraReporterAccountId,jiraAssigneeAccountId:$jiraAssigneeAccountId,inputText:$inputText)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}"
        }
    };
}();
$13f118fd299fdf03$var$node.hash = "dbfa17d85f2c22cbfd96f030d30cc29a";
var $13f118fd299fdf03$export$2e2bcd8739ae039 = $13f118fd299fdf03$var$node;
module.exports["default"] = $13f118fd299fdf03$export$2e2bcd8739ae039;

});

parcelRegister("aiN0O", function(module, exports) {
/**
 * @generated SignedSource<<83edf1fa840e1e2cbb5c5a5eac139f64>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $82a3921aaa089fdb$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entityAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "inputText"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraAssigneeAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jiraReporterAccountId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceId"
        }
    ],
    "kind": "Fragment",
    "name": "preloadAutohighlightsQuery_query",
    "selections": [
        {
            "concreteType": "KnowledgeDiscoveryQueryApi",
            "kind": "LinkedField",
            "name": "knowledgeDiscovery",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "entityAri",
                            "variableName": "entityAri"
                        },
                        {
                            "kind": "Variable",
                            "name": "inputText",
                            "variableName": "inputText"
                        },
                        {
                            "kind": "Variable",
                            "name": "jiraAssigneeAccountId",
                            "variableName": "jiraAssigneeAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jiraReporterAccountId",
                            "variableName": "jiraReporterAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "workspaceId",
                            "variableName": "workspaceId"
                        }
                    ],
                    "kind": "LinkedField",
                    "name": "keyPhrases",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "keyPhrase"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "category"
                                        }
                                    ]
                                }
                            ],
                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "message"
                                }
                            ],
                            "type": "QueryError"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$82a3921aaa089fdb$var$node.hash = "e217dd52ca3b019fe148e9b8034b7cd9";
var $82a3921aaa089fdb$export$2e2bcd8739ae039 = $82a3921aaa089fdb$var$node;
module.exports["default"] = $82a3921aaa089fdb$export$2e2bcd8739ae039;

});

parcelRegister("hu6Tz", function(module, exports) {

var $gw4Eo = parcelRequire("gw4Eo");

const $ceeb6fd84b3cae53$export$7625152cc0552e6b = ({ contentId: contentId, cloudId: cloudId, activationId: activationId, contentType: contentType })=>({
        entityAri: (0, $gw4Eo.getConfluenceContentAri)({
            siteId: cloudId,
            resourceType: contentType,
            resourceId: contentId,
            activationId: ''
        }),
        workspaceId: (0, $gw4Eo.getConfluenceContentAri)({
            siteId: cloudId,
            resourceType: 'workspace',
            resourceId: activationId,
            activationId: ''
        })
    });
module.exports["getAutohighlightsQueryVariables"] = $ceeb6fd84b3cae53$export$7625152cc0552e6b;

});

parcelRegister("gw4Eo", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $17a724fe65d90332$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ((0, $1ggpj.TYPES_WITH_ACTIVATIONID).includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $17a724fe65d90332$export$6a2f2c83863e9bfe;

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$e8b4d9d0d681efa4 = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name,
    (0, $1NBp8.EDIT_PAGE).name,
    (0, $1NBp8.EDIT_PAGE_V2).name
];
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).SLIDE
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$var$VERSION_HISTORY_CONTENT_TYPE_SET = {
    whiteboard: true,
    database: true,
    slide: true
};
const $2aa2bdb281c6889a$export$4c89eeb173e3fb0e = (contentType)=>!!contentType && Object.prototype.hasOwnProperty.call($2aa2bdb281c6889a$var$VERSION_HISTORY_CONTENT_TYPE_SET, contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["DELETE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$e8b4d9d0d681efa4;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["isVersionHistoryContentType"] = $2aa2bdb281c6889a$export$4c89eeb173e3fb0e;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    FeedbackSource["SLIDE"] = "Slide";
    FeedbackSource["TABS"] = "Tabs";
    FeedbackSource["CONTEXT_HUB"] = "Context Hub";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("llqlc", function(module, exports) {

var $jTt8P = parcelRequire("jTt8P");

function $64e7b9256d090f27$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $jTt8P.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}
module.exports["filter"] = $64e7b9256d090f27$export$3dea766d36a8935f;

});

parcelRegister("8pcS0", function(module, exports) {
const $6863c3b6124eda1d$export$2400baf28368a887 = {
    TEMPLATE: 'com.atlassian.confluence.template',
    MACRO_CORE: 'com.atlassian.confluence.macro.core',
    MIGRATION: 'com.atlassian.confluence.migration',
    // used for all macros that use Extension API and require references to be rendered
    MACRO_WITH_REFERENCES: 'com.atlassian.confluence.macro.with.references',
    NATIVE: 'com.atlassian.confluence.native'
};
const $6863c3b6124eda1d$export$8e1715e14eb19dce = {
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__'
};
const $6863c3b6124eda1d$export$a4903313a3329d59 = {
    UNSUPPORTED_EXTENSION: 'unsupportedExtension',
    INVALID_ADF: 'invalidAdf'
};
const $6863c3b6124eda1d$export$84b772adeaf6b683 = 'extension';
const $6863c3b6124eda1d$export$5da07912b4c30471 = 'inlineExtension';
const $6863c3b6124eda1d$export$2af94dcd5e74e23b = 'bodiedExtension';
const $6863c3b6124eda1d$export$43b3eb119fc177ea = 'multiBodiedExtension';
const $6863c3b6124eda1d$export$6e997645168087e1 = [
    {
        content: [],
        type: 'paragraph'
    }
];
const $6863c3b6124eda1d$export$87be616c9ded92ee = [
    {
        type: 'extensionFrame',
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    }
];
const $6863c3b6124eda1d$export$f9804d409e73a2cd = {
    TEMPLATE: 'variable',
    INLINE_EXTERNAL_IMAGE: 'inline-external-image',
    INLINE_MEDIA_IMAGE: 'inline-media-image',
    PRIVACY_MARK: 'privacy-mark',
    ANCHOR: 'anchor',
    PANEL: 'panel',
    SECTION: 'section',
    CHEESE: 'cheese',
    COLUMN: 'column',
    CONTENT_BY_LABEL: 'contentbylabel',
    CONTENT_BY_USER: 'content-by-user',
    CREATE_SPACE_BUTTON: 'create-space-button',
    FAVORITE_PAGES: 'favpages',
    GLOBAL_REPORTS: 'global-reports',
    IM_PRESENCE: 'im',
    LOREMIPSUM: 'loremipsum',
    NAVIGATION_MAP: 'navmap',
    PAGE_TREE: 'pagetree',
    RECENTLY_UPDATED: 'recently-updated',
    RECENTLY_USED_LABELS: 'recently-used-labels',
    SEARCH: 'search',
    SPACE_DETAILS: 'space-details',
    INVALID: '__confluenceADFMigrationUnsupportedContentInternalExtension__',
    REDACTED_MACRO_PLACEHOLDER: 'redactedMacroPlaceholder',
    TOC: 'toc',
    LIVE_SEARCH: 'livesearch',
    CREATE_FROM_TEMPLATE: 'create-from-template',
    CONFLUENCE_DATABASES: 'database-extension',
    DETAILS: 'details',
    DETAILS_SUMMARY: 'detailssummary',
    EXPAND: 'expand',
    EXCERPT: 'excerpt',
    EXCERPT_INCLUDE: 'excerpt-include',
    CHILDREN: 'children',
    PROFILE_PICTURE: 'profile-picture',
    PROFILE: 'profile',
    BLOG_POSTS: 'blog-posts',
    INCLUDE: 'include',
    JIRA: 'jira',
    JIRACHART: 'jirachart',
    LEGACY_CONTENT: 'legacy-content',
    TEAM_CALENDARS: 'calendar',
    CONTRIBUTORS: 'contributors',
    IFRAME: 'iframe',
    LIST_LABELS: 'listlabels',
    POPULAR_LABELS: 'popular-labels',
    TASKS_REPORT_MACRO: 'tasks-report-macro',
    NATIVE_EMBED: 'native-embed',
    HIDE: 'hide',
    PAGE_TREE_SEARCH: 'pagetreesearch',
    WIDGET: 'widget',
    CONTENT_REPORT_TABLE: 'content-report-table',
    CHANGE_HISTORY: 'change-history',
    VIEWPDF: 'viewpdf',
    ATTACHMENTS: 'attachments',
    AGENT_MANAGED_BLOCK: 'agent-managed-block',
    VIEWXLS: 'viewxls'
};
const $6863c3b6124eda1d$export$52ab8a936196819e = [
    'toc',
    'expand',
    'trello-board',
    'status',
    'jiraroadmap'
];
const $6863c3b6124eda1d$export$ab3b6d629a99a505 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TOC,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ANCHOR,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIVE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXPAND,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CREATE_FROM_TEMPLATE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.REDACTED_MACRO_PLACEHOLDER,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONFLUENCE_DATABASES,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE_PICTURE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PROFILE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.ATTACHMENTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.BLOG_POSTS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TEAM_CALENDARS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTRIBUTORS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.IFRAME,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.POPULAR_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.LIST_LABELS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE_SEARCH,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.WIDGET,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_REPORT_TABLE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHANGE_HISTORY,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWPDF,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.TASKS_REPORT_MACRO,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.VIEWXLS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.HIDE
];
const $6863c3b6124eda1d$export$77fa9372f916e938 = new Set([
    $6863c3b6124eda1d$export$84b772adeaf6b683,
    $6863c3b6124eda1d$export$5da07912b4c30471,
    $6863c3b6124eda1d$export$2af94dcd5e74e23b
]);
const $6863c3b6124eda1d$export$12c3fa6b8a339bbd = 255;
const $6863c3b6124eda1d$export$3b4caad8695d985a = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.EXCERPT_INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CONTENT_BY_LABEL,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.RECENTLY_UPDATED
];
const $6863c3b6124eda1d$export$b700e56f703b191 = [
    $6863c3b6124eda1d$export$f9804d409e73a2cd.CHILDREN,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.PAGE_TREE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.INCLUDE,
    $6863c3b6124eda1d$export$f9804d409e73a2cd.DETAILS_SUMMARY
];
module.exports["EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2400baf28368a887;
module.exports["MIGRATION_EXTENSION_KEYS"] = $6863c3b6124eda1d$export$8e1715e14eb19dce;
module.exports["REGULAR_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$84b772adeaf6b683;
module.exports["INLINE_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$5da07912b4c30471;
module.exports["BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$2af94dcd5e74e23b;
module.exports["MULTI_BODIED_EXTENSION_TYPE"] = $6863c3b6124eda1d$export$43b3eb119fc177ea;
module.exports["EMPTY_ADF_CONTENT"] = $6863c3b6124eda1d$export$6e997645168087e1;
module.exports["MULTI_BODIED_INITIAL_CONTENT"] = $6863c3b6124eda1d$export$87be616c9ded92ee;
module.exports["EXTENSION_KEY"] = $6863c3b6124eda1d$export$f9804d409e73a2cd;
module.exports["allowedMacrosForInsertMenu"] = $6863c3b6124eda1d$export$52ab8a936196819e;
module.exports["serverRenderedExtensions"] = $6863c3b6124eda1d$export$ab3b6d629a99a505;
module.exports["supportedExtensions"] = $6863c3b6124eda1d$export$77fa9372f916e938;
module.exports["MAX_ATLASSIAN_ALLOWED_FRAGMENT_LENGTH"] = $6863c3b6124eda1d$export$12c3fa6b8a339bbd;
module.exports["MODERENIZED_MACRO_KEYS"] = $6863c3b6124eda1d$export$3b4caad8695d985a;
module.exports["MACROS_WITH_LIVE_DOC_REFERENCE"] = $6863c3b6124eda1d$export$b700e56f703b191;

});

parcelRegister("6mEZ3", function(module, exports) {

var $aMlgD = parcelRequire("aMlgD");


var $8pcS0 = parcelRequire("8pcS0");


var $juS6m = parcelRequire("juS6m");

function $b31b733ebe52245a$export$d80a64b0df71385c(params) {
    if (params.hasOwnProperty('')) return $b31b733ebe52245a$var$getParamValue(params['']) || '';
    return '';
}
function $b31b733ebe52245a$export$1d258479ae5735d7(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (value !== '') curr[key] = value;
        return curr;
    }, {});
}
function $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams = {}) {
    return Object.keys(macroParams).reduce((curr, key)=>{
        const value = $b31b733ebe52245a$var$getParamValue(macroParams[key]);
        if (key !== '' || value !== '') curr[key] = {
            value: value
        };
        return curr;
    }, {});
}
// does every key have a value key inside?
function $b31b733ebe52245a$var$getParamValue(macroParam) {
    if (macroParam?.hasOwnProperty('value')) return macroParam.value;
    return macroParam;
}
function $b31b733ebe52245a$export$a113856a79fa82ca(node) {
    const { type: type, content: content, attrs: attrs, fragmentLocalId: fragmentLocalId, ...rest } = node;
    // There is a discrepancy in docs and implementation of different parts of the code
    // https://stash.atlassian.com/projects/CONFCLOUD/repos/confluence-frontend/pull-requests/30727/overview?commentId=4917242
    const fieldWithMacroParameters = attrs?.parameters ? attrs : rest;
    const { macroParams: macroParams } = fieldWithMacroParameters?.parameters || {};
    const adf = {
        attrs: fieldWithMacroParameters,
        type: type
    };
    if (fragmentLocalId) adf.marks = [
        {
            attrs: {
                localId: fragmentLocalId,
                name: null
            },
            type: 'fragment'
        }
    ];
    // confluence needs to be updated to get rid of bodyType as per
    // https://product-fabric.atlassian.net/wiki/spaces/E/pages/252351342/Splitting+Extension+node+into+three+nodes
    // but for now, the beackend requires it to be sent
    adf.attrs.bodyType = 'none';
    if (type === 'bodiedExtension') {
        adf.content = content && content.length > 0 ? content : [];
        adf.attrs.bodyType = 'rich';
    }
    const keys = Object.keys(adf.attrs);
    keys.forEach((key)=>{
        if (adf.attrs[key] === undefined || adf.attrs[key] === null) delete adf.attrs[key];
    });
    if (adf.attrs?.parameters) adf.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return adf;
}
function $b31b733ebe52245a$export$f700a29bb3cb52bb(node) {
    const { attrs: attrs, content: content, type: type } = node;
    const { macroParams: macroParams } = attrs.parameters;
    // MacroAttributes and ADNode are pretty much the same type, but
    // MacroAttributes requires either "extension", "bodiedExtension", "multiBodiedExtension" or
    // "inlineExtension". This check is so we can pass the ADNode as a
    // MacroAttributes, but will default to "extension" if given an unexpected
    // value.
    let extensionType = (0, $8pcS0.REGULAR_EXTENSION_TYPE);
    if ([
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE),
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.INLINE_EXTENSION_TYPE)
    ].indexOf(type) >= 0) extensionType = type;
    const macroAttributes = {
        type: extensionType,
        attrs: attrs
    };
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    if (content) macroAttributes.content = content;
    macroAttributes.attrs.parameters.macroParams = $b31b733ebe52245a$export$80a8efbe6e0eac1d(macroParams);
    return macroAttributes;
}
async function $b31b733ebe52245a$export$9ebfba63bbffe824(from, to, body, contentIdContext) {
    const queryData = await (0, $juS6m.experimentalContentBodyConvertQuery)(from, to, body, contentIdContext);
    return queryData.experimentalContentBodyConvert?.value;
}
async function $b31b733ebe52245a$export$4f223f6f161fb687(node, intl) {
    const legacyMacro = await $b31b733ebe52245a$export$dc6dc202968f1e29(node);
    legacyMacro.title = node.attrs?.parameters?.macroMetadata?.title;
    if (intl) {
        const description = (0, $aMlgD.getMacroDescriptionOverride)(node.attrs.extensionKey, intl);
        if (description) legacyMacro.description = description;
    }
    return legacyMacro;
}
async function $b31b733ebe52245a$export$dc6dc202968f1e29(node) {
    // just return the node if it's already in legacy format;
    if (node.hasOwnProperty('name') && !node.hasOwnProperty('attrs')) return Promise.resolve(node);
    const adNode = node;
    const { attrs: attrs } = adNode;
    const { extensionKey: extensionKey, parameters: parameters } = attrs || {
        extensionKey: null,
        parameters: {
            macroParams: {},
            macroMetadata: {
                schemaVersion: null
            }
        }
    };
    const { macroParams: macroParams, macroMetadata: macroMetadata } = parameters;
    const type = node.type;
    const name = extensionKey || '';
    const params = $b31b733ebe52245a$export$1d258479ae5735d7(macroParams || {});
    const defaultParameterValue = $b31b733ebe52245a$export$d80a64b0df71385c(macroParams || {});
    const schemaVersion = macroMetadata && macroMetadata.schemaVersion || '1';
    if (!adNode.content || adNode.content.length === 0) return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: ''
    };
    const responseBody = await $b31b733ebe52245a$export$9ebfba63bbffe824('atlas_doc_format', 'storage', JSON.stringify({
        type: 'doc',
        content: adNode.content,
        version: 1
    }));
    return {
        type: type,
        name: name,
        params: params,
        defaultParameterValue: defaultParameterValue,
        schemaVersion: schemaVersion,
        body: responseBody || ''
    };
}
function $b31b733ebe52245a$export$9ca244251d53bbfc(node) {
    const parameters = {
        ...node?.parameters?.macroParams
    };
    if (parameters.__bodyContent) delete parameters.__bodyContent;
    // CEMS-300: To provide a consistent parameter to macro vendors for
    // both the Tiny and Fabric editors, we unwrap the parameter values
    return JSON.stringify($b31b733ebe52245a$export$1d258479ae5735d7(parameters));
}
module.exports["getDefaultParamValue"] = $b31b733ebe52245a$export$d80a64b0df71385c;
module.exports["unwrapMacroParams"] = $b31b733ebe52245a$export$1d258479ae5735d7;
module.exports["wrapMacroParams"] = $b31b733ebe52245a$export$80a8efbe6e0eac1d;
module.exports["extensionToADF"] = $b31b733ebe52245a$export$a113856a79fa82ca;
module.exports["formatAsMacroAttributes"] = $b31b733ebe52245a$export$f700a29bb3cb52bb;
module.exports["convertBody"] = $b31b733ebe52245a$export$9ebfba63bbffe824;
module.exports["formatAsLegacyMacroWithOverrides"] = $b31b733ebe52245a$export$4f223f6f161fb687;
module.exports["getParametersString"] = $b31b733ebe52245a$export$9ca244251d53bbfc;

});

parcelRegister("aMlgD", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $lPJNC = parcelRequire("lPJNC");


var $l0P92 = parcelRequire("l0P92");


var $12FeT = parcelRequire("12FeT");


var $8pcS0 = parcelRequire("8pcS0");

const $123431e233f03ed6$var$i18n = (0, $kSwu1.defineMessages)({
    anchorMacroTitle: {
        id: "fabric-extension-lib.anchor.title",
        defaultMessage: "Anchor link"
    },
    anchorMacroDescription: {
        id: "fabric-extension-lib.anchor.description",
        defaultMessage: "Create a direct link to any section"
    },
    opsgenieAttribution: {
        id: "fabric-extension-lib.quick-insert.preview-attribution.opsgenie",
        defaultMessage: "Opsgenie"
    },
    childrenMacroTitle: {
        id: "fabric-extension-lib.children.live-docs.title",
        defaultMessage: "Child items"
    },
    childrenMacroDescription: {
        id: "fabric-extension-lib.children.live-docs.description",
        defaultMessage: "List content beneath pages or live docs"
    },
    detailsMacroTitle: {
        id: "fabric-extension-lib.details.live-docs.title",
        defaultMessage: "Content properties"
    },
    detailsMacroDescription: {
        id: "fabric-extension-lib.details.live-docs.description",
        defaultMessage: "Capture summary information for content reports"
    },
    pageTreeMacroTitle: {
        id: "fabric-extension-lib.pagetree.live-docs.title",
        defaultMessage: "Content tree"
    },
    pageTreeMacroDescription: {
        id: "fabric-extension-lib.pagetree.live-docs.description",
        defaultMessage: "Display a full or partial content tree"
    },
    includeMacroTitle: {
        id: "fabric-extension-lib.include.live-docs.title",
        defaultMessage: "Include content"
    },
    includeMacroDescription: {
        id: "fabric-extension-lib.include.live-docs.description",
        defaultMessage: "Embed a full page or live doc"
    },
    detailsSummaryMacroTitle: {
        id: "fabric-extension-lib.details-summary.live-docs.title",
        defaultMessage: "Content properties report"
    },
    detailsSummaryMacroDescription: {
        id: "fabric-extension-lib.details-summary.live-docs.description",
        defaultMessage: "Compile content summaries by label"
    },
    jiraMacroTitle: {
        id: "fabric-extension-lib.jira.title",
        defaultMessage: "Jira Data Center"
    },
    jiraMacroDescription: {
        id: "fabric-extension-lib.jira.description",
        defaultMessage: "Display Data Center work items using JQL"
    }
});
const $123431e233f03ed6$export$9f32ba550957708c = (preview, intl)=>{
    const { attribution: attribution, ...previewWithoutAttribution } = preview;
    if (!attribution) return previewWithoutAttribution;
    return {
        ...previewWithoutAttribution,
        attribution: {
            name: intl.formatMessage(attribution.message),
            ...attribution.icon ? {
                icon: attribution.icon
            } : {}
        }
    };
};
const $123431e233f03ed6$var$macroQuickInsertPreviewOverrides = {
    iframe: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI8.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLM.png'
        }
    },
    'blog-posts': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIU.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLJ.png'
        }
    },
    'change-history': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIA.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMK.png'
        }
    },
    children: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIP.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVME.png'
        }
    },
    details: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIQ.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLR.png'
        }
    },
    detailssummary: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIS.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM9.png'
        }
    },
    'content-report-table': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI6.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMC.png'
        }
    },
    pagetree: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIV.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNC.png'
        }
    },
    contributors: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ0.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL1.png'
        }
    },
    decisionreport: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHF.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMF.png'
        }
    },
    contentbylabel: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIX.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKY.png'
        }
    },
    listlabels: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHS.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMI.png'
        }
    },
    livesearch: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIL.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL4.png'
        }
    },
    pagetreesearch: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK0.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMB.png'
        }
    },
    'popular-labels': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ4.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKR.png'
        }
    },
    'questionslist-macro-native': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHQ.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMH.png'
        }
    },
    'recently-updated': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ5.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKX.png'
        }
    },
    'tasks-report-macro': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHJ.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL3.png'
        }
    },
    calendar: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ8.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM5.png'
        }
    },
    userlister: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ3.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLH.png'
        }
    },
    profile: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI1.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVML.png'
        }
    },
    excerpt: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJT.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLX.png'
        }
    },
    'excerpt-include': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJR.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVN9.png'
        }
    },
    include: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHV.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNP.png'
        }
    },
    jirachart: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionJira,
            icon: (0, $12FeT.JiraAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12P300.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12P2ZZ.png'
        }
    },
    jira: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionJira,
            icon: (0, $12FeT.JiraAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJW.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVND.png'
        }
    },
    portfolioforjiraplan: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionJira,
            icon: (0, $12FeT.JiraAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJX.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNF.png'
        }
    },
    'opsgenie-incident-timeline-eu-macro': {
        attribution: {
            message: $123431e233f03ed6$var$i18n.opsgenieAttribution
        }
    },
    'sharelinks-urlmacro': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHZ.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL7.png'
        }
    },
    'toc-zone': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJS.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVNE.png'
        }
    },
    viewpdf: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12P2ZX.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12P2ZY.png'
        }
    },
    viewxls: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionMicrosoft
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIW.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL2.png'
        }
    },
    'profile-picture': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIN.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLS.png'
        }
    },
    anchor: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHH.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKZ.png'
        }
    },
    toc: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJG.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMX.png'
        }
    },
    'create-from-template': {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OZ55.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OZ54.png'
        }
    },
    widget: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        },
        image: {
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK7.png',
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL9.png'
        }
    },
    roadmap: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        }
    },
    attachments: {
        attribution: {
            message: (0, $lPJNC.messages).previewAttributionConfluence,
            icon: (0, $l0P92.ConfluenceAttributionIcon)
        }
    }
};
const $123431e233f03ed6$export$4752f1531f8f7b08 = (extensionKey, intl)=>{
    const preview = $123431e233f03ed6$var$macroQuickInsertPreviewOverrides[extensionKey];
    return preview ? $123431e233f03ed6$export$9f32ba550957708c(preview, intl) : undefined;
};
const $123431e233f03ed6$export$f37635a5fac054ef = (extensionKey, intl)=>{
    // Override new macro title for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroTitle);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroTitle);
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroTitle);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroTitle);
    }
    return null;
};
const $123431e233f03ed6$export$d82ae1b0fd434097 = (extensionKey, intl)=>{
    // Override new macro title and description for anchor macro
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).ANCHOR) return intl.formatMessage($123431e233f03ed6$var$i18n.anchorMacroDescription);
    if (extensionKey === (0, $8pcS0.EXTENSION_KEY).JIRA) return intl.formatMessage($123431e233f03ed6$var$i18n.jiraMacroDescription);
    // PGXT-7617 Update macro strings referencing page content types to also include live docs content types
    if ((0, $8pcS0.MACROS_WITH_LIVE_DOC_REFERENCE).includes(extensionKey)) switch(extensionKey){
        case (0, $8pcS0.EXTENSION_KEY).CHILDREN:
            return intl.formatMessage($123431e233f03ed6$var$i18n.childrenMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).PAGE_TREE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.pageTreeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).INCLUDE:
            return intl.formatMessage($123431e233f03ed6$var$i18n.includeMacroDescription);
        case (0, $8pcS0.EXTENSION_KEY).DETAILS_SUMMARY:
            return intl.formatMessage($123431e233f03ed6$var$i18n.detailsSummaryMacroDescription);
    }
    return null;
};
module.exports["localizeQuickInsertPreview"] = $123431e233f03ed6$export$9f32ba550957708c;
module.exports["getMacroQuickInsertPreviewOverride"] = $123431e233f03ed6$export$4752f1531f8f7b08;
module.exports["getMacroTitleOverride"] = $123431e233f03ed6$export$f37635a5fac054ef;
module.exports["getMacroDescriptionOverride"] = $123431e233f03ed6$export$d82ae1b0fd434097;

});

parcelRegister("l0P92", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $b70fc362a02fef99$export$f5752395a477e5ed = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.confluenceIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.confluenceIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["ConfluenceAttributionIcon"] = $b70fc362a02fef99$export$f5752395a477e5ed;

});

parcelRegister("kp580", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bb0b17085479d6a47c0256168de66f61>>
 * @codegenCommand afm workspace @atlaskit/logo generate:components
 */ const $eec4d9b8943404d8$export$82d1529631ebf0fd = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$f936b2d6e392668e = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z'/> </svg> ";
const $eec4d9b8943404d8$export$ef4515a2b2e64fb9 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z'/> </svg> ";
const $eec4d9b8943404d8$export$e46fc5b9f36b0a2a = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727' clip-rule='evenodd'/> <path fill='%23101214' d='M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z'/> </svg> ";
const $eec4d9b8943404d8$export$937778b9dd7a3235 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z'/> </svg> ";
const $eec4d9b8943404d8$export$d994760fc7f4d251 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578'/> </svg> ";
const $eec4d9b8943404d8$export$4ed1e309cbc9944e = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582'/> </svg> ";
const $eec4d9b8943404d8$export$f082a360c4afba79 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$8d3a8a08ef6ddfb7 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 82 82'> <path fill='%2394c748' d='M0 20.5C0 9.178 9.178 0 20.5 0h41C72.822 0 82 9.178 82 20.5v41C82 72.822 72.822 82 61.5 82h-41C9.178 82 0 72.822 0 61.5z'/> <path fill='%23101214' d='M24.6 23.78h24.6v26.24H24.6z'/> <path fill='%23101214' fill-rule='evenodd' d='M36.762 56.548c-10.927 0-19.785-8.858-19.785-19.786 0-10.927 8.858-19.785 19.785-19.785 10.928 0 19.786 8.858 19.786 19.785 0 3.55-.934 6.88-2.57 9.76l11.624 11.625-7.533 7.533-11.647-11.646a19.7 19.7 0 0 1-9.66 2.514m-.933-32.014-.828 2.103c-1.175 2.987-1.763 4.481-2.848 5.606s-2.557 1.765-5.5 3.048l-1.26.549v1.74l1.26.548c2.943 1.282 4.415 1.924 5.5 3.048s1.673 2.619 2.849 5.607l.827 2.103h1.74l.827-2.104c1.176-2.987 1.764-4.481 2.848-5.606 1.085-1.124 2.557-1.766 5.5-3.048l1.26-.549v-1.74l-1.26-.548c-2.943-1.283-4.415-1.924-5.5-3.048s-1.672-2.619-2.848-5.606l-.828-2.103z' clip-rule='evenodd'/> <g fill='%2394c748' clip-path='url(%23clip0_458_334619)'> <path d='m33.96 42.3-5.4-5.4 5.4-5.4-2.32-2.32-7.72 7.72 7.72 7.72zm5.88-10.8 5.4 5.4-5.4 5.4 2.32 2.32 7.72-7.72-7.72-7.72z'/> </g> <defs> <clipPath id='clip0_458_334619'> <path fill='%23fff' d='M17.22 17.22h39.36v39.36H17.22z'/> </clipPath> </defs> </svg> ";
const $eec4d9b8943404d8$export$591e8b3773b35267 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M6.75 19V5h10.5v14h-3.937v-3.062h-2.625V19zM9.375 8.063h1.75V6.75h-1.75zm3.5 0h1.75V6.75h-1.75zm-1.75 3.062h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75zm5.25-3.063h-1.75V9.813h1.75zm-1.75 3.063h1.75v-1.313h-1.75z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$a3743ca7417fb23c = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z'/> <path fill='%23101214' d='M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z'/> </svg> ";
const $eec4d9b8943404d8$export$c7c3bc01199c13a4 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617'/> </svg> ";
const $eec4d9b8943404d8$export$d522b359cb8c5c04 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673'/> </svg> ";
const $eec4d9b8943404d8$export$52ddff92dfaa8b68 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433'/> </svg> ";
const $eec4d9b8943404d8$export$9fbf2bb44326bb19 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$e293cb595239063c = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z'/> </svg> ";
const $eec4d9b8943404d8$export$d9455021fb3d272f = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <path fill='%2394c748' d='M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z'/> <path fill='%23101214' d='m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z'/> </svg> ";
const $eec4d9b8943404d8$export$3ed6243f17a53ae7 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <rect width='48' height='48' fill='%23c97cf4' rx='12'/> <path fill='%23101214' d='M20 19h5v11h-5zm7-9h5v28h-5zm7 6h5v16h-5zm-21 0h5v16h-5zm-7 5h5v7H6z'/> </svg> ";
const $eec4d9b8943404d8$export$2837c3a55abaa285 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z'/> </svg> ";
const $eec4d9b8943404d8$export$51f93e7b4b9eb293 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0'/> <path fill='%23101214' fill-rule='evenodd' d='M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$eb29548f99467d60 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649'/> </svg> ";
const $eec4d9b8943404d8$export$2aba1ca138d7bd07 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649'/> </svg> ";
const $eec4d9b8943404d8$export$2e2deae5fbafd37b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z'/> </svg> ";
const $eec4d9b8943404d8$export$c7a8f12525e3fb68 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 32 32'> <g clip-path='url(%23clip0_95164_16219)'> <path fill='%23dddee1' d='M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z'/> <g clip-path='url(%23clip1_95164_16219)'> <path fill='%23101214' fill-rule='evenodd' d='M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z' clip-rule='evenodd'/> </g> </g> <defs> <clipPath id='clip0_95164_16219'> <path fill='%23fff' d='M0 0h32v32H0z'/> </clipPath> <clipPath id='clip1_95164_16219'> <path fill='%23fff' d='M2 2h28v28H2z'/> </clipPath> </defs> </svg> ";
const $eec4d9b8943404d8$export$b24c6e7728e33086 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 48 48'> <path fill='%23dddee1' d='M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z'/> <path fill='%23101214' d='M36.5 37.5h-25v-4h25zM18.25 31h-6.5v-9h6.5zm9 0h-6.5V18h6.5zm2.53-13.93c1.15.51 1.46.72 1.66.93l.1.12c.24.3.47.82 1.12 2.47l.97 2.49h2.61V31h-6.5V17.06zm6.7-8.85c.68 1.73 1.01 2.59 1.64 3.24.62.65 1.47 1.02 3.16 1.76l.73.32v1.01l-.72.32q-.53.23-.96.43c-1.08.49-1.71.82-2.2 1.34l-.11.12c-.52.6-.85 1.39-1.4 2.82l-.12.3-.5 1.2h-1l-.48-1.22c-.25-.65-.46-1.17-.65-1.61-.32-.73-.6-1.22-.99-1.63-.5-.53-1.16-.87-2.28-1.37q-.26-.12-.57-.25l-.31-.14-.72-.32v-1.01l.73-.32c.61-.27 1.11-.49 1.53-.69l.18-.09q.11-.05.21-.11l.16-.09a7 7 0 0 0 .33-.19 5 5 0 0 0 .29-.2 4 4 0 0 0 .45-.39c.62-.65.96-1.51 1.64-3.24L35 7h1z'/> </svg> ";
const $eec4d9b8943404d8$export$817524b4a4c71959 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 55 55'> <path fill='%231868db' d='M24.519.844a6.3 6.3 0 0 1 6.3 0l18.37 10.601a6.3 6.3 0 0 1 3.15 5.454V38.1c0 2.25-1.2 4.33-3.15 5.454l-18.37 10.601a6.3 6.3 0 0 1-6.3 0l-18.37-10.6a6.3 6.3 0 0 1-3.15-5.454V16.9c0-2.25 1.2-4.33 3.15-5.454z'/> <path fill='%23fff' d='M20.71 34.657h-2.705C13.926 34.657 11 32.16 11 28.5h14.543c.754 0 1.241.536 1.241 1.294v14.634c-3.635 0-6.074-2.944-6.074-7.05zm7.183-7.272h-2.705c-4.079 0-7.005-2.454-7.005-6.113h14.542c.754 0 1.286.491 1.286 1.25v14.634c-3.635 0-6.118-2.945-6.118-7.05zm7.227-7.228h-2.705c-4.079 0-7.005-2.498-7.005-6.157h14.543c.753 0 1.241.535 1.241 1.25v14.633c-3.636 0-6.074-2.944-6.074-7.049z'/> </svg> ";
const $eec4d9b8943404d8$export$645368f1ea0478bc = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fff' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5'/> <path stroke='%23dddee1' d='M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z'/> <path fill='%231868db' d='M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z'/> </svg> ";
const $eec4d9b8943404d8$export$18c65aa2927f3995 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23c97cf4' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z'/> </svg> ";
const $eec4d9b8943404d8$export$8a1ee2e50fe5beb1 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 25 24'> <path fill='%23fff' d='M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5'/> <path stroke='%23dddee1' d='M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z'/> <path fill='%231868db' d='M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z'/> </svg> ";
const $eec4d9b8943404d8$export$b90ef39cc7d9d158 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z'/> </svg> ";
const $eec4d9b8943404d8$export$fa286aa7e20bed9b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z'/> </svg> ";
const $eec4d9b8943404d8$export$668450ac5134d2b8 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23625df5' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302'/> </svg> ";
const $eec4d9b8943404d8$export$ce29d3d34b2cdd71 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302'/> </svg> ";
const $eec4d9b8943404d8$export$24d80805366b7b8f = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M11.13 5.88H5.88v5.25h5.25zm0 7H5.88v5.25h5.25zm1.75-7h5.25v5.25h-5.25zm5.25 7h-5.25v5.25h5.25z'/> </svg> ";
const $eec4d9b8943404d8$export$a07965903d0d8925 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848'/> </svg> ";
const $eec4d9b8943404d8$export$5d8aa0e5e461a369 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$6248e4308e35c81 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z'/> <path fill='%23fff' d='M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691'/> </svg> ";
const $eec4d9b8943404d8$export$5bde95973ddbe69b = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678' clip-rule='evenodd'/> <path fill='%23101214' fill-rule='evenodd' d='M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$238fafeb4135d57 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%2394c748' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z'/> <path fill='%23101214' d='M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75'/> </svg> ";
const $eec4d9b8943404d8$export$494586f00e0959f0 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$d82a05c5cfbe1aa1 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231868db' fill-rule='evenodd' d='m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z' clip-rule='evenodd'/> <path fill='%236a9a23' fill-rule='evenodd' d='m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z' clip-rule='evenodd'/> <path fill='%23af59e1' fill-rule='evenodd' d='m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354' clip-rule='evenodd'/> <path fill='%23fca700' fill-rule='evenodd' d='M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$8687ffcdea58e000 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$dc9f14a5d9a626e2 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23ffc716' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68'/> </svg> ";
const $eec4d9b8943404d8$export$d2c4cddab147c0da = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z' clip-rule='evenodd'/> <path fill='%23101214' d='M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z'/> </svg> ";
const $eec4d9b8943404d8$export$eaf28ddd8a75ca21 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23fb9700' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' fill-rule='evenodd' d='m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786' clip-rule='evenodd'/> </svg> ";
const $eec4d9b8943404d8$export$2475d3c354c72640 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%23dddee1' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23101214' d='M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63'/> </svg> ";
const $eec4d9b8943404d8$export$a1ac7613cb802f12 = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 24 24'> <path fill='%231558bc' d='M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z'/> <path fill='%23fff' d='M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z'/> </svg> ";
const $eec4d9b8943404d8$export$750778568a97222d = {
    admin: $eec4d9b8943404d8$export$82d1529631ebf0fd,
    align: $eec4d9b8943404d8$export$f936b2d6e392668e,
    analytics: $eec4d9b8943404d8$export$ef4515a2b2e64fb9,
    assets: $eec4d9b8943404d8$export$e46fc5b9f36b0a2a,
    bamboo: $eec4d9b8943404d8$export$937778b9dd7a3235,
    bitbucketDataCenter: $eec4d9b8943404d8$export$d994760fc7f4d251,
    bitbucket: $eec4d9b8943404d8$export$4ed1e309cbc9944e,
    chat: $eec4d9b8943404d8$export$f082a360c4afba79,
    codeSearch: $eec4d9b8943404d8$export$8d3a8a08ef6ddfb7,
    companyHub: $eec4d9b8943404d8$export$591e8b3773b35267,
    compass: $eec4d9b8943404d8$export$a3743ca7417fb23c,
    confluenceDataCenter: $eec4d9b8943404d8$export$c7c3bc01199c13a4,
    confluence: $eec4d9b8943404d8$export$d522b359cb8c5c04,
    crowd: $eec4d9b8943404d8$export$52ddff92dfaa8b68,
    customLink: $eec4d9b8943404d8$export$9fbf2bb44326bb19,
    customerServiceManagement: $eec4d9b8943404d8$export$e293cb595239063c,
    dx: $eec4d9b8943404d8$export$d9455021fb3d272f,
    feedback: $eec4d9b8943404d8$export$3ed6243f17a53ae7,
    focus: $eec4d9b8943404d8$export$2837c3a55abaa285,
    goals: $eec4d9b8943404d8$export$51f93e7b4b9eb293,
    guardDetect: $eec4d9b8943404d8$export$eb29548f99467d60,
    guard: $eec4d9b8943404d8$export$2aba1ca138d7bd07,
    home: $eec4d9b8943404d8$export$2e2deae5fbafd37b,
    hub: $eec4d9b8943404d8$export$c7a8f12525e3fb68,
    insights: $eec4d9b8943404d8$export$b24c6e7728e33086,
    jiraCodingAgent: $eec4d9b8943404d8$export$817524b4a4c71959,
    jiraDataCenter: $eec4d9b8943404d8$export$645368f1ea0478bc,
    jiraProductDiscovery: $eec4d9b8943404d8$export$18c65aa2927f3995,
    jiraServiceManagementDataCenter: $eec4d9b8943404d8$export$8a1ee2e50fe5beb1,
    jiraServiceManagement: $eec4d9b8943404d8$export$b90ef39cc7d9d158,
    jira: $eec4d9b8943404d8$export$fa286aa7e20bed9b,
    loomInternal: $eec4d9b8943404d8$export$668450ac5134d2b8,
    loom: $eec4d9b8943404d8$export$ce29d3d34b2cdd71,
    moreAtlassianApps: $eec4d9b8943404d8$export$24d80805366b7b8f,
    opsgenie: $eec4d9b8943404d8$export$a07965903d0d8925,
    projects: $eec4d9b8943404d8$export$5d8aa0e5e461a369,
    rovoClassic: $eec4d9b8943404d8$export$6248e4308e35c81,
    rovoDevAgent: $eec4d9b8943404d8$export$5bde95973ddbe69b,
    rovoDev: $eec4d9b8943404d8$export$238fafeb4135d57,
    rovoHex: $eec4d9b8943404d8$export$494586f00e0959f0,
    rovo: $eec4d9b8943404d8$export$d82a05c5cfbe1aa1,
    search: $eec4d9b8943404d8$export$8687ffcdea58e000,
    statuspage: $eec4d9b8943404d8$export$dc9f14a5d9a626e2,
    studio: $eec4d9b8943404d8$export$d2c4cddab147c0da,
    talent: $eec4d9b8943404d8$export$eaf28ddd8a75ca21,
    teams: $eec4d9b8943404d8$export$2475d3c354c72640,
    trello: $eec4d9b8943404d8$export$a1ac7613cb802f12
};
module.exports["assetsIcon"] = $eec4d9b8943404d8$export$e46fc5b9f36b0a2a;
module.exports["bitbucketIcon"] = $eec4d9b8943404d8$export$4ed1e309cbc9944e;
module.exports["confluenceIcon"] = $eec4d9b8943404d8$export$d522b359cb8c5c04;
module.exports["feedbackIcon"] = $eec4d9b8943404d8$export$3ed6243f17a53ae7;
module.exports["focusIcon"] = $eec4d9b8943404d8$export$2837c3a55abaa285;
module.exports["goalsIcon"] = $eec4d9b8943404d8$export$51f93e7b4b9eb293;
module.exports["homeIcon"] = $eec4d9b8943404d8$export$2e2deae5fbafd37b;
module.exports["jiraProductDiscoveryIcon"] = $eec4d9b8943404d8$export$18c65aa2927f3995;
module.exports["jiraServiceManagementIcon"] = $eec4d9b8943404d8$export$b90ef39cc7d9d158;
module.exports["jiraIcon"] = $eec4d9b8943404d8$export$fa286aa7e20bed9b;
module.exports["loomIcon"] = $eec4d9b8943404d8$export$ce29d3d34b2cdd71;
module.exports["projectsIcon"] = $eec4d9b8943404d8$export$5d8aa0e5e461a369;
module.exports["rovoHexIcon"] = $eec4d9b8943404d8$export$494586f00e0959f0;
module.exports["studioIcon"] = $eec4d9b8943404d8$export$d2c4cddab147c0da;
module.exports["talentIcon"] = $eec4d9b8943404d8$export$eaf28ddd8a75ca21;
module.exports["teamsIcon"] = $eec4d9b8943404d8$export$2475d3c354c72640;
module.exports["trelloIcon"] = $eec4d9b8943404d8$export$a1ac7613cb802f12;

});

parcelRegister("12FeT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $da086be7599055eb$export$5a5b2410f606869 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.jiraIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.jiraIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["JiraAttributionIcon"] = $da086be7599055eb$export$5a5b2410f606869;

});

parcelRegister("juS6m", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");

const $3a3d352db800a7ae$export$4cf4dd4c5ab7075b = async (from, to, body, contentIdContext)=>{
    const variables = {
        from: from,
        to: to,
        body: body,
        contentIdContext: contentIdContext
    };
    const requestBody = {
        representation: from,
        value: body
    };
    const params = new URLSearchParams();
    if (contentIdContext) params.append('contentIdContext', contentIdContext);
    const queryString = params.toString();
    const queryParams = queryString ? `?${queryString}` : '';
    const url = `/wiki/rest/api/contentbody/convert/${to}${queryParams}`;
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: url,
        method: 'POST',
        body: JSON.stringify(requestBody),
        credentials: 'include',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnSuccess: async (response)=>{
            if (response.ok && response.status === 200) return response.json();
            throw response;
        },
        parseResponseOnError: (error)=>{
            throw new Error(`Conversion HTTP error, status = ${error.status}, message = "${error.statusText}"`);
        },
        parseResult: (response)=>({
                experimentalContentBodyConvert: {
                    value: response.value
                }
            }),
        variables: variables
    });
    return result.data;
};
module.exports["experimentalContentBodyConvertQuery"] = $3a3d352db800a7ae$export$4cf4dd4c5ab7075b;

});

parcelRegister("iS5Ay", function(module, exports) {

var $c6StJ = parcelRequire("c6StJ");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $c6StJ.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("1RY07", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $7Sm4c = parcelRequire("7Sm4c");

async function $32cd044d306ca797$export$642c5b07a008cc22({ fetchData: fetchData, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none', skip: skip = false, onCompleted: onCompleted, onError: onError, getCachedData: getCachedData, setCachedData: setCachedData, convertToApolloError: convertToApolloError }) {
    if (skip) return {
        data: undefined,
        error: undefined
    };
    // cache-first / store-or-network: return cached data if it exists or fetch from network
    if ((fetchPolicy === 'cache-first' || fetchPolicy === 'store-or-network') && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // cache-and-network: return cached data immediately, fetch in background
    if (fetchPolicy === 'cache-and-network' && getCachedData) {
        const cachedData = getCachedData();
        if (cachedData !== undefined) {
            fetchData().catch(()=>{});
            onCompleted?.(cachedData);
            return {
                data: cachedData,
                error: undefined
            };
        }
    }
    // network-only or cache miss: fetch from network
    try {
        const data = await fetchData();
        if (fetchPolicy !== 'no-cache' && setCachedData) await setCachedData(data);
        onCompleted?.(data);
        return {
            data: data,
            error: undefined
        };
    } catch (error) {
        const apolloError = await Promise.resolve(convertToApolloError(error));
        if (apolloError.graphQLErrors?.length) apolloError.graphQLErrors.forEach((e)=>{
            (0, $7Sm4c.processError)(e);
        });
        onError?.(apolloError);
        if (errorPolicy === 'all') return {
            data: undefined,
            error: apolloError
        };
        // errorPolicy === 'none': throw the error
        throw apolloError;
    }
}
module.exports["apolloCompatibleQuery"] = $32cd044d306ca797$export$642c5b07a008cc22;

});

parcelRegister("GLgaM", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $6kV7w = parcelRequire("6kV7w");


var $3FAG5 = parcelRequire("3FAG5");

async function $2229ddfbe95e9ad1$export$4b00e7449e7c9147(fetchOptions, variables) {
    const { url: url, method: method, body: body, headers: headers, credentials: credentials, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError } = fetchOptions;
    try {
        const resolvedMethod = typeof method === 'function' ? method(variables) : method;
        const defaultBody = resolvedMethod === 'GET' ? undefined : JSON.stringify(variables);
        // Tesseract instruments the outgoing http requests automatically, no need to pass tracing headers when running in SSR.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)('' /* url, not used */ );
        const enhancedHeaders = {
            ...headers,
            ...tracingHeaders
        };
        const response = await (0, $f7B1p.cfetch)(typeof url === 'function' ? url(variables) : url, {
            method: resolvedMethod,
            body: typeof body === 'function' ? body(variables) : body || defaultBody,
            headers: enhancedHeaders,
            credentials: credentials
        });
        if (parseResponseOnSuccess) return parseResponseOnSuccess(response);
        return await $2229ddfbe95e9ad1$var$parseResponse(response);
    } catch (error) {
        if (parseResponseOnError) return parseResponseOnError(error, variables);
        throw error;
    }
}
async function $2229ddfbe95e9ad1$var$parseResponse(response) {
    if (response.status === 204) return {};
    // In case a service happens to return a 200 instead of 204 with no content
    if (response.headers?.get('content-length') === '0') return {};
    try {
        return await response.json();
    } catch (error) {
        throw (0, $3FAG5.throwErrorWithResponse)(error, response);
    }
}
module.exports["fetchResponse"] = $2229ddfbe95e9ad1$export$4b00e7449e7c9147;

});

parcelRegister("3FAG5", function(module, exports) {
// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
function $6c7ad22961ce35d0$export$8a24908f7aac7ac7(error, response) {
    // Don't swallow the Response object, attach it to the error so the rest of
    // the app has a chance to see it e.g. OnErrorLink:
    if (typeof error === 'object' && error) {
        // At times our various resolver implementations interpret the JSON body of
        // non-OK responses as errors. And sometimes these errors contain a response
        // property (which may be an empty object) that leads to the loss of
        // Response information such as trace ID.
        if ('response' in error) {
            const existingErrorResponse = error.response;
            // Try to attach at least the trace ID to the existing error response:
            if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
                // OnError's getResponseFromError needs the status property:
                if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
                // getTraceIdFromResponse needs the headers property:
                if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
            }
        } else error.response = response;
    }
    throw error;
}
module.exports["throwErrorWithResponse"] = $6c7ad22961ce35d0$export$8a24908f7aac7ac7;

});

parcelRegister("7ji4X", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $67e5a1fc9f6e62d4$export$c6060eb21313da7c = {
    data: undefined,
    loading: false,
    error: undefined,
    called: false
};
const $67e5a1fc9f6e62d4$export$baa1629d06692c30 = {
    data: undefined,
    loading: true,
    error: undefined,
    called: true
};
const $67e5a1fc9f6e62d4$var$Store = (0, $8s9DV.createStore)({
    initialState: {},
    actions: {
        setQueryState: (key, state)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const prevState = currentState[key] || $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
                const newState = typeof state === 'function' ? state(prevState) : state;
                setState({
                    ...currentState,
                    [key]: newState
                });
            }
    },
    name: 'useExperimentalQueryState'
});
const $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a = (0, $kBr4q.createActionsHook)($67e5a1fc9f6e62d4$var$Store);
const $67e5a1fc9f6e62d4$export$39156bd8f00c1e38 = (0, $kBr4q.createStateHook)($67e5a1fc9f6e62d4$var$Store, {
    selector: (state, params)=>state[params.key]
});
const $67e5a1fc9f6e62d4$export$14d57088f5885a49 = $67e5a1fc9f6e62d4$var$Store;
module.exports["INITIAL_IDLE_STATE"] = $67e5a1fc9f6e62d4$export$c6060eb21313da7c;
module.exports["INITIAL_LOADING_STATE"] = $67e5a1fc9f6e62d4$export$baa1629d06692c30;
module.exports["useExperimentalQueryStateActions"] = $67e5a1fc9f6e62d4$export$3904d1f229fe9b3a;
module.exports["useExperimentalQueryState"] = $67e5a1fc9f6e62d4$export$39156bd8f00c1e38;
module.exports["queryStateStore"] = $67e5a1fc9f6e62d4$export$14d57088f5885a49;

});

parcelRegister("6l6jb", function(module, exports) {
function $459f9fedb053e25e$export$a4f9b7f788f9e71f(params) {
    const { url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables } = params;
    return $459f9fedb053e25e$var$canonicalStringify({
        url: typeof url === 'function' ? url.toString() : url,
        method: typeof method === 'function' ? method.toString() : method,
        headers: headers,
        body: typeof body === 'function' ? body.toString() : body,
        credentials: credentials,
        variables: variables
    });
}
function $459f9fedb053e25e$export$ebaa599ca92b9c11(requestConfigs, variables) {
    const keys = requestConfigs.map((config)=>$459f9fedb053e25e$export$a4f9b7f788f9e71f({
            ...config,
            variables: variables
        })).sort();
    return $459f9fedb053e25e$var$canonicalStringify(keys);
}
// Serializes with sorted object keys for deterministic output
function $459f9fedb053e25e$var$canonicalStringify(value) {
    return JSON.stringify(value, $459f9fedb053e25e$var$canonicalStringifyReplacer);
}
function $459f9fedb053e25e$var$canonicalStringifyReplacer(_key, value) {
    // Ensures we only process plain objects (not arrays, dates, etc.)
    if (value && typeof value === 'object') {
        const proto = Object.getPrototypeOf(value);
        if (proto === Object.prototype || proto === null) {
            const keys = Object.keys(value);
            // If keys are already sorted, return the original value unchanged to avoid unnecessary object creation
            if (keys.every($459f9fedb053e25e$var$everyKeyInOrder)) return value;
            keys.sort();
            const sortedObject = Object.create(proto);
            keys.forEach((key)=>{
                sortedObject[key] = value[key];
            });
            return sortedObject;
        }
    }
    return value;
}
function $459f9fedb053e25e$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}
module.exports["generateCacheKey"] = $459f9fedb053e25e$export$a4f9b7f788f9e71f;
module.exports["generateCacheKeyForMultipleFetches"] = $459f9fedb053e25e$export$ebaa599ca92b9c11;

});

parcelRegister("bjeS8", function(module, exports) {

var $7m1pr = parcelRequire("7m1pr");

const $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a = (error)=>{
    const message = error.message || 'Unknown error';
    const status = 'response' in error ? error.response?.status : undefined;
    return new (0, $7m1pr.RelayError)({
        graphQLErrors: [
            $79bfccd7ee2a0d89$var$createGraphQLError({
                message: message,
                status: status,
                originalError: error
            })
        ]
    });
};
const $79bfccd7ee2a0d89$var$createGraphQLError = ({ message: message, status: status, originalError: originalError })=>{
    const extensions = status ? {
        statusCode: status,
        http: {
            status: status
        }
    } : undefined;
    return (0, $7m1pr.createGraphQLError)(message, {
        path: null,
        originalError: originalError,
        extensions: extensions
    });
};
module.exports["convertToApolloError"] = $79bfccd7ee2a0d89$export$657ce0d4a1b8cb1a;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("6Cce7", function(module, exports) {

var $jQLsH = parcelRequire("jQLsH");

const $266b70085156c92e$export$ef5feff44649e0e4 = (0, $jQLsH.default);
module.exports["ContentConverterQuery"] = $266b70085156c92e$export$ef5feff44649e0e4;

});

parcelRegister("jQLsH", function(module, exports) {
/**
 * @generated SignedSource<<9e6f3b9ddc07475a4d0d7fa8551ae498>>
 * @relayHash 449b252c30e0e1ea61274ed95f3aaf56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bf4577ec63e0557a0bf6492075dab1680c0c0b275f759aefa582c2b782658477
const $a5cfbccb9473c362$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "content"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "from"
    }, v3 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "spaceKeyContext"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "to"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "content",
                    "variableName": "content"
                },
                {
                    "kind": "Variable",
                    "name": "contentIdContext",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "from",
                    "variableName": "from"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKeyContext",
                    "variableName": "spaceKeyContext"
                },
                {
                    "kind": "Variable",
                    "name": "to",
                    "variableName": "to"
                }
            ],
            "concreteType": "ConfluenceBody",
            "kind": "LinkedField",
            "name": "contentConverter",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentConverterQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentConverterQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "449b252c30e0e1ea61274ed95f3aaf56",
            "id": "bf4577ec63e0557a0bf6492075dab1680c0c0b275f759aefa582c2b782658477",
            "metadata": {},
            "name": "ContentConverterQuery",
            "operationKind": "query",
            "text": "query ContentConverterQuery($content:String!,$contentId:ID!,$from:String!,$to:String!,$spaceKeyContext:String=\"\"){contentConverter(from:$from,to:$to,content:$content,contentIdContext:$contentId,spaceKeyContext:$spaceKeyContext){value}}"
        }
    };
}();
$a5cfbccb9473c362$var$node.hash = "6980f8893393c2f02dae03f9d79f696a";
var $a5cfbccb9473c362$export$2e2bcd8739ae039 = $a5cfbccb9473c362$var$node;
module.exports["default"] = $a5cfbccb9473c362$export$2e2bcd8739ae039;

});

parcelRegister("gSV4C", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $axutP = parcelRequire("axutP");

function $853f14d41fe05930$export$fb43949e55e0c9d2({ cloudId: cloudId, spaceKey: spaceKey }) {
    return (0, $dYU3e.query)({
        query: (0, $axutP.default),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        __callerPackage__: "team-presence"
    });
}
module.exports["preloadPresenceSettings"] = $853f14d41fe05930$export$fb43949e55e0c9d2;

});

parcelRegister("axutP", function(module, exports) {
/**
 * @generated SignedSource<<1489173bfe4b7806076804a6e2602ed8>>
 * @relayHash fa5b50f9c89692d4dd86caf1df42c2d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a
const $972689412971ec2f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceTeamPresence",
            "kind": "LinkedField",
            "name": "confluence_teamPresenceContentSetting",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fa5b50f9c89692d4dd86caf1df42c2d1",
            "id": "60833378a8743a6756bd6e1c0fa498d563c23b5e85cbe46b5ee3f3b782265d4a",
            "metadata": {},
            "name": "ContentHeaderPresenceContentSettingsQuery",
            "operationKind": "query",
            "text": "query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!,$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId,spaceKey:$spaceKey){isEnabledOnContentView}}"
        }
    };
}();
$972689412971ec2f$var$node.hash = "2d4682166f4edbdf50428f0d98c0918c";
var $972689412971ec2f$export$2e2bcd8739ae039 = $972689412971ec2f$var$node;
module.exports["default"] = $972689412971ec2f$export$2e2bcd8739ae039;

});

parcelRegister("8E4P6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eqEJl = parcelRequire("eqEJl");


var $dYU3e = parcelRequire("dYU3e");


var $20mi0 = parcelRequire("20mi0");


var $axutP = parcelRequire("axutP");


var $6ANjK = parcelRequire("6ANjK");

// Browser-only first-use state; never hold a token in module scope or on the server.
let $88601d9afedd89f9$var$activeKey;
let $88601d9afedd89f9$var$consumed = false;
let $88601d9afedd89f9$var$tokenRetention;
const $88601d9afedd89f9$var$releaseTokenRetention = ()=>{
    $88601d9afedd89f9$var$tokenRetention?.dispose();
    $88601d9afedd89f9$var$tokenRetention = undefined;
};
const $88601d9afedd89f9$var$inFlight = new Map();
const $88601d9afedd89f9$var$pendingPreloads = new Map();
const $88601d9afedd89f9$var$pendingListeners = new Set();
const $88601d9afedd89f9$var$keyFor = ({ cloudId: cloudId, contentId: contentId, spaceKey: spaceKey })=>JSON.stringify([
        cloudId,
        contentId,
        spaceKey
    ]);
const $88601d9afedd89f9$var$subscribeToPending = (listener)=>{
    $88601d9afedd89f9$var$pendingListeners.add(listener);
    return ()=>$88601d9afedd89f9$var$pendingListeners.delete(listener);
};
const $88601d9afedd89f9$var$notifyPending = ()=>$88601d9afedd89f9$var$pendingListeners.forEach((listener)=>listener());
function $88601d9afedd89f9$export$cc06d29896aaaab8(variables) {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] !== variables) {
        t0 = $88601d9afedd89f9$var$keyFor(variables);
        $[0] = variables;
        $[1] = t0;
    } else t0 = $[1];
    const key = t0;
    let t1;
    if ($[2] !== key) {
        t1 = ()=>$88601d9afedd89f9$var$pendingPreloads.has(key);
        $[2] = key;
        $[3] = t1;
    } else t1 = $[3];
    const getSnapshot = t1;
    return (0, $cozmU.useSyncExternalStore)($88601d9afedd89f9$var$subscribeToPending, getSnapshot, $88601d9afedd89f9$var$_temp);
}
function $88601d9afedd89f9$var$_temp() {
    return false;
}
async function $88601d9afedd89f9$export$af224a0170a9928b(variables, preload) {
    const key = $88601d9afedd89f9$var$keyFor(variables);
    if ($88601d9afedd89f9$var$isBrowser()) {
        $88601d9afedd89f9$var$pendingPreloads.set(key, ($88601d9afedd89f9$var$pendingPreloads.get(key) ?? 0) + 1);
        $88601d9afedd89f9$var$notifyPending();
    }
    try {
        return await preload();
    } finally{
        if ($88601d9afedd89f9$var$isBrowser()) {
            const remaining = ($88601d9afedd89f9$var$pendingPreloads.get(key) ?? 1) - 1;
            if (remaining > 0) $88601d9afedd89f9$var$pendingPreloads.set(key, remaining);
            else $88601d9afedd89f9$var$pendingPreloads.delete(key);
            $88601d9afedd89f9$var$notifyPending();
        }
    }
}
// The SSR preloader has a window shim. Never store request-specific state in this module on SSR.
const $88601d9afedd89f9$var$isBrowser = ()=>typeof window !== 'undefined';
// The route only invokes this preloader when both operations use Relay. Use the same
// environment as its query preloader and the header's existing settings reader.
const $88601d9afedd89f9$var$relayEnvironment = ()=>window.GLOBAL_RELAY_ENV;
const $88601d9afedd89f9$var$readCachedQuery = (queryNode, variables)=>{
    const environment = $88601d9afedd89f9$var$relayEnvironment();
    if (!environment) return null;
    const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)(queryNode), variables);
    const snapshot = environment.lookup(operation.fragment);
    return snapshot.isMissingData ? null : snapshot.data;
};
function $88601d9afedd89f9$export$57202bd5b84741f7(cloudId, spaceKey) {
    const data = $88601d9afedd89f9$var$readCachedQuery((0, $axutP.default), {
        cloudId: cloudId,
        spaceKey: spaceKey
    });
    const value = data?.confluence_teamPresenceContentSetting?.isEnabledOnContentView;
    return typeof value === 'boolean' ? value : undefined;
}



async function $88601d9afedd89f9$export$f9bb6db309f685ca(variables) {
    const key = $88601d9afedd89f9$var$keyFor(variables);
    // Never share tokens or promises between server requests, including concurrent SSR.
    if ($88601d9afedd89f9$var$isBrowser()) {
        if ($88601d9afedd89f9$var$activeKey !== key) {
            $88601d9afedd89f9$var$releaseTokenRetention();
            $88601d9afedd89f9$var$activeKey = key;
            $88601d9afedd89f9$var$consumed = false;
        }
        if ($88601d9afedd89f9$var$inFlight.has(key)) return $88601d9afedd89f9$var$inFlight.get(key);
    }
    const preload = async ()=>{
        if ($88601d9afedd89f9$export$57202bd5b84741f7(variables.cloudId, variables.spaceKey) !== undefined) {
            if ($88601d9afedd89f9$var$isBrowser() && $88601d9afedd89f9$var$activeKey === key) {
                $88601d9afedd89f9$var$consumed = true;
                $88601d9afedd89f9$var$releaseTokenRetention();
            }
            return;
        }
        // The caller normally guarantees a Relay environment. If one is unavailable,
        // avoid a redundant bootstrap request and let the legacy preloader recover.
        const environment = $88601d9afedd89f9$var$relayEnvironment();
        if (!environment) {
            const { preloadPresenceSettings: preloadPresenceSettings } = await Promise.resolve((parcelRequire("gSV4C")));
            await preloadPresenceSettings(variables);
            if ($88601d9afedd89f9$var$isBrowser() && $88601d9afedd89f9$var$activeKey === key) $88601d9afedd89f9$var$consumed = true;
            return;
        }
        // Keep the result alive until the socket's first token callback; Relay can
        // collect an unretained preload before PagePresence mounts after paint.
        const retention = $88601d9afedd89f9$var$isBrowser() && !$88601d9afedd89f9$var$consumed ? environment.retain((0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $20mi0.default)), variables)) : undefined;
        let response;
        try {
            response = await (0, $dYU3e.query)({
                query: (0, $6ANjK.VIEW_PRESENCE_BOOTSTRAP_QUERY),
                variables: variables,
                fetchPolicy: 'network-only',
                __callerPackage__: "team-presence"
            });
        } catch  {
        // Network rejection takes the same legacy fallback as a GraphQL error.
        }
        const result = response?.data?.confluence_viewPresenceBootstrap;
        if (response?.hasErrors || !result || typeof result.isEnabledOnContentView !== 'boolean') {
            retention?.dispose();
            // An error must never be normalized to disabled. Keep the legacy setting/token path.
            const { preloadPresenceSettings: preloadPresenceSettings } = await Promise.resolve((parcelRequire("gSV4C")));
            await preloadPresenceSettings(variables);
            if ($88601d9afedd89f9$var$isBrowser() && $88601d9afedd89f9$var$activeKey === key) $88601d9afedd89f9$var$consumed = true;
            return;
        }
        // A late response from a previous navigation must not overwrite the current setting.
        if ($88601d9afedd89f9$var$isBrowser() && $88601d9afedd89f9$var$activeKey !== key) {
            retention?.dispose();
            return;
        }
        const currentEnvironment = $88601d9afedd89f9$var$relayEnvironment();
        if (!currentEnvironment || currentEnvironment !== environment) {
            retention?.dispose();
            const { preloadPresenceSettings: preloadPresenceSettings } = await Promise.resolve((parcelRequire("gSV4C")));
            await preloadPresenceSettings(variables);
            if ($88601d9afedd89f9$var$isBrowser() && $88601d9afedd89f9$var$activeKey === key) $88601d9afedd89f9$var$consumed = true;
            return;
        }
        environment.commitPayload((0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $axutP.default)), {
            cloudId: variables.cloudId,
            spaceKey: variables.spaceKey
        }), {
            confluence_teamPresenceContentSetting: {
                isEnabledOnContentView: result.isEnabledOnContentView
            }
        });
        // The token stays in the content-specific bootstrap operation, never in the
        // space-scoped settings entry. A subsequent cache hit must not replay it.
        if ($88601d9afedd89f9$var$isBrowser() && $88601d9afedd89f9$var$activeKey === key && result.isEnabledOnContentView && !$88601d9afedd89f9$var$consumed) $88601d9afedd89f9$var$tokenRetention = retention;
        else {
            retention?.dispose();
            if ($88601d9afedd89f9$var$isBrowser() && $88601d9afedd89f9$var$activeKey === key) $88601d9afedd89f9$var$consumed = true;
        }
    };
    const promise = preload();
    if ($88601d9afedd89f9$var$isBrowser()) $88601d9afedd89f9$var$inFlight.set(key, promise);
    try {
        await promise;
    } finally{
        if ($88601d9afedd89f9$var$isBrowser() && $88601d9afedd89f9$var$inFlight.get(key) === promise) $88601d9afedd89f9$var$inFlight.delete(key);
    }
}
function $88601d9afedd89f9$export$be0e3a8b31637a32(variables) {
    if (!$88601d9afedd89f9$var$isBrowser()) return undefined;
    const key = $88601d9afedd89f9$var$keyFor(variables);
    // SSR hydration does not run the route preload in this browser process.
    if ($88601d9afedd89f9$var$activeKey === undefined) $88601d9afedd89f9$var$activeKey = key;
    if ($88601d9afedd89f9$var$activeKey !== key || $88601d9afedd89f9$var$consumed) return undefined;
    // Claim before reading: delayed stream responses cannot authenticate a reconnect.
    $88601d9afedd89f9$var$consumed = true;
    try {
        const data = $88601d9afedd89f9$var$readCachedQuery((0, $20mi0.default), variables);
        const result = data?.confluence_viewPresenceBootstrap;
        return result?.isEnabledOnContentView === true ? {
            token: result.token
        } : undefined;
    } finally{
        $88601d9afedd89f9$var$releaseTokenRetention();
    }
}
module.exports["useViewPresencePreloadPending"] = $88601d9afedd89f9$export$cc06d29896aaaab8;
module.exports["trackViewPresencePreload"] = $88601d9afedd89f9$export$af224a0170a9928b;
module.exports["preloadViewPresenceBootstrap"] = $88601d9afedd89f9$export$f9bb6db309f685ca;
module.exports["takeInitialViewPresenceToken"] = $88601d9afedd89f9$export$be0e3a8b31637a32;

});

parcelRegister("20mi0", function(module, exports) {
/**
 * @generated SignedSource<<bcb51462d9f43d92de4a06d9fc04f974>>
 * @relayHash c63a23027fa9e07208c3313202d77291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd05c98c37d56faf7d98617782fb98bf5729e2b323419e6dcce732c621fdb49d
const $69a3db9f9b4d09f4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceViewPresenceBootstrap",
            "kind": "LinkedField",
            "name": "confluence_viewPresenceBootstrap",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isEnabledOnContentView"
                },
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewPresenceBootstrapQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewPresenceBootstrapQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c63a23027fa9e07208c3313202d77291",
            "id": "fd05c98c37d56faf7d98617782fb98bf5729e2b323419e6dcce732c621fdb49d",
            "metadata": {},
            "name": "viewPresenceBootstrapQuery",
            "operationKind": "query",
            "text": "query viewPresenceBootstrapQuery($cloudId:ID!,$contentId:ID!,$spaceKey:String!){confluence_viewPresenceBootstrap(cloudId:$cloudId,contentId:$contentId,spaceKey:$spaceKey){isEnabledOnContentView,token}}"
        }
    };
}();
$69a3db9f9b4d09f4$var$node.hash = "207ea4ee88a2f126801b6001c3c8b54b";
var $69a3db9f9b4d09f4$export$2e2bcd8739ae039 = $69a3db9f9b4d09f4$var$node;
module.exports["default"] = $69a3db9f9b4d09f4$export$2e2bcd8739ae039;

});

parcelRegister("6ANjK", function(module, exports) {

var $20mi0 = parcelRequire("20mi0");

const $2c61044f52184816$export$1f036a8aeb9066d8 = (0, $20mi0.default);
module.exports["VIEW_PRESENCE_BOOTSTRAP_QUERY"] = $2c61044f52184816$export$1f036a8aeb9066d8;

});

parcelRegister("6P16d", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $76647cb3ea58216d$export$abcf1fd16eae1d29 = ({ edition: edition, isLoggedIn: isLoggedIn, accessStatus: accessStatus, userId: userId })=>{
    if (edition === 'FREE') return 'free-edition';
    if (!isLoggedIn) return 'logged-out';
    if (userId?.startsWith('qm:')) return 'customer-account';
    if (accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS) return 'anonymous-access';
    if (accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS) return 'external-share-access';
    return null;
};
const $76647cb3ea58216d$export$98119e0f8deca2eb = (accessStatus)=>{
    switch(accessStatus){
        case (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS:
        case (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS:
            return true;
        case (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS:
        case (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS:
        case (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS:
        case (0, $d9tcB.AccessStatus).NOT_PERMITTED:
        case (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS:
            return false;
        default:
            return null;
    }
};
const $76647cb3ea58216d$export$ede4b763296fb7f2 = (accessStatus)=>{
    switch(accessStatus){
        case (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS:
        case (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS:
            return 'licensed';
        case (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS:
            return 'externalCollaborator';
        case (0, $d9tcB.AccessStatus).UNLICENSED_AUTHENTICATED_ACCESS:
            return 'unlicensedAuthenticated';
        case (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS:
        case (0, $d9tcB.AccessStatus).EXTERNAL_SHARE_ACCESS:
            return 'anonymousOrExternalShare';
        case (0, $d9tcB.AccessStatus).NOT_PERMITTED:
            return 'notPermitted';
        default:
            return 'missing';
    }
};
module.exports["getAnalyticsBylineGateReason"] = $76647cb3ea58216d$export$abcf1fd16eae1d29;
module.exports["getSessionDataInternalUserCandidate"] = $76647cb3ea58216d$export$98119e0f8deca2eb;
module.exports["getAnalyticsBylineAccessClass"] = $76647cb3ea58216d$export$ede4b763296fb7f2;

});

parcelRegister("b1n8n", function(module, exports) {
function $780b4720740de967$export$c2b76f942a3d6145(content, contentId) {
    return Boolean(content?.id === contentId && content.status === 'current' && content.subType !== 'live' && content.type && content.title && content.version?.number != null && content.space?.id && content.space.key && content.space.name && content.space.type && content.operations?.every((operation)=>operation?.operation && operation.targetType));
}
module.exports["isReusableLegacyBridgeContent"] = $780b4720740de967$export$c2b76f942a3d6145;

});

parcelRegister("e5EnV", function(module, exports) {
/**
 * @generated SignedSource<<19f88e77d3cfba146c135d602dcd850a>>
 * @relayHash 6cd75834f128f4e69b90e03b31603fd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362
const $e4798d13ae2c4a75$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canBeSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "6cd75834f128f4e69b90e03b31603fd0",
            "id": "12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362",
            "metadata": {},
            "name": "RestrictedPageWithCanViewQuery",
            "operationKind": "query",
            "text": "query RestrictedPageWithCanViewQuery($id:ID!){singleContent(id:$id){id,status,links{webui}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
        }
    };
}();
$e4798d13ae2c4a75$var$node.hash = "cac9cbea2e6f98b7e3ef1e383776a339";
var $e4798d13ae2c4a75$export$2e2bcd8739ae039 = $e4798d13ae2c4a75$var$node;
module.exports["default"] = $e4798d13ae2c4a75$export$2e2bcd8739ae039;

});

parcelRegister("6jrkJ", function(module, exports) {

var $68uaC = parcelRequire("68uaC");

const $00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE = 'confluence.asSuperAdmin';
function $00ee7f2affe27fcd$export$2fc1623749affa1a() {
    return Boolean((0, $68uaC.Cookies).get($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE));
}
function $00ee7f2affe27fcd$export$b097cdee5288154b() {
    (0, $68uaC.Cookies).removeStrictlyNecessary($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE);
}
async function $00ee7f2affe27fcd$export$f5d5d0f409509831() {
    await (0, $68uaC.Cookies).set($00ee7f2affe27fcd$var$SUPER_ADMIN_COOKIE, 'true', undefined, (0, $68uaC.CookieLevel).NECESSARY);
}
module.exports["getSuperAdminClaim"] = $00ee7f2affe27fcd$export$2fc1623749affa1a;
module.exports["removeSuperAdminClaim"] = $00ee7f2affe27fcd$export$b097cdee5288154b;
module.exports["setSuperAdminClaim"] = $00ee7f2affe27fcd$export$f5d5d0f409509831;

});

parcelRegister("hiC7Y", function(module, exports) {
/**
 * @generated SignedSource<<994231445f227a67e1aaccbbe4790b5b>>
 * @relayHash 0f84e07ae7daaa03ff834c7e22000d77
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78
const $55ca182de67fa1f0$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "IsSuperAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f84e07ae7daaa03ff834c7e22000d77",
            "id": "54df31e8c4d8a985ea8cf57de4e9987537d70dbc168cfc0cfa0a076f20f53d78",
            "metadata": {},
            "name": "IsSuperAdminQuery",
            "operationKind": "query",
            "text": "query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{roles{isSuperAdmin}}}}"
        }
    };
}();
$55ca182de67fa1f0$var$node.hash = "9aa53dcf116596c8f8285a3aa93878ce";
var $55ca182de67fa1f0$export$2e2bcd8739ae039 = $55ca182de67fa1f0$var$node;
module.exports["default"] = $55ca182de67fa1f0$export$2e2bcd8739ae039;

});

parcelRegister("eDV4X", function(module, exports) {
const $e24dc53dc88ae3e8$export$3211963609921415 = [
    'current',
    'draft'
];
const $e24dc53dc88ae3e8$export$d7a13677648fb230 = 'edit-label-dialog-heading';
var $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4 = /*#__PURE__*/ function(ActionTypes) {
    ActionTypes["CLEAR"] = "clear";
    ActionTypes["CREATE_OPTION"] = "create-option";
    ActionTypes["REMOVE_VALUE"] = "remove-value";
    ActionTypes["POP_VALUE"] = "pop-value";
    ActionTypes["SELECT_OPTION"] = "select-option";
    return ActionTypes;
}({});
const $e24dc53dc88ae3e8$export$cac90560d1a4fb86 = /[:;,.•?&[\]()#^*@!<>]/;
var $e24dc53dc88ae3e8$export$b9e669a853ca2f38 = /*#__PURE__*/ function(ContentTypes) {
    ContentTypes["TEMPLATE"] = "template";
    return ContentTypes;
}({});
module.exports["ALLOWED_CONTENT_STATUSES"] = $e24dc53dc88ae3e8$export$3211963609921415;
module.exports["ActionTypes"] = $e24dc53dc88ae3e8$export$1385d81a6c6bbcd4;
module.exports["INVALID_CHARACTERS"] = $e24dc53dc88ae3e8$export$cac90560d1a4fb86;
module.exports["ContentTypes"] = $e24dc53dc88ae3e8$export$b9e669a853ca2f38;

});

parcelRegister("fD4xZ", function(module, exports) {
/**
 * @generated SignedSource<<1a93f69da43b9061a7c9446104b7f51c>>
 * @relayHash b698f2f645007ae504c47432886a8c9f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ec1bbae0d06503f83cace8fb8dcc810514d285963c0c294c636dfbed334b851a
const $d6621697d90b85f7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "orderBy",
                                    "value": {
                                        "direction": "ASCENDING",
                                        "sortField": "LABELLING_CREATIONDATE"
                                    }
                                }
                            ],
                            "concreteType": "PaginatedLabelList",
                            "kind": "LinkedField",
                            "name": "labels",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "count"
                                },
                                {
                                    "concreteType": "Label",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v1 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "label"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "prefix"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useLabelsSelectPropsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "b698f2f645007ae504c47432886a8c9f",
            "id": "ec1bbae0d06503f83cace8fb8dcc810514d285963c0c294c636dfbed334b851a",
            "metadata": {},
            "name": "useLabelsSelectPropsQuery",
            "operationKind": "query",
            "text": "query useLabelsSelectPropsQuery($contentId:ID!,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}}}"
        }
    };
}();
$d6621697d90b85f7$var$node.hash = "d18f04cceb469e9db4defcdb1b9ec4bd";
var $d6621697d90b85f7$export$2e2bcd8739ae039 = $d6621697d90b85f7$var$node;
module.exports["default"] = $d6621697d90b85f7$export$2e2bcd8739ae039;

});

parcelRegister("jkwMx", function(module, exports) {

var $cqob2 = parcelRequire("cqob2");


var $e9oF4 = parcelRequire("e9oF4");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $9HB34 = parcelRequire("9HB34");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $ad7e745e3d59b8c7$export$bb5886bf758160d3 = (0, $e9oF4.default);
const $ad7e745e3d59b8c7$export$ffff3ea8cf53a69e = (0, $cqob2.default);
const $ad7e745e3d59b8c7$var$SETTLED_EMPTY = {
    labels: [],
    loading: false,
    error: undefined
};
const $ad7e745e3d59b8c7$export$1e91156d5765cc4b = (cloudId, contentId, contentType)=>{
    if (!cloudId || !contentId || contentType !== 'page' && contentType !== 'blogpost') return '';
    return `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
};
const $ad7e745e3d59b8c7$export$48837ed000c21cf = (contentId, contentType)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const entityAri = $ad7e745e3d59b8c7$export$1e91156d5765cc4b(cloudId, contentId, contentType);
    const skip = !(0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') || !cloudId || !contentId || !entityAri;
    // Start loading when active so consumers don't flash empty before the first read.
    const [state, setState] = (0, $cozmU.useState)(()=>skip ? $ad7e745e3d59b8c7$var$SETTLED_EMPTY : {
            labels: [],
            loading: true,
            error: undefined
        });
    // Bumping this re-runs the effect, giving `refetch` a network round-trip.
    const [reloadToken, setReloadToken] = (0, $cozmU.useState)(0);
    const runQuery = (0, $cozmU.useCallback)(()=>{
        if (skip) {
            setState($ad7e745e3d59b8c7$var$SETTLED_EMPTY);
            return ()=>{};
        }
        setState((prev)=>({
                ...prev,
                loading: true,
                error: undefined
            }));
        const environment = (0, $9HB34.getRelayEnvironment)();
        const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)($ad7e745e3d59b8c7$export$bb5886bf758160d3), {
            cloudId: cloudId,
            id: entityAri
        });
        // Retain so the subscribed records aren't GC'd while mounted.
        const retention = environment.retain(operation);
        let cancelled = false;
        // Re-read on any change to the normalized record (incl. mutation-updater writes).
        const publishFromStore = (data)=>{
            if (cancelled) return;
            setState((prev)=>({
                    // Gateway types array and elements as nullable; drop nulls.
                    labels: (data?.confluence_externalLabels ?? []).filter((label)=>label != null),
                    loading: false,
                    error: prev.error
                }));
        };
        const storeSubscription = environment.subscribe(environment.lookup(operation.fragment), (snapshot)=>publishFromStore(snapshot.data));
        const fetchSubscription = (0, $6SsN4.fetchQuery)(environment, $ad7e745e3d59b8c7$export$bb5886bf758160d3, {
            cloudId: cloudId,
            id: entityAri
        }, {
            // Store-first (warmed by SSR `preloadManagedLabels`), network otherwise.
            // No `X-Query-Context` header so the field folds into the batched ContentUnifiedQuery.
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>publishFromStore(data),
            error: (err)=>{
                if (cancelled) return;
                setState((prev)=>({
                        ...prev,
                        loading: false,
                        error: err instanceof Error ? err : new Error(String(err))
                    }));
            }
        });
        return ()=>{
            cancelled = true;
            fetchSubscription.unsubscribe();
            storeSubscription.dispose();
            retention.dispose();
        };
    }, [
        skip,
        cloudId,
        entityAri
    ]);
    (0, $cozmU.useEffect)(()=>{
        // `runQuery` returns its cleanup; `reloadToken` re-runs it for `refetch`.
        return runQuery();
    }, [
        runQuery,
        reloadToken
    ]);
    return {
        labels: state.labels,
        loading: state.loading,
        error: state.error,
        refetch: ()=>{
            if (!skip) setReloadToken((token)=>token + 1);
        }
    };
};
const $ad7e745e3d59b8c7$export$7fcfc8c1f94175ba = (fragmentRef)=>{
    // Native `useFragment` calls `useRelayEnvironment()` even for a null ref, so it
    // throws when no provider is mounted (Apollo mode / Apollo-mode jest tests). The
    // spread only exists when the gate is on, so skip the read entirely when it's off.
    // The gate is session-stable within a render tree, matching `useReadFragmentInterop`.
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    const data = (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') ? // eslint-disable-next-line react-hooks/rules-of-hooks -- gate is session-stable within a render tree, matching useReadFragmentInterop
    (0, $6SsN4.useFragment)($ad7e745e3d59b8c7$export$ffff3ea8cf53a69e, fragmentRef ?? null) : null;
    // Gateway types array and elements as nullable; drop nulls.
    return (data?.confluence_externalLabels ?? []).filter((label)=>label != null);
};
const $ad7e745e3d59b8c7$export$931547829ee50720 = (contentId, contentType)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const entityAri = $ad7e745e3d59b8c7$export$1e91156d5765cc4b(cloudId, contentId, contentType);
    // Empty ARI (unresolved content type) fails closed: don't include the spread.
    const includeExternalLabels = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    Boolean(entityAri) && (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint');
    return {
        includeExternalLabels: includeExternalLabels,
        cloudId: includeExternalLabels ? cloudId : '',
        id: includeExternalLabels ? entityAri : ''
    };
};
module.exports["buildExternalLabelsAri"] = $ad7e745e3d59b8c7$export$1e91156d5765cc4b;
module.exports["useExternalLabels"] = $ad7e745e3d59b8c7$export$48837ed000c21cf;
module.exports["useExternalLabelsFragment"] = $ad7e745e3d59b8c7$export$7fcfc8c1f94175ba;
module.exports["useExternalLabelsFragmentVariables"] = $ad7e745e3d59b8c7$export$931547829ee50720;

});

parcelRegister("cqob2", function(module, exports) {
/**
 * @generated SignedSource<<69a1f3de73c3ec1c5c64e3b35cea7a4d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $07831018b6e60c32$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ],
    "kind": "Fragment",
    "name": "useExternalLabels_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceExternalLabel",
            "kind": "LinkedField",
            "name": "confluence_externalLabels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "kind"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ],
    "type": "Query"
};
$07831018b6e60c32$var$node.hash = "7d28bc802d44490f82047790ad70cb83";
var $07831018b6e60c32$export$2e2bcd8739ae039 = $07831018b6e60c32$var$node;
module.exports["default"] = $07831018b6e60c32$export$2e2bcd8739ae039;

});

parcelRegister("e9oF4", function(module, exports) {
/**
 * @generated SignedSource<<b9754658ef133de839007ab6255673ef>>
 * @relayHash 86987791157c6aeb4f02ade819203bff
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1bebf65bb0058062a5f20b41b072b9b6d77d7dce49de5f8d66e78144518f290
const $d3d143b69f678795$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceExternalLabel",
            "kind": "LinkedField",
            "name": "confluence_externalLabels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "kind"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useExternalLabelsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useExternalLabelsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "86987791157c6aeb4f02ade819203bff",
            "id": "f1bebf65bb0058062a5f20b41b072b9b6d77d7dce49de5f8d66e78144518f290",
            "metadata": {},
            "name": "useExternalLabelsQuery",
            "operationKind": "query",
            "text": "query useExternalLabelsQuery($cloudId:ID!,$id:ID!){confluence_externalLabels(cloudId:$cloudId,id:$id){id,kind,name}}"
        }
    };
}();
$d3d143b69f678795$var$node.hash = "05a01cd2e9877ac3fd6774883b47072b";
var $d3d143b69f678795$export$2e2bcd8739ae039 = $d3d143b69f678795$var$node;
module.exports["default"] = $d3d143b69f678795$export$2e2bcd8739ae039;

});

parcelRegister("9xoMO", function(module, exports) {

var $dBcar = parcelRequire("dBcar");


var $gxTpP = parcelRequire("gxTpP");


var $5cryL = parcelRequire("5cryL");


var $lohHj = parcelRequire("lohHj");


var $b4VFP = parcelRequire("b4VFP");


var $d282Z = parcelRequire("d282Z");


var $d0hiC = parcelRequire("d0hiC");


var $9DBk6 = parcelRequire("9DBk6");


var $isKLx = parcelRequire("isKLx");


var $1gy7x = parcelRequire("1gy7x");


var $h86CY = parcelRequire("h86CY");


var $jbYIt = parcelRequire("jbYIt");


var $ccGoc = parcelRequire("ccGoc");


var $eoU1C = parcelRequire("eoU1C");


var $2wUAJ = parcelRequire("2wUAJ");


var $6eN5W = parcelRequire("6eN5W");


var $kNKrY = parcelRequire("kNKrY");


var $lIcXr = parcelRequire("lIcXr");


var $bPDOf = parcelRequire("bPDOf");


var $eyUJP = parcelRequire("eyUJP");


var $eC276 = parcelRequire("eC276");


var $fsF73 = parcelRequire("fsF73");


var $bEwOV = parcelRequire("bEwOV");


var $gGieN = parcelRequire("gGieN");


var $exrKs = parcelRequire("exrKs");


var $i1J1l = parcelRequire("i1J1l");


var $iTy0f = parcelRequire("iTy0f");


var $kCtxZ = parcelRequire("kCtxZ");


var $8l6NF = parcelRequire("8l6NF");


var $iQzVo = parcelRequire("iQzVo");


var $4UYoK = parcelRequire("4UYoK");


var $8SJ0d = parcelRequire("8SJ0d");

const $af0fb818e1350632$export$1c433575c0d65d05 = [
    ...(0, $2wUAJ.StorageEnforcementOnboardingKeys),
    ...(0, $dBcar.OnboardingKeys),
    ...(0, $gxTpP.ContextualInviteNudgeOnboardingKeys),
    ...(0, $5cryL.EditorOnboardingKeys),
    ...(0, $d282Z.InsightsOnboardingKeys),
    ...(0, $isKLx.SpaceMissionControlOnboardingKeys),
    ...(0, $h86CY.PresenceAdminFeedbackSurveyOnboardingKeys),
    ...(0, $jbYIt.RoleBasedAccessControlOnboardingKeys),
    ...(0, $ccGoc.RovoVideoPlayerStateOnboardingKeys),
    ...(0, $eoU1C.ShareAndRestrictDialogOnboardingKeys),
    ...(0, $6eN5W.TrialComponentsOnboardingKeys),
    ...(0, $1gy7x.PersonalizedTemplatesOnboardingKeys),
    ...(0, $9DBk6.LiveDocsOnboardingKeys),
    ...(0, $b4VFP.HomeTakeoverOnboardingKeys),
    ...(0, $lohHj.FeedOnboardingKeys),
    ...(0, $d0hiC.LandInSpampleSpaceOnboardingKeys),
    ...(0, $kNKrY.CreateIntroFirstStepOnboardingStateKeys),
    ...(0, $lIcXr.NewContentHistoryOnboardingStateKeys),
    ...(0, $bPDOf.AIFCOnboardingKeys),
    ...(0, $eyUJP.NthUserHomeOnboardingRevampKeys),
    ...(0, $eC276.ExportJiraContextToPageTourKeys),
    ...(0, $fsF73.ConfluenceRecapOnboardingKeys),
    ...(0, $gGieN.SuggestWhiteboardBasedOnPageTitleOnboardingKeys),
    ...(0, $exrKs.SuggestSkillBasedOnPageTitleOnboardingKeys),
    ...(0, $i1J1l.SuggestAgentBasedOnPageTitleOnboardingKeys),
    ...(0, $bEwOV.SnippetsOnboardingKeys),
    ...(0, $iTy0f.SmartLinkDraggableOnboardingKeys),
    ...(0, $kCtxZ.SmartFolderPasteNudgeOnboardingKeys),
    ...(0, $8l6NF.ChangeboardingAdminNavTourOnboardingKeys),
    ...(0, $iQzVo.Twcg1489ConnectorOnboardingKeys),
    ...(0, $4UYoK.UniversalCreateCwRExperimentSpotlightOnboardingKeys),
    ...(0, $8SJ0d.AgentSessionsOnboardingKeys),
    ...(0, $8SJ0d.AgentMentionsOnboardingKeys)
];
module.exports["OnboardingKeysCombined"] = $af0fb818e1350632$export$1c433575c0d65d05;

});

parcelRegister("gxTpP", function(module, exports) {
const $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab = {
    EXPERIMENT_ELIGIBLE_TAG: 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    WAS_CONFETTI_SEEN: 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
};
const $62a1556a5bf2ef38$export$fdbc8dd83db637ed = Object.values($62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab);
module.exports["CONTEXTUAL_INVITE_NUDGE"] = $62a1556a5bf2ef38$export$ed1ceddf3ffdd8ab;
module.exports["ContextualInviteNudgeOnboardingKeys"] = $62a1556a5bf2ef38$export$fdbc8dd83db637ed;

});

parcelRegister("5cryL", function(module, exports) {
const $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b = {
    EDITOR_ONBOARDING_ELIGIBLE_NEW: 'editor-state:editorOnboardingEligiblity',
    EDITOR_VISITED: 'editor-state:editorVisited',
    WAS_DRAFT_BANNER_SEEN: 'editor-state:wasDraftBannerSeen',
    IS_DRAFT_BANNER_VISIBLE: 'editor-state:isDraftBannerVisible',
    IS_LAND_IN_EDITOR_BANNER_VISIBLE: 'editor-state:isLandInEditorBannerVisible',
    HAS_USER_PUBLISHED: 'editor-state:hasUserPublished',
    SUCCESS_FLAG_SEEN: 'editor-state:successFlagCompleted',
    RECENT_SPOTLIGHT_OPEN: 'editor-state:recentSpotlightOpen',
    RECENT_SPOTLIGHT_SEEN: 'editor-state:recentSpotlightCompleted',
    EDITOR_TUTORIAL_SUCCESS_FLAG_SEEN: 'editor-state:editorTutorialSuccessFlagCompleted',
    WAS_EDITOR_CONVERSION_DIALOG_SEEN: 'editor-state:wasEditorConversionModalSeen',
    WAS_EDITOR_CONVERSION_DIALOG_V3_SEEN: 'editor-state:wasEditorConversionModalV3Seen'
};
const $d59a11eb5a1dc2b2$export$1a907d3885d0a16c = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-blueprint';
const $d59a11eb5a1dc2b2$export$3cae7707c5db4087 = 'com.atlassian.confluence.plugins.confluence-onboarding:using-the-editor-template-v2-blueprint';
const $d59a11eb5a1dc2b2$export$fa405f661a23ebc5 = 'editor-onboarding';
const $d59a11eb5a1dc2b2$export$caf77613d415fe3 = [
    ...Object.values($d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b),
    $d59a11eb5a1dc2b2$export$1a907d3885d0a16c,
    $d59a11eb5a1dc2b2$export$3cae7707c5db4087
];
module.exports["EDITOR_ONBOARDING_STATE_KEYS"] = $d59a11eb5a1dc2b2$export$a5c9a23fa8bd992b;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY"] = $d59a11eb5a1dc2b2$export$1a907d3885d0a16c;
module.exports["EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED"] = $d59a11eb5a1dc2b2$export$3cae7707c5db4087;
module.exports["ONBOARDING_TUTORIAL_LABEL"] = $d59a11eb5a1dc2b2$export$fa405f661a23ebc5;
module.exports["EditorOnboardingKeys"] = $d59a11eb5a1dc2b2$export$caf77613d415fe3;

});

parcelRegister("lohHj", function(module, exports) {
const $3f26c87821b680a5$export$215d0f9cb557eff8 = 'onboarding-popular-feed-card:isDismissed';
const $3f26c87821b680a5$export$84bf53f359485dfc = [
    $3f26c87821b680a5$export$215d0f9cb557eff8
];
module.exports["FeedOnboardingKeys"] = $3f26c87821b680a5$export$84bf53f359485dfc;

});

parcelRegister("b4VFP", function(module, exports) {
const $390e454b1ae488b2$export$1d1c13df264a094 = {
    hasSeenHomeNudge: 'home-onboarding-takeover-v2:hasSeenHomeNudge',
    isHomeNudgeScheduledAt: 'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    takeoverSeenAt: 'home-onboarding-takeover-v2:takeoverSeenAt',
    onboardingActionStates: 'home-onboarding-takeover-v2:onboardingActionStates',
    isCollapsed: 'home-onboarding-takeover-v2:isCollapsed',
    hasSeenConfetti: 'home-onboarding-takeover-v2:hasSeenConfetti',
    hasDismissedCarousel: 'home-onboarding-takeover-v2:hasDismissedCarousel',
    hasDismissedLearningResources: 'home-onboarding-takeover-v2:hasDismissedLearningResources',
    hasDismissedTakeover: 'home-onboarding-takeover-v2:hasDismissedTakeover'
};
const $390e454b1ae488b2$export$3392b5b28b589b00 = Object.values($390e454b1ae488b2$export$1d1c13df264a094);
module.exports["HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS"] = $390e454b1ae488b2$export$1d1c13df264a094;
module.exports["HomeTakeoverOnboardingKeys"] = $390e454b1ae488b2$export$3392b5b28b589b00;

});

parcelRegister("d282Z", function(module, exports) {
const $a18eeb1d05dccc62$export$fc9b2402bb5adac2 = {
    CONTEXTUAL_FLOATING_BUTTON_NUDGE: 'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    AUDIO_BRIEFING: 'onboarding-insights:hasAudioBriefingChangeboardingBeenSeen',
    AUDIO_V3_CHANGEBOARDING: 'onboarding-insights:hasAudioV3ChangeboardingBeenSeen',
    FLOATING_TABLE_OF_CONTENTS: 'onboarding-insights:hasFloatingTableOfContentsBeenInteractedWith'
};
const $a18eeb1d05dccc62$export$fac0a92023e58acd = Object.values($a18eeb1d05dccc62$export$fc9b2402bb5adac2);
module.exports["ONBOARDING_INSIGHTS"] = $a18eeb1d05dccc62$export$fc9b2402bb5adac2;
module.exports["InsightsOnboardingKeys"] = $a18eeb1d05dccc62$export$fac0a92023e58acd;

});

parcelRegister("d0hiC", function(module, exports) {
const $fd31f36c9d251c72$export$3b7e7c8d78a4b783 = {
    hasDismissedBanner: 'land-in-sample-space:hasDismissedBanner',
    hasSeenSampleContentFlag: 'land-in-sample-space:hasSeenSampleContentFlag'
};
const $fd31f36c9d251c72$export$12692b0da4497e60 = Object.values($fd31f36c9d251c72$export$3b7e7c8d78a4b783);
module.exports["LandInSpampleSpaceOnboardingKeys"] = $fd31f36c9d251c72$export$12692b0da4497e60;

});

parcelRegister("9DBk6", function(module, exports) {
const $d9e19a0d44ee3302$export$b02e3be205ee7739 = {
    LIVE_PAGE_CONTEXTUAL_NUDGE_SEEN: 'live-page-nudge:wasLivePageNudgeSeen',
    // used to limit calls to the invite permissions API
    LIVE_PAGE_INVITE_INELIGIBLE: 'live-page-nudge:livePageNudgeInviteIneligible'
};
const $d9e19a0d44ee3302$export$b3d9533dbdf35d0 = Object.values($d9e19a0d44ee3302$export$b02e3be205ee7739);
module.exports["LIVE_PAGE_NUDGE"] = $d9e19a0d44ee3302$export$b02e3be205ee7739;
module.exports["LiveDocsOnboardingKeys"] = $d9e19a0d44ee3302$export$b3d9533dbdf35d0;

});

parcelRegister("isKLx", function(module, exports) {
const $d14f8037089c8dc2$export$92d46364e5595a5a = {
    SPACE_SETTINGS_CHANGEBOARDING_FIRST_SEEN_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingFirstSeenAt',
    SPACE_SETTINGS_CHANGEBOARDING_DISMISSED_AT: 'space-mission-control-onboarding:spaceSettingsChangeboardingDismissedAt'
};
const $d14f8037089c8dc2$export$d9eb44525b9507f7 = Object.values($d14f8037089c8dc2$export$92d46364e5595a5a);
module.exports["SpaceMissionControlOnboardingKeys"] = $d14f8037089c8dc2$export$d9eb44525b9507f7;

});

parcelRegister("1gy7x", function(module, exports) {
const $071869849092e495$export$d8593f7ef284bfd8 = {
    onboardingActionStates: 'personalized-templates-v2:onboardingActionStates',
    hasDismissedOnboardingActions: 'personalized-templates-v2:hasDismissedOnboardingActions',
    takeoverSeenAt: 'personalized-templates-v2:takeoverSeenAt',
    isTemplateListDismissed: 'personalized-templates-v2:isTemplateListDismissed',
    templateUsageValues: 'personalized-templates-v2:templateUsageValues'
};
const $071869849092e495$export$67c979693bf8551b = Object.values($071869849092e495$export$d8593f7ef284bfd8);
module.exports["PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS"] = $071869849092e495$export$d8593f7ef284bfd8;
module.exports["PersonalizedTemplatesOnboardingKeys"] = $071869849092e495$export$67c979693bf8551b;

});

parcelRegister("h86CY", function(module, exports) {
const $1dd4a0157170f997$export$f8474b3e5d170456 = {
    PRESENCE_ADMIN_FEEDBACK_SEEN: 'presence-feedback-survey:hasAdminSeenFeedbackSurvey'
};
const $1dd4a0157170f997$export$dcc0ca03f6f8c68d = Object.values($1dd4a0157170f997$export$f8474b3e5d170456);
module.exports["ONBOARDING_PRESENCE_ADMIN_FEEDBACK_SURVEY_KEYS"] = $1dd4a0157170f997$export$f8474b3e5d170456;
module.exports["PresenceAdminFeedbackSurveyOnboardingKeys"] = $1dd4a0157170f997$export$dcc0ca03f6f8c68d;

});

parcelRegister("jbYIt", function(module, exports) {
const $15e5f1cf9df2e13c$export$67837434b2dea54f = {
    USERS_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:usersTableSpotlightSeen',
    DEFAULTS_ROLE_TABLE_MODAL_SEEN: 'RoleBasedAccessControl:defaultsRoleTableModalSeen',
    GA_IN_PRODUCT_ONBOARDING_FLAG_SEEN: 'RoleBasedAccessControl:gaInProductOnboardingFlagSeen',
    DEFAULT_ROLE_TABLE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:defaultRoleTableSpotlightSeen',
    CUSTOM_ROLE_PAGE_SPOTLIGHT_SEEN: 'RoleBasedAccessControl:customRolePageSpotlightSeen'
};
const $15e5f1cf9df2e13c$export$134f165f9f20f01c = Object.values($15e5f1cf9df2e13c$export$67837434b2dea54f);
module.exports["ONBOARDING_ROLE_BASED_ACCESS_CONTROL"] = $15e5f1cf9df2e13c$export$67837434b2dea54f;
module.exports["RoleBasedAccessControlOnboardingKeys"] = $15e5f1cf9df2e13c$export$134f165f9f20f01c;

});

parcelRegister("ccGoc", function(module, exports) {
const $1acbcc6f3166a324$export$fa80c824b7402d9f = {
    ROVO_VIDEO_PLAYER_SEEN: 'onboarding-rovo-video-player:rovoVideoPlayerSeen'
};
const $1acbcc6f3166a324$export$d42bdf2f6333fafd = Object.values($1acbcc6f3166a324$export$fa80c824b7402d9f);
module.exports["RovoVideoPlayerStateOnboardingKeys"] = $1acbcc6f3166a324$export$d42bdf2f6333fafd;

});

parcelRegister("eoU1C", function(module, exports) {
const $b3332cb66ea1a913$export$7f1c6b461c54348b = {
    DIALOG_SPOTLIGHT_SEEN: 'random:ShareAndRestrictDialog:spotlightSeen',
    PUBLIC_LINK_FOOTER_BUTTON_SEEN: 'ShareAndRestrictDialog:editPublicLinkFooterSpotLightSeen',
    EDIT_PUBLIC_LINK_PERMISSION_SEEN: 'ShareAndRestrictDialog:editPublicLinkPermissionSpotLightSeen',
    GENERAL_AND_SPECIFIC_ACCESS_SEEN: 'ShareAndRestrictDialog:generalAndSpecificAccessSpotLightSeen',
    CTA_NOTIFY_MESSAGE_FOOTER_SEEN: 'ShareAndRestrictDialog:ctaNotifyMessageFooterSpotLightSeen'
};
const $b3332cb66ea1a913$export$e5c211f9c9c7792f = Object.values($b3332cb66ea1a913$export$7f1c6b461c54348b);
module.exports["ONBOARDING_SHARE_AND_RESTRICT_DIALOG"] = $b3332cb66ea1a913$export$7f1c6b461c54348b;
module.exports["ShareAndRestrictDialogOnboardingKeys"] = $b3332cb66ea1a913$export$e5c211f9c9c7792f;

});

parcelRegister("2wUAJ", function(module, exports) {
const $70d55b678e14166c$export$13e578b1c1856d6f = {
    FLAGS_DISMISSED_FREE_THRESHOLD: 'storage-enforcement-state:flagsDismissedFreeThreshold'
};
const $70d55b678e14166c$export$abe3d9e5b5171ebf = Object.values($70d55b678e14166c$export$13e578b1c1856d6f);
module.exports["STORAGE_ENFORCEMENT_STATE_KEYS"] = $70d55b678e14166c$export$13e578b1c1856d6f;
module.exports["StorageEnforcementOnboardingKeys"] = $70d55b678e14166c$export$abe3d9e5b5171ebf;

});

parcelRegister("6eN5W", function(module, exports) {
const $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f = {
    ACTION_MENU_OPENED: 'trial-components:actionMenuOpened',
    TRIAL_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial1DayFlag',
    TRIAL_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrial3DayFlag',
    GRACE_PERIOD_0_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning0DayFlag',
    GRACE_PERIOD_1_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning1DayFlag',
    GRACE_PERIOD_2_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning2DayFlag',
    GRACE_PERIOD_3_DAY_FLAG_DISMISSED: 'trial-components:dismissedPredunning3DayFlag',
    TRIAL_UNHANDLED_DAY_FLAG_DISMISSED: 'trial-components:dismissedTrialUnhandledDayFlag'
};
const $e04ddb4a5df5bba6$export$8001dc7a7ed753e1 = Object.values($e04ddb4a5df5bba6$export$840dd6f6c8ecd45f);
module.exports["TRIAL_COMPONENTS_EXPERIENCES"] = $e04ddb4a5df5bba6$export$840dd6f6c8ecd45f;
module.exports["TrialComponentsOnboardingKeys"] = $e04ddb4a5df5bba6$export$8001dc7a7ed753e1;

});

parcelRegister("kNKrY", function(module, exports) {
const $9b3060c835515c41$export$ff14eab135fe9584 = {
    headerSeenAt: 'create-intro-first-step:headerSeenAt',
    headerCompleted: 'create-intro-first-step:headerCompleted',
    headerDismissed: 'create-intro-first-step:headerDismissed'
};
const $9b3060c835515c41$export$1c0fd29b58a87c97 = Object.values($9b3060c835515c41$export$ff14eab135fe9584);
module.exports["CreateIntroFirstStepOnboardingStateKeys"] = $9b3060c835515c41$export$1c0fd29b58a87c97;

});

parcelRegister("lIcXr", function(module, exports) {
const $06a9ae8b05df4a8c$export$561442d092b808c6 = {
    HAS_SEEN_SPOTLIGHT: 'new-content-history-onboarding:hasSeenSpotlight1'
};
const $06a9ae8b05df4a8c$export$a8854c7bde991ac7 = Object.values($06a9ae8b05df4a8c$export$561442d092b808c6);
module.exports["NEW_CONTENT_HISTORY_ONBOARDING_STATE_KEYS"] = $06a9ae8b05df4a8c$export$561442d092b808c6;
module.exports["NewContentHistoryOnboardingStateKeys"] = $06a9ae8b05df4a8c$export$a8854c7bde991ac7;

});

parcelRegister("eyUJP", function(module, exports) {
const $37b72543ace58c19$export$a266d7c13575e674 = {
    onboardingActionStates: 'nth-user-home-onboarding-revamp:onboardingActionStates',
    areAllActionsDismissed: 'nth-user-home-onboarding-revamp:areAllActionsDismissed',
    takeoverSeenAt: 'nth-user-home-onboarding-revamp:takeoverSeenAt',
    isTemplateListDismissed: 'nth-user-home-onboarding-revamp:isTemplateListDismissed',
    templateUsageValues: 'nth-user-home-onboarding-revamp:templateUsageValues'
};
const $37b72543ace58c19$export$f9348e90ce13bd50 = Object.values($37b72543ace58c19$export$a266d7c13575e674);
module.exports["NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS"] = $37b72543ace58c19$export$a266d7c13575e674;
module.exports["NthUserHomeOnboardingRevampKeys"] = $37b72543ace58c19$export$f9348e90ce13bd50;

});

parcelRegister("eC276", function(module, exports) {
const $6acee6b0894846a1$export$fe11c6170169891b = {
    TOUR_COMPLETED: 'random:ExportJiraContextToPage:tourCompleted',
    TOUR_DISMISSED: 'random:ExportJiraContextToPage:tourDismissed'
};
const $6acee6b0894846a1$export$7eebc92289f9ff40 = Object.values($6acee6b0894846a1$export$fe11c6170169891b);
module.exports["ExportJiraContextToPageTourKeys"] = $6acee6b0894846a1$export$7eebc92289f9ff40;

});

parcelRegister("fsF73", function(module, exports) {
const $29520d740d888926$export$84bb2ff8e52d4c63 = {
    HAS_SEEN_PUBLISH_SPOTLIGHT: 'confluence-recap:hasSeenPublishSpotlight'
};
const $29520d740d888926$export$42e96b8eba35eec9 = Object.values($29520d740d888926$export$84bb2ff8e52d4c63);
module.exports["CONFLUENCE_RECAP_ONBOARDING_STATE_KEYS"] = $29520d740d888926$export$84bb2ff8e52d4c63;
module.exports["ConfluenceRecapOnboardingKeys"] = $29520d740d888926$export$42e96b8eba35eec9;

});

parcelRegister("bEwOV", function(module, exports) {
const $91bce0a19c17c87b$export$608e762b0e8c3e5d = {
    HAS_SEEN_FIRST_SNIPPET_CREATED_MODAL: 'snippets:hasSeenFirstSnippetCreatedModal',
    HAS_SEEN_SNIPPETS_TAB_SPOTLIGHT: 'snippets:hasSeenSnippetsTabSpotlight'
};
const $91bce0a19c17c87b$export$cf7ec9d4d7075704 = Object.values($91bce0a19c17c87b$export$608e762b0e8c3e5d);
module.exports["SNIPPETS_ONBOARDING"] = $91bce0a19c17c87b$export$608e762b0e8c3e5d;
module.exports["SnippetsOnboardingKeys"] = $91bce0a19c17c87b$export$cf7ec9d4d7075704;

});

parcelRegister("gGieN", function(module, exports) {
const $24bab03e25b23f73$export$df82485048e605d4 = {
    hasDismissedFlowChart: 'suggest-whiteboard-based-on-page-title:hasDismissedFlowChart',
    hasDismissedBrainstorming: 'suggest-whiteboard-based-on-page-title:hasDismissedBrainstorming',
    hasDismissedRetro: 'suggest-whiteboard-based-on-page-title:hasDismissedRetro',
    hasDismissedProductRoadmap: 'suggest-whiteboard-based-on-page-title:hasDismissedProductRoadmap',
    hasDismissedPrioritizationMatrix: 'suggest-whiteboard-based-on-page-title:hasDismissedPrioritizationMatrix',
    hasDismissedOrgChart: 'suggest-whiteboard-based-on-page-title:hasDismissedOrgChart',
    hasDismissedStickyNotePack: 'suggest-whiteboard-based-on-page-title:hasDismissedStickyNotePack',
    hasDismissedAllTemplateSuggestions: 'suggest-whiteboard-based-on-page-title:hasDismissedAllTemplateSuggestions'
};
const $24bab03e25b23f73$export$70c9c230d84d75ef = Object.values($24bab03e25b23f73$export$df82485048e605d4);
module.exports["SuggestWhiteboardBasedOnPageTitleOnboardingKeys"] = $24bab03e25b23f73$export$70c9c230d84d75ef;

});

parcelRegister("exrKs", function(module, exports) {
const $0be47723f71ecf5a$export$68726aa6479c32ea = {
    hasDismissedWritePrd: 'suggest-skill-based-on-page-title:hasDismissedWritePrd',
    hasDismissedWriteHowToArticle: 'suggest-skill-based-on-page-title:hasDismissedWriteHowToArticle',
    hasDismissedResearchInsights: 'suggest-skill-based-on-page-title:hasDismissedResearchInsights',
    hasDismissedCreateActionPlan: 'suggest-skill-based-on-page-title:hasDismissedCreateActionPlan',
    hasDismissedMarketingBriefSkill: 'suggest-skill-based-on-page-title:hasDismissedMarketingBriefSkill',
    marketingBriefSkillInteractionCount: 'suggest-skill-based-on-page-title:marketingBriefSkillInteractionCount',
    hasDismissedAllSkillSuggestions: 'suggest-skill-based-on-page-title:hasDismissedAllSkillSuggestions'
};
const $0be47723f71ecf5a$export$fde582fc9946f220 = Object.values($0be47723f71ecf5a$export$68726aa6479c32ea);
module.exports["SUGGEST_SKILL_BASED_ON_PAGE_TITLE_ONBOARDING_STATE_KEYS"] = $0be47723f71ecf5a$export$68726aa6479c32ea;
module.exports["SuggestSkillBasedOnPageTitleOnboardingKeys"] = $0be47723f71ecf5a$export$fde582fc9946f220;

});

parcelRegister("i1J1l", function(module, exports) {
const $2942cd38c2776ad9$export$589fce97fb79e61b = {
    // Planner
    hasDismissedPlannerOnce: 'suggest-agent-based-on-page-title:hasDismissedPlannerOnce',
    hasDismissedPlannerPermanently: 'suggest-agent-based-on-page-title:hasDismissedPlannerPermanently',
    hasDismissedDiscoveryAndFeedbackOnce: 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackOnce',
    hasDismissedDiscoveryAndFeedbackPermanently: 'suggest-agent-based-on-page-title:hasDismissedDiscoveryAndFeedbackPermanently',
    hasShownTechWriterContentIds: 'suggest-agent-based-on-page-title:hasShownTechWriterContentIds',
    catalogState: 'suggest-agent-based-on-page-title:catalogState'
};
const $2942cd38c2776ad9$export$ecbd342637c16a8a = Object.values($2942cd38c2776ad9$export$589fce97fb79e61b);
const $2942cd38c2776ad9$export$d3824c57be9dc0d6 = [
    $2942cd38c2776ad9$export$589fce97fb79e61b.hasDismissedPlannerPermanently,
    $2942cd38c2776ad9$export$589fce97fb79e61b.hasDismissedDiscoveryAndFeedbackPermanently
];
module.exports["SuggestAgentBasedOnPageTitleOnboardingKeys"] = $2942cd38c2776ad9$export$ecbd342637c16a8a;

});

parcelRegister("iTy0f", function(module, exports) {
const $f4695f4ca31fd51c$export$a6cb5d34cb10fc27 = {
    CHANGEBOARD_VIEWED: 'smart-link-draggable:changeboardViewed'
};
const $f4695f4ca31fd51c$export$1a93287f12972b73 = Object.values($f4695f4ca31fd51c$export$a6cb5d34cb10fc27);
module.exports["SmartLinkDraggableOnboardingKeys"] = $f4695f4ca31fd51c$export$1a93287f12972b73;

});

parcelRegister("kCtxZ", function(module, exports) {
const $f412def6e40f9ed5$export$da11b06c8a5fa7af = {
    // Set once the paste nudge has been displayed; it never shows again for this user.
    VIEWED: 'smart-folder-paste-nudge:viewed',
    // Set when the user closes the nudge with the X or Escape.
    DISMISSED: 'smart-folder-paste-nudge:dismissed'
};
const $f412def6e40f9ed5$export$98862500db5a98f9 = Object.values($f412def6e40f9ed5$export$da11b06c8a5fa7af);
module.exports["SMART_FOLDER_PASTE_NUDGE"] = $f412def6e40f9ed5$export$da11b06c8a5fa7af;
module.exports["SmartFolderPasteNudgeOnboardingKeys"] = $f412def6e40f9ed5$export$98862500db5a98f9;

});

parcelRegister("8l6NF", function(module, exports) {
/**
 * Onboarding-state keys for the admin-nav changeboarding tour. The tour is a
 * 3-step popover walkthrough shown to product admins the first time they
 * land on Confluence Admin after the RBAC admin modernization experiment
 * ships.
 */ const $aa5a5848fd75f53d$export$85befb6401d118b0 = {
    TOUR_SEEN: 'changeboarding-admin-nav-tour:tourSeen'
};
const $aa5a5848fd75f53d$export$d48b7123660bbab = [
    $aa5a5848fd75f53d$export$85befb6401d118b0.TOUR_SEEN
];
module.exports["CHANGEBOARDING_ADMIN_NAV_TOUR"] = $aa5a5848fd75f53d$export$85befb6401d118b0;
module.exports["ChangeboardingAdminNavTourOnboardingKeys"] = $aa5a5848fd75f53d$export$d48b7123660bbab;

});

parcelRegister("4UYoK", function(module, exports) {
/**
 * Onboarding-state keys for the spotlight that is anchored to the Universal
 * Create menu dropdown shown the first time a user in the Universal Create
 * (CwR) experiment cohort opens the create menu.
 */ const $88afb75838a9f8b5$export$134ea9981ab0c82e = {
    hasSeenUniversalCreateCwRExperimentSpotlight: 'universal-create-cwr-experiment-spotlight:hasSeenUniversalCreateCwRExperimentSpotlight'
};
const $88afb75838a9f8b5$export$5b55ba0fa31f0184 = Object.values($88afb75838a9f8b5$export$134ea9981ab0c82e);
module.exports["UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS"] = $88afb75838a9f8b5$export$134ea9981ab0c82e;
module.exports["UniversalCreateCwRExperimentSpotlightOnboardingKeys"] = $88afb75838a9f8b5$export$5b55ba0fa31f0184;

});

parcelRegister("8SJ0d", function(module, exports) {
const $e751a0da6bbc9c2a$export$ddd489a6d0047222 = {
    HAS_OPENED_AGENT_SESSION_FOR_YOU: 'agent-sessions:hasOpenedAgentSessionForYou',
    HAS_OPENED_AGENT_SESSION_RECENT: 'agent-sessions:hasOpenedAgentSessionRecent'
};
const $e751a0da6bbc9c2a$export$6a194dcabcfc01be = Object.values($e751a0da6bbc9c2a$export$ddd489a6d0047222);
const $e751a0da6bbc9c2a$export$8990c634eda6b687 = {
    EDITOR_MENTION_POPUP_OPEN_COUNT: 'agent-mentions:editorMentionPopupOpenCount'
};
const $e751a0da6bbc9c2a$export$3987e1c0efa7c993 = Object.values($e751a0da6bbc9c2a$export$8990c634eda6b687);
module.exports["AGENT_SESSIONS_ONBOARDING_STATE_KEYS"] = $e751a0da6bbc9c2a$export$ddd489a6d0047222;
module.exports["AgentSessionsOnboardingKeys"] = $e751a0da6bbc9c2a$export$6a194dcabcfc01be;
module.exports["AGENT_MENTIONS_ONBOARDING_STATE_KEYS"] = $e751a0da6bbc9c2a$export$8990c634eda6b687;
module.exports["AgentMentionsOnboardingKeys"] = $e751a0da6bbc9c2a$export$3987e1c0efa7c993;

});

parcelRegister("fbp8i", function(module, exports) {
const $3770fc867193c711$export$8770175d3079e1c0 = [
    'onboarding-origin-state:attributes',
    'onboarding-state:isFoundingAdmin',
    'onboarding-state:isRedactionsTourVisible',
    'onboarding-state:isContentWrapperLabelsTourDismissed',
    'onboarding-state:isMoreActionsTourVisible',
    'onboarding-state:isMoreActionsHintVisible',
    'random:ShareAndRestrictDialog:spotlightSeen',
    'home-onboarding-takeover-v2:hasSeenHomeNudge',
    'home-onboarding-takeover-v2:isHomeNudgeScheduledAt',
    'home-onboarding-takeover-v2:takeoverSeenAt',
    'home-onboarding-takeover-v2:onboardingActionStates',
    'home-onboarding-takeover-v2:isCollapsed',
    'home-onboarding-takeover-v2:hasSeenConfetti',
    'home-onboarding-takeover-v2:hasDismissedCarousel',
    'home-onboarding-takeover-v2:hasDismissedLearningResources',
    'home-onboarding-takeover-v2:hasDismissedTakeover',
    'editor-state:editorOnboardingEligiblity',
    'editor-state:editorVisited',
    'editor-state:wasDraftBannerSeen',
    'editor-state:isDraftBannerVisible',
    'editor-state:isLandInEditorBannerVisible',
    'editor-state:hasUserPublished',
    'editor-state:successFlagCompleted',
    'editor-state:recentSpotlightOpen',
    'editor-state:recentSpotlightCompleted',
    'editor-state:editorTutorialSuccessFlagCompleted',
    'editor-state:wasEditorConversionModalSeen',
    'onboarding-intent-experiences:onboardingIntentExperienceClosed',
    'onboarding-intent-experience:isOnboardingExperienceEligibleUser',
    'onboarding-intent-experiences:onboardingIntentExperienceLandViewedAt',
    'onboarding-intent-experiences:onboardingIntentExperienceLandClosed',
    'page:pagePresenceAvatarGroupSpotlightSeen',
    'page:pageTelepointerAvatarGroupSpotlightSeen',
    'whats-new-in-confluence:isWhatsNewInConfluneceSpotlightDismissed',
    'whats-new-in-confluence:whatsNewInConfluencePulseSeenAt',
    'onboarding-insights:hasContextualFloatingButtonBeenSeen',
    'trial-components:dismissedTrialnullDayFlag',
    'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
    'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen',
    'land-in-sample-space:hasDismissedBanner',
    'land-in-sample-space:hasSeenSampleContentFlag',
    'live-page-nudge:wasLivePageNudgeSeen',
    'nav4:isNav4GlobalSpotlightDismissed',
    'nav4:isNav4SpaceTourDismissed',
    'personalized-templates-v2:onboardingActionStates',
    'personalized-templates-v2:hasDismissedOnboardingActions',
    'personalized-templates-v2:takeoverSeenAt',
    'personalized-templates-v2:isTemplateListDismissed',
    'personalized-templates-v2:templateUsageValues',
    'templates-collection:isTaggedForTemplatesCollectionExperiment',
    'templates-collection:isTemplatesSectionDismissed',
    'onboarding-state:introWorkflow',
    'onboarding-state:legacy',
    'onboarding-state:isSampleContentV2SpotlightVisible',
    'onboarding-state:landOnPath',
    'onboarding-state:teamSpaceCreated',
    'onboarding-state:improvedGetStartedPath',
    'onboarding-state:improvedGetStartedWhiteboardPath',
    'nav4:isNav4CollapseReminderSpotlightDismissed',
    'storage-enforcement-state:flagsDismissedFreeThreshold',
    'onboarding-state:nthUserOnboardingFlagViewed',
    'onboarding-state:nthUserOnboardingCompletedTimestamp',
    'onboarding-state:nthUserOnboardingPageViewed',
    'onboarding-state:nthUserGSPagePath',
    'onboarding-state:nthUserBannerDismissed'
];
module.exports["PRELOADED_KEYS"] = $3770fc867193c711$export$8770175d3079e1c0;

});

parcelRegister("aqBZ0", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1f65bcd6ebccf55c$export$41b2e06f27dfe96e = 'archived';
const $1f65bcd6ebccf55c$export$e2153f1ee0381860 = 'ARCHIVE_';
const $1f65bcd6ebccf55c$export$c8e98879124fb1f0 = 'UNARCHIVE_';
const $1f65bcd6ebccf55c$export$781b73bccf46ba2c = 255;
const $1f65bcd6ebccf55c$export$ab874a69c0b17d25 = 500;
var $1f65bcd6ebccf55c$export$ca079fdb822b790f = /*#__PURE__*/ function(ArchiveStatus) {
    ArchiveStatus["LOADING"] = "loading";
    ArchiveStatus["ERROR"] = "error";
    ArchiveStatus["SUCCESS"] = "success";
    return ArchiveStatus;
}({});
const $1f65bcd6ebccf55c$export$90622b83e51be397 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $1f65bcd6ebccf55c$export$a2742df05b19b873 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/#When-content-is-inheriting-restrictions-from-parent-content';
const $1f65bcd6ebccf55c$export$9de02bef22980fc = 'https://support.atlassian.com/confluence-cloud/docs/archive-pages/#Who-can-archive-an-item';
const $1f65bcd6ebccf55c$export$45c8fb669461b6d5 = 'https://support.atlassian.com/confluence-cloud/docs/restore-archived-pages-to-the-page-tree/#Who-can-restore-an-item';
const $1f65bcd6ebccf55c$export$f71e45bebd610efa = 'archivedPageBanner';
const $1f65bcd6ebccf55c$export$7d669dd29a0917b2 = 'archive-page-banner-restore-link';
const $1f65bcd6ebccf55c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    restoreLinkMessage: {
        id: "archive-pages.page-banner.link.unarchive",
        defaultMessage: "Restore"
    },
    learnMoreLinkMessage: {
        id: "archive-pages.page-banner.link.learn-more",
        defaultMessage: "Learn more"
    },
    hasRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-restorable",
        defaultMessage: "This content is archived. Restore to make changes."
    },
    noRestoreContentPermissionBannerMessage: {
        id: "archive-pages.content-banner.message-unrestorable",
        defaultMessage: "This content is archived."
    }
});
module.exports["CONTENT_STATUS_ARCHIVED"] = $1f65bcd6ebccf55c$export$41b2e06f27dfe96e;
module.exports["ARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$e2153f1ee0381860;
module.exports["UNARCHIVE_INTL_PREFIX"] = $1f65bcd6ebccf55c$export$c8e98879124fb1f0;
module.exports["ARCHIVE_PAGES_WITH_NOTE_CHARACTER_LIMIT"] = $1f65bcd6ebccf55c$export$781b73bccf46ba2c;
module.exports["BULK_ARCHIVE_PAGE_SELECTION_LIMIT"] = $1f65bcd6ebccf55c$export$ab874a69c0b17d25;
module.exports["ArchiveStatus"] = $1f65bcd6ebccf55c$export$ca079fdb822b790f;
module.exports["PAGE_INHERITED_RESTRICTIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$a2742df05b19b873;
module.exports["ARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$9de02bef22980fc;
module.exports["UNARCHIVE_PERMISSIONS_SUPPORT_LINK"] = $1f65bcd6ebccf55c$export$45c8fb669461b6d5;
module.exports["ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE"] = $1f65bcd6ebccf55c$export$f71e45bebd610efa;
module.exports["ARCHIVED_PAGE_BANNER_RESTORE_LINK_TESTID"] = $1f65bcd6ebccf55c$export$7d669dd29a0917b2;
module.exports["i18n"] = $1f65bcd6ebccf55c$export$a7357cdd1f0b0168;

});

parcelRegister("ccWUN", function(module, exports) {
/**
 * @generated SignedSource<<655e5b5d54928e9a3dbeab0fae4a36b9>>
 * @relayHash b9d1efe6b1cd056569e39345117f0c88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81989b0b417d33031602bc94683f12b047f59581ccbc8926b307e0c037ab314c
const $462dea7d21a073f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "concreteType": "ArchivedContentMetadata",
        "kind": "LinkedField",
        "name": "archivedContentMetadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "archiveNote"
            }
        ]
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "KnownUser"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "UnknownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "ArchivedPageBannerV2_content"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b9d1efe6b1cd056569e39345117f0c88",
            "id": "81989b0b417d33031602bc94683f12b047f59581ccbc8926b307e0c037ab314c",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}},...ArchivedPageBannerV2_content}}}fragment ArchivedPageBannerV2_content on Content{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}"
        }
    };
}();
$462dea7d21a073f6$var$node.hash = "f6e1082054df2975d0307494e9090b59";
var $462dea7d21a073f6$export$2e2bcd8739ae039 = $462dea7d21a073f6$var$node;
module.exports["default"] = $462dea7d21a073f6$export$2e2bcd8739ae039;

});

parcelRegister("gFF2G", function(module, exports) {
/**
 * @generated SignedSource<<b09412736b8beecddca9546c0e2759d4>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d
const $385b63e5393fb4b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
            "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$385b63e5393fb4b0$var$node.hash = "c639141edd782146ad296893dc79f146";
var $385b63e5393fb4b0$export$2e2bcd8739ae039 = $385b63e5393fb4b0$var$node;
module.exports["default"] = $385b63e5393fb4b0$export$2e2bcd8739ae039;

});

parcelRegister("gad6U", function(module, exports) {
/**
 * @generated SignedSource<<c2d774a48c90fa70a24cdb1130a0d5d5>>
 * @relayHash 05121d91dabaeb1256fcb9012d73ba65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554
const $ad449ae2ccc67b2c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v5 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v9 = [
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ], v10 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v11 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v7 /*: any*/ ,
        v8 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAudioContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v9 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAudioContentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v12 /*: any*/ 
                                }
                            ]
                        },
                        v10 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "05121d91dabaeb1256fcb9012d73ba65",
            "id": "c83d09eb0de6a3bf710d7364431c8200591175f07d8ff8317f01a5255ea13554",
            "metadata": {},
            "name": "useAudioContentQuery",
            "operationKind": "query",
            "text": "query useAudioContentQuery($contentId:ID!){singleContent(id:$contentId){id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}}"
        }
    };
}();
$ad449ae2ccc67b2c$var$node.hash = "a697f593a36975591a0fa8257ca3e174";
var $ad449ae2ccc67b2c$export$2e2bcd8739ae039 = $ad449ae2ccc67b2c$var$node;
module.exports["default"] = $ad449ae2ccc67b2c$export$2e2bcd8739ae039;

});

parcelRegister("lKLmX", function(module, exports) {
/**
 * @generated SignedSource<<a537377ad3d9ba5f15a6476dad96f330>>
 * @relayHash 3a6f9a0ee1190046a596a1731f90472b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 009e4c6f2525de7cd21a82a03bf9fcd77ad71e8b4048515c94cc798de55fddcf
const $c7a72aad1b5e4549$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalExpirationConfig"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeApprovalsBetaFeatures"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeOtherModeReviewDetails"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherContentStatus"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "concreteType": "SpaceTypeSettings",
                "kind": "LinkedField",
                "name": "spaceTypeSettings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EnabledFeatures",
                        "kind": "LinkedField",
                        "name": "enabledFeatures",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isContentApprovalsEnabled"
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeApprovalExpirationConfig",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceSettings",
                        "kind": "LinkedField",
                        "name": "settings",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContentStateSettings",
                                "kind": "LinkedField",
                                "name": "contentStateSettings",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "ContentState",
                                        "kind": "LinkedField",
                                        "name": "spaceContentStates",
                                        "plural": true,
                                        "selections": [
                                            v9 /*: any*/ ,
                                            v10 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v12 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "success"
    }, v14 = {
        "kind": "ScalarField",
        "name": "message"
    }, v15 = {
        "kind": "ScalarField",
        "name": "isEnabled"
    }, v16 = {
        "kind": "ScalarField",
        "name": "value"
    }, v17 = {
        "kind": "ScalarField",
        "name": "principalType"
    }, v18 = {
        "kind": "ScalarField",
        "name": "principalId"
    }, v19 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v20 = {
        "kind": "ScalarField",
        "name": "isActive"
    }, v21 = {
        "kind": "ScalarField",
        "name": "isPrimary"
    }, v22 = [
        v9 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "concreteType": "AtlassianUserPhoto",
            "kind": "LinkedField",
            "name": "photos",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "condition": "includeApprovalsBetaFeatures",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    v12 /*: any*/ 
                ],
                "concreteType": "ConfluenceContentApprovalsSiteSettings",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSiteSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "enabled"
                    }
                ]
            },
            {
                "args": [
                    v12 /*: any*/ ,
                    {
                        "kind": "Literal",
                        "name": "filterSelf",
                        "value": false
                    },
                    {
                        "kind": "Variable",
                        "name": "spaceKey",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "ConfluenceContentApprovalsSpaceSettingConfigPayload",
                "kind": "LinkedField",
                "name": "confluence_contentApprovalsSpaceSettingConfig",
                "plural": false,
                "selections": [
                    v13 /*: any*/ ,
                    {
                        "concreteType": "MutationError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v14 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceContentApprovalsSpaceSettingConfig",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "disallowFirstPublish"
                            },
                            {
                                "condition": "includeApprovalExpirationConfig",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "concreteType": "ConfluenceApprovalExpirationConfig",
                                        "kind": "LinkedField",
                                        "name": "approvalExpirationConfig",
                                        "plural": false,
                                        "selections": [
                                            v15 /*: any*/ ,
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationInterval",
                                                "kind": "LinkedField",
                                                "name": "interval",
                                                "plural": false,
                                                "selections": [
                                                    v16 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "unit"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "restartApproval"
                                            },
                                            {
                                                "concreteType": "ConfluenceApprovalExpirationChangeStatus",
                                                "kind": "LinkedField",
                                                "name": "changeStatus",
                                                "plural": false,
                                                "selections": [
                                                    v15 /*: any*/ ,
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "expireToContentStateId"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                "concreteType": "ConfluenceApprovalReviewerConfig",
                                "kind": "LinkedField",
                                "name": "enforcedApprovalReviewerConfig",
                                "plural": false,
                                "selections": [
                                    v15 /*: any*/ ,
                                    {
                                        "concreteType": "ConfluenceSpaceApprovalReviewerEntry",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                            v17 /*: any*/ ,
                                            v18 /*: any*/ ,
                                            {
                                                "concreteType": "AtlassianUser",
                                                "kind": "LinkedField",
                                                "name": "user",
                                                "plural": false,
                                                "selections": v22 /*: any*/ 
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v24 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "status"
    }, v26 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "number"
            }
        ]
    }, v27 = {
        "args": [
            v12 /*: any*/ ,
            {
                "kind": "Variable",
                "name": "transitionType",
                "variableName": "transitionType"
            }
        ],
        "concreteType": "ConfluenceApprovalsWorkflowStatus",
        "kind": "LinkedField",
        "name": "confluence_contentApprovalStatuses",
        "plural": true,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "allowsReviews"
            },
            {
                "concreteType": "ConfluenceApprovalsWorkflowStatusDisplayProperties",
                "kind": "LinkedField",
                "name": "displayProperties",
                "plural": false,
                "selections": [
                    v10 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    }
                ]
            }
        ]
    }, v28 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v29 = {
        "kind": "Literal",
        "name": "fetchWorkflowReview",
        "value": true
    }, v30 = {
        "kind": "Literal",
        "name": "workflowId",
        "value": "1"
    }, v31 = [
        v12 /*: any*/ ,
        v28 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "otherContentStatus"
        },
        v29 /*: any*/ ,
        v30 /*: any*/ 
    ], v32 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v33 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v34 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    v32 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "reviewStatus"
    }, v36 = {
        "kind": "ScalarField",
        "name": "creatorAaid"
    }, v37 = {
        "kind": "ScalarField",
        "name": "reviewComment"
    }, v38 = {
        "kind": "ScalarField",
        "name": "decisionId"
    }, v39 = {
        "kind": "ScalarField",
        "name": "reviewerId"
    }, v40 = {
        "kind": "ScalarField",
        "name": "required"
    }, v41 = {
        "kind": "ScalarField",
        "name": "reviewerDecisionStatus"
    }, v42 = {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
            v21 /*: any*/ ,
            v16 /*: any*/ 
        ]
    }, v43 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v35 /*: any*/ ,
            {
                "condition": "includeOtherModeReviewDetails",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v36 /*: any*/ ,
                    v37 /*: any*/ ,
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "creator",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            v19 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "ConfluenceReviewerDecisionInfo",
                        "kind": "LinkedField",
                        "name": "reviewerDecisions",
                        "plural": true,
                        "selections": [
                            v38 /*: any*/ ,
                            v39 /*: any*/ ,
                            v40 /*: any*/ ,
                            v17 /*: any*/ ,
                            v18 /*: any*/ ,
                            v41 /*: any*/ ,
                            {
                                "concreteType": "AtlassianUser",
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                    v9 /*: any*/ ,
                                    v19 /*: any*/ ,
                                    v42 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v44 = [
        v12 /*: any*/ ,
        v28 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "contentStatus",
            "variableName": "contentStatus"
        },
        {
            "kind": "Variable",
            "name": "fetchExpiryDate",
            "variableName": "includeApprovalExpirationConfig"
        },
        v29 /*: any*/ ,
        v30 /*: any*/ 
    ], v45 = {
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "creator",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v46 = [
        v16 /*: any*/ 
    ], v47 = {
        "concreteType": "ConfluenceWorkflowApplicationDetails",
        "kind": "LinkedField",
        "name": "workflowApplication",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "workflowId"
            },
            {
                "kind": "ScalarField",
                "name": "contentId"
            },
            {
                "kind": "ScalarField",
                "name": "contentVersion"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "kind": "ScalarField",
                "name": "workflowStatusId"
            },
            v20 /*: any*/ ,
            v45 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "lastModificationDate",
                "plural": false,
                "selections": v46 /*: any*/ 
            },
            {
                "concreteType": "AtlassianUser",
                "kind": "LinkedField",
                "name": "modifier",
                "plural": false,
                "selections": v22 /*: any*/ 
            }
        ]
    }, v48 = {
        "concreteType": "ConfluenceWorkflowReviewWithDecisions",
        "kind": "LinkedField",
        "name": "workflowReviewWithDecisions",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v36 /*: any*/ ,
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "creationDate",
                "plural": false,
                "selections": v46 /*: any*/ 
            },
            v35 /*: any*/ ,
            v37 /*: any*/ ,
            {
                "condition": "includeApprovalsBetaFeatures",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "dueDate",
                        "plural": false,
                        "selections": v46 /*: any*/ 
                    }
                ]
            },
            {
                "condition": "includeApprovalExpirationConfig",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "expiryDate",
                        "plural": false,
                        "selections": v46 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "ConfluenceApprovalsDate",
                "kind": "LinkedField",
                "name": "reviewLastModified",
                "plural": false,
                "selections": v46 /*: any*/ 
            },
            v45 /*: any*/ ,
            {
                "concreteType": "ConfluenceReviewerDecisionInfo",
                "kind": "LinkedField",
                "name": "reviewerDecisions",
                "plural": true,
                "selections": [
                    v38 /*: any*/ ,
                    v39 /*: any*/ ,
                    v40 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v41 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "comment"
                    },
                    {
                        "concreteType": "ConfluenceApprovalsDate",
                        "kind": "LinkedField",
                        "name": "lastModifiedDate",
                        "plural": false,
                        "selections": v46 /*: any*/ 
                    },
                    {
                        "concreteType": "AtlassianUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v9 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v42 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v49 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            v14 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "__typename"
                    },
                    v32 /*: any*/ ,
                    v33 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v9 /*: any*/ 
                        ],
                        "type": "BulkMutationErrorExtension"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v11 /*: any*/ ,
                v23 /*: any*/ ,
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v27 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v31 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v13 /*: any*/ ,
                        v34 /*: any*/ ,
                        v43 /*: any*/ 
                    ]
                },
                {
                    "args": v44 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v13 /*: any*/ ,
                        v34 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ApprovalsContextApprovalsDataQuery",
            "selections": [
                v11 /*: any*/ ,
                v23 /*: any*/ ,
                {
                    "args": v24 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v25 /*: any*/ ,
                                v26 /*: any*/ ,
                                v9 /*: any*/ 
                            ]
                        }
                    ]
                },
                v27 /*: any*/ ,
                {
                    "alias": "confluence_getActiveWorkflowApplicationForOtherStatus",
                    "args": v31 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v13 /*: any*/ ,
                        v49 /*: any*/ ,
                        v43 /*: any*/ 
                    ]
                },
                {
                    "args": v44 /*: any*/ ,
                    "concreteType": "ConfluenceWorkflowApplicationPayload",
                    "kind": "LinkedField",
                    "name": "confluence_getActiveWorkflowApplication",
                    "plural": false,
                    "selections": [
                        v13 /*: any*/ ,
                        v49 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3a6f9a0ee1190046a596a1731f90472b",
            "id": "009e4c6f2525de7cd21a82a03bf9fcd77ad71e8b4048515c94cc798de55fddcf",
            "metadata": {},
            "name": "ApprovalsContextApprovalsDataQuery",
            "operationKind": "query",
            "text": "query ApprovalsContextApprovalsDataQuery($cloudId:ID!,$contentId:ID!,$contentStatus:String!,$otherContentStatus:String!,$transitionType:ConfluenceApprovalTransitionType,$spaceKey:String!,$includeApprovalsBetaFeatures:Boolean!,$includeApprovalExpirationConfig:Boolean!,$includeOtherModeReviewDetails:Boolean!){space(key:$spaceKey){id,spaceTypeSettings{enabledFeatures{isContentApprovalsEnabled}},settings@include(if:$includeApprovalExpirationConfig){contentStateSettings{spaceContentStates{id,name}}}},confluence_contentApprovalsSiteSettings(cloudId:$cloudId)@include(if:$includeApprovalsBetaFeatures){enabled}\n  confluence_contentApprovalsSpaceSettingConfig(cloudId:$cloudId,spaceKey:$spaceKey,filterSelf:false)@include(if:$includeApprovalsBetaFeatures){success,errors{message},config{disallowFirstPublish,approvalExpirationConfig@include(if:$includeApprovalExpirationConfig){isEnabled,interval{value,unit},restartApproval,changeStatus{isEnabled,expireToContentStateId}},enforcedApprovalReviewerConfig{isEnabled,reviewers{principalType,principalId,user{id,displayName,isActive,photos{value,isPrimary}}}}}},content(id:$contentId){nodes{status,version{number},id}},confluence_contentApprovalStatuses(cloudId:$cloudId,transitionType:$transitionType){id,allowsReviews,displayProperties{name,color}},confluence_getActiveWorkflowApplicationForOtherStatus:confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$otherContentStatus,workflowId:\"1\",fetchWorkflowReview:true){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowReviewWithDecisions{id,reviewStatus,creatorAaid@include(if:$includeOtherModeReviewDetails)\n      reviewComment@include(if:$includeOtherModeReviewDetails)\n      creator@include(if:$includeOtherModeReviewDetails){id,displayName}\n      reviewerDecisions@include(if:$includeOtherModeReviewDetails){decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,user{id,displayName,photos{isPrimary,value}}}}},confluence_getActiveWorkflowApplication(cloudId:$cloudId,contentId:$contentId,contentStatus:$contentStatus,workflowId:\"1\",fetchWorkflowReview:true,fetchExpiryDate:$includeApprovalExpirationConfig){success,errors{message,extensions{__typename,statusCode,errorType,...on BulkMutationErrorExtension{id}}},workflowApplication{id,workflowId,contentId,contentVersion,contentStatus,workflowStatusId,isActive,creator{id,displayName,isActive,photos{value,isPrimary}},lastModificationDate{value},modifier{id,displayName,isActive,photos{value,isPrimary}}},workflowReviewWithDecisions{id,creatorAaid,creationDate{value},reviewStatus,reviewComment,dueDate@include(if:$includeApprovalsBetaFeatures){value},expiryDate@include(if:$includeApprovalExpirationConfig){value},reviewLastModified{value},creator{id,displayName,isActive,photos{value,isPrimary}},reviewerDecisions{decisionId,reviewerId,required,principalType,principalId,reviewerDecisionStatus,comment,lastModifiedDate{value},user{id,displayName,isActive,photos{isPrimary,value}}}}}}"
        }
    };
}();
$c7a72aad1b5e4549$var$node.hash = "b629f1cf67aaa014b8d2d49727153516";
var $c7a72aad1b5e4549$export$2e2bcd8739ae039 = $c7a72aad1b5e4549$var$node;
module.exports["default"] = $c7a72aad1b5e4549$export$2e2bcd8739ae039;

});

parcelRegister("iOp5s", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");

const $e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE = 'Approvals are disabled';
const $e8d397546331cd08$var$isApprovalsDisabledGraphQLError = (error)=>Boolean(error.message?.includes($e8d397546331cd08$var$APPROVALS_DISABLED_ERROR_MESSAGE));
const $e8d397546331cd08$export$b724ffcdc4a2c130 = (error)=>{
    if (!error) return false;
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    if (graphQLErrors?.length) return graphQLErrors.every($e8d397546331cd08$var$isApprovalsDisabledGraphQLError);
    return $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(error);
};
const $e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled = (error)=>{
    (0, $7Sm4c.markErrorAsHandled)(error);
    const originalCause = error.originalError?.cause;
    if (originalCause && $e8d397546331cd08$var$isApprovalsDisabledGraphQLError(originalCause)) (0, $7Sm4c.markErrorAsHandled)(originalCause);
};
const $e8d397546331cd08$export$50302788ce0889ee = (error)=>{
    if (!error || !$e8d397546331cd08$export$b724ffcdc4a2c130(error)) return;
    (0, $7Sm4c.markErrorAsHandled)(error);
    const graphQLErrors = 'graphQLErrors' in error ? error.graphQLErrors : undefined;
    graphQLErrors?.forEach($e8d397546331cd08$var$markGraphQLErrorAndCauseAsHandled);
};
module.exports["isApprovalsDisabledError"] = $e8d397546331cd08$export$b724ffcdc4a2c130;
module.exports["markApprovalsDisabledErrorAsHandled"] = $e8d397546331cd08$export$50302788ce0889ee;

});

parcelRegister("c5JFM", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $c8d6014c9c636b97$export$7c5b1b3e3108671e = ()=>// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-ht-gate') || (0, $9wGTI.fg)('twcg-2202-loom-meeting-nudge-lt-gate');
module.exports["isMeetingRecorderEligibilityEnabled"] = $c8d6014c9c636b97$export$7c5b1b3e3108671e;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("7tHGa", function(module, exports) {
var $c76572742e8d6c54$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "CURRENT";
    ContentStatus["DRAFT"] = "DRAFT";
    ContentStatus["ARCHIVED"] = "ARCHIVED";
    return ContentStatus;
}({});
module.exports["ContentStatus"] = $c76572742e8d6c54$export$b2be22e9d5dd3927;

});

parcelRegister("79mss", function(module, exports) {
/**
 * @generated SignedSource<<217ed72306ad0003c83611da9b9dfec7>>
 * @relayHash 02343eb4ab11fc6471bc117cd9c349d2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d
const $22165adc85ae14ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevel",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "02343eb4ab11fc6471bc117cd9c349d2",
            "id": "2f9794fe079d8566f47a9f279f6b1eb86fd6f7441be80aea326be0f0bc4e003d",
            "metadata": {},
            "name": "useContentClassificationContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevel{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$22165adc85ae14ea$var$node.hash = "e2a3c90b94181436fe0a32faafb92cf6";
var $22165adc85ae14ea$export$2e2bcd8739ae039 = $22165adc85ae14ea$var$node;
module.exports["default"] = $22165adc85ae14ea$export$2e2bcd8739ae039;

});

parcelRegister("kJOuS", function(module, exports) {
/**
 * @generated SignedSource<<1ecb2a6d2d19295fae62133387181821>>
 * @relayHash ab62c7356a626dc786625f88620a3290
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 32cd7cbe2ba59d5f06327d98298806c00a63ac71489e6313e3c4721adcb64c66
const $c19c25ac6851ffdf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "lowerCaseContentStatusArray"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "lowerCaseContentStatusArray"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ClassificationLevelDetails",
                    "kind": "LinkedField",
                    "name": "classificationLevelDetails",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentDataClassificationLevel",
                            "kind": "LinkedField",
                            "name": "classificationLevelV2",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "guideline"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "guidelineADF"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "description"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "color"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "featureEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "source"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isReclassificationPermitted"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canManageSpaceSettings"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "classificationControlSetting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userOverrideSetting"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentClassificationV2ContentDataClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentClassificationV2ContentDataClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ab62c7356a626dc786625f88620a3290",
            "id": "32cd7cbe2ba59d5f06327d98298806c00a63ac71489e6313e3c4721adcb64c66",
            "metadata": {},
            "name": "useContentClassificationV2ContentDataClassificationQuery",
            "operationKind": "query",
            "text": "query useContentClassificationV2ContentDataClassificationQuery($contentId:ID!,$lowerCaseContentStatusArray:[String]){singleContent(id:$contentId,status:$lowerCaseContentStatusArray){id,classificationLevelDetails{classificationLevelV2{id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}}"
        }
    };
}();
$c19c25ac6851ffdf$var$node.hash = "bdf80caa76bbd41df830127b1a3309c9";
var $c19c25ac6851ffdf$export$2e2bcd8739ae039 = $c19c25ac6851ffdf$var$node;
module.exports["default"] = $c19c25ac6851ffdf$export$2e2bcd8739ae039;

});

parcelRegister("gSfo4", function(module, exports) {

var $7tHGa = parcelRequire("7tHGa");

const $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap = {
    [(0, $7tHGa.ContentStatus).CURRENT]: 'current',
    [(0, $7tHGa.ContentStatus).DRAFT]: 'draft',
    [(0, $7tHGa.ContentStatus).ARCHIVED]: 'archived'
};
const $d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus = (status)=>{
    return $d569ee9ba15fe187$var$classificationContentStatusEnumToSingleContentSearchArrayMap[status];
};
const $d569ee9ba15fe187$export$930e5fd4dd47a5f1 = (statuses)=>{
    return statuses.map((status)=>$d569ee9ba15fe187$var$getSingleContentStatusStringFromClassificationStatus(status)).filter(Boolean);
};
module.exports["getQuerySingleContentStatusArrayVariable"] = $d569ee9ba15fe187$export$930e5fd4dd47a5f1;

});

parcelRegister("d3OVq", function(module, exports) {
/**
 * @generated SignedSource<<a13cd2a1d29aae2129c9a2a32580afb2>>
 * @relayHash 08655b5a07a80d6db6123fa2b954538c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22
const $49f91628ee52d08c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "width"
    }, v5 = {
        "kind": "ScalarField",
        "name": "height"
    }, v6 = [
        v2 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v7 = {
        "concreteType": "MapOfStringToString",
        "kind": "LinkedField",
        "name": "hoverOrFocus",
        "plural": true,
        "selections": v6 /*: any*/ 
    }, v8 = {
        "kind": "ScalarField",
        "name": "color"
    }, v9 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v10 = [
        v9 /*: any*/ ,
        v8 /*: any*/ 
    ], v11 = [
        v8 /*: any*/ ,
        v7 /*: any*/ 
    ], v12 = {
        "kind": "ScalarField",
        "name": "background"
    }, v13 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v14 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v15 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v16 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v17 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v18 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v19 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v20 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v21 = [
        v12 /*: any*/ ,
        v9 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "padding"
        },
        {
            "kind": "ScalarField",
            "name": "borderRadius"
        }
    ], v22 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                },
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "isDefault"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "SpaceSettings",
                            "kind": "LinkedField",
                            "name": "settings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "routeOverrideEnabled"
                                }
                            ]
                        },
                        {
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "themeKey"
                                }
                            ]
                        },
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "headings",
                                    "plural": true,
                                    "selections": v6 /*: any*/ 
                                },
                                {
                                    "concreteType": "MenusLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "menus",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "HeaderLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        {
                                            "concreteType": "ButtonLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "button",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "NavigationLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "primaryNavigation",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "NavigationLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "secondaryNavigation",
                                            "plural": false,
                                            "selections": v11 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "SearchFieldLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "search",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ScreenLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "screen",
                                            "plural": false,
                                            "selections": [
                                                v12 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v14 /*: any*/ ,
                                                v15 /*: any*/ ,
                                                v16 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                {
                                                    "concreteType": "LayerScreenLookAndFeel",
                                                    "kind": "LinkedField",
                                                    "name": "layer",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterTop"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterRight"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterBottom"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "gutterLeft"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "container",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "header",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        },
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "body",
                                            "plural": false,
                                            "selections": v21 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "SpaceMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "prefix"
                                                },
                                                v3 /*: any*/ ,
                                                v1 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceBaseQueryBaseQuery",
            "selections": v22 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceBaseQueryBaseQuery",
            "selections": v22 /*: any*/ 
        },
        "params": {
            "cacheID": "08655b5a07a80d6db6123fa2b954538c",
            "id": "6a03e95f43b1257f84130aca2fcbdeff6cdf7b832e117cacf3d0b825870beb22",
            "metadata": {},
            "name": "useSpaceBaseQueryBaseQuery",
            "operationKind": "query",
            "text": "query useSpaceBaseQueryBaseQuery($spaceKey:String){spaces(spaceKey:$spaceKey){nodes{id,key,alias,name,homepage{id},icon{path,width,height,isDefault},type,settings{routeOverrideEnabled},theme{themeKey},lookAndFeel{headings{key,value},menus{hoverOrFocus{key,value},color},header{backgroundColor,button{backgroundColor,color},primaryNavigation{color,hoverOrFocus{key,value}},secondaryNavigation{color,hoverOrFocus{key,value}},search{backgroundColor,color}},content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},header{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius},body{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},metadata{labels{nodes{prefix,name,id}}},operations{operation,targetType}}}}"
        }
    };
}();
$49f91628ee52d08c$var$node.hash = "e885d5c349d4cf19afe686a9f6747925";
var $49f91628ee52d08c$export$2e2bcd8739ae039 = $49f91628ee52d08c$var$node;
module.exports["default"] = $49f91628ee52d08c$export$2e2bcd8739ae039;

});

parcelRegister("ixL26", function(module, exports) {
/**
 * @generated SignedSource<<fbb30a8834043aa8efe95e491818e212>>
 * @relayHash d6be154debcc9cc4834278390fc53126
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b
const $0d2a1fbf3179ce94$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "excludeOperations"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "theme",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "themeKey"
                        }
                    ]
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "condition": "excludeOperations",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SpaceOverviewQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "d6be154debcc9cc4834278390fc53126",
            "id": "2aa0ed74afe3b72eb6db76d715d8da108ed70a4d3568c05987cecb7b3770645b",
            "metadata": {},
            "name": "SpaceOverviewQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewQuery($spaceKey:String!,$excludeOperations:Boolean!){space(key:$spaceKey){id,currentUser{isAdmin},name,type,theme{themeKey},icon{path},homepage{id,operations@skip(if:$excludeOperations){operation},properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}}}}}"
        }
    };
}();
$0d2a1fbf3179ce94$var$node.hash = "800c4a5e07b722b2b0e454947ac55f3c";
var $0d2a1fbf3179ce94$export$2e2bcd8739ae039 = $0d2a1fbf3179ce94$var$node;
module.exports["default"] = $0d2a1fbf3179ce94$export$2e2bcd8739ae039;

});

parcelRegister("3hHGU", function(module, exports) {
/**
 * @generated SignedSource<<97883e4f3341dc8eee867b0d2022b8b6>>
 * @relayHash 167c1a5fbdbb53604f3f562e570f1f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030
const $02fb880a65c09e36$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "isPinned"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ConfluenceSmartSpaceOverview",
            "kind": "LinkedField",
            "name": "confluence_smartSpaceOverview",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewFAQ",
                    "kind": "LinkedField",
                    "name": "faq",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewFAQEntry",
                            "kind": "LinkedField",
                            "name": "entries",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "question"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "answer"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "followUpQuestions"
                                },
                                {
                                    "concreteType": "ConfluenceSmartSpaceOverviewFAQSource",
                                    "kind": "LinkedField",
                                    "name": "sources",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                },
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "excerpt"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "embeddedProduct"
                                                },
                                                {
                                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                    "kind": "LinkedField",
                                                    "name": "links",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "webui"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceSmartSpaceOverviewTopLinks",
                    "kind": "LinkedField",
                    "name": "topLinks",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "contentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "lastRefreshed"
                        },
                        {
                            "concreteType": "ConfluenceSmartSpaceOverviewTopLink",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewSwitcherQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "167c1a5fbdbb53604f3f562e570f1f91",
            "id": "9aa276284b5516cde1d9f7f8b3fe7215cd9ebb9294f9ac504abc7c452e599030",
            "metadata": {},
            "name": "SpaceOverviewSwitcherQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewSwitcherQuery($cloudId:ID!,$spaceKey:String!){confluence_smartSpaceOverview(cloudId:$cloudId,spaceKey:$spaceKey){summary{body,isPinned},faq{entries{question,answer,followUpQuestions,sources{content{id,title,excerpt,embeddedProduct,links{webui}}}}},topLinks{contentId,lastRefreshed,links{isPinned,title,url}}}}"
        }
    };
}();
$02fb880a65c09e36$var$node.hash = "1b64f396256f01419c73a81884314905";
var $02fb880a65c09e36$export$2e2bcd8739ae039 = $02fb880a65c09e36$var$node;
module.exports["default"] = $02fb880a65c09e36$export$2e2bcd8739ae039;

});

parcelRegister("jpSPX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $cEgMD = parcelRequire("cEgMD");


var $8Psje = parcelRequire("8Psje");

const $d271b30f20f80b69$export$bb12d233342ab079 = ({ spaceKey: spaceKey, isRovoEnabled: isRovoEnabled, cloudId: cloudId })=>Boolean(cloudId) && !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && !(0, $8Psje.isRovoSystemSpaceKey)(spaceKey) && isRovoEnabled && (0, $6mKj3.expVal)('smart_space_overview', 'isEnabled', false);
module.exports["isSmartSpaceOverviewEnabled"] = $d271b30f20f80b69$export$bb12d233342ab079;

});

parcelRegister("8Psje", function(module, exports) {
const $5c0c9a15440579bc$export$fb74cd09fc20f0c3 = (spaceKey)=>{
    if (!spaceKey) return false;
    return spaceKey.startsWith('~ROVO') && spaceKey.endsWith('~');
};
module.exports["isRovoSystemSpaceKey"] = $5c0c9a15440579bc$export$fb74cd09fc20f0c3;

});

parcelRegister("d5h4f", function(module, exports) {
/**
 * @generated SignedSource<<c66496c25cb521f876dac5a42fd2fcd2>>
 * @relayHash 237b04f22d9b44361b6e9b7436f12aa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 995bea55a94fd3b763d25f287ae43c4506bba32bd0abef2bf4de024e2ba46bf9
const $9de934dc3b27501e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentVersion"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "referenceId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "hasRestrictions"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
    }, v10 = {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "kind": "ScalarField",
        "name": "type"
    }, v14 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v4 /*: any*/ ,
            v13 /*: any*/ ,
            v6 /*: any*/ ,
            v15 /*: any*/ 
        ]
    }, v17 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "value"
    }, v19 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "import-source",
                    "imported-page-modified-date"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v12 /*: any*/ ,
                    v18 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"import-source\",\"imported-page-modified-date\"])"
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v21 = {
        "kind": "InlineFragment",
        "selections": v20 /*: any*/ ,
        "type": "KnownUser"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": v20 /*: any*/ ,
        "type": "UnknownUser"
    }, v23 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v24 = [
        v4 /*: any*/ 
    ], v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "first",
                "value": 10
            },
            v23 /*: any*/ 
        ],
        "concreteType": "PaginatedSpaceList",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": false,
        "selections": [
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    v11 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "homepage",
                        "plural": false,
                        "selections": v24 /*: any*/ 
                    }
                ]
            }
        ]
    }, v26 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "concreteType": "ConfluenceUser",
                "kind": "LinkedField",
                "name": "confluence",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": v24 /*: any*/ 
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v27 = {
        "args": v3 /*: any*/ ,
        "kind": "ScalarField",
        "name": "paywallStatus"
    }, v28 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v29 = [
        v28 /*: any*/ 
    ], v30 = {
        "args": v29 /*: any*/ ,
        "concreteType": "CanvasToken",
        "kind": "LinkedField",
        "name": "canvasToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "token"
            }
        ]
    }, v31 = [
        v18 /*: any*/ 
    ], v32 = {
        "args": v29 /*: any*/ ,
        "concreteType": "ContentMediaSession",
        "kind": "LinkedField",
        "name": "contentMediaSession",
        "plural": false,
        "selections": [
            {
                "concreteType": "MediaAccessTokens",
                "kind": "LinkedField",
                "name": "accessTokens",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MediaToken",
                        "kind": "LinkedField",
                        "name": "readOnlyToken",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    },
                    {
                        "concreteType": "MediaToken",
                        "kind": "LinkedField",
                        "name": "readWriteToken",
                        "plural": false,
                        "selections": v31 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "configuration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fileStoreUrl"
                    }
                ]
            }
        ]
    }, v33 = [
        {
            "kind": "ScalarField",
            "name": "isEntitled"
        }
    ], v34 = {
        "concreteType": "Entitlements",
        "kind": "LinkedField",
        "name": "entitlements",
        "plural": false,
        "selections": [
            {
                "concreteType": "WhiteboardFeatures",
                "kind": "LinkedField",
                "name": "whiteboardFeatures",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SmartConnectorsFeature",
                        "kind": "LinkedField",
                        "name": "smartConnectors",
                        "plural": false,
                        "selections": v33 /*: any*/ 
                    },
                    {
                        "concreteType": "SmartSectionsFeature",
                        "kind": "LinkedField",
                        "name": "smartSections",
                        "plural": false,
                        "selections": v33 /*: any*/ 
                    }
                ]
            }
        ]
    }, v35 = {
        "kind": "Literal",
        "name": "contentStatus",
        "value": "CURRENT"
    }, v36 = {
        "kind": "Variable",
        "name": "contentVersion",
        "variableName": "contentVersion"
    }, v37 = [
        {
            "kind": "ScalarField",
            "name": "allowed"
        }
    ], v38 = {
        "concreteType": "Confluence_dataSecurityPolicy",
        "kind": "LinkedField",
        "name": "dataSecurityPolicy",
        "plural": false,
        "selections": [
            {
                "alias": "isExportAllowed",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "action",
                        "value": "PAGE_EXPORT"
                    },
                    v28 /*: any*/ ,
                    v35 /*: any*/ ,
                    v36 /*: any*/ ,
                    v23 /*: any*/ 
                ],
                "concreteType": "DataSecurityPolicyDecision",
                "kind": "LinkedField",
                "name": "isActionEnabledForContent",
                "plural": false,
                "selections": v37 /*: any*/ 
            },
            {
                "alias": "isDownloadAllowed",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "action",
                        "value": "ATTACHMENT_DOWNLOAD"
                    },
                    v28 /*: any*/ ,
                    v35 /*: any*/ ,
                    v36 /*: any*/ ,
                    v23 /*: any*/ 
                ],
                "concreteType": "DataSecurityPolicyDecision",
                "kind": "LinkedField",
                "name": "isActionEnabledForContent",
                "plural": false,
                "selections": v37 /*: any*/ 
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WhiteboardUnifiedQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v14 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v30 /*: any*/ ,
                v32 /*: any*/ ,
                v34 /*: any*/ ,
                v38 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WhiteboardUnifiedQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v14 /*: any*/ ,
                                v13 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v19 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v30 /*: any*/ ,
                v32 /*: any*/ ,
                v34 /*: any*/ ,
                v38 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "237b04f22d9b44361b6e9b7436f12aa7",
            "id": "995bea55a94fd3b763d25f287ae43c4506bba32bd0abef2bf4de024e2ba46bf9",
            "metadata": {},
            "name": "WhiteboardUnifiedQuery",
            "operationKind": "query",
            "text": "query WhiteboardUnifiedQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status},metadata{currentuser{favourited{isFavourite}},lastModifiedDate},properties(keys:[\"import-source\",\"imported-page-modified-date\"]){nodes{key,value}},history{createdBy{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,confluence{space{id}}},paywallStatus(id:$contentId),canvasToken(contentId:$contentId){token},contentMediaSession(contentId:$contentId){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl}},entitlements{whiteboardFeatures{smartConnectors{isEntitled},smartSections{isEntitled}}},dataSecurityPolicy{isExportAllowed:isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed},isDownloadAllowed:isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
        }
    };
}();
$9de934dc3b27501e$var$node.hash = "3a27147e54d7dc7fee56b195174180ed";
var $9de934dc3b27501e$export$2e2bcd8739ae039 = $9de934dc3b27501e$var$node;
module.exports["default"] = $9de934dc3b27501e$export$2e2bcd8739ae039;

});

parcelRegister("kwaj3", function(module, exports) {
/**
 * @generated SignedSource<<82a5121e796d7d88be54dc18b0c66612>>
 * @relayHash 7a46b279c61b3080707b64c6f2a92e47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f9ec01d56a841624c18f4cc3a1a96a06f53f806043d4f21f968b593c8ea5b1c7
const $80d237b89b6ac744$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "7a46b279c61b3080707b64c6f2a92e47",
            "id": "f9ec01d56a841624c18f4cc3a1a96a06f53f806043d4f21f968b593c8ea5b1c7",
            "metadata": {},
            "name": "SpaceQuery",
            "operationKind": "query",
            "text": "query SpaceQuery($spaceKey:String){space(key:$spaceKey){id,name,icon{path},homepage{id}}}"
        }
    };
}();
$80d237b89b6ac744$var$node.hash = "6eceb4fc897c8a684e865776c35134e0";
var $80d237b89b6ac744$export$2e2bcd8739ae039 = $80d237b89b6ac744$var$node;
module.exports["default"] = $80d237b89b6ac744$export$2e2bcd8739ae039;

});

parcelRegister("bcVE2", function(module, exports) {
const $234cfa339ee54346$var$isQueryParamPresent = (value)=>Array.isArray(value) ? value.length > 0 : Boolean(value);
const $234cfa339ee54346$export$ca840bf5ed4ee034 = ({ parentProduct: parentProduct, presentationMode: presentationMode })=>$234cfa339ee54346$var$isQueryParamPresent(parentProduct) || $234cfa339ee54346$var$isQueryParamPresent(presentationMode);
module.exports["isEmbeddedWhiteboardMode"] = $234cfa339ee54346$export$ca840bf5ed4ee034;

});

parcelRegister("c7BJC", function(module, exports) {
/**
 * @generated SignedSource<<7480b5813e71e947657f66416e8eb77e>>
 * @relayHash 3d5107055d0ad5e5fed0e694feb80f1c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5acb81487b5b5127dead4c25a310545e5437aad4717ee4c6f1d7a5a5a6c6614e
const $0040230a36fc338e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentVersion"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v9 = [
        v3 /*: any*/ 
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v11 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v12 = {
        "kind": "Literal",
        "name": "contentStatus",
        "value": "CURRENT"
    }, v13 = {
        "kind": "Variable",
        "name": "contentVersion",
        "variableName": "contentVersion"
    }, v14 = [
        {
            "kind": "ScalarField",
            "name": "allowed"
        }
    ], v15 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "referenceId"
                        },
                        v4 /*: any*/ ,
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasViewRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasInheritedRestrictions"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v6 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                v6 /*: any*/ ,
                                v4 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                },
                v8 /*: any*/ 
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v10 /*: any*/ 
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v10 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "locale"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": v9 /*: any*/ 
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "alias": "isExportAllowed",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "action",
                            "value": "PAGE_EXPORT"
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "isDownloadAllowed",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "action",
                            "value": "ATTACHMENT_DOWNLOAD"
                        },
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v8 /*: any*/ 
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DatabaseContainerQuery",
            "selections": v15 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "DatabaseContainerQuery",
            "selections": v15 /*: any*/ 
        },
        "params": {
            "cacheID": "3d5107055d0ad5e5fed0e694feb80f1c",
            "id": "5acb81487b5b5127dead4c25a310545e5437aad4717ee4c6f1d7a5a5a6c6614e",
            "metadata": {},
            "name": "DatabaseContainerQuery",
            "operationKind": "query",
            "text": "query DatabaseContainerQuery($contentId:ID!,$spaceKey:String,$contentVersion:Int!){content(id:$contentId){nodes{id,referenceId,title,operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status}}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary},emails{value,isPrimary},locale,confluence{space{id}}},dataSecurityPolicy{isExportAllowed:isActionEnabledForContent(action:PAGE_EXPORT,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed},isDownloadAllowed:isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,spaceKey:$spaceKey,contentVersion:$contentVersion){allowed}}}"
        }
    };
}();
$0040230a36fc338e$var$node.hash = "7a60e16be16d4c46e03e2f2d23d9dc89";
var $0040230a36fc338e$export$2e2bcd8739ae039 = $0040230a36fc338e$var$node;
module.exports["default"] = $0040230a36fc338e$export$2e2bcd8739ae039;

});

parcelRegister("4TRDb", function(module, exports) {
/**
 * @generated SignedSource<<08bbdfb732a0e903037634e82b2cebab>>
 * @relayHash c0a7532c77f00a6d3db89afbba6c2124
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e3afe4be4952ff1385de921ea89e96ad689b38bd27c628e4ceacc511c99519eb
const $027763ba95a6da42$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "atlas_doc_format",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c0a7532c77f00a6d3db89afbba6c2124",
            "id": "e3afe4be4952ff1385de921ea89e96ad689b38bd27c628e4ceacc511c99519eb",
            "metadata": {},
            "name": "SmartCreatePageEditorDataWrapperComponentQuery",
            "operationKind": "query",
            "text": "query SmartCreatePageEditorDataWrapperComponentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\"]){nodes{id,title,body{atlas_doc_format{value}},space{id,key,alias}}}}"
        }
    };
}();
$027763ba95a6da42$var$node.hash = "1aa5e1f3fdc665522f842f14ed2e0264";
var $027763ba95a6da42$export$2e2bcd8739ae039 = $027763ba95a6da42$var$node;
module.exports["default"] = $027763ba95a6da42$export$2e2bcd8739ae039;

});

parcelRegister("a2zQR", function(module, exports) {
/**
 * @generated SignedSource<<e77ba13c86de7ab0ec90d72e14a5eba1>>
 * @relayHash 3674404876fb671e57a7bc564c9498dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d9d6149ee0dc2a6f69d42a3b799534977c79ae87426c615721176aadbe34bd6
const $fbc22293d57aa8f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "title"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = [
        v1 /*: any*/ 
    ], v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedUrl"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasViewRestrictions"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasInheritedRestrictions"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "ancestors",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v4 /*: any*/ ,
                                v2 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "embeddedProduct"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "homepage",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": v6 /*: any*/ 
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EmbedContainerQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EmbedContainerQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "3674404876fb671e57a7bc564c9498dc",
            "id": "5d9d6149ee0dc2a6f69d42a3b799534977c79ae87426c615721176aadbe34bd6",
            "metadata": {},
            "name": "EmbedContainerQuery",
            "operationKind": "query",
            "text": "query EmbedContainerQuery($contentId:ID!,$spaceKey:String!){content(id:$contentId){nodes{id,title,metadata{frontend{embedUrl},currentuser{favourited{isFavourite}}},operations{operation,targetType},hasRestrictions,hasViewRestrictions,hasInheritedRestrictions,space{id,name,key,type,alias},type,status,ancestors{id,type,title,status},embeddedProduct}},spaces(spaceKey:$spaceKey,first:10){nodes{id,name,homepage{id}}},user:confluence_atlassianUser(current:true){id,confluence{space{id}}}}"
        }
    };
}();
$fbc22293d57aa8f6$var$node.hash = "93be96607102ab4e689586d3195128e3";
var $fbc22293d57aa8f6$export$2e2bcd8739ae039 = $fbc22293d57aa8f6$var$node;
module.exports["default"] = $fbc22293d57aa8f6$export$2e2bcd8739ae039;

});

parcelRegister("7PLO8", function(module, exports) {
const $3009aa09d1bfedbe$export$93a0fdadbf6c055a = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get('draftShareId') || '';
};
module.exports["getDraftShareIdFromQueryParam"] = $3009aa09d1bfedbe$export$93a0fdadbf6c055a;

});

parcelRegister("32Xjk", function(module, exports) {
/**
 * @generated SignedSource<<1411d3b38bfd3828f39e9de902613b71>>
 * @relayHash 3d166b53e496ae6a12171538cb6c6ca8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce
const $6ea889d48284c196$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-ever-set"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(key:\"emoji-ever-set\")"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useEmojiEverSetPropertyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "3d166b53e496ae6a12171538cb6c6ca8",
            "id": "47671c12a30051dade8a24379bdff81b92cd52b7a0f16a09096ff4fec8aa47ce",
            "metadata": {},
            "name": "useEmojiEverSetPropertyQuery",
            "operationKind": "query",
            "text": "query useEmojiEverSetPropertyQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(key:\"emoji-ever-set\"){nodes{id,key,value}}}}}"
        }
    };
}();
$6ea889d48284c196$var$node.hash = "7922225ac99254e0526a345863d19578";
var $6ea889d48284c196$export$2e2bcd8739ae039 = $6ea889d48284c196$var$node;
module.exports["default"] = $6ea889d48284c196$export$2e2bcd8739ae039;

});

parcelRegister("8R0gj", function(module, exports) {

var $747ya = parcelRequire("747ya");

async function $65899b702fdd32b1$export$dfd3c4c0aa957792(contentId, draftShareId) {
    window.__PRELOAD_DRAFT__ = {
        contentId: contentId,
        draftFetchPromise: (0, $747ya.fetchDraft)(contentId, draftShareId),
        startTime: window?.performance?.now?.()
    };
}
const $65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR = '.PermissionException: User does not have permission';
function $65899b702fdd32b1$export$9d45b1b64b2cb8e1(message) {
    if (!message) return false;
    return message.indexOf($65899b702fdd32b1$var$DRAFT_PERMISSION_ERROR) > -1 || false;
}
module.exports["preloadDraft"] = $65899b702fdd32b1$export$dfd3c4c0aa957792;
module.exports["isDraftSSRPreloadPermissionError"] = $65899b702fdd32b1$export$9d45b1b64b2cb8e1;

});

parcelRegister("747ya", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $fqIt3 = parcelRequire("fqIt3");


var $nIvaQ = parcelRequire("nIvaQ");

async function $67d2826966f59cb2$export$af6160a01d539948(contentId, draftShareId) {
    // Use cache-first only if SSR rendered AND cache is not stale (within TTL)
    // This prevents stale data during SPA transitions while still benefiting from SSR cache
    const shouldUseCache = window.__SSR_RENDERED__ || !(0, $fqIt3.isCollabDraftCacheStale)(contentId, draftShareId);
    const response = await (0, $c0rhi.queryInterop)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: shouldUseCache ? 'cache-first' : 'network-only',
        __callerPackage__: "fabric-providers"
    });
    const { data: data, error: error } = response;
    if (error || !data?.collabDraft) return {
        draft: null,
        response: response
    };
    const { document: document, version: version, metadata: metadata } = data.collabDraft;
    const draft = {
        version: version,
        metadata: $67d2826966f59cb2$var$excludeTypename(metadata),
        document: JSON.parse(document || '')
    };
    return {
        draft: draft,
        response: response
    };
}
function $67d2826966f59cb2$var$excludeTypename(metadata) {
    if (!metadata) return metadata;
    const { __typename: __typename, ...rest } = metadata;
    return rest;
}
module.exports["fetchDraft"] = $67d2826966f59cb2$export$af6160a01d539948;

});

parcelRegister("fqIt3", function(module, exports) {
const $3014a7cdda499b2d$var$collabDraftFetchTimestamps = new Map();
// TTL for CollabDraftQuery cached data
// This prevents stale data during SPA transitions while still allowing
// cache-first for SSR-rendered pages within the TTL window
const $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS = 15000;
/**
 * Creates a composite cache key that includes both contentId and draftShareId.
 * This aligns with how Apollo caches queries by their variables.
 */ const $3014a7cdda499b2d$var$getCacheKey = (contentId, draftShareId)=>{
    return `${contentId}:${draftShareId || ''}`;
};
function $3014a7cdda499b2d$export$76901333d647261(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    const lastFetchTime = $3014a7cdda499b2d$var$collabDraftFetchTimestamps.get(key);
    if (!lastFetchTime) return true;
    return Date.now() - lastFetchTime > $3014a7cdda499b2d$var$COLLAB_DRAFT_TTL_MS;
}
function $3014a7cdda499b2d$export$85437e97168f99bc(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.set(key, Date.now());
}
function $3014a7cdda499b2d$export$5f725cb33e7218ab(contentId, draftShareId) {
    const key = $3014a7cdda499b2d$var$getCacheKey(contentId, draftShareId);
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.delete(key);
}
function $3014a7cdda499b2d$export$a379bfa68f31645e() {
    $3014a7cdda499b2d$var$collabDraftFetchTimestamps.clear();
}
module.exports["isCollabDraftCacheStale"] = $3014a7cdda499b2d$export$76901333d647261;
module.exports["markCollabDraftFetched"] = $3014a7cdda499b2d$export$85437e97168f99bc;
module.exports["clearCollabDraftTimestamp"] = $3014a7cdda499b2d$export$5f725cb33e7218ab;

});

parcelRegister("nIvaQ", function(module, exports) {

var $7ZQNA = parcelRequire("7ZQNA");

const $c4f625141049567c$export$1248f2ac56981fbd = ()=>(0, $7ZQNA.CollabDraftQuery);
module.exports["getCollabDraftQuery"] = $c4f625141049567c$export$1248f2ac56981fbd;

});

parcelRegister("7ZQNA", function(module, exports) {

var $lU81J = parcelRequire("lU81J");

const $270318977b9095e1$export$89183b1b5e58f33c = (0, $lU81J.default);
module.exports["CollabDraftQuery"] = $270318977b9095e1$export$89183b1b5e58f33c;

});

parcelRegister("lU81J", function(module, exports) {
/**
 * @generated SignedSource<<81d932c04171cccd3ee1c517fa2180ce>>
 * @relayHash cd92794db2ea2a3b9bfa36b4fb9ae833
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a
const $e1affc2f9f206abd$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hydrateAdf"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "hydrateAdf",
                    "variableName": "hydrateAdf"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "CollabDraft",
            "kind": "LinkedField",
            "name": "collabDraft",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "document"
                },
                {
                    "kind": "ScalarField",
                    "name": "version"
                },
                {
                    "concreteType": "CollabDraftMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CollabDraftQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cd92794db2ea2a3b9bfa36b4fb9ae833",
            "id": "44e85cfd7f416b92fd30c810982ddfc4aeaa8b9ab964fe47829b79185c29b63a",
            "metadata": {},
            "name": "CollabDraftQuery",
            "operationKind": "query",
            "text": "query CollabDraftQuery($id:ID!,$draftShareId:String=\"\",$hydrateAdf:Boolean){collabDraft(id:$id,draftShareId:$draftShareId,hydrateAdf:$hydrateAdf){document,version,metadata{title}}}"
        }
    };
}();
$e1affc2f9f206abd$var$node.hash = "3cf6959ca06a0e7e4a4e60e0c720b14e";
var $e1affc2f9f206abd$export$2e2bcd8739ae039 = $e1affc2f9f206abd$var$node;
module.exports["default"] = $e1affc2f9f206abd$export$2e2bcd8739ae039;

});

parcelRegister("fxLAA", function(module, exports) {
/**
 * @generated SignedSource<<6f0c818aa24ef56cfa34ff0b280f1173>>
 * @relayHash deb4c93383532c2419d82cca2aec5628
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e982f35f0a8d751383b7fee1e0354b31c910d8c350a2e790a9d7dfe591777d98
const $d3bfdb752c338d80$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "embeddedContentRender"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsBylineConnection"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePublicLink"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useAccessButtonFragment"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useClassificationLevelV2"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useEditButtonFragment"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useObjectHeaderFragment"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v14 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "embeddedContentRender",
            "variableName": "embeddedContentRender"
        },
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "id"
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "kind": "ScalarField",
        "name": "title"
    }, v20 = {
        "kind": "ScalarField",
        "name": "status"
    }, v21 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v22 = {
        "kind": "ScalarField",
        "name": "key"
    }, v23 = {
        "kind": "ScalarField",
        "name": "value"
    }, v24 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ 
            ]
        }
    ], v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "devdocsProperties",
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v16 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v26 /*: any*/ 
                    ]
                }
            ]
        }
    ], v28 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v27 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v29 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v31 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v32 = [
        v17 /*: any*/ ,
        v21 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v33 = {
        "alias": "emojiTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v27 /*: any*/ ,
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v34 = {
        "condition": "useNewContentTopper",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "pageTitlePublished",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "page-title-property-published"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v27 /*: any*/ ,
                "storageKey": "properties(key:\"page-title-property-published\")"
            }
        ]
    }, v35 = {
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v24 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v36 = {
        "kind": "ScalarField",
        "name": "name"
    }, v37 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            v36 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v38 = {
        "kind": "ScalarField",
        "name": "message"
    }, v39 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v40 = {
        "kind": "ScalarField",
        "name": "when"
    }, v41 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v42 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v43 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "sourceTemplateEntityId"
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "coverPictureWidth"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v44 = {
        "condition": "includePublicLink",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "contentId"
                    }
                ],
                "concreteType": "PublicLinkPage",
                "kind": "LinkedField",
                "name": "publicLinkPage",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "pageId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "pageStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "accessType"
                    }
                ]
            }
        ]
    }, v45 = [
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v46 = {
        "kind": "ScalarField",
        "name": "count"
    }, v47 = {
        "kind": "ScalarField",
        "name": "isCurrentUserContributor"
    }, v48 = {
        "kind": "ScalarField",
        "name": "isOwnerContributor"
    }, v49 = [
        v22 /*: any*/ ,
        v23 /*: any*/ 
    ], v50 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "spaceKey"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v16 /*: any*/ ,
            {
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "theme",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "themeKey"
                    }
                ]
            },
            {
                "concreteType": "LookAndFeel",
                "kind": "LinkedField",
                "name": "lookAndFeel",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "MapOfStringToString",
                        "kind": "LinkedField",
                        "name": "headings",
                        "plural": true,
                        "selections": v49 /*: any*/ 
                    },
                    {
                        "concreteType": "ContentLookAndFeel",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "ContainerLookAndFeel",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "background"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundAttachment"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundBlendMode"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundClip"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundColor"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundImage"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundOrigin"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundPosition"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundRepeat"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "backgroundSize"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "borderRadius"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "padding"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v51 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v52 = [
        v51 /*: any*/ ,
        v17 /*: any*/ ,
        v21 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ 
    ], v53 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v54 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v22 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v55 = [
        v51 /*: any*/ ,
        v21 /*: any*/ 
    ], v56 = [
        v16 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "guideline"
        },
        {
            "kind": "ScalarField",
            "name": "guidelineADF"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        {
            "kind": "ScalarField",
            "name": "color"
        },
        v36 /*: any*/ ,
        v20 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "condition": "useEditButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "EditContentButton_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "editContentButton"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useAccessButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useShareAndRestrictButtonData_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "shareAndRestrictButtonData"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useObjectHeaderFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "ContentTypesHeader_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "contentTypesHeader"
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "args": [
                                                            {
                                                                "kind": "Variable",
                                                                "name": "useClassificationLevelV2",
                                                                "variableName": "useClassificationLevelV2"
                                                            }
                                                        ],
                                                        "kind": "FragmentSpread",
                                                        "name": "BylineClassification_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "bylineClassificationFragment"
                                        }
                                    ]
                                },
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": [
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        }
                                    ]
                                },
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v35 /*: any*/ ,
                                v37 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v32 /*: any*/ 
                                        },
                                        v39 /*: any*/ ,
                                        v40 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v41 /*: any*/ 
                                    ]
                                },
                                v42 /*: any*/ ,
                                v43 /*: any*/ 
                            ]
                        }
                    ]
                },
                v44 /*: any*/ ,
                {
                    "args": v45 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v46 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v32 /*: any*/ 
                        }
                    ]
                },
                v50 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v13 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v11 /*: any*/ ,
                v3 /*: any*/ ,
                v12 /*: any*/ ,
                v10 /*: any*/ ,
                v8 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v9 /*: any*/ ,
                v7 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentHeaderUnifiedQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        }
                                    ]
                                },
                                v33 /*: any*/ ,
                                v35 /*: any*/ ,
                                v37 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        v39 /*: any*/ ,
                                        v40 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v41 /*: any*/ 
                                    ]
                                },
                                v42 /*: any*/ ,
                                v43 /*: any*/ ,
                                {
                                    "condition": "useEditButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                                    "kind": "LinkedField",
                                                    "name": "frontend",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "embedded"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "collabService"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "useAccessButtonFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasInheritedRestrictions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasRestrictions"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasViewRestrictions"
                                        }
                                    ]
                                },
                                {
                                    "condition": "useObjectHeaderFragment",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        {
                                            "alias": "smartFolderProperties",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "keys",
                                                    "value": [
                                                        "smartFolderProperties"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "PaginatedJsonContentPropertyList",
                                            "kind": "LinkedField",
                                            "name": "properties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JsonContentProperty",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": v49 /*: any*/ 
                                                }
                                            ],
                                            "storageKey": "properties(keys:[\"smartFolderProperties\"])"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "draftVersion",
                                            "plural": false,
                                            "selections": [
                                                v41 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v55 /*: any*/ 
                                                },
                                                v40 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        v53 /*: any*/ ,
                                        v54 /*: any*/ ,
                                        {
                                            "concreteType": "ClassificationLevelDetails",
                                            "kind": "LinkedField",
                                            "name": "classificationLevelDetails",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "useClassificationLevelV2",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ContentDataClassificationLevel",
                                                            "kind": "LinkedField",
                                                            "name": "classificationLevel",
                                                            "plural": false,
                                                            "selections": v56 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "useClassificationLevelV2",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ContentDataClassificationLevel",
                                                            "kind": "LinkedField",
                                                            "name": "classificationLevelV2",
                                                            "plural": false,
                                                            "selections": v56 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "featureEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "source"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isReclassificationPermitted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canManageSpaceSettings"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "classificationControlSetting"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "userOverrideSetting"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeDevDocsBylineConnection",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": v55 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                v25 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v34 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "args": v45 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v46 /*: any*/ ,
                        v47 /*: any*/ ,
                        v48 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v52 /*: any*/ 
                        }
                    ]
                },
                v50 /*: any*/ ,
                v44 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "deb4c93383532c2419d82cca2aec5628",
            "id": "e982f35f0a8d751383b7fee1e0354b31c910d8c350a2e790a9d7dfe591777d98",
            "metadata": {},
            "name": "ContentHeaderUnifiedQuery",
            "operationKind": "query",
            "text": "query ContentHeaderUnifiedQuery($contentId:ID!,$spaceKey:String,$versionOverride:Int,$embeddedContentRender:String,$limit:Int,$useNewContentTopper:Boolean=false,$includeDevDocsBylineConnection:Boolean=false,$useObjectHeaderFragment:Boolean=false,$useEditButtonFragment:Boolean=false,$useAccessButtonFragment:Boolean=false,$includePublicLink:Boolean=false,$includeClassification:Boolean=false,$useClassificationLevelV2:Boolean=false,$status:[String]){content(id:$contentId,version:$versionOverride,embeddedContentRender:$embeddedContentRender,status:$status){nodes{id,...EditContentButton_content@include(if:$useEditButtonFragment),...useShareAndRestrictButtonData_content@include(if:$useAccessButtonFragment),...ContentTypesHeader_content@include(if:$useObjectHeaderFragment),...BylineClassification_content_4MZOe@include(if:$includeClassification),type,subType,title,status,ancestors@include(if:$includeDevDocsBylineConnection){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},space{id,name,homepageId},version{message,by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},metadata{sourceTemplateEntityId,lastModifiedDate,frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}}}},publicLinkPage(pageId:$contentId)@include(if:$includePublicLink){pageId,pageStatus,accessType},contentContributors(id:$contentId,limit:$limit){count,isCurrentUserContributor,isOwnerContributor,nodes{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},space(key:$spaceKey){id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}}fragment BylineClassification_content_4MZOe on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content_4MZOe}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment useContentClassification_content_4MZOe on Content{id,classificationLevelDetails{classificationLevel@skip(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},classificationLevelV2@include(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}"
        }
    };
}();
$d3bfdb752c338d80$var$node.hash = "662e902aa1a52517f06500f6f8ac464f";
var $d3bfdb752c338d80$export$2e2bcd8739ae039 = $d3bfdb752c338d80$var$node;
module.exports["default"] = $d3bfdb752c338d80$export$2e2bcd8739ae039;

});

parcelRegister("kBkBz", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $xwvlW = parcelRequire("xwvlW");


var $7PLO8 = parcelRequire("7PLO8");


var $1aQ2R = parcelRequire("1aQ2R");


var $g6QPm = parcelRequire("g6QPm");


var $7zWPb = parcelRequire("7zWPb");

const $4e5fb2b69331c38d$export$ed4ec3024b990284 = ({ contentId: contentId, isLivePage: isLivePage })=>{
    const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const variables = (0, $g6QPm.createEditorContentOperationVariables)({
        contentId: contentId,
        cloudId: cloudId,
        draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
        isLivePage: isLivePage
    });
    return (0, $7zWPb.withEditorContentFreshness)(variables, (fetchPolicy)=>(0, $dYU3e.query)({
            query: (0, $1aQ2R.default),
            variables: variables,
            fetchPolicy: fetchPolicy,
            __callerPackage__: "editor-content-unified-query"
        }));
};
module.exports["preloadEditorContentUnifiedQuery"] = $4e5fb2b69331c38d$export$ed4ec3024b990284;

});

parcelRegister("1aQ2R", function(module, exports) {
/**
 * @generated SignedSource<<5802b080dd9e172429459d2e21948680>>
 * @relayHash 824daac81eab254b583c59bb2041fe81
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 290e48913d31536650f61c6635b159795d5922dc3b2d58005c80cdda815c9f92
const $6680153e74732958$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": "USER_FRIENDLY",
        "kind": "LocalArgument",
        "name": "contentStateLastUpdatedFormat"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeCollaborators"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentStateApprovals"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentStateLastUpdated"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsAncestors"
    }, v9 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "isContentStateDraft"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLivePage"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useClassificationLevelV2"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v14 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "draftShareId",
            "variableName": "draftShareId"
        },
        v14 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v16 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isContentStateDraft"
    }, v17 = {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
    }, v18 = [
        v17 /*: any*/ 
    ], v19 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = {
        "kind": "ScalarField",
        "name": "title"
    }, v22 = {
        "kind": "ScalarField",
        "name": "name"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "type"
    }, v25 = [
        {
            "kind": "ScalarField",
            "name": "path"
        }
    ], v26 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v27 = {
        "kind": "ScalarField",
        "name": "status"
    }, v28 = {
        "kind": "ScalarField",
        "name": "value"
    }, v29 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v30 = {
        "kind": "ScalarField",
        "name": "number"
    }, v31 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v32 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v33 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v34 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            v34 /*: any*/ 
        ],
        "type": "KnownUser"
    }, v36 = {
        "kind": "ScalarField",
        "name": "when"
    }, v37 = [
        v32 /*: any*/ ,
        v33 /*: any*/ 
    ], v38 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v20 /*: any*/ ,
                v23 /*: any*/ ,
                v28 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        v30 /*: any*/ 
                    ]
                }
            ]
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "generatedBy"
    }, v40 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v41 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v20 /*: any*/ ,
                v23 /*: any*/ ,
                v28 /*: any*/ 
            ]
        }
    ], v42 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": v25 /*: any*/ 
    }, v43 = [
        v32 /*: any*/ ,
        v33 /*: any*/ ,
        v35 /*: any*/ ,
        v42 /*: any*/ 
    ], v44 = {
        "kind": "ScalarField",
        "name": "count"
    }, v45 = {
        "kind": "ScalarField",
        "name": "color"
    }, v46 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v47 = [
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "guideline"
        },
        {
            "kind": "ScalarField",
            "name": "guidelineADF"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        v45 /*: any*/ ,
        v22 /*: any*/ ,
        v27 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentUnifiedQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useEditorContentTypesHeaderFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentTypesHeaderFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useEmojiTitleFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "emojiTitleFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useEmojiEverSetPropertyFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "emojiEverSetPropertyFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useContentAppearanceFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentAppearanceFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useCoverPictureFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "coverPictureFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useTitleContentPropertiesFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "titleContentPropertiesFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "isLivePage",
                                                        "variableName": "isLivePage"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "useContentModeFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentModeFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useShareAndRestrictButtonFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "shareAndRestrictButtonFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useEditorSpaceDetailFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "editorSpaceDetailFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useNativeCollabFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "nativeCollabFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useLabelsFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "labelsFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useSmartCreateFeedbackBannerFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "smartCreateFeedbackBannerFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useFavouriteContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "favouriteContentFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useMigratedRecentlyFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "migratedRecentlyFragment"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeClassification",
                                                        "variableName": "includeClassification"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "useClassificationLevelV2",
                                                        "variableName": "useClassificationLevelV2"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "useEditorByLineFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "editorByLineFragment"
                                },
                                {
                                    "condition": "includeDevDocsAncestors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useDevDocsAncestorsFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "devDocsAncestorsFragment"
                                        }
                                    ]
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeApprovals",
                                                        "variableName": "includeContentStateApprovals"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeLastUpdated",
                                                        "variableName": "includeContentStateLastUpdated"
                                                    },
                                                    v16 /*: any*/ ,
                                                    {
                                                        "kind": "Variable",
                                                        "name": "lastUpdatedFormat",
                                                        "variableName": "contentStateLastUpdatedFormat"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "useEditorContentStateFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "editorContentStateFragment"
                                },
                                {
                                    "condition": "includeCollaborators",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "fragment": {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "FragmentSpread",
                                                        "name": "useEditorCollaboratorsFragment_content"
                                                    }
                                                ],
                                                "type": "Content"
                                            },
                                            "kind": "AliasedInlineFragmentSpread",
                                            "name": "editorCollaboratorsFragment"
                                        }
                                    ]
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useEditorAddCommentPermissionFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "editorAddCommentPermissionFragment"
                                }
                            ]
                        }
                    ]
                },
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "args": v18 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "useShareAndRestrictButtonFragment_query"
                            }
                        ],
                        "type": "Query"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "shareAndRestrictButtonPublicLinkFragment"
                },
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "args": v18 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "useEditorByLineFragment_query"
                            }
                        ],
                        "type": "Query"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "editorByLineContributorsFragment"
                },
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "args": v18 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "useEditorContentStateFragment_query"
                            }
                        ],
                        "type": "Query"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "editorAvailableContentStatesFragment"
                },
                {
                    "condition": "includeCollaborators",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            v19 /*: any*/ ,
                                            v17 /*: any*/ 
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "useEditorCollaboratorsFragment_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "editorCollaboratorsListFragment"
                        }
                    ]
                },
                {
                    "fragment": {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "args": v18 /*: any*/ ,
                                "kind": "FragmentSpread",
                                "name": "useEditorAttachmentDownloadPolicyFragment_query"
                            }
                        ],
                        "type": "Query"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "editorAttachmentDownloadPolicyFragment"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v13 /*: any*/ ,
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v10 /*: any*/ ,
                v4 /*: any*/ ,
                v12 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentUnifiedQuery",
            "selections": [
                {
                    "args": v15 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v20 /*: any*/ ,
                                v21 /*: any*/ ,
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetType"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        },
                                        v24 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "dataClassificationTags"
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "homepage",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v24 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "Icon",
                                            "kind": "LinkedField",
                                            "name": "icon",
                                            "plural": false,
                                            "selections": v25 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "homepageId"
                                        }
                                    ]
                                },
                                v24 /*: any*/ ,
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                {
                                    "alias": "smartFolderProperties",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "smartFolderProperties"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JsonContentProperty",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                v28 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "properties(keys:[\"smartFolderProperties\"])"
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v32 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v35 /*: any*/ 
                                            ]
                                        },
                                        v36 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "ncsStepVersion"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": [
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        v31 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v37 /*: any*/ 
                                        },
                                        v36 /*: any*/ 
                                    ]
                                },
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v38 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                },
                                {
                                    "alias": "emojiTitleDraft",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-draft"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v38 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-draft\")"
                                },
                                {
                                    "concreteType": "ContentProperties",
                                    "kind": "LinkedField",
                                    "name": "contentProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "defaultTitleEmoji"
                                                },
                                                v39 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isLivePage",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "PublishedContentProperties",
                                                    "kind": "LinkedField",
                                                    "name": "latest",
                                                    "plural": false,
                                                    "selections": v40 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isLivePage",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DraftContentProperties",
                                                    "kind": "LinkedField",
                                                    "name": "draft",
                                                    "plural": false,
                                                    "selections": v40 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": [
                                                v39 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-ever-set"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v41 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-ever-set\")"
                                },
                                {
                                    "alias": "appearanceDraft",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "content-appearance-draft"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v38 /*: any*/ ,
                                    "storageKey": "properties(key:\"content-appearance-draft\")"
                                },
                                {
                                    "alias": "coverPictureProperties",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "cover-picture-id-draft",
                                                "cover-picture-id-published"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v38 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                                },
                                {
                                    "alias": "pageTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "page-title-property-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v38 /*: any*/ ,
                                    "storageKey": "properties(key:\"page-title-property-published\")"
                                },
                                {
                                    "alias": "pageTitleDraft",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "page-title-property-draft"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v38 /*: any*/ ,
                                    "storageKey": "properties(key:\"page-title-property-draft\")"
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                            "kind": "LinkedField",
                                            "name": "frontend",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "coverPictureWidth"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "migratedRecently"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                            "kind": "LinkedField",
                                            "name": "currentuser",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "FavouritedSummary",
                                                    "kind": "LinkedField",
                                                    "name": "favourited",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFavourite"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasInheritedRestrictions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasRestrictions"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasViewRestrictions"
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v43 /*: any*/ 
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "createdDate"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v43 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "orderBy",
                                            "value": {
                                                "direction": "ASCENDING",
                                                "sortField": "LABELLING_CREATIONDATE"
                                            }
                                        }
                                    ],
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v22 /*: any*/ 
                                            ]
                                        },
                                        v44 /*: any*/ 
                                    ],
                                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "creatorId"
                                },
                                {
                                    "args": [
                                        v16 /*: any*/ 
                                    ],
                                    "concreteType": "ContentState",
                                    "kind": "LinkedField",
                                    "name": "contentState",
                                    "plural": false,
                                    "selections": [
                                        v20 /*: any*/ ,
                                        v22 /*: any*/ ,
                                        v45 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCallerPermitted"
                                        },
                                        {
                                            "condition": "includeContentStateApprovals",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastModifierAaid"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeClassification",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ClassificationLevelDetails",
                                            "kind": "LinkedField",
                                            "name": "classificationLevelDetails",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "condition": "useClassificationLevelV2",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ContentDataClassificationLevel",
                                                            "kind": "LinkedField",
                                                            "name": "classificationLevel",
                                                            "plural": false,
                                                            "selections": v47 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "useClassificationLevelV2",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "ContentDataClassificationLevel",
                                                            "kind": "LinkedField",
                                                            "name": "classificationLevelV2",
                                                            "plural": false,
                                                            "selections": v47 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "featureEnabled"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "source"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isReclassificationPermitted"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "canManageSpaceSettings"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "classificationControlSetting"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "userOverrideSetting"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeDevDocsAncestors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v26 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "createdBy",
                                                            "plural": false,
                                                            "selections": v37 /*: any*/ 
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "keys",
                                                            "value": [
                                                                "devdocsProperties",
                                                                "smartFolderProperties"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "PaginatedJsonContentPropertyList",
                                                    "kind": "LinkedField",
                                                    "name": "properties",
                                                    "plural": false,
                                                    "selections": v41 /*: any*/ ,
                                                    "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeContentStateLastUpdated",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "format",
                                                    "variableName": "contentStateLastUpdatedFormat"
                                                },
                                                v16 /*: any*/ 
                                            ],
                                            "concreteType": "ConfluenceDate",
                                            "kind": "LinkedField",
                                            "name": "contentStateLastUpdated",
                                            "plural": false,
                                            "selections": [
                                                v28 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeCollaborators",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "SpaceUserMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "currentUser",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isAdmin"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        }
                    ]
                },
                {
                    "args": [
                        v14 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 4
                        }
                    ],
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        v44 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "isOwnerContributor"
                        }
                    ]
                },
                {
                    "args": v18 /*: any*/ ,
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v22 /*: any*/ ,
                                v45 /*: any*/ ,
                                v20 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v22 /*: any*/ ,
                                v45 /*: any*/ ,
                                v20 /*: any*/ ,
                                v46 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Confluence_dataSecurityPolicy",
                    "kind": "LinkedField",
                    "name": "dataSecurityPolicy",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "action",
                                    "value": "ATTACHMENT_DOWNLOAD"
                                },
                                v17 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "contentStatus",
                                    "value": "CURRENT"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentVersion",
                                    "value": 1
                                }
                            ],
                            "concreteType": "DataSecurityPolicyDecision",
                            "kind": "LinkedField",
                            "name": "isActionEnabledForContent",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "action"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "allowed"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeCollaborators",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                v19 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 2147483647
                                },
                                v14 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceCollaboratorConnection",
                            "kind": "LinkedField",
                            "name": "confluence_contentCollaborators",
                            "plural": false,
                            "selections": [
                                v44 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceCollaborator",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "person",
                                            "plural": false,
                                            "selections": [
                                                v32 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v42 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v34 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jobTitle"
                                                        }
                                                    ],
                                                    "type": "KnownUser"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ConfluenceAgent",
                                            "kind": "LinkedField",
                                            "name": "agent",
                                            "plural": false,
                                            "selections": [
                                                v33 /*: any*/ ,
                                                v34 /*: any*/ ,
                                                v42 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "824daac81eab254b583c59bb2041fe81",
            "id": "290e48913d31536650f61c6635b159795d5922dc3b2d58005c80cdda815c9f92",
            "metadata": {},
            "name": "EditorContentUnifiedQuery",
            "operationKind": "query",
            "text": "query EditorContentUnifiedQuery($contentId:ID!,$cloudId:ID!,$versionOverride:Int,$draftShareId:String,$status:[String],$isLivePage:Boolean!,$includeClassification:Boolean=false,$useClassificationLevelV2:Boolean=false,$includeDevDocsAncestors:Boolean=false,$isContentStateDraft:Boolean=true,$includeContentStateApprovals:Boolean=false,$includeContentStateLastUpdated:Boolean=false,$contentStateLastUpdatedFormat:GraphQLDateFormat=USER_FRIENDLY,$includeCollaborators:Boolean=false){content(id:$contentId,version:$versionOverride,draftShareId:$draftShareId,status:$status){nodes{...useEditorContentTypesHeaderFragment_content,...useEmojiTitleFragment_content,...useEmojiEverSetPropertyFragment_content,...useContentAppearanceFragment_content,...useCoverPictureFragment_content,...useTitleContentPropertiesFragment_content,...useContentModeFragment_content_2xAkZ6,...useShareAndRestrictButtonFragment_content,...useEditorSpaceDetailFragment_content,...useNativeCollabFragment_content,...useLabelsFragment_content,...useSmartCreateFeedbackBannerFragment_content,...useFavouriteContentFragment_content,...useMigratedRecentlyFragment_content,...useEditorByLineFragment_content_hx45J,...useDevDocsAncestorsFragment_content@include(if:$includeDevDocsAncestors),...useEditorContentStateFragment_content_17amu1,...useEditorCollaboratorsFragment_content@include(if:$includeCollaborators),...useEditorAddCommentPermissionFragment_content,id}},...useShareAndRestrictButtonFragment_query_3SK5LQ,...useEditorByLineFragment_query_3SK5LQ,...useEditorContentStateFragment_query_3SK5LQ,...useEditorCollaboratorsFragment_query_1d0jrk@include(if:$includeCollaborators),...useEditorAttachmentDownloadPolicyFragment_query_3SK5LQ}fragment BylineClassification_content_4MZOe on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content_4MZOe}fragment SpaceDetail_space on Space{id,name,alias,key,type,dataClassificationTags,homepage{id,title,type},icon{path}}fragment useContentAppearanceFragment_content on Content{id,appearanceDraft:properties(key:\"content-appearance-draft\"){nodes{id,key,value,version{number}}}}fragment useContentClassification_content_4MZOe on Content{id,classificationLevelDetails{classificationLevel@skip(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},classificationLevelV2@include(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useContentModeFragment_content_2xAkZ6 on Content{id,contentProperties{latest@include(if:$isLivePage){contentMode},draft@skip(if:$isLivePage){contentMode}}}fragment useCoverPictureFragment_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment useDevDocsAncestorsFragment_content on Content{id,ancestors{id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}}}fragment useEditorAddCommentPermissionFragment_content on Content{id,type,operations{operation,targetType}}fragment useEditorAttachmentDownloadPolicyFragment_query_3SK5LQ on Query{dataSecurityPolicy{isActionEnabledForContent(action:ATTACHMENT_DOWNLOAD,contentId:$contentId,contentStatus:CURRENT,contentVersion:1){action,allowed}}}fragment useEditorByLineFragment_content_hx45J on Content{id,type,history{createdBy{__typename,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,displayName,...on KnownUser{accountId},profilePicture{path}}},version{number,when},contentProperties{latest{generatedBy}},space{id,name},...BylineClassification_content_4MZOe@include(if:$includeClassification)}fragment useEditorByLineFragment_query_3SK5LQ on Query{contentContributors(id:$contentId,limit:4){count,isOwnerContributor}}fragment useEditorCollaboratorsFragment_content on Content{id,status,space{id,currentUser{isAdmin}}}fragment useEditorCollaboratorsFragment_query_1d0jrk on Query{confluence_contentCollaborators(cloudId:$cloudId,id:$contentId,first:2147483647){count,nodes{person{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId,jobTitle}},agent{displayName,accountId,profilePicture{path}}}}}fragment useEditorContentStateFragment_content_17amu1 on Content{id,contentState(isDraft:$isContentStateDraft){id,name,color,restrictionLevel,isCallerPermitted,lastModifierAaid@include(if:$includeContentStateApprovals)},contentStateLastUpdated(format:$contentStateLastUpdatedFormat,isDraft:$isContentStateDraft)@include(if:$includeContentStateLastUpdated){value}}fragment useEditorContentStateFragment_query_3SK5LQ on Query{availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}fragment useEditorContentTypesHeaderFragment_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment useEditorSpaceDetailFragment_content on Content{space{id,key,alias,...SpaceDetail_space}}fragment useEmojiEverSetPropertyFragment_content on Content{id,properties(key:\"emoji-ever-set\"){nodes{id,key,value}}}fragment useEmojiTitleFragment_content on Content{id,emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}fragment useFavouriteContentFragment_content on Content{id,type,metadata{currentuser{favourited{isFavourite}}},operations{operation,targetType}}fragment useLabelsFragment_content on Content{id,labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count}}fragment useMigratedRecentlyFragment_content on Content{id,metadata{frontend{migratedRecently}}}fragment useNativeCollabFragment_content on Content{id,type,status,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},history{createdBy{__typename,displayName},createdDate},space{id,name,homepageId},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){nodes{id,name}},subType}fragment useShareAndRestrictButtonFragment_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useShareAndRestrictButtonFragment_query_3SK5LQ on Query{publicLinkPage(pageId:$contentId){pageId,pageStatus,accessType}}fragment useSmartCreateFeedbackBannerFragment_content on Content{title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}fragment useTitleContentPropertiesFragment_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
        }
    };
}();
$6680153e74732958$var$node.hash = "64cb4183dc7f5e661a8db3995949dc34";
var $6680153e74732958$export$2e2bcd8739ae039 = $6680153e74732958$var$node;
module.exports["default"] = $6680153e74732958$export$2e2bcd8739ae039;

});

parcelRegister("7zWPb", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $1aQ2R = parcelRequire("1aQ2R");

const $043b772404268ab3$var$entries = new Map();
const $043b772404268ab3$var$EDITOR_CONTENT_TTL_MS = 15000;
// Module state on the server is shared across Bifrost requests, so every function is a no-op there.
function $043b772404268ab3$var$isSSR() {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return Boolean(undefined);
}
// The edit and live operations of a content select different fields, so each has its own entry.
function $043b772404268ab3$var$getKey({ contentId: contentId, draftShareId: draftShareId, isLivePage: isLivePage }) {
    return `${contentId}:${draftShareId || ''}:${isLivePage ? 'live' : 'edit'}`;
}
function $043b772404268ab3$var$deleteEntry(key) {
    $043b772404268ab3$var$entries.get(key)?.retention?.dispose();
    $043b772404268ab3$var$entries.delete(key);
}
// Entries of pages the editor never showed (a warm-up without a click) are never cleared otherwise.
function $043b772404268ab3$var$deleteExpired() {
    const now = performance.now();
    for (const [key, { fetchedAt: fetchedAt }] of $043b772404268ab3$var$entries)if (now - fetchedAt > $043b772404268ab3$var$EDITOR_CONTENT_TTL_MS) $043b772404268ab3$var$deleteEntry(key);
}
// Nothing may read the operation until the editor mounts (e.g. after a hover), so it is retained
// from the start of the fetch; Relay can collect unretained data as soon as it is published.
// Same environment as `query` from query-preloader-tools executes on.
function $043b772404268ab3$var$retain(variables) {
    if ($043b772404268ab3$var$isSSR() || !window.GLOBAL_RELAY_ENV) return null;
    return window.GLOBAL_RELAY_ENV.retain((0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $1aQ2R.default)), variables));
}
function $043b772404268ab3$var$markFetched(key, retention) {
    $043b772404268ab3$var$deleteExpired();
    $043b772404268ab3$var$deleteEntry(key);
    $043b772404268ab3$var$entries.set(key, {
        fetchedAt: performance.now(),
        retention: retention
    });
}
function $043b772404268ab3$export$1f040fe4c1c6ec50(variables) {
    if ($043b772404268ab3$var$isSSR()) return false;
    const entry = $043b772404268ab3$var$entries.get($043b772404268ab3$var$getKey(variables));
    return entry !== undefined && performance.now() - entry.fetchedAt <= $043b772404268ab3$var$EDITOR_CONTENT_TTL_MS;
}
function $043b772404268ab3$export$c6247d4f21abc039(variables, runQuery) {
    const key = $043b772404268ab3$var$getKey(variables);
    // Never fresh on SSR, so the server always fetches.
    const isFresh = $043b772404268ab3$export$1f040fe4c1c6ec50(variables);
    // A store read is not new data, so it neither extends the TTL nor the retention.
    const retention = isFresh ? null : $043b772404268ab3$var$retain(variables);
    return runQuery(isFresh ? 'cache-first' : 'network-only').then((result)=>{
        if (!isFresh && !$043b772404268ab3$var$isSSR() && result.data?.content) $043b772404268ab3$var$markFetched(key, retention);
        else retention?.dispose();
        return result;
    }, (error)=>{
        retention?.dispose();
        throw error;
    });
}
function $043b772404268ab3$export$e8cd43e42adc5f39(contentId) {
    if ($043b772404268ab3$var$isSSR()) return;
    $043b772404268ab3$var$deleteExpired();
    const prefix = `${contentId}:`;
    for (const key of $043b772404268ab3$var$entries.keys())if (key.startsWith(prefix)) $043b772404268ab3$var$deleteEntry(key);
}
function $043b772404268ab3$export$c2dbddd61ca9a12c() {
    for (const key of $043b772404268ab3$var$entries.keys())$043b772404268ab3$var$deleteEntry(key);
}
module.exports["withEditorContentFreshness"] = $043b772404268ab3$export$c6247d4f21abc039;
module.exports["clearEditorContentFetched"] = $043b772404268ab3$export$e8cd43e42adc5f39;

});

parcelRegister("3gyyc", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

const $59e4a4ba3e3599a7$export$7e063004a2621936 = ()=>{
    try {
        const isSSRRendered = // In most places there is no document when running on server-side
        typeof document === 'undefined' || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        typeof $1P2f3 !== 'undefined' && $1P2f3.env?.REACT_SSR || typeof window !== 'undefined' && window.__SSR_RENDERED__ || globalThis.__SSR_RENDERED__;
        const isSSRReactStreaming = typeof window !== 'undefined' && window.__SSR_REACT_STREAMING__ || globalThis.__SSR_REACT_STREAMING__;
        return Boolean(isSSRRendered) && Boolean(isSSRReactStreaming);
    } catch  {
        // Catch possible error that might occur and just return false
        return false;
    }
};
module.exports["isSSRStreaming"] = $59e4a4ba3e3599a7$export$7e063004a2621936;

});

parcelRegister("bKbJ1", function(module, exports) {

let $88cd15f556b790a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $88cd15f556b790a2$var$load("2xoIF"),
    $88cd15f556b790a2$var$load("gA528")
]).then(()=>parcelRequire('cS7ok'));

});

parcelRegister("2XqLa", function(module, exports) {
/**
 * @generated SignedSource<<a63d6821b45767207607249abf9688dc>>
 * @relayHash 3d96e93646da973911628e43055a9f08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e401857f7c01e3a1e9f0925bc458239f573445ed8b7119ee7ef804a2ec848c88
const $24a18f673122a45e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "PagesSpaceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "PagesSpaceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3d96e93646da973911628e43055a9f08",
            "id": "e401857f7c01e3a1e9f0925bc458239f573445ed8b7119ee7ef804a2ec848c88",
            "metadata": {},
            "name": "PagesSpaceIdQuery",
            "operationKind": "query",
            "text": "query PagesSpaceIdQuery($spaceKey:String){space(key:$spaceKey){id}}"
        }
    };
}();
$24a18f673122a45e$var$node.hash = "deb46e23288932c7ab718d7f71cc2103";
var $24a18f673122a45e$export$2e2bcd8739ae039 = $24a18f673122a45e$var$node;
module.exports["default"] = $24a18f673122a45e$export$2e2bcd8739ae039;

});

parcelRegister("jG2Es", function(module, exports) {
/**
 * @generated SignedSource<<308939eb97236fd7abf20adc7a4f957c>>
 * @relayHash 59320f1b8601c0164d05458b5671082b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7db8c3153986b4dbb13acf7de34310f81ac9a8e0ac042516b4ef9dcad70cc31e
const $2a2707667ff6d1a7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "globalPageCardAppearancePreference"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "PagesSortPersistenceOption",
                    "kind": "LinkedField",
                    "name": "spacePagesSortView",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "field"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "order"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpacePagesPersistenceQueriesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpacePagesPersistenceQueriesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "59320f1b8601c0164d05458b5671082b",
            "id": "7db8c3153986b4dbb13acf7de34310f81ac9a8e0ac042516b4ef9dcad70cc31e",
            "metadata": {},
            "name": "SpacePagesPersistenceQueriesQuery",
            "operationKind": "query",
            "text": "query SpacePagesPersistenceQueriesQuery($spaceKey:String!){userPreferences{globalPageCardAppearancePreference,spacePagesSortView(spaceKey:$spaceKey){field,order}}}"
        }
    };
}();
$2a2707667ff6d1a7$var$node.hash = "2a6df4b92cf1482402557b6fd5bb750a";
var $2a2707667ff6d1a7$export$2e2bcd8739ae039 = $2a2707667ff6d1a7$var$node;
module.exports["default"] = $2a2707667ff6d1a7$export$2e2bcd8739ae039;

});

parcelRegister("khheP", function(module, exports) {
/**
 * @generated SignedSource<<bacc94674a3082b2d04c245fadae9b93>>
 * @relayHash 767409598881887aa79d216996b506d5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6841cfcc0970a95f1d151af08e5fdeee1588edf1ca9d6b1e88d51154f26c4932
const $fdbd89e429f2aa39$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARI"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRecommended"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isLicensed"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceId"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v14 = {
        "kind": "Variable",
        "name": "experience",
        "variableName": "experience"
    }, v15 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        v14 /*: any*/ ,
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "cloudIdARI"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v16 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v19 = {
        "kind": "ScalarField",
        "name": "description"
    }, v20 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v21 = {
        "kind": "ScalarField",
        "name": "title"
    }, v22 = {
        "kind": "ScalarField",
        "name": "type"
    }, v23 = {
        "kind": "ScalarField",
        "name": "url"
    }, v24 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v25 = {
        "kind": "ScalarField",
        "name": "isVerified"
    }, v26 = {
        "kind": "ScalarField",
        "name": "name"
    }, v27 = {
        "concreteType": "SearchConfluenceResultSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v26 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "webUiLink"
            }
        ]
    }, v28 = {
        "kind": "ScalarField",
        "name": "currentUserIsWatching"
    }, v29 = {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isWatched"
            },
            {
                "kind": "ScalarField",
                "name": "isWatchingBlogs"
            }
        ]
    }, v30 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v31 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v32 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "excerpt"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v34 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v35 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v36 = {
        "kind": "ScalarField",
        "name": "editUi"
    }, v37 = [
        v35 /*: any*/ ,
        v36 /*: any*/ 
    ], v38 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v37 /*: any*/ 
    }, v39 = {
        "kind": "ScalarField",
        "name": "key"
    }, v40 = {
        "kind": "ScalarField",
        "name": "value"
    }, v41 = [
        v18 /*: any*/ ,
        v17 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v42 = {
        "concreteType": "ConfluenceContentTitleEmoji",
        "kind": "LinkedField",
        "name": "titleEmojiPublished",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v43 = {
        "concreteType": "ConfluenceContentTitleEmoji",
        "kind": "LinkedField",
        "name": "titleEmojiDraft",
        "plural": false,
        "selections": v41 /*: any*/ 
    }, v44 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v42 /*: any*/ ,
            v43 /*: any*/ 
        ]
    }, v45 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "editor"
            ]
        }
    ], v46 = [
        v18 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ 
    ], v47 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v46 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v48 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v49 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v39 /*: any*/ ,
            v48 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v51 = [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v17 /*: any*/ ,
                v50 /*: any*/ ,
                v26 /*: any*/ 
            ]
        }
    ], v52 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": v51 /*: any*/ 
    }, v53 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v51 /*: any*/ 
    }, v54 = [
        {
            "concreteType": "ConfluenceFavoritedSummary",
            "kind": "LinkedField",
            "name": "favoritedSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavorite"
                }
            ]
        }
    ], v55 = {
        "concreteType": "ConfluencePageViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v56 = {
        "concreteType": "ConfluenceCommentCountSummary",
        "kind": "LinkedField",
        "name": "commentCountSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "total"
            }
        ]
    }, v57 = {
        "kind": "ScalarField",
        "name": "count"
    }, v58 = {
        "concreteType": "ConfluenceLikesSummary",
        "kind": "LinkedField",
        "name": "likesSummary",
        "plural": false,
        "selections": [
            v57 /*: any*/ 
        ]
    }, v59 = {
        "alias": "blogPostStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v60 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v37 /*: any*/ 
    }, v61 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v46 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v62 = {
        "concreteType": "ConfluenceBlogPostViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v63 = {
        "alias": "contentStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v64 = [
        v35 /*: any*/ 
    ], v65 = {
        "concreteType": "ConfluenceEmbedLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v66 = {
        "concreteType": "ConfluenceContentViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v67 = {
        "concreteType": "ConfluenceDatabaseLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v68 = {
        "concreteType": "ConfluenceWhiteboardLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v69 = {
        "concreteType": "ConfluenceFolderLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v64 /*: any*/ 
    }, v70 = {
        "concreteType": "SearchProductCount",
        "kind": "LinkedField",
        "name": "totalCounts",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "product"
            },
            v57 /*: any*/ 
        ]
    }, v71 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v72 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "containerId",
                            "variableName": "spaceId"
                        },
                        {
                            "kind": "Literal",
                            "name": "product",
                            "value": "confluence"
                        },
                        {
                            "kind": "Variable",
                            "name": "tenantId",
                            "variableName": "tenantId"
                        },
                        {
                            "kind": "Literal",
                            "name": "userId",
                            "value": "context"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "context"
                },
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "caller",
                            "value": "confluence"
                        },
                        v14 /*: any*/ 
                    ],
                    "kind": "ObjectValue",
                    "name": "modelRequestParams"
                },
                {
                    "kind": "Literal",
                    "name": "requestingUserId",
                    "value": "context"
                }
            ],
            "kind": "ObjectValue",
            "name": "recommendationsQuery"
        }
    ], v73 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v31 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "length",
                        "value": 372
                    }
                ],
                "kind": "ScalarField",
                "name": "excerpt",
                "storageKey": "excerpt(length:372)"
            }
        ]
    }, v74 = [
        v35 /*: any*/ ,
        v36 /*: any*/ ,
        v18 /*: any*/ 
    ], v75 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v74 /*: any*/ 
    }, v76 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v43 /*: any*/ ,
            v42 /*: any*/ 
        ]
    }, v77 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v39 /*: any*/ ,
            v48 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v78 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v50 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v79 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v78 /*: any*/ 
        ]
    }, v80 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v81 = [
        v79 /*: any*/ ,
        v80 /*: any*/ 
    ], v82 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v74 /*: any*/ 
    }, v83 = [
        v18 /*: any*/ ,
        v39 /*: any*/ ,
        v40 /*: any*/ ,
        v17 /*: any*/ 
    ], v84 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluencePageProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v83 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v85 = [
        {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                v18 /*: any*/ ,
                v17 /*: any*/ ,
                v50 /*: any*/ ,
                v26 /*: any*/ 
            ]
        },
        v17 /*: any*/ 
    ], v86 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": v85 /*: any*/ 
    }, v87 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": v85 /*: any*/ 
    }, v88 = {
        "alias": "editorVersion",
        "args": v45 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v83 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            v17 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v90 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v78 /*: any*/ ,
            v17 /*: any*/ 
        ]
    }, v91 = [
        v90 /*: any*/ ,
        v80 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SearchResultsAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "results",
                            "args": v15 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "condition": "isLicensed",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "watchDialogContent",
                                                                    "concreteType": "Content",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "Space",
                                                                            "kind": "LinkedField",
                                                                            "name": "space",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v32 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceBlogPost"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v68 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceFolder"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v70 /*: any*/ ,
                                v71 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeRecommended",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SmartsQueryApi",
                            "kind": "LinkedField",
                            "name": "smarts",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v72 /*: any*/ ,
                                    "concreteType": "SmartsRecommendedObject",
                                    "kind": "LinkedField",
                                    "name": "recommendedObject",
                                    "plural": true,
                                    "selections": [
                                        v73 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "object",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v75 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v55 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v79 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluencePageVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v81 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluencePage"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v82 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v62 /*: any*/ ,
                                                        v61 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v79 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluenceBlogPostVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v81 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluenceBlogPost"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v10 /*: any*/ ,
                v1 /*: any*/ ,
                v9 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v11 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v7 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SearchResultsAGGSearchQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "results",
                            "args": v15 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "search",
                            "plural": false,
                            "selections": [
                                v16 /*: any*/ ,
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ ,
                                                v22 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        v32 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v18 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v84 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v88 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v58 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceBlogPost"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceEmbed"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v67 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceDatabase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v68 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v56 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceWhiteboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v86 /*: any*/ ,
                                                                        v87 /*: any*/ ,
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "type": "ConfluenceFolder"
                                                                },
                                                                v89 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "isLicensed",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "alias": "watchDialogContent",
                                                                    "concreteType": "Content",
                                                                    "kind": "LinkedField",
                                                                    "name": "content",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "Space",
                                                                            "kind": "LinkedField",
                                                                            "name": "space",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v29 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v17 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v70 /*: any*/ ,
                                v71 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeRecommended",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "SmartsQueryApi",
                            "kind": "LinkedField",
                            "name": "smarts",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v72 /*: any*/ ,
                                    "concreteType": "SmartsRecommendedObject",
                                    "kind": "LinkedField",
                                    "name": "recommendedObject",
                                    "plural": true,
                                    "selections": [
                                        v73 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "object",
                                            "plural": false,
                                            "selections": [
                                                v18 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v33 /*: any*/ ,
                                                        v34 /*: any*/ ,
                                                        v75 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v55 /*: any*/ ,
                                                        v84 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v90 /*: any*/ ,
                                                        v87 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluencePageVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v91 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluencePage"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v22 /*: any*/ ,
                                                        v59 /*: any*/ ,
                                                        v82 /*: any*/ ,
                                                        v76 /*: any*/ ,
                                                        v62 /*: any*/ ,
                                                        v88 /*: any*/ ,
                                                        v77 /*: any*/ ,
                                                        v90 /*: any*/ ,
                                                        v87 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluenceBlogPostVersion",
                                                            "kind": "LinkedField",
                                                            "name": "latestVersion",
                                                            "plural": false,
                                                            "selections": v91 /*: any*/ 
                                                        },
                                                        v56 /*: any*/ ,
                                                        v58 /*: any*/ 
                                                    ],
                                                    "type": "ConfluenceBlogPost"
                                                },
                                                v89 /*: any*/ 
                                            ]
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "767409598881887aa79d216996b506d5",
            "id": "6841cfcc0970a95f1d151af08e5fdeee1588edf1ca9d6b1e88d51154f26c4932",
            "metadata": {},
            "name": "SearchResultsAGGSearchQuery",
            "operationKind": "query",
            "text": "query SearchResultsAGGSearchQuery($query:String!,$cloudIdARI:[String!]!,$limit:Int!,$entities:[String!]!,$commonFilters:SearchCommonFilter,$confluenceFilters:SearchConfluenceFilter,$sort:[SearchSortInput],$after:String,$disableQueryReplacement:Boolean,$experience:String!,$isLicensed:Boolean!,$includeRecommended:Boolean=false,$spaceId:String!,$tenantId:String!){search{results:search(experience:$experience,query:$query,first:$limit,after:$after,sort:$sort,disableQueryReplacement:$disableQueryReplacement,filters:{entities:$entities,locations:$cloudIdARI,commonFilters:$commonFilters,confluenceFilters:$confluenceFilters}){totalCount,edges{node{id,__typename,description,iconUrl,title,type,url,...on SearchConfluencePageBlogAttachment{lastModified,isVerified,space{id,name,webUiLink},watchDialogContent:content@include(if:$isLicensed){id,__typename,currentUserIsWatching,space{currentUser{isWatched,isWatchingBlogs},operations{operation,targetType},id}},content{id,__typename,blank,excerpt},confluenceEntity{__typename,...on ConfluencePage{id,__typename,title,type,subtype,pageStatus:status,links{webUi,editUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},likesSummary{count}},...on ConfluenceBlogPost{id,__typename,title,type,blogPostStatus:status,links{webUi,editUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},likesSummary{count}},...on ConfluenceEmbed{id,__typename,title,type,contentStatus:status,links{webUi},metadata{titleEmojiPublished{__typename,id,key,value},titleEmojiDraft{__typename,id,key,value}},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceDatabase{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceWhiteboard{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}},commentCountSummary{total}},...on ConfluenceFolder{id,__typename,title,type,contentStatus:status,links{webUi},space{id,key,alias,name},author{user{__typename,id,picture,name},id},owner{user{__typename,id,picture,name},id},viewer{favoritedSummary{isFavorite}}},...on Node{__isNode:__typename,id}}}}},totalCounts{product,count},pageInfo{endCursor}}},smarts@include(if:$includeRecommended){recommendedObject(recommendationsQuery:{context:{userId:\"context\",tenantId:$tenantId,product:\"confluence\",containerId:$spaceId},modelRequestParams:{experience:$experience,caller:\"confluence\"},requestingUserId:\"context\"}){content{id,__typename,blank,excerpt(length:372)},object{__typename,...on ConfluencePage{id,__typename,title,type,subtype,pageStatus:status,links{webUi,editUi,__typename},metadata{titleEmojiDraft{__typename,id,key,value},titleEmojiPublished{__typename,id,key,value}},viewer{favoritedSummary{isFavorite}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,__typename,key,alias,name},author{user{id,__typename,picture,name},id},owner{user{__typename,id,picture,name},id},latestVersion{author{user{id,__typename,picture,name},id},createdAt},commentCountSummary{total},likesSummary{count}},...on ConfluenceBlogPost{id,__typename,title,type,blogPostStatus:status,links{webUi,editUi,__typename},metadata{titleEmojiDraft{__typename,id,key,value},titleEmojiPublished{__typename,id,key,value}},viewer{favoritedSummary{isFavorite}},editorVersion:properties(keys:[\"editor\"]){__typename,key,value,id},space{id,__typename,key,alias,name},author{user{id,__typename,picture,name},id},owner{user{__typename,id,picture,name},id},latestVersion{author{user{id,__typename,picture,name},id},createdAt},commentCountSummary{total},likesSummary{count}},...on Node{__isNode:__typename,id}},id}}}"
        }
    };
}();
$fdbd89e429f2aa39$var$node.hash = "d1ed786c62b431549c6e881cb261091e";
var $fdbd89e429f2aa39$export$2e2bcd8739ae039 = $fdbd89e429f2aa39$var$node;
module.exports["default"] = $fdbd89e429f2aa39$export$2e2bcd8739ae039;

});

parcelRegister("dC2j7", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports, no-unneeded-ternary */ 
var $c3Qwv = parcelRequire("c3Qwv");

const $acb737f2b02900d4$var$CCSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $acb737f2b02900d4$export$3e1423ba918b02c3 = 12;
const $acb737f2b02900d4$export$964ee2c26a2e8aba = {
    page: 'ati:cloud:confluence:page',
    blogpost: 'ati:cloud:confluence:blogpost',
    embed: 'ati:cloud:confluence:embed',
    folder: 'ati:cloud:confluence:folder',
    whiteboard: 'ati:cloud:confluence:whiteboard',
    database: 'ati:cloud:confluence:database'
};
const $acb737f2b02900d4$var$AGG_EXPERIENCE = 'ConfSpacePages';
const $acb737f2b02900d4$var$STARRED_PAGE_LABEL = 'my:favourite';
const $acb737f2b02900d4$export$f471e8a003a4fb0d = (sortBy)=>{
    if (!sortBy) return [];
    const order = sortBy.order === $acb737f2b02900d4$var$CCSortOrder.ASC ? 'ASC' : 'DESC';
    let field;
    switch(sortBy.field){
        case 'LAST_MODIFIED_DATE':
            field = 'latestModifiedDate';
            break;
        case 'TITLE':
            field = 'title';
            break;
        default:
            field = 'latestModifiedDate';
    }
    return [
        {
            field: field,
            order: order
        }
    ];
};
const $acb737f2b02900d4$export$832c8592ab821c21 = ({ cloudId: cloudId, spaceKey: spaceKey, userId: userId, isLicensed: isLicensed, spaceId: spaceId, isWhiteboardEnabled: isWhiteboardEnabled, isDatabaseEnabled: isDatabaseEnabled, searchText: searchText, pagesFilter: pagesFilter, sort: sort, after: after = '', includeRecommended: includeRecommended = false })=>{
    return {
        cloudIdARI: [
            `ari:cloud:confluence::site/${cloudId}`
        ],
        tenantId: cloudId,
        limit: $acb737f2b02900d4$export$3e1423ba918b02c3,
        after: after,
        query: searchText,
        commonFilters: {
            range: {}
        },
        confluenceFilters: {
            spacesFilter: [
                spaceKey
            ],
            ...pagesFilter === 'worked-on' && userId && isLicensed && {
                contributorsFilter: [
                    userId
                ]
            },
            ...pagesFilter === 'starred' && isLicensed && {
                labelsFilter: [
                    $acb737f2b02900d4$var$STARRED_PAGE_LABEL
                ]
            },
            titleMatchOnly: true,
            contentStatuses: [
                'CURRENT',
                'DRAFT'
            ],
            containerStatus: []
        },
        sort: sort ? sort : [],
        entities: [
            $acb737f2b02900d4$export$964ee2c26a2e8aba.page,
            $acb737f2b02900d4$export$964ee2c26a2e8aba.embed,
            $acb737f2b02900d4$export$964ee2c26a2e8aba.folder,
            ...isWhiteboardEnabled ? [
                $acb737f2b02900d4$export$964ee2c26a2e8aba.whiteboard
            ] : [],
            ...isDatabaseEnabled ? [
                $acb737f2b02900d4$export$964ee2c26a2e8aba.database
            ] : []
        ],
        experience: $acb737f2b02900d4$var$AGG_EXPERIENCE,
        spaceId: spaceId,
        isLicensed: Boolean(isLicensed),
        includeRecommended: includeRecommended
    };
};
const $acb737f2b02900d4$export$9afcdf80918a886b = (options)=>{
    const { cloudId: cloudId, spaceKey: spaceKey, queryParams: queryParams, userId: userId, isLicensed: isLicensed, spaceId: spaceId = '', isWhiteboardEnabled: isWhiteboardEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false } = options;
    const pagesFilter = (0, $c3Qwv.getSingleParam)(queryParams, 'pagesFilter');
    const searchText = (0, $c3Qwv.getSingleParam)(queryParams, 'text') || '';
    const sort = [
        {
            field: 'latestModifiedDate',
            order: 'DESC'
        }
    ];
    return $acb737f2b02900d4$export$832c8592ab821c21({
        cloudId: cloudId,
        spaceKey: spaceKey,
        userId: userId,
        isLicensed: isLicensed,
        spaceId: spaceId,
        isWhiteboardEnabled: isWhiteboardEnabled,
        isDatabaseEnabled: isDatabaseEnabled,
        searchText: searchText,
        pagesFilter: pagesFilter,
        sort: sort
    });
};
module.exports["convertCcSortToAggSort"] = $acb737f2b02900d4$export$f471e8a003a4fb0d;
module.exports["getAggSpacePagesQueryVariables"] = $acb737f2b02900d4$export$832c8592ab821c21;
module.exports["getPreloadAggSpacePagesQueryVariables"] = $acb737f2b02900d4$export$9afcdf80918a886b;

});

parcelRegister("yuLaV", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $jH9cM = parcelRequire("jH9cM");


var $3ricL = parcelRequire("3ricL");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            const isEnvEnabled = (0, $3ricL.isFeatureEnabled)('confluence', featureKeyMap[contentType], {
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                'fedramp-moderate': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_fedramp'),
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                'isolated-cloud-commercial': ()=>(0, $9wGTI.fg)('confluence_frontend_enable_canvas_types_in_ic')
            });
            if (contentType === 'slide') return isEnvEnabled && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
            return isEnvEnabled;
        }
        if (contentType === 'slide') return !(0, $jH9cM.isFedRamp)() && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        !(0, $9wGTI.fg)('cc-mui-slides-opted-out') && (0, $6mKj3.expValEquals)('cc-mui-slides-experiment', 'isEnabled', true);
        return !(0, $jH9cM.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("aYbn7", function(module, exports) {
/**
 * @generated SignedSource<<3da907304922aa316c0cd54ed0c14713>>
 * @relayHash 7df592bb5fda30e06f43718e9defe250
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 19a2cf3f1071fa87f2247c1bd2cea6e61fa75346876ceb3ad87e1ca8779b8e5d
const $ece8cda195425f0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "value"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confRev"
                        }
                    ]
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "number"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"content-appearance-published\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRendererExternalQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRendererExternalQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7df592bb5fda30e06f43718e9defe250",
            "id": "19a2cf3f1071fa87f2247c1bd2cea6e61fa75346876ceb3ad87e1ca8779b8e5d",
            "metadata": {},
            "name": "ContentRendererExternalQuery",
            "operationKind": "query",
            "text": "query ContentRendererExternalQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{value}},type,version{confRev},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}}}}"
        }
    };
}();
$ece8cda195425f0d$var$node.hash = "8649e53c65ceb270b387846df51531ee";
var $ece8cda195425f0d$export$2e2bcd8739ae039 = $ece8cda195425f0d$var$node;
module.exports["default"] = $ece8cda195425f0d$export$2e2bcd8739ae039;

});

parcelRegister("eP7b6", function(module, exports) {
/**
 * @generated SignedSource<<293007c6777799aa33e10204d25d472b>>
 * @relayHash 002ee32db0695a9b63af69a407a07639
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54
const $0ba271c76ca4c8d2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "alias": "emojiTitlePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "emoji-title-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": v4 /*: any*/ ,
                    "storageKey": "properties(key:\"emoji-title-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                            "kind": "LinkedField",
                            "name": "frontend",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fabricEditorSupported"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTitleExternalQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "002ee32db0695a9b63af69a407a07639",
            "id": "5d8fe2acb674a13f635de2de38cd556b5d67fea5e30e200be8bdac0269751a54",
            "metadata": {},
            "name": "ContentTitleExternalQuery",
            "operationKind": "query",
            "text": "query ContentTitleExternalQuery($contentId:ID!){singleContent(id:$contentId){id,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported}}}}"
        }
    };
}();
$0ba271c76ca4c8d2$var$node.hash = "99403818c8d620c95107a7fed0ae3cd7";
var $0ba271c76ca4c8d2$export$2e2bcd8739ae039 = $0ba271c76ca4c8d2$var$node;
module.exports["default"] = $0ba271c76ca4c8d2$export$2e2bcd8739ae039;

});

parcelRegister("9HhEw", function(module, exports) {
/**
 * @generated SignedSource<<79c229d4f4ae3adcbe0b4f7f72920a16>>
 * @relayHash 80f146a83f48be7b9331f291c6222df0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962
const $cb80c8184222fcac$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ], v8 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v9 = {
        "kind": "ScalarField",
        "name": "number"
    }, v10 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v11 = {
        "kind": "ScalarField",
        "name": "syncRev"
    }, v12 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v3 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v7 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalByLineQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "lastOwnedBy",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v13 /*: any*/ 
                                },
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "80f146a83f48be7b9331f291c6222df0",
            "id": "441a5a61fe71025e06bc5da2cffef931ef0f47310237ad63b8470d65a380d962",
            "metadata": {},
            "name": "ExternalByLineQuery",
            "operationKind": "query",
            "text": "query ExternalByLineQuery($contentId:ID!){singleContent(id:$contentId){id,type,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId}},ownedBy{__typename,type,displayName,...on KnownUser{accountId}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId}}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,confRev,syncRev,contentTypeModified}}}"
        }
    };
}();
$cb80c8184222fcac$var$node.hash = "012bf9a7497572d73e22134c755e8758";
var $cb80c8184222fcac$export$2e2bcd8739ae039 = $cb80c8184222fcac$var$node;
module.exports["default"] = $cb80c8184222fcac$export$2e2bcd8739ae039;

});

parcelRegister("73cd2", function(module, exports) {
/**
 * @generated SignedSource<<c6c020a68d69e9e48a5ac030b6585a64>>
 * @relayHash 4fdb1f894d6df44e4cf39caaffb8cb1f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a0e4e72ab737980a3ca2f8403bce83b6a5ed72adbe7eada3312127dad645f8d7
const $6373d130d96f71f6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shareToken"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "key"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "referenceId"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                v4 /*: any*/ ,
                {
                    "concreteType": "ConfluenceAccessLinkInfo",
                    "kind": "LinkedField",
                    "name": "accessLinkInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        },
                        v4 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "lastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "when"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        }
                    ]
                },
                {
                    "alias": "appearancePublished",
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "content-appearance-published"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "number"
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"content-appearance-published\")"
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "key",
                            "value": "editor"
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ],
                    "storageKey": "properties(key:\"editor\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "SharedContentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "SharedContentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "4fdb1f894d6df44e4cf39caaffb8cb1f",
            "id": "a0e4e72ab737980a3ca2f8403bce83b6a5ed72adbe7eada3312127dad645f8d7",
            "metadata": {},
            "name": "SharedContentQuery",
            "operationKind": "query",
            "text": "query SharedContentQuery($shareToken:String!,$contentId:ID){singleContent(shareToken:$shareToken,id:$contentId){id,referenceId,space{id,key,alias,name},title,type,subType,status,accessLinkInfo{accessType,status},history{createdDate,lastUpdated{when}},version{friendlyWhen},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(key:\"editor\"){nodes{id,key,value}}}}"
        }
    };
}();
$6373d130d96f71f6$var$node.hash = "2aaa01efb1277573924d9d8cb34989ad";
var $6373d130d96f71f6$export$2e2bcd8739ae039 = $6373d130d96f71f6$var$node;
module.exports["default"] = $6373d130d96f71f6$export$2e2bcd8739ae039;

});

parcelRegister("83sfO", function(module, exports) {
const $567f280605647fdf$export$5d4c19aec4201e9 = 'live';
module.exports["LIVE_PAGE_SUBTYPE"] = $567f280605647fdf$export$5d4c19aec4201e9;

});

parcelRegister("5WLjq", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $5IsL6 = parcelRequire("5IsL6");


var $gW6rh = parcelRequire("gW6rh");


var $4H4Pj = parcelRequire("4H4Pj");


var $4eIcx = parcelRequire("4eIcx");


var $5t9S7 = parcelRequire("5t9S7");

const $0075b8fcac3e7fa4$export$19b525d696aff959 = ({ isLicensed: isLicensed, selectedSpaceKey: selectedSpaceKey })=>{
    const preloadQueries = [];
    if (isLicensed) {
        preloadQueries.push((0, $dYU3e.query)({
            query: (0, $gW6rh.default),
            variables: {},
            __callerPackage__: "space-utils"
        }));
        if (selectedSpaceKey) preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4eIcx.default),
            variables: {
                selectedSpaceKey: selectedSpaceKey
            },
            __callerPackage__: "space-utils"
        }));
        else preloadQueries.push((0, $dYU3e.query)({
            query: (0, $4H4Pj.default),
            variables: {},
            __callerPackage__: "space-utils"
        }));
    } else preloadQueries.push((0, $dYU3e.query)({
        query: (0, $5t9S7.default),
        variables: {},
        __callerPackage__: "space-utils"
    }));
    preloadQueries.push((0, $5IsL6.preloadCreateSpace)({
        isLicensed: isLicensed
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(preloadQueries);
};
module.exports["preloadSpacesList"] = $0075b8fcac3e7fa4$export$19b525d696aff959;

});

parcelRegister("5IsL6", function(module, exports) {

var $fEhQK = parcelRequire("fEhQK");


var $dYU3e = parcelRequire("dYU3e");

/**
 * see next/packages/create-space/src/useCanCreateSpace.tsx for the query usage
 */ const $c4ac54148814de4b$var$PreloadCreateSpaceQuery = (0, $fEhQK.default);
const $c4ac54148814de4b$export$25bcc47d8ed557d4 = ({ isLicensed: isLicensed })=>{
    if (!isLicensed) return Promise.resolve({
        data: null
    });
    return (0, $dYU3e.query)({
        query: $c4ac54148814de4b$var$PreloadCreateSpaceQuery,
        __callerPackage__: "create-space-preload"
    });
};
module.exports["preloadCreateSpace"] = $c4ac54148814de4b$export$25bcc47d8ed557d4;

});

parcelRegister("fEhQK", function(module, exports) {
/**
 * @generated SignedSource<<d09735fc2cd7a6020b32121ef039e936>>
 * @relayHash a615654a08ce3274fc54e07efd9211ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf
const $ba87c6a44dc20089$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadCreateSpaceQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "a615654a08ce3274fc54e07efd9211ea",
            "id": "e5addd49b9ac727e4192ce3ec103b6837173e48788768fc87bc51109c51864cf",
            "metadata": {},
            "name": "preloadCreateSpaceQuery",
            "operationKind": "query",
            "text": "query preloadCreateSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation}}}}"
        }
    };
}();
$ba87c6a44dc20089$var$node.hash = "9a716c385cdfcba90204a7cf16292b9a";
var $ba87c6a44dc20089$export$2e2bcd8739ae039 = $ba87c6a44dc20089$var$node;
module.exports["default"] = $ba87c6a44dc20089$export$2e2bcd8739ae039;

});

parcelRegister("gW6rh", function(module, exports) {
/**
 * @generated SignedSource<<6731d778ac5ebb58b720918619ebf00d>>
 * @relayHash 3aa9658e6db0cb9714f9e327bc6d5bd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8
const $af8a2f26164bd677$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "favourite",
                    "value": true
                },
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 30
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "current"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(favourite:true,first:30,status:\"current\")"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataStarredSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "3aa9658e6db0cb9714f9e327bc6d5bd0",
            "id": "9732bd17f0f57947436f8213d4305b2e471121c66764a94800bca9ec865695d8",
            "metadata": {},
            "name": "useSpacesDataStarredSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataStarredSpacesQuery{spaces(favourite:true,first:30,status:\"current\"){__typename,nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$af8a2f26164bd677$var$node.hash = "519f9d02cbfeb4f3f118821c02e3a7b9";
var $af8a2f26164bd677$export$2e2bcd8739ae039 = $af8a2f26164bd677$var$node;
module.exports["default"] = $af8a2f26164bd677$export$2e2bcd8739ae039;

});

parcelRegister("4H4Pj", function(module, exports) {
/**
 * @generated SignedSource<<522284270ccae9ff37ff7a08efdc694a>>
 * @relayHash 0f8f1589411c8c2d9b98218fe1edd493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79
const $893f79462ca6be46$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "0f8f1589411c8c2d9b98218fe1edd493",
            "id": "68fe95b23891fbec5be8b12d63fd41809cfcfc27e7e63fbb44888dd38747ee79",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesQuery{myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$893f79462ca6be46$var$node.hash = "7082555a280d4e2eb838dda87a12b019";
var $893f79462ca6be46$export$2e2bcd8739ae039 = $893f79462ca6be46$var$node;
module.exports["default"] = $893f79462ca6be46$export$2e2bcd8739ae039;

});

parcelRegister("4eIcx", function(module, exports) {
/**
 * @generated SignedSource<<2801721cb0c85e92874b08f85a0ef8ee>>
 * @relayHash e0d0ca312e455dd89cba54cfb1984fbb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e
const $f0042d2ade0da40c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "selectedSpaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "alias"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "status"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "icon",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "selectedSpaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isFavourited"
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "limit",
                    "value": 26
                }
            ],
            "concreteType": "MyVisitedSpaces",
            "kind": "LinkedField",
            "name": "myVisitedSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MyVisitedSpacesItems",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "spaces",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "myVisitedSpaces(limit:26)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "selections": v7 /*: any*/ 
        },
        "params": {
            "cacheID": "e0d0ca312e455dd89cba54cfb1984fbb",
            "id": "526240db83f047ca0274a00241245e9aa0b1109c534c8e0fb8577568d58ba35e",
            "metadata": {},
            "name": "useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery",
            "operationKind": "query",
            "text": "query useSpacesDataMyVisitedSpacesWithCurrentSpaceQuery($selectedSpaceKey:String){space(key:$selectedSpaceKey){alias,id,name,key,status,icon{path},currentUser{isFavourited}},myVisitedSpaces(limit:26){nodes{spaces{alias,id,name,key,status,icon{path}}}}}"
        }
    };
}();
$f0042d2ade0da40c$var$node.hash = "24da03b127211694c7ed862f0d6a1ac9";
var $f0042d2ade0da40c$export$2e2bcd8739ae039 = $f0042d2ade0da40c$var$node;
module.exports["default"] = $f0042d2ade0da40c$export$2e2bcd8739ae039;

});

parcelRegister("5t9S7", function(module, exports) {
/**
 * @generated SignedSource<<834023d7f0314fe8e5962f6e892c4636>>
 * @relayHash 6a42dba0e2f55d85a4e53a29287ca269
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476
const $410f901cf69fac5d$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "spaces(first:10)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useSpacesDataAnonymousSpacesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "6a42dba0e2f55d85a4e53a29287ca269",
            "id": "5e3f4c044b63a16f4dffed6bb0854c1e5cb8e810b97ad22a7a75eed9bb785476",
            "metadata": {},
            "name": "useSpacesDataAnonymousSpacesQuery",
            "operationKind": "query",
            "text": "query useSpacesDataAnonymousSpacesQuery{spaces(first:10){nodes{alias,id,name,key,status,icon{path}}}}"
        }
    };
}();
$410f901cf69fac5d$var$node.hash = "7f837e22c8d2b27a827944523b07b786";
var $410f901cf69fac5d$export$2e2bcd8739ae039 = $410f901cf69fac5d$var$node;
module.exports["default"] = $410f901cf69fac5d$export$2e2bcd8739ae039;

});

parcelRegister("2XnBq", function(module, exports) {
/**
 * @generated SignedSource<<32d93325a27852124b5d99365dc2cff4>>
 * @relayHash b2a8ea8d210999521cf3b649254b93b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b280819fb9c85b6d95763ed6f26cb6c023351042bc0addf09716d3b76423122a
const $11dc747b33c63e78$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siteAri"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "siteAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "args": [
            {
                "kind": "Literal",
                "name": "filter",
                "value": {
                    "atis": [
                        "ati:cloud:studio:workspace"
                    ]
                }
            },
            {
                "kind": "Literal",
                "name": "first",
                "value": 1
            }
        ],
        "concreteType": "AdminUnitLinkedConnection",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "concreteType": "AdminUnitLinkedEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "AdminUnitLinkedTo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "links(filter:{\"atis\":[\"ati:cloud:studio:workspace\"]},first:1)"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useStudioPermissionsLinkedWorkspaceQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AdminUnitLinkedResource",
                    "kind": "LinkedField",
                    "name": "admin_unitLinkedResource",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useStudioPermissionsLinkedWorkspaceQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "AdminUnitLinkedResource",
                    "kind": "LinkedField",
                    "name": "admin_unitLinkedResource",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b2a8ea8d210999521cf3b649254b93b4",
            "id": "b280819fb9c85b6d95763ed6f26cb6c023351042bc0addf09716d3b76423122a",
            "metadata": {},
            "name": "useStudioPermissionsLinkedWorkspaceQuery",
            "operationKind": "query",
            "text": "query useStudioPermissionsLinkedWorkspaceQuery($siteAri:ID!){admin_unitLinkedResource(id:$siteAri){links(first:1,filter:{atis:[\"ati:cloud:studio:workspace\"]}){edges{node{id}}},id}}"
        }
    };
}();
$11dc747b33c63e78$var$node.hash = "29c062799a5b2c1f7df7d186f1b7b94b";
var $11dc747b33c63e78$export$2e2bcd8739ae039 = $11dc747b33c63e78$var$node;
module.exports["default"] = $11dc747b33c63e78$export$2e2bcd8739ae039;

});

parcelRegister("c3rPL", function(module, exports) {
/**
 * @generated SignedSource<<b4d9b389974e1e2b04f360a57f72927b>>
 * @relayHash 149d2389147c874aab96bf7e444616a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b9f1a2541961493f1ece64ec09a3d9b2e21ae4af470894d68a879429dad460c9
const $3beb673f6f4c6093$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "workspaceId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "workspaceId",
                    "variableName": "workspaceId"
                }
            ],
            "concreteType": "StudioWorkspaceCapabilities",
            "kind": "LinkedField",
            "name": "studio_workspaceCapabilities",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canCreateAutomationsInDefaultSpace"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useStudioPermissionsWorkspaceCapabilitiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useStudioPermissionsWorkspaceCapabilitiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "149d2389147c874aab96bf7e444616a0",
            "id": "b9f1a2541961493f1ece64ec09a3d9b2e21ae4af470894d68a879429dad460c9",
            "metadata": {},
            "name": "useStudioPermissionsWorkspaceCapabilitiesQuery",
            "operationKind": "query",
            "text": "query useStudioPermissionsWorkspaceCapabilitiesQuery($workspaceId:ID!){studio_workspaceCapabilities(workspaceId:$workspaceId)@optIn(to:\"StudioWorkspaceCapabilities\"){canCreateAutomationsInDefaultSpace}}"
        }
    };
}();
$3beb673f6f4c6093$var$node.hash = "1a9a593d1bbf9038222f298a6b387b82";
var $3beb673f6f4c6093$export$2e2bcd8739ae039 = $3beb673f6f4c6093$var$node;
module.exports["default"] = $3beb673f6f4c6093$export$2e2bcd8739ae039;

});

parcelRegister("fTRoC", function(module, exports) {

var $5FMVr = parcelRequire("5FMVr");


var $hxlW2 = parcelRequire("hxlW2");


var $d9tcB = parcelRequire("d9tcB");

const $d43d34e2bfb3d2ae$export$bb84b9030972991c = ({ cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn })=>{
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    return Boolean(isRovoLLMEnabled && !isAnonymousUser && cloudId);
};
const $d43d34e2bfb3d2ae$export$6171b36848d7f2ff = (cloudId)=>{
    if (!cloudId) return null;
    try {
        return (0, $5FMVr.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
    } catch  {
        return null;
    }
};
const $d43d34e2bfb3d2ae$export$4ea30a3e247d9f69 = (data)=>{
    const workspaceAri = data?.admin_unitLinkedResource?.links?.edges?.[0]?.node?.id;
    return workspaceAri && (0, $hxlW2.StudioWorkspaceAri).check(workspaceAri) ? (0, $hxlW2.StudioWorkspaceAri).parse(workspaceAri) : null;
};
module.exports["hasStudioPermissionsBaseEligibility"] = $d43d34e2bfb3d2ae$export$bb84b9030972991c;
module.exports["getStudioWorkspaceLookupSiteAri"] = $d43d34e2bfb3d2ae$export$6171b36848d7f2ff;
module.exports["getLinkedStudioWorkspaceAri"] = $d43d34e2bfb3d2ae$export$4ea30a3e247d9f69;

});

parcelRegister("5FMVr", function(module, exports) {

var $6EphZ = parcelRequire("6EphZ");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/site/manifest.ts
var $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $6EphZ.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $6EphZ.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $4216bba50de8d2e4$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $4216bba50de8d2e4$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ConfluenceSiteAri"] = $4216bba50de8d2e4$export$82e6693d75ffdd8;

});

parcelRegister("6EphZ", function(module, exports) {
// src/confluence/site/types.ts
var $4d7a18635b736c71$export$9e07499cd8b0bde5 = "confluence", $4d7a18635b736c71$export$57b7cabbf31f1f68 = "site";
module.exports["ConfluenceSiteAriResourceOwner"] = $4d7a18635b736c71$export$9e07499cd8b0bde5;
module.exports["ConfluenceSiteAriResourceType"] = $4d7a18635b736c71$export$57b7cabbf31f1f68;

});

parcelRegister("hxlW2", function(module, exports) {

var $1uK7M = parcelRequire("1uK7M");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/studio/workspace/manifest.ts
var $cc468898296ff14c$var$studioWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $1uK7M.StudioWorkspaceAriResourceOwner),
    resourceType: (0, $1uK7M.StudioWorkspaceAriResourceType),
    resourceIdSlug: "{workspaceId}",
    resourceIdSegmentFormats: {
        workspaceId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/studio/workspace/index.ts
var $cc468898296ff14c$export$b1c922ee878b8ada = class _StudioWorkspaceAri extends (0, $9j37t.RegisteredAri) {
    get workspaceId() {
        return this._workspaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cc468898296ff14c$var$studioWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $cc468898296ff14c$var$studioWorkspaceAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $cc468898296ff14c$var$studioWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $cc468898296ff14c$var$studioWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.workspaceId}`,
            resourceIdSegmentValues: {
                workspaceId: opts.workspaceId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $cc468898296ff14c$var$studioWorkspaceAriStaticOpts);
        return new _StudioWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $cc468898296ff14c$var$studioWorkspaceAriStaticOpts);
        return new _StudioWorkspaceAri(opts);
    }
    getVariables() {
        return {
            workspaceId: this.workspaceId
        };
    }
    constructor(opts){
        super(opts), this._workspaceId = opts.resourceIdSegmentValues.workspaceId;
    }
};
module.exports["StudioWorkspaceAri"] = $cc468898296ff14c$export$b1c922ee878b8ada;

});

parcelRegister("1uK7M", function(module, exports) {
// src/studio/workspace/types.ts
var $116c5f21c6f2e932$export$d24c7c9a6a764930 = "studio", $116c5f21c6f2e932$export$3b0bff5644c1c632 = "workspace";
module.exports["StudioWorkspaceAriResourceOwner"] = $116c5f21c6f2e932$export$d24c7c9a6a764930;
module.exports["StudioWorkspaceAriResourceType"] = $116c5f21c6f2e932$export$3b0bff5644c1c632;

});

parcelRegister("gGK1T", function(module, exports) {
/**
 * @generated SignedSource<<e983bd00ea24afc042f5f11535352524>>
 * @relayHash b8208417e6c09fc98b947c6af794b0f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327
const $edbbfe37cbd0175f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": 4,
            "kind": "LocalArgument",
            "name": "limit"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v8 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "limit",
            "variableName": "limit"
        }
    ], v10 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v8 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v8 /*: any*/ 
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": v10 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v9 /*: any*/ ,
                    "concreteType": "ContentContributors",
                    "kind": "LinkedField",
                    "name": "contentContributors",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": v10 /*: any*/ 
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8208417e6c09fc98b947c6af794b0f3",
            "id": "c971c003da78a01cf940b7459511673bdc72b6148aa95f1c43a4a7a4369e8327",
            "metadata": {},
            "name": "useContentOwnershipContributorsContentOwnershipContributorsQuery",
            "operationKind": "query",
            "text": "query useContentOwnershipContributorsContentOwnershipContributorsQuery($contentId:ID!,$limit:Int=4){content(id:$contentId){nodes{id,history{ownedBy{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}},contentContributors(id:$contentId,limit:$limit){nodes{__typename,displayName,type,...on KnownUser{accountId},profilePicture{path}}}}"
        }
    };
}();
$edbbfe37cbd0175f$var$node.hash = "e8dd42a19657acc23120ab54c46606ff";
var $edbbfe37cbd0175f$export$2e2bcd8739ae039 = $edbbfe37cbd0175f$var$node;
module.exports["default"] = $edbbfe37cbd0175f$export$2e2bcd8739ae039;

});

parcelRegister("2E1L5", function(module, exports) {
const $f1205e6da653ae62$export$16708f74bd486c8 = 'confluence_page_ownership_changeboarding';
const $f1205e6da653ae62$export$9ed1986df73b834a = 'change-page-ownership-link';
const $f1205e6da653ae62$export$21191b0c00ca25f4 = 10;
const $f1205e6da653ae62$export$83728ea2bd792f67 = {
    USER_IS_NULL: 'You cannot set an owner as an anonymous user.',
    USER_NOT_FOUND: 'Owner id is an invalid account id.',
    USER_MISSING_PAGE_PERMISSION: 'New owner must have view and edit permission on the content.',
    CONTENT_ID_INVALID: 'Content id is invalid.',
    INSUFFICIENT_PERMISSIONS: 'You must be the content creator, owner, or a space admin to set the owner.'
};
const $f1205e6da653ae62$export$f0b683cb64dc68b0 = 'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions/';
const $f1205e6da653ae62$export$b344b39e3835f655 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
const $f1205e6da653ae62$export$7ab4b084abc24ac8 = 'https://support.atlassian.com/confluence-cloud/docs/transfer-ownership-of-your-page-to-another-person/';
module.exports["CONTENT_OWNERSHIP_WEB_ITEM_ID"] = $f1205e6da653ae62$export$9ed1986df73b834a;
module.exports["DEFAULT_CONTRIBUTORS_FETCH_LIMIT"] = $f1205e6da653ae62$export$21191b0c00ca25f4;
module.exports["EXPECTED_ERROR_MESSAGES"] = $f1205e6da653ae62$export$83728ea2bd792f67;
module.exports["PARENT_PAGE_LEARN_MORE_URL"] = $f1205e6da653ae62$export$f0b683cb64dc68b0;
module.exports["CONFIRM_MODAL_LEARN_MORE_LINK"] = $f1205e6da653ae62$export$7ab4b084abc24ac8;

});

parcelRegister("duklN", function(module, exports) {
/**
 * @generated SignedSource<<cc7770e3fb2fd979845343325dfb00a2>>
 * @relayHash 512d3c288e476ca23b45061d9102b2d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b
const $78d6c4b2c14ab559$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageTitlePageTitleQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "512d3c288e476ca23b45061d9102b2d6",
            "id": "e2afb2ac9c484784fd55eb2fcafbcb54d438eef15f40b0e4c160a6b625de2a3b",
            "metadata": {},
            "name": "usePageTitlePageTitleQuery",
            "operationKind": "query",
            "text": "query usePageTitlePageTitleQuery($contentId:ID!){singleContent(id:$contentId){id,title}}"
        }
    };
}();
$78d6c4b2c14ab559$var$node.hash = "49163e20c25d3da0c01ad2e924f87c37";
var $78d6c4b2c14ab559$export$2e2bcd8739ae039 = $78d6c4b2c14ab559$var$node;
module.exports["default"] = $78d6c4b2c14ab559$export$2e2bcd8739ae039;

});

parcelRegister("8N95V", function(module, exports) {
/**
 * @generated SignedSource<<1cc0f8340d365118c8b0f69a30f40fe2>>
 * @relayHash 3b5fad1a56c1598624b4b5ffdde44051
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c049eefe56af2e3d93d69210c8f6fc06cdb796a19b009865dd5ce274d19afd1
const $aa86d7b4cd56d740$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
    }, v2 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "page"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "lastUpdated",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "when"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "concreteType": "Contributors",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContributorUsers",
                                    "kind": "LinkedField",
                                    "name": "publishers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "users",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v9 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "folder"
        }
    ], v10 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "whiteboard"
        }
    ], v11 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "database"
        }
    ], v12 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "embed"
        }
    ], v13 = [
        v1 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "slide"
        }
    ], v14 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "concreteType": "Contributors",
                            "kind": "LinkedField",
                            "name": "contributors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContributorUsers",
                                    "kind": "LinkedField",
                                    "name": "publishers",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "users",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FolderOverviewChildrenContentQuery",
            "selections": [
                {
                    "alias": "pageContent",
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "folderContent",
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "whiteboardContent",
                    "args": v10 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "databaseContent",
                    "args": v11 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "embedContent",
                    "args": v12 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "alias": "slideContent",
                    "args": v13 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FolderOverviewChildrenContentQuery",
            "selections": [
                {
                    "alias": "pageContent",
                    "args": v2 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "folderContent",
                    "args": v9 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "whiteboardContent",
                    "args": v10 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "databaseContent",
                    "args": v11 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "embedContent",
                    "args": v12 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                },
                {
                    "alias": "slideContent",
                    "args": v13 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v14 /*: any*/ 
                }
            ]
        },
        "params": {
            "cacheID": "3b5fad1a56c1598624b4b5ffdde44051",
            "id": "4c049eefe56af2e3d93d69210c8f6fc06cdb796a19b009865dd5ce274d19afd1",
            "metadata": {},
            "name": "FolderOverviewChildrenContentQuery",
            "operationKind": "query",
            "text": "query FolderOverviewChildrenContentQuery($ids:[ID!]!){pageContent:content(ids:$ids,type:\"page\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},folderContent:content(ids:$ids,type:\"folder\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},whiteboardContent:content(ids:$ids,type:\"whiteboard\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},databaseContent:content(ids:$ids,type:\"database\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},embedContent:content(ids:$ids,type:\"embed\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}},slideContent:content(ids:$ids,type:\"slide\"){nodes{id,history{lastUpdated{when},contributors{publishers{users{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}}}"
        }
    };
}();
$aa86d7b4cd56d740$var$node.hash = "47e4e127b7c7f393d655d6799a3ed4a3";
var $aa86d7b4cd56d740$export$2e2bcd8739ae039 = $aa86d7b4cd56d740$var$node;
module.exports["default"] = $aa86d7b4cd56d740$export$2e2bcd8739ae039;

});

parcelRegister("fDjhq", function(module, exports) {
/**
 * @generated SignedSource<<177663c771a62bc00caa6d5e8b52c8bf>>
 * @relayHash 85cb0d76b7f30cedec41d67061ac7b61
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d44ce9e927db2a5197576051a54b07d6c23f9b6248623bd2f79bc04027b2f6aa
const $15c1c72a72f2cd3e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": 100,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeArchiveFolderSupport"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeDevDocsSyncStatus"
    }, v5 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFolderSummary"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraPlannerConnection"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "parentId"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "parentId"
            },
            {
                "kind": "Literal",
                "name": "status",
                "value": [
                    "CURRENT",
                    "DRAFT"
                ]
            }
        ],
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "ptpage",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v14 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "condition": "includeArchiveFolderSupport",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            v15 /*: any*/ ,
            v10 /*: any*/ ,
            v12 /*: any*/ 
        ]
    }, v17 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "condition": "includeArchiveFolderSupport",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            }
        ]
    }, v18 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "coverPicture"
                    }
                ]
            }
        ]
    }, v19 = {
        "kind": "ScalarField",
        "name": "value"
    }, v20 = {
        "condition": "includeFolderSummary",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    }
                ]
            },
            {
                "concreteType": "ContentBodyPerRepresentation",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentBody",
                        "kind": "LinkedField",
                        "name": "storage",
                        "plural": false,
                        "selections": [
                            v19 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "key"
    }, v22 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v21 /*: any*/ ,
                v19 /*: any*/ 
            ]
        }
    ], v23 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v22 /*: any*/ ,
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v24 = {
        "condition": "includeJiraPlannerConnection",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "jiraPlannerConnection",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "jira-planner-connection"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v21 /*: any*/ ,
                            v19 /*: any*/ 
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"jira-planner-connection\"])"
            }
        ]
    }, v25 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "devdocsProperties"
            ]
        }
    ], v26 = {
        "alias": "devDocsOwnershipProperties",
        "args": v25 /*: any*/ ,
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"devdocsProperties\"])"
    }, v27 = {
        "condition": "includeDevDocsSyncStatus",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "devDocsProperties",
                "args": v25 /*: any*/ ,
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v22 /*: any*/ ,
                "storageKey": "properties(keys:[\"devdocsProperties\"])"
            }
        ]
    }, v28 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v29 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v30 = {
        "kind": "Variable",
        "name": "parentId",
        "variableName": "parentId"
    }, v31 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v32 = [
        v28 /*: any*/ ,
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "FOLDER"
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "emojiTitlePublished"
    }, v34 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v35 = {
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v36 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v37 = [
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ 
            ]
        },
        v36 /*: any*/ 
    ], v38 = [
        v28 /*: any*/ ,
        v29 /*: any*/ ,
        v30 /*: any*/ ,
        v31 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "type",
            "value": "CONTENT"
        }
    ], v39 = [
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v15 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ 
            ]
        },
        v36 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "DualStreamQueriesFirstPageQuery",
            "selections": [
                v13 /*: any*/ ,
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v20 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ 
                    ]
                },
                {
                    "alias": "folders",
                    "args": v32 /*: any*/ ,
                    "concreteType": "ConfluenceContentTreeItemConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentTreeChildren",
                    "plural": false,
                    "selections": v37 /*: any*/ 
                },
                {
                    "alias": "content",
                    "args": v38 /*: any*/ ,
                    "concreteType": "ConfluenceContentTreeItemConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentTreeChildren",
                    "plural": false,
                    "selections": v37 /*: any*/ 
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v3 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "DualStreamQueriesFirstPageQuery",
            "selections": [
                v13 /*: any*/ ,
                {
                    "args": v14 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v18 /*: any*/ ,
                        v20 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v26 /*: any*/ ,
                        v27 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                },
                {
                    "alias": "folders",
                    "args": v32 /*: any*/ ,
                    "concreteType": "ConfluenceContentTreeItemConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentTreeChildren",
                    "plural": false,
                    "selections": v39 /*: any*/ 
                },
                {
                    "alias": "content",
                    "args": v38 /*: any*/ ,
                    "concreteType": "ConfluenceContentTreeItemConnection",
                    "kind": "LinkedField",
                    "name": "confluence_contentTreeChildren",
                    "plural": false,
                    "selections": v39 /*: any*/ 
                }
            ]
        },
        "params": {
            "cacheID": "85cb0d76b7f30cedec41d67061ac7b61",
            "id": "d44ce9e927db2a5197576051a54b07d6c23f9b6248623bd2f79bc04027b2f6aa",
            "metadata": {},
            "name": "DualStreamQueriesFirstPageQuery",
            "operationKind": "query",
            "text": "query DualStreamQueriesFirstPageQuery($cloudId:ID!,$parentId:ID!,$spaceKey:String,$contentId:ID!,$first:Int=100,$includeDevDocsSyncStatus:Boolean=false,$includeFolderSummary:Boolean=false,$includeArchiveFolderSupport:Boolean=false,$includeJiraPlannerConnection:Boolean=false){ptpage(id:$parentId,status:[CURRENT,DRAFT]){id,title,type,subType},singleContent(id:$contentId){status@include(if:$includeArchiveFolderSupport)\n    title@include(if:$includeArchiveFolderSupport)\n    subType@include(if:$includeArchiveFolderSupport),operations{operation,targetType@include(if:$includeArchiveFolderSupport)},contentProperties{latest{coverPicture}},version@include(if:$includeFolderSummary){number}\n    body@include(if:$includeFolderSummary){storage{value}},properties(keys:[\"smartFolderProperties\"]){nodes{id,key,value}},jiraPlannerConnection:properties(keys:[\"jira-planner-connection\"])@include(if:$includeJiraPlannerConnection){nodes{key,value}},devDocsOwnershipProperties:properties(keys:[\"devdocsProperties\"]){nodes{id,key}},devDocsProperties:properties(keys:[\"devdocsProperties\"])@include(if:$includeDevDocsSyncStatus){nodes{id,key,value}},id},folders:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:FOLDER,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}},content:confluence_contentTreeChildren(cloudId:$cloudId,parentId:$parentId,spaceKey:$spaceKey,type:CONTENT,first:$first){nodes{__typename,id,title,status,type,subType,emojiTitlePublished,links{webui},properties{nodes{id,key,value}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$15c1c72a72f2cd3e$var$node.hash = "d5fe00545e0fc29967b033e08f83d159";
var $15c1c72a72f2cd3e$export$2e2bcd8739ae039 = $15c1c72a72f2cd3e$var$node;
module.exports["default"] = $15c1c72a72f2cd3e$export$2e2bcd8739ae039;

});

parcelRegister("7jfZt", function(module, exports) {
const $41f3867909531b3f$export$f14e72fd46160aae = 100;
const $41f3867909531b3f$export$8ec3d08588d2eeda = 40;
const $41f3867909531b3f$export$52f2a5e5fe3f446b = (folderNodes, contentNodes, foldersExhausted, visibleCount)=>{
    const allFolderNodesShown = visibleCount >= folderNodes.length;
    const showContent = foldersExhausted && allFolderNodesShown;
    if (!showContent) return folderNodes.slice(0, visibleCount);
    const remainingSlots = visibleCount - folderNodes.length;
    const visibleContent = remainingSlots > 0 ? contentNodes.slice(0, remainingSlots) : [];
    return [
        ...folderNodes,
        ...visibleContent
    ];
};
/** Collects the ids of a stream's nodes, skipping any node without an id. */ const $41f3867909531b3f$var$collectIds = (stream)=>{
    const ids = [];
    for (const node of stream?.nodes ?? [])if (node?.id) ids.push(node.id);
    return ids;
};
const $41f3867909531b3f$export$e91dc7634634b3e7 = (folders, content)=>{
    const folderIds = $41f3867909531b3f$var$collectIds(folders);
    const contentIds = $41f3867909531b3f$var$collectIds(content);
    const foldersExhausted = folderIds.length === 0 || !(folders?.pageInfo?.hasNextPage ?? false);
    return $41f3867909531b3f$export$52f2a5e5fe3f446b(folderIds, contentIds, foldersExhausted, $41f3867909531b3f$export$8ec3d08588d2eeda);
};
module.exports["FETCH_SIZE"] = $41f3867909531b3f$export$f14e72fd46160aae;
module.exports["PAGE_SIZE"] = $41f3867909531b3f$export$8ec3d08588d2eeda;
module.exports["selectVisibleNodes"] = $41f3867909531b3f$export$52f2a5e5fe3f446b;
module.exports["getInitialVisibleChildIds"] = $41f3867909531b3f$export$e91dc7634634b3e7;

});

parcelRegister("ieWRE", function(module, exports) {
/**
 * @generated SignedSource<<cc3649e97b9be1d6269151089c18fb3f>>
 * @relayHash 544e060744fb4498c2bc0371295ea8f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126
const $89ec832c644948be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSmartFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsSmartFoldersEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "544e060744fb4498c2bc0371295ea8f5",
            "id": "44a5510e6c08eb024dc9e65741680c85b5e934e6cb2711735740a5c625e28126",
            "metadata": {},
            "name": "useIsSmartFoldersEnabledQuery",
            "operationKind": "query",
            "text": "query useIsSmartFoldersEnabledQuery($spaceKey:String!){space(key:$spaceKey){id,spaceTypeSettings{enabledContentTypes{isFoldersEnabled,isSmartFoldersEnabled}}}}"
        }
    };
}();
$89ec832c644948be$var$node.hash = "03675b093cffce21dc93e86a9415a3c7";
var $89ec832c644948be$export$2e2bcd8739ae039 = $89ec832c644948be$var$node;
module.exports["default"] = $89ec832c644948be$export$2e2bcd8739ae039;

});

parcelRegister("iaK3p", function(module, exports) {
/**
 * @generated SignedSource<<77901a4d26c14ce3e165e61f1fbc7d81>>
 * @relayHash 5f15c23509e6cb7f2874b0f92de8a11b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f
const $8d30006ecab20121$var$node = function() {
    var v0 = [
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "5f15c23509e6cb7f2874b0f92de8a11b",
            "id": "8c70e28d771c617ecf7c58416cff6761443cf9b61782cdb47a1bb82fdf95ba9f",
            "metadata": {},
            "name": "useFeatureDiscoveryFeatureDiscoveryQuery",
            "operationKind": "query",
            "text": "query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey,featureKey}}"
        }
    };
}();
$8d30006ecab20121$var$node.hash = "8577be880df828fbee71c90a7701eddf";
var $8d30006ecab20121$export$2e2bcd8739ae039 = $8d30006ecab20121$var$node;
module.exports["default"] = $8d30006ecab20121$export$2e2bcd8739ae039;

});

parcelRegister("Yc1IN", function(module, exports) {
/**
 * @generated SignedSource<<bd6b1ec563cea711fab078f320bd9b02>>
 * @relayHash 5fa23ad64581bf268c729651d6bf4ddb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e98aed0963d75eecbe46cb82c413f1c7dab51ea1ec1170145ad8a9a88b6c3de0
const $ffca0a52a06c83ff$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": "relevant",
        "kind": "LocalArgument",
        "name": "sortBy"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "recentActionsCount"
    }, v5 = {
        "kind": "ScalarField",
        "name": "datetime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "groupSize"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v11 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "KnownUser"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": v10 /*: any*/ ,
        "type": "UnknownUser"
    }, v13 = [
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v14 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v13 /*: any*/ 
    }, v15 = {
        "kind": "ScalarField",
        "name": "version"
    }, v16 = [
        v15 /*: any*/ ,
        v14 /*: any*/ 
    ], v17 = {
        "kind": "ScalarField",
        "name": "id"
    }, v18 = [
        {
            "kind": "ScalarField",
            "name": "webui"
        }
    ], v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "inlineText"
            }
        ],
        "type": "InlineComment"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            v21 /*: any*/ 
        ],
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v23 = {
        "kind": "ScalarField",
        "name": "source"
    }, v24 = {
        "kind": "ScalarField",
        "name": "title"
    }, v25 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v26 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v17 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v27 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v28 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v29 = {
        "concreteType": "ConfluenceContentAISummaryResponse",
        "kind": "LinkedField",
        "name": "aiProperty",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "objectData"
            },
            {
                "kind": "ScalarField",
                "name": "createdAt"
            },
            {
                "kind": "ScalarField",
                "name": "errorMessage"
            }
        ]
    }, v30 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v31 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v32 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v17 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v33 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v34 = {
        "concreteType": "FeedPageInformation",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v35 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "spaces",
        "plural": true,
        "selections": [
            v17 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "type",
                        "value": "ABSOLUTE"
                    }
                ],
                "kind": "ScalarField",
                "name": "path",
                "storageKey": "path(type:\"ABSOLUTE\")"
            }
        ]
    }, v37 = {
        "kind": "ScalarField",
        "name": "servingRecommendations"
    }, v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v39 = [
        v38 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ 
    ], v40 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v39 /*: any*/ 
    }, v41 = [
        v15 /*: any*/ ,
        v40 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v16 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v13 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v8 /*: any*/ ,
                                v36 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedFeed",
                    "kind": "LinkedField",
                    "name": "feed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "FeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "summaryLineUpdate",
                                    "plural": false,
                                    "selections": [
                                        v38 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ 
                                            ],
                                            "type": "FeedEventCreate"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEdit"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventEditLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": v41 /*: any*/ ,
                                            "type": "FeedEventPublishLive"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "Comment",
                                                    "kind": "LinkedField",
                                                    "name": "comment",
                                                    "plural": false,
                                                    "selections": [
                                                        v17 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "location",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        v22 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "type": "FeedEventComment"
                                        }
                                    ]
                                },
                                v23 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v24 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ ,
                                        v28 /*: any*/ ,
                                        v29 /*: any*/ ,
                                        v30 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v39 /*: any*/ 
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v38 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v9 /*: any*/ ,
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                v31 /*: any*/ 
                                            ]
                                        },
                                        v32 /*: any*/ ,
                                        v33 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v34 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "FollowingFeedGetUserConfig",
                    "kind": "LinkedField",
                    "name": "getFeedUserConfig",
                    "plural": false,
                    "selections": [
                        v35 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "users",
                            "plural": true,
                            "selections": [
                                v38 /*: any*/ ,
                                v8 /*: any*/ ,
                                v36 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ 
                            ]
                        },
                        v37 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "5fa23ad64581bf268c729651d6bf4ddb",
            "id": "e98aed0963d75eecbe46cb82c413f1c7dab51ea1ec1170145ad8a9a88b6c3de0",
            "metadata": {},
            "name": "FollowingFeedWithSortByStorageSnippetsQuery",
            "operationKind": "query",
            "text": "query FollowingFeedWithSortByStorageSnippetsQuery($first:Int,$after:String,$sortBy:String=\"relevant\"){feed(first:$first,after:$after,sortBy:$sortBy){nodes{recentActionsCount,summaryLineUpdate{__typename,datetime,type,groupSize,...on FeedEventCreate{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEdit{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventEditLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventPublishLive{version,user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}}},...on FeedEventComment{user{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},comment{id,links{webui},location{__typename,type,...on InlineComment{inlineText}},body(representation:ATLAS_DOC_FORMAT){value}}}},source,content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),aiProperty{objectData,createdAt,errorMessage},links{webui},history{createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}},createdDate},space{alias,id,key,name},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}}}},pageInfo{hasNextPage,endCursor}},getFeedUserConfig{spaces{id},users{__typename,displayName,profilePicture{path(type:ABSOLUTE)},...on KnownUser{accountId},...on UnknownUser{accountId}},servingRecommendations}}"
        }
    };
}();
$ffca0a52a06c83ff$var$node.hash = "3d5373dca56a1cdfcca16a1aaa83ff13";
var $ffca0a52a06c83ff$export$2e2bcd8739ae039 = $ffca0a52a06c83ff$var$node;
module.exports["default"] = $ffca0a52a06c83ff$export$2e2bcd8739ae039;

});

parcelRegister("g4evd", function(module, exports) {
/**
 * @generated SignedSource<<fbdeb79565959637d7e45870912ffd14>>
 * @relayHash 40ddeb0ef9f72faff15ea2ef539798b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81
const $8f22a426de8950e5$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "feedTab"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedTypeSelectorRefreshQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "40ddeb0ef9f72faff15ea2ef539798b5",
            "id": "1c36b3d08c0171b7af6e2e8fb696bc2e9936c087ca8d85dcb9bd02a1f8349a81",
            "metadata": {},
            "name": "useFeedTypeSelectorRefreshQuery",
            "operationKind": "query",
            "text": "query useFeedTypeSelectorRefreshQuery{userPreferences{__typename,feedTab}}"
        }
    };
}();
$8f22a426de8950e5$var$node.hash = "6ca55df8184dd78031693e2b650f878d";
var $8f22a426de8950e5$export$2e2bcd8739ae039 = $8f22a426de8950e5$var$node;
module.exports["default"] = $8f22a426de8950e5$export$2e2bcd8739ae039;

});

parcelRegister("lNpDX", function(module, exports) {
/**
 * @generated SignedSource<<8ad738f7cd5bddfd309c63bbe975efaf>>
 * @relayHash 39acb1147d229935866fe5c76d20c1bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac244f8eb2900313dbd1f99458efd3a3edf69c82efb71c7fff3c8c7aa156021e
const $afadcf197f0b9a77$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "title"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v8 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v9 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v11 /*: any*/ 
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v17 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v18 = {
        "kind": "InlineFragment",
        "selections": v17 /*: any*/ ,
        "type": "KnownUser"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": v17 /*: any*/ ,
        "type": "UnknownUser"
    }, v20 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v21 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v22 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v12 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v18 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "39acb1147d229935866fe5c76d20c1bc",
            "id": "ac244f8eb2900313dbd1f99458efd3a3edf69c82efb71c7fff3c8c7aa156021e",
            "metadata": {},
            "name": "usePopularFeedWithTimeGranularityStorageQuery",
            "operationKind": "query",
            "text": "query usePopularFeedWithTimeGranularityStorageQuery($first:Int,$after:String,$timeGranularity:String=\"default\"){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$afadcf197f0b9a77$var$node.hash = "458c889823784393227130726e48009d";
var $afadcf197f0b9a77$export$2e2bcd8739ae039 = $afadcf197f0b9a77$var$node;
module.exports["default"] = $afadcf197f0b9a77$export$2e2bcd8739ae039;

});

parcelRegister("d7td2", function(module, exports) {
/**
 * @generated SignedSource<<c91a75b1008ae7e27ac3d0fa999dfd5d>>
 * @relayHash 6e6daec1ee51db3b3653a64a4144cb12
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cdbbbcf4cd5fbe5d40081d9bc1efc3b0378b8b6ef5afaf25636b2cd7158e02ee
const $25444c17515b1490$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isRovoLLMEnabled"
    }, v3 = {
        "defaultValue": "default",
        "kind": "LocalArgument",
        "name": "timeGranularity"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "timeGranularity",
            "variableName": "timeGranularity"
        }
    ], v5 = {
        "condition": "isRovoLLMEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "entryPoint",
                        "value": "CONFLUENCE_HOME_POPULAR_FEED"
                    },
                    {
                        "kind": "Literal",
                        "name": "objectType",
                        "value": "snippet_v2"
                    }
                ],
                "concreteType": "ConfluenceContentAISummaryResponse",
                "kind": "LinkedField",
                "name": "aiProperty",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "errorMessage"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "createdAt"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "objectData"
                    }
                ],
                "storageKey": "aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\",objectType:\"snippet_v2\")"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v10 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v7 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v11 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "generatedBy"
                    }
                ]
            }
        ]
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 350
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:350)"
    }, v13 = {
        "kind": "ScalarField",
        "name": "name"
    }, v14 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v13 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v17 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v18 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v19 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v20 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "KnownUser"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": v19 /*: any*/ ,
        "type": "UnknownUser"
    }, v22 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v23 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "friendlyWhen"
            }
        ]
    }, v24 = {
        "concreteType": "FeedPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v25 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedPopularFeed",
                    "kind": "LinkedField",
                    "name": "popularFeed",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PopularFeedItem",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "PaginatedLabelList",
                                            "kind": "LinkedField",
                                            "name": "labels",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "Label",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v8 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v20 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v22 /*: any*/ ,
                                        v23 /*: any*/ 
                                    ]
                                },
                                v7 /*: any*/ 
                            ]
                        },
                        v24 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "6e6daec1ee51db3b3653a64a4144cb12",
            "id": "cdbbbcf4cd5fbe5d40081d9bc1efc3b0378b8b6ef5afaf25636b2cd7158e02ee",
            "metadata": {},
            "name": "PopularFeedWithTimeGranularityStorageSnippetsV2Query",
            "operationKind": "query",
            "text": "query PopularFeedWithTimeGranularityStorageSnippetsV2Query($first:Int,$after:String,$timeGranularity:String=\"default\",$isRovoLLMEnabled:Boolean=false){popularFeed(first:$first,after:$after,timeGranularity:$timeGranularity){nodes{aiProperty(entryPoint:\"CONFLUENCE_HOME_POPULAR_FEED\",objectType:snippet_v2)@include(if:$isRovoLLMEnabled){errorMessage,createdAt,objectData},content{title,id,type,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},contentProperties{latest{generatedBy}},excerpt(length:350),labels{nodes{name,id}},links{webui},space{alias,id,key,name},history{createdDate,createdBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId},...on UnknownUser{accountId}},ownedBy{__typename,type,displayName,profilePicture{path},...on KnownUser{accountId}}},metadata{lastModifiedDate,comments{commentsCount},currentuser{favourited{isFavourite}}},version{friendlyWhen}},id},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$25444c17515b1490$var$node.hash = "aff44ffc8d4a5147fced8a7e10d8221b";
var $25444c17515b1490$export$2e2bcd8739ae039 = $25444c17515b1490$var$node;
module.exports["default"] = $25444c17515b1490$export$2e2bcd8739ae039;

});

parcelRegister("hGIXv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");


var $4PX6o = parcelRequire("4PX6o");


var $bkTet = parcelRequire("bkTet");


var $xwvlW = parcelRequire("xwvlW");


var $wPrRK = parcelRequire("wPrRK");


var $1xpoY = parcelRequire("1xpoY");


var $60cDW = parcelRequire("60cDW");


var $d6NtA = parcelRequire("d6NtA");



var $6mKj3 = parcelRequire("6mKj3");


var $f27vC = parcelRequire("f27vC");


var $bZg9h = parcelRequire("bZg9h");

/**
 * Post Office class for managing in memory cache of Placement queries.
 * We store the cache reference on the global object to persist across SSR requests.
 */ const $ea3c3b16e40ad0d7$var$POST_OFFICE_QUERY_CACHE = globalThis?.__POST_OFFICE_QUERY_CACHE__ || {};
const $ea3c3b16e40ad0d7$var$postOfficeClient = new (0, $f27vC.PostOfficeCacheClient)($ea3c3b16e40ad0d7$var$POST_OFFICE_QUERY_CACHE);
const $ea3c3b16e40ad0d7$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $ea3c3b16e40ad0d7$export$b3732c8ff6f9c463 = (res)=>{
    if (typeof res === 'undefined') throw new Error('No response from server');
    if (res.ok) return res;
    throw new Error($ea3c3b16e40ad0d7$export$18a0019e5439b209(res));
};
const $ea3c3b16e40ad0d7$var$wrapResolvedDataAsFetchResponse = (data)=>{
    const init = {
        status: 200,
        statusText: 'ok!'
    };
    return new Response(JSON.stringify(data), init);
};
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $ea3c3b16e40ad0d7$var$getIsSSR = ()=>Boolean(undefined);
const $ea3c3b16e40ad0d7$var$POST_OFFICE_SERVICE_NAME = 'post-office';
const $ea3c3b16e40ad0d7$var$POST_OFFICE_ARCHETYPE_NAME = 'post-office-archetype';
const $ea3c3b16e40ad0d7$var$confluenceFetcher = async (url, headers, requestInit, writeData = (url, data)=>$ea3c3b16e40ad0d7$var$postOfficeClient.setDataWithUrl(url, data))=>{
    // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Transition preloaders
    if (!$ea3c3b16e40ad0d7$var$getIsSSR()) {
        const cachedFetcher = $ea3c3b16e40ad0d7$var$postOfficeClient.getFetcherWithUrl(url);
        if (cachedFetcher) return cachedFetcher;
    }
    let fetcher;
    fetcher = (0, $4PX6o.defaultFetcher)(url, headers, requestInit);
    fetcher = fetcher.then($ea3c3b16e40ad0d7$export$b3732c8ff6f9c463).then((res)=>res.json()).then((data)=>{
        writeData(url, data);
        return $ea3c3b16e40ad0d7$var$wrapResolvedDataAsFetchResponse(data);
    });
    // When we're in SPA mode, we want to cache the fetcher so that it can be reused
    // if the network request takes too long and the data doesn't come back in time
    // before another request is requested by <Placement>
    if (!$ea3c3b16e40ad0d7$var$getIsSSR()) $ea3c3b16e40ad0d7$var$postOfficeClient.setFetcherWithUrl(url, fetcher);
    return fetcher;
};
const $ea3c3b16e40ad0d7$var$cookieMap = new Map([
    [
        'consentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_COOKIE_KEY)
    ],
    [
        'fallbackConsentToken',
        (0, $bkTet.ATLASSIAN_CONSENT_FALLBACK_COOKIE_KEY)
    ]
]);
const $ea3c3b16e40ad0d7$var$mapCookiesToFetchHeaders = (cookies)=>{
    if (typeof cookies !== 'object' || cookies === null) return undefined;
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- pre-existing pattern, small bounded map
    return Array.from($ea3c3b16e40ad0d7$var$cookieMap.entries()).map(([key, value])=>{
        if (cookies[key]) return `${value}=${cookies[key]}`;
        return '';
    }).filter(Boolean).join(';');
};
/**
 * Common method for setting up the Post Office placement request URL with the environment and product context
 *
 * @param placementId
 * @param contextOptions
 * @returns
 */ const $ea3c3b16e40ad0d7$var$preloadPostOfficePlacement = async (placementId, contextOptions, extraFetchOptions, writeData)=>{
    const { postOfficeContext: postOfficeContext, environment: environment } = contextOptions;
    // Mirror client-side guard in Placement.tsx (useInitialDataIfEnabled → isPostOfficePlacementsGloballyDisabled)
    // to prevent SSR/client mismatch when placements are globally disabled (e.g. stableUI=1).
    if (postOfficeContext.disableAllPlacements) return;
    const confluenceFetcherWithS2SHeaders = async (url)=>{
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const isSSR = Boolean(undefined);
        if (isSSR) {
            let hostEnv = 'prod';
            if (environment.currentEnv !== 'production') hostEnv = 'staging';
            const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, isBifrostIcRequest: isBifrostIcRequest } = (0, $60cDW.getSSRRenderInputs)();
            const cookies = $ea3c3b16e40ad0d7$var$mapCookiesToFetchHeaders({
                consentToken: cookiesConsentToken,
                fallbackConsentToken: cookiesFallbackToken
            });
            const fetchHeaders = !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': $ea3c3b16e40ad0d7$var$POST_OFFICE_SERVICE_NAME,
                // Tells Tesseract to S2S with `post-office`
                ...isBifrostIcRequest === true ? {
                    'x-archetype-name': $ea3c3b16e40ad0d7$var$POST_OFFICE_ARCHETYPE_NAME
                } : {},
                'x-ssr-service-env': hostEnv // Defaults to current Env, however Post Office is not in dev
            } : {};
            if (cookies) fetchHeaders.Cookie = cookies;
            const finalUrl = (0, $d6NtA.isLocal)() ? url : url.replace('gateway/api/post-office/', '');
            return $ea3c3b16e40ad0d7$var$confluenceFetcher(finalUrl, fetchHeaders, extraFetchOptions?.requestInit, writeData);
        }
        return $ea3c3b16e40ad0d7$var$confluenceFetcher(url, undefined, extraFetchOptions?.requestInit, writeData);
    };
    const basePath = (0, $apw3A.buildBasePath)(environment.currentEnv, environment.envConfigs);
    return (0, $4PX6o.requestInitialData)(placementId, postOfficeContext, confluenceFetcherWithS2SHeaders, {
        ...basePath,
        resource: extraFetchOptions?.resource
    });
};
const $ea3c3b16e40ad0d7$export$420f2f91a928b3b6 = ()=>{
    return (0, $cozmU.useCallback)((url, requestOptions)=>{
        // Use data in cache if it exists
        const data = $ea3c3b16e40ad0d7$var$postOfficeClient.getDataWithUrl(url);
        if (data) /**
       * Preloaded data must be serialized, however our initialData is expected to be in the form of a Response promise.
       * TODO: Remove this workaround once the Post Office placement API is updated to handle flat data.
       */ return Promise.resolve($ea3c3b16e40ad0d7$var$wrapResolvedDataAsFetchResponse(data));
        // When in SPA mode, we want to re-use the pending fetcher if it exists - so that we don't make another Network request from the Placement component
        if (!$ea3c3b16e40ad0d7$var$getIsSSR()) {
            const fetcher = $ea3c3b16e40ad0d7$var$postOfficeClient.getFetcherWithUrl(url);
            if (fetcher) return fetcher;
        }
        // Convert headers to Record<string, string> if present
        let headers = {};
        if (requestOptions?.headers) {
            if (requestOptions.headers instanceof Headers) requestOptions.headers.forEach((value, name)=>{
                headers[name] = value;
            });
            else if (Array.isArray(requestOptions.headers)) requestOptions.headers.forEach(([name, value])=>{
                headers[name] = value;
            });
            else headers = requestOptions.headers;
        }
        // Use a new fetcher if neither data nor fetcher is in cache
        return $ea3c3b16e40ad0d7$var$confluenceFetcher(url, headers, requestOptions);
    }, []);
};
const $ea3c3b16e40ad0d7$export$17b92961ead3f211 = (placementId)=>{
    const [preloadedData, setPreloadedData] = (0, $cozmU.useState)(()=>{
        const data = $ea3c3b16e40ad0d7$var$postOfficeClient.getDataWithPlacementId(placementId);
        if (data) return data;
        return undefined;
    });
    const setter = (0, $cozmU.useCallback)((data)=>{
        $ea3c3b16e40ad0d7$var$postOfficeClient.setDataWithPlacementId(placementId, data);
        setPreloadedData(data);
    }, [
        placementId
    ]);
    return [
        preloadedData,
        setter
    ];
};
const $ea3c3b16e40ad0d7$export$1d2f4123d64ba093 = async (placementId, extraFetchOptions)=>{
    const sessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const postOfficeTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_postoffice_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const preloadPlacement = (writeData)=>(0, $wPrRK.slowQueryGuard)(`preloadPostOfficePlacement:${placementId}`, ()=>$ea3c3b16e40ad0d7$var$preloadPostOfficePlacement(placementId, {
                postOfficeContext: (0, $bZg9h.sessionToPostOfficeContext)(sessionContext),
                environment: {
                    currentEnv: (0, $bZg9h.transformConfluenceEnvToPostOfficeEnvironment)(sessionContext.environment)
                }
            }, extraFetchOptions, writeData), postOfficeTimeout);
    if ($ea3c3b16e40ad0d7$var$getIsSSR() && window.__SSR_REACT_STREAMING__ && (0, $6mKj3.expValEquals)('confluence_react_streaming_all_routes', 'isEnabled', true)) {
        // Publish only data from a preload that finished before its timeout. A late response
        // must not change the snapshot after SSR has rendered the empty placement.
        const pendingData = new Map();
        const completed = await preloadPlacement((url, data)=>pendingData.set(url, data));
        if (completed) pendingData.forEach((data, url)=>$ea3c3b16e40ad0d7$var$postOfficeClient.setDataWithUrl(url, data));
        return completed;
    }
    return preloadPlacement();
};
module.exports["usePlacementSSRFetch"] = $ea3c3b16e40ad0d7$export$420f2f91a928b3b6;
module.exports["usePlacementPreloadedData"] = $ea3c3b16e40ad0d7$export$17b92961ead3f211;
module.exports["preloadPostOfficePlacementWithSessionContext"] = $ea3c3b16e40ad0d7$export$1d2f4123d64ba093;

});

parcelRegister("apw3A", function(module, exports) {

var $3rMm0 = parcelRequire("3rMm0");


var $jdpvF = parcelRequire("jdpvF");

const $9fbb603c3fc74986$export$e8b30f9c4a80230f = (currentEnv, envConfigs = (0, $jdpvF.defaultEnvironmentValues).envConfigs)=>{
    const baseUrl = envConfigs[currentEnv].api.origin;
    // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
    const path = envConfigs[currentEnv].api.pathname ?? (0, $3rMm0.API_PATHNAME_STG_PROD);
    return {
        baseUrl: baseUrl,
        path: path
    };
};
module.exports["buildBasePath"] = $9fbb603c3fc74986$export$e8b30f9c4a80230f;

});

parcelRegister("4PX6o", function(module, exports) {
const $dc9030da747a3f79$export$77754e0ac9f8aba3 = (url, headers, fetchOptions)=>fetch(url, {
        ...fetchOptions,
        headers: {
            credentials: 'include',
            mode: 'cors',
            'Content-Type': 'application/json',
            ...headers,
            ...fetchOptions?.headers
        }
    });
const $dc9030da747a3f79$export$c4c39037cc4b06ab = async (placementId, context, fetcher = $dc9030da747a3f79$export$77754e0ac9f8aba3, options)=>{
    const baseUrl = options.baseUrl;
    const path = options.path;
    const requestUrl = baseUrl ? new URL(path, baseUrl).toString() : path;
    const requestResource = options.resource ? options.resource : '';
    function stringifyObjectValues(input) {
        const entries = Object.entries(input);
        const stringifiedEntries = entries.filter(([, v])=>typeof v !== 'undefined' && v !== null).map(([key, value])=>[
                key,
                String(value)
            ]);
        return Object.fromEntries(stringifiedEntries);
    }
    const contextAsSearchParams = new URLSearchParams(stringifyObjectValues(context));
    contextAsSearchParams.sort();
    const url = encodeURI(`${requestUrl}${placementId}${requestResource}?${contextAsSearchParams.toString()}`);
    // Response will be handled inside the component
    return fetcher(url);
};
module.exports["defaultFetcher"] = $dc9030da747a3f79$export$77754e0ac9f8aba3;
module.exports["requestInitialData"] = $dc9030da747a3f79$export$c4c39037cc4b06ab;

});

parcelRegister("f27vC", function(module, exports) {
class $1b47749400216a66$export$11e1da55bed53d18 {
    getKey(url) {
        const urlMatches = url.match(/placements\/([\w\-/]+)(?:.*updateKey=)?(\w+)?/);
        if (urlMatches?.length && urlMatches.length > 1) return urlMatches.slice(1).filter(Boolean).join('/');
        return url;
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
    getDataWithPlacementId(placementId) {
        return this.get(`placements/${placementId}`)?.data;
    }
    setDataWithPlacementId(placementId, data) {
        this.set(`placements/${placementId}`, {
            data: data,
            fetcher: undefined
        });
    }
    getDataWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.data;
    }
    setDataWithUrl(url, data) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            fetcher: cache?.fetcher,
            data: data
        });
    }
    getFetcherWithUrl(url) {
        return this.get(`placements/${this.getKey(url)}`)?.fetcher;
    }
    setFetcherWithUrl(url, fetcher) {
        const cache = this.get(`placements/${this.getKey(url)}`);
        this.set(`placements/${this.getKey(url)}`, {
            data: cache?.data,
            fetcher: fetcher
        });
    }
    constructor(cache){
        this.cache = cache;
        globalThis.__POST_OFFICE_QUERY_CACHE__ = cache;
    }
}
module.exports["PostOfficeCacheClient"] = $1b47749400216a66$export$11e1da55bed53d18;

});

parcelRegister("bZg9h", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");


var $d9tcB = parcelRequire("d9tcB");

const $ca200171583a3716$var$CONFLUENCE_PRODUCT = 'confluence';
const $ca200171583a3716$var$DEFAULT_POST_OFFICE_CONTEXT = {
    product: $ca200171583a3716$var$CONFLUENCE_PRODUCT,
    locale: 'en'
};
const $ca200171583a3716$var$getWorkspaceARI = ({ cloudId: cloudId, activationId: activationId })=>{
    return `ari:cloud:confluence:${cloudId}:workspace/${activationId}`;
};
const $ca200171583a3716$export$40fdfb947dabfc30 = (sessionData)=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, locale: locale, orgId: orgId, edition: edition } = sessionData;
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const workspaceAri = $ca200171583a3716$var$getWorkspaceARI({
        activationId: activationId,
        cloudId: cloudId
    });
    return {
        ...$ca200171583a3716$var$DEFAULT_POST_OFFICE_CONTEXT,
        locale: locale,
        orgId: orgId,
        isSiteAdmin: isAdmin,
        tenantId: cloudId === '' ? undefined : cloudId,
        workspaceAri: workspaceAri,
        workspaceId: activationId,
        subproduct: undefined,
        productEdition: edition || undefined,
        disableAllPlacements: (0, $i3jcY.isStableUIEnabledForTests)() ? true : undefined
    };
};
const $ca200171583a3716$export$76d03739bfe0286a = (environment)=>{
    switch(environment){
        case 'STAGING':
            return 'staging';
        case 'PRODUCTION':
            return 'production';
        case 'DEVELOPMENT':
            return 'local';
        default:
            return 'local';
    }
};
module.exports["sessionToPostOfficeContext"] = $ca200171583a3716$export$40fdfb947dabfc30;
module.exports["transformConfluenceEnvToPostOfficeEnvironment"] = $ca200171583a3716$export$76d03739bfe0286a;

});

parcelRegister("i3jcY", function(module, exports) {

const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return (window.location.search ?? '').includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("byPOx", function(module, exports) {
/**
 * @generated SignedSource<<b733e0a60fa7a2103af52ebf9c82676d>>
 * @relayHash 411aa56f960d21732fdea57d6645aefa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a480d9b1888fbb308b36f8f29f5b4576f84e4817c537652251e266c7ab98d45d
const $c11e5f03fd3a6c81$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v0 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "411aa56f960d21732fdea57d6645aefa",
            "id": "a480d9b1888fbb308b36f8f29f5b4576f84e4817c537652251e266c7ab98d45d",
            "metadata": {},
            "name": "useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
            "operationKind": "query",
            "text": "query useGetTeamAndSubanchorGetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$c11e5f03fd3a6c81$var$node.hash = "d084357d5b8c80b2a717087a9d5973e6";
var $c11e5f03fd3a6c81$export$2e2bcd8739ae039 = $c11e5f03fd3a6c81$var$node;
module.exports["default"] = $c11e5f03fd3a6c81$export$2e2bcd8739ae039;

});

parcelRegister("lWFZM", function(module, exports) {
/**
 * @generated SignedSource<<a28a6d4ece37010a1b3dc61b788601fc>>
 * @relayHash c4dbb1e53daef1b7c8f169a3f50616ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 83251c724d7af2d6ea333c162ae5a4de26266110e4352c5b02f33510b840978f
const $f9637bad6b9857cf$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "usePersonalSpace",
                    "value": true
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "templateId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentBlueprintId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "itemModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ],
            "storageKey": "allTemplates(usePersonalSpace:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c4dbb1e53daef1b7c8f169a3f50616ce",
            "id": "83251c724d7af2d6ea333c162ae5a4de26266110e4352c5b02f33510b840978f",
            "metadata": {},
            "name": "PersonalizedTemplatesV2AllTemplatesQuery",
            "operationKind": "query",
            "text": "query PersonalizedTemplatesV2AllTemplatesQuery{allTemplates(usePersonalSpace:true){nodes{templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,name}}}"
        }
    };
}();
$f9637bad6b9857cf$var$node.hash = "f89ae5ce759533fd2a0812719d0966df";
var $f9637bad6b9857cf$export$2e2bcd8739ae039 = $f9637bad6b9857cf$var$node;
module.exports["default"] = $f9637bad6b9857cf$export$2e2bcd8739ae039;

});

parcelRegister("l57Xv", function(module, exports) {
/**
 * @generated SignedSource<<23711dc6752a7094995d8efb756e1c1a>>
 * @relayHash 1dbbd240576b496aabf7631bbe5e8317
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ad6fa59108f9429438bd30d3273091c7c3dbac7714e0489bd218aecdc02623cc
const $03e9502d9a3559f4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accountId",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "GrowthUnifiedProfileResult",
            "kind": "LinkedField",
            "name": "growthUnifiedProfile_getUnifiedProfile",
            "plural": false,
            "selections": [
                {
                    "concreteType": "GrowthUnifiedProfilePaidChannelContextByProduct",
                    "kind": "LinkedField",
                    "name": "paidChannelContext",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GrowthUnifiedProfilePaidChannelContext",
                            "kind": "LinkedField",
                            "name": "confluence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "subAnchor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1dbbd240576b496aabf7631bbe5e8317",
            "id": "ad6fa59108f9429438bd30d3273091c7c3dbac7714e0489bd218aecdc02623cc",
            "metadata": {},
            "name": "useGetTeamAndSubanchorGetSubanchorsAGGQuery",
            "operationKind": "query",
            "text": "query useGetTeamAndSubanchorGetSubanchorsAGGQuery($accountId:ID!){growthUnifiedProfile_getUnifiedProfile(accountId:$accountId){paidChannelContext{confluence{subAnchor}}}}"
        }
    };
}();
$03e9502d9a3559f4$var$node.hash = "41238e70a66e2ffbcfc5e10ca0de9d20";
var $03e9502d9a3559f4$export$2e2bcd8739ae039 = $03e9502d9a3559f4$var$node;
module.exports["default"] = $03e9502d9a3559f4$export$2e2bcd8739ae039;

});

parcelRegister("c8Y4F", function(module, exports) {
/**
 * @generated SignedSource<<37f3c934776838a31da0561c3367b039>>
 * @relayHash 54a5106deb8051638f67e17262ef90b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1ae8f1aadd164d1b501e16f6020a287594e642feab79c3afc381daad3acbf576
const $a939e7843212ec9f$var$node = function() {
    var v0 = [
        {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "licenseConsumingUserCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "54a5106deb8051638f67e17262ef90b5",
            "id": "1ae8f1aadd164d1b501e16f6020a287594e642feab79c3afc381daad3acbf576",
            "metadata": {},
            "name": "useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery{license{licenseConsumingUserCount}}"
        }
    };
}();
$a939e7843212ec9f$var$node.hash = "eaf07b0d0888b09c16c5bc48d9bf826d";
var $a939e7843212ec9f$export$2e2bcd8739ae039 = $a939e7843212ec9f$var$node;
module.exports["default"] = $a939e7843212ec9f$export$2e2bcd8739ae039;

});

parcelRegister("aSQ2H", function(module, exports) {
/**
 * @generated SignedSource<<eba3ddf4122d34c052396e7e6f6d33bf>>
 * @relayHash 475721f730a3548a4f4eefeb978ba00d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d7c04d39708c6a688256a9fd02644f4c9f3257ba8cf834d535b12f160ca61efb
const $20d3ce40728fbf7c$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useUserByLicensedProductsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useUserByLicensedProductsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "475721f730a3548a4f4eefeb978ba00d",
            "id": "d7c04d39708c6a688256a9fd02644f4c9f3257ba8cf834d535b12f160ca61efb",
            "metadata": {},
            "name": "useUserByLicensedProductsQuery",
            "operationKind": "query",
            "text": "query useUserByLicensedProductsQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$20d3ce40728fbf7c$var$node.hash = "d128f30f97ec5f59ea08d8e5ff26d122";
var $20d3ce40728fbf7c$export$2e2bcd8739ae039 = $20d3ce40728fbf7c$var$node;
module.exports["default"] = $20d3ce40728fbf7c$export$2e2bcd8739ae039;

});

parcelRegister("lkQRq", function(module, exports) {
/**
 * @generated SignedSource<<1786786af5fbe9ee3a2042731a1d34f9>>
 * @relayHash f1f5bc833b3adcfaa8f23a0262a11c35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3dfcdba660c43ea3c005773a8867b277288a1f1828accb84953d86fd5503884
const $8e3067533735c561$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HomeWidget",
                    "kind": "LinkedField",
                    "name": "homeWidgets",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "state"
                        },
                        v0 /*: any*/ 
                    ]
                },
                v0 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useHomeWidgetStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useHomeWidgetStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f1f5bc833b3adcfaa8f23a0262a11c35",
            "id": "a3dfcdba660c43ea3c005773a8867b277288a1f1828accb84953d86fd5503884",
            "metadata": {},
            "name": "useHomeWidgetStateQuery",
            "operationKind": "query",
            "text": "query useHomeWidgetStateQuery{userPreferences{homeWidgets{id,state,__typename},__typename}}"
        }
    };
}();
$8e3067533735c561$var$node.hash = "2b3d6cba775f89e74fb24fec1d37c65d";
var $8e3067533735c561$export$2e2bcd8739ae039 = $8e3067533735c561$var$node;
module.exports["default"] = $8e3067533735c561$export$2e2bcd8739ae039;

});

parcelRegister("cMfVN", function(module, exports) {
/**
 * @generated SignedSource<<c10a3479344de239969bd1a93235453c>>
 * @relayHash 485b07e69670e84889e1c718d8693e52
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 212c349f0cf0225cfd610d7a4583eaceeb584b90c8bb730b8316e6bde9ba4e2c
const $760c61ad763022c8$var$node = function() {
    var v0 = [
        {
            "concreteType": "SpaViewModel",
            "kind": "LinkedField",
            "name": "spaViewContext",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "welcomeMessageEditUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "welcomeMessageHtml"
                },
                {
                    "kind": "ScalarField",
                    "name": "isWelcomeMessageCustomized"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceKeys"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceContexts"
                },
                {
                    "kind": "ScalarField",
                    "name": "showWelcomeMessageEditHint"
                },
                {
                    "kind": "ScalarField",
                    "name": "showEditButton"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "WelcomeMessagesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "WelcomeMessagesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "485b07e69670e84889e1c718d8693e52",
            "id": "212c349f0cf0225cfd610d7a4583eaceeb584b90c8bb730b8316e6bde9ba4e2c",
            "metadata": {},
            "name": "WelcomeMessagesQuery",
            "operationKind": "query",
            "text": "query WelcomeMessagesQuery{spaViewContext{welcomeMessageEditUrl,welcomeMessageHtml,isWelcomeMessageCustomized,resourceKeys,resourceContexts,showWelcomeMessageEditHint,showEditButton}}"
        }
    };
}();
$760c61ad763022c8$var$node.hash = "7a7432847603f3b8c92c592f7e345430";
var $760c61ad763022c8$export$2e2bcd8739ae039 = $760c61ad763022c8$var$node;
module.exports["default"] = $760c61ad763022c8$export$2e2bcd8739ae039;

});

parcelRegister("3U2Qo", function(module, exports) {
/**
 * @generated SignedSource<<9fcaba83c624f9ea4d1df2b8f6bb7c45>>
 * @relayHash efec5f055ec1e78d26218969dcf38875
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 491fdfbddebec8cf715e3c38abd6a48b6dc4289dcbbd9eca243db2d44e1f6355
const $49e00110ea819844$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "aqlQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shardingContext"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "aqlQuery",
        "variableName": "aqlQuery"
    }, v2 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "shardingContext",
        "variableName": "shardingContext"
    }, v4 = [
        v1 /*: any*/ ,
        v2 /*: any*/ ,
        v3 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "sort",
            "value": "lastStateChangeAt DESC"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AgentsWaitingForYourInputSessionsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "AgentsWaitingForYourInputSessionsFragment_query"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AgentsWaitingForYourInputSessionsQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "AgentSessionConnection",
                    "kind": "LinkedField",
                    "name": "agent_sessionQuery",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentSessionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "AgentSession",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "agent",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "picture"
                                                },
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "associatedEntities",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "concreteType": "ConfluencePageLinks",
                                                            "kind": "LinkedField",
                                                            "name": "links",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUi"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "pageId"
                                                        },
                                                        {
                                                            "concreteType": "ConfluenceSpace",
                                                            "kind": "LinkedField",
                                                            "name": "space",
                                                            "plural": false,
                                                            "selections": [
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "key"
                                                                },
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "subtype"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "title"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        }
                                                    ],
                                                    "type": "ConfluencePage"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v7 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "workspaceAri",
                                                    "variableName": "shardingContext"
                                                }
                                            ],
                                            "concreteType": "AgentConversationChannel",
                                            "kind": "LinkedField",
                                            "name": "conversationChannel",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "invocationType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isRovo"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastStateChangeAt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "state"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "stateReason"
                                        },
                                        v5 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v4 /*: any*/ ,
                    "filters": [
                        "aqlQuery",
                        "shardingContext"
                    ],
                    "handle": "connection",
                    "key": "AgentsWaitingForYourInputSessionsFragment_agent_sessionQuery",
                    "kind": "LinkedHandle",
                    "name": "agent_sessionQuery"
                }
            ]
        },
        "params": {
            "cacheID": "efec5f055ec1e78d26218969dcf38875",
            "id": "491fdfbddebec8cf715e3c38abd6a48b6dc4289dcbbd9eca243db2d44e1f6355",
            "metadata": {},
            "name": "AgentsWaitingForYourInputSessionsQuery",
            "operationKind": "query",
            "text": "query AgentsWaitingForYourInputSessionsQuery($aqlQuery:String!,$first:Int!,$shardingContext:String!){...AgentsWaitingForYourInputSessionsFragment_query_GOwZE}fragment AgentsWaitingForYourInputSessionsFragment_query_GOwZE on Query{agent_sessionQuery(aqlQuery:$aqlQuery,first:$first,shardingContext:$shardingContext,sort:\"lastStateChangeAt DESC\"){edges{node{agent{__typename,name,picture,id},associatedEntities{__typename,...on ConfluencePage{id,links{webUi},pageId,space{id,key,name},status,subtype,title,type},...on Node{__isNode:__typename,id}},conversationChannel(workspaceAri:$shardingContext)@optIn(to:\"AgentConversationChannelTeamEu26DemoOnly\"){name,id},id,invocationType,isRovo,lastStateChangeAt,state,stateReason,__typename},cursor},pageInfo{endCursor,hasNextPage}}}"
        }
    };
}();
$49e00110ea819844$var$node.hash = "6382b8149ddee2363e0e990bad79d19e";
var $49e00110ea819844$export$2e2bcd8739ae039 = $49e00110ea819844$var$node;
module.exports["default"] = $49e00110ea819844$export$2e2bcd8739ae039;

});

parcelRegister("fFEmG", function(module, exports) {
/**
 * @generated SignedSource<<978f65f3e673e7f42e72ef6851cbf225>>
 * @relayHash 728a2ad3728f136399c1d8c2b40bf0d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 790ebc6080b14acd2b47338e1c1cc832580f824be88853d7dc2b7800d3c1f8dd
const $f6392bd922924d7d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "aqlQuery"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shardingContext"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "aqlQuery",
            "variableName": "aqlQuery"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "shardingContext",
            "variableName": "shardingContext"
        },
        {
            "kind": "Literal",
            "name": "sort",
            "value": "lastStateChangeAt DESC"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "state"
    }, v6 = {
        "kind": "ScalarField",
        "name": "stateReason"
    }, v7 = {
        "kind": "ScalarField",
        "name": "isRovo"
    }, v8 = {
        "kind": "ScalarField",
        "name": "invocationType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "lastStateChangeAt"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v12 = [
        {
            "kind": "Variable",
            "name": "workspaceAri",
            "variableName": "shardingContext"
        }
    ], v13 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "pageId"
            },
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "webUi"
                    }
                ]
            },
            {
                "concreteType": "ConfluenceSpace",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v10 /*: any*/ 
                ]
            }
        ],
        "type": "ConfluencePage"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentAgentSessionsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "AgentSessionConnection",
                    "kind": "LinkedField",
                    "name": "agent_sessionQuery",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentSession",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "AgentConversationChannel",
                                    "kind": "LinkedField",
                                    "name": "conversationChannel",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "associatedEntities",
                                    "plural": true,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentAgentSessionsQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "AgentSessionConnection",
                    "kind": "LinkedField",
                    "name": "agent_sessionQuery",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "AgentSession",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "agent",
                                    "plural": false,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v12 /*: any*/ ,
                                    "concreteType": "AgentConversationChannel",
                                    "kind": "LinkedField",
                                    "name": "conversationChannel",
                                    "plural": false,
                                    "selections": [
                                        v10 /*: any*/ ,
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "associatedEntities",
                                    "plural": true,
                                    "selections": [
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v4 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "728a2ad3728f136399c1d8c2b40bf0d3",
            "id": "790ebc6080b14acd2b47338e1c1cc832580f824be88853d7dc2b7800d3c1f8dd",
            "metadata": {},
            "name": "HomeRecentAgentSessionsQuery",
            "operationKind": "query",
            "text": "query HomeRecentAgentSessionsQuery($aqlQuery:String!,$shardingContext:String!,$first:Int!){agent_sessionQuery(aqlQuery:$aqlQuery,shardingContext:$shardingContext,first:$first,sort:\"lastStateChangeAt DESC\"){nodes{id,state,stateReason,isRovo,invocationType,lastStateChangeAt,agent{__typename,name,picture,id},conversationChannel(workspaceAri:$shardingContext)@optIn(to:\"AgentConversationChannelTeamEu26DemoOnly\"){name,id},associatedEntities{__typename,...on ConfluencePage{id,pageId,title,type,subtype,status,links{webUi},space{id,key,name}},...on Node{__isNode:__typename,id}}}}}"
        }
    };
}();
$f6392bd922924d7d$var$node.hash = "926d6e056f872df5100d4256fba873f8";
var $f6392bd922924d7d$export$2e2bcd8739ae039 = $f6392bd922924d7d$var$node;
module.exports["default"] = $f6392bd922924d7d$export$2e2bcd8739ae039;

});

parcelRegister("ka7BG", function(module, exports) {
/**
 * @generated SignedSource<<4fe0ab79419cc50dd5b23b7724ea75ba>>
 * @relayHash c04d7f2f39419bac7cfc3ba24d416e48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac32b88da303fbdd882aa63a9a680e9498c5a1ca5e27e1eb5c6dcd624ef6ef4d
const $3a8b23bf16b066ec$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "cloudIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "cloudIds"
                }
            ],
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "product",
                            "value": "rovo"
                        }
                    ],
                    "concreteType": "TenantContextActivationId",
                    "kind": "LinkedField",
                    "name": "activationIdByProduct",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        }
                    ],
                    "storageKey": "activationIdByProduct(product:\"rovo\")"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "HomeRecentRovoActivationQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "HomeRecentRovoActivationQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c04d7f2f39419bac7cfc3ba24d416e48",
            "id": "ac32b88da303fbdd882aa63a9a680e9498c5a1ca5e27e1eb5c6dcd624ef6ef4d",
            "metadata": {},
            "name": "HomeRecentRovoActivationQuery",
            "operationKind": "query",
            "text": "query HomeRecentRovoActivationQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){activationIdByProduct(product:\"rovo\"){active}}}"
        }
    };
}();
$3a8b23bf16b066ec$var$node.hash = "4a23e7f8c2b00f4c9bc7da80369430fb";
var $3a8b23bf16b066ec$export$2e2bcd8739ae039 = $3a8b23bf16b066ec$var$node;
module.exports["default"] = $3a8b23bf16b066ec$export$2e2bcd8739ae039;

});

parcelRegister("kCweT", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $69a48bd824d27426$export$ad36cc5bb25b2295 = 2;
const $69a48bd824d27426$export$1aafa4e79c196698 = 25;
const $69a48bd824d27426$var$HOUR_MS = 3600000;
const $69a48bd824d27426$var$AGENTS_WAITING_FOR_YOUR_INPUT_MAX_AGE_MS = 72 * $69a48bd824d27426$var$HOUR_MS;
const $69a48bd824d27426$export$2852c22affb76189 = (now = Date.now())=>Math.floor((now - ((0, $6mKj3.expVal)('cc_ai_agentic_sessions', 'maxAgeMs', null) || $69a48bd824d27426$var$AGENTS_WAITING_FOR_YOUR_INPUT_MAX_AGE_MS)) / $69a48bd824d27426$var$HOUR_MS) * $69a48bd824d27426$var$HOUR_MS;
const $69a48bd824d27426$var$escapeAqlValue = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
const $69a48bd824d27426$export$29210935d66ad3a5 = 'CONTENT_REVIEW_READY';
const $69a48bd824d27426$export$d794cd2cd9cb33b3 = 'CONFLUENCE_CREATION_READY';
const $69a48bd824d27426$var$CWR_FILTER = "((invocationType = 'CONFLUENCE_CWR_EDIT' OR invocationType = 'CONFLUENCE_CWR_CREATE' OR invocationType = 'CONFLUENCE_CWR_EXISTING') AND (state = 'ARTEFACT_READY' OR state = 'INPUT_REQUIRED'))" + ` OR (stateReason = '${$69a48bd824d27426$export$d794cd2cd9cb33b3}' AND state = 'ARTEFACT_READY')`;
const $69a48bd824d27426$var$CONTENT_REVIEW_FILTER = `(stateReason = '${$69a48bd824d27426$export$29210935d66ad3a5}' AND state = 'ARTEFACT_READY')`;
const $69a48bd824d27426$var$REMIX_FILTER = "((invocationType = 'CONFLUENCE_REMIX' OR invocationType = 'CONFLUENCE_REMIX_EDIT') AND state = 'INPUT_REQUIRED')";
const $69a48bd824d27426$var$HERO_FILTER = `${$69a48bd824d27426$var$CWR_FILTER} OR ${$69a48bd824d27426$var$CONTENT_REVIEW_FILTER} OR ${$69a48bd824d27426$var$REMIX_FILTER}`;
const $69a48bd824d27426$export$d7f0b10a5821bf9f = ({ userId: userId, rovoActivationId: rovoActivationId, first: first = $69a48bd824d27426$export$1aafa4e79c196698, since: since })=>{
    return {
        aqlQuery: `authorAccountId = '${$69a48bd824d27426$var$escapeAqlValue(userId)}'${$69a48bd824d27426$var$getSinceFilter(since)}` + ` AND (${(0, $6mKj3.expVal)('cc_ai_agentic_sessions', 'aqlFilter', null) ?? $69a48bd824d27426$var$HERO_FILTER})`,
        shardingContext: `ari:cloud:rovo::workspace/${rovoActivationId}`,
        first: first
    };
};
/**
 * Associations are keyed by (session, entity), so one session can hold several. This bounds the
 * scoped association query generously enough that no requested session is silently truncated away.
 */ const $69a48bd824d27426$var$MAX_ASSOCIATIONS_PER_SESSION = 5;
const $69a48bd824d27426$export$4b8b106b72290d8d = ({ associatedEntities: associatedEntities, first: first = associatedEntities.length * $69a48bd824d27426$var$MAX_ASSOCIATIONS_PER_SESSION, rovoActivationId: rovoActivationId, since: since, userId: userId })=>{
    const sessionEntityFilter = associatedEntities.map(({ entityId: entityId, sessionId: sessionId })=>`(entityId = '${$69a48bd824d27426$var$escapeAqlValue(entityId)}' AND agentSessionId = '${$69a48bd824d27426$var$escapeAqlValue(sessionId)}')`).join(' OR ');
    return {
        aqlQuery: `userAccountId = '${$69a48bd824d27426$var$escapeAqlValue(userId)}'` + ` AND deleted = false${$69a48bd824d27426$var$getSinceFilter(since)}` + ` AND (${sessionEntityFilter})`,
        first: first,
        shardingContext: `ari:cloud:rovo::workspace/${rovoActivationId}`
    };
};
/**
 * The backend bounds which part of its index it reads only with top-level AND terms, so `lastStateChangeAt`
 * MUST NOT be nested inside parentheses. Everything else (e.g. `state`) is applied to each page after `first`.
 */ const $69a48bd824d27426$var$getSinceFilter = (since)=>since === undefined ? '' : ` AND lastStateChangeAt >= ${since}`;
module.exports["RECENT_AGENT_SESSIONS_DISPLAY_COUNT"] = $69a48bd824d27426$export$ad36cc5bb25b2295;
module.exports["AGENTS_WAITING_FOR_YOUR_INPUT_PAGE_SIZE"] = $69a48bd824d27426$export$1aafa4e79c196698;
module.exports["getAgentsWaitingForYourInputSince"] = $69a48bd824d27426$export$2852c22affb76189;
module.exports["CONTENT_REVIEW_READY_STATE_REASON"] = $69a48bd824d27426$export$29210935d66ad3a5;
module.exports["CONFLUENCE_CREATION_READY_STATE_REASON"] = $69a48bd824d27426$export$d794cd2cd9cb33b3;
module.exports["getRecentAgentSessionsQueryVariables"] = $69a48bd824d27426$export$d7f0b10a5821bf9f;
module.exports["getRecentAgentSessionAssociationsQueryVariables"] = $69a48bd824d27426$export$4b8b106b72290d8d;

});

parcelRegister("a67vB", function(module, exports) {

var $5PJPG = parcelRequire("5PJPG");


var $ctLrB = parcelRequire("ctLrB");


var $MTTRf = parcelRequire("MTTRf");

const $4b2ee2ac7b774614$export$154132902c275093 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false, first: first = 10 })=>({
        query: (0, $MTTRf.HomeRecentWorkQuery),
        variables: {
            cloudId: (0, $5PJPG.PlatformSiteAri).create({
                siteId: cloudId
            }).toString(),
            first: first,
            after: '',
            objectTypes: [
                (0, $ctLrB.ActivitiesObjectType).PAGE,
                (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
                (0, $ctLrB.ActivitiesObjectType).EMBED,
                (0, $ctLrB.ActivitiesObjectType).CONTENT,
                ...isWhiteboardViewedEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                ] : [],
                ...isDatabaseEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).DATABASE
                ] : [],
                ...isSlidesEnabled ? [
                    (0, $ctLrB.ActivitiesObjectType).SLIDE
                ] : []
            ]
        },
        skip: !isLoggedIn
    });
module.exports["getRecentWorkQueryOptions"] = $4b2ee2ac7b774614$export$154132902c275093;

});

parcelRegister("ctLrB", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $5T18X = parcelRequire("5T18X");


var $kSwu1 = parcelRequire("kSwu1");

var $61e4e33a86012bad$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState[LoadingState["done"] = 0] = "done";
    LoadingState[LoadingState["initial"] = 1] = "initial";
    LoadingState[LoadingState["pagination"] = 2] = "pagination";
    return LoadingState;
}({});
var $61e4e33a86012bad$export$f5dd0176116f8854 = /*#__PURE__*/ function(HomeViewFilters) {
    HomeViewFilters["ALL"] = "ALL";
    HomeViewFilters["WORKED_ON"] = "WORKED_ON";
    HomeViewFilters["CREATED"] = "CREATED";
    HomeViewFilters["STARRED"] = "STARRED";
    HomeViewFilters["TASKS"] = "TASKS";
    HomeViewFilters["DRAFTS"] = "DRAFTS";
    return HomeViewFilters;
}({});
var $61e4e33a86012bad$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $61e4e33a86012bad$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["BLOGPOST"] = "BLOGPOST";
    ActivitiesObjectType["DATABASE"] = "DATABASE";
    ActivitiesObjectType["EMBED"] = "EMBED";
    ActivitiesObjectType["ISSUE"] = "ISSUE";
    ActivitiesObjectType["PAGE"] = "PAGE";
    ActivitiesObjectType["SLIDE"] = "SLIDE";
    ActivitiesObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivitiesObjectType["CONTENT"] = "CONTENT";
    ActivitiesObjectType["COMMENT"] = "COMMENT";
    return ActivitiesObjectType;
}({});
const $61e4e33a86012bad$var$i18n = (0, $kSwu1.defineMessages)({
    untitled: {
        id: "home.views.untitled",
        defaultMessage: "Untitled"
    }
});
const $61e4e33a86012bad$export$232e7dd3cd551a33 = $61e4e33a86012bad$var$i18n.untitled;
const $61e4e33a86012bad$export$2786ecc2e2951fe3 = (networkStatus)=>{
    if (networkStatus === (0, $5T18X.NetworkStatus).loading || networkStatus === (0, $5T18X.NetworkStatus).setVariables) return 1;
    if (networkStatus === (0, $5T18X.NetworkStatus).fetchMore) return 2;
    return 0;
};
function $61e4e33a86012bad$export$b29ea735dcfba3c1(value) {
    return value !== null && value !== undefined;
}
const $61e4e33a86012bad$export$4b0a6c95b9c45006 = (textFilter, title)=>{
    const trimmedTextFilter = textFilter.trim();
    if (trimmedTextFilter === '') return true;
    return (title || '').toUpperCase().indexOf(textFilter.toUpperCase()) > -1;
};
const $61e4e33a86012bad$export$c29c1699278467fe = (recent, isActivityV3HomeRecent)=>{
    if (recent?.object?.data?.commentId) {
        recent.event.eventType = 'commented';
        recent.object.data = recent?.object?.data?.container;
    }
    const content = recent?.object?.data;
    if (isActivityV3HomeRecent) {
        if (content) {
            content.type = content.type?.toLowerCase();
            if (content.type === 'blog_post') content.type = 'blogpost';
            content.subtype = content.subtype?.toLowerCase();
            // The "status" field is ConfluencePage/ConfluenceBlogPost type for pages/blogs but is
            // ConfluenceContentStatus type for all other content types. To prevent the GraphQL
            // "returns different types" error, we are using the aliases "pageStatus" and "blogStatus"
            content.status = [
                content.status,
                content.pageStatus,
                content.blogStatus
            ].find((status)=>status)?.toLowerCase();
            // FE workaround for activity query returning "status: DRAFT" for published content with unpublished changes
            if (content.status === 'draft' && content.createdAt) content.status = 'current';
        }
        recent.event.eventType = recent.event?.eventType.toUpperCase();
    }
    return recent;
};
const $61e4e33a86012bad$export$7105b33a95adadcf = (content)=>{
    return content?.status !== 'archived';
};
const $61e4e33a86012bad$export$d54a312242c6a930 = (content)=>{
    return content?.status !== 'trashed';
};
const $61e4e33a86012bad$export$78ba6bbd8fcbc43f = (userId, content)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    return userId === createdBy?.accountId;
};
module.exports["LoadingState"] = $61e4e33a86012bad$export$62aa48085237e36f;
module.exports["HomeViewFilters"] = $61e4e33a86012bad$export$f5dd0176116f8854;
module.exports["ActivityEventType"] = $61e4e33a86012bad$export$132f858337fea016;
module.exports["ActivitiesObjectType"] = $61e4e33a86012bad$export$4edf00fad4b97379;
module.exports["untitled"] = $61e4e33a86012bad$export$232e7dd3cd551a33;
module.exports["getLoadingState"] = $61e4e33a86012bad$export$2786ecc2e2951fe3;
module.exports["notEmpty"] = $61e4e33a86012bad$export$b29ea735dcfba3c1;
module.exports["byTitle"] = $61e4e33a86012bad$export$4b0a6c95b9c45006;
module.exports["transformActivityData"] = $61e4e33a86012bad$export$c29c1699278467fe;
module.exports["notArchived"] = $61e4e33a86012bad$export$7105b33a95adadcf;
module.exports["notDeleted"] = $61e4e33a86012bad$export$d54a312242c6a930;
module.exports["isCreatorCurrentUser"] = $61e4e33a86012bad$export$78ba6bbd8fcbc43f;

});

parcelRegister("MTTRf", function(module, exports) {

var $2Ujef = parcelRequire("2Ujef");

const $fed37ec4c6d5a8b4$export$93fc89076fcc0c52 = (0, $2Ujef.default);
module.exports["HomeRecentWorkQuery"] = $fed37ec4c6d5a8b4$export$93fc89076fcc0c52;

});

parcelRegister("2Ujef", function(module, exports) {
/**
 * @generated SignedSource<<5a11bc75dfd8762ef129fa2338a54406>>
 * @relayHash 29c4cb130b82621c8ae64d700e35e867
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0f8088baf02eccbefe567796b693e824d4a461ef0707b0e60aa6a11c98152551
const $451651b37d1d3ba3$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Literal",
                            "name": "products",
                            "value": [
                                "CONFLUENCE"
                            ]
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    }, v7 = {
        "kind": "ScalarField",
        "name": "title"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v11 = [
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "editUi"
        }
    ], v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiDraft",
                "plural": false,
                "selections": v12 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiPublished",
                "plural": false,
                "selections": v12 /*: any*/ 
            }
        ]
    }, v14 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "subtype"
            },
            {
                "alias": "pageStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v9 /*: any*/ ,
            {
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v11 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "alias": "blogStatus",
                "kind": "ScalarField",
                "name": "status"
            },
            v9 /*: any*/ ,
            {
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v11 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceBlogPost"
    }, v17 = {
        "kind": "ScalarField",
        "name": "status"
    }, v18 = [
        v10 /*: any*/ 
    ], v19 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceWhiteboard"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceDatabase"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceSlideLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v14 /*: any*/ 
        ],
        "type": "ConfluenceSlide"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v17 /*: any*/ ,
            {
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v18 /*: any*/ 
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ],
        "type": "ConfluenceEmbed"
    }, v23 = {
        "concreteType": "ActivityEvent",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "ScalarField",
                "name": "eventType"
            }
        ]
    }, v24 = [
        v6 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentWorkQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentWorkQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "__typename"
                                                                        },
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v24 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "29c4cb130b82621c8ae64d700e35e867",
            "id": "0f8088baf02eccbefe567796b693e824d4a461ef0707b0e60aa6a11c98152551",
            "metadata": {},
            "name": "HomeRecentWorkQuery",
            "operationKind": "query",
            "text": "query HomeRecentWorkQuery($cloudId:ID!,$first:Int,$after:String,$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:[\"CONFLUENCE\"],objectTypes:$objectTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceSlide{id,title,type,status,links{webUi},space{alias,id,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},metadata{titleEmojiDraft{value},titleEmojiPublished{value}},space{alias,id,key,name}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}}}}}}"
        }
    };
}();
$451651b37d1d3ba3$var$node.hash = "a45e25c98c3a3864ddaee2dc7df8090c";
var $451651b37d1d3ba3$export$2e2bcd8739ae039 = $451651b37d1d3ba3$var$node;
module.exports["default"] = $451651b37d1d3ba3$export$2e2bcd8739ae039;

});

parcelRegister("y9T5W", function(module, exports) {
const $c2f13451050bd3c6$export$a1180afea81894e6 = 6;
const $c2f13451050bd3c6$export$124f170b2681e34e = 3;
module.exports["ALL_RECENT_ITEMS_COUNT_HOME_REFRESH"] = $c2f13451050bd3c6$export$a1180afea81894e6;
module.exports["ALL_RECENT_ITEMS_COUNT_AGENTIC_SESSIONS"] = $c2f13451050bd3c6$export$124f170b2681e34e;

});

parcelRegister("k2RxH", function(module, exports) {

var $5PJPG = parcelRequire("5PJPG");


var $36tM8 = parcelRequire("36tM8");


var $ctLrB = parcelRequire("ctLrB");


var $7Pigg = parcelRequire("7Pigg");


var $493fu = parcelRequire("493fu");

const $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3 = [
    (0, $ctLrB.ActivityEventType).EDITED,
    (0, $ctLrB.ActivityEventType).PUBLISHED,
    (0, $ctLrB.ActivityEventType).UPDATED,
    (0, $ctLrB.ActivityEventType).CREATED,
    (0, $ctLrB.ActivityEventType).STARTED,
    (0, $ctLrB.ActivityEventType).SNAPSHOTTED
];
const $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES = [
    (0, $ctLrB.ActivityEventType).COMMENTED,
    ...$355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3
];
const $355018d1e9284f84$var$COLLABORATED_ON_WITH_3P_EVENT_TYPES = [
    'commented',
    ...(0, $36tM8.WORKED_ON_WITH_3P_EVENT_TYPES)
];
const $355018d1e9284f84$var$OBJECT_TYPES = [
    (0, $ctLrB.ActivitiesObjectType).PAGE,
    (0, $ctLrB.ActivitiesObjectType).BLOGPOST,
    (0, $ctLrB.ActivitiesObjectType).EMBED
];
const $355018d1e9284f84$var$PAGE_SIZE = 24;
const $355018d1e9284f84$export$c0883c47d72a59fc = ({ pill: pill, cloudId: cloudId, endCursor: endCursor, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled, isDatabaseEnabled: isDatabaseEnabled, include3P: include3P })=>{
    const createdDateFilter = 'and created >= startOfDay("-90d") ';
    const activityQuery = (0, $7Pigg.default);
    const activityCloudId = (0, $5PJPG.PlatformSiteAri).create({
        siteId: cloudId
    }).toString();
    switch(pill){
        case 'created':
            return {
                query: (0, $493fu.default),
                variables: {
                    cql: `type in (page, blogpost, embed${isWhiteboardUpdatedEnabled ? ', whiteboard' : ''}${isDatabaseEnabled ? ', database' : ''}) and owner=currentUser() ${createdDateFilter}order by created desc`,
                    cqlcontext: `{"contentStatuses":["draft", "current"]}`,
                    first: $355018d1e9284f84$var$PAGE_SIZE,
                    after: endCursor
                }
            };
        case 'worked-on':
            {
                const objectTypes = [
                    ...$355018d1e9284f84$var$OBJECT_TYPES,
                    (0, $ctLrB.ActivitiesObjectType).CONTENT,
                    ...isWhiteboardUpdatedEnabled ? [
                        (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                    ] : [],
                    ...isDatabaseEnabled ? [
                        (0, $ctLrB.ActivitiesObjectType).DATABASE
                    ] : []
                ];
                return {
                    query: activityQuery,
                    variables: {
                        cloudId: activityCloudId,
                        first: $355018d1e9284f84$var$PAGE_SIZE,
                        after: endCursor,
                        ...include3P ? (0, $36tM8.getThirdPartyRecentVars)(objectTypes, (0, $36tM8.WORKED_ON_WITH_3P_EVENT_TYPES)) : {
                            eventTypes: $355018d1e9284f84$var$WORKED_ON_EVENT_TYPES_V3,
                            objectTypes: objectTypes
                        }
                    }
                };
            }
        case 'collaborated-on':
            {
                const objectTypes = [
                    ...$355018d1e9284f84$var$OBJECT_TYPES,
                    ...isWhiteboardUpdatedEnabled ? [
                        (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                    ] : [],
                    ...isDatabaseEnabled ? [
                        (0, $ctLrB.ActivitiesObjectType).DATABASE
                    ] : [],
                    (0, $ctLrB.ActivitiesObjectType).CONTENT,
                    (0, $ctLrB.ActivitiesObjectType).COMMENT
                ];
                return {
                    query: activityQuery,
                    variables: {
                        cloudId: (0, $5PJPG.PlatformSiteAri).create({
                            siteId: cloudId
                        }).toString(),
                        first: $355018d1e9284f84$var$PAGE_SIZE,
                        after: endCursor,
                        ...include3P ? (0, $36tM8.getThirdPartyRecentVars)(objectTypes, $355018d1e9284f84$var$COLLABORATED_ON_WITH_3P_EVENT_TYPES) : {
                            eventTypes: $355018d1e9284f84$var$COLLABORATED_ON_EVENT_TYPES,
                            objectTypes: objectTypes
                        }
                    }
                };
            }
        case 'all':
        default:
            {
                const objectTypes = [
                    ...$355018d1e9284f84$var$OBJECT_TYPES,
                    (0, $ctLrB.ActivitiesObjectType).CONTENT,
                    ...isWhiteboardViewedEnabled ? [
                        (0, $ctLrB.ActivitiesObjectType).WHITEBOARD
                    ] : [],
                    ...isDatabaseEnabled ? [
                        (0, $ctLrB.ActivitiesObjectType).DATABASE
                    ] : []
                ];
                return {
                    query: activityQuery,
                    variables: {
                        cloudId: activityCloudId,
                        first: $355018d1e9284f84$var$PAGE_SIZE,
                        after: endCursor,
                        ...include3P ? (0, $36tM8.getThirdPartyRecentVars)(objectTypes) : {
                            eventTypes: [],
                            objectTypes: objectTypes
                        }
                    }
                };
            }
    }
};
module.exports["getRecentQueryOptions"] = $355018d1e9284f84$export$c0883c47d72a59fc;

});

parcelRegister("36tM8", function(module, exports) {
/**
 * Shared constants for the Recent Content Menu.
 *
 * These are extracted into a separate lightweight file to avoid pulling the
 * full recentQueryConfig module (which contains heavy query-building logic,
 * data transforms, and GraphQL queries) into chunks that only need these
 * constants (e.g. the preloader). This prevents tree-shaking defeats.
 */ 
var $5PJPG = parcelRequire("5PJPG");


var $yuLaV = parcelRequire("yuLaV");

var $aae031cb24e89c49$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["ASSIGNED"] = "ASSIGNED";
    ActivityEventType["COMMENTED"] = "COMMENTED";
    ActivityEventType["CREATED"] = "CREATED";
    ActivityEventType["EDITED"] = "EDITED";
    ActivityEventType["LIKED"] = "LIKED";
    ActivityEventType["PUBLISHED"] = "PUBLISHED";
    ActivityEventType["SNAPSHOTTED"] = "SNAPSHOTTED";
    ActivityEventType["STARTED"] = "STARTED";
    ActivityEventType["TRANSITIONED"] = "TRANSITIONED";
    ActivityEventType["UNASSIGNED"] = "UNASSIGNED";
    ActivityEventType["UPDATED"] = "UPDATED";
    ActivityEventType["VIEWED"] = "VIEWED";
    return ActivityEventType;
}({});
var $aae031cb24e89c49$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["PAGE"] = "PAGE";
    ActivityObjectType["BLOGPOST"] = "BLOGPOST";
    ActivityObjectType["WHITEBOARD"] = "WHITEBOARD";
    ActivityObjectType["DATABASE"] = "DATABASE";
    ActivityObjectType["SLIDE"] = "SLIDE";
    ActivityObjectType["EMBED"] = "EMBED";
    ActivityObjectType["CONTENT"] = "CONTENT";
    ActivityObjectType["COMMENT"] = "COMMENT";
    return ActivityObjectType;
}({});
const $aae031cb24e89c49$export$8ec3d08588d2eeda = 30;
const $aae031cb24e89c49$export$c49cfb2681596b20 = [
    "PAGE",
    "BLOGPOST",
    "WHITEBOARD",
    "DATABASE",
    "SLIDE",
    "EMBED",
    "CONTENT"
];
function $aae031cb24e89c49$export$e0c1f83af18ea809() {
    return $aae031cb24e89c49$export$c49cfb2681596b20.filter((t)=>t !== "SLIDE" || (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide'));
}
const $aae031cb24e89c49$export$507c2df9171a0432 = [
    "EDITED",
    "PUBLISHED",
    "UPDATED",
    "CREATED",
    "STARTED",
    "SNAPSHOTTED"
];
/** Teamwork Graph product and object types for third-party (3P) items: files, smart links, pull requests and work items. */ const $aae031cb24e89c49$var$GRAPH_ACTIVITY_PRODUCT = 'graph';
const $aae031cb24e89c49$var$GRAPH_OBJECT_TYPES = [
    'document',
    'remote-link',
    'pull-request',
    'work-item'
];
const $aae031cb24e89c49$export$a399be5655b386eb = (objectId)=>/^ari:(third-party|cloud:graph):/.test(objectId ?? '');
const $aae031cb24e89c49$export$5b3f764d42cb8710 = (data)=>data?.displayName && data.url && data.provider?.name ? {
        title: data.displayName,
        url: data.url,
        thirdPartyId: data.thirdPartyId,
        // Provider names can end in " provider" (e.g. "Google Drive provider"), as create-space's
        // connectorFiles.ts also handles.
        providerName: data.provider.name.replace(/\s+provider$/i, '')
    } : null;
/**
 * Event types for the "All" filter when it includes 3P items. `eventTypes` applies to every
 * product in the query, so this is Quick Find's list (which covers Confluence events) plus `clicked`,
 * without `sl-viewed`: smart link views are a noisy signal that would drown out the list.
 */ const $aae031cb24e89c49$var$RECENT_WITH_3P_EVENT_TYPES = [
    'assigned',
    'unassigned',
    'viewed',
    'clicked',
    'updated',
    'created',
    'liked',
    'transitioned',
    'published',
    'edited',
    'commented',
    'sl-clicked',
    'shared',
    'exported',
    'deleted',
    'started',
    'snapshotted',
    'trashed',
    'reaction'
];
const $aae031cb24e89c49$export$b79a30816b9686d5 = [
    'edited',
    'published',
    'updated',
    'created',
    'started',
    'snapshotted'
];
const $aae031cb24e89c49$export$fe7f9dd2d21e56ad = (confluenceObjectTypes, eventTypes = $aae031cb24e89c49$var$RECENT_WITH_3P_EVENT_TYPES)=>({
        products: [
            'CONFLUENCE',
            $aae031cb24e89c49$var$GRAPH_ACTIVITY_PRODUCT
        ],
        eventTypes: eventTypes,
        objectTypes: [
            ...confluenceObjectTypes,
            ...$aae031cb24e89c49$var$GRAPH_OBJECT_TYPES
        ]
    });
function $aae031cb24e89c49$export$848fde9b10e78f91(cloudId, include3P) {
    return {
        cloudId: (0, $5PJPG.PlatformSiteAri).create({
            siteId: cloudId
        }).toString(),
        after: '',
        first: $aae031cb24e89c49$export$8ec3d08588d2eeda,
        ...include3P ? $aae031cb24e89c49$export$fe7f9dd2d21e56ad($aae031cb24e89c49$export$e0c1f83af18ea809()) : {
            eventTypes: [],
            objectTypes: $aae031cb24e89c49$export$e0c1f83af18ea809()
        }
    };
}
module.exports["ActivityObjectType"] = $aae031cb24e89c49$export$d02a56686be43f69;
module.exports["PAGE_SIZE"] = $aae031cb24e89c49$export$8ec3d08588d2eeda;
module.exports["objectTypes"] = $aae031cb24e89c49$export$e0c1f83af18ea809;
module.exports["WORKED_ON_EVENT_TYPES"] = $aae031cb24e89c49$export$507c2df9171a0432;
module.exports["isThirdPartyActivity"] = $aae031cb24e89c49$export$a399be5655b386eb;
module.exports["getThirdPartyItem"] = $aae031cb24e89c49$export$5b3f764d42cb8710;
module.exports["WORKED_ON_WITH_3P_EVENT_TYPES"] = $aae031cb24e89c49$export$b79a30816b9686d5;
module.exports["getThirdPartyRecentVars"] = $aae031cb24e89c49$export$fe7f9dd2d21e56ad;
module.exports["getAllRecentInitialVars"] = $aae031cb24e89c49$export$848fde9b10e78f91;

});

parcelRegister("7Pigg", function(module, exports) {
/**
 * @generated SignedSource<<2631ace7906f2dfbab9a5de981482dfb>>
 * @relayHash ef9d214fb72710f0604b77c39b9f3be4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8ca052a55e5704a38799c86ee034c9b4f155be0b8ce000ad09b8da69695bc0fa
const $38dad1ddcca5450a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "eventTypes"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "objectTypes"
    }, v5 = {
        "defaultValue": [
            "CONFLUENCE"
        ],
        "kind": "LocalArgument",
        "name": "products"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "eventTypes",
                            "variableName": "eventTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "objectTypes",
                            "variableName": "objectTypes"
                        },
                        {
                            "kind": "Variable",
                            "name": "products",
                            "variableName": "products"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "arguments"
                },
                {
                    "items": [
                        {
                            "kind": "Variable",
                            "name": "rootContainerIds.0",
                            "variableName": "cloudId"
                        }
                    ],
                    "kind": "ListValue",
                    "name": "rootContainerIds"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "AND"
                }
            ],
            "kind": "ObjectValue",
            "name": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v12 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v14 = {
        "kind": "ScalarField",
        "name": "webUi"
    }, v15 = [
        v14 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "editUi"
        }
    ], v16 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v15 /*: any*/ 
    }, v17 = {
        "concreteType": "ConfluenceBodies",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "excerpt"
            }
        ]
    }, v18 = [
        {
            "concreteType": "ConfluenceFavoritedSummary",
            "kind": "LinkedField",
            "name": "favoritedSummary",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavorite"
                }
            ]
        }
    ], v19 = {
        "concreteType": "ConfluencePageViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v20 = {
        "concreteType": "ConfluenceCommentCountSummary",
        "kind": "LinkedField",
        "name": "commentCountSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "total"
            }
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "name"
    }, v22 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v21 /*: any*/ 
        ]
    }, v23 = {
        "concreteType": "ConfluenceLikesSummary",
        "kind": "LinkedField",
        "name": "likesSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v24 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "editor"
            ]
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "value"
    }, v26 = [
        v25 /*: any*/ 
    ], v27 = {
        "concreteType": "ConfluenceContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiDraft",
                "plural": false,
                "selections": v26 /*: any*/ 
            },
            {
                "concreteType": "ConfluenceContentTitleEmoji",
                "kind": "LinkedField",
                "name": "titleEmojiPublished",
                "plural": false,
                "selections": v26 /*: any*/ 
            }
        ]
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v22 /*: any*/ ,
            v23 /*: any*/ ,
            {
                "alias": "editorVersion",
                "args": v24 /*: any*/ ,
                "concreteType": "ConfluencePageProperty",
                "kind": "LinkedField",
                "name": "properties",
                "plural": true,
                "selections": v26 /*: any*/ ,
                "storageKey": "properties(keys:[\"editor\"])"
            },
            v27 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v29 = {
        "alias": "blogStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v30 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v15 /*: any*/ 
    }, v31 = {
        "concreteType": "ConfluenceBlogPostViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v32 = {
        "alias": "editorVersion",
        "args": v24 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v26 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v33 = {
        "kind": "ScalarField",
        "name": "status"
    }, v34 = [
        v14 /*: any*/ 
    ], v35 = {
        "concreteType": "ConfluenceContentViewerSummary",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": v18 /*: any*/ 
    }, v36 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v33 /*: any*/ ,
            {
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v34 /*: any*/ 
            },
            v35 /*: any*/ ,
            v20 /*: any*/ ,
            v22 /*: any*/ 
        ],
        "type": "ConfluenceWhiteboard"
    }, v37 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v33 /*: any*/ ,
            {
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v34 /*: any*/ 
            },
            v35 /*: any*/ ,
            v20 /*: any*/ ,
            v22 /*: any*/ 
        ],
        "type": "ConfluenceDatabase"
    }, v38 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v33 /*: any*/ ,
            {
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v34 /*: any*/ 
            },
            v35 /*: any*/ ,
            v20 /*: any*/ ,
            v22 /*: any*/ ,
            v27 /*: any*/ 
        ],
        "type": "ConfluenceEmbed"
    }, v39 = [
        v8 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "displayName"
        },
        {
            "kind": "ScalarField",
            "name": "url"
        },
        {
            "concreteType": "ExternalProvider",
            "kind": "LinkedField",
            "name": "provider",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v40 = {
        "kind": "InlineFragment",
        "selections": v39 /*: any*/ ,
        "type": "ExternalDocument"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": v39 /*: any*/ ,
        "type": "ExternalRemoteLink"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": v39 /*: any*/ ,
        "type": "ExternalPullRequest"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": v39 /*: any*/ ,
        "type": "ExternalWorkItem"
    }, v44 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v45 = [
        v8 /*: any*/ ,
        v44 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v28 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v29 /*: any*/ ,
                        v30 /*: any*/ ,
                        v17 /*: any*/ ,
                        v31 /*: any*/ ,
                        v20 /*: any*/ ,
                        v22 /*: any*/ ,
                        v32 /*: any*/ ,
                        v27 /*: any*/ 
                    ],
                    "type": "ConfluenceBlogPost"
                },
                v36 /*: any*/ 
            ]
        }
    ], v46 = {
        "concreteType": "ActivityEvent",
        "kind": "LinkedField",
        "name": "event",
        "plural": false,
        "selections": [
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "ScalarField",
                "name": "eventType"
            }
        ]
    }, v47 = {
        "concreteType": "ActivityPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v48 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v49 = [
        v25 /*: any*/ ,
        v8 /*: any*/ 
    ], v50 = {
        "kind": "InlineFragment",
        "selections": [
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v13 /*: any*/ ,
            v16 /*: any*/ ,
            v17 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            v22 /*: any*/ ,
            v23 /*: any*/ ,
            {
                "alias": "editorVersion",
                "args": v24 /*: any*/ ,
                "concreteType": "ConfluencePageProperty",
                "kind": "LinkedField",
                "name": "properties",
                "plural": true,
                "selections": v49 /*: any*/ ,
                "storageKey": "properties(keys:[\"editor\"])"
            },
            v27 /*: any*/ 
        ],
        "type": "ConfluencePage"
    }, v51 = {
        "alias": "editorVersion",
        "args": v24 /*: any*/ ,
        "concreteType": "ConfluenceBlogPostProperty",
        "kind": "LinkedField",
        "name": "properties",
        "plural": true,
        "selections": v49 /*: any*/ ,
        "storageKey": "properties(keys:[\"editor\"])"
    }, v52 = [
        v8 /*: any*/ 
    ], v53 = {
        "kind": "InlineFragment",
        "selections": v52 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v54 = [
        v8 /*: any*/ ,
        v44 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
                v48 /*: any*/ ,
                v50 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v29 /*: any*/ ,
                        v30 /*: any*/ ,
                        v17 /*: any*/ ,
                        v31 /*: any*/ ,
                        v20 /*: any*/ ,
                        v22 /*: any*/ ,
                        v51 /*: any*/ ,
                        v27 /*: any*/ 
                    ],
                    "type": "ConfluenceBlogPost"
                },
                v36 /*: any*/ ,
                v53 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentActivityQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v28 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v32 /*: any*/ ,
                                                                                v27 /*: any*/ 
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        v36 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v41 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v45 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v45 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v46 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v47 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentActivityQuery",
            "selections": [
                {
                    "concreteType": "Activity",
                    "kind": "LinkedField",
                    "name": "activity",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MyActivity",
                            "kind": "LinkedField",
                            "name": "myActivity",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v6 /*: any*/ ,
                                    "concreteType": "ActivityConnection",
                                    "kind": "LinkedField",
                                    "name": "all",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ActivityItemEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "concreteType": "ActivityNode",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v8 /*: any*/ ,
                                                        {
                                                            "concreteType": "ActivityObject",
                                                            "kind": "LinkedField",
                                                            "name": "object",
                                                            "plural": false,
                                                            "selections": [
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v48 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v29 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v30 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v20 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v51 /*: any*/ ,
                                                                                v27 /*: any*/ 
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        v36 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        v38 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        v41 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v54 /*: any*/ ,
                                                                            "type": "ConfluenceInlineComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v54 /*: any*/ ,
                                                                            "type": "ConfluenceFooterComment"
                                                                        },
                                                                        v53 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v52 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v52 /*: any*/ ,
                                                                            "type": "MercuryPortfolio"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v46 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v47 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "ef9d214fb72710f0604b77c39b9f3be4",
            "id": "8ca052a55e5704a38799c86ee034c9b4f155be0b8ce000ad09b8da69695bc0fa",
            "metadata": {},
            "name": "HomeRecentActivityQuery",
            "operationKind": "query",
            "text": "query HomeRecentActivityQuery($cloudId:ID!,$first:Int,$after:String,$products:[String!]=[\"CONFLUENCE\"],$eventTypes:[String!],$objectTypes:[String!]){activity{myActivity{all(filter:{type:AND,rootContainerIds:[$cloudId],arguments:{products:$products,objectTypes:$objectTypes,eventTypes:$eventTypes}},first:$first,after:$after){edges{cursor,node{id,object{id,data{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceDatabase{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on ConfluenceEmbed{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ExternalDocument{id,displayName,url,provider{name}},...on ExternalRemoteLink{id,displayName,url,provider{name}},...on ExternalPullRequest{id,displayName,url,provider{name}},...on ExternalWorkItem{id,displayName,url,provider{name}},...on ConfluenceInlineComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on ConfluenceFooterComment{id,commentId,container{__typename,...on ConfluencePage{id,title,type,subtype,pageStatus:status,createdAt,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},likesSummary{count},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceBlogPost{id,title,type,blogStatus:status,links{webUi,editUi},body{excerpt},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name},editorVersion:properties(keys:[\"editor\"]){value,id},metadata{titleEmojiDraft{value},titleEmojiPublished{value}}},...on ConfluenceWhiteboard{id,title,type,status,links{webUi},viewer{favoritedSummary{isFavorite}},commentCountSummary{total},space{id,alias,key,name}},...on Node{__isNode:__typename,id}}},...on Node{__isNode:__typename,id},...on DevOpsPullRequestDetails{id},...on MercuryPortfolio{id}}},event{id,timestamp,eventType}}},pageInfo{hasNextPage,endCursor}}}}}"
        }
    };
}();
$38dad1ddcca5450a$var$node.hash = "e4ab3a2dba3e8649a0ea5abf39bd4a41";
var $38dad1ddcca5450a$export$2e2bcd8739ae039 = $38dad1ddcca5450a$var$node;
module.exports["default"] = $38dad1ddcca5450a$export$2e2bcd8739ae039;

});

parcelRegister("493fu", function(module, exports) {
/**
 * @generated SignedSource<<450d62048a00a7671a0495c232f885c6>>
 * @relayHash f0145d2844cb31576b9be51e3b4df41d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b2a7906eff37e0caa37a462044732c692e9ba5599a2b0e93eb2b126520f4761b
const $c756b2564f8020f1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 372
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:372)"
    }, v11 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "createdDate"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "key"
    }, v13 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v5 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v14 = {
        "concreteType": "LikesResponse",
        "kind": "LinkedField",
        "name": "likes",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "status"
    }, v16 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v17 = {
        "kind": "ScalarField",
        "name": "value"
    }, v18 = {
        "alias": "editorVersion",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"editor\")"
    }, v19 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v17 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\"])"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v21 = [
        v20 /*: any*/ 
    ], v22 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v23 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v20 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "HomeRecentCreatedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v21 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "HomeRecentCreatedQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v13 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "createdBy",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": v23 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v22 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f0145d2844cb31576b9be51e3b4df41d",
            "id": "b2a7906eff37e0caa37a462044732c692e9ba5599a2b0e93eb2b126520f4761b",
            "metadata": {},
            "name": "HomeRecentCreatedQuery",
            "operationKind": "query",
            "text": "query HomeRecentCreatedQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{content{id,title,type,subType,links{webui,editui},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},createdDate},space{alias,id,key,name},likes{count},status,blank,editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\"]){nodes{id,value,key}},history{createdBy{__typename,...on KnownUser{accountId}}},version{by{__typename,...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$c756b2564f8020f1$var$node.hash = "85d080eebc369ed2623af7fb67441257";
var $c756b2564f8020f1$export$2e2bcd8739ae039 = $c756b2564f8020f1$var$node;
module.exports["default"] = $c756b2564f8020f1$export$2e2bcd8739ae039;

});

parcelRegister("5dcQK", function(module, exports) {
/**
 * @generated SignedSource<<ab148751716f98f00deddf45b6de3959>>
 * @relayHash 375208eee06e531e31912b7a419f44d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ead1382726b260e2d93f54b2da52d4042d91bc06acdee3a39ad5b4709186307
const $a2dc34d339146e99$var$node = function() {
    var v0 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "recentFilter"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "375208eee06e531e31912b7a419f44d0",
            "id": "6ead1382726b260e2d93f54b2da52d4042d91bc06acdee3a39ad5b4709186307",
            "metadata": {},
            "name": "useRecentPreferencesHomeRecentUserPreferencesQuery",
            "operationKind": "query",
            "text": "query useRecentPreferencesHomeRecentUserPreferencesQuery{userPreferences{recentFilter}}"
        }
    };
}();
$a2dc34d339146e99$var$node.hash = "7467140cd6c953941675ec5eab0f0de2";
var $a2dc34d339146e99$export$2e2bcd8739ae039 = $a2dc34d339146e99$var$node;
module.exports["default"] = $a2dc34d339146e99$export$2e2bcd8739ae039;

});

parcelRegister("1abNy", function(module, exports) {
/**
 * @generated SignedSource<<45e1157e30330b381f1779e6a6b13578>>
 * @relayHash 62d0ae3cc424d28cdfd278c6ed4201e3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 02857286577e787ccdd046602aa1cf2c1745318f4c88787491f6db95af2b6f9b
const $4ae0e3efa3fecc57$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "limit"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "start"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "limit",
                    "variableName": "limit"
                },
                {
                    "kind": "Variable",
                    "name": "start",
                    "variableName": "start"
                }
            ],
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "favoriteContent",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "excerpt"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "lastUpdated",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "when"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "editorVersion",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "editor"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v3 /*: any*/ ,
                            "storageKey": "properties(key:\"editor\")"
                        },
                        {
                            "alias": "emoji",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v3 /*: any*/ ,
                            "storageKey": "properties(keys:[\"emoji-title-published\"])"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                    "kind": "LinkedField",
                                    "name": "currentuser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "FavouritedSummary",
                                            "kind": "LinkedField",
                                            "name": "favourited",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isFavourite"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "RecentlyViewedSummary",
                                            "kind": "LinkedField",
                                            "name": "viewed",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastSeen"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "LikesModelMetadataDto",
                                    "kind": "LinkedField",
                                    "name": "likes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                                    "kind": "LinkedField",
                                    "name": "comments",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "commentsCount"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                },
                                v1 /*: any*/ ,
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useStarredDataHomeStarredPagesQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useStarredDataHomeStarredPagesQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "62d0ae3cc424d28cdfd278c6ed4201e3",
            "id": "02857286577e787ccdd046602aa1cf2c1745318f4c88787491f6db95af2b6f9b",
            "metadata": {},
            "name": "useStarredDataHomeStarredPagesQuery",
            "operationKind": "query",
            "text": "query useStarredDataHomeStarredPagesQuery($limit:Int,$start:Int)@allowHigherTimeout{favoriteContent(limit:$limit,start:$start){nodes{id,subType,type,title,excerpt,links{editui,webui},history{lastUpdated{when}},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\"]){nodes{id,key,value}},metadata{currentuser{favourited{isFavourite},viewed{lastSeen}},likes{count},comments{commentsCount}},space{alias,id,key,name}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$4ae0e3efa3fecc57$var$node.hash = "16905464af1968f88f238bc0c6585634";
var $4ae0e3efa3fecc57$export$2e2bcd8739ae039 = $4ae0e3efa3fecc57$var$node;
module.exports["default"] = $4ae0e3efa3fecc57$export$2e2bcd8739ae039;

});

parcelRegister("d64J2", function(module, exports) {
/**
 * @generated SignedSource<<2d62ef64b860026e339ca7c6a503eb4c>>
 * @relayHash b21205896b56de61c144ea7d0548f80d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d1b9f41b5612543ef58997db3b4d247971963f3a0117ac3fffe895483a45f2e
const $ed2416599a6e6a62$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v6 = [
        {
            "alias": "search",
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "after"
                },
                {
                    "kind": "Literal",
                    "name": "cql",
                    "value": "type in (page,blogpost) order by lastModified desc"
                },
                {
                    "kind": "Variable",
                    "name": "cqlcontext",
                    "variableName": "cqlcontext"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "concreteType": "ConfluenceSearchConnection",
            "kind": "LinkedField",
            "name": "confluence_search",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSearchResponse",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "title"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "type"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                },
                                {
                                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                    "kind": "LinkedField",
                                    "name": "links",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "webui"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "editui"
                                        }
                                    ]
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "length",
                                            "value": 372
                                        }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "excerpt",
                                    "storageKey": "excerpt(length:372)"
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                                            "kind": "LinkedField",
                                            "name": "currentuser",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "FavouritedSummary",
                                                    "kind": "LinkedField",
                                                    "name": "favourited",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isFavourite"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                                            "kind": "LinkedField",
                                            "name": "comments",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "commentsCount"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModifiedDate"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "alias"
                                        },
                                        v3 /*: any*/ ,
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "LikesResponse",
                                    "kind": "LinkedField",
                                    "name": "likes",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "blank"
                                },
                                {
                                    "alias": "editorVersion",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "editor"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"editor\")"
                                },
                                {
                                    "alias": "emoji",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "keys",
                                            "value": [
                                                "emoji-title-draft"
                                            ]
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(keys:[\"emoji-title-draft\"])"
                                }
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useDraftsDataHomeDraftsQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useDraftsDataHomeDraftsQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "b21205896b56de61c144ea7d0548f80d",
            "id": "1d1b9f41b5612543ef58997db3b4d247971963f3a0117ac3fffe895483a45f2e",
            "metadata": {},
            "name": "useDraftsDataHomeDraftsQuery",
            "operationKind": "query",
            "text": "query useDraftsDataHomeDraftsQuery($cqlcontext:String,$first:Int,$after:String){search:confluence_search(cql:\"type in (page,blogpost) order by lastModified desc\",cqlcontext:$cqlcontext,first:$first,after:$after){nodes{content{id,title,type,subType,links{webui,editui},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},space{alias,id,key,name},likes{count},status,blank,editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-draft\"]){nodes{id,key,value}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$ed2416599a6e6a62$var$node.hash = "7618e5a200bb793a16a7e96fb74bdb29";
var $ed2416599a6e6a62$export$2e2bcd8739ae039 = $ed2416599a6e6a62$var$node;
module.exports["default"] = $ed2416599a6e6a62$export$2e2bcd8739ae039;

});

parcelRegister("kgC8N", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ // oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
const $8494f2a7cbb1632a$var$PAGE_SIZE = 24;
const $8494f2a7cbb1632a$export$57a6045b566b8b90 = {
    variables: {
        cqlcontext: `{"contentStatuses":["draft"]}`,
        first: $8494f2a7cbb1632a$var$PAGE_SIZE
    }
};
module.exports["DRAFTS_QUERY_OPTIONS"] = $8494f2a7cbb1632a$export$57a6045b566b8b90;

});

parcelRegister("01STT", function(module, exports) {
var $8357fd24c5d501e8$export$27a5bd065ad55220 = /*#__PURE__*/ function(View) {
    View["OVERVIEW"] = "overview";
    View["RECENT"] = "recent";
    View["STARRED"] = "starred";
    View["DRAFTS"] = "drafts";
    View["TASKS"] = "tasks";
    return View;
}({});
const $8357fd24c5d501e8$export$f183fe8f38c8cf4f = [
    "recent",
    "starred",
    "drafts",
    "tasks"
];
module.exports["View"] = $8357fd24c5d501e8$export$27a5bd065ad55220;
module.exports["SUPPORTED_ROUTES"] = $8357fd24c5d501e8$export$f183fe8f38c8cf4f;

});

parcelRegister("iwZYw", function(module, exports) {
/**
 * @generated SignedSource<<0f601e53264e4335e95f52245f9778c6>>
 * @relayHash 7354786c74bc87b4af0be7aa1c508959
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc
const $3ac726b99ebc60d4$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceAdminAnnouncementBanner",
            "kind": "LinkedField",
            "name": "adminAnnouncementBanner",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "isDismissible"
                },
                {
                    "kind": "ScalarField",
                    "name": "content"
                },
                {
                    "kind": "ScalarField",
                    "name": "appearance"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "updatedAt"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7354786c74bc87b4af0be7aa1c508959",
            "id": "cabf46c80d68570a7536cd273538fd1d7a98ce651705dc29413ac4754b769dbc",
            "metadata": {},
            "name": "useRegisterAdminAnnouncementBannerQuery",
            "operationKind": "query",
            "text": "query useRegisterAdminAnnouncementBannerQuery{adminAnnouncementBanner{id,isDismissible,content,appearance,title,updatedAt}}"
        }
    };
}();
$3ac726b99ebc60d4$var$node.hash = "240e64f11995d52e66311a69dc8032ab";
var $3ac726b99ebc60d4$export$2e2bcd8739ae039 = $3ac726b99ebc60d4$var$node;
module.exports["default"] = $3ac726b99ebc60d4$export$2e2bcd8739ae039;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<110669bc5712b3aaa5375f0556a88c68>>
 * @relayHash c9ca4dc87d7c1b4565eb911df8516d1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cdd92af0747404310421f4571bdd6507ac1f6fdf50708f5065f81af4c579262b
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "bytesLimit"
                },
                {
                    "kind": "ScalarField",
                    "name": "isUnlimited"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c9ca4dc87d7c1b4565eb911df8516d1b",
            "id": "cdd92af0747404310421f4571bdd6507ac1f6fdf50708f5065f81af4c579262b",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,bytesLimit,isUnlimited,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "5b53f7e45b7378c585a91224c689138b";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("ctTo0", function(module, exports) {
/**
 * @generated SignedSource<<991ce2d939a58c458f86c450ce401fbc>>
 * @relayHash cfd6fa9dcb9e9305611fc3619dc85ec3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6
const $d7558363fe39fca1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "enabled"
        },
        {
            "kind": "ScalarField",
            "name": "messageContent"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceAccessRequestSettingsConfiguration",
            "kind": "LinkedField",
            "name": "confluence_accessRequestSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceAccessRequestSettings",
                    "kind": "LinkedField",
                    "name": "contentAccessRequestSettings",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceAccessRequestSettings",
                    "kind": "LinkedField",
                    "name": "spaceAccessRequestSettings",
                    "plural": false,
                    "selections": v1 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAccessRequestSettingsQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAccessRequestSettingsQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "cfd6fa9dcb9e9305611fc3619dc85ec3",
            "id": "5c673b0736dce3bbc3183b766ba5dc60fdc106f9b1261efc2d3ca8806009b3f6",
            "metadata": {},
            "name": "useAccessRequestSettingsQuery",
            "operationKind": "query",
            "text": "query useAccessRequestSettingsQuery($cloudId:ID!){confluence_accessRequestSettings(cloudId:$cloudId){contentAccessRequestSettings{enabled,messageContent},spaceAccessRequestSettings{enabled,messageContent}}}"
        }
    };
}();
$d7558363fe39fca1$var$node.hash = "a036ba125a56fbf2de00fed43babc58f";
var $d7558363fe39fca1$export$2e2bcd8739ae039 = $d7558363fe39fca1$var$node;
module.exports["default"] = $d7558363fe39fca1$export$2e2bcd8739ae039;

});

parcelRegister("kdKo9", function(module, exports) {
/**
 * @generated SignedSource<<f026ee318392a45fe95d1de0923dc1ed>>
 * @relayHash 8899b56f857af5bbb6a7740a976421fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7
const $04119cd59f78d958$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "routeOverrideEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceRestrictionCheckQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8899b56f857af5bbb6a7740a976421fb",
            "id": "ccc3fed4f1272376987ab0969757e99e08b473a8f3181629a4d10c47646cafb7",
            "metadata": {},
            "name": "SpaceRestrictionCheckQuery",
            "operationKind": "query",
            "text": "query SpaceRestrictionCheckQuery($spaceKey:String!){space(key:$spaceKey){id,settings{routeOverrideEnabled}}}"
        }
    };
}();
$04119cd59f78d958$var$node.hash = "57291753cf0096ea57a2f2351520a494";
var $04119cd59f78d958$export$2e2bcd8739ae039 = $04119cd59f78d958$var$node;
module.exports["default"] = $04119cd59f78d958$export$2e2bcd8739ae039;

});

parcelRegister("dtDUi", function(module, exports) {
/* eslint-disable prefer-template */ 
var $64KID = parcelRequire("64KID");


var $fMEnQ = parcelRequire("fMEnQ");

const $dab54f7f733e6dc2$var$DOC_LINK = 'https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches';
const $dab54f7f733e6dc2$export$476b9d1d68660527 = [
    {
        matchers: [
            /Hydration failed because the initial UI does not match what was rendered on the server/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /The server could not finish this Suspense boundary, likely due to an error during server rendering/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /This root received an early update, before anything was able hydrate. Switched the entire root to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Text content does not match server-rendered HTML./
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /There was an error while hydrating this Suspense boundary. Switched to client rendering./
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    //Production errors
    {
        matchers: [
            /Minified React error #418/
        ],
        friendlyError: {
            friendlyMessage: 'Hydration failed because the initial UI does not match what was rendered on the server in production. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #419/
        ],
        friendlyError: {
            friendlyMessage: 'The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering. Run in development mode for more details.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #421/
        ],
        friendlyError: {
            friendlyMessage: 'This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #422/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating this Suspense boundary. Switched to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #423/
        ],
        friendlyError: {
            friendlyMessage: 'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #424/
        ],
        friendlyError: {
            friendlyMessage: 'This root received an early update, before anything was able hydrate. Switched the entire root to client rendering.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    },
    {
        matchers: [
            /Minified React error #425/
        ],
        friendlyError: {
            friendlyMessage: 'Text content does not match server-rendered HTML.',
            docLink: $dab54f7f733e6dc2$var$DOC_LINK
        },
        hydrationFailed: true
    }
];
const $dab54f7f733e6dc2$export$5796b97ecb5a412 = (errorString)=>{
    for (const { matchers: matchers, friendlyError: friendlyError, hydrationFailed: hydrationFailed } of $dab54f7f733e6dc2$export$476b9d1d68660527){
        if (matchers.some((matcher)=>matcher.test(errorString))) return {
            ...friendlyError,
            originalString: errorString,
            hydrationFailed: hydrationFailed
        };
    }
    return {
        friendlyMessage: 'An additional error occurred, attached below.',
        docLink: '',
        fallback: true,
        originalString: errorString,
        hydrationFailed: false
    };
};
let $dab54f7f733e6dc2$var$hydrationFailureReported = false;
const $dab54f7f733e6dc2$export$f31e9b802517ca17 = ()=>{
    if ($dab54f7f733e6dc2$var$hydrationFailureReported) return false;
    $dab54f7f733e6dc2$var$hydrationFailureReported = true;
    return true;
};
const $dab54f7f733e6dc2$export$80bd7c1950a14658 = ()=>{
    $dab54f7f733e6dc2$var$hydrationFailureReported = false;
};
const $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2 = (url)=>{
    const match = (0, $fMEnQ.Route).matchFirst(Object.values((0, $64KID.namedRoutes)), url);
    return {
        error: new Error(`Hydration failed on route ${match?.name}`),
        route: match?.name || 'unknown'
    };
};
function $dab54f7f733e6dc2$export$260985b5e8a6fce6({ source: source, route: route, errorWithRoute: errorWithRoute, isSSRReactStreaming: isSSRReactStreaming }) {
    const attribution = isSSRReactStreaming ? 'streaming-hydration' : 'hydration';
    const error = $dab54f7f733e6dc2$var$trimTextLength(errorWithRoute.message || String(errorWithRoute), 1000);
    return {
        type: 'sendOperationalEvent',
        data: {
            source: source,
            route: route,
            action: 'failed',
            actionSubject: 'hydration',
            attributes: {
                error: error,
                route: route,
                attribution: attribution,
                isSSRReactStreaming: isSSRReactStreaming
            }
        }
    };
}
function $dab54f7f733e6dc2$var$trimTextLength(text, maxLength) {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}
module.exports["matchHydrationError"] = $dab54f7f733e6dc2$export$5796b97ecb5a412;
module.exports["shouldReportHydrationFailure"] = $dab54f7f733e6dc2$export$f31e9b802517ca17;
module.exports["getHydrationErrorWithRoute"] = $dab54f7f733e6dc2$export$2ce86ea0a2fd49b2;
module.exports["getHydrationFailureOperationalEvent"] = $dab54f7f733e6dc2$export$260985b5e8a6fce6;

});

parcelRegister("dA1Sn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $18ccf8477934fc9e$export$2a8604960d7d23d9 = 30000;
const $18ccf8477934fc9e$var$useTwoStageHydration = (name, enabled)=>{
    const fullCycleOutput = window.__FULLCYCLE__?.[name];
    const isNoFullCycleOutput = fullCycleOutput === undefined;
    const isNoSSR = !window.__SSR_RENDERED__;
    // Rely on a normal hydration/rendering flow when it's a transition or there's no full cycle output
    // or when experience is not hydratable
    const [hydrated, setHydrated] = (0, $cozmU.useState)(isNoSSR || isNoFullCycleOutput || !window.__HYDRATABLE__ || !enabled);
    (0, $cozmU.useEffect)(()=>{
        setHydrated(true);
        const cleanup = ()=>{
            delete window.__FULLCYCLE__?.[name];
        };
        // Arbitrary 30s CLEANUP_TIMEOUT to allow for the element to be rendered before removal
        // to not force an unecessary re-render or flash of blank content, even in slowest cases
        setTimeout(cleanup, $18ccf8477934fc9e$export$2a8604960d7d23d9);
        return cleanup;
    }, [
        name
    ]);
    return {
        hydrated: hydrated,
        fullCycleOutput: fullCycleOutput
    };
};
const $18ccf8477934fc9e$export$ca5d80b93e3e21b2 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals -- the saveFullCycleOutput() only runs in the browser
    const nodesForPartialHydration = document.querySelectorAll('[data-fullcycle-name]');
    if (nodesForPartialHydration.length > 0) window.__FULLCYCLE__ = Array.from(nodesForPartialHydration).reduce((acc, node)=>{
        acc[node.dataset.fullcycleName] = node.innerHTML;
        return acc;
    }, {});
};
const $18ccf8477934fc9e$export$137b13ff1789fa49 = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? false : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    const { hydrated: hydrated, fullCycleOutput: fullCycleOutput } = $18ccf8477934fc9e$var$useTwoStageHydration(name, enabled);
    if (!enabled) return children;
    if (hydrated) {
        let t3;
        if ($[0] !== name || $[1] !== ssrPlaceholder) {
            t3 = ssrPlaceholder ? {
                "data-ssr-placeholder": name,
                "data-ssr-placeholder-replace": name
            } : {};
            $[0] = name;
            $[1] = ssrPlaceholder;
            $[2] = t3;
        } else t3 = $[2];
        let t4;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t4 = {
                position: "relative",
                height: "100%",
                width: "100%"
            };
            $[3] = t4;
        } else t4 = $[3];
        let t5;
        if ($[4] !== children || $[5] !== name || $[6] !== t3) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "two-stage-hydration",
                "data-fullcycle-name": name,
                ...t3,
                style: t4
            }, children);
            $[4] = children;
            $[5] = name;
            $[6] = t3;
            $[7] = t5;
        } else t5 = $[7];
        return t5;
    }
    const innerHTML = fullCycleOutput;
    let t3;
    if ($[8] !== name || $[9] !== ssrPlaceholder) {
        t3 = ssrPlaceholder ? {
            "data-ssr-placeholder": name,
            "data-ssr-placeholder-replace": name
        } : {};
        $[8] = name;
        $[9] = ssrPlaceholder;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== innerHTML) {
        t4 = {
            __html: innerHTML
        };
        $[11] = innerHTML;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            position: "relative",
            height: "100%",
            width: "100%"
        };
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== name || $[15] !== t3 || $[16] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "two-stage-hydration",
            "data-fullcycle-name": name,
            ...t3,
            dangerouslySetInnerHTML: t4,
            style: t5
        });
        $[14] = name;
        $[15] = t3;
        $[16] = t4;
        $[17] = t6;
    } else t6 = $[17];
    return t6;
};
const $18ccf8477934fc9e$export$b6db8e1e111c3550 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { name: name, children: children, enabled: t1, ssrPlaceholder: t2 } = t0;
    const enabled = t1 === undefined ? true : t1;
    const ssrPlaceholder = t2 === undefined ? false : t2;
    let t3;
    if ($[0] !== children || $[1] !== enabled || $[2] !== name || $[3] !== ssrPlaceholder) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($18ccf8477934fc9e$export$137b13ff1789fa49, {
            name: name,
            enabled: enabled,
            ssrPlaceholder: ssrPlaceholder
        }, children);
        $[0] = children;
        $[1] = enabled;
        $[2] = name;
        $[3] = ssrPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["saveFullCycleOutput"] = $18ccf8477934fc9e$export$ca5d80b93e3e21b2;
module.exports["TwoStageHydration"] = $18ccf8477934fc9e$export$b6db8e1e111c3550;

});

parcelRegister("8sZwv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jvnPU = parcelRequire("jvnPU");


var $3d3WW = parcelRequire("3d3WW");


var $iDrrr = parcelRequire("iDrrr");


var $bGVJw = parcelRequire("bGVJw");


var $jdpvF = parcelRequire("jdpvF");


var $arQiA = parcelRequire("arQiA");


var $l08Du = parcelRequire("l08Du");


var $VDfNH = parcelRequire("VDfNH");


var $6m3nS = parcelRequire("6m3nS");


var $1RMKR = parcelRequire("1RMKR");


var $igBZm = parcelRequire("igBZm");


var $e79Od = parcelRequire("e79Od");


var $di43e = parcelRequire("di43e");


var $blkyl = parcelRequire("blkyl");


var $2295f = parcelRequire("2295f");

const $3ce14727ee29c8fc$export$fb465b6e855c1e85 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("post-office-rml-fedramp-compliant-urls");
        $[0] = t1;
    } else t1 = $[0];
    const isFedRampCompliantUrlsEnabled = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $jdpvF.buildDefaultEnvironmentValues)(isFedRampCompliantUrlsEnabled);
        $[1] = t2;
    } else t2 = $[1];
    const environmentValues = t2;
    let t3;
    if ($[2] !== envWithOverrides) {
        t3 = (0, $blkyl.generateEnvironmentConfigWithOverrides)(environmentValues, envWithOverrides);
        $[2] = envWithOverrides;
        $[3] = t3;
    } else t3 = $[3];
    const stableEnvironment = (0, $1RMKR.useStableObject)(t3);
    let t4;
    if ($[4] !== context.current) {
        t4 = $3ce14727ee29c8fc$var$composeConfig((0, $bGVJw.defaultPostOfficeContextValue), context.current);
        $[4] = context.current;
        $[5] = t4;
    } else t4 = $[5];
    const stableContext = (0, $1RMKR.useStableObject)(t4);
    const contextSettled = context.settled ?? true;
    let t5;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $di43e.createMessagePlacementValues)();
        $[6] = t5;
    } else t5 = $[6];
    const memoizedMessagePlacementValues = t5;
    let t6;
    if ($[7] !== analyticsClientInstance || $[8] !== children) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $VDfNH.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di43e.MessagePlacementProvider), {
            value: memoizedMessagePlacementValues
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l08Du.RouteListenerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6m3nS.TriggerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ce14727ee29c8fc$var$MaybeAnalyticsListener, {
            analyticsClientInstance: analyticsClientInstance
        }, children)))));
        $[7] = analyticsClientInstance;
        $[8] = children;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== stableContext || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bGVJw.InternalPostOfficeContextProvider), {
            value: stableContext
        }, t6);
        $[10] = stableContext;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    let t8;
    if ($[13] !== contextSettled || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $igBZm.PostOfficeContextSettledProvider), {
            value: contextSettled
        }, t7);
        $[13] = contextSettled;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== stableEnvironment || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ce14727ee29c8fc$var$MaybePostOfficeCacheProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdpvF.PostOfficeEnvironmentProvider), {
            value: stableEnvironment
        }, t8));
        $[16] = stableEnvironment;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ environment: envWithOverrides, context: context, children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isFedRampCompliantUrlsEnabled = (0, $iDrrr.fg)('post-office-rml-fedramp-compliant-urls');
    const environmentValues = (0, $cozmU.useMemo)(()=>(0, $jdpvF.buildDefaultEnvironmentValues)(isFedRampCompliantUrlsEnabled), [
        isFedRampCompliantUrlsEnabled
    ]);
    const stableEnvironment = (0, $1RMKR.useStableObject)((0, $blkyl.generateEnvironmentConfigWithOverrides)(environmentValues, envWithOverrides));
    const stableContext = (0, $1RMKR.useStableObject)($3ce14727ee29c8fc$var$composeConfig((0, $bGVJw.defaultPostOfficeContextValue), context.current));
    const contextSettled = context.settled ?? true;
    const memoizedMessagePlacementValues = (0, $cozmU.useMemo)(()=>(0, $di43e.createMessagePlacementValues)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ce14727ee29c8fc$var$MaybePostOfficeCacheProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jdpvF.PostOfficeEnvironmentProvider), {
        value: stableEnvironment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $igBZm.PostOfficeContextSettledProvider), {
        value: contextSettled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bGVJw.InternalPostOfficeContextProvider), {
        value: stableContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $VDfNH.PostOfficeScreenContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di43e.MessagePlacementProvider), {
        value: memoizedMessagePlacementValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l08Du.RouteListenerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6m3nS.TriggerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ce14727ee29c8fc$var$MaybeAnalyticsListener, {
        analyticsClientInstance: analyticsClientInstance
    }, children)))))))));
};
const $3ce14727ee29c8fc$var$swrConfig = {
    provider: (0, $2295f.localStorageCacheProvider),
    use: [
        (0, $2295f.postOfficeCacheMiddleware)
    ]
};
const $3ce14727ee29c8fc$var$MaybePostOfficeCacheProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $iDrrr.fg)("post-office-use-placement-with-client")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jvnPU.SWRConfig), {
                value: $3ce14727ee29c8fc$var$swrConfig
            }, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $iDrrr.fg)('post-office-use-placement-with-client')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jvnPU.SWRConfig), {
        value: $3ce14727ee29c8fc$var$swrConfig
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $3ce14727ee29c8fc$var$MaybeAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    const isEPExposuresListenerEnabled = (0, $iDrrr.fg)("post-office_ep_exposures_enabled");
    const isAnalyticsListenerEnabled = (0, $iDrrr.fg)("post-office-analytics-listener-enabled");
    let content = children;
    if (isEPExposuresListenerEnabled) {
        let t1;
        if ($[0] !== analyticsClientInstance || $[1] !== content) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e79Od.EPExposuresListener), {
                analyticsClientInstance: analyticsClientInstance
            }, content);
            $[0] = analyticsClientInstance;
            $[1] = content;
            $[2] = t1;
        } else t1 = $[2];
        content = t1;
    }
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $arQiA.postOfficeGasv3ListenerStore);
        let t1;
        if ($[3] !== content) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
                channel: "*",
                onEvent: handleEvent
            }, content);
            $[3] = content;
            $[4] = t1;
        } else t1 = $[4];
        content = t1;
    }
    let t1;
    if ($[5] !== content) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content);
        $[5] = content;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const isEPExposuresListenerEnabled = (0, $iDrrr.fg)('post-office_ep_exposures_enabled');
    const isAnalyticsListenerEnabled = (0, $iDrrr.fg)('post-office-analytics-listener-enabled');
    let content = children;
    if (isEPExposuresListenerEnabled) content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e79Od.EPExposuresListener), {
        analyticsClientInstance: analyticsClientInstance
    }, content);
    if (isAnalyticsListenerEnabled) {
        const { handleEvent: handleEvent } = (0, $arQiA.postOfficeGasv3ListenerStore);
        content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: "*",
            onEvent: handleEvent
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, content);
};
const $3ce14727ee29c8fc$var$composeConfig = (base, ...rest)=>rest.reduce((acc, v)=>{
        // Bring logic inline with lodash merge
        // Iterator (right) properties that resolve to undefined are skipped if an Accumulator (left) value already exists
        for(const key in v)if (typeof v[key] === 'undefined') delete v[key];
        return {
            ...acc,
            ...v
        };
    }, {
        ...base
    });
module.exports["PostOfficeProvider"] = $3ce14727ee29c8fc$export$fb465b6e855c1e85;

});

parcelRegister("arQiA", function(module, exports) {

var $dwM0U = parcelRequire("dwM0U");

function $e445a34dfcfa6076$var$getSubscribers() {
    if (typeof window !== 'undefined' && window.postOffice?.gasv3Listener?.subscribers) return window.postOffice.gasv3Listener.subscribers;
    if (typeof window !== 'undefined') {
        window.postOffice = {
            ...window.postOffice,
            gasv3Listener: {
                ...window.postOffice?.gasv3Listener,
                subscribers: new Map()
            }
        };
        return window.postOffice.gasv3Listener.subscribers;
    }
    return new Map();
}
const $e445a34dfcfa6076$var$createPostOfficeGasv3ListenerStore = ()=>{
    const subscribers = $e445a34dfcfa6076$var$getSubscribers();
    const handleEvent = (event)=>{
        subscribers.forEach((callback, matcher)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($dwM0U)))(event.payload, matcher)) callback();
        });
    };
    const subscribe = (matcher, callback)=>{
        subscribers.set(matcher, callback);
        return ()=>{
            subscribers.delete(matcher);
        };
    };
    return {
        subscribe: subscribe,
        handleEvent: handleEvent
    };
};
const $e445a34dfcfa6076$export$19b95495a42be187 = $e445a34dfcfa6076$var$createPostOfficeGasv3ListenerStore();
module.exports["postOfficeGasv3ListenerStore"] = $e445a34dfcfa6076$export$19b95495a42be187;

});

parcelRegister("l08Du", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $8RKDP = parcelRequire("8RKDP");


var $5h1mk = parcelRequire("5h1mk");

const $acc09a1fccfadb8a$var$noop = ()=>{};
const $acc09a1fccfadb8a$var$RouteListenerContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    update: $acc09a1fccfadb8a$var$noop
});
const $acc09a1fccfadb8a$export$7a2084f4baac29a7 = ()=>(0, $8RKDP.createSimplePubSub)();
const $acc09a1fccfadb8a$export$72fd8977abf03d60 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($acc09a1fccfadb8a$var$RouteListenerContext);
} : ()=>(0, $cozmU.useContext)($acc09a1fccfadb8a$var$RouteListenerContext);
const $acc09a1fccfadb8a$export$755edb1665399d41 = ()=>{
    const ref = (0, $cozmU.useRef)();
    if (!ref.current) ref.current = $acc09a1fccfadb8a$export$7a2084f4baac29a7();
    const [routeSubscriber, updateRoute] = ref.current;
    const routeConfig = (0, $cozmU.useMemo)(()=>({
            initialUrl: new URL(window.location.href),
            routeSubscriber: routeSubscriber
        }), [
        routeSubscriber
    ]);
    const routeUpdater = (0, $cozmU.useMemo)(()=>({
            update: updateRoute
        }), [
        updateRoute
    ]);
    return [
        routeConfig,
        routeUpdater
    ];
};
const $acc09a1fccfadb8a$export$bb606326acdd1a64 = (deps)=>{
    const { update: update } = $acc09a1fccfadb8a$export$72fd8977abf03d60();
    (0, $cozmU.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        update({
            next: new URL(window.location.href)
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const $acc09a1fccfadb8a$export$31986273b686f5ea = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const [route, routeUpdater] = $acc09a1fccfadb8a$export$755edb1665399d41();
    let t1;
    if ($[0] !== children || $[1] !== route) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5h1mk.PostOfficeRouteProvider), route, children);
        $[0] = children;
        $[1] = route;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== routeUpdater || $[4] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acc09a1fccfadb8a$var$RouteListenerContext.Provider, {
            value: routeUpdater
        }, t1);
        $[3] = routeUpdater;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ children: children })=>{
    const [route, routeUpdater] = $acc09a1fccfadb8a$export$755edb1665399d41();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($acc09a1fccfadb8a$var$RouteListenerContext.Provider, {
        value: routeUpdater
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5h1mk.PostOfficeRouteProvider), route, children));
};
module.exports["usePostOfficeRouteUpdate"] = $acc09a1fccfadb8a$export$bb606326acdd1a64;
module.exports["RouteListenerProvider"] = $acc09a1fccfadb8a$export$31986273b686f5ea;

});

parcelRegister("8RKDP", function(module, exports) {
const $f5ed2f634676d1ae$export$92469b55607f005b = ()=>{
    const subscribers = new Map();
    const subscribe = (subscriber)=>{
        subscribers.set(subscriber, subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const publish = (payload)=>{
        subscribers.forEach((callback)=>callback(payload));
    };
    return [
        subscribe,
        publish
    ];
};
module.exports["createSimplePubSub"] = $f5ed2f634676d1ae$export$92469b55607f005b;

});

parcelRegister("5h1mk", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $6nvBr = parcelRequire("6nvBr");


var $1RMKR = parcelRequire("1RMKR");

const $a524e85936787c13$export$98c77e1bd702ed15 = ({ routeSubscriber: routeSubscriber, initialUrl: initialUrl })=>{
    let state = $a524e85936787c13$var$initializeState({
        initialUrl: initialUrl
    });
    const handleUpdate = (routeChange)=>{
        const next = routeChange.next?.toString();
        if (next === state.current && state.searchParams === routeChange.next?.searchParams) return;
        state = {
            previous: state.current,
            current: next,
            searchParams: routeChange.next?.searchParams
        };
    };
    const subscribe = (next)=>routeSubscriber((routeChange)=>{
            handleUpdate(routeChange);
            next();
        });
    const getSnapshot = ()=>{
        return state;
    };
    return {
        subscribe: subscribe,
        getSnapshot: getSnapshot
    };
};
const $a524e85936787c13$var$usePostOfficeRouteStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const { subscribe: subscribe, getSnapshot: getSnapshot } = t0;
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
} : ({ subscribe: subscribe, getSnapshot: getSnapshot })=>{
    const route = (0, $6nvBr.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    return (0, $1RMKR.useStableObject)(route);
};
const $a524e85936787c13$var$initialState = {
    previous: undefined,
    current: undefined,
    searchParams: undefined
};
const $a524e85936787c13$var$initializeState = ({ initialUrl: initialUrl })=>({
        ...$a524e85936787c13$var$initialState,
        current: initialUrl ? initialUrl?.toString() : undefined,
        searchParams: initialUrl?.searchParams
    });
const $a524e85936787c13$export$f7f47a74e8b47b1f = /*#__PURE__*/ (0, $cozmU.createContext)($a524e85936787c13$var$initialState);
const $a524e85936787c13$export$89eadc6b3e5f4e9e = ({ children: children, ...props })=>{
    const ref = (0, $cozmU.useRef)();
    if (!ref.current) ref.current = $a524e85936787c13$export$98c77e1bd702ed15(props);
    const route = $a524e85936787c13$var$usePostOfficeRouteStore(ref.current);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a524e85936787c13$export$f7f47a74e8b47b1f.Provider, {
        value: route
    }, children);
};
const $a524e85936787c13$export$79301b66f7808cd8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f);
} : ()=>(0, $cozmU.useContext)($a524e85936787c13$export$f7f47a74e8b47b1f); //Route listener
module.exports["PostOfficeRouteContext"] = $a524e85936787c13$export$f7f47a74e8b47b1f;
module.exports["PostOfficeRouteProvider"] = $a524e85936787c13$export$89eadc6b3e5f4e9e;
module.exports["usePostOfficeRoute"] = $a524e85936787c13$export$79301b66f7808cd8;

});

parcelRegister("1RMKR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $323d99f2c95b5263$export$cdf98ded28406f69(obj) {
    return Object.entries(obj).sort().flatMap((v)=>v);
}
function $323d99f2c95b5263$export$ed02d4adf2068b08(obj) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $cozmU.useMemo)(()=>obj, $323d99f2c95b5263$export$cdf98ded28406f69(obj));
}
module.exports["useStableObject"] = $323d99f2c95b5263$export$ed02d4adf2068b08;

});

parcelRegister("6m3nS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $e71ebdc70c2ecd2e$var$initialActiveTriggerState = {
    activeTriggerState: {}
};
const $e71ebdc70c2ecd2e$var$initialTriggerDispatchState = {
    setTriggerState: ()=>{
        // eslint-disable-next-line no-console
        console.error('No Post Office Trigger Context found. Did you remember to add a Post Office Provider?');
    }
};
const $e71ebdc70c2ecd2e$var$TriggerContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialActiveTriggerState);
const $e71ebdc70c2ecd2e$var$TriggerDispatchContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext($e71ebdc70c2ecd2e$var$initialTriggerDispatchState);
const $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3 = ({ children: children })=>{
    const [recordState, setRecordState] = (0, $cozmU.useState)({});
    const setTriggerState = (0, $cozmU.useCallback)(({ isActive: isActive, triggerId: triggerId })=>{
        setRecordState((current)=>{
            if (!!current[triggerId] === isActive) return current;
            if (isActive) return {
                ...current,
                [triggerId]: true
            };
            const { [triggerId]: excludedTrigger, ...rest } = current;
            return rest;
        });
    }, []);
    const triggerContextValue = (0, $cozmU.useMemo)(()=>({
            activeTriggerState: recordState
        }), [
        recordState
    ]);
    const triggerContexDispatchValue = (0, $cozmU.useMemo)(()=>({
            setTriggerState: setTriggerState
        }), [
        setTriggerState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerContext.Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e71ebdc70c2ecd2e$var$TriggerDispatchContext.Provider, {
        value: triggerContexDispatchValue
    }, children));
};
const $e71ebdc70c2ecd2e$export$454c1d7c35958f5e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerContext);
const $e71ebdc70c2ecd2e$export$23cbf084e08bdb93 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
} : ()=>(0, $cozmU.useContext)($e71ebdc70c2ecd2e$var$TriggerDispatchContext);
const $e71ebdc70c2ecd2e$export$3b196fe93a948c18 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (triggerId)=>{
    const $ = (0, $bDgLe.c)(3);
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    let t0;
    if ($[0] !== activeTriggerState || $[1] !== triggerId) {
        t0 = triggerId ? {
            isActive: !!activeTriggerState[triggerId]
        } : {
            isActive: undefined
        };
        $[0] = activeTriggerState;
        $[1] = triggerId;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (triggerId)=>{
    const { activeTriggerState: activeTriggerState } = $e71ebdc70c2ecd2e$export$454c1d7c35958f5e();
    return triggerId ? {
        isActive: !!activeTriggerState[triggerId]
    } : {
        isActive: undefined
    };
};
const $e71ebdc70c2ecd2e$export$83b33e5fe4cce64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { triggerId: triggerId } = t0;
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    let t1;
    if ($[0] !== setContextTriggerState || $[1] !== triggerId) {
        t1 = (t2)=>{
            const { isActive: isActive } = t2;
            return setContextTriggerState({
                triggerId: triggerId,
                isActive: isActive
            });
        };
        $[0] = setContextTriggerState;
        $[1] = triggerId;
        $[2] = t1;
    } else t1 = $[2];
    const fireTrigger = t1;
    let t2;
    if ($[3] !== fireTrigger) {
        t2 = {
            fireTrigger: fireTrigger
        };
        $[3] = fireTrigger;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ triggerId: triggerId })=>{
    const { setTriggerState: setContextTriggerState } = $e71ebdc70c2ecd2e$export$23cbf084e08bdb93();
    const fireTrigger = (0, $cozmU.useCallback)(({ isActive: isActive })=>{
        return setContextTriggerState({
            triggerId: triggerId,
            isActive: isActive
        });
    }, [
        setContextTriggerState,
        triggerId
    ]);
    return {
        fireTrigger: fireTrigger
    };
};
const $e71ebdc70c2ecd2e$export$e45375ff75169f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (messageId)=>{
    const $ = (0, $bDgLe.c)(17);
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    const t0 = `${messageId}-start`;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            triggerId: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t1);
    const t2 = `${messageId}-dismiss`;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            triggerId: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t3);
    const t4 = `${messageId}-cta-click`;
    let t5;
    if ($[4] !== t4) {
        t5 = {
            triggerId: t4
        };
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64(t5);
    let t6;
    if ($[6] !== requestMessageStartTrigger) {
        t6 = ()=>{
            requestMessageStartTrigger({
                isActive: true
            });
        };
        $[6] = requestMessageStartTrigger;
        $[7] = t6;
    } else t6 = $[7];
    const requestMessageStart = t6;
    let t7;
    if ($[8] !== fireDismissClickTrigger) {
        t7 = ()=>{
            fireDismissClickTrigger({
                isActive: true
            });
        };
        $[8] = fireDismissClickTrigger;
        $[9] = t7;
    } else t7 = $[9];
    const dismissMessage = t7;
    let t8;
    if ($[10] !== fireCtaClickTrigger) {
        t8 = ()=>{
            fireCtaClickTrigger({
                isActive: true
            });
        };
        $[10] = fireCtaClickTrigger;
        $[11] = t8;
    } else t8 = $[11];
    const handlePostOfficeClickTracking = t8;
    let t9;
    if ($[12] !== dismissMessage || $[13] !== handlePostOfficeClickTracking || $[14] !== hasMessageStarted || $[15] !== requestMessageStart) {
        t9 = {
            hasMessageStarted: hasMessageStarted,
            requestMessageStart: requestMessageStart,
            dismissMessage: dismissMessage,
            handlePostOfficeClickTracking: handlePostOfficeClickTracking
        };
        $[12] = dismissMessage;
        $[13] = handlePostOfficeClickTracking;
        $[14] = hasMessageStarted;
        $[15] = requestMessageStart;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
} : (messageId)=>{
    // listeners
    const { isActive: hasMessageStarted } = $e71ebdc70c2ecd2e$export$3b196fe93a948c18(`${messageId}-started`);
    // actions
    const { fireTrigger: requestMessageStartTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-start`
    });
    const { fireTrigger: fireDismissClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-dismiss`
    });
    const { fireTrigger: fireCtaClickTrigger } = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64({
        triggerId: `${messageId}-cta-click`
    });
    const requestMessageStart = (0, $cozmU.useCallback)(()=>{
        requestMessageStartTrigger({
            isActive: true
        });
    }, [
        requestMessageStartTrigger
    ]);
    const dismissMessage = (0, $cozmU.useCallback)(()=>{
        fireDismissClickTrigger({
            isActive: true
        });
    }, [
        fireDismissClickTrigger
    ]);
    const handlePostOfficeClickTracking = (0, $cozmU.useCallback)(()=>{
        fireCtaClickTrigger({
            isActive: true
        });
    }, [
        fireCtaClickTrigger
    ]);
    return {
        hasMessageStarted: hasMessageStarted,
        requestMessageStart: requestMessageStart,
        dismissMessage: dismissMessage,
        handlePostOfficeClickTracking: handlePostOfficeClickTracking
    };
};
module.exports["TriggerContextProvider"] = $e71ebdc70c2ecd2e$export$e80a5720bb4c8fe3;
module.exports["useTrigger"] = $e71ebdc70c2ecd2e$export$3b196fe93a948c18;
module.exports["useFirePostOfficeTrigger"] = $e71ebdc70c2ecd2e$export$83b33e5fe4cce64;
module.exports["usePostOfficeExernalMessageProxy"] = $e71ebdc70c2ecd2e$export$e45375ff75169f;

});

parcelRegister("e79Od", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l7jo6 = parcelRequire("l7jo6");


var $3d3WW = parcelRequire("3d3WW");

const $d5b433beb4d04640$var$ENGAGEMENT_PLATFORM_CHANNEL = 'engagementPlatform';
const $d5b433beb4d04640$var$isPromise = (value)=>{
    return value && typeof value.then === 'function';
};
const $d5b433beb4d04640$export$3476bc3bd0845b44 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, analyticsClientInstance: analyticsClientInstance } = t0;
    let t1;
    if ($[0] !== analyticsClientInstance) {
        t1 = (event)=>{
            if (!analyticsClientInstance) return;
            const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
            const userId = restPayload?.userId || attributes?.userId;
            const tenantId = restPayload?.tenantId || attributes?.tenantId;
            if (eventType !== "track" && eventType !== "operational") return;
            if (!userId || !tenantId) return;
            const processEvent = (client)=>{
                try {
                    if (tenantId) client.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, tenantId);
                    if (userId) client.setUserInfo((0, $l7jo6.userType).ATLASSIAN_ACCOUNT, userId);
                } catch (t2) {
                    return;
                }
                const gasPayload = {
                    ...restPayload,
                    tenantId: tenantId,
                    ...attributes ? {
                        attributes: attributes
                    } : {}
                };
                if (eventType === "track") client.sendTrackEvent(gasPayload);
                else if (eventType === "operational") client.sendOperationalEvent(gasPayload);
            };
            if ($d5b433beb4d04640$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
            else processEvent(analyticsClientInstance);
        };
        $[0] = analyticsClientInstance;
        $[1] = t1;
    } else t1 = $[1];
    const handleEvent = t1;
    let t2;
    if ($[2] !== children || $[3] !== handleEvent) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            channel: $d5b433beb4d04640$var$ENGAGEMENT_PLATFORM_CHANNEL,
            onEvent: handleEvent
        }, children);
        $[2] = children;
        $[3] = handleEvent;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, analyticsClientInstance: analyticsClientInstance })=>{
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        if (!analyticsClientInstance) return;
        const { eventType: eventType, attributes: attributes, ...restPayload } = event.payload || {};
        const userId = restPayload?.userId || attributes?.userId;
        const tenantId = restPayload?.tenantId || attributes?.tenantId;
        if (eventType !== 'track' && eventType !== 'operational') return;
        if (!userId || !tenantId) return;
        // Handle Promise if analyticsClientInstance is a Promise
        const processEvent = (client)=>{
            // Update client with user and tenant info
            try {
                if (tenantId) client.setTenantInfo((0, $l7jo6.tenantType).CLOUD_ID, tenantId);
                if (userId) client.setUserInfo((0, $l7jo6.userType).ATLASSIAN_ACCOUNT, userId);
            } catch (error) {
                return;
            }
            // Build payload with tenantId at top level (userId is automatically included via setUserInfo)
            const gasPayload = {
                ...restPayload,
                tenantId: tenantId,
                ...attributes ? {
                    attributes: attributes
                } : {}
            };
            if (eventType === 'track') client.sendTrackEvent(gasPayload);
            else if (eventType === 'operational') client.sendOperationalEvent(gasPayload);
        };
        if ($d5b433beb4d04640$var$isPromise(analyticsClientInstance)) analyticsClientInstance.then(processEvent);
        else processEvent(analyticsClientInstance);
    }, [
        analyticsClientInstance
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: $d5b433beb4d04640$var$ENGAGEMENT_PLATFORM_CHANNEL,
        onEvent: handleEvent
    }, children);
};
module.exports["EPExposuresListener"] = $d5b433beb4d04640$export$3476bc3bd0845b44;

});

parcelRegister("blkyl", function(module, exports) {
const $3d63cb5f2152d1a1$export$ae3dab16eb1fc2cc = (defaultEnvironmentValues, environmentWithOverrides)=>{
    const { env: env, overrides: overrides } = environmentWithOverrides;
    return {
        currentEnv: env,
        envConfigs: {
            ...defaultEnvironmentValues.envConfigs,
            [env]: {
                remoteModule: {
                    origin: overrides?.remoteModule?.origin ?? defaultEnvironmentValues.envConfigs[env].remoteModule.origin,
                    pathname: overrides?.remoteModule?.pathname ?? defaultEnvironmentValues.envConfigs[env].remoteModule.pathname,
                    searchParams: overrides?.remoteModule?.searchParams ?? defaultEnvironmentValues.envConfigs[env].remoteModule.searchParams
                },
                api: {
                    origin: overrides?.api?.origin ?? defaultEnvironmentValues.envConfigs[env].api.origin,
                    pathname: overrides?.api?.pathname ?? defaultEnvironmentValues.envConfigs[env].api.pathname,
                    searchParams: overrides?.api?.searchParams ?? defaultEnvironmentValues.envConfigs[env].api.searchParams
                }
            }
        }
    };
};
module.exports["generateEnvironmentConfigWithOverrides"] = $3d63cb5f2152d1a1$export$ae3dab16eb1fc2cc;

});

parcelRegister("2295f", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3PVFp = parcelRequire("3PVFp");

parcelRequire("6YrB3");
var $f9XbP = parcelRequire("f9XbP");

const $af0c3fa8f4094b14$var$STORAGE_KEY = 'POST_OFFICE__CLIENT_CACHE';
const $af0c3fa8f4094b14$var$CACHE_KEY = 'placement-api';
const $af0c3fa8f4094b14$var$CACHE_EXPIRY = 120000; // 2 minutes
const $af0c3fa8f4094b14$var$storageClient = new (0, $f9XbP.StorageClient)($af0c3fa8f4094b14$var$STORAGE_KEY);
const $af0c3fa8f4094b14$export$3c979fbaa76beaf9 = (cache)=>{
    if (cache instanceof Map && cache.size > 0) {
        const existingCache = $af0c3fa8f4094b14$export$54eb3e634424b746();
        const mergedCache = new Map([
            ...existingCache,
            ...cache
        ]);
        const appCache = Array.from(mergedCache.entries());
        // localStorage.getItem("POST_OFFICE__CLIENT_CACHE_placement-api")
        $af0c3fa8f4094b14$var$storageClient.setItemWithExpiry($af0c3fa8f4094b14$var$CACHE_KEY, appCache, $af0c3fa8f4094b14$var$CACHE_EXPIRY);
    }
};
const $af0c3fa8f4094b14$export$54eb3e634424b746 = ()=>{
    if (typeof window === 'undefined') // Return a dummy storage for server-side rendering
    return new Map();
    // When initializing, we restore the data from `localStorage` into a map.
    const cache = $af0c3fa8f4094b14$var$storageClient.getItem($af0c3fa8f4094b14$var$CACHE_KEY) || [];
    return new Map(cache);
};
const $af0c3fa8f4094b14$export$711c5bb855c82238 = (useSWRNext)=>{
    return (key, fetcher, config)=>{
        const { cache: cache } = (0, $3PVFp.useSWRConfig)();
        const swr = useSWRNext(key, fetcher, config);
        /**
     * This will execute even when data is pulled from the local storage cache.
     * This means that the cache will be updated and the CACHE_EXPIRY reset to be a rolling window.
     *
     * We may want to change this behaviour in the future to only update the cache when the data is NOT pulled from the local storage cache.
     */ (0, $cozmU.useEffect)(()=>{
            if (swr.data !== undefined) $af0c3fa8f4094b14$export$3c979fbaa76beaf9(cache);
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            swr.data
        ]);
        return swr;
    };
};
module.exports["localStorageCacheProvider"] = $af0c3fa8f4094b14$export$54eb3e634424b746;
module.exports["postOfficeCacheMiddleware"] = $af0c3fa8f4094b14$export$711c5bb855c82238;

});

parcelRegister("6YrB3", function(module, exports) {
$parcel$export(module.exports, "StorageClient", () => (parcelRequire("f9XbP")).StorageClient);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $f9XbP = parcelRequire("f9XbP");


var $293056f9068f55f6$export$2e2bcd8739ae039 = (0, $f9XbP.StorageClient);

});

parcelRegister("f9XbP", function(module, exports) {

var $fmV2n = parcelRequire("fmV2n");


var $4KkEB = parcelRequire("4KkEB");

class $cecff34dc45d8bb2$export$6c85f5032e75eff9 {
    captureException(e, tags) {
        if (this.handlers?.captureException) this.handlers.captureException(e, tags);
    }
    itemKey(key) {
        return `${this.clientKey}_${key}`;
    }
    constructor(clientKey, options){
        this.client = void 0;
        this.clientKey = void 0;
        this.handlers = void 0;
        this.getItem = (key, { useExpiredItem: useExpiredItem } = {
            useExpiredItem: false
        })=>{
            const item = this.client.getItem(this.itemKey(key));
            if (item) try {
                const parsedItem = JSON.parse(item);
                if (parsedItem.expires && new Date(parsedItem.expires) < new Date()) {
                    if (!useExpiredItem) return undefined;
                }
                return parsedItem.value;
            } catch (e) {
                this.captureException(e);
                return undefined; // Return undefined on parsing error
            }
            return undefined;
        };
        this.removeItem = (key)=>{
            try {
                this.client.removeItem(this.itemKey(key));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.setItemWithExpiry = (key, value, expireInMS)=>{
            const itemWithExpiry = {
                value: value,
                expires: typeof expireInMS === 'number' ? Date.now() + expireInMS : undefined
            };
            try {
                this.client.setItem(this.itemKey(key), JSON.stringify(itemWithExpiry));
            } catch (e) {
                this.captureException(e);
            }
        };
        this.clientKey = clientKey;
        this.handlers = options?.handlers;
        const storageEngine = options?.storageEngine || (0, $4KkEB.DEFAULT_STORAGE_ENGINE);
        if (typeof window === 'undefined' || !Object.prototype.hasOwnProperty.call(window, storageEngine)) (0, $fmV2n.mockWindowStorage)([
            storageEngine
        ]);
        // Get window reference after mockWindowStorage has potentially created it
        const windowRef = typeof window !== 'undefined' ? window : $parcel$global.window;
        this.client = windowRef[storageEngine];
    }
}
module.exports["StorageClient"] = $cecff34dc45d8bb2$export$6c85f5032e75eff9;

});

parcelRegister("fmV2n", function(module, exports) {
/**
 * This can be used to mock local storage for Edge and other browsers
 * that have disabled local storage setting
 */ const $a61ea4cfed034b37$export$c65e688d8b365035 = {
    _data: {},
    length: 0,
    setItem: function(id, val) {
        return this._data[id] = String(val);
    },
    getItem: function(id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem: function(id) {
        return delete this._data[id];
    },
    clear: function() {
        return this._data = {};
    },
    key: function(index) {
        const keys = Object.keys(this._data);
        return keys[index] || null;
    }
};
const $a61ea4cfed034b37$export$efebfe7859cae3c7 = (storageToMock = [
    'localStorage',
    'sessionStorage'
])=>{
    // Handle SSR environment where window is undefined
    let windowRef;
    let replacedWindowRef = false;
    if (typeof window === 'undefined') {
        // Ensure global exists and create window if needed
        if (typeof $parcel$global !== 'undefined') {
            $parcel$global.window = $parcel$global.window || {};
            windowRef = $parcel$global.window;
        } else {
            // Fallback for environments where global might not exist
            windowRef = {};
            replacedWindowRef = true;
        }
    } else windowRef = window;
    // Ensure windowRef is always defined and is an object
    if (!windowRef || typeof windowRef !== 'object') {
        windowRef = {};
        replacedWindowRef = true;
    }
    // If we had to replace the window reference, reflect it back to global.window
    if (replacedWindowRef && typeof $parcel$global !== 'undefined') $parcel$global.window = windowRef;
    for (const storageToMockElement of storageToMock)Object.defineProperty(windowRef, storageToMockElement, {
        value: {
            ...$a61ea4cfed034b37$export$c65e688d8b365035
        },
        configurable: true,
        writable: true
    });
};
module.exports["mockWindowStorage"] = $a61ea4cfed034b37$export$efebfe7859cae3c7;

});

parcelRegister("4KkEB", function(module, exports) {
const $0745f528b71a1a3c$export$3364800d9d60baf9 = 'localStorage';
module.exports["DEFAULT_STORAGE_ENGINE"] = $0745f528b71a1a3c$export$3364800d9d60baf9;

});

parcelRegister("5nuFe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f7e158d3e97078e1$export$e5c6d63c1f3f867f = (0, $cozmU.createContext)({
    usePageRecommendationData: ()=>({
            data: undefined,
            loading: false,
            hoverPageError: undefined,
            recPageError: undefined
        }),
    useInlineReactionsData: (_numberOfReactedUsers, _skip)=>({
            data: {
                authorName: undefined,
                authorAvatar: undefined,
                reactionsCount: undefined,
                reactionsSummary: undefined,
                reactedUsers: undefined,
                userId: undefined,
                activationId: undefined
            },
            loading: false,
            error: undefined
        }),
    getPageDataFromUrl: ()=>({
            contentId: undefined,
            contentType: undefined,
            spaceKey: undefined
        }),
    emojiProvider: undefined
});
module.exports["ConfluenceExperimentsContext"] = $f7e158d3e97078e1$export$e5c6d63c1f3f867f;

});

parcelRegister("7Px0t", function(module, exports) {
const $5fe4063a771982d5$export$bc4310477dcd6b19 = {
    ATLASSIAN_SWITCHER: 'atlassianSwitcher',
    PROJECT_PAGES: 'project-pages',
    TWC_MARKETING_EMAIL: 'marketingEmail',
    FLAG: 'flag',
    NOTIFICATION: 'notification',
    CONFLUENCE_HOME: 'confluenceHome',
    WAC: 'wac',
    STORYBOOK: 'storybook',
    TEST: 'test',
    TWC_XFLOW_CONFLUENCE_TEMPLATE: 'confluence-template-xflow'
};
const $5fe4063a771982d5$export$1b7797189cccf3b2 = {
    ATLASSIAN_SWITCHER_TRY: 'atlassianSwitcherTry',
    PROJECT_PAGES: 'project-pages',
    WAC_HOMEPAGE_TWC_OFFER: 'wacHomepageTwcOffer',
    STORYBOOK: 'storybook',
    TEST: 'test',
    // TWC Marketing Email (twc-marketing-email-v2) CTA contexts
    JIRA_PLATFORM_TOP_CTA: 'jiraPlatformTopCta',
    JIRA_PLATFORM_BOTTOM_CTA: 'jiraPlatformBottomCta',
    JIRA_ARTICLE_TOP_CTA: 'jiraArticleTopCta',
    JIRA_ARTICLE_BOTTOM_CTA: 'jiraArticleBottomCta',
    JIRA_DATA_TOP_CTA: 'jiraDataTopCta',
    JIRA_DATA_BOTTOM_CTA: 'jiraDataBottomCta',
    CONFLUENCE_PLATFORM_TOP_CTA: 'confluencePlatformTopCta',
    CONFLUENCE_PLATFORM_BOTTOM_CTA: 'confluencePlatformBottomCta',
    CONFLUENCE_ARTICLE_TOP_CTA: 'confluenceArticleTopCta',
    CONFLUENCE_ARTICLE_BOTTOM_CTA: 'confluenceArticleBottomCta',
    CONFLUENCE_DATA_TOP_CTA: 'confluenceDataTopCta',
    CONFLUENCE_DATA_BOTTOM_CTA: 'confluenceDataBottomCta',
    JIRA_CONF_PLATFORM_TOP_CTA: 'jiraConfPlatformTopCta',
    JIRA_CONF_PLATFORM_BOTTOM_CTA: 'jiraConfPlatformBottomCta',
    JIRA_CONF_ARTICLE_TOP_CTA: 'jiraConfArticleTopCta',
    JIRA_CONF_ARTICLE_BOTTOM_CTA: 'jiraConfArticleBottomCta',
    JIRA_CONF_DATA_TOP_CTA: 'jiraConfDataTopCta',
    JIRA_CONF_DATA_BOTTOM_CTA: 'jiraConfDataBottomCta',
    // TWCG-1794: atlassian-switcher Loom intercept (offer TWC over standalone Loom)
    ATLASSIAN_SWITCHER_LOOM_INTERCEPT: 'atlassianSwitcherLoomIntercept',
    LOOM_MEETINGS_PILL: 'loomMeetingsPill',
    CONFLUENCE_XFLOW_SIDENAV: 'confluence-xflow-sidenav',
    CONFLUENCE_XFLOW_FLAG: 'confluence-xflow-flag',
    CONFLUENCE_MEETINGS_TAB: 'confluence-meetings-tab',
    TWC_PROVISIONED_FLAG: 'twc-provisioned-flag',
    TWC_PROVISIONED_NOTIFICATION: 'twc-provisioned-notification'
};
module.exports["SOURCE_COMPONENT"] = $5fe4063a771982d5$export$bc4310477dcd6b19;
module.exports["SOURCE_CONTEXT"] = $5fe4063a771982d5$export$1b7797189cccf3b2;

});

parcelRegister("32x2E", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $bwAnG = parcelRequire("bwAnG");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $7W8i8 = parcelRequire("7W8i8");


var $51W2Z = parcelRequire("51W2Z");

const $dc26b22176754e2e$var$logger = (0, $7W8i8.getLogger)('emoji-provider');
const $dc26b22176754e2e$export$ca6dda5263526f75 = '/gateway/api/emoji';
const $dc26b22176754e2e$export$240be4f98742fdda = (cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const config = {
        providers: [
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/standard`
            },
            {
                url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/atlassian`
            }
        ],
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks
    };
    if (cloudId && (userId || allowAnonymousAccess)) config.providers.push({
        url: `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/site`
    });
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    if (cloudId && (0, $9wGTI.fg)('platform_emoji_adaptive_image_size')) config.optimisticImageApi = {
        getUrl: ({ id: id })=>id ? `${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/${encodeURIComponent(id)}/path?scale=MDPI` : ''
    };
    return config;
};
const $dc26b22176754e2e$export$1504d130127dbc5f = (_EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? false;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    // For signed-in users, allowAnonymousAccess does not change the provider config. Sharing the
    // resource lets uploads propagate immediately between editor, title, and reaction pickers.
    const allowAnonymousAccessCacheKey = userId ? false : allowAnonymousAccess;
    return `${cloudId}_${userId}_${allowAnonymousAccessCacheKey}_${emojiSSRConfig ? 'withSSR' : 'noSSR'}`;
};
const $dc26b22176754e2e$export$9e6d4bd03aadcea5 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const allowAnonymousAccess = extraConfig?.allowAnonymousAccess ?? undefined;
    const emojiConfig = $dc26b22176754e2e$export$240be4f98742fdda(cloudId, userId, disableUpload, emojiSSRConfig, allowAnonymousAccess);
    if (cloudId && userId && (0, $6mKj3.expValEquals)('confluence_on_demand_emoji_repository', 'isEnabled', true)) return new (0, $51W2Z.OnDemandEmojiResource)({
        ...emojiConfig,
        options: {
            onlyFetchOnDemand: true
        },
        singleEmojiApi: {
            getUrl: ({ id: id, shortName: shortName })=>`${$dc26b22176754e2e$export$ca6dda5263526f75}/${cloudId}/${encodeURIComponent(id ?? shortName)}`
        }
    });
    return new EmojiResource(emojiConfig);
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return emojiResource.getEmojiProvider();
    } catch (err) {
        return Promise.resolve(undefined);
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
const $dc26b22176754e2e$export$b263a0680b18512c = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((EmojiResource, extraConfig)=>{
    try {
        const emojiResource = $dc26b22176754e2e$export$9e6d4bd03aadcea5(EmojiResource, extraConfig);
        return new (0, $bwAnG.EmojiNodeDataProvider)(emojiResource);
    } catch (err) {
        return undefined;
    }
}, $dc26b22176754e2e$export$1504d130127dbc5f);
module.exports["getEmojiConfig"] = $dc26b22176754e2e$export$240be4f98742fdda;
module.exports["getEmojiProvider"] = $dc26b22176754e2e$export$8210f5f78c0bcf27;
module.exports["getEmojiNodeDataProvider"] = $dc26b22176754e2e$export$b263a0680b18512c;

});

parcelRegister("bwAnG", function(module, exports) {

var $4iudd = parcelRequire("4iudd");


var $l4yrE = parcelRequire("l4yrE");


var $drRzc = parcelRequire("drRzc");

class $dfb1108de4ce4e19$export$67106c51beb59865 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return node.type === 'emoji';
    }
    nodeDataKey(node) {
        return node.attrs.id || node.attrs.shortName;
    }
    /**
   * Implementing different re-fetching strategy for emoji.
   *
   * Default strategy for NodeDataProvider is to:
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   * 4. Re-render node with fresh data.
   *
   * This is similar, but doesn't update the node.
   * 1. If entry is in cache = return from cache
   * 2. Re-fetch data.
   * 3. Update cache
   */ getData(node, callback) {
        const cached = this.getNodeDataFromCache(node);
        if (cached?.data) {
            callback(cached);
            if (!(0, $4iudd.isSSR)() && typeof requestAnimationFrame !== 'undefined') requestAnimationFrame(()=>void this.getDataAsync(node, ()=>{}));
        } else this.getDataAsync(node, callback);
    }
    async fetchNodesData(nodes) {
        // If we have an `optimisticImageApi`, use it to generate a URL immediately.
        // This is how emojis are server-side rendered in Confluence.
        // Without this, the emoji server response will hit timeout on SSR and the emoji will not be rendered.
        //
        // We are using this optimization only in SSR because on client side we need to know a valid emoji size
        // which is not possible to get from optimisticImageApi.
        //
        // Check platform/packages/editor/renderer/src/react/nodes/emoji.tsx
        // and platform/packages/elements/emoji/src/components/common/ResourcedEmojiComponent.tsx
        const getOptimisticImageUrl = this.emojiResource.emojiProviderConfig.optimisticImageApi?.getUrl;
        if ((0, $4iudd.isSSR)() && getOptimisticImageUrl) return nodes.map((node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            const optimisticImageURL = getOptimisticImageUrl(emojiId);
            return {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text,
                representation: {
                    height: (0, $l4yrE.defaultEmojiHeight),
                    width: (0, $l4yrE.defaultEmojiHeight),
                    imagePath: optimisticImageURL
                },
                searchable: true,
                // Type and category are unknown at this point.
                // It's not a big deal, because EmojiNodeView doesn't use them.
                type: '',
                category: ''
            };
        });
        // This is slower path because during access to emojiProvider emojiResource
        // makes a request to fetch all emojis.
        const emojiProvider = await this.emojiProvider;
        const fetches = nodes.map(async (node)=>{
            const emojiId = {
                id: node.attrs.id,
                shortName: node.attrs.shortName,
                fallback: node.attrs.text
            };
            // This usually fast because the emojiProvider already has all emojis fetched.
            const result = await emojiProvider.fetchByEmojiId(emojiId, true);
            // If we have optimisticImageApi, we need to path response and set URL from it to match the URL used in SSR.
            if (getOptimisticImageUrl && result) {
                const optimisticImageURL = getOptimisticImageUrl(emojiId);
                if (result.representation && 'imagePath' in result.representation) return {
                    ...result,
                    representation: {
                        ...result.representation,
                        imagePath: optimisticImageURL
                    }
                };
            }
            return result;
        });
        return Promise.all(fetches);
    }
    constructor(resource){
        super();
        this.name = 'emojiNodeDataProvider';
        this.emojiResource = void 0;
        this.emojiProvider = void 0;
        this.emojiResource = resource;
        this.emojiProvider = resource.getEmojiProvider();
    }
}
module.exports["EmojiNodeDataProvider"] = $dfb1108de4ce4e19$export$67106c51beb59865;

});

parcelRegister("drRzc", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

class $27efd3461a9c6d27$export$1185db7a00c13eed {
    /**
   * Sets the SSR data for the provider.
   * This pre-populates the cache with data rendered on the server, preventing redundant network requests on the client.
   * Calling this method will invalidate the existing cache.
   *
   * @example
   * ```
   * const ssrData = window.__SSR_NODE_DATA__ || {};
   * nodeDataProvider.setSSRData(ssrData);
   * ```
   *
   * @param ssrData A map of node data keys to their corresponding data.
   */ setSSRData(ssrData = {}) {
        this.updateCache(ssrData, {
            strategy: 'replace',
            source: 'ssr'
        });
    }
    /**
   * Clears all cached data.
   * This increments the internal cache version, invalidating any pending network requests.
   *
   * @example
   * ```
   * function useMyNodeDataProvider(contentId: string) {
   *  const nodeDataProvider = new MyNodeDataProvider();
   *
   *  // Reset the cache when the contentId changes (e.g., when the user navigates to a different page).
   *  useEffect(() => {
   *    nodeDataProvider.resetCache();
   *  }, [contentId]);
   *
   *  return nodeDataProvider;
   * }
   * ```
   */ resetCache() {
        this.cacheVersion++;
        this.cache = {};
    }
    /**
   * Fetches data for a given node using a cache-first-then-network strategy.
   *
   * The provided callback may be called multiple times:
   * 1. Immediately with data from the SSR cache, if available.
   * 2. Asynchronously with data fetched from the network.
   *
   * @example
   * ```
   * const nodeDataProvider = new MyNodeDataProvider();
   *
   * nodeDataProvider.getData(node, (data) => {
   * 	console.log('Node data:', data);
   * });
   * ```
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @param callback The callback function to call with the fetched data or an error.
   */ getData(node, callback) {
        // Move implementation to a separate async method
        // to keep this method synchronous and avoid async/await in the public API.
        this.getDataAsync(node, callback);
    }
    async getDataAsync(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        const dataFromCache = this.cache[dataKey];
        if (dataFromCache !== undefined) // If we have the data in the SSR data, we can use it directly
        callback({
            data: dataFromCache.data
        });
        if ((0, $4iudd.isSSR)()) // During SSR, we only use the cache and never fetch from the network.
        // Use loading state instead.
        return;
        // If no data is available in the cache, or the data is from the network,
        // we need to fetch it from the network.
        if (dataFromCache?.source !== 'network') {
            // Store the current cache version before making the request,
            // so we can check if the cache has changed while we are waiting for the network response.
            const cacheVersionBeforeRequest = this.cacheVersion;
            // Create a unique key for the in-flight network request
            // based on the cache version and the data key.
            const networkRequestInFlightKey = `${cacheVersionBeforeRequest}-${dataKey}`;
            // Check if there is already a network request in flight for this data
            // to avoid duplicate requests.
            const networkRequestInFlight = this.networkRequestsInFlight[networkRequestInFlightKey];
            if (networkRequestInFlight) {
                try {
                    const data = await networkRequestInFlight;
                    callback({
                        data: data
                    });
                } catch (error) {
                    callback({
                        error: error instanceof Error ? error : new Error(String(error))
                    });
                }
                return;
            }
            try {
                const dataPromise = this.fetchNodesData([
                    jsonNode
                ]).then(([value])=>value);
                // Store the promise in the in-flight requests map
                this.networkRequestsInFlight[networkRequestInFlightKey] = dataPromise;
                const data = await dataPromise;
                // We need to call the callback with the data with result even if the cache version has changed,
                // so all promises that are waiting for the data can resolve.
                callback({
                    data: data
                });
                // If the cache version has changed, we don't want to use the data from the network
                // because it could be stale data.
                if (cacheVersionBeforeRequest === this.cacheVersion) // Replace promise with the resolved data in the cache
                this.updateCache({
                    [dataKey]: data
                }, {
                    strategy: 'merge',
                    source: 'network'
                });
            } catch (error) {
                // If an error occurs, we call the callback with the error
                callback({
                    error: error instanceof Error ? error : new Error(String(error))
                });
            } finally{
                // Ensure we clean up the in-flight request entry
                delete this.networkRequestsInFlight[networkRequestInFlightKey];
            }
        }
    }
    /**
   * Fetches data for a given node and returns it as a Promise.
   * This is a convenience wrapper around the `data` method for use with async/await.
   *
   * Note: This promise resolves with the *first* available data, which could be from the SSR cache or the network.
   * It may not provide the most up-to-date data if a network fetch is in progress.
   *
   * Note: This method is only for migration purposes. Use {@link getData} in new code instead.
   *
   * @private
   * @deprecated Don't use this method, use {@link getData} method instead.
   *             This method is only for migration purposes.
   *
   * @param node The node (or its ProseMirror representation) for which to fetch data.
   * @returns A promise that resolves with the node's data.
   */ getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS(node) {
        return new Promise((resolve, reject)=>{
            try {
                this.getData(node, (payload)=>{
                    if (payload.error) reject(payload.error);
                    else resolve(payload.data);
                });
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Checks the cache for the given node and returns its status.
   *
   * Possible return values:
   * - `false`: No cached data found for the node.
   * - `'ssr'`: Data is cached from server-side rendering (SSR).
   * - `'network'`: Data is cached from a network request.
   *
   * @param node The node (or its ProseMirror representation) to check in the cache.
   * @returns The cache status: `false`, `'ssr'`, or `'network'`.
   */ getCacheStatusForNode(node) {
        const dataFromCache = this.getNodeDataFromCache(node);
        return dataFromCache ? dataFromCache.source : false;
    }
    /**
   * Retrieves the cached data for a given node, if available.
   *
   * @param node The node (or its ProseMirror representation) for which to retrieve cached data.
   * @returns The cached data object containing `data` and `source`, or `undefined` if no cache entry exists.
   */ getNodeDataFromCache(node) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) {
            // eslint-disable-next-line no-console
            console.error(`The ${this.constructor.name} doesn't support Node ${jsonNode.type}.`);
            return undefined;
        }
        const dataKey = this.nodeDataKey(jsonNode);
        return this.cache[dataKey];
    }
    /**
   * Returns the keys of the cache.
   *
   * @returns An array of the keys of the cache.
   */ getNodeDataCacheKeys() {
        return Object.keys(this.cache);
    }
    /**
   * Updates the cache with new records using merge or replace strategies.
   * This method should be the only way to modify the cache directly.
   * This allow subclasses to use it when needed. e.g. abstract fetchNodesData implementation.
   *
   * @example
   * ```
   * const newRecords = {
   *   'node-id-1': { value: 'updated data' },
   *   'node-id-3': { value: 'new data' }
   * };
   * nodeDataProvider.updateCache(newRecords, { strategy: 'merge', source: 'network' });
   * ```
   *
   * Supports two strategies:
   * - 'merge' (default): Merges new records into the existing cache.
   * - 'replace': Replaces the entire cache with the new records, invalidating any in-flight requests.
   *
   * @param records A map of node data keys to their corresponding data.
   * @param options Optional settings for the update operation.
   * @param options.strategy The strategy to use for updating the cache ('merge' or 'replace'). Defaults to 'merge'.
   * @param options.source The source of the data being added ('ssr' or 'network'). Defaults to 'network'.
   */ updateCache(records = {}, options) {
        const strategy = options?.strategy ?? 'merge';
        const source = options?.source ?? 'network';
        if (strategy === 'merge') {
            for (const [key, data] of Object.entries(records))this.cache[key] = {
                data: data,
                source: source
            };
            return;
        } else if (strategy === 'replace') {
            // Replace the entire cache with the new records
            // This will increase the cache version to invalidate any in-flight requests
            this.resetCache();
            this.cache = Object.fromEntries(Object.entries(records).map(([key, data])=>[
                    key,
                    {
                        data: data,
                        source: source
                    }
                ]));
        }
    }
    /**
   * Removes one or more entries from the cache.
   *
   * @param keys A single data key or array of data keys to remove from the cache.
   */ removeFromCache(keys) {
        keys.forEach((key)=>{
            delete this.cache[key];
        });
    }
    constructor(){
        this.cacheVersion = void 0;
        this.cache = void 0;
        this.networkRequestsInFlight = void 0;
        /**
     * A unique name for the provider. Used for identification in SSR.
     */ this.name = void 0;
        this.cacheVersion = 0;
        this.cache = {};
        this.networkRequestsInFlight = {};
    }
}
module.exports["NodeDataProvider"] = $27efd3461a9c6d27$export$1185db7a00c13eed;

});

parcelRegister("51W2Z", function(module, exports) {

var $ez25d = parcelRequire("ez25d");


var $kwzZh = parcelRequire("kwzZh");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");

// requestService rejects a non-ok response with `{ code: status, reason }`.
const $20b5b351e69bef6e$var$getResponseStatus = (error)=>typeof error === 'object' && error !== null && 'code' in error ? error.code : undefined;
const $20b5b351e69bef6e$var$isNotFoundError = (error)=>$20b5b351e69bef6e$var$getResponseStatus(error) === 404;
const $20b5b351e69bef6e$var$reportRepositoryFallback = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error instanceof Error ? error : new Error(`Single-emoji request failed with status ${$20b5b351e69bef6e$var$getResponseStatus(error)}`), {
        attribution: (0, $3IBnw.Attribution).PAGE_EXPERIENCES
    });
};
const $20b5b351e69bef6e$var$isMediaRepresentation = (representation)=>!!representation && 'mediaPath' in representation;
class $20b5b351e69bef6e$export$cfbb91621ad16c67 extends (0, $kwzZh.default) {
    // filter() reports "not ready" without waiting, so it has to start the fetch itself. The fetch
    // re-runs the last filter when it completes.
    filter(query, options) {
        this.startRepositoryFetch();
        super.filter(query, options);
    }
    async fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder) {
        const { singleEmojiApi: singleEmojiApi } = this.emojiProviderConfig;
        if (!singleEmojiApi || !emojiId.id || this.isRepositoryLoaded()) return super.fetchByEmojiId(emojiId, optimistic, emojiProviderLookupOrder);
        // Emoji ids never contain a slash, but page icons can be URLs, such as a favicon. No emoji list
        // has them, and the single-emoji endpoint rejects them, which would download the repository.
        if (emojiId.id.includes('/') || this.notFoundEmojiIds.has(emojiId.id)) return undefined;
        // This request replaces the base class's optimistic one, which swallows the response status.
        const provider = {
            url: singleEmojiApi.getUrl(emojiId),
            securityProvider: singleEmojiApi.securityProvider
        };
        let response;
        try {
            response = await new (0, $ez25d.default)(provider).loadEmoji();
        } catch (error) {
            // Deleted custom emoji return 404 here and are missing from the repository too, so
            // downloading the repository could not find them.
            if ($20b5b351e69bef6e$var$isNotFoundError(error)) {
                this.notFoundEmojiIds.add(emojiId.id);
                return undefined;
            }
            $20b5b351e69bef6e$var$reportRepositoryFallback(error);
        }
        const emoji = response?.emojis[0];
        if (response && emoji) try {
            if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(response, provider);
            return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        } catch (error) {
            $20b5b351e69bef6e$var$reportRepositoryFallback(error);
        }
        // With `optimistic` false, the base class waits for the repository, and retryIfLoading starts
        // downloading it.
        return super.fetchByEmojiId(emojiId, false, emojiProviderLookupOrder);
    }
    findById(id) {
        if (!this.emojiProviderConfig.singleEmojiApi || this.isRepositoryLoaded()) return super.findById(id);
        return this.fetchByEmojiId({
            id: id,
            shortName: ''
        }, true);
    }
    retryIfLoading(retry, defaultResponse) {
        this.startRepositoryFetch();
        return super.retryIfLoading(retry, defaultResponse);
    }
    // The single-emoji response can be the first to carry a media token. SiteEmojiResource keeps the
    // URL it is created with for uploads, deletes and token refreshes, so it must get the site provider
    // rather than the single-emoji URL. The base class primes the resource with the first emoji, which
    // throws for a standard or Atlassian emoji and makes the lookup fall back to the repository, so only
    // media emoji are passed on.
    initSiteEmojiResource(emojiResponse, provider) {
        const siteProvider = this.emojiProviderConfig.providers.find(({ url: url })=>url.endsWith('/site'));
        return super.initSiteEmojiResource({
            ...emojiResponse,
            emojis: emojiResponse.emojis.filter(({ representation: representation })=>$20b5b351e69bef6e$var$isMediaRepresentation(representation))
        }, siteProvider ?? provider);
    }
    isRepositoryLoaded() {
        return !!this.emojiRepository && this.initialLoaders !== 0 && this.activeLoaders === 0;
    }
    startRepositoryFetch() {
        if (!this.isInitialised) // Failures are reported through notifyError and the pending retries.
        this.fetchEmojiProvider().catch(()=>{});
    }
    constructor(...args){
        super(...args);
        this.notFoundEmojiIds = new Set();
    }
}
module.exports["OnDemandEmojiResource"] = $20b5b351e69bef6e$export$cfbb91621ad16c67;

});

parcelRegister("8dbvt", function(module, exports) {

var $cxMI6 = parcelRequire("cxMI6");

const $d8f8e39152f0bc27$export$19f6fc45ac74736 = (data, strategiesCounter)=>{
    const pageCardData = (0, $cxMI6.transformGlobalContent)(data.content);
    pageCardData.likesCount = 0;
    pageCardData.commentsCount = 0;
    pageCardData.recommendationStrategy = $d8f8e39152f0bc27$export$7c50bf2d337b5c51(data, strategiesCounter);
    return pageCardData;
};
const $d8f8e39152f0bc27$export$7c50bf2d337b5c51 = (data, strategiesCounter)=>{
    const strategies = data.strategy;
    if (strategies.includes('CONTENT_TO_CONTENT')) return 'CONTENT_TO_CONTENT';
    const currentCounter = new Map();
    strategies.forEach((entry)=>{
        const entryCount = strategiesCounter.get(entry) || 0;
        currentCounter.set(entry, entryCount);
    });
    const sortedCounter = new Map([
        ...currentCounter.entries()
    ].sort((a, b)=>a[1] - b[1]));
    const strategy = [
        ...sortedCounter.keys()
    ][0];
    const count = strategiesCounter.get(strategy) || 0;
    strategiesCounter.set(strategy, count + 1);
    return strategy;
};
const $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7 = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>$d8f8e39152f0bc27$export$19f6fc45ac74736(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const contentId = rec?.content?.id;
        if (!contentId) return;
        const el = transformedRecs.find((card)=>card?.id === contentId);
        if (el) pageCards.push(el);
    });
    return pageCards;
};
module.exports["transformEndOfPageRecContent"] = $d8f8e39152f0bc27$export$19f6fc45ac74736;
module.exports["transformAndOrderRecs"] = $d8f8e39152f0bc27$export$9c80c5ff7d0b31d7;

});

parcelRegister("cxMI6", function(module, exports) {

var $brn6e = parcelRequire("brn6e");


var $8rneB = parcelRequire("8rneB");


var $huWyw = parcelRequire("huWyw");


var $c7GB4 = parcelRequire("c7GB4");

const $c6273926c8df4325$var$ALL_CONTENT_TYPE = [
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'embed',
    'folder',
    'slide'
];
const $c6273926c8df4325$var$resumeDraftWebUiBypass = (urlPath, content)=>{
    const bypassUrl = (0, $huWyw.getURLBypassingResumeDraftAction)({
        url: urlPath || '',
        spaceKey: content?.space?.alias || content?.space?.key || '',
        contentType: content?.type,
        editorVersion: content?.editorVersion?.nodes?.[0]?.value?.replace(/['"]+/g, ''),
        contentId: content?.id || '',
        noContextPath: true
    });
    return bypassUrl;
};
const $c6273926c8df4325$export$a0bd4958aceee288 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent)=>{
    const EMOJI_CONTENT_TYPE = isWhiteboardEmojiFGEnabled ? [
        'page',
        'blogpost',
        'embed',
        'whiteboard',
        'slide'
    ] : [
        'page',
        'blogpost',
        'embed'
    ];
    const contentType = $c6273926c8df4325$var$ALL_CONTENT_TYPE.includes(content?.type) ? content.type : 'page';
    if (isActivityV3HomeRecent) return {
        id: (0, $c7GB4.getIdFromConfluenceContentAri)({
            ari: content?.id,
            resourceType: contentType
        }) || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, content?.metadata?.titleEmojiPublished?.value || '', content?.metadata?.titleEmojiDraft?.value || '', content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subtype,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editUi, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webUi, content)
        },
        isStarred: content?.viewer?.favoritedSummary?.isFavorite || false,
        likesCount: content?.likesSummary?.count || 0,
        commentsCount: content?.commentCountSummary?.total || 0,
        excerpt: content?.body?.excerpt?.trim()
    };
    return {
        id: content?.id || '',
        status: content?.status === 'draft' || content?.status === 'unpublished' ? content?.status : undefined,
        // @ts-expect-error TODO FIXME there is some deep null mismatch, which might be worth fixing
        title: (0, $brn6e.getTitleAndEmoji)(content?.title, (0, $8rneB.getEmojiPublishedFromProperties)(content), (0, $8rneB.getEmojiDraftFromProperties)(content), content?.status, untitledDraftText, EMOJI_CONTENT_TYPE.includes(contentType)),
        type: contentType,
        subType: content?.subType,
        editorVersion: content?.editorVersion,
        links: {
            editui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.editui, content),
            webui: $c6273926c8df4325$var$resumeDraftWebUiBypass(content?.links?.webui, content)
        },
        isStarred: content?.metadata?.currentuser?.favourited?.isFavourite || false,
        likesCount: content?.likes?.count || 0,
        commentsCount: content?.metadata?.comments?.commentsCount || 0,
        excerpt: content?.excerpt?.trim(),
        lastAction: {
            when: content?.metadata?.lastModifiedDate || '',
            action: 'updated'
        }
    };
};
const $c6273926c8df4325$export$898674fde3fd0597 = (content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent = false)=>{
    const spaceAlias = content?.space?.alias || content?.space?.key;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled, isActivityV3HomeRecent),
        space: {
            spaceKey: spaceAlias || '',
            name: content?.space?.name || ''
        },
        creatorId: content?.creatorId || '',
        history: {
            ownedBy: {
                displayName: content?.history?.ownedBy?.displayName || ''
            }
        }
    };
};
const $c6273926c8df4325$export$2f107dce00257aca = ({ id: id, title: title, url: url, providerName: providerName })=>({
        id: id,
        title: {
            text: title,
            emoji: ''
        },
        // Unused: the items show 3P cards by `thirdParty` instead
        type: 'page',
        subType: null,
        lastAction: {},
        isStarred: false,
        links: {
            webui: '',
            editui: ''
        },
        likesCount: 0,
        commentsCount: 0,
        space: {
            spaceKey: '',
            name: providerName
        },
        creatorId: '',
        history: {
            ownedBy: {
                displayName: ''
            }
        },
        thirdParty: {
            url: url
        }
    });
const $c6273926c8df4325$export$1e1d4cb60561af2b = (content, untitledDraftText = '', isWhiteboardEmojiFGEnabled = false)=>{
    const createdBy = content?.status === 'draft' ? content?.version?.by : content?.history?.createdBy;
    const ownedBy = content?.status === 'draft' ? content?.version?.by : content?.history?.ownedBy;
    return {
        ...$c6273926c8df4325$export$a0bd4958aceee288(content, untitledDraftText, isWhiteboardEmojiFGEnabled),
        createdBy: {
            displayName: createdBy?.displayName || '',
            profilePicture: createdBy?.profilePicture?.path || '',
            accountId: createdBy?.accountId || ''
        },
        ownedBy: {
            displayName: ownedBy?.displayName || '',
            profilePicture: ownedBy?.profilePicture?.path || '',
            accountId: ownedBy?.accountId || ''
        }
    };
};
const $c6273926c8df4325$export$ee67d5d6f48183b0 = (card)=>Boolean(card.createdBy);
module.exports["transformGlobalContent"] = $c6273926c8df4325$export$898674fde3fd0597;
module.exports["transformThirdPartyContent"] = $c6273926c8df4325$export$2f107dce00257aca;
module.exports["transformSpaceContent"] = $c6273926c8df4325$export$1e1d4cb60561af2b;
module.exports["isSpacePageCard"] = $c6273926c8df4325$export$ee67d5d6f48183b0;

});

parcelRegister("brn6e", function(module, exports) {

var $g6QPm = parcelRequire("g6QPm");


var $7PLO8 = parcelRequire("7PLO8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $6mKj3 = parcelRequire("6mKj3");


var $3shHM = parcelRequire("3shHM");


var $41Hff = parcelRequire("41Hff");


var $8rneB = parcelRequire("8rneB");


var $5DJsZ = parcelRequire("5DJsZ");


var $5amrO = parcelRequire("5amrO");

const $a7a7184e7345058e$export$8807f1cb55bf77de = async ({ userId: userId, cloudId: cloudId, emojiId: emojiId })=>{
    const provider = await (0, $8rneB.getEmojiProvider)(cloudId, userId);
    if (provider) {
        const emoji = await provider.findById(emojiId);
        if (emoji) return provider.loadMediaEmoji(emoji);
    }
    return Promise.resolve(null);
};
const $a7a7184e7345058e$export$66e71aac8865f81a = /([a-z\d_-]+):/;
let $a7a7184e7345058e$var$hasSetFavicon = false;
let $a7a7184e7345058e$var$previousFavicon = null;
const $a7a7184e7345058e$var$updateFaviconHref = (href)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const favIcons = document.querySelectorAll("link[rel~='icon']");
    favIcons.forEach((linkEl)=>{
        // remember default favicon on first change in case we need to revert
        if (!$a7a7184e7345058e$var$hasSetFavicon) {
            $a7a7184e7345058e$var$previousFavicon = linkEl.href;
            $a7a7184e7345058e$var$hasSetFavicon = true;
        }
        linkEl.href = href;
    });
};
const $a7a7184e7345058e$export$4bb2c221b7e4cc0 = (emoji)=>{
    if (!(0, $6mKj3.isExperimentEnabled)('confluence_expt_emoji_title_favicon')) return;
    if (!emoji) {
        if ($a7a7184e7345058e$var$hasSetFavicon && $a7a7184e7345058e$var$previousFavicon) $a7a7184e7345058e$var$updateFaviconHref($a7a7184e7345058e$var$previousFavicon);
        return;
    }
    $a7a7184e7345058e$var$updateFaviconHref(emoji);
};
const $a7a7184e7345058e$export$ea48fb6f63107646 = async ({ selectedEmoji: selectedEmoji, emojiProvider: emojiProvider, onUpdateStartEmoji: onUpdateStartEmoji, createAnalyticsEvent: createAnalyticsEvent, emojiTitleState: emojiTitleState, onEmojiUpdated: onEmojiUpdated, onUpdateEndEmoji: onUpdateEndEmoji, updateContentProperty: updateContentProperty, contentId: contentId, componentName: componentName, isLivePage: isLivePage, emojiStatusFieldName: emojiStatusFieldName, aiSuggestedEmojiId: aiSuggestedEmojiId, isSmartCreate: isSmartCreate, hasReplacedAIFCEmoji: hasReplacedAIFCEmoji, setHasReplacedAIFCEmoji: setHasReplacedAIFCEmoji, aiEmojiSuggestionSource: aiEmojiSuggestionSource }, _event)=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    // Snapshot before overwrite to detect if the AIFC-suggested emoji was replaced.
    const previouslySelectedEmoji = emojiTitleState.state.selectedEmoji;
    const previouslySelectedEmojiId = typeof previouslySelectedEmoji === 'string' ? previouslySelectedEmoji : previouslySelectedEmoji?.id;
    const replacedAIFCSuggestedEmoji = !hasReplacedAIFCEmoji && !!isSmartCreate && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedAIFCSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedBlankPageAutoSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'pasteAutoTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedBlankPageAutoSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    const replacedSuggestTitleSuggestedEmoji = !hasReplacedAIFCEmoji && aiEmojiSuggestionSource === 'suggestTitle' && !!aiSuggestedEmojiId && previouslySelectedEmojiId === aiSuggestedEmojiId;
    if (replacedSuggestTitleSuggestedEmoji) setHasReplacedAIFCEmoji?.(true);
    // Snapshot the shared flag at fire time so the value reflects the latest
    // state regardless of when/where the picker JSX was created.
    const justRestoredEmoji = !!emojiTitleState.justRestoredEmoji;
    (0, $3shHM.sendAnalyticsEvent)(createAnalyticsEvent, {
        eventType: 'sendUIEvent',
        element: 'button',
        action: 'clicked',
        actionSubject: 'emojiPicker',
        actionSubjectId: 'emoji',
        attributes: {
            emojiId: selectedEmoji?.id,
            inputMethod: 'title',
            isLivePage: isLivePage,
            replacedAIFCSuggestedEmoji: replacedAIFCSuggestedEmoji,
            replacedBlankPageAutoSuggestedEmoji: replacedBlankPageAutoSuggestedEmoji,
            replacedSuggestTitleSuggestedEmoji: replacedSuggestTitleSuggestedEmoji,
            aiEmojiSuggestionSource: aiEmojiSuggestionSource,
            isRestoreLatestEmojiEnabled: (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji'),
            replacedRestoredEmoji: justRestoredEmoji
        }
    });
    // Reset after firing so the next selection correctly reports
    // replacedRestoredEmoji=false.
    emojiTitleState.justRestoredEmoji = false;
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    const loadedEmoji = await emojiProvider.loadMediaEmoji(selectedEmoji, true);
    emojiTitleState.setOpenSecondEmojiPicker(false);
    emojiTitleState.setSelectedEmoji(loadedEmoji);
    return onEmojiUpdated().then(({ data: data })=>{
        const versionNumber = (0, $8rneB.getVersionNumber)(data, emojiStatusFieldName);
        const newVersionNumber = versionNumber ? versionNumber + 1 : 1;
        const emojiValue = selectedEmoji?.id?.replace(/['"]+/g, '') ?? '';
        return updateContentProperty({
            propertyKey: propertyKey,
            propertyValue: emojiValue,
            hasExistingProperty: versionNumber > 0,
            options: {
                update: ()=>{
                    try {
                        const cacheData = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
                                ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                                    contentId: contentId,
                                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                }),
                                skipPublishedFragment: true
                            } : {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
                                skipPublishedFragment: true
                            },
                            __callerPackage__: "emoji-title"
                        });
                        if (cacheData.content.nodes[0][emojiStatusFieldName]) cacheData.content.nodes[0][emojiStatusFieldName].nodes[0] = {
                            ...cacheData.content.nodes[0][emojiStatusFieldName].nodes[0],
                            id: contentId,
                            key: propertyKey,
                            value: emojiValue,
                            version: {
                                number: newVersionNumber,
                                __typename: 'Version'
                            }
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
                                ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                                    contentId: contentId,
                                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                }),
                                skipPublishedFragment: true
                            } : {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
                                skipPublishedFragment: true
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating ${propertyKey} content property after user selecting emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).then(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
            emojiTitleState.setSelectedEmoji(loadedEmoji);
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user selecting emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$fbfb144f0da80edc = (_event, { onUpdateStartEmoji: onUpdateStartEmoji, onUpdateEndEmoji: onUpdateEndEmoji, onEmojiUpdated: onEmojiUpdated, contentId: contentId, updateContentProperty: updateContentProperty, componentName: componentName = '', emojiStatusFieldName: emojiStatusFieldName })=>{
    onUpdateStartEmoji && onUpdateStartEmoji();
    const propertyKey = (0, $5amrO.convertEmojiFieldNameToPropertyKey)(emojiStatusFieldName);
    return onEmojiUpdated().then(()=>{
        return updateContentProperty({
            propertyKey: propertyKey,
            isDelete: true,
            options: {
                update: ()=>{
                    try {
                        const data = (0, $l1uFv.readQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
                                ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                                    contentId: contentId,
                                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                }),
                                skipPublishedFragment: true
                            } : {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
                                skipPublishedFragment: true
                            },
                            __callerPackage__: "emoji-title"
                        });
                        data.content.nodes[0][emojiStatusFieldName] = {
                            nodes: [],
                            __typename: 'PaginatedJsonContentPropertyList'
                        };
                        (0, $fEmGS.writeQueryInterop)({
                            query: (0, $5DJsZ.default),
                            variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
                                ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                                    contentId: contentId,
                                    draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
                                }),
                                skipPublishedFragment: true
                            } : {
                                contentId: contentId,
                                status: [
                                    'current',
                                    'draft'
                                ],
                                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)(),
                                skipPublishedFragment: true
                            },
                            data: data,
                            __callerPackage__: "emoji-title"
                        });
                    } catch (error) {
                        throw new Error(`${componentName} failed to write to cache while updating content property after user removing emoji ${error.message}`);
                    }
                }
            },
            shouldOptimisticResponse: true
        }).finally(()=>{
            onUpdateEndEmoji && onUpdateEndEmoji();
        }).catch((error)=>{
            throw new Error(`${componentName} failed to update ${propertyKey} content property after user removing emoji ${error.message}`);
        });
    });
};
const $a7a7184e7345058e$export$8c0236acf4c550c0 = RegExp("^(\\p{RI}\\p{RI}|\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?(\\u{200D}\\p{Extended_Pictographic}(\\p{Emoji_Modifier}|\\u{FE0F}\\u{20E3}?|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?)*)", "u");
const $a7a7184e7345058e$export$598d52cdacf3cab2 = ()=>(0, $41Hff.pinnedEmojiExp);
const $a7a7184e7345058e$export$cb9bb843138d9261 = (title)=>title && title.replace($a7a7184e7345058e$export$598d52cdacf3cab2(), '').trimLeft() || '';
const $a7a7184e7345058e$export$9d1875ac2476f6b6 = (title)=>title && $a7a7184e7345058e$export$598d52cdacf3cab2().exec(title)?.[0] || '';
const $a7a7184e7345058e$export$388f90f8e727e4d5 = (rawTitle = '', rawPublishedEmoji = '', rawDraftEmoji = '', status = '', untitledDraftText = '', getEmoji = true)=>{
    const nativeEmoji = getEmoji ? $a7a7184e7345058e$export$9d1875ac2476f6b6(rawTitle) : '';
    let selectedEmoji = '';
    if (getEmoji) selectedEmoji = status?.toLowerCase() === 'draft' ? rawDraftEmoji : rawPublishedEmoji;
    const hasNativeEmoji = nativeEmoji.length > 0;
    const hasSelectedEmoji = selectedEmoji.length > 0;
    const emoji = hasSelectedEmoji ? selectedEmoji : nativeEmoji;
    let text = hasNativeEmoji && !hasSelectedEmoji ? $a7a7184e7345058e$export$cb9bb843138d9261(rawTitle) : rawTitle;
    if (status === 'draft' && !text) text = untitledDraftText;
    return {
        text: text,
        emoji: emoji,
        selectedEmoji: selectedEmoji
    };
};
module.exports["getEmojiFromEmojiId"] = $a7a7184e7345058e$export$8807f1cb55bf77de;
module.exports["maybeOverrideFaviconWithEmoji"] = $a7a7184e7345058e$export$4bb2c221b7e4cc0;
module.exports["onSelectEmoji"] = $a7a7184e7345058e$export$ea48fb6f63107646;
module.exports["onRemoveEmoji"] = $a7a7184e7345058e$export$fbfb144f0da80edc;
module.exports["getEmojiExp"] = $a7a7184e7345058e$export$598d52cdacf3cab2;
module.exports["removeEmojiFromTitle"] = $a7a7184e7345058e$export$cb9bb843138d9261;
module.exports["getEmojiFromTitle"] = $a7a7184e7345058e$export$9d1875ac2476f6b6;
module.exports["getTitleAndEmoji"] = $a7a7184e7345058e$export$388f90f8e727e4d5;

});

parcelRegister("l1uFv", function(module, exports) {

var $eqEJl = parcelRequire("eqEJl");


var $jclGA = parcelRequire("jclGA");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $7M67g = parcelRequire("7M67g");

function $65c7b8940c778902$export$627cb922211284f(params) {
    const operationName = (0, $7M67g.getRelayOperationName)(params.query);
    return (0, $iffSy.isRelayEnabled)(params.__callerPackage__, {
        operationName: operationName,
        phase: 'cache'
    }) ? $65c7b8940c778902$var$readQueryInteropRelay(params) : $65c7b8940c778902$var$readQueryInteropApollo(params);
}
function $65c7b8940c778902$var$readQueryInteropRelay(params) {
    const relayEnv = typeof window !== 'undefined' ? window.GLOBAL_RELAY_ENV : undefined;
    if (!relayEnv) throw new Error(`[Relay migration] Missing GLOBAL_RELAY_ENV for readQueryInterop; ${params.__callerPackage__}.`);
    const queryNode = params.query;
    if (!queryNode?.fragment || !queryNode?.operation) return null;
    const variables = params.variables ?? {};
    const operation = (0, $eqEJl.createOperationDescriptor)(queryNode, variables);
    const snapshot = relayEnv.lookup(operation.fragment);
    return snapshot.isMissingData ? null : (0, $jclGA.cloneRelayQueryResult)(snapshot.data);
}
function $65c7b8940c778902$var$readQueryInteropApollo(params) {
    return window['GLOBAL_APOLLO_CLIENT'].readQuery({
        ...params,
        query: (0, $86okN.toDocumentNode)(params.query)
    });
}
module.exports["readQueryInterop"] = $65c7b8940c778902$export$627cb922211284f;

});

parcelRegister("3shHM", function(module, exports) {

var $g6QPm = parcelRequire("g6QPm");


var $6mKj3 = parcelRequire("6mKj3");


var $7PLO8 = parcelRequire("7PLO8");


var $c0rhi = parcelRequire("c0rhi");


var $8rneB = parcelRequire("8rneB");


var $5amrO = parcelRequire("5amrO");


var $5DJsZ = parcelRequire("5DJsZ");

const $d6c558249b167bda$export$5e53520e517ec9ab = (createAnalyticsEvent, { eventType: eventType, element: element, action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes = {} })=>{
    createAnalyticsEvent({
        type: eventType,
        data: {
            action: action,
            source: 'EmojiTitleSection',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                element: element,
                ...attributes
            }
        }
    }).fire();
};
const $d6c558249b167bda$export$1fa99c5c7c4cc530 = async ({ createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isLivePage: isLivePage })=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $5DJsZ.default),
        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
            ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                contentId: contentId,
                draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
            }),
            skipPublishedFragment: false
        } : {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            skipPublishedFragment: false
        },
        __callerPackage__: "emoji-title"
    });
    const emojiId = (0, $8rneB.getEmojiId)(data, (0, $5amrO.EMOJI_TITLE_DRAFT_FIELD));
    const hasDraftEmoji = emojiId.length >= 0 && emojiId !== '';
    // only track draft with emoji
    if (hasDraftEmoji) $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: '',
        action: 'created',
        actionSubject: 'draftWithEmoji',
        actionSubjectId: '',
        attributes: {
            emojiId: emojiId,
            isLivePage: isLivePage
        }
    });
};
const $d6c558249b167bda$export$5a8401d422e6e576 = ({ createAnalyticsEvent: createAnalyticsEvent, emoji: emoji, context: context, error: error = {
    message: ''
}, isLivePage: isLivePage })=>{
    $d6c558249b167bda$export$5e53520e517ec9ab(createAnalyticsEvent, {
        eventType: 'sendTrackEvent',
        element: 'emoji',
        action: 'error',
        actionSubject: 'renderEmoji',
        actionSubjectId: 'renderEmojiError',
        attributes: {
            emojiShortName: emoji && emoji.shortName,
            emojiId: emoji && emoji.id,
            context: context,
            errorMessage: error.message,
            isLivePage: isLivePage
        }
    });
};
module.exports["sendAnalyticsEvent"] = $d6c558249b167bda$export$5e53520e517ec9ab;
module.exports["trackDraftCreatedWithEmoji"] = $d6c558249b167bda$export$1fa99c5c7c4cc530;
module.exports["onFailedToLoadEmoji"] = $d6c558249b167bda$export$5a8401d422e6e576;

});

parcelRegister("8rneB", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");


var $32x2E = parcelRequire("32x2E");


var $5amrO = parcelRequire("5amrO");

const $61659933fe71a4ee$export$d2d37cdca5b73056 = (data, emojiFieldName)=>data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.version?.number || 0;
const $61659933fe71a4ee$export$4f65bc4b6ab2638 = (data, emojiFieldName)=>(data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$7f77dde40cb9b60a = (emojiValue)=>(emojiValue || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$var$transformProperty = (property)=>{
    if (property) return {
        propertyId: property?.id ?? '',
        value: (property?.value || '').replace(/['"]+/g, '').replace(/null/, ''),
        versionNumber: 'version' in property && property.version?.number || 0
    };
};
const $61659933fe71a4ee$var$findPropertyByKey = (object, key)=>$61659933fe71a4ee$var$transformProperty(object?.properties?.nodes?.find((node)=>node?.key === key));
const $61659933fe71a4ee$export$1b37039eb4b94aa5 = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-published');
const $61659933fe71a4ee$export$4d2921b7085d93bb = (object)=>$61659933fe71a4ee$var$findPropertyByKey(object, 'emoji-title-draft');
const $61659933fe71a4ee$export$f6641c501f8a1aee = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$e1cb12562674727b = (page)=>{
    const values = page?.properties?.nodes?.filter((node)=>node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$db0acf1152e62ad6 = (data)=>((data?.content?.nodes?.[0] || data?.singleContent)?.emojiTitlePublished?.nodes?.[0]?.value || '').replace(/['"]+/g, '');
const $61659933fe71a4ee$export$a5b3ff94c918547 = (content)=>(content?.emoji?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$c4fe69c947489b89 = (content)=>(content?.emojiDraft?.nodes?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
const $61659933fe71a4ee$export$bb520a2176fa2873 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-draft');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$fbf43d9e87015d93 = (content)=>{
    const values = content?.emoji?.nodes?.filter((node)=>node && 'key' in node && node?.key === 'emoji-title-published');
    return (values?.[0]?.value || '').replace(/['"]+/g, '').replace(/null/, '');
};
const $61659933fe71a4ee$export$b8852397200defa1 = (data, emojiFieldName)=>{
    let nodes;
    if (data && 'content' in data) nodes = data?.content?.nodes?.[0]?.[emojiFieldName]?.nodes?.[0];
    else nodes = data?.emojiTitlePublished?.nodes?.[0];
    return !!nodes?.value && nodes?.value !== '""' && nodes?.value !== '"null"';
};
const $61659933fe71a4ee$export$496af73e8e85fd08 = (data)=>{
    return $61659933fe71a4ee$export$b8852397200defa1(data, 'emojiTitlePublished');
};
const $61659933fe71a4ee$export$53519180ca077ff2 = (data)=>$61659933fe71a4ee$export$b8852397200defa1(data, (0, $5amrO.EMOJI_TITLE_PUBLISHED_FIELD));
const $61659933fe71a4ee$export$8210f5f78c0bcf27 = async (cloudId, userId)=>{
    return await (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
        cloudId: cloudId,
        userId: userId
    });
};
var $61659933fe71a4ee$export$66d7571a7d7aad65 = /*#__PURE__*/ function(DefaultTitleEmojiValues) {
    DefaultTitleEmojiValues["LIVE_PAGE_DEFAULT"] = "live-page-default";
    DefaultTitleEmojiValues["NONE"] = "none";
    return DefaultTitleEmojiValues;
}({});
const $61659933fe71a4ee$export$efb819bf9c3235c7 = (data)=>{
    if (!data) return false;
    const defaultTitleEmoji = data?.content?.nodes?.[0]?.contentProperties?.latest?.defaultTitleEmoji;
    // This property denotes whether or not we show a default emoji icon, and is initially set to null to avoid backfilling on the BE;
    // therefore, a null value OR a specifically set value implies that we need to show a default icon, while a "none" value implies
    // that we should not show an icon. The default icon should also be overriden by a user-set emoji.
    return defaultTitleEmoji === null || defaultTitleEmoji === "live-page-default";
};
module.exports["getVersionNumber"] = $61659933fe71a4ee$export$d2d37cdca5b73056;
module.exports["getEmojiId"] = $61659933fe71a4ee$export$4f65bc4b6ab2638;
module.exports["sanitizeEmojiValue"] = $61659933fe71a4ee$export$7f77dde40cb9b60a;
module.exports["getEmojiPublishedProperty"] = $61659933fe71a4ee$export$1b37039eb4b94aa5;
module.exports["getEmojiDraftProperty"] = $61659933fe71a4ee$export$4d2921b7085d93bb;
module.exports["getEmojiFromPublishedPageProperties"] = $61659933fe71a4ee$export$f6641c501f8a1aee;
module.exports["getEmojiFromDraftPageProperties"] = $61659933fe71a4ee$export$e1cb12562674727b;
module.exports["getPublishedEmojiId"] = $61659933fe71a4ee$export$db0acf1152e62ad6;
module.exports["getEmojiValueFromContent"] = $61659933fe71a4ee$export$a5b3ff94c918547;
module.exports["getEmojiDraftFromProperties"] = $61659933fe71a4ee$export$bb520a2176fa2873;
module.exports["getEmojiPublishedFromProperties"] = $61659933fe71a4ee$export$fbf43d9e87015d93;
module.exports["getHasEmoji"] = $61659933fe71a4ee$export$b8852397200defa1;
module.exports["doesContentHaveEmojiPublished"] = $61659933fe71a4ee$export$496af73e8e85fd08;
module.exports["getEmojiProvider"] = $61659933fe71a4ee$export$8210f5f78c0bcf27;
module.exports["DefaultTitleEmojiValues"] = $61659933fe71a4ee$export$66d7571a7d7aad65;
module.exports["getHasLiveDocsDefaultEmoji"] = $61659933fe71a4ee$export$efb819bf9c3235c7;

});

parcelRegister("5amrO", function(module, exports) {

var $3jwuS = parcelRequire("3jwuS");


var $99t4P = parcelRequire("99t4P");

const $bb7cbab4663812b3$export$342dc808a4f4a7ab = 'emoji-title-draft';
const $bb7cbab4663812b3$export$97ffb0b9059d248e = 'emoji-title-published';
const $bb7cbab4663812b3$export$5a027b13986198b7 = 'emojiTitleDraft';
const $bb7cbab4663812b3$export$b78a8db8f4546258 = 'emojiTitlePublished';
const $bb7cbab4663812b3$export$61509c1d76ea5fb2 = (contentType)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isWhiteboardEmoji = (0, $99t4P.isEmojiTitleEnabled)(contentType);
    if (isWhiteboardEmoji || isLivePage) return $bb7cbab4663812b3$export$b78a8db8f4546258;
    else return $bb7cbab4663812b3$export$5a027b13986198b7;
};
const $bb7cbab4663812b3$export$28c62f1b367f9166 = (fieldName)=>{
    return fieldName === $bb7cbab4663812b3$export$b78a8db8f4546258 ? $bb7cbab4663812b3$export$97ffb0b9059d248e : $bb7cbab4663812b3$export$342dc808a4f4a7ab;
};
module.exports["EMOJI_TITLE_DRAFT_FIELD"] = $bb7cbab4663812b3$export$5a027b13986198b7;
module.exports["EMOJI_TITLE_PUBLISHED_FIELD"] = $bb7cbab4663812b3$export$b78a8db8f4546258;
module.exports["useEmojiStatusFieldName"] = $bb7cbab4663812b3$export$61509c1d76ea5fb2;
module.exports["convertEmojiFieldNameToPropertyKey"] = $bb7cbab4663812b3$export$28c62f1b367f9166;

});

parcelRegister("99t4P", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $6b4026d31beb25d0$export$f0410e068eb2ef9e = (contentType)=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    return contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
};
module.exports["isEmojiTitleEnabled"] = $6b4026d31beb25d0$export$f0410e068eb2ef9e;

});

parcelRegister("5DJsZ", function(module, exports) {
/**
 * @generated SignedSource<<8b96b7ca504d956e62c9a3c7888eb72c>>
 * @relayHash 736318216100158fedfd1efdb0277723
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6
const $4dc353069380bea7$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipPublishedFragment"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "condition": "skipPublishedFragment",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "emoji-title-published"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                }
                            ]
                        },
                        {
                            "alias": "emojiTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "emoji-title-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v5 /*: any*/ ,
                            "storageKey": "properties(key:\"emoji-title-draft\")"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PublishedContentProperties",
                                    "kind": "LinkedField",
                                    "name": "latest",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "defaultTitleEmoji"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EmojiTitleQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "736318216100158fedfd1efdb0277723",
            "id": "ee7b55ba4a12d84512c880cfd1a46392ff785081052c438befeefd868cef06a6",
            "metadata": {},
            "name": "EmojiTitleQuery",
            "operationKind": "query",
            "text": "query EmojiTitleQuery($contentId:ID,$status:[String],$draftShareId:String,$skipPublishedFragment:Boolean!){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,emojiTitlePublished:properties(key:\"emoji-title-published\")@skip(if:$skipPublishedFragment){nodes{id,key,value,version{number}}},emojiTitleDraft:properties(key:\"emoji-title-draft\"){nodes{id,key,value,version{number}}},contentProperties{latest{defaultTitleEmoji}}}}}"
        }
    };
}();
$4dc353069380bea7$var$node.hash = "c3af19fccb4a5096e4bb34c9aa198098";
var $4dc353069380bea7$export$2e2bcd8739ae039 = $4dc353069380bea7$var$node;
module.exports["default"] = $4dc353069380bea7$export$2e2bcd8739ae039;

});

parcelRegister("41Hff", function(module, exports) {
// Generated from emojiExp with regexpu-core (regenerate-unicode-properties, Unicode 17.0.0).
// Pinned so SSR and browsers agree on Extended_Pictographic regardless of engine Unicode tables.
// Regenerate: rewritePattern(src, "u", { unicodePropertyEscapes: "transform", unicodeFlag: "transform" })
// eslint-disable-next-line no-misleading-character-class
const $365ed100db6a5b65$export$6f5a4567cbce7bde = /^((?:\uD83C[\uDDE6-\uDDFF])(?:\uD83C[\uDDE6-\uDDFF])|(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCCF\uDCD0\uDCF6-\uDCFF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAE-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDE5F\uDE66-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFA]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDEE5\uDEE9\uDEEB-\uDEF0\uDEF3-\uDEFF\uDFDA-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCBC-\uDCBF\uDCC2-\uDCCF\uDCD9-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE58-\uDE5F\uDE6E-\uDEFF]|\uD83F[\uDC00-\uDFFD])((?:\uD83C[\uDFFB-\uDFFF])|\uFE0F\u20E3?|(?:\uDB40[\uDC20-\uDC7E])+(?:\uDB40\uDC7F))?(\u200D(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDC2C-\uDC2F\uDC94-\uDC9F\uDCAF\uDCB0\uDCC0\uDCCF\uDCD0\uDCF6-\uDCFF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAE-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDE5F\uDE66-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFA]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDEE5\uDEE9\uDEEB-\uDEF0\uDEF3-\uDEFF\uDFDA-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE\uDCAF\uDCBC-\uDCBF\uDCC2-\uDCCF\uDCD9-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE58-\uDE5F\uDE6E-\uDEFF]|\uD83F[\uDC00-\uDFFD])((?:\uD83C[\uDFFB-\uDFFF])|\uFE0F\u20E3?|(?:\uDB40[\uDC20-\uDC7E])+(?:\uDB40\uDC7F))?)*)/;
module.exports["pinnedEmojiExp"] = $365ed100db6a5b65$export$6f5a4567cbce7bde;

});

parcelRegister("huWyw", function(module, exports) {

var $jlIaF = parcelRequire("jlIaF");

const $61f50eb1c9d5c417$export$35f6369946b1d8c9 = ({ url: url, spaceKey: spaceKey, contentType: contentType, editorVersion: editorVersion, contentId: contentId, fabricEditorSupported: fabricEditorSupported, noContextPath: noContextPath })=>{
    const isPage = contentType === 'page';
    const isBlog = contentType === 'blogpost';
    const isPageOrBlog = isPage || isBlog;
    const isUsingFabricEditor = fabricEditorSupported || editorVersion === 'v2'; // as opposed to the v1 TinyMCE editor
    const providedURLHitsResumeDraftAction = url.includes('resumedraft.action');
    if (isPageOrBlog && isUsingFabricEditor && providedURLHitsResumeDraftAction) {
        const contentTypeForURL = isPage ? 'pages' : 'blog';
        const contentIdForURL = contentId;
        // Extract the query string from the relative URL.
        const queryString = url.includes('?') ? url.slice(url.indexOf('?') + 1) : '';
        // Extract the `draftShareId` from the query string.
        const urlSearchParams = new URLSearchParams(queryString);
        const draftShareId = urlSearchParams.get('draftShareId');
        const draftShareIdParamString = draftShareId ? `draftShareId=${draftShareId}` : '';
        const optionalContextPath = noContextPath ? '' : (0, $jlIaF.CONTEXT_PATH);
        const bypassURL = `${optionalContextPath}/spaces/${spaceKey}/${contentTypeForURL}/edit-v2/${contentIdForURL}?${draftShareIdParamString}`;
        return bypassURL;
    } else return url;
};
module.exports["getURLBypassingResumeDraftAction"] = $61f50eb1c9d5c417$export$35f6369946b1d8c9;

});

parcelRegister("c7GB4", function(module, exports) {

var $5BvyC = parcelRequire("5BvyC");

var $lT7Mv = parcelRequire("lT7Mv");

var $k0a0F = parcelRequire("k0a0F");

var $bAV6O = parcelRequire("bAV6O");

var $8jDil = parcelRequire("8jDil");

var $dLbqW = parcelRequire("dLbqW");

var $7GbwS = parcelRequire("7GbwS");


var $1ggpj = parcelRequire("1ggpj");

const $c96e0d62cf176fc6$export$84dfa7fadd8a006b = ({ ari: ari, resourceType: resourceType })=>{
    if (!ari) return null;
    switch(resourceType){
        case (0, $1ggpj.ContentType).PAGE:
            return (0, $8jDil.ConfluencePageAri).parse(ari).pageId;
        case (0, $1ggpj.ContentType).BLOGPOST:
            return (0, $5BvyC.ConfluenceBlogpostAri).parse(ari).blogpostId;
        case (0, $1ggpj.ContentType).WHITEBOARD:
            return (0, $7GbwS.ConfluenceWhiteboardAri).parse(ari).whiteboardId;
        case (0, $1ggpj.ContentType).DATABASE:
            return (0, $lT7Mv.ConfluenceDatabaseAri).parse(ari).databaseId;
        case (0, $1ggpj.ContentType).EMBED:
            return (0, $k0a0F.ConfluenceEmbedAri).parse(ari).embedId;
        case (0, $1ggpj.ContentType).FOLDER:
            return (0, $bAV6O.ConfluenceFolderAri).parse(ari).folderId;
        case (0, $1ggpj.ContentType).SLIDE:
            return (0, $dLbqW.ConfluenceSlideAri).parse(ari).slideId;
    }
};
module.exports["getIdFromConfluenceContentAri"] = $c96e0d62cf176fc6$export$84dfa7fadd8a006b;

});

parcelRegister("5BvyC", function(module, exports) {

var $eQkRH = parcelRequire("eQkRH");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/blogpost/manifest.ts
var $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $eQkRH.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $eQkRH.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $4148e3160e6a23b4$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $4148e3160e6a23b4$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};
module.exports["ConfluenceBlogpostAri"] = $4148e3160e6a23b4$export$8602a2c2f6ac09bc;

});

parcelRegister("eQkRH", function(module, exports) {
// src/confluence/blogpost/types.ts
var $ace61b64202bfb2d$export$9389f06bd1d0765c = "confluence", $ace61b64202bfb2d$export$fb777a2d645a4129 = "blogpost";
module.exports["ConfluenceBlogpostAriResourceOwner"] = $ace61b64202bfb2d$export$9389f06bd1d0765c;
module.exports["ConfluenceBlogpostAriResourceType"] = $ace61b64202bfb2d$export$fb777a2d645a4129;

});

parcelRegister("lT7Mv", function(module, exports) {

var $jp6rV = parcelRequire("jp6rV");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/database/manifest.ts
var $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jp6rV.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $jp6rV.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $fef4c53c0d169c78$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $fef4c53c0d169c78$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};
module.exports["ConfluenceDatabaseAri"] = $fef4c53c0d169c78$export$317cd32472deea7e;

});

parcelRegister("jp6rV", function(module, exports) {
// src/confluence/database/types.ts
var $e2055ad385da7e5a$export$e83bc7b627335f1d = "confluence", $e2055ad385da7e5a$export$d26db9a1a0b750aa = "database";
module.exports["ConfluenceDatabaseAriResourceOwner"] = $e2055ad385da7e5a$export$e83bc7b627335f1d;
module.exports["ConfluenceDatabaseAriResourceType"] = $e2055ad385da7e5a$export$d26db9a1a0b750aa;

});

parcelRegister("k0a0F", function(module, exports) {

var $1pgGd = parcelRequire("1pgGd");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/embed/manifest.ts
var $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1pgGd.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $1pgGd.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $e8fb927b13f87211$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $e8fb927b13f87211$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};
module.exports["ConfluenceEmbedAri"] = $e8fb927b13f87211$export$47d4b4205d0ac61a;

});

parcelRegister("1pgGd", function(module, exports) {
// src/confluence/embed/types.ts
var $10651083a44828c2$export$7a02af293cacddd2 = "confluence", $10651083a44828c2$export$f817d48842ea0d4a = "embed";
module.exports["ConfluenceEmbedAriResourceOwner"] = $10651083a44828c2$export$7a02af293cacddd2;
module.exports["ConfluenceEmbedAriResourceType"] = $10651083a44828c2$export$f817d48842ea0d4a;

});

parcelRegister("bAV6O", function(module, exports) {

var $7SOnZ = parcelRequire("7SOnZ");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/folder/manifest.ts
var $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $7SOnZ.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $7SOnZ.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $870f5b1ead2b6083$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $870f5b1ead2b6083$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};
module.exports["ConfluenceFolderAri"] = $870f5b1ead2b6083$export$501a782385a3f485;

});

parcelRegister("7SOnZ", function(module, exports) {
// src/confluence/folder/types.ts
var $5bd4a92be6836a9b$export$77cf4e1b17902bfa = "confluence", $5bd4a92be6836a9b$export$6256ff329bc25a9c = "folder";
module.exports["ConfluenceFolderAriResourceOwner"] = $5bd4a92be6836a9b$export$77cf4e1b17902bfa;
module.exports["ConfluenceFolderAriResourceType"] = $5bd4a92be6836a9b$export$6256ff329bc25a9c;

});

parcelRegister("8jDil", function(module, exports) {

var $jyUkr = parcelRequire("jyUkr");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/page/manifest.ts
var $60de943ef043ed79$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $jyUkr.ConfluencePageAriResourceOwner),
    resourceType: (0, $jyUkr.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $60de943ef043ed79$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $60de943ef043ed79$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $60de943ef043ed79$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $60de943ef043ed79$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["ConfluencePageAri"] = $60de943ef043ed79$export$3f931dd15d96caff;

});

parcelRegister("jyUkr", function(module, exports) {
// src/confluence/page/types.ts
var $e3dce2fc5add42f7$export$da53e4f7db4c6a71 = "confluence", $e3dce2fc5add42f7$export$636fc622562a2c5b = "page";
module.exports["ConfluencePageAriResourceOwner"] = $e3dce2fc5add42f7$export$da53e4f7db4c6a71;
module.exports["ConfluencePageAriResourceType"] = $e3dce2fc5add42f7$export$636fc622562a2c5b;

});

parcelRegister("dLbqW", function(module, exports) {

var $1AG0i = parcelRequire("1AG0i");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/slide/manifest.ts
var $a04888a2b5576260$var$confluenceSlideAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $1AG0i.ConfluenceSlideAriResourceOwner),
    resourceType: (0, $1AG0i.ConfluenceSlideAriResourceType),
    resourceIdSlug: "activation/{activationId}/{slideId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        slideId: /[0-9]+/
    }
};
// src/confluence/slide/index.ts
var $a04888a2b5576260$export$86048ac46024146a = class _ConfluenceSlideAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get slideId() {
        return this._slideId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.qualifier,
            platformQualifier: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceOwner,
            resourceType: $a04888a2b5576260$var$confluenceSlideAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.slideId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                slideId: opts.slideId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $a04888a2b5576260$var$confluenceSlideAriStaticOpts);
        return new _ConfluenceSlideAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            slideId: this.slideId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._slideId = opts.resourceIdSegmentValues.slideId;
    }
};
module.exports["ConfluenceSlideAri"] = $a04888a2b5576260$export$86048ac46024146a;

});

parcelRegister("1AG0i", function(module, exports) {
// src/confluence/slide/types.ts
var $1289bc4ba87a8942$export$204fa7edd529d4b3 = "confluence", $1289bc4ba87a8942$export$3de52c55a164daa4 = "slide";
module.exports["ConfluenceSlideAriResourceOwner"] = $1289bc4ba87a8942$export$204fa7edd529d4b3;
module.exports["ConfluenceSlideAriResourceType"] = $1289bc4ba87a8942$export$3de52c55a164daa4;

});

parcelRegister("7GbwS", function(module, exports) {

var $9z7xR = parcelRequire("9z7xR");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/confluence/whiteboard/manifest.ts
var $597566211494b449$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $9z7xR.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $9z7xR.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $597566211494b449$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $597566211494b449$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $597566211494b449$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $597566211494b449$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};
module.exports["ConfluenceWhiteboardAri"] = $597566211494b449$export$ba3d25b6768ddb10;

});

parcelRegister("9z7xR", function(module, exports) {
// src/confluence/whiteboard/types.ts
var $6f6d3c41ba97755c$export$6130ea1abbb885ef = "confluence", $6f6d3c41ba97755c$export$d3070d1568a10e2d = "whiteboard";
module.exports["ConfluenceWhiteboardAriResourceOwner"] = $6f6d3c41ba97755c$export$6130ea1abbb885ef;
module.exports["ConfluenceWhiteboardAriResourceType"] = $6f6d3c41ba97755c$export$d3070d1568a10e2d;

});

parcelRegister("2HQyh", function(module, exports) {
/**
 * @generated SignedSource<<3ccde3616734a111f53da6e5e1f8991e>>
 * @relayHash ab13c035f40ba0298bd82a325ff2c401
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41
const $5b8dbd4fd00aa380$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "exp"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "key"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "keyString"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ 
        ]
    }, v7 = [
        {
            "kind": "Variable",
            "name": "entityId",
            "variableName": "id"
        },
        {
            "kind": "Variable",
            "name": "entityType",
            "variableName": "type"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "exp"
        }
    ], v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v11 = {
        "kind": "ScalarField",
        "name": "creatorId"
    }, v12 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "key"
    }, v15 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v5 /*: any*/ ,
            v14 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v16 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "emoji-title-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v14 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v17 = {
        "kind": "ScalarField",
        "name": "strategy"
    }, v18 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EndOfPageRecommendationQuery",
            "selections": [
                v6 /*: any*/ ,
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "RecommendedPages",
                    "kind": "LinkedField",
                    "name": "getRecommendedPages",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "RecommendedPagesItem",
                            "kind": "LinkedField",
                            "name": "recommendedPages",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ ,
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "ownedBy",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v13 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ 
                                    ]
                                },
                                v17 /*: any*/ 
                            ]
                        }
                    ]
                },
                v18 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "ab13c035f40ba0298bd82a325ff2c401",
            "id": "e58f63c20fdf70f91a40059b6e32935f05ca4978a7c84ffed3e0dfca58f47c41",
            "metadata": {},
            "name": "EndOfPageRecommendationQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationQuery($type:String!,$id:ID!,$exp:String!,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPages(entityType:$type,entityId:$id,experience:$exp){recommendedPages{content{id,title,type,subType,creatorId,links{webui},history{ownedBy{__typename,displayName}},space{id,key,name},emoji:properties(key:\"emoji-title-published\"){nodes{id,key,value}}},strategy}},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior}}"
        }
    };
}();
$5b8dbd4fd00aa380$var$node.hash = "e939560761a450cc2ece30ee9466334e";
var $5b8dbd4fd00aa380$export$2e2bcd8739ae039 = $5b8dbd4fd00aa380$var$node;
module.exports["default"] = $5b8dbd4fd00aa380$export$2e2bcd8739ae039;

});

parcelRegister("1AapX", function(module, exports) {
/**
 * @generated SignedSource<<49f29fe4cce6e5914fc9f51ae5a226c1>>
 * @relayHash bde3b931406ea3b1108284cc13c5d3a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2af0384892c40194e0e0a528388473adfd17c11fe5e5c3ae99fd5096a1349d29
const $43fd533a637b8d46$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v8 = {
        "kind": "ScalarField",
        "name": "key"
    }, v9 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v2 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ], v10 = {
        "alias": "editorVersion",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "editor"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(key:\"editor\")"
    }, v11 = {
        "alias": "emoji",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v9 /*: any*/ ,
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"])"
    }, v12 = {
        "args": [
            {
                "kind": "Literal",
                "name": "length",
                "value": 372
            }
        ],
        "kind": "ScalarField",
        "name": "excerpt",
        "storageKey": "excerpt(length:372)"
    }, v13 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
                "kind": "LinkedField",
                "name": "currentuser",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "FavouritedSummary",
                        "kind": "LinkedField",
                        "name": "favourited",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFavourite"
                            }
                        ]
                    }
                ]
            },
            {
                "concreteType": "ContentMetadata_CommentsMetadataProvider_comments",
                "kind": "LinkedField",
                "name": "comments",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "commentsCount"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v14 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v17 = [
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ], v18 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "name"
            }
        ]
    }, v19 = {
        "concreteType": "LikesResponse",
        "kind": "LinkedField",
        "name": "likes",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "count"
            }
        ]
    }, v20 = [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v16 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceHoverPageCardQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "singleContent",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v7 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "createdBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                },
                                {
                                    "kind": "LinkedField",
                                    "name": "ownedBy",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        },
                        v18 /*: any*/ ,
                        v19 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": v20 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "bde3b931406ea3b1108284cc13c5d3a4",
            "id": "2af0384892c40194e0e0a528388473adfd17c11fe5e5c3ae99fd5096a1349d29",
            "metadata": {},
            "name": "SpaceHoverPageCardQuery",
            "operationKind": "query",
            "text": "query SpaceHoverPageCardQuery($id:ID!){singleContent(id:$id){id,title,type,subType,status,links{webui,editui},editorVersion:properties(key:\"editor\"){nodes{id,key,value}},emoji:properties(keys:[\"emoji-title-published\",\"emoji-title-draft\"]){nodes{id,key,value}},excerpt(length:372),metadata{currentuser{favourited{isFavourite}},comments{commentsCount},lastModifiedDate},history{createdBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}},ownedBy{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}},space{id,key,alias,name},likes{count},version{by{__typename,profilePicture{path},displayName,...on KnownUser{accountId}}}}}"
        }
    };
}();
$43fd533a637b8d46$var$node.hash = "43d0bff36706ae93bf29ac12a5604ee3";
var $43fd533a637b8d46$export$2e2bcd8739ae039 = $43fd533a637b8d46$var$node;
module.exports["default"] = $43fd533a637b8d46$export$2e2bcd8739ae039;

});

parcelRegister("3V1KT", function(module, exports) {

var $71jDq = parcelRequire("71jDq");

const $bb6fcff23ee99252$export$d1ed7f06ad741aec = (0, $71jDq.default);
module.exports["ReactionsContentQuery"] = $bb6fcff23ee99252$export$d1ed7f06ad741aec;

});

parcelRegister("71jDq", function(module, exports) {
/**
 * @generated SignedSource<<4ace922d92a4d91954ed2877f69143ae>>
 * @relayHash f5d80e75401b9c7d3d224f964fef6438
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4
const $380a75471f8fd0e5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "contentReactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v1 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ReactionsContentQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f5d80e75401b9c7d3d224f964fef6438",
            "id": "1233c9b22c359c5d8cbed7e4b61033fe5b764797cdcb71dc0673a7aa5eed93f4",
            "metadata": {},
            "name": "ReactionsContentQuery",
            "operationKind": "query",
            "text": "query ReactionsContentQuery($contentId:ID!){content(id:$contentId){nodes{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$380a75471f8fd0e5$var$node.hash = "324529dfd12ad8cfc9429a4857981e84";
var $380a75471f8fd0e5$export$2e2bcd8739ae039 = $380a75471f8fd0e5$var$node;
module.exports["default"] = $380a75471f8fd0e5$export$2e2bcd8739ae039;

});

parcelRegister("2OQgp", function(module, exports) {

var $6snPf = parcelRequire("6snPf");

const $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b = (0, $6snPf.default);
module.exports["ReactedUsersQuery"] = $b0d4ef9b24ddbdc3$export$e27c33fe32c2fd7b;

});

parcelRegister("6snPf", function(module, exports) {
/**
 * @generated SignedSource<<c7c013e439bad88b330cd4d9c70935f1>>
 * @relayHash a2be411b1772244feef74a2765f2ac57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96
const $d0a610df0853dabe$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerType"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "emojiId"
    }, v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "containerId",
                    "variableName": "containerId"
                },
                {
                    "kind": "Variable",
                    "name": "containerType",
                    "variableName": "containerType"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                },
                {
                    "kind": "Variable",
                    "name": "emojiId",
                    "variableName": "emojiId"
                }
            ],
            "concreteType": "ReactedUsersResponse",
            "kind": "LinkedField",
            "name": "reactedUsers",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "count"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiId"
                },
                {
                    "kind": "ScalarField",
                    "name": "reacted"
                },
                {
                    "concreteType": "ConfluencePerson",
                    "kind": "LinkedField",
                    "name": "confluencePerson",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "displayName"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactedUsersQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactedUsersQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "a2be411b1772244feef74a2765f2ac57",
            "id": "8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96",
            "metadata": {},
            "name": "ReactedUsersQuery",
            "operationKind": "query",
            "text": "query ReactedUsersQuery($contentId:String!,$containerId:String!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){reactedUsers(contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId){count,emojiId,reacted,confluencePerson{accountId,displayName,profilePicture{path}}}}"
        }
    };
}();
$d0a610df0853dabe$var$node.hash = "c015b4e131a157a2b697f6c2a7cdf8e3";
var $d0a610df0853dabe$export$2e2bcd8739ae039 = $d0a610df0853dabe$var$node;
module.exports["default"] = $d0a610df0853dabe$export$2e2bcd8739ae039;

});

parcelRegister("kcIQr", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $9DHhW = parcelRequire("9DHhW");

const $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70 = ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (payload)=>createAnalyticsEvent(payload);
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const createEvent = t0;
    let t1;
    if ($[2] !== createEvent) {
        t1 = {
            createEvent: createEvent
        };
        $[2] = createEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["useConfluenceAnalyticsEvents"] = $8f5ec29d1cc276d5$export$b8af4dbcbdf99d70;

});

parcelRegister("f7MuR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $8s9DV.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $kBr4q.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $kBr4q.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skip: skip, skipBootstrap: skipBootstrap, fetchPolicy: fetchPolicy = 'cache-first' } = {}) {
    // skip=true -> full idle, no preload/store/fetch
    const preloadedData = (0, $cozmU.useMemo)(()=>skip ? null : $26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), [
        skip
    ]);
    const [storeState, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    // Track whether cache-and-network fetch dispatched this mount
    const fetchDispatchedRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (skip) return;
        if (!cloudId || !userId) return;
        if (skipBootstrap) return;
        if (!hasLicensedAccess) return;
        if (fetchPolicy === 'cache-first') {
            // Old behavior: don't fetch if we have data from any source
            if (preloadedData || storeState.data || storeState.loading || storeState.error) return;
            if ($26d702ce000cc6e9$var$hasFetched) return;
            $26d702ce000cc6e9$var$hasFetched = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        } else {
            // cache-and-network: fetch once per mount
            if (storeState.loading) {
                fetchDispatchedRef.current = true;
                return;
            }
            if (fetchDispatchedRef.current) return;
            fetchDispatchedRef.current = true;
            storeActions.start();
            $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then((data)=>storeActions.success(data), (err)=>storeActions.error(err));
        }
    }, [
        skip,
        skipBootstrap,
        fetchPolicy,
        cloudId,
        userId,
        hasLicensedAccess,
        preloadedData,
        storeState,
        storeActions
    ]);
    if (skip) return {
        data: null,
        loading: false,
        error: null
    };
    // Fetched store result wins over preloaded data
    if (storeState.data) return {
        data: storeState.data,
        loading: storeState.loading,
        error: storeState.error
    };
    if (preloadedData) return {
        data: preloadedData,
        loading: storeState.loading,
        error: null
    };
    return {
        data: null,
        loading: storeState.loading,
        error: storeState.error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("664fH", function(module, exports) {

let $47069a0574ff59c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $47069a0574ff59c9$var$load("dxcsb"),
    $47069a0574ff59c9$var$load("4flC1")
]).then(()=>parcelRequire('eN31l'));

});

parcelRegister("ibNn3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDUvk = parcelRequire("iDUvk");


var $5UaGA = parcelRequire("5UaGA");


var $bGVJw = parcelRequire("bGVJw");


var $5h1mk = parcelRequire("5h1mk");


var $8RKDP = parcelRequire("8RKDP");

const $9a875a626b0d54c7$var$scopesNamesAsString = (scopes = [])=>scopes.map((e)=>e.name).sort().join(',');
const $9a875a626b0d54c7$export$daf66a67c26dc848 = (config)=>{
    const currentScopeNames = $9a875a626b0d54c7$var$scopesNamesAsString(config.scopes);
    const matchScopes = (0, $cozmU.useCallback)((input)=>$9a875a626b0d54c7$export$ec890b48cae4cc1c(config)(input), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentScopeNames
    ]);
    const [state, setState] = (0, $cozmU.useState)($9a875a626b0d54c7$var$initialState);
    const route = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const next = matchScopes({
        route: route,
        context: context
    });
    const nextScopeNames = $9a875a626b0d54c7$var$scopesNamesAsString(next);
    const updateKey = `${currentScopeNames}-${nextScopeNames}`;
    $9a875a626b0d54c7$var$usePostOfficeScopeSpy(state, config);
    (0, $cozmU.useEffect)(()=>{
        if ($9a875a626b0d54c7$export$fcc046cb16c47539({
            next: next,
            state: state,
            treatIntersectionAsSame: config.treatIntersectionAsSame
        })) setState(({ current: current })=>({
                updateKey: (0, $5UaGA.simpleHash)(updateKey),
                current: next,
                previous: current
            }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        updateKey
    ]);
    return state;
};
const $9a875a626b0d54c7$var$initialState = {
    updateKey: undefined,
    current: [],
    previous: []
};
const $9a875a626b0d54c7$var$createMatchScope = ({ route: route, context: context })=>(input)=>{
        const contextMatch = route ? 'pathname' in route ? {
            route: route,
            context: context
        } : route.current ? {
            route: $9a875a626b0d54c7$var$extractRelevantUrlFields(route.current),
            context: context
        } : {
            route: undefined,
            context: context
        } : {
            route: undefined,
            context: context
        };
        const inputMatch = input.when;
        return $9a875a626b0d54c7$export$5c1cef6f5f213829({
            contextMatch: contextMatch,
            inputMatch: inputMatch
        });
    };
const $9a875a626b0d54c7$var$extractRelevantUrlFields = (route)=>{
    const { hostname: hostname, pathname: pathname, search: search } = new URL(route);
    return {
        hostname: hostname,
        pathname: pathname,
        search: search
    };
};
const $9a875a626b0d54c7$export$5c1cef6f5f213829 = ({ contextMatch: contextMatch, inputMatch: inputMatch })=>(0, (/*@__PURE__*/$parcel$interopDefault($iDUvk)))(contextMatch, inputMatch, (contextValue, inputValue)=>$9a875a626b0d54c7$var$isValueMatchDeep({
            contextValue: contextValue,
            inputValue: inputValue
        }));
const $9a875a626b0d54c7$var$isValueMatch = ({ contextValue: contextValue, inputValue: inputValue })=>{
    if (!contextValue || !inputValue) return false;
    if (typeof inputValue === 'string') return contextValue === inputValue;
    if (inputValue?.equals) return contextValue === inputValue.equals;
    if (!inputValue?.matches) return false;
    if (typeof inputValue.matches !== 'string' || typeof contextValue !== 'string') return false;
    return new RegExp(inputValue.matches).test(contextValue);
};
const $9a875a626b0d54c7$var$isValueMatchDeep = ({ contextValue: contextValue, inputValue: inputValue })=>typeof inputValue === 'object' && typeof contextValue === 'object' ? $9a875a626b0d54c7$export$5c1cef6f5f213829({
        contextMatch: contextValue,
        inputMatch: inputValue
    }) : $9a875a626b0d54c7$var$isValueMatch({
        contextValue: contextValue,
        inputValue: inputValue
    });
const $9a875a626b0d54c7$export$ec890b48cae4cc1c = ({ scopes: scopes })=>(input)=>scopes.filter($9a875a626b0d54c7$var$createMatchScope(input)).map((scope)=>({
                name: scope.name
            }));
const $9a875a626b0d54c7$export$fcc046cb16c47539 = ({ next: next, state: state, treatIntersectionAsSame: treatIntersectionAsSame })=>{
    const currentSet = Array.from(new Set(state.current.map((e)=>e.name)));
    const nextSet = Array.from(new Set(next.map((e)=>e.name)));
    if (treatIntersectionAsSame) {
        if (currentSet.length !== 0 && nextSet.length === 0) return true;
    } else {
        if (currentSet.length !== nextSet.length) return true;
    }
    return !nextSet.every((e)=>currentSet.includes(e));
};
// Scope Spy
const $9a875a626b0d54c7$var$usePostOfficeScopeSpy = (state, config)=>{
    if (config?.consoleSpy && typeof window !== 'undefined' && !window?.postOffice?.scopes) {
        const [listen, update] = (0, $8RKDP.createSimplePubSub)();
        window.postOffice = {
            ...window.postOffice,
            scopes: {
                [config?.consoleSpy.name]: {
                    listen: listen,
                    update: update,
                    list: config.scopes
                }
            }
        };
    }
    (0, $cozmU.useEffect)(()=>{
        if (!config?.consoleSpy) return;
        if (!window.postOffice?.scopes) return;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        window.postOffice?.scopes?.[config?.consoleSpy.name]?.update?.(state);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        $9a875a626b0d54c7$var$scopesNamesAsString(state.current)
    ]);
};
module.exports["usePostOfficeContextScope"] = $9a875a626b0d54c7$export$daf66a67c26dc848;
module.exports["createMatchScopes"] = $9a875a626b0d54c7$export$ec890b48cae4cc1c;

});

parcelRegister("iDUvk", function(module, exports) {

var $5du2X = parcelRequire("5du2X");


var $alIi2 = parcelRequire("alIi2");

/**
 * This method is like `_.isMatch` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with five
 * arguments: (objValue, srcValue, index|key, object, source).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, srcValue) {
 *   if (isGreeting(objValue) && isGreeting(srcValue)) {
 *     return true;
 *   }
 * }
 *
 * var object = { 'greeting': 'hello' };
 * var source = { 'greeting': 'hi' };
 *
 * _.isMatchWith(object, source, customizer);
 * // => true
 */ function $d927b313c5b2752a$var$isMatchWith(object, source, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    return $5du2X(object, source, $alIi2(source), customizer);
}
module.exports = $d927b313c5b2752a$var$isMatchWith;

});

parcelRegister("5UaGA", function(module, exports) {
const $8fc9840d3c007d61$export$b211ce59c0ea1cfb = (str)=>{
    let hash = 0;
    for(let i = 0; i < str.length; i++){
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};
module.exports["simpleHash"] = $8fc9840d3c007d61$export$b211ce59c0ea1cfb;

});

parcelRegister("6U5eU", function(module, exports) {

var $7rM80 = parcelRequire("7rM80");

const $9db2e529afbaed9d$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $7rM80.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $9db2e529afbaed9d$export$8a57effc6307f916;

});

parcelRegister("7rM80", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $i3S9F = parcelRequire("i3S9F");


var $iQwJa = parcelRequire("iQwJa");


var $1RMKR = parcelRequire("1RMKR");


var $gswTK = parcelRequire("gswTK");


var $1NJu1 = parcelRequire("1NJu1");


var $1722n = parcelRequire("1722n");


var $ll379 = parcelRequire("ll379");

var $qzjr4 = parcelRequire("qzjr4");


var $8BCsI = parcelRequire("8BCsI");

const $63c899b662d40d3e$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $8BCsI.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $i3S9F.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $1RMKR.useStableObject)(context);
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gswTK.MaybePlacementFetchingProvider), {
                fetch: fetch?.fetch,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $qzjr4.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $63c899b662d40d3e$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $63c899b662d40d3e$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $1722n.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $1NJu1.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $63c899b662d40d3e$export$8a57effc6307f916;

});

parcelRegister("1NJu1", function(module, exports) {
const $bff07b8bbb17f66c$export$9c542858adf7dcd0 = {
    isSiteAdmin: undefined,
    locale: undefined,
    product: undefined,
    subproduct: undefined,
    tenantId: undefined,
    workspaceAri: 'no-workspace-ari-available',
    workspaceId: undefined,
    orgId: undefined,
    productEdition: undefined,
    disableAllPlacements: undefined
};
const $bff07b8bbb17f66c$export$71ff7382870ef1b0 = 'create-placement-component';
module.exports["DEFAULT_CONTEXT"] = $bff07b8bbb17f66c$export$9c542858adf7dcd0;
module.exports["ERROR_BOUNDARY_LOCATION"] = $bff07b8bbb17f66c$export$71ff7382870ef1b0;

});

parcelRegister("1722n", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $c99625c3d1d9a9b2$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $cozmU.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $c99625c3d1d9a9b2$export$3d127465d22fe4e5;

});

parcelRegister("ll379", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $jTNdj = parcelRequire("jTNdj");


var $cozmU = parcelRequire("cozmU");


var $1NVwf = parcelRequire("1NVwf");


var $3WFdt = parcelRequire("3WFdt");

const $0443f5c700dc203b$export$9a335a42ce02bdb8 = /*#__PURE__*/ (0, $cozmU.memo)(({ children: children, ...props })=>{
    const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
    const { isLoading: isLoading, onMount: onMount } = (0, $3WFdt.usePerformanceTracking)(props);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            isUFOEnabled && isLoading && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                name: (0, $jTNdj.UFOv2).HoldNames.PLACEMENT
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                onMount: onMount,
                children: children
            })
        ]
    });
});
const $0443f5c700dc203b$export$b35129264a401b3c = /*#__PURE__*/ (0, $cozmU.memo)(({ placementId: placementId, children: children })=>{
    const isEnabled = (0, $cXtTj.default).checkGate('post_office_update_ufov2_placements');
    /**
   * If feature gate is not enabled, then we just return the children without the
   * UFO segments attached.
   */ if (!isEnabled) return children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.PLACEMENT,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.PLACEMENT}.${placementId}`,
            children: children
        })
    });
});
module.exports["PerformanceTracking"] = $0443f5c700dc203b$export$9a335a42ce02bdb8;
module.exports["PerformanceTrackingSegment"] = $0443f5c700dc203b$export$b35129264a401b3c;

});

parcelRegister("jTNdj", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $65DSU = parcelRequire("65DSU");

const $8f5948bf59d85fb8$export$c91b09caa8ecbab1 = {
    /** Names for UFOv2 segments for Post Office */ SegmentNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
        PLACEMENT: 'post-office-placement',
        MESSAGE: 'post-office-message'
    },
    /** Names for UFOv2 holds for Post Office */ HoldNames: {
        REMOTE_PLACEMENT: 'post-office-remote-loaded-placement-loading',
        PLACEMENT: 'post-office-placement-loading',
        MESSAGE: 'post-office-message-loading'
    },
    UFOLoadHold: (0, $b8pma.default),
    UFOSegment: (0, $65DSU.default)
};
module.exports["UFOv2"] = $8f5948bf59d85fb8$export$c91b09caa8ecbab1;

});

parcelRegister("1NVwf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $2808315b9dcd7678$export$21b400a8c8ebc91a = ({ onMount: onMount, children: children })=>{
    (0, $cozmU.useEffect)(()=>{
        const onUnmount = onMount();
        return onUnmount;
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["TrackMount"] = $2808315b9dcd7678$export$21b400a8c8ebc91a;

});

parcelRegister("3WFdt", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7da53318f1fd530c$export$317d52099614f316 = ({ onEvent: onEvent, initialData: initialData })=>{
    // Initialise to true only if there's a Promise to await, avoiding an unnecessary UFO hold on mount.
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(initialData !== undefined);
    const onMount = (0, $cozmU.useCallback)(()=>{
        return ()=>onEvent?.({
                type: 'unmount'
            });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (initialData) initialData.then(()=>{
            onEvent?.({
                type: 'initial-data-complete'
            });
        }).catch((error)=>{
            onEvent?.({
                type: 'initial-data-error',
                error: error
            });
        }).finally(()=>{
            setIsLoading(false);
        });
        else setIsLoading(false);
    }, [
        initialData,
        onEvent
    ]);
    const onComponentError = (0, $cozmU.useCallback)((error)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
    }, [
        onEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isLoading === false) onEvent?.({
            type: 'component-ready'
        });
    }, [
        isLoading
    ]);
    return {
        onMount: onMount,
        isLoading: isLoading,
        onComponentError: onComponentError
    };
};
module.exports["usePerformanceTracking"] = $7da53318f1fd530c$export$317d52099614f316;

});

parcelRegister("qzjr4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $lTlGN = parcelRequire("lTlGN");


var $im2FK = parcelRequire("im2FK");


var $6NRmI = parcelRequire("6NRmI");


var $li4w8 = parcelRequire("li4w8");


var $5SfHd = parcelRequire("5SfHd");


var $9Nqm6 = parcelRequire("9Nqm6");


var $5SRox = parcelRequire("5SRox");


var $ll379 = parcelRequire("ll379");

const $b95d67109e64283f$export$2b6596bcb1383a71 = ({ children: children, context: context, placement: placement, route: route, choreographer: choreographer, subscription: subscription })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $li4w8.StableContextProvider), {
        context: context,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SfHd.StablePlacementProvider), {
            placement: placement,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SRox.StableRouteProvider), {
                route: route,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $im2FK.StableAnaltyicsProvider), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9Nqm6.StableSubscriptionConfigProvider), {
                        subscription: subscription,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6NRmI.StableChoreographerProvider), {
                            choreographer: choreographer,
                            placementId: placement.placementId,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lTlGN.RenderTrackerProvider), {
                                placementId: placement.placementId,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
module.exports["StableProviders"] = $b95d67109e64283f$export$2b6596bcb1383a71;

});

parcelRegister("lTlGN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $9TNXZ = parcelRequire("9TNXZ");


var $cozmU = parcelRequire("cozmU");


var $9Nqm6 = parcelRequire("9Nqm6");

/**
 * List of Placements we do not want to track placement (rendered) for, due to cost reasons, until we have a better solution.
 */ const $0688fdc237844f49$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS = [
    'screen-space-flags'
];
const $0688fdc237844f49$export$2d84fd9af6c9e378 = ({ children: children, placementId: placementId })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const subscriptionConfig = (0, $9Nqm6.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    (0, $cozmU.useEffect)(()=>{
        if ($0688fdc237844f49$var$TEMPORARY_NO_RENDER_TRACK_PLACEMENTS.includes(placementId)) return;
        fireAnalyticsEvent({
            eventType: 'track',
            action: 'rendered',
            actionSubject: 'placement',
            attributes: {
                subscriptionEnabled: subscriptionEnabled
            }
        });
    }, [
        fireAnalyticsEvent,
        placementId,
        subscriptionEnabled
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["RenderTrackerProvider"] = $0688fdc237844f49$export$2d84fd9af6c9e378;

});

parcelRegister("9TNXZ", function(module, exports) {

var $9DHhW = parcelRequire("9DHhW");


var $cozmU = parcelRequire("cozmU");

const $a0ec0e7d81fbe018$export$85183a312807388d = 'postOffice';
const $a0ec0e7d81fbe018$export$33911828b25deac7 = 'engagementPlatform';
const $a0ec0e7d81fbe018$export$57d19d18d6e255a5 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((eventPayload, attributes)=>{
        createAnalyticsEvent({
            ...eventPayload,
            side: 'client',
            attributes: {
                ...eventPayload.attributes,
                ...attributes
            }
        }).fire($a0ec0e7d81fbe018$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
const $a0ec0e7d81fbe018$export$f7fadc54a04f9307 = {
    eventType: 'track',
    action: 'exposed',
    actionSubject: 'feature',
    source: 'engagement-platform',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        reason: 'RULE_MATCH',
        ruleId: 'engagement.inproduct',
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ]
};
const $a0ec0e7d81fbe018$export$e0b2a6bfc6c6f992 = {
    eventType: 'operational',
    action: 'stopped',
    actionSubject: 'message',
    source: 'epTargeting',
    tenantType: 'cloudId',
    userType: 'atlassianAccount',
    attributes: {
        sourceProduct: 'postOffice'
    },
    tags: [
        'engagementPlatform'
    ],
    product: 'engagementPlatform'
};
const $a0ec0e7d81fbe018$export$f14470c9a12428fc = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((eventPayload, attributes)=>{
        if (eventPayload.messageType === 'inapp') {
            const epMessageId = `engagement.inproduct.${eventPayload.messageId}`;
            createAnalyticsEvent({
                ...$a0ec0e7d81fbe018$export$f7fadc54a04f9307,
                ...eventPayload,
                actionSubjectId: epMessageId,
                attributes: {
                    ...$a0ec0e7d81fbe018$export$f7fadc54a04f9307.attributes,
                    ...eventPayload.locale && {
                        locale: eventPayload.locale
                    },
                    ...attributes,
                    flagKey: epMessageId
                }
            }).fire($a0ec0e7d81fbe018$export$33911828b25deac7);
        } else createAnalyticsEvent({
            ...$a0ec0e7d81fbe018$export$e0b2a6bfc6c6f992,
            ...eventPayload,
            actionSubjectId: eventPayload.messageId,
            attributes: {
                ...$a0ec0e7d81fbe018$export$e0b2a6bfc6c6f992.attributes,
                ...eventPayload.locale && {
                    locale: eventPayload.locale
                },
                ...attributes
            }
        }).fire($a0ec0e7d81fbe018$export$33911828b25deac7);
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent
    };
};
module.exports["ANALYTICS_CHANNEL"] = $a0ec0e7d81fbe018$export$85183a312807388d;
module.exports["useFirePostOfficeAnalyticsEvents"] = $a0ec0e7d81fbe018$export$57d19d18d6e255a5;
module.exports["useFireEngagementPlatformAnalyticsEvents"] = $a0ec0e7d81fbe018$export$f14470c9a12428fc;

});

parcelRegister("9Nqm6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $ffaea1b52a58fd24$var$SubscriptionConfigContext = /*#__PURE__*/ (0, $cozmU.createContext)({
    subscription: undefined
});
const $ffaea1b52a58fd24$export$d870bd1cf2974c88 = ({ subscription: subscription, children: children })=>{
    const memoizedValue = (0, $cozmU.useMemo)(()=>({
            subscription: subscription
        }), [
        subscription
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ffaea1b52a58fd24$var$SubscriptionConfigContext.Provider, {
        value: memoizedValue,
        children: children
    });
};
const $ffaea1b52a58fd24$export$1129f1fe63b2d7ab = ()=>{
    return (0, $cozmU.useContext)($ffaea1b52a58fd24$var$SubscriptionConfigContext);
};
module.exports["StableSubscriptionConfigProvider"] = $ffaea1b52a58fd24$export$d870bd1cf2974c88;
module.exports["useSubscriptionConfig"] = $ffaea1b52a58fd24$export$1129f1fe63b2d7ab;

});

parcelRegister("im2FK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $f1G3w = parcelRequire("f1G3w");

const $15ac6ff16ee48c24$var$postOfficeAnalyticsContextData = {
    attributes: {
        build: {
            c: "dad290bdac561f3cfd354191c74ed657fefc0aa2",
            b: "25885812",
            t: undefined
        }
    }
};
const $15ac6ff16ee48c24$export$5a66cdc9893b43e = ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: $15ac6ff16ee48c24$var$postOfficeAnalyticsContextData,
        children: children
    });
};
module.exports["StableAnaltyicsProvider"] = $15ac6ff16ee48c24$export$5a66cdc9893b43e;

});

parcelRegister("li4w8", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $bGVJw = parcelRequire("bGVJw");


var $1RMKR = parcelRequire("1RMKR");


var $1NJu1 = parcelRequire("1NJu1");

const $52edb35a97f45deb$export$d4982c0a28b18f63 = ({ context: context, children: children })=>{
    const stableContext = (0, $1RMKR.useStableObject)({
        ...(0, $1NJu1.DEFAULT_CONTEXT),
        ...context
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bGVJw.PostOfficeContextProvider), {
        value: stableContext,
        children: children
    });
};
module.exports["StableContextProvider"] = $52edb35a97f45deb$export$d4982c0a28b18f63;

});

parcelRegister("5SfHd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");


var $4cICV = parcelRequire("4cICV");

const $9ea687c3ab35e390$export$e9fd288527498af6 = ({ children: children, placement: placement })=>{
    const stableValue = (0, $1RMKR.useStableObject)(placement);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4cICV.PlacementProvider), {
        value: stableValue,
        children: children
    });
};
module.exports["StablePlacementProvider"] = $9ea687c3ab35e390$export$e9fd288527498af6;

});

parcelRegister("5SRox", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $5h1mk = parcelRequire("5h1mk");


var $1RMKR = parcelRequire("1RMKR");


var $2LW9e = parcelRequire("2LW9e");

const $2e96bdbc145ab642$export$ce13d00e696dfc96 = ({ route: route, children: children })=>{
    const href = (0, $2LW9e.useLocationHref)();
    const stableRoute = (0, $1RMKR.useStableObject)(route ?? {
        previous: href,
        current: href,
        searchParams: href ? new URL(href).searchParams : undefined
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5h1mk.PostOfficeRouteContext).Provider, {
        value: stableRoute,
        children: children
    });
};
module.exports["StableRouteProvider"] = $2e96bdbc145ab642$export$ce13d00e696dfc96;

});

parcelRegister("2LW9e", function(module, exports) {
const $0e2c91a22a84681f$var$isLocationAvailable = ()=>typeof globalThis !== 'undefined' && typeof globalThis.location !== 'undefined';
const $0e2c91a22a84681f$export$49fc3f3d8c7f99 = ()=>{
    return $0e2c91a22a84681f$var$isLocationAvailable() ? globalThis.location.href : undefined;
};
module.exports["useLocationHref"] = $0e2c91a22a84681f$export$49fc3f3d8c7f99;

});

parcelRegister("8BCsI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $852mP = parcelRequire("852mP");


var $9TNXZ = parcelRequire("9TNXZ");


var $9EOlJ = parcelRequire("9EOlJ");

const $fd01083bcb8bbfd4$export$f0c7a449e0cfaec7 = (Component)=>(props)=>{
        const { errorBoundaryLocation: errorBoundaryLocation, placementId: placementId, messageTemplateId: messageTemplateId, fallbackRender: fallbackRender, onError: onError } = props;
        const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
        const internalOnError = (additionalAnalytics, onError)=>(error, info)=>{
                if (onError) onError(error, info);
                fireAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    action: 'caughtError',
                    actionSubject: 'PostOfficeErrorBoundary',
                    actionSubjectId: additionalAnalytics.errorBoundaryLocation
                }, {
                    error: {
                        name: error.name,
                        message: error.message,
                        stack: error.stack
                    },
                    info: info,
                    errorBoundaryLocation: additionalAnalytics.errorBoundaryLocation,
                    placementId: additionalAnalytics.placementId,
                    messageTemplateId: additionalAnalytics.messageTemplateId
                });
            };
        const internalFallbackRender = (FallbackRender)=>(props)=>{
                if (FallbackRender) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore - Confluence Local Consumption - 'FallbackRender' cannot be used as a JSX component. Its return type 'ReactNode' is not a valid JSX element. Type 'undefined' is not assignable to type 'Element | null'.
                return /*#__PURE__*/ (0, $8aG6j.jsx)(FallbackRender, {
                    ...props
                });
                return null;
            };
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
            fallbackRender: internalFallbackRender(fallbackRender),
            onError: internalOnError({
                errorBoundaryLocation: errorBoundaryLocation,
                placementId: placementId,
                messageTemplateId: messageTemplateId
            }, onError),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                ...props
            })
        });
    };
module.exports["withErrorBoundary"] = $fd01083bcb8bbfd4$export$f0c7a449e0cfaec7;

});

parcelRegister("bq8Da", function(module, exports) {
module.exports = JSON.parse('{"cc-permissions.access-links-changeboarding.back":[{"type":0,"value":"Back"}],"cc-permissions.access-links-changeboarding.check-it-out":[{"type":0,"value":"Check it out"}],"cc-permissions.access-links-changeboarding.configure-description":[{"type":0,"value":"Manage your allowed access levels, permissions, and content types."}],"cc-permissions.access-links-changeboarding.configure-title":[{"type":0,"value":"Configure access links"}],"cc-permissions.access-links-changeboarding.description":[{"type":0,"value":"Public links have evolved to support more flexible ways of sharing content."}],"cc-permissions.access-links-changeboarding.done":[{"type":0,"value":"Done"}],"cc-permissions.access-links-changeboarding.learn-more":[{"type":0,"value":"Learn more"}],"cc-permissions.access-links-changeboarding.more-ways-description":[{"type":0,"value":"You can now share content with licensed Confluence users on your app without granting them space access."}],"cc-permissions.access-links-changeboarding.more-ways-title":[{"type":0,"value":"More ways to share content"}],"cc-permissions.access-links-changeboarding.next":[{"type":0,"value":"Next"}],"cc-permissions.access-links-changeboarding.public-links-disabled-description":[{"type":0,"value":"Public links are now a type of access link. Allow them to share content with anyone on the internet."}],"cc-permissions.access-links-changeboarding.public-links-enabled-description":[{"type":0,"value":"Public links are now a type of access link. Your existing settings remain unchanged."}],"cc-permissions.access-links-changeboarding.public-links-title":[{"type":0,"value":"Public links are still here"}],"cc-permissions.access-links-changeboarding.step-count":[{"type":0,"value":"Step "},{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"cc-permissions.access-links-changeboarding.title":[{"type":0,"value":"Public links are now access links"}],"cc-permissions.confluence-exco-added-to-space.message-template.email.gday":[{"type":0,"value":"G\'day"}],"cc-permissions.confluence-exco-added-to-space.message-template.email.header.external-info":[{"type":0,"value":"Guests may be external to your organization."}],"cc-permissions.confluence-exco-no-space-access.message-template.email.more-message":[{"type":0,"value":"And more. Select "},{"children":[{"type":0,"value":"Manage access"}],"type":8,"value":"strong"},{"type":0,"value":" to get a full list."}],"cc-permissions.confluence-exco-space-ready.message-template.email.external-info":[{"type":0,"value":"Guests may be external to your organization."}],"cc-permissions.confluence-exco-space-ready.message-template.email.secondary-cta":[{"type":0,"value":"Learn more"}],"cc-permissions.confluence-exco-user-requested-access.message-template.email.guest-profile.guest-badge":[{"type":0,"value":"GUEST"}],"cc-permissions.confluence-exco-user-requested-access.message-template.email.header.text":[{"type":0,"value":"The following guest has requested access to your Confluence site: "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"b"},{"type":0,"value":". Guests need access to a space before they can use Confluence at all."}],"confluence.confluence-public-link-page-enabled.message-template.email.access-link.subject":[{"type":0,"value":"An access link has been turned on for a content in "},{"type":1,"value":"spaceName"}],"confluence.confluence-public-link-page-enabled.test-message.email.body.avatar":[{"type":0,"value":"Avatar"}],"confluence.confluence-public-link-page-enabled.test-message.email.body.content-space-and-site.access-link":[{"type":0,"value":"This content is in the "},{"children":[{"type":1,"value":"spaceName"}],"type":8,"value":"b"},{"type":0,"value":" space on "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"b"}],"confluence.confluence-public-link-page-enabled.test-message.email.body.description-of-access-link-feature.external":[{"type":0,"value":"An access link has been turned on for this content \u2013 this lets anyone on the internet with the link view this content while the link is active."}],"confluence.confluence-public-link-page-enabled.test-message.email.body.description-of-access-link-feature.internal-licensed":[{"type":0,"value":"An access link has been turned on for this content \u2013 this lets all licensed Confluence users on your site with the link view this content while the link is active."}],"confluence.confluence-public-link-page-enabled.test-message.email.body.learn-more-about-access-links":[{"type":0,"value":"Learn more about access links"}],"confluence.confluence-public-link-page-enabled.test-message.email.body.manage-public-links-cta.live-doc":[{"type":0,"value":"View doc"}],"confluence.confluence-public-link-page-enabled.test-message.email.body.manage-public-links-cta.page":[{"type":0,"value":"View page"}],"confluence.confluence-public-link-page-enabled.test-message.email.body.manage-public-links-cta.slide":[{"type":0,"value":"View slide"}],"confluence.confluence-public-link-page-enabled.test-message.email.body.manage-public-links-cta.whiteboard":[{"type":0,"value":"View whiteboard"}],"confluence.confluence-public-link-page-enabled.test-message.email.body.summary.access-link":[{"type":1,"value":"pageLinkEnabler"},{"type":0,"value":" turned on an access link for "},{"type":1,"value":"contentTitle"}],"confluence.confluence-public-link-space-enabled.message-template.email.subject.external":[{"type":0,"value":"Access links are now allowed in your Confluence space"}],"confluence.confluence-public-link-space-enabled.message-template.email.subject.internal-licensed":[{"type":0,"value":"Access links are now allowed in your Confluence space"}],"confluence.confluence-public-link-space-enabled.test-message.email.body.avatar":[{"type":0,"value":"Avatar"}],"confluence.confluence-public-link-space-enabled.test-message.email.body.description.external":[{"type":0,"value":"This update doesn\'t change any existing user access. It simply enables users in this space to share content with anyone on the internet using access links."}],"confluence.confluence-public-link-space-enabled.test-message.email.body.description.internal-licensed":[{"type":0,"value":"This update doesn\'t change any existing user access. It simply enables users in this space to share content more broadly with all licensed Confluence users on your site using access links."}],"confluence.confluence-public-link-space-enabled.test-message.email.body.learn-more-about-access-links":[{"type":0,"value":"Learn more about access links"}],"confluence.confluence-public-link-space-enabled.test-message.email.body.manage-access-links-cta":[{"type":0,"value":"Manage access links"}],"confluence.confluence-public-link-space-enabled.test-message.email.body.space-header":[{"type":0,"value":"Confluence space"}],"confluence.confluence-public-link-space-enabled.test-message.email.body.title.external":[{"type":0,"value":"People in your space can now use access links"}],"confluence.confluence-public-link-space-enabled.test-message.email.body.who-made-the-change":[{"type":0,"value":"Who made the change"}],"confluence.confluence-public-links-site-enabled.message-template.email.subject.external":[{"type":0,"value":"Access links are now allowed on your Confluence site"}],"confluence.confluence-public-links-site-enabled.message-template.email.subject.internal-licensed":[{"type":0,"value":"Access links are now allowed in your Confluence site"}],"confluence.confluence-public-links-site-enabled.test-message.email.body.avatar":[{"type":0,"value":"Avatar"}],"confluence.confluence-public-links-site-enabled.test-message.email.body.header.external":[{"type":0,"value":"People in your site can now use access links"}],"confluence.confluence-public-links-site-enabled.test-message.email.body.learn-more-about-access-links":[{"type":0,"value":"Learn more about access links"}],"confluence.confluence-public-links-site-enabled.test-message.email.body.manage-access-links-cta":[{"type":0,"value":"Manage access links"}],"confluence.confluence-public-links-site-enabled.test-message.email.body.site-name":[{"type":0,"value":"Confluence site"}],"confluence.confluence-public-links-site-enabled.test-message.email.body.subtext.external":[{"type":0,"value":"This update doesn\'t change any existing user access. It simply enables users in spaces where access links are allowed to share content with anyone on the internet."}],"confluence.confluence-public-links-site-enabled.test-message.email.body.subtext.internal-licensed":[{"type":0,"value":"This update doesn\'t change any existing user access. It simply enables users in spaces where access links are allowed to share content more broadly with all licensed Confluence users on your site."}],"confluence.confluence-public-links-site-enabled.test-message.email.body.system.subtext.updated":[{"type":0,"value":"Access links let users share Confluence content with all licensed Confluence users on your site, across your unit, or publicly with anyone on the internet."}],"confluence.confluence-public-links-site-enabled.test-message.email.body.upgrade.description.updated":[{"type":0,"value":"Access links are only available on paid plans and are allowed by default. This default was activated when your plan was upgraded."}],"confluence.confluence-public-links-site-enabled.test-message.email.body.who-made-the-change":[{"type":0,"value":"Who made the change"}],"confluence.confluence-public-links-site-enabled.test-message.email.system.body.header.updated":[{"type":0,"value":"People in your site can now use access links because your Confluence plan was upgraded."}],"confluence.confluence-public-links-site-enabled.test-message.email.system.body.site-name":[{"type":0,"value":"Confluence site"}],"confluence.email.external-collab-guest-added.gday.greeting":[{"type":0,"value":"G\'day "},{"children":[{"type":1,"value":"username"}],"type":8,"value":"b"},{"type":0,"value":","}],"confluence.notifications.exco.space.ready.subject":[{"type":0,"value":"[Confluence] "},{"type":1,"value":"inviterName"},{"type":0,"value":" has invited you to join Confluence as a guest"}],"email.immediate.cta.space.learn_more":[{"type":0,"value":"Learn more"}],"email.immediate.cta.space.manage_access":[{"type":0,"value":"Manage access"}],"email.immediate.external_collab.guest.permission.footer":[{"children":[{"type":0,"value":"Note: "}],"type":8,"value":"b"},{"type":0,"value":" Your admin may further restrict your functionality from these default settings."}],"email.immediate.external_collab.guest.permission.header":[{"type":0,"value":"As a guest, you can:"}],"email.immediate.external_collab.guest.permission.row.five":[{"type":0,"value":"Mention other people"}],"email.immediate.external_collab.guest.permission.row.four":[{"type":0,"value":"See other people\'s profiles"}],"email.immediate.external_collab.guest.permission.row.one":[{"type":0,"value":"View, create, and edit in this space"}],"email.immediate.external_collab.guest.permission.row.three":[{"type":0,"value":"View and collaborate in other spaces"}],"email.immediate.external_collab.guest.permission.row.two":[{"type":0,"value":"Leave comments in this space"}],"email.immediate.external_collab.guest.primary.cta":[{"type":0,"value":"Join as a guest"}],"email.immediate.external_collab.guest_added_to_your_space.header.text":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"A guest has been added to your space by "},{"type":1,"value":"originatorName"},{"type":0,"value":"."}]},"other":{"value":[{"type":1,"value":"guestCount"},{"type":0,"value":" guests have been added to your space by "},{"type":1,"value":"originatorName"},{"type":0,"value":"."}]}},"pluralType":"cardinal","type":6,"value":"guestCount"}],"email.immediate.external_collab.guest_added_to_your_space.subject":[{"type":0,"value":"[Confluence] "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"A guest has been added to your space"}]},"other":{"value":[{"type":1,"value":"guestCount"},{"type":0,"value":" guests have been added to your space"}]}},"pluralType":"cardinal","type":6,"value":"guestCount"}],"email.immediate.external_collab.guest_request_access.subject":[{"type":0,"value":"[Confluence] A guest has requested access to your site"}],"email.immediate.external_collab.no_space_access.header.text":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"A guest"}]},"other":{"value":[{"type":1,"value":"displayCount"},{"type":0,"value":" guests"}]}},"pluralType":"cardinal","type":6,"value":"numGuests"},{"type":0,"value":" in "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"b"},{"type":0,"value":" need to be assigned a space in "},{"children":[{"type":0,"value":"Product Settings"}],"type":8,"value":"productSettingsLink"},{"type":0,"value":"."}],"email.immediate.external_collab.no_space_access.subject":[{"type":0,"value":"[Confluence] ACTION REQUIRED: "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"A guest needs access to Confluence"}]},"other":{"value":[{"options":{"25":{"value":[{"type":0,"value":"25+ guests need access to Confluence"}]},"other":{"value":[{"type":1,"value":"numGuests"},{"type":0,"value":" guests need access to Confluence"}]}},"type":5,"value":"numGuests"}]}},"pluralType":"cardinal","type":6,"value":"numGuests"}],"email.immediate.external_collab.space_is_ready.header.text":[{"type":1,"value":"originatorName"},{"type":0,"value":" has invited you to join the following Confluence space as a guest. Join now to start collaborating!"}],"email.immediate.space_request_access.subject":[{"type":1,"value":"requesterName"},{"type":0,"value":" requested access to your space"}],"email.immediate.space_request_access.subject.wants_access":[{"type":1,"value":"requesterName"},{"type":0,"value":" wants access to your space"}]}');

});

parcelRegister("cUcPn", function(module, exports) {
/**
 * This function is being used to address locale discrepancies in Atlassian products:
 * see: https://hello.atlassian.net/wiki/spaces/i18n/pages/528623554/Locale+Discrepancies+Across+Atlassian+Products+and+Platform+Areas
 */ const $cfc2cb470fbdc4fd$export$852ff24d0930c62f = (locale)=>{
    const standardizedLocale = locale.replace('_', '-');
    switch(standardizedLocale){
        case 'en-GB':
        case 'en-US':
        case 'en-XA':
        case 'en-XB':
        case 'en-ZZ':
        case 'pt-BR':
        case 'zh-CN':
        case 'zh-TW':
            return standardizedLocale;
        case 'en-UK':
            return 'en-GB';
        case 'en':
            return 'en-US';
        default:
            return standardizedLocale.split('-')[0];
    }
};
var $cfc2cb470fbdc4fd$export$2e2bcd8739ae039 = $cfc2cb470fbdc4fd$export$852ff24d0930c62f;
module.exports["default"] = $cfc2cb470fbdc4fd$export$2e2bcd8739ae039;

});

parcelRegister("8kiTx", function(module, exports) {

let $60fed91a01a6f2f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $60fed91a01a6f2f9$var$load("cmEvh").then(()=>parcelRequire('eJMch'));

});

parcelRegister("jvwR3", function(module, exports) {

let $e33a65d3bf3c8087$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e33a65d3bf3c8087$var$load("kGe6a").then(()=>parcelRequire('lIfgl'));

});

parcelRegister("9C8Zx", function(module, exports) {

let $6ffea3385200b081$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ffea3385200b081$var$load("liEbx").then(()=>parcelRequire('fjxXr'));

});

parcelRegister("8kSZw", function(module, exports) {

let $611ad91e0e8fe2b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $611ad91e0e8fe2b0$var$load("apfi2").then(()=>parcelRequire('4dhpz'));

});

parcelRegister("7zG2V", function(module, exports) {

let $583c6ac84e538d1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $583c6ac84e538d1d$var$load("3UAAQ").then(()=>parcelRequire('a5bTp'));

});

parcelRegister("8QId8", function(module, exports) {

let $6715796cd0b7450f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6715796cd0b7450f$var$load("eId38").then(()=>parcelRequire('5wZYq'));

});

parcelRegister("bjwpp", function(module, exports) {

let $83ca9bc24c54fdd6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83ca9bc24c54fdd6$var$load("iORSj").then(()=>parcelRequire('7GTVG'));

});

parcelRegister("8AKqi", function(module, exports) {

let $6415b235222e4c4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6415b235222e4c4c$var$load("abMZo").then(()=>parcelRequire('bmIqk'));

});

parcelRegister("7x7cL", function(module, exports) {

let $57c1343b781c7eb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57c1343b781c7eb3$var$load("jp3Ws").then(()=>parcelRequire('aUa54'));

});

parcelRegister("bkYly", function(module, exports) {

let $84105f92aa0593fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84105f92aa0593fd$var$load("EaLw7").then(()=>parcelRequire('ieqQ9'));

});

parcelRegister("7wFnr", function(module, exports) {

let $57ab9e365c9ec956$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57ab9e365c9ec956$var$load("coTiO").then(()=>parcelRequire('3JkaH'));

});

parcelRegister("3V1Pb", function(module, exports) {

let $2da81c4d95df6f85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2da81c4d95df6f85$var$load("eeIOh").then(()=>parcelRequire('eg8NP'));

});

parcelRegister("kFouI", function(module, exports) {

let $f0baa315f92a125d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0baa315f92a125d$var$load("lSbI6").then(()=>parcelRequire('43LZ9'));

});

parcelRegister("6ZWRH", function(module, exports) {

let $518619f3bd090352$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $518619f3bd090352$var$load("lOLkN").then(()=>parcelRequire('5C3EA'));

});

parcelRegister("4VFh8", function(module, exports) {

let $396c80bd370796ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $396c80bd370796ce$var$load("gwnSr").then(()=>parcelRequire('1wbUx'));

});

parcelRegister("cndcR", function(module, exports) {

let $9021e089c7cf8956$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9021e089c7cf8956$var$load("kpj1s").then(()=>parcelRequire('lfVwN'));

});

parcelRegister("3DkR1", function(module, exports) {

let $2a5530d18765ed35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a5530d18765ed35$var$load("hR67m").then(()=>parcelRequire('gi06l'));

});

parcelRegister("9MPOQ", function(module, exports) {

let $7200caeaf229d69c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7200caeaf229d69c$var$load("kJECS").then(()=>parcelRequire('je563'));

});

parcelRegister("hyLnR", function(module, exports) {

let $cc8a5e14a3edc446$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc8a5e14a3edc446$var$load("fvTmy").then(()=>parcelRequire('adhJ7'));

});

parcelRegister("3oVUn", function(module, exports) {

let $27a08858a148876f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27a08858a148876f$var$load("e98eo").then(()=>parcelRequire('3ssVR'));

});

parcelRegister("3DFhF", function(module, exports) {

let $2a6509c0a8042c6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a6509c0a8042c6f$var$load("iK5gt").then(()=>parcelRequire('cVLox'));

});

parcelRegister("jV89E", function(module, exports) {

let $e809aa9059c05409$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e809aa9059c05409$var$load("8Z5RD").then(()=>parcelRequire('8tKXO'));

});

parcelRegister("huRSd", function(module, exports) {

let $cbcf0726e05f9388$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cbcf0726e05f9388$var$load("4kjsP").then(()=>parcelRequire('19u9a'));

});

parcelRegister("5u5SF", function(module, exports) {

let $3fe450df65251bd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fe450df65251bd5$var$load("c7eYR").then(()=>parcelRequire('eA5uI'));

});

parcelRegister("lj2gn", function(module, exports) {

let $f82d20b8ebfcf6ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f82d20b8ebfcf6ba$var$load("5rEWq").then(()=>parcelRequire('9l9Rs'));

});

parcelRegister("jHn1o", function(module, exports) {

let $e573e40dc45549d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e573e40dc45549d3$var$load("irMrU").then(()=>parcelRequire('33X7e'));

});

parcelRegister("572Nz", function(module, exports) {

let $3b8fc6e8962cebdf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b8fc6e8962cebdf$var$load("dRdHv").then(()=>parcelRequire('1bf21'));

});

parcelRegister("3GzWv", function(module, exports) {

let $2af12cd0c62c3ea5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2af12cd0c62c3ea5$var$load("eG6xC").then(()=>parcelRequire('GvfGG'));

});

parcelRegister("1OBpa", function(module, exports) {

let $152779d0fc12b709$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $152779d0fc12b709$var$load("cUuTO").then(()=>parcelRequire('5JfxY'));

});

parcelRegister("f855X", function(module, exports) {

let $b03b8e27fa45c2c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b03b8e27fa45c2c3$var$load("71hqF").then(()=>parcelRequire('kN9QI'));

});

parcelRegister("ilxmD", function(module, exports) {

let $d5b41192c44db602$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5b41192c44db602$var$load("i4BWN").then(()=>parcelRequire('h7BGM'));

});

parcelRegister("dMzjg", function(module, exports) {

let $a08b25d4d9b5108c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a08b25d4d9b5108c$var$load("jDzQz").then(()=>parcelRequire('9PoE4'));

});

parcelRegister("6yFw0", function(module, exports) {

let $4c661f21f977508a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c661f21f977508a$var$load("h9NHf").then(()=>parcelRequire('dXL5C'));

});

parcelRegister("cAlXn", function(module, exports) {

let $9299e0f3e84d948c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9299e0f3e84d948c$var$load("fGQhm").then(()=>parcelRequire('foWLe'));

});

parcelRegister("dJkmj", function(module, exports) {
module.exports = JSON.parse('{"admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.body":[{"type":0,"value":"We\'ve brought the most relevant requests to the top."}],"admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-urm-rank-ra-using-ml-spotlight.heading":[{"type":0,"value":"Review requests quickly"}],"growth-groot.adminhub-request-access-weekly-digest.email.approve-all-cta":[{"type":0,"value":"Approve all"}],"growth-groot.adminhub-request-access-weekly-digest.email.footer.approve-all-cta":[{"type":0,"value":"Approve all"}],"growth-groot.adminhub-request-access-weekly-digest.email.footer.review-all-cta":[{"type":0,"value":"Review all"}],"growth-groot.adminhub-request-access-weekly-digest.email.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Administration."}],"growth-groot.adminhub-request-access-weekly-digest.email.footer.unsubscribe-link":[{"type":0,"value":"Unsubscribe"}],"growth-groot.adminhub-request-access-weekly-digest.email.header.no-dates":[{"type":0,"value":"Recent pending access requests"}],"growth-groot.adminhub-request-access-weekly-digest.email.header.with-dates":[{"type":0,"value":"Recent pending access requests from "},{"type":1,"value":"startDate"},{"type":0,"value":" - "},{"type":1,"value":"endDate"}],"growth-groot.adminhub-request-access-weekly-digest.email.org-icon.alt":[{"type":0,"value":"Organisation icon"}],"growth-groot.adminhub-request-access-weekly-digest.email.overflow-note":[{"type":0,"value":"Showing "},{"type":1,"value":"shown"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" requests"}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.app-requested-label":[{"type":0,"value":"App requested"}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.approve-cta":[{"type":0,"value":"Approve"}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.date-label":[{"type":0,"value":"Date requested"}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.days-ago":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" DAY AGO"}]},"other":{"value":[{"type":7},{"type":0,"value":" DAYS AGO"}]}},"pluralType":"cardinal","type":6,"value":"days"}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.existing-access-label":[{"type":0,"value":"Existing access"}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.requested-by-label":[{"type":0,"value":"Requested by"}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.review-cta":[{"type":0,"value":"Review"}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.summary-fallback":[{"type":0,"value":"Hi, admin \uD83D\uDC4B I\'d like to use "},{"type":1,"value":"requestedProduct"},{"type":0,"value":" to collaborate with my team."}],"growth-groot.adminhub-request-access-weekly-digest.email.request-card.summary-label":[{"type":0,"value":"Summary"}],"growth-groot.adminhub-request-access-weekly-digest.email.review-all-cta":[{"type":0,"value":"Review all"}],"growth-groot.adminhub-request-access-weekly-digest.email.stats.apps-label":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"app"}]},"other":{"value":[{"type":0,"value":"apps"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"growth-groot.adminhub-request-access-weekly-digest.email.stats.oldest-request-value":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"days"}],"growth-groot.adminhub-request-access-weekly-digest.email.stats.pending-days-label":[{"type":0,"value":"pending"}],"growth-groot.adminhub-request-access-weekly-digest.email.stats.requests-plural-label":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"request"}]},"other":{"value":[{"type":0,"value":"requests"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"growth-groot.adminhub-request-access-weekly-digest.email.subject":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" access request is"}]},"other":{"value":[{"type":7},{"type":0,"value":" access requests are"}]}},"pluralType":"cardinal","type":6,"value":"totalPendingCount"},{"type":0,"value":" pending your review"}],"growth-groot.pending-request-access-summary.message-template.in-app-notification.body":[{"type":0,"value":"Approve or deny your users\' requests for app access."}],"growth-groot.pending-request-access-summary.message-template.in-app-notification.heading":[{"type":1,"value":"totalRequests"},{"type":0,"value":" access requests are waiting for review"}],"growth-groot.pending-request-access-summary.message-template.notification-drawer.heading-without-count":[{"type":0,"value":"Access requests are waiting for review"}],"growth-groot.pull-forward-join.message-template.notification-drawer.body.confluence":[{"type":0,"value":"Your admin has opened access for you to join. Find and share knowledge across your team in one place."}],"growth-groot.pull-forward-join.message-template.notification-drawer.body.jira":[{"type":0,"value":"Your admin has opened access for you to join. Track tasks, bugs, and projects with your team."}],"growth-groot.pull-forward-join.message-template.notification-drawer.body.loom":[{"type":0,"value":"Your admin has opened access for you to join. Record your screen and share context with your team."}],"growth-groot.pull-forward-join.message-template.notification-drawer.title":[{"type":1,"value":"productName"},{"type":0,"value":" is now available to you"}],"user.access.settings.access.message.spotlight.content.body":[{"type":0,"value":"Create a message that users in your organization will see when they want to request access to an app."}],"user.access.settings.access.message.spotlight.content.got.it":[{"type":0,"value":"Got it"}],"user.access.settings.access.message.spotlight.content.headline":[{"type":0,"value":"Create an access message"}]}');

});

parcelRegister("ksfN5", function(module, exports) {

let $ee42abe27a03dbbe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee42abe27a03dbbe$var$load("2EtNs").then(()=>parcelRequire('hdw0u'));

});

parcelRegister("1WW3i", function(module, exports) {

let $16b83d280b3030ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $16b83d280b3030ab$var$load("eWeHm").then(()=>parcelRequire('ir5y3'));

});

parcelRegister("8JNw5", function(module, exports) {

let $65c8efa2120b2547$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65c8efa2120b2547$var$load("g7ZJa").then(()=>parcelRequire('8DKDE'));

});

parcelRegister("b4Dfp", function(module, exports) {

let $80fe832fad8c521a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80fe832fad8c521a$var$load("eE62E").then(()=>parcelRequire('3LhCp'));

});

parcelRegister("7N8K6", function(module, exports) {

let $5ac3e41982a65805$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ac3e41982a65805$var$load("lv1Bk").then(()=>parcelRequire('es3YO'));

});

parcelRegister("caZSr", function(module, exports) {

let $8dd66ab13b205a9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8dd66ab13b205a9f$var$load("d55l3").then(()=>parcelRequire('6A3i9'));

});

parcelRegister("7baG8", function(module, exports) {

let $53a1d80e0f25af7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $53a1d80e0f25af7a$var$load("lz84V").then(()=>parcelRequire('2IAb4'));

});

parcelRegister("iG5Z7", function(module, exports) {

let $d990caabda07c5cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d990caabda07c5cb$var$load("j3LfE").then(()=>parcelRequire('7A9F2'));

});

parcelRegister("z0NfQ", function(module, exports) {

let $0693e28eac491a5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0693e28eac491a5c$var$load("3XEhJ").then(()=>parcelRequire('bHbAe'));

});

parcelRegister("lay1O", function(module, exports) {

let $f694ed77ee89f0b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f694ed77ee89f0b8$var$load("llDgL").then(()=>parcelRequire('1LBHL'));

});

parcelRegister("c09TU", function(module, exports) {

let $8bcd2a38cba15758$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8bcd2a38cba15758$var$load("58sqC").then(()=>parcelRequire('70TWY'));

});

parcelRegister("hbyeW", function(module, exports) {

let $c82e061f83ed955f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c82e061f83ed955f$var$load("lDzKw").then(()=>parcelRequire('1uPoa'));

});

parcelRegister("ihfOC", function(module, exports) {

let $d4e61523d66e59b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d4e61523d66e59b1$var$load("1idoH").then(()=>parcelRequire('jzsWR'));

});

parcelRegister("iTVjy", function(module, exports) {

let $dc29d28366cb2820$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc29d28366cb2820$var$load("aRADU").then(()=>parcelRequire('ex3A7'));

});

parcelRegister("jambV", function(module, exports) {

let $df402a356c9f0946$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df402a356c9f0946$var$load("dVjby").then(()=>parcelRequire('4CKzi'));

});

parcelRegister("bgRQf", function(module, exports) {

let $834af42ee262650b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $834af42ee262650b$var$load("ejhOV").then(()=>parcelRequire('LLnIC'));

});

parcelRegister("fkCwb", function(module, exports) {

let $b2969a2b259d0231$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2969a2b259d0231$var$load("k7WuK").then(()=>parcelRequire('12Fue'));

});

parcelRegister("e1R9y", function(module, exports) {

let $a36a63ca5adfa98b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a36a63ca5adfa98b$var$load("1yEPv").then(()=>parcelRequire('5Dkws'));

});

parcelRegister("8y7KT", function(module, exports) {

let $639783c4d14456eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $639783c4d14456eb$var$load("4u6HT").then(()=>parcelRequire('7BBhH'));

});

parcelRegister("llaTT", function(module, exports) {

let $f89403c4735842fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f89403c4735842fa$var$load("anABM").then(()=>parcelRequire('8IXkM'));

});

parcelRegister("bFqV5", function(module, exports) {

let $87e867bce2d707bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87e867bce2d707bc$var$load("49Clp").then(()=>parcelRequire('6ZoVr'));

});

parcelRegister("52S0G", function(module, exports) {

let $3ac708f18336605d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ac708f18336605d$var$load("3kgJe").then(()=>parcelRequire('8n4CU'));

});

parcelRegister("9oOUi", function(module, exports) {

let $6d7dd80a7594e321$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d7dd80a7594e321$var$load("6HXr2").then(()=>parcelRequire('gNexk'));

});

parcelRegister("5NwB0", function(module, exports) {

let $438ad033ceda5bb5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $438ad033ceda5bb5$var$load("tISiS").then(()=>parcelRequire('1hkfJ'));

});

parcelRegister("hEUq2", function(module, exports) {

let $cdb1efb52b539217$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cdb1efb52b539217$var$load("hIl9r").then(()=>parcelRequire('kXEgC'));

});

parcelRegister("7XWIt", function(module, exports) {

let $5ccb96ea2a075d23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ccb96ea2a075d23$var$load("koBp7").then(()=>parcelRequire('gXAFG'));

});

parcelRegister("jFYco", function(module, exports) {

let $e5308aec5aa6f80a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e5308aec5aa6f80a$var$load("8pW1D").then(()=>parcelRequire('PcQsj'));

});

parcelRegister("5sLxi", function(module, exports) {

let $3fa470f40cbfe456$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fa470f40cbfe456$var$load("v2jdI").then(()=>parcelRequire('eqPcR'));

});

parcelRegister("bYnX5", function(module, exports) {

let $8b77e0ac1dec4a74$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b77e0ac1dec4a74$var$load("djK0N").then(()=>parcelRequire('3ApYG'));

});

parcelRegister("fRuEg", function(module, exports) {

let $b8c3945dd8c3406d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8c3945dd8c3406d$var$load("f06Ms").then(()=>parcelRequire('b5wn5'));

});

parcelRegister("etig5", function(module, exports) {

let $a891efdd5b74363c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a891efdd5b74363c$var$load("g74Qa").then(()=>parcelRequire('dzXuS'));

});

parcelRegister("g9XuR", function(module, exports) {

let $bc3ba36a02722c32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc3ba36a02722c32$var$load("ePLv5").then(()=>parcelRequire('7i8wT'));

});

parcelRegister("87dWx", function(module, exports) {

let $5e89cb012104b030$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e89cb012104b030$var$load("6kfQO").then(()=>parcelRequire('fgxGg'));

});

parcelRegister("b66vN", function(module, exports) {

let $81454e5c623d0aa1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81454e5c623d0aa1$var$load("3q2n1").then(()=>parcelRequire('iUWMf'));

});

parcelRegister("i2fPX", function(module, exports) {
module.exports = JSON.parse('{"admin-hub-notifications.dropdown-menu-button.aria-label":[{"type":0,"value":"More actions"}],"admin-hub-notifications.unread-notifications.aria-label":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" unread notification"}]},"other":{"value":[{"type":7},{"type":0,"value":" unread notifications"}]}},"pluralType":"cardinal","type":6,"value":"displayedCount"}],"admin-hub.adminhub-ia-nav-eu-26-onboarding.screen-space-flags.bullet.point.1":[{"type":0,"value":"Connectors is the new home for all connectors and platform tools"}],"admin-hub.adminhub-ia-nav-eu-26-onboarding.screen-space-flags.bullet.point.2":[{"type":0,"value":"AI controls and access settings sit under a new AI and Rovo heading"}],"admin-hub.adminhub-ia-nav-eu-26-onboarding.screen-space-flags.bullet.point.3":[{"type":0,"value":"Related features are grouped into individual pages for increased findability"}],"admin-hub.adminhub-ia-nav-eu-26-onboarding.screen-space-flags.confirm":[{"type":0,"value":"Close"}],"admin-hub.adminhub-ia-nav-eu-26-onboarding.screen-space-flags.description":[{"type":0,"value":"Find what you need faster in Atlassian Administration:"}],"admin-hub.adminhub-ia-nav-eu-26-onboarding.screen-space-flags.title":[{"type":0,"value":"We decluttered the left navigation"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-0":[{"type":0,"value":"Gain insight into your current period, past usage, and 30, 60, 90-day history."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-1":[{"type":0,"value":"Explore usage broken down by apps, features, and individual users."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.body-2":[{"type":0,"value":"Download usage data for in-depth analysis, custom reports, and easy sharing."}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-0":[{"type":0,"value":"Track "},{"type":1,"value":"meterName"},{"type":0,"value":" credits across time"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-1":[{"type":0,"value":"Granular "},{"type":1,"value":"meterName"},{"type":0,"value":" insights"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.heading-2":[{"type":0,"value":"Download usage reports"}],"admin-hub.adminhub-platform-usage-m5-spotlight-tour.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-1":[{"type":0,"value":"Different reports now live in dedicated spaces so you can quickly find what you need."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-2":[{"type":0,"value":"Assess your Data Center instances and get them ready for cloud migration."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-3":[{"type":0,"value":"Monitor and improve the health and performance of your Data Center instances."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.body-4":[{"type":0,"value":"Discover Data Center instances you own based on existing connections."}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-1":[{"type":0,"value":"What\'s new in Portfolio insights"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-2":[{"type":0,"value":"Cloud readiness"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-3":[{"type":0,"value":"Instance health"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.heading-4":[{"type":0,"value":"Detected instances"}],"admin-hub.adminhub-portfolio-insights-nav-spotlight.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-rovo-chat-button-spotlight.body":[{"type":0,"value":"Troubleshoot common tasks with Rovo admin skills. Go to "},{"type":1,"value":"rovoSettings"},{"type":0,"value":" to turn on "},{"type":1,"value":"rovoChatInAdministration"},{"type":0,"value":"."}],"admin-hub.adminhub-rovo-chat-button-spotlight.button-open-rovo-chat":[{"type":0,"value":"Open Rovo Chat"}],"admin-hub.adminhub-rovo-chat-button-spotlight.heading":[{"type":0,"value":"Meet your new admin assistant"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-chat-in-administration":[{"type":0,"value":"Rovo Chat in Administration"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link":[{"type":0,"value":"Rovo settings"}],"admin-hub.adminhub-rovo-chat-button-spotlight.rovo-settings-link-text":[{"type":0,"value":"Rovo settings"}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.body":[{"type":0,"value":"Turn on Rovo Chat to enable it in Atlassian Administration."}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.button-try-it":[{"type":0,"value":"Turn on"}],"admin-hub.adminhub-rovo-chat-toggle-spotlight.heading":[{"type":0,"value":"Turn on Rovo Chat"}],"admin-hub.adminhub-theme-darkmode.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-theme-darkmode.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-theme-darkmode.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-theme-darkmode.spotlight-body-1":[{"type":0,"value":"Reduce glare and boost focus with our sleek new dark theme."}],"admin-hub.adminhub-theme-darkmode.spotlight-body-2":[{"type":0,"value":"Go dark, stay light, or match your browser settings. Give it a try."}],"admin-hub.adminhub-theme-darkmode.spotlight-heading-1":[{"type":0,"value":"Experience dark mode"}],"admin-hub.adminhub-theme-darkmode.spotlight-heading-2":[{"type":0,"value":"Switch themes"}],"admin-hub.adminhub-theme-darkmode.step-count-1":[{"type":0,"value":"1 of 2"}],"admin-hub.adminhub-theme-darkmode.step-count-2":[{"type":0,"value":"2 of 2"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-1-description":[{"type":0,"value":"Take a quick tour to understand what your unit can do."}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-1-title":[{"type":0,"value":"Welcome to your new unit"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-2-description":[{"type":0,"value":"Units are a way to ensure the right people have access to the right apps. Add Atlassian apps, collections and sites to your unit."}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-2-title":[{"type":0,"value":"Unit scoped apps"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-3-description":[{"type":0,"value":"Connections helps you understand which apps outside the unit are integrated and share data with apps inside a unit."}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-3-title":[{"type":0,"value":"Manage data flow"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-4-description":[{"type":0,"value":"Conditional allocation policies let you sync the right users and groups from your identity provider to this unit\'s directory."}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-4-title":[{"type":0,"value":"Allocate IdP users and groups"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-5-description":[{"type":0,"value":"Invite external users or allocate users from your identity provider to this unit\'s directory"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-5-title":[{"type":0,"value":"Unit scoped user directory"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-6-description":[{"type":0,"value":"Create local groups or allocate groups from your identity provider to this unit\'s directory"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-6-title":[{"type":0,"value":"Unit scoped groups directory"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-7-description":[{"type":0,"value":"Your next step in setting up your unit is adding an Atlassian app or collection to this unit"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-7-title":[{"type":0,"value":"Continue your setup"}],"admin-hub.adminhub-unit-create-ga-spotlight-tour.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-list-spotlight-tour-non-vortex.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-list-spotlight-tour-non-vortex.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-list-spotlight-tour-non-vortex.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-list-spotlight-tour-non-vortex.screen-space-flags.step-1-description":[{"type":0,"value":"Your sites have been transformed into units. Each unit contains one of your sites, its apps, users and groups."}],"admin-hub.adminhub-unit-list-spotlight-tour-non-vortex.screen-space-flags.step-1-title":[{"type":0,"value":"Your footprint of units"}],"admin-hub.adminhub-unit-list-spotlight-tour-non-vortex.screen-space-flags.step-2-description":[{"type":0,"value":"You can easily get back to the Units launch guide and continue building out your footprint."}],"admin-hub.adminhub-unit-list-spotlight-tour-non-vortex.screen-space-flags.step-2-title":[{"type":0,"value":"Continue with launch"}],"admin-hub.adminhub-unit-list-spotlight-tour-non-vortex.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-list-spotlight-tour.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-list-spotlight-tour.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-list-spotlight-tour.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-list-spotlight-tour.screen-space-flags.step-1-description":[{"type":0,"value":"All of your existing apps, users and data can be found in units ensuring no users experience downtime as you launch units in your organization."}],"admin-hub.adminhub-unit-list-spotlight-tour.screen-space-flags.step-1-title":[{"type":0,"value":"Your footprint of units"}],"admin-hub.adminhub-unit-list-spotlight-tour.screen-space-flags.step-2-description":[{"type":0,"value":"You can easily get back to the Units launch guide and continue building out your footprint."}],"admin-hub.adminhub-unit-list-spotlight-tour.screen-space-flags.step-2-title":[{"type":0,"value":"Continue with launch"}],"admin-hub.adminhub-unit-list-spotlight-tour.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-profile-connections-tab-ga-spotlight-tour.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-profile-connections-tab-ga-spotlight-tour.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-profile-connections-tab-ga-spotlight-tour.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-profile-connections-tab-ga-spotlight-tour.screen-space-flags.step-1-description":[{"type":0,"value":"Understand and manage which apps outside this unit are integrated and share data across this unit\u2019s boundaries."}],"admin-hub.adminhub-unit-profile-connections-tab-ga-spotlight-tour.screen-space-flags.step-1-title":[{"type":0,"value":"Manage data flow"}],"admin-hub.adminhub-unit-profile-connections-tab-ga-spotlight-tour.screen-space-flags.step-2-description":[{"type":0,"value":"Continue your unit tour by clicking the Users tab."}],"admin-hub.adminhub-unit-profile-connections-tab-ga-spotlight-tour.screen-space-flags.step-2-title":[{"type":0,"value":"Click the Users tab"}],"admin-hub.adminhub-unit-profile-connections-tab-ga-spotlight-tour.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-1-description":[{"type":0,"value":"You can create or allocate identity provider groups to this unit\'s directory to streamline access control to apps in this unit."}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-1-title":[{"type":0,"value":"Unit-scoped groups"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-2-description":[{"type":0,"value":"Groups created manually in this unit are local to this unit and aren\'t shared with any other unit."}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-2-title":[{"type":0,"value":"Create a group"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-3-description":[{"type":0,"value":"Continue your unit tour by clicking the Settings tab."}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-3-title":[{"type":0,"value":"Click the Settings tab"}],"admin-hub.adminhub-unit-profile-groups-tab-spotlight-tour.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.step-1-description":[{"type":0,"value":"You\u2019ll find a bunch of important options you can set on your unit in the Settings tab, like theme settings or data residency location."}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.step-1-title":[{"type":0,"value":"Configure your unit"}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.step-2-description":[{"type":0,"value":"Users see units in the navigation and app switcher. We recommend adding icons, easy-to-understand names, and descriptions so users can easily recognize them."}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.step-2-title":[{"type":0,"value":"Theme your units"}],"admin-hub.adminhub-unit-profile-settings-tab-spotlight-tour.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.button-back":[{"type":0,"value":"Back"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.button-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.button-next":[{"type":0,"value":"Next"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-1-description":[{"type":0,"value":"Invite or allocate users to this unit\u2019s directory so the right people can collaborate together."}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-1-title":[{"type":0,"value":"Unit-scoped users"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-2-description":[{"type":0,"value":"Delegate control by assigning unit administrators to manage apps and people in this unit."}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-2-title":[{"type":0,"value":"Assign unit administrators"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-3-description":[{"type":0,"value":"Invite users synced from your identity provider or external accounts by email."}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-3-title":[{"type":0,"value":"Invite users to this unit"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-4-description":[{"type":0,"value":"Continue your unit tour by clicking the Groups tab."}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-4-title":[{"type":0,"value":"Click the Groups tab"}],"admin-hub.adminhub-unit-profile-users-tab-ga-spotlight-tour.screen-space-flags.step-count":[{"type":1,"value":"step"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"admin-hub.adminhub-unit-side-nav-spotlight-tour.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"admin-hub.adminhub-unit-side-nav-spotlight-tour.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.close":[{"type":0,"value":"Close"}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.community-post-link":[{"type":0,"value":"Read our community post"}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.description.no-translate":[{"type":0,"value":"Units create collaboration boundaries within your organization. Explore the onboarding guide to understand what changes when you create your first unit and plan your setup."}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.show-me":[{"type":0,"value":"Show me"}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.spotlight-description":[{"type":0,"value":"Organize apps and users into units to define collaboration boundaries."}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.spotlight-done":[{"type":0,"value":"Done"}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.spotlight-title":[{"type":0,"value":"Manage your units"}],"admin-hub.adminhub-units-ga-onboarding-modal.screen-space-flags.title.no-translate":[{"type":0,"value":"Create collaboration boundary"}],"adminhub.inbox.recommendations.placement.empty-state.description":[{"type":0,"value":"Recommendations help you follow best practices for your organization. We\u2019ll let you know here when there are new ways to improve your security and setup."}],"adminhub.inbox.recommendations.placement.empty-state.header":[{"type":0,"value":"Improve your organization with recommendations"}],"adminhub.inbox.recommendations.placement.error-state.description":[{"type":0,"value":"Try refreshing the page. If this keeps happening, "},{"children":[{"type":0,"value":"contact support"}],"type":8,"value":"support"},{"type":0,"value":"."}],"adminhub.inbox.recommendations.placement.error-state.header":[{"type":0,"value":"We\u2019re not sure what went wrong"}],"adminhub.inbox.recommendations.placement.header":[{"type":0,"value":"Recommendations"}],"adminhub.inbox.recommendations.placement.loading":[{"type":0,"value":"Loading recommendations"}],"ai-3p-connector-action-required.admin-hub-notifications.actionLink":[{"type":0,"value":"Go to connector settings"}],"ai-3p-connector-action-required.admin-hub-notifications.body":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector is still syncing, but a configuration issue needs your review. Some content may not be included as intended until it\'s resolved. Go to the connector setting and select the "},{"children":[{"type":0,"value":"Action required"}],"type":8,"value":"b"},{"type":0,"value":" status on your connector to see what needs attention and how to fix it."}],"ai-3p-connector-action-required.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector needs attention"}],"ai-3p-connector-draft-reminder.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors page"}],"ai-3p-connector-draft-reminder.admin-hub-notifications.body":[{"type":0,"value":"You started setting up your "},{"children":[{"type":1,"value":"connectorType"}],"type":8,"value":"b"},{"type":0,"value":" connector but didn\u2019t finish. Finish setting up the draft so your connector can be used in Rovo."}],"ai-3p-connector-draft-reminder.admin-hub-notifications.heading":[{"type":0,"value":"Finish setting up your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"}],"ai-3p-connector-github-unlock-in-app-notification.admin-hub-notifications.actionLink":[{"type":0,"value":"Set up GitHub in Rovo"}],"ai-3p-connector-github-unlock-in-app-notification.admin-hub-notifications.body":[{"options":{"other":{"value":[{"type":0,"value":"Your site can now bring its GitHub data into Rovo Search, Chat, and Agents."}]},"true":{"value":[{"type":0,"value":"Your site "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"b"},{"type":0,"value":" can now bring its GitHub data into Rovo Search, Chat, and Agents."}]}},"type":5,"value":"hasSiteName"},{"type":0,"value":" Follow the guided setup to get started. Indexing doesn\u2019t use Rovo credits."}],"ai-3p-connector-github-unlock-in-app-notification.admin-hub-notifications.heading":[{"type":0,"value":"Make your GitHub data available in Rovo"}],"ai-3p-connector-github-unlock-in-app-notification.admin-hub-notifications.secondaryButtonLink":[{"type":0,"value":"Learn more"}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.actionLink":[{"type":0,"value":"Go to connector settings"}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.body":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"},{"options":{"other":{"value":[]},"true":{"value":[{"type":0,"value":" on "},{"type":1,"value":"cloudUrl"}]}},"type":5,"value":"hasCloudUrl"},{"type":0,"value":" is currently experiencing issues and cannot sync data from "},{"type":1,"value":"connectorType"},{"type":0,"value":"."}],"ai-3p-connector-healthcheck-failure.admin-hub-notifications.heading":[{"type":0,"value":"Action required: Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" Teamwork Graph connector needs attention"}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors"}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.body":[{"type":0,"value":"Good news! Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector"},{"options":{"other":{"value":[]},"true":{"value":[{"type":0,"value":" on "},{"type":1,"value":"cloudUrl"}]}},"type":5,"value":"hasCloudUrl"},{"type":0,"value":" has recovered and is now syncing data normally. No further action is required."}],"ai-3p-connector-healthcheck-recovery.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" Teamwork Graph connector is back online"}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.actionLink":[{"type":0,"value":"View your connectors"}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.body":[{"type":0,"value":"We\'ve finished the initial sync of your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector and ingested everything your connector configuration allows. Your data is now searchable in Rovo - try asking a question or running a search to see it in action."}],"ai-3p-connector-initial-scan-completed.admin-hub-notifications.heading":[{"type":0,"value":"Your "},{"type":1,"value":"connectorType"},{"type":0,"value":" connector\'s initial sync is complete"}],"brie-automated-restore-failed.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the automated restore test for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" run on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This may affect your ability to recover data if needed. Review restore test view more details."}],"brie-automated-restore-failed.admin-hub-notifications.heading":[{"type":0,"value":"Automated restore test did not complete"}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.action":[{"type":0,"value":"Check Backup"}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.body":[{"type":0,"value":"You can view details in the attached report or download the report for "},{"type":1,"value":"product"},{"type":0,"value":"."}],"brie-backup-completed-admin-hub-in-app.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" backup "},{"type":1,"value":"status"},{"type":0,"value":" for "},{"type":1,"value":"cloudUrl"}],"brie-backup-failed.admin-hub-notifications.body":[{"type":0,"value":"The backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" failed on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This means your latest data may not be protected. Review backup job to view more details."}],"brie-backup-failed.admin-hub-notifications.heading":[{"type":0,"value":"Backup failed"}],"brie-backup-incomplete.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". This means your latest data may not be protected. Review backup job to view more details."}],"brie-backup-incomplete.admin-hub-notifications.heading":[{"type":0,"value":"Backup did not complete"}],"brie-restore-completed-successfully.admin-hub-notifications.body":[{"type":0,"value":"The restore job for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" finished successfully. Review restore job to view more details."}],"brie-restore-completed-successfully.admin-hub-notifications.heading":[{"type":0,"value":"Restore complete"}],"brie-restore-failed.admin-hub-notifications.body":[{"type":0,"value":"The restore for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" that started at "},{"type":1,"value":"startTime"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":" has failed. Review restore job to view more details."}],"brie-restore-failed.admin-hub-notifications.heading":[{"type":0,"value":"Restore failed"}],"brie-restore-incomplete.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t complete the restore for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" started at "},{"type":1,"value":"startTime"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":". Review restore job to view more details."}],"brie-restore-incomplete.admin-hub-notifications.heading":[{"type":0,"value":"Restore did not complete"}],"brie-scheduler-halted-access-issue.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t run the scheduled backup for "},{"type":1,"value":"cloudUrl"},{"type":0,"value":" on "},{"type":1,"value":"jobStartTimeTimestamp"},{"type":0,"value":" due to a user access issue. This means your latest data may not be protected."}],"brie-scheduler-halted-access-issue.admin-hub-notifications.heading":[{"type":0,"value":"Scheduled backup could not run"}],"commerce.commerce-soft-limit-breach-ccp.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" is over the user limit"}],"commerce.commerce-soft-limit-breach-ccp.body-default.no-translate":[{"type":0,"value":"We recommend removing users as soon as possible if you don\'t want to automatically upgrade user tiers"}],"encryption.policy-page.spotlight.apps":[{"type":0,"value":"Your CMK encrypted apps will appear here."}],"encryption.policy-page.spotlight.back":[{"type":0,"value":"Back"}],"encryption.policy-page.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"encryption.policy-page.spotlight.done":[{"type":0,"value":"Done"}],"encryption.policy-page.spotlight.next":[{"type":0,"value":"Next"}],"encryption.policy-page.spotlight.tenantIdVpce":[{"type":0,"value":"Update your AWS KMS key policy with Encryption Tenant Identifier-tag pair and VPC endpoint(s) to enhance security."}],"growth-groot.pending-request-access-summary.admin-hub-notification.body":[{"type":0,"value":"Approve or deny your users\' requests for app access."}],"growth-groot.pending-request-access-summary.admin-hub-notification.heading":[{"type":1,"value":"totalRequests"},{"type":0,"value":" access requests are waiting for review"}],"placement.admin-hub-notifications.button.markAsRead":[{"type":0,"value":"Mark all as read"}],"placement.admin-hub-notifications.give-feedback":[{"type":0,"value":"Give feedback"}],"placement.admin-hub-notifications.learn-more.beta":[{"type":0,"value":"About this feature"}],"placement.admin-hub-notifications.main-heading":[{"type":0,"value":"Notifications"}],"placement.admin-hub-notifications.mark-as-read-tooltip":[{"type":0,"value":"Mark as read"}],"placement.admin-hub-notifications.mark-as-unread-tooltip":[{"type":0,"value":"Mark as unread"}],"post-office.access-invalid-payment.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.access-invalid-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.access-missing-payment.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.access-missing-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.actionLink":[{"type":0,"value":"Regenerate key"}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.body":[{"type":0,"value":"Regenerate key for "},{"type":1,"value":"directoryName"},{"type":0,"value":" to continue customer provisioning."}],"post-office.admin-hub-expiring-customer-account-scim-tokens.notification.header":[{"type":0,"value":"Your SCIM API key will expire on "},{"type":1,"value":"expirationDate"},{"type":0,"value":"."}],"post-office.admin-hub-expiring-scim-tokens.notification.actionLink":[{"type":0,"value":"Regenerate key"}],"post-office.admin-hub-expiring-scim-tokens.notification.body":[{"type":0,"value":"Regenerate key for "},{"type":1,"value":"directoryName"},{"type":0,"value":" to continue user provisioning."}],"post-office.admin-hub-expiring-scim-tokens.notification.header":[{"type":0,"value":"Your SCIM API key will expire on "},{"type":1,"value":"expirationDate"},{"type":0,"value":"."}],"post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.body.non-final":[{"type":1,"value":"requesterName"},{"type":0,"value":" requested org admin permissions for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"post-office.admin-hub-permissions-notification-shipit.admin-hub-notifications.heading.non-final":[{"type":0,"value":"Org Admin Request"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.body":[{"type":0,"value":"We\'ve found "},{"children":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" Atlassian app"}]},"other":{"value":[{"type":7},{"type":0,"value":" Atlassian apps"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"type":8,"value":"strong"},{"type":0,"value":" that might belong to your portfolio. Review and connect them to get more insights. "}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.admin-hub-notifications.heading":[{"type":0,"value":"Detected "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" Atlassian app"}]},"other":{"value":[{"type":7},{"type":0,"value":" Atlassian apps"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered-appified.notification.buttonText":[{"type":0,"value":"Review detected apps"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.body":[{"type":0,"value":"We\'ve found "},{"children":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" product"}]},"other":{"value":[{"type":7},{"type":0,"value":" products"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"type":8,"value":"strong"},{"type":0,"value":" that might belong to your portfolio. Review and connect them to get more insights. "}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.admin-hub-notifications.heading":[{"type":0,"value":"Detected "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" product"}]},"other":{"value":[{"type":7},{"type":0,"value":" products"}]}},"pluralType":"cardinal","type":6,"value":"products"}],"post-office.admin-hub-portfolio-analyzer-new-product-discovered.notification.buttonText":[{"type":0,"value":"Review detected products"}],"post-office.adminhub-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.body":[{"type":0,"value":"We\'re consolidating groups and teams visibility to support future improvements and features. Assign teams to a site to avoid losing team data."}],"post-office.adminhub-scope-alignment-reminder.admin-hub-notifications.heading":[{"type":0,"value":"Teams must be assigned to sites"}],"post-office.adminhub-scope-alignment-reminder.notification.buttonText":[{"type":0,"value":"Assign teams"}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.body":[{"type":0,"value":"As a result, some features will be restricted or unavailable until your allowance resets."}],"post-office.commerce-cbp-hard-limit-breach-ccp-breach.admin-hub-notifications.heading":[{"type":1,"value":"chargeElement"},{"type":0,"value":" limit reached"}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-cbp-hard-limit-breach-ccp-milestone.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit has been used"}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.action":[{"type":0,"value":"Review new bill"}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.body":[{"type":0,"value":"You can now be billed for this app based on the number of Jira Service Management agents, instead of Jira users. If you don\'t switch to the new way of billing, we\'ll transition you automatically soon."}],"post-office.commerce-decoupled-offering-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Move to a new way of billing for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management"}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.action":[{"type":0,"value":"View subscription"}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.body":[{"type":0,"value":"The way you\'re billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management has been updated, which means you\'re now billed based on the number of JSM agents who have access to the app. Organization admins can view and manage user access in Atlassian Administration."}],"post-office.commerce-decoupled-offering-order-confirmation-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Enjoy more control over billing for "},{"type":1,"value":"productName"},{"type":0,"value":" for JSM"}],"post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.body":[{"type":0,"value":"You can start your download by clicking here"}],"post-office.commerce-invoice-json-download-ppc.admin-hub-notifications.heading":[{"type":0,"value":"JSON file for invoice ["},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"] is ready"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.body":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlement"},{"type":0,"value":" purchase."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple-different-trial-lengths.admin-hub.notification.header":[{"type":0,"value":"Try "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" free"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.body":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlement"},{"type":0,"value":" purchase."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-multiple.admin-hub.notification.header":[{"type":0,"value":"Try "},{"type":1,"value":"entitlementOne"},{"type":0,"value":" & "},{"type":1,"value":"entitlementTwo"},{"type":0,"value":" "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.body":[{"type":0,"value":"Tired of hunting for the right doc? Build a single source of truth for your team\u2019s info with Confluence "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-confluence.admin-hub.notification.header":[{"type":0,"value":"Try Confluence"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.body":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. Try the "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" plan free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jira.admin-hub.notification.header":[{"type":0,"value":"Try Jira"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.body":[{"type":0,"value":"Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jpd.admin-hub.notification.header":[{"type":0,"value":"Try Jira Product Discovery"}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.body":[{"type":0,"value":"Bring developers, IT, and ops on the same tool and make work visible across teams with the "},{"type":1,"value":"entitlementOneOfferingName"},{"type":0,"value":" plan. Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":"."}],"post-office.commerce-marketing-multiple-product-upgrade-ccp-single-jsm.admin-hub.notification.header":[{"type":0,"value":"Try Jira Service Management"}],"post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.body":[{"type":0,"value":"We\u2019ll need a payment method before "},{"type":1,"value":"lastDate"},{"type":0,"value":" to start the migration, otherwise migration will be cancelled automatically"}],"post-office.commerce-migration-opsgenie-ccp.admin-hub.notification.header.heading":[{"type":0,"value":"Migrating Opsgenie to "},{"type":1,"value":"targetProductName"},{"type":0,"value":", bill approval pending"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-no-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\'re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount-appify.admin-hub.notification.header.heading":[{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount applied on your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.body":[{"type":0,"value":"We\'re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount on your Atlassian Guard subscription for one year and the estimated bill may have changed. Review the bill estimate based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-partial-discount.admin-hub.notification.header.heading":[{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount applied on your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud app on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount-appify.notification.secondary-action":[{"type":0,"value":"Download Report"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ll migrate from Opsgenie to your Atlassian cloud product on "},{"type":1,"value":"migrationDate"},{"type":0,"value":"."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-ag-review-partial-discount.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-no-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the potential increase in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\u2019re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of the discounted Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.body":[{"type":0,"value":"We\u2019re providing a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"discountPercentage"},{"type":0,"value":" discount for one year on your Atlassian Guard subscription. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of the discounted Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount-appify.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.body":[{"type":0,"value":"Ensure the bill estimate of your subscription is correct based on the number of users who\u2019ve migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the changes in your bill estimate"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.manage-users":[{"type":0,"value":"Manage users"}],"post-office.commerce-migration-opsgenie-generic-ccp-existing-configured-ag-review-partial-discount.notification.review-subscription":[{"type":0,"value":"Review subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with a "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Review the subscription plan."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"A new Atlassian Guard subscription has been activated"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who\u2019ll use Atlassian Guard."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-ag-review-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Configure your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud app."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount-appify.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of your newly activated Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription with "},{"style":{"parsedOptions":{"maximumFractionDigits":1,"style":"percent"},"tokens":[{"options":[],"stem":"percent"},{"options":[],"stem":".#"}],"type":0},"type":2,"value":"fullDiscountPercentage"},{"type":0,"value":" discount for one year. Ensure the bill estimate is correct based on the number of users migrated from Opsgenie to your Atlassian cloud product."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Review the bill estimate of your newly activated Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.body":[{"type":0,"value":"We\'ve activated a new Atlassian Guard subscription for your Jira Service Management Premium account. Verify the domains and review the list of users who\u2019ll use Atlassian Guard."}],"post-office.commerce-migration-opsgenie-generic-ccp-new-configured-ag-review-full-discount.admin-hub.notification.header.heading":[{"type":0,"value":"Configure your Atlassian Guard subscription"}],"post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.body":[{"type":1,"value":"bodyContent"}],"post-office.commerce-migration-opsgenie-generic-ccp.admin-hub.notification.header.heading":[{"type":1,"value":"titleContent"}],"post-office.commerce-payment-failure-hams-atlassian-access-paid.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid losing your Atlassian Access security settings, update your payment details."}],"post-office.commerce-payment-failure-hams-atlassian-access-paid.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid losing your Atlassian Access security settings, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-atlassian-access-trial.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-multi-product-paid.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions for this site ("},{"type":1,"value":"siteUrl"},{"type":0,"value":") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-hams-multi-product-paid.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-hams-multi-product-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for subscriptions for this site ("},{"type":1,"value":"siteUrl"},{"type":0,"value":"). To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-multi-product-trial.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-hams-single-product-paid.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-hams-single-product-trial.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-trials-multi-product-invalid-payment.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions on your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-trials-multi-product-invalid-payment.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-trials-multi-product-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscriptions on your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"). To avoid your subscriptions being deactivated, add payment details as soon as possible."}],"post-office.commerce-payment-failure-trials-multi-product-missing-payment.heading":[{"type":0,"value":"Payment failed for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-payment-failure-trials-single-product-invalid-payment.body":[{"type":0,"value":"We couldn\u2019t process payment for subscription due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details."}],"post-office.commerce-payment-failure-trials-single-product-invalid-payment.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-payment-failure-trials-single-product-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details."}],"post-office.commerce-payment-failure-trials-single-product-missing-payment.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.body.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"post-office.commerce-permission-request-add-payment-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Request to add payment from "},{"type":1,"value":"name"}],"post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.body.no-translate":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"post-office.commerce-permission-request-add-payment-response-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Payment details added by billing admin"}],"post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.body.no-translate":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"children":[{"type":1,"value":"email"}],"type":8,"value":"b"},{"type":0,"value":") requested billing admin permission."}],"post-office.commerce-permission-request-grant-ba-role-ccp.admin-hub-notifications.heading":[{"type":0,"value":"Billing admin access requested"}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.body":[{"type":0,"value":"Your billing admin request was approved."}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-approved.admin-hub-notifications.heading":[{"type":0,"value":"You\'re now a billing admin"}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.body":[{"type":0,"value":"Your billing admin request was declined. If needed, you can submit another request."}],"post-office.commerce-permission-request-grant-ba-role-response-ccp-declined.admin-hub-notifications.heading":[{"type":0,"value":"Your request to be a billing admin was declined"}],"post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for some of your subscriptions. To avoid your subscriptions being deactivated, add payment details as soon as possible."}],"post-office.commerce-pre-dunning-ccp-multi-trial-missing-payment.heading":[{"type":0,"value":"Your trial expired for "},{"type":1,"value":"product"},{"type":0,"value":" +"},{"type":1,"value":"remainingProducts"},{"type":0,"value":" more"}],"post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add payment details as soon as possible."}],"post-office.commerce-pre-dunning-ccp-single-trial-missing-payment.heading":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" trial expired"}],"post-office.commerce-quote-json-download-ppc.admin-hub-notifications.body":[{"type":0,"value":"You can start your download by clicking here"}],"post-office.commerce-quote-json-download-ppc.admin-hub-notifications.heading":[{"type":0,"value":"JSON file for quote ["},{"type":1,"value":"quoteNumber"},{"type":0,"value":"] is ready"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-breach.admin-hub-notifications.heading":[{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance reached"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.body":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance. Monitor your org\u2019s usage in Atlassian Administration."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-milestone.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of "},{"type":1,"value":"chargeElement"},{"type":0,"value":" allowance used"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-pooled-meter-announce-view-usage.admin-hub-notifications.action":[{"type":0,"value":"View usage"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.action":[{"type":0,"value":"Request upgrade"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.body":[{"type":0,"value":"Rovo Dev will be disabled for users who reach their limit. Allow more credits by requesting an upgrade to Rovo Dev Standard."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rde.admin-hub-notifications.heading":[{"type":0,"value":"Upgrade Rovo Dev users to avoid interruption"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.body":[{"type":0,"value":"At least one user has reached "},{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of their Rovo Dev credit limit. If extra usage is enabled, extra charges will apply to use over the limit. Otherwise, Rovo Dev will be disabled for those users."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds-mileStone-generic.admin-hub-notifications.heading":[{"type":1,"value":"usageMileStone"},{"type":0,"value":"% of Rovo Dev credits used"}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.body":[{"type":0,"value":"If an extra usage limit has been set, Rovo Dev usage will be disabled for those users. Otherwise, charges will apply for extra usage."}],"post-office.commerce-rovo-dev-usage-limit-breach-reminder-ccp-rds.admin-hub-notifications.heading":[{"type":0,"value":"Users have reached their Rovo Dev credit limit"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.body":[{"type":0,"value":"A "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been added to your billing account ("},{"type":1,"value":"transactionAccountNumber"},{"type":0,"value":"). You can move it to a different billing account until your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"post-office.commerce-subscription-paid-trials-no-payment-method-ccp.admin-hub-notifications.heading":[{"type":0,"value":"New subscription added to your account"}],"post-office.common.email.body.sent-by-atlassian-cloud.footer.org-id":[{"type":0,"value":" (ID: "},{"type":1,"value":"orgId"},{"type":0,"value":")"}],"post-office.common.email.body.sent-by-atlassian-cloud.footer.text":[{"type":0,"value":"This message was sent to you by Atlassian Administration. You are receiving this email because you are an admin for "},{"type":1,"value":"orgName"}],"post-office.et-domain-verification-missing-token.admin-hub.notification.body":[{"type":0,"value":"We\'re unable to verify that you own "},{"children":[{"type":1,"value":"domain"}],"type":8,"value":"strong"},{"type":0,"value":" due to missing tokens. Verify this domain to keep your managed accounts."}],"post-office.et-domain-verification-missing-token.admin-hub.notification.header":[{"type":0,"value":"Domain will be unverified in "},{"type":1,"value":"remainingDays"},{"type":0,"value":" days"}],"post-office.et-domain-verification-token-revoked.admin-hub.notification.body":[{"children":[{"type":1,"value":"domain"}],"type":8,"value":"strong"},{"type":0,"value":" is no longer verified. Accounts with this domain are now unmanaged. Verify the domain again to claim these accounts."}],"post-office.et-domain-verification-token-revoked.admin-hub.notification.header":[{"type":0,"value":"Domain has been unverified"}],"post-office.generic-invalid-payment.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription because of an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.generic-invalid-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.generic-missing-payment.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have payment details for your subscription. To avoid your subscription being deactivated, add payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.generic-missing-payment.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.multi-generic-invalid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for subscriptions on this site "},{"type":1,"value":"siteUrl"},{"type":0,"value":" due to an issue with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.multi-generic-invalid.admin-hub-notifications.heading":[{"type":0,"value":"Payment failed"}],"post-office.multi-generic-missing.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for subscriptions on this site "},{"type":1,"value":"siteUrl"},{"type":0,"value":". To avoid your subscription being deactivated, add payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.multi-generic-missing.admin-hub-notifications.heading":[{"type":0,"value":"Payment failed"}],"post-office.one-admin-left-notification.admin-hub.notification.body":[{"type":0,"value":"You\'re the only organization admin for this organization. Add another admin to avoid being locked out if you lose access."}],"post-office.one-admin-left-notification.admin-hub.notification.header":[{"type":0,"value":"Only one organization admin"}],"post-office.one-admin-left-notification.admin-hub.notification.how-to-add-admin-link":[{"type":0,"value":"How to add an admin"}],"post-office.one-admin-left-notification.notification.add-another-admin-link":[{"type":0,"value":"Add another organization admin"}],"post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.body":[{"type":0,"value":"You can view the PVR registration by clicking here"}],"post-office.partner-unified-xp-pvr-registrations.admin-hub-notifications.heading":[{"type":0,"value":"PVR registration "},{"type":1,"value":"pvrNumber"},{"type":0,"value":" submitted by "},{"type":1,"value":"submittedBy"}],"post-office.pure-dynamic-template.admin-hub.notification.body.no-translate":[{"type":1,"value":"bodyText"}],"post-office.pure-dynamic-template.admin-hub.notification.header.heading.no-translate":[{"type":1,"value":"headingText"}],"post-office.single-generic-invalid.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process payment for your subscription due to a problem with your payment details. To avoid your subscription being deactivated, update your payment details by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.single-generic-invalid.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.single-generic-missing.admin-hub-notifications.body":[{"type":0,"value":"We don\u2019t have a payment method for your subscription. To avoid your subscription being deactivated, add a payment method by "},{"type":1,"value":"paymentDue"},{"type":0,"value":"."}],"post-office.single-generic-missing.admin-hub-notifications.heading":[{"type":1,"value":"product"},{"type":0,"value":" payment failed"}],"post-office.three-ds-payment-failure.admin-hub-notifications.body":[{"type":0,"value":"We couldn\u2019t process your payment since we need your help to complete 3-D Secure (3DS) authentication."}],"post-office.three-ds-payment-failure.admin-hub-notifications.heading":[{"type":0,"value":"3DS payment failure"}],"post-office.townsquare-goals-request-trial.admin-hub-notifications.body":[{"type":0,"value":"Hi, I\u2019d like to try goals in the early access program. I think it can help the team save time and work better together. It\u2019s free to try if we\u2019re eligible."}],"post-office.townsquare-goals-request-trial.admin-hub-notifications.heading":[{"type":1,"value":"requesterName"},{"type":0,"value":" sent an approval request."}],"toggleLabel":[{"type":0,"value":"Only show unread"}]}');

});

parcelRegister("bRqeA", function(module, exports) {

let $8a28fe8c393ddb21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a28fe8c393ddb21$var$load("eWLcK").then(()=>parcelRequire('gDRIW'));

});

parcelRegister("9jD1I", function(module, exports) {

let $6c84294fe1449a2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c84294fe1449a2e$var$load("2T0W4").then(()=>parcelRequire('eLcdP'));

});

parcelRegister("cZ3uF", function(module, exports) {

let $973de44f60c63e00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $973de44f60c63e00$var$load("9IIJ7").then(()=>parcelRequire('hsgqZ'));

});

parcelRegister("dmPno", function(module, exports) {

let $9bb52eb19c634fb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9bb52eb19c634fb1$var$load("cugua").then(()=>parcelRequire('2cqmf'));

});

parcelRegister("d63z9", function(module, exports) {

let $988e9a031bfd1ae2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $988e9a031bfd1ae2$var$load("iyIG8").then(()=>parcelRequire('gg1CP'));

});

parcelRegister("dYrFI", function(module, exports) {

let $a2c658084fc618b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2c658084fc618b6$var$load("hHL2G").then(()=>parcelRequire('9MLdd'));

});

parcelRegister("fwUrk", function(module, exports) {

let $b4e59fee03185fa7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b4e59fee03185fa7$var$load("jfwui").then(()=>parcelRequire('1HcFC'));

});

parcelRegister("aSvJn", function(module, exports) {

let $7eb78fa428dbd579$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7eb78fa428dbd579$var$load("2UlhK").then(()=>parcelRequire('4rvnJ'));

});

parcelRegister("hJ4rW", function(module, exports) {

let $ce7a173b27c8720f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce7a173b27c8720f$var$load("hh17O").then(()=>parcelRequire('14rsg'));

});

parcelRegister("57BZh", function(module, exports) {

let $3bab12b70bab94d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3bab12b70bab94d2$var$load("YsXtp").then(()=>parcelRequire('fjU0o'));

});

parcelRegister("48G6M", function(module, exports) {

let $3038929a9af5be47$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3038929a9af5be47$var$load("opvyH").then(()=>parcelRequire('hXkW3'));

});

parcelRegister("ce9jn", function(module, exports) {

let $8e6e03e4daac3137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e6e03e4daac3137$var$load("8BxCK").then(()=>parcelRequire('etu66'));

});

parcelRegister("8uzv1", function(module, exports) {

let $62eca984292b7364$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62eca984292b7364$var$load("dA5Gb").then(()=>parcelRequire('gOGuu'));

});

parcelRegister("kvD9W", function(module, exports) {

let $eee5141fa9689947$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eee5141fa9689947$var$load("61IAr").then(()=>parcelRequire('kVpQP'));

});

parcelRegister("8ala4", function(module, exports) {

let $5f1fac1f26bd4a1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f1fac1f26bd4a1e$var$load("ga2TL").then(()=>parcelRequire('kE3gq'));

});

parcelRegister("hhTMG", function(module, exports) {

let $c95f4bc9aa5540df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c95f4bc9aa5540df$var$load("652oW").then(()=>parcelRequire('4JU8n'));

});

parcelRegister("j9FdF", function(module, exports) {

let $df1ed4e5113be7c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df1ed4e5113be7c5$var$load("1rWCo").then(()=>parcelRequire('763ky'));

});

parcelRegister("8DcID", function(module, exports) {

let $648bd4f65e3b8329$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $648bd4f65e3b8329$var$load("38R1r").then(()=>parcelRequire('ii5Pq'));

});

parcelRegister("g93PL", function(module, exports) {

let $bc1075efdaf2e9af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc1075efdaf2e9af$var$load("jJJBm").then(()=>parcelRequire('8dH9J'));

});

parcelRegister("38C5h", function(module, exports) {

let $248fa92f2ba8577d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $248fa92f2ba8577d$var$load("4Owtx").then(()=>parcelRequire('lzUbJ'));

});

parcelRegister("1j6R2", function(module, exports) {

let $0f3ce1f454ddc8a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f3ce1f454ddc8a7$var$load("h4PCn").then(()=>parcelRequire('66Wiy'));

});

parcelRegister("db8Mq", function(module, exports) {

let $99831cfe73a3fd85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99831cfe73a3fd85$var$load("3CP92").then(()=>parcelRequire('2gIVQ'));

});

parcelRegister("dAssT", function(module, exports) {

let $9e44b7bc9937b176$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e44b7bc9937b176$var$load("bWTZH").then(()=>parcelRequire('8grab'));

});

parcelRegister("hXhj2", function(module, exports) {

let $d1255efd8488ee2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1255efd8488ee2e$var$load("jNYJM").then(()=>parcelRequire('62WZV'));

});

parcelRegister("ijv9f", function(module, exports) {

let $d55229b903d397e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d55229b903d397e6$var$load("JFzIm").then(()=>parcelRequire('3mhE7'));

});

parcelRegister("bwFNp", function(module, exports) {

let $86431aad7348782e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86431aad7348782e$var$load("fADOz").then(()=>parcelRequire('f97jT'));

});

parcelRegister("7EuHF", function(module, exports) {

let $592415e0ecd48a53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $592415e0ecd48a53$var$load("fzfXk").then(()=>parcelRequire('cXi1a'));

});

parcelRegister("824Zb", function(module, exports) {

let $5d9260bd71d6fd94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5d9260bd71d6fd94$var$load("hJXks").then(()=>parcelRequire('3bENj'));

});

parcelRegister("3Vtyt", function(module, exports) {

let $2dbd9efe0bc49c85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dbd9efe0bc49c85$var$load("e3tNc").then(()=>parcelRequire('5YNhz'));

});

parcelRegister("bzZRD", function(module, exports) {

let $86e2f37f97ba0fcb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86e2f37f97ba0fcb$var$load("985CF").then(()=>parcelRequire('2pf0Y'));

});

parcelRegister("5PAsW", function(module, exports) {

let $43ee0085e4bffe6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43ee0085e4bffe6f$var$load("78b3f").then(()=>parcelRequire('jVhcJ'));

});

parcelRegister("f2STn", function(module, exports) {

let $af419f606fe02c07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af419f606fe02c07$var$load("ayC8c").then(()=>parcelRequire('03715'));

});

parcelRegister("iNdWn", function(module, exports) {

let $dae79deaee0a6d36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dae79deaee0a6d36$var$load("7lW68").then(()=>parcelRequire('4tD29'));

});

parcelRegister("7LKZI", function(module, exports) {

let $5a8160470db3a26d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a8160470db3a26d$var$load("1KdtN").then(()=>parcelRequire('9nXnA'));

});

parcelRegister("jn6Vd", function(module, exports) {
module.exports = JSON.parse("{\"admin-hub.adminhub-performance-monitoring-first-run.body-0\":[{\"type\":0,\"value\":\"See how your apps loaded for users in the last 24 hours, grouped by fast, moderate, and slow experiences.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-1\":[{\"type\":0,\"value\":\"Understand which configuration issues affect load times, and where improvements can make the difference.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-10\":[{\"type\":0,\"value\":\"Click any row to see what's impacting this app's performance and review detailed metrics.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-2\":[{\"type\":0,\"value\":\"Find what's affecting performance the most. View insight details to understand the issue and take the next step.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-3\":[{\"type\":0,\"value\":\"Explore how load times split across fast, moderate, and slow for the period you chose.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-4\":[{\"type\":0,\"value\":\"The same data plotted over time, so you can identify when slow loads occurred and tell whether a change helped.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-5\":[{\"type\":0,\"value\":\"Change the time range and how often data is sampled, or switch between alternative data views.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-6\":[{\"type\":0,\"value\":\"Compare the impact of network speed, CPU cores, network protocol, and operating system over the last 4 weeks.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-7\":[{\"type\":0,\"value\":\"Filter to the product or site you care about, then explore the details to learn how page loads are distributed.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-8\":[{\"type\":0,\"value\":\"Compare load times for each app to quickly assess individual performance and evaluate optimization needs.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.body-9\":[{\"type\":0,\"value\":\"Use search, filter and sorting capabilities to quickly identify which apps need attention.\"}],\"admin-hub.adminhub-performance-monitoring-first-run.button-back\":[{\"type\":0,\"value\":\"Back\"}],\"admin-hub.adminhub-performance-monitoring-first-run.button-done\":[{\"type\":0,\"value\":\"Done\"}],\"admin-hub.adminhub-performance-monitoring-first-run.button-next\":[{\"type\":0,\"value\":\"Next\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-0\":[{\"type\":0,\"value\":\"App performance at a glance\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-1\":[{\"type\":0,\"value\":\"Find what's slowing things down\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-10\":[{\"type\":0,\"value\":\"View performance breakdown\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-2\":[{\"type\":0,\"value\":\"Review insights\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-3\":[{\"type\":0,\"value\":\"See the spread of load times\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-4\":[{\"type\":0,\"value\":\"Watch load times change\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-5\":[{\"type\":0,\"value\":\"Adjust the view to get a clear picture\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-6\":[{\"type\":0,\"value\":\"See how user setup affects load times\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-7\":[{\"type\":0,\"value\":\"Narrow it to one product or site\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-8\":[{\"type\":0,\"value\":\"Get a comprehensive overview\"}],\"admin-hub.adminhub-performance-monitoring-first-run.heading-9\":[{\"type\":0,\"value\":\"Boost your investigation\"}],\"admin-hub.adminhub-performance-monitoring-first-run.step-count\":[{\"type\":1,\"value\":\"step\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.back\":[{\"type\":0,\"value\":\"Back\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.done\":[{\"type\":0,\"value\":\"Done\"}],\"aviator.service-health-dashboard.app-status-spotlight.action.next\":[{\"type\":0,\"value\":\"Next\"}],\"aviator.service-health-dashboard.app-status-spotlight.step-counter\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"aviator.service-health-dashboard.app-status-spotlight.step1.body\":[{\"type\":0,\"value\":\"View active incidents, maintenance events and their details.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step1.heading\":[{\"type\":0,\"value\":\"Track current events\"}],\"aviator.service-health-dashboard.app-status-spotlight.step2.body\":[{\"type\":0,\"value\":\"Search and filter past incidents and maintenance events.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step2.heading\":[{\"type\":0,\"value\":\"Browse event history\"}],\"aviator.service-health-dashboard.app-status-spotlight.step3.body\":[{\"type\":0,\"value\":\"View which app experiences across app instances are currently impacted.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step3.heading\":[{\"type\":0,\"value\":\"Check experience status\"}],\"aviator.service-health-dashboard.app-status-spotlight.step4.body\":[{\"type\":0,\"value\":\"Get an overview of how events affect your apps and their experiences.\"}],\"aviator.service-health-dashboard.app-status-spotlight.step4.heading\":[{\"type\":0,\"value\":\"Review impact on apps\"}],\"aviator.service-health-dashboard.spotlight.action.back\":[{\"type\":0,\"value\":\"Back\"}],\"aviator.service-health-dashboard.spotlight.action.done\":[{\"type\":0,\"value\":\"Done\"}],\"aviator.service-health-dashboard.spotlight.action.next\":[{\"type\":0,\"value\":\"Next\"}],\"aviator.service-health-dashboard.spotlight.step-counter\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"aviator.service-health-dashboard.spotlight.step1.body\":[{\"type\":0,\"value\":\"View the current status and recent events for each app in your organization.\"}],\"aviator.service-health-dashboard.spotlight.step1.heading\":[{\"type\":0,\"value\":\"Dive into app status\"}],\"aviator.service-health-dashboard.spotlight.step2.body\":[{\"type\":0,\"value\":\"Stay informed about incidents and maintenance events in your organization\"}],\"aviator.service-health-dashboard.spotlight.step2.heading\":[{\"type\":0,\"value\":\"Subscribe to updates\"}],\"catapult.adminhub-shd-arb-email-webhook-spotlight-tour.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"catapult.adminhub-shd-arb-email-webhook-spotlight-tour.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}],\"catapult.adminhub-shd-new-notifications-spotlight.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"catapult.adminhub-shd-new-notifications-spotlight.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}],\"catapult.adminhub-system-health-dashboard-app-status-spotlight.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"catapult.adminhub-system-health-dashboard-app-status-spotlight.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}]}");

});

parcelRegister("6DVal", function(module, exports) {

let $4d62ba89612d0740$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d62ba89612d0740$var$load("8K2Ks").then(()=>parcelRequire('ksC63'));

});

parcelRegister("dnviE", function(module, exports) {

let $9bd5b3d09a7018d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9bd5b3d09a7018d6$var$load("fK3Bb").then(()=>parcelRequire('6uAWE'));

});

parcelRegister("inQF0", function(module, exports) {

let $d6233940b2f3bc5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6233940b2f3bc5f$var$load("kOtuG").then(()=>parcelRequire('9AunT'));

});

parcelRegister("3pSD4", function(module, exports) {

let $27ce151d0ad81d3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27ce151d0ad81d3a$var$load("2UXfO").then(()=>parcelRequire('hN4Vk'));

});

parcelRegister("l7JF3", function(module, exports) {

let $f60dabc8004e4373$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f60dabc8004e4373$var$load("ac3D4").then(()=>parcelRequire('1e2My'));

});

parcelRegister("9EPTJ", function(module, exports) {

let $70801b50a8171516$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70801b50a8171516$var$load("6FheE").then(()=>parcelRequire('b6MHo'));

});

parcelRegister("bi9fn", function(module, exports) {

let $83888c6b6019dfbe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83888c6b6019dfbe$var$load("fpifQ").then(()=>parcelRequire('7wnS8'));

});

parcelRegister("6eRZW", function(module, exports) {

let $48adefc62c42bb8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48adefc62c42bb8a$var$load("dCwTP").then(()=>parcelRequire('fHOi0'));

});

parcelRegister("c5itn", function(module, exports) {

let $8cc447f546e3404b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cc447f546e3404b$var$load("d81M2").then(()=>parcelRequire('8A6W8'));

});

parcelRegister("5Lkat", function(module, exports) {

let $4320fc7898de7e9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4320fc7898de7e9f$var$load("g2EkB").then(()=>parcelRequire('igR1Y'));

});

parcelRegister("2RTex", function(module, exports) {

let $216b6034504297c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $216b6034504297c6$var$load("joKjD").then(()=>parcelRequire('h32Q8'));

});

parcelRegister("8UQU8", function(module, exports) {

let $67dc97662e28cde9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67dc97662e28cde9$var$load("bvblR").then(()=>parcelRequire('1kFIu'));

});

parcelRegister("4iWGP", function(module, exports) {

let $32265e68ccef9323$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32265e68ccef9323$var$load("63Bl6").then(()=>parcelRequire('iXAjO'));

});

parcelRegister("e6L7b", function(module, exports) {

let $a4562c424c9c7627$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4562c424c9c7627$var$load("71uoA").then(()=>parcelRequire('dY6Fe'));

});

parcelRegister("4JoIz", function(module, exports) {

let $371e89d97439bb8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $371e89d97439bb8a$var$load("iIwy7").then(()=>parcelRequire('25io6'));

});

parcelRegister("6JOFf", function(module, exports) {

let $4e7e3ee6dd23ea31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e7e3ee6dd23ea31$var$load("5zuZn").then(()=>parcelRequire('jH664'));

});

parcelRegister("84Cal", function(module, exports) {

let $018453d433fb8472$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $018453d433fb8472$var$load("6g8QC").then(()=>parcelRequire('DCRg6'));

});

parcelRegister("1bYEh", function(module, exports) {

let $0de5dd1093d2672e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0de5dd1093d2672e$var$load("75Bsd").then(()=>parcelRequire('4JbSw'));

});

parcelRegister("28r74", function(module, exports) {

let $18e15c3525e5be21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18e15c3525e5be21$var$load("bGm0C").then(()=>parcelRequire('cWhKw'));

});

parcelRegister("gx9jb", function(module, exports) {

let $c096f2e08bf6536c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c096f2e08bf6536c$var$load("2lwGB").then(()=>parcelRequire('5kCW0'));

});

parcelRegister("l8Kdm", function(module, exports) {

let $f63e318f8fe449f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f63e318f8fe449f2$var$load("3VQ72").then(()=>parcelRequire('baWyr'));

});

parcelRegister("3TFWR", function(module, exports) {

let $2d670c3dbb333169$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d670c3dbb333169$var$load("iIYnd").then(()=>parcelRequire('8weu1'));

});

parcelRegister("9kURA", function(module, exports) {

let $6cc2173022304d3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6cc2173022304d3c$var$load("9cI2H").then(()=>parcelRequire('4hgLX'));

});

parcelRegister("4a06L", function(module, exports) {

let $30782e0d72814e29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30782e0d72814e29$var$load("ahGEq").then(()=>parcelRequire('31qLi'));

});

parcelRegister("abJUx", function(module, exports) {

let $76ae8b6fcda5dabc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76ae8b6fcda5dabc$var$load("jVpEb").then(()=>parcelRequire('gFhjm'));

});

parcelRegister("4t3lo", function(module, exports) {

let $340c76e82ec9e3c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $340c76e82ec9e3c2$var$load("dppZk").then(()=>parcelRequire('cqHuz'));

});

parcelRegister("4ESb7", function(module, exports) {

let $3644ec8d69785b93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3644ec8d69785b93$var$load("70Wj9").then(()=>parcelRequire('dz0ts'));

});

parcelRegister("5pKn7", function(module, exports) {

let $3f1342074b6408f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f1342074b6408f9$var$load("lj6hI").then(()=>parcelRequire('6qcWD'));

});

parcelRegister("jqAt5", function(module, exports) {

let $03a666206a0cc88c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03a666206a0cc88c$var$load("kys5a").then(()=>parcelRequire('70ADh'));

});

parcelRegister("2rLoo", function(module, exports) {

let $1c82dd866b9b15be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c82dd866b9b15be$var$load("7MAqQ").then(()=>parcelRequire('8zD3c'));

});

parcelRegister("fiPK2", function(module, exports) {

let $b240ac3adbd3cfa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b240ac3adbd3cfa5$var$load("fuqyw").then(()=>parcelRequire('4iMWs'));

});

parcelRegister("k9ukf", function(module, exports) {

let $eabc2bedbebae831$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eabc2bedbebae831$var$load("kfioc").then(()=>parcelRequire('hoerD'));

});

parcelRegister("9ig6e", function(module, exports) {

let $6c424881535a3627$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c424881535a3627$var$load("gxjfb").then(()=>parcelRequire('hGwoj'));

});

parcelRegister("7MsWr", function(module, exports) {

let $5aa3775089dc221b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5aa3775089dc221b$var$load("8l4hg").then(()=>parcelRequire('8uQ82'));

});

parcelRegister("e0FlU", function(module, exports) {
module.exports = JSON.parse("{\"rovo-agents.scenario-onboarding.backButton\":[{\"type\":0,\"value\":\"Back\"}],\"rovo-agents.scenario-onboarding.close.no-translate\":[{\"type\":0,\"value\":\"Close\"}],\"rovo-agents.scenario-onboarding.doneButton\":[{\"type\":0,\"value\":\"Done\"}],\"rovo-agents.scenario-onboarding.gettingStarted\":[{\"type\":0,\"value\":\"Getting started with your agent\"}],\"rovo-agents.scenario-onboarding.nextButton\":[{\"type\":0,\"value\":\"Next\"}],\"rovo-agents.scenario-onboarding.startTour\":[{\"type\":0,\"value\":\"Start Tour\"}],\"rovo-agents.scenario-onboarding.step1Body\":[{\"type\":0,\"value\":\"Scenarios allow you to instruct your agent to do things differently depending on the situation.\"}],\"rovo-agents.scenario-onboarding.step1Headline\":[{\"type\":0,\"value\":\"Tune your agent to each situation\"}],\"rovo-agents.scenario-onboarding.step2Body\":[{\"type\":0,\"value\":\"Unlike scenarios, behavior is the instructions your agent always follows, no matter the situation.\"}],\"rovo-agents.scenario-onboarding.step2Headline\":[{\"type\":0,\"value\":\"Set your agent's traits and goals\"}],\"rovo-agents.scenario-onboarding.step3Body\":[{\"type\":0,\"value\":\"You can add knowledge to your agent's scenarios so it has the right information to answer prompts in each situation.\"}],\"rovo-agents.scenario-onboarding.step3Headline\":[{\"type\":0,\"value\":\"See what your agent knows\"}],\"rovo-agents.scenario-onboarding.step4Body\":[{\"type\":0,\"value\":\"You can add skills to your agent's scenarios so it can connect and take action across apps.\"}],\"rovo-agents.scenario-onboarding.step4Headline\":[{\"type\":0,\"value\":\"See what your agent can do\"}],\"rovo-agents.scenario-onboarding.stepIndicator\":[{\"type\":1,\"value\":\"currentStep\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"totalSteps\"}]}");

});

parcelRegister("eabg7", function(module, exports) {

let $a4fabba68e00317b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4fabba68e00317b$var$load("c2cNk").then(()=>parcelRequire('g3aLF'));

});

parcelRegister("jZeAX", function(module, exports) {

let $e8cf0915a22f6631$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8cf0915a22f6631$var$load("QGW8D").then(()=>parcelRequire('8g2vO'));

});

parcelRegister("2axJb", function(module, exports) {

let $1946ad95b5608d6d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1946ad95b5608d6d$var$load("ifl3H").then(()=>parcelRequire('5Q5fO'));

});

parcelRegister("lUsnv", function(module, exports) {

let $ff34d7438629bf5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff34d7438629bf5a$var$load("4mEml").then(()=>parcelRequire('53hPN'));

});

parcelRegister("8c7JZ", function(module, exports) {

let $5f7572e59acb670a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f7572e59acb670a$var$load("rZOZY").then(()=>parcelRequire('6I9wx'));

});

parcelRegister("abUmM", function(module, exports) {

let $76b6a7a32ef744b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76b6a7a32ef744b4$var$load("dDFt1").then(()=>parcelRequire('izODv'));

});

parcelRegister("eXUz1", function(module, exports) {

let $ae5273c9aad06291$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae5273c9aad06291$var$load("2JeW2").then(()=>parcelRequire('2xbrn'));

});

parcelRegister("fEYiZ", function(module, exports) {

let $b6695eca943024fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b6695eca943024fc$var$load("77e5Z").then(()=>parcelRequire('3cnHI'));

});

parcelRegister("5ptAs", function(module, exports) {

let $3f063ce92a888344$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f063ce92a888344$var$load("9e1BM").then(()=>parcelRequire('hOkKa'));

});

parcelRegister("1VQcl", function(module, exports) {

let $16839ac7cb8b7e4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $16839ac7cb8b7e4c$var$load("jli6F").then(()=>parcelRequire('88Pbf'));

});

parcelRegister("4xiJB", function(module, exports) {

let $34d8c6cb373b1dd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34d8c6cb373b1dd8$var$load("aKNtX").then(()=>parcelRequire('gD7TW'));

});

parcelRegister("g7kN0", function(module, exports) {

let $bbbd6d1d9f7a7f90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbbd6d1d9f7a7f90$var$load("b1YKO").then(()=>parcelRequire('dIOb5'));

});

parcelRegister("5aDHN", function(module, exports) {

let $3c3caf9757e84a38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c3caf9757e84a38$var$load("5yx51").then(()=>parcelRequire('287IL'));

});

parcelRegister("6Db5r", function(module, exports) {

let $4d3efc2f4129054e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d3efc2f4129054e$var$load("8bdxk").then(()=>parcelRequire('abqJ2'));

});

parcelRegister("7EnAW", function(module, exports) {

let $591e92412b539392$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $591e92412b539392$var$load("lmyBt").then(()=>parcelRequire('bcqJt'));

});

parcelRegister("1NMC1", function(module, exports) {

let $1500136b7a032e26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1500136b7a032e26$var$load("7d1aK").then(()=>parcelRequire('dx9Yh'));

});

parcelRegister("h7mrz", function(module, exports) {

let $c7647ff3325ec027$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7647ff3325ec027$var$load("dXU3R").then(()=>parcelRequire('ASIbO'));

});

parcelRegister("dJrN5", function(module, exports) {

let $9ff508fc29d2fd78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ff508fc29d2fd78$var$load("3EIMp").then(()=>parcelRequire('90zwb'));

});

parcelRegister("kIiRu", function(module, exports) {

let $f1468c4669e8840a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1468c4669e8840a$var$load("1SKts").then(()=>parcelRequire('8AO1A'));

});

parcelRegister("6cC5U", function(module, exports) {

let $484169c6fe4fd565$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $484169c6fe4fd565$var$load("jLUYl").then(()=>parcelRequire('izNDz'));

});

parcelRegister("jOK5M", function(module, exports) {

let $e6d670c8590a6d59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6d670c8590a6d59$var$load("4pRNe").then(()=>parcelRequire('t8RbL'));

});

parcelRegister("3cL9D", function(module, exports) {

let $255711f3f513e7b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $255711f3f513e7b3$var$load("hFiOH").then(()=>parcelRequire('7LtNY'));

});

parcelRegister("3sD7h", function(module, exports) {

let $2852544fa75330be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2852544fa75330be$var$load("f9dTk").then(()=>parcelRequire('grELN'));

});

parcelRegister("5TuXS", function(module, exports) {

let $44aa1bc46649a520$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44aa1bc46649a520$var$load("40l8F").then(()=>parcelRequire('ihcxT'));

});

parcelRegister("7PMPV", function(module, exports) {

let $5b432db6c085f47c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b432db6c085f47c$var$load("aCDxA").then(()=>parcelRequire('3HZz3'));

});

parcelRegister("4fQN1", function(module, exports) {

let $3191831052ee1d58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3191831052ee1d58$var$load("bbzzZ").then(()=>parcelRequire('fSqVW'));

});

parcelRegister("2sOFs", function(module, exports) {

let $1cb57fd458a90a7d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1cb57fd458a90a7d$var$load("kEAWR").then(()=>parcelRequire('eRL2S'));

});

parcelRegister("aFgC3", function(module, exports) {

let $7c3a9ea8e4450213$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c3a9ea8e4450213$var$load("btCC0").then(()=>parcelRequire('gAZWb'));

});

parcelRegister("idbW5", function(module, exports) {

let $d422b3209c036515$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d422b3209c036515$var$load("fRb1S").then(()=>parcelRequire('4zy6a'));

});

parcelRegister("kY8vo", function(module, exports) {

let $f4400237aea1f309$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4400237aea1f309$var$load("9JiEa").then(()=>parcelRequire('beqfv'));

});

parcelRegister("7t28c", function(module, exports) {

let $56fce51529b3d8bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56fce51529b3d8bb$var$load("4Kewe").then(()=>parcelRequire('4TcAS'));

});

parcelRegister("877yj", function(module, exports) {

let $5e84d5e99f0e3124$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e84d5e99f0e3124$var$load("b5fXF").then(()=>parcelRequire('ick0T'));

});

parcelRegister("6J3MX", function(module, exports) {

let $4e59e260facd3dd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e59e260facd3dd2$var$load("hN4vM").then(()=>parcelRequire('lfr2i'));

});

parcelRegister("bjFRG", function(module, exports) {

let $83d1f18c6c9717d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83d1f18c6c9717d0$var$load("k2TRi").then(()=>parcelRequire('iZH4z'));

});

parcelRegister("17jnj", function(module, exports) {
module.exports = JSON.parse('{"assets-deeplinking-modal.closeButton":[{"type":0,"value":"Close"}],"assets-deeplinking-modal.description1":[{"type":0,"value":"You can now click directly on data points in your charts to drill in and see the underlying records. For example, if you select a bar in the \u201CTicket volume\u201D chart, we\u2019ll open a detailed view showing the actual tickets that make up that data point."}],"assets-deeplinking-modal.description2":[{"type":0,"value":"This lets you move from high-level trends to the raw sources behind them in just one click."}],"assets-deeplinking-modal.doneButton":[{"type":0,"value":"Done"}],"assets-deeplinking-modal.heading":[{"type":0,"value":"See the data behind your charts"}],"jira-ops-reports-changeboarding.close-button":[{"type":0,"value":"Close"}],"jira-ops-reports-changeboarding.done-button":[{"type":0,"value":"Got it"}],"jira-ops-reports-changeboarding.feature1":[{"type":0,"value":"Add views as tabs to organize information your way"}],"jira-ops-reports-changeboarding.feature2":[{"type":0,"value":"Create new charts to meet your custom needs."}],"jira-ops-reports-changeboarding.heading":[{"type":0,"value":"Your new reporting experience"}],"jira-ops-reports-changeboarding.more-about-reports-button":[{"type":0,"value":"More about reports"}],"jira-ops-reports-changeboarding.subtitle":[{"type":0,"value":"Tailor your reports by adding tabs, widgets, charts and editing filters."}],"jira-ops-reports-changeboarding.whats-new-heading":[{"type":0,"value":"What\u2019s new?"}]}');

});

parcelRegister("6ClI5", function(module, exports) {

let $4d1721d90763667f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d1721d90763667f$var$load("f7WNn").then(()=>parcelRequire('4jDg1'));

});

parcelRegister("8hGTN", function(module, exports) {

let $6081301c5eaa781e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6081301c5eaa781e$var$load("7gDpy").then(()=>parcelRequire('cLCJ4'));

});

parcelRegister("kgAWE", function(module, exports) {

let $ec11f5c70e79e470$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec11f5c70e79e470$var$load("ei38P").then(()=>parcelRequire('gYJh2'));

});

parcelRegister("5i55E", function(module, exports) {

let $3da294f7f4bff2ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3da294f7f4bff2ad$var$load("fdgSn").then(()=>parcelRequire('9e5Xy'));

});

parcelRegister("6lzM7", function(module, exports) {

let $49f07468f0e2be52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49f07468f0e2be52$var$load("fwT6m").then(()=>parcelRequire('5skey'));

});

parcelRegister("c6grN", function(module, exports) {

let $8cf2cdabce865ec3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cf2cdabce865ec3$var$load("gXNhS").then(()=>parcelRequire('hpkWz'));

});

parcelRegister("eXr6z", function(module, exports) {

let $ae3b99da6d784e69$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae3b99da6d784e69$var$load("KbdSp").then(()=>parcelRequire('33VPg'));

});

parcelRegister("7Waeo", function(module, exports) {

let $017dc5b936b15eb4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $017dc5b936b15eb4$var$load("ccfBZ").then(()=>parcelRequire('jmquI'));

});

parcelRegister("av8hd", function(module, exports) {

let $7a533837d25c416d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a533837d25c416d$var$load("11O9x").then(()=>parcelRequire('bs9vZ'));

});

parcelRegister("iinO3", function(module, exports) {

let $d51c5fdff3e468bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d51c5fdff3e468bd$var$load("hUdDj").then(()=>parcelRequire('iJhe0'));

});

parcelRegister("6aSdw", function(module, exports) {

let $47edbb9c4ff263b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47edbb9c4ff263b7$var$load("aYE4r").then(()=>parcelRequire('ghPja'));

});

parcelRegister("8IdGC", function(module, exports) {

let $01a30c972327f970$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01a30c972327f970$var$load("48zVO").then(()=>parcelRequire('98jLT'));

});

parcelRegister("5Ljvt", function(module, exports) {

let $43207922bf183141$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43207922bf183141$var$load("iKk6B").then(()=>parcelRequire('kJB8U'));

});

parcelRegister("h9UHK", function(module, exports) {

let $c7df4349f40bc7e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7df4349f40bc7e3$var$load("8DXol").then(()=>parcelRequire('6Jxyr'));

});

parcelRegister("exAVp", function(module, exports) {

let $a960ca4e3a20d916$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a960ca4e3a20d916$var$load("3aGSv").then(()=>parcelRequire('fiCF0'));

});

parcelRegister("fkdWp", function(module, exports) {

let $b28389ab1577e9d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b28389ab1577e9d9$var$load("1kIci").then(()=>parcelRequire('i3sps'));

});

parcelRegister("g930E", function(module, exports) {

let $bc0fd234cc17c41d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc0fd234cc17c41d$var$load("hMgGX").then(()=>parcelRequire('dlDoU'));

});

parcelRegister("fWgxi", function(module, exports) {

let $b9a9197c8454bff8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9a9197c8454bff8$var$load("3SQRp").then(()=>parcelRequire('701D3'));

});

parcelRegister("fDLGH", function(module, exports) {

let $b62f7d564f3f6f45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b62f7d564f3f6f45$var$load("1wPsb").then(()=>parcelRequire('8wcaG'));

});

parcelRegister("lTuyI", function(module, exports) {

let $ff0670682c2f99c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff0670682c2f99c7$var$load("4UbgM").then(()=>parcelRequire('icNiA'));

});

parcelRegister("hfwWF", function(module, exports) {

let $c8ed64a3357bc9b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c8ed64a3357bc9b7$var$load("7wxHT").then(()=>parcelRequire('9TSXb'));

});

parcelRegister("iYOer", function(module, exports) {

let $0390d9fe79ae776f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0390d9fe79ae776f$var$load("aushQ").then(()=>parcelRequire('4U3Do'));

});

parcelRegister("b7HfY", function(module, exports) {

let $8191e70a32c37776$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8191e70a32c37776$var$load("gmbe8").then(()=>parcelRequire('9oMWl'));

});

parcelRegister("e12Gu", function(module, exports) {

let $a3433dc1d6bef1a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3433dc1d6bef1a2$var$load("7LC10").then(()=>parcelRequire('fSxHo'));

});

parcelRegister("khLm8", function(module, exports) {

let $ec4a211ea8f068da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec4a211ea8f068da$var$load("lOHne").then(()=>parcelRequire('jBnAe'));

});

parcelRegister("bxTdC", function(module, exports) {

let $867d9c0b02a10fa4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $867d9c0b02a10fa4$var$load("bEtan").then(()=>parcelRequire('86N95'));

});

parcelRegister("7zpdc", function(module, exports) {

let $582f5bde5a9bca99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $582f5bde5a9bca99$var$load("5ASZi").then(()=>parcelRequire('cVirH'));

});

parcelRegister("eeoPq", function(module, exports) {

let $a5c5a1ec1ada6481$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5c5a1ec1ada6481$var$load("e3EkW").then(()=>parcelRequire('iHj8H'));

});

parcelRegister("5Bt1H", function(module, exports) {

let $4146ec7824ef94de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4146ec7824ef94de$var$load("fgwxB").then(()=>parcelRequire('bZ1s3'));

});

parcelRegister("lMJex", function(module, exports) {

let $fdc12b12990cc13c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fdc12b12990cc13c$var$load("b97TL").then(()=>parcelRequire('53lm2'));

});

parcelRegister("8ggZy", function(module, exports) {

let $603cff961e609247$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $603cff961e609247$var$load("kqGj7").then(()=>parcelRequire('kETxu'));

});

parcelRegister("gOpNc", function(module, exports) {

let $c3d552b456de9185$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3d552b456de9185$var$load("47TJV").then(()=>parcelRequire('5Sb7N'));

});

parcelRegister("9JALx", function(module, exports) {

let $7164d5eb61319afe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7164d5eb61319afe$var$load("VzTdH").then(()=>parcelRequire('521Vt'));

});

parcelRegister("e2NTg", function(module, exports) {

let $a397f3c21843e1c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a397f3c21843e1c5$var$load("68wRK").then(()=>parcelRequire('erD4R'));

});

parcelRegister("aDXRl", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("dhgg6", function(module, exports) {

let $9aa97983c54cc73e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9aa97983c54cc73e$var$load("hklN5").then(()=>parcelRequire('Pnbvz'));

});

parcelRegister("4quJN", function(module, exports) {

let $33916f004bba2870$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $33916f004bba2870$var$load("bYzoO").then(()=>parcelRequire('hw6F1'));

});

parcelRegister("4YtW3", function(module, exports) {

let $39f3fc90292cfce0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $39f3fc90292cfce0$var$load("5oeVE").then(()=>parcelRequire('4GxPk'));

});

parcelRegister("1dXJ4", function(module, exports) {

let $0e4555aa3b1eb04d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e4555aa3b1eb04d$var$load("6oncS").then(()=>parcelRequire('6CJQQ'));

});

parcelRegister("hpIew", function(module, exports) {

let $cad7153fa4f19290$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cad7153fa4f19290$var$load("dLIpQ").then(()=>parcelRequire('92xsd'));

});

parcelRegister("l91fK", function(module, exports) {

let $f64b690aa9ce67aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f64b690aa9ce67aa$var$load("3roLh").then(()=>parcelRequire('64Tla'));

});

parcelRegister("7OnNX", function(module, exports) {

let $5affab0be59320a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5affab0be59320a6$var$load("itNgg").then(()=>parcelRequire('lX49y'));

});

parcelRegister("hnOZU", function(module, exports) {

let $ca7c24b5c627fc61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca7c24b5c627fc61$var$load("7kll5").then(()=>parcelRequire('aTo8h'));

});

parcelRegister("fgbrU", function(module, exports) {

let $b1c13b344fe8f05e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1c13b344fe8f05e$var$load("gWJWo").then(()=>parcelRequire('lUvBC'));

});

parcelRegister("iT7rO", function(module, exports) {

let $dc0323feb0b530c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc0323feb0b530c6$var$load("jbyyZ").then(()=>parcelRequire('e64EK'));

});

parcelRegister("4YZ6d", function(module, exports) {

let $3a0c2911c64132c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a0c2911c64132c7$var$load("aqtvy").then(()=>parcelRequire('fyi6x'));

});

parcelRegister("lO34q", function(module, exports) {

let $fe00a62cf4bab2b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe00a62cf4bab2b2$var$load("36JAe").then(()=>parcelRequire('CBVOE'));

});

parcelRegister("2LAgN", function(module, exports) {

let $203c1b024b3123de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $203c1b024b3123de$var$load("d5XNJ").then(()=>parcelRequire('3Twqm'));

});

parcelRegister("lAEfc", function(module, exports) {

let $fb7c2d676e07258a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb7c2d676e07258a$var$load("kIpJ3").then(()=>parcelRequire('1RXgW'));

});

parcelRegister("eVqNW", function(module, exports) {

let $addb2e644349483b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $addb2e644349483b$var$load("bWjOt").then(()=>parcelRequire('dWcMf'));

});

parcelRegister("ioF3u", function(module, exports) {

let $d64a5096f0087237$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d64a5096f0087237$var$load("cPWct").then(()=>parcelRequire('f79mI'));

});

parcelRegister("1EU5y", function(module, exports) {

let $135508e940418db0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $135508e940418db0$var$load("jggnq").then(()=>parcelRequire('hUTYd'));

});

parcelRegister("d50eo", function(module, exports) {

let $985bebde7d38a555$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $985bebde7d38a555$var$load("e0Ntg").then(()=>parcelRequire('9NblC'));

});

parcelRegister("5UW3g", function(module, exports) {

let $44ef368f47e69d4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44ef368f47e69d4a$var$load("2JgKr").then(()=>parcelRequire('aI5qS'));

});

parcelRegister("2qyIm", function(module, exports) {

let $1c48f00fc7ef291a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c48f00fc7ef291a$var$load("acuHR").then(()=>parcelRequire('b16F1'));

});

parcelRegister("6UYsU", function(module, exports) {

let $5096e033dc8365c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5096e033dc8365c2$var$load("3O4Ad").then(()=>parcelRequire('82VBy'));

});

parcelRegister("5Jp07", function(module, exports) {

let $42c48c5c1b7f84dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42c48c5c1b7f84dd$var$load("game2").then(()=>parcelRequire('aCtQL'));

});

parcelRegister("hjwpd", function(module, exports) {

let $c9ad591ef5b7d118$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9ad591ef5b7d118$var$load("eIQjF").then(()=>parcelRequire('5NZ8M'));

});

parcelRegister("1dgn9", function(module, exports) {

let $0e23b49435988386$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e23b49435988386$var$load("38DCQ").then(()=>parcelRequire('9K6KX'));

});

parcelRegister("ajJkr", function(module, exports) {

let $782ed710d328cd82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $782ed710d328cd82$var$load("9keOr").then(()=>parcelRequire('1BPk1'));

});

parcelRegister("gIgCg", function(module, exports) {

let $c2ada50c723b21b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2ada50c723b21b0$var$load("kVp0R").then(()=>parcelRequire('kfsBI'));

});

parcelRegister("lxn1t", function(module, exports) {

let $fade89e849f67fa0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fade89e849f67fa0$var$load("boO82").then(()=>parcelRequire('epPtX'));

});

parcelRegister("3ZONs", function(module, exports) {

let $2e8e78cad9bda857$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e8e78cad9bda857$var$load("1oiW8").then(()=>parcelRequire('jrVd1'));

});

parcelRegister("eZukP", function(module, exports) {

let $ae9e4b10fc84cc8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae9e4b10fc84cc8b$var$load("dWZoZ").then(()=>parcelRequire('4173K'));

});

parcelRegister("1Zm20", function(module, exports) {

let $172c93e5e4cdef21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $172c93e5e4cdef21$var$load("d0hH7").then(()=>parcelRequire('98n0p'));

});

parcelRegister("fzP1A", function(module, exports) {

let $b571b44b5ef8dee5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b571b44b5ef8dee5$var$load("eQ1QI").then(()=>parcelRequire('9RLUJ'));

});

parcelRegister("5cVsx", function(module, exports) {

let $3caaa4f8f98199d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3caaa4f8f98199d7$var$load("gUkiy").then(()=>parcelRequire('3CCJR'));

});

parcelRegister("jDEId", function(module, exports) {

let $e4c13d672521a11c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e4c13d672521a11c$var$load("fe1ax").then(()=>parcelRequire('fJvIy'));

});

parcelRegister("gxVgn", function(module, exports) {

let $c0bc25a91992ad9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0bc25a91992ad9b$var$load("13Qno").then(()=>parcelRequire('9wqlu'));

});

parcelRegister("8DLD7", function(module, exports) {
module.exports = JSON.parse("{\"jsm-gs.cases.spotlight.step1.body.non-final\":[{\"type\":0,\"value\":\"Streamline how your team documents findings and outcomes with a dedicated \"},{\"children\":[{\"type\":0,\"value\":\"Case notes\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" section within work items.\"}],\"jsm-gs.cases.spotlight.step1.next.non-final\":[{\"type\":0,\"value\":\"Next\"}],\"jsm-gs.cases.spotlight.step1.step-count.non-final\":[{\"type\":0,\"value\":\"1 of 3\"}],\"jsm-gs.cases.spotlight.step1.title.non-final\":[{\"type\":0,\"value\":\"Better manage your case load\"}],\"jsm-gs.cases.spotlight.step2.back.non-final\":[{\"type\":0,\"value\":\"Back\"}],\"jsm-gs.cases.spotlight.step2.body.non-final\":[{\"type\":0,\"value\":\"To enable \"},{\"children\":[{\"type\":0,\"value\":\"Case notes\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" on work items, simply create or assign existing request types to this work category.\"}],\"jsm-gs.cases.spotlight.step2.next.non-final\":[{\"type\":0,\"value\":\"Next\"}],\"jsm-gs.cases.spotlight.step2.step-count.non-final\":[{\"type\":0,\"value\":\"2 of 3\"}],\"jsm-gs.cases.spotlight.step2.title.non-final\":[{\"type\":0,\"value\":\"Create or assign existing types\"}],\"jsm-gs.cases.spotlight.step3.back.non-final\":[{\"type\":0,\"value\":\"Back\"}],\"jsm-gs.cases.spotlight.step3.body.non-final\":[{\"type\":0,\"value\":\"Lock down sensitive \"},{\"children\":[{\"type\":0,\"value\":\"Cases\"}],\"type\":8,\"value\":\"strong\"},{\"type\":0,\"value\":\" with work item security so only those with access can view case information.\"}],\"jsm-gs.cases.spotlight.step3.done.non-final\":[{\"type\":0,\"value\":\"Done\"}],\"jsm-gs.cases.spotlight.step3.step-count.non-final\":[{\"type\":0,\"value\":\"3 of 3\"}],\"jsm-gs.cases.spotlight.step3.title.non-final\":[{\"type\":0,\"value\":\"Restrict access to specific people\"}]}");

});

parcelRegister("5vdvc", function(module, exports) {

let $401a52436abd32a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $401a52436abd32a2$var$load("hT3HO").then(()=>parcelRequire('i21D4'));

});

parcelRegister("qEMXn", function(module, exports) {

let $0502119811f58bda$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0502119811f58bda$var$load("4eots").then(()=>parcelRequire('lH8ux'));

});

parcelRegister("5jrVu", function(module, exports) {

let $3de463afbd9fb904$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3de463afbd9fb904$var$load("andjq").then(()=>parcelRequire('44a2R'));

});

parcelRegister("koJIg", function(module, exports) {

let $ed998232215323e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed998232215323e8$var$load("bjEoV").then(()=>parcelRequire('gzr0l'));

});

parcelRegister("aw7Dc", function(module, exports) {

let $7a82cff64a0e5c1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a82cff64a0e5c1a$var$load("gwDxW").then(()=>parcelRequire('d1aby'));

});

parcelRegister("jXjZI", function(module, exports) {

let $e873097f94176b03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e873097f94176b03$var$load("cFsE9").then(()=>parcelRequire('blieT'));

});

parcelRegister("db8ly", function(module, exports) {

let $9982c6e81fca1709$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9982c6e81fca1709$var$load("6bfA4").then(()=>parcelRequire('2iAaN'));

});

parcelRegister("kTwQy", function(module, exports) {

let $f3626c612636750e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3626c612636750e$var$load("3Pigm").then(()=>parcelRequire('2FEom'));

});

parcelRegister("7lkyB", function(module, exports) {

let $558a70ceca3b8018$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $558a70ceca3b8018$var$load("fgUfc").then(()=>parcelRequire('5hJ2d'));

});

parcelRegister("dCvJo", function(module, exports) {

let $9ea770176033af04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ea770176033af04$var$load("5Gh9S").then(()=>parcelRequire('kZQM9'));

});

parcelRegister("jTB0l", function(module, exports) {

let $e7bfdbaf84318676$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e7bfdbaf84318676$var$load("f0O62").then(()=>parcelRequire('3zXaW'));

});

parcelRegister("5S1zV", function(module, exports) {

let $44633851538e3ae4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44633851538e3ae4$var$load("2pSWr").then(()=>parcelRequire('59BKS'));

});

parcelRegister("5TqnL", function(module, exports) {

let $44a68dc20b860f34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44a68dc20b860f34$var$load("5eXEK").then(()=>parcelRequire('iMsTX'));

});

parcelRegister("bvhrU", function(module, exports) {

let $86001ff9b0fc513b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86001ff9b0fc513b$var$load("gDdfm").then(()=>parcelRequire('9xOUG'));

});

parcelRegister("58giV", function(module, exports) {

let $3bca58c816509f67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3bca58c816509f67$var$load("gb6VF").then(()=>parcelRequire('jyuar'));

});

parcelRegister("6hkl8", function(module, exports) {

let $49241baf7eac8a6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49241baf7eac8a6b$var$load("7vT85").then(()=>parcelRequire('jueHI'));

});

parcelRegister("f8pos", function(module, exports) {

let $b04b4cfe633378fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b04b4cfe633378fd$var$load("fxHSF").then(()=>parcelRequire('5DOfN'));

});

parcelRegister("ajGUp", function(module, exports) {

let $782cf683d166d9a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $782cf683d166d9a8$var$load("6gApR").then(()=>parcelRequire('99uGZ'));

});

parcelRegister("ixanl", function(module, exports) {

let $d7e35b67aa5c169a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7e35b67aa5c169a$var$load("fFmkS").then(()=>parcelRequire('e4s0f'));

});

parcelRegister("lAjmB", function(module, exports) {

let $fb6bfaf86350e35f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb6bfaf86350e35f$var$load("h5FFt").then(()=>parcelRequire('9SpED'));

});

parcelRegister("jWwky", function(module, exports) {

let $e84c8347e621b410$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e84c8347e621b410$var$load("krFS6").then(()=>parcelRequire('5AB0A'));

});

parcelRegister("3qo0Q", function(module, exports) {

let $27e66d315d34a94d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27e66d315d34a94d$var$load("aAhAA").then(()=>parcelRequire('6dgyz'));

});

parcelRegister("k3qFk", function(module, exports) {

let $e998c5b24c189ecc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e998c5b24c189ecc$var$load("gVbDR").then(()=>parcelRequire('dMqdD'));

});

parcelRegister("793El", function(module, exports) {

let $533c346e8fcba480$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $533c346e8fcba480$var$load("4oC4A").then(()=>parcelRequire('cXsib'));

});

parcelRegister("25ZVe", function(module, exports) {

let $186c14d6a4715cc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $186c14d6a4715cc0$var$load("k4XXp").then(()=>parcelRequire('lqnQ4'));

});

parcelRegister("2bv7j", function(module, exports) {

let $1974bf0241177c0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1974bf0241177c0e$var$load("51wgc").then(()=>parcelRequire('jRPVi'));

});

parcelRegister("520hK", function(module, exports) {

let $3a9d5c52663aec57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a9d5c52663aec57$var$load("5asEs").then(()=>parcelRequire('aJYAY'));

});

parcelRegister("fRJ7g", function(module, exports) {

let $b8cecd5f575073e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8cecd5f575073e9$var$load("dwJdU").then(()=>parcelRequire('46CwV'));

});

parcelRegister("1WZFn", function(module, exports) {

let $16bb0ae1dfaa6c36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $16bb0ae1dfaa6c36$var$load("6WCjV").then(()=>parcelRequire('72NA2'));

});

parcelRegister("eYvVI", function(module, exports) {

let $ae6f6fe36a6af4d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae6f6fe36a6af4d8$var$load("bMkZK").then(()=>parcelRequire('8ZkfH'));

});

parcelRegister("4aDKk", function(module, exports) {

let $3096ed5bba5ba149$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3096ed5bba5ba149$var$load("bCU4M").then(()=>parcelRequire('sf0Zg'));

});

parcelRegister("kIThW", function(module, exports) {

let $f162cdd7490fe375$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f162cdd7490fe375$var$load("7g9TA").then(()=>parcelRequire('8NzTu'));

});

parcelRegister("k618X", function(module, exports) {

let $ea1541408e13d6f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea1541408e13d6f9$var$load("ajQbp").then(()=>parcelRequire('2c1Xy'));

});

parcelRegister("bqSK2", function(module, exports) {

let $852c95ef8d3e41a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $852c95ef8d3e41a1$var$load("cusCL").then(()=>parcelRequire('9ibN1'));

});

parcelRegister("aQHtk", function(module, exports) {
module.exports = JSON.parse("{\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-description\":[{\"type\":0,\"value\":\"Blocks of content can now be easily transformed, kept in sync, and saved as a template!\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-header\":[{\"type\":0,\"value\":\"Transform, sync & save blocks\"}],\"post-office.cc-changeboarding-block-menu-primary-new.spotlight-image-alt\":[{\"type\":0,\"value\":\"Blocks feature illustration\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-description\":[{\"type\":0,\"value\":\"Blocks of content can now be easily transformed, kept in sync, and saved as a template!\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-header\":[{\"type\":0,\"value\":\"Transform, sync & save blocks\"}],\"post-office.cc-changeboarding-block-menu-primary.spotlight-image-alt\":[{\"type\":0,\"value\":\"Blocks feature illustration\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-description\":[{\"type\":0,\"value\":\"Save any content as a block template for easy reuse across Confluence and Jira!\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-header\":[{\"type\":0,\"value\":\"Save content with block templates\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-image-alt\":[{\"type\":0,\"value\":\"Block templates feature illustration\"}],\"post-office.cc-changeboarding-block-menu-templates.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-description\":[{\"type\":0,\"value\":\"Easily change content blocks from one format to another!\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-header-new\":[{\"type\":0,\"value\":\"Quickly change format\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-image-alt-new\":[{\"type\":0,\"value\":\"Format feature illustration\"}],\"post-office.cc-changeboarding-block-menu-transform.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-changeboarding-synced-blocks.activation-spotlight-description\":[{\"type\":0,\"value\":\"You can reuse content in synced blocks in Confluence and Jira. Just copy and paste this synced block in a new location\"}],\"post-office.cc-changeboarding-synced-blocks.activation-spotlight-header\":[{\"type\":0,\"value\":\"Reuse this content\"}],\"post-office.cc-changeboarding-synced-blocks.activation-spotlight-image-alt\":[{\"type\":0,\"value\":\"Animation showing a synced block being copied from its source and pasted into another page as a linked reference\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-button\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-description\":[{\"type\":0,\"value\":\"Synced blocks maintain source of truth across Confluence & Jira. Insert, copy, and paste!\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-header\":[{\"type\":0,\"value\":\"Keep content in sync\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-image-alt\":[{\"type\":0,\"value\":\"Synced blocks feature illustration\"}],\"post-office.cc-changeboarding-synced-blocks.spotlight-learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-button\":[{\"type\":0,\"value\":\"Got it\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-description\":[{\"type\":0,\"value\":\"Controls to add or delete rows and columns have moved to their own menus. You can also align content vertically from the cell menu.\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-header\":[{\"type\":0,\"value\":\"Simple table controls\"}],\"post-office.cc-editor-table-cell-menu-changes.spotlight-image-alt\":[{\"type\":0,\"value\":\"Table cell menu illustration\"}]}");

});

parcelRegister("fMSEy", function(module, exports) {

let $b7e5bbac1ce5b118$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7e5bbac1ce5b118$var$load("l6Yi1").then(()=>parcelRequire('lY2D6'));

});

parcelRegister("3G9it", function(module, exports) {

let $2adc818b8bb4a1f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2adc818b8bb4a1f8$var$load("3mfEV").then(()=>parcelRequire('hXZOC'));

});

parcelRegister("aM2FB", function(module, exports) {

let $7d80754deab0d1af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d80754deab0d1af$var$load("e9gHo").then(()=>parcelRequire('cJ22M'));

});

parcelRegister("bF4VV", function(module, exports) {

let $0230e48b0ed85efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0230e48b0ed85efd$var$load("gq0Gj").then(()=>parcelRequire('3qU5n'));

});

parcelRegister("2SbnI", function(module, exports) {

let $21797406b4eeaebd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21797406b4eeaebd$var$load("kFTBl").then(()=>parcelRequire('8WAx5'));

});

parcelRegister("hDNJd", function(module, exports) {

let $cd7ca733c441a7b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd7ca733c441a7b1$var$load("aZxOH").then(()=>parcelRequire('57iPO'));

});

parcelRegister("3elgK", function(module, exports) {

let $25a32d7df13a4a60$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $25a32d7df13a4a60$var$load("bRS34").then(()=>parcelRequire('e9aXv'));

});

parcelRegister("iYqND", function(module, exports) {

let $dd029e7095315873$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd029e7095315873$var$load("cTEMA").then(()=>parcelRequire('4YWqR'));

});

parcelRegister("dZkOi", function(module, exports) {

let $a2f11d557b1de0c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2f11d557b1de0c4$var$load("fG4dn").then(()=>parcelRequire('i8Ju0'));

});

parcelRegister("7Kl9V", function(module, exports) {

let $5a3d3e0c47abb400$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3d3e0c47abb400$var$load("dBfAG").then(()=>parcelRequire('3LcuQ'));

});

parcelRegister("1jiqi", function(module, exports) {

let $0f45db3b62ea3a95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f45db3b62ea3a95$var$load("bhFWY").then(()=>parcelRequire('SZYPs'));

});

parcelRegister("kwgrL", function(module, exports) {

let $ef038dcf9842e149$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef038dcf9842e149$var$load("5Ipsb").then(()=>parcelRequire('bEw7J'));

});

parcelRegister("9cjc7", function(module, exports) {

let $6b241faf2d0e51b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b241faf2d0e51b9$var$load("9bycB").then(()=>parcelRequire('3U4X8'));

});

parcelRegister("eY6Xm", function(module, exports) {

let $ae5c10aecbfd6755$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae5c10aecbfd6755$var$load("8vXBw").then(()=>parcelRequire('eRnb4'));

});

parcelRegister("8b476", function(module, exports) {

let $5f428aa95f000fca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f428aa95f000fca$var$load("12bd1").then(()=>parcelRequire('jjtG3'));

});

parcelRegister("6AL9N", function(module, exports) {

let $4ccaaf462db8034c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ccaaf462db8034c$var$load("2dUzq").then(()=>parcelRequire('gnnqb'));

});

parcelRegister("TQ212", function(module, exports) {

let $0a7d7f8b1e97d343$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a7d7f8b1e97d343$var$load("dDQyn").then(()=>parcelRequire('7aj4H'));

});

parcelRegister("8gBYS", function(module, exports) {

let $604d4795dc58784d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $604d4795dc58784d$var$load("klG72").then(()=>parcelRequire('kJV9w'));

});

parcelRegister("h1EBA", function(module, exports) {

let $c6520700dca973ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6520700dca973ff$var$load("bB5zS").then(()=>parcelRequire('4E0mt'));

});

parcelRegister("2rKwb", function(module, exports) {

let $1c822fe7afb10fd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c822fe7afb10fd8$var$load("haKnr").then(()=>parcelRequire('eWpWZ'));

});

parcelRegister("bs9HJ", function(module, exports) {

let $8569d650877126a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8569d650877126a0$var$load("e6rmp").then(()=>parcelRequire('ba2NN'));

});

parcelRegister("SxP1K", function(module, exports) {

let $0a3f479be6115b53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a3f479be6115b53$var$load("dykgD").then(()=>parcelRequire('58PXh'));

});

parcelRegister("848Jl", function(module, exports) {

let $5df57822bb0a6a32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5df57822bb0a6a32$var$load("2sjPq").then(()=>parcelRequire('icssZ'));

});

parcelRegister("d6B6Y", function(module, exports) {

let $98a89f7dc1957cf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98a89f7dc1957cf6$var$load("8Tg6a").then(()=>parcelRequire('2ldir'));

});

parcelRegister("aHbdn", function(module, exports) {

let $7c969e905e5e09ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c969e905e5e09ca$var$load("aue9j").then(()=>parcelRequire('bXqxG'));

});

parcelRegister("lqWIu", function(module, exports) {

let $f9a99297c703882d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9a99297c703882d$var$load("iRiuC").then(()=>parcelRequire('2GzuM'));

});

parcelRegister("d7OQl", function(module, exports) {

let $98e35e3d626de6b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98e35e3d626de6b3$var$load("dZRz2").then(()=>parcelRequire('9AUmY'));

});

parcelRegister("8eV38", function(module, exports) {

let $5ffbe25dc39370c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ffbe25dc39370c3$var$load("9TTXb").then(()=>parcelRequire('f8EwP'));

});

parcelRegister("huJQM", function(module, exports) {

let $cbc8cdeb7b003453$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cbc8cdeb7b003453$var$load("6OD5x").then(()=>parcelRequire('lnAbD'));

});

parcelRegister("d65j7", function(module, exports) {

let $988ff3d1ae08d737$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $988ff3d1ae08d737$var$load("30KfA").then(()=>parcelRequire('kywzF'));

});

parcelRegister("7zcwB", function(module, exports) {

let $58258476f3bbc90a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58258476f3bbc90a$var$load("iAyPJ").then(()=>parcelRequire('1ilAf'));

});

parcelRegister("e2I4y", function(module, exports) {

let $a3937074f9ca61c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3937074f9ca61c6$var$load("hgjk6").then(()=>parcelRequire('hCiFJ'));

});

parcelRegister("87swa", function(module, exports) {

let $5e95193d064a08af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e95193d064a08af$var$load("92bBQ").then(()=>parcelRequire('efaNz'));

});

parcelRegister("bE3B0", function(module, exports) {

let $87a638383020f3a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87a638383020f3a2$var$load("838CA").then(()=>parcelRequire('iwO9t'));

});

parcelRegister("gHvGn", function(module, exports) {
module.exports = JSON.parse('{"ccommerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-dispute":[{"type":0,"value":"Action required: ACH Direct debit payment failed"}],"commerce-access-invalid-payment-ccp.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-access-invalid-payment-hams.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch":[{"type":0,"value":"To understand more on why we couldn\'t generate your invoice, please "},{"type":1,"value":"getInTouchLink"},{"type":0,"value":" with us."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.get-in-touch-link":[{"type":0,"value":"get in touch"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.no-invoice-generation":[{"type":0,"value":"We couldn\'t generate an invoice for your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") as we don\'t have\\n\\t\\t\\t\\tyour complete billing information. As a result, your subscription has been canceled."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-1":[{"type":0,"value":"Once you\u2019ve updated the billing details, reactivate your subscription by going to "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-5":[{"type":0,"value":". If you reactivate your subscription within 60 days of cancellation, your data and preferences will remain the same."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-instructions-5.findability":[{"type":0,"value":". You may be able to reactivate your subscription and restore your data while it remains available. Once your subscription and data have been permanently deleted, they cannot be recovered."}],"commerce-auto-cancellation-uninvoiceable-ccp.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.update-billing-details-partner-button":[{"type":0,"value":"Update billing details"}],"commerce-auto-cancellation-uninvoiceable-ccp.email.wrong-details":[{"type":0,"value":"It could be because you\u2019ve entered the wrong details, or that the information you\u2019ve provided us is\\n\\t\\t\\t\\tincomplete. Don\'t worry, you can reactivate your subscription after updating your billing information."}],"commerce-credit-account-deactivation-ccp.clear-unpaid-invoices":[{"type":0,"value":"Clear any unpaid invoices associated with your account."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.help-message":[{"type":0,"value":"We understand that managing payments can sometimes be challenging, and we\'re here to help."}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.learn-reasons":[{"type":0,"value":"Learn about possible reasons"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.message":[{"type":0,"value":"You can no longer use Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms to place your orders as your billing account\u2019s eligibility has been suspended. "},{"type":1,"value":"learnReason"}],"commerce-credit-account-deactivation-ccp.message-template.deactivation.title":[{"type":0,"value":"You\u2019re no longer eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" terms"}],"commerce-credit-account-deactivation-ccp.reach-out":[{"type":0,"value":"Reach out to us so we can review your eligibility."}],"commerce-credit-account-deactivation-ccp.reconsider-eligibility":[{"type":0,"value":"If you\u2019d like us to reconsider your eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms, we suggest you to:"}],"commerce-credit-account-deactivation-ccp.view-unpaid-invoices-link":[{"type":0,"value":"View unpaid invoices"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.couldn\'t-approve-request":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your request because you\u2019ve reached the maximum credit limit that we can offer at this time. You can check back in a few months to see if your eligibility has changed."}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Unable to offer a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.rejected.title":[{"type":0,"value":"We\u2019re unable to offer you a higher Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce-credit-account-limit-increase-request-rejection-ccp.message-template.thank-you.submitting":[{"type":0,"value":"Thank you for submitting your application for increasing your Atlassian Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit."}],"commerce-credit-account-limit-increase-request-rejection-ccp.move-forward":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce-credit-account-reactivation-ccp.message-template.good-news.restored.billing.account":[{"type":0,"value":"Good news! We\u2019ve restored your billing account\u2019s eligibility for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details:"}],"commerce-credit-account-reactivation-ccp.message-template.restored.title":[{"type":0,"value":"Your eligibility has been restored"}],"commerce-invoice-drawdown-ccp.message-template.confirm":[{"type":0,"value":"This email confirms that we\'ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The invoice is attached as a PDF for your records."}],"commerce-invoice-drawdown-ccp.message-template.covered-by-wallet":[{"type":0,"value":"This invoice is covered by the funds available in your wallet."}],"commerce-invoice-drawdown-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-generated-ccp-g.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp-g.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-generated-ccp.message-template.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"businessKey"},{"type":0,"value":". "}],"commerce-invoice-generated-ccp.message-template.partner.confirm":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"}],"commerce-invoice-generated-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-generated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp-g.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-terms-payment-pending-ccp.message-template.dc-message":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\u2019ve generated your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The\\n\\t\\t\\t\\tinvoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.invoice-attached":[{"type":0,"value":"The attached invoice is to be paid before the due date mentioned in the invoice."}],"commerce-invoice-terms-payment-pending-ccp.message-template.manage-invoices":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner-message":[{"type":0,"value":"This email is to confirm that we\u2019ve generated the following invoice. The payment due date is "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-invoice-terms-payment-pending-ccp.message-template.partner.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce-invoice-terms-payment-pending-ccp.message-template.title":[{"type":0,"value":"Your invoice has been generated"}],"commerce-invoice-terms-payment-pending-ccp.message-template.view-subscription":[{"type":0,"value":"View subscription"}],"commerce-invoice-updated-ccp-g.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp-g.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp-g.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp-g.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-invoice-updated-ccp.message-template.invoice-attached":[{"type":0,"value":"For your records, the invoice is attached as a PDF."}],"commerce-invoice-updated-ccp.message-template.title":[{"type":0,"value":"Your invoice has been updated"}],"commerce-invoice-updated-ccp.message-template.updated":[{"type":0,"value":"This is a follow up email about the credit note generated against your subscription cancellation\\n                    request. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.updated_partner":[{"type":0,"value":"This is a follow up email about the credit note generated against a subscription cancellation\\n\\t\\t\\t\\trequest. To process this request, we\'ve updated your existing invoice with the latest changes."}],"commerce-invoice-updated-ccp.message-template.view-invoice":[{"type":0,"value":"View Invoice"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.message.entity.link.label":[{"type":0,"value":"Atlassian Administration"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.body.multiple":[{"type":0,"value":"Get a free trial of "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" with your "},{"type":1,"value":"purchasedEntitlementProductName"},{"type":0,"value":" purchase."}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.different.trial.lengths.multiple":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" free"}],"commerce-marketing-multiple-product-upgrade-ccp-multiple.product.purchased.message.title.multiple":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"},{"type":0,"value":" & "},{"type":1,"value":"secondEntitlementProductName"},{"type":0,"value":" "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"}],"commerce-marketing-multiple-product-upgrade-ccp-single.message.entity.link.label":[{"type":0,"value":"Atlassian Administration"}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.message.title.single":[{"type":0,"value":"Try "},{"type":1,"value":"firstEntitlementProductName"}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.confluence.message.body.single":[{"type":0,"value":"Tired of hunting for the right doc? Build a single source of truth for your team\'s info with Confluence "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jira.message.body.single":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. Try the "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" plan free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jpd.message.body.single":[{"type":0,"value":"Say goodbye to messy backlogs. Keep your brilliant ideas in one place with Jira Product Discovery "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":". Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp-single.product.purchased.try.jsm.message.body.single":[{"type":0,"value":"Bring developers, IT, and ops on the same tool and make work visible across teams with the "},{"type":1,"value":"firstEntitlementOfferingName"},{"type":0,"value":" plan. Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"firstEntitlementTrialLength"},{"type":0,"value":"."}],"commerce-marketing-multiple-product-upgrade-ccp.subtext":[{"type":0,"value":"Atlassian Administration"}],"commerce-on-account-approval-partner.email.attached-instructions":[{"type":0,"value":"We\'ve attached instructions outlining how to read your statement."}],"commerce-on-account-approval-partner.email.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Pay on account with terms of Net-\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from statement date."}],"commerce-on-account-approval-partner.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-approval-partner.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-approval-partner.email.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce-on-account-approval-partner.email.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n\\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the statement date"}],"commerce-on-account-approval-partner.email.statement-info":[{"type":0,"value":"As Pay on account Partner, you will now receive a statement twice a month (on the 1st and 16th) covering\\n\\t\\t\\t\\tinvoices for the periods 16th to last day and 1st to 15th respectively."}],"commerce-on-account-approval-partner.email.subject":[{"type":0,"value":"Your Pay on account request is approved"}],"commerce-on-account-approval-partner.email.title":[{"type":0,"value":"Your Pay on account request has been approved"}],"commerce-on-account-deactivation-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-deactivation-partner-ccp.email.apply-again":[{"type":0,"value":"You may apply again for Pay on account option after 6 months. Don\u2019t worry, you can still place new orders using a credit card. "}],"commerce-on-account-deactivation-partner-ccp.email.contact-us":[{"type":0,"value":"Should you have questions or wish to discuss ways to reactivate your pay on account option, please contact us at "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-deactivation-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-deactivation-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-deactivation-partner-ccp.email.on-account-being-deactivated":[{"type":0,"value":"Your Pay on account option with Atlassian is being deactivated effective immediately, due to overdue balances and failure to meet the agreed payment terms. "}],"commerce-on-account-deactivation-partner-ccp.email.reach-us":[{"type":0,"value":"You can reach out to us if you need further help in placing your order."}],"commerce-on-account-deactivation-partner-ccp.email.subject":[{"type":0,"value":"Pay on account deactivation notice"}],"commerce-on-account-deactivation-partner-ccp.email.title":[{"type":0,"value":"Pay on account is deactivated"}],"commerce-on-account-rejection-partner-ccp.email.accountsreceivable":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.apply-again":[{"type":0,"value":"You can resubmit your application after 6 months to be considered again.  "}],"commerce-on-account-rejection-partner-ccp.email.contact-us":[{"type":0,"value":"You can still go ahead with your purchase. We suggest using a credit card to pay for your order. If you still need help placing an order contact us at  "},{"type":1,"value":"accountsReceivableEmail"}],"commerce-on-account-rejection-partner-ccp.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce-on-account-rejection-partner-ccp.email.list.payment-method":[{"type":0,"value":"Payment method: Pay on account"}],"commerce-on-account-rejection-partner-ccp.email.on-account-application-rejected":[{"type":0,"value":"Thank you for submitting your application for Pay on account. Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements. "}],"commerce-on-account-rejection-partner-ccp.email.sales-op-support.no-translate":[{"type":0,"value":"sales-ops-support@atlassian.com"}],"commerce-on-account-rejection-partner-ccp.email.subject":[{"type":0,"value":"Pay on account application rejection notice"}],"commerce-on-account-rejection-partner-ccp.email.title":[{"type":0,"value":"We\u2019re unable to approve your Pay on account request"}],"commerce-payment-failure-ccp.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"FAQ"}],"commerce-payment-failure-hams.email.not-trial.without-cc.add-payment-details":[{"type":0,"value":"We noticed you haven\'t added payment details for "},{"type":1,"value":"allProductListString"},{"type":0,"value":". Add payment details today so your team can keep working without interruption."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.not-trial.without-cc.not-cloud.4more.not-interested.update-subscription":[{"type":0,"value":"update your subscription"}],"commerce-payment-failure-hams.email.subject":[{"type":1,"value":"subject"}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.BB.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or alternatively contact your bank.Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.additional-actions":[{"type":0,"value":"Or see "},{"type":1,"value":"additionalActionsLink"},{"type":0,"value":" you can take if you\u2019re unable to make payments."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for Atlassian Cloud "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-1":[{"type":0,"value":"We\'re unable to process your payment for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":":"}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.not-processed.part-2":[{"type":0,"value":"This is due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request":[{"type":0,"value":"If you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.cloud.4more.expiration.submit-request.contact-us":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.not-processed":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"allProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.additional-actions":[{"type":0,"value":"If you\u2019re unable to make payments or you need to speak to one of our team members about your situation, please "},{"type":1,"value":"submitRequestLink"},{"type":0,"value":" to the Atlassian Support Team."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details":[{"type":0,"value":"If your details look correct, please try a different payment method or contact your bank. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.check-details.submit":[{"type":0,"value":"submit a request"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.not-processed":[{"type":0,"value":"We\'re unable to process your payment for "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" due to a problem with your payment details. We\'re happy to try again, but we need your help."}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request":[{"type":0,"value":"For more information about what happens when you\u2019re unsubscribed from Atlassian Access, "},{"type":1,"value":"submitRequestLink"}],"commerce-payment-failure-hams.email.trial.cc.org.4more.expiration.submit-request.faq":[{"type":0,"value":"see our FAQ"}],"commerce-payment-failure-hams.email.trial.without-cc.2-4.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-1":[{"type":0,"value":"It\u2019s okay, we all get busy! Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.2-4.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but you can still add your payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-1":[{"type":0,"value":"Your Standard plan trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.expiration.part-2":[{"type":0,"value":"But it\u2019s not too late! You can still add payment details and keep the work you\u2019ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can "},{"type":1,"value":"linkToAdmin"},{"type":0,"value":" at any time."}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.4more.expiration.not-interested.cancel-subscription":[{"type":0,"value":"cancel your subscription"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-1":[{"type":0,"value":"Your trial for the following products on "},{"type":1,"value":"linkToDomain"},{"type":0,"value":" has ended:"}],"commerce-payment-failure-hams.email.trial.without-cc.cloud.less2.expiration.part-2":[{"type":0,"value":"Your trial may have ended, but this could just be the beginning! Add payment details to keep working\\n\\t\\t\\t\\t\\t\\t\\t\\t\\t\\twith your dream team."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more":[{"type":0,"value":"Learn more about our products and how teams use them to do great work at "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce-payment-failure-hams.email.trial.without-cc.less2.expiration.learn-more.support":[{"type":0,"value":"support.atlassian.com"}],"commerce-payment-failure-hams.email.trial.without-cc.org.2-4.expiration":[{"type":0,"value":"It\'s okay, we all get busy! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment details and keep the momentum going."}],"commerce-payment-failure-hams.email.trial.without-cc.org.4more.expiration.expiration":[{"type":0,"value":"It\'s not too late! Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but you can still add payment\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tdetails and keep the work you\'ve done so far."}],"commerce-payment-failure-hams.email.trial.without-cc.org.less2.expiration":[{"type":0,"value":"Your trial of "},{"type":1,"value":"orgProductListString"},{"type":0,"value":" has ended, but this could just be the beginning. Add payment details to keep working with your dream team"}],"commerce-payment-failure-hams.email.trial.without-cc.without-cc.org.4more.expiration.not-interested":[{"type":0,"value":"If you\'re no longer interested, you can unsubscribe at any time within the Manage Subscriptions area\\n\\t\\t\\t\\t\\t\\t\\t\\t\\tof your organization administration."}],"commerce-payment-failure-hams.email.update-payment-details":[{"type":0,"value":"Update Payment Detail"}],"commerce-payment-failure-trials.add-payment":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.add-payment-without-access":[{"type":0,"value":"Add your payment details today to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.billing-cycle-label.no-translate":[{"type":0,"value":" | "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.billing-cycle-text-label.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"commerce-payment-failure-trials.card-details":[{"type":0,"value":"Card: "},{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"lastFourDigits"}],"commerce-payment-failure-trials.contact-your-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue.\\n                        Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.contact_us":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation. We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce-payment-failure-trials.contact_us_access.contact_us_link":[{"type":0,"value":"Contact us"}],"commerce-payment-failure-trials.contact_us_access.data_storage_link":[{"type":0,"value":"Data Storage FAQs"}],"commerce-payment-failure-trials.contact_us_access.downgrade_link":[{"type":0,"value":"downgrade to a free plan"}],"commerce-payment-failure-trials.couldnt-charge-card":[{"type":0,"value":"We\'re reaching out as we couldn\'t charge your card for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.couldnt-charge-paypal":[{"type":0,"value":"We couldn\'t charge your PayPal account for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" because there was a problem with your account settings or the payment method selected from your PayPal wallet."}],"commerce-payment-failure-trials.ent-org-name-with-space-label.no-translate":[{"type":1,"value":"separator"},{"type":0,"value":" "},{"type":1,"value":"entOrgName"},{"type":0,"value":" "}],"commerce-payment-failure-trials.entitlement-number-label.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.entitlement-number-text.no-translate":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce-payment-failure-trials.has_payment_method.add-payment-caption":[{"type":0,"value":"Add payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.caption":[{"type":0,"value":"Action required: Your payment was declined"}],"commerce-payment-failure-trials.has_payment_method.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment, based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.has_company_name.could_not_process_payment_for_following":[{"type":0,"value":"We couldn\'t process payment for "},{"type":1,"value":"companyName"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.has_payment_method.no_retries.partners.caption":[{"type":0,"value":"Action required: Update payment details by "},{"type":1,"value":"dueDate"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.has-next-retry.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Payment declined"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.partners.payment-declined-title.no-retries.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required to keep subscription"}],"commerce-payment-failure-trials.has_payment_method.payment-declined-title":[{"type":0,"value":"Action required: Payment declined for #"},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access":[{"type":0,"value":"Update your credit card details, or add a different credit card. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card--not-access-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual":[{"type":0,"value":"Update your payment details or add a different payment method to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-contact-bank":[{"type":0,"value":"Contact your bank if you need more information about the issue. Banks sometimes decline payments due to restrictions on international transactions."}],"commerce-payment-failure-trials.has_payment_method.update-credit-card-access-annual-monthly-subscriptions":[{"type":0,"value":"For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce-payment-failure-trials.has_payment_method.update-payment-caption":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce-payment-failure-trials.has_payment_method.update-paypal":[{"type":0,"value":"Log in to your PayPal account and go to your automatic payment settings. Select a different payment method for your Atlassian payment. You should also check that your account isn\'t restricted and allows international payments."}],"commerce-payment-failure-trials.has_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":", based on the payment information we have for this account."}],"commerce-payment-failure-trials.invoice-number":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"invoiceNumber"}],"commerce-payment-failure-trials.invoice-number-label":[{"type":0,"value":"Invoice Number:"}],"commerce-payment-failure-trials.invoice_pdf_attachment":[{"type":0,"value":"For your records, the invoice with payment due is attached as a PDF."}],"commerce-payment-failure-trials.item-description-label.no-translate":[{"type":1,"value":"description"}],"commerce-payment-failure-trials.item-description.no-translate":[{"type":0,"value":" "},{"type":1,"value":"description"}],"commerce-payment-failure-trials.log-in-paypal":[{"type":0,"value":"Log in to PayPal"}],"commerce-payment-failure-trials.no_payment_method.partners.add_your_payment_details":[{"type":0,"value":"Add payment details today to avoid interruptions."}],"commerce-payment-failure-trials.no_payment_method.partners.caption":[{"type":0,"value":"Add payment details to avoid interruptions"}],"commerce-payment-failure-trials.no_payment_method.partners.title.with-companyname":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.partners.title.without-companyName":[{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action required: Add payment details"}],"commerce-payment-failure-trials.no_payment_method.title":[{"type":0,"value":"Action required: Add your payment details"}],"commerce-payment-failure-trials.no_payment_method.unable_to_process_your_payment":[{"type":0,"value":"We were unable to process your payment since we haven\'t received your payment details for your subscription."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process":[{"type":0,"value":"We couldn\'t process your payment for Atlassian products as you haven\'t provided us with payment details yet."}],"commerce-payment-failure-trials.no_payment_method.we_could_not_process-access":[{"type":0,"value":"We\'re reaching out as we couldn\'t process your recent payment for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" due to an issue with your account\'s payment details."}],"commerce-payment-failure-trials.payment":[{"type":0,"value":"This payment was for:"}],"commerce-payment-failure-trials.paypal-details":[{"type":0,"value":"PayPal account: "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.sold-to-details.address":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"address"}],"commerce-payment-failure-trials.sold-to-details.address-message":[{"type":0,"value":"Address:"}],"commerce-payment-failure-trials.sold-to-details.company":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"companyName"}],"commerce-payment-failure-trials.sold-to-details.company-label":[{"type":0,"value":"Company:"}],"commerce-payment-failure-trials.sold-to-details.customer-contact":[{"type":1,"value":"element"},{"type":0,"value":" "},{"type":1,"value":"customerContact"}],"commerce-payment-failure-trials.sold-to-details.customer-contact-label":[{"type":0,"value":"Customer contact:"}],"commerce-payment-failure-trials.total-bill":[{"type":0,"value":"Your total bill is "},{"type":1,"value":"element"}],"commerce-payment-failure-trials.unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce-payment-failure-trials.update-credit-card":[{"type":0,"value":"Update your payment details today to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data and security configurations."}],"commerce-payment-failure-trials.update-credit-card-without-access":[{"type":0,"value":"Update your credit card details, or add a different credit card to ensure continuous access to the product and prevent any potential loss of data."}],"commerce-payment-failure-trials.we_will_try_to_process_again":[{"type":0,"value":"We\u2019ll try to process your payment again on "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce-payment-failure-trials.what-to-do":[{"type":0,"value":"What you need to do:"}],"commerce-payment-failure-trials.without-payment-faq-product-access-lost":[{"type":0,"value":"Without this payment, product access will be lost, and product data will be permanently deleted soon after. See our "},{"type":1,"value":"element"}],"commerce-permission-request-add-payment-ccp.email.add-payment-request-text":[{"type":0,"value":"There is an add payment request from "},{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") for the subscription: "}],"commerce-permission-request-add-payment-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce-permission-request-add-payment-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce-permission-request-add-payment-ccp.email.personal-note.no-translate":[{"options":{"other":{"value":[{"type":0,"value":"Hi, I\u2019d like to request an upgrade and need payment details added to this subscription."}]},"true":{"value":[{"type":1,"value":"customMessage"}]}},"type":5,"value":"hasCustomMessage"}],"commerce-permission-request-add-payment-ccp.email.subtext-for-personal-note":[{"type":0,"value":"To help you with more details, here\u2019s a note from the requester: "}],"commerce-permission-request-add-payment-ccp.email.title":[{"type":0,"value":"Request from "},{"type":1,"value":"name"},{"type":0,"value":" to add payment details"}],"commerce-permission-request-add-payment-ccp.email.whats-next-subtext":[{"type":0,"value":"If you approve the request, continue with adding payment details for the subscription and we\u2019ll notify the requester. Ignore this email to deny. "}],"commerce-permission-request-add-payment-response-ccp.email.add-payment-request-text":[{"type":0,"value":"Great news! Your request has been approved. Billing admin has added payment details to your subscription."}],"commerce-permission-request-add-payment-response-ccp.email.benefits-text":[{"type":0,"value":"You can now enjoy the benefits of:"}],"commerce-permission-request-add-payment-response-ccp.email.go-to-site":[{"type":0,"value":"Go to site"}],"commerce-permission-request-add-payment-response-ccp.email.title":[{"type":0,"value":"Your request is complete"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-count":[{"type":0,"value":"Units: "},{"type":1,"value":"count"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.add-on-entitlement-number":[{"type":1,"value":"entitlementNumber"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.free-entitlement.no-action":[{"type":0,"value":"You don\u2019t need to do anything, and your monthly Statuspage payments will remain the same."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.merged-addon":[{"type":0,"value":"Over the next few days, we\u2019ll simplify things for you by merging these "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on subscriptions into one:"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.multiple-addons":[{"type":0,"value":"We noticed your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" for "},{"type":1,"value":"site"},{"type":0,"value":" has more than one "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-on: "}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.merged-add-on":[{"type":0,"value":"You\u2019ll only see one Subscribers add-on listed on your next invoice."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-change":[{"type":0,"value":"There\u2019s no change to what you\u2019ll pay each month."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.paid-entitlement.no-setup":[{"type":0,"value":"You won\u2019t need to set up or configure anything."}],"commerce-pre-comms-sp-add-on-merge-ccp.email.title":[{"type":0,"value":"We\u2019re merging your "},{"type":1,"value":"addOnName"},{"type":0,"value":" add-ons for Statuspage"}],"commerce-pre-comms-sp-add-on-merge-ccp.email.what-this-means":[{"type":0,"value":"What this means for you"}],"commerce-reactivation-order-to-paid-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-auto-servco-upgrade-notification.message.link.view.apps":[{"type":0,"value":"View apps"}],"commerce-subscription-auto-servco-upgrade-notification.message.link.what.is.service.collection":[{"type":0,"value":"What\'s Service Collection?"}],"commerce-subscription-auto-servco-upgrade-notification.message.text":[{"type":0,"value":"Jira Service Management has moved to Service Collection on your site. You can now use the new Customer Service Management app while your existing setup stays the same."}],"commerce-subscription-auto-servco-upgrade-notification.message.title":[{"type":0,"value":"Jira Service Management update"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.agent":[{"type":0,"value":"We upgraded you to a no-cost 14 day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard, because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":"-"},{"type":1,"value":"userType"},{"type":0,"value":" for the Free plan. Add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to avoid deactivation. Cancel anytime.\\nYou can switch back to a Free plan anytime by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count."}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.body.full.user":[{"type":0,"value":"We upgraded you to a no-cost 14 day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard, because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":"-"},{"type":1,"value":"userType"},{"type":0,"value":" for the Free plan. Add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to avoid deactivation. Cancel anytime.\\nYou can switch back to a Free plan anytime by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count."}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.path.manage.billing":[{"type":0,"value":"Manage billing"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.primary.action":[{"type":0,"value":"Add payment"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.secondary.action":[{"type":0,"value":"Manage subscriptions"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.agent":[{"type":0,"value":"Subscription upgraded: Add payment or remove "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" before your trial ends"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.commerce.auto.upgrade.no.payment.notification.title.user":[{"type":0,"value":"Subscription upgraded: Add payment or remove "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" before your trial ends"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.in-app.screen-space-flags.flag-body.no-translate":[{"type":0,"value":"This is the test message body"}],"commerce-subscription-auto-upgrade-no-payment-method-ccp.in-app.screen-space-flags.flag-title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"commerce-subscription-cancellation-ecc.email.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" canceled"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp-g.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-1":[{"type":0,"value":"To reactivate your subscription, go to "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-2":[{"type":0,"value":"Subscriptions > Inactive "}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-3":[{"type":0,"value":"tab"}],"commerce-subscription-cancellation-occurs-ccp.email.reactivate-instructions-4":[{"type":0,"value":" > Reactivate."}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-auto-conversion-off-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext":[{"type":1,"value":"entitlementNumber"}],"commerce-subscription-paid-trials-no-payment-method-ccp.subtext-with-site-url":[{"type":1,"value":"siteURL"},{"type":0,"value":" &#x2022; "},{"type":1,"value":"entitlementNumber"}],"commerce-subscription-reactivation-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"}],"commerce-subscription-reactivation-trial-ccp.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce-subscription-skip-trial-ccp.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.estimated-bill":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excluding tax)"},{"type":1,"value":"content"}],"commerce-subscription-skip-trial-ccp.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is active"}],"commerce-subscription-skip-trial-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" subscription "}],"commerce-subscription-systematic-downgrade-ccp.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" subscription "}],"commerce.bill-estimate-common.key":[{"type":0,"value":"Estimated bill:"}],"commerce.bill-estimate-common.value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"},{"type":0,"value":" (excludes tax)"}],"commerce.billing-cycle-common.key":[{"type":0,"value":"Billing cycle:"}],"commerce.billing-cycle-common.value":[{"type":1,"value":"billingCycle"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.3ds-secure":[{"type":0,"value":"3DS is a mechanism that makes your online card transactions more secure."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.caption":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.help":[{"type":0,"value":"We couldn\'t process your payment since we need your help to complete 3-D Secure (3DS) authentication."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.retry":[{"type":0,"value":"3DS is a mechanism that makes your online card transactions more secure. Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or be asked to authenticate in a different way."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.international-transactions":[{"type":0,"value":"Keep in mind that banks sometimes decline payments due to restrictions on international transactions."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.help":[{"type":0,"value":"We couldn\'t process your payment for the following invoice because we need your help to complete 3-D Secure (3DS) authentication:"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.retry":[{"type":0,"value":"Retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or be asked to authenticate in a different way."}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Action needed: Retry payment"}],"commerce.commerce-3ds-failure-generic-email-ccp.message-template.email.retry-payment-button":[{"type":0,"value":"Retry payment"}],"commerce.commerce-approvals-received-author-notification.email.body":[{"type":0,"value":"Your initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") has been approved and is now ready for release."}],"commerce.commerce-approvals-received-author-notification.email.cta.link":[{"type":0,"value":"Click on the button below to release the initiative in Workbench."}],"commerce.commerce-approvals-received-author-notification.email.initiative.link":[{"type":0,"value":"Go to initiative"}],"commerce.commerce-approvals-received-author-notification.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-approvals-received-author-notification.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-approvals-received-author-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-approvals-received-author-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Your initiative is ready for release"}],"commerce.commerce-approvals-received-author-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.email.partner.reactivate-button.ai-non-final":[{"type":0,"value":"Reactivate"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.email.reactivate-button.ai-non-final":[{"type":0,"value":"Reactivate"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.cancellation-reason":[{"type":0,"value":"It could be because the information provided to us is incorrect or incomplete. Don\'t worry,\\n                            the subscription can be reactivated after you update your billing information."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.reactive-within":[{"type":1,"value":"content"},{"type":0,"value":" If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.body.subscription-cancellation-message":[{"type":0,"value":"We couldn\'t generate an invoice for the following subscription as we don\'t have your complete billing information.\\n                            As a result, the subscription has been canceled."}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription canceled - update billing details"}],"commerce.commerce-auto-cancellation-uninvoiceable-ccp.message-template.email.partner.subject":[{"type":1,"value":"title"},{"type":0,"value":" canceled"}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.caption":[{"type":0,"value":"You are now on the Free plan of "},{"type":1,"value":"productName"}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.interruptions":[{"type":0,"value":"To avoid any interruptions, make sure your payment details are up to date."}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.invoice-failure":[{"type":0,"value":"We were unable to generate an invoice for your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementId"},{"type":0,"value":") as we don\'t have your complete billing information. As a result, we\'ve moved your subscription to the Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.body.upgrade":[{"type":0,"value":"Want to go back on your original plan? You can upgrade your subscription. "},{"children":[{"type":0,"value":"Learn how to change plans"}],"type":8,"value":"link"}],"commerce.commerce-auto-downgrade-uninvoiceable-ccp.message-template.email.subject":[{"type":1,"value":"productName"},{"type":0,"value":" subscription moved to Free plan"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.caption":[{"type":0,"value":"Changes have been made to your billing account"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.bill-to-party":[{"type":0,"value":"your billing details were updated. The following changes were made:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.bill-to-price-eligibility":[{"type":0,"value":"your bill-to pricing eligibility was changed."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.invoice-group-recipients":[{"type":0,"value":"your list of invoice recipients was changed."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.ship-to-party":[{"type":0,"value":"your sold-to details were updated. The following changes were made:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.change.ship-to-price-eligibility":[{"type":0,"value":"your sold-to pricing eligibility was changed."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.company-name-key":[{"type":0,"value":"Company name:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.introduction":[{"type":0,"value":"This email is to let you know that some changes were made to a billing account managed by you."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.invoice-group.recipients":[{"type":0,"value":"Updated list of recipients:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.notice":[{"type":0,"value":"To centrally manage all your accounts, visit "},{"type":1,"value":"adminHubLink"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.phone-key":[{"type":0,"value":"Phone:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.postal-address":[{"type":0,"value":"Postal address:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.party.tax-id-key":[{"type":0,"value":"Tax id:"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.academic":[{"type":0,"value":"Price eligibility was updated to Academic."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.classroom":[{"type":0,"value":"Price eligibility was updated to Classroom."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.community":[{"type":0,"value":"Price eligibility was updated to Community."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.generic":[{"type":0,"value":"Price eligibility was updated."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.price-eligibility.opensource":[{"type":0,"value":"Price eligibility was updated to Open Source."}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.subject":[{"type":0,"value":"Atlassian billing account information was updated"}],"commerce.commerce-billing-admin-notification-email-ccp.message-template.email.updated-at":[{"type":0,"value":"At "},{"type":1,"value":"updatedAt"},{"type":0,"value":","}],"commerce.commerce-cancellation-occurs-offering-archived-ccp-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.body.summary.partner":[{"type":0,"value":"We\'ve canceled the following subscription:"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.we-have-cancelled-the-following-subscription":[{"type":0,"value":"We\'ve canceled the following subscription"}],"commerce.commerce-cancellation-occurs-offering-archived-ccp.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.direct-customer.jsm-requirement":[{"type":0,"value":"This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.direct-customer.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.partner.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.email.partner.caption.twc":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" scheduled for cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.body.sub-cancel-note.twc":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button":[{"type":0,"value":"View subscription"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.received-request":[{"type":0,"value":"We\'ve received your request to cancel your subscription:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.body.sub-cancel-note":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.billing-partner-details.twc":[{"type":0,"value":"Your billing partner details are:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.data-deletion-note":[{"type":0,"value":"Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you\u2019d like to request deletion of personal data, "},{"type":1,"value":"contactSupport"},{"type":0,"value":". Learn about "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.contact-us":[{"type":0,"value":"contact us"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.data-deletion-note":[{"type":0,"value":"Product data will be deleted 60 days from cancellation. For trials, we retain data for 15 days. If you\'d like to request deletion of personal data, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.intro":[{"type":0,"value":"Your app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to contact your Atlassian billing partner to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.received-request":[{"type":0,"value":"We\'ve received a request to cancel the following subscription:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.received-request.twc":[{"type":0,"value":"We\'ve received your request to cancel your subscription"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.undo-cancellation":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.ecc.body.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.email.ecc.subject":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.email.ecc.subject.twc":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-admin.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.billing-user.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.customer-details.twc":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy":[{"type":0,"value":"Atlassian\u2019s Privacy Policy"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.ecc.contact-billing-partner":[{"type":0,"value":"You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.intro":[{"type":0,"value":"Your customer\'s app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since your customer doesn\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.keep-subscription":[{"type":0,"value":"Keeping the subscription"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.keep-subscription.twc":[{"type":0,"value":"Your customer contact can undo the cancellation at any time from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.partner-managed-subscriptions-link":[{"type":1,"value":"partnerManagedSubscriptionsLink"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link":[{"type":0,"value":"Learn how to undo a cancellation"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.received-request":[{"type":0,"value":"We\u2019ve received a request to cancel the following subscription:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.received-request.twc":[{"type":0,"value":"We\u2019ve received your customer\u2019s request to cancel their subscription."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.sub-cancel-note":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.sub-cancel-note.twc":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". Until then, the subscription can still be used. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.body.subscription-details.twc":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.with-company-name.twc":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.without-company-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cancellation-scheduled-offering-archived-ccp.message-template.email.partner.subject.without-company-name.twc":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.body.billing-faq-url":[{"type":0,"value":"When and how will I be billed?"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-adjust-limit":[{"type":0,"value":"Organization admins can adjust this limit anytime."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-body":[{"type":0,"value":"Your organization has reached the monthly "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit set by your admin. As a result, some features will be restricted or unavailable until your usage reset date. "},{"type":1,"value":"learnMoreLink"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-caption":[{"type":0,"value":"Your organization has hit its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.breach-visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-body":[{"type":0,"value":"Your organization has used 80% of its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit. This is a limit that was set by your admin, and is different to the allowance included with your subscriptions."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"80% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit has been used"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next":[{"type":0,"value":"Once your organization reaches the limit, some features will be restricted or unavailable until your usage resets. Organization admins can adjust this limit anytime."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next.enforced":[{"type":0,"value":"For the amount of usage above the allowance, at the end of the current cycle, you\u2019ll receive a bill for extra usage incurred this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.milestone-whats-next.non-enforced":[{"type":0,"value":"Any usage beyond your allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.breach":[{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"Your organization has used 80% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.more-about-usage-charges-and-billing":[{"type":0,"value":"More about usage charges and billing"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.email.whats-next":[{"type":0,"value":"What\'s next?"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-adjust-limit":[{"type":0,"value":"You can adjust this limit anytime."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-body":[{"type":0,"value":"Your customer has reached the monthly "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit you set. As a result, some features will be restricted or unavailable for your customer until their usage reset date. "},{"type":1,"value":"learnMoreLink"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-caption":[{"type":0,"value":"Your customer has hit their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.breach-visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-body":[{"type":0,"value":"Your customer has used 80% of their organization\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit. This is a limit that was set by your customer\'s admin, and is different to the allowance included with your customer\'s subscriptions."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"80% of your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit has been used"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone-whats-next":[{"type":0,"value":"Once your customer reaches the limit, some features will be restricted or unavailable until their usage resets. You can adjust this limit anytime."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone.billable-usage-notice.enforced":[{"type":0,"value":"For the amount of usage above the allowance, at the end of the current cycle, you\u2019ll receive a bill for extra usage incurred this cycle."}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.milestone.billable-usage-notice.non-enforced":[{"type":0,"value":"Any usage beyond your allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.breach.without-company-name":[{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit reached"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": 80% of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-cbp-hard-limit-breach-ccp.message-template.partner.email.subject.milestone.without-company-name":[{"type":0,"value":"80% of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit"}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.email.body.usage":[{"type":0,"value":"Your organization has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of its "},{"type":1,"value":"productName"},{"type":0,"value":" committed pack."}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"productName"},{"type":0,"value":" committed pack usage in your organization."}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.email.caption":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"productName"},{"type":0,"value":" committed pack has been used"}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.email.subject.exhausted":[{"type":1,"value":"productName"},{"type":0,"value":" committed pack used"}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" committed pack is running low"}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.partner.email.body.usage":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" committed pack."}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.partner.email.body.visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"productName"},{"type":0,"value":" committed pack usage."}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.partner.email.caption":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"productName"},{"type":0,"value":" committed pack has been used"}],"commerce.commerce-committed-pack-usage-reminder-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of "},{"type":1,"value":"productName"},{"type":0,"value":" committed pack used"}],"commerce.commerce-credit-account-approval-ccp.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-approval-ccp.message-template.approved.title":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application has been approved"}],"commerce.commerce-credit-account-approval-ccp.message-template.email.subject":[{"type":0,"value":"Approved for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-approval-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve approved your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms. Here are the details: "}],"commerce.commerce-credit-account-deactivation-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your account is now ineligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-limit-update-ccp.email.list.new-credit-limit":[{"type":0,"value":"New Credit limit: "},{"type":1,"value":"newCreditLimitFormatted"},{"type":1,"value":"limitShareText"}],"commerce.commerce-credit-account-limit-update-ccp.email.possible-reasons":[{"type":0,"value":"Learn about possible reasons."}],"commerce.commerce-credit-account-limit-update-ccp.email.statement-info":[{"type":0,"value":"We\u2019ve decreased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". "},{"type":1,"value":"possibleReasons"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.decrease.title":[{"type":0,"value":"We\u2019ve decreased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.decrease.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been decreased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.email.increase.subject":[{"type":0,"value":"Your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit has been increased"}],"commerce.commerce-credit-account-limit-update-ccp.message-template.good-news":[{"type":0,"value":"Good news! We\u2019ve increased your credit limit to "},{"type":1,"value":"newCreditLimitFormatted"},{"type":0,"value":". Your previous credit limit was "},{"type":1,"value":"creditLimitFormatted"},{"type":0,"value":". Here are the details: "}],"commerce.commerce-credit-account-limit-update-ccp.message-template.increase.title":[{"type":0,"value":"We\u2019ve increased your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" credit limit"}],"commerce.commerce-credit-account-reactivation-ccp.message-template.email.subject":[{"type":0,"value":"Your account is now re-eligible for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.bad-news":[{"type":0,"value":"Unfortunately, we couldn\u2019t approve your application because you didn\u2019t meet our credit check requirements."}],"commerce.commerce-credit-account-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Couldn\u2019t approve your Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms application"}],"commerce.commerce-credit-account-rejection-ccp.message-template.other-option":[{"type":0,"value":"You can still move forward with your purchase. We suggest using a credit card to pay for your order. Reach out to us if you need further help in placing your order."}],"commerce.commerce-credit-account-rejection-ccp.message-template.rejection.title":[{"type":0,"value":"We\u2019re unable to approve you for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms"}],"commerce.commerce-credit-account-rejection-ccp.message-template.thanks":[{"type":0,"value":"Thank you for submitting your application for Net-"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" payment terms."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.email.subject":[{"type":0,"value":"Credit Application Result: Reject"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.how-to-move-forward":[{"type":0,"value":"Here\'s how to move forward:"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.all-fields":[{"children":[{"type":0,"value":"Double-check"}],"type":8,"value":"strong"},{"type":0,"value":" that every field is filled in \u2014 this helps us complete our review faster."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.return-form":[{"children":[{"type":0,"value":"Send them the form"}],"type":8,"value":"strong"},{"type":0,"value":" and ask them to return it directly to us."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.sign":[{"children":[{"type":0,"value":"Sign"}],"type":8,"value":"strong"},{"type":0,"value":" the top of the form."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.instruction.vendors":[{"children":[{"type":0,"value":"Choose two vendors"}],"type":8,"value":"strong"},{"type":0,"value":" you\'ve traded with for at least 12 months, whose trade volume with you exceeds the credit limit you\'re requesting. Please note: they can\'t be related entities."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.financial-statements":[{"children":[{"type":0,"value":"Latest audited financial statements"}],"type":8,"value":"strong"},{"type":0,"value":" (if you haven\'t already shared these), or"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.option.trade-references":[{"children":[{"type":0,"value":"A completed trade references form"}],"type":8,"value":"strong"},{"type":0,"value":" (attached)"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment":[{"type":0,"value":"The good news? This isn\'t final \u2014 we\'d be happy to reassess your account once we have a bit more information."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.reassessment-underway":[{"type":0,"value":"Once we receive everything, we\'ll get your reassessment underway."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.rejection":[{"type":0,"value":"Thank you for applying for payment terms with us. After carefully reviewing your application, we\'re unable to approve Net-30 terms at this time."}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.resubmit-instructions":[{"type":0,"value":"Once you have the additional information ready, you can resubmit a new Net-30 application directly from your account (the application link is available there). Just include "},{"children":[{"type":0,"value":"one"}],"type":8,"value":"strong"},{"type":0,"value":" of the following with your resubmission:"}],"commerce.commerce-credit-application-severe-rejection-ccp.message-template.trade-reference-intro":[{"type":0,"value":"Using the trade references form? Just follow these 4 steps:"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.card-expiry-warning-message":[{"type":0,"value":"Heads up \u2014 your credit card expires in "},{"type":1,"value":"expiryMonthAndYear"},{"type":0,"value":". To make sure your next payment is made on time so you can continue using your subscriptions without interruption, you\u2019ll need to update your payment details before "},{"type":1,"value":"dueDate"},{"type":0,"value":"."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action":[{"type":0,"value":"What happens if I don\u2019t update my details?"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.no-update-action-warning":[{"type":0,"value":"Your next payment attempt will fail \u2013 this means your subscription could be deactivated and you could lose product access and data."}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.select":[{"type":0,"value":"Select "}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Your credit card expires soon"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.time-to-update-credit-card-details":[{"type":0,"value":"Time to update your credit card details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details":[{"type":0,"value":"Update payment details"}],"commerce.commerce-credit-card-expiry-reminder-ccp.message-template.email.update-payment-details-note":[{"type":0,"value":" below to edit your saved card."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.email.subject":[{"type":0,"value":"Additional information needed for your Net-30 application"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.balance-sheet":[{"type":0,"value":"Balance Sheet"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.cash-flow":[{"type":0,"value":"Cash Flow Statement"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.financial.income-statement":[{"type":0,"value":"Income Statement"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.all-fields":[{"type":0,"value":"Ensure all fields are completed so we can finalize the review without delays."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.return-form":[{"type":0,"value":"Send them the form and ask them to return it directly to us."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.sign":[{"type":0,"value":"Sign the top of the form."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.instruction.vendors":[{"type":0,"value":"Select two vendors you\'ve traded with for at least 12 months, whose trade volume with you exceeds the credit limit you\'re requesting. Please note that they can\'t be related entities."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.intro":[{"type":0,"value":"Thank you for your interest in setting up Net-30 payment terms with us. After reviewing your D&B credit profile, we\'re unable to approve the request at this time."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-accounting-team":[{"type":0,"value":"Your accounting team should be able to provide these. They\'ll give us a clearer view of your account and support our reassessment."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-heading":[{"type":0,"value":"Option 1: Provide your audited financial statements"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option1-intro":[{"type":0,"value":"If you haven\'t already shared these, please send your most recent:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-heading":[{"type":0,"value":"Option 2: Provide trade references"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.option2-intro":[{"type":0,"value":"If you\'d prefer this option, please complete the attached trade reference form. Here\'s what we\'ll need:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.reconsider":[{"type":0,"value":"If you\'d like us to reconsider, we\'d be glad to take another look with some additional information from your end."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.thank-you":[{"type":0,"value":"Thank you again for being an Atlassian customer. We appreciate your business and look forward to hearing from you soon."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.two-options":[{"type":0,"value":"You have two options:"}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-body":[{"type":0,"value":"Please let us know which option you\'d like to pursue, or feel free to reach out with any questions. We\'re here to support you and want to make this process as straightforward as possible."}],"commerce.commerce-credit-trade-reference-request-ccp.message-template.whats-next-heading":[{"type":0,"value":"What happens next?"}],"commerce.commerce-customer-contact-remove-digest.email.body.removed-contact":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":")"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.caption":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.contact-removed":[{"type":0,"value":"Contact removed: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.impacted-subscriptions":[{"type":0,"value":"Impacted subscriptions:"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.intro":[{"type":0,"value":"We\'ve removed a key customer contact from a billing profile."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.questions":[{"type":0,"value":"If you have any questions, please reach out to your Atlassian billing partner."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.removed-by":[{"type":0,"value":"Removed by: "}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes":[{"type":0,"value":"You can view the changes at "},{"type":1,"value":"url"},{"type":0,"value":" page."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.body.view-changes-link":[{"type":0,"value":"partner managed subscriptions"}],"commerce.commerce-customer-contact-remove-digest.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" subscriptions."}],"commerce.commerce-customer-contact-remove-digest.message-template.email.subject":[{"type":0,"value":"Customer contact removed"}],"commerce.commerce-customers-deactivation-eve.email.body-p1":[{"type":0,"value":"U.S. law prohibits Atlassian, an Australian corporation with offices in the United States, from providing you with access to our products and services. After analyzing the applicable lists of restricted parties maintained by the U.S. Government, we were unable to confirm that your name was not affiliated with a restricted party."}],"commerce.commerce-customers-deactivation-eve.email.body-p2":[{"type":0,"value":"If this is a case of misidentification, please reply with two different copies of official documentation to verify your identity."}],"commerce.commerce-customers-deactivation-eve.email.body-p3":[{"type":0,"value":"Official documentation includes, but is not limited to, a government-issued driver\'s license or identification card, passport, utility bill, mortgage or bank statement, etc. Please make sure your full name and address are clearly visible."}],"commerce.commerce-customers-deactivation-eve.email.body-p4":[{"type":0,"value":"You may check out these resources for more information: U.S. export controls ("},{"type":1,"value":"exportControl"},{"type":0,"value":") | Consolidated Screening List ("},{"type":1,"value":"csl"},{"type":0,"value":")"}],"commerce.commerce-customers-deactivation-eve.email.body-p5":[{"type":0,"value":"Please reply directly via email with any further questions and the identification requested."}],"commerce.commerce-customers-deactivation-eve.email.body-p6":[{"type":0,"value":"We look forward to your reply."}],"commerce.commerce-customers-deactivation-eve.email.body.csl":[{"type":0,"value":"https://www.trade.gov/consolidated-screening-list"}],"commerce.commerce-customers-deactivation-eve.email.body.exportControl":[{"type":0,"value":"https://www.trade.gov/us-export-controls"}],"commerce.commerce-customers-deactivation-eve.email.caption":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-customers-deactivation-eve.email.salutation":[{"type":0,"value":"Dear Atlassian user,"}],"commerce.commerce-customers-deactivation-eve.email.subject":[{"type":0,"value":"Deactivated Atlassian Account"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.billed-based-on-the-users":[{"type":0,"value":"Until now, billing for this app has been linked to your total user count for Jira. The change will mean that you\'ll be billed based on the number of agents who use the Jira Service Management subscription instead."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.billing-flexibility-info-message":[{"type":0,"value":"Billing flexibility is now available for your "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management app."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.body.this-change-will-introduce-pricing-updates":[{"type":0,"value":"The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn\'t updated."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.body.we-will-make-the-change":[{"type":0,"value":"We\'ll automatically make the change on "},{"type":1,"value":"nextBillingDate"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.caption":[{"type":0,"value":"Have more billing flexibility and only pay for what you need"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.if-you-dont-do-anything":[{"type":0,"value":"If you don\'t do anything"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.maximize-your-billing-efficiency":[{"type":0,"value":"Maximize your billing efficiency"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.need-more-info":[{"type":0,"value":"Need more info? See our guide on "},{"type":1,"value":"howMarketplaceAreBilled"},{"type":0,"value":"."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billed-based-on-the-users":[{"type":0,"value":"Until now, billing for this app has been linked to your customer\'s total user count for Jira. The change will mean that your customer will be billed based on the number of agents who use the Jira Service Management subscription instead."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.billing-flexibility-info-message":[{"type":0,"value":"Billing flexibility is now available for your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management app."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.this-change-will-introduce-pricing-updates":[{"type":0,"value":"The change will introduce pricing updates that are set out by our Marketplace partners. These updates will come into effect with the new way of billing, even if your user count isn\'t updated."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.body.we-will-make-the-change":[{"type":0,"value":"We\'ll automatically make the change on "},{"type":1,"value":"nextBillingDate"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.caption":[{"type":0,"value":"Give your customer more billing flexibility"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.customer-label":[{"type":0,"value":"Customer: "},{"type":1,"value":"customerName"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-for-what-you-need":[{"type":0,"value":"To only pay for what you need, your customer can update the number of JSM agents by heading to Atlassian Administration."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.pay-only-for-users-who-need-access":[{"type":0,"value":"This means they have the option to only pay for the users that really need access."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.partner.review-your-bill":[{"type":0,"value":"Make the switch now so your customer can start making the most of billing flexibility for this app. Keep in mind that the bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We\'d recommend reviewing the bill as you make the change."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.pay-for-what-you-need":[{"type":0,"value":"To only pay for what you need, your organization admin can update the number of JSM agents by heading to Atlassian Administration."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.pay-only-for-users-who-need-access":[{"type":0,"value":"This means you have the option to only pay for the users that really need access."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.review-your-bill":[{"type":0,"value":"Make the switch now to start making the most of billing flexibility for this app. Keep in mind that your bill may be impacted, and can be changed by the organization admin by managing JSM access as needed. We\'d recommend reviewing your bill as you make the change."}],"commerce.commerce-decoupled-offering-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Update billing for your Marketplace app"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-decoupled-offering-ccp.message-template.email.what-does-this-mean":[{"type":0,"value":"What does this mean?"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p1":[{"type":0,"value":"As requested, we\'ve updated the way you\'re billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management. You can now enjoy more control over who has access to and is charged for the app, and your bill will be based on the number of Jira Service Management agents, instead of the user count for Jira."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.direct.p2":[{"type":0,"value":"It\'s a good idea to review who you\'d like to have access to the app. Keep in mind that your bill may be impacted, and organization admins can change it by managing who has access to the app as needed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p1":[{"type":0,"value":"As requested, we\'ve updated the way your customer is billed for "},{"type":1,"value":"productName"},{"type":0,"value":" for Jira Service Management. They can now enjoy more control over who has access to and is charged for the app, and the bill will be linked to the number of JSM agents instead of the user count for Jira."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.body.partner.p2":[{"type":0,"value":"It\'s a good idea to remind your customer to review who they\'d like to have access to the app, and their bill may be impacted. Organization admins can adjust the bill by managing who has access to the app as needed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.button.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.help":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouch"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.get-in-touch":[{"type":0,"value":"Get in touch"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.link.how-billed":[{"type":0,"value":"Find out more about how Marketplace apps are billed."}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.signoff":[{"type":0,"value":"Thanks,"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" for JSM billing has been updated"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.subject.partner":[{"type":0,"value":"Update billing for your customer\'s Marketplace app"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.team":[{"type":0,"value":"The Atlassian team"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.direct":[{"type":0,"value":"Enjoy more control over your Marketplace app billing"}],"commerce.commerce-decoupled-offering-order-confirmation-ccp.message-template.email.title.partner":[{"type":0,"value":"Enjoy more control over your customer\'s app billing"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.credit-note-button":[{"type":0,"value":"View credit note"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.caption":[{"type":0,"value":"Your credit note has been generated"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.processed":[{"type":0,"value":"We have processed your cancellation request for subscriptions under the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". We\'ve generated a credit note "},{"type":1,"value":"creditNoteNumber"},{"type":0,"value":" against your invoice and adjusted the outstanding amount."}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.direct.subject":[{"type":0,"value":"Credit note generated against invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.no-refund":[{"type":0,"value":"Please note that this credit note will not result in any refund since it is generated against an unpaid invoice."}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.caption":[{"type":0,"value":"Credit note generated"}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.processed":[{"type":0,"value":"We\'ve processed a cancellation request for subscriptions under the following invoice. We\'ve generated a credit note against the invoice and adjusted the outstanding amount."}],"commerce.commerce-dunning-cancellation-credit-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Credit note generated"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.custom":[{"type":1,"value":"greetingText"}],"commerce.commerce-dynamic-content-test-cns.message-template.email.greeting.default":[{"type":0,"value":"Dear "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-dynamic-content-test-cns.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.body.click":[{"type":0,"value":"Please click the button below to view and approve the initiative in Workbench."}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.body.reminder":[{"type":0,"value":"Just a reminder that "},{"type":1,"value":"ownerName"},{"type":0,"value":" submitted an initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") for your approval."}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"Review initiative"}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.subject.no-translate":[{"type":0,"value":"Reminder: An initiative is awaiting your approval"}],"commerce.commerce-final-reviewer-notification-every-x-days.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-invoice-drawdown-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian invoice is ready"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"message"}],"commerce.commerce-invoice-generated-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-generated-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"businessKey"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-generated-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice has been processed"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.body":[{"type":0,"value":"As requested, we\'ve attached a copy of your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":")."}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.caption":[{"type":0,"value":"Your invoice is ready"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your invoice is attached ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":")"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" invoice is attached ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":")"}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.body":[{"type":0,"value":"You can also access your invoices in your billing account."}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.partner.body":[{"type":0,"value":"You can also access your invoices in the Partner Purchasing Center."}],"commerce.commerce-invoice-resend-email-ccp.message-template.email.view-invoices.view-invoices":[{"type":0,"value":"View invoices"}],"commerce.commerce-invoice-resend-email-ccp.view-invoices.view-invoices":[{"type":0,"value":"View invoices"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp-g.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" Invoice generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" generated"}],"commerce.commerce-invoice-terms-payment-pending-ccp.message-template.email.subject":[{"type":0,"value":"Your invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been processed"}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.direct.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\'ve received your payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The invoice is attached as a PDF for your records."}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your payment has been processed for the invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.partner-or-reseller.confirm":[{"type":0,"value":"This email is to confirm we\'ve received payment for the following invoice:"}],"commerce.commerce-invoice-terms-payment-received-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Payment processed"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.amount-label":[{"type":0,"value":"Amount Due:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.attached-pdf":[{"type":0,"value":"Please find attached a copy of the invoice for your reference with payment instructions. To ensure uninterrupted service, we request that you settle this outstanding amount as soon as possible."}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.caption":[{"type":0,"value":"Reactivation of Services and Payment Reminder"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.contact-us":[{"type":0,"value":"If there are any issues or if you require any additional information, feel free to "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.contact-us-link":[{"type":0,"value":"contact us"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.details":[{"type":0,"value":"Upon reactivation of your subscription, we wish to remind you that your "},{"children":[{"type":0,"value":"previous invoice is overdue"}],"type":8,"value":"strong"},{"type":0,"value":". See below details:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.due-date-label":[{"type":0,"value":"Due Date:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.invoice-date-label":[{"type":0,"value":"Invoice Date:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.invoice-number-label":[{"type":0,"value":"Invoice:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.payment-confirm":[{"type":0,"value":"If you have already made the payment, please send remittance advice to "},{"type":1,"value":"arLink"},{"type":0,"value":"."}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.reactivation-date-label":[{"type":0,"value":"Reactivation Date:"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.subject":[{"type":0,"value":"Reactivation of Services and Payment Reminder - Invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-invoice-terms-post-uncollectible-dunning-email-ccp.message-template.email.thank-you":[{"type":0,"value":"Thank you for your prompt attention to this matter."}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp-g.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.company-name.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.partner.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-invoice-updated-ccp.message-template.email.subject":[{"type":0,"value":"Invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" updated"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.offer-message":[{"type":0,"value":"When you use the two together, you can centralize your docs, connect work across teams and more. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-congratulations-message":[{"type":0,"value":"Did you know that "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Confluence?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.single-product-caption":[{"type":0,"value":"Build a single source of truth for all your team\u2019s important info"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.confluence.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.cta.try-now":[{"type":0,"value":"Try now"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.offer-message":[{"type":0,"value":"Together, the products help you capture ideas and prioritize work, so you\u2019re always organized. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-congratulations-message":[{"type":0,"value":"Did you know "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" works even better with Jira Product Discovery?"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.single-product-caption":[{"type":0,"value":"Say goodbye to messy backlogs"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jpd.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.offer-message":[{"type":0,"value":"With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-congratulations-message":[{"type":0,"value":"People who use Jira Service Management say that work is more visible for all teams involved, from request to resolution."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.single-product-caption":[{"type":0,"value":"Bring developers, IT, and operations onto the same platform"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsm.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.offer-message":[{"type":0,"value":"With Jira, your team can move fast, stay aligned, and build better - together. With the Standard plan, you get:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-congratulations-message":[{"type":0,"value":"Jira and "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" can help you visualize and deliver work, fast."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.single-product-caption":[{"type":0,"value":"Break down silos and connect the dots between teams"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.jsw.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-congratulations-message":[{"type":0,"value":"Congrats on purchasing "},{"type":1,"value":"purchasedProductTitle"},{"type":0,"value":"! Get free trials of these products and unlock these advanced features:"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.multi-product-caption":[{"type":0,"value":"Get free trials of "},{"type":1,"value":"productName1"},{"type":0,"value":" & "},{"type":1,"value":"productName2"},{"type":0,"value":" Standard with your "},{"type":1,"value":"purchasedProductName"},{"type":0,"value":" purchase"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.trial-length-message":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.body.welcome":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement-with-trial-length.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.multi-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"firstProduct"},{"type":0,"value":" & "},{"type":1,"value":"secondProduct"},{"type":0,"value":" free"}],"commerce.commerce-marketing-multiple-product-upgrade-ccp.message-template.email.single-entitlement.subject":[{"type":0,"value":"Try "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.advanced-user-space-permissions":[{"type":0,"value":"Advanced user & space permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.higher-automation-limit":[{"type":0,"value":"Higher automation limit"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.insights-into-page-views":[{"type":0,"value":"Get insights into page views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.on-call-management":[{"type":0,"value":"On-call management"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.published-views":[{"type":0,"value":"Published views"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.trial-length":[{"type":0,"value":"Free "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":"-day trial"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day trial"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":". Cancel anytime."}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents":[{"type":0,"value":"Unlimited agents"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-agents-storage":[{"type":0,"value":"Unlocked agent & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creator-storage":[{"type":0,"value":"Unlocked creator & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-user-storage":[{"type":0,"value":"Unlocked user & storage limits"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.unlimited-users":[{"type":0,"value":"Unlimited users"}],"commerce.commerce-marketing-multiple-product-upgrade.email.body.feature.user-project-permissions":[{"type":0,"value":"Advanced user & project permissions"}],"commerce.commerce-marketing-multiple-product-upgrade.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-archive.alt-text":[{"type":0,"value":"Icon - Archive"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-graph.alt-text":[{"type":0,"value":"Icon - Graph"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-lightning.alt-text":[{"type":0,"value":"Icon - Lightning"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-link.alt-text":[{"type":0,"value":"Icon - Link"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-people.alt-text":[{"type":0,"value":"Icon - People"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-phone.alt-text":[{"type":0,"value":"Icon - Phone"}],"commerce.commerce-marketing-multiple-product-upgrade.email.icon-unlock.alt-text":[{"type":0,"value":"Icon - Unlock"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.commerce-marketing-multiple-product-upgrade.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.automatic-removal":[{"type":0,"value":"After "},{"type":1,"value":"uninstallDate"},{"type":0,"value":", no further action will be required from you; the app will be removed automatically."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.back-up-data":[{"type":0,"value":"Export or back up any data you need from the app."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.caption":[{"type":0,"value":"Final notice: action required"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.exception-heading":[{"type":0,"value":"If you have an unresolved concern"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.exception-path":[{"type":0,"value":"\u2014 an active support commitment, contractual arrangement, or ownership dispute \u2014 reply to this email today so we can review before we proceed."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.find-alternative":[{"type":0,"value":"Identify a supported alternative on the "},{"type":1,"value":"marketplaceLink"},{"type":0,"value":" and migrate if needed."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.introduction":[{"type":0,"value":"This is your final notice. On "},{"type":1,"value":"uninstallDate"},{"type":0,"value":", Atlassian will uninstall the following unsupported app(s) from your Atlassian site ("},{"type":1,"value":"siteName"},{"type":0,"value":" \u2014 "},{"type":1,"value":"siteUrl"},{"type":0,"value":") and access will be removed:"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.marketplace-link":[{"type":0,"value":"Atlassian Marketplace"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.recommended-actions-introduction":[{"type":0,"value":"Before "},{"type":1,"value":"uninstallDate"},{"type":0,"value":", please:"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.retirement-status":[{"type":0,"value":"These apps\u2019 Marketplace listings have been archived and are no longer maintained or supported."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.review-use":[{"type":0,"value":"Review whether the app is still in active use on your site."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.signature":[{"type":0,"value":"Thank you, The Atlassian Marketplace team"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.subject":[{"type":0,"value":"Final notice \u2014 app will be uninstalled on "},{"type":1,"value":"uninstallDate"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.support":[{"type":0,"value":"If you need help, please "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.support-link":[{"type":0,"value":"contact Atlassian Support"}],"commerce.commerce-marketplace-app-uninstall-final-notice.message-template.email.uninstall-early":[{"type":0,"value":"Uninstall the app yourself once you\u2019re ready \u2014 no need to wait for the deadline."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.affected-apps":[{"type":0,"value":"App(s) affected on your site"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.app-retirement-status":[{"type":0,"value":" \u2014 Marketplace listing archived"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.back-up-data":[{"type":0,"value":"Export or back up any data you need from the app."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.caption":[{"type":0,"value":"Action required"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.exception-path":[{"type":0,"value":"If you believe this affects you in error, or you have an active support commitment or contractual arrangement tied to this app, reply to this email so we can review your account before any action is taken."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.find-alternative":[{"type":0,"value":"Identify a supported alternative on the "},{"type":1,"value":"marketplaceLink"},{"type":0,"value":" and migrate if needed."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.introduction":[{"type":0,"value":"We\u2019re contacting you because one or more apps installed on your Atlassian site ("},{"type":1,"value":"siteName"},{"type":0,"value":" \u2014 "},{"type":1,"value":"siteUrl"},{"type":0,"value":") are tied to Marketplace listings that have been archived by their partner and are no longer maintained or supported."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.no-support":[{"type":0,"value":"These apps no longer receive updates, fixes, or security patches, and there is no supported version or partner support available."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.recommended-actions":[{"type":0,"value":"What we recommend you do before "},{"type":1,"value":"uninstallDate"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.reminder":[{"type":0,"value":"We\u2019ll send you a reminder before the deadline. Thank you for helping us keep your site secure and supported."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.review-use":[{"type":0,"value":"Review whether the app is still in active use on your site."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.signature":[{"type":0,"value":"The Atlassian Marketplace team"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.subject":[{"type":0,"value":"Action needed by "},{"type":1,"value":"uninstallDate"},{"type":0,"value":": an app on your Atlassian site is being retired"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.support":[{"type":0,"value":"If you need help, please "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.support-link":[{"type":0,"value":"contact Atlassian Support"}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.uninstall-action":[{"type":0,"value":"To keep your site secure and supported, Atlassian will remove access to and uninstall these app(s) on "},{"type":1,"value":"uninstallDate"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.uninstall-early":[{"type":0,"value":"Uninstall the app yourself once you\u2019re ready \u2014 no need to wait for the deadline."}],"commerce.commerce-marketplace-app-uninstall-notice.message-template.email.what-this-means":[{"type":0,"value":"What this means"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.already-uninstalled":[{"type":0,"value":"If you\u2019ve already uninstalled it, no further action is needed and you can ignore this message."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.back-up-data":[{"type":0,"value":"Export or back up any data you need from the app."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.caption":[{"type":0,"value":"Reminder: action required"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.exception-heading":[{"type":0,"value":"Need more time or think this is in error?"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.exception-path":[{"type":0,"value":"If you have an active support commitment, contractual arrangement, or a dispute about ownership of this app, reply to this email and we\u2019ll review your account before any action is taken."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.find-alternative":[{"type":0,"value":"Identify a supported alternative on the "},{"type":1,"value":"marketplaceLink"},{"type":0,"value":" and migrate if needed."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.introduction":[{"type":0,"value":"This is a reminder that the following unsupported app(s) on your Atlassian site ("},{"type":1,"value":"siteName"},{"type":0,"value":" \u2014 "},{"type":1,"value":"siteUrl"},{"type":0,"value":") will be uninstalled by Atlassian on "},{"type":1,"value":"uninstallDate"},{"type":0,"value":" because the Marketplace listing has been archived or removed:"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.marketplace-link":[{"type":0,"value":"Atlassian Marketplace"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.recommended-actions-introduction":[{"type":0,"value":"Before "},{"type":1,"value":"uninstallDate"},{"type":0,"value":", we recommend you:"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.review-use":[{"type":0,"value":"Review whether the app is still in active use on your site."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.signature":[{"type":0,"value":"The Atlassian Marketplace team"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.still-time":[{"type":0,"value":"There is still time to act."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.subject":[{"type":0,"value":"Reminder \u2014 app retirement on your Atlassian site on "},{"type":1,"value":"uninstallDate"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.support":[{"type":0,"value":"If you need help, please "},{"type":1,"value":"supportLink"},{"type":0,"value":"."}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.support-link":[{"type":0,"value":"contact Atlassian Support"}],"commerce.commerce-marketplace-app-uninstall-reminder.message-template.email.uninstall-early":[{"type":0,"value":"Uninstall the app yourself once you\u2019re ready \u2014 no need to wait for the deadline."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.billing":[{"type":1,"value":"billingUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.faq":[{"type":0,"value":"FAQs"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.migrate":[{"type":0,"value":"You have been successfully migrated from Jira Work Management to Jira, within "},{"type":1,"value":"site"},{"type":0,"value":"."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.options":[{"type":0,"value":"To view pricing, auto-renewal, and cancellation options, go to "},{"type":1,"value":"billing"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.site":[{"type":1,"value":"siteUrl"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.body.subsciption":[{"type":0,"value":"The current price of your subscription has not changed. However, pricing may vary if changes are made to your user tier, plan, and/or licensing. See "},{"type":1,"value":"faq"},{"type":0,"value":" for more details."}],"commerce.commerce-migration-jwm-to-jira.message-template.email.caption":[{"type":0,"value":"You\u2019ve been successfully migrated to Jira"}],"commerce.commerce-migration-jwm-to-jira.message-template.email.subject":[{"type":0,"value":"Your migration was successful"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.encryption-policy-info":[{"type":0,"value":"CMK policy enrollment is required for activation. "},{"type":1,"value":"supportInfo"},{"type":0,"value":" to self-enroll before provisioning Atlassian app instances. For step-by-step instructions, refer to the support "},{"type":1,"value":"CMKSupportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.manage-subscription":[{"type":0,"value":"Please click \u2018Manage Subscription\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.partner-managed-subscription":[{"type":0,"value":"Please visit your partner-managed subscriptions page"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.CMK.view-subscription":[{"type":0,"value":"Please click \u2018View all Subscriptions\u2019"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration. You can view a detailed breakdown of your team\u2019s usage in your billing account."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above your allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.cbp-details":[{"type":0,"value":"Your plan includes:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"You can visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":" to learn more about how billing works."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"We\u2019ll send the final invoice within 24 hours, which will include all the details and payment options for your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" details from your "},{"type":1,"value":"hostingDetails"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.non-cloud.billing-info":[{"type":0,"value":"Go to your billing account to set up your new subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated-with-date.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.direct.future-dated.body.intro":[{"type":0,"value":"You\'ll be able to set up and start using your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription from its start date"}]},"other":{"value":[{"type":0,"value":"subscriptions from their start dates"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.atlassian-billing-reseller":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.give-admin-permission":[{"type":0,"value":"Setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian billing partner. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received the order placed by your Atlassian reseller. The "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription is"}]},"other":{"value":[{"type":0,"value":"subscriptions are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active and ready to use."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-reseller":[{"type":0,"value":"You can view or cancel your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time by going to "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" and following the steps."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"the subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.setup-your-site":[{"type":0,"value":"Get started straight away by setting up your new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":":"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.body.site-url":[{"children":[{"type":1,"value":"siteURL"}],"type":8,"value":"a"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.ecc-reseller-managed-subscription.url":[{"type":0,"value":"your Subscription overview"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body-ecc.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.future-dated.body.intro.reseller":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian reseller, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.ecc.subject":[{"type":1,"value":"billToPartyName"},{"type":0,"value":": Atlassian product order confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\u2019s bill at the end of the bill cycle. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.auto_prov_notification":[{"type":0,"value":"The products will be added to your customer\u2019s account shortly."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.cbp-details":[{"type":0,"value":"The plan also includes the following:"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.customer_contact_info":[{"type":0,"value":"Your customer contact can view or cancel "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" at any time."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.get-started":[{"type":0,"value":"You can get started straight away by setting up the subscriptions. We\u2019ve also sent a notification to your customer with a setup link to get started. "}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"this subscription"}]},"other":{"value":[{"type":0,"value":"these subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" from our "},{"type":1,"value":"ppcHomePage"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_invoice_info":[{"type":0,"value":"We\u2019ll email the invoice with all the details within 24 hours."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.next_steps_notification":[{"type":0,"value":"We\u2019ll also send a notification to your customer with a link to set up their new "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and get started."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Remember, extra usage charges can now be accrued \u2014 any extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit and added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.body.rovo-dev-details":[{"type":0,"value":"We\u2019ll send you an invoice with all the details within 24 hours. We\u2019ll also send an email to your customer with a link to set up and get started with their new subscription. You can get started straight away by setting up the subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.button.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order, and the products will be ready to use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Thanks for choosing Atlassian. We\'ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.cta.explore":[{"type":0,"value":"Explore Teamwork Collection"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.price-decrease.title":[{"type":0,"value":"Want to pay less for your subscription?"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.price-increase.title":[{"type":0,"value":"Try new apps for free with Teamwork Collection"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.three.description":[{"type":0,"value":"without losing any work"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.two.description":[{"type":0,"value":"for daily use"}],"commerce.commerce-order-fulfilled-ccp.message-template.email.twc-offer.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscriptions from their start dates. We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.future.with.date.reminder":[{"type":0,"value":"You\'ll be able to set up and start using your subscription/s on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\'ll send you a reminder when they\'re ready."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.more-information":[{"type":0,"value":"For more information on how to manage your subscriptions and billing, visit "},{"type":1,"value":"supportUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.no-payment.expect-final-invoice":[{"type":0,"value":"Expect the final invoice within 24 hours, which will include all the necessary details and payment options for your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.payment-processing":[{"type":0,"value":"We\u2019re processing your payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.set-up-your-cloud-site":[{"type":0,"value":"Dive right in and "},{"type":1,"value":"getStartedUrl"},{"type":0,"value":" by setting up your cloud site for your new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.thanks-for-choosing-atlassian":[{"type":0,"value":"Thanks for choosing Atlassian. We\u2019ve received your order."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.button.view-subscription":[{"type":0,"value":"View all Subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your Atlassian order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-date.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received an order from your Atlassian billing partner, and the products will be ready for use from their start dates. We\u2019ll send a reminder when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-manage-subscriptions":[{"type":0,"value":"You can view the subscription from "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.intro":[{"type":0,"value":"Good news \u2013 we\u2019ve received your order for:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.next_steps":[{"type":0,"value":"Get started by setting up your customer\u2019s cloud site for the new subscription."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.ppc_homepage":[{"type":0,"value":" You can also view and manage the subscription details from our Partner Purchasing Center. "},{"type":1,"value":"viewQuoteUrl"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.processing":[{"type":0,"value":"We\u2019re processing the payment and will email the final invoice within 24 hours."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.body.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your order is confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-date.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": Order "},{"type":1,"value":"orderNumber"},{"type":0,"value":" confirmed"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated-with-date.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.future-dated.body.intro":[{"type":0,"value":"Good news \u2014 we\u2019ve received your order, and the products will be ready for use from their start dates. We\u2019ll send a reminder to your customer when they are active."}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.partner.subject":[{"type":0,"value":"We\u2019ve received your order for "},{"type":1,"value":"customerCompanyName"}],"commerce.commerce-order-fulfilled-from-quote-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message-template.email.subject":[{"type":0,"value":"This template has been deprecated"}],"commerce.commerce-order-fulfilled-from-quote-no-payment-method-ccp.message.email.body.no-translate":[{"type":0,"value":"This template has been deprecated as it has been merged along with \'commerce-quote-order-fulfilled-ccp\' template with dynamic content added to differentiate between pull/push payment method."}],"commerce.commerce-partner-cancellation-personal-data-deletion-link":[{"type":0,"value":"personal data deletion request form"}],"commerce.commerce-partner-personal-data-deletion":[{"type":0,"value":"If your customer would like to place a request for immediate deletion of personal data after cancellation, they can submit a "},{"type":1,"value":"formLink"},{"type":0,"value":". Otherwise, the data will be deleted in accordance with Atlassian\u2019s standard "},{"type":1,"value":"policyLink"},{"type":0,"value":"."}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.direct.confirm":[{"type":0,"value":"Thanks for choosing Atlassian. This email is to confirm that we\'ve received your payment for the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". The invoice is attached as a PDF for your records."}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.caption":[{"type":0,"value":"Your payment has been processed"}],"commerce.commerce-payment-confirmation-generic-email-ccp.email.partner-or-reseller.confirm":[{"type":0,"value":"This email is to confirm we have received payment for the following invoice:"}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your payment has been processed for the invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.invoice-attached":[{"type":0,"value":"The invoice is attached as a PDF for your records."}],"commerce.commerce-payment-confirmation-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Payment processed"}],"commerce.commerce-payment-method-manage-ccp.account-ending-key":[{"type":0,"value":"Account ending: "}],"commerce.commerce-payment-method-manage-ccp.account-ending-value":[{"type":1,"value":"last4"}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-key":[{"type":0,"value":"Account holder name: "}],"commerce.commerce-payment-method-manage-ccp.account-holder-name-value":[{"type":1,"value":"accountHolder"}],"commerce.commerce-payment-method-manage-ccp.authorization-date-key":[{"type":0,"value":"Authorization date: "}],"commerce.commerce-payment-method-manage-ccp.authorization-date-value":[{"type":1,"value":"authorizationDate"}],"commerce.commerce-payment-method-manage-ccp.authorization-details":[{"type":0,"value":"Authorization details"}],"commerce.commerce-payment-method-manage-ccp.bank-name-key":[{"type":0,"value":"Bank name: "}],"commerce.commerce-payment-method-manage-ccp.bank-name-value":[{"type":1,"value":"bankName"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-authorization":[{"type":0,"value":"Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.caption.direct-debit-dispute":[{"type":0,"value":"Update payment details to continue subscription"}],"commerce.commerce-payment-method-manage-ccp.caption.flex-wallet-active":[{"type":0,"value":"Your wallet is active"}],"commerce.commerce-payment-method-manage-ccp.could-not-process-payment":[{"type":0,"value":"We couldn\'t process your recent payment due to a dispute raised with your bank."}],"commerce.commerce-payment-method-manage-ccp.direct-debit-legal-terms":[{"type":0,"value":"You have authorized Atlassian to debit the bank account specified above for any amount owed for charges arising from your use of Atlassian\u2019 services and/or purchase of products from Atlassian, pursuant to Atlassian\u2019 website and terms, until this authorization is revoked. You have authorized Atlassian to debit your bank account periodically if and when you use Atlassian\u2019 services or purchase more than one of Atlassian\u2019 products periodically pursuant to Atlassian terms. Payments that fall outside the regular debits authorized above will only be debited after your authorization is obtained."}],"commerce.commerce-payment-method-manage-ccp.email.subject.ach-direct-debit-mandate":[{"type":0,"value":"Confirmation: Direct debit authorization"}],"commerce.commerce-payment-method-manage-ccp.email.subject.flex-wallet-active":[{"type":0,"value":"Your Atlassian wallet is active"}],"commerce.commerce-payment-method-manage-ccp.flex-contact-us":[{"type":0,"value":"Contact us"}],"commerce.commerce-payment-method-manage-ccp.flex-view-wallet-details":[{"type":0,"value":"View your Wallet details"}],"commerce.commerce-payment-method-manage-ccp.flex-wallet-active-intro":[{"type":0,"value":"Thanks for choosing Atlassian. Your wallet is now active, and the Atlassian subscriptions linked to your wallet will bill against it from your next billing cycle."}],"commerce.commerce-payment-method-manage-ccp.flex-wallet-no-separate-payment":[{"type":0,"value":"Charges for these subscriptions are paid from your wallet, so no separate payment is required from you."}],"commerce.commerce-payment-method-manage-ccp.flex-wallet-question":[{"type":0,"value":"Have a question about your wallet? Your Atlassian account team is here to help. "},{"type":1,"value":"contactUs"}],"commerce.commerce-payment-method-manage-ccp.how-to-cancel-direct-debit":[{"type":0,"value":"You can cancel this direct debit at any time by deleting the linked bank account from your "},{"type":1,"value":"paymentMethods"},{"type":0,"value":" page"}],"commerce.commerce-payment-method-manage-ccp.payment-methods":[{"type":0,"value":"Payment methods"}],"commerce.commerce-payment-method-manage-ccp.received-authorization":[{"type":0,"value":"We\u2019ve received your authorization for direct debit."}],"commerce.commerce-payment-method-manage-ccp.routing-number-key":[{"type":0,"value":"Routing number: "}],"commerce.commerce-payment-method-manage-ccp.routing-number-value":[{"type":1,"value":"routingNumber"}],"commerce.commerce-payment-method-manage-ccp.update-bank-details":[{"type":0,"value":"Update your bank account details, or link a different bank account. For monthly subscriptions, we don\u2019t accept bank transfers."}],"commerce.commerce-permission-request-add-payment-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: You have an add payment request"}],"commerce.commerce-permission-request-add-payment-response-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Request complete: Payment details added by billing admin "}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.cta.accept-billing-admin-request":[{"type":0,"value":"Review billing admin request"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.ba-request-text":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") is requesting billing admin permission for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.begin-quotes.no-translate":[{"type":0,"value":"\u275D "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.end-quotes.no-translate":[{"type":0,"value":" \u275E"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.personal-note.no-translate":[{"type":1,"value":"customMessage"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.subtext-for-personal-note":[{"type":0,"value":"The request was sent with the following note: "}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.title":[{"type":1,"value":"name"},{"type":0,"value":" is requesting billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.what-they-can-do":[{"type":0,"value":"If you approve, they\'ll be able to:"}],"commerce.commerce-permission-request-grant-ba-role-ccp.email.whats-next-subtext":[{"type":0,"value":"If you accept the request, we\'ll notify the requester. If you don\'t want to grant billing admin access, you can decline the request."}],"commerce.commerce-permission-request-grant-ba-role-ccp.message-template.email.subject":[{"type":0,"value":"Action needed: "},{"type":1,"value":"requesterName"},{"type":0,"value":" is requesting Billing admin access"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.cta.manageSubscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.manage-payment-method":[{"type":0,"value":"Manage payment methods and addresses"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails":[{"type":0,"value":"Receive emails about products, billing and orders"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.receive-emails-for-changes":[{"type":0,"value":"Receive emails about any changes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.request-billing-admin":[{"type":0,"value":"Request billing admins to make changes to subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage":[{"type":0,"value":"View and manage all subscriptions in your account"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-invoices":[{"type":0,"value":"View and manage invoices and quotes"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.body.feature.view-and-manage-site":[{"type":0,"value":"View, upgrade, downgrade and cancel subscriptions in your site"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-name":[{"type":1,"value":"transactionAccountName"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.account-number":[{"type":1,"value":"transactionAccountNumber"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-approved-text":[{"type":0,"value":"Great news - your billing admin request has been approved for the following account: "}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.ba-declined-text":[{"type":0,"value":"Your request to become a billing admin on the following account has been declined."}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-approved":[{"type":0,"value":"You\'re now a billing admin"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.title-declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.total-entitlements":[{"type":1,"value":"totalEntitlements"},{"type":0,"value":" subscriptions"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get":[{"type":0,"value":"You\'ll now be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.email.what-you-get-without-access":[{"type":0,"value":"You\'ll still be able to:"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.approved":[{"type":0,"value":"Your billing admin request has been approved"}],"commerce.commerce-permission-request-grant-ba-role-response-ccp.message-template.email.subject.declined":[{"type":0,"value":"Your billing admin request has been declined"}],"commerce.commerce-pre-comms-sp-add-on-merge-ccp.message-template.email.subject.no-translate":[{"type":0,"value":"Important information about your Statuspage add-ons"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.body-text":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" Standard "},{"children":[{"type":0,"value":"trial has ended."}],"type":8,"value":"strong"},{"type":0,"value":" You\'re currently over the 10-user limit for our Free plan. Add payment details now to keep your team active - otherwise, your team will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.body-text-within-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" Standard "},{"children":[{"type":0,"value":"trial has ended."}],"type":8,"value":"strong"},{"type":0,"value":" Add payment details now to keep your team on Standard - otherwise, your team will lose access to some "},{"type":1,"value":"productName"},{"type":0,"value":" features and be downgraded to the Free plan."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.heading":[{"type":0,"value":"Last chance to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" site and data"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.not-ready-heading":[{"type":0,"value":"Not ready to upgrade?"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.subject":[{"type":0,"value":"Last chance to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-admin":[{"type":0,"value":"You can switch back to a Free plan by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"link"},{"type":0,"value":" to 10 or fewer."}],"commerce.commerce-pre-dunning-ccp.mpucup.email.switch-back-to-free-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan by reducing your user count to 10 or fewer."}],"commerce.commerce-pre-dunning-ccp.v2.email.contact-us":[{"type":0,"value":"Please "},{"type":1,"value":"contactUs"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"commerce.commerce-pre-dunning-ccp.v2.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-pre-dunning-ccp.v2.email.total-bill":[{"type":0,"value":"Your total estimated bill is "},{"type":1,"value":"amount"},{"type":0,"value":" (excludes tax)"}],"commerce.commerce-quote-expired-ccp.email.caption":[{"type":0,"value":"Your quote has expired"}],"commerce.commerce-quote-expired-ccp.email.contact-us":[{"type":0,"value":"Contact us"}],"commerce.commerce-quote-expired-ccp.email.ready-to-order":[{"type":0,"value":"If you\u2019d like to try Atlassian products, opt for a free trial."}],"commerce.commerce-quote-expired-ccp.email.reminder-before-expiry":[{"type":0,"value":"Your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired. You\u2019ll no longer be able to pay for it."}],"commerce.commerce-quote-expired-ccp.email.view-quote":[{"type":0,"value":"You can always create a new quote by reaching out to us."}],"commerce.commerce-quote-expired-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" has expired"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"It\u2019s time to renew your subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.direct-customer.request-quote-to-avoid-losing-access":[{"type":0,"value":"To avoid losing access to your products, request a quote that is valid until the end of your billing cycle. When you are ready to pay, simply review the quote and place your order. "}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.list-subscriptions":[{"type":0,"value":"Subscriptions list:"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.caption":[{"type":0,"value":"It\u2019s time to renew"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.reach-out-to-create-quote":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.request-quote-to-avoid-customer-losing-access":[{"type":0,"value":"To avoid losing access to the products, request a quote valid until the end of your billing cycle. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Request quote to renew subscription"}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring":[{"type":0,"value":"Just a heads up that you have subscriptions that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-renewal-ccp.message-template.email.subscriptions-are-expiring-for-customer-company":[{"type":0,"value":"Just a heads up that you have subscriptions for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" that are approaching their end date, so it\u2019s time to renew."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp-g.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.body.request-a-quote-message":[{"type":0,"value":"You\u2019re on a free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") that ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to your product after the trial ends, request a quote valid until the trial expiry date. When you are ready to pay simply review the quote and place your order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Create a quote for your trial"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Request quote for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.body.request-a-quote-message":[{"type":0,"value":"The free trial trial of Confluence Premium ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription for "},{"type":1,"value":"customerCompanyName"},{"type":0,"value":" ends on "},{"type":1,"value":"quoteEndDate"},{"type":0,"value":". To avoid losing access to the product after the trial ends, request a quote that\u2019s valid until the trial expiry date. When your customer is ready to pay, they can simply review the quote and place an order."}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.caption":[{"type":0,"value":"Create a quote for subscription trial "}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : Request a quote"}],"commerce.commerce-quote-not-auto-created-trial-ccp.message-template.email.partners.body.reach-us":[{"type":0,"value":"Reach out to us to create a quote."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote billing period"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote billing period change"}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.updated-quote-body":[{"type":0,"value":"We\'ve updated the quote billing period for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-billing-period-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.estimates-changed":[{"type":0,"value":"Changing the billing period has changed how we calculate the quote total, which means that the quote total has now been updated."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote billing period and total change"}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.updated-quote-body":[{"type":0,"value":"We\'ve updated the quote billing period and quote total for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because there was a change to the subscription plan, user tier or billing cycle since the quote was created, which changed the start date for one or more items on the quote."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-bp-and-estimates-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.caption":[{"type":0,"value":"We\'ve updated your quote total"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.ppc-homepage":[{"type":0,"value":"You can also view the quote from our "},{"children":[{"type":0,"value":"Partner Purchasing Center."}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" quote total change"}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.updated-quote":[{"type":0,"value":"We\'ve updated the quote total for "},{"type":1,"value":"quoteNumber"},{"type":0,"value":". This is because the billing address or sold-to address or subscription\'s user count linked to the quote was updated since the quote was created, which changes how we estimate the quote total."}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.valid-until":[{"type":0,"value":"The quote is valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the updated details, select \'View quote\' and download the PDF."}],"commerce.commerce-quote-open-auto-fix-estimate-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"commerce.commerce-quote-open-auto-fix-estimate.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"commerce.commerce-quote-open-auto-fix-estimate.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.caption":[{"type":0,"value":"It\u2019s time to renew "}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.get-in-touch":[{"type":0,"value":"Get in touch with your Atlassian Billing Partner to get started on your renewal. They\u2019ll be able to help you with your quote and any next steps."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.let-you-know":[{"type":0,"value":"We hope you\u2019ve been enjoying your Atlassian products. We wanted to let you know that your subscription/s expire soon, so it\u2019s time to renew."}],"commerce.commerce-quote-open-auto-renewal-ccp.ecc.partner.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-quote-open-auto-renewal-ccp.message-template.email.ecc.subject":[{"type":0,"value":"Contact your Atlassian Billing Partner to renew "}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.auto-renewal.button":[{"type":0,"value":"Switch to auto-renew \u2192"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.auto-renewal.description":[{"type":0,"value":"Skip manual renewals and avoid cancellation at the end of your billing cycle. Switch to annual auto-renewal to keep your service active automatically."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.auto-renewal.title":[{"type":0,"value":"Want to avoid manual renewals?"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.caption":[{"type":0,"value":"Renew your subscription"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.caption":[{"type":0,"value":"It\'s time to renew your subscription"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order":[{"type":0,"value":"When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. You can also head to our Partner Purchasing Center to create an order. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"learnMoreLink"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.create-order-title":[{"type":0,"value":"To create an order"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.intro":[{"type":0,"value":"Hi, "},{"children":[],"type":8,"value":"br"},{"type":0,"value":"Just a heads up that the subscription for "},{"type":1,"value":"companyName"},{"type":0,"value":" expires soon and is ready to be renewed. To review the subscription details and the cost, we\'ve created a quote that\'s valid until the end of your customer\'s billing cycle."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.partner.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.quote-created":[{"type":0,"value":"This is a friendly reminder that you have subscriptions up for renewal on "},{"children":[{"type":1,"value":"renewalDate"}],"type":8,"value":"b"},{"type":0,"value":". To review your subscription details and assess the cost, we\'ve created a quote("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") that\'s valid until the end of your current billing cycle. To view the details, download the attached quote PDF."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.ready-to-pay":[{"children":[{"type":0,"value":"Ready to pay?"}],"type":8,"value":"b"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.reseller.create-order":[{"type":0,"value":"When your customer is ready to convert the quote to an order, proceed to pay and confirm the order. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"learnMoreLink"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-details":[{"type":0,"value":"When you\'re ready to renew your subscription, access the quote from the "},{"children":[{"type":0,"value":"Quotes"}],"type":8,"value":"b"},{"type":0,"value":" page of your "},{"children":[{"type":0,"value":"billing account"}],"type":8,"value":"billingLink"},{"type":0,"value":" and place an order."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-answer":[{"type":0,"value":"Your subscription will be canceled, unless you renew for the next billing cycle."}],"commerce.commerce-quote-open-auto-renewal-email-ccp.email.what-happens-question":[{"children":[{"type":0,"value":"What happens after my current billing cycle ends?"}],"type":8,"value":"b"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.direct":[{"type":0,"value":"Renew now: your subscription expires soon"}],"commerce.commerce-quote-open-auto-renewal-email-ccp.message-template.email.subject.partner":[{"type":0,"value":"Quote created for "},{"type":1,"value":"companyName"},{"type":0,"value":" ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":")"}],"commerce.commerce-quote-open-auto-trial-ccp.email.caption":[{"type":0,"value":"Your quote is ready"}],"commerce.commerce-quote-open-auto-trial-ccp.email.place-order":[{"type":0,"value":"Ready to start your paid subscription? Simply review the quote and place your order."}],"commerce.commerce-quote-open-auto-trial-ccp.email.quote-created":[{"type":0,"value":"We\'ve created a quote for your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" trial ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"), to help you assess if it\'s the right plan for you. The quote is valid until your trial ends on "},{"children":[{"type":1,"value":"trialExpiry"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-quote-open-auto-trial-ccp.email.reminder":[{"type":0,"value":"Just a reminder \u2013 be sure to order before your trial ends to avoid losing access to your product."}],"commerce.commerce-quote-open-auto-trial-ccp.email.view-details":[{"type":0,"value":"To view the details, download the attached quote PDF or go to the "},{"children":[{"type":0,"value":"Quotes"}],"type":8,"value":"b"},{"type":0,"value":" page of your "},{"children":[{"type":0,"value":"billing account"}],"type":8,"value":"billingLink"},{"type":0,"value":"."}],"commerce.commerce-quote-open-auto-trial-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-auto-trial-ccp.message-template.email.subject":[{"type":0,"value":"Quote created: "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" trial ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":")"}],"commerce.commerce-quote-open-ccp.email.contract-type-non-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, contact your customer advocate."}],"commerce.commerce-quote-open-ccp.email.contract-type-standard":[{"type":0,"value":"When you\'re ready to convert the quote to an order, go to the quote in your billing account and proceed to create an order."}],"commerce.commerce-quote-open-ccp.email.direct-customer":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":0,"value":"admin.atlassian.com/billing"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open":[{"type":0,"value":"Your quote ("},{"type":1,"value":"quoteNumber"},{"type":0,"value":") is ready and will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details of the quote, download the attached PDF or go to your site\'s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":1,"value":"billingUrlText"}],"type":8,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-quote-open-ccp.email.direct-customer-quote-open-reminder":[{"type":0,"value":"Keep in mind, if you have product trials in the quote, we recommend placing your order before the trial ends. If you need more time, "},{"children":[{"type":0,"value":"reach out to us"}],"type":8,"value":"RawLink"},{"type":0,"value":" to extend your quote validity."}],"commerce.commerce-quote-open-ccp.email.manage-subscription":[{"type":0,"value":"You can view subscription and billing details on your "},{"children":[{"type":0,"value":"Manage Subscriptions"}],"type":8,"value":"RawLink"},{"type":0,"value":" page."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-caption":[{"type":0,"value":"Here\u2019s the quote you requested"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open":[{"type":0,"value":"Good news \u2013 the quote you requested is now ready:"}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-quote-open-details":[{"type":0,"value":"The quote will be valid until "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". To view the details, select \u2018View quote\u2019 and download the PDF."}],"commerce.commerce-quote-open-ccp.email.partner-or-reseller-view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.email.partner-ppc-homepage":[{"type":0,"value":"You can also view quotes and manage these subscriptions from our Partner Purchasing Center. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"RawLink"}],"commerce.commerce-quote-open-ccp.email.view-quote-button":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.direct":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is here!"}],"commerce.commerce-quote-open-ccp.message-template.email.subject.partner-or-reseller":[{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" is ready"}],"commerce.commerce-quote-reminder-expiry-ccp.email.administration":[{"type":0,"value":"Administration"}],"commerce.commerce-quote-reminder-expiry-ccp.email.caption":[{"type":0,"value":"Your quote will expire soon"}],"commerce.commerce-quote-reminder-expiry-ccp.email.order-in-bac":[{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":" and create an order."}],"commerce.commerce-quote-reminder-expiry-ccp.email.ready-to-order":[{"type":0,"value":"When you\u2019re ready to convert your quote to an order, go to your site\'s "}],"commerce.commerce-quote-reminder-expiry-ccp.email.reminder-before-expiry":[{"type":0,"value":"This is a friendly reminder that your quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire on "},{"type":1,"value":"quoteExpiry"},{"type":0,"value":". Once expired, the quote will be canceled and you have to create a new one."}],"commerce.commerce-quote-reminder-expiry-ccp.email.view-quote":[{"type":0,"value":"View quote"}],"commerce.commerce-quote-reminder-expiry-ccp.message-template.email.subject":[{"type":0,"value":"Your Atlassian quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" will expire soon"}],"commerce.commerce-quote-stale-ccp.email.body":[{"type":0,"value":"Just a heads up that your quote for "},{"type":1,"value":"companyName"},{"type":0,"value":" needs to be updated before it can be moved back to OPEN."}],"commerce.commerce-quote-stale-ccp.email.caption":[{"type":0,"value":"Your quote needs to be reviewed"}],"commerce.commerce-quote-stale-ccp.email.update-line-item":[{"type":0,"value":"Head to the effected line item/s on the quote and follow the prompts from the error to update it. If that doesn\'t work, you\'ll need to raise a GSAC ticket so that an Atlassian Customer Advocate can look into it."}],"commerce.commerce-quote-stale-ccp.message-template.email.subject":[{"type":0,"value":"Action required: "},{"type":1,"value":"companyName"},{"type":0,"value":" quote "},{"type":1,"value":"quoteNumber"},{"type":0,"value":" needs review"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.caption":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been successfully reactivated"}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.we-will-charge":[{"type":0,"value":"We\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-reactivation-order-to-paid-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entNumber"},{"type":0,"value":")"}],"commerce.commerce-reactivation-order-to-paid-ccp.personal-information":[{"type":0,"value":"Since you reactivated your subscription within 60 days of cancellation, your data and preferences\\n                    are as you left them. You can jump right in and get started!"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.cannot-be-refunded":[{"type":0,"value":"Please note that this balance can\'t be refunded or exchanged for cash."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.caption":[{"type":0,"value":"Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.completed":[{"type":0,"value":"We have successfully processed your request for SLA Compensation. You are entitled to receive Service Credits, as per our service level commitment. These credits will be added to your account balance and will be used in future invoices."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.subject":[{"type":0,"value":"Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.direct.terms":[{"type":0,"value":"Service Credits are applied to your account governed by the terms in "},{"type":1,"value":"slaLink"},{"type":0,"value":". To read more about Service Credits, click "},{"type":1,"value":"hereLink"},{"type":0,"value":"."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.here-link-text":[{"type":0,"value":"here"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.completed":[{"type":0,"value":"We\'ve successfully processed a request for SLA Compensation. You\'re entitled to receive Service Credits, as per our service level commitment. These credits will be added to your account balance and used in future invoices."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":": Your Service Credits adjustment has been processed"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.partner-or-reseller.terms":[{"type":0,"value":"Service Credits are applied to your account governed by the terms in "},{"type":1,"value":"slaLink"},{"type":0,"value":". Read more about "},{"type":1,"value":"serviceCreditsLink"},{"type":0,"value":"."}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.service-credits-link-text":[{"type":0,"value":"Service Credits"}],"commerce.commerce-refund-credit-grant-ccp.message-template.email.sla-link-text":[{"type":0,"value":"Atlassian Service Level Agreement"}],"commerce.commerce-refund-generic-email-ccp.email.direct.caption":[{"type":0,"value":"Your refund has been processed"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.caption":[{"type":0,"value":"Your refund has been processed"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.completed":[{"type":0,"value":"We have completed the refund related to the following invoice:"}],"commerce.commerce-refund-generic-email-ccp.email.partner-or-reseller.refund-amount":[{"type":0,"value":"The refund has been credited to the payment method used in the original purchase. Please allow 2-3 business days for the refunded amount to appear on your bank statement. Please note that any subscription changes based on your refund request will reflect on your account shortly."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.cash-refund":[{"type":0,"value":"If you would like to receive a cash refund instead, please reach out to "},{"children":[{"type":0,"value":"accountsreceivable@atlassian.com"}],"type":8,"value":"a"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.completed":[{"type":0,"value":"We have completed the refund related to the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.credit-issued":[{"type":0,"value":"The credits issued on this credit note will be applied to any outstanding unpaid invoices you may have."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.direct.subject":[{"type":0,"value":"Refund processed for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce-refund-generic-email-ccp.message-template.email.more-info":[{"type":0,"value":"For more information about invoices and subscriptions, go to your sites "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.partner-or-reseller.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":": Refund processed"}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-amount":[{"type":0,"value":"The refunded amount should appear on your bank statement in 2-3 business days. Any subscription changes based on your refund request will reflect on your account soon."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-cc":[{"type":0,"value":"A refund from the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been credited to your card "},{"children":[{"type":1,"value":"cardBrand"},{"type":0,"value":" ending in "},{"type":1,"value":"maskedNumber"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.refund-credited-to-paypal":[{"type":0,"value":"A refund from the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" has been credited to your "},{"children":[{"type":0,"value":"PayPal account, "},{"type":1,"value":"paypalEmail"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-refund-generic-email-ccp.message-template.email.terms-completed":[{"type":0,"value":"We have completed the refund related to the invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":" and generated a credit note "},{"type":1,"value":"creditNoteNumber"},{"type":0,"value":" against it."}],"commerce.commerce-refund-internal-ccp.message-template.email.adc-refund.body":[{"type":0,"value":"Advocate Central REFUND LINK - "},{"type":1,"value":"advocateCentralUrl"},{"type":0,"value":"/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-bank-transfer.subject":[{"type":0,"value":"Bank Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund-onAccount.subject":[{"type":0,"value":"Expert Account Refund Request - Refund #"},{"type":1,"value":"refundId"}],"commerce.commerce-refund-internal-ccp.message-template.email.refund.body":[{"type":0,"value":"CASSI REFUND LINK - "},{"type":1,"value":"cassiUrl"},{"type":0,"value":"/ui/refunds/"},{"type":1,"value":"refundId"},{"type":0,"value":"."}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.body.click":[{"type":0,"value":"Click the button below to access Workbench and review (or reassign) the initiative."}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.body.reminder":[{"type":0,"value":"Just a reminder that you were assigned as the owner and reviewer of a new initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") by "},{"type":1,"value":"authorName"},{"type":0,"value":" from the "},{"type":1,"value":"authorTeam"},{"type":0,"value":" team."}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"Review initiative"}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.subject.no-translate":[{"type":0,"value":"Reminder: Please review your assigned initiative"}],"commerce.commerce-review-reminder-owner-notification-email.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-review-reminder-reviewer-notification-email.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-review-reminder-reviewer-notification-email.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-review-reminder-reviewer-notification-email.message-template.email.message-template.email.body.reminder":[{"type":0,"value":"Just a reminder that "},{"type":1,"value":"ownerName"},{"type":0,"value":" submitted an initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") for your approval. Please click the button below to view and approve the initiative in Workbench."}],"commerce.commerce-review-reminder-reviewer-notification-email.message-template.email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.commerce-review-reminder-reviewer-notification-email.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"Review initiative"}],"commerce.commerce-review-reminder-reviewer-notification-email.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-review-reminder-reviewer-notification-email.message-template.email.message-template.email.subject.no-translate":[{"type":0,"value":"Reminder: An initiative is awaiting your approval"}],"commerce.commerce-review-reminder-reviewer-notification-email.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-review-start-final-reviewer-notification-email.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-review-start-final-reviewer-notification-email.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-review-start-final-reviewer-notification-email.message-template.email.message-template.email.body.reminder":[{"type":0,"value":"An initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") has been submitted for your approval. Please click the button below to view and approve the initiative in Workbench."}],"commerce.commerce-review-start-final-reviewer-notification-email.message-template.email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.commerce-review-start-final-reviewer-notification-email.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"Review initiative"}],"commerce.commerce-review-start-final-reviewer-notification-email.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-review-start-final-reviewer-notification-email.message-template.email.message-template.email.subject.no-translate":[{"type":0,"value":"An initiative is ready for your approval"}],"commerce.commerce-review-start-final-reviewer-notification-email.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-review-start-notified-user-notification-email.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi,"}],"commerce.commerce-review-start-notified-user-notification-email.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-review-start-notified-user-notification-email.message-template.email.message-template.email.body.reminder":[{"type":0,"value":"A new initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") has been created by "},{"type":1,"value":"authorName"},{"type":0,"value":". You can view the initiative in Workbench, or by clicking the button below."}],"commerce.commerce-review-start-notified-user-notification-email.message-template.email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.commerce-review-start-notified-user-notification-email.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"View initiative"}],"commerce.commerce-review-start-notified-user-notification-email.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-review-start-notified-user-notification-email.message-template.email.message-template.email.subject.no-translate":[{"type":0,"value":"Reminder: An initiative is awaiting your approval"}],"commerce.commerce-review-start-notified-user-notification-email.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.body.click":[{"type":0,"value":"Click the button below to access Workbench and review (or reassign) the initiative."}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.body.reminder":[{"type":0,"value":"You\u2019ve been assigned as the owner and reviewer of a new initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") by "},{"type":1,"value":"authorName"},{"type":0,"value":" from the "},{"type":1,"value":"authorTeam"},{"type":0,"value":" team."}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"Review initiative"}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.subject.no-translate":[{"type":0,"value":"New pricing change initiative for your review"}],"commerce.commerce-review-start-owner-notification-email.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-review-start-reviewer-notification-email.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-review-start-reviewer-notification-email.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-review-start-reviewer-notification-email.message-template.email.message-template.email.body.reminder":[{"type":0,"value":"An initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") has been submitted for your approval. Please click the button below to view and approve the initiative in Workbench."}],"commerce.commerce-review-start-reviewer-notification-email.message-template.email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.commerce-review-start-reviewer-notification-email.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"Review initiative"}],"commerce.commerce-review-start-reviewer-notification-email.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-review-start-reviewer-notification-email.message-template.email.message-template.email.subject.no-translate":[{"type":0,"value":"An initiative is ready for your approval"}],"commerce.commerce-review-start-reviewer-notification-email.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.message-template.email.body.click":[{"type":0,"value":"Click the button below to view the status of the initiative in Workbench."}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.message-template.email.body.reminder":[{"type":1,"value":"reviewerName"},{"type":0,"value":" has approved the initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":"). A request has now been sent to the next approver, "},{"type":1,"value":"finalReviewerName"},{"type":0,"value":"."}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"View initiative"}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-reviewer-approve-initiative-owner-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Initiative approval update:  "},{"type":1,"value":"totalApprovalReceived"},{"type":0,"value":" of "},{"type":1,"value":"totalApprovalRequired"},{"type":0,"value":" received"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption":[{"type":0,"value":"Users in your site have used up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-caption-announcement.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.breached-rde-caption":[{"type":0,"value":"Upgrade to Rovo Dev Standard to get more Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Users in your site are using up their Rovo Dev credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.milestone-caption-allowance-announencement.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"Rovo Dev credit allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.breached.pooled-meter":[{"type":1,"value":"productName"},{"type":0,"value":" allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":1,"value":"productName"},{"type":0,"value":" credit allowance running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.dc.email.subject.milestone.pooled-meter":[{"type":1,"value":"productName"},{"type":0,"value":" allowance is running low"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.need-to-know-list-user-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-monitor":[{"type":0,"value":"You can monitor usage in your billing account to see which users have used their allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-ugrade-to-standard":[{"type":0,"value":"To increase Rovo Dev credits and allow extra usage, organization admins can upgrade to Rovo Dev Standard."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.rde.need-to-know-list-user-cannot-use-extra":[{"type":0,"value":"Users who are at their credit limit won\'t be able to use any Rovo Dev features until the next billing cycle."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-admin-can-limit-usage":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done anytime in Atlassian Administration to keep costs predictable. "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trials.need-to-know-list-extra-usage-charges":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.breached.trialsneed-to-know-list-function-disabled":[{"type":0,"value":"Rovo Dev functionality is disabled for users who reach their allowance, and usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to your next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-monitor-usage":[{"type":0,"value":"It\'s a good idea to monitor usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-extra-charges-in-invoice":[{"type":0,"value":"If you want to allow extra usage before the trial ends, you can end the trial early and start the paid plan. If you do this, usage will reset and any usage over the allocated amount will be charged at USD 0.01 per extra Rovo Dev credit and added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage for when the paid plan starts \u2014 this can be done at any time in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.trials.need-to-know-list-will-be-disabled":[{"type":0,"value":"Once users use up their Rovo Dev credits, Rovo Dev functionality will be disabled until usage resets when the paid plan starts."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.body.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.billing-faq-url":[{"type":0,"value":"When and how will I be billed?"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-billable-usage-notice":[{"type":0,"value":"Any usage beyond your allowance is considered billable usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your billable usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-details.ubp5":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message":[{"type":0,"value":"At least one of your users has used up their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-info-message-announcement.ubp5":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-rde-info-message":[{"type":0,"value":"At least one of your users has used up their free Rovo Dev credit allowance in Jira."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-update-limits.ubp5":[{"type":0,"value":"Your org admin can update your usage limits anytime."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached-what-next.ubp5":[{"type":0,"value":"If your org admin has enabled extra usage, you\u2019ll incur extra usage charges up to your extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until your usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.breached.monitoring-message":[{"type":0,"value":"Monitor what your team\'s using by viewing a detailed breakdown of their usage in your billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-billable-usage-notice":[{"type":0,"value":"Once your organization exceeds your allowance, you\u2019ll start to incur billable usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your billable usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"At least one of your users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their Rovo Dev credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement":[{"type":0,"value":"Your organization has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of its "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-announcement.ubp5":[{"type":0,"value":"Your org has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-info-message-allowance-org-details.ubp5":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.milestone-what-next.ubp5":[{"type":0,"value":"If your org reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until your usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.dc.usage-details-announcement":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.billing-faq-url":[{"type":0,"value":"When and how will they be billed?"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-extra-usage-charges":[{"type":0,"value":"Extra usage will extra usage will be charged at USD 0.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.breached.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-monitor-usage":[{"type":0,"value":"It\u2019s a good idea to encourage your customer to monitor their usage in their billing account."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.body.milestone.need-to-know-list-org-admin-can-limit":[{"type":0,"value":"Organization admins can adjust the extra usage limit or disable extra usage anytime in Atlassian Administration to keep costs predictable."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-billable-usage-notice":[{"type":0,"value":"Any usage beyond your customer\u2019s allowance is considered billable usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your billable usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-details.ubp5":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-info-message-pooled-meter.ubp5":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-update-limits.ubp5":[{"type":0,"value":"You can update your customer\u2019s usage limits anytime."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.breached-what-next.ubp5":[{"type":0,"value":"If you\'ve enabled extra usage for your customer, they\u2019ll incur extra usage charges up to the extra usage limit. If extra usage is disabled, some features will be restricted or unavailable until their usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-billable-usage-notice":[{"type":0,"value":"Once your customer\u2019s organization exceeds their allowance, they\u2019ll start to incur billable usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for your billable usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-details.ubp5":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"At least one of your customer\'s users has used up "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"productName"},{"type":0,"value":" credit allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their organization\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-pooled-meter.ubp5":[{"type":0,"value":"Your customer has used "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-info-message-vist-ppc-pooled-meter":[{"type":0,"value":"Visit PPC to get more details on your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.partner.milestone-what-next.ubp5":[{"type":0,"value":"If your customer reaches 100% of their allowance, extra usage charges will be incurred if extra usage is enabled. Otherwise, some features will be restricted or unavailable until their usage resets."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.email.whats-next.ubp5":[{"type":0,"value":"What\u2019s next?"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.breached.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Unless an organization admin has adjusted the extra usage limit or disabled extra usage, users will be able to use up to 2,000 extra Rovo Dev credits for an extra charge on top of the 2,000 credits included in the subscription."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.body.milestone.need-to-know-list-users-can-use-extra":[{"type":0,"value":"Once users exceed their allowance of Rovo Dev credits, extra usage will be charged at USD\xa00.01 per extra Rovo Dev credit \u2014 any extra charges will be added to the next invoice."}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption":[{"type":0,"value":"Users in your customer\'s site have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.breached-caption-pooled-meter.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Users in your customer\'s site are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.milestone-caption-pooled-meter.ubp5":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your customer\u2019s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" allowance has been used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.pooled-meter":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" allowance used"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users have used up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.pooled-meter":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" allowance is running low "}],"commerce.commerce-rovo-dev-usage-limit-breach-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Users are using up their "},{"type":1,"value":"productName"},{"type":0,"value":" credits"}],"commerce.commerce-ship-to-party-archival-ccp.body.initimation":[{"type":0,"value":"Please note that this sold-to address is no longer available for billing."}],"commerce.commerce-ship-to-party-archival-ccp.body.partner.p3":[{"type":0,"value":"To view the changes, head to "},{"type":1,"value":"ppcHomePageLink"},{"type":0,"value":"."}],"commerce.commerce-ship-to-party-archival-ccp.email.body.disclaimer":[{"type":0,"value":"We\'ve deactivated the below sold-to address:"}],"commerce.commerce-ship-to-party-archival-ccp.message-template.email.subject":[{"type":1,"value":"name"},{"type":0,"value":" Sold to address deactivated"}],"commerce.commerce-soft-limit-breach-ccp.email.automatic-upgrade":[{"type":0,"value":"Automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.email.manage-users":[{"type":0,"value":"Manage "},{"type":1,"value":"product"}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade":[{"type":0,"value":"Don\'t want to upgrade? "}],"commerce.commerce-soft-limit-breach-ccp.email.no-upgrade-text":[{"type":0,"value":"We recommend removing "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users before your upgrade date. You can do this by selecting Manage users in your "},{"type":1,"value":"product"},{"type":0,"value":" subscription"}],"commerce.commerce-soft-limit-breach-ccp.email.note1":[{"type":0,"value":"If no changes are made, you\'ll be upgraded and we\'ll send you an invoice of prorated costs for the remainder of your billing period."}],"commerce.commerce-soft-limit-breach-ccp.email.note2":[{"type":0,"value":"You don\'t need to take any action. We\'ll automatically upgrade your account and the new charges will be applied."}],"commerce.commerce-soft-limit-breach-ccp.email.product-limit-exceeded":[{"type":0,"value":"Your "},{"type":1,"value":"product"},{"type":0,"value":" user limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" has exceeded by "},{"type":1,"value":"exceededLimit"},{"type":0,"value":" users."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder":[{"type":0,"value":"In a few days you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.final-reminder-caption":[{"type":0,"value":"You\u2019re about to be upgraded"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder":[{"type":0,"value":"Soon you\'ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count."}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.first-reminder-caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder":[{"type":0,"value":"In the next week, you\u2019ll be automatically upgraded to a new limit of "},{"type":1,"value":"lowerLimit"},{"type":0,"value":"-"},{"type":1,"value":"upperLimit"},{"type":0,"value":" to accommodate your growing user count. "}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.second-reminder-caption":[{"type":0,"value":"You\u2019ll be upgraded soon"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.final-reminder":[{"type":0,"value":"Last chance: manage users before automatic upgrade"}],"commerce.commerce-soft-limit-breach-ccp.message-template.email.subject.reminder":[{"type":0,"value":"Action required before automatic upgrade"}],"commerce.commerce-subscription-activation-ccp.message-template.ecc.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.admin-permission-url":[{"type":0,"value":"how to give users admin permissions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian reseller: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to "},{"type":1,"value":"partnerManagedSubscriptionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.setup-site":[{"type":0,"value":"Setting up the site means you\u2019ll automatically get admin permissions as an org and site admin. You can also give admin roles to others - see "},{"type":1,"value":"giveUserAdminPermissionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.body.site-heading":[{"type":0,"value":"Site: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.with-site":[{"type":0,"value":"Your products are ready for use "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.caption.without-site":[{"type":0,"value":"Set up your subscription and get started"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.partner-managed-subscription.url":[{"type":0,"value":"your partner-managed subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.body.atlassian-billing-partner":[{"type":0,"value":"Atlassian billing partner: "}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.reseller.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian partner had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.site-info":[{"type":0,"value":"They\'ll be added to your site shortly."}],"commerce.commerce-subscription-activation-ccp.message-template.email.ecc.subscriptions-active":[{"type":0,"value":"Great news! Your Atlassian reseller had placed an order for Atlassian products on "},{"type":1,"value":"orderDate"},{"type":0,"value":". The subscriptions are now active and ready to use."},{"type":1,"value":"contentForSite"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"You can manage these subscriptions from our "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-activation-ccp.message-template.email.partner.subscriptions-active":[{"type":0,"value":"Great news \u2014 the subscriptions that you ordered for your customer on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are now active and ready to use. We\u2019ve also informed your customer that they can get started."}],"commerce.commerce-subscription-activation-ccp.message-template.email.remaining-subs":[{"type":0,"value":"+ "},{"type":1,"value":"remainingCount"},{"type":0,"value":" more subscriptions."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view or cancel your subscriptions at any time by going to your "},{"type":1,"value":"managedSubscriptionUrl"},{"type":0,"value":" page and following the steps."}],"commerce.commerce-subscription-activation-ccp.message-template.email.reseller.partner-managed-subscription.url":[{"type":0,"value":"Subscription overview"}],"commerce.commerce-subscription-activation-ccp.message-template.email.set-up-subscriptions":[{"type":0,"value":"Get started by setting up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":"."}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.ecc":[{"type":0,"value":"It\u2019s time to set up your subscription"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.partner":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": it\u2019s time to set up subscriptions"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subject.singular":[{"type":0,"value":"It\'s time to set up your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"}],"commerce.commerce-subscription-activation-ccp.message-template.email.subscriptions-active":[{"type":0,"value":"Great news \u2014 the "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" is"}]},"other":{"value":[{"type":0,"value":"subscriptions that you ordered on "},{"type":1,"value":"orderDate"},{"type":0,"value":" are"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" now active."}],"commerce.commerce-subscription-activation-ccp.message-template.email.time-to-get-set-up":[{"type":0,"value":"It\'s time to get set up"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp-g.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.dc.p3":[{"type":0,"value":"You can manage the subscription from your Subscription details page."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.body.partner.p3":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"ppcSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.add-on.cta":[{"type":0,"value":"Increase usage limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.dc.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.add-on.cta":[{"type":0,"value":"Get quote for higher limit"}],"commerce.commerce-subscription-add-on-usage-reminder-ccp.message-template.email.partner.cta":[{"type":0,"value":"Get add-on"}],"commerce.commerce-subscription-auto-downgrade-ccp.email.partner.subject.with.company.name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":":"},{"type":1,"value":"productName"},{"type":0,"value":" now on Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.limted.features.info":[{"type":0,"value":"This way, your customer can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uncollectible":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.body.summary.partner-uninvoiceable":[{"type":0,"value":"We\u2019ve moved the below subscription to the Free plan. This is because we don\u2019t have your customer\u2019s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.body.request-deletion-of-personal-data-link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.caption-v3":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.direct-customer.summary":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.go-back-original-plan":[{"type":0,"value":"Want to go back on the original plan?"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.review-and-manage-subscription":[{"type":0,"value":"Review the customer\u2019s billing details from our Partner Purchasing Center and change the subscription."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.subscription-downgraded-message":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for this subscription. As a result, we\'ve moved the subscription to the Free plan. This way, "},{"type":1,"value":"productName"},{"type":0,"value":" can still be used, but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.body.you-may-request-deletion-of-personal-data":[{"type":0,"value":"Your customer can also place a "},{"type":1,"value":"requestForDeletionOfPersonalDataLink"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" moved to Free plan due to payment issue"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users, AI credits, and more storage for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.confluence-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users, advanced permissions, and 250GB of storage."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.jira-premium":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users and storage, AI credits, and advanced admin controls."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.jira-product-discovery-premium.ai-non-final":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to advanced roadmaps, field-level security, or admin insights."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.jira-product-discovery-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to increased user limits, permissions, and published views for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.jira-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users, roles and permissions, and 1,700 monthly automations."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.loom-business":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has been downgraded to the Starter plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to increased user limits, recording insights, and unlimited videos for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.loom-business-ai":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has been downgraded to the Starter plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited recording, custom branding, or AI-powered features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.premium":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users, AI credits, and unlimited storage for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.service-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to increased user limits, 250GB of storage, and Assets for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.teamwork-premium":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to unlimited users and storage, AI credits, and Atlassian Guard."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.body.teamwork-standard":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the Free plan. Restore your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan to keep access to increased user limits, AI credits, and videos without limits for your team."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.current-plan-label":[{"type":0,"value":"Current plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.current-plan-name":[{"type":1,"value":"productName"},{"type":0,"value":" Free"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.current-plan-name.loom":[{"type":1,"value":"productName"},{"type":0,"value":" Starter"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.greeting":[{"type":0,"value":"Hello "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.heading":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.restore-access.ai-non-final":[{"type":0,"value":"Restore access"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" Free"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.trial-has-ended-offer-to-buy.subject.loom":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" Starter"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.caption.ai-non-final":[{"type":0,"value":"You are now on the Free plan of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.interruptions.ai-non-final":[{"type":0,"value":"To avoid any interruptions, make sure your payment details are up to date."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.manage-subscription.ai-non-final":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.payment-failure.ai-non-final":[{"type":0,"value":"We couldn\u2019t process payment for your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementId"},{"type":0,"value":") due to an issue with your payment details. As a result, we\u2019ve moved your subscription to the Free plan. This way, you can still use "},{"type":1,"value":"productName"},{"type":0,"value":", but with limited features."}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.subject.ai-non-final":[{"type":1,"value":"productName"},{"type":0,"value":" subscription moved to Free plan"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.email.uncollectible.upgrade.ai-non-final":[{"type":0,"value":"Want to go back on your original plan? You can upgrade your subscription. "},{"children":[{"type":0,"value":"Learn how to change plans"}],"type":8,"value":"link"}],"commerce.commerce-subscription-auto-downgrade-ccp.message-template.partner.email.body.personal-data-retention-summary.link":[{"type":0,"value":"request for deletion of their personal data."}],"commerce.commerce-subscription-auto-upgrade-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.downgrade":[{"type":0,"value":"downgrade"}],"commerce.commerce-subscription-auto-upgrade-ccp.legal-update-twcg-1465.reduce-your-user-count":[{"type":0,"value":"reduce your user count"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Your customer can now enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, with instructions."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.body.switch-to-back-free-plan":[{"type":0,"value":"To stay on the Standard plan, you don\'t need to do anything. We\'ll charge your saved payment method when your trial ends. To return to the Free plan, first "},{"type":1,"value":"reduceYourUserCount"},{"type":0,"value":" to meet the plan limit, then "},{"type":1,"value":"downgrade"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-date-label":[{"type":0,"value":"Next bill date"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-label":[{"type":0,"value":"Next bill estimate"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.next-bill-estimate-value":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"type":1,"value":"billingCycle"},{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-label":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.contextual-info.plan-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.explore-standard-cta":[{"type":0,"value":"Explore Standard"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial":[{"type":0,"value":"You\'ve reached the user limit for your Free plan, so "},{"children":[{"type":0,"value":"we\'ve upgraded you"}],"type":8,"value":"bold"},{"type":0,"value":" to our Standard plan. It\'s free for 14 days."},{"type":1,"value":"br"},{"type":0,"value":"You can now add unlimited users to your projects and help your team ship faster."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.body.subscription-trial-with-end-date":[{"type":0,"value":"You\'ve reached the user limit for your Free plan, so "},{"children":[{"type":0,"value":"we\'ve upgraded you"}],"type":8,"value":"bold"},{"type":0,"value":" to our Standard plan. It\'s free for 14 days."},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"You can now add unlimited users to your projects and help your team ship faster. Your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"bold"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.caption":[{"type":0,"value":"Your Standard trial has started"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.subscription-details-heading":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.direct-customer.what-happens-next-heading":[{"type":0,"value":"What happens next?"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.confluence-logo-alt":[{"type":0,"value":"Confluence"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jira-logo-alt":[{"type":0,"value":"Jira"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.legal-update-twcg-1465.header.jpd-logo-alt":[{"type":0,"value":"Jira Product Discovery"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.billing-heading":[{"type":0,"value":"What happens to my billing?"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.explore-features":[{"type":0,"value":"Explore new features"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features-heading":[{"type":0,"value":"What else can your new plan do?"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.archivePages.description":[{"type":0,"value":"Keep your space tidy without deleting."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.archivePages.title":[{"type":0,"value":"Archive old pages"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.automateWork.description":[{"type":0,"value":"Speed up your work and remove human error."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.automateWork.title":[{"type":0,"value":"Automate work"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.controlAccess.description":[{"type":0,"value":"Choose who can see, create, and edit pages."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.controlAccess.title":[{"type":0,"value":"Control access"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.dataResidency.description":[{"type":0,"value":"Make sure your data storage is compliant."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.dataResidency.title":[{"type":0,"value":"Choose where data lives"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.draftWithAi.description":[{"type":0,"value":"Create, summarize, and find content, fast."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.draftWithAi.title":[{"type":0,"value":"Draft faster with AI"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jiraControlAccess.description":[{"type":0,"value":"Choose who can see, create, and edit work items."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jpdCompliance.description":[{"type":0,"value":"Choose where your data lives and use HIPAA-eligible infrastructure with a BAA available."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jpdCompliance.title":[{"type":0,"value":"Built for compliance"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jpdProjectRoles.description":[{"type":0,"value":"Add unlimited creators and fine-tune access with custom project roles."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jpdProjectRoles.title":[{"type":0,"value":"Control who does what"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jpdShare.description":[{"type":0,"value":"Share read-only views with stakeholders inside and outside your company, no Jira needed."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jpdShare.title":[{"type":0,"value":"Share with anyone"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jpdWithAi.description":[{"type":0,"value":"Ask Rovo AI to compare impact and effort or write team updates in seconds."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.jpdWithAi.title":[{"type":0,"value":"Work faster"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.measureImpact.description":[{"type":0,"value":"Track page views and engagement."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.measureImpact.title":[{"type":0,"value":"Measure impact"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.workWithAi.description":[{"type":0,"value":"Search, create, and summarize, fast."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.features.workWithAi.title":[{"type":0,"value":"Work faster with AI"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.heading-creators":[{"type":0,"value":"Say hello to unlimited creators"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.heading-users":[{"type":0,"value":"Say hello to unlimited users"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.hero-creators-alt":[{"type":0,"value":"From 3 creators on Free to unlimited creators on Standard"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.hero-users-alt":[{"type":0,"value":"From 10 users on Free to unlimited users on Standard"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.intro":[{"type":0,"value":"Your team outgrew the Free plan, so now you\'re on Standard, free for 14 days."}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.refund":[{"type":0,"value":"Refund if you forget to cancel within 30 days"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.reminder":[{"type":0,"value":"We\u2019ll remind you 3 days before your trial ends"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.subject":[{"type":0,"value":"Welcome to your 14-day free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.switch-to-free":[{"children":[{"type":0,"value":"Manage "},{"options":{"other":{"value":[{"type":0,"value":"users"}]},"true":{"value":[{"type":0,"value":"creators"}]}},"type":5,"value":"isJpd"}],"type":8,"value":"a"},{"type":0,"value":" to switch back to Free"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.pde-auto-upgrade-optimization.trial-end":[{"type":0,"value":"Your Standard trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-ccp.screen-space-flags.description.no-translate":[{"type":0,"value":"You\'re over the Free user limit, so we moved you to a Standard trial."}],"commerce.commerce-subscription-auto-upgrade-ccp.screen-space-flags.title.no-translate":[{"type":0,"value":"Welcome to your 14-day free trial of Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.email.icon-warning.alt-text":[{"type":0,"value":"Icon - Warning"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.learn-how-to-do-this":[{"type":0,"value":"Learn how to do this"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Your customer\u2019s site or organization admin will first need to reduce the "},{"type":1,"value":"userType"},{"type":0,"value":" count for the product to 10 or fewer."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-admin-partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Important things to know about "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.more-information":[{"type":0,"value":"For help or more information, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.partner-managed-subscriptions":[{"type":0,"value":"You can also cancel your subscription at any time by going to your "},{"type":1,"value":"partnerManagedSubscriptions"},{"type":0,"value":" and following the steps. [Link to ECC section on admin hub]"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.body.stay-on-plan":[{"type":0,"value":"If you\u2019d like to stay on the "},{"type":1,"value":"planName"},{"type":0,"value":" plan, you\u2019ll just need to make sure your Atlassian billing partner has the correct billing details. We\u2019ve also sent them an email with instructions."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.caption":[{"type":0,"value":"Enjoy the benefits of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.billing-user-partner.subject":[{"type":1,"value":"partnerName"},{"type":0,"value":": Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been upgraded to the "},{"type":1,"value":"planName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.add-payment-details":[{"type":0,"value":"Add payment details before the trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", otherwise the subscription will be deactivated."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded you to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":". This is because the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":" limit for the Free plan was exceeded."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.switch-to-back-free-plan":[{"type":0,"value":"You can switch back to a Free plan at any time by reducing your "},{"type":1,"value":"userType"},{"type":0,"value":" count. "},{"type":1,"value":"learnHowToDoThis"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access":[{"type":0,"value":"You\u2019ll lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" if you don\u2019t take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.take-action-or-lose-access.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-billing-admin":[{"type":0,"value":"You can switch back to a Free plan at any time by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"Link"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.body.you-can-switch-back-to-free-plan-mpucup-user":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan at any time by reducing your user count."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.body-intro":[{"type":0,"value":"Your team now has a "},{"children":[{"type":0,"value":"free 14-day trial"}],"type":8,"value":"b"},{"type":0,"value":" of "},{"type":1,"value":"productName"},{"type":0,"value":" Standard because you reached the 10-user limit on the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.invite-team":[{"children":[{"type":0,"value":"Invite your team."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need to your spaces."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.page-insights":[{"children":[{"type":0,"value":"Measure impact."}],"type":8,"value":"b"},{"type":0,"value":" Track views and engagement with page insights."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.confluence.rovo-ai":[{"children":[{"type":0,"value":"Draft faster."}],"type":8,"value":"b"},{"type":0,"value":" Generate ideas and first drafts with Rovo AI."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.automation":[{"children":[{"type":0,"value":"Automate tedious tasks."}],"type":8,"value":"b"},{"type":0,"value":" Set rules for repetitive updates."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.invite-team":[{"children":[{"type":0,"value":"Invite your team."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need to your spaces."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.features.jira.rovo-agents":[{"children":[{"type":0,"value":"Put agents to work."}],"type":8,"value":"b"},{"type":0,"value":" Call on Rovo agents for specialized tasks."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.heading":[{"type":0,"value":"We\'ve upgraded you to "},{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.payment-deadline":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\'t add payment details or reduce your user count to 10 or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.d0-treatment.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.stay-on-plan":[{"type":0,"value":"If you\u2019ve already added your payment details, you don\u2019t need to do anything."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.body.subscription-trial":[{"type":0,"value":"We\u2019ve upgraded the following subscription to a free 14-day trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". This is because you went over the "},{"type":1,"value":"exceedingUsageCount"},{"type":0,"value":" "},{"type":1,"value":"userType"},{"type":0,"value":" limit for the Free plan."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Add payment details to enjoy the benefits of "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.direct-customer.subject3":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has changed to Standard"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-admin-partner.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or have your customer\u2019s admin remove users so you can switch back to Free in the "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":". Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.add-payment-or-remove-users":[{"type":0,"value":"To keep unlimited and users stay on Standard, ensure your Atlassian billing partner updates your billing details. We\u2019ve also sent them instructions. To switch back to Free, "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.billing-user-partner.take-action":[{"type":0,"value":"Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation. For help, contact your Atlassian billing partner."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.direct-customer.add-payment-or-remove-users":[{"type":0,"value":"Add payment to keep unlimited users and stay on Standard, or "},{"type":1,"value":"removeUsersLink"},{"type":0,"value":" to switch back to the Free plan. Take action "},{"type":1,"value":"takeActionBy"},{"type":0,"value":" to avoid site deactivation."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.over-free-limit-moved-to-standard":[{"type":0,"value":"You\'re over the Free user limit, so we moved you to Standard, which includes unlimited users."}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.partner-purchasing-center":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.remove-users":[{"type":0,"value":"remove users"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-available":[{"type":0,"value":"by "},{"type":1,"value":"trialEndMonth"},{"type":0,"value":" "},{"offset":0,"options":{"few":{"value":[{"type":0,"value":"$rd"}]},"one":{"value":[{"type":7},{"type":0,"value":"st"}]},"other":{"value":[{"type":7},{"type":0,"value":"th"}]},"two":{"value":[{"type":7},{"type":0,"value":"nd"}]}},"pluralType":"ordinal","type":6,"value":"trialEndDate"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.email-body.take-action-by-trial-end-date-not-available":[{"type":0,"value":"soon"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.unlocks-additional-features":[{"type":0,"value":"Your new "},{"type":1,"value":"planName"},{"type":0,"value":" plan unlocks additional features to help your team achieve more together:"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.message-template.email.want-to-stay-on-standard":[{"type":0,"value":"Don\'t want to stay on "},{"type":1,"value":"planName"},{"type":0,"value":"?"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-managed-subscriptions-link":[{"type":0,"value":"partner-managed subscriptions"}],"commerce.commerce-subscription-auto-upgrade-no-payment-method-ccp.partner-purchasing-link\'":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.caption":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.closing-line":[{"type":0,"value":"Your new bill date will be in effect from the next billing cycle. To transition you to the new\\n\\t\\t\\t\\t\\t  bill date, pro-rated adjustments will be applied to your next invoice."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.first-line":[{"type":0,"value":"We\'ve processed your request to change the bill date for your "},{"type":1,"value":"productName"},{"type":0,"value":"\\n\\t\\t\\t\\t\\t\\t("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") subscription to "},{"type":1,"value":"requestedNextBillingDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template-template.email.body.second-line":[{"type":0,"value":"If you have any other product and subscriptions on the same site that belong to the same product family,\\n            they need to be billed together. That means we\u2019ve changed the bill date for those subscriptions too."}],"commerce.commerce-subscription-bill-date-change-ccp.message-template.email.subject":[{"type":0,"value":"Your bill date will soon be changed"}],"commerce.commerce-subscription-cancellation-ecc.email.body.billing-partner":[{"type":0,"value":"Atlassian billing partner"}],"commerce.commerce-subscription-cancellation-ecc.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" subscription is canceled"}],"commerce.commerce-subscription-cancellation-ecc.email.body.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-ecc.email.body.data-will-be-deleted":[{"type":0,"value":"Data will be deleted within 60 days from the date of cancellation. If you\u2019d like to request deletion of the data earlier, "}],"commerce.commerce-subscription-cancellation-ecc.email.body.reactivate":[{"type":0,"value":"Your Atlassian billing partner can ask us to reactivate the subscription if needed. If you weren\u2019t expecting this email, you can contact us."}],"commerce.commerce-subscription-cancellation-ecc.email.body.this-is-to-let-you-know":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g-direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp-g.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.email.reactivate-button.ai-non-final":[{"type":0,"value":"Reactivate"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.auto-cancellation-info.uninvoiceable":[{"type":0,"value":"If you want to keep your subscription, you can update your billing details and then reactivate."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user":[{"type":0,"value":"If you want to keep your subscription, you can ask a billing admin to reactivate it. "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.billing-user.link":[{"type":0,"value":"Learn more about reactivation"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link":[{"type":0,"value":"see how to reactivate it"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.cta-direct-customer.support.link.twc":[{"type":0,"value":"reactivate your subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.ecc.partner-details":[{"type":0,"value":"Your partner details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription":[{"type":0,"value":"If you want to keep your subscription, you can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.how-to-reactivate-subscription.twc":[{"type":0,"value":"We\'re sad to see you go, but if you change your mind, you can always "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.customer-details":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.partner.subscription-details":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your app\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.findability":[{"type":0,"value":"You may be able to reactivate your subscription and restore your data while it remains available. Once your subscription and data have been permanently deleted, they cannot be recovered. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link.twc":[{"type":0,"value":"immediate deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc":[{"type":0,"value":"If you reactivate your subscription within 60 days, your data and preferences will remain the same. For trials, data is stored for 15 days. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.twc.findability":[{"type":0,"value":"You may be able to reactivate your subscription and restore your data while it remains available. Once your subscription and data have been permanently deleted, they cannot be recovered. You may also place a request for "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":". Learn about the "},{"type":1,"value":"privacyPolicyLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uncollectible":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.dc-uninvoiceable":[{"type":0,"value":"We\u2019ve canceled the following subscription. This is because we\u2019re missing the right payment details, so we weren\u2019t able to process your payment."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.body.summary.partner":[{"type":0,"value":"As requested, we\'ve canceled the following subscription:"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.direct-customer":[{"type":0,"value":"Your "},{"type":1,"value":"productInfo"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.caption.partner-end-customer-contact":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.cta.reactivate-button":[{"type":0,"value":"Reactivate "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days":[{"type":0,"value":"You can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.body.restore-within-15-days-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-billing-admin-and-billing-user":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.email.subject.partner-bu-and-ecc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-the-following-subscription":[{"type":0,"value":"As requested, we\'ve canceled the following subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.as-requested-we-have-cancelled-your-customers-subscription":[{"type":0,"value":"As requested, we\'ve canceled your customer\'s subscription"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-customers-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your customer\'s product data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-reactivate-within-60-days-we-will-restore-product-data":[{"type":0,"value":"If you reactivate within 60 days (or 15 days for trials), we\'ll restore your product\'s data and preferences."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-direct-customer-non-cloud":[{"type":0,"value":"If you want to keep your subscription, "},{"type":1,"value":"reachOutLinkForNonCloud"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-you-want-to-keep-your-subscription-reach-out-to-your-billing-partner-to-reactivate":[{"type":0,"value":"If you want to keep your subscription, reach out to your Atlassian billing partner to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.if-your-customer-wants-to-keep-the-subscription-reach-out-to-us-to-reactivate":[{"type":0,"value":"If your customer wants to keep the subscription, "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-their-personal-data":[{"type":0,"value":"request for deletion of their personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.request-for-deletion-of-your-personal-data":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-colon":[{"type":0,"value":":"}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.special-char-period":[{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-do-not-have-your-customers-billing-information":[{"type":0,"value":"This is because we don\'t have your customer\'s complete billing information. It could be because the information provided to us is incorrect or incomplete."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.this-is-because-we-were-not-able-to-collect-payment-for-an-invoice":[{"type":0,"value":"This is because we weren\'t able to collect payment for an invoice."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.update-your-customers-billing-details-and-then-reach-out-to-us-to-reactivate":[{"type":0,"value":"Update your customer\'s billing details and then "},{"type":1,"value":"reachOutLink"},{"type":0,"value":" to reactivate the subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.we-have-cancelled-your-customers-subscription":[{"type":0,"value":"We\'ve canceled your customer\'s subscription."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.you-can-also-submit-a-request-for-deletion-of-your-personal-data":[{"type":0,"value":"You can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-occurs-ccp.message-template.texts.your-customer-can-also-submit-a-request-for-deletion-of-their-personal-data":[{"type":0,"value":"Your customer can also submit a "},{"type":1,"value":"requestForDeletionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.jsm-requirement":[{"type":0,"value":"This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.direct-customer.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption":[{"type":0,"value":"We\'re sad to see you go"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.email.partner.caption.twc":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.body.sub-cancel-note.twc":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.manage-subscription-button":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.billing-user.keep-subscription":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.received-request":[{"type":0,"value":"We\'ve received your request to cancel your subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.body.sub-cancel-note":[{"type":0,"value":"Your subscription will be canceled at the end of your current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":" Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.billing-partner-details.twc":[{"type":0,"value":"Your billing partner details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.data-deletion-note":[{"type":0,"value":"Product data will be deleted in 60 days from the date of cancellation. For trials, we retain data for 15 days. If you\u2019d like to request deletion of personal data, "},{"type":1,"value":"contactSupport"},{"type":0,"value":". Learn about "},{"type":1,"value":"privacyPolicy"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.contact-us":[{"type":0,"value":"contact us"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.data-deletion-note":[{"type":0,"value":"Product data will be deleted 60 days from cancellation. For trials, we retain data for 15 days. If you\'d like to request deletion of personal data, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.intro":[{"type":0,"value":"Your app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since you don\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to contact your Atlassian billing partner to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request":[{"type":0,"value":"We\'ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.received-request.twc":[{"type":0,"value":"We\'ve received your request to cancel your subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation":[{"type":0,"value":"You can always "},{"type":1,"value":"undoLink"},{"type":0,"value":" from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.ecc.body.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.email.ecc.subject.twc":[{"type":1,"value":"billingPartnerName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is scheduled for cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. If you reactivate the subscription within 60 days of cancellation, we\'ll restore the relevant data and preferences. For trials, the reactivation period is 15 days."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-admin.undo-cancellation-link":[{"type":0,"value":"undo your cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.billing-user.keep-subscription":[{"type":0,"value":"If needed, you can contact us to reverse the cancellation request. "},{"type":1,"value":"undoLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.customer-details.twc":[{"type":0,"value":"Your customer details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.atlassian-privacy-policy":[{"type":0,"value":"Atlassian\u2019s Privacy Policy"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-atlassian-support":[{"type":0,"value":"contact Atlassian support"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.ecc.contact-billing-partner":[{"type":0,"value":"You can contact your Atlassian billing partner if you need help or want to reverse the cancellation request."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.cancellation-notice":[{"type":0,"value":"Your subscription will be canceled on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\'ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.intro":[{"type":0,"value":"Your customer\'s app subscription is scheduled for cancellation. This is because our Marketplace app partner has updated the way this app is billed, which means it needs to be installed on Jira Service Management going forward. Since your customer doesn\'t have an active JSM subscription, the app can no longer be billed compatibly."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.jira-decoupled.prevention-option":[{"type":0,"value":"There\'s still time to prevent cancellation. You just need to purchase a Jira Service Management subscription before "},{"type":1,"value":"cancellationDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription":[{"type":0,"value":"Keeping the subscription"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.keep-subscription.twc":[{"type":0,"value":"Your customer contact can undo the cancellation at any time from "},{"type":1,"value":"partnerManagedSubscriptionsLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner-managed-subscriptions-link":[{"type":1,"value":"partnerManagedSubscriptionsLink"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.partner.billing-admin.undo-cancellation-link":[{"type":0,"value":"Learn how to undo a cancellation"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request":[{"type":0,"value":"We\u2019ve received a request to cancel the following subscription:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.received-request.twc":[{"type":0,"value":"We\u2019ve received your customer\u2019s request to cancel their subscription."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"type":1,"value":"nextBillingDate"},{"type":0,"value":". You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" until then. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.sub-cancel-note.twc":[{"type":0,"value":"The subscription will be canceled at the end of the current billing cycle on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"b"},{"type":0,"value":". Until then, the subscription can still be used. We\u2019ll send you an email once the cancellation has gone through."}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.body.subscription-details.twc":[{"type":0,"value":"Your subscription details are:"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.with-company-name.twc":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-scheduled-ccp.message-template.email.partner.subject.without-company-name.twc":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" : "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" cancellation scheduled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.email.partner.reactivate-button.ai-non-final":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.body.could-not-process-payment":[{"type":0,"value":"This is to let you know that we\u2019ve canceled the following subscription since we were unable to process your payment. "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.cta.reactivate-button":[{"type":0,"value":"Reactivate "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.exceeded-user-limit":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription was canceled because your team exceeded the 10-user limit on the Free plan and payment details were not added to upgrade to the Standard plan."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days":[{"type":0,"value":"You can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.body.restore-within-15-days-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can restore your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription and all data within the next 15 days. After that, your data will be permanently deleted."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.mpucup.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has ended"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t collect payment for an invoice generated for the following subscription.As a result, the subscription has been canceled."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email-content.partner.subject.no-customer-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Subscription canceled due to non-payment"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.cta-direct-customer.reactivate-subscription":[{"type":0,"value":"Don\u2019t worry, all\u2019s not lost! You can "},{"type":1,"value":"reactivateSubscriptionLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer":[{"type":0,"value":"If you reactivate within 60 days, we\'ll restore your product\'s data and preferences. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.findability":[{"type":0,"value":"You may be able to reactivate your subscription and restore your data while it remains available. Once your subscription and data have been permanently deleted, they cannot be recovered. You can also submit a "},{"type":1,"value":"deletionOfPersonalDataLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.body.personal-data-retention-summary.direct-customer.link":[{"type":0,"value":"request for deletion of your personal data"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.cta.reactivate-subscription-button":[{"type":0,"value":"Reactivate subscription"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.product-list-item":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"planName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"},{"type":0,"value":")"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.body.update-payment-details":[{"type":0,"value":"We recommend updating your payment details to ensure this doesn\'t happen again."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. As a result, we\'ve canceled your plan changes scheduled for "},{"type":1,"value":"scheduleStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.payment-details-up-to-date":[{"type":0,"value":"To avoid this in the future, ensure your payment details are up to date."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.body.subscription-is-still-active":[{"type":1,"value":"productName"},{"type":0,"value":" subscription is still active, but the scheduled changes won\'t happen."}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your scheduled changes have been canceled"}],"commerce.commerce-subscription-cancellation-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" scheduled changes canceled"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp-g.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info":[{"type":0,"value":"If you want to increase your included quantity, you can upgrade your plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.breached-upgrade-plan-info.partner":[{"type":0,"value":"If you want to increase the included quantity, you can upgrade your customer\u2019s plan."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.dc.what-you-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.email.dc.billing-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.milestone-caption":[{"type":0,"value":"Your included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.breached":[{"type":0,"value":"You\u2019ve exceeded your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.dc.email.subject.milestone":[{"type":0,"value":"You\u2019re running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-caption":[{"type":0,"value":"You\u2019ll now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.breached-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.body.included-qty-info":[{"type":0,"value":"Your plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.dc.milestone-info-message":[{"type":0,"value":"We wanted to let you know that you\u2019ve reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of your included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.breached-what-to-know":[{"type":0,"value":"You can continue to use your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but keep in mind that any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" you use from now on will incur extra charges. Any extra usage charges will be reflected in your next invoice, and can be viewed in your site\u2019s "},{"type":1,"value":"admin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in your subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.extra-charge-info":[{"type":0,"value":"If you go over this amount, extra usage charges will be added to your next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan":[{"type":0,"value":"Upgrade your plan"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.direct-customer.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade your plan to increase your included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.breached-what-to-know":[{"type":0,"value":"Your customer can continue to use their "},{"type":1,"value":"productName"},{"type":0,"value":" subscription as normal, but any "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" they use from now on will incur extra charges.Any extra charges will be reflected in the next bill, and can be viewed in the Partner Purchasing Centre."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-details":[{"type":0,"value":"Any extra charges will be reflected in the subscription details page"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.extra-charge-info":[{"type":0,"value":"If they go over this amount, extra usage charges will be added to their next invoice"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.included-qty-info":[{"type":0,"value":"This plan includes "},{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":". "},{"type":1,"value":"viewUsage"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.body.upgrade-plan-increase-qty":[{"type":0,"value":"You can upgrade the plan to increase your customer\u2019s included quantity"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-caption":[{"type":0,"value":"Your customer will now be charged extra for using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.breached-info-message":[{"type":0,"value":"Your customer has reached their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.partner.milestone-info-message":[{"type":0,"value":"Your customer has reached "},{"type":1,"value":"usageMilestone"},{"type":0,"value":"% of their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.email.what-you-need":[{"type":0,"value":"What you need to know:"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.milestone-caption":[{"type":0,"value":"Included quantity of "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"},{"type":0,"value":" is running low"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.breached.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" has exceeded their included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cbp-usage-reminder-ccp.message-template.partner.email.subject.milestone.with-company-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is running out of included quantity for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" in "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Subscription moved from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.ecc-view-cancel-subscription":[{"type":0,"value":"You can view or cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.managed-subscriptions-url":[{"type":1,"value":"url"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-manage-subscription":[{"type":0,"value":"You can manage the subscription from the "},{"type":1,"value":"partnerPurchaseCentralUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"Based on a quote that\u2019s already paid, your customer\u2019s subscriptions are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.partner-view-cancel-subscription":[{"type":0,"value":"Your customer contact can view and cancel the subscription at any time from "},{"type":1,"value":"partnerManagedSubscriptionsUrl"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"Based on a quote that you\u2019ve already paid, you have subscriptions that are now on annual from monthly."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-view-cancel-subscription":[{"type":0,"value":"You can view and manage your subscription from your billing account. "}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":" We\u2019ll charge your chosen payment details annually, and your subscription will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":"We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.auto-renewal":[{"type":0,"value":"As requested, your subscription has now been moved to the annual (auto-renewal) plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.body.plan-note.termed":[{"type":0,"value":"As requested, your subscription has now been moved to the annual plan."}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"] Billing cycle changed from monthly to annual"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.caption":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.auto-renewal":[{"type":0,"value":"We\u2019ll charge your chosen payment details annually for this subscription, and it will be renewed automatically each year. Don\u2019t worry \u2013 we\u2019ll let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.charge-note.termed":[{"type":0,"value":" We\'ll charge your chosen payment details and let you know when your renewal is coming up."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.auto-renewal":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n\\t\\t\\t\\tAs requested, your subscription has been moved to an annual (auto-renewal) plan, which will start after\\n\\t\\t\\t\\tyour trial period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.body.subscription-note.termed":[{"type":0,"value":"We hope you\'ve enjoyed your monthly "},{"type":1,"value":"oldPricingPlan"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":").\\n                As requested, your subscription has been moved to an annual plan, which will start after your trial\\n                period has ended."}],"commerce.commerce-subscription-cycle-change-trial-to-trial-ccp.message-template.email.subject":[{"type":0,"value":"Let\u2019s make it long term"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.charge-quantities-added-message":[{"type":0,"value":"You added new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to your subscription. Based on these changes, we\u2019ve adjusted your billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and prorated the cost for new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for the remaining time in your billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.estimated-bill":[{"type":0,"value":"Your estimated bill for the next billing cycle is "},{"children":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"type":8,"value":"b"},{"type":0,"value":" (excluding tax)."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.final-invoice-details":[{"type":0,"value":"Your final invoice will reflect all "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of your current billing period and the subsequent prorated charges."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.body.to-view-bill":[{"type":0,"value":"To view your bill breakdown and usage details, visit your "},{"children":[{"type":0,"value":"Subscription details"}],"type":8,"value":"b"},{"type":0,"value":" page."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.charge-quantities-added-message":[{"type":0,"value":"More "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been added to the following subscription:"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.final-invoice-details":[{"type":0,"value":"The final invoice will reflect the total number of "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" added before the end of the current billing cycle."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.p2-billing-adjusted":[{"type":0,"value":"The billed "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" have been adjusted to "},{"type":1,"value":"maximumBillingUsageValue"},{"type":0,"value":" and the cost for the new "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" has been prorated for the remaining time in the billing period."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.body.ppc":[{"type":0,"value":"You can view the usage details from our "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your customer\u2019s team is growing"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.with-customer-name":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-hwm-limit-exceed-ccp.message-template.email.partner.subject.without-customer-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" New "},{"type":1,"value":"maximumBillingUsageName"},{"type":0,"value":" for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-offering-cancellation-ccp.email.app-retiring":[{"type":0,"value":"We wanted to let you know that we\u2019re no longer offering "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". "}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-at-end-of-billing-cycle":[{"type":0,"value":"This means your subscription will be canceled at the end of your last billing cycle."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-immediately":[{"type":0,"value":"This means your subscription will be canceled 30 days from the date of this email."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.cancelled-on-offering-expiry-date":[{"type":0,"value":"This means your subscription will be canceled on "},{"type":1,"value":"expiryDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-offering-cancellation-ccp.email.caption":[{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" is being retired"}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.body.subscription-details":[{"type":0,"value":"Subscription details:"}],"commerce.commerce-subscription-offering-cancellation-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"appName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription will be canceled"}],"commerce.commerce-subscription-offering-movement-ccp.email.app-getting-replaced":[{"type":0,"value":" The developers of "},{"type":1,"value":"appName"},{"type":0,"value":" are retiring this app and replacing it with a free version. Your paid\\n                subscription will transition to "},{"type":1,"value":"freeAppName"},{"type":0,"value":". From the end of your last billing cycle, you\u2019ll no \\n\\t\\t\\t\\tlonger be charged for this app."}],"commerce.commerce-subscription-offering-movement-ccp.email.caption":[{"type":0,"value":"Your paid subscription for this app will convert to a free subscription"}],"commerce.commerce-subscription-offering-movement-ccp.message-template.email.subject":[{"type":1,"value":"appName"},{"type":0,"value":" is being retired."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp-g.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp-g.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-opt-out-ccp-grouped.email.direct.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember \u2014 if your organization admin has enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. Organization admins can adjust usage limits anytime. "}],"commerce.commerce-subscription-opt-out-ccp-grouped.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember \u2014 if you\u2019ve enabled extra usage, any usage above the allowance will incur extra usage charges. These will be reflected on your bill at the end of the cycle. You can adjust usage limits anytime."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.caption.upsell-twc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan is active"}],"commerce.commerce-subscription-opt-out-ccp.direct.message-template.email.body.intimation":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":". Your paid "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has now started from date "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.email.direct.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.email.partner.body.allowance-contributions-enforcement-ubp5":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\'s bill at the end of the bill cycle. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.confluence-decrease":[{"type":0,"value":"Get more out of Confluence, Jira, Loom, and Rovo in one bundle and save."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.confluence-increase":[{"type":0,"value":"Get more out of "},{"type":1,"value":"productName"},{"type":0,"value":" and level-up your pages with Teamwork Collection."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.jira-decrease":[{"type":0,"value":"Get more out of Jira, Confluence, Loom, and Rovo in one bundle and save."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.jira-increase":[{"type":0,"value":"Get more out of "},{"type":1,"value":"productName"},{"type":0,"value":" and level-up your projects with Teamwork Collection."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.loom-decrease":[{"type":0,"value":"Get Loom, Jira, Confluence, and Rovo in one bundle and save."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.loom-increase":[{"type":0,"value":"Get Loom, Jira, Confluence, and Rovo in one bundle for just $5 more each month."}],"commerce.commerce-subscription-opt-out-ccp.message-template.direct.email.body.trial-end-upsell-twc-offer.plan-started":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan started on "},{"type":1,"value":"billingStartDate"},{"type":0,"value":". "}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.subject":[{"type":0,"value":"Your no-cost, trial period on "},{"type":1,"value":"productName"},{"type":0,"value":" paid plan has ended"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-decrease.row.one.description":[{"type":0,"value":"Bundle Confluence with Jira, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-decrease.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-decrease.row.two.description":[{"type":0,"value":"Pay less for all four apps than you currently pay for Confluence"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-decrease.title":[{"type":0,"value":"Want to pay less for Confluence?"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.description":[{"type":0,"value":"to make sure AI is as useful as it can be"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.title":[{"type":0,"value":"More context"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.description":[{"type":0,"value":"to instantly create more pages and whiteboards"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.confluence-price-increase.title":[{"type":0,"value":"Take your pages to the next level"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.cta.explore":[{"type":0,"value":"Explore Teamwork Collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.cta.see-pricing":[{"type":0,"value":"See pricing"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-decrease.row.one.description":[{"type":0,"value":"Bundle Jira with Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-decrease.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-decrease.row.two.description":[{"type":0,"value":"Pay less for all four apps than you currently pay for Jira"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-decrease.title":[{"type":0,"value":"Want to pay less for Jira?"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.three.description":[{"type":0,"value":"to instantly create work in bulk"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.three.title":[{"type":0,"value":"More agents"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.two.description":[{"type":0,"value":"to automatically triage more work"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.jira-price-increase.title":[{"type":0,"value":"Take your projects to the next level"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.description":[{"type":0,"value":"for less than you think"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.title":[{"type":0,"value":"All in one place"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.description":[{"type":0,"value":"to easily connect Loom with your other tools"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business-and-ai.title":[{"type":0,"value":"Get more from Loom with the full collection"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business.row.one.title":[{"type":0,"value":"Bundle Loom with Jira, Confluence, and Rovo"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business.row.two.title":[{"type":0,"value":"Pay less for all four apps than you currently pay for Loom"}],"commerce.commerce-subscription-opt-out-ccp.message-template.email.twc-offer.loom-business.title":[{"type":0,"value":"Want to pay less for Loom?"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.billing-info":[{"type":0,"value":"We\u2019ll charge for the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation. Your customer may first be charged a prorated amount to align their bill date with the previous plan. Any remaining days of the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan will be adjusted as credits in the invoice."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.body.upgradation":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan."}],"commerce.commerce-subscription-opt-out-ccp.partner.message-template.email.intimation":[{"type":0,"value":"The free "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.body.manage-subscription":[{"type":0,"value":"You can view "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"entitlementsLength"},{"type":0,"value":" and billing details on your "},{"type":1,"value":"manageSubscriptionUrl"},{"type":0,"value":" page."}],"commerce.commerce-subscription-order-fulfilled-ccp.message-template.email.reseller.manage-url":[{"type":0,"value":"Manage Subscriptions"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.ba-when-the-trial-ends":[{"type":0,"value":"Your subscription will be canceled, unless you place an order for the paid plan before the trial end date. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.bu-when-the-trial-ends":[{"type":0,"value":"When you\'re ready to start paid subscription, your billing admin will need to use the quote we send them to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.caption-partner-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p2.partner":[{"type":0,"value":"When trial ends, the subscription will be deactivated. To extend the trial "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3":[{"type":0,"value":"We\'ve sent a quote to your billing admin. When you\'re ready to start your paid subscription, your billing admin will need to use the quote to place an order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.p3-admin":[{"type":0,"value":"During your trial, we\'ll send you a quote. When you\'re ready to start your paid subscription, you can use the quote to place the order."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.reach-out-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". The trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template-template.email.body.twc.p1.partner":[{"type":0,"value":"This is to notify you that your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.ba.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to the included amount for each quota. If they want extra usage straight away you can contact us. Otherwise, they\u2019ll be able to use more than the included quantity once their paid plan starts, and extra usage charges will be added to the invoice as per their usage."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.cbp-details":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-cbp-details":[{"type":0,"value":"Your new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.dc.twc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.twc.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.body.upgraded-cbp-details":[{"type":0,"value":"The new plan includes:"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.partner.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-auto-conversion-off-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-cc.message-template.email.direct-customer.body.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbp-details":[{"type":0,"value":"Your trial includes:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allowance for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.caption-new":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.cbps-description":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":". You won\'t be charged if you switch before the trial ends."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.rovo-dev-description":[{"type":0,"value":"As part of the free trial, your customer can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends. "},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.trial-ends-on":[{"type":0,"value":"The trial ends on "},{"type":1,"value":"trialEndDate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.twc-as-requested":[{"type":0,"value":"Your customer\'s free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has started. To start making the most of it, make sure you or your customer "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice your customer for their upgraded plan, we\u2019ll also include any extra usage charges from the previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.partner.upgrade-trial-description":[{"type":0,"value":"Your customer will be charged for their existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.trial-ends-description":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends"},{"type":1,"value":"upGradeTrialContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.twc-good-news":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-cbp-description":[{"type":0,"value":" When we invoice you for your upgraded plan, we\u2019ll also include any extra usage charges from your previous plan."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.body.upgrade-trial-description":[{"type":0,"value":", and you\u2019ll continue to be charged for your existing "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan and any included quantities until then."},{"type":1,"value":"upgradeTrialCbpContent"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.dc.twc.body.ubp5-enforcement":[{"type":0,"value":"During your trial, you can only use the allowances included in your subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.changed-your-mind":[{"type":0,"value":"Changed your mind?"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.subtitle":[{"type":0,"value":"Your free "},{"children":[{"type":1,"value":"trialLength"},{"type":0,"value":" trial"}],"type":8,"value":"b"},{"type":0,"value":" has started. Your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-direct-trial-optimization.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.cta.get-started":[{"type":0,"value":"Get started"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.docs":[{"children":[{"type":0,"value":"Create docs instantly."}],"type":8,"value":"b"},{"type":0,"value":" Generate plans, roadmaps, and more with AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.confluence.find":[{"children":[{"type":0,"value":"Find what you need."}],"type":8,"value":"b"},{"type":0,"value":" Search across all your connected apps in one place."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.automate":[{"children":[{"type":0,"value":"Automate tedious tasks."}],"type":8,"value":"b"},{"type":0,"value":" Set rules for repetitive updates."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jira.plans":[{"children":[{"type":0,"value":"Turn plans into work."}],"type":8,"value":"b"},{"type":0,"value":" Create work items from docs using AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.access":[{"children":[{"type":0,"value":"Set access guardrails."}],"type":8,"value":"b"},{"type":0,"value":" Control what users can create and see."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.align":[{"children":[{"type":0,"value":"Align your team."}],"type":8,"value":"b"},{"type":0,"value":" Share plans with co-workers, no sign up required."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.jpd.prioritize":[{"children":[{"type":0,"value":"Prioritize ideas."}],"type":8,"value":"b"},{"type":0,"value":" Define and refine your opportunities in one place."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.edit":[{"children":[{"type":0,"value":"Edit your videos."}],"type":8,"value":"b"},{"type":0,"value":" Cut \u201Cums\u201D and more with trim and stitch tools."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.engagement":[{"children":[{"type":0,"value":"Understand engagement."}],"type":8,"value":"b"},{"type":0,"value":" See who watched and for how long."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.loom.record":[{"children":[{"type":0,"value":"Record without limits."}],"type":8,"value":"b"},{"type":0,"value":" Create and share unlimited videos."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.confluence":[{"children":[{"type":0,"value":"Create docs instantly."}],"type":8,"value":"b"},{"type":0,"value":" Generate plans, roadmaps, and more with AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.jira":[{"children":[{"type":0,"value":"Turn plans into work."}],"type":8,"value":"b"},{"type":0,"value":" Create work items from docs using AI."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.loom":[{"children":[{"type":0,"value":"Align without meetings."}],"type":8,"value":"b"},{"type":0,"value":" Explain work or decisions with async video."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.features.twc.rovo":[{"children":[{"type":0,"value":"Put agents to work."}],"type":8,"value":"b"},{"type":0,"value":" Create AI agents to handle specific tasks."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-full-access":[{"type":0,"value":"You get full access to all "},{"children":[{"type":1,"value":"planName"},{"type":0,"value":" features"}],"type":8,"value":"link"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-refund":[{"type":0,"value":"You can request a refund within 30 days if you forget to cancel."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.bullet-reminder":[{"type":0,"value":"We\'ll remind you 3 days before your trial ends. Cancel anytime."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.how-trial-works.title":[{"type":0,"value":"How your trial works"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-date.label":[{"type":0,"value":"Next bill date"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.label":[{"type":0,"value":"Next bill estimate"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.next-bill-estimate.value":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"type":1,"value":"billingCycle"},{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.plan.label":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.label":[{"type":0,"value":"Rovo credits"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.rovo-credits.value":[{"type":1,"value":"quantity"},{"type":0,"value":" per user / month"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subscription-details.title":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.subtitle":[{"type":0,"value":"Your free "},{"children":[{"type":1,"value":"trialLength"},{"type":0,"value":" trial"}],"type":8,"value":"b"},{"type":0,"value":" has started. "},{"type":1,"value":"offeringName"},{"type":0,"value":" gives you unlimited users and advanced features that help you:"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.confluence":[{"type":0,"value":"Create and collaborate in one place"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jira":[{"type":0,"value":"Start building better workflows"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.jpd":[{"type":0,"value":"Discover your next great product idea"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.loom":[{"type":0,"value":"Align your team without extra meetings"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-manual-trial-optimization.title.twc":[{"type":0,"value":"Sync work across teams, all in one place"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.keep-work":[{"type":0,"value":"Keep all of your work if you change plans."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.refund":[{"type":0,"value":"Get a refund if you forget to cancel within 30 days."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.paid-trial-optimization.features.reminder":[{"type":0,"value":"We\'ll remind you 3 days before your trial ends. Cancel anytime."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.twc.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.partner.body.ubp5-enforcement":[{"type":0,"value":"During the trial, your customer can only use the allowances included in their subscription."}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-ccp.message-template.email.subject-new.partners":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cbps-description":[{"type":0,"value":"As part of the free trial, usage can\u2019t exceed the included quantity or allocation for each applicable usage type. Once the paid plan starts, extra usage will be allowed, and extra usage charges will be added to the invoice as required. "},{"children":[{"type":0,"value":"More about how billing works."}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-admin-button":[{"type":0,"value":"Add payment details"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.cta-user":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.downgrade-to-free":[{"type":0,"value":"Add your payment details by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" to continue using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" without any disruption. If you\u2019re under the user limit and don\u2019t add payment, you\u2019ll automatically switch to the Free plan at the end of your trial."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"As part of the free trial, users can only use up to 2,000 Rovo Dev credits. Rovo Dev functionality will be disabled for any user who reaches this usage. Once the paid plan starts, they\u2019ll be able to use more for USD\xa00.01 per extra Rovo Dev credit. To keep spending predictable, organization admins can adjust the usage limit or disable extra usage anytime in Atlassian Administration. You can view detailed usage in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.body.twc.trial-started":[{"type":0,"value":"Good news - you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":" - to start making the most of it, make sure you "},{"type":1,"value":"setUpCollectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.caption-new":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.cta-button":[{"type":0,"value":"Add payment details"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.heading":[{"type":0,"value":"Add payment details to keep your current features"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.intro":[{"type":0,"value":"Your team has been busy in "},{"type":1,"value":"productName"},{"type":0,"value":", and we want to make sure you have everything you need to keep moving forward."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan-consequence":[{"type":0,"value":"You won\'t be charged until your trial ends. If you don\'t add payment details, your site will automatically move to the "},{"type":1,"value":"productName"},{"type":0,"value":" Free plan."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.confluence-premium":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features like advanced permissions and analytics after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.confluence-standard":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features like audit logs and 250 GB of storage after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.generic":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.jira-premium":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features like advanced planning and unlimited automation after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.keep-plan.jira-standard":[{"type":0,"value":"To keep using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features like audit logs and increased user limits after your trial ends, add your payment details before "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.section-heading":[{"type":0,"value":"Stay on your current plan"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.subject":[{"type":0,"value":"You\'re currently using "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.subject.confluence":[{"type":0,"value":"You\'re using "},{"type":1,"value":"offeringName"},{"type":0,"value":" features, here\'s how to keep them \uD83D\uDCA1"}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.early-reverse-trial.trial-details":[{"type":0,"value":"When you signed up, we started you on a "},{"children":[{"type":1,"value":"trialLength"},{"type":0,"value":" trial"}],"type":8,"value":"b"},{"type":0,"value":" of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" so you could experience our most powerful features. Your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":"."}],"commerce.commerce-subscription-paid-trials-no-payment-method-ccp.message-template.email.subject-new":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.caption.grouped":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.plans.grouped":[{"type":0,"value":"If you decide "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for you \u2013 no problem. You can either cancel or change the plan from your account before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.preferences.grouped":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started. "}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.reactivation.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subject.grouped":[{"type":0,"value":"Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.subscription-details.grouped":[{"type":0,"value":"Your subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. To keep your subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.caption.grouped":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.email.body.info.grouped":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.plans.grouped":[{"type":0,"value":"If your customer decides "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" isn\u2019t for them, go to our Partner Purchasing Center and change the plan before the trial ends."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.subscription-details.grouped":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan at the end of the trial period. If your customer wants to keep the subscription on the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan, "},{"type":1,"value":"contactUs"},{"type":0,"value":" before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-auto-conversion-off-ccp.partner.message-template.email.trial-ends.grouped":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.commerce-subscription-reactivation-ccp-g.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you left them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.email.body.caption":[{"type":0,"value":"Your subscription is successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.email.body.welcome-back":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your subscription:"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.free.personal-information.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-data-information":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your data and preferences will be as you\\n\\t\\t\\t\\t\\t\\t\\t\\tleft them. You can jump right in and get started!"}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information-next":[{"type":0,"value":"If you\u2019ve already settled the outstanding amount, you\u2019re all set. If not, settling it immediately will ensure uninterrupted service and prevent any future deactivations."}],"commerce.commerce-subscription-reactivation-ccp.paid.personal-information.partner":[{"type":0,"value":"If you have reactivated your subscription within 60 days of cancellation, your customer\u2019s data and preferences will be as you left them."}],"commerce.commerce-subscription-reactivation-ccp.paid.what\'s-next":[{"type":0,"value":"What\u2019s next"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.caption":[{"type":0,"value":"Subscription trial successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription trial."}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.caption":[{"type":0,"value":"Subscription successfully reactivated"}],"commerce.commerce-subscription-reactivation-ccp.partner.trial.email.body.info":[{"type":0,"value":"Welcome back! As requested, we\u2019ve reactivated your customer\u2019s subscription."}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.subject.customerCompanyName":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"}],"commerce.commerce-subscription-reactivation-ccp.subject.email.partner.trial.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Welcome back to "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information":[{"type":0,"value":"When your trial ends, we\u2019ll charge your chosen payment method and send you an invoice within 24 hours."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next":[{"type":0,"value":"Your data and preferences are just as you left them, so jump right in and get started"}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information-next.partner":[{"type":0,"value":"Your customer\u2019s data and preferences are just as you left them."}],"commerce.commerce-subscription-reactivation-ccp.trial.personal-information.partner":[{"type":0,"value":"When the trial ends, we\u2019ll charge the chosen payment method and send an invoice within 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.caption":[{"type":0,"value":"We\'ve reactivated your subscriptions"}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.details":[{"type":0,"value":"Your data and preferences are just as you left them, so your team can jump back in straight away."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.body.intro":[{"type":0,"value":"As requested, we\'ve reactivated "},{"type":1,"value":"numOfReactivatedSubscriptions"},{"type":0,"value":" subscriptions in the last 24 hours."}],"commerce.commerce-subscription-reactivations-digest.message-template.email.subject":[{"type":0,"value":"Your daily reactivations"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure your service continues smoothly, we\'ve moved you back on your previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.manage-subscription-change-plan":[{"type":0,"value":"Go to Manage subscription, then Change plan. "}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.payment-details-up-to-date":[{"type":0,"value":"Make sure your payment details are up to date."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users you have exceeds the user limit allowed on your updated plan. You can do this by heading to your Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.change-your-plan":[{"type":0,"value":"To change your plan"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.could-not-process-payment":[{"type":0,"value":"We couldn\'t process payment for your invoice ("},{"type":1,"value":"invoiceNumber"},{"type":0,"value":") due to an issue with your payment details. To ensure service continues smoothly, we\'ve changed the subscription back to its previous plan."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.manage-subscription":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.update-plan":[{"type":0,"value":"You may need to remove users if the number of users exceeds the user limit allowed on the updated plan. You can do this from the Directory in Administration Hub."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.body.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.caption":[{"type":0,"value":"Your subscription has been changed"}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.manage-subscription":[{"type":0,"value":"Ensure the payment details are up to date then manage the subscription in Partner Purchasing Center."}],"commerce.commerce-subscription-rewind-uncollectible-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription changed"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-key":[{"type":0,"value":"Users:"}],"commerce.commerce-subscription-rewind-uncollectible.user-count-value":[{"type":1,"value":"users"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.direct-customer-whats-next":[{"type":0,"value":"You can use your current plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.accepted-request.nonpause-billing-accepted-request":[{"type":0,"value":"We\'ve accepted your request to move your subscription from monthly to annual (auto-renewal) plan, which will start at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.ecc":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.nonpause-billing-caption":[{"type":0,"value":"Let\u2019s take it to the next level"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.caption.partner":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.direct-customer-caption":[{"type":0,"value":"Scheduled changes to billing cycle"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-accepted-request":[{"type":0,"value":"You can use the current plan, but your partner would need to contact us for any modifications. "}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details":[{"children":[{"type":0,"value":"Subscription:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-details-billing-partner":[{"children":[{"type":0,"value":"Atlassian billing partner:"}],"type":8,"value":"bold"},{"type":0,"value":" "},{"type":1,"value":"billingPartner"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.ecc-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.nonpause-billing-current-plan":[{"type":0,"value":"We\u2019re glad you\u2019re enjoying your monthly "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-accepted-request":[{"type":0,"value":"The customer can continue with the existing plan, but you won\u2019t be able to make any changes. You\u2019ll need to "},{"type":1,"value":"contactLink"},{"type":0,"value":" for any modifications."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-subscription-moved":[{"type":0,"value":"The billing cycle for one of your customer\u2019s subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":". We\u2019ve also informed your customer about the change."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.partner-wont-billed":[{"type":0,"value":"Your customer won\'t be billed between the end of the current monthly billing cycle and the start of the annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-list":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"},{"type":1,"value":"siteUrlSeparator"},{"children":[{"type":1,"value":"siteUrl"}],"type":8,"value":"siteUrlLink"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.subscription-moved.direct-customer-subscription-moved":[{"type":0,"value":"The billing cycle for one of your subscriptions will be moved from monthly to annual on "},{"type":1,"value":"futureStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.email.wont-billed.direct-customer-wont-billed":[{"type":0,"value":"You won\'t be billed between the end of your current monthly billing cycle and the start of your annual billing."}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.ECC":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.direct":[{"type":0,"value":"Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.nonpause-billing":[{"type":0,"value":"Enjoy your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-scheduled-cycle-change-paid-to-paid-ccp.message-template.email.subject.partner":[{"type":0,"value":"["},{"type":1,"value":"customerName"},{"type":0,"value":"]: Billing cycle change scheduled"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.caption":[{"type":0,"value":"Your billing frequency will soon be changed"}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.contact-us":[{"type":0,"value":"If you have any questions concerning this change, please contact us."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.request-to-change-bill-freq":[{"type":0,"value":"We received a request to change the billing frequency for your Statuspage subscription "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.email.when-will-cycle-change":[{"type":0,"value":"We\u2019ll change your "},{"type":1,"value":"oldBillingCycleName"},{"type":0,"value":" subscription to "},{"type":1,"value":"newBillingCycleName"},{"type":0,"value":" subscription at the end of your current billing cycle."}],"commerce.commerce-subscription-scheduled-cycle-change-sp-ccp.message-template.email.subject":[{"type":0,"value":"Your request to change your billing frequency"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp-g.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direcct-customer.view-subscription":[{"type":0,"value":"You can view or cancel your subscription at any time from your site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"type":1,"value":"billingUrlLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.direct.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be reflected on your next bill."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.email.dc.ubp-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.email.partner.ubp-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.direct-customer.subject":[{"type":0,"value":"You\u2019re scheduled for "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcHomePage"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.ppc-url":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.message-template.email.partner.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is scheduled for "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.change-subscription":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-scheduled-downgrade-ccp.partner.email.body.subscription-downgraded-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is scheduled to move to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from the previous plan will be reflected on the next bill."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.caption":[{"type":0,"value":"Welcome to the "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":" plan for "},{"type":1,"value":"productName"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.charge-chosen-payment-method":[{"type":0,"value":"We\'ll charge your chosen payment method within 24 hours and send you a payment confirmation along with your invoice"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.caption":[{"type":0,"value":"Welcome to your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision":[{"type":0,"value":"If you decide that this isn\u2019t for you, "},{"type":1,"value":"content"},{"type":0,"value":" "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-multiple-offering":[{"type":0,"value":"you can change your plan from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.decision.has-single-offering":[{"type":0,"value":"you can cancel anytime from"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.direct-customer.great-news":[{"type":0,"value":"Great news \u2014 your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.great-news":[{"type":0,"value":"Great news - you\u2019re now on a "},{"type":1,"value":"newPricingPlanName"},{"type":0,"value":", "},{"type":1,"value":"productName"},{"type":0,"value":" subscription ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.how-addon-billed":[{"type":0,"value":"Find out more about "},{"type":1,"value":"manageAddonLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.manage-addon-link":[{"type":0,"value":"how add-ons are billed"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.on-pricing-plan":[{"type":0,"value":" on "},{"type":1,"value":"newPricingPlan"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.atlassian-admin-link":[{"type":0,"value":"admin.atlassian.com/billing/partner-managed-subscriptions"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.caption":[{"type":0,"value":"Welcome to "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision":[{"type":0,"value":"If your customer decides this isn\u2019t for them, they can "},{"type":1,"value":"content"},{"type":0,"value":" at any time from "},{"type":1,"value":"atlassianAdminLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-multiple-offering":[{"type":0,"value":"change their plan"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.decision.has-single-offering":[{"type":0,"value":"cancel the subscription"}],"commerce.commerce-subscription-skip-trial-ccp.email.body.partner.great-news":[{"type":0,"value":"Great news \u2014 "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" subscription"},{"type":1,"value":"companyName"},{"type":0,"value":" is now up and running. Here are the details:"}],"commerce.commerce-subscription-skip-trial-ccp.personal-information":[{"type":0,"value":"Remember - your invoice contains personal information such as your address and other billing admin details, so you should only share it with trusted sources."}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.body":[{"type":0,"value":"We\'re confirming your choice to move to automatic renewals of your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"count"},{"type":0,"value":". That means your team won\'t lose access to their tools and you won\'t have to spend time manually renewing each year."}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.change-renewal-settings":[{"type":0,"value":"You can change your renewal settings at any time by "},{"type":1,"value":"contactingSupport"},{"type":0,"value":"."}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.contacting-support":[{"type":0,"value":"contacting support"}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.contextual-info.billing-cycle":[{"type":0,"value":"Billing cycle: "},{"type":1,"value":"billingCycle"}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.contextual-info.next-renewal":[{"type":0,"value":"Next automatic renewal: "},{"type":1,"value":"renewalDate"}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.contextual-info.plan-name":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.heading":[{"type":0,"value":"Your annual "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"subscription"}]},"other":{"value":[{"type":0,"value":"subscriptions"}]}},"pluralType":"cardinal","type":6,"value":"count"},{"type":0,"value":" will now automatically renew"}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.subject":[{"type":0,"value":"Your annual renewal settings have updated"}],"commerce.commerce-subscription-switched-termed-to-auto-renew-ccp.message-template.email.subscription-details-heading":[{"type":0,"value":"Subscription details"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan":[{"type":0,"value":"Change plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.change-plan-and-upgrade":[{"type":0,"value":" and upgrade your subscription. Don\u2019t forget to add your payment details so you can use "},{"type":1,"value":"productName"},{"type":0,"value":" without any interruptions."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.manage-subscription-button":[{"type":0,"value":"Manage subscription"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.no-payment-info":[{"type":0,"value":"Since we dont have your complete billing information, we moved you to the Free plan. You can continue using "},{"type":1,"value":"productName"},{"type":0,"value":" but with limited features."}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.product-info":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" ("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription is now on the Free plan"}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.to-get-back-go-to":[{"type":0,"value":"Want to go back on the "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" plan? Select "}],"commerce.commerce-subscription-systematic-downgrade-ccp.message-template.email.trial-has-ended":[{"type":0,"value":"Your "},{"type":1,"value":"oldPricingPlanName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" has ended. We hope you enjoyed it!"}],"commerce.commerce-subscription-transferred-ccp-g.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.can-now-manage":[{"type":0,"value":"You can now manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.direct-customer.transferred-to-billing-account.uninterrupted-service":[{"type":0,"value":"To ensure uninterrupted access to your subscriptions, add your payment details before your bill end date."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can view and cancel the subscription by going to "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-from-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.direct-customer.transferred-to-billing-account":[{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-from-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription removed from billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.subject.partner.transferred-to-billing-account":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" subscription added to your billing account"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.can-not-manage":[{"type":0,"value":"You can no longer manage this subscription \u2014 or access quotes, orders, and invoices \u2014 from "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":". However, all the invoices up to the date of transfer are still available."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.caption":[{"type":0,"value":"Subscription removed from billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.product-transferred-info":[{"type":0,"value":"If you had any other product and subscriptions on the same site that belonged to the same product family,\\n\\t\\t\\tthey need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-from-billing-account.transferred":[{"type":0,"value":"We\'ve successfully transferred the requested subscription from your Billing Account, "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.caption":[{"type":0,"value":"Subscription added to your billing account"}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.product-transferred-info":[{"type":0,"value":"If the billing account "},{"type":1,"value":"transferredFromBillingAccountName"},{"type":0,"value":" had any other product and subscriptions on the same site that belonged to the same product family, they need to be billed together. That means we\u2019ve transferred them too."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-billing-account.transferred":[{"type":0,"value":"We\u2019ve successfully transferred the requested subscription to your Billing Account, "},{"type":1,"value":"transferredToBillingAccountName"},{"type":0,"value":"."}],"commerce.commerce-subscription-transferred-ccp.message-template.email.transferred-to-customer-billing-account.caption":[{"type":0,"value":"Subscription transferred to your billing account"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp-g.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.trial-ended-message":[{"type":0,"value":"We hope you enjoyed your free trial of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":". Your paid plan has now started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge you for your "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.direct.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" free trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.partner.subscription-includes":[{"type":0,"value":"The subscription also includes the following:"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credit-usage":[{"type":0,"value":"Rovo Dev credit usage"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to your next invoice. Don\u2019t worry \u2014 we\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. You can view usage details in your billing account. "},{"children":[{"type":0,"value":"More about Rovo Dev billing"}],"type":8,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.body.rovo-dev-credits-usage-details-partner":[{"type":0,"value":"Each month, any usage over the allocated amount will be billed at USD\xa00.01 per extra Rovo Dev credit, which will be added to the next invoice. We\u2019ve set an extra usage limit of 2,000 Rovo Dev credits per user, which means extra usage charges per user is currently limited to USD 20 (unless it\u2019s already been adjusted). To keep spending predictable, organization admins can adjust this limit or disable extra usage anytime in Atlassian Administration. "}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.one.description":[{"type":0,"value":"Bundle Confluence with Jira, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.row.two.description":[{"type":0,"value":"Pay less for all four apps than you currently pay for Confluence"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-decrease.title":[{"type":0,"value":"Want to pay less for Confluence?"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.description":[{"type":0,"value":"to make sure AI is as useful as it can be"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.three.title":[{"type":0,"value":"More context"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.description":[{"type":0,"value":"to instantly create more pages and whiteboards"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.confluence-price-increase.title":[{"type":0,"value":"Take your pages to the next level"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.cta.explore":[{"type":0,"value":"Explore Teamwork collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.cta.see-pricing":[{"type":0,"value":"See pricing"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.one.description":[{"type":0,"value":"Bundle Jira with Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.row.two.description":[{"type":0,"value":"Pay less for all four apps than you currently pay for Jira"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-decrease.title":[{"type":0,"value":"Want to pay less for Jira?"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.three.description":[{"type":0,"value":"to instantly create work in bulk"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.three.title":[{"type":0,"value":"More agents"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.two.description":[{"type":0,"value":"to automatically triage more work"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.jira-price-increase.title":[{"type":0,"value":"Take your projects to the next level"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.description":[{"type":0,"value":"of apps, Jira, Confluence, Loom, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.one.title":[{"type":0,"value":"One collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.description":[{"type":0,"value":"for less than you think"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.three.title":[{"type":0,"value":"All in one place"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.description":[{"type":0,"value":"to easily connect Loom with your other tools"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.row.two.title":[{"type":0,"value":"More AI credits"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business-and-ai.title":[{"type":0,"value":"Get more from Loom with the full collection"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.one.title":[{"type":0,"value":"Bundle Loom with Jira, Confluence, and Rovo"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.three.title":[{"type":0,"value":"Switch back anytime"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.row.two.title":[{"type":0,"value":"Pay less for all four apps than you currently pay for Loom"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.email.twc-offer.loom-business.title":[{"type":0,"value":"Want to pay less for Loom?"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.trial-ended-message":[{"type":0,"value":"The free "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended, and the paid period has started from "},{"type":1,"value":"billingStartDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.body.we-will-charge-you":[{"type":0,"value":"We\u2019ll charge the chosen payment method and send you an invoice soon, along with the payment confirmation."}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.caption.upsell-twc":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan is active"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-free-to-paid-ccp.message-template.partner.email.subject.without-company-name":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Free "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial has ended"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.moved-back-old-plan":[{"type":0,"value":"The subscription will be moved back to the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan. You don\'t have to pay any additional charges for the trial period used as we continued your billing per your "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan while on trial. If you were initially on the Free plan, you won\'t be charged anything. "}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.email.subscription-opted-out-from-to":[{"type":0,"value":"As requested, we\'ve ended the no-cost "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial of the following product:"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"If needed, you can always restart the trial from our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-opt-out-ccp.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" trial ended on request"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.trial-ended-message":[{"type":0,"value":"The no-cost "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan trial for the following product has ended."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.upgrade-offering-message":[{"type":0,"value":"The subscription is now upgraded from a "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" paid plan to a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" paid plan:"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.view-subscription":[{"type":0,"value":"To view the subscription, visit our "},{"type":1,"value":"ppcSubscriptionLink"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.body.we-will-charge-message":[{"type":0,"value":"We\u2019ll charge you for a "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan and send you an invoice within 24 hours along with the payment confirmation. You may first be charged a prorated amount to align your bill date with your previous plan. Any remaining days of the "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" plan will be adjusted as credits in your invoice."}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" paid plan has started"}],"commerce.commerce-subscription-trial-ended-paid-to-paid-ccp.message-template.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" - "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": No cost "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"fromOfferingName"},{"type":0,"value":" trial period has ended"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.ba-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.bu-add-payment":[{"type":0,"value":"For a seamless transition when your trial ends, your billing admin will need to add payment details before "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":". "}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.cancel":[{"type":0,"value":"If you decide this isn\u2019t for you, you can cancel your subscription before your trial ends by logging in to your account."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial has started"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.on-trial":[{"type":0,"value":"Good news \u2014 you\'re now on a free "},{"type":1,"value":"trialLength"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offering"},{"type":0,"value":" trial. Your trial ends on "},{"type":1,"value":"trialEndDateBold"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.commerce-subscription-trial-started-digest.message-template.email.body.trial-auto-convert":[{"type":0,"value":"Your trial will be automatically converted to the paid plan once your trial ends."}],"commerce.commerce-subscription-trial-started-digest.message-template.email.subject":[{"type":0,"value":"Your new "},{"type":1,"value":"productName"},{"type":0,"value":" trial"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.lets-make-it-official":[{"type":0,"value":"Let\u2019s make it official"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.caption.time-flies":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is coming to an end"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.comparison-image-alt.twc-end-of-trial":[{"type":0,"value":"Comparison between "},{"type":1,"value":"offeringName"},{"type":0,"value":" and Free plans"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.content-safe.twc-end-of-trial-no-pde":[{"type":0,"value":"Your content, work items, and files stay safe. Only the paid features change."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.cross-flow-comparison-image-alt.twc-end-of-trial":[{"type":0,"value":"Comparison between your previous plan and Teamwork Collection"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.details.billing-cycle.twc-end-of-trial-with-pde":[{"type":0,"value":"Billing cycle"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.details.first-bill-estimate-value.twc-end-of-trial-with-pde":[{"type":1,"value":"amount"},{"type":0,"value":" "},{"options":{"Annual":{"value":[{"type":0,"value":"yearly "}]},"Monthly":{"value":[{"type":0,"value":"monthly "}]},"other":{"value":[]}},"type":5,"value":"billingCycle"},{"type":0,"value":"(excluding taxes)"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.details.first-bill-estimate.twc-end-of-trial-with-pde":[{"type":0,"value":"First bill estimate"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.details.plan.twc-end-of-trial-with-pde":[{"type":0,"value":"Plan"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.details.trial-ends.twc-end-of-trial-with-pde":[{"type":0,"value":"Trial ends"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.add-payment":[{"type":0,"value":"If you want to continue with the paid plan, you\u2019ll need to add payment details before "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion":[{"type":0,"value":"If you want to continue, you don\u2019t need to do anything. When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off":[{"type":0,"value":"Your subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"You\u2019ll be moved back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.change-or-cancel-plan":[{"type":0,"value":"You can change or cancel your subscription before your trial ends by going to "},{"type":1,"value":"changePlanLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, we\u2019ll move you to the Free plan \u2014 as long as you meet the user limit requirements. If not, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.downgrade-or-deactivate-if-payment-not-added-v2":[{"type":0,"value":"If you don\u2019t add your payment details before your trial ends, we\u2019ll move you to the Free plan \u2014 as long as you meet the limit requirements. If not, your subscription will be deactivated."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.extend-trial":[{"type":0,"value":"If you\u2019d like to extend your trial, you\u2019ll need to contact us at "},{"type":1,"value":"salesOpsSupportEmail"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your trial ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.scheduled-for-cancellation":[{"type":0,"value":"You can undo the cancellation by "},{"type":1,"value":"contactingUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.direct-customer.body.trial-will-end-twc":[{"type":0,"value":"We hope you\'re enjoying your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial and your team\'s making the most of the increased collaboration."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.explore-all-plans.twc-end-of-trial":[{"type":0,"value":"Explore all plans"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.feature.admin-controls.twc-end-of-trial-with-pde":[{"children":[{"type":0,"value":"Advanced admin controls."}],"type":8,"value":"b"},{"type":0,"value":" Keep tracking usage and security insights in one place."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.feature.advanced-planning.twc-standard-to-premium-end-of-trial-with-pde":[{"children":[{"type":0,"value":"Advanced Planning."}],"type":8,"value":"b"},{"type":0,"value":" Track dependencies across teams and manage complex projects with ease."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.feature.atlassian-guard.twc-end-of-trial-with-pde":[{"children":[{"type":0,"value":"Atlassian Guard."}],"type":8,"value":"b"},{"type":0,"value":" Maintain advanced data discovery and classification to protect sensitive information."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.feature.atlassian-guard.twc-standard-to-premium-end-of-trial-with-pde":[{"children":[{"type":0,"value":"Atlassian Guard."}],"type":8,"value":"b"},{"type":0,"value":" Maintain advanced cloud security and SSO."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.feature.loom-ai.twc-standard-to-premium-end-of-trial-with-pde":[{"children":[{"type":0,"value":"Loom AI."}],"type":8,"value":"b"},{"type":0,"value":" Save time with auto-generated summaries, easy edits, and action items."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.feature.permissions.twc-end-of-trial-with-pde":[{"children":[{"type":0,"value":"User permissions."}],"type":8,"value":"b"},{"type":0,"value":" Maintain control over who can access and edit your workspace content."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.feature.rovo.twc-end-of-trial-with-pde":[{"children":[{"type":0,"value":"Rovo AI."}],"type":8,"value":"b"},{"type":0,"value":" Keep using AI agents and chat to find information and automate tasks."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.feature.users.twc-end-of-trial-with-pde":[{"children":[{"type":0,"value":"Unlimited users."}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.features-heading.twc-end-of-trial-with-pde":[{"type":0,"value":"Your features include"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.features.your-features-include":[{"children":[{"type":0,"value":"Your features include:"}],"type":8,"value":"b"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.header-alt.twc-end-of-trial":[{"type":0,"value":"Teamwork Collection"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.end-of-trial-with-pde":[{"type":0,"value":"Your subscription begins on "},{"type":1,"value":"subscriptionStartDate"},{"type":0,"value":". Learn about your plan\u2019s features and see what they can do for you."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.twc-end-of-trial-no-pde":[{"type":0,"value":"Your "},{"type":1,"value":"offeringName"},{"type":0,"value":" "},{"children":[{"type":0,"value":"trial ends in "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysLeft"},{"type":0,"value":","}],"type":8,"value":"b"},{"type":0,"value":" on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":". Add payment details to stay on "},{"type":1,"value":"offeringName"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.twc-end-of-trial-no-pde-no-offering":[{"type":0,"value":"Your "},{"children":[{"type":0,"value":"trial ends in "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysLeft"},{"type":0,"value":","}],"type":8,"value":"b"},{"type":0,"value":" on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":". Add payment details to stay on your plan."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-body.twc-end-of-trial-with-pde":[{"type":0,"value":"Your subscription begins on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":". Explore the "},{"type":1,"value":"offeringName"},{"type":0,"value":" features you\u2019re keeping and what they can do for you."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.end-of-trial-with-pde":[{"type":0,"value":"Ready for your next chapter?"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.twc-end-of-trial-no-pde":[{"type":0,"value":"Keep what\u2019s working for your team"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.headline-caption.twc-end-of-trial-with-pde":[{"type":0,"value":"Ready for your next chapter?"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.keep-plan.twc-end-of-trial-no-pde":[{"type":0,"value":"Keep "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.loss.admin.twc-end-of-trial-no-pde":[{"children":[{"type":0,"value":"Advanced admin security"}],"type":8,"value":"b"},{"type":0,"value":" is no longer available"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.loss.meeting-recaps.twc-end-of-trial-no-pde":[{"children":[{"type":0,"value":"Automatic meeting recaps"}],"type":8,"value":"b"},{"type":0,"value":" are removed, so your team will need to take notes manually"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.loss.permissions.twc-end-of-trial-no-pde":[{"children":[{"type":0,"value":"Open access."}],"type":8,"value":"b"},{"type":0,"value":" Everyone in your workspace can see all content"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.loss.rovo.twc-end-of-trial-no-pde":[{"children":[{"type":0,"value":"Rovo AI tools"}],"type":8,"value":"b"},{"type":0,"value":" are turned off"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.loss.users.twc-end-of-trial-no-pde":[{"children":[{"type":0,"value":"User limit"}],"type":8,"value":"b"},{"type":0,"value":" drops from unlimited to "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" person"}]},"other":{"value":[{"type":7},{"type":0,"value":" people"}]}},"pluralType":"cardinal","type":6,"value":"freeUserLimit"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.multi-app-comparison-image-alt.twc-end-of-trial":[{"type":0,"value":"Comparison between separate apps and Teamwork Collection"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.no-action-body.twc-end-of-trial-with-pde":[{"type":0,"value":"When your trial ends we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.no-action-heading.twc-end-of-trial-with-pde":[{"type":0,"value":"You don\u2019t need to do anything"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.not-charged.twc-end-of-trial-no-pde":[{"type":0,"value":"You won\u2019t be charged until "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off":[{"type":0,"value":"When the trial ends, the subscription will be deactivated. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-off-upgrade-trial":[{"type":0,"value":"The subscription will move back to the "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" plan. "}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.auto-conversion-upgrade-trial":[{"type":0,"value":"If your customer wants to continue on this plan, you don\u2019t need to do anything. When the trial ends, the subscription will be moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan and charged on the next bill date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.deactivate-if-payment-not-added":[{"type":0,"value":"To continue, add payment details (if you haven\u2019t already) before your trial ends to avoid deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.downgrade-or-deactivate-if-payment-not-added":[{"type":0,"value":"To continue with the paid plan, add payment details (if you haven\u2019t already) before your trial ends to avoid downgrading to the Free plan or deactivation."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.extend-trial":[{"type":0,"value":"To extend the trial, "},{"type":1,"value":"reachOutTous"},{"type":0,"value":" before the trial end date. You may also request a quote, valid until the trial expiry date."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reach-out-to-us":[{"type":0,"value":"reach out to us"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.reminder-trial-ending":[{"type":0,"value":"Heads up \u2014 your customer\'s "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial for "},{"type":1,"value":"productName"},{"type":0,"value":" ends on "},{"type":1,"value":"trialEndDate"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.partner.body.scheduled-for-cancellation":[{"type":0,"value":"The trial is scheduled for cancellation. If your customer wants to undo the cancellation, "},{"type":1,"value":"contactUs"},{"type":0,"value":"."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.refund.twc-end-of-trial-no-pde":[{"type":0,"value":"If "},{"type":1,"value":"offeringName"},{"type":0,"value":" isn\u2019t right for you, cancel within 30 days of your first bill for a full refund."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.refund.twc-end-of-trial-no-pde-no-offering":[{"type":0,"value":"If this plan isn\u2019t right for you, cancel within 30 days of your first bill for a full refund."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.standard-to-premium-comparison-image-alt.twc-end-of-trial":[{"type":0,"value":"Comparison between Standard and Premium plans"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.add-payment":[{"type":0,"value":"Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.end-of-trial-with-pde":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup":[{"type":0,"value":"Payment required to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.mpucup.no-product-name":[{"type":0,"value":"Payment required to keep your subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.add-payment":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": Add payment details before "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.partner.trial-ends-soon":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]},"yes":{"value":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":": "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}]}},"type":5,"value":"hasCustomerCompanyName"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.trial-ends-soon":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial ends soon"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.twc-end-of-trial-no-pde":[{"type":0,"value":"Your Teamwork Collection trial is ending. Add payment details to keep "},{"type":1,"value":"offeringName"},{"type":0,"value":" features"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.twc-end-of-trial-no-pde-no-offering":[{"type":0,"value":"Your Teamwork Collection trial is ending. Add payment details to keep your features"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.subject.twc-end-of-trial-with-pde":[{"type":0,"value":"Your Teamwork Collection trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.switch-plans.twc-end-of-trial-with-pde":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" If "},{"type":1,"value":"offeringName"},{"type":0,"value":" isn\u2019t right for you, cancel within 30 days of your first bill for a full refund."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.switch-plans.twc-end-of-trial-with-pde-no-offering":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" If this plan isn\u2019t right for you, cancel within 30 days of your first bill for a full refund."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.title":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.title.twc-end-of-trial":[{"type":0,"value":"Your Teamwork Collection trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.what-happens-body.twc-end-of-trial-no-pde":[{"type":0,"value":"On "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", your team moves to the Free plan."}],"commerce.commerce-subscription-trial-will-end-ccp.message-template.email.what-happens-heading.twc-end-of-trial-no-pde":[{"type":0,"value":"What happens if I don\'t add payment details?"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.add-payment-details-before-trial-ends":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your users and features. If you don\'t add payment details or reduce your user count to 10 or fewer by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" and your data will be permanently deleted."}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.add-payment-details-before-trial-ends-within-limit":[{"type":0,"value":"Add payment details before your trial ends on "},{"children":[{"type":1,"value":"trialEndDate"}],"type":8,"value":"b"},{"type":0,"value":" to keep all your features. If you don\'t add payment details by "},{"type":1,"value":"trialEndDate"},{"type":0,"value":", you will lose access to "},{"type":1,"value":"productName"},{"type":0,"value":" Standard."}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.caption":[{"type":0,"value":"Add payment details to keep your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.what-you-need-to-do":[{"type":0,"value":"What you need to do"}],"commerce.commerce-subscription-trial-will-end-ccp.mpucup.email.your-trial-ends-in-days":[{"type":0,"value":"Your free "},{"type":1,"value":"productName"},{"type":0,"value":" Standard trial ends in "},{"children":[{"type":0,"value":"3 days"}],"type":8,"value":"b"},{"type":0,"value":". Add payment details now to ensure your team has uninterrupted access."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.billing-heading.auto-conversion":[{"type":0,"value":"You don\u2019t need to do anything"}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.billing.auto-conversion":[{"type":0,"value":"When your trial ends we\u2019ll charge the payment method you chose when you signed up."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.comparison.confluence":[{"type":0,"value":"Confluence plan comparison. Premium includes analytics, 24/7 support, team calendars, admin key, and admin insights. These features are not included in Standard."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.comparison.jira":[{"type":0,"value":"Jira plan comparison. Premium includes advanced planning, 24/7 support, project archiving, admin key, and unlimited storage. These features are not included in Standard."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.comparison.jpd":[{"type":0,"value":"Jira Product Discovery plan comparison. Premium includes advanced planning, 24/7 support, custom permissions, sandboxes, and release tracks. These features are not included in Standard."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.comparison.loom":[{"type":0,"value":"Loom plan comparison. Business + AI includes AI features, admin insights, meeting notes, advanced editing, and automation. These features are not included in Business."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.comparison.servco":[{"type":0,"value":"Service Collection plan comparison. Premium includes automated approvals, alert grouping, more object syncing, instant PIRs, and 24/7 support. These features are not included in Standard."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.excluding-taxes":[{"type":0,"value":" (excluding taxes)"}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.explore-all-plans":[{"type":0,"value":"Explore all plans"}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.explore-features":[{"type":0,"value":"Explore features"}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features-heading":[{"type":0,"value":"Your features include"}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.admin-insights":[{"children":[{"type":0,"value":"Admin insights."}],"type":8,"value":"strong"},{"type":0,"value":" Track usage and top users."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.advanced-planning":[{"children":[{"type":0,"value":"Advanced planning."}],"type":8,"value":"strong"},{"type":0,"value":" Plan dependencies across teams."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.ai-features":[{"children":[{"type":0,"value":"AI features."}],"type":8,"value":"strong"},{"type":0,"value":" Edit and improve videos fast."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.alert-grouping":[{"children":[{"type":0,"value":"Alert Grouping."}],"type":8,"value":"strong"},{"type":0,"value":" Prevent alert fatigue."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.analytics":[{"children":[{"type":0,"value":"Analytics."}],"type":8,"value":"strong"},{"type":0,"value":" Track engagement and trends."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.automated-approvals":[{"children":[{"type":0,"value":"Automated approvals."}],"type":8,"value":"strong"},{"type":0,"value":" Speed up low risk changes."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.instant-pirs":[{"children":[{"type":0,"value":"Instant PIRs."}],"type":8,"value":"strong"},{"type":0,"value":" Accelerate resolution with summaries."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.project-archiving":[{"children":[{"type":0,"value":"Project archiving."}],"type":8,"value":"strong"},{"type":0,"value":" Preserve and hide unused spaces."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.sandboxes":[{"children":[{"type":0,"value":"Sandboxes."}],"type":8,"value":"strong"},{"type":0,"value":" Test changes in isolated staging."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.support":[{"children":[{"type":0,"value":"24/7 support."}],"type":8,"value":"strong"},{"type":0,"value":" 1 hr responses for critical issues."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.features.team-calendars":[{"children":[{"type":0,"value":"Team calendars."}],"type":8,"value":"strong"},{"type":0,"value":" Plan timelines and capacity."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.heading":[{"type":0,"value":"Ready for your next chapter?"}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.intro.auto-conversion":[{"type":0,"value":"Your subscription begins on "},{"type":1,"value":"date"},{"type":0,"value":". Explore the "},{"type":1,"value":"offeringName"},{"type":0,"value":" features you\u2019re keeping and what they can do for you."}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" trial is ending"}],"commerce.commerce-subscription-trial-will-end-ccp.s2p.switch-plans-anytime":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"strong"},{"type":0,"value":" If "},{"type":1,"value":"planName"},{"type":0,"value":" isn\u2019t right for you, cancel within 30 days of your first bill for a full refund."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.add-payment-details":[{"type":0,"value":"We noticed that we don\'t have your payment details on file. Add payment details before the renewal date to avoid any disruptions to your subscription."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.caption":[{"type":0,"value":"Your upcoming renewal"}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.payment-method-charged":[{"type":0,"value":"We\u2019ll charge your chosen payment method at this time. If you want to use a different payment method, update your details before the renewal date."}],"commerce.commerce-subscription-upcoming-renewal-ccp.email.renewal-reminder":[{"type":0,"value":"This is a friendly reminder that your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription will renew on "},{"type":1,"value":"renewalDate"},{"type":0,"value":". Here are the details:"}],"commerce.commerce-subscription-upcoming-renewal-ccp.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription renews soon"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp-g.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp-g.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.direct.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to your existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.direct.message-template.email.subject":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" plan has been upgraded"}],"commerce.commerce-subscription-upgrade-ccp.email.dc.ubp-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill each month. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-ccp.email.partner.ubp-enforcement":[{"type":0,"value":"Remember, if your customer exceeds their allowance for their plan, extra usage charges will be added to their next invoice. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.caption":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-ccp.partner.email.body.subscription-upgrade-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"oldOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan. Any extra usage from your previous plan will be charged to the existing payment method."}],"commerce.commerce-subscription-upgrade-ccp.partner.message-template.email.subject":[{"type":1,"value":"companyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if you go over the included quantity or allowance for any of the usage types on your subscription, extra usage charges will be added to your next invoice. Organization admins can set and adjust usage limits anytime."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your customer goes over the included quantity or allowance for any of the usage types on the subscription, extra usage charges will be added to their next invoice. You can set and adjust usage limits anytime."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp-g.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.info-message":[{"type":0,"value":"As requested, your "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered-billing":[{"type":0,"value":"Remember, you can only use up to the included quantity for each quota type. If you want a higher included quantity or the option to use extra, you\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if you go over the included quantity for any of the quota types on your subscription, extra usage charges will be added to your next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.dc.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, if your organization admin has enabled extra usage, any usage above the allowance may incur extra usage charges, which will be added to your bill at the end of your bill cycle. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.info-message":[{"type":0,"value":"As requested, your customer\u2019s "},{"type":1,"value":"previousOfferingName"},{"type":0,"value":" "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered-billing":[{"type":0,"value":"Remember, if your customer wants a higher included quantity, or wants the option to use extra, they\u2019ll need to upgrade to a paid plan."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.email.partner.metered.upgrade-trial-opt-out.ubp5-enforcement":[{"type":0,"value":"Remember, any usage above the allowance may incur extra usage charges, which will be added to your customer\'s bill at the end of the bill cycle. Organization admins can set and adjust usage limits anytime. "},{"children":[{"type":0,"value":"Find out more about usage charges and billing"}],"type":8,"value":"UsageChargesAndBillingLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.caption":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.dc.email.subject":[{"type":0,"value":"You\u2019re now on "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.email.partner.body.change-subscription":[{"type":0,"value":"Change the subscription by visiting the "},{"type":1,"value":"ppcSubscriptionsPageLink"},{"type":0,"value":"."}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.caption":[{"type":1,"value":"productName"},{"type":0,"value":" subscription has moved to the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-subscription-upgrade-trial-opt-out-ccp.message-template.partner.email.subject":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":" "},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" is now on the "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"commerce.commerce-to-all-everyone-on-initiative-published.message-template.email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Congratulations "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.commerce-to-all-everyone-on-initiative-published.message-template.email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.commerce-to-all-everyone-on-initiative-published.message-template.email.message-template.email.body.reminder":[{"type":0,"value":"Your initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":") has been successfully released. You can see your released initiatives in Workbench"}],"commerce.commerce-to-all-everyone-on-initiative-published.message-template.email.message-template.email.initiative.link":[{"type":0,"value":"Your initiatives"}],"commerce.commerce-to-all-everyone-on-initiative-published.message-template.email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.commerce-to-all-everyone-on-initiative-published.message-template.email.message-template.email.subject.no-translate":[{"type":0,"value":"Your initiative has been released"}],"commerce.commerce-to-all-everyone-on-initiative-published.message-template.email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.commerce-trial-extension-ad.created-date-bold.key":[{"type":0,"value":"Created date: "}],"commerce.commerce-trial-extension-ad.created-date-value":[{"type":1,"value":"createdDate"}],"commerce.commerce-trial-extension-ad.created-date.key":[{"type":1,"value":"createdDateKey"}],"commerce.commerce-trial-extension-ad.email.approved":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has approved the request."}],"commerce.commerce-trial-extension-ad.email.caption":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.email.declined":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has declined the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.default":[{"type":0,"value":"Your request for a trial extension has been received and is being processed."}],"commerce.commerce-trial-extension-ad.email.in-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" is the assignee of the approval request."}],"commerce.commerce-trial-extension-ad.email.reasons-provided":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has provided supporting reasons."}],"commerce.commerce-trial-extension-ad.email.reasons-requested":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has requested supporting reasons."}],"commerce.commerce-trial-extension-ad.email.request-cancelled":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has cancelled the request. The request us now closed."}],"commerce.commerce-trial-extension-ad.email.waiting-for-review":[{"type":1,"value":"initiatorName"},{"type":0,"value":" has submitted a new Trial Extension request."}],"commerce.commerce-trial-extension-ad.initiator-id-bold.key":[{"type":0,"value":"Initiator: "}],"commerce.commerce-trial-extension-ad.initiator-id-value":[{"type":1,"value":"initiator"}],"commerce.commerce-trial-extension-ad.initiator-id.key":[{"type":1,"value":"initiatorKey"}],"commerce.commerce-trial-extension-ad.message-template.email.subject":[{"type":0,"value":"Trial Extension "},{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id-bold.key":[{"type":0,"value":"Request ID: "}],"commerce.commerce-trial-extension-ad.request-id-value":[{"type":1,"value":"requestId"}],"commerce.commerce-trial-extension-ad.request-id.key":[{"type":1,"value":"requestIdKey"}],"commerce.commerce-trial-extension-ad.status-bold.key":[{"type":0,"value":"Status: "}],"commerce.commerce-trial-extension-ad.status-value":[{"type":1,"value":"status"}],"commerce.commerce-trial-extension-ad.status.key":[{"type":1,"value":"statusKey"}],"commerce.commerce-trial-extension-ad.subscription-bold.key":[{"type":0,"value":"Subscription: "}],"commerce.commerce-trial-extension-ad.subscription-value":[{"type":1,"value":"entitlementNumber"}],"commerce.commerce-trial-extension-ad.subscription.key":[{"type":1,"value":"subscriptionKey"}],"commerce.commerce-trial-extension-ad.support-ticket-id-bold.key":[{"type":0,"value":"Support Ticket: "}],"commerce.commerce-trial-extension-ad.support-ticket-id-value":[{"type":1,"value":"supportTicket"}],"commerce.commerce-trial-extension-ad.support-ticket-id.key":[{"type":1,"value":"supportTicketKey"}],"commerce.commerce-trial-extension-ad.total-trial-length-bold.key":[{"type":0,"value":"Total days on trial so far: "}],"commerce.commerce-trial-extension-ad.total-trial-length-value":[{"type":1,"value":"currentTotalTrialLength"}],"commerce.commerce-trial-extension-ad.total-trial-length.key":[{"type":1,"value":"totalTrialLengthKey"}],"commerce.commerce-trial-extension-ad.trial-length-bold.key":[{"type":0,"value":"Request: "}],"commerce.commerce-trial-extension-ad.trial-length-value":[{"type":0,"value":"Extend trial for "},{"type":1,"value":"netTrialDays"},{"type":0,"value":" days"}],"commerce.commerce-trial-extension-ad.trial-length.key":[{"type":1,"value":"requestKey"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.billable-usage-notice":[{"type":0,"value":"Any usage beyond your allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.billable-usage-notice.enforced":[{"type":0,"value":"If your organization goes over the extra usage limit, you\u2019ll receive a bill for extra usage incurred at the end of your bill cycle"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.billing-faq-url":[{"type":0,"value":"When and how will I be billed?"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.disabled":[{"type":0,"value":"An admin has disabled extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.enabled.intro":[{"type":0,"value":"An admin has enabled extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" on your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-policy.adjust-limit":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.limit-set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your organization now allows monthly usage up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.disabled":[{"type":0,"value":"Extra "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage has been disabled"}],"commerce.commerce-ubp-extra-usage-enabled-disabled-ccp.message-template.email.subject.enabled":[{"type":0,"value":"Extra "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage has been enabled"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.billable-usage-notice":[{"type":0,"value":"Any usage beyond your allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.billable-usage-notice.enforced":[{"type":0,"value":"If your organization allows extra usage above the allowance, at the end of the cycle, you\u2019ll receive a bill for extra usage incurred"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.billing-faq-url":[{"type":0,"value":"When and how will I be billed?"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.policy.adjust-limit":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your organization now allows monthly usage up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.updated.unlimited":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit on your organization. Your extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" has no set limit."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.body.visit-admin":[{"type":0,"value":"Visit Atlassian Administration to get more details on "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage in your organization."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.set":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.caption.updated":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.set":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.dc.email.subject.updated":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.email.body.cta.view-usage":[{"type":0,"value":"View usage"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.billable-usage-notice":[{"type":0,"value":"Any usage beyond your customer\'s allowance is considered extra usage. "},{"children":[{"type":0,"value":"You won\u2019t be billed for extra usage at this time."}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"billingUrl"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.billable-usage-notice.enforced":[{"type":0,"value":"If your customer\u2019s usage exceeds their allowance, you\u2019ll receive an extra usage bill at the end of the cycle"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.billing-faq-url":[{"type":0,"value":"When and how will they be billed?"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.policy.adjust-limit":[{"type":0,"value":"Organization and billing admins can adjust this limit anytime."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.set":[{"type":0,"value":"An admin has set the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organization. They can now use up to "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organization. Your customer\'s extra usage limit for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" is now "},{"type":1,"value":"limit"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":"."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.updated.unlimited":[{"type":0,"value":"An admin has updated the "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" limit for your customer\'s organization. Your customer\'s extra usage for "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" has no set limit."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.body.visit-ppc":[{"type":0,"value":"Visit PPC to get more details on your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage."}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.set":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit has been set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.caption.updated":[{"type":0,"value":"Your customer\'s "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit has been updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.set.without-company-name":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit set"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated":[{"type":1,"value":"customerCompanyName"},{"type":0,"value":": New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-ubp-extra-usage-limit-set-updated-ccp.message-template.partner.email.subject.updated.without-company-name":[{"type":0,"value":"New "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" usage limit updated"}],"commerce.commerce-write-off-email-ccp.message-template.email.caption":[{"type":0,"value":"Your invoice has been written off"}],"commerce.commerce-write-off-email-ccp.message-template.email.no-refund":[{"type":0,"value":"Please note that this credit note will not result in any refund since it is generated against an unpaid invoice."}],"commerce.commerce-write-off-email-ccp.message-template.email.processed-write-off":[{"type":0,"value":"We\'ve processed a write-off for invoice "},{"type":1,"value":"invoiceNumber"},{"type":0,"value":". If the invoice used any account balance, this has been returned to your account."}],"commerce.commerce-write-off-email-ccp.message-template.email.subject":[{"type":0,"value":"Write-off processed for invoice "},{"type":1,"value":"invoiceNumber"}],"commerce.commerce.commerce-ship-to-party-archival-ccp.email.body.caption":[{"type":1,"value":"name"},{"type":0,"value":": Sold to address deactivated"}],"commerce.common-ui.manage-subscription-from-ppc-homepage":[{"type":0,"value":"You can manage the subscription from our "},{"type":1,"value":"partnerPurchasingCenterLink"},{"type":0,"value":"."}],"commerce.common-ui.ppc":[{"type":0,"value":"Partner Purchasing Center"}],"commerce.common.atlassian-privacy-policy":[{"type":0,"value":"Atlassian Privacy Policy"}],"commerce.common.contact-us-to-talk-or-downgrade-to-free":[{"type":1,"value":"contactUs"},{"type":0,"value":" to talk about your situation, or "},{"type":1,"value":"downGradeToFreePlan"},{"type":0,"value":". We suggest you export your data before your subscription gets canceled. For more information, see our "},{"type":1,"value":"dataStorageFAQs"},{"type":0,"value":"."}],"commerce.common.contact-your-bank-for-more-info":[{"type":0,"value":"Contact your bank if you need more information about the issue."}],"commerce.common.contacting-us":[{"type":0,"value":"contacting us"}],"commerce.common.data-retention-and-backup-policy":[{"type":0,"value":"data retention and backup policies"}],"commerce.common.data-storage-faqs":[{"type":0,"value":"Data Storage FAQs"}],"commerce.common.downgrade-to-a-free-plan":[{"type":0,"value":"downgrade to a free plan"}],"commerce.common.email.atl-logo.alt-text":[{"type":0,"value":"Atlassian logo"}],"commerce.common.email.billing-url":[{"type":1,"value":"url"}],"commerce.common.email.bitbucket-logo.alt-text":[{"type":0,"value":"Bitbucket logo"}],"commerce.common.email.compass-logo.alt-text":[{"type":0,"value":"Compass logo"}],"commerce.common.email.confluence-logo.alt-text":[{"type":0,"value":"Confluence logo"}],"commerce.common.email.csm-logo.alt-text":[{"type":0,"value":"Customer Service Management logo"}],"commerce.common.email.dx-logo.alt-text":[{"type":0,"value":"DX logo"}],"commerce.common.email.focus-logo.alt-text":[{"type":0,"value":"Focus logo"}],"commerce.common.email.guard-logo.alt-text":[{"type":0,"value":"Guard logo"}],"commerce.common.email.jpd-logo.alt-text":[{"type":0,"value":"Jira Product Discovery logo"}],"commerce.common.email.jsm-logo.alt-text":[{"type":0,"value":"Jira Service Management logo"}],"commerce.common.email.loom-logo.alt-text":[{"type":0,"value":"Loom logo"}],"commerce.common.email.rovo-dev-logo.alt-text":[{"type":0,"value":"Rovo Dev logo"}],"commerce.common.email.rovo-logo.alt-text":[{"type":0,"value":"Rovo logo"}],"commerce.common.email.siteAdmin":[{"type":0,"value":"Administration"}],"commerce.common.email.talent-logo.alt-text":[{"type":0,"value":"Talent logo"}],"commerce.common.if-you-are-unable-to-pay":[{"type":0,"value":"If you\'re unable to make payments:"}],"commerce.common.jira-logo.alt-text":[{"type":0,"value":"Jira logo"}],"commerce.common.manage-subscription-document-link":[{"type":0,"value":"Manage your subscription for Standard and Premium plans"}],"commerce.common.subscriptiom-reactivation-link":[{"type":0,"value":"reactivate your subscription"}],"commerce.common.view-subscription":[{"type":0,"value":"You can view your subscription details from your site\u2019s "},{"type":1,"value":"siteAdmin"},{"type":0,"value":" at "},{"type":1,"value":"billingUrl"},{"type":0,"value":"."}],"commerce.email.body.what-happens-if-your-customer-uses-extra":[{"type":0,"value":"Remember, if your customer goes over the included quantity for any of the quota types on the subscription, extra usage charges will be added to their next invoice."}],"commerce.email.changed-your-mind":[{"type":0,"value":"Changed your mind?"}],"commerce.email.cms.learn-more":[{"type":0,"value":"Pay later by invoice."}],"commerce.email.current-plan-details":[{"type":0,"value":"More information about your current plan"}],"commerce.email.dont-want-continue":[{"type":0,"value":"Don\'t want to continue with the subscription?"}],"commerce.email.dont-want-to-cancel":[{"type":0,"value":"Don\'t want to cancel?"}],"commerce.email.extra-usage-charge-for-metered-billing":[{"type":0,"value":"Remember, if the included quantity or allowance for any of the usage types on the subscription are exceeded each billing cycle, extra usage charges will be added to the next invoice. "},{"type":1,"value":"SubscriptionAndBillingSupportUrl"}],"commerce.email.how-to":[{"type":0,"value":"How to pay your invoices"}],"commerce.email.included-products":[{"type":0,"value":"Included products:"}],"commerce.email.last-page":[{"type":0,"value":"The last page of your invoice includes Atlassian\u2019s account details and instructions on how to pay."}],"commerce.email.list.billing-account":[{"type":0,"value":"Billing account: "},{"type":1,"value":"transactionAccountNum"}],"commerce.email.list.credit-limit":[{"type":0,"value":"Credit limit: "},{"type":1,"value":"creditLimitFormatted"}],"commerce.email.list.payment-method":[{"type":0,"value":"Payment method: Pay later by invoice"}],"commerce.email.list.payment-terms":[{"type":0,"value":"Payment terms: "},{"type":1,"value":"netTermsDuration"}],"commerce.email.list.taxId":[{"type":1,"value":"identifierName"},{"type":0,"value":": "},{"type":1,"value":"id"}],"commerce.email.new-plan-includes":[{"type":0,"value":"Your new plan includes:"}],"commerce.email.payment-days":[{"type":0,"value":"You\u2019ll have "},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days from the order invoice date to send your payment to Atlassian. You can pay using bank transfer or ACH/check (U.S. banks). "}],"commerce.email.subscription-and-billing-support-url":[{"type":0,"value":"More about how billing works."}],"commerce.email.subscription-details":[{"type":0,"value":"Here are the subscription details:"}],"commerce.email.subscription-includes":[{"type":0,"value":"Your subscription includes:"}],"commerce.email.subscription-includes-quotes":[{"type":0,"value":"The subscription also includes the following quotas:"}],"commerce.email.subscription-list-title":[{"type":0,"value":"Subscription list:"}],"commerce.email.teamwork-collection":[{"type":0,"value":"Teamwork Collection can make it easy for your whole organization to work more effectively together - "},{"type":1,"value":"findOut"},{"type":0,"value":"."}],"commerce.email.teamwork-collection.find-out":[{"type":0,"value":"find out more about Atlassian collections"}],"commerce.email.the.new-plan-includes":[{"type":0,"value":"The new plan includes:"}],"commerce.email.trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.view-subscription":[{"type":0,"value":"View subscription"}],"commerce.email.view-usage":[{"type":0,"value":"View usage"}],"commerce.email.want-to-keep your subscription":[{"type":0,"value":"Want to keep your subscription?"}],"commerce.email.what-do-i-need-to-do":[{"type":0,"value":"What do I need to do?"}],"commerce.email.what-do-you-need-to-do":[{"type":0,"value":"What you need to do:"}],"commerce.email.what-happens-when-trial-ends":[{"type":0,"value":"What happens when the trial ends?"}],"commerce.email.whats-next":[{"type":0,"value":"What\u2019s next?"}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.body":[{"type":1,"value":"finalReviewerName"},{"type":0,"value":" has approved the initiative ("},{"type":1,"value":"initiativeName"},{"type":0,"value":"). We have notified SBO that the initiative is now ready for release."}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.body.img.alt.no-translate":[{"type":0,"value":"Workbench"}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.cta.link":[{"type":0,"value":"Click the button below to view the status of the initiative in Workbench."}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.help":[{"type":0,"value":"If you need help, please reach out to "},{"type":1,"value":"helpLink"},{"type":0,"value":" via Slack or \\"Help\\" in the portal."}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.initiative.link":[{"type":0,"value":"View initiative"}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.regards":[{"type":0,"value":"Regards,"}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.subject.no-translate":[{"type":0,"value":"Initiative approval update: "},{"type":1,"value":"totalApprovalReceived"},{"type":0,"value":" of "},{"type":1,"value":"totalApprovalRequired"},{"type":0,"value":" received"}],"commerce.final-reviewer-approve-owner-notification-email.message-template.email.your.workbench.team":[{"type":0,"value":"Your Workbench team"}],"commerce.learn-more":[{"type":0,"value":"To learn more, see "},{"type":1,"value":"learnMore"}],"commerce.list.payment-terms":[{"type":0,"value":"Payment terms: Net-"},{"type":1,"value":"netTermsDuration"}],"commerce.message-template.email.explore-all-features-button.explore-all-features":[{"type":0,"value":"Explore all features"}],"commerce.message-template.email.features-list.confluence.premium.analytics":[{"children":[{"type":0,"value":"Analytics:"}],"type":8,"value":"b"},{"type":0,"value":" See who has viewed a page and when"}],"commerce.message-template.email.features-list.confluence.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.confluence.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.confluence.standard.page-insights":[{"children":[{"type":0,"value":"Page insights:"}],"type":8,"value":"b"},{"type":0,"value":" See engagement data, like page views"}],"commerce.message-template.email.features-list.confluence.standard.page-permissions":[{"children":[{"type":0,"value":"Page permissions:"}],"type":8,"value":"b"},{"type":0,"value":" Choose who can view, edit, and comment"}],"commerce.message-template.email.features-list.confluence.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jira.premium.cross-team-planning":[{"children":[{"type":0,"value":"Cross-team planning:"}],"type":8,"value":"b"},{"type":0,"value":" See all projects and timelines in one place"}],"commerce.message-template.email.features-list.jira.premium.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jira.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your work and remove human error"}],"commerce.message-template.email.features-list.jira.standard.data-residency":[{"children":[{"type":0,"value":"Data residency:"}],"type":8,"value":"b"},{"type":0,"value":" Choose where your data is stored"}],"commerce.message-template.email.features-list.jira.standard.unlimited-users":[{"children":[{"type":0,"value":"Unlimited users:"}],"type":8,"value":"b"},{"type":0,"value":" Add as many people as you need"}],"commerce.message-template.email.features-list.jpd.premium.atlassian-intelligence":[{"children":[{"type":0,"value":"Atlassian intelligence:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up your day-to-day work"}],"commerce.message-template.email.features-list.jpd.premium.roadmaps":[{"children":[{"type":0,"value":"Roadmaps:"}],"type":8,"value":"b"},{"type":0,"value":" See multiple roadmaps in a single view"}],"commerce.message-template.email.features-list.jpd.premium.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jpd.standard.automation":[{"children":[{"type":0,"value":"Automation:"}],"type":8,"value":"b"},{"type":0,"value":" Speed up work and reduce human error"}],"commerce.message-template.email.features-list.jpd.standard.published-views":[{"children":[{"type":0,"value":"Published views:"}],"type":8,"value":"b"},{"type":0,"value":" Share read-only views with anyone"}],"commerce.message-template.email.features-list.jpd.standard.unlimited-creators":[{"children":[{"type":0,"value":"Unlimited creators:"}],"type":8,"value":"b"},{"type":0,"value":" People who can create and manage projects"}],"commerce.message-template.email.features-list.jsm.premium.ai-features":[{"children":[{"type":0,"value":"AI features:"}],"type":8,"value":"b"},{"type":0,"value":" AI-powered agents, search, and chat"}],"commerce.message-template.email.features-list.jsm.premium.change-automation":[{"children":[{"type":0,"value":"Change automation:"}],"type":8,"value":"b"},{"type":0,"value":" Gate deploys and automate record creation"}],"commerce.message-template.email.features-list.jsm.premium.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.jsm.standard.branded-help-center":[{"children":[{"type":0,"value":"Branded help center:"}],"type":8,"value":"b"},{"type":0,"value":" Use your company\'s branding and URLs"}],"commerce.message-template.email.features-list.jsm.standard.enhanced-support":[{"children":[{"type":0,"value":"Enhanced support:"}],"type":8,"value":"b"},{"type":0,"value":" Get business hour support from our experts"}],"commerce.message-template.email.features-list.jsm.standard.unlimited-agents":[{"children":[{"type":0,"value":"Unlimited agents:"}],"type":8,"value":"b"},{"type":0,"value":" Grow your team, with no cap on customers"}],"commerce.message-template.email.features-list.loom.business-ai.advanced-editing":[{"children":[{"type":0,"value":"Advanced editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim, stitch, remove silence and filler words"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business-ai.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.loom.business.editing":[{"children":[{"type":0,"value":"Editing:"}],"type":8,"value":"b"},{"type":0,"value":" Trim out mistakes or stitch multiple videos together"}],"commerce.message-template.email.features-list.loom.business.unlimited-recording-time":[{"children":[{"type":0,"value":"Unlimited recording time:"}],"type":8,"value":"b"},{"type":0,"value":" Record for as long as you want"}],"commerce.message-template.email.features-list.loom.business.unlimited-videos":[{"children":[{"type":0,"value":"Unlimited videos:"}],"type":8,"value":"b"},{"type":0,"value":" Record as many videos as you want"}],"commerce.message-template.email.features-list.service-collection.premium.advanced-aiops":[{"children":[{"type":0,"value":"Advanced AIOps:"}],"type":8,"value":"b"},{"type":0,"value":" Fast alert grouping, incident creation, and more"}],"commerce.message-template.email.features-list.service-collection.premium.ai-agents":[{"children":[{"type":0,"value":"AI agents:"}],"type":8,"value":"b"},{"type":0,"value":" Save time and use AI for basic conversational support"}],"commerce.message-template.email.features-list.service-collection.premium.asset-management":[{"children":[{"type":0,"value":"Asset management:"}],"type":8,"value":"b"},{"type":0,"value":" Manage the lifecycle of assets and services"}],"commerce.message-template.email.features-list.service-collection.standard.ai-powered-agents":[{"children":[{"type":0,"value":"AI-powered agents:"}],"type":8,"value":"b"},{"type":0,"value":" Automate support, resolve requests faster"}],"commerce.message-template.email.features-list.service-collection.standard.custom-help-center":[{"children":[{"type":0,"value":"Custom help center:"}],"type":8,"value":"b"},{"type":0,"value":" Deliver a seamless support experience"}],"commerce.message-template.email.features-list.service-collection.standard.unlimited-emails":[{"children":[{"type":0,"value":"Unlimited emails:"}],"type":8,"value":"b"},{"type":0,"value":" Talk to customers as much as you need"}],"commerce.message-template.email.upgrade-benefits.compass.body.customizations":[{"type":0,"value":"More customizations"}],"commerce.message-template.email.upgrade-benefits.compass.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benefits.compass.body.reusable-templates":[{"type":0,"value":"20 reusable templates"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.agents-and-customers":[{"type":0,"value":"Up to 20,000 agents and unlimited customers"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.ai-powered-support":[{"type":0,"value":"AI-powered employee support, operations, and customer service"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.audit-logs-data-residency":[{"type":0,"value":"Audit logs and multi-region data residency"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.custom-help-center":[{"type":0,"value":"Custom-branded help center"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\'s team of experts"}],"commerce.message-template.email.upgrade-benefits.service-collection.body.unlimited-email-notifications":[{"type":0,"value":"Unlimited email notifications"}],"commerce.message-template.email.upgrade-benifits.compass.body.storage":[{"type":0,"value":"One year of data retention"}],"commerce.message-template.email.upgrade-benifits.compass.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.confluence.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.confluence.body.page-analytics":[{"type":0,"value":"Page analytics"}],"commerce.message-template.email.upgrade-benifits.confluence.body.space-and-page-permissions":[{"type":0,"value":"Space and page permissions"}],"commerce.message-template.email.upgrade-benifits.confluence.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.confluence.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jira.body.create-issues":[{"type":0,"value":"Anonymous access to let external users view and create issues"}],"commerce.message-template.email.upgrade-benifits.jira.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jira.body.issue-permissions":[{"type":0,"value":"Advanced project and issue permissions"}],"commerce.message-template.email.upgrade-benifits.jira.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jira.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.custom-project-roles":[{"type":0,"value":"Custom project roles"}],"commerce.message-template.email.upgrade-benifits.jpd.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jpd.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jpd.body.unlimited-creators":[{"type":0,"value":"Unlimited creators"}],"commerce.message-template.email.upgrade-benifits.jsm.body.automation-rules-per-month":[{"type":0,"value":"500 project automation rules per month"}],"commerce.message-template.email.upgrade-benifits.jsm.body.increased-user-limits":[{"type":0,"value":"Increased user limits"}],"commerce.message-template.email.upgrade-benifits.jsm.body.storage":[{"type":0,"value":"250 GB of storage"}],"commerce.message-template.email.upgrade-benifits.jsm.body.team-experts":[{"type":0,"value":"9 to 5 support from Atlassian\u2019s team of experts"}],"commerce.message-template.email.upgrade-benifits.jsm.body.track-changes":[{"type":0,"value":"Audit logs to troubleshoot and track changes"}],"commerce.message-template.next-steps":[{"type":0,"value":"Next steps:"}],"commerce.message-template.start-set-up":[{"type":0,"value":"Start set up"}],"commerce.next-bill-estimate-common.key":[{"type":0,"value":"Next estimated bill (prorated):"}],"commerce.partner-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":"."}],"commerce.partner-name.key":[{"type":0,"value":"Atlassian billing partner:"}],"commerce.partner-name.value":[{"type":1,"value":"partnerName"}],"commerce.payment-option-details":[{"type":0,"value":"This payment option allows you to buy your Atlassian products now, and pay within\\n    \\t\\t\\t\\t"},{"type":1,"value":"netTermsDuration"},{"type":0,"value":" days."}],"commerce.requested-by-common.key":[{"type":0,"value":"Requested by:"}],"commerce.requested-by-common.value":[{"type":1,"value":"orderPlacedBy"}],"commerce.requested-by-common.value-with-email":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"emailLink"},{"type":0,"value":")"}],"commerce.requested-by-common.value-without-email":[{"type":1,"value":"name"}],"commerce.reseller-manage-subscriptions":[{"type":0,"value":"Your customer contact can cancel the subscription at any time from the "},{"type":1,"value":"redirectionUrl"},{"type":0,"value":" page."}],"commerce.reseller-manage-subscriptions-subscription-overview":[{"type":0,"value":"Subscription overview"}],"commerce.servco-post-auto-uplift-email-notification.email.banner-alt":[{"type":0,"value":"Service Collection"}],"commerce.servco-post-auto-uplift-email-notification.email.button-v2":[{"type":0,"value":"See details"}],"commerce.servco-post-auto-uplift-email-notification.email.csm-label":[{"type":0,"value":"Customer Service Management"}],"commerce.servco-post-auto-uplift-email-notification.email.heading":[{"type":0,"value":"Jira Service Management is now part of Service Collection"}],"commerce.servco-post-auto-uplift-email-notification.email.help-message":[{"type":0,"value":"If you have any questions or need assistance exploring the new features, please don\'t hesitate to reach out."}],"commerce.servco-post-auto-uplift-email-notification.email.instruction-how-to-add-label":[{"type":0,"value":"Ready to add to your sites. "},{"type":1,"value":"viewInstructions"}],"commerce.servco-post-auto-uplift-email-notification.email.instructions.url":[{"type":0,"value":"View Instructions"}],"commerce.servco-post-auto-uplift-email-notification.email.intro":[{"type":0,"value":"We\'re excited to announce that as of "},{"type":1,"value":"month"},{"type":0,"value":" "},{"type":1,"value":"day"},{"type":0,"value":", "},{"type":1,"value":"year"},{"type":0,"value":", your Jira Service Management has become part of Service Collection. Try the new Customer Service Management app and enjoy extra features, with no changes to your Jira Service Management."}],"commerce.servco-post-auto-uplift-email-notification.email.jsm-label.v2":[{"type":0,"value":"Jira Service Management"}],"commerce.servco-post-auto-uplift-email-notification.email.new-app-label":[{"type":0,"value":"New app"}],"commerce.servco-post-auto-uplift-email-notification.email.on-your-entitlement":[{"type":0,"value":"On your entitlement:"}],"commerce.servco-post-auto-uplift-email-notification.email.received-because":[{"type":0,"value":"You received this email because you\'re an admin for "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"commerce.servco-post-auto-uplift-email-notification.email.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Administration."}],"commerce.servco-post-auto-uplift-email-notification.message-template.email.subject":[{"type":0,"value":"Jira Service Management has moved to Service Collection"}],"commerce.ship-to-information.address-key":[{"type":0,"value":"Address:"}],"commerce.ship-to-information.address-value":[{"type":1,"value":"soldToAddress"}],"commerce.ship-to-information.company-name-key":[{"type":0,"value":"Company:"}],"commerce.ship-to-information.company-name-key-alt-customer":[{"type":0,"value":"Customer:"}],"commerce.ship-to-information.company-name-value":[{"type":1,"value":"soldToCompanyName"}],"commerce.ship-to-information.end-customer-contact-key":[{"type":0,"value":"Customer contact:"}],"commerce.ship-to-information.end-customer-contact-value":[{"type":1,"value":"endCustomerContacts"}],"commerce.ship-to-information.invoice-number-key":[{"type":0,"value":"Invoice number:"}],"commerce.ship-to-information.invoice-number-value":[{"type":1,"value":"invoiceNumber"}],"commerce.subscription-common.entitlement-details":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-with-org-name":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":") | "},{"type":1,"value":"orgName"}],"commerce.subscription-common.entitlement-details-with-site-url":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteURL"},{"type":0,"value":")"}],"commerce.subscription-common.entitlement-details-without-orgName":[{"type":0,"value":"("},{"type":1,"value":"entitlementNumber"},{"type":0,"value":")"}],"commerce.subscription-common.key":[{"type":0,"value":"Subscription:"}],"commerce.subscription-common.new-quote-total-key":[{"type":0,"value":"New quote total:"}],"commerce.subscription-common.old-quote-total-key":[{"type":0,"value":"Old quote total:"}],"commerce.subscription-common.quote-number-key":[{"type":0,"value":"Quote:"}],"commerce.subscription-common.quote-number-value":[{"type":1,"value":"quoteNumber"}],"commerce.subscription-common.quote-total-key":[{"type":0,"value":"Quote total:"}],"commerce.subscription-common.quote-total-value":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amount"}],"commerce.subscription-common.value-with-offering":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-offering-without-entitlement":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"commerce.subscription-common.value-with-pricing-plan":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"pricingPlanName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.subscription-common.value-with-product":[{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"entitlementDetails"}],"commerce.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"commerce.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"commerce.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"commerce.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"common.cloud-payment-retry-actions.admin-hub-url":[{"type":0,"value":"admin.atlassian.com"}],"common.cloud-payment-retry-actions.atlassian-administration":[{"type":0,"value":"Atlassian administration"}],"common.cloud-payment-retry-actions.billing-console-url":[{"type":0,"value":"admin.atlassian.com/billing"}],"common.cloud-payment-retry-actions.billing-overview":[{"type":0,"value":"Billing overview"}],"common.cloud-payment-retry-actions.change-plan":[{"type":0,"value":"Change plan"}],"common.cloud-payment-retry-actions.contact-supportt":[{"type":0,"value":"If you need to speak to our team, you may "},{"type":1,"value":"element"},{"type":0,"value":" to the Atlassian Support Team."}],"common.cloud-payment-retry-actions.contact-us-heading":[{"type":0,"value":"Contact us:"}],"common.cloud-payment-retry-actions.data-storage-faq":[{"type":0,"value":"Data Storage FAQs"}],"common.cloud-payment-retry-actions.downgrade-heading":[{"type":0,"value":"Downgrade to a Free plan:"}],"common.cloud-payment-retry-actions.export-data":[{"type":0,"value":"We advise you to export your business data from your Atlassian instance. For more information, see our "},{"type":1,"value":"element"}],"common.cloud-payment-retry-actions.export-data-heading":[{"type":0,"value":"Export your data:"}],"common.cloud-payment-retry-actions.free":[{"type":0,"value":"Free"}],"common.cloud-payment-retry-actions.free-plan-change":[{"type":0,"value":"Change to the Free plan at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"billingOverview"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" in the "},{"type":1,"value":"subscriptions"},{"type":0,"value":" section. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":" for your product. In "},{"type":1,"value":"subscriptionDetails"},{"type":0,"value":", select "},{"type":1,"value":"planChange"},{"type":0,"value":". Select the "},{"type":1,"value":"free"},{"type":0,"value":" plan and confirm"}],"common.cloud-payment-retry-actions.here-are-actions":[{"type":0,"value":"Here are some actions we suggest you take:"}],"common.cloud-payment-retry-actions.manage":[{"type":0,"value":"Manage"}],"common.cloud-payment-retry-actions.manage-users":[{"type":0,"value":"Manage users"}],"common.cloud-payment-retry-actions.reduce-users":[{"type":0,"value":"If applicable, you\'ll first need to reduce users to 10 or fewer (three agents or fewer for Jira Service Management). Go to your site\'s admin at "},{"type":1,"value":"link"},{"type":0,"value":". In "},{"type":1,"value":"admin"},{"type":0,"value":", select "},{"type":1,"value":"manage"},{"type":0,"value":". Find users you want to remove, and select "},{"type":1,"value":"showDetails"},{"type":0,"value":"."}],"common.cloud-payment-retry-actions.show-details":[{"type":0,"value":"Show details &gt; Actions &gt; Remove user"}],"common.cloud-payment-retry-actions.submit-ticket":[{"type":0,"value":"Submit a ticket"}],"common.cloud-payment-retry-actions.subscription-details":[{"type":0,"value":"Subscription details"}],"common.cloud-payment-retry-actions.subscriptions":[{"type":0,"value":"Subscriptions"}],"common.cloud-payment-retry-actions.what-if-unable":[{"type":0,"value":"What if I\'m unable to make payments?"}],"common.invoice.manage-subscriptions.partner-info":[{"type":0,"value":"To manage subscriptions, visit our Partner Purchasing Center (PPC)."}],"common.invoice.manage-subscriptions.subscription-info":[{"type":0,"value":"To view or manage your invoices and subscription, go to your site\'s Administration."}],"post-office.commerce-access-invalid-payment-hams.caption":[{"type":0,"value":"Action needed: Retry your payment with 3DS authentication"}],"post-office.commerce-access-invalid-payment-hams.error-message.access":[{"type":0,"value":"We couldn\u2019t process your payment for Atlassian Access since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.bitbucket":[{"type":0,"value":"We couldn\u2019t process your payment for Bitbucket ("},{"type":1,"value":"bbAccountName"},{"type":0,"value":") since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.cloud":[{"type":0,"value":"We couldn\'t process your payment for Atlassian Cloud since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.error-message.server":[{"type":0,"value":"We couldn\u2019t process your payment for "},{"type":1,"value":"productInfoString"},{"type":0,"value":" since we need your help to complete 3-D Secure (3DS) authentication. 3DS is a mechanism that makes your online card transactions more secure."}],"post-office.commerce-access-invalid-payment-hams.retry-button":[{"type":0,"value":"Retry Payment"}],"post-office.commerce-access-invalid-payment-hams.retry-message":[{"type":0,"value":"Please retry making the payment and complete 3DS authentication. You may be asked to verify through an app, enter a confirmation code sent to your phone, or asked to authenticate in a different way."}],"post-office.commerce-common.Contact-us":[{"type":0,"value":"Contact us"}],"post-office.commerce-common.atlassian-support-team":[{"type":0,"value":"Atlassian Support Team"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.label":[{"type":0,"value":"Plan"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.value":[{"type":1,"value":"productName"},{"type":0,"value":" Standard ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" user"}]},"other":{"value":[{"type":7},{"type":0,"value":" users"}]}},"pluralType":"cardinal","type":6,"value":"userCount"},{"type":0,"value":")"}],"post-office.commerce-common.auto-upgrade-subscription-details.plan.value.no-user-count":[{"type":1,"value":"productName"},{"type":0,"value":" Standard"}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.heading":[{"type":0,"value":"Not ready to upgrade?"}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-admin":[{"type":0,"value":"You can switch back to a Free plan by "},{"children":[{"type":0,"value":"reducing your user count"}],"type":8,"value":"link"},{"type":0,"value":" to 10 or fewer."}],"post-office.commerce-common.auto-upgrade-subscription-details.switch-back-to-free.switch-back-to-free-non-admin":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" admin can switch back to a Free plan by reducing your user count to 10 or fewer."}],"post-office.commerce-common.blocks.regards":[{"type":0,"value":"Regards,"}],"post-office.commerce-common.blocks.thanks":[{"type":0,"value":"Thanks,"}],"post-office.commerce-common.cheers":[{"type":0,"value":"Cheers,"}],"post-office.commerce-common.cheers.from-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.cheers.from-atlassians":[{"type":0,"value":"The Atlassians"}],"post-office.commerce-common.choose-plan-link":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.choose-plan.billing-console":[{"type":0,"value":"Keep Premium plan"}],"post-office.commerce-common.choose-plan.choose-plan.billing-console":[{"type":0,"value":"Choose plan"}],"post-office.commerce-common.consumption.included-quantity-details":[{"type":1,"value":"includedQuantity"},{"type":0,"value":" "},{"type":1,"value":"includedQuantityUnit"}],"post-office.commerce-common.consumption.summary-included-quantity":[{"type":0,"value":"Included quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity":[{"type":0,"value":"Consumed quantity"}],"post-office.commerce-common.consumptionl.summary-consumed-quantity-details":[{"type":1,"value":"consumedQuantity"},{"type":0,"value":" "},{"type":1,"value":"consumedQuantityUnit"}],"post-office.commerce-common.consumptionl.summary.consumption-percentage":[{"type":1,"value":"usageMilestone"},{"type":0,"value":"% consumed"}],"post-office.commerce-common.contact-support-button.partner":[{"type":0,"value":"Contact Support"}],"post-office.commerce-common.contact-us":[{"type":0,"value":"contact us"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-jira-service-management":[{"type":0,"value":"Atlassian Jira Service Management"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v2.atlassian-logo-alt-service-collection":[{"type":0,"value":"Atlassian Service Collection"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt":[{"type":0,"value":"Atlassian Jira"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-confluence":[{"type":0,"value":"Atlassian Confluence"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-jira-product-discovery":[{"type":0,"value":"Atlassian Jira Product Discovery"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-loom":[{"type":0,"value":"Atlassian Loom"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-serivce-collection":[{"type":0,"value":"Atlassian Service Collection"}],"post-office.commerce-common.email-header-v3.atlassian-logo-alt-teamwork-collection":[{"type":0,"value":"Atlassian Teamwork Collection"}],"post-office.commerce-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.email.plan-section.description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Switch plans anytime."}],"type":8,"value":"b"},{"type":0,"value":" 30-day money back guarantee if you forget to cancel."}],"post-office.commerce-common.email.plan-section.explore-plan.link-description.end-of-trial-with-pde":[{"children":[{"type":0,"value":"Explore all plans \u2192"}],"type":8,"value":"b"}],"post-office.commerce-common.email.subscription-details-section.billing-cycle-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Billing cycle"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-subtitle.end-of-trial-with-pde":[{"type":0,"value":"First bill estimate"}],"post-office.commerce-common.email.subscription-details-section.first-bill-estimate-suffix.end-of-trial-with-pde":[{"type":0,"value":" (Excludes taxes)"}],"post-office.commerce-common.email.subscription-details-section.plan-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Plan"}],"post-office.commerce-common.email.subscription-details-section.title.end-of-trial-with-pde":[{"type":0,"value":"Subscription details"}],"post-office.commerce-common.email.subscription-details-section.trial-ends-subtitle.end-of-trial-with-pde":[{"type":0,"value":"Trial ends"}],"post-office.commerce-common.email.subscription.description.end-of-trial-with-pde":[{"type":0,"value":"When your trial ends, we\u2019ll charge the payment method you chose when you signed up."}],"post-office.commerce-common.email.subscription.headline.end-of-trial-with-pde":[{"type":0,"value":"You don\'t need to do anything"}],"post-office.commerce-common.email.subscription.tick-circle-green-icon.end-of-trial-with-pde":[{"type":0,"value":"Green tick circle icon for the billing section"}],"post-office.commerce-common.features-image.confluence-premium":[{"type":0,"value":"Confluence Premium Features"}],"post-office.commerce-common.features-image.confluence-standard":[{"type":0,"value":"Confluence Standard Features"}],"post-office.commerce-common.features-image.jira-premium":[{"type":0,"value":"Jira Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-premium":[{"type":0,"value":"Jira Product Discovery Premium Features"}],"post-office.commerce-common.features-image.jira-product-discovery-standard":[{"type":0,"value":"Jira Product Discovery Standard Features"}],"post-office.commerce-common.features-image.jira-service-management-premium":[{"type":0,"value":"Jira Service Management Premium Features"}],"post-office.commerce-common.features-image.jira-service-management-standard":[{"type":0,"value":"Jira Service Management Standard Features"}],"post-office.commerce-common.features-image.jira-standard":[{"type":0,"value":"Jira Standard Features"}],"post-office.commerce-common.features-image.loom-business":[{"type":0,"value":"Loom Business Features"}],"post-office.commerce-common.features-image.loom-business-ai":[{"type":0,"value":"Loom Business + AI Features"}],"post-office.commerce-common.features-image.service-collection-premium":[{"type":0,"value":"Service Collection Premium Features"}],"post-office.commerce-common.features-image.service-collection-standard":[{"type":0,"value":"Service Collection Standard Features"}],"post-office.commerce-common.footer-v2.ai-disclaimer":[{"type":0,"value":"Some content in this email has been generated by AI."}],"post-office.commerce-common.footer-v2.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer-v2.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer-v2.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.commerce-common.footer-v2.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer-v2.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer-v2.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer-v2.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer-v2.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer-v2.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer-v2.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer-v2.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.commerce-common.footer-v2.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer-v2.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.commerce-common.footer-v2.x-alt-text":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.x-title":[{"type":0,"value":"X"}],"post-office.commerce-common.footer-v2.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer-v2.youtube-title":[{"type":0,"value":"Youtube"}],"post-office.commerce-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.commerce-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.commerce-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.commerce-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.commerce-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.commerce-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.commerce-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.commerce-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.commerce-common.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.commerce-common.footer.office-address.we-are-located-at":[{"type":0,"value":"We are located at "}],"post-office.commerce-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.commerce-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.commerce-common.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.commerce-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.commerce-common.formal-goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" with any questions, we\'re always happy to help."}],"post-office.commerce-common.formal-goodbye.contact-representative":[{"type":0,"value":"Contact your Atlassian representative if you have any questions."}],"post-office.commerce-common.formal-thank-you":[{"type":0,"value":"Thank you for taking action at your earliest convenience."}],"post-office.commerce-common.get-in-touch":[{"type":0,"value":"Have a question? We\'re here to help. "},{"type":1,"value":"getInTouchLink"}],"post-office.commerce-common.need-help-with-contact-us":[{"type":0,"value":"Need help with plans and billing? "},{"type":1,"value":"contactUs"}],"post-office.commerce-common.not-personal-greetings":[{"type":0,"value":"Hi,"}],"post-office.commerce-common.payment-details.add":[{"type":0,"value":"Add payment details"}],"post-office.commerce-common.payment-details.add.v2":[{"type":0,"value":"explore your plan options"}],"post-office.commerce-common.payment-details.update":[{"type":0,"value":"Update payment details"}],"post-office.commerce-common.personal-greetings":[{"type":0,"value":"Hi "},{"type":1,"value":"firstName"},{"type":0,"value":","}],"post-office.commerce-common.product.entitlement-number.billing-cycle":[{"type":0,"value":"Billing cycle: "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.product.entitlement-number.requested-by-email-id":[{"type":0,"value":"Requested by: "},{"type":1,"value":"requestedByEmailId"}],"post-office.commerce-common.product.entitlement-number.site-url.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"entitlementNumber"}]},"true":{"value":[{"type":1,"value":"entitlementNumber"},{"type":0,"value":" | "},{"type":1,"value":"siteUrl"}]}},"type":5,"value":"hasSiteUrl"}],"post-office.commerce-common.product.entitlement-number.users-count":[{"type":1,"value":"chargeElement"},{"type":0,"value":"s: "},{"type":1,"value":"usersCount"}],"post-office.commerce-common.product.product-title.no-translate":[{"options":{"other":{"value":[{"type":1,"value":"productName"}]},"true":{"value":[{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"offeringName"},{"type":0,"value":")"}]}},"type":5,"value":"hasOfferingName"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits":[{"children":[{"type":0,"value":"Assets objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-asset-credits-with-unit":[{"children":[{"type":0,"value":"Assets objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits":[{"children":[{"type":0,"value":"Automation steps:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-automation-credits-with-unit":[{"children":[{"type":0,"value":"Automation steps:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-build-time-with-unit":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-lfs-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-network-with-unit":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-bitbucket-package-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-build-time":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-build-time-with-unit":[{"children":[{"type":0,"value":"Bitbucket build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution":[{"children":[{"type":0,"value":"AI agent resolutions:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-csm-resolution-with-unit":[{"children":[{"type":0,"value":"AI agent resolutions:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects":[{"children":[{"type":0,"value":"Indexed objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-indexed-objects-with-unit":[{"children":[{"type":0,"value":"Indexed objects:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-lfs-storage":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-lfs-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket Git LFS:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-package-network":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-package-network-with-unit":[{"children":[{"type":0,"value":"Bitbucket package network:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-package-storage":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-package-storage-with-unit":[{"children":[{"type":0,"value":"Bitbucket package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-rovo-dev-credits-with-unit":[{"children":[{"type":0,"value":"Rovo credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-runners-concurrency-limit":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription-context.cbp-allowance-detail-runners-concurrency-limit-with-unit":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription-product-details.bill-estimate-and-currency":[{"type":1,"value":"currency"},{"type":0,"value":" "},{"type":1,"value":"amountExcludingTax"}],"post-office.commerce-common.subscription-product-details.bill-estimate-title":[{"type":0,"value":"Total bill estimate"}],"post-office.commerce-common.subscription-product-details.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription-product-details.exclude-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscription-product-details.offering-name.user-size.billing-cycle.no-translate":[{"type":1,"value":"siteDetails"}],"post-office.commerce-common.subscription-product-details.product-name.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription-product-details.site-url.no-translate":[{"type":1,"value":"siteURL"}],"post-office.commerce-common.subscription.atlassian-guard-standard":[{"type":0,"value":"Atlassian Guard Standard"}],"post-office.commerce-common.subscription.atlassian-rovo":[{"type":0,"value":"Atlassian Rovo"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits":[{"type":0,"value":"Assets objects: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits-label":[{"type":0,"value":"Assets objects"}],"post-office.commerce-common.subscription.cbp-allowance-detail-asset-credits-with-unit":[{"type":0,"value":"Assets objects: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits":[{"type":0,"value":"Automation steps: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits-label":[{"type":0,"value":"Automation steps"}],"post-office.commerce-common.subscription.cbp-allowance-detail-automation-credits-with-unit":[{"type":0,"value":"Automation steps: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time-label":[{"type":0,"value":"Bitbucket build minutes"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-build-time-with-unit":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage-label":[{"type":0,"value":"Bitbucket Git LFS"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-lfs-storage-with-unit":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network-label":[{"type":0,"value":"Bitbucket package network"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-network-with-unit":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage-label":[{"type":0,"value":"Bitbucket package storage"}],"post-office.commerce-common.subscription.cbp-allowance-detail-bitbucket-package-storage-with-unit":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-build-time":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-build-time-label":[{"type":0,"value":"Bitbucket build minutes"}],"post-office.commerce-common.subscription.cbp-allowance-detail-build-time-with-unit":[{"type":0,"value":"Bitbucket build minutes: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution":[{"type":0,"value":"AI agent resolutions: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution-label":[{"type":0,"value":"AI agent resolutions"}],"post-office.commerce-common.subscription.cbp-allowance-detail-csm-resolution-with-unit":[{"type":0,"value":"AI agent resolutions: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-default-value-with-unit":[{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects":[{"type":0,"value":"Indexed objects: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects-label":[{"type":0,"value":"Indexed objects"}],"post-office.commerce-common.subscription.cbp-allowance-detail-indexed-objects-with-unit":[{"type":0,"value":"Indexed objects: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage-label":[{"type":0,"value":"Bitbucket Git LFS"}],"post-office.commerce-common.subscription.cbp-allowance-detail-lfs-storage-with-unit":[{"type":0,"value":"Bitbucket Git LFS: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-network":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-network-label":[{"type":0,"value":"Bitbucket package network"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-network-with-unit":[{"type":0,"value":"Bitbucket package network: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-storage":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-storage-label":[{"type":0,"value":"Bitbucket package storage"}],"post-office.commerce-common.subscription.cbp-allowance-detail-package-storage-with-unit":[{"type":0,"value":"Bitbucket package storage: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-allowance-detail-per-month-value":[{"type":1,"value":"value"},{"type":0,"value":" / month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-per-month-value-with-unit":[{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" / month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-per-user-per-month-value":[{"type":1,"value":"value"},{"type":0,"value":" per user / month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-per-user-per-month-value-with-unit":[{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":" per user / month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits":[{"type":0,"value":"Rovo credits: "},{"type":1,"value":"value"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits-label":[{"type":0,"value":"Rovo credits"}],"post-office.commerce-common.subscription.cbp-allowance-detail-rovo-dev-credits-with-unit":[{"type":0,"value":"Rovo credits: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"},{"type":0,"value":"/month"}],"post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit":[{"type":0,"value":"Pipeline runners: "},{"type":1,"value":"value"}],"post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit-label":[{"type":0,"value":"Pipeline runners"}],"post-office.commerce-common.subscription.cbp-allowance-detail-runners-concurrency-limit-with-unit":[{"type":0,"value":"Pipeline runners: "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-package-network":[{"children":[{"type":0,"value":"Network traffic:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-package-storage":[{"children":[{"type":0,"value":"Package storage:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-rovo-dev-credits":[{"children":[{"type":0,"value":"Rovo Dev credits:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" credits per user"}],"post-office.commerce-common.subscription.cbp-charge-element-runners":[{"children":[{"type":0,"value":"Pipeline runners:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage":[{"children":[{"type":0,"value":"Storage (Git LFS):"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.cbp-charge-element-storage-minutes":[{"children":[{"type":0,"value":"Build minutes:"}],"type":8,"value":"strong"},{"type":0,"value":" "},{"type":1,"value":"value"},{"type":0,"value":" "},{"type":1,"value":"unit"}],"post-office.commerce-common.subscription.free-access":[{"type":0,"value":"Free access to:"}],"post-office.commerce-common.subscription.included-apps":[{"type":0,"value":"Included apps:"}],"post-office.commerce-common.subscription.pooled-allocation.per-user-month":[{"type":1,"value":"credits"},{"type":0,"value":" "},{"type":1,"value":"chargeElementName"},{"type":0,"value":" per user/month"}],"post-office.commerce-common.subscription.product-title.no-translate":[{"type":1,"value":"productName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.address.no-translate":[{"type":0,"value":"Address: "},{"type":1,"value":"address"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.company.no-translate":[{"type":0,"value":"Company: "},{"type":1,"value":"companyName"}],"post-office.commerce-common.subscription.product.billing-admin-partner-contextual-info.customer-contact.no-translate":[{"type":0,"value":"Customer contact: "},{"type":1,"value":"customerContact"}],"post-office.commerce-common.subscription.product.billing-cycle.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"billingCycle"}],"post-office.commerce-common.subscription.product.billing-user-partner-contextual-info.partner-name.no-translate":[{"type":0,"value":"Atlassian billing partner: "},{"type":1,"value":"billingPartner"}],"post-office.commerce-common.subscription.product.charge quantities.no-translate":[{"type":0,"value":"| "},{"type":1,"value":"usageQuantity"},{"type":0,"value":" "},{"type":1,"value":"chargeElement"},{"type":0,"value":"s "}],"post-office.commerce-common.subscription.product.entitlement-number.no-translate":[{"type":1,"value":"entitlementNumber"}],"post-office.commerce-common.subscription.product.offering-name.no-translate":[{"type":1,"value":"offeringName"},{"type":0,"value":" "}],"post-office.commerce-common.subscription.product.site-url.no-translate":[{"type":1,"value":"siteUrl"}],"post-office.commerce-common.subscription.rovo-dev-credit-allocation.per-user":[{"type":1,"value":"credits"},{"type":0,"value":" Rovo Dev credits per user"}],"post-office.commerce-common.subscriptions-change-plan":[{"type":0,"value":"Subscriptions"}],"post-office.commerce-common.subscriptions.excludes-taxes":[{"type":0,"value":"(excludes taxes)"}],"post-office.commerce-common.subscriptions.this-payment-is-for":[{"type":0,"value":"This payment is for:"}],"post-office.commerce-common.subscriptions.total-bill-estimate":[{"type":0,"value":"Total bill estimate:"}],"post-office.commerce-common.subscriptions.total-bill-estimate-after-trial":[{"type":0,"value":"Total bill estimate after trial ends:"}],"post-office.commerce-common.subscriptions.your-estimated-bill-is":[{"type":0,"value":"Your estimated bill is:"}],"post-office.commerce-common.the-atlassian-team":[{"type":0,"value":"The Atlassian team"}],"post-office.commerce-common.view-subscription.billing-console":[{"type":0,"value":"View subscription"}],"post-office.commerce-decoupled-offering-ccp.button.review-bill":[{"type":0,"value":"Review your new bill"}],"post-office.commerce-decoupled-offering-ccp.marketplace-details-guide":[{"type":0,"value":"how Marketplace apps are billed"}],"post-office.commerce-order-fulfilled-ccp.email.billing-account.other-host-type":[{"type":0,"value":"billing account"}],"post-office.commerce-order-fulfilled-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-ccp.email.cmk.support-url":[{"type":0,"value":"page"}],"post-office.commerce-order-fulfilled-ccp.email.direct-customer.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-ccp.email.siteAdmin.cloud":[{"type":0,"value":"site\u2019s "},{"children":[{"type":0,"value":"Administration"}],"type":8,"value":"b"}],"post-office.commerce-order-fulfilled-ccp.email.support-url":[{"type":0,"value":"billing support"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.billing-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.get-started":[{"type":0,"value":"get started"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.siteAdmin":[{"type":0,"value":"Administration"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.support-url":[{"type":1,"value":"url"}],"post-office.commerce-order-fulfilled-from-quote-ccp.email.view-quote-url":[{"type":0,"value":"Learn more"}],"post-office.commerce-payment-failure-hams.email.support.additional_actions":[{"type":0,"value":"additional actions"}],"post-office.commerce-payment-failure-hams.email.title.check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.expiration":[{"type":0,"value":"This doesn\'t have to be a goodbye"}],"post-office.commerce-payment-failure-hams.email.title.expired":[{"type":0,"value":"Your Atlassian subscription has expired"}],"post-office.commerce-payment-failure-hams.email.title.make-it-official":[{"type":0,"value":"Let\'s make it official!"}],"post-office.commerce-payment-failure-hams.email.title.trial-check-payment-details":[{"type":0,"value":"Action needed: Please update your payment details"}],"post-office.commerce-payment-failure-hams.email.title.trial-end":[{"type":0,"value":"Your trial has ended. What\'s next?"}],"post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.body.with-plan":[{"type":0,"value":"Your "},{"type":1,"value":"productName"},{"type":0,"value":" has been downgraded to the "},{"type":1,"value":"toOfferingName"},{"type":0,"value":" plan."}],"post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.restore-plan":[{"type":0,"value":"Restore "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan"}],"post-office.commerce-subscription-auto-downgrade-ccp.bac-banner.title":[{"type":0,"value":"Your "},{"type":1,"value":"offeringName"},{"type":0,"value":" trial has ended"}],"post-office.commerce-subscription-paid-trials-auto-conversion-off-ccp.email.partner.set-up":[{"type":0,"value":"set up the collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.direct-customer.set-up":[{"type":0,"value":"set up your collection"}],"post-office.commerce-subscription-paid-trials-ccp.email.partner.set-up":[{"type":0,"value":"sets up the collection"}],"post-office.commerce.star-email-template.body.agent-limit":[{"type":0,"value":"Get "},{"children":[{"type":0,"value":"unlimited agents"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"250 GB file storage"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.ai-triage":[{"type":0,"value":"Use "},{"children":[{"type":0,"value":"AI"}],"type":8,"value":"b"},{"type":0,"value":" to triage requests from portal, email, and chat"}],"post-office.commerce.star-email-template.body.ai-written-support":[{"type":0,"value":"Power your Rovo agent with "},{"children":[{"type":0,"value":"AI written support articles"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.assets":[{"type":0,"value":"Track business "},{"children":[{"type":0,"value":"assets"}],"type":8,"value":"b"},{"type":0,"value":" and link them to work items"}],"post-office.commerce.star-email-template.body.auto":[{"type":0,"value":"You\'ve reached the agent limit for your Free plan, so we\'ve upgraded you to our "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of the "},{"children":[{"type":0,"value":"Standard"}],"type":8,"value":"b"},{"type":0,"value":" plan."}],"post-office.commerce.star-email-template.body.auto.change-your-mind":[{"type":0,"value":"If you change your mind, get refunded in the first 30 days of your purchase. You can also "},{"children":[{"type":0,"value":"cancel or switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime by reducing your usage to be within its limits."}],"post-office.commerce.star-email-template.body.auto.storage":[{"type":0,"value":"You\'ve reached the 2 GB storage limit for your Free plan, so we\'ve upgraded you to our "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of the "},{"children":[{"type":0,"value":"Standard"}],"type":8,"value":"b"},{"type":0,"value":" plan."}],"post-office.commerce.star-email-template.body.billing-date-with-pde":[{"type":0,"value":"You won\'t be charged until your next billing date on "},{"children":[{"type":1,"value":"nextBillTimestamp"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"post-office.commerce.star-email-template.body.billing-date-without-pde":[{"type":0,"value":"To continue with Standard, add payment details by "},{"children":[{"type":1,"value":"nextBillTimestamp"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"post-office.commerce.star-email-template.body.direct":[{"type":0,"value":"You\'re currently on a "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":". Dive in to manage requests, incidents, changes and assets. All in one place, with the power of AI."}],"post-office.commerce.star-email-template.body.manual":[{"type":0,"value":"Enjoy your "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":" with brand new benefits like AI, Assets, higher automation limits and unlimited agents."}],"post-office.commerce.star-email-template.body.manual-direct.change-your-mind":[{"type":0,"value":"If you change your mind, get refunded in the first 30 days of your purchase. You can also "},{"children":[{"type":0,"value":"cancel or switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime."}],"post-office.commerce.star-email-template.body.rovo-ai-agents":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"Rovo AI agents"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.body.rovo-ai-agents-direct":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"AI agents"}],"type":8,"value":"b"}],"post-office.commerce.star-email-template.button.explore-standard-direct":[{"type":0,"value":"Explore your new service space"}],"post-office.commerce.star-email-template.button.explore-standard-manual-auto":[{"type":0,"value":"Explore Standard"}],"post-office.commerce.star-email-template.caption.add-payment-details-button":[{"type":0,"value":"Add Payment Details"}],"post-office.commerce.star-email-template.caption.billing":[{"type":0,"value":"What happens to your billing?"}],"post-office.commerce.star-email-template.caption.heading.auto":[{"type":0,"value":"\uD83D\uDC4B Say hello to unlimited agents"}],"post-office.commerce.star-email-template.caption.heading.auto.storage":[{"type":0,"value":"\uD83D\uDC4B Say hello to more storage"}],"post-office.commerce.star-email-template.caption.heading.welcome.manual-direct":[{"type":0,"value":"\uD83C\uDF89 Welcome to Service Collection Standard"}],"post-office.commerce.star-email-template.link.explore-plans":[{"type":0,"value":"Explore all plans"}],"post-office.commerce.star-email-template.subject.auto-upgrade":[{"type":0,"value":"You\'ve been upgraded to our Standard plan - free for 14 days"}],"post-office.commerce.star-email-template.subject.direct-trial":[{"type":0,"value":"Welcome to your Service Collection "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan!"}],"post-office.commerce.star-email-template.subject.manual-trial":[{"type":0,"value":"Your "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialDaysLeft"},{"type":0,"value":" free trial of our "},{"type":1,"value":"offeringName"},{"type":0,"value":" plan has started"}],"post-office.commerce.star-email-template.subscription.excludes-taxes":[{"type":0,"value":"(Excludes Taxes)"}],"post-office.commerce.star-email-template.subscription.header":[{"type":0,"value":"Subscription Details"}],"post-office.commerce.star-email-template.subscription.header-no-payment":[{"type":0,"value":"Trial details"}],"post-office.commerce.star-email-template.subscription.included-apps":[{"type":0,"value":"Included apps:"}],"post-office.commerce.star-email-template.subscription.next-bill-date":[{"type":0,"value":"Next bill date"}],"post-office.commerce.star-email-template.subscription.next-bill-estimate":[{"type":0,"value":"Next bill estimate"}],"post-office.commerce.star-email-template.subscription.next-bill-estimate-no-payment":[{"type":0,"value":"Estimated first bill"}],"post-office.commerce.star-email-template.subscription.trial-end-date":[{"type":0,"value":"Trial ends"}],"post-office.commerce.star-email-template.subscription.users":[{"type":1,"value":"count"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"user"}]},"other":{"value":[{"type":0,"value":"users"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"post-office.star-email-template.email-header-alt":[{"type":0,"value":"Service Collection"}],"post-office.star-email-template.email-header-subtitle":[{"type":0,"value":"Includes:"}],"post-office.star-email-template.footer.ai-disclaimer":[{"type":0,"value":"Some content in this email has been generated by AI."}],"post-office.star-email-template.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.star-email-template.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.star-email-template.footer.dot-separator":[{"type":0,"value":"\u2022"}],"post-office.star-email-template.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.star-email-template.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.star-email-template.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.star-email-template.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.star-email-template.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.star-email-template.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.star-email-template.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"post-office.star-email-template.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"post-office.star-email-template.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"post-office.star-email-template.footer.x-alt-text":[{"type":0,"value":"X"}],"post-office.star-email-template.footer.x-title":[{"type":0,"value":"X"}],"post-office.star-email-template.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"post-office.star-email-template.footer.youtube-title":[{"type":0,"value":"Youtube"}]}');

});

parcelRegister("hWly3", function(module, exports) {

let $d0f8918199dfb820$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0f8918199dfb820$var$load("1vCS4").then(()=>parcelRequire('2vnwT'));

});

parcelRegister("kD2jz", function(module, exports) {

let $f0493ed50b23f670$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0493ed50b23f670$var$load("f8KfO").then(()=>parcelRequire('8BTik'));

});

parcelRegister("1w2IL", function(module, exports) {

let $11aae3ea361742f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11aae3ea361742f4$var$load("kTn2q").then(()=>parcelRequire('dBx2j'));

});

parcelRegister("8RbOE", function(module, exports) {

let $672c70600b004d4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $672c70600b004d4e$var$load("5uMul").then(()=>parcelRequire('37nX5'));

});

parcelRegister("63Yel", function(module, exports) {

let $46a1be6924618d7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46a1be6924618d7b$var$load("c1VEk").then(()=>parcelRequire('e2UQ4'));

});

parcelRegister("5M5pV", function(module, exports) {

let $4345a32f29659869$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4345a32f29659869$var$load("73Pi9").then(()=>parcelRequire('7juli'));

});

parcelRegister("2nT0u", function(module, exports) {

let $1bc865f4d97f4a36$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1bc865f4d97f4a36$var$load("gkEwh").then(()=>parcelRequire('lqGqh'));

});

parcelRegister("3e8DW", function(module, exports) {

let $2599624000f6b6a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2599624000f6b6a9$var$load("bYFNb").then(()=>parcelRequire('7B3R9'));

});

parcelRegister("7OtJ9", function(module, exports) {

let $5b044321ea4353c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b044321ea4353c5$var$load("82NW6").then(()=>parcelRequire('aZesB'));

});

parcelRegister("c9erU", function(module, exports) {

let $8d81889d68d47224$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d81889d68d47224$var$load("1Dbsb").then(()=>parcelRequire('equoS'));

});

parcelRegister("jxNdA", function(module, exports) {

let $e3a74717df47386c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3a74717df47386c$var$load("h4z0k").then(()=>parcelRequire('8Wpsg'));

});

parcelRegister("fdsXl", function(module, exports) {

let $b13e87fce887e10d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b13e87fce887e10d$var$load("kIPH1").then(()=>parcelRequire('6dPAH'));

});

parcelRegister("fNRe5", function(module, exports) {

let $b814b83f36a07bd4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b814b83f36a07bd4$var$load("ebJuj").then(()=>parcelRequire('ggVYZ'));

});

parcelRegister("kPor2", function(module, exports) {

let $f29b866320c3afc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f29b866320c3afc1$var$load("4TMY0").then(()=>parcelRequire('9p5H9'));

});

parcelRegister("2kbU2", function(module, exports) {

let $1b16aea8da0abedc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b16aea8da0abedc$var$load("1cH6h").then(()=>parcelRequire('8aeX8'));

});

parcelRegister("fZi6C", function(module, exports) {

let $ba3a98f218532e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba3a98f218532e90$var$load("3PH8B").then(()=>parcelRequire('4RJ4O'));

});

parcelRegister("eRwKc", function(module, exports) {

let $ad1f6a3adf8cfd61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad1f6a3adf8cfd61$var$load("brR2x").then(()=>parcelRequire('ce2xj'));

});

parcelRegister("yg9gZ", function(module, exports) {

let $066fb3dbf01d9661$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $066fb3dbf01d9661$var$load("bQ8uQ").then(()=>parcelRequire('l1RCr'));

});

parcelRegister("zjuWb", function(module, exports) {

let $06a264e4df9a0983$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $06a264e4df9a0983$var$load("3CHBz").then(()=>parcelRequire('aCXGM'));

});

parcelRegister("enIzW", function(module, exports) {

let $a785cb0e44999d3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a785cb0e44999d3a$var$load("hqjTG").then(()=>parcelRequire('2Epvx'));

});

parcelRegister("8rNKP", function(module, exports) {

let $6267708a0f6db3ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6267708a0f6db3ad$var$load("9DQ1i").then(()=>parcelRequire('01cHG'));

});

parcelRegister("hzrWy", function(module, exports) {

let $ccab6185f9a9ce1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ccab6185f9a9ce1a$var$load("eJKPl").then(()=>parcelRequire('ahcE1'));

});

parcelRegister("M9Xz5", function(module, exports) {

let $090c359a55d75dd1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $090c359a55d75dd1$var$load("g7h0d").then(()=>parcelRequire('dPSPT'));

});

parcelRegister("2I4JV", function(module, exports) {

let $1f935e0597102150$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f935e0597102150$var$load("6wIOl").then(()=>parcelRequire('7I0Sx'));

});

parcelRegister("026q8", function(module, exports) {

let $00652afc4c448f86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00652afc4c448f86$var$load("aHXF0").then(()=>parcelRequire('63hEC'));

});

parcelRegister("46mMR", function(module, exports) {

let $2fc965ff6789c976$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2fc965ff6789c976$var$load("5gOt7").then(()=>parcelRequire('h4JGL'));

});

parcelRegister("kezJr", function(module, exports) {

let $ebb0d5172cf66331$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ebb0d5172cf66331$var$load("lsavo").then(()=>parcelRequire('6dV99'));

});

parcelRegister("dsfVu", function(module, exports) {

let $0287220a55fe3e4f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0287220a55fe3e4f$var$load("ga6DO").then(()=>parcelRequire('uF7NE'));

});

parcelRegister("j1a5i", function(module, exports) {

let $dd85eee5736e92a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd85eee5736e92a7$var$load("8v3WH").then(()=>parcelRequire('bTHXI'));

});

parcelRegister("kuDvi", function(module, exports) {

let $eeb540a43d0df58f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eeb540a43d0df58f$var$load("hPGN2").then(()=>parcelRequire('7oNEf'));

});

parcelRegister("9jMo8", function(module, exports) {

let $6c8b6c5274eb6267$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c8b6c5274eb6267$var$load("2a33i").then(()=>parcelRequire('i8TJK'));

});

parcelRegister("hrIu5", function(module, exports) {

let $cb3776f57be19fb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb3776f57be19fb0$var$load("9f1ZJ").then(()=>parcelRequire('jWhXH'));

});

parcelRegister("04ndd", function(module, exports) {

let $00d2614e850b2dfc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00d2614e850b2dfc$var$load("aonFR").then(()=>parcelRequire('jzfNl'));

});

parcelRegister("gnNML", function(module, exports) {

let $bed569aa2aa0fe52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bed569aa2aa0fe52$var$load("eKKVJ").then(()=>parcelRequire('5M7U7'));

});

parcelRegister("evz1y", function(module, exports) {

let $a8ff20f74d1d46e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a8ff20f74d1d46e7$var$load("4FcIh").then(()=>parcelRequire('1MW0k'));

});

parcelRegister("6XRKH", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $31Fwu = parcelRequire("31Fwu");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $712e01cf4988f075$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $712e01cf4988f075$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("ataRH")));
        case 'da':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("iVDSF")));
        case 'de':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("egyQ2")));
        case 'en-GB':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("7hTMh")));
        case 'en-US':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("9PwQo")));
        case 'en-XA':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("d3zO7")));
        case 'en-XB':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("j9Wau")));
        case 'en-ZZ':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("9CUci")));
        case 'en':
            return $712e01cf4988f075$var$importHelper(await Promise.resolve((parcelRequire("31Fwu"))));
        case 'es':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("6Bfr6")));
        case 'et':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("3497S")));
        case 'fi':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("77AfX")));
        case 'fr':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("dzXUT")));
        case 'hr':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("hKCnd")));
        case 'hu':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("7KWe1")));
        case 'it':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("k3nPU")));
        case 'ja':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("5OEJ7")));
        case 'ko':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("jJeXe")));
        case 'nb':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("PRNRE")));
        case 'nl':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("7VRWF")));
        case 'pl':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("gLLIP")));
        case 'pt-BR':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("jDPqE")));
        case 'ro':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("eX5es")));
        case 'ru':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("lqLSP")));
        case 'sl':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("bdSSO")));
        case 'sr-RS':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("eHKx8")));
        case 'sr-YR':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("8fwnI")));
        case 'sr':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("74Qrr")));
        case 'sv':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("aKmhn")));
        case 'th':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("4D3g4")));
        case 'tr':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("fPs3d")));
        case 'uk':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("5JFQ2")));
        case 'vi':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("iJfcJ")));
        case 'zh-CN':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("aUGzw")));
        case 'zh-TW':
            return $712e01cf4988f075$var$importHelper(await (parcelRequire("5fR79")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($31Fwu));
    }
};
module.exports["messagesLoader"] = $712e01cf4988f075$export$720676d8cac8fbb;

});

parcelRegister("31Fwu", function(module, exports) {
module.exports = JSON.parse('{"Dismiss":[{"type":0,"value":"Dismiss"}],"Looking to enhance the agent experience?":[{"type":0,"value":"Looking to enhance the agent experience?"}],"Show me the apps":[{"type":0,"value":"Show me the apps"}],"Upgrade options":[{"type":0,"value":"Upgrade options"}],"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!":[{"type":0,"value":"We\'ve curated a list for you of the best marketplace apps to boost agent productivity!"}],"We\u2019re having trouble with your plan":[{"type":0,"value":"We\u2019re having trouble with your plan"}],"We\u2019ve kept you on the Standard plan of Confluence for now.":[{"type":0,"value":"We\u2019ve kept you on the Standard plan of Confluence for now."}],"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users.":[{"type":0,"value":"We\u2019ve put you on the Free plan of Confluence for now. You can add up to 10 users."}],"confluence-3p-connector-nudge.action.connect":[{"type":0,"value":"Connect now"}],"confluence-3p-connector-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"confluence-3p-connector-nudge.connecting":[{"type":0,"value":"Connecting"}],"confluence-3p-connector-nudge.connecting.no-translate":[{"type":0,"value":"Connecting"}],"confluence-3p-connector-nudge.description":[{"type":0,"value":"You\'ve been using "},{"type":1,"value":"providerName"},{"type":0,"value":". Connect it to get richer previews and better search."}],"confluence-3p-connector-nudge.error-label":[{"type":0,"value":"error"}],"confluence-3p-connector-nudge.error-label.no-translate":[{"type":0,"value":"error"}],"confluence-3p-connector-nudge.error.generic.action.tryAgain":[{"type":0,"value":"Try again"}],"confluence-3p-connector-nudge.error.generic.description":[{"type":0,"value":"Try again or ask your admin for help."}],"confluence-3p-connector-nudge.error.generic.title":[{"type":0,"value":"We\'re having trouble connecting "},{"type":1,"value":"providerName"}],"confluence-3p-connector-nudge.error.unavailable.description":[{"type":0,"value":"Try using the "},{"type":1,"value":"providerName"},{"type":0,"value":" Smart Link to connect your account, or ask your admin for help."}],"confluence-3p-connector-nudge.error.unavailable.title":[{"type":0,"value":"We couldn\'t connect your app"}],"confluence-3p-connector-nudge.title":[{"type":0,"value":"Connect "},{"type":1,"value":"providerName"}],"ep-migration-external-messages.in-app.screen-space-flags.flag-body.no-translate":[{"type":0,"value":"Placeholder body"}],"ep-migration-external-messages.in-app.screen-space-flags.flag-title.no-translate":[{"type":0,"value":"Placeholder title"}],"feedback-collector.can-be-enrolled-label.text":[{"type":0,"value":"Atlassian can contact me about this feedback. See our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"feedback-collector.enroll-in-research-label.text":[{"type":0,"value":"I\'d like to help improve Atlassian products by joining the"},{"type":1,"value":"nbsp"},{"type":1,"value":"n"},{"type":1,"value":"t"},{"type":1,"value":"t"},{"children":[{"type":0,"value":"Atlassian Research Group"}],"type":8,"value":"enrollLink"}],"feedback-collector.feedback-title-details.component":[{"type":0,"value":"For help with billing or other issues, visit our"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"documentation"}],"type":8,"value":"documentationLink"},{"type":1,"value":"nbsp"},{"type":0,"value":"or contact"},{"type":1,"value":"nbsp"},{"children":[{"type":0,"value":"support"}],"type":8,"value":"supportLink"}],"no-notifications-fallback.learn-more-link.text":[{"type":0,"value":"Learn more about this feature"}],"no-notifications-fallback.no-notifications.text":[{"type":0,"value":"Check back soon. No notifications yet."}],"notifications.error-fallback-error-reason.text":[{"type":0,"value":"We\'re unable to load notifications"}],"notifications.error-fallback-proposed-solution.text":[{"type":0,"value":"Refresh the page or try again later"}],"post-office-team.commerce-approvals-received-author-notification-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.commerce-approvals-received-author-notification-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.commerce-approvals-received-author-notification-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.confluence-recommended-following-feed.add-comment-button":[{"type":0,"value":"Comment"}],"post-office-team.confluence-recommended-following-feed.add-emoji-button-alt-text":[{"type":0,"value":"Add Emoji"}],"post-office-team.confluence-recommended-following-feed.ai-generated-content-icon-alt-text":[{"type":0,"value":"AI Generated Content"}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer":[{"type":0,"value":"Uses AI. Verify results."}],"post-office-team.confluence-recommended-following-feed.ai-use-disclaimer-alt-text":[{"type":0,"value":"Information icon"}],"post-office-team.confluence-recommended-following-feed.atlassian-logo":[{"type":0,"value":"Atlassian Logo"}],"post-office-team.confluence-recommended-following-feed.blog-icon":[{"type":0,"value":"Blog icon"}],"post-office-team.confluence-recommended-following-feed.clap-button-alt-text":[{"type":0,"value":"Clap"}],"post-office-team.confluence-recommended-following-feed.database-icon":[{"type":0,"value":"Database icon"}],"post-office-team.confluence-recommended-following-feed.email-unsubscribe-text":[{"children":[{"type":0,"value":"Update your email settings"}],"type":8,"value":"trackedLink"},{"type":0,"value":" to customize or stop receiving this email."}],"post-office-team.confluence-recommended-following-feed.email.body.hello":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.confluence-recommended-following-feed.email.body.summary":[{"type":0,"value":"Here are pages your team is reading, don\'t miss out on the conversation."}],"post-office-team.confluence-recommended-following-feed.email.ios-android-text":[{"type":0,"value":"Download the Confluence mobile app on "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"iosLink"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"androidLink"},{"type":0,"value":" to read notifications and comment on the go."}],"post-office-team.confluence-recommended-following-feed.email.privacy-policy-text":[{"type":0,"value":"This email was sent by Atlassian Confluence  \u2022  "},{"children":[{"type":0,"value":"Privacy policy"}],"type":8,"value":"privacyPolicyLink"}],"post-office-team.confluence-recommended-following-feed.email.subject":[{"type":1,"value":"name"},{"type":0,"value":", your team is working on these pages -- join the conversation"}],"post-office-team.confluence-recommended-following-feed.email.subject.variant-a":[{"type":1,"value":"name"},{"type":0,"value":", "},{"type":1,"value":"pageTitle"},{"type":0,"value":" plus more pages your team is working on"}],"post-office-team.confluence-recommended-following-feed.header.confluence-icon.alt-text":[{"type":0,"value":"Confluence Icon"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted":[{"children":[{"type":1,"value":"firstUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-user-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":" and "},{"type":1,"value":"secondUser"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}],"post-office-team.confluence-recommended-following-feed.name-users-reacted-and-number-of-others":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" other"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"firstUser"},{"type":0,"value":", "},{"type":1,"value":"secondUser"},{"type":0,"value":", and "},{"type":1,"value":"calculatedReactionCount"},{"type":0,"value":" others"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"calculatedReactionCount"}],"post-office-team.confluence-recommended-following-feed.no-comments":[{"type":0,"value":"Be the first to comment"}],"post-office-team.confluence-recommended-following-feed.no-reactions-text":[{"type":0,"value":"Be the first to react"}],"post-office-team.confluence-recommended-following-feed.number-of-comments":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comment"}]},"other":{"value":[{"children":[{"type":7}],"type":8,"value":"strong"},{"type":0,"value":" comments"}]}},"pluralType":"cardinal","type":6,"value":"commentCount"}],"post-office-team.confluence-recommended-following-feed.number-of-users-reacted":[{"offset":0,"options":{"one":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]},"other":{"value":[{"children":[{"type":1,"value":"reactionCount"}],"type":8,"value":"strong"},{"type":0,"value":" reacted"}]}},"pluralType":"cardinal","type":6,"value":"reactionCount"}],"post-office-team.confluence-recommended-following-feed.owned-by":[{"type":0,"value":"Owned by "},{"type":1,"value":"ownerName"}],"post-office-team.confluence-recommended-following-feed.party-popper-button-alt-text":[{"type":0,"value":"Party Popper"}],"post-office-team.confluence-recommended-following-feed.read-more-link":[{"type":0,"value":"Read more"}],"post-office-team.confluence-recommended-following-feed.thumbs-up-button-alt-text":[{"type":0,"value":"Thumbs up"}],"post-office-team.confluence-recommended-following-feed.user-profile-picture-alt-text":[{"type":1,"value":"name"},{"type":0,"value":"\'s profile picture"}],"post-office-team.confluence-recommended-following-feed.whiteboard-icon":[{"type":0,"value":"Whiteboard icon"}],"post-office-team.email-with-tracking-links.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.email-with-tracking-links.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.email-with-tracking-links.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.email-with-tracking-links.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.email-with-tracking-links.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.email-with-tracking-links.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.email-with-tracking-links.test-message.email.confluence-link.text.no-translate":[{"type":0,"value":"Go to Confluence link"}],"post-office-team.email-with-tracking-links.test-message.email.jira-link.text.no-translate":[{"type":0,"value":"Go to Jira link"}],"post-office-team.email-with-tracking-links.test-message.email.trello-link.text.no-translate":[{"type":0,"value":"Go to Trello board"}],"post-office-team.example-screen-space-flags-modal.confirm.no-translate":[{"type":0,"value":"OK"}],"post-office-team.example-screen-space-flags-modal.description.no-translate":[{"type":0,"value":"This is the modal body"}],"post-office-team.example-screen-space-flags-modal.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"post-office-team.jira-messaging-research-recruitment.close-label.no-translate":[{"type":0,"value":"Close flag"}],"post-office-team.jira-messaging-research-recruitment.feedback-label.no-translate":[{"type":0,"value":"feedback-icon"}],"post-office-team.push-msg-object-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.push-msg-object-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.push-msg-object-tracking.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office-team.push-msg-object-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.push-msg-object-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.push-msg-object-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.push-msg-object-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.push-msg-object-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.test-audience-message-template.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.test-audience-message-template.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.test-audience-message-template.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.test-audience-message-template.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.test-audience-message-template.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.test-audience-message-template.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.test-audience-message-template.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.test-message-groot.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"post-office-team.test-message-groot.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"post-office-team.test-message-groot.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"post-office-team.test-message-groot.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"post-office-team.test-message-groot.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"post-office-team.test-message-groot.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"post-office-team.test-message-groot.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office-team.test-screen-space-flags-message.acknowledge.no-translate":[{"type":0,"value":"Got it"}],"post-office-team.test-screen-space-flags-message.confirm.no-translate":[{"type":0,"value":"OK"}],"post-office-team.test-screen-space-flags-message.description.no-translate":[{"type":0,"value":"This is the modal body"}],"post-office-team.test-screen-space-flags-message.dismiss.no-translate":[{"type":0,"value":"Dismiss"}],"post-office-team.test-screen-space-flags-message.open.no-translate":[{"type":0,"value":"Open"}],"post-office-team.test-screen-space-flags-message.snooze.no-translate":[{"type":0,"value":"Remind me later"}],"post-office-team.test-screen-space-flags-message.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"post-office.admin-hub.end-of-notifications.description":[{"type":0,"value":"That\'s all your notifications from the last 90 days"}],"post-office.confluence-side-nav-create-a-space.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.flag.editor.action-id":[{"type":0,"value":"Action ID"}],"post-office.flag.editor.action-label":[{"type":0,"value":"Action label"}],"post-office.flag.editor.action-type":[{"type":0,"value":"Action type"}],"post-office.flag.editor.add-action":[{"type":0,"value":"Add action"}],"post-office.flag.editor.appearance":[{"type":0,"value":"Appearance"}],"post-office.flag.editor.description":[{"type":0,"value":"Description"}],"post-office.flag.editor.dismiss-action":[{"type":0,"value":"Dismiss"}],"post-office.flag.editor.error":[{"type":0,"value":"Error"}],"post-office.flag.editor.info":[{"type":0,"value":"Information"}],"post-office.flag.editor.link":[{"type":0,"value":"Link"}],"post-office.flag.editor.link-action":[{"type":0,"value":"Link"}],"post-office.flag.editor.message":[{"type":0,"value":"Message"}],"post-office.flag.editor.normal":[{"type":0,"value":"Normal"}],"post-office.flag.editor.preview":[{"type":0,"value":"Live preview"}],"post-office.flag.editor.preview-dismiss":[{"type":0,"value":"Dismiss"}],"post-office.flag.editor.preview-empty":[{"type":0,"value":"Complete the message to see its preview."}],"post-office.flag.editor.preview-help":[{"type":0,"value":"Flags appear in the product\u2019s notification stack. Try this one without saving the draft."}],"post-office.flag.editor.preview-invalid":[{"type":0,"value":"Complete the required fields"}],"post-office.flag.editor.preview-valid":[{"type":0,"value":"Configuration is ready to save"}],"post-office.flag.editor.remove-action":[{"type":0,"value":"Remove action"}],"post-office.flag.editor.show-flag":[{"type":0,"value":"Show Flag"}],"post-office.flag.editor.success":[{"type":0,"value":"Success"}],"post-office.flag.editor.timer":[{"type":0,"value":"Dismiss after (seconds)"}],"post-office.flag.editor.title":[{"type":0,"value":"Title"}],"post-office.flag.editor.warning":[{"type":0,"value":"Warning"}],"post-office.flag.test.action.ai-non-final":[{"type":0,"value":"Got it"}],"post-office.flag.test.description.ai-non-final":[{"type":0,"value":"Written by the message maker."}],"post-office.flag.test.title.ai-non-final":[{"type":1,"value":"title"}],"post-office.flag.verification.error-description":[{"type":0,"value":"Your draft is safe. Review your connection and try again."}],"post-office.flag.verification.error-title":[{"type":0,"value":"We couldn\'t publish your changes"}],"post-office.flag.verification.review":[{"type":0,"value":"Review draft"}],"post-office.live-nudge-demo.connecting.no-translate":[{"type":0,"value":"Connecting..."}],"post-office.live-nudge-demo.live-count.no-translate":[{"type":1,"value":"count"},{"type":0,"value":" live"}],"post-office.live-nudge-demo.main-heading.no-translate":[{"type":0,"value":"Live Nudge Demo Placement"}],"post-office.live-nudge-demo.subscription-error.no-translate":[{"type":0,"value":"Subscription Error!"}],"post-office.modal.editor.action-label":[{"type":0,"value":"Action "},{"type":1,"value":"number"},{"type":0,"value":" label"}],"post-office.modal.editor.action-url":[{"type":0,"value":"Action "},{"type":1,"value":"number"},{"type":0,"value":" URL"}],"post-office.modal.editor.add-action":[{"type":0,"value":"Add action"}],"post-office.modal.editor.body":[{"type":0,"value":"Body"}],"post-office.modal.editor.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.modal.editor.got-it":[{"type":0,"value":"Got it"}],"post-office.modal.editor.image-alt":[{"type":0,"value":"Image description"}],"post-office.modal.editor.image-url":[{"type":0,"value":"Image URL"}],"post-office.modal.editor.invalid-configuration":[{"type":0,"value":"Add a title, text body and valid actions before saving."}],"post-office.modal.editor.link":[{"type":0,"value":"Link"}],"post-office.modal.editor.message":[{"type":0,"value":"Message"}],"post-office.modal.editor.preview":[{"type":0,"value":"Live preview"}],"post-office.modal.editor.preview-empty":[{"type":0,"value":"Complete the message to see its preview."}],"post-office.modal.editor.preview-help":[{"type":0,"value":"Modals open over the product. Try this one without saving the draft."}],"post-office.modal.editor.remove-action":[{"type":0,"value":"Remove action "},{"type":1,"value":"number"}],"post-office.modal.editor.show-modal":[{"type":0,"value":"Show Modal"}],"post-office.modal.editor.title":[{"type":0,"value":"Title"}],"post-office.modal.test.action.ai-non-final":[{"type":0,"value":"Got it"}],"post-office.modal.test.description.ai-non-final":[{"type":0,"value":"Written by the message maker."}],"post-office.modal.test.title.ai-non-final":[{"type":1,"value":"title"}],"post-office.post-office-team-components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.post-office-team-components.email.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.post-office-team-components.email.footer.why-am-i-receiving-this-email":[{"type":0,"value":"You are receiving this email because this is an important message regarding your account and products you are using. You are not allowed to unsubscribe from this type of message."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.cta-link":[{"type":0,"value":"Get started"}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Help us improve messaging for Atlassian Admins! Answer a few short questions, and our Research team will contact you for a 60-minute Zoom session if you qualify."}],"post-office.post-office-team.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Share your experience for $120 USD"}],"post-office.post-office-team.push-msg-object-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.post-office-team.push-msg-object-tracking.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.post-office-team.test-message-dynamic-config-sets.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.spotlight.editor.action-label":[{"type":0,"value":"Action "},{"type":1,"value":"number"},{"type":0,"value":" label"}],"post-office.spotlight.editor.action-url":[{"type":0,"value":"Action "},{"type":1,"value":"number"},{"type":0,"value":" URL"}],"post-office.spotlight.editor.add-action":[{"type":0,"value":"Add action"}],"post-office.spotlight.editor.body":[{"type":0,"value":"Description"}],"post-office.spotlight.editor.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.spotlight.editor.empty-preview":[{"type":0,"value":"Complete the message to see its preview."}],"post-office.spotlight.editor.got-it":[{"type":0,"value":"Got it"}],"post-office.spotlight.editor.invalid-configuration":[{"type":0,"value":"Add a title, description and valid actions before saving."}],"post-office.spotlight.editor.link":[{"type":0,"value":"Link"}],"post-office.spotlight.editor.message":[{"type":0,"value":"Message"}],"post-office.spotlight.editor.preview":[{"type":0,"value":"Live preview"}],"post-office.spotlight.editor.preview-help":[{"type":0,"value":"Spotlights appear beside a product control. Try this one on the sample button."}],"post-office.spotlight.editor.remove-action":[{"type":0,"value":"Remove action "},{"type":1,"value":"number"}],"post-office.spotlight.editor.show-spotlight":[{"type":0,"value":"Show Spotlight"}],"post-office.spotlight.editor.title":[{"type":0,"value":"Title"}],"post-office.spotlight.test.action.ai-non-final":[{"type":0,"value":"Got it"}],"post-office.spotlight.test.description.ai-non-final":[{"type":0,"value":"Written by the message maker."}],"post-office.spotlight.test.title.ai-non-final":[{"type":1,"value":"title"}],"test-message-ep-migration.description.no-translate":[{"type":0,"value":"Check out the support documentation for more details."}],"test-message-ep-migration.primary-button.no-translate":[{"type":0,"value":"Show me"}],"test-message-ep-migration.secondary-button.no-translate":[{"type":0,"value":"Not now"}],"test-message-ep-migration.title.no-translate":[{"type":0,"value":"We\'ve made some changes to imports"}],"test-messages.test-message-dynamic-config-sets.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-dynamic-config-sets.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"},{"type":0,"value":" for Dynamic Config Sets"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-dynamic-config-sets.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"Click here to visit Atlassian"}],"test-messages.test-message-dynamic-config-sets.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("ataRH", function(module, exports) {

let $79f50a6629ea02ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79f50a6629ea02ae$var$load("lBItX").then(()=>parcelRequire('31uGK'));

});

parcelRegister("iVDSF", function(module, exports) {

let $dc7c7c54b0380c70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc7c7c54b0380c70$var$load("kSVCU").then(()=>parcelRequire('5bYVO'));

});

parcelRegister("egyQ2", function(module, exports) {

let $a62d9580964ec09e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a62d9580964ec09e$var$load("36m0K").then(()=>parcelRequire('brpuD'));

});

parcelRegister("7hTMh", function(module, exports) {

let $54e5633bfeb3a867$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $54e5633bfeb3a867$var$load("l5ulc").then(()=>parcelRequire('2X04D'));

});

parcelRegister("9PwQo", function(module, exports) {

let $72825a9b8e467a27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72825a9b8e467a27$var$load("fvPob").then(()=>parcelRequire('iCHqy'));

});

parcelRegister("d3zO7", function(module, exports) {

let $981754c0c2b08f29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $981754c0c2b08f29$var$load("ayBsf").then(()=>parcelRequire('egy2G'));

});

parcelRegister("j9Wau", function(module, exports) {

let $df2bfa902441a25f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df2bfa902441a25f$var$load("emwaD").then(()=>parcelRequire('d5TY3'));

});

parcelRegister("9CUci", function(module, exports) {

let $7023414c1785642c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7023414c1785642c$var$load("1eEUv").then(()=>parcelRequire('1S5Pl'));

});

parcelRegister("6Bfr6", function(module, exports) {

let $4ce22c1350f39c53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ce22c1350f39c53$var$load("3YCJK").then(()=>parcelRequire('8LHFQ'));

});

parcelRegister("3497S", function(module, exports) {

let $23b8d314d4037110$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23b8d314d4037110$var$load("8vozI").then(()=>parcelRequire('dD2jW'));

});

parcelRegister("77AfX", function(module, exports) {

let $52f54f9cdc9f649a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52f54f9cdc9f649a$var$load("9hAXj").then(()=>parcelRequire('atX06'));

});

parcelRegister("dzXUT", function(module, exports) {

let $028d1cfdc3739809$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $028d1cfdc3739809$var$load("3svdp").then(()=>parcelRequire('jo8P3'));

});

parcelRegister("hKCnd", function(module, exports) {

let $cec47fbc5bbc5527$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cec47fbc5bbc5527$var$load("hOwiJ").then(()=>parcelRequire('g2JYO'));

});

parcelRegister("7KWe1", function(module, exports) {

let $5a59fe908e0be886$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a59fe908e0be886$var$load("4CzOJ").then(()=>parcelRequire('lx74m'));

});

parcelRegister("k3nPU", function(module, exports) {

let $e99693d1791d007e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e99693d1791d007e$var$load("a4fef").then(()=>parcelRequire('dIYg0'));

});

parcelRegister("5OEJ7", function(module, exports) {

let $43c136bb28b2ac9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43c136bb28b2ac9a$var$load("54Xdr").then(()=>parcelRequire('e6gZF'));

});

parcelRegister("jJeXe", function(module, exports) {

let $e5cdd1ef5013bec0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e5cdd1ef5013bec0$var$load("1tt8h").then(()=>parcelRequire('bYNsj'));

});

parcelRegister("PRNRE", function(module, exports) {

let $09be7fbe001228f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $09be7fbe001228f2$var$load("3S1yh").then(()=>parcelRequire('4Q8DQ'));

});

parcelRegister("7VRWF", function(module, exports) {

let $5c67b3a804177048$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c67b3a804177048$var$load("iL51d").then(()=>parcelRequire('kaebT'));

});

parcelRegister("gLLIP", function(module, exports) {

let $c3560dbfbf144e15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3560dbfbf144e15$var$load("h0F5J").then(()=>parcelRequire('h2dz4'));

});

parcelRegister("jDPqE", function(module, exports) {

let $e4c98d83eeacbf6a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e4c98d83eeacbf6a$var$load("eg5Vt").then(()=>parcelRequire('7rKZY'));

});

parcelRegister("eX5es", function(module, exports) {

let $ae2aa25b4c531b8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae2aa25b4c531b8f$var$load("8BSfm").then(()=>parcelRequire('iRb0J'));

});

parcelRegister("lqLSP", function(module, exports) {

let $f9a12b49cff2f80d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9a12b49cff2f80d$var$load("9vrHg").then(()=>parcelRequire('1oNo1'));

});

parcelRegister("bdSSO", function(module, exports) {

let $82bb7b386af0b1f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82bb7b386af0b1f9$var$load("cpkgc").then(()=>parcelRequire('3qHuK'));

});

parcelRegister("eHKx8", function(module, exports) {

let $ab492d6b72091b0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab492d6b72091b0b$var$load("eWSIh").then(()=>parcelRequire('2wI1J'));

});

parcelRegister("8fwnI", function(module, exports) {

let $6018d7b904347a87$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6018d7b904347a87$var$load("71LY3").then(()=>parcelRequire('85TgC'));

});

parcelRegister("74Qrr", function(module, exports) {

let $527195f03563a561$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $527195f03563a561$var$load("f0ygr").then(()=>parcelRequire('a7VHR'));

});

parcelRegister("aKmhn", function(module, exports) {

let $7d2f7b7ba324a96c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d2f7b7ba324a96c$var$load("iRyQ2").then(()=>parcelRequire('5YrYw'));

});

parcelRegister("4D3g4", function(module, exports) {

let $35ed54f5b2d3a6af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35ed54f5b2d3a6af$var$load("hGUOp").then(()=>parcelRequire('gtm5A'));

});

parcelRegister("fPs3d", function(module, exports) {

let $b86160bf1071a1ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b86160bf1071a1ef$var$load("kHjAO").then(()=>parcelRequire('bWvw5'));

});

parcelRegister("5JFQ2", function(module, exports) {

let $42d19beb1dd75d19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42d19beb1dd75d19$var$load("d4W4R").then(()=>parcelRequire('4XQAE'));

});

parcelRegister("iJfcJ", function(module, exports) {

let $da28393d3539cb16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da28393d3539cb16$var$load("eu8Ln").then(()=>parcelRequire('dBWcz'));

});

parcelRegister("aUGzw", function(module, exports) {

let $7f202843bdee8e07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f202843bdee8e07$var$load("2IpmP").then(()=>parcelRequire('duHSx'));

});

parcelRegister("5fR79", function(module, exports) {

let $3d378ddec03c4f4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d378ddec03c4f4d$var$load("apRJp").then(()=>parcelRequire('gpPjY'));

});

parcelRegister("k2auA", function(module, exports) {
module.exports = JSON.parse('{"confluence-ai-audio.scenario-changeboarding.backButton":[{"type":0,"value":"Back"}],"confluence-ai-audio.scenario-changeboarding.doneButton":[{"type":0,"value":"Done"}],"confluence-ai-audio.scenario-changeboarding.nextButton":[{"type":0,"value":"Next"}],"confluence-ai-audio.scenario-changeboarding.step1Body":[{"type":0,"value":"Not ready to listen? Add it to your playlist for later or play it on the app."}],"confluence-ai-audio.scenario-changeboarding.step1Headline":[{"type":0,"value":"Save it"}],"confluence-ai-audio.scenario-changeboarding.step2Body":[{"type":0,"value":"See what\u2019s next, change the order, or start playing."}],"confluence-ai-audio.scenario-changeboarding.step2Headline":[{"type":0,"value":"Open playlist"}],"confluence-ai-audio.scenario-changeboarding.step3Body":[{"type":0,"value":"Copy and share a link so anyone with access can listen."}],"confluence-ai-audio.scenario-changeboarding.step3Headline":[{"type":0,"value":"Share it"}],"confluence-ai-audio.scenario-changeboarding.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"post-office.audio-button-spotlight.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2 hello there"}],"post-office.audio-player-spotlight-tour.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}]}');

});

parcelRegister("FwuiN", function(module, exports) {

let $07cd07d6dc583847$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07cd07d6dc583847$var$load("bvzn7").then(()=>parcelRequire('7ZQnz'));

});

parcelRegister("eNgNU", function(module, exports) {

let $ac52ad316f16984d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac52ad316f16984d$var$load("4JNj3").then(()=>parcelRequire('3uIoZ'));

});

parcelRegister("lUgKS", function(module, exports) {

let $ff2bd3270ec6506a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff2bd3270ec6506a$var$load("6Sc8a").then(()=>parcelRequire('53xVm'));

});

parcelRegister("7ThjH", function(module, exports) {

let $5beb1a2e5594f9de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5beb1a2e5594f9de$var$load("5PMZ7").then(()=>parcelRequire('kbnAl'));

});

parcelRegister("9sv9x", function(module, exports) {

let $6e2ee4e4df261b33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e2ee4e4df261b33$var$load("eFPiR").then(()=>parcelRequire('bzJlI'));

});

parcelRegister("782SK", function(module, exports) {

let $530b840db98fa19c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $530b840db98fa19c$var$load("gNoLM").then(()=>parcelRequire('gM5CY'));

});

parcelRegister("fKkKP", function(module, exports) {

let $b76b4048b41d8f5d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b76b4048b41d8f5d$var$load("jfLa3").then(()=>parcelRequire('2UqKe'));

});

parcelRegister("5cj9Q", function(module, exports) {

let $3c8cef132fae3feb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c8cef132fae3feb$var$load("aXEGC").then(()=>parcelRequire('5rcuK'));

});

parcelRegister("i1khq", function(module, exports) {

let $d1e80d306523600c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1e80d306523600c$var$load("8LJb5").then(()=>parcelRequire('3dnnL'));

});

parcelRegister("SNoUr", function(module, exports) {

let $0a4b5d3921ed3aec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a4b5d3921ed3aec$var$load("cZ1pB").then(()=>parcelRequire('l0pmC'));

});

parcelRegister("1cRIF", function(module, exports) {

let $0e1094fabe83d0b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e1094fabe83d0b0$var$load("ffzdy").then(()=>parcelRequire('lHuP1'));

});

parcelRegister("dzVtf", function(module, exports) {

let $9e2b1fc193892750$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e2b1fc193892750$var$load("d27F7").then(()=>parcelRequire('k1dfP'));

});

parcelRegister("gRM9j", function(module, exports) {

let $c476f20187ea9a56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c476f20187ea9a56$var$load("hQMun").then(()=>parcelRequire('bIE2F'));

});

parcelRegister("9Mae7", function(module, exports) {

let $71e08791f2407bc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71e08791f2407bc2$var$load("3mvse").then(()=>parcelRequire('cDWwk'));

});

parcelRegister("8qc8Y", function(module, exports) {

let $621a2beb62bd4b0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $621a2beb62bd4b0c$var$load("iNJuM").then(()=>parcelRequire('5a4ee'));

});

parcelRegister("hENPP", function(module, exports) {

let $cdacd448d6128674$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cdacd448d6128674$var$load("kTLg7").then(()=>parcelRequire('53Dtk'));

});

parcelRegister("h9rEa", function(module, exports) {

let $c7c8b905ad4c37ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7c8b905ad4c37ef$var$load("fuRbZ").then(()=>parcelRequire('lSkKw'));

});

parcelRegister("4Uw1Y", function(module, exports) {

let $39353d0d88612d1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $39353d0d88612d1d$var$load("lgdty").then(()=>parcelRequire('arOdO'));

});

parcelRegister("a2LSY", function(module, exports) {

let $74ff3c6788cedd07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $74ff3c6788cedd07$var$load("2Zf1V").then(()=>parcelRequire('irsZi'));

});

parcelRegister("jTUwT", function(module, exports) {

let $e7cf00f952d7eddb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e7cf00f952d7eddb$var$load("j01vV").then(()=>parcelRequire('8sQ1G'));

});

parcelRegister("6kNHQ", function(module, exports) {

let $49cb2aec3bc44cd9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49cb2aec3bc44cd9$var$load("32Y6K").then(()=>parcelRequire('jjbTG'));

});

parcelRegister("dLmOX", function(module, exports) {

let $a0515de5ab0b10f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0515de5ab0b10f9$var$load("ID2Zz").then(()=>parcelRequire('l9iLx'));

});

parcelRegister("aCYfF", function(module, exports) {

let $7bcc30be605c5e67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7bcc30be605c5e67$var$load("fqmZx").then(()=>parcelRequire('b0sxg'));

});

parcelRegister("fWbyw", function(module, exports) {

let $b9a53c8a52a3d189$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9a53c8a52a3d189$var$load("83g46").then(()=>parcelRequire('fcV88'));

});

parcelRegister("as9ur", function(module, exports) {

let $79c3e16d3782ac4d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79c3e16d3782ac4d$var$load("j0xox").then(()=>parcelRequire('3rW6P'));

});

parcelRegister("5x5w9", function(module, exports) {

let $407450809c1f159e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $407450809c1f159e$var$load("dabrh").then(()=>parcelRequire('3j7l0'));

});

parcelRegister("eJkio", function(module, exports) {

let $ab9502f855e9ad6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab9502f855e9ad6e$var$load("awyMj").then(()=>parcelRequire('gwSds'));

});

parcelRegister("e1SWB", function(module, exports) {

let $a36bc770510d36cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a36bc770510d36cc$var$load("k8KoF").then(()=>parcelRequire('deuDv'));

});

parcelRegister("e8j4V", function(module, exports) {

let $a4a09c9ca2aad9fb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4a09c9ca2aad9fb$var$load("kNvQj").then(()=>parcelRequire('41hqQ'));

});

parcelRegister("4ZM8U", function(module, exports) {

let $3a32341711b3f31c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a32341711b3f31c$var$load("6ccwN").then(()=>parcelRequire('2F5Ek'));

});

parcelRegister("kljmN", function(module, exports) {

let $ecf4caa42c8a43de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecf4caa42c8a43de$var$load("jIVAP").then(()=>parcelRequire('8YtHg'));

});

parcelRegister("eZ572", function(module, exports) {

let $ae8aba7095cc27bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae8aba7095cc27bb$var$load("8Hnn3").then(()=>parcelRequire('7tZTX'));

});

parcelRegister("62Cc4", function(module, exports) {

let $46608e741d193fbd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46608e741d193fbd$var$load("goxlR").then(()=>parcelRequire('dEcBE'));

});

parcelRegister("8MpM5", function(module, exports) {

let $6646ccb97ff7db94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6646ccb97ff7db94$var$load("kZJPe").then(()=>parcelRequire('2f9bg'));

});

parcelRegister("cPGgH", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bQrvV = parcelRequire("bQrvV");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $99171129d9ff45eb$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $99171129d9ff45eb$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("cpSk1")));
        case 'da':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("622ag")));
        case 'de':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("csCHj")));
        case 'en-GB':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("f092a")));
        case 'en-US':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("csMAX")));
        case 'en-XA':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("2NFXt")));
        case 'en-XB':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("10Zqj")));
        case 'en-ZZ':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("05jcL")));
        case 'en':
            return $99171129d9ff45eb$var$importHelper(await Promise.resolve((parcelRequire("bQrvV"))));
        case 'es':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("5vT4Z")));
        case 'et':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("6MxWE")));
        case 'fi':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("jkrtb")));
        case 'fr':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("e8ELh")));
        case 'hr':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("htzXe")));
        case 'hu':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("d4Y8k")));
        case 'it':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("dBygo")));
        case 'ja':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("fCWQ3")));
        case 'ko':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("2SxP3")));
        case 'nb':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("buXeC")));
        case 'nl':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("k21Fm")));
        case 'pl':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("661RS")));
        case 'pt-BR':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("9BqLL")));
        case 'ro':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("7Emfi")));
        case 'ru':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("aJaB7")));
        case 'sl':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("bL6Nd")));
        case 'sr-RS':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("jTbhu")));
        case 'sr-YR':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("7jSCk")));
        case 'sr':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("i7TsA")));
        case 'sv':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("367uj")));
        case 'th':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("15oq5")));
        case 'tr':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("iE3aS")));
        case 'uk':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("joVfM")));
        case 'vi':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("2pZgu")));
        case 'zh-CN':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("e7OsV")));
        case 'zh-TW':
            return $99171129d9ff45eb$var$importHelper(await (parcelRequire("1oGo1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bQrvV));
    }
};
module.exports["messagesLoader"] = $99171129d9ff45eb$export$720676d8cac8fbb;

});

parcelRegister("bQrvV", function(module, exports) {
module.exports = JSON.parse('{"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.primary.no-pde":[{"type":0,"value":"Try it free"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.primary.pde":[{"type":0,"value":"Try now"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.action.secondary":[{"type":0,"value":"No thanks"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.body.has-payment":[{"type":0,"value":"Billing starts after "},{"type":1,"value":"trialEndDate"},{"type":0,"value":". We\u2019ll remind you before your trial ends. Downgrade to Free or "},{"children":[{"type":0,"value":"switch plans"}],"type":8,"value":"Link"},{"type":0,"value":" anytime."}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.body.no-payment":[{"type":0,"value":"After your trial you can stay on your plan or downgrade to a free plan. "},{"children":[{"type":0,"value":"Explore plans"}],"type":8,"value":"Link"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.header":[{"type":0,"value":"Welcome to your "},{"offset":0,"options":{"=1":{"value":[{"type":7},{"type":0,"value":"-day"}]},"other":{"value":[{"type":7},{"type":0,"value":"-day"}]}},"pluralType":"cardinal","type":6,"value":"trialLength"},{"type":0,"value":" free trial "},{"options":{"other":{"value":[]},"premium":{"value":[{"type":0,"value":"of Premium"}]},"standard":{"value":[{"type":0,"value":"of Standard"}]}},"type":5,"value":"edition"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature1":[{"type":0,"value":"See user data and insights in one place"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature2":[{"type":0,"value":"Control who can view, edit, and comment"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.premium.feature3":[{"type":0,"value":"Create unlimited whiteboards"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature1":[{"type":0,"value":"Share read-only pages with external stakeholders"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature2":[{"type":0,"value":"Automate repetitive tasks"}],"growth-transmuters.confluence-auto-provisioning-edition-parity-trial-dialog.placement.standard.feature3":[{"type":0,"value":"Control who can edit and comment"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.admin-key":[{"children":[{"type":0,"value":"Admin key"}],"type":8,"value":"b"},{"type":0,"value":": Access restricted content so you can fix bugs, fast"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.automation":[{"children":[{"type":0,"value":"Automation"}],"type":8,"value":"b"},{"type":0,"value":": 10x more rule runs per month"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.page-insights":[{"children":[{"type":0,"value":"Page insights"}],"type":8,"value":"b"},{"type":0,"value":": See who viewed your page and when"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.page-permissions":[{"children":[{"type":0,"value":"Page permissions"}],"type":8,"value":"b"},{"type":0,"value":": Choose who can view, edit, and comment"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.rovo":[{"children":[{"type":0,"value":"Rovo"}],"type":8,"value":"b"},{"type":0,"value":": AI-powered search, chat, and agents"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.benefits.space-permissions":[{"children":[{"type":0,"value":"Space permissions"}],"type":8,"value":"b"},{"type":0,"value":": Choose who can access entire folders"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.admin-features-title":[{"type":0,"value":"You also get more admin features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Archive\' feature on the Confluence Standard plan. This will make it easy to archive outdated content and keep things tidy."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Archive\' feature on the Confluence Standard plan. This will make it easy to archive outdated content and keep things tidy."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Archive\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.no-name.title":[{"type":0,"value":"Help your team keep Confluence work tidy and up-to-date"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Archive\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.archive.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" keep Confluence work tidy and up-to-date"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Calendars\' feature on the Confluence Premium plan. This will make it easy to plan deadlines and time off across teams."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Calendars\' feature on the Confluence Premium plan. This will make it easy to plan deadlines and time off across teams."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Calendars\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.no-name.title":[{"type":0,"value":"Help your team balance downtime with deadlines"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Calendars\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.calendars.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" balance downtime with deadlines"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try features on the Confluence Standard plan."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.description":[{"type":0,"value":"Someone on your team has requested to try features on the Confluence Standard plan."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try new features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.no-name.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try new features"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.edition-awareness.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.explore-all-features":[{"type":0,"value":"Explore all features \u2192"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.get-started-button":[{"type":0,"value":"Get Started"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Confluence logo"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Pages insights and analytics\' feature on the Confluence Standard plan. This will make it easy to see user engagement and make more informed decisions"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Pages insights and analytics\' feature on the Confluence Standard plan. This will make it easy to see user engagement and make more informed decisions"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Page insights\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.no-name.title":[{"type":0,"value":"Unlock data and insights for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Page insights\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-insights.title":[{"type":0,"value":"Unlock data and insights for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try the \'Page permissions\' feature on the Confluence Standard plan. This will makes it easy to decide who can edit, view, and comment on pages."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Page permissions\' feature on the Confluence Standard plan. This will makes it easy to decide who can edit, view, and comment on pages."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Page permissions\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.no-name.title":[{"type":0,"value":"Help your team share more and worry less"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try \'Page permissions\'"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.page-permissions.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" share more and worry less"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested to try Rovo (AI) on the Confluence Standard plan. This will make it easy to summarize pages, get writing help, and generate ideas, fast."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.description":[{"type":0,"value":"Someone on your team has requested to try Rovo (AI) on the Confluence Standard plan. This will make it easy to summarize pages, get writing help, and generate ideas, fast."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try Rovo (AI)"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.no-name.title":[{"type":0,"value":"Unlock improved writing and more creativity for your team"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" wants to try Rovo (AI)"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.rovo.title":[{"type":0,"value":"Unlock improved writing and more creativity for "},{"type":1,"value":"requesterFullName"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.upgrade-trial-edition-info":[{"type":0,"value":"Grant access on a "},{"children":[{"type":0,"value":"free"}],"type":8,"value":"b"},{"type":0,"value":", "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."},{"type":1,"value":"br"},{"children":[{"type":0,"value":"Cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":". We\'ll remind you 3 days before your trial ends."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.description":[{"type":1,"value":"requesterFullName"},{"type":0,"value":" has requested access to more whiteboards on the Confluence Premium plan. This will unlock unlimited whiteboards."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.description":[{"type":0,"value":"Someone on your team has requested access to more whiteboards on the Confluence Premium plan. This will unlock unlimited whiteboards."}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team needs more Confluence whiteboards"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.no-name.title":[{"type":0,"value":"Help your team turn ideas into action"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" needs more Confluence whiteboards"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.body.whiteboards.title":[{"type":0,"value":"Help "},{"type":1,"value":"requesterFullName"},{"type":0,"value":" turn ideas into action"}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"growth-transmuters.confluence-feature-gates-end-user-upgrade-request.message-template-template.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-transmuters.edition-upgrade-system.email.automation":[{"children":[{"type":0,"value":"Scale automation."}],"type":8,"value":"strong"},{"type":0,"value":" 750 automation steps per user per month."}],"growth-transmuters.edition-upgrade-system.email.considerUpgrade":[{"type":0,"value":"Decide if you need to upgrade your Jira plan for more space"}],"growth-transmuters.edition-upgrade-system.email.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-transmuters.edition-upgrade-system.email.features":[{"type":0,"value":"Jira Premium comes with better features"}],"growth-transmuters.edition-upgrade-system.email.fullDescriptionWithGracePeriod":[{"type":1,"value":"name"},{"type":0,"value":", we\u2019re reaching out as your team has "},{"options":{"exceeded":{"value":[{"type":0,"value":"exceeded"}]},"other":{"value":[{"type":0,"value":"reached"}]}},"type":5,"value":"storageStatus"},{"type":0,"value":" the "},{"children":[{"type":1,"value":"limit"},{"type":0,"value":" GB storage allowance"}],"type":8,"value":"strong"},{"type":0,"value":" on Jira Standard."}],"growth-transmuters.edition-upgrade-system.email.fullTitleWithGracePeriod":[{"type":0,"value":"Review your team\u2019s Jira storage"}],"growth-transmuters.edition-upgrade-system.email.gracePeriod":[{"type":0,"value":"Your current files remain safe however in 7 days your team won\u2019t be able to upload new files until you get more space."}],"growth-transmuters.edition-upgrade-system.email.logo":[{"type":0,"value":"Jira logo"}],"growth-transmuters.edition-upgrade-system.email.nameFallback":[{"type":0,"value":"Hello"}],"growth-transmuters.edition-upgrade-system.email.nearlyFullDescription":[{"type":0,"value":"Your team is approaching the "},{"type":1,"value":"limit"},{"type":0,"value":" GB allowance for Jira Standard. If your team exceeds this limit, they won\'t be able to add attachments to their work."}],"growth-transmuters.edition-upgrade-system.email.nearlyFullTitle":[{"type":0,"value":"Upgrade now to avoid disruptions"}],"growth-transmuters.edition-upgrade-system.email.planning":[{"children":[{"type":0,"value":"Cross-team planning."}],"type":8,"value":"strong"},{"type":0,"value":" Easily manage dependencies."}],"growth-transmuters.edition-upgrade-system.email.remaining":[{"type":1,"value":"remaining"},{"type":0,"value":" GB left"}],"growth-transmuters.edition-upgrade-system.email.requiredActions":[{"type":0,"value":"What you need to do by "},{"type":1,"value":"date"}],"growth-transmuters.edition-upgrade-system.email.reviewStorage":[{"type":0,"value":"Review and manage your team\u2019s "},{"children":[{"type":0,"value":"current storage"}],"type":8,"value":"manage"}],"growth-transmuters.edition-upgrade-system.email.storage":[{"type":0,"value":"Storage"}],"growth-transmuters.edition-upgrade-system.email.subjectFull":[{"type":0,"value":"[Action Required] Your storage is full - upgrade now"}],"growth-transmuters.edition-upgrade-system.email.subjectNearlyFull":[{"type":0,"value":"Approaching storage limit - upgrade now"}],"growth-transmuters.edition-upgrade-system.email.support":[{"children":[{"type":0,"value":"24/7 support."}],"type":8,"value":"strong"},{"type":0,"value":" 1 hour response time for critical issues."}],"growth-transmuters.edition-upgrade-system.email.trialOffer":[{"type":0,"value":"Get unlimited storage with Jira Premium, free for 30 days."}],"growth-transmuters.edition-upgrade-system.email.tryPremium":[{"type":0,"value":"Try Jira Premium free for 30 days to see how "},{"children":[{"type":0,"value":"unlimited storage"}],"type":8,"value":"strong"},{"type":0,"value":" works for your team"}],"growth-transmuters.edition-upgrade-system.email.upgrade":[{"type":0,"value":"Upgrade"}],"growth-transmuters.edition-upgrade-system.email.used":[{"type":0,"value":"Using "},{"type":1,"value":"used"},{"type":0,"value":" GB of "},{"type":1,"value":"limit"},{"type":0,"value":" GB"}],"growth-transmuters.edition-upgrade.email.storage.description":[{"type":1,"value":"name"},{"type":0,"value":" has sent a request because your team\u2019s storage is full. "},{"children":[{"type":0,"value":"Manage files"}],"type":8,"value":"manageFiles"},{"type":0,"value":" to free up space or upgrade to "},{"type":1,"value":"product"},{"type":0,"value":" "},{"type":1,"value":"editionName"},{"type":0,"value":" now for "},{"options":{"other":{"value":[{"type":0,"value":"more storage"}]},"premium":{"value":[{"type":0,"value":"unlimited storage"}]}},"type":5,"value":"edition"},{"type":0,"value":"."}],"growth-transmuters.edition-upgrade.email.storage.label":[{"type":0,"value":"Storage"}],"growth-transmuters.edition-upgrade.email.storage.logo":[{"type":1,"value":"product"},{"type":0,"value":" logo"}],"growth-transmuters.edition-upgrade.email.storage.quote":[{"type":0,"value":"\u201C"},{"type":1,"value":"message"},{"type":0,"value":"\u201D"}],"growth-transmuters.edition-upgrade.email.storage.remaining":[{"type":1,"value":"remaining"},{"type":0,"value":" GB left"}],"growth-transmuters.edition-upgrade.email.storage.request":[{"type":1,"value":"name"},{"type":0,"value":"\u2019s request"}],"growth-transmuters.edition-upgrade.email.storage.subject":[{"type":0,"value":"[Approval Required] "},{"type":1,"value":"name"},{"type":0,"value":" needs more storage - upgrade now"}],"growth-transmuters.edition-upgrade.email.storage.teammate":[{"type":0,"value":"A teammate"}],"growth-transmuters.edition-upgrade.email.storage.title":[{"type":0,"value":"Your team can\u2019t add attachments"}],"growth-transmuters.edition-upgrade.email.storage.trial-offer":[{"type":0,"value":"Free for "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"days"},{"type":0,"value":", cancel anytime."}],"growth-transmuters.edition-upgrade.email.storage.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"growth-transmuters.edition-upgrade.email.storage.upgrade":[{"type":0,"value":"Upgrade"}],"growth-transmuters.edition-upgrade.email.storage.used":[{"type":0,"value":"Using "},{"type":1,"value":"used"},{"type":0,"value":" GB of "},{"type":1,"value":"limit"},{"type":0,"value":" GB"}],"growth-transmuters.edition-upgrade.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"growth-transmuters.edition-upgrade.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"growth-transmuters.edition-upgrade.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"growth-transmuters.edition-upgrade.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"growth-transmuters.edition-upgrade.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"growth-transmuters.edition-upgrade.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"growth-transmuters.edition-upgrade.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"growth-transmuters.edition-upgrade.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"growth-transmuters.recent-downgrade-discount-email.email.benefit.automation-steps":[{"type":0,"value":"Get more automation steps and AI credits"}],"growth-transmuters.recent-downgrade-discount-email.email.benefit.automation-steps-per-user":[{"type":0,"value":"Get more automation steps per user"}],"growth-transmuters.recent-downgrade-discount-email.email.benefit.cancel":[{"type":0,"value":"Cancel or switch back anytime"}],"growth-transmuters.recent-downgrade-discount-email.email.benefit.loom-videos":[{"type":0,"value":"Get unlimited Loom videos and easy editing"}],"growth-transmuters.recent-downgrade-discount-email.email.benefit.pickup":[{"type":0,"value":"Instantly pick up where you left off"}],"growth-transmuters.recent-downgrade-discount-email.email.benefits.title-last-chance":[{"type":0,"value":"Last chance"}],"growth-transmuters.recent-downgrade-discount-email.email.body-offer-ends":[{"type":0,"value":"Your offer to restore "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"editionName"},{"type":0,"value":" and get "},{"children":[{"type":0,"value":"20% off your bill for 3 months"}],"type":8,"value":"b"},{"children":[{"type":0,"value":"*"}],"type":8,"value":"sup"},{"type":0,"value":" ends on "},{"type":1,"value":"expiryDate"},{"type":0,"value":". After that, the discount won\u2019t be available."}],"growth-transmuters.recent-downgrade-discount-email.email.cta":[{"type":0,"value":"Claim offer"}],"growth-transmuters.recent-downgrade-discount-email.email.expiry-date":[{"children":[{"type":0,"value":"*"}],"type":8,"value":"sup"},{"type":0,"value":"Offer expires "},{"type":1,"value":"expiryDate"}],"growth-transmuters.recent-downgrade-discount-email.email.heading-ends-soon":[{"type":0,"value":"Your 20% off ends soon"}],"growth-transmuters.recent-downgrade-discount-email.email.hero.alt":[{"type":0,"value":"Discount savings illustration"}],"growth-transmuters.recent-downgrade-discount-email.message-template.email.preheader":[{"type":0,"value":"One-time offer"}],"growth-transmuters.recent-downgrade-discount-email.message-template.email.subject-offer-ends":[{"type":0,"value":"Your 20% off "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"editionName"},{"type":0,"value":" offer ends "},{"type":1,"value":"expiryDate"}],"growth-transmuters.recent-downgrade-discount.banner.cta":[{"type":0,"value":"View offer"}],"growth-transmuters.recent-downgrade-discount.banner.title":[{"type":0,"value":"Get 20% off 3 months of "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"}],"growth-transmuters.recent-downgrade-discount.modal.body":[{"type":0,"value":"Restore your "},{"type":1,"value":"productName"},{"type":0,"value":" "},{"type":1,"value":"edition"},{"type":0,"value":" plan today and get 20% off your bill for 3 months."},{"children":[{"type":0,"value":"*"}],"type":8,"value":"sup"}],"growth-transmuters.recent-downgrade-discount.modal.feature.automation-steps":[{"type":0,"value":"Get more automation steps and AI credits"}],"growth-transmuters.recent-downgrade-discount.modal.feature.automation-steps-per-user":[{"type":0,"value":"Get more automation steps per user"}],"growth-transmuters.recent-downgrade-discount.modal.feature.cancel":[{"type":0,"value":"Cancel or switch back anytime"}],"growth-transmuters.recent-downgrade-discount.modal.feature.pick-up":[{"type":0,"value":"Instantly pick up where you left off"}],"growth-transmuters.recent-downgrade-discount.modal.footnote":[{"children":[{"type":0,"value":"*"}],"type":8,"value":"sup"},{"type":0,"value":"Offer expires on "},{"type":1,"value":"expiryDate"}],"growth-transmuters.recent-downgrade-discount.modal.heading":[{"type":0,"value":"Get 20% off your next 3 months"}],"growth-transmuters.recent-downgrade-discount.modal.primary-action":[{"type":0,"value":"Claim offer"}],"growth-transmuters.recent-downgrade-discount.modal.secondary-action":[{"type":0,"value":"No thanks"}],"post-office.adminhub-pls-contact-sales.body":[{"type":0,"value":"Make sure you\u2019re on the right plan. "},{"children":[{"type":0,"value":"Contact sales"}],"type":8,"value":"Link"}],"post-office.growth-transmuters.edition-upgrade-system.slack.manage-storage-button":[{"type":0,"value":"Manage storage"}],"post-office.growth-transmuters.edition-upgrade-system.slack.storage-full-grace-period":[{"type":0,"value":"Your team has exceeded the "},{"children":[{"style":null,"type":2,"value":"storageLimit"},{"type":0,"value":" GB storage allowance"}],"type":8,"value":"strong"},{"type":0,"value":" on Jira Standard. You can keep adding attachments to work for 7 days and then you\u2019ll need to get more space. Upgrade for unlimited storage or manage your current storage now."}],"post-office.growth-transmuters.edition-upgrade-system.slack.storage-nearly-full":[{"type":0,"value":"Your org has used "},{"style":null,"type":2,"value":"storageUsed"},{"type":0,"value":" GB of your "},{"style":null,"type":2,"value":"storageLimit"},{"type":0,"value":" GB storage allowance for "},{"type":1,"value":"siteHost"},{"type":0,"value":". To avoid being blocked from adding new attachments, delete files or upgrade for unlimited storage."}],"post-office.growth-transmuters.edition-upgrade-system.slack.turn-off-notifications":[{"type":0,"value":"Turn off these notifications"}],"post-office.growth-transmuters.edition-upgrade-system.slack.upgrade-button":[{"type":0,"value":"Upgrade"}],"post-office.growth-transmuters.edition-upgrade-with-digest.slack.manage-files-button":[{"type":0,"value":"Manage files"}],"post-office.growth-transmuters.edition-upgrade-with-digest.slack.requester-fallback":[{"type":0,"value":"A teammate"}],"post-office.growth-transmuters.edition-upgrade-with-digest.slack.storage-request":[{"type":1,"value":"requesterName"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"otherRequesterCount"},{"type":0,"value":" have requested storage for "},{"type":1,"value":"siteHost"},{"type":0,"value":" because you\u2019ve reached 100% of your allowance. Delete files or upgrade for unlimited storage to get more space."}],"post-office.growth-transmuters.edition-upgrade-with-digest.slack.turn-off-notifications":[{"type":0,"value":"Turn off these notifications"}],"post-office.growth-transmuters.edition-upgrade-with-digest.slack.upgrade-button":[{"type":0,"value":"Upgrade"}],"post-office.growth-transmuters.edition-upgrade.slack.manage-files-button":[{"type":0,"value":"Manage files"}],"post-office.growth-transmuters.edition-upgrade.slack.product.jira":[{"type":0,"value":"Jira"}],"post-office.growth-transmuters.edition-upgrade.slack.requester-fallback":[{"type":0,"value":"A teammate"}],"post-office.growth-transmuters.edition-upgrade.slack.storage-request":[{"type":1,"value":"requesterName"},{"type":0,"value":" has requested storage for "},{"type":1,"value":"siteHost"},{"type":0,"value":" because you\u2019ve reached 100% of your allowance. Delete files or upgrade for unlimited storage to get more space."}],"post-office.growth-transmuters.edition-upgrade.slack.turn-off-notifications":[{"type":0,"value":"Turn off these notifications"}],"post-office.growth-transmuters.edition-upgrade.slack.upgrade-button":[{"type":0,"value":"Upgrade"}],"post-office.xflow-access-request-slack-notification.app-description.confluence":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Confluence, a collaboration app that lets your team create, share, and organize work in pages and spaces."}],"post-office.xflow-access-request-slack-notification.app-description.jira-product-discovery":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Jira Product Discovery, a roadmap and prioritization app that links to your Jira projects."}],"post-office.xflow-access-request-slack-notification.app-description.jira-service-management":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Jira Service Management, an app that helps your team unify and resolve requests faster."}],"post-office.xflow-access-request-slack-notification.app-description.loom":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Loom, an app that lets your team record and embed videos to Jira work items."}],"post-office.xflow-access-request-slack-notification.app-description.service-collection":[{"type":1,"value":"requestorMention"},{"type":0,"value":" "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"needs"}]},"other":{"value":[{"type":0,"value":"need"}]}},"pluralType":"cardinal","type":6,"value":"requestorCount"},{"type":0,"value":" your approval to try Service Collection, a suite of apps designed to help your team unify and resolve requests faster."}],"post-office.xflow-access-request-slack-notification.more-actions-placeholder":[{"type":0,"value":"More actions..."}],"post-office.xflow-access-request-slack-notification.mute-for-1-day":[{"type":0,"value":"Snooze for 1 day"}],"post-office.xflow-access-request-slack-notification.requestor-mention-fallback":[{"type":0,"value":"Someone"}],"post-office.xflow-access-request-slack-notification.review-request-button":[{"type":0,"value":"Review request"}],"post-office.xflow-access-request-slack-notification.turn-off-notifications":[{"type":0,"value":"Turn off these notifications"}]}');

});

parcelRegister("cpSk1", function(module, exports) {

let $90a1f50d1d2b1416$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90a1f50d1d2b1416$var$load("g35Ma").then(()=>parcelRequire('4QBxc'));

});

parcelRegister("622ag", function(module, exports) {

let $46449bcec1261573$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46449bcec1261573$var$load("6jn9l").then(()=>parcelRequire('8Y3mq'));

});

parcelRegister("csCHj", function(module, exports) {

let $91261e1600f9d5c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91261e1600f9d5c3$var$load("1w7fH").then(()=>parcelRequire('aOLQD'));

});

parcelRegister("f092a", function(module, exports) {

let $aebddd0846e692b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aebddd0846e692b6$var$load("6oBxf").then(()=>parcelRequire('6ELUQ'));

});

parcelRegister("csMAX", function(module, exports) {

let $912dcb8e29b485c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $912dcb8e29b485c9$var$load("1TTQt").then(()=>parcelRequire('42HiS'));

});

parcelRegister("2NFXt", function(module, exports) {

let $20a0b46ce8c30c97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20a0b46ce8c30c97$var$load("k2w8V").then(()=>parcelRequire('ckJbb'));

});

parcelRegister("10Zqj", function(module, exports) {

let $0bd56feb8dd7e8d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bd56feb8dd7e8d1$var$load("9DH1A").then(()=>parcelRequire('ieHus'));

});

parcelRegister("05jcL", function(module, exports) {

let $00ff5d6ecf74786d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00ff5d6ecf74786d$var$load("88qtk").then(()=>parcelRequire('jxpfs'));

});

parcelRegister("5vT4Z", function(module, exports) {

let $403a92a8756dbd19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $403a92a8756dbd19$var$load("loV6E").then(()=>parcelRequire('77b9f'));

});

parcelRegister("6MxWE", function(module, exports) {

let $4f018e8889326f17$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f018e8889326f17$var$load("3Afk1").then(()=>parcelRequire('iBq85'));

});

parcelRegister("jkrtb", function(module, exports) {

let $e12531816b8c362d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e12531816b8c362d$var$load("3xvJH").then(()=>parcelRequire('lqPWc'));

});

parcelRegister("e8ELh", function(module, exports) {

let $a4b16e700c761f03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4b16e700c761f03$var$load("eYO04").then(()=>parcelRequire('eZwXN'));

});

parcelRegister("htzXe", function(module, exports) {

let $cb9108e665b2473d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb9108e665b2473d$var$load("6GuZx").then(()=>parcelRequire('7Gd74'));

});

parcelRegister("d4Y8k", function(module, exports) {

let $985a4b54ac51ed9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $985a4b54ac51ed9a$var$load("4Afn2").then(()=>parcelRequire('faPS9'));

});

parcelRegister("dBygo", function(module, exports) {

let $9e794f0dd06ee016$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e794f0dd06ee016$var$load("5t7J7").then(()=>parcelRequire('7hUXJ'));

});

parcelRegister("fCWQ3", function(module, exports) {

let $b6080bc0e0a65df4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b6080bc0e0a65df4$var$load("fPagA").then(()=>parcelRequire('hnXKn'));

});

parcelRegister("2SxP3", function(module, exports) {

let $218adc5e77d7c994$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $218adc5e77d7c994$var$load("dsh71").then(()=>parcelRequire('UPOf6'));

});

parcelRegister("buXeC", function(module, exports) {

let $85f071deaacbec1f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85f071deaacbec1f$var$load("03jrX").then(()=>parcelRequire('6KaWf'));

});

parcelRegister("k21Fm", function(module, exports) {

let $e9554962cb82ad3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9554962cb82ad3b$var$load("gebmR").then(()=>parcelRequire('fCrX6'));

});

parcelRegister("661RS", function(module, exports) {

let $4704c0949f943088$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4704c0949f943088$var$load("4YGt1").then(()=>parcelRequire('4WseD'));

});

parcelRegister("9BqLL", function(module, exports) {

let $6fdc55964817abb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fdc55964817abb0$var$load("9amHO").then(()=>parcelRequire('2R34W'));

});

parcelRegister("7Emfi", function(module, exports) {

let $591d865fd9037a24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $591d865fd9037a24$var$load("42zva").then(()=>parcelRequire('4PQWi'));

});

parcelRegister("aJaB7", function(module, exports) {

let $7cf653cf98ba3b79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7cf653cf98ba3b79$var$load("cxvqH").then(()=>parcelRequire('gEZFl'));

});

parcelRegister("bL6Nd", function(module, exports) {

let $88f95a6b2426247b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88f95a6b2426247b$var$load("aEBds").then(()=>parcelRequire('5cY7z'));

});

parcelRegister("jTbhu", function(module, exports) {

let $e7abe78a8966ef8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e7abe78a8966ef8b$var$load("4QuXE").then(()=>parcelRequire('7GUuE'));

});

parcelRegister("7jSCk", function(module, exports) {

let $5544ac9d4c2c861c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5544ac9d4c2c861c$var$load("fZbef").then(()=>parcelRequire('kPEZr'));

});

parcelRegister("i7TsA", function(module, exports) {

let $d323e6a9b0d666d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d323e6a9b0d666d5$var$load("hfdfW").then(()=>parcelRequire('kdN1v'));

});

parcelRegister("367uj", function(module, exports) {

let $2417bd909c0c1fce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2417bd909c0c1fce$var$load("cnTvB").then(()=>parcelRequire('26AyV'));

});

parcelRegister("15oq5", function(module, exports) {

let $0ca9335537ae199c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ca9335537ae199c$var$load("4zZgK").then(()=>parcelRequire('2gf0n'));

});

parcelRegister("iE3aS", function(module, exports) {

let $d92e6ccdf341560c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d92e6ccdf341560c$var$load("lCDYE").then(()=>parcelRequire('7R6gR'));

});

parcelRegister("joVfM", function(module, exports) {

let $e1fcab8f240005db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1fcab8f240005db$var$load("3umn0").then(()=>parcelRequire('7sRBD'));

});

parcelRegister("2pZgu", function(module, exports) {

let $1c2d7088981982e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c2d7088981982e1$var$load("eMrsH").then(()=>parcelRequire('1UyFz'));

});

parcelRegister("e7OsV", function(module, exports) {

let $a488dd87d283bd9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a488dd87d283bd9f$var$load("ffbcZ").then(()=>parcelRequire('eoPFJ'));

});

parcelRegister("1oGo1", function(module, exports) {

let $1048e965e303ff88$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1048e965e303ff88$var$load("ifRct").then(()=>parcelRequire('9tV6z'));

});

parcelRegister("eaqtE", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9UEKm = parcelRequire("9UEKm");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3338d8d57db1759a$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $3338d8d57db1759a$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("T0DBV")));
        case 'da':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("4rnG6")));
        case 'de':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("hcc5H")));
        case 'en-GB':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("7P5xH")));
        case 'en-US':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("gLMuS")));
        case 'en-XA':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("tsPTc")));
        case 'en-XB':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("kpuRB")));
        case 'en-ZZ':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("gvMdu")));
        case 'en':
            return $3338d8d57db1759a$var$importHelper(await Promise.resolve((parcelRequire("9UEKm"))));
        case 'es':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("epPtr")));
        case 'et':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("9kKq1")));
        case 'fi':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("cNuY3")));
        case 'fr':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("8ZR5H")));
        case 'hr':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("kUHWb")));
        case 'hu':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("6Naho")));
        case 'it':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("774Ai")));
        case 'ja':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("9AHDY")));
        case 'ko':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("d7WH4")));
        case 'nb':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("ji2tA")));
        case 'nl':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("i9m1s")));
        case 'pl':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("iAthU")));
        case 'pt-BR':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("luIhB")));
        case 'ro':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("5Xidp")));
        case 'ru':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("eUrQo")));
        case 'sl':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("jr7Ti")));
        case 'sr-RS':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("hvBrV")));
        case 'sr-YR':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("fBcWz")));
        case 'sr':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("aZKQY")));
        case 'sv':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("7uH4q")));
        case 'th':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("auyEA")));
        case 'tr':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("auLEI")));
        case 'uk':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("9zsK0")));
        case 'vi':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("8Ocbg")));
        case 'zh-CN':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("jZfyc")));
        case 'zh-TW':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("7lBAh")));
        case 'zh':
            return $3338d8d57db1759a$var$importHelper(await (parcelRequire("jZfyc")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9UEKm));
    }
};
module.exports["messagesLoader"] = $3338d8d57db1759a$export$720676d8cac8fbb;

});

parcelRegister("9UEKm", function(module, exports) {
module.exports = JSON.parse('{"app-switcher-discovery-section.atlassian-store":[{"type":0,"value":"Marketplace apps"}],"app-switcher-discovery-section.discover-more-products":[{"type":0,"value":"Discover more apps"}],"app-switcher-discovery-section.more-atlassian-products":[{"type":0,"value":"More Atlassian apps"}],"app-switcher-discovery-section.recommended-for-your-team":[{"type":0,"value":"Recommended for your team"}],"confluence-inline-reactions-nudge.description.many-reactions":[{"type":1,"value":"user1"},{"type":0,"value":", "},{"type":1,"value":"user2"},{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" other"},{"offset":0,"options":{"one":{"value":[]},"other":{"value":[{"type":0,"value":"s"}]}},"pluralType":"cardinal","type":6,"value":"count"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.description.no-reactions":[{"type":0,"value":"Be the first one to react"}],"confluence-inline-reactions-nudge.description.one-reaction":[{"type":1,"value":"user"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.description.two-reactions":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" reacted to this page"}],"confluence-inline-reactions-nudge.title":[{"type":0,"value":"Love this page? Let "},{"type":1,"value":"authorName"},{"type":0,"value":" know"}],"confluence.continue.reading.body":[{"children":[{"type":0,"value":"Related reading from "},{"type":1,"value":"pageOwnerName"}],"type":8,"value":"text"}],"confluence.continue.reading.read-now":[{"type":0,"value":"Read now"}],"continue-reading.ai-footer.content-quality":[{"children":[{"type":0,"value":"Content quality may vary"}],"type":8,"value":"text"}],"continue-reading.ai-footer.powered-by-ai":[{"children":[{"type":0,"value":"Powered by AI"}],"type":8,"value":"text"}],"cross-flow-itsm-template.jsm.title":[{"type":0,"value":"Collect IT requests"}],"cross-flow-product-prioritization-template.jpd.title":[{"type":0,"value":"Prioritize ideas"}],"cross-flow-product-request-pending.jpd.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-request-pending.jsm.title":[{"type":0,"value":"Work requests"}],"cross-flow-product-roadmap-template.jpd.title":[{"type":0,"value":"Create a roadmap"}],"cross-flow-work-requests-template.jsm.title":[{"type":0,"value":"Collect requests"}],"first-party-recommendation.reason-1":[{"type":0,"value":"the size of your team"}],"first-party-recommendation.reason-2":[{"type":0,"value":"your existing Atlassian products"}],"growth.app-switcher-discovery-section.flag.description":[{"type":0,"value":"You won\u2019t see this here as often."}],"growth.app-switcher-discovery-section.flag.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"growth.app-switcher-discovery-section.wac-toast.close.aria-label":[{"type":0,"value":"Dismiss toast"}],"growth.confluence-catch-up-rovo-nudge.description.ai-non-final":[{"type":0,"value":"See updates to your watched pages."}],"growth.confluence-catch-up-rovo-nudge.title.ai-non-final":[{"type":0,"value":"Catch up on pages you watch"}],"growth.confluence-nudge-for-jira.action":[{"type":0,"value":"Accept invitation"}],"growth.confluence-nudge-for-jira.description":[{"type":0,"value":"Accept your invitation to make sure you\'re not missing any project updates."}],"growth.confluence-nudge-for-jira.title":[{"type":0,"value":"Your team invited you to Jira"}],"growth.confluenceNudgeFlag.flagHeadline.commentedOnPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" commented on your page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInComment.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you in a comment"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.flagHeadline.mentionedInPage.text":[{"children":[{"type":1,"value":"name"},{"type":0,"value":" mentioned you on a page"}],"type":8,"value":"h"}],"growth.confluenceNudgeFlag.repliedSuccessFlagTitle.text":[{"type":0,"value":"Reply sent to "},{"type":1,"value":"mentionerName"}],"growth.confluenceNudgeFlag.reply-cancel-button":[{"type":0,"value":"Cancel"}],"growth.confluenceNudgeFlag.reply-confirm-button":[{"type":0,"value":"Reply"}],"growth.confluenceNudgeFlag.reply-on-page-confirm-button.text":[{"children":[{"type":0,"value":"Reply on page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.replyFieldGenericError":[{"type":0,"value":"Failed to send comment. Please try again later."}],"growth.confluenceNudgeFlag.see-page-confirm-button":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.see-page-confirm-button.success.flag":[{"children":[{"type":0,"value":"See page"}],"type":8,"value":"a"}],"growth.confluenceNudgeFlag.viewReactionsError":[{"type":0,"value":"Reactions failed to load"}],"growth.placement-v2.atlas-side-nav-app-recommendation-menu-item.try-new-product":[{"type":0,"value":"TRY"}],"growth.recommendation-atlas.app-switcher-discovery-section.app-name":[{"type":0,"value":"Atlas"}],"growth.recommendation-atlas.value-proposition":[{"type":0,"value":"Your company\'s teamwork directory"}],"growth.recommendation-confluence.app-switcher-discovery-section.app-name":[{"type":0,"value":"Confluence"}],"growth.recommendation-confluence.cta.label":[{"type":0,"value":"Try Confluence"}],"growth.recommendation-confluence.jira-your-work.description":[{"type":0,"value":"Create a centralized space to organize requirements, release notes, goals, and more."}],"growth.recommendation-confluence.jira-your-work.header":[{"type":0,"value":"Get everyone on the same page"}],"growth.recommendation-confluence.jira-your-work.header-image-alt-text":[{"type":0,"value":"Multiple people collaborating and commenting on the same page at the same time"}],"growth.recommendation-confluence.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.product-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"growth.recommendation-confluence.product-heading":[{"type":0,"value":"Create one source of truth, for all"}],"growth.recommendation-confluence.product-name.header":[{"type":0,"value":"Collaborate on pages in real-time"}],"growth.recommendation-confluence.product-subheading":[{"type":0,"value":"Create and link documents like release notes, product requirements, and roadmaps from a single place."}],"growth.recommendation-confluence.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"confluence"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-confluence.value-proposition":[{"type":0,"value":"Document collaboration"}],"growth.recommendation-jira.product-alt-text":[{"type":0,"value":"A board view to move tasks from to do, to in progress to done"}],"growth.recommendation-jira.product-heading":[{"type":0,"value":"Plan and track work across teams"}],"growth.recommendation-jira.product-subheading":[{"type":0,"value":"Break big ideas down into achievable steps. Organize work, create milestones, map dependencies, and get visibility across all teams."}],"growth.recommendation-jpd-product-roadmap.value-proposition":[{"type":0,"value":"Align everyone with custom roadmaps"}],"growth.recommendation-jpd.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Product Discovery"}],"growth.recommendation-jpd.app-switcher-discovery-section.template-name":[{"type":0,"value":"Product roadmap"}],"growth.recommendation-jpd.cta.label":[{"type":0,"value":"Try Jira Product Discovery"}],"growth.recommendation-jpd.jira-your-work.description":[{"type":0,"value":"Prioritize your ideas then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.jira-your-work.header":[{"type":0,"value":"Build right features, the right way"}],"growth.recommendation-jpd.jira-your-work.header-image-alt-text":[{"type":0,"value":"An idea in Jira Product Discovery automatically turning into an Epic in Jira"}],"growth.recommendation-jpd.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.product-alt-text":[{"type":0,"value":"Five ideas are all organized into now, next and later groups, with a goal, score and effort ranking connected to each idea."}],"growth.recommendation-jpd.product-heading":[{"type":0,"value":"Build the right features, the right way"}],"growth.recommendation-jpd.product-name.header":[{"type":0,"value":"Transform insights into action plans"}],"growth.recommendation-jpd.product-subheading":[{"type":0,"value":"Capture and prioritize your ideas, then easily move them into delivery, without losing any details on the way."}],"growth.recommendation-jpd.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jpd"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jpd.value-proposition":[{"type":0,"value":"Prioritize, collaborate, and deliver new ideas"}],"growth.recommendation-jsm-work-request.value-proposition":[{"type":0,"value":"Create one place to manage requests"}],"growth.recommendation-jsm.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Service Management"}],"growth.recommendation-jsm.app-switcher-discovery-section.template-name":[{"type":0,"value":"Work requests"}],"growth.recommendation-jsm.cta.label":[{"type":0,"value":"Try Jira Service Management"}],"growth.recommendation-jsm.jira-your-work.description":[{"type":0,"value":"Connect support teams with development teams to get the full picture, from request to resolution."}],"growth.recommendation-jsm.jira-your-work.header":[{"type":0,"value":"Link your teams, make work visible"}],"growth.recommendation-jsm.jira-your-work.header-image-alt-text":[{"type":0,"value":"Requests from Slack, Teams and email turning into a Jira Service Management request automatically"}],"growth.recommendation-jsm.jira-your-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.product-alt-text":[{"type":0,"value":"Seven requests are all organized in one place, with a status and project connected to each request."}],"growth.recommendation-jsm.product-heading":[{"type":0,"value":"Make your work more visible"}],"growth.recommendation-jsm.product-name.header":[{"type":0,"value":"Automate workflows for faster resolutions"}],"growth.recommendation-jsm.product-subheading":[{"type":0,"value":"Connect Dev and Ops teams on a single platform to collaborate and connect the whole picture, from request to resolution."}],"growth.recommendation-jsm.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"jsm"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsm.value-proposition":[{"type":0,"value":"Collaborative IT service management"}],"growth.recommendation-jsw-visualize-work.cta.label":[{"type":0,"value":"Try Jira"}],"growth.recommendation-jsw-visualize-work.product-name.header":[{"type":0,"value":"Visualize your projects in lists, boards, and more"}],"growth.recommendation-jsw-visualize-work.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-jsw.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira"}],"growth.recommendation-jsw.recommendations.dropdown-menu-trigger.aria-label":[{"type":1,"value":"productName"},{"type":0,"value":" options"}],"growth.recommendation-jsw.value-proposition":[{"type":0,"value":"Project and issue tracking"}],"growth.recommendation-jwm.app-switcher-discovery-section.app-name":[{"type":0,"value":"Jira Work Management"}],"growth.recommendation-jwm.value-proposition":[{"type":0,"value":"ITSM that unlocks high-velocity teams"}],"growth.recommendation-loom.app-switcher-discovery-section.app-name":[{"type":0,"value":"Loom"}],"growth.recommendation-loom.cta.label":[{"type":0,"value":"Try Loom"}],"growth.recommendation-loom.product-name.header":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-loom.reasons-modal.message":[{"type":0,"value":"We think "},{"type":1,"value":"product"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"growth.recommendation-loom.value-proposition":[{"type":0,"value":"Record and share videos easily"}],"growth.recommendation-opsgenie.app-switcher-discovery-section.app-name":[{"type":0,"value":"Opsgenie"}],"growth.recommendation-opsgenie.value-proposition":[{"type":0,"value":"Modern incident management"}],"growth.recommendation-product-store.learn-cta-button-text":[{"type":0,"value":"Learn more"}],"growth.recommendation-product-store.try-cta-button-text":[{"type":0,"value":"Try it now"}],"growth.recommendation-twc.twc-apps-lozenge":[{"type":0,"value":"New"}],"growth.recommendation-twc.twc-apps-product-benefits-description":[{"type":0,"value":"Run your whole project seamlessly"}],"growth.recommendation-twc.twc-apps-product-benefits-title":[{"type":0,"value":"1 collection, 4 tools"}],"growth.recommendation-twc.twc-image-alt-text":[{"type":0,"value":"Teamwork Collection"}],"growth.team-25-ipm.jira-your-work.call-to-action.watch-now.text":[{"type":0,"value":"Watch now"}],"growth.team-25-ipm.jira-your-work.description":[{"type":0,"value":"See how Rovo can improve the way you work with AI search, chat, and agents."}],"growth.team-25-ipm.jira-your-work.header-image-alt-text":[{"type":0,"value":"See the Rovo announcement!"}],"growth.team-25-ipm.jira-your-work.reasons-modal.message":[{"type":0,"value":"Atlassian recently shared multiple announcements at Team \'25, and we wanted to make sure you know about our new capabilities."}],"growth.team-25-ipm.jira-your-work.title":[{"type":0,"value":"Work better with Rovo"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-continue-reading-nudge.reason.suggested-next-steps":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.message":[{"type":0,"value":"You\'re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-continue-reading-nudge.why-am-i-seeing-this.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag-message.recommendation-basis":[{"type":0,"value":"You\u2019re seeing a personalized recommendation based on:"}],"post-office.ad-controls.confluence-mcu-nudge-flag-reason.activity-in-product":[{"type":0,"value":"Your activity in Confluence"}],"post-office.ad-controls.confluence-mcu-nudge-flag-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.confluence-mcu-nudge-flag.suggestions":[{"type":0,"value":"Suggested next steps to help you get more value out of Atlassian"}],"post-office.ad-controls.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls.dismiss-flag.feedback.title":[{"type":0,"value":"Thanks for your feedback"}],"post-office.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls.next-best-action-message.recommendation-basis":[{"type":0,"value":"This recommendation is based on:"}],"post-office.ad-controls.next-best-action-reason.actions-done-so-far":[{"type":0,"value":"What you\u2019ve done so far in the product"}],"post-office.ad-controls.next-best-action-reason.suggestions":[{"type":0,"value":"What we suggest to help you get the most value from Atlassian"}],"post-office.ad-controls.next-best-action-title.why-am-i-seeing-this":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.close-button.tooltip":[{"type":0,"value":"Close"}],"post-office.confluence-banner-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.confluence-side-nav.next-best-action.craete-space-header":[{"type":0,"value":"Centralize your team\'s projects, and docs."}],"post-office.confluence-side-nav.next-best-action.create-page-cta-message":[{"type":0,"value":"Create page"}],"post-office.confluence-side-nav.next-best-action.create-page-header":[{"type":0,"value":"Plan projects, take notes, and track tasks."}],"post-office.confluence-side-nav.next-best-action.create-space-cta-message":[{"type":0,"value":"Create space"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-cta-message":[{"type":0,"value":"Create whiteboard"}],"post-office.confluence-side-nav.next-best-action.create-whiteboard-header":[{"type":0,"value":"Dream up new ideas, and visualize your work."}],"post-office.example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.example-placement-advanced.learn-more-modal.done-button-text.no-translate":[{"type":0,"value":"Done"}],"post-office.example-placement-quick-start.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.growth.jira-activation-project-recommendation.check-jira":[{"type":0,"value":"Check Jira"}],"post-office.growth.jira-activation-project-recommendation.hello-message":[{"type":0,"value":":wave: Hey "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"post-office.growth.jira-activation-project-recommendation.message-text":[{"type":0,"value":"Have you checked Jira lately? You may be missing out on important updates. Take a quick look to see if your team is using it to track any of your projects."}],"post-office.growth.jira-activation-project-recommendation.messages-exist":[{"type":0,"value":"Don\u2019t forget to get caught up on your "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"project"}]},"other":{"value":[{"type":0,"value":"projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":" in Jira! Take a quick look to get up-to-date on your teammates\u2019 progress."}],"post-office.growth.jira-activation-project-recommendation.see-projects":[{"type":0,"value":"See all projects"}],"post-office.growth.jira-activation-project-recommendation.you-have-messages":[{"offset":0,"options":{"=0":{"value":[]},"=1":{"value":[]},"=2":{"value":[{"type":0,"value":"You have *two projects*:"}]},"=3":{"value":[{"type":0,"value":"You have *three projects*:"}]},"other":{"value":[{"type":0,"value":"You have *"},{"options":{"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects*. Here are three to get you started:"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-multiple-projects":[{"type":0,"value":":wave: Just a heads up \u2014 you have *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one project"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfProjects"}]}},"type":5,"value":"numberOfProjects"},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"numberOfProjects"},{"type":0,"value":"* assigned to you with new work items you haven\'t checked out yet."}],"post-office.growth.jira-assigned-nudge-digest.hello-message-for-one-project-work-items":[{"type":0,"value":":wave: Just a heads up \u2014 you were assigned "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"a work item in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]},"other":{"value":[{"type":0,"value":"some work items in *<"},{"type":1,"value":"projectUrl"},{"type":0,"value":"|"},{"type":1,"value":"projectName"},{"type":0,"value":">*"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":" over three days ago."}],"post-office.growth.jira-assigned-nudge-digest.max-top-work-items-message":[{"type":0,"value":"You\'ve got *"},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"one item"}]},"other":{"value":[{"options":{"2":{"value":[{"type":0,"value":"two"}]},"3":{"value":[{"type":0,"value":"three"}]},"4":{"value":[{"type":0,"value":"four"}]},"5":{"value":[{"type":0,"value":"five"}]},"6":{"value":[{"type":0,"value":"six"}]},"7":{"value":[{"type":0,"value":"seven"}]},"8":{"value":[{"type":0,"value":"eight"}]},"9":{"value":[{"type":0,"value":"nine"}]},"other":{"value":[{"type":1,"value":"numberOfWorkItems"}]}},"type":5,"value":"numberOfWorkItems"},{"type":0,"value":" items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"},{"type":0,"value":"* to check on \u2014 here are three:"}],"post-office.growth.jira-assigned-nudge-digest.plural-cta-message":[{"type":0,"value":"See inactive "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"item"}]},"other":{"value":[{"type":0,"value":"items"}]}},"pluralType":"cardinal","type":6,"value":"numberOfWorkItems"}],"post-office.growth.jira-assigned-nudge-digest.top-projects-message":[{"type":0,"value":"Here are three to get you started:"}],"post-office.growth.jira-board-catch-up-rovo-nudge.secondary-title":[{"type":0,"value":"Get a quick summary of new issues and important activity."}],"post-office.growth.jira-board-catch-up-rovo-nudge.static-prompt":[{"type":0,"value":"Summarize the most recent activity on this Jira board. Create an executive-ready update (max ~8 bullets total) using this structure: 1. Sprint / timeline context\\n- Current sprint or time window, dates, and high-level status (e.g. \\"on track / at risk / off track\\"). 2. Key progress / wins (2-4 bullets)\\n- Focus on issues that moved into In Progress, In Review / Pending Review, or Done in the selected period.\\n- For each, include: issue key, short description (3-7 words), and current status only (no technical deep dive). 3. Blockers / risks (1-3 bullets)\\n- Call out any flagged issues, long-running items stuck in In Progress or In Review, or dependencies that could impact delivery for this sprint / period. 4. Scope & pipeline (1-3 bullets)\\n- Highlight important newly created or To Do issues that are not yet started but are significant for upcoming milestones.\\n- Note if work is skewed toward setup/foundations vs user-visible outcomes. 5. Next-focus recommendation (1-2 bullets)\\n- Recommend the 1-2 highest-leverage next actions to keep the team\'s objectives on track, referencing specific issue keys. Output the answer as concise markdown bullets, optimized for an executive audience (outcomes, risks, and next moves over implementation details)."}],"post-office.growth.jira-board-catch-up-rovo-nudge.title":[{"type":0,"value":"Catch up on recent changes"}],"post-office.growth.recommendation-jpd.confluence-home-banner.description":[{"type":0,"value":"Make sure your team is building the right things with Jira Product Discovery."}],"post-office.growth.recommendation-jpd.confluence-home-banner.header":[{"type":0,"value":"Capture your ideas and customer feedback all in one place"}],"post-office.growth.recommendation-jpd.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Discovery Product Logo"}],"post-office.growth.recommendation-jsm.confluence-home-banner.description":[{"type":0,"value":"Automatically turn Slack, Teams, and email requests into tickets."}],"post-office.growth.recommendation-jsm.confluence-home-banner.header":[{"type":0,"value":"See the whole picture, from request to resolution"}],"post-office.growth.recommendation-jsm.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Service Management Product Logo"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.description":[{"type":0,"value":"See analytics and insights about what your team is working on at any moment"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.header":[{"type":0,"value":"Sync real-time data from Jira to any document in Confluence"}],"post-office.growth.recommendation-jsw-real-time-updates.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.description":[{"type":0,"value":"76% customers shipped projects faster after adding Confluence and Jira."}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.header":[{"type":0,"value":"Build world-class products, fast"}],"post-office.growth.recommendation-jsw-tech-teams.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.description":[{"type":0,"value":"Jira lets you view your project and tasks in a way that works for you and your team."}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.header":[{"type":0,"value":"Visualize any project in a list, board, backlog, and more"}],"post-office.growth.recommendation-jsw-visualize-work.confluence-home-banner.logo-alt-text":[{"type":0,"value":"Jira Product Logo"}],"post-office.jira-side-nav-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.jira-your-work-first-party-recommendation.learn-more":[{"type":0,"value":"Learn more"}],"post-office.jira-your-work-first-party-recommendation.learn-more.alt-text":[{"type":0,"value":"Discover more about "},{"type":1,"value":"product"}],"post-office.jira-your-work-first-party-recommendation.try-it-now":[{"type":0,"value":"Try it now"}],"post-office.jira-your-work-first-party-recommendation.try-product":[{"type":0,"value":"Try Product"}],"post-office.nav-4-projects-recommendations.cta-button-lozenge-try":[{"type":0,"value":"Try"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-one-spork":[{"type":0,"value":"the tools you use (Jira)"}],"post-office.nav-4-projects-recommendations.reasons-modal-bullet-two-appify":[{"type":0,"value":"the way you use your existing tools and apps"}],"post-office.nav-4-projects-recommendations.reasons-modal-explanation":[{"type":0,"value":"We think "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"post-office.nav-4-projects-recommendations.section-heading":[{"type":0,"value":"Recommended"}],"post-office.nav-4-requested-item.cta-button-dimissal":[{"type":0,"value":"Dismiss"}],"post-office.nav-4-requested-item.cta-button-lozenge-pending":[{"type":0,"value":"Pending"}],"post-office.nav-4-requested-item.product-roadmap-icon-alt-text":[{"type":0,"value":"Icon for product roadmap"}],"post-office.nav-4-requested-item.work-requests-icon-alt-text":[{"type":0,"value":"Icon for work requests"}],"post-office.placement-v2-nav-4-section.requested-main-heading":[{"type":0,"value":"Requested"}],"post-office.test-placement.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.test-placement.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.test-placement.test-message.learn-more-button.no-translate":[{"type":0,"value":"Learn more"}],"recommendation-controls.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"recommendation-controls.team-size":[{"type":0,"value":"the size of your team"}],"recommendations.ad-controls.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"recommendations.ad-controls.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"recommendations.ad-controls.reasons-modal.accept-button.label":[{"type":0,"value":"Ok"}],"recommendations.ad-controls.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"recommendations.ad-controls.reasons-modal.body":[{"type":0,"value":"We think that "},{"type":1,"value":"productName"},{"type":0,"value":" will improve your team\'s productivity. The recommendation is based on:"}],"recommendations.ad-controls.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"recommendations.ad-controls.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"rovo-3p-party-integration-admin-nudge.action.connect":[{"type":0,"value":"Connect now"}],"rovo-3p-party-integration-admin-nudge.action.learnMore":[{"type":0,"value":"Learn more"}],"rovo-3p-party-integration-admin-nudge.description.high-percentage-and-less-than-two-apps":[{"type":0,"value":"Over 90% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.low-percentage":[{"type":0,"value":"Most of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.description.one-app":[{"type":1,"value":"percUsersConnected"},{"type":0,"value":"% of your team works with shared content. Connecting makes search and chat more useful for everyone."}],"rovo-3p-party-integration-admin-nudge.more-apps-label":[{"type":0,"value":"More apps"}],"rovo-3p-party-integration-admin-nudge.title.one-app":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"switcher.ad-controls.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"switcher.ad-controls.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"test":[{"type":0,"value":"default message"}]}');

});

parcelRegister("T0DBV", function(module, exports) {

let $0a55a1d6cd9a1cff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a55a1d6cd9a1cff$var$load("3feYV").then(()=>parcelRequire('ezhgc'));

});

parcelRegister("4rnG6", function(module, exports) {

let $33bc0d025e59d4b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $33bc0d025e59d4b6$var$load("7Q1SM").then(()=>parcelRequire('1FQHT'));

});

parcelRegister("hcc5H", function(module, exports) {

let $c84cefad34d7b450$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c84cefad34d7b450$var$load("7JdzX").then(()=>parcelRequire('cDV05'));

});

parcelRegister("7P5xH", function(module, exports) {

let $5b219878d382c28a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b219878d382c28a$var$load("24LNf").then(()=>parcelRequire('iG1MR'));

});

parcelRegister("gLMuS", function(module, exports) {

let $c356a7a11c0c8ad6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c356a7a11c0c8ad6$var$load("70Taf").then(()=>parcelRequire('c2UOk'));

});

parcelRegister("tsPTc", function(module, exports) {

let $058913c324fe5fef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $058913c324fe5fef$var$load("1H1DU").then(()=>parcelRequire('c15fn'));

});

parcelRegister("kpuRB", function(module, exports) {

let $edbe154adf9db8f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $edbe154adf9db8f4$var$load("5GytV").then(()=>parcelRequire('ajyyK'));

});

parcelRegister("gvMdu", function(module, exports) {

let $c054f15ff46b748a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c054f15ff46b748a$var$load("cnlNg").then(()=>parcelRequire('fu2us'));

});

parcelRegister("epPtr", function(module, exports) {

let $a7eb5420b4c8578c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7eb5420b4c8578c$var$load("9Uf61").then(()=>parcelRequire('6U3Wd'));

});

parcelRegister("9kKq1", function(module, exports) {

let $6cb9fd1e8965e155$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6cb9fd1e8965e155$var$load("2hqQb").then(()=>parcelRequire('hkhaC'));

});

parcelRegister("cNuY3", function(module, exports) {

let $95121529bf623937$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95121529bf623937$var$load("fJSEb").then(()=>parcelRequire('aZo8e'));

});

parcelRegister("8ZR5H", function(module, exports) {

let $68cd33f78ee60d1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $68cd33f78ee60d1b$var$load("9TeWr").then(()=>parcelRequire('jHH9j'));

});

parcelRegister("kUHWb", function(module, exports) {

let $f39b1eb0c87177aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f39b1eb0c87177aa$var$load("bvfHG").then(()=>parcelRequire('bIdTA'));

});

parcelRegister("6Naho", function(module, exports) {

let $4f1f4afa7eea8a6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f1f4afa7eea8a6b$var$load("fOGnR").then(()=>parcelRequire('ah3ql'));

});

parcelRegister("774Ai", function(module, exports) {

let $52dcbe3de93451ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52dcbe3de93451ff$var$load("8nEeY").then(()=>parcelRequire('I0LpX'));

});

parcelRegister("9AHDY", function(module, exports) {

let $6fb95491fd5cc916$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fb95491fd5cc916$var$load("fzzMQ").then(()=>parcelRequire('alNF5'));

});

parcelRegister("d7WH4", function(module, exports) {

let $98e9752399922d0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98e9752399922d0c$var$load("3gNEO").then(()=>parcelRequire('lnT2Y'));

});

parcelRegister("ji2tA", function(module, exports) {

let $e0b19e7b5d846f33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0b19e7b5d846f33$var$load("gvylW").then(()=>parcelRequire('hNq4L'));

});

parcelRegister("i9m1s", function(module, exports) {

let $d36a2677ebe9c200$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d36a2677ebe9c200$var$load("80OLx").then(()=>parcelRequire('69yxd'));

});

parcelRegister("iAthU", function(module, exports) {

let $d8824ec094ee6292$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8824ec094ee6292$var$load("e4s0V").then(()=>parcelRequire('elqYD'));

});

parcelRegister("luIhB", function(module, exports) {

let $fa5ebffa2d6e4cfd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa5ebffa2d6e4cfd$var$load("4dPO1").then(()=>parcelRequire('aMGQ1'));

});

parcelRegister("5Xidp", function(module, exports) {

let $456097994c616e4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $456097994c616e4c$var$load("apVmx").then(()=>parcelRequire('1GQ8t'));

});

parcelRegister("eUrQo", function(module, exports) {

let $adabe4e7bccea7f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $adabe4e7bccea7f8$var$load("ltrgi").then(()=>parcelRequire('aNogn'));

});

parcelRegister("jr7Ti", function(module, exports) {

let $e266a8ecb0f1f068$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e266a8ecb0f1f068$var$load("96T5a").then(()=>parcelRequire('d7uW9'));

});

parcelRegister("hvBrV", function(module, exports) {

let $cbf26198e6e92382$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cbf26198e6e92382$var$load("2taES").then(()=>parcelRequire('8i5Vp'));

});

parcelRegister("fBcWz", function(module, exports) {

let $b5b45a100bd39c38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b5b45a100bd39c38$var$load("eraiV").then(()=>parcelRequire('32lJS'));

});

parcelRegister("aZKQY", function(module, exports) {

let $8013f1fdbb49cbff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8013f1fdbb49cbff$var$load("bSohw").then(()=>parcelRequire('i0sQU'));

});

parcelRegister("7uH4q", function(module, exports) {

let $574cbe9d110bdc8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $574cbe9d110bdc8a$var$load("69YlM").then(()=>parcelRequire('hjc11'));

});

parcelRegister("auyEA", function(module, exports) {

let $7a379634f532b5c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a379634f532b5c3$var$load("5OFyu").then(()=>parcelRequire('goI9c'));

});

parcelRegister("auLEI", function(module, exports) {

let $7a41ac2793f1cd63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a41ac2793f1cd63$var$load("kgHzZ").then(()=>parcelRequire('dK9PC'));

});

parcelRegister("9zsK0", function(module, exports) {

let $6f7dad521bb75086$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f7dad521bb75086$var$load("8ZNKO").then(()=>parcelRequire('ciScA'));

});

parcelRegister("8Ocbg", function(module, exports) {

let $669c7116274db364$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $669c7116274db364$var$load("lzRfF").then(()=>parcelRequire('3Hu90'));

});

parcelRegister("jZfyc", function(module, exports) {

let $e8cfc6db2147d651$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8cfc6db2147d651$var$load("j03Pa").then(()=>parcelRequire('hQIr5'));

});

parcelRegister("7lBAh", function(module, exports) {

let $5597a6053ed2d5bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5597a6053ed2d5bb$var$load("brdRT").then(()=>parcelRequire('hrRS6'));

});

parcelRegister("9aKzs", function(module, exports) {
module.exports = JSON.parse("{\"post-office.confluence-create-agent-spotlight.spotlight-button\":[{\"type\":0,\"value\":\"Got it\"}],\"post-office.confluence-create-agent-spotlight.spotlight-description\":[{\"type\":0,\"value\":\"Create custom agents trained on your team's workflow so they can jump in at anytime.\"}],\"post-office.confluence-create-agent-spotlight.spotlight-header\":[{\"type\":0,\"value\":\"Build your perfect teammate\"}],\"post-office.confluence-create-agent-spotlight.spotlight-image-alt\":[{\"type\":0,\"value\":\"Create agent illustration\"}]}");

});

parcelRegister("8GURh", function(module, exports) {

let $653e59db58ec0e55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $653e59db58ec0e55$var$load("59VZS").then(()=>parcelRequire('hNZLv'));

});

parcelRegister("4zGtD", function(module, exports) {

let $354b6158b63b6a61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $354b6158b63b6a61$var$load("fD3Bu").then(()=>parcelRequire('fKvt9'));

});

parcelRegister("aid6F", function(module, exports) {

let $77e5c07eb1cfc49a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77e5c07eb1cfc49a$var$load("gRJ61").then(()=>parcelRequire('4tVLF'));

});

parcelRegister("4Clyy", function(module, exports) {

let $35cb6eaa02af2c27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35cb6eaa02af2c27$var$load("db90I").then(()=>parcelRequire('g1dkF'));

});

parcelRegister("8uQPR", function(module, exports) {

let $62fa1c1db5c732c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62fa1c1db5c732c5$var$load("joW5u").then(()=>parcelRequire('k9KM9'));

});

parcelRegister("hOrRF", function(module, exports) {

let $cf7cb886f3239849$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf7cb886f3239849$var$load("67xgi").then(()=>parcelRequire('5WdXD'));

});

parcelRegister("2yPxv", function(module, exports) {

let $1dd6bc6451171c90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1dd6bc6451171c90$var$load("bVvFl").then(()=>parcelRequire('fFON2'));

});

parcelRegister("2jMAY", function(module, exports) {

let $1b030d299a081d3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b030d299a081d3f$var$load("60L1Q").then(()=>parcelRequire('k5qKR'));

});

parcelRegister("biFM8", function(module, exports) {

let $83a1c7dc7a401aba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83a1c7dc7a401aba$var$load("9gh8z").then(()=>parcelRequire('7qzbM'));

});

parcelRegister("krKp5", function(module, exports) {

let $ee2a530a51f16ba3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee2a530a51f16ba3$var$load("icxPh").then(()=>parcelRequire('9zD1O'));

});

parcelRegister("269w2", function(module, exports) {

let $187385eb619312b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $187385eb619312b0$var$load("1oTaS").then(()=>parcelRequire('hy8Uz'));

});

parcelRegister("JEIM5", function(module, exports) {

let $0893ca75ed0b85b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0893ca75ed0b85b1$var$load("cqvdC").then(()=>parcelRequire('eEupV'));

});

parcelRegister("hByEB", function(module, exports) {

let $cd10c5e710c15c71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd10c5e710c15c71$var$load("4rUkz").then(()=>parcelRequire('j5mxX'));

});

parcelRegister("bUhBn", function(module, exports) {

let $8ab294079f11e2c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ab294079f11e2c7$var$load("7VF4B").then(()=>parcelRequire('glZuM'));

});

parcelRegister("lgRkc", function(module, exports) {

let $f7c474c47157cfbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7c474c47157cfbf$var$load("3tcBd").then(()=>parcelRequire('6D8as'));

});

parcelRegister("fqI37", function(module, exports) {

let $b3bb73ff25ba54b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3bb73ff25ba54b1$var$load("31l79").then(()=>parcelRequire('8qkRD'));

});

parcelRegister("6oC6u", function(module, exports) {

let $4a828a8f231dc155$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a828a8f231dc155$var$load("7MbjQ").then(()=>parcelRequire('ilRcA'));

});

parcelRegister("cnzYU", function(module, exports) {

let $90338b328da7cc45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90338b328da7cc45$var$load("iP1nm").then(()=>parcelRequire('1DMG7'));

});

parcelRegister("IzJ62", function(module, exports) {

let $085fd2afd387a590$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $085fd2afd387a590$var$load("laJkP").then(()=>parcelRequire('gSO05'));

});

parcelRegister("9Ze4j", function(module, exports) {

let $01e05591c09953c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01e05591c09953c2$var$load("aWTot").then(()=>parcelRequire('5P7h1'));

});

parcelRegister("6z72A", function(module, exports) {

let $4c7b79193495cfa7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c7b79193495cfa7$var$load("kjUC9").then(()=>parcelRequire('lIMts'));

});

parcelRegister("irxYM", function(module, exports) {

let $d6d51b3327ca92cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6d51b3327ca92cc$var$load("fgeyW").then(()=>parcelRequire('kp3Lm'));

});

parcelRegister("OrW9M", function(module, exports) {

let $097a5755c4dcda28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $097a5755c4dcda28$var$load("b21vI").then(()=>parcelRequire('v5Cjh'));

});

parcelRegister("8TWgT", function(module, exports) {

let $67b0a94a0514236a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67b0a94a0514236a$var$load("hMefO").then(()=>parcelRequire('6767A'));

});

parcelRegister("h75Oa", function(module, exports) {

let $c757987ea709c1fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c757987ea709c1fd$var$load("hKlVe").then(()=>parcelRequire('hRTcJ'));

});

parcelRegister("1MpTu", function(module, exports) {

let $14be5c20e137fdff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14be5c20e137fdff$var$load("b9c2O").then(()=>parcelRequire('eTJBe'));

});

parcelRegister("lhybn", function(module, exports) {

let $f7e5b36c53d480d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7e5b36c53d480d4$var$load("2JG5z").then(()=>parcelRequire('cO1la'));

});

parcelRegister("iMfuZ", function(module, exports) {

let $dab8bb74aa80b825$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dab8bb74aa80b825$var$load("dAnlL").then(()=>parcelRequire('slsry'));

});

parcelRegister("ie2Ua", function(module, exports) {

let $d44bc9a688bbe8f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d44bc9a688bbe8f5$var$load("9A2Qz").then(()=>parcelRequire('9mb1G'));

});

parcelRegister("aolZxO", function(module, exports) {

let $01f3d36cd0f8b736$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01f3d36cd0f8b736$var$load("jxJ7F").then(()=>parcelRequire('finor'));

});

parcelRegister("4SSNj", function(module, exports) {

let $38e6b59a0ce8d291$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38e6b59a0ce8d291$var$load("hgEqe").then(()=>parcelRequire('fKNbW'));

});

parcelRegister("aXc5k", function(module, exports) {

let $7f98c9e42a620c9d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f98c9e42a620c9d$var$load("8k5hX").then(()=>parcelRequire('cRDxd'));

});

parcelRegister("hpKAi", function(module, exports) {

let $cad8e82f47d4c5a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cad8e82f47d4c5a7$var$load("I9usf").then(()=>parcelRequire('3ON4W'));

});

parcelRegister("2QCge", function(module, exports) {

let $212e1de9c2d4d82e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $212e1de9c2d4d82e$var$load("dnzC2").then(()=>parcelRequire('kKZFe'));

});

parcelRegister("8l5Vh", function(module, exports) {
module.exports = JSON.parse("{\"post-office.fabric-editor.confluence-agent-content-suggestions.notification-drawer.shared\":[{\"type\":1,\"value\":\"agentName\"},{\"type\":0,\"value\":\" shared \"},{\"offset\":0,\"options\":{\"one\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" suggestion\"}]},\"other\":{\"value\":[{\"type\":7},{\"type\":0,\"value\":\" suggestions\"}]}},\"pluralType\":\"cardinal\",\"type\":6,\"value\":\"count\"},{\"type\":0,\"value\":\" with you\"}],\"post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-body\":[{\"type\":0,\"value\":\"Mention an agent to instantly brainstorm ideas, draft content, and analyze data.\"}],\"post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-headline\":[{\"type\":0,\"value\":\"Your agents are ready to help\"}],\"post-office.fabric-editor.confluence-editor-agentic-typeahead-spotlight.spotlight-primary-action\":[{\"type\":0,\"value\":\"Got it\"}]}");

});

parcelRegister("2S5KU", function(module, exports) {

let $217516e0b7e47e53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $217516e0b7e47e53$var$load("baWf1").then(()=>parcelRequire('bg8C1'));

});

parcelRegister("g4LNg", function(module, exports) {

let $bb4217e354613ca9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb4217e354613ca9$var$load("cL29a").then(()=>parcelRequire('3ouW4'));

});

parcelRegister("exKg5", function(module, exports) {

let $a96807bc302c7711$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a96807bc302c7711$var$load("8d08B").then(()=>parcelRequire('gRWb4'));

});

parcelRegister("gaFGJ", function(module, exports) {

let $bc5deaf0bc45d12b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc5deaf0bc45d12b$var$load("59255").then(()=>parcelRequire('dQaet'));

});

parcelRegister("6e45s", function(module, exports) {

let $4887387e5d75285b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4887387e5d75285b$var$load("QAMCX").then(()=>parcelRequire('daGt5'));

});

parcelRegister("32aVk", function(module, exports) {

let $235a083865ba038d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $235a083865ba038d$var$load("ipMBa").then(()=>parcelRequire('29cY7'));

});

parcelRegister("iiAkf", function(module, exports) {

let $d52615f242e3e6cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d52615f242e3e6cd$var$load("4Fe0y").then(()=>parcelRequire('iloPx'));

});

parcelRegister("2kve5", function(module, exports) {

let $1b25abe6b9737386$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b25abe6b9737386$var$load("frY3Q").then(()=>parcelRequire('heWOF'));

});

parcelRegister("avBPq", function(module, exports) {

let $7a6a248ea054858f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a6a248ea054858f$var$load("guXpK").then(()=>parcelRequire('fnieY'));

});

parcelRegister("bRMrv", function(module, exports) {

let $8a3a38a37781eb2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a3a38a37781eb2a$var$load("iBlah").then(()=>parcelRequire('e3AoE'));

});

parcelRegister("9OSuz", function(module, exports) {

let $72630d907bfe843b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72630d907bfe843b$var$load("2UZrx").then(()=>parcelRequire('dcIsE'));

});

parcelRegister("6htpd", function(module, exports) {

let $492b23fe85e4a8c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $492b23fe85e4a8c2$var$load("c9IX9").then(()=>parcelRequire('dBzQm'));

});

parcelRegister("7NeIw", function(module, exports) {

let $5ac8868a8d715ead$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ac8868a8d715ead$var$load("fGR58").then(()=>parcelRequire('a1X57'));

});

parcelRegister("8lAlf", function(module, exports) {

let $613c79989be84219$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $613c79989be84219$var$load("kDN1X").then(()=>parcelRequire('gvihj'));

});

parcelRegister("eqRMq", function(module, exports) {

let $a81d3600938a0a28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a81d3600938a0a28$var$load("fXmm3").then(()=>parcelRequire('5NBwN'));

});

parcelRegister("fZnKc", function(module, exports) {

let $ba3ef8a0916ae24f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba3ef8a0916ae24f$var$load("aW1xT").then(()=>parcelRequire('gnVhL'));

});

parcelRegister("eXwQn", function(module, exports) {

let $ae400d78c90d3308$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae400d78c90d3308$var$load("juBWy").then(()=>parcelRequire('b4WDI'));

});

parcelRegister("3HgGd", function(module, exports) {

let $2b12538dfd8d9838$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b12538dfd8d9838$var$load("71skT").then(()=>parcelRequire('2d3Ig'));

});

parcelRegister("iLuVk", function(module, exports) {

let $da949a981cf63a97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da949a981cf63a97$var$load("gK7PJ").then(()=>parcelRequire('diLu9'));

});

parcelRegister("4ECdt", function(module, exports) {

let $36388ad2254f57c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36388ad2254f57c9$var$load("66YlC").then(()=>parcelRequire('iijwr'));

});

parcelRegister("l5Xon", function(module, exports) {

let $03f695342f24810f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03f695342f24810f$var$load("jhnib").then(()=>parcelRequire('k3l7l'));

});

parcelRegister("2QxFd", function(module, exports) {

let $212a8cfff74b6afd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $212a8cfff74b6afd$var$load("5A08g").then(()=>parcelRequire('jA9aC'));

});

parcelRegister("5uSzX", function(module, exports) {

let $400a17538153b204$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $400a17538153b204$var$load("gpPIs").then(()=>parcelRequire('6e15x'));

});

parcelRegister("eUzIC", function(module, exports) {

let $adb2009ce6094cdd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $adb2009ce6094cdd$var$load("2ruUM").then(()=>parcelRequire('4P2wv'));

});

parcelRegister("4lKDT", function(module, exports) {

let $32ad4dccb97f5c8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32ad4dccb97f5c8c$var$load("eKpGd").then(()=>parcelRequire('2syXW'));

});

parcelRegister("78WuP", function(module, exports) {

let $5336a7e5b21a8718$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5336a7e5b21a8718$var$load("MWjax").then(()=>parcelRequire('k4rw1'));

});

parcelRegister("63SLp", function(module, exports) {

let $469d80cb434ca6b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $469d80cb434ca6b3$var$load("7m68o").then(()=>parcelRequire('8Xck8'));

});

parcelRegister("5VwrO", function(module, exports) {

let $450b720cb9a31cba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $450b720cb9a31cba$var$load("49J53").then(()=>parcelRequire('6B0CT'));

});

parcelRegister("lSRnF", function(module, exports) {

let $fee80c69edcc8be6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fee80c69edcc8be6$var$load("fKd1v").then(()=>parcelRequire('efQU9'));

});

parcelRegister("2QwtB", function(module, exports) {

let $2129a144af6d22a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2129a144af6d22a2$var$load("cCzJA").then(()=>parcelRequire('bpo59'));

});

parcelRegister("cTmP6", function(module, exports) {

let $962c5354218d80bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $962c5354218d80bf$var$load("5v6nN").then(()=>parcelRequire('5XaKi'));

});

parcelRegister("9vcQi", function(module, exports) {

let $6eb0f889a42fe6ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6eb0f889a42fe6ec$var$load("5oeaX").then(()=>parcelRequire('1qlZk'));

});

parcelRegister("01AdQ", function(module, exports) {

let $004c31208d7d505f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $004c31208d7d505f$var$load("879MX").then(()=>parcelRequire('anzDT'));

});

parcelRegister("8bawX", function(module, exports) {

let $5f4784f6b03bcbfb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f4784f6b03bcbfb$var$load("6SVTg").then(()=>parcelRequire('ithSW'));

});

parcelRegister("6QKF0", function(module, exports) {
module.exports = JSON.parse("{\"confluence-integrations.confluence-connector-request-fulfilled.email.action\":[{\"type\":0,\"value\":\"Finish Connecting\"}],\"confluence-integrations.confluence-connector-request-fulfilled.email.body.generic\":[{\"type\":0,\"value\":\"You can now connect your workspace to your requested app!\"}],\"confluence-integrations.confluence-connector-request-fulfilled.email.body.named\":[{\"type\":0,\"value\":\"You can now connect your workspace to \"},{\"type\":1,\"value\":\"appName\"},{\"type\":0,\"value\":\"!\"}],\"confluence-integrations.confluence-connector-request-fulfilled.email.copyright\":[{\"type\":0,\"value\":\"Copyright \"},{\"type\":1,\"value\":\"year\"},{\"type\":0,\"value\":\" Atlassian Pty Ltd. All rights reserved.\"}],\"confluence-integrations.confluence-connector-request-fulfilled.email.heading\":[{\"type\":0,\"value\":\"Your connection request was approved!\"}],\"confluence-integrations.confluence-connector-request-fulfilled.email.subject\":[{\"type\":0,\"value\":\"Your connection request was approved\"}],\"confluence-integrations.confluence-connector-request-fulfilled.notification-drawer.generic.ai-non-final\":[{\"type\":0,\"value\":\"Your connection request was approved.\"}],\"confluence-integrations.confluence-connector-request-fulfilled.notification-drawer.named.ai-non-final\":[{\"type\":0,\"value\":\"Your connection request for \"},{\"type\":1,\"value\":\"appName\"},{\"type\":0,\"value\":\" was approved\"}],\"confluence-integrations.confluence-devdocs-sync-complete.message-template.notification-drawer.message\":[{\"type\":0,\"value\":\"Docs created from your code are ready\"}],\"confluence-integrations.confluence-editor-smart-folder-paste-nudge.close\":[{\"type\":0,\"value\":\"Close\"}],\"confluence-integrations.confluence-editor-smart-folder-paste-nudge.description\":[{\"type\":0,\"value\":\"Create a Confluence folder that syncs to your external folder.\"}],\"confluence-integrations.confluence-editor-smart-folder-paste-nudge.done\":[{\"type\":0,\"value\":\"Create a synced folder\"}],\"confluence-integrations.confluence-editor-smart-folder-paste-nudge.title\":[{\"type\":0,\"value\":\"Bring your work into this space\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.explanation\":[{\"type\":0,\"value\":\"With this access, JSM users (who may or may not be licensed Confluence users) can view and potentially create and edit content in Confluence -- but only in specific spaces that are explicitly linked to JSM projects.\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.farewell-line-one\":[{\"type\":0,\"value\":\"Thanks,\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.farewell-line-two\":[{\"type\":0,\"value\":\"the Confluence team\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.global-permissions\":[{\"type\":0,\"value\":\"Confluence site's global permissions\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.greeting\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"username\"},{\"type\":0,\"value\":\",\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.header-summary\":[{\"children\":[{\"type\":0,\"value\":\"Admin notification\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\": JSM Access is turned on for \"},{\"children\":[{\"type\":1,\"value\":\"0\"}],\"type\":8,\"value\":\"b\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.learn-more\":[{\"type\":0,\"value\":\"Learn more\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.subject\":[{\"type\":0,\"value\":\"Admin notification: JSM Access is turned on for \"},{\"type\":1,\"value\":\"0\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.view-info\":[{\"type\":0,\"value\":\"You can view and remove this access in the JSM Access tab of your \"},{\"type\":1,\"value\":\"globalPermissionsLink\"},{\"type\":0,\"value\":\".\"}],\"confluence-integrations.confluence-jsm-access.message-template.email.your-confluence-site\":[{\"type\":0,\"value\":\"Your Confluence site \"},{\"type\":1,\"value\":\"confluenceLink\"},{\"type\":0,\"value\":\" has the Jira Service Management (JSM) access global setting turned on. This helps JSM teams manage their knowledge base needs by using JSM and Confluence together.\"}],\"confluence-integrations.confluence-smart-links-abandoned-auth-reminder.email.body\":[{\"type\":0,\"value\":\"You started connecting \"},{\"type\":1,\"value\":\"provider\"},{\"type\":0,\"value\":\" in Confluence but did not finish.\"}],\"confluence-integrations.confluence-smart-links-abandoned-auth-reminder.email.cta\":[{\"type\":0,\"value\":\"Finish connecting\"}],\"confluence-integrations.confluence-smart-links-abandoned-auth-reminder.email.subject\":[{\"type\":0,\"value\":\"Finish connecting \"},{\"type\":1,\"value\":\"provider\"},{\"type\":0,\"value\":\" in Confluence\"}],\"confluence-integrations.confluence-smart-links-abandoned-auth-reminder.email.unsubscribe\":[{\"type\":0,\"value\":\"Manage email preferences\"}],\"confluence-integrations.confluence-smart-links-abandoned-auth-reminder.notification-drawer.connect\":[{\"type\":0,\"value\":\"Connect\"}],\"confluence-integrations.confluence-smart-links-abandoned-auth-reminder.notification-drawer.title\":[{\"type\":0,\"value\":\"Connect \"},{\"type\":1,\"value\":\"providerName\"},{\"type\":0,\"value\":\" to see previews\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.body\":[{\"type\":0,\"value\":\"Pages is now Docs. Access pages, live docs, and more, all from your space.\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.done-button\":[{\"type\":0,\"value\":\"Done\"}],\"confluence-integrations.project-pages-revamp-onboarding-spotlight.heading\":[{\"type\":0,\"value\":\"One place for all your project docs\"}]}");

});

parcelRegister("58F0p", function(module, exports) {

let $3bdd81f88a5c3777$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3bdd81f88a5c3777$var$load("k7Dnl").then(()=>parcelRequire('9i2oi'));

});

parcelRegister("kIii3", function(module, exports) {

let $f1461abc1fdf2507$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1461abc1fdf2507$var$load("cObhK").then(()=>parcelRequire('6qycB'));

});

parcelRegister("eppSn", function(module, exports) {

let $a7d778f2eb67a676$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7d778f2eb67a676$var$load("6sKsv").then(()=>parcelRequire('lIIii'));

});

parcelRegister("2UIqY", function(module, exports) {

let $21f3476f586654db$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21f3476f586654db$var$load("9wYt0").then(()=>parcelRequire('2gEZT'));

});

parcelRegister("fZuj0", function(module, exports) {

let $ba440f928de1d27c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba440f928de1d27c$var$load("bwIB0").then(()=>parcelRequire('7NsNP'));

});

parcelRegister("5TuVS", function(module, exports) {

let $44aa155562075d1e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44aa155562075d1e$var$load("1mr1Y").then(()=>parcelRequire('lJPUp'));

});

parcelRegister("fULde", function(module, exports) {

let $b960b560bd0f6de0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b960b560bd0f6de0$var$load("ciR0c").then(()=>parcelRequire('cyUPE'));

});

parcelRegister("dVNJ2", function(module, exports) {

let $a2472ba72bed8324$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2472ba72bed8324$var$load("1m3JB").then(()=>parcelRequire('5HjuF'));

});

parcelRegister("kdH7o", function(module, exports) {

let $eb8677e766cbe23b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eb8677e766cbe23b$var$load("1s4Mb").then(()=>parcelRequire('dLbGh'));

});

parcelRegister("girve", function(module, exports) {

let $bdd3a93e3d0b5686$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdd3a93e3d0b5686$var$load("9uXfC").then(()=>parcelRequire('cuewo'));

});

parcelRegister("91l9v", function(module, exports) {

let $69149d7cbef2db5b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69149d7cbef2db5b$var$load("7rTXm").then(()=>parcelRequire('1zefa'));

});

parcelRegister("jrZjR", function(module, exports) {

let $e2901ab32f15e28c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e2901ab32f15e28c$var$load("1UUyE").then(()=>parcelRequire('bk50W'));

});

parcelRegister("kEqGy", function(module, exports) {

let $f08c3e3a25e8fc05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f08c3e3a25e8fc05$var$load("21w5u").then(()=>parcelRequire('B9X3D'));

});

parcelRegister("9g7V6", function(module, exports) {

let $6bdbc072063b0f20$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bdbc072063b0f20$var$load("bdqac").then(()=>parcelRequire('dSjS5'));

});

parcelRegister("awfIw", function(module, exports) {

let $7a8915a71233e2bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a8915a71233e2bf$var$load("hZ7yF").then(()=>parcelRequire('kaZS7'));

});

parcelRegister("50HSs", function(module, exports) {

let $3a5efcfb9e1d51fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a5efcfb9e1d51fe$var$load("94QX4").then(()=>parcelRequire('j4Mcf'));

});

parcelRegister("k7EOY", function(module, exports) {

let $ea64204df2da39d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea64204df2da39d7$var$load("4GUO8").then(()=>parcelRequire('2ryMG'));

});

parcelRegister("avOKD", function(module, exports) {

let $7a742abe1f1392c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a742abe1f1392c9$var$load("lj8m0").then(()=>parcelRequire('8mfQ7'));

});

parcelRegister("8aJGT", function(module, exports) {

let $5f32b324e7c4403f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f32b324e7c4403f$var$load("8vLZJ").then(()=>parcelRequire('1U2Qj'));

});

parcelRegister("b2n8Q", function(module, exports) {

let $8091d5119526e3f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8091d5119526e3f4$var$load("gQvB5").then(()=>parcelRequire('i4ySq'));

});

parcelRegister("1FdUP", function(module, exports) {

let $13646a1efb263bfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13646a1efb263bfe$var$load("h2ndR").then(()=>parcelRequire('du0VX'));

});

parcelRegister("1PBOf", function(module, exports) {

let $1557e20f040a9e30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1557e20f040a9e30$var$load("87AZ8").then(()=>parcelRequire('9wwbg'));

});

parcelRegister("ayxE3", function(module, exports) {

let $7af72d8a695b78d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7af72d8a695b78d6$var$load("cly39").then(()=>parcelRequire('kwKie'));

});

parcelRegister("3yI8C", function(module, exports) {

let $2976c8f9d1727717$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2976c8f9d1727717$var$load("aRcDN").then(()=>parcelRequire('5eo49'));

});

parcelRegister("hmA7l", function(module, exports) {

let $ca4081eff11ef43a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca4081eff11ef43a$var$load("894o2").then(()=>parcelRequire('aAW0m'));

});

parcelRegister("8suUU", function(module, exports) {

let $6288ebb6481400b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6288ebb6481400b1$var$load("5laHz").then(()=>parcelRequire('9j0Ep'));

});

parcelRegister("1f1ta", function(module, exports) {

let $0e7854f80087d490$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e7854f80087d490$var$load("hXaWt").then(()=>parcelRequire('2NLmt'));

});

parcelRegister("gwAcJ", function(module, exports) {

let $c07bb7eb7530ebb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c07bb7eb7530ebb1$var$load("3aIcV").then(()=>parcelRequire('fMBHX'));

});

parcelRegister("6odmS", function(module, exports) {

let $4a6f5a93fc7ffffe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a6f5a93fc7ffffe$var$load("9y7HQ").then(()=>parcelRequire('dGXM1'));

});

parcelRegister("dNgup", function(module, exports) {

let $a0aca46d975727d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0aca46d975727d7$var$load("b4rrC").then(()=>parcelRequire('gy9DE'));

});

parcelRegister("8rgs7", function(module, exports) {

let $624d9b7f239a6113$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $624d9b7f239a6113$var$load("kQXg5").then(()=>parcelRequire('jG2N2'));

});

parcelRegister("aowj5", function(module, exports) {

let $791534c227f320c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $791534c227f320c0$var$load("9uhto").then(()=>parcelRequire('2qRwZ'));

});

parcelRegister("8Mkmm", function(module, exports) {

let $6642996de4b01278$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6642996de4b01278$var$load("2h8kX").then(()=>parcelRequire('2PgN2'));

});

parcelRegister("i9CdS", function(module, exports) {

let $d376b77f4e0cf4cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d376b77f4e0cf4cb$var$load("f07eY").then(()=>parcelRequire('l4vKr'));

});

parcelRegister("hExow", function(module, exports) {
module.exports = JSON.parse('{"growth-confluence-find.confluence-d1d6-back-to-product-email.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.header":[{"type":0,"value":"Confluence is better "},{"type":1,"value":"lineBreak"},{"type":0,"value":" when the team\u2019s all in"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Your team\u2019s waiting for your great ideas!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Jump back into Confluence and start collaborating today"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Click "},{"children":[{"type":0,"value":"Share"}],"type":8,"value":"b"},{"type":0,"value":" in Confluence to copy a link you can send in email, Slack or MS Teams"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Link content to teammates"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Give feedback on docs in progress, and @mention teammates to keep everyone in the loop"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Comment in pages"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Align on the best path forward by voting on ideas as a team in whiteboards"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Vote in whiteboards"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.steps-header":[{"type":0,"value":"How to use Confluence "},{"type":1,"value":"lineBreak"},{"type":0,"value":" with your team:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.add-your-team.subtext":[{"type":0,"value":"You\u2019re creating awesome ideas in Confluence, "},{"type":1,"value":"firstName"},{"type":0,"value":". It\u2019s "},{"type":1,"value":"lineBreak"},{"type":0,"value":" time to share them with your team!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-nth-user-active.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83D\uDC4F Your ideas deserve an audience, "},{"type":1,"value":"firstName"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.header":[{"type":0,"value":"Get your ideas"},{"type":1,"value":"lineBreak"},{"type":0,"value":"on \u201Cpaper\u201D, "},{"type":1,"value":"firstName"},{"type":0,"value":"!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Ready to jump back in?"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Go back to Confluence today to start doing your team\u2019s best work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Jot down & organize your ideas with sleek editor tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Start with a page"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"@mention someone to show them what you\u2019re working on"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Brainstorm with teammates"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Connect Slack, Microsoft, or Google to keep the whole team in sync"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Connect your tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Easy ways to get setup:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.add-your-team.subtext":[{"type":0,"value":"It only takes a minute to wrap up your Confluence setup. Jump back in now to start unleashing your team\u2019s knowledge."}],"growth-confluence-find.confluence-d1d6-back-to-product-no-page-created.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83D\uDC4B Almost there\u2014need help setting up Confluence?"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.header":[{"type":0,"value":"It\u2019s time to make your space, more spacious"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Create a space everyone will rave about!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Create, organize & share to get the team\u2019s ideas all out there"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Simply drag items around in the left-hand sidebar & click + to create something new to your space"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"Drag, drop & create in context"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Add folders to create directories where everything\u2019s stored. You can even convert pages to folders in the ... menu."}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Pop it into a folder"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Create "},{"children":[{"type":0,"value":"smart links"}],"type":8,"value":"b"},{"type":0,"value":" to auto-pull content into Confluence from other tools your team already uses, like Google Docs or MS Excel"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Link from your favorite tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Tips for building out your team\u2019s space:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.add-your-team.subtext":[{"type":0,"value":"Your "},{"children":[{"type":0,"value":"space"}],"type":8,"value":"b"},{"type":0,"value":" is like a hub for your team\u2019s docs & resources. "},{"type":1,"value":"lineBreak"},{"type":0,"value":"Create more and organize it all in your space today!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-page-created.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83E\uDD29 Impressive work you\u2019ve got there, "},{"type":1,"value":"firstName"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.button-text":[{"type":0,"value":"Let\'s go"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.header":[{"type":0,"value":"Take your team\u2019s knowledge"},{"type":1,"value":"lineBreak"},{"type":0,"value":" to the next level"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.main-image.alt-text":[{"type":0,"value":"Confluence cards showing tasks with assignees and different types of work"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-header":[{"type":0,"value":"Go ahead - unleash your team\u2019s knowledge!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.pre-footer-subtext":[{"type":0,"value":"Speed up teamwork by building out your knowledge hub today"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.description":[{"type":0,"value":"Organize work for specific teams, projects and workstreams in separate spaces to create specialized knowledge repos"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-1.title":[{"type":0,"value":"More spaces = more knowledge sources"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.description":[{"type":0,"value":"Rovo Search helps any team instantly find the info they need in Confluence, Slack, MS Office, and more!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-2.title":[{"type":0,"value":"Search across spaces & tools"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.description":[{"type":0,"value":"Need to make a page or presentation with info from multiple sources? Ask Rovo Chat to pull in knowledge from anywhere and auto-create it for you in a snap!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-3.title":[{"type":0,"value":"Just ask Rovo"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.steps-header":[{"type":0,"value":"Try out the knowledge hub basics:"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.add-your-team.subtext":[{"type":0,"value":"Creating new spaces with even more Confluence content helps "},{"type":1,"value":"lineBreak"},{"type":0,"value":"unlock knowledge across every team!"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.icon-check-circle.alt-text":[{"type":0,"value":"Icon - Check circle"}],"growth-confluence-find.confluence-d1d6-back-to-product-no-second-space.message-template.email.subject.no-first-issue-assigned":[{"type":0,"value":"\uD83E\uDDD9 Did you know? A knowledge hub makes work easier"}],"growth-confluence-find.message-templates.confluence-notification-drawer-getting-started-nth-user.welcome-to-confluence":[{"type":0,"value":"Welcome to Confluence, "},{"type":1,"value":"name"},{"type":0,"value":"! Learn how to create your first doc."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.atlassian-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-ideas":[{"type":0,"value":"Capture your ideas as a team in pages, whiteboards, and more today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.capture-your-thoughts":[{"type":0,"value":"Capture your thoughts and ideas on docs and whiteboards."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.collaborate-with-your-new-teammate":[{"type":0,"value":"Collaborate with your new teammate on your next big idea today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.confluence-is":[{"children":[{"type":0,"value":"Confluence is a collaborative workspace"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers create and organize knowledge with their team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.create-with-a-template":[{"type":0,"value":"Create with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.forward-invite-banner":[{"type":0,"value":"\uD83D\uDC4B "},{"children":[{"type":0,"value":"Forward this email"}],"type":8,"value":"b"},{"type":0,"value":" to easily invite more teammates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-started-at-lightning-speed":[{"type":0,"value":"\u26A1 Get started at lightning speed with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.get-your-ideas-on-paper":[{"type":0,"value":"Get your ideas on \\"paper\\" with pages, whiteboards, and more in Confluence today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-job-adding":[{"type":0,"value":"Great job adding your work to your Confluence space!"},{"children":[],"type":8,"value":"br"},{"type":0,"value":"Invite a teammate to get feedback on it today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-momentum":[{"type":0,"value":"Great momentum, "},{"type":1,"value":"name"},{"type":0,"value":"! Keep it going with a template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.great-work":[{"type":0,"value":"\uD83E\uDD29 Great work\u2014Your space deserves an audience"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-teammates":[{"type":0,"value":"Invite teammates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.invite-your-teammates":[{"type":0,"value":"Invite your teammates to collaborate and align on ideas quickly."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.jump-back-in":[{"type":0,"value":"Jump back in"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.kick-off-collaboration":[{"type":0,"value":"Kick off collaboration with your new teammate, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited":[{"type":0,"value":"Last edited "},{"type":1,"value":"relativeTime"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortJustNow":[{"type":0,"value":"just now"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXDaysAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"d ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXHoursAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"h ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.last-edited.shortXMinutesAgo":[{"type":1,"value":"timeAgo"},{"type":0,"value":"m ago"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.lets-create-your-next":[{"type":0,"value":"Let\'s create your next big idea, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.nows-the-time":[{"type":0,"value":"\u23F0 Now\'s the time to create something great as a team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.one-new-teammate":[{"type":0,"value":"1 new teammate joined your Confluence space. Capture your next big idea with them in pages, whiteboards, and more today."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.or-share-this-link":[{"type":0,"value":"Or share this link:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.save-time-with":[{"type":0,"value":"Save time with these templates"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.share-your-work":[{"type":0,"value":"Share your work with the team, "},{"type":1,"value":"name"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.space":[{"type":1,"value":"spaceName"},{"type":0,"value":" space"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.start-creating-fast":[{"type":0,"value":"Start creating fast with templates recommended for your team."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.team":[{"type":0,"value":"Team"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.90-day-plan":[{"type":0,"value":"90-day plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.all-hands-meeting":[{"type":0,"value":"All hands meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.annual-plan-one-pager":[{"type":0,"value":"Annual plan one-pager"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.aws-architecture-diagram":[{"type":0,"value":"AWS architecture diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-plan-one-pager":[{"type":0,"value":"Business plan one-pager"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.business-status-update":[{"type":0,"value":"Business status update"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.career-development-plan":[{"type":0,"value":"Career development plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.competitive-analysis":[{"type":0,"value":"Competitive analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-design-glossary":[{"type":0,"value":"Content design glossary"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.content-strategy":[{"type":0,"value":"Content strategy"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-impact-assessment":[{"type":0,"value":"Customer impact assessment"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.customer-interview-report":[{"type":0,"value":"Customer interview report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.daci-decision-documentation":[{"type":0,"value":"DACI: decision documentation"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-decision":[{"type":0,"value":"Design decision"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-review":[{"type":0,"value":"Design review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-sprint":[{"type":0,"value":"Design sprint"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.design-systems":[{"type":0,"value":"Design systems"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.devops-runbook":[{"type":0,"value":"DevOps runbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.disruptive-brainstorming":[{"type":0,"value":"Disruptive brainstorming"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.employee-handbook":[{"type":0,"value":"Employee handbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.end-of-week-status-report":[{"type":0,"value":"End of week status report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.executive-business-review":[{"type":0,"value":"Executive business review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hiring-process":[{"type":0,"value":"Hiring process"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.how-to-article":[{"type":0,"value":"How-to article"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.hr-knowledge-base-management":[{"type":0,"value":"HR knowledge base management"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-communication":[{"type":0,"value":"Incident communication"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.incident-postmortem":[{"type":0,"value":"Incident postmortem"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-change-management":[{"type":0,"value":"ITSM change management"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-known-errors":[{"type":0,"value":"ITSM known errors"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-post-incident-reviews":[{"type":0,"value":"ITSM post incident reviews"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-runbook":[{"type":0,"value":"ITSM runbook"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.itsm-weekly-major-incident-report":[{"type":0,"value":"ITSM weekly major incident report"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.job-description":[{"type":0,"value":"Job description"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-performance-review":[{"type":0,"value":"Lenny\'s performance review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.lennys-product-requirements":[{"type":0,"value":"Lenny\'s product requirements"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-blog-post":[{"type":0,"value":"Marketing blog post"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-campaign":[{"type":0,"value":"Marketing campaign"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.marketing-plan":[{"type":0,"value":"Marketing plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.meeting-notes":[{"type":0,"value":"Meeting notes"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.message-house":[{"type":0,"value":"Message house"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.mutual-action-plan":[{"type":0,"value":"Mutual action plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.okrs":[{"type":0,"value":"OKRs"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.persona":[{"type":0,"value":"Persona"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.presenter-mode":[{"type":0,"value":"Presenter mode"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-requirements":[{"type":0,"value":"Product requirements"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.product-roadmap":[{"type":0,"value":"Product roadmap"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-kickoff":[{"type":0,"value":"Project kickoff"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-plan":[{"type":0,"value":"Project plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-status":[{"type":0,"value":"Project status"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.project-timeline-template":[{"type":0,"value":"Project timeline"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.qtc-acquisition":[{"type":0,"value":"QTC acquisition"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.quarterly-check-in":[{"type":0,"value":"Quarterly check in"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.remote-team-meeting":[{"type":0,"value":"Remote team meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.risk-assessment-matrix":[{"type":0,"value":"Risk assessment matrix"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.roles-and-responsibilities-play":[{"type":0,"value":"Roles and responsibilities play"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-account-planning":[{"type":0,"value":"Sales account planning"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sales-portal":[{"type":0,"value":"Sales portal"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.service-team-health-monitor":[{"type":0,"value":"Service team health monitor"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.smart-goals":[{"type":0,"value":"SMART goals"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.software-architecture-review":[{"type":0,"value":"Software architecture review"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.sprint-planning-meeting":[{"type":0,"value":"Sprint planning meeting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.stakeholder-communications":[{"type":0,"value":"Stakeholder communications"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.standard-operating-procedure":[{"type":0,"value":"Standard operating procedure (SOP)"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.strategic-plan":[{"type":0,"value":"Strategic plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.swot-analysis":[{"type":0,"value":"SWOT analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-homepage":[{"type":0,"value":"Team homepage"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.team-poster":[{"type":0,"value":"Team poster"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.to-do-list":[{"type":0,"value":"To-do list"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.troubleshooting-article":[{"type":0,"value":"Troubleshooting article"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vendor-agreement":[{"type":0,"value":"Vendor agreement"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.virtual-event":[{"type":0,"value":"Virtual event"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.vision-to-values":[{"type":0,"value":"Vision to values"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.weekly-meeting-notes":[{"type":0,"value":"Weekly meeting notes"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.work-trip-planner":[{"type":0,"value":"Work trip planner"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.workshop-planner":[{"type":0,"value":"Workshop planner"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.template.writing-guidelines":[{"type":0,"value":"Writing guidelines"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this."}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.use-template":[{"type":0,"value":"Use template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-starting":[{"type":0,"value":"We recommend starting with these templates for your team:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.we-recommend-these-templates":[{"type":0,"value":"We recommend these templates for your team:"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.4ls-retro":[{"type":0,"value":"4 Ls Retro"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.action-plan":[{"type":0,"value":"Action plan"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.annual-calendar-2025-2026":[{"type":0,"value":"Annual Calendar"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.brainwriting":[{"type":0,"value":"Brainwriting"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.concept-map":[{"type":0,"value":"Concept map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.crazy-8s":[{"type":0,"value":"Crazy 8s brainstorming"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.disruptive-brainstorm":[{"type":0,"value":"Disruptive brainstorm"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.elevator-pitch":[{"type":0,"value":"Elevator pitch"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.executive-summary":[{"type":0,"value":"Executive summary"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.fishbone-diagram":[{"type":0,"value":"Fishbone diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.flow-chart":[{"type":0,"value":"Flowchart"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.focus-area-diagram":[{"type":0,"value":"Focus area diagram"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.gap-analysis":[{"type":0,"value":"Gap analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.health-monitor":[{"type":0,"value":"Team health monitor"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.ice-breakers":[{"type":0,"value":"Icebreakers"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.incident-postmortem":[{"type":0,"value":"Incident postmortem"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.network-of-teams":[{"type":0,"value":"Network of teams"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.org-chart":[{"type":0,"value":"Org chart"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.prioritization":[{"type":0,"value":"Prioritization matrix"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-roadmap":[{"type":0,"value":"Product roadmap"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.product-vision-board":[{"type":0,"value":"Product vision board"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.root-cause-analysis":[{"type":0,"value":"Root cause analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.service-blueprint":[{"type":0,"value":"Service blueprint"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.simple-retrospective":[{"type":0,"value":"Simple retrospective"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.stakeholder-mapping":[{"type":0,"value":"Stakeholder mapping"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swimlanes":[{"type":0,"value":"Swimlanes process map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.swot-analysis":[{"type":0,"value":"SWOT Analysis"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.team-formation-guide":[{"type":0,"value":"Team charter template"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.timeline-workflow":[{"type":0,"value":"Timeline workflow"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.user-story-map":[{"type":0,"value":"User story map"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.whiteboard-template.workflow":[{"type":0,"value":"Workflow"}],"growth-confluence-find.message-templates.confluence-nudge-complete-fo.youre-off-to-a-great-start":[{"type":0,"value":"\uD83D\uDE80 You\'re off to a great start\u2014Let\'s start creating"}],"post-office.growth-confluence-find.connect-tools-spotlight.body":[{"type":0,"value":"Connect your team\'s most used apps to get better answers and more results across Search and Chat."}],"post-office.growth-confluence-find.connect-tools-spotlight.headline":[{"type":0,"value":"Search across tools"}],"post-office.growth-confluence-find.connect-tools-spotlight.primary-action":[{"type":0,"value":"Setup"}],"post-office.growth-confluence-find.flag-to-share.copied":[{"type":0,"value":"Copied!"}],"post-office.growth-confluence-find.flag-to-share.copy-link":[{"type":0,"value":"Copy link"}],"post-office.growth-confluence-find.flag-to-share.first.database.description":[{"type":0,"value":"Add your teammates so you can collaborate and stay in sync."}],"post-office.growth-confluence-find.flag-to-share.first.database.primary-action":[{"type":0,"value":"Share database"}],"post-office.growth-confluence-find.flag-to-share.first.database.title":[{"type":0,"value":"You\'ve created your first database"}],"post-office.growth-confluence-find.flag-to-share.first.live-doc.description":[{"type":0,"value":"Add your teammates so you can collaborate and stay in sync."}],"post-office.growth-confluence-find.flag-to-share.first.live-doc.primary-action":[{"type":0,"value":"Share doc"}],"post-office.growth-confluence-find.flag-to-share.first.live-doc.title":[{"type":0,"value":"You\'ve created your first live doc"}],"post-office.growth-confluence-find.flag-to-share.first.whiteboard.description":[{"type":0,"value":"Add your teammates so you can collaborate together in real time."}],"post-office.growth-confluence-find.flag-to-share.first.whiteboard.primary-action":[{"type":0,"value":"Share whiteboard"}],"post-office.growth-confluence-find.flag-to-share.first.whiteboard.title":[{"type":0,"value":"You\'ve created your first whiteboard"}],"post-office.growth-confluence-find.flag-to-share.second.land.database.description":[{"type":0,"value":"Share this database with your teammates, so everyone can contribute and stay in sync."}],"post-office.growth-confluence-find.flag-to-share.second.land.live-doc.description":[{"type":0,"value":"Share this doc with your teammates, so everyone has the same context."}],"post-office.growth-confluence-find.flag-to-share.second.land.whiteboard.description":[{"type":0,"value":"Share this whiteboard with your teammates, so you can brainstorm together in real time."}],"post-office.growth-confluence-find.flag-to-share.second.primary-action":[{"type":0,"value":"Share"}],"post-office.growth-confluence-find.flag-to-share.second.title":[{"type":0,"value":"Collaborate with your team"}],"post-office.growth-confluence-find.flag-to-share.second.xflow.database.description":[{"type":0,"value":"Share this database with your Jira team, so they can contribute and stay in sync."}],"post-office.growth-confluence-find.flag-to-share.second.xflow.live-doc.description":[{"type":0,"value":"Share this doc with your Jira teammates, so everyone has the same project info."}],"post-office.growth-confluence-find.flag-to-share.second.xflow.whiteboard.description":[{"type":0,"value":"Share this whiteboard with your Jira team, so you can brainstorm together in real time."}]}');

});

parcelRegister("7TLih", function(module, exports) {

let $5c025b0bbd992113$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c025b0bbd992113$var$load("kUReN").then(()=>parcelRequire('2FHx4'));

});

parcelRegister("7mTau", function(module, exports) {

let $55d561b966c24d89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $55d561b966c24d89$var$load("eMF3x").then(()=>parcelRequire('7ILCN'));

});

parcelRegister("aQ5Te", function(module, exports) {

let $7e43544c3d2d8e1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e43544c3d2d8e1b$var$load("iv98M").then(()=>parcelRequire('4Ukan'));

});

parcelRegister("3mJ4S", function(module, exports) {

let $273664acf2a35328$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $273664acf2a35328$var$load("8SFsg").then(()=>parcelRequire('hcy9K'));

});

parcelRegister("ehEnr", function(module, exports) {

let $a661f93ed06af945$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a661f93ed06af945$var$load("j71Pg").then(()=>parcelRequire('kdyiW'));

});

parcelRegister("bhKPe", function(module, exports) {

let $83759ac2ec41eca1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83759ac2ec41eca1$var$load("jMxQ4").then(()=>parcelRequire('8kErv'));

});

parcelRegister("8aPOA", function(module, exports) {

let $5f377342f17c9de4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f377342f17c9de4$var$load("hEDAR").then(()=>parcelRequire('h9KoL'));

});

parcelRegister("5c04W", function(module, exports) {

let $3c7e2263226b27a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c7e2263226b27a9$var$load("8VZD6").then(()=>parcelRequire('6f7Pr'));

});

parcelRegister("iElhp", function(module, exports) {

let $d93c7827edd49df5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d93c7827edd49df5$var$load("aD1tR").then(()=>parcelRequire('eCKK0'));

});

parcelRegister("2MSuk", function(module, exports) {

let $207a54a7d7fe00dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $207a54a7d7fe00dd$var$load("gH5IN").then(()=>parcelRequire('jbvFg'));

});

parcelRegister("gyU53", function(module, exports) {

let $c0eb52be32e9c243$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0eb52be32e9c243$var$load("8ykXg").then(()=>parcelRequire('diFy4'));

});

parcelRegister("hUMS7", function(module, exports) {

let $d0ad9396062add77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0ad9396062add77$var$load("6k2Mx").then(()=>parcelRequire('EMrLW'));

});

parcelRegister("eCwrg", function(module, exports) {

let $aa4dc6f61252a1ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa4dc6f61252a1ba$var$load("7Yi8H").then(()=>parcelRequire('3VKkk'));

});

parcelRegister("2vIBs", function(module, exports) {

let $1d41134510778054$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1d41134510778054$var$load("6z8cX").then(()=>parcelRequire('eB5yM'));

});

parcelRegister("ipMGk", function(module, exports) {

let $d68052fbb23903ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d68052fbb23903ed$var$load("fxpHG").then(()=>parcelRequire('3R04o'));

});

parcelRegister("gre8P", function(module, exports) {

let $bf7a23258a581beb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf7a23258a581beb$var$load("c5NNO").then(()=>parcelRequire('fq0jP'));

});

parcelRegister("ahKBm", function(module, exports) {

let $77cfa409d5db0163$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77cfa409d5db0163$var$load("ellam").then(()=>parcelRequire('1WyD0'));

});

parcelRegister("lpVTB", function(module, exports) {

let $f978d7a71402f5c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f978d7a71402f5c6$var$load("16C0F").then(()=>parcelRequire('5WonM'));

});

parcelRegister("bNzyH", function(module, exports) {

let $896fda86ed27d4f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $896fda86ed27d4f2$var$load("eJ5SG").then(()=>parcelRequire('2dsSH'));

});

parcelRegister("9TBwA", function(module, exports) {

let $73465bb93592b71e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73465bb93592b71e$var$load("6pDZc").then(()=>parcelRequire('h3zUr'));

});

parcelRegister("6Uq1z", function(module, exports) {

let $507c28ea788735cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $507c28ea788735cf$var$load("gQsKk").then(()=>parcelRequire('hjDgk'));

});

parcelRegister("krNGI", function(module, exports) {

let $ee2cdf45cbd44a26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee2cdf45cbd44a26$var$load("5jRki").then(()=>parcelRequire('8fqnr'));

});

parcelRegister("eRkHK", function(module, exports) {

let $ad1613737902a6eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad1613737902a6eb$var$load("jUEOF").then(()=>parcelRequire('eLJSK'));

});

parcelRegister("9X0Cq", function(module, exports) {

let $73ea1aa273c9d3e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73ea1aa273c9d3e1$var$load("l3a5T").then(()=>parcelRequire('f6vAO'));

});

parcelRegister("kgvwa", function(module, exports) {

let $ec0dc008227a4f73$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec0dc008227a4f73$var$load("4oMoL").then(()=>parcelRequire('bt3Vm'));

});

parcelRegister("6l3j3", function(module, exports) {

let $49d744cae09efa74$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49d744cae09efa74$var$load("gpmPo").then(()=>parcelRequire('azrW4'));

});

parcelRegister("h0a3n", function(module, exports) {

let $c60a3c2c116d5023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c60a3c2c116d5023$var$load("05bp2").then(()=>parcelRequire('7kvZY'));

});

parcelRegister("3Mq6j", function(module, exports) {

let $2c0a19e17eea1550$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c0a19e17eea1550$var$load("hVbzv").then(()=>parcelRequire('jMjFS'));

});

parcelRegister("71Rjt", function(module, exports) {

let $51e1fb4774a648f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51e1fb4774a648f4$var$load("9ze1k").then(()=>parcelRequire('l86OZ'));

});

parcelRegister("cTrN7", function(module, exports) {

let $96302ddaa069266f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96302ddaa069266f$var$load("4Yw33").then(()=>parcelRequire('hLcf2'));

});

parcelRegister("aUto0", function(module, exports) {

let $7f15edd3ee94a533$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f15edd3ee94a533$var$load("UJ9mk").then(()=>parcelRequire('6fEu9'));

});

parcelRegister("jcOzM", function(module, exports) {

let $dfb65ea73430197d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfb65ea73430197d$var$load("hNDlV").then(()=>parcelRequire('fHpzH'));

});

parcelRegister("f9Xq7", function(module, exports) {

let $b095c9e23b783c76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b095c9e23b783c76$var$load("jgg9p").then(()=>parcelRequire('1F9S0'));

});

parcelRegister("e0QjB", function(module, exports) {

let $a339a57ddd3344e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a339a57ddd3344e7$var$load("6F1vf").then(()=>parcelRequire('U0Rbi'));

});

parcelRegister("b9HG5", function(module, exports) {
module.exports = JSON.parse("{\"cpq.cpq-user-feedback.question.no-translate\":[{\"type\":0,\"value\":\"What is your feedback?\"}],\"cpq.cpq-user-feedback.statement.no-translate\":[{\"type\":0,\"value\":\"What is your feedback?\"}]}");

});

parcelRegister("cG81y", function(module, exports) {

let $0261ccee405291d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0261ccee405291d4$var$load("7OEli").then(()=>parcelRequire('5XgFD'));

});

parcelRegister("2NyU9", function(module, exports) {

let $209b3bbb8376b90a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $209b3bbb8376b90a$var$load("2KfwO").then(()=>parcelRequire('ajT1B'));

});

parcelRegister("ietP8", function(module, exports) {

let $d460ab2dbc1d7fbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d460ab2dbc1d7fbf$var$load("g8Cbp").then(()=>parcelRequire('gFnm0'));

});

parcelRegister("1eovA", function(module, exports) {

let $0e5a1c1db1a83ede$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0e5a1c1db1a83ede$var$load("7uhdl").then(()=>parcelRequire('04yKK'));

});

parcelRegister("5k7oO", function(module, exports) {

let $3e048f51072b5747$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3e048f51072b5747$var$load("80wi9").then(()=>parcelRequire('hAVOk'));

});

parcelRegister("88KU9", function(module, exports) {

let $5ed3745fa6fe4b2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ed3745fa6fe4b2a$var$load("lzOwV").then(()=>parcelRequire('dT28m'));

});

parcelRegister("etvON", function(module, exports) {

let $a89c7495bf355dab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a89c7495bf355dab$var$load("4vmcC").then(()=>parcelRequire('dNRsB'));

});

parcelRegister("9kCgZ", function(module, exports) {

let $6cb3ab89a6c4e5b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6cb3ab89a6c4e5b3$var$load("dWu2v").then(()=>parcelRequire('kK3nH'));

});

parcelRegister("kxQKy", function(module, exports) {

let $ef4fceb8cbee4453$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef4fceb8cbee4453$var$load("cCX2j").then(()=>parcelRequire('4n0zW'));

});

parcelRegister("fqcA7", function(module, exports) {

let $b3a30b232604c959$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3a30b232604c959$var$load("j33tP").then(()=>parcelRequire('hoEr3'));

});

parcelRegister("1k6j7", function(module, exports) {

let $0f6c8d3aa3f335b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f6c8d3aa3f335b2$var$load("fyYQF").then(()=>parcelRequire('32Edz'));

});

parcelRegister("8rJtX", function(module, exports) {

let $6264202a4e92fc30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6264202a4e92fc30$var$load("c937Z").then(()=>parcelRequire('38oce'));

});

parcelRegister("37RbN", function(module, exports) {

let $246b48d8a11a9a39$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $246b48d8a11a9a39$var$load("hZDjH").then(()=>parcelRequire('8EP4c'));

});

parcelRegister("bCAVJ", function(module, exports) {

let $875fe3dc38fb333a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $875fe3dc38fb333a$var$load("6yhsL").then(()=>parcelRequire('fqL9o'));

});

parcelRegister("d3t0X", function(module, exports) {

let $98120fd5d300f07e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98120fd5d300f07e$var$load("keBqf").then(()=>parcelRequire('bmVXy'));

});

parcelRegister("bMGI1", function(module, exports) {

let $89454e8279762075$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89454e8279762075$var$load("ksM6Y").then(()=>parcelRequire('hsq8h'));

});

parcelRegister("8hbyi", function(module, exports) {

let $6068df47d4016d91$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6068df47d4016d91$var$load("hfEI5").then(()=>parcelRequire('5sVbI'));

});

parcelRegister("d1DSE", function(module, exports) {

let $97ba4dd056b383a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97ba4dd056b383a3$var$load("i6JM4").then(()=>parcelRequire('dD34N'));

});

parcelRegister("iugLC", function(module, exports) {

let $d75808eefc14dc03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d75808eefc14dc03$var$load("23PTT").then(()=>parcelRequire('atjK4'));

});

parcelRegister("hAZGJ", function(module, exports) {

let $ccf5a67403e50e89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ccf5a67403e50e89$var$load("lTJDt").then(()=>parcelRequire('h5Ykw'));

});

parcelRegister("6gViH", function(module, exports) {

let $4910af658e815ecc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4910af658e815ecc$var$load("1Pk0z").then(()=>parcelRequire('bDxYF'));

});

parcelRegister("69cDb", function(module, exports) {

let $479d619c7eb97df8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $479d619c7eb97df8$var$load("lcQmz").then(()=>parcelRequire('jsozp'));

});

parcelRegister("4myJI", function(module, exports) {

let $32d4296bf01dde71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32d4296bf01dde71$var$load("2eOkY").then(()=>parcelRequire('1GPOE'));

});

parcelRegister("9cxEo", function(module, exports) {

let $6b2f565334413c58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b2f565334413c58$var$load("kmcTd").then(()=>parcelRequire('aVIPp'));

});

parcelRegister("kalAm", function(module, exports) {

let $eae57c3fe3dd6b26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eae57c3fe3dd6b26$var$load("iQeyY").then(()=>parcelRequire('cCaxa'));

});

parcelRegister("7Fzov", function(module, exports) {

let $5957d14fd66384a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5957d14fd66384a6$var$load("aNWiG").then(()=>parcelRequire('8aTnT'));

});

parcelRegister("8OFrP", function(module, exports) {

let $66b324e703317985$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66b324e703317985$var$load("TwJAa").then(()=>parcelRequire('dDG6f'));

});

parcelRegister("5gsuk", function(module, exports) {

let $3d548b81e64f9b5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d548b81e64f9b5a$var$load("3K4dQ").then(()=>parcelRequire('81bUc'));

});

parcelRegister("5U4bf", function(module, exports) {

let $44c56cd5f8fbcf77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44c56cd5f8fbcf77$var$load("1MAF8").then(()=>parcelRequire('54X8R'));

});

parcelRegister("44BT5", function(module, exports) {

let $2f74eccac25c9e04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f74eccac25c9e04$var$load("90ONN").then(()=>parcelRequire('9seif'));

});

parcelRegister("4MR8N", function(module, exports) {

let $37c4ddc39bd740dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37c4ddc39bd740dd$var$load("5LXJQ").then(()=>parcelRequire('5JDZ8'));

});

parcelRegister("6fdO5", function(module, exports) {

let $48beda8bf84933f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48beda8bf84933f2$var$load("2ZV6d").then(()=>parcelRequire('hSyVS'));

});

parcelRegister("86TRc", function(module, exports) {

let $5e7a364d35f603c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e7a364d35f603c9$var$load("1M5tg").then(()=>parcelRequire('en58w'));

});

parcelRegister("lKnw1", function(module, exports) {

let $fd502289a7823dc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd502289a7823dc1$var$load("3HAaW").then(()=>parcelRequire('6zWKz'));

});

parcelRegister("iwQJq", function(module, exports) {
module.exports = JSON.parse('{"cross-flow-jpd-notify-continue-set-up.notification.primary.action":[{"type":0,"value":"Finish setup"}],"cross-flow-jpd-notify-continue-set-up.notification.secondary.action":[{"type":0,"value":"Start a new project"}],"cross-flow-jpd-notify-continue-set-up.notification.title":[{"type":0,"value":"Finish setting up "},{"type":1,"value":"templateName"}],"cross-flow-jsm-notify-continue-set-up.notification.body":[{"type":0,"value":"85% of users find that using Jira with Jira Service Management makes it easier to coordinate and resolve requests."}],"cross-flow-jsm-notify-continue-set-up.notification.generic.title":[{"type":0,"value":"Finish setting up "},{"type":1,"value":"templateName"}],"cross-flow-jsm-notify-continue-set-up.notification.primary.action":[{"type":0,"value":"Finish setup"}],"cross-flow-jsm-notify-continue-set-up.notification.secondary.action":[{"type":0,"value":"Start a new project"}],"cross-flow-jsm-notify-continue-set-up.notification.specific.title":[{"type":0,"value":"Finish setting up your "},{"type":1,"value":"templateName"},{"type":0,"value":" project"}],"cross-flow-product-notification-added-new-product.message.jira.product.discovery.body":[{"type":0,"value":"Jira Product Discovery has been added to your site. Use it to capture, prioritize, and roadmap ideas."}],"cross-flow-product-notification-added-new-product.message.jira.servicedesk.ondemand.body":[{"type":0,"value":"Jira Service Management has been added to your site. Use it to receive, track, and manage requests."}],"cross-flow-product-notification-added-new-product.message.path.link.label":[{"type":0,"value":"Atlassian Administration"}],"cross-flow-product-notification-added-new-product.message.title":[{"type":1,"value":"actorName"},{"type":0,"value":" added "},{"type":1,"value":"productName"}],"cross-flow-product-notification-added-new-product.request.primary.action.label":[{"type":0,"value":"View project"}],"cross-flow-product-notification-added-new-product.request.secondary.action.label":[{"type":0,"value":"Learn more"}],"cross-flow-product-request-approval.message.title":[{"type":0,"value":"Your request to try "},{"type":1,"value":"product_name"},{"type":0,"value":" has been approved!"}],"cross-flow-product-request-reminder.message.com.atlassian.service.collection.body":[{"type":0,"value":"Service Collection helps your teams deliver exceptional service experiences for employees and customers through a single platform."}],"cross-flow-product-request-reminder.message.confluence.ondemand.body":[{"type":0,"value":"Confluence is a single place for all documentation and it seamlessly links to Jira. It\u2019s free to try and cancel anytime."}],"cross-flow-product-request-reminder.message.jira.product.discovery.body":[{"type":0,"value":"Jira Product Discovery is a roadmap and prioritization tool that links to your business or software projects."}],"cross-flow-product-request-reminder.message.jira.servicedesk.ondemand.body":[{"type":0,"value":"Jira Service Management links to your business or software projects to receive and manage requests."}],"cross-flow-product-request-reminder.message.path.link.label":[{"type":0,"value":"Atlassian Administration"}],"cross-flow-product-request-reminder.message.title":[{"type":0,"value":"Action required: "},{"type":1,"value":"requestor_name"},{"type":0,"value":" is waiting for your approval to try "},{"type":1,"value":"product_name"}],"cross-flow-product-request-reminder.message.title.doublerequestors":[{"type":0,"value":"Action required: "},{"type":1,"value":"requestor_name"},{"type":0,"value":" and "},{"type":1,"value":"previous_requestor_name"},{"type":0,"value":" are waiting for your approval to try "},{"type":1,"value":"product_name"}],"cross-flow-product-request-reminder.message.title.multirequestors":[{"type":0,"value":"Action required: "},{"type":1,"value":"requestor_name"},{"type":0,"value":" and "},{"type":1,"value":"previous_requestor_count"},{"type":0,"value":" others are waiting for your approval to try "},{"type":1,"value":"product_name"}],"cross-flow-product-request-reminder.request.primary.action.label":[{"type":0,"value":"Start free"}],"cross-flow-product-request-reminder.request.secondary.action.label":[{"type":0,"value":"Learn more"}],"cross-flow-product-request.message.path.link.label":[{"type":0,"value":"Atlassian Administration"}],"cross-flow-product-request.message.title":[{"type":0,"value":"Approve app request from "},{"type":1,"value":"actorName"}],"cross-flow-product-request.request.primary.action.label":[{"type":0,"value":"Start free"}],"cross-flow-product-request.request.primary.action.review.label":[{"type":0,"value":"Review request"}],"cross-flow-product-request.request.secondary.action.label":[{"type":0,"value":"Learn more"}],"cross-flow-product-store-recommendations.confluence.body":[{"type":0,"value":"Create consistency with award-winning page templates."}],"cross-flow-product-store-recommendations.confluence.title":[{"type":0,"value":"Content creation"}],"cross-flow-product-store-recommendations.jira.body":[{"type":0,"value":"Visualize work with custom workflow, lists, boards, backlogs, and more."}],"cross-flow-product-store-recommendations.jira.title":[{"type":0,"value":"Plan and track work"}],"cross-flow-product-store-recommendations.jpd.product-discovery.body":[{"type":0,"value":"Prioritize ideas then connect them from discovery through to delivery."}],"cross-flow-product-store-recommendations.jpd.product-discovery.title":[{"type":0,"value":"Product discovery"}],"cross-flow-product-store-recommendations.jpd.product-roadmap.body":[{"type":0,"value":"Create custom roadmaps and share your plans with anyone."}],"cross-flow-product-store-recommendations.jpd.product-roadmap.title":[{"type":0,"value":"Product roadmap"}],"cross-flow-product-store-recommendations.jsm.analytics-service-management.body":[{"type":0,"value":"Help employees access and request the data and analytics they need."}],"cross-flow-product-store-recommendations.jsm.analytics-service-management.title":[{"type":0,"value":"Analytics service management"}],"cross-flow-product-store-recommendations.jsm.customer-service-management.body":[{"type":0,"value":"Help your customers easily raise requests, report problems, and get support."}],"cross-flow-product-store-recommendations.jsm.customer-service-management.title":[{"type":0,"value":"Customer service management"}],"cross-flow-product-store-recommendations.jsm.design-service-management.body":[{"type":0,"value":"Manage employee requests for designs, reviews, and any other request."}],"cross-flow-product-store-recommendations.jsm.design-service-management.title":[{"type":0,"value":"Design service management"}],"cross-flow-product-store-recommendations.jsm.facilities-service-management.body":[{"type":0,"value":"Easily manage requests for maintenance, moving, and event planning."}],"cross-flow-product-store-recommendations.jsm.facilities-service-management.title":[{"type":0,"value":"Facilities service management"}],"cross-flow-product-store-recommendations.jsm.finance-service-management.body":[{"type":0,"value":"Easily manage and track budget, spend, and any other finance request."}],"cross-flow-product-store-recommendations.jsm.finance-service-management.title":[{"type":0,"value":"Finance service management"}],"cross-flow-product-store-recommendations.jsm.general-service-management.body":[{"type":0,"value":"Create one place to collect and manage any type of request."}],"cross-flow-product-store-recommendations.jsm.general-service-management.title":[{"type":0,"value":"General service management"}],"cross-flow-product-store-recommendations.jsm.hr-service-management.body":[{"type":0,"value":"Simplify onboarding, off-boarding, and any other HR request."}],"cross-flow-product-store-recommendations.jsm.hr-service-management.title":[{"type":0,"value":"HR service management"}],"cross-flow-product-store-recommendations.jsm.it-service-management.body":[{"type":0,"value":"Quickly respond to requests, resolve incidents, and deploy changes."}],"cross-flow-product-store-recommendations.jsm.it-service-management.title":[{"type":0,"value":"IT service management"}],"cross-flow-product-store-recommendations.jsm.legal-service-management.body":[{"type":0,"value":"Easily manage requests about contracts, policies, and more."}],"cross-flow-product-store-recommendations.jsm.legal-service-management.title":[{"type":0,"value":"Legal service management"}],"cross-flow-product-store-recommendations.jsm.marketing-service-management.body":[{"type":0,"value":"Manage employee requests for assets, reviews, and any other marketing request."}],"cross-flow-product-store-recommendations.jsm.marketing-service-management.title":[{"type":0,"value":"Marketing service management"}],"cross-flow-product-store-recommendations.jsm.sales-service-management.body":[{"type":0,"value":"Easily manage requests for quote support, contract reviews, and more."}],"cross-flow-product-store-recommendations.jsm.sales-service-management.title":[{"type":0,"value":"Sales service management"}],"cross-flow.components.product-store-template-card.template-image-alt-text":[{"type":0,"value":"A document titled quarterly planning. The document has details like mission, scope and a monthly plan."}],"cross-flow.components.product-store-template-card.template-try-cta-button-text":[{"type":0,"value":"Try template"}],"cross-flow.cross-flow-product-request-approval.action":[{"type":0,"value":"Go to Jira Product Discovery"}],"cross-flow.cross-flow-product-request-approval.description":[{"type":0,"value":"Prioritize ideas, build living roadmaps, and connect to delivery in Jira."}],"cross-flow.cross-flow-product-request-approval.title":[{"type":0,"value":"Your access to Jira Product Discovery has been approved"}],"cross-flow.cross-flow-product-request.screen-space-flags.action.get-started":[{"type":0,"value":"Get started"}],"cross-flow.cross-flow-product-request.screen-space-flags.action.remind-me-later":[{"type":0,"value":"Remind me later"}],"cross-flow.cross-flow-product-request.screen-space-flags.action.review-request":[{"type":0,"value":"Review request"}],"cross-flow.cross-flow-product-request.screen-space-flags.description":[{"type":1,"value":"requesterName"},{"type":0,"value":" sent a request to try "},{"type":1,"value":"productName"},{"type":0,"value":". It\'s free to try. Cancel any time."}],"cross-flow.cross-flow-product-request.screen-space-flags.title":[{"type":0,"value":"Approve a request to try "},{"type":1,"value":"productName"}],"cross-flow.xflow-notification-end-user-added-loom.message-template.email.subject":[{"type":0,"value":"\uD83C\uDF89 "},{"type":1,"value":"name"},{"type":0,"value":" has started using Loom"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.admin-url.no-translate":[{"type":0,"value":"admin.atlassian.com"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.footer.icon.alt":[{"type":0,"value":"Atlassian Logo"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.get-started.button":[{"type":0,"value":"Get started"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.header.icon.alt":[{"type":0,"value":"Loom Logo"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.headline":[{"type":1,"value":"name"},{"type":0,"value":" has started using Loom!"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.instance-url.no-translate":[{"type":1,"value":"instanceUrl"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.lead-paragraph":[{"type":0,"value":"Loom has been added to "},{"type":1,"value":"instanceURL"},{"type":0,"value":". You don\u2019t need to do anything. "},{"children":[{"type":0,"value":"Invite up to 10 members, for free."}],"type":8,"value":"b"},{"type":0,"value":" You can cancel any time at "},{"type":1,"value":"adminURL"},{"type":0,"value":"."}],"cross-flow.xflow-notification-end-user-added-loom.message.email.sent-by-atlassian":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.communication":[{"type":0,"value":"\uD83D\uDE80 Explore Loom and see how it can transform your team\'s communication and collaboration."}],"cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.efficiency":[{"type":0,"value":"\u23F1\uFE0F Teams using Loom report a 29% reduction in meetings and a 74% increase in efficiency."}],"cross-flow.xflow-notification-end-user-added-loom.message.email.value-prop.share-video":[{"type":0,"value":"\uD83D\uDCF9 Loom allows teams to create and share video messages effortlessly."}]}');

});

parcelRegister("esDHJ", function(module, exports) {

let $a8727aaa0c103137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a8727aaa0c103137$var$load("8uTFT").then(()=>parcelRequire('9GqZ9'));

});

parcelRegister("9AMHt", function(module, exports) {

let $6fbd40b54bd88904$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fbd40b54bd88904$var$load("4o3WJ").then(()=>parcelRequire('1HfXN'));

});

parcelRegister("4eLN9", function(module, exports) {

let $315d8aa747699639$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $315d8aa747699639$var$load("52FP2").then(()=>parcelRequire('6AGJc'));

});

parcelRegister("hkPKW", function(module, exports) {

let $c9ec739e92bef01a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9ec739e92bef01a$var$load("6XsHL").then(()=>parcelRequire('8Uqwy'));

});

parcelRegister("beYaH", function(module, exports) {

let $82efad5757ea673f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82efad5757ea673f$var$load("5ddYP").then(()=>parcelRequire('bQ93l'));

});

parcelRegister("6ZiaS", function(module, exports) {

let $516689a39e370d77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $516689a39e370d77$var$load("4r2y8").then(()=>parcelRequire('9tNWK'));

});

parcelRegister("h2Q2Q", function(module, exports) {

let $c68afe987888e604$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c68afe987888e604$var$load("7eMpd").then(()=>parcelRequire('9rZZk'));

});

parcelRegister("bU500", function(module, exports) {

let $8aa8cd69762c4b87$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8aa8cd69762c4b87$var$load("r5gXC").then(()=>parcelRequire('9zf6W'));

});

parcelRegister("awDKW", function(module, exports) {

let $7a9bbb43093fc45d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a9bbb43093fc45d$var$load("020fI").then(()=>parcelRequire('7eMeC'));

});

parcelRegister("AzXWa", function(module, exports) {

let $06df42f3bda32fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $06df42f3bda32fed$var$load("grlv4").then(()=>parcelRequire('8z5sq'));

});

parcelRegister("eF6Ya", function(module, exports) {

let $aaca4d02618997eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aaca4d02618997eb$var$load("11YfA").then(()=>parcelRequire('cPC4h'));

});

parcelRegister("dd9cR", function(module, exports) {

let $99e3a171c805cbfd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99e3a171c805cbfd$var$load("lzV4B").then(()=>parcelRequire('fWciR'));

});

parcelRegister("a1Acb", function(module, exports) {

let $74c613118ca03447$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $74c613118ca03447$var$load("ipHLW").then(()=>parcelRequire('iMMeq'));

});

parcelRegister("4LZ3t", function(module, exports) {

let $379ae9735d88c38c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $379ae9735d88c38c$var$load("jTt1X").then(()=>parcelRequire('4ipdI'));

});

parcelRegister("9bTeQ", function(module, exports) {

let $6b0ffd576fbe628f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b0ffd576fbe628f$var$load("bxGuJ").then(()=>parcelRequire('aRaqD'));

});

parcelRegister("5HqKc", function(module, exports) {

let $4265b6bbea81a0f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4265b6bbea81a0f1$var$load("6qadE").then(()=>parcelRequire('eiQsN'));

});

parcelRegister("4uo0N", function(module, exports) {

let $344c97041af2b7a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $344c97041af2b7a7$var$load("l75ju").then(()=>parcelRequire('f1zCj'));

});

parcelRegister("1juUo", function(module, exports) {

let $0f4f8a9b7a8e5e31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f4f8a9b7a8e5e31$var$load("kyun8").then(()=>parcelRequire('lWqWj'));

});

parcelRegister("cwrME", function(module, exports) {

let $91de0671db68e7ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91de0671db68e7ca$var$load("6EAab").then(()=>parcelRequire('g4R9y'));

});

parcelRegister("8Qg1Z", function(module, exports) {

let $66ff9d7c54015891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $66ff9d7c54015891$var$load("bZzRf").then(()=>parcelRequire('cMYdw'));

});

parcelRegister("2EI43", function(module, exports) {

let $1ef17f74ab472f27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ef17f74ab472f27$var$load("9JS7u").then(()=>parcelRequire('cQfJB'));

});

parcelRegister("daXaK", function(module, exports) {

let $997a1beb36caf57e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $997a1beb36caf57e$var$load("9AUQY").then(()=>parcelRequire('hfsbb'));

});

parcelRegister("e9mhf", function(module, exports) {

let $02a8914957c61fde$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $02a8914957c61fde$var$load("amAv0").then(()=>parcelRequire('6Sidc'));

});

parcelRegister("aoRDp", function(module, exports) {

let $7925bffd8c060791$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7925bffd8c060791$var$load("jxXXO").then(()=>parcelRequire('aGgN4'));

});

parcelRegister("1FZc3", function(module, exports) {

let $1389168061947429$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1389168061947429$var$load("4QPGH").then(()=>parcelRequire('iv1eT'));

});

parcelRegister("3gHqI", function(module, exports) {

let $26148e03e184431d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26148e03e184431d$var$load("4WGuU").then(()=>parcelRequire('iF5xc'));

});

parcelRegister("dtwRs", function(module, exports) {

let $9cf779549ede87ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9cf779549ede87ea$var$load("6DebQ").then(()=>parcelRequire('4WiK3'));

});

parcelRegister("kOGAu", function(module, exports) {

let $f279832db94ae910$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f279832db94ae910$var$load("4rwgn").then(()=>parcelRequire('8Nmoe'));

});

parcelRegister("dRke1", function(module, exports) {

let $a16fe9dfb27e46ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a16fe9dfb27e46ae$var$load("gqzs7").then(()=>parcelRequire('5z2Qf'));

});

parcelRegister("4bMpu", function(module, exports) {

let $30cdbdbedf2e02ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $30cdbdbedf2e02ed$var$load("fC6Z3").then(()=>parcelRequire('2jW6D'));

});

parcelRegister("3QLtk", function(module, exports) {

let $2cdb0d688da2aaa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cdb0d688da2aaa6$var$load("k2qqp").then(()=>parcelRequire('1V42t'));

});

parcelRegister("8hTGT", function(module, exports) {

let $608b1c4a0a4aff3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $608b1c4a0a4aff3d$var$load("gxsnu").then(()=>parcelRequire('dlgjv'));

});

parcelRegister("bXeCN", function(module, exports) {

let $8b408c947e3e75cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b408c947e3e75cb$var$load("2aRNt").then(()=>parcelRequire('5Fqy2'));

});

parcelRegister("9wqIE", function(module, exports) {

let $6eebd4103856a4d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6eebd4103856a4d0$var$load("ksXJ1").then(()=>parcelRequire('dIzw1'));

});

parcelRegister("f5lVB", function(module, exports) {
module.exports = JSON.parse('{"jsm-cbp-grace-period-notification.message.link.extra.objects":[{"type":0,"value":"Get extra objects"}],"jsm-cbp-grace-period-notification.message.link.learn.more":[{"type":0,"value":"Learn more"}],"jsm-cbp-grace-period-notification.message.link.manage.usage":[{"type":0,"value":"Manage usage"}],"jsm-cbp-grace-period-notification.message.text.ninety.days":[{"type":0,"value":"Consumption-based pricing will come into effect after "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"jsm-cbp-grace-period-notification.message.text.thirty.days":[{"type":0,"value":"Extra usage of Assets and the virtual service agent in Jira Service Management will be billed."}],"jsm-cbp-grace-period-notification.message.title.ninety.days":[{"type":0,"value":"You are nearing the end of your Grace period"}],"jsm-cbp-grace-period-notification.message.title.thirty.days":[{"type":0,"value":"Consumption-based pricing starts in "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"daysRemaining"}],"jsm-sequoia.better-together-with-jira.csm.brand":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.better-together-with-jira.csm.closingDescription":[{"type":0,"value":"During signup, you were provisioned both Jira and Jira Service Management. Jump into Jira to discover what\'s possible"}],"jsm-sequoia.better-together-with-jira.csm.closingTitle":[{"type":0,"value":"Ready to get started?"}],"jsm-sequoia.better-together-with-jira.csm.heroDescription":[{"type":0,"value":"Help customers in the moment, spot customer service trends and track opportunities in Jira to continuously improve how your team delivers support."}],"jsm-sequoia.better-together-with-jira.csm.heroTitle":[{"type":0,"value":"Support customers today, elevate your service tomorrow"}],"jsm-sequoia.better-together-with-jira.csm.sectionTitle":[{"type":0,"value":"Deliver customer support in 3 steps"}],"jsm-sequoia.better-together-with-jira.csm.step1Description":[{"type":0,"value":"Manage email, chat, web, and voice requests from a single queue. Use AI agents to provide help 24/7."}],"jsm-sequoia.better-together-with-jira.csm.step1ImageAlt":[{"type":0,"value":"Customer support conversation in a shared service queue"}],"jsm-sequoia.better-together-with-jira.csm.step1Title":[{"type":0,"value":"Bring all requests into one place"}],"jsm-sequoia.better-together-with-jira.csm.step2Description":[{"type":0,"value":"Use dashboards and reports to identify opportunities to improve products and customer support."}],"jsm-sequoia.better-together-with-jira.csm.step2ImageAlt":[{"type":0,"value":"Customer satisfaction and time to resolution report highlighting an opportunity"}],"jsm-sequoia.better-together-with-jira.csm.step2Title":[{"type":0,"value":"Spot trends and save time"}],"jsm-sequoia.better-together-with-jira.csm.step3Description":[{"type":0,"value":"Turn support conversations straight into Jira work items to update help articles, report bugs, or share feedback directly with developers."}],"jsm-sequoia.better-together-with-jira.csm.step3ImageAlt":[{"type":0,"value":"Jira board with work items for improving customer support"}],"jsm-sequoia.better-together-with-jira.csm.step3Title":[{"type":0,"value":"Turn everyday issues into lasting improvements"}],"jsm-sequoia.better-together-with-jira.csm.subject":[{"type":0,"value":"Deliver better support, with Jira!"}],"jsm-sequoia.better-together-with-jira.explore-jira":[{"type":0,"value":"Explore Jira"}],"jsm-sequoia.better-together-with-jira.hr.brand":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.better-together-with-jira.hr.closingDescription":[{"type":0,"value":"During signup, you were provisioned both Jira and Jira Service Management. Jump into Jira to discover what\'s possible"}],"jsm-sequoia.better-together-with-jira.hr.closingTitle":[{"type":0,"value":"Ready to get started?"}],"jsm-sequoia.better-together-with-jira.hr.heroDescription":[{"type":0,"value":"Centralize inquiries from various channels and let Rovo agents handle routine questions. Find common trends and use Jira to track the work you\'re doing to improve your support and boost productivity."}],"jsm-sequoia.better-together-with-jira.hr.heroTitle":[{"type":0,"value":"Streamline HR requests and delight your team from Day 1"}],"jsm-sequoia.better-together-with-jira.hr.sectionTitle":[{"type":0,"value":"Deliver exceptional HR service in 3 steps"}],"jsm-sequoia.better-together-with-jira.hr.step1Description":[{"type":0,"value":"Meet employees where they work, whether on Slack, web, or email. Let Rovo agents handle repetitive questions instantly so your team doesn\'t have to."}],"jsm-sequoia.better-together-with-jira.hr.step1ImageAlt":[{"type":0,"value":"Help center form for onboarding a new employee with an attached details file"}],"jsm-sequoia.better-together-with-jira.hr.step1Title":[{"type":0,"value":"Centralize and automate intake"}],"jsm-sequoia.better-together-with-jira.hr.step2Description":[{"type":0,"value":"Use dashboards and reports to turn service data into actionable insights for continuous onboarding improvements."}],"jsm-sequoia.better-together-with-jira.hr.step2ImageAlt":[{"type":0,"value":"Report of onboarding questions highlighting an opportunity"}],"jsm-sequoia.better-together-with-jira.hr.step2Title":[{"type":0,"value":"Uncover trends and bottlenecks"}],"jsm-sequoia.better-together-with-jira.hr.step3Description":[{"type":0,"value":"Turn recurring pain points into prioritized work items. Collaborate with stakeholders to solve problems at the source."}],"jsm-sequoia.better-together-with-jira.hr.step3ImageAlt":[{"type":0,"value":"Jira board with work items for improving employee onboarding"}],"jsm-sequoia.better-together-with-jira.hr.step3Title":[{"type":0,"value":"Turn feedback into continuous improvements"}],"jsm-sequoia.better-together-with-jira.hr.subject":[{"type":0,"value":"Deliver better service, with Jira!"}],"jsm-sequoia.better-together-with-jira.jsm.brand":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.better-together-with-jira.jsm.closingDescription":[{"type":0,"value":"During signup, you were provisioned both Jira and Jira Service Management. Jump into Jira to discover what\'s possible"}],"jsm-sequoia.better-together-with-jira.jsm.closingTitle":[{"type":0,"value":"Ready to get started?"}],"jsm-sequoia.better-together-with-jira.jsm.heroDescription":[{"type":0,"value":"Connect support queues to backlogs in Jira to eliminate hand-off friction and lost context."}],"jsm-sequoia.better-together-with-jira.jsm.heroTitle":[{"type":0,"value":"Build a seamless workflow between request intake and product delivery"}],"jsm-sequoia.better-together-with-jira.jsm.sectionTitle":[{"type":0,"value":"Deliver exceptional service in 3 steps"}],"jsm-sequoia.better-together-with-jira.jsm.step1Description":[{"type":0,"value":"Collect, triage, and resolve requests from portals, mobile, Slack, or email. Use Rovo agents to handle routine queries and improve self service."}],"jsm-sequoia.better-together-with-jira.jsm.step1ImageAlt":[{"type":0,"value":"Help center request form with a support request and attached file"}],"jsm-sequoia.better-together-with-jira.jsm.step1Title":[{"type":0,"value":"Triage requests automatically"}],"jsm-sequoia.better-together-with-jira.jsm.step2Description":[{"type":0,"value":"Use dashboards and reports to uncover recurring issues and identify opportunities to improve support."}],"jsm-sequoia.better-together-with-jira.jsm.step2ImageAlt":[{"type":0,"value":"Service request with an option to raise an incident"}],"jsm-sequoia.better-together-with-jira.jsm.step2Title":[{"type":0,"value":"Spot trends and save time"}],"jsm-sequoia.better-together-with-jira.jsm.step3Description":[{"type":0,"value":"Link support requests directly to Jira work items with full context. Keep agents and developers in sync from intake to deployment."}],"jsm-sequoia.better-together-with-jira.jsm.step3ImageAlt":[{"type":0,"value":"Jira board showing linked work items across workflow columns"}],"jsm-sequoia.better-together-with-jira.jsm.step3Title":[{"type":0,"value":"Link requests to backlogs"}],"jsm-sequoia.better-together-with-jira.jsm.subject":[{"type":0,"value":"Deliver better service, with Jira!"}],"jsm-sequoia.better-together-with-jira.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"jsm-sequoia.edition-benefits-modal.screen-space-flags.description.no-translate":[{"type":0,"value":"Add your payment details by "},{"type":1,"value":"date"},{"type":0,"value":" to continue using "},{"type":1,"value":"edition"},{"type":0,"value":". "},{"type":1,"value":"plansLink"}],"jsm-sequoia.edition-benefits-modal.screen-space-flags.title.no-translate":[{"type":0,"value":"Explore your trial"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.heading":[{"type":0,"value":"Consumption-based pricing starts with your next renewal"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.intro":[{"type":0,"value":"We\u2019re letting you know that Assets and Virtual service agent will move to consumption-based pricing at your next renewal on "},{"type":1,"value":"cbpEffectiveDate"},{"type":0,"value":". Additional charges will only apply if your usage exceeds the included limit. Check your current usage and learn more below."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.body.need-to-know":[{"type":0,"value":"Helpful things to know:"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.comment.alt-text":[{"type":0,"value":"comment"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.lightbulb.alt-text":[{"type":0,"value":"lightbulb"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.optimize-schema":[{"children":[{"type":0,"value":"Contact support"}],"type":8,"value":"a"},{"type":0,"value":" if you have any questions"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.list.usage-limit":[{"type":0,"value":"Consider "},{"children":[{"type":0,"value":"optimizing the structure of your schemas"}],"type":8,"value":"a"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.more-details-button":[{"type":0,"value":"More details"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.subject":[{"type":0,"value":"[Reminder] Upcoming pricing changes to Assets and Virtual Service Agent"}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.support.annual.feature-usage-limits-guide":[{"type":0,"value":"For more information, read more about "},{"children":[{"type":0,"value":"how feature usage limits work"}],"type":8,"value":"a"},{"type":0,"value":"."}],"jsm-sequoia.jsm-cbp-concession-notifications.message-template.email.view-and-manage-usage-button":[{"type":0,"value":"View and manage usage"}],"jsm-sequoia.jsm-edition-awareness-button-popup.screen-space-flags.description.no-translate":[{"type":0,"value":"You won\'t be charged until your next billing date on "},{"children":[{"type":1,"value":"nextBillingDate"}],"type":8,"value":"strong"},{"type":0,"value":". "},{"children":[{"type":0,"value":"See plans"}],"type":8,"value":"a"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"cancel anytime"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jsm-sequoia.jsm-edition-awareness-button-popup.screen-space-flags.title.no-translate":[{"type":0,"value":"You\'ve been upgraded to a "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" day"}]},"other":{"value":[{"type":7},{"type":0,"value":" days"}]}},"pluralType":"cardinal","type":6,"value":"trialDaysLeft"},{"type":0,"value":" free trial of our "},{"type":1,"value":"edition"},{"type":0,"value":" plan"}],"jsm-sequoia.jsm-edition-awareness-premium-upsell-modal.screen-space-flags.description":[{"type":0,"value":"Discover Premium capabilities from the Edition Awareness upgrade button."}],"jsm-sequoia.jsm-edition-awareness-premium-upsell-modal.screen-space-flags.title":[{"type":0,"value":"Explore Jira Service Management Premium"}],"jsm-sequoia.nearing-storage-limit.body.agent-limit":[{"type":0,"value":"Get "},{"children":[{"type":0,"value":"unlimited agents"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"250 GB file storage"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.body.ai-written-support":[{"type":0,"value":"Power your Rovo agent with "},{"children":[{"type":0,"value":"AI written support articles"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.body.assets":[{"type":0,"value":"Track business "},{"children":[{"type":0,"value":"assets"}],"type":8,"value":"b"},{"type":0,"value":" and link them to work items"}],"jsm-sequoia.nearing-storage-limit.body.disclaimer":[{"type":0,"value":"We will automatically upgrade you to a "},{"children":[{"type":0,"value":"14-day free trial"}],"type":8,"value":"b"},{"type":0,"value":" of our "},{"children":[{"type":0,"value":"Standard plan"}],"type":8,"value":"b"},{"type":0,"value":". You can "},{"children":[{"type":0,"value":"switch back to the Free plan"}],"type":8,"value":"b"},{"type":0,"value":" anytime by reducing your limits."}],"jsm-sequoia.nearing-storage-limit.body.rovo-ai-agents":[{"type":0,"value":"Resolve requests and incidents faster with "},{"children":[{"type":0,"value":"Rovo AI agents"}],"type":8,"value":"b"}],"jsm-sequoia.nearing-storage-limit.button.try-standard":[{"type":0,"value":"Try Standard for free"}],"jsm-sequoia.nearing-storage-limit.caption.body":[{"type":0,"value":"You\'ve used at least 1.8 GB of the 2 GB storage available on the Free plan. Once you reach 2 GB, you\'ll be upgraded to the 14-day free trial of our Standard plan."}],"jsm-sequoia.nearing-storage-limit.caption.disclaimer":[{"type":0,"value":"What happens once storage is full?"}],"jsm-sequoia.nearing-storage-limit.caption.heading":[{"type":0,"value":"You\'re almost out of storage"}],"jsm-sequoia.nearing-storage-limit.email-header-alt":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.nearing-storage-limit.email-header-subtitle":[{"type":0,"value":"Includes:"}],"jsm-sequoia.nearing-storage-limit.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.nearing-storage-limit.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.nearing-storage-limit.footer.dot-separator":[{"type":0,"value":"\u2022"}],"jsm-sequoia.nearing-storage-limit.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"jsm-sequoia.nearing-storage-limit.footer.facebook-title":[{"type":0,"value":"Facebook"}],"jsm-sequoia.nearing-storage-limit.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"jsm-sequoia.nearing-storage-limit.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"jsm-sequoia.nearing-storage-limit.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"jsm-sequoia.nearing-storage-limit.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"jsm-sequoia.nearing-storage-limit.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.nearing-storage-limit.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"jsm-sequoia.nearing-storage-limit.footer.unsubscribe":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"jsm-sequoia.nearing-storage-limit.footer.x-alt-text":[{"type":0,"value":"X"}],"jsm-sequoia.nearing-storage-limit.footer.x-title":[{"type":0,"value":"X"}],"jsm-sequoia.nearing-storage-limit.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"jsm-sequoia.nearing-storage-limit.footer.youtube-title":[{"type":0,"value":"Youtube"}],"jsm-sequoia.nearing-storage-limit.link.explore-plans":[{"type":0,"value":"Explore all plans"}],"jsm-sequoia.service-collection-nearing-storage-limit-awareness.email.subject":[{"type":0,"value":"You are about to reach your limit"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.avatar.alt_text.user_avatar":[{"type":0,"value":"User Avatar"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.connection":[{"type":0,"value":"Connection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.csm":[{"type":0,"value":"Customer Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.id-badge":[{"type":0,"value":"ID Badge"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.jsm":[{"type":0,"value":"Jira Service Management"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.alt_text.service-collection":[{"type":0,"value":"Service Collection"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.description":[{"type":0,"value":"Deliver better customer support and quickly turn feedback into product improvements."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.csm.title":[{"type":0,"value":"Delight external customers with purpose-built features"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.description":[{"type":0,"value":"Make internal support easier by enabling HR, IT, and other teams to resolve employee requests quickly."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.body.jsm.title":[{"type":0,"value":"Unite teams to deliver exceptional service experiences"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.alt_text.atlassian":[{"type":0,"value":"Atlassian"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.contact_us":[{"type":0,"value":"Contact us"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.privacy_policy":[{"type":0,"value":"Privacy Policy"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.read_our_blog":[{"type":0,"value":"Blog"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.footer.twitter.no-translate":[{"type":0,"value":"Twitter"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.greeting":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":","}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.header.message":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" has requested a trial of Service Collection."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card":[{"type":1,"value":"requestingUserName"},{"type":0,"value":" requested your organization try Service Collection, Atlassian\u2019s solution for AI service management at high velocity."}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.cta":[{"type":0,"value":"Try Service Collection for free"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.request-card.review-request-cta":[{"type":0,"value":"Review request"}],"jsm-sequoia.xflow-request-access-from-admin-jsm-service-collection.message-template.email.subject":[{"type":0,"value":"Hey "},{"type":1,"value":"adminName"},{"type":0,"value":", "},{"type":1,"value":"requestingUserName"},{"type":0,"value":" wants you to start a Service Collection trial"}],"jsm-servco-uplift-notification.message.button.servco.uplift":[{"type":0,"value":"Try it now"}],"jsm-servco-uplift-notification.message.link.learn.more.servco.uplift":[{"type":0,"value":"What\'s Service Collection"}],"jsm-servco-uplift-notification.message.text.servco.uplift":[{"type":0,"value":"Deliver great service experiences fast with a template designed to help your external customers."}],"jsm-servco-uplift-notification.message.title.servco.uplift":[{"type":0,"value":"Try Customer Service Management today with Service Collection"}],"post-office.ad-controls-sequoia.custom-dropdown-item.1.no-translate":[{"type":0,"value":"the first custom dropdown item"}],"post-office.ad-controls-sequoia.custom-dropdown-item.2.no-translate":[{"type":0,"value":"the second custom dropdown item"}],"post-office.ad-controls-sequoia.custom-reason.existing-products.no-translate":[{"type":0,"value":"the second reason for displaying the message to the customer"}],"post-office.ad-controls-sequoia.custom-reason.team-size.no-translate":[{"type":0,"value":"the first reason for displaying the message to the customer"}],"post-office.ad-controls-sequoia.default-reason.existing-products":[{"type":0,"value":"your existing Atlassian products"}],"post-office.ad-controls-sequoia.default-reason.team-size":[{"type":0,"value":"the size of your team"}],"post-office.ad-controls-sequoia.dismiss-flag.not-interested.subtitle":[{"type":0,"value":"You won\u2019t see this here as often."}],"post-office.ad-controls-sequoia.dismiss-flag.not-interested.title":[{"type":0,"value":"Got it, thanks for letting us know"}],"post-office.ad-controls-sequoia.dropdown-item.not-interested.label":[{"type":0,"value":"Not interested"}],"post-office.ad-controls-sequoia.dropdown-item.remind-me-later.label":[{"type":0,"value":"Remind me later"}],"post-office.ad-controls-sequoia.dropdown-item.why-am-i-seeing-this.label":[{"type":0,"value":"Why am I seeing this?"}],"post-office.ad-controls-sequoia.dropdown-menu-trigger.aria-label":[{"type":1,"value":"messageInstanceId"},{"type":0,"value":" options menu"}],"post-office.ad-controls-sequoia.dropdown-menu-trigger.tooltip":[{"type":0,"value":"More actions"}],"post-office.ad-controls-sequoia.reasons-modal.accept-button.label-ok":[{"type":0,"value":"OK"}],"post-office.ad-controls-sequoia.reasons-modal.body":[{"type":0,"value":"We think you\'d find this relevant. This is based on:"}],"post-office.ad-controls-sequoia.reasons-modal.privacy-policy-link.text":[{"type":0,"value":"Learn more about your data privacy with Atlassian"}],"post-office.ad-controls-sequoia.reasons-modal.title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-dashboard-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-dashboard-item.menu-item-label":[{"type":0,"value":"Dashboards"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-dashboard-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-data-manager-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-data-manager-item.menu-item-label":[{"type":0,"value":"Data Manager"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-data-manager-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-assets-premium-trial-item.lozenge-try":[{"type":0,"value":"Try"}],"post-office.jsm-assets-premium-trial-item.menu-item-label":[{"type":0,"value":"Assets"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-one":[{"type":0,"value":"your current product usage"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-bullet-two":[{"type":0,"value":"features available in premium"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-explanation":[{"type":0,"value":"We think this premium feature will help you get more out of Assets. The recommendation is based on:"}],"post-office.jsm-assets-premium-trial-item.reasons-modal-title":[{"type":0,"value":"Why am I seeing this?"}],"post-office.jsm-issue-view-details-section.description":[{"type":0,"value":"Update incidents from within Slack and summarize key events with AI."}],"post-office.jsm-issue-view-details-section.dismiss-button-one":[{"type":0,"value":"I don\'t use Slack"}],"post-office.jsm-issue-view-details-section.reasons-modal-bullet-one":[{"type":0,"value":"your usage of Jira Service Management\'s Alerts and Incidents features"}],"post-office.jsm-issue-view-details-section.reasons-modal-explanation":[{"type":0,"value":"We think Service Collection Premium will improve your team\'s workflow. The recommendation is based on:"}],"post-office.jsm-issue-view-details-section.title":[{"type":0,"value":"Resolve incidents on Slack with AI"}],"servco-recent-purchase-in-product-recruitment.message.description":[{"type":0,"value":"Discover the best features and configure it to your team\'s needs."},{"type":1,"value":"br"},{"type":0,"value":"Book a free 45 minute session with an Atlassian expert."}],"servco-recent-purchase-in-product-recruitment.message.link.book.now":[{"type":0,"value":"Book now"}],"servco-recent-purchase-in-product-recruitment.message.title":[{"type":0,"value":"Get expert help setting up Service Collection"}],"servco-recent-purchase-in-product-recruitment.modal.reason.recent-purchase":[{"type":0,"value":"Your recent purchase of Service Collection"}],"servco-recent-purchase-in-product-recruitment.modal.reason.user-count":[{"type":0,"value":"The number of users in Service Collection"}],"servco-recent-purchase-in-product-recruitment.modal.why-am-i-seeing-this.based-on":[{"type":0,"value":"This recommendation is based on:"}],"servco-recent-purchase-in-product-recruitment.modal.why-am-i-seeing-this.intro":[{"type":0,"value":"Your organization recently purchased Service Collection. We believe that speaking with an Atlassian expert will help you get the most out of it."}]}');

});

parcelRegister("eJARV", function(module, exports) {

let $aba1de03573cbb12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aba1de03573cbb12$var$load("7Xrtc").then(()=>parcelRequire('6ebnt'));

});

parcelRegister("c8HEb", function(module, exports) {

let $8d6816d24a4d3e76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d6816d24a4d3e76$var$load("ahusQ").then(()=>parcelRequire('2ldfU'));

});

parcelRegister("3S5og", function(module, exports) {

let $2d1a98ad645d5c85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d1a98ad645d5c85$var$load("g5bp4").then(()=>parcelRequire('bnTBa'));

});

parcelRegister("1DOsy", function(module, exports) {

let $132093341d5e5807$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $132093341d5e5807$var$load("au4aS").then(()=>parcelRequire('9zDo7'));

});

parcelRegister("5A0e0", function(module, exports) {

let $41007d36edcb09c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41007d36edcb09c4$var$load("agOhm").then(()=>parcelRequire('j6kOd'));

});

parcelRegister("1BlH8", function(module, exports) {

let $12aa13488a3fc403$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12aa13488a3fc403$var$load("3bFVa").then(()=>parcelRequire('b78Nn'));

});

parcelRegister("eIS6p", function(module, exports) {

let $ab7f245b635c82a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab7f245b635c82a2$var$load("hwMc4").then(()=>parcelRequire('1hpcT'));

});

parcelRegister("937y2", function(module, exports) {

let $696a3fbeedd01cf6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $696a3fbeedd01cf6$var$load("6d0N2").then(()=>parcelRequire('5mJ8W'));

});

parcelRegister("cn7N4", function(module, exports) {

let $901dad0fbb9e2438$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $901dad0fbb9e2438$var$load("kNMVE").then(()=>parcelRequire('8moab'));

});

parcelRegister("7RVtq", function(module, exports) {

let $5baa10b66e63705a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5baa10b66e63705a$var$load("25quG").then(()=>parcelRequire('hyY0a'));

});

parcelRegister("2C8PW", function(module, exports) {

let $1e75fc2b0262b3f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e75fc2b0262b3f1$var$load("3gPE9").then(()=>parcelRequire('1L0Io'));

});

parcelRegister("2grYS", function(module, exports) {

let $1a62c7cf1692f5b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1a62c7cf1692f5b9$var$load("1v8Pq").then(()=>parcelRequire('kCLLG'));

});

parcelRegister("hPl05", function(module, exports) {

let $cfa77d566f242c8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfa77d566f242c8b$var$load("k7rQv").then(()=>parcelRequire('gyHBB'));

});

parcelRegister("2VzBa", function(module, exports) {

let $221c84c04c42f209$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $221c84c04c42f209$var$load("gBmHm").then(()=>parcelRequire('gDdZS'));

});

parcelRegister("1BrDj", function(module, exports) {

let $12aeae807d8c652a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12aeae807d8c652a$var$load("5HAQI").then(()=>parcelRequire('HQzTB'));

});

parcelRegister("11EUE", function(module, exports) {

let $0bf59ed9d7c05b2b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf59ed9d7c05b2b$var$load("iiDzS").then(()=>parcelRequire('37HNP'));

});

parcelRegister("aMBi9", function(module, exports) {

let $7d9b5074c804cfea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d9b5074c804cfea$var$load("bT5Gj").then(()=>parcelRequire('iNjlU'));

});

parcelRegister("27hut", function(module, exports) {

let $18a9cd7d2d64929f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18a9cd7d2d64929f$var$load("ess1I").then(()=>parcelRequire('bMOBC'));

});

parcelRegister("6OsG3", function(module, exports) {

let $4f5da85177c547bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f5da85177c547bc$var$load("jk0Ep").then(()=>parcelRequire('ltaMB'));

});

parcelRegister("33ogS", function(module, exports) {

let $23947aabeec3c892$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23947aabeec3c892$var$load("lpM0o").then(()=>parcelRequire('iwHFa'));

});

parcelRegister("cDzdi", function(module, exports) {

let $933471373dddce5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $933471373dddce5a$var$load("4YU10").then(()=>parcelRequire('hSHUk'));

});

parcelRegister("hTXg4", function(module, exports) {

let $035cfe1969b633fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $035cfe1969b633fa$var$load("g3MV3").then(()=>parcelRequire('1FbNA'));

});

parcelRegister("4yGSl", function(module, exports) {

let $351b9894bf970fb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $351b9894bf970fb3$var$load("3evQb").then(()=>parcelRequire('9HKtk'));

});

parcelRegister("67VKj", function(module, exports) {

let $476030b004d75b75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $476030b004d75b75$var$load("jjPSy").then(()=>parcelRequire('dqffR'));

});

parcelRegister("7CdPL", function(module, exports) {

let $58b6d02634d21b09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58b6d02634d21b09$var$load("4ohDn").then(()=>parcelRequire('gBupx'));

});

parcelRegister("9fzK8", function(module, exports) {

let $6bc13d9ef43363a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bc13d9ef43363a1$var$load("etgmr").then(()=>parcelRequire('jehk3'));

});

parcelRegister("9BrJT", function(module, exports) {

let $6fdd162d31112ae6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fdd162d31112ae6$var$load("fmHid").then(()=>parcelRequire('015AX'));

});

parcelRegister("1tMpf", function(module, exports) {

let $113e0c5ca331751c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $113e0c5ca331751c$var$load("24Vlz").then(()=>parcelRequire('4qZXY'));

});

parcelRegister("5toJp", function(module, exports) {

let $3fc2d85848bb1049$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3fc2d85848bb1049$var$load("aws4y").then(()=>parcelRequire('FX4ay'));

});

parcelRegister("9bd4K", function(module, exports) {

let $6aef48a8610e0f7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aef48a8610e0f7f$var$load("leByQ").then(()=>parcelRequire('4P3Pm'));

});

parcelRegister("9VH07", function(module, exports) {

let $73aacb031061907d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73aacb031061907d$var$load("jBxUm").then(()=>parcelRequire('jg4Tr'));

});

parcelRegister("kPern", function(module, exports) {

let $f293c5a744e50124$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f293c5a744e50124$var$load("g1bcx").then(()=>parcelRequire('kSafG'));

});

parcelRegister("eCFB3", function(module, exports) {

let $aa54e18cc7672700$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa54e18cc7672700$var$load("1p9cy").then(()=>parcelRequire('5H3Kj'));

});

parcelRegister("9Joxq", function(module, exports) {

let $715b59cbcd4b81f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $715b59cbcd4b81f1$var$load("ejtUr").then(()=>parcelRequire('i3qzx'));

});

parcelRegister("fnjwM", function(module, exports) {
module.exports = JSON.parse('{"app.accept":[{"type":0,"value":"Accept"}],"app.reject":[{"type":0,"value":"Reject"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"ecosystem-forge-apps.ecosystem-forge-apps-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"ecosystem-forge-apps.ecosystem-forge-apps-in-app.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"jira.jira-project-pages-gdrive-deprecation.message-template.email.subject":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-1":[{"type":0,"value":"We\'re reaching out to notify you that from April 23rd 2024, syncing Google Drive shared drives will no longer be supported in Project Pages for the users in your site. Users will no longer be able to access their shared drives Jira as we are removing the feature, but they will still be able to sync Confluence spaces to Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-2":[{"type":0,"value":"Please note that we are not deleting any data within Google Drive itself. The change only affects the ability to sync, link, and access Google Shared Drives from Jira."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-3":[{"type":0,"value":"This is part of our ongoing efforts to streamline our services and ensure the highest quality experience for our users."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-4":[{"type":0,"value":"Next steps:"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body-5":[{"type":0,"value":"We are committed to providing you with the best possible experience, and appreciate your understanding as we make these necessary improvements. Thank you for your continued support."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-1":[{"type":0,"value":"No immediate action is required from your end regarding this deprecation. However, we understand that this change may impact your workflow, and we are here to support you through this transition."}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.body.list-3":[{"type":0,"value":"For any feedback, or further questions and assistance with change management, please contact jnguyen2@atlassian.com"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.greeting":[{"type":0,"value":"Dear Admin,"}],"jira.jira-project-pages-gdrive-deprecation.test-message.email.title":[{"type":0,"value":"Google Drive will no longer be supported in Jira Project Pages"}],"jira.jira-weekly-digest.message-template.email.subject":[{"type":0,"value":"Your weekly digest for Jira project: "},{"type":1,"value":"projectName"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCompletion":[{"type":0,"value":"issues completed in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesCreated":[{"type":0,"value":"issues created in the past week"}],"jira.jira-weekly-digest.test-message.email.body.lastSevenDaysIssuesUpdated":[{"type":0,"value":"issues updated in the past week"}],"jira.jira-weekly-digest.test-message.email.body.plusSign":[{"type":0,"value":"+"}],"jira.jira-weekly-digest.test-message.email.header":[{"type":0,"value":"Here\'s your weekly digest for Jira ("},{"type":1,"value":"projectName"},{"type":0,"value":") over the past week"}],"jira.jira-weekly-digest.test-message.email.headerDescription":[{"type":0,"value":"You\u2019re receiving this email because you have opted in to receive weekly updates for this project in Jira."}],"jira.jira-weekly-digest.test-message.email.playbookBodyText":[{"type":0,"value":"Atlassian Playbook"}],"jira.jira-weekly-digest.test-message.email.playbookHeader":[{"type":0,"value":"Has your team conducted a retrospective recently?"}],"jira.jira-weekly-digest.test-message.email.playbookSubheader":[{"type":0,"value":"A retrospective gives you an opportunity to review your latest project progress and make improvements for the future. Find out more at "},{"type":1,"value":"link"},{"type":0,"value":"."}],"jira.jira-weekly-digest.test-message.email.tableHeader":[{"type":0,"value":"Weekly Summary"}],"jira.suppression-email-notification-email.contact-us":[{"type":0,"value":"contact us"}],"jira.suppression-email-notification-email.email.body":[{"type":0,"value":"This is an automatated message to notify you that the jira "},{"type":1,"value":"emailType"},{"type":0,"value":" email \\n\\t\\t\\t\\t\\t\\tto "},{"type":1,"value":"affectedUserEmail"},{"type":0,"value":" has been suppressed. Please visit this "},{"type":1,"value":"unsuppressApiLink"},{"type":0,"value":" to unsuppress the user\'s email."}],"jira.suppression-email-notification-email.email.body.goodbye":[{"type":0,"value":"Please "},{"type":1,"value":"contactUsLink"},{"type":0,"value":" if the issue persists, we\'re always happy to help."}],"jira.suppression-email-notification-email.email.body.regards":[{"type":0,"value":"Jira Notifications Team"}],"jira.suppression-email-notification-email.email.body.signoff":[{"type":0,"value":"Regards,"}],"jira.suppression-email-notification-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"jira.suppression-email-notification-email.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira.suppression-email-notification-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"playground.end-of-trial-extension.description.no-translate":[{"type":0,"value":"End of trial extension test message."}],"playground.end-of-trial-extension.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"playground.playground-local-execution-message.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.playground-local-execution-message.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.playground-local-execution-message.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hello, fellow child "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.playground-local-execution-message.test-message.email.body.no-translate":[{"type":0,"value":"We are currently trying to locally execute this message!"}],"playground.playground-local-execution-message.test-message.email.body.regards.no-translate":[{"type":0,"value":"Playground Team"}],"playground.playground-local-execution-message.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.playground-local-execution-message.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"playground.post-office-auto-merge-config.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"playground.post-office-auto-merge-config.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"playground.post-office-auto-merge-config.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"playground.post-office-auto-merge-config.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"playground.post-office-auto-merge-config.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"playground.post-office-auto-merge-config.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"playground.post-office-auto-merge-config.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"post-office.commerce-common.unsuppress-email-link":[{"type":0,"value":"link"}],"post-office.jira-email.contact-us":[{"type":0,"value":"contact us"}],"post-office.playground.go-faster-techops-rollup-notifier.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.playground.test-playground-message.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"sharc.sharc-tenant-migration-brazil-unpinned.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"sharc.sharc-tenant-migration-brazil-unpinned.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}]}');

});

parcelRegister("alZ6t", function(module, exports) {

let $789b436fb3f5f156$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $789b436fb3f5f156$var$load("czp36").then(()=>parcelRequire('k8Mou'));

});

parcelRegister("jjI9T", function(module, exports) {

let $e1020ba74cbc8ee1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1020ba74cbc8ee1$var$load("kMAXW").then(()=>parcelRequire('6r2F4'));

});

parcelRegister("4CGwT", function(module, exports) {

let $35dbb3893c50b21a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35dbb3893c50b21a$var$load("3GkDf").then(()=>parcelRequire('dHGfx'));

});

parcelRegister("hLcE3", function(module, exports) {

let $cee0a27c61e54e96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cee0a27c61e54e96$var$load("jC9Rs").then(()=>parcelRequire('efoXP'));

});

parcelRegister("b968C", function(module, exports) {

let $81d54bd671fa97c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81d54bd671fa97c3$var$load("8ynxX").then(()=>parcelRequire('4KpqX'));

});

parcelRegister("7AD3N", function(module, exports) {

let $586a31c42d8bc602$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $586a31c42d8bc602$var$load("3gJkM").then(()=>parcelRequire('1Ezgp'));

});

parcelRegister("lQ73y", function(module, exports) {

let $fe63ed8bfdf96417$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe63ed8bfdf96417$var$load("eqo8j").then(()=>parcelRequire('hlIKn'));

});

parcelRegister("jdijK", function(module, exports) {

let $dfcd70b5a6cc271b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfcd70b5a6cc271b$var$load("7I7e4").then(()=>parcelRequire('7yWuG'));

});

parcelRegister("c4QmP", function(module, exports) {

let $8cae7accf1d20a4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cae7accf1d20a4e$var$load("csrLl").then(()=>parcelRequire('h7eL8'));

});

parcelRegister("aJgCR", function(module, exports) {

let $7cfb00e6570526e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7cfb00e6570526e7$var$load("j5Lsa").then(()=>parcelRequire('7c7pH'));

});

parcelRegister("1B4TH", function(module, exports) {

let $129d0ba9b187676c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $129d0ba9b187676c$var$load("4sHgh").then(()=>parcelRequire('l3tuo'));

});

parcelRegister("hRqHT", function(module, exports) {

let $d00c1a53624d436e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00c1a53624d436e$var$load("4s68a").then(()=>parcelRequire('4xyaY'));

});

parcelRegister("jyUGx", function(module, exports) {

let $e3dd29c482d56786$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3dd29c482d56786$var$load("eMKcg").then(()=>parcelRequire('5nOGu'));

});

parcelRegister("bi7ue", function(module, exports) {

let $83872ed08a722622$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83872ed08a722622$var$load("9Lid4").then(()=>parcelRequire('edb6M'));

});

parcelRegister("63Oos", function(module, exports) {

let $469a1cfebf766da6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $469a1cfebf766da6$var$load("4H2JR").then(()=>parcelRequire('jh47D'));

});

parcelRegister("cPVbs", function(module, exports) {

let $95869af6b68aac18$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95869af6b68aac18$var$load("4BUAw").then(()=>parcelRequire('8AkjG'));

});

parcelRegister("lUbkO", function(module, exports) {

let $ff279ec3568edb1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff279ec3568edb1b$var$load("26vCJ").then(()=>parcelRequire('7qViT'));

});

parcelRegister("fojmp", function(module, exports) {

let $b3481d8196fa095d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b3481d8196fa095d$var$load("248fi").then(()=>parcelRequire('9xGa0'));

});

parcelRegister("1Im5h", function(module, exports) {

let $13fb07fa61eede04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13fb07fa61eede04$var$load("1eaJh").then(()=>parcelRequire('3d0aC'));

});

parcelRegister("b7PuI", function(module, exports) {

let $81984ae2677b3d9d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81984ae2677b3d9d$var$load("cb2qH").then(()=>parcelRequire('jB01E'));

});

parcelRegister("awCZh", function(module, exports) {

let $7a9b229aabae0deb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a9b229aabae0deb$var$load("cXZBf").then(()=>parcelRequire('3MFgx'));

});

parcelRegister("fX5Gv", function(module, exports) {

let $b9d0c68d1b3a511a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9d0c68d1b3a511a$var$load("g9KgO").then(()=>parcelRequire('7MsWl'));

});

parcelRegister("5vsDw", function(module, exports) {

let $40260f9974bc93a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40260f9974bc93a6$var$load("kFGbg").then(()=>parcelRequire('6powa'));

});

parcelRegister("jRjmb", function(module, exports) {

let $e751fb6a029280b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e751fb6a029280b3$var$load("cCVdk").then(()=>parcelRequire('hnl91'));

});

parcelRegister("bzsYJ", function(module, exports) {

let $86c9711d1992ad7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86c9711d1992ad7a$var$load("iDM0X").then(()=>parcelRequire('gDmPq'));

});

parcelRegister("jP49l", function(module, exports) {

let $e6e5ffc676417e45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6e5ffc676417e45$var$load("fDyFp").then(()=>parcelRequire('4P8Ug'));

});

parcelRegister("7wWJW", function(module, exports) {

let $57b91614a6605f3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57b91614a6605f3b$var$load("ciiT8").then(()=>parcelRequire('h4rNI'));

});

parcelRegister("2n8d7", function(module, exports) {

let $1ba4193510f30e75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ba4193510f30e75$var$load("oK6sK").then(()=>parcelRequire('dzbrU'));

});

parcelRegister("lmH7k", function(module, exports) {

let $f8dd19334bb1322e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8dd19334bb1322e$var$load("gQVui").then(()=>parcelRequire('1zeU2'));

});

parcelRegister("6ua4X", function(module, exports) {

let $4b8d5ce559d4ca77$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b8d5ce559d4ca77$var$load("hD494").then(()=>parcelRequire('9LT4x'));

});

parcelRegister("iFzjG", function(module, exports) {

let $d977737589411039$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d977737589411039$var$load("e6T9M").then(()=>parcelRequire('4VR5g'));

});

parcelRegister("3WTZO", function(module, exports) {

let $2e02397e7b5f75f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e02397e7b5f75f6$var$load("7OyVM").then(()=>parcelRequire('kLdrv'));

});

parcelRegister("fXzfL", function(module, exports) {

let $b9e7b63e553a0daf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9e7b63e553a0daf$var$load("7xkIQ").then(()=>parcelRequire('7ctPc'));

});

parcelRegister("haLUf", function(module, exports) {

let $c8088808ee52962b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c8088808ee52962b$var$load("7hBz4").then(()=>parcelRequire('k3BXj'));

});

parcelRegister("kDvBY", function(module, exports) {
module.exports = JSON.parse('{"INAPP-1736.spotlight.body":[{"type":0,"value":"We\'ve got the basic settings for your integration covered. Customize them to make sure you get the most out of the integration."}],"INAPP-1736.spotlight.primary":[{"type":0,"value":"OK"}],"INAPP-1736.spotlight.secondary":[{"type":0,"value":"Dismiss"}],"INAPP-1736.spotlight.title":[{"type":0,"value":"Set up your integration"}],"INAPP-1737.spotlight.body":[{"type":0,"value":"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed"}],"INAPP-1737.spotlight.primary":[{"type":0,"value":"Learn more"}],"INAPP-1737.spotlight.secondary":[{"type":0,"value":"OK"}],"INAPP-1737.spotlight.title":[{"type":0,"value":"Create rich and informative alerts"}],"alert.status.acked":[{"type":0,"value":"Acknowledged"}],"alert.status.closed":[{"type":0,"value":"Closed"}],"alert.status.open":[{"type":0,"value":"Open"}],"alert.status.snoozed":[{"type":0,"value":"Snoozed"}],"alexstrasza.assess-risk-button-spotlight.description":[{"type":0,"value":"Evaluate the potential impact of this change before approving or scheduling."}],"alexstrasza.assess-risk-button-spotlight.heading":[{"type":0,"value":"Assess risk with Rovo Ops"}],"alexstrasza.assess-risk-button-spotlight.try-it-now":[{"type":0,"value":"Try it now"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Note added"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View alert in OpsGenie"}],"alexstrasza.jsm-operations-add-note-to-alert.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Note added to alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-acked.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert acknowledged: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-assigned.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert assigned: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-closed.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" Alert closed: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-alert-export.message-template.email.subject.no-translate":[{"type":0,"value":"Export Alert Result"}],"alexstrasza.jsm-operations-alert-export.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":"!"}],"alexstrasza.jsm-operations-alert-export.test-message.email.body.no-translate":[{"type":0,"value":"We\u2019ve exported your alerts and now you can download the zip file here:"}],"alexstrasza.jsm-operations-alert-export.test-message.email.continue-export-label.no-translate":[{"type":0,"value":"The results contain the latest 10k alerts. To continue exporting, you can click the link below:"}],"alexstrasza.jsm-operations-alert-export.test-message.email.expiry.no-translate":[{"type":0,"value":"Please note that the export link will expire in 14 days."}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.assignee-label.no-translate":[{"type":0,"value":"Assignee"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.created-at.no-translate":[{"type":0,"value":"Created "},{"type":1,"value":"createdAt"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.id-label.no-translate":[{"type":0,"value":"ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.integration-label.no-translate":[{"type":0,"value":"Integration"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.responder-label.no-translate":[{"type":0,"value":"Responder"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.source-label.no-translate":[{"type":0,"value":"Source"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.status-label.no-translate":[{"type":0,"value":"Status"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tags-label.no-translate":[{"type":0,"value":"Tags"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.tiny-id-label.no-translate":[{"type":0,"value":"Tiny ID"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-button.no-translate":[{"type":0,"value":"View Alert"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-compass-button.no-translate":[{"type":0,"value":"View Alert in Compass"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-alert-jsm-button.no-translate":[{"type":0,"value":"View Alert in Jira Service Management"}],"alexstrasza.jsm-operations-alert-new.message-template.email.body.view-og-alert-button.no-translate":[{"type":0,"value":"View in OpsGenie"}],"alexstrasza.jsm-operations-alert-new.message-template.email.subject.no-translate":[{"type":1,"value":"product"},{"type":0,"value":" New alert: ("},{"type":1,"value":"priority"},{"type":0,"value":") "},{"type":1,"value":"message"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-button.no-translate":[{"type":0,"value":"Download "},{"type":1,"value":"exportType"},{"type":0,"value":" log"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.download-icon.alt.no-translate":[{"type":0,"value":"Download icon"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-category.no-translate":[{"type":0,"value":"Category: "},{"type":1,"value":"filterCategories"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-label.no-translate":[{"type":0,"value":"Export Criteria:"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-log-level.no-translate":[{"type":0,"value":"Log level: "},{"type":1,"value":"filterLogLevels"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-search.no-translate":[{"type":0,"value":"Search: "},{"type":1,"value":"searchKeywords"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.export-criteria-time.no-translate":[{"type":0,"value":"Time: "},{"type":1,"value":"from"},{"type":0,"value":" to "},{"type":1,"value":"to"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"userFullName"},{"type":0,"value":","}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.heading.no-translate":[{"type":0,"value":"Download your "},{"type":1,"value":"exportType"},{"type":0,"value":" log"}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.intro-message.no-translate":[{"type":0,"value":"The CSV file for "},{"type":1,"value":"siteName"},{"type":0,"value":"\'s "},{"type":1,"value":"exportType"},{"type":0,"value":" log is ready to download. The download link will expire in 24 hours."}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.body.limit-note.no-translate":[{"type":0,"value":"Up to 100,000 activities can be exported at once, activities over the limit would be skipped in the CSV file."}],"alexstrasza.jsm-operations-audit-log-download.message-template.email.subject.no-translate":[{"type":0,"value":"Your "},{"type":1,"value":"exportType"},{"type":0,"value":" log is ready to download"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.affected-role-label.no-translate":[{"type":0,"value":"Affected member role"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.button-text.no-translate":[{"type":0,"value":"View your alert notifications"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.contact-methods.no-translate":[{"type":0,"value":"contact methods"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-label.no-translate":[{"type":0,"value":"Description"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.description-text.no-translate":[{"type":0,"value":"The role-based notification "},{"type":1,"value":"roleBasedNotificationSettingName"},{"type":0,"value":" will trigger alert notifications based on the conditions set by the admin."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-label.no-translate":[{"type":0,"value":"Note"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.note-text.no-translate":[{"type":0,"value":"Review your "},{"type":1,"value":"contactMethods"},{"type":0,"value":" to confirm that this role-based notification works as expected."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.override-message.no-translate":[{"type":0,"value":"Role-based notifications override your personal notifications."}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.body.title.no-translate":[{"type":0,"value":"Role-based notification turned on"}],"alexstrasza.jsm-operations-role-based-notification-enabled.message-template.email.subject.no-translate":[{"type":0,"value":"Role-based notification turned on"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-ends.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" ends"}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending, at "},{"type":1,"value":"endTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-ends.test-message.email.body.rotation-ending-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is ending now."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.app-store-logo.alt.no-translate":[{"type":0,"value":"Download on the App Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.link-text.no-translate":[{"type":0,"value":"update your notification settings"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.manage-notifications.no-translate":[{"type":0,"value":"To customize the email or unsubscribe, "},{"type":1,"value":"link"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.mobile-app.no-translate":[{"type":0,"value":"Stay notified and comment on the go with Jira Service Management Mobile App"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.play-store-logo.alt.no-translate":[{"type":0,"value":"Download on the Play Store"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.body.team.no-translate":[{"type":0,"value":"Team"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer-logo.alt.no-translate":[{"type":0,"value":"Atlassian"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.privacy-policy.no-translate":[{"type":0,"value":"Privacy Policy"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.footer.text.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management"}],"alexstrasza.jsm-operations-rotation-starts.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"productName"},{"type":0,"value":"] Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" starts"}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-at.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting, at "},{"type":1,"value":"startTime"},{"type":0,"value":"."}],"alexstrasza.jsm-operations-rotation-starts.test-message.email.body.rotation-starting-now.no-translate":[{"type":0,"value":"Your on-call rotation in \\""},{"type":1,"value":"scheduleName"},{"type":0,"value":"\\" is starting now."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.alert-feature-image.alt.no-translate":[{"type":0,"value":"Alert management illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.chat-feature-image.alt.no-translate":[{"type":0,"value":"Chat integration illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.explore-subheading.no-translate":[{"type":0,"value":"Explore how operations can elevate your team\'s response"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-description.no-translate":[{"type":0,"value":"Improve response efficiency and reduce the alert fatigue."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-alert-title.no-translate":[{"type":0,"value":"Manage all alerts in one place"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-description.no-translate":[{"type":0,"value":"Handle alerts and on-call using your chat tools."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-chat-title.no-translate":[{"type":0,"value":"Respond to alerts via chat"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-description.no-translate":[{"type":0,"value":"Connect your IT tools and apps to centralize alerts in one place."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-integration-title.no-translate":[{"type":0,"value":"Integrate with your apps"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-description.no-translate":[{"type":0,"value":"Set on-call schedules easily and never miss a critical alert."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.feature-oncall-title.no-translate":[{"type":0,"value":"Become an on-call team"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.heading.no-translate":[{"children":[{"type":1,"value":"teamName"}],"type":8,"value":"strong"},{"type":0,"value":" has launched its operations and is ready to respond"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.integration-feature-image.alt.no-translate":[{"type":0,"value":"Integration illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.launch-message.no-translate":[{"children":[{"type":1,"value":"actorUserName"}],"type":8,"value":"strong"},{"type":0,"value":" has launched "},{"children":[{"type":1,"value":"teamName"},{"type":0,"value":"\'s"}],"type":8,"value":"strong"},{"type":0,"value":" operations and added you as a member to collaborate."}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.learn-more-link.no-translate":[{"type":0,"value":"Learn more"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.oncall-feature-image.alt.no-translate":[{"type":0,"value":"On-call scheduling illustration"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.start-collaborating-button.no-translate":[{"type":0,"value":"Start collaborating"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.team-image.alt.no-translate":[{"type":0,"value":"Team profile picture"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.body.what-are-operations.no-translate":[{"type":0,"value":"What are operations?"}],"alexstrasza.jsm-operations-team-enablement.message-template.email.subject.no-translate":[{"type":0,"value":"You\'re invited to collaborate on your team\'s operations"}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-allowlist.no-translate":[{"type":0,"value":"Your email server might be rejecting emails from Jira Service Management. Request your email administrator to allowlist jsm-notifications.atlassian.net."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-deactivated.no-translate":[{"type":0,"value":"The email address "},{"type":1,"value":"displayName"},{"type":0,"value":" you had added for alert notifications is deactivated."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.email-reactivate.no-translate":[{"type":0,"value":"If the email address is correct, go to the Alert notifications page in your personal settings and reactivate it."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.greeting.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"fullName"},{"type":0,"value":","}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.mobile-deactivated.no-translate":[{"type":0,"value":"The mobile device "},{"type":1,"value":"displayName"},{"type":0,"value":" added to your contact methods for mobile push notifications is currently deactivated because it\'s invalid or your app instance was unregistered. To continue receiving push notifications, re-install the application and verify the status from the Alert notifications page in your Jira personal settings."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.body.phone-deactivated.no-translate":[{"type":0,"value":"The phone number "},{"type":1,"value":"displayName"},{"type":0,"value":" added to your contact methods for voice/SMS is currently deactivated because it\'s invalid or it\'s blocklisted by your service provider. If the phone number is correct, go to the Alert notifications page in your Jira personal settings and reactivate it."}],"alexstrasza.jsm-operations-user-contact-disabled.message-template.email.subject.no-translate":[{"type":0,"value":"["},{"type":1,"value":"product"},{"type":0,"value":"] Contact method for notifications deactivated"}],"alexstrasza.jsm-ops-enablement-notification-drawer.message-template.notification-drawer.message":[{"type":1,"value":"actorName"},{"type":0,"value":" launched "},{"type":1,"value":"teamName"},{"type":0,"value":"\'s operations"}],"alexstrasza.operations-overview-discoverability-spotlights.high-bug.description":[{"type":0,"value":"Your team\'s been logging a lot of bugs. Set up operations to get ahead of the next one \u2014 with on-call, alerting, and incident response built right in."}],"alexstrasza.operations-overview-discoverability-spotlights.high-bug.tour.step1-description":[{"type":0,"value":"Your team\'s been logging a lot of bugs. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and get ahead of the next one \u2014 with on-call, alerting, and incident response built right in."}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.description":[{"type":0,"value":"It\'s been a while since you started setting up operations. Turn on alerts and on-call schedules to unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.heading":[{"type":0,"value":"You\'re almost there"}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.primary-action":[{"type":0,"value":"Go to Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.inactive-ops.tour.step1-description":[{"type":0,"value":"It\'s been a while since you started setting up operations. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.description":[{"type":0,"value":"You\'re getting notified through third-party integrations today. Instead, set up operations to receive real-time alerts and stay on top of issues as soon as they happen."}],"alexstrasza.operations-overview-discoverability-spotlights.marketplace-ops.tour.step1-description":[{"type":0,"value":"You\'re getting notified through third-party integrations today. Click "},{"children":[{"type":0,"value":"More"}],"type":8,"value":"b"},{"type":0,"value":" to set up operations and unlock its full potential for your team."}],"alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.heading":[{"type":0,"value":"Explore Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.shared.explore-operations.primary-action":[{"type":0,"value":"Explore"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.next-button":[{"type":0,"value":"Next"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.primary-action":[{"type":0,"value":"Go to Operations"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step-count":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step1-heading":[{"type":0,"value":"Complete your Operations setup"}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step2-description":[{"type":0,"value":"Click on "},{"children":[{"type":0,"value":"Operations"}],"type":8,"value":"b"},{"type":0,"value":" to set up alerts and on-call schedules to make sure your team stay on top of issues as soon as they happen."}],"alexstrasza.operations-overview-discoverability-spotlights.tour.step2-heading":[{"type":0,"value":"You\'re almost there"}],"alexstrasza.risk-assessment-spotlight.explore-categories.description":[{"type":0,"value":"Rovo Ops breaks down risk into categories. Select any category to see risk details, contributing factors, and why it was flagged."}],"alexstrasza.risk-assessment-spotlight.explore-categories.heading":[{"type":0,"value":"Explore risk by category"}],"alexstrasza.risk-assessment-spotlight.mitigate-risk.description":[{"type":0,"value":"Get actionable mitigation steps tailored to each risk category, so you can address issues before the change goes live."}],"alexstrasza.risk-assessment-spotlight.mitigate-risk.heading":[{"type":0,"value":"Mitigate risk"}],"alexstrasza.risk-assessment-spotlight.navigation.done":[{"type":0,"value":"Done"}],"alexstrasza.risk-assessment-spotlight.navigation.next":[{"type":0,"value":"Next"}],"alexstrasza.risk-assessment-spotlight.navigation.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"eoc-heartbeats.message-id.spotlight.body":[{"type":0,"value":"Copy heartbeat\u2019s name, edit, duplicate, and manage more heartbeat actions."}],"eoc-heartbeats.message-id.spotlight.dismiss":[{"type":0,"value":"OK"}],"eoc-heartbeats.message-id.spotlight.title":[{"type":0,"value":"Easy access to heartbeat actions"}],"eoc-heartbeats.tour.learn-more.no-translate":[{"type":0,"value":"Learn More"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-body.no-translate":[{"type":1,"value":"description"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-subtitle.no-translate":[{"type":0,"value":"Status: "},{"type":1,"value":"status"},{"type":0,"value":" | Source: "},{"type":1,"value":"source"}],"post-office.alexstrasza.jsm-operations-alert-new.mobile-push-title.no-translate":[{"type":0,"value":"["},{"type":1,"value":"priority"},{"type":0,"value":"] "},{"type":1,"value":"message"}]}');

});

parcelRegister("3qG4F", function(module, exports) {

let $27f46fe301a4f1c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27f46fe301a4f1c6$var$load("9Mfkk").then(()=>parcelRequire('fI9Wr'));

});

parcelRegister("6vgTR", function(module, exports) {

let $4bc2bf4c480bc5ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4bc2bf4c480bc5ee$var$load("9ixoP").then(()=>parcelRequire('loxal'));

});

parcelRegister("5uH1o", function(module, exports) {

let $40012044f76e1eb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40012044f76e1eb9$var$load("6gYLk").then(()=>parcelRequire('kG5PD'));

});

parcelRegister("eycDR", function(module, exports) {

let $a97e0c12e5e6f64e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a97e0c12e5e6f64e$var$load("6a2En").then(()=>parcelRequire('lFRox'));

});

parcelRegister("71unu", function(module, exports) {

let $51d030ce104f439b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51d030ce104f439b$var$load("k41Nz").then(()=>parcelRequire('ePTMY'));

});

parcelRegister("7QImw", function(module, exports) {

let $5b6fcd2da049a344$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b6fcd2da049a344$var$load("cJgVv").then(()=>parcelRequire('je163'));

});

parcelRegister("esvWB", function(module, exports) {

let $a86c75aa9fd55145$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a86c75aa9fd55145$var$load("grpo1").then(()=>parcelRequire('b5TtR'));

});

parcelRegister("wwoSG", function(module, exports) {

let $061c1f4ca48486a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $061c1f4ca48486a5$var$load("kQ5b3").then(()=>parcelRequire('kq8Om'));

});

parcelRegister("d9FaO", function(module, exports) {

let $993c0dc81c416575$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $993c0dc81c416575$var$load("eBgRM").then(()=>parcelRequire('bpq65'));

});

parcelRegister("bcEp6", function(module, exports) {

let $82802814640b153e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82802814640b153e$var$load("4DfKF").then(()=>parcelRequire('dELuh'));

});

parcelRegister("cPisg", function(module, exports) {

let $9568902efee7e113$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9568902efee7e113$var$load("2Fqck").then(()=>parcelRequire('62Oxr'));

});

parcelRegister("gKvel", function(module, exports) {

let $c3192aea34b43c24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c3192aea34b43c24$var$load("6bO1t").then(()=>parcelRequire('2czCF'));

});

parcelRegister("iexSm", function(module, exports) {

let $d463cfd728aad5f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d463cfd728aad5f6$var$load("jahlu").then(()=>parcelRequire('DtmYT'));

});

parcelRegister("3cwM2", function(module, exports) {

let $254bea47965b13b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $254bea47965b13b8$var$load("2LhzZ").then(()=>parcelRequire('gD6Td'));

});

parcelRegister("6rvzd", function(module, exports) {

let $4b0dc042cc6f079a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b0dc042cc6f079a$var$load("fL6dO").then(()=>parcelRequire('en50B'));

});

parcelRegister("2TrDa", function(module, exports) {

let $21b626b849ff4563$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21b626b849ff4563$var$load("bgjqj").then(()=>parcelRequire('8Xml8'));

});

parcelRegister("8bc2h", function(module, exports) {

let $5f48afe2917e28a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f48afe2917e28a4$var$load("k3pVa").then(()=>parcelRequire('3LYhU'));

});

parcelRegister("SJxrG", function(module, exports) {

let $0a485e3f0e2bd51d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a485e3f0e2bd51d$var$load("dtPqn").then(()=>parcelRequire('i0ncI'));

});

parcelRegister("bdFPK", function(module, exports) {

let $82b15bdfbcd1c0b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82b15bdfbcd1c0b2$var$load("5Fibl").then(()=>parcelRequire('gbX36'));

});

parcelRegister("dn4qr", function(module, exports) {

let $9bc0db20fd8d732a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9bc0db20fd8d732a$var$load("c3Lo8").then(()=>parcelRequire('7SHlu'));

});

parcelRegister("4ukYk", function(module, exports) {

let $344a3b657a4f1f68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $344a3b657a4f1f68$var$load("h1z5r").then(()=>parcelRequire('83fYT'));

});

parcelRegister("7qtmD", function(module, exports) {

let $5681bd3a33aaa7dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5681bd3a33aaa7dd$var$load("4l735").then(()=>parcelRequire('km8f3'));

});

parcelRegister("8RiMF", function(module, exports) {

let $6731d80b6233ab33$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6731d80b6233ab33$var$load("6OgGr").then(()=>parcelRequire('fo4h8'));

});

parcelRegister("lWsSi", function(module, exports) {

let $ff9569afbe900d70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff9569afbe900d70$var$load("795yO").then(()=>parcelRequire('jqdPx'));

});

parcelRegister("ftx15", function(module, exports) {

let $02e84f2cdf379c8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $02e84f2cdf379c8d$var$load("36yXL").then(()=>parcelRequire('cIa6C'));

});

parcelRegister("4pFQf", function(module, exports) {

let $3369f41a173f2fd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3369f41a173f2fd0$var$load("6m2IY").then(()=>parcelRequire('9j8gc'));

});

parcelRegister("lq0RK", function(module, exports) {

let $f97cb2a2a43f3cef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f97cb2a2a43f3cef$var$load("i9MSA").then(()=>parcelRequire('gOaOa'));

});

parcelRegister("gdfv9", function(module, exports) {

let $bcd9e285e2e56d29$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bcd9e285e2e56d29$var$load("3XXkw").then(()=>parcelRequire('6BPzb'));

});

parcelRegister("ifomm", function(module, exports) {

let $d48c8607bcaac3f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d48c8607bcaac3f1$var$load("hG9vb").then(()=>parcelRequire('9jlHa'));

});

parcelRegister("d8v7l", function(module, exports) {

let $99042903774c77be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99042903774c77be$var$load("dk61q").then(()=>parcelRequire('atTXx'));

});

parcelRegister("8fuUJ", function(module, exports) {

let $6017b4547a072c86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6017b4547a072c86$var$load("zlHdL").then(()=>parcelRequire('lFe4L'));

});

parcelRegister("8aMn9", function(module, exports) {

let $5f34c7ada698ea56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5f34c7ada698ea56$var$load("iIy5h").then(()=>parcelRequire('59zua'));

});

parcelRegister("8TCeu", function(module, exports) {

let $67a11e01de61ad76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67a11e01de61ad76$var$load("1BGiy").then(()=>parcelRequire('abAFo'));

});

parcelRegister("iV0ke", function(module, exports) {

let $dc5dcd74cdfa8c63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc5dcd74cdfa8c63$var$load("iU68J").then(()=>parcelRequire('99y2W'));

});

parcelRegister("eKgSp", function(module, exports) {
module.exports = JSON.parse("{\"INAPP-2055.spotlight.body\":[{\"type\":0,\"value\":\"Draggable tags help you create well-defined alerts and manage them with ease. All you have to do is drag-and-drop the tags into any alert property field as needed\"}],\"INAPP-2055.spotlight.primary\":[{\"type\":0,\"value\":\"Learn more\"}],\"INAPP-2055.spotlight.secondary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-2055.spotlight.title\":[{\"type\":0,\"value\":\"Create rich and informative alerts\"}],\"INAPP-3273.spotlight.body\":[{\"type\":0,\"value\":\"Triage and resolve alerts faster by using Atlassian Intelligence to access similar alerts.\"}],\"INAPP-3273.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"INAPP-3273.spotlight.title\":[{\"type\":0,\"value\":\"Drive faster alert resolution with Atlassian Intelligence\"}],\"aiops-grogu.rovo-ops-cta-spotlight.body\":[{\"type\":0,\"value\":\"Investigate and compare alerts, and find related resources to resolve faster.\"}],\"aiops-grogu.rovo-ops-cta-spotlight.done\":[{\"type\":0,\"value\":\"Ok\"}],\"aiops-grogu.rovo-ops-cta-spotlight.heading\":[{\"type\":0,\"value\":\"Triage alerts with Rovo Ops\"}],\"jira-ops-group-customisation.spotlight.body\":[{\"type\":0,\"value\":\"Your team's alerts are grouped based on the similarity of alert titles, descriptions, tags and so on within a specific time window. If you want more control, you can fine-tune how alerts are grouped. Only team admins, Ops admins, or Jira admins can change these settings.\"}],\"jira-ops-group-customisation.spotlight.primary\":[{\"type\":0,\"value\":\"OK\"}],\"jira-ops-group-customisation.spotlight.title\":[{\"type\":0,\"value\":\"Configure alert groups\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.body\":[{\"type\":0,\"value\":\"Expand to quickly view all alerts in the group.\"}],\"jira-ops-unified-view-revamp.grouped-alerts.spotlight.title\":[{\"type\":0,\"value\":\"View grouped alerts\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.body\":[{\"type\":0,\"value\":\"Rovo helps you classify your alerts as signal or noise so you can focus on what matters most.\"}],\"jira-ops-unified-view-revamp.snr-header.spotlight.title\":[{\"type\":0,\"value\":\"Triage alerts faster\"}],\"jira-ops-unified-view-revamp.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-ops-unified-view-revamp.spotlight.go-back\":[{\"type\":0,\"value\":\"Go back\"}],\"jira-ops-unified-view-revamp.spotlight.next\":[{\"type\":0,\"value\":\"Next\"}],\"jira-ops-unified-view-revamp.spotlight.ok\":[{\"type\":0,\"value\":\"OK\"}]}");

});

parcelRegister("429nu", function(module, exports) {

let $2efe9f9863f50a21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2efe9f9863f50a21$var$load("3M52M").then(()=>parcelRequire('iHSlK'));

});

parcelRegister("lkJRX", function(module, exports) {

let $f87f0be67a438bd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f87f0be67a438bd0$var$load("hXzW4").then(()=>parcelRequire('jBawD'));

});

parcelRegister("lTmRO", function(module, exports) {

let $ff0078efe4272a3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff0078efe4272a3b$var$load("6H6xO").then(()=>parcelRequire('cChcG'));

});

parcelRegister("kVSfW", function(module, exports) {

let $f3d337a45540f2df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3d337a45540f2df$var$load("dKUKe").then(()=>parcelRequire('fKoq1'));

});

parcelRegister("lga3Q", function(module, exports) {

let $f7a2e5841688e740$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7a2e5841688e740$var$load("3P4OX").then(()=>parcelRequire('4FqPu'));

});

parcelRegister("4lqx1", function(module, exports) {

let $329db4356c1723f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $329db4356c1723f6$var$load("fXZcJ").then(()=>parcelRequire('8R6aY'));

});

parcelRegister("8ESoT", function(module, exports) {

let $64dc41f1b18baa96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $64dc41f1b18baa96$var$load("bfegz").then(()=>parcelRequire('jnv4H'));

});

parcelRegister("gWvPm", function(module, exports) {

let $c55ac06017699058$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c55ac06017699058$var$load("6llrY").then(()=>parcelRequire('3MFZ2'));

});

parcelRegister("9A72q", function(module, exports) {

let $6f9cef7be8961bff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f9cef7be8961bff$var$load("idtF6").then(()=>parcelRequire('61pnU'));

});

parcelRegister("gx1CC", function(module, exports) {

let $c090fc7ffb3b343c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c090fc7ffb3b343c$var$load("uBxej").then(()=>parcelRequire('aHRnk'));

});

parcelRegister("bBCYv", function(module, exports) {

let $873162058cd85fdc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $873162058cd85fdc$var$load("jka8i").then(()=>parcelRequire('ly8Do'));

});

parcelRegister("8CdyV", function(module, exports) {

let $645c648e46057318$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $645c648e46057318$var$load("gSlAj").then(()=>parcelRequire('9cEBf'));

});

parcelRegister("dMuHY", function(module, exports) {

let $a08794167812bab1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a08794167812bab1$var$load("hBjFq").then(()=>parcelRequire('l8lqB'));

});

parcelRegister("kMCDP", function(module, exports) {

let $f21643b6d3c5d153$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f21643b6d3c5d153$var$load("4sGH7").then(()=>parcelRequire('duoyh'));

});

parcelRegister("dWA2c", function(module, exports) {

let $a26ca4d6572daaa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a26ca4d6572daaa3$var$load("eCtPz").then(()=>parcelRequire('fmv6i'));

});

parcelRegister("izvSu", function(module, exports) {

let $d854392254bb19a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d854392254bb19a6$var$load("eGaEl").then(()=>parcelRequire('46zrQ'));

});

parcelRegister("7Lxrh", function(module, exports) {

let $5a76dc7a2b7adb8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a76dc7a2b7adb8a$var$load("2rPrN").then(()=>parcelRequire('4qpjD'));

});

parcelRegister("jdwgw", function(module, exports) {

let $dfd84277ded5e2f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfd84277ded5e2f1$var$load("4knbp").then(()=>parcelRequire('kQV6d'));

});

parcelRegister("cHuDH", function(module, exports) {

let $93f14481d36e17c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93f14481d36e17c9$var$load("22kOQ").then(()=>parcelRequire('5QxPW'));

});

parcelRegister("keqsm", function(module, exports) {

let $eba9a3236d207650$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eba9a3236d207650$var$load("3PcMr").then(()=>parcelRequire('7zAJE'));

});

parcelRegister("bKddi", function(module, exports) {

let $88ce3d8319dbcafa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88ce3d8319dbcafa$var$load("hH5L8").then(()=>parcelRequire('22kSN'));

});

parcelRegister("eZBaS", function(module, exports) {

let $aea3993f11ad2ea1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aea3993f11ad2ea1$var$load("bKq5Y").then(()=>parcelRequire('50qNL'));

});

parcelRegister("d2EqJ", function(module, exports) {

let $97ead2dbaaf214dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97ead2dbaaf214dd$var$load("l8yhk").then(()=>parcelRequire('83VkF'));

});

parcelRegister("8yPmT", function(module, exports) {

let $63b9585c952b3222$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $63b9585c952b3222$var$load("1vfKI").then(()=>parcelRequire('MSpSB'));

});

parcelRegister("lkxV9", function(module, exports) {

let $f875c72b88ab1569$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f875c72b88ab1569$var$load("hZ9Wf").then(()=>parcelRequire('1Wcz9'));

});

parcelRegister("lLCIC", function(module, exports) {

let $fd8c057d7d457d3b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd8c057d7d457d3b$var$load("3e714").then(()=>parcelRequire('6pVZj'));

});

parcelRegister("lkqfj", function(module, exports) {

let $f86fd3288521d12c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f86fd3288521d12c$var$load("fnfyQ").then(()=>parcelRequire('j28kp'));

});

parcelRegister("efFK4", function(module, exports) {

let $a602d87e55f80afa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a602d87e55f80afa$var$load("5Y0la").then(()=>parcelRequire('98Yey'));

});

parcelRegister("krC0o", function(module, exports) {

let $ee23cf55524a009a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee23cf55524a009a$var$load("cyzjl").then(()=>parcelRequire('4RJAV'));

});

parcelRegister("9muly", function(module, exports) {

let $6d0db55321ff106f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d0db55321ff106f$var$load("kFz1Z").then(()=>parcelRequire('b2bZn'));

});

parcelRegister("apk7s", function(module, exports) {

let $793bd8716e096495$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $793bd8716e096495$var$load("ekw2t").then(()=>parcelRequire('ldfgH'));

});

parcelRegister("fDi4x", function(module, exports) {

let $b618844b90eaf60a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b618844b90eaf60a$var$load("ggmz8").then(()=>parcelRequire('6NTOJ'));

});

parcelRegister("gpcYc", function(module, exports) {

let $bf190ab3b2febcae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf190ab3b2febcae$var$load("j2KAJ").then(()=>parcelRequire('i2frm'));

});

parcelRegister("ib4T9", function(module, exports) {

let $d3bd0bd71f6a9214$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3bd0bd71f6a9214$var$load("lrlVs").then(()=>parcelRequire('9bVII'));

});

parcelRegister("lzOvC", function(module, exports) {
module.exports = JSON.parse('{"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.admin-key":[{"children":[{"type":0,"value":"Admin key"}],"type":8,"value":"b"},{"type":0,"value":": Access restricted content so you can fix issues"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.advanced-insights":[{"children":[{"type":0,"value":"Advanced insights"}],"type":8,"value":"b"},{"type":0,"value":": Audit and track all admin activity"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.benefits.support":[{"children":[{"type":0,"value":"24/7 support"}],"type":8,"value":"b"},{"type":0,"value":": Dedicated support team for critical issues"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Mission Control\' feature on the Premium plan. This will give them a dashboard to easily see activity across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.description":[{"type":0,"value":"Someone on your team has requested to try the \'Mission Control\' feature on the Confluence Premium plan. This will give them a dashboard to easily see activity across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Mission Control\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.no-name.title":[{"type":0,"value":"Help your team do more and worry less"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Mission Control\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-center.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" stay across team activity"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.admin-features-title":[{"type":0,"value":"You also get more admin features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.description":[{"type":0,"value":"Someone on your team wants to try advanced page elements on the Premium plan. This will give your team the tools to create richer content."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced page elements"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.no-name.title":[{"type":0,"value":"Help your team create engaging content"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced page elements"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-page-elements.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" create engaging content"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.description":[{"type":0,"value":"Someone on your team wants to try the advanced permissions features on the Premium plan. This will let them easily troubleshoot access issues and copy settings to new spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced permissions features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.no-name.title":[{"type":0,"value":"Help your team manage access better"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced permissions features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.advanced-permissions.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" manage access better"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Company Hub\' feature on the Premium plan. This will let them create a central place for updates and key resources."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.description":[{"type":0,"value":"Someone on your team wants to try the \u2018Company Hub\u2019 feature on the Premium plan. This will let them create a central place for updates and key resources."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Company Hub\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.no-name.title":[{"type":0,"value":"Give your team one place to share updates"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Company Hub\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.company-hub.title":[{"type":0,"value":"Give "},{"type":1,"value":"firstName"},{"type":0,"value":" one place to share updates"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try the \'Content manager\' feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.description":[{"type":0,"value":"Someone on your team wants to try the \u2018Content Manager\u2019 feature on the Premium plan. This will make it easy for them to bulk manage content across spaces."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try \'Content manager\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.no-name.title":[{"type":0,"value":"Help your team keep spaces organised"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try \'Content manager\'"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.content-manager.title":[{"type":0,"value":"Help "},{"type":1,"value":"firstName"},{"type":0,"value":" keep spaces organised"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.body-description":[{"children":[{"type":0,"value":"Let "},{"type":1,"value":"firstName"},{"type":0,"value":" try on a free, "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Cancel anytime. We\'ll remind you "},{"type":1,"value":"reminderDays"},{"type":0,"value":" days before your trial ends."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.description":[{"type":1,"value":"firstName"},{"type":0,"value":" has requested to try features on the Confluence Premium plan."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.body-description":[{"children":[{"type":0,"value":"Let your team member try on a free, "},{"type":1,"value":"trialLengthDays"},{"type":0,"value":"-day trial."}],"type":8,"value":"b"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Cancel anytime. We\'ll remind you "},{"type":1,"value":"reminderDays"},{"type":0,"value":" days before your trial ends."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.description":[{"type":0,"value":"Someone on your team has requested to try features on the Confluence Premium plan."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try new features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.no-name.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for your team"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try new features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.default.title":[{"type":0,"value":"Unlock more insights, clarity, and speed for "},{"type":1,"value":"firstName"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.explore-all-features":[{"type":0,"value":"Explore all features \u2192"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.get-started-button":[{"type":0,"value":"Get Started"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.img.alt":[{"type":0,"value":"Confluence logo"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.learn-more":[{"type":0,"value":"Learn more"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.description":[{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.description":[{"type":0,"value":"Someone on your team wants to try advanced whiteboard features on the Premium plan. This will let them create unlimited whiteboards and use smart integrations."}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.subject":[{"type":0,"value":"Approval required: Someone in your team wants to try advanced whiteboard features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.no-name.title":[{"type":0,"value":"Boost your team\'s collaboration"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"firstName"},{"type":0,"value":" wants to try advanced whiteboard features"}],"growth-luna.confluence-feature-gates-end-user-upgrade-request-standard.message-template.email.body.whiteboards.title":[{"type":0,"value":"Boost "},{"type":1,"value":"firstName"},{"type":0,"value":"\'s team collaboration"}],"growth-luna.jira-auto-upgrade-completion-modal.screen-space-flags.description":[{"type":0,"value":"See the remaining time in your Jira Standard trial."}],"growth-luna.jira-auto-upgrade-completion-modal.screen-space-flags.title":[{"type":0,"value":"Your Jira Standard trial is ready"}],"growth-luna.jira-pre-dunning-confirm-plan-modal.screen-space-flags.description.no-translate":[{"type":0,"value":"TWCG-2131 content will be added here."}],"growth-luna.jira-pre-dunning-confirm-plan-modal.screen-space-flags.title.no-translate":[{"type":0,"value":"Confirm plan modal placeholder"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.100-percent.description":[{"type":1,"value":"name"},{"type":0,"value":", your team can\u2019t add attachments to their work until you upgrade. Get 250 GB with Standard or "},{"children":[{"type":0,"value":"manage attachments"}],"type":8,"value":"a"},{"type":0,"value":"."}],"growth-luna.jira-storage-limit-emails.message-template.email.body.100-percent.heading":[{"type":0,"value":"Your team is out of free storage"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.80-percent.description":[{"type":1,"value":"name"},{"type":0,"value":", your team will run out of storage in the next few days. Upgrade now and get 250 GB storage with Standard."}],"growth-luna.jira-storage-limit-emails.message-template.email.body.80-percent.heading":[{"type":0,"value":"Your team is nearly out of free storage"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.80-percent.primary-button-text":[{"type":0,"value":"Upgrade"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.90-percent.description":[{"type":1,"value":"name"},{"type":0,"value":", your team is about to run out of storage and won\u2019t be able to add attachments to work. Upgrade now and get 250 GB with Standard."}],"growth-luna.jira-storage-limit-emails.message-template.email.body.90-percent.heading":[{"type":0,"value":"Your team is running out of storage"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.primary-button":[{"type":0,"value":"Upgrade"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-features-heading":[{"type":0,"value":"With Standard, you\u2019ll also get"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-features.advanced-feature":[{"children":[{"type":0,"value":"Advanced features"}],"type":8,"value":"b"},{"type":0,"value":" - Rovo AI, Permissions and more"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-features.automation-feature":[{"children":[{"type":0,"value":"More automation"}],"type":8,"value":"b"},{"type":0,"value":" - Get a higher rule run limit per month"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-features.permissions-feature":[{"children":[{"type":0,"value":"Permissions"}],"type":8,"value":"b"},{"type":0,"value":" - Choose who can edit and view your work"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-features.rovo-feature":[{"children":[{"type":0,"value":"Rovo AI"}],"type":8,"value":"b"},{"type":0,"value":" - Speed up work with Chat, Search and Agents"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-features.unlimited-user-feature":[{"children":[{"type":0,"value":"Unlimited users"}],"type":8,"value":"b"},{"type":0,"value":" - Get everyone in the same tool"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-ineligible.100-percent.description":[{"type":1,"value":"name"},{"type":0,"value":", you can\u2019t add any more attachments to your work."}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-ineligible.80-percent.description":[{"type":1,"value":"name"},{"type":0,"value":", you will run out of storage in the next few days."}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-ineligible.90-percent.description":[{"type":1,"value":"name"},{"type":0,"value":", you are about to run out of storage and won\u2019t be able to add attachments to work soon."}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-ineligible.admin-upgrade-prompt":[{"type":0,"value":"Our team is out of free storage. The Standard plan gets us 250 GB and other advanced features, check it out "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"a"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-ineligible.let-admin-know-default":[{"type":0,"value":"Let your admin know to upgrade your team:"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-ineligible.let-admin-know-multiple-admin":[{"type":0,"value":"Let "},{"children":[{"type":1,"value":"adminName1"}],"type":8,"value":"b"},{"type":0,"value":" or one of your "},{"type":1,"value":"numAdmins"},{"type":0,"value":" other admins know to upgrade your team:"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-ineligible.let-admin-know-one-admin":[{"type":0,"value":"Let your admin "},{"children":[{"type":1,"value":"adminName1"}],"type":8,"value":"b"},{"type":0,"value":" know to upgrade your team:"}],"growth-luna.jira-storage-limit-emails.message-template.email.body.upgrade-ineligible.let-admin-know-two-admin":[{"type":0,"value":"Let your admins "},{"children":[{"type":1,"value":"adminName1"}],"type":8,"value":"b"},{"type":0,"value":" or "},{"children":[{"type":1,"value":"adminName2"}],"type":8,"value":"b"},{"type":0,"value":" know to upgrade your team:"}],"growth-luna.jira-storage-limit-emails.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"growth-luna.jira-storage-limit-emails.message-template.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.ep-migration-inapp-715.body":[{"type":0,"value":"Get Confluence Premium to ship projects faster with advanced admin controls and analytics."}],"post-office.ep-migration-inapp-715.change-plans-button":[{"type":0,"value":"Change plans"}],"post-office.ep-migration-inapp-715.image-alt":[{"type":0,"value":"Confluence Premium illustration"}],"post-office.ep-migration-inapp-715.not-now-button":[{"type":0,"value":"Not now"}],"post-office.ep-migration-inapp-715.title":[{"type":0,"value":"Grow more agile"}],"post-office.jira-exp-banner.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.jira-standard-automation-limit-awareness-banner.close":[{"type":0,"value":"Close"}],"post-office.jira-standard-automation-limit-awareness-banner.message":[{"type":0,"value":"You\'re nearing or at your monthly automation run limit. Automations will fail to run this month if you hit the limit."}]}');

});

parcelRegister("62vgI", function(module, exports) {

let $465b2f4c3aa5215a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $465b2f4c3aa5215a$var$load("dhGnB").then(()=>parcelRequire('47Fb9'));

});

parcelRegister("gPR4R", function(module, exports) {

let $c41a94d8467b2839$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c41a94d8467b2839$var$load("3OExY").then(()=>parcelRequire('44D6H'));

});

parcelRegister("5g3kR", function(module, exports) {

let $3d4108b3f44cc888$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d4108b3f44cc888$var$load("31iqC").then(()=>parcelRequire('k0a53'));

});

parcelRegister("c1drX", function(module, exports) {

let $8c0002ee132070f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c0002ee132070f8$var$load("4OTW1").then(()=>parcelRequire('dsAfZ'));

});

parcelRegister("Sjgmg", function(module, exports) {

let $0a33fc7581ece655$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a33fc7581ece655$var$load("QY9sf").then(()=>parcelRequire('6n86q'));

});

parcelRegister("6MB91", function(module, exports) {

let $4f0409e9dd16805a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f0409e9dd16805a$var$load("bXVWk").then(()=>parcelRequire('a8lFX'));

});

parcelRegister("2oCab", function(module, exports) {

let $1beb6d1960bcf963$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1beb6d1960bcf963$var$load("baM9Z").then(()=>parcelRequire('gTJRz'));

});

parcelRegister("hzd9l", function(module, exports) {

let $cc9fe7d2b58a3eca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc9fe7d2b58a3eca$var$load("hB3Eu").then(()=>parcelRequire('360nH'));

});

parcelRegister("3t2D5", function(module, exports) {

let $28661ea8537591d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28661ea8537591d5$var$load("2js81").then(()=>parcelRequire('b51St'));

});

parcelRegister("2pKAa", function(module, exports) {

let $1c220cdf4ede1533$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c220cdf4ede1533$var$load("ACr5m").then(()=>parcelRequire('8DWFf'));

});

parcelRegister("45Usu", function(module, exports) {

let $2fb36c847fc7e7f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2fb36c847fc7e7f6$var$load("aWQdo").then(()=>parcelRequire('iXhoH'));

});

parcelRegister("bHjty", function(module, exports) {

let $8842d14daf0976d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8842d14daf0976d5$var$load("3FDv8").then(()=>parcelRequire('cZcdH'));

});

parcelRegister("alPmq", function(module, exports) {

let $7893b4b7005f1459$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7893b4b7005f1459$var$load("aZseA").then(()=>parcelRequire('1IPyy'));

});

parcelRegister("4M6FR", function(module, exports) {

let $37a0d2785aca0bf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37a0d2785aca0bf4$var$load("3BLof").then(()=>parcelRequire('bzGOQ'));

});

parcelRegister("iyYoP", function(module, exports) {

let $d83a410795af93c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d83a410795af93c5$var$load("9T5k3").then(()=>parcelRequire('jHe08'));

});

parcelRegister("kZwkd", function(module, exports) {

let $f482943e16809e45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f482943e16809e45$var$load("iHntS").then(()=>parcelRequire('86YTx'));

});

parcelRegister("dHoaX", function(module, exports) {

let $9f920b4a38316150$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f920b4a38316150$var$load("5IV2y").then(()=>parcelRequire('7oxlX'));

});

parcelRegister("3raFD", function(module, exports) {

let $280c2babbae73b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $280c2babbae73b6f$var$load("aDY98").then(()=>parcelRequire('4XYeE'));

});

parcelRegister("exitT", function(module, exports) {

let $a9527bb6ff1e34f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9527bb6ff1e34f9$var$load("fnJtc").then(()=>parcelRequire('71iMm'));

});

parcelRegister("bVXPj", function(module, exports) {

let $8b036ce1026eb32f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b036ce1026eb32f$var$load("8fU5H").then(()=>parcelRequire('84nhu'));

});

parcelRegister("c0zow", function(module, exports) {

let $8be0f0ba3eaaed72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8be0f0ba3eaaed72$var$load("eaREO").then(()=>parcelRequire('5Ya9l'));

});

parcelRegister("jZhFg", function(module, exports) {

let $e8d16aa5df2675b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8d16aa5df2675b7$var$load("eyFqR").then(()=>parcelRequire('7fBLo'));

});

parcelRegister("fV7bw", function(module, exports) {

let $b971c09ed50e2cb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b971c09ed50e2cb1$var$load("1ToNc").then(()=>parcelRequire('a9DA3'));

});

parcelRegister("fPID5", function(module, exports) {

let $b86e3ceee7586d9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b86e3ceee7586d9b$var$load("hswX7").then(()=>parcelRequire('2JDGU'));

});

parcelRegister("fYROS", function(module, exports) {

let $ba26350a0cc70f04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba26350a0cc70f04$var$load("fGPFy").then(()=>parcelRequire('5amq3'));

});

parcelRegister("eRbae", function(module, exports) {

let $ad0eacd9d567f52c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad0eacd9d567f52c$var$load("59eoJ").then(()=>parcelRequire('5eHYY'));

});

parcelRegister("15Kks", function(module, exports) {

let $0cba32073cf7b239$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0cba32073cf7b239$var$load("9BDcp").then(()=>parcelRequire('2yxbz'));

});

parcelRegister("6vg3U", function(module, exports) {

let $4bc218e90a077ffc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4bc218e90a077ffc$var$load("2U4Fl").then(()=>parcelRequire('jhjyP'));

});

parcelRegister("lrnaw", function(module, exports) {

let $f9be176a02934af1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9be176a02934af1$var$load("7Qlxf").then(()=>parcelRequire('gqMfj'));

});

parcelRegister("9LzqH", function(module, exports) {

let $71c3fc6fa20599b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71c3fc6fa20599b8$var$load("8JsK3").then(()=>parcelRequire('elZZU'));

});

parcelRegister("jbbJk", function(module, exports) {

let $df6824bb4278365f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df6824bb4278365f$var$load("40Noq").then(()=>parcelRequire('cWUx5'));

});

parcelRegister("jZeNQ", function(module, exports) {

let $e8cf32623222e075$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8cf32623222e075$var$load("1SmLA").then(()=>parcelRequire('lkzxj'));

});

parcelRegister("jQ2cU", function(module, exports) {

let $03ba2373755b0249$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03ba2373755b0249$var$load("a1jbE").then(()=>parcelRequire('1DOrr'));

});

parcelRegister("4HVs6", function(module, exports) {

let $36d7be6b3bd3351a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36d7be6b3bd3351a$var$load("ijSqD").then(()=>parcelRequire('1IyNH'));

});

parcelRegister("3MCML", function(module, exports) {
module.exports = JSON.parse('{"atlassian":[{"type":0,"value":"Atlassian"}],"ax-epsilon.finalized.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.social-proof":[{"type":0,"value":"Over "},{"type":1,"value":"numberOfCustomers"},{"type":0,"value":" customers use "},{"type":1,"value":"productName"},{"type":0,"value":" to accelerate their work"}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.accept-invite":[{"type":0,"value":"Accept invite"}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.body":[{"type":0,"value":"It\u2019s separate from the "},{"type":1,"value":"productName"},{"type":0,"value":" sites you already use. Accept the invite to get started."}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.heading":[{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to a new "},{"type":1,"value":"productName"},{"type":0,"value":" site."}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.heading-no-inviter":[{"type":0,"value":"Your admin invited you to a new "},{"type":1,"value":"productName"},{"type":0,"value":" site."}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.lozenge":[{"type":0,"value":"New"}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.preheader":[{"type":1,"value":"siteDisplayName"},{"type":0,"value":" is a different "},{"type":1,"value":"productName"},{"type":0,"value":" site from the one you already use."}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.reminder-subject":[{"type":0,"value":"[Reminder] "},{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to a new "},{"type":1,"value":"productName"},{"type":0,"value":" site"}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.reminder-subject-no-inviter":[{"type":0,"value":"[Reminder] Your admin invited you to a new "},{"type":1,"value":"productName"},{"type":0,"value":" site"}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.subject":[{"type":0,"value":"[Action Required] "},{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to a new "},{"type":1,"value":"productName"},{"type":0,"value":" site"}],"ax-epsilon.invitations-better-notification-invite-user.cross-site.subject-no-inviter":[{"type":0,"value":"[Action Required] Your admin invited you to a new "},{"type":1,"value":"productName"},{"type":0,"value":" site"}],"ax-epsilon.invitations-better-notification-invite-user.invite-reminder-flag.description":[{"type":0,"value":"Don\'t miss out on project updates and decisions from your teammates"}],"ax-epsilon.invitations-better-notification-invite-user.invite-reminder-flag.primary-action":[{"type":0,"value":"Join your team"}],"ax-epsilon.invitations-better-notification-invite-user.invite-reminder-flag.title-team-invited":[{"type":0,"value":"Your team invited you to Confluence"}],"ax-epsilon.invitations-better-notification-invite-user.invite-reminder-flag.title-user-invited":[{"type":1,"value":"adminName"},{"type":0,"value":" invited you to Confluence"}],"ax-epsilon.invitations-better-notification-invite-user.jira.description":[{"type":0,"value":"A software tool for project and issue tracking across your team. Plan, track and manage your projects in Jira."}],"ax-epsilon.invitations-better-notification-invite-user.jsm.accept-invite":[{"type":0,"value":"Accept invite"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.body-with-space":[{"type":0,"value":"You\u2019ve been given access to the "},{"children":[{"type":1,"value":"projectName"}],"type":8,"value":"strong"},{"type":0,"value":" space to start collaborating with your team today."}],"ax-epsilon.invitations-better-notification-invite-user.jsm.body-without-space":[{"type":0,"value":"You\u2019ve been given access to Jira Service Management to start collaborating with your team today."}],"ax-epsilon.invitations-better-notification-invite-user.jsm.customer-body":[{"type":0,"value":"You\u2019ve been given access to Jira Service Management to start raising requests."}],"ax-epsilon.invitations-better-notification-invite-user.jsm.customer-logos-alt":[{"type":0,"value":"Customer logos"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.customer-product-description":[{"children":[{"type":0,"value":"What is Jira Service Management?"}],"type":8,"value":"strong"},{"type":0,"value":" An AI-powered platform to deliver great service experiences."}],"ax-epsilon.invitations-better-notification-invite-user.jsm.greeting":[{"type":0,"value":"\uD83D\uDC4B G\u2019day "},{"type":1,"value":"recipientName"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.heading-customer":[{"type":0,"value":"You\u2019ve been invited to Jira Service Management"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.heading-generic":[{"type":0,"value":"You\u2019ve been invited to join your team in Jira Service Management"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.heading-with-inviter":[{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to join your team in Jira Service Management"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.note-from-admin":[{"type":0,"value":"A note from "},{"type":1,"value":"inviterName"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.note-from-admin-fallback":[{"type":0,"value":"A note from your admin"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.pairs.body-with-space.ai-non-final":[{"type":0,"value":"You\u2019ve been invited as an administrator to help set up "},{"children":[{"type":1,"value":"projectName"}],"type":8,"value":"strong"},{"type":0,"value":"."}],"ax-epsilon.invitations-better-notification-invite-user.jsm.pairs.heading-with-inviter.ai-non-final":[{"type":0,"value":"Join "},{"type":1,"value":"inviterName"},{"type":0,"value":" to set up your new service space"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.pairs.product-description.ai-non-final":[{"type":0,"value":"Customize request types, configure queues, and get the portal ready for your team."}],"ax-epsilon.invitations-better-notification-invite-user.jsm.pairs.subject-with-inviter.ai-non-final":[{"type":0,"value":"Action required: "},{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to set up "},{"type":1,"value":"projectName"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.preheader":[{"type":0,"value":"Accept your invitation to Jira Service Management"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.product-description":[{"type":0,"value":"Join Jira Service Management to help your team seamlessly manage incoming requests and deliver great service."}],"ax-epsilon.invitations-better-notification-invite-user.jsm.social-proof":[{"type":0,"value":"Over 125,000 customers use Jira Service Management to accelerate their work"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.subject":[{"type":0,"value":"Action required: You\u2019ve been invited to Jira Service Management"}],"ax-epsilon.invitations-better-notification-invite-user.jsm.subject-with-inviter":[{"type":0,"value":"Action required: "},{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to Jira Service Management"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.accept-button":[{"type":0,"value":"Accept invite"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.customer-logos-alt":[{"type":0,"value":"Logos of companies using "},{"type":1,"value":"productName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.logo-alt":[{"type":0,"value":"Product logo"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.analytics":[{"type":0,"value":"A tool that provides data visualization and insights across your Atlassian products to help teams make informed decisions."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.analytics-appify":[{"type":0,"value":"A tool that provides data visualization and insights across your Atlassian apps to help teams make informed decisions."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.assets":[{"type":0,"value":"From laptops to llamas, bring anything you need to track into a flexible database. Link objects to work items, documents, automations, and more."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.atlas":[{"type":0,"value":"A software tool to connect work across your company. Share work and get aligned across teams."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.avocado":[{"type":0,"value":"A question and answer application."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.bitbucket":[{"type":0,"value":"A Git-based code hosting and collaboration tool, built for teams"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.compass":[{"type":0,"value":"Mission control for your distributed architecture."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.confluence":[{"type":0,"value":"Get to knowledge faster with Confluence. Document, brainstorm, and collaborate on work, together."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.confluence-reinvite":[{"type":0,"value":"Sending you a friendly reminder that your teammate "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join "},{"type":1,"value":"productName"},{"type":0,"value":". Start collaborating with your team today."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.default":[{"type":0,"value":"Start planning, tracking, and collaborating on your work with your team today."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.feedback":[{"type":0,"value":"A tool for collecting, organizing, and acting on customer and team feedback."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.focus":[{"type":0,"value":"A portfolio management tool that helps leaders define and map strategic priorities and track progress with their teams."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.guard":[{"type":0,"value":"An intelligent security add-on that detects suspicious activity and data misuse across your Atlassian Cloud \u2014 so you can act before threats become incidents."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira":[{"type":0,"value":"A software tool for project and issue tracking with your team"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira-customer-service":[{"type":0,"value":"A platform to unite Development, Operations, and Customer Service teams to resolve support cases faster and deliver exceptional customer experiences."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira-product-discovery":[{"type":0,"value":"A tool for product teams to capture, prioritize, and transform ideas into shareable roadmaps."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira-reinvite":[{"type":0,"value":"Sending you a friendly reminder that your teammate "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join "},{"type":1,"value":"productName"},{"type":0,"value":". Start planning and tracking your work with your team today."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.jira-service-management":[{"type":0,"value":"An AI-powered platform to deliver great service experiences."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.loom":[{"type":0,"value":"Loom is an easy way to create video messages of feedback, ideas, presentations, and more. Work moves forward faster, and you have fewer meetings."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.opsgenie":[{"type":0,"value":"A software tool for incident management. Track on-call alerts and notifications."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.rovo":[{"type":0,"value":"Start using the same AI your team uses to find answers across your apps and work faster with chat, search, and agents."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.rovo-app":[{"type":0,"value":"Start using the same AI your team uses to find answers across your apps and work faster with chat, search, and agents."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.rovodev":[{"type":0,"value":"Rovo Dev is a suite of AI features that help you both review and create code using Atlassian products."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.rovodev-appify":[{"type":0,"value":"Rovo Dev is a suite of AI features that help you both review and create code using Atlassian apps."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.statuspage":[{"type":0,"value":"A software tool for incident communication."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.studio":[{"type":0,"value":"A space for makers to build and combine automations, agents, and apps into custom solutions that solve your unique business problems."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.talent":[{"type":0,"value":"Talent is a strategic workforce planning tool that helps you understand, design and build a thriving workforce."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.product-info.trello":[{"type":0,"value":"A visual collaboration tool that organizes your projects into boards, allowing for easy task and project management."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.welcome":[{"type":1,"value":"waveEmoji"},{"type":0,"value":" G\'day, "},{"type":1,"value":"recipientFirstName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.what-is":[{"type":0,"value":"What is "},{"type":1,"value":"productName"},{"type":0,"value":"? "}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.common.what-is.new":[{"children":[{"type":0,"value":"What is "},{"type":1,"value":"productName"},{"type":0,"value":"?"}],"type":8,"value":"strong"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.admin":[{"type":0,"value":"Your admin "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"productName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.no-inviter-nor-product":[{"type":0,"value":"You\'ve been invited to join your team"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.no-product":[{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to join your team"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.non-ugc":[{"type":0,"value":"You\'ve been invited to join your team in "},{"type":1,"value":"productName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.nth-user":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"productName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.reinvite":[{"type":1,"value":"inviterName"},{"type":0,"value":" is waiting for you to join your team in "},{"type":1,"value":"productName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body-title.rovo-product":[{"type":1,"value":"inviterName"},{"type":0,"value":" invited you to join them in "},{"type":1,"value":"productName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.copyright":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.links.contact-us":[{"type":0,"value":"Contact us"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.links.privacy-policy":[{"type":0,"value":"Privacy policy"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.links.read-our-blog":[{"type":0,"value":"Read our blog"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.links.unsubscribe":[{"type":0,"value":"Unsubscribe"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.reinvite":[{"type":0,"value":"Over "},{"type":1,"value":"numberOfCustomers"},{"type":0,"value":" customers use Atlassian apps to accelerate their work"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.rovo.social-proof":[{"type":0,"value":"Trusted by teams around the world"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.body.footer.social-proof":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":"+ customers use "},{"type":1,"value":"productName"},{"type":0,"value":" to move work forward"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject":[{"type":0,"value":"Action requested: "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"productName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject.invite-with-inviter-and-product":[{"type":0,"value":"Action requested: "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"subjectName"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject.invite-without-inviter-nor-product":[{"type":0,"value":"Action required: You\u2019re invited to join your team"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject.invite-without-product":[{"type":0,"value":"Action required: "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team"}],"ax-epsilon.invitations-better-notification-invite-user.simplify-email-experiment-template.email.subject.reinvite":[{"type":0,"value":"Reminder: "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"subjectName"}],"ax-epsilon.invitations.better.notification.invite.user.body.img.alt":[{"type":0,"value":"Atlassian Logo"}],"experiment.invite-email-user-to-bundle.admin-role":[{"type":0,"value":"ADMIN"}],"experiment.invite-email-user-to-bundle.body":[{"type":0,"value":"Start planning and tracking work with "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" and your team. You can share your work and view what your team is doing."}],"experiment.invite-email-user-to-bundle.body-image-alt":[{"type":1,"value":"productName"}],"experiment.invite-email-user-to-bundle.body-reinvite":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join Jira and Confluence 3 days ago. Start collaborating with your team."}],"experiment.invite-email-user-to-bundle.button-text.confluence":[{"type":0,"value":"Go to Confluence"}],"experiment.invite-email-user-to-bundle.button-text.jira":[{"type":0,"value":"Go to Jira"}],"experiment.invite-email-user-to-bundle.confluence.description":[{"type":0,"value":"A team workspace where knowledge and collaboration meet. Create, collaborate, and organize all your work in one place."}],"experiment.invite-email-user-to-bundle.invite-user.avatar-alt-text":[{"type":0,"value":"Inviter user avatar"}],"experiment.invite-email-user-to-bundle.jira.description":[{"type":0,"value":"A software tool for project and issue tracking across your team. Plan, track and manage your projects in Jira."}],"experiment.invite-email-user-to-bundle.learn-more":[{"type":0,"value":" Learn more"}],"experiment.invite-email-user-to-bundle.note-title":[{"type":0,"value":"A note from "},{"type":1,"value":"inviterDisplayName"}],"experiment.invite-email-user-to-bundle.reminder-subject-text":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" is waiting for you to join Jira and Confluence"}],"experiment.invite-email-user-to-bundle.subject-with-inviter":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join them in Jira and Confluence"}],"experiment.invite-email-user-to-bundle.subject-without-inviter":[{"type":0,"value":"You\'ve been invited to Jira and Confluence"}],"experiment.invite-email-user-to-bundle.what-is":[{"type":0,"value":"What is "},{"type":1,"value":"productName"},{"type":0,"value":"? "}],"id-invitations-service.better_notification_invite_user.admin_role":[{"type":0,"value":"ADMIN"}],"id-invitations-service.better_notification_invite_user.analytics.description":[{"type":0,"value":"Visualize data across Atlassian products for actionable insights."}],"id-invitations-service.better_notification_invite_user.assets.description":[{"type":0,"value":"From laptops to llamas, bring anything you need to track into a flexible database. Link objects to work items, documents, automations, and more."}],"id-invitations-service.better_notification_invite_user.avocado.description":[{"type":0,"value":"Question and answer."}],"id-invitations-service.better_notification_invite_user.beacon.description":[{"type":0,"value":"Security monitoring."}],"id-invitations-service.better_notification_invite_user.body":[{"type":0,"value":"Start planning and tracking work with "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" and your team. You can share your work and view what your team is doing."}],"id-invitations-service.better_notification_invite_user.body.devai":[{"type":0,"value":"Start using AI to help you get started with coding your work."}],"id-invitations-service.better_notification_invite_user.body.jira-product-discovery":[{"type":0,"value":"A dedicated tool for product teams to capture and prioritize ideas, connect business and tech teams, and align everyone\u2014all in Jira."}],"id-invitations-service.better_notification_invite_user.body.mercury":[{"type":0,"value":"Understand your company\'s strategic priorities and start mapping focus areas with your team. Connect goals, work, positions, and funds to maximize your enterprise strategy."}],"id-invitations-service.better_notification_invite_user.body.rovo.personalised.note":[{"type":0,"value":"Start using and tracking work with "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" and your team. You can share your work and view what your team is doing."}],"id-invitations-service.better_notification_invite_user.body_image_alt":[{"type":1,"value":"productName"}],"id-invitations-service.better_notification_invite_user.body_reinvite":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join "},{"type":1,"value":"productName"},{"type":0,"value":". Start collaborating with your team."}],"id-invitations-service.better_notification_invite_user.button_text":[{"type":0,"value":"Accept Invite"}],"id-invitations-service.better_notification_invite_user.compass.description":[{"type":0,"value":"Mission control for your distributed architecture."}],"id-invitations-service.better_notification_invite_user.confluence.description":[{"type":0,"value":"A team workspace where knowledge and collaboration meet. Create, collaborate, and organize all your work in one place."}],"id-invitations-service.better_notification_invite_user.devai.description":[{"type":0,"value":"Rovo Dev is a suite of AI features that help you both review and create code using Atlassian products."}],"id-invitations-service.better_notification_invite_user.feedback.description":[{"type":0,"value":"A tool for collecting, organizing, and acting on customer and team feedback."}],"id-invitations-service.better_notification_invite_user.jira-customer-service.description":[{"type":0,"value":"Unite Development, Operations, and Customer Service teams on a single platform to resolve support cases faster and deliver exceptional customer experiences."}],"id-invitations-service.better_notification_invite_user.jira-servicedesk.description":[{"type":0,"value":"IT service desk and customer service."}],"id-invitations-service.better_notification_invite_user.jira.description":[{"type":0,"value":"A software tool for project and issue tracking across your team. Plan, track and manage your projects in Jira."}],"id-invitations-service.better_notification_invite_user.learn_more":[{"type":0,"value":" Learn more"}],"id-invitations-service.better_notification_invite_user.loom.description":[{"type":0,"value":"Loom is an easy way to create video messages of feedback, ideas, presentations, and more. Work moves forward faster, and you have fewer meetings."}],"id-invitations-service.better_notification_invite_user.mercury.description":[{"type":0,"value":"Define and map strategic priorities and track progress with your team."}],"id-invitations-service.better_notification_invite_user.note_title":[{"type":0,"value":"A note from "},{"type":1,"value":"inviterDisplayName"}],"id-invitations-service.better_notification_invite_user.opsgenie.description":[{"type":0,"value":"A software tool for incident management. Track on-call alerts and notifications."}],"id-invitations-service.better_notification_invite_user.reminder_subject_text":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" is waiting for you to join "},{"type":1,"value":"subjectName"}],"id-invitations-service.better_notification_invite_user.rovo.description":[{"type":0,"value":"Start using the same AI your team uses to find answers across your apps and work faster with chat, search, and agents."}],"id-invitations-service.better_notification_invite_user.statuspage.description":[{"type":0,"value":"A software tool for incident communication."}],"id-invitations-service.better_notification_invite_user.studio.description":[{"type":0,"value":"A space for makers to build and combine automations, agents, and apps into custom solutions that solve your unique business problems."}],"id-invitations-service.better_notification_invite_user.subject_with_inviter":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join them in "},{"type":1,"value":"subjectName"}],"id-invitations-service.better_notification_invite_user.subject_without_inviter":[{"type":0,"value":"You\'ve been invited to "},{"type":1,"value":"subjectName"}],"id-invitations-service.better_notification_invite_user.subject_without_subject_name":[{"type":0,"value":"You\'ve been invited"}],"id-invitations-service.better_notification_invite_user.talent.description":[{"type":0,"value":"Talent is a strategic workforce planning tool that helps you understand, design and build a thriving workforce."}],"id-invitations-service.better_notification_invite_user.townsquare.description":[{"type":0,"value":"A software tool to connect work across your company. Share work and get aligned across teams."}],"id-invitations-service.better_notification_invite_user.what_is":[{"type":0,"value":"What is "},{"type":1,"value":"productName"},{"type":0,"value":"? "}],"id-invitations-service.components.VortexProductComponent.bitbucket.description":[{"type":0,"value":"Code management and collaboration."}],"id-invitations-service.components.VortexProductComponent.trello.description":[{"type":0,"value":"Tasks and project management."}],"id-invitations-service.invitation-urls-notify-admin.body":[{"type":1,"value":"userLink"},{"type":0,"value":" will now have access to "},{"type":1,"value":"product"},{"type":0,"value":" and will consume a seat in your license."}],"id-invitations-service.invitation-urls-notify-admin.header":[{"type":1,"value":"name"},{"type":0,"value":" joined "},{"type":1,"value":"product"}],"id-invitations-service.invitation-urls-notify-admin.intro":[{"type":1,"value":"name"},{"type":0,"value":" ("},{"type":1,"value":"email"},{"type":0,"value":") joined "},{"type":1,"value":"siteName"},{"type":0,"value":" via your "},{"type":1,"value":"product"},{"type":0,"value":" invitation URL."}],"id-invitations-service.invitation-urls-notify-admin.request-access.button":[{"type":0,"value":"Go to site administration"}],"id-invitations-service.invitation-urls-notify-admin.subject":[{"type":0,"value":"Your team is growing"}],"id-invitations-service.invite-user.avatar-alt-text":[{"type":0,"value":"Inviter user avatar"}],"id-invitations-service.invite-user.button-text":[{"type":0,"value":"Join the team"}],"id-invitations-service.invite-user.header":[{"type":0,"value":"Your team is waiting for you to join them"}],"id-invitations-service.invite-user.invite-text-with-inviter-and-site":[{"type":1,"value":"inviterName"},{"type":0,"value":" has invited you to collaborate on "},{"type":1,"value":"siteUrl"}],"id-invitations-service.invite-user.invite-text-with-inviter-without-site":[{"type":1,"value":"inviterName"},{"type":0,"value":" has invited you to collaborate with the "},{"type":1,"value":"instanceName"},{"type":0,"value":" team"}],"id-invitations-service.invite-user.invite-text-without-inviter-and-site":[{"type":0,"value":"You\'ve been invited to collaborate with the "},{"type":1,"value":"instanceName"},{"type":0,"value":" team"}],"id-invitations-service.invite-user.invite-text-without-inviter-with-site":[{"type":0,"value":"You\'ve been invited to collaborate on "},{"type":1,"value":"siteUrl"}],"id-invitations-service.invite-user.reminder-subject-text":[{"type":0,"value":"[Reminder]"}],"id-invitations-service.invite-user.subject-with-inviter":[{"type":1,"value":"reminderValue"},{"type":0,"value":" "},{"type":1,"value":"inviterName"},{"type":0,"value":" is waiting for you to join them"}],"id-invitations-service.invite-user.subject-without-inviter":[{"type":1,"value":"reminderValue"},{"type":0,"value":" Your team is waiting for you to join them"}],"id-invitations-service.invite-user.team-message-with-inviter":[{"type":0,"value":"Here\'s what "},{"type":1,"value":"inviterName"},{"type":0,"value":" and your team are using to work seamlessly and accomplish more, together:"}],"id-invitations-service.invite-user.team-message-without-inviter":[{"type":0,"value":"Here\'s what your team are using to work seamlessly and accomplish more, together:"}],"id-invitations-service.invite_user.avatar_alt_text":[{"type":0,"value":"Inviter user avatar"}],"id-invitations-service.join-multiple-products-admin-notification.invite-text-with-inviter":[{"type":1,"value":"joinedUserName"},{"type":0,"value":" ("},{"type":1,"value":"joinedUserEmailAddress"},{"type":0,"value":") has just joined "},{"type":1,"value":"siteUrl"},{"type":0,"value":" in "},{"type":1,"value":"organizationName"},{"type":0,"value":". They have access to the following products:"}],"id-invitations-service.join-multiple-products-admin-notification.review-settings-text":[{"type":0,"value":"If something doesn\'t look right, "},{"children":[{"type":0,"value":"review your user access settings"}],"type":8,"value":"link"},{"type":0,"value":"."}],"id-invitations-service.join-multiple-products-admin-notification.subject-text":[{"type":1,"value":"joinedUserName"},{"type":0,"value":" has joined "},{"type":1,"value":"organizationName"}],"id-invitations-service.join-multiple-products-admin-notification.title":[{"type":1,"value":"joinedUserName"},{"type":0,"value":" has joined "},{"type":1,"value":"organizationName"}],"id-invitations-service.join-multiple-products-admin-notification.view-profile-button-text":[{"type":0,"value":"View "},{"type":1,"value":"joinedUserName"},{"type":0,"value":"\'s profile"}],"id-invitations-service.join-product-admin-notification.invite-text-with-inviter":[{"type":1,"value":"joinedUserName"},{"type":0,"value":" ("},{"type":1,"value":"joinedUserEmailAddress"},{"type":0,"value":") has just joined "},{"type":1,"value":"productName"},{"type":0,"value":" ("},{"type":1,"value":"siteUrl"},{"type":0,"value":") in "},{"type":1,"value":"organizationName"},{"type":0,"value":"."}],"id-invitations-service.join-product-admin-notification.review-settings-text":[{"type":0,"value":"If something doesn\'t look right, "},{"children":[{"type":0,"value":"review your user access settings"}],"type":8,"value":"link"},{"type":0,"value":"."}],"id-invitations-service.join-product-admin-notification.subject-text":[{"type":1,"value":"joinedUserName"},{"type":0,"value":" has joined your "},{"type":1,"value":"productName"}],"id-invitations-service.join-product-admin-notification.title":[{"type":1,"value":"joinedUserName"},{"type":0,"value":" has joined "},{"type":1,"value":"productName"}],"id-invitations-service.join-product-admin-notification.view-profile-button-text":[{"type":0,"value":"View "},{"type":1,"value":"joinedUserName"},{"type":0,"value":"\'s profile"}],"id-invitations-service.open-invite-notification.header-invited-user":[{"type":1,"value":"inviterPublicName"},{"type":0,"value":" invited "},{"type":1,"value":"inviteePublicName"},{"type":0,"value":" to your Atlassian site"}],"id-invitations-service.open-invite-notification.intro-invited-user":[{"type":1,"value":"inviterPublicName"},{"type":0,"value":" ("},{"type":1,"value":"inviterEmail"},{"type":0,"value":") has invited "},{"type":1,"value":"inviteePublicName"},{"type":0,"value":" to work with your team. Here\'s some more information about them:"}],"id-invitations-service.open-invite-notification.invite-settings-link":[{"children":[{"type":0,"value":"View your invite settings"}],"type":8,"value":"link"}],"id-invitations-service.open-invite-notification.subject-invited":[{"type":1,"value":"inviterPublicName"},{"type":0,"value":" invited "},{"type":1,"value":"inviteePublicName"},{"type":0,"value":" to your Atlassian site"}],"id-invitations-service.open-invite-notification.view-profile.button":[{"type":0,"value":"View profile"}],"id-invitations-service.pending-invite-approve-original-user.header":[{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" wanted you to get access to "},{"type":1,"value":"product"}],"id-invitations-service.pending-invite-approve-original-user.intro-invited-user":[{"type":0,"value":"Your site admin ("},{"type":1,"value":"siteAdmin"},{"type":0,"value":") granted you access to "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"type":1,"value":"siteName"}],"id-invitations-service.pending-invite-approve-original-user.intro-user-requested-access":[{"type":0,"value":"Your site admin "},{"type":1,"value":"siteAdminInfo"},{"type":0,"value":" granted you access to "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"type":1,"value":"siteName"}],"id-invitations-service.pending-invite-approve-original-user.request-access.button":[{"type":0,"value":"Open "},{"type":1,"value":"product"}],"id-invitations-service.pending-invite-approve-original-user.subject":[{"type":0,"value":"You have access to "},{"type":1,"value":"product"}],"id-invitations-service.pending-invite-reject-user.header":[{"type":0,"value":"The user at "},{"type":1,"value":"invitedUserEmail"},{"type":0,"value":" cannot access "},{"type":1,"value":"product"}],"id-invitations-service.pending-invite-reject-user.intro-internal":[{"type":0,"value":"Your site admin ("},{"type":1,"value":"siteAdmin"},{"type":0,"value":") at "},{"type":1,"value":"siteName"},{"type":0,"value":" denied your request for "},{"type":1,"value":"invitedUserEmail"},{"type":0,"value":" to access "},{"type":1,"value":"product"},{"type":0,"value":"."}],"id-invitations-service.pending-invite-reject-user.subject":[{"type":0,"value":"Your admin declined your invitation to another user"}],"id-invitations-service.product-component.product-logo.alt-text":[{"type":1,"value":"displayName"},{"type":0,"value":" logo"}],"id-invitations-service.request-access-approve-user.header":[{"type":0,"value":"You can now see the content you requested"}],"id-invitations-service.request-access-approve-user.intro-invited-user":[{"type":0,"value":"Your site admin ("},{"type":1,"value":"email"},{"type":0,"value":") granted you access to "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"type":1,"value":"site"},{"type":0,"value":"."}],"id-invitations-service.request-access-approve-user.intro-user-requested-access":[{"type":0,"value":"Your site admin granted you access to "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"type":1,"value":"site"},{"type":0,"value":"."}],"id-invitations-service.request-access-approve-user.loom-value-prop":[{"type":0,"value":"Record and share Loom videos to keep your team up to date on progress, feedback, ideas, and more."}],"id-invitations-service.request-access-approve-user.new-loom-header":[{"type":0,"value":"Start sharing async video with Loom"}],"id-invitations-service.request-access-approve-user.request-access.button":[{"type":0,"value":"Open "},{"type":1,"value":"product"}],"id-invitations-service.request-access-approve-user.subject":[{"type":0,"value":"You have access to "},{"type":1,"value":"product"}],"id-invitations-service.request-access-reject-user.deny-reason":[{"type":1,"value":"denyReason"}],"id-invitations-service.request-access-reject-user.header":[{"type":0,"value":"We can\'t show you the content you requested"}],"id-invitations-service.request-access-reject-user.intro-external":[{"type":0,"value":"The site admin denied your request for access to "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"strong"},{"type":0,"value":"."}],"id-invitations-service.request-access-reject-user.intro-internal":[{"type":0,"value":"Your site admin denied your request for access to "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"strong"},{"type":0,"value":"."}],"id-invitations-service.request-access-reject-user.intro-internal-specified-site-admin":[{"type":0,"value":"Your site admin ("},{"type":1,"value":"email"},{"type":0,"value":") denied your request for access to "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"strong"},{"type":0,"value":"."}],"id-invitations-service.request-access-reject-user.subject":[{"type":0,"value":"You were denied access to "},{"type":1,"value":"product"}],"id-invitations-service.request-access.access-details.app-requested-label":[{"type":0,"value":"App Requested"}],"id-invitations-service.request-access.access-details.requestTime-label":[{"type":0,"value":"Date"}],"id-invitations-service.request-access.access-details.requested-by-label":[{"type":0,"value":"Requested by"}],"id-invitations-service.request-access.access-details.requester-info":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" ("},{"type":1,"value":"inviterEmail"},{"type":0,"value":")"}],"id-invitations-service.request-access.access-details.summary-label":[{"type":0,"value":"Summary"}],"id-invitations-service.request-access.access-details.summary-text-detailed":[{"type":1,"value":"note"}],"id-invitations-service.request-access.access-details.summary-text-simple":[{"type":0,"value":"Hi, admin \uD83D\uDC4B I\'d like to use "},{"type":1,"value":"requestedProductName"},{"type":0,"value":" to collaborate with my team."}],"id-invitations-service.request-access.footer.received-as-admin":[{"type":0,"value":"You received this email because you\'re an admin for "},{"type":1,"value":"siteName"},{"type":0,"value":"."}],"id-invitations-service.request-access.footer.sent-by-atlassian":[{"type":0,"value":"This message was sent to you by Atlassian Administration."}],"id-invitations-service.request-access.header-access-details":[{"type":0,"value":"Access Details"}],"id-invitations-service.request-access.header-grant-access":[{"type":0,"value":"Grant access to "},{"type":1,"value":"product"},{"type":0,"value":"?"}],"id-invitations-service.request-access.header-requester-information":[{"type":0,"value":"Requester information"}],"id-invitations-service.request-access.header.atlassian-logo.alt-text":[{"type":0,"value":"Atlassian logo"}],"id-invitations-service.request-access.requester-details.existing-app-access-label":[{"type":0,"value":"Existing app access:"}],"id-invitations-service.request-access.requester-details.existing-apps-list":[{"type":1,"value":"existingAppsList"}],"id-invitations-service.request-access.requester-details.requester-email-only":[{"type":1,"value":"requesterEmail"}],"id-invitations-service.request-access.requester-details.requester-info":[{"type":1,"value":"requesterName"},{"type":0,"value":" ("},{"type":1,"value":"requesterEmail"},{"type":0,"value":")"}],"id-invitations-service.request-access.requester-details.who-needs-access-label":[{"type":0,"value":"Who needs access"}],"id-invitations-service.request-access.site-header.building-icon-alt":[{"type":0,"value":"Office Building icon"}],"id-invitations-service.vogue-migration-notify-admin.cta-button-new.org-admin":[{"type":0,"value":"Explore the new settings"}],"id-invitations-service.vogue-migration-notify-admin.cta-button-new.site-admin":[{"type":0,"value":"Learn more about these changes"}],"id-invitations-service.vogue-migration-notify-admin.header.org-admin":[{"type":0,"value":"Welcome to your centralized user access settings"}],"id-invitations-service.vogue-migration-notify-admin.header.site-admin":[{"type":0,"value":"We\'ve moved your site access settings"}],"id-invitations-service.vogue-migration-notify-admin.message-body-p1.org-admin":[{"type":0,"value":"We\'ve just "},{"children":[{"type":0,"value":"rolled out improvements to your site access settings"}],"type":8,"value":"link"},{"type":0,"value":". You\'ll find your organization\'s new "},{"children":[{"type":0,"value":"User access settings"}],"type":8,"value":"b"},{"type":0,"value":" at "},{"children":[{"type":0,"value":"admin.atlassian.com"}],"type":8,"value":"adminLink"},{"type":0,"value":" under Products."}],"id-invitations-service.vogue-migration-notify-admin.message-body-p1.site-admin":[{"type":0,"value":"We\'ve just rolled out changes to your site access settings. The new "},{"children":[{"type":0,"value":"User access settings"}],"type":8,"value":"b"},{"type":0,"value":" experience is now available for your Atlassian organization."}],"id-invitations-service.vogue-migration-notify-admin.message-body-p2.org-admin":[{"type":0,"value":"We\'ve centralized these settings to give you more flexibility when pre-approving email domains to access your products."}],"id-invitations-service.vogue-migration-notify-admin.message-body-p2.site-admin":[{"type":0,"value":"We\'ve centralized these settings to give your organization more flexibility when pre-approving email domains to access your products."}],"id-invitations-service.vogue-migration-notify-admin.message-body-p3.site-admin":[{"children":[{"type":0,"value":"What does this mean for me?"}],"type":8,"value":"b"}],"id-invitations-service.vogue-migration-notify-admin.message-body-p4.site-admin":[{"type":0,"value":"Site admins no longer have access to these settings, but your organization admin still has full control."}],"id-invitations-service.vogue-migration-notify-admin.pre-header-new.org-admin":[{"type":0,"value":"You\'ll now have more flexibility when approving which email domains can get access to your products."}],"id-invitations-service.vogue-migration-notify-admin.pre-header-new.site-admin":[{"type":0,"value":"We\'ve given your organization more flexibility to approve which email domains can get access to your products."}],"id-invitations-service.vogue-migration-notify-admin.subject.org-admin":[{"type":0,"value":"Improvements to your site access settings"}],"id-invitations-service.vogue-migration-notify-admin.subject.site-admin":[{"type":0,"value":"Changes to your site access settings"}],"id-invitations-service.vortex-invite-user.avatar-alt-text":[{"type":0,"value":"Inviter user avatar"}],"id-invitations-service.vortex-invite-user.button-text":[{"type":0,"value":"Join the team"}],"id-invitations-service.vortex-invite-user.header":[{"type":0,"value":"Your team is waiting for you to join them"}],"id-invitations-service.vortex-invite-user.invite-text-with-inviter":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" has invited you to collaborate on "},{"type":1,"value":"organizationName"}],"id-invitations-service.vortex-invite-user.invite-text-without-inviter":[{"type":0,"value":"You\'ve been invited to collaborate on "},{"type":1,"value":"organizationName"}],"id-invitations-service.vortex-invite-user.subject-with-inviter":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" has invited you to join them"}],"id-invitations-service.vortex-invite-user.subject-without-inviter":[{"type":0,"value":"Your team is waiting for you to join them"}],"id-invitations-service.vortex-invite-user.team-message-with-inviter":[{"type":0,"value":"Here\'s what "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" and your team are using to work seamlessly and accomplish more, together:"}],"id-invitations-service.vortex-invite-user.team-message-without-inviter":[{"type":0,"value":"Here\'s what your team are using to work seamlessly and accomplish more, together:"}],"id-invitations-service/components/InviteFooter/text":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"id-invitations-service/components/InviteFooter/unsubscribe":[{"type":0,"value":"Unsubscribe"}],"id-invitations-service/components/JoinProductFooter/admin-site-url-text":[{"type":0,"value":"You are receiving this email because you are a listed administrator of "},{"type":1,"value":"orgName"},{"type":0,"value":"."}],"id-invitations-service/components/JoinProductFooter/text":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"id-invitations-service/components/ProductComponent/analytics/description":[{"type":0,"value":"Actionable insights for agile teams"}],"id-invitations-service/components/ProductComponent/assets/description":[{"type":0,"value":"IT asset management"}],"id-invitations-service/components/ProductComponent/avocado/description":[{"type":0,"value":"Question and answer"}],"id-invitations-service/components/ProductComponent/beacon/description":[{"type":0,"value":"Security monitoring"}],"id-invitations-service/components/ProductComponent/bitbucket/description":[{"type":0,"value":"Code management and collaboration"}],"id-invitations-service/components/ProductComponent/compass/description":[{"type":0,"value":"Mission control for your distributed architecture"}],"id-invitations-service/components/ProductComponent/confluence/description":[{"type":0,"value":"Document collaboration"}],"id-invitations-service/components/ProductComponent/devai/description":[{"type":0,"value":"AI for developers"}],"id-invitations-service/components/ProductComponent/feedback/description":[{"type":0,"value":"Collect and manage feedback"}],"id-invitations-service/components/ProductComponent/jira-core/description":[{"type":0,"value":"Essential business management"}],"id-invitations-service/components/ProductComponent/jira-customer-service/description":[{"type":0,"value":"Customer service management"}],"id-invitations-service/components/ProductComponent/jira-product-discovery/description":[{"type":0,"value":"Transform product ideas into business impact"}],"id-invitations-service/components/ProductComponent/jira-servicedesk/description":[{"type":0,"value":"IT service desk and customer service"}],"id-invitations-service/components/ProductComponent/jira-software/description":[{"type":0,"value":"Project and issue tracking"}],"id-invitations-service/components/ProductComponent/jira/description":[{"type":0,"value":"Project and issue tracking"}],"id-invitations-service/components/ProductComponent/loom/description":[{"type":0,"value":"Record and share video messages"}],"id-invitations-service/components/ProductComponent/mercury/description":[{"type":0,"value":"Define strategic priorities and track progress"}],"id-invitations-service/components/ProductComponent/opsgenie/description":[{"type":0,"value":"Modern incident management"}],"id-invitations-service/components/ProductComponent/statuspage/description":[{"type":0,"value":"Incident communication"}],"id-invitations-service/components/ProductComponent/studio/description":[{"type":0,"value":"Build custom solutions with automations, agents, and apps"}],"id-invitations-service/components/ProductComponent/talent/description":[{"type":0,"value":"Strategic workforce planning"}],"id-invitations-service/components/ProductComponent/townsquare/description":[{"type":0,"value":"Your company project, goal, people and help directory"}],"id-invitations-service/components/ProductComponent/trello/description":[{"type":0,"value":"Tasks and project management"}],"id-invitations-service/components/ProductComponent/unified-help/description":[{"type":0,"value":"Help for All"}],"id-invitations-service/components/UserInfo/avatar_alt_text":[{"type":0,"value":"User avatar"}],"id-invitations-service/open_invite_notification/no_products":[{"type":0,"value":"New user at "},{"children":[{"type":1,"value":"site"}],"type":8,"value":"a"}],"id-invitations-service/open_invite_notification/user_many_products":[{"type":0,"value":"Already using "},{"type":1,"value":"products"},{"type":0,"value":" and "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"site"}],"type":8,"value":"a"}],"id-invitations-service/open_invite_notification/user_products":[{"type":0,"value":"Already using "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"site"}],"type":8,"value":"a"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-1":[{"type":0,"value":"Access request: "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" is waiting to join their team in "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-10":[{"type":0,"value":"\uD83D\uDD12 "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" requested access to "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-2":[{"type":0,"value":"Review request: "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" is asking to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-3":[{"type":1,"value":"product"},{"type":0,"value":" Access request from "},{"type":1,"value":"requesterDisplayName"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-4":[{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" is waiting - Approve their request to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-5":[{"type":0,"value":"Don\'t miss "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":"\'s request to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-6":[{"type":0,"value":"Hey "},{"type":1,"value":"adminDisplayName"},{"type":0,"value":", can "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" join their team in "},{"type":1,"value":"product"},{"type":0,"value":"?"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-7":[{"type":0,"value":"Approve "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":"\'s request to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-8":[{"type":0,"value":"Someone is requesting to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-1-3/subject-line-9":[{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" requested access to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-2/subject-line-1":[{"type":0,"value":"Access request: "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" needs "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-2/subject-line-2":[{"type":0,"value":"Review request: "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" is asking for "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-2/subject-line-3":[{"type":0,"value":"Approve "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":"\'s request for "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" to join "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-2/subject-line-4":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" requested "},{"type":1,"value":"product"},{"type":0,"value":" access for "},{"type":1,"value":"requesterDisplayName"}],"id-invitations-service/request-access/groot/ra-2/subject-line-5":[{"type":0,"value":"Someone needs access to "},{"type":1,"value":"product"}],"id-invitations-service/request-access/groot/ra-2/subject-line-6":[{"type":0,"value":"\uD83D\uDD12 "},{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" needs teammate to gain access to "},{"type":1,"value":"product"}],"id-invitations-service/request_access/approve_message_site_administration":[{"type":0,"value":"You can find and manage all your access requests in "},{"children":[{"type":0,"value":"Site administration"}],"type":8,"value":"bold"},{"type":0,"value":"."}],"id-invitations-service/request_access/approve_message_user_requests":[{"type":0,"value":"You can find and manage all your access requests in "},{"children":[{"type":0,"value":"User requests"}],"type":8,"value":"bold"},{"type":0,"value":"."}],"id-invitations-service/request_access/header-invited-user":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" has requested for "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" to join "},{"type":1,"value":"product"}],"id-invitations-service/request_access/header-user-requested-access":[{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" has requested to join "},{"type":1,"value":"product"}],"id-invitations-service/request_access/intro-invited-user":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" ("},{"type":1,"value":"inviterEmail"},{"type":0,"value":") wants "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" to join "},{"type":1,"value":"product"},{"type":0,"value":" so they can work together. Here\'s some more information about them:"}],"id-invitations-service/request_access/intro-user-requested-access":[{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" wants to join "},{"type":1,"value":"product"},{"type":0,"value":". Here\'s some more information about them:"}],"id-invitations-service/request_access/no-email":[{"type":0,"value":"No email provided"}],"id-invitations-service/request_access/no_products":[{"type":0,"value":"Doesn\'t have access to any products on "},{"type":1,"value":"siteLink"},{"type":0,"value":" yet."}],"id-invitations-service/request_access/request_access/approve-button":[{"type":0,"value":"Approve request"}],"id-invitations-service/request_access/request_access/button":[{"type":0,"value":"Review request"}],"id-invitations-service/request_access/subject":[{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" needs to join "},{"type":1,"value":"productName"}],"id-invitations-service/request_access/subject-invited":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" needs "},{"type":1,"value":"requesterDisplayName"},{"type":0,"value":" to join "},{"type":1,"value":"productName"}],"id-invitations-service/request_access/user_many_products":[{"type":0,"value":"Already using "},{"type":1,"value":"products"},{"type":0,"value":" and "},{"type":1,"value":"lastProduct"},{"type":0,"value":" on "},{"type":1,"value":"siteLink"}],"id-invitations-service/request_access/user_products":[{"type":0,"value":"Already using "},{"type":1,"value":"product"},{"type":0,"value":" on "},{"type":1,"value":"siteLink"}],"identity-mailer.components.footer.message":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}]}');

});

parcelRegister("1UYll", function(module, exports) {

let $1659d44e7462e6f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1659d44e7462e6f5$var$load("bWYgU").then(()=>parcelRequire('8St6C'));

});

parcelRegister("cfy8B", function(module, exports) {

let $8eb15dcdd7574e78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8eb15dcdd7574e78$var$load("exQXP").then(()=>parcelRequire('7bxxs'));

});

parcelRegister("8fs1k", function(module, exports) {

let $601575b7687c5ddd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $601575b7687c5ddd$var$load("1c3Ww").then(()=>parcelRequire('Tot4k'));

});

parcelRegister("iNW2L", function(module, exports) {

let $db09d3d94f7d02c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db09d3d94f7d02c9$var$load("j7DlJ").then(()=>parcelRequire('iY3Ri'));

});

parcelRegister("5BaUx", function(module, exports) {

let $4138df2550179350$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4138df2550179350$var$load("gjXs8").then(()=>parcelRequire('dJtTD'));

});

parcelRegister("EjXsI", function(module, exports) {

let $079337cc4acece07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $079337cc4acece07$var$load("lhILP").then(()=>parcelRequire('50iOV'));

});

parcelRegister("9iJHl", function(module, exports) {

let $6c593e30ae839fc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c593e30ae839fc1$var$load("7esxv").then(()=>parcelRequire('ez01T'));

});

parcelRegister("7mKep", function(module, exports) {

let $55ce731205daf821$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $55ce731205daf821$var$load("4ZMCw").then(()=>parcelRequire('dWmHN'));

});

parcelRegister("eC7ku", function(module, exports) {

let $aa3a4ccbb3f245ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa3a4ccbb3f245ad$var$load("gUe8u").then(()=>parcelRequire('dQXTa'));

});

parcelRegister("6dFgH", function(module, exports) {

let $4873f8020285d7de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4873f8020285d7de$var$load("7GB3y").then(()=>parcelRequire('aKUM4'));

});

parcelRegister("bkAt1", function(module, exports) {

let $83fdd98e8781a98b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83fdd98e8781a98b$var$load("1s7Hd").then(()=>parcelRequire('hzqzS'));

});

parcelRegister("4EhjA", function(module, exports) {

let $3628543bfd0654ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3628543bfd0654ed$var$load("dg23L").then(()=>parcelRequire('4E5V4'));

});

parcelRegister("i6ZAF", function(module, exports) {

let $d2f8901716bd70e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d2f8901716bd70e8$var$load("3pWCP").then(()=>parcelRequire('f4O4X'));

});

parcelRegister("5FTml", function(module, exports) {

let $421bb952b5523ee7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $421bb952b5523ee7$var$load("gaiCy").then(()=>parcelRequire('48w9s'));

});

parcelRegister("J7ica", function(module, exports) {

let $0879dc379d11f550$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0879dc379d11f550$var$load("gnfxo").then(()=>parcelRequire('7l7Bw'));

});

parcelRegister("aHmyb", function(module, exports) {

let $7c9f698a439596c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c9f698a439596c1$var$load("l6Hd2").then(()=>parcelRequire('eYA3P'));

});

parcelRegister("hA64x", function(module, exports) {

let $ccca82400abe0fd6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ccca82400abe0fd6$var$load("6wou2").then(()=>parcelRequire('eDg64'));

});

parcelRegister("hXBk8", function(module, exports) {

let $d134e618977a21a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d134e618977a21a1$var$load("lFo4L").then(()=>parcelRequire('bGNWc'));

});

parcelRegister("7lT2H", function(module, exports) {

let $55a530deee60b4a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $55a530deee60b4a5$var$load("eDqlZ").then(()=>parcelRequire('lRBZP'));

});

parcelRegister("duMzc", function(module, exports) {

let $9d33c010452522d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d33c010452522d3$var$load("406qt").then(()=>parcelRequire('7Btz7'));

});

parcelRegister("lWweK", function(module, exports) {

let $ff98054f37f56e8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff98054f37f56e8a$var$load("6RDdx").then(()=>parcelRequire('ldxib'));

});

parcelRegister("eEMqZ", function(module, exports) {

let $aaba5f2d8f0a5a4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aaba5f2d8f0a5a4e$var$load("2G47x").then(()=>parcelRequire('kEXiz'));

});

parcelRegister("1proA", function(module, exports) {

let $106d606fa8c4f414$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $106d606fa8c4f414$var$load("kxngW").then(()=>parcelRequire('iaS4v'));

});

parcelRegister("b5qDX", function(module, exports) {

let $8124d4337cef427c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8124d4337cef427c$var$load("fXxmU").then(()=>parcelRequire('2pIBc'));

});

parcelRegister("5Y9jh", function(module, exports) {

let $4589c71877fcb205$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4589c71877fcb205$var$load("lf9TB").then(()=>parcelRequire('eqczz'));

});

parcelRegister("iABnw", function(module, exports) {

let $d888955eda6758b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d888955eda6758b4$var$load("hTOLy").then(()=>parcelRequire('b9BgL'));

});

parcelRegister("4nI0d", function(module, exports) {

let $330b716559fd8faf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $330b716559fd8faf$var$load("jMGiY").then(()=>parcelRequire('6SwbH'));

});

parcelRegister("7cr6J", function(module, exports) {

let $53deae6143b67316$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $53deae6143b67316$var$load("c02VP").then(()=>parcelRequire('g0nxz'));

});

parcelRegister("9Zgbf", function(module, exports) {

let $74565ca5d46a5079$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $74565ca5d46a5079$var$load("c7WFB").then(()=>parcelRequire('gWa7Y'));

});

parcelRegister("kmdke", function(module, exports) {

let $ed2032e0a79d4430$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed2032e0a79d4430$var$load("jT3GY").then(()=>parcelRequire('euVFl'));

});

parcelRegister("3YuhI", function(module, exports) {

let $2e4e779c5fe0c728$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e4e779c5fe0c728$var$load("57cvc").then(()=>parcelRequire('bfxHv'));

});

parcelRegister("jE55K", function(module, exports) {

let $e4d5b3da6af170c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e4d5b3da6af170c5$var$load("3zUuJ").then(()=>parcelRequire('aWrkW'));

});

parcelRegister("jYpMo", function(module, exports) {

let $e8a79e362e33a647$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e8a79e362e33a647$var$load("eUcWs").then(()=>parcelRequire('2wnyM'));

});

parcelRegister("8DQLz", function(module, exports) {

let $64aae584d7194cd6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $64aae584d7194cd6$var$load("8k2RP").then(()=>parcelRequire('kUNgk'));

});

parcelRegister("5LXn7", function(module, exports) {
module.exports = JSON.parse('{"agent-sessions-discovery.example.current-view.ai-non-final":[{"type":0,"value":"Current simulated view: "},{"type":1,"value":"view"},{"type":0,"value":"."}],"agent-sessions-discovery.example.events.ai-non-final":[{"type":0,"value":"Pulses shown: "},{"type":1,"value":"count"},{"type":0,"value":"."}],"agent-sessions-discovery.example.navigate.ai-non-final":[{"options":{"backlog":{"value":[{"type":0,"value":"Backlog"}]},"board":{"value":[{"type":0,"value":"Board"}]},"list":{"value":[{"type":0,"value":"List"}]},"other":{"value":[{"type":0,"value":"View"}]},"timeline":{"value":[{"type":0,"value":"Timeline"}]}},"type":5,"value":"view"}],"agent-sessions-discovery.example.settings.ai-non-final":[{"type":0,"value":"View settings"}],"agent-sessions-pulse-poc.reopen.ai-non-final":[{"type":0,"value":"Reopen announcement"}],"agent-sessions-pulse-poc.view-settings.ai-non-final":[{"type":0,"value":"View settings"}],"agent-visibility-changeboarding.acknowledge":[{"type":0,"value":"Done"}],"agent-visibility-changeboarding.available-board-backlog-ready":[{"options":{"board":{"value":[{"type":0,"value":"We\u2019ve taken care of Board for you:"}]},"both":{"value":[{"type":0,"value":"We\u2019ve taken care of Board and Backlog for you:"}]},"other":{"value":[{"type":0,"value":"We\u2019ve taken care of Backlog for you:"}]}},"type":5,"value":"availableViews"}],"agent-visibility-changeboarding.available-manual-setting":[{"options":{"both":{"value":[{"type":0,"value":"Select view settings in List and Timeline to add agents:"}]},"list":{"value":[{"type":0,"value":"Select view settings in List to add agents:"}]},"other":{"value":[{"type":0,"value":"Select view settings in Timeline to add agents:"}]}},"type":5,"value":"availableViews"}],"agent-visibility-changeboarding.backlog":[{"type":0,"value":"Backlog"}],"agent-visibility-changeboarding.board":[{"type":0,"value":"Board"}],"agent-visibility-changeboarding.list":[{"type":0,"value":"List"}],"agent-visibility-changeboarding.next":[{"type":0,"value":"Next"}],"agent-visibility-changeboarding.open-view-tooltip":[{"type":0,"value":"Open "},{"type":1,"value":"view"}],"agent-visibility-changeboarding.opens-in-new-tab":[{"type":0,"value":"opens in a new tab"}],"agent-visibility-changeboarding.pause-previews":[{"type":0,"value":"Pause previews"}],"agent-visibility-changeboarding.play-previews":[{"type":0,"value":"Play previews"}],"agent-visibility-changeboarding.previous":[{"type":0,"value":"Previous"}],"agent-visibility-changeboarding.timeline":[{"type":0,"value":"Timeline"}],"agent-visibility-changeboarding.welcome-body":[{"type":0,"value":"Start and follow agent work in context at the scale you need, from a single card or column to multiple work items at once. Additionally, you can "},{"children":[{"type":0,"value":"group"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"filter"}],"type":8,"value":"b"},{"type":0,"value":" by agents."}],"agent-visibility-changeboarding.welcome-title":[{"type":0,"value":"Welcoming agentic teammates"}],"agent-visibility-changeboarding.welcome-views":[{"type":0,"value":"Agents are now available in "},{"children":[{"type":0,"value":"Board, Backlog, List"}],"type":8,"value":"b"},{"type":0,"value":" & "},{"children":[{"type":0,"value":"Timeline."}],"type":8,"value":"b"}],"jira-business-saved-views.admin.changeboarding.spotlight.body":[{"type":0,"value":"Saved views are now in timeline view.\\n\\nSave your view for everyone in the project or reset it back to your previous saved view."}],"jira-business-saved-views.admin.changeboarding.spotlight.headline":[{"type":0,"value":"Save and reset your timeline view"}],"jira-business-saved-views.admin.changeboarding.spotlight.primary-action":[{"type":0,"value":"OK"}],"jira-business-saved-views.admin.changeboarding.spotlight.secondary-action":[{"type":0,"value":"More about saved views"}],"jira-business-saved-views.changeboarding.spotlight.body":[{"type":0,"value":"Saved views are now in timeline view. Your admin set up a view to help make collaboration easier.\\n\\nYou can make changes to your view or reset to the admin\'s view anytime."}],"jira-business-saved-views.changeboarding.spotlight.headline":[{"type":0,"value":"Reset your view"}],"jira-business-saved-views.changeboarding.spotlight.primary-action":[{"type":0,"value":"OK"}],"jira-business-saved-views.changeboarding.spotlight.secondary-action":[{"type":0,"value":"More about saved views"}],"jira-filter-refinement-standalone-release-changeboarding.tour.addFieldsBody":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement-standalone-release-changeboarding.tour.addFieldsHeadline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement-standalone-release-changeboarding.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement-standalone-release-changeboarding.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement-standalone-release-changeboarding.tour.filterHomeBody":[{"type":0,"value":"More fields and more ways to surface the information that is important to you."}],"jira-filter-refinement-standalone-release-changeboarding.tour.filterHomeHeadline":[{"type":0,"value":"A new home for filters"}],"jira-filter-refinement-standalone-release-changeboarding.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement-standalone-release-changeboarding.tour.reorderPinFieldsBody":[{"type":0,"value":"Reorder and pin fields to prioritize what matters most to you."}],"jira-filter-refinement-standalone-release-changeboarding.tour.reorderPinFieldsHeadline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement-standalone-release-changeboarding.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-software-backlog-bulk-agents-changeboarding.spotlight.body":[{"type":0,"value":"Select the "},{"children":[{"type":0,"value":"Agent sessions"}],"type":8,"value":"b"},{"type":0,"value":" field to monitor agent activity."}],"jira-software-backlog-bulk-agents-changeboarding.spotlight.configureFields":[{"type":0,"value":"Configure fields"}],"jira-software-backlog-bulk-agents-changeboarding.spotlight.headline":[{"type":0,"value":"View & manage agent activity"}],"jira-software-list-bulk-agent-changeboarding.spotlight.body":[{"type":0,"value":"Select the "},{"children":[{"type":0,"value":"Agent sessions"}],"type":8,"value":"b"},{"type":0,"value":" column to monitor agent activity."}],"jira-software-list-bulk-agent-changeboarding.spotlight.configureColumns":[{"type":0,"value":"Configure columns"}],"jira-software-list-bulk-agent-changeboarding.spotlight.headline":[{"type":0,"value":"View & manage agent activity"}],"jira-software-timeline-hierarchy-changeboarding-flag.back":[{"type":0,"value":"Back"}],"jira-software-timeline-hierarchy-changeboarding-flag.done":[{"type":0,"value":"Done"}],"jira-software-timeline-hierarchy-changeboarding-flag.next":[{"type":0,"value":"Next"}],"jira-software-timeline-hierarchy-changeboarding-flag.step1.description":[{"type":0,"value":"Select the highest level of work you want to see. Zoom out for a high-level overview or drill down into the details."}],"jira-software-timeline-hierarchy-changeboarding-flag.step1.title":[{"type":0,"value":"Set your timeline level "}],"jira-software-timeline-hierarchy-changeboarding-flag.step2.description":[{"type":0,"value":"Hide items that aren\'t linked to a higher level parent to keep your timeline clean and focused on your primary goals."}],"jira-software-timeline-hierarchy-changeboarding-flag.step2.title":[{"type":0,"value":"Focus on what matters"}],"jira-software-timeline-hierarchy-changeboarding-flag.stepCount":[{"type":1,"value":"current"},{"type":0,"value":" of "},{"type":1,"value":"total"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.back":[{"type":0,"value":"Back"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.done":[{"type":0,"value":"Done"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.next":[{"type":0,"value":"Next"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.step1.description":[{"type":0,"value":"Use view settings to control exactly how your timeline looks and feels."}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.step1.title":[{"type":0,"value":"Your timeline, your way"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.step2.description":[{"type":0,"value":"Decide how hierarchy appears when filters are applied."}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.step2.title":[{"type":0,"value":"Control your hierarchy"}],"jira-software-timeline-inline-hierarchy-changeboarding-flag.stepCount":[{"type":1,"value":"current"},{"type":0,"value":" of "},{"type":1,"value":"total"}],"jira-software-timeline-m3.descriptionContentBulkOperations":[{"type":0,"value":"Edit, move, transition, watch or delete multiple work items simultaneously."}],"jira-software-timeline-m3.descriptionContentCustomizeBar":[{"type":0,"value":"Make specific work items easier to scan or highlight as a priority."}],"jira-software-timeline-m3.descriptionContentFindWork":[{"type":0,"value":"Search, filter and group work items."}],"jira-software-timeline-m3.descriptionContentSeeSubtasks":[{"type":0,"value":"They now appear under epics."}],"jira-software-timeline-m3.headingContentBulkOperations":[{"type":0,"value":"Reduce repetitive work"}],"jira-software-timeline-m3.headingContentCustomizeBar":[{"type":0,"value":"Customize bars using colors"}],"jira-software-timeline-m3.headingContentFindWork":[{"type":0,"value":"Quickly find work items"}],"jira-software-timeline-m3.headingContentSeeSubtasks":[{"type":0,"value":"See subtasks at a glance"}],"jira-software-timeline-m3.modal.closeButton":[{"type":0,"value":"Close"}],"jira-software-timeline-m3.modal.doneButton":[{"type":0,"value":"Done"}],"jira-software-timeline-m3.modal.nextButton":[{"type":0,"value":"Next"}],"jira-software-timeline-m3.timelineImprovmentsLink":[{"type":0,"value":"Read about Timeline improvements."}],"jira-yurree.jira-agent-sessions-awareness.description":[{"type":0,"value":"Find Agent Sessions in the view settings for your board, backlog, list, or timeline. Available views depend on your space."}],"jira-yurree.jira-agent-sessions-awareness.title":[{"type":0,"value":"New ways to use agents in Jira"}],"jira-yurree.jira-software-timeline-hide-top-level-changeboarding.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"jira-yurree.jira-software-timeline-hide-top-level-changeboarding.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"post-office.software-timeline-example-message-template.example-placement.cta-button.no-translate":[{"type":0,"value":"Try now"}],"post-office.software-timeline-testing.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"post-office.software-timeline-testing.main-heading.no-translate":[{"type":0,"value":"Welcome to Placements v2"}],"post-office.software-timeline-testing.test-message.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}],"timeline-10k-issues-flag.actions":[{"type":0,"value":"Learn more about the 10k limit"}],"timeline-10k-issues-flag.description":[{"type":0,"value":"Parent rollup bars in timeline have been disabled to give you a smoother performance and experience."}],"timeline-10k-issues-flag.title":[{"type":0,"value":"This space has more than 10k work items."}],"timeline-feedback-collector.spotlight.body":[{"type":0,"value":"In doing this we are keen to hear feedback from users about the timeline, what else you may want, and importantly, what you don\u2019t want."}],"timeline-feedback-collector.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"timeline-feedback-collector.spotlight.give-feedback":[{"type":0,"value":"Give feedback"}],"timeline-feedback-collector.spotlight.heading":[{"type":0,"value":"We\u2019re updating Jira timelines"}]}');

});

parcelRegister("lNvx6", function(module, exports) {

let $fde6a25d972abedb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fde6a25d972abedb$var$load("ffL9q").then(()=>parcelRequire('gUEt6'));

});

parcelRegister("gazYW", function(module, exports) {

let $bc597dc570bda84b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc597dc570bda84b$var$load("fmDnQ").then(()=>parcelRequire('8HOnL'));

});

parcelRegister("kxeq9", function(module, exports) {

let $ef321365178de3e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef321365178de3e7$var$load("3rhE8").then(()=>parcelRequire('4BUsS'));

});

parcelRegister("1IDHd", function(module, exports) {

let $1408b15176103be7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1408b15176103be7$var$load("500la").then(()=>parcelRequire('3PolQ'));

});

parcelRegister("AT11t", function(module, exports) {

let $06ee09d6ba829a83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $06ee09d6ba829a83$var$load("6b24k").then(()=>parcelRequire('4YWIe'));

});

parcelRegister("bmVIy", function(module, exports) {

let $846e854be72f8123$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846e854be72f8123$var$load("6RWRK").then(()=>parcelRequire('2bvZR'));

});

parcelRegister("c1Sw8", function(module, exports) {

let $8c1fde05a0f7c5a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c1fde05a0f7c5a8$var$load("3GnHu").then(()=>parcelRequire('2Tp3d'));

});

parcelRegister("lp3zR", function(module, exports) {

let $f94eb52c61488e8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f94eb52c61488e8a$var$load("cUvDi").then(()=>parcelRequire('fRHy9'));

});

parcelRegister("283aW", function(module, exports) {

let $18cecabbc62d81ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18cecabbc62d81ab$var$load("9w5Pu").then(()=>parcelRequire('ee5TU'));

});

parcelRegister("dZ4om", function(module, exports) {

let $a2e461080b85f102$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2e461080b85f102$var$load("dMka0").then(()=>parcelRequire('iZmVB'));

});

parcelRegister("3sUkb", function(module, exports) {

let $285fad7f9963ee92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $285fad7f9963ee92$var$load("bN59W").then(()=>parcelRequire('2uAdz'));

});

parcelRegister("jBmNc", function(module, exports) {

let $e453272139f771e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e453272139f771e3$var$load("bvlVk").then(()=>parcelRequire('fSnRF'));

});

parcelRegister("15qwh", function(module, exports) {

let $0caad458c81dd88b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0caad458c81dd88b$var$load("7UMuq").then(()=>parcelRequire('8xanX'));

});

parcelRegister("5PzhD", function(module, exports) {

let $43ed15bf1bdf985f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43ed15bf1bdf985f$var$load("g4Z5x").then(()=>parcelRequire('8AJ85'));

});

parcelRegister("7UkhN", function(module, exports) {

let $5c1d7fc57852fde6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c1d7fc57852fde6$var$load("7MFNP").then(()=>parcelRequire('flV2z'));

});

parcelRegister("2tRH7", function(module, exports) {

let $1ce7f0cf3ab9848b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ce7f0cf3ab9848b$var$load("khw6G").then(()=>parcelRequire('dvYsA'));

});

parcelRegister("e1zmU", function(module, exports) {

let $a35c981c1fe73f82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a35c981c1fe73f82$var$load("iID8O").then(()=>parcelRequire('lvPWI'));

});

parcelRegister("87I2q", function(module, exports) {

let $5ea1233603dd54e7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5ea1233603dd54e7$var$load("l4jYP").then(()=>parcelRequire('ctAD3'));

});

parcelRegister("6WREV", function(module, exports) {

let $50f1c872b89262dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $50f1c872b89262dc$var$load("jjlJY").then(()=>parcelRequire('b3QZU'));

});

parcelRegister("2sB85", function(module, exports) {

let $1caaff6f64a0fcb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1caaff6f64a0fcb2$var$load("7Fdvi").then(()=>parcelRequire('3aiGT'));

});

parcelRegister("hY2q5", function(module, exports) {

let $d149eac1a081d9b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d149eac1a081d9b2$var$load("4NvRS").then(()=>parcelRequire('8ETRV'));

});

parcelRegister("l5xuT", function(module, exports) {

let $f5a40c70fcf9483f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5a40c70fcf9483f$var$load("7OYG4").then(()=>parcelRequire('jJ8Je'));

});

parcelRegister("2ksgB", function(module, exports) {

let $1b23603da448f5eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b23603da448f5eb$var$load("1uk6L").then(()=>parcelRequire('hdPzW'));

});

parcelRegister("9cyWu", function(module, exports) {

let $6b3056e12bca434b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b3056e12bca434b$var$load("8XceY").then(()=>parcelRequire('8kAsA'));

});

parcelRegister("5UvXI", function(module, exports) {

let $44daf9b4fdeb8fc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44daf9b4fdeb8fc5$var$load("lnocA").then(()=>parcelRequire('lcwZc'));

});

parcelRegister("7zFF6", function(module, exports) {

let $583c1e7b97220452$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $583c1e7b97220452$var$load("3vIvK").then(()=>parcelRequire('i69y6'));

});

parcelRegister("6RotY", function(module, exports) {

let $4feaaf05ae1aabc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4feaaf05ae1aabc2$var$load("eZtLZ").then(()=>parcelRequire('jZd2X'));

});

parcelRegister("02GWY", function(module, exports) {

let $00818103400b22df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00818103400b22df$var$load("9qH0V").then(()=>parcelRequire('lO1fk'));

});

parcelRegister("gyLnY", function(module, exports) {

let $c0e4941a9b0ab2b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0e4941a9b0ab2b8$var$load("5odJ3").then(()=>parcelRequire('6VT5N'));

});

parcelRegister("37a11", function(module, exports) {

let $2449cb698b5ab97f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2449cb698b5ab97f$var$load("cbbXH").then(()=>parcelRequire('9UfLH'));

});

parcelRegister("gieR4", function(module, exports) {

let $bdc9d9a9ef07fc8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdc9d9a9ef07fc8f$var$load("jtvE1").then(()=>parcelRequire('k5Q6H'));

});

parcelRegister("cfoJK", function(module, exports) {

let $8eaa12f84794e7e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8eaa12f84794e7e6$var$load("7NJ03").then(()=>parcelRequire('7oVJi'));

});

parcelRegister("7MnUN", function(module, exports) {

let $5a9f911ba762f8f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a9f911ba762f8f1$var$load("d23ER").then(()=>parcelRequire('8N6FV'));

});

parcelRegister("9u4Zn", function(module, exports) {

let $6e7ac919885c9599$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e7ac919885c9599$var$load("7u6dQ").then(()=>parcelRequire('bXm86'));

});

parcelRegister("2Zd3Q", function(module, exports) {
module.exports = JSON.parse("{\"post-office.aurum.jira-assets-schemas-display-name.body\":[{\"type\":0,\"value\":\"Clarify and localise entities without breaking AQL or integrations.\"}],\"post-office.aurum.jira-assets-schemas-display-name.headline\":[{\"type\":0,\"value\":\"Display names are here\"}],\"post-office.aurum.jira-assets-schemas-display-name.primary-action\":[{\"type\":0,\"value\":\"Learn more\"}]}");

});

parcelRegister("iUZnC", function(module, exports) {

let $dc5d11c24757e6f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc5d11c24757e6f1$var$load("6pCBB").then(()=>parcelRequire('dyiz8'));

});

parcelRegister("9N4Up", function(module, exports) {

let $720c7f6eedf66d2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $720c7f6eedf66d2c$var$load("kVn0V").then(()=>parcelRequire('4Gx21'));

});

parcelRegister("1n5UH", function(module, exports) {

let $0ffc86be333e2614$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ffc86be333e2614$var$load("5DQ1z").then(()=>parcelRequire('jq72x'));

});

parcelRegister("g6ptF", function(module, exports) {

let $bb90f82aff2e8c48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb90f82aff2e8c48$var$load("LDejH").then(()=>parcelRequire('4kqQW'));

});

parcelRegister("7wcyl", function(module, exports) {

let $5795424cbbaef507$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5795424cbbaef507$var$load("2uDQw").then(()=>parcelRequire('5TQHI'));

});

parcelRegister("gRTcM", function(module, exports) {

let $c47c6b2bae4d8e30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c47c6b2bae4d8e30$var$load("5nuqb").then(()=>parcelRequire('imuHq'));

});

parcelRegister("hKBiq", function(module, exports) {

let $cec3a9c98d8bab8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cec3a9c98d8bab8b$var$load("kH60N").then(()=>parcelRequire('20dtZ'));

});

parcelRegister("3Rtoa", function(module, exports) {

let $2cfd1e542797205b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cfd1e542797205b$var$load("4xb4h").then(()=>parcelRequire('lcD9q'));

});

parcelRegister("l7W0z", function(module, exports) {

let $f6173fa1702103be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6173fa1702103be$var$load("aaCvY").then(()=>parcelRequire('k9wsA'));

});

parcelRegister("cbXiM", function(module, exports) {

let $8e048338f2087a5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e048338f2087a5e$var$load("kBHDQ").then(()=>parcelRequire('hPeXS'));

});

parcelRegister("sUJqP", function(module, exports) {

let $056e9f6342f2efa5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $056e9f6342f2efa5$var$load("gLIUa").then(()=>parcelRequire('1Njen'));

});

parcelRegister("lzFjf", function(module, exports) {

let $fb4ce911992a60b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb4ce911992a60b9$var$load("4gt8Y").then(()=>parcelRequire('6K5q2'));

});

parcelRegister("99T91", function(module, exports) {

let $6aafbad93d1d7ee1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aafbad93d1d7ee1$var$load("aJxF6").then(()=>parcelRequire('fg1MZ'));

});

parcelRegister("9M8yL", function(module, exports) {

let $71df3c82ca7ae347$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71df3c82ca7ae347$var$load("hvMwI").then(()=>parcelRequire('b6zgf'));

});

parcelRegister("bKsZA", function(module, exports) {

let $88da7ad85add128c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88da7ad85add128c$var$load("1fYNS").then(()=>parcelRequire('hKBbO'));

});

parcelRegister("4VyCo", function(module, exports) {

let $396756bec475bba7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $396756bec475bba7$var$load("8zAtc").then(()=>parcelRequire('iq87w'));

});

parcelRegister("2QyXe", function(module, exports) {

let $212b8d4dd19af914$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $212b8d4dd19af914$var$load("iRSNZ").then(()=>parcelRequire('i8DbP'));

});

parcelRegister("lKFwf", function(module, exports) {

let $fd5e19b0e605c528$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd5e19b0e605c528$var$load("7S3EG").then(()=>parcelRequire('fv9M0'));

});

parcelRegister("k14ay", function(module, exports) {

let $e927228db1153861$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e927228db1153861$var$load("bF9pH").then(()=>parcelRequire('hjyq5'));

});

parcelRegister("clUv1", function(module, exports) {

let $8fe345c72b06ee67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8fe345c72b06ee67$var$load("3RZXT").then(()=>parcelRequire('5vDId'));

});

parcelRegister("btmDe", function(module, exports) {

let $85a3f55336e9f153$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $85a3f55336e9f153$var$load("brigs").then(()=>parcelRequire('IMFGA'));

});

parcelRegister("byka9", function(module, exports) {

let $86928298bb1b8c7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86928298bb1b8c7f$var$load("1nFCT").then(()=>parcelRequire('dVXVf'));

});

parcelRegister("5ydME", function(module, exports) {

let $40aad1e0ae837d96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40aad1e0ae837d96$var$load("cXEr9").then(()=>parcelRequire('a1VQu'));

});

parcelRegister("gGpon", function(module, exports) {

let $c25443f66bfda50e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c25443f66bfda50e$var$load("6uR2i").then(()=>parcelRequire('h5Hfe'));

});

parcelRegister("9eo1c", function(module, exports) {

let $6b880d68a5084e6d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b880d68a5084e6d$var$load("uZppM").then(()=>parcelRequire('eClAU'));

});

parcelRegister("jKqGZ", function(module, exports) {

let $e60704bcd3eb4d55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e60704bcd3eb4d55$var$load("fUm6j").then(()=>parcelRequire('d13oO'));

});

parcelRegister("aK5dI", function(module, exports) {

let $7d223fe91e100691$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d223fe91e100691$var$load("9bw2v").then(()=>parcelRequire('alwPS'));

});

parcelRegister("l7CJr", function(module, exports) {

let $f6084bc28f627a3a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6084bc28f627a3a$var$load("e9YoG").then(()=>parcelRequire('leXh7'));

});

parcelRegister("bODaF", function(module, exports) {

let $89a2bfc5e5cd68c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89a2bfc5e5cd68c9$var$load("gAnNF").then(()=>parcelRequire('goKXq'));

});

parcelRegister("kZji1", function(module, exports) {

let $f47877af894602af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f47877af894602af$var$load("eLnML").then(()=>parcelRequire('aoLOs'));

});

parcelRegister("1CKFL", function(module, exports) {

let $12ed8b42f2d94c81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12ed8b42f2d94c81$var$load("bpyl4").then(()=>parcelRequire('3Bdfh'));

});

parcelRegister("bEOB5", function(module, exports) {

let $87caadb071390041$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $87caadb071390041$var$load("22cfO").then(()=>parcelRequire('d1WRJ'));

});

parcelRegister("kKovn", function(module, exports) {

let $f1ab1cb6425fd314$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1ab1cb6425fd314$var$load("ag6no").then(()=>parcelRequire('abRm9'));

});

parcelRegister("3LkYB", function(module, exports) {

let $2bd6085f5861d79f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2bd6085f5861d79f$var$load("g0rrw").then(()=>parcelRequire('9rxg1'));

});

parcelRegister("3NgrG", function(module, exports) {
module.exports = JSON.parse("{\"jira-forms-conditional-fields-changeboarding.spotlight.body.no-translate\":[{\"type\":0,\"value\":\"Create conditions to have more control over the information you receive.\"}],\"jira-forms-conditional-fields-changeboarding.spotlight.heading.no-translate\":[{\"type\":0,\"value\":\"Show fields based on previous responses\"}],\"jira-forms-conditional-fields-changeboarding.spotlight.ok.no-translate\":[{\"type\":0,\"value\":\"Ok\"}],\"jira-tanuki.jira-forms-public-forms-changeboarding-flag.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Jira Forms can now be shared publicly with anyone online. You can also customize forms by adding conditions.\"}],\"jira-tanuki.jira-forms-public-forms-changeboarding-flag.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"Public forms available now\"}],\"jira-tanuki.jira-forms-public-forms-changeboarding.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Jira Forms can now be shared publicly, so you can receive responses from anyone online and collect work for your team in real time. You can also customize forms by adding conditions and setting required fields.\"}],\"jira-tanuki.jira-forms-public-forms-changeboarding.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"Public forms available now\"}],\"jira-tanuki.jira-in-context-config-sidebar-changeboarding.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"From the \"},{\"children\":[{\"type\":0,\"value\":\"All work\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" tab, you can now use currency or percentage formatting for a number field.\"}],\"jira-tanuki.jira-in-context-config-sidebar-changeboarding.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"Introducing currency formatting\"}]}");

});

parcelRegister("7UFKR", function(module, exports) {

let $5c2e26fcf18a1da5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c2e26fcf18a1da5$var$load("iqwP8").then(()=>parcelRequire('cR9fY'));

});

parcelRegister("7xrR7", function(module, exports) {

let $57d1390ce3ad00e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57d1390ce3ad00e8$var$load("8nWCM").then(()=>parcelRequire('6HeYS'));

});

parcelRegister("5x31x", function(module, exports) {

let $40726144b4435ac2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40726144b4435ac2$var$load("dAkfP").then(()=>parcelRequire('9dOeR'));

});

parcelRegister("irJXn", function(module, exports) {

let $d6de65aae9098e8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6de65aae9098e8f$var$load("fpb0q").then(()=>parcelRequire('7Gkdd'));

});

parcelRegister("aj07G", function(module, exports) {

let $780bc61e2ad356d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $780bc61e2ad356d6$var$load("1FB5D").then(()=>parcelRequire('b6JYG'));

});

parcelRegister("5KdSc", function(module, exports) {

let $42ec029075f3d039$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42ec029075f3d039$var$load("8DCST").then(()=>parcelRequire('jZoyS'));

});

parcelRegister("elzTc", function(module, exports) {

let $a71eddbc355ada65$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a71eddbc355ada65$var$load("kaRj4").then(()=>parcelRequire('iDavy'));

});

parcelRegister("jpvXg", function(module, exports) {

let $e21923b73923d475$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e21923b73923d475$var$load("amBK5").then(()=>parcelRequire('2OPDq'));

});

parcelRegister("iyt6Y", function(module, exports) {

let $d821fbec99bb9376$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d821fbec99bb9376$var$load("eU8Xq").then(()=>parcelRequire('cexM8'));

});

parcelRegister("kGz6V", function(module, exports) {

let $03e2e2f4439b00f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03e2e2f4439b00f0$var$load("3dvXG").then(()=>parcelRequire('2UJi7'));

});

parcelRegister("feZ8g", function(module, exports) {

let $b187956f1d5d09cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b187956f1d5d09cb$var$load("6QR3R").then(()=>parcelRequire('61S0g'));

});

parcelRegister("Gh97v", function(module, exports) {

let $07f1393763a58e69$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07f1393763a58e69$var$load("cNz9w").then(()=>parcelRequire('934zW'));

});

parcelRegister("lQTvq", function(module, exports) {

let $fe89829883f7b554$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe89829883f7b554$var$load("cAwkO").then(()=>parcelRequire('g5D5L'));

});

parcelRegister("j0D9N", function(module, exports) {

let $dd6c64268ac452d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dd6c64268ac452d0$var$load("bxhDL").then(()=>parcelRequire('l2sCl'));

});

parcelRegister("7u6a1", function(module, exports) {

let $57301d1eef027105$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57301d1eef027105$var$load("7Ep8d").then(()=>parcelRequire('25rei'));

});

parcelRegister("78jBd", function(module, exports) {

let $53187bc0964e4b5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $53187bc0964e4b5c$var$load("ayZ37").then(()=>parcelRequire('etnRk'));

});

parcelRegister("kk9UR", function(module, exports) {

let $ecbd5e049b16e7a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecbd5e049b16e7a0$var$load("f2tuW").then(()=>parcelRequire('cx1Jy'));

});

parcelRegister("p0vY1", function(module, exports) {

let $04b2bc1a3b6a2a82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $04b2bc1a3b6a2a82$var$load("g6ZPm").then(()=>parcelRequire('2JsVa'));

});

parcelRegister("5Z0g7", function(module, exports) {

let $45b2d9ad58ff4dc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45b2d9ad58ff4dc5$var$load("jirLe").then(()=>parcelRequire('cNtYP'));

});

parcelRegister("5i3XF", function(module, exports) {

let $3da1b4d155ab08f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3da1b4d155ab08f4$var$load("9N0t2").then(()=>parcelRequire('c8tBI'));

});

parcelRegister("aVvtu", function(module, exports) {

let $7f47a4725dee1a3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f47a4725dee1a3f$var$load("OrFMi").then(()=>parcelRequire('lKjg0'));

});

parcelRegister("7Fvbt", function(module, exports) {

let $59548d413b52e863$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $59548d413b52e863$var$load("dbdyp").then(()=>parcelRequire('iyYNP'));

});

parcelRegister("2RDu2", function(module, exports) {

let $215f289533ec0762$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $215f289533ec0762$var$load("8LUfP").then(()=>parcelRequire('jivQS'));

});

parcelRegister("c2ndM", function(module, exports) {

let $8c37af380ebb94b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c37af380ebb94b1$var$load("cC5vO").then(()=>parcelRequire('5WBjM'));

});

parcelRegister("gUTaH", function(module, exports) {

let $c50cac405b2010ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c50cac405b2010ab$var$load("wwMNk").then(()=>parcelRequire('8NPvM'));

});

parcelRegister("lCWMS", function(module, exports) {

let $fbeabf8869e9dc35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fbeabf8869e9dc35$var$load("4XzxG").then(()=>parcelRequire('3BIWQ'));

});

parcelRegister("hm9Dy", function(module, exports) {

let $ca2bf76bffcabdb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca2bf76bffcabdb9$var$load("c9EY5").then(()=>parcelRequire('2pgm7'));

});

parcelRegister("3ONYW", function(module, exports) {

let $2c7ccffada1f688f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c7ccffada1f688f$var$load("94fYc").then(()=>parcelRequire('3uu6I'));

});

parcelRegister("hRI0p", function(module, exports) {

let $d01985862b692ea2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d01985862b692ea2$var$load("jC3rz").then(()=>parcelRequire('cSW0X'));

});

parcelRegister("gTtok", function(module, exports) {

let $c4c894e5cda34eb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4c894e5cda34eb8$var$load("bqITJ").then(()=>parcelRequire('8PH7O'));

});

parcelRegister("hb44P", function(module, exports) {

let $c816a054c6420895$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c816a054c6420895$var$load("8FBa8").then(()=>parcelRequire('emErc'));

});

parcelRegister("hX03y", function(module, exports) {

let $d117fd869ae67ef6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d117fd869ae67ef6$var$load("1zA7i").then(()=>parcelRequire('aG699'));

});

parcelRegister("fYaiw", function(module, exports) {

let $ba047289be234b43$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba047289be234b43$var$load("8kOTu").then(()=>parcelRequire('gv1yu'));

});

parcelRegister("6VwSN", function(module, exports) {

let $50b192c47b48678c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $50b192c47b48678c$var$load("g3dJ1").then(()=>parcelRequire('6mMuG'));

});

parcelRegister("bEUWX", function(module, exports) {
module.exports = JSON.parse("{\"gnin.fps-redirect.changeboarding.description\":[{\"type\":0,\"value\":\"Looking for more? Switch to find results and answers from all your Atlassian and connected apps.\"}],\"gnin.fps-redirect.changeboarding.primary-button\":[{\"type\":0,\"value\":\"Got it\"}],\"gnin.fps-redirect.changeboarding.title\":[{\"type\":0,\"value\":\"Switch to search beyond Jira\"}],\"post-office.quick-find-spotlight.spotlight-body-1\":[{\"type\":0,\"value\":\"Apply a mix of filters to narrow down results.\"}],\"post-office.quick-find-spotlight.spotlight-body-2\":[{\"type\":0,\"value\":\"Search only Jira, or expand across all your Atlassian and connected apps.\"}],\"post-office.quick-find-spotlight.spotlight-button-done\":[{\"type\":0,\"value\":\"Done\"}],\"post-office.quick-find-spotlight.spotlight-button-next\":[{\"type\":0,\"value\":\"Next\"}],\"post-office.quick-find-spotlight.spotlight-heading-1\":[{\"type\":0,\"value\":\"Filter for what you need\"}],\"post-office.quick-find-spotlight.spotlight-heading-2\":[{\"type\":0,\"value\":\"Choose where to search\"}],\"search-page.gnin-redirect.changeboarding.back-button\":[{\"type\":0,\"value\":\"Back\"}],\"search-page.gnin-redirect.changeboarding.next-button\":[{\"type\":0,\"value\":\"Next\"}],\"search-page.gnin-redirect.changeboarding.primary-button\":[{\"type\":0,\"value\":\"Got it\"}],\"search-page.gnin-redirect.changeboarding.step-label\":[{\"type\":1,\"value\":\"current\"},{\"type\":0,\"value\":\" of \"},{\"type\":1,\"value\":\"total\"}],\"search-page.gnin-redirect.changeboarding.step1.description\":[{\"type\":0,\"value\":\"Your results may come from all your apps or just Jira, depending on your search terms.\"}],\"search-page.gnin-redirect.changeboarding.step1.image-alt\":[{\"type\":0,\"value\":\"Rovo full page search smart AI answer illustration\"}],\"search-page.gnin-redirect.changeboarding.step1.title\":[{\"type\":0,\"value\":\"Search that adapts to you\"}],\"search-page.gnin-redirect.changeboarding.step2.description\":[{\"type\":0,\"value\":\"You can switch anytime to search Jira work items (including JQL).\"}],\"search-page.gnin-redirect.changeboarding.step2.image-alt\":[{\"type\":0,\"value\":\"Rovo full page search illustration\"}],\"search-page.gnin-redirect.changeboarding.step2.title\":[{\"type\":0,\"value\":\"Switch your view anytime\"}],\"search-plex.jira-quick-find-intent-detection-changeboarding.description.no-translate\":[{\"type\":0,\"value\":\"Quick find intent detection test message.\"}],\"search-plex.jira-quick-find-intent-detection-changeboarding.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}]}");

});

parcelRegister("2RLjC", function(module, exports) {

let $21653be28f725bfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21653be28f725bfe$var$load("cHK32").then(()=>parcelRequire('97vpA'));

});

parcelRegister("dGu50", function(module, exports) {

let $9f6687ce65b92ba0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f6687ce65b92ba0$var$load("3bxQs").then(()=>parcelRequire('6cqls'));

});

parcelRegister("aOiiW", function(module, exports) {

let $7decc5d0283a3961$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7decc5d0283a3961$var$load("iH1Vh").then(()=>parcelRequire('i9vg1'));

});

parcelRegister("funYt", function(module, exports) {

let $b46c412531f82f5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b46c412531f82f5a$var$load("gSoco").then(()=>parcelRequire('1omd8'));

});

parcelRegister("i24EM", function(module, exports) {

let $d20c069aef7697b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d20c069aef7697b4$var$load("k7cv3").then(()=>parcelRequire('kDgIv'));

});

parcelRegister("jhXoI", function(module, exports) {

let $e0adae02d38ca9a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e0adae02d38ca9a4$var$load("emn3F").then(()=>parcelRequire('35djh'));

});

parcelRegister("L5WWk", function(module, exports) {

let $08d9016022c0d896$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $08d9016022c0d896$var$load("7T7dD").then(()=>parcelRequire('kJc0Z'));

});

parcelRegister("h0oUr", function(module, exports) {

let $c615c238f8230e88$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c615c238f8230e88$var$load("8umAl").then(()=>parcelRequire('kSRpm'));

});

parcelRegister("13Wsv", function(module, exports) {

let $0c636af48e62cb47$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c636af48e62cb47$var$load("1CmfX").then(()=>parcelRequire('diBX0'));

});

parcelRegister("gVqQl", function(module, exports) {

let $c526cabe09ffb51a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c526cabe09ffb51a$var$load("89Bhf").then(()=>parcelRequire('dgqCg'));

});

parcelRegister("aSf2F", function(module, exports) {

let $7eaa9d911032e182$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7eaa9d911032e182$var$load("l6Lby").then(()=>parcelRequire('a3Njm'));

});

parcelRegister("iaMoz", function(module, exports) {

let $d3aeb37756df8646$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3aeb37756df8646$var$load("hIIHZ").then(()=>parcelRequire('dzl2R'));

});

parcelRegister("cpDmt", function(module, exports) {

let $90965a35c91deaea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90965a35c91deaea$var$load("4kNi5").then(()=>parcelRequire('bM7JN'));

});

parcelRegister("1Crzy", function(module, exports) {

let $12deba5f042da86c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12deba5f042da86c$var$load("7w0NZ").then(()=>parcelRequire('kBEk1'));

});

parcelRegister("2NSFh", function(module, exports) {

let $20aa8fafe7b6689b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20aa8fafe7b6689b$var$load("lilq5").then(()=>parcelRequire('iVTZa'));

});

parcelRegister("2Durl", function(module, exports) {

let $1eb6d605dad83707$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1eb6d605dad83707$var$load("j4mjo").then(()=>parcelRequire('k6NDD'));

});

parcelRegister("2fH5g", function(module, exports) {

let $1a3e670a17a5ae44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1a3e670a17a5ae44$var$load("3kAYj").then(()=>parcelRequire('32JtS'));

});

parcelRegister("de9J4", function(module, exports) {

let $9a142087c9eaf836$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a142087c9eaf836$var$load("1nYUd").then(()=>parcelRequire('7JZv5'));

});

parcelRegister("2w5Qd", function(module, exports) {

let $1d5319e0f30125ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1d5319e0f30125ab$var$load("1qvAs").then(()=>parcelRequire('dpCjt'));

});

parcelRegister("ht60R", function(module, exports) {

let $cb79cf1f78c52260$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb79cf1f78c52260$var$load("jD1h4").then(()=>parcelRequire('6jMfg'));

});

parcelRegister("l8Lmn", function(module, exports) {

let $f63f1509be12ab12$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f63f1509be12ab12$var$load("c03Vk").then(()=>parcelRequire('8jROn'));

});

parcelRegister("e07cw", function(module, exports) {

let $a316a6bb73b8b009$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a316a6bb73b8b009$var$load("dWG3o").then(()=>parcelRequire('3X6zI'));

});

parcelRegister("jKS37", function(module, exports) {

let $e61c3d3ea0a2de8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e61c3d3ea0a2de8d$var$load("bQ2Kg").then(()=>parcelRequire('7PjED'));

});

parcelRegister("cdolv", function(module, exports) {

let $8e49958034e5728e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e49958034e5728e$var$load("duvLw").then(()=>parcelRequire('S3xVJ'));

});

parcelRegister("eDzD9", function(module, exports) {

let $aa8058af4e74a3ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aa8058af4e74a3ea$var$load("8qNMQ").then(()=>parcelRequire('3iotu'));

});

parcelRegister("2mx5U", function(module, exports) {

let $1b874eaa8ba63bbd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b874eaa8ba63bbd$var$load("dNYjV").then(()=>parcelRequire('4imFK'));

});

parcelRegister("1PMkZ", function(module, exports) {

let $15600cad976edbfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $15600cad976edbfa$var$load("32TIL").then(()=>parcelRequire('kdnv1'));

});

parcelRegister("hWVm9", function(module, exports) {

let $d114582f0ecfa392$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d114582f0ecfa392$var$load("4k4DB").then(()=>parcelRequire('2Bci7'));

});

parcelRegister("jSqbS", function(module, exports) {

let $e787605956345cfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e787605956345cfa$var$load("3hRC4").then(()=>parcelRequire('1JfdL'));

});

parcelRegister("1VVPw", function(module, exports) {

let $1687f920947107f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1687f920947107f9$var$load("cMWPa").then(()=>parcelRequire('f2zu1'));

});

parcelRegister("3xs7D", function(module, exports) {

let $293a44a4d90a99d2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $293a44a4d90a99d2$var$load("7nNMy").then(()=>parcelRequire('48pWg'));

});

parcelRegister("dNusO", function(module, exports) {

let $a0b77b71f61a3689$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0b77b71f61a3689$var$load("6YMb9").then(()=>parcelRequire('1W4wY'));

});

parcelRegister("dilgY", function(module, exports) {

let $9add751bd0e6f3fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9add751bd0e6f3fc$var$load("5YJ3b").then(()=>parcelRequire('9GMD8'));

});

parcelRegister("7sfMS", function(module, exports) {

let $56d764f58e2caf97$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56d764f58e2caf97$var$load("lbbXI").then(()=>parcelRequire('5bnnd'));

});

parcelRegister("yNAPT", function(module, exports) {
module.exports = JSON.parse("{\"jira-glance-panel-navigation-arrows.spotlight.body\":[{\"type\":0,\"value\":\"View your work in a side panel or modal, and navigate both contextually.\"}],\"jira-glance-panel-navigation-arrows.spotlight.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-glance-panel-navigation-arrows.spotlight.headline\":[{\"type\":0,\"value\":\"Control how you view work\"}],\"jira-glance-panel-navigation-arrows.spotlight.image-alt\":[{\"type\":0,\"value\":\"Navigation arrows on the glance panel\"}],\"jira-glance-panel-navigation-arrows.spotlight.primary-action\":[{\"type\":0,\"value\":\"OK\"}],\"jira-work-item-view-native-projects-field.body\":[{\"type\":0,\"value\":\"Your existing project connections have moved to the new field. Nothing to set up.\"}],\"jira-work-item-view-native-projects-field.button.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-work-item-view-native-projects-field.button.done\":[{\"type\":0,\"value\":\"Got it\"}],\"jira-work-item-view-native-projects-field.headline\":[{\"type\":0,\"value\":\"Projects are now part of Jira\"}],\"jira-work-item-view-native-projects-field.image-alt\":[{\"type\":0,\"value\":\"Illustration showing a native Atlas project smart card pointing to the project interface\"}],\"jira-work-item-view-native-projects-field.tp.body\":[{\"type\":0,\"value\":\"Connect your work to a project, track progress, and easily share updates.\"}],\"jira-work-item-view-native-projects-field.tp.button.dismiss\":[{\"type\":0,\"value\":\"Dismiss\"}],\"jira-work-item-view-native-projects-field.tp.button.done\":[{\"type\":0,\"value\":\"Try Projects\"}],\"jira-work-item-view-native-projects-field.tp.headline\":[{\"type\":0,\"value\":\"Share updates with Projects\"}],\"jira-work-item-view-native-projects-field.tp.image-alt\":[{\"type\":0,\"value\":\"Illustration showing the new Projects field in the Jira work item view, ready to connect work to a project\"}]}");

});

parcelRegister("at6ge", function(module, exports) {

let $79f178108ab18d07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79f178108ab18d07$var$load("cPx82").then(()=>parcelRequire('4hxe6'));

});

parcelRegister("h3LQV", function(module, exports) {

let $c6b7d6093eebdc1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6b7d6093eebdc1c$var$load("jmw3U").then(()=>parcelRequire('hM9EQ'));

});

parcelRegister("iDANl", function(module, exports) {

let $d918693b8dc072bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d918693b8dc072bf$var$load("jIY8J").then(()=>parcelRequire('gaGff'));

});

parcelRegister("bsAiM", function(module, exports) {

let $857e78062daffadf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857e78062daffadf$var$load("6Im4e").then(()=>parcelRequire('423mv'));

});

parcelRegister("6lyYa", function(module, exports) {

let $49efd474e2bf0f7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49efd474e2bf0f7b$var$load("LkFfU").then(()=>parcelRequire('iEoTz'));

});

parcelRegister("8qi8n", function(module, exports) {

let $621ed17838251034$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $621ed17838251034$var$load("1pIYU").then(()=>parcelRequire('aJQZ1'));

});

parcelRegister("6XkOd", function(module, exports) {

let $510865024b64a943$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $510865024b64a943$var$load("8uldz").then(()=>parcelRequire('h6kf3'));

});

parcelRegister("d67Hj", function(module, exports) {

let $9891ce762bd21c08$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9891ce762bd21c08$var$load("gsBNh").then(()=>parcelRequire('eZokD'));

});

parcelRegister("1keZ4", function(module, exports) {

let $0f73483179005c93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f73483179005c93$var$load("2JDUr").then(()=>parcelRequire('8cRf6'));

});

parcelRegister("2nKnU", function(module, exports) {

let $1bc1b5c06d1c1687$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1bc1b5c06d1c1687$var$load("ct4Di").then(()=>parcelRequire('2h44e'));

});

parcelRegister("gWLXI", function(module, exports) {

let $c5674465eb5a96e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5674465eb5a96e5$var$load("ldiqw").then(()=>parcelRequire('4oKje'));

});

parcelRegister("1BDAL", function(module, exports) {

let $12b7f54f53aa7859$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12b7f54f53aa7859$var$load("gZpRF").then(()=>parcelRequire('5iuuv'));

});

parcelRegister("jtjTT", function(module, exports) {

let $e2d02998bb39a6e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e2d02998bb39a6e6$var$load("eW0Rv").then(()=>parcelRequire('8DqwB'));

});

parcelRegister("e1N2p", function(module, exports) {

let $a3673290bdaad900$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3673290bdaad900$var$load("gh5bR").then(()=>parcelRequire('5sDgs'));

});

parcelRegister("9lyX3", function(module, exports) {

let $6ce12fdd5399002d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ce12fdd5399002d$var$load("gGssw").then(()=>parcelRequire('lJYd4'));

});

parcelRegister("dTUIP", function(module, exports) {

let $a1ec69364dc0b553$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1ec69364dc0b553$var$load("1umq9").then(()=>parcelRequire('e17RD'));

});

parcelRegister("04MZU", function(module, exports) {

let $00e661b848004445$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00e661b848004445$var$load("1oqKK").then(()=>parcelRequire('2SIpH'));

});

parcelRegister("dVWXL", function(module, exports) {

let $a24e560c6f43d315$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a24e560c6f43d315$var$load("1q3a9").then(()=>parcelRequire('8EwCw'));

});

parcelRegister("a8PaN", function(module, exports) {

let $762258a9de3bd80d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $762258a9de3bd80d$var$load("72nL8").then(()=>parcelRequire('cFX9N'));

});

parcelRegister("jCefS", function(module, exports) {

let $e47c9fb3ba1433a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e47c9fb3ba1433a8$var$load("6euaV").then(()=>parcelRequire('ZsA5q'));

});

parcelRegister("9V8bE", function(module, exports) {

let $738fc9b0ab0518a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $738fc9b0ab0518a5$var$load("caRmm").then(()=>parcelRequire('f6VVd'));

});

parcelRegister("1mMbt", function(module, exports) {

let $0fed38d8bc66260e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fed38d8bc66260e$var$load("6zNJe").then(()=>parcelRequire('a5gXS'));

});

parcelRegister("1F49G", function(module, exports) {

let $135cd7e38ba6aa28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $135cd7e38ba6aa28$var$load("f3j46").then(()=>parcelRequire('kphPq'));

});

parcelRegister("a7MkY", function(module, exports) {

let $75f00d9b6aec54b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $75f00d9b6aec54b8$var$load("eOjuo").then(()=>parcelRequire('8VrZ8'));

});

parcelRegister("c736q", function(module, exports) {

let $8d188b9daf0f36dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d188b9daf0f36dd$var$load("gohsw").then(()=>parcelRequire('63W9D'));

});

parcelRegister("fYv7t", function(module, exports) {

let $ba14994d805741a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba14994d805741a1$var$load("3mUOz").then(()=>parcelRequire('2sa3n'));

});

parcelRegister("5GFdo", function(module, exports) {

let $4240d86d4cf5cefc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4240d86d4cf5cefc$var$load("3M9cg").then(()=>parcelRequire('3Zxzs'));

});

parcelRegister("aBTMj", function(module, exports) {

let $7b98a08097656745$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7b98a08097656745$var$load("fZZSN").then(()=>parcelRequire('d0QDj'));

});

parcelRegister("bDOVy", function(module, exports) {

let $879ad759a198f9b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $879ad759a198f9b1$var$load("Iwd00").then(()=>parcelRequire('1rAfd'));

});

parcelRegister("euBtw", function(module, exports) {

let $a8d0efd2a242ca44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a8d0efd2a242ca44$var$load("aUyl6").then(()=>parcelRequire('jXJDf'));

});

parcelRegister("cMpDF", function(module, exports) {

let $94dddb0d6bbc4b6c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $94dddb0d6bbc4b6c$var$load("6rAtd").then(()=>parcelRequire('dWZ0T'));

});

parcelRegister("cPYe2", function(module, exports) {

let $9588f6f21593c378$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9588f6f21593c378$var$load("dcGu1").then(()=>parcelRequire('bS1nb'));

});

parcelRegister("fgCrG", function(module, exports) {

let $b1d62c189c3d1af1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1d62c189c3d1af1$var$load("h2u4q").then(()=>parcelRequire('77uPd'));

});

parcelRegister("hkOdi", function(module, exports) {

let $c9eb41419735db42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9eb41419735db42$var$load("lNJhK").then(()=>parcelRequire('2HGNz'));

});

parcelRegister("fyclM", function(module, exports) {
module.exports = JSON.parse('{"post-office.attachment-consolidation-add-create.spotlight.body":[{"type":0,"value":"Find your pages, videos, and files in one place. You can search for existing content or upload new files directly."}],"post-office.attachment-consolidation-add-create.spotlight.got-it":[{"type":0,"value":"Got it"}],"post-office.attachment-consolidation-add-create.spotlight.headline":[{"type":0,"value":"Confluence and Loom are now in Attachments"}],"post-office.jira-issue-view-contextual-survey.dismiss-label":[{"type":0,"value":"Dismiss survey"}],"post-office.jira-issue-view-contextual-survey.highest-score-label":[{"type":0,"value":"Very easy"}],"post-office.jira-issue-view-contextual-survey.lowest-score-label":[{"type":0,"value":"Not very easy"}],"post-office.jira-issue-view-contextual-survey.question":[{"type":0,"value":"We\u2019d love to hear from you"}],"post-office.jira-issue-view-contextual-survey.scale-button-label":[{"type":1,"value":"score"},{"type":0,"value":" out of 5"}],"post-office.jira-issue-view-contextual-survey.statement":[{"type":0,"value":"How easy is it to get work done in this view?"}],"post-office.jira-issue-view-contextual-survey.submit-label":[{"type":0,"value":"Submit"}],"post-office.jira-issue-view-contextual-survey.text-description":[{"type":0,"value":"Your feedback will be used to improve our products."}],"post-office.jira-issue-view-contextual-survey.text-label":[{"type":0,"value":"What influenced your rating? (optional)"}],"post-office.jira-issue-view-contextual-survey.thank-you":[{"type":0,"value":"Thanks for your feedback"}]}');

});

parcelRegister("cGd1k", function(module, exports) {

let $93b381d76b95e833$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $93b381d76b95e833$var$load("cdpBA").then(()=>parcelRequire('6LAvj'));

});

parcelRegister("3HDjE", function(module, exports) {

let $2b23e29a91ebb6e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b23e29a91ebb6e6$var$load("kDqdQ").then(()=>parcelRequire('iMThV'));

});

parcelRegister("hAAl0", function(module, exports) {

let $cce1fc6187654d32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cce1fc6187654d32$var$load("bfJHQ").then(()=>parcelRequire('gkqjf'));

});

parcelRegister("ky6Rt", function(module, exports) {

let $ef5c4e261239d155$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef5c4e261239d155$var$load("wk5oE").then(()=>parcelRequire('8b5so'));

});

parcelRegister("aU26J", function(module, exports) {

let $7f00c4dd708118b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f00c4dd708118b9$var$load("8MTmw").then(()=>parcelRequire('dDCfi'));

});

parcelRegister("4FonW", function(module, exports) {

let $365de827786c9700$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $365de827786c9700$var$load("dNgq6").then(()=>parcelRequire('kZIz1'));

});

parcelRegister("6uKj4", function(module, exports) {

let $4ba976f668204103$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ba976f668204103$var$load("lyCUB").then(()=>parcelRequire('54zFO'));

});

parcelRegister("3tAQa", function(module, exports) {

let $2880a83e99ead708$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2880a83e99ead708$var$load("hdwzT").then(()=>parcelRequire('95Tgt'));

});

parcelRegister("1HVDx", function(module, exports) {

let $13e68409d80b942e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13e68409d80b942e$var$load("2LUAT").then(()=>parcelRequire('krj0u'));

});

parcelRegister("9CafP", function(module, exports) {

let $6fff9df531b8d666$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fff9df531b8d666$var$load("d3NsJ").then(()=>parcelRequire('fkI6f'));

});

parcelRegister("6ltLd", function(module, exports) {

let $49ebca0fa3253ab9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49ebca0fa3253ab9$var$load("gezlD").then(()=>parcelRequire('fdaQW'));

});

parcelRegister("i16Fe", function(module, exports) {

let $d1dd7d4e847eee83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1dd7d4e847eee83$var$load("fMJgW").then(()=>parcelRequire('hFmfH'));

});

parcelRegister("6r2ld", function(module, exports) {

let $4af714989f672f83$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4af714989f672f83$var$load("b3qLT").then(()=>parcelRequire('jQmuA'));

});

parcelRegister("kf1O9", function(module, exports) {

let $ebc69c5a0b9a6098$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ebc69c5a0b9a6098$var$load("hkRB5").then(()=>parcelRequire('jZ5Re'));

});

parcelRegister("b4nzq", function(module, exports) {

let $80f25a0577d579e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80f25a0577d579e8$var$load("hU08q").then(()=>parcelRequire('1dLFm'));

});

parcelRegister("ljPEV", function(module, exports) {

let $f85371b716abd4b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f85371b716abd4b6$var$load("6T4uM").then(()=>parcelRequire('i2jiX'));

});

parcelRegister("8KduJ", function(module, exports) {

let $65dd165aca026ca8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65dd165aca026ca8$var$load("eHweH").then(()=>parcelRequire('8NaJc'));

});

parcelRegister("hMJjt", function(module, exports) {

let $cf2a1197cae8ed6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf2a1197cae8ed6f$var$load("aO1ri").then(()=>parcelRequire('gOPsU'));

});

parcelRegister("40c6r", function(module, exports) {

let $2ea08ce46248e367$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2ea08ce46248e367$var$load("6E1jP").then(()=>parcelRequire('10L4G'));

});

parcelRegister("6LxVi", function(module, exports) {

let $4ed1724840812fa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ed1724840812fa3$var$load("42LBe").then(()=>parcelRequire('9CqS1'));

});

parcelRegister("7p3Ya", function(module, exports) {

let $563df276cb808438$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $563df276cb808438$var$load("jY5FA").then(()=>parcelRequire('7TJiG'));

});

parcelRegister("dIGoT", function(module, exports) {

let $9fd04645058aab7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9fd04645058aab7e$var$load("hmx8U").then(()=>parcelRequire('jeoCN'));

});

parcelRegister("aX1s8", function(module, exports) {

let $7f908a95adc004c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f908a95adc004c0$var$load("am7EO").then(()=>parcelRequire('4hdme'));

});

parcelRegister("c3rCu", function(module, exports) {

let $8c6b308dce44e2f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c6b308dce44e2f4$var$load("gJgz9").then(()=>parcelRequire('8G00A'));

});

parcelRegister("dVLoB", function(module, exports) {

let $a2455d07f8d23c6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2455d07f8d23c6f$var$load("ecpU2").then(()=>parcelRequire('aDeUo'));

});

parcelRegister("j5CRW", function(module, exports) {

let $de5ca2882f6e68d6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de5ca2882f6e68d6$var$load("jk6JR").then(()=>parcelRequire('bjaXE'));

});

parcelRegister("lg8vL", function(module, exports) {

let $f7a1b1ca7d5a8ed7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7a1b1ca7d5a8ed7$var$load("fIF1Z").then(()=>parcelRequire('lyQOo'));

});

parcelRegister("9jSrV", function(module, exports) {

let $6c901ff0c6999c70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c901ff0c6999c70$var$load("pse3c").then(()=>parcelRequire('b5CQZ'));

});

parcelRegister("92SVU", function(module, exports) {

let $695ee98177f70b55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $695ee98177f70b55$var$load("haODU").then(()=>parcelRequire('6R04P'));

});

parcelRegister("aghh8", function(module, exports) {

let $7788cc88aef11ff8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7788cc88aef11ff8$var$load("cehMQ").then(()=>parcelRequire('fnCRV'));

});

parcelRegister("kksE6", function(module, exports) {

let $eccbe55b8e307df5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eccbe55b8e307df5$var$load("a3uJJ").then(()=>parcelRequire('6Mo1N'));

});

parcelRegister("2Di42", function(module, exports) {

let $1ead3c70427089b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ead3c70427089b1$var$load("kEI64").then(()=>parcelRequire('bzsMv'));

});

parcelRegister("mhkYP", function(module, exports) {

let $042f810885b0d1b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $042f810885b0d1b8$var$load("2KjDN").then(()=>parcelRequire('1lLHB'));

});

parcelRegister("bAQal", function(module, exports) {

let $870b8591c0267912$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $870b8591c0267912$var$load("gOkzU").then(()=>parcelRequire('fiapf'));

});

parcelRegister("c8Pyb", function(module, exports) {
module.exports = JSON.parse('{"growth-jira-onboarding.Contact-us":[{"type":0,"value":"Contact us"}],"growth-jira-onboarding.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"growth-jira-onboarding.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"growth-jira-onboarding.footer.dot-separator":[{"type":0,"value":"\u2022"}],"growth-jira-onboarding.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"growth-jira-onboarding.footer.facebook-title":[{"type":0,"value":"Facebook"}],"growth-jira-onboarding.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"growth-jira-onboarding.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"growth-jira-onboarding.footer.footer-links.read-our-blog":[{"type":1,"value":"thirdText"}],"growth-jira-onboarding.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"growth-jira-onboarding.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"growth-jira-onboarding.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"growth-jira-onboarding.footer.privacy-policy":[{"type":0,"value":"Privacy Policy"}],"growth-jira-onboarding.footer.read-our-blog":[{"type":0,"value":"Read our blog"}],"growth-jira-onboarding.footer.x-alt-text":[{"type":0,"value":"X"}],"growth-jira-onboarding.footer.x-title":[{"type":0,"value":"X"}],"growth-jira-onboarding.footer.youtube-alt-text":[{"type":0,"value":"Youtube"}],"growth-jira-onboarding.footer.youtube-title":[{"type":0,"value":"Youtube"}],"growth-jira-onboarding.invite-reminder-with-board-activity.customer-logos.alt":[{"type":0,"value":"Customer logos including Twilio, NASA, Illumina, Docker, and Morningstar"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading":[{"type":0,"value":"Join in on your team\u2019s recent work"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.board-heading-text":[{"type":0,"value":"Here\u2019s what everyone\u2019s been up to in Jira:"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text":[{"type":0,"value":"Start collaborating"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-text.join-now":[{"type":0,"value":"Join now"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.button-view-all":[{"type":0,"value":"View all work"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.assignee":[{"type":0,"value":"Assignee"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.due-date":[{"type":0,"value":"Due date"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.status":[{"type":0,"value":"Status"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.column.summary":[{"type":0,"value":"Summary"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.created-by":[{"type":0,"value":"Created by "},{"type":1,"value":"projectAdmin"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-admin-only":[{"type":1,"value":"projectAdmin"},{"type":0,"value":" is waiting for you to join \'"},{"type":1,"value":"projectName"},{"type":0,"value":"\'"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.header-many-user":[{"type":1,"value":"projectAdmin"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other"}]},"other":{"value":[{"type":7},{"type":0,"value":" others"}]}},"pluralType":"cardinal","type":6,"value":"otherUsers"},{"type":0,"value":" are waiting for you to join \'"},{"type":1,"value":"projectName"},{"type":0,"value":"\'"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.in-body-header":[{"type":0,"value":"Your team is waiting for you to join them in Jira"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.email.subject.no-translate":[{"type":0,"value":"Reminder: You\u2019ve been invited to plan and track work in Jira"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.done":[{"type":0,"value":"Done"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.inProgress":[{"type":0,"value":"In Progress"}],"growth-jira-onboarding.invite-reminder-with-board-activity.message-template.status.category.todo":[{"type":0,"value":"To Do"}],"growth-jira-onboarding.invite-reminder-with-board-activity.social-proof.text":[{"children":[{"type":0,"value":"Jira is the #1 project management tool"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers plan and track work across every team."}],"growth-jira-onboarding.invite-reminder-with-board-activitye.message-template.email.project-launch":[{"type":1,"value":"projectName"}],"growth-jira-onboarding.jira-issueview-description-title-final.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"growth-jira-onboarding.jira-issueview-description-title-final.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.body-text":[{"children":[{"type":0,"value":"Jira is the #1 project management tool"}],"type":8,"value":"b"},{"type":0,"value":" where over 75,000+ customers plan and track work across every team."}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.button-text":[{"type":0,"value":"Join now"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.created-by":[{"type":0,"value":"Created by "},{"type":1,"value":"projectAdmin"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.header":[{"type":0,"value":"Start collaborating with your team in Jira"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.invite-nudge.banner":[{"type":0,"value":"\uD83D\uDC4B "},{"children":[{"type":0,"value":"Forward this email"}],"type":8,"value":"b"},{"type":0,"value":" to easily invite more teammates"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.project-launch":[{"type":1,"value":"filteredProjectName"},{"type":0,"value":" Launch"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.subject.start-collaborating":[{"type":0,"value":"Start collaborating with your team on "},{"type":1,"value":"filteredProjectName"}],"growth-jira-onboarding.jira-onboarding-forward-invite.message-template.email.unsubscribe-link-text":[{"children":[{"type":0,"value":"Unsubscribe"}],"type":8,"value":"a"},{"type":0,"value":" to opt out of future emails like this"}],"growth-jira-onboarding.jira-side-nav-mature-example-project-space-setup.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"growth-jira-onboarding.jira-side-nav-mature-example-project-space-setup.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"jira-sidebar-nav-day-x-notification.body-text":[{"type":0,"value":"We\u2019ve added features to boost your productivity. "},{"children":[{"type":0,"value":"Customize your sidebar"}],"type":8,"value":"strong"},{"type":0,"value":" to change what shows up."}],"jira-sidebar-nav-day-x-notification.button-text":[{"type":0,"value":"Got it"}],"post-office.components.email.default-project-name":[{"type":0,"value":"Big Campaign"}],"post-office.components.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"post-office.components.email.footer.office-address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.growth-jira-onboarding-common.footer.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"post-office.growth-jira-onboarding-common.footer.contact-us":[{"type":0,"value":" Contact us \u2022 "}],"post-office.growth-jira-onboarding-common.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved. "}],"post-office.growth-jira-onboarding-common.footer.facebook-alt-text":[{"type":0,"value":"Facebook"}],"post-office.growth-jira-onboarding-common.footer.facebook-title":[{"type":0,"value":"Facebook"}],"post-office.growth-jira-onboarding-common.footer.footer-links.contact-us":[{"type":1,"value":"contactLink"}],"post-office.growth-jira-onboarding-common.footer.footer-links.join-atlassian-community":[{"type":1,"value":"joinAtlassianCommunity"}],"post-office.growth-jira-onboarding-common.footer.footer-links.privacy-policy":[{"type":1,"value":"privacyPolicy"}],"post-office.growth-jira-onboarding-common.footer.footer-links.read-in-browser":[{"type":1,"value":"readInBrowser"}],"post-office.growth-jira-onboarding-common.footer.footer-links.read-our-blog":[{"type":0,"value":" "},{"type":1,"value":"thirdText"}],"post-office.growth-jira-onboarding-common.footer.join-atlassian-community":[{"type":0,"value":"Join Atlassian Community"}],"post-office.growth-jira-onboarding-common.footer.linkedin-alt-text":[{"type":0,"value":"LinkedIn"}],"post-office.growth-jira-onboarding-common.footer.linkedin-title":[{"type":0,"value":"LinkedIn"}],"post-office.growth-jira-onboarding-common.footer.office-address":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia"}],"post-office.growth-jira-onboarding-common.footer.partner-portal":[{"type":0,"value":"Partner Portal"}],"post-office.growth-jira-onboarding-common.footer.privacy-policy":[{"type":0,"value":"Privacy Policy \u2022 "}],"post-office.growth-jira-onboarding-common.footer.read-in-browser":[{"type":0,"value":"Read in browser \u2022 "}],"post-office.growth-jira-onboarding-common.footer.read-our-blog":[{"type":0,"value":"Read our blog \u2022 "}],"post-office.growth-jira-onboarding-common.footer.twitter-alt-text":[{"type":0,"value":"Twitter"}],"post-office.growth-jira-onboarding-common.footer.twitter-title":[{"type":0,"value":"Twitter"}],"post-office.growth-jira-onboarding-common.footer.unsubscribe":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or "},{"type":1,"value":"unsubscribe"},{"type":0,"value":" here."}],"post-office.growth-jira-onboarding-common.footer.unsubscribeText":[{"type":0,"value":"unsubscribe"}],"post-office.growth-jira-onboarding-common.jira-email-header.atlassian-text":[{"type":0,"value":"Atlassian"}],"post-office.growth-jira-onboarding-common.jira-email-header.jira-logo-alt-text":[{"type":0,"value":"Jira"}],"post-office.growth-jira-onboarding-common.jira-email-header.jira-text":[{"type":0,"value":"Jira"}],"post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.description":[{"type":0,"value":"Tell us about your setup experience and we\u2019ll send you a $100 gift card as a thank you."}],"post-office.growth-jira-onboarding.jira-messaging-research-recruitment.screen-space-flags.header":[{"type":0,"value":"Join our paid research study \uD83D\uDCB8"}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.body":[{"type":0,"value":"Use Rovo to create structured tasks, connect agents, and organize work."}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.cta":[{"type":0,"value":"Try now"}],"post-office.growth-jira-onboarding.jira-rovo-spotlight.screen-space-flags.headline":[{"type":0,"value":"Try a suggested action"}],"post-office.growth-jira-onboarding.jira-setup-user-interviews-signup.screen-space-flags.cta-link":[{"type":0,"value":"Join now"}],"post-office.test-placement.jonboarding-jira-side-nav-projects.dismiss-button.no-translate":[{"type":0,"value":"Dismiss"}]}');

});

parcelRegister("72yBg", function(module, exports) {

let $52038f2383e9cbf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52038f2383e9cbf9$var$load("8odnZ").then(()=>parcelRequire('fTfl4'));

});

parcelRegister("34CHz", function(module, exports) {

let $23cfc42dced5091a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23cfc42dced5091a$var$load("8wMqD").then(()=>parcelRequire('ivsNK'));

});

parcelRegister("kMKcN", function(module, exports) {

let $f21c21c1180751e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f21c21c1180751e2$var$load("2qVSg").then(()=>parcelRequire('cJ54O'));

});

parcelRegister("apltJ", function(module, exports) {

let $793ce66279b24fc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $793ce66279b24fc0$var$load("4tZMg").then(()=>parcelRequire('h2Non'));

});

parcelRegister("3K0Yv", function(module, exports) {

let $2b966c98080a9ed7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b966c98080a9ed7$var$load("1HQlP").then(()=>parcelRequire('4cuP7'));

});

parcelRegister("djKWK", function(module, exports) {

let $9b21775555292613$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9b21775555292613$var$load("3EoTF").then(()=>parcelRequire('8Q6P1'));

});

parcelRegister("01utY", function(module, exports) {

let $0047bd511cd29ad3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0047bd511cd29ad3$var$load("3ouij").then(()=>parcelRequire('k0hrO'));

});

parcelRegister("24m3m", function(module, exports) {

let $181d0fd2054fb836$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $181d0fd2054fb836$var$load("5nLLr").then(()=>parcelRequire('7yALc'));

});

parcelRegister("96EuC", function(module, exports) {

let $6a14159d7fe61856$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a14159d7fe61856$var$load("41TS2").then(()=>parcelRequire('cMyrd'));

});

parcelRegister("2U42d", function(module, exports) {

let $21d3f0f429691f1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21d3f0f429691f1a$var$load("gZdf8").then(()=>parcelRequire('3QdN6'));

});

parcelRegister("7Gz2R", function(module, exports) {

let $5987a3df77fce068$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5987a3df77fce068$var$load("7TrUY").then(()=>parcelRequire('jbQXQ'));

});

parcelRegister("eJudw", function(module, exports) {

let $ab9cb520164014c5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab9cb520164014c5$var$load("5NBva").then(()=>parcelRequire('ekj5i'));

});

parcelRegister("jWXSm", function(module, exports) {

let $e861e129e0e16b8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e861e129e0e16b8e$var$load("6JkpT").then(()=>parcelRequire('a3SKX'));

});

parcelRegister("d0CCF", function(module, exports) {

let $97893c1dd4bda325$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97893c1dd4bda325$var$load("9wWCX").then(()=>parcelRequire('dZSv1'));

});

parcelRegister("hVgMi", function(module, exports) {

let $d0c4c64d498cd55c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0c4c64d498cd55c$var$load("1zzxF").then(()=>parcelRequire('96XsG'));

});

parcelRegister("aqAkV", function(module, exports) {

let $797884c1aeabe436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $797884c1aeabe436$var$load("78lVo").then(()=>parcelRequire('l65Qx'));

});

parcelRegister("8jPAN", function(module, exports) {

let $60e81e49af87893d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $60e81e49af87893d$var$load("9K4EB").then(()=>parcelRequire('fEcy1'));

});

parcelRegister("hJ1Ua", function(module, exports) {

let $ce781dee1895fa28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce781dee1895fa28$var$load("H4Ms4").then(()=>parcelRequire('8pT9o'));

});

parcelRegister("a9ymm", function(module, exports) {

let $764565bbafad35a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $764565bbafad35a9$var$load("2pkVK").then(()=>parcelRequire('C4qTk'));

});

parcelRegister("dqohW", function(module, exports) {

let $9c608b3fae8b5ef6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c608b3fae8b5ef6$var$load("er5Jq").then(()=>parcelRequire('6raEW'));

});

parcelRegister("c5L14", function(module, exports) {

let $8cda6c229977823b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8cda6c229977823b$var$load("3BOlE").then(()=>parcelRequire('61ISI'));

});

parcelRegister("1xaV8", function(module, exports) {

let $11e1581581285ff8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11e1581581285ff8$var$load("dTjN8").then(()=>parcelRequire('5kzRw'));

});

parcelRegister("htHe6", function(module, exports) {

let $cb96acf6c2d39f05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb96acf6c2d39f05$var$load("3SCPB").then(()=>parcelRequire('64vuc'));

});

parcelRegister("8xsok", function(module, exports) {

let $63776dbbe981f098$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $63776dbbe981f098$var$load("kaDNR").then(()=>parcelRequire('fWA8k'));

});

parcelRegister("id7hU", function(module, exports) {

let $d41f181cf6c6e377$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d41f181cf6c6e377$var$load("iSHt2").then(()=>parcelRequire('5I7hK'));

});

parcelRegister("fy3FM", function(module, exports) {

let $b51ce157a7fb2544$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b51ce157a7fb2544$var$load("fELfG").then(()=>parcelRequire('42zOJ'));

});

parcelRegister("5NLRP", function(module, exports) {

let $4396a8cc561d5430$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4396a8cc561d5430$var$load("hHg56").then(()=>parcelRequire('2e3vn'));

});

parcelRegister("94DnD", function(module, exports) {

let $69b308d7e99b14c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69b308d7e99b14c3$var$load("eURYs").then(()=>parcelRequire('k8Syd'));

});

parcelRegister("juHGP", function(module, exports) {

let $e312b58b069d2ac2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e312b58b069d2ac2$var$load("kVxUh").then(()=>parcelRequire('6ABC3'));

});

parcelRegister("a2UWN", function(module, exports) {

let $750643d3ad37a6cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $750643d3ad37a6cb$var$load("9HyuV").then(()=>parcelRequire('9Zqjk'));

});

parcelRegister("5PbVc", function(module, exports) {

let $43daf690170dc602$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $43daf690170dc602$var$load("fBe3V").then(()=>parcelRequire('fbkQ6'));

});

parcelRegister("amBbx", function(module, exports) {

let $78b8cda3540900a5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78b8cda3540900a5$var$load("fYTt7").then(()=>parcelRequire('eWcXO'));

});

parcelRegister("fkh2h", function(module, exports) {

let $b285f032781f4b5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b285f032781f4b5a$var$load("hQcxQ").then(()=>parcelRequire('heR7q'));

});

parcelRegister("40r0l", function(module, exports) {

let $2eac1c126e885df6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2eac1c126e885df6$var$load("cHbKu").then(()=>parcelRequire('3G11Q'));

});

parcelRegister("4mlnj", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $h89dU = parcelRequire("h89dU");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $08ae4730ccae252e$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $08ae4730ccae252e$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("18AbW")));
        case 'da':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("5TrQ9")));
        case 'de':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("apcQm")));
        case 'en-GB':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("38Pio")));
        case 'en-US':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("ePu5I")));
        case 'en-XA':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("3ie9X")));
        case 'en-XB':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("f3eB3")));
        case 'en-ZZ':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("4L0cU")));
        case 'en':
            return $08ae4730ccae252e$var$importHelper(await Promise.resolve((parcelRequire("h89dU"))));
        case 'es':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("eQsRU")));
        case 'et':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("hWyGN")));
        case 'fi':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("aVyPi")));
        case 'fr':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("hkaHC")));
        case 'hr':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("7BPcO")));
        case 'hu':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("iiAOW")));
        case 'it':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("7vYJq")));
        case 'ja':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("7UAe1")));
        case 'ko':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("alQ7v")));
        case 'nb':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("9R1Vi")));
        case 'nl':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("9Y5Ly")));
        case 'pl':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("cV5oE")));
        case 'pt-BR':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("7eC1l")));
        case 'ro':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("3DmQG")));
        case 'ru':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("a0gCC")));
        case 'sl':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("fkXoM")));
        case 'sr-RS':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("bkkFx")));
        case 'sr-YR':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("4xEEU")));
        case 'sr':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("cgoSX")));
        case 'sv':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("4A4dR")));
        case 'th':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("3tX10")));
        case 'tr':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("9XdYK")));
        case 'uk':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("kMafC")));
        case 'vi':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("lleYH")));
        case 'zh-CN':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("g1YnZ")));
        case 'zh-TW':
            return $08ae4730ccae252e$var$importHelper(await (parcelRequire("1LJzY")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($h89dU));
    }
};
module.exports["messagesLoader"] = $08ae4730ccae252e$export$720676d8cac8fbb;

});

parcelRegister("h89dU", function(module, exports) {
module.exports = JSON.parse('{"ai-rovo.actions-software-backlog.nudge-description.nonfinal":[{"type":0,"value":"We have identified "},{"type":1,"value":"numberOfSuggestions"},{"type":0,"value":" work item "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"update"}]},"other":{"value":[{"type":0,"value":"updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfSuggestions"}],"ai-rovo.actions-software-backlog.nudge-icon-label.nonfinal":[{"type":0,"value":"Work items icon"}],"ai-rovo.actions-software-backlog.nudge-title.nonfinal":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfSuggestions"},{"type":0,"value":" work item "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"update"}]},"other":{"value":[{"type":0,"value":"updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfSuggestions"}],"jira-issueview-quickactions.src.ui.index.recommended-for-you":[{"type":0,"value":"Recommended for you"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.now":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.soon":[{"type":0,"value":"Jira \'projects\' will soon be renamed \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.learn-more":[{"type":0,"value":"Read more about this change"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.now":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.soon":[{"type":0,"value":"Coming soon"}],"jira-pulsar.common.components.cross-flow.add":[{"type":0,"value":"Add"}],"jira-pulsar.common.components.cross-flow.dismiss":[{"type":0,"value":"Dismiss"}],"jira-pulsar.common.components.issue-view-description-ad.close":[{"type":0,"value":"Close"}],"jira-pulsar.jira-comment-mention.message-template.notification-drawer.message":[{"type":1,"value":"user1"},{"type":0,"value":" mentioned you in a comment"}],"jira-pulsar.jira-comment-mention.message-template.notification-drawer.message.anonymous":[{"type":0,"value":"You\'ve been mentioned in a comment"}],"jira-pulsar.jira-common.celebration-icon.body_image_alt":[{"type":0,"value":"Celebration icon"}],"jira-pulsar.jira-common.exclamation-icon.body_image_alt":[{"type":0,"value":"Exclamation icon"}],"jira-pulsar.jira-common.jira-logo.alt_text":[{"type":0,"value":"Jira logo"}],"jira-pulsar.jira-common.message-template.text.body.display.old.field.value":[{"type":0,"value":"was: "},{"type":1,"value":"oldFieldValue"}],"jira-pulsar.jira-common.redesign.footer.atlassian-logo.no-translate":[{"type":0,"value":"Atlassian logo"}],"jira-pulsar.jira-common.right-arrow-icon.no-translate":[{"type":0,"value":"&#x2192;"}],"jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin":[{"type":0,"value":"From:"}],"jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin":[{"type":0,"value":"New message from Contact Administrators page"}],"jira-pulsar.jira-contact-admin.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"}],"jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate":[{"type":0,"value":"->"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate":[{"type":0,"value":"+"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required":[{"type":1,"value":"issueLink"},{"type":0,"value":" requires your approval"}],"jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject":[{"type":0,"value":"Approval required: "},{"type":1,"value":"issueLabel"}],"jira-pulsar.jira-issue-approval.message-template.email.footer.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jira-pulsar.jira-issue-approval.message-template.email.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-archived.message-template.redacted.email.subject":[{"type":0,"value":"("},{"type":1,"value":"issueKey"},{"type":0,"value":") work item was archived"}],"jira-pulsar.jira-issue-assign.message-template-template.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"assigned"}],"type":8,"value":"b"},{"type":0,"value":" this work item to you"}],"jira-pulsar.jira-issue-assign.message-template.email.html.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"issueKey"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been assigned to "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" to you"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been unassigned from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous":[{"type":0,"value":"There\'s a new assignee on an issue"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new assignee on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" to "},{"type":1,"value":"newAssignee"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assignee.change.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" to "},{"type":1,"value":"newAssignee"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"The "},{"options":{"Bug":{"value":[{"type":0,"value":"bug\'s"}]},"Epic":{"value":[{"type":0,"value":"epic\'s"}]},"Generalrequest":{"value":[{"type":0,"value":"request\'s"}]},"Idea":{"value":[{"type":0,"value":"idea\'s"}]},"Story":{"value":[{"type":0,"value":"story\'s"}]},"Subtask":{"value":[{"type":0,"value":"subtask\'s"}]},"Task":{"value":[{"type":0,"value":"task\'s"}]},"other":{"value":[{"type":0,"value":"work item\'s"}]}},"type":5,"value":"issueType"},{"type":0,"value":" assignee has been removed"}],"jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-assigned.email.body.assignee":[{"type":0,"value":"Assignee"}],"jira-pulsar.jira-issue-assigned.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-comment-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update":[{"type":0,"value":"Comment: "},{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment-update.email.body.added":[{"type":0,"value":"Added"}],"jira-pulsar.jira-issue-comment-update.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-comment-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-comment-update.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new update in a comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" updated the comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-comment.body_image_alt":[{"type":0,"value":"Icon for comment on a Jira issue"}],"jira-pulsar.jira-issue-comment.email.body.add-comment":[{"type":0,"value":"Add comment"}],"jira-pulsar.jira-issue-comment.email.body.view-comment":[{"type":0,"value":"View comment"}],"jira-pulsar.jira-issue-comment.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"There\'s a new comment on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-create.email.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira-pulsar.jira-issue-create.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" created "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-delete.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"type":0,"value":"You\'ve been mentioned on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user1"},{"type":0,"value":" mentioned you on "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-moved.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"issueKey"},{"type":0,"value":" Work item was updated"}],"jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"jira-pulsar.jira-issue-reopened.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4":[{"options":{"Bug":{"value":[{"type":0,"value":"A bug"}]},"Epic":{"value":[{"type":0,"value":"An epic"}]},"Generalrequest":{"value":[{"type":0,"value":"A request"}]},"Idea":{"value":[{"type":0,"value":"An idea"}]},"Story":{"value":[{"type":0,"value":"A story"}]},"Subtask":{"value":[{"type":0,"value":"A subtask"}]},"Task":{"value":[{"type":0,"value":"A task"}]},"other":{"value":[{"type":0,"value":"A work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" has been transitioned from "},{"type":1,"value":"fromStatus"},{"type":0,"value":" to "},{"type":1,"value":"toStatus"}],"jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.issue-terminology-refresh-m4":[{"type":1,"value":"user"},{"type":0,"value":" changed "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"fromStatus"},{"type":0,"value":" to "},{"type":1,"value":"toStatus"}],"jira-pulsar.jira-issue-update.email.body.slash.no-translate":[{"type":0,"value":" \u2192 "}],"jira-pulsar.jira-issue-update.message-template.changeby":[{"type":0,"value":"Change by: "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"issuekey"}],"jira-pulsar.jira-issue-update.message-template.hipppa.view.update":[{"children":[{"type":0,"value":"View update"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-update.message-template.notification-drawer.message":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"options":{"Bug":{"value":[{"type":0,"value":"a bug"}]},"Epic":{"value":[{"type":0,"value":"an epic"}]},"Generalrequest":{"value":[{"type":0,"value":"a request"}]},"Idea":{"value":[{"type":0,"value":"an idea"}]},"Story":{"value":[{"type":0,"value":"a story"}]},"Subtask":{"value":[{"type":0,"value":"a subtask"}]},"Task":{"value":[{"type":0,"value":"a task"}]},"other":{"value":[{"type":0,"value":"a work item"}]}},"type":5,"value":"issueType"}],"jira-pulsar.jira-issue-work-started.message-template.email.body.started":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"started work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"stopped work on this work item"}],"type":8,"value":"color"}],"jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issuekey"},{"type":0,"value":") Work item was updated"}],"jira-pulsar.jira-issue-worklog-delete.email.body.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted":[{"type":0,"value":"Deleted"}],"jira-pulsar.jira-issue-worklog-update.email.body.edited":[{"type":0,"value":"Edited"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a worklog"}],"type":8,"value":"strong"},{"type":0,"value":" on "},{"children":[{"type":1,"value":"issueKey"}],"type":8,"value":"b"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.change.by":[{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment":[{"children":[{"type":0,"value":"Add Comment"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description":[{"children":[{"type":0,"value":"View work description"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by":[{"type":1,"value":"entry"},{"type":0,"value":" logged by "},{"children":[{"type":1,"value":"actioner"}],"type":8,"value":"a"}],"jira-pulsar.jira-issue-worklogged.body_image_alt":[{"type":0,"value":"Product logo"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Put the details in a page to keep the description short"}],"jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Create a page"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence":[{"type":0,"value":"Confluence"}],"jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page":[{"type":0,"value":"Page"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription":[{"type":0,"value":"Capture ideas and insights"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-jpd.placements.in-app.jira-issueview-description-template.titleForIssueDescription":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea":[{"type":0,"value":"Idea"}],"jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd":[{"type":0,"value":"Jira Product Discovery"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment":[{"type":0,"value":"Record a comment"}],"jira-xflow-loom.placements.in-app.jira-issueview-comment.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription":[{"type":0,"value":"Try"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription":[{"type":0,"value":"Use video to explain the work"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.loom":[{"type":0,"value":"Loom"}],"jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription":[{"type":0,"value":"Record your screen"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add":[{"type":0,"value":"Add"}],"jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video":[{"type":0,"value":"Video"}],"jira.default.subject":[{"type":0,"value":"[JIRA] Project Update: "},{"type":1,"value":"projectName"},{"type":0,"value":" ("},{"type":1,"value":"projectKey"},{"type":0,"value":")"}],"jira.jira-bulk.message-template.email.header":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"sent you"}],"type":8,"value":"strong"},{"type":0,"value":" a message."}],"jira.jira-bulk.message-template.email.subject.user.provided.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"subject"}],"jira.jira-bulk.message-template.text.message":[{"type":1,"value":"user"},{"type":0,"value":" sent you a message"}],"jira.jira-common.email.addon-banner.gmail":[{"type":0,"value":"Gmail"}],"jira.jira-common.email.addon-banner.install-text":[{"type":0,"value":"Install the Atlassian email extension for "},{"type":1,"value":"gmailLink"},{"type":0,"value":" or "},{"type":1,"value":"outlookLink"},{"type":0,"value":"."}],"jira.jira-common.email.addon-banner.main-text":[{"type":0,"value":"Update work items without leaving your inbox."}],"jira.jira-common.email.addon-banner.opt-out":[{"type":0,"value":"Don\'t show again"}],"jira.jira-common.email.addon-banner.outlook":[{"type":0,"value":"Outlook"}],"jira.jira-common.email.addon-banner.tip":[{"type":0,"value":"Tip:"}],"jira.jira-common.email.dot-separator.no-translate":[{"type":0,"value":" \u2022 "}],"jira.jira-common.email.footer.custom.message":[{"type":1,"value":"footerText"}],"jira.jira-common.email.footer.download.app-store.no-translate":[{"type":0,"value":"Download on the App Store"}],"jira.jira-common.email.footer.get-on.google-play.no-translate":[{"type":0,"value":"Get it on Google Play"}],"jira.jira-common.email.footer.get.apps":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "}],"jira.jira-common.email.footer.get.apps.new":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"children":[{"type":0,"value":"Android"}],"type":8,"value":"a1"},{"type":0,"value":" or "},{"children":[{"type":0,"value":"iOS"}],"type":8,"value":"a2"},{"type":0,"value":"."}],"jira.jira-common.email.footer.give.feedback":[{"type":0,"value":"Give feedback"}],"jira.jira-common.email.footer.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.email.footer.open.attachment":[{"type":0,"value":"Open the work item to view attachments over 100 KB"}],"jira.jira-common.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-common.email.footer.sent-by-atlassian-jira":[{"type":0,"value":"This email was sent by Atlassian Jira"}],"jira.jira-common.email.footer.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.email.footer.unsubscribe-message":[{"type":0,"value":"If you no longer wish to receive these emails, please update your preferences or unsubscribe "},{"children":[{"type":0,"value":"here"}],"type":8,"value":"link"},{"type":0,"value":"."}],"jira.jira-common.email.loom-footer-tip":[{"children":[{"type":0,"value":"Tip:"}],"type":8,"value":"tip"},{"type":0,"value":" Try "},{"children":[{"type":0,"value":"Loom video"}],"type":8,"value":"loomVideo"},{"type":0,"value":" to get everyone on the same page, without a meeting."}],"jira.jira-common.email.slash.no-translate":[{"type":0,"value":"/"}],"jira.jira-common.email.twg-cli-banner.link-text":[{"type":0,"value":"Teamwork Graph CLI"}],"jira.jira-common.email.twg-cli-banner.text":[{"type":0,"value":"Give your AI agents rich Jira context with fewer credits. Query open work items and dependencies with "},{"type":1,"value":"twgCliLink"},{"type":0,"value":"."}],"jira.jira-common.email.twg-cli-banner.tip":[{"type":0,"value":"Tip:"}],"jira.jira-common.message-template.text.body.assignee.label":[{"type":0,"value":"Assignee:"}],"jira.jira-common.message-template.text.body.attachments.label":[{"type":0,"value":"Attachments:"}],"jira.jira-common.message-template.text.body.key.label":[{"type":0,"value":"Key:"}],"jira.jira-common.message-template.text.body.loom-footer-tip":[{"type":0,"value":"Tip: Try Loom video to get everyone on the same page, without a meeting.\\n"},{"type":1,"value":"loomUrl"}],"jira.jira-common.message-template.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-common.message-template.text.body.priority.label":[{"type":0,"value":"Priority:"}],"jira.jira-common.message-template.text.body.project.label":[{"type":0,"value":"Project:"}],"jira.jira-common.message-template.text.body.reporter.heading":[{"type":0,"value":"Reporter: "}],"jira.jira-common.message-template.text.body.reporter.label":[{"type":0,"value":"Reporter:"}],"jira.jira-common.message-template.text.body.sent.by":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-common.message-template.text.body.work.type.label":[{"type":0,"value":"Work type:"}],"jira.jira-filter-subscription.message-template.email.table.filter-label":[{"type":0,"value":"Filter: "}],"jira.jira-filter-subscription.message-template.email.table.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-filter-subscription.message-template.email.table.subscriber-label":[{"type":0,"value":"Subscriber:"}],"jira.jira-issue-approval-decided.message-template.approval.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural":[{"type":1,"value":"remainingApprovals"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueTypeName"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.approval.event.declined.transition":[{"type":1,"value":"issueTypeName"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" "},{"type":1,"value":"arrowIcon"},{"type":0,"value":" "},{"type":1,"value":"newStatus"}],"jira.jira-issue-approval-decided.message-template.declined.by.user":[{"type":1,"value":"user"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLink"}],"jira.jira-issue-approval.message-template.approval.required.title":[{"type":1,"value":"issueLabel"},{"type":0,"value":" requires your approval"}],"jira.jira-issue-approval.message-template.approval.title.all-approved":[{"type":1,"value":"issueLink"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.approval.approved":[{"type":0,"value":"Approved"}],"jira.jira-issue-approval.message-template.email.approval.approvers.remaining":[{"type":1,"value":"remainingApprovers"},{"type":0,"value":" more approvals required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.assigned.to":[{"type":0,"value":"Assigned to: "},{"type":1,"value":"assignee"}],"jira.jira-issue-approval.message-template.email.approval.declined":[{"type":0,"value":"Declined"}],"jira.jira-issue-approval.message-template.email.approval.declined.transition":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"declinedStatus"}],"jira.jira-issue-approval.message-template.email.approval.event.approvers":[{"type":0,"value":"Approvers: "}],"jira.jira-issue-approval.message-template.email.approval.one.approver.remaining":[{"type":0,"value":"1 more approval required to move this "},{"type":1,"value":"issueType"},{"type":0,"value":" from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-approval.message-template.email.approval.view.work.item":[{"type":0,"value":"View "},{"type":1,"value":"issueType"}],"jira.jira-issue-approval.message-template.email.approved.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has approved "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.declined.by":[{"type":1,"value":"deciderName"},{"type":0,"value":" has declined "},{"type":1,"value":"issueLabel"}],"jira.jira-issue-approval.message-template.email.footer.contact.us":[{"type":0,"value":"Contact Us"}],"jira.jira-issue-approval.message-template.email.footer.location":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"jira.jira-issue-approval.message-template.email.footer.privacy.policy":[{"type":0,"value":"Privacy Policy"}],"jira.jira-issue-approval.message-template.email.issue.approved":[{"type":1,"value":"issueLabel"},{"type":0,"value":" has been approved!"}],"jira.jira-issue-approval.message-template.email.issue.has.moved.from":[{"type":1,"value":"issueType"},{"type":0,"value":" has moved from "},{"type":1,"value":"originalStatus"},{"type":0,"value":" to "},{"type":1,"value":"approvedStatus"}],"jira.jira-issue-archived.message-template.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.redacted.email.subject":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"archived a work item."}],"type":8,"value":"strong"}],"jira.jira-issue-archived.message-template.text.archived.work.item":[{"type":1,"value":"user"},{"type":0,"value":" archived "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-assign.text.body.assigned":[{"type":0,"value":" "},{"type":1,"value":"user"},{"type":0,"value":" reassigned "},{"type":1,"value":"issueKey"}],"jira.jira-issue-assign.text.body.assignee.update":[{"type":0,"value":"Assignee: "},{"type":1,"value":"assigneeName"},{"type":0,"value":" was: ("},{"type":1,"value":"oldAssigneeName"},{"type":0,"value":")"}],"jira.jira-issue-assign.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-batch.email.body.issue.comments.heading":[{"type":0,"value":"Comments"}],"jira.jira-issue-batch.email.body.issue.created.heading":[{"type":0,"value":"Work item created"}],"jira.jira-issue-batch.email.body.issue.updates.heading":[{"type":0,"value":"Updates"}],"jira.jira-issue-batch.email.body.issue.worklog.heading":[{"type":0,"value":"Work log"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a new comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" new comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a comment"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" comments"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.created.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a work item"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work items"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.dot":[{"type":0,"value":". "}],"jira.jira-issue-batch.email.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.separator.comma":[{"type":0,"value":", "}],"jira.jira-issue-batch.email.body.summary.issue.updates.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"type":1,"value":"count"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" other person"}]},"other":{"value":[{"type":7},{"type":0,"value":" other people"}]}},"pluralType":"cardinal","type":6,"value":"userCount"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"an update"}]},"other":{"value":[{"type":1,"value":"count"},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading":[{"type":1,"value":"user"},{"type":0,"value":" and "},{"type":1,"value":"user1"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  made "},{"offset":0,"options":{"one":{"value":[{"type":0,"value":"an update"}]},"other":{"value":[{"type":1,"value":"count"},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" added a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  added "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" deleted a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  deleted "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" started a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  started "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" updated a worklog"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":"  updated "},{"type":1,"value":"count"},{"type":0,"value":" work log"}],"type":8,"value":"b"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"userCount"},{"type":0,"value":" other people "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading":[{"offset":0,"options":{"one":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made an update"}],"type":8,"value":"b"}]},"other":{"value":[{"type":1,"value":"user1"},{"type":0,"value":" and "},{"type":1,"value":"user2"},{"type":0,"value":" "},{"children":[{"type":0,"value":" made "},{"type":1,"value":"count"},{"type":0,"value":" updates"}],"type":8,"value":"b"}]}},"pluralType":"cardinal","type":6,"value":"count"}],"jira.jira-issue-batch.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueId"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-batch.message-template.redacted.email.subject":[{"type":0,"value":"[JIRA] Updates for "},{"type":1,"value":"issueId"}],"jira.jira-issue-closed.message-template.email.body.closed":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.email.body.closed.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"closed a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-closed.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" closed "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment-delete.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-delete.message-template.text.comment.was.deleted":[{"type":0,"value":"Comment: was deleted"}],"jira.jira-issue-comment-delete.message-template.text.updated.work.item":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-comment-update.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"edited a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment-update.message-template.text.body.comment.was":[{"type":0,"value":"was (Author: "},{"type":1,"value":"authorName"},{"type":0,"value":"):"}],"jira.jira-issue-comment-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" edited a comment on "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-comment.message-template.email.body.commented":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"added a comment on a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-comment.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-common.message-template.text.body.common.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-common.message-template.text.body.common.issue.author":[{"type":0,"value":"Author:"}],"jira.jira-issue-create.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"created a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-create.email.body.view.attachments":[{"type":0,"value":"View Attachments"}],"jira.jira-issue-create.email.body.view.components":[{"type":0,"value":"View Components"}],"jira.jira-issue-create.email.body.view.description":[{"type":0,"value":"View description"}],"jira.jira-issue-create.email.body.view.environment":[{"type":0,"value":"View environment"}],"jira.jira-issue-create.email.body.view.labels":[{"type":0,"value":"View labels"}],"jira.jira-issue-create.email.body.view.work.type":[{"type":0,"value":"View Work Type"}],"jira.jira-issue-create.message-template.email.original.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"issueKey"},{"type":0,"value":") "},{"type":1,"value":"summary"}],"jira.jira-issue-create.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" created "},{"type":1,"value":"issueKey"}],"jira.jira-issue-create.message-template.text.body.common.issue.key":[{"type":0,"value":"Key"}],"jira.jira-issue-create.message-template.text.body.common.summary":[{"type":0,"value":"Summary"}],"jira.jira-issue-create.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"jira.jira-issue-create.text.body.common.assignee":[{"type":0,"value":"Assignee"}],"jira.jira-issue-create.text.body.common.attachments":[{"type":0,"value":"Attachments"}],"jira.jira-issue-create.text.body.common.created":[{"type":0,"value":"Created"}],"jira.jira-issue-create.text.body.common.description":[{"type":0,"value":"Description"}],"jira.jira-issue-create.text.body.common.priority":[{"type":0,"value":"Priority"}],"jira.jira-issue-create.text.body.common.reporter":[{"type":0,"value":"Reporter"}],"jira.jira-issue-create.text.body.common.status":[{"type":0,"value":"Status"}],"jira.jira-issue-create.text.body.common.work.type":[{"type":0,"value":"Work type"}],"jira.jira-issue-delete.message-template.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" deleted this work item at "},{"type":1,"value":"timestamp"}],"jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted"}],"type":8,"value":"strong"},{"type":0,"value":" a work item"}],"jira.jira-issue-delete.message-template.text.deleted.work.item":[{"type":1,"value":"user"},{"type":0,"value":" deleted "},{"type":1,"value":"workItemKey"},{"type":0,"value":":"}],"jira.jira-issue-filter-subscription.message-template.email.subject":[{"type":0,"value":"[JIRA] Subscription: "},{"type":1,"value":"filterName"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header":[{"type":0,"value":"Work Item Subscription"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name":[{"type":0,"value":"Filter: "},{"type":1,"value":"filterName"},{"type":1,"value":"count"}],"jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info":[{"type":0,"value":"Subscriber: "},{"type":1,"value":"subscriberName"}],"jira.jira-issue-mention.email.body.colon.no-translate":[{"type":0,"value":": "}],"jira.jira-issue-mention.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"mentioned you"}],"type":8,"value":"strong"},{"type":0,"value":" on a work item"}],"jira.jira-issue-mention.email.body.mentioned.you":[{"type":0,"value":" mentioned you "}],"jira.jira-issue-mention.email.body.onWorkItem.you":[{"type":0,"value":" on a work item "}],"jira.jira-issue-mention.email.body.spaces.no-translate":[{"type":0,"value":"&nbsp;&nbsp;"}],"jira.jira-issue-mention.email.body.view.work.item":[{"type":0,"value":" View work item "}],"jira.jira-issue-mention.email.subject.mention":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-mention.push.mentioned.you":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"jira.jira-issue-mention.push.mentioned.you.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on this work item"}],"jira.jira-issue-mention.text.body.addComment":[{"type":0,"value":" Add Comment: "}],"jira.jira-issue-mention.text.body.manage.notifications":[{"type":0,"value":"Manage Notifications"}],"jira.jira-issue-mention.text.body.mention.hint":[{"type":0,"value":" Hint: You can mention someone in a work item description or comment by typing  \\"@\\" in front of their username."}],"jira.jira-issue-mention.text.body.mentioned":[{"type":0,"value":" mentioned you on "}],"jira.jira-issue-mention.text.body.sentby":[{"type":0,"value":"This message was sent by Atlassian Jira"}],"jira.jira-issue-mention.text.body.unassigned":[{"type":0,"value":"Unassigned"}],"jira.jira-issue-mention.text.body.viewOnline":[{"type":0,"value":" View Online: "}],"jira.jira-issue-moved.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"moved a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-moved.message-template.text.email.body":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-notify.email.body.heading":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.body.heading.redesigned":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"b"},{"type":0,"value":" a work item with you"}],"jira.jira-issue-notify.email.subject.notify":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared \\""},{"type":1,"value":"issueKey"},{"type":0,"value":" "},{"type":1,"value":"summary"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-reopened.message-template.email.body.reopened":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"reopened a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-reopened.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" reopened "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-resolved.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-search.message-template.email.subject.filter.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared the filter \\""},{"type":1,"value":"filterName"},{"type":0,"value":"\\" with you"}],"jira.jira-issue-search.message-template.email.subject.search.results":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.email.header.filter":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a filter with you."}],"jira.jira-issue-share.message-template.email.header.results":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"shared"}],"type":8,"value":"strong"},{"type":0,"value":" a search result with you."}],"jira.jira-issue-share.message-template.email.shared-with":[{"type":0,"value":" Also shared with "}],"jira.jira-issue-share.message-template.email.view.results":[{"type":0,"value":"View search results"}],"jira.jira-issue-share.message-template.text.shared.filter.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a filter with you"}],"jira.jira-issue-share.message-template.text.shared.results.heading":[{"type":1,"value":"user"},{"type":0,"value":" shared a search result with you"}],"jira.jira-issue-share.message-template.text.shared.with.others":[{"type":0,"value":"Also shared with"}],"jira.jira-issue-test.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] test template "},{"type":1,"value":"issueKey"}],"jira.jira-issue-update.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.created.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a work item"}],"type":8,"value":"strong"}],"jira.jira-issue-update.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-update.message-template.text.subject":[{"type":1,"value":"user"},{"type":0,"value":" updated "},{"type":1,"value":"workItemKey"}],"jira.jira-issue-work-started.message-template.email.body.created":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.email.body.created.redesigned":[{"type":1,"value":"actioner"},{"type":0,"value":" "},{"children":[{"type":0,"value":"made "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" update"}]},"other":{"value":[{"type":7},{"type":0,"value":" updates"}]}},"pluralType":"cardinal","type":6,"value":"numberOfUpdates"}],"type":8,"value":"strong"}],"jira.jira-issue-work-started.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" started by "},{"type":1,"value":"user"}],"jira.jira-issue-work-stopped.message-template.text.header":[{"type":0,"value":"Work on "},{"type":1,"value":"workItemKey"},{"type":0,"value":" stopped by "},{"type":1,"value":"user"}],"jira.jira-issue-worklog-delete.message-template.email.body.title.redesigned":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-delete.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"deleted a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog":[{"type":0,"value":"The following worklog was deleted:"}],"jira.jira-issue-worklog-update.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.body.title.redesigned":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"edited 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklog-update.message-template.email.redacted.body.title":[{"type":1,"value":"user"},{"type":0,"value":" "},{"children":[{"type":0,"value":"updated a worklog"}],"type":8,"value":"b"},{"type":0,"value":" on a work item"}],"jira.jira-issue-worklog-updated.message-template.email.body.description":[{"type":0,"value":"Description"}],"jira.jira-issue-worklog-updated.message-template.email.body.timeLogged":[{"type":0,"value":"Time logged"}],"jira.jira-issue-worklogged.message-template.email.body.description":[{"type":0,"value":"Description: "}],"jira.jira-issue-worklogged.message-template.email.body.logTitle":[{"type":0,"value":"Work log"}],"jira.jira-issue-worklogged.message-template.email.body.timelogged":[{"type":0,"value":"Time logged: "}],"jira.jira-issue-worklogged.message-template.email.body.title":[{"children":[{"type":0,"value":" made 2 updates"}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":"added 1 work log"}],"type":8,"value":"b"},{"type":0,"value":"."}],"jira.jira-issue-worklogged.message-template.email.body.updateTitle":[{"type":0,"value":"Updates"}],"jira.jira-issue-worklogged.message-template.email.body.worklog.change.by":[{"type":0,"value":"Change by: "}],"jira.jira-issue-worklogged.message-template.email.body.worklog.entry":[{"type":0,"value":"Worklog entry:"}],"jira.jira-issue-worklogged.message-template.email.subject.no-translate":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.body.common.change.by":[{"type":0,"value":"Change by"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on":[{"type":0,"value":"Created on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by":[{"type":0,"value":"Edited by:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on":[{"type":0,"value":"Edited on:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.key":[{"type":0,"value":"Key:"}],"jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label":[{"type":0,"value":"Worklog entry"}],"jira.jira-issue-worklogged.message-template.text.body.common.project":[{"type":0,"value":"Project:"}],"jira.jira-issue-worklogged.message-template.text.body.common.start.date":[{"type":0,"value":"Start Date:"}],"jira.jira-issue-worklogged.message-template.text.body.common.time.spent":[{"type":0,"value":"Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.common.url":[{"type":0,"value":"URL:"}],"jira.jira-issue-worklogged.message-template.text.body.common.view.work.description":[{"type":0,"value":"View work description"}],"jira.jira-issue-worklogged.message-template.text.body.common.work.type":[{"type":0,"value":"Work type:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.body":[{"type":0,"value":"Work Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description":[{"type":0,"value":"Worklog Description:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was":[{"type":0,"value":"Worklog Description was:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.id":[{"type":0,"value":"Worklog Id:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated":[{"type":0,"value":"Remaining Estimate:"}],"jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent":[{"type":0,"value":"Worklog Time Spent:"}],"jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by":[{"type":1,"value":"worklogEntry"},{"type":0,"value":" logged by "},{"type":1,"value":"actioner"}],"jira.jira-issue-worklogged.message-template.text.email.body.created":[{"type":1,"value":"user"},{"type":0,"value":" logged work on "},{"type":1,"value":"issueKey"}],"jira.jira-issue-worklogged.message-template.text.email.body.tracking":[{"type":0,"value":"Issue time Tracking"}],"jira.jira-project-deletion-reminder.message-template.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"header"},{"type":0,"value":" "}],"jira.jira-project-event-archived-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from archive "}],"jira.jira-project-event-archived.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Space archived"}],"jira.jira-project-event-delete-failed.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Could not permanently delete the project "}],"jira.jira-project-event-deleted-restore.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project restored from trash"}],"jira.jira-project-event-deleted.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"projectName"},{"type":0,"value":") ("},{"type":1,"value":"projectKey"},{"type":0,"value":") Project moved to trash"}],"jira.jira-project-event-user-invited-new-user.message-template.email.subject":[{"type":0,"value":"Action requested: "},{"type":1,"value":"userName"},{"type":0,"value":" invited you to join your team in "},{"type":1,"value":"projectName"},{"type":0,"value":", Jira"}],"jira.jira-project-event-user-invited-new-user.message-template.email.subject.redacted":[{"type":0,"value":"Action requested: You\'ve been invited to join your team in Jira"}],"jira.jira-project-event-user-invited.message-template.email.subject":[{"type":0,"value":"[JIRA] ("},{"type":1,"value":"userName"},{"type":0,"value":") invited you to ("},{"type":1,"value":"projectName"},{"type":0,"value":")  "}],"jira.lovabilityFastSnappy.survey.acknowledgement":[{"type":0,"value":"Thank you for your feedback!"}],"jira.lovabilityFastSnappy.survey.contact-label":[{"type":0,"value":"Atlassian can contact me about this feedback"}],"jira.lovabilityFastSnappy.survey.dismiss-label":[{"type":0,"value":"Dismiss"}],"jira.lovabilityFastSnappy.survey.fast-and-snappy.statement":[{"type":0,"value":"Jira feels fast and snappy"}],"jira.lovabilityFastSnappy.survey.feedback-label":[{"type":0,"value":"Tell us why? (Optional)"}],"jira.lovabilityFastSnappy.survey.lovability.statement":[{"type":0,"value":"Jira is a pleasure to use"}],"jira.lovabilityFastSnappy.survey.overline":[{"type":0,"value":"To what extent do you agree or disagree with the following statement?"}],"jira.lovabilityFastSnappy.survey.score-subtext.neutral":[{"type":0,"value":"Neutral"}],"jira.lovabilityFastSnappy.survey.score-subtext.strongly-agree":[{"type":0,"value":"Strongly agree"}],"jira.lovabilityFastSnappy.survey.score-subtext.strongly-disagree":[{"type":0,"value":"Strongly disagree"}],"jira.lovabilityFastSnappy.survey.submit-label":[{"type":0,"value":"Submit"}],"jira.lovabilityFastSnappy.survey.title":[{"type":0,"value":"Jira feedback survey"}],"jira.user.premium-plan.requested.email.explaination":[{"type":0,"value":"You can try Jira Premium for free with no commitment. This trial period includes access\\n\\t\\t\\t\\tto our advanced planning features plus other great functionalities that unlock new ways\\n\\t\\t\\t\\tof working for your teams."}],"jira.user.premium-plan.requested.email.greeting":[{"type":0,"value":"Hi,"}],"jira.user.premium-plan.requested.email.learn-more":[{"type":0,"value":"Learn more about Jira Premium."}],"jira.user.premium-plan.requested.email.start-trial":[{"type":0,"value":"Start your Jira Premium trial"}],"jira.user.premium-plan.requested.email.subject":[{"type":0,"value":"[JIRA] "},{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium"}],"jira.user.premium-plan.requested.email.text":[{"type":1,"value":"user"},{"type":0,"value":" has requested a free trial of Jira Premium."}],"note.added.by.user":[{"type":1,"value":"userName"},{"type":0,"value":" added this note"}],"post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.placement.jira-top-banner.primary-message":[{"type":0,"value":"As we roll out \'work\' as the new term for items tracked in Jira, you may still see \'issue\' in some areas."}],"postoffice.jira.issue.common.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.common.reply-button":[{"type":0,"value":"Reply"}],"postoffice.jira.issue.common.visibility-level":[{"type":0,"value":"Restricted to "},{"children":[{"type":1,"value":"name"}],"type":8,"value":"b"},{"type":0,"value":" "},{"type":1,"value":"type"}],"postoffice.jira.issue.metioned.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.share-search.shared-with.no-translate":[{"type":0,"value":"sharedWithUser"}],"postoffice.jira.issue.work.started.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.work.stopped.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.issue.worklogged.avatar.no-translate":[{"type":0,"value":"Avatar"}],"postoffice.jira.project.event.avatar.no-translate":[{"type":0,"value":"avatar"}],"postoffice.jira.project.event.blueprint.no-translate":[{"type":0,"value":"blueprintLogo"}],"postoffice.jira.project.event.globe.no-translate":[{"type":0,"value":"globeLogo"}],"postoffice.jira.project.event.logo.no-translate":[{"type":0,"value":"logo"}],"postoffice.jira.project.event.write.no-translate":[{"type":0,"value":"writeLogo"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.body":[{"type":0,"value":"Everything else about how you use these containers remains the same."}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.learn-more":[{"type":0,"value":"Learn more"}],"ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.title":[{"type":0,"value":"Jira \'projects\' are now called \'spaces\'"}],"push.mobile.issue.approval.requested.description":[{"type":0,"value":"on "},{"type":1,"value":"summary"}],"push.mobile.issue.approval.requested.title":[{"type":0,"value":"Approval requested"}],"push.mobile.issue.assignment.description.assigned.others":[{"type":1,"value":"user"},{"type":0,"value":" assigned "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"assignee"}],"push.mobile.issue.assignment.description.assigned.you":[{"type":1,"value":"user"},{"type":0,"value":" assigned you to "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.others":[{"type":1,"value":"user"},{"type":0,"value":" unassigned "},{"type":1,"value":"oldAssignee"},{"type":0,"value":" from "},{"type":1,"value":"summary"}],"push.mobile.issue.assignment.description.unassigned.you":[{"type":1,"value":"user"},{"type":0,"value":" unassigned you from "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment to "},{"type":1,"value":"summary"}],"push.mobile.issue.attachment.added.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" added an attachment"}],"push.mobile.issue.comment.added.android.description":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.added.ios.body.redacted":[{"type":0,"value":"commented on this work item"}],"push.mobile.issue.comment.added.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" commented on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.android.description.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you on "},{"type":1,"value":"summary"}],"push.mobile.issue.comment.mention.ios.subtitle.redacted":[{"type":0,"value":"\uD83D\uDCE3 "},{"type":1,"value":"user"},{"type":0,"value":" mentioned you in a comment on this work item"}],"push.mobile.issue.create.android.description":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.create.android.title":[{"type":0,"value":"Work item Created"}],"push.mobile.issue.create.ios.body.redacted":[{"type":0,"value":"Open to view work item details"}],"push.mobile.issue.create.ios.subtitle":[{"type":1,"value":"user"},{"type":0,"value":" created a work item"}],"push.mobile.issue.transition.description.resolved":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved "},{"type":1,"value":"summary"}],"push.mobile.issue.transition.description.resolved.redacted":[{"type":0,"value":"\u2714 "},{"type":1,"value":"user"},{"type":0,"value":" resolved this work item"}],"push.mobile.issue.transition.ios.description":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"push.mobile.issue.transition.ios.description.redacted":[{"type":1,"value":"user"},{"type":0,"value":" moved "},{"type":1,"value":"summary"},{"type":0,"value":" to "},{"type":1,"value":"status"}],"st-office.placement.jira-top-banner.primary-cta-text":[{"type":0,"value":"Read about this terminology change"}],"template..project-deletion-reminder.restore-link.multiple-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.restore-link.single-project":[{"type":0,"value":" Restore"}],"template..project-deletion-reminder.trash-link.multiple-project":[{"type":0,"value":" Trash"}],"template.project-deletion-reminder.generic-message.mutiple-projects":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" project"}]},"other":{"value":[{"type":7},{"type":0,"value":" projects"}]}},"pluralType":"cardinal","type":6,"value":"projectCount"},{"type":0,"value":" will be permanently deleted in 7 days "}],"template.project-deletion-reminder.generic-message.single-project":[{"type":0,"value":"The project will be permanently deleted in 7 days "}],"template.project-deletion-reminder.view-more-projects-message":[{"type":0,"value":"+ "},{"type":1,"value":"remainingProjectCount"},{"type":0,"value":" other projects currently in "}],"template.project-event-user-invited-new.custom-message-heading":[{"type":0,"value":"A note from "},{"type":1,"value":"inviterName"}],"template.project-event-user-invited-new.custom-message-heading-no-inviter":[{"type":0,"value":"A note from the admin"}],"template.project-event-user-invited-new.footer.sent-by":[{"type":0,"value":"This message was sent to you by Atlassian Cloud"}],"template.project-event-user-invited-new.join-space":[{"type":0,"value":"Join the space"}],"template.project-event-user-invited-new.logo-alt-text":[{"type":0,"value":"Jira logo"}],"template.project-event-user-invited-new.product-description":[{"children":[{"type":0,"value":"What is Jira?"}],"type":8,"value":"strong"},{"type":0,"value":" A software tool for project and work item tracking with your team"}],"template.project-event-user-invited-new.social-proof-text":[{"type":1,"value":"numberOfCustomers"},{"type":0,"value":"+ customers use Jira to move work forward"}],"template.project-event-user-invited-new.title-generic":[{"type":0,"value":"You\'ve been invited to join your team in Jira"}],"template.project-event-user-invited-new.title-inviter":[{"type":1,"value":"inviterDisplayName"},{"type":0,"value":" invited you to join your team in Jira"}],"template.project-event-user-invited-new.welcome-message":[{"type":1,"value":"waveEmoji"},{"type":0,"value":" G\'day, "},{"type":1,"value":"recipientFirstName"}],"template.project-event-user-invited.invited-custom-message":[{"type":1,"value":"customMessage"}],"template.project-event-user-invited.invited-message":[{"type":1,"value":"userName"},{"type":0,"value":"  invited you to "},{"children":[{"type":0,"value":" "},{"type":1,"value":"projectName"},{"type":0,"value":" "}],"type":8,"value":"b"}],"template.project.archived.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the space."}],"template.project.deleted.event.admins.permission.message":[{"type":0,"value":"Only Jira admins can restore the project."}],"template.project.event.project.archive.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from archive on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" archived this space on "},{"type":1,"value":"eventTime"}],"template.project.event.project.archived.body.template.generic.message":[{"type":0,"value":"This space and its work items, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" archive "}],"type":8,"value":"a"},{"type":0,"value":" forever"}],"template.project.event.project.deleted.body.template":[{"type":1,"value":"userName"},{"type":0,"value":" moved this project to trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deleted.body.template.generic.message":[{"type":0,"value":"The project, including all its issues, components, attachments, and versions will be available in the "},{"children":[{"type":0,"value":" trash "}],"type":8,"value":"a"},{"type":0,"value":" for 60 days after which it will be permanently deleted."}],"template.project.event.project.deleted.failure.body.template.generic.message":[{"type":0,"value":"It\'s probably a temporary problem. "},{"children":[{"type":0,"value":" Go to trash "}],"type":8,"value":"a"},{"type":0,"value":" and try again. If it persists, please contact support."}],"template.project.event.project.deleted.restore.body.template":[{"type":0,"value":" "},{"type":1,"value":"userName"},{"type":0,"value":" restored this project from trash on "},{"type":1,"value":"eventTime"}],"template.project.event.project.deletion.failure.body.template":[{"type":0,"value":"We couldn\'t delete this project"}],"template.project.event.project.privacy.contactus.template":[{"type":0,"value":"Contact us"}],"template.project.event.project.privacy.copyright.template":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"template.project.event.project.privacy.location.template":[{"type":0,"value":"We are located at 341 George Street, Sydney, NSW, 2000, Australia."}],"template.project.event.project.privacy.policy.template":[{"type":0,"value":"Privacy policy"}],"template.project.event.project.privacy.policy.template.dot":[{"type":0,"value":"."}],"template.project.event.project.user.invited.collborate.message":[{"type":0,"value":"Collaborate, align, and deliver work, all in "},{"children":[{"type":0,"value":" one place "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.collect.message":[{"type":0,"value":"Collect and send work to other teams or stakeholders using "},{"children":[{"type":0,"value":" forms "}],"type":8,"value":"b"}],"template.project.event.project.user.invited.join.link":[{"type":0,"value":"Join the Project"}],"template.project.event.project.user.invited.learn.more.message":[{"type":0,"value":"Learn more about Jira "}],"template.project.event.project.user.invited.use.jira.generic.message":[{"type":0,"value":"Use Jira to..."}],"template.project.event.project.user.invited.view.work.message":[{"type":0,"value":"View work your way using the "},{"children":[{"type":0,"value":" list, board, calendar "}],"type":8,"value":"b"},{"type":0,"value":" and "},{"children":[{"type":0,"value":" timeline "}],"type":8,"value":"b"},{"type":0,"value":" views"}],"template.subscription.filter.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.html.subset.issue-term-refresh":[{"type":0,"value":"Displaying "},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" matched work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" matched work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":". "}],"template.subscription.filter.html.view.filter.work-items":[{"type":0,"value":"View all of them"}],"template.subscription.filter.redacted.html.edit":[{"type":0,"value":"You may edit this subscription "},{"children":[{"type":0,"value":" here "}],"type":8,"value":"a"},{"type":0,"value":" "}],"template.subscription.filter.redacted.html.view.filter":[{"type":0,"value":"Details are hidden to protect sensitive data. "},{"children":[{"type":0,"value":" View the filter "}],"type":8,"value":"a"},{"type":0,"value":" in Jira"}],"template.subscription.filter.subcount.issue-term-refresh":[{"type":0,"value":"  ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"template.subscription.filter.text.count.issue-term-refresh":[{"type":0,"value":" ("},{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" work item"}]},"other":{"value":[{"type":7},{"type":0,"value":" work items"}]}},"pluralType":"cardinal","type":6,"value":"total"},{"type":0,"value":")"}],"template.subscription.filter.text.subcount.issue-term-refresh":[{"type":0,"value":" ("},{"type":1,"value":"actual"},{"type":0,"value":" of "},{"type":1,"value":"total"},{"type":0,"value":" work items)"}],"user.avatar.alt":[{"type":0,"value":"User avatar"}]}');

});

parcelRegister("18AbW", function(module, exports) {

let $0d429cb08dfaedd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d429cb08dfaedd0$var$load("9H975").then(()=>parcelRequire('3pMf6'));

});

parcelRegister("5TrQ9", function(module, exports) {

let $44a7af4c4e583c16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44a7af4c4e583c16$var$load("jR2lV").then(()=>parcelRequire('7ATou'));

});

parcelRegister("apcQm", function(module, exports) {

let $793633a45813a2df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $793633a45813a2df$var$load("j2Ec8").then(()=>parcelRequire('iPERp'));

});

parcelRegister("38Pio", function(module, exports) {

let $2499e8b81fbe14a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2499e8b81fbe14a0$var$load("4JobB").then(()=>parcelRequire('ilwNa'));

});

parcelRegister("ePu5I", function(module, exports) {

let $acbd2b9427e1aeae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acbd2b9427e1aeae$var$load("kBW39").then(()=>parcelRequire('hGaYG'));

});

parcelRegister("3ie9X", function(module, exports) {

let $265e095c59643f8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $265e095c59643f8c$var$load("2aylT").then(()=>parcelRequire('f9smC'));

});

parcelRegister("f3eB3", function(module, exports) {

let $af527569023a3124$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af527569023a3124$var$load("OuGjy").then(()=>parcelRequire('eTprP'));

});

parcelRegister("4L0cU", function(module, exports) {

let $376bb65be0024c11$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $376bb65be0024c11$var$load("i1dal").then(()=>parcelRequire('7T1D5'));

});

parcelRegister("eQsRU", function(module, exports) {

let $acec50b7b1fe775b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acec50b7b1fe775b$var$load("8iwxF").then(()=>parcelRequire('41yZF'));

});

parcelRegister("hWyGN", function(module, exports) {

let $d102c30304942b96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d102c30304942b96$var$load("aTl5q").then(()=>parcelRequire('282Ch'));

});

parcelRegister("aVyPi", function(module, exports) {

let $7f4a3e070c3f4e1b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f4a3e070c3f4e1b$var$load("5rjaP").then(()=>parcelRequire('4T4PR'));

});

parcelRegister("hkaHC", function(module, exports) {

let $c9cc9b3e58f858c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9cc9b3e58f858c7$var$load("kP4pR").then(()=>parcelRequire('26Zwu'));

});

parcelRegister("7BPcO", function(module, exports) {

let $58a3b57740325c9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58a3b57740325c9b$var$load("dwdIx").then(()=>parcelRequire('ll9qG'));

});

parcelRegister("iiAOW", function(module, exports) {

let $d52678413abdab0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d52678413abdab0e$var$load("cw3qI").then(()=>parcelRequire('3G8I1'));

});

parcelRegister("7vYJq", function(module, exports) {

let $578a89af1db9822f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $578a89af1db9822f$var$load("4GGM3").then(()=>parcelRequire('9N0Km'));

});

parcelRegister("7UAe1", function(module, exports) {

let $5c29dcefb5ccc4e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c29dcefb5ccc4e2$var$load("cuCvR").then(()=>parcelRequire('6ypMh'));

});

parcelRegister("alQ7v", function(module, exports) {

let $78944b7f02d62caa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78944b7f02d62caa$var$load("jHjHj").then(()=>parcelRequire('hnZaI'));

});

parcelRegister("9R1Vi", function(module, exports) {

let $72ca8e31df12311d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $72ca8e31df12311d$var$load("lhvPc").then(()=>parcelRequire('8JrQP'));

});

parcelRegister("9Y5Ly", function(module, exports) {

let $741e30ae42be8052$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $741e30ae42be8052$var$load("99lD1").then(()=>parcelRequire('27Oo7'));

});

parcelRegister("cV5oE", function(module, exports) {

let $967efe9193445bd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $967efe9193445bd2$var$load("3T0Xt").then(()=>parcelRequire('4ySQE'));

});

parcelRegister("7eC1l", function(module, exports) {

let $54475559f8ecd36a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $54475559f8ecd36a$var$load("c6XFt").then(()=>parcelRequire('eied3'));

});

parcelRegister("3DmQG", function(module, exports) {

let $2a56bceb6b45d9be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a56bceb6b45d9be$var$load("dliPD").then(()=>parcelRequire('kDzg3'));

});

parcelRegister("a0gCC", function(module, exports) {

let $7486cc406fe6e801$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7486cc406fe6e801$var$load("gZdAC").then(()=>parcelRequire('1aoyS'));

});

parcelRegister("fkXoM", function(module, exports) {

let $b2a6cc9b66445021$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2a6cc9b66445021$var$load("hiZ4G").then(()=>parcelRequire('h6GGi'));

});

parcelRegister("bkkFx", function(module, exports) {

let $83f198621ac01a9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83f198621ac01a9f$var$load("dj3uv").then(()=>parcelRequire('4RzXz'));

});

parcelRegister("4xEEU", function(module, exports) {

let $34e9c879b7336265$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34e9c879b7336265$var$load("h0RNK").then(()=>parcelRequire('ilsxq'));

});

parcelRegister("cgoSX", function(module, exports) {

let $8eda486683e5658e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8eda486683e5658e$var$load("6NpHC").then(()=>parcelRequire('eoXUj'));

});

parcelRegister("4A4dR", function(module, exports) {

let $355dccbdcfc7a141$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $355dccbdcfc7a141$var$load("9Onj7").then(()=>parcelRequire('4cg1h'));

});

parcelRegister("3tX10", function(module, exports) {

let $2891dbb38871e5b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2891dbb38871e5b3$var$load("25vBs").then(()=>parcelRequire('7oJNO'));

});

parcelRegister("9XdYK", function(module, exports) {

let $73f4779eebf746e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73f4779eebf746e4$var$load("a4EjD").then(()=>parcelRequire('2RHQv'));

});

parcelRegister("kMafC", function(module, exports) {

let $f2003df3c11f3402$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2003df3c11f3402$var$load("eB9by").then(()=>parcelRequire('fjjUa'));

});

parcelRegister("lleYH", function(module, exports) {

let $f8972d70bce1cf63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f8972d70bce1cf63$var$load("dZDiM").then(()=>parcelRequire('i91dS'));

});

parcelRegister("g1YnZ", function(module, exports) {

let $babb94b3509fe47e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $babb94b3509fe47e$var$load("5vsEj").then(()=>parcelRequire('hGl08'));

});

parcelRegister("1LJzY", function(module, exports) {

let $149d89544d92e414$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $149d89544d92e414$var$load("jyMdm").then(()=>parcelRequire('1lGij'));

});

parcelRegister("d9Kla", function(module, exports) {
module.exports = JSON.parse('{"export-issues-flyout-spotlight-tour.spotlight.body":[{"type":0,"value":"Export your work items in the format you need, right from the more actions menu."}],"export-issues-flyout-spotlight-tour.spotlight.heading":[{"type":0,"value":"Export options have moved"}],"export-issues-flyout-spotlight-tour.spotlight.okButton":[{"type":0,"value":"OK"}],"jira-filter-refinement-board-and-backlog.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement-board-and-backlog.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement-board-and-backlog.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement-board-and-backlog.tour.step1Body":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement-board-and-backlog.tour.step1Headline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement-board-and-backlog.tour.step2Body":[{"type":0,"value":"Reorder and pin fields to\xa0prioritize\xa0what matters\xa0most to you."}],"jira-filter-refinement-board-and-backlog.tour.step2Headline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement-board-and-backlog.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-filter-refinement.tour.backButton":[{"type":0,"value":"Back"}],"jira-filter-refinement.tour.doneButton":[{"type":0,"value":"Done"}],"jira-filter-refinement.tour.nextButton":[{"type":0,"value":"Next"}],"jira-filter-refinement.tour.step1Body":[{"type":0,"value":"Save any filter combination to reuse later."}],"jira-filter-refinement.tour.step1Headline":[{"type":0,"value":"Save your filter"}],"jira-filter-refinement.tour.step2Body":[{"type":0,"value":"Add the fields you need and remove the fields you don\u2019t."}],"jira-filter-refinement.tour.step2Headline":[{"type":0,"value":"Add and remove fields"}],"jira-filter-refinement.tour.step3Body":[{"type":0,"value":"Reorder and pin fields to\xa0prioritize\xa0what matters\xa0most to you."}],"jira-filter-refinement.tour.step3Headline":[{"type":0,"value":"Reorder and pin fields"}],"jira-filter-refinement.tour.stepIndicator":[{"type":1,"value":"currentStep"},{"type":0,"value":" of "},{"type":1,"value":"totalSteps"}],"jira-nin-issue-preview-panel-resize.body":[{"type":0,"value":"Drag to resize the panel and view more work item information."}],"jira-nin-issue-preview-panel-resize.heading":[{"type":0,"value":"Expand the panel"}],"jira-nin-issue-preview-panel.body":[{"type":0,"value":"View and edit work items in the new preview panel, while staying on the List."}],"jira-nin-issue-preview-panel.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-issue-preview-panel.heading":[{"type":0,"value":"Access work items instantly"}],"jira-nin-issue-preview-panel.more":[{"type":0,"value":"More about preview panels"}],"jira-nin-issue-preview-panel.new-window":[{"type":0,"value":"(opens in a new window)"}],"jira-nin-issue-preview-panel.tour.arrows-heading":[{"type":0,"value":"Preview your work items"}],"jira-nin-issue-preview-panel.tour.arrows-image-alt":[{"type":0,"value":"Navigation arrows on the glance panel"}],"jira-nin-issue-preview-panel.tour.arrows-modal-body":[{"type":0,"value":"Select the arrows to move through work items. Select minimise to view your work in a preview panel."}],"jira-nin-issue-preview-panel.tour.arrows-panel-body":[{"type":0,"value":"Select the arrows to move through work items. Select expand for modal view."}],"jira-nin-issue-preview-panel.tour.back":[{"type":0,"value":"Back"}],"jira-nin-issue-preview-panel.tour.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-issue-preview-panel.tour.done":[{"type":0,"value":"Done"}],"jira-nin-issue-preview-panel.tour.intro-body":[{"type":0,"value":"View work item details in a layout that works best for your list."}],"jira-nin-issue-preview-panel.tour.intro-heading":[{"type":0,"value":"New ways to view work in context"}],"jira-nin-issue-preview-panel.tour.next":[{"type":0,"value":"Next"}],"jira-nin-issue-preview-panel.tour.resize-body":[{"type":0,"value":"Drag to resize the panel and view more work item information."}],"jira-nin-issue-preview-panel.tour.resize-heading":[{"type":0,"value":"Expand the panel"}],"jira-nin-issue-preview-panel.tour.step-count":[{"type":1,"value":"current"},{"type":0,"value":" of "},{"type":1,"value":"total"}],"jira-nin-list-merge-modal-onboarding-v2.closeButton":[{"type":0,"value":"Close"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsDescription":[{"type":0,"value":"Want us to apply your current filter and group settings to this new List view?"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsNo":[{"type":0,"value":"No"}],"jira-nin-list-merge-modal-onboarding-v2.copyListSettingsYes":[{"type":0,"value":"Yes"}],"jira-nin-list-merge-modal-onboarding-v2.description":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience. A new List view."}],"jira-nin-list-merge-modal-onboarding-v2.filtersAndGroupsDescription":[{"type":0,"value":"Any existing filters and groups will be applied."}],"jira-nin-list-merge-modal-onboarding-v2.heading":[{"type":0,"value":"We\'ve merged List and All Work"}],"jira-nin-list-merge-modal-onboarding-v2.learnMoreLink":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.body":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience. A new List view."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.explore-list-view-button-label":[{"type":0,"value":"Explore List view"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.filter":[{"type":0,"value":"One place to search work and filter results to find what you need."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.heading":[{"type":0,"value":"We\'ve merged List and All Work views"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.more-actions":[{"type":0,"value":"Dive deeper - view work items as a chart, use format rules to highlight key work, and more."}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.next":[{"type":0,"value":"Next"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.ok":[{"type":0,"value":"OK"}],"jira-nin-list-merge-modal-onboarding-v2.spotlight.tell-me-more-aria-label":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.body":[{"type":0,"value":"We\'ve merged the best of List and All Work into a faster, accessible experience."}],"jira-nin-list-merge-spotlight-onboarding.spotlight.dismiss":[{"type":0,"value":"Dismiss"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.heading":[{"type":0,"value":"We\'ve merged List and All Work views"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more":[{"type":0,"value":"Tell me more"}],"jira-nin-list-merge-spotlight-onboarding.spotlight.tell-me-more-aria-label":[{"type":0,"value":"Read our community post about the merge of List and All Work views"}],"jira-nl2jql-ai-filter-changeboarding.spotlight.body":[{"type":0,"value":"We\u2019ve improved AI filtering to give you more accurate results. Just describe what you\u2019re looking for."}],"jira-nl2jql-ai-filter-changeboarding.spotlight.headline":[{"type":0,"value":"Find work faster with AI"}],"jira-nl2jql-ai-filter-changeboarding.spotlight.tryItOutButton":[{"type":0,"value":"Try it out"}],"jira.filter.refinement.filter-popup.changeboarding.description.filter":[{"type":0,"value":"You can now filter work items by status and priority, making it easier to find work."}],"jira.filter.refinement.filter-popup.changeboarding.description.improvements":[{"type":0,"value":"More improvements to come."}],"jira.filter.refinement.filter-popup.changeboarding.description.parent":[{"type":0,"value":"Use the parent filter to search for epics, as well as any other work items with child work items."}],"jira.filter.refinement.filter-popup.changeboarding.dismiss":[{"type":0,"value":"Dismiss"}],"jira.filter.refinement.filter-popup.changeboarding.next":[{"type":0,"value":"Next"}],"jira.filter.refinement.filter-popup.changeboarding.ok":[{"type":0,"value":"OK"}],"jira.filter.refinement.filter-popup.changeboarding.page2.title":[{"type":0,"value":"We\'ve updated epic to parent"}],"jira.filter.refinement.filter-popup.changeboarding.title":[{"type":0,"value":"Introducing a new home for filters"}]}');

});

parcelRegister("ktcOp", function(module, exports) {

let $ee70744c507aaa00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee70744c507aaa00$var$load("1Ms7M").then(()=>parcelRequire('hc7BF'));

});

parcelRegister("iBniq", function(module, exports) {

let $d8adc0d742be624e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8adc0d742be624e$var$load("g9nZd").then(()=>parcelRequire('6x7Wf'));

});

parcelRegister("9E25K", function(module, exports) {

let $705978db2bef7d54$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $705978db2bef7d54$var$load("9MfRk").then(()=>parcelRequire('fcHTk'));

});

parcelRegister("6anjp", function(module, exports) {

let $47d5c2883b89a1fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47d5c2883b89a1fa$var$load("8TJOR").then(()=>parcelRequire('aI1UL'));

});

parcelRegister("luucs", function(module, exports) {

let $fa53d36abbe6b9bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa53d36abbe6b9bd$var$load("8udy0").then(()=>parcelRequire('jxKmu'));

});

parcelRegister("f5joJ", function(module, exports) {

let $afb65eadc03e7348$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $afb65eadc03e7348$var$load("lPTEq").then(()=>parcelRequire('8rN1d'));

});

parcelRegister("6nrI0", function(module, exports) {

let $4a4a6277697d84ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a4a6277697d84ae$var$load("4THFF").then(()=>parcelRequire('9qZYh'));

});

parcelRegister("bxaDU", function(module, exports) {

let $865b0830cdb669c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $865b0830cdb669c9$var$load("c07nz").then(()=>parcelRequire('lL655'));

});

parcelRegister("98EBs", function(module, exports) {

let $6a745b55355e5ebd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a745b55355e5ebd$var$load("kkCU9").then(()=>parcelRequire('lsYsg'));

});

parcelRegister("gE99x", function(module, exports) {

let $c1e77b56f868dde7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1e77b56f868dde7$var$load("13fXN").then(()=>parcelRequire('jO7eN'));

});

parcelRegister("hlhL8", function(module, exports) {

let $ca022c70a16fc01c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca022c70a16fc01c$var$load("7W0qN").then(()=>parcelRequire('3Cqh1'));

});

parcelRegister("9yRox", function(module, exports) {

let $6f60b519b079f7af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6f60b519b079f7af$var$load("41eX3").then(()=>parcelRequire('iW6Wy'));

});

parcelRegister("lQ8wg", function(module, exports) {

let $fe651015e40e8669$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe651015e40e8669$var$load("cfh02").then(()=>parcelRequire('1sCFb'));

});

parcelRegister("jnLzZ", function(module, exports) {

let $e1c5129333456a2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e1c5129333456a2e$var$load("begO5").then(()=>parcelRequire('6qior'));

});

parcelRegister("2C8Xo", function(module, exports) {

let $1e7614098fc5d85e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e7614098fc5d85e$var$load("8tx7H").then(()=>parcelRequire('id4iX'));

});

parcelRegister("5h5os", function(module, exports) {

let $3d72b94a9716722a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d72b94a9716722a$var$load("7IzyO").then(()=>parcelRequire('1Q3kL'));

});

parcelRegister("ei1op", function(module, exports) {

let $a673d3b590b535ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a673d3b590b535ff$var$load("dRvv6").then(()=>parcelRequire('4lX2f'));

});

parcelRegister("9fvHg", function(module, exports) {

let $6bbe1a16306d06c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bbe1a16306d06c2$var$load("bMZ6i").then(()=>parcelRequire('6fjoN'));

});

parcelRegister("hLER0", function(module, exports) {

let $cef6843046890d2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cef6843046890d2f$var$load("9T1xY").then(()=>parcelRequire('9ddlz'));

});

parcelRegister("aFnwY", function(module, exports) {

let $7c3ffc6e53f4c31a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c3ffc6e53f4c31a$var$load("fdC1a").then(()=>parcelRequire('2k2Js'));

});

parcelRegister("0sqpa", function(module, exports) {

let $00160ccac9e938f6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $00160ccac9e938f6$var$load("etiqp").then(()=>parcelRequire('95wyr'));

});

parcelRegister("fVd32", function(module, exports) {

let $b9764ceeda5f6479$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9764ceeda5f6479$var$load("8fQkM").then(()=>parcelRequire('dHoxp'));

});

parcelRegister("bmLRy", function(module, exports) {

let $8466e05112081d4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8466e05112081d4a$var$load("27XGC").then(()=>parcelRequire('dhc7q'));

});

parcelRegister("k3mzK", function(module, exports) {

let $e9959982e1e795ee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9959982e1e795ee$var$load("jP6tH").then(()=>parcelRequire('9detW'));

});

parcelRegister("1Uxdk", function(module, exports) {

let $1644c903370f6a0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1644c903370f6a0f$var$load("blpTr").then(()=>parcelRequire('krxDQ'));

});

parcelRegister("k7AMr", function(module, exports) {

let $ea60fde112b11c49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ea60fde112b11c49$var$load("eiqE0").then(()=>parcelRequire('5fIMo'));

});

parcelRegister("kum9N", function(module, exports) {

let $eea7cbe7f6313604$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eea7cbe7f6313604$var$load("6NqUi").then(()=>parcelRequire('2jWoY'));

});

parcelRegister("1kfoi", function(module, exports) {

let $0f7399014fd9f2af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f7399014fd9f2af$var$load("hJEnB").then(()=>parcelRequire('gUbjY'));

});

parcelRegister("2UjWQ", function(module, exports) {

let $21e04901ed75854e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21e04901ed75854e$var$load("7yXxF").then(()=>parcelRequire('aYy4X'));

});

parcelRegister("jaQ6u", function(module, exports) {

let $df575e2d729117ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $df575e2d729117ca$var$load("fbON9").then(()=>parcelRequire('b8clR'));

});

parcelRegister("hMVdN", function(module, exports) {

let $cf334e5dcb70b3f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf334e5dcb70b3f1$var$load("iJrtF").then(()=>parcelRequire('8uAmU'));

});

parcelRegister("6pAEW", function(module, exports) {

let $4ab183a8c5dfe625$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ab183a8c5dfe625$var$load("kIyIG").then(()=>parcelRequire('kN7Rq'));

});

parcelRegister("kzCrI", function(module, exports) {

let $efa4e620dae3d6af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $efa4e620dae3d6af$var$load("1RNDi").then(()=>parcelRequire('8lOUT'));

});

parcelRegister("gKRAQ", function(module, exports) {

let $c32a83bfbf473f15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c32a83bfbf473f15$var$load("b4gHG").then(()=>parcelRequire('997Tf'));

});

parcelRegister("gK3zM", function(module, exports) {
module.exports = JSON.parse('{"jira-pandora.common.footer.address.no-translate":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"jira-pandora.common.footer.copyright.no-translate":[{"type":0,"value":"Copyright 2025 Atlassian Pty Ltd. All rights reserved."}],"jira-pandora.common.project-access-email.banner.alt":[{"type":0,"value":"Jira banner image"}],"jira-pandora.internal-app-request.manage-connections":[{"type":0,"value":"Manage connections"}],"jira-pandora.jira-code-reviewer-growth.default.cta":[{"type":0,"value":"Review every new pull request"}],"jira-pandora.jira-code-reviewer-growth.default.description":[{"type":0,"value":"Get feedback on pull requests automatically, without needing to start each review manually."}],"jira-pandora.jira-code-reviewer-growth.default.heading":[{"type":0,"value":"Catch issues earlier"}],"jira-pandora.jira-code-reviewer-growth.default.hide":[{"type":0,"value":"Hide suggestion"}],"jira-pandora.jira-code-reviewer-growth.default.menuLabel":[{"type":0,"value":"More actions for Code Reviewer"}],"jira-pandora.jira-code-reviewer-growth.try.cta":[{"type":0,"value":"How to use Code Reviewer"}],"jira-pandora.jira-code-reviewer-growth.try.description":[{"type":0,"value":"Get feedback on pull requests to highlight quality, security, and performance issues in your code."}],"jira-pandora.jira-code-reviewer-growth.try.heading":[{"type":0,"value":"Try Code Reviewer"}],"jira-pandora.jira-code-reviewer-growth.try.hide":[{"type":0,"value":"Hide suggestion"}],"jira-pandora.jira-code-reviewer-growth.try.menuLabel":[{"type":0,"value":"More actions for Code Reviewer"}],"jira-pandora.jira-internal-app-request-admin-daily-summary.email.redacted.body.generic":[{"type":0,"value":"Review the requests from people on your site."}],"jira-pandora.jira-internal-app-request-admin-daily-summary.email.redacted.heading.generic":[{"type":0,"value":"You have new requests to review"}],"jira-pandora.jira-internal-app-request-admin-daily-summary.email.redacted.subject.generic":[{"type":0,"value":"You have new requests to review"}],"jira-pandora.jira-internal-app-request-admin-daily-summary.email.subject.generic":[{"type":0,"value":"You have new requests to review"}],"jira-pandora.jira-internal-app-request-admin-daily-summary.manage-connections":[{"type":0,"value":"Manage connections"}],"jira-pandora.jira-internal-app-request-admin-daily-summary.request-count.generic":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" person requested this"}]},"other":{"value":[{"type":7},{"type":0,"value":" people requested this"}]}},"pluralType":"cardinal","type":6,"value":"requesterCount"}],"jira-pandora.jira-internal-app-request-admin-daily-summary.summary":[{"offset":0,"options":{"one":{"value":[{"type":7},{"type":0,"value":" person requested "},{"type":1,"value":"appName"}]},"other":{"value":[{"type":7},{"type":0,"value":" people requested "},{"type":1,"value":"appName"}]}},"pluralType":"cardinal","type":6,"value":"requesterCount"}],"jira-pandora.jira-internal-app-request-installed.email.body.generic":[{"type":0,"value":"Your admin has fulfilled your request."}],"jira-pandora.jira-internal-app-request-installed.email.heading.generic":[{"type":0,"value":"Your request for "},{"type":1,"value":"appName"},{"type":0,"value":" has been fulfilled"}],"jira-pandora.jira-internal-app-request-installed.email.redacted.body.generic":[{"type":0,"value":"Your admin has fulfilled your request."}],"jira-pandora.jira-internal-app-request-installed.email.redacted.heading.generic":[{"type":0,"value":"Your request has been fulfilled"}],"jira-pandora.jira-internal-app-request-installed.email.redacted.subject.generic":[{"type":0,"value":"Your request has been fulfilled"}],"jira-pandora.jira-internal-app-request-installed.email.subject.generic":[{"type":0,"value":"Your request for "},{"type":1,"value":"appName"},{"type":0,"value":" has been fulfilled"}],"jira-pandora.jira-internal-app-request-installed.notification-drawer.message.generic":[{"type":0,"value":"Your request for "},{"type":1,"value":"appName"},{"type":0,"value":" has been fulfilled"}],"jira-pandora.jira-internal-app-request-rejection.email.body":[{"type":0,"value":"Your admin rejected your request for "},{"type":1,"value":"appName"},{"type":0,"value":"."}],"jira-pandora.jira-internal-app-request-rejection.email.heading":[{"type":0,"value":"Your admin rejected your request for "},{"type":1,"value":"appName"}],"jira-pandora.jira-internal-app-request-rejection.email.reason":[{"type":0,"value":"Reason from your admin"}],"jira-pandora.jira-internal-app-request-rejection.email.redacted.body.generic":[{"type":0,"value":"Your admin rejected your request."}],"jira-pandora.jira-internal-app-request-rejection.email.redacted.heading.generic":[{"type":0,"value":"Your request was rejected"}],"jira-pandora.jira-internal-app-request-rejection.email.redacted.subject.generic":[{"type":0,"value":"Your request was rejected"}],"jira-pandora.jira-internal-app-request-rejection.email.subject":[{"type":0,"value":"Your admin rejected your request for "},{"type":1,"value":"appName"}],"jira-pandora.jira-internal-app-request-rejection.notification-drawer.message":[{"type":0,"value":"Your admin rejected your request for "},{"type":1,"value":"appName"}],"jira-pandora.jira-internal-app-request-submission.email.body":[{"type":0,"value":"Your request for "},{"type":1,"value":"appName"},{"type":0,"value":" has been sent to your admin."}],"jira-pandora.jira-internal-app-request-submission.email.heading":[{"type":0,"value":"You requested "},{"type":1,"value":"appName"}],"jira-pandora.jira-internal-app-request-submission.email.redacted.body.generic":[{"type":0,"value":"Your request has been sent to your admin."}],"jira-pandora.jira-internal-app-request-submission.email.redacted.heading.generic":[{"type":0,"value":"Your request was submitted"}],"jira-pandora.jira-internal-app-request-submission.email.redacted.subject.generic":[{"type":0,"value":"Your request was submitted"}],"jira-pandora.jira-internal-app-request-submission.email.subject":[{"type":0,"value":"You requested "},{"type":1,"value":"appName"}],"jira-pandora.jira-internal-app-request-submission.notification-drawer.message":[{"type":0,"value":"You requested "},{"type":1,"value":"appName"}],"jira-pandora.jira-onboarding-hub-welcome-modal.screen-space-flags.description.no-translate":[{"type":0,"value":"At Atlassian, we use Jira to plan and manage work. We created a Jira board to help you manage your onboarding to-do list (you may have a separate list if you\u2019re in TEAM Camp). This Jira board is filled with tasks, required to-do\'s, and recommended content. You can think of it as your personal tracker for the onboarding process! Follow it each day and be sure to mark items complete."}],"jira-pandora.jira-onboarding-hub-welcome-modal.screen-space-flags.title.no-translate":[{"type":0,"value":"Hi Newlassian, welcome to Jira!"}],"jira-pandora.jira-project-access-granted.email.body.content":[{"type":0,"value":"You can now access "},{"children":[{"type":1,"value":"projectName"}],"type":8,"value":"b"}],"jira-pandora.jira-project-access-granted.email.body.redacted.content":[{"children":[{"type":0,"value":"You can now access your Jira project"}],"type":8,"value":"b"}],"jira-pandora.jira-project-access-granted.email.button.redacted.text":[{"type":0,"value":"View project"}],"jira-pandora.jira-project-access-granted.email.button.text":[{"type":0,"value":"View project"}],"jira-pandora.jira-project-access-granted.message-template.email.redacted.subject":[{"type":0,"value":"You\'ve been granted access to your project"}],"jira-pandora.jira-project-access-granted.message-template.email.subject":[{"type":0,"value":"You\'ve been granted access to "},{"type":1,"value":"projectName"}],"jira-pandora.jira-project-access-request-reminder.email.body.content":[{"type":0,"value":"Users have requested to join "},{"children":[{"type":1,"value":"projectName"}],"type":8,"value":"b"},{"type":0,"value":" project"}],"jira-pandora.jira-project-access-request-reminder.email.body.redacted.content":[{"children":[{"type":0,"value":"Users have requested to join your Jira project"}],"type":8,"value":"b"}],"jira-pandora.jira-project-access-request-reminder.email.button.redacted.text":[{"type":0,"value":"View access requests"}],"jira-pandora.jira-project-access-request-reminder.email.button.text":[{"type":0,"value":"View access requests"}],"jira-pandora.jira-project-access-request-reminder.message-template.email.redacted.subject":[{"type":0,"value":"Access request for your project"}],"jira-pandora.jira-project-access-request-reminder.message-template.email.subject":[{"type":0,"value":"Access request for "},{"type":1,"value":"projectName"}],"jira-sprints-auto-managed-feature-discovery.spotlight-content":[{"type":0,"value":"Sprints can now start and complete automatically based on their scheduled dates."}],"jira-sprints-auto-managed-feature-discovery.spotlight-cta-button-label":[{"type":0,"value":"See how"}],"jira-sprints-auto-managed-feature-discovery.spotlight-headline":[{"type":0,"value":"Automate your sprint transitions"}]}');

});

parcelRegister("dC2IS", function(module, exports) {

let $9e90efa6c4f35e23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e90efa6c4f35e23$var$load("j91ZG").then(()=>parcelRequire('7D5qo'));

});

parcelRegister("aIZAP", function(module, exports) {

let $7cedca82960e51c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7cedca82960e51c8$var$load("eqb80").then(()=>parcelRequire('3R11v'));

});

parcelRegister("hWcFz", function(module, exports) {

let $d0f1ae51b50ed4be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d0f1ae51b50ed4be$var$load("7U0ZZ").then(()=>parcelRequire('kSReM'));

});

parcelRegister("i96r9", function(module, exports) {

let $d35e0f82ab6414a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d35e0f82ab6414a6$var$load("dFx6Z").then(()=>parcelRequire('hxna1'));

});

parcelRegister("3nia2", function(module, exports) {

let $27519b7bc2d3145c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27519b7bc2d3145c$var$load("3ZKoa").then(()=>parcelRequire('29L2I'));

});

parcelRegister("da2r6", function(module, exports) {

let $994e194c25680776$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $994e194c25680776$var$load("lG9oH").then(()=>parcelRequire('1srhl'));

});

parcelRegister("bXNpI", function(module, exports) {

let $8b5b88f50c71bc2b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b5b88f50c71bc2b$var$load("iFAZb").then(()=>parcelRequire('8WQ9T'));

});

parcelRegister("66n3X", function(module, exports) {

let $4715316a88f66b8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4715316a88f66b8d$var$load("3qfa1").then(()=>parcelRequire('eZNsU'));

});

parcelRegister("cpZ6Z", function(module, exports) {

let $90a7395d788ada6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90a7395d788ada6e$var$load("4X4ps").then(()=>parcelRequire('gRIfA'));

});

parcelRegister("4ET6R", function(module, exports) {

let $3645a57fb3848d5c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3645a57fb3848d5c$var$load("flwJx").then(()=>parcelRequire('fX373'));

});

parcelRegister("9VSom", function(module, exports) {

let $73b3a108640df010$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $73b3a108640df010$var$load("fWeSS").then(()=>parcelRequire('imzoA'));

});

parcelRegister("SDfFq", function(module, exports) {

let $0a437dd45ab69394$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0a437dd45ab69394$var$load("bVmut").then(()=>parcelRequire('cvfgq'));

});

parcelRegister("bt1SJ", function(module, exports) {

let $8593dcd73d1efee3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8593dcd73d1efee3$var$load("67MZP").then(()=>parcelRequire('4Ag7T'));

});

parcelRegister("lzChE", function(module, exports) {

let $fb4a9037f3c22e54$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fb4a9037f3c22e54$var$load("aYIpK").then(()=>parcelRequire('gfniG'));

});

parcelRegister("hXmDf", function(module, exports) {

let $d12980a1590d6e1f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d12980a1590d6e1f$var$load("6IsAQ").then(()=>parcelRequire('hbq8w'));

});

parcelRegister("aUZ8j", function(module, exports) {

let $7f2e8e1f856077ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f2e8e1f856077ae$var$load("9RuM8").then(()=>parcelRequire('3clIp'));

});

parcelRegister("1u6AF", function(module, exports) {

let $114db481c6ee5500$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $114db481c6ee5500$var$load("bbY5v").then(()=>parcelRequire('dEoj3'));

});

parcelRegister("sImHY", function(module, exports) {

let $056507a806be8009$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $056507a806be8009$var$load("bBEqB").then(()=>parcelRequire('f9qcJ'));

});

parcelRegister("fcZIE", function(module, exports) {

let $b127da2843347986$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b127da2843347986$var$load("hZuNW").then(()=>parcelRequire('bd79y'));

});

parcelRegister("16P0m", function(module, exports) {

let $0cedea745db8bf19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0cedea745db8bf19$var$load("fCREn").then(()=>parcelRequire('6lQ38'));

});

parcelRegister("7vwBZ", function(module, exports) {

let $5774b9a5dc5a4d4b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5774b9a5dc5a4d4b$var$load("j3ukk").then(()=>parcelRequire('4izHB'));

});

parcelRegister("cVRT2", function(module, exports) {

let $96a49bad274603e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $96a49bad274603e6$var$load("aCEjw").then(()=>parcelRequire('lXjqY'));

});

parcelRegister("8JdZ1", function(module, exports) {

let $65ad5f7cc86c22c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65ad5f7cc86c22c1$var$load("7rweH").then(()=>parcelRequire('fh4F3'));

});

parcelRegister("guipf", function(module, exports) {

let $c00db9c2fd1fd5a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c00db9c2fd1fd5a0$var$load("hp02C").then(()=>parcelRequire('byToY'));

});

parcelRegister("k0CnR", function(module, exports) {

let $e91194f8470d664b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e91194f8470d664b$var$load("f1zfJ").then(()=>parcelRequire('in4jU'));

});

parcelRegister("b8ebr", function(module, exports) {

let $81ab719f6bb031a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $81ab719f6bb031a6$var$load("8MNFC").then(()=>parcelRequire('7gyT3'));

});

parcelRegister("6NLKW", function(module, exports) {

let $4f3c5d13033f0bb6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f3c5d13033f0bb6$var$load("6ELou").then(()=>parcelRequire('kIehH'));

});

parcelRegister("kh1Vy", function(module, exports) {

let $ec26e3ea75b9d40a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ec26e3ea75b9d40a$var$load("jh1c7").then(()=>parcelRequire('5AXUg'));

});

parcelRegister("3gqHa", function(module, exports) {

let $260792d113d7c388$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $260792d113d7c388$var$load("9S5ny").then(()=>parcelRequire('lJ1bX'));

});

parcelRegister("gVvdw", function(module, exports) {

let $c52a2f47ad5f5828$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c52a2f47ad5f5828$var$load("hIDvy").then(()=>parcelRequire('drmZg'));

});

parcelRegister("3vvpd", function(module, exports) {

let $28dca0debc1645a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $28dca0debc1645a4$var$load("gXhOE").then(()=>parcelRequire('frwJg'));

});

parcelRegister("4yDFm", function(module, exports) {

let $35191b46f85ed341$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35191b46f85ed341$var$load("jq7RW").then(()=>parcelRequire('5uBij'));

});

parcelRegister("9ZMNS", function(module, exports) {

let $746faaea66037fcd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $746faaea66037fcd$var$load("bc9eO").then(()=>parcelRequire('kjvLv'));

});

parcelRegister("dFCLX", function(module, exports) {

let $9f3d2e1a8a86bc5d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f3d2e1a8a86bc5d$var$load("8DjHZ").then(()=>parcelRequire('debUt'));

});

parcelRegister("6HVff", function(module, exports) {
module.exports = JSON.parse("{\"jsm-sherpas.jira-screen-modal.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"jsm-sherpas.jira-screen-modal.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.closing\":[{\"type\":0,\"value\":\"Launch your space today to give your team a single, self-service entry point for HR help.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact\":[{\"type\":0,\"value\":\"Please \"},{\"type\":1,\"value\":\"contactUsLink\"},{\"type\":0,\"value\":\" with any questions, we're always happy to help.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.contact-us-link\":[{\"type\":0,\"value\":\"contact us\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.cta\":[{\"type\":0,\"value\":\"Go to your space\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.greeting\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.heading\":[{\"type\":0,\"value\":\"Bring your HR team together in Jira Service Management\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.intro\":[{\"type\":0,\"value\":\"You recently started an HR service space, but it looks like your team hasn't moved in yet. When you're ready, Jira Service Management can help you centralize requests and track onboarding in one place.\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.signoff\":[{\"type\":0,\"value\":\"Cheers,\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-1\":[{\"children\":[{\"type\":0,\"value\":\"Add team members\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" as agents to handle requests\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-2\":[{\"children\":[{\"type\":0,\"value\":\"Set up request types\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" like \\\"New hire onboarding\\\"\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.step-3\":[{\"children\":[{\"type\":0,\"value\":\"Publish your portal\"}],\"type\":8,\"value\":\"b\"},{\"type\":0,\"value\":\" so employees can find help\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.steps-heading\":[{\"type\":0,\"value\":\"Get started in three steps:\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.body.team-name\":[{\"type\":0,\"value\":\"The Atlassians\"}],\"jsm-sherpas.jsm-hr-dormant-project-email.email.subject\":[{\"type\":0,\"value\":\"Quick check-in on your HR service space\"}]}");

});

parcelRegister("2Kd6C", function(module, exports) {

let $1ffa0b29e13093f0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ffa0b29e13093f0$var$load("4M9gU").then(()=>parcelRequire('5iEs0'));

});

parcelRegister("lw41y", function(module, exports) {

let $fa9fb53b7e4120c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa9fb53b7e4120c7$var$load("62NPr").then(()=>parcelRequire('l1o7E'));

});

parcelRegister("crUJD", function(module, exports) {

let $910404121c0ecade$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $910404121c0ecade$var$load("9OYkz").then(()=>parcelRequire('ew50i'));

});

parcelRegister("b1wqV", function(module, exports) {

let $02123574b2a5e2ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $02123574b2a5e2ba$var$load("hEbOm").then(()=>parcelRequire('4VqWk'));

});

parcelRegister("g6r7n", function(module, exports) {

let $bb923dee204af4b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb923dee204af4b6$var$load("6EaIq").then(()=>parcelRequire('fQS9W'));

});

parcelRegister("3VXaK", function(module, exports) {

let $2dd49857a8d19404$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dd49857a8d19404$var$load("6qmG0").then(()=>parcelRequire('61tl1'));

});

parcelRegister("6dDc8", function(module, exports) {

let $48725c38ed8781bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48725c38ed8781bf$var$load("gFZTd").then(()=>parcelRequire('iK0uC'));

});

parcelRegister("aIzii", function(module, exports) {

let $7cd9641d670e1d7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7cd9641d670e1d7e$var$load("ioyvr").then(()=>parcelRequire('ff3i7'));

});

parcelRegister("83hQf", function(module, exports) {

let $5dcc71835dbfc6b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5dcc71835dbfc6b7$var$load("9Z0Fu").then(()=>parcelRequire('81vin'));

});

parcelRegister("cQcQk", function(module, exports) {

let $95944db4985c79a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $95944db4985c79a4$var$load("cXaEa").then(()=>parcelRequire('53k1V'));

});

parcelRegister("6YyWh", function(module, exports) {

let $514372d126fbb9b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $514372d126fbb9b8$var$load("g2VgR").then(()=>parcelRequire('lHOoU'));

});

parcelRegister("5Z7pM", function(module, exports) {

let $45b866af14464219$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45b866af14464219$var$load("iJHt2").then(()=>parcelRequire('jwGsZ'));

});

parcelRegister("2rBOg", function(module, exports) {

let $1c7b6e9de4126c41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c7b6e9de4126c41$var$load("afdDN").then(()=>parcelRequire('gZgD2'));

});

parcelRegister("aVKau", function(module, exports) {

let $7f530a4bab3d7a13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f530a4bab3d7a13$var$load("e8q4A").then(()=>parcelRequire('9aJM5'));

});

parcelRegister("e0dbW", function(module, exports) {

let $a31b4c5635459737$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a31b4c5635459737$var$load("hl8UQ").then(()=>parcelRequire('hzR9x'));

});

parcelRegister("h7c5Y", function(module, exports) {

let $c75c78ff5162ee45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c75c78ff5162ee45$var$load("b9Ezt").then(()=>parcelRequire('8O7b5'));

});

parcelRegister("3zn4F", function(module, exports) {

let $29968a11cc761b35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $29968a11cc761b35$var$load("eSj9v").then(()=>parcelRequire('9rP2W'));

});

parcelRegister("6Pqb8", function(module, exports) {

let $4f8bd00be3d06a1f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f8bd00be3d06a1f$var$load("411Xv").then(()=>parcelRequire('cTKB1'));

});

parcelRegister("f09u8", function(module, exports) {

let $aebe36a55a4b7b7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aebe36a55a4b7b7a$var$load("3tIuh").then(()=>parcelRequire('grZPa'));

});

parcelRegister("f8znK", function(module, exports) {

let $b0530c7f31ebc629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0530c7f31ebc629$var$load("3IzUl").then(()=>parcelRequire('dmX3a'));

});

parcelRegister("bKnCl", function(module, exports) {

let $88d64f8bb54a2d7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $88d64f8bb54a2d7b$var$load("eXAqK").then(()=>parcelRequire('dSGyX'));

});

parcelRegister("9Tbjf", function(module, exports) {

let $733205f471566904$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $733205f471566904$var$load("5p2vG").then(()=>parcelRequire('8wCOZ'));

});

parcelRegister("7tpoI", function(module, exports) {

let $570ef14213e4bfde$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $570ef14213e4bfde$var$load("kyCKW").then(()=>parcelRequire('ejSw3'));

});

parcelRegister("1NbHf", function(module, exports) {

let $14e370b7936c2459$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14e370b7936c2459$var$load("fHfwP").then(()=>parcelRequire('2QJch'));

});

parcelRegister("3HIVY", function(module, exports) {

let $2b283e33b0155703$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b283e33b0155703$var$load("5MGgR").then(()=>parcelRequire('20aSF'));

});

parcelRegister("a8ohm", function(module, exports) {

let $760d7c0f377be919$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $760d7c0f377be919$var$load("fyT30").then(()=>parcelRequire('eJKFa'));

});

parcelRegister("ivZD4", function(module, exports) {

let $d7aaed8225e9fdd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7aaed8225e9fdd2$var$load("bbzLK").then(()=>parcelRequire('bAncG'));

});

parcelRegister("iSxsK", function(module, exports) {

let $dbe73a1f8d50237e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dbe73a1f8d50237e$var$load("jckkN").then(()=>parcelRequire('69PuF'));

});

parcelRegister("RcCEN", function(module, exports) {

let $09febdeaef9e8c58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $09febdeaef9e8c58$var$load("d0q5G").then(()=>parcelRequire('7Opv9'));

});

parcelRegister("bgfWq", function(module, exports) {

let $832d8df773ec8c4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $832d8df773ec8c4e$var$load("ePad5").then(()=>parcelRequire('41kf5'));

});

parcelRegister("imUvr", function(module, exports) {

let $d5f61cff04498b35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5f61cff04498b35$var$load("8vDlN").then(()=>parcelRequire('2g443'));

});

parcelRegister("gCVPz", function(module, exports) {

let $c1ad0df6e6d62208$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1ad0df6e6d62208$var$load("bPMV3").then(()=>parcelRequire('5hDHL'));

});

parcelRegister("afU4v", function(module, exports) {

let $7776ccbea065fc8c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7776ccbea065fc8c$var$load("320QW").then(()=>parcelRequire('dhfMB'));

});

parcelRegister("aK9R1", function(module, exports) {

let $7d25d81ae966c42b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d25d81ae966c42b$var$load("3tmz7").then(()=>parcelRequire('3FmP7'));

});

parcelRegister("b9hxd", function(module, exports) {
module.exports = JSON.parse('{"jsm-phantom.jira-space-settings-playbooks-navigation-spotlight.screen-space-flags.description.no-translate":[{"type":0,"value":"Replace this with a short summary of what this message tells the recipient."}],"jsm-phantom.jira-space-settings-playbooks-navigation-spotlight.screen-space-flags.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-close-button":[{"type":0,"value":"Close"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-first-line":[{"type":0,"value":"Follow step-by-step guidance and run automate actions to resolve work faster."}],"post-office.jsm-phantom.issue-view.playbook.spotlight-heading":[{"type":0,"value":"Resolve work items faster with playbooks"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-learn-more":[{"type":0,"value":"Learn more about playbooks"}],"post-office.jsm-phantom.issue-view.playbook.spotlight-second-line":[{"type":0,"value":"No playbook yet? Share your runbooks with project admin to turn them into actionable playbooks."}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-close-button":[{"type":0,"value":"Close"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-first-line":[{"type":0,"value":"Create reusable playbooks from runbooks, SOPs, and how-tos to give your team step-by-step guidance and automated actions to resolve work items faster, right in context."}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-heading":[{"type":0,"value":"Turn your team\u2019s knowledge into playbooks"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight-learn-more":[{"type":0,"value":"Learn more about playbooks"}],"post-office.jsm-phantom.space-settings.playbook-nav.spotlight.create-playbook":[{"type":0,"value":"Create playbook"}]}');

});

parcelRegister("gFZts", function(module, exports) {

let $c240292dbf42a2b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c240292dbf42a2b4$var$load("g731f").then(()=>parcelRequire('gXkR8'));

});

parcelRegister("eWItg", function(module, exports) {

let $ae18fa7af95f010c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae18fa7af95f010c$var$load("dp2jt").then(()=>parcelRequire('ekUbo'));

});

parcelRegister("78918", function(module, exports) {

let $5310466a1a2f1853$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5310466a1a2f1853$var$load("8cHEI").then(()=>parcelRequire('2rGO2'));

});

parcelRegister("gJib5", function(module, exports) {

let $c2def30f988c0a48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2def30f988c0a48$var$load("i74Oi").then(()=>parcelRequire('aDQGW'));

});

parcelRegister("1sFPA", function(module, exports) {

let $1108dac4d8bd5dfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1108dac4d8bd5dfa$var$load("5c1dQ").then(()=>parcelRequire('cg7lg'));

});

parcelRegister("cwUFF", function(module, exports) {

let $91f46ee283d666c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f46ee283d666c3$var$load("2lb6C").then(()=>parcelRequire('3Epo6'));

});

parcelRegister("6dvF9", function(module, exports) {

let $486c848588c3aa89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $486c848588c3aa89$var$load("4gXw8").then(()=>parcelRequire('lh0tz'));

});

parcelRegister("csb1s", function(module, exports) {

let $9110a6647b4a9f24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9110a6647b4a9f24$var$load("iCR06").then(()=>parcelRequire('4zXN0'));

});

parcelRegister("bCHa3", function(module, exports) {

let $8764b940c05ae3b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8764b940c05ae3b0$var$load("80ZsV").then(()=>parcelRequire('5xmUO'));

});

parcelRegister("553z6", function(module, exports) {

let $3b302f561946e66f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b302f561946e66f$var$load("khpL1").then(()=>parcelRequire('1AJnC'));

});

parcelRegister("14QYC", function(module, exports) {

let $0c8f423ae3392b5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0c8f423ae3392b5e$var$load("dck3v").then(()=>parcelRequire('9jWY7'));

});

parcelRegister("iTvo8", function(module, exports) {

let $dc15b617222fa4be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc15b617222fa4be$var$load("fXGdz").then(()=>parcelRequire('fdJi1'));

});

parcelRegister("22MCk", function(module, exports) {

let $17d17b04054099c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17d17b04054099c4$var$load("q0cUM").then(()=>parcelRequire('hWhdh'));

});

parcelRegister("3W3fm", function(module, exports) {

let $2dd94ea21d852a8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dd94ea21d852a8d$var$load("jPNKi").then(()=>parcelRequire('31pQW'));

});

parcelRegister("5k5XS", function(module, exports) {

let $3e03727cd30a9cb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3e03727cd30a9cb0$var$load("2Uj5H").then(()=>parcelRequire('hFueX'));

});

parcelRegister("kGoGQ", function(module, exports) {

let $f0eae1d673d98d0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0eae1d673d98d0b$var$load("7sqwa").then(()=>parcelRequire('4XFbr'));

});

parcelRegister("eyOq1", function(module, exports) {

let $a99b59c5bac73238$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a99b59c5bac73238$var$load("gsGjU").then(()=>parcelRequire('4DIXi'));

});

parcelRegister("2desL", function(module, exports) {

let $19c803b01a928407$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19c803b01a928407$var$load("29QG4").then(()=>parcelRequire('1YxK5'));

});

parcelRegister("6ruAp", function(module, exports) {

let $4b0cfd78210a302c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b0cfd78210a302c$var$load("jdfXm").then(()=>parcelRequire('eh53f'));

});

parcelRegister("gxAUL", function(module, exports) {

let $c0ac5cdd3d563bd6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0ac5cdd3d563bd6$var$load("g2E6R").then(()=>parcelRequire('e7QVA'));

});

parcelRegister("7xXf0", function(module, exports) {

let $57e991822880a7f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $57e991822880a7f8$var$load("9pOEg").then(()=>parcelRequire('ddkGO'));

});

parcelRegister("6xmsq", function(module, exports) {

let $4c273eb85e013bc7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c273eb85e013bc7$var$load("3IA1C").then(()=>parcelRequire('fGplT'));

});

parcelRegister("lStcL", function(module, exports) {

let $fed54b97f7b55bed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fed54b97f7b55bed$var$load("lkiub").then(()=>parcelRequire('b4bht'));

});

parcelRegister("dwuVP", function(module, exports) {

let $9d8641e43c665d51$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d8641e43c665d51$var$load("8Szhy").then(()=>parcelRequire('dHTzR'));

});

parcelRegister("9uf6k", function(module, exports) {

let $6e82a127330bad3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e82a127330bad3d$var$load("aAjPW").then(()=>parcelRequire('8N4YE'));

});

parcelRegister("19tni", function(module, exports) {

let $0d6d6ae74a295601$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d6d6ae74a295601$var$load("3CgQU").then(()=>parcelRequire('dVInm'));

});

parcelRegister("fI7ZB", function(module, exports) {

let $b7012a392b284492$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7012a392b284492$var$load("aH9hz").then(()=>parcelRequire('4EDRK'));

});

parcelRegister("4QBCK", function(module, exports) {

let $38793410994b5bb9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38793410994b5bb9$var$load("4maWX").then(()=>parcelRequire('hxlEI'));

});

parcelRegister("lf5sD", function(module, exports) {

let $f76f3c1c0cced188$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f76f3c1c0cced188$var$load("2o4Wm").then(()=>parcelRequire('4N68Y'));

});

parcelRegister("ewCAm", function(module, exports) {

let $a931fc19b33b6ce8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a931fc19b33b6ce8$var$load("2x412").then(()=>parcelRequire('00Mm5'));

});

parcelRegister("gSOTt", function(module, exports) {

let $c4a92aec1d40963e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4a92aec1d40963e$var$load("PYk2N").then(()=>parcelRequire('iyFSu'));

});

parcelRegister("9b0w8", function(module, exports) {

let $6ae58ad715618026$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ae58ad715618026$var$load("Lfv9s").then(()=>parcelRequire('6yPaB'));

});

parcelRegister("9ejEW", function(module, exports) {

let $6b84abd0a39e70d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b84abd0a39e70d1$var$load("7muI7").then(()=>parcelRequire('fmoP3'));

});

parcelRegister("bMYzJ", function(module, exports) {

let $89532a62e40ef6b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89532a62e40ef6b4$var$load("9XTcG").then(()=>parcelRequire('3HIEW'));

});

parcelRegister("lpVVF", function(module, exports) {
module.exports = JSON.parse('{"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.address":[{"type":0,"value":"341 George Street, Sydney, NSW, 2000, Australia"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.copyright":[{"type":0,"value":"Copyright "},{"type":1,"value":"year"},{"type":0,"value":" Atlassian Pty Ltd. All rights reserved."}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.cta.shift-details":[{"type":0,"value":"View shift details"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.cta.work-items":[{"type":0,"value":"View work items"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.heading":[{"type":0,"value":"Your shift in "},{"type":1,"value":"scheduleName"},{"type":0,"value":" starts in "},{"type":1,"value":"leadMinutes"},{"type":0,"value":" minutes"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.preferences":[{"type":0,"value":"Manage notifications for your schedules"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.shift-ends.label":[{"type":0,"value":"Shift ends:"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.email.body.shift-starts.label":[{"type":0,"value":"Shift starts:"}],"jsm-core-capabilities.jsm-workforce-upcoming-shift-reminder.message-template.email.subject":[{"type":0,"value":"Your shift in "},{"type":1,"value":"scheduleName"},{"type":0,"value":" starts soon"}],"jsm-project-summary-onboarding.changeLayout":[{"type":0,"value":"Change the layout and order of charts"}],"jsm-project-summary-onboarding.closeButton":[{"type":0,"value":"Close"}],"jsm-project-summary-onboarding.description":[{"type":0,"value":"You can now edit the summary page to keep your team up to date. Tailor your space overview by customizing the layout, filters, and charts."}],"jsm-project-summary-onboarding.editFilters":[{"type":0,"value":"Edit filters"}],"jsm-project-summary-onboarding.heading":[{"type":0,"value":"Edit your space summary"}],"jsm-project-summary-onboarding.hideAddCharts":[{"type":0,"value":"Hide or add charts"}],"jsm-project-summary-onboarding.moreAboutFeature":[{"type":0,"value":"More about space summary"}],"jsm-project-summary-onboarding.okButton":[{"type":0,"value":"Got it"}],"jsm-project-summary-onboarding.whatsNewTitle":[{"type":0,"value":"What\u2019s new?"}],"jsm-wfm-setup-completion-reminder.body-nonfinal":[{"type":0,"value":"Start routing work to agents based on schedules, availability, and capacity."}],"jsm-wfm-setup-completion-reminder.cta-nonfinal":[{"type":0,"value":"Set up"}],"jsm-wfm-setup-completion-reminder.dismiss-nonfinal":[{"type":0,"value":"Dismiss"}],"jsm-wfm-setup-completion-reminder.title-nonfinal":[{"type":0,"value":"Set up workforce management"}]}');

});

parcelRegister("acziF", function(module, exports) {

let $76d6684155d91efa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76d6684155d91efa$var$load("clzDl").then(()=>parcelRequire('c4uOe'));

});

parcelRegister("jP4Dk", function(module, exports) {

let $e6e65fd11289375c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6e65fd11289375c$var$load("80U4D").then(()=>parcelRequire('dvadT'));

});

parcelRegister("g9Mmd", function(module, exports) {

let $bc32ff5b0d0ba770$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc32ff5b0d0ba770$var$load("j2deT").then(()=>parcelRequire('dEEnn'));

});

parcelRegister("c8CIX", function(module, exports) {

let $8d644534cc38ad0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d644534cc38ad0a$var$load("8LOKW").then(()=>parcelRequire('g3RHO'));

});

parcelRegister("cLyLc", function(module, exports) {

let $94b4d67bac82e4b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $94b4d67bac82e4b1$var$load("1yBnY").then(()=>parcelRequire('cN2Nx'));

});

parcelRegister("6huTR", function(module, exports) {

let $492c4cb090ad355f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $492c4cb090ad355f$var$load("1wn0F").then(()=>parcelRequire('2tZDf'));

});

parcelRegister("02XSw", function(module, exports) {

let $008ea29e2785563d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $008ea29e2785563d$var$load("sRO5I").then(()=>parcelRequire('koyVD'));

});

parcelRegister("5CNqE", function(module, exports) {

let $4186d7e56ff0e40c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4186d7e56ff0e40c$var$load("g5Wvk").then(()=>parcelRequire('7xXrU'));

});

parcelRegister("iPbDx", function(module, exports) {

let $db46043615d54f9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db46043615d54f9e$var$load("HsCzv").then(()=>parcelRequire('4rZCo'));

});

parcelRegister("j3Rl4", function(module, exports) {

let $de07ac18c51a3c51$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de07ac18c51a3c51$var$load("e7mzU").then(()=>parcelRequire('bouJk'));

});

parcelRegister("1uoXH", function(module, exports) {

let $115bf4adc942d769$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $115bf4adc942d769$var$load("83eto").then(()=>parcelRequire('cJDu0'));

});

parcelRegister("lNTqV", function(module, exports) {

let $fdf92c77c5fdddac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fdf92c77c5fdddac$var$load("iXmvI").then(()=>parcelRequire('b9CSL'));

});

parcelRegister("6Wm8l", function(module, exports) {

let $50d954243c9e44c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $50d954243c9e44c7$var$load("5iVxj").then(()=>parcelRequire('990rL'));

});

parcelRegister("iRCg9", function(module, exports) {

let $dbbadac5dba1e30d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dbbadac5dba1e30d$var$load("hukdG").then(()=>parcelRequire('kyaSe'));

});

parcelRegister("3kGub", function(module, exports) {

let $26d432269dc2deb0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $26d432269dc2deb0$var$load("jnlqz").then(()=>parcelRequire('fUGpa'));

});

parcelRegister("1QZp2", function(module, exports) {

let $159a4718520ae19c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $159a4718520ae19c$var$load("g4c70").then(()=>parcelRequire('649Bv'));

});

parcelRegister("01qRf", function(module, exports) {

let $0044ed82f58348e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0044ed82f58348e3$var$load("lEBEM").then(()=>parcelRequire('3DNWB'));

});

parcelRegister("uwqzU", function(module, exports) {

let $05bbf4eb358d0325$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $05bbf4eb358d0325$var$load("8DTy4").then(()=>parcelRequire('R99iv'));

});

parcelRegister("mKEZ8", function(module, exports) {

let $04463fe71977467d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $04463fe71977467d$var$load("5MdzJ").then(()=>parcelRequire('fBBEW'));

});

parcelRegister("l0rWL", function(module, exports) {

let $f4af46b67049ac62$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4af46b67049ac62$var$load("gfBQB").then(()=>parcelRequire('5kaEJ'));

});

parcelRegister("4ALsf", function(module, exports) {

let $357f55bc8c8ecc87$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $357f55bc8c8ecc87$var$load("jMrHj").then(()=>parcelRequire('iZBtj'));

});

parcelRegister("aBQpk", function(module, exports) {

let $01fe4a5f736cb467$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01fe4a5f736cb467$var$load("yV6mq").then(()=>parcelRequire('jaYaK'));

});

parcelRegister("9aVqg", function(module, exports) {

let $6ae1972e372a81f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ae1972e372a81f4$var$load("bA1Ze").then(()=>parcelRequire('5kRaj'));

});

parcelRegister("6nZlF", function(module, exports) {

let $4a647a97dccdfb61$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a647a97dccdfb61$var$load("b5DyJ").then(()=>parcelRequire('15XZL'));

});

parcelRegister("danHd", function(module, exports) {

let $995e97163c3a0eb7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $995e97163c3a0eb7$var$load("1vghY").then(()=>parcelRequire('9uu3u'));

});

parcelRegister("6G461", function(module, exports) {

let $4dc9d7bbde719473$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4dc9d7bbde719473$var$load("5TbY4").then(()=>parcelRequire('55pYC'));

});

parcelRegister("2OLQd", function(module, exports) {

let $20d55c8d1026a138$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20d55c8d1026a138$var$load("4LA5S").then(()=>parcelRequire('5roIj'));

});

parcelRegister("be6SR", function(module, exports) {

let $82c65782e61dbcb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82c65782e61dbcb8$var$load("1sSWt").then(()=>parcelRequire('hGZVV'));

});

parcelRegister("lVSd3", function(module, exports) {

let $ff78f8b731ca6759$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff78f8b731ca6759$var$load("3oNaU").then(()=>parcelRequire('fi7n7'));

});

parcelRegister("cpdri", function(module, exports) {

let $90823e981070f5e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $90823e981070f5e8$var$load("dNJRO").then(()=>parcelRequire('kSqa6'));

});

parcelRegister("3Bixi", function(module, exports) {

let $29f334aeab35bb59$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $29f334aeab35bb59$var$load("fJAgc").then(()=>parcelRequire('g3f55'));

});

parcelRegister("3Yuu3", function(module, exports) {

let $2e4e9f1ee0aa8454$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e4e9f1ee0aa8454$var$load("iKZaN").then(()=>parcelRequire('f811W'));

});

parcelRegister("k3dTn", function(module, exports) {

let $e98edd285d099ed4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e98edd285d099ed4$var$load("kQOp7").then(()=>parcelRequire('1XS4x'));

});

parcelRegister("56e4D", function(module, exports) {

let $3b686e094296da07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3b686e094296da07$var$load("2bmSH").then(()=>parcelRequire('iR55a'));

});

parcelRegister("03a7D", function(module, exports) {
module.exports = JSON.parse("{}");

});

parcelRegister("iUFhM", function(module, exports) {

let $dc4d7b6ece384144$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dc4d7b6ece384144$var$load("fbUx3").then(()=>parcelRequire('7Wkhh'));

});

parcelRegister("6kbnv", function(module, exports) {

let $49ad6fcb7b42f4c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49ad6fcb7b42f4c9$var$load("gQxLC").then(()=>parcelRequire('5dr6c'));

});

parcelRegister("isMeM", function(module, exports) {

let $d7104279c0fff186$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7104279c0fff186$var$load("dzNSE").then(()=>parcelRequire('4flfD'));

});

parcelRegister("6ePtG", function(module, exports) {

let $48abfb514a50c6ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $48abfb514a50c6ae$var$load("5hjht").then(()=>parcelRequire('1gxMF'));

});

parcelRegister("8h36A", function(module, exports) {

let $606251e9cd784b22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $606251e9cd784b22$var$load("bpjR5").then(()=>parcelRequire('6Rt75'));

});

parcelRegister("iGK1b", function(module, exports) {

let $d9afd87a27f28c28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d9afd87a27f28c28$var$load("kdosV").then(()=>parcelRequire('d02ln'));

});

parcelRegister("cdt3d", function(module, exports) {

let $8e4d3bd6d3b4e7ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e4d3bd6d3b4e7ac$var$load("1rljH").then(()=>parcelRequire('jsqSS'));

});

parcelRegister("6wWfH", function(module, exports) {

let $4c12eae5d5846f34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c12eae5d5846f34$var$load("lQQwQ").then(()=>parcelRequire('2oq3E'));

});

parcelRegister("2Neoq", function(module, exports) {

let $208b5286403da667$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $208b5286403da667$var$load("88sXV").then(()=>parcelRequire('eXC49'));

});

parcelRegister("enz3X", function(module, exports) {

let $a77e6967caaaf961$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a77e6967caaaf961$var$load("9MKUm").then(()=>parcelRequire('cjdgt'));

});

parcelRegister("9fEIL", function(module, exports) {

let $6bc51a19fde0b5cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bc51a19fde0b5cb$var$load("8b1LB").then(()=>parcelRequire('aFJf4'));

});

parcelRegister("2RZTm", function(module, exports) {

let $21708a724f0d4b38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21708a724f0d4b38$var$load("a4wJB").then(()=>parcelRequire('cLfcK'));

});

parcelRegister("bm8hE", function(module, exports) {

let $84482cbca7d97542$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84482cbca7d97542$var$load("3GVyX").then(()=>parcelRequire('2CZnm'));

});

parcelRegister("ccxy3", function(module, exports) {

let $8e20a103c91546a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e20a103c91546a0$var$load("b8tYi").then(()=>parcelRequire('3tEGO'));

});

parcelRegister("fF1ow", function(module, exports) {

let $b66bc44823ad44b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b66bc44823ad44b4$var$load("duexz").then(()=>parcelRequire('h4K13'));

});

parcelRegister("7sapK", function(module, exports) {

let $56d339fd2a5e9a85$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56d339fd2a5e9a85$var$load("aQMbY").then(()=>parcelRequire('dUCTu'));

});

parcelRegister("6tBdX", function(module, exports) {

let $4b725375fa4aab56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b725375fa4aab56$var$load("lnHpr").then(()=>parcelRequire('dz5D7'));

});

parcelRegister("5DiPD", function(module, exports) {

let $419f33e6238b6d22$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $419f33e6238b6d22$var$load("8VwfX").then(()=>parcelRequire('zwQRn'));

});

parcelRegister("4KOk9", function(module, exports) {

let $37627ea0db62dfed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37627ea0db62dfed$var$load("54iKW").then(()=>parcelRequire('lzJNJ'));

});

parcelRegister("4IrS3", function(module, exports) {

let $36f0e40cabf6b65b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36f0e40cabf6b65b$var$load("3jKg4").then(()=>parcelRequire('dutYd'));

});

parcelRegister("8oujl", function(module, exports) {

let $61c813bec8b42b8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61c813bec8b42b8f$var$load("aNrcY").then(()=>parcelRequire('gCiXl'));

});

parcelRegister("DIrQ3", function(module, exports) {

let $07761f14e1593b37$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $07761f14e1593b37$var$load("4BBRG").then(()=>parcelRequire('2KlJ2'));

});

parcelRegister("gZQ9s", function(module, exports) {

let $c5facc0d8b5730bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5facc0d8b5730bd$var$load("cEOBh").then(()=>parcelRequire('5mufr'));

});

parcelRegister("clvP4", function(module, exports) {

let $8fd021862f8e216a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8fd021862f8e216a$var$load("2QvjT").then(()=>parcelRequire('8sXOG'));

});

parcelRegister("KfxtW", function(module, exports) {

let $08b059b862207b1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $08b059b862207b1a$var$load("7czjb").then(()=>parcelRequire('8LeSZ'));

});

parcelRegister("2z4QG", function(module, exports) {

let $1de29c826721e552$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1de29c826721e552$var$load("lQ6Bu").then(()=>parcelRequire('dDMVS'));

});

parcelRegister("d713K", function(module, exports) {

let $98bcc036b7658da1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98bcc036b7658da1$var$load("695sI").then(()=>parcelRequire('70147'));

});

parcelRegister("h9naC", function(module, exports) {

let $c7c54010e793f403$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7c54010e793f403$var$load("fXXDL").then(()=>parcelRequire('hopxO'));

});

parcelRegister("7prL8", function(module, exports) {

let $5650669dbf62e4d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5650669dbf62e4d7$var$load("1dHe5").then(()=>parcelRequire('iEOIs'));

});

parcelRegister("937zY", function(module, exports) {

let $696a45f82220b7c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $696a45f82220b7c1$var$load("bfbL0").then(()=>parcelRequire('aocP1'));

});

parcelRegister("dclGe", function(module, exports) {

let $99bd369a0b78a535$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99bd369a0b78a535$var$load("3m9RT").then(()=>parcelRequire('1YcRm'));

});

parcelRegister("kkNoL", function(module, exports) {

let $ecdbfe62a2428c6a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ecdbfe62a2428c6a$var$load("hKwnn").then(()=>parcelRequire('iaAyD'));

});

parcelRegister("34TFK", function(module, exports) {

let $23dcee2f3c70654b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23dcee2f3c70654b$var$load("9aMDB").then(()=>parcelRequire('h8Rqx'));

});

parcelRegister("iO9wq", function(module, exports) {

let $db14486427169f06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db14486427169f06$var$load("5RDyg").then(()=>parcelRequire('i4LVu'));

});

parcelRegister("9UiU1", function(module, exports) {
/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5WcjV = parcelRequire("5WcjV");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d8b349b01a649e7f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $d8b349b01a649e7f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("bGmWa")));
        case 'da':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("3Cd3y")));
        case 'de':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("goDhu")));
        case 'en-GB':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("hewKr")));
        case 'en-US':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("dZJcY")));
        case 'en-XA':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("f3DVu")));
        case 'en-XB':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("gCXvv")));
        case 'en-ZZ':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("boVWr")));
        case 'en':
            return $d8b349b01a649e7f$var$importHelper(await Promise.resolve((parcelRequire("5WcjV"))));
        case 'es':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("6x9hI")));
        case 'et':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("h3xxR")));
        case 'fi':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("fsMMj")));
        case 'fr':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("db4Xx")));
        case 'hr':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("a8FB5")));
        case 'hu':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("2q9wP")));
        case 'it':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("fOqRP")));
        case 'ja':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("5iWHo")));
        case 'ko':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("l4pkE")));
        case 'nb':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("dpxdg")));
        case 'nl':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("d0DKq")));
        case 'pl':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("irNuw")));
        case 'pt-BR':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("8A21B")));
        case 'ro':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("dAg7u")));
        case 'ru':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("bkcEB")));
        case 'sl':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("2BQks")));
        case 'sr-RS':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("e3rpj")));
        case 'sr-YR':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("gJfty")));
        case 'sr':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("cOMKb")));
        case 'sv':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("gSl3D")));
        case 'th':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("aZ3u6")));
        case 'tr':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("1ZacD")));
        case 'uk':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("5poTN")));
        case 'vi':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("4ddjz")));
        case 'zh-CN':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("5XYFn")));
        case 'zh-TW':
            return $d8b349b01a649e7f$var$importHelper(await (parcelRequire("gWZMd")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5WcjV));
    }
};
module.exports["messagesLoader"] = $d8b349b01a649e7f$export$720676d8cac8fbb;

});

parcelRegister("5WcjV", function(module, exports) {
module.exports = JSON.parse('{"post-office.rovo-chat-button.main-heading.dismiss":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat-button.onboarding-heading":[{"type":0,"value":"Chat with Rovo AI"}],"post-office.rovo-chat-button.onboarding-input-placeholder-1":[{"type":0,"value":"Pick a conversation starter or ask Rovo anything"}],"post-office.rovo-chat-button.onboarding-input-placeholder-2":[{"type":0,"value":"Write a prompt"}],"post-office.rovo-chat-button.send-prompt":[{"type":0,"value":"Send prompt"}],"post-office.rovo-chat.3p-connector-nudge.connect-button":[{"type":0,"value":"Connect "},{"type":1,"value":"appName"}],"post-office.rovo-chat.3p-connector-nudge.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.3p-connector-nudge.heading":[{"type":0,"value":"Your admin has added "},{"type":1,"value":"appName"}],"post-office.rovo-chat.3p-connector-nudge.logo-alt":[{"type":1,"value":"appName"},{"type":0,"value":" logo"}],"post-office.rovo-chat.3p-connector-nudge.subtitle":[{"type":0,"value":"Connect your account to see more results"}],"post-office.rovo-chat.jira-work-item-catchup-parent.description":[{"type":0,"value":"See what changed on this work item and its children since your last visit."}],"post-office.rovo-chat.jira-work-item-catchup-parent.icon-label":[{"type":0,"value":"Work item catch-up"}],"post-office.rovo-chat.jira-work-item-catchup-parent.secondary-title":[{"type":0,"value":"See what changed since your last visit."}],"post-office.rovo-chat.jira-work-item-catchup-parent.title":[{"type":0,"value":"Catch up on this work item"}],"post-office.rovo-chat.long-running-task-fullpage-banner.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-fullpage-banner.cta-button":[{"type":0,"value":"Get a team summary"}],"post-office.rovo-chat.long-running-task-fullpage-banner.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.long-running-task-fullpage-banner.headline":[{"type":0,"value":"Meet Max. It handles everything."}],"post-office.rovo-chat.long-running-task-fullpage-banner.max-label":[{"type":0,"value":"Max"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta":[{"type":0,"value":"Awaiting user response"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-meta-timestamp":[{"type":0,"value":"1 minute ago"}],"post-office.rovo-chat.long-running-task-fullpage-banner.primary-task-title":[{"type":0,"value":"Implement new authentication system"}],"post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-meta":[{"type":0,"value":"Just now"}],"post-office.rovo-chat.long-running-task-fullpage-banner.secondary-task-title":[{"type":0,"value":"New Policy Presentation"}],"post-office.rovo-chat.long-running-task-spotlight.body":[{"type":0,"value":"Max takes on complex, multi-step work and comes back with a finished result."}],"post-office.rovo-chat.long-running-task-spotlight.headline":[{"type":0,"value":"Say hi to Max"}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.body":[{"type":0,"value":"Max takes on complex, multi-step work for you."}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.dismiss-button":[{"type":0,"value":"Dismiss"}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.headline":[{"type":0,"value":"Meet Max. It handles everything."}],"post-office.rovo-chat.long-running-task-spotlight.side-panel-banner.try-max-button":[{"type":0,"value":"Try Max"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.action":[{"type":0,"value":"See how"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.body":[{"type":0,"value":"Rovo now remembers facts and details from your chats to make responses more personalized and helpful"}],"post-office.rovo-chat.memory-settings-onboarding-spotlight.headline":[{"type":0,"value":"A more personalized Rovo"}],"post-office.rovo-chat.web-search-preference-spotlight.body":[{"type":0,"value":"Web search is now on by default. You can turn it off anytime."}],"post-office.rovo-chat.web-search-preference-spotlight.headline":[{"type":0,"value":"Web search is on"}],"post-office.rovo-chat.web-search-spotlight.body":[{"type":0,"value":"We\'re running an experiment to improve Rovo. For some users, web search is now on by default\u2014you can turn it off any time."}],"post-office.rovo-chat.web-search-spotlight.dismiss":[{"type":0,"value":"Turn off default web search"}],"post-office.rovo-chat.web-search-spotlight.done":[{"type":0,"value":"Done"}],"post-office.rovo-chat.web-search-spotlight.headline":[{"type":0,"value":"Web search is now on by default"}],"post-office.rovo-chat.web-search-spotlight.manage-defaults":[{"type":0,"value":"Manage my defaults"}],"rovo-chat.inline-memory-saved-message.description.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"rovo-chat.inline-memory-saved-message.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"rovo-chat.rovo-chat-scheduled-chat-recurring-chat-complete.message-template.notification-drawer.message":[{"type":0,"value":"Rovo has completed your scheduled query"}],"rovo-chat.rovo-chat-task-awaiting-user.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"Rovo is awaiting your response"}],"rovo-chat.rovo-chat-task-complete.message-template.notification-drawer.message":[{"type":0,"value":"Rovo has completed your task"}],"rovo-chat.rovo-chat-task-plan-generated.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"Rovo has generated your plan"}]}');

});

parcelRegister("bGmWa", function(module, exports) {

let $881568c81b02779c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $881568c81b02779c$var$load("1ARj0").then(()=>parcelRequire('bKYpH'));

});

parcelRegister("3Cd3y", function(module, exports) {

let $2a1f0c6ef47650d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2a1f0c6ef47650d3$var$load("5lGGX").then(()=>parcelRequire('bAzBg'));

});

parcelRegister("goDhu", function(module, exports) {

let $befd5ba38e006b0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $befd5ba38e006b0b$var$load("jB5ov").then(()=>parcelRequire('48Qm4'));

});

parcelRegister("hewKr", function(module, exports) {

let $c8bd259300443e90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c8bd259300443e90$var$load("k32Bn").then(()=>parcelRequire('gg4ee'));

});

parcelRegister("dZJcY", function(module, exports) {

let $a3040a4f11d130c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3040a4f11d130c2$var$load("bBNFz").then(()=>parcelRequire('eknDD'));

});

parcelRegister("f3DVu", function(module, exports) {

let $af661b53bffe8230$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af661b53bffe8230$var$load("cujfT").then(()=>parcelRequire('fLbVb'));

});

parcelRegister("gCXvv", function(module, exports) {

let $c1ae5ad797f1de06$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c1ae5ad797f1de06$var$load("jv1W1").then(()=>parcelRequire('eoW7v'));

});

parcelRegister("boVWr", function(module, exports) {

let $84cee1922cff73de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84cee1922cff73de$var$load("42Bqq").then(()=>parcelRequire('hiamJ'));

});

parcelRegister("6x9hI", function(module, exports) {

let $4c1d06e76a97c94e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c1d06e76a97c94e$var$load("dcfds").then(()=>parcelRequire('eU3AQ'));

});

parcelRegister("h3xxR", function(module, exports) {

let $c6acbcd48437cb2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6acbcd48437cb2f$var$load("g07T8").then(()=>parcelRequire('bqeEy'));

});

parcelRegister("fsMMj", function(module, exports) {

let $b41f4edb6ba42f5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b41f4edb6ba42f5e$var$load("kr42s").then(()=>parcelRequire('iAUci'));

});

parcelRegister("db4Xx", function(module, exports) {

let $99802640bfedc43d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99802640bfedc43d$var$load("lJEIV").then(()=>parcelRequire('1dtXv'));

});

parcelRegister("a8FB5", function(module, exports) {

let $761aeb11e73c3157$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $761aeb11e73c3157$var$load("4jwJ3").then(()=>parcelRequire('52LyJ'));

});

parcelRegister("2q9wP", function(module, exports) {

let $1c3566a353549f93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1c3566a353549f93$var$load("a6iRV").then(()=>parcelRequire('eOaJh'));

});

parcelRegister("fOqRP", function(module, exports) {

let $b8305dc7caf5f966$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8305dc7caf5f966$var$load("lAYyC").then(()=>parcelRequire('aGsFc'));

});

parcelRegister("5iWHo", function(module, exports) {

let $3dcc2a8bca4a2f10$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3dcc2a8bca4a2f10$var$load("4vEh0").then(()=>parcelRequire('KFkzr'));

});

parcelRegister("l4pkE", function(module, exports) {

let $f56d9f22a9eda167$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f56d9f22a9eda167$var$load("irTAI").then(()=>parcelRequire('gDXUd'));

});

parcelRegister("dpxdg", function(module, exports) {

let $9c375f907a4af170$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c375f907a4af170$var$load("159pY").then(()=>parcelRequire('8Yzmj'));

});

parcelRegister("d0DKq", function(module, exports) {

let $978a1b8765846aa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $978a1b8765846aa3$var$load("d98eX").then(()=>parcelRequire('frnTl'));

});

parcelRegister("irNuw", function(module, exports) {

let $d6e12393069271b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d6e12393069271b9$var$load("4kq29").then(()=>parcelRequire('lnPSR'));

});

parcelRegister("8A21B", function(module, exports) {

let $63f3419a89502a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $63f3419a89502a03$var$load("gzlcr").then(()=>parcelRequire('lt0zY'));

});

parcelRegister("dAg7u", function(module, exports) {

let $9e3b2433ef75dd6c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e3b2433ef75dd6c$var$load("ioziG").then(()=>parcelRequire('h0g74'));

});

parcelRegister("bkcEB", function(module, exports) {

let $83eb60c67ebaad99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83eb60c67ebaad99$var$load("cE4pd").then(()=>parcelRequire('bJXhH'));

});

parcelRegister("2BQks", function(module, exports) {

let $1e67a0eb72705cc8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e67a0eb72705cc8$var$load("Bf65L").then(()=>parcelRequire('afd3B'));

});

parcelRegister("e3rpj", function(module, exports) {

let $a3b69afffe9faa86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3b69afffe9faa86$var$load("jEVwz").then(()=>parcelRequire('5ZzmK'));

});

parcelRegister("gJfty", function(module, exports) {

let $c2dcda78e47f655e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2dcda78e47f655e$var$load("fMITV").then(()=>parcelRequire('8IEGN'));

});

parcelRegister("cOMKb", function(module, exports) {

let $954ff70ee1c280c6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $954ff70ee1c280c6$var$load("GYTWV").then(()=>parcelRequire('auRGd'));

});

parcelRegister("gSl3D", function(module, exports) {

let $c492061d7c5eabfb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c492061d7c5eabfb$var$load("4GBfP").then(()=>parcelRequire('98Qmo'));

});

parcelRegister("aZ3u6", function(module, exports) {

let $7ff24dde41b476f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ff24dde41b476f3$var$load("beTrz").then(()=>parcelRequire('bAogT'));

});

parcelRegister("1ZacD", function(module, exports) {

let $172367084aa84264$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $172367084aa84264$var$load("caN5r").then(()=>parcelRequire('8kGHF'));

});

parcelRegister("5poTN", function(module, exports) {

let $3f0299f0d2b22d00$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f0299f0d2b22d00$var$load("fAirC").then(()=>parcelRequire('eJwHU'));

});

parcelRegister("4ddjz", function(module, exports) {

let $3112b456f7e3dd8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3112b456f7e3dd8a$var$load("lXu14").then(()=>parcelRequire('hKIjR'));

});

parcelRegister("5XYFn", function(module, exports) {

let $4581857e24c453e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4581857e24c453e1$var$load("jWT3L").then(()=>parcelRequire('2K1Za'));

});

parcelRegister("gWZMd", function(module, exports) {

let $c571fbb282209729$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c571fbb282209729$var$load("lK4Gr").then(()=>parcelRequire('eTYup'));

});

parcelRegister("8IaD6", function(module, exports) {
module.exports = JSON.parse("{\"shared-user-preferences-onboarding.modal.alternative-text\":[{\"type\":0,\"value\":\"Alternatively, you can choose light or dark mode from the \"},{\"children\":[{\"type\":0,\"value\":\"Appearance\"}],\"type\":8,\"value\":\"appearanceSettings\"},{\"type\":0,\"value\":\" settings in your profile menu.\"}],\"shared-user-preferences-onboarding.modal.button.accept\":[{\"type\":0,\"value\":\"Okay\"}],\"shared-user-preferences-onboarding.modal.button.choose-theme\":[{\"type\":0,\"value\":\"Choose mode\"}],\"shared-user-preferences-onboarding.modal.button.close\":[{\"type\":0,\"value\":\"Close modal\"}],\"shared-user-preferences-onboarding.modal.description\":[{\"type\":0,\"value\":\"All supported apps will now match your system's display mode by default.\"}],\"shared-user-preferences-onboarding.modal.feature.consistent\":[{\"type\":0,\"value\":\"Consistent look and feel\"}],\"shared-user-preferences-onboarding.modal.feature.override\":[{\"type\":0,\"value\":\"Choose display mode for individual apps\"}],\"shared-user-preferences-onboarding.modal.feature.set-once\":[{\"type\":0,\"value\":\"Only set your display mode once\"}],\"shared-user-preferences-onboarding.modal.title\":[{\"type\":0,\"value\":\"Your display mode is now synced\"}]}");

});

parcelRegister("fjK1g", function(module, exports) {

let $b26c53d9c17eafe9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b26c53d9c17eafe9$var$load("2hZuF").then(()=>parcelRequire('650YV'));

});

parcelRegister("7Cxrz", function(module, exports) {

let $58c6063c5ca39a35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $58c6063c5ca39a35$var$load("28FoP").then(()=>parcelRequire('cluqU'));

});

parcelRegister("gm21G", function(module, exports) {

let $be8045c120d8c71f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $be8045c120d8c71f$var$load("6zP5L").then(()=>parcelRequire('g1Zfp'));

});

parcelRegister("f0OVj", function(module, exports) {

let $aede5b6990465ccd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aede5b6990465ccd$var$load("12wpT").then(()=>parcelRequire('6xjV0'));

});

parcelRegister("baPkP", function(module, exports) {

let $822872ec8f023382$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $822872ec8f023382$var$load("fyAVO").then(()=>parcelRequire('iUX4f'));

});

parcelRegister("acwEe", function(module, exports) {

let $76d4598bcdbad909$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76d4598bcdbad909$var$load("4GpiG").then(()=>parcelRequire('9IHIE'));

});

parcelRegister("1F7Fi", function(module, exports) {

let $135f90e559795dd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $135f90e559795dd0$var$load("ia6Aw").then(()=>parcelRequire('dfeXA'));

});

parcelRegister("bYaRo", function(module, exports) {

let $8b6db8e7ca15df5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b6db8e7ca15df5a$var$load("l6Cdh").then(()=>parcelRequire('3EMoA'));

});

parcelRegister("7o16o", function(module, exports) {

let $560ba12a722b798f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $560ba12a722b798f$var$load("j4rni").then(()=>parcelRequire('2jAjz'));

});

parcelRegister("dlX8d", function(module, exports) {

let $9b8b1ad3fb83ed95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9b8b1ad3fb83ed95$var$load("dO5re").then(()=>parcelRequire('hG6TU'));

});

parcelRegister("eEXjN", function(module, exports) {

let $aac2d08488ab9e34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aac2d08488ab9e34$var$load("eZtKA").then(()=>parcelRequire('aERQP'));

});

parcelRegister("7Tvwf", function(module, exports) {

let $5bf61e7a6fda237d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5bf61e7a6fda237d$var$load("ereYz").then(()=>parcelRequire('iQyWj'));

});

parcelRegister("8G60n", function(module, exports) {

let $6516e77b8cf0cea2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6516e77b8cf0cea2$var$load("dWtto").then(()=>parcelRequire('iVaap'));

});

parcelRegister("iEFhI", function(module, exports) {

let $d94bfcb911fbc4f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d94bfcb911fbc4f7$var$load("bZsVc").then(()=>parcelRequire('4Ttgk'));

});

parcelRegister("5J4lr", function(module, exports) {

let $42b486890a13afbe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42b486890a13afbe$var$load("1pCBb").then(()=>parcelRequire('64tbW'));

});

parcelRegister("7TAVK", function(module, exports) {

let $5bfa5114a32b57de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5bfa5114a32b57de$var$load("5tyGk").then(()=>parcelRequire('cgJRD'));

});

parcelRegister("8K6Nr", function(module, exports) {

let $65d7e43b1e882f4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65d7e43b1e882f4e$var$load("1hP6d").then(()=>parcelRequire('k6nbq'));

});

parcelRegister("7Afq7", function(module, exports) {

let $5857db59220abb98$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5857db59220abb98$var$load("2ymcr").then(()=>parcelRequire('edMNK'));

});

parcelRegister("5gNbS", function(module, exports) {

let $3d649a96ab9e5cb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d649a96ab9e5cb8$var$load("9pq1l").then(()=>parcelRequire('45ZXM'));

});

parcelRegister("88tHU", function(module, exports) {

let $0187530d9f27975f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0187530d9f27975f$var$load("1g5q0").then(()=>parcelRequire('gjiud'));

});

parcelRegister("4LNoh", function(module, exports) {

let $3791dd2dfa2699ab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3791dd2dfa2699ab$var$load("cqNk4").then(()=>parcelRequire('1imww'));

});

parcelRegister("3UJPP", function(module, exports) {

let $2d9a27f054c16277$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d9a27f054c16277$var$load("7YRqx").then(()=>parcelRequire('d2xbW'));

});

parcelRegister("8BoSL", function(module, exports) {

let $6435148d3e53c845$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6435148d3e53c845$var$load("ahmEh").then(()=>parcelRequire('gRHWX'));

});

parcelRegister("5bseM", function(module, exports) {

let $3c63e2300210cc27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c63e2300210cc27$var$load("8Jy6V").then(()=>parcelRequire('3CFxq'));

});

parcelRegister("8Taz6", function(module, exports) {

let $678ba7ce23a039d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $678ba7ce23a039d3$var$load("d9lsa").then(()=>parcelRequire('7OOQP'));

});

parcelRegister("dSUn6", function(module, exports) {

let $a1bc0bbec02a590a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a1bc0bbec02a590a$var$load("dqqDj").then(()=>parcelRequire('6ML4N'));

});

parcelRegister("fV2yV", function(module, exports) {

let $b96e2ab8b2cb70aa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b96e2ab8b2cb70aa$var$load("aZ3Em").then(()=>parcelRequire('3yy7h'));

});

parcelRegister("7dIJm", function(module, exports) {

let $541c71dfc2a2550e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $541c71dfc2a2550e$var$load("fyD9k").then(()=>parcelRequire('5ZAju'));

});

parcelRegister("23tal", function(module, exports) {

let $17f27c4c3c46b4c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17f27c4c3c46b4c4$var$load("3eCyF").then(()=>parcelRequire('lOrr0'));

});

parcelRegister("dMbaR", function(module, exports) {

let $a0786d0471ff9ff3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0786d0471ff9ff3$var$load("7i2hB").then(()=>parcelRequire('ios8g'));

});

parcelRegister("hfWR0", function(module, exports) {

let $c9017d908af29622$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c9017d908af29622$var$load("dY1xW").then(()=>parcelRequire('1t8Qa'));

});

parcelRegister("91jOk", function(module, exports) {

let $6913930f5d647cee$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6913930f5d647cee$var$load("4idmO").then(()=>parcelRequire('gtSH4'));

});

parcelRegister("f6wto", function(module, exports) {

let $aff09b097c468796$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aff09b097c468796$var$load("iQAb2").then(()=>parcelRequire('hXcsW'));

});

parcelRegister("4PWHz", function(module, exports) {

let $385975c9d07fed80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $385975c9d07fed80$var$load("kdCub").then(()=>parcelRequire('7bJmJ'));

});

parcelRegister("kPr2b", function(module, exports) {
module.exports = JSON.parse('{"integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.confluence-app":[{"type":0,"value":"Get Confluence notifications on your phone! Download the Confluence Cloud app for "},{"type":1,"value":"androidLink"},{"type":0,"value":" or "},{"type":1,"value":"iosLink"},{"type":0,"value":"."}],"integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.feedback":[{"type":0,"value":"Give feedback"}],"integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.jira-app":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"type":1,"value":"androidLink"},{"type":0,"value":" or "},{"type":1,"value":"iosLink"},{"type":0,"value":"."}],"integrations-service.integrations-service-mcp-request-digest-event.message-template.email.footer.privacy":[{"type":0,"value":"Privacy policy"}],"integrations-service.integrations-service-mcp-request-notification.message-template.in-app.admin-hub-notifications.heading.no-translate":[{"type":0,"value":"MCP server request for "},{"type":1,"value":"appName"}],"integrations-service.integrations-service-mcp-request-notification.message-template.notification-drawer.message.no-translate":[{"type":0,"value":"MCP server request for "},{"type":1,"value":"appName"}],"integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.confluence-app":[{"type":0,"value":"Get Confluence notifications on your phone! Download the Confluence Cloud app for "},{"type":1,"value":"androidLink"},{"type":0,"value":" or "},{"type":1,"value":"iosLink"},{"type":0,"value":"."}],"integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.feedback":[{"type":0,"value":"Give feedback"}],"integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.jira-app":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for "},{"type":1,"value":"androidLink"},{"type":0,"value":" or "},{"type":1,"value":"iosLink"},{"type":0,"value":"."}],"integrations-service.integrations-service-mcp-request-updated.message-template.email.footer.privacy":[{"type":0,"value":"Privacy policy"}],"integrations-service.mcp-server-request-digest.message-template.email.footer.confluence-app":[{"type":0,"value":"Get Confluence notifications on your phone! Download the Confluence Cloud app for Android or iOS."}],"integrations-service.mcp-server-request-digest.message-template.email.footer.feedback":[{"type":0,"value":"Give feedback"}],"integrations-service.mcp-server-request-digest.message-template.email.footer.jira-app":[{"type":0,"value":"Get Jira notifications on your phone! Download the Jira Cloud app for Android or iOS."}],"integrations-service.mcp-server-request-digest.message-template.email.footer.privacy":[{"type":0,"value":"Privacy policy"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.blank-page":[{"type":0,"value":"A shared consent link may display a blank page after the Microsoft administrator selects "},{"children":[{"type":0,"value":"Accept"}],"type":8,"value":"b"},{"type":0,"value":". This is expected."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.consequence":[{"type":0,"value":"If consent is not granted by "},{"type":1,"value":"deadline"},{"type":0,"value":" users may no longer be able to resolve SharePoint and OneDrive Smart Links or find SharePoint and OneDrive content through Rovo."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.heading":[{"type":0,"value":"After granting consent"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.after.verify":[{"type":0,"value":"To verify completion, the Microsoft administrator can open "},{"children":[{"type":0,"value":"Enterprise applications"}],"type":8,"value":"b"},{"type":0,"value":" in the Microsoft Entra admin center, search for application ID "},{"children":[{"type":1,"value":"applicationId"}],"type":8,"value":"mono"},{"type":0,"value":", open the "},{"children":[{"type":0,"value":"Atlassian"}],"type":8,"value":"b"},{"type":0,"value":" application, and confirm under "},{"children":[{"type":0,"value":"Permissions"}],"type":8,"value":"b"},{"type":0,"value":" that admin consent has been granted."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.heading":[{"type":0,"value":"Application to approve"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.id":[{"children":[{"type":0,"value":"Application ID:"}],"type":8,"value":"b"},{"type":0,"value":" "},{"children":[{"type":1,"value":"applicationId"}],"type":8,"value":"mono"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.name":[{"children":[{"type":0,"value":"Name:"}],"type":8,"value":"b"},{"type":0,"value":" Atlassian"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.application.publisher":[{"children":[{"type":0,"value":"Verified publisher:"}],"type":8,"value":"b"},{"type":0,"value":" Atlassian"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.cta":[{"type":0,"value":"Open the Microsoft admin consent flow"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.intro":[{"type":0,"value":"Complete this by "},{"type":1,"value":"deadline"},{"type":0,"value":" to prevent disruption to:"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.previews":[{"type":0,"value":"SharePoint and OneDrive Rich-link and inline-file previews"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.disruption.rovo":[{"type":0,"value":"SharePoint and OneDrive experiences in Rovo"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.greeting":[{"type":0,"value":"Hi "},{"type":1,"value":"recipientName"},{"type":0,"value":","}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.intro":[{"type":0,"value":"A Microsoft 365 administrator needs to approve Atlassian\'s new Microsoft publisher-verified application for your Atlassian site, "},{"children":[{"type":1,"value":"siteName"}],"type":8,"value":"b"},{"type":0,"value":" to ensure users can continue resolving SmartLinks and access SharePoint/OneDrive data if enabled."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.preheader":[{"type":0,"value":"Ask your Microsoft 365 administrator to approve Atlassian\'s publisher-verified application."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.application-administrator":[{"type":0,"value":"Application Administrator"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.atlassian-account":[{"type":0,"value":"The Microsoft administrator needs an Atlassian account to open the consent flow, but they do not need Atlassian admin permissions."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.cloud-application-administrator":[{"type":0,"value":"Cloud Application Administrator"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.forward":[{"type":0,"value":"If you do not have one of these roles, forward this email or send the consent link to your Microsoft administrator."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.global-administrator":[{"type":0,"value":"Global Administrator"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.heading":[{"type":0,"value":"Who should complete this?"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.roles.intro":[{"type":0,"value":"The person granting consent must have one of these Microsoft 365 roles:"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.subject":[{"type":0,"value":"Action required by "},{"type":1,"value":"deadline"},{"type":0,"value":": Keep SharePoint and OneDrive working in Atlassian"}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.support-doc":[{"type":0,"value":"For complete instructions, see "},{"children":[{"type":0,"value":"Upgrade your SharePoint and OneDrive connection in Atlassian"}],"type":8,"value":"link"},{"type":0,"value":"."}],"integrations-service.sharepoint-smartlink-app-migration-admin-email.message-template.email.why-receiving":[{"type":0,"value":"We\'re contacting you because users in your tenant have connected SharePoint/OneDrive to Atlassian to resolve SmartLinks or use the SharePoint and OneDrive connector."}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.copied":[{"type":0,"value":"Copied!"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.copy-consent-link":[{"type":0,"value":"Copy consent link"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.description":[{"type":0,"value":"Grant admin consent to the updated SharePoint app so people in your organization can continue using SharePoint and OneDrive links. If you\'re not a Microsoft Entra admin, copy the consent link and share it with your Microsoft admin. "},{"children":[{"type":0,"value":"Learn more"}],"type":8,"value":"link"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.grant-consent":[{"type":0,"value":"Grant Consent"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.remind-me-later":[{"type":0,"value":"Remind me later"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.title":[{"type":0,"value":"Action required: Grant consent for SharePoint/OneDrive"}],"integrations-service.sharepoint-smartlink-app-migration-test.message-template.in-app.screen-space-flags.warning-icon-label":[{"type":0,"value":"Warning"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.body.no-translate":[{"type":0,"value":"The connection for *"},{"type":1,"value":"serverName"},{"type":0,"value":"* has expired or needs to be re-authorized."}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.reauth-button.no-translate":[{"type":0,"value":"Re-authenticate"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.runbook-link.no-translate":[{"type":0,"value":"Runbook / more information"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.auth-required.title.no-translate":[{"type":0,"value":":warning: Global MCP tool sync cannot run \u2014 authentication required"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.subtitle.no-translate":[{"type":0,"value":"Remote: "},{"type":1,"value":"remoteToolCount"},{"type":0,"value":" tools \xb7 YAML baseline: "},{"type":1,"value":"baselineToolCount"},{"type":0,"value":" tools"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.body.no-translate":[{"type":0,"value":"The global MCP tool sync for *"},{"type":1,"value":"serverName"},{"type":0,"value":"* failed. Check the runbook for troubleshooting and retry guidance."}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.runbook-link.no-translate":[{"type":0,"value":"Runbook / more information"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.sync-failure.title.no-translate":[{"type":0,"value":":x: Global MCP tool sync failed \u2014 "},{"type":1,"value":"serverName"}],"post-office.integrations-service.integrations-service-mcp-global-sync-notification.title.no-translate":[{"type":0,"value":"Global MCP tool sync \u2014 "},{"type":1,"value":"serverName"}]}');

});

parcelRegister("4ZWNt", function(module, exports) {

let $3a3a77cb77c81d81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3a3a77cb77c81d81$var$load("1x1hq").then(()=>parcelRequire('keR8t'));

});

parcelRegister("jmb7g", function(module, exports) {

let $e178b1d5bb3d0344$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e178b1d5bb3d0344$var$load("5SFfH").then(()=>parcelRequire('cip0f'));

});

parcelRegister("lV852", function(module, exports) {

let $ff55306adec21850$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff55306adec21850$var$load("cpw3f").then(()=>parcelRequire('9ttis'));

});

parcelRegister("2N2rV", function(module, exports) {

let $20820eca1ddc2072$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20820eca1ddc2072$var$load("fMz6k").then(()=>parcelRequire('ai0DV'));

});

parcelRegister("5q0jV", function(module, exports) {

let $3f1fa10dcd17f126$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3f1fa10dcd17f126$var$load("47UEn").then(()=>parcelRequire('3W7Xn'));

});

parcelRegister("kwUKZ", function(module, exports) {

let $ef22d2869d9ce795$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ef22d2869d9ce795$var$load("kQsQ2").then(()=>parcelRequire('k4DCG'));

});

parcelRegister("hhfhU", function(module, exports) {

let $c93fe208fbad2242$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c93fe208fbad2242$var$load("1BJMn").then(()=>parcelRequire('f9W2E'));

});

parcelRegister("iboJb", function(module, exports) {

let $d3cc6f7d11ebced6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3cc6f7d11ebced6$var$load("fZTMJ").then(()=>parcelRequire('93PwR'));

});

parcelRegister("9Vsjx", function(module, exports) {

let $739f6681efb47a9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $739f6681efb47a9c$var$load("adUHY").then(()=>parcelRequire('hUfD3'));

});

parcelRegister("27sh5", function(module, exports) {

let $18b22af10688cb16$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18b22af10688cb16$var$load("41mwo").then(()=>parcelRequire('bn1Qz'));

});

parcelRegister("6oIvE", function(module, exports) {

let $4a87829f3340441b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a87829f3340441b$var$load("jAdw5").then(()=>parcelRequire('995N0'));

});

parcelRegister("1wxZ1", function(module, exports) {

let $11c323f3e431d206$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11c323f3e431d206$var$load("aHh12").then(()=>parcelRequire('ino8y'));

});

parcelRegister("g7Mce", function(module, exports) {

let $bbd2af8d81b56101$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbd2af8d81b56101$var$load("kabpX").then(()=>parcelRequire('hVxxy'));

});

parcelRegister("d6Xn9", function(module, exports) {

let $98b9e4020acd4448$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98b9e4020acd4448$var$load("1mBGM").then(()=>parcelRequire('bOMYM'));

});

parcelRegister("f1A8G", function(module, exports) {

let $af02fb7aa98cb8b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af02fb7aa98cb8b3$var$load("5qrQ7").then(()=>parcelRequire('a5Otz'));

});

parcelRegister("20HRd", function(module, exports) {

let $176d9a077a04ed0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $176d9a077a04ed0e$var$load("aQY1v").then(()=>parcelRequire('f78wq'));

});

parcelRegister("gi6su", function(module, exports) {

let $bdc356483d4e1c70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdc356483d4e1c70$var$load("1hrrC").then(()=>parcelRequire('bWaGQ'));

});

parcelRegister("fkjiw", function(module, exports) {

let $b287b169febdf2c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b287b169febdf2c7$var$load("lFqZL").then(()=>parcelRequire('10h68'));

});

parcelRegister("f86Qv", function(module, exports) {

let $b03ce9cfc8b1abc7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b03ce9cfc8b1abc7$var$load("lEI22").then(()=>parcelRequire('4yJhG'));

});

parcelRegister("gd6Pb", function(module, exports) {

let $030ba9ed4e3e67f4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $030ba9ed4e3e67f4$var$load("7vEL5").then(()=>parcelRequire('2bSUA'));

});

parcelRegister("fPpTt", function(module, exports) {

let $b85fb462ec84ef07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b85fb462ec84ef07$var$load("2bEe7").then(()=>parcelRequire('37tBB'));

});

parcelRegister("jdobf", function(module, exports) {

let $dfd1fcf783677cb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dfd1fcf783677cb1$var$load("ati4D").then(()=>parcelRequire('gqMS7'));

});

parcelRegister("iCCpE", function(module, exports) {

let $d8e9928c08494dfb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d8e9928c08494dfb$var$load("fZxb2").then(()=>parcelRequire('fm06P'));

});

parcelRegister("hHzOZ", function(module, exports) {

let $ce323d362d189870$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce323d362d189870$var$load("iUZSO").then(()=>parcelRequire('5BgXL'));

});

parcelRegister("g9fh6", function(module, exports) {

let $bc1955e0a5262b0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bc1955e0a5262b0a$var$load("cwhTA").then(()=>parcelRequire('flNN8'));

});

parcelRegister("5wENs", function(module, exports) {

let $405f9648784b1a8a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $405f9648784b1a8a$var$load("i6tRn").then(()=>parcelRequire('lLjPW'));

});

parcelRegister("4jY0a", function(module, exports) {

let $32577ade5ea8de6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32577ade5ea8de6e$var$load("1oQz9").then(()=>parcelRequire('9fbEv'));

});

parcelRegister("4ErJP", function(module, exports) {

let $36306a12993c3b57$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36306a12993c3b57$var$load("fivRZ").then(()=>parcelRequire('4Nduc'));

});

parcelRegister("dA83e", function(module, exports) {

let $9e34e1f4fdaafadf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e34e1f4fdaafadf$var$load("25IqW").then(()=>parcelRequire('4IsQh'));

});

parcelRegister("hXgoQ", function(module, exports) {

let $d124aafad7b2605a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d124aafad7b2605a$var$load("CWJ4s").then(()=>parcelRequire('bxak3'));

});

parcelRegister("bRXbf", function(module, exports) {

let $8a428cec17c7bac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8a428cec17c7bac0$var$load("4s0RU").then(()=>parcelRequire('lxnoM'));

});

parcelRegister("dJRZ3", function(module, exports) {

let $a0095a5d41ddb35d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0095a5d41ddb35d$var$load("6HRvx").then(()=>parcelRequire('3rEfR'));

});

parcelRegister("1fZEx", function(module, exports) {

let $0ea704204922f810$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ea704204922f810$var$load("3RfWO").then(()=>parcelRequire('1xXfP'));

});

parcelRegister("ahjHi", function(module, exports) {

let $77bac5606969eb52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77bac5606969eb52$var$load("ivmch").then(()=>parcelRequire('b45mf'));

});

parcelRegister("ce9f2", function(module, exports) {
module.exports = JSON.parse('{"jsm-nebula-kb-suggested-topic.multiple.button.primary":[{"type":0,"value":"View suggestions"}],"jsm-nebula-kb-suggested-topic.notification.subtitle":[{"type":0,"value":"These suggestions are for "},{"type":1,"value":"projectName"}],"jsm-nebula-kb-suggested-topic.notification.title":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new article suggestion for your knowledge base"}]},"other":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new article suggestions for your knowledge base"}]}},"pluralType":"cardinal","type":6,"value":"numSuggestions"}],"jsm-nebula-kb-suggested-topic.single.button.primary":[{"type":0,"value":"View suggestion"}],"jsm-nebula-kb-suggested-topic.singletopic.notification.subtitle":[{"type":0,"value":"This suggestion is for "},{"type":1,"value":"projectName"}],"jsm-nebula-kb-suggested-topic.singletopic.notification.title":[{"type":0,"value":"You have a new article suggestion for your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.add-knowledge-from-third-party-apps":[{"type":0,"value":"Add knowledge from third-party apps"}],"jsm-nebula.jsm-kb-activation-reminder.boost-agent-productivity":[{"type":0,"value":"Boost agent productivity"}],"jsm-nebula.jsm-kb-activation-reminder.create-or-link-articles":[{"type":0,"value":"Create or link articles."}],"jsm-nebula.jsm-kb-activation-reminder.empower-customers-with-instant-access":[{"type":0,"value":"Empower customers with instant access to helpful articles"}],"jsm-nebula.jsm-kb-activation-reminder.get-started-button-label":[{"type":0,"value":"Get started"}],"jsm-nebula.jsm-kb-activation-reminder.getting-started-is-easy":[{"type":0,"value":"Getting started is easy"}],"jsm-nebula.jsm-kb-activation-reminder.greeting-message":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"jsm-nebula.jsm-kb-activation-reminder.header.text":[{"type":0,"value":"Say goodbye to knowledge silos"}],"jsm-nebula.jsm-kb-activation-reminder.how-to-set-up-your-knowledge-base":[{"type":0,"value":"How to set up your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.illustration.alt":[{"type":0,"value":"KnowledgeBase Illustration"}],"jsm-nebula.jsm-kb-activation-reminder.improve-ai-powered-suggestions":[{"type":0,"value":"Improve AI-powered suggestions"}],"jsm-nebula.jsm-kb-activation-reminder.improve-knowledge-base-health-by-closing-knowledge-gaps":[{"type":0,"value":"Improve knowledge base health by closing knowledge gaps."}],"jsm-nebula.jsm-kb-activation-reminder.knowledge-base-benefit":[{"type":0,"value":"By setting up a knowledge base, you can provide instant answers to your customers, reduce repetitive requests, and help your team resolve requests faster."}],"jsm-nebula.jsm-kb-activation-reminder.knowledge-base-help":[{"type":0,"value":"Adding knowledge to your Jira Service Management project helps:"}],"jsm-nebula.jsm-kb-activation-reminder.message-template.email.subject":[{"type":0,"value":"[Jira Service Management] Set up your knowledge base today"}],"jsm-nebula.jsm-kb-activation-reminder.need-help-explore-these-resources":[{"type":0,"value":"Need help? Explore these resources"}],"jsm-nebula.jsm-kb-activation-reminder.privacy-policy":[{"type":0,"value":"Privacy policy"}],"jsm-nebula.jsm-kb-activation-reminder.project-notice":[{"type":0,"value":"We noticed your Jira Service Management project, "},{"children":[{"type":1,"value":"project"}],"type":8,"value":"b"},{"type":0,"value":", doesn\'t have a knowledge base yet."}],"jsm-nebula.jsm-kb-activation-reminder.sent-to-you-by-atlassian-jira-service-management":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management  \u2022"}],"jsm-nebula.jsm-kb-activation-reminder.share-them-with-your-team-and-customers":[{"type":0,"value":"Share them with your team and customers."}],"jsm-nebula.jsm-kb-activation-reminder.start-building-your-knowledge-base":[{"type":0,"value":"Start building your knowledge base"}],"jsm-nebula.jsm-kb-activation-reminder.stay-notified-and-comment-on-the-go-with-jira-mobile-app":[{"type":0,"value":"Stay notified and comment on the go with Jira Mobile App"}],"jsm-nebula.jsm-kb-activation-reminder.subheading":[{"type":0,"value":"Set up knowledge base to keep requests and knowledge within Jira Service Management."}],"jsm-nebula.jsm-kb-activation-reminder.surface-instant-answers-deflect-requests-and-keep-everything-in-one-place":[{"type":0,"value":"Surface instant answers, deflect requests, and keep everything in one place"}],"jsm-nebula.jsm-kb-activation-reminder.tips-for-writing-effective-knowledge-articles":[{"type":0,"value":"Tips for writing effective knowledge articles"}],"jsm-nebula.jsm-kb-activation-reminder.to-build-your-knowledge-base":[{"type":0,"value":"To build your knowledge base, all you need to do is:"}],"jsm-nebula.jsm-kb-activation-reminder.to-customize-email-or-unsubscribe":[{"type":0,"value":"To customize the email or unsubscribe, "}],"jsm-nebula.jsm-kb-activation-reminder.update-your-notification-settings":[{"type":0,"value":"update your notification settings."}],"jsm-nebula.jsm-kb-activation-reminder.why-set-up-knowledge-base":[{"type":0,"value":"Why set up a knowledge base?"}],"jsm-nebula.solcom-create-space-spotlight.action":[{"type":0,"value":"Get started"}],"jsm-nebula.solcom-create-space-spotlight.body":[{"type":0,"value":"Tell Rovo what you need in plain language and it\'ll build the space for you."}],"jsm-nebula.solcom-create-space-spotlight.headline":[{"type":0,"value":"Support teams faster with Rovo"}]}');

});

parcelRegister("h4XLq", function(module, exports) {

let $c6f12b486c75c484$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c6f12b486c75c484$var$load("2hoPf").then(()=>parcelRequire('ksGGA'));

});

parcelRegister("aSIuu", function(module, exports) {

let $7ec17572ab57c42e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ec17572ab57c42e$var$load("h2DZg").then(()=>parcelRequire('be3Fc'));

});

parcelRegister("23l4O", function(module, exports) {

let $17ec35f0fb79820f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $17ec35f0fb79820f$var$load("i8MqZ").then(()=>parcelRequire('4iWFW'));

});

parcelRegister("cChEl", function(module, exports) {

let $92f6b97eafe79655$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $92f6b97eafe79655$var$load("lE85C").then(()=>parcelRequire('ngbTB'));

});

parcelRegister("f3rj4", function(module, exports) {

let $af5c51545a31e1b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af5c51545a31e1b5$var$load("2Vb2u").then(()=>parcelRequire('8Tx8H'));

});

parcelRegister("gcN2A", function(module, exports) {

let $bcc3cec750b14c9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bcc3cec750b14c9a$var$load("lb22P").then(()=>parcelRequire('lsm9k'));

});

parcelRegister("bzeFj", function(module, exports) {

let $86be56d2144abf92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86be56d2144abf92$var$load("8SVs3").then(()=>parcelRequire('5DOQP'));

});

parcelRegister("iaQTW", function(module, exports) {

let $d3b2324016b7b137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d3b2324016b7b137$var$load("kSW8T").then(()=>parcelRequire('4I2Tm'));

});

parcelRegister("3VbYR", function(module, exports) {

let $2daffd0df4e42727$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2daffd0df4e42727$var$load("8R6v8").then(()=>parcelRequire('efSSv'));

});

parcelRegister("66euP", function(module, exports) {

let $470e8c48e35e5658$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $470e8c48e35e5658$var$load("lRlez").then(()=>parcelRequire('9KjV4'));

});

parcelRegister("dWdh5", function(module, exports) {

let $a25afd32beb7a311$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a25afd32beb7a311$var$load("7uxAd").then(()=>parcelRequire('5wLXc'));

});

parcelRegister("6L5mq", function(module, exports) {

let $4ebb4a5d8d00bf8b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ebb4a5d8d00bf8b$var$load("6ZAZK").then(()=>parcelRequire('iUNPK'));

});

parcelRegister("8d9mp", function(module, exports) {

let $5fa6cc65f32aa3fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5fa6cc65f32aa3fa$var$load("iUoKv").then(()=>parcelRequire('lV45y'));

});

parcelRegister("6oh7C", function(module, exports) {

let $4a72440701c3a072$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a72440701c3a072$var$load("gRQ4A").then(()=>parcelRequire('1Pq7B'));

});

parcelRegister("5Ih8N", function(module, exports) {

let $428e5ba2901e35ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $428e5ba2901e35ca$var$load("7W3A8").then(()=>parcelRequire('1cjlo'));

});

parcelRegister("aiIM4", function(module, exports) {

let $77fe510e579e24a6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77fe510e579e24a6$var$load("5uxEx").then(()=>parcelRequire('9hNFj'));

});

parcelRegister("ezVJc", function(module, exports) {

let $a9d11d2c24419247$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a9d11d2c24419247$var$load("br3uv").then(()=>parcelRequire('8Qbrh'));

});

parcelRegister("d5Py7", function(module, exports) {

let $9883ba9a534c4fe3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9883ba9a534c4fe3$var$load("iPZA4").then(()=>parcelRequire('4mnrm'));

});

parcelRegister("l460a", function(module, exports) {

let $f55ea07e33a23219$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f55ea07e33a23219$var$load("8NPMz").then(()=>parcelRequire('8ZrYM'));

});

parcelRegister("ktgFI", function(module, exports) {

let $ee7372c6fed87f41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee7372c6fed87f41$var$load("HyqnQ").then(()=>parcelRequire('4Y1Om'));

});

parcelRegister("5RWbp", function(module, exports) {

let $445f08e90572cd9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $445f08e90572cd9a$var$load("kV7xL").then(()=>parcelRequire('9gsmM'));

});

parcelRegister("akrpS", function(module, exports) {

let $785109f15a47bf0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $785109f15a47bf0b$var$load("hvokT").then(()=>parcelRequire('lzKpS'));

});

parcelRegister("9su3t", function(module, exports) {

let $6e2e0ae65eae4002$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e2e0ae65eae4002$var$load("j4XhX").then(()=>parcelRequire('aSk5o'));

});

parcelRegister("krb0o", function(module, exports) {

let $ee0eddb43867fc9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee0eddb43867fc9e$var$load("iW785").then(()=>parcelRequire('cwNj3'));

});

parcelRegister("ax70l", function(module, exports) {

let $7ab26b6e7b307337$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ab26b6e7b307337$var$load("c2qY5").then(()=>parcelRequire('7dIob'));

});

parcelRegister("Mb2FM", function(module, exports) {

let $090d0c8afe100800$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $090d0c8afe100800$var$load("lynYB").then(()=>parcelRequire('aRezM'));

});

parcelRegister("5hvFc", function(module, exports) {

let $3d871a00b9d04d9f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d871a00b9d04d9f$var$load("ah8oK").then(()=>parcelRequire('k2qXo'));

});

parcelRegister("i9uou", function(module, exports) {

let $d370a4e3974b021b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d370a4e3974b021b$var$load("bFPau").then(()=>parcelRequire('dWKDy'));

});

parcelRegister("bqXXX", function(module, exports) {

let $0225f21ea6bc4206$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0225f21ea6bc4206$var$load("canhk").then(()=>parcelRequire('bO4BZ'));

});

parcelRegister("bwbqM", function(module, exports) {

let $862b8cd05c131e76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $862b8cd05c131e76$var$load("kSVFa").then(()=>parcelRequire('dMM03'));

});

parcelRegister("d4pv2", function(module, exports) {

let $983f6dc554f1233d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $983f6dc554f1233d$var$load("1TBSO").then(()=>parcelRequire('gGBhu'));

});

parcelRegister("4im8D", function(module, exports) {

let $320a040d2b0da095$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $320a040d2b0da095$var$load("dNopY").then(()=>parcelRequire('gNGKu'));

});

parcelRegister("8RCWw", function(module, exports) {

let $67417b3a6bd801d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67417b3a6bd801d5$var$load("kXnHJ").then(()=>parcelRequire('6YGvg'));

});

parcelRegister("c6FoP", function(module, exports) {

let $8d0628a1c685ee2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d0628a1c685ee2a$var$load("eveqf").then(()=>parcelRequire('6dqVR'));

});

parcelRegister("2N9a7", function(module, exports) {
module.exports = JSON.parse('{"post-office.stakeholder-comms-common.email-header.atlassian-logo-alt":[{"type":0,"value":"Atlassian"}],"stakeholder-comms-confirm-add-subscriber-email.email-events-list.no-translate":[{"type":0,"value":"You will now receive emails whenever:"}],"stakeholder-comms-confirm-add-subscriber-email.endpoint-info.no-translate":[{"type":0,"value":"View Status page"}],"stakeholder-comms-confirm-add-subscriber-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-confirm-add-subscriber-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-confirm-add-subscriber-email.list-item.incident-resolved.no-translate":[{"type":0,"value":"An incident is resolved"}],"stakeholder-comms-confirm-add-subscriber-email.list-item.service-outage.no-translate":[{"type":0,"value":"A service outage or degradation occurs"}],"stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Added as subscriber to status page updates"}],"stakeholder-comms-confirm-add-subscriber-email.message-template.email.subject-with-page-name.no-translate":[{"type":0,"value":"Added as subscriber to "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status updates"}],"stakeholder-comms-confirm-add-subscriber-email.title-message.email.title.no-translate":[{"type":0,"value":"You have been added as a subscriber"}],"stakeholder-comms-confirm-add-subscriber-email.webhook-added.no-translate":[{"type":0,"value":"The admin has successfully added you as a subscriber to "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page."}],"stakeholder-comms-webhook-notification-confirmation-email.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-notification-confirmation-email.endpoint-info.no-translate":[{"type":0,"value":"The endpoint "},{"type":1,"value":"webhookEndpointUrl"},{"type":0,"value":" is now set to receive updates. "}],"stakeholder-comms-webhook-notification-confirmation-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-notification-confirmation-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-notification-confirmation-email.greeting.no-translate":[{"type":0,"value":"Hi there,"}],"stakeholder-comms-webhook-notification-confirmation-email.title-message.email.title.no-translate":[{"type":0,"value":"Webhook subscription activated"}],"stakeholder-comms-webhook-notification-confirmation-email.webhook-added.no-translate":[{"type":0,"value":"We\'ve added your webhook subscription for "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page."}],"stakeholder-comms-webhook-notification-delivery-failure.deactivation-reason.no-translate":[{"type":0,"value":" has been deactivated because we couldn\'t deliver notifications to it. This endpoint was previously reachable, but it\'s now returning errors or is unreachable."}],"stakeholder-comms-webhook-notification-delivery-failure.endpoint-deactivated.no-translate":[{"type":0,"value":"Your endpoint "},{"type":1,"value":"webhookEndpointUrl"}],"stakeholder-comms-webhook-notification-delivery-failure.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-notification-delivery-failure.footer-message-url.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-notification-delivery-failure.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-notification-delivery-failure.resubscribe-message.no-translate":[{"type":0,"value":"To continue receiving updates, resubscribe to your endpoint."}],"stakeholder-comms-webhook-notification-delivery-failure.title-message.email.title.no-translate":[{"type":0,"value":"Webhook subscription deactivated"}],"stakeholder-comms-webhook-validation-failure.endpoint-info-hyperlink.no-translate":[{"type":0,"value":"Read more about status pages"}],"stakeholder-comms-webhook-validation-failure.endpoint-unreachable.no-translate":[{"type":0,"value":"The endpoint "},{"type":1,"value":"webhookEndpointUrl"},{"type":0,"value":" could not be reached or did not respond."}],"stakeholder-comms-webhook-validation-failure.footer-message-url.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"stakeholder-comms-webhook-validation-failure.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"stakeholder-comms-webhook-validation-failure.title-message.email.title.no-translate":[{"type":0,"value":"Endpoint validation failed"}],"stakeholder-comms-webhook-validation-failure.webhook-validation-error.no-translate":[{"type":0,"value":"We couldn\'t notify your webhook for "},{"type":1,"value":"pageNameText"},{"type":0,"value":" status page updates."}],"status-page.create-component-details.spotlight.got-it":[{"type":0,"value":"Ok, got it"}],"status-page.create-component.spotlight.action":[{"type":0,"value":"Dismiss"}],"status-page.create-component.spotlight.primary-action":[{"type":0,"value":"Next"}],"status-page.create-component.spotlight.step1.body":[{"type":0,"value":"Customize each component and link it to a service"}],"status-page.create-component.spotlight.step1.heading":[{"type":0,"value":"Add component"}],"status-page.create-component.spotlight.step2.body":[{"type":0,"value":"Organize your components by adding them to specific groups."}],"status-page.create-component.spotlight.step2.heading":[{"type":0,"value":"Group components"}],"status-page.create-component.spotlight.step3.body":[{"type":0,"value":"Add multiple components and groups for better structure and clarity."}],"status-page.create-component.spotlight.step3.heading":[{"type":0,"value":"Manage and organize"}],"status-page.details.actions.spotlight.body":[{"type":0,"value":"Easily manage your status page, edit details and post updates to keep your audience informed."}],"status-page.details.actions.spotlight.got-it":[{"type":0,"value":"Ok, got it"}],"status-page.details.actions.spotlight.heading":[{"type":0,"value":"Update and manage"}],"status-page.details.tabs.spotlight.action":[{"type":0,"value":"Dismiss"}],"status-page.details.tabs.spotlight.body":[{"type":0,"value":"Review your status page, target audience, and post real-time incident updates, all from a single place."}],"status-page.details.tabs.spotlight.body.line1":[{"type":0,"value":"Review your status page, target"}],"status-page.details.tabs.spotlight.body.line2":[{"type":0,"value":"audience, and post real-time incident"}],"status-page.details.tabs.spotlight.body.line3":[{"type":0,"value":"updates, all from a single place."}],"status-page.details.tabs.spotlight.heading":[{"type":0,"value":"All at a glance"}],"status-page.details.tabs.spotlight.primary-action":[{"type":0,"value":"Next"}],"statuspage.actions-spotlight.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"statuspage.appearance-spotlight.action":[{"type":0,"value":"Ok, got it"}],"statuspage.appearance-spotlight.body":[{"type":0,"value":"Customize with additional flexibility and advanced styling."}],"statuspage.appearance-spotlight.heading":[{"type":0,"value":"Switch to CSS view"}],"statuspage.confirm-incident-notifications.button.verify-email.no-translate":[{"type":0,"value":"Confirm subscription"}],"statuspage.confirm-incident-notifications.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.confirm-incident-notifications.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.confirm-incident-notifications.list-item.incident-resolved.no-translate":[{"type":0,"value":"An incident is resolved"}],"statuspage.confirm-incident-notifications.list-item.scheduled-maintenance.no-translate":[{"type":0,"value":"Scheduled maintenance is announced"}],"statuspage.confirm-incident-notifications.list-item.service-outage.no-translate":[{"type":0,"value":"A service outage or degradation occurs"}],"statuspage.confirm-incident-notifications.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Confirm your email to subscribe to status page updates"}],"statuspage.confirm-incident-notifications.message-template.email.subject-with-page-name.no-translate":[{"type":0,"value":"Confirm your email to subscribe to "},{"type":1,"value":"pageName"},{"type":0,"value":" status updates"}],"statuspage.confirm-incident-notifications.test-message.email.body-hello.no-translate":[{"type":0,"value":"Hi there,"},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Please confirm your email address to start receiving incident and maintenance notifications."},{"type":1,"value":"br"},{"type":1,"value":"br"},{"type":0,"value":"Once confirmed, you\u2019ll receive emails whenever:"}],"statuspage.confirm-incident-notifications.title-message.email.title.no-translate":[{"type":0,"value":"Confirm your subscription"}],"statuspage.create-component-spotlight.progress":[{"type":1,"value":"currentStep"},{"type":0,"value":"/"},{"type":1,"value":"totalSteps"}],"statuspage.edit-spotlight.action":[{"type":0,"value":"Done"}],"statuspage.edit-spotlight.body":[{"type":0,"value":"Customize your status page to match your brand. Add the components you need and personalize the look and feel with brand new colours and themes."}],"statuspage.edit-spotlight.heading":[{"type":0,"value":"Status page created! Set it up in a few simple steps."}],"statuspage.navigation-spotlight.action":[{"type":0,"value":"About status pages"}],"statuspage.navigation-spotlight.body":[{"type":0,"value":"Post real-time updates and customize your status pages directly from here, without switching platforms."}],"statuspage.navigation-spotlight.heading":[{"type":0,"value":"Create and manage status pages"}],"statuspage.stakeholder-comms-archive-email.title.no-translate":[{"type":0,"value":"Your status page is archived and will be deleted in 60 days."}],"statuspage.stakeholder-comms-archive-page-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-archive-page-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-archive-page-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Details of the status page"}],"statuspage.stakeholder-comms-archive-page-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Atlassian Logo"}],"statuspage.stakeholder-comms-archive-page-email.message-template.email.subject.no-translate":[{"type":0,"value":"Status page archived"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Archived on"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"archivedOn"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"URL"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"pageUrl"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time-title.no-translate":[{"type":0,"value":"Permanent deletion date"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.incident-info-time.no-translate":[{"type":1,"value":"deletionDate"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'ve received your request to archive the status page. This status page will be automatically deleted in 60 days"}],"statuspage.stakeholder-comms-archive-page-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"If you wish to restore it, you can do so within the next 60 days"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"statuspage.stakeholder-comms-confirm-webhook-subscription-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-maintenance-custom-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"statuspage.stakeholder-comms-maintenance-custom-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"statuspage.stakeholder-comms-maintenance-custom-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-maintenance-notification-email.affected-components-title.no-translate":[{"type":0,"value":"Affected components"}],"statuspage.stakeholder-comms-maintenance-notification-email.affected-components.and-more.no-translate":[{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"statuspage.stakeholder-comms-maintenance-notification-email.affected-components.no-translate":[{"type":1,"value":"affectedComponentsString"}],"statuspage.stakeholder-comms-maintenance-notification-email.affected-components.none.no-translate":[{"type":0,"value":"None"}],"statuspage.stakeholder-comms-maintenance-notification-email.button.view-maintenance.no-translate":[{"type":0,"value":"View Maintenance"}],"statuspage.stakeholder-comms-maintenance-notification-email.details-title.no-translate":[{"type":0,"value":"Details"}],"statuspage.stakeholder-comms-maintenance-notification-email.details-value.no-translate":[{"type":1,"value":"maintenanceMessage"}],"statuspage.stakeholder-comms-maintenance-notification-email.footer-message.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-maintenance-notification-email.footer-privacy-policy.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-maintenance-notification-email.footer-unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-maintenance-notification-email.hello.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-maintenance-notification-email.introduction.end.no-translate":[{"type":0,"value":"You\'re receiving this email because you\'re subscribed to maintenance updates for "},{"type":1,"value":"statusPageName"},{"type":0,"value":" Status Page. The scheduled maintenance is complete. Here are the details:"}],"statuspage.stakeholder-comms-maintenance-notification-email.introduction.one-hour-reminder.no-translate":[{"type":0,"value":"You\'re receiving this email because you\'re subscribed to maintenance updates for "},{"type":1,"value":"statusPageName"},{"type":0,"value":" Status Page. This is a reminder that scheduled maintenance will begin in approximately one hour. Here are the details:"}],"statuspage.stakeholder-comms-maintenance-notification-email.introduction.scheduled.no-translate":[{"type":0,"value":"You\'re receiving this email because you\'re subscribed to maintenance updates for "},{"type":1,"value":"statusPageName"},{"type":0,"value":" Status Page. We\'re planning maintenance that may affect some components. Here are the details:"}],"statuspage.stakeholder-comms-maintenance-notification-email.introduction.start.no-translate":[{"type":0,"value":"You\'re receiving this email because you\'re subscribed to maintenance updates for "},{"type":1,"value":"statusPageName"},{"type":0,"value":" Status Page. Scheduled maintenance is now in progress. Here are the details:"}],"statuspage.stakeholder-comms-maintenance-notification-email.maintenance-details.no-translate":[{"type":0,"value":"Maintenance details"}],"statuspage.stakeholder-comms-maintenance-notification-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Status page Maintenance: "},{"type":1,"value":"maintenanceTitle"},{"type":0,"value":" ("},{"type":1,"value":"maintenanceStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-maintenance-notification-email.message-template.email.subject-with-page-name.no-translate":[{"type":1,"value":"statusPageName"},{"type":0,"value":" Maintenance: "},{"type":1,"value":"maintenanceTitle"},{"type":0,"value":" ("},{"type":1,"value":"maintenanceStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-maintenance-notification-email.no-action.no-translate":[{"type":0,"value":"No action is required at this time. If you rely on the above mentioned components, plan any time-sensitive work outside this maintenance window."}],"statuspage.stakeholder-comms-maintenance-notification-email.status-title.no-translate":[{"type":0,"value":"Status"}],"statuspage.stakeholder-comms-maintenance-notification-email.status-value.no-translate":[{"type":1,"value":"maintenanceStatus"}],"statuspage.stakeholder-comms-maintenance-notification-email.time-posted-title.no-translate":[{"type":0,"value":"Time posted"}],"statuspage.stakeholder-comms-maintenance-notification-email.time-posted-value.no-translate":[{"type":1,"value":"timePosted"}],"statuspage.stakeholder-comms-maintenance-notification-email.title.no-translate":[{"type":1,"value":"maintenanceTitle"}],"statuspage.stakeholder-comms-page-restored-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-page-restored-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-page-restored-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Details of the status page"}],"statuspage.stakeholder-comms-page-restored-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Atlassian Logo"}],"statuspage.stakeholder-comms-page-restored-email.message-template.email.subject.no-translate":[{"type":0,"value":"Status page restored"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Archived on"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"archivedOn"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"URL"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"pageUrl"}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'ve received your request to restore the status page. You can now edit the page and post any updates as needed."}],"statuspage.stakeholder-comms-page-restored-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"You can publish the page when you\'re ready to make it accessible to all subscribers."}],"statuspage.stakeholder-comms-page-restored-email.title.no-translate":[{"type":0,"value":"Your status page has been restored"}],"statuspage.stakeholder-comms-sender-test.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-sender-test.footer-message.email.body":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-sender-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-sender-test.test-message.email.body.no-translate":[{"type":0,"value":"Thanks for subscribing to pageName status updates. You\'re almost done - we just need to confirm your subscription."}],"statuspage.stakeholder-comms-sender-test.test-message.email.link-body.no-translate":[{"type":0,"value":"In order to activate your subscription, please click the following link:"}],"statuspage.stakeholder-comms-sender-test.title-message.email.title":[{"type":0,"value":"Confirm your subscription."}],"statuspage.stakeholder-comms-subscriber-incident-status-email.affected-components.and-more.no-translate":[{"type":0,"value":" and "},{"type":1,"value":"count"},{"type":0,"value":" more"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.button.view-status-page.no-translate":[{"type":0,"value":"View Status page"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-message.email.body.no-translate":[{"type":0,"value":"Sent to you by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-subscriber-incident-status-email.footer-unsubscribe-url.email.email.no-translate":[{"type":0,"value":"Unsubscribe"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.incident-details-message.email.title.no-translate":[{"type":0,"value":"Incident details"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-generic.no-translate":[{"type":0,"value":"Status page Incident: "},{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.message-template.email.subject-with-page-name.no-translate":[{"type":1,"value":"pageName"},{"type":0,"value":" Incident: "},{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.hello-message.no-translate":[{"type":0,"value":"Hi there,"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components-title.no-translate":[{"type":0,"value":"Affected components"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-affected-components.no-translate":[{"type":1,"value":"affectedComponentsString"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-description-title.no-translate":[{"type":0,"value":"Details"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-details.no-translate":[{"type":1,"value":"incidentDescription"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status-title.no-translate":[{"type":0,"value":"Status"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-status.no-translate":[{"type":1,"value":"incidentStatus"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time-title.no-translate":[{"type":0,"value":"Time posted"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.incident-info-time.no-translate":[{"type":1,"value":"timePosted"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.introduction-message.no-translate":[{"type":0,"value":"We\'re investigating issues reported on the "},{"type":1,"value":"pageNameText"},{"type":0,"value":"status page. Here are the details:"}],"statuspage.stakeholder-comms-subscriber-incident-status-email.test-message.email.post-info-message.no-translate":[{"type":0,"value":"You received this email because you subscribed to incident updates for "},{"type":1,"value":"pageNameText"},{"type":0,"value":"."}],"statuspage.stakeholder-comms-subscriber-incident-status-email.title-message.email.title.no-translate":[{"type":1,"value":"incidentName"},{"type":0,"value":" ("},{"type":1,"value":"incidentStatus"},{"type":0,"value":")"}],"statuspage.stakeholder-comms-user-added-verify-email.button.verify-email":[{"type":0,"value":"Verify your email"}],"statuspage.stakeholder-comms-user-added-verify-email.footer-message-url.email.email.no-translate":[{"type":0,"value":"Privacy Policy"}],"statuspage.stakeholder-comms-user-added-verify-email.footer-message.email.body":[{"type":0,"value":"This email was sent by Atlassian Jira Service Management \u2022 "}],"statuspage.stakeholder-comms-user-added-verify-email.message-template.email.subject.no-translate":[{"type":0,"value":"[Action required] Verify your email to join "},{"type":1,"value":"siteName"},{"type":0,"value":"\'s site as a stakeholder on "},{"type":1,"value":"env"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message1.email.body":[{"type":0,"value":"Know about disruptions that affect operations"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message2.email.body":[{"type":0,"value":"Make better decisions as you\u2019re always informed"}],"statuspage.stakeholder-comms-user-added-verify-email.table-message3.email.body":[{"type":0,"value":"Get notified about the health and status of key services"}],"statuspage.stakeholder-comms-user-added-verify-email.table-title-message.email.title":[{"type":0,"value":"Stay in the loop always"}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"G\'day "},{"type":1,"value":"name"},{"type":0,"value":","}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body1.no-translate":[{"type":1,"value":"adminName"},{"type":0,"value":" has invited you to join their Jira Service Management site, "},{"type":1,"value":"siteName"},{"type":0,"value":", as a stakeholder."}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body2.no-translate":[{"type":0,"value":"Once you verify your email, you\'ll start receiving important notifications about incidents and changes directly to your inbox."}],"statuspage.stakeholder-comms-user-added-verify-email.test-message.email.body3.no-translate":[{"type":0,"value":"To receive updates on incidents communications, verify your email now!"}],"statuspage.stakeholder-comms-user-added-verify-email.title-message.email.title":[{"type":0,"value":"You\u2019ve been invited to join "},{"type":1,"value":"siteName"},{"type":0,"value":" as a stakeholder"}],"statuspage.stakeholder-comms-webhook-notification-confirmation-email.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription is active"}],"statuspage.stakeholder-comms-webhook-notification-delivery-failure.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription is deactivated"}],"statuspage.stakeholder-comms-webhook-validation-failure.message-template.email.subject.no-translate":[{"type":0,"value":"Your webhook subscription could not be activated"}],"statuspage.statuspage-navigation-spotlight-v2.description.no-translate":[{"type":0,"value":"Statuspage navigation spotlight v2 test message."}],"statuspage.statuspage-navigation-spotlight-v2.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"statuspage.statuspage-navigation-spotlight.description.no-translate":[{"type":0,"value":"Statuspage navigation spotlight test message."}],"statuspage.statuspage-navigation-spotlight.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}]}');

});

parcelRegister("c2txx", function(module, exports) {

let $8c3c95f20262782b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8c3c95f20262782b$var$load("dkOn3").then(()=>parcelRequire('1Lsqe'));

});

parcelRegister("5bfTF", function(module, exports) {

let $3c5a4f99f839bb84$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3c5a4f99f839bb84$var$load("9rrQ3").then(()=>parcelRequire('5VTyv'));

});

parcelRegister("yv2PF", function(module, exports) {

let $067b41eaef55dd30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $067b41eaef55dd30$var$load("lMHeM").then(()=>parcelRequire('2wmA2'));

});

parcelRegister("5ytEt", function(module, exports) {

let $40b720f17e9295c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $40b720f17e9295c1$var$load("dyg7C").then(()=>parcelRequire('5gVqq'));

});

parcelRegister("84xPc", function(module, exports) {

let $5e08ef53c2da31b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5e08ef53c2da31b6$var$load("exJfV").then(()=>parcelRequire('aCwYR'));

});

parcelRegister("g50do", function(module, exports) {

let $bb4d47a6287a3920$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb4d47a6287a3920$var$load("gsZNK").then(()=>parcelRequire('2XELA'));

});

parcelRegister("ldTqI", function(module, exports) {

let $f735cf1d9643f8c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f735cf1d9643f8c9$var$load("6PSzu").then(()=>parcelRequire('hqeI3'));

});

parcelRegister("1P4Bo", function(module, exports) {

let $153e1fbb0e76155b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $153e1fbb0e76155b$var$load("9xa6R").then(()=>parcelRequire('lP7yJ'));

});

parcelRegister("kLuUQ", function(module, exports) {

let $f1e02dadbf355fe3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1e02dadbf355fe3$var$load("1YQWl").then(()=>parcelRequire('8PJr6'));

});

parcelRegister("17Z99", function(module, exports) {

let $0d25e0548c28b24f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0d25e0548c28b24f$var$load("2K7kE").then(()=>parcelRequire('9Nkia'));

});

parcelRegister("7WGGY", function(module, exports) {

let $5c8f10eca2afd5a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5c8f10eca2afd5a2$var$load("7l3Pb").then(()=>parcelRequire('lWLcR'));

});

parcelRegister("jeifm", function(module, exports) {

let $dffd7a892c99e561$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dffd7a892c99e561$var$load("94J3Y").then(()=>parcelRequire('jhQrO'));

});

parcelRegister("dM9Ko", function(module, exports) {

let $a07751ad769c56df$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a07751ad769c56df$var$load("dp569").then(()=>parcelRequire('fxGXs'));

});

parcelRegister("9dS55", function(module, exports) {

let $6b6f47556d160e80$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b6f47556d160e80$var$load("ciwQa").then(()=>parcelRequire('cDmyS'));

});

parcelRegister("aruux", function(module, exports) {

let $79a413fb4df28c6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79a413fb4df28c6f$var$load("lUobG").then(()=>parcelRequire('56ziH'));

});

parcelRegister("6z61k", function(module, exports) {

let $4c7aae7901bad2e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4c7aae7901bad2e3$var$load("aW2jH").then(()=>parcelRequire('hnC1a'));

});

parcelRegister("5kRoJ", function(module, exports) {

let $3e283db97351b18a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3e283db97351b18a$var$load("8jpkv").then(()=>parcelRequire('4YnFK'));

});

parcelRegister("feR2c", function(module, exports) {

let $b1814d5ca40bbc4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1814d5ca40bbc4a$var$load("9H4Yh").then(()=>parcelRequire('6D2O4'));

});

parcelRegister("4etg2", function(module, exports) {

let $314f2a345afdf3a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $314f2a345afdf3a7$var$load("2OxSs").then(()=>parcelRequire('25Wds'));

});

parcelRegister("8nZQJ", function(module, exports) {

let $01935cb06e143400$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01935cb06e143400$var$load("2xkr3").then(()=>parcelRequire('exVrW'));

});

parcelRegister("8lFmQ", function(module, exports) {

let $61405f9650dda366$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61405f9650dda366$var$load("hs9ik").then(()=>parcelRequire('i6yE3'));

});

parcelRegister("g8jnN", function(module, exports) {

let $bbec6db8ee996d2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bbec6db8ee996d2c$var$load("ccCKs").then(()=>parcelRequire('hXUtP'));

});

parcelRegister("jBETK", function(module, exports) {

let $e461328eabd5e724$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e461328eabd5e724$var$load("6CgbS").then(()=>parcelRequire('9iyv6'));

});

parcelRegister("3rMHk", function(module, exports) {

let $2829ab117b1f6bf2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2829ab117b1f6bf2$var$load("kA0Mr").then(()=>parcelRequire('63UFV'));

});

parcelRegister("dIytw", function(module, exports) {

let $9fca207ba7e0c574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9fca207ba7e0c574$var$load("bZGIU").then(()=>parcelRequire('41VWU'));

});

parcelRegister("ISfPl", function(module, exports) {

let $086e31f1c129de58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $086e31f1c129de58$var$load("cLU5V").then(()=>parcelRequire('dZMvw'));

});

parcelRegister("9vqSC", function(module, exports) {

let $6ebbdc196f4d360a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ebbdc196f4d360a$var$load("PqYIe").then(()=>parcelRequire('RPxwf'));

});

parcelRegister("dcv25", function(module, exports) {

let $99c477ce9e884692$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99c477ce9e884692$var$load("gUDo1").then(()=>parcelRequire('iNKsx'));

});

parcelRegister("6DwO1", function(module, exports) {

let $4d4fd521603a06b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d4fd521603a06b8$var$load("1DKre").then(()=>parcelRequire('6tNEy'));

});

parcelRegister("4iphv", function(module, exports) {

let $320c74323becf2e2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $320c74323becf2e2$var$load("2nKmH").then(()=>parcelRequire('jIByH'));

});

parcelRegister("fxZOi", function(module, exports) {

let $b519e24ddafcf476$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b519e24ddafcf476$var$load("d21Hl").then(()=>parcelRequire('elIN1'));

});

parcelRegister("9GOzA", function(module, exports) {

let $70df4405e839235f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70df4405e839235f$var$load("dfRLB").then(()=>parcelRequire('g1EId'));

});

parcelRegister("dfTVS", function(module, exports) {

let $9a681017f9e71d7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a681017f9e71d7a$var$load("kLIOD").then(()=>parcelRequire('j2ZL3'));

});

parcelRegister("Nzu2E", function(module, exports) {

let $09501a02ce48a566$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $09501a02ce48a566$var$load("iJ0AA").then(()=>parcelRequire('3eqd8'));

});

parcelRegister("jZkCD", function(module, exports) {
module.exports = JSON.parse("{\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.cta-link\":[{\"type\":0,\"value\":\"Go to space\"}],\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.description\":[{\"type\":0,\"value\":\"Your work has been imported and your new space is set up.\"}],\"post-office.team-wolverine.team-wolverine-jira-migration-success.screen-space-flags.header\":[{\"type\":0,\"value\":\"Your space is ready\"}]}");

});

parcelRegister("6ZT3C", function(module, exports) {

let $518325d2f79a65ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $518325d2f79a65ae$var$load("cg3GS").then(()=>parcelRequire('59e1l'));

});

parcelRegister("5cTfJ", function(module, exports) {

let $3ca8eecbbc768e9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ca8eecbbc768e9b$var$load("6SbRq").then(()=>parcelRequire('4lYdB'));

});

parcelRegister("camC3", function(module, exports) {

let $8db7f5a6918372b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8db7f5a6918372b4$var$load("d7GYX").then(()=>parcelRequire('5cwpc'));

});

parcelRegister("a1edG", function(module, exports) {

let $74b5072277453fe7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $74b5072277453fe7$var$load("dVLgf").then(()=>parcelRequire('8OX4t'));

});

parcelRegister("hozy7", function(module, exports) {

let $caa040e71203fe9c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $caa040e71203fe9c$var$load("6offb").then(()=>parcelRequire('1nfLG'));

});

parcelRegister("3sU7B", function(module, exports) {

let $285f8538b32f554a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $285f8538b32f554a$var$load("tkrur").then(()=>parcelRequire('1U0bm'));

});

parcelRegister("ad5pE", function(module, exports) {

let $76ef51252b89fa0f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $76ef51252b89fa0f$var$load("ePGL7").then(()=>parcelRequire('9m0ZZ'));

});

parcelRegister("lTULb", function(module, exports) {

let $ff1ac361905b20bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ff1ac361905b20bd$var$load("7AfGw").then(()=>parcelRequire('6sWpL'));

});

parcelRegister("dAEiR", function(module, exports) {

let $9e4de68473c8091e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e4de68473c8091e$var$load("lqSaP").then(()=>parcelRequire('1lEAN'));

});

parcelRegister("9nH1R", function(module, exports) {

let $6d47a3b26d0e463a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d47a3b26d0e463a$var$load("ghOMN").then(()=>parcelRequire('gb2jc'));

});

parcelRegister("kjKfL", function(module, exports) {

let $eca975efeeabaa70$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eca975efeeabaa70$var$load("cuIms").then(()=>parcelRequire('aCy2v'));

});

parcelRegister("g2PTm", function(module, exports) {

let $bae515e3cc7db40d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bae515e3cc7db40d$var$load("gjDiT").then(()=>parcelRequire('iYkhF'));

});

parcelRegister("6q5Fg", function(module, exports) {

let $4ac990a9a7106f39$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ac990a9a7106f39$var$load("7cize").then(()=>parcelRequire('jVqyT'));

});

parcelRegister("lghd1", function(module, exports) {

let $03fe9677998d683a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $03fe9677998d683a$var$load("8Xg77").then(()=>parcelRequire('kriK5'));

});

parcelRegister("64AMJ", function(module, exports) {

let $46bfa68356781fb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46bfa68356781fb1$var$load("4Qt6m").then(()=>parcelRequire('6Su4j'));

});

parcelRegister("a7XXP", function(module, exports) {

let $75f9126d4b8cb9f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $75f9126d4b8cb9f2$var$load("dHfMi").then(()=>parcelRequire('bgKoB'));

});

parcelRegister("b5VVj", function(module, exports) {

let $813d17b1d510d594$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $813d17b1d510d594$var$load("gdILP").then(()=>parcelRequire('dZO5w'));

});

parcelRegister("jlOJT", function(module, exports) {

let $e167563f8b2b34d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e167563f8b2b34d1$var$load("fd6UR").then(()=>parcelRequire('1E4jW'));

});

parcelRegister("hIhOs", function(module, exports) {

let $ce545cf68e4dac31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce545cf68e4dac31$var$load("aFPee").then(()=>parcelRequire('kDu7b'));

});

parcelRegister("28Vku", function(module, exports) {

let $18f8cc930c07a92f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $18f8cc930c07a92f$var$load("4r5MC").then(()=>parcelRequire('dRwNL'));

});

parcelRegister("2sxxn", function(module, exports) {

let $1ca8361ad84f0ae4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1ca8361ad84f0ae4$var$load("9DQeJ").then(()=>parcelRequire('lFxj3'));

});

parcelRegister("aRIgT", function(module, exports) {

let $7e9132007d1a9628$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e9132007d1a9628$var$load("4awUz").then(()=>parcelRequire('393nX'));

});

parcelRegister("9ciVU", function(module, exports) {

let $6b23ebbc568acbed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6b23ebbc568acbed$var$load("iF52h").then(()=>parcelRequire('ezqBe'));

});

parcelRegister("5DLSN", function(module, exports) {

let $41b5bccb49f4272b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41b5bccb49f4272b$var$load("bgcC0").then(()=>parcelRequire('atcQX'));

});

parcelRegister("jMFNQ", function(module, exports) {

let $e672ed311771acd0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e672ed311771acd0$var$load("6GASH").then(()=>parcelRequire('bVIoD'));

});

parcelRegister("72eR9", function(module, exports) {

let $51f43e79da823257$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51f43e79da823257$var$load("2TbuH").then(()=>parcelRequire('13c5l'));

});

parcelRegister("8Vo2l", function(module, exports) {

let $67f64ad2ca8ba6e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $67f64ad2ca8ba6e8$var$load("cMZfy").then(()=>parcelRequire('dlhw6'));

});

parcelRegister("8sK49", function(module, exports) {

let $6294abfd4ae45f32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6294abfd4ae45f32$var$load("7DQ9M").then(()=>parcelRequire('8Wmxm'));

});

parcelRegister("jvQHv", function(module, exports) {

let $e349cad3cad63e1c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e349cad3cad63e1c$var$load("iacA0").then(()=>parcelRequire('kZDqV'));

});

parcelRegister("i2Vpd", function(module, exports) {

let $d234f17efe702777$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d234f17efe702777$var$load("POM2m").then(()=>parcelRequire('eetOO'));

});

parcelRegister("8qoY9", function(module, exports) {

let $62241ec6bb41ae9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62241ec6bb41ae9a$var$load("2Qw02").then(()=>parcelRequire('d1Q49'));

});

parcelRegister("1hFwa", function(module, exports) {

let $0ef79586c4cf848f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ef79586c4cf848f$var$load("6VXSK").then(()=>parcelRequire('5oVxu'));

});

parcelRegister("4nr8Z", function(module, exports) {

let $32fe5da6846621e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $32fe5da6846621e4$var$load("1vhr7").then(()=>parcelRequire('6m47E'));

});

parcelRegister("kBX89", function(module, exports) {

let $f015216d97548d49$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f015216d97548d49$var$load("tyd5V").then(()=>parcelRequire('8uqSG'));

});

parcelRegister("2tp0D", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $4OYR1 = parcelRequire("4OYR1");


var $jTNdj = parcelRequire("jTNdj");


var $o0RSX = parcelRequire("o0RSX");


var $k4HA2 = parcelRequire("k4HA2");


var $b4B1V = parcelRequire("b4B1V");


var $d4rpM = parcelRequire("d4rpM");


var $gKIF0 = parcelRequire("gKIF0");


var $bP5wt = parcelRequire("bP5wt");


var $44R0O = parcelRequire("44R0O");


var $jS1GQ = parcelRequire("jS1GQ");


var $1NVwf = parcelRequire("1NVwf");


var $8BCsI = parcelRequire("8BCsI");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $g7aP0 = parcelRequire("g7aP0");


var $1dHYE = parcelRequire("1dHYE");

const $210c900388def499$var$STABLE_EMPTY_OBJECT = {};
const $210c900388def499$export$7192d943ff7d5979 = 'post-office_enable_narrow-exposure-classic';
const $210c900388def499$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        ...props,
        children: children
    });
};
const $210c900388def499$export$7b7e5a348ef9a7c1 = (messageComponents, _placementId, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $cozmU.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, configSetId: configSetId, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), ...data })=>{
            const isUFOEnabled = (0, $cXtTj.default).checkGate('enable_ufo_tracking_in_post_office');
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $cozmU.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $4OYR1.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const isChunkLoadError = (error)=>{
                    return error?.name === 'ChunkLoadError';
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        if (!isChunkLoadError(error)) messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $cozmU.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $o0RSX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $o0RSX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
                        name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = (0, $jS1GQ.isClientTriggeredMessage)(triggerType);
                const isNarrowExposureClassicEnabled = (0, $cXtTj.default).checkGate($210c900388def499$export$7192d943ff7d5979);
                const narrowExposureConfig = isNarrowExposureClassicEnabled ? inAppNarrowExposureExperiment : undefined;
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $bP5wt.useWaitForTrigger)({
                    hasTrigger: hasTrigger,
                    messageSuccessComponent: messageSuccessComponent,
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    inAppNarrowExposureExperiment: narrowExposureConfig
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                const messageContextValue = (0, $cozmU.useMemo)(()=>({
                        messageInstanceId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        triggerId: triggerId,
                        messageCreationType: messageCreationType,
                        transactionAccountId: componentProps.transactionAccountId,
                        analyticsDetails: postOffice?.analyticsDetails,
                        journeyId: journeyId,
                        journeyTriggerId: journeyTriggerId,
                        configSetId: configSetId
                    }), [
                    componentProps.transactionAccountId,
                    messageCategory
                ]);
                if (inAppNarrowExposureExperiment && !isNarrowExposureClassicEnabled) return null;
                const message = /*#__PURE__*/ (0, $8aG6j.jsx)(SuspenseBoundary, {
                    fallback: loadingComponent,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gKIF0.MaybeTriggeredMessageValidator), {
                        waitForTrigger: waitForTrigger,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4B1V.MessageAnalyticsContextProvider), {
                            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $44R0O.MaybeManualMessageViewedEvent), {
                                isManual: !!waitForTrigger,
                                children: [
                                    !waitForTrigger && messageSuccessComponent,
                                    /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                                        onError: onError,
                                        messageInstanceId: messageInstanceId,
                                        ...componentProps,
                                        waitForTrigger: waitForTrigger,
                                        inAppNarrowExposureExperiment: narrowExposureConfig
                                    })
                                ]
                            })
                        })
                    })
                });
                const withMessageContext = (children)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
                        value: messageContextValue,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                            value: recommendationSession ?? $210c900388def499$var$STABLE_EMPTY_OBJECT,
                            children: children
                        })
                    });
                // MaybeChoreographerWrapper sits above the lazy chunk so it can claim its slot while
                // loading; it no-ops for client-triggered messages, which handle their own
                // choreography via MaybeTriggeredMessageValidator.
                const withChoreographer = (children)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dHYE.MaybeChoreographerWrapper), {
                        ChoreographerWrapper: (0, $g7aP0.ChoreographerWrapper),
                        enabled: !waitForTrigger,
                        messageId: messageInstanceId,
                        messageTemplateId: messageTemplateId,
                        messageCategory: messageCategory,
                        inAppNarrowExposureExperiment: narrowExposureConfig,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4rpM.FeatureFlaggedUfoWrapper), {
                            messageTemplateId: messageTemplateId,
                            isEnabled: isUFOEnabled,
                            children: children
                        })
                    });
                // A narrow exposure shouldClaim needs message and recommendation context above the
                // choreographer to post a dropped event for this message.
                return isNarrowExposureClassicEnabled ? withMessageContext(withChoreographer(message)) : withChoreographer(withMessageContext(message));
            };
            return (0, $8BCsI.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $210c900388def499$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $210c900388def499$export$7b7e5a348ef9a7c1;

});

parcelRegister("4OYR1", function(module, exports) {

var $jAbAo = parcelRequire("jAbAo");


var $8fXDz = parcelRequire("8fXDz");

const $baf07cb19e3d1dfe$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jAbAo.MessagePerformanceTracker,
    PlacementPerformanceTracker: $8fXDz.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $baf07cb19e3d1dfe$export$96236906ebaa7f87;

});

parcelRegister("jAbAo", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");


var $8UDja = parcelRequire("8UDja");

class $01005f2678a8118a$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $gZFfs.ExperienceTypes).Load,
            platform: {
                component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $01005f2678a8118a$export$ae5c73c7c4f454e6;

});

parcelRegister("8UDja", function(module, exports) {
const $21c39d458f004fb5$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $21c39d458f004fb5$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $21c39d458f004fb5$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $21c39d458f004fb5$export$6d482cfa20c9d220;

});

parcelRegister("8fXDz", function(module, exports) {

var $34VCg = parcelRequire("34VCg");


var $gZFfs = parcelRequire("gZFfs");


var $8UDja = parcelRequire("8UDja");

const $e2ea1aa57de97a70$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $gZFfs.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $gZFfs.ExperienceTypes).Load,
    platform: {
        component: (0, $8UDja.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $e2ea1aa57de97a70$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$e2ea1aa57de97a70$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $e2ea1aa57de97a70$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $34VCg.UFOExperience)((0, $8UDja.UFOExperienceNames).PLACEMENT, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $34VCg.UFOExperience)(`${(0, $8UDja.UFOExperienceNames).PLACEMENT}.${placementId}`, $e2ea1aa57de97a70$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $e2ea1aa57de97a70$export$8b48c2105ba0b35a;

});

parcelRegister("o0RSX", function(module, exports) {
//#region src/index.ts

var $ddnoW = parcelRequire("ddnoW");

let $0482ea6551d2dfec$export$b9722560029694e7 = /* @__PURE__ */ function(PostOfficeErrorCodes) {
    PostOfficeErrorCodes["MessageTemplatePlacementError"] = "MessageTemplatePlacementError";
    PostOfficeErrorCodes["NotAbleToProcessRecipientExpansionInputError"] = "NotAbleToProcessRecipientExpansionInputError";
    PostOfficeErrorCodes["NotAbleToProcessEmailTemplateError"] = "NotAbleToProcessEmailTemplateError";
    PostOfficeErrorCodes["RecipientExpansionManagerError"] = "RecipientExpansionManagerError";
    PostOfficeErrorCodes["RecipientExpansionProcessingError"] = "RecipientExpansionProcessingError";
    PostOfficeErrorCodes["RecipientExpansionMethodInvocationError"] = "RecipientExpansionMethodInvocationError";
    PostOfficeErrorCodes["MessageConsumptionFailure"] = "MessageConsumptionFailure";
    PostOfficeErrorCodes["ReceiverInputValidationError"] = "ReceiverInputValidationError";
    PostOfficeErrorCodes["InvalidMessageTemplateIdError"] = "InvalidMessageTemplateIdError";
    PostOfficeErrorCodes["MessageTemplateNotFoundError"] = "MessageTemplateNotFoundError";
    PostOfficeErrorCodes["ConfigSetNotFoundError"] = "ConfigSetNotFoundError";
    PostOfficeErrorCodes["JourneyNotFoundError"] = "JourneyNotFoundError";
    PostOfficeErrorCodes["MessageTemplateNotEnabledError"] = "MessageTemplateNotEnabledError";
    PostOfficeErrorCodes["MessageTemplateActionValidationError"] = "MessageTemplateActionValidationError";
    PostOfficeErrorCodes["MessageTemplateActionHandlerTimeoutError"] = "MessageTemplateActionHandlerTimeoutError";
    PostOfficeErrorCodes["MessageRendererEmptyValidationResponseError"] = "MessageRendererEmptyValidationResponseError";
    PostOfficeErrorCodes["IngestionHandlerFailedSendError"] = "IngestionHandlerFailedSendError";
    PostOfficeErrorCodes["OrchestrationHandlerFailedSendError"] = "OrchestrationHandlerFailedSendError";
    PostOfficeErrorCodes["DigestEngineFailedSendError"] = "DigestEngineFailedSendError";
    PostOfficeErrorCodes["UnableToGetUserDetailsError"] = "UnableToGetUserDetailsError";
    PostOfficeErrorCodes["GatewayTimeoutError"] = "GatewayTimeoutError";
    PostOfficeErrorCodes["InvalidPayloadError"] = "InvalidPayloadError";
    PostOfficeErrorCodes["UnsupportedAttachmentTypeError"] = "UnsupportedAttachmentType";
    PostOfficeErrorCodes["InvalidEmailRequestHeader"] = "InvalidEmailRequestHeader";
    PostOfficeErrorCodes["NonProdEmailDomainError"] = "NonProdEmailDomainError";
    PostOfficeErrorCodes["UnsupportedMessageAtPlacementError"] = "UnsupportedMessageAtPlacementError";
    PostOfficeErrorCodes["HydrationFailureAtPlacementError"] = "HydrationFailureAtPlacementError";
    PostOfficeErrorCodes["AllMessagesFailureHydrationAtPlacementError"] = "AllMessagesFailureHydrationAtPlacementError";
    PostOfficeErrorCodes["UnusedValidateError"] = "UnusedValidateError";
    PostOfficeErrorCodes["RecipientExpanderMapRetrievalError"] = "RecipientExpanderMapRetrievalError";
    PostOfficeErrorCodes["GrowthRecRecommendationsError"] = "GrowthRecRecommendationsError";
    PostOfficeErrorCodes["PlacementNotFoundError"] = "PlacementNotFoundError";
    PostOfficeErrorCodes["UnexpectedMobileNotificationsError"] = "UnexpectedMobileNotificationsError";
    PostOfficeErrorCodes["MobilePushPlacementError"] = "MobilePushPlacementError";
    PostOfficeErrorCodes["MissingIngestionSourceError"] = "MissingIngestionSourceError";
    PostOfficeErrorCodes["RenderRedactedNotFoundError"] = "RenderRedactedNotFoundError";
    PostOfficeErrorCodes["UnexpectedAtlassianMailError"] = "UnexpectedAtlassianMailError";
    PostOfficeErrorCodes["RetryableAtlassianMailError"] = "RetryableAtlassianMailError";
    PostOfficeErrorCodes["RetryableMobileNotificationsError"] = "RetryableMobileNotificationsError";
    PostOfficeErrorCodes["RecipientExpanderError"] = "RecipientExpanderError";
    PostOfficeErrorCodes["RetryableTCSError"] = "RetryableTCSError";
    PostOfficeErrorCodes["MessageEventServiceError"] = "MessageEventServiceError";
    PostOfficeErrorCodes["HydrationDeliveryNoDataFoundError"] = "HydrationDeliveryNoDataFoundError";
    PostOfficeErrorCodes["PlacementMessageError"] = "PlacementMessageError";
    PostOfficeErrorCodes["PlacementError"] = "PlacementError";
    PostOfficeErrorCodes["PlacementSystemError"] = "PlacementSystemError";
    PostOfficeErrorCodes["PlacementRuntimeError"] = "PlacementRuntimeError";
    PostOfficeErrorCodes["PlacementMiddlewareError"] = "PlacementMiddlewareError";
    PostOfficeErrorCodes["SendOutNotFoundError"] = "SendOutNotFoundError";
    PostOfficeErrorCodes["SendOutUpdateForbiddenError"] = "SendOutUpdateForbiddenError";
    PostOfficeErrorCodes["SendOutUserStatusTransitionForbiddenError"] = "SendOutUserStatusTransitionForbiddenError";
    PostOfficeErrorCodes["SendOutValidationError"] = "SendOutValidationError";
    PostOfficeErrorCodes["SendOutFailedToInitiateApprovalRequest"] = "SendOutFailedToInitiateApprovalRequest";
    PostOfficeErrorCodes["MessageTemplateError"] = "MessageTemplateError";
    PostOfficeErrorCodes["MessageTemplatePackageMalformedError"] = "MessageTemplatePackageMalformedError";
    PostOfficeErrorCodes["EmptyMessageTemplateRegistryError"] = "EmptyMessageTemplateRegistryError";
    PostOfficeErrorCodes["PostOfficeGraphQLError"] = "PostOfficeGraphQLError";
    PostOfficeErrorCodes["NotificationRollupConflictError"] = "NotificationRollupConflictError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingDisabledError"] = "TesseractTemplateRuntimeMappingDisabledError";
    PostOfficeErrorCodes["TesseractTemplateRuntimeMappingValidationError"] = "TesseractTemplateRuntimeMappingValidationError";
    return PostOfficeErrorCodes;
}({});
var $0482ea6551d2dfec$export$46f86d28cd0a5d38 = class extends Error {
};
var $0482ea6551d2dfec$export$627bc00a5ef5f6ae = class extends Error {
};
/**
* @deprecated Do not use this pattern. Throwing errors from `hydrate()` to control message
* visibility is an anti-pattern that conflates hydration with filtering.
*
* **Why this is wrong:**
* Filtering decisions (e.g. experiment cohort checks, feature flag gates) belong in the
* filtering/eligibility stage, not inside `hydrate()`. Using errors as control flow here
* risks spreading a pattern that is difficult to reason about, harms observability, and
* fires experiment exposures at the wrong layer.
*
* **What to do instead:**
* - Use **message template filters** to gate visibility based on experiment or feature flag state.
* - For experiment exposure specifically, fire exposures on the Placement Frontend
*   (Narrow-Level Triggering) as described in the official guidance:
*   https://hello.atlassian.net/wiki/spaces/POSTOFFICE/pages/5372727565/Where+to+fire+exposure+for+experiments+in+Post+Office
* - The long-term platform solution for narrow exposure is tracked in POST-773.
*
* This class will be removed once all existing usages have been migrated.
*/ var $0482ea6551d2dfec$export$66e065cfeb491a4d = class HydrationAbortError extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    static is(value) {
        return value instanceof HydrationAbortError;
    }
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d145ea5319863172 = class extends Error {
    constructor(message, code, cause){
        super(message, {
            cause: cause
        }), (0, $ddnoW._)(this, "code", void 0);
        this.code = code;
    }
};
var $0482ea6551d2dfec$export$69be53c018c89481 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, details){
        super(message, "PostOfficeGraphQLError"), (0, $ddnoW._)(this, "clientName", void 0), (0, $ddnoW._)(this, "operationName", void 0), (0, $ddnoW._)(this, "status", void 0), (0, $ddnoW._)(this, "graphQLErrorMessage", void 0), (0, $ddnoW._)(this, "errors", void 0), (0, $ddnoW._)(this, "sanitisedRequestHeaders", void 0), (0, $ddnoW._)(this, "sanitisedResponseHeaders", void 0), (0, $ddnoW._)(this, "responseBody", void 0);
        this.name = this.constructor.name;
        this.clientName = details.clientName;
        this.operationName = details.operationName;
        this.status = details.status;
        this.graphQLErrorMessage = details.graphQLErrorMessage;
        this.errors = details.errors;
        this.sanitisedRequestHeaders = details.sanitisedRequestHeaders;
        this.sanitisedResponseHeaders = details.sanitisedResponseHeaders;
        this.responseBody = details.responseBody;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6452976adc01572 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(cause, code){
        super($0482ea6551d2dfec$var$getErrorMessage(cause), code, cause);
        this.name = this.constructor.name;
    }
};
const $0482ea6551d2dfec$var$getErrorMessage = (cause)=>{
    if (cause instanceof Error) return cause.message;
    if (typeof cause === "string") return cause;
    return "Unknown error";
};
function $0482ea6551d2dfec$export$4cb1ea6034a33155(error) {
    return typeof error === "object" && !!error && "status" in error && typeof error.status === "number";
}
function $0482ea6551d2dfec$export$aed524b0009b5631(error) {
    return typeof error === "object" && !!error && "logLevel" in error && typeof error.logLevel === "string";
}
var $0482ea6551d2dfec$export$ed601cd0dc1a1be7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(args){
        /**
		* It is expected that this error message can be not deterministic.
		* This error message can be displayed in the "Failures" and "Preview It" tabs for message makers.
		* Showing the error cause helps them understand what was the problem with their payload.
		*
		* On Post Office (platform) side, we use "instanceof MessageTemplateError" check
		* to distinguish between message makers code errors and platform errors,
		* but we don't rely on the error message itself.
		*/ const errMessage = args.cause instanceof Error ? args.cause.message : "Error in message template code";
        super(errMessage, "MessageTemplateError", args.cause), (0, $ddnoW._)(this, "function", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "triggerId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = args.messageTemplateId;
        this.triggerId = args.triggerId;
        this.function = args.function;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2833d4759f81601b = class extends $0482ea6551d2dfec$export$ed601cd0dc1a1be7 {
    constructor(args){
        super(args);
        this.message = "Invalid CSS property could not be processed by Juice";
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8d39b103586e9fd4 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, cause){
        super(message, "NotAbleToProcessEmailTemplateError", cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$f649da38897d27f7 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2852c1c4d9aba3e = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionProcessingError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4b7b4e09547e4bb3 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "RecipientExpansionMethodInvocationError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$360a094a97597d87 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "RecipientExpansionManagerError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$4d068b43eb55165b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, input){
        super(message, "NotAbleToProcessRecipientExpansionInputError"), (0, $ddnoW._)(this, "input", void 0);
        this.input = input;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ac007ee150add337 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "ReceiverInputValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$19cb89dd679394cb = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "InvalidMessageTemplateIdError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$78651662ad470cc5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template not found", "MessageTemplateNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$43b3b4535703ed1b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            configSetId: this.configSetId
        };
    }
    constructor(configSetId){
        super(`Config Set with ConfigSetId ${configSetId} could not be found`, "ConfigSetNotFoundError"), (0, $ddnoW._)(this, "configSetId", void 0);
        this.configSetId = configSetId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8a5041670cdd8db2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(journeyId){
        super("Journey not found", "JourneyNotFoundError"), (0, $ddnoW._)(this, "journeyId", void 0);
        this.journeyId = journeyId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1240ddc25cf964e6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Template action handler validation error", "MessageTemplateActionValidationError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3c4884b7ae7fe517 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(timeoutInSeconds = 5){
        super(`Message Template action handler timed out after ${timeoutInSeconds} seconds`, "MessageTemplateActionHandlerTimeoutError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$913b8e68dc7ae8fe = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Placement not found", "PlacementNotFoundError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3dfc27a8d3942f4d = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message Renderer received empty response from validator", "MessageRendererEmptyValidationResponseError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e5ccdf8bbfead7a2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "IngestionHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$823733742d803ae6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Failed to send some events", "OrchestrationHandlerFailedSendError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$1caa32527f23acd2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(errorCause){
        super("Failed to send digest event to orchestration queue", "DigestEngineFailedSendError"), (0, $ddnoW._)(this, "errorCause", void 0);
        this.name = this.constructor.name;
        this.errorCause = errorCause;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$a6f2aad8fa094b39 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Unable to get user details for the given account ID", "UnableToGetUserDetailsError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2296e5dc6a1bf3d2 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(accountId, customErrorMessage){
        super(customErrorMessage ?? "Gateway timeout occurred", "GatewayTimeoutError"), (0, $ddnoW._)(this, "accountId", void 0);
        this.accountId = accountId;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2f1e27130c2bf271 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, payloadSize){
        super(message, "InvalidPayloadError"), (0, $ddnoW._)(this, "payloadSize", void 0);
        this.name = this.constructor.name;
        this.payloadSize = payloadSize;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$d0dc094613469f2b = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message, workspaceId){
        super(message), (0, $ddnoW._)(this, "workspaceId", void 0);
        this.name = this.constructor.name;
        this.workspaceId = workspaceId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5603eab37ce562f5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(fileType){
        super("The attachment file is not supported", "UnsupportedAttachmentType"), (0, $ddnoW._)(this, "fileType", void 0);
        this.name = this.constructor.name;
        this.fileType = fileType;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$e0e9aa0e9c6b37ff = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, error){
        super(message, "InvalidEmailRequestHeader"), (0, $ddnoW._)(this, "error", void 0);
        this.name = this.constructor.name;
        this.error = error;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$3ad818f64601e141 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message){
        super(message, "NonProdEmailDomainError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$25470bb6cba4fba0 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ messageTemplateId: messageTemplateId, placementId: placementId }){
        super("messageTemplateId not supported by placement", "UnsupportedMessageAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$ce14d445679448b6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(error, { messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, placementId: placementId }){
        super(error?.message ?? "unknown error", "HydrationFailureAtPlacementError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.messageTemplateId = messageTemplateId;
        this.messageInstanceId = messageInstanceId;
        this.placementId = placementId;
        this.stack = error?.stack;
    }
};
var $0482ea6551d2dfec$export$c9a26a17db1045c8 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ placementId: placementId }){
        super("All messages failed at placement", "AllMessagesFailureHydrationAtPlacementError"), (0, $ddnoW._)(this, "placementId", void 0);
        this.name = this.constructor.name;
        this.placementId = placementId;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$8ab4fb362168b928 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Unexpected invocation of validate() function for push delivery channel", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2afd69f57fe5285f = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Recipient expander not found for mapper", "UnusedValidateError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$7635d2b1a281d626 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, errors){
        super(message, "GrowthRecRecommendationsError"), (0, $ddnoW._)(this, "errors", void 0);
        this.errors = errors;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$90bef7fa95eca3fa = class extends Error {
    constructor(status){
        super("Posting Mobile Notifications message failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$6d1a4929f6ff1a32 = class extends $0482ea6551d2dfec$export$46f86d28cd0a5d38 {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c19fc5e8aa4e064d = class extends Error {
    constructor(){
        super("Ingestion source is required when custom profile is specified");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$2d3a68dab93b8cc4 = class extends Error {
    constructor(){
        super("A renderRedacted function is required when redactionLevel is set to a non-null value");
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$175c1dbb0d7c238a = class extends Error {
    constructor(status){
        super("Enqueueing email failed"), (0, $ddnoW._)(this, "status", void 0);
        this.status = status;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$23fab744b3076342 = class extends Error {
    constructor(message, status){
        super(message), (0, $ddnoW._)(this, "message", void 0), (0, $ddnoW._)(this, "status", void 0);
        this.message = message;
        this.status = status;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$194adecfa0265ea1 = class extends Error {
    constructor(msg, messageInstanceId, error){
        super(msg), (0, $ddnoW._)(this, "msg", void 0), (0, $ddnoW._)(this, "messageInstanceId", void 0);
        this.msg = msg;
        this.messageInstanceId = messageInstanceId;
        if (error instanceof Error) this.stack = error.stack;
        else Error.captureStackTrace(this, this.constructor);
        this.name = this.constructor.name;
    }
};
var $0482ea6551d2dfec$export$c504492f06c975b5 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor({ ipmNumber: ipmNumber, variantFromStatsig: variantFromStatsig, contentfulLocale: contentfulLocale }){
        super("hydrate delivery marketing-screen-space-flag-contentful-usecase No data found for the user", "HydrationDeliveryNoDataFoundError"), (0, $ddnoW._)(this, "ipmNumber", void 0), (0, $ddnoW._)(this, "variantFromStatsig", void 0), (0, $ddnoW._)(this, "contentfulLocale", void 0);
        this.name = this.constructor.name;
        this.ipmNumber = ipmNumber;
        this.variantFromStatsig = variantFromStatsig;
        this.contentfulLocale = contentfulLocale;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Error thrown when an upstream service (e.g., Atlassian Mail, Mobile Notifications, TCS)
* returns a retryable error status code (e.g. 500, 502, 503, 504).
*
* An SQS message that encounters this error will be retried.
*
* Only the final retry will be counted against our reliability SLOs and canary analysis.
*/ var $0482ea6551d2dfec$export$1c932b9d1680ee0b = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(message, code, cause){
        super(message, code, cause);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$5d5d1885c87ef4bc = class extends Error {
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Wraps an error thrown while running a recipient expander. Carries the expander key and message
* template id so they can be surfaced in logs and used to emit the recipient expander SLO metric.
*
* Co-located here with {@link UnretryableError} so a dedicated serializer can live in
* `@post-office/error-serializers` (the expander-specific fields are otherwise dropped by the
* generic error serializer).
*/ var $0482ea6551d2dfec$export$85497ede72633b85 = class extends $0482ea6551d2dfec$export$1c932b9d1680ee0b {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Recipient Expander Error: ${message}`, "RecipientExpanderError", error), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Unretryable variant of {@link RecipientExpanderError}, thrown when an expander fails with a
* non-retryable error. The originating error is preserved as the `cause`.
*/ var $0482ea6551d2dfec$export$359a331da49d1ec8 = class extends $0482ea6551d2dfec$export$5d5d1885c87ef4bc {
    constructor(error, { expanderKey: expanderKey, messageTemplateId: messageTemplateId }){
        const message = error instanceof Error ? error.message : String(error);
        super(`Unretryable Recipient Expander Error: ${message}`, {
            cause: error
        }), (0, $ddnoW._)(this, "expanderKey", void 0), (0, $ddnoW._)(this, "messageTemplateId", void 0);
        this.name = this.constructor.name;
        this.expanderKey = expanderKey;
        this.messageTemplateId = messageTemplateId;
    }
};
/**
* Thrown when a message template package loads but is missing one or more exports that every
* template is required to have. In production the bundler intermittently produces module
* namespaces with re-exported bindings missing, which is decided once per process and then
* permanent. Detection uses a sentinel export rather than an exhaustive check, so `missingFields`
* reports what was inspected, not every binding the bundler actually dropped.
*
* Callers must treat this as a platform failure and let the message retry onto a healthy process;
* never as "the template has no subscriptions/config", which silently discards traffic.
*/ var $0482ea6551d2dfec$export$8506e646874f88f6 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    get nonSensitiveFields() {
        return {
            missingFields: this.missingFields.join(",")
        };
    }
    constructor(messageTemplateId, missingFields){
        super("Message template package loaded without required exports", "MessageTemplatePackageMalformedError"), (0, $ddnoW._)(this, "messageTemplateId", void 0), (0, $ddnoW._)(this, "missingFields", void 0);
        this.messageTemplateId = messageTemplateId;
        this.missingFields = missingFields;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
/**
* Thrown when the message template registry reports zero templates. There is no legitimate state in
* which Post Office has no templates, so callers must retry rather than read it as "nobody is
* subscribed"; the latter acks the message and discards it permanently.
*/ var $0482ea6551d2dfec$export$6a4077faeb1c609 = class extends $0482ea6551d2dfec$export$d145ea5319863172 {
    constructor(){
        super("Message template registry returned no templates", "EmptyMessageTemplateRegistryError");
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
var $0482ea6551d2dfec$export$c2cfe2317dcfcabb = class extends Error {
    get nonSensitiveFields() {
        return {
            deliveryChannel: this.deliveryChannel
        };
    }
    constructor(deliveryChannel){
        super("Duplicate message detected"), (0, $ddnoW._)(this, "deliveryChannel", void 0);
        this.deliveryChannel = deliveryChannel;
        this.name = this.constructor.name;
        Error.captureStackTrace(this, this.constructor);
    }
};
const $0482ea6551d2dfec$export$fec3468114498229 = (value)=>typeof value === "object" && value !== null && Object.values(value).every((field)=>field === void 0 || field === null || typeof field === "string" || typeof field === "number" || typeof field === "boolean");
 //# sourceMappingURL=index.mjs.map
module.exports["InvalidMessageTemplateIdError"] = $0482ea6551d2dfec$export$19cb89dd679394cb;
module.exports["MessageRendererEmptyValidationResponseError"] = $0482ea6551d2dfec$export$3dfc27a8d3942f4d;

});

parcelRegister("b4B1V", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");

const $38aadf7fa80db7e7$var$defaultMessageAnalyticsContextValue = {
    fireMessageViewedInMessageComponent: null,
    setFireMessageViewedInMessageComponent: ()=>{}
};
const $38aadf7fa80db7e7$export$c81717973c6c4a90 = /*#__PURE__*/ (0, $cozmU.createContext)($38aadf7fa80db7e7$var$defaultMessageAnalyticsContextValue);
const $38aadf7fa80db7e7$export$1737ab199e83455e = ({ children: children })=>{
    const fireMessageViewedInMessageComponent = (0, $cozmU.useRef)(false);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent,
            setFireMessageViewedInMessageComponent: (value)=>{
                fireMessageViewedInMessageComponent.current = value;
            }
        }), [
        fireMessageViewedInMessageComponent
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($38aadf7fa80db7e7$export$c81717973c6c4a90.Provider, {
        value: contextValue,
        children: children
    });
};
const $38aadf7fa80db7e7$export$bb426ba114b64992 = ()=>(0, $cozmU.useContext)($38aadf7fa80db7e7$export$c81717973c6c4a90);
module.exports["MessageAnalyticsContextProvider"] = $38aadf7fa80db7e7$export$1737ab199e83455e;
module.exports["useMessageAnalyticsContext"] = $38aadf7fa80db7e7$export$bb426ba114b64992;

});

parcelRegister("d4rpM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $jTNdj = parcelRequire("jTNdj");

const $2edd5268d1298569$export$8e6fb7035018b3e4 = ({ isEnabled: isEnabled, messageTemplateId: messageTemplateId, children: children })=>{
    if (isEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
        name: (0, $jTNdj.UFOv2).SegmentNames.MESSAGE,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOSegment, {
            name: `${(0, $jTNdj.UFOv2).SegmentNames.MESSAGE}.${messageTemplateId}`,
            children: children
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["FeatureFlaggedUfoWrapper"] = $2edd5268d1298569$export$8e6fb7035018b3e4;

});

parcelRegister("gKIF0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $k50GG = parcelRequire("k50GG");

const $721b9c50d6cef8f5$export$dac988aa97dc7b79 = ({ children: children, waitForTrigger: waitForTrigger })=>{
    if (!waitForTrigger) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $k50GG.TriggeredMessageValidator), {
        waitForTrigger: waitForTrigger,
        children: children
    });
};
module.exports["MaybeTriggeredMessageValidator"] = $721b9c50d6cef8f5$export$dac988aa97dc7b79;

});

parcelRegister("k50GG", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4mjUI = parcelRequire("4mjUI");

/** Hide content until validated; avoids flash without off-screen positioning or scrollbar issues. */ const $7edc18d494c18e25$var$HIDDEN_CONTAINER_STYLE = {
    display: 'none'
};
const $7edc18d494c18e25$export$c8b5f992b8a1b38b = ({ children: children, waitForTrigger: waitForTrigger })=>{
    const [validated, setValidated] = (0, $cozmU.useState)('pending');
    (0, $4mjUI.useLayoutEffect)(()=>{
        const calledRef = waitForTrigger?.__calledRef;
        if (calledRef?.current) {
            setValidated('allowed');
            return;
        }
        // Ref not set after template had a chance to run.
        if (calledRef) setValidated('blocked');
    }, [
        waitForTrigger,
        children
    ]);
    if (validated === 'blocked') return null;
    const isHidden = validated === 'pending';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        style: isHidden ? $7edc18d494c18e25$var$HIDDEN_CONTAINER_STYLE : undefined,
        "aria-hidden": isHidden,
        "data-testid": isHidden ? 'triggered-message-validator-hidden' : undefined,
        children: children
    });
};
module.exports["TriggeredMessageValidator"] = $7edc18d494c18e25$export$c8b5f992b8a1b38b;

});

parcelRegister("4mjUI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * `useLayoutEffect` warns during SSR ("Warning: useLayoutEffect does nothing on the server").
 * Fall back to `useEffect` on the server so utilities in this package are safe to render in SSR
 * contexts. In the browser the synchronous commit-time semantics of `useLayoutEffect` are preserved.
 *
 * Consumers import this as `useLayoutEffect` so the call site reads identically to React's hook.
 *
 * See: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a
 */ const $c7f27652ce5a6cdc$export$e5c5a5f917a5871c = typeof window !== 'undefined' ? (0, $cozmU.useLayoutEffect) : (0, $cozmU.useEffect);
module.exports["useLayoutEffect"] = $c7f27652ce5a6cdc$export$e5c5a5f917a5871c;

});

parcelRegister("bP5wt", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $wnnKE = parcelRequire("wnnKE");


var $8hKSa = parcelRequire("8hKSa");


var $7NHN3 = parcelRequire("7NHN3");

/**
 * Component that calls messageInstanceViewed, renders messageSuccessComponent, and calls onShow callback once when mounted
 */ const $5ae52cbfb074d546$var$OnChoreographerApproved = ({ children: children, onShow: onShow, messageSuccessComponent: messageSuccessComponent, displayTracking: displayTracking, additionalMetadataFromFrontend: additionalMetadataFromFrontend = {} })=>{
    const hasShownRef = (0, $cozmU.useRef)(false);
    const { messageInstanceViewed: messageInstanceViewed } = (0, $7NHN3.useMessageInstanceEvent)();
    (0, $cozmU.useEffect)(()=>{
        if (hasShownRef.current) return;
        hasShownRef.current = true;
        if (displayTracking !== 'host') messageInstanceViewed(additionalMetadataFromFrontend);
        onShow?.();
    // Intentional empty deps: this effect must fire exactly once after the first commit.
    // The values captured here are the ones the caller passed at mount, which is the desired
    // "as of when the message was shown" semantic — if a caller subsequently passes a new
    // onShow or metadata, we should NOT fire again. Using non-empty deps would also cause
    // this effect to re-register on every render whenever a caller passes an unmemoized
    // `additionalMetadataFromFrontend={{ ... }}` literal, even though the body is a no-op
    // after first run. Strict-Mode double-invocation is still handled by hasShownRef.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            messageSuccessComponent,
            children
        ]
    });
};
const $5ae52cbfb074d546$export$b5884e72fa051e28 = ({ hasTrigger: hasTrigger, messageSuccessComponent: messageSuccessComponent, messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, displayTracking: displayTracking })=>{
    const waitForTriggerCalledRef = (0, $cozmU.useRef)(false);
    // Create waitForTrigger function that wraps content with choreography
    const waitForTriggerCallback = (0, $cozmU.useCallback)(({ isTriggerActive: isTriggerActive, messageContent: messageContent, onMessageShown: onMessageShown, additionalMetadataFromFrontend: additionalMetadataFromFrontend, onTeardown: onTeardown })=>{
        // Mark that this function was called
        waitForTriggerCalledRef.current = true;
        // If isTriggerActive is false, don't claim choreographer slot yet
        if (!isTriggerActive) return null;
        const messageContentWithOptionalTeardown = onTeardown !== undefined ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8hKSa.UnmountCleanup), {
            onCleanup: onTeardown,
            children: messageContent
        }) : messageContent;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $wnnKE.ChoreographerWrapper), {
            messageId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory,
            inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($5ae52cbfb074d546$var$OnChoreographerApproved, {
                displayTracking: displayTracking,
                onShow: onMessageShown,
                additionalMetadataFromFrontend: additionalMetadataFromFrontend,
                messageSuccessComponent: messageSuccessComponent,
                children: messageContentWithOptionalTeardown
            })
        });
    }, [
        messageInstanceId,
        messageTemplateId,
        messageCategory,
        messageSuccessComponent,
        inAppNarrowExposureExperiment,
        displayTracking
    ]);
    const waitForTrigger = hasTrigger ? waitForTriggerCallback : undefined; // Non-triggered messages don't get this prop
    // Attach the ref to the function as a property
    if (waitForTrigger) waitForTrigger.__calledRef = waitForTriggerCalledRef;
    return {
        waitForTrigger: waitForTrigger
    };
};
module.exports["useWaitForTrigger"] = $5ae52cbfb074d546$export$b5884e72fa051e28;

});

parcelRegister("wnnKE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $5ydwr = parcelRequire("5ydwr");


var $9TNXZ = parcelRequire("9TNXZ");


var $cozmU = parcelRequire("cozmU");


var $6NRmI = parcelRequire("6NRmI");

const $4a16561cf48266ce$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldClaim = (0, $5ydwr.useNarrowExposureShouldClaim)(inAppNarrowExposureExperiment);
    const shouldRender = useChoreographedRender({
        messageId: messageId,
        shouldClaim: shouldClaim
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $4a16561cf48266ce$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($4a16561cf48266ce$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $4a16561cf48266ce$export$8db7ba034addcd65;

});

parcelRegister("8hKSa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $4mjUI = parcelRequire("4mjUI");

const $522a2bdcd9585e84$export$ea970fe2c565070a = ({ onCleanup: onCleanup, children: children })=>{
    const onCleanupRef = (0, $cozmU.useRef)(onCleanup);
    (0, $4mjUI.useLayoutEffect)(()=>{
        onCleanupRef.current = onCleanup;
    });
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            onCleanupRef.current?.();
        };
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["UnmountCleanup"] = $522a2bdcd9585e84$export$ea970fe2c565070a;

});

parcelRegister("7NHN3", function(module, exports) {

var $kEPax = parcelRequire("kEPax");

const $b15c706fb306d92c$export$39b0f5626e96f41e = (0, $kEPax.useMessageInstanceEvent);
module.exports["useMessageInstanceEvent"] = $b15c706fb306d92c$export$39b0f5626e96f41e;

});

parcelRegister("44R0O", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $j5DVd = parcelRequire("j5DVd");

const $18ac7c17ff477189$export$9915b88f81e90e6e = ({ isManual: isManual, children: children })=>{
    return isManual ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j5DVd.ManualMessageViewedEvent), {
        children: children
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["MaybeManualMessageViewedEvent"] = $18ac7c17ff477189$export$9915b88f81e90e6e;

});

parcelRegister("j5DVd", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $7NHN3 = parcelRequire("7NHN3");


var $baFbJ = parcelRequire("baFbJ");


var $cozmU = parcelRequire("cozmU");


var $lixOz = parcelRequire("lixOz");


var $b4B1V = parcelRequire("b4B1V");


var $1NVwf = parcelRequire("1NVwf");

const $08ec3000a15d9da6$export$de534803cb07dfcc = ({ children: children })=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent, setFireMessageViewedInMessageComponent: setFireMessageViewedInMessageComponent } = (0, $b4B1V.useMessageAnalyticsContext)();
    if (fireMessageViewedInMessageComponent) setFireMessageViewedInMessageComponent(true);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
const $08ec3000a15d9da6$export$14fe1fc3395b6e3f = ()=>{
    const { fireMessageViewedInMessageComponent: fireMessageViewedInMessageComponent } = (0, $b4B1V.useMessageAnalyticsContext)();
    const { messageViewed: messageViewed } = (0, $baFbJ.useMessageEvent)();
    const { messageInstanceViewed: messageInstanceViewed, messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    // messageViewed returns a promise of void, which is incompatible with the TrackMount onMount prop
    const messageViewedVoidFunction = (0, $cozmU.useCallback)(()=>{
        // Only fire the message viewed event if the message viewed event is not fired in the message component.
        if (fireMessageViewedInMessageComponent && !fireMessageViewedInMessageComponent.current) {
            messageViewed();
            messageInstanceViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1NVwf.TrackMount), {
        onMount: messageViewedVoidFunction
    });
};
const $08ec3000a15d9da6$export$4c73c6f545b966b7 = ({ children: children })=>{
    const messageRef = (0, $cozmU.useRef)(null);
    const { messageInstanceDeliveredSuccessfully: messageInstanceDeliveredSuccessfully } = (0, $7NHN3.useMessageInstanceEvent)();
    const { inViewport: inViewport, enterCount: enterCount } = (0, $lixOz.useInViewport)(messageRef, {});
    const hasDeliveredSuccessfullyBeenFired = (0, $cozmU.useRef)(false);
    // Only fire the delivery successful event once.
    (0, $cozmU.useEffect)(()=>{
        if (!hasDeliveredSuccessfullyBeenFired.current) {
            hasDeliveredSuccessfullyBeenFired.current = true;
            messageInstanceDeliveredSuccessfully();
        }
    }, [
        messageInstanceDeliveredSuccessfully
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("section", {
        ref: messageRef,
        children: [
            inViewport && enterCount >= 1 ? /*#__PURE__*/ (0, $8aG6j.jsx)($08ec3000a15d9da6$export$14fe1fc3395b6e3f, {}) : null,
            children
        ]
    });
};
module.exports["ManualMessageViewedEvent"] = $08ec3000a15d9da6$export$de534803cb07dfcc;
module.exports["MessageViewed"] = $08ec3000a15d9da6$export$14fe1fc3395b6e3f;

});

parcelRegister("baFbJ", function(module, exports) {

var $di43e = parcelRequire("di43e");


var $bGVJw = parcelRequire("bGVJw");


var $k4HA2 = parcelRequire("k4HA2");


var $4cICV = parcelRequire("4cICV");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $5Rfgj = parcelRequire("5Rfgj");

parcelRequire("aByw7");
var $dEG1b = parcelRequire("dEG1b");


var $lOnm2 = parcelRequire("lOnm2");

const $858a4870c67919f0$export$3cbbf1e81e2ecb39 = ()=>{
    if (!globalThis.window.postOfficeMessageEventClient) globalThis.window.postOfficeMessageEventClient = new (0, $dEG1b.MessageEventClient)();
    const client = globalThis.window.postOfficeMessageEventClient;
    const { dismissMessageFromPlacement: dismissMessageFromPlacement, markReadFromPlacement: markReadFromPlacement, markClickedFromPlacement: markClickedFromPlacement, markViewedFromPlacement: markViewedFromPlacement, snoozeMessageFromPlacement: snoozeMessageFromPlacement } = (0, $di43e.useMessagePlacementHooks)();
    const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, transactionAccountId: transactionAccountId, analyticsDetails: analyticsDetails } = (0, $k4HA2.useMessageContext)();
    const { placementId: placementId } = (0, $4cICV.usePlacementContext)();
    const browserContext = (0, $bGVJw.usePostOfficeContext)();
    const recommendationContext = (0, $82Ab4.useRecommendationContext)();
    const context = {
        browser: browserContext,
        recommendation: recommendationContext
    };
    /**
	 * Marks all messages as read. Calls markAllAsReadEvent() as the API call
	 */ const markAllAsRead = (0, $cozmU.useCallback)(async (messages)=>{
        const messagesEventPostPayload = messages.map((message)=>{
            const { messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId } = message;
            if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
            return {
                messageInstanceId: message['messageInstanceId'],
                messageTemplateId: message['messageTemplateId'],
                type: (0, $lOnm2.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            };
        });
        try {
            await client.markAllAsReadEvent(messagesEventPostPayload);
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        client,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as read. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageRead = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markReadFromPlacement({
            messageInstanceId: messageInstanceId
        });
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $lOnm2.InAppMessageEventType).Read,
                placement: placementId,
                createdAt: Date.now(),
                analyticsDetails: analyticsDetails,
                context: context
            });
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        markReadFromPlacement
    ]);
    /**
	 * Marks a message as unread. Calls sendEvent() as the API call
	 * has to happen immediately.
	 */ const messageUnread = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        try {
            await client.sendEvent({
                messageInstanceId: messageInstanceId,
                messageTemplateId: messageTemplateId,
                type: (0, $lOnm2.InAppMessageEventType).Unread,
                placement: placementId,
                createdAt: Date.now(),
                context: context,
                analyticsDetails: analyticsDetails
            });
        } catch (error) {
            throw new (0, $5Rfgj.MessageLifecycleClientError)();
        }
    }, [
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context
    ]);
    /**
	 * Marks a message as viewed. This event is fired automatically and should not need to be fired manually in the message component.
	 */ const messageViewed = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markViewedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Viewed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markViewedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageClicked = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        markClickedFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Clicked,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        markClickedFromPlacement
    ]);
    /**
	 * Marks a message as clicked.
	 * This event is used as a positive reward to train the Post Office Defacto Bandit ML Model.
	 * Lower value than messageClicked (use for options like: "Learn More"), not to be used as a dismiss
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 */ const messageClickedSecondary = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).ClickedSecondary,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as acknowledged
	 */ const messageAcknowledged = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Acknowledged,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId
    ]);
    /**
	 * Marks a message as dismissed.
	 * This event is used as a negative reward to train the Post Office Defacto Bandit ML Model.
	 * Message Creators should use this event if you want to enable ML reranking for your placement.
	 *
	 * @deprecated use messageInstanceClicked from useMessageInstanceEvent instead
	 */ const messageDismissed = (0, $cozmU.useCallback)(async ()=>{
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        dismissMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Dismissed,
            placement: placementId,
            createdAt: Date.now(),
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        dismissMessageFromPlacement
    ]);
    /**
	 * Marks a message as snoozed.
	 * This event is not used to train the Post Office Defacto Bandit ML Model.
	 */ const messageSnoozed = (0, $cozmU.useCallback)(async (snoozeDays)=>{
        const MILLIS_IN_A_DAY = 86400000;
        if (!messageInstanceId || !messageTemplateId || !placementId) throw new (0, $5Rfgj.MessageLifecycleContextError)();
        snoozeMessageFromPlacement({
            messageInstanceId: messageInstanceId
        });
        const statusExpiryTime = Date.now() + snoozeDays * MILLIS_IN_A_DAY;
        client.batchSendEvent({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            transactionAccountId: transactionAccountId,
            type: (0, $lOnm2.InAppMessageEventType).Snoozed,
            placement: placementId,
            createdAt: Date.now(),
            statusExpiryTime: statusExpiryTime,
            analyticsDetails: analyticsDetails,
            context: context
        });
    }, [
        client,
        messageInstanceId,
        messageTemplateId,
        placementId,
        analyticsDetails,
        context,
        transactionAccountId,
        snoozeMessageFromPlacement
    ]);
    return {
        markAllAsRead: markAllAsRead,
        messageRead: messageRead,
        messageUnread: messageUnread,
        messageViewed: messageViewed,
        messageClicked: messageClicked,
        messageClickedSecondary: messageClickedSecondary,
        messageAcknowledged: messageAcknowledged,
        messageDismissed: messageDismissed,
        messageSnoozed: messageSnoozed
    };
};
module.exports["useMessageEvent"] = $858a4870c67919f0$export$3cbbf1e81e2ecb39;

});

parcelRegister("5Rfgj", function(module, exports) {
class $4253c717b3565d29$export$12bb62b204112f55 extends Error {
    constructor(){
        super('useMessageLifecycle must be used inside a Message template render component.');
    }
}
class $4253c717b3565d29$export$44f397e2afeb89e0 extends Error {
    constructor(){
        super('API call to /messages failed due to an error');
    }
}
module.exports["MessageLifecycleContextError"] = $4253c717b3565d29$export$12bb62b204112f55;
module.exports["MessageLifecycleClientError"] = $4253c717b3565d29$export$44f397e2afeb89e0;

});

parcelRegister("aByw7", function(module, exports) {
$parcel$export(module.exports, "MessageEventClient", () => (parcelRequire("dEG1b")).MessageEventClient);
/**
 * Re-exports from the canonical implementation in `@atlassian/post-office-context`.
 *
 * The source of truth is:
 *   platform/packages/post-office/post-office-context/src/message-lifecycle/message-event-client.ts
 *
 * This re-export ensures that `@post-office/message-lifecycle` and
 * `@atlassian/post-office-context` share the same `MessageEventClient` class
 * identity, avoiding TypeScript structural mismatch errors caused by private fields.
 */ 
var $dEG1b = parcelRequire("dEG1b");


});

parcelRegister("lOnm2", function(module, exports) {
var $984aeda379ad7f1a$export$b31ffc6f7c85f1b = /*#__PURE__*/ function(InAppMessageEventType) {
    InAppMessageEventType["Viewed"] = "viewed";
    InAppMessageEventType["Acknowledged"] = "acknowledged";
    InAppMessageEventType["Clicked"] = "clicked";
    InAppMessageEventType["ClickedSecondary"] = "clickedSecondary";
    InAppMessageEventType["Dismissed"] = "dismissed";
    InAppMessageEventType["Snoozed"] = "snoozed";
    InAppMessageEventType["Read"] = "read";
    InAppMessageEventType["Unread"] = "unread";
    return InAppMessageEventType;
}({});
module.exports["InAppMessageEventType"] = $984aeda379ad7f1a$export$b31ffc6f7c85f1b;

});

parcelRegister("lixOz", function(module, exports) {
$parcel$export(module.exports, "useInViewport", () => $f8158248d0f47600$export$6215040b989f9b0f, (v) => $f8158248d0f47600$export$6215040b989f9b0f = v);
var $f8158248d0f47600$export$1e511d4a378977f5;
var $f8158248d0f47600$export$6215040b989f9b0f;
var $f8158248d0f47600$export$436b63fa4855237f;
var $f8158248d0f47600$export$2e2bcd8739ae039;
var $f8158248d0f47600$export$95cef81be5ddcfd4;
"use strict";
$f8158248d0f47600$export$1e511d4a378977f5 = true;
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$export$95cef81be5ddcfd4 = void 0;

var $f8158248d0f47600$var$_handleViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("3Tfn6")));
$f8158248d0f47600$export$436b63fa4855237f = $f8158248d0f47600$var$_handleViewport.default;

var $f8158248d0f47600$var$_useInViewport = $f8158248d0f47600$var$_interopRequireDefault((parcelRequire("byriw")));
$f8158248d0f47600$export$6215040b989f9b0f = $f8158248d0f47600$var$_useInViewport.default;
function $f8158248d0f47600$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $f8158248d0f47600$var$customProps = $f8158248d0f47600$export$95cef81be5ddcfd4 = [
    'inViewport',
    'enterCount',
    'leaveCount'
];
var $f8158248d0f47600$var$_default = $f8158248d0f47600$export$2e2bcd8739ae039 = $f8158248d0f47600$var$_handleViewport.default;

});

parcelRegister("3Tfn6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $2d526ea1e19243c2$export$1e511d4a378977f5, (v) => $2d526ea1e19243c2$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $2d526ea1e19243c2$export$2e2bcd8739ae039, (v) => $2d526ea1e19243c2$export$2e2bcd8739ae039 = v);
var $2d526ea1e19243c2$export$1e511d4a378977f5;
var $2d526ea1e19243c2$export$2e2bcd8739ae039;
"use strict";
$2d526ea1e19243c2$export$1e511d4a378977f5 = true;
$2d526ea1e19243c2$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $2d526ea1e19243c2$var$_hoistNonReactStatics = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("aH9xZ")));

var $2d526ea1e19243c2$var$_useInViewport = $2d526ea1e19243c2$var$_interopRequireDefault((parcelRequire("byriw")));

var $3dWch = parcelRequire("3dWch");


var $8aG6j = parcelRequire("8aG6j");

var $2d526ea1e19243c2$var$_excluded = [
    "onEnterViewport",
    "onLeaveViewport"
];
function $2d526ea1e19243c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function $2d526ea1e19243c2$var$_extends() {
    return $2d526ea1e19243c2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2d526ea1e19243c2$var$_extends.apply(null, arguments);
}
function $2d526ea1e19243c2$var$handleViewport(TargetComponent, options, config) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    var ForwardedRefComponent = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        var refProps = {
            forwardedRef: ref
        };
        return /*#__PURE__*/ (0, $8aG6j.jsx)(TargetComponent, $2d526ea1e19243c2$var$_extends({}, props, refProps));
    });
    var InViewport = (_ref)=>{
        var { onEnterViewport: onEnterViewport = $3dWch.noop, onLeaveViewport: onLeaveViewport = $3dWch.noop } = _ref, restProps = $2d526ea1e19243c2$var$_objectWithoutPropertiesLoose(_ref, $2d526ea1e19243c2$var$_excluded);
        var node = (0, $cozmU.useRef)(null);
        var { inViewport: inViewport, enterCount: enterCount, leaveCount: leaveCount } = (0, $2d526ea1e19243c2$var$_useInViewport.default)(node, options, config, {
            onEnterViewport: onEnterViewport,
            onLeaveViewport: onLeaveViewport
        });
        var props = $2d526ea1e19243c2$var$_extends({}, restProps, {
            inViewport: inViewport,
            enterCount: enterCount,
            leaveCount: leaveCount
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)(ForwardedRefComponent, $2d526ea1e19243c2$var$_extends({}, props, {
            ref: node
        }));
    };
    var name = TargetComponent.displayName || TargetComponent.name || 'Component';
    InViewport.displayName = "handleViewport(" + name + ")";
    return (0, $2d526ea1e19243c2$var$_hoistNonReactStatics.default)(InViewport, ForwardedRefComponent);
}
var $2d526ea1e19243c2$var$_default = $2d526ea1e19243c2$export$2e2bcd8739ae039 = $2d526ea1e19243c2$var$handleViewport;

});

parcelRegister("byriw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", () => $86980b6f9121fe40$export$1e511d4a378977f5, (v) => $86980b6f9121fe40$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $86980b6f9121fe40$export$2e2bcd8739ae039, (v) => $86980b6f9121fe40$export$2e2bcd8739ae039 = v);
var $86980b6f9121fe40$export$1e511d4a378977f5;
var $86980b6f9121fe40$export$2e2bcd8739ae039;
"use strict";
$86980b6f9121fe40$export$1e511d4a378977f5 = true;
$86980b6f9121fe40$export$2e2bcd8739ae039 = void 0;

var $cozmU = parcelRequire("cozmU");


var $3dWch = parcelRequire("3dWch");

var $86980b6f9121fe40$var$defaultMutationObserverOption = {
    attributes: true,
    childList: true,
    subtree: true
};
var $86980b6f9121fe40$var$useInViewport = function useInViewport(target, options, config, props) {
    if (options === void 0) options = $3dWch.defaultOptions;
    if (config === void 0) config = $3dWch.defaultConfig;
    if (props === void 0) props = $3dWch.defaultProps;
    var { onEnterViewport: onEnterViewport, onLeaveViewport: onLeaveViewport } = props;
    var [, forceUpdate] = (0, $cozmU.useState)();
    var observer = (0, $cozmU.useRef)();
    var inViewportRef = (0, $cozmU.useRef)(false);
    var intersected = (0, $cozmU.useRef)(false);
    var enterCountRef = (0, $cozmU.useRef)(0);
    var leaveCountRef = (0, $cozmU.useRef)(0);
    // State to track when target is available
    var [isTargetReady, setIsTargetReady] = (0, $cozmU.useState)(Boolean(target.current));
    function startObserver(_ref) {
        var { observerRef: observerRef } = _ref;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.observe(node);
        }
    }
    function stopObserver(_ref2) {
        var { observerRef: observerRef } = _ref2;
        var targetRef = target.current;
        if (targetRef) {
            var node = targetRef;
            if (node) observerRef == null || observerRef.unobserve(node);
        }
        observerRef == null || observerRef.disconnect();
        observer.current = null;
    }
    var handleIntersection = (entries)=>{
        var entry = entries[0] || {};
        var { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = entry;
        var isInViewport = typeof isIntersecting !== 'undefined' ? isIntersecting : intersectionRatio > 0;
        // enter
        if (!intersected.current && isInViewport) {
            intersected.current = true;
            onEnterViewport == null || onEnterViewport();
            enterCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
            return;
        }
        // leave
        if (intersected.current && !isInViewport) {
            intersected.current = false;
            onLeaveViewport == null || onLeaveViewport();
            if (config.disconnectOnLeave && observer.current) // disconnect observer on leave
            observer.current.disconnect();
            leaveCountRef.current += 1;
            inViewportRef.current = isInViewport;
            forceUpdate(isInViewport);
        }
    };
    function initIntersectionObserver(_ref3) {
        var { observerRef: observerRef } = _ref3;
        if (!observerRef) {
            observer.current = new IntersectionObserver(handleIntersection, options);
            return observer.current;
        }
        return observerRef;
    }
    (0, $cozmU.useEffect)(()=>{
        var observerRef = observer.current;
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        observerRef = initIntersectionObserver({
            observerRef: observerRef
        });
        startObserver({
            observerRef: observerRef
        });
        return ()=>{
            stopObserver({
                observerRef: observerRef
            });
        };
    }, [
        target.current,
        options,
        config,
        onEnterViewport,
        onLeaveViewport
    ]);
    // Use MutationObserver to detect when `target.current` becomes non-null
    // only at start up
    (0, $cozmU.useEffect)(()=>{
        var currentElement = target.current;
        var mutationObserver = null;
        // MutationObserver callback to check when the target ref is assigned
        var handleOnChange = ()=>{
            if (target.current && !isTargetReady) {
                setIsTargetReady(true);
                if (mutationObserver) mutationObserver.disconnect();
            }
        };
        if (currentElement) setIsTargetReady(true); // If target is already available, mark it ready
        else {
            // Observe changes to detect when `target.current` becomes non-null
            mutationObserver = new MutationObserver(handleOnChange);
            mutationObserver.observe(document.body, $86980b6f9121fe40$var$defaultMutationObserverOption);
        }
        // Cleanup function to stop observing when the component unmounts
        return ()=>{
            if (mutationObserver) mutationObserver.disconnect();
        };
    }, [
        target.current
    ]);
    return {
        inViewport: inViewportRef.current,
        enterCount: enterCountRef.current,
        leaveCount: leaveCountRef.current
    };
};
var $86980b6f9121fe40$var$_default = $86980b6f9121fe40$export$2e2bcd8739ae039 = $86980b6f9121fe40$var$useInViewport;

});

parcelRegister("3dWch", function(module, exports) {
$parcel$export(module.exports, "noop", () => $258fbab87dea3908$export$8793edee2d425525, (v) => $258fbab87dea3908$export$8793edee2d425525 = v);
$parcel$export(module.exports, "defaultProps", () => $258fbab87dea3908$export$9c21a3269931e1e6, (v) => $258fbab87dea3908$export$9c21a3269931e1e6 = v);
$parcel$export(module.exports, "defaultOptions", () => $258fbab87dea3908$export$ba43bf67f3d48107, (v) => $258fbab87dea3908$export$ba43bf67f3d48107 = v);
$parcel$export(module.exports, "defaultConfig", () => $258fbab87dea3908$export$f84bd70098573c5c, (v) => $258fbab87dea3908$export$f84bd70098573c5c = v);
var $258fbab87dea3908$export$1e511d4a378977f5;
var $258fbab87dea3908$export$8793edee2d425525;
var $258fbab87dea3908$export$9c21a3269931e1e6;
var $258fbab87dea3908$export$ba43bf67f3d48107;
var $258fbab87dea3908$export$f84bd70098573c5c;
"use strict";
$258fbab87dea3908$export$1e511d4a378977f5 = true;
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$export$9c21a3269931e1e6 = $258fbab87dea3908$export$ba43bf67f3d48107 = $258fbab87dea3908$export$f84bd70098573c5c = void 0;
var $258fbab87dea3908$var$defaultOptions = $258fbab87dea3908$export$ba43bf67f3d48107 = {};
var $258fbab87dea3908$var$defaultConfig = $258fbab87dea3908$export$f84bd70098573c5c = {
    disconnectOnLeave: false
};
var $258fbab87dea3908$var$noop = ()=>{};
$258fbab87dea3908$export$8793edee2d425525 = $258fbab87dea3908$var$noop;
var $258fbab87dea3908$var$defaultProps = $258fbab87dea3908$export$9c21a3269931e1e6 = {
    onEnterViewport: $258fbab87dea3908$var$noop,
    onLeaveViewport: $258fbab87dea3908$var$noop
};

});

parcelRegister("jS1GQ", function(module, exports) {
const $6bdcc106a64db8f9$export$21c420c0c257c346 = (triggerType)=>{
    if (!triggerType) return false;
    return triggerType === 'gasV3' || triggerType === 'poTrigger';
};
module.exports["isClientTriggeredMessage"] = $6bdcc106a64db8f9$export$21c420c0c257c346;

});

parcelRegister("g7aP0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cXtTj = parcelRequire("cXtTj");


var $5ydwr = parcelRequire("5ydwr");


var $khbFI = parcelRequire("khbFI");


var $9TNXZ = parcelRequire("9TNXZ");


var $6NRmI = parcelRequire("6NRmI");


var $cozmU = parcelRequire("cozmU");

const $2adf26225a469e82$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldClaim = (0, $5ydwr.useNarrowExposureShouldClaim)(inAppNarrowExposureExperiment);
    const shouldRender = useChoreographedRender({
        messageId: messageId,
        shouldClaim: shouldClaim
    });
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $2adf26225a469e82$var$NarrowExposureComponent = ({ children: children, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const shouldRender = (0, $khbFI.useNarrowExposureShouldRender)(inAppNarrowExposureExperiment);
    if (shouldRender) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return null;
};
const $2adf26225a469e82$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $6NRmI.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $cXtTj.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $cXtTj.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $8aG6j.jsx)($2adf26225a469e82$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
                children: children
            });
        }
        // The choreographer won't offer this message a slot, so check its experiment here. With the
        // choreographer off, placements run the check themselves.
        if (inAppNarrowExposureExperiment) return /*#__PURE__*/ (0, $8aG6j.jsx)($2adf26225a469e82$var$NarrowExposureComponent, {
            inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
            children: children
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $2adf26225a469e82$export$8db7ba034addcd65;

});

parcelRegister("khbFI", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kEPax = parcelRequire("kEPax");


var $k4HA2 = parcelRequire("k4HA2");


var $fklDH = parcelRequire("fklDH");


var $eke7R = parcelRequire("eke7R");

const $5be779e57f4885b6$export$72c63079067610b3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (config)=>{
    const $ = (0, $bDgLe.c)(7);
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    const { messageInstanceDropped: messageInstanceDropped } = (0, $kEPax.useMessageInstanceEvent)();
    let t0;
    if ($[0] !== config) {
        t0 = config ? (0, $eke7R.evaluateCohort)(config) : undefined;
        $[0] = config;
        $[1] = t0;
    } else t0 = $[1];
    const decision = t0;
    let t1;
    if ($[2] !== config || $[3] !== decision || $[4] !== messageInstanceDropped || $[5] !== messageInstanceId) {
        t1 = ()=>{
            if (config && decision && decision.outcome !== "show") (0, $fklDH.postNarrowExposureDrop)(messageInstanceDropped, messageInstanceId, config, decision);
        };
        $[2] = config;
        $[3] = decision;
        $[4] = messageInstanceDropped;
        $[5] = messageInstanceId;
        $[6] = t1;
    } else t1 = $[6];
    (0, $cozmU.useEffect)(t1);
    return !decision || decision.outcome === "show";
} : (config)=>{
    const { messageInstanceId: messageInstanceId } = (0, $k4HA2.useMessageContext)();
    const { messageInstanceDropped: messageInstanceDropped } = (0, $kEPax.useMessageInstanceEvent)();
    const decision = config ? (0, $eke7R.evaluateCohort)(config) : undefined;
    // The cohort can change between renders, so check each commit; the drop helper deduplicates.
    (0, $cozmU.useEffect)(()=>{
        if (config && decision && decision.outcome !== 'show') (0, $fklDH.postNarrowExposureDrop)(messageInstanceDropped, messageInstanceId, config, decision);
    });
    return !decision || decision.outcome === 'show';
};
module.exports["useNarrowExposureShouldRender"] = $5be779e57f4885b6$export$72c63079067610b3;

});

parcelRegister("1dHYE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

const $c24c1359cebc9ade$export$738797901aa9197a = ({ ChoreographerWrapper: ChoreographerWrapper, enabled: enabled, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, inAppNarrowExposureExperiment: inAppNarrowExposureExperiment, children: children })=>{
    if (!enabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)(ChoreographerWrapper, {
        messageId: messageId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        inAppNarrowExposureExperiment: inAppNarrowExposureExperiment,
        children: children
    });
};
module.exports["MaybeChoreographerWrapper"] = $c24c1359cebc9ade$export$738797901aa9197a;

});

parcelRegister("5KMtM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aeEJA = parcelRequire("aeEJA");

const $1ae28466f611f1b1$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $cozmU.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $aeEJA.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $1ae28466f611f1b1$export$5523c5f3222291d0;

});

parcelRegister("aeEJA", function(module, exports) {

var $9TNXZ = parcelRequire("9TNXZ");


var $j4yZr = parcelRequire("j4yZr");


var $cozmU = parcelRequire("cozmU");


var $fRJAi = parcelRequire("fRJAi");

class $d65c3221c86fee02$export$8c5224d3af2f3c8b extends Error {
    constructor(){
        super('Request is already running.');
        this.name = 'AlreadyRunningError';
    }
}
const $d65c3221c86fee02$export$c1cf1cf4c5d51937 = (promiseToResolve, options)=>{
    const [state, setState] = (0, $cozmU.useState)((0, $fRJAi.toLoading)());
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $9TNXZ.useFirePostOfficeAnalyticsEvents)();
    const { name: analyticsSubjectId, ...analyticsAttributes } = options?.analytics ?? {
        name: 'unknown'
    };
    (0, $cozmU.useEffect)(()=>{
        if (typeof promiseToResolve !== 'function') return;
        const abortController = new AbortController();
        const { signal: signal } = abortController;
        promiseToResolve({
            signal: signal
        })?.then(async (res)=>{
            if (!res) return;
            if ((0, $fRJAi.assertResponseIsOk)(res)) {
                const data = await res.json();
                setState((0, $fRJAi.toData)(data));
                fireAnalyticsEvent({
                    action: 'resolved',
                    actionSubject: 'dataPromise',
                    actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                    eventType: 'operational',
                    attributes: {
                        ...analyticsAttributes
                    }
                });
            }
        }).catch((err)=>{
            if (err instanceof $d65c3221c86fee02$export$8c5224d3af2f3c8b || signal.aborted) return;
            const errorState = (0, $fRJAi.toError)(err);
            fireAnalyticsEvent({
                action: 'rejected',
                actionSubject: 'dataPromise',
                actionSubjectId: (0, (/*@__PURE__*/$parcel$interopDefault($j4yZr)))(analyticsSubjectId) + 'DataPromise',
                eventType: 'operational',
                attributes: {
                    ...analyticsAttributes,
                    errorName: errorState.error.name ?? 'unknown',
                    errorMessage: errorState.error.message ?? 'unknown'
                }
            });
            setState(errorState);
        });
        return ()=>{
            abortController.abort();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        promiseToResolve
    ]);
    return state;
};
module.exports["AlreadyRunningError"] = $d65c3221c86fee02$export$8c5224d3af2f3c8b;
module.exports["useData"] = $d65c3221c86fee02$export$c1cf1cf4c5d51937;

});

parcelRegister("fRJAi", function(module, exports) {
const $b02ec9b1100b044c$export$18a0019e5439b209 = ({ status: status, statusText: statusText })=>JSON.stringify({
        status: status,
        statusText: statusText
    });
const $b02ec9b1100b044c$export$b3732c8ff6f9c463 = (res)=>{
    if (res.ok) return res;
    throw new Error($b02ec9b1100b044c$export$18a0019e5439b209(res));
};
const $b02ec9b1100b044c$export$f9a5bd0ffba29ffc = ()=>({
        isLoading: true,
        data: undefined,
        error: undefined
    });
const $b02ec9b1100b044c$export$cc3b967c039ed3e7 = (error)=>({
        isLoading: false,
        error: error instanceof Error ? error : Error(String(error)),
        data: undefined
    });
const $b02ec9b1100b044c$export$24a6b176bdc41ce5 = (data)=>({
        isLoading: false,
        error: undefined,
        data: data
    });
module.exports["assertResponseIsOk"] = $b02ec9b1100b044c$export$b3732c8ff6f9c463;
module.exports["toLoading"] = $b02ec9b1100b044c$export$f9a5bd0ffba29ffc;
module.exports["toError"] = $b02ec9b1100b044c$export$cc3b967c039ed3e7;
module.exports["toData"] = $b02ec9b1100b044c$export$24a6b176bdc41ce5;

});

parcelRegister("7oSFe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $4SEHm = parcelRequire("4SEHm");


var $byLFK = parcelRequire("byLFK");

// React 18's lazy initializer checks the component's status as soon as `then` returns, and suspends
// unless `then` has already called back. `Promise.resolve(loaded)` always calls back in a
// microtask, so it would suspend even for a loaded module. This Promise overrides `then` to call
// back synchronously. The rest of the Promise API goes through `then`, so `catch`, `finally` and
// `Promise.all` still work.
const $c56f53959e94d59f$var$resolvedThenable = (value)=>{
    const promise = new Promise((resolve)=>resolve(value));
    promise.then = (onFulfilled)=>Promise.resolve(onFulfilled ? onFulfilled(value) : value);
    return promise;
};
function $c56f53959e94d59f$var$withServerTracking(id, module) {
    const Original = module.default;
    const TrackedLazy = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
        // Effects do not run during SSR, so render is the only place to record the rendered split.
        if ((0, $6mKj3.expValEquals)('confluence_ssr_react_lazy_preload_v2', 'isEnabled', true)) (0, $byLFK.addLoadableId)(id);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Original, {
            ...props,
            ref: ref
        });
    });
    TrackedLazy.displayName = `TrackedLazy(${Original.displayName || Original.name || 'Component'})`;
    return {
        ...module,
        default: TrackedLazy
    };
}
function $c56f53959e94d59f$export$fb5c897fe5d03fec(id, loader) {
    // process.env.REACT_SSR is read inline so each build can drop the other side's branch. None of
    // these branches changes rendered markup, so they cannot cause a hydration mismatch.
    const prepare = (module)=>module;
    let loaded;
    let pending;
    const load = ()=>{
        pending ?? (pending = loader().then((module)=>{
            loaded = prepare(module);
            return loaded;
        }, (error)=>{
            pending = undefined;
            throw error;
        }));
        return pending;
    };
    let preloaded = false;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if ((0, $4SEHm.isReportedReactLazyId)(id)) // Waiting a microtask lets the defining module finish evaluating before the loader reads any
    // of its bindings.
    (0, $byLFK.preloadIfNeeded)(id, undefined, ()=>Promise.resolve().then(load).then(()=>{
            preloaded = true;
        }));
    return ()=>{
        if (!loaded) return load();
        // The client only answers synchronously after the preload the server asked for, so lazy
        // components behave as before when the experiment is off.
        const canResolveSynchronously = preloaded;
        return canResolveSynchronously ? $c56f53959e94d59f$var$resolvedThenable(loaded) : load();
    };
}
module.exports["trackReactLazy"] = $c56f53959e94d59f$export$fb5c897fe5d03fec;

});

parcelRegister("4Iym9", function(module, exports) {

let $36f5ebece00db0ae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36f5ebece00db0ae$var$load("kHrF1").then(()=>parcelRequire('89Vfm'));

});

parcelRegister("1iTqD", function(module, exports) {

let $0f3277d5a0eb8dab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0f3277d5a0eb8dab$var$load("37rXb").then(()=>parcelRequire('5bCTa'));

});

parcelRegister("3hepi", function(module, exports) {

let $262e22910dc1058e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $262e22910dc1058e$var$load("cONd1").then(()=>parcelRequire('fTmm2'));

});

parcelRegister("2ZHmQ", function(module, exports) {

let $22e2eb2c120cc10f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $22e2eb2c120cc10f$var$load("ife00").then(()=>parcelRequire('b13jK'));

});

parcelRegister("bV4Ce", function(module, exports) {

let $8ad89920ab88d8e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ad89920ab88d8e8$var$load("1637h").then(()=>parcelRequire('5vyg2'));

});

parcelRegister("lxdhr", function(module, exports) {

let $fad6fb360d225633$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fad6fb360d225633$var$load("2QkNi").then(()=>parcelRequire('hkdEU'));

});

parcelRegister("5NUPY", function(module, exports) {

let $439d9e11070519f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $439d9e11070519f8$var$load("ezq6J").then(()=>parcelRequire('kZtvI'));

});

parcelRegister("bB9t0", function(module, exports) {

let $871a7e532bbadbb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $871a7e532bbadbb2$var$load("860N5").then(()=>parcelRequire('3S7d3'));

});

parcelRegister("ltw2p", function(module, exports) {

let $fa25286f6a37ba58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa25286f6a37ba58$var$load("hycPu").then(()=>parcelRequire('lYiPY'));

});

parcelRegister("8dMQg", function(module, exports) {

let $5fc56ca4cea0de3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5fc56ca4cea0de3f$var$load("fsIdf").then(()=>parcelRequire('bfkO7'));

});

parcelRegister("9o5o9", function(module, exports) {

let $6d5a890335982d39$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d5a890335982d39$var$load("diOlf").then(()=>parcelRequire('lpAQD'));

});

parcelRegister("3XQ5e", function(module, exports) {

let $2e2f4876292e6e3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e2f4876292e6e3d$var$load("e1cVY").then(()=>parcelRequire('60rzW'));

});

parcelRegister("7PVOs", function(module, exports) {

let $5b4a243f6abe67da$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b4a243f6abe67da$var$load("inCDC").then(()=>parcelRequire('cuBRF'));

});

parcelRegister("jBG5K", function(module, exports) {

let $e4621f912cb6ab4c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e4621f912cb6ab4c$var$load("aytCv").then(()=>parcelRequire('3sZAI'));

});

parcelRegister("lMMZS", function(module, exports) {

let $fdc4166f9e7e2047$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fdc4166f9e7e2047$var$load("8ARqL").then(()=>parcelRequire('hqwqX'));

});

parcelRegister("gm8IT", function(module, exports) {

let $be85779fb6b7ca8f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $be85779fb6b7ca8f$var$load("ba7zz").then(()=>parcelRequire('k7bDg'));

});

parcelRegister("dxgn1", function(module, exports) {

let $9dab0e37c3005da6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9dab0e37c3005da6$var$load("5JsmA").then(()=>parcelRequire('fvR7h'));

});

parcelRegister("lwhBR", function(module, exports) {

let $faaa3f0565cd47f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $faaa3f0565cd47f1$var$load("5V9Lw").then(()=>parcelRequire('140kO'));

});

parcelRegister("8Myjm", function(module, exports) {

let $664d6be8d94b99e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $664d6be8d94b99e0$var$load("9qDiv").then(()=>parcelRequire('iJH1m'));

});

parcelRegister("6iDb8", function(module, exports) {

let $4962d08d4036c7fd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4962d08d4036c7fd$var$load("6c5Xi").then(()=>parcelRequire('dOOpP'));

});

parcelRegister("6BeIK", function(module, exports) {

let $4ce19e02fae7259e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4ce19e02fae7259e$var$load("gjM3W").then(()=>parcelRequire('gKrHM'));

});

parcelRegister("hR1bU", function(module, exports) {

let $cff84f730db5027d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cff84f730db5027d$var$load("1ZG09").then(()=>parcelRequire('1z67G'));

});

parcelRegister("hGNYw", function(module, exports) {

let $ce0d1fe991cd2d9d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce0d1fe991cd2d9d$var$load("1Ky7r").then(()=>parcelRequire('fi3GB'));

});

parcelRegister("kS4YW", function(module, exports) {

let $f31cb714072a2082$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f31cb714072a2082$var$load("iV7FO").then(()=>parcelRequire('jbKsQ'));

});

parcelRegister("dB5G7", function(module, exports) {

let $9e6322ab74a1e5d4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e6322ab74a1e5d4$var$load("lY1yi").then(()=>parcelRequire('28AlJ'));

});

parcelRegister("dBGBb", function(module, exports) {

let $9e7fc64bd801671a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9e7fc64bd801671a$var$load("7fPba").then(()=>parcelRequire('9KuH8'));

});

parcelRegister("ieekc", function(module, exports) {

let $d454a565e966c4b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d454a565e966c4b8$var$load("gfpFC").then(()=>parcelRequire('8eU9O'));

});

parcelRegister("f1fGT", function(module, exports) {

let $aef31edcbae50f94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aef31edcbae50f94$var$load("j4RcO").then(()=>parcelRequire('bw3XU'));

});

parcelRegister("725J8", function(module, exports) {

let $51ed299756c5b00b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $51ed299756c5b00b$var$load("bE2dO").then(()=>parcelRequire('23aPH'));

});

parcelRegister("2nOCv", function(module, exports) {

let $1bc4fede744a3342$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1bc4fede744a3342$var$load("Rn28l").then(()=>parcelRequire('9MWQg'));

});

parcelRegister("czarH", function(module, exports) {

let $9260db3bca01763e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9260db3bca01763e$var$load("jDlZ4").then(()=>parcelRequire('5ZGzM'));

});

parcelRegister("9F1ix", function(module, exports) {

let $7088f325a1316989$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7088f325a1316989$var$load("2xYiQ").then(()=>parcelRequire('jkMtN'));

});

parcelRegister("ltiBY", function(module, exports) {

let $fa1abe418f1eaf4e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fa1abe418f1eaf4e$var$load("hHT92").then(()=>parcelRequire('7Bp9g'));

});

parcelRegister("hK21o", function(module, exports) {

let $cea84cf8a17974bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cea84cf8a17974bb$var$load("2xKrc"),
    $cea84cf8a17974bb$var$load("kBatH"),
    $cea84cf8a17974bb$var$load("lleiS")
]).then(()=>parcelRequire('dtUQm'));

});

parcelRegister("jRxdD", function(module, exports) {

let $e75cbc217b5dc83c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e75cbc217b5dc83c$var$load("4rgre").then(()=>parcelRequire('du1c2'));

});

parcelRegister("c7WVx", function(module, exports) {

let $8d43d92484f06b9d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8d43d92484f06b9d$var$load("2SJP4").then(()=>parcelRequire('gRgUB'));

});

parcelRegister("eGudH", function(module, exports) {

let $ab0c6e02b0f57a58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ab0c6e02b0f57a58$var$load("kCWQF").then(()=>parcelRequire('g3lBl'));

});

parcelRegister("99lIr", function(module, exports) {

let $6a95cca1b730b118$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a95cca1b730b118$var$load("3ZHNf").then(()=>parcelRequire('kmQ3S'));

});

parcelRegister("8NWfU", function(module, exports) {

let $669016a8748dcba8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $669016a8748dcba8$var$load("6wr18"),
    $669016a8748dcba8$var$load("63q9w"),
    $669016a8748dcba8$var$load("e00ow"),
    $669016a8748dcba8$var$load("ffEVr"),
    $669016a8748dcba8$var$load("4jgLQ")
]).then(()=>parcelRequire('azNlN'));

});

parcelRegister("bem5T", function(module, exports) {

let $82d223ef46021943$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $82d223ef46021943$var$load("alfJN"),
    $82d223ef46021943$var$load("b3nRR")
]).then(()=>parcelRequire('gfWP6'));

});

parcelRegister("2WwaO", function(module, exports) {

let $2249f485ab49b067$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2249f485ab49b067$var$load("3onSx").then(()=>parcelRequire('gCTHb'));

});

parcelRegister("3QAyQ", function(module, exports) {

let $2cd296abd7f18188$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2cd296abd7f18188$var$load("8umkR").then(()=>parcelRequire('dMCKX'));

});

parcelRegister("hsVRc", function(module, exports) {

let $cb71ee6a2f60bb92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb71ee6a2f60bb92$var$load("kDeae").then(()=>parcelRequire('kzs31'));

});

parcelRegister("3ZUUm", function(module, exports) {

let $2e93365aa91e55d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e93365aa91e55d0$var$load("kCf82").then(()=>parcelRequire('5jXiY'));

});

parcelRegister("gTFT7", function(module, exports) {

let $c4d2467c1b1d27fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4d2467c1b1d27fa$var$load("dGFoh").then(()=>parcelRequire('3ICSB'));

});

parcelRegister("3RZNa", function(module, exports) {

let $2d1640f060a8ac62$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2d1640f060a8ac62$var$load("kQi2e").then(()=>parcelRequire('3Mhmc'));

});

parcelRegister("rf1Td", function(module, exports) {

let $051e2e45b5a62691$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $051e2e45b5a62691$var$load("6wr18"),
    $051e2e45b5a62691$var$load("7EorR"),
    $051e2e45b5a62691$var$load("6TLS9"),
    $051e2e45b5a62691$var$load("ffEVr"),
    $051e2e45b5a62691$var$load("alfJN"),
    $051e2e45b5a62691$var$load("63q9w"),
    $051e2e45b5a62691$var$load("hHsqv"),
    $051e2e45b5a62691$var$load("7hA9c")
]).then(()=>parcelRequire('3GQq8'));

});

parcelRegister("lNkfP", function(module, exports) {

let $fddde2ad3e797348$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fddde2ad3e797348$var$load("6wr18"),
    $fddde2ad3e797348$var$load("7EorR"),
    $fddde2ad3e797348$var$load("6TLS9"),
    $fddde2ad3e797348$var$load("ffEVr"),
    $fddde2ad3e797348$var$load("alfJN"),
    $fddde2ad3e797348$var$load("63q9w"),
    $fddde2ad3e797348$var$load("hHsqv")
]).then(()=>parcelRequire('d0i9V'));

});

parcelRegister("26ETM", function(module, exports) {

let $188bddf45d48eb68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $188bddf45d48eb68$var$load("6wr18"),
    $188bddf45d48eb68$var$load("7EorR"),
    $188bddf45d48eb68$var$load("6TLS9"),
    $188bddf45d48eb68$var$load("ffEVr"),
    $188bddf45d48eb68$var$load("alfJN"),
    $188bddf45d48eb68$var$load("63q9w"),
    $188bddf45d48eb68$var$load("bXoJE")
]).then(()=>parcelRequire('bq8Nu'));

});

parcelRegister("fhsoM", function(module, exports) {

let $b1fe78e85047b94e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1fe78e85047b94e$var$load("4QV5D").then(()=>parcelRequire('brTFX'));

});

parcelRegister("4wYkW", function(module, exports) {

let $34c8f43aa3dfa85c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $34c8f43aa3dfa85c$var$load("kHXBa").then(()=>parcelRequire('dTwd2'));

});

parcelRegister("36KuD", function(module, exports) {

let $2435ff3999c78d24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2435ff3999c78d24$var$load("bClf1").then(()=>parcelRequire('jLMD4'));

});

parcelRegister("izveW", function(module, exports) {

let $d853ba7a1258f94d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d853ba7a1258f94d$var$load("4KYRw").then(()=>parcelRequire('gLXwE'));

});

parcelRegister("hywCm", function(module, exports) {

let $cc7ee9d8a39fe3d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc7ee9d8a39fe3d1$var$load("9m5cb").then(()=>parcelRequire('aXeIJ'));

});

parcelRegister("kjhgs", function(module, exports) {

let $ec92f9615c74dca2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ec92f9615c74dca2$var$load("5k22f"),
    $ec92f9615c74dca2$var$load("2hBkV")
]).then(()=>parcelRequire('eUttj'));

});

parcelRegister("f5YQo", function(module, exports) {

let $afd6850264ef6634$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $afd6850264ef6634$var$load("447Rs").then(()=>parcelRequire('5Mn6m'));

});

parcelRegister("3nXIr", function(module, exports) {

let $2771d7689bb0bfc6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2771d7689bb0bfc6$var$load("5dNUC").then(()=>parcelRequire('hAP6H'));

});

parcelRegister("YKJfe", function(module, exports) {

let $0b69da116988dc99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b69da116988dc99$var$load("eiDfJ").then(()=>parcelRequire('1dewd'));

});

parcelRegister("aUEov", function(module, exports) {

let $7f1e77d36fc0e0ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7f1e77d36fc0e0ad$var$load("TIXGP"),
    $7f1e77d36fc0e0ad$var$load("l8DDU"),
    $7f1e77d36fc0e0ad$var$load("f6KEh")
]).then(()=>parcelRequire('hycHN'));

});

parcelRegister("gb8Zj", function(module, exports) {

let $bc74a53f298c9def$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bc74a53f298c9def$var$load("TIXGP"),
    $bc74a53f298c9def$var$load("l8DDU"),
    $bc74a53f298c9def$var$load("bXeXh")
]).then(()=>parcelRequire('9gwTe'));

});

parcelRegister("6DFNs", function(module, exports) {

let $4d56ce88b9918f79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4d56ce88b9918f79$var$load("TIXGP"),
    $4d56ce88b9918f79$var$load("l8DDU"),
    $4d56ce88b9918f79$var$load("834j4")
]).then(()=>parcelRequire('9mO55'));

});

parcelRegister("70fHu", function(module, exports) {

let $5194b64597779ea9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5194b64597779ea9$var$load("8UEAA").then(()=>parcelRequire('kktUa'));

});

parcelRegister("9COO3", function(module, exports) {

let $701f12c2bcf915bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $701f12c2bcf915bd$var$load("aj9HA").then(()=>parcelRequire('gcdyh'));

});

parcelRegister("9AJVN", function(module, exports) {

let $6fbb1ad9cd5929bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6fbb1ad9cd5929bb$var$load("cU4Lc").then(()=>parcelRequire('k659G'));

});

parcelRegister("i1rL6", function(module, exports) {

let $d1edda46aa215141$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d1edda46aa215141$var$load("4Pq08"),
    $d1edda46aa215141$var$load("fHVVl"),
    $d1edda46aa215141$var$load("cjCTw")
]).then(()=>parcelRequire('kKQTn'));

});

parcelRegister("4NlrP", function(module, exports) {

let $37dc601c92a38713$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $37dc601c92a38713$var$load("4Rxsb").then(()=>parcelRequire('4vrP7'));

});

parcelRegister("94ngV", function(module, exports) {

let $69a68a223595adc7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $69a68a223595adc7$var$load("bnhHn").then(()=>parcelRequire('7aQac'));

});

parcelRegister("53lm9", function(module, exports) {

let $3addcc7d13f29ce7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3addcc7d13f29ce7$var$load("e18er").then(()=>parcelRequire('uQZPQ'));

});

parcelRegister("8zifP", function(module, exports) {

let $63cfc08935141123$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $63cfc08935141123$var$load("jkTan").then(()=>parcelRequire('2gLwU'));

});

parcelRegister("5DyJr", function(module, exports) {

let $41ab8951a2d33ae8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $41ab8951a2d33ae8$var$load("gmoL6").then(()=>parcelRequire('8PDBj'));

});

parcelRegister("cwRNp", function(module, exports) {

let $91f233f48dd5dbec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f233f48dd5dbec$var$load("hzSEs").then(()=>parcelRequire('dcCsW'));

});

parcelRegister("gi1yN", function(module, exports) {

let $bdbf8999418fc963$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bdbf8999418fc963$var$load("3Vc58").then(()=>parcelRequire('iH0tS'));

});

parcelRegister("8NEv2", function(module, exports) {

let $668250b44c042b3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $668250b44c042b3d$var$load("5ddsf").then(()=>parcelRequire('lVWEb'));

});

parcelRegister("33BpE", function(module, exports) {

let $239eac47b551ce2a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $239eac47b551ce2a$var$load("gdibj").then(()=>parcelRequire('b2K1V'));

});

parcelRegister("6mMPa", function(module, exports) {

let $4a2aaba200f35586$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a2aaba200f35586$var$load("d7dT5").then(()=>parcelRequire('4DRrO'));

});

parcelRegister("cUj4S", function(module, exports) {

let $9659837098ee5153$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9659837098ee5153$var$load("fO7Yd").then(()=>parcelRequire('d0nOG'));

});

parcelRegister("ban89", function(module, exports) {

let $82129219f932806d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $82129219f932806d$var$load("1S3jg").then(()=>parcelRequire('67WAp'));

});

parcelRegister("2ACrS", function(module, exports) {

let $1e2cc4a65c840bdc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1e2cc4a65c840bdc$var$load("18XeG").then(()=>parcelRequire('3crva'));

});

parcelRegister("gQsfe", function(module, exports) {

let $c437697fda13c153$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c437697fda13c153$var$load("d9GnO").then(()=>parcelRequire('a5f7R'));

});

parcelRegister("fPdyF", function(module, exports) {

let $b85622ceb2864de1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b85622ceb2864de1$var$load("8T5bw").then(()=>parcelRequire('jTlN6'));

});

parcelRegister("1x1r6", function(module, exports) {

let $11d9fcace011c387$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $11d9fcace011c387$var$load("eGtiq").then(()=>parcelRequire('kbjVa'));

});

parcelRegister("j0Fng", function(module, exports) {

let $dd6e1c7a19f6b77e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $dd6e1c7a19f6b77e$var$load("aOIZj"),
    $dd6e1c7a19f6b77e$var$load("lFmKr"),
    $dd6e1c7a19f6b77e$var$load("lCkJt"),
    $dd6e1c7a19f6b77e$var$load("4iZxP")
]).then(()=>parcelRequire('7lOHJ'));

});

parcelRegister("lCcbG", function(module, exports) {

let $fbc699c070786ce3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fbc699c070786ce3$var$load("aHGqm").then(()=>parcelRequire('ih3S1'));

});

parcelRegister("kEDDE", function(module, exports) {

let $f0964a7702a5191a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f0964a7702a5191a$var$load("kBatH"),
    $f0964a7702a5191a$var$load("9WFRt")
]).then(()=>parcelRequire('lWqb4'));

});

parcelRegister("kD1fH", function(module, exports) {

let $f0486bd53b970887$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f0486bd53b970887$var$load("iD34V").then(()=>parcelRequire('dkL40'));

});

parcelRegister("76P5l", function(module, exports) {

let $52d0b86039d960b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52d0b86039d960b7$var$load("au0nh").then(()=>parcelRequire('aXCpm'));

});

parcelRegister("7SG5v", function(module, exports) {

let $5bce394a5a535f5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5bce394a5a535f5e$var$load("8A2Xx").then(()=>parcelRequire('9VMF5'));

});

parcelRegister("e5Coy", function(module, exports) {

let $a41f50bfdf2e7b27$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a41f50bfdf2e7b27$var$load("69OVr").then(()=>parcelRequire('7oC4q'));

});

parcelRegister("9he98", function(module, exports) {

let $6c10acc1a57cf1e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c10acc1a57cf1e9$var$load("fdKcf").then(()=>parcelRequire('kpTGI'));

});

parcelRegister("8onkz", function(module, exports) {

let $61c2a99f0e3b7d26$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61c2a99f0e3b7d26$var$load("aweX2").then(()=>parcelRequire('bS8Fw'));

});

parcelRegister("lTNBf", function(module, exports) {

let $041d3ecc659bf1d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $041d3ecc659bf1d1$var$load("aOx6c").then(()=>parcelRequire('cWrmk'));

});

parcelRegister("4EMsu", function(module, exports) {

let $36407cb438c9c6a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $36407cb438c9c6a8$var$load("eDdaZ").then(()=>parcelRequire('bifqA'));

});

parcelRegister("gnQbw", function(module, exports) {

let $bed74622458bc8c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bed74622458bc8c0$var$load("d4Yqk").then(()=>parcelRequire('jiHGl'));

});

parcelRegister("akSrV", function(module, exports) {

let $78660224015e8923$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78660224015e8923$var$load("lvBrb").then(()=>parcelRequire('hKHmL'));

});

parcelRegister("16nTW", function(module, exports) {

let $0cd8e4414c0fe92a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0cd8e4414c0fe92a$var$load("kK3aY").then(()=>parcelRequire('kmh06'));

});

parcelRegister("7kiHM", function(module, exports) {

let $5558e9199944a248$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5558e9199944a248$var$load("a7dVH").then(()=>parcelRequire('d2p57'));

});

parcelRegister("hrhhh", function(module, exports) {

let $cb225c4731e37140$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cb225c4731e37140$var$load("6wr18"),
    $cb225c4731e37140$var$load("ffEVr"),
    $cb225c4731e37140$var$load("eVeZI")
]).then(()=>parcelRequire('2JUHj'));

});

parcelRegister("5CILm", function(module, exports) {

let $418339530e99f8ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $418339530e99f8ce$var$load("g1wmL").then(()=>parcelRequire('mPnYT'));

});

parcelRegister("gBblt", function(module, exports) {

let $c158e6faa0c3a221$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c158e6faa0c3a221$var$load("ddCqD").then(()=>parcelRequire('4xbYb'));

});

parcelRegister("kseEQ", function(module, exports) {

let $ee41cae6ebc2573d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee41cae6ebc2573d$var$load("9Ws8Q").then(()=>parcelRequire('lS8je'));

});

parcelRegister("2Rcwf", function(module, exports) {

let $214a3e0d5577a4ca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $214a3e0d5577a4ca$var$load("6wr18"),
    $214a3e0d5577a4ca$var$load("ffEVr"),
    $214a3e0d5577a4ca$var$load("e00ow"),
    $214a3e0d5577a4ca$var$load("kgtxd")
]).then(()=>parcelRequire('h57vo'));

});

parcelRegister("eSb7b", function(module, exports) {

let $ad3ebafd6de9395d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad3ebafd6de9395d$var$load("6s8yZ").then(()=>parcelRequire('db9Ek'));

});

parcelRegister("fZqoY", function(module, exports) {

let $ba41085ecf5a5843$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ba41085ecf5a5843$var$load("3W5HF").then(()=>parcelRequire('fLhOh'));

});

parcelRegister("1jc83", function(module, exports) {

let $0f40f95c0a96b7dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0f40f95c0a96b7dd$var$load("6wr18"),
    $0f40f95c0a96b7dd$var$load("ffEVr"),
    $0f40f95c0a96b7dd$var$load("9nPYa")
]).then(()=>parcelRequire('1Q2X2'));

});

parcelRegister("6vo9S", function(module, exports) {

let $4bc860a411c7b586$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4bc860a411c7b586$var$load("4AbJM").then(()=>parcelRequire('a4boW'));

});

parcelRegister("j33pp", function(module, exports) {

let $dde0f10ee8b912f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dde0f10ee8b912f8$var$load("lqVk4").then(()=>parcelRequire('kzPcD'));

});

parcelRegister("i3d5p", function(module, exports) {

let $d242a874d31909ce$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d242a874d31909ce$var$load("9Lc61").then(()=>parcelRequire('sTB0L'));

});

parcelRegister("1O2Fq", function(module, exports) {

let $150c87944a43208f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $150c87944a43208f$var$load("iLpFP").then(()=>parcelRequire('6hynS'));

});

parcelRegister("fkjQo", function(module, exports) {

let $b2881de03b7bd652$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2881de03b7bd652$var$load("9PH3W").then(()=>parcelRequire('6puOC'));

});

parcelRegister("exz4d", function(module, exports) {

let $a95f5950ec2b5012$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a95f5950ec2b5012$var$load("k3Bmb").then(()=>parcelRequire('81wup'));

});

parcelRegister("4RBQ1", function(module, exports) {

let $38a9767d4396a0a2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38a9767d4396a0a2$var$load("eU6QS").then(()=>parcelRequire('6Bxy9'));

});

parcelRegister("66n5l", function(module, exports) {

let $471535e0095115f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $471535e0095115f3$var$load("cDRFw").then(()=>parcelRequire('8anRq'));

});

parcelRegister("aKNJU", function(module, exports) {

let $7d44c87fc220a56d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7d44c87fc220a56d$var$load("ibLDR").then(()=>parcelRequire('eJTZN'));

});

parcelRegister("cZ7XF", function(module, exports) {

let $97415b81ba4d7090$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97415b81ba4d7090$var$load("eSjLl").then(()=>parcelRequire('gpAcV'));

});

parcelRegister("kBb5k", function(module, exports) {

let $efefdc9a3937c784$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $efefdc9a3937c784$var$load("fsYZ9").then(()=>parcelRequire('bSIfc'));

});

parcelRegister("5nro8", function(module, exports) {

let $3ea45873a0802e52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ea45873a0802e52$var$load("8ctIE").then(()=>parcelRequire('jdHij'));

});

parcelRegister("2FIQD", function(module, exports) {

let $1f2232f8de31b075$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1f2232f8de31b075$var$load("deDVS").then(()=>parcelRequire('kSVGc'));

});

parcelRegister("fkUqr", function(module, exports) {

let $b2a47e336513e43b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b2a47e336513e43b$var$load("fHVVl"),
    $b2a47e336513e43b$var$load("eOsfC"),
    $b2a47e336513e43b$var$load("41y4j"),
    $b2a47e336513e43b$var$load("cRLka")
]).then(()=>parcelRequire('dzxK2'));

});

parcelRegister("dW3Af", function(module, exports) {

let $a25378cba67d0fa1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a25378cba67d0fa1$var$load("4Pq08"),
    $a25378cba67d0fa1$var$load("fHVVl"),
    $a25378cba67d0fa1$var$load("lsUdZ")
]).then(()=>parcelRequire('hic1B'));

});

parcelRegister("8ii4s", function(module, exports) {

let $609e05ab29ee98b8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $609e05ab29ee98b8$var$load("6wr18"),
    $609e05ab29ee98b8$var$load("ffEVr"),
    $609e05ab29ee98b8$var$load("jEq9j")
]).then(()=>parcelRequire('fOJHU'));

});

parcelRegister("6IexO", function(module, exports) {

let $4e322253f34f8185$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4e322253f34f8185$var$load("6wHcy").then(()=>parcelRequire('4XBvZ'));

});

parcelRegister("25kjh", function(module, exports) {

let $184bcd8e43c6c7ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $184bcd8e43c6c7ff$var$load("6X4te").then(()=>parcelRequire('iohz2'));

});

parcelRegister("hM9MC", function(module, exports) {

let $cf0e821ea7aed751$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cf0e821ea7aed751$var$load("btN9S").then(()=>parcelRequire('fEzL3'));

});

parcelRegister("hJzUi", function(module, exports) {

let $ce927e04e9d1a0eb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ce927e04e9d1a0eb$var$load("eDwMS").then(()=>parcelRequire('4NkyW'));

});

parcelRegister("fKEim", function(module, exports) {

let $b77a68ac41f4ff86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b77a68ac41f4ff86$var$load("6Julb").then(()=>parcelRequire('6QvCO'));

});

parcelRegister("dEKuw", function(module, exports) {

let $9f1312f7bd919df5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9f1312f7bd919df5$var$load("2pJjh").then(()=>parcelRequire('bJ9yu'));

});

parcelRegister("ktbmc", function(module, exports) {

let $ee6f53565aa9b1ad$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee6f53565aa9b1ad$var$load("2E8Tp").then(()=>parcelRequire('jWGt9'));

});

parcelRegister("4ppH6", function(module, exports) {

let $335d6d930a66fba1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $335d6d930a66fba1$var$load("j2vqS").then(()=>parcelRequire('9WEcg'));

});

parcelRegister("3JYAC", function(module, exports) {

let $2b9492e6f5ab5ddc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2b9492e6f5ab5ddc$var$load("eI3Pe").then(()=>parcelRequire('bXTiq'));

});

parcelRegister("e2h8M", function(module, exports) {

let $a37e8c5e71763ca6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a37e8c5e71763ca6$var$load("c3Xws").then(()=>parcelRequire('1raVS'));

});

parcelRegister("jEK0N", function(module, exports) {

let $e4f571c1ef0a472d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e4f571c1ef0a472d$var$load("jAHQB").then(()=>parcelRequire('exnKR'));

});

parcelRegister("lpbUB", function(module, exports) {

let $f9552c3f2f313240$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f9552c3f2f313240$var$load("bWqOr").then(()=>parcelRequire('6lawT'));

});

parcelRegister("8vVIH", function(module, exports) {

let $632dfdfaa2dafd19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $632dfdfaa2dafd19$var$load("jn4AN").then(()=>parcelRequire('7Bf6V'));

});

parcelRegister("75hDZ", function(module, exports) {

let $5286afc04bb70363$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5286afc04bb70363$var$load("25i29").then(()=>parcelRequire('dzpj1'));

});

parcelRegister("5gsyW", function(module, exports) {

let $3d549a4baf5ab1b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d549a4baf5ab1b2$var$load("8RXIA").then(()=>parcelRequire('57esA'));

});

parcelRegister("3mkfb", function(module, exports) {

let $272321296d38a6f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $272321296d38a6f2$var$load("dJr2B").then(()=>parcelRequire('eJSzT'));

});

parcelRegister("9g76l", function(module, exports) {

let $6bdb1dd643190d9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6bdb1dd643190d9b$var$load("41fHN").then(()=>parcelRequire('6gdrU'));

});

parcelRegister("kWOwA", function(module, exports) {

let $f4006a947f654297$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4006a947f654297$var$load("4NyoM").then(()=>parcelRequire('a3jlE'));

});

parcelRegister("boBOk", function(module, exports) {

let $84bf440858ba0858$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $84bf440858ba0858$var$load("dtVPZ").then(()=>parcelRequire('csbni'));

});

parcelRegister("1piuw", function(module, exports) {

let $10667837635c93c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $10667837635c93c0$var$load("lzctT").then(()=>parcelRequire('c4L8g'));

});

parcelRegister("axfdb", function(module, exports) {

let $7ab8c92de09feb46$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7ab8c92de09feb46$var$load("dxcsb"),
    $7ab8c92de09feb46$var$load("99ObF"),
    $7ab8c92de09feb46$var$load("bor3G")
]).then(()=>parcelRequire('kftbw'));

});

parcelRegister("8lQWa", function(module, exports) {

let $61495917c2868522$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61495917c2868522$var$load("1sLXn").then(()=>parcelRequire('6hN70'));

});

parcelRegister("kZFpG", function(module, exports) {

let $f489a0f99a6e238b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f489a0f99a6e238b$var$load("ackvo").then(()=>parcelRequire('a13Ss'));

});

parcelRegister("gZ12D", function(module, exports) {

let $c5d326a4b713f72a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c5d326a4b713f72a$var$load("81e2B"),
    $c5d326a4b713f72a$var$load("dFc2X")
]).then(()=>parcelRequire('1nNva'));

});

parcelRegister("8tBhH", function(module, exports) {

let $62bdf4120ac1cab5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62bdf4120ac1cab5$var$load("fUtQM").then(()=>parcelRequire('6B5Dy'));

});

parcelRegister("byLio", function(module, exports) {

let $022bfe2beb4e0613$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $022bfe2beb4e0613$var$load("fukan").then(()=>parcelRequire('3eZwH'));

});

parcelRegister("9J73n", function(module, exports) {

let $714dc9adda75764e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $714dc9adda75764e$var$load("lJFkk").then(()=>parcelRequire('1oLmm'));

});

parcelRegister("i337n", function(module, exports) {

let $d23aecf3f8d425af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d23aecf3f8d425af$var$load("lgpJT").then(()=>parcelRequire('cs9Wl'));

});

parcelRegister("f2t7r", function(module, exports) {

let $af2da1564180ddbc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $af2da1564180ddbc$var$load("4g78a").then(()=>parcelRequire('kmdZx'));

});

parcelRegister("hR9tV", function(module, exports) {

let $cffebdc0c5eb661f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cffebdc0c5eb661f$var$load("d6YR9").then(()=>parcelRequire('240nf'));

});

parcelRegister("fwR83", function(module, exports) {

let $b4e30e78393562cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b4e30e78393562cb$var$load("hHSam").then(()=>parcelRequire('7hA6S'));

});

parcelRegister("d7RkC", function(module, exports) {

let $98e54c5d931a1e2f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98e54c5d931a1e2f$var$load("jHIhG").then(()=>parcelRequire('c2zwz'));

});

parcelRegister("kIno2", function(module, exports) {

let $f14a0ed502760c6b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f14a0ed502760c6b$var$load("dCZRz").then(()=>parcelRequire('623XT'));

});

parcelRegister("V1WU6", function(module, exports) {

let $0ab6d6077a07db40$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ab6d6077a07db40$var$load("jkdu5").then(()=>parcelRequire('C96uh'));

});

parcelRegister("9jEC9", function(module, exports) {

let $6c85648f9f821689$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6c85648f9f821689$var$load("3NrJC").then(()=>parcelRequire('ev4Ur'));

});

parcelRegister("dcKcJ", function(module, exports) {

let $99d03c96042c7a3e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99d03c96042c7a3e$var$load("iwBgR").then(()=>parcelRequire('jUK96'));

});

parcelRegister("4V82D", function(module, exports) {

let $3952b92a05cc1ec3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3952b92a05cc1ec3$var$load("jBe6c").then(()=>parcelRequire('4O0HL'));

});

parcelRegister("6n030", function(module, exports) {

let $4a34ed7d7ef9be48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a34ed7d7ef9be48$var$load("k9oRF").then(()=>parcelRequire('c2ZYW'));

});

parcelRegister("5GLk6", function(module, exports) {

let $42459561c25abf3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $42459561c25abf3f$var$load("csxiJ").then(()=>parcelRequire('790Fy'));

});

parcelRegister("8GpdS", function(module, exports) {

let $6525cfaf14100024$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6525cfaf14100024$var$load("6E0eQ").then(()=>parcelRequire('lI0w6'));

});

parcelRegister("e3Tx6", function(module, exports) {

let $a3cc6c2fd9d9de55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a3cc6c2fd9d9de55$var$load("dxcsb"),
    $a3cc6c2fd9d9de55$var$load("4flC1"),
    $a3cc6c2fd9d9de55$var$load("fDXJE"),
    $a3cc6c2fd9d9de55$var$load("lrpUd"),
    $a3cc6c2fd9d9de55$var$load("4LY4N"),
    $a3cc6c2fd9d9de55$var$load("5Zn6x")
]).then(()=>parcelRequire('98a0E'));

});

parcelRegister("5vi32", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    return (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("5kbLE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");


var $7L44N = parcelRequire("7L44N");


var $6U5eU = parcelRequire("6U5eU");


var $ll379 = parcelRequire("ll379");


var $cozmU = parcelRequire("cozmU");


var $fcLDg = parcelRequire("fcLDg");


var $jBS9T = parcelRequire("jBS9T");

const $a0d19ad2319e4e34$var$STABLE_OBJECT = {};
const $a0d19ad2319e4e34$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $cozmU.useMemo)(()=>(0, $6U5eU.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $1RMKR.useStableObject)(placementProps ?? $a0d19ad2319e4e34$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7L44N.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fcLDg.default), {
                    analyticsChannel: (0, $jBS9T.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
const $a0d19ad2319e4e34$var$PlacementMemoized = /*#__PURE__*/ (0, $cozmU.memo)($a0d19ad2319e4e34$var$Placement);
var $a0d19ad2319e4e34$export$2e2bcd8739ae039 = $a0d19ad2319e4e34$var$PlacementMemoized;
module.exports["default"] = $a0d19ad2319e4e34$export$2e2bcd8739ae039;

});

parcelRegister("7L44N", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f1G3w = parcelRequire("f1G3w");


var $8BQV6 = parcelRequire("8BQV6");


var $4QMIF = parcelRequire("4QMIF");


var $a33Aa = parcelRequire("a33Aa");


var $iQwJa = parcelRequire("iQwJa");


var $bGVJw = parcelRequire("bGVJw");


var $5h1mk = parcelRequire("5h1mk");


var $1RMKR = parcelRequire("1RMKR");


var $4OYR1 = parcelRequire("4OYR1");


var $gswTK = parcelRequire("gswTK");


var $9aSEF = parcelRequire("9aSEF");


var $4PX6o = parcelRequire("4PX6o");


var $3raeL = parcelRequire("3raeL");

const $17d7b5e1361d82f3$var$useInitialDataIfEnabled = (0, $gtMdU.isReactCompilerActivePlatform)() ? (placementId, context, baseUrl, path, disableInitialData)=>{
    const $ = (0, $bDgLe.c)(10);
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    let t0;
    if ($[0] !== context) {
        t0 = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
        $[0] = context;
        $[1] = t0;
    } else t0 = $[1];
    const arePlacementsGloballyDisabled = t0;
    let t1;
    if ($[2] !== arePlacementsGloballyDisabled || $[3] !== baseUrl || $[4] !== context || $[5] !== disableInitialData || $[6] !== fetcher.fetch || $[7] !== path || $[8] !== placementId) {
        t1 = arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        });
        $[2] = arePlacementsGloballyDisabled;
        $[3] = baseUrl;
        $[4] = context;
        $[5] = disableInitialData;
        $[6] = fetcher.fetch;
        $[7] = path;
        $[8] = placementId;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
} : (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $gswTK.usePlacementFetchingContext)();
    const arePlacementsGloballyDisabled = (0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context);
    return (0, $cozmU.useMemo)(()=>arePlacementsGloballyDisabled || disableInitialData ? undefined : (0, $4PX6o.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        arePlacementsGloballyDisabled,
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $17d7b5e1361d82f3$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $17d7b5e1361d82f3$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $17d7b5e1361d82f3$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $a33Aa.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $a33Aa.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $17d7b5e1361d82f3$var$Placement = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: t1, children: children } = t0;
    const disableInitialData = t1 === undefined ? false : t1;
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    let t2;
    if ($[0] !== context || $[1] !== postOfficeRoute) {
        t2 = {
            ...context,
            postOfficeRoute: postOfficeRoute
        };
        $[0] = context;
        $[1] = postOfficeRoute;
        $[2] = t2;
    } else t2 = $[2];
    const stableContextWithRoute = (0, $1RMKR.useStableObject)(t2);
    let t3;
    if ($[3] !== consumptionType || $[4] !== placementId) {
        t3 = new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType);
        $[3] = consumptionType;
        $[4] = placementId;
        $[5] = t3;
    } else t3 = $[5];
    const ufoV1PlacementTracker = t3;
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const t4 = ufoV2InteractionContext?.labelStack;
    let t5;
    if ($[6] !== t4 || $[7] !== ufoV2InteractionId.current) {
        t5 = {
            interactionId: ufoV2InteractionId.current,
            labelStack: t4
        };
        $[6] = t4;
        $[7] = ufoV2InteractionId.current;
        $[8] = t5;
    } else t5 = $[8];
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)(t5);
    let t6;
    if ($[9] !== consumptionType || $[10] !== placementId || $[11] !== placementOnEvent || $[12] !== stableUfoV2Interaction || $[13] !== ufoV1PlacementTracker) {
        t6 = (t7)=>{
            const { type: type, error: error } = t7;
            if (consumptionType === "local") {
                switch(type){
                    case "fetch-error":
                    case "component-error":
                    case "render-error":
                        $17d7b5e1361d82f3$var$handleUfoV2Error({
                            ufoV2Interaction: stableUfoV2Interaction,
                            placementId: placementId,
                            error: error,
                            errorEventType: type
                        });
                }
                return;
            }
            if (consumptionType === "remote") {
                placementOnEvent?.({
                    type: type,
                    error: error
                });
                bb29: switch(type){
                    case "fetch-complete":
                        ufoV1PlacementTracker?.markFetchComplete();
                        break bb29;
                    case "fetch-error":
                        ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "render-complete":
                        ufoV1PlacementTracker?.markRenderComplete();
                        break bb29;
                    case "render-error":
                        ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "initial-data-complete":
                        ufoV1PlacementTracker?.markInitialDataComplete();
                        break bb29;
                    case "initial-data-error":
                        ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "component-error":
                        ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                        break bb29;
                    case "component-ready":
                        ufoV1PlacementTracker?.markComponentReady();
                        break bb29;
                    case "unmount":
                        ufoV1PlacementTracker?.markComponentAborted();
                }
            }
        };
        $[9] = consumptionType;
        $[10] = placementId;
        $[11] = placementOnEvent;
        $[12] = stableUfoV2Interaction;
        $[13] = ufoV1PlacementTracker;
        $[14] = t6;
    } else t6 = $[14];
    const componentOnEvent = t6;
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    let t7;
    if ($[15] !== placementId) {
        t7 = {
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: "Placement",
            attributes: {
                placementId: placementId,
                channel: "in-app"
            }
        };
        $[15] = placementId;
        $[16] = t7;
    } else t7 = $[16];
    const placementAnalyticsContext = t7;
    let t8;
    if ($[17] !== children || $[18] !== componentOnEvent || $[19] !== initialData || $[20] !== stableContextWithRoute) {
        t8 = children({
            initialData: initialData,
            context: stableContextWithRoute,
            onEvent: componentOnEvent
        });
        $[17] = children;
        $[18] = componentOnEvent;
        $[19] = initialData;
        $[20] = stableContextWithRoute;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== placementAnalyticsContext || $[23] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1G3w.PostOfficeAnalyticsContext), {
            data: placementAnalyticsContext
        }, t8);
        $[22] = placementAnalyticsContext;
        $[23] = t8;
        $[24] = t9;
    } else t9 = $[24];
    return t9;
} : ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $5h1mk.usePostOfficeRoute)();
    const context = (0, $bGVJw.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $3raeL.useBuildBasePath)();
    const stableContextWithRoute = (0, $1RMKR.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $cozmU.useMemo)(()=>isUFOEnabled ? new (0, $4OYR1.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $cozmU.useContext)((0, $4QMIF.default));
    const ufoV2InteractionContext = (0, $cozmU.useContext)((0, $8BQV6.default));
    const stableUfoV2Interaction = (0, $1RMKR.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $cozmU.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    $17d7b5e1361d82f3$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($17d7b5e1361d82f3$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $17d7b5e1361d82f3$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $cozmU.useMemo)(()=>({
            source: (0, $9aSEF.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1G3w.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $17d7b5e1361d82f3$export$2e2bcd8739ae039 = $17d7b5e1361d82f3$var$Placement;
module.exports["default"] = $17d7b5e1361d82f3$export$2e2bcd8739ae039;

});

parcelRegister("9aSEF", function(module, exports) {
const $94018a62770928ba$export$85183a312807388d = 'postOffice';
const $94018a62770928ba$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $94018a62770928ba$export$f7109619a5e9e0d6;

});

parcelRegister("3raeL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $apw3A = parcelRequire("apw3A");


var $jdpvF = parcelRequire("jdpvF");

const $04b3f6e864eb8426$export$83d6c58b7ab7ae67 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(3);
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    let t0;
    if ($[0] !== postOfficeEnvironment.currentEnv || $[1] !== postOfficeEnvironment.envConfigs) {
        t0 = (0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs);
        $[0] = postOfficeEnvironment.currentEnv;
        $[1] = postOfficeEnvironment.envConfigs;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : ()=>{
    const postOfficeEnvironment = (0, $jdpvF.usePostOfficeEnvironment)();
    return (0, $cozmU.useMemo)(()=>(0, $apw3A.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $04b3f6e864eb8426$export$83d6c58b7ab7ae67;

});

parcelRegister("fcLDg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $lzgC6 = parcelRequire("lzgC6");


var $cozmU = parcelRequire("cozmU");

class $45465d036124c3a6$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
const $45465d036124c3a6$var$ErrorBoundaryWithAnalytics = (0, $lzgC6.default)()($45465d036124c3a6$var$ErrorBoundary);
var $45465d036124c3a6$export$2e2bcd8739ae039 = $45465d036124c3a6$var$ErrorBoundaryWithAnalytics;
module.exports["default"] = $45465d036124c3a6$export$2e2bcd8739ae039;

});

parcelRegister("jBS9T", function(module, exports) {
const $27b0c301be1a67fd$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $27b0c301be1a67fd$export$85183a312807388d;

});

parcelRegister("7ZO1y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gswTK = parcelRequire("gswTK");


var $hGIXv = parcelRequire("hGIXv");

const $785b1547b9a94f27$export$9be10e5cc29463c9 = ({ children: children })=>{
    const fetch = (0, $hGIXv.usePlacementSSRFetch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gswTK.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
module.exports["PlacementFetchProvider"] = $785b1547b9a94f27$export$9be10e5cc29463c9;

});

parcelRegister("b3j2Y", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");

function $ff81fbcf85bdaf85$export$d56b0569bceb92ae(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { children: children, error: error } = t0;
    const [errorListenerIsReady, setErrorListenerIsReady] = (0, $cozmU.useState)(false);
    let t1;
    let t2;
    if ($[0] !== error) {
        t1 = ()=>{
            const listener = (event)=>{
                if (event.error === error) event.preventDefault();
            };
            window.addEventListener("error", listener);
            setErrorListenerIsReady(true);
            return ()=>{
                window.removeEventListener("error", listener);
                setErrorListenerIsReady(false);
            };
        };
        t2 = [
            error,
            setErrorListenerIsReady
        ];
        $[0] = error;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = (_)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    const renderOnError = t3;
    let t4;
    if ($[5] !== error || $[6] !== errorListenerIsReady) {
        t4 = errorListenerIsReady ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff81fbcf85bdaf85$export$4d51f41a5e7cc382, {
            error: error
        }) : null;
        $[5] = error;
        $[6] = errorListenerIsReady;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== renderOnError || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).INHERIT,
            renderOnError: renderOnError
        }, t4);
        $[8] = renderOnError;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
}
function $ff81fbcf85bdaf85$export$4d51f41a5e7cc382({ error: error }) {
    throw error;
}
module.exports["ErrorDisplay"] = $ff81fbcf85bdaf85$export$d56b0569bceb92ae;

});

parcelRegister("8MKuN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a33Aa = parcelRequire("a33Aa");


var $jb2gB = parcelRequire("jb2gB");

const $88668855474bc367$export$27cee8d00af73bce = [
    'edit-page.page_load',
    'edit-page.transition',
    'space-overview-edit-page.page_load',
    'space-overview-edit-page.transition',
    'live-edit.page_load',
    'live-edit.transition'
];
function $88668855474bc367$export$2510d15b8c74a469({ children: children, excludedInteractions: excludedInteractions = $88668855474bc367$export$27cee8d00af73bce }) {
    // Capture the interaction once at mount time to ensure stable behavior for the
    // component's lifetime. getActiveInteraction() can return null mid-render cycle
    // if the UFO interaction ends, which would cause the ignore prop to toggle
    // between renders and effectively un-ignore the hold on a subsequent re-render.
    const ignoreHoldsRef = (0, $cozmU.useRef)(null);
    if (ignoreHoldsRef.current === null) {
        const interaction = (0, $a33Aa.getActiveInteraction)();
        if (interaction) {
            const { type: type, ufoName: ufoName } = interaction;
            ignoreHoldsRef.current = excludedInteractions.includes(`${ufoName}.${type}`);
        } else ignoreHoldsRef.current = false;
    }
    const ignoreHolds = ignoreHoldsRef.current ?? false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jb2gB.default), {
        ignore: ignoreHolds
    }, children);
}
module.exports["ConditionalUfoHoldIgnore"] = $88668855474bc367$export$2510d15b8c74a469;

});

parcelRegister("aDyoj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");





var $8NccQ = parcelRequire("8NccQ");


var $dYn3u = parcelRequire("dYn3u");


var $gqUuL = parcelRequire("gqUuL");


var $852mP = parcelRequire("852mP");

const $08452e6d6a4098ea$export$91b4dd3bfc301325 = (analyticsClient)=>{
    return (event)=>{
        return Promise.resolve(analyticsClient).then((client)=>{
            switch(event.eventType){
                case 0, $852mP.UI_EVENT_TYPE:
                    client.sendUIEvent(event);
                    break;
                case 0, $852mP.TRACK_EVENT_TYPE:
                    client.sendTrackEvent(event);
                    break;
                case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $852mP.SCREEN_EVENT_TYPE:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};


// Copied from xflow-ui. We post raw analytics events (context and payload only) from xflow-ui to consumer (CFE), transform on consumer and post to gasv3.



const $39100ae7653d17e4$var$GROWTH_TAG = 'growth';
const $39100ae7653d17e4$var$extractFromEventContext = (propertyNames, context)=>context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $39100ae7653d17e4$var$getSources = (context)=>$39100ae7653d17e4$var$extractFromEventContext([
        'source'
    ], context);
const $39100ae7653d17e4$var$getExtraAttributes = (context)=>context.reduce((ans, { attributes: attributes, ...contextProps })=>{
        const newAttributes = {
            ...ans,
            ...contextProps
        };
        return attributes ? {
            ...newAttributes,
            ...attributes
        } : newAttributes;
    }, {});
const $39100ae7653d17e4$var$getPackageInfo = (context)=>context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $39100ae7653d17e4$var$last = (values)=>values[values.length - 1];
const $39100ae7653d17e4$export$3f40e8c44448be30 = (event)=>{
    const { context: context, payload: payload } = event;
    if (!payload) return null;
    const sources = $39100ae7653d17e4$var$getSources(context);
    const source = $39100ae7653d17e4$var$last(sources) || (0, $852mP.DEFAULT_SOURCE);
    const extraAttributes = $39100ae7653d17e4$var$getExtraAttributes(context);
    const { packageName: packageName, packageVersion: packageVersion } = $39100ae7653d17e4$var$last($39100ae7653d17e4$var$getPackageInfo(context)) || {};
    const { eventType: eventType = (0, $852mP.UI_EVENT_TYPE), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = payload;
    const attributes = {
        packageName: packageName,
        packageVersion: packageVersion,
        ...extraAttributes,
        ...payloadAttributes
    };
    const tags = payload.tags || [];
    tags.push($39100ae7653d17e4$var$GROWTH_TAG);
    switch(eventType){
        case 0, $852mP.UI_EVENT_TYPE:
        case 0, $852mP.OPERATIONAL_EVENT_TYPE:
        case 0, $852mP.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $852mP.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};





const $59a3e79e459608db$export$b4d5da5f34fb77ad = 'crossFlowProvider';
const $59a3e79e459608db$export$9d8252a268f4fa72 = 'errorCaught';
const $59a3e79e459608db$export$1045419caf49b395 = 'errorBoundary';
const $59a3e79e459608db$export$d54c183f56e39aa5 = 'crossFlowSupport';
const $59a3e79e459608db$export$e5c2c058fa8068a6 = 'uiInitialized';
const $59a3e79e459608db$export$e67cdcb8867a3bd0 = 'openInvoked';




const $f4edb280b529d91a$var$version = "0.0.0-use.local";
const $f4edb280b529d91a$export$84f9cf7ef89d4c26 = {
    version: $f4edb280b529d91a$var$version
};
const $f4edb280b529d91a$export$59518efab336a8b5 = (event)=>{
    const attributes = {
        ...event.attributes || {},
        crossFlowSupport: $f4edb280b529d91a$export$84f9cf7ef89d4c26
    };
    return {
        ...event,
        attributes: attributes
    };
};


const $2d56ab819e6936bb$export$a5a156dc5df42f0 = (event, requestOptions)=>{
    if (!requestOptions) return event;
    const attributes = {
        // Spread the extra analytics attributes first, because we don't want consumers to override any event attributes below
        ...requestOptions.extraAnalyticsAttributes || {},
        ...event.attributes || {},
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    };
    return {
        ...event,
        attributes: attributes
    };
};








const $2afc09defa936d50$var$name = "platform-pkg";
const $2afc09defa936d50$var$version = "0.0.0-use.local";
const $2afc09defa936d50$var$payload = {
    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
    action: (0, $59a3e79e459608db$export$9d8252a268f4fa72),
    actionSubject: (0, $59a3e79e459608db$export$1045419caf49b395)
};
const $2afc09defa936d50$var$context = [
    {
        source: $59a3e79e459608db$export$b4d5da5f34fb77ad
    },
    {
        packageName: $2afc09defa936d50$var$name,
        packageVersion: $2afc09defa936d50$var$version
    }
];
class $2afc09defa936d50$export$e926676385687eaf extends (0, $cozmU.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        this.props.onAnalyticsEvent({
            payload: $2afc09defa936d50$var$payload,
            context: $2afc09defa936d50$var$context
        });
        if (this.props.onError) this.props.onError(error);
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}



var $3qdJ0 = parcelRequire("3qdJ0");

var $4b58641a5d50fe20$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});


const $dcb4e29cfd63a6dd$export$c37558e5c67d2b01 = 'https://qa-wac.internal.atlassian.com';
const $dcb4e29cfd63a6dd$export$f199baf8dfc7621e = 'https://www.atlassian.com';
const $dcb4e29cfd63a6dd$export$fb1e43fdafe12e9b = '/software/opsgenie/try';
const $dcb4e29cfd63a6dd$export$e6c04a1dd86d1c14 = '/try/cloud/signup';
const $dcb4e29cfd63a6dd$export$2a45a00073911255 = '/software';


const $f5471fd49a9d2c96$var$utmCampaignMap = {
    'atlassian-switcher': (0, $4b58641a5d50fe20$export$fc604aa353a97e10)['atlassian-switcher']
};
const $f5471fd49a9d2c96$var$isBundledProduct = (productKey)=>{
    return [
        (0, $3qdJ0.Targets).JIRA_SOFTWARE,
        (0, $3qdJ0.Targets).JIRA_SERVICE_DESK,
        (0, $3qdJ0.Targets).JIRA_CORE,
        (0, $3qdJ0.Targets).CONFLUENCE
    ].includes(productKey);
};
const $f5471fd49a9d2c96$var$getBundleSignUpParams = (productKey)=>{
    const bundles = {
        [(0, $3qdJ0.Targets).JIRA_SOFTWARE]: 'jira-software',
        [(0, $3qdJ0.Targets).JIRA_SERVICE_DESK]: 'jira-service-desk',
        [(0, $3qdJ0.Targets).JIRA_CORE]: 'jira-core',
        [(0, $3qdJ0.Targets).CONFLUENCE]: 'confluence'
    };
    // Bundles default to free
    return `bundle=${bundles[productKey]}&edition=free`;
};
const $f5471fd49a9d2c96$var$isProductWithCustomSignUpPath = (productKey)=>{
    return [
        (0, $3qdJ0.Targets).OPSGENIE
    ].includes(productKey);
};
const $f5471fd49a9d2c96$var$getProductCustomSignUpPath = (productKey)=>{
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    const links = {
        [(0, $3qdJ0.Targets).OPSGENIE]: (0, $dcb4e29cfd63a6dd$export$fb1e43fdafe12e9b)
    };
    return links[productKey];
};
const $f5471fd49a9d2c96$var$isSourceComponentWithUtmParams = (sourceComponent)=>{
    return Boolean($f5471fd49a9d2c96$var$utmCampaignMap[sourceComponent]);
};
const $f5471fd49a9d2c96$var$getUtmParams = (sourceComponent, sourceContext)=>{
    let utmParams = '';
    if (sourceComponent && $f5471fd49a9d2c96$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + `utm_campaign=${$f5471fd49a9d2c96$var$utmCampaignMap[sourceComponent]}&utm_medium=in_product_ad`;
        if (sourceContext) utmParams = utmParams + `&utm_source=${sourceContext}`;
    }
    return utmParams;
};
const $f5471fd49a9d2c96$export$39eab502fc96327d = (productKey, env, sourceComponent, sourceContext)=>{
    const wacUrl = env === 'staging' ? (0, $dcb4e29cfd63a6dd$export$c37558e5c67d2b01) : (0, $dcb4e29cfd63a6dd$export$f199baf8dfc7621e);
    const utmParams = $f5471fd49a9d2c96$var$getUtmParams(sourceComponent, sourceContext);
    let queryParams = '';
    let bundleParams = '';
    let path = (0, $dcb4e29cfd63a6dd$export$2a45a00073911255);
    if ($f5471fd49a9d2c96$var$isBundledProduct(productKey)) {
        path = (0, $dcb4e29cfd63a6dd$export$e6c04a1dd86d1c14);
        bundleParams = $f5471fd49a9d2c96$var$getBundleSignUpParams(productKey);
    } else if ($f5471fd49a9d2c96$var$isProductWithCustomSignUpPath(productKey)) path = $f5471fd49a9d2c96$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + `?${bundleParams}`;
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? '&' : '?') + utmParams;
    return wacUrl + path + queryParams;
};
const $f5471fd49a9d2c96$export$2827e2473cb9a346 = (productKey, env = 'production', sourceComponent, sourceContext)=>{
    const url = $f5471fd49a9d2c96$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, '_blank');
};



var $7oSFe = parcelRequire("7oSFe");


const $55aa4af0e198d81c$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy((0, $7oSFe.trackReactLazy)("rl-poFejx", ()=>(parcelRequire("eH04Z"))));
const $55aa4af0e198d81c$export$79d79d8dd8574306 = (IntegrationView)=>(props)=>{
        const { children: children, analyticsClient: analyticsClient, originProduct: originProduct, redirectToWac: redirectToWac, env: env, plugins: plugins = [], globalExperimentalOptions: globalExperimentalOptions, onError: onError, ...baseProviderProps } = props;
        const onCloseResolver = (0, $cozmU.useRef)();
        const [firstHandshakeReceived, setFirstHandshakeReceived] = (0, $cozmU.useState)(false);
        const fireEvent = (0, $cozmU.useMemo)(()=>(0, $08452e6d6a4098ea$export$91b4dd3bfc301325)(analyticsClient), [
            analyticsClient
        ]);
        const [requestOptions, setRequestOptions] = (0, $cozmU.useState)();
        const onAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
            const gasV3Event = (0, $39100ae7653d17e4$export$3f40e8c44448be30)(payload);
            if (gasV3Event) {
                const enrichedEvent = (0, $2d56ab819e6936bb$export$a5a156dc5df42f0)((0, $f4edb280b529d91a$export$59518efab336a8b5)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        const onHandShake = (0, $cozmU.useCallback)((appName)=>{
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                        action: (0, $59a3e79e459608db$export$e5c2c058fa8068a6),
                        actionSubject: (0, $59a3e79e459608db$export$d54c183f56e39aa5),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: $59a3e79e459608db$export$b4d5da5f34fb77ad
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        const onOpen = (0, $cozmU.useCallback)((options)=>{
            /**
     * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
     * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
     */ setFirstHandshakeReceived(false);
            const analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $2d56ab819e6936bb$export$a5a156dc5df42f0)({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    action: (0, $59a3e79e459608db$export$e67cdcb8867a3bd0),
                    actionSubject: (0, $59a3e79e459608db$export$d54c183f56e39aa5)
                }, options),
                context: [
                    {
                        source: $59a3e79e459608db$export$b4d5da5f34fb77ad
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $dYn3u.Journeys).GET_STARTED && redirectToWac) {
                (0, $f5471fd49a9d2c96$export$2827e2473cb9a346)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                const completionStatus = {};
                return Promise.resolve(completionStatus);
            }
            const updatedExperimentalOptions = {
                ...globalExperimentalOptions || {},
                // "globalExperimentalOptions" will be injected to EVERY crossFlow invoke
                ...options.experimentalOptions || {} // "options.experimentalOptions" takes care of passing experimentalOptions to ONE specific crossFlow invoke
            };
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise((resolve)=>{
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        const onClose = (0, $cozmU.useCallback)((completionStatus)=>{
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        const { colorMode: colorMode } = (0, $gqUuL.getGlobalTheme)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8NccQ.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2afc09defa936d50$export$e926676385687eaf), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IntegrationView, {
            ...baseProviderProps,
            ...requestOptions,
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            zIndex: requestOptions.zIndex ?? 1000
        }))));
    };
const $55aa4af0e198d81c$export$d900e4062895cd7c = $55aa4af0e198d81c$export$79d79d8dd8574306($55aa4af0e198d81c$var$IntegrationView);



const $f277a6ccc9f41939$var$ConfluenceProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55aa4af0e198d81c$export$d900e4062895cd7c), {
            ...props,
            originProduct: "confluence"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55aa4af0e198d81c$export$d900e4062895cd7c), {
        ...props,
        originProduct: "confluence"
    });
};
var $f277a6ccc9f41939$export$2e2bcd8739ae039 = $f277a6ccc9f41939$var$ConfluenceProvider;
module.exports["default"] = $f277a6ccc9f41939$export$2e2bcd8739ae039;

});

parcelRegister("8NccQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $h9Y0D = parcelRequire("h9Y0D");


var $6j5v3 = parcelRequire("6j5v3");


var $dYn3u = parcelRequire("dYn3u");

const $95842fb34f191a76$var$LATEST_VERSION = (0, $6j5v3.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ const $95842fb34f191a76$var$CrossFlowContext = /*#__PURE__*/ (0, $cozmU.createContext)(()=>({
        isEnabled: false,
        reason: (0, $dYn3u.Reasons).NO_PROVIDER
    }));
const $95842fb34f191a76$export$59ce2d27e6cd8c9 = (onOpen)=>(version)=>{
        switch(version){
            case 0, $6j5v3.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $h9Y0D.createAPIv0)(onOpen),
                    apiV1: (0, $6j5v3.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $dYn3u.Reasons).NO_API_SUPPORT
                };
        }
    };
const $95842fb34f191a76$export$c0ddec072762f62a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { onOpen: onOpen, children: children } = t0;
    let t1;
    if ($[0] !== onOpen) {
        t1 = $95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen);
        $[0] = onOpen;
        $[1] = t1;
    } else t1 = $[1];
    const negotiateApi = t1;
    let t2;
    if ($[2] !== children || $[3] !== negotiateApi) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
            value: negotiateApi
        }, children);
        $[2] = children;
        $[3] = negotiateApi;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ onOpen: onOpen, children: children })=>{
    const negotiateApi = (0, $cozmU.useMemo)(()=>$95842fb34f191a76$export$59ce2d27e6cd8c9(onOpen), [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($95842fb34f191a76$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
const $95842fb34f191a76$export$6e7a10fe635a0dfc = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    let t0;
    if ($[0] !== negotiateApi) {
        t0 = negotiateApi($95842fb34f191a76$var$LATEST_VERSION);
        $[0] = negotiateApi;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const negotiateApi = (0, $cozmU.useContext)($95842fb34f191a76$var$CrossFlowContext);
    return (0, $cozmU.useMemo)(()=>negotiateApi($95842fb34f191a76$var$LATEST_VERSION), [
        negotiateApi
    ]);
};
function $95842fb34f191a76$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    const ComponentWithCrossFlow = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(3);
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        let t0;
        if ($[0] !== crossFlow || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...props,
                crossFlow: crossFlow
            });
            $[0] = crossFlow;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const crossFlow = $95842fb34f191a76$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            crossFlow: crossFlow
        });
    };
    ComponentWithCrossFlow.displayName = `withCrossFlow(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    return ComponentWithCrossFlow;
}
module.exports["BaseCrossFlowApiProvider"] = $95842fb34f191a76$export$c0ddec072762f62a;
module.exports["useCrossFlow"] = $95842fb34f191a76$export$6e7a10fe635a0dfc;
module.exports["withCrossFlow"] = $95842fb34f191a76$export$655b6c19a0daddb8;

});

parcelRegister("h9Y0D", function(module, exports) {
const $dac2ee632762edd0$export$a4ad2735b021c132 = 0;
const $dac2ee632762edd0$export$9ff7368ac93fcf2d = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["createAPIv0"] = $dac2ee632762edd0$export$9ff7368ac93fcf2d;

});

parcelRegister("6j5v3", function(module, exports) {
const $146c188c19063c17$export$a4ad2735b021c132 = 1;
const $146c188c19063c17$export$8fd5792fc468459f = (onOpen)=>({
        open (options) {
            return onOpen(options);
        }
    });
module.exports["VERSION"] = $146c188c19063c17$export$a4ad2735b021c132;
module.exports["createAPIv1"] = $146c188c19063c17$export$8fd5792fc468459f;

});

parcelRegister("dYn3u", function(module, exports) {
const $f5b6049530406f9f$export$3411873bfd520bb6 = {
    GET_STARTED: 'get-started',
    DECIDE: 'decide',
    DISCOVER: 'discover'
};
const $f5b6049530406f9f$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: 'Could not provide requested API version',
    NO_PROVIDER: 'Provider not found'
};
module.exports["Journeys"] = $f5b6049530406f9f$export$3411873bfd520bb6;
module.exports["Reasons"] = $f5b6049530406f9f$export$da2d4f2f250d6f84;

});

parcelRegister("3qdJ0", function(module, exports) {
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ const $8c8615b3f214c36e$export$59a8eb9cff113544 = {
    CONFLUENCE: 'confluence.ondemand',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    JIRA_CUSTOMER_SERVICE: 'jira-customer-service',
    BITBUCKET: 'bitbucket.ondemand',
    TRELLO: 'trello',
    OPSGENIE: 'opsgenie',
    STATUSPAGE: 'statuspage',
    /**
	 * @private
	 * @deprecated Use ATLAS instead
	 */ TEAM_CENTRAL: 'townsquare',
    ATLAS: 'townsquare',
    /**
	 * @private
	 * @deprecated
	 */ AVOCADO: 'avocado',
    ANALYTICS: 'atlassian-analytics-free',
    COMPASS: 'compass',
    LOOM: 'loom',
    ROVO: 'rovo.ondemand',
    TEAMWORK_COLLECTION: 'teamwork-collection'
};
module.exports["Targets"] = $8c8615b3f214c36e$export$59a8eb9cff113544;

});

parcelRegister("eH04Z", function(module, exports) {

let $ab25249fce44814d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ab25249fce44814d$var$load("i0Zk0"),
    $ab25249fce44814d$var$load("i5oVl")
]).then(()=>parcelRequire('eUM4P'));

});

parcelRegister("lsxnT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $cozmU.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $cozmU.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $cozmU.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    ChoreographedComponent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightTarget: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("hSHWm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $d1e7679282bf3961$export$8b4809eaf655f286 = /*#__PURE__*/ (0, $cozmU.createContext)({});
module.exports["CoreInvitesContext"] = $d1e7679282bf3961$export$8b4809eaf655f286;

});

parcelRegister("3fP9Q", function(module, exports) {

let $25ea74b2d12151b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $25ea74b2d12151b5$var$load("gQrOI"),
    $25ea74b2d12151b5$var$load("2xoIF"),
    $25ea74b2d12151b5$var$load("gpUln"),
    $25ea74b2d12151b5$var$load("hE9re"),
    $25ea74b2d12151b5$var$load("lrXQY"),
    $25ea74b2d12151b5$var$load("dnOT2"),
    $25ea74b2d12151b5$var$load("aqBOp"),
    $25ea74b2d12151b5$var$load("b3yRn"),
    $25ea74b2d12151b5$var$load("7zPi7")
]).then(()=>parcelRequire('MVtCj'));

});

parcelRegister("koZ31", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ var $6a2b9fa9e63188b2$export$1ba03842b7d3a654 = /*#__PURE__*/ function(CoreInvitesSource) {
    CoreInvitesSource["UNKNOWN"] = "unknown";
    CoreInvitesSource["MENTION"] = "mention";
    CoreInvitesSource["PEOPLE_MENU"] = "peopleMenu";
    CoreInvitesSource["ONBOARDING_INVITE_FLAG"] = "onboarding-invite-flag";
    CoreInvitesSource["PERSISTENT_INVITE_PAGETREE"] = "pageTree";
    CoreInvitesSource["PERSISTENT_INVITE_HOMESCREEN"] = "homeScreen";
    CoreInvitesSource["CONTEXTUAL_INVITE_NUDGE"] = "onboarding-contextual-invite-nudge";
    CoreInvitesSource["LIVE_PAGES_NUDGE"] = "onboarding-contextual-invite-live-pages-nudge";
    CoreInvitesSource["SHARE_DIALOG"] = "share-dialog";
    CoreInvitesSource["SHARE_AND_RESTRICT_DIALOG"] = "share-and-restrict-dialog";
    CoreInvitesSource["IBO_TAKEOVER_INVITE"] = "onboarding-takeover-invite-people";
    CoreInvitesSource["EA_DROPDOWN"] = "ea-dropdown";
    CoreInvitesSource["HOME_ONBOARDING_TAKEOVER_V2"] = "home-onboarding-takeover-v2";
    CoreInvitesSource["CROSS_JOIN"] = "virality-cross-join";
    CoreInvitesSource["OPEN_MODAL_QUERY_PARAM"] = "open-modal-query-param";
    return CoreInvitesSource;
}({});
module.exports["CoreInvitesSource"] = $6a2b9fa9e63188b2$export$1ba03842b7d3a654;

});

parcelRegister("hrAmX", function(module, exports) {

var $a4dgs = parcelRequire("a4dgs");


var $8zRYE = parcelRequire("8zRYE");


var $jecot = parcelRequire("jecot");

const $6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME = 'ServerRenderedBanners';
const $6ee3834dea9f6c5c$export$f7df67e8f3ba0620 = (name, inArray)=>inArray.findIndex((banner)=>banner.name === name);
class $6ee3834dea9f6c5c$export$bbac707b3ebb5681 extends (0, $a4dgs.BaseStateContainer) {
    constructor(props = {}){
        super();
        // Resolved unconditionally, even when it is about to be discarded, so that exposure for the
        // nav-height flags is unchanged from before this was extracted into a helper.
        /** Frozen at construction: a mid-session flag flip must not change an instance's arithmetic. */ this.topNavHeight = void 0;
        this.suppressed = void 0;
        this.pendingNotify = null;
        this.unsubscribeFromStore = null;
        this.state = {
            banners: []
        };
        this._updateServerRenderedBanners = (spaBannerHeight)=>{
            if (spaBannerHeight === 0) this.hide($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME);
            else this.show($6ee3834dea9f6c5c$var$SERVER_RENDER_BANNER_NAME, spaBannerHeight);
        };
        /**
     * Adds or updates the specified banner in the list of visible banners.
     * Add the banner is not already in the list, otherwise update the banner's height.
     * Applied on the next microtask; a suppressed container drops the write entirely.
     *
     * @param {string} name Unique name of the banner
     * @param {number} height Height of the banner, in pixels
     */ this.show = (name, height)=>{
            if (this.suppressed) return;
            (0, $8zRYE.showBanner)(name, height);
        };
        /**
     * Removes the specified banner from the list of visible banners
     * Remove the banner if it is in the list, do nothing it is not
     *
     * @param {string} name Unique name of the banner
     */ this.hide = (name)=>{
            if (this.suppressed) return;
            (0, $8zRYE.hideBanner)(name);
        };
        /**
     * Returns the combined height of all banners in the list.
     * @param {boolean} includeTopNav Include `TOP_NAV_HEIGHT` in the calculation
     * if not `false`
     * @returns {number} Combined height of all visible banners
     */ this.getTotalHeight = (includeTopNav)=>this.state.banners.reduce((totalOffset, banner)=>totalOffset + banner.height, includeTopNav !== false ? this.topNavHeight : 0);
        /**
     * Returns list of all banners in visible list in "-" seperated string.
     * @returns {string} Combined names of all banners in visible list seperated by "-"
     */ this.getBannerList = ()=>this.state.banners.map((banner)=>banner.name).join('-');
        /**
     * Detaches from the store. unstated gives containers no teardown hook, so any caller that creates
     * short-lived containers — fixtures, tests, anything mounted more than once — must call this, or
     * the store keeps the listener and with it this instance alive for the lifetime of the module.
     */ this.destroy = ()=>{
            this.unsubscribeFromStore?.();
            this.unsubscribeFromStore = null;
        };
        this.scheduleNotify = ()=>{
            if (this.pendingNotify) return;
            this.pendingNotify = Promise.resolve().then(()=>{
                this.pendingNotify = null;
                return this.notifyListeners();
            });
        };
        const navHeight = (0, $jecot.resolveTopNavHeight)();
        this.topNavHeight = props.hasTopNav === false ? 0 : navHeight;
        this.suppressed = props.suppressed === true;
        if (this.suppressed) return;
        (0, $8zRYE.seedBanners)(props.initialState?.banners ?? []);
        this.state = {
            banners: (0, $8zRYE.getBanners)()
        };
        // The mirror is synchronous so a read straight after a flush is fresh; the notification is
        // coalesced, so a tick's worth of store changes costs one round no matter which container
        // (or hook) wrote them.
        this.unsubscribeFromStore = (0, $8zRYE.subscribeToBanners)(()=>{
            this.state = {
                banners: (0, $8zRYE.getBanners)()
            };
            this.scheduleNotify();
        });
    }
}
module.exports["findBanner"] = $6ee3834dea9f6c5c$export$f7df67e8f3ba0620;
module.exports["BannerStateContainer"] = $6ee3834dea9f6c5c$export$bbac707b3ebb5681;

});

parcelRegister("a4dgs", function(module, exports) {
// unstated is deprecated; new banner state belongs in src/bannerStore.ts
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

class $5ed4587dbe3a0e20$export$5db0f71585d91cd4 extends (0, $kNIYN.Container) {
    subscribe(fn) {
        this.listeners.add(fn);
    }
    unsubscribe(fn) {
        this.listeners.delete(fn);
    }
    setState(updater, callback) {
        return Promise.resolve().then(()=>{
            const next = typeof updater === 'function' ? updater(this.state) : updater;
            if (next == null) {
                callback?.();
                return;
            }
            this.state = Object.assign({}, this.state, next);
            return this.notifyListeners().then(()=>{
                callback?.();
            });
        });
    }
    notifyListeners() {
        // Snapshot before notifying: a listener's re-render makes unstated's Subscribe unsubscribe
        // and resubscribe, which would mutate the Set mid-iteration.
        const snapshot = Array.from(this.listeners);
        return Promise.all(snapshot.map((listener)=>listener())).then(()=>undefined);
    }
    constructor(...args){
        super(...args);
        this.listeners = new Set();
    }
}
module.exports["BaseStateContainer"] = $5ed4587dbe3a0e20$export$5db0f71585d91cd4;

});

parcelRegister("8zRYE", function(module, exports) {

var $i3jcY = parcelRequire("i3jcY");

/**
 * Module store for the page-top banner stack, read through `useSyncExternalStore`.
 *
 * A module store, not a library: see `docs/llm/agent-instructions/common/state-management.md`.
 *
 * Writes are deferred to a microtask and coalesced here rather than in any caller, so every writer —
 * the container shim and the `useBannerState` hooks — inherits it. Notification is synchronous and
 * several banners still call `show`/`hide` from a render body, so an undeferred write would update
 * other components mid-render.
 *
 * Global and unscoped: only three production containers exist — the client root, the SSR root
 * (mutually exclusive with it), and `WithoutBanners`, which is write-free and read-once.
 *
 * SSR: Tesseract isolates each request, so module state is per-request. `handleReactRender.tsx`
 * serialises the server's list into `window.__SSR_BANNERS__`, which this store reads at module init,
 * so the first render — including the hydrating one — matches the server without waiting on a
 * container. The server has no such global, so its seed is an explicit `seedBanners` call from the
 * SSR entry point; that keeps `ssrBannerManager` out of this module.
 *
 * `stableUI=1` (E2E/VR runs) is honoured here, at all three entry points that can change `banners`,
 * rather than in each writer: `ssrBannerManager` registers banners regardless of the URL param, so
 * an unguarded hydration seed would give a hydrating render banners the SSR render dropped, and the
 * `useBannerState` hooks never see the param at all.
 */ /** Frozen so a consumer cannot mutate it, and stable so `getSnapshot` never triggers a re-render. */ const $827d62b6188a5818$var$NO_BANNERS = Object.freeze([]);
/**
 * Read at module init rather than from a component, so the store is populated before anything
 * renders. Entries are validated because the value is deserialised from the page.
 *
 * No `typeof window` guard: the build substitutes `globalThis`, so `window` is always defined in both
 * environments. On the server the property simply is not set, which the `Array.isArray` check already
 * covers — the server seed comes from `seedBanners` instead.
 */ const $827d62b6188a5818$var$readHydrationBanners = ()=>{
    // `Array.isArray` is deliberately first: it short-circuits on the server, where the global is
    // never set, so the request URI — not available this early in module evaluation — is never read.
    if (!Array.isArray(window.__SSR_BANNERS__) || (0, $i3jcY.isStableUIEnabledForTests)()) return $827d62b6188a5818$var$NO_BANNERS;
    const parsed = window.__SSR_BANNERS__.filter((banner)=>typeof banner?.name === 'string' && typeof banner?.height === 'number');
    return parsed.length > 0 ? parsed : $827d62b6188a5818$var$NO_BANNERS;
};
let $827d62b6188a5818$var$banners = $827d62b6188a5818$var$readHydrationBanners();
const $827d62b6188a5818$var$listeners = new Set();
const $827d62b6188a5818$export$49fd326b255f6ddb = ()=>$827d62b6188a5818$var$banners;
const $827d62b6188a5818$export$7cfac2c025b473e4 = (listener)=>{
    $827d62b6188a5818$var$listeners.add(listener);
    return ()=>{
        $827d62b6188a5818$var$listeners.delete(listener);
    };
};
const $827d62b6188a5818$var$commit = (next)=>{
    $827d62b6188a5818$var$banners = next;
    // Snapshot first: a listener may unsubscribe while being notified.
    Array.from($827d62b6188a5818$var$listeners).forEach((listener)=>listener());
};
let $827d62b6188a5818$var$pending = [];
let $827d62b6188a5818$var$pendingFlush = null;
const $827d62b6188a5818$var$enqueue = (mutate)=>{
    // Evaluated per call rather than memoised at module init: an SPA transition changes
    // `window.location.search`, so the param is not a session constant.
    // Hides are dropped along with shows, which is safe because nothing can enter the store.
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    $827d62b6188a5818$var$pending.push(mutate);
    if ($827d62b6188a5818$var$pendingFlush) return;
    $827d62b6188a5818$var$pendingFlush = Promise.resolve().then(()=>{
        $827d62b6188a5818$var$pendingFlush = null;
        const queued = $827d62b6188a5818$var$pending;
        $827d62b6188a5818$var$pending = [];
        let next = $827d62b6188a5818$var$banners;
        let changed = false;
        for (const run of queued){
            // Applied against the running value, not the pre-flush one, so a name shown twice in a tick
            // resolves against the first write rather than duplicating.
            const result = run(next);
            if (result === undefined) continue;
            next = result;
            changed = true;
        }
        if (changed) $827d62b6188a5818$var$commit(next);
    });
};
const $827d62b6188a5818$export$f5c0eb035ef26e87 = (name, height)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return [
            ...current,
            {
                name: name,
                height: height
            }
        ];
        if (current[index].height !== height) {
            const next = [
                ...current
            ];
            // Replace rather than mutate, so the previous array keeps the old height.
            next[index] = {
                name: name,
                height: height
            };
            return next;
        }
        return undefined;
    });
};
const $827d62b6188a5818$export$11fa8b7d26b756a8 = (name)=>{
    $827d62b6188a5818$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return undefined;
        const next = [
            ...current
        ];
        next.splice(index, 1);
        return next;
    });
};
const $827d62b6188a5818$export$468156c225d4c0f9 = (initial)=>{
    if ((0, $i3jcY.isStableUIEnabledForTests)()) return;
    if ($827d62b6188a5818$var$banners.length === 0 && initial.length > 0) $827d62b6188a5818$var$commit([
        ...initial
    ]);
};
const $827d62b6188a5818$export$b3f5cfd1906442cb = ()=>{
    $827d62b6188a5818$var$banners = $827d62b6188a5818$var$NO_BANNERS;
    $827d62b6188a5818$var$listeners.clear();
    $827d62b6188a5818$var$pending = [];
    $827d62b6188a5818$var$pendingFlush = null;
};
module.exports["getBanners"] = $827d62b6188a5818$export$49fd326b255f6ddb;
module.exports["subscribeToBanners"] = $827d62b6188a5818$export$7cfac2c025b473e4;
module.exports["showBanner"] = $827d62b6188a5818$export$f5c0eb035ef26e87;
module.exports["hideBanner"] = $827d62b6188a5818$export$11fa8b7d26b756a8;
module.exports["seedBanners"] = $827d62b6188a5818$export$468156c225d4c0f9;

});

parcelRegister("jecot", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $ff48e00b2c36a911$export$756e5b68ec79d923 = ()=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('platform_dst_ads_appswitcher_improvements')) return 56;
    return 48;
};
module.exports["resolveTopNavHeight"] = $ff48e00b2c36a911$export$756e5b68ec79d923;

});

parcelRegister("bJX6u", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");

const $258e0d668fcd3778$export$7e292eecf5a8f340 = {
    contentState: null,
    contentStateLastUpdated: null,
    shouldRunContentStateEffect: true,
    defaultStatesArray: [],
    customStatesArray: [],
    isContentStateEnabled: true,
    isSuggestedEnabled: true,
    isCustomEnabled: true,
    isUpdating: false,
    lastFetchedIsDraft: null,
    lastFetchedContentId: null
};
class $258e0d668fcd3778$export$ade89fbf99f42685 extends (0, $kNIYN.Container) {
    populateState(ssrContentStateData) {
        const newContentStateValues = Object.assign({}, $258e0d668fcd3778$export$7e292eecf5a8f340);
        newContentStateValues.shouldRunContentStateEffect = false;
        newContentStateValues.contentState = ssrContentStateData?.singleContent?.contentState || null;
        newContentStateValues.contentStateLastUpdated = ssrContentStateData?.singleContent?.contentStateLastUpdated?.value || null;
        newContentStateValues.defaultStatesArray = ssrContentStateData?.availableContentStates?.spaceContentStates?.filter((i)=>!!i) || [];
        newContentStateValues.customStatesArray = ssrContentStateData?.availableContentStates?.customContentStates?.filter((i)=>!!i) || [];
        // If an admin has turned off a toggle, BE returns us the value as null
        // If an empty array is returned [], means the feature is still enabled - there's just no values in there.
        // if both return as null it means the admin disabled content states
        const isSuggestedContentStatesDisabled = !ssrContentStateData?.availableContentStates?.spaceContentStates;
        const isCustomContentStatesDisabled = !ssrContentStateData?.availableContentStates?.customContentStates;
        const isContentStatesDisabled = isSuggestedContentStatesDisabled && isCustomContentStatesDisabled;
        if (isContentStatesDisabled) newContentStateValues.isContentStateEnabled = false;
        else if (isSuggestedContentStatesDisabled) // if spaceContentStates is null, admin disabled suggested
        newContentStateValues.isSuggestedEnabled = false;
        else if (isCustomContentStatesDisabled) // if customContentStates is null, admin disabled custom
        newContentStateValues.isCustomEnabled = false;
        this.state = newContentStateValues;
    }
    constructor(ssrContentStateData){
        super();
        this.state = {
            ...$258e0d668fcd3778$export$7e292eecf5a8f340
        };
        // Guards optimistic, mutation-owned fields (applied status + option list) from being
        // clobbered by stale refetches while an operation is pending. Kept off `state` so it
        // survives the refetch-driven `setInitialValues` calls.
        this.isOptimisticOperationPending = false;
        this.setIsOptimisticOperationPending = (isOptimisticOperationPending)=>{
            this.isOptimisticOperationPending = isOptimisticOperationPending;
        };
        // The contentId for which the empty add-status trigger should be kept visible after a
        // view-mode delete. Stored as an id (not a boolean) so render can scope it to the current page
        // without a navigation listener — it's only honored while this matches the active contentId,
        // so it naturally clears on navigation. Kept off `state` so a fresh container (refresh) resets it.
        this.keepEmptyTriggerForContentId = null;
        this.setKeepEmptyTriggerForContentId = (contentId)=>{
            this.keepEmptyTriggerForContentId = contentId;
        };
        this.setContentState = (contentState)=>this.setState({
                contentState: contentState
            });
        this.setShouldRunContentStateEffect = (shouldRunContentStateEffect)=>this.setState({
                shouldRunContentStateEffect: shouldRunContentStateEffect
            });
        this.setDefaultStatesArray = (defaultStatesArray)=>this.setState({
                defaultStatesArray: defaultStatesArray
            });
        this.setCustomStatesArray = (customStatesArray)=>this.setState({
                customStatesArray: customStatesArray
            });
        this.setIsContentStateEnabled = (isContentStateEnabled)=>this.setState({
                isContentStateEnabled: isContentStateEnabled
            });
        this.setIsSuggestedEnabled = (isSuggestedEnabled)=>this.setState({
                isSuggestedEnabled: isSuggestedEnabled
            });
        this.setIsCustomEnabled = (isCustomEnabled)=>this.setState({
                isCustomEnabled: isCustomEnabled
            });
        this.setIsUpdating = (isUpdating)=>this.setState({
                isUpdating: isUpdating
            });
        this.setLastFetchedIsDraft = (lastFetchedIsDraft)=>this.setState({
                lastFetchedIsDraft: lastFetchedIsDraft
            });
        this.setLastFetchedContentId = (lastFetchedContentId)=>this.setState({
                lastFetchedContentId: lastFetchedContentId
            });
        this.setInitialValues = (contentStateState)=>this.setState(contentStateState);
        this.resetToDefaults = ()=>this.setState({
                ...$258e0d668fcd3778$export$7e292eecf5a8f340
            });
        if (ssrContentStateData) this.populateState(ssrContentStateData);
    }
}
module.exports["defaultValues"] = $258e0d668fcd3778$export$7e292eecf5a8f340;
module.exports["ContentStateStateContainer"] = $258e0d668fcd3778$export$ade89fbf99f42685;

});

parcelRegister("ktUCG", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $8rneB = parcelRequire("8rneB");


var $bKZz0 = parcelRequire("bKZz0");

class $122734ff4c4db131$export$c7d05d5ff2632978 extends (0, $kNIYN.Container) {
    populateState(ssrEmojiTitleData) {
        const { emojiStatusFieldName: emojiStatusFieldName, queryData: queryData, isLivePage: isLivePage } = ssrEmojiTitleData;
        const emojiId = (0, $8rneB.getEmojiId)(queryData, emojiStatusFieldName);
        const hasDefaultLiveTitleEmoji = (0, $8rneB.getHasLiveDocsDefaultEmoji)(queryData);
        this.setSelectedEmoji(emojiId || null);
        this.setHasLiveDocsDefaultEmoji(hasDefaultLiveTitleEmoji && isLivePage);
    }
    constructor(ssrEmojiTitleData){
        super();
        // Analytics-only flag: intentionally bypasses Container state so mutations
        // never trigger subscriber re-renders.
        this.justRestoredEmoji = false;
        this.state = {
            emojiPickerLoaded: false,
            isLoading: true,
            isMouseEnterTitle: false,
            isUpdatingEmoji: false,
            openFirstEmojiPicker: false,
            openSecondEmojiPicker: false,
            selectedEmoji: null,
            isEmojiButtonFocused: false,
            isRemovingEmoji: false,
            hasLiveDocsDefaultEmoji: false,
            previousEmojiIdByContentId: {}
        };
        this.onUpdateStart = ()=>this.setState({
                isUpdatingEmoji: true
            });
        this.onUpdateEnd = ()=>{
            this.setState({
                isUpdatingEmoji: false
            });
            this.setState({
                isRemovingEmoji: false
            });
        };
        this.setIsEmojiButtonFocused = (isEmojiButtonFocused)=>this.setState({
                isEmojiButtonFocused: isEmojiButtonFocused
            });
        this.setIsRemovingEmoji = (isRemovingEmoji)=>this.setState({
                isRemovingEmoji: isRemovingEmoji
            });
        this.setIsUpdatingEmoji = (isUpdatingEmoji)=>this.setState({
                isUpdatingEmoji: isUpdatingEmoji
            });
        // first emoji picker is open when user already selected an emoji
        // click on the emoji and want to change it to different emoji
        this.setOpenFirstEmojiPicker = (isOpen)=>{
            if (this.state.openFirstEmojiPicker !== isOpen) this.setState({
                openFirstEmojiPicker: isOpen
            });
        };
        // second emoji picker is open when not yet selected an emoji
        // and want to add emoji via Add emoji button
        this.setOpenSecondEmojiPicker = (isOpen)=>{
            if (this.state.openSecondEmojiPicker !== isOpen) this.setState({
                openSecondEmojiPicker: isOpen
            });
        };
        this.setSelectedEmoji = (emoji)=>this.setState({
                selectedEmoji: emoji
            });
        this.onEmojiPickerLoaded = ()=>{
            if (!this.state.emojiPickerLoaded) this.setState({
                emojiPickerLoaded: true
            });
        };
        // for testing
        this.setContainerState = (newState)=>this.setState((state)=>({
                    ...state,
                    ...newState
                }));
        this.setLoadingEmoji = (isLoading)=>this.setState({
                isLoading: isLoading
            });
        this.setHasLiveDocsDefaultEmoji = (hasDefaultEmoji)=>this.setState({
                hasLiveDocsDefaultEmoji: hasDefaultEmoji
            });
        this.getPreviousEmojiId = (contentId)=>this.state.previousEmojiIdByContentId[contentId] ?? null;
        // Pass `null` to clear just that entry.
        this.setPreviousEmojiId = (contentId, previousEmojiId)=>{
            const next = {
                ...this.state.previousEmojiIdByContentId
            };
            if (previousEmojiId === null) delete next[contentId];
            else next[contentId] = previousEmojiId;
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) (0, $bKZz0.writeSessionStoragePreviousEmojiCache)(next);
            return this.setState({
                previousEmojiIdByContentId: next
            });
        };
        if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_livedocs_restore_latest_emoji')) {
            const hydrated = (0, $bKZz0.readSessionStoragePreviousEmojiCache)();
            if (Object.keys(hydrated).length > 0) this.state = {
                ...this.state,
                previousEmojiIdByContentId: hydrated
            };
        }
        if (ssrEmojiTitleData) this.populateState(ssrEmojiTitleData);
    }
}
module.exports["EmojiTitleStateContainer"] = $122734ff4c4db131$export$c7d05d5ff2632978;

});

parcelRegister("bKZz0", function(module, exports) {
/**
 * sessionStorage mirror for the per-contentId `previousEmojiId` cache used by
 * the Live Docs "Restore emoji" affordance. Survives same-tab refresh; not a
 * source of truth — the in-memory unstated state is. Failures degrade silently.
 */ 
var $17wUi = parcelRequire("17wUi");


var $ivEX1 = parcelRequire("ivEX1");

const $dabf2e5c28263f4b$var$STORAGE_KEY = (0, $ivEX1.sessionKeys).EMOJI_TITLE_PREVIOUS_EMOJI;
const $dabf2e5c28263f4b$export$6adb2744b497be8f = ()=>{
    try {
        const raw = (0, $17wUi.confluenceSessionStorageInstance)?.getItem($dabf2e5c28263f4b$var$STORAGE_KEY);
        if (!raw || typeof raw !== 'string') return {};
        const parsed = JSON.parse(raw);
        if (!parsed || parsed.v !== 1 || typeof parsed.entries !== 'object' || !parsed.entries) return {};
        // Defensive: filter to non-empty string values in case the slot was
        // mutated by something else on the same origin.
        const out = {};
        for (const [contentId, emojiId] of Object.entries(parsed.entries))if (typeof emojiId === 'string' && emojiId.length > 0) out[contentId] = emojiId;
        return out;
    } catch  {
        return {};
    }
};
const $dabf2e5c28263f4b$export$3ef572a2467e08f4 = (map)=>{
    try {
        const entries = {};
        for (const [contentId, emojiId] of Object.entries(map))if (typeof emojiId === 'string' && emojiId.length > 0) entries[contentId] = emojiId;
        // Drop the key entirely when empty to keep storage clean.
        if (Object.keys(entries).length === 0) {
            (0, $17wUi.confluenceSessionStorageInstance)?.removeItem($dabf2e5c28263f4b$var$STORAGE_KEY);
            return;
        }
        (0, $17wUi.confluenceSessionStorageInstance)?.setItem($dabf2e5c28263f4b$var$STORAGE_KEY, JSON.stringify({
            v: 1,
            entries: entries
        }));
    } catch  {
    // Quota / consent / disabled storage — swallow; in-memory cache is unaffected.
    }
};
const $dabf2e5c28263f4b$export$fc4e54f3757eb471 = $dabf2e5c28263f4b$var$STORAGE_KEY;
module.exports["readSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$6adb2744b497be8f;
module.exports["writeSessionStoragePreviousEmojiCache"] = $dabf2e5c28263f4b$export$3ef572a2467e08f4;

});

parcelRegister("ivEX1", function(module, exports) {
/**
 * Registry of keys used with `confluenceSessionStorageInstance` (session storage).
 *
 * Keys here are intentionally NOT persisted across browser sessions.
 * Do NOT add keys here that should survive a tab close — use `LocalStorageKeys.ts` instead.
 */ const $ebcfca89ee3399cd$export$43572ca00746d574 = {
    /**
	 * The layout ('grid' | 'list') selected by the user for the folder contents view.
	 * Persisted for the duration of the browser session only.
	 */ FOLDER_VIEW_LAYOUT: 'folder.view.layout',
    /**
	 * Overrides the release track to 'dev'. Useful for running end-to-end tests
	 * from a dev machine against a production instance.
	 * Used by @confluence/build-info.
	 */ TELEMETRY_DEV_TRACK_OVERRIDE: 'confluence.telemetry-dev-track-override',
    /**
	 * Enables Confluence frontend logging when set to 'true'.
	 * Used by @confluence/logger.
	 */ ENABLE_LOGGING: 'confluence.enable-logging',
    /**
	 * Controls the minimum log level (1–5) for Confluence frontend logging.
	 * Used by @confluence/logger.
	 */ LOG_LEVEL: 'confluence.log-level',
    /**
	 * Tracks when the page-watch nudge was last shown to the user.
	 * Used by @confluence/third-party-nudge.
	 */ PAGE_VIEW_NUDGE_DATE: 'page-view-nudge-date',
    /**
	 * Tracks the state of the notification section nudge.
	 * Used by @confluence/third-party-nudge.
	 */ NOTIFICATION_NUDGE_STATE: 'notification-nudge-state',
    /**
	 * Per-contentId cache of the most recent custom emoji observed on a Live
	 * Doc, used to drive the "Restore emoji" affordance.
	 * Used by @confluence/emoji-title.
	 */ EMOJI_TITLE_PREVIOUS_EMOJI: 'confluence.emoji-title.previousEmojiId.v1',
    /**
	 * Identifies the title-based agent suggestion already shown in this editing
	 * session. The value is the owning agent/content pair so the currently visible
	 * suggestion can remain mounted while all other title suggestions are suppressed.
	 * Used by @confluence/experiment-ootb-title-based-agent-suggestion-nudge.
	 */ TITLE_AGENT_NUDGE_SHOWN_SESSION: 'confluence.title-agent-nudge.shown-session',
    /**
	 * Light mode debug mode from the Performance tab of Confluence Dev Tools. It is read and written
	 * with raw `sessionStorage`, like loadable's SSR outline flags, because it is not registered with
	 * browser storage controls.
	 * Used by @confluence/dev-tools and @confluence/content-renderer.
	 */ LIGHT_MODE_DEBUG: 'confluence.light-mode.debug'
};
module.exports["sessionKeys"] = $ebcfca89ee3399cd$export$43572ca00746d574;

});

parcelRegister("brNvA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $2c05d1bead0fe3b6$export$fb4e7a383f5cb089 = /*#__PURE__*/ (0, $cozmU.createContext)({
    commentToReattach: null,
    reattachHighlight: null,
    isInReattachMode: ()=>false
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentContext';
const $2c05d1bead0fe3b6$export$29a077948aa018ea = /*#__PURE__*/ (0, $cozmU.createContext)({
    setCommentToReattach: ()=>{},
    setReattachHighlight: ()=>{},
    clearReattachMode: ()=>{}
});
$2c05d1bead0fe3b6$export$fb4e7a383f5cb089.displayName = 'ReattachCommentDispatchContext';
const $2c05d1bead0fe3b6$export$eeb6c3345224df9d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { children: children } = t0;
    const [commentToReattach, setCommentToReattach] = (0, $cozmU.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] !== commentToReattach) {
        t1 = ()=>Boolean(commentToReattach);
        $[0] = commentToReattach;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== commentToReattach || $[3] !== reattachHighlight || $[4] !== t1) {
        t2 = {
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: t1
        };
        $[2] = commentToReattach;
        $[3] = reattachHighlight;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const providerValue = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        };
        $[6] = t3;
    } else t3 = $[6];
    const dispatchProviderValue = t3;
    let t4;
    if ($[7] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
            value: dispatchProviderValue
        }, children);
        $[7] = children;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== providerValue || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
            value: providerValue
        }, t4);
        $[9] = providerValue;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ children: children })=>{
    const [commentToReattach, setCommentToReattach] = (0, $cozmU.useState)(null);
    const [reattachHighlight, setReattachHighlight] = (0, $cozmU.useState)(null);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            commentToReattach: commentToReattach,
            reattachHighlight: reattachHighlight,
            isInReattachMode: ()=>Boolean(commentToReattach)
        }), [
        commentToReattach,
        reattachHighlight
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setCommentToReattach: setCommentToReattach,
            setReattachHighlight: (highlight)=>{
                setReattachHighlight(highlight?.numMatches !== 0 ? highlight : null);
            },
            clearReattachMode: ()=>{
                setCommentToReattach(null);
                setReattachHighlight(null);
            }
        }), [
        setCommentToReattach,
        setReattachHighlight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$fb4e7a383f5cb089.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2c05d1bead0fe3b6$export$29a077948aa018ea.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $2c05d1bead0fe3b6$export$d801c7a3a205f98e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
} : ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$fb4e7a383f5cb089);
};
const $2c05d1bead0fe3b6$export$344893016ba0bdd4 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
} : ()=>{
    return (0, $cozmU.useContext)($2c05d1bead0fe3b6$export$29a077948aa018ea);
};
module.exports["ReattachCommentContext"] = $2c05d1bead0fe3b6$export$fb4e7a383f5cb089;
module.exports["ReattachCommentProvider"] = $2c05d1bead0fe3b6$export$eeb6c3345224df9d;
module.exports["useReattachComment"] = $2c05d1bead0fe3b6$export$d801c7a3a205f98e;
module.exports["useReattachCommentDispatch"] = $2c05d1bead0fe3b6$export$344893016ba0bdd4;

});

parcelRegister("kCeSx", function(module, exports) {
$parcel$export(module.exports, "default", () => $f022e5db44f52121$export$2e2bcd8739ae039);

var $bEYte = parcelRequire("bEYte");


var $apyi7 = parcelRequire("apyi7");


var $eYRlV = parcelRequire("eYRlV");


var $iyEDi = parcelRequire("iyEDi");


var $eYNcX = parcelRequire("eYNcX");


var $g4VeD = parcelRequire("g4VeD");

const $f022e5db44f52121$var$selectContentsFromIds = (0, $eYRlV.createContentsFromIdsSelector)();
const $f022e5db44f52121$export$c31df4bd766f9c35 = (state)=>{
    let spaceKey;
    let contentId;
    let contentType;
    let createpageProps = {};
    // CreatePage passes draftId as contentId. Use it instead of the one coming from
    if (state.editor.get('draftId') && state.editor.get('statusCode') === (0, $eYNcX.OK)) {
        contentId = state.editor.get('draftId');
        const createdPage = state.editor.get('result');
        let ancestors;
        let parentPage;
        if (typeof createdPage?.get === 'function') {
            contentType = createdPage.get('type', null);
            ancestors = createdPage.get('ancestors', []);
            parentPage = ancestors.last();
        } else {
            contentType = createdPage.type;
            ancestors = createdPage.ancestors || [];
            parentPage = ancestors[ancestors.length - 1];
        }
        createpageProps = {
            parentPageId: `${// So the page can either be a plain object or a record depending on timing...
            // TODO: Get rid of all the redux here.
            parentPage ? typeof parentPage.get === 'function' ? parentPage.get('id') : parentPage.id : 0}`,
            // cast to string
            pageVersion: 0 // enforce version 0, otherwise saving will fail with 409 Conflict
        };
    }
    const routeParams = (0, $iyEDi.getRouteParams)(state);
    const location = (0, $iyEDi.getLocation)(state);
    if (!spaceKey) spaceKey = routeParams.spaceKey;
    if (!contentId) // on old viewPage we need `contentId` for request permissions component
    // we can get it as `pageId` from location query;
    contentId = routeParams.contentId || (location.query || {}).pageId;
    if (!contentId && spaceKey) // Fallback to space homepage if no content id found
    contentId = `${state.entities.getIn([
        'spaces',
        spaceKey,
        'homepageId'
    ])}`; // string
    const currentPage = state.entities.getIn([
        'contents',
        `${contentId}`
    ]);
    if (contentId && currentPage) contentType = currentPage.type;
    const editorForCommentsIsEnabled = state.views.viewPage.editor.contentId;
    if (editorForCommentsIsEnabled) contentType = 'comment';
    if ([
        'CREATE_TEMPLATE_SPACE',
        'EDIT_TEMPLATE_SPACE',
        'EDIT_TEMPLATE',
        'CREATE_TEMPLATE'
    ].includes(location.routeName)) contentType = 'template';
    let viewpageProps = {};
    const currentPageVersion = state.entities.getIn([
        'versions',
        `${contentId}`
    ], {});
    if (currentPage) {
        const parentPage = currentPage.ancestors && currentPage.ancestors.size ? $f022e5db44f52121$var$selectContentsFromIds((0, $apyi7.fromJS)([
            currentPage.ancestors.last()
        ]), state).first() : null;
        viewpageProps = {
            pageTitle: currentPage.title,
            pageVersion: currentPageVersion.number,
            parentPageTitle: parentPage ? parentPage.title : '',
            parentPageId: parentPage ? parentPage.id : '0',
            canRemovePage: currentPage.currentUserPermissions && currentPage.currentUserPermissions.includes('delete')
        };
    }
    const experimentProps = {
        experimentFeatures: state.views.dashboard.get('experimentFeatures')
    };
    // TODO: there is no simple way to select the parent yet so this code will be commented out till we solve it
    // matches /spaces/{spaceKey}/pages or /spaces/{spaceKey}/pages/ only
    //const isPageTree = /\/spaces\/([~0-9A-z]*)\/pages(\/)?$/.test(location.pathname);
    //const contextualMenuOpenForPageId = state.views.spaceHome.pageTreeContextualMenu;
    //
    //if (isPageTree && !!contextualMenuOpenForPageId) {
    //    const selectedPage = state.entities.getIn(['contents', contextualMenuOpenForPageId]);
    //    if (selectedPage) {
    //        const parentPage = selectedPage.ancestors.size ? selectContentsFromIds(fromJS([selectedPage.ancestors.last()]), state).first() : null;
    //        viewpageProps = {
    //            contentId: selectedPage.id,
    //            pageTitle: selectedPage.title,
    //            parentPageTitle: parentPage ? parentPage.title : null,
    //            parentPageId: parentPage ? parentPage.id : '0',
    //            canRemovePage: selectedPage.currentUserPermissions.includes('delete')
    //        };
    //    }
    //}
    return {
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: contentType,
        spaceName: state.entities.getIn([
            'spaces',
            spaceKey,
            'name'
        ]),
        spaceType: state.entities.getIn([
            'spaces',
            spaceKey,
            'type'
        ]),
        ...viewpageProps,
        ...createpageProps,
        ...experimentProps
    };
};
var $f022e5db44f52121$export$2e2bcd8739ae039 = (0, $bEYte.connect)($f022e5db44f52121$export$c31df4bd766f9c35)((0, $g4VeD.default));

});

parcelRegister("eYRlV", function(module, exports) {

var $fZl6o = parcelRequire("fZl6o");


var $apyi7 = parcelRequire("apyi7");


var $ePeSL = parcelRequire("ePeSL");

const $ae800dfdeadf4eac$var$PREDEFINED_BLUEPRINT_TYPES = {
    'meeting-notes': true,
    decisions: true,
    'kb-how-to-article': true,
    'file-list': true,
    retrospective: true,
    requirements: true,
    'shared-links': true,
    'kb-troubleshooting-article': true,
    'task-report': true,
    jirareport: true
};
function $ae800dfdeadf4eac$var$isEmpty(data) {
    if (!data) return true;
    return !$ae800dfdeadf4eac$var$size(data);
}
function $ae800dfdeadf4eac$var$size(data) {
    if (!data) return 0;
    return data.hasOwnProperty('size') ? data.size : data.length;
}
const $ae800dfdeadf4eac$export$1ada442d7b78f25 = (0, $ePeSL.default)((item)=>item, (item, users)=>users, // 'containers' may be a space or a content, right now it's only ever content on file records
(item, users, containers)=>containers, (item, users, containers, versions)=>versions, (item, users, containers, versions)=>{
    let version = versions.get(`${item.version}`);
    if (version) version = version.set('by', users.get(version.by));
    const container = item.container ? containers.get(`${item.container}`) : null;
    let result = item.set('createdBy', users.get(item.createdBy)).set('version', version);
    if (item.contributors) result = result.set('contributors', item.contributors.map((accountId)=>users.get(accountId)));
    if (item.viewers) result = result.set('viewers', item.viewers.map((accountId)=>users.get(accountId)));
    if (container) {
        result = result.set('container', container);
        const containerVersion = container.get('version');
        if (containerVersion) result = result.setIn([
            'container',
            'version'
        ], versions.get(`${containerVersion}`));
    }
    return result;
});
const $ae800dfdeadf4eac$export$5c63e7dafa621e16 = (contentId, state)=>{
    const entities = state.entities;
    const content = entities.get('contents').get(`${contentId}`);
    if (content && (content.createdBy || content.version)) return $ae800dfdeadf4eac$export$1ada442d7b78f25(content, entities.get('users'), entities.get('contents'), entities.get('versions'));
    return content;
};
const $ae800dfdeadf4eac$export$fe6dd8e2950283cb = (state, contentId, permissionType)=>{
    const content = state.entities.getIn([
        'contents',
        contentId
    ]);
    return content.currentUserPermissions.contains(permissionType);
};
const $ae800dfdeadf4eac$export$84b461ed686ebfb9 = (state, contentId)=>$ae800dfdeadf4eac$export$fe6dd8e2950283cb(state, contentId, 'update');
const $ae800dfdeadf4eac$var$buildContentCreatedBy = (0, $ePeSL.default)((item)=>item, (item, users)=>users, (item, users)=>item.set('createdBy', users.get(item.createdBy)));
const $ae800dfdeadf4eac$export$5c767ea021dac201 = ()=>(0, $fZl6o.createSelector)((ids)=>ids, (ids, state, contents)=>contents || state.entities.get('contents'), (ids, state)=>state.entities.get('contents'), (ids, state)=>state.entities.get('versions'), (ids, state)=>state.entities.get('users'), // 'containers' may be a space or a content, right now it's only ever content on file records
    (ids, contents, containers, versions, users)=>{
        if (!ids) return null;
        if (typeof ids === 'number' || typeof ids === 'string') ids = (0, $apyi7.List)([
            `${ids}`
        ]);
        if (ids.length && !(0, $apyi7.List).isList(ids)) ids = (0, $apyi7.List)(ids);
        if (!ids.size) return (0, $apyi7.List)([]);
        ids = ids.filter((id)=>!!contents.get(`${id}`));
        return ids.map((id)=>{
            const content = contents.get(`${id}`);
            if (content.createdBy || content.version) return $ae800dfdeadf4eac$export$1ada442d7b78f25(content, users, containers, versions);
            return content;
        });
    });
const $ae800dfdeadf4eac$export$7203590478a6c254 = ()=>(0, $fZl6o.createSelector)((ids)=>ids, (ids, state)=>state.entities.get('contents'), (ids, contents)=>{
        if ($ae800dfdeadf4eac$var$isEmpty(ids)) return (0, $apyi7.List)([]);
        return ids.map((id)=>contents.get(`${id}`));
    });
const $ae800dfdeadf4eac$export$167cb14480de4389 = ()=>(0, $fZl6o.createSelector)((ids)=>ids, (ids, state)=>state.entities.get('contents'), (ids, state)=>state.entities.get('users'), (ids, contents, users)=>{
        if ($ae800dfdeadf4eac$var$isEmpty(ids)) return (0, $apyi7.List)([]);
        return ids.map((id)=>{
            const content = contents.get(`${id}`);
            if (content && content.createdBy) return $ae800dfdeadf4eac$var$buildContentCreatedBy(content, users);
            return content;
        });
    });
const $ae800dfdeadf4eac$var$getContent = (contentId, state)=>state.entities.getIn([
        'contents',
        contentId
    ]);
const $ae800dfdeadf4eac$var$getLabels = (contentId, state)=>state.entities.get('labels');
const $ae800dfdeadf4eac$export$e23bbeb6c3d185f2 = (0, $fZl6o.createSelector)($ae800dfdeadf4eac$var$getContent, $ae800dfdeadf4eac$var$getLabels, (content, labels)=>{
    if (!content || !labels) return '';
    const contentLabels = content.get('labels');
    if (!contentLabels || contentLabels.size === 0) return '';
    const contentBlueprintId = contentLabels.find((labelId)=>{
        const labelData = labels.get(labelId);
        return !labelData ? false : $ae800dfdeadf4eac$var$PREDEFINED_BLUEPRINT_TYPES[labelData.get('name')];
    });
    return contentBlueprintId ? labels.get(contentBlueprintId).get('name') : '';
});
module.exports["buildContentItem"] = $ae800dfdeadf4eac$export$5c63e7dafa621e16;
module.exports["createContentsFromIdsSelector"] = $ae800dfdeadf4eac$export$5c767ea021dac201;

});

parcelRegister("ePeSL", function(module, exports) {
$parcel$export(module.exports, "default", () => $acb15f65db8e2947$export$2e2bcd8739ae039);

var $fZl6o = parcelRequire("fZl6o");

/**
 * WeakMapMemoizer allows memoisation of lists
 */ class $acb15f65db8e2947$var$WeakMapMemoizer {
    memoize(...weakArgs) {
        return this._memoizeImpl(this.map, weakArgs, 0);
    }
    _memoizeImpl(map, args, i) {
        let value = map.get(args[i]);
        if (i === args.length - 1) {
            if (!value) {
                value = this.func(...args);
                map.set(args[i], value);
            }
            return value;
        }
        if (!value) {
            value = new WeakMap();
            map.set(args[i], value);
        }
        return this._memoizeImpl(value, args, i + 1);
    }
    constructor(func){
        this.map = new WeakMap();
        this.func = func;
    }
}
var /**
 * createSelectorCreator - drop in replacement for reselect.createSelector
 * which offers better performance when dealing with lists that should
 * be recreated very often
 */ $acb15f65db8e2947$export$2e2bcd8739ae039 = (0, $fZl6o.createSelectorCreator)((func)=>{
    const memoizer = new $acb15f65db8e2947$var$WeakMapMemoizer(func);
    return memoizer.memoize.bind(memoizer);
});

});

parcelRegister("g4VeD", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $1i7uI = parcelRequire("1i7uI");


var $cSdzn = parcelRequire("cSdzn");

class $bb496ac4c35df382$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    componentDidMount() {
        this._setLegacyProps(this.props);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this._setLegacyProps(nextProps);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.props, nextProps);
    }
    componentWillUnmount() {
        this._setAJSValues({});
        this._cancelWaitForGlobalInProgress();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this._waitForGlobalInProgress = null;
        this._setLegacyProps = (props)=>{
            this._cancelWaitForGlobalInProgress();
            this._waitForGlobalInProgress = (0, $cSdzn.default)({
                listener: 'LegacyBridge.js',
                globalProperty: 'AJS.params'
            }, ()=>this._setAJSValues(props));
        };
        this._cancelWaitForGlobalInProgress = ()=>{
            if (this._waitForGlobalInProgress) // This prevents waitForGlobal to updates this component in random order in case of multiple calls.
            this._waitForGlobalInProgress.cancel();
        };
        this._setAJSValues = (props)=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS || !(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.params) return;
            const { spaceKey: spaceKey, spaceName: spaceName, spaceType: spaceType, contentId: contentId, contentType: contentType, pageTitle: pageTitle, pageVersion: pageVersion, parentPageId: parentPageId, parentPageTitle: parentPageTitle, canRemovePage: canRemovePage, experimentFeatures: experimentFeatures } = props;
            const createPage = pageVersion === 0;
            const pageId = createPage ? '0' : contentId;
            // page/content info
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.params.pageId = pageId;
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.params.spaceKey = spaceKey;
            const metaParams = {
                // page/content info
                'content-id': contentId,
                'content-type': contentType,
                'page-id': pageId,
                'page-title': pageTitle,
                'page-version': pageVersion,
                'parent-page-id': parentPageId,
                'parent-page-title': parentPageTitle,
                'latest-page-id': contentId,
                'can-remove-page': canRemovePage,
                'new-page': createPage,
                // space info
                'space-key': spaceKey,
                'space-name': spaceName,
                'space-type': spaceType,
                // experiments
                'experiment-features': experimentFeatures
            };
            // Do not set if legacy bridge in next has already handled
            // See: next/packages/view-page/src/LegacyBridgeNext.js
            if ((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.Meta && !(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.Meta.get('has-next-legacy-bridge')) Object.keys(metaParams).forEach((key)=>{
                // standalone mode doesn't have AJS
                (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).AJS.Meta.set(key, metaParams[key]);
            });
        };
    }
}
$bb496ac4c35df382$export$2e2bcd8739ae039.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    spaceName: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    spaceType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    pageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    pageVersion: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).number,
    parentPageId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    parentPageTitle: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    canRemovePage: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool,
    experimentFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string
};
module.exports["default"] = $bb496ac4c35df382$export$2e2bcd8739ae039;

});

parcelRegister("cSdzn", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f50dcfd27e28ce$export$2e2bcd8739ae039);
function $95f50dcfd27e28ce$var$isDefined(path) {
    const pathParts = path.split('.');
    let obj = window[pathParts.shift()];
    while(typeof obj !== 'undefined' && pathParts.length)obj = obj[pathParts.shift()];
    return obj;
}
const $95f50dcfd27e28ce$var$lines = {};
function $95f50dcfd27e28ce$var$logOnce(message) {}
function $95f50dcfd27e28ce$export$d2adf65b87e47523() {
    for(const key in $95f50dcfd27e28ce$var$lines)delete $95f50dcfd27e28ce$var$lines[key];
}
function $95f50dcfd27e28ce$export$2e2bcd8739ae039({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
        $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $95f50dcfd27e28ce$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($95f50dcfd27e28ce$var$isDefined(globalProperty)) {
            $95f50dcfd27e28ce$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
    return {
        cancel () {
            if (waitForGlobalInterval) clearInterval(waitForGlobalInterval);
        }
    };
}

});

parcelRegister("7SkLu", function(module, exports) {

var $E1QOf = parcelRequire("E1QOf");


var $a33Aa = parcelRequire("a33Aa");

function $c60ab42870e33b24$export$f9c6890b323d326b(key, value) {
    const interactionId = (0, $E1QOf.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    (0, $a33Aa.addCohortingCustomData)(currentInteractionId, key, value);
}
module.exports["addUFOCustomCohortData"] = $c60ab42870e33b24$export$f9c6890b323d326b;

});

parcelRegister("9i4uP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3TVAD = parcelRequire("3TVAD");


var $325xw = parcelRequire("325xw");


var $cOJFA = parcelRequire("cOJFA");


var $1iTIy = parcelRequire("1iTIy");


var $bfMSr = parcelRequire("bfMSr");


var $er5PO = parcelRequire("er5PO");


var $8pmO0 = parcelRequire("8pmO0");


var $9N9hR = parcelRequire("9N9hR");


var $ezd2Q = parcelRequire("ezd2Q");

const $1fd02aa1ed8a7078$export$4c26c27af9c29b22 = ()=>(0, $8pmO0.useCreditsRequest)();
const $1fd02aa1ed8a7078$var$createEmptySessionState = ()=>(0, $9N9hR.EMPTY_CREDITS_STATE);
const $1fd02aa1ed8a7078$var$createScopedSessionState = (scopeKey, creditsState = $1fd02aa1ed8a7078$var$createEmptySessionState(), snapshotKey = null, supersededSnapshotKey = null)=>({
        scopeKey: scopeKey,
        creditsState: creditsState,
        snapshotKey: snapshotKey,
        supersededSnapshotKey: supersededSnapshotKey
    });
const $1fd02aa1ed8a7078$var$HEALTHY_BANNER_STATE = Object.freeze({
    balanceState: 'healthy',
    depletionBehavior: null
});
const $1fd02aa1ed8a7078$var$getSnapshotKey = ({ snapshot: snapshot })=>(0, $bfMSr.getStoredSnapshotId)(snapshot);
const $1fd02aa1ed8a7078$var$getBrowserDocument = ()=>typeof globalThis.document === 'undefined' ? null : globalThis.document;
const $1fd02aa1ed8a7078$var$canObserveVisibility = (browserDocument)=>browserDocument !== null && typeof browserDocument.addEventListener === 'function';
const $1fd02aa1ed8a7078$var$getProviderError = (cause, fallbackMessage)=>cause instanceof Error ? cause : new (0, $cOJFA.ErrorWithCause)(fallbackMessage, {
        cause: (0, $cOJFA.normalizeErrorCause)(cause)
    });
const $1fd02aa1ed8a7078$var$getCreditsBannerStateFromEvent = ({ snapshot: storedSnapshot })=>{
    const { snapshot: backendSnapshot } = storedSnapshot;
    return (0, $er5PO.deriveCreditsBannerState)(backendSnapshot);
};
const $1fd02aa1ed8a7078$var$getNextSessionState = (currentState, nextBannerState)=>{
    if (currentState.bannerState !== null && (0, $er5PO.areCreditsBannerStatesEqual)(currentState.bannerState, nextBannerState)) // BroadcastChannel and follower polling can report the same stored
    // snapshot more than once. Keep the previous state-change object so
    // context consumers do not re-render for duplicate credit state.
    return currentState;
    // Keep the current banner state and its state-change flags derived from the
    // same backend response. Consumers can then use `bannerState` for rendering
    // decisions and `bannerStateChange` for side effects without racing two independent
    // calculations.
    return {
        bannerState: nextBannerState,
        bannerStateChange: (0, $er5PO.deriveCreditsBannerStateChange)(currentState.bannerState, nextBannerState)
    };
};
const $1fd02aa1ed8a7078$var$subscribeToVisibleDocumentRefresh = (coordinator, reportError)=>{
    const browserDocument = $1fd02aa1ed8a7078$var$getBrowserDocument();
    if (!$1fd02aa1ed8a7078$var$canObserveVisibility(browserDocument)) return ()=>{};
    const handleVisibilityChange = ()=>{
        if (browserDocument.visibilityState !== 'visible') return;
        // Visibility changes are a lightweight revalidation trigger. The
        // coordinator still decides whether this tab may call the backend or
        // should keep following another tab's stored snapshot.
        coordinator.requestRefresh().catch((cause)=>{
            reportError($1fd02aa1ed8a7078$var$getProviderError(cause, 'Credits visibility refresh failed.'), 'request-refresh');
        });
    };
    browserDocument.addEventListener('visibilitychange', handleVisibilityChange);
    return ()=>{
        browserDocument.removeEventListener('visibilitychange', handleVisibilityChange);
    };
};
const $1fd02aa1ed8a7078$var$resetSessionState = (setSessionState, scopeKey)=>{
    setSessionState((currentState)=>{
        if (currentState.scopeKey === scopeKey && currentState.creditsState.bannerState === null && currentState.creditsState.bannerStateChange === null) return currentState;
        return $1fd02aa1ed8a7078$var$createScopedSessionState(scopeKey);
    });
};


const $1fd02aa1ed8a7078$var$startCreditsSession = ({ product: product, cloudId: cloudId, workspaceId: workspaceId, agentId: agentId, onSnapshot: onSnapshot, reportError: reportError })=>{
    let coordinator = null;
    let unsubscribeFromVisibilityRefresh = null;
    let isCancelled = false;
    const stopStartedSession = ()=>{
        unsubscribeFromVisibilityRefresh?.();
        unsubscribeFromVisibilityRefresh = null;
        coordinator?.stop();
        coordinator = null;
    };
    (async ()=>{
        try {
            // Load the backend client and coordinator only after the site is known,
            // Rovo is enabled, and the feature gate is on. Gate-off consumers can render
            // the provider without loading polling, storage, or Web Lock code.
            // The shared webpack chunk name is intentional: startup always needs both
            // modules together today. Split the chunk only if a future startup path can
            // use one module without the other.
            const [creditsBackendClientController, creditsSessionCoordinatorController] = await Promise.all([
                Promise.resolve((parcelRequire("0E2ZR"))),
                (parcelRequire("hTUNJ"))
            ]);
            if (isCancelled) return;
            const backendClient = creditsBackendClientController.createCreditsBackendClient({
                product: product,
                cloudId: cloudId,
                workspaceId: workspaceId,
                ...agentId !== undefined ? {
                    agentId: agentId
                } : {}
            });
            coordinator = creditsSessionCoordinatorController.createCreditsSessionCoordinator({
                refreshCreditsState: (options)=>backendClient.getCreditsState(options),
                parseSnapshot: creditsBackendClientController.parseCreditsBackendSnapshot,
                // Workspace sessions may have no site; they are keyed by workspace instead.
                siteId: cloudId ?? '',
                ...agentId !== undefined ? {
                    agentId: agentId
                } : {},
                ...workspaceId !== undefined ? {
                    workspaceId: workspaceId
                } : {},
                onSnapshot: (snapshotEvent)=>{
                    if (!isCancelled) onSnapshot(snapshotEvent);
                },
                onError: reportError
            });
            coordinator.start();
            if (isCancelled) {
                stopStartedSession();
                return;
            }
            unsubscribeFromVisibilityRefresh = $1fd02aa1ed8a7078$var$subscribeToVisibleDocumentRefresh(coordinator, reportError);
        } catch (cause) {
            if (!isCancelled) reportError($1fd02aa1ed8a7078$var$getProviderError(cause, 'Credits session state startup failed.'), 'session-startup');
            stopStartedSession();
        }
    })();
    return {
        cancel: ()=>{
            isCancelled = true;
            stopStartedSession();
        }
    };
};
const $1fd02aa1ed8a7078$var$useCreditsSessionState = ({ enabled: enabled, product: product, cloudId: cloudId, workspaceId: workspaceId, agentId: agentId, onError: onError })=>{
    const stateScope = JSON.stringify([
        product,
        cloudId,
        workspaceId,
        agentId
    ]);
    const onErrorRef = (0, $cozmU.useRef)(onError);
    const [sessionState, setSessionState] = (0, $cozmU.useState)(()=>$1fd02aa1ed8a7078$var$createScopedSessionState(stateScope));
    const shouldStartSession = enabled && (cloudId !== undefined || workspaceId !== undefined);
    const reportTargetRef = (0, $cozmU.useRef)({
        shouldStartSession: shouldStartSession,
        scopeKey: stateScope
    });
    (0, $cozmU.useEffect)(()=>{
        onErrorRef.current = onError;
    }, [
        onError
    ]);
    (0, $cozmU.useEffect)(()=>{
        reportTargetRef.current = {
            shouldStartSession: shouldStartSession,
            scopeKey: stateScope
        };
    }, [
        shouldStartSession,
        stateScope
    ]);
    (0, $cozmU.useEffect)(()=>{
        // A new start attempt begins a new state-change history. When startup is
        // disabled, this also clears stale warning/depleted state from consumers.
        $1fd02aa1ed8a7078$var$resetSessionState(setSessionState, stateScope);
        if (!shouldStartSession) return;
        const reportError = (error, context)=>{
            const onErrorHandler = onErrorRef.current;
            if (onErrorHandler !== null) onErrorHandler(error, context);
        };
        const sessionStartup = $1fd02aa1ed8a7078$var$startCreditsSession({
            product: product,
            cloudId: cloudId,
            workspaceId: workspaceId,
            agentId: agentId,
            onSnapshot: (snapshotEvent)=>{
                setSessionState((currentState)=>{
                    const snapshotKey = $1fd02aa1ed8a7078$var$getSnapshotKey(snapshotEvent);
                    if (snapshotEvent.source === 'storage' && currentState.scopeKey === stateScope && currentState.supersededSnapshotKey === snapshotKey) // This is a replay of the snapshot a reported denial already replaced, so
                    // applying it would undo the report. A newer snapshot has a different key.
                    return currentState;
                    // A snapshot never builds on another request scope's history.
                    const previousCreditsState = currentState.scopeKey === stateScope ? currentState.creditsState : $1fd02aa1ed8a7078$var$createEmptySessionState();
                    const nextCreditsState = $1fd02aa1ed8a7078$var$getNextSessionState(previousCreditsState, $1fd02aa1ed8a7078$var$getCreditsBannerStateFromEvent(snapshotEvent));
                    if (currentState.scopeKey === stateScope && nextCreditsState === previousCreditsState && currentState.snapshotKey === snapshotKey && currentState.supersededSnapshotKey === null) return currentState;
                    return $1fd02aa1ed8a7078$var$createScopedSessionState(stateScope, nextCreditsState, snapshotKey);
                });
            },
            reportError: reportError
        });
        return ()=>{
            sessionStartup.cancel();
        };
    }, [
        shouldStartSession,
        product,
        cloudId,
        workspaceId,
        agentId,
        stateScope
    ]);
    const reportCreditDenial = (0, $cozmU.useCallback)((reportedDenial)=>{
        // Read through a ref so the function keeps one identity when the request scope changes.
        const { shouldStartSession: isSessionRunning, scopeKey: reportScopeKey } = reportTargetRef.current;
        const denial = (0, $3TVAD.normalizeReportedCreditDenial)(reportedDenial);
        if (!isSessionRunning || denial === null) return;
        setSessionState((currentState)=>{
            const previousCreditsState = currentState.scopeKey === reportScopeKey ? currentState.creditsState : $1fd02aa1ed8a7078$var$createEmptySessionState();
            // Before the first snapshot a block is still a newly entered state, not an initial one.
            const nextCreditsState = $1fd02aa1ed8a7078$var$getNextSessionState(previousCreditsState.bannerState === null ? {
                ...previousCreditsState,
                bannerState: $1fd02aa1ed8a7078$var$HEALTHY_BANNER_STATE
            } : previousCreditsState, (0, $er5PO.deriveCreditsBannerState)({
                denial: denial
            }));
            if (nextCreditsState === previousCreditsState) return currentState;
            const snapshotKey = currentState.scopeKey === reportScopeKey ? currentState.snapshotKey : null;
            return $1fd02aa1ed8a7078$var$createScopedSessionState(reportScopeKey, nextCreditsState, snapshotKey, snapshotKey);
        });
    }, []);
    // The reset effect runs after rendering a new scope, so never expose
    // the previous workspace, site or agent state during that render.
    return {
        creditsState: shouldStartSession && sessionState.scopeKey === stateScope ? sessionState.creditsState : $1fd02aa1ed8a7078$var$createEmptySessionState(),
        reportCreditDenial: reportCreditDenial
    };
};
const $1fd02aa1ed8a7078$var$MISSING_PROVIDER_MESSAGE = "[@atlassian/rovo-credits] useCreditsState was called without a CreditsProvider above it. Returning empty credits state, so no credits banner or state changes will be reported. Mount CreditsProvider above this component.";
const $1fd02aa1ed8a7078$export$1a114210ab9abc7a = ()=>{
    const creditsState = (0, $9N9hR.useCreditsStateContext)();
    const isProviderMissing = creditsState === null;
    (0, $cozmU.useEffect)(()=>{
        if (isProviderMissing) // eslint-disable-next-line no-console
        console.error($1fd02aa1ed8a7078$var$MISSING_PROVIDER_MESSAGE);
    }, [
        isProviderMissing
    ]);
    return creditsState ?? (0, $9N9hR.EMPTY_CREDITS_STATE);
};
const $1fd02aa1ed8a7078$var$MISSING_PROVIDER_REPORT_MESSAGE = "[@atlassian/rovo-credits] useReportCreditDenial was called without a CreditsProvider above it. Reported denials are ignored. Mount CreditsProvider above this component.";
const $1fd02aa1ed8a7078$var$ignoreCreditDenial = ()=>{};
const $1fd02aa1ed8a7078$export$f47dbea17bbdacf1 = ()=>{
    const reportCreditDenial = (0, $9N9hR.useCreditsDenialReporterContext)();
    const isProviderMissing = reportCreditDenial === null;
    (0, $cozmU.useEffect)(()=>{
        if (isProviderMissing) // eslint-disable-next-line no-console
        console.error($1fd02aa1ed8a7078$var$MISSING_PROVIDER_REPORT_MESSAGE);
    }, [
        isProviderMissing
    ]);
    return reportCreditDenial ?? $1fd02aa1ed8a7078$var$ignoreCreditDenial;
};
/**
 * Starts the active credits session for a mounted provider subtree.
 *
 * The raw `CreditsStateContext.Provider` only stores a value. This component
 * owns the active backend/coordinator session for that context value.
 * `CreditsProvider` always renders it; `enabled` only decides whether browser
 * coordination starts, so gate-off renders keep the same component shape.
 */ const $1fd02aa1ed8a7078$var$CreditsProviderSession = ({ children: children, enabled: enabled, product: product, cloudId: cloudId, workspaceId: workspaceId, usageEnvironment: usageEnvironment, onError: onError, onCreditRequestResult: onCreditRequestResult, agentId: agentId })=>{
    const { creditsState: creditsState, reportCreditDenial: reportCreditDenial } = $1fd02aa1ed8a7078$var$useCreditsSessionState({
        enabled: enabled,
        product: product,
        cloudId: cloudId?.trim() || undefined,
        workspaceId: workspaceId,
        // Blank ids are omitted by the backend client, so they must not scope the
        // session either, or "" and no agent would stop sharing state.
        agentId: agentId?.trim() || undefined,
        onError: onError ?? null
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ezd2Q.CreditsUsageContext).Provider, {
        value: (0, $325xw.getCreditsUsageUrl)(cloudId, usageEnvironment)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9N9hR.CreditsDenialReporterContext).Provider, {
        value: reportCreditDenial
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9N9hR.CreditsStateContext).Provider, {
        value: creditsState
    }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8pmO0.CreditsRequestProvider), {
        product: product,
        cloudId: cloudId,
        workspaceId: workspaceId,
        agentId: agentId,
        enabled: enabled,
        state: creditsState.bannerState,
        onResult: onCreditRequestResult,
        children: children
    }))));
};
const $1fd02aa1ed8a7078$export$c0580f4fcf3f66d5 = ({ children: children, product: product, cloudId: cloudId, workspaceId: workspaceId, usageEnvironment: usageEnvironment, isRovoEnabled: isRovoEnabled = true, onError: onError, onCreditRequestResult: onCreditRequestResult, agentId: agentId })=>{
    const [isEnabled, setIsEnabled] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        // Defer the gate read until after mount so server and client render the
        // same provider tree first. Startup remains disabled until the gate can
        // be evaluated in the browser.
        setIsEnabled((0, $1iTIy.isCreditsDegradationUiEnabled)());
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1fd02aa1ed8a7078$var$CreditsProviderSession, {
        children: children,
        enabled: isEnabled && isRovoEnabled,
        product: product,
        cloudId: cloudId,
        workspaceId: workspaceId?.trim() || undefined,
        usageEnvironment: usageEnvironment,
        onError: onError,
        onCreditRequestResult: onCreditRequestResult,
        agentId: agentId
    });
};
module.exports["useCreditsState"] = $1fd02aa1ed8a7078$export$1a114210ab9abc7a;
module.exports["useReportCreditDenial"] = $1fd02aa1ed8a7078$export$f47dbea17bbdacf1;
module.exports["CreditsProvider"] = $1fd02aa1ed8a7078$export$c0580f4fcf3f66d5;

});

parcelRegister("3TVAD", function(module, exports) {

var $evsJv = parcelRequire("evsJv");

const $579ea7bb1bb43094$var$KNOWN_DENIAL_SCOPES = new Set([
    'ORGANIZATION',
    'USER',
    'AGENT'
]);
const $579ea7bb1bb43094$export$2786bac338df9c24 = (value)=>(0, $evsJv.isValidTimestamp)(value) && value > 0 && !Number.isNaN(new Date(value).getTime()) ? value : undefined;
// An unknown mode is treated as EMAIL, but a redirect without a usable web URL offers nothing.
const $579ea7bb1bb43094$var$parseRequestMethod = (value)=>{
    if (!(0, $evsJv.isRecord)(value) || typeof value.mode !== 'string') return undefined;
    if (value.mode !== 'REDIRECT_URL') return {
        mode: 'EMAIL'
    };
    try {
        const { protocol: protocol, username: username, password: password } = new URL(String(value.redirectUrl));
        return protocol === 'https:' && !username && !password && String(value.redirectUrl).length <= 2048 ? {
            mode: 'REDIRECT_URL',
            redirectUrl: String(value.redirectUrl)
        } : undefined;
    } catch  {
        return undefined;
    }
};
const $579ea7bb1bb43094$export$a236b91420bf4eb5 = (denial)=>{
    const scope = $579ea7bb1bb43094$var$KNOWN_DENIAL_SCOPES.has(denial.scope) ? denial.scope : 'UNKNOWN';
    const resetsAt = scope === 'UNKNOWN' ? undefined : $579ea7bb1bb43094$export$2786bac338df9c24(denial.resetsAt);
    const requestMethod = scope === 'USER' ? $579ea7bb1bb43094$var$parseRequestMethod(denial.requestMethod) : undefined;
    return {
        scope: scope,
        ...resetsAt !== undefined ? {
            resetsAt: resetsAt
        } : {},
        ...requestMethod !== undefined ? {
            requestMethod: requestMethod
        } : {}
    };
};
const $579ea7bb1bb43094$export$f027d647018d66fd = (denial)=>{
    if (!(0, $evsJv.isRecord)(denial)) return null;
    const { scope: scope, resetsAt: resetsAt, requestMethod: requestMethod } = denial;
    return $579ea7bb1bb43094$export$a236b91420bf4eb5({
        scope: scope,
        ...resetsAt !== undefined ? {
            resetsAt: resetsAt
        } : {},
        ...requestMethod !== undefined ? {
            requestMethod: requestMethod
        } : {}
    });
};
module.exports["getResetDate"] = $579ea7bb1bb43094$export$2786bac338df9c24;
module.exports["parseCreditDenial"] = $579ea7bb1bb43094$export$a236b91420bf4eb5;
module.exports["normalizeReportedCreditDenial"] = $579ea7bb1bb43094$export$f027d647018d66fd;

});

parcelRegister("evsJv", function(module, exports) {
const $0d6b1247cb920175$export$6ba840931da50680 = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) && Reflect.ownKeys(value).every((key)=>typeof key === 'string');
const $0d6b1247cb920175$export$e1fe2eb830813601 = (value)=>typeof value === 'string' && value.trim().length > 0;
const $0d6b1247cb920175$export$5f870fcca7ae6a88 = (value)=>typeof value === 'number' && Number.isFinite(value) && value >= 0;
module.exports["isRecord"] = $0d6b1247cb920175$export$6ba840931da50680;
module.exports["isNonEmptyString"] = $0d6b1247cb920175$export$e1fe2eb830813601;
module.exports["isValidTimestamp"] = $0d6b1247cb920175$export$5f870fcca7ae6a88;

});

parcelRegister("325xw", function(module, exports) {
const $d507f07f8d500927$export$a21c27ccae4aa2e = (cloudId, environment = 'production')=>{
    const siteId = cloudId?.trim();
    if (!siteId) return undefined;
    const origin = environment === 'staging' ? 'https://home.stg.atlassian.com' : 'https://home.atlassian.com';
    const query = new URLSearchParams({
        cloudId: siteId
    });
    return `${origin}/usage?${query.toString()}`;
};
module.exports["getCreditsUsageUrl"] = $d507f07f8d500927$export$a21c27ccae4aa2e;

});

parcelRegister("cOJFA", function(module, exports) {
const $138a597dce8224aa$var$ErrorBase = Error;
const $138a597dce8224aa$export$ff654df971616da8 = class ErrorWithCause extends $138a597dce8224aa$var$ErrorBase {
    constructor(message, options){
        super(message, options);
        this.name = 'ErrorWithCause';
        const cause = options?.cause;
        if (cause !== undefined && !Object.prototype.hasOwnProperty.call(this, 'cause')) Object.defineProperty(this, 'cause', {
            value: cause,
            configurable: true,
            writable: true
        });
    }
};
const $138a597dce8224aa$export$947da545c279cc22 = (cause)=>{
    if (cause instanceof Error || typeof cause === 'string' || cause === null || cause === undefined) return cause;
    try {
        return String(cause);
    } catch  {
        return '[object Object]';
    }
};
module.exports["ErrorWithCause"] = $138a597dce8224aa$export$ff654df971616da8;
module.exports["normalizeErrorCause"] = $138a597dce8224aa$export$947da545c279cc22;

});

parcelRegister("1iTIy", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $9a2d78fdc1441d34$export$eda4117e2771dab6 = ()=>{
    try {
        return (0, $iDrrr.fg)('rovo_credits_degradation_ui');
    } catch  {
        // Feature-gate lookup should not be able to crash Rovo surfaces. When
        // the gate cannot be evaluated, treat it as off.
        return false;
    }
};
module.exports["isCreditsDegradationUiEnabled"] = $9a2d78fdc1441d34$export$eda4117e2771dab6;

});

parcelRegister("bfMSr", function(module, exports) {
const $0e25b9f927bb7fd9$export$576342365521bcfc = ({ leaderTabId: leaderTabId, updatedAt: updatedAt })=>`${leaderTabId}:${updatedAt}`;
module.exports["getStoredSnapshotId"] = $0e25b9f927bb7fd9$export$576342365521bcfc;

});

parcelRegister("er5PO", function(module, exports) {

var $ez9fa = parcelRequire("ez9fa");

const $e1f55feafbd60001$export$ce920dcd020750ba = ({ denial: denial, warning: warning })=>{
    if (denial === null) return warning ? {
        balanceState: 'warning',
        depletionBehavior: null,
        scope: warning.scope,
        ...warning.resetsAt !== undefined ? {
            resetDate: warning.resetsAt
        } : {}
    } : {
        balanceState: 'healthy',
        depletionBehavior: null
    };
    return {
        balanceState: 'depleted',
        depletionBehavior: 'block',
        scope: denial.scope,
        ...denial.resetsAt !== undefined ? {
            resetDate: denial.resetsAt
        } : {},
        ...denial.requestMethod !== undefined && (0, $ez9fa.canScopeRequestCredits)(denial.scope) ? {
            requestMethod: denial.requestMethod,
            canRequestCredits: true
        } : {}
    };
};
const $e1f55feafbd60001$var$hasDepletedBalance = ({ balanceState: balanceState })=>balanceState === 'depleted';
const $e1f55feafbd60001$var$hasBlockedDepletionBehavior = ({ balanceState: balanceState, depletionBehavior: depletionBehavior })=>balanceState === 'depleted' && depletionBehavior === 'block';
const $e1f55feafbd60001$var$CREDITS_BANNER_STATE_COMPARISON_KEYS = {
    balanceState: true,
    depletionBehavior: true,
    scope: true,
    resetDate: true,
    canRequestCredits: true
};
const $e1f55feafbd60001$var$creditsBannerStateComparisonKeys = Object.keys($e1f55feafbd60001$var$CREDITS_BANNER_STATE_COMPARISON_KEYS);
const $e1f55feafbd60001$var$getRequestMethodKey = ({ requestMethod: requestMethod })=>requestMethod?.mode === 'REDIRECT_URL' ? `${requestMethod.mode}:${requestMethod.redirectUrl}` : requestMethod?.mode;
const $e1f55feafbd60001$export$8b8e1f09ac398df2 = (previousState, nextState)=>$e1f55feafbd60001$var$creditsBannerStateComparisonKeys.every((comparisonKey)=>previousState[comparisonKey] === nextState[comparisonKey]) && $e1f55feafbd60001$var$getRequestMethodKey(previousState) === $e1f55feafbd60001$var$getRequestMethodKey(nextState);
const $e1f55feafbd60001$export$d1af85350d69e790 = (previousState, nextState)=>{
    if (previousState === null) // The first accepted snapshot is current state, not a newly-entered
    // state. Do not fire entry effects for a warning/block that already
    // existed before the provider mounted.
    return {
        isInitial: true,
        enteredHealthy: false,
        enteredDepleted: false,
        enteredBlocked: false,
        shouldResetDismissal: false
    };
    return {
        isInitial: false,
        enteredHealthy: previousState.balanceState !== 'healthy' && nextState.balanceState === 'healthy',
        enteredDepleted: !$e1f55feafbd60001$var$hasDepletedBalance(previousState) && $e1f55feafbd60001$var$hasDepletedBalance(nextState),
        enteredBlocked: !$e1f55feafbd60001$var$hasBlockedDepletionBehavior(previousState) && $e1f55feafbd60001$var$hasBlockedDepletionBehavior(nextState),
        shouldResetDismissal: previousState.balanceState !== nextState.balanceState || previousState.depletionBehavior !== nextState.depletionBehavior || previousState.scope !== nextState.scope
    };
};
module.exports["deriveCreditsBannerState"] = $e1f55feafbd60001$export$ce920dcd020750ba;
module.exports["areCreditsBannerStatesEqual"] = $e1f55feafbd60001$export$8b8e1f09ac398df2;
module.exports["deriveCreditsBannerStateChange"] = $e1f55feafbd60001$export$d1af85350d69e790;

});

parcelRegister("ez9fa", function(module, exports) {
const $6d6b6e111cf9ad11$export$3a9cbfc39830d870 = (scope)=>scope !== 'ORGANIZATION' && scope !== 'UNKNOWN';
const $6d6b6e111cf9ad11$export$7385b2da815a263f = (scope)=>scope !== 'UNKNOWN';
module.exports["canScopeRequestCredits"] = $6d6b6e111cf9ad11$export$3a9cbfc39830d870;
module.exports["canScopeShowResetDate"] = $6d6b6e111cf9ad11$export$7385b2da815a263f;

});

parcelRegister("8pmO0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $0E2ZR = parcelRequire("0E2ZR");


var $4wPaJ = parcelRequire("4wPaJ");

const $5658fc7cce06419f$var$CreditsRequestContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $5658fc7cce06419f$export$8be04bfefd206000 = ()=>(0, $cozmU.useContext)($5658fc7cce06419f$var$CreditsRequestContext);
const $5658fc7cce06419f$export$4c26c27af9c29b22 = ()=>{
    const value = $5658fc7cce06419f$export$8be04bfefd206000();
    return {
        isPending: value?.isPending ?? false,
        result: value?.result ?? null
    };
};
const $5658fc7cce06419f$var$RequestProvider = ({ children: children, product: product, cloudId: cloudId, workspaceId: workspaceId, agentId: agentId, state: state, enabled: enabled, onResult: onResult })=>{
    const [successScope, setSuccessScope] = (0, $cozmU.useState)(null);
    const [isPending, setPending] = (0, $cozmU.useState)(false);
    const [result, setResult] = (0, $cozmU.useState)(null);
    const inFlight = (0, $cozmU.useRef)(false);
    const controller = (0, $cozmU.useRef)(null);
    const mounted = (0, $cozmU.useRef)(true);
    (0, $cozmU.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
            controller.current?.abort();
        };
    }, []);
    const method = state?.balanceState === 'depleted' && state.scope === 'USER' ? state.requestMethod : undefined;
    const eligible = enabled && Boolean(cloudId?.trim()) && Boolean(method);
    // Only identity changes invalidate an in-flight POST.
    const scopeKey = JSON.stringify([
        product,
        cloudId,
        workspaceId?.trim() || undefined,
        agentId,
        enabled
    ]);
    const creditStateKey = JSON.stringify([
        state?.balanceState,
        state?.scope,
        state?.resetDate,
        method
    ]);
    const current = (0, $cozmU.useRef)({
        eligible: eligible,
        method: method,
        scopeKey: scopeKey
    });
    current.current = {
        eligible: eligible,
        method: method,
        scopeKey: scopeKey
    };
    (0, $cozmU.useEffect)(()=>{
        controller.current?.abort();
        controller.current = null;
        inFlight.current = false;
        setPending(false);
        setSuccessScope(null);
        setResult(null);
    }, [
        scopeKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Polling may update metadata while a request is being delivered.
        // Keep that request and its outcome, but reset idle state for a new credit decision.
        if (!inFlight.current) setResult(null);
    }, [
        creditStateKey,
        eligible,
        method?.mode
    ]);
    const send = async ()=>{
        if (inFlight.current || !current.current.eligible || current.current.method?.mode !== 'EMAIL') return;
        inFlight.current = true;
        setSuccessScope(null);
        setPending(true);
        setResult(null);
        const abortController = new AbortController();
        controller.current = abortController;
        const timeout = setTimeout(()=>abortController.abort(), 30000);
        let outcome;
        try {
            outcome = await (0, $0E2ZR.createCreditsBackendClient)({
                product: product,
                cloudId: cloudId,
                workspaceId: workspaceId,
                agentId: agentId
            }).requestCredits({
                signal: abortController.signal
            });
        } catch  {
            outcome = {
                outcome: 'failed'
            };
        } finally{
            clearTimeout(timeout);
            if (controller.current === abortController) inFlight.current = false;
        }
        if (!mounted.current || controller.current !== abortController || current.current.scopeKey !== scopeKey) return;
        setPending(false);
        setResult(outcome);
        if (outcome.outcome === 'accepted') setSuccessScope(scopeKey);
        onResult?.(outcome);
    };
    const start = ()=>{
        if (!eligible || inFlight.current) return;
        if (method?.mode === 'REDIRECT_URL') window.open(method.redirectUrl, '_blank', 'noopener,noreferrer');
        else send();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5658fc7cce06419f$var$CreditsRequestContext.Provider, {
        value: {
            isPending: isPending,
            result: result,
            start: start,
            isUnavailable: !eligible
        }
    }, children, successScope === scopeKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4wPaJ.CreditRequestSuccessFlag), {
        onDismiss: ()=>setSuccessScope(null)
    }));
};
const $5658fc7cce06419f$export$526b981c47a13cff = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5658fc7cce06419f$var$RequestProvider, props);
module.exports["useCreditsRequestContext"] = $5658fc7cce06419f$export$8be04bfefd206000;
module.exports["useCreditsRequest"] = $5658fc7cce06419f$export$4c26c27af9c29b22;
module.exports["CreditsRequestProvider"] = $5658fc7cce06419f$export$526b981c47a13cff;

});

parcelRegister("0E2ZR", function(module, exports) {

var $3TVAD = parcelRequire("3TVAD");


var $cOJFA = parcelRequire("cOJFA");


var $evsJv = parcelRequire("evsJv");

class $7dbbf8097b789e69$export$b4fdaf542cb2fcdb extends (0, $cOJFA.ErrorWithCause) {
    constructor(message, cause){
        super(message, cause !== undefined ? {
            cause: cause
        } : undefined);
        this.name = 'CreditsBackendClientError';
    }
}
const $7dbbf8097b789e69$var$DEFAULT_CREDITS_BACKEND_PATH = '/gateway/api/assist/api/rovo/v1/credits/state';
const $7dbbf8097b789e69$var$EXPERIENCE_ID = 'ai-mate';
// The warning is advisory, so a malformed one is dropped instead of rejecting the response.
const $7dbbf8097b789e69$var$parseCreditWarning = (warning)=>{
    if (!(0, $evsJv.isRecord)(warning) || warning.scope !== 'ORGANIZATION') return undefined;
    const resetsAt = (0, $3TVAD.getResetDate)(warning.resetsAt);
    return {
        scope: 'ORGANIZATION',
        ...resetsAt !== undefined ? {
            resetsAt: resetsAt
        } : {}
    };
};
const $7dbbf8097b789e69$var$withWarning = (snapshot, warning)=>{
    const parsedWarning = snapshot.denial === null ? $7dbbf8097b789e69$var$parseCreditWarning(warning) : undefined;
    return parsedWarning === undefined ? snapshot : {
        ...snapshot,
        warning: parsedWarning
    };
};
const $7dbbf8097b789e69$export$f46ef261c1fb6fe8 = (value)=>{
    if (!(0, $evsJv.isRecord)(value)) return null;
    const { asOf: asOf, updatedAt: updatedAt, expiresAt: expiresAt, denial: denial, warning: warning } = value;
    if (!(0, $evsJv.isValidTimestamp)(asOf) || !(0, $evsJv.isValidTimestamp)(updatedAt) || !(0, $evsJv.isValidTimestamp)(expiresAt) || expiresAt <= updatedAt || denial === undefined) return null;
    if (denial === null) return $7dbbf8097b789e69$var$withWarning({
        asOf: asOf,
        updatedAt: updatedAt,
        expiresAt: expiresAt,
        denial: null
    }, warning);
    return (0, $evsJv.isRecord)(denial) ? {
        asOf: asOf,
        updatedAt: updatedAt,
        expiresAt: expiresAt,
        denial: (0, $3TVAD.parseCreditDenial)(denial)
    } : null;
};
/** Adapt the pre-flight response to the existing session and consumer state model. */ const $7dbbf8097b789e69$var$parseCreditStateResponse = (value)=>{
    if (!(0, $evsJv.isRecord)(value)) return null;
    const { asOf: asOf, refreshAfterSeconds: refreshAfterSeconds, denial: denial, warning: warning } = value;
    if (!(0, $evsJv.isValidTimestamp)(asOf) || typeof refreshAfterSeconds !== 'number' || !Number.isFinite(refreshAfterSeconds) || refreshAfterSeconds <= 0 || denial != null && !(0, $evsJv.isRecord)(denial)) return null;
    // Schedule relative to receipt, not the server clock (which may be skewed).
    const updatedAt = Date.now();
    const expiresAt = updatedAt + refreshAfterSeconds * 1000;
    if (!(0, $evsJv.isValidTimestamp)(expiresAt) || expiresAt <= updatedAt) return null;
    return $7dbbf8097b789e69$var$withWarning({
        asOf: asOf,
        updatedAt: updatedAt,
        expiresAt: expiresAt,
        denial: (0, $evsJv.isRecord)(denial) ? (0, $3TVAD.parseCreditDenial)(denial) : null
    }, warning);
};
const $7dbbf8097b789e69$var$withAgentId = (endpoint, agentId)=>{
    const trimmedAgentId = agentId?.trim();
    if (!trimmedAgentId) return endpoint;
    return `${endpoint}${endpoint.includes('?') ? '&' : '?'}agentId=${encodeURIComponent(trimmedAgentId)}`;
};
const $7dbbf8097b789e69$var$resolveCreditsBackendFetch = (fetchOverride)=>{
    if (fetchOverride !== undefined) return fetchOverride;
    if (typeof globalThis.fetch !== 'function') throw new $7dbbf8097b789e69$export$b4fdaf542cb2fcdb('Credits backend fetch is unavailable.');
    return globalThis.fetch.bind(globalThis);
};
const $7dbbf8097b789e69$export$d2bee51890c91a9 = ({ product: product, cloudId: cloudId, workspaceId: workspaceId, agentId: agentId, fetch: fetchOverride, endpoint: endpoint = $7dbbf8097b789e69$var$DEFAULT_CREDITS_BACKEND_PATH })=>{
    if (!(0, $evsJv.isNonEmptyString)(endpoint)) throw new $7dbbf8097b789e69$export$b4fdaf542cb2fcdb('Credits backend endpoint is empty or blank.');
    const normalizedEndpoint = $7dbbf8097b789e69$var$withAgentId(endpoint.trim(), agentId);
    const creditsBackendFetch = $7dbbf8097b789e69$var$resolveCreditsBackendFetch(fetchOverride);
    const headers = {
        Accept: 'application/json',
        'X-Product': product,
        'X-Experience-Id': $7dbbf8097b789e69$var$EXPERIENCE_ID
    };
    if (cloudId?.trim()) {
        headers['Atl-Cloudid'] = cloudId.trim();
        headers['X-Cloudid'] = cloudId.trim();
    }
    if (workspaceId?.trim()) headers['X-Workspace-Id'] = workspaceId.trim();
    return {
        requestCredits: async ({ signal: signal } = {})=>{
            if (!cloudId?.trim()) return {
                outcome: 'unavailable',
                status: 400
            };
            try {
                const response = await creditsBackendFetch($7dbbf8097b789e69$var$withAgentId('/gateway/api/assist/api/rovo/v1/credits/requests', agentId), {
                    method: 'POST',
                    credentials: 'include',
                    headers: headers,
                    ...signal !== undefined ? {
                        signal: signal
                    } : {}
                });
                if (response.status === 202) {
                    const payload = await response.json();
                    return (0, $evsJv.isRecord)(payload) && (0, $evsJv.isNonEmptyString)(payload.requestId) ? {
                        outcome: 'accepted',
                        requestId: payload.requestId
                    } : {
                        outcome: 'failed',
                        status: 202
                    };
                }
                if (response.status === 429) {
                    const raw = response.headers?.get('Retry-After');
                    const seconds = raw?.trim() ? Number(raw) : NaN;
                    return {
                        outcome: 'rate-limited',
                        ...Number.isFinite(seconds) && seconds >= 0 ? {
                            retryAfterSeconds: seconds
                        } : {}
                    };
                }
                if ([
                    400,
                    401,
                    403,
                    404,
                    409
                ].includes(response.status)) return {
                    outcome: 'unavailable',
                    status: response.status
                };
                return {
                    outcome: 'failed',
                    status: response.status
                };
            } catch  {
                return {
                    outcome: 'failed'
                };
            }
        },
        getCreditsState: async ({ signal: signal } = {})=>{
            let response;
            try {
                response = await creditsBackendFetch(normalizedEndpoint, {
                    method: 'GET',
                    credentials: 'include',
                    headers: headers,
                    ...signal !== undefined ? {
                        signal: signal
                    } : {}
                });
            } catch (cause) {
                throw new $7dbbf8097b789e69$export$b4fdaf542cb2fcdb('Credits backend request failed.', (0, $cOJFA.normalizeErrorCause)(cause));
            }
            if (response.status !== 200) {
                // Pre-flight is advisory: clear a previous block on HTTP errors. The
                // action backend remains responsible for enforcement at time of use.
                const now = Date.now();
                return {
                    asOf: now,
                    updatedAt: now,
                    expiresAt: now + 60000,
                    denial: null
                };
            }
            let payload;
            try {
                payload = await response.json();
            } catch (cause) {
                throw new $7dbbf8097b789e69$export$b4fdaf542cb2fcdb('Credits backend response was not valid JSON.', (0, $cOJFA.normalizeErrorCause)(cause));
            }
            const snapshot = $7dbbf8097b789e69$var$parseCreditStateResponse(payload);
            if (snapshot === null) throw new $7dbbf8097b789e69$export$b4fdaf542cb2fcdb('Credits backend response shape was invalid.');
            return snapshot;
        }
    };
};
module.exports["CreditsBackendClientError"] = $7dbbf8097b789e69$export$b4fdaf542cb2fcdb;
module.exports["parseCreditsBackendSnapshot"] = $7dbbf8097b789e69$export$f46ef261c1fb6fe8;
module.exports["createCreditsBackendClient"] = $7dbbf8097b789e69$export$d2bee51890c91a9;

});

parcelRegister("4wPaJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $FKQbh = parcelRequire("FKQbh");


var $lqtHz = parcelRequire("lqtHz");


var $chu6R = parcelRequire("chu6R");


var $9Zo8c = parcelRequire("9Zo8c");

const $1d650994e855a4c9$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "rovo-credits.internal.credit-request-success-flag.title",
        defaultMessage: "Request sent"
    },
    body: {
        id: "rovo-credits.internal.credit-request-success-flag.body",
        defaultMessage: "We sent your request for more credits to your organization admins."
    }
});
const $1d650994e855a4c9$var$SuccessFlag = ({ onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const id = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lqtHz.FlagGroup), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $FKQbh.default), {
        id: id,
        appearance: "normal",
        title: formatMessage($1d650994e855a4c9$var$messages.title),
        description: formatMessage($1d650994e855a4c9$var$messages.body),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
            label: "",
            color: "var(--ds-icon-success, #6A9A23)"
        }),
        onDismissed: onDismiss
    }));
};
const $1d650994e855a4c9$export$3d363b97f9014d49 = ({ onDismiss: onDismiss })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zo8c.RovoCreditsIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d650994e855a4c9$var$SuccessFlag, {
        onDismiss: onDismiss
    }));
module.exports["CreditRequestSuccessFlag"] = $1d650994e855a4c9$export$3d363b97f9014d49;

});

parcelRegister("9Zo8c", function(module, exports) {

var $aibb0 = parcelRequire("aibb0");


var $d9eT2 = parcelRequire("d9eT2");


var $6ut7B = parcelRequire("6ut7B");

const $6b0951636ec4ec52$export$2c5531e7fea471d2 = (0, $aibb0.createAsyncIntlProvider)({
    defaultMessages: (0, $6ut7B.default),
    asyncLanguages: $d9eT2.asyncLanguages
});
module.exports["RovoCreditsIntlProvider"] = $6b0951636ec4ec52$export$2c5531e7fea471d2;

});

parcelRegister("aibb0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");

function $5a198a38a6368eba$export$6fa362ed4e835606({ defaultMessages: defaultMessages, asyncLanguages: asyncLanguages, onLoadError: onLoadError }) {
    const fetchMessagesForLocale = async (locale)=>{
        try {
            // Fallback to the generic locale (e.g. `de`) if the specified
            // region-qualified locale (e.g. `de-DE`) is not present in the map.
            const languageLocale = locale in asyncLanguages ? locale : locale.split(/[-_]/)[0] || '';
            const localeMessages = await asyncLanguages[languageLocale]?.();
            return localeMessages?.default ?? defaultMessages;
        } catch (e) {
            onLoadError?.(locale, e);
        }
        return defaultMessages;
    };
    return function AsyncIntlProvider({ children: children, disabled: disabled = false }) {
        if (disabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        // `fetchMessagesForLocale` is defined once at factory-call time and
        // closed over here, so its identity is already stable across renders
        // of this returned component — no `useCallback` needed.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: defaultMessages,
            loaderFn: fetchMessagesForLocale
        }, children);
    };
}
module.exports["createAsyncIntlProvider"] = $5a198a38a6368eba$export$6fa362ed4e835606;

});

parcelRegister("64VTj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fKN6m = parcelRequire("fKN6m");


var $471nw = parcelRequire("471nw");

const $8ae958986c8c799d$var$IntlMessagesProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IntlMessagesProvider(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { loaderFn: loaderFn, children: children, defaultMessages: defaultMessages } = t0;
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    let t1;
    if ($[0] !== defaultMessages || $[1] !== intl.messages || $[2] !== messages) {
        t1 = {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
        $[0] = defaultMessages;
        $[1] = intl.messages;
        $[2] = messages;
        $[3] = t1;
    } else t1 = $[3];
    const mergedMessages = t1;
    let t2;
    if ($[4] !== children || $[5] !== intl.locale || $[6] !== intl.onError || $[7] !== mergedMessages) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            defaultLocale: "en",
            locale: intl.locale,
            onError: intl.onError,
            messages: mergedMessages
        }, children);
        $[4] = children;
        $[5] = intl.locale;
        $[6] = intl.onError;
        $[7] = mergedMessages;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function IntlMessagesProvider({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $471nw.useSafeIntl)();
    const messages = (0, $fKN6m.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the Intl context (via useSafeIntl) and pass them downstream
   * This prevents the missing messages error.
   */ const mergedMessages = (0, $cozmU.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages
    }, children);
};
var $8ae958986c8c799d$export$2e2bcd8739ae039 = $8ae958986c8c799d$var$IntlMessagesProvider;
module.exports["default"] = $8ae958986c8c799d$export$2e2bcd8739ae039;

});

parcelRegister("fKN6m", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ezgjU = parcelRequire("ezgjU");

const $8781597542fb3a9a$export$4d17e2d9c5348842 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMessages(locale, loaderFn) {
    const $ = (0, $bDgLe.c)(4);
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    let t0;
    let t1;
    if ($[0] !== loaderFn || $[1] !== locale) {
        t0 = ()=>{
            if (locale === loadedLocaleRef.current) return;
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) {
                    loadedLocaleRef.current = locale;
                    setLocaleState({
                        locale: locale,
                        messages: messages ?? {}
                    });
                }
            }, $8781597542fb3a9a$var$_temp);
            return ()=>{
                current = false;
            };
        };
        t1 = [
            loaderFn,
            locale
        ];
        $[0] = loaderFn;
        $[1] = locale;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return localeState.messages;
} : function useMessages(locale, loaderFn) {
    const [localeState, setLocaleState] = (0, $cozmU.useState)((0, $ezgjU.DEFAULT_LOCALE_STATE));
    const loadedLocaleRef = (0, $cozmU.useRef)(localeState.locale);
    (0, $cozmU.useEffect)(()=>{
        // Skip if we already have messages for this locale
        if (locale === loadedLocaleRef.current) return;
        let current = true;
        loaderFn(locale).then((messages)=>{
            if (current) {
                loadedLocaleRef.current = locale;
                setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            }
        }, (error)=>{
            // Handle or log error appropriately
            console.error('Failed to load i18n messages via intl-messages-provider', error);
        });
        return ()=>{
            current = false;
        };
    }, [
        loaderFn,
        locale
    ]);
    return localeState.messages;
};
function $8781597542fb3a9a$var$_temp(error) {
    console.error("Failed to load i18n messages via intl-messages-provider", error);
}
module.exports["useMessages"] = $8781597542fb3a9a$export$4d17e2d9c5348842;

});

parcelRegister("ezgjU", function(module, exports) {
const $c69670c8f17f7b27$export$79618bef82c02d4c = {
    locale: 'en-US',
    messages: undefined
};
module.exports["DEFAULT_LOCALE_STATE"] = $c69670c8f17f7b27$export$79618bef82c02d4c;

});

parcelRegister("471nw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ezgjU = parcelRequire("ezgjU");

// Prevents memory leaks
const $2a38add47fc8c1ad$var$cache = (0, $kSwu1.createIntlCache)();
const $2a38add47fc8c1ad$export$f752ac21ea3960a5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    if (!context) return (0, $kSwu1.createIntl)((0, $ezgjU.DEFAULT_LOCALE_STATE), $2a38add47fc8c1ad$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $2a38add47fc8c1ad$export$f752ac21ea3960a5;

});

parcelRegister("d9eT2", function(module, exports) {

const $fb58c7d796d26205$export$3770c7a7737d463c = {
    en: ()=>Promise.resolve((parcelRequire("6ut7B")))
};
module.exports["asyncLanguages"] = $fb58c7d796d26205$export$3770c7a7737d463c;

});

parcelRegister("6ut7B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gUmQU = parcelRequire("gUmQU");

// Temporary English-only fallback until Traduki publishes the generated Rovo Credits package.
// Do not copy this for other locales; generated Traduki bundles should supply translations.
const $04b9a8b85d7a0d29$var$temporaryEnglishMessages = Object.values((0, $gUmQU.messages)).reduce((acc, message)=>{
    const { defaultMessage: defaultMessage, id: id } = message;
    if (typeof id === 'string' && typeof defaultMessage === 'string') acc[id] = defaultMessage;
    return acc;
}, {});
var $04b9a8b85d7a0d29$export$2e2bcd8739ae039 = $04b9a8b85d7a0d29$var$temporaryEnglishMessages;
module.exports["default"] = $04b9a8b85d7a0d29$export$2e2bcd8739ae039;

});

parcelRegister("gUmQU", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $6d92dfb5e05c1dcc$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    depletedWithContextAndResetDate: {
        id: "rovo-credits.internal.credits-banner-content.depletedWithContextAndResetDate",
        defaultMessage: "Out of Rovo credits. {additionalContext} Resets {resetDate}."
    },
    depletedWithContext: {
        id: "rovo-credits.internal.credits-banner-content.depletedWithContext",
        defaultMessage: "Out of Rovo credits. {additionalContext}"
    },
    warningWithContextAndResetDate: {
        id: "rovo-credits.internal.credits-banner-content.warningWithContextAndResetDate",
        defaultMessage: "Rovo credits running low. {additionalContext} Resets {resetDate}."
    },
    warningWithContext: {
        id: "rovo-credits.internal.credits-banner-content.warningWithContext",
        defaultMessage: "Rovo credits running low. {additionalContext}"
    },
    warningWithResetDate: {
        id: "rovo-credits.internal.credits-banner-content.warningWithResetDate",
        defaultMessage: "Rovo credits running low. Resets {resetDate}."
    },
    warningWithoutResetDate: {
        id: "rovo-credits.internal.credits-banner-content.warningWithoutResetDate",
        defaultMessage: "Rovo credits running low."
    },
    depletedWithResetDate: {
        id: "rovo-credits.internal.credits-banner-content.depletedWithResetDate",
        defaultMessage: "Out of Rovo credits. Resets {resetDate}."
    },
    agentDepletedWithContextAndResetDate: {
        id: "rovo-credits.internal.credits-banner-content.agentDepletedWithContextAndResetDate",
        defaultMessage: "{agentName} is out of Rovo credits. {additionalContext} Resets {resetDate}."
    },
    agentDepletedWithContext: {
        id: "rovo-credits.internal.credits-banner-content.agentDepletedWithContext",
        defaultMessage: "{agentName} is out of Rovo credits. {additionalContext}"
    },
    agentDepletedWithResetDate: {
        id: "rovo-credits.internal.credits-banner-content.agentDepletedWithResetDate",
        defaultMessage: "{agentName} is out of Rovo credits. Resets {resetDate}."
    },
    agentDepletedWithoutResetDate: {
        id: "rovo-credits.internal.credits-banner-content.agentDepletedWithoutResetDate",
        defaultMessage: "{agentName} is out of Rovo credits."
    },
    depletedWithoutResetDate: {
        id: "rovo-credits.internal.credits-banner-content.depletedWithoutResetDate",
        defaultMessage: "Out of Rovo credits."
    },
    requestMore: {
        id: "rovo-credits.internal.credits-banner-content.requestMore",
        defaultMessage: "Request more"
    },
    orViewUsage: {
        id: "rovo-credits.internal.credits-banner-content.orViewUsage",
        defaultMessage: "or <link>view usage</link>"
    },
    viewUsage: {
        id: "rovo-credits.internal.credits-banner-content.viewUsage",
        defaultMessage: "<link>View usage</link>"
    },
    dismissBanner: {
        id: "rovo-credits.credits-banner.dismiss-banner.non-final",
        defaultMessage: "Dismiss banner"
    }
});
module.exports["messages"] = $6d92dfb5e05c1dcc$export$defe85febe8b728c;

});

parcelRegister("9N9hR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $107e6a047ed471d6$export$fbe07a153a0fae08 = Object.freeze({
    bannerState: null,
    bannerStateChange: null
});
const $107e6a047ed471d6$export$6b0caade6b354d19 = (0, $cozmU.createContext)(null);
const $107e6a047ed471d6$export$edd4764ef73b548f = ()=>(0, $cozmU.useContext)($107e6a047ed471d6$export$6b0caade6b354d19);
const $107e6a047ed471d6$export$4b8474ee3d27ad7d = (0, $cozmU.createContext)(null);
const $107e6a047ed471d6$export$f93792d8954000b2 = ()=>(0, $cozmU.useContext)($107e6a047ed471d6$export$4b8474ee3d27ad7d);
module.exports["EMPTY_CREDITS_STATE"] = $107e6a047ed471d6$export$fbe07a153a0fae08;
module.exports["CreditsStateContext"] = $107e6a047ed471d6$export$6b0caade6b354d19;
module.exports["useCreditsStateContext"] = $107e6a047ed471d6$export$edd4764ef73b548f;
module.exports["CreditsDenialReporterContext"] = $107e6a047ed471d6$export$4b8474ee3d27ad7d;
module.exports["useCreditsDenialReporterContext"] = $107e6a047ed471d6$export$f93792d8954000b2;

});

parcelRegister("ezd2Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $3b50f8804ab23e6a$export$f3ff0242dd44707b = (0, $cozmU.createContext)(undefined);
const $3b50f8804ab23e6a$export$aa354e06f905a0c = ()=>(0, $cozmU.useContext)($3b50f8804ab23e6a$export$f3ff0242dd44707b);
module.exports["CreditsUsageContext"] = $3b50f8804ab23e6a$export$f3ff0242dd44707b;
module.exports["useCreditsUsageUrl"] = $3b50f8804ab23e6a$export$aa354e06f905a0c;

});

parcelRegister("hTUNJ", function(module, exports) {

let $d083a2390720bc0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d083a2390720bc0b$var$load("d0ZRF"),
    $d083a2390720bc0b$var$load("k507P"),
    $d083a2390720bc0b$var$load("d3hZ4")
]).then(()=>parcelRequire('kxtLZ'));

});

parcelRegister("aXWtB", function(module, exports) {

var $b8pma = parcelRequire("b8pma");


var $jmjWc = parcelRequire("jmjWc");

const $35c87ab817b10787$var$createLoadingComponent = ()=>{
    return (0, $b8pma.default)({
        name: 'LoadingConfluenceConversationAssistantBundle'
    });
};


const $35c87ab817b10787$export$3ca68d91b1a1bca2 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "HQN7e",
    name: "ConfluenceConversationAssistant",
    loader: async ()=>{
        // Fetch the outer loadable chunk (loadable-ConversationAssistant) AND
        // the AI-mate @atlassian/conversation-assistant chunk in parallel. Both
        // `import()` calls live inside this LoadableLazy object expression, so
        // LoadableMetaBabelPlugin tags them BOTH with this loadable's id — which
        // causes parcel-reporter-loadable to union both bundle groups into
        // preloadAssets for this loadable. Without the second `import()`, the
        // register chunk that owns modules like
        //   platform/…/atlassian-project-status-update-action-renderer/main.tsx
        // (module id 'iuVKP' on CDN / '2xPvv' in local builds) is not included
        // in this loadable's chunk set, and the runtime throws
        //   `Cannot find module 'iuVKP'`
        // when the outer loader's compiled `.then(() => parcelRequire('iuVKP'))`
        // fires.
        const [outer] = await Promise.all([
            (parcelRequire("ePsWq")),
            // eslint-disable-next-line import/dynamic-import-chunkname
            (parcelRequire("ErVgu"))
        ]);
        return outer.ConfluenceConversationAssistant;
    },
    loading: $35c87ab817b10787$var$createLoadingComponent
});
module.exports["ConfluenceConversationAssistant"] = $35c87ab817b10787$export$3ca68d91b1a1bca2;

});

parcelRegister("ePsWq", function(module, exports) {

let $acbc473fddd0453f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $acbc473fddd0453f$var$load("ftNkH"),
    $acbc473fddd0453f$var$load("koqDJ"),
    $acbc473fddd0453f$var$load("mUfsl"),
    $acbc473fddd0453f$var$load("6iTkp"),
    $acbc473fddd0453f$var$load("6wr18"),
    $acbc473fddd0453f$var$load("9TOep"),
    $acbc473fddd0453f$var$load("ffEVr"),
    $acbc473fddd0453f$var$load("2xoIF"),
    $acbc473fddd0453f$var$load("cGkFm"),
    $acbc473fddd0453f$var$load("d0ZRF"),
    $acbc473fddd0453f$var$load("k507P"),
    $acbc473fddd0453f$var$load("hhss7"),
    $acbc473fddd0453f$var$load("ce05o"),
    $acbc473fddd0453f$var$load("bAgF6"),
    $acbc473fddd0453f$var$load("1t4Ce"),
    $acbc473fddd0453f$var$load("1lfcO"),
    $acbc473fddd0453f$var$load("4U6x6"),
    $acbc473fddd0453f$var$load("4bu4H"),
    $acbc473fddd0453f$var$load("7SteV"),
    $acbc473fddd0453f$var$load("hyCrt"),
    $acbc473fddd0453f$var$load("jE0Mz"),
    $acbc473fddd0453f$var$load("iEsP0"),
    $acbc473fddd0453f$var$load("1AybA"),
    $acbc473fddd0453f$var$load("7EorR"),
    $acbc473fddd0453f$var$load("bmOOW"),
    $acbc473fddd0453f$var$load("dDiWc"),
    $acbc473fddd0453f$var$load("fwbNS"),
    $acbc473fddd0453f$var$load("aoJPa")
]).then(()=>parcelRequire('kaQDe'));

});

parcelRegister("ErVgu", function(module, exports) {

let $07996564d0f4f790$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $07996564d0f4f790$var$load("6iTkp"),
    $07996564d0f4f790$var$load("6wr18"),
    $07996564d0f4f790$var$load("7SteV"),
    $07996564d0f4f790$var$load("jE0Mz"),
    $07996564d0f4f790$var$load("9TOep"),
    $07996564d0f4f790$var$load("ffEVr"),
    $07996564d0f4f790$var$load("2xoIF"),
    $07996564d0f4f790$var$load("cGkFm"),
    $07996564d0f4f790$var$load("d0ZRF"),
    $07996564d0f4f790$var$load("k507P"),
    $07996564d0f4f790$var$load("hhss7"),
    $07996564d0f4f790$var$load("7EorR"),
    $07996564d0f4f790$var$load("ce05o")
]).then(()=>parcelRequire('7Myh3'));

});

parcelRegister("7aRa9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $gqqjz = parcelRequire("gqqjz");

function $eb37d7497b3d263d$export$e624a3067d475d88(InnerComponent) {
    var _WithFlags;
    return _WithFlags = class WithFlags extends (0, $cozmU.Component) {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
                to: [
                    (0, $gqqjz.FlagsStateContainer)
                ]
            }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                    ...this.props,
                    flags: flags
                }));
        }
    }, _WithFlags.displayName = `withFlags(${InnerComponent.displayName || InnerComponent.name})`, _WithFlags;
}
module.exports["withFlags"] = $eb37d7497b3d263d$export$e624a3067d475d88;

});

parcelRegister("gEtAQ", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $b5832a8b6d0203e7$export$d9797e3a42403d0f = ()=>Boolean((0, $1NBp8.VIEW_PAGE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$b6ab121b23baa35 = ()=>Boolean((0, $1NBp8.VIEW_BLOG).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(window.location.pathname) || (0, $1NBp8.VIEW_BLOG_MOBILE).match(window.location.pathname));
const $b5832a8b6d0203e7$export$99418391c9d4edd1 = ()=>Boolean((0, $1NBp8.HOME).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3b7cd9ec7876f958 = ()=>Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG_V2).match(window.location.pathname) || (0, $1NBp8.EDIT_PAGE).match(window.location.pathname) || (0, $1NBp8.EDIT_BLOG).match(window.location.pathname));
const $b5832a8b6d0203e7$export$3ea67fa37c59fc23 = ()=>Boolean((0, $1NBp8.SPACE_OVERVIEW).match(window.location.pathname));
const $b5832a8b6d0203e7$export$ea39914fa18450ef = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.DATABASE_VIEW).name;
    return Boolean((0, $1NBp8.DATABASE_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$3a15fff847513284 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.WHITEBOARD_BOARD).name;
    return Boolean((0, $1NBp8.WHITEBOARD_BOARD).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$e40fec4aab490836 = (routeName)=>{
    if (routeName !== undefined && routeName !== null) return routeName === (0, $1NBp8.SLIDES_VIEW).name;
    return Boolean((0, $1NBp8.SLIDES_VIEW).match(window.location.pathname));
};
const $b5832a8b6d0203e7$export$49ce8db5bd2e4087 = (routeName)=>{
    if (!routeName) return false;
    const editRoutes = [
        (0, $1NBp8.EDIT_PAGE_EMBED).name,
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name
    ];
    return editRoutes.includes(routeName);
};
module.exports["isViewPage"] = $b5832a8b6d0203e7$export$d9797e3a42403d0f;
module.exports["isBlogPage"] = $b5832a8b6d0203e7$export$b6ab121b23baa35;
module.exports["isHomePage"] = $b5832a8b6d0203e7$export$99418391c9d4edd1;
module.exports["isSpaceOverview"] = $b5832a8b6d0203e7$export$3ea67fa37c59fc23;
module.exports["isDatabase"] = $b5832a8b6d0203e7$export$ea39914fa18450ef;
module.exports["isWhiteboard"] = $b5832a8b6d0203e7$export$3a15fff847513284;
module.exports["isSlides"] = $b5832a8b6d0203e7$export$e40fec4aab490836;
module.exports["isEditPage"] = $b5832a8b6d0203e7$export$49ce8db5bd2e4087;

});

parcelRegister("i1t43", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $7vK9E = parcelRequire("7vK9E");


var $iMnC5 = parcelRequire("iMnC5");

const $7e44050607850249$var$styles = {
    base: "_0bjKvDcjp5 _0WKd3G4z3T",
    visitedLink: "_2nTuUYWfPD _3ADzdEWfPD _1warJ9WfPD _4scvAwWyeI",
    defaultAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzM7Tp _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5M7Tp _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMM7Tp _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbkAwSC",
    subtleAppearance: "_00uqCYjOvk _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYzZpcK _32C2rkjOvk _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5ZpcK _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMZpcK _3WzCGi98eZ _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbky7kJ",
    inverseAppearance: "_00uqCY98eZ _3xtjKN0Rl6 _0H9qDF6wH8 _23rrnHo10F _1UtDYze5R3 _2nTuUYe5R3 _32C2rk98eZ _0i9AWA0Rl6 _0mm6KQ6wH8 _10n1R5e5R3 _0DCa9DjOvk _3932vv0Rl6 _02cRtH6wH8 _1B4rbIo10F _0clgaMe5R3 _3WzCGijOvk _0NqVRt0Rl6 _3BKYwu6wH8 _3sFUREDdj4 _0CMRbke5R3",
    iconWrapper: "_3iDTPbS8kF _1ANEUSLRg7 _1RrJLiQame _1mT5xdRAKS _2I62gzVQEB"
};
const $7e44050607850249$var$iconStyles = null;
const $7e44050607850249$var$LinkWithoutRef = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let children;
    let htmlAttributes;
    let newWindowLabel;
    let t1;
    let target;
    let testId;
    if ($[0] !== t0) {
        const { children: t2, testId: t3, appearance: t4, newWindowLabel: t5, target: t6, className: _preventedClassName, style: _preventedStyle, ...t7 } = t0;
        children = t2;
        testId = t3;
        t1 = t4;
        newWindowLabel = t5;
        target = t6;
        htmlAttributes = t7;
        $[0] = t0;
        $[1] = children;
        $[2] = htmlAttributes;
        $[3] = newWindowLabel;
        $[4] = t1;
        $[5] = target;
        $[6] = testId;
    } else {
        children = $[1];
        htmlAttributes = $[2];
        newWindowLabel = $[3];
        t1 = $[4];
        target = $[5];
        testId = $[6];
    }
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = appearance === "default" && $7e44050607850249$var$styles.defaultAppearance;
    const t3 = appearance === "subtle" && $7e44050607850249$var$styles.subtleAppearance;
    const t4 = appearance === "inverse" && $7e44050607850249$var$styles.inverseAppearance;
    const t5 = appearance !== "inverse" && $7e44050607850249$var$styles.visitedLink;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
        t6 = (0, $w6R6I.cx)($7e44050607850249$var$styles.base, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== target || $[13] !== testId) {
        t7 = target === "_blank" && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            as: "span",
            xcss: $7e44050607850249$var$styles.iconWrapper,
            testId: testId && `${testId}__icon`,
            children: [
                "\uFEFF",
                /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                    width: "12",
                    height: "12",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    className: (0, $hekY6.default)([
                        "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                        fill: "currentColor"
                    })
                })
            ]
        });
        $[12] = target;
        $[13] = testId;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== children || $[16] !== htmlAttributes || $[17] !== newWindowLabel || $[18] !== ref || $[19] !== t6 || $[20] !== t7 || $[21] !== target || $[22] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            ...htmlAttributes,
            target: target,
            ref: ref,
            xcss: t6,
            testId: testId,
            componentName: "Link",
            newWindowLabel: newWindowLabel,
            children: [
                children,
                t7
            ]
        });
        $[15] = children;
        $[16] = htmlAttributes;
        $[17] = newWindowLabel;
        $[18] = ref;
        $[19] = t6;
        $[20] = t7;
        $[21] = target;
        $[22] = testId;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ children: children, testId: testId, appearance: appearance = 'default', newWindowLabel: newWindowLabel, target: target, // @ts-expect-error
className: _preventedClassName, // @ts-expect-error
style: _preventedStyle, ...htmlAttributes }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    ), {
        ...htmlAttributes,
        target: target,
        ref: ref,
        xcss: (0, $w6R6I.cx)($7e44050607850249$var$styles.base, appearance === 'default' && $7e44050607850249$var$styles.defaultAppearance, appearance === 'subtle' && $7e44050607850249$var$styles.subtleAppearance, appearance === 'inverse' && $7e44050607850249$var$styles.inverseAppearance, // Visited styles are not supported for inverse links due to contrast issues
        appearance !== 'inverse' && $7e44050607850249$var$styles.visitedLink),
        testId: testId,
        componentName: "Link",
        newWindowLabel: newWindowLabel,
        children: [
            children,
            target === '_blank' && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                as: "span",
                xcss: $7e44050607850249$var$styles.iconWrapper,
                testId: testId && `${testId}__icon`,
                children: [
                    "\uFEFF",
                    /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
                        width: "12",
                        height: "12",
                        viewBox: "0 0 12 12",
                        fill: "none",
                        className: (0, $hekY6.default)([
                            "_39xV02YsW8 _0jFU0VYsW8 _0GTcwRu3qR"
                        ]),
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M0 1.82609C0 0.817938 0.817938 0 1.82609 0H3.91304V1.04348H1.82609C1.39424 1.04348 1.04348 1.39424 1.04348 1.82609V10.1739C1.04348 10.6058 1.39424 10.9565 1.82609 10.9565H10.1739C10.6058 10.9565 10.9565 10.6058 10.9565 10.1739V8.08696H12V10.1739C12 11.1821 11.1821 12 10.1739 12H1.82609C0.817938 12 0 11.1821 0 10.1739V1.82609ZM7.04348 0H12V4.95652H10.9565V1.78133L6.36893 6.36893L5.63107 5.63107L10.2187 1.04348H7.04348V0Z",
                            fill: "currentColor"
                        })
                    })
                ]
            })
        ]
    }); // Workarounds to support generic types with forwardRef
/**
 * __Link__
 *
 * A link is an inline text element that navigates to a new location when clicked.
 *
 * - [Examples](https://atlassian.design/components/primitives/link/examples)
 * - [Code](https://atlassian.design/components/primitives/link/code)
 * - [Usage](https://atlassian.design/components/primitives/link/usage)
 */ const $7e44050607850249$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)($7e44050607850249$var$LinkWithoutRef);
var $7e44050607850249$export$2e2bcd8739ae039 = $7e44050607850249$var$Link;
module.exports["default"] = $7e44050607850249$export$2e2bcd8739ae039;

});

parcelRegister("4o1RV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $1eD4P = parcelRequire("1eD4P");


var $ihkY1 = parcelRequire("ihkY1");


var $kBW0t = parcelRequire("kBW0t");

function $f3bd82ae210529c7$export$57395cb9dce31159() {
    const $ = (0, $bDgLe.c)(3);
    const { navigationPolicy: navigationPolicy } = (0, $1eD4P.useReactProps_DO_NOT_USE)() || {};
    const routePolicy = (0, $ihkY1.useRoutePolicy)(navigationPolicy);
    const shimUrl = (0, $kBW0t.useShimUrl)(navigationPolicy);
    let t0;
    if ($[0] !== routePolicy || $[1] !== shimUrl) {
        t0 = {
            routePolicy: routePolicy,
            ...shimUrl
        };
        $[0] = routePolicy;
        $[1] = shimUrl;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
}
module.exports["useNavigationPolicy"] = $f3bd82ae210529c7$export$57395cb9dce31159;

});

parcelRegister("ihkY1", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lTECB = parcelRequire("lTECB");


var $1eD4P = parcelRequire("1eD4P");


var $cb6fO = parcelRequire("cb6fO");


var $kBW0t = parcelRequire("kBW0t");

function $477c5af85d2d7fb0$export$53e37724c6846f41(navigationPolicy) {
    const isEmbeddedConfluence = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const { shimUrl: shimUrl } = (0, $kBW0t.useShimUrl)(navigationPolicy);
    const iframePassThroughProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    const enableIframeSpaTransitions = iframePassThroughProps?.enableSpaTransitions;
    const getEmbeddedConfluenceRoutePolicy = (0, $cozmU.useCallback)(()=>({
            push ({ match: match, matchSupportedRoute: matchSupportedRoute, open: open, push: defaultPush }, url, forceReload) {
                // When navigate to an url with anchor only e.g. `#test`, the navigation doesn't need to continue as SPA transition,
                // Hence, there is no need to continue the navigation using `push` and potentially execute parent product's navigate method.
                // In this case, we exit `routePolicy.push` earlier and use `open` (window.open) to load the url in the exisitng browsing context
                if ((0, $cb6fO.isHashedOnlyURL)(url)) {
                    open(url, '_self');
                    return;
                }
                const _currRouteName = match?.name;
                const _currRouteContentId = match?.params.contentId;
                const _destinationRoute = matchSupportedRoute(url);
                const _dstRouteName = _destinationRoute?.name;
                const _dstRouteContentId = _destinationRoute?.params.contentId;
                const _dstRouteSpaceKey = _destinationRoute?.params.spaceKey;
                /**
       * Transition within the same window if the target route is navigating to the same content
       * This can ensure link to anchors in the page can still happen within the same window, instead of opening a new tab
       **/ const modifiers = {
                    routeName: $477c5af85d2d7fb0$var$toEPRouteName(_dstRouteName),
                    contentId: _dstRouteContentId,
                    spaceKey: _dstRouteSpaceKey,
                    target: this.willPushInSelf(_currRouteName, _currRouteContentId, _dstRouteName, _dstRouteContentId) ? '_self' : '_blank'
                };
                const defaultNavigate = (url_0, { target: target })=>{
                    // We double check the url here in case parent product modify the `url` in `navigate` function and provided the hashed-only url to `defaultNavigate`
                    if ((0, $cb6fO.isHashedOnlyURL)(url_0)) {
                        open(url_0, '_self');
                        return;
                    }
                    const destRoute = matchSupportedRoute(url_0);
                    const willPushInSelf = this.willPushInSelf(_currRouteName, _currRouteContentId, destRoute?.name, destRoute?.params.contentId);
                    // When navigate to an url with anchor and destination is under the same route for same content,
                    // EP's default navigtation should simply follow browser's navigation instead of going to `defaultPush` and execute `history.push`.
                    // In this case, we use `open` (window.open) to load in the exisitng browsing context
                    if (willPushInSelf && Boolean(destRoute?.hash)) {
                        open(destRoute?.hash, '_self');
                        return;
                    }
                    if (target === '_self') defaultPush(url_0, forceReload);
                    else open(url_0, target);
                };
                /**
       * defaultNavigate can be invoked by the embedding product because it's the 3rd argument to
       * navigationPolicy's navigate. If embedding product tells EP to navigate to a URL in a new
       * tab, EP should not shim (rebase) it since the embedding product has already had a chance
       * and they chose not to. On the other hand, if the embedding product does not tell EP to
       * nagivate, EP can shim the url only when opening a new tab (some links might not have been
       * shimmed, need to shim all links supposed to be shimmed as the last defense).
       **/ return navigationPolicy?.navigate ? navigationPolicy?.navigate(url, modifiers, defaultNavigate) : defaultNavigate(modifiers.target === '_self' ? url : shimUrl(url), modifiers);
            },
            willPushInSelf (currRouteName, currRouteContentId, dstRouteName, dstRouteContentId) {
                const isEPRoute = !!$477c5af85d2d7fb0$var$toEPRouteName(dstRouteName);
                const isSameRoute = currRouteName === dstRouteName && currRouteContentId === dstRouteContentId;
                const shouldTransition = !!enableIframeSpaTransitions && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(currRouteName ?? '') && [
                    'VIEW_PAGE',
                    'EDIT_PAGE_EMBED'
                ].includes(dstRouteName ?? '') && currRouteContentId === dstRouteContentId;
                return isEPRoute && (isSameRoute || shouldTransition);
            }
        }), [
        enableIframeSpaTransitions,
        navigationPolicy,
        shimUrl
    ]);
    return (0, $cozmU.useMemo)(()=>isEmbeddedConfluence ? getEmbeddedConfluenceRoutePolicy() : undefined, [
        isEmbeddedConfluence,
        getEmbeddedConfluenceRoutePolicy
    ]);
}
function $477c5af85d2d7fb0$var$toEPRouteName(routeName) {
    switch(routeName){
        case 'VIEW_PAGE':
        case 'EDIT_PAGE_EMBED':
            return routeName;
        default:
            return undefined;
    }
}
module.exports["useRoutePolicy"] = $477c5af85d2d7fb0$export$53e37724c6846f41;

});

parcelRegister("kBW0t", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dOBRD = parcelRequire("dOBRD");


var $f8dGE = parcelRequire("f8dGE");


var $7nEuU = parcelRequire("7nEuU");

var $bnFzS = parcelRequire("bnFzS");


var $cb6fO = parcelRequire("cb6fO");

const $734ea8da77496ad5$var$isAdfContent = (content)=>{
    return content && typeof content === 'object' && content.type === 'doc' && Array.isArray(content.content);
};
function $734ea8da77496ad5$export$8ed0b067e5cd675d(navigationPolicy) {
    const $ = (0, $bDgLe.c)(17);
    const shimTemplate = navigationPolicy?.shimUrl;
    const domainNamesToReplace = navigationPolicy?.domainNamesToReplace;
    const spaceKeyFilter = navigationPolicy?.spaceKeyFilter;
    let t0;
    if ($[0] !== domainNamesToReplace || $[1] !== shimTemplate || $[2] !== spaceKeyFilter) {
        t0 = (urlToShim)=>$734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        $[0] = domainNamesToReplace;
        $[1] = shimTemplate;
        $[2] = spaceKeyFilter;
        $[3] = t0;
    } else t0 = $[3];
    const shimUrl = t0;
    let t1;
    if ($[4] !== domainNamesToReplace || $[5] !== shimTemplate || $[6] !== spaceKeyFilter) {
        t1 = (adf)=>{
            if (!shimTemplate || !adf || !Object.keys(adf).length) return adf;
            const adfClone = (0, (/*@__PURE__*/$parcel$interopDefault($f8dGE)))(adf);
            $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfClone, shimTemplate, domainNamesToReplace, spaceKeyFilter);
            return adfClone;
        };
        $[4] = domainNamesToReplace;
        $[5] = shimTemplate;
        $[6] = spaceKeyFilter;
        $[7] = t1;
    } else t1 = $[7];
    const shimAdfUrls = t1;
    let t2;
    if ($[8] !== domainNamesToReplace || $[9] !== shimAdfUrls || $[10] !== shimTemplate || $[11] !== spaceKeyFilter) {
        t2 = (html)=>{
            if (!shimTemplate || !html) return html;
            try {
                const parsedContent = JSON.parse(html);
                if ($734ea8da77496ad5$var$isAdfContent(parsedContent)) {
                    if (html.includes("\"extensionKey\":\"nested-table\"")) {
                        const processedAdf = $734ea8da77496ad5$var$shimAdfWithNestedTables(parsedContent, shimAdfUrls);
                        return JSON.stringify(processedAdf);
                    } else {
                        const shimmedAdf = shimAdfUrls(parsedContent);
                        return JSON.stringify(shimmedAdf);
                    }
                }
            } catch  {}
            try {
                return $734ea8da77496ad5$var$shimDomUrls(new DOMParser().parseFromString(html, "text/html"), shimTemplate, domainNamesToReplace, spaceKeyFilter).body.innerHTML;
            } catch  {
                return html;
            }
        };
        $[8] = domainNamesToReplace;
        $[9] = shimAdfUrls;
        $[10] = shimTemplate;
        $[11] = spaceKeyFilter;
        $[12] = t2;
    } else t2 = $[12];
    const shimHtmlUrls = t2;
    let t3;
    if ($[13] !== shimAdfUrls || $[14] !== shimHtmlUrls || $[15] !== shimUrl) {
        t3 = {
            shimUrl: shimUrl,
            shimAdfUrls: shimAdfUrls,
            shimHtmlUrls: shimHtmlUrls
        };
        $[13] = shimAdfUrls;
        $[14] = shimHtmlUrls;
        $[15] = shimUrl;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
}
function $734ea8da77496ad5$var$shimDomUrls(dom, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    const anchors = dom.getElementsByTagName('a');
    Array.from(anchors).forEach((a)=>{
        a.href = $734ea8da77496ad5$var$shimThisUrl(a.href, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    const imgs = dom.getElementsByTagName('img');
    Array.from(imgs).forEach((img)=>{
        img.src = $734ea8da77496ad5$var$shimThisUrl(img.src, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
    return dom;
}
function $734ea8da77496ad5$var$shimThisUrl(urlToShim, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    if (!shimTemplate || !urlToShim || (0, $cb6fO.isHashedOnlyURL)(urlToShim) || !$734ea8da77496ad5$var$isUrlForShimmedSpace(urlToShim, spaceKeyFilter)) return urlToShim;
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const baseUrl = document.baseURI || window.location.toString();
        const absUrlWithDomainToShim = $734ea8da77496ad5$var$getAbsUrlWithDomain(urlToShim, baseUrl);
        const urlPrefixToShim = $734ea8da77496ad5$var$ccAbsUrlWithDomain(baseUrl);
        const urlShimTemplate = $734ea8da77496ad5$var$shimAbsUrlWithDomain(shimTemplate, baseUrl);
        return $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace);
    } catch  {
        return urlToShim;
    }
}
function $734ea8da77496ad5$var$isUrlForShimmedSpace(url, spaceKeyFilter) {
    // If no filter, shim all URLs (backwards compatibility)
    if (!spaceKeyFilter?.length) return true;
    // Regex to extract spaceKey from /spaces/<spaceKey>/
    const match = url.match(/\/spaces\/([^/]+)/);
    if (match) {
        // If URL contains /spaces/<spaceKey>, only shim if spaceKey is in the filter
        const spaceKey = match[1];
        return spaceKeyFilter.includes(spaceKey);
    }
    // For other /wiki URLs (e.g., share links), retain previous behavior and shim
    return true;
}
const $734ea8da77496ad5$var$ccAbsUrlWithDomain = (0, $dOBRD.default)((base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain((0, $cb6fO.CONTEXT_PATH), base)));
const $734ea8da77496ad5$var$shimAbsUrlWithDomain = (0, $dOBRD.default)((urlShimTemplate, base)=>$734ea8da77496ad5$var$appendSlash($734ea8da77496ad5$var$getAbsUrlWithDomain(urlShimTemplate, base)));
function $734ea8da77496ad5$var$getAbsUrlWithDomain(url, base) {
    return new URL(url, base).toString();
}
function $734ea8da77496ad5$var$getShimmedUrl(absUrlWithDomainToShim, urlPrefixToShim, urlShimTemplate, baseUrl, domainNamesToReplace) {
    if (absUrlWithDomainToShim.includes((0, $cb6fO.CONTEXT_PATH))) {
        //We can only rebase or shim /wiki URLs
        const absUrlObj = new URL(absUrlWithDomainToShim);
        const baseUrlObj = new URL(baseUrl);
        //Check if the URL should be rebased
        if (domainNamesToReplace?.includes(absUrlObj.hostname)) {
            //Rebase the URL by replacing the origin string of absUrlWithDomainToShim with that of baseUrl
            const rebasedAbsUrlToShim = absUrlWithDomainToShim.replace(absUrlObj.origin, baseUrlObj.origin);
            //Shimming the rebased URL
            return rebasedAbsUrlToShim.replace(urlPrefixToShim, urlShimTemplate);
        }
    }
    return absUrlWithDomainToShim.replace(urlPrefixToShim, urlShimTemplate);
}
function $734ea8da77496ad5$var$appendSlash(url) {
    if (!url.endsWith('/')) return `${url}/`;
    return url;
}
const $734ea8da77496ad5$var$URL_ADF_KEYS = [
    'url',
    'href'
];
function $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(adfJson, shimTemplate, domainNamesToReplace, spaceKeyFilter) {
    Object.entries(adfJson).forEach(([key, value])=>{
        if (!value) return;
        if ($734ea8da77496ad5$var$URL_ADF_KEYS.includes(key) && typeof value === 'string') adfJson[key] = $734ea8da77496ad5$var$shimThisUrl(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
        else if (typeof value === 'object') $734ea8da77496ad5$var$replaceCcPageUrlsInAdf(value, shimTemplate, domainNamesToReplace, spaceKeyFilter);
    });
}
/**
 * Shims URLs in ADF content that contains nested tables.
 * This function processes ADF document content with nested tables by:
 * 1. Transforming nested tables (incoming)
 * 2. Applying URL shimming via shimAdfUrls
 * 3. Transforming nested tables (outgoing)
 *
 * @param adfContent - Parsed ADF document content (already validated)
 * @param shimAdfUrls - Function to apply URL shimming to ADF objects
 * @returns Processed ADF object with shimmed URLs and transformed nested tables
 */ function $734ea8da77496ad5$var$shimAdfWithNestedTables(adfContent, shimAdfUrls) {
    // Process ADF document with nested tables - transform and delegate to shimAdfUrls
    const { transformedAdf: transformedAdf } = (0, $bnFzS.transformNestedTablesIncomingDocument)(adfContent);
    const shimmedAdf = shimAdfUrls(transformedAdf);
    return (0, $7nEuU.transformNestedTableNodeOutgoingDocument)(shimmedAdf);
}
module.exports["useShimUrl"] = $734ea8da77496ad5$export$8ed0b067e5cd675d;

});

parcelRegister("f8dGE", function(module, exports) {

var $hGc5T = parcelRequire("hGc5T");

/** Used to compose bitmasks for cloning. */ var $b042384c0682c153$var$CLONE_DEEP_FLAG = 1, $b042384c0682c153$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $b042384c0682c153$var$cloneDeep(value) {
    return $hGc5T(value, $b042384c0682c153$var$CLONE_DEEP_FLAG | $b042384c0682c153$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $b042384c0682c153$var$cloneDeep;

});

parcelRegister("aFbGo", function(module, exports) {
const $3fe527a88453b695$export$5dd7a635c52544a = ()=>window?.location?.search?.indexOf('lite=1') >= 0;
module.exports["isViewPageLite"] = $3fe527a88453b695$export$5dd7a635c52544a;

});

parcelRegister("5q601", function(module, exports) {
const $23ec6b91fddb9839$export$190611e0edbb22d5 = 'viewEditButtonClicked';
const $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e = 'editButtonClickedToEditRouteChange';
const $23ec6b91fddb9839$export$caabe0b707a0bfac = 'editRouteChangeToPageLoad';
const $23ec6b91fddb9839$export$a5b3479b02282e8c = 'tinySynchronyPluginsLoad';
const $23ec6b91fddb9839$export$1787f4f7916eb601 = 'tinySynchronyContentFetch';
const $23ec6b91fddb9839$export$99c2e20685f1cd4e = 'editIntentToEditPageTTI';
const $23ec6b91fddb9839$export$e04cfb21f00b2ad0 = 'editIntentToEditPageFMP';
const $23ec6b91fddb9839$export$1d8f87e0ed24898e = 'editEmbeddedPageTTI';
const $23ec6b91fddb9839$export$16bdef2ba2fa4a5 = 'editEmbeddedPageFMP';
const $23ec6b91fddb9839$export$4d09a02f749e3cc2 = 'routeChangeToEditorTTI';
const $23ec6b91fddb9839$export$c2bda34fe2c26f89 = 'tinySynchronyContentMetadaPreload';
module.exports["VIEW_EDIT_BUTTON_CLICKED_ACTION"] = $23ec6b91fddb9839$export$190611e0edbb22d5;
module.exports["EDIT_ROUTE_CHANGE_ACTION"] = $23ec6b91fddb9839$export$ed5bb54d3f9e4a8e;
module.exports["EDIT_ROUTE_CHANGE_TO_FMP_ACTION"] = $23ec6b91fddb9839$export$caabe0b707a0bfac;
module.exports["TINY_SYNCHRONY_PLUGINS_LOAD_ACTION"] = $23ec6b91fddb9839$export$a5b3479b02282e8c;
module.exports["TINY_SYNCHRONY_CONTENT_FETCH_ACTION"] = $23ec6b91fddb9839$export$1787f4f7916eb601;
module.exports["EDIT_INTENT_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$99c2e20685f1cd4e;
module.exports["EDIT_INTENT_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$e04cfb21f00b2ad0;
module.exports["EMBEDDED_EDIT_TTI_ACTION"] = $23ec6b91fddb9839$export$1d8f87e0ed24898e;
module.exports["EMBEDDED_EDIT_FMP_ACTION"] = $23ec6b91fddb9839$export$16bdef2ba2fa4a5;
module.exports["EDIT_ROUTE_CHANGE_TO_TTI_ACTION"] = $23ec6b91fddb9839$export$4d09a02f749e3cc2;
module.exports["TINY_SYNCHRONY_CONTENT_METADATA_PRELOAD"] = $23ec6b91fddb9839$export$c2bda34fe2c26f89;

});

parcelRegister("lSOAM", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ /* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");


var $8RwKN = parcelRequire("8RwKN");


var $64KID = parcelRequire("64KID");


var $fQ3iN = parcelRequire("fQ3iN");


var $i3c1S = parcelRequire("i3c1S");

const $2a47a9fc48674e91$export$d539c641d560c25d = new Set([
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_BLOG_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_V2.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_PAGE.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_INDEX.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_OVERVIEW.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).TEMPLATE_GALLERY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).CONTENT_HISTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).ADVANCED_SEARCH.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).HOME.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_DIRECTORY.name,
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_PAGES.name
]);
const $2a47a9fc48674e91$export$9dede01b6f349441 = (match)=>{
    if (!match) return false;
    return $2a47a9fc48674e91$export$d539c641d560c25d.has(match.name);
};
const $2a47a9fc48674e91$export$cb339d0cd5cc821c = ()=>{
    const currentMetric = (0, $8RwKN.browserMetrics).getPageLoadMetric();
    return currentMetric.getData().start !== null;
};
const $2a47a9fc48674e91$export$c5aa7fcaede4a84d = (0, $iDdTC.metrics).pageLoad;
const $2a47a9fc48674e91$export$19ba7be4fcf34f3d = (0, $iDdTC.metrics).custom;
const $2a47a9fc48674e91$export$36d7a61d0660e29c = (0, $iDdTC.metrics).interaction;
const $2a47a9fc48674e91$var$concurrent = (0, $iDdTC.metrics).concurrent;
const $2a47a9fc48674e91$export$9db2e0f538bb10fa = $2a47a9fc48674e91$var$concurrent.custom;
module.exports["createPageLoadMetric"] = $2a47a9fc48674e91$export$c5aa7fcaede4a84d;
module.exports["createCustomMetric"] = $2a47a9fc48674e91$export$19ba7be4fcf34f3d;
module.exports["createInteractionMetric"] = $2a47a9fc48674e91$export$36d7a61d0660e29c;
module.exports["createConcurrentCustomMetric"] = $2a47a9fc48674e91$export$9db2e0f538bb10fa;

});

parcelRegister("iDdTC", function(module, exports) {

var $9aI7t = parcelRequire("9aI7t");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");


var $1Ht4b = parcelRequire("1Ht4b");


var $aaEQD = parcelRequire("aaEQD");

const $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54 = {
    pageLoad: $1Ht4b.pageLoad,
    pageSegmentLoad: $aaEQD.pageSegmentLoad,
    interaction: $b90aI.interaction,
    custom: $b5593.custom,
    concurrent: $9aI7t.concurrent
};
module.exports["metrics"] = $ffb05ca8baf9d9e1$export$b0c5c2fac8144e54;

});

parcelRegister("9aI7t", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $b5593 = parcelRequire("b5593");


var $b90aI = parcelRequire("b90aI");

const $95763ae236d73d99$var$concurrentMetrics = {};
const $95763ae236d73d99$var$getKey = (config, type)=>`${type}--${config.key}`;
const $95763ae236d73d99$var$validateConfig = (config)=>{
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
const $95763ae236d73d99$var$ensurePath = (config, type)=>{
    const key = $95763ae236d73d99$var$getKey(config, type);
    if (!(key in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[key] = {};
};
const $95763ae236d73d99$var$getMetricFromCache = (concurrentId, config, type)=>{
    const concurrentKey = $95763ae236d73d99$var$getKey(config, type);
    if (concurrentKey in $95763ae236d73d99$var$concurrentMetrics && $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $95763ae236d73d99$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $95763ae236d73d99$var$concurrentMetrics)) $95763ae236d73d99$var$concurrentMetrics[concurrentKey] = {};
    return;
};
const $95763ae236d73d99$var$makeConcurrentMetric = (concurrentId, config, type)=>{
    $95763ae236d73d99$var$validateConfig(config);
    $95763ae236d73d99$var$ensurePath(config, type);
    const metricFromCache = $95763ae236d73d99$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    const metricFactory = type === (0, $lCTbz.BMEventsType).INLINE_RESULT ? (0, $b90aI.interaction) : (0, $b5593.custom);
    const metric = metricFactory(config);
    $95763ae236d73d99$var$concurrentMetrics[$95763ae236d73d99$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
const $95763ae236d73d99$export$370df09ecc3de059 = {
    pageSegmentLoad: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD),
    interaction: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).INLINE_RESULT),
    custom: (config)=>(concurrentId)=>$95763ae236d73d99$var$makeConcurrentMetric(concurrentId, {
                ...config
            }, (0, $lCTbz.BMEventsType).CUSTOM)
};
module.exports["concurrent"] = $95763ae236d73d99$export$370df09ecc3de059;

});

parcelRegister("b5593", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $39f57926a8ef795b$export$4c00f665f0d4b443 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).CUSTOM
    });
};
module.exports["custom"] = $39f57926a8ef795b$export$4c00f665f0d4b443;

});

parcelRegister("ipFlS", function(module, exports) {

var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $7IphZ = parcelRequire("7IphZ");

class $4db3d4178d03c3ea$export$efdd3e096bc27746 extends (0, $7IphZ.BaseMetric) {
    start({ startTime: startTime } = {}) {
        super.start({
            startTime: startTime
        });
        this.route = (0, $hvVQt.Route).getRoute();
    }
    stop(params = {}) {
        const stoppedSuccessfully = super.stop(params);
        if (stoppedSuccessfully && !this.config.virtual) (0, $581yf.submitter).queue(this.getData());
        return stoppedSuccessfully;
    }
}
module.exports["Metric"] = $4db3d4178d03c3ea$export$efdd3e096bc27746;

});

parcelRegister("b90aI", function(module, exports) {

var $ipFlS = parcelRequire("ipFlS");


var $lCTbz = parcelRequire("lCTbz");

const $060787d14b6a30d6$export$92473e6020ad89b4 = (config)=>{
    return new (0, $ipFlS.Metric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).INLINE_RESULT
    });
};
module.exports["interaction"] = $060787d14b6a30d6$export$92473e6020ad89b4;

});

parcelRegister("1Ht4b", function(module, exports) {

var $3L5Pu = parcelRequire("3L5Pu");


var $lCTbz = parcelRequire("lCTbz");

const $a55ff36d094d83ef$export$791d520f7e8058a5 = (config)=>{
    return new (0, $3L5Pu.PageLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_LOAD
    });
};
module.exports["pageLoad"] = $a55ff36d094d83ef$export$791d520f7e8058a5;

});

parcelRegister("3L5Pu", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $jk8rA = parcelRequire("jk8rA");


var $hvVQt = parcelRequire("hvVQt");


var $581yf = parcelRequire("581yf");


var $lCTbz = parcelRequire("lCTbz");


var $2QFOI = parcelRequire("2QFOI");


var $wgCbG = parcelRequire("wgCbG");


var $eNslE = parcelRequire("eNslE");

class $bbca0ae0eaeecc15$export$3c51073271a9eac3 extends (0, $2QFOI.BasePageLoadMetric) {
    startPageLoad(params = {
        isInitial: false
    }) {
        (0, $wgCbG.pageLoadMetaMetric).startPageLoad({
            ...params,
            cancelStarted: 'startTime' in params
        });
        this.watchUntil();
    }
    stop(params = {}) {
        const stopTime = params.stopTime || window.performance.now();
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getDataToMerge();
        const metaMetricStopped = (0, $wgCbG.pageLoadMetaMetric).stop(params);
        if (!metaMetricStopped) return false;
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) (0, $wgCbG.pageLoadMetaMetric).markFMP(mark);
            } else (0, $wgCbG.pageLoadMetaMetric).markFMP(this.marks[(0, $2QFOI.BasePageLoadMetric).FMP]);
        }
        this.route = (0, $hvVQt.Route).getRoute();
        const metricStopped = this.stopPageLoad(pageLoadData, {
            ...params,
            stopTime: stopTime
        });
        if (!metricStopped) return false;
        const data = this.getData();
        if (!this.config.virtual) (0, $581yf.submitter).queue(data);
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'page-load', 'stop', this.getData);
        this.enqueueWebVitals();
        return true;
    }
    mark(mark, timestamp = window.performance.now()) {
        (0, $wgCbG.pageLoadMetaMetric).mark(mark, timestamp);
    }
    markFMP(timestamp) {
        (0, $wgCbG.pageLoadMetaMetric).markFMP(timestamp);
    }
    getData() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        return {
            ...super.getData(),
            // marks and explicitTimings are available only in pageLoadMeta
            marks: pageLoadMetaData.marks,
            explicitTimings: pageLoadMetaData.explicitTimings
        };
    }
    async enqueueWebVitals() {
        if (this.config.virtual || !this.isInitial) return false;
        const configChunk = await (0, $581yf.submitter).config.configChunk;
        if (!configChunk?.[(0, $lCTbz.BMEventsType).WEB_VITALS].webVitals?.enabled) return false;
        const webVitalMetric = new (0, $eNslE.WebVitalsMetric)({
            key: this.config.key,
            route: this.route,
            startTime: this.startTime,
            stopTime: this.stopTime,
            pageVisibleState: this.pageVisibleState
        });
        (0, $581yf.submitter).queue(webVitalMetric.getData());
        (0, $jk8rA.logger).logCond(!!this.config.debug, 'web-vitals', webVitalMetric.getData);
        return true;
    }
}
module.exports["PageLoadMetric"] = $bbca0ae0eaeecc15$export$3c51073271a9eac3;

});

parcelRegister("eNslE", function(module, exports) {

var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");

class $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7 extends (0, $7IphZ.BaseMetric) {
    constructor({ key: key, route: route, startTime: startTime, stopTime: stopTime, pageVisibleState: pageVisibleState }){
        super({
            type: (0, $lCTbz.BMEventsType).WEB_VITALS,
            key: key
        });
        this.route = route;
        this.startTime = startTime;
        this.stopTime = stopTime;
        this.state = (0, $7IphZ.MetricState).FINISHED;
        this.pageVisibleState = pageVisibleState;
    }
}
module.exports["WebVitalsMetric"] = $23d0f6650a8bd5e3$export$dc0d85d4d6503cd7;

});

parcelRegister("aaEQD", function(module, exports) {

var $h51B5 = parcelRequire("h51B5");


var $lCTbz = parcelRequire("lCTbz");

const $2eb5124fdb2b6158$export$94114666844d5f66 = (config)=>{
    return new (0, $h51B5.PageSegmentLoadMetric)({
        ...config,
        type: (0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD
    });
};
module.exports["pageSegmentLoad"] = $2eb5124fdb2b6158$export$94114666844d5f66;

});

parcelRegister("h51B5", function(module, exports) {

var $97AWA = parcelRequire("97AWA");


var $lCTbz = parcelRequire("lCTbz");


var $7IphZ = parcelRequire("7IphZ");


var $ipFlS = parcelRequire("ipFlS");


var $wgCbG = parcelRequire("wgCbG");

class $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1 extends (0, $ipFlS.Metric) {
    startFromPageLoad() {
        const pageLoadMetaData = (0, $wgCbG.pageLoadMetaMetric).getData();
        this.start({
            startTime: pageLoadMetaData.start ?? undefined
        });
        this.isInitial = pageLoadMetaData.isInitial;
        this.pageVisibleState = pageLoadMetaData.pageVisibleState;
    }
    mark(mark, timestamp = window.performance.now()) {
        if (mark === $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP) return;
        super.mark(mark, timestamp);
    }
    markFMP(timestamp) {
        super.mark($0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP, timestamp);
    }
    getPageSegmentLoadData() {
        return {
            isInitial: this.isInitial
        };
    }
    getData() {
        return {
            ...super.getData(),
            ...this.getPageSegmentLoadData()
        };
    }
    getDataToMerge() {
        return {
            ...super.getDataToMerge(),
            ...this.getPageSegmentLoadData()
        };
    }
    merge(mergeData) {
        super.merge(mergeData);
        this.isInitial = mergeData.isInitial;
    }
    stop(params = {}) {
        const pageLoadData = (0, $wgCbG.pageLoadMetaMetric).getData();
        if (pageLoadData.isInitial && this.config.ssr?.doneAsFmp) {
            if (!this.marks[$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP]) {
                const mark = (0, $97AWA.SSRGetDoneMark).getDoneMark();
                if (mark) this.markFMP(mark);
            }
        }
        if (this.config.includePageLoadTimings !== (0, $lCTbz.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $7IphZ.MetricState).FINISHED) return super.stop(params);
        const now = performance.now();
        if (pageLoadData.state === (0, $7IphZ.MetricState).STARTED) (0, $wgCbG.pageLoadMetaMetric).onStop(()=>{
            super.stop({
                ...params,
                stopTime: params.stopTime || now
            });
        }, ()=>{
            this.cancel();
        });
        return true;
    }
    constructor(config){
        super(config);
        this.isInitial = true;
        this.config = void 0;
        this.config = config;
    }
}
$0f8d7af9cfafbf9f$export$24c8bfcd77494cc1.FMP = 'fmp';
module.exports["PageSegmentLoadMetric"] = $0f8d7af9cfafbf9f$export$24c8bfcd77494cc1;

});

parcelRegister("fQ3iN", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");


var $3YpC9 = parcelRequire("3YpC9");


var $kw6I9 = parcelRequire("kw6I9");


var $8W4Gr = parcelRequire("8W4Gr");

function $a96d58ddd476e3f0$export$34f706592a2f7442(config) {
    const metric = (0, $kw6I9.createBM3PageSegmentLoadMetricRaw)(config);
    const key = config.key;
    // Capture the original methods before overriding them.
    const realStart = metric.start.bind(metric);
    const realStartFromPageLoad = metric.startFromPageLoad.bind(metric);
    const realStop = metric.stop.bind(metric);
    const realCancel = metric.cancel.bind(metric);
    const realMark = metric.mark.bind(metric);
    const realMarkFMP = metric.markFMP.bind(metric);
    metric.start = (...args)=>{
        const binding = (0, $8W4Gr.bindPageSegmentToUFO)(metric, key, args[0]?.startTime);
        if (binding) {
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`, [], binding.startTime);
            return;
        }
        return realStart(...args);
    };
    metric.startFromPageLoad = (...args)=>{
        const binding = (0, $8W4Gr.bindPageSegmentToUFO)(metric, key, 'page-load');
        if (binding) {
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START)}:${key}`, [], binding.startTime);
            return;
        }
        return realStartFromPageLoad(...args);
    };
    metric.stop = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, args[0]);
            return true;
        }
        return realStop(...args);
    };
    metric.cancel = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            // This is a legacy marker, not a native interaction cancellation/completion.
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`, [], performance.now());
            return;
        }
        return realCancel(...args);
    };
    metric.mark = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            const [name, timestamp] = args;
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', name, [], timestamp ?? performance.now());
            return;
        }
        return realMark(...args);
    };
    metric.markFMP = (...args)=>{
        const binding = (0, $8W4Gr.getPageSegmentUFOBinding)(metric);
        if (binding) {
            const [timestamp] = args;
            (0, $a33Aa.addMark)(binding.interactionId, 'custom', `fmp:${key}`, [], timestamp ?? performance.now());
            return;
        }
        return realMarkFMP(...args);
    };
    return metric;
}
module.exports["createPageSegmentLoadMetric"] = $a96d58ddd476e3f0$export$34f706592a2f7442;

});

parcelRegister("3YpC9", function(module, exports) {
const $4dbe182ee19642b3$export$f59b3ea823fcdb3d = 'segment-start';
const $4dbe182ee19642b3$export$a217b163593f51a = 'segment-end';
module.exports["PAGE_SEGMENT_MARK_PREFIX_START"] = $4dbe182ee19642b3$export$f59b3ea823fcdb3d;
module.exports["PAGE_SEGMENT_MARK_PREFIX_END"] = $4dbe182ee19642b3$export$a217b163593f51a;

});

parcelRegister("kw6I9", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-restricted-syntax */ 
var $iDdTC = parcelRequire("iDdTC");

const $864083edfead32eb$export$2a2fe1e11b4e0413 = (0, $iDdTC.metrics).pageSegmentLoad;
module.exports["createBM3PageSegmentLoadMetricRaw"] = $864083edfead32eb$export$2a2fe1e11b4e0413;

});

parcelRegister("8W4Gr", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");


var $iJ7Px = parcelRequire("iJ7Px");


var $3YpC9 = parcelRequire("3YpC9");

// Dispatch information only: UFO still owns holds, completion and reporting.
// Object identity keeps separate metric instances with the same key independent.
const $06e453a80b18c305$var$bindings = new WeakMap();
// Deduplicate end telemetry per captured start without changing UFO completion or holds.
const $06e453a80b18c305$var$reportedEnds = new WeakSet();
function $06e453a80b18c305$export$658d1540acda6146(metric, key = metric.key, startTime) {
    $06e453a80b18c305$var$bindings.delete(metric);
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction && (0, $iJ7Px.BM3_MIGRATION_SCOPES).some(({ ufoNames: ufoNames, segmentKeys: segmentKeys })=>ufoNames.includes(interaction.ufoName) && segmentKeys.some((segment)=>segment === key))) {
        const binding = {
            interactionId: interaction.id,
            key: key,
            startTime: startTime === 'page-load' ? interaction.start : startTime ?? performance.now()
        };
        $06e453a80b18c305$var$bindings.set(metric, binding);
        return binding;
    }
    return undefined;
}
function $06e453a80b18c305$export$23d3c6fa6a541f1c(metric) {
    return $06e453a80b18c305$var$bindings.get(metric);
}
function $06e453a80b18c305$export$de99dc22751ce5a4(binding, options) {
    const { interactionId: interactionId, key: key, startTime: startTime } = binding;
    if (!$06e453a80b18c305$var$reportedEnds.has(binding)) {
        $06e453a80b18c305$var$reportedEnds.add(binding);
        const endTime = options?.stopTime ?? performance.now();
        (0, $a33Aa.addMark)(interactionId, 'custom', `${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${key}`, [], endTime);
        (0, $a33Aa.addCustomTiming)(interactionId, [], {
            [`wf/react/${key}`]: {
                startTime: startTime,
                endTime: endTime
            }
        });
    }
    // Later React/imperative callbacks can still supply attributes to the same owner.
    if (options?.customData) (0, $a33Aa.addCustomData)(interactionId, [], typeof globalThis.structuredClone === 'function' ? globalThis.structuredClone(options.customData) : options.customData);
}
module.exports["bindPageSegmentToUFO"] = $06e453a80b18c305$export$658d1540acda6146;
module.exports["getPageSegmentUFOBinding"] = $06e453a80b18c305$export$23d3c6fa6a541f1c;
module.exports["reportPageSegmentEndToUFO"] = $06e453a80b18c305$export$de99dc22751ce5a4;

});

parcelRegister("iJ7Px", function(module, exports) {

var $1UCmC = parcelRequire("1UCmC");


var $jX1qB = parcelRequire("jX1qB");

const $9f5a9554b14e3be2$export$59f08ddb222dbbda = [
    {
        pageLoadKey: (0, $1UCmC.VIEW_PAGE_LOAD_KEY),
        ufoNames: [
            'view_page'
        ],
        segmentKeys: [
            // View Page's initial/transition segments, plus its header and content UI.
            (0, $jX1qB.APP_NAVIGATION_SEGMENT_KEY),
            (0, $jX1qB.BYLINE_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_RENDERER_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_TITLE_SEGMENT_KEY),
            (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
            (0, $jX1qB.CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY),
            (0, $jX1qB.END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY),
            (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
            (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
            (0, $jX1qB.OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY),
            (0, $jX1qB.PAGE_TREE_SEGMENT_KEY),
            (0, $jX1qB.READ_TIME_SEGMENT_KEY),
            (0, $jX1qB.RESTRICTIONS_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY),
            (0, $jX1qB.SPACE_NAVIGATION_SEGMENT_KEY),
            (0, $jX1qB.VIEW_PAGE_CONTAINER_SEGMENT_KEY),
            (0, $jX1qB.VIEW_PAGE_LABELS_METRIC_KEY),
            (0, $jX1qB.WATCH_BUTTON_SEGMENT_KEY)
        ]
    }
];
module.exports["BM3_MIGRATION_SCOPES"] = $9f5a9554b14e3be2$export$59f08ddb222dbbda;

});

parcelRegister("1UCmC", function(module, exports) {
const $00aca2e58bbddd9e$export$9ee3c9e81070f140 = 'admin-announcement-banner-setting-page';
const $00aca2e58bbddd9e$export$162462d8f302c50a = 'advanced-search';
const $00aca2e58bbddd9e$export$17e011598d6a739d = 'unified-search';
const $00aca2e58bbddd9e$export$a88513891a2ab6b7 = 'confluence-home';
const $00aca2e58bbddd9e$export$5614199f62986e3b = 'all-drafts';
const $00aca2e58bbddd9e$export$3bbaa81ece500746 = 'recent-pages';
const $00aca2e58bbddd9e$export$b634edee624f5dc2 = 'starred-pages';
const $00aca2e58bbddd9e$export$5946c48030569b81 = 'content-history';
const $00aca2e58bbddd9e$export$1eefb862c6c6ce00 = 'edit-page';
const $00aca2e58bbddd9e$export$e164999ba8681ff6 = 'edit-template';
const $00aca2e58bbddd9e$export$6cdf3f4614ddd679 = 'edit-template-old';
const $00aca2e58bbddd9e$export$8faa34d8ba45e128 = 'embedded-view-page';
const $00aca2e58bbddd9e$export$3fb3338cf2b36704 = 'embedded-edit-page';
const $00aca2e58bbddd9e$export$779fbc1a16a8cb5d = 'global-permissions';
const $00aca2e58bbddd9e$export$9d8c586f3355f180 = 'inaccessible-page';
const $00aca2e58bbddd9e$export$a0c73183bde575ec = 'not-found';
const $00aca2e58bbddd9e$export$6d480c75094dbd7f = 'space-directory';
const $00aca2e58bbddd9e$export$8d0f9920174f22b4 = 'space-overview';
const $00aca2e58bbddd9e$export$228f2841a225e5ad = 'space-pages';
const $00aca2e58bbddd9e$export$fe4f0edc4d6532a8 = 'tasks-home';
const $00aca2e58bbddd9e$export$cc53520b570e0a46 = 'content-manager';
const $00aca2e58bbddd9e$export$bdc26b2b517231a = 'space-manager';
const $00aca2e58bbddd9e$export$b6d237d1e8f12e5d = 'template-gallery';
const $00aca2e58bbddd9e$export$a715ad00b824ec3f = 'view-page';
const $00aca2e58bbddd9e$export$132f38e0c19c02b6 = 'embedded-marketplace';
const $00aca2e58bbddd9e$export$803e647119e41cc = 'embedded-store';
const $00aca2e58bbddd9e$export$d2dddf4422ad7ae8 = 'create-content';
const $00aca2e58bbddd9e$export$511ffb17da23b1a7 = 'access-link-shared-page';
const $00aca2e58bbddd9e$export$9c7a9f4f853f6fba = 'public-link-shared-page';
const $00aca2e58bbddd9e$export$643b9c181748da38 = 'public-link-site-setting-page';
const $00aca2e58bbddd9e$export$4716363caa82a23b = 'public-links-space-settings-page';
const $00aca2e58bbddd9e$export$75726af5c0ee9402 = 'whiteboard-view-page';
const $00aca2e58bbddd9e$export$afe76b61b3f9aaa8 = 'database-view-page';
const $00aca2e58bbddd9e$export$dd63a13fc6c1ba34 = 'embed-view-page';
const $00aca2e58bbddd9e$export$16aeb03ec0c24b89 = 'live-page';
const $00aca2e58bbddd9e$export$2b4bf316b2f90e51 = 'folder-page';
const $00aca2e58bbddd9e$export$ce4e0f6f3d614d45 = 'live-edit';
const $00aca2e58bbddd9e$export$ecea02b4eaa314f3 = 'team-calendars';
const $00aca2e58bbddd9e$export$726cbfa087a55101 = 'admin-team-calendars';
const $00aca2e58bbddd9e$export$2f245ed7ebaea89 = 'admin-general-configuration';
const $00aca2e58bbddd9e$export$2af60fefae96902b = 'admin-configure-code-macro';
const $00aca2e58bbddd9e$export$fbea00ed02ef2502 = 'admin-default-space-logo-config';
const $00aca2e58bbddd9e$export$6e9c07174668ae36 = 'admin-header-and-footer';
const $00aca2e58bbddd9e$export$51fdddeccf175d74 = 'admin-security-configuration';
const $00aca2e58bbddd9e$export$2d0370cc7d14b72e = 'admin-templates-and-blueprints';
const $00aca2e58bbddd9e$export$a8d02dbd84c83dd = 'admin-import-spaces';
const $00aca2e58bbddd9e$export$1d91ea2ef976728a = 'admin-trashed-spaces';
const $00aca2e58bbddd9e$export$a13bfc71dc6b7924 = 'admin-application-navigator';
const $00aca2e58bbddd9e$export$3ba6335cd90d2e59 = 'admin-themes';
const $00aca2e58bbddd9e$export$cb4b6b707a32ee92 = 'admin-jira-macro-repair';
const $00aca2e58bbddd9e$export$5cb6689cb672a5c0 = 'admin-pdf-export';
const $00aca2e58bbddd9e$export$fff7d33fb1514c44 = 'admin-macro-usage';
const $00aca2e58bbddd9e$export$87f484dad415164c = 'admin-storage-management';
const $00aca2e58bbddd9e$export$d4aa60a3ffc18652 = 'admin-user-access';
const $00aca2e58bbddd9e$export$52c0c13179848b50 = 'CONTENT_ANALYTICS';
const $00aca2e58bbddd9e$export$40dab65f060e1231 = 'SPACE_ANALYTICS';
const $00aca2e58bbddd9e$export$b682ed6d6fa429fb = 'INSTANCE_ANALYTICS';
const $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1 = 'space-details';
const $00aca2e58bbddd9e$export$2633c6986b98b723 = 'pdf-export-route';
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9ee3c9e81070f140;
module.exports["ADVANCED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$162462d8f302c50a;
module.exports["UNIFIED_SEARCH_LOAD_KEY"] = $00aca2e58bbddd9e$export$17e011598d6a739d;
module.exports["CONFLUENCE_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$a88513891a2ab6b7;
module.exports["CONFLUENCE_DRAFTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$5614199f62986e3b;
module.exports["CONFLUENCE_RECENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$3bbaa81ece500746;
module.exports["CONFLUENCE_STARRED_LOAD_KEY"] = $00aca2e58bbddd9e$export$b634edee624f5dc2;
module.exports["CONTENT_HISTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$5946c48030569b81;
module.exports["EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$1eefb862c6c6ce00;
module.exports["EDIT_TEMPLATE_LOAD_KEY"] = $00aca2e58bbddd9e$export$e164999ba8681ff6;
module.exports["EDIT_TEMPLATE_OLD_LOAD_KEY"] = $00aca2e58bbddd9e$export$6cdf3f4614ddd679;
module.exports["EMBEDDED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$8faa34d8ba45e128;
module.exports["EMBEDDED_EDIT_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$3fb3338cf2b36704;
module.exports["GLOBAL_PERMISSIONS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$779fbc1a16a8cb5d;
module.exports["INACCESSIBLE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9d8c586f3355f180;
module.exports["NOT_FOUND_LOAD_KEY"] = $00aca2e58bbddd9e$export$a0c73183bde575ec;
module.exports["SPACE_DIRECTORY_LOAD_KEY"] = $00aca2e58bbddd9e$export$6d480c75094dbd7f;
module.exports["SPACE_OVERVIEW_LOAD_KEY"] = $00aca2e58bbddd9e$export$8d0f9920174f22b4;
module.exports["SPACE_PAGES_LOAD_KEY"] = $00aca2e58bbddd9e$export$228f2841a225e5ad;
module.exports["TASKS_HOME_LOAD_KEY"] = $00aca2e58bbddd9e$export$fe4f0edc4d6532a8;
module.exports["CONTENT_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$cc53520b570e0a46;
module.exports["SPACE_MANAGER_LOAD_KEY"] = $00aca2e58bbddd9e$export$bdc26b2b517231a;
module.exports["TEMPLATE_GALLERY_LOAD_KEY"] = $00aca2e58bbddd9e$export$b6d237d1e8f12e5d;
module.exports["VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$a715ad00b824ec3f;
module.exports["EMBEDDED_MARKETPLACE_LOAD_KEY"] = $00aca2e58bbddd9e$export$132f38e0c19c02b6;
module.exports["EMBEDDED_STORE_LOAD_KEY"] = $00aca2e58bbddd9e$export$803e647119e41cc;
module.exports["CREATE_CONTENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$d2dddf4422ad7ae8;
module.exports["ACCESS_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$511ffb17da23b1a7;
module.exports["PUBLIC_LINK_SHARED_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$9c7a9f4f853f6fba;
module.exports["PUBLIC_LINK_SITE_SETTING_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$643b9c181748da38;
module.exports["WHITEBOARD_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$75726af5c0ee9402;
module.exports["DATABASE_VIEW_PAGE_KEY"] = $00aca2e58bbddd9e$export$afe76b61b3f9aaa8;
module.exports["EMBED_VIEW_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$dd63a13fc6c1ba34;
module.exports["LIVE_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$16aeb03ec0c24b89;
module.exports["FOLDER_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2b4bf316b2f90e51;
module.exports["LIVE_PAGE_REACT_UFO_LOAD_KEY"] = $00aca2e58bbddd9e$export$ce4e0f6f3d614d45;
module.exports["TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$ecea02b4eaa314f3;
module.exports["ADMIN_TEAM_CALENDARS_LOAD_KEY"] = $00aca2e58bbddd9e$export$726cbfa087a55101;
module.exports["ADMIN_GENERAL_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$2f245ed7ebaea89;
module.exports["ADMIN_CONFIGURE_CODE_MACRO_LOAD_KEY"] = $00aca2e58bbddd9e$export$2af60fefae96902b;
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_LOAD_KEY"] = $00aca2e58bbddd9e$export$fbea00ed02ef2502;
module.exports["ADMIN_HEADER_AND_FOOTER_LOAD_KEY"] = $00aca2e58bbddd9e$export$6e9c07174668ae36;
module.exports["ADMIN_SECURITY_CONFIGURATION_LOAD_KEY"] = $00aca2e58bbddd9e$export$51fdddeccf175d74;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_LOAD_KEY"] = $00aca2e58bbddd9e$export$2d0370cc7d14b72e;
module.exports["ADMIN_IMPORT_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$a8d02dbd84c83dd;
module.exports["ADMIN_TRASHED_SPACES_LOAD_KEY"] = $00aca2e58bbddd9e$export$1d91ea2ef976728a;
module.exports["ADMIN_APPLICATION_NAVIGATOR_KEY"] = $00aca2e58bbddd9e$export$a13bfc71dc6b7924;
module.exports["ADMIN_THEMES_LOAD_KEY"] = $00aca2e58bbddd9e$export$3ba6335cd90d2e59;
module.exports["ADMIN_JIRA_MACRO_REPAIR_LOAD_KEY"] = $00aca2e58bbddd9e$export$cb4b6b707a32ee92;
module.exports["ADMIN_PDF_EXPORT_LOAD_KEY"] = $00aca2e58bbddd9e$export$5cb6689cb672a5c0;
module.exports["ADMIN_MACRO_USAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$fff7d33fb1514c44;
module.exports["ADMIN_STORAGE_MANAGEMENT_LOAD_KEY"] = $00aca2e58bbddd9e$export$87f484dad415164c;
module.exports["ADMIN_USER_ACCESS_KEY"] = $00aca2e58bbddd9e$export$d4aa60a3ffc18652;
module.exports["PAGE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$52c0c13179848b50;
module.exports["SPACE_ANALYTICS_PAGE_LOAD_KEY"] = $00aca2e58bbddd9e$export$40dab65f060e1231;
module.exports["SITE_ANALYTICS_LOAD_KEY"] = $00aca2e58bbddd9e$export$b682ed6d6fa429fb;
module.exports["SPACE_DETAILS_LOAD_KEY"] = $00aca2e58bbddd9e$export$93cf1e51c6a6b6b1;
module.exports["PDF_EXPORT_ROUTE_LOAD_KEY"] = $00aca2e58bbddd9e$export$2633c6986b98b723;

});

parcelRegister("jX1qB", function(module, exports) {
// "confluence.fe.page-segment-load.XXX"
const $fa0ea3428ec5aa62$export$9e40500efe28ac9e = 'app-navigation';
const $fa0ea3428ec5aa62$export$38b273cdbbf56c26 = 'blog-tree';
const $fa0ea3428ec5aa62$export$1ac23cd5807df863 = 'byline';
const $fa0ea3428ec5aa62$export$5bbb36bee09a5671 = 'read-time';
const $fa0ea3428ec5aa62$export$a79607497a4a710c = 'content-analytics-viewers';
const $fa0ea3428ec5aa62$export$c56a99673f1bb7bb = 'content-analytics-links-table';
const $fa0ea3428ec5aa62$export$140a493a9e781fe2 = 'content-renderer';
const $fa0ea3428ec5aa62$export$db1285ccb0399c01 = 'content-title';
const $fa0ea3428ec5aa62$export$eb5bb54418693284 = 'favourite-button';
const $fa0ea3428ec5aa62$export$3fde425dbc74423b = 'focused-inline-comment';
const $fa0ea3428ec5aa62$export$6a58cce6529da40e = 'inline-comments-highlights';
const $fa0ea3428ec5aa62$export$8910bc840e3ee4ce = 'fabric-comments-highlights';
const $fa0ea3428ec5aa62$export$bf572571ca036b67 = 'render-inline-comment';
const $fa0ea3428ec5aa62$export$644778267d4a4a82 = 'editor-render-inline-comment';
const $fa0ea3428ec5aa62$export$3afb71dd0b0dbc3a = 'reactions';
const $fa0ea3428ec5aa62$export$e4ff10a0a39a7217 = 'page-comments';
const $fa0ea3428ec5aa62$export$6648c9be174e6923 = 'page-reactions';
const $fa0ea3428ec5aa62$export$2d3d6144128aaee3 = 'feed-reactions';
const $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499 = 'page-tree';
const $fa0ea3428ec5aa62$export$d1dfca9e0eb45581 = 'restrictions-button';
const $fa0ea3428ec5aa62$export$312db7b759bad970 = 'global-navigation';
const $fa0ea3428ec5aa62$export$cf2a6bf49e73b304 = 'space-navigation';
const $fa0ea3428ec5aa62$export$84f6b5717c3fb962 = 'space-apps';
const $fa0ea3428ec5aa62$export$1a423f2548c46be3 = 'watch-button';
const $fa0ea3428ec5aa62$export$b6426c6941656619 = 'home-overview-recent';
const $fa0ea3428ec5aa62$export$14f30a91623dfcf3 = 'home-overview-feed';
const $fa0ea3428ec5aa62$export$c6926beb57b60636 = 'home-overview-right-panel';
const $fa0ea3428ec5aa62$export$687913e127f52cc3 = 'home-overview-spaces-section';
const $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0 = 'home-recents-view';
const $fa0ea3428ec5aa62$export$76243e8aa4afaa0b = 'home-starred-view';
const $fa0ea3428ec5aa62$export$e1df6f3f29083f48 = 'home-drafts-view';
const $fa0ea3428ec5aa62$export$7b32848c9413526a = 'end-of-page-recommendations';
const $fa0ea3428ec5aa62$export$58fbb0ba50341103 = 'in-editor-templates';
const $fa0ea3428ec5aa62$export$4f481f063369df3c = 'ncs-connected-fmp';
const $fa0ea3428ec5aa62$export$db1b9793e009e605 = 'advanced-search-component';
const $fa0ea3428ec5aa62$export$90bda069d4bf981b = 'advanced-search-filter-section';
const $fa0ea3428ec5aa62$export$f11e1d4269141c0e = 'advanced-search-result-section';
const $fa0ea3428ec5aa62$export$f0298cbab4a44998 = 'database-header';
const $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5 = 'smart-link-embed-header';
const $fa0ea3428ec5aa62$export$cf2f52fec740bdea = 'whiteboard-header';
const $fa0ea3428ec5aa62$export$52050233077a1838 = 'object-header';
const $fa0ea3428ec5aa62$export$e1ab333f0b70b317 = 'content-types-header-title';
const $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4 = 'whiteboard-view-page-content';
const $fa0ea3428ec5aa62$export$b95bd4bfc46932fc = 'database-view-page-content';
const $fa0ea3428ec5aa62$export$f6bd20f4f796eb89 = 'folder-page-content';
const $fa0ea3428ec5aa62$export$bf838b84ba2f7b95 = 'share-button';
const $fa0ea3428ec5aa62$export$79910402df6be117 = 'view-page-labels';
const $fa0ea3428ec5aa62$export$d86af34f7dc194b4 = 'admin-announcement-banner';
const $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb = 'cp-web-fragment';
const $fa0ea3428ec5aa62$export$1939caa7fae28ef5 = 'view-space-permissions';
const $fa0ea3428ec5aa62$export$3f06ee123a5ad183 = 'view-page-container';
const $fa0ea3428ec5aa62$export$37da6122cd60d332 = 'embed-view-page-content';
const $fa0ea3428ec5aa62$export$3437c1f145cfce19 = 'embed-view-page-blank-content';
const $fa0ea3428ec5aa62$export$7903037283afbce0 = 'editor';
const $fa0ea3428ec5aa62$export$31d10d7597db11d3 = 'object-sidebar-control';
const $fa0ea3428ec5aa62$export$b64d520f9b37dcd7 = 'comments-panel-open-view';
const $fa0ea3428ec5aa62$export$50553e47471a0f5e = 'comments-panel-unread-view';
const $fa0ea3428ec5aa62$export$40d92ab0c1cc5298 = 'comments-panel-deleted-content-view';
const $fa0ea3428ec5aa62$export$f2a6407ac901fd8d = 'comments-panel-resolved-view';
const $fa0ea3428ec5aa62$export$b3aade49b91bdeba = 'comments-panel-mentions-me-view';
module.exports["APP_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$9e40500efe28ac9e;
module.exports["BLOG_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$38b273cdbbf56c26;
module.exports["BYLINE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1ac23cd5807df863;
module.exports["READ_TIME_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$5bbb36bee09a5671;
module.exports["CONTENT_ANALYTICS_VIEWERS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$a79607497a4a710c;
module.exports["CONTENT_ANALYTICS_LINKS_TABLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c56a99673f1bb7bb;
module.exports["CONTENT_RENDERER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$140a493a9e781fe2;
module.exports["CONTENT_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1285ccb0399c01;
module.exports["FAVOURITE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$eb5bb54418693284;
module.exports["FOCUSED_INLINE_COMMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3fde425dbc74423b;
module.exports["INLINE_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6a58cce6529da40e;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$8910bc840e3ee4ce;
module.exports["RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf572571ca036b67;
module.exports["EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$644778267d4a4a82;
module.exports["PAGE_COMMENTS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e4ff10a0a39a7217;
module.exports["PAGE_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$6648c9be174e6923;
module.exports["FEED_REACTIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d3d6144128aaee3;
module.exports["PAGE_TREE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2f4a07b2ab7a5499;
module.exports["RESTRICTIONS_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d1dfca9e0eb45581;
module.exports["GLOBAL_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$312db7b759bad970;
module.exports["SPACE_NAVIGATION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$cf2a6bf49e73b304;
module.exports["SPACE_APPS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$84f6b5717c3fb962;
module.exports["WATCH_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1a423f2548c46be3;
module.exports["HOME_OVERVIEW_RECENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6426c6941656619;
module.exports["HOME_OVERVIEW_FEED_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$14f30a91623dfcf3;
module.exports["HOME_OVERVIEW_RIGHT_PANEL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$c6926beb57b60636;
module.exports["HOME_RECENTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$2d52eeb1a0271bf0;
module.exports["HOME_STARRED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$76243e8aa4afaa0b;
module.exports["HOME_DRAFTS_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1df6f3f29083f48;
module.exports["END_OF_PAGE_RECOMMENDATIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7b32848c9413526a;
module.exports["IN_EDITOR_TEMPLATES_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$58fbb0ba50341103;
module.exports["NCS_CONNECTED_FMP_KEY"] = $fa0ea3428ec5aa62$export$4f481f063369df3c;
module.exports["ADVANCED_SEARCH_COMPONENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$db1b9793e009e605;
module.exports["ADVANCED_SEARCH_FILTER_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$90bda069d4bf981b;
module.exports["ADVANCED_SEARCH_RESULT_SECTION_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f11e1d4269141c0e;
module.exports["DATABASE_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$f0298cbab4a44998;
module.exports["SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$fa02a8e56ccc9d5;
module.exports["WHITEBOARD_HEADER_SEGMENT_METRIC_KEY"] = $fa0ea3428ec5aa62$export$cf2f52fec740bdea;
module.exports["OBJECT_HEADER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$52050233077a1838;
module.exports["CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$e1ab333f0b70b317;
module.exports["WHITEBOARD_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b6a22e6ed7750ea4;
module.exports["DATABASE_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b95bd4bfc46932fc;
module.exports["FOLDER_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f6bd20f4f796eb89;
module.exports["SHARE_BUTTON_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$bf838b84ba2f7b95;
module.exports["VIEW_PAGE_LABELS_METRIC_KEY"] = $fa0ea3428ec5aa62$export$79910402df6be117;
module.exports["ADMIN_ANNOUNCEMENT_BANNER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$d86af34f7dc194b4;
module.exports["CONNECT_APP_WEB_FRAGMENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$ae588ea5fb9e92bb;
module.exports["SPACE_PERMISSIONS_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$1939caa7fae28ef5;
module.exports["VIEW_PAGE_CONTAINER_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3f06ee123a5ad183;
module.exports["EMBED_VIEW_PAGE_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$37da6122cd60d332;
module.exports["EMBED_VIEW_PAGE_BLANK_CONTENT_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$3437c1f145cfce19;
module.exports["EDITOR_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$7903037283afbce0;
module.exports["OBJECT_SIDEBAR_CONTROL_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$31d10d7597db11d3;
module.exports["COMMENTS_PANEL_OPEN_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b64d520f9b37dcd7;
module.exports["COMMENTS_PANEL_UNREAD_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$50553e47471a0f5e;
module.exports["COMMENTS_PANEL_DELETED_CONTENT_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$40d92ab0c1cc5298;
module.exports["COMMENTS_PANEL_RESOLVED_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$f2a6407ac901fd8d;
module.exports["COMMENTS_PANEL_MENTIONS_ME_VIEW_SEGMENT_KEY"] = $fa0ea3428ec5aa62$export$b3aade49b91bdeba;

});

parcelRegister("i3c1S", function(module, exports) {

var $hZpML = parcelRequire("hZpML");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");

// We preload a bunch of queries on mousedown. This is actually before transition happens.
// At the moment when queries were sent we don't know the next route yet.
// So we need to look back a bit see if we can find any queries that were sent before.
const $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS = 500;
function $82eb5b0eb983d5b4$export$9dbd6bda36500fa9(expectedPageSegments) {
    // Create list of timings for every segment that indicate actual start and end time for it.
    // This is useful for displaying page loading sequence as a waterfall, while tracking every
    // segment from page load start. Waterfall timings are prefixed with `wf/`.
    const markers = expectedPageSegments.map((segment)=>({
            key: `wf/react/${segment.key}`,
            endMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END}:${segment.key}`,
            startMark: `${0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_START}:${segment.key}`
        }));
    let measures;
    if ((0, $6VdZc.isInitial)()) measures = Object.values((0, $hZpML.WATERFALL_INITIAL_MEASURES));
    else {
        measures = (0, $hZpML.WaterfallMeasures).getMeasureKeys((0, $6VdZc.browserMetricsState).pageLoadStartTimestamp - $82eb5b0eb983d5b4$var$LOOK_BEHIND_MS).filter((key)=>key.startsWith('wf/client'));
        (0, $hZpML.WaterfallMeasures).clearMeasures();
    }
    measures.forEach((key)=>{
        markers.push({
            key: key,
            startMark: `${key}.start`,
            endMark: `${key}.end`
        });
    });
    return markers;
}
module.exports["getWaterfallTimings"] = $82eb5b0eb983d5b4$export$9dbd6bda36500fa9;

});

parcelRegister("fd6g2", function(module, exports) {
// "confluence.fe.custom.XXX"
const $88f9a74d7687653d$export$3fe4a04f712fdf3b = 'mentions-query';
const $88f9a74d7687653d$export$18a3d3c084ff47d0 = 'profile-card-query';
const $88f9a74d7687653d$export$95463e4d15a0dca9 = 'legacy-extension-loading';
const $88f9a74d7687653d$export$5a66bfdc2ac06329 = 'fabric-publish-page';
const $88f9a74d7687653d$export$96dfe3e664538004 = 'time-to-app-idle';
const $88f9a74d7687653d$export$18a3e97ff841447b = 'share-notif-from-restrictions';
const $88f9a74d7687653d$export$d0eb1faf5fa0dbc7 = 'tc-events-fetch';
const $88f9a74d7687653d$export$ec119fee4dbc7f75 = 'tc-subcals-fetch';
const $88f9a74d7687653d$export$693c7d831f137ed3 = 'tc-jira-projects-fetch';
module.exports["MENTIONS_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$3fe4a04f712fdf3b;
module.exports["PROFILE_CARD_QUERY_CUSTOM_KEY"] = $88f9a74d7687653d$export$18a3d3c084ff47d0;
module.exports["LEGACY_EXTENSION_LOADING_CUSTOM_KEY"] = $88f9a74d7687653d$export$95463e4d15a0dca9;
module.exports["FABRIC_PUBLISH_PAGE_KEY"] = $88f9a74d7687653d$export$5a66bfdc2ac06329;
module.exports["TIME_TO_APP_IDLE_KEY"] = $88f9a74d7687653d$export$96dfe3e664538004;
module.exports["TEAM_CALENDARS_EVENT_FETCH_KEY"] = $88f9a74d7687653d$export$d0eb1faf5fa0dbc7;
module.exports["TEAM_CALENDARS_SUBCALS_FETCH_KEY"] = $88f9a74d7687653d$export$ec119fee4dbc7f75;
module.exports["TEAM_CALENDARS_JIRA_PROJECTS_FETCH_KEY"] = $88f9a74d7687653d$export$693c7d831f137ed3;

});

parcelRegister("loJVf", function(module, exports) {

let $f93f7617efe317e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f93f7617efe317e8$var$load("aWPe2").then(()=>parcelRequire('bDxwy'));

});

parcelRegister("8Ss4E", function(module, exports) {

var $3AVOh = parcelRequire("3AVOh");


var $kyKWe = parcelRequire("kyKWe");


var $34MZN = parcelRequire("34MZN");


var $eYg5X = parcelRequire("eYg5X");


var $lTECB = parcelRequire("lTECB");


var $hukUK = parcelRequire("hukUK");


var $c3Qwv = parcelRequire("c3Qwv");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $irVI7 = parcelRequire("irVI7");


var $gykrH = parcelRequire("gykrH");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");


var $7v9li = parcelRequire("7v9li");


var $949zl = parcelRequire("949zl");


var $h10mo = parcelRequire("h10mo");

const $8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences = [
    (0, $irVI7.NOT_FOUND_EXPERIENCE),
    (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_EXPERIENCE),
    (0, $irVI7.RESTRICTED_SPACE_FOR_GUEST_EXPERIENCE)
];
const $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound = (0, $1A7bE.collectAny)($8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences);
const $8c50530bac3b9ba1$var$stopOnConnectAddon = (0, $1A7bE.collectAny)([
    (0, $irVI7.CONNECT_ADDON_EXPERIENCE)
]);
/**
 * Stores the new experiences started due to SPA transition
 */ const $8c50530bac3b9ba1$var$namesStartedInPreviousRoute = [];
/**
 *  Specifies routes that signify completion for each experience.
 *  Used with experienceTracker's collect function to monitor progress of experiences.
 *  For example, 'create page' experience is considered complete when it leads to 'edit page'.
 */ const $8c50530bac3b9ba1$var$redirectRoutesForExperiences = {
    [(0, $irVI7.CREATE_PAGE_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name // CREATE_PAGE_EXPERIENCE -> VIEW_PAGE means a live page was created
    ],
    // Same redirect routes as CREATE_PAGE_EXPERIENCE — the link-creation flow also succeeds when it leads to edit-page (a page was created from an Undefined Link).
    [(0, $irVI7.CREATE_PAGE_FROM_LINK_CREATION_EXPERIENCE)]: [
        (0, $1NBp8.EDIT_PAGE_V2).name,
        (0, $1NBp8.EDIT_BLOG_V2).name,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_BLOG).name,
        (0, $1NBp8.VIEW_PAGE).name
    ],
    [(0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE)]: [
        (0, $1NBp8.WHITEBOARD_BOARD).name
    ],
    [(0, $irVI7.CREATE_SLIDE_EXPERIENCE)]: [
        (0, $1NBp8.SLIDES_VIEW).name
    ],
    [(0, $irVI7.CREATE_DATABASE_EXPERIENCE)]: [
        (0, $1NBp8.DATABASE_VIEW).name
    ],
    [(0, $irVI7.CREATE_EMBED_EXPERIENCE)]: [
        (0, $1NBp8.EMBED_VIEW).name
    ]
};
const $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE = [
    (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE)
];
const $8c50530bac3b9ba1$export$3fe90f303be4225a = 'Aborted due to SPA started a new experience';
const $8c50530bac3b9ba1$export$4b786e0ae0cc0857 = {
    [(0, $1NBp8.SPACE_OVERVIEW).name]: 'space',
    [(0, $1NBp8.COMPANY_HUB).name]: 'space',
    [(0, $1NBp8.EDIT_PAGE_EMBED).name]: 'page',
    [(0, $1NBp8.EDIT_PAGE_V2).name]: 'page',
    [(0, $1NBp8.EDIT_BLOG_V2).name]: 'blog',
    [(0, $1NBp8.VIEW_PAGE).name]: 'page',
    [(0, $1NBp8.VIEW_BLOG).name]: 'blog',
    [(0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name]: 'blog'
};
const $8c50530bac3b9ba1$export$5396770e9da36673 = (routeName)=>{
    switch(routeName){
        case (0, $1NBp8.EDIT_BLOG).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.CREATE_PAGE).name:
            return 'TINY';
        default:
            return 'FABRIC';
    }
};
function $8c50530bac3b9ba1$export$cac1117e2433d80e(match, transitionId, sessionData) {
    if (!match) return;
    const tracker = (0, $fGzMp.getExperienceTracker)();
    // Moves current route data to previous route data to ensure `getExperienceTracker.ts getPreviousRouteExperienceData()` works correctly
    (0, $fGzMp.captureRouteChange)(match.name);
    // Live page's edit-page and session experience starts after the route has finished loading and unsubscribed from the tracker, so it's not in the `startExperienceForRoute` function's namesStartedInPreviousRoute array. We will handle finishing it separately in `finishLivePageExperiences`.
    // It's important that `finishLivePageExperiences` is invoked before we attempt to succeed EDIT_PAGE_EXPERIENCE below, as `finishLivePageExperiences` is responsible for succeeding EDIT_PAGE_EXPERIENCE on live pages while setting the experience attribute `isLivePage
    $8c50530bac3b9ba1$var$finishLivePageExperiences();
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.forEach((name)=>{
        const allowedRoutes = $8c50530bac3b9ba1$var$redirectRoutesForExperiences[name];
        // For create content routes, we do not want to abort if it is routing to correct page.
        // But, if it is a create experience and routing to a page is is not supposed to be going to,
        // we can assume something is wrong and we abort it.
        if (allowedRoutes && allowedRoutes.includes(match.name)) return;
        if (// If we were on edit-page or view-page/session experience and leave to another route, we should succeed that experience, not abort it.
        name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $7v9li.hasHealthyRunningEditPageExperience)() || name === (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE) && (0, $7v9li.hasHealthyRunningCompanyHubEditExperience)() || name === (0, $irVI7.VIEW_PAGE_SESSION_EXPERIENCE) && (0, $949zl.hasHealthyRunningViewPageExperience)()) {
            tracker.succeed({
                name: name
            });
            return;
        }
        // For all other situations, we still abort.
        tracker.abort({
            name: name,
            reason: $8c50530bac3b9ba1$export$3fe90f303be4225a
        });
    });
    $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.length = 0;
    const unsubscribe = tracker.subscribe((e)=>{
        if (e.action === 'taskStart') $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(e.name);
    });
    $8c50530bac3b9ba1$var$EXPERIENCES_TO_ABORT_ON_ROUTE_CHANGE.forEach((name)=>{
        $8c50530bac3b9ba1$var$namesStartedInPreviousRoute.push(name);
    });
    switch(match.name){
        case (0, $1NBp8.COMPANY_HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.HUB_EDIT).name:
            $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
            // With the redirect on, these routes forward to edit-v2, which starts its own experience.
            if (!(0, $6mKj3.expValEquals)('confluence_redirect_legacy_edit', 'isEnabled', true)) $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.CREATE_PAGE).name:
            // With the redirect on, this route forwards to the Fabric editor and never loads the legacy one.
            if (!(0, $6mKj3.expValEquals)('confluence_redirect_legacy_create', 'isEnabled', true)) $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData);
            break;
        case (0, $1NBp8.VIEW_PAGE).name:
        case (0, $1NBp8.VIEW_BLOG).name:
        case (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.contentId, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData);
            break;
        case (0, $1NBp8.PAGE_SPLIT).name:
            $8c50530bac3b9ba1$var$startSplitPageLoad(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name:
            $8c50530bac3b9ba1$var$startEditPageSmartCreate(match);
            break;
        case (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(match.query.tab, match.query.space, transitionId);
            break;
        case (0, $1NBp8.EXTERNAL_SHARE).name:
            $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(match.params.id, transitionId);
            break;
        case (0, $1NBp8.SPACE_OVERVIEW).name:
            $8c50530bac3b9ba1$var$startViewContent(match.params.spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: match.params.spaceKey,
                isLandingPage: match.search === '?mode=global'
            });
            break;
        case (0, $1NBp8.COMPANY_HUB).name:
            const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)(sessionData) || '';
            $8c50530bac3b9ba1$var$startViewContent(spaceKey, transitionId, $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name], match.query, sessionData, {
                spaceKey: spaceKey
            });
            break;
        case (0, $1NBp8.HOME).name:
            (0, $h10mo.startHome)();
            break;
        case (0, $1NBp8.EDIT_TEMPLATE_SPACE).name:
        case (0, $1NBp8.EDIT_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(match.params.contentId, transitionId);
            break;
        case (0, $1NBp8.CREATE_TEMPLATE_SPACE).name:
        case (0, $1NBp8.CREATE_TEMPLATE).name:
            $8c50530bac3b9ba1$var$startTemplateEditPage(/* id */ undefined, transitionId);
            break;
        case (0, $1NBp8.ADVANCED_SEARCH).name:
            $8c50530bac3b9ba1$var$startAdvancedSearch(match);
            break;
        case (0, $1NBp8.SPACE_ARCHIVED_PAGES).name:
            $8c50530bac3b9ba1$var$startArchivedPagesList();
            break;
        case (0, $1NBp8.SPACE_BULK_TOOLS).name:
            $8c50530bac3b9ba1$var$startContentManager();
            break;
        case (0, $1NBp8.SPACE_DIRECTORY).name:
            $8c50530bac3b9ba1$var$startSpaceDirectory();
            break;
        case (0, $1NBp8.TEMPLATE_GALLERY).name:
            $8c50530bac3b9ba1$var$startTemplateGallery();
            break;
        case (0, $1NBp8.SPACE_PAGES).name:
            $8c50530bac3b9ba1$var$startSpacePages();
            break;
        case (0, $1NBp8.WHITEBOARD_BOARD).name:
            $8c50530bac3b9ba1$var$startWhiteboardBoard(match);
            break;
        case (0, $1NBp8.SLIDES_VIEW).name:
            $8c50530bac3b9ba1$var$startSlideView(match.params.contentId);
            break;
        case (0, $1NBp8.DATABASE_VIEW).name:
            $8c50530bac3b9ba1$var$startDatabaseView(match.params.contentId);
            break;
        case (0, $1NBp8.EMBED_VIEW).name:
            $8c50530bac3b9ba1$var$startEmbedPageView(match.params.contentId);
            break;
        case (0, $1NBp8.FOLDER_VIEW).name:
            $8c50530bac3b9ba1$var$startFolderView(match.params.contentId);
            break;
        case (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name:
            //Adding the other space perms uplift tabs at a later date.
            if (match.params.tab === 'public-links') $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings();
            break;
        case (0, $1NBp8.ADMIN_ANNOUNCEMENT_BANNER_RENDERER).name:
            $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings();
            break;
        case (0, $1NBp8.SPACE_MANAGER).name:
            $8c50530bac3b9ba1$var$startSpaceManager();
            break;
        case (0, $1NBp8.ADMIN_COMPANY_HOME_BUILDER).name:
        case (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name:
            $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad();
            break;
    }
    const startCreateOperations = ()=>{
        const subType = typeof match?.query?.subType === 'string' ? match.query.subType : null;
        if (match.name === (0, $1NBp8.CREATE_CONTENT).name) $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType);
        else if (match.query.createDialog) {
            $8c50530bac3b9ba1$var$startCreatePage(String(transitionId), transitionId, subType);
            (0, $7v9li.startCreateAndEditPage)();
        }
    };
    startCreateOperations();
    unsubscribe();
}
function $8c50530bac3b9ba1$var$startSplitPageLoad(contentId, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPLIT_PAGE_LOAD_EXPERIENCE),
        id: contentId,
        startTime: transitionId === 0 ? 0 : undefined
    });
}
function $8c50530bac3b9ba1$var$startCreatePage(id, transitionId, subType) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_EXPERIENCE),
        id: id,
        attributes: {
            isLivePage: subType?.toLowerCase() === 'live'
        },
        startTime: transitionId === 0 ? 0 : undefined,
        collect (events, experience) {
            experience.stopOn(events.find((event)=>event.action === 'taskFail' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE), (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskSuccess' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
            experience.stopOn(events.find((event)=>event.action === 'taskAbort' && (0, $gykrH.hasName)(event, (0, $irVI7.CREATE_PAGE_TEMPLATE_VARIABLES_EXPERIENCE))));
        }
    });
    experienceTracker.start({
        name: (0, $irVI7.CREATE_PAGE_LOAD_DIALOG_EXPERIENCE),
        id: id,
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_DIALOG_LOAD
    });
}
function $8c50530bac3b9ba1$export$b9a409823a06b924(experienceName) {
    const activeTrace = (0, $34MZN.getActiveTrace)();
    if (!activeTrace) (0, $eYg5X.default)(experienceName.replace(/\//g, '-'));
}
function $8c50530bac3b9ba1$export$478e84e2cc5ff22d(compoundExperience, editorLoadExperience, editorPublishExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const compoundExperienceAttributes = {
        ...compoundExperience.attributes,
        compoundTaskId: compoundTaskId
    };
    experienceTracker.start({
        ...compoundExperience,
        id: compoundTaskId,
        attributes: compoundExperienceAttributes,
        collect: (events, experience)=>{
            experience.stopOn(events.find(({ action: action, name: name })=>action === 'taskFail' && name === editorLoadExperience.name));
            experience.stopOn(events.find(({ action: action, name: name })=>(action === 'taskSuccess' || action === 'taskFail') && name === editorPublishExperience.name));
            if (compoundExperience.collect) compoundExperience.collect(events, experience);
        }
    });
    experienceTracker.start({
        ...editorLoadExperience,
        id: editorLoadExperience.id || compoundExperience.id,
        timeout: editorLoadExperience.timeout || (0, $aJPUt.ExperienceTimeout).EDITOR_LOAD,
        attributes: compoundExperienceAttributes,
        collect: editorLoadExperience.collect
    });
}
function $8c50530bac3b9ba1$export$7df6656d8508e8da(subExperience) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // Initialize attributes from the original subExperience
    const attributes = {
        ...subExperience.attributes
    };
    // Extract the compound experience name from the sub-experience name if it follows
    // the naming convention "<compound_experience_name>/<sub_experience>"
    const subExperienceName = subExperience.name;
    const nameParts = subExperienceName.split('/');
    // Only attempt to get compound experience if the name includes a separator
    if (nameParts.length > 1) {
        const compoundExperienceName = nameParts[0];
        const compoundExperienceState = experienceTracker.getExperienceState(compoundExperienceName);
        // If compound experience exists, inherit its compoundTaskId
        if (compoundExperienceState) // Link the compound experience's compoundTaskId if available
        {
            if (compoundExperienceState.attributes?.compoundTaskId) attributes.compoundTaskId = compoundExperienceState.attributes.compoundTaskId;
        }
    }
    // Start the sub-experience with the attributes (original or enhanced with compoundTaskId)
    experienceTracker.start({
        ...subExperience,
        attributes: attributes
    });
}
const $8c50530bac3b9ba1$var$stopOnCloseForEditPage = (events, experience, loadExperienceName, closeExperienceName)=>{
    const loadStopExperience = events.find((event)=>event.name === loadExperienceName && (0, $gykrH.isStop)(event));
    const closeStopExperience = events.find((event)=>event.name === closeExperienceName && (0, $gykrH.isStop)(event));
    if (!closeStopExperience) return;
    // prettier-ignore
    if ((!loadStopExperience || loadStopExperience.action !== "taskSuccess") && closeStopExperience.action === "taskSuccess") // loading incomplete or failed, therefore editing session was broken and close doesn't indicate a success
    experience.abort({
        reason: "Editor closed before load completed",
        attributes: {
            loadExperienceState: loadStopExperience?.action ?? "incomplete"
        }
    });
    else experience.stopOn(closeStopExperience);
};
function $8c50530bac3b9ba1$var$startEditPageSmartCreate(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE),
        id: match.params.contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        attributes: {
            // The only identifier shared with the embedding product's preview experience.
            sharedFeaturesInstrumentationId: (0, $c3Qwv.getSingleParam)(match.query, 'sharedFeaturesInstrumentationId')
        },
        collect: (events, experience)=>{
            const hasNoPermissionOrNotFoundEvent = events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...$8c50530bac3b9ba1$var$noPermissionOrNotFoundExperiences));
            if (hasNoPermissionOrNotFoundEvent) experience.fail({
                error: new Error(`${hasNoPermissionOrNotFoundEvent.name} experience resulted in ${hasNoPermissionOrNotFoundEvent.action} - unexpected for the smart create editor`)
            });
        }
    });
}
function $8c50530bac3b9ba1$var$startEditPage(match, transitionId, sessionData) {
    const isLegacyEditor = $8c50530bac3b9ba1$export$5396770e9da36673(match?.name ?? '') === 'TINY';
    let editPageExperienceName = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    if (match.name === (0, $1NBp8.EDIT_PAGE_EMBED).name) editPageExperienceName = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (isLegacyEditor) editPageExperienceName = (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE);
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: editPageExperienceName,
        id: match.params.contentId,
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: $8c50530bac3b9ba1$export$5396770e9da36673(match.name),
            contentType: $8c50530bac3b9ba1$export$4b786e0ae0cc0857[match.name],
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: match?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || match?.name === (0, $1NBp8.HUB_EDIT).name,
            contentId: match.params.contentId,
            isGuest: sessionData?.accessStatus === 'EXTERNAL_COLLABORATOR_ACCESS'
        },
        // override with full-page-editor specific stop/collect behaviour
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const loadExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, loadExperienceName, closeExperienceName);
        }
    }, /* editorLoadExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_LOAD_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            const closeExperienceName = isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_CLOSE_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_CLOSE_EXPERIENCE);
            const closeExperience = events.find((event)=>(0, $gykrH.isStop)(event) && event.name === closeExperienceName);
            if (closeExperience) experience.abort({
                reason: 'Editor closed before load completed',
                attributes: {
                    closeExperienceState: closeExperience?.action ?? 'incomplete'
                }
            });
        }
    }, /* editorPublishExperience */ {
        name: isLegacyEditor ? (0, $irVI7.EDIT_LEGACY_PAGE_PUBLISH_EXPERIENCE) : (0, $irVI7.EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCompanyHubEditor(transitionId, sessionData) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_EXPERIENCE),
        startTime: transitionId === 0 ? 0 : undefined,
        attributes: {
            editor: 'FABRIC',
            contentType: 'space',
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            isCompanyHub: true
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnCloseForEditPage(events, experience, (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE), (0, $irVI7.COMPANY_HUB_EDITOR_CLOSE_EXPERIENCE));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.COMPANY_HUB_EDITOR_LOAD_EXPERIENCE),
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        }
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.FRONT_COVER_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startViewContent(id, transitionId, contentType, query, sessionData, attributes) {
    // WS-3261 - We need to track if the view is coming from an external source (email notification, Slack, etc.)
    const isFromExternal = Boolean(query && query.atlOrigin);
    // Track APDEX part of the content (title and content itself)
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_CONTENT_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD,
        attributes: {
            contentType: contentType,
            isFromExternal: isFromExternal,
            edition: sessionData?.edition,
            shard: sessionData?.shard,
            ...attributes
        },
        collect: (events, experience)=>{
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
            $8c50530bac3b9ba1$var$stopOnConnectAddon(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkGlobalSettings(tab, space, transitionId) {
    if (tab === 'public-links' && !space) (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SITE_SETTINGS_EXPERIENCE),
        id: 'public-links',
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinksSpaceSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINKS_SPACE_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startViewPublicLinkSharedPage(id, transitionId) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        timeout: (0, $aJPUt.ExperienceTimeout).PAGE_LOAD
    });
}
function $8c50530bac3b9ba1$var$startTemplateEditPage(id, transitionId) {
    $8c50530bac3b9ba1$export$478e84e2cc5ff22d(/* compoundExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_EXPERIENCE),
        id: id,
        startTime: transitionId === 0 ? 0 : undefined,
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && event.name === (0, $irVI7.TEMPLATE_EDIT_PAGE_CLOSE_EXPERIENCE)));
        }
    }, /* editorLoadExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).TEMPLATE_EDITOR_LOAD
    }, /* editorPublishExperience */ {
        name: (0, $irVI7.TEMPLATE_EDIT_PAGE_PUBLISH_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startAdvancedSearch(match) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE),
        id: (0, $hukUK.objectHash)((0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(match.query, [
            'search_id'
        ]))
    });
}
function $8c50530bac3b9ba1$var$startArchivedPagesList() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_ARCHIVED_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startContentManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CONTENT_MANAGER_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startSpaceDirectory() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_DIRECTORY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).SPACE_DIRECTORY
    });
}
function $8c50530bac3b9ba1$var$startTemplateGallery() {
    const TemplateGallerySubExperiences = [
        (0, $irVI7.TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_SPACE_SELECTOR_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_CARDS_EXPERIENCE),
        (0, $irVI7.TEMPLATE_GALLERY_TEMPLATE_DETAIL_EXPERIENCE)
    ];
    const collectTemplateGalleryLoadExperiences = (events, experience)=>{
        (0, $1A7bE.collectAll)(TemplateGallerySubExperiences)(events, experience);
    };
    const stopOnRestrictedPage = (0, $1A7bE.collectAll)([
        (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    ]);
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.TEMPLATE_GALLERY_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT,
        collect: (events, experience)=>{
            collectTemplateGalleryLoadExperiences(events, experience);
            stopOnRestrictedPage(events, experience);
        }
    });
}
function $8c50530bac3b9ba1$var$startSpacePages() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_PAGES_EXPERIENCE)
    });
}
function $8c50530bac3b9ba1$var$startCreateContent(match, sessionData, subType) {
    const queryParams = match.query;
    const isPersonalSpace = queryParams.spaceKey?.[0] !== undefined ? (queryParams.spaceKey[0] === '~').toString() : 'unknown';
    const flow = (0, $c3Qwv.getSingleParam)(queryParams, 'source') || 'createContentRoute';
    if (match.params.contentType === 'whiteboard') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.WHITEBOARD_EXPERIENCE));
            if (whiteboardExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'slide') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_SLIDE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            experience.stopOn(events.find((event)=>(event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort') && event.name === (0, $irVI7.SLIDE_CONTENT_EXPERIENCE)));
        }
    });
    else if (match.params.contentType === 'database') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const databaseExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.DATABASE_EXPERIENCE));
            if (databaseExperienceStart) experience.succeed();
        }
    });
    else if (match.params.contentType === 'smartLinkEmbed') (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.CREATE_EMBED_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
        attributes: {
            flow: flow,
            isPersonalSpace: isPersonalSpace
        },
        collect: (events, experience)=>{
            const smartLinkEmbedExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.EMBED_EXPERIENCE));
            if (smartLinkEmbedExperienceStart) experience.succeed();
        }
    });
    else if ([
        'page',
        'blog'
    ].includes(match.params.contentType)) {
        // Undefined Links flows (linkCreation=true) are tracked under a separate non-SLA experience
        // to prevent them from polluting the SLA'd create-page experience
        const isLinkCreationFlow = (0, $c3Qwv.getSingleParam)(queryParams, 'linkCreation') === 'true';
        const createPageExperienceName = isLinkCreationFlow ? (0, $irVI7.CREATE_PAGE_FROM_LINK_CREATION_EXPERIENCE) : (0, $irVI7.CREATE_PAGE_EXPERIENCE);
        (0, $fGzMp.getExperienceTracker)().start({
            name: createPageExperienceName,
            timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
            attributes: {
                contentType: match.params.contentType,
                flow: flow,
                isCreateContentRoute: true,
                isPersonalSpace: isPersonalSpace,
                edition: sessionData?.edition,
                shard: sessionData?.shard,
                isLivePage: subType?.toLowerCase() === 'live'
            },
            collect: (events, experience)=>{
                const editPageStarted = events.find((event)=>event.action === 'taskStart' && (event.name === (0, $irVI7.EDIT_PAGE_EXPERIENCE) || event.name === (0, $irVI7.EDIT_LEGACY_PAGE_EXPERIENCE)));
                if (editPageStarted) experience.succeed();
            }
        });
    }
}
function $8c50530bac3b9ba1$var$startWhiteboardBoard(match) {
    const embeddedWhiteboardSubExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.WHITEBOARD_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    const contentId = match.params.contentId;
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.WHITEBOARD_EXPERIENCE), isEmbedded ? embeddedWhiteboardSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSlideView(contentId) {
    const subExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedSlideSubExperiences = [
        (0, $irVI7.SLIDE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.SLIDE_EXPERIENCE), isEmbedded ? embeddedSlideSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startDatabaseView(contentId) {
    const subExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    const embeddedDatabaseSubExperiences = [
        (0, $irVI7.DATABASE_CONTENT_EXPERIENCE)
    ];
    const isEmbedded = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)();
    $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, (0, $irVI7.DATABASE_EXPERIENCE), isEmbedded ? embeddedDatabaseSubExperiences : subExperiences);
}
function $8c50530bac3b9ba1$var$startSubExperiencesForMainExperience(contentId, mainExperience, subExperiences) {
    (0, $fGzMp.getExperienceTracker)().start({
        name: mainExperience,
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    subExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startEmbedPageView(contentId) {
    const embedPageSubExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE),
        (0, $irVI7.VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE)
    ];
    const subExperiences = [
        (0, $irVI7.EMBED_CONTENT_EXPERIENCE),
        (0, $irVI7.CONTENT_TYPES_HEADER_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.EMBED_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(subExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    embedPageSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startFolderView(contentId) {
    const folderSubExperiences = [
        (0, $irVI7.FOLDER_CONTENT_EXPERIENCE)
    ];
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.FOLDER_EXPERIENCE),
        collect: (events, experience)=>{
            (0, $1A7bE.collectAll)(folderSubExperiences)(events, experience);
            $8c50530bac3b9ba1$var$stopOnNoPermissionOrNotFound(events, experience);
        },
        id: contentId,
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
    folderSubExperiences.forEach((name)=>{
        (0, $fGzMp.getExperienceTracker)().start({
            name: name,
            id: contentId
        });
    });
}
function $8c50530bac3b9ba1$var$startViewAdminAnnouncementBannerSettings() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.ADMIN_ANNOUNCEMENT_BANNER_SETTINGS_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startSpaceManager() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.SPACE_MANAGER_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$startCompanyHomeBuilderLoad() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.COMPANY_HOME_BUILDER_LOAD_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
    });
}
function $8c50530bac3b9ba1$var$finishLivePageExperiences() {
    const tracker = (0, $fGzMp.getExperienceTracker)();
    const livePageExperiencesToSucceed = [
        (0, $irVI7.EDIT_PAGE_EXPERIENCE),
        (0, $irVI7.LIVE_PAGE_SESSION_EXPERIENCE)
    ];
    livePageExperiencesToSucceed.forEach((experience)=>{
        const experienceState = tracker.getExperienceState(experience);
        // We want to identify if it's actively running, and if so, succeed it. This aligns with how we succeed non-live-page experiences on transition.
        // We validate the `isLivePage` attribute is `true` before succeeding, to avoid undesirably succeeding edit-page here when it's not a live page
        if (experienceState && !experienceState?.hasStopped && experienceState?.attributes?.isLivePage) tracker.succeed({
            name: experience
        });
    });
}
module.exports["ROUTE_CHANGE_ABORT_REASON"] = $8c50530bac3b9ba1$export$3fe90f303be4225a;
module.exports["routeNameToContentTypeMap"] = $8c50530bac3b9ba1$export$4b786e0ae0cc0857;
module.exports["startExperienceForRoute"] = $8c50530bac3b9ba1$export$cac1117e2433d80e;
module.exports["startUFOPressTrace"] = $8c50530bac3b9ba1$export$b9a409823a06b924;
module.exports["startEditorExperiences"] = $8c50530bac3b9ba1$export$478e84e2cc5ff22d;
module.exports["startEditorSubExperience"] = $8c50530bac3b9ba1$export$7df6656d8508e8da;

});

parcelRegister("3AVOh", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $hGc5T = parcelRequire("hGc5T");


var $hcV0q = parcelRequire("hcV0q");


var $aI4Cx = parcelRequire("aI4Cx");


var $bk5x8 = parcelRequire("bk5x8");


var $ezTcL = parcelRequire("ezTcL");


var $jPzTX = parcelRequire("jPzTX");


var $14dnq = parcelRequire("14dnq");

/** Used to compose bitmasks for cloning. */ var $29e193b87644e449$var$CLONE_DEEP_FLAG = 1, $29e193b87644e449$var$CLONE_FLAT_FLAG = 2, $29e193b87644e449$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $29e193b87644e449$var$omit = $jPzTX(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $79D42(paths, function(path) {
        path = $aI4Cx(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $bk5x8(object, $14dnq(object), result);
    if (isDeep) result = $hGc5T(result, $29e193b87644e449$var$CLONE_DEEP_FLAG | $29e193b87644e449$var$CLONE_FLAT_FLAG | $29e193b87644e449$var$CLONE_SYMBOLS_FLAG, $ezTcL);
    var length = paths.length;
    while(length--)$hcV0q(result, paths[length]);
    return result;
});
module.exports = $29e193b87644e449$var$omit;

});

parcelRegister("hcV0q", function(module, exports) {

var $aI4Cx = parcelRequire("aI4Cx");


var $gO1os = parcelRequire("gO1os");


var $3ye78 = parcelRequire("3ye78");


var $4yN45 = parcelRequire("4yN45");

/** Used for built-in method references. */ var $c86fc6d9079351ab$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c86fc6d9079351ab$var$hasOwnProperty = $c86fc6d9079351ab$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $c86fc6d9079351ab$var$baseUnset(object, path) {
    path = $aI4Cx(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = $4yN45(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === '__proto__' && !$c86fc6d9079351ab$var$hasOwnProperty.call(object, '__proto__')) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
    }
    var obj = $3ye78(object, path);
    return obj == null || delete obj[$4yN45($gO1os(path))];
}
module.exports = $c86fc6d9079351ab$var$baseUnset;

});

parcelRegister("3ye78", function(module, exports) {

var $5g03W = parcelRequire("5g03W");


var $dAhdV = parcelRequire("dAhdV");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $295f7eda793e290e$var$parent(object, path) {
    return path.length < 2 ? object : $5g03W(object, $dAhdV(path, 0, -1));
}
module.exports = $295f7eda793e290e$var$parent;

});

parcelRegister("ezTcL", function(module, exports) {

var $etJuK = parcelRequire("etJuK");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $a9cf2821aeb590cb$var$customOmitClone(value) {
    return $etJuK(value) ? undefined : value;
}
module.exports = $a9cf2821aeb590cb$var$customOmitClone;

});

parcelRegister("jPzTX", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $e7pPJ = parcelRequire("e7pPJ");


var $d246i = parcelRequire("d246i");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $e6fea10dbb684687$var$flatRest(func) {
    return $d246i($e7pPJ(func, undefined, $lyW2B), func + '');
}
module.exports = $e6fea10dbb684687$var$flatRest;

});

parcelRegister("lyW2B", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $fb29cba7dcd09042$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $avFJ9(array, 1) : [];
}
module.exports = $fb29cba7dcd09042$var$flatten;

});

parcelRegister("avFJ9", function(module, exports) {

var $8kPaX = parcelRequire("8kPaX");


var $eED1E = parcelRequire("eED1E");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a6d2ac83094702e$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $eED1E);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a6d2ac83094702e$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $8kPaX(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a6d2ac83094702e$var$baseFlatten;

});

parcelRegister("eED1E", function(module, exports) {

var $2v1OR = parcelRequire("2v1OR");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");

/** Built-in value references. */ var $aab312c604d1130a$var$spreadableSymbol = $2v1OR ? $2v1OR.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $aab312c604d1130a$var$isFlattenable(value) {
    return $1ScXu(value) || $bZ5J1(value) || !!($aab312c604d1130a$var$spreadableSymbol && value && value[$aab312c604d1130a$var$spreadableSymbol]);
}
module.exports = $aab312c604d1130a$var$isFlattenable;

});

parcelRegister("hukUK", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $1AV5C = parcelRequire("1AV5C");

let $ad68a267ac2e31a8$var$SESSION_SALT;
const $ad68a267ac2e31a8$export$237ebf1f4974c28e = ()=>{
    $ad68a267ac2e31a8$var$SESSION_SALT = (0, $9HkI0.v4)();
};
const $ad68a267ac2e31a8$var$toStringArray = (arr)=>`[${arr.map((item)=>$ad68a267ac2e31a8$var$toString(item)).join(',')}]`;
const $ad68a267ac2e31a8$var$toString = (o)=>{
    if (o === null) return 'null';
    if (Array.isArray(o)) return $ad68a267ac2e31a8$var$toStringArray(o);
    if (typeof o == 'object') return $ad68a267ac2e31a8$export$66b1d6a1029e925d(o);
    if (typeof o == 'string') return `"${o}"`;
    return `${o.toString()}`;
};
const $ad68a267ac2e31a8$export$66b1d6a1029e925d = (o)=>{
    if (!$ad68a267ac2e31a8$var$SESSION_SALT) $ad68a267ac2e31a8$export$237ebf1f4974c28e();
    const strToHash = `${Object.entries(o).filter(([_, value])=>typeof value !== 'undefined').sort((a, b)=>a[0].localeCompare(b[0])).map(([key, value])=>`${key}:${$ad68a267ac2e31a8$var$toString(value)}`).join()},${$ad68a267ac2e31a8$var$SESSION_SALT}`;
    return (0, $1AV5C.hashData)(strToHash);
};
module.exports["objectHash"] = $ad68a267ac2e31a8$export$66b1d6a1029e925d;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_PAGE_COMMENT"] = 30000] = "VIEW_PAGE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("1A7bE", function(module, exports) {

var $gykrH = parcelRequire("gykrH");

const $812facbbd37978f7$export$feb7963ae429f97f = (experienceNames)=>{
    const experienceNameSet = new Set(experienceNames);
    return (events, experience)=>{
        // Fail as soon as any sub-experience is failed or aborted
        experience.stopOn(events.find((event)=>experienceNameSet.has(event.name) && (event.action === 'taskFail' || event.action === 'taskAbort')), {
            incompleteSubExperiences: [
                ...experienceNameSet
            ].join(', ')
        });
        // If there's a success remove the experience from the set
        // of experiences we're waiting for.
        events.forEach((event)=>{
            if ((0, $gykrH.isStop)(event)) experienceNameSet.delete(event.name);
        });
        // Experience is considered complete if all sub-experiences
        // are complete.
        if (experienceNameSet.size === 0) experience.succeed();
    };
};
const $812facbbd37978f7$export$79dbdd3e43727beb = (experienceNames)=>(events, experience)=>experience.stopOn(events.find((event)=>(0, $gykrH.isStop)(event) && (0, $gykrH.hasName)(event, ...experienceNames)));
module.exports["collectAll"] = $812facbbd37978f7$export$feb7963ae429f97f;
module.exports["collectAny"] = $812facbbd37978f7$export$79dbdd3e43727beb;

});

parcelRegister("h10mo", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

const $49be9d39a158f0e7$var$homeSubExperiences = [
    (0, $irVI7.HOME_OVERVIEW_EXPERIENCE),
    (0, $irVI7.HOME_RECENT_EXPERIENCE),
    (0, $irVI7.HOME_STARRED_EXPERIENCE),
    (0, $irVI7.HOME_WATCHING_EXPERIENCE),
    (0, $irVI7.HOME_DRAFTS_EXPERIENCE)
];
function $49be9d39a158f0e7$export$4278268ff5675d74() {
    (0, $fGzMp.getExperienceTracker)().start({
        name: (0, $irVI7.HOME_EXPERIENCE),
        collect: (0, $1A7bE.collectAny)($49be9d39a158f0e7$var$homeSubExperiences)
    });
}
module.exports["startHome"] = $49be9d39a158f0e7$export$4278268ff5675d74;

});

parcelRegister("hzVuz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1NBp8 = parcelRequire("1NBp8");


var $6mKj3 = parcelRequire("6mKj3");





var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");


var $k3pHv = parcelRequire("k3pHv");

const $b7aff31f4e633d8f$var$checkDomainApproval = async (cloudId, userId, onError)=>{
    let OrgMemberCapabilityType = /*#__PURE__*/ function(OrgMemberCapabilityType) {
        OrgMemberCapabilityType["DIRECT_ACCESS"] = "DIRECT_ACCESS";
        OrgMemberCapabilityType["REQUEST_ACCESS"] = "REQUEST_ACCESS";
        OrgMemberCapabilityType["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
        return OrgMemberCapabilityType;
    }({});
    const params = new URLSearchParams({
        resource: `ari:cloud:confluence::site/${cloudId}`
    });
    let hasCapabilities = false;
    try {
        const response = await (0, $f7B1p.cfetch)(`/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`, {
            method: 'GET',
            headers: {
                resource: `ari:cloud:confluence::site/${cloudId}`,
                ACCEPT: 'application/json',
                'Account-Id': userId
            }
        });
        const data = await response.json();
        if (Object.values(data.results)[0] in OrgMemberCapabilityType) hasCapabilities = true;
    } catch (e) {
        if ((0, $hBkCm.BadStatusError).isBadStatusError(e) && e.response?.status === 401) // A 401 from the invitations gateway is expected for guest/external users whose
        // session tokens are scoped to Confluence only and cannot authenticate against
        // platform APIs. Treat this as "not an org member" without failing the experience.
        return false;
        const response = (0, $hBkCm.BadStatusError).isBadStatusError(e) ? e.response : undefined;
        const error = new Error(`Error in getting approved domains, status = ${response?.status}, message = "${response?.statusText}"`);
        onError(error);
    }
    return hasCapabilities;
};
const $b7aff31f4e633d8f$export$435bbe3b3c44f9d8 = (isExternalShareRequest = false)=>{
    const { isLicensed: isLicensed, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [isApprovedOrgMember, setIsApprovedOrgMember] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        const validateDomain = async ()=>{
            if (userId && !isLicensed && isExternalShareRequest) {
                const isApproved = await $b7aff31f4e633d8f$var$checkDomainApproval(cloudId, userId, (error)=>{
                    experienceTracker.fail({
                        name: (0, $irVI7.VIEW_PUBLIC_LINK_SHARED_PAGE_EXPERIENCE),
                        error: error
                    });
                });
                isApproved && setIsApprovedOrgMember(isApproved);
            }
        };
        validateDomain();
    }, [
        userId,
        isLicensed,
        cloudId,
        experienceTracker,
        isExternalShareRequest
    ]);
    if (!userId) return {
        userType: (0, $k3pHv.UserTypes).ANONYMOUS
    };
    if (isLicensed) return {
        userType: (0, $k3pHv.UserTypes).CONFLUENCE_USER
    };
    return {
        userType: isApprovedOrgMember ? (0, $k3pHv.UserTypes).ORG_MEMBER : (0, $k3pHv.UserTypes).ATLASSIAN_USER
    };
};



var $gXrHX = parcelRequire("gXrHX");

const $a5952995c9c756c1$export$355d4724e049b0df = ({ children: children, path: path, shareToken: shareToken })=>{
    const isExternalShareRequest = !!(0, $1NBp8.EXTERNAL_SHARE).match(path);
    const isAccessLinkRequest = !!(0, $1NBp8.ACCESS_LINK).match(path) && (0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false);
    const { userType: userType } = (0, $b7aff31f4e633d8f$export$435bbe3b3c44f9d8)(isExternalShareRequest || isAccessLinkRequest);
    // Extract shareToken from path if it's an external share request
    const extractedShareToken = (0, $cozmU.useMemo)(()=>{
        if (isExternalShareRequest) {
            const match = (0, $1NBp8.EXTERNAL_SHARE).match(path);
            return match?.params?.externalToken || undefined;
        } else if (isAccessLinkRequest) {
            const match = (0, $1NBp8.ACCESS_LINK).match(path);
            return match?.params?.shareToken || undefined;
        }
        return undefined;
    }, [
        isExternalShareRequest,
        path,
        isAccessLinkRequest
    ]);
    // Use provided shareToken if available, otherwise use extracted one
    const resolvedShareToken = shareToken || extractedShareToken;
    const externalShareContextValue = (0, $cozmU.useMemo)(()=>({
            isExternalShareRequest: isExternalShareRequest || isAccessLinkRequest,
            userType: userType,
            shareToken: resolvedShareToken,
            isAccessLinkRequest: isAccessLinkRequest
        }), [
        isExternalShareRequest,
        userType,
        resolvedShareToken,
        isAccessLinkRequest
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gXrHX.ExternalShareContext).Provider, {
        value: externalShareContextValue
    }, children);
};
module.exports["ExternalShareContextProvider"] = $a5952995c9c756c1$export$355d4724e049b0df;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("gXrHX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("hmDFY", function(module, exports) {

let $ca4344963891a626$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca4344963891a626$var$load("8k5W1").then(()=>parcelRequire('42H7Z'));

});

parcelRegister("iMLPM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $jmjWc = parcelRequire("jmjWc");


// Keep the machine registry graph out of the root App bundle and off the page-load
// critical path. The host renders nothing and only observes flows that start from
// user interaction, so it loads in the background phase: no SSR preload and no UFO
// load hold on every page view. A late mount reads the registry's current snapshot.
// Producers call `preloadRemixWatcherHost` at flow admission so the chunk is already
// in flight before any machine-derived phase becomes user-visible.
const $8fae2dbb97264744$var$LazyRemixWatcherHost = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "ikpQt",
    name: 'RemixWatcherHost',
    loader: async ()=>(await (parcelRequire("irtib"))).RemixWatcherHost,
    loading: ()=>null
});
const $8fae2dbb97264744$export$8ac6a35c27bccce6 = ()=>{
    // Fire-and-forget: the loadable surfaces load failures through its own error path.
    $8fae2dbb97264744$var$LazyRemixWatcherHost.preload();
};
const $8fae2dbb97264744$export$b6d016c0687b53a1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8fae2dbb97264744$var$LazyRemixWatcherHost, null));
module.exports["preloadRemixWatcherHost"] = $8fae2dbb97264744$export$8ac6a35c27bccce6;
module.exports["RemixWatcherMount"] = $8fae2dbb97264744$export$b6d016c0687b53a1;

});

parcelRegister("irtib", function(module, exports) {

let $d6d17872935fbb96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d6d17872935fbb96$var$load("7BITa"),
    $d6d17872935fbb96$var$load("j3CG3")
]).then(()=>parcelRequire('1HmBi'));

});

parcelRegister("83wRA", function(module, exports) {

var $jIrdU = parcelRequire("jIrdU");

const $2644e734697600df$export$a512a3cc8fd81b18 = ({ themeState: themeState })=>themeState ? (0, $jIrdU.themeStringToObject)(decodeURIComponent(themeState)) : null;
module.exports["getThemeFromQueryParams"] = $2644e734697600df$export$a512a3cc8fd81b18;

});

parcelRegister("6UYek", function(module, exports) {

var $fbcPJ = parcelRequire("fbcPJ");


var $cozmU = parcelRequire("cozmU");


var $kyKWe = parcelRequire("kyKWe");


var $fD0Uz = parcelRequire("fD0Uz");


var $7Sm4c = parcelRequire("7Sm4c");


var $fJlJm = parcelRequire("fJlJm");


var $5ZqQS = parcelRequire("5ZqQS");


var $1xpoY = parcelRequire("1xpoY");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $3vc4U = parcelRequire("3vc4U");

const $da160e8fa3112de6$var$SubscriptionsContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$var$SubscriptionsDispatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $da160e8fa3112de6$export$2612561ece05d878 = [
    '401',
    'Failed to fetch',
    'Load Failed',
    'Network error',
    'GraphQL error: undefined',
    'Auth category: UNAUTHENTICATED is not allowed in service confluence_monolith_subscriptions'
];
const $da160e8fa3112de6$var$getLegacyApolloError = (error)=>{
    if (!('errors' in error) || !Array.isArray(error.errors)) return undefined;
    const firstError = error.errors[0];
    return firstError && typeof firstError === 'object' ? firstError : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorMessage = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('message' in firstError)) return undefined;
    return typeof firstError.message === 'string' ? firstError.message : undefined;
};
const $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode = (error)=>{
    const firstError = $da160e8fa3112de6$var$getLegacyApolloError(error);
    if (!firstError || !('extensions' in firstError)) return undefined;
    const { extensions: extensions } = firstError;
    if (!extensions || typeof extensions !== 'object' || !('statusCode' in extensions)) return undefined;
    return typeof extensions.statusCode === 'number' ? extensions.statusCode : undefined;
};
const $da160e8fa3112de6$export$5f043fff8b6d3ca6 = ({ children: children })=>{
    const [contentModified, setContentModified] = (0, $cozmU.useState)(null);
    const [contentId, setContentId] = (0, $cozmU.useState)(null);
    const [contentType, setContentType] = (0, $cozmU.useState)(null);
    const subscribersRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef({});
    // if there are no subscribers left we set the contentId and contentType to null
    // remove subscriber on unmount of subscription component
    /***
   * Adds a subscriber to the context.
   * @delta - the delta to subscribe to
   * @subscriberId - an id for the subscriber, used to remove the subscriber later
   * @onSubscriptionData - callback to be called when data is received for the delta
   * @returns uniqueSubscriberId - a unique id for the subscriber, used to remove the subscriber later
   */ const addSubscriber = (0, $cozmU.useCallback)(({ subscriberId: subscriberId, onSubscriptionData: onSubscriptionData, delta: delta })=>{
        const subscribers = subscribersRef.current;
        const uniqueSubscriberId = `${subscriberId}-${(0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))()}`; // ensure unique subscriberId
        const currentSubscribersForDelta = subscribers?.[delta] || [];
        subscribers[delta] = [
            ...currentSubscribersForDelta,
            {
                id: uniqueSubscriberId,
                onSubscriptionData: onSubscriptionData
            }
        ];
        return uniqueSubscriberId;
    }, []);
    const removeSubscriber = (0, $cozmU.useCallback)(({ delta: delta, subscriberId: subscriberId })=>{
        const subscribers = subscribersRef.current;
        if (subscribers.hasOwnProperty(delta)) {
            subscribers[delta] = (subscribers[delta] ?? []).filter((sub)=>sub.id !== subscriberId);
            // if there are no subscribers left for this delta, we can remove the delta
            if (subscribers[delta].length === 0) {
                delete subscribers[delta];
                // if that was the last subscriber we can stop the subscription entirely
                if (Object.keys(subscribers).length === 0) {
                    setContentId(null);
                    setContentType(null);
                }
            }
        }
    }, [
        setContentId,
        setContentType
    ]);
    const callSubscribers = (0, $cozmU.useCallback)((deltas, data)=>{
        const subscribers = subscribersRef.current;
        deltas.forEach((delta)=>{
            const subscribersForDelta = subscribers[delta];
            if (subscribersForDelta) subscribersForDelta.forEach((subscriber)=>{
                const callback = subscriber?.onSubscriptionData?.(delta, data);
                if (callback instanceof Promise) Promise.resolve(callback).catch((err)=>{
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        // hard coded as the package will cause circular dependency
                        attribution: 'page-experiences'
                    });
                });
            });
        });
    }, []);
    const { id: id, onSubscriptionComplete: onSubscriptionComplete, extensions: extensions, onSubscriptionData: onDataReceived } = (0, $3vc4U.useSubscriptionValues)({
        contentType: contentType,
        contentId: contentId
    });
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const skipSubscriptionForAnonUsers = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS;
    const { error: error } = (0, $fD0Uz.useSubscriptionInterop)((0, $fbcPJ.default), {
        variables: {
            id: id,
            __extensions: extensions
        },
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData (response) {
            onDataReceived(response);
            const { subscriptionData: subscriptionData } = response;
            if (!subscriptionData || !subscriptionData.data) return;
            const deltas = subscriptionData?.data?.confluence_onContentModified?._deltas;
            const data = subscriptionData?.data?.confluence_onContentModified;
            if (deltas && Array.isArray(deltas) && deltas.length > 0 && data) callSubscribers(deltas, data);
            setContentModified(data ?? null);
        },
        skip: !id || skipSubscriptionForAnonUsers,
        interopApolloAggClient: true,
        __callerPackage__: "graphql"
    });
    (0, $cozmU.useEffect)(()=>{
        if (error) {
            const errorMessage = error?.message || $da160e8fa3112de6$var$getLegacyApolloErrorMessage(error) || error?.graphQLErrors?.[0]?.message || error?.graphQLErrors?.[0]?.originalError?.message || error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message || error?.graphQLErrors?.[0]?.extensions?.message;
            const statusCode = $da160e8fa3112de6$var$getLegacyApolloErrorStatusCode(error);
            // if there is no error message it is likely to be a client side network issue
            // eg spotty vpn
            //
            // When graphql-subscriptions rate-limits us it returns an HTML page (eg a 429),
            // which graphql-ws feeds into JSON.parse and throws a SyntaxError. In V8 the
            // thrown message embeds the offending token, eg:
            //   Unexpected token '<', "<!DOCTYPE "... is not valid JSON
            // We match on the HTML markers rather than the generic "Unexpected token" so we
            // only suppress HTML payloads and not unrelated malformed-JSON bugs.
            const isHtmlRateLimitError = (0, $1xpoY.default).getBoolean('confluence_html_error_catching', false) && Boolean(errorMessage && /Unexpected token '<'|<!DOCTYPE|<html/.test(errorMessage));
            const isIgnoredError = $da160e8fa3112de6$export$2612561ece05d878.some((errorString)=>error?.message.includes(errorString)) || !errorMessage || isHtmlRateLimitError;
            if (statusCode !== 403 && !isIgnoredError) {
                const e = new Error(`Subscription Error - :${errorMessage}`);
                (0, $fJlJm.setContentErrorAttributes)(e, {
                    objectId: contentId,
                    objectType: contentType
                });
                (0, $5ZqQS.getMonitoringClient)().submitError(e, {
                    // hard coded as the package will cause circular dependency
                    attribution: 'page-experiences'
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    }, [
        error,
        contentId,
        contentType
    ]);
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            contentModified: contentModified,
            error: error
        }), [
        contentModified,
        error
    ]);
    const dispatchContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            setContentType: setContentType,
            setContentId: setContentId,
            addSubscriber: addSubscriber,
            removeSubscriber: removeSubscriber
        }), [
        setContentType,
        setContentId,
        addSubscriber,
        removeSubscriber
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($da160e8fa3112de6$var$SubscriptionsDispatchContext.Provider, {
        value: dispatchContextValue
    }, children));
};
const $da160e8fa3112de6$export$98d6302051bd25df = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsContext);
};
const $da160e8fa3112de6$export$e2675019a3c1d99f = ()=>{
    return (0, $cozmU.useContext)($da160e8fa3112de6$var$SubscriptionsDispatchContext);
};
module.exports["SubscriptionsContextProvider"] = $da160e8fa3112de6$export$5f043fff8b6d3ca6;
module.exports["useSubscriptionsContext"] = $da160e8fa3112de6$export$98d6302051bd25df;
module.exports["useSubscriptionsDispatchContext"] = $da160e8fa3112de6$export$e2675019a3c1d99f;

});

parcelRegister("fbcPJ", function(module, exports) {
/**
 * @generated SignedSource<<7a9167c315a11d046c0bff38f5b70b15>>
 * @relayHash a6d262fd516bfd241640743526134aa7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6426981365f88cebe6177665244f3e9579877c2fd53a467b8e33e2dc13ac27ce
const $31174e902ea6e4b2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "version"
    }, v4 = [
        v2 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "value"
        },
        v3 /*: any*/ ,
        v1 /*: any*/ 
    ], v5 = [
        v2 /*: any*/ ,
        v1 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "spaceKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "contentId"
    }, v8 = [
        v7 /*: any*/ ,
        v1 /*: any*/ 
    ], v9 = {
        "kind": "ScalarField",
        "name": "confVersion"
    }, v10 = {
        "kind": "ScalarField",
        "name": "commentId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "inlineCommentType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "adfBodyContent"
    }, v13 = {
        "kind": "ScalarField",
        "name": "markerRef"
    }, v14 = {
        "kind": "ScalarField",
        "name": "publishVersionNumber"
    }, v15 = {
        "kind": "ScalarField",
        "name": "from"
    }, v16 = {
        "kind": "ScalarField",
        "name": "annotationType"
    }, v17 = [
        v10 /*: any*/ ,
        v13 /*: any*/ ,
        v1 /*: any*/ 
    ], v18 = {
        "kind": "ScalarField",
        "name": "replies"
    }, v19 = {
        "kind": "ScalarField",
        "name": "pageCommentType"
    }, v20 = [
        v1 /*: any*/ ,
        v10 /*: any*/ 
    ], v21 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "ConfluenceContentModified",
            "kind": "LinkedField",
            "name": "confluence_onContentModified",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                },
                {
                    "kind": "ScalarField",
                    "name": "originTabId"
                },
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "_deltas"
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "contentStateUpdated",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "emojiTitleUpdated",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureUpdated",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyUpdated",
                    "kind": "LinkedField",
                    "name": "pageTitlePropertyUpdated",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "coverPictureDeleted",
                    "plural": false,
                    "selections": v5 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "emojiTitleDeleted",
                    "plural": false,
                    "selections": v5 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentPropertyDeleted",
                    "kind": "LinkedField",
                    "name": "contentStateDeleted",
                    "plural": false,
                    "selections": v5 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCoverPictureWidthUpdated",
                    "kind": "LinkedField",
                    "name": "coverPictureWidthUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "coverPictureWidth"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageBlogified",
                    "kind": "LinkedField",
                    "name": "pageBlogified",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "spaceName"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blogTitle"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "converterDisplayName"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceEmbedUpdated",
                    "kind": "LinkedField",
                    "name": "embedUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "product"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isBlankStateUpdate"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageMigrated",
                    "kind": "LinkedField",
                    "name": "pageMigrated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fabricEligibility"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentRestrictionUpdated",
                    "kind": "LinkedField",
                    "name": "contentRestrictionUpdated",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "concreteType": "ConfluencePageMoved",
                    "kind": "LinkedField",
                    "name": "pageMoved",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldParentId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldPosition"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newSpaceAlias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "oldSpaceAlias"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluencePageUpdated",
                    "kind": "LinkedField",
                    "name": "pageUpdated",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "trigger"
                        },
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceWorkflowApplicationChanged",
                    "kind": "LinkedField",
                    "name": "workflowApplicationChanged",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "changeType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "newWorkflowStatusId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "contentStatus"
                        },
                        v3 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentUpdatedWithTemplate",
                    "kind": "LinkedField",
                    "name": "contentUpdatedWithTemplate",
                    "plural": false,
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "subtype"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "inlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v1 /*: any*/ ,
                        v13 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceRendererInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "rendererInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v10 /*: any*/ ,
                        v12 /*: any*/ ,
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "to"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "pos"
                                },
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v16 /*: any*/ ,
                                                v1 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentCreated",
                    "kind": "LinkedField",
                    "name": "editorInlineCommentCreated",
                    "plural": false,
                    "selections": [
                        v12 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUpdated",
                    "plural": false,
                    "selections": v17 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentDeleted",
                    "kind": "LinkedField",
                    "name": "inlineCommentDeleted",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v13 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentResolved",
                    "kind": "LinkedField",
                    "name": "inlineCommentResolved",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentResolveProperties",
                            "kind": "LinkedField",
                            "name": "inlineResolveProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolved"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedByDangling"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedFriendlyDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "resolvedUser"
                                },
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "inlineText"
                        },
                        v13 /*: any*/ ,
                        v18 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceInlineCommentUpdated",
                    "kind": "LinkedField",
                    "name": "inlineCommentUnresolved",
                    "plural": false,
                    "selections": v17 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceInlineCommentReattached",
                    "kind": "LinkedField",
                    "name": "inlineCommentReattached",
                    "plural": false,
                    "selections": [
                        v10 /*: any*/ ,
                        v1 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        {
                            "concreteType": "ConfluenceInlineCommentStep",
                            "kind": "LinkedField",
                            "name": "step",
                            "plural": false,
                            "selections": [
                                v15 /*: any*/ ,
                                {
                                    "concreteType": "ConfluenceInlineCommentStepMark",
                                    "kind": "LinkedField",
                                    "name": "mark",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ConfluenceInlineCommentStepMarkAttrs",
                                            "kind": "LinkedField",
                                            "name": "attrs",
                                            "plural": false,
                                            "selections": [
                                                v1 /*: any*/ ,
                                                v16 /*: any*/ 
                                            ]
                                        },
                                        v1 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentCreated",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v12 /*: any*/ ,
                        v10 /*: any*/ ,
                        v19 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentUpdated",
                    "plural": false,
                    "selections": v20 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentDeleted",
                    "plural": false,
                    "selections": v20 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceCommentCreated",
                    "kind": "LinkedField",
                    "name": "commentResolved",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        v12 /*: any*/ ,
                        v10 /*: any*/ ,
                        v19 /*: any*/ ,
                        v18 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceCommentUpdated",
                    "kind": "LinkedField",
                    "name": "commentReopened",
                    "plural": false,
                    "selections": v20 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceSchedulePublished",
                    "kind": "LinkedField",
                    "name": "schedulePublished",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "publishTime"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "eventType"
                        },
                        v9 /*: any*/ ,
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ConfluenceContentAccessRequested",
                    "kind": "LinkedField",
                    "name": "contentAccessRequested",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceContentAccessDecisionMade",
                    "kind": "LinkedField",
                    "name": "contentAccessDecisionMade",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "decision"
                        },
                        v1 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v21 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SubscriptionsContextProviderSubscription",
            "selections": v21 /*: any*/ 
        },
        "params": {
            "cacheID": "a6d262fd516bfd241640743526134aa7",
            "id": "6426981365f88cebe6177665244f3e9579877c2fd53a467b8e33e2dc13ac27ce",
            "metadata": {},
            "name": "SubscriptionsContextProviderSubscription",
            "operationKind": "subscription",
            "text": "subscription SubscriptionsContextProviderSubscription($id:ID!){confluence_onContentModified(id:$id){type,id,accountId,originTabId,__typename,_deltas,contentStateUpdated{key,value,version,__typename},emojiTitleUpdated{key,value,version,__typename},coverPictureUpdated{key,value,version,__typename},pageTitlePropertyUpdated{key,value,version,__typename},coverPictureDeleted{key,__typename},emojiTitleDeleted{key,__typename},contentStateDeleted{key,__typename},coverPictureWidthUpdated{coverPictureWidth,__typename},pageBlogified{spaceKey,spaceName,blogTitle,converterDisplayName,__typename},embedUpdated{product,isBlankStateUpdate,__typename},pageMigrated{fabricEligibility,__typename},contentRestrictionUpdated{contentId,__typename},pageMoved{oldSpaceKey,newSpaceKey,oldParentId,oldPosition,newSpaceAlias,oldSpaceAlias,__typename},pageUpdated{__typename,trigger,confVersion},workflowApplicationChanged{contentId,changeType,newWorkflowStatusId,contentStatus,version,__typename},contentUpdatedWithTemplate{spaceKey,subtype,__typename},inlineCommentCreated{commentId,inlineCommentType,adfBodyContent,__typename,markerRef},rendererInlineCommentCreated{__typename,commentId,adfBodyContent,inlineCommentType,markerRef,publishVersionNumber,step{from,to,pos,mark{attrs{annotationType,__typename},__typename},__typename}},editorInlineCommentCreated{adfBodyContent,commentId,inlineCommentType,markerRef,__typename},inlineCommentUpdated{commentId,markerRef,__typename},inlineCommentDeleted{commentId,inlineCommentType,markerRef,__typename},inlineCommentResolved{commentId,inlineResolveProperties{isDangling,resolved,resolvedByDangling,resolvedFriendlyDate,resolvedTime,resolvedUser,__typename},inlineText,markerRef,replies,__typename},inlineCommentUnresolved{commentId,markerRef,__typename},inlineCommentReattached{commentId,__typename,markerRef,publishVersionNumber,step{from,mark{attrs{__typename,annotationType},__typename},__typename}},commentCreated{__typename,adfBodyContent,commentId,pageCommentType},commentUpdated{__typename,commentId},commentDeleted{__typename,commentId},commentResolved{__typename,adfBodyContent,commentId,pageCommentType,replies},commentReopened{__typename,commentId},schedulePublished{publishTime,eventType,confVersion,__typename},contentAccessRequested{contentId,__typename},contentAccessDecisionMade{contentId,decision,__typename}}}"
        }
    };
}();
$31174e902ea6e4b2$var$node.hash = "5f32fea86d09ae215d5698e5715124ed";
var $31174e902ea6e4b2$export$2e2bcd8739ae039 = $31174e902ea6e4b2$var$node;
module.exports["default"] = $31174e902ea6e4b2$export$2e2bcd8739ae039;

});

parcelRegister("fD0Uz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $7m1pr = parcelRequire("7m1pr");


var $iffSy = parcelRequire("iffSy");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

const $c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode = (subscription)=>typeof subscription === 'function' || subscription.kind !== 'Document';
const $c7f06d7e4ea271ae$var$isFormattedExecutionResult = (response)=>Boolean(response && typeof response === 'object' && ('data' in response || 'errors' in response));
const $c7f06d7e4ea271ae$var$isSubscriptionData = (response)=>!$c7f06d7e4ea271ae$var$isFormattedExecutionResult(response);
const $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions = (response)=>{
    if (response == null) return {
        data: undefined,
        extensions: undefined
    };
    if ($c7f06d7e4ea271ae$var$isSubscriptionData(response)) return {
        data: response,
        extensions: undefined
    };
    return {
        data: response.data ?? undefined,
        extensions: response.extensions
    };
};
const $c7f06d7e4ea271ae$export$4966ff7f324f6363 = (response)=>{
    const { data: data, extensions: extensions } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
    return {
        ...extensions ? {
            extensions: extensions
        } : {},
        subscriptionData: {
            data: data,
            loading: false,
            ...extensions ? {
                extensions: extensions
            } : {}
        }
    };
};
const $c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment = ()=>{
    const isProduction = true;
    const isCloudProduction = true;
    const isCloudStaging = false;
    if (isProduction || isCloudProduction || isCloudStaging) return false;
    const isTest = false;
    const isDevelopment = false;
    const isLocalhost = typeof window !== 'undefined' && window.location.hostname === 'localhost';
    return isTest || isDevelopment || isLocalhost;
};
const $c7f06d7e4ea271ae$export$1bed67b955596e29 = (forceRelay)=>{
    if (!$c7f06d7e4ea271ae$var$__TEST_ONLY_isTestOnlySafeEnvironment()) return false;
    window.__TEST_ONLY_FORCE_RELAY_MODE__ = forceRelay;
    return true;
};
function $c7f06d7e4ea271ae$export$275462b87cef6610(subscription, options) {
    const forceRelayMode = window.__TEST_ONLY_FORCE_RELAY_MODE__;
    const shouldUseRelay = forceRelayMode || (0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        phase: 'subscription'
    });
    if (shouldUseRelay) {
        if (!$c7f06d7e4ea271ae$var$isRelayGraphQLTaggedNode(subscription)) throw new Error('[Relay migration] useSubscriptionInterop Relay mode requires graphql tag');
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options);
    } else {
        const { interopApolloAggClient: interopApolloAggClient, extensions: extensions, ...apolloOptions } = options ?? {};
        // Apollo v2's `useSubscription` does not forward a per-call `context` option down
        // to the WebSocket link, so we smuggle `extensions` through `variables.__extensions`.
        // `AttachExtensionsLink` strips it back out and re-attaches it to the operation
        // context, which `GraphQLWSLink.request` then sets on the wire payload.
        const variables = extensions !== undefined ? {
            ...apolloOptions.variables,
            __extensions: extensions
        } : apolloOptions.variables;
        // eslint-disable-next-line react-hooks/rules-of-hooks
        return (0, $7EPz1.useSubscription)((0, $86okN.toDocumentNode)(subscription), {
            ...apolloOptions,
            variables: variables,
            ...interopApolloAggClient ? {
                client: window.GLOBAL_APOLLO_AGG_CLIENT ?? window.MOCK_GATEWAY_APOLLO_CLIENT
            } : {}
        });
    }
}
const $c7f06d7e4ea271ae$var$toApolloErrorInterop = (error)=>new (0, $7m1pr.RelayError)({
        networkError: error instanceof Error ? error : new Error(String(error))
    });
function $c7f06d7e4ea271ae$var$useSubscriptionInteropRelay(subscription, options) {
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const [loading, setLoading] = (0, $cozmU.useState)(!options?.skip);
    const disposableRef = (0, $cozmU.useRef)(null);
    const callbacksRef = (0, $cozmU.useRef)(options);
    callbacksRef.current = options;
    const skip = options?.skip;
    const variables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        phase: 'subscription'
    });
    const extensions = (0, $iF5wn.useMemoObj)(options?.extensions, options?.__callerPackage__, {
        phase: 'subscription'
    });
    (0, $cozmU.useEffect)(()=>{
        if (skip) {
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(undefined);
        setData(undefined);
        try {
            disposableRef.current = (0, $eqEJl.requestSubscription)(environment, {
                subscription: subscription,
                variables: variables,
                // `RelayWebSocketSubscriptionHandler` reads `cacheConfig.metadata.extensions`
                // and attaches them to the WS payload's `extensions` field.
                // cacheConfig is always set because useMemoObj coerces undefined → {}, so any
                // guard on `extensions` would always evaluate the same way. The consumer
                // (RelayWebSocketSubscriptionHandler) ignores an empty extensions object.
                cacheConfig: {
                    metadata: {
                        extensions: extensions
                    }
                },
                onNext: (response)=>{
                    const { data: responseData } = $c7f06d7e4ea271ae$var$getSubscriptionDataAndExtensions(response);
                    setData(responseData);
                    setError(undefined);
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionData?.($c7f06d7e4ea271ae$export$4966ff7f324f6363(response));
                },
                onError: (err_0)=>{
                    setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err_0));
                    setLoading(false);
                },
                onCompleted: ()=>{
                    setLoading(false);
                    callbacksRef.current?.onSubscriptionComplete?.();
                }
            });
        } catch (err) {
            setError($c7f06d7e4ea271ae$var$toApolloErrorInterop(err));
            setLoading(false);
        }
        return ()=>{
            if (!disposableRef.current) return;
            disposableRef.current.dispose();
            disposableRef.current = null;
        };
    }, [
        environment,
        subscription,
        variables,
        extensions,
        skip
    ]);
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSubscriptionInterop"] = $c7f06d7e4ea271ae$export$275462b87cef6610;

});

parcelRegister("3vc4U", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $fSDun = parcelRequire("fSDun");

const $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS = 48;
const $e5d99b79ae0d2558$export$d9c46c14618307b6 = ({ contentId: contentId, contentType: contentType, replayCap: replayCap })=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const lastSequenceId = (0, $cozmU.useRef)(Math.floor(new Date().getTime() / 1000));
    const [updateExtensionsTrigger, setUpdateExtensionsTrigger] = (0, $cozmU.useState)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onSubscriptionComplete = (0, $cozmU.useCallback)(()=>{
        setUpdateExtensionsTrigger(updateExtensionsTrigger + 1);
    }, [
        updateExtensionsTrigger,
        setUpdateExtensionsTrigger
    ]);
    const onSubscriptionData = (0, $cozmU.useCallback)((result)=>{
        // update the last received message timestamp with either the messages time or use a best guess from the current time
        lastSequenceId.current = result?.extensions?.sequenceNumber ?? Math.floor(new Date().getTime() / 1000);
        const subscriptionField = Object.keys(result?.subscriptionData?.data ?? {}).find((field)=>field !== '__typename');
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'received',
                actionSubject: 'subscription.event',
                source: 'AGGSubscriptions',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    request_id: result?.extensions?.agg?.request_id || '',
                    traceId: result?.extensions?.traceId || '',
                    ...subscriptionField && ((0, $6mKj3.expValEquals)('platform_editor_ai_content_suggested_edits', 'isEnabled', true) || // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Rollout gate for the platformised subset of suggested edits, independent of the experiment.
                    (0, $9wGTI.fg)('platform_editor_ai_suggested_edits')) ? {
                        subscriptionField: subscriptionField
                    } : {}
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const ari = !contentId || !contentType || !cloudId || !activationId ? '' : (0, $fSDun.getConfluenceContentAri)({
        siteId: cloudId,
        resourceType: contentType,
        activationId: activationId,
        resourceId: contentId
    });
    const extensions = (0, $cozmU.useMemo)(()=>{
        const fallbackReplayCapInSeconds = Math.floor((Date.now() - $e5d99b79ae0d2558$var$REPLAY_WINDOW_HOURS * 3600000) / 1000);
        let sequenceNumber;
        if (replayCap !== undefined) sequenceNumber = replayCap;
        else if (lastSequenceId.current < fallbackReplayCapInSeconds) sequenceNumber = fallbackReplayCapInSeconds;
        else sequenceNumber = lastSequenceId.current;
        return updateExtensionsTrigger > 0 ? {
            command: {
                type: 'replay',
                data: {
                    sequenceNumber: sequenceNumber
                }
            }
        } : {};
    }, [
        updateExtensionsTrigger,
        replayCap
    ]);
    return {
        id: ari,
        extensions: extensions,
        onSubscriptionComplete: onSubscriptionComplete,
        onSubscriptionData: onSubscriptionData
    };
};
module.exports["useSubscriptionValues"] = $e5d99b79ae0d2558$export$d9c46c14618307b6;

});

parcelRegister("fSDun", function(module, exports) {
// Copied from @confluence/content-types-utils/src/getConfluenceContentAri.ts
/**
 * Resource types where the ARIs include activationIds. This is a pattern
 * that started with Confluence Databases.
 */ const $ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID = [
    'database',
    'embed',
    'folder',
    'slide'
];
const $ad4104a6b6731a94$export$6a2f2c83863e9bfe = (confluenceContentAriParameters)=>{
    const { siteId: siteId, resourceType: resourceType, activationId: activationId, resourceId: resourceId } = confluenceContentAriParameters;
    if ($ad4104a6b6731a94$var$TYPES_WITH_ACTIVATIONID.includes(resourceType)) return `ari:cloud:confluence:${siteId}:${resourceType}/activation/${activationId}/${resourceId}`;
    return `ari:cloud:confluence:${siteId}:${resourceType}/${resourceId}`;
};
module.exports["getConfluenceContentAri"] = $ad4104a6b6731a94$export$6a2f2c83863e9bfe;

});

parcelRegister("l1eT4", function(module, exports) {

let $f4d53d45cfd5d893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f4d53d45cfd5d893$var$load("kY5BF").then(()=>parcelRequire('fUwgh'));

});

parcelRegister("kE2cJ", function(module, exports) {

var $jiJCD = parcelRequire("jiJCD");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");



parcelRequire("gSgn8");


var $9wGTI = parcelRequire("9wGTI");


var $7zgzO = parcelRequire("7zgzO");


const $14c2681824cc07d8$export$7b9b5b70059a466b = ({ href: href = null, name: name, params: params, to: to = null, usePush: usePush = false, forceReload: forceReload = false, reason: reason, skipRouteChange: skipRouteChange = false, excludedQueryParams: excludedQueryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { push: push, replace: replace, toUrl: toUrl, getHash: getHash, getQueryParams: getQueryParams, getHref: getHref, matchRoute: matchRoute } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const getUrl = ()=>{
        const customPath = href || to;
        let parsedUrl = {};
        if (customPath) parsedUrl = (0, $jiJCD.parse)(customPath, true);
        const currentQuery = getQueryParams();
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (excludedQueryParams && (0, $9wGTI.fg)('confluence_frontend_excluded_query_params_redirect')) excludedQueryParams.forEach((param)=>{
            delete currentQuery[param];
        });
        return toUrl(name, {
            hash: getHash(),
            query: currentQuery,
            ...params,
            ...parsedUrl
        });
    };
    (0, $cozmU.useEffect)(()=>{
        const oldRoute = matchRoute(getHref());
        const oldRouteName = oldRoute?.name || null;
        const getAnalyticsAttributes = ({ newRouteName: newRouteName })=>({
                oldRouteName: oldRouteName,
                newRouteName: newRouteName,
                // It is safe to fire an event with the names of the route params because they are not UGC.
                // They are part of our route definitions. In contrast, the values of the route params are UGC.
                // Additionally, both the names and values of the route query params are UGC because they are
                // read directly from the URL without matching against our route definitions.
                oldRouteParamNames: Object.keys(oldRoute?.params || {}),
                newRouteParamNames: Object.keys(params || {}),
                // Space key related attributes.
                isOldRouteSpaceKeyDefined: !!oldRoute?.params?.spaceKey,
                isNewRouteSpaceKeyDefined: !!params?.spaceKey,
                areSpaceKeysEqual: oldRoute?.params?.spaceKey === params?.spaceKey,
                areSpaceKeysEqualLowercase: oldRoute?.params?.spaceKey?.toLowerCase() === params?.spaceKey?.toLowerCase()
            });
        const doRedirect = ()=>{
            // Reset the delayed content redirection object to avoid unnecessary redirects
            window['__DELAYED_CONTENT_REDIRECTION__'] = {};
            const gottenUrl = getUrl();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'redirect',
                    actionSubject: oldRouteName,
                    actionSubjectId: name || matchRoute(gottenUrl)?.name,
                    source: oldRouteName
                }
            }).fire();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirect',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: getAnalyticsAttributes({
                        newRouteName: name || matchRoute(gottenUrl)?.name
                    })
                }
            }).fire();
            // Skip route change by only rewrite URL
            if (skipRouteChange) try {
                window.history.replaceState({}, '', gottenUrl);
                return;
            } catch  {
            // If replaceState failed, then run the redirect normally
            }
            (usePush ? push : replace)(gottenUrl, forceReload);
        };
        try {
            doRedirect();
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirectFailed',
                    actionSubject: 'route',
                    source: 'Redirection',
                    attributes: {
                        ...getAnalyticsAttributes({
                            newRouteName: name
                        }),
                        errorMessage: error?.message
                    }
                }
            }).fire();
            throw error;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
module.exports["Redirection"] = $14c2681824cc07d8$export$7b9b5b70059a466b;

});

parcelRegister("k1GeI", function(module, exports) {

let $e944a9eb606426d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e944a9eb606426d9$var$load("5zLU3").then(()=>parcelRequire('6nGVD'));

});

parcelRegister("eMS5h", function(module, exports) {

let $ac3f80630bfa0d53$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac3f80630bfa0d53$var$load("9dZCH").then(()=>parcelRequire('ghOyy'));

});

parcelRegister("5gmpn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f6b55c9cc88888b7$export$93af822566053b3e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GCw5R",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'MainLayout',
    loader: async ()=>(await (parcelRequire("c1EtD"))).MainLayout
});
module.exports["MainLayout"] = $f6b55c9cc88888b7$export$93af822566053b3e;

});

parcelRegister("c1EtD", function(module, exports) {

let $8c14f9e9c494bf68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8c14f9e9c494bf68$var$load("bAgF6"),
    $8c14f9e9c494bf68$var$load("4GE9S")
]).then(()=>parcelRequire('cmkWO'));

});

parcelRegister("6pwLK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5vi32 = parcelRequire("5vi32");


var $lJlG6 = parcelRequire("lJlG6");


var $jxpvN = parcelRequire("jxpvN");

const $f91eb48475fb1f4e$export$fce08d0d9d687787 = ({ includeTopNav: includeTopNav, suppressed: suppressed, children: children })=>{
    const { includeTopNav: inheritedOrDefaultValue, suppressed: inheritedSuppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    if (typeof includeTopNav !== 'boolean') includeTopNav = isEmbeddedConfluence || isMobileApp ? false : inheritedOrDefaultValue;
    // Suppression is inherited so a nested provider cannot accidentally un-suppress a subtree.
    const resolvedSuppressed = suppressed === true || inheritedSuppressed === true;
    const bannerContextValue = (0, $cozmU.useMemo)(()=>({
            includeTopNav: includeTopNav,
            suppressed: resolvedSuppressed
        }), [
        includeTopNav,
        resolvedSuppressed
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: bannerContextValue
    }, children);
};
module.exports["BannerContextProvider"] = $f91eb48475fb1f4e$export$fce08d0d9d687787;

});

parcelRegister("jxpvN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $205998aae8e9bd72$export$60bd66ed7962b851 = /*#__PURE__*/ (0, $cozmU.createContext)({
    includeTopNav: true
});
$205998aae8e9bd72$export$60bd66ed7962b851.displayName = 'BannerContext';
module.exports["BannerContext"] = $205998aae8e9bd72$export$60bd66ed7962b851;

});

parcelRegister("djZz9", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $38a3bf8a14810337$export$de3a38bd9f6fbd0c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JEntR",
    name: "SpaceOverviewLoader",
    loader: async ()=>(await (parcelRequire("jwtL9"))).SpaceOverview
});

const $38a3bf8a14810337$export$5c3607a122f4ef5a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "AGreW",
    name: "SpaceOverviewSwitcherLoader",
    loader: async ()=>(await (parcelRequire("bGPSp"))).SpaceOverviewSwitcher
});
module.exports["SpaceOverviewLoader"] = $38a3bf8a14810337$export$de3a38bd9f6fbd0c;
module.exports["SpaceOverviewSwitcherLoader"] = $38a3bf8a14810337$export$5c3607a122f4ef5a;

});

parcelRegister("jwtL9", function(module, exports) {

let $e3681717d79acd44$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e3681717d79acd44$var$load("aRCaA"),
    $e3681717d79acd44$var$load("h3Rq9"),
    $e3681717d79acd44$var$load("2F69B"),
    $e3681717d79acd44$var$load("8Bic8"),
    $e3681717d79acd44$var$load("cLCaE"),
    $e3681717d79acd44$var$load("KsShd"),
    $e3681717d79acd44$var$load("d3PpR"),
    $e3681717d79acd44$var$load("8yk9S"),
    $e3681717d79acd44$var$load("i8sPk"),
    $e3681717d79acd44$var$load("bqdgP"),
    $e3681717d79acd44$var$load("15jTz"),
    $e3681717d79acd44$var$load("48F3z"),
    $e3681717d79acd44$var$load("9LJFK"),
    $e3681717d79acd44$var$load("d66hN"),
    $e3681717d79acd44$var$load("dxA9F"),
    $e3681717d79acd44$var$load("bkMxV"),
    $e3681717d79acd44$var$load("cIoRg"),
    $e3681717d79acd44$var$load("g7vSH"),
    $e3681717d79acd44$var$load("kJASg"),
    $e3681717d79acd44$var$load("asCsc"),
    $e3681717d79acd44$var$load("fYx6U"),
    $e3681717d79acd44$var$load("botpL"),
    $e3681717d79acd44$var$load("a7sEM"),
    $e3681717d79acd44$var$load("7IvJj"),
    $e3681717d79acd44$var$load("j7JUO"),
    $e3681717d79acd44$var$load("gaUhx"),
    $e3681717d79acd44$var$load("5PKbS"),
    $e3681717d79acd44$var$load("bmOOW"),
    $e3681717d79acd44$var$load("dDiWc"),
    $e3681717d79acd44$var$load("i6pyw"),
    $e3681717d79acd44$var$load("l4j2l"),
    $e3681717d79acd44$var$load("37v60"),
    $e3681717d79acd44$var$load("4Oj5y"),
    $e3681717d79acd44$var$load("bncmK"),
    $e3681717d79acd44$var$load("5dkX4"),
    $e3681717d79acd44$var$load("aAWLw"),
    $e3681717d79acd44$var$load("44XW6"),
    $e3681717d79acd44$var$load("eF92L"),
    $e3681717d79acd44$var$load("jwMHX"),
    $e3681717d79acd44$var$load("d0ZRF"),
    $e3681717d79acd44$var$load("k507P"),
    $e3681717d79acd44$var$load("6iTkp"),
    $e3681717d79acd44$var$load("6wr18"),
    $e3681717d79acd44$var$load("16bOI"),
    $e3681717d79acd44$var$load("2be0t"),
    $e3681717d79acd44$var$load("7SteV"),
    $e3681717d79acd44$var$load("jE0Mz"),
    $e3681717d79acd44$var$load("1AybA"),
    $e3681717d79acd44$var$load("ffEVr"),
    $e3681717d79acd44$var$load("9TOep"),
    $e3681717d79acd44$var$load("dxcsb"),
    $e3681717d79acd44$var$load("cGkFm"),
    $e3681717d79acd44$var$load("8iu3F"),
    $e3681717d79acd44$var$load("hhss7"),
    $e3681717d79acd44$var$load("7EorR"),
    $e3681717d79acd44$var$load("1gUNx"),
    $e3681717d79acd44$var$load("e66P8")
]).then(()=>parcelRequire('eiWUW'));

});

parcelRegister("bGPSp", function(module, exports) {

let $882bdb9344afe7a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $882bdb9344afe7a4$var$load("hUbK8"),
    $882bdb9344afe7a4$var$load("kfGHh"),
    $882bdb9344afe7a4$var$load("lIiD7"),
    $882bdb9344afe7a4$var$load("gQrOI"),
    $882bdb9344afe7a4$var$load("aRCaA"),
    $882bdb9344afe7a4$var$load("h3Rq9"),
    $882bdb9344afe7a4$var$load("2F69B"),
    $882bdb9344afe7a4$var$load("8Bic8"),
    $882bdb9344afe7a4$var$load("cLCaE"),
    $882bdb9344afe7a4$var$load("KsShd"),
    $882bdb9344afe7a4$var$load("d3PpR"),
    $882bdb9344afe7a4$var$load("8yk9S"),
    $882bdb9344afe7a4$var$load("i8sPk"),
    $882bdb9344afe7a4$var$load("bqdgP"),
    $882bdb9344afe7a4$var$load("15jTz"),
    $882bdb9344afe7a4$var$load("48F3z"),
    $882bdb9344afe7a4$var$load("9LJFK"),
    $882bdb9344afe7a4$var$load("d66hN"),
    $882bdb9344afe7a4$var$load("dxA9F"),
    $882bdb9344afe7a4$var$load("bkMxV"),
    $882bdb9344afe7a4$var$load("cIoRg"),
    $882bdb9344afe7a4$var$load("g7vSH"),
    $882bdb9344afe7a4$var$load("kJASg"),
    $882bdb9344afe7a4$var$load("asCsc"),
    $882bdb9344afe7a4$var$load("fYx6U"),
    $882bdb9344afe7a4$var$load("botpL"),
    $882bdb9344afe7a4$var$load("a7sEM"),
    $882bdb9344afe7a4$var$load("7IvJj"),
    $882bdb9344afe7a4$var$load("j7JUO"),
    $882bdb9344afe7a4$var$load("gaUhx"),
    $882bdb9344afe7a4$var$load("5PKbS"),
    $882bdb9344afe7a4$var$load("bmOOW"),
    $882bdb9344afe7a4$var$load("dDiWc"),
    $882bdb9344afe7a4$var$load("i6pyw"),
    $882bdb9344afe7a4$var$load("l4j2l"),
    $882bdb9344afe7a4$var$load("37v60"),
    $882bdb9344afe7a4$var$load("4Oj5y"),
    $882bdb9344afe7a4$var$load("bncmK"),
    $882bdb9344afe7a4$var$load("5dkX4"),
    $882bdb9344afe7a4$var$load("aAWLw"),
    $882bdb9344afe7a4$var$load("e66P8"),
    $882bdb9344afe7a4$var$load("44XW6"),
    $882bdb9344afe7a4$var$load("eF92L"),
    $882bdb9344afe7a4$var$load("jwMHX"),
    $882bdb9344afe7a4$var$load("d0ZRF"),
    $882bdb9344afe7a4$var$load("k507P"),
    $882bdb9344afe7a4$var$load("6iTkp"),
    $882bdb9344afe7a4$var$load("6wr18"),
    $882bdb9344afe7a4$var$load("16bOI"),
    $882bdb9344afe7a4$var$load("2be0t"),
    $882bdb9344afe7a4$var$load("7SteV"),
    $882bdb9344afe7a4$var$load("jE0Mz"),
    $882bdb9344afe7a4$var$load("1AybA"),
    $882bdb9344afe7a4$var$load("ffEVr"),
    $882bdb9344afe7a4$var$load("9TOep"),
    $882bdb9344afe7a4$var$load("dxcsb"),
    $882bdb9344afe7a4$var$load("cGkFm"),
    $882bdb9344afe7a4$var$load("8iu3F"),
    $882bdb9344afe7a4$var$load("hhss7"),
    $882bdb9344afe7a4$var$load("7EorR"),
    $882bdb9344afe7a4$var$load("1gUNx"),
    $882bdb9344afe7a4$var$load("7J0Jt")
]).then(()=>parcelRequire('2m4WS'));

});

parcelRegister("iqPBi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $5X6fy = parcelRequire("5X6fy");


var $9DHhW = parcelRequire("9DHhW");


var $6mKj3 = parcelRequire("6mKj3");


var $dPJCf = parcelRequire("dPJCf");


var $1ytiN = parcelRequire("1ytiN");


var $fM6x5 = parcelRequire("fM6x5");


var $cEgMD = parcelRequire("cEgMD");


var $8oCjN = parcelRequire("8oCjN");


var $4b4iP = parcelRequire("4b4iP");


var $j9XVO = parcelRequire("j9XVO");

const $023f02fd9a9aead0$var$DISPLAY_ROOT = 'display';
const $023f02fd9a9aead0$var$SPACE_ROOT = 'spaces';
const $023f02fd9a9aead0$var$getUrlRoot = (pathname)=>{
    if (!pathname) return undefined;
    if (pathname.includes(`/${$023f02fd9a9aead0$var$SPACE_ROOT}/`)) return $023f02fd9a9aead0$var$SPACE_ROOT;
    else if (pathname.includes(`/${$023f02fd9a9aead0$var$DISPLAY_ROOT}/`)) return $023f02fd9a9aead0$var$DISPLAY_ROOT;
    else return undefined;
};
const $023f02fd9a9aead0$var$useContentSlug = (0, $dPJCf.createRouteParamHook)('contentSlug');
const $023f02fd9a9aead0$var$useContentId = (0, $dPJCf.createRouteParamHook)('contentId');
const $023f02fd9a9aead0$var$LegacySpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { isAnonymous: isAnonymous } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const history = (0, $dPJCf.useHistory)();
    const isFirstRoute = history?.length === 1;
    const location = (0, $KDAt0.useLocation)();
    const fixSpaceEncodingInSpaceKey = ()=>{
        const pathname = location?.pathname || '';
        const decodedPathname = decodeURIComponent(pathname);
        if (// excludes the cases where there are no + symbols to replace at all
        // eg: /spaces/perfectly-fine-space-key
        pathname.indexOf('+') !== -1 && // excludes the cases where there is a + that follows the space key portion of the path
        // eg: /spaces/DS/other+stuff+that+contains+plus
        spaceKey.indexOf('+') !== -1 && // excludes the cases where the decoded path name still contains a + (from %2B)
        // , but the replacement to strip the + from the space key has already happened in previous SPA transition
        // eg: pathname = '/spaces/space%2Bkey', decodedPathname = '/spaces/space+key', spaceKey = 'space+key'
        decodedPathname.indexOf(`spaces/${spaceKey}`) !== -1) history?.replace?.({
            ...location,
            // Ensure we are replacing the "+" in the space key not other funny stuff
            pathname: decodedPathname.replace(`spaces/${spaceKey}`, `spaces/${spaceKey}`.replace(/\+/g, ' '))
        });
    };
    const removeEmailQueryParameters = ()=>{
        if (!location?.search?.includes('src=mail') && !location?.search?.includes('src.mail.')) return;
        let search = location?.search?.substring(1);
        const params = search.split('&').filter((param)=>!param.includes('src=mail') && !param.startsWith('src.mail.'));
        search = `?${params.join('&')}`;
        history?.replace?.({
            ...location,
            search: search
        });
    };
    (0, $cozmU.useEffect)(()=>{
        fixSpaceEncodingInSpaceKey();
        removeEmailQueryParameters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (isSpaceLoading) return;
        if (space && space.alias && space.alias !== spaceKey) {
            const pathnameRoot = $023f02fd9a9aead0$var$getUrlRoot(location?.pathname);
            if (pathnameRoot) {
                const routeName = routeDataRef.current?.routeName || null;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'redirect',
                        actionSubject: 'route',
                        source: 'SpaceBase',
                        attributes: {
                            routeName: routeName,
                            // Space key related attributes.
                            areSpaceKeysEqualLowercase: space?.alias?.toLowerCase() === spaceKey?.toLowerCase()
                        }
                    }
                }).fire();
                history?.replace?.({
                    ...location,
                    pathname: location?.pathname?.replace(`/${pathnameRoot}/${spaceKey}`, `/${pathnameRoot}/${space.alias}`)
                });
            }
            return;
        }
    }, [
        createAnalyticsEvent,
        history,
        location,
        space,
        spaceKey,
        routeDataRef,
        isSpaceLoading
    ]);
    /*
   * Removing SpaceBaseThemedComponent for the Company Hub app-like experience
   *
   * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
   * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
   */ const SpaceBaseWrapper = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) ? (0, $cozmU.Fragment) : (0, $8oCjN.SpaceBaseThemedComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        isFirstRoute: isFirstRoute,
        goBackPreviousPage: history?.goBack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpaceBaseWrapper, null, children)));
};
const $023f02fd9a9aead0$var$SpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const { isAnonymous: isAnonymous } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    // We cannot use useIsSSROrHydrating() here
    // because SpaceBaseComponent is invoked through withDocumentTitle's inline
    // function pattern, which breaks hooks during renderToString.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    if (isSSR && (0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        goBackPreviousPage: ()=>{}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, children));
    else if (isSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($023f02fd9a9aead0$var$LegacySpaceBaseComponent, {
        spaceKey: spaceKey,
        space: space,
        isSpaceLoading: isSpaceLoading
    }, children);
};
const $023f02fd9a9aead0$var$useSpaceKey = (0, $dPJCf.createRouteParamHook)('spaceKey');
const $023f02fd9a9aead0$export$adbf61121b32bd9b = ({ children: children, spaceKey: spaceKey })=>{
    const resolvedSpaceKey = $023f02fd9a9aead0$var$useSpaceKey() || spaceKey || '';
    const { space: space, loading: loading } = (0, $j9XVO.useSpaceBaseQuery)({
        resolvedSpaceKey: resolvedSpaceKey
    });
    return (0, $fM6x5.default)(()=>space?.name)($023f02fd9a9aead0$var$SpaceBaseComponent)({
        spaceKey: resolvedSpaceKey,
        space: space,
        children: children,
        isSpaceLoading: loading
    });
};
module.exports["SpaceBase"] = $023f02fd9a9aead0$export$adbf61121b32bd9b;

});

parcelRegister("fM6x5", function(module, exports) {
$parcel$export(module.exports, "default", () => $6436abe84fc91b7d$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $8EsbU = parcelRequire("8EsbU");


var $d5RCH = parcelRequire("d5RCH");

function $6436abe84fc91b7d$export$2e2bcd8739ae039(getTitle, wrapperStyle) {
    if (typeof wrapperStyle === 'undefined') wrapperStyle = {};
    return (BaseComponent)=>(props)=>{
            const title = getTitle(props);
            const siteTitle = (0, $8EsbU.getOverride)('site-title') || '';
            const titleDefinedOnWindow = window['__DOCUMENT_TITLE_TAG__'] || '';
            let titleProp;
            if (titleDefinedOnWindow) titleProp = titleDefinedOnWindow;
            else if (title && siteTitle) titleProp = `${title} - ${siteTitle}`;
            else titleProp = title || siteTitle;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                style: wrapperStyle,
                "data-testid": "with-document-title"
            }, !window['__SSR_RENDERED__'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
                title: titleProp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BaseComponent, props)));
        };
}

});

parcelRegister("d5RCH", function(module, exports) {
function $69aebb91e74cbedb$export$155581e8dc02007a({ title: title }) {
    // document.title is safe to set during render:
    // - It's idempotent (setting the same value multiple times is safe)
    // - It doesn't trigger React re-renders
    // - Many React libraries do this (react-helmet, react-document-title, etc.)
    // - It's a browser API, not React state, so it doesn't violate React's rules
    // - The last component to render will have its title set, avoiding race conditions
    if (typeof document !== 'undefined' && title) document.title = title;
    return null;
}
module.exports["PageTitle"] = $69aebb91e74cbedb$export$155581e8dc02007a;

});

parcelRegister("8oCjN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $lKNXy = parcelRequire("lKNXy");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $1NBp8 = parcelRequire("1NBp8");


var $3Klda = parcelRequire("3Klda");


var $5ZqQS = parcelRequire("5ZqQS");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $fyPYm = parcelRequire("fyPYm");


var $6mKj3 = parcelRequire("6mKj3");


var $fwscq = parcelRequire("fwscq");


var $eSlm6 = parcelRequire("eSlm6");

const $7bbee5da9ba28ec8$var$connectAddonContainerStyle = {
    position: 'relative'
};
const $7bbee5da9ba28ec8$var$connectAddonProps = {
    contentStyle: {
        width: '100%',
        textAlign: 'center',
        display: 'inline-block'
    },
    width: '100%',
    height: '100%'
};
const $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX = /^ac:(.*)__(.*)-remote-theme$/;
const $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7 = (themeKey)=>{
    const regexResult = $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX.exec(themeKey);
    return regexResult ? [
        regexResult[1],
        regexResult[2]
    ] : [
        null,
        null
    ];
};
const $7bbee5da9ba28ec8$export$7f576b861c4a75d4 = ({ children: children })=>{
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const isBlogpost = contentType === 'blogpost';
    const isSpaceOverview = match?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
    const skipContentQuery = !contentId || !spaceKey || !isSpaceOverview || contentIdLoading;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const pageContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $jgc4t.default), {
        context: {
            single: true
        },
        variables: {
            contentId: contentId ?? '',
            spaceKey: spaceKey,
            versionOverride: null,
            isSSR: isSSR,
            useNewContentTopper: true
        },
        skip: skipContentQuery || isBlogpost,
        __callerPackage__: "space-base"
    });
    const blogContentQueryResult = (0, $jMyy4.useQueryInterop)((0, $f9opb.default), {
        context: {
            single: true
        },
        variables: {
            contentId: contentId ?? '',
            spaceKey: spaceKey,
            isSSR: isSSR,
            versionOverride: null,
            useNewContentTopper: true
        },
        skip: skipContentQuery || !isBlogpost,
        __callerPackage__: "space-base"
    });
    const contentQueryResult = isBlogpost ? blogContentQueryResult : pageContentQueryResult;
    const themeKey = contentQueryResult?.data?.space?.theme?.themeKey;
    const routeOverrideEnabled = contentQueryResult?.data?.space?.settings?.routeOverrideEnabled;
    const [themeAddonKey, themeModuleKey] = $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7(themeKey ?? '');
    const skipOverrideQuery = !themeAddonKey || !themeModuleKey || !routeOverrideEnabled;
    const overrideQueryResult = (0, $eSlm6.useExperimentalThemeSpaceHomeOverrideQuery)({
        variables: {
            themeAddonKey: themeAddonKey,
            themeModuleKey: themeModuleKey,
            spaceKey: spaceKey || '',
            spaceHomePageId: contentId || ''
        },
        skip: skipOverrideQuery
    });
    const productCtx = overrideQueryResult.data?.experimentalThemeSpaceHomeOverride?.spaceHomeOverrideDescriptor?.productCtx;
    const productContext = (0, $cozmU.useMemo)(()=>productCtx ? JSON.parse(productCtx) : undefined, [
        productCtx
    ]);
    if (contentQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(contentQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(contentQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    }
    if (overrideQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(overrideQueryResult.error, {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(overrideQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    }
    if (contentIdLoading) return null;
    if (skipContentQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    if (contentQueryResult.loading || !skipOverrideQuery && overrideQueryResult.loading) return null;
    if (skipOverrideQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    if (!contentQueryResult.data || !overrideQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    const { hasSpaceHomeOverride: hasSpaceHomeOverride, spaceHomeOverrideDescriptor: spaceHomeOverrideDescriptor } = overrideQueryResult.data.experimentalThemeSpaceHomeOverride;
    if (!hasSpaceHomeOverride || !spaceHomeOverrideDescriptor) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    // Ensure required fields are present for ConnectAddonDescriptor
    if (!spaceHomeOverrideDescriptor.addon_key || !spaceHomeOverrideDescriptor.key || !spaceHomeOverrideDescriptor.url || !spaceHomeOverrideDescriptor.contextJwt || !spaceHomeOverrideDescriptor.structuredContext || !spaceHomeOverrideDescriptor.productCtx) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
    const descriptor = {
        addon_key: spaceHomeOverrideDescriptor.addon_key,
        key: spaceHomeOverrideDescriptor.key,
        url: spaceHomeOverrideDescriptor.url,
        contextJwt: spaceHomeOverrideDescriptor.contextJwt,
        structuredContext: spaceHomeOverrideDescriptor.structuredContext,
        productContext: productContext
    };
    // When the metric flag is off, preserve the original render tree exactly: a
    // Fragment containing the background layer and a plain ConnectAddon (no
    // experience tracking, no iframe lifecycle callbacks).
    if (!(0, $6mKj3.expVal)('confluence_enable_connect_group_6_metrics', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: descriptor,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
    // When the flag is on, route through ConnectThemeRenderer which tracks the
    // CONNECT_THEME_RENDER_EXPERIENCE via the Connect iframe lifecycle callbacks.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbee5da9ba28ec8$var$ConnectThemeRenderer, {
        descriptor: descriptor,
        addonKey: themeAddonKey,
        moduleKey: themeModuleKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
};
/**
 * Renders the remote theme via ConnectAddon and tracks the
 * CONNECT_THEME_RENDER_EXPERIENCE for the "Connect themes" capability (Group 6 of
 * the @ecosystem Feature Test Migration), gated behind the
 * `confluence_enable_connect_group_6_metrics` experiment.
 *
 * Mirrors the canonical ConnectCustomContentIframe lifecycle: start on render,
 * succeed/fail via the Connect iframe callbacks, and abort on unmount if the
 * experience started but never resolved.
 */ const $7bbee5da9ba28ec8$var$ConnectThemeRenderer = ({ children: children, descriptor: descriptor, addonKey: addonKey, moduleKey: moduleKey })=>{
    const experienceStartedRef = (0, $cozmU.useRef)(false);
    const experienceResolvedRef = (0, $cozmU.useRef)(false);
    // Note: this component is only rendered when the
    // `confluence_enable_connect_group_6_metrics` flag is on (gated at the call
    // site in SpaceBaseThemedComponent), so no flag check is needed here.
    const startExperienceIfNeeded = (0, $cozmU.useCallback)(()=>{
        const extension = {
            addonKey: addonKey,
            moduleKey: moduleKey
        };
        if (!(0, $fwscq.ThemeExperienceTrackerSupport).isTrackable(extension)) return false;
        if (!experienceStartedRef.current) {
            (0, $fwscq.ThemeExperienceTrackerSupport).start(extension);
            experienceStartedRef.current = true;
        }
        return true;
    }, [
        addonKey,
        moduleKey
    ]);
    const onIframeEstablished = (0, $cozmU.useCallback)(()=>{
        if (startExperienceIfNeeded() && !experienceResolvedRef.current) {
            (0, $fwscq.ThemeExperienceTrackerSupport).succeed();
            experienceResolvedRef.current = true;
        }
    }, [
        startExperienceIfNeeded
    ]);
    const onIframeTimeout = (0, $cozmU.useCallback)(()=>{
        if (startExperienceIfNeeded() && !experienceResolvedRef.current) {
            (0, $fwscq.ThemeExperienceTrackerSupport).fail('Connect theme iframe timeout');
            experienceResolvedRef.current = true;
        }
    }, [
        startExperienceIfNeeded
    ]);
    const onIframeFailedToLoad = (0, $cozmU.useCallback)(()=>{
        if (startExperienceIfNeeded() && !experienceResolvedRef.current) {
            (0, $fwscq.ThemeExperienceTrackerSupport).fail('Connect theme iframe failed to load');
            experienceResolvedRef.current = true;
        }
    }, [
        startExperienceIfNeeded
    ]);
    // Start the experience as soon as we render the theme.
    (0, $cozmU.useEffect)(()=>{
        startExperienceIfNeeded();
    }, [
        startExperienceIfNeeded
    ]);
    // Abort if the component unmounts before the render experience resolves.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (experienceStartedRef.current && !experienceResolvedRef.current) (0, $fwscq.ThemeExperienceTrackerSupport).abort('SpaceBaseThemedComponent unmounted before theme render experience resolved');
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: descriptor,
        onIframeEstablished: onIframeEstablished,
        onIframeTimeout: onIframeTimeout,
        onIframeFailedToLoad: onIframeFailedToLoad,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }));
};
module.exports["SpaceBaseThemedComponent"] = $7bbee5da9ba28ec8$export$7f576b861c4a75d4;

});

parcelRegister("lKNXy", function(module, exports) {
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


const $d2cf06290ddd4b8d$export$1679e39403bb0c0c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rJ3Sr",
    loader: async ()=>(await (parcelRequire("2I0Wk"))).ConnectAddon,
    name: 'ConnectAddonNext'
});
module.exports["ConnectAddon"] = $d2cf06290ddd4b8d$export$1679e39403bb0c0c;

});

parcelRegister("2I0Wk", function(module, exports) {

let $1f906b7721a63adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f906b7721a63adb$var$load("fWCBZ"),
    $1f906b7721a63adb$var$load("lK9vp"),
    $1f906b7721a63adb$var$load("9TOep"),
    $1f906b7721a63adb$var$load("6d83I")
]).then(()=>parcelRequire('2uezU'));

});

parcelRegister("3Klda", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");

const $2ba61f17a8768eba$var$screenLayerStyles = {
    display: 'block',
    position: 'absolute',
    width: '100%',
    top: 0,
    left: 0,
    height: 250
};
class $2ba61f17a8768eba$export$e0e5b47f08900b58 extends (0, $cozmU.Component) {
    render() {
        const { lookAndFeel: lookAndFeel } = this.props;
        if (!lookAndFeel || !lookAndFeel.content) return null;
        const customScreenLayerStyles = lookAndFeel?.content?.screen?.layer || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "content-screen-background-layer",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                ...$2ba61f17a8768eba$var$screenLayerStyles,
                ...customScreenLayerStyles
            }
        });
    }
}
$2ba61f17a8768eba$export$e0e5b47f08900b58.propTypes = {
    lookAndFeel: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object
};
module.exports["ContentScreenBackgroundLayer"] = $2ba61f17a8768eba$export$e0e5b47f08900b58;

});

parcelRegister("fyPYm", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bavCP = parcelRequire("bavCP");


var $eyzLS = parcelRequire("eyzLS");

let $701bdc3764047e40$var$lastContentId;
const $701bdc3764047e40$export$cc2fc38458ee98cc = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { contentId: contentId } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId) {
        t1 = ()=>{
            $701bdc3764047e40$var$lastContentId = contentId;
        };
        t2 = [
            contentId
        ];
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[3] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[3] = contentId;
        $[4] = t3;
    } else t3 = $[4];
    const t4 = $701bdc3764047e40$var$lastContentId === contentId;
    let t5;
    if ($[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: (0, $eyzLS.default),
            variables: t3,
            fetchPolicy: "network-only",
            skip: t4,
            __callerPackage__: "content-body"
        }, $701bdc3764047e40$var$_temp);
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
};
function $701bdc3764047e40$var$_temp() {
    return null;
}
module.exports["ContentViewedEvent"] = $701bdc3764047e40$export$cc2fc38458ee98cc;

});

parcelRegister("bavCP", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $jMyy4 = parcelRequire("jMyy4");

const $86f32d96feea2a1f$export$67f105fad14d18d = (0, $3u0dr.isReactCompilerActiveV2)() ? function QueryInterop(t0) {
    const $ = (0, $bDgLe.c)(7);
    let children;
    let props;
    let query;
    if ($[0] !== t0) {
        ({ children: children, query: query, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = query;
    } else {
        children = $[1];
        props = $[2];
        query = $[3];
    }
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    let t1;
    if ($[4] !== children || $[5] !== result) {
        t1 = children(result);
        $[4] = children;
        $[5] = result;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : function QueryInterop({ children: children, query: query, ...props }) {
    const result = (0, $jMyy4.useQueryInterop)(query, props);
    return children(result);
};
module.exports["QueryInterop"] = $86f32d96feea2a1f$export$67f105fad14d18d;

});

parcelRegister("eyzLS", function(module, exports) {
/**
 * @generated SignedSource<<b170f4062a7b22df5c789ae2263ec5d9>>
 * @relayHash 6b82c836e177933e272ade59efcd5b5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42
const $ac80f5dc8fd0c04e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "trigger",
                    "value": "viewed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentViewedEventQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "6b82c836e177933e272ade59efcd5b5c",
            "id": "6442e1d626bb37ef4897bdc166747bc6f6f93f7d888574ea37d7d5521fde4b42",
            "metadata": {},
            "name": "ContentViewedEventQuery",
            "operationKind": "query",
            "text": "query ContentViewedEventQuery($contentId:ID){content(id:$contentId,trigger:\"viewed\"){nodes{id}}}"
        }
    };
}();
$ac80f5dc8fd0c04e$var$node.hash = "d8b1d8e3bca16082db7c9284db04b505";
var $ac80f5dc8fd0c04e$export$2e2bcd8739ae039 = $ac80f5dc8fd0c04e$var$node;
module.exports["default"] = $ac80f5dc8fd0c04e$export$2e2bcd8739ae039;

});

parcelRegister("fwscq", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $e3580b2eccf81d32$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $e3580b2eccf81d32$export$570932507afcc1e1 = new class ThemeExperienceTrackerSupport {
    isTrackable(extension) {
        return Boolean(extension?.addonKey) && Boolean(extension?.moduleKey);
    }
    start(extension) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.CONNECT_THEME_RENDER_EXPERIENCE),
            attributes: {
                addonKey: extension?.addonKey,
                moduleKey: extension?.moduleKey
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.CONNECT_THEME_RENDER_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.CONNECT_THEME_RENDER_EXPERIENCE),
            error: $e3580b2eccf81d32$var$getError(messageOrError)
        });
    }
    abort(reason) {
        (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.CONNECT_THEME_RENDER_EXPERIENCE),
            reason: reason
        });
    }
}();
module.exports["ThemeExperienceTrackerSupport"] = $e3580b2eccf81d32$export$570932507afcc1e1;

});

parcelRegister("eSlm6", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $aBfpe = parcelRequire("aBfpe");

const $d5f5bff41df6d94f$export$aa603d43549e91b7 = ({ skip: skip, variables: variables })=>{
    const { themeAddonKey: themeAddonKey, themeModuleKey: themeModuleKey, spaceKey: spaceKey, spaceHomePageId: spaceHomePageId } = variables;
    return (0, $dK51B.useExperimentalQuery)({
        url: ()=>{
            if (!themeAddonKey || !themeModuleKey) // This will be handled by parseResponseOnError to return expected data when these keys are missing
            throw new Error('themeAddonKey and themeModuleKey are missing');
            return `/wiki/plugins/servlet/ac/${themeAddonKey}/${themeModuleKey}/?classifier=json&space.key=${spaceKey}&content.id=${spaceHomePageId}&content.type=page`;
        },
        method: 'GET',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        parseResponseOnError: ()=>null,
        parseResult: (data)=>({
                experimentalThemeSpaceHomeOverride: {
                    hasSpaceHomeOverride: data !== null,
                    spaceHomeOverrideDescriptor: data
                }
            }),
        skip: skip,
        variables: variables
    });
};
module.exports["useExperimentalThemeSpaceHomeOverrideQuery"] = $d5f5bff41df6d94f$export$aa603d43549e91b7;

});

parcelRegister("dK51B", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GTIR = parcelRequire("1GTIR");


var $fqCbQ = parcelRequire("fqCbQ");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");

function $7ac155b86059b716$export$9a41df5b9f27a628({ url: url, method: method, headers: headers, body: body, variables: variables, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    const { fetchData: fetchData } = (0, $1GTIR.useFetchData)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables,
        parseResult: parseResult,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    });
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    return $7ac155b86059b716$export$defacdf98710c90a({
        key: key,
        fetchData: fetchData,
        variables: variables,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        skip: skip,
        fetchPolicy: fetchPolicy,
        pollInterval: pollInterval
    });
}
function $7ac155b86059b716$export$defacdf98710c90a({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, skip: skip = false, fetchPolicy: fetchPolicy = 'cache-first', pollInterval: pollInterval }) {
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const { queryState: queryState, execute: execute, refetch: refetch, stopPolling: stopPolling } = (0, $fqCbQ.useExperimentalQueryExecution)({
        key: key,
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        transformError: transformError,
        fetchPolicy: fetchPolicy,
        isLazyQuery: false,
        pollInterval: pollInterval,
        isSSR: isSSR
    });
    (0, $cozmU.useEffect)(()=>{
        // Edit Page uses JSDOM, so effects run in SSR. Experimental queries should not execute during SSR
        if (!skip && !isSSR) execute();
    }, [
        execute,
        key,
        skip,
        fetchPolicy,
        isSSR
    ]);
    // If skip is true, return idle state with refetch
    if (skip) return {
        ...(0, $7ji4X.INITIAL_IDLE_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
    // Use store state if available, otherwise return initial loading state with refetch
    // (stable reference prevents extra renders before query executes)
    return queryState ? {
        ...queryState,
        refetch: refetch,
        stopPolling: stopPolling
    } : {
        ...(0, $7ji4X.INITIAL_LOADING_STATE),
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQuery"] = $7ac155b86059b716$export$9a41df5b9f27a628;
module.exports["useExperimentalQueryBase"] = $7ac155b86059b716$export$defacdf98710c90a;

});

parcelRegister("1GTIR", function(module, exports) {

var $26Yfd = parcelRequire("26Yfd");


var $GLgaM = parcelRequire("GLgaM");

// Allows using variables from either the mutate call or initial hook call
// Follows Apollo Client behavior: only falls back when variables is undefined, not empty object
const $e94116a19c839dfc$var$resolveVariables = (localVariables, fallbackVariables)=>{
    return localVariables !== undefined ? localVariables : fallbackVariables ?? {};
};
const $e94116a19c839dfc$export$80ee20aa64f130f = ({ url: url, method: method, variables: variables = {}, headers: headers, body: body, credentials: credentials, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const response = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, resolvedVariables);
        return parseResult(response, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
const $e94116a19c839dfc$export$54f10667ecd8890d = ({ requestConfigs: requestConfigs, variables: variables = {}, parseResult: parseResult })=>{
    const fetchData = (0, $26Yfd.useStableCallback)(async (localVariables)=>{
        const resolvedVariables = $e94116a19c839dfc$var$resolveVariables(localVariables, variables);
        const responses = await Promise.all(requestConfigs.map((fetchOptions)=>(0, $GLgaM.fetchResponse)(fetchOptions, resolvedVariables)));
        return parseResult(responses, resolvedVariables);
    });
    return {
        fetchData: fetchData
    };
};
module.exports["useFetchData"] = $e94116a19c839dfc$export$80ee20aa64f130f;
module.exports["useFetchDataWithMultipleFetches"] = $e94116a19c839dfc$export$54f10667ecd8890d;

});

parcelRegister("fqCbQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $26Yfd = parcelRequire("26Yfd");


var $hR9WV = parcelRequire("hR9WV");


var $7ji4X = parcelRequire("7ji4X");


var $iXGsw = parcelRequire("iXGsw");

const $2b5be438041a56b3$export$96d43f36deadf5d1 = new Map();
function $2b5be438041a56b3$export$ca796a141438ab25({ key: key, fetchData: fetchData, onCompleted: onCompleted, onError: onError, transformError: transformError, fetchPolicy: fetchPolicy, isLazyQuery: isLazyQuery = false, pollInterval: pollInterval, isSSR: isSSR = false }) {
    // For no-cache: use local state per hook instance instead of shared state
    const [localState, setLocalState] = (0, $cozmU.useState)();
    const sharedState = (0, $7ji4X.useExperimentalQueryState)({
        key: key
    });
    const { setQueryState: setQueryState } = (0, $7ji4X.useExperimentalQueryStateActions)();
    // Store the last used variables for polling
    // This ensures lazy queries remember their variables for subsequent poll requests
    const lastVariablesRef = (0, $cozmU.useRef)(undefined);
    // Choose which state to expose based on fetchPolicy
    const queryState = fetchPolicy === 'no-cache' ? localState : sharedState;
    const execute = (0, $26Yfd.useStableCallback)(async (variables, options)=>{
        // Store variables for future polling requests
        // This matches Apollo's behavior where lazy queries remember their variables
        if (variables !== undefined) lastVariablesRef.current = variables;
        // Use provided variables, or fall back to stored variables (e.g., during polling)
        const effectiveVariables = variables ?? lastVariablesRef.current;
        // If cache-first and we have data, return immediately (unless bypassCache is true, e.g., for polling)
        if (fetchPolicy === 'cache-first' && queryState?.data !== undefined && !options?.bypassCache) {
            onCompleted?.(queryState.data);
            return;
        }
        // Check if this exact query is already in flight (deduplication)
        const existingPromise = $2b5be438041a56b3$export$96d43f36deadf5d1.get(key);
        if (existingPromise) {
            // Wait for the shared promise
            const outcome = await existingPromise;
            // Set local state if no-cache policy. Other fetch policies use shared state
            if (fetchPolicy === 'no-cache') {
                if (outcome.error) setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: outcome.error,
                        called: true
                    }));
                else if (outcome.data !== undefined) setLocalState({
                    data: outcome.data,
                    loading: false,
                    error: undefined,
                    called: true
                });
            }
            // Call this component's callbacks
            if (outcome.error) onError?.(outcome.error);
            else if (outcome.data !== undefined) onCompleted?.(outcome.data);
            return;
        }
        // Create a Promise for the fetch operation that resolves to the outcome
        const fetchPromise = (async ()=>{
            try {
                // Set loading state if not initial fetch
                const shouldSetLoadingState = !options?.skipLoadingState && (isLazyQuery || queryState?.loading === false || queryState?.data !== undefined || queryState?.error);
                if (shouldSetLoadingState) {
                    // Update the appropriate state based on fetchPolicy
                    if (fetchPolicy === 'no-cache') setLocalState({
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                    else setQueryState(key, {
                        data: queryState?.data,
                        loading: true,
                        error: undefined,
                        called: true
                    });
                }
                const data = await fetchData(effectiveVariables);
                if (fetchPolicy === 'no-cache') setLocalState({
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                else setQueryState(key, {
                    data: data,
                    loading: false,
                    error: undefined,
                    called: true
                });
                onCompleted?.(data);
                return {
                    data: data
                };
            } catch (error) {
                const finalError = await (0, $hR9WV.handleError)({
                    error: error,
                    transformError: transformError,
                    onError: onError
                });
                if (fetchPolicy === 'no-cache') setLocalState((prev)=>({
                        data: prev?.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                else setQueryState(key, (prev)=>({
                        data: prev.data,
                        loading: false,
                        error: finalError,
                        called: true
                    }));
                return {
                    error: finalError
                };
            } finally{
                // Remove from in-flight map so future calls create a new request
                $2b5be438041a56b3$export$96d43f36deadf5d1.delete(key);
            }
        })();
        // Store the Promise in the Map before starting the fetch
        $2b5be438041a56b3$export$96d43f36deadf5d1.set(key, fetchPromise);
        await fetchPromise;
    });
    // Note: This only updates the shared state, so any fetch policies (e.g. "no-cache") will be ignored.
    // Please implement local state usage if it's needed in the future.
    const refetch = (0, $26Yfd.useStableCallback)(async (variables)=>{
        try {
            setQueryState(key, {
                data: queryState?.data,
                loading: true,
                error: undefined,
                called: true
            });
            const data = await fetchData(variables);
            setQueryState(key, {
                data: data,
                loading: false,
                error: undefined,
                called: true
            });
            onCompleted?.(data);
            return {
                data: data
            };
        } catch (error) {
            const finalError = await (0, $hR9WV.handleError)({
                error: error,
                transformError: transformError,
                onError: onError
            });
            setQueryState(key, (prev)=>({
                    data: prev.data,
                    loading: false,
                    error: finalError,
                    called: true
                }));
            throw finalError;
        }
    });
    const { stopPolling: stopPolling } = (0, $iXGsw.usePollInterval)(pollInterval, execute, fetchPolicy, isLazyQuery, queryState?.called, isSSR);
    return {
        queryState: queryState,
        execute: execute,
        refetch: refetch,
        stopPolling: stopPolling
    };
}
module.exports["useExperimentalQueryExecution"] = $2b5be438041a56b3$export$ca796a141438ab25;

});

parcelRegister("hR9WV", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $bjeS8 = parcelRequire("bjeS8");

const $b1a7f6ba28f294ca$export$d3da1ecaf1206c58 = async ({ error: error, transformError: transformError, onError: onError })=>{
    // The `transformError` callback can optionally return a new error to replace the original,
    // allowing for custom errors (e.g. based on the error's status code)
    const finalError = (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    // Process error for monitoring/analytics
    if (finalError.graphQLErrors?.length) finalError.graphQLErrors.forEach((e)=>{
        (0, $7Sm4c.processError)(e);
    });
    onError?.(finalError);
    return finalError;
};
module.exports["handleError"] = $b1a7f6ba28f294ca$export$d3da1ecaf1206c58;

});

parcelRegister("iXGsw", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

function $d90d6eaddcfc40bd$export$55982a4d88e0db29(pollInterval, execute, fetchPolicy, isLazyQuery, called, isSSR) {
    if (pollInterval && fetchPolicy === 'cache-first') throw new Error('Queries that specify the cache-first fetchPolicy cannot also be polling queries.');
    const pollIntervalRef = (0, $cozmU.useRef)(null);
    const stopPolling = (0, $cozmU.useCallback)(()=>{
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
    }, []);
    const handlePoll = (0, $cozmU.useCallback)(()=>{
        execute(undefined, {
            bypassCache: true,
            skipLoadingState: true
        });
    }, [
        execute
    ]);
    // For non-lazy queries: poll immediately when pollInterval > 0
    // For lazy queries: only poll after query has been called at least once
    const shouldStartPolling = (0, $cozmU.useMemo)(()=>{
        if (isSSR || !pollInterval || pollInterval <= 0) return false;
        return !isLazyQuery || called;
    }, [
        isSSR,
        pollInterval,
        isLazyQuery,
        called
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Clear any existing poll interval when conditions change
        if (pollIntervalRef.current) {
            clearInterval(pollIntervalRef.current);
            pollIntervalRef.current = null;
        }
        if (shouldStartPolling) pollIntervalRef.current = setInterval(()=>{
            handlePoll();
        }, pollInterval);
        // Cleanup on unmount or when dependencies change
        return ()=>{
            if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
            }
        };
    }, [
        pollInterval,
        handlePoll,
        shouldStartPolling
    ]);
    return {
        stopPolling: stopPolling
    };
}
module.exports["usePollInterval"] = $d90d6eaddcfc40bd$export$55982a4d88e0db29;

});

parcelRegister("4b4iP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $67Foi = parcelRequire("67Foi");


var $eAduJ = parcelRequire("eAduJ");


var $fG32j = parcelRequire("fG32j");


var $aZfd8 = parcelRequire("aZfd8");

const $343989ced147f5e6$export$20a459334853e190 = ({ children: children, spaceKey: spaceKey, isAnonymous: isAnonymous = false, contentId: contentId, isFirstRoute: isFirstRoute = false, goBackPreviousPage: goBackPreviousPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        spaceKey: spaceKey,
        contentId: contentId
    }, ({ isSpaceRestricted: isSpaceRestricted, isSpaceNotFound: isSpaceNotFound })=>{
        if (isSpaceRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eAduJ.RestrictedSpace), {
            goToPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute,
            contentId: contentId
        });
        if (isSpaceNotFound && !isAnonymous && !contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aZfd8.Space404), {
            goBackPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67Foi.ScreenEvent), {
            name: "spaceNotFoundScreen",
            id: spaceKey
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    });
};
module.exports["SpaceRestrictionHandler"] = $343989ced147f5e6$export$20a459334853e190;

});

parcelRegister("eAduJ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0e8fee473144754c$export$5ef003f00c9525a1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "wviAQ",
    name: "RestrictedSpace",
    loader: async ()=>(await (parcelRequire("hRSZM"))).RestrictedSpace
});
module.exports["RestrictedSpace"] = $0e8fee473144754c$export$5ef003f00c9525a1;

});

parcelRegister("hRSZM", function(module, exports) {

let $d0220bd8aab21b40$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d0220bd8aab21b40$var$load("d0ZRF"),
    $d0220bd8aab21b40$var$load("k507P"),
    $d0220bd8aab21b40$var$load("b6eef"),
    $d0220bd8aab21b40$var$load("hhss7"),
    $d0220bd8aab21b40$var$load("7EorR"),
    $d0220bd8aab21b40$var$load("2OcM6")
]).then(()=>parcelRequire('9at9H'));

});

parcelRegister("fG32j", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $kdKo9 = parcelRequire("kdKo9");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");



var $jMyy4 = parcelRequire("jMyy4");

const $06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery = (0, $kdKo9.default);
const $06e8bea7aad8a7b8$export$f1b4255eb8ae314e = (0, $3u0dr.isReactCompilerActiveV2)() ? function SpaceRestrictionCheck(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId } = t0;
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    let t1;
    if ($[0] !== asSuperAdmin) {
        t1 = asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        };
        $[0] = asSuperAdmin;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = spaceKey || stateSpaceKey;
    let t3;
    if ($[2] !== t2) {
        t3 = {
            spaceKey: t2
        };
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = {
            context: t1,
            errorPolicy: "all",
            variables: t3
        };
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        ...t4,
        __callerPackage__: "restrictions"
    });
    let t5;
    let t6;
    if ($[7] !== children || $[8] !== contentId || $[9] !== data || $[10] !== error || $[11] !== loading) {
        t6 = Symbol.for("react.early_return_sentinel");
        bb0: {
            let isSpaceNotFound;
            let isSpaceRestricted;
            if (error) {
                isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
                isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
                if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
            } else if (data) {
                const errorSwallowed = data.space === null;
                isSpaceNotFound = errorSwallowed && window.__SPACE_NOTFOUND_CHECK_ERROR__;
                isSpaceRestricted = errorSwallowed && window.__SPACE_RESTRICTED_CHECK_ERROR__;
            }
            if (loading) {
                t6 = null;
                break bb0;
            }
            const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.__SPACE_RESTRICTED_ERROR__ === contentId;
            t5 = children({
                error: error,
                isSpaceNotFound: isSpaceNotFound,
                isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
            });
        }
        $[7] = children;
        $[8] = contentId;
        $[9] = data;
        $[10] = error;
        $[11] = loading;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    if (t6 !== Symbol.for("react.early_return_sentinel")) return t6;
    return t5;
} : function SpaceRestrictionCheck({ asSuperAdmin: asSuperAdmin, children: children, spaceKey: spaceKey, contentId: contentId }) {
    const [stateSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($06e8bea7aad8a7b8$var$SpaceRestrictionCheckQuery, {
        context: asSuperAdmin == undefined ? undefined : {
            asSuperAdmin: asSuperAdmin
        },
        errorPolicy: 'all',
        variables: {
            // XXX Though SpaceRestrictionCheckProps defines spaceKey as required,
            // SpaceBaseComponent is not written in TypeScript and it may provide
            // undefined as it is reading spaceKey from redux. While it would result
            // in a better separation of concerns to have a fix in SpaceBaseComponent,
            // such a fix would be riskier.
            spaceKey: spaceKey || stateSpaceKey
        },
        __callerPackage__: "restrictions"
    });
    let isSpaceNotFound;
    let isSpaceRestricted;
    if (error) {
        isSpaceNotFound = $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error);
        isSpaceRestricted = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error);
        if (isSpaceNotFound || isSpaceRestricted) (0, $7Sm4c.markErrorAsHandled)(error);
    } else if (data) {
        const errorSwallowed = data.space === null;
        isSpaceNotFound = errorSwallowed && window['__SPACE_NOTFOUND_CHECK_ERROR__'];
        isSpaceRestricted = errorSwallowed && window['__SPACE_RESTRICTED_CHECK_ERROR__'];
    }
    if (loading) return null;
    const contentIsNotViewableBecauseOfSpaceRestrictions = Boolean(contentId) && window?.['__SPACE_RESTRICTED_ERROR__'] === contentId;
    return children({
        error: error,
        isSpaceNotFound: isSpaceNotFound,
        isSpaceRestricted: isSpaceRestricted || contentIsNotViewableBecauseOfSpaceRestrictions
    });
};
function $06e8bea7aad8a7b8$export$498e7daa29ea2c61(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ({ statusCode: statusCode })=>statusCode === 404 || statusCode === 400);
}
function $06e8bea7aad8a7b8$export$ee3dd1f0a88cef(error) {
    return $06e8bea7aad8a7b8$var$isSpaceError(error, ()=>(0, $1uFM6.isUnauthorizedError)(error));
}
function $06e8bea7aad8a7b8$var$isSpaceError({ graphQLErrors: graphQLErrors }, extensionsPredicate) {
    if (graphQLErrors && graphQLErrors.length > 0) for (const { extensions: extensions, path: path } of graphQLErrors){
        if (Array.isArray(path) && path.indexOf('space') !== -1 && extensions && extensionsPredicate(extensions)) return true;
    }
    return false;
}
module.exports["SpaceRestrictionCheck"] = $06e8bea7aad8a7b8$export$f1b4255eb8ae314e;
module.exports["isSpaceNotFoundError"] = $06e8bea7aad8a7b8$export$498e7daa29ea2c61;
module.exports["isSpaceRestrictedError"] = $06e8bea7aad8a7b8$export$ee3dd1f0a88cef;

});

parcelRegister("aZfd8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $wtSEP = parcelRequire("wtSEP");

const $c70a78199cd90f84$export$a506b89ee82dfeb8 = (props)=>{
    const { isFirstRoute: isFirstRoute, goBackPreviousPage: goBackPreviousPage } = props;
    const onClickGoPreviousLink = (e)=>{
        e.preventDefault();
        if (goBackPreviousPage) goBackPreviousPage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), {
        secondaryButtonProps: {
            children: !isFirstRoute && goBackPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                id: "space-404.text.go.back.previous.page",
                defaultMessage: "Go to previous page"
            }),
            onClick: onClickGoPreviousLink
        }
    });
};
$c70a78199cd90f84$export$a506b89ee82dfeb8.displayName = 'Space404';
module.exports["Space404"] = $c70a78199cd90f84$export$a506b89ee82dfeb8;

});

parcelRegister("wtSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $251dbde4d6244b59$export$271f9f08425019c7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "pM5to",
    name: "NotFound",
    loader: async ()=>// eslint-disable-next-line
        (await (parcelRequire("g3wkt"))).NotFound
});
module.exports["NotFound"] = $251dbde4d6244b59$export$271f9f08425019c7;

});

parcelRegister("g3wkt", function(module, exports) {

let $bb06010aabb1fa2c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bb06010aabb1fa2c$var$load("d0ZRF"),
    $bb06010aabb1fa2c$var$load("k507P"),
    $bb06010aabb1fa2c$var$load("b6eef"),
    $bb06010aabb1fa2c$var$load("85Ack"),
    $bb06010aabb1fa2c$var$load("k0Z8C"),
    $bb06010aabb1fa2c$var$load("hhss7"),
    $bb06010aabb1fa2c$var$load("7EorR"),
    $bb06010aabb1fa2c$var$load("gEi5K")
]).then(()=>parcelRequire('3nvKi'));

});

parcelRegister("j9XVO", function(module, exports) {

var $kiJuS = parcelRequire("kiJuS");


var $d3OVq = parcelRequire("d3OVq");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");

const $2278a3c3763ebfe6$export$f1cfc3b574a4d714 = (0, $d3OVq.default);
const $2278a3c3763ebfe6$export$9d574d064e4f4f51 = (0, $kiJuS.default);
const $2278a3c3763ebfe6$export$8eab19bcc4a0311d = ({ resolvedSpaceKey: resolvedSpaceKey })=>{
    const { data: spaceBaseQueryData, loading: spaceBaseQueryLoading, error: spaceBaseQueryError } = (0, $jMyy4.useQueryInterop)($2278a3c3763ebfe6$export$f1cfc3b574a4d714, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        },
        __callerPackage__: "space-base"
    });
    const { data: singleSpaceQueryData, loading: singleSpaceQueryLoading, error: singleSpaceQueryError } = (0, $jMyy4.useQueryInterop)($2278a3c3763ebfe6$export$9d574d064e4f4f51, {
        skip: // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        Boolean(undefined) || !(0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false),
        variables: {
            spaceKey: resolvedSpaceKey
        },
        __callerPackage__: "space-base"
    });
    let space, loading;
    if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
        loading = singleSpaceQueryLoading;
        space = singleSpaceQueryError && !singleSpaceQueryLoading ? null : singleSpaceQueryData?.space;
    } else {
        loading = spaceBaseQueryLoading;
        space = spaceBaseQueryError && !spaceBaseQueryLoading ? null : spaceBaseQueryData?.spaces?.nodes?.[0];
    }
    return {
        space: space,
        loading: loading
    };
};
module.exports["useSpaceBaseQuery"] = $2278a3c3763ebfe6$export$8eab19bcc4a0311d;

});

parcelRegister("kiJuS", function(module, exports) {
/**
 * @generated SignedSource<<3ce11fe803ce3ee1884a6393aee1a87e>>
 * @relayHash c65404aa4339865deb33b960b63ac1fb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366
const $667a49a7f0668b30$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c65404aa4339865deb33b960b63ac1fb",
            "id": "e03d29f1801373ff6e80b3bfcf7c8bfe26a96bb6370f9f8c083d9d51a7a1a366",
            "metadata": {},
            "name": "useSpaceBaseQuerySingleSpaceQuery",
            "operationKind": "query",
            "text": "query useSpaceBaseQuerySingleSpaceQuery($spaceKey:String){space(key:$spaceKey){id,key,name,alias}}"
        }
    };
}();
$667a49a7f0668b30$var$node.hash = "0994a40a61365970e08e840dbdb433df";
var $667a49a7f0668b30$export$2e2bcd8739ae039 = $667a49a7f0668b30$var$node;
module.exports["default"] = $667a49a7f0668b30$export$2e2bcd8739ae039;

});

parcelRegister("jNRDO", function(module, exports) {

let $e6ac33ec1f17f296$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6ac33ec1f17f296$var$load("fp9cm").then(()=>parcelRequire('9ehFI'));

});

parcelRegister("eM9mN", function(module, exports) {

let $ac1cd06a641e8fe9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ac1cd06a641e8fe9$var$load("6XCf4"),
    $ac1cd06a641e8fe9$var$load("gWjIZ"),
    $ac1cd06a641e8fe9$var$load("1yVM6"),
    $ac1cd06a641e8fe9$var$load("22Xly")
]).then(()=>parcelRequire('kQJNb'));

});

parcelRegister("8NC5Z", function(module, exports) {

var $896gY = parcelRequire("896gY");


var $7Sm4c = parcelRequire("7Sm4c");


var $euL71 = parcelRequire("euL71");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");

const $1de3a5511529eed3$export$f032b5e8b485da1d = ({ skip: skip = false } = {})=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const shouldSkip = skip || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $jMyy4.useQueryInterop)((0, $896gY.default), {
        skip: shouldSkip,
        __callerPackage__: "company-hub-utils"
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !shouldSkip && !data?.entitlements?.companyHub?.isEntitled;
};
module.exports["useCompanyHubPremiumGate"] = $1de3a5511529eed3$export$f032b5e8b485da1d;

});

parcelRegister("896gY", function(module, exports) {
/**
 * @generated SignedSource<<0bf45832ece12ce1024ca4a87950d3ec>>
 * @relayHash c31aa70a9a01e2207eb48c0b9be8b493
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6
const $983e77d68212dc57$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "CompanyHubFeature",
                    "kind": "LinkedField",
                    "name": "companyHub",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "c31aa70a9a01e2207eb48c0b9be8b493",
            "id": "46122cb94f25a4d113917d2f15feffbc32da4a3126240723b7ca4eed1bf9dbd6",
            "metadata": {},
            "name": "useCompanyHubPremiumGateCompanyHubPremiumGateQuery",
            "operationKind": "query",
            "text": "query useCompanyHubPremiumGateCompanyHubPremiumGateQuery{entitlements{companyHub{isEntitled}}}"
        }
    };
}();
$983e77d68212dc57$var$node.hash = "a5508e7e7123c5675909c4f9214a5be2";
var $983e77d68212dc57$export$2e2bcd8739ae039 = $983e77d68212dc57$var$node;
module.exports["default"] = $983e77d68212dc57$export$2e2bcd8739ae039;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("7CeAz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cEgMD = parcelRequire("cEgMD");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $8NC5Z = parcelRequire("8NC5Z");

const $16ea73778f65e8da$export$1d4394ae12760637 = ()=>{
    const { frontCoverState: frontCoverState, isSiteAdmin: isSiteAdmin, loading: loading } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const canPublish = isSiteAdmin || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    const isAdminDiscoverable = // 1. If entitled (e.g. Premium), both site admin and product admin have the
    //    entry point in the top nav, because it leads to COMPANY_HUB.
    // 2. If not entitled (e.g. Free or Standard):
    //   a. only site admin has the entry point in the top nav, because it
    //      renders an upsell;
    //   b. product admin doesn't have the entry point in the top nav, because
    //      it automatically redirects to HOME.
    shouldShowPremiumUpsell ? isSiteAdmin : canPublish;
    const isCompanyHubFeatureAvailable = !shouldShowPremiumUpsell;
    const isCompanyHubPublished = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).SHOWN);
    const isCompanyHubShownToEditors = Boolean(isCompanyHubFeatureAvailable && frontCoverState === (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY || isCompanyHubPublished);
    const isCompanyHubEntryPointEnabled = Boolean(isCompanyHubFeatureAvailable && (isCompanyHubPublished || isCompanyHubShownToEditors) || isAdminDiscoverable);
    return {
        canPublish: isCompanyHubFeatureAvailable && canPublish,
        isCompanyHubPublished: isCompanyHubPublished,
        isCompanyHubShownToEditors: isCompanyHubShownToEditors,
        isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled,
        loading: Boolean(loading)
    };
};
module.exports["useIsCompanyHubEnabled"] = $16ea73778f65e8da$export$1d4394ae12760637;

});

parcelRegister("eqNP8", function(module, exports) {
/* FullPageLoadingScreen.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $94835ea6111c7010$var$zIndexBlanket = 500; // layers.blanket()
const $94835ea6111c7010$export$7c6e2c02157bb7d2 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _2IhTon715P _3OE6xY715P _1VJPcaiDnZ _42Yu6B6zpv",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_23rrnH4Jcb _42Yu6BN779 _0jFU0VN91d _39xV02N91d _1mT5xdy1CL _3OE6xYdnbC _2IhTondnbC _0KLXrulfZc _1YKVNs4qrS _3OZqoKe6K4",
            __cmplp.className
        ])
    });
});
const $94835ea6111c7010$export$fe2b6579564feee = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($94835ea6111c7010$export$7c6e2c02157bb7d2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        interactionName: "full-page-loading-screen",
        size: 26
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($94835ea6111c7010$export$5b927fc1ef8c468b, null));
module.exports["FullPageLoadingScreen"] = $94835ea6111c7010$export$fe2b6579564feee;

});

parcelRegister("gi8UL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $7m1pr = parcelRequire("7m1pr");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $1NBp8 = parcelRequire("1NBp8");


var $cEgMD = parcelRequire("cEgMD");


var $6s78L = parcelRequire("6s78L");


var $fEmGS = parcelRequire("fEmGS");


var $43e2h = parcelRequire("43e2h");


var $bZB1l = parcelRequire("bZB1l");


var $fg6th = parcelRequire("fg6th");


var $fbF8y = parcelRequire("fbF8y");

const $acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR = 'A space already exists';
const $acd2ea8b6650161b$export$66010d469140e6a6 = (error)=>{
    return !!error?.graphQLErrors?.some((error)=>{
        const isStatusCode400 = error.extensions?.statusCode === 400;
        const hasSimpleErrorMessage = error.message.includes($acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR);
        const hasNestedErrorMessage = error.extensions?.data?.errors?.every((err)=>err?.message?.translation?.includes($acd2ea8b6650161b$var$SPACE_ALREADY_EXISTS_ERROR));
        return isStatusCode400 && (hasSimpleErrorMessage || hasNestedErrorMessage);
    });
};
const $acd2ea8b6650161b$export$167bd8b1ca11153c = "User doesn't have permission to create system space";
const $acd2ea8b6650161b$export$ed3e7d674501852d = (error)=>$acd2ea8b6650161b$var$hasNestedApolloErrorMessage(error, $acd2ea8b6650161b$export$167bd8b1ca11153c);
const $acd2ea8b6650161b$var$hasNestedApolloErrorMessage = (error, errorMessage)=>{
    return error?.graphQLErrors?.[0]?.extensions?.data?.errors?.some((err)=>err?.message?.translation?.includes(errorMessage));
};
const $acd2ea8b6650161b$var$getErrorFlagConfig = (title, description, actions = [], id)=>({
        id: id,
        title: title,
        description: description,
        actions: actions
    });
const $acd2ea8b6650161b$var$showStalePermissionsErrorFlag = (flags)=>{
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagDescription,
        values: {
            a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                    target: "_blank"
                }, chunks)
        }
    });
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceStalePermissionsErrorFlagButton),
            onClick: ()=>window.location.reload()
        }
    ];
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, actions));
};
const $acd2ea8b6650161b$var$showUnauthorizedErrorFlag = (flags)=>{
    const id = 'create-system-space-permissions-failure';
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagDescription,
        values: {
            b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
        }
    });
    const actions = [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpacePermissionsErrorFlagButton),
            href: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        }
    ];
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, actions, id));
};
const $acd2ea8b6650161b$var$showGenericErrorFlag = (flags)=>{
    const id = 'create-system-space-failure';
    const title = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceErrorFlagTitle);
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $acd2ea8b6650161b$export$a7357cdd1f0b0168.createCompanyHubSpaceErrorFlagDescription);
    flags.showErrorFlag($acd2ea8b6650161b$var$getErrorFlagConfig(title, description, [], id));
};
const $acd2ea8b6650161b$export$a7357cdd1f0b0168 = // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages -- To not throw away existing translations when the concept "Company Home Builder" was obsoleted
(0, $kSwu1.defineMessages)({
    createCompanyHubSpaceErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-title",
        defaultMessage: "Something went wrong"
    },
    createCompanyHubSpaceErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-error-flag-description",
        defaultMessage: "Try again to continue setting up your landing page."
    },
    createCompanyHubSpacePermissionsErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-title",
        defaultMessage: "You need permission"
    },
    createCompanyHubSpacePermissionsErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-description",
        defaultMessage: "You need <b>Create space</b> permissions to create this hub."
    },
    createCompanyHubSpacePermissionsErrorFlagButton: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-permissions-error-flag-button",
        defaultMessage: "Go to permissions"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagTitle: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-title",
        defaultMessage: "We couldn\u2019t create your hub"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagDescription: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-description",
        defaultMessage: "Only product admins can create and activate a <a>Company hub</a>"
    },
    createCompanyHubSpaceStalePermissionsErrorFlagButton: {
        id: "company-home-builder.company-hub-space-create-modal.create-system-space-stale-permissions-error-flag-button",
        defaultMessage: "Got it"
    }
});
async function $acd2ea8b6650161b$export$cb27704aaa7dfff2(flags) {
    const client = (0, $hp2SH.getApolloClient)();
    try {
        const hasHubSpace = await (0, $43e2h.checkIfCompanyHubSpaceExists)();
        if (!hasHubSpace) {
            const { data: data, errors: errors } = await (0, $6s78L.mutateInterop)({
                mutation: (0, $fg6th.default),
                variables: {
                    input: {
                        systemSpaceHomepageTemplate: (0, $bZB1l.SystemSpaceHomepageTemplate).EAP
                    }
                },
                update: (cache, { data: data })=>{
                    const companyHubName = data?.createSystemSpace?.name;
                    if (!companyHubName) return;
                    $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, companyHubName);
                },
                __callerPackage__: "company-hub-utils"
            });
            if (errors?.length) throw new (0, $7m1pr.RelayError)({
                graphQLErrors: errors
            });
            if (data?.createSystemSpace?.id != null) $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
            return {
                didCreateSpace: true,
                homepageId: data?.createSystemSpace?.homepageId
            };
        }
        $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
        return {
            didCreateSpace: false,
            homepageId: undefined
        };
    } catch (error) {
        if ($acd2ea8b6650161b$export$66010d469140e6a6(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            $acd2ea8b6650161b$var$updateFrontCoverStateCache(client);
            return {
                didCreateSpace: false,
                homepageId: undefined
            };
        }
        if (flags) {
            if ($acd2ea8b6650161b$export$ed3e7d674501852d(error)) $acd2ea8b6650161b$var$showStalePermissionsErrorFlag(flags);
            else if ((0, $1uFM6.isUnauthorizedError)(error)) $acd2ea8b6650161b$var$showUnauthorizedErrorFlag(flags);
            else $acd2ea8b6650161b$var$showGenericErrorFlag(flags);
        }
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).MIGRATIONS_TOOLING
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        throw error;
    }
}
function $acd2ea8b6650161b$var$updateFrontCoverStateCache(cache) {
    $acd2ea8b6650161b$var$updateSiteConfigurationCache(cache, null, (0, $cEgMD.FrontCoverStateEnum).EDITORS_ONLY);
}
function $acd2ea8b6650161b$var$updateSiteConfigurationCache(_cache, companyHubName, frontCoverState) {
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $fbF8y.default),
        data: {
            siteSettings: {
                // Codegen is specifically configured to not add __typename when generating the types file,
                // so unfortunately ts-ignore is required here.
                // @ts-ignore
                __typename: 'SiteSettings',
                ...companyHubName ? {
                    companyHubName: companyHubName
                } : {},
                ...frontCoverState ? {
                    frontCover: {
                        frontCoverState: frontCoverState,
                        // Codegen is specifically configured to not add __typename when generating the types file,
                        // so unfortunately ts-ignore is required here.
                        // @ts-ignore
                        __typename: 'FrontCover'
                    }
                } : {}
            }
        },
        __callerPackage__: "company-hub-utils"
    });
}
module.exports["hasStalePermissionsErrorMessage"] = $acd2ea8b6650161b$export$ed3e7d674501852d;
module.exports["i18n"] = $acd2ea8b6650161b$export$a7357cdd1f0b0168;
module.exports["createCompanyHubSpace"] = $acd2ea8b6650161b$export$cb27704aaa7dfff2;

});

parcelRegister("43e2h", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $cEgMD = parcelRequire("cEgMD");


var $dSvuc = parcelRequire("dSvuc");


var $c0rhi = parcelRequire("c0rhi");

async function $efb8b6f89ca41072$export$bd1440de1c6279ff() {
    const key = (0, $cEgMD.getCompanyHubSpaceKey)();
    if (!key) throw new Error('Failed to get company hub space key');
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $dSvuc.CompanyHubSpaceQuery),
            variables: {
                key: key
            },
            __callerPackage__: "company-hub-utils"
        });
        return !!data?.space?.id;
    } catch (error) {
        if (error?.message.includes('NotFoundException')) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return false;
        } else throw error;
    }
}
module.exports["checkIfCompanyHubSpaceExists"] = $efb8b6f89ca41072$export$bd1440de1c6279ff;

});

parcelRegister("dSvuc", function(module, exports) {

var $8m8tN = parcelRequire("8m8tN");

const $d89c04ce1104682e$export$64834e9fe6776d12 = (0, $8m8tN.default);
module.exports["CompanyHubSpaceQuery"] = $d89c04ce1104682e$export$64834e9fe6776d12;

});

parcelRegister("8m8tN", function(module, exports) {
/**
 * @generated SignedSource<<22025a05bd4c5824adfd3b7c2aa87820>>
 * @relayHash f54737bfd2a13d4b0794f55692abc45f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5dadc9e02b20435a2eb281b9e0526d9c30d7939933ec6809776a6a63a0bfbfb0
const $a46838f64d9d3dd2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CompanyHubSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CompanyHubSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f54737bfd2a13d4b0794f55692abc45f",
            "id": "5dadc9e02b20435a2eb281b9e0526d9c30d7939933ec6809776a6a63a0bfbfb0",
            "metadata": {},
            "name": "CompanyHubSpaceQuery",
            "operationKind": "query",
            "text": "query CompanyHubSpaceQuery($key:String!){space(key:$key){id,homepageId}}"
        }
    };
}();
$a46838f64d9d3dd2$var$node.hash = "27e0b4cea0d06588f669e5b18022e172";
var $a46838f64d9d3dd2$export$2e2bcd8739ae039 = $a46838f64d9d3dd2$var$node;
module.exports["default"] = $a46838f64d9d3dd2$export$2e2bcd8739ae039;

});

parcelRegister("bZB1l", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $f8cc4d70fe32131d$export$7347d1c116cc1a56 = /*#__PURE__*/ function(SystemSpaceHomepageTemplate) {
    SystemSpaceHomepageTemplate["EAP"] = "EAP";
    SystemSpaceHomepageTemplate["MINIMAL"] = "MINIMAL";
    SystemSpaceHomepageTemplate["VISUAL"] = "VISUAL";
    return SystemSpaceHomepageTemplate;
}({});
module.exports["SystemSpaceHomepageTemplate"] = $f8cc4d70fe32131d$export$7347d1c116cc1a56;

});

parcelRegister("fg6th", function(module, exports) {
/**
 * @generated SignedSource<<0846e0fadbf09c50aad36a858dc422d6>>
 * @relayHash fe06e2f4a69f3231f81c25802441a1dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 694ca0efa967ba191320a5158bb8c5493f3d9fad08441a81d4bd1701967c7fc1
const $50fdf9c304115b8b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "createSystemSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CreateCompanyHubSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CreateCompanyHubSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "fe06e2f4a69f3231f81c25802441a1dc",
            "id": "694ca0efa967ba191320a5158bb8c5493f3d9fad08441a81d4bd1701967c7fc1",
            "metadata": {},
            "name": "CreateCompanyHubSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation CreateCompanyHubSpaceMutation($input:SystemSpaceHomepageInput!){createSystemSpace(input:$input){homepageId,id,name,type}}"
        }
    };
}();
$50fdf9c304115b8b$var$node.hash = "6d874a2575f518173ffd31619b161569";
var $50fdf9c304115b8b$export$2e2bcd8739ae039 = $50fdf9c304115b8b$var$node;
module.exports["default"] = $50fdf9c304115b8b$export$2e2bcd8739ae039;

});

parcelRegister("fbF8y", function(module, exports) {
/**
 * @generated SignedSource<<671cda1bccf0a3f50223a0090b44579c>>
 * @relayHash 4811a5c342533b21d8dd3e696c5fe3f8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b172e9d092e820e54ac35b21158bc7ef6a5fb96801347d822b558b506f90cf8
const $dd16027bddebb268$var$node = function() {
    var v0 = [
        {
            "concreteType": "SiteSettings",
            "kind": "LinkedField",
            "name": "siteSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "companyHubName"
                },
                {
                    "concreteType": "FrontCover",
                    "kind": "LinkedField",
                    "name": "frontCover",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "frontCoverState"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "SiteConfigurationQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "SiteConfigurationQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "4811a5c342533b21d8dd3e696c5fe3f8",
            "id": "4b172e9d092e820e54ac35b21158bc7ef6a5fb96801347d822b558b506f90cf8",
            "metadata": {},
            "name": "SiteConfigurationQuery",
            "operationKind": "query",
            "text": "query SiteConfigurationQuery{siteSettings{companyHubName,frontCover{frontCoverState}}}"
        }
    };
}();
$dd16027bddebb268$var$node.hash = "b4b2ce4fdc75a41f2f68ef6d954513ab";
var $dd16027bddebb268$export$2e2bcd8739ae039 = $dd16027bddebb268$var$node;
module.exports["default"] = $dd16027bddebb268$export$2e2bcd8739ae039;

});

parcelRegister("1P7Cq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $5c11702222c9ae97$export$10d6d9579eb80191 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const includeNonHydratingInitialRender = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [isSSROrHydrating, setIsSSROrHydrating] = (0, $cozmU.useState)(includeNonHydratingInitialRender ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            {
                if (window.__SSR_RENDERED__) (0, $cozmU.startTransition)(()=>{
                    setIsSSROrHydrating(false);
                });
                else setIsSSROrHydrating(false);
            }
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isSSROrHydrating;
};
module.exports["useIsSSROrHydrating"] = $5c11702222c9ae97$export$10d6d9579eb80191;

});

parcelRegister("2qfPs", function(module, exports) {

let $1c3a49c4c8a8009d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1c3a49c4c8a8009d$var$load("1ElkK"),
    $1c3a49c4c8a8009d$var$load("2xoIF"),
    $1c3a49c4c8a8009d$var$load("3BWYi"),
    $1c3a49c4c8a8009d$var$load("eosOx"),
    $1c3a49c4c8a8009d$var$load("hohnS"),
    $1c3a49c4c8a8009d$var$load("bAgF6"),
    $1c3a49c4c8a8009d$var$load("1F9i1"),
    $1c3a49c4c8a8009d$var$load("jFbCQ"),
    $1c3a49c4c8a8009d$var$load("kmE76"),
    $1c3a49c4c8a8009d$var$load("8qpwN"),
    $1c3a49c4c8a8009d$var$load("dnVmf"),
    $1c3a49c4c8a8009d$var$load("7e1By"),
    $1c3a49c4c8a8009d$var$load("85Ack"),
    $1c3a49c4c8a8009d$var$load("kUuw5"),
    $1c3a49c4c8a8009d$var$load("gQrOI"),
    $1c3a49c4c8a8009d$var$load("cYP30")
]).then(()=>parcelRequire('35RMv'));

});

parcelRegister("ak57N", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $a0c4fc2f529fa1f8$export$99fa8db8497fb663 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "fAvbz",
    name: 'EditPageLoaderServer',
    loader: async ()=>(await (parcelRequire("hLlCP"))).EditPageLoaderServer,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ClassicEditorContextProviderLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).NativeCollabLoader,
        (0, $2w2Hu.MustPreloadLoadableNames).FullPageEditorLoader
    ]
});
module.exports["EditPageLoaderServer"] = $a0c4fc2f529fa1f8$export$99fa8db8497fb663;

});

parcelRegister("2w2Hu", function(module, exports) {
/**
 * These are loadable names that cross reference by multiple places.
 * They were kept as constants here instead of automatically generated for consistency.
 * ONLY put names here if they are going to be used in _mustPreloadWhenRenderingSPA.
 */ const $8cf96aaaf31dfd76$export$75ebf2388340a0ba = {
    ClassicRendererLoader: 'ClassicRendererLoader',
    ClassicEditorContextProviderLoader: 'ClassicEditorContextProviderLoader',
    NativeCollabLoader: 'NativeCollabLoader',
    FullPageEditorLoader: 'FullPageEditorLoader',
    ViewPageRouteComponentLoader: 'ViewPageRouteComponentLoader',
    LivePageComponentLoader: 'LivePageComponentLoader',
    EditorByLineArea: 'EditorByLineArea',
    TitleAreaContentComponents: 'TitleAreaContentComponents'
};
module.exports["MustPreloadLoadableNames"] = $8cf96aaaf31dfd76$export$75ebf2388340a0ba;

});

parcelRegister("hLlCP", function(module, exports) {

let $cee799c233e05113$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cee799c233e05113$var$load("7EorR"),
    $cee799c233e05113$var$load("cgtG8")
]).then(()=>parcelRequire('g3qL5'));

});

parcelRegister("faAj4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $54Cdh = parcelRequire("54Cdh");

class $c089dd5bc3bc2565$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    render() {
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $8aG6j.jsx)($c089dd5bc3bc2565$var$WithEditorActionsNew, {
            ...this.props
        });
    }
    constructor(props){
        super(props);
    }
}
const $c089dd5bc3bc2565$var$WithEditorActionsNew = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WithEditorActionsNew(props) {
    const $ = (0, $bDgLe.c)(3);
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
    const t0 = context?.editorActions;
    let t1;
    if ($[0] !== render || $[1] !== t0) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($c089dd5bc3bc2565$var$WithEditorActionsInner, {
            render: render,
            editorActions: t0
        });
        $[0] = render;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function WithEditorActionsNew(props) {
    const { render: render } = props;
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $54Cdh.EditorContext));
    return /*#__PURE__*/ (0, $8aG6j.jsx)($c089dd5bc3bc2565$var$WithEditorActionsInner, {
        render: render,
        editorActions: context?.editorActions
    });
}; // Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c089dd5bc3bc2565$var$WithEditorActionsInner extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        this.props.editorActions._privateSubscribe(()=>this.forceUpdate());
    }
    componentWillUnmount() {
        this.props.editorActions._privateUnsubscribe(()=>this.forceUpdate());
    }
    render() {
        return this.props.render(this.props.editorActions);
    }
}
module.exports["default"] = $c089dd5bc3bc2565$export$2e2bcd8739ae039;

});

parcelRegister("4yccB", function(module, exports) {

var $QO4PV = parcelRequire("QO4PV");


var $6Q8Dd = parcelRequire("6Q8Dd");


var $iKWdo = parcelRequire("iKWdo");


var $lPEt0 = parcelRequire("lPEt0");


var $axuex = parcelRequire("axuex");


var $j39Hd = parcelRequire("j39Hd");


var $ixC10 = parcelRequire("ixC10");


var $cXJjm = parcelRequire("cXJjm");


var $grief = parcelRequire("grief");


var $2g31M = parcelRequire("2g31M");


var $ggGdk = parcelRequire("ggGdk");


var $iDrrr = parcelRequire("iDrrr");


var $c2kDy = parcelRequire("c2kDy");


var $44Sj0 = parcelRequire("44Sj0");

const $614b823604b25d0c$var$MAX_BATCH_SIZE = 50;
const $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE = 100;
const $614b823604b25d0c$export$d6a66073b5d79eb3 = new (0, $lPEt0.LRUMap)($614b823604b25d0c$var$URL_RESPONSE_CACHE_SIZE);
const $614b823604b25d0c$var$urlResponseInFlightCache = new Map();
class $614b823604b25d0c$export$2e2bcd8739ae039 {
    setProduct(product) {
        this.product = product;
    }
    /**
   * Set custom headers to be sent with each request to the resolver.
   *
   * @param headers - Object containing headers to be sent with each request.
   */ setHeaders(headers) {
        this.headers = headers;
    }
    createUrlLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($axuex)))({
            limit: 1,
            interval: $614b823604b25d0c$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolveUrl);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $614b823604b25d0c$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolveUrl`.
            cache: false
        });
    }
    getUrlLoader(hostname) {
        if (!this.urlLoadersByDomain[hostname]) this.urlLoadersByDomain[hostname] = this.createUrlLoader();
        return this.urlLoadersByDomain[hostname];
    }
    getHostName(url) {
        try {
            return new URL(url).hostname;
        } catch (error) {
            throw new (0, $grief.InvalidUrlError)(error);
        }
    }
    async resolveUrlWithoutInlineOptimization(url, hostname, force) {
        let responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            const urlLoader = this.getUrlLoader(hostname);
            responsePromise = urlLoader.load({
                resourceUrl: url,
                ignoreCachedValue: force || undefined
            });
            $614b823604b25d0c$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async resolveUrlWithInlineOptimization(url, hostname, force, appearance) {
        const cacheKey = `${url}|${appearance}`;
        const inFlightCacheKey = JSON.stringify([
            url,
            appearance,
            force
        ]);
        let responsePromise = $614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey);
        if (!responsePromise) {
            responsePromise = $614b823604b25d0c$export$d6a66073b5d79eb3.get(cacheKey);
            if (!responsePromise || force) {
                const urlLoader = this.getUrlLoader(hostname);
                responsePromise = urlLoader.load({
                    resourceUrl: url,
                    ignoreCachedValue: force || undefined,
                    appearance: appearance
                });
                $614b823604b25d0c$export$d6a66073b5d79eb3.set(cacheKey, responsePromise);
                $614b823604b25d0c$var$urlResponseInFlightCache.set(inFlightCacheKey, responsePromise);
            }
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
            throw e;
        } finally{
            if ($614b823604b25d0c$var$urlResponseInFlightCache.get(inFlightCacheKey) === responsePromise) $614b823604b25d0c$var$urlResponseInFlightCache.delete(inFlightCacheKey);
        }
        const isUnresolvedLink = !(0, $44Sj0.isSuccessfulResponse)(response) || (0, $ggGdk.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $614b823604b25d0c$export$d6a66073b5d79eb3.delete(cacheKey);
        return response;
    }
    async resolveUrl(url, force = false, appearance) {
        const hostname = this.getHostName(url);
        if (appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return this.resolveUrlWithInlineOptimization(url, hostname, force, appearance);
        return this.resolveUrlWithoutInlineOptimization(url, hostname, force);
    }
    async prefetchData(url, appearance) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false, appearance);
        if ((0, $44Sj0.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false, appearance);
                    if ((0, $44Sj0.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch  {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $c2kDy.isErrorResponse)(response) && response.error.status === 429;
    }
    /**
   * Fetch data from URL
   * @param url - The URL to fetch data for
   * @param force - Whether to force a fresh fetch, bypassing cache
   * @param appearance - Card appearance hint for ORS to optimize response payload.
   *                     When 'inline', ORS returns minimal data (title, status).
   *                     When 'block' or 'embed', ORS returns full data including summary.
   */ async fetchData(url, force, appearance) {
        let response = await this.resolveUrl(url, force, appearance);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($QO4PV)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false, appearance);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $44Sj0.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
   * Fetch data for multiple ARIs (batch) in one operation
   * @param aris Array of ARIs to fetch data for
   */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
   * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
   * spec.
   * @param data Payload including the search provider key and query. An empty search query string
   * results in recent results being returned (pre-query).
   * @returns JsonLd collection of search results.
   */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $c2kDy.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $j39Hd.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $2g31M.NetworkError)) return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                case 'BadRequestError':
                    return new (0, $ixC10.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                case 'AuthError':
                    return new (0, $ixC10.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                case 'UnsupportedError':
                    // URL isn't supported
                    return new (0, $ixC10.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                case 'TimeoutError':
                case 'RateLimitError':
                    return new (0, $ixC10.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $ixC10.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
   * This method will strigify both enumerable and  non enumerable properties of an object
   * @param err
   * @returns object serialized to JSON with both enumerable and non enumerable objects
   */ stringifyError(err) {
        /**
     * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
     * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
     * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
     */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
    constructor(envKey, baseUrlOverride){
        this.resolverUrl = void 0;
        this.envKey = void 0;
        this.baseUrlOverride = void 0;
        this.urlLoadersByDomain = void 0;
        this.retryConfig = void 0;
        this.resolvedCache = void 0;
        this.product = void 0;
        this.headers = void 0;
        this.postBatchResolveNew = async (resources, resourceType, keyGetter)=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = (0, (/*@__PURE__*/$parcel$interopDefault($iKWdo)))(resources, keyGetter);
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ?? {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources, headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources, headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[keyGetter(resource)] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[keyGetter(originalResource)]);
        };
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createUrlLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
         * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
         * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
         */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone,
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {},
                // add custom headers if defined
                ...this.headers ? this.headers : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $j39Hd.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $c2kDy.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        this.batchResolveUrl = async (urls)=>{
            return this.postBatchResolveNew(urls, 'URL', (resource)=>{
                // Appearance is only added to the payload when the inline resolve optimization gate is on.
                // Preserve differently shaped requests for the same URL so a reduced inline response cannot
                // be returned to a block request from the same batch.
                if (resource.appearance !== undefined && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return JSON.stringify([
                    resource.resourceUrl,
                    resource.appearance,
                    resource.ignoreCachedValue === true
                ]);
                return resource.resourceUrl;
            });
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.urlLoadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
}
module.exports["default"] = $614b823604b25d0c$export$2e2bcd8739ae039;

});

parcelRegister("QO4PV", function(module, exports) {
// Packages

var $lbZ9z = parcelRequire("lbZ9z");

function $09ebb3b1b19cd625$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        var op;
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        op = $lbZ9z.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $09ebb3b1b19cd625$var$retry;

});

parcelRegister("lbZ9z", function(module, exports) {

module.exports = (parcelRequire("4co4r"));

});

parcelRegister("4co4r", function(module, exports) {

var $8xi9I = parcelRequire("8xi9I");

exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $8xi9I(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});

parcelRegister("8xi9I", function(module, exports) {
function $636f7d2929f63478$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $636f7d2929f63478$var$RetryOperation;
$636f7d2929f63478$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
$636f7d2929f63478$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$636f7d2929f63478$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$636f7d2929f63478$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$636f7d2929f63478$var$RetryOperation.prototype.start = $636f7d2929f63478$var$RetryOperation.prototype.try;
$636f7d2929f63478$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$636f7d2929f63478$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$636f7d2929f63478$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});

parcelRegister("6Q8Dd", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");

"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $4fae4b715d22864c$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $4fae4b715d22864c$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $4fae4b715d22864c$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $4fae4b715d22864c$var$getValidCacheKeyFn(options);
        this._cacheMap = $4fae4b715d22864c$var$getValidCacheMap(options);
        this._batch = null;
        this.name = $4fae4b715d22864c$var$getValidName(options);
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value, ' + ("but got: " + String(key) + "."));
        var batch = $4fae4b715d22864c$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey; // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            cacheKey = this._cacheKeyFn(key);
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    };
    _proto.loadMany = function loadMany(keys) {
        if (!$4fae4b715d22864c$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    };
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    };
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    };
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $4fae4b715d22864c$var$enqueuePostPromiseJob = typeof $1P2f3 === 'object' && typeof $1P2f3.nextTick === 'function' ? function(fn) {
    if (!$4fae4b715d22864c$var$resolvedPromise) $4fae4b715d22864c$var$resolvedPromise = Promise.resolve();
    $4fae4b715d22864c$var$resolvedPromise.then(function() {
        $1P2f3.nextTick(fn);
    });
} : typeof setImmediate === 'function' ? function(fn) {
    setImmediate(fn);
} : function(fn) {
    setTimeout(fn);
}; // Private: cached resolved Promise instance
var $4fae4b715d22864c$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $4fae4b715d22864c$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        $4fae4b715d22864c$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $4fae4b715d22864c$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $4fae4b715d22864c$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise;
    try {
        batchPromise = loader._batchLoadFn(batch.keys);
    } catch (e) {
        return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(e) + ".")));
    } // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $4fae4b715d22864c$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$4fae4b715d22864c$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $4fae4b715d22864c$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var _value = values[i];
            if (_value instanceof Error) batch.callbacks[i].reject(_value);
            else batch.callbacks[i].resolve(_value);
        }
    })["catch"](function(error) {
        $4fae4b715d22864c$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $4fae4b715d22864c$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $4fae4b715d22864c$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $4fae4b715d22864c$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $4fae4b715d22864c$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $4fae4b715d22864c$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $4fae4b715d22864c$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $4fae4b715d22864c$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $4fae4b715d22864c$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
}
function $4fae4b715d22864c$var$getValidName(options) {
    if (options && options.name) return options.name;
    return null;
} // Private
function $4fae4b715d22864c$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $4fae4b715d22864c$var$DataLoader;

});

parcelRegister("iKWdo", function(module, exports) {

var $j6gAQ = parcelRequire("j6gAQ");


var $1Rned = parcelRequire("1Rned");

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $da79ae2b1521df52$var$uniqBy(array, iteratee) {
    return array && array.length ? $1Rned(array, $j6gAQ(iteratee, 2)) : [];
}
module.exports = $da79ae2b1521df52$var$uniqBy;

});

parcelRegister("1Rned", function(module, exports) {

var $dLza3 = parcelRequire("dLza3");


var $gqaVn = parcelRequire("gqaVn");


var $3wyDU = parcelRequire("3wyDU");


var $jG16D = parcelRequire("jG16D");


var $4sYWJ = parcelRequire("4sYWJ");


var $j8WYy = parcelRequire("j8WYy");

/** Used as the size to enable large array optimizations. */ var $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $15acc2503c30cdc7$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $gqaVn, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $3wyDU;
    } else if (length >= $15acc2503c30cdc7$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $4sYWJ(array);
        if (set) return $j8WYy(set);
        isCommon = false;
        includes = $jG16D;
        seen = new $dLza3;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $15acc2503c30cdc7$var$baseUniq;

});

parcelRegister("gqaVn", function(module, exports) {

var $62lK8 = parcelRequire("62lK8");

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $bf478c6b28a93eba$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $62lK8(array, value, 0) > -1;
}
module.exports = $bf478c6b28a93eba$var$arrayIncludes;

});

parcelRegister("62lK8", function(module, exports) {

var $7jN2X = parcelRequire("7jN2X");


var $4Jcz7 = parcelRequire("4Jcz7");


var $jMyMb = parcelRequire("jMyMb");

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $4653cbb84a510850$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $jMyMb(array, value, fromIndex) : $7jN2X(array, $4Jcz7, fromIndex);
}
module.exports = $4653cbb84a510850$var$baseIndexOf;

});

parcelRegister("7jN2X", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $55405a69ad8b093d$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $55405a69ad8b093d$var$baseFindIndex;

});

parcelRegister("4Jcz7", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $37151c9a2b945fe4$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $37151c9a2b945fe4$var$baseIsNaN;

});

parcelRegister("jMyMb", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $e66d79db7455d8ea$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $e66d79db7455d8ea$var$strictIndexOf;

});

parcelRegister("3wyDU", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $290f3b94ccd981c7$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $290f3b94ccd981c7$var$arrayIncludesWith;

});

parcelRegister("4sYWJ", function(module, exports) {

var $lE8ES = parcelRequire("lE8ES");


var $jEK83 = parcelRequire("jEK83");


var $j8WYy = parcelRequire("j8WYy");

/** Used as references for various `Number` constants. */ var $34090d9ff4ab3dd6$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $34090d9ff4ab3dd6$var$createSet = !($lE8ES && 1 / $j8WYy(new $lE8ES([
    ,
    -0
]))[1] == $34090d9ff4ab3dd6$var$INFINITY) ? $jEK83 : function(values) {
    return new $lE8ES(values);
};
module.exports = $34090d9ff4ab3dd6$var$createSet;

});

parcelRegister("jEK83", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $e4f588fe3a77f67d$var$noop() {
// No operation performed.
}
module.exports = $e4f588fe3a77f67d$var$noop;

});

parcelRegister("lPEt0", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
}); //# sourceMappingURL=lru.js.map

});

parcelRegister("axuex", function(module, exports) {
'use strict';
class $7ac4702e317338af$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $7ac4702e317338af$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $7ac4702e317338af$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $7ac4702e317338af$var$pThrottle;
module.exports.AbortError = $7ac4702e317338af$var$AbortError;

});

parcelRegister("j39Hd", function(module, exports) {

var $2g31M = parcelRequire("2g31M");

const $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
async function $53f448a1a60c9e76$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $53f448a1a60c9e76$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new (0, $2g31M.NetworkError)(error);
        throw error;
    }
}
module.exports["request"] = $53f448a1a60c9e76$export$b5fe3f66a567bec0;

});

parcelRegister("2g31M", function(module, exports) {
class $70283a430bb4f4fe$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
module.exports["NetworkError"] = $70283a430bb4f4fe$export$bae979e68e4dc802;

});

parcelRegister("ixC10", function(module, exports) {
class $5661a24319617f8d$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
module.exports["APIError"] = $5661a24319617f8d$export$3e5b797e39668f84;

});

parcelRegister("cXJjm", function(module, exports) {

var $kzwaO = parcelRequire("kzwaO");

const $aee62c7b870e0d6a$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? '/gateway/api/object-resolver';
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
module.exports["getResolverUrl"] = $aee62c7b870e0d6a$export$dc37652c1696f231;

});

parcelRegister("kzwaO", function(module, exports) {

var $4B79C = parcelRequire("4B79C");

const $445f8294ba7508fe$export$f654b28f82155665 = (envKey, baseUrlOverride)=>{
    // The `custom` environment is used if the full resolver URL is provided by the user.
    // It could be useful for SSR, where `CardClient` should use direct service URL instead of the Edge Proxy.
    if (envKey === 'custom') return baseUrlOverride ?? (0, $4B79C.prodBaseUrl);
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in (0, $4B79C.BaseUrls) ? (0, $4B79C.BaseUrls)[envKey] : (0, $4B79C.prodBaseUrl);
    return typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.origin : '';
};
module.exports["getBaseUrl"] = $445f8294ba7508fe$export$f654b28f82155665;

});

parcelRegister("4B79C", function(module, exports) {
const $ef9de7657ea9d2d2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $ef9de7657ea9d2d2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $ef9de7657ea9d2d2$export$7469f9cd9cda802c = 'https://api-private.atlassian.com';
const $ef9de7657ea9d2d2$export$e2b040f052407032 = {
    dev: $ef9de7657ea9d2d2$var$devBaseUrl,
    development: $ef9de7657ea9d2d2$var$devBaseUrl,
    stg: $ef9de7657ea9d2d2$var$stgBaseUrl,
    staging: $ef9de7657ea9d2d2$var$stgBaseUrl,
    prd: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    prod: $ef9de7657ea9d2d2$export$7469f9cd9cda802c,
    production: $ef9de7657ea9d2d2$export$7469f9cd9cda802c
};
var $ef9de7657ea9d2d2$export$2e2bcd8739ae039 = $ef9de7657ea9d2d2$export$e2b040f052407032;
module.exports["prodBaseUrl"] = $ef9de7657ea9d2d2$export$7469f9cd9cda802c;
module.exports["BaseUrls"] = $ef9de7657ea9d2d2$export$e2b040f052407032;

});

parcelRegister("grief", function(module, exports) {
class $8165f67089b396cb$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
module.exports["InvalidUrlError"] = $8165f67089b396cb$export$19fa02dd69bd4efd;

});

parcelRegister("ggGdk", function(module, exports) {
const $b75c372cb2906748$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $b75c372cb2906748$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $b75c372cb2906748$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $b75c372cb2906748$export$b70265791d2079d4;

});

parcelRegister("c2kDy", function(module, exports) {
const $3cbc4520680d3a92$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};
module.exports["isErrorResponse"] = $3cbc4520680d3a92$export$bea7bee8a87e7c52;

});

parcelRegister("44Sj0", function(module, exports) {
const $d86f0936ed92dc7f$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
module.exports["isSuccessfulResponse"] = $d86f0936ed92dc7f$export$1b59fe731a28a49d;

});

parcelRegister("3eDML", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $5Z14v = parcelRequire("5Z14v");


var $g6IOz = parcelRequire("g6IOz");

const $a28e4467baac2569$var$styles = {
    image: "_39xV02ztyp",
    root: "_0jFU0VN91d _1wydGWGXk2",
    content: "_2fwxA5DIqT _1EqgXl06U0"
};
const $a28e4467baac2569$export$5d76009b056f3e5d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ $cozmU.createElement("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($5Z14v))),
            alt: "error page",
            className: (0, $hekY6.default)([
                $a28e4467baac2569$var$styles.image
            ])
        });
        t1 = (0, $hekY6.default)([
            $a28e4467baac2569$var$styles.content
        ]);
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xlarge"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $g6IOz.default).genericErrorHeading));
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            alignInline: "center",
            space: "space.200",
            alignBlock: "center",
            xcss: $a28e4467baac2569$var$styles.root
        }, t0, /*#__PURE__*/ $cozmU.createElement("div", {
            className: t1
        }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            space: "space.200"
        }, t2, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $g6IOz.default).genericErrorDescription)))));
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : ()=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        alignInline: "center",
        space: "space.200",
        alignBlock: "center",
        xcss: $a28e4467baac2569$var$styles.root
    }, /*#__PURE__*/ $cozmU.createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($5Z14v))),
        alt: "error page",
        className: (0, $hekY6.default)([
            $a28e4467baac2569$var$styles.image
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $a28e4467baac2569$var$styles.content
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xlarge"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $g6IOz.default).genericErrorHeading)), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $g6IOz.default).genericErrorDescription)))));
};
module.exports["GenericErrorPage"] = $a28e4467baac2569$export$5d76009b056f3e5d;

});

parcelRegister("5Z14v", function(module, exports) {
module.exports = new URL("error-icon.fcea7b28.svg", import.meta.url).toString();

});

parcelRegister("g6IOz", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $d73abe7c8884822c$var$_default_1 = (0, $kSwu1.defineMessages)({
    genericErrorHeading: {
        id: "company-hub.generic-error-page.heading",
        defaultMessage: "We're on it"
    },
    genericErrorDescription: {
        id: "company-hub.generic-error-page.description",
        defaultMessage: "An unexpected error has occured when processing your request. Our team is working to get things back up and running."
    }
});
var $d73abe7c8884822c$export$2e2bcd8739ae039 = $d73abe7c8884822c$var$_default_1;
module.exports["default"] = $d73abe7c8884822c$export$2e2bcd8739ae039;

});

parcelRegister("ame4Z", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $iDrrr = parcelRequire("iDrrr");


var $h6BA0 = parcelRequire("h6BA0");


var $kFTt2 = parcelRequire("kFTt2");


var $6qzJ0 = parcelRequire("6qzJ0");


var $5o2Ge = parcelRequire("5o2Ge");

const $254f47a48ddd9760$var$isFetchClientError = (err)=>{
    return err?.status < 500;
};
const $254f47a48ddd9760$export$ba2f52e216142b3d = ({ children: children, packageName: packageName, id: id, fallback: fallback, shouldForceError: shouldForceError, operationNames: operationNames })=>{
    const logError = (0, $h6BA0.useUFOReportError)();
    const observeError = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $5o2Ge.HubErrorObserverContext));
    const onError = (error)=>{
        if ($254f47a48ddd9760$var$isFetchClientError(error)) // skip fetch client error e.g. 4xx
        return;
        if ((0, $iDrrr.fg)('help_center_hub_premium_sla_metrics')) observeError?.({
            error: error,
            id: id,
            packageName: packageName,
            shouldForceError: shouldForceError
        });
        // react-ufo does not expose a dedicated traceId/attribute field, so the trace ID is
        // appended to the error message. fireErrorAnalytics additionally receives it as an attribute.
        let traceId;
        if (operationNames && (0, $iDrrr.fg)('hub_error_analytics_trace_id')) {
            const traceIds = operationNames.flatMap((name)=>(0, $6qzJ0.getTraceIds)(name));
            traceId = traceIds.find(Boolean);
        }
        // Fire additional error analytics
        try {
            // Log rUFO error metrics
            logError({
                name: error.name,
                errorMessage: traceId ? `${error.message} (traceId: ${traceId})` : error.message,
                errorStack: error.stack,
                forcedError: shouldForceError
            });
            (0, $kFTt2.default)({
                error: error,
                meta: {
                    id: id,
                    packageName: packageName
                },
                attributes: traceId ? {
                    traceId: traceId
                } : undefined
            });
        } catch (err) {
            // Added to silently fail Uncaught ReferenceError: __SERVER__ is not defined
            // eslint-disable-next-line no-console
            console.warn('Failed to fire error analytics:', err);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        onError: onError,
        fallback: fallback
    }, children);
};
module.exports["HubErrorBoundary"] = $254f47a48ddd9760$export$ba2f52e216142b3d;

});

parcelRegister("kFTt2", function(module, exports) {

var $huGTe = parcelRequire("huGTe");


var $66Bcq = parcelRequire("66Bcq");


var $k8V2e = parcelRequire("k8V2e");


var $hcOES = parcelRequire("hcOES");


var $lIkvQ = parcelRequire("lIkvQ");

let $1fc2285692461264$var$analyticsClient;
const $1fc2285692461264$export$d4079397f9611138 = (client)=>{
    $1fc2285692461264$var$analyticsClient = client;
};
const $1fc2285692461264$export$bf406c01a195b215 = ()=>{
    $1fc2285692461264$var$analyticsClient = undefined;
};
const $1fc2285692461264$var$fireErrorAnalytics = ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes })=>{
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (__SERVER__) {
        if (error) throw error;
        else {
            const payload = event && (0, $k8V2e.extractAWCDataFromEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: attributes
            }));
        }
    }
    const fullAnalyticsId = `${packageName}.${id}`;
    if (error) {
        const details = (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
            ...attributes,
            packageName: packageName,
            teamName: teamName,
            errorInfo: errorInfo
        }, (0, (/*@__PURE__*/$parcel$interopDefault($huGTe))));
        if (event && event.context) {
            const fullEvent = (0, $k8V2e.extractAWCDataFromEvent)(event);
            (0, $lIkvQ.captureException)(fullAnalyticsId, error, {
                ...details,
                ...fullEvent.payload
            });
        } else (0, $lIkvQ.captureException)(fullAnalyticsId, error, details);
    }
    if (event && event.handlers && event.handlers.length > 0) {
        const attrs = attributes || {};
        (0, $hcOES.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else //Allow this to pass in a promise so that we can avoid blocking render for firing these events.
    if ($1fc2285692461264$var$analyticsClient && $1fc2285692461264$var$analyticsClient.sendOperationalEvent) {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: attributes
        };
        $1fc2285692461264$var$analyticsClient.sendOperationalEvent(gasV3Event);
    } else {
        const analyticsClientUninitialisedError = new Error("Analytics client hasn't been initialised, unable to fire error operational event");
        (0, $lIkvQ.captureException)(fullAnalyticsId, analyticsClientUninitialisedError);
    }
};
const $1fc2285692461264$export$706c486c6b5abdfb = async ({ error: error, id: id, packageName: packageName })=>{
    if (error.statusCode) {
        const { statusCode: statusCode } = error;
        let statusCodeGroup;
        if (statusCode >= 300 && statusCode < 400) statusCodeGroup = '3xx';
        else if (statusCode >= 400 && statusCode < 500) statusCodeGroup = '4xx';
        else if (statusCode >= 500 && statusCode < 600) statusCodeGroup = '5xx';
        else statusCodeGroup = 'unknown';
        await $1fc2285692461264$var$fireErrorAnalytics({
            meta: {
                id: id,
                packageName: packageName
            },
            attributes: {
                statusCodeGroup: statusCodeGroup
            }
        });
    } else await $1fc2285692461264$var$fireErrorAnalytics({
        error: error,
        meta: {
            id: id,
            packageName: packageName
        }
    });
};
var $1fc2285692461264$export$2e2bcd8739ae039 = $1fc2285692461264$var$fireErrorAnalytics;
module.exports["default"] = $1fc2285692461264$export$2e2bcd8739ae039;

});

parcelRegister("huGTe", function(module, exports) {

var $4rtI4 = parcelRequire("4rtI4");


var $jOCrv = parcelRequire("jOCrv");


var $bZ5J1 = parcelRequire("bZ5J1");


var $1ScXu = parcelRequire("1ScXu");


var $9pMwd = parcelRequire("9pMwd");


var $6DVFM = parcelRequire("6DVFM");


var $bAfjw = parcelRequire("bAfjw");


var $5J1xO = parcelRequire("5J1xO");

/** `Object#toString` result references. */ var $cbc68209f80e3755$var$mapTag = '[object Map]', $cbc68209f80e3755$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $cbc68209f80e3755$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $cbc68209f80e3755$var$hasOwnProperty = $cbc68209f80e3755$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $cbc68209f80e3755$var$isEmpty(value) {
    if (value == null) return true;
    if ($9pMwd(value) && ($1ScXu(value) || typeof value == 'string' || typeof value.splice == 'function' || $6DVFM(value) || $5J1xO(value) || $bZ5J1(value))) return !value.length;
    var tag = $jOCrv(value);
    if (tag == $cbc68209f80e3755$var$mapTag || tag == $cbc68209f80e3755$var$setTag) return !value.size;
    if ($bAfjw(value)) return !$4rtI4(value).length;
    for(var key in value){
        if ($cbc68209f80e3755$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $cbc68209f80e3755$var$isEmpty;

});

parcelRegister("k8V2e", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $emZLc = parcelRequire("emZLc");


var $66Bcq = parcelRequire("66Bcq");


var $jYwtP = parcelRequire("jYwtP");


var $8El2z = parcelRequire("8El2z");

const $035dbde6912e4d4c$export$1c850cf68c053906 = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const analyticsType = (0, $8El2z.getAnalyticsType)(castedEvent);
    const attributes = (0, $8El2z.getAttributes)(castedEvent);
    const source = (0, $8El2z.getSource)(castedEvent);
    const actionSubject = (0, $8El2z.getActionSubject)(castedEvent);
    if (analyticsType === (0, $jYwtP.SCREEN_EVENT_TYPE)) return {
        type: (0, $jYwtP.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes
        }
    };
    switch(analyticsType){
        case 0, $jYwtP.UI_EVENT_TYPE:
        case 0, $jYwtP.TRACK_EVENT_TYPE:
        case 0, $jYwtP.OPERATIONAL_EVENT_TYPE:
            {
                const action = (0, $8El2z.getAction)(castedEvent);
                const actionSubjectId = (0, $8El2z.getActionSubjectId)(castedEvent);
                const containerId = (0, $8El2z.getContainerId)(castedEvent);
                const containerType = (0, $8El2z.getContainerType)(castedEvent);
                const objectId = (0, $8El2z.getObjectId)(castedEvent);
                const objectType = (0, $8El2z.getObjectType)(castedEvent);
                const tags = (0, $8El2z.getTags)(castedEvent);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerType: containerType,
                        containerId: containerId,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes
                },
                type: undefined
            };
    }
};
module.exports["extractAWCDataFromEvent"] = $035dbde6912e4d4c$export$1c850cf68c053906;

});

parcelRegister("emZLc", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a763071343fcb354$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a763071343fcb354$var$isUndefined;

});

parcelRegister("jYwtP", function(module, exports) {
const $fec988d562d5bfbb$export$f636b5b56f1d624a = 'Screen';
const $fec988d562d5bfbb$export$9d2de6eebf7462b5 = 'Drawer';
const $fec988d562d5bfbb$export$1171103ea9083ffa = 'Modal';
const $fec988d562d5bfbb$export$cae2783c9279926 = 'InlineDialog';
const $fec988d562d5bfbb$export$d1123261ca8831d2 = 'Dropdown';
const $fec988d562d5bfbb$export$a1562d08625f5d7e = 'UI';
const $fec988d562d5bfbb$export$947dac6c72b26f81 = 'TRACK';
const $fec988d562d5bfbb$export$f1d537d508d2945a = 'SCREEN';
const $fec988d562d5bfbb$export$12346a674644c156 = 'OPERATIONAL';
const $fec988d562d5bfbb$export$2ceccf177fae277c = 'analyticsBridge';
module.exports["SCREEN"] = $fec988d562d5bfbb$export$f636b5b56f1d624a;
module.exports["MODAL"] = $fec988d562d5bfbb$export$1171103ea9083ffa;
module.exports["UI_EVENT_TYPE"] = $fec988d562d5bfbb$export$a1562d08625f5d7e;
module.exports["TRACK_EVENT_TYPE"] = $fec988d562d5bfbb$export$947dac6c72b26f81;
module.exports["SCREEN_EVENT_TYPE"] = $fec988d562d5bfbb$export$f1d537d508d2945a;
module.exports["OPERATIONAL_EVENT_TYPE"] = $fec988d562d5bfbb$export$12346a674644c156;
module.exports["ANALYTICS_BRIDGE_CHANNEL"] = $fec988d562d5bfbb$export$2ceccf177fae277c;

});

parcelRegister("8El2z", function(module, exports) {

var $lyW2B = parcelRequire("lyW2B");


var $emZLc = parcelRequire("emZLc");


var $gO1os = parcelRequire("gO1os");


var $lYpJw = parcelRequire("lYpJw");


var $66Bcq = parcelRequire("66Bcq");


var $1wIeS = parcelRequire("1wIeS");

const $c9f6533ef6431d6e$var$extractFromContext = (event, property)=>event.context.map((item)=>item[property]);
const $c9f6533ef6431d6e$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $c9f6533ef6431d6e$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $c9f6533ef6431d6e$var$extractFromContext(event, 'attributes');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(contextAttributes.reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($lYpJw)))(result, extraAttributes), {}), payloadAttributes);
    const sources = $c9f6533ef6431d6e$var$extractFromContext(event, 'source');
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($66Bcq)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($emZLc))));
};
const $c9f6533ef6431d6e$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'source').filter(Boolean));
const $c9f6533ef6431d6e$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $c9f6533ef6431d6e$export$6ca3170acb89054 = (event)=>event.payload.action;
const $c9f6533ef6431d6e$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $c9f6533ef6431d6e$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerId').filter(Boolean));
const $c9f6533ef6431d6e$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'containerType').filter(Boolean));
const $c9f6533ef6431d6e$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectId').filter(Boolean));
const $c9f6533ef6431d6e$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))($c9f6533ef6431d6e$var$extractFromContext(event, 'objectType').filter(Boolean));
const $c9f6533ef6431d6e$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))((0, (/*@__PURE__*/$parcel$interopDefault($lyW2B)))($c9f6533ef6431d6e$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
module.exports["getAnalyticsType"] = $c9f6533ef6431d6e$export$a3569ac53b82a914;
module.exports["getAttributes"] = $c9f6533ef6431d6e$export$fe94072fee8a6976;
module.exports["getSource"] = $c9f6533ef6431d6e$export$dd2b6e807fb37ba3;
module.exports["getActionSubject"] = $c9f6533ef6431d6e$export$6f40cdf6d42c018d;
module.exports["getAction"] = $c9f6533ef6431d6e$export$6ca3170acb89054;
module.exports["getActionSubjectId"] = $c9f6533ef6431d6e$export$b6f8db3ad0711b02;
module.exports["getContainerId"] = $c9f6533ef6431d6e$export$7c8178cc9001d237;
module.exports["getContainerType"] = $c9f6533ef6431d6e$export$acc6f3e19803b3dc;
module.exports["getObjectId"] = $c9f6533ef6431d6e$export$fa986b91291934c7;
module.exports["getObjectType"] = $c9f6533ef6431d6e$export$11cc42aebef2ef3a;
module.exports["getTags"] = $c9f6533ef6431d6e$export$af63d7414243dad3;

});

parcelRegister("1wIeS", function(module, exports) {

var $1Rned = parcelRequire("1Rned");

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $11cb188fd562c44b$var$uniq(array) {
    return array && array.length ? $1Rned(array) : [];
}
module.exports = $11cb188fd562c44b$var$uniq;

});

parcelRegister("hcOES", function(module, exports) {

var $gO1os = parcelRequire("gO1os");


var $jYwtP = parcelRequire("jYwtP");


var $5sm3M = parcelRequire("5sm3M");

const $2b7c6f2b383d7d91$export$34ac71ce24cddec2 = (event, type, payload)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    const clonedEvent = castedEvent.clone();
    if (!clonedEvent) throw new Error("Cannot clone an event after it's been fired.");
    clonedEvent.update({
        ...payload,
        analyticsType: type
    }).fire((0, $jYwtP.ANALYTICS_BRIDGE_CHANNEL));
};
const $2b7c6f2b383d7d91$var$getActionSubjectFromContext = (event)=>{
    // TODO: the distinction between AnalyticsEvent and UIAnalyticsEvent is all odd in AK and needs to be understood better
    const castedEvent = event;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gO1os)))(castedEvent.context.map((i)=>i.component || i.componentName).filter(Boolean));
};
const $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in UI event');
    const { action: argumentsAction, actionSubject: argumentsActionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    const castedEvent = event;
    const action = event.payload && event.payload.action || argumentsAction;
    const actionSubject = event.payload && event.payload.actionSubject || argumentsActionSubject || $2b7c6f2b383d7d91$var$getActionSubjectFromContext(castedEvent);
    if (!action) throw new Error('Mandatory "action" field is missing from UI event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from UI event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.UI_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$13990ad4625571ed = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Track event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Track event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Track event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.TRACK_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$79f423cc3fd39762 = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Operational event');
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    if (!action) throw new Error('Mandatory "action" field is missing from Operational event');
    if (!actionSubject) throw new Error('Mandatory "actionSubject" field is missing from Operational event');
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.OPERATIONAL_EVENT_TYPE), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $2b7c6f2b383d7d91$export$6f46fb37ad7d962b = (event, ...rest)=>{
    if (!event.clone) throw new Error('There is no analytics event from Atlaskit in Screen event');
    const { attributes: attributes } = (0, $5sm3M.getImperativeAnalyticsDataFromArguments)(rest);
    $2b7c6f2b383d7d91$export$34ac71ce24cddec2(event, (0, $jYwtP.SCREEN_EVENT_TYPE), {
        attributes: attributes
    });
};
module.exports["fireAnalytics"] = $2b7c6f2b383d7d91$export$34ac71ce24cddec2;
module.exports["fireUIAnalytics"] = $2b7c6f2b383d7d91$export$5d00cd31b1bf8e94;
module.exports["fireTrackAnalytics"] = $2b7c6f2b383d7d91$export$13990ad4625571ed;
module.exports["fireOperationalAnalytics"] = $2b7c6f2b383d7d91$export$79f423cc3fd39762;

});

parcelRegister("5sm3M", function(module, exports) {
const $8f4a194f3d46df20$var$extractDataFromStringAttribute = (string)=>{
    const arr = string.split(' ');
    switch(arr.length){
        case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $8f4a194f3d46df20$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
    if (typeof one === 'object') return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromTwoAttribute = (one, two)=>{
    if (typeof one === 'string' && typeof two === 'string') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    if (typeof one === 'string' && typeof two === 'object') {
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: two
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$var$extractDataFromThreeAttribute = (one, two, three)=>{
    if (typeof one === 'string' && typeof two === 'string' && typeof three === 'object') {
        const { action: action, actionSubject: actionSubject } = $8f4a194f3d46df20$var$extractDataFromStringAttribute(one);
        const actionSubjectId = two;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: three
        };
    }
    throw Error('Event of this type is not supported');
};
const $8f4a194f3d46df20$export$e6baab532ef8c6bf = (args)=>{
    switch(args.length){
        case 0:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: undefined,
                attributes: undefined
            };
        case 1:
            return $8f4a194f3d46df20$var$extractDataFromOneAttribute(args[0]);
        case 2:
            return $8f4a194f3d46df20$var$extractDataFromTwoAttribute(args[0], args[1]);
        case 3:
            return $8f4a194f3d46df20$var$extractDataFromThreeAttribute(args[0], args[1], args[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
module.exports["getImperativeAnalyticsDataFromArguments"] = $8f4a194f3d46df20$export$e6baab532ef8c6bf;

});

parcelRegister("lIkvQ", function(module, exports) {

var $l54O9 = parcelRequire("l54O9");

const $34ee97725f8181a5$export$7da675e3dd1bd6b5 = (sentryUrl, config, getExtraContext)=>(0, $l54O9.default).installGlobalHandler(sentryUrl, config, getExtraContext);
const $34ee97725f8181a5$export$f5282963edea4a68 = (location, error, details = {})=>(0, $l54O9.default).captureException(location, error, details);
module.exports["captureException"] = $34ee97725f8181a5$export$f5282963edea4a68;

});

parcelRegister("l54O9", function(module, exports) {
// This is the only file that should directly import Raven.

var $9HPf3 = parcelRequire("9HPf3");

var $amM2J = parcelRequire("amM2J");

var $eAdCn = parcelRequire("eAdCn");


var $iyIOY = parcelRequire("iyIOY");

var $6W0Xl = parcelRequire("6W0Xl");

var $fa95z = parcelRequire("fa95z");

var $hLq0X = parcelRequire("hLq0X");


var $1wIeS = parcelRequire("1wIeS");

const $15510fe24ae0eb31$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = [];
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.push(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    const distinctfragmentNames = (0, (/*@__PURE__*/$parcel$interopDefault($1wIeS)))(fragmentNames);
    return distinctfragmentNames;
};
// Add custom tags based on stack trace
const $15510fe24ae0eb31$var$getTaggedData = (data, hint)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    const fragmentNames = $15510fe24ae0eb31$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    return taggedData;
};
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
const $15510fe24ae0eb31$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
const $15510fe24ae0eb31$var$installGlobalHandler = (sentryUrl, config, getExtraContext)=>{
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = $amM2J.getCurrentHub().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    const defaultConfig = {
        dsn: sentryUrl,
        environment: "production",
        // This adds our tags to the data sent to sentry
        beforeSend: (event, hint)=>{
            // Yes, we're mutating the argument, but at this point in the error handling lifecycle
            // immutability is not important and it simplifies the logic
            // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
            const extraBeforeSend = config.beforeSend || (()=>null);
            let updatedData = extraBeforeSend(event, hint);
            updatedData = $15510fe24ae0eb31$var$getTaggedData(updatedData, hint);
            return updatedData;
        },
        //Integration typing doesn't seem to work well so I'm just typing it to any
        integrations: (integrations)=>[
                ...$15510fe24ae0eb31$var$getFilteredIntegrations(integrations),
                new $6W0Xl.Dedupe(),
                new $fa95z.ExtraErrorData(),
                new $hLq0X.Transaction(),
                new $iyIOY.CaptureConsole({
                    levels: [
                        'error'
                    ]
                }),
                // not supporting the case where config.integrations is a function that returns an array
                ...config.integrations && config.integrations instanceof Array ? config.integrations : []
            ]
    };
    // Because we don't want to completely override the platform defaults remove them from the config object.
    // They've been integrated into the defaultConfig above.
    config.beforeSend = undefined;
    config.integrations = undefined;
    $eAdCn.init({
        ...defaultConfig,
        ...config
    });
    try {
        $9HPf3.setExtras(getExtraContext());
    } catch (e) {
        $9HPf3.captureException(e);
    }
};
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $15510fe24ae0eb31$var$tags = [
    'packageName',
    'teamName'
];
const $15510fe24ae0eb31$var$captureException = (location, error, details)=>{
    $9HPf3.configureScope((scope)=>{
        scope.setTag('logger', location);
        if (details) Object.keys(details).forEach((key)=>{
            if ($15510fe24ae0eb31$var$tags.includes(key)) scope.setTag(key, details[key]);
            else scope.setExtra(key, details[key]);
        });
    });
    $9HPf3.captureException(error);
};
const $15510fe24ae0eb31$var$sentryErrorHandler = {
    installGlobalHandler: $15510fe24ae0eb31$var$installGlobalHandler,
    captureException: $15510fe24ae0eb31$var$captureException
};
var $15510fe24ae0eb31$export$2e2bcd8739ae039 = $15510fe24ae0eb31$var$sentryErrorHandler;
module.exports["default"] = $15510fe24ae0eb31$export$2e2bcd8739ae039;

});

parcelRegister("iyIOY", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");
var $eC9tI = parcelRequire("eC9tI");
var $niMUw = parcelRequire("niMUw");
var $4RrPd = parcelRequire("4RrPd");
var $bJv8O = parcelRequire("bJv8O");

var $d82e2b7f9d9ed58c$var$global = (0, $niMUw.getGlobalObject)();
/** Send Console API calls as Sentry Events */ var $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function CaptureConsole(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */ this._levels = (0, $142hz.CONSOLE_LEVELS);
        if (options.levels) this._levels = options.levels;
    }
    /**
     * @inheritDoc
     */ CaptureConsole.prototype.setupOnce = function(_, getCurrentHub) {
        if (!('console' in $d82e2b7f9d9ed58c$var$global)) return;
        this._levels.forEach(function(level) {
            if (!(level in $d82e2b7f9d9ed58c$var$global.console)) return;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $eC9tI.fill)($d82e2b7f9d9ed58c$var$global.console, level, function(originalConsoleMethod) {
                return function() {
                    var args = [];
                    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                    var hub = getCurrentHub();
                    if (hub.getIntegration(CaptureConsole)) hub.withScope(function(scope) {
                        scope.setLevel((0, $bJv8O.severityFromString)(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function(event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = (0, $4RrPd.safeJoin)(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + ((0, $4RrPd.safeJoin)(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        } else if (level === 'error' && args[0] instanceof Error) hub.captureException(args[0]);
                        else hub.captureMessage(message);
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleMethod) originalConsoleMethod.apply($d82e2b7f9d9ed58c$var$global.console, args);
                };
            });
        });
    };
    /**
     * @inheritDoc
     */ CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}();
 //# sourceMappingURL=captureconsole.js.map
module.exports["CaptureConsole"] = $d82e2b7f9d9ed58c$export$25a43cb5b5c58c08;

});

parcelRegister("95IFc", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("niMUw")).getGlobalObject);
$parcel$export(module.exports, "isError", () => (parcelRequire("h6HKI")).isError);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("h6HKI")).isPlainObject);
$parcel$export(module.exports, "CONSOLE_LEVELS", () => (parcelRequire("142hz")).CONSOLE_LEVELS);
$parcel$export(module.exports, "logger", () => (parcelRequire("142hz")).logger);
$parcel$export(module.exports, "normalize", () => (parcelRequire("11Kkv")).normalize);
$parcel$export(module.exports, "fill", () => (parcelRequire("eC9tI")).fill);
$parcel$export(module.exports, "severityFromString", () => (parcelRequire("bJv8O")).severityFromString);
$parcel$export(module.exports, "safeJoin", () => (parcelRequire("4RrPd")).safeJoin);





parcelRequire("niMUw");


parcelRequire("h6HKI");

parcelRequire("142hz");




var $5kreq = parcelRequire("5kreq");

parcelRequire("11Kkv");

parcelRequire("eC9tI");



parcelRequire("bJv8O");



parcelRequire("4RrPd");




var $6pmA9 = parcelRequire("6pmA9");






 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $5kreq);
$parcel$exportWildcard(module.exports, $6pmA9);

});

parcelRegister("lIxjW", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $h6HKI = parcelRequire("h6HKI");

function $fcf78dd05a1f2799$export$5647df6b7814ac86(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $fcf78dd05a1f2799$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $fcf78dd05a1f2799$var$_htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
    });
    else {
        if (elem.id) out.push("#" + elem.id);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $h6HKI.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
        }
    }
    var allowedAttrs = [
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + "=\"" + attr + "\"]");
    }
    return out.join('');
}
function $fcf78dd05a1f2799$export$1cfafeee2987818b() {
    var global = (0, $niMUw.getGlobalObject)();
    try {
        return global.document.location.href;
    } catch (oO) {
        return '';
    }
} //# sourceMappingURL=browser.js.map
module.exports["htmlTreeAsString"] = $fcf78dd05a1f2799$export$5647df6b7814ac86;

});

parcelRegister("niMUw", function(module, exports) {
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $5kreq = parcelRequire("5kreq");

var $0460b8fabe4a64c2$var$fallbackGlobalObject = {};
function $0460b8fabe4a64c2$export$256479dc0cea61c4() {
    return (0, $5kreq.isNodeEnv)() ? $parcel$global : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
     ? window // eslint-disable-line no-restricted-globals
     : typeof self !== 'undefined' ? self : $0460b8fabe4a64c2$var$fallbackGlobalObject;
}
function $0460b8fabe4a64c2$export$7e223ec222791509(name, creator, obj) {
    var global1 = obj || $0460b8fabe4a64c2$export$256479dc0cea61c4();
    var __SENTRY__ = global1.__SENTRY__ = global1.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
} //# sourceMappingURL=global.js.map
module.exports["getGlobalObject"] = $0460b8fabe4a64c2$export$256479dc0cea61c4;
module.exports["getGlobalSingleton"] = $0460b8fabe4a64c2$export$7e223ec222791509;

});

parcelRegister("5kreq", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv, (v) => isNodeEnv = v);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire, (v) => dynamicRequire = v);
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ 
var $3HxeM = parcelRequire("3HxeM");


var $1P2f3 = parcelRequire("1P2f3");

function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $3HxeM.isBrowserBundle)() && Object.prototype.toString.call(typeof $1P2f3 !== 'undefined' ? $1P2f3 : 0) === '[object process]';
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    } catch (e) {
    // no-empty
    }
    return mod;
} //# sourceMappingURL=node.js.map

});

parcelRegister("3HxeM", function(module, exports) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $2b1f2b7c68d97ced$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
} //# sourceMappingURL=env.js.map
module.exports["isBrowserBundle"] = $2b1f2b7c68d97ced$export$2928c40372e623c0;

});

parcelRegister("h6HKI", function(module, exports) {
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ // eslint-disable-next-line @typescript-eslint/unbound-method
var $c744ef8efbbea969$var$objectToString = Object.prototype.toString;
function $c744ef8efbbea969$export$e6127cc7fe7395c3(wat) {
    switch($c744ef8efbbea969$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $c744ef8efbbea969$export$49034edbe6b62415(wat, Error);
    }
}
function $c744ef8efbbea969$var$isBuiltin(wat, ty) {
    return $c744ef8efbbea969$var$objectToString.call(wat) === "[object " + ty + "]";
}
function $c744ef8efbbea969$export$9f9636d330b71954(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'ErrorEvent');
}
function $c744ef8efbbea969$export$ef9e2056653f0c8e(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMError');
}
function $c744ef8efbbea969$export$12e869b2a583f783(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'DOMException');
}
function $c744ef8efbbea969$export$844ec244b1367d54(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'String');
}
function $c744ef8efbbea969$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
function $c744ef8efbbea969$export$53b83ca8eaab0383(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'Object');
}
function $c744ef8efbbea969$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Event);
}
function $c744ef8efbbea969$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $c744ef8efbbea969$export$49034edbe6b62415(wat, Element);
}
function $c744ef8efbbea969$export$49841c62b9eff15(wat) {
    return $c744ef8efbbea969$var$isBuiltin(wat, 'RegExp');
}
function $c744ef8efbbea969$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
function $c744ef8efbbea969$export$bc2894c7158efbac(wat) {
    return $c744ef8efbbea969$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
function $c744ef8efbbea969$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
function $c744ef8efbbea969$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
} //# sourceMappingURL=is.js.map
module.exports["isError"] = $c744ef8efbbea969$export$e6127cc7fe7395c3;
module.exports["isInstanceOf"] = $c744ef8efbbea969$export$49034edbe6b62415;
module.exports["isString"] = $c744ef8efbbea969$export$844ec244b1367d54;
module.exports["isPrimitive"] = $c744ef8efbbea969$export$c3825b437cbdea5c;
module.exports["isPlainObject"] = $c744ef8efbbea969$export$53b83ca8eaab0383;
module.exports["isEvent"] = $c744ef8efbbea969$export$9671ea99bd126ace;
module.exports["isElement"] = $c744ef8efbbea969$export$45a5e7f76e0caa8d;
module.exports["isRegExp"] = $c744ef8efbbea969$export$49841c62b9eff15;
module.exports["isSyntheticEvent"] = $c744ef8efbbea969$export$bc2894c7158efbac;
module.exports["isNaN"] = $c744ef8efbbea969$export$c9f5652083b8129d;

});

parcelRegister("2Q8PY", function(module, exports) {
var $21174afd68a919a2$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
]; //# sourceMappingURL=enums.js.map
module.exports["SeverityLevels"] = $21174afd68a919a2$export$484b1ea9aec914c;

});

parcelRegister("142hz", function(module, exports) {
$parcel$export(module.exports, "logger", () => $0c67ef66515853ff$export$af88d00dbe7f521);

var $fbwmZ = parcelRequire("fbwmZ");


var $4O82D = parcelRequire("4O82D");


var $niMUw = parcelRequire("niMUw");

// TODO: Implement different loggers for different environments
var $0c67ef66515853ff$var$global = (0, $niMUw.getGlobalObject)();
/** Prefix for logging strings */ var $0c67ef66515853ff$var$PREFIX = 'Sentry Logger ';
var $0c67ef66515853ff$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert'
];
function $0c67ef66515853ff$export$cda52e2a8927a2ca(callback) {
    var global = (0, $niMUw.getGlobalObject)();
    if (!('console' in global)) return callback();
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function(level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $0c67ef66515853ff$var$makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        }
    };
    if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (enabled) $0c67ef66515853ff$export$cda52e2a8927a2ca(function() {
                var _a;
                (_a = $0c67ef66515853ff$var$global.console)[name].apply(_a, (0, $fbwmZ.__spread)([
                    $0c67ef66515853ff$var$PREFIX + "[" + name + "]:"
                ], args));
            });
        };
    });
    else $0c67ef66515853ff$export$2a2b1d2252a69ecb.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var $0c67ef66515853ff$export$af88d00dbe7f521;
if (0, $4O82D.IS_DEBUG_BUILD) $0c67ef66515853ff$export$af88d00dbe7f521 = (0, $niMUw.getGlobalSingleton)('logger', $0c67ef66515853ff$var$makeLogger);
else $0c67ef66515853ff$export$af88d00dbe7f521 = $0c67ef66515853ff$var$makeLogger();
 //# sourceMappingURL=logger.js.map
module.exports["CONSOLE_LEVELS"] = $0c67ef66515853ff$export$2a2b1d2252a69ecb;

});

parcelRegister("4O82D", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $380211d076ff50e5$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $380211d076ff50e5$export$48a8984ec0bf2e44;

});

parcelRegister("aY4rC", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $7fc2f48fbe1d088a$export$8115b0b78e956ab3() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
} //# sourceMappingURL=memo.js.map
module.exports["memoBuilder"] = $7fc2f48fbe1d088a$export$8115b0b78e956ab3;

});

parcelRegister("11Kkv", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $h6HKI = parcelRequire("h6HKI");


var $aY4rC = parcelRequire("aY4rC");


var $eC9tI = parcelRequire("eC9tI");


var $fgmiz = parcelRequire("fgmiz");

function $0bf9d29200a37024$export$a3295358bff77e(input, depth, maxProperties) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    try {
        // since we're at the outermost level, there is no key
        return $0bf9d29200a37024$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: "**non-serializable** (" + err + ")"
        };
    }
}
function $0bf9d29200a37024$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var normalized = $0bf9d29200a37024$export$a3295358bff77e(object, depth);
    if ($0bf9d29200a37024$var$jsonSize(normalized) > maxSize) return $0bf9d29200a37024$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $0bf9d29200a37024$export$588732934346abbf(key, value, depth, maxProperties, memo) {
    if (depth === void 0) depth = Infinity;
    if (maxProperties === void 0) maxProperties = Infinity;
    if (memo === void 0) memo = (0, $aY4rC.memoBuilder)();
    var _a = (0, $fbwmZ.__read)(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        return valueWithToJSON.toJSON();
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $h6HKI.isNaN)(value)) return value;
    var stringified = $0bf9d29200a37024$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // We're also done if we've reached the max depth
    if (depth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, $h6HKI.isError)(value) || (0, $h6HKI.isEvent)(value) ? (0, $eC9tI.convertToPlainObject)(value) : value;
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = $0bf9d29200a37024$export$588732934346abbf(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $0bf9d29200a37024$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $h6HKI.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return "[Function: " + (0, $fgmiz.getFunctionName)(value) + "]";
        if (typeof value === 'symbol') return "[" + String(value) + "]";
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return "[BigInt: " + String(value) + "]";
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    } catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */ function $0bf9d29200a37024$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $0bf9d29200a37024$var$jsonSize(value) {
    return $0bf9d29200a37024$var$utf8Length(JSON.stringify(value));
} //# sourceMappingURL=normalize.js.map
module.exports["normalize"] = $0bf9d29200a37024$export$a3295358bff77e;

});

parcelRegister("eC9tI", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");


var $lIxjW = parcelRequire("lIxjW");


var $h6HKI = parcelRequire("h6HKI");


var $4RrPd = parcelRequire("4RrPd");

function $aa3bf77b99750f4a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $aa3bf77b99750f4a$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
function $aa3bf77b99750f4a$export$5c1499e2e5d010ae(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $aa3bf77b99750f4a$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
function $aa3bf77b99750f4a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
function $aa3bf77b99750f4a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join('&');
}
function $aa3bf77b99750f4a$export$62ff257738bf57f5(value) {
    var newObj = value;
    if ((0, $h6HKI.isError)(value)) newObj = (0, $fbwmZ.__assign)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, $aa3bf77b99750f4a$var$getOwnProperties(value));
    else if ((0, $h6HKI.isEvent)(value)) {
        var event_1 = value;
        newObj = (0, $fbwmZ.__assign)({
            type: event_1.type,
            target: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.target),
            currentTarget: $aa3bf77b99750f4a$var$serializeEventTarget(event_1.currentTarget)
        }, $aa3bf77b99750f4a$var$getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && (0, $h6HKI.isInstanceOf)(value, CustomEvent)) newObj.detail = event_1.detail;
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */ function $aa3bf77b99750f4a$var$serializeEventTarget(target) {
    try {
        return (0, $h6HKI.isElement)(target) ? (0, $lIxjW.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $aa3bf77b99750f4a$var$getOwnProperties(obj) {
    var extractedProps = {};
    for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
    return extractedProps;
}
function $aa3bf77b99750f4a$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($aa3bf77b99750f4a$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4RrPd.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4RrPd.truncate)(serialized, maxLength);
    }
    return '';
}
function $aa3bf77b99750f4a$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $h6HKI.isPlainObject)(val)) {
        var rv = {};
        try {
            for(var _b = (0, $fbwmZ.__values)(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof val[key] !== 'undefined') rv[key] = $aa3bf77b99750f4a$export$d25f2688db1bb433(val[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($aa3bf77b99750f4a$export$d25f2688db1bb433);
    return val;
}
function $aa3bf77b99750f4a$export$92b78acdbe066b6b(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $h6HKI.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
} //# sourceMappingURL=object.js.map
module.exports["fill"] = $aa3bf77b99750f4a$export$9563e054e6f787fb;
module.exports["convertToPlainObject"] = $aa3bf77b99750f4a$export$62ff257738bf57f5;

});

parcelRegister("4RrPd", function(module, exports) {

var $h6HKI = parcelRequire("h6HKI");

function $38a1b21eefbb9b2d$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $38a1b21eefbb9b2d$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
function $38a1b21eefbb9b2d$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
function $38a1b21eefbb9b2d$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $h6HKI.isString)(value)) return false;
    if ((0, $h6HKI.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === 'string') return value.indexOf(pattern) !== -1;
    return false;
}
function $38a1b21eefbb9b2d$export$466fc863a824cea6(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
} //# sourceMappingURL=string.js.map
module.exports["truncate"] = $38a1b21eefbb9b2d$export$6a506b36fdea397d;
module.exports["safeJoin"] = $38a1b21eefbb9b2d$export$465e9d514283d4fd;

});

parcelRegister("fgmiz", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

var $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT = 50;
function $b1c9a5aa64b78b97$export$a5739666fb2d03d4() {
    var parsers = [];
    for(var _i = 0; _i < arguments.length; _i++)parsers[_i] = arguments[_i];
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) skipFirst = 0;
        var frames = [];
        try {
            for(var _c = (0, $fbwmZ.__values)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()){
                var line = _d.value;
                try {
                    for(var sortedParsers_1 = (e_2 = void 0, (0, $fbwmZ.__values)(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()){
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return $b1c9a5aa64b78b97$export$c55c24c0eeba0205(frames);
    };
}
function $b1c9a5aa64b78b97$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $b1c9a5aa64b78b97$var$STACKTRACE_LIMIT).map(function(frame) {
        return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, frame), {
            filename: frame.filename || localStack[0].filename,
            function: frame.function || '?'
        });
    }).reverse();
}
var $b1c9a5aa64b78b97$var$defaultFunctionName = '<anonymous>';
function $b1c9a5aa64b78b97$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $b1c9a5aa64b78b97$var$defaultFunctionName;
        return fn.name || $b1c9a5aa64b78b97$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $b1c9a5aa64b78b97$var$defaultFunctionName;
    }
} //# sourceMappingURL=stacktrace.js.map
module.exports["getFunctionName"] = $b1c9a5aa64b78b97$export$aad197c7121a6651;

});

parcelRegister("bJv8O", function(module, exports) {

var $dRGWM = parcelRequire("dRGWM");


var $2Q8PY = parcelRequire("2Q8PY");

function $88ac0da36f058dd3$var$isSupportedSeverity(level) {
    return (0, $2Q8PY.SeverityLevels).indexOf(level) !== -1;
}
function $88ac0da36f058dd3$export$e01cef29b4327697(level) {
    if (level === 'warn') return (0, $dRGWM.Severity).Warning;
    if ($88ac0da36f058dd3$var$isSupportedSeverity(level)) return level;
    return (0, $dRGWM.Severity).Log;
} //# sourceMappingURL=severity.js.map
module.exports["severityFromString"] = $88ac0da36f058dd3$export$e01cef29b4327697;

});

parcelRegister("dRGWM", function(module, exports) {
$parcel$export(module.exports, "Severity", () => $a18189fe7a3d3e93$export$918a9776c0a3cf27);
/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */ var $a18189fe7a3d3e93$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($a18189fe7a3d3e93$export$918a9776c0a3cf27 || ($a18189fe7a3d3e93$export$918a9776c0a3cf27 = {}));
var $a18189fe7a3d3e93$export$484b1ea9aec914c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug',
    'critical'
]; //# sourceMappingURL=severity.js.map

});

parcelRegister("6pmA9", function(module, exports) {

var $niMUw = parcelRequire("niMUw");


var $5kreq = parcelRequire("5kreq");

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $5kreq.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $5kreq.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var _browserPerformanceTimeOriginMode;
var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, $niMUw.getGlobalObject)().performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}(); //# sourceMappingURL=time.js.map

});

parcelRegister("6W0Xl", function(module, exports) {
parcelRequire("95IFc");
var $142hz = parcelRequire("142hz");


var $c9L3v = parcelRequire("c9L3v");

/** Deduplication filter */ var $50c8e6bccf5bbb5e$export$688d98c249d31ad3 = /** @class */ function() {
    function Dedupe() {
        /**
         * @inheritDoc
         */ this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */ Dedupe.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if ($50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, self._previousEvent)) {
                        (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                } catch (_oO) {
                    return self._previousEvent = currentEvent;
                }
                return self._previousEvent = currentEvent;
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */ Dedupe.id = 'Dedupe';
    return Dedupe;
}();
function $50c8e6bccf5bbb5e$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(previousEvent);
    var currentException = $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(currentEvent);
    var previousFrames = $50c8e6bccf5bbb5e$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */ function $50c8e6bccf5bbb5e$var$_getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-ignore Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    else if (event.stacktrace) return event.stacktrace.frames;
    return undefined;
} //# sourceMappingURL=dedupe.js.map
module.exports["Dedupe"] = $50c8e6bccf5bbb5e$export$688d98c249d31ad3;

});

parcelRegister("c9L3v", function(module, exports) {
/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */ /** Flag that is true for debug builds, false otherwise. */ var $8d9ad39358b035f4$export$48a8984ec0bf2e44 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__; //# sourceMappingURL=flags.js.map
module.exports["IS_DEBUG_BUILD"] = $8d9ad39358b035f4$export$48a8984ec0bf2e44;

});

parcelRegister("fa95z", function(module, exports) {

var $fbwmZ = parcelRequire("fbwmZ");

parcelRequire("95IFc");
var $h6HKI = parcelRequire("h6HKI");
var $142hz = parcelRequire("142hz");
var $11Kkv = parcelRequire("11Kkv");


var $c9L3v = parcelRequire("c9L3v");

/** Patch toString calls to return proper name for wrapped functions */ var $b09ed70491c36903$export$56d961ef3a52a072 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function ExtraErrorData(options) {
        /**
         * @inheritDoc
         */ this.name = ExtraErrorData.id;
        this._options = (0, $fbwmZ.__assign)({
            depth: 3
        }, options);
    }
    /**
     * @inheritDoc
     */ ExtraErrorData.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event, hint) {
            var self = getCurrentHub().getIntegration(ExtraErrorData);
            if (!self) return event;
            return self.enhanceEventWithErrorData(event, hint);
        });
    };
    /**
     * Attaches extracted information from the Error object to extra field in the Event
     */ ExtraErrorData.prototype.enhanceEventWithErrorData = function(event, hint) {
        var _a;
        if (!hint || !hint.originalException || !(0, $h6HKI.isError)(hint.originalException)) return event;
        var name = hint.originalException.name || hint.originalException.constructor.name;
        var errorData = this._extractErrorData(hint.originalException);
        if (errorData) {
            var contexts = (0, $fbwmZ.__assign)({}, event.contexts);
            var normalizedErrorData = (0, $11Kkv.normalize)(errorData, this._options.depth);
            if ((0, $h6HKI.isPlainObject)(normalizedErrorData)) contexts = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event.contexts), (_a = {}, _a[name] = (0, $fbwmZ.__assign)({}, normalizedErrorData), _a));
            return (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, event), {
                contexts: contexts
            });
        }
        return event;
    };
    /**
     * Extract extra information from the Error object
     */ ExtraErrorData.prototype._extractErrorData = function(error) {
        var e_1, _a, e_2, _b;
        // We are trying to enhance already existing event, so no harm done if it won't succeed
        try {
            var nativeKeys = [
                'name',
                'message',
                'stack',
                'line',
                'column',
                'fileName',
                'lineNumber',
                'columnNumber',
                'toJSON'
            ];
            var extraErrorInfo = {};
            try {
                // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
                for(var _c = (0, $fbwmZ.__values)(Object.keys(error)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var key = _d.value;
                    if (nativeKeys.indexOf(key) !== -1) continue;
                    var value = error[key];
                    extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
            if (typeof error.toJSON === 'function') {
                var serializedError = error.toJSON();
                try {
                    for(var _e = (0, $fbwmZ.__values)(Object.keys(serializedError)), _f = _e.next(); !_f.done; _f = _e.next()){
                        var key = _f.value;
                        var value = serializedError[key];
                        extraErrorInfo[key] = (0, $h6HKI.isError)(value) ? value.toString() : value;
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            return extraErrorInfo;
        } catch (oO) {
            (0, $c9L3v.IS_DEBUG_BUILD) && (0, $142hz.logger).error('Unable to extract extra data from the Error object:', oO);
        }
        return null;
    };
    /**
     * @inheritDoc
     */ ExtraErrorData.id = 'ExtraErrorData';
    return ExtraErrorData;
}();
 //# sourceMappingURL=extraerrordata.js.map
module.exports["ExtraErrorData"] = $b09ed70491c36903$export$56d961ef3a52a072;

});

parcelRegister("hLq0X", function(module, exports) {
/** Add node transaction to the event */ var $ceeb015bb088f872$export$febc5573c75cefb0 = /** @class */ function() {
    function Transaction() {
        /**
         * @inheritDoc
         */ this.name = Transaction.id;
    }
    /**
     * @inheritDoc
     */ Transaction.prototype.setupOnce = function(addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function(event) {
            var self = getCurrentHub().getIntegration(Transaction);
            if (self) return self.process(event);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ Transaction.prototype.process = function(event) {
        var frames = this._getFramesFromEvent(event);
        // use for loop so we don't have to reverse whole frames array
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i];
            if (frame.in_app === true) {
                event.transaction = this._getTransaction(frame);
                break;
            }
        }
        return event;
    };
    /** JSDoc */ Transaction.prototype._getFramesFromEvent = function(event) {
        var exception = event.exception && event.exception.values && event.exception.values[0];
        return exception && exception.stacktrace && exception.stacktrace.frames || [];
    };
    /** JSDoc */ Transaction.prototype._getTransaction = function(frame) {
        return frame.module || frame.function ? (frame.module || '?') + "/" + (frame.function || '?') : '<unknown>';
    };
    /**
     * @inheritDoc
     */ Transaction.id = 'Transaction';
    return Transaction;
}();
 //# sourceMappingURL=transaction.js.map
module.exports["Transaction"] = $ceeb015bb088f872$export$febc5573c75cefb0;

});

parcelRegister("5o2Ge", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $99172359a6fdf681$export$f0a9f6d56660bc06 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
module.exports["HubErrorObserverContext"] = $99172359a6fdf681$export$f0a9f6d56660bc06;

});

parcelRegister("r8hvx", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $dabtY = parcelRequire("dabtY");

var $32sS3 = parcelRequire("32sS3");

const $4cf16431deccd0b9$export$9a47313ad5d1f7c3 = (asapIssuer, mediaToken, mediaUrl)=>async ()=>{
        return {
            asapIssuer: asapIssuer,
            token: mediaToken,
            baseUrl: mediaUrl
        };
    };
const $4cf16431deccd0b9$export$98e696b66f6bbf2b = (mediaCollectionName, asapIssuer, mediaToken, mediaUrl, isUploadMediaConfigRequired)=>{
    const authProvider = $4cf16431deccd0b9$export$9a47313ad5d1f7c3(asapIssuer, mediaToken, mediaUrl);
    return {
        uploadParams: {
            collection: mediaCollectionName
        },
        viewMediaClientConfig: {
            authProvider: authProvider,
            useSha256ForUploads: true
        },
        ...isUploadMediaConfigRequired && {
            uploadMediaClientConfig: {
                authProvider: authProvider
            }
        }
    };
};
const $4cf16431deccd0b9$var$getSafeHelpCenterIdMeta = (helpCenterAri)=>{
    try {
        if (helpCenterAri && helpCenterAri !== 'null') {
            const { activationId: activationId, helpCenterId: helpCenterId } = (0, $dabtY.HelpHelpCenterAri).parse(helpCenterAri);
            return {
                activationId: activationId,
                helpCenterId: helpCenterId
            };
        }
    } catch  {
    // todo: add analytics
    }
};
const $4cf16431deccd0b9$export$9e8d72642057ad79 = (helpCenterAri, pageId)=>{
    const { activationId: activationId = '', helpCenterId: helpCenterId = '' } = $4cf16431deccd0b9$var$getSafeHelpCenterIdMeta(helpCenterAri) || {};
    return (0, $32sS3.HelpPageAri).create({
        activationId: activationId,
        pageId: pageId || helpCenterId
    }).toString() || '';
};
const $4cf16431deccd0b9$export$6a5aa704056d141b = (0, $cozmU.createContext)(null);
const $4cf16431deccd0b9$export$ac8576a9912be18c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($4cf16431deccd0b9$export$6a5aa704056d141b);
    if (!context) throw new Error("useHubContext must be used within a HubContextProvider");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($4cf16431deccd0b9$export$6a5aa704056d141b);
    if (!context) throw new Error('useHubContext must be used within a HubContextProvider');
    return context;
};
module.exports["getMediaProvider"] = $4cf16431deccd0b9$export$98e696b66f6bbf2b;
module.exports["HubContext"] = $4cf16431deccd0b9$export$6a5aa704056d141b;
module.exports["useHubContext"] = $4cf16431deccd0b9$export$ac8576a9912be18c;

});

parcelRegister("dabtY", function(module, exports) {

var $hkG7x = parcelRequire("hkG7x");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/help/help-center/manifest.ts
var $99551dbaeda9bfe2$var$helpHelpCenterAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $hkG7x.HelpHelpCenterAriResourceOwner),
    resourceType: (0, $hkG7x.HelpHelpCenterAriResourceType),
    resourceIdSlug: "{activationId}/{helpCenterId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        helpCenterId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/help-center/index.ts
var $99551dbaeda9bfe2$export$a75f3c98d930b258 = class _HelpHelpCenterAri extends (0, $9j37t.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get helpCenterId() {
        return this._helpCenterId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $99551dbaeda9bfe2$var$helpHelpCenterAriStaticOpts.qualifier,
            platformQualifier: $99551dbaeda9bfe2$var$helpHelpCenterAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $99551dbaeda9bfe2$var$helpHelpCenterAriStaticOpts.resourceOwner,
            resourceType: $99551dbaeda9bfe2$var$helpHelpCenterAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.helpCenterId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                helpCenterId: opts.helpCenterId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $99551dbaeda9bfe2$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $99551dbaeda9bfe2$var$helpHelpCenterAriStaticOpts);
        return new _HelpHelpCenterAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            helpCenterId: this.helpCenterId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._helpCenterId = opts.resourceIdSegmentValues.helpCenterId;
    }
};
module.exports["HelpHelpCenterAri"] = $99551dbaeda9bfe2$export$a75f3c98d930b258;

});

parcelRegister("hkG7x", function(module, exports) {
// src/help/help-center/types.ts
var $c9e4fa34ad2a6b7c$export$a4af98a27b4568ee = "help", $c9e4fa34ad2a6b7c$export$f6271ed6947e9084 = "help-center";
module.exports["HelpHelpCenterAriResourceOwner"] = $c9e4fa34ad2a6b7c$export$a4af98a27b4568ee;
module.exports["HelpHelpCenterAriResourceType"] = $c9e4fa34ad2a6b7c$export$f6271ed6947e9084;

});

parcelRegister("32sS3", function(module, exports) {

var $8VqLT = parcelRequire("8VqLT");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/help/page/manifest.ts
var $2367f42997e8fbbc$var$helpPageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $8VqLT.HelpPageAriResourceOwner),
    resourceType: (0, $8VqLT.HelpPageAriResourceType),
    resourceIdSlug: "{activationId}/{pageId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        pageId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/help/page/index.ts
var $2367f42997e8fbbc$export$7855a3c68b5a0b04 = class _HelpPageAri extends (0, $9j37t.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2367f42997e8fbbc$var$helpPageAriStaticOpts.qualifier,
            platformQualifier: $2367f42997e8fbbc$var$helpPageAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $2367f42997e8fbbc$var$helpPageAriStaticOpts.resourceOwner,
            resourceType: $2367f42997e8fbbc$var$helpPageAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}/${opts.pageId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                pageId: opts.pageId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $2367f42997e8fbbc$var$helpPageAriStaticOpts);
        return new _HelpPageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $2367f42997e8fbbc$var$helpPageAriStaticOpts);
        return new _HelpPageAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};
module.exports["HelpPageAri"] = $2367f42997e8fbbc$export$7855a3c68b5a0b04;

});

parcelRegister("8VqLT", function(module, exports) {
// src/help/page/types.ts
var $67f869d565f71cc8$export$b6fe1f05324d51ea = "help", $67f869d565f71cc8$export$e6c9af890e88f3eb = "page";
module.exports["HelpPageAriResourceOwner"] = $67f869d565f71cc8$export$b6fe1f05324d51ea;
module.exports["HelpPageAriResourceType"] = $67f869d565f71cc8$export$e6c9af890e88f3eb;

});

parcelRegister("5w0mC", function(module, exports) {
/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub
 * Connect extension. Must remain stable across product releases — changing
 * it is a breaking change to persisted hub content.
 *
 * Mirrors the Help Center Connect module shape so installed Connect apps
 * (Portal header / Portal footer modules) can be shared between Help
 * Center and Hub editors with zero schema translation.
 */ const $ea111247103d173e$export$9739bc39ff578ef = 'com.atlassian.hub-connect';
const $ea111247103d173e$export$3a3256797a873c9d = 'hub-connect';
const $ea111247103d173e$export$a391370883dc60a0 = `${$ea111247103d173e$export$3a3256797a873c9d}-header`;
const $ea111247103d173e$export$6214169031454add = `${$ea111247103d173e$export$3a3256797a873c9d}-footer`;
const $ea111247103d173e$export$2772ad16b9dc4cf1 = (extensionKey)=>extensionKey === $ea111247103d173e$export$a391370883dc60a0;
const $ea111247103d173e$export$5672169d8cc92b0b = (extensionKey)=>extensionKey === $ea111247103d173e$export$6214169031454add;
const $ea111247103d173e$export$cbd6fa0855da1fbd = '1.0.0';
const $ea111247103d173e$export$a7467005470ef946 = {
    HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
    FOOTER_PANELS: 'footerPanels'
};
const $ea111247103d173e$export$dc1f825c64ccdff6 = {
    HELP_HUB: 'HELP_HUB'
};
const $ea111247103d173e$export$939aa9ef868c885e = 'hubConnectExtension';
const $ea111247103d173e$export$7bb2524ff74eaaaa = 'hubConnectExtensionConfig';
const $ea111247103d173e$export$88cc63a4344dc0e3 = 'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';
module.exports["HUB_CONNECT_EXTENSION_TYPE"] = $ea111247103d173e$export$9739bc39ff578ef;
module.exports["isFooterExtensionKey"] = $ea111247103d173e$export$5672169d8cc92b0b;
module.exports["HUB_CONNECT_LEARN_MORE_URL"] = $ea111247103d173e$export$88cc63a4344dc0e3;

});

parcelRegister("239dQ", function(module, exports) {
/**
 * Reverse-DNS identifier carried in ADF `extension` nodes for a Hub Forge
 * extension. Must remain stable across product releases — changing it is a
 * breaking change to persisted hub content.
 *
 * Mirrors the Help Center Forge module shape so that Forge UI Kit / Custom UI
 * extensions can be shared between Help Center and Hub editors.
 */ const $cb776784963775a4$export$28815926b67771e7 = 'com.atlassian.hub-forge';
const $cb776784963775a4$export$e1401e10db30b53d = 'hub-forge';
const $cb776784963775a4$export$bbd2284a8b6f23d6 = `${$cb776784963775a4$export$e1401e10db30b53d}-header`;
const $cb776784963775a4$export$9204604618f84769 = `${$cb776784963775a4$export$e1401e10db30b53d}-footer`;
const $cb776784963775a4$export$4fd744a56941aef9 = '1.0.0';
const $cb776784963775a4$export$f351bc2072386324 = {
    HEADER_AND_SUB_HEADER_PANELS: 'headerAndSubheaderPanels',
    FOOTER_PANELS: 'footerPanels'
};
const $cb776784963775a4$export$ed5f67b6b84eb2bf = {
    HELP_HUB: 'HELP_HUB',
    CSM_HELP_CENTER: 'CSM_HELP_CENTER'
};
const $cb776784963775a4$export$a4c5610f6315d2b8 = 'hubForgeExtension';
const $cb776784963775a4$export$10977f18dbecea4f = 'hubForgeExtensionConfig';
const $cb776784963775a4$export$7e8317652605f123 = 'https://developer.atlassian.com/platform/forge/manifest-reference/modules/index-jsm/';
module.exports["HUB_FORGE_EXTENSION_TYPE"] = $cb776784963775a4$export$28815926b67771e7;
module.exports["HUB_FORGE_HEADER_EXTENSION_KEY"] = $cb776784963775a4$export$bbd2284a8b6f23d6;
module.exports["HUB_FORGE_FOOTER_EXTENSION_KEY"] = $cb776784963775a4$export$9204604618f84769;
module.exports["HUB_FORGE_LEARN_MORE_URL"] = $cb776784963775a4$export$7e8317652605f123;

});

parcelRegister("1ovy4", function(module, exports) {
const $cd81dce5d98cc0da$export$62b7ac1cc8a8f8d7 = 'com.atlassian.hub.jsm-help';
const $cd81dce5d98cc0da$export$b5a30704f903627a = 'jsm-help';
const $cd81dce5d98cc0da$export$727d928d273126f1 = 'jsmHelpExtension';
const $cd81dce5d98cc0da$export$5eecea5c34e4d0ec = 'jsmHelpExtensionConfig';
const $cd81dce5d98cc0da$export$42fa33c628980eca = '1.0.0';
const $cd81dce5d98cc0da$export$8ec3d08588d2eeda = 9;
const $cd81dce5d98cc0da$export$93c0382b74e40ff9 = {
    SMALL: 'small',
    LARGE: 'large'
};
const $cd81dce5d98cc0da$export$d95e7684b6658cc2 = {
    COMMON_REQUESTS: 'common-requests',
    KB_ARTICLES: 'kb-articles',
    MANUAL: 'manual',
    PORTAL_CARDS: 'portal-cards',
    PORTAL_GROUPS: 'portal-groups'
};
module.exports["JSM_HELP_EXTENSION_TYPE"] = $cd81dce5d98cc0da$export$62b7ac1cc8a8f8d7;
module.exports["JSM_HELP_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $cd81dce5d98cc0da$export$5eecea5c34e4d0ec;
module.exports["PAGE_SIZE"] = $cd81dce5d98cc0da$export$8ec3d08588d2eeda;
module.exports["SourceType"] = $cd81dce5d98cc0da$export$d95e7684b6658cc2;

});

parcelRegister("6Q9UP", function(module, exports) {
// Constants are renamed from PAGE_TOPPER prefix to CALLOUT_BANNER in anticipation of the extension rename to callout banner.
// Leaving the extension and type strings as page-topper, however, as the extension has already been added to a few instances
const $d8a24fb3c82801ff$export$5eb13835d9fc35c6 = 'page-topper';
const $d8a24fb3c82801ff$export$1e0076557b3776e7 = 'com.atlassian.confluence.page-topper';
const $d8a24fb3c82801ff$export$bbe74ef6b7213123 = 'calloutBannerExtension';
module.exports["CALLOUT_BANNER_EXTENSION_TYPE"] = $d8a24fb3c82801ff$export$1e0076557b3776e7;
module.exports["CALLOUT_BANNER_EXTENSION_ANALYTIC_SOURCE"] = $d8a24fb3c82801ff$export$bbe74ef6b7213123;

});

parcelRegister("6Cr27", function(module, exports) {

let $4d1b42e6f38a55e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4d1b42e6f38a55e4$var$load("2xoIF"),
    $4d1b42e6f38a55e4$var$load("5NuZb"),
    $4d1b42e6f38a55e4$var$load("gBTXw"),
    $4d1b42e6f38a55e4$var$load("gkVge"),
    $4d1b42e6f38a55e4$var$load("cvcNg"),
    $4d1b42e6f38a55e4$var$load("7FVeh"),
    $4d1b42e6f38a55e4$var$load("eOFeQ"),
    $4d1b42e6f38a55e4$var$load("fqJr7"),
    $4d1b42e6f38a55e4$var$load("1dHf3"),
    $4d1b42e6f38a55e4$var$load("b19pM"),
    $4d1b42e6f38a55e4$var$load("rF2nk"),
    $4d1b42e6f38a55e4$var$load("bBCIu"),
    $4d1b42e6f38a55e4$var$load("38ocJ"),
    $4d1b42e6f38a55e4$var$load("dgmjH"),
    $4d1b42e6f38a55e4$var$load("5jMIH"),
    $4d1b42e6f38a55e4$var$load("1he0z"),
    $4d1b42e6f38a55e4$var$load("do5z1"),
    $4d1b42e6f38a55e4$var$load("1aqfs"),
    $4d1b42e6f38a55e4$var$load("hS8gF"),
    $4d1b42e6f38a55e4$var$load("6wr18"),
    $4d1b42e6f38a55e4$var$load("g8A75"),
    $4d1b42e6f38a55e4$var$load("9w623"),
    $4d1b42e6f38a55e4$var$load("4bu4H"),
    $4d1b42e6f38a55e4$var$load("boOz1"),
    $4d1b42e6f38a55e4$var$load("coGVA"),
    $4d1b42e6f38a55e4$var$load("96rwC"),
    $4d1b42e6f38a55e4$var$load("RI3SR"),
    $4d1b42e6f38a55e4$var$load("5pK3l"),
    $4d1b42e6f38a55e4$var$load("4C4vr"),
    $4d1b42e6f38a55e4$var$load("jmTCk"),
    $4d1b42e6f38a55e4$var$load("VXbA1"),
    $4d1b42e6f38a55e4$var$load("4Pq08"),
    $4d1b42e6f38a55e4$var$load("fHVVl"),
    $4d1b42e6f38a55e4$var$load("ffEVr"),
    $4d1b42e6f38a55e4$var$load("gQrOI"),
    $4d1b42e6f38a55e4$var$load("jH5Dl")
]).then(()=>parcelRequire('ho4OS'));

});

parcelRegister("6RwwD", function(module, exports) {
/* eslint-disable require-unicode-regexp,prefer-regex-literals */ 
var $6Q8Dd = parcelRequire("6Q8Dd");


var $8OcYi = parcelRequire("8OcYi");


var $4yccB = parcelRequire("4yccB");


var $kzwaO = parcelRequire("kzwaO");


var $cXJjm = parcelRequire("cXJjm");


var $ggGdk = parcelRequire("ggGdk");


var $drRzc = parcelRequire("drRzc");


var $iDrrr = parcelRequire("iDrrr");


var $biKbJ = parcelRequire("biKbJ");


var $iyuxZ = parcelRequire("iyuxZ");


var $koAyx = parcelRequire("koAyx");


var $8kONW = parcelRequire("8kONW");

const $d4521f0694a3bb0e$var$BATCH_WAIT_TIME = 50;
// Check if it is matching a Jira Roadmaps or Jira Timeline url
// NOT to be confused with JSM timeline
const $d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/.*?\/(timeline|roadmap)\/?/;
const $d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX = /^https:\/\/.*?\/jira\/polaris\/projects\/[^\/]+?\/ideas\/view\/\d+$|^https:\/\/.*?\/secure\/JiraProductDiscoveryAnonymous\.jspa\?hash=\w+|^https:\/\/.*?\/jira\/polaris\/share\/\w+|^https:\/\/.*?\/jira\/discovery\/share\/views\/[\w-]+(\?selectedIssue=[\w-]+&issueViewLayout=sidebar&issueViewSection=[\w-]+)?$/;
const $d4521f0694a3bb0e$var$JWM_VIEW_REGEX = /^https:\/\/.*?\/jira\/core\/projects\/[^\/]+?\/(timeline|calendar|list|board|summary|(form\/[^\/]+?))\/?/;
const $d4521f0694a3bb0e$var$JIRA_LIST_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/list\/?/;
const $d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX = /^https:\/\/(.*?\.)?giphy\.com\/(gifs|media|clips)\//;
const $d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX = /^https:\/\/[^/]+\/jira\/(core|software(\/c)?|servicedesk)\/projects\/\w+\/forms\/form\/direct\/\d+\/\d+.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?");
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX = RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?");
const $d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX = /\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/;
const $d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX = /^https:\/\/(.*?\.)?(youtube\..*?\/(watch\?|v\/|shorts\/)|youtu\.be)/;
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
// prettier-ignore
const $d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX = /^https:\/\/(.*?\.)?loom\..*?\/(?:playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:\/view)?|embed\/playlists\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\?|$)/i;
const $d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX = RegExp("^https:\\/\\/(.*?\\.)?loom\\..*?\\/i\\/(?<id>[a-f0-9]{32})");
const $d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX = /^https:\/\/.*?\/jira\/dashboards\/[0-9]+.*/;
const $d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\/backlog\??.*/;
const $d4521f0694a3bb0e$var$JIRA_BOARD_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/boards\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_PLAN_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)");
// prettier-ignore
const $d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX = RegExp("https:\\/\\/.*?\\/jira\\/plans\\/(?<resourceId>\\d+)\\/scenarios\\/(?<resourceContext>\\d+)\\/(timeline|summary|calendar|program\\/\\d+|dependencies)\\/?");
const $d4521f0694a3bb0e$var$JIRA_VERSION_REGEX = /https:\/\/.*?\/projects\/[^\/]+?\/versions\/\d+\/tab\/release-report-all-issues/;
const $d4521f0694a3bb0e$var$JIRA_FORM_REGEX = /https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/form\/\d\??.*/;
const $d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX = /^https:\/\/.*?\/jira\/software\/(c\/)?projects\/[^\/]+?\/summary/;
const $d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX = /^https:\/\/.*?\/people\/agent\/.+$/;
const $d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX = /^https:\/\/customer\.atlassian\.com\/.*$/;
// prettier-ignore
const $d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX = RegExp("\\/wiki\\/spaces\\/(?<resourceContext>[^\\/]+)\\/calendars\\/(?<resourceId>[a-zA-Z0-9-]+)");
const $d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX = /^https:\/\/.*?\/jira\/software|core\/(c\/)?projects\/[^\/]+?\/issues\/?/;
const $d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX = /^https:\/\/.*?\/avpviz\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$ARTIFACT_UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
// Keep in sync with ARTIFACT_URL_PATTERNS in @atlassian/native-embeds-artifacts-experience
const $d4521f0694a3bb0e$var$ARTIFACT_SHARE_REGEX = [
    new RegExp(`/artifacts/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}(?:[/?#].*)?$`),
    new RegExp(`/apps/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}/${$d4521f0694a3bb0e$var$ARTIFACT_UUID}/[^?#]*\\?(?:[^#]*&)?smartlink=artifact`)
];
const $d4521f0694a3bb0e$var$DASHBOARDS_CHART_VIEW_REGEX = /^https:\/\/.*?\/dashboards\/c\/[^\/]+.*/;
const $d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX = /\/browse\/((?:\w+)-(?:\d+))/i;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX = /^[a-zA-Z0-9]/;
const $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX = /[a-zA-Z0-9]$/;
const $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ROADMAP_OR_TIMELINE_REGEX);
const $d4521f0694a3bb0e$var$isPolarisView = (url)=>url.match($d4521f0694a3bb0e$var$POLARIS_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJwmView = (url)=>url.match($d4521f0694a3bb0e$var$JWM_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isJiraList = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_LIST_REGEX);
const $d4521f0694a3bb0e$var$isGiphyMedia = (url)=>url.match($d4521f0694a3bb0e$var$GIPHY_MEDIA_REGEX);
const $d4521f0694a3bb0e$var$isProformaView = (url)=>url.match($d4521f0694a3bb0e$var$PROFORMA_VIEW_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceWhiteboard = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_DECIMAL_REGEX) || url.match($d4521f0694a3bb0e$var$CONFLUENCE_WHITEBOARD_UUID_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceDatabase = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_DATABASE_REGEX);
const $d4521f0694a3bb0e$var$isYoutubeVideo = (url)=>url.match($d4521f0694a3bb0e$var$YOUTUBE_VIDEO_REGEX);
const $d4521f0694a3bb0e$var$isLoomVideoUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_VIDEO_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomPlaylistUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_PLAYLIST_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isLoomScreenshotUrl = (url)=>{
    return url.match($d4521f0694a3bb0e$var$LOOM_SCREENSHOT_URL_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraDashboard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_DASHBOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBacklog = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BACKLOG_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraBoard = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_BOARD_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraPlan = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_PLAN_REGEX) || url.match($d4521f0694a3bb0e$var$JIRA_PLAN_WITH_SCENARIO_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraVersion = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_VERSION_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraForm = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_FORM_REGEX);
};
const $d4521f0694a3bb0e$var$isJiraSummary = (url)=>{
    return url.match($d4521f0694a3bb0e$var$JIRA_SUMMARY_REGEX);
};
const $d4521f0694a3bb0e$var$isRovoAgentProfilePage = (url)=>{
    return url.match($d4521f0694a3bb0e$var$ROVO_AGENT_PROFILE_PAGE_REGEX);
};
const $d4521f0694a3bb0e$var$isCustomer360LandingPage = (url)=>url.match($d4521f0694a3bb0e$var$CUSTOMER_360_LANDING_PAGE_REGEX);
const $d4521f0694a3bb0e$var$isConfluenceTeamCalendars = (url)=>url.match($d4521f0694a3bb0e$var$CONFLUENCE_TEAM_CALENDARS_REGEX);
const $d4521f0694a3bb0e$var$isJiraIssueNavigator = (url)=>url.match($d4521f0694a3bb0e$var$JIRA_ISSUE_NAVIGATOR_REGEX);
const $d4521f0694a3bb0e$var$isAvpVisualizationView = (url)=>url.match($d4521f0694a3bb0e$var$AVP_VISUALIZATION_VIEW_REGEX) || ((0, $iDrrr.fg)('platform_avp_viz_dashboard_link_embed') ? url.match($d4521f0694a3bb0e$var$DASHBOARDS_CHART_VIEW_REGEX) : null);
const $d4521f0694a3bb0e$var$isArtifactsShareView = (url)=>{
    for (const pattern of $d4521f0694a3bb0e$var$ARTIFACT_SHARE_REGEX){
        const match = url.match(pattern);
        if (match) return match;
    }
    return null;
};
const $d4521f0694a3bb0e$export$6a9668b99d8a1708 = (url)=>$d4521f0694a3bb0e$var$JIRA_WORK_ITEM_REGEX.test(url);
// Local UrlChecker-compatible wrapper around the boolean-returning
// `isConfluenceSlideUrl` from `./url-checkers` (the single source of truth for
// slide URL matching). Wrapping (rather than aliasing the imported identifier
// directly inside the exported `internalUrlCheckers` object) avoids the
// @atlaskit/editor/no-re-export lint rule and gives the registry a uniform
// `(url) => RegExpMatchArray | null` signature. Consumers of
// `internalUrlCheckers` only check the truthiness of the result, so returning
// a synthetic single-element match array (or `null`) preserves behaviour.
const $d4521f0694a3bb0e$var$isConfluenceSlide = (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) ? [
        url
    ] : null;
const $d4521f0694a3bb0e$export$da256e60841d38fd = {
    isJiraRoadmapOrTimeline: $d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline,
    isPolarisView: $d4521f0694a3bb0e$var$isPolarisView,
    isJwmView: $d4521f0694a3bb0e$var$isJwmView,
    isJiraList: $d4521f0694a3bb0e$var$isJiraList,
    isConfluenceWhiteboard: $d4521f0694a3bb0e$var$isConfluenceWhiteboard,
    isConfluenceDatabase: $d4521f0694a3bb0e$var$isConfluenceDatabase,
    isConfluenceSlide: $d4521f0694a3bb0e$var$isConfluenceSlide,
    isJiraDashboard: $d4521f0694a3bb0e$var$isJiraDashboard,
    isJiraBacklog: $d4521f0694a3bb0e$var$isJiraBacklog,
    isJiraBoard: $d4521f0694a3bb0e$var$isJiraBoard,
    isJiraPlan: $d4521f0694a3bb0e$var$isJiraPlan,
    isJiraVersion: $d4521f0694a3bb0e$var$isJiraVersion,
    isJiraForm: $d4521f0694a3bb0e$var$isJiraForm,
    isJiraSummary: $d4521f0694a3bb0e$var$isJiraSummary,
    isRovoAgentProfilePage: $d4521f0694a3bb0e$var$isRovoAgentProfilePage,
    isConfluenceTeamCalendars: $d4521f0694a3bb0e$var$isConfluenceTeamCalendars,
    isJiraIssueNavigator: $d4521f0694a3bb0e$var$isJiraIssueNavigator
};
function $d4521f0694a3bb0e$export$4006295459a20a0(url) {
    return Object.values($d4521f0694a3bb0e$export$da256e60841d38fd).some((checker)=>checker(url));
}
function $d4521f0694a3bb0e$export$78234eee43b97e81(url) {
    return !$d4521f0694a3bb0e$export$4006295459a20a0(url);
}
function $d4521f0694a3bb0e$var$getAppearanceForNode(node) {
    return node.type === 'blockCard' ? 'block' : node.type === 'embedCard' ? 'embed' : 'inline';
}
function $d4521f0694a3bb0e$var$isCardNode(node) {
    return [
        'inlineCard',
        'blockCard',
        'embedCard'
    ].includes(node.type) && !!node.attrs && 'url' in node.attrs && typeof node.attrs.url === 'string';
}
class $d4521f0694a3bb0e$export$e4635c0135e1a519 extends (0, $drRzc.NodeDataProvider) {
    refreshCache(node) {
        if (this.getCacheStatusForNode(node) !== 'network') this.getData(node, ()=>{});
    }
    getData(node, callback) {
        const jsonNode = 'toJSON' in node ? node.toJSON() : node;
        if (!this.isNodeSupported(jsonNode)) return;
        // if we can load a response from cache, use it first
        const key = this.nodeDataKey(jsonNode);
        const details = this.smartCardLocalCacheClient.getItem(key);
        // NAVX-4712: Handle responses with non-resolved statuses that were previously cached
        const isResolvedCachedResponse = details && details.meta && (0, $ggGdk.getStatus)(details) === 'resolved';
        if (isResolvedCachedResponse) callback({
            data: details
        });
        // if parent class NodeDataProvider has cached the network request for the node
        // we can skip fetching the data async and updating the document cache
        if (isResolvedCachedResponse && this.getCacheStatusForNode(jsonNode) === 'network') return;
        // fetch the latest data async and update the document cache
        this.getDataAsync(node, (payload)=>{
            const response = payload.data;
            if (!payload.error && response?.meta) {
                const status = (0, $ggGdk.getStatus)(response);
                if (status === 'resolved') this.smartCardLocalCacheClient.setItem(key, response);
            }
            callback(payload);
        });
    }
    nodeDataKey(node) {
        if (!(0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) return node.attrs.url;
        return `${node.attrs.url}|${$d4521f0694a3bb0e$var$getAppearanceForNode(node)}`;
    }
    fetchNodesData(nodes) {
        const promises = nodes.map((node)=>{
            const url = node.attrs.url;
            const appearance = (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? $d4521f0694a3bb0e$var$getAppearanceForNode(node) : undefined;
            return this.cardClient.fetchData(url, false, appearance);
        });
        return Promise.all(promises);
    }
    isNodeSupported(node) {
        if (!$d4521f0694a3bb0e$var$isCardNode(node)) return false;
        if (!this.supportedUrlFilter) return true;
        return this.supportedUrlFilter(node.attrs.url);
    }
    async batchProviders(keys) {
        // EDM-2205: Batch requests in the case that user paste multiple links at
        // once. This is so that only one /providersData is being called.
        const providersData = await this.fetchProvidersData();
        return keys.map(()=>providersData);
    }
    async checkLinkResolved(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return true;
        } catch  {
            return false;
        }
    }
    async fetchDataForResource(resourceUrl) {
        try {
            const response = await this.fetchData(resourceUrl);
            if ((0, $ggGdk.getStatus)(response) !== 'not_found') return response;
        } catch  {
            return undefined;
        }
    }
    extractAriFromData(responseData) {
        if (responseData.data && 'atlassian:ari' in responseData.data) return responseData.data['atlassian:ari'];
        return undefined;
    }
    async fetchProvidersData() {
        const endpoint = `${this.resolverUrl}/providers`;
        const response = await (0, $biKbJ.request)('post', endpoint, undefined, this.requestHeaders);
        return {
            patterns: response.providers.reduce((allSources, provider)=>{
                return allSources.concat(provider.patterns);
            }, []),
            userPreferences: response.userPreferences
        };
    }
    async loadProviderData() {
        try {
            this.providersData = await this.providersLoader.load('providersData');
        } catch (err) {
            // eslint-disable-next-line
            console.error('failed to fetch /providers', err);
            this.providersLoader.clear('providerData');
            return undefined;
        }
    }
    async findPattern(url) {
        return !!await this.findPatternData(url) || !!await this.checkLinkResolved(url);
    }
    doesUrlMatchPath(path, url) {
        // Using [a-zA-Z0-9] here instead of \w since that includes underscores
        const startingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_START_REGEX.test(path) ? '(^|[^a-zA-Z0-9])' : '';
        const endingRegex = $d4521f0694a3bb0e$var$DOES_URL_MATCH_PATH_END_REGEX.test(path) ? '($|[^a-zA-Z0-9])' : '';
        const escapedPath = path.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const regexPattern = new RegExp(`${startingRegex}${escapedPath}${endingRegex}`);
        return regexPattern.test(url);
    }
    async findUserPreference(url) {
        if (!this.providersData) await this.loadProviderData();
        const userPreferences = this.providersData?.userPreferences;
        if (userPreferences) {
            const { defaultAppearance: defaultAppearance, appearances: appearances } = userPreferences;
            const allMatchedLabeledAppearances = appearances.filter(({ urlSegment: urlSegment })=>this.doesUrlMatchPath(urlSegment, url));
            if (allMatchedLabeledAppearances.length > 0) {
                const longestMatchedLabeledAppearance = allMatchedLabeledAppearances.reduce((previousLabeledAppearance, currentLabeledAppearance)=>previousLabeledAppearance.urlSegment.length > currentLabeledAppearance.urlSegment.length ? previousLabeledAppearance : currentLabeledAppearance);
                return longestMatchedLabeledAppearance.appearance;
            }
            if (defaultAppearance !== 'inline') return defaultAppearance;
        }
    }
    async findPatternData(url) {
        if (!this.providersData) await this.loadProviderData();
        return this.providersData?.patterns.find((pattern)=>url.match(pattern.source));
    }
    /**
   *
   * Decides whether the url passed in should be embedded by default
   *
   * protected so that subclasses can override this in order to custom handle links embedded by default
   *
   * @param url
   * @returns 'embed' for the card appearance to embed by default
   */ getHardCodedAppearance(url) {
        // Replace directly with isJiraPlan(url) on cleanup
        const isJiraPlanEvaluated = $d4521f0694a3bb0e$var$isJiraPlan(url);
        const isJiraFormEvaluated = $d4521f0694a3bb0e$var$isJiraForm(url);
        const isJiraSummaryEvaluated = $d4521f0694a3bb0e$var$isJiraSummary(url);
        if ($d4521f0694a3bb0e$var$isJiraRoadmapOrTimeline(url) || $d4521f0694a3bb0e$var$isPolarisView(url) || $d4521f0694a3bb0e$var$isJwmView(url) || $d4521f0694a3bb0e$var$isJiraList(url) || $d4521f0694a3bb0e$var$isGiphyMedia(url) || $d4521f0694a3bb0e$var$isProformaView(url) || $d4521f0694a3bb0e$var$isConfluenceWhiteboard(url) || $d4521f0694a3bb0e$var$isConfluenceDatabase(url) || (0, $8kONW.isConfluenceSlideUrl)(url) || $d4521f0694a3bb0e$var$isYoutubeVideo(url) || $d4521f0694a3bb0e$var$isLoomVideoUrl(url) || $d4521f0694a3bb0e$var$isLoomPlaylistUrl(url) && (0, $iDrrr.fg)('loom-playlist-smartlink-embed-default') || $d4521f0694a3bb0e$var$isLoomScreenshotUrl(url) && (0, $iDrrr.fg)('loom-support-screenshot-sl-resolution') || $d4521f0694a3bb0e$var$isJiraDashboard(url) || $d4521f0694a3bb0e$var$isJiraBacklog(url) || $d4521f0694a3bb0e$var$isJiraBoard(url) || $d4521f0694a3bb0e$var$isRovoAgentProfilePage(url) || $d4521f0694a3bb0e$var$isJiraVersion(url) || isJiraPlanEvaluated || isJiraFormEvaluated || isJiraSummaryEvaluated || $d4521f0694a3bb0e$var$isCustomer360LandingPage(url) || $d4521f0694a3bb0e$var$isJiraIssueNavigator(url) || $d4521f0694a3bb0e$var$isAvpVisualizationView(url) || $d4521f0694a3bb0e$var$isArtifactsShareView(url) && (0, $iDrrr.fg)('platform_forge_ui_artifact_confluence_integration')) return 'embed';
    }
    async fetchData(url) {
        // it uses fetchNodesData internally and caches the result
        return await this.getDataAsPromise_DO_NOT_USE_OUTSIDE_MIGRATIONS({
            // It's ok to cast any resourceUrl to inlineCard here, because only URL is important for the request.
            type: 'inlineCard',
            attrs: {
                url: url
            }
        });
    }
    /**
   * Make a /resolve call and find out if result has embed capability
   */ async canBeResolvedAsEmbed(url) {
        try {
            const details = await this.fetchData(url);
            if (!details) return false;
            // Imagine response is "unauthorized". We won't be able to tell if even after auth
            // page going to have preview. Yes, we can show auth view for embed. But what if even after
            // success auth flow there won't be preview? We will already have ugly embed ADF.
            // Being on a safe side - if we get anything but resolved - we decide it can't be an embed.
            if ((0, $ggGdk.getStatus)(details) !== 'resolved') return false;
            const embed = (0, $8OcYi.extractSmartLinkEmbed)(details);
            return !!embed;
        } catch  {
            return false;
        }
    }
    /**
   * Opt-in hook: when a caller explicitly requests an `'embed'` appearance and the
   * user has no saved preference for the URL, honour that request as the default
   * (above any provider default), validating embeddability first and falling back
   * to a card (`'block'`) when the link cannot be embedded.
   *
   * Defaults to `false` so behaviour is unchanged for every existing consumer.
   * Subclasses (e.g. Confluence) can override this to opt in, typically behind an
   * experiment.
   */ shouldHonorRequestedEmbedAsDefault() {
        return false;
    }
    async getAuthStatusFromResolveResponse(url) {
        try {
            const { meta: { access: access, visibility: visibility } } = await this.fetchData(url);
            return {
                access: access,
                visibility: visibility
            };
        } catch  {
            return undefined;
        }
    }
    /**
   * Make a /resolve call and find out if result has datasource capability
   */ async getDatasourceFromResolveResponse(url) {
        try {
            const response = await this.fetchData(url);
            const datasources = response && response.datasources || [];
            if (datasources.length > 0) // For now we only have one datasource expected even though it is in an array.
            // When we have resources returning more than one we will have revisit this part.
            return datasources[0];
        } catch  {
            return undefined;
        }
    }
    /**
   * This is used to determine if the url is a local Jira url or a remote one.
   */ isLocalUrl(url) {
        return new URL(url).origin === this.baseUrl;
    }
    async resolve(url, appearance, shouldForceAppearance, isEmbedFriendlyLocation) {
        try {
            if (shouldForceAppearance === true) // At this point we don't need to check pattern nor call `check` because manual change means
            // this url is already supported and can be resolved. We want to ignore all other options and
            // respect user's choice.
            return this.transformer.toSmartlinkAdf(url, appearance);
            const hardCodedAppearance = this.getHardCodedAppearance(url);
            const [matchedProviderPattern, userPreference] = await Promise.all([
                this.findPatternData(url),
                this.findUserPreference(url)
            ]);
            if ($d4521f0694a3bb0e$export$6a9668b99d8a1708(url) && this.isLocalUrl(url)) {
                const data = await this.fetchDataForResource(url);
                if (data) {
                    const issueAri = this.extractAriFromData(data);
                    if (issueAri) this.onResolve?.(url, issueAri);
                }
            }
            if (shouldForceAppearance === false && userPreference === 'url') return Promise.reject(undefined);
            const isSupported = !!matchedProviderPattern || await this.checkLinkResolved(url);
            if (isSupported) {
                const providerDefaultAppearance = matchedProviderPattern?.defaultView;
                const isEmbedFriendlyLocationEvaluated = isEmbedFriendlyLocation || isEmbedFriendlyLocation === undefined;
                let preferredAppearance = shouldForceAppearance === undefined ? // Ignore both User and provider's appearances if older editor that doesn't send shouldForceAppearance
                hardCodedAppearance || appearance : // User preferred appearance. It would be either one that has matching domain/path pattern OR
                // if user's default choice is NOT "inline" (so, block or embed at this point, url was dealt with above)
                userPreference || // If user's default choice is "inline" or user hasn't specified preferences at all,
                // we check whatever one of the hardcoded providers match url (jira /timeline, polaris, etc)
                isEmbedFriendlyLocationEvaluated && hardCodedAppearance || // If non match, we see if this provider has default appearance for this particular regexp
                providerDefaultAppearance || // If not, we pick what editor (or any other client) requested
                appearance;
                if (preferredAppearance === userPreference && userPreference === 'embed') {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    if (!canItBeEmbed) preferredAppearance = 'inline';
                }
                // When a caller explicitly requested an embed (e.g. Confluence's quick-insert
                // embed flow tags the inserted link) and the user has no saved preference for
                // this URL, honour embed-by-default above the provider default — but only in an
                // embed-friendly location (matching how hard-coded embeds are gated above) and
                // only when the link can actually be embedded, otherwise fall back to a card.
                // Gated behind a default-off opt-in hook so other consumers are unaffected.
                if (!userPreference && appearance === 'embed' && isEmbedFriendlyLocationEvaluated && this.shouldHonorRequestedEmbedAsDefault()) {
                    const canItBeEmbed = await this.canBeResolvedAsEmbed(url);
                    preferredAppearance = canItBeEmbed ? 'embed' : 'block';
                }
                const datasource = await this.getDatasourceFromResolveResponse(url);
                if (datasource) {
                    const { id: id, parameters: parameters } = datasource;
                    return this.transformer.toDatasourceAdf({
                        id: id,
                        parameters: parameters,
                        // in the future when we support multiple views, we will need to pass this in as a parameter
                        // transform toDatasourceAdf to accept multiple views (like how how appearance for other other transforms are handled)
                        views: [
                            {
                                type: 'table'
                            }
                        ]
                    }, url);
                }
                if (isEmbedFriendlyLocationEvaluated && !userPreference) {
                    const authStatus = await this.getAuthStatusFromResolveResponse(url);
                    if (authStatus) {
                        const { access: access } = authStatus;
                        if (access === 'unauthorized') return this.transformer.toSmartlinkAdf(url, 'block');
                    }
                }
                return this.transformer.toSmartlinkAdf(url, preferredAppearance);
            }
        } catch (e) {
            // eslint-disable-next-line
            console.warn(`Error when trying to check Smart Card url "${url}"${e instanceof Error ? ` - ${e.name} ${e.message}` : ''}`, e);
        }
        return Promise.reject(undefined);
    }
    constructor(envKey, baseUrlOverride, product, onResolve, customCardClient, supportedUrlFilter){
        super();
        this.name = void 0;
        this.baseUrl = void 0;
        this.resolverUrl = void 0;
        this.providersData = void 0;
        this.requestHeaders = void 0;
        this.transformer = void 0;
        this.providersLoader = void 0;
        this.cardClient = void 0;
        this.smartCardLocalCacheClient = (0, $iyuxZ.SmartCardLocalCacheClient).getInstance();
        this.onResolve = void 0;
        this.supportedUrlFilter = void 0;
        this.name = 'editorCardProvider';
        this.baseUrl = baseUrlOverride || (0, $kzwaO.getBaseUrl)(envKey);
        this.resolverUrl = (0, $cXJjm.getResolverUrl)(envKey, baseUrlOverride);
        this.transformer = new (0, $koAyx.Transformer)();
        this.onResolve = onResolve;
        this.supportedUrlFilter = supportedUrlFilter;
        this.requestHeaders = {
            Origin: this.baseUrl
        };
        this.providersLoader = new (0, (/*@__PURE__*/$parcel$interopDefault($6Q8Dd)))((keys)=>this.batchProviders(keys), {
            batchScheduleFn: (callback)=>setTimeout(callback, $d4521f0694a3bb0e$var$BATCH_WAIT_TIME)
        });
        this.cardClient = customCardClient ?? new (0, $4yccB.default)(envKey, baseUrlOverride);
        if (!customCardClient && product) this.cardClient.setProduct(product);
    }
}
const $d4521f0694a3bb0e$export$b7c3c9a99f7959f5 = new $d4521f0694a3bb0e$export$e4635c0135e1a519();
module.exports["isInternalUrl"] = $d4521f0694a3bb0e$export$4006295459a20a0;
module.exports["isExternalUrl"] = $d4521f0694a3bb0e$export$78234eee43b97e81;
module.exports["EditorCardProvider"] = $d4521f0694a3bb0e$export$e4635c0135e1a519;
module.exports["editorCardProvider"] = $d4521f0694a3bb0e$export$b7c3c9a99f7959f5;

});

parcelRegister("biKbJ", function(module, exports) {
const $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $57ceb58159fd0951$export$bae979e68e4dc802 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(error){
        super(error);
    }
}
async function $57ceb58159fd0951$export$b5fe3f66a567bec0(method, url, // eslint-disable-next-line @typescript-eslint/no-explicit-any
data, headers) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || $57ceb58159fd0951$var$ALLOWED_RESPONSE_STATUS_CODES.includes(response.status)) return await response.json();
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $57ceb58159fd0951$export$bae979e68e4dc802(error);
        throw error;
    }
}
module.exports["request"] = $57ceb58159fd0951$export$b5fe3f66a567bec0;

});

parcelRegister("iyuxZ", function(module, exports) {
var $842937149a04b8ba$var$_SmartCardLocalCacheClient;
const $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS = 100;
class $842937149a04b8ba$export$1987ad1ab31f2528 {
    /**
   * Gets the singleton instance of SmartCardLocalCacheClient.
   * This ensures all callers share the same in-memory cache.
   * @param maxItems Maximum number of items to store in the cache (only used on first instantiation)
   * @returns The singleton instance
   */ static getInstance(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS) {
        if (!$842937149a04b8ba$export$1987ad1ab31f2528.instance) $842937149a04b8ba$export$1987ad1ab31f2528.instance = new $842937149a04b8ba$export$1987ad1ab31f2528(maxItems);
        return $842937149a04b8ba$export$1987ad1ab31f2528.instance;
    }
    /**
   * Resets the singleton instance. Only intended for testing purposes.
   * @internal
   */ static resetInstance() {
        $842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
    }
    constructor(maxItems = $842937149a04b8ba$var$SMART_CARD_CACHE_DEFAULT_MAX_ITEMS){
        this.maxItems = void 0;
        this.documentCache = {};
        /**
     * Retrieves the entire cache object from memory
     * @returns The entire cache object
     */ this.getCache = ()=>{
            return this.documentCache;
        };
        /**
     * Caches the SmartLinkResponse against the provided url
     * @param url The url (key) to store the response against
     * @param response The SmartLinkResponse to be cached
     */ this.setItem = (url, response)=>{
            this.documentCache[url] = {
                data: response,
                timestamp: Date.now()
            };
            const cacheKeys = Object.keys(this.documentCache);
            if (cacheKeys.length > this.maxItems) {
                const sortedKeys = cacheKeys.sort((a, b)=>this.documentCache[a].timestamp - this.documentCache[b].timestamp);
                const itemsToRemove = cacheKeys.length - this.maxItems;
                const keysToRemove = sortedKeys.slice(0, itemsToRemove);
                keysToRemove.forEach((key)=>{
                    delete this.documentCache[key];
                });
            }
        };
        /**
     * Retrieves the cached SmartLinkResponse for the provided url (if it exists)
     * @param url The url (key) to retrieve the cached response for
     * @returns The cached SmartLinkResponse if it exists, else undefined
     */ this.getItem = (url)=>{
            if (!url) return;
            return this.documentCache[url]?.data;
        };
        /**
     * Checks if a cached entry exists for the provided url
     * @param url The url (key) to check for existence in the cache
     * @returns True if a cached entry exists, else false
     */ this.isUrlInCache = (url)=>{
            return url in this.documentCache;
        };
        this.maxItems = maxItems;
    }
}
$842937149a04b8ba$var$_SmartCardLocalCacheClient = $842937149a04b8ba$export$1987ad1ab31f2528;
$842937149a04b8ba$export$1987ad1ab31f2528.instance = null;
module.exports["SmartCardLocalCacheClient"] = $842937149a04b8ba$export$1987ad1ab31f2528;

});

parcelRegister("koAyx", function(module, exports) {
class $b7cac00c977cfcad$export$f993aef960936087 {
    buildInlineAdf(url) {
        return {
            type: 'inlineCard',
            attrs: {
                url: url
            }
        };
    }
    buildBlockAdf(url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url
            }
        };
    }
    buildEmbedAdf(url) {
        return {
            type: 'embedCard',
            attrs: {
                url: url,
                layout: 'wide'
            }
        };
    }
    buildDatasourceAdf(datasource, url) {
        return {
            type: 'blockCard',
            attrs: {
                url: url,
                datasource: datasource
            }
        };
    }
    toSmartlinkAdf(url, appearance) {
        switch(appearance){
            case 'inline':
                return this.buildInlineAdf(url);
            case 'block':
                return this.buildBlockAdf(url);
            case 'embed':
                return this.buildEmbedAdf(url);
        }
    }
    toDatasourceAdf(datasource, url) {
        return this.buildDatasourceAdf(datasource, url);
    }
}
module.exports["Transformer"] = $b7cac00c977cfcad$export$f993aef960936087;

});

parcelRegister("8kONW", function(module, exports) {
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $025d94307c54f6b4$export$4091d55e0211d2e1 = (url)=>$025d94307c54f6b4$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);
module.exports["isConfluenceSlideUrl"] = $025d94307c54f6b4$export$4091d55e0211d2e1;

});

parcelRegister("cDpdq", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eRn3r = parcelRequire("eRn3r");


const $2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("iDlJN")));
const $2a3e0a8082e0a83e$var$DUMMY_PLUGIN_KEY = '__dummy_plugin__';
const $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS = [
    {
        tabKey: $2a3e0a8082e0a83e$var$DUMMY_PLUGIN_KEY,
        tabTitle: 'DUMMY_PLUGIN',
        resolve: ()=>Promise.resolve({
                data: []
            })
    }
];
const $2a3e0a8082e0a83e$export$5057fa778edd8de9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props, config)=>{
    const $ = (0, $bDgLe.c)(11);
    const shouldMergeAdditionalPlugins = props?.shouldMergeAdditionalPlugins ?? false;
    let t0;
    if ($[0] !== config || $[1] !== shouldMergeAdditionalPlugins) {
        t0 = (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props_0,
                config: config,
                shouldMergeAdditionalPlugins: shouldMergeAdditionalPlugins
            });
        $[0] = config;
        $[1] = shouldMergeAdditionalPlugins;
        $[2] = t0;
    } else t0 = $[2];
    const WrapperComponent = t0;
    let t1;
    if ($[3] !== props) {
        t1 = props ?? {};
        $[3] = props;
        $[4] = t1;
    } else t1 = $[4];
    let linkPickerProps;
    if ($[5] !== t1) {
        const { shouldMergeAdditionalPlugins: _shouldMergeAdditionalPlugins, ...t2 } = t1;
        linkPickerProps = t2;
        $[5] = t1;
        $[6] = linkPickerProps;
    } else linkPickerProps = $[6];
    const t2 = shouldMergeAdditionalPlugins && props?.plugins?.length ? props.plugins : $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS;
    let t3;
    if ($[7] !== WrapperComponent || $[8] !== linkPickerProps || $[9] !== t2) {
        t3 = {
            ...linkPickerProps,
            plugins: t2,
            component: WrapperComponent
        };
        $[7] = WrapperComponent;
        $[8] = linkPickerProps;
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : (props, config)=>{
    // TODO: When editor reactivity is fixed,
    // replace the below with useLinkPickerPlugins
    const shouldMergeAdditionalPlugins = props?.shouldMergeAdditionalPlugins ?? false;
    const WrapperComponent = (0, $cozmU.useMemo)(()=>(props_0)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2a3e0a8082e0a83e$var$LazyEditorLinkPickerRootComponentWithPlugins, {
                ...props_0,
                config: config,
                shouldMergeAdditionalPlugins: shouldMergeAdditionalPlugins
            });
        }, [
        config,
        shouldMergeAdditionalPlugins
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const { shouldMergeAdditionalPlugins: _shouldMergeAdditionalPlugins, ...linkPickerProps } = props ?? {};
        return {
            ...linkPickerProps,
            // We are providing an array of placeholder plugins
            // otherwise editor will not position the link picker correctly
            plugins: shouldMergeAdditionalPlugins && props?.plugins?.length ? props.plugins : $2a3e0a8082e0a83e$var$PLACEHOLDER_PLUGINS,
            component: WrapperComponent
        };
    }, [
        WrapperComponent,
        props,
        shouldMergeAdditionalPlugins
    ]);
};
module.exports["useLinkPickerEditorProps"] = $2a3e0a8082e0a83e$export$5057fa778edd8de9;

});

parcelRegister("iDlJN", function(module, exports) {

let $d90cbb274607f156$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d90cbb274607f156$var$load("5PKbS"),
    $d90cbb274607f156$var$load("hS8gF"),
    $d90cbb274607f156$var$load("6wr18"),
    $d90cbb274607f156$var$load("g8A75"),
    $d90cbb274607f156$var$load("4938u"),
    $d90cbb274607f156$var$load("jmTCk"),
    $d90cbb274607f156$var$load("9TOep"),
    $d90cbb274607f156$var$load("ffEVr"),
    $d90cbb274607f156$var$load("gQrOI"),
    $d90cbb274607f156$var$load("fmCjo")
]).then(()=>parcelRequire('et6nL'));

});

parcelRegister("hjUDQ", function(module, exports) {
var $3f94275ae089f93c$export$bdc3c19374266b98 = /*#__PURE__*/ function(ButtonStyle) {
    ButtonStyle["DEFAULT"] = "default";
    ButtonStyle["ALTERNATIVE_1"] = "alternative_1";
    return ButtonStyle;
}({});
var $3f94275ae089f93c$export$a6e645fda5339bf8 = /*#__PURE__*/ function(CornerStyle) {
    CornerStyle["ROUNDED"] = "rounded";
    CornerStyle["SQUARED"] = "squared";
    return CornerStyle;
}({});
var $3f94275ae089f93c$export$8954cfac7c08d16a = /*#__PURE__*/ function(Height) {
    Height["MEDIUM"] = "medium";
    Height["SMALL"] = "small";
    Height["LARGE"] = "large";
    return Height;
}({});
var $3f94275ae089f93c$export$9d7927214ed7d2cf = /*#__PURE__*/ function(Alignment) {
    Alignment["LEFT"] = "left";
    Alignment["RIGHT"] = "right";
    Alignment["CENTER"] = "center";
    return Alignment;
}({});
var $3f94275ae089f93c$export$df54d73aa0ec5e82 = /*#__PURE__*/ function(Orientation) {
    Orientation["ROW"] = "row";
    Orientation["STACKED"] = "stacked";
    return Orientation;
}({});
var $3f94275ae089f93c$export$21e76ed09a093e97 = /*#__PURE__*/ function(CardLayout) {
    CardLayout["FOLDERS"] = "folders";
    CardLayout["ACCORDIONS"] = "accordions";
    return CardLayout;
}({});
var $3f94275ae089f93c$export$42809f9f1496f50d = /*#__PURE__*/ function(CommonLayout) {
    CommonLayout["FRAME_ABOVE_IMAGE"] = "frame-above-image";
    CommonLayout["SPLIT_IMAGE_RIGHT"] = "split-image-right";
    CommonLayout["SPLIT_IMAGE_LEFT"] = "split-image-left";
    CommonLayout["FULL_IMAGE_BACKGROUND"] = "full-image-background";
    CommonLayout["NO_IMAGE_BACKGROUND"] = "no-image-background";
    return CommonLayout;
}({});
var $3f94275ae089f93c$export$d4c0482bf980ef26 = /*#__PURE__*/ function(FeedbackType) {
    FeedbackType["CARDS"] = "Cards";
    FeedbackType["CAROUSEL"] = "Carousel";
    FeedbackType["COMPANY_HUB"] = "Company hub";
    FeedbackType["CUSTOMIZE_NAVIGATION"] = "Customize Navigation";
    FeedbackType["LINKS_MENU"] = "Links menu";
    FeedbackType["SPOTLIGHT"] = "Spotlight";
    FeedbackType["SECTION"] = "Section";
    FeedbackType["CUSTOM_SEARCH"] = "Custom search";
    return FeedbackType;
}({});
var $3f94275ae089f93c$export$533ae1c1b7b7ac6 = /*#__PURE__*/ function(ExtensionMode) {
    ExtensionMode["RENDERER"] = "renderer";
    ExtensionMode["EDITOR"] = "editor";
    return ExtensionMode;
}({});
const $3f94275ae089f93c$export$cb307dad255adf47 = 'epic.logout.LOG_OUT';
var $3f94275ae089f93c$export$1f60141b6ce5efed = /*#__PURE__*/ function(RenderVariant) {
    RenderVariant["MANUAL"] = "manual";
    RenderVariant["DYNAMIC"] = "dynamic";
    return RenderVariant;
}({});
var $3f94275ae089f93c$export$f6cd408cac7f930c = /*#__PURE__*/ function(SegmentationTargets) {
    SegmentationTargets["ALL"] = "all";
    SegmentationTargets["EACH"] = "each";
    return SegmentationTargets;
}({});
var $3f94275ae089f93c$export$bf7ebf7fed6e7189 = /*#__PURE__*/ function(ITEM_FIELDS) {
    ITEM_FIELDS["CARD_ID"] = "cardId";
    ITEM_FIELDS["TITLE"] = "title";
    ITEM_FIELDS["IS_TITLE_USER_EDITED"] = "isTitleUserEdited";
    ITEM_FIELDS["DESCRIPTION"] = "description";
    ITEM_FIELDS["IS_DESCRIPTION_USER_EDITED"] = "isDescriptionUserEdited";
    ITEM_FIELDS["IS_DESCRIPTION_SHOWN"] = "isDescriptionShown";
    ITEM_FIELDS["LABEL"] = "label";
    ITEM_FIELDS["IS_LABEL_HIDDEN"] = "isLabelHidden";
    ITEM_FIELDS["LINK"] = "link";
    ITEM_FIELDS["IS_LINK_USER_EDITED"] = "isLinkUserEdited";
    ITEM_FIELDS["IMAGE_SRC"] = "imageSrc";
    ITEM_FIELDS["CONFLUENCE_PAGE_ID"] = "confluencePageId";
    ITEM_FIELDS["IMAGE_ALT_TEXT"] = "imageAltText";
    ITEM_FIELDS["SEGMENTATION_TARGETS"] = "segmentationTarget";
    ITEM_FIELDS["AUDIENCE_SEGMENTATION_GROUP_IDS"] = "audienceSegmentationGroupIds";
    // group preferences stored via this field when segmentationTarget is EACH
    ITEM_FIELDS["LINK_RESOURCE_TYPE"] = "linkResourceType";
    ITEM_FIELDS["BACKGROUND_COLOR"] = "backgroundColor";
    ITEM_FIELDS["TEXT_COLOR"] = "textColor";
    ITEM_FIELDS["LABEL_COLOR"] = "labelColor";
    ITEM_FIELDS["LAYOUT"] = "layout";
    ITEM_FIELDS["IS_BUTTON_SHOWN"] = "isButtonShown";
    ITEM_FIELDS["BUTTON_TEXT"] = "buttonText";
    ITEM_FIELDS["BUTTON_STYLE"] = "buttonStyle";
    ITEM_FIELDS["HEIGHT"] = "height";
    return ITEM_FIELDS;
}({});
module.exports["ButtonStyle"] = $3f94275ae089f93c$export$bdc3c19374266b98;
module.exports["CornerStyle"] = $3f94275ae089f93c$export$a6e645fda5339bf8;
module.exports["Height"] = $3f94275ae089f93c$export$8954cfac7c08d16a;
module.exports["Alignment"] = $3f94275ae089f93c$export$9d7927214ed7d2cf;
module.exports["Orientation"] = $3f94275ae089f93c$export$df54d73aa0ec5e82;
module.exports["CardLayout"] = $3f94275ae089f93c$export$21e76ed09a093e97;
module.exports["CommonLayout"] = $3f94275ae089f93c$export$42809f9f1496f50d;
module.exports["FeedbackType"] = $3f94275ae089f93c$export$d4c0482bf980ef26;
module.exports["ExtensionMode"] = $3f94275ae089f93c$export$533ae1c1b7b7ac6;
module.exports["RenderVariant"] = $3f94275ae089f93c$export$1f60141b6ce5efed;
module.exports["SegmentationTargets"] = $3f94275ae089f93c$export$f6cd408cac7f930c;
module.exports["ITEM_FIELDS"] = $3f94275ae089f93c$export$bf7ebf7fed6e7189;

});

parcelRegister("6THkE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $03RpJ = parcelRequire("03RpJ");


var $bdpeX = parcelRequire("bdpeX");


var $b8pma = parcelRequire("b8pma");


var $bktnv = parcelRequire("bktnv");


var $bQmwQ = parcelRequire("bQmwQ");


var $8Yw12 = parcelRequire("8Yw12");


var $da5jE = parcelRequire("da5jE");

const $bbbb0ea9e387a71a$var$LINKS_MENU_VERSION_1 = '1';

const $bbbb0ea9e387a71a$var$LinksMenuExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "l5-_n",
    name: "LinksMenuExtension",
    loader: async ()=>(await (parcelRequire("59rm3"))).LinksMenuExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "links-menu-extension-loader"
        })
});
const $bbbb0ea9e387a71a$export$e0faacd43528e300 = {
    alignment: (0, $8Yw12.ALIGNMENT).CENTER,
    fillColor: "var(--ds-surface-overlay, #FFFFFF)",
    borderColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    border: (0, $8Yw12.BORDER).NONE,
    cornerStyle: (0, $8Yw12.CORNERS).SHARP,
    textColor: "var(--ds-text, #292A2E)",
    highlightColor: "var(--ds-text, #292A2E)"
};
const $bbbb0ea9e387a71a$var$getParameters = ({ formatMessage: formatMessage, defaultParameters: defaultParameters })=>({
        extensionTitle: formatMessage((0, $da5jE.messages).lozengeTitle),
        version: $bbbb0ea9e387a71a$var$LINKS_MENU_VERSION_1,
        styles: {
            ...$bbbb0ea9e387a71a$export$e0faacd43528e300,
            // Pre-v2 behaviour (preserved verbatim from master): when help-center
            // passes `defaultParameters` (legacy `var(--hub-primary-color, ...)`
            // shape), both `fillColor` AND `borderColor` mirror the brand-tinted
            // bg so the menu chip blends visually with the rest of the page chrome.
            ...defaultParameters?.backgroundColor ? {
                fillColor: defaultParameters.backgroundColor,
                borderColor: defaultParameters.backgroundColor
            } : {},
            // Advanced-theming (v2) override: spec says the day-0 border for new
            // links-menu inserts should be the neutral `color.border` hex, not the
            // bg-mirroring shade above. Fires *after* the legacy block so it wins.
            // Gated explicitly on the v2 flag — legacy help-center, Confluence,
            // and CSM all see `isAdvancedThemingEnabled !== true` and skip this.
            ...defaultParameters?.isAdvancedThemingEnabled ? {
                borderColor: '#DCDFE4'
            } : {},
            // Corner default is gate-aware. The legacy default is `CORNERS.SHARP`,
            // which the gated render maps to a 0px *local override* — so a brand-new
            // menu would be pinned to 0px and never follow the hub-wide radius. When
            // advanced theming is on, default to `CORNERS.ROUND` instead: it resolves
            // to "no override", so the menu inherits (and keeps tracking)
            // `--hub-corner-radius` until the admin picks an explicit value on the
            // slider. Gate off (Confluence Company Hub / CSM / legacy) keeps SHARP.
            ...defaultParameters?.isAdvancedThemingEnabled ? {
                cornerStyle: (0, $8Yw12.CORNERS).ROUND
            } : {},
            ...defaultParameters?.textColor ? {
                textColor: defaultParameters.textColor,
                highlightColor: defaultParameters.textColor
            } : {}
        },
        items: [
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, $03RpJ.default)(),
                type: (0, $8Yw12.ITEM).LINK,
                title: formatMessage((0, $da5jE.messages).firstDefaultItem),
                link: ''
            },
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, $03RpJ.default)(),
                type: (0, $8Yw12.ITEM).LINK,
                title: formatMessage((0, $da5jE.messages).secondDefaultItem),
                link: ''
            },
            {
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                itemId: (0, $03RpJ.default)(),
                type: (0, $8Yw12.ITEM).MENU,
                title: formatMessage((0, $da5jE.messages).thirdDefaultItem),
                childItems: [
                    {
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        itemId: (0, $03RpJ.default)(),
                        type: (0, $8Yw12.ITEM).LINK,
                        title: formatMessage((0, $da5jE.messages).nestedDefaultItem),
                        link: ''
                    }
                ]
            }
        ]
    });

const $bbbb0ea9e387a71a$export$7c3934f2ad869115 = async ({ contentId: contentId, propsProvider: propsProvider, mode: mode, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const parameters = $bbbb0ea9e387a71a$var$getParameters({
            formatMessage: intl.formatMessage,
            defaultParameters: defaultParameters
        });
        return new (0, $bdpeX.default)([
            (0, $bktnv.getExtensionManifest)({
                title: intl.formatMessage((0, $da5jE.messages).lozengeTitle),
                type: (0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE),
                key: 'links-menu',
                description: intl.formatMessage((0, $da5jE.messages).linksMenuDescription),
                icons: {
                    '48': ()=>(parcelRequire("1rKaD")).then((mod)=>mod.LinksMenuExtensionIcon)
                },
                parameters: parameters,
                update: async ()=>{
                    const selectedNode = editorActions?.getSelectedNode()?.toJSON();
                    const selectedLocalId = selectedNode?.attrs?.localId;
                    if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
                },
                render: async ()=>({ node: node })=>{
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bbbb0ea9e387a71a$var$LinksMenuExtension, {
                            extensionNode: node,
                            contentId: contentId,
                            propsProvider: propsProvider,
                            mode: mode
                        });
                    },
                // @TODO add links menu upsell in COMPHUB-2408
                setUpsellModalSource: undefined,
                source: 'premiumCarouselInsert'
            })
        ]);
    };
};
module.exports["DEFAULT_STYLES"] = $bbbb0ea9e387a71a$export$e0faacd43528e300;
module.exports["linksMenuExtensionProvider"] = $bbbb0ea9e387a71a$export$7c3934f2ad869115;

});

parcelRegister("bdpeX", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $54Kws = parcelRequire("54Kws");

class $88516670672fc955$export$2e2bcd8739ae039 {
    getExtensions() {
        return this.manifestsPromise;
    }
    async preload() {
        this.manifestsCache = await this.getExtensions();
        const preloadCalls = [];
        for (const manifest of this.manifestsCache){
            const nodes = manifest?.modules?.nodes;
            if (nodes) Object.values(nodes).forEach((node)=>{
                preloadCalls.push(node?.preloadRender?.());
            });
        }
        await Promise.allSettled(preloadCalls);
    }
    /**
   * Synchronously returns an extension from the manifests loaded by `preload`. Returns undefined when
   * the extension is not preloaded, so callers can fall back to the asynchronous `getExtension`.
   */ getPreloadedExtension(type, key) {
        if ((0, $iDrrr.fg)('platform_editor_preloaded_extension_not_found')) return this.findExtensionInManifests(this.manifestsCache, type, key);
        if (!this.manifestsCache) return;
        return this.getExtensionFromManifest(this.manifestsCache, type, key);
    }
    async getExtension(type, key) {
        return this.getExtensionFromManifest(await this.manifestsPromise, type, key);
    }
    findExtensionInManifests(manifests, type, key) {
        return manifests.find((manifest)=>manifest.type === type && manifest.key === key);
    }
    getExtensionFromManifest(manifests, type, key) {
        const extension = this.findExtensionInManifests(manifests, type, key);
        if (!extension) throw new Error(`Extension with type "${type}" and key "${key}" not found!`);
        return extension;
    }
    async search(keyword) {
        const extensions = (await this.manifestsPromise).filter((manifest)=>manifest.title.toLowerCase().includes(keyword.toLowerCase()));
        return extensions;
    }
    async getAutoConverter() {
        if (this.autoConvertHandlers) return this.autoConvertHandlers;
        const autoConverters = (0, $54Kws.getAutoConvertPatternsFromModule)(await this.manifestsPromise);
        return autoConverters;
    }
    constructor(manifests, /**
   * Allows for an optional list of pre compiled auto convert handlers to be passed.
   * Useful for performance improvements or to support legacy converters.
   *
   * Warning: If this attribute is passed, this provider will ignore auto convert patterns from the manifests.
   */ autoConvertHandlers){
        this.manifestsPromise = void 0;
        this.manifestsCache = [];
        this.autoConvertHandlers = void 0;
        this.manifestsPromise = Promise.resolve(manifests);
        this.autoConvertHandlers = autoConvertHandlers;
    }
}
module.exports["default"] = $88516670672fc955$export$2e2bcd8739ae039;

});

parcelRegister("54Kws", function(module, exports) {
async function $4782fc034cf1736f$export$60407594ea5edd1c(extensions) {
    const items = await Promise.all(extensions.map((manifest)=>{
        if (manifest.modules.autoConvert && manifest.modules.autoConvert.url) return manifest.modules.autoConvert.url;
        return [];
    }));
    return [].concat(...items);
}
module.exports["getAutoConvertPatternsFromModule"] = $4782fc034cf1736f$export$60407594ea5edd1c;

});

parcelRegister("8Yw12", function(module, exports) {
var $9938aa9e143976c7$export$25d99ac3e552cf7a = /*#__PURE__*/ function(ITEM) {
    ITEM["LINK"] = "link";
    ITEM["MENU"] = "menu";
    return ITEM;
}({});
var $9938aa9e143976c7$export$470d0905851e47a1 = /*#__PURE__*/ function(ALIGNMENT) {
    ALIGNMENT["LEFT"] = "left";
    ALIGNMENT["CENTER"] = "center";
    ALIGNMENT["RIGHT"] = "right";
    return ALIGNMENT;
}({});
var $9938aa9e143976c7$export$8a9179e387c60c17 = /*#__PURE__*/ function(BORDER) {
    BORDER["NONE"] = "none";
    BORDER["ALL_SIDES"] = "all_sides";
    BORDER["BOTTOM"] = "bottom";
    return BORDER;
}({});
var $9938aa9e143976c7$export$87780c3e8dee494d = /*#__PURE__*/ function(CORNERS) {
    CORNERS["ROUND"] = "round";
    CORNERS["SHARP"] = "sharp";
    return CORNERS;
}({});
module.exports["ITEM"] = $9938aa9e143976c7$export$25d99ac3e552cf7a;
module.exports["ALIGNMENT"] = $9938aa9e143976c7$export$470d0905851e47a1;
module.exports["BORDER"] = $9938aa9e143976c7$export$8a9179e387c60c17;
module.exports["CORNERS"] = $9938aa9e143976c7$export$87780c3e8dee494d;

});

parcelRegister("da5jE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4296b183500f3807$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    lozengeTitle: {
        id: "company-hub.links-menu-extension.manifest.extension-lozenge-title",
        defaultMessage: "Links menu"
    },
    linksMenuDescription: {
        id: "company-hub.links-menu-extension.manifest.extension-description",
        defaultMessage: "Add multiple links and sub-menus to Company Hub"
    },
    firstDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.first-default-item",
        defaultMessage: "About us"
    },
    secondDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.second-default-item",
        defaultMessage: "Benefits"
    },
    thirdDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.third-default-item",
        defaultMessage: "Teams"
    },
    nestedDefaultItem: {
        id: "company-hub.links-menu-extension.manifest.nested-default-item",
        defaultMessage: "Team 1"
    }
});
module.exports["messages"] = $4296b183500f3807$export$defe85febe8b728c;

});

parcelRegister("59rm3", function(module, exports) {

let $3c03031bd1bd8c52$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c03031bd1bd8c52$var$load("3CJiR"),
    $3c03031bd1bd8c52$var$load("6vAHn")
]).then(()=>parcelRequire('1wiCI'));

});

parcelRegister("1rKaD", function(module, exports) {

let $10dc20922be43d56$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $10dc20922be43d56$var$load("hAyMj").then(()=>parcelRequire('jEIhu'));

});

parcelRegister("87QCv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $bdpeX = parcelRequire("bdpeX");


var $b8pma = parcelRequire("b8pma");


var $5KWZf = parcelRequire("5KWZf");


var $bktnv = parcelRequire("bktnv");


var $jDh8Q = parcelRequire("jDh8Q");


var $69Xl7 = parcelRequire("69Xl7");


const $cfc0028c4e22d32a$var$SectionExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "r-pUQ",
    name: "SectionExtension",
    loader: async ()=>(await (parcelRequire("jfODh"))).SectionExtension,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "section-extension-loader"
        })
});
const $cfc0028c4e22d32a$var$sectionParameters = (intl, defaultBackgroundColor)=>({
        extensionTitle: intl.formatMessage((0, $69Xl7.messages).lozengeTitle),
        backgroundColor: defaultBackgroundColor,
        contentWidth: (0, $jDh8Q.DEFAULT_CONTENT_WIDTH)
    });

const $cfc0028c4e22d32a$export$6775abcfdb3b0453 = ({ getSectionExtensionContents: getSectionExtensionContents, mode: mode, propsProvider: propsProvider, defaultParameters: defaultParameters })=>async ({ contentId: contentId, editorActions: editorActions, openConfigPanel: openConfigPanel, intl: intl })=>{
        const title = intl.formatMessage((0, $69Xl7.messages).lozengeTitle);
        const description = intl.formatMessage((0, $69Xl7.messages).description);
        // Only honour the v2 seed when advanced theming is on. Falls back to the
        // legacy `DEFAULT_BACKGROUND_COLOR` for Confluence/CSM/gate-OFF help-center.
        const defaultBackgroundColor = defaultParameters?.isAdvancedThemingEnabled && defaultParameters.backgroundColor ? defaultParameters.backgroundColor : (0, $jDh8Q.DEFAULT_BACKGROUND_COLOR);
        const parameters = $cfc0028c4e22d32a$var$sectionParameters(intl, defaultBackgroundColor);
        const type = (0, $5KWZf.SECTION_EXTENSION_TYPE);
        const key = (0, $jDh8Q.SECTION_EXTENSION_KEY);
        const initialContentText = {
            header: intl.formatMessage((0, $69Xl7.messages).contentHeader),
            subHeader: intl.formatMessage((0, $69Xl7.messages).contentSubHeader),
            placeholderTitle: intl.formatMessage((0, $69Xl7.messages).placeHolderTitle)
        };
        const icons = {
            '48': ()=>Promise.resolve((parcelRequire("jo8MM"))).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const update = async ()=>{
            const selectedNode = editorActions?.getSelectedNode()?.toJSON();
            const selectedLocalId = selectedNode?.attrs?.localId;
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        const render = async ()=>({ node: node, actions: actions })=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cfc0028c4e22d32a$var$SectionExtension, {
                    contentId: contentId,
                    extensionNode: node,
                    editorActions: editorActions,
                    mbeActions: actions,
                    mode: mode,
                    propsProvider: propsProvider
                });
            };
        const additionalModuleNodeProps = {
            __allowBodiedOverride: true
        };
        return new (0, $bdpeX.default)([
            (0, $bktnv.getExtensionManifest)({
                key: key,
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                source: 'premiumSectionInsert',
                nodeType: 'multiBodiedExtension',
                quickInsertAction: async ()=>Promise.resolve({
                        type: 'multiBodiedExtension',
                        key: 'hub-section',
                        attrs: {
                            extensionType: type,
                            extensionKey: 'hub-section',
                            layout: 'full-width',
                            parameters: parameters
                        },
                        content: getSectionExtensionContents(initialContentText)
                    }),
                additionalModuleNodeProps: additionalModuleNodeProps
            })
        ]);
    };
module.exports["sectionExtensionProvider"] = $cfc0028c4e22d32a$export$6775abcfdb3b0453;

});

parcelRegister("jDh8Q", function(module, exports) {
const $a848882170411a45$export$bc69bf23ec1f99d5 = 'hub-section';
const $a848882170411a45$export$7a75cc6a69e05549 = 'hub-sectionExtensionConfig';
var $a848882170411a45$export$3130b484681bf8bc = /*#__PURE__*/ function(CONTENT_WIDTH) {
    CONTENT_WIDTH["NARROW"] = "narrow";
    CONTENT_WIDTH["WIDE"] = "wide";
    CONTENT_WIDTH["FULL"] = "full";
    return CONTENT_WIDTH;
}({});
const $a848882170411a45$export$6cccba5fae1d609d = "wide";
const $a848882170411a45$export$617cdcc6afaae4f7 = "var(--ds-surface-overlay, #FFFFFF)";
module.exports["SECTION_EXTENSION_KEY"] = $a848882170411a45$export$bc69bf23ec1f99d5;
module.exports["SECTION_EXTENSION_ANALYTICS_SOURCE"] = $a848882170411a45$export$7a75cc6a69e05549;
module.exports["CONTENT_WIDTH"] = $a848882170411a45$export$3130b484681bf8bc;
module.exports["DEFAULT_CONTENT_WIDTH"] = $a848882170411a45$export$6cccba5fae1d609d;
module.exports["DEFAULT_BACKGROUND_COLOR"] = $a848882170411a45$export$617cdcc6afaae4f7;

});

parcelRegister("69Xl7", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $8fc561d04607119e$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    lozengeTitle: {
        id: "company-hub.section-extension.manifest.extension-lozenge-title",
        defaultMessage: "Section"
    },
    description: {
        id: "company-hub.section-extension.manifest.macro-description",
        defaultMessage: "Group elements together with a background"
    },
    contentHeader: {
        id: "company-hub.section-extension.manifest.content.header",
        defaultMessage: "Give your section a title"
    },
    contentSubHeader: {
        id: "company-hub.section-extension.manifest.content.sub-header",
        defaultMessage: "Organize elements into sections with customizable backgrounds."
    },
    placeHolderTitle: {
        id: "company-hub.section-extension.manifest.content.placeholder-title",
        defaultMessage: "Placeholder"
    }
});
module.exports["messages"] = $8fc561d04607119e$export$defe85febe8b728c;

});

parcelRegister("jfODh", function(module, exports) {

let $e046b197e8cdc0d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e046b197e8cdc0d7$var$load("lgdFu"),
    $e046b197e8cdc0d7$var$load("d9bN1"),
    $e046b197e8cdc0d7$var$load("5NX6D")
]).then(()=>parcelRequire('kkFKP'));

});

parcelRegister("aNrj7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $bdpeX = parcelRequire("bdpeX");


var $l0P92 = parcelRequire("l0P92");


var $lPJNC = parcelRequire("lPJNC");


var $b8pma = parcelRequire("b8pma");


var $5KWZf = parcelRequire("5KWZf");


var $bktnv = parcelRequire("bktnv");


var $hjUDQ = parcelRequire("hjUDQ");


var $1NMjw = parcelRequire("1NMjw");


var $3qjtL = parcelRequire("3qjtL");


const $c5740a6cfacb53db$var$SpotlightExtension = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "p5n9G",
    name: "SpotlightExtension",
    loader: async ()=>(await (parcelRequire("6m1zT"))).Spotlight,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "spotlight-extension-loader"
        })
});
const $c5740a6cfacb53db$export$bc4319ada86b358d = ({ intl: intl, defaultParameters: defaultParameters })=>({
        extensionTitle: intl.formatMessage((0, $3qjtL.i18n).title),
        height: (0, $hjUDQ.Height).MEDIUM,
        backgroundColor: defaultParameters?.backgroundColor ?? "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
        cornerStyle: (0, $hjUDQ.CornerStyle).ROUNDED,
        layout: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT,
        content: {
            text: {
                title: intl.formatMessage((0, $3qjtL.i18n).initialTitleParameter),
                description: intl.formatMessage((0, $3qjtL.i18n).initialDescriptionParameter),
                textColor: defaultParameters?.textColor ?? "var(--ds-text, #292A2E)"
            },
            button: {
                isButtonShown: false,
                text: '',
                link: '',
                style: (0, $hjUDQ.ButtonStyle).DEFAULT
            },
            image: {
                imageSrc: 'https://images.unsplash.com/photo-1527519135413-1e146b552e10?q=80&w=2940&auto=format',
                altText: intl.formatMessage((0, $3qjtL.i18n).initialImageAltTextParameter)
            }
        }
    });

const $c5740a6cfacb53db$export$10b21ce9d2029ff1 = async ({ contentId: contentId, propsProvider: propsProvider, defaultParameters: defaultParameters })=>{
    return async ({ editorActions: editorActions, openConfigPanel: openConfigPanel, setUpsellModalSource: setUpsellModalSource, intl: intl })=>{
        const title = intl.formatMessage((0, $3qjtL.i18n).title);
        const description = intl.formatMessage((0, $3qjtL.i18n).description);
        const type = (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE);
        const render = async ()=>({ node: node })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c5740a6cfacb53db$var$SpotlightExtension, {
                    isInEditor: true,
                    contentId: contentId,
                    extensionNode: node,
                    PropsProvider: propsProvider
                });
        const icons = {
            // eslint-disable-next-line import/dynamic-import-chunkname
            '48': ()=>Promise.resolve((parcelRequire("jo8MM"))).then(({ default: PremiumIcon })=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PremiumIcon, {
                            color: "var(--ds-icon-subtle, #505258)",
                            label: "",
                            spacing: "spacious"
                        }))
        };
        const parameters = $c5740a6cfacb53db$export$bc4319ada86b358d({
            intl: intl,
            defaultParameters: defaultParameters
        });
        const update = async ()=>{
            const selectedNode = editorActions?.getSelectedNode()?.toJSON();
            const selectedLocalId = selectedNode?.attrs?.localId;
            // missing openConfigPanel and editorActions
            if (!!selectedLocalId && openConfigPanel) openConfigPanel(selectedLocalId);
        };
        return new (0, $bdpeX.default)([
            (0, $bktnv.getExtensionManifest)({
                preview: {
                    image: {
                        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJP.png',
                        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMS.png'
                    },
                    attribution: {
                        name: intl.formatMessage((0, $lPJNC.messages).previewAttributionConfluence),
                        icon: (0, $l0P92.ConfluenceAttributionIcon)
                    }
                },
                key: (0, $1NMjw.SPOTLIGHT_EXTENSION_KEY),
                icons: icons,
                parameters: parameters,
                update: update,
                render: render,
                title: title,
                type: type,
                description: description,
                setUpsellModalSource: setUpsellModalSource,
                source: 'premiumSpotlightInsert'
            })
        ]);
    };
};
module.exports["spotlightParameters"] = $c5740a6cfacb53db$export$bc4319ada86b358d;
module.exports["spotlightExtensionProvider"] = $c5740a6cfacb53db$export$10b21ce9d2029ff1;

});

parcelRegister("1NMjw", function(module, exports) {

var $hjUDQ = parcelRequire("hjUDQ");


var $9ltNi = parcelRequire("9ltNi");

const $e794509a5ea2ab20$export$8434ce10552078fe = 'spotlight';
const $e794509a5ea2ab20$export$af1b061943ec63f0 = [
    {
        label: (0, $9ltNi.i18n).splitDesignContentFirstLabel,
        description: (0, $9ltNi.i18n).splitDesignContentFirstDescription,
        value: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_RIGHT
    },
    {
        label: (0, $9ltNi.i18n).splitDesignImageFirstLabel,
        description: (0, $9ltNi.i18n).splitDesignImageFirstDescription,
        value: (0, $hjUDQ.CommonLayout).SPLIT_IMAGE_LEFT
    },
    {
        label: (0, $9ltNi.i18n).solidColorBackgroundLabel,
        description: (0, $9ltNi.i18n).solidColorBackgroundDescription,
        value: (0, $hjUDQ.CommonLayout).NO_IMAGE_BACKGROUND
    },
    {
        label: (0, $9ltNi.i18n).frameAboveImageLabel,
        description: (0, $9ltNi.i18n).frameAboveImageDescription,
        value: (0, $hjUDQ.CommonLayout).FRAME_ABOVE_IMAGE
    }
];
module.exports["SPOTLIGHT_EXTENSION_KEY"] = $e794509a5ea2ab20$export$8434ce10552078fe;
module.exports["layoutOptions"] = $e794509a5ea2ab20$export$af1b061943ec63f0;

});

parcelRegister("9ltNi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f98976740a1f360f$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    splitDesignContentFirstLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.label",
        defaultMessage: "Split design (content first)"
    },
    splitDesignContentFirstDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-content-first.description",
        defaultMessage: "Large image on the right with lots of room for content"
    },
    splitDesignImageFirstLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.label",
        defaultMessage: "Split design (image first)"
    },
    splitDesignImageFirstDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.split-design-image-first.description",
        defaultMessage: "Large image on the left with lots of room for content"
    },
    solidColorBackgroundLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.label",
        defaultMessage: "Solid color background"
    },
    solidColorBackgroundDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.solid-color-background.description",
        defaultMessage: "Content in front of a full-width color"
    },
    frameAboveImageLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.label",
        defaultMessage: "Content frame inside image"
    },
    frameAboveImageDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.frame-above-image.description",
        defaultMessage: "Text box overlay on a large image"
    },
    // We will eventually use these translations when full background layout is properly introduced
    imageBackgroundLabel: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.label",
        defaultMessage: "Image background"
    },
    imageBackgroundDescription: {
        id: "company-hub.spotlight-extension.spotlight-config-panel.layouts.image-background.description",
        defaultMessage: "Full-size image behind your content"
    }
});
module.exports["i18n"] = $f98976740a1f360f$export$a7357cdd1f0b0168;

});

parcelRegister("3qjtL", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $226565a51fa3f7c4$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    title: {
        id: "company-hub.spotlight-extension.manifest.macro-title",
        defaultMessage: "Spotlight"
    },
    description: {
        id: "company-hub.spotlight-extension.manifest.macro-description",
        defaultMessage: "Highlight messages with a visual spotlight"
    },
    initialTitleParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.text-title",
        defaultMessage: "Give your spotlight a title"
    },
    initialDescriptionParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.text-description",
        defaultMessage: "Design a spotlight to highlight your most vital information. Bring the most important messages to life with custom colors, a powerful image, and flexible layouts."
    },
    initialImageAltTextParameter: {
        id: "company-hub.spotlight-extension.manifest.initial-state.alt-image-text",
        defaultMessage: "Landscape photography of desert"
    }
});
module.exports["i18n"] = $226565a51fa3f7c4$export$a7357cdd1f0b0168;

});

parcelRegister("6m1zT", function(module, exports) {

let $4a06057b6ecdb522$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4a06057b6ecdb522$var$load("boOz1"),
    $4a06057b6ecdb522$var$load("coGVA"),
    $4a06057b6ecdb522$var$load("RI3SR"),
    $4a06057b6ecdb522$var$load("96rwC")
]).then(()=>parcelRequire('fwVKa'));

});

parcelRegister("fYRS9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lpNn5 = parcelRequire("lpNn5");


var $1Bu5C = parcelRequire("1Bu5C");

/**
 * __Bidi Warning__
 *
 * A component used to render a bidi character warning.
 * A bidi character can be used to perform a "bidi override attack".
 *
 * See https://hello.atlassian.net/wiki/spaces/PRODSEC/pages/1347434677/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability#1)-Providing-visual-cues-for-our-Customers-in-our-affected-products
 */ const $75f6060a0eba078d$var$BidiWarning = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BidiWarning(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: t1 } = t0;
    const label = t1 === undefined ? "Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code." : t1;
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) {
        const t2 = shouldSkip ? null : bidiCharacter;
        let t3;
        if ($[0] !== bidiCharacter || $[1] !== t2 || $[2] !== testId) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1Bu5C.Decorator), {
                testId: testId,
                bidiCharacter: bidiCharacter,
                children: t2
            });
            $[0] = bidiCharacter;
            $[1] = t2;
            $[2] = testId;
            $[3] = t3;
        } else t3 = $[3];
        let t4;
        if ($[4] !== label || $[5] !== t3) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: label,
                tag: $75f6060a0eba078d$var$CustomizedTagWithRef,
                children: t3
            });
            $[4] = label;
            $[5] = t3;
            $[6] = t4;
        } else t4 = $[6];
        return t4;
    }
    const t2 = shouldSkip ? null : bidiCharacter;
    let t3;
    if ($[7] !== bidiCharacter || $[8] !== t2 || $[9] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1Bu5C.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: t2
        });
        $[7] = bidiCharacter;
        $[8] = t2;
        $[9] = testId;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : function BidiWarning({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: label,
        tag: $75f6060a0eba078d$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1Bu5C.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1Bu5C.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
};
var $75f6060a0eba078d$export$2e2bcd8739ae039 = $75f6060a0eba078d$var$BidiWarning;
const $75f6060a0eba078d$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(7);
    let children;
    let rest;
    if ($[0] !== props) {
        ({ children: children, ...rest } = props);
        $[0] = props;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    let t0;
    if ($[3] !== children || $[4] !== ref || $[5] !== rest) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ...rest,
            ref: ref,
            children: children
        });
        $[3] = children;
        $[4] = ref;
        $[5] = rest;
        $[6] = t0;
    } else t0 = $[6];
    return t0;
} : (props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});
module.exports["default"] = $75f6060a0eba078d$export$2e2bcd8739ae039;

});

parcelRegister("1Bu5C", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9GVkD = parcelRequire("9GVkD");

const $1b6f0b06c7576879$var$decoration = {
    root: "_1mT5xdRAKS _1UDy7ImnOE _0UsFEzIZbP _4Cjotl1Y8M _2vWqy01Y8M _2KsHXAPgdg _1QltOPPgdg _32AUXxzUZr _3DPH5Cfx9v _4nhm2x70UD _3Ku51IYkpS _1eQ8NNZSA9 _4diMdqhxIM _05vhMa1qpb _08GQIuDIqT _30TpC6DIqT _0OU75rccYA _4b5hU4ZSA9 _4BlKn3dEDW"
};
const $1b6f0b06c7576879$export$a592b67c93d52467 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Decorator(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { bidiCharacter: bidiCharacter, children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== bidiCharacter) {
        t1 = $1b6f0b06c7576879$var$getBidiCharacterCode(bidiCharacter);
        $[0] = bidiCharacter;
        $[1] = t1;
    } else t1 = $[1];
    const bidiCharacterCode = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $1b6f0b06c7576879$var$decoration.root
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== bidiCharacterCode || $[4] !== children || $[5] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true",
            className: t2,
            children: children
        });
        $[3] = bidiCharacterCode;
        $[4] = children;
        $[5] = testId;
        $[6] = t3;
    } else t3 = $[6];
    const t4 = testId && `${testId}--visually-hidden`;
    let t5;
    if ($[7] !== bidiCharacterCode) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("mark", {
            children: bidiCharacterCode
        });
        $[7] = bidiCharacterCode;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t4 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
            testId: t4,
            children: t5
        });
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t3 || $[13] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                t3,
                t6
            ]
        });
        $[12] = t3;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : function Decorator({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $1b6f0b06c7576879$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $hekY6.default)([
                    $1b6f0b06c7576879$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GVkD.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
};
function $1b6f0b06c7576879$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}
module.exports["Decorator"] = $1b6f0b06c7576879$export$a592b67c93d52467;

});

parcelRegister("cOjjv", function(module, exports) {
$parcel$export(module.exports, "default", () => $74055aca243263e6$export$2e2bcd8739ae039);

var $id6XS = parcelRequire("id6XS");

function $74055aca243263e6$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll((0, $id6XS.bidiCharacterRegex))
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("id6XS", function(module, exports) {
const $ee2ba9e96e536e80$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
module.exports["bidiCharacterRegex"] = $ee2ba9e96e536e80$export$ecb256e6a1f5ee7e;

});

parcelRegister("51qBv", function(module, exports) {

var $561lj = parcelRequire("561lj");


var $dK6bS = parcelRequire("dK6bS");

const $4f3f5baef79264ec$export$a69eee655819c5bd = ({ api: api, config: config })=>{
    return {
        name: 'codeBlockAdvanced',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $561lj.codeBlockNodeWithFixedToDOM)({
                        allowCodeFolding: config?.allowCodeFolding ?? false
                    })
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlockAdvancedPlugin',
                    plugin: ({ getIntl: getIntl })=>(0, $dK6bS.createPlugin)({
                            api: api,
                            extensions: config?.extensions ?? [],
                            allowCodeFolding: config?.allowCodeFolding ?? false,
                            getIntl: getIntl
                        })
                }
            ];
        }
    };
};
module.exports["codeBlockAdvancedPlugin"] = $4f3f5baef79264ec$export$a69eee655819c5bd;

});

parcelRegister("561lj", function(module, exports) {

var $jDAs4 = parcelRequire("jDAs4");


var $6gBg9 = parcelRequire("6gBg9");


var $8Dx7s = parcelRequire("8Dx7s");


var $cRhiT = parcelRequire("cRhiT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");

const $c0e4e9972d346b0c$var$codeBlockClassNames = {
    container: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    content: (0, $cRhiT.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
};
const $c0e4e9972d346b0c$var$MATCH_NEWLINES = new RegExp('\n', 'gu');
const $c0e4e9972d346b0c$var$getGutterBaseStyle = ()=>({
        backgroundColor: "var(--ds-background-neutral, #0515240F)",
        position: 'relative',
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '0.875em',
        boxSizing: 'content-box'
    });
const $c0e4e9972d346b0c$var$getGutterPadding = (allowCodeFolding)=>allowCodeFolding ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-100, 8px)";
const $c0e4e9972d346b0c$var$getGuttersWithLineNumbers = (content, config)=>[
        'div',
        {
            // Based on packages/editor/editor-common/src/styles/shared/code-block.ts
            // But we can't reuse that class as it adds a ::before that intefers with this approach
            style: (0, $8Dx7s.convertToInlineCss)({
                ...$c0e4e9972d346b0c$var$getGutterBaseStyle(),
                width: 'var(--lineNumberGutterWidth, 2rem)',
                /* top and bottom | left and right */ padding: $c0e4e9972d346b0c$var$getGutterPadding(config.allowCodeFolding)
            }),
            contenteditable: 'false'
        },
        [
            'div',
            {
                class: 'code-block-gutter-pseudo-element',
                style: (0, $8Dx7s.convertToInlineCss)({
                    textAlign: 'right',
                    color: "var(--ds-text-subtlest, #6B6E76)",
                    fontFamily: "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
                    whiteSpace: 'pre-wrap'
                }),
                'data-label': content
            }
        ]
    ];
const $c0e4e9972d346b0c$var$getFoldOnlyGutter = ()=>[
        'div',
        {
            style: (0, $8Dx7s.convertToInlineCss)({
                ...$c0e4e9972d346b0c$var$getGutterBaseStyle(),
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
            }),
            contenteditable: 'false'
        }
    ];
const $c0e4e9972d346b0c$var$getGutters = (content, config, hideLineNumbers)=>{
    if (!hideLineNumbers) return [
        $c0e4e9972d346b0c$var$getGuttersWithLineNumbers(content, config)
    ];
    if (config.allowCodeFolding) return [
        $c0e4e9972d346b0c$var$getFoldOnlyGutter()
    ];
    return [];
};
// Based on: `packages/editor/editor-plugin-code-block/src/nodeviews/code-block.ts`
const $c0e4e9972d346b0c$var$toDOM = (node, formattedAriaLabel, config)=>{
    let totalLineCount = 1;
    node.forEach((node)=>{
        const text = node.text;
        if (text) totalLineCount += (node.text.match($c0e4e9972d346b0c$var$MATCH_NEWLINES) || []).length;
    });
    const hideLineNumbers = (0, $6gBg9.areCodeBlockLineNumbersHidden)(node);
    const maxDigits = totalLineCount.toString().length;
    const content = node.textContent.split('\n').map((_, i)=>i + 1).join('\n');
    const gutters = $c0e4e9972d346b0c$var$getGutters(content, config, hideLineNumbers);
    const isCodeBlockWrapped = (0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && node.attrs.wrap === true;
    const className = [
        $c0e4e9972d346b0c$var$codeBlockClassNames.container,
        isCodeBlockWrapped ? $c0e4e9972d346b0c$var$codeBlockClassNames.contentWrapped : undefined
    ].filter(Boolean).join(' ');
    return [
        'pre',
        {
            class: className,
            style: `--lineNumberGutterWidth:${maxDigits}ch;`,
            'data-language': node.attrs.language || '',
            ...(0, $anBbz.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) && {
                'data-wrap': node.attrs.wrap ? 'true' : 'false',
                ...hideLineNumbers && {
                    'data-hide-line-numbers': 'true'
                }
            }
        },
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.contentWrapper
            },
            ...gutters,
            [
                'div',
                {
                    class: $c0e4e9972d346b0c$var$codeBlockClassNames.content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $iDrrr.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: $c0e4e9972d346b0c$var$codeBlockClassNames.end,
                contenteditable: 'false'
            }
        ]
    ];
};
const $c0e4e9972d346b0c$export$3cf83e71c577e77b = (config)=>{
    return {
        ...(0, $ieeJu.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? (0, $jDAs4.codeBlock) : (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $jDAs4.codeBlockWithLocalId) : (0, $jDAs4.codeBlock),
        toDOM: (node)=>$c0e4e9972d346b0c$var$toDOM(node, '', config)
    };
};
module.exports["codeBlockNodeWithFixedToDOM"] = $c0e4e9972d346b0c$export$3cf83e71c577e77b;

});

parcelRegister("dK6bS", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $ixu0Q = parcelRequire("ixu0Q");


var $kz1SL = parcelRequire("kz1SL");

const $7df39c642c535c5a$export$ae829ec7b2625219 = (props)=>{
    return new (0, $kpCD8.SafePlugin)({
        props: {
            nodeViews: {
                codeBlock: (0, $ixu0Q.lazyCodeBlockView)(props)
            },
            // Custom selection behaviour to fix issues with codeblocks with Shift + Arrow{Up || Down}
            // These issues are also present in the prosemirror codemirror example and @marijnh suggests to
            // use custom event handlers: https://github.com/ProseMirror/website/issues/83
            handleKeyDown (view, event) {
                if (!(event instanceof KeyboardEvent)) return false;
                if (event.key === 'ArrowUp' && event.shiftKey) return (0, $kz1SL.shiftArrowUpWorkaround)(view, event);
                else if (event.key === 'ArrowDown' && event.shiftKey) return (0, $kz1SL.shiftArrowDownWorkaround)(view, event);
            }
        }
    });
};
module.exports["createPlugin"] = $7df39c642c535c5a$export$ae829ec7b2625219;

});

parcelRegister("ixu0Q", function(module, exports) {

var $hMfrQ = parcelRequire("hMfrQ");


const $766d24dab7d8c4dd$export$28da8fbeb01202c6 = (props)=>{
    return (0, $hMfrQ.withLazyLoading)({
        nodeName: 'codeBlock',
        getNodeViewOptions: ()=>{},
        loader: async ()=>{
            const { getCodeBlockAdvancedNodeView: getCodeBlockAdvancedNodeView } = await (parcelRequire("jLcA5"));
            return (node, view, getPos, _decs, _nodeViewOptions, innerDecorations)=>getCodeBlockAdvancedNodeView(props)(node, view, getPos, innerDecorations);
        }
    });
};
module.exports["lazyCodeBlockView"] = $766d24dab7d8c4dd$export$28da8fbeb01202c6;

});

parcelRegister("jLcA5", function(module, exports) {

let $e62c2a6fcd5be4e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e62c2a6fcd5be4e8$var$load("fBohe"),
    $e62c2a6fcd5be4e8$var$load("eMRD3"),
    $e62c2a6fcd5be4e8$var$load("hmrCV")
]).then(()=>parcelRequire('kDxNm'));

});

parcelRegister("kz1SL", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $12e69e2dcfc4bd75$export$d4559115ffe0b372 = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = Math.max($head.pos - 1, 1);
    const isNodeBefore = doc.resolve(pos).nodeBefore?.type === codeBlock;
    const maybeProblematicNode = isNodeBefore ? doc.resolve(pos).nodeBefore : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeBefore ? pos : $head.pos;
        tr.setSelection((0, $kCECX.TextSelection).create(doc, $anchor.pos, Math.max(startPos - nodeSize, 0)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
const $12e69e2dcfc4bd75$export$ba335e235e59f4ed = (view, event)=>{
    const { doc: doc, selection: { $head: $head, $anchor: $anchor }, tr: tr, schema: { nodes: { codeBlock: codeBlock } } } = view.state;
    // Position we want to check (directly after our current position)
    const pos = $head.pos + 1;
    const isNodeAfter = doc.resolve(pos).nodeAfter?.type === codeBlock;
    const maybeProblematicNode = isNodeAfter ? doc.resolve(pos).nodeAfter : doc.resolve(pos).node();
    if (maybeProblematicNode?.type === codeBlock) {
        const nodeSize = maybeProblematicNode.nodeSize;
        const startPos = isNodeAfter ? pos : $head.pos;
        tr.setSelection((0, $kCECX.TextSelection).create(doc, $anchor.pos, Math.min(startPos + nodeSize, doc.content.size)));
        view.dispatch(tr);
        event.preventDefault();
        return true;
    }
    return false;
};
module.exports["shiftArrowUpWorkaround"] = $12e69e2dcfc4bd75$export$d4559115ffe0b372;
module.exports["shiftArrowDownWorkaround"] = $12e69e2dcfc4bd75$export$ba335e235e59f4ed;

});

parcelRegister("1U7Jq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $1ptyh = parcelRequire("1ptyh");


var $4o0zT = parcelRequire("4o0zT");


var $jkcNT = parcelRequire("jkcNT");


var $ieeJu = parcelRequire("ieeJu");


var $klpad = parcelRequire("klpad");


var $8dubf = parcelRequire("8dubf");


var $lpCJp = parcelRequire("lpCJp");


var $3qA9L = parcelRequire("3qA9L");


var $4KwOr = parcelRequire("4KwOr");


var $cjq97 = parcelRequire("cjq97");


var $9trAT = parcelRequire("9trAT");

const $dc90d7d40da4ba04$export$8751de4ba1d9a8f9 = ({ api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, editorView: editorView })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cjq97.PrimaryToolbarHighlightColorWithIntl), {
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            pluginInjectionApi: api,
            editorView: editorView
        });
    };
    if (!isToolbarAIFCEnabled) api?.primaryToolbar?.actions.registerComponent({
        name: 'highlight',
        component: primaryToolbarComponent
    });
    else api?.toolbar?.actions.registerComponents((0, $9trAT.getToolbarComponent)(api));
    return {
        name: 'highlight',
        marks () {
            if ((0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) || (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_color_schema_change')) return [
                {
                    name: 'backgroundColor',
                    mark: (0, $1ptyh.backgroundColor)
                }
            ];
            // color is defined in platform/packages/editor/adf-schema/src/next-schema/marks/color.ts
            return [
                {
                    name: 'backgroundColor',
                    mark: {
                        ...(0, $1ptyh.backgroundColor),
                        excludes: 'color'
                    }
                }
            ];
        },
        commands: {
            changeColor: (0, $klpad.changeColor)(editorAnalyticsAPI)
        },
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'highlight',
                    plugin: ()=>(0, $3qA9L.createPlugin)()
                },
                {
                    name: 'highlightKeymap',
                    plugin: ()=>(0, $lpCJp.keymapPlugin)({
                            api: api
                        })
                },
                {
                    name: 'highlightPadding',
                    plugin: ()=>(0, $8dubf.createHighlightPaddingPlugin)()
                }
            ];
            return plugins;
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $3qA9L.highlightPluginKey).getState(editorState);
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar () {
                const toolbarDocking = api?.userPreferences?.sharedState.currentState()?.preferences?.toolbarDockingPosition;
                if (toolbarDocking === 'none' && (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $4KwOr.FloatingToolbarHighlightColorWithIntl), {
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                pluginInjectionApi: api,
                                editorView: view
                            }),
                        fallback: []
                    };
                    const rank = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? 5 : -9;
                    return {
                        rank: rank,
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        pluginName: 'highlight'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["highlightPlugin"] = $dc90d7d40da4ba04$export$8751de4ba1d9a8f9;

});

parcelRegister("klpad", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $cZ1Iw = parcelRequire("cZ1Iw");

var $5tsXu = parcelRequire("5tsXu");


var $bhf6v = parcelRequire("bhf6v");


var $2RAus = parcelRequire("2RAus");


var $1jFAi = parcelRequire("1jFAi");


var $evFm2 = parcelRequire("evFm2");


var $4o0zT = parcelRequire("4o0zT");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $3qA9L = parcelRequire("3qA9L");


var $fMLvg = parcelRequire("fMLvg");

const $aab02ab2394ccf36$var$maybeSyncSelectionAfterFormat = (tr)=>{
    if (tr.docChanged) tr.setMeta((0, $2RAus.FORMAT_SELECTION_SYNC_META), true);
};
const $aab02ab2394ccf36$export$917538e4f4eb20f9 = (editorAnalyticsAPI)=>({ color: color, inputMethod: inputMethod })=>({ tr: tr })=>{
            const { marks: marks } = tr.doc.type.schema;
            const { backgroundColor: backgroundColor } = tr.doc.type.schema.marks;
            if (!backgroundColor) return null;
            editorAnalyticsAPI?.attachAnalyticsEvent($aab02ab2394ccf36$var$createAnalyticsEvent(color, inputMethod, tr))(tr);
            tr.scrollIntoView();
            if (color === (0, $evFm2.REMOVE_HIGHLIGHT_COLOR)) (0, $5tsXu.removeMark)(backgroundColor)({
                tr: tr
            });
            else {
                if ((0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_color_schema_change') && !(0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
                    const overrideMarks = [
                        'textColor'
                    ];
                    overrideMarks.forEach((mark)=>{
                        if (marks[mark]) (0, $5tsXu.removeMark)(marks[mark])({
                            tr: tr
                        });
                    });
                }
                tr.setMeta((0, $3qA9L.highlightPluginKey), {
                    type: (0, $3qA9L.HighlightPluginAction).CHANGE_COLOR,
                    color: color
                });
                (0, $bhf6v.toggleMark)(backgroundColor, {
                    color: color
                })({
                    tr: tr
                });
            }
            $aab02ab2394ccf36$var$maybeSyncSelectionAfterFormat(tr);
            return tr;
        };
const $aab02ab2394ccf36$var$createAnalyticsEvent = (color, inputMethod, tr)=>{
    const previousColor = (0, $fMLvg.getActiveColor)(tr) ?? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
    const highlightPalette = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
    // get color names from palette
    const newColorFromPalette = highlightPalette.find(({ value: value })=>value === color);
    const previousColorFromPalette = highlightPalette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : color;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor;
    const { textColor: textColor, link: link } = tr.doc.type.schema.marks;
    return {
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel ? previousColorLabel.toLowerCase() : '',
            inputMethod: inputMethod,
            ...color === (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) ? {} : (0, $cZ1Iw.getHadMarkAttributes)(tr, [
                textColor,
                link
            ])
        }
    };
};
module.exports["changeColor"] = $aab02ab2394ccf36$export$917538e4f4eb20f9;

});

parcelRegister("1jFAi", function(module, exports) {

var $1ptyh = parcelRequire("1ptyh");


var $xx2Zf = parcelRequire("xx2Zf");


var $evFm2 = parcelRequire("evFm2");


var $9Av6M = parcelRequire("9Av6M");


var $j1hRT = parcelRequire("j1hRT");

const $db5946739e91a2e0$export$7dee00034afd0ce = [
    {
        value: (0, $evFm2.REMOVE_HIGHLIGHT_COLOR),
        label: 'No color',
        // Mostly informative, only used for analytics
        border: "var(--ds-border, #0B120E24)",
        message: (0, $xx2Zf.default)((0, $j1hRT.default), 'no-color')
    }
];
(0, $1ptyh.backgroundColorPaletteNew).forEach((label, color)=>{
    $db5946739e91a2e0$export$7dee00034afd0ce.push((0, $9Av6M.mapPaletteColor)(label, color));
});
module.exports["highlightColorPaletteNew"] = $db5946739e91a2e0$export$7dee00034afd0ce;

});

parcelRegister("3qA9L", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $fMLvg = parcelRequire("fMLvg");


var $b71zX = parcelRequire("b71zX");

const $f58243ba1921692c$export$b8f1e1e1a4636cb0 = new (0, $kCECX.PluginKey)('highlight');
var $f58243ba1921692c$export$2dfab9d4f3f51423 = /*#__PURE__*/ function(HighlightPluginAction) {
    HighlightPluginAction[HighlightPluginAction["CHANGE_COLOR"] = 0] = "CHANGE_COLOR";
    HighlightPluginAction[HighlightPluginAction["SET_PALETTE"] = 1] = "SET_PALETTE";
    return HighlightPluginAction;
}({});
const $f58243ba1921692c$export$ae829ec7b2625219 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $f58243ba1921692c$export$b8f1e1e1a4636cb0,
        state: {
            init: (_, editorState)=>({
                    activeColor: null,
                    disabled: (0, $b71zX.getDisabledState)(editorState),
                    isPaletteOpen: false
                }),
            apply: (tr, pluginState, _oldState, newState)=>{
                const action = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0)?.type;
                switch(action){
                    case 0:
                        const { color: color } = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            activeColor: color
                        };
                    case 1:
                        const { isPaletteOpen: isPaletteOpen } = tr.getMeta($f58243ba1921692c$export$b8f1e1e1a4636cb0);
                        return {
                            ...pluginState,
                            isPaletteOpen: isPaletteOpen
                        };
                    default:
                        const activeColor = (0, $fMLvg.getActiveColor)(tr);
                        return {
                            ...pluginState,
                            activeColor: activeColor,
                            disabled: (0, $b71zX.getDisabledState)(newState)
                        };
                }
            }
        }
    });
};
module.exports["highlightPluginKey"] = $f58243ba1921692c$export$b8f1e1e1a4636cb0;
module.exports["HighlightPluginAction"] = $f58243ba1921692c$export$2dfab9d4f3f51423;
module.exports["createPlugin"] = $f58243ba1921692c$export$ae829ec7b2625219;

});

parcelRegister("fMLvg", function(module, exports) {

var $hXuXM = parcelRequire("hXuXM");


var $kCECX = parcelRequire("kCECX");


var $8HW7o = parcelRequire("8HW7o");

const $cc72b0b788eceff6$export$544437a37c3070a9 = 'multiple';
const $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange = (from, to, tr)=>{
    const { doc: doc } = tr;
    const { backgroundColor: backgroundColor } = doc.type.schema.marks;
    const colorMarks = [];
    const colorSet = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (node.isLeaf) {
            const mark = backgroundColor.isInSet(node.marks);
            if (mark && !colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        }
    });
    return colorMarks;
};
const $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInCellSelection = (selection, tr)=>{
    const colorMarks = [];
    const colorSet = new Set();
    selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
        marks.forEach((mark)=>{
            if (!colorSet.has(mark.attrs.color)) {
                colorMarks.push(mark);
                colorSet.add(mark.attrs.color);
            }
        });
    });
    return colorMarks;
};
// For Cell Selections - find first instance of a backgroundColor mark
// if all cells entirely contain this mark, set the color.
// If the selection contains multiple colors, return null
const $cc72b0b788eceff6$var$getColorFromCellSelection = (selection, tr)=>{
    const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInCellSelection(selection, tr);
    if (marks.length > 1) return $cc72b0b788eceff6$export$544437a37c3070a9;
    const firstColorMark = marks.at(0);
    if (!firstColorMark) return null;
    let foundUncolouredNode = false;
    selection.forEachCell((cell, cellPos)=>{
        if (foundUncolouredNode) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!(0, $hXuXM.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) foundUncolouredNode = true;
    });
    return foundUncolouredNode ? null : firstColorMark.attrs.color;
};
// All other selections - find the first instance of a backgroundColor mark
// if selection entirely contains this mark, set the color.
// If the selection contains multiple colors, return null
const $cc72b0b788eceff6$var$getColorFromRange = (from, to, tr)=>{
    const marks = $cc72b0b788eceff6$var$getAllUniqueBackgroundColorMarksInRange(from, to, tr);
    if (marks.length > 1) return $cc72b0b788eceff6$export$544437a37c3070a9;
    const firstColorMark = marks.at(0);
    if (firstColorMark && (0, $hXuXM.entireSelectionContainsMark)(firstColorMark, tr.doc, from, to)) return firstColorMark.attrs.color;
    return null;
};
// For Cursor selections - set color if it is found in the storedMarks or $cursor.marks
const $cc72b0b788eceff6$var$getColorFromCursor = (selection, tr)=>{
    if (!selection.$cursor) return null;
    const mark = tr.doc.type.schema.marks.backgroundColor.isInSet([
        ...tr.storedMarks ? tr.storedMarks : [],
        ...selection.$cursor.marks()
    ]);
    return mark?.attrs.color ?? null;
};
const $cc72b0b788eceff6$export$1c6fa8f53a5fb47f = (tr)=>{
    const { selection: selection } = tr;
    let color = null;
    if (selection instanceof (0, $8HW7o.CellSelection)) color = $cc72b0b788eceff6$var$getColorFromCellSelection(selection, tr);
    else if (selection instanceof (0, $kCECX.TextSelection) && selection.$cursor) color = $cc72b0b788eceff6$var$getColorFromCursor(selection, tr);
    else color = $cc72b0b788eceff6$var$getColorFromRange(selection.from, selection.to, tr);
    return color;
};
module.exports["getActiveColor"] = $cc72b0b788eceff6$export$1c6fa8f53a5fb47f;

});

parcelRegister("b71zX", function(module, exports) {

var $kzHT3 = parcelRequire("kzHT3");

var $adJV7 = parcelRequire("adJV7");


var $4EksL = parcelRequire("4EksL");


var $kCECX = parcelRequire("kCECX");

const $e2943e24876b6d57$export$4af1020a67b5ec91 = (state)=>{
    const { backgroundColor: backgroundColor } = state.schema.marks;
    const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
    if (!backgroundColor) return true;
    if (state.selection instanceof (0, $kCECX.NodeSelection) || state.selection instanceof (0, $4EksL.GapCursorSelection)) return true;
    if (empty && !$cursor || (0, $kzHT3.isMarkAllowedInRange)(state.doc, ranges, backgroundColor) === false) return true;
    if ((0, $adJV7.isMarkExcluded)(backgroundColor, state.storedMarks || $cursor && $cursor.marks())) return true;
    return false;
};
module.exports["getDisabledState"] = $e2943e24876b6d57$export$4af1020a67b5ec91;

});

parcelRegister("8dubf", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $3YhlK = parcelRequire("3YhlK");


var $2Y3yg = parcelRequire("2Y3yg");

const $c486e0fd30b92a7e$export$64079c8b271eeba4 = new (0, $kCECX.PluginKey)('highlightPaddingPluginKey');
const $c486e0fd30b92a7e$export$8d5a971433249768 = ()=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $c486e0fd30b92a7e$export$64079c8b271eeba4,
        state: {
            init: (_, state)=>{
                // Initially scan the entire doc to create all highlight padding decorations
                // after which updates will only apply to changed ranges
                const initialDecorationSet = (0, $8nvEM.DecorationSet).empty;
                const decorationSet = (0, $3YhlK.addPaddingDecorations)({
                    decorationSet: initialDecorationSet,
                    state: state,
                    from: 0,
                    to: state.doc.content.size
                });
                return {
                    decorationSet: decorationSet
                };
            },
            apply: (tr, pluginState, _oldState, state)=>{
                if (!tr.docChanged) return pluginState;
                let decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
                tr.mapping.maps.forEach((stepMap)=>{
                    stepMap.forEach((_oldStart, _oldEnd, start, end)=>{
                        decorationSet = (0, $2Y3yg.updatePaddingDecorations)({
                            decorationSet: decorationSet,
                            state: state,
                            start: start,
                            end: end
                        });
                    });
                });
                return {
                    decorationSet: decorationSet
                };
            }
        },
        props: {
            decorations: (state)=>{
                return $c486e0fd30b92a7e$export$64079c8b271eeba4.getState(state).decorationSet;
            }
        }
    });
};
module.exports["createHighlightPaddingPlugin"] = $c486e0fd30b92a7e$export$8d5a971433249768;

});

parcelRegister("3YhlK", function(module, exports) {

var $8nvEM = parcelRequire("8nvEM");


var $kX7j6 = parcelRequire("kX7j6");

const $0dd8ab74fbe19def$var$createPaddingDecoration = ({ pos: pos, node: node, padLeft: padLeft, padRight: padRight })=>{
    const classes = [];
    const baseClass = 'background-color';
    const padLeftClass = `${baseClass}-padding-left`;
    const padRightClass = `${baseClass}-padding-right`;
    if (padLeft) classes.push(padLeftClass);
    if (padRight) classes.push(padRightClass);
    return (0, $8nvEM.Decoration).inline(pos, pos + node.nodeSize, {
        class: classes.join(' ')
    });
};
const $0dd8ab74fbe19def$export$e955b6e659e59713 = ({ decorationSet: decorationSet, state: state, from: from, to: to })=>{
    let newDecorationSet = decorationSet;
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!(0, $kX7j6.isHighlightedTextNode)(node)) return;
        const nodeStart = pos;
        const nodeEnd = pos + node.nodeSize;
        const padLeft = (0, $kX7j6.shouldPadLeft)({
            state: state,
            nodeStart: nodeStart
        });
        const padRight = (0, $kX7j6.shouldPadRight)({
            state: state,
            nodeEnd: nodeEnd
        });
        if (padLeft && padRight) {
            const newDecoration = $0dd8ab74fbe19def$var$createPaddingDecoration({
                pos: nodeStart,
                node: node,
                padLeft: padLeft,
                padRight: padRight
            });
            newDecorationSet = newDecorationSet.add(state.doc, [
                newDecoration
            ]);
        }
    });
    return newDecorationSet;
};
module.exports["addPaddingDecorations"] = $0dd8ab74fbe19def$export$e955b6e659e59713;

});

parcelRegister("kX7j6", function(module, exports) {
const $04ef2b2b71a6e383$export$d6f914f85b7b868b = (node)=>{
    return node.isText && node.marks.some((mark)=>mark.type.name === 'backgroundColor');
};
const $04ef2b2b71a6e383$export$48e6e6ce50a6fb39 = ({ state: state, nodeStart: nodeStart })=>{
    const $pos = state.doc.resolve(nodeStart);
    const isAtBlockStart = $pos.parentOffset === 0;
    if (isAtBlockStart) return true;
    const isAtDocStart = nodeStart === 0;
    if (isAtDocStart) return true;
    const isPrevCharSpace = state.doc.textBetween(nodeStart - 1, nodeStart) === ' ';
    if (isPrevCharSpace) return true;
    return false;
};
const $04ef2b2b71a6e383$export$b44b3045e621df46 = ({ state: state, nodeEnd: nodeEnd })=>{
    const $pos = state.doc.resolve(nodeEnd);
    const isAtBlockEnd = $pos.parentOffset === $pos.parent.content.size;
    if (isAtBlockEnd) return true;
    const isAtDocEnd = nodeEnd === state.doc.content.size;
    if (isAtDocEnd) return true;
    const isNextCharSpace = state.doc.textBetween(nodeEnd, nodeEnd + 1) === ' ';
    if (isNextCharSpace) return true;
    return false;
};
module.exports["isHighlightedTextNode"] = $04ef2b2b71a6e383$export$d6f914f85b7b868b;
module.exports["shouldPadLeft"] = $04ef2b2b71a6e383$export$48e6e6ce50a6fb39;
module.exports["shouldPadRight"] = $04ef2b2b71a6e383$export$b44b3045e621df46;

});

parcelRegister("2Y3yg", function(module, exports) {

var $3YhlK = parcelRequire("3YhlK");

const $c292e18cced6f552$export$d9003f1f8089aa99 = ({ decorationSet: prevDecorationSet, state: state, start: start, end: end })=>{
    // First remove any decorations within the range
    // Note that it finds all decorations in the set which touch the given range (including decorations that start or end directly at the boundaries)
    const toRemove = prevDecorationSet.find(start, end);
    const decorationSet = prevDecorationSet.remove(toRemove);
    // Expand the range by 1 on each side to catch adjacent text nodes
    // that may need padding decorations added/removed
    const from = Math.max(0, start - 1);
    const to = Math.min(state.doc.content.size, end + 1);
    return (0, $3YhlK.addPaddingDecorations)({
        decorationSet: decorationSet,
        state: state,
        from: from,
        to: to
    });
};
module.exports["updatePaddingDecorations"] = $c292e18cced6f552$export$d9003f1f8089aa99;

});

parcelRegister("lpCJp", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $eBSR7 = parcelRequire("eBSR7");


var $ldqjS = parcelRequire("ldqjS");


var $aC6bW = parcelRequire("aC6bW");


var $1jFAi = parcelRequire("1jFAi");


var $evFm2 = parcelRequire("evFm2");


var $anBbz = parcelRequire("anBbz");


var $klpad = parcelRequire("klpad");


var $hho3D = parcelRequire("hho3D");

function $96e0040b7d537f88$export$e832373cff8dec22({ api: api }) {
    const list = {};
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    if (!isToolbarAIFCEnabled) (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.toggleHighlightPalette).common, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $hho3D.togglePalette)(api)({
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    }), list);
    const analyticsApi = api?.analytics?.actions;
    const highlightPalette = (0, $anBbz.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
    const color = highlightPalette.find(({ label: label })=>label === 'Yellow');
    if (color) (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.applyYellowHighlight).common, (0, $aC6bW.editorCommandToPMCommand)((0, $klpad.changeColor)(analyticsApi)({
        color: color.value,
        inputMethod: (0, $krYZG.INPUT_METHOD).SHORTCUT
    })), list);
    return (0, $eBSR7.keymap)(list);
}
module.exports["keymapPlugin"] = $96e0040b7d537f88$export$e832373cff8dec22;

});

parcelRegister("hho3D", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $3qA9L = parcelRequire("3qA9L");

const $2aa1bfdef742e4d8$export$7c9cf3bdfeac3246 = (api)=>({ inputMethod: inputMethod })=>(state, dispatch)=>{
            const isPaletteOpen = (0, $3qA9L.highlightPluginKey).getState(state)?.isPaletteOpen;
            return $2aa1bfdef742e4d8$export$9567774ece486a9(api)({
                isPaletteOpen: !isPaletteOpen,
                inputMethod: inputMethod
            })(state, dispatch);
        };
const $2aa1bfdef742e4d8$export$9567774ece486a9 = (api)=>({ isPaletteOpen: isPaletteOpen, inputMethod: inputMethod })=>(state, dispatch)=>{
            const isDisabled = (0, $3qA9L.highlightPluginKey).getState(state)?.disabled;
            if (!isDisabled) {
                const tr = state.tr;
                tr.setMeta((0, $3qA9L.highlightPluginKey), {
                    type: (0, $3qA9L.HighlightPluginAction).SET_PALETTE,
                    isPaletteOpen: isPaletteOpen
                });
                api.analytics?.actions.attachAnalyticsEvent($2aa1bfdef742e4d8$var$createAnalyticsEvent(isPaletteOpen, inputMethod))(tr);
                tr.setMeta('addToHistory', false);
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
const $2aa1bfdef742e4d8$var$createAnalyticsEvent = (isPaletteOpen, inputMethod)=>{
    return {
        action: isPaletteOpen ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod
        }
    };
};
module.exports["togglePalette"] = $2aa1bfdef742e4d8$export$7c9cf3bdfeac3246;
module.exports["setPalette"] = $2aa1bfdef742e4d8$export$9567774ece486a9;

});

parcelRegister("4KwOr", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $aiL0G = parcelRequire("aiL0G");


var $btkFO = parcelRequire("btkFO");


var $ldqjS = parcelRequire("ldqjS");


var $hzZPp = parcelRequire("hzZPp");


var $6DhDg = parcelRequire("6DhDg");


var $9iFhC = parcelRequire("9iFhC");


var $ldbHR = parcelRequire("ldbHR");


var $3k5Tv = parcelRequire("3k5Tv");


var $9Rqjc = parcelRequire("9Rqjc");


var $7sJoX = parcelRequire("7sJoX");


var $58BEn = parcelRequire("58BEn");


var $jkcNT = parcelRequire("jkcNT");


var $hho3D = parcelRequire("hho3D");


var $17Axi = parcelRequire("17Axi");


var $bvwoM = parcelRequire("bvwoM");

const $0f74fcdc8766f2ac$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        activeColor: states.highlightState?.activeColor,
        disabled: states.highlightState?.disabled
    };
};
const $0f74fcdc8766f2ac$var$FloatingToolbarHighlightColor = ({ pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $cozmU.useRef)(null);
    const { activeColor: activeColor, disabled: disabled, isPaletteOpen: isPaletteOpen } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $0f74fcdc8766f2ac$var$selector);
    const setDropdownOpen = (isOpen)=>{
        if (!disabled && editorView && pluginInjectionApi) {
            const { state: state, dispatch: dispatch } = editorView;
            (0, $hho3D.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            })(state, dispatch);
        }
        pluginInjectionApi?.analytics?.actions.fireAnalyticsEvent({
            action: isOpen ? (0, $krYZG.ACTION).OPENED : (0, $krYZG.ACTION).CLOSED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            }
        });
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $bvwoM.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || disabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $hzZPp.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(activeColor);
    const title = (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel) : toolbarButtonLabel;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $17Axi.PaletteDropdown), {
        isOpen: isDropdownOpen && !disabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $9iFhC.disableBlueBorderStyles),
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
            disabled: disabled,
            selected: isDropdownOpen,
            "aria-label": title,
            "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: title,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $9iFhC.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $btkFO.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: disabled,
                icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58BEn))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: (0, $6DhDg.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }, (0, $jkcNT.editorExperiment)('platform_editor_controls', 'control') && formatMessage((0, $hzZPp.highlightMessages).highlightFloatingToolbar)),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    });
};
const $0f74fcdc8766f2ac$export$5d201a8e1b725031 = (0, $kSwu1.injectIntl)($0f74fcdc8766f2ac$var$FloatingToolbarHighlightColor);
module.exports["FloatingToolbarHighlightColorWithIntl"] = $0f74fcdc8766f2ac$export$5d201a8e1b725031;

});

parcelRegister("17Axi", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $1jFAi = parcelRequire("1jFAi");


var $7xQNd = parcelRequire("7xQNd");


var $evFm2 = parcelRequire("evFm2");


var $3gFnx = parcelRequire("3gFnx");


var $9RT19 = parcelRequire("9RT19");


var $9GNtS = parcelRequire("9GNtS");


var $9Rqjc = parcelRequire("9Rqjc");


var $7Y8M5 = parcelRequire("7Y8M5");


var $ieeJu = parcelRequire("ieeJu");

const $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 8;
const $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS_NEW = 10;
const $beb5a9a099edbe6a$export$780f86860853be18 = (props)=>{
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isOpen: isOpen, activeColor: activeColor, trigger: trigger, onColorChange: onColorChange, isOpenedByKeyboard: isOpenedByKeyboard, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown } = props;
    const isNewColorPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const highlightPalette = (0, $cozmU.useMemo)(()=>{
        if (isNewColorPaletteEnabled) return (0, $1jFAi.highlightColorPaletteNew).filter((color)=>{
            return color.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
        });
        return 0, $evFm2.highlightColorPalette;
    }, [
        isNewColorPaletteEnabled
    ]);
    const colorPickerColumns = isNewColorPaletteEnabled ? $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS_NEW : $beb5a9a099edbe6a$var$HIGHLIGHT_COLOR_PICKER_COLUMNS;
    // pixels, used to determine where to horizontally position the dropdown when space is limited
    // this should reflect the width of the dropdown when fully populated with colors, including translations due to layering
    const fitWidth = isNewColorPaletteEnabled ? 338 : 274;
    // 8 cols: 272 = (32 * 8) + (8 + 8)
    // 10 cols: 336 = (32 * 10) + (8 + 8)
    // Not sure where the extra 2px comes from
    const selectedColor = activeColor || (isNewColorPaletteEnabled ? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) : null);
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $3gFnx.getSelectedRowAndColumnFromPalette)(highlightPalette, selectedColor, colorPickerColumns);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9GNtS.DropdownContainer), {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        isOpen: isOpen,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown,
        zIndex: (0, $7Y8M5.akEditorMenuZIndex),
        fitWidth: fitWidth,
        closeOnTab: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $9RT19.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: true
        },
        trigger: trigger,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "highlight-color-palette",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7xQNd.default), {
                cols: colorPickerColumns,
                onClick: onColorChange,
                selectedColor: selectedColor,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                paletteOptions: {
                    palette: highlightPalette,
                    hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
                }
            })
        })
    });
};
module.exports["PaletteDropdown"] = $beb5a9a099edbe6a$export$780f86860853be18;

});

parcelRegister("bvwoM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $klpad = parcelRequire("klpad");

const $c5c096bb56d4fa88$export$98f4eb06acf89919 = (args)=>{
    const { toolbarItemRef: toolbarItemRef, setIsDropdownOpen: setIsDropdownOpen, isDropdownOpen: isDropdownOpen, pluginInjectionApi: pluginInjectionApi } = args;
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $cozmU.useState)(false);
    return {
        handleClick: ()=>{
            setIsOpenedByKeyboard(false);
            setIsDropdownOpen(!isDropdownOpen);
        },
        handleKeyDown: (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setIsOpenedByKeyboard(true);
                setIsDropdownOpen(!isDropdownOpen);
            }
        },
        handleClickOutside: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
            }
        },
        handleEscapeKeydown: ()=>{
            if (isDropdownOpen) {
                setIsDropdownOpen(false);
                setIsOpenedByKeyboard(false);
                toolbarItemRef?.current?.focus();
            }
        },
        handleColorChange: ({ color: color, inputMethod: inputMethod })=>{
            pluginInjectionApi?.core?.actions.execute((0, $klpad.changeColor)(pluginInjectionApi?.analytics?.actions)({
                color: color,
                inputMethod: inputMethod
            }));
            setIsDropdownOpen(false);
        },
        isOpenedByKeyboard: isOpenedByKeyboard
    };
};
module.exports["useDropdownEvents"] = $c5c096bb56d4fa88$export$98f4eb06acf89919;

});

parcelRegister("cjq97", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $aiL0G = parcelRequire("aiL0G");


var $btkFO = parcelRequire("btkFO");


var $ldqjS = parcelRequire("ldqjS");


var $hzZPp = parcelRequire("hzZPp");


var $6DhDg = parcelRequire("6DhDg");


var $9iFhC = parcelRequire("9iFhC");


var $ldbHR = parcelRequire("ldbHR");


var $3k5Tv = parcelRequire("3k5Tv");


var $9Rqjc = parcelRequire("9Rqjc");


var $7sJoX = parcelRequire("7sJoX");


var $58BEn = parcelRequire("58BEn");


var $4ez2K = parcelRequire("4ez2K");


var $hho3D = parcelRequire("hho3D");


var $17Axi = parcelRequire("17Axi");


var $bvwoM = parcelRequire("bvwoM");

const $0956ebe46a405aea$var$selector = (states)=>{
    return {
        isPaletteOpen: states.highlightState?.isPaletteOpen,
        highlightDisabled: states.highlightState?.disabled,
        activeColor: states.highlightState?.activeColor
    };
};
const $0956ebe46a405aea$var$PrimaryToolbarHighlightColor = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, pluginInjectionApi: pluginInjectionApi, intl: { formatMessage: formatMessage }, editorView: editorView })=>{
    const toolbarItemRef = (0, $cozmU.useRef)(null);
    const { isPaletteOpen: isPaletteOpen, highlightDisabled: highlightDisabled, activeColor: activeColor } = (0, $3k5Tv.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'highlight'
    ], $0956ebe46a405aea$var$selector);
    const setIsDropdownOpen = (isOpen)=>{
        if (!highlightDisabled) {
            const { state: state, dispatch: dispatch } = editorView;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $hho3D.setPalette)(pluginInjectionApi)({
                isPaletteOpen: isOpen,
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
            })(state, dispatch);
        }
    };
    const isDropdownOpen = !!isPaletteOpen;
    const { handleClick: handleClick, handleKeyDown: handleKeyDown, handleClickOutside: handleClickOutside, handleEscapeKeydown: handleEscapeKeydown, handleColorChange: handleColorChange, isOpenedByKeyboard: isOpenedByKeyboard } = (0, $bvwoM.useDropdownEvents)({
        toolbarItemRef: toolbarItemRef,
        setIsDropdownOpen: setIsDropdownOpen,
        isDropdownOpen: isDropdownOpen,
        pluginInjectionApi: pluginInjectionApi
    });
    // Don't render the toolbar option while the plugin is initialising
    if (activeColor === undefined || highlightDisabled === undefined) return null;
    const toolbarButtonLabel = formatMessage((0, $hzZPp.highlightMessages).highlight);
    // Get the design token for the  active color (if it exists) to modify the toolbar
    // icon, but show the nice rainbow if none is selected
    const activeColorToken = activeColor === null ? null : (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(activeColor);
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $17Axi.PaletteDropdown), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isOpen: isDropdownOpen && !highlightDisabled,
        activeColor: activeColor,
        trigger: /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
            css: (0, $9iFhC.disableBlueBorderStyles),
            buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).BACKGROUND_COLOR,
            spacing: isToolbarReducedSpacing ? 'none' : 'default',
            disabled: disabled || highlightDisabled,
            selected: isDropdownOpen,
            "aria-label": (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel),
            "aria-keyshortcuts": (0, $ldqjS.getAriaKeyshortcuts)((0, $ldqjS.toggleHighlightPalette)),
            "aria-expanded": isDropdownOpen,
            "aria-haspopup": true,
            title: (0, $ldqjS.tooltip)((0, $ldqjS.toggleHighlightPalette), toolbarButtonLabel),
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            ref: toolbarItemRef,
            iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
                css: (0, $9iFhC.triggerWrapperStylesWithPadding)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $btkFO.DynamicStrokeIconDecoration), {
                selectedColor: activeColorToken,
                disabled: highlightDisabled,
                icon: /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58BEn))), {
                    label: "",
                    color: "currentColor",
                    spacing: "spacious"
                })
            }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
                css: (0, $6DhDg.expandIconContainerStyle)
            }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: "",
                color: "currentColor",
                size: "small"
            })))
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onColorChange: (color)=>handleColorChange({
                color: color,
                inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR
            }),
        isOpenedByKeyboard: isOpenedByKeyboard,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleEscapeKeydown
    }));
};
const $0956ebe46a405aea$export$124ac7b23aa1ea6a = (0, $kSwu1.injectIntl)($0956ebe46a405aea$var$PrimaryToolbarHighlightColor);
module.exports["PrimaryToolbarHighlightColorWithIntl"] = $0956ebe46a405aea$export$124ac7b23aa1ea6a;

});

parcelRegister("9trAT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");


var $hVLmg = parcelRequire("hVLmg");


var $3drJJ = parcelRequire("3drJJ");

const $fa195af61c51f8bd$export$6cd8b101843de8d2 = (api)=>{
    return [
        {
            ...(0, $3nacY.HIGHLIGHT_MENU_ITEM),
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $hVLmg.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $3nacY.HIGHLIGHT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3drJJ.HighlightColorMenuItem), {
                    api: api,
                    parents: parents
                })
        }
    ];
};
module.exports["getToolbarComponent"] = $fa195af61c51f8bd$export$6cd8b101843de8d2;

});

parcelRegister("3drJJ", function(module, exports) {
/* HighlightColorMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $hzZPp = parcelRequire("hzZPp");


var $is7KY = parcelRequire("is7KY");


var $1jFAi = parcelRequire("1jFAi");

var $hEYnV = parcelRequire("hEYnV");


var $evFm2 = parcelRequire("evFm2");


var $4Qu9h = parcelRequire("4Qu9h");


var $g8ETs = parcelRequire("g8ETs");


var $9Rqjc = parcelRequire("9Rqjc");


var $74bCf = parcelRequire("74bCf");


var $kwf4Z = parcelRequire("kwf4Z");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $9FyRG = parcelRequire("9FyRG");


var $iDrrr = parcelRequire("iDrrr");


var $22YX5 = parcelRequire("22YX5");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $ieeJu = parcelRequire("ieeJu");

const $41e58cb6d3564e2b$var$HIGHLIGHT_COLOR_PICKER_COLUMNS = 10;
const $41e58cb6d3564e2b$var$styles = {
    container: "_2mHwu8gVvo _3138425zaO",
    containerPatch: "_313842Pgdg",
    icon: "_3iDTPbvbI6 _2XsHFMA17z"
};
const $41e58cb6d3564e2b$var$getTextColorIconColor = (defaultColor, textColor, isNewColorPaletteEnabled)=>{
    if (!isNewColorPaletteEnabled) return "var(--ds-icon, #292A2E)";
    if (!textColor || defaultColor && textColor === defaultColor) return "var(--ds-icon, #292A2E)";
    return (0, $g8ETs.hexToEditorTextPaletteColor)(textColor) || "var(--ds-icon, #292A2E)";
};
const $41e58cb6d3564e2b$var$TextColorIconDecorator = ({ label: label, isSelected: isSelected, iconColor: iconColor })=>{
    return isSelected ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        color: "var(--ds-icon, #292A2E)",
        label: label
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "span",
        xcss: $41e58cb6d3564e2b$var$styles.icon,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
            label: label,
            color: iconColor,
            shouldRecommendSmallIcon: true,
            spacing: "spacious",
            size: "small"
        })
    });
};
const $41e58cb6d3564e2b$var$NoColorIconDecorator = ({ isSelected: isSelected, iconColor: iconColor })=>/*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            transform: "translate(-1 -1)",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    x: "1.70703",
                    y: "1.35383",
                    width: "29.8003",
                    height: "0.5",
                    transform: "rotate(45 1.70703 1.35383)",
                    stroke: "var(--ds-border, #0B120E24)",
                    strokeWidth: "0.5"
                }),
                isSelected ? /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M17.959 7.9707L10.709 16.9707C10.5675 17.1462 10.3544 17.2488 10.1289 17.25C9.90343 17.2512 9.68924 17.1506 9.5459 16.9766L6.0459 12.7266L7.2041 11.7734L10.1182 15.3115L16.791 7.0293L17.959 7.9707Z",
                    fill: "var(--ds-icon, #292A2E)"
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M7.80469 16L10.9746 7.26953H12.2637L15.4746 16H14.3027L12.4512 10.8203C12.3379 10.5 12.2051 10.1016 12.0527 9.625C11.9043 9.14453 11.7227 8.5332 11.5078 7.79102H11.7188C11.5078 8.54102 11.3242 9.16016 11.168 9.64844C11.0156 10.1328 10.8887 10.5234 10.7871 10.8203L8.98828 16H7.80469ZM9.39844 13.5625V12.5898H13.8809V13.5625H9.39844Z",
                    fill: iconColor
                })
            ]
        })
    });
function $41e58cb6d3564e2b$export$5b2f3a4c271f0961({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const labelId = (0, $cozmU.useId)();
    const activeColor = (0, $4Qu9h.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const { textColor: textColor, defaultColor: defaultColor } = (0, $hEYnV.useSelectedTextColor)();
    const closeMenu = context?.closeMenu;
    const isNewColorPaletteEnabled = (0, $ieeJu.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const selectedColor = activeColor || (isNewColorPaletteEnabled ? (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) : null);
    const handleHighlightColorChange = (0, $cozmU.useCallback)((color, event)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
            }));
            if (!isNewColorPaletteEnabled) closeMenu?.(event);
        }
    }, [
        api,
        closeMenu,
        isNewColorPaletteEnabled,
        parents
    ]);
    const colorPalette = (0, $cozmU.useMemo)(()=>{
        const isSelected = (color)=>color.value === selectedColor;
        const iconColor = $41e58cb6d3564e2b$var$getTextColorIconColor(defaultColor, textColor, isNewColorPaletteEnabled);
        const highlightPalette = isNewColorPaletteEnabled ? (0, $1jFAi.highlightColorPaletteNew) : (0, $evFm2.highlightColorPalette);
        return highlightPalette.filter((color)=>{
            return color.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
        }).map((color)=>({
                ...color,
                decorator: isNewColorPaletteEnabled && color.value === (0, $evFm2.REMOVE_HIGHLIGHT_COLOR) ? /*#__PURE__*/ (0, $8aG6j.jsx)($41e58cb6d3564e2b$var$NoColorIconDecorator, {
                    isSelected: isSelected(color),
                    iconColor: iconColor
                }) : /*#__PURE__*/ (0, $8aG6j.jsx)($41e58cb6d3564e2b$var$TextColorIconDecorator, {
                    label: color.label,
                    isSelected: isSelected(color),
                    iconColor: iconColor
                })
            }));
    }, [
        defaultColor,
        textColor,
        isNewColorPaletteEnabled,
        selectedColor
    ]);
    const colorPaletteElement = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $74bCf.default), {
        ariaLabelledBy: labelId,
        cols: isNewColorPaletteEnabled ? $41e58cb6d3564e2b$var$HIGHLIGHT_COLOR_PICKER_COLUMNS : undefined,
        gap: isNewColorPaletteEnabled ? 'space.0' : undefined,
        onClick: (color, _, event)=>{
            handleHighlightColorChange(color, event);
        },
        selectedColor: selectedColor,
        paletteOptions: {
            palette: colorPalette || [],
            hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
        }
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $dinVW.Stack), {
        xcss: (0, $w6R6I.cx)($41e58cb6d3564e2b$var$styles.container, isNewColorPaletteEnabled && $41e58cb6d3564e2b$var$styles.containerPatch),
        testId: "highlight-color-menu-item",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                id: labelId,
                size: "xxsmall",
                as: (0, $iDrrr.fg)('platform_editor_a11y_color_palette_radiogroup') ? 'div' : undefined,
                children: formatMessage((0, $hzZPp.highlightMessages).highlight)
            }),
            isNewColorPaletteEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $22YX5.Bleed), {
                inline: "space.025",
                children: colorPaletteElement
            }) : colorPaletteElement
        ]
    });
}
module.exports["HighlightColorMenuItem"] = $41e58cb6d3564e2b$export$5b2f3a4c271f0961;

});

parcelRegister("hEYnV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $8xvQD = parcelRequire("8xvQD");

const $903f1392564b5212$export$dbd605ef953212b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $8xvQD.SelectedTextColorContext));
} : ()=>(0, $cozmU.useContext)((0, $8xvQD.SelectedTextColorContext));
module.exports["useSelectedTextColor"] = $903f1392564b5212$export$dbd605ef953212b2;

});

parcelRegister("HGu9Y", function(module, exports) {

var $7toP7 = parcelRequire("7toP7");


var $fClPf = parcelRequire("fClPf");


var $aOTwp = parcelRequire("aOTwp");


var $gYiLB = parcelRequire("gYiLB");

const $7545ccce0e49e308$export$171e576bb7c729fa = ({ api: api })=>({
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $7toP7.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $aOTwp.getIndentCommand)(api?.analytics?.actions),
            outdentParagraphOrHeading: (0, $aOTwp.getOutdentCommand)(api?.analytics?.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $aOTwp.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: (indentationMark?.attrs.level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>(0, $gYiLB.keymapPlugin)(api?.analytics?.actions)
                }
            ];
        }
    });
module.exports["indentationPlugin"] = $7545ccce0e49e308$export$171e576bb7c729fa;

});

parcelRegister("aOTwp", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $iX5Ka = parcelRequire("iX5Ka");


var $9WBFV = parcelRequire("9WBFV");


var $fClPf = parcelRequire("fClPf");


var $fanJz = parcelRequire("fanJz");


var $eFZrs = parcelRequire("eFZrs");

const $8ccb9806c3a6424a$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $8ccb9806c3a6424a$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $9WBFV.toggleBlockMark)(indentation, getNewIndentationAttrs, $8ccb9806c3a6424a$export$54db194d337db321)(state, dispatch);
    };
}
function $8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $fanJz.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $8ccb9806c3a6424a$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $eFZrs.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $fClPf.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $8ccb9806c3a6424a$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getIndentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $8ccb9806c3a6424a$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $8ccb9806c3a6424a$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $krYZG.INPUT_METHOD).KEYBOARD)=>$8ccb9806c3a6424a$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $8ccb9806c3a6424a$var$getOutdentAttrs,
            direction: (0, $iX5Ka.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $8ccb9806c3a6424a$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $9WBFV.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);
module.exports["isIndentationAllowed"] = $8ccb9806c3a6424a$export$54db194d337db321;
module.exports["getIndentCommand"] = $8ccb9806c3a6424a$export$b294289254b8cdac;
module.exports["getOutdentCommand"] = $8ccb9806c3a6424a$export$620b2a1f10eb3a5f;

});

parcelRegister("fanJz", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dd1315d32deb815$export$2e2bcd8739ae039);
function $7dd1315d32deb815$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("eFZrs", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $iX5Ka = parcelRequire("iX5Ka");

const $1736d54b67a5c25e$var$indentTypes = {
    paragraph: (0, $iX5Ka.INDENT_TYPE).PARAGRAPH,
    heading: (0, $iX5Ka.INDENT_TYPE).HEADING
};
function $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $1736d54b67a5c25e$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $1736d54b67a5c25e$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).FORMATTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $krYZG.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $1736d54b67a5c25e$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $1736d54b67a5c25e$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}
module.exports["createAnalyticsDispatch"] = $1736d54b67a5c25e$export$4f15b45384b61427;

});

parcelRegister("gYiLB", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $b9BvQ = parcelRequire("b9BvQ");


var $44cyU = parcelRequire("44cyU");


var $bjg0G = parcelRequire("bjg0G");


var $aOTwp = parcelRequire("aOTwp");

function $1df8e650ca8df6e6$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && parent?.type === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $aOTwp.getIndentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.outdent)), (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD), list);
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.findShortcutByKeymap)((0, $ldqjS.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $b9BvQ.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $bjg0G.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $aOTwp.getOutdentCommand)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $44cyU.keymap)(list);
}
var $1df8e650ca8df6e6$export$2e2bcd8739ae039 = $1df8e650ca8df6e6$export$e832373cff8dec22;
module.exports["keymapPlugin"] = $1df8e650ca8df6e6$export$e832373cff8dec22;

});

parcelRegister("jdplc", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $4o0zT = parcelRequire("4o0zT");


var $lP4rW = parcelRequire("lP4rW");


var $7Jrsi = parcelRequire("7Jrsi");


var $1aZze = parcelRequire("1aZze");


var $7G1y6 = parcelRequire("7G1y6");


var $28aNf = parcelRequire("28aNf");


var $bnkCY = parcelRequire("bnkCY");

const $93067ab894e7d078$export$c1375d8d7bd75982 = ({ config: config, api: api })=>{
    const editorAnalyticsAPI = api?.analytics?.actions;
    const isNewToolbarEnabled = Boolean(api?.toolbar);
    // Workaround since we want to insert a loom via the `hyperlink` plugin for now.
    // The hyperlink plugin (and the card plugin) are deeply tied into using the Prosemirror Command
    // Ideally one day we refactor those and we can remove this.
    const editorViewRef = {
        current: null
    };
    const primaryToolbarComponent = (0, $1aZze.loomPrimaryToolbarComponent)(config, api);
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    let isLoomMenuItemRegistered = false;
    const registerLoomMenuItem = ()=>{
        if (!isRegisteredSlashCommandEnabled || isLoomMenuItemRegistered || !api?.uiControlRegistry) return;
        api.uiControlRegistry.actions.register((0, $7G1y6.getLoomQuickInsertComponents)({
            api: api
        }));
        isLoomMenuItemRegistered = true;
    };
    if (config.loomProvider && isRegisteredSlashCommandEnabled) registerLoomMenuItem();
    if (isNewToolbarEnabled) api?.toolbar?.actions.registerComponents((0, $bnkCY.getToolbarComponents)(config, api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'loom',
        component: primaryToolbarComponent
    });
    return {
        name: 'loom',
        actions: {
            recordVideo: $lP4rW.recordVideo,
            insertLoom: (video, positionType)=>(0, $lP4rW.insertLoom)(editorViewRef.current, api, video, positionType),
            initLoom: async ({ loomProvider: loomProvider })=>{
                const result = await (0, $lP4rW.setupLoom)(loomProvider, api, editorViewRef.current, true);
                if (!result.error) registerLoomMenuItem();
                return result;
            }
        },
        pmPlugins: ()=>[
                {
                    name: 'loom',
                    plugin: ()=>(0, $7Jrsi.createPlugin)({
                            config: config,
                            api: api
                        })
                },
                {
                    name: 'loomViewRefWorkaround',
                    plugin: ()=>{
                        return new (0, $kpCD8.SafePlugin)({
                            view: (editorView)=>{
                                // Do not cleanup the editorViewRef on destroy
                                // because some functions may point to a stale
                                // reference and this means we will return null.
                                // EditorView is assumed to be stable so we do not need to
                                // cleanup.
                                // See: #hot-106316
                                editorViewRef.current = editorView;
                                return {};
                            }
                        });
                    }
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $7Jrsi.loomPluginKey).getState(editorState);
        },
        pluginsOptions: isRegisteredSlashCommandEnabled ? {} : {
            // Enable inserting Loom recordings through the slash command
            quickInsert: (intl)=>{
                if (config.loomProvider) return (0, $28aNf.getQuickInsertItem)(editorAnalyticsAPI)(intl);
                return [];
            }
        },
        // Enable inserting Loom recordings through main toolbar
        primaryToolbarComponent: !api?.primaryToolbar && !isNewToolbarEnabled ? primaryToolbarComponent : undefined
    };
};
module.exports["loomPlugin"] = $93067ab894e7d078$export$c1375d8d7bd75982;

});

parcelRegister("lP4rW", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $jv11C = parcelRequire("jv11C");


var $28aNf = parcelRequire("28aNf");


var $7Jrsi = parcelRequire("7Jrsi");

const $fa941eae7657c6f0$export$b5c7c74886310ae0 = ({ loomButton: loomButton })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).ENABLE,
            loomButton: loomButton
        });
        return tr;
    };
const $fa941eae7657c6f0$export$6f61f49dd8b64c45 = ({ error: error })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).DISABLE,
            error: error
        });
        return tr;
    };
const $fa941eae7657c6f0$export$2d56b03ca3f4ead9 = ({ inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).RECORD_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).RECORD_VIDEO,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$export$3b5a9e613ed2ae87 = ({ inputMethod: inputMethod, error: error, editorAnalyticsAPI: editorAnalyticsAPI })=>({ tr: tr })=>{
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).RECORD_VIDEO_FAILED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            attributes: {
                inputMethod: inputMethod,
                error: error
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$export$73a289ac38fc1ec = ({ editorAnalyticsAPI: editorAnalyticsAPI, video: video })=>({ tr: tr })=>{
        tr.setMeta((0, $7Jrsi.loomPluginKey), {
            type: (0, $7Jrsi.LoomPluginAction).INSERT_VIDEO
        });
        editorAnalyticsAPI?.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERT_VIDEO,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            eventType: (0, $krYZG.EVENT_TYPE).TRACK,
            attributes: {
                duration: video.duration
            }
        })(tr);
        return tr;
    };
const $fa941eae7657c6f0$var$getPositions = (tr, posType)=>{
    const selection = tr.selection;
    switch(posType){
        case 'current':
            return {
                from: selection.from,
                to: selection.from
            };
        case 'start':
            return {
                from: 0,
                to: 0
            };
        case 'end':
            return {
                from: tr.doc.content.size,
                to: tr.doc.content.size
            };
    }
};
const $fa941eae7657c6f0$export$e61f2d2bdaa7ecf4 = (editorView, api, video, positionType)=>{
    if (!editorView) return false;
    const { state: state, dispatch: dispatch } = editorView;
    const { from: from, to: to } = $fa941eae7657c6f0$var$getPositions(state.tr, positionType);
    return api?.hyperlink?.actions.insertLink((0, $krYZG.INPUT_METHOD).TYPEAHEAD, from, to, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch) ?? false;
};
const $fa941eae7657c6f0$export$92a5ff9a4d5c2287 = (api)=>{
    api?.core?.actions.execute($fa941eae7657c6f0$export$2d56b03ca3f4ead9({
        inputMethod: (0, $krYZG.INPUT_METHOD).TOOLBAR,
        editorAnalyticsAPI: api?.analytics?.actions
    }));
};
const $fa941eae7657c6f0$export$a39487b0b81d2404 = async (loomProvider, api, editorView, /**
	 * Whether loom initialisation is evoked via `initLoom` command.
	 */ initViaCommand)=>{
    const clientResult = await loomProvider.getClient();
    if (clientResult.status === 'error') {
        api?.core?.actions.execute($fa941eae7657c6f0$export$6f61f49dd8b64c45({
            error: clientResult.message
        }));
        (0, $jv11C.logException)(new Error(clientResult.message), {
            location: 'editor-plugin-loom/sdk-initialisation'
        });
        api?.analytics?.actions.fireAnalyticsEvent({
            action: (0, $krYZG.ACTION).ERRORED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
            eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: clientResult.message
            }
        });
        return {
            error: clientResult.message
        };
    }
    const { attachToButton: attachToButton } = clientResult.client;
    // Hidden element to work around the SDK API
    const loomButton = document.createElement('button');
    attachToButton({
        button: loomButton,
        onInsert: (video)=>{
            if (!editorView) return;
            const { state: state, dispatch: dispatch } = editorView;
            const pos = state.selection.from;
            api?.hyperlink?.actions.insertLink((0, $krYZG.INPUT_METHOD).TYPEAHEAD, pos, pos, video.sharedUrl, video.title, undefined, undefined, undefined, 'embed')(state, dispatch);
            api?.core?.actions.execute($fa941eae7657c6f0$export$73a289ac38fc1ec({
                editorAnalyticsAPI: api?.analytics?.actions,
                video: video
            }));
        }
    });
    api?.core?.actions.execute(({ tr: tr })=>{
        $fa941eae7657c6f0$export$b5c7c74886310ae0({
            loomButton: loomButton
        })({
            tr: tr
        });
        if (initViaCommand) api?.quickInsert?.commands.addQuickInsertItem((0, $28aNf.getQuickInsertItem)(api?.analytics?.actions))({
            tr: tr
        });
        return tr;
    });
    // We're not combining the analytics steps into the enable / disable commands because the collab-edit plugin
    // filters out any transactions with steps (even analytics) when it's initialising.
    // Even if `initViaCommand` is true, collab-edit might not be ready depending on when `initLoom` is called,
    // hence the analytics step is added separately in both cases
    api?.analytics?.actions.fireAnalyticsEvent({
        action: (0, $krYZG.ACTION).INITIALISED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).LOOM,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL
    });
    return {};
};
module.exports["recordVideo"] = $fa941eae7657c6f0$export$2d56b03ca3f4ead9;
module.exports["recordVideoFailed"] = $fa941eae7657c6f0$export$3b5a9e613ed2ae87;
module.exports["insertLoom"] = $fa941eae7657c6f0$export$e61f2d2bdaa7ecf4;
module.exports["executeRecordVideo"] = $fa941eae7657c6f0$export$92a5ff9a4d5c2287;
module.exports["setupLoom"] = $fa941eae7657c6f0$export$a39487b0b81d2404;

});

parcelRegister("28aNf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $jv11C = parcelRequire("jv11C");


var $60Yxm = parcelRequire("60Yxm");


var $4o0zT = parcelRequire("4o0zT");


var $lP4rW = parcelRequire("lP4rW");


var $7Jrsi = parcelRequire("7Jrsi");

const $c5f309acd343d20a$export$3432d7b65cad662d = (editorAnalyticsAPI)=>({ formatMessage: formatMessage })=>[
            {
                id: 'loom',
                title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideo),
                description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideoDescription),
                keywords: [
                    'loom',
                    'record',
                    'video'
                ],
                priority: 800,
                isDisabledOffline: true,
                icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
                        label: "",
                        color: (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? undefined : "var(--ds-icon-subtle, #505258)",
                        spacing: "spacious"
                    }),
                action (insert, editorState) {
                    const tr = insert(undefined);
                    const loomState = (0, $7Jrsi.loomPluginKey).getState(editorState);
                    if (!loomState?.isEnabled) {
                        const errorMessage = loomState?.error;
                        (0, $jv11C.logException)(new Error(errorMessage), {
                            location: 'editor-plugin-loom/quick-insert-record-video'
                        });
                        return (0, $lP4rW.recordVideoFailed)({
                            inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                            error: errorMessage,
                            editorAnalyticsAPI: editorAnalyticsAPI
                        })({
                            tr: tr
                        }) ?? false;
                    }
                    return (0, $lP4rW.recordVideo)({
                        inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                        editorAnalyticsAPI: editorAnalyticsAPI
                    })({
                        tr: tr
                    }) ?? false;
                }
            }
        ];
module.exports["getQuickInsertItem"] = $c5f309acd343d20a$export$3432d7b65cad662d;

});

parcelRegister("7Jrsi", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $lP4rW = parcelRequire("lP4rW");

var $a44fd40d86cc104a$export$5f9dbfce88541fe5 = /*#__PURE__*/ function(LoomPluginAction) {
    LoomPluginAction[LoomPluginAction["ENABLE"] = 0] = "ENABLE";
    LoomPluginAction[LoomPluginAction["DISABLE"] = 1] = "DISABLE";
    LoomPluginAction[LoomPluginAction["RECORD_VIDEO"] = 2] = "RECORD_VIDEO";
    LoomPluginAction[LoomPluginAction["INSERT_VIDEO"] = 3] = "INSERT_VIDEO";
    return LoomPluginAction;
}({});
const $a44fd40d86cc104a$export$db6b5ebe5a8c279 = new (0, $kCECX.PluginKey)('loom');
const $a44fd40d86cc104a$export$ae829ec7b2625219 = ({ config: config, api: api })=>{
    return new (0, $kpCD8.SafePlugin)({
        key: $a44fd40d86cc104a$export$db6b5ebe5a8c279,
        state: {
            init: ()=>({
                    isEnabled: false,
                    loomButton: null,
                    isRecordingVideo: false,
                    error: undefined
                }),
            apply: (tr, pluginState)=>{
                const action = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279)?.type;
                switch(action){
                    case 0:
                        const { loomButton: loomButton } = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: true,
                            loomButton: loomButton
                        };
                    case 1:
                        const { error: error } = tr.getMeta($a44fd40d86cc104a$export$db6b5ebe5a8c279);
                        return {
                            ...pluginState,
                            isEnabled: false,
                            loomButton: null,
                            error: error
                        };
                    case 2:
                        // Click the unmounted button in state that has the Loom SDK attached
                        pluginState?.loomButton?.click();
                        return {
                            ...pluginState,
                            isRecordingVideo: true
                        };
                    case 3:
                        return {
                            ...pluginState,
                            isRecordingVideo: false
                        };
                    default:
                        return pluginState;
                }
            }
        },
        view (editorView) {
            if (config.loomProvider) (0, $lP4rW.setupLoom)(config.loomProvider, api, editorView);
            return {};
        }
    });
};
module.exports["LoomPluginAction"] = $a44fd40d86cc104a$export$5f9dbfce88541fe5;
module.exports["loomPluginKey"] = $a44fd40d86cc104a$export$db6b5ebe5a8c279;
module.exports["createPlugin"] = $a44fd40d86cc104a$export$ae829ec7b2625219;

});

parcelRegister("1aZze", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $jaFVy = parcelRequire("jaFVy");


var $3k5Tv = parcelRequire("3k5Tv");


var $lP4rW = parcelRequire("lP4rW");


var $g00sD = parcelRequire("g00sD");

const $ec640dec66ccb66d$var$selector = (states)=>{
    return {
        loomEnabled: states.loomState?.isEnabled,
        connectivityMode: states.connectivityState?.mode
    };
};
const $ec640dec66ccb66d$var$CustomisableLoomToolbarButton = (disabled, appearance, api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((props, ref)=>{
        const { onClickBeforeInit: onClickBeforeInit, isDisabled: isDisabled = false, href: href, ...restProps } = props;
        const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
            'loom',
            'connectivity'
        ], $ec640dec66ccb66d$var$selector);
        const isLoomEnabled = !!loomEnabled;
        const handleOnClick = (0, $cozmU.useCallback)((e)=>{
            if (isLoomEnabled) (0, $lP4rW.executeRecordVideo)(api);
            else onClickBeforeInit && onClickBeforeInit(e);
        }, [
            isLoomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g00sD.default), {
            ref: ref,
            hideTooltip: !!(restProps.onMouseEnter || restProps.onMouseLeave),
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: isLoomEnabled ? undefined : href,
            disabled: disabled || isDisabled || (0, $jaFVy.isOfflineMode)(connectivityMode),
            api: api,
            appearance: appearance,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (e)=>handleOnClick(e),
            ...restProps
        });
    });
const $ec640dec66ccb66d$var$LoomToolbarButtonWrapper = ({ disabled: disabled, api: api, appearance: appearance })=>{
    const handleOnClick = (0, $cozmU.useCallback)(()=>(0, $lP4rW.executeRecordVideo)(api), [
        api
    ]);
    const { loomEnabled: loomEnabled, connectivityMode: connectivityMode } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'loom',
        'connectivity'
    ], $ec640dec66ccb66d$var$selector);
    if (loomEnabled === undefined) return null;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $g00sD.default), {
        // Disable the icon while the SDK isn't initialised
        disabled: disabled || !loomEnabled || (0, $jaFVy.isOfflineMode)(connectivityMode),
        api: api,
        appearance: appearance,
        onClick: handleOnClick
    });
};
const $ec640dec66ccb66d$export$b7aa095334bc8677 = (config, api)=>({ disabled: disabled, appearance: appearance })=>{
        if (config.shouldShowToolbarButton === false) return null;
        if (config.renderButton) return config.renderButton($ec640dec66ccb66d$var$CustomisableLoomToolbarButton(disabled, appearance, api));
        if (config.shouldShowToolbarButton) return /*#__PURE__*/ (0, $lOiVq.jsx)($ec640dec66ccb66d$var$LoomToolbarButtonWrapper, {
            // Disable the icon while the SDK isn't initialised
            disabled: disabled,
            api: api,
            appearance: appearance
        });
        return null;
    };
module.exports["loomPrimaryToolbarComponent"] = $ec640dec66ccb66d$export$b7aa095334bc8677;

});

parcelRegister("g00sD", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $aiL0G = parcelRequire("aiL0G");


var $gx3UZ = parcelRequire("gx3UZ");


var $ldbHR = parcelRequire("ldbHR");


var $3k5Tv = parcelRequire("3k5Tv");


var $60Yxm = parcelRequire("60Yxm");

function $367060042bbafb1f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
// Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
const $367060042bbafb1f$var$LOOM_BUTTON_WIDTH_BREAKPOINT = 1076;
const $367060042bbafb1f$var$iconMinWidthStyle = {
    name: "9bmev",
    styles: "min-width:24px"
};
const $367060042bbafb1f$var$selector = (states)=>{
    return {
        width: states.widthState?.width
    };
};
const $367060042bbafb1f$var$LoomToolbarButtonInternal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ disabled: disabled, api: api, appearance: appearance, intl: { formatMessage: formatMessage }, selected: selected, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'data-ds--level': dataDsLevel, onClick: onClick, href: href, target: target, hideTooltip: hideTooltip, rel: rel }, ref)=>{
    const { width: width } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'width'
    ], $367060042bbafb1f$var$selector);
    const label = formatMessage(appearance === 'comment' ? (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideoComment : (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideo);
    const shouldShowRecordText = (width || 0) > $367060042bbafb1f$var$LOOM_BUTTON_WIDTH_BREAKPOINT;
    return /*#__PURE__*/ (0, $lOiVq.jsx)((0, $ldbHR.default), {
        hideTooltip: hideTooltip,
        ref: ref,
        href: href,
        buttonId: (0, $aiL0G.TOOLBAR_ACTION_SUBJECT_ID).RECORD_VIDEO,
        disabled: disabled,
        title: label,
        iconBefore: /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
            css: $367060042bbafb1f$var$iconMinWidthStyle
        }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            label: label,
            color: disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
            spacing: "spacious"
        })),
        selected: selected,
        onBlur: onBlur,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "aria-controls": ariaControls,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        target: target,
        rel: rel
    }, shouldShowRecordText && formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordLoomShortTitle));
});
const $367060042bbafb1f$var$_default_1 = (0, $kSwu1.injectIntl)($367060042bbafb1f$var$LoomToolbarButtonInternal, {
    forwardRef: true
});
var $367060042bbafb1f$export$2e2bcd8739ae039 = $367060042bbafb1f$var$_default_1;
module.exports["default"] = $367060042bbafb1f$export$2e2bcd8739ae039;

});

parcelRegister("7G1y6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $gx3UZ = parcelRequire("gx3UZ");


var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");


var $7PIl3 = parcelRequire("7PIl3");

const $d544291d906bb420$export$f6aadb331b1b1790 = ({ api: api })=>[
        {
            key: (0, $dCkbP.LOOM_MENU_ITEM).key,
            type: (0, $dCkbP.LOOM_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.CREATE_SECTION).key,
                    type: (0, $dCkbP.CREATE_SECTION).type,
                    rank: (0, $dXqu3.CREATE_SECTION_RANK)[(0, $dCkbP.LOOM_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideoDescription),
                    keywords: [
                        'loom',
                        'record',
                        'video'
                    ],
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).loomTitle)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $7PIl3.LoomQuickInsertMenuItem), {
                    api: api
                })
        }
    ];
module.exports["getLoomQuickInsertComponents"] = $d544291d906bb420$export$f6aadb331b1b1790;

});

parcelRegister("7PIl3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $jv11C = parcelRequire("jv11C");


var $I2MTF = parcelRequire("I2MTF");


var $lPJNC = parcelRequire("lPJNC");


var $9wgTc = parcelRequire("9wgTc");


var $60Yxm = parcelRequire("60Yxm");


var $lP4rW = parcelRequire("lP4rW");


var $7Jrsi = parcelRequire("7Jrsi");

const $4be03fc915944ace$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM4.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIR.png'
};
const $4be03fc915944ace$export$fac7c79757e2238d = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isOffline: isOffline } = (0, $9wgTc.useQuickInsertContext)();
    const preview = (0, $cozmU.useMemo)(()=>({
            image: $4be03fc915944ace$var$previewImageUrls,
            attribution: {
                name: formatMessage((0, $lPJNC.messages).previewAttributionAtlassian)
            }
        }), [
        formatMessage
    ]);
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert })=>{
        const tr = insert(undefined);
        const loomState = (0, $7Jrsi.loomPluginKey).getState(editorView.state);
        if (!loomState?.isEnabled) {
            (0, $jv11C.logException)(new Error(loomState?.error), {
                location: 'editor-plugin-loom/quick-insert-record-video'
            });
            return (0, $lP4rW.recordVideoFailed)({
                inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
                error: loomState?.error,
                editorAnalyticsAPI: api?.analytics?.actions
            })({
                tr: tr
            }) ?? false;
        }
        return (0, $lP4rW.recordVideo)({
            inputMethod: (0, $krYZG.INPUT_METHOD).QUICK_INSERT,
            editorAnalyticsAPI: api?.analytics?.actions
        })({
            tr: tr
        }) ?? false;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).recordVideoDescription),
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            label: ""
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        preview: preview,
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).loomTitle)
    });
};
module.exports["LoomQuickInsertMenuItem"] = $4be03fc915944ace$export$fac7c79757e2238d;

});

parcelRegister("bnkCY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");


var $hVLmg = parcelRequire("hVLmg");


var $akmSK = parcelRequire("akmSK");


var $QhQtc = parcelRequire("QhQtc");

const $abbb8912713cedae$export$a758406ca53b86a5 = (config, api)=>{
    return [
        {
            type: (0, $3nacY.LOOM_MENU_SECTION).type,
            key: (0, $3nacY.LOOM_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.LOOM_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $QhQtc.MenuSection), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $3nacY.LOOM_MENU_ITEM).type,
            key: (0, $3nacY.LOOM_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $3nacY.LOOM_MENU_SECTION).type,
                    key: (0, $3nacY.LOOM_MENU_SECTION).key,
                    rank: (0, $hVLmg.LOOM_MENU_SECTION_RANK)[(0, $3nacY.LOOM_MENU_ITEM).key]
                },
                {
                    type: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
                    key: (0, $3nacY.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
                    rank: (0, $hVLmg.OVERFLOW_EXTENSIONS_MENU_SECTION_RANK)[(0, $3nacY.LOOM_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $akmSK.LoomMenuItem), {
                    api: api,
                    renderButton: config.renderButton
                });
            },
            isHidden: ()=>{
                const loomState = api?.loom?.sharedState.currentState();
                const editorViewMode = api?.editorViewMode?.sharedState.currentState() ?? 'edit';
                // if shouldRenderButton is not provided, default to true
                const shouldRenderButton = config?.shouldRenderButton?.() ?? true;
                return 'renderButton' in config && shouldRenderButton === false || loomState?.isEnabled === undefined || editorViewMode !== 'edit';
            }
        }
    ];
};
module.exports["getToolbarComponents"] = $abbb8912713cedae$export$a758406ca53b86a5;

});

parcelRegister("akmSK", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $gx3UZ = parcelRequire("gx3UZ");


var $bFSJa = parcelRequire("bFSJa");


var $3k5Tv = parcelRequire("3k5Tv");


var $60Yxm = parcelRequire("60Yxm");


var $dVKvM = parcelRequire("dVKvM");


var $lP4rW = parcelRequire("lP4rW");

const $1c445c5059187b69$var$useLoomEnabled = (api)=>{
    const { loomEnabled: loomEnabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'loom'
    ], (states)=>{
        return {
            loomEnabled: states.loomState?.isEnabled
        };
    });
    return loomEnabled;
};
const $1c445c5059187b69$export$cfd738d449e0a4ef = ({ api: api, renderButton: renderButton })=>{
    const loomEnabled = $1c445c5059187b69$var$useLoomEnabled(api);
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    if (editorViewMode !== 'edit') return null;
    if (renderButton) return renderButton($1c445c5059187b69$export$a209d77fd6c75051(api));
    else if (loomEnabled !== undefined) return /*#__PURE__*/ (0, $8aG6j.jsx)($1c445c5059187b69$var$DefaultLoomMenuItem, {
        api: api
    });
};
const $1c445c5059187b69$export$a209d77fd6c75051 = (api)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ isDisabled: isDisabled = false, onClickBeforeInit: onClickBeforeInit, href: href, target: target, rel: rel }, ref)=>{
        const loomEnabled = !!$1c445c5059187b69$var$useLoomEnabled(api);
        const handleOnClick = (0, $cozmU.useCallback)((e)=>{
            if (loomEnabled) (0, $lP4rW.executeRecordVideo)(api);
            else if (onClickBeforeInit && e.type === 'click' && e.target instanceof HTMLElement) onClickBeforeInit(e);
        }, [
            loomEnabled,
            onClickBeforeInit
        ]);
        return /*#__PURE__*/ (0, $8aG6j.jsx)($1c445c5059187b69$var$MenuItemComponent, {
            ref: ref,
            // Ignore href if Loom is enabled so that it doesn't interfere with recording
            href: loomEnabled ? undefined : href,
            disabled: isDisabled,
            onClick: handleOnClick,
            target: target,
            rel: rel
        });
    });
const $1c445c5059187b69$var$DefaultLoomMenuItem = ({ api: api })=>{
    const loomEnabled = $1c445c5059187b69$var$useLoomEnabled(api);
    const handleOnClick = (0, $cozmU.useCallback)(()=>(0, $lP4rW.executeRecordVideo)(api), [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)($1c445c5059187b69$var$MenuItemComponent, {
        disabled: !loomEnabled,
        onClick: handleOnClick
    });
};
const $1c445c5059187b69$var$MenuItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(// eslint-disable-next-line no-unused-vars
({ disabled: disabled, onClick: onClick, href: href, target: target, rel: rel }, ref)=>{
    const { editorAppearance: editorAppearance } = (0, $bFSJa.useEditorToolbar)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $dVKvM.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))), {
            size: "small",
            label: ""
        }),
        isDisabled: disabled,
        href: href,
        target: target,
        rel: rel,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>onClick(e),
        children: formatMessage(editorAppearance === 'comment' ? (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideoComment : (0, $gx3UZ.toolbarInsertBlockMessages).addLoomVideo)
    });
});
module.exports["LoomMenuItem"] = $1c445c5059187b69$export$cfd738d449e0a4ef;

});

parcelRegister("QhQtc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $bFSJa = parcelRequire("bFSJa");


var $jgJIe = parcelRequire("jgJIe");

const $fc79263a4212ed67$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $bFSJa.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $fc79263a4212ed67$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $fc79263a4212ed67$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jgJIe.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};
module.exports["MenuSection"] = $fc79263a4212ed67$export$4b1545b4f2016d26;

});

parcelRegister("2hEu6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $2kGqi = parcelRequire("2kGqi");


var $krYZG = parcelRequire("krYZG");


var $jGK9e = parcelRequire("jGK9e");


var $gx3UZ = parcelRequire("gx3UZ");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $gtG8p = parcelRequire("gtG8p");


var $7YIYC = parcelRequire("7YIYC");


var $jV511 = parcelRequire("jV511");


var $kDjQd = parcelRequire("kDjQd");


var $3vhYl = parcelRequire("3vhYl");


var $6SVJo = parcelRequire("6SVJo");

const $c741bb398d7047e7$export$7cc71f8da095a98d = ({ api: api })=>{
    const isRegisteredSlashCommandEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) api?.uiControlRegistry?.actions.register((0, $3vhYl.getRuleQuickInsertComponents)({
        api: api
    }));
    return {
        name: 'rule',
        nodes () {
            return [
                {
                    name: 'rule',
                    node: (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_dividers_attributes') ? (0, $2kGqi.ruleWithAttrs) : (0, $iDrrr.fg)('platform_editor_adf_with_localid') ? (0, $2kGqi.ruleWithLocalId) : (0, $2kGqi.rule)
                }
            ];
        },
        actions: {
            insertHorizontalRule: (0, $gtG8p.insertHorizontalRule)(api?.analytics?.actions)
        },
        pmPlugins () {
            return [
                ...(0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_dividers') ? [
                    {
                        name: 'ruleNodeView',
                        plugin: (0, $kDjQd.default)
                    }
                ] : [],
                {
                    name: 'ruleInputRule',
                    plugin: ({ schema: schema })=>(0, $7YIYC.default)(schema, api?.analytics?.actions)
                },
                {
                    name: 'ruleKeymap',
                    plugin: ()=>(0, $jV511.default)(api?.analytics?.actions)
                }
            ];
        },
        pluginsOptions: {
            ...(0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_dividers') ? {
                floatingToolbar: (state, intl)=>(0, $6SVJo.getToolbarConfig)(state, intl, api)
            } : {},
            quickInsert: isRegisteredSlashCommandEnabled ? undefined : ({ formatMessage: formatMessage })=>[
                    {
                        id: 'rule',
                        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRule),
                        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRuleDescription),
                        keywords: [
                            'horizontal',
                            'rule',
                            'line',
                            'hr'
                        ],
                        priority: 1200,
                        keyshortcut: '---',
                        icon: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $jGK9e.IconDivider), {}),
                        action (insert, state, source) {
                            const tr = insert(state.schema.nodes.rule.createChecked());
                            api?.analytics?.actions.attachAnalyticsEvent({
                                action: (0, $krYZG.ACTION).INSERTED,
                                actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DIVIDER,
                                attributes: {
                                    inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $krYZG.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};
module.exports["rulePlugin"] = $c741bb398d7047e7$export$7cc71f8da095a98d;

});

parcelRegister("gtG8p", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $bjg0G = parcelRequire("bjg0G");


var $cpKbG = parcelRequire("cpKbG");


var $7YIYC = parcelRequire("7YIYC");

const $5deaa86b10dd8648$export$439dcefd29ca03b3 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const tr = (0, $7YIYC.createHorizontalRule)(state, state.selection.from, state.selection.to, inputMethod, editorAnalyticsAPI);
            if (tr) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
const $5deaa86b10dd8648$export$93942a466902d058 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { rule: rule } = state.schema.nodes;
        if (!(0, $bjg0G.findSelectedNodeOfType)(rule)(state.selection)) return false;
        if (dispatch) {
            const deleteTr = (0, $bjg0G.removeSelectedNode)(state.tr);
            const payload = {
                action: (0, $krYZG.ACTION).DELETED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DIVIDER,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            };
            editorAnalyticsAPI?.attachAnalyticsEvent(payload)(deleteTr);
            dispatch(deleteTr);
        }
        return true;
    };
const $5deaa86b10dd8648$export$e55d67c4985f2966 = (weight, editorAnalyticsAPI)=>(state, dispatch)=>{
        const { rule: rule } = state.schema.nodes;
        const selectedRule = (0, $bjg0G.findSelectedNodeOfType)(rule)(state.selection);
        if (!selectedRule) return false;
        const previousWeight = selectedRule.node.attrs.weight ?? (0, $cpKbG.DEFAULT_DIVIDER_WEIGHT);
        if (previousWeight === weight) return true;
        if (dispatch) {
            const updateTr = state.tr.setNodeMarkup(selectedRule.pos, undefined, {
                ...selectedRule.node.attrs,
                weight: weight
            });
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).UPDATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DIVIDER,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                    previousWeight: previousWeight,
                    weight: weight
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(updateTr);
            dispatch(updateTr);
        }
        return true;
    };
const $5deaa86b10dd8648$export$f1274b300007451f = (style, editorAnalyticsAPI)=>(state, dispatch)=>{
        const { rule: rule } = state.schema.nodes;
        const selectedRule = (0, $bjg0G.findSelectedNodeOfType)(rule)(state.selection);
        if (!selectedRule) return false;
        const previousStyle = selectedRule.node.attrs.style ?? (0, $cpKbG.DEFAULT_DIVIDER_STYLE);
        if (previousStyle === style) return true;
        if (dispatch) {
            const updateTr = state.tr.setNodeMarkup(selectedRule.pos, undefined, {
                ...selectedRule.node.attrs,
                style: style
            });
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).UPDATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DIVIDER,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                    previousStyle: previousStyle,
                    style: style
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(updateTr);
            dispatch(updateTr);
        }
        return true;
    };
const $5deaa86b10dd8648$export$69bf1c5ef9e8c26b = (color, editorAnalyticsAPI)=>(state, dispatch)=>{
        const { rule: rule } = state.schema.nodes;
        const selectedRule = (0, $bjg0G.findSelectedNodeOfType)(rule)(state.selection);
        if (!selectedRule) return false;
        const defaultColor = "var(--ds-border, #0B120E24)";
        const previousColor = typeof selectedRule.node.attrs.color === 'string' ? selectedRule.node.attrs.color : null;
        const updatedColor = color === defaultColor ? null : color;
        if (previousColor === updatedColor) return true;
        if (dispatch) {
            const updateTr = state.tr.setNodeMarkup(selectedRule.pos, undefined, {
                ...selectedRule.node.attrs,
                color: updatedColor
            });
            editorAnalyticsAPI?.attachAnalyticsEvent({
                action: (0, $krYZG.ACTION).UPDATED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).DIVIDER,
                attributes: {
                    inputMethod: (0, $krYZG.INPUT_METHOD).FLOATING_TB,
                    previousColor: previousColor,
                    color: updatedColor
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            })(updateTr);
            dispatch(updateTr);
        }
        return true;
    };
module.exports["insertHorizontalRule"] = $5deaa86b10dd8648$export$439dcefd29ca03b3;
module.exports["removeHorizontalRule"] = $5deaa86b10dd8648$export$93942a466902d058;
module.exports["updateHorizontalRuleWeight"] = $5deaa86b10dd8648$export$e55d67c4985f2966;
module.exports["updateHorizontalRuleStyle"] = $5deaa86b10dd8648$export$f1274b300007451f;
module.exports["updateHorizontalRuleColor"] = $5deaa86b10dd8648$export$69bf1c5ef9e8c26b;

});

parcelRegister("cpKbG", function(module, exports) {
const $02c43b586d3d8cc1$export$18afedb55d187f64 = 'solid';
const $02c43b586d3d8cc1$export$c51e6b91f3cc81af = 2;
module.exports["DEFAULT_DIVIDER_STYLE"] = $02c43b586d3d8cc1$export$18afedb55d187f64;
module.exports["DEFAULT_DIVIDER_WEIGHT"] = $02c43b586d3d8cc1$export$c51e6b91f3cc81af;

});

parcelRegister("7YIYC", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $8tXCb = parcelRequire("8tXCb");


var $kpCD8 = parcelRequire("kpCD8");


var $d8RhQ = parcelRequire("d8RhQ");


var $aPdNQ = parcelRequire("aPdNQ");


var $bjg0G = parcelRequire("bjg0G");


var $3brWT = parcelRequire("3brWT");


var $91Kwo = parcelRequire("91Kwo");

const $05985544cd07af13$export$718ed5cb714e84ae = (state, start, end, inputMethod, editorAnalyticsAPI)=>{
    if (!state.selection.empty) return null;
    let tr = null;
    const { rule: rule } = state.schema.nodes;
    /**
	 * This is a workaround to get rid of the typeahead text when using quick insert
	 * Once we insert *nothing*, we get a new transaction, so we can use the new selection
	 * without considering the extra text after the `/` command.
	 **/ tr = state.tr.replaceWith(start, end, (0, $aPdNQ.Fragment).empty);
    tr = (0, $8tXCb.safeInsert)(rule.createChecked(), tr.selection.from)(tr);
    if (!tr) tr = state.tr.replaceRange(start, end, new (0, $aPdNQ.Slice)((0, $aPdNQ.Fragment).from(state.schema.nodes.rule.createChecked()), 0, 0));
    editorAnalyticsAPI?.attachAnalyticsEvent({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DIVIDER,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $krYZG.EVENT_TYPE).TRACK
    })(tr);
    return tr;
};
const $05985544cd07af13$var$createHorizontalRuleAutoformat = (state, start, end, editorAnalyticsAPI)=>{
    const { listItem: listItem } = state.schema.nodes;
    if ((0, $bjg0G.hasParentNodeOfType)(listItem)(state.selection)) return null;
    return $05985544cd07af13$export$718ed5cb714e84ae(state, start, end, (0, $krYZG.INPUT_METHOD).FORMATTING, editorAnalyticsAPI);
};
// eslint-disable-next-line require-unicode-regexp
const $05985544cd07af13$var$HORIZONTAL_RULE_AUTOFORMAT_REGEX = /^(---|\*\*\*)$/;
function $05985544cd07af13$export$568a7ed6897c4817(schema, editorAnalyticsAPI) {
    const rules = [];
    if (schema.nodes.rule) {
        // '---' and '***' for hr
        rules.push((0, $d8RhQ.createRule)($05985544cd07af13$var$HORIZONTAL_RULE_AUTOFORMAT_REGEX, (state, _match, start, end)=>$05985544cd07af13$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI)));
        // '---' and '***' after shift+enter for hr
        rules.push((0, $d8RhQ.createRule)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`${(0, $3brWT.leafNodeReplacementCharacter)}(\\-\\-\\-|\\*\\*\\*)`), (state, _match, start, end)=>{
            const { hardBreak: hardBreak } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (state.doc.resolve(start).nodeAfter.type !== hardBreak) return null;
            return $05985544cd07af13$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI);
        }));
    }
    if (rules.length !== 0) return new (0, $kpCD8.SafePlugin)((0, $91Kwo.createPlugin)('rule', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $05985544cd07af13$export$2e2bcd8739ae039 = $05985544cd07af13$export$568a7ed6897c4817;
module.exports["createHorizontalRule"] = $05985544cd07af13$export$718ed5cb714e84ae;
module.exports["default"] = $05985544cd07af13$export$2e2bcd8739ae039;

});

parcelRegister("jV511", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $ldqjS = parcelRequire("ldqjS");


var $44cyU = parcelRequire("44cyU");


var $gtG8p = parcelRequire("gtG8p");

function $c2d8440543aebfe9$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $ldqjS.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.insertRule).common, (0, $gtG8p.insertHorizontalRule)(editorAnalyticsAPI)((0, $krYZG.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $ldqjS.bindKeymapWithCommand)((0, $ldqjS.escape).common, ()=>true, list);
    return (0, $44cyU.keymap)(list);
}
var $c2d8440543aebfe9$export$2e2bcd8739ae039 = $c2d8440543aebfe9$export$e832373cff8dec22;
module.exports["default"] = $c2d8440543aebfe9$export$2e2bcd8739ae039;

});

parcelRegister("kDjQd", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $lp7sw = parcelRequire("lp7sw");


var $9dMau = parcelRequire("9dMau");

const $061b77cc4184ae35$var$selectRuleOnClick = (0, $lp7sw.createSelectionClickHandler)([
    'rule'
], (target)=>!!target.closest('[data-rule-node-view]'), {
    useLongPressSelection: false
});
const $061b77cc4184ae35$export$ae829ec7b2625219 = ()=>new (0, $kpCD8.SafePlugin)({
        props: {
            nodeViews: {
                rule: (node, view)=>new (0, $9dMau.RuleNodeView)(node, view)
            },
            handleClickOn (view, ...args) {
                const handled = $061b77cc4184ae35$var$selectRuleOnClick(view, ...args);
                if (handled && view.editable) view.focus();
                return handled;
            }
        }
    });
var $061b77cc4184ae35$export$2e2bcd8739ae039 = $061b77cc4184ae35$export$ae829ec7b2625219;
module.exports["default"] = $061b77cc4184ae35$export$2e2bcd8739ae039;

});

parcelRegister("9dMau", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $aPdNQ = parcelRequire("aPdNQ");

const $4dfc138f9743ba5e$var$ruleNodeViewAttribute = 'data-rule-node-view';
class $4dfc138f9743ba5e$export$3f0e6320a0d488d8 {
    update(node) {
        if (node.type !== this.node.type) return false;
        if (this.dom.firstChild && node.sameMarkup(this.node)) {
            this.node = node;
            return true;
        }
        const toDOM = node.type.spec.toDOM;
        if (!toDOM) return false;
        const { dom: dom } = (0, $aPdNQ.DOMSerializer).renderSpec(this.view.dom.ownerDocument, toDOM(node));
        if (dom instanceof HTMLElement) dom.contentEditable = 'false';
        if (this.dom.firstChild) this.dom.replaceChild(dom, this.dom.firstChild);
        else this.dom.appendChild(dom);
        this.node = node;
        return true;
    }
    ignoreMutation() {
        return true;
    }
    destroy() {
        this.unbindMousedown();
    }
    constructor(node, view){
        this.dom = void 0;
        this.node = void 0;
        this.view = void 0;
        // when there is only 1 rule node on the page and it is not editable, clicking on it does not focus the editor and Cmd+C/ Ctrl+C shortcut will not work. this mouse down listener adds focus to the editor.
        this.handleMousedown = ()=>{
            if (!this.view.hasFocus()) this.view.focus();
        };
        this.unbindMousedown = void 0;
        this.node = node;
        this.view = view;
        const dom = this.view.dom.ownerDocument.createElement('div');
        this.dom = dom;
        dom.setAttribute($4dfc138f9743ba5e$var$ruleNodeViewAttribute, '');
        dom.setAttribute('contenteditable', 'inherit');
        this.unbindMousedown = (0, $cbY7C.bind)(dom, {
            type: 'mousedown',
            listener: this.handleMousedown
        });
        this.update(node);
    }
}
module.exports["RuleNodeView"] = $4dfc138f9743ba5e$export$3f0e6320a0d488d8;

});

parcelRegister("3vhYl", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $gx3UZ = parcelRequire("gx3UZ");


var $7SMXM = parcelRequire("7SMXM");


var $dCkbP = parcelRequire("dCkbP");


var $dXqu3 = parcelRequire("dXqu3");


var $03uyf = parcelRequire("03uyf");

const $a4c8f86523c4b5d4$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL8.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK1.png'
};
const $a4c8f86523c4b5d4$export$5dfa902850534ff5 = ({ api: api })=>[
        {
            key: (0, $dCkbP.RULE_MENU_ITEM).key,
            type: (0, $dCkbP.RULE_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $dCkbP.STRUCTURE_SECTION).key,
                    type: (0, $dCkbP.STRUCTURE_SECTION).type,
                    rank: (0, $dXqu3.STRUCTURE_SECTION_RANK)[(0, $dCkbP.RULE_MENU_ITEM).key]
                }
            ],
            match: (0, $7SMXM.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRuleDescription),
                    keywords: [
                        'horizontal',
                        'rule',
                        'line',
                        'hr'
                    ],
                    shortcut: '---',
                    title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRule)
                })),
            component: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $03uyf.RuleQuickInsertMenuItem), {
                    api: api,
                    previewImageUrls: $a4c8f86523c4b5d4$var$previewImageUrls
                })
        }
    ];
module.exports["getRuleQuickInsertComponents"] = $a4c8f86523c4b5d4$export$5dfa902850534ff5;

});

parcelRegister("03uyf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $krYZG = parcelRequire("krYZG");


var $gx3UZ = parcelRequire("gx3UZ");


var $I2MTF = parcelRequire("I2MTF");


var $lPJNC = parcelRequire("lPJNC");


var $hade9 = parcelRequire("hade9");

const $43f4ba6fda843c09$export$63f498da6b5e3124 = ({ api: api, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const preview = (0, $cozmU.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $lPJNC.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $cozmU.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        const tr = insert(editorView.state.schema.nodes.rule.createChecked());
        api?.analytics?.actions.attachAnalyticsEvent({
            action: (0, $krYZG.ACTION).INSERTED,
            actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).DIVIDER,
            attributes: {
                inputMethod: source ?? (0, $krYZG.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $krYZG.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I2MTF.QuickInsertMenuItem), {
        description: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRuleDescription),
        iconBefore: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hade9))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: "---",
        title: formatMessage((0, $gx3UZ.toolbarInsertBlockMessages).horizontalRule)
    });
};
module.exports["RuleQuickInsertMenuItem"] = $43f4ba6fda843c09$export$63f498da6b5e3124;

});

parcelRegister("6SVJo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $krYZG = parcelRequire("krYZG");


var $2xhuI = parcelRequire("2xhuI");


var $k2TYa = parcelRequire("k2TYa");


var $g8ETs = parcelRequire("g8ETs");


var $bjg0G = parcelRequire("bjg0G");


var $7Y8M5 = parcelRequire("7Y8M5");


var $fHs3z = parcelRequire("fHs3z");


var $dPtk6 = parcelRequire("dPtk6");


var $iDfTs = parcelRequire("iDfTs");


var $gtG8p = parcelRequire("gtG8p");


var $ltcoi = parcelRequire("ltcoi");


var $dW9Zh = parcelRequire("dW9Zh");


var $8tMrA = parcelRequire("8tMrA");

const $f6294d9ccc2bb84f$var$getToolbarItems = (formatMessage, ruleNodeType, ruleAttrs, api)=>{
    const hoverDecoration = api?.decorations?.actions.hoverDecoration;
    const hoverDecorationProps = (className)=>({
            onMouseEnter: hoverDecoration?.(ruleNodeType, true, className),
            onMouseLeave: hoverDecoration?.(ruleNodeType, false, className),
            onFocus: hoverDecoration?.(ruleNodeType, true, className),
            onBlur: hoverDecoration?.(ruleNodeType, false, className)
        });
    const currentColor = ruleAttrs.color || "var(--ds-border, #0B120E24)";
    const items = [
        {
            id: 'divider-options',
            type: 'dropdown',
            testId: 'divider-options',
            title: formatMessage((0, $k2TYa.ruleMessages).dividerOptions),
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($dPtk6))),
            options: {
                width: 272,
                height: 184,
                render: ({ dispatchCommand: dispatchCommand })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8tMrA.DividerOptions), {
                        style: ruleAttrs.style,
                        weight: ruleAttrs.weight,
                        onStyleChange: (style)=>dispatchCommand((0, $gtG8p.updateHorizontalRuleStyle)(style, api?.analytics?.actions)),
                        onWeightChange: (weight)=>dispatchCommand((0, $gtG8p.updateHorizontalRuleWeight)(weight, api?.analytics?.actions))
                    })
            }
        },
        {
            id: 'divider-color-picker',
            type: 'select',
            selectType: 'color',
            title: formatMessage((0, $k2TYa.ruleMessages).dividerColors),
            isAriaExpanded: true,
            hideExpandIcon: true,
            defaultValue: (0, $ltcoi.dividerColorPalette).find((color)=>color.value === currentColor) || {
                label: formatMessage((0, $k2TYa.ruleMessages).customDividerColor),
                value: currentColor,
                border: (0, $ltcoi.dividerColorPalette)[0].border
            },
            options: (0, $ltcoi.dividerColorPalette),
            cols: 10,
            hexToPaletteColor: (color)=>color === "var(--ds-border, #0B120E24)" ? color : (0, $g8ETs.hexToEditorTextPaletteColor)(color),
            paletteColorTooltipMessages: (0, $dW9Zh.dividerPaletteTooltipMessages),
            onChange: (option)=>(0, $gtG8p.updateHorizontalRuleColor)(option.value, api?.analytics?.actions)
        },
        {
            type: 'separator',
            fullHeight: true
        }
    ];
    const overflowMenuItems = [
        {
            type: 'overflow-dropdown',
            options: [
                {
                    title: formatMessage((0, $2xhuI.default).copyToClipboard),
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fHs3z))), {
                        label: ""
                    }),
                    onClick: ()=>{
                        api?.core?.actions.execute(api?.floatingToolbar?.commands.copyNode(ruleNodeType, (0, $krYZG.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    ...hoverDecorationProps((0, $7Y8M5.akEditorSelectedNodeClassName))
                },
                {
                    title: formatMessage((0, $2xhuI.default).delete),
                    icon: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                        label: ""
                    }),
                    onClick: (0, $gtG8p.removeHorizontalRule)(api?.analytics?.actions),
                    ...hoverDecorationProps()
                }
            ]
        }
    ];
    items.push(...overflowMenuItems);
    return items;
};
const $f6294d9ccc2bb84f$export$86ce8f8241c20a3 = (state, intl, api)=>{
    const { formatMessage: formatMessage } = intl;
    const { selection: selection } = state;
    const { rule: rule } = state.schema.nodes;
    const ruleNode = (0, $bjg0G.findSelectedNodeOfType)(state.schema.nodes.rule)(state.selection);
    if (!ruleNode) return undefined;
    const getDomRef = (editorView)=>{
        const domAtPos = editorView.domAtPos.bind(editorView);
        const element = (0, $bjg0G.findDomRefAtPos)(selection.from, domAtPos);
        return element;
    };
    return {
        title: formatMessage((0, $k2TYa.ruleMessages).dividerFloatingControls),
        getDomRef: getDomRef,
        nodeType: [
            rule
        ],
        items: $f6294d9ccc2bb84f$var$getToolbarItems(formatMessage, rule, ruleNode.node.attrs, api),
        scrollable: true
    };
};
module.exports["getToolbarConfig"] = $f6294d9ccc2bb84f$export$86ce8f8241c20a3;

});

parcelRegister("k2TYa", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $71687a0e4e06d813$export$a0557135812acc8e = (0, $kSwu1.defineMessages)({
    customDividerColor: {
        id: "editor-common.messages.rule.customDividerColor",
        defaultMessage: "Custom"
    },
    boldGrayDividerColor: {
        id: "editor-common.messages.rule.boldGrayDividerColor",
        defaultMessage: "Bold gray"
    },
    dividerColors: {
        id: "fabric.editor.rule.dividerColors",
        defaultMessage: "Divider colors"
    },
    defaultDividerColor: {
        id: "editor-common.messages.rule.defaultDividerColor",
        defaultMessage: "Default"
    },
    dividerOptions: {
        id: "fabric.editor.rule.dividerOptions",
        defaultMessage: "Divider options"
    },
    dividerFloatingControls: {
        id: "fabric.editor.rule.dividerFloatingControls",
        defaultMessage: "Divider floating controls"
    },
    weight: {
        id: "fabric.editor.rule.weight",
        defaultMessage: "Weight"
    },
    style: {
        id: "fabric.editor.rule.style",
        defaultMessage: "Style"
    },
    smallDivider: {
        id: "fabric.editor.rule.smallDivider",
        defaultMessage: "Small divider"
    },
    mediumDivider: {
        id: "fabric.editor.rule.mediumDivider",
        defaultMessage: "Medium divider"
    },
    largeDivider: {
        id: "fabric.editor.rule.largeDivider",
        defaultMessage: "Large divider"
    },
    solidDivider: {
        id: "fabric.editor.rule.solidDivider",
        defaultMessage: "Solid divider"
    },
    dashedDivider: {
        id: "fabric.editor.rule.dashedDivider",
        defaultMessage: "Dashed divider"
    },
    dottedDivider: {
        id: "fabric.editor.rule.dottedDivider",
        defaultMessage: "Dotted divider"
    },
    sketchDivider: {
        id: "fabric.editor.rule.sketchDivider",
        defaultMessage: "Sketch divider"
    },
    fadeDivider: {
        id: "fabric.editor.rule.fadeDivider",
        defaultMessage: "Fade divider"
    }
});
module.exports["ruleMessages"] = $71687a0e4e06d813$export$a0557135812acc8e;

});

parcelRegister("ltcoi", function(module, exports) {

var $k2TYa = parcelRequire("k2TYa");


var $351lz = parcelRequire("351lz");

const $9326958f54e2f69e$export$b943e9971a5bac74 = [
    // 1. the textColorPalette does not have the "bold gray" color. it is added separately
    // in `platform/packages/editor/editor-plugin-text-color/src/pm-plugins/utils/constants.ts`
    // by editor-plugin-text-color so we need to do the same for the dividerColorPalette
    {
        border: "var(--ds-border, #0B120E24)",
        label: (0, $k2TYa.ruleMessages).boldGrayDividerColor.defaultMessage,
        message: (0, $k2TYa.ruleMessages).boldGrayDividerColor,
        value: '#172B4D'
    },
    // 2. the dividerColorPalette replaces textColorPalette's white with the divider's default color.
    ...(0, $351lz.textColorPaletteNew).map((swatch)=>swatch.value.toUpperCase() === '#FFFFFF' ? {
            ...swatch,
            label: (0, $k2TYa.ruleMessages).defaultDividerColor.defaultMessage,
            message: undefined,
            value: "var(--ds-border, #0B120E24)"
        } : swatch)
];
module.exports["dividerColorPalette"] = $9326958f54e2f69e$export$b943e9971a5bac74;

});

parcelRegister("dW9Zh", function(module, exports) {

var $k2TYa = parcelRequire("k2TYa");


var $8VCvx = parcelRequire("8VCvx");

// from platform/packages/editor/editor-plugin-text-color/src/pm-plugins/utils/constants.t
const $128a0c66de700cb8$var$defaultTextColor = '#172B4D';
const $128a0c66de700cb8$export$80089910eb58ed9f = {
    light: {
        ...(0, $8VCvx.textPaletteTooltipMessages).light,
        [$128a0c66de700cb8$var$defaultTextColor]: (0, $k2TYa.ruleMessages).boldGrayDividerColor,
        ["var(--ds-border, #0B120E24)".toUpperCase()]: (0, $k2TYa.ruleMessages).defaultDividerColor
    },
    dark: {
        ...(0, $8VCvx.textPaletteTooltipMessages).dark,
        [$128a0c66de700cb8$var$defaultTextColor]: (0, $k2TYa.ruleMessages).boldGrayDividerColor,
        ["var(--ds-border, #0B120E24)".toUpperCase()]: (0, $k2TYa.ruleMessages).defaultDividerColor
    }
};
module.exports["dividerPaletteTooltipMessages"] = $128a0c66de700cb8$export$80089910eb58ed9f;

});

parcelRegister("8tMrA", function(module, exports) {
/* DividerOptions.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $k2TYa = parcelRequire("k2TYa");


var $2iHw5 = parcelRequire("2iHw5");


var $fxA94 = parcelRequire("fxA94");


var $fRmp0 = parcelRequire("fRmp0");


var $jdueN = parcelRequire("jdueN");


var $4o0zT = parcelRequire("4o0zT");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $cpKbG = parcelRequire("cpKbG");


var $fhJ6E = parcelRequire("fhJ6E");


var $5XCup = parcelRequire("5XCup");


var $lgHqX = parcelRequire("lgHqX");


var $kBnIR = parcelRequire("kBnIR");


var $18WiY = parcelRequire("18WiY");

const $0b15b9603935b2e5$var$styles = {
    container: "_2Y7lL48HPE _0jFU0VJgqs",
    section: "_4c065U1Y8M",
    dividerOptionsContainer: "_2mHwu82ADO _3iDTPbQ4SZ _39xV02N91d",
    dividerOptionsButtonContainer: "_4c065U1Y8M"
};
const $0b15b9603935b2e5$var$dividerOptionsButtonStyles = null;
const $0b15b9603935b2e5$var$dividerOptionsButtonStylesOld = null;
const $0b15b9603935b2e5$var$SmallWeightIcon = (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jdueN))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: iconProps.label
    });
const $0b15b9603935b2e5$var$MediumWeightIcon = (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fRmp0))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: iconProps.label
    });
const $0b15b9603935b2e5$var$LargeWeightIcon = (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fxA94))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: iconProps.label
    });
const $0b15b9603935b2e5$var$weightOptions = [
    {
        icon: $0b15b9603935b2e5$var$SmallWeightIcon,
        label: (0, $k2TYa.ruleMessages).smallDivider,
        value: 1
    },
    {
        icon: $0b15b9603935b2e5$var$MediumWeightIcon,
        label: (0, $k2TYa.ruleMessages).mediumDivider,
        value: 2
    },
    {
        icon: $0b15b9603935b2e5$var$LargeWeightIcon,
        label: (0, $k2TYa.ruleMessages).largeDivider,
        value: 3
    }
];
const $0b15b9603935b2e5$var$styleOptionRows = [
    // row 1
    [
        {
            icon: (0, $18WiY.SolidStrokeIcon),
            label: (0, $k2TYa.ruleMessages).solidDivider,
            value: 'solid'
        },
        {
            icon: (0, $fhJ6E.DashedStrokeIcon),
            label: (0, $k2TYa.ruleMessages).dashedDivider,
            value: 'dashed'
        },
        {
            icon: (0, $5XCup.DottedStrokeIcon),
            label: (0, $k2TYa.ruleMessages).dottedDivider,
            value: 'dotted'
        }
    ],
    // row 2
    [
        {
            icon: (0, $kBnIR.SketchStrokeIcon),
            label: (0, $k2TYa.ruleMessages).sketchDivider,
            value: 'sketch'
        },
        {
            icon: (0, $lgHqX.FadeStrokeIcon),
            label: (0, $k2TYa.ruleMessages).fadeDivider,
            value: 'fade'
        }
    ]
];
const $0b15b9603935b2e5$var$DividerOptionButton = ({ autoFocus: autoFocus, icon: icon, isSelected: isSelected, label: label, onKeyDownCapture: onKeyDownCapture, onSelect: onSelect, value: value })=>{
    const handleClick = (0, $cozmU.useCallback)(()=>onSelect?.(value), [
        onSelect,
        value
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        className: (0, $hekY6.default)([
            "_0bjKvD8fU6 _2O5Vij7dHp _4u2ZtJ8fU6 _20B9uKDIqT _1N4wA6N91d",
            !(0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_dividers_patch_1') && "_4bt5LAnQyn _2WAcuGnQyn"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
            autoFocus: autoFocus,
            icon: icon,
            isSelected: isSelected,
            label: label,
            onClick: handleClick,
            onKeyDownCapture: onKeyDownCapture
        })
    });
};
const $0b15b9603935b2e5$export$ff01baa6f7ec1e6f = ({ onStyleChange: onStyleChange, onWeightChange: onWeightChange, style: style, weight: weight })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { popupsMountPoint: popupsMountPoint } = (0, $cozmU.useContext)((0, $2iHw5.default));
    const containerRef = (0, $cozmU.useRef)(null);
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const buttons = Array.from(containerRef.current?.querySelectorAll('button') ?? []);
        const index = buttons.indexOf(event.currentTarget);
        if (index === -1) return;
        const columns = $0b15b9603935b2e5$var$weightOptions.length;
        const row = Math.floor(index / columns);
        const column = index % columns;
        const rows = [
            $0b15b9603935b2e5$var$weightOptions,
            ...$0b15b9603935b2e5$var$styleOptionRows
        ];
        let nextIndex;
        switch(event.key){
            case 'ArrowDown':
            case 'ArrowUp':
                {
                    const nextRow = (row + (event.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
                    nextIndex = nextRow * columns + Math.min(column, rows[nextRow].length - 1);
                    break;
                }
            case 'ArrowRight':
                nextIndex = (index + 1) % buttons.length;
                break;
            case 'ArrowLeft':
                nextIndex = (index - 1 + buttons.length) % buttons.length;
                break;
            default:
                return;
        }
        event.preventDefault();
        event.stopPropagation();
        buttons[nextIndex]?.focus();
    }, []);
    const selectedStyle = style ?? (0, $cpKbG.DEFAULT_DIVIDER_STYLE);
    const selectedWeight = weight ?? (0, $cpKbG.DEFAULT_DIVIDER_WEIGHT);
    const isPatchEnabled = (0, $4o0zT.isExperimentEnabled)('platform_editor_lovability_dividers_patch_1');
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: $0b15b9603935b2e5$var$styles.container,
        ref: isPatchEnabled ? containerRef : undefined,
        role: isPatchEnabled ? 'group' : undefined,
        "aria-label": isPatchEnabled ? formatMessage((0, $k2TYa.ruleMessages).dividerOptions) : undefined,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $0b15b9603935b2e5$var$styles.section,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        weight: "bold",
                        color: "color.text.subtle",
                        children: formatMessage((0, $k2TYa.ruleMessages).weight)
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                        xcss: $0b15b9603935b2e5$var$styles.dividerOptionsButtonContainer,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $0b15b9603935b2e5$var$styles.dividerOptionsContainer,
                            children: $0b15b9603935b2e5$var$weightOptions.map(({ icon: icon, label: label, value: value })=>/*#__PURE__*/ (0, $8aG6j.jsx)($0b15b9603935b2e5$var$DividerOptionButton, {
                                    autoFocus: // when there is no custom mount point, Dropdown sends ArrowDown
                                    // on keyboard open so autofocusing is not required.
                                    isPatchEnabled && Boolean(popupsMountPoint) && value === $0b15b9603935b2e5$var$weightOptions[0].value,
                                    icon: icon,
                                    isSelected: selectedWeight === value,
                                    label: formatMessage(label),
                                    onKeyDownCapture: isPatchEnabled ? handleKeyDown : undefined,
                                    onSelect: onWeightChange,
                                    value: value
                                }, value))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
                xcss: $0b15b9603935b2e5$var$styles.section,
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        weight: "bold",
                        color: "color.text.subtle",
                        children: formatMessage((0, $k2TYa.ruleMessages).style)
                    }),
                    $0b15b9603935b2e5$var$styleOptionRows.map((options)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                            xcss: $0b15b9603935b2e5$var$styles.dividerOptionsButtonContainer,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                xcss: $0b15b9603935b2e5$var$styles.dividerOptionsContainer,
                                children: options.map(({ icon: icon, label: label, value: value })=>/*#__PURE__*/ (0, $8aG6j.jsx)($0b15b9603935b2e5$var$DividerOptionButton, {
                                        icon: icon,
                                        isSelected: selectedStyle === value,
                                        label: formatMessage(label),
                                        onKeyDownCapture: isPatchEnabled ? handleKeyDown : undefined,
                                        onSelect: onStyleChange,
                                        value: value
                                    }, value))
                            })
                        }, options[0].value))
                ]
            })
        ]
    });
};
module.exports["DividerOptions"] = $0b15b9603935b2e5$export$ff01baa6f7ec1e6f;

});

parcelRegister("fhJ6E", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

const $ccdea181e9cc9d00$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "44",
        height: "8",
        viewBox: "0 0 44 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                clipPath: "url(#clip0_238_17349)",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M-78 4H122",
                    stroke: "var(--ds-icon-subtle, #505258)",
                    strokeWidth: "2",
                    strokeDasharray: "4 6"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "clip0_238_17349",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "44",
                        height: "8",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $ccdea181e9cc9d00$export$f8ebe9de64d90be2 = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($ccdea181e9cc9d00$var$CustomGlyph, {});
};
module.exports["DashedStrokeIcon"] = $ccdea181e9cc9d00$export$f8ebe9de64d90be2;

});

parcelRegister("5XCup", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

const $468f1ba1083ecb29$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "44",
        height: "8",
        viewBox: "0 0 44 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                clipPath: "url(#clip0_238_2909)",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M-78 4H122",
                    stroke: "var(--ds-icon, #292A2E)",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeDasharray: "0.01 6"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "clip0_238_2909",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "44",
                        height: "8",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $468f1ba1083ecb29$export$5f5f24456a5d0432 = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($468f1ba1083ecb29$var$CustomGlyph, {});
};
module.exports["DottedStrokeIcon"] = $468f1ba1083ecb29$export$5f5f24456a5d0432;

});

parcelRegister("lgHqX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

const $3a5a759948a262ee$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "79",
        height: "2",
        viewBox: "0 0 79 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                d: "M0 1C1.31667 1.06667 2.63333 1.13 3.95 1.19C15.8 1.73 27.65 2 39.5 2C51.35 2 63.2 1.73 75.05 1.19C76.3667 1.13 77.6833 1.06667 79 1C77.6833 0.933333 76.3667 0.87 75.05 0.81C63.2 0.27 51.35 0 39.5 0C27.65 0 15.8 0.27 3.95 0.81C2.63333 0.87 1.31667 0.933333 0 1Z",
                fill: "url(#paint0_linear_238_2941)"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)("linearGradient", {
                    id: "paint0_linear_238_2941",
                    x1: "0",
                    y1: "1.5",
                    x2: "79",
                    y2: "1.5",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                            stopColor: "var(--ds-icon, #292A2E)",
                            stopOpacity: 0
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                            offset: "0.274038",
                            stopColor: "var(--ds-icon, #292A2E)"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                            offset: "0.740385",
                            stopColor: "var(--ds-icon, #292A2E)"
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsx)("stop", {
                            offset: "1",
                            stopColor: "var(--ds-icon, #292A2E)",
                            stopOpacity: 0
                        })
                    ]
                })
            })
        ]
    });
const $3a5a759948a262ee$export$1b1d09d3b21445d7 = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($3a5a759948a262ee$var$CustomGlyph, {});
};
module.exports["FadeStrokeIcon"] = $3a5a759948a262ee$export$1b1d09d3b21445d7;

});

parcelRegister("kBnIR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

const $3d779168daa5a0c5$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "83",
        height: "6",
        viewBox: "0 0 83 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            d: "M0.428223 4.0112C0.428223 4.0112 6.35543 1.20063 10.4282 1.0112C15.2535 0.786762 17.5977 4.0112 22.4282 4.0112C27.2587 4.0112 29.5977 1.01007 34.4282 1.0112C38.8335 1.01222 41.0265 3.33342 45.4282 3.5112C50.7856 3.72757 53.5691 0.845277 58.9282 1.0112C63.5219 1.15342 65.8325 3.47137 70.4282 3.5112C75.215 3.55267 77.6415 1.04949 82.4282 1.0112",
            stroke: "var(--ds-icon, #292A2E)",
            strokeWidth: "2"
        })
    });
const $3d779168daa5a0c5$export$b7de24e477dce174 = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($3d779168daa5a0c5$var$CustomGlyph, {});
};
module.exports["SketchStrokeIcon"] = $3d779168daa5a0c5$export$b7de24e477dce174;

});

parcelRegister("18WiY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");

const $48416116b5fec35e$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $8aG6j.jsxs)("svg", {
        width: "44",
        height: "8",
        viewBox: "0 0 44 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("g", {
                clipPath: "url(#clip0_238_17340)",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
                    d: "M-78 4H122",
                    stroke: "var(--ds-icon, #292A2E)",
                    strokeWidth: "2"
                })
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("defs", {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("clipPath", {
                    id: "clip0_238_17340",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                        width: "44",
                        height: "8",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $48416116b5fec35e$export$e163998943e805e9 = ()=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($48416116b5fec35e$var$CustomGlyph, {});
};
module.exports["SolidStrokeIcon"] = $48416116b5fec35e$export$e163998943e805e9;

});

parcelRegister("c2kFl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0e4105444fd9a55d$export$8becdf1c29fc36cd = (0, $kSwu1.defineMessages)({
    colorPickerTitle: {
        id: "company-hub-text-color.color-picker-dropdown.picker-title",
        defaultMessage: "Text Color"
    }
});
module.exports["companyHubTextColorMessages"] = $0e4105444fd9a55d$export$8becdf1c29fc36cd;

});

parcelRegister("vZEJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $cVoAa = parcelRequire("cVoAa");


var $hHzd2 = parcelRequire("hHzd2");

const $b399db01e99f7201$export$62ed72bc21f6b8a6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropIndicator(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { appearance: t1, edge: edge, gap: gap, indent: indent, type: type } = t0;
    const appearance = t1 === undefined ? "default" : t1;
    const t2 = (0, $hHzd2.presetStrokeColors)[appearance];
    let t3;
    if ($[0] !== edge || $[1] !== gap || $[2] !== indent || $[3] !== t2 || $[4] !== type) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
            edge: edge,
            gap: gap,
            strokeColor: t2,
            type: type,
            indent: indent
        });
        $[0] = edge;
        $[1] = gap;
        $[2] = indent;
        $[3] = t2;
        $[4] = type;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : function DropIndicator({ appearance: appearance = 'default', edge: edge, gap: gap, indent: indent, type: type }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cVoAa.Line), {
        edge: edge,
        gap: gap,
        strokeColor: (0, $hHzd2.presetStrokeColors)[appearance],
        type: type,
        indent: indent
    });
};
var // This default export is intended for usage with React.lazy
// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b399db01e99f7201$export$2e2bcd8739ae039 = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["DropIndicator"] = $b399db01e99f7201$export$62ed72bc21f6b8a6;
module.exports["default"] = $b399db01e99f7201$export$2e2bcd8739ae039;

});

parcelRegister("cVoAa", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hHzd2 = parcelRequire("hHzd2");

const $06f7f86bfd55e0d2$var$edgeToOrientationMap = {
    top: 'horizontal',
    bottom: 'horizontal',
    left: 'vertical',
    right: 'vertical'
};
const $06f7f86bfd55e0d2$var$baseStyles = {
    root: "_3iDTPbvLZJ _1mT5xdWVPG _42Yu6B7dHp _1pp6NdYbGa _0KLXrul0Q1 _1Oimfu715P _0eGJOxOn88 _1nRsHk6wH8 _2KinTkl0Q1 _0OU75rKWn1 _3Ku51Iogpp _3dCYwDWVPG _2DsrY12Njc _3ScelF3U6W _1lBcDc3U6W"
};
const $06f7f86bfd55e0d2$var$orientationStyles = {
    horizontal: "_0jFU0VOn88 _3iC0zdfRAD _1OKFqYdnbC _2jTvwtWjDq",
    vertical: "_39xV02On88 _2IhTonfRAD _0Bm75GdnbC _35I30BWjDq"
};
const $06f7f86bfd55e0d2$var$edgeStyles = {
    top: "_2IhTon5Cwg _35I30BHqe5",
    right: "_4ApkO25Cwg _1D2b5MHqe5",
    bottom: "_0Bm75G5Cwg _31ReDyHqe5",
    left: "_3OE6xY5Cwg _1L3m71Hqe5"
};
const $06f7f86bfd55e0d2$var$lineStartFrom = {
    // - half the terminal bleeding out the containing element
    // - half the terminal inside the containing element (we need to position the line next to this)
    terminal: ({ indent: indent })=>`calc(var(--terminal-radius) + ${indent})`,
    // The full terminal is inside the containing element (we need to position the line next to this)
    'terminal-no-bleed': ({ indent: indent })=>`calc(var(--terminal-diameter) + ${indent})`,
    // No terminal to worry about, line should take up all the space
    'no-terminal': ({ indent: indent })=>indent
};
const $06f7f86bfd55e0d2$export$17d680238e50603e = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Line(t0) {
    const $ = (0, $bDgLe.c)(15);
    const { edge: edge, gap: t1, indent: t2, strokeColor: t3, strokeWidth: t4, type: t5 } = t0;
    const gap = t1 === undefined ? "0px" : t1;
    const indent = t2 === undefined ? "0px" : t2;
    const strokeColor = t3 === undefined ? (0, $hHzd2.presetStrokeColors).default : t3;
    const strokeWidth = t4 === undefined ? (0, $hHzd2.presetStrokeWidth) : t4;
    const type = t5 === undefined ? "terminal" : t5;
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    const t6 = `calc(-0.5 * (${gap} + var(--stroke-width)))`;
    let t7;
    if ($[0] !== indent || $[1] !== type) {
        t7 = $06f7f86bfd55e0d2$var$lineStartFrom[type]({
            indent: indent
        });
        $[0] = indent;
        $[1] = type;
        $[2] = t7;
    } else t7 = $[2];
    const t8 = type === "no-terminal" ? "none" : "block";
    let t9;
    if ($[3] !== strokeColor || $[4] !== strokeWidth || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            "--stroke-color": strokeColor,
            "--stroke-width": strokeWidth,
            "--main-axis-offset": t6,
            "--line-main-axis-start": t7,
            "--terminal-display": t8,
            "--terminal-diameter": "calc(var(--stroke-width) * 4)",
            "--terminal-radius": "calc(var(--terminal-diameter) / 2)",
            "--terminal-main-axis-start": "calc(-1 * var(--terminal-diameter))",
            "--terminal-cross-axis-offset": "calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)"
        };
        $[3] = strokeColor;
        $[4] = strokeWidth;
        $[5] = t6;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = t9;
    const t11 = $06f7f86bfd55e0d2$var$orientationStyles[orientation];
    const t12 = $06f7f86bfd55e0d2$var$edgeStyles[edge];
    let t13;
    if ($[9] !== t11 || $[10] !== t12) {
        t13 = (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            t11,
            t12
        ]);
        $[9] = t11;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    let t14;
    if ($[12] !== t10 || $[13] !== t13) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t10,
            className: t13
        });
        $[12] = t10;
        $[13] = t13;
        $[14] = t14;
    } else t14 = $[14];
    return t14;
} : function Line({ edge: edge, gap: gap = '0px', indent: indent = '0px', strokeColor: strokeColor = (0, $hHzd2.presetStrokeColors).default, strokeWidth: strokeWidth = (0, $hHzd2.presetStrokeWidth), type: type = 'terminal' }) {
    const orientation = $06f7f86bfd55e0d2$var$edgeToOrientationMap[edge];
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // ## All
            '--stroke-color': strokeColor,
            '--stroke-width': strokeWidth,
            // Shift line and terminal on the main access to account for gaps between items
            '--main-axis-offset': `calc(-0.5 * (${gap} + var(--stroke-width)))`,
            // ## Line
            // If there is a terminal, we want the line to start from next to it
            '--line-main-axis-start': $06f7f86bfd55e0d2$var$lineStartFrom[type]({
                indent: indent
            }),
            // ## Terminal
            '--terminal-display': type === 'no-terminal' ? 'none' : 'block',
            '--terminal-diameter': 'calc(var(--stroke-width) * 4)',
            '--terminal-radius': 'calc(var(--terminal-diameter) / 2)',
            // The line is positioned to account for the the terminal (--line-main-axis-start).
            // The terminal is rendered relative to the line (it's a `::before`)
            // We need to pull the terminal backwards so it sits before the start of the line
            '--terminal-main-axis-start': 'calc(-1 * var(--terminal-diameter))',
            // Pull the terminal backwards on the cross axis (eg "up" on "vertical")
            // so the center of the terminal lines up with the center of the line
            '--terminal-cross-axis-offset': 'calc(calc(var(--stroke-width) - var(--terminal-diameter)) / 2)'
        },
        className: (0, $hekY6.default)([
            $06f7f86bfd55e0d2$var$baseStyles.root,
            $06f7f86bfd55e0d2$var$orientationStyles[orientation],
            $06f7f86bfd55e0d2$var$edgeStyles[edge]
        ])
    });
}; // For React.lazy
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$06f7f86bfd55e0d2$export$2e2bcd8739ae039 = $06f7f86bfd55e0d2$export$17d680238e50603e;
module.exports["Line"] = $06f7f86bfd55e0d2$export$17d680238e50603e;

});

parcelRegister("hHzd2", function(module, exports) {
const $4ee2c7f82a7b207c$export$477fafec326bfca0 = {
    default: "var(--ds-border-selected, #1868DB)",
    warning: "var(--ds-border-warning, #E06C00)"
};
const $4ee2c7f82a7b207c$export$45db03aa04b685e3 = "var(--ds-border-width-selected, 2px)";
module.exports["presetStrokeColors"] = $4ee2c7f82a7b207c$export$477fafec326bfca0;
module.exports["presetStrokeWidth"] = $4ee2c7f82a7b207c$export$45db03aa04b685e3;

});

parcelRegister("7SeeH", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $5bb89e8909dcc61b$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $5bb89e8909dcc61b$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $5bb89e8909dcc61b$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $5bb89e8909dcc61b$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $5bb89e8909dcc61b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $5bb89e8909dcc61b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $5bb89e8909dcc61b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $5bb89e8909dcc61b$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $5bb89e8909dcc61b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $5bb89e8909dcc61b$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $5bb89e8909dcc61b$var$root = $5bb89e8909dcc61b$var$freeGlobal || $5bb89e8909dcc61b$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $5bb89e8909dcc61b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $5bb89e8909dcc61b$var$objectToString = $5bb89e8909dcc61b$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5bb89e8909dcc61b$var$nativeMax = Math.max, $5bb89e8909dcc61b$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $5bb89e8909dcc61b$var$now = function() {
    return $5bb89e8909dcc61b$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $5bb89e8909dcc61b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($5bb89e8909dcc61b$var$FUNC_ERROR_TEXT);
    wait = $5bb89e8909dcc61b$var$toNumber(wait) || 0;
    if ($5bb89e8909dcc61b$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $5bb89e8909dcc61b$var$nativeMax($5bb89e8909dcc61b$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $5bb89e8909dcc61b$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $5bb89e8909dcc61b$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($5bb89e8909dcc61b$var$now());
    }
    function debounced() {
        var time = $5bb89e8909dcc61b$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $5bb89e8909dcc61b$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5bb89e8909dcc61b$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5bb89e8909dcc61b$var$isSymbol(value) {
    return typeof value == 'symbol' || $5bb89e8909dcc61b$var$isObjectLike(value) && $5bb89e8909dcc61b$var$objectToString.call(value) == $5bb89e8909dcc61b$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $5bb89e8909dcc61b$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($5bb89e8909dcc61b$var$isSymbol(value)) return $5bb89e8909dcc61b$var$NAN;
    if ($5bb89e8909dcc61b$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $5bb89e8909dcc61b$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($5bb89e8909dcc61b$var$reTrim, '');
    var isBinary = $5bb89e8909dcc61b$var$reIsBinary.test(value);
    return isBinary || $5bb89e8909dcc61b$var$reIsOctal.test(value) ? $5bb89e8909dcc61b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $5bb89e8909dcc61b$var$reIsBadHex.test(value) ? $5bb89e8909dcc61b$var$NAN : +value;
}
module.exports = $5bb89e8909dcc61b$var$debounce;

});

parcelRegister("eO7Xs", function(module, exports) {
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $ac7be878b65c198f$var$noop() {
// No operation performed.
}
module.exports = $ac7be878b65c198f$var$noop;

});

parcelRegister("4NiRC", function(module, exports) {
'use strict';

var $UV56W = parcelRequire("UV56W");


var $1XKQW = parcelRequire("1XKQW");

var $37da5efad62bea45$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $37da5efad62bea45$var$CRHTLF = /[\n\r\t]/g, $37da5efad62bea45$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $37da5efad62bea45$var$port = /:\d+$/, $37da5efad62bea45$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $37da5efad62bea45$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $37da5efad62bea45$var$trimLeft(str) {
    return (str ? str : '').toString().replace($37da5efad62bea45$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $37da5efad62bea45$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $37da5efad62bea45$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $37da5efad62bea45$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $37da5efad62bea45$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $37da5efad62bea45$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $37da5efad62bea45$var$Url(loc, {});
        for(key in $37da5efad62bea45$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $37da5efad62bea45$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $37da5efad62bea45$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $37da5efad62bea45$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $37da5efad62bea45$var$extractProtocol(address, location) {
    address = $37da5efad62bea45$var$trimLeft(address);
    address = address.replace($37da5efad62bea45$var$CRHTLF, '');
    location = location || {};
    var match = $37da5efad62bea45$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($37da5efad62bea45$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $37da5efad62bea45$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $37da5efad62bea45$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $37da5efad62bea45$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $37da5efad62bea45$var$Url(address, location, parser) {
    address = $37da5efad62bea45$var$trimLeft(address);
    address = address.replace($37da5efad62bea45$var$CRHTLF, '');
    if (!(this instanceof $37da5efad62bea45$var$Url)) return new $37da5efad62bea45$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $37da5efad62bea45$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $1XKQW.parse;
    location = $37da5efad62bea45$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $37da5efad62bea45$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $37da5efad62bea45$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$37da5efad62bea45$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $37da5efad62bea45$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $37da5efad62bea45$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$UV56W(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $37da5efad62bea45$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $1XKQW.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$UV56W(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($37da5efad62bea45$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $37da5efad62bea45$var$rules.length; i++){
        var ins = $37da5efad62bea45$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $37da5efad62bea45$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $1XKQW.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $37da5efad62bea45$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $37da5efad62bea45$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $37da5efad62bea45$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$37da5efad62bea45$var$Url.prototype = {
    set: $37da5efad62bea45$var$set,
    toString: $37da5efad62bea45$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$37da5efad62bea45$var$Url.extractProtocol = $37da5efad62bea45$var$extractProtocol;
$37da5efad62bea45$var$Url.location = $37da5efad62bea45$var$lolcation;
$37da5efad62bea45$var$Url.trimLeft = $37da5efad62bea45$var$trimLeft;
$37da5efad62bea45$var$Url.qs = $1XKQW;
module.exports = $37da5efad62bea45$var$Url;

});

parcelRegister("UV56W", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("1XKQW", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $16dfa51e60a0cda0$export$fac44ee5b035f737, (v) => $16dfa51e60a0cda0$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $16dfa51e60a0cda0$export$98e6a39c04603d36, (v) => $16dfa51e60a0cda0$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $16dfa51e60a0cda0$export$fac44ee5b035f737;
var $16dfa51e60a0cda0$export$98e6a39c04603d36;
'use strict';
var $16dfa51e60a0cda0$var$has = Object.prototype.hasOwnProperty, $16dfa51e60a0cda0$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $16dfa51e60a0cda0$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $16dfa51e60a0cda0$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $16dfa51e60a0cda0$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $16dfa51e60a0cda0$var$decode(part[1]), value = $16dfa51e60a0cda0$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $16dfa51e60a0cda0$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($16dfa51e60a0cda0$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $16dfa51e60a0cda0$var$undef || isNaN(value))) value = '';
        key = $16dfa51e60a0cda0$var$encode(key);
        value = $16dfa51e60a0cda0$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$16dfa51e60a0cda0$export$fac44ee5b035f737 = $16dfa51e60a0cda0$var$querystringify;
$16dfa51e60a0cda0$export$98e6a39c04603d36 = $16dfa51e60a0cda0$var$querystring;

});

parcelRegister("33jh4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $1hQ0e = parcelRequire("1hQ0e");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $dX71b = parcelRequire("dX71b");


var $iCvWJ = parcelRequire("iCvWJ");


var $fPRWc = parcelRequire("fPRWc");


var $2OKnq = parcelRequire("2OKnq");


var $g0IDr = parcelRequire("g0IDr");


var $7DQ7D = parcelRequire("7DQ7D");

const $afd57266bdb0eac4$var$defaultMaxItems = 8;
const $afd57266bdb0eac4$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $afd57266bdb0eac4$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $afd57266bdb0eac4$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children;
const $afd57266bdb0eac4$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $afd57266bdb0eac4$var$noop = (0, $dpsRj.default);
const $afd57266bdb0eac4$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $afd57266bdb0eac4$var$breadcrumbStylesOld = null;
const $afd57266bdb0eac4$var$breadcrumbStylesNew = null;
const $afd57266bdb0eac4$var$navStylesNew = null;
const $afd57266bdb0eac4$var$ellipsisItemWrapperStyles = null; // items will get collapsed into ellipsis dropdown
// therefore they are no longer rendered in the DOM
// they need to be passed in to the dropdown
function $afd57266bdb0eac4$var$getItemProps(child) {
    const { text: text, href: href, onClick: onClick, target: target } = child.props;
    const wrappedOnClick = onClick ? (event)=>{
        // Collapsed dropdown items can be activated via keyboard, but the
        // original BreadcrumbsItem onClick contract is mouse-based.
        if ('button' in event) onClick(event);
    } : undefined;
    return {
        text: text ?? '',
        href: href,
        onClick: wrappedOnClick,
        target: target
    };
}
function $afd57266bdb0eac4$var$cloneBreadcrumbChild(child, index, itemCount, registerItem) {
    const isLast = index === itemCount - 1;
    const isCurrentItem = child.type === (0, $dX71b.default);
    return(// eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
        key: child.key ?? index,
        _overflowRef: registerItem(index),
        ...isLast && !isCurrentItem ? {
            'aria-current': 'page'
        } : {}
    }));
}
const $afd57266bdb0eac4$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(6);
    if ((0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh")) {
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsNew, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    let t0;
    if ($[3] !== props || $[4] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsOld, {
            ...props,
            ref: ref
        });
        $[3] = props;
        $[4] = ref;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : (props, ref)=>{
    if ((0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsNew, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsOld, {
        ...props,
        ref: ref
    });
});
const $afd57266bdb0eac4$var$InnerBreadcrumbsOld = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(25);
    const { defaultExpanded: t0, isExpanded: isExpanded, maxItems: t1, itemsBeforeCollapse: t2, itemsAfterCollapse: t3, children: t4, testId: testId, onExpand: t5, analyticsContext: analyticsContext, label: t6, ellipsisLabel: t7, size: t8 } = props;
    const defaultExpanded = t0 === undefined ? false : t0;
    const maxItems = t1 === undefined ? $afd57266bdb0eac4$var$defaultMaxItems : t1;
    const itemsBeforeCollapse = t2 === undefined ? 1 : t2;
    const itemsAfterCollapse = t3 === undefined ? 1 : t3;
    const children = t4 === undefined ? [] : t4;
    const providedExpanse = t5 === undefined ? $afd57266bdb0eac4$var$noop : t5;
    const label = t6 === undefined ? $afd57266bdb0eac4$var$defaultBreadcrumbsLabel : t6;
    const ellipsisLabel = t7 === undefined ? $afd57266bdb0eac4$var$defaultEllipsisLabel : t7;
    const size = t8 === undefined ? "medium" : t8;
    const [expanded, setExpanse] = (0, $cozmU.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const isControlled = typeof isExpanded !== "undefined";
    const isExpansionHandled = providedExpanse !== $afd57266bdb0eac4$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    let t9;
    if ($[0] !== itemsBeforeCollapse) {
        t9 = ()=>{
            if (wrapperRef.current) {
                const listItems = Array.from(wrapperRef.current.querySelectorAll("li"));
                const interactiveElements = listItems.map($afd57266bdb0eac4$var$_temp);
                const elementToFocus = interactiveElements[itemsBeforeCollapse];
                const firstInteractiveElement = interactiveElements[0];
                if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
                else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
                else wrapperRef.current.focus();
            }
            setExpansionTrigger(false);
        };
        $[0] = itemsBeforeCollapse;
        $[1] = t9;
    } else t9 = $[1];
    const focusFirstRevealedMemoized = t9;
    const t10 = !isClickedBySpace;
    let t11;
    if ($[2] !== shouldExpand || $[3] !== t10) {
        t11 = {
            isExpanded: shouldExpand,
            isDisabled: t10
        };
        $[2] = shouldExpand;
        $[3] = t10;
        $[4] = t11;
    } else t11 = $[4];
    (0, $g0IDr.useOnRevealed)(focusFirstRevealedMemoized, t11);
    let t12;
    if ($[5] !== isControlled || $[6] !== isExpansionHandled || $[7] !== providedExpanse) {
        t12 = (event, analyticsEvent)=>{
            if (!isControlled) setExpanse($afd57266bdb0eac4$var$_temp2);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $1hQ0e.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        };
        $[5] = isControlled;
        $[6] = isExpansionHandled;
        $[7] = providedExpanse;
        $[8] = t12;
    } else t12 = $[8];
    let t13;
    if ($[9] !== analyticsContext || $[10] !== t12) {
        t13 = {
            fn: t12,
            action: "expanded",
            analyticsData: analyticsContext,
            ...$afd57266bdb0eac4$var$analyticsAttributes
        };
        $[9] = analyticsContext;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    const handleExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    const childrenArray = $afd57266bdb0eac4$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === "string") return child;
        return childrenArray.length - 1 === index ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            "aria-current": "page"
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iCvWJ.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    let t14;
    if ($[12] !== ref) {
        t14 = (0, $lmzCg.default)([
            ref,
            wrapperRef
        ]);
        $[12] = ref;
        $[13] = t14;
    } else t14 = $[13];
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE _1UtDYzKGUX _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg"
        ]);
        $[14] = t15;
    } else t15 = $[14];
    let t16;
    if ($[15] !== breadcrumbsItems || $[16] !== testId) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
            "data-testid": testId,
            className: t15,
            children: breadcrumbsItems
        });
        $[15] = breadcrumbsItems;
        $[16] = testId;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== label || $[19] !== t14 || $[20] !== t16) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: t14,
            tabIndex: -1,
            children: t16
        });
        $[18] = label;
        $[19] = t14;
        $[20] = t16;
        $[21] = t17;
    } else t17 = $[21];
    let t18;
    if ($[22] !== size || $[23] !== t17) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
            value: size,
            children: t17
        });
        $[22] = size;
        $[23] = t17;
        $[24] = t18;
    } else t18 = $[24];
    return t18;
} : (props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $afd57266bdb0eac4$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $afd57266bdb0eac4$var$noop, analyticsContext: analyticsContext, label: label = $afd57266bdb0eac4$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $afd57266bdb0eac4$var$defaultEllipsisLabel, size: size = 'medium' } = props;
    const [expanded, setExpanse] = (0, $cozmU.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $afd57266bdb0eac4$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $cozmU.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($afd57266bdb0eac4$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $g0IDr.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded_0)=>!expanded_0);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $1hQ0e.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$afd57266bdb0eac4$var$analyticsAttributes
    });
    const childrenArray = $afd57266bdb0eac4$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iCvWJ.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: (0, $lmzCg.default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
                "data-testid": testId,
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _3TGfC9HnLE _1UtDYzKGUX _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg"
                ]),
                children: breadcrumbsItems
            })
        })
    });
});
const $afd57266bdb0eac4$var$InnerBreadcrumbsNew = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: t0, testId: testId, analyticsContext: analyticsContext, label: t1, ellipsisLabel: t2, size: t3 } = props;
    const children = t0 === undefined ? [] : t0;
    const label = t1 === undefined ? $afd57266bdb0eac4$var$defaultBreadcrumbsLabel : t1;
    const ellipsisLabel = t2 === undefined ? $afd57266bdb0eac4$var$defaultEllipsisLabel : t2;
    const size = t3 === undefined ? "medium" : t3;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).filter($afd57266bdb0eac4$var$_temp3);
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $7DQ7D.default)(itemCount);
    let t4;
    if ($[2] !== analyticsContext) {
        t4 = {
            fn: $afd57266bdb0eac4$var$noop,
            action: "expanded",
            analyticsData: analyticsContext,
            ...$afd57266bdb0eac4$var$analyticsAttributes
        };
        $[2] = analyticsContext;
        $[3] = t4;
    } else t4 = $[3];
    const handleOverflowExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const collapsedItems = Array.from(collapsedIndices).sort($afd57266bdb0eac4$var$_temp4).map((i)=>$afd57266bdb0eac4$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child_1, index_0)=>{
        const isCollapsed = collapsedIndices.has(index_0);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbQ4SZ _24h04i2Njc _0hPCNLDIqT _0aFT5v1qpb _3YEZNOdnbC _4xdlr0DIqT _43nrzTPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5DIqT _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2OKnq.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($afd57266bdb0eac4$var$cloneBreadcrumbChild(child_1, index_0, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child_2, index_1)=>$afd57266bdb0eac4$var$cloneBreadcrumbChild(child_2, index_1, itemCount, registerItem)) : null;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3SamIH5UaJ _2YLqiK5UaJ _4c065U1Y8M _2Y7lL41Y8M _4ouGXIdnbC"
        ]);
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _4ouGXIdnbC _0hPCNLDIqT _3TGfC9LRg7 _0aNu0LYbGa _0rIjykdnbC _43nrzTdnbC _2xTnZxdnbC _0GTcwRdnbC _0xmtkodnbC _46hvQmdnbC _03SyCPdnbC _0LQT5EdnbC"
        ]);
        $[5] = t6;
    } else t6 = $[5];
    const t7 = naturalWidthsReady ? renderedItems : measureItems;
    let t8;
    if ($[6] !== registerContainer || $[7] !== t7 || $[8] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
            "data-testid": testId,
            ref: registerContainer,
            className: t6,
            children: t7
        });
        $[6] = registerContainer;
        $[7] = t7;
        $[8] = testId;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== label || $[11] !== ref || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: t5,
            children: t8
        });
        $[10] = label;
        $[11] = ref;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== size || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
            value: size,
            children: t9
        });
        $[14] = size;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
} : (props, ref)=>{
    const { children: children = [], testId: testId, analyticsContext: analyticsContext, label: label = $afd57266bdb0eac4$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $afd57266bdb0eac4$var$defaultEllipsisLabel, size: size = 'medium', createAnalyticsEvent: _createAnalyticsEvent } = props;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child));
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $7DQ7D.default)(itemCount);
    const handleOverflowExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: $afd57266bdb0eac4$var$noop,
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$afd57266bdb0eac4$var$analyticsAttributes
    });
    const collapsedItems = Array.from(collapsedIndices).sort((a, b)=>a - b).map((i)=>$afd57266bdb0eac4$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child_1, index_0)=>{
        const isCollapsed = collapsedIndices.has(index_0);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbQ4SZ _24h04i2Njc _0hPCNLDIqT _0aFT5v1qpb _3YEZNOdnbC _4xdlr0DIqT _43nrzTPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5DIqT _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2OKnq.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($afd57266bdb0eac4$var$cloneBreadcrumbChild(child_1, index_0, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child_2, index_1)=>$afd57266bdb0eac4$var$cloneBreadcrumbChild(child_2, index_1, itemCount, registerItem)) : null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _3SamIH5UaJ _2YLqiK5UaJ _4c065U1Y8M _2Y7lL41Y8M _4ouGXIdnbC"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
                "data-testid": testId,
                ref: registerContainer,
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _4ouGXIdnbC _0hPCNLDIqT _3TGfC9LRg7 _0aNu0LYbGa _0rIjykdnbC _43nrzTdnbC _2xTnZxdnbC _0GTcwRdnbC _0xmtkodnbC _46hvQmdnbC _03SyCPdnbC _0LQT5EdnbC"
                ]),
                children: naturalWidthsReady ? renderedItems : measureItems
            })
        })
    });
});
const $afd57266bdb0eac4$var$Breadcrumbs = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(31);
    let analyticsContext;
    let children;
    let createAnalyticsEvent;
    let defaultExpanded;
    let ellipsisLabel;
    let isExpanded;
    let itemsAfterCollapse;
    let itemsBeforeCollapse;
    let label;
    let maxItems;
    let onExpand;
    let props;
    let size;
    let testId;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = children;
        $[3] = createAnalyticsEvent;
        $[4] = defaultExpanded;
        $[5] = ellipsisLabel;
        $[6] = isExpanded;
        $[7] = itemsAfterCollapse;
        $[8] = itemsBeforeCollapse;
        $[9] = label;
        $[10] = maxItems;
        $[11] = onExpand;
        $[12] = props;
        $[13] = size;
        $[14] = testId;
    } else {
        analyticsContext = $[1];
        children = $[2];
        createAnalyticsEvent = $[3];
        defaultExpanded = $[4];
        ellipsisLabel = $[5];
        isExpanded = $[6];
        itemsAfterCollapse = $[7];
        itemsBeforeCollapse = $[8];
        label = $[9];
        maxItems = $[10];
        onExpand = $[11];
        props = $[12];
        size = $[13];
        testId = $[14];
    }
    let t1;
    if ($[15] !== analyticsContext || $[16] !== children || $[17] !== createAnalyticsEvent || $[18] !== defaultExpanded || $[19] !== ellipsisLabel || $[20] !== isExpanded || $[21] !== itemsAfterCollapse || $[22] !== itemsBeforeCollapse || $[23] !== label || $[24] !== maxItems || $[25] !== onExpand || $[26] !== props || $[27] !== ref || $[28] !== size || $[29] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbs, {
            ...props,
            analyticsContext: analyticsContext,
            children: children,
            createAnalyticsEvent: createAnalyticsEvent,
            defaultExpanded: defaultExpanded,
            ellipsisLabel: ellipsisLabel,
            isExpanded: isExpanded,
            itemsAfterCollapse: itemsAfterCollapse,
            itemsBeforeCollapse: itemsBeforeCollapse,
            label: label,
            maxItems: maxItems,
            onExpand: onExpand,
            size: size,
            ref: ref,
            testId: testId
        });
        $[15] = analyticsContext;
        $[16] = children;
        $[17] = createAnalyticsEvent;
        $[18] = defaultExpanded;
        $[19] = ellipsisLabel;
        $[20] = isExpanded;
        $[21] = itemsAfterCollapse;
        $[22] = itemsBeforeCollapse;
        $[23] = label;
        $[24] = maxItems;
        $[25] = onExpand;
        $[26] = props;
        $[27] = ref;
        $[28] = size;
        $[29] = testId;
        $[30] = t1;
    } else t1 = $[30];
    return t1;
} : ({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        size: size,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $afd57266bdb0eac4$export$2e2bcd8739ae039 = $afd57266bdb0eac4$var$Breadcrumbs;
function $afd57266bdb0eac4$var$_temp(li) {
    return li.querySelector($afd57266bdb0eac4$var$interactiveElementSelector);
}
function $afd57266bdb0eac4$var$_temp2(expanded_0) {
    return !expanded_0;
}
function $afd57266bdb0eac4$var$_temp3(child) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child);
}
function $afd57266bdb0eac4$var$_temp4(a, b) {
    return a - b;
}
module.exports["default"] = $afd57266bdb0eac4$export$2e2bcd8739ae039;

});

parcelRegister("dX71b", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $kTb7m = parcelRequire("kTb7m");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $lpNn5 = parcelRequire("lpNn5");


var $jiltW = parcelRequire("jiltW");


var $8C5a3 = parcelRequire("8C5a3");

const $f5df9bde6b3e6461$var$analyticsAttributes = {
    componentName: 'breadcrumbsCurrentItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS = 2000;
const $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE = 24;
const $f5df9bde6b3e6461$var$unboundedStyles = {
    container: "_2mHwu81Y8M _0bjKvDKxmn _4c065UFQfX _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _0jFU0V9DVM _487zM87dHp",
    itemWrapper: "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _4xdlr0DIqT _0aFT5v1qpb _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
    copyButtonWrapper: "_3iDTPbccYA _1YKVNsdnbC _17c2U47dHp _3Tg68S7dHp",
    iconWrapper: "_1UtDYzWYXf",
    iconWrapperSmall: "_27VeLCey7F _2Qxi4ney7F"
};
const $f5df9bde6b3e6461$var$styles = {
    interactiveContainer: "_2mHwu81Y8M _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2sNsIgmnOE _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _1UtDYzy7kJ _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMy7kJ _0CMRbky7kJ",
    interactiveContainerMotion: "_23rrnHWE38 _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9Dy7kJ _3sFUREDdj4 _3WzCGiy7kJ",
    interactiveContainerSmall: "_2sNsIg7NXe",
    interactiveContainerLegacy: "_0jFU0V9DVM",
    interactiveContainerWithTruncation: "_4ouGXIdnbC _3YEZNO7dHp",
    iconWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    iconWrapperExternal: "_2xTnZxFQfX",
    iconWrapperExternalSmall: "_2xTnZxPgdg",
    text: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7",
    textSmall: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7",
    textWithTruncation: "_4ouGXIdnbC _1EqgXlN91d _3YEZNO7dHp"
};
const $f5df9bde6b3e6461$var$BreadcrumbsCurrentItem = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { text: text, href: href, onClick: onClick, target: target, analyticsContext: analyticsContext, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef } = t0;
    const isSmall = (0, $jiltW.useBreadcrumbsSize)() === "small";
    const t1 = onClick ?? (0, $dpsRj.default);
    let t2;
    if ($[0] !== analyticsContext || $[1] !== t1) {
        t2 = {
            fn: t1,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$f5df9bde6b3e6461$var$analyticsAttributes
        };
        $[0] = analyticsContext;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)(t2);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $cozmU.useState)(false);
    const [linkElement, setLinkElement] = (0, $cozmU.useState)(null);
    const resetTimerRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (element)=>{
            setLinkElement(element);
        };
        $[3] = t3;
    } else t3 = $[3];
    const setLinkRef = t3;
    const [, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, linkElement, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? 0 : resolvedElemBefore ? $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE : 0);
    let t4;
    if ($[4] !== href || $[5] !== onCopyLink) {
        t4 = ()=>{
            if (!navigator.clipboard) return;
            const url = new URL(href, window.location.href).href;
            navigator.clipboard.writeText(url).then(()=>{
                setCopied(true);
                onCopyLink?.();
                if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
                resetTimerRef.current = setTimeout(()=>{
                    setCopied(false);
                }, $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS);
            }, (0, $dpsRj.default));
        };
        $[4] = href;
        $[5] = onCopyLink;
        $[6] = t4;
    } else t4 = $[6];
    const handleCopy = t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>()=>{
                if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            };
        t6 = [];
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[9] !== isSmall || $[10] !== resolvedElemBefore || $[11] !== testId) {
        t7 = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId && `${testId}--icon-before`,
            className: (0, $hekY6.default)([
                $f5df9bde6b3e6461$var$styles.iconWrapper,
                $f5df9bde6b3e6461$var$unboundedStyles.iconWrapper,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $f5df9bde6b3e6461$var$styles.iconWrapperExternal,
                isSmall && $f5df9bde6b3e6461$var$styles.iconWrapperExternalSmall,
                isSmall && $f5df9bde6b3e6461$var$unboundedStyles.iconWrapperSmall
            ]),
            children: resolvedElemBefore
        });
        $[9] = isSmall;
        $[10] = resolvedElemBefore;
        $[11] = testId;
        $[12] = t7;
    } else t7 = $[12];
    const iconElement = t7;
    const t8 = isSmall && $f5df9bde6b3e6461$var$styles.textSmall;
    const t9 = !isSmall && $f5df9bde6b3e6461$var$styles.text;
    const t10 = truncationWidth && $f5df9bde6b3e6461$var$styles.textWithTruncation;
    let t11;
    if ($[13] !== t10 || $[14] !== t8 || $[15] !== t9) {
        t11 = (0, $hekY6.default)([
            t8,
            t9,
            t10
        ]);
        $[13] = t10;
        $[14] = t8;
        $[15] = t9;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== t11 || $[18] !== text) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t11,
            children: text
        });
        $[17] = t11;
        $[18] = text;
        $[19] = t12;
    } else t12 = $[19];
    const textElement = t12;
    let t13;
    if ($[20] !== handleClick || $[21] !== href || $[22] !== iconElement || $[23] !== isSmall || $[24] !== target || $[25] !== testId || $[26] !== textElement || $[27] !== truncationWidth) {
        t13 = (triggerProps)=>{
            const tooltipRef = triggerProps?.ref;
            const handleTriggerClick = (event)=>{
                triggerProps?.onClick?.(event);
                handleClick(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
                href: href,
                target: target,
                rel: target === "_blank" ? "noopener noreferrer" : undefined,
                "aria-current": "page",
                onClick: handleTriggerClick,
                onMouseOver: triggerProps?.onMouseOver,
                onMouseOut: triggerProps?.onMouseOut,
                onMouseMove: triggerProps?.onMouseMove,
                onMouseDown: triggerProps?.onMouseDown,
                onFocus: triggerProps?.onFocus,
                onBlur: triggerProps?.onBlur,
                "aria-describedby": triggerProps?.["aria-describedby"],
                testId: testId,
                ref: tooltipRef ? (0, $lmzCg.default)([
                    setLinkRef,
                    tooltipRef
                ]) : setLinkRef,
                xcss: (0, $w6R6I.cx)($f5df9bde6b3e6461$var$styles.interactiveContainer, !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $f5df9bde6b3e6461$var$styles.interactiveContainerLegacy, isSmall && $f5df9bde6b3e6461$var$styles.interactiveContainerSmall, truncationWidth != null && $f5df9bde6b3e6461$var$styles.interactiveContainerWithTruncation, $f5df9bde6b3e6461$var$styles.interactiveContainerMotion),
                style: {
                    maxWidth: truncationWidth
                },
                children: [
                    !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && iconElement,
                    textElement
                ]
            });
        };
        $[20] = handleClick;
        $[21] = href;
        $[22] = iconElement;
        $[23] = isSmall;
        $[24] = target;
        $[25] = testId;
        $[26] = textElement;
        $[27] = truncationWidth;
        $[28] = t13;
    } else t13 = $[28];
    const renderLink = t13;
    const t14 = copied ? "Copied!" : "Copy link";
    let t15;
    if ($[29] !== copied || $[30] !== handleCopy || $[31] !== testId) {
        t15 = (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $hekY6.default)([
                    $f5df9bde6b3e6461$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
                    isTooltipDisabled: true,
                    label: copied ? "Link copied" : "Copy link",
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            });
        $[29] = copied;
        $[30] = handleCopy;
        $[31] = testId;
        $[32] = t15;
    } else t15 = $[32];
    let t16;
    if ($[33] !== t14 || $[34] !== t15) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: t14,
            position: "bottom",
            hasNewContentOnTriggerClick: true,
            children: t15
        });
        $[33] = t14;
        $[34] = t15;
        $[35] = t16;
    } else t16 = $[35];
    const copyButton = t16;
    let t17;
    let t18;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.itemWrapper
        ]);
        t18 = (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.container
        ]);
        $[36] = t17;
        $[37] = t18;
    } else {
        t17 = $[36];
        t18 = $[37];
    }
    let t19;
    if ($[38] !== iconElement) {
        t19 = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && iconElement;
        $[38] = iconElement;
        $[39] = t19;
    } else t19 = $[39];
    let t20;
    if ($[40] !== onTooltipShown || $[41] !== renderLink || $[42] !== shouldShowTooltip || $[43] !== text) {
        t20 = shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderLink
        }) : renderLink();
        $[40] = onTooltipShown;
        $[41] = renderLink;
        $[42] = shouldShowTooltip;
        $[43] = text;
        $[44] = t20;
    } else t20 = $[44];
    let t21;
    if ($[45] !== copyButton || $[46] !== t19 || $[47] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            className: t18,
            children: [
                t19,
                t20,
                copyButton
            ]
        });
        $[45] = copyButton;
        $[46] = t19;
        $[47] = t20;
        $[48] = t21;
    } else t21 = $[48];
    let t22;
    if ($[49] !== _overflowRef || $[50] !== t21) {
        t22 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            ref: _overflowRef,
            "data-breadcrumbs-current-item": true,
            className: t17,
            children: t21
        });
        $[49] = _overflowRef;
        $[50] = t21;
        $[51] = t22;
    } else t22 = $[51];
    return t22;
} : ({ text: text, href: href, onClick: onClick, target: target, analyticsContext: analyticsContext, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef })=>{
    const isSmall = (0, $jiltW.useBreadcrumbsSize)() === 'small';
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClick ?? (0, $dpsRj.default),
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$f5df9bde6b3e6461$var$analyticsAttributes
    });
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $cozmU.useState)(false);
    const [linkElement, setLinkElement] = (0, $cozmU.useState)(null);
    const resetTimerRef = (0, $cozmU.useRef)(null);
    const setLinkRef = (0, $cozmU.useCallback)((element)=>{
        setLinkElement(element);
    }, []);
    const [, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, linkElement, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? 0 : resolvedElemBefore ? $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE : 0);
    const handleCopy = (0, $cozmU.useCallback)(()=>{
        if (!navigator.clipboard) return;
        const url = new URL(href, window.location.href).href;
        navigator.clipboard.writeText(url).then(()=>{
            setCopied(true);
            onCopyLink?.();
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            resetTimerRef.current = setTimeout(()=>{
                setCopied(false);
            }, $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS);
        }, (0, $dpsRj.default));
    }, [
        href,
        onCopyLink
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        }, []);
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$styles.iconWrapper,
            $f5df9bde6b3e6461$var$unboundedStyles.iconWrapper,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $f5df9bde6b3e6461$var$styles.iconWrapperExternal,
            isSmall && $f5df9bde6b3e6461$var$styles.iconWrapperExternalSmall,
            isSmall && $f5df9bde6b3e6461$var$unboundedStyles.iconWrapperSmall
        ]),
        children: resolvedElemBefore
    });
    const textElement = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            isSmall && $f5df9bde6b3e6461$var$styles.textSmall,
            !isSmall && $f5df9bde6b3e6461$var$styles.text,
            truncationWidth && $f5df9bde6b3e6461$var$styles.textWithTruncation
        ]),
        children: text
    });
    const renderLink = (triggerProps)=>{
        const tooltipRef = triggerProps?.ref;
        const handleTriggerClick = (event)=>{
            triggerProps?.onClick?.(event);
            handleClick(event);
        };
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined,
            "aria-current": "page",
            onClick: handleTriggerClick,
            onMouseOver: triggerProps?.onMouseOver,
            onMouseOut: triggerProps?.onMouseOut,
            onMouseMove: triggerProps?.onMouseMove,
            onMouseDown: triggerProps?.onMouseDown,
            onFocus: triggerProps?.onFocus,
            onBlur: triggerProps?.onBlur,
            "aria-describedby": triggerProps?.['aria-describedby'],
            testId: testId,
            ref: tooltipRef ? (0, $lmzCg.default)([
                setLinkRef,
                tooltipRef
            ]) : setLinkRef,
            xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
            (0, $w6R6I.cx)($f5df9bde6b3e6461$var$styles.interactiveContainer, !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $f5df9bde6b3e6461$var$styles.interactiveContainerLegacy, isSmall && $f5df9bde6b3e6461$var$styles.interactiveContainerSmall, truncationWidth != null && $f5df9bde6b3e6461$var$styles.interactiveContainerWithTruncation, $f5df9bde6b3e6461$var$styles.interactiveContainerMotion),
            style: {
                maxWidth: truncationWidth
            },
            children: [
                !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                textElement
            ]
        });
    };
    const copyButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: copied ? 'Copied!' : 'Copy link',
        position: "bottom",
        hasNewContentOnTriggerClick: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $hekY6.default)([
                    $f5df9bde6b3e6461$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
                    isTooltipDisabled: true,
                    label: copied ? 'Link copied' : 'Copy link',
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: _overflowRef,
        "data-breadcrumbs-current-item": true,
        className: (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.itemWrapper
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            className: (0, $hekY6.default)([
                $f5df9bde6b3e6461$var$unboundedStyles.container
            ]),
            children: [
                (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: text,
                    position: "bottom",
                    onShow: onTooltipShown,
                    children: renderLink
                }) : renderLink(),
                copyButton
            ]
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $f5df9bde6b3e6461$export$2e2bcd8739ae039 = $f5df9bde6b3e6461$var$BreadcrumbsCurrentItem;
module.exports["default"] = $f5df9bde6b3e6461$export$2e2bcd8739ae039;

});

parcelRegister("jiltW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gaEqB = parcelRequire("gaEqB");

const $b33aea80784c088a$export$c60a2bbc99661fa2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBreadcrumbsSize() {
    return (0, $cozmU.useContext)((0, $gaEqB.default));
} : function useBreadcrumbsSize() {
    return (0, $cozmU.useContext)((0, $gaEqB.default));
};
module.exports["useBreadcrumbsSize"] = $b33aea80784c088a$export$c60a2bbc99661fa2;

});

parcelRegister("gaEqB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Shared breadcrumbs size context for the primitives API and refreshed composed breadcrumbs.
 */ const $3def2b1530e0149b$var$BreadcrumbsSizeContext = /*#__PURE__*/ (0, $cozmU.createContext)('medium');
var $3def2b1530e0149b$export$2e2bcd8739ae039 = $3def2b1530e0149b$var$BreadcrumbsSizeContext;
module.exports["default"] = $3def2b1530e0149b$export$2e2bcd8739ae039;

});

parcelRegister("8C5a3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $3ef1c5a5d4771e71$var$useOverflowable = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOverflowable(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const $ = (0, $bDgLe.c)(9);
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    const [hasOverflow, setOverflow] = (0, $cozmU.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    let t0;
    let t1;
    if ($[0] !== buttonRefCurrent || $[1] !== iconWidthAllowance || $[2] !== shouldCheckWidth || $[3] !== truncationWidth) {
        t0 = ()=>{
            if (shouldCheckWidth) {
                const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
                const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
                setOverflow(shouldOverflow);
                setShowTooltip(shouldShowTooltip);
            } else {
                setOverflow(false);
                setShowTooltip(false);
            }
        };
        t1 = [
            truncationWidth,
            buttonRefCurrent,
            iconWidthAllowance,
            shouldCheckWidth
        ];
        $[0] = buttonRefCurrent;
        $[1] = iconWidthAllowance;
        $[2] = shouldCheckWidth;
        $[3] = truncationWidth;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[6] !== hasOverflow || $[7] !== showTooltip) {
        t2 = [
            hasOverflow,
            showTooltip
        ];
        $[6] = hasOverflow;
        $[7] = showTooltip;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function useOverflowable(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $cozmU.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $cozmU.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
};
var $3ef1c5a5d4771e71$export$2e2bcd8739ae039 = $3ef1c5a5d4771e71$var$useOverflowable;
module.exports["default"] = $3ef1c5a5d4771e71$export$2e2bcd8739ae039;

});

parcelRegister("iCvWJ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $dpsRj = parcelRequire("dpsRj");


var $hBYtq = parcelRequire("hBYtq");


var $jiltW = parcelRequire("jiltW");

const $839a3575228e0db7$var$noop = (0, $dpsRj.default);
const $839a3575228e0db7$var$itemWrapperStyles = null;
const $839a3575228e0db7$var$styles = {
    root: "_2sNsIgmnOE _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKYbGa _2mHwu81Y8M _0bjKvDKxmn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0KLXru66of _1UtDYzKGUX _3iDTPbccYA _0hPCNLDIqT _4xdlr0DIqT _43nrzTPgdg _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5KGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX _0CMRbky7kJ",
    rootSmall: "_2sNsIg7NXe",
    interactiveMotion: "_23rrnHo10F _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ"
};
const $839a3575228e0db7$var$EllipsisItem = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { label: label, onClick: t1, testId: testId } = t0;
    const onClick = t1 === undefined ? $839a3575228e0db7$var$noop : t1;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === "small";
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0aFT5v1qpb _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwc2ADO _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    const t3 = isSmall && $839a3575228e0db7$var$styles.rootSmall;
    let t4;
    if ($[1] !== t3) {
        t4 = (0, $w6R6I.cx)($839a3575228e0db7$var$styles.root, t3, $839a3575228e0db7$var$styles.interactiveMotion);
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== label || $[4] !== onClick || $[5] !== t4 || $[6] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                "aria-label": label,
                onClick: onClick,
                xcss: t4,
                testId: testId,
                children: "\u2026"
            })
        });
        $[3] = label;
        $[4] = onClick;
        $[5] = t4;
        $[6] = testId;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ label: label, onClick: onClick = $839a3575228e0db7$var$noop, testId: testId })=>{
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0aFT5v1qpb _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwc2ADO _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            "aria-label": label,
            onClick: onClick,
            xcss: (0, $w6R6I.cx)($839a3575228e0db7$var$styles.root, isSmall && $839a3575228e0db7$var$styles.rootSmall, $839a3575228e0db7$var$styles.interactiveMotion),
            testId: testId,
            children: "\u2026"
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $839a3575228e0db7$export$2e2bcd8739ae039 = $839a3575228e0db7$var$EllipsisItem;
module.exports["default"] = $839a3575228e0db7$export$2e2bcd8739ae039;

});

parcelRegister("fPRWc", function(module, exports) {

var $gaEqB = parcelRequire("gaEqB");

const $23e2c6453ef39b0a$export$2295e777093f3940 = (0, $gaEqB.default).Provider;
module.exports["BreadcrumbsSizeProvider"] = $23e2c6453ef39b0a$export$2295e777093f3940;

});

parcelRegister("2OKnq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $6TaGl = parcelRequire("6TaGl");

const $ec7a344b5ea2223d$var$groupWrapperStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $ec7a344b5ea2223d$var$EllipsisPopup = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EllipsisPopup(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId } = t0;
    let t1;
    if ($[0] !== label || $[1] !== onClick || $[2] !== testId) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps } = t2;
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        };
        $[0] = label;
        $[1] = onClick;
        $[2] = testId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_1EqgXlOm3a"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== collapsedItems) {
        t3 = collapsedItems.map($ec7a344b5ea2223d$var$_temp);
        $[5] = collapsedItems;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                children: t3
            })
        });
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
            trigger: t1,
            placement: "bottom-start",
            children: t4
        });
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : function EllipsisPopup({ collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps })=>{
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        },
        placement: "bottom-start",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_1EqgXlOm3a"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                children: collapsedItems.map((item, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                        href: item.href,
                        target: item.target,
                        onClick: item.onClick,
                        children: item.text
                    }, i))
            })
        })
    });
};
var $ec7a344b5ea2223d$export$2e2bcd8739ae039 = $ec7a344b5ea2223d$var$EllipsisPopup;
function $ec7a344b5ea2223d$var$_temp(item, i) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        href: item.href,
        target: item.target,
        onClick: item.onClick,
        children: item.text
    }, i);
}
module.exports["default"] = $ec7a344b5ea2223d$export$2e2bcd8739ae039;

});

parcelRegister("3vgx3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $4CEP6 = parcelRequire("4CEP6");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $jp2Q3 = parcelRequire("jp2Q3");


var $eLJVM = parcelRequire("eLJVM");


var $iv7mf = parcelRequire("iv7mf");


var $94Dr9 = parcelRequire("94Dr9");


var $ggC1G = parcelRequire("ggC1G");


var $imIsb = parcelRequire("imIsb");


var $eEek6 = parcelRequire("eEek6");

const $53393d8413cfd6c9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $53393d8413cfd6c9$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $53393d8413cfd6c9$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${crossAxis}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
            `${$53393d8413cfd6c9$var$opposites[mainAxis]}-${$53393d8413cfd6c9$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-start`,
        `${$53393d8413cfd6c9$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $53393d8413cfd6c9$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * Legacy Popper/Popup implementation (hooks run unconditionally when this component mounts).
 */ const $53393d8413cfd6c9$var$DropdownMenuLegacy = (0, $gtMdU.isReactCompilerActivePlatform)() ? function DropdownMenuLegacy(t0) {
    const $ = (0, $bDgLe.c)(63);
    const { autoFocus: t1, children: children, defaultOpen: t2, isLoading: t3, isOpen: isOpen, onOpenChange: t4, placement: t5, shouldFitContainer: t6, shouldFlip: t7, shouldRenderToParent: t8, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: t9, label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: t10, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent } = t0;
    const autoFocus = t1 === undefined ? false : t1;
    const defaultOpen = t2 === undefined ? false : t2;
    const isLoading = t3 === undefined ? false : t3;
    const onOpenChange = t4 === undefined ? (0, $dpsRj.default) : t4;
    const placement = t5 === undefined ? "bottom-start" : t5;
    const shouldFitContainer = t6 === undefined ? false : t6;
    const shouldFlip = t7 === undefined ? true : t7;
    const shouldRenderToParent = t8 === undefined ? false : t8;
    let t11;
    if ($[0] !== t9) {
        t11 = t9 === undefined ? (0, $jp2Q3.layers).modal() : t9;
        $[0] = t9;
        $[1] = t11;
    } else t11 = $[1];
    const zIndex = t11;
    const shouldPreventEscapePropagation = t10 === undefined ? false : t10;
    let t12;
    if ($[2] !== defaultOpen) {
        t12 = ()=>defaultOpen;
        $[2] = defaultOpen;
        $[3] = t12;
    } else t12 = $[3];
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, t12);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    let t13;
    if ($[4] !== placement) {
        t13 = $53393d8413cfd6c9$var$getFallbackPlacements(placement);
        $[4] = placement;
        $[5] = t13;
    } else t13 = $[5];
    const fallbackPlacements = t13;
    let t14;
    if ($[6] !== isLocalOpen || $[7] !== itemRef || $[8] !== onOpenChange || $[9] !== setLocalIsOpen) {
        t14 = (event)=>{
            const newValue = !isLocalOpen;
            const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
            if (type === "keydown") setTriggeredUsingKeyboard(true);
            else {
                if (clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
                else if (detail === 0) setTriggeredUsingKeyboard(true);
                else {
                    itemRef?.current?.focus();
                    setTriggeredUsingKeyboard(false);
                }
            }
            setLocalIsOpen(newValue);
            onOpenChange({
                isOpen: newValue,
                event: event
            });
        };
        $[6] = isLocalOpen;
        $[7] = itemRef;
        $[8] = onOpenChange;
        $[9] = setLocalIsOpen;
        $[10] = t14;
    } else t14 = $[10];
    const handleTriggerClicked = t14;
    let t15;
    if ($[11] !== itemRef || $[12] !== onOpenChange || $[13] !== returnFocusRef || $[14] !== setLocalIsOpen || $[15] !== shouldPreventEscapePropagation) {
        t15 = (event_0, currentLevel_0)=>{
            const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT));
            if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
            if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $eEek6.PREFIX)}] [aria-haspopup="true"]`)) {
                if (!currentLevel_0) return;
                const toCloseLevel = itemRef.current?.dataset["ds-Level"];
                if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
            }
            if (returnFocusRef) requestAnimationFrame(()=>{
                returnFocusRef.current?.focus();
            });
            else {
                if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === "Tab" && event_0.shiftKey || event_0.key === "Escape" || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
                    itemRef.current?.focus();
                });
                else if (triggerRef.current) {
                    const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.("[role=\"menu\"]") === null;
                    const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body;
                    if (!shouldPreventFocus) requestAnimationFrame(()=>{
                        triggerRef.current?.focus();
                    });
                }
            }
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: event_0
            });
        };
        $[11] = itemRef;
        $[12] = onOpenChange;
        $[13] = returnFocusRef;
        $[14] = setLocalIsOpen;
        $[15] = shouldPreventEscapePropagation;
        $[16] = t15;
    } else t15 = $[16];
    const handleOnClose = t15;
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    let t16;
    let t17;
    if ($[17] !== handleOnClose || $[18] !== handleTriggerClicked || $[19] !== isFocused || $[20] !== isLocalOpen) {
        t16 = ()=>{
            if (!isFocused) return 0, $dpsRj.default;
            if (isLocalOpen) return 0, $dpsRj.default;
            return (0, $cbY7C.bind)(window, {
                type: "keydown",
                listener: function openOnKeyDown(e) {
                    let isNestedTriggerButton;
                    if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $eEek6.PREFIX)}] [aria-haspopup="true"]`);
                    if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                        e.preventDefault();
                        handleTriggerClicked(e);
                    } else {
                        if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) setTriggeredUsingKeyboard(true);
                        else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) handleOnClose(e);
                    }
                }
            });
        };
        t17 = [
            isFocused,
            isLocalOpen,
            handleTriggerClicked,
            handleOnClose
        ];
        $[17] = handleOnClose;
        $[18] = handleTriggerClicked;
        $[19] = isFocused;
        $[20] = isLocalOpen;
        $[21] = t16;
        $[22] = t17;
    } else {
        t16 = $[21];
        t17 = $[22];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    if ($[23] !== shouldFitContainer || $[24] !== shouldRenderToParent || $[25] !== strategy) {
        t18 = shouldFitContainer ? {
            shouldFitContainer: shouldFitContainer,
            strategy: strategy !== "fixed" ? strategy : undefined
        } : {
            shouldRenderToParent: shouldRenderToParent,
            strategy: strategy
        };
        $[23] = shouldFitContainer;
        $[24] = shouldRenderToParent;
        $[25] = strategy;
        $[26] = t18;
    } else t18 = $[26];
    const conditionalProps = t18;
    const t19 = isLocalOpen ? id : undefined;
    const t20 = returnFocusRef === undefined;
    const t21 = shouldRenderToParent && currentLevel > 0 ? "group" : undefined;
    const t22 = testId && `${testId}--content`;
    let t23;
    if ($[27] !== bindFocus || $[28] !== handleTriggerClicked || $[29] !== interactionName || $[30] !== isLocalOpen || $[31] !== itemRef || $[32] !== label || $[33] !== testId || $[34] !== trigger) {
        t23 = (t24)=>{
            const { ref: ref, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, ...rest } = t24;
            if (typeof trigger === "function") return trigger({
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                ...bindFocus,
                ref: (0, $lmzCg.default)([
                    ref,
                    triggerRef,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: $53393d8413cfd6c9$var$_temp,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label,
                interactionName: interactionName,
                children: trigger
            });
        };
        $[27] = bindFocus;
        $[28] = handleTriggerClicked;
        $[29] = interactionName;
        $[30] = isLocalOpen;
        $[31] = itemRef;
        $[32] = label;
        $[33] = testId;
        $[34] = trigger;
        $[35] = t23;
    } else t23 = $[35];
    let t24;
    if ($[36] !== autoFocus || $[37] !== children || $[38] !== handleOnClose || $[39] !== isLoading || $[40] !== isTriggeredUsingKeyboard || $[41] !== menuLabel || $[42] !== shouldFitContainer || $[43] !== shouldRenderToParent || $[44] !== spacing || $[45] !== statusLabel || $[46] !== testId) {
        t24 = (contentProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iv7mf.default), {
                onClose: handleOnClose,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $94Dr9.default), {
                    spacing: spacing,
                    maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                    maxWidth: shouldFitContainer ? undefined : 800,
                    onClose: handleOnClose,
                    onUpdate: contentProps.update,
                    isLoading: isLoading,
                    statusLabel: statusLabel,
                    setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? contentProps.setInitialFocusRef : undefined,
                    shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                    isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                    autoFocus: autoFocus,
                    testId: testId && `${testId}--menu-wrapper`,
                    menuLabel: menuLabel,
                    children: children
                })
            });
        $[36] = autoFocus;
        $[37] = children;
        $[38] = handleOnClose;
        $[39] = isLoading;
        $[40] = isTriggeredUsingKeyboard;
        $[41] = menuLabel;
        $[42] = shouldFitContainer;
        $[43] = shouldRenderToParent;
        $[44] = spacing;
        $[45] = statusLabel;
        $[46] = testId;
        $[47] = t24;
    } else t24 = $[47];
    let t25;
    if ($[48] !== conditionalProps || $[49] !== fallbackPlacements || $[50] !== handleOnClose || $[51] !== isLocalOpen || $[52] !== placement || $[53] !== shouldFlip || $[54] !== shouldIgnoreCloseEvent || $[55] !== t19 || $[56] !== t20 || $[57] !== t21 || $[58] !== t22 || $[59] !== t23 || $[60] !== t24 || $[61] !== zIndex) {
        t25 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ggC1G.default), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
                id: t19,
                shouldFlip: shouldFlip,
                isOpen: isLocalOpen,
                shouldReturnFocus: t20,
                onClose: handleOnClose,
                zIndex: zIndex,
                placement: placement,
                role: t21,
                fallbackPlacements: fallbackPlacements,
                testId: t22,
                shouldUseCaptureOnOutsideClick: true,
                shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
                ...conditionalProps,
                shouldDisableFocusLock: true,
                trigger: t23,
                content: t24
            })
        });
        $[48] = conditionalProps;
        $[49] = fallbackPlacements;
        $[50] = handleOnClose;
        $[51] = isLocalOpen;
        $[52] = placement;
        $[53] = shouldFlip;
        $[54] = shouldIgnoreCloseEvent;
        $[55] = t19;
        $[56] = t20;
        $[57] = t21;
        $[58] = t22;
        $[59] = t23;
        $[60] = t24;
        $[61] = zIndex;
        $[62] = t25;
    } else t25 = $[62];
    return t25;
} : function DropdownMenuLegacy({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $jp2Q3.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $cozmU.useState)(false);
    const id = (0, $eEek6.default)();
    const itemRef = (0, $imIsb.default)();
    const { currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    const fallbackPlacements = (0, $cozmU.useMemo)(()=>$53393d8413cfd6c9$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $cozmU.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $cozmU.useCallback)((event_0, currentLevel_0)=>{
        const isTabLeftOrEscapeKey = $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) event_0.stopPropagation();
        if (event_0 !== null && !isTabLeftOrEscapeKey && event_0.target instanceof HTMLElement && event_0.target.closest?.(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $eEek6.PREFIX)}] [aria-haspopup="true"]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel_0) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel_0) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($53393d8413cfd6c9$var$isKeyboardEvent(event_0) && (event_0.key === 'Tab' && event_0.shiftKey || event_0.key === 'Escape' || event_0.key === (0, $fM984.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event_0?.target instanceof HTMLElement && event_0.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue_0 = false;
        setLocalIsOpen(newValue_0);
        onOpenChange({
            isOpen: newValue_0,
            event: event_0
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $cozmU.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $dpsRj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $dpsRj.default;
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $eEek6.PREFIX)}] [aria-haspopup="menu"], [id^=${(0, $eEek6.PREFIX)}] [aria-haspopup="true"]`);
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $fM984.KEY_SPACE) || e.key === (0, $fM984.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $fM984.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
   * The Popup component requires either:
   * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
   * or
   * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
   *
   * But not:
   * - shouldFitContainer={true} and shouldRenderToParent={false}
   *
   * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
   * types are satisfied.
   */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ggC1G.default), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $lmzCg.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                    ...bindFocus,
                    ref: (0, $lmzCg.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            // Legacy only. Run time passes the setter for every role; the types hide it.
            // The cast goes at the flag cleanup.
            content: (contentProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iv7mf.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $94Dr9.default), {
                        spacing: spacing,
                        maxHeight: $53393d8413cfd6c9$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: contentProps.update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? contentProps.setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ function $53393d8413cfd6c9$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        ...iconProps,
        size: "small"
    });
}
const $53393d8413cfd6c9$var$DropdownMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(19);
    const { autoFocus: t0, children: children, defaultOpen: t1, isLoading: isLoading, isOpen: isOpen, onOpenChange: t2, placement: t3, shouldFitContainer: t4, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    const autoFocus = t0 === undefined ? false : t0;
    const defaultOpen = t1 === undefined ? false : t1;
    const onOpenChange = t2 === undefined ? (0, $dpsRj.default) : t2;
    const placement = t3 === undefined ? "bottom-start" : t3;
    const shouldFitContainer = t4 === undefined ? false : t4;
    if ((0, $iDrrr.fg)("platform-dst-top-layer")) {
        let t5;
        if ($[0] !== autoFocus || $[1] !== children || $[2] !== defaultOpen || $[3] !== interactionName || $[4] !== isLoading || $[5] !== isOpen || $[6] !== label || $[7] !== menuLabel || $[8] !== onOpenChange || $[9] !== placement || $[10] !== returnFocusRef || $[11] !== shouldFitContainer || $[12] !== spacing || $[13] !== statusLabel || $[14] !== testId || $[15] !== trigger) {
            t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eLJVM.default), {
                autoFocus: autoFocus,
                children: children,
                defaultOpen: defaultOpen,
                isLoading: isLoading,
                isOpen: isOpen,
                onOpenChange: onOpenChange,
                placement: placement,
                shouldFitContainer: shouldFitContainer,
                returnFocusRef: returnFocusRef,
                spacing: spacing,
                statusLabel: statusLabel,
                testId: testId,
                trigger: trigger,
                label: label,
                interactionName: interactionName,
                menuLabel: menuLabel
            });
            $[0] = autoFocus;
            $[1] = children;
            $[2] = defaultOpen;
            $[3] = interactionName;
            $[4] = isLoading;
            $[5] = isOpen;
            $[6] = label;
            $[7] = menuLabel;
            $[8] = onOpenChange;
            $[9] = placement;
            $[10] = returnFocusRef;
            $[11] = shouldFitContainer;
            $[12] = spacing;
            $[13] = statusLabel;
            $[14] = testId;
            $[15] = trigger;
            $[16] = t5;
        } else t5 = $[16];
        return t5;
    }
    let t5;
    if ($[17] !== props) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($53393d8413cfd6c9$var$DropdownMenuLegacy, {
            ...props
        });
        $[17] = props;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
} : (props)=>{
    const { autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpen, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel } = props;
    if ((0, $iDrrr.fg)('platform-dst-top-layer')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eLJVM.default), {
        autoFocus: autoFocus,
        children: children,
        defaultOpen: defaultOpen,
        isLoading: isLoading,
        isOpen: isOpen,
        onOpenChange: onOpenChange,
        placement: placement,
        shouldFitContainer: shouldFitContainer,
        returnFocusRef: returnFocusRef,
        spacing: spacing,
        statusLabel: statusLabel,
        testId: testId,
        trigger: trigger,
        label: label,
        interactionName: interactionName,
        menuLabel: menuLabel
    });
    // Forward full public props to the legacy Popper/Popup implementation unchanged.
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props -- wrapper delegates entire DropdownMenuProps API
    return /*#__PURE__*/ (0, $8aG6j.jsx)($53393d8413cfd6c9$var$DropdownMenuLegacy, {
        ...props
    });
};
var $53393d8413cfd6c9$export$2e2bcd8739ae039 = $53393d8413cfd6c9$var$DropdownMenu;
module.exports["default"] = $53393d8413cfd6c9$export$2e2bcd8739ae039;

});

parcelRegister("5Dlqn", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a527e5bb9222c5e$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $4a527e5bb9222c5e$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $cozmU.useState)(getDefaultPropValue);
    const isControlledRef = (0, $cozmU.useRef)(isControlled);
    (0, $cozmU.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $cozmU.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("aRyr7", function(module, exports) {
$parcel$export(module.exports, "default", () => $09649a4f36a12f35$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $09649a4f36a12f35$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $cozmU.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $cozmU.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("eLJVM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $cbY7C = parcelRequire("cbY7C");


var $ad7Ou = parcelRequire("ad7Ou");


var $fM984 = parcelRequire("fM984");


var $dpsRj = parcelRequire("dpsRj");


var $5Dlqn = parcelRequire("5Dlqn");


var $aRyr7 = parcelRequire("aRyr7");


var $7sJoX = parcelRequire("7sJoX");


var $6IL1T = parcelRequire("6IL1T");


var $lfoFx = parcelRequire("lfoFx");


var $lBMxH = parcelRequire("lBMxH");


var $fb8lP = parcelRequire("fb8lP");


var $iEQb0 = parcelRequire("iEQb0");


var $juXYb = parcelRequire("juXYb");


var $kVXS3 = parcelRequire("kVXS3");


var $dV1Zs = parcelRequire("dV1Zs");


var $iNWdN = parcelRequire("iNWdN");


var $1unCm = parcelRequire("1unCm");


var $ggC1G = parcelRequire("ggC1G");

const $f516bc94b8de2bc9$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $f516bc94b8de2bc9$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
}; /**
    * Event types produced by trigger interactions.
    *
    * - `React.MouseEvent<Element>`: from the trigger's `onClick` handler
    * - `React.KeyboardEvent<Element>`: from the trigger's `onClick` when activated via keyboard
    * - `KeyboardEvent`: native event from the ArrowDown `bind(window, ...)` listener
    */ 
function $f516bc94b8de2bc9$var$getRootMenuPopover({ menu: menu }) {
    const parentMenu = menu.parentElement?.closest('[popover][role="menu"]');
    if (!parentMenu) return menu;
    return $f516bc94b8de2bc9$var$getRootMenuPopover({
        menu: parentMenu
    });
} /**
   * Loading indicator for the dropdown menu.
   */ 
const $f516bc94b8de2bc9$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingIndicator(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== statusLabel || $[2] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "menuitem",
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "small",
                label: statusLabel,
                testId: testId
            })
        });
        $[1] = statusLabel;
        $[2] = testId;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
} : function LoadingIndicator({ statusLabel: statusLabel = 'Loading', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "menuitem",
        className: (0, $hekY6.default)([
            $f516bc94b8de2bc9$var$styles.spinnerContainer
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
};
/**
 * Top-layer implementation of DropdownMenu.
 *
 * Replaces the legacy `@atlaskit/popup` + `@atlaskit/portal` + `@atlaskit/layering` pipeline
 * with the native Popover API via `@atlaskit/top-layer`.
 *
 * What is no longer needed:
 * - Portal: top layer handles stacking natively
 * - FocusLock / react-focus-lock: popover=auto provides light dismiss
 * - z-index: top layer is always above everything
 * - FocusManager (ref registration): replaced by DOM-query-based `useArrowNavigation`
 * - handle-focus.tsx: replaced by `useArrowNavigation`
 * - Layering context: top layer nesting is handled by the browser
 * - Fallback placements / Popper: CSS Anchor Positioning handles positioning
 */ function $f516bc94b8de2bc9$var$DropdownMenuTopLayer({ children: children, defaultOpen: defaultOpen = false, isLoading: isLoading, isOpen: isOpenProp, onOpenChange: onOpenChange = (0, $dpsRj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, label: label, interactionName: interactionName, menuLabel: menuLabel }) {
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpenProp, ()=>defaultOpen);
    const triggerRef = (0, $cozmU.useRef)(null);
    const popoverRef = (0, $cozmU.useRef)(null);
    const setPopoverRef = (0, $cozmU.useCallback)((element)=>{
        popoverRef.current = element; // Leave untouched menus without a busy state; retain false once it has been set.
        if (isLoading !== undefined || element?.hasAttribute('aria-busy')) element?.setAttribute('aria-busy', String(Boolean(isLoading)));
    }, [
        isLoading
    ]);
    const popoverId = (0, $1unCm.usePopoverId)();
    const topLayerPlacement = (0, $cozmU.useMemo)(()=>(0, $iEQb0.fromLegacyPlacement)({
            legacy: placement
        }), [
        placement
    ]); // DropdownMenu has no `shouldFitViewport` equivalent, so neither axis ever
    // fits and `blockSize` stays `'content'` - `MenuGroup`'s `maxHeight` owns the
    // block axis.
    (0, $dV1Zs.useAnchoredPopover)({
        anchorRef: triggerRef,
        popoverRef: popoverRef,
        placement: topLayerPlacement,
        isOpen: isLocalOpen,
        inlineSize: shouldFitContainer ? 'min-anchor' : 'content'
    }); // Close handling.
    // Focus restoration is handled natively by the Popover API:
    //   - Escape: browser restores focus to the trigger automatically
    //   - Click-outside: browser does NOT restore (correct behavior)
    //
    // The only custom focus handling needed is `returnFocusRef`: when provided,
    // we redirect focus to a different element than the trigger. We do this
    // in the onClose callback via rAF, which runs after the browser's native
    // restoration, effectively overriding it.
    const handleOnClose = (0, $cozmU.useCallback)(()=>{
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        setLocalIsOpen(false);
        onOpenChange({
            isOpen: false,
            event: null
        });
    }, [
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen
    ]); // Trigger click handling.
    const handleTriggerClicked = (0, $cozmU.useCallback)((event)=>{
        const nextIsOpen = !isLocalOpen;
        setLocalIsOpen(nextIsOpen); // Extract the native DOM event for onOpenChange
        const nativeEvent = 'nativeEvent' in event ? event.nativeEvent : event;
        onOpenChange({
            isOpen: nextIsOpen,
            event: nativeEvent
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $aRyr7.default)(); // When trigger is focused, open dropdown on ArrowDown (top-level only).
    // Per WAI-ARIA, ArrowDown opens a menu from a menubar/button trigger,
    // but inside a vertical submenu, ArrowDown navigates between siblings
    // and ArrowRight opens nested menus instead.
    (0, $cozmU.useEffect)(()=>{
        if (!isFocused || isLocalOpen) return;
         // Do not open on ArrowDown if this trigger is inside a parent menu.
        // Nested menus should only be opened via ArrowRight or Enter.
        const isNestedTrigger = Boolean(triggerRef.current?.closest('[role="menu"]'));
        return (0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $fM984.KEY_DOWN) && !isNestedTrigger) {
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked
    ]);
    const handleNestedOpen = (0, $cozmU.useCallback)(({ trigger: trigger_0 })=>{
        if (!trigger_0.matches('[aria-haspopup="menu"], [aria-haspopup="true"]')) return;
        trigger_0.click();
    }, []);
    const handleTabClose = (0, $cozmU.useCallback)(()=>{
        const currentMenu = popoverRef.current;
        if (!currentMenu) return;
         // Hiding the root native popover synchronously closes its descendant popovers and restores
        // focus to the root trigger. The browser can then perform the Tab default action from there.
        $f516bc94b8de2bc9$var$getRootMenuPopover({
            menu: currentMenu
        }).hidePopover();
    }, []);
    (0, $iNWdN.useArrowNavigation)({
        containerRef: popoverRef,
        onClose: handleTabClose,
        onNestedOpen: handleNestedOpen,
        onNestedClose: handleOnClose,
        isEnabled: isLocalOpen,
        filter: (0, $fb8lP.isAtCurrentMenuLevel)
    }); // Close on menu item click.
    // Close when a regular menuitem is clicked, but not checkboxes/radios
    // and not nested submenu triggers.
    const handleMenuClick = (0, $cozmU.useCallback)((e_0)=>{
        if (!(e_0.target instanceof Element)) return;
        const menuItem = e_0.target.closest?.('[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]');
        if (!menuItem) return;
        const isCheckboxOrRadio = menuItem.getAttribute('role') === 'menuitemcheckbox' || menuItem.getAttribute('role') === 'menuitemradio'; // Only menu/true popup values identify submenus.
        // The nested dropdown will handle its own open/close.
        const isNestedTrigger_0 = menuItem.matches('[aria-haspopup="menu"], [aria-haspopup="true"]');
        if (!isCheckboxOrRadio && !isNestedTrigger_0) {
            setLocalIsOpen(false);
            onOpenChange({
                isOpen: false,
                event: e_0.nativeEvent
            });
        }
    }, [
        setLocalIsOpen,
        onOpenChange
    ]);
    const ariaAttributes = (0, $lBMxH.getAriaForTrigger)({
        role: 'menu',
        isOpen: isLocalOpen,
        popoverId: popoverId
    }); /**
       * Custom trigger consumers historically receive a callback ref,
       * and their code assumes it is one.
       * Using this wrapper for compatibility...
       */ 
    const setTriggerRef = (0, $cozmU.useCallback)((node)=>{
        triggerRef.current = node;
    }, []);
    const renderTrigger = ()=>{
        if (typeof trigger === 'function') return trigger({
            ...ariaAttributes,
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            triggerRef: setTriggerRef,
            isSelected: isLocalOpen,
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`
        });
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onFocus: bindFocus.onFocus,
            onBlur: bindFocus.onBlur,
            ref: setTriggerRef,
            ...ariaAttributes,
            isSelected: isLocalOpen,
            iconAfter: (iconProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    ...iconProps,
                    size: "small"
                }),
            onClick: handleTriggerClicked,
            testId: testId && `${testId}--trigger`,
            "aria-label": label,
            interactionName: interactionName,
            children: trigger
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $ggC1G.default), {
        children: [
            renderTrigger(),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kVXS3.Popover), {
                ref: setPopoverRef,
                id: popoverId,
                role: "menu",
                label: menuLabel ?? label ?? (typeof trigger === 'string' ? trigger : 'Menu'),
                isOpen: isLocalOpen,
                onClose: handleOnClose,
                shouldAnimate: true,
                placement: topLayerPlacement,
                testId: testId && `${testId}--content`,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $juXYb.PopoverSurface), {
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
                        maxHeight: $f516bc94b8de2bc9$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClick: handleMenuClick,
                        spacing: spacing,
                        testId: testId && `${testId}--menu-wrapper--menu-group`,
                        children: isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($f516bc94b8de2bc9$var$LoadingIndicator, {
                            statusLabel: statusLabel,
                            testId: testId && `${testId}--menu-wrapper--loading-indicator`
                        }) : children
                    })
                })
            })
        ]
    });
}
var $f516bc94b8de2bc9$export$2e2bcd8739ae039 = $f516bc94b8de2bc9$var$DropdownMenuTopLayer;
module.exports["default"] = $f516bc94b8de2bc9$export$2e2bcd8739ae039;

});

parcelRegister("fb8lP", function(module, exports) {
const $6bfdddcadf7826ef$var$menuSelector = '[role="menu"]';
/**
 * Walks up from `element` and returns `true` when it reaches `container` before any other
 * `role="menu"` element.
 */ function $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu({ element: element, container: container }) {
    if (!element) return false;
    if (element === container) return true;
    if (element.getAttribute('role') === 'menu') return false;
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu({
        element: element.parentElement,
        container: container
    });
}
function $6bfdddcadf7826ef$export$f1bba0ef464d60af(element, container) {
    const closestMenu = element.closest($6bfdddcadf7826ef$var$menuSelector);
    // Pattern 1: the element belongs to this level if its closest menu is the container.
    if (container.getAttribute('role') === 'menu') return closestMenu === container;
    // Pattern 2: the container is a wrapper without `role="menu"`. An element in no menu belongs to
    // this level.
    if (closestMenu === null) return true;
    // Start from the parent, so the walk does not stop at `closestMenu` itself.
    return $6bfdddcadf7826ef$var$reachesContainerWithoutNestedMenu({
        element: closestMenu.parentElement,
        container: container
    });
}
module.exports["isAtCurrentMenuLevel"] = $6bfdddcadf7826ef$export$f1bba0ef464d60af;

});

parcelRegister("iNWdN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $fM984 = parcelRequire("fM984");


var $3hJ5V = parcelRequire("3hJ5V");


var $7MWxP = parcelRequire("7MWxP");


var $jzRXW = parcelRequire("jzRXW");

const $341d868aa0ec42f2$var$menuSelector = '[role="menu"]';
/**
 * Whether the focused element belongs to this menu level, so the hook acts on the key. A nested
 * menu handles its own keys.
 */ function $341d868aa0ec42f2$var$isFocusedElementAtThisLevel({ focusedElement: focusedElement, container: container, filter: filter }) {
    if (!(focusedElement instanceof HTMLElement)) return true;
    if (filter) return filter(focusedElement, container);
    if (container.getAttribute('role') !== 'menu') return true;
    return focusedElement.closest($341d868aa0ec42f2$var$menuSelector) === container;
}
const $341d868aa0ec42f2$export$23dfbae28e0cc453 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useArrowNavigation(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: t1, filter: filter } = t0;
    const isEnabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== containerRef || $[1] !== filter || $[2] !== onClose || $[3] !== onNestedClose || $[4] !== onNestedOpen) {
        t2 = (event)=>{
            const container = containerRef.current;
            if (!container) return;
            const focusedElement = container.ownerDocument.activeElement;
            if (!$341d868aa0ec42f2$var$isFocusedElementAtThisLevel({
                focusedElement: focusedElement,
                container: container,
                filter: filter
            })) return;
            if (event.key === (0, $fM984.KEY_DOWN)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "forwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_UP)) {
                event.preventDefault();
                (0, $jzRXW.getNextFocusable)({
                    container: container,
                    direction: "backwards",
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_HOME)) {
                event.preventDefault();
                (0, $3hJ5V.getFirstFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_END)) {
                event.preventDefault();
                (0, $7MWxP.getLastFocusable)({
                    container: container,
                    filter: filter
                })?.focus();
                return;
            }
            if (event.key === (0, $fM984.KEY_TAB)) {
                onClose();
                return;
            }
            if (event.key === (0, $fM984.KEY_RIGHT)) {
                if (onNestedOpen && focusedElement instanceof HTMLElement && focusedElement.hasAttribute("aria-haspopup")) {
                    event.preventDefault();
                    onNestedOpen({
                        trigger: focusedElement
                    });
                }
                return;
            }
            if (event.key === (0, $fM984.KEY_LEFT)) {
                if (onNestedClose) {
                    const isNested = Boolean(container.parentElement?.closest($341d868aa0ec42f2$var$menuSelector));
                    if (isNested) {
                        event.preventDefault();
                        onNestedClose();
                    }
                }
                return;
            }
        };
        $[0] = containerRef;
        $[1] = filter;
        $[2] = onClose;
        $[3] = onNestedClose;
        $[4] = onNestedOpen;
        $[5] = t2;
    } else t2 = $[5];
    const handleKeyDown = t2;
    let t3;
    let t4;
    if ($[6] !== containerRef || $[7] !== handleKeyDown || $[8] !== isEnabled) {
        t3 = ()=>{
            const container_0 = containerRef.current;
            if (!container_0 || !isEnabled) return;
            return (0, $cbY7C.bind)(container_0, {
                type: "keydown",
                listener: handleKeyDown
            });
        };
        t4 = [
            containerRef,
            handleKeyDown,
            isEnabled
        ];
        $[6] = containerRef;
        $[7] = handleKeyDown;
        $[8] = isEnabled;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
} : function useArrowNavigation({ containerRef: containerRef, onClose: onClose, onNestedOpen: onNestedOpen, onNestedClose: onNestedClose, isEnabled: isEnabled = true, filter: filter }) {
    const handleKeyDown = (0, $cozmU.useCallback)((event)=>{
        const container = containerRef.current;
        if (!container) return;
        const focusedElement = container.ownerDocument.activeElement;
        if (!$341d868aa0ec42f2$var$isFocusedElementAtThisLevel({
            focusedElement: focusedElement,
            container: container,
            filter: filter
        })) return;
        if (event.key === (0, $fM984.KEY_DOWN)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'forwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_UP)) {
            // Prevent page scroll while navigating menu items.
            event.preventDefault();
            (0, $jzRXW.getNextFocusable)({
                container: container,
                direction: 'backwards',
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_HOME)) {
            // Prevent browser default (e.g. scrolling to top of page).
            event.preventDefault();
            (0, $3hJ5V.getFirstFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_END)) {
            // Prevent browser default (e.g. scrolling to bottom of page).
            event.preventDefault();
            (0, $7MWxP.getLastFocusable)({
                container: container,
                filter: filter
            })?.focus();
            return;
        }
        if (event.key === (0, $fM984.KEY_TAB)) {
            onClose();
            return;
        }
        // Nested menus (WAI-ARIA menu pattern): ArrowRight on an item with `aria-haspopup` opens
        // its submenu.
        if (event.key === (0, $fM984.KEY_RIGHT)) {
            if (onNestedOpen && focusedElement instanceof HTMLElement && focusedElement.hasAttribute('aria-haspopup')) {
                event.preventDefault();
                onNestedOpen({
                    trigger: focusedElement
                });
            }
            return;
        }
        // ArrowLeft closes this menu only if it is a submenu.
        if (event.key === (0, $fM984.KEY_LEFT)) {
            if (onNestedClose) {
                // Start from the parent, so `closest()` does not match the container itself.
                const isNested = Boolean(container.parentElement?.closest($341d868aa0ec42f2$var$menuSelector));
                if (isNested) {
                    event.preventDefault();
                    onNestedClose();
                }
            }
            return;
        }
    }, [
        containerRef,
        onClose,
        onNestedOpen,
        onNestedClose,
        filter
    ]);
    (0, $cozmU.useEffect)(()=>{
        const container_0 = containerRef.current;
        if (!container_0 || !isEnabled) return;
        return (0, $cbY7C.bind)(container_0, {
            type: 'keydown',
            listener: handleKeyDown
        });
    }, [
        containerRef,
        handleKeyDown,
        isEnabled
    ]);
};
module.exports["useArrowNavigation"] = $341d868aa0ec42f2$export$23dfbae28e0cc453;

});

parcelRegister("ggC1G", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lOWpM = parcelRequire("lOWpM");

/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $885bea270958798f$var$SelectionStore = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {};
        $[0] = t0;
    } else t0 = $[0];
    const store = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>store.current[group_2] || {}
        };
        $[1] = t1;
    } else t1 = $[1];
    const context = t1;
    let t2;
    if ($[2] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOWpM.SelectionStoreContext).Provider, {
            value: context,
            children: children
        });
        $[2] = children;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : (props)=>{
    const { children: children } = props;
    const store = (0, $cozmU.useRef)({});
    const context = (0, $cozmU.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group_0, id_0)=>{
                if (!store.current[group_0]) return undefined;
                return store.current[group_0][id_0];
            },
            setGroupState: (group_1, value_0)=>{
                store.current[group_1] = value_0;
            },
            getGroupState: (group_2)=>{
                return store.current[group_2] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lOWpM.SelectionStoreContext).Provider, {
        value: context,
        children: children
    });
};
var $885bea270958798f$export$2e2bcd8739ae039 = $885bea270958798f$var$SelectionStore;
module.exports["default"] = $885bea270958798f$export$2e2bcd8739ae039;

});

parcelRegister("lOWpM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $db8a5bf4c7b230f3$export$756f795847463ebd = /*#__PURE__*/ (0, $cozmU.createContext)({
    setItemState: (0, $dpsRj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $dpsRj.default),
    getGroupState: ()=>({})
});
module.exports["SelectionStoreContext"] = $db8a5bf4c7b230f3$export$756f795847463ebd;

});

parcelRegister("iv7mf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $4CEP6 = parcelRequire("4CEP6");


var $2Bag3 = parcelRequire("2Bag3");


var $6nHMa = parcelRequire("6nHMa");

/**
 * Focus manager logic.
 */ const $f5a399746fdfd30b$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $cozmU.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $cozmU.useState)(0);
    const registerMode = (0, $cozmU.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $cozmU.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $4CEP6.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $cozmU.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $cozmU.useEffect)(()=>(0, $cbY7C.bind)(window, {
            type: 'keydown',
            listener: (0, $2Bag3.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6nHMa.FocusManagerContext).Provider, {
        value: contextValue,
        children: children
    });
};
var $f5a399746fdfd30b$export$2e2bcd8739ae039 = $f5a399746fdfd30b$var$FocusManager;
module.exports["default"] = $f5a399746fdfd30b$export$2e2bcd8739ae039;

});

parcelRegister("2Bag3", function(module, exports) {
$parcel$export(module.exports, "default", () => $b55ec80e24a5f4b9$export$2e2bcd8739ae039);

var $fM984 = parcelRequire("fM984");


var $iDrrr = parcelRequire("iDrrr");


var $eEek6 = parcelRequire("eEek6");

const $b55ec80e24a5f4b9$var$actionMap = {
    [(0, $fM984.KEY_DOWN)]: 'next',
    [(0, $fM984.KEY_UP)]: 'prev',
    [(0, $fM984.KEY_HOME)]: 'first',
    [(0, $fM984.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b55ec80e24a5f4b9$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $b55ec80e24a5f4b9$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $iDrrr.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $eEek6.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $fM984.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $fM984.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $fM984.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $b55ec80e24a5f4b9$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $b55ec80e24a5f4b9$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $b55ec80e24a5f4b9$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("eEek6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $6JrSr = parcelRequire("6JrSr");

const $bcf8a6c8e532b2af$export$8a682ae47622dbb9 = 'ds--dropdown--';
/**
 * useGeneratedId generates a random string which remains constant across
 * renders when called without any parameter.
 */ const $bcf8a6c8e532b2af$var$useGeneratedId = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
} : function useGeneratedId() {
    const id = (0, $6JrSr.useId)();
    return `${$bcf8a6c8e532b2af$export$8a682ae47622dbb9}${id}`;
};
var $bcf8a6c8e532b2af$export$2e2bcd8739ae039 = $bcf8a6c8e532b2af$var$useGeneratedId;
module.exports["PREFIX"] = $bcf8a6c8e532b2af$export$8a682ae47622dbb9;
module.exports["default"] = $bcf8a6c8e532b2af$export$2e2bcd8739ae039;

});

parcelRegister("6nHMa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dpsRj = parcelRequire("dpsRj");

const $f526bd1b7b92569a$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $cozmU.createContext)({
    menuItemRefs: [],
    registerRef: (0, $dpsRj.default)
});
module.exports["FocusManagerContext"] = $f526bd1b7b92569a$export$f18c1d4fc7326096;

});

parcelRegister("94Dr9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6IL1T = parcelRequire("6IL1T");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $gsYt4 = parcelRequire("gsYt4");


var $2zAfh = parcelRequire("2zAfh");


var $6nHMa = parcelRequire("6nHMa");

const $9c09f45d8ede8a3c$var$styles = {
    spinnerContainer: "_3iDTPbQ4SZ _4ouGXIoaux _37wbyuDIqT _46hvQmkG2W _03SyCPkG2W _0xmtkokG2W _0LQT5EkG2W"
};
const $9c09f45d8ede8a3c$var$LoadingIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { statusLabel: t1, testId: testId } = t0;
    const statusLabel = t1 === undefined ? "Loading" : t1;
    let t2;
    if ($[0] !== statusLabel || $[1] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
            role: "menuitem",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
                size: "small",
                label: statusLabel,
                testId: testId
            })
        });
        $[0] = statusLabel;
        $[1] = testId;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $9c09f45d8ede8a3c$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lfoFx.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    }); /**
          *
          * MenuWrapper wraps all the menu items.
          * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
          * if a CheckboxItem or RadioItem is clicked.
          * It also sets focus to the first menu item when opened.
          */ 
const $9c09f45d8ede8a3c$var$MenuWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel } = t0;
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    let t1;
    if ($[0] !== menuItemRefs || $[1] !== onClose) {
        t1 = (e)=>{
            const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
                const { current: menuItem } = menuItemRef;
                if (!menuItem) return false;
                const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
                return menuItem.contains(e.target) && !isCheckboxOrRadio;
            });
            if (isTargetMenuItemOrDescendant && onClose) onClose(e);
        };
        $[0] = menuItemRefs;
        $[1] = onClose;
        $[2] = t1;
    } else t1 = $[2];
    const closeOnMenuItemClick = t1;
    let t2;
    if ($[3] !== onUpdate) {
        t2 = ()=>{
            onUpdate();
        };
        $[3] = onUpdate;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== isLoading || $[6] !== onUpdate) {
        t3 = [
            isLoading,
            onUpdate
        ];
        $[5] = isLoading;
        $[6] = onUpdate;
        $[7] = t3;
    } else t3 = $[7];
    (0, $cozmU.useLayoutEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== autoFocus || $[9] !== isTriggeredUsingKeyboard || $[10] !== menuItemRefs || $[11] !== setInitialFocusRef || $[12] !== shouldRenderToParent) {
        t4 = ()=>{
            const firstFocusableRef = menuItemRefs.map($9c09f45d8ede8a3c$var$_temp).find($9c09f45d8ede8a3c$var$_temp2) ?? null;
            if (((0, $iDrrr.fg)("platform_dst_menu_item_focus") || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
            setInitialFocusRef?.(firstFocusableRef);
        };
        t5 = [
            menuItemRefs,
            setInitialFocusRef,
            autoFocus,
            shouldRenderToParent,
            isTriggeredUsingKeyboard
        ];
        $[8] = autoFocus;
        $[9] = isTriggeredUsingKeyboard;
        $[10] = menuItemRefs;
        $[11] = setInitialFocusRef;
        $[12] = shouldRenderToParent;
        $[13] = t4;
        $[14] = t5;
    } else {
        t4 = $[13];
        t5 = $[14];
    }
    (0, $cozmU.useEffect)(t4, t5);
    const t6 = testId && `${testId}--menu-group`;
    let t7;
    if ($[15] !== children || $[16] !== isLoading || $[17] !== statusLabel || $[18] !== testId) {
        t7 = isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($9c09f45d8ede8a3c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children;
        $[15] = children;
        $[16] = isLoading;
        $[17] = statusLabel;
        $[18] = testId;
        $[19] = t7;
    } else t7 = $[19];
    let t8;
    if ($[20] !== closeOnMenuItemClick || $[21] !== isLoading || $[22] !== maxHeight || $[23] !== maxWidth || $[24] !== menuLabel || $[25] !== spacing || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
            isLoading: isLoading,
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            onClick: closeOnMenuItemClick,
            role: "menu",
            spacing: spacing,
            testId: t6,
            menuLabel: menuLabel,
            children: t7
        });
        $[20] = closeOnMenuItemClick;
        $[21] = isLoading;
        $[22] = maxHeight;
        $[23] = maxWidth;
        $[24] = menuLabel;
        $[25] = spacing;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $gsYt4.default)(menuItem) || (0, $2zAfh.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        }); // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $cozmU.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $cozmU.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $iDrrr.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6IL1T.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $8aG6j.jsx)($9c09f45d8ede8a3c$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $9c09f45d8ede8a3c$export$2e2bcd8739ae039 = $9c09f45d8ede8a3c$var$MenuWrapper;
function $9c09f45d8ede8a3c$var$_temp(t0) {
    const { current: current } = t0;
    return current;
}
function $9c09f45d8ede8a3c$var$_temp2(el) {
    return !!el && !el.hasAttribute("disabled");
}
module.exports["default"] = $9c09f45d8ede8a3c$export$2e2bcd8739ae039;

});

parcelRegister("gsYt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $363009d7887a30e5$export$2e2bcd8739ae039);
function $363009d7887a30e5$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("2zAfh", function(module, exports) {
$parcel$export(module.exports, "default", () => $364a1a3a4c98073c$export$2e2bcd8739ae039);
function $364a1a3a4c98073c$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("imIsb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $6nHMa = parcelRequire("6nHMa");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
const $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useRegisterItemWithFocusManager(t0) {
    const $ = (0, $bDgLe.c)(4);
    const hasPopup = t0 === undefined ? false : t0;
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== hasPopup || $[1] !== registerRef) {
        t1 = ()=>{
            if (hasPopup && (0, $iDrrr.fg)("select-avoid-duplicated-registered-ref")) return;
            registerRef(itemRef);
        };
        t2 = [
            registerRef,
            hasPopup
        ];
        $[0] = hasPopup;
        $[1] = registerRef;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return itemRef;
} : function useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $cozmU.useContext)((0, $6nHMa.FocusManagerContext));
    const itemRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (hasPopup && (0, $iDrrr.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
};
var $ab7ed338ade85dc7$export$2e2bcd8739ae039 = $ab7ed338ade85dc7$var$useRegisterItemWithFocusManager;
module.exports["default"] = $ab7ed338ade85dc7$export$2e2bcd8739ae039;

});

parcelRegister("is1T6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $lmzCg = parcelRequire("lmzCg");


var $9d7Pd = parcelRequire("9d7Pd");


var $kD4eB = parcelRequire("kD4eB");


var $8oBbn = parcelRequire("8oBbn");


var $iDrrr = parcelRequire("iDrrr");


var $imIsb = parcelRequire("imIsb");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $94fa0e4252415620$var$DropdownMenuItem = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // Nested submenu triggers register with the focus manager inside DropdownMenu.
    // Dialog triggers must register here so arrow navigation can reach them.
    const isNestedTrigger = !!rest['aria-haspopup'] && rest['aria-haspopup'] !== 'dialog';
    const itemRef = (0, $imIsb.default)(isNestedTrigger);
    const handleItemClick = (0, $cozmU.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kD4eB.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8oBbn.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9d7Pd.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $lmzCg.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        ...isNestedTrigger && (0, $iDrrr.fg)('platform_dst_dropdown_nested_trigger_aria_current') ? {
            'aria-current': undefined
        } : {},
        children: children
    });
});
var $94fa0e4252415620$export$2e2bcd8739ae039 = $94fa0e4252415620$var$DropdownMenuItem;
module.exports["default"] = $94fa0e4252415620$export$2e2bcd8739ae039;

});

parcelRegister("9erVg", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6JrSr = parcelRequire("6JrSr");


var $8FgJC = parcelRequire("8FgJC");


var $eiIYc = parcelRequire("eiIYc");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $e544827bc46159a5$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(23);
    let children;
    let hasSeparator;
    let id;
    let isList;
    let isScrollable;
    let rest;
    let testId;
    let title;
    if ($[0] !== t0) {
        ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = hasSeparator;
        $[3] = id;
        $[4] = isList;
        $[5] = isScrollable;
        $[6] = rest;
        $[7] = testId;
        $[8] = title;
    } else {
        children = $[1];
        hasSeparator = $[2];
        id = $[3];
        isList = $[4];
        isScrollable = $[5];
        rest = $[6];
        testId = $[7];
        title = $[8];
    }
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    const t1 = title ? titleId : undefined;
    let t2;
    if ($[9] !== title || $[10] !== titleId) {
        t2 = title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eiIYc.default), {
            id: titleId,
            title: title
        });
        $[9] = title;
        $[10] = titleId;
        $[11] = t2;
    } else t2 = $[11];
    let t3;
    if ($[12] !== children || $[13] !== hasSeparator || $[14] !== id || $[15] !== isList || $[16] !== isScrollable || $[17] !== ref || $[18] !== rest || $[19] !== t1 || $[20] !== t2 || $[21] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: t1,
            ...rest,
            children: [
                t2,
                children
            ]
        });
        $[12] = children;
        $[13] = hasSeparator;
        $[14] = id;
        $[15] = isList;
        $[16] = isScrollable;
        $[17] = ref;
        $[18] = rest;
        $[19] = t1;
        $[20] = t2;
        $[21] = testId;
        $[22] = t3;
    } else t3 = $[22];
    return t3;
} : ({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $6JrSr.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8FgJC.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $eiIYc.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $e544827bc46159a5$export$2e2bcd8739ae039 = $e544827bc46159a5$var$DropdownMenuItemGroup;
module.exports["default"] = $e544827bc46159a5$export$2e2bcd8739ae039;

});

parcelRegister("eiIYc", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $c2ad6d0f9690e679$var$styles = {
    heading: "_2sNsIgd8bj _4c065UPgdg _2Y7lL45zaO _1UtDYzZpcK"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups.
 *
 * Pre-existing a11y note: uses `role="menuitem"` with `aria-hidden="true"`.
 * WAI-ARIA APG recommends `role="presentation"` for non-interactive group
 * headings, with the group linked via `aria-labelledby`. Out of scope for
 * the top-layer migration — this is legacy behavior.
 *
 * @internal
 */ const $c2ad6d0f9690e679$var$GroupTitle = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { id: id, title: title } = t0;
    let t1;
    if ($[0] !== id || $[1] !== title) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            "data-ds--menu--heading-item": true,
            role: "menuitem",
            id: id,
            "aria-hidden": "true",
            xcss: $c2ad6d0f9690e679$var$styles.heading,
            children: title
        });
        $[0] = id;
        $[1] = title;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ id: id, title: title })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $c2ad6d0f9690e679$var$styles.heading,
        children: title
    });
var $c2ad6d0f9690e679$export$2e2bcd8739ae039 = $c2ad6d0f9690e679$var$GroupTitle;
module.exports["default"] = $c2ad6d0f9690e679$export$2e2bcd8739ae039;

});

parcelRegister("g0IDr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6iJ3v = parcelRequire("6iJ3v");

const $f40788a777bec402$export$e9c4922b2ecf808a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOnRevealed(callback, t0) {
    const $ = (0, $bDgLe.c)(6);
    const { isExpanded: isExpanded, isDisabled: isDisabled } = t0;
    const prevExtended = (0, $6iJ3v.default)(isExpanded);
    let t1;
    let t2;
    if ($[0] !== callback || $[1] !== isDisabled || $[2] !== isExpanded || $[3] !== prevExtended) {
        t1 = ()=>{
            const hasBeenRevealed = !prevExtended && isExpanded;
            if (!isDisabled && hasBeenRevealed) callback();
        };
        t2 = [
            isExpanded,
            isDisabled,
            callback,
            prevExtended
        ];
        $[0] = callback;
        $[1] = isDisabled;
        $[2] = isExpanded;
        $[3] = prevExtended;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useOnRevealed(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $6iJ3v.default)(isExpanded);
    (0, $cozmU.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
};
module.exports["useOnRevealed"] = $f40788a777bec402$export$e9c4922b2ecf808a;

});

parcelRegister("7DQ7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $84c50e72db23da4d$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

// The ellipsis trigger is a compact IconButton (24px) plus the trailing separator (24px).
const $84c50e72db23da4d$var$ELLIPSIS_WIDTH_ESTIMATE = 48;
// Measurements need layout timing in the browser, but should be a no-op for SSR.
const $84c50e72db23da4d$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
function $84c50e72db23da4d$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const v of a){
        if (!b.has(v)) return false;
    }
    return true;
}
function $84c50e72db23da4d$var$getMiddleOutCollapseOrder(itemCount) {
    const lastIndex = itemCount - 1;
    const middleIndex = Math.floor((itemCount - 1) / 2);
    const collapseOrder = [];
    if (middleIndex > 0 && middleIndex < lastIndex) collapseOrder.push(middleIndex);
    for(let distance = 1; distance < itemCount; distance++){
        const leftIndex = middleIndex - distance;
        const rightIndex = middleIndex + distance;
        if (leftIndex > 0) collapseOrder.push(leftIndex);
        if (rightIndex < lastIndex) collapseOrder.push(rightIndex);
    }
    return collapseOrder;
}
function $84c50e72db23da4d$export$2e2bcd8739ae039(itemCount) {
    const itemRefs = (0, $cozmU.useRef)([]);
    const containerRef = (0, $cozmU.useRef)(null);
    const naturalWidths = (0, $cozmU.useRef)([]);
    const naturalWidthsReady = (0, $cozmU.useRef)(false);
    const [naturalWidthsReadyState, setNaturalWidthsReadyState] = (0, $cozmU.useState)(false);
    const [collapsedIndices, setCollapsedIndices] = (0, $cozmU.useState)(new Set());
    // Intentionally runs after each render until refs have committed and natural widths are measured.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $84c50e72db23da4d$var$useLayoutEffect(()=>{
        if (naturalWidthsReady.current) return;
        const widths = itemRefs.current.map((el)=>el?.offsetWidth ?? 0);
        if (widths.some((w)=>w > 0)) {
            naturalWidths.current = widths;
            naturalWidthsReady.current = true;
            setNaturalWidthsReadyState(true);
        }
    });
    const recalculate = (0, $cozmU.useCallback)(()=>{
        const container = containerRef.current;
        if (!container || !naturalWidthsReady.current) return;
        const availableWidth = container.offsetWidth;
        const widths = naturalWidths.current;
        if (itemCount <= 2) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0);
        if (totalWidth <= availableWidth) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        let usedWidth = totalWidth;
        const newCollapsed = new Set();
        for (const index of $84c50e72db23da4d$var$getMiddleOutCollapseOrder(itemCount)){
            if (newCollapsed.size === 0) usedWidth += $84c50e72db23da4d$var$ELLIPSIS_WIDTH_ESTIMATE;
            newCollapsed.add(index);
            usedWidth -= widths[index] ?? 0;
            if (usedWidth <= availableWidth) break;
        }
        // At the smallest sizes, even first + ellipsis + last may not fit.
        // In that case, also collapse the first item so only ellipsis + last is shown.
        // Note: this branch is only reachable when itemCount > 2 (the early return above
        // handles itemCount <= 2), so collapsing index 0 here always leaves at least one
        // visible item (the last) plus the ellipsis trigger.
        if (usedWidth > availableWidth) newCollapsed.add(0);
        setCollapsedIndices((prev)=>$84c50e72db23da4d$var$setsEqual(prev, newCollapsed) ? prev : newCollapsed);
    }, [
        itemCount
    ]);
    const registerItem = (0, $cozmU.useCallback)((index)=>(el)=>{
            itemRefs.current[index] = el;
        }, []);
    const observerRef = (0, $cozmU.useRef)(null);
    const registerContainer = (0, $cozmU.useCallback)((el)=>{
        // Disconnect any existing observer
        observerRef.current?.disconnect();
        containerRef.current = el;
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') return;
        // Set up ResizeObserver immediately when container mounts
        const observer = new ResizeObserver(()=>{
            recalculate();
        });
        observer.observe(el);
        observerRef.current = observer;
    }, [
        recalculate
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (naturalWidthsReadyState) recalculate();
    }, [
        naturalWidthsReadyState,
        recalculate
    ]);
    // Cleanup observer on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        naturalWidthsReady.current = false;
        naturalWidths.current = [];
        setNaturalWidthsReadyState(false);
        setCollapsedIndices(new Set());
    }, [
        itemCount
    ]);
    return {
        collapsedIndices: collapsedIndices,
        naturalWidthsReady: naturalWidthsReadyState,
        registerItem: registerItem,
        registerContainer: registerContainer
    };
}

});

parcelRegister("6cA3O", function(module, exports) {
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $g4h89 = parcelRequire("g4h89");


var $aKleR = parcelRequire("aKleR");


var $bggFv = parcelRequire("bggFv");


var $jiltW = parcelRequire("jiltW");


var $8C5a3 = parcelRequire("8C5a3");

const $be0fad57d9cedf06$var$itemWrapperStyles = null;
const $be0fad57d9cedf06$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE = 24;
const $be0fad57d9cedf06$var$staticItemStyles = null;
const $be0fad57d9cedf06$var$staticItemWithTruncationStyles = null;
const $be0fad57d9cedf06$var$staticItemWithoutTruncationStyles = null;
const $be0fad57d9cedf06$var$motionItemStyles = null;
const $be0fad57d9cedf06$var$BreadcrumbsItem = /*#__PURE__*/ (0, $cozmU.memo)(({ analyticsContext: analyticsContext, component: component, // Analytics event creation comes from context via usePlatformLeafEventHandler.
// Strip this prop so it cannot leak onto DOM-backed controls.
createAnalyticsEvent: _createAnalyticsEvent, href: href, elemBefore: elemBefore, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, // This is overridden by the `buttonRef` below
ref: _ref, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, _overflowRef: _overflowRef, ...rest })=>{
    const [stepElement, setStepElement] = (0, $cozmU.useState)(null);
    const setStepRef = (0, $cozmU.useCallback)((element)=>{
        setStepElement(element);
    }, []);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const leadingIconWidth = resolvedElemBefore ? $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE + (breadcrumbsSize === 'small' ? 0 : 2) : 0;
    let iconWidthAllowance = 0;
    if (resolvedElemBefore) iconWidthAllowance += $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, stepElement, // The refresh control now includes the leading icon; exclude it from the truncation check.
    (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? -leadingIconWidth : iconWidthAllowance);
    if (!component && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g4h89.default), {
        ref: _overflowRef,
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        elemBefore: resolvedElemBefore,
        href: href,
        // `BreadcrumbsItem.iconAfter` in `src/packages/polaris/component-ideas-idea-view/tests/IssueKey.test.tsx`
        // and `src/packages/polaris/component-ideas-idea-view/tests/IssueBreadcrumbs.test.tsx`.
        // Those consumers need to move the copy-link affordance out of `BreadcrumbsItem` first.
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        onTooltipShown: onTooltipShown,
        shouldShowTooltip: shouldShowTooltip,
        stepRef: setStepRef,
        target: target,
        testId: testId,
        text: text,
        title: title,
        truncationWidth: truncationWidth,
        "aria-current": ariaCurrent
    });
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }; // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$be0fad57d9cedf06$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        truncationWidth: truncationWidth,
        ...rest,
        children: text
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bggFv.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: resolvedElemBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        ...rest,
        className: (0, $hekY6.default)([
            "_26BoRwPcut",
            truncationWidth ? "_1EqgXlKIuT" : "_4ouGXIAASz _3YEZNO3mKv",
            "_23rrnHo10F _00uqCYjOvk _3xtjKN0Rl6 _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: _overflowRef,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0hPCNLDIqT _0aFT5v1qpb _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwcJg58 _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be0fad57d9cedf06$export$2e2bcd8739ae039 = $be0fad57d9cedf06$var$BreadcrumbsItem;
module.exports["default"] = $be0fad57d9cedf06$export$2e2bcd8739ae039;

});

parcelRegister("g4h89", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lmzCg = parcelRequire("lmzCg");


var $lpNn5 = parcelRequire("lpNn5");


var $aKleR = parcelRequire("aKleR");

const $940cd9b04c8fc3c8$var$itemWrapperStyles = null;
const $940cd9b04c8fc3c8$var$BreadcrumbsItemBase = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    const { analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-current": ariaCurrent } = t0;
    const resolvedElemBefore = elemBefore ?? iconBefore;
    let t1;
    if ($[0] !== analyticsContext || $[1] !== ariaCurrent || $[2] !== ariaLabel || $[3] !== ariaLabelledBy || $[4] !== href || $[5] !== iconAfter || $[6] !== iconBefore || $[7] !== onClick || $[8] !== resolvedElemBefore || $[9] !== stepRef || $[10] !== target || $[11] !== testId || $[12] !== text || $[13] !== title || $[14] !== truncationWidth) {
        t1 = (triggerProps)=>{
            const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
                ref: tooltipRef ? (0, $lmzCg.default)([
                    stepRef,
                    tooltipRef
                ]) : stepRef,
                analyticsContext: analyticsContext,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                "aria-current": ariaCurrent,
                elemBefore: resolvedElemBefore,
                href: href,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                onClick: onClick,
                target: target,
                testId: testId,
                title: title,
                triggerProps: triggerProps ? tooltipTriggerProps : undefined,
                truncationWidth: truncationWidth,
                children: text
            });
        };
        $[0] = analyticsContext;
        $[1] = ariaCurrent;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = href;
        $[5] = iconAfter;
        $[6] = iconBefore;
        $[7] = onClick;
        $[8] = resolvedElemBefore;
        $[9] = stepRef;
        $[10] = target;
        $[11] = testId;
        $[12] = text;
        $[13] = title;
        $[14] = truncationWidth;
        $[15] = t1;
    } else t1 = $[15];
    const renderStep = t1;
    let t2;
    if ($[16] !== renderStep) {
        t2 = renderStep();
        $[16] = renderStep;
        $[17] = t2;
    } else t2 = $[17];
    const step = t2;
    let t3;
    if ($[18] !== xcss) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _0aFT5v1qpb _4xdlr0DIqT _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5Qame _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT",
            xcss
        ]);
        $[18] = xcss;
        $[19] = t3;
    } else t3 = $[19];
    let t4;
    if ($[20] !== onTooltipShown || $[21] !== renderStep || $[22] !== shouldShowTooltip || $[23] !== step || $[24] !== text) {
        t4 = shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step;
        $[20] = onTooltipShown;
        $[21] = renderStep;
        $[22] = shouldShowTooltip;
        $[23] = step;
        $[24] = text;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== ref || $[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            ref: ref,
            className: t3,
            children: t4
        });
        $[26] = ref;
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
} : ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const renderStep = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
            ref: tooltipRef ? (0, $lmzCg.default)([
                stepRef,
                tooltipRef
            ]) : stepRef,
            analyticsContext: analyticsContext,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-current": ariaCurrent,
            elemBefore: resolvedElemBefore,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            target: target,
            testId: testId,
            title: title,
            triggerProps: triggerProps ? tooltipTriggerProps : undefined,
            truncationWidth: truncationWidth,
            children: text
        });
    };
    const step = renderStep();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _0aFT5v1qpb _4xdlr0DIqT _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5Qame _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT",
            xcss
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $940cd9b04c8fc3c8$export$2e2bcd8739ae039 = $940cd9b04c8fc3c8$var$BreadcrumbsItemBase;
module.exports["default"] = $940cd9b04c8fc3c8$export$2e2bcd8739ae039;

});

parcelRegister("aKleR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $w6R6I = parcelRequire("w6R6I");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $hBYtq = parcelRequire("hBYtq");


var $jiltW = parcelRequire("jiltW");

const $145f806ee7333746$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $145f806ee7333746$var$noop = (0, $dpsRj.default);
const $145f806ee7333746$var$styles = {
    root: "_2sNsIgmnOE _30huDKYbGa _2mHwu81Y8M _0bjKvDcjp5 _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2Y7lL4Pgdg _0KLXru66of _1UtDYzKGUX _3iDTPbccYA _0hPCNLDIqT _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5KGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX _0CMRbky7kJ",
    rootSmall: "_2sNsIg7NXe",
    rootRefresh: "_2mHwu8Pgdg _24h04i2Njc _0jFU0V9DVM",
    interactiveMotion: "_23rrnHo10F _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ",
    withoutTruncation: "_4ouGXIdnbC _3YEZNO7dHp",
    withTruncation: "_4ouGXIdnbC",
    iconWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    iconWrapperSpacing: "_2xTnZxFQfX",
    iconWrapperSmallSpacing: "_2xTnZxPgdg",
    text: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    textWithIconAfter: "_2xTnZx1Y8M",
    textWithTruncation: "_4ouGXIdnbC _1EqgXlN91d _3YEZNO7dHp"
};
const $145f806ee7333746$var$unboundedStyles = {
    iconWrapperRefresh: "_39xV02NHnM _0jFU0VNHnM",
    iconWrapperSmall: "_27VeLCey7F _2Qxi4ney7F",
    iconWrapperSmallRefresh: "_27VeLC5zaO _2Qxi4n5zaO",
    iconWrapper: "_1UtDYzWYXf"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $145f806ee7333746$var$Step = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(106);
    let analyticsContext;
    let ariaCurrent;
    let ariaDescribedBy;
    let ariaLabel;
    let ariaLabelledBy;
    let children;
    let elemBefore;
    let href;
    let iconAfter;
    let iconBefore;
    let onBlur;
    let onFocus;
    let onMouseDown;
    let onMouseMove;
    let onMouseOut;
    let onMouseOver;
    let rest;
    let t1;
    let target;
    let testId;
    let title;
    let triggerProps;
    let truncationWidth;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: t1, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-current": ariaCurrent, "aria-describedby": ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = ariaCurrent;
        $[3] = ariaDescribedBy;
        $[4] = ariaLabel;
        $[5] = ariaLabelledBy;
        $[6] = children;
        $[7] = elemBefore;
        $[8] = href;
        $[9] = iconAfter;
        $[10] = iconBefore;
        $[11] = onBlur;
        $[12] = onFocus;
        $[13] = onMouseDown;
        $[14] = onMouseMove;
        $[15] = onMouseOut;
        $[16] = onMouseOver;
        $[17] = rest;
        $[18] = t1;
        $[19] = target;
        $[20] = testId;
        $[21] = title;
        $[22] = triggerProps;
        $[23] = truncationWidth;
    } else {
        analyticsContext = $[1];
        ariaCurrent = $[2];
        ariaDescribedBy = $[3];
        ariaLabel = $[4];
        ariaLabelledBy = $[5];
        children = $[6];
        elemBefore = $[7];
        href = $[8];
        iconAfter = $[9];
        iconBefore = $[10];
        onBlur = $[11];
        onFocus = $[12];
        onMouseDown = $[13];
        onMouseMove = $[14];
        onMouseOut = $[15];
        onMouseOver = $[16];
        rest = $[17];
        t1 = $[18];
        target = $[19];
        testId = $[20];
        title = $[21];
        triggerProps = $[22];
        truncationWidth = $[23];
    }
    const onClickProvided = t1 === undefined ? $145f806ee7333746$var$noop : t1;
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === "small";
    const leadingIconWidth = resolvedElemBefore ? `${"var(--ds-space-300, 24px)"} + ${isSmall ? "var(--ds-space-0, 0px)" : "var(--ds-space-025, 2px)"}` : "0px";
    let t2;
    if ($[24] !== leadingIconWidth || $[25] !== truncationWidth) {
        t2 = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && truncationWidth != null ? `calc(${truncationWidth}px + ${leadingIconWidth})` : truncationWidth;
        $[24] = leadingIconWidth;
        $[25] = truncationWidth;
        $[26] = t2;
    } else t2 = $[26];
    const maxWidth = t2;
    let t3;
    if ($[27] !== analyticsContext || $[28] !== onClickProvided) {
        t3 = {
            fn: onClickProvided,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$145f806ee7333746$var$analyticsAttributes
        };
        $[27] = analyticsContext;
        $[28] = onClickProvided;
        $[29] = t3;
    } else t3 = $[29];
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)(t3);
    let t4;
    if ($[30] !== handleClick || $[31] !== triggerProps) {
        t4 = (event)=>{
            triggerProps?.onClick?.(event);
            handleClick(event);
        };
        $[30] = handleClick;
        $[31] = triggerProps;
        $[32] = t4;
    } else t4 = $[32];
    const handleTriggerClick = t4;
    const controlRef = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? ref : undefined;
    const textRef = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? undefined : ref;
    let t5;
    if ($[33] !== isSmall || $[34] !== resolvedElemBefore || $[35] !== testId) {
        t5 = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId && `${testId}--icon-before`,
            className: (0, $hekY6.default)([
                $145f806ee7333746$var$styles.iconWrapper,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$unboundedStyles.iconWrapperRefresh,
                $145f806ee7333746$var$unboundedStyles.iconWrapper,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.iconWrapperSpacing,
                isSmall && $145f806ee7333746$var$styles.iconWrapperSmallSpacing,
                !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmall,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmallRefresh
            ]),
            children: resolvedElemBefore
        });
        $[33] = isSmall;
        $[34] = resolvedElemBefore;
        $[35] = testId;
        $[36] = t5;
    } else t5 = $[36];
    const iconElement = t5;
    let t6;
    if ($[37] !== isSmall || $[38] !== resolvedElemBefore) {
        t6 = !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && !isSmall && resolvedElemBefore;
        $[37] = isSmall;
        $[38] = resolvedElemBefore;
        $[39] = t6;
    } else t6 = $[39];
    let t7;
    if ($[40] !== iconElement || $[41] !== isSmall) {
        t7 = ((0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") || isSmall) && iconElement;
        $[40] = iconElement;
        $[41] = isSmall;
        $[42] = t7;
    } else t7 = $[42];
    let t8;
    if ($[43] !== iconAfter || $[44] !== truncationWidth) {
        t8 = (0, $hekY6.default)([
            $145f806ee7333746$var$styles.text,
            (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && Boolean(iconAfter) && $145f806ee7333746$var$styles.textWithIconAfter,
            truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.textWithTruncation
        ]);
        $[43] = iconAfter;
        $[44] = truncationWidth;
        $[45] = t8;
    } else t8 = $[45];
    let t9;
    if ($[46] !== children || $[47] !== t8 || $[48] !== textRef) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: textRef,
            className: t8,
            children: children
        });
        $[46] = children;
        $[47] = t8;
        $[48] = textRef;
        $[49] = t9;
    } else t9 = $[49];
    let t10;
    if ($[50] !== iconAfter || $[51] !== t6 || $[52] !== t7 || $[53] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                t6,
                t7,
                t9,
                iconAfter
            ]
        });
        $[50] = iconAfter;
        $[51] = t6;
        $[52] = t7;
        $[53] = t9;
        $[54] = t10;
    } else t10 = $[54];
    const content = t10;
    if (href) {
        const t11 = controlRef;
        const t12 = triggerProps?.onMouseOver ?? onMouseOver;
        const t13 = triggerProps?.onMouseOut ?? onMouseOut;
        const t14 = triggerProps?.onMouseMove ?? onMouseMove;
        const t15 = triggerProps?.onMouseDown ?? onMouseDown;
        const t16 = triggerProps?.onFocus ?? onFocus;
        const t17 = triggerProps?.onBlur ?? onBlur;
        const t18 = triggerProps?.["aria-describedby"] ?? ariaDescribedBy;
        const t19 = target === "_blank" ? "noopener noreferrer" : undefined;
        let t20;
        if ($[55] !== isSmall || $[56] !== truncationWidth) {
            t20 = (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, $145f806ee7333746$var$styles.interactiveMotion);
            $[55] = isSmall;
            $[56] = truncationWidth;
            $[57] = t20;
        } else t20 = $[57];
        let t21;
        if ($[58] !== maxWidth) {
            t21 = {
                maxWidth: maxWidth
            };
            $[58] = maxWidth;
            $[59] = t21;
        } else t21 = $[59];
        let t22;
        if ($[60] !== ariaCurrent || $[61] !== ariaLabel || $[62] !== ariaLabelledBy || $[63] !== content || $[64] !== handleTriggerClick || $[65] !== href || $[66] !== rest || $[67] !== t11 || $[68] !== t12 || $[69] !== t13 || $[70] !== t14 || $[71] !== t15 || $[72] !== t16 || $[73] !== t17 || $[74] !== t18 || $[75] !== t19 || $[76] !== t20 || $[77] !== t21 || $[78] !== target || $[79] !== testId || $[80] !== title) {
            t22 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                ...rest,
                ref: t11,
                "aria-current": ariaCurrent,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                href: href,
                onClick: handleTriggerClick,
                onMouseOver: t12,
                onMouseOut: t13,
                onMouseMove: t14,
                onMouseDown: t15,
                onFocus: t16,
                onBlur: t17,
                "aria-describedby": t18,
                target: target,
                rel: t19,
                testId: testId,
                title: title,
                xcss: t20,
                style: t21,
                children: content
            });
            $[60] = ariaCurrent;
            $[61] = ariaLabel;
            $[62] = ariaLabelledBy;
            $[63] = content;
            $[64] = handleTriggerClick;
            $[65] = href;
            $[66] = rest;
            $[67] = t11;
            $[68] = t12;
            $[69] = t13;
            $[70] = t14;
            $[71] = t15;
            $[72] = t16;
            $[73] = t17;
            $[74] = t18;
            $[75] = t19;
            $[76] = t20;
            $[77] = t21;
            $[78] = target;
            $[79] = testId;
            $[80] = title;
            $[81] = t22;
        } else t22 = $[81];
        return t22;
    }
    const t11 = controlRef;
    const t12 = triggerProps?.onMouseOver ?? onMouseOver;
    const t13 = triggerProps?.onMouseOut ?? onMouseOut;
    const t14 = triggerProps?.onMouseMove ?? onMouseMove;
    const t15 = triggerProps?.onMouseDown ?? onMouseDown;
    const t16 = triggerProps?.onFocus ?? onFocus;
    const t17 = triggerProps?.onBlur ?? onBlur;
    const t18 = triggerProps?.["aria-describedby"] ?? ariaDescribedBy;
    let t19;
    if ($[82] !== isSmall || $[83] !== truncationWidth) {
        t19 = (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, $145f806ee7333746$var$styles.interactiveMotion);
        $[82] = isSmall;
        $[83] = truncationWidth;
        $[84] = t19;
    } else t19 = $[84];
    let t20;
    if ($[85] !== maxWidth) {
        t20 = {
            maxWidth: maxWidth
        };
        $[85] = maxWidth;
        $[86] = t20;
    } else t20 = $[86];
    let t21;
    if ($[87] !== ariaCurrent || $[88] !== ariaLabel || $[89] !== ariaLabelledBy || $[90] !== content || $[91] !== handleTriggerClick || $[92] !== rest || $[93] !== t11 || $[94] !== t12 || $[95] !== t13 || $[96] !== t14 || $[97] !== t15 || $[98] !== t16 || $[99] !== t17 || $[100] !== t18 || $[101] !== t19 || $[102] !== t20 || $[103] !== testId || $[104] !== title) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            ...rest,
            ref: t11,
            "aria-current": ariaCurrent,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            onClick: handleTriggerClick,
            onMouseOver: t12,
            onMouseOut: t13,
            onMouseMove: t14,
            onMouseDown: t15,
            onFocus: t16,
            onBlur: t17,
            "aria-describedby": t18,
            testId: testId,
            title: title,
            xcss: t19,
            style: t20,
            children: content
        });
        $[87] = ariaCurrent;
        $[88] = ariaLabel;
        $[89] = ariaLabelledBy;
        $[90] = content;
        $[91] = handleTriggerClick;
        $[92] = rest;
        $[93] = t11;
        $[94] = t12;
        $[95] = t13;
        $[96] = t14;
        $[97] = t15;
        $[98] = t16;
        $[99] = t17;
        $[100] = t18;
        $[101] = t19;
        $[102] = t20;
        $[103] = testId;
        $[104] = title;
        $[105] = t21;
    } else t21 = $[105];
    return t21;
} : ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $145f806ee7333746$var$noop, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, 'aria-describedby': ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small'; // Preserve the text/trailing-icon width budget now that the leading icon is inside the control.
    const leadingIconWidth = resolvedElemBefore ? `${"var(--ds-space-300, 24px)"} + ${isSmall ? "var(--ds-space-0, 0px)" : "var(--ds-space-025, 2px)"}` : '0px';
    const maxWidth = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && truncationWidth != null ? `calc(${truncationWidth}px + ${leadingIconWidth})` : truncationWidth;
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$145f806ee7333746$var$analyticsAttributes
    });
    const handleTriggerClick = (event)=>{
        triggerProps?.onClick?.(event);
        handleClick(event);
    };
    const controlRef = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? ref : undefined;
    const textRef = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? undefined : ref;
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $hekY6.default)([
            $145f806ee7333746$var$styles.iconWrapper,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$unboundedStyles.iconWrapperRefresh,
            $145f806ee7333746$var$unboundedStyles.iconWrapper,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.iconWrapperSpacing,
            isSmall && $145f806ee7333746$var$styles.iconWrapperSmallSpacing,
            !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmall,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmallRefresh
        ]),
        children: resolvedElemBefore
    });
    const content = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && !isSmall && resolvedElemBefore,
            ((0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') || isSmall) && iconElement,
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: textRef,
                className: (0, $hekY6.default)([
                    $145f806ee7333746$var$styles.text,
                    (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && Boolean(iconAfter) && $145f806ee7333746$var$styles.textWithIconAfter,
                    truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.textWithTruncation
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        href: href,
        onClick: handleTriggerClick,
        onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
        onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
        onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
        onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
        onFocus: triggerProps?.onFocus ?? onFocus,
        onBlur: triggerProps?.onBlur ?? onBlur,
        "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        testId: testId,
        title: title,
        xcss: (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, $145f806ee7333746$var$styles.interactiveMotion),
        style: {
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Width depends on the consumer truncationWidth and leading icon.
            maxWidth
        },
        children: content
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: handleTriggerClick,
        onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
        onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
        onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
        onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
        onFocus: triggerProps?.onFocus ?? onFocus,
        onBlur: triggerProps?.onBlur ?? onBlur,
        "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
        testId: testId,
        title: title,
        xcss: (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, $145f806ee7333746$var$styles.interactiveMotion),
        style: {
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Width depends on the consumer truncationWidth and leading icon.
            maxWidth
        },
        children: content
    });
});
var $145f806ee7333746$export$2e2bcd8739ae039 = $145f806ee7333746$var$Step;
module.exports["default"] = $145f806ee7333746$export$2e2bcd8739ae039;

});

parcelRegister("bggFv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $7ZB0A = parcelRequire("7ZB0A");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");

const $2ab552b1d511ed22$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $2ab552b1d511ed22$var$noop = (0, $dpsRj.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $2ab552b1d511ed22$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let analyticsContext;
    let component;
    let iconAfter;
    let iconBefore;
    let props;
    let t1;
    let t2;
    let t3;
    let target;
    let testId;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, component: component, hasOverflow: t1, href: t2, iconAfter: iconAfter, iconBefore: iconBefore, onClick: t3, target: target, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = component;
        $[3] = iconAfter;
        $[4] = iconBefore;
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = target;
        $[10] = testId;
    } else {
        analyticsContext = $[1];
        component = $[2];
        iconAfter = $[3];
        iconBefore = $[4];
        props = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        target = $[9];
        testId = $[10];
    }
    const hasOverflow = t1 === undefined ? true : t1;
    const href = t2 === undefined ? "#" : t2;
    const onClickProvided = t3 === undefined ? $2ab552b1d511ed22$var$noop : t3;
    let t4;
    if ($[11] !== analyticsContext || $[12] !== onClickProvided) {
        t4 = {
            fn: onClickProvided,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$2ab552b1d511ed22$var$analyticsAttributes
        };
        $[11] = analyticsContext;
        $[12] = onClickProvided;
        $[13] = t4;
    } else t4 = $[13];
    const handleClicked = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const resolvedIconAfter = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? undefined : hasOverflow ? undefined : iconAfter;
    const t5 = hasOverflow ? undefined : iconBefore;
    let t6;
    if ($[14] !== component || $[15] !== handleClicked || $[16] !== href || $[17] !== props || $[18] !== ref || $[19] !== resolvedIconAfter || $[20] !== t5 || $[21] !== target || $[22] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            ...props,
            appearance: "subtle-link",
            component: component,
            href: href,
            iconAfter: resolvedIconAfter,
            iconBefore: t5,
            onClick: handleClicked,
            ref: ref,
            spacing: "none",
            target: target,
            testId: testId
        });
        $[14] = component;
        $[15] = handleClicked;
        $[16] = href;
        $[17] = props;
        $[18] = ref;
        $[19] = resolvedIconAfter;
        $[20] = t5;
        $[21] = target;
        $[22] = testId;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : ({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $2ab552b1d511ed22$var$noop, target: target, testId: testId, ...props }, ref)=>{
    const handleClicked = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$2ab552b1d511ed22$var$analyticsAttributes
    });
    const resolvedIconAfter = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? undefined : hasOverflow ? undefined : iconAfter;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: resolvedIconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $2ab552b1d511ed22$export$2e2bcd8739ae039 = $2ab552b1d511ed22$var$StepOld;
module.exports["default"] = $2ab552b1d511ed22$export$2e2bcd8739ae039;

});

parcelRegister("a9aSv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $5EzLH = parcelRequire("5EzLH");


var $iDrrr = parcelRequire("iDrrr");

const $19ad0c297e7cfe22$var$shimmerKeyframes = null;
const $19ad0c297e7cfe22$var$skeletonStyles = null;
const $19ad0c297e7cfe22$var$activeShimmerStyles = null; /**
                                   * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                   * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                   * which makes things simpler than doing an `isServer` check or a `null` check.
                                   *
                                   * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                   */ 
const $19ad0c297e7cfe22$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect); /**
                                                                                          * __Skeleton__
                                                                                          *
                                                                                          * A skeleton acts as a placeholder for content, usually while the content loads.
                                                                                          *
                                                                                          * - [Examples](https://atlassian.design/components/skeleton/examples)
                                                                                          * - [Code](https://atlassian.design/components/skeleton/code)
                                                                                          */ 
const $19ad0c297e7cfe22$var$Skeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(21);
    const { width: width, height: height, borderRadius: t1, color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: t2, groupName: groupName, interactionName: interactionName, testId: testId } = t0;
    const borderRadius = t1 === undefined ? "var(--ds-radius-small, 4px)" : t1;
    const isShimmering = t2 === undefined ? false : t2;
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t3;
    let t4;
    if ($[0] !== context || $[1] !== interactionName) {
        t3 = ()=>{
            if (context != null && (0, $iDrrr.fg)("platform-dst-skeleton-ufo-hold")) return context.hold(interactionName);
        };
        t4 = [
            context,
            interactionName
        ];
        $[0] = context;
        $[1] = interactionName;
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    $19ad0c297e7cfe22$var$useLayoutEffect(t3, t4);
    const t5 = color && ShimmeringEndColor ? color : undefined;
    const t6 = color && ShimmeringEndColor ? ShimmeringEndColor : undefined;
    let t7;
    if ($[4] !== borderRadius || $[5] !== color || $[6] !== height || $[7] !== t5 || $[8] !== t6 || $[9] !== width) {
        t7 = {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            "--ds-skeleton-from-color": t5,
            "--ds-skeleton-to-color": t6
        };
        $[4] = borderRadius;
        $[5] = color;
        $[6] = height;
        $[7] = t5;
        $[8] = t6;
        $[9] = width;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = t7;
    let t9;
    if ($[11] !== groupDataAttribute) {
        t9 = groupDataAttribute && {
            [groupDataAttribute]: "true"
        };
        $[11] = groupDataAttribute;
        $[12] = t9;
    } else t9 = $[12];
    const t10 = isShimmering && "";
    const t11 = isShimmering && "_1gBibyKB6V";
    let t12;
    if ($[13] !== t10 || $[14] !== t11) {
        t12 = (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            t10,
            t11
        ]);
        $[13] = t10;
        $[14] = t11;
        $[15] = t12;
    } else t12 = $[15];
    let t13;
    if ($[16] !== t12 || $[17] !== t8 || $[18] !== t9 || $[19] !== testId) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            style: t8,
            ...t9,
            className: t12
        });
        $[16] = t12;
        $[17] = t8;
        $[18] = t9;
        $[19] = testId;
        $[20] = t13;
    } else t13 = $[20];
    return t13;
} : ({ width: width, height: height, borderRadius: borderRadius = "var(--ds-radius-small, 4px)", color: color, ShimmeringEndColor: ShimmeringEndColor, isShimmering: isShimmering = false, groupName: groupName, interactionName: interactionName, testId: testId })=>{
    const groupDataAttribute = groupName && `data-${groupName}`;
    const context = (0, $cozmU.useContext)((0, $5EzLH.default));
    $19ad0c297e7cfe22$var$useLayoutEffect(()=>{
        if (context != null && (0, $iDrrr.fg)('platform-dst-skeleton-ufo-hold')) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        style: {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        },
        ...groupDataAttribute && {
            [groupDataAttribute]: 'true'
        },
        className: (0, $hekY6.default)([
            "_0uDzWjkSs3 _0nFVCGfONH _03m2nySHWH _43vdfTHVQb _0KLXruGsB2",
            isShimmering && "",
            isShimmering && "_1gBibyKB6V"
        ])
    });
};
var $19ad0c297e7cfe22$export$2e2bcd8739ae039 = $19ad0c297e7cfe22$var$Skeleton;
module.exports["default"] = $19ad0c297e7cfe22$export$2e2bcd8739ae039;

});

parcelRegister("4HuLY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $r8hvx = parcelRequire("r8hvx");

var $196c0e198225aa23$export$49ecbc2ec404bcce = /*#__PURE__*/ function(HUB_FEATURES) {
    HUB_FEATURES["BREADCRUMBS"] = "BREADCRUMBS";
    HUB_FEATURES["CONFIGURABLE_SITE_TREE"] = "CONFIGURABLE_SITE_TREE";
    HUB_FEATURES["DRAFT_MODE"] = "DRAFT_MODE";
    return HUB_FEATURES;
}({});
const $196c0e198225aa23$var$HUB_FEATURE_CONFIG = {
    ["BREADCRUMBS"]: {
        contextKey: 'enable_hub_breadcrumbs',
        isPlatformEnabled: ()=>(0, $iDrrr.fg)('enable_hub_breadcrumbs')
    },
    ["CONFIGURABLE_SITE_TREE"]: {
        contextKey: 'help_hubs_configurable_site_tree',
        isPlatformEnabled: ()=>(0, $iDrrr.fg)('help_hubs_configurable_site_tree')
    },
    ["DRAFT_MODE"]: {
        contextKey: 'help_hubs_draft_mode',
        isPlatformEnabled: ()=>(0, $iDrrr.fg)('help_hubs_draft_mode')
    }
};
function $196c0e198225aa23$export$5a7b13b33b3b4bc8(features) {
    const ctx = (0, $cozmU.useContext)((0, $r8hvx.HubContext));
    const next = features.map((feature)=>{
        const { contextKey: contextKey, isPlatformEnabled: isPlatformEnabled } = $196c0e198225aa23$var$HUB_FEATURE_CONFIG[feature];
        const isContextEnabled = ctx?.featureFlags?.[contextKey] === true;
        return isContextEnabled && isPlatformEnabled();
    });
    // Reuse the previous array when values match so deps on the return value
    // do not re-fire every render.
    const cachedRef = (0, $cozmU.useRef)(next);
    const cached = cachedRef.current;
    if (cached.length !== next.length || next.some((value, index)=>value !== cached[index])) cachedRef.current = next;
    return cachedRef.current;
}
module.exports["HUB_FEATURES"] = $196c0e198225aa23$export$49ecbc2ec404bcce;
module.exports["useIsHubFeatureEnabled"] = $196c0e198225aa23$export$5a7b13b33b3b4bc8;

});

parcelRegister("fMvIa", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("fcvZw")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("idnP4")).useRouterActions);
$parcel$export(module.exports, "Link", () => (parcelRequire("8Dc6h")).default);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("hFkZi")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("hFkZi")).useRouterStoreActions);

parcelRequire("cKmxI");
var $fcvZw = parcelRequire("fcvZw");
var $idnP4 = parcelRequire("idnP4");

parcelRequire("eCzAr");
var $8Dc6h = parcelRequire("8Dc6h");

parcelRequire("htyBH");
var $ac1eE = parcelRequire("ac1eE");
var $jwQVI = parcelRequire("jwQVI");
var $epPJ3 = parcelRequire("epPJ3");
var $htyBH = parcelRequire("htyBH");


var $3xrKK = parcelRequire("3xrKK");


var $hFkZi = parcelRequire("hFkZi");


var $jjIOx = parcelRequire("jjIOx");

parcelRequire("9Nkr4");
var $97ZVl = parcelRequire("97ZVl");
var $RNy7H = parcelRequire("RNy7H");
var $3ct2F = parcelRequire("3ct2F");


});

parcelRegister("1sXWi", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $caBeY = parcelRequire("caBeY");

const $0c1aad5e33f23526$export$93d4e7f90805808f = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $caBeY.ThemeContext));
} : ()=>(0, $cozmU.useContext)((0, $caBeY.ThemeContext));
module.exports["useTheme"] = $0c1aad5e33f23526$export$93d4e7f90805808f;

});

parcelRegister("caBeY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $R7iGI = parcelRequire("R7iGI");

const $a725a8ada4f727cc$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $R7iGI.defaultTheme));
module.exports["ThemeContext"] = $a725a8ada4f727cc$export$2c657da244d00bd6;

});

parcelRegister("R7iGI", function(module, exports) {

var $esp18 = parcelRequire("esp18");

const $86ec0bf94787f7c8$export$164de7ab8df77ef0 = (0, $esp18.atlassianTheme);
module.exports["defaultTheme"] = $86ec0bf94787f7c8$export$164de7ab8df77ef0;

});

parcelRegister("esp18", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");


var $3QMns = parcelRequire("3QMns");

const $e836efa0898b03ba$export$eeee8619e1b91cb0 = (0, $3QMns.generateTheme)({
    name: (0, $jY2LF.DEFAULT_THEME_NAME),
    backgroundColor: '#FFFFFF',
    highlightColor: '#0052CC'
});
module.exports["atlassianTheme"] = $e836efa0898b03ba$export$eeee8619e1b91cb0;

});

parcelRegister("jY2LF", function(module, exports) {
const $fa3ed95e05138600$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-pressed, #144794)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold, #1868DB)",
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, #FFFFFF)",
                backgroundColor: "var(--ds-background-brand-bold-hovered, #1558BC)",
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, #FFFFFF)",
            color: "var(--ds-text-subtlest, #6B6E76)"
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, #1868DB)",
            color: "var(--ds-text, #292A2E)",
            borderRight: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
            // TODO: replace with token after brand refresh
            iconColor: '#357DE8',
            textColor: "var(--ds-text, #292A2E)"
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #0515240F)",
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected, #E9F2FE)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            },
            selectedHover: {
                color: "var(--ds-text-selected, #1868DB)",
                backgroundColor: "var(--ds-background-selected-hovered, #CFE1FD)",
                boxShadow: '',
                borderColor: "var(--ds-border-selected, #1868DB)"
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, #FFFFFF)",
                color: "var(--ds-text-subtlest, #6B6E76)",
                borderColor: "var(--ds-border-input, #8C8F97)"
            },
            focus: {
                borderColor: "var(--ds-border-focused, #4688EC)"
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, #F8F8F8)"
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            opacity: 1
        }
    }
};
// Create deep copy of defaultTheme
const $fa3ed95e05138600$var$defaultThemeCopy = JSON.parse(JSON.stringify($fa3ed95e05138600$var$defaultTheme));
// Update iconColor and textColor in defaultThemeBrandRefresh
$fa3ed95e05138600$var$defaultThemeCopy.mode.productHome.iconColor = undefined;
$fa3ed95e05138600$var$defaultThemeCopy.mode.productHome.textColor = undefined;
const $fa3ed95e05138600$export$2491e13b198e597d = 'atlassian';
var $fa3ed95e05138600$export$2e2bcd8739ae039 = $fa3ed95e05138600$var$defaultTheme;
module.exports["DEFAULT_THEME_NAME"] = $fa3ed95e05138600$export$2491e13b198e597d;
module.exports["default"] = $fa3ed95e05138600$export$2e2bcd8739ae039;

});

parcelRegister("3QMns", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");


var $7hcrB = parcelRequire("7hcrB");


var $jIkZX = parcelRequire("jIkZX");


var $6DrQc = parcelRequire("6DrQc");


var $dZ8SJ = parcelRequire("dZ8SJ");


var $8T7KI = parcelRequire("8T7KI");

const $42bc0c8ea2a74a92$var$generateOpacityValue = (color)=>color === '#000000' ? 0.3 : 0.6;
const $42bc0c8ea2a74a92$var$generateButtonCSSStates = (colors, buttonType)=>{
    const { backgroundColor: backgroundColor, color: color, highlightColor: highlightColor } = colors;
    // Add less opacity for white text so it is still legible.
    const opacityValue = $42bc0c8ea2a74a92$var$generateOpacityValue(color);
    const isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $8T7KI.hexToRGBA)(backgroundColor, 0.65) : (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $8T7KI.hexToRGBA)(backgroundColor, 0.8) : (0, $dZ8SJ.getContrastColor)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $dZ8SJ.getContrastColor)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $6DrQc.getBoxShadow)('transparent')
        }
    };
};
const $42bc0c8ea2a74a92$var$generateCreateButtonColors = (_themeBackground, themeHighlight)=>({
        backgroundColor: themeHighlight,
        color: (0, $jIkZX.generateTextColor)(themeHighlight),
        highlightColor: themeHighlight
    });
const $42bc0c8ea2a74a92$export$2e4ecffaca289a18 = (themeColors)=>{
    const { backgroundColor: backgroundColor, highlightColor: highlightColor, name: name } = themeColors;
    const color = (0, $jIkZX.generateTextColor)(backgroundColor);
    const colors = {
        ...themeColors,
        color: color
    };
    if (name === (0, $jY2LF.DEFAULT_THEME_NAME)) return 0, $7hcrB.defaultThemeBrandRefresh;
    return {
        mode: {
            create: $42bc0c8ea2a74a92$var$generateButtonCSSStates($42bc0c8ea2a74a92$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $42bc0c8ea2a74a92$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $42bc0c8ea2a74a92$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                iconColor: color,
                textColor: color,
                backgroundColor: highlightColor,
                borderRight: `${"var(--ds-border-width, 1px)"} solid ${(0, $8T7KI.hexToRGBA)(color, 0.5)}`
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $8T7KI.hexToRGBA)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $8T7KI.hexToRGBA)(highlightColor, 0.8),
                    boxShadow: (0, $6DrQc.getBoxShadow)((0, $8T7KI.hexToRGBA)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $dZ8SJ.getContrastColor)(0.1, $42bc0c8ea2a74a92$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
module.exports["generateTheme"] = $42bc0c8ea2a74a92$export$2e4ecffaca289a18;

});

parcelRegister("7hcrB", function(module, exports) {

var $jY2LF = parcelRequire("jY2LF");

const $a303abd91c32b08e$var$defaultThemeCopy = JSON.parse(JSON.stringify((0, $jY2LF.default)));
const $a303abd91c32b08e$export$77823bc9863eaa03 = $a303abd91c32b08e$var$defaultThemeCopy;
module.exports["defaultThemeBrandRefresh"] = $a303abd91c32b08e$export$77823bc9863eaa03;

});

parcelRegister("jIkZX", function(module, exports) {

var $aELWC = parcelRequire("aELWC");


var $bDWMn = parcelRequire("bDWMn");

const $d156dcf17fd40e8f$export$10a10e7cd1193377 = (color)=>{
    const converted = (0, $bDWMn.convertHexShorthand)(color);
    return (0, $aELWC.default).contrastRatio(converted).hex;
};
module.exports["generateTextColor"] = $d156dcf17fd40e8f$export$10a10e7cd1193377;

});

parcelRegister("bDWMn", function(module, exports) {
const $00e839f9891a322a$var$hex = '[a-z0-9]';
const $00e839f9891a322a$var$shortHandHexColorPattern = new RegExp(`#(${$00e839f9891a322a$var$hex})(${$00e839f9891a322a$var$hex})(${$00e839f9891a322a$var$hex})`, 'i');
const $00e839f9891a322a$var$repeat = (str, times)=>[
        ...Array(times)
    ].map(()=>str).join('');
const $00e839f9891a322a$var$isShortHexColor = (color)=>color && color.length === 4;
const $00e839f9891a322a$var$completeHexColor = (colors)=>{
    const hex = colors.map((color)=>$00e839f9891a322a$var$repeat(color, 2)).join('');
    return `#${hex}`;
};
const $00e839f9891a322a$var$completeTriplet = (colors)=>`#${$00e839f9891a322a$var$repeat(colors[1], 6)}`;
const $00e839f9891a322a$var$isTriplet = (colors)=>colors[0] === colors[1] && colors[1] === colors[2];
const $00e839f9891a322a$export$db8d2130677f868c = (color)=>{
    if ($00e839f9891a322a$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        const matches = color.match($00e839f9891a322a$var$shortHandHexColorPattern);
        if (matches) {
            const colors = matches.slice(1, 4);
            if ($00e839f9891a322a$var$isTriplet(colors)) return $00e839f9891a322a$var$completeTriplet(colors);
            else return $00e839f9891a322a$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
module.exports["convertHexShorthand"] = $00e839f9891a322a$export$db8d2130677f868c;

});

parcelRegister("6DrQc", function(module, exports) {
const $39c046d81b46dcab$export$bba5a971afe05444 = (color)=>`0 0 0 2px ${color}`;
module.exports["getBoxShadow"] = $39c046d81b46dcab$export$bba5a971afe05444;

});

parcelRegister("dZ8SJ", function(module, exports) {

var $aELWC = parcelRequire("aELWC");


var $8T7KI = parcelRequire("8T7KI");

const $51a91b894a1b5a60$export$77a1051494882576 = (contrastValue, opacityValue, color)=>(0, $8T7KI.hexToRGBA)((0, $aELWC.default).contrast(contrastValue, color).hex, opacityValue);
module.exports["getContrastColor"] = $51a91b894a1b5a60$export$77a1051494882576;

});

parcelRegister("8T7KI", function(module, exports) {

var $aELWC = parcelRequire("aELWC");

const $93f364b8cdab62de$export$7229be6d7219ee6a = (hex, opacity = 1)=>{
    const rgba = {
        ...(0, $aELWC.default).convert(hex).rgb,
        a: opacity
    };
    return `rgba(${Object.values(rgba).join(', ')})`;
};
module.exports["hexToRGBA"] = $93f364b8cdab62de$export$7229be6d7219ee6a;

});

parcelRegister("untPk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ebf482a6988f6298a86299ac42fdfe98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $05b5041c5b068c03$var$_react = $05b5041c5b068c03$var$_interopRequireDefault((parcelRequire("cozmU")));

var $05b5041c5b068c03$var$_iconNew = $05b5041c5b068c03$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $05b5041c5b068c03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Home".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/home
 * Usage guidance:
 * Single purpose - Reserved for home in navigation. When a user clicks on this, they should return to the homepage.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $05b5041c5b068c03$var$HomeIcon = (props)=>/*#__PURE__*/ $05b5041c5b068c03$var$_react.default.createElement($05b5041c5b068c03$var$_iconNew.default, Object.assign({
        name: "HomeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.646.727a2 2 0 0 1 2.708 0l5 4.6A2 2 0 0 1 15 6.799V13a2 2 0 0 1-2 2H9.75a.75.75 0 0 1-.75-.75V9.5H7v4.75a.75.75 0 0 1-.75.75H3a2 2 0 0 1-2-2V6.799a2 2 0 0 1 .646-1.472zM8.339 1.83a.5.5 0 0 0-.678 0l-5 4.6a.5.5 0 0 0-.161.368V13a.5.5 0 0 0 .5.5h2.5V8.75A.75.75 0 0 1 6.25 8h3.5a.75.75 0 0 1 .75.75v4.75H13a.5.5 0 0 0 .5-.5V6.799a.5.5 0 0 0-.162-.368z" clip-rule="evenodd"/>`
    }, props));
$05b5041c5b068c03$var$HomeIcon.displayName = 'HomeIcon';
var $05b5041c5b068c03$var$_default = module.exports.default = $05b5041c5b068c03$var$HomeIcon;

});

parcelRegister("lskrC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9fa04d7bec8552f7cf5d65f57f0111e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9ec1258c694af78$var$_react = $f9ec1258c694af78$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f9ec1258c694af78$var$_iconNew = $f9ec1258c694af78$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f9ec1258c694af78$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Inbox".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/inbox
 * Usage guidance:
 * Multi purpose - Known uses: 'Your work' in Confluence, inbox, mail.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9ec1258c694af78$var$InboxIcon = (props)=>/*#__PURE__*/ $f9ec1258c694af78$var$_react.default.createElement($f9ec1258c694af78$var$_iconNew.default, Object.assign({
        name: "InboxIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v5h3a.75.75 0 0 1 .75.75 1.75 1.75 0 1 0 3.5 0A.75.75 0 0 1 10.5 8h3V3a.5.5 0 0 0-.5-.5zm10.5 7h-2.337a3.251 3.251 0 0 1-6.326 0H2.5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM12 6H4V4.5h8z" clip-rule="evenodd"/>`
    }, props));
$f9ec1258c694af78$var$InboxIcon.displayName = 'InboxIcon';
var $f9ec1258c694af78$var$_default = module.exports.default = $f9ec1258c694af78$var$InboxIcon;

});

parcelRegister("7Mix9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::113cd4523810e6c9fe05d0e52a1ca1f4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a9b647a96a0e4d7$var$_react = $5a9b647a96a0e4d7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $5a9b647a96a0e4d7$var$_iconNew = $5a9b647a96a0e4d7$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $5a9b647a96a0e4d7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Menu".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/menu
 * Usage guidance:
 * Single purpose - Reserved for accessing the menu in global app navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a9b647a96a0e4d7$var$MenuIcon = (props)=>/*#__PURE__*/ $5a9b647a96a0e4d7$var$_react.default.createElement($5a9b647a96a0e4d7$var$_iconNew.default, Object.assign({
        name: "MenuIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M15 12.5V14H1v-1.5zm0-5.25v1.5H1v-1.5zM15 2v1.5H1V2z"/>`
    }, props));
$5a9b647a96a0e4d7$var$MenuIcon.displayName = 'MenuIcon';
var $5a9b647a96a0e4d7$var$_default = module.exports.default = $5a9b647a96a0e4d7$var$MenuIcon;

});

parcelRegister("d7SWg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $60458bc9967d0c01$var$noop = ()=>{};
const $60458bc9967d0c01$export$2c6067e95d1be081 = (0, $cozmU.createContext)({
    options: null,
    setOptions: $60458bc9967d0c01$var$noop
});
const $60458bc9967d0c01$export$ce205152a61c4e11 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($60458bc9967d0c01$export$2c6067e95d1be081);
} : ()=>(0, $cozmU.useContext)($60458bc9967d0c01$export$2c6067e95d1be081);
module.exports["useNavigationStyle"] = $60458bc9967d0c01$export$ce205152a61c4e11;

});

parcelRegister("4WDWC", function(module, exports) {

var $hjUDQ = parcelRequire("hjUDQ");

const $6fcee6e7d693a28e$export$ca8289818e8a00b3 = 0;
const $6fcee6e7d693a28e$export$fd5c0c061b90ed51 = 32;
const $6fcee6e7d693a28e$export$39e466a7b7ce22ff = 8;
const $6fcee6e7d693a28e$export$80508b5197dbe846 = 8;
const $6fcee6e7d693a28e$export$e3711566ecaf02ae = '--hub-corner-radius';
const $6fcee6e7d693a28e$var$VALID = new Set([
    0,
    8,
    16,
    24,
    32
]);
const $6fcee6e7d693a28e$export$122ea29a9b10732a = (value)=>typeof value === 'number' && $6fcee6e7d693a28e$var$VALID.has(value) ? value : $6fcee6e7d693a28e$export$80508b5197dbe846;
const $6fcee6e7d693a28e$export$3795d91173f540a = (style)=>style === (0, $hjUDQ.CornerStyle).SQUARED ? 0 : undefined;
const $6fcee6e7d693a28e$export$db3cd30e3eed0965 = (cornerRadius, cornerStyle)=>cornerRadius ?? $6fcee6e7d693a28e$export$3795d91173f540a(cornerStyle);
module.exports["HUB_CORNER_RADIUS_MIN"] = $6fcee6e7d693a28e$export$ca8289818e8a00b3;
module.exports["HUB_CORNER_RADIUS_MAX"] = $6fcee6e7d693a28e$export$fd5c0c061b90ed51;
module.exports["HUB_CORNER_RADIUS_STEP"] = $6fcee6e7d693a28e$export$39e466a7b7ce22ff;
module.exports["HUB_CORNER_RADIUS_DEFAULT"] = $6fcee6e7d693a28e$export$80508b5197dbe846;
module.exports["HUB_CORNER_RADIUS_CSS_VAR"] = $6fcee6e7d693a28e$export$e3711566ecaf02ae;
module.exports["resolveHubCornerRadius"] = $6fcee6e7d693a28e$export$122ea29a9b10732a;
module.exports["resolveCornerRadiusOverride"] = $6fcee6e7d693a28e$export$db3cd30e3eed0965;

});

parcelRegister("eafQX", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $j0Q3v = parcelRequire("j0Q3v");

const $14392eb285344a6f$export$186c72664a5e904e = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $j0Q3v.useIsAdvancedThemingEnabled)();
} : ()=>(0, $j0Q3v.useIsAdvancedThemingEnabled)();
module.exports["useIsHubCornerRadiusEnabled"] = $14392eb285344a6f$export$186c72664a5e904e;

});

parcelRegister("j0Q3v", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $r8hvx = parcelRequire("r8hvx");

const $a0de554e52ac72d7$export$13ab96420d94e773 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const ctx = (0, $cozmU.useContext)((0, $r8hvx.HubContext));
    if (!ctx) return false;
    const productFlag = ctx.featureFlags?.["advanced-theming-in-hub"] === true;
    let t0;
    if ($[0] !== productFlag) {
        t0 = productFlag && (0, $iDrrr.fg)("hub-advanced-theming");
        $[0] = productFlag;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const ctx = (0, $cozmU.useContext)((0, $r8hvx.HubContext));
    if (!ctx) // No HubContextProvider in tree (e.g. Confluence Company Hub). Theming
    // is help-center-only — return false without throwing.
    return false;
    const productFlag = ctx.featureFlags?.['advanced-theming-in-hub'] === true;
    return productFlag && (0, $iDrrr.fg)('hub-advanced-theming');
};
module.exports["useIsAdvancedThemingEnabled"] = $a0de554e52ac72d7$export$13ab96420d94e773;

});

parcelRegister("51SAu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $r8hvx = parcelRequire("r8hvx");

const $35a70c9707c3191c$export$c54b4589f088dfd2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const ctx = (0, $cozmU.useContext)((0, $r8hvx.HubContext));
    if (!ctx) return false;
    if (ctx.hubType !== "HELP_HUB") return false;
    let t0;
    if ($[0] !== ctx.isPremiumEntitled) {
        t0 = ctx.isPremiumEntitled === false && (0, $iDrrr.fg)("hubs_premium_upsell");
        $[0] = ctx.isPremiumEntitled;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const ctx = (0, $cozmU.useContext)((0, $r8hvx.HubContext));
    if (!ctx) // e.g. Confluence Company Hub — never lock.
    return false;
    if (ctx.hubType !== 'HELP_HUB') return false;
    return ctx.isPremiumEntitled === false && (0, $iDrrr.fg)('hubs_premium_upsell');
};
module.exports["useShouldShowPremiumUpsell"] = $35a70c9707c3191c$export$c54b4589f088dfd2;

});

parcelRegister("67z7B", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lI7ls = parcelRequire("lI7ls");

parcelRequire("cvj4z");
var $imtAv = parcelRequire("imtAv");
var $aO6HO = parcelRequire("aO6HO");

const $735fd5e1bb83b60f$export$d3010bc2e9cc1386 = (to, currentLocation)=>(0, $lI7ls.createLocation)(to, null, undefined, currentLocation);
const $735fd5e1bb83b60f$var$isModifiedEvent = (event)=>event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
/**
 * React Resource Router does not apply the base URL when `to` is a string. because we do not pass basePath to the router, we instead pass it to the history.
 * Keep the displayed URL base-aware while navigating with the relative router location.
 */ // The server case is intentionally not handled until platform can safely access AJS metadata.
const $735fd5e1bb83b60f$var$getHref = (history, location)=>history.createHref(location);
const $735fd5e1bb83b60f$var$BaseUrlRespectedLink = ({ to: to, onClick: onClick, history: history, location: location, target: target, replace: replace, children: children, ...rest })=>{
    const toAsLocation = $735fd5e1bb83b60f$export$d3010bc2e9cc1386(to, location);
    const href = toAsLocation ? $735fd5e1bb83b60f$var$getHref(history, toAsLocation) : '';
    const wrappedOnClick = (0, $cozmU.useCallback)((event)=>{
        try {
            onClick?.(event);
        } catch (error) {
            event.preventDefault();
            throw error;
        }
        const isPrimaryClick = 'button' in event && event.button === 0;
        const isEnterKey = 'key' in event && event.key === 'Enter';
        if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && (!target || target === '_self') && !$735fd5e1bb83b60f$var$isModifiedEvent(event)) {
            event.preventDefault();
            const method = replace ? history.replace : history.push;
            method($735fd5e1bb83b60f$export$d3010bc2e9cc1386(to, location));
        }
    }, [
        history,
        location,
        onClick,
        replace,
        target,
        to
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $imtAv.default), {
        href: href,
        ...rest,
        target: target,
        onClick: wrappedOnClick
    }, children);
};
const $735fd5e1bb83b60f$var$BaseUrlRespectedLinkWithRouter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ $cozmU.createElement((0, $aO6HO.RouterSubscriber), null, (router)=>{
            const { location: location } = router;
            const { history: history } = router;
            return /*#__PURE__*/ $cozmU.createElement($735fd5e1bb83b60f$var$BaseUrlRespectedLink, {
                location: location,
                history: history,
                ...props
            });
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ $cozmU.createElement((0, $aO6HO.RouterSubscriber), null, (router)=>{
        const { location: location } = router;
        const { history: history } = router;
        return /*#__PURE__*/ $cozmU.createElement($735fd5e1bb83b60f$var$BaseUrlRespectedLink, {
            location: location,
            history: history,
            ...props
        });
    });
var $735fd5e1bb83b60f$export$2e2bcd8739ae039 = $735fd5e1bb83b60f$var$BaseUrlRespectedLinkWithRouter;
module.exports["default"] = $735fd5e1bb83b60f$export$2e2bcd8739ae039;

});

parcelRegister("dS16R", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1d6b90709e3afd07$var$_default_1 = (0, $kSwu1.defineMessages)({
    editSite: {
        id: "hub-app-shell.avatar-menu.edit-site",
        defaultMessage: "Edit site"
    },
    profile: {
        id: "hub-app-shell.avatar-menu.profile",
        defaultMessage: "Profile"
    },
    logout: {
        id: "hub-app-shell.avatar-menu.logout",
        defaultMessage: "Logout"
    }
});
var $1d6b90709e3afd07$export$2e2bcd8739ae039 = $1d6b90709e3afd07$var$_default_1;
module.exports["default"] = $1d6b90709e3afd07$export$2e2bcd8739ae039;

});

parcelRegister("iK7lw", function(module, exports) {
const $58563c9d63e704c0$var$MODELS_API_URL = '/rest/servicedesk/1/customer/models';
const $58563c9d63e704c0$export$9aabeb09177df765 = async (cloudUrl, helpCenterAri)=>{
    const response = await fetch(`${cloudUrl}${$58563c9d63e704c0$var$MODELS_API_URL}`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: {
                clientBasePath: cloudUrl,
                helpCenterAri: helpCenterAri
            },
            models: [
                'userRequestsCounts'
            ]
        })
    });
    return response.json();
};
module.exports["getRequestCount"] = $58563c9d63e704c0$export$9aabeb09177df765;

});

parcelRegister("6DK5X", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $14b83beb709dfcd6$export$d80475e2e9574bf6 = ()=>(0, $iDrrr.fg)('help_hubs_hide_nav_menus');
const $14b83beb709dfcd6$export$b56f2ad6d9942cbc = (hiddenMenus)=>{
    const hidden = $14b83beb709dfcd6$export$d80475e2e9574bf6() ? hiddenMenus ?? [] : [];
    return {
        isPortalsMenuHidden: hidden.includes('PORTALS'),
        isTopicsMenuHidden: hidden.includes('TOPICS')
    };
};
module.exports["isHideNavMenusEnabled"] = $14b83beb709dfcd6$export$d80475e2e9574bf6;
module.exports["getHiddenNavMenus"] = $14b83beb709dfcd6$export$b56f2ad6d9942cbc;

});

parcelRegister("7TPw9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<0b420321b8f0e6761b0f1e413d38c4e4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d32cd3ca5e3f8abd$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "moreDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "customPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "CUSTOM"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
        }
    ],
    "type": "HelpCenter"
};
$d32cd3ca5e3f8abd$var$node.hash = "bdf2ee4c0e7d81a58ea6f6250d6f062a";
var $d32cd3ca5e3f8abd$export$2e2bcd8739ae039 = $d32cd3ca5e3f8abd$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $7ZB0A = parcelRequire("7ZB0A");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $hMaHH = parcelRequire("hMaHH");


var $9d7Pd = parcelRequire("9d7Pd");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $6Pqow = parcelRequire("6Pqow");


var $32sS3 = parcelRequire("32sS3");




const $ded1358e0c6181df$var$messages = (0, $kSwu1.defineMessages)({
    more: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more",
        defaultMessage: "More"
    },
    moreDownIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.chevron-down",
        defaultMessage: "Open more dropdown"
    },
    moreUpIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.chevron-up",
        defaultMessage: "Close more dropdown"
    },
    pageIconLabel: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more.page-icon-label",
        defaultMessage: "Page icon"
    }
});
var $ded1358e0c6181df$export$2e2bcd8739ae039 = $ded1358e0c6181df$var$messages;


const $5ef9cadcd9035e1b$var$styles = {
    overflowHidden: "_4bt5LAnQyn _2WAcuGnQyn",
    dropdownItems: "_2Zuz6Q2ADO"
};
const $5ef9cadcd9035e1b$var$motionStyles = {
    slideEntering: "_1gBibyJtnr _0nFVCGLrT7 _43vdfTjwM9",
    slideExiting: "_1gBibyMmpp _0nFVCGLrT7 _43vdfTyNAO"
};
const $5ef9cadcd9035e1b$export$6d7fd1d1521d3638 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { queryRef: queryRef, textColor: textColor, isMobile: isMobile } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const data = (0, $6SsN4.useFragment)((0, $d32cd3ca5e3f8abd$export$2e2bcd8739ae039), queryRef);
    const customPages = data?.customPages;
    if (!customPages || customPages.length === 0) return null;
    if (isMobile) {
        let t1;
        if ($[0] !== formatMessage || $[1] !== isExpanded) {
            t1 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreDownIcon)
            });
            $[0] = formatMessage;
            $[1] = isExpanded;
            $[2] = t1;
        } else t1 = $[2];
        let t2;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = ()=>setIsExpanded($5ef9cadcd9035e1b$var$_temp);
            $[3] = t2;
        } else t2 = $[3];
        let t3;
        if ($[4] !== formatMessage) {
            t3 = formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).more);
            $[4] = formatMessage;
            $[5] = t3;
        } else t3 = $[5];
        let t4;
        if ($[6] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                weight: "medium"
            }, t3);
            $[6] = t3;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== isExpanded || $[9] !== t1 || $[10] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconAfter: t1,
                onClick: t2,
                "aria-expanded": isExpanded
            }, t4);
            $[8] = isExpanded;
            $[9] = t1;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = (0, $hekY6.default)([
                $5ef9cadcd9035e1b$var$styles.overflowHidden
            ]);
            $[12] = t6;
        } else t6 = $[12];
        let t7;
        if ($[13] !== customPages || $[14] !== isExpanded || $[15] !== push) {
            t7 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                enteringAnimationXcss: $5ef9cadcd9035e1b$var$motionStyles.slideEntering,
                exitingAnimationXcss: $5ef9cadcd9035e1b$var$motionStyles.slideExiting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "more-dropdown-items",
                className: (0, $hekY6.default)([
                    $5ef9cadcd9035e1b$var$styles.dropdownItems
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, customPages.map((page)=>{
                const pageId = page?.id ? (0, $32sS3.HelpPageAri).parse(page.id).pageId : "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    key: pageId,
                    testId: `nav-custom-page-${pageId}`,
                    onClick: ()=>{
                        push(`/page/${pageId}`);
                    }
                }, page?.name?.default);
            }))));
            $[13] = customPages;
            $[14] = isExpanded;
            $[15] = push;
            $[16] = t7;
        } else t7 = $[16];
        let t8;
        if ($[17] !== t7) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
                appear: true
            }, t7);
            $[17] = t7;
            $[18] = t8;
        } else t8 = $[18];
        let t9;
        if ($[19] !== t6 || $[20] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: t6
            }, t8);
            $[19] = t6;
            $[20] = t8;
            $[21] = t9;
        } else t9 = $[21];
        let t10;
        if ($[22] !== t5 || $[23] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t5, t9);
            $[22] = t5;
            $[23] = t9;
            $[24] = t10;
        } else t10 = $[24];
        return t10;
    }
    let t1;
    if ($[25] !== formatMessage || $[26] !== textColor) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).more));
        };
        $[25] = formatMessage;
        $[26] = textColor;
        $[27] = t1;
    } else t1 = $[27];
    let t2;
    if ($[28] !== customPages || $[29] !== formatMessage || $[30] !== push) {
        let t3;
        if ($[32] !== formatMessage || $[33] !== push) {
            t3 = (page_0)=>{
                const pageId_0 = page_0?.id ? (0, $32sS3.HelpPageAri).parse(page_0.id).pageId : "";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                    key: pageId_0,
                    testId: `nav-custom-page-${pageId_0}`,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                        label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).pageIconLabel)
                    }),
                    onClick: ()=>{
                        push(`/page/${pageId_0}`);
                    }
                }, page_0?.name?.default);
            };
            $[32] = formatMessage;
            $[33] = push;
            $[34] = t3;
        } else t3 = $[34];
        t2 = customPages.map(t3);
        $[28] = customPages;
        $[29] = formatMessage;
        $[30] = push;
        $[31] = t2;
    } else t2 = $[31];
    let t3;
    if ($[35] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t2);
        $[35] = t2;
        $[36] = t3;
    } else t3 = $[36];
    let t4;
    if ($[37] !== t1 || $[38] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t1,
            shouldRenderToParent: true
        }, t3);
        $[37] = t1;
        $[38] = t3;
        $[39] = t4;
    } else t4 = $[39];
    return t4;
} : ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const data = (0, $6SsN4.useFragment)((0, $d32cd3ca5e3f8abd$export$2e2bcd8739ae039), queryRef);
    const customPages = data?.customPages;
    if (!customPages || customPages.length === 0) return null;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
        weight: "medium"
    }, formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).more))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5ef9cadcd9035e1b$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
        enteringAnimationXcss: $5ef9cadcd9035e1b$var$motionStyles.slideEntering,
        exitingAnimationXcss: $5ef9cadcd9035e1b$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "more-dropdown-items",
        className: (0, $hekY6.default)([
            $5ef9cadcd9035e1b$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, customPages.map((page)=>{
        const pageId = page?.id ? (0, $32sS3.HelpPageAri).parse(page.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: pageId,
            testId: `nav-custom-page-${pageId}`,
            onClick: ()=>{
                push(`/page/${pageId}`);
            }
        }, page?.name?.default);
    })))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).moreDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).more)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, customPages.map((page_0)=>{
        const pageId_0 = page_0?.id ? (0, $32sS3.HelpPageAri).parse(page_0.id).pageId : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: pageId_0,
            testId: `nav-custom-page-${pageId_0}`,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                label: formatMessage((0, $ded1358e0c6181df$export$2e2bcd8739ae039).pageIconLabel)
            }),
            onClick: ()=>{
                push(`/page/${pageId_0}`);
            }
        }, page_0?.name?.default);
    })));
};
function $5ef9cadcd9035e1b$var$_temp(prev) {
    return !prev;
}
module.exports["MoreDropdown"] = $5ef9cadcd9035e1b$export$6d7fd1d1521d3638;

});

parcelRegister("59YRu", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<d7aa09aa29354220a79c91e7d74f6e10>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ed886607e5376318$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "portalsFilter"
        }
    ],
    "kind": "Fragment",
    "name": "portalDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "portalsFilter",
                    "variableName": "portalsFilter"
                }
            ],
            "concreteType": "HelpCenterPortals",
            "kind": "LinkedField",
            "name": "portals",
            "plural": false,
            "selections": [
                {
                    "concreteType": "HelpCenterPortal",
                    "kind": "LinkedField",
                    "name": "portalsList",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "HelpCenter"
};
$ed886607e5376318$var$node.hash = "99e96001b0845815b25025bb6c70250a";
var $ed886607e5376318$export$2e2bcd8739ae039 = $ed886607e5376318$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $7ZB0A = parcelRequire("7ZB0A");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $hMaHH = parcelRequire("hMaHH");


var $9d7Pd = parcelRequire("9d7Pd");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $6Pqow = parcelRequire("6Pqow");


var $4HuLY = parcelRequire("4HuLY");




const $d97399a84a7f3dc6$var$messages = (0, $kSwu1.defineMessages)({
    pageIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.page-icon.non-final",
        defaultMessage: "Page icon"
    },
    portalDownIcon: {
        defaultMessage: "Open portals dropdown",
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-down.non-final"
    },
    portalUpIcon: {
        defaultMessage: "Close portals dropdown",
        id: "company-hub.hub-app-shell.navbar.nav-links.portal-dropdown.chevron-up.non-final"
    },
    portals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portals",
        defaultMessage: "Portals"
    }
});
var $d97399a84a7f3dc6$export$2e2bcd8739ae039 = $d97399a84a7f3dc6$var$messages;



var $auieu = parcelRequire("auieu");

const $94a12285eaa7eea3$var$styles = {
    overflowHidden: "_4bt5LAnQyn _2WAcuGnQyn",
    dropdownItems: "_2Zuz6Q2ADO"
};
const $94a12285eaa7eea3$var$motionStyles = {
    slideEntering: "_1gBibyJtnr _0nFVCGLrT7 _43vdfTjwM9",
    slideExiting: "_1gBibyMmpp _0nFVCGLrT7 _43vdfTyNAO"
};
const $94a12285eaa7eea3$export$32e0c0d1c2f88773 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(54);
    const { queryRef: queryRef, textColor: textColor, isMobile: isMobile } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $4HuLY.HUB_FEATURES).CONFIGURABLE_SITE_TREE
        ];
        $[0] = t1;
    } else t1 = $[0];
    const [isConfigurableSiteTreeEnabled] = (0, $4HuLY.useIsHubFeatureEnabled)(t1);
    const data = (0, $6SsN4.useFragment)((0, $ed886607e5376318$export$2e2bcd8739ae039), queryRef);
    const portalPages = data?.portals?.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (isMobile) {
        if (hasSinglePortal) {
            let t2;
            if ($[1] !== portalPages[0]?.id || $[2] !== push) {
                t2 = ()=>{
                    push(`/portal/${portalPages[0]?.id}`);
                };
                $[1] = portalPages[0]?.id;
                $[2] = push;
                $[3] = t2;
            } else t2 = $[3];
            const t3 = portalPages[0]?.name;
            let t4;
            if ($[4] !== t2 || $[5] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    onClick: t2
                }, t3);
                $[4] = t2;
                $[5] = t3;
                $[6] = t4;
            } else t4 = $[6];
            return t4;
        }
        let t2;
        if ($[7] !== formatMessage || $[8] !== isExpanded) {
            t2 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalDownIcon)
            });
            $[7] = formatMessage;
            $[8] = isExpanded;
            $[9] = t2;
        } else t2 = $[9];
        let t3;
        if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = ()=>setIsExpanded($94a12285eaa7eea3$var$_temp);
            $[10] = t3;
        } else t3 = $[10];
        let t4;
        if ($[11] !== formatMessage) {
            t4 = formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portals);
            $[11] = formatMessage;
            $[12] = t4;
        } else t4 = $[12];
        let t5;
        if ($[13] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
                weight: "medium"
            }, t4);
            $[13] = t4;
            $[14] = t5;
        } else t5 = $[14];
        let t6;
        if ($[15] !== isExpanded || $[16] !== t2 || $[17] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconAfter: t2,
                onClick: t3,
                "aria-expanded": isExpanded
            }, t5);
            $[15] = isExpanded;
            $[16] = t2;
            $[17] = t5;
            $[18] = t6;
        } else t6 = $[18];
        let t7;
        if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $hekY6.default)([
                $94a12285eaa7eea3$var$styles.overflowHidden
            ]);
            $[19] = t7;
        } else t7 = $[19];
        let t8;
        if ($[20] !== isExpanded || $[21] !== portalPages || $[22] !== push) {
            t8 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                enteringAnimationXcss: $94a12285eaa7eea3$var$motionStyles.slideEntering,
                exitingAnimationXcss: $94a12285eaa7eea3$var$motionStyles.slideExiting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "portal-dropdown-items",
                className: (0, $hekY6.default)([
                    $94a12285eaa7eea3$var$styles.dropdownItems
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, portalPages?.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    key: portal?.id,
                    onClick: ()=>{
                        push(`/portal/${portal?.id}`);
                    }
                }, portal?.name)))));
            $[20] = isExpanded;
            $[21] = portalPages;
            $[22] = push;
            $[23] = t8;
        } else t8 = $[23];
        let t9;
        if ($[24] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
                appear: true
            }, t8);
            $[24] = t8;
            $[25] = t9;
        } else t9 = $[25];
        let t10;
        if ($[26] !== t7 || $[27] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: t7
            }, t9);
            $[26] = t7;
            $[27] = t9;
            $[28] = t10;
        } else t10 = $[28];
        let t11;
        if ($[29] !== t10 || $[30] !== t6) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t10);
            $[29] = t10;
            $[30] = t6;
            $[31] = t11;
        } else t11 = $[31];
        return t11;
    }
    if (hasSinglePortal) {
        let t2;
        if ($[32] !== portalPages[0]?.id || $[33] !== push) {
            t2 = ()=>{
                push(`/portal/${portalPages[0]?.id}`);
            };
            $[32] = portalPages[0]?.id;
            $[33] = push;
            $[34] = t2;
        } else t2 = $[34];
        let t3;
        if ($[35] !== textColor) {
            t3 = {
                color: textColor
            };
            $[35] = textColor;
            $[36] = t3;
        } else t3 = $[36];
        const t4 = portalPages[0]?.name;
        let t5;
        if ($[37] !== t2 || $[38] !== t3 || $[39] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                appearance: "subtle",
                onClick: t2,
                style: t3
            }, t4);
            $[37] = t2;
            $[38] = t3;
            $[39] = t4;
            $[40] = t5;
        } else t5 = $[40];
        return t5;
    }
    let t2;
    if ($[41] !== formatMessage || $[42] !== textColor) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, ...props } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portals));
        };
        $[41] = formatMessage;
        $[42] = textColor;
        $[43] = t2;
    } else t2 = $[43];
    let t3;
    if ($[44] !== formatMessage || $[45] !== isConfigurableSiteTreeEnabled || $[46] !== portalPages || $[47] !== push) {
        t3 = portalPages?.map((portal_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                key: portal_0?.id,
                onClick: ()=>{
                    push(`/portal/${portal_0?.id}`);
                },
                elemBefore: isConfigurableSiteTreeEnabled ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                    label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).pageIcon)
                })
            }, portal_0?.name));
        $[44] = formatMessage;
        $[45] = isConfigurableSiteTreeEnabled;
        $[46] = portalPages;
        $[47] = push;
        $[48] = t3;
    } else t3 = $[48];
    let t4;
    if ($[49] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t3);
        $[49] = t3;
        $[50] = t4;
    } else t4 = $[50];
    let t5;
    if ($[51] !== t2 || $[52] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t2,
            shouldRenderToParent: true
        }, t4);
        $[51] = t2;
        $[52] = t4;
        $[53] = t5;
    } else t5 = $[53];
    return t5;
} : ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const [isConfigurableSiteTreeEnabled] = (0, $4HuLY.useIsHubFeatureEnabled)([
        (0, $4HuLY.HUB_FEATURES).CONFIGURABLE_SITE_TREE
    ]);
    const data = (0, $6SsN4.useFragment)((0, $ed886607e5376318$export$2e2bcd8739ae039), queryRef);
    const portalPages = data?.portals?.portalsList;
    if (!portalPages || portalPages.length === 0) return null;
    const hasSinglePortal = portalPages.length === 1;
    if (isMobile) {
        if (hasSinglePortal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            onClick: ()=>{
                push(`/portal/${portalPages[0]?.id}`);
            }
        }, portalPages[0]?.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalDownIcon)
            }),
            onClick: ()=>setIsExpanded((prev)=>!prev),
            "aria-expanded": isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            weight: "medium"
        }, formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portals))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: (0, $hekY6.default)([
                $94a12285eaa7eea3$var$styles.overflowHidden
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
            appear: true
        }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
            enteringAnimationXcss: $94a12285eaa7eea3$var$motionStyles.slideEntering,
            exitingAnimationXcss: $94a12285eaa7eea3$var$motionStyles.slideExiting
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "portal-dropdown-items",
            className: (0, $hekY6.default)([
                $94a12285eaa7eea3$var$styles.dropdownItems
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, portalPages?.map((portal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                key: portal?.id,
                onClick: ()=>{
                    push(`/portal/${portal?.id}`);
                }
            }, portal?.name))))))));
    }
    if (hasSinglePortal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: ()=>{
            push(`/portal/${portalPages[0]?.id}`);
        },
        style: {
            color: textColor
        }
    }, portalPages[0]?.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portalDownIcon)
                }),
                ref: triggerRef
            }, formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).portals)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, portalPages?.map((portal_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: portal_0?.id,
            onClick: ()=>{
                push(`/portal/${portal_0?.id}`);
            },
            elemBefore: isConfigurableSiteTreeEnabled ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), {
                label: formatMessage((0, $d97399a84a7f3dc6$export$2e2bcd8739ae039).pageIcon)
            })
        }, portal_0?.name))));
};
function $94a12285eaa7eea3$var$_temp(prev) {
    return !prev;
}
module.exports["PortalDropdown"] = $94a12285eaa7eea3$export$32e0c0d1c2f88773;

});

parcelRegister("auieu", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6DK5X = parcelRequire("6DK5X");

const $b508a09f59ab4135$export$563ca09564aae6d5 = ()=>(0, $iDrrr.fg)('hubs_nav_visible_portals_filter') ? {
        typeFilter: [
            'VISIBLE'
        ]
    } : null;
const $b508a09f59ab4135$export$7465fb1a07d28cb3 = ({ cloudId: cloudId, featureFlags: featureFlags, helpCenterAri: helpCenterAri, hubEditMode: hubEditMode })=>{
    const isDraftModeEnabled = (0, $iDrrr.fg)('help_hubs_draft_mode') && featureFlags?.help_hubs_draft_mode === true;
    const isConfigurableSiteTreeEnabled = (0, $iDrrr.fg)('help_hubs_configurable_site_tree') && featureFlags?.help_hubs_configurable_site_tree === true;
    return {
        cloudId: cloudId,
        hubAri: helpCenterAri,
        isDraft: Boolean(hubEditMode) && isDraftModeEnabled,
        isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled,
        isHideNavMenusEnabled: (0, $6DK5X.isHideNavMenusEnabled)(),
        isTopicsEnabled: (0, $iDrrr.fg)('hubs_premium_upsell'),
        portalsFilter: $b508a09f59ab4135$export$563ca09564aae6d5()
    };
};
module.exports["getPortalsFilter"] = $b508a09f59ab4135$export$563ca09564aae6d5;
module.exports["getNavigationBarQueryVariables"] = $b508a09f59ab4135$export$7465fb1a07d28cb3;

});

parcelRegister("i4PiE", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<1c0759b364a6890ded896701bb942cb0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f4e1b1d1c8ca412d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topicDropdown_AtlassianHubAppShell",
    "selections": [
        {
            "alias": "topicPages",
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "ids": [],
                        "type": "TOPIC"
                    }
                }
            ],
            "concreteType": "HelpCenterPage",
            "kind": "LinkedField",
            "name": "pages",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "HelpCenterPageName",
                    "kind": "LinkedField",
                    "name": "name",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "default"
                        }
                    ]
                }
            ],
            "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
        }
    ],
    "type": "HelpCenter"
};
$f4e1b1d1c8ca412d$var$node.hash = "9aa0d54a463ddf69b87af168a98c5079";
var $f4e1b1d1c8ca412d$export$2e2bcd8739ae039 = $f4e1b1d1c8ca412d$var$node;



var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $7ZB0A = parcelRequire("7ZB0A");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $j6vyT = parcelRequire("j6vyT");


var $9d7Pd = parcelRequire("9d7Pd");


var $8FgJC = parcelRequire("8FgJC");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");


var $4aRua = parcelRequire("4aRua");


var $32sS3 = parcelRequire("32sS3");




const $9c7bf96141f104f4$var$messages = (0, $kSwu1.defineMessages)({
    topics: {
        id: "hub-app-shell.navbar.nav-links.topic-dropdown.topics",
        defaultMessage: "Topics"
    },
    topicDownIcon: {
        id: "hub-app-shell.navbar.nav-links.topic-dropdown.topicDownIcon",
        defaultMessage: "Open topics dropdown"
    },
    topicUpIcon: {
        id: "hub-app-shell.navbar.nav-links.topic-dropdown.topicUpIcon",
        defaultMessage: "Close topics dropdown"
    }
});
var $9c7bf96141f104f4$export$2e2bcd8739ae039 = $9c7bf96141f104f4$var$messages;


const $0b604717a3654663$var$styles = {
    overflowHidden: "_4bt5LAnQyn _2WAcuGnQyn",
    dropdownItems: "_2Zuz6Q2ADO"
};
const $0b604717a3654663$var$motionStyles = {
    slideEntering: "_1gBibyJtnr _0nFVCGLrT7 _43vdfTjwM9",
    slideExiting: "_1gBibyMmpp _0nFVCGLrT7 _43vdfTyNAO"
};
const $0b604717a3654663$var$getPageIdFromAri = (pageAri)=>{
    try {
        return (0, $32sS3.HelpPageAri).parse(pageAri).pageId;
    } catch  {
        return null;
    }
}; /**
    * The navbar's Topics menu.
    *
    * Unlike `PortalDropdown`, a single topic still renders as the `Topics` menu
    * rather than collapsing to the topic's own name: "Topics" is a category, so
    * collapsing it would put one topic's title in the navbar and reshape the nav as
    * topics come and go.
    *
    * Draft handling needs nothing here — `helpCenterById` is already resolved with
    * `isDraft`, so the parent query decides whether draft or live topics come back,
    * exactly as it does for the custom pages in `MoreDropdown`.
    */ 
const $0b604717a3654663$export$ffcc4c72ae603c4e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(40);
    const { queryRef: queryRef, textColor: textColor, isMobile: isMobile } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const data = (0, $6SsN4.useFragment)((0, $f4e1b1d1c8ca412d$export$2e2bcd8739ae039), queryRef);
    const topicPages = data?.topicPages;
    if (!(0, $iDrrr.fg)("hubs_premium_upsell") || !topicPages || topicPages.length === 0) return null;
    let t1;
    if ($[0] !== push) {
        t1 = (pageAri)=>{
            const pageId = pageAri ? $0b604717a3654663$var$getPageIdFromAri(pageAri) : null;
            if (pageId) push(`/page/${pageId}`);
        };
        $[0] = push;
        $[1] = t1;
    } else t1 = $[1];
    const openTopic = t1;
    const topicTestId = $0b604717a3654663$var$_temp;
    if (isMobile) {
        let t2;
        if ($[2] !== formatMessage || $[3] !== isExpanded) {
            t2 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
                label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicUpIcon)
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicDownIcon)
            });
            $[2] = formatMessage;
            $[3] = isExpanded;
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = ()=>setIsExpanded($0b604717a3654663$var$_temp2);
            $[5] = t3;
        } else t3 = $[5];
        let t4;
        if ($[6] !== formatMessage) {
            t4 = formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topics);
            $[6] = formatMessage;
            $[7] = t4;
        } else t4 = $[7];
        let t5;
        if ($[8] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                weight: "medium"
            }, t4);
            $[8] = t4;
            $[9] = t5;
        } else t5 = $[9];
        let t6;
        if ($[10] !== isExpanded || $[11] !== t2 || $[12] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                iconAfter: t2,
                onClick: t3,
                "aria-expanded": isExpanded
            }, t5);
            $[10] = isExpanded;
            $[11] = t2;
            $[12] = t5;
            $[13] = t6;
        } else t6 = $[13];
        let t7;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $hekY6.default)([
                $0b604717a3654663$var$styles.overflowHidden
            ]);
            $[14] = t7;
        } else t7 = $[14];
        let t8;
        if ($[15] !== isExpanded || $[16] !== openTopic || $[17] !== topicPages) {
            t8 = isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
                enteringAnimationXcss: $0b604717a3654663$var$motionStyles.slideEntering,
                exitingAnimationXcss: $0b604717a3654663$var$motionStyles.slideExiting
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "topic-dropdown-items",
                className: (0, $hekY6.default)([
                    $0b604717a3654663$var$styles.dropdownItems
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, topicPages.map((topic)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
                    key: topic?.id,
                    testId: topicTestId(topic?.id),
                    onClick: ()=>openTopic(topic?.id)
                }, topic?.name?.default ?? "")))));
            $[15] = isExpanded;
            $[16] = openTopic;
            $[17] = topicPages;
            $[18] = t8;
        } else t8 = $[18];
        let t9;
        if ($[19] !== t8) {
            t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
                appear: true
            }, t8);
            $[19] = t8;
            $[20] = t9;
        } else t9 = $[20];
        let t10;
        if ($[21] !== t7 || $[22] !== t9) {
            t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                className: t7
            }, t9);
            $[21] = t7;
            $[22] = t9;
            $[23] = t10;
        } else t10 = $[23];
        let t11;
        if ($[24] !== t10 || $[25] !== t6) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t6, t10);
            $[24] = t10;
            $[25] = t6;
            $[26] = t11;
        } else t11 = $[26];
        return t11;
    }
    let t2;
    if ($[27] !== formatMessage || $[28] !== textColor) {
        t2 = (t3)=>{
            const { triggerRef: triggerRef, ...props } = t3;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicDownIcon)
                }),
                ref: triggerRef,
                testId: "topic-dropdown-trigger"
            }, formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topics));
        };
        $[27] = formatMessage;
        $[28] = textColor;
        $[29] = t2;
    } else t2 = $[29];
    let t3;
    if ($[30] !== openTopic || $[31] !== topicPages) {
        let t4;
        if ($[33] !== openTopic) {
            t4 = (topic_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                    key: topic_0?.id,
                    testId: topicTestId(topic_0?.id),
                    onClick: ()=>openTopic(topic_0?.id)
                }, topic_0?.name?.default ?? "");
            $[33] = openTopic;
            $[34] = t4;
        } else t4 = $[34];
        t3 = topicPages.map(t4);
        $[30] = openTopic;
        $[31] = topicPages;
        $[32] = t3;
    } else t3 = $[32];
    let t4;
    if ($[35] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t3);
        $[35] = t3;
        $[36] = t4;
    } else t4 = $[36];
    let t5;
    if ($[37] !== t2 || $[38] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            trigger: t2,
            shouldRenderToParent: true
        }, t4);
        $[37] = t2;
        $[38] = t4;
        $[39] = t5;
    } else t5 = $[39];
    return t5;
} : ({ queryRef: queryRef, textColor: textColor, isMobile: isMobile })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const data = (0, $6SsN4.useFragment)((0, $f4e1b1d1c8ca412d$export$2e2bcd8739ae039), queryRef);
    const topicPages = data?.topicPages; // Nothing to open onto, so the menu stays out of the navbar entirely.
    if (!(0, $iDrrr.fg)('hubs_premium_upsell') || !topicPages || topicPages.length === 0) return null;
    const openTopic = (pageAri)=>{
        const pageId = pageAri ? $0b604717a3654663$var$getPageIdFromAri(pageAri) : null;
        if (pageId) push(`/page/${pageId}`);
    };
    const topicTestId = (pageAri_0)=>`nav-topic-page-${(pageAri_0 ? $0b604717a3654663$var$getPageIdFromAri(pageAri_0) : null) ?? ''}`;
    if (isMobile) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
        iconAfter: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j6vyT))), {
            label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicUpIcon)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicDownIcon)
        }),
        onClick: ()=>setIsExpanded((prev)=>!prev),
        "aria-expanded": isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topics))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $0b604717a3654663$var$styles.overflowHidden
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
        enteringAnimationXcss: $0b604717a3654663$var$motionStyles.slideEntering,
        exitingAnimationXcss: $0b604717a3654663$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "topic-dropdown-items",
        className: (0, $hekY6.default)([
            $0b604717a3654663$var$styles.dropdownItems
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, topicPages.map((topic)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9d7Pd.default), {
            key: topic?.id,
            testId: topicTestId(topic?.id),
            onClick: ()=>openTopic(topic?.id)
        }, topic?.name?.default ?? ''))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
                ...props,
                appearance: "subtle",
                style: {
                    color: props.isSelected ? undefined : textColor
                },
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topicDownIcon)
                }),
                ref: triggerRef,
                testId: "topic-dropdown-trigger"
            }, formatMessage((0, $9c7bf96141f104f4$export$2e2bcd8739ae039).topics)),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, topicPages.map((topic_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            key: topic_0?.id,
            testId: topicTestId(topic_0?.id),
            onClick: ()=>openTopic(topic_0?.id)
        }, topic_0?.name?.default ?? ''))));
};
function $0b604717a3654663$var$_temp(pageAri_0) {
    return `nav-topic-page-${(pageAri_0 ? $0b604717a3654663$var$getPageIdFromAri(pageAri_0) : null) ?? ""}`;
}
function $0b604717a3654663$var$_temp2(prev) {
    return !prev;
}
module.exports["TopicDropdown"] = $0b604717a3654663$export$ffcc4c72ae603c4e;

});

parcelRegister("kPBMe", function(module, exports) {

let $f2a5dfc27bbdb7ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2a5dfc27bbdb7ec$var$load("5pIPD").then(()=>parcelRequire('5B0UD'));

});

parcelRegister("5v3yH", function(module, exports) {

let $40129bb4354e8258$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $40129bb4354e8258$var$load("hNOga"),
    $40129bb4354e8258$var$load("hohnS"),
    $40129bb4354e8258$var$load("lxIZ8"),
    $40129bb4354e8258$var$load("gpUln"),
    $40129bb4354e8258$var$load("7SteV"),
    $40129bb4354e8258$var$load("2xoIF"),
    $40129bb4354e8258$var$load("ce05o"),
    $40129bb4354e8258$var$load("8Ytws"),
    $40129bb4354e8258$var$load("3Wy8Y"),
    $40129bb4354e8258$var$load("4B1vY"),
    $40129bb4354e8258$var$load("5LPcj"),
    $40129bb4354e8258$var$load("k0wQ3"),
    $40129bb4354e8258$var$load("8MjiJ"),
    $40129bb4354e8258$var$load("9V1vV"),
    $40129bb4354e8258$var$load("2F69B"),
    $40129bb4354e8258$var$load("8Bic8"),
    $40129bb4354e8258$var$load("4PCFY"),
    $40129bb4354e8258$var$load("d0ZRF"),
    $40129bb4354e8258$var$load("k507P"),
    $40129bb4354e8258$var$load("bncmK"),
    $40129bb4354e8258$var$load("5dkX4"),
    $40129bb4354e8258$var$load("cLCaE"),
    $40129bb4354e8258$var$load("KsShd"),
    $40129bb4354e8258$var$load("cGkFm"),
    $40129bb4354e8258$var$load("l4j2l"),
    $40129bb4354e8258$var$load("37v60"),
    $40129bb4354e8258$var$load("6iTkp"),
    $40129bb4354e8258$var$load("4Oj5y"),
    $40129bb4354e8258$var$load("lHX6l"),
    $40129bb4354e8258$var$load("d3PpR"),
    $40129bb4354e8258$var$load("53mVX"),
    $40129bb4354e8258$var$load("iXo3l"),
    $40129bb4354e8258$var$load("i8sPk"),
    $40129bb4354e8258$var$load("Jyh1v"),
    $40129bb4354e8258$var$load("ftNkH"),
    $40129bb4354e8258$var$load("hyCrt"),
    $40129bb4354e8258$var$load("jE0Mz"),
    $40129bb4354e8258$var$load("7EorR"),
    $40129bb4354e8258$var$load("jqoep"),
    $40129bb4354e8258$var$load("1ElkK"),
    $40129bb4354e8258$var$load("9TOep"),
    $40129bb4354e8258$var$load("gWjIZ"),
    $40129bb4354e8258$var$load("6wr18"),
    $40129bb4354e8258$var$load("bmOOW"),
    $40129bb4354e8258$var$load("dDiWc"),
    $40129bb4354e8258$var$load("hhss7"),
    $40129bb4354e8258$var$load("i6pyw"),
    $40129bb4354e8258$var$load("VXbA1"),
    $40129bb4354e8258$var$load("1yVM6"),
    $40129bb4354e8258$var$load("dxcsb"),
    $40129bb4354e8258$var$load("ffEVr"),
    $40129bb4354e8258$var$load("1NyWL"),
    $40129bb4354e8258$var$load("hy9kW")
]).then(()=>parcelRequire('88o1o'));

});

parcelRegister("aVKfT", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "93O33",
    name: "ForgeGlobalSettingsExtensionPoint",
    loader: async ()=>(await (parcelRequire("a9FjG"))).GlobalSettings
});
module.exports["ForgeGlobalSettingsExtensionPoint"] = $c1cdb40c21dd0ca3$export$6e2f6a8db94682b4;

});

parcelRegister("a9FjG", function(module, exports) {

let $764acb37d8e5f7c9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $764acb37d8e5f7c9$var$load("c6fAG").then(()=>parcelRequire('jOztW'));

});

parcelRegister("imDYW", function(module, exports) {

let $d5e94ba94ae41f5b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5e94ba94ae41f5b$var$load("iVLHX").then(()=>parcelRequire('7DYe9'));

});

parcelRegister("aF1vZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $47940fef216e9562$export$2709da4acd7d0aec = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Q3Ruy",
    name: "AdvancedSearch",
    loader: async ()=>(await (parcelRequire("bNevr"))).AdvancedSearch
});
module.exports["AdvancedSearch"] = $47940fef216e9562$export$2709da4acd7d0aec;

});

parcelRegister("bNevr", function(module, exports) {

let $895f85eae613ddfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $895f85eae613ddfa$var$load("7JO34"),
    $895f85eae613ddfa$var$load("jE0Mz"),
    $895f85eae613ddfa$var$load("5PKbS"),
    $895f85eae613ddfa$var$load("hUbK8"),
    $895f85eae613ddfa$var$load("giRB9"),
    $895f85eae613ddfa$var$load("kGZ8W"),
    $895f85eae613ddfa$var$load("8yk9S"),
    $895f85eae613ddfa$var$load("5KHgm"),
    $895f85eae613ddfa$var$load("211bN"),
    $895f85eae613ddfa$var$load("hRiI8"),
    $895f85eae613ddfa$var$load("bRoHi"),
    $895f85eae613ddfa$var$load("eaGQ3"),
    $895f85eae613ddfa$var$load("hoo42"),
    $895f85eae613ddfa$var$load("3Whaz"),
    $895f85eae613ddfa$var$load("lPKve"),
    $895f85eae613ddfa$var$load("aUXrB"),
    $895f85eae613ddfa$var$load("esBxc"),
    $895f85eae613ddfa$var$load("3pbEq"),
    $895f85eae613ddfa$var$load("hZsD1"),
    $895f85eae613ddfa$var$load("15jTz"),
    $895f85eae613ddfa$var$load("48F3z"),
    $895f85eae613ddfa$var$load("7SteV"),
    $895f85eae613ddfa$var$load("hyCrt"),
    $895f85eae613ddfa$var$load("1AybA"),
    $895f85eae613ddfa$var$load("jqoep"),
    $895f85eae613ddfa$var$load("44XW6"),
    $895f85eae613ddfa$var$load("dxA9F"),
    $895f85eae613ddfa$var$load("bkMxV"),
    $895f85eae613ddfa$var$load("aRCaA"),
    $895f85eae613ddfa$var$load("h3Rq9"),
    $895f85eae613ddfa$var$load("kfGHh"),
    $895f85eae613ddfa$var$load("lIiD7"),
    $895f85eae613ddfa$var$load("dqLHj"),
    $895f85eae613ddfa$var$load("g2wVX"),
    $895f85eae613ddfa$var$load("cIoRg"),
    $895f85eae613ddfa$var$load("g7vSH"),
    $895f85eae613ddfa$var$load("ea3NB"),
    $895f85eae613ddfa$var$load("dxcsb"),
    $895f85eae613ddfa$var$load("gQrOI"),
    $895f85eae613ddfa$var$load("6wr18"),
    $895f85eae613ddfa$var$load("59hV4"),
    $895f85eae613ddfa$var$load("l4j2l"),
    $895f85eae613ddfa$var$load("37v60"),
    $895f85eae613ddfa$var$load("ffEVr"),
    $895f85eae613ddfa$var$load("2xoIF"),
    $895f85eae613ddfa$var$load("do0Fh"),
    $895f85eae613ddfa$var$load("cGkFm"),
    $895f85eae613ddfa$var$load("eF92L"),
    $895f85eae613ddfa$var$load("jwMHX"),
    $895f85eae613ddfa$var$load("ckVWI"),
    $895f85eae613ddfa$var$load("bmOOW"),
    $895f85eae613ddfa$var$load("dDiWc"),
    $895f85eae613ddfa$var$load("d0ZRF"),
    $895f85eae613ddfa$var$load("k507P"),
    $895f85eae613ddfa$var$load("9TOep"),
    $895f85eae613ddfa$var$load("bncmK"),
    $895f85eae613ddfa$var$load("6iTkp"),
    $895f85eae613ddfa$var$load("hhss7"),
    $895f85eae613ddfa$var$load("aAWLw"),
    $895f85eae613ddfa$var$load("7EorR"),
    $895f85eae613ddfa$var$load("mK22p")
]).then(()=>parcelRequire('luNAU'));

});

parcelRegister("fxOEJ", function(module, exports) {

let $b5113b5290702959$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b5113b5290702959$var$load("d3PpR"),
    $b5113b5290702959$var$load("bAgF6"),
    $b5113b5290702959$var$load("hnpcA"),
    $b5113b5290702959$var$load("hDfPU")
]).then(()=>parcelRequire('2mD8T'));

});

parcelRegister("9FEPa", function(module, exports) {

var $lmggZ = parcelRequire("lmggZ");


var $1lO7z = parcelRequire("1lO7z");


var $f14Rr = parcelRequire("f14Rr");


var $1i7uI = parcelRequire("1i7uI");

const $dc5b931ac8650fb5$export$d17bd3fb4432c2eb = (a, b)=>{
    // lodash reduce can reduce over objects, not just arrays
    /* istanbul ignore next */ const results = (0, (/*@__PURE__*/$parcel$interopDefault($lmggZ)))(a, (result, value, key)=>value === b[key] ? result : result.concat([
            `Prop name: '${key}'`,
            '1:',
            value,
            '2:',
            b[key]
        ], '=========='), []);
    /* istanbul ignore next */ if (!results || results.length === 0) return 'No change!';
    return results;
};
const $dc5b931ac8650fb5$export$2225b4c39d37f8b3 = (obj1, obj2, omitProps = [])=>{
    if (obj1 === obj2) return true;
    const allKeys = (0, (/*@__PURE__*/$parcel$interopDefault($1lO7z)))((0, (/*@__PURE__*/$parcel$interopDefault($f14Rr)))(obj1), (0, (/*@__PURE__*/$parcel$interopDefault($f14Rr)))(obj2));
    for (const key of allKeys){
        if (omitProps.indexOf(key) >= 0) continue;
        if (obj1[key] !== obj2[key]) return false;
    }
    return true;
};
const $dc5b931ac8650fb5$export$e3a9c512dde3781c = (name)=>{};
const $dc5b931ac8650fb5$export$1b1e26e4583cf9d2 = (names)=>{};
const $dc5b931ac8650fb5$export$948fe58907adae7d = (markA, markB)=>{
    return 'N/A';
};
const $dc5b931ac8650fb5$export$76909ea6fcdbea03 = (name, markA, markB)=>{};
const $dc5b931ac8650fb5$export$34e34130f1d9d12c = (mark)=>{
    return 'N/A';
};
const $dc5b931ac8650fb5$export$a1e5925b5910cb4 = (mark)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance) return;
    (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance.mark(mark);
};
module.exports["performanceMarkInProd"] = $dc5b931ac8650fb5$export$a1e5925b5910cb4;

});

parcelRegister("lmggZ", function(module, exports) {

var $1XwR6 = parcelRequire("1XwR6");


var $bNHBU = parcelRequire("bNHBU");


var $j6gAQ = parcelRequire("j6gAQ");


var $cQ8Hi = parcelRequire("cQ8Hi");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $f8c846851f588b54$var$reduce(collection, iteratee, accumulator) {
    var func = $1ScXu(collection) ? $1XwR6 : $cQ8Hi, initAccum = arguments.length < 3;
    return func(collection, $j6gAQ(iteratee, 4), accumulator, initAccum, $bNHBU);
}
module.exports = $f8c846851f588b54$var$reduce;

});

parcelRegister("bNHBU", function(module, exports) {

var $lFjE5 = parcelRequire("lFjE5");


var $923lQ = parcelRequire("923lQ");

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $8976196cdeddb1dc$var$baseEach = $923lQ($lFjE5);
module.exports = $8976196cdeddb1dc$var$baseEach;

});

parcelRegister("lFjE5", function(module, exports) {

var $comu1 = parcelRequire("comu1");


var $f14Rr = parcelRequire("f14Rr");

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $fc5caa85fb423e25$var$baseForOwn(object, iteratee) {
    return object && $comu1(object, iteratee, $f14Rr);
}
module.exports = $fc5caa85fb423e25$var$baseForOwn;

});

parcelRegister("923lQ", function(module, exports) {

var $9pMwd = parcelRequire("9pMwd");

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $6936e67b6e4d0605$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$9pMwd(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $6936e67b6e4d0605$var$createBaseEach;

});

parcelRegister("cQ8Hi", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $9591167375c6fe4f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $9591167375c6fe4f$var$baseReduce;

});

parcelRegister("1lO7z", function(module, exports) {

var $avFJ9 = parcelRequire("avFJ9");


var $kxLmQ = parcelRequire("kxLmQ");


var $1Rned = parcelRequire("1Rned");


var $5RsFr = parcelRequire("5RsFr");

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $0fbea1a47b097dd2$var$union = $kxLmQ(function(arrays) {
    return $1Rned($avFJ9(arrays, 1, $5RsFr, true));
});
module.exports = $0fbea1a47b097dd2$var$union;

});

parcelRegister("lSd9S", function(module, exports) {

let $fec8d915ac2b7d55$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fec8d915ac2b7d55$var$load("dMWJp").then(()=>parcelRequire('eTW2b'));

});

parcelRegister("dOgQ2", function(module, exports) {

let $a0dd01a080c82fb8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0dd01a080c82fb8$var$load("amygy").then(()=>parcelRequire('iMfxO'));

});

parcelRegister("4R1NE", function(module, exports) {

let $388d82142afdec54$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $388d82142afdec54$var$load("erzsl"),
    $388d82142afdec54$var$load("arG0U"),
    $388d82142afdec54$var$load("jnr1d"),
    $388d82142afdec54$var$load("9YlTA"),
    $388d82142afdec54$var$load("bRqDI"),
    $388d82142afdec54$var$load("fufmI"),
    $388d82142afdec54$var$load("e9OWm"),
    $388d82142afdec54$var$load("LWh5V"),
    $388d82142afdec54$var$load("6XCf4"),
    $388d82142afdec54$var$load("gWjIZ"),
    $388d82142afdec54$var$load("8SLfD"),
    $388d82142afdec54$var$load("6xN9r"),
    $388d82142afdec54$var$load("1yVM6"),
    $388d82142afdec54$var$load("1inbB"),
    $388d82142afdec54$var$load("efUj2"),
    $388d82142afdec54$var$load("l0dd5"),
    $388d82142afdec54$var$load("dbQ5m"),
    $388d82142afdec54$var$load("4fYzp"),
    $388d82142afdec54$var$load("bm0oR"),
    $388d82142afdec54$var$load("1GCFv"),
    $388d82142afdec54$var$load("3eyRH"),
    $388d82142afdec54$var$load("h4Nf7"),
    $388d82142afdec54$var$load("3Whaz"),
    $388d82142afdec54$var$load("15jTz"),
    $388d82142afdec54$var$load("48F3z"),
    $388d82142afdec54$var$load("fuOfV"),
    $388d82142afdec54$var$load("jL1Ke"),
    $388d82142afdec54$var$load("5MQ0D"),
    $388d82142afdec54$var$load("cIoRg"),
    $388d82142afdec54$var$load("g7vSH"),
    $388d82142afdec54$var$load("ea3NB"),
    $388d82142afdec54$var$load("6wr18"),
    $388d82142afdec54$var$load("59hV4"),
    $388d82142afdec54$var$load("hhss7"),
    $388d82142afdec54$var$load("excC5"),
    $388d82142afdec54$var$load("fwbNS"),
    $388d82142afdec54$var$load("d0ZRF"),
    $388d82142afdec54$var$load("k507P"),
    $388d82142afdec54$var$load("9TOep"),
    $388d82142afdec54$var$load("bncmK"),
    $388d82142afdec54$var$load("7EorR"),
    $388d82142afdec54$var$load("hA2SB"),
    $388d82142afdec54$var$load("4Scjl"),
    $388d82142afdec54$var$load("ffEVr"),
    $388d82142afdec54$var$load("6ExNy")
]).then(()=>parcelRequire('iIJIO'));

});

parcelRegister("agglT", function(module, exports) {
var $585d52ec7db54bb4$export$e0a694ad492b37fe = /*#__PURE__*/ function(CompanyHubSettingsPageTabsType) {
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["GENERAL"] = 0] = "GENERAL";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["ANALYTICS"] = 1] = "ANALYTICS";
    CompanyHubSettingsPageTabsType[CompanyHubSettingsPageTabsType["USERS"] = 2] = "USERS";
    return CompanyHubSettingsPageTabsType;
}({});
module.exports["CompanyHubSettingsPageTabsType"] = $585d52ec7db54bb4$export$e0a694ad492b37fe;

});

parcelRegister("eXz7x", function(module, exports) {

let $ae41d194d669099b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ae41d194d669099b$var$load("fJvLh"),
    $ae41d194d669099b$var$load("aOUZr"),
    $ae41d194d669099b$var$load("6wr18"),
    $ae41d194d669099b$var$load("iLqgZ"),
    $ae41d194d669099b$var$load("kwgtb"),
    $ae41d194d669099b$var$load("49rXL"),
    $ae41d194d669099b$var$load("4RHRd"),
    $ae41d194d669099b$var$load("FJgmQ"),
    $ae41d194d669099b$var$load("4fYzp"),
    $ae41d194d669099b$var$load("30iG7"),
    $ae41d194d669099b$var$load("efUj2"),
    $ae41d194d669099b$var$load("7EorR"),
    $ae41d194d669099b$var$load("ffEVr"),
    $ae41d194d669099b$var$load("1fLz7")
]).then(()=>parcelRequire('eBAks'));

});

parcelRegister("iquRY", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $24WXz = parcelRequire("24WXz");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $cccaa992351fdb79$export$dcac763621aee435 = ()=>{
    const $ = (0, $bDgLe.c)(9);
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const t1 = !isLoggedIn;
    let t2;
    if ($[2] !== t0 || $[3] !== t1) {
        t2 = {
            variables: t0,
            skip: t1,
            onError: $cccaa992351fdb79$var$_temp
        };
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $24WXz.default), {
        ...t2,
        __callerPackage__: "space-utils"
    });
    const isNotPreRoles = data?.confluence_spaceRoleMode ? data.confluence_spaceRoleMode !== "PRE_ROLES" : false;
    const t3 = data?.confluence_spaceRoleMode;
    let t4;
    if ($[5] !== isNotPreRoles || $[6] !== loading || $[7] !== t3) {
        t4 = {
            spaceRoleMode: t3,
            isRbacEnabled: isNotPreRoles,
            loading: loading
        };
        $[5] = isNotPreRoles;
        $[6] = loading;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
function $cccaa992351fdb79$var$_temp(error) {
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
}
module.exports["useSpaceRoleMode"] = $cccaa992351fdb79$export$dcac763621aee435;

});

parcelRegister("24WXz", function(module, exports) {
/**
 * @generated SignedSource<<2ff02ee1cce578f61d9a435abf2def2c>>
 * @relayHash 60ed41889a4cd98154a0419dcf1f59f5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82
const $016cc5cc0310f39a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_spaceRoleMode"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceRoleModeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "60ed41889a4cd98154a0419dcf1f59f5",
            "id": "568a16c2dadb6c51097438a074053eda35e4744d08b20d0f79c582acba061e82",
            "metadata": {},
            "name": "useSpaceRoleModeQuery",
            "operationKind": "query",
            "text": "query useSpaceRoleModeQuery($cloudId:ID!){confluence_spaceRoleMode(cloudId:$cloudId)}"
        }
    };
}();
$016cc5cc0310f39a$var$node.hash = "88c4ae8983cc6692099b2b1e1d7a4379";
var $016cc5cc0310f39a$export$2e2bcd8739ae039 = $016cc5cc0310f39a$var$node;
module.exports["default"] = $016cc5cc0310f39a$export$2e2bcd8739ae039;

});

parcelRegister("6ZGi9", function(module, exports) {

let $51793ed42738224f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $51793ed42738224f$var$load("jGTjO"),
    $51793ed42738224f$var$load("cpYhM"),
    $51793ed42738224f$var$load("6wKNt"),
    $51793ed42738224f$var$load("fJvLh"),
    $51793ed42738224f$var$load("dbQ5m"),
    $51793ed42738224f$var$load("bm0oR"),
    $51793ed42738224f$var$load("c831e"),
    $51793ed42738224f$var$load("1GCFv"),
    $51793ed42738224f$var$load("iOfkQ"),
    $51793ed42738224f$var$load("2NFUs"),
    $51793ed42738224f$var$load("8qpwN"),
    $51793ed42738224f$var$load("efUj2"),
    $51793ed42738224f$var$load("6wr18"),
    $51793ed42738224f$var$load("6xN9r"),
    $51793ed42738224f$var$load("bRqDI"),
    $51793ed42738224f$var$load("fufmI"),
    $51793ed42738224f$var$load("e9OWm"),
    $51793ed42738224f$var$load("LWh5V"),
    $51793ed42738224f$var$load("4fYzp"),
    $51793ed42738224f$var$load("6XCf4"),
    $51793ed42738224f$var$load("7EorR"),
    $51793ed42738224f$var$load("gWjIZ"),
    $51793ed42738224f$var$load("8SLfD"),
    $51793ed42738224f$var$load("1yVM6"),
    $51793ed42738224f$var$load("2xKrc"),
    $51793ed42738224f$var$load("ffEVr"),
    $51793ed42738224f$var$load("7DSUW")
]).then(()=>parcelRequire('54mQG'));

});

parcelRegister("5R2Ic", function(module, exports) {

let $4434017fa2bffe9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4434017fa2bffe9b$var$load("fJvLh"),
    $4434017fa2bffe9b$var$load("cLCaE"),
    $4434017fa2bffe9b$var$load("6wr18"),
    $4434017fa2bffe9b$var$load("3yZPW"),
    $4434017fa2bffe9b$var$load("at3xi"),
    $4434017fa2bffe9b$var$load("jGTjO"),
    $4434017fa2bffe9b$var$load("2fgvC"),
    $4434017fa2bffe9b$var$load("4fYzp"),
    $4434017fa2bffe9b$var$load("c831e"),
    $4434017fa2bffe9b$var$load("iOfkQ"),
    $4434017fa2bffe9b$var$load("2NFUs"),
    $4434017fa2bffe9b$var$load("w3Gc8"),
    $4434017fa2bffe9b$var$load("h2QcJ"),
    $4434017fa2bffe9b$var$load("kUuw5"),
    $4434017fa2bffe9b$var$load("iN26T"),
    $4434017fa2bffe9b$var$load("efUj2"),
    $4434017fa2bffe9b$var$load("llcQo"),
    $4434017fa2bffe9b$var$load("amPsT"),
    $4434017fa2bffe9b$var$load("6XCf4"),
    $4434017fa2bffe9b$var$load("gWjIZ"),
    $4434017fa2bffe9b$var$load("9TOep"),
    $4434017fa2bffe9b$var$load("hhss7"),
    $4434017fa2bffe9b$var$load("bU3dV"),
    $4434017fa2bffe9b$var$load("1yVM6"),
    $4434017fa2bffe9b$var$load("7EorR"),
    $4434017fa2bffe9b$var$load("kBatH"),
    $4434017fa2bffe9b$var$load("ffEVr"),
    $4434017fa2bffe9b$var$load("96X3r")
]).then(()=>parcelRequire('9FcLT'));

});

parcelRegister("fna4p", function(module, exports) {

let $b310d0b784013623$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b310d0b784013623$var$load("6wr18"),
    $b310d0b784013623$var$load("dbQ5m"),
    $b310d0b784013623$var$load("bm0oR"),
    $b310d0b784013623$var$load("ffEVr"),
    $b310d0b784013623$var$load("7EorR"),
    $b310d0b784013623$var$load("coGVA"),
    $b310d0b784013623$var$load("RI3SR"),
    $b310d0b784013623$var$load("5ZaO3")
]).then(()=>parcelRequire('dpLKi'));

});

parcelRegister("9cEOX", function(module, exports) {

let $6b34e6374c09244a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6b34e6374c09244a$var$load("lRwjQ"),
    $6b34e6374c09244a$var$load("iIfud")
]).then(()=>parcelRequire('fi3dY'));

});

parcelRegister("dDPgH", function(module, exports) {

let $9ee6afae76b7b2be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9ee6afae76b7b2be$var$load("6wr18"),
    $9ee6afae76b7b2be$var$load("l0dd5"),
    $9ee6afae76b7b2be$var$load("efUj2"),
    $9ee6afae76b7b2be$var$load("7EorR"),
    $9ee6afae76b7b2be$var$load("ffEVr"),
    $9ee6afae76b7b2be$var$load("4uUio")
]).then(()=>parcelRequire('ayZRr'));

});

parcelRegister("g6l3K", function(module, exports) {

let $bb8d8ad87b6dc778$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bb8d8ad87b6dc778$var$load("d3PpR"),
    $bb8d8ad87b6dc778$var$load("6TLS9"),
    $bb8d8ad87b6dc778$var$load("2xoIF"),
    $bb8d8ad87b6dc778$var$load("ce05o"),
    $bb8d8ad87b6dc778$var$load("12TnU"),
    $bb8d8ad87b6dc778$var$load("3Wy8Y"),
    $bb8d8ad87b6dc778$var$load("4B1vY"),
    $bb8d8ad87b6dc778$var$load("hNOga"),
    $bb8d8ad87b6dc778$var$load("hVmYa"),
    $bb8d8ad87b6dc778$var$load("cEJvh"),
    $bb8d8ad87b6dc778$var$load("k0wQ3"),
    $bb8d8ad87b6dc778$var$load("8MjiJ"),
    $bb8d8ad87b6dc778$var$load("8PJsv"),
    $bb8d8ad87b6dc778$var$load("bncmK"),
    $bb8d8ad87b6dc778$var$load("5dkX4"),
    $bb8d8ad87b6dc778$var$load("cLCaE"),
    $bb8d8ad87b6dc778$var$load("KsShd"),
    $bb8d8ad87b6dc778$var$load("dlm6q"),
    $bb8d8ad87b6dc778$var$load("kFE08"),
    $bb8d8ad87b6dc778$var$load("knUU4"),
    $bb8d8ad87b6dc778$var$load("aQJUV"),
    $bb8d8ad87b6dc778$var$load("jD3c3"),
    $bb8d8ad87b6dc778$var$load("lHX6l"),
    $bb8d8ad87b6dc778$var$load("7Y0AX"),
    $bb8d8ad87b6dc778$var$load("1GCFv"),
    $bb8d8ad87b6dc778$var$load("cJsay"),
    $bb8d8ad87b6dc778$var$load("i8sPk"),
    $bb8d8ad87b6dc778$var$load("jqoep"),
    $bb8d8ad87b6dc778$var$load("TIXGP"),
    $bb8d8ad87b6dc778$var$load("44XW6"),
    $bb8d8ad87b6dc778$var$load("eF92L"),
    $bb8d8ad87b6dc778$var$load("jwMHX"),
    $bb8d8ad87b6dc778$var$load("d0ZRF"),
    $bb8d8ad87b6dc778$var$load("k507P"),
    $bb8d8ad87b6dc778$var$load("6iTkp"),
    $bb8d8ad87b6dc778$var$load("6wr18"),
    $bb8d8ad87b6dc778$var$load("16bOI"),
    $bb8d8ad87b6dc778$var$load("2be0t"),
    $bb8d8ad87b6dc778$var$load("7SteV"),
    $bb8d8ad87b6dc778$var$load("jE0Mz"),
    $bb8d8ad87b6dc778$var$load("1AybA"),
    $bb8d8ad87b6dc778$var$load("9TOep"),
    $bb8d8ad87b6dc778$var$load("dxcsb"),
    $bb8d8ad87b6dc778$var$load("cGkFm"),
    $bb8d8ad87b6dc778$var$load("8iu3F"),
    $bb8d8ad87b6dc778$var$load("hhss7"),
    $bb8d8ad87b6dc778$var$load("7EorR"),
    $bb8d8ad87b6dc778$var$load("1gUNx"),
    $bb8d8ad87b6dc778$var$load("ffEVr"),
    $bb8d8ad87b6dc778$var$load("1NyWL"),
    $bb8d8ad87b6dc778$var$load("27cgC")
]).then(()=>parcelRequire('fp8N8'));

});

parcelRegister("4Yv1J", function(module, exports) {
$parcel$export(module.exports, "ContentExtensionsProvider", () => (parcelRequire("f5aR2")).ContentExtensionsProvider);

var $f5aR2 = parcelRequire("f5aR2");


});

parcelRegister("f5aR2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7okiz = parcelRequire("7okiz");


var $69aHU = parcelRequire("69aHU");


var $hFueH = parcelRequire("hFueH");


var $hMRhJ = parcelRequire("hMRhJ");


const $cc34c55db5a1bcbb$var$getLegacyContentExtensions = ()=>({
        loadSortableTable: ()=>(parcelRequire("b0g2B"))
    });
const $cc34c55db5a1bcbb$var$providers = {
    getExtensionHandlers: $7okiz.getExtensionHandlers,
    getLegacyContentExtensions: $cc34c55db5a1bcbb$var$getLegacyContentExtensions,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    EditorLoaderLoader: $hFueH.default
};
const $cc34c55db5a1bcbb$export$2a88d3b468decd4a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: $cc34c55db5a1bcbb$var$providers
    }, children);
module.exports["ContentExtensionsProvider"] = $cc34c55db5a1bcbb$export$2a88d3b468decd4a;

});

parcelRegister("b0g2B", function(module, exports) {

let $802c233669065fa8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $802c233669065fa8$var$load("kuPgl").then(()=>parcelRequire('5byen'));

});

parcelRegister("crTA1", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("iqZzD")).default);

var $iqZzD = parcelRequire("iqZzD");


});

parcelRegister("iqZzD", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ba6afbc5717c4a$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $iqPBi = parcelRequire("iqPBi");

var $d6ba6afbc5717c4a$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPBi.SpaceBase), props);
};

});

parcelRegister("3anUZ", function(module, exports) {

let $24e4dbebbe8d7087$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $24e4dbebbe8d7087$var$load("kGZ8W"),
    $24e4dbebbe8d7087$var$load("ik9rg")
]).then(()=>parcelRequire('dg3UC'));

});

parcelRegister("eKukX", function(module, exports) {

let $abcce4d8fd6bfe4b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $abcce4d8fd6bfe4b$var$load("4RHRd"),
    $abcce4d8fd6bfe4b$var$load("gUrlb"),
    $abcce4d8fd6bfe4b$var$load("FJgmQ"),
    $abcce4d8fd6bfe4b$var$load("j3lvX"),
    $abcce4d8fd6bfe4b$var$load("1F9i1"),
    $abcce4d8fd6bfe4b$var$load("6wr18"),
    $abcce4d8fd6bfe4b$var$load("lAllw"),
    $abcce4d8fd6bfe4b$var$load("bm0oR"),
    $abcce4d8fd6bfe4b$var$load("9j2vN"),
    $abcce4d8fd6bfe4b$var$load("iy0x4"),
    $abcce4d8fd6bfe4b$var$load("hG5oc"),
    $abcce4d8fd6bfe4b$var$load("fK7gg"),
    $abcce4d8fd6bfe4b$var$load("av0nn"),
    $abcce4d8fd6bfe4b$var$load("3VBIf"),
    $abcce4d8fd6bfe4b$var$load("efUj2"),
    $abcce4d8fd6bfe4b$var$load("81e2B"),
    $abcce4d8fd6bfe4b$var$load("i0Zk0"),
    $abcce4d8fd6bfe4b$var$load("gWjIZ"),
    $abcce4d8fd6bfe4b$var$load("7EorR"),
    $abcce4d8fd6bfe4b$var$load("ffEVr"),
    $abcce4d8fd6bfe4b$var$load("hKiFG"),
    $abcce4d8fd6bfe4b$var$load("eVJyV")
]).then(()=>parcelRequire('9yrtR'));

});

parcelRegister("d6uSg", function(module, exports) {

let $98a3c8e73ead0721$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $98a3c8e73ead0721$var$load("fJvLh"),
    $98a3c8e73ead0721$var$load("6unZM")
]).then(()=>parcelRequire('c0oNl'));

});

parcelRegister("7oqPI", function(module, exports) {

let $561f96cd2cf3d537$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $561f96cd2cf3d537$var$load("7UdVV").then(()=>parcelRequire('kCK7c'));

});

parcelRegister("anIt2", function(module, exports) {

let $78ee8bac1cbfe29b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $78ee8bac1cbfe29b$var$load("ge3AN").then(()=>parcelRequire('iiG61'));

});

parcelRegister("bNraL", function(module, exports) {

let $8969593ec3262c58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8969593ec3262c58$var$load("8prF9").then(()=>parcelRequire('aJ0Cr'));

});

parcelRegister("5UYZp", function(module, exports) {

let $44f17dee5634ac42$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $44f17dee5634ac42$var$load("6wr18"),
    $44f17dee5634ac42$var$load("fJvLh"),
    $44f17dee5634ac42$var$load("4fYzp"),
    $44f17dee5634ac42$var$load("8qpwN"),
    $44f17dee5634ac42$var$load("ffEVr"),
    $44f17dee5634ac42$var$load("2xKrc"),
    $44f17dee5634ac42$var$load("aIuOE")
]).then(()=>parcelRequire('56n4X'));

});

parcelRegister("6NpxL", function(module, exports) {

let $4f2b221de9aded3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4f2b221de9aded3d$var$load("fV7Cf").then(()=>parcelRequire('gkSJt'));

});

parcelRegister("6fbdJ", function(module, exports) {

let $48bcd8edf98e3b82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $48bcd8edf98e3b82$var$load("fJvLh"),
    $48bcd8edf98e3b82$var$load("53mVX"),
    $48bcd8edf98e3b82$var$load("jE0Mz"),
    $48bcd8edf98e3b82$var$load("6wr18"),
    $48bcd8edf98e3b82$var$load("eMHGR"),
    $48bcd8edf98e3b82$var$load("vYEMr"),
    $48bcd8edf98e3b82$var$load("eMviP"),
    $48bcd8edf98e3b82$var$load("6XCf4"),
    $48bcd8edf98e3b82$var$load("hSDwk"),
    $48bcd8edf98e3b82$var$load("d3PpR"),
    $48bcd8edf98e3b82$var$load("5qdFt"),
    $48bcd8edf98e3b82$var$load("jEGYW"),
    $48bcd8edf98e3b82$var$load("9PRTA"),
    $48bcd8edf98e3b82$var$load("2wboY"),
    $48bcd8edf98e3b82$var$load("6TqFw"),
    $48bcd8edf98e3b82$var$load("ELJez"),
    $48bcd8edf98e3b82$var$load("j5wpJ"),
    $48bcd8edf98e3b82$var$load("jFbCQ"),
    $48bcd8edf98e3b82$var$load("6rYhz"),
    $48bcd8edf98e3b82$var$load("jNdu9"),
    $48bcd8edf98e3b82$var$load("7SteV"),
    $48bcd8edf98e3b82$var$load("Msrsx"),
    $48bcd8edf98e3b82$var$load("211bN"),
    $48bcd8edf98e3b82$var$load("bajKf"),
    $48bcd8edf98e3b82$var$load("4XkVJ"),
    $48bcd8edf98e3b82$var$load("2j57H"),
    $48bcd8edf98e3b82$var$load("lPKve"),
    $48bcd8edf98e3b82$var$load("jw3eS"),
    $48bcd8edf98e3b82$var$load("1lfcO"),
    $48bcd8edf98e3b82$var$load("4U6x6"),
    $48bcd8edf98e3b82$var$load("d8cdR"),
    $48bcd8edf98e3b82$var$load("4bu4H"),
    $48bcd8edf98e3b82$var$load("hyCrt"),
    $48bcd8edf98e3b82$var$load("jqoep"),
    $48bcd8edf98e3b82$var$load("44XW6"),
    $48bcd8edf98e3b82$var$load("7EorR"),
    $48bcd8edf98e3b82$var$load("4ZTRc"),
    $48bcd8edf98e3b82$var$load("kDdlJ"),
    $48bcd8edf98e3b82$var$load("fBohe"),
    $48bcd8edf98e3b82$var$load("8iGBb"),
    $48bcd8edf98e3b82$var$load("cfsnG"),
    $48bcd8edf98e3b82$var$load("11hpF"),
    $48bcd8edf98e3b82$var$load("eMRD3"),
    $48bcd8edf98e3b82$var$load("gWjIZ"),
    $48bcd8edf98e3b82$var$load("VXbA1"),
    $48bcd8edf98e3b82$var$load("1yVM6"),
    $48bcd8edf98e3b82$var$load("fHVVl"),
    $48bcd8edf98e3b82$var$load("ffEVr"),
    $48bcd8edf98e3b82$var$load("dxcsb"),
    $48bcd8edf98e3b82$var$load("7UvpM")
]).then(()=>parcelRequire('hQDgX'));

});

parcelRegister("7s77i", function(module, exports) {

let $56d0ab230c5260d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $56d0ab230c5260d9$var$load("6wr18"),
    $56d0ab230c5260d9$var$load("fJvLh"),
    $56d0ab230c5260d9$var$load("4fYzp"),
    $56d0ab230c5260d9$var$load("8qpwN"),
    $56d0ab230c5260d9$var$load("ffEVr"),
    $56d0ab230c5260d9$var$load("2xKrc"),
    $56d0ab230c5260d9$var$load("dezv5")
]).then(()=>parcelRequire('hD4yV'));

});

parcelRegister("dDcra", function(module, exports) {

let $9ec890a72f5e8d23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9ec890a72f5e8d23$var$load("LWh5V"),
    $9ec890a72f5e8d23$var$load("i8sPk"),
    $9ec890a72f5e8d23$var$load("6wr18"),
    $9ec890a72f5e8d23$var$load("cAbXt"),
    $9ec890a72f5e8d23$var$load("hTUa8"),
    $9ec890a72f5e8d23$var$load("1X4na"),
    $9ec890a72f5e8d23$var$load("ffEVr"),
    $9ec890a72f5e8d23$var$load("2eiOk")
]).then(()=>parcelRequire('do0K0'));

});

parcelRegister("a2qY6", function(module, exports) {

let $74ef02a42450f702$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $74ef02a42450f702$var$load("TIXGP"),
    $74ef02a42450f702$var$load("6wr18"),
    $74ef02a42450f702$var$load("jbxCW"),
    $74ef02a42450f702$var$load("k6TzV"),
    $74ef02a42450f702$var$load("2bJoN"),
    $74ef02a42450f702$var$load("ffEVr"),
    $74ef02a42450f702$var$load("8GFi1"),
    $74ef02a42450f702$var$load("3dSbb"),
    $74ef02a42450f702$var$load("e1OlX"),
    $74ef02a42450f702$var$load("2gN4E"),
    $74ef02a42450f702$var$load("c1IkM"),
    $74ef02a42450f702$var$load("dxKHc"),
    $74ef02a42450f702$var$load("i8lZ0"),
    $74ef02a42450f702$var$load("iDrFi"),
    $74ef02a42450f702$var$load("15nOL")
]).then(()=>parcelRequire('kI3Qk'));

});

parcelRegister("knHrR", function(module, exports) {

let $ed67a897b71e5a1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ed67a897b71e5a1a$var$load("EEHCI").then(()=>parcelRequire('dtJ3H'));

});

parcelRegister("8VPuN", function(module, exports) {

let $680b97922621c20d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $680b97922621c20d$var$load("gABRh").then(()=>parcelRequire('3JgtQ'));

});

parcelRegister("bDjCi", function(module, exports) {
$parcel$export(module.exports, "LazyHomepageCard", () => (parcelRequire("hQIJk")).LazyHomepageCard);
$parcel$export(module.exports, "LazyTeamCalendarSiteSettingsPage", () => (parcelRequire("eHqQb")).LazyTeamCalendarSiteSettingsPage);
$parcel$export(module.exports, "ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE", () => (parcelRequire("e8WZK")).ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE);
$parcel$export(module.exports, "CALENDAR_CONTEXT", () => (parcelRequire("ltKTq")).CALENDAR_CONTEXT);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $jmjWc = parcelRequire("jmjWc");


var $hQIJk = parcelRequire("hQIJk");


var $eHqQb = parcelRequire("eHqQb");


var $e8WZK = parcelRequire("e8WZK");


var $ltKTq = parcelRequire("ltKTq");


const $0fe83f4fb6168025$export$666c7163d0ae1b3f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UHi5n",
    name: "LazyTeamCalendars",
    loader: async ()=>(await (parcelRequire("jU8FT"))).TeamCalendar
});
module.exports["LazyTeamCalendars"] = $0fe83f4fb6168025$export$666c7163d0ae1b3f;

});

parcelRegister("jU8FT", function(module, exports) {

let $e7d9f9e526f8207d$var$load = (parcelRequire("6dFT0"))(5);



module.exports = Promise.all([
    $e7d9f9e526f8207d$var$load("TIXGP"),
    $e7d9f9e526f8207d$var$load("6wr18"),
    $e7d9f9e526f8207d$var$load("4fYzp"),
    $e7d9f9e526f8207d$var$load("j3lvX"),
    $e7d9f9e526f8207d$var$load("bm0oR"),
    (parcelRequire("aZWbq"))((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve("jL45t"), 5)),
    $e7d9f9e526f8207d$var$load("c831e"),
    $e7d9f9e526f8207d$var$load("9pso5"),
    $e7d9f9e526f8207d$var$load("5oU5X"),
    $e7d9f9e526f8207d$var$load("3ey58"),
    $e7d9f9e526f8207d$var$load("94qRZ"),
    $e7d9f9e526f8207d$var$load("bOwpR"),
    $e7d9f9e526f8207d$var$load("kOAbA"),
    $e7d9f9e526f8207d$var$load("BKxAI"),
    $e7d9f9e526f8207d$var$load("kUuw5"),
    $e7d9f9e526f8207d$var$load("eOkWq"),
    $e7d9f9e526f8207d$var$load("251nM"),
    $e7d9f9e526f8207d$var$load("fVexC"),
    $e7d9f9e526f8207d$var$load("eYxdW"),
    $e7d9f9e526f8207d$var$load("8ZQ6W"),
    $e7d9f9e526f8207d$var$load("k0Z8C"),
    $e7d9f9e526f8207d$var$load("eUsnQ"),
    $e7d9f9e526f8207d$var$load("4C4vr"),
    $e7d9f9e526f8207d$var$load("fKQ9j"),
    $e7d9f9e526f8207d$var$load("bOOzQ"),
    $e7d9f9e526f8207d$var$load("ffEVr"),
    $e7d9f9e526f8207d$var$load("9TOep"),
    $e7d9f9e526f8207d$var$load("alL67")
]).then(()=>parcelRequire('biV8C'));

});

parcelRegister("aZWbq", function(module, exports) {
"use strict";

var $87Wxe = parcelRequire("87Wxe");

module.exports = $87Wxe(function loadCSSBundle(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        let isCurrentBundle = function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        };
        if ([].concat(existingLinks).some(isCurrentBundle)) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});

parcelRegister("87Wxe", function(module, exports) {
"use strict";
let $5eac61fceb5317f9$var$cachedBundles = {};
let $5eac61fceb5317f9$var$cachedPreloads = {};
let $5eac61fceb5317f9$var$cachedPrefetches = {};
function $5eac61fceb5317f9$var$getCache(type) {
    switch(type){
        case 'preload':
            return $5eac61fceb5317f9$var$cachedPreloads;
        case 'prefetch':
            return $5eac61fceb5317f9$var$cachedPrefetches;
        default:
            return $5eac61fceb5317f9$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $5eac61fceb5317f9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});

parcelRegister("hQIJk", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cc634bbba90ade6e$export$9bc5a864d70a9980 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "kgHDE",
    name: "LazyHomepageCard",
    loader: async ()=>(await (parcelRequire("48d4X"))).HomepageCard
});
module.exports["LazyHomepageCard"] = $cc634bbba90ade6e$export$9bc5a864d70a9980;

});

parcelRegister("48d4X", function(module, exports) {

let $30220e00dff42a68$var$load = (parcelRequire("6dFT0"))(5);



module.exports = Promise.all([
    $30220e00dff42a68$var$load("6wr18"),
    $30220e00dff42a68$var$load("4fYzp"),
    $30220e00dff42a68$var$load("j3lvX"),
    $30220e00dff42a68$var$load("bm0oR"),
    (parcelRequire("aZWbq"))((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve("jL45t"), 5)),
    $30220e00dff42a68$var$load("c831e"),
    $30220e00dff42a68$var$load("9pso5"),
    $30220e00dff42a68$var$load("5oU5X"),
    $30220e00dff42a68$var$load("3ey58"),
    $30220e00dff42a68$var$load("bOwpR"),
    $30220e00dff42a68$var$load("BKxAI"),
    $30220e00dff42a68$var$load("kUuw5"),
    $30220e00dff42a68$var$load("eOkWq"),
    $30220e00dff42a68$var$load("251nM"),
    $30220e00dff42a68$var$load("fVexC"),
    $30220e00dff42a68$var$load("eYxdW"),
    $30220e00dff42a68$var$load("8ZQ6W"),
    $30220e00dff42a68$var$load("k0Z8C"),
    $30220e00dff42a68$var$load("eUsnQ"),
    $30220e00dff42a68$var$load("4C4vr"),
    $30220e00dff42a68$var$load("fKQ9j"),
    $30220e00dff42a68$var$load("bOOzQ"),
    $30220e00dff42a68$var$load("ffEVr"),
    $30220e00dff42a68$var$load("9TOep"),
    $30220e00dff42a68$var$load("3orE4")
]).then(()=>parcelRequire('IdTEh'));

});

parcelRegister("eHqQb", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3e7c4c05628e7b82$export$85a8d72151ca049b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "u3ubl",
    name: "LazyTeamCalendarSiteSettingsPage",
    loader: async ()=>(await (parcelRequire("issxO"))).TeamCalendarSiteSettingsPage
});
module.exports["LazyTeamCalendarSiteSettingsPage"] = $3e7c4c05628e7b82$export$85a8d72151ca049b;

});

parcelRegister("issxO", function(module, exports) {

let $d700fbd5a6e55d28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d700fbd5a6e55d28$var$load("5oU5X"),
    $d700fbd5a6e55d28$var$load("hhss7"),
    $d700fbd5a6e55d28$var$load("9g1FS")
]).then(()=>parcelRequire('4GncZ'));

});

parcelRegister("e8WZK", function(module, exports) {
const $5e4945ce4960200f$export$c0e43f82fc27fe04 = 'adminTeamCalendars';
module.exports["ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE"] = $5e4945ce4960200f$export$c0e43f82fc27fe04;

});

parcelRegister("ltKTq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $c9e0854a72739c18$export$feb9e2d8bc9b9b85 = /*#__PURE__*/ function(CALENDAR_CONTEXT) {
    CALENDAR_CONTEXT["SPACE_CALENDARS"] = "spaceCalendars";
    CALENDAR_CONTEXT["MY_CALENDARS"] = "myCalendars";
    CALENDAR_CONTEXT["SPACE_SUBCALENDAR"] = "spaceSubCalendar";
    CALENDAR_CONTEXT["MACRO"] = "macro";
    return CALENDAR_CONTEXT;
}({});
const $c9e0854a72739c18$var$TCContext = /*#__PURE__*/ (0, $cozmU.createContext)({});
const $c9e0854a72739c18$export$5f8036cb54c4d559 = ()=>{
    const context = (0, $cozmU.useContext)($c9e0854a72739c18$var$TCContext);
    if (context === undefined) throw new Error('useTCContextDispatch must be used within TCContextProvider');
    return context;
};
let $c9e0854a72739c18$var$initialState;
const $c9e0854a72739c18$var$getInitialState = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents, firstDay: firstDay })=>{
    return(// @ts-expect-error - TS2454 Typescript 5.9.2 upgrade
    $c9e0854a72739c18$var$initialState || {
        calendars: calendars,
        events: [],
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        viewDate: new Date(),
        dateTimeFormatOptions: {
            hour: 'numeric',
            minute: 'numeric',
            hourCycle: userTimeFormat === 'displayTimeFormat12' ? 'h12' : 'h23',
            timeZone: userTimeZoneId
        },
        calendarErrors: [],
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
};
const $c9e0854a72739c18$var$AT = {
    SET_EVENTS: 'SET_EVENTS',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    SET_CALENDARS: 'SET_CALENDARS',
    SET_VIEW_DATE: 'SET_VIEW_DATE',
    SET_CALENDAR_ERRORS: 'SET_CALENDAR_ERRORS',
    SET_IS_LOADING_EVENTS: 'SET_IS_LOADING_EVENTS',
    SET_FIRST_DAY: 'SET_FIRST_DAY'
};
const $c9e0854a72739c18$export$97f0c60a5aa0f317 = ({ calendars: calendars, calendarContext: calendarContext, userTimeZoneId: userTimeZoneId, children: children, userTimeFormat: userTimeFormat, isLoadingEvents: isLoadingEvents = false, firstDay: firstDay = 1 })=>{
    const initialState = $c9e0854a72739c18$var$getInitialState({
        calendars: calendars,
        calendarContext: calendarContext,
        userTimeZoneId: userTimeZoneId,
        userTimeFormat: userTimeFormat,
        isLoadingEvents: isLoadingEvents,
        firstDay: firstDay
    });
    const reducer = (0, $cozmU.useCallback)((state, action)=>{
        switch(action.type){
            case $c9e0854a72739c18$var$AT.SET_EVENTS:
                return {
                    ...state,
                    events: action.events
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS:
                {
                    const calendarIds = action.calendarIds;
                    const newEvents = action.events;
                    const oldEvents = state.events.filter((event)=>!calendarIds.includes(event.subCalendarId));
                    const updatedEvents = oldEvents.concat(newEvents);
                    return {
                        ...state,
                        events: updatedEvents
                    };
                }
            case $c9e0854a72739c18$var$AT.SET_CALENDARS:
                return {
                    ...state,
                    calendars: action.calendars
                };
            case $c9e0854a72739c18$var$AT.SET_VIEW_DATE:
                return {
                    ...state,
                    viewDate: action.viewDate
                };
            case $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS:
                if (state.calendarErrors.length === 0 && action.calendarErrors.length === 0) return state;
                return {
                    ...state,
                    calendarErrors: action.calendarErrors
                };
            case $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS:
                return {
                    ...state,
                    isLoadingEvents: action.isLoadingEvents
                };
            case $c9e0854a72739c18$var$AT.SET_FIRST_DAY:
                return {
                    ...state,
                    firstDay: action.firstDay
                };
            default:
                return initialState;
        }
    }, [
        initialState
    ]);
    const [state, dispatch] = (0, $cozmU.useReducer)(reducer, initialState);
    const actions = (0, $cozmU.useMemo)(()=>({
            setEvents: (events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_EVENTS,
                    events: events
                });
            },
            setCalendarEvents: (calendarIds, events)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_EVENTS,
                    calendarIds: calendarIds,
                    events: events
                });
            },
            setCalendars: (calendars)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDARS,
                    calendars: calendars
                });
            },
            setViewDate: (viewDate)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_VIEW_DATE,
                    viewDate: viewDate
                });
            },
            setCalendarErrors: (calendarErrors)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_CALENDAR_ERRORS,
                    calendarErrors: calendarErrors
                });
            },
            setIsLoadingEvents: (isLoadingEvents)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_IS_LOADING_EVENTS,
                    isLoadingEvents: isLoadingEvents
                });
            },
            setFirstDay: (firstDay)=>{
                dispatch({
                    type: $c9e0854a72739c18$var$AT.SET_FIRST_DAY,
                    firstDay: firstDay
                });
            }
        }), []);
    const tcContextValue = (0, $cozmU.useMemo)(()=>({
            state: state,
            actions: actions
        }), [
        state,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c9e0854a72739c18$var$TCContext.Provider, {
        value: tcContextValue
    }, children);
};
module.exports["CALENDAR_CONTEXT"] = $c9e0854a72739c18$export$feb9e2d8bc9b9b85;
module.exports["useTCContextDispatch"] = $c9e0854a72739c18$export$5f8036cb54c4d559;
module.exports["TCContextProvider"] = $c9e0854a72739c18$export$97f0c60a5aa0f317;

});

parcelRegister("h1QnW", function(module, exports) {

let $c65b2a41aae0265c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c65b2a41aae0265c$var$load("fAUr9").then(()=>parcelRequire('7EJ9w'));

});

parcelRegister("e9iBv", function(module, exports) {

let $a4d056487361517e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a4d056487361517e$var$load("i8sPk"),
    $a4d056487361517e$var$load("6wr18"),
    $a4d056487361517e$var$load("7QQL7"),
    $a4d056487361517e$var$load("efUj2"),
    $a4d056487361517e$var$load("ffEVr"),
    $a4d056487361517e$var$load("4pYLw")
]).then(()=>parcelRequire('i9E8j'));

});

parcelRegister("lEzA0", function(module, exports) {

let $fc38eeccef075a15$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fc38eeccef075a15$var$load("evWu5").then(()=>parcelRequire('8foBH'));

});

parcelRegister("6O2BV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4f497007dae01ffa$export$25fb473e92ff8332 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PT7yD",
    name: "ClassicEditorContextProviderLoader",
    loader: ()=>(parcelRequire("ihYWF"))
});
module.exports["ClassicEditorContextProviderLoader"] = $4f497007dae01ffa$export$25fb473e92ff8332;

});

parcelRegister("ihYWF", function(module, exports) {

let $d50916fbbdc3c77d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d50916fbbdc3c77d$var$load("el1U6"),
    $d50916fbbdc3c77d$var$load("2yyll"),
    $d50916fbbdc3c77d$var$load("hUbK8"),
    $d50916fbbdc3c77d$var$load("kOHTK"),
    $d50916fbbdc3c77d$var$load("8faB9"),
    $d50916fbbdc3c77d$var$load("fU0ae"),
    $d50916fbbdc3c77d$var$load("4nZ85"),
    $d50916fbbdc3c77d$var$load("gIO2h"),
    $d50916fbbdc3c77d$var$load("bqdgP"),
    $d50916fbbdc3c77d$var$load("3Whaz"),
    $d50916fbbdc3c77d$var$load("esBxc"),
    $d50916fbbdc3c77d$var$load("3pbEq"),
    $d50916fbbdc3c77d$var$load("9cVML"),
    $d50916fbbdc3c77d$var$load("15jTz"),
    $d50916fbbdc3c77d$var$load("48F3z"),
    $d50916fbbdc3c77d$var$load("7SteV"),
    $d50916fbbdc3c77d$var$load("eUsnQ"),
    $d50916fbbdc3c77d$var$load("9LJFK"),
    $d50916fbbdc3c77d$var$load("d66hN"),
    $d50916fbbdc3c77d$var$load("dxA9F"),
    $d50916fbbdc3c77d$var$load("bkMxV"),
    $d50916fbbdc3c77d$var$load("aRCaA"),
    $d50916fbbdc3c77d$var$load("h3Rq9"),
    $d50916fbbdc3c77d$var$load("i7NGK"),
    $d50916fbbdc3c77d$var$load("cIoRg"),
    $d50916fbbdc3c77d$var$load("g7vSH"),
    $d50916fbbdc3c77d$var$load("iWnyc"),
    $d50916fbbdc3c77d$var$load("ea3NB"),
    $d50916fbbdc3c77d$var$load("6wr18"),
    $d50916fbbdc3c77d$var$load("ffEVr"),
    $d50916fbbdc3c77d$var$load("59hV4"),
    $d50916fbbdc3c77d$var$load("kJASg"),
    $d50916fbbdc3c77d$var$load("asCsc"),
    $d50916fbbdc3c77d$var$load("fYx6U"),
    $d50916fbbdc3c77d$var$load("botpL"),
    $d50916fbbdc3c77d$var$load("frgRG"),
    $d50916fbbdc3c77d$var$load("gRItA"),
    $d50916fbbdc3c77d$var$load("l4j2l"),
    $d50916fbbdc3c77d$var$load("37v60"),
    $d50916fbbdc3c77d$var$load("a7sEM"),
    $d50916fbbdc3c77d$var$load("koqDJ"),
    $d50916fbbdc3c77d$var$load("7IvJj"),
    $d50916fbbdc3c77d$var$load("j7JUO"),
    $d50916fbbdc3c77d$var$load("cGkFm"),
    $d50916fbbdc3c77d$var$load("eF92L"),
    $d50916fbbdc3c77d$var$load("jwMHX"),
    $d50916fbbdc3c77d$var$load("bmOOW"),
    $d50916fbbdc3c77d$var$load("dDiWc"),
    $d50916fbbdc3c77d$var$load("d0ZRF"),
    $d50916fbbdc3c77d$var$load("k507P"),
    $d50916fbbdc3c77d$var$load("fwbNS"),
    $d50916fbbdc3c77d$var$load("a8R25"),
    $d50916fbbdc3c77d$var$load("gaUhx"),
    $d50916fbbdc3c77d$var$load("5PKbS"),
    $d50916fbbdc3c77d$var$load("gFeoL"),
    $d50916fbbdc3c77d$var$load("9TOep"),
    $d50916fbbdc3c77d$var$load("bncmK"),
    $d50916fbbdc3c77d$var$load("8iu3F"),
    $d50916fbbdc3c77d$var$load("fWCBZ"),
    $d50916fbbdc3c77d$var$load("6iTkp"),
    $d50916fbbdc3c77d$var$load("hhss7"),
    $d50916fbbdc3c77d$var$load("h6rbF"),
    $d50916fbbdc3c77d$var$load("jD5ZU"),
    $d50916fbbdc3c77d$var$load("aAWLw"),
    $d50916fbbdc3c77d$var$load("7EorR"),
    $d50916fbbdc3c77d$var$load("lsb09")
]).then(()=>parcelRequire('gnN3I'));

});

parcelRegister("3d5UI", function(module, exports) {
function $28507a73a7688e48$var$isDefined(path) {
    return path.split('.').reduce((object, pathPart)=>{
        return object && object[pathPart] ? object[pathPart] : null;
    }, window);
}
const $28507a73a7688e48$var$lines = {};
function $28507a73a7688e48$var$logOnce(message) {}
function $28507a73a7688e48$export$d2adf65b87e47523() {
    for(const key in $28507a73a7688e48$var$lines)delete $28507a73a7688e48$var$lines[key];
}
function $28507a73a7688e48$export$88d492d47be57a7e({ listener: listener, globalProperty: globalProperty, interval: interval = 250 }, callback) {
    if ($28507a73a7688e48$var$isDefined(globalProperty)) {
        $28507a73a7688e48$var$logOnce(`window.${globalProperty} is already available for use by ${listener}.`);
        callback();
        return null;
    }
    const waitForGlobalInterval = setInterval(()=>{
        $28507a73a7688e48$var$logOnce(`${listener} is waiting for window.${globalProperty} to be available`);
        if ($28507a73a7688e48$var$isDefined(globalProperty)) {
            $28507a73a7688e48$var$logOnce(`window.${globalProperty} now available!`);
            clearInterval(waitForGlobalInterval);
            callback();
        }
    }, interval);
}
module.exports["waitForGlobal"] = $28507a73a7688e48$export$88d492d47be57a7e;

});

parcelRegister("7EX8o", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $2w2Hu = parcelRequire("2w2Hu");


const $1c44eab82f88f298$export$3717da370a5be6bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NLJVG",
    name: "EmbeddedViewPageLoader",
    loader: async ()=>(await (parcelRequire("4x5O9"))).EmbeddedViewPage,
    _mustPreloadWhenRenderingSPA: [
        (0, $2w2Hu.MustPreloadLoadableNames).ViewPageRouteComponentLoader
    ]
});
module.exports["EmbeddedViewPageLoader"] = $1c44eab82f88f298$export$3717da370a5be6bc;

});

parcelRegister("4x5O9", function(module, exports) {

let $34cebfd17ed55c72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $34cebfd17ed55c72$var$load("4PCFY"),
    $34cebfd17ed55c72$var$load("d3PpR"),
    $34cebfd17ed55c72$var$load("6TLS9"),
    $34cebfd17ed55c72$var$load("kfGHh"),
    $34cebfd17ed55c72$var$load("lIiD7"),
    $34cebfd17ed55c72$var$load("2xoIF"),
    $34cebfd17ed55c72$var$load("ce05o"),
    $34cebfd17ed55c72$var$load("12TnU"),
    $34cebfd17ed55c72$var$load("3Wy8Y"),
    $34cebfd17ed55c72$var$load("4B1vY"),
    $34cebfd17ed55c72$var$load("hNOga"),
    $34cebfd17ed55c72$var$load("k0wQ3"),
    $34cebfd17ed55c72$var$load("8MjiJ"),
    $34cebfd17ed55c72$var$load("bncmK"),
    $34cebfd17ed55c72$var$load("5dkX4"),
    $34cebfd17ed55c72$var$load("cLCaE"),
    $34cebfd17ed55c72$var$load("KsShd"),
    $34cebfd17ed55c72$var$load("dlm6q"),
    $34cebfd17ed55c72$var$load("kFE08"),
    $34cebfd17ed55c72$var$load("knUU4"),
    $34cebfd17ed55c72$var$load("aQJUV"),
    $34cebfd17ed55c72$var$load("jD3c3"),
    $34cebfd17ed55c72$var$load("lHX6l"),
    $34cebfd17ed55c72$var$load("7Y0AX"),
    $34cebfd17ed55c72$var$load("i8sPk"),
    $34cebfd17ed55c72$var$load("el56J"),
    $34cebfd17ed55c72$var$load("jqoep"),
    $34cebfd17ed55c72$var$load("TIXGP"),
    $34cebfd17ed55c72$var$load("b3zRm"),
    $34cebfd17ed55c72$var$load("1NyWL"),
    $34cebfd17ed55c72$var$load("mUfsl"),
    $34cebfd17ed55c72$var$load("htKpm"),
    $34cebfd17ed55c72$var$load("44XW6"),
    $34cebfd17ed55c72$var$load("eF92L"),
    $34cebfd17ed55c72$var$load("jwMHX"),
    $34cebfd17ed55c72$var$load("d0ZRF"),
    $34cebfd17ed55c72$var$load("k507P"),
    $34cebfd17ed55c72$var$load("6iTkp"),
    $34cebfd17ed55c72$var$load("6wr18"),
    $34cebfd17ed55c72$var$load("16bOI"),
    $34cebfd17ed55c72$var$load("2be0t"),
    $34cebfd17ed55c72$var$load("7SteV"),
    $34cebfd17ed55c72$var$load("jE0Mz"),
    $34cebfd17ed55c72$var$load("1AybA"),
    $34cebfd17ed55c72$var$load("ffEVr"),
    $34cebfd17ed55c72$var$load("9TOep"),
    $34cebfd17ed55c72$var$load("dxcsb"),
    $34cebfd17ed55c72$var$load("cGkFm"),
    $34cebfd17ed55c72$var$load("8iu3F"),
    $34cebfd17ed55c72$var$load("hhss7"),
    $34cebfd17ed55c72$var$load("7EorR"),
    $34cebfd17ed55c72$var$load("1gUNx"),
    $34cebfd17ed55c72$var$load("WXYxI")
]).then(()=>parcelRequire('6N2H2'));

});

parcelRegister("4H46k", function(module, exports) {
// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.

var $jmjWc = parcelRequire("jmjWc");


const $36ae5bfcf92491af$export$2f32c75fff716fcc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b7m6n",
    name: "LazySpaceBlogRedirect",
    loader: async ()=>(await (parcelRequire("aSorL"))).SpaceBlogRedirect
});

const $36ae5bfcf92491af$export$5590c410e7d0a293 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LfHUf",
    name: "LazySpaceCreatePage",
    loader: ()=>(parcelRequire("e7Cit"))
});

const $36ae5bfcf92491af$export$e650af616d3a92cf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Z1eTA",
    name: "LazyMobileWebContainer",
    loader: ()=>(parcelRequire("eTRmX"))
});

const $36ae5bfcf92491af$export$dcf40c4d983a3b1f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TnNDX",
    name: "LazyDwellTime",
    loader: ()=>(parcelRequire("3NGbz"))
});

const $36ae5bfcf92491af$export$a804be9097757ef8 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GCYkT",
    name: "LazyConsumptionViewedAndCompletedEventTracker",
    loader: async ()=>(await (parcelRequire("2b91E"))).ConsumptionViewedAndCompletedEventTracker
});

const $36ae5bfcf92491af$export$33256e23669f7955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AaHry",
    name: "LazyConfluenceNotFound",
    loader: ()=>(parcelRequire("44sbU"))
});
module.exports["LazySpaceBlogRedirect"] = $36ae5bfcf92491af$export$2f32c75fff716fcc;
module.exports["LazySpaceCreatePage"] = $36ae5bfcf92491af$export$5590c410e7d0a293;
module.exports["LazyMobileWebContainer"] = $36ae5bfcf92491af$export$e650af616d3a92cf;
module.exports["LazyDwellTime"] = $36ae5bfcf92491af$export$dcf40c4d983a3b1f;
module.exports["LazyConsumptionViewedAndCompletedEventTracker"] = $36ae5bfcf92491af$export$a804be9097757ef8;
module.exports["LazyConfluenceNotFound"] = $36ae5bfcf92491af$export$33256e23669f7955;

});

parcelRegister("aSorL", function(module, exports) {

let $7eb1e928c024f4bd$var$load = (parcelRequire("6dFT0"))(5);



module.exports = Promise.all([
    (parcelRequire("aZWbq"))((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve("kzRPH"), 5)),
    $7eb1e928c024f4bd$var$load("gaXhw")
]).then(()=>parcelRequire('4bW1i'));

});

parcelRegister("e7Cit", function(module, exports) {

let $a47f6d16c60ef5a9$var$load = (parcelRequire("6dFT0"))(5);



module.exports = Promise.all([
    $a47f6d16c60ef5a9$var$load("4PCFY"),
    $a47f6d16c60ef5a9$var$load("el1U6"),
    $a47f6d16c60ef5a9$var$load("2yyll"),
    $a47f6d16c60ef5a9$var$load("d0ZRF"),
    $a47f6d16c60ef5a9$var$load("k507P"),
    $a47f6d16c60ef5a9$var$load("hUbK8"),
    $a47f6d16c60ef5a9$var$load("6wr18"),
    (parcelRequire("aZWbq"))((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve("meCbt"), 5)),
    $a47f6d16c60ef5a9$var$load("ddsSQ"),
    $a47f6d16c60ef5a9$var$load("2F69B"),
    $a47f6d16c60ef5a9$var$load("7Rf3l"),
    $a47f6d16c60ef5a9$var$load("1GCFv"),
    $a47f6d16c60ef5a9$var$load("kOHTK"),
    $a47f6d16c60ef5a9$var$load("8faB9"),
    $a47f6d16c60ef5a9$var$load("fU0ae"),
    $a47f6d16c60ef5a9$var$load("el56J"),
    $a47f6d16c60ef5a9$var$load("4nZ85"),
    $a47f6d16c60ef5a9$var$load("gIO2h"),
    $a47f6d16c60ef5a9$var$load("bqdgP"),
    $a47f6d16c60ef5a9$var$load("KTLLA"),
    $a47f6d16c60ef5a9$var$load("1Gr4q"),
    $a47f6d16c60ef5a9$var$load("esBxc"),
    $a47f6d16c60ef5a9$var$load("3pbEq"),
    $a47f6d16c60ef5a9$var$load("9cVML"),
    $a47f6d16c60ef5a9$var$load("hZsD1"),
    $a47f6d16c60ef5a9$var$load("9TOep"),
    $a47f6d16c60ef5a9$var$load("4938u"),
    $a47f6d16c60ef5a9$var$load("kHDuB"),
    $a47f6d16c60ef5a9$var$load("ariuh"),
    $a47f6d16c60ef5a9$var$load("eUsnQ"),
    $a47f6d16c60ef5a9$var$load("9LJFK"),
    $a47f6d16c60ef5a9$var$load("d66hN"),
    $a47f6d16c60ef5a9$var$load("7EorR"),
    $a47f6d16c60ef5a9$var$load("aRCaA"),
    $a47f6d16c60ef5a9$var$load("h3Rq9"),
    $a47f6d16c60ef5a9$var$load("aCJpU"),
    $a47f6d16c60ef5a9$var$load("kHXvF"),
    $a47f6d16c60ef5a9$var$load("hhss7"),
    $a47f6d16c60ef5a9$var$load("ffEVr"),
    $a47f6d16c60ef5a9$var$load("kJASg"),
    $a47f6d16c60ef5a9$var$load("asCsc"),
    $a47f6d16c60ef5a9$var$load("fYx6U"),
    $a47f6d16c60ef5a9$var$load("botpL"),
    $a47f6d16c60ef5a9$var$load("frgRG"),
    $a47f6d16c60ef5a9$var$load("8bEF3"),
    $a47f6d16c60ef5a9$var$load("gRItA"),
    $a47f6d16c60ef5a9$var$load("7IvJj"),
    $a47f6d16c60ef5a9$var$load("j7JUO"),
    $a47f6d16c60ef5a9$var$load("f6ZVy"),
    $a47f6d16c60ef5a9$var$load("eF92L"),
    $a47f6d16c60ef5a9$var$load("jwMHX"),
    $a47f6d16c60ef5a9$var$load("ckGjo"),
    $a47f6d16c60ef5a9$var$load("a8R25"),
    $a47f6d16c60ef5a9$var$load("gaUhx"),
    $a47f6d16c60ef5a9$var$load("gFeoL"),
    $a47f6d16c60ef5a9$var$load("8iu3F"),
    $a47f6d16c60ef5a9$var$load("fWCBZ"),
    $a47f6d16c60ef5a9$var$load("h6rbF"),
    $a47f6d16c60ef5a9$var$load("jD5ZU"),
    $a47f6d16c60ef5a9$var$load("6UKHF")
]).then(()=>parcelRequire('lJvEZ'));

});

parcelRegister("eTRmX", function(module, exports) {

let $ad8f99c4489ca000$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ad8f99c4489ca000$var$load("6wr18"),
    $ad8f99c4489ca000$var$load("kOWvR"),
    $ad8f99c4489ca000$var$load("ffEVr"),
    $ad8f99c4489ca000$var$load("8iu3F"),
    $ad8f99c4489ca000$var$load("4D7T2")
]).then(()=>parcelRequire('1x5LM'));

});

parcelRegister("3NGbz", function(module, exports) {

let $2c46abe44c9a4d38$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2c46abe44c9a4d38$var$load("9HjYv").then(()=>parcelRequire('7SYCP'));

});

parcelRegister("2b91E", function(module, exports) {

let $19639c244e61a02c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $19639c244e61a02c$var$load("f2uDI").then(()=>parcelRequire('3deqg'));

});

parcelRegister("44sbU", function(module, exports) {

let $2f6d6750936bac7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f6d6750936bac7a$var$load("kOWvR").then(()=>parcelRequire('4uiGD'));

});

parcelRegister("9pOEz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9jl6v = parcelRequire("9jl6v");

const $1adfb96e71037064$export$1d04f0e8aa57d594 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9jl6v.InlineCommentsProvider), null, children);
};
module.exports["CommentContextWrapper"] = $1adfb96e71037064$export$1d04f0e8aa57d594;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $cozmU = parcelRequire("cozmU");


var $l0zDh = parcelRequire("l0zDh");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $cozmU.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $cozmU.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $cozmU.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $cozmU.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $cozmU.useState)(false);
    const firstHighlightClicked = (0, $cozmU.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $cozmU.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $cozmU.useState)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $cozmU.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0;
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(nextThreadKey) || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(`footer-comment-thread-${nextThreadKey}-container`);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $l0zDh.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $cozmU.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("l0zDh", function(module, exports) {
const $cae4ddecf89022a7$var$prefix = 'pm-alt-text';
const $cae4ddecf89022a7$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$cae4ddecf89022a7$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};
module.exports["ClassNames"] = $cae4ddecf89022a7$export$9b9c0f9d9f3552b8;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') {
        if ((0, $6mKj3.expValEquals)('platform_editor_fix_lcm_editor_annotations', 'isEnabled', true)) return '[annotationtype="inlineComment"], .fabric-editor-popup-scroll-parent [data-lcm-annotation-renderer] [data-mark-annotation-type="inlineComment"]';
        return "[annotationtype='inlineComment']";
    } else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$var$isHighlightCandidateVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    const computedStyle = window.getComputedStyle(element);
    return element.isConnected && computedStyle.display !== 'none' && computedStyle.visibility !== 'hidden' && element.getAttribute('aria-hidden') !== 'true' && (rect.width > 0 || rect.height > 0);
};
const $a78c261c3211f7d6$export$c36aa9f15eddb765 = (markerRef)=>{
    if (!markerRef) return null;
    const allHighlights = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    const visibleHighlight = allHighlights.find((element)=>$a78c261c3211f7d6$var$isHighlightCandidateVisible(element));
    return visibleHighlight || $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$59a770a0e59b0dd2 = (container)=>{
    const selector = [
        'button:not([disabled])',
        'a[href]',
        'input:not([disabled])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[contenteditable="true"]',
        '[tabindex]:not([tabindex="-1"])'
    ].join(',');
    return Array.from(container.querySelectorAll(selector)).filter((element)=>!element.hasAttribute('disabled') && element.getAttribute('aria-hidden') !== 'true');
};
const $a78c261c3211f7d6$export$642e21ba866d02df = (container, element)=>{
    if (!element) return false;
    return $a78c261c3211f7d6$export$59a770a0e59b0dd2(container)[0] === element;
};
const $a78c261c3211f7d6$export$876aeb5dffd449af = (container, element)=>{
    if (!element) return false;
    const tabbableElements = $a78c261c3211f7d6$export$59a770a0e59b0dd2(container);
    return tabbableElements[tabbableElements.length - 1] === element;
};
const $a78c261c3211f7d6$export$cfa8eefe354167cd = (element, focusOptions)=>{
    element.setAttribute('tabIndex', '-1');
    element.focus(focusOptions);
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // new sticky header implementation
    if (relativeToElement && nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('tr.pm-table-row-native-sticky-active')) {
        const elementRect = nodeToMeasure.getBoundingClientRect();
        const containerRect = relativeToElement.getBoundingClientRect();
        return elementRect.top - containerRect.top;
    }
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    let measureLcmAnnotationThroughRenderer = false;
    if ((0, $6mKj3.expValEquals)('platform_editor_fix_lcm_editor_annotations', 'isEnabled', true)) {
        // LCM renderer offsets belong to the editor coordinate space only when it is inside that editor.
        const lcmRenderer = nodeToMeasure?.closest('[data-lcm-annotation-renderer]');
        const editorScrollParent = lcmRenderer?.closest('.fabric-editor-popup-scroll-parent');
        measureLcmAnnotationThroughRenderer = Boolean(nodeToMeasure && lcmRenderer && editorScrollParent?.contains(nodeToMeasure));
    }
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && (measureLcmAnnotationThroughRenderer || !nodeToMeasure.classList.contains('ak-renderer-wrapper')) && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure && !measureLcmAnnotationThroughRenderer) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = ()=>{
    const windowHeight = window.innerHeight;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorTextArea = document.getElementById('ak-editor-textarea');
    const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
    if (editorBottom && windowHeight) {
        // The minimum spacing between bottom of editor content and top of footer is 120px
        const minimumSpacing = 120;
        // - There's an existing fixed 24px margin below editor content.
        // - ObjectAddCommentContainer.tsx has a 64px height.
        // - We lift footer comment top by 14px to make it visually distinct
        //   when a short LiveDoc has some vs zero existing footer comment.
        const editorBottomMargin = 24;
        const addFooterCommentHeight = 64;
        const extraFooterCommentHeightToShow = 14;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
        const currentScroll = editorScrollParent?.scrollTop ?? 0;
        const editorBottomUnscrolled = editorBottom + currentScroll;
        const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
        return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
    }
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = scrollRootElement instanceof Window ? 0 // Window doesn't have a bounding rect; its top is always 0
     : scrollRootElement.getBoundingClientRect().top;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId, annotationId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`) || (annotationId ? targetContainer.querySelector(`[data-testid="comment-thread-${annotationId}-container"]`) : null);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: annotationId ? [
            'data-comment-id',
            'data-testid'
        ] : [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default,
 *  this is the div with id=AkMainContent, if the id exists in the DOM
 */ function $a78c261c3211f7d6$var$getScrollRootContext() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const scrollRootElement = nav4ScrollRootElement || window;
    const scrollRootOffset = nav4ScrollRootElement ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations ? endOfPageRecommendationsMaxWidth : '100%'
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["getFocusableElementFromMarkerRef"] = $a78c261c3211f7d6$export$c36aa9f15eddb765;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getNodeForTableORMacro"] = $a78c261c3211f7d6$export$ee0755cb593feed6;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["isFirstTabbableElement"] = $a78c261c3211f7d6$export$642e21ba866d02df;
module.exports["isLastTabbableElement"] = $a78c261c3211f7d6$export$876aeb5dffd449af;
module.exports["focusElementAndUpdateTabIndex"] = $a78c261c3211f7d6$export$cfa8eefe354167cd;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("cD1qu", function(module, exports) {
var $7825447594ee3eb0$export$6ea4b0c62affbe44 = /*#__PURE__*/ function(PageMode) {
    PageMode["EDIT"] = "edit";
    PageMode["VIEW"] = "view";
    PageMode["LIVE"] = "live";
    return PageMode;
}({});
var $7825447594ee3eb0$export$b2be22e9d5dd3927 = /*#__PURE__*/ function(ContentStatus) {
    ContentStatus["CURRENT"] = "current";
    ContentStatus["DRAFT"] = "draft";
    ContentStatus["ARCHIVED"] = "archived";
    return ContentStatus;
}({});
const $7825447594ee3eb0$export$5d7c5e13dde1e9b8 = [
    "draft"
];
const $7825447594ee3eb0$export$c75005e52070dee = [
    "current"
];
module.exports["PageMode"] = $7825447594ee3eb0$export$6ea4b0c62affbe44;
module.exports["ContentStatus"] = $7825447594ee3eb0$export$b2be22e9d5dd3927;
module.exports["DRAFT_STATUS"] = $7825447594ee3eb0$export$5d7c5e13dde1e9b8;
module.exports["CURRENT_STATUS"] = $7825447594ee3eb0$export$c75005e52070dee;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;

});

parcelRegister("gfqXk", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d97010bba34874b5$var$editorEmitter = undefined;
const $d97010bba34874b5$export$60921b94e11f8e19 = ()=>{
    if (!$d97010bba34874b5$var$editorEmitter) $d97010bba34874b5$var$editorEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d97010bba34874b5$var$editorEmitter;
};
module.exports["getEditorAnnotationEventEmitter"] = $d97010bba34874b5$export$60921b94e11f8e19;

});

parcelRegister("cz6eP", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");


var $5uEm7 = parcelRequire("5uEm7");

class $91ffffc20e95f4c4$export$7cc60aa9ef845515 extends (0, $eSa5t.EventEmitter) {
    on(event, listener) {
        return super.on(event, listener);
    }
    off(event, listener) {
        return super.removeListener(event, listener);
    }
}
function $91ffffc20e95f4c4$export$3238f27f6e07aed2() {
    return new (0, $5uEm7.SharedAnnotationManager)();
}
module.exports["AnnotationUpdateEmitter"] = $91ffffc20e95f4c4$export$7cc60aa9ef845515;
module.exports["createAnnotationManager"] = $91ffffc20e95f4c4$export$3238f27f6e07aed2;

});

parcelRegister("5uEm7", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");

class $ca65321d79324be4$export$c7aecf09b7cf478f {
    setPreemptiveGate(handler) {
        this.preemptiveGate = handler;
        return this;
    }
    checkPreemptiveGate() {
        if (this.activePreemptiveGate) // If the preemptive gate check already in flight then just return the promise
        // and don't call the preemptive gate again.
        // This is to prevent multiple calls to the preemptive gate creating multiple
        // promises that will resolve at different times.
        return Promise.resolve(this.activePreemptiveGate);
        const gate = this.activePreemptiveGate = this.preemptiveGate().then((result)=>{
            this.activePreemptiveGate = undefined;
            return result;
        });
        return gate;
    }
    onDraftAnnotationStarted(handler) {
        this.emitter.on('draftAnnotationStarted', handler);
        return this;
    }
    offDraftAnnotationStarted(handler) {
        this.emitter.off('draftAnnotationStarted', handler);
        return this;
    }
    onAnnotationSelectionChange(handler) {
        this.emitter.on('annotationSelectionChanged', handler);
        return this;
    }
    offAnnotationSelectionChange(handler) {
        this.emitter.off('annotationSelectionChanged', handler);
        return this;
    }
    onDraftAnnotationCleared(handler) {
        this.emitter.on('draftAnnotationCleared', handler);
        return this;
    }
    offDraftAnnotationCleared(handler) {
        this.emitter.off('draftAnnotationCleared', handler);
        return this;
    }
    emit(event) {
        this.emitter.emit(event.name, 'data' in event ? event.data : undefined);
        return this;
    }
    hook(method, handler) {
        this.hooks.set(method, handler);
        return this;
    }
    unhook(method, handler) {
        if (!this.hooks.has(method) || this.hooks.get(method) !== handler) return this;
        this.hooks.delete(method);
        return this;
    }
    allowAnnotation() {
        const fn = this.hooks.get('allowAnnotation');
        if (!fn) return false;
        try {
            return fn();
        } catch  {
            return false;
        }
    }
    startDraft(localId) {
        const fn = this.hooks.get('startDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(localId);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearDraft() {
        const fn = this.hooks.get('clearDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    applyDraft(id) {
        const fn = this.hooks.get('applyDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    getDraft() {
        const fn = this.hooks.get('getDraft');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationSelected(id, isSelected) {
        const fn = this.hooks.get('setIsAnnotationSelected');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            // NOTE: The hook needs to manage the firing the annotationSelectionChanged event when a change is made. This is
            // because the hook is responsible for the state of the selection. The manager is not responsible for the state of
            // the selection.
            return fn(id, isSelected);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    setIsAnnotationHovered(id, isHovered) {
        const fn = this.hooks.get('setIsAnnotationHovered');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id, isHovered);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearAnnotation(id) {
        const fn = this.hooks.get('clearAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn(id);
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearSelectedAnnotation() {
        const fn = this.hooks.get('clearSelectedAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    clearHoveredAnnotation() {
        const fn = this.hooks.get('clearHoveredAnnotation');
        if (!fn) return {
            success: false,
            reason: 'manager-not-initialized'
        };
        try {
            return fn();
        } catch  {
            return {
                success: false,
                reason: 'hook-execution-error'
            };
        }
    }
    constructor(){
        /**
     * This is the event emitter that is used to emit events from the manager. It is used to communicate with
     * other parts of the application.
     */ this.emitter = new (0, $eSa5t.EventEmitter)();
        /**
     * This is the map of hooks that can be added to the manager. Hooks are a 1:1 mapping of methods that can be
     * called on the manager. They are used to extend the functionality of the manager.
     */ this.hooks = new Map();
        this.preemptiveGate = ()=>Promise.resolve(true);
        this.activePreemptiveGate = undefined;
    }
}
module.exports["SharedAnnotationManager"] = $ca65321d79324be4$export$c7aecf09b7cf478f;

});

parcelRegister("4EKKB", function(module, exports) {

var $gykrH = parcelRequire("gykrH");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $fGzMp = parcelRequire("fGzMp");


var $6nryz = parcelRequire("6nryz");


var $8Ss4E = parcelRequire("8Ss4E");

let $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
function $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug(_experienceName, experienceStage) {
    function createInlineCommentExperienceDebug({ error: error, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Legacy select debug message: ${error.message || String(error)}`,
            attributes: {
                ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                ...extraAttributes,
                experienceStage: experienceStage
            }
        });
    }
    return createInlineCommentExperienceDebug;
}
var $d671aa981fcb4da6$var$ExperienceType = /*#__PURE__*/ function(ExperienceType) {
    ExperienceType["DOCUMENT"] = "document";
    ExperienceType["DOCUMENT_WITH_PANEL"] = "documentWithPanel";
    ExperienceType["PANEL"] = "panel";
    return ExperienceType;
}($d671aa981fcb4da6$var$ExperienceType || {});
function $d671aa981fcb4da6$var$getExperienceType(entryPoint, sidebarOpenAtStart) {
    switch(entryPoint){
        case 'create-comment':
        case 'comment-navigation':
        case 'unknown:InlineComment':
            return "document";
        case 'annotation-change':
        case 'keyboard-navigation':
        case 'unknown:RendererFocus':
            return sidebarOpenAtStart ? "documentWithPanel" : "document";
        case 'sidebar':
        case 'unknown:CommentsPanelList':
            return "panel";
        default:
            return "document";
    }
}
const $d671aa981fcb4da6$export$e2b3aff7888f2745 = {
    _start: (startAttributes, _options)=>{
        if (startAttributes.pageClass === 'tinyMCE' || startAttributes.pageClass === 'database' || startAttributes.pageClass === 'whiteboard' || startAttributes.pageClass === 'slide') return;
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        const runningExperienceAttributes = experienceState?.attributes;
        const context = (0, $6nryz.getInlineCommentExperienceContext)(startAttributes.annotationId, startAttributes.pageMode ?? (startAttributes.pageClass === 'renderer' ? 'view' : undefined));
        if (startAttributes.commentTargetType) context.commentTargetType = startAttributes.commentTargetType;
        if (!experienceState?.hasStopped && runningExperienceAttributes?.annotationId !== undefined && runningExperienceAttributes?.annotationId === startAttributes.annotationId) {
            // Later signals can supply page mode or a previously unavailable target.
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                ...context.commentTargetType !== 'unknown' ? {
                    commentTargetType: context.commentTargetType
                } : {},
                ...context.pageMode ? {
                    pageMode: context.pageMode
                } : {}
            });
            // If there is an existing (unstopped) experience
            // - and that experience has an annotationId
            //   - keyboard and comment navigation will start experiences without an annotationId -- and these should be restarted on an new start
            // - and that annotationId matches the one in the startAttributes
            // we assume the experience is still active, and don't start a new one.
            // the reason we can hit this is because the selectInlineCommentCompoundExperience._start is called when there is a "select inline comment"
            // signal, and individual signals fire in different orders (sometimes they are the first signal, sometimes they are later).
            // However -- if the second signal has a clearer entry point
            // we update the entry point attribute of the existing experience.
            if (runningExperienceAttributes?.entryPoint?.startsWith('unknown') && !startAttributes.entryPoint.startsWith('unknown')) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                    entryPoint: startAttributes.entryPoint
                });
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint}`
                });
            }
            return;
        }
        if (// When the side bar is open, and the user selects a comment using the keyboard,
        // the keyboard navigation triggers a select annotation first (without an annotationId),
        // followed by the show comment start or select annotation complete (with an annotationId.
        startAttributes.entryPoint === 'unknown:CommentsPanelList' && runningExperienceAttributes?.entryPoint === 'keyboard-navigation' && runningExperienceAttributes?.annotationId === undefined) {
            $d671aa981fcb4da6$export$e2b3aff7888f2745.addCommonAttributes({
                annotationId: startAttributes.annotationId,
                ...context
            });
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `After starting from ${runningExperienceAttributes.entryPoint}, received signal from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
            });
            return;
        }
        // First prepare the new attributes without modifying the global state
        // This ensures that any abort of current experiences will use their original attributes
        const newAttributes = {
            ...context,
            pageClass: startAttributes.pageClass,
            commentType: startAttributes.commentType,
            annotationId: 'annotationId' in startAttributes ? startAttributes.annotationId : undefined,
            entryPoint: startAttributes.entryPoint,
            version: 'single-experience'
        };
        // We check if there is a dom element with a testId of "object-sidebar-panel-body" and if so mark the
        // experience as being during a sidebar open experience.
        newAttributes.sidebarOpenAtStart = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('[data-testid="object-sidebar-panel-body"]') !== null;
        newAttributes.experienceType = $d671aa981fcb4da6$var$getExperienceType(startAttributes.entryPoint, newAttributes.sidebarOpenAtStart);
        // If the create inline comment experience is running, we want to link the two experiences
        const createInlineCommentExperienceState = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        if (createInlineCommentExperienceState && !createInlineCommentExperienceState.hasStopped) newAttributes.linkedCompoundTaskId = createInlineCommentExperienceState.attributes?.compoundTaskId;
        // Adds a debug point to the last running experience (debug points are only added if there is a running experience)
        // Note:
        // A new experience is followed after this is fired -- so this should always be the last debug point (as the new experience will trigger a fail or abort).
        // In the case there is no running experience, the experience tracker will discard the debugPoint.
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `Restarted from ${startAttributes.entryPoint} with annotationId: ${startAttributes.annotationId} (sidebarOpenAtStart: ${newAttributes.sidebarOpenAtStart})`
        });
        // Start press trace if no trace is currently active
        (0, $8Ss4E.startUFOPressTrace)((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
        // Then start a new compound experience with the new attributes
        // This will abort any running experiences with the same name, but they'll keep their original attributes
        experienceTracker.start({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                ...newAttributes
            },
            // If the annotation is not selected and comment shown to the user within 12 seconds -- we assume there has been a failure to select the inline comment
            timeout: (0, $aJPUt.ExperienceTimeout).SELECT_INLINE_COMMMENT,
            collect: (events)=>{
                const isThisCommentBeingResolved = (event)=>{
                    return event.name === (0, $irVI7.RESOLVE_INLINE_COMMENT_EXPERIENCE) && event.action === 'taskStart' && (0, $gykrH.hasAttribute)(event, 'annotationId', $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId);
                };
                events.forEach((event)=>{
                    if (isThisCommentBeingResolved(event)) $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                        abortReason: 'Comment being resolved'
                    });
                });
            }
        });
        if (startAttributes.annotationId === undefined) experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with unknown annotationId`
        });
        else experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `selectInlineCommentCompoundExperience._start started from ${startAttributes.entryPoint} with annotationId ${startAttributes.annotationId}`
        });
        // Now it's safe to update the global state since any aborts have already happened
        // We reset experience state if we are starting a new experience
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...newAttributes
        };
        // By the time we get a task fail (particularly for timeout aborts) -- the contentId may have changed
        const originalContentId = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE))?.attributes?.contentId;
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.originalContentId = originalContentId;
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                originalContentId: originalContentId
            }
        });
    },
    debugPoint: (message, attributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
            message: message,
            attributes: attributes
        });
    },
    addCommonAttributes: (additionalCommonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {
            ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
            ...additionalCommonAttributes
        };
        experienceTracker.updateAttributes({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            attributes: additionalCommonAttributes
        });
    },
    abort: ({ abortReason: abortReason })=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.abort({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            reason: abortReason,
            checkForTimeout: true
        });
        $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
    },
    selectAnnotation: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'selectAnnotation'),
        /**
     * This is currently used to start from
     * - annotationId unknown
     *   - comment navigation
     *   - keyboard navigation
     * - annotationId known
     *   - create comment
     *   - comment sidebar comment selection
     *
     * These should be separate signals once the multi experience is deprecated.
     */ start: (startAttributes)=>{
            function isUnknownAnnotationId(startAttributes) {
                return startAttributes.entryPoint === 'keyboard-navigation' || startAttributes.entryPoint === 'comment-navigation';
            }
            if (isUnknownAnnotationId(startAttributes)) {
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes, {
                    annotationUnknown: true
                });
                return;
            }
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
        },
        abort: ({ abortReason: abortReason })=>{
            $d671aa981fcb4da6$export$e2b3aff7888f2745.abort({
                abortReason: // @ts-ignore the abort reasons have mismatch due to type from the old multi experience. and once that is removed we can remove this cast
                abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        /**
     * Note -- the selectAnnotation does not trigger a completion of the selectInlineComment experience.
     * Instead -- the selectInlineComment experience is completed when the showComment experience completes
     * (which looks for the selected annotation as part of its completion logic).
     *
     * With the single experience -- this is less a complete and rather just an indirect signal that a selection has been made (in case it's not detected by the showComment experience).
     * When the multi selectInlineCommentCompoundExperience is deprecated, this can be renamed to indicate it's a "annotationSelection" signal rather than a "completed" signal.
     */ complete: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            const experienceState = experienceTracker.getExperienceState((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE));
            // There can be cases where no start has been called for the select experience.
            // - When a product consumer of the editor setselectedannotation api calls the select experience
            //   and has not been instrumented.
            // - When the annotation selection is via editor logic (ie. editor selection being moved onto
            //   an annotation).
            if (experienceState === null) {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: 'selectAnnotation completed from no experience - no explicit start point',
                    attributes: startAttributes
                });
                $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            }
        }
    },
    showComment: {
        debug: $d671aa981fcb4da6$var$getSelectInlineCommentExperienceDebug((0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE), 'showComment'),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        },
        start: (startAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            $d671aa981fcb4da6$export$e2b3aff7888f2745._start(startAttributes);
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: 'showComment start triggered',
                attributes: startAttributes
            });
        },
        abort: ({ abortReason: abortReason })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                reason: abortReason
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        fail: (error, extraAttributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: error,
                attributes: {
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes,
                    ...extraAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        complete: (completedFrom)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: completedFrom,
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
            $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes = {};
        },
        standaloneSidebarComplete: (commentUIVerticalDistanceFromAnnotation)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `standaloneSidebarComplete triggered`
            });
            if (commentUIVerticalDistanceFromAnnotation > 40) experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `Comment UI is misaligned by >40px pixels`,
                attributes: {
                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                }
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.standaloneSidebarComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`selectInlineCommentCompoundExperience.standaloneSidebarComplete ended without a focused and in viewport annotation.`),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Standalone sidebar inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        },
        sidePanelComplete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                message: `sidePanelComplete triggered`
            });
            if (typeof $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId !== 'string') {
                experienceTracker.fail({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete called when no annotationId was known'),
                    attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                });
                return;
            }
            if (!$d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused($d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes.annotationId)) experienceTracker.fail({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                error: new Error('selectInlineCommentCompoundExperience.sidePanelComplete did not result in a visible and focused annotation'),
                attributes: $d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
            });
            experienceTracker.succeed({
                name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                attributes: {
                    completedFrom: 'Side Panel inline comment selection completed',
                    ...$d671aa981fcb4da6$var$commonSelectInlineCommentExperiencesAttributes
                }
            });
        }
    }
};
/**
 *
 * Checks if there is an annotation currently visible in the document.
 *
 * The comment UI is currently opinionated about the comment UI being attached to the first instance of the focused annotation element.
 *
 * So we can safely skip checking if the initial focused annotation is not visible
 *
 * Note: this method causes reflow, and should not be used in performance sensitive code.
 *
 */ function $d671aa981fcb4da6$var$__checkAnnotationVisibleAndFocused(annotationId) {
    const experienceTracker = (0, $fGzMp.getExperienceTracker)();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const possibleFocusedAnnotationElements = document.querySelectorAll(// This will match the annotation id in either the Editor or Renderer
    `[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"][data-has-focus="true"],
		[data-id="${annotationId}"][data-mark-annotation-type="inlineComment"] .ak-editor-annotation-focus`);
    if (possibleFocusedAnnotationElements.length === 0) {
        experienceTracker.attachDebugPoint({
            name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
            message: `No annotation element found`
        });
        return false;
    }
    /**
   * Annotations can have multiple elements in the dom, with each of the elements having the focus state set to true.
   * Ie. Comments spanning multiple lines will have multiple elements with the focus state set to true.
   *
   * In addition to this -- sometimes there will be "hidden" focused annotation elements where the dom is duplicated
   * such as for annotations on table header cells in the renderer.
   *
   * If the first element is not visible due to being hidden, we continue checking until we reach a visible element, and then check whether it is in the viewport.
   *
   */ for(let i = 0; i < possibleFocusedAnnotationElements.length; i++){
        const element = possibleFocusedAnnotationElements[i];
        if (element instanceof HTMLElement) {
            if (!element.checkVisibility()) {
                // Skip to the next element if the current one is not visible
                // This can happen in scenarios where the dom is duplicated, such as for annotations on table header cells in the renderer.
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element had a hidden focused element, skipping to next element`
                });
                continue;
            }
            const rect = element.getBoundingClientRect();
            const isVisible = rect.top >= 0 && rect.left >= 0 && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            rect.right <= (window.innerWidth || document.documentElement.clientWidth);
            // This is the first visible element -- which should be focused and
            // in the viewport
            if (isVisible) return true;
            else {
                experienceTracker.attachDebugPoint({
                    name: (0, $irVI7.SELECT_INLINE_COMMENT_EXPERIENCE),
                    message: `Annotation element found - but not in viewport`
                });
                return false;
            }
        }
    }
    return false;
}
const $d671aa981fcb4da6$export$b65d55854b7eb069 = {
    debug: $d671aa981fcb4da6$export$e2b3aff7888f2745.debugPoint
};
module.exports["selectInlineCommentCompoundExperience"] = $d671aa981fcb4da6$export$e2b3aff7888f2745;
module.exports["selectInlineComment"] = $d671aa981fcb4da6$export$b65d55854b7eb069;

});

parcelRegister("6nryz", function(module, exports) {
function $244e2cac5c7985f0$export$232fd3e2eca7a829(annotationId, pageMode) {
    const context = {
        commentTargetType: 'unknown',
        ...pageMode ? {
            pageMode: pageMode
        } : {}
    };
    if (!annotationId) return context;
    const annotation = Array.from(typeof document !== 'undefined' ? document.querySelectorAll('[data-mark-annotation-type="inlineComment"][data-id]') : []).find((element)=>element.getAttribute('data-id') === annotationId);
    if (!annotation) return context;
    const blockSelector = '[data-node-type="extension"], [data-prosemirror-node-name="extension"], [data-node-type="media"], [data-node-type="mediaSingle"], [data-prosemirror-node-name="mediaSingle"]';
    // Renderer anchors sit inside the block; editor annotation marks can wrap it.
    const block = annotation.closest(blockSelector) ?? annotation.querySelector(blockSelector);
    if (!block) return {
        ...context,
        commentTargetType: 'text'
    };
    const nodeType = block.getAttribute('data-node-type') ?? block.getAttribute('data-prosemirror-node-name');
    if (nodeType !== 'extension') return {
        ...context,
        commentTargetType: 'media'
    };
    const embed = block.querySelector('[data-native-embed-experience="maui"]');
    return {
        ...context,
        commentTargetType: block.getAttribute('extensionkey') === 'native-embed:maui' || embed?.closest(blockSelector) === block ? 'remixEmbed' : 'other'
    };
}
module.exports["getInlineCommentExperienceContext"] = $244e2cac5c7985f0$export$232fd3e2eca7a829;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $fJCU9 = parcelRequire("fJCU9");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6mKj3 = parcelRequire("6mKj3");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    ViewValues["MENTIONS_ME"] = "MENTIONS_ME";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
var $0343eaf78527fd4c$export$368ed1d84e0ae668 = /*#__PURE__*/ function(CommentNavigationStatus) {
    CommentNavigationStatus["FOUND_IN_DOM"] = "FOUND_IN_DOM";
    CommentNavigationStatus["DELETED_CONTENT"] = "DELETED_CONTENT";
    CommentNavigationStatus["RESOLVED"] = "RESOLVED";
    CommentNavigationStatus["UNKNOWN"] = "UNKNOWN";
    CommentNavigationStatus["REMOVED_BY_ANOTHER_USER"] = "REMOVED_BY_ANOTHER_USER";
    return CommentNavigationStatus;
}({});
var $0343eaf78527fd4c$export$352adda3721e4ee = /*#__PURE__*/ function(CommentNavigationCategory) {
    CommentNavigationCategory["FOUND"] = "FOUND";
    CommentNavigationCategory["ANNOTATION_FOUND_COMMENT_MISSING"] = "ANNOTATION_FOUND_COMMENT_MISSING";
    CommentNavigationCategory["ANNOTATION_MISSING_COMMENT_FOUND"] = "ANNOTATION_MISSING_COMMENT_FOUND";
    CommentNavigationCategory["ANNOTATION_AND_COMMENT_MISSING"] = "ANNOTATION_AND_COMMENT_MISSING";
    CommentNavigationCategory["COMMENTS_DATA_NOT_LOADED"] = "COMMENTS_DATA_NOT_LOADED";
    CommentNavigationCategory["COMMENTS_DATA_ERROR"] = "COMMENTS_DATA_ERROR";
    CommentNavigationCategory["COMMENT_RESOLVED"] = "COMMENT_RESOLVED";
    CommentNavigationCategory["COMMENT_REMOVED_BY_ANOTHER_USER"] = "COMMENT_REMOVED_BY_ANOTHER_USER";
    return CommentNavigationCategory;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if the top edge of an element is visible in the viewport
 * Used to determine if scrolling is needed based on element visibility
 */ const $0343eaf78527fd4c$var$isElementTopVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
};
/**
 * Wait for an element to finish scrolling into view
 * Returns a Promise that resolves when the element is reasonably visible or times out
 */ const $0343eaf78527fd4c$var$waitForScrollCompletion = (element, timeout = 3000)=>{
    return new Promise((resolve)=>{
        const startTime = Date.now();
        const check = ()=>{
            if ($0343eaf78527fd4c$var$isElementTopVisible(element)) // Add a small delay after element becomes visible to let scrolling settle
            setTimeout(()=>resolve(true), 150);
            else if (Date.now() - startTime > timeout) resolve(false);
            else requestAnimationFrame(check);
        };
        // Small delay to let scroll animation start
        setTimeout(check, 16);
    });
};
/**
 * Helper function for viewport checking - returns true if should skip scrolling due to viewport visibility
 */ const $0343eaf78527fd4c$var$checkAndHandleViewportVisibility = (element, shouldScrollIfCommentIsInViewport)=>{
    if (!shouldScrollIfCommentIsInViewport) {
        const commentIsInViewport = $0343eaf78527fd4c$var$isElementTopVisible(element);
        if (commentIsInViewport) return true;
    }
    return false;
};
/**
 * Handle scroll completion based on awaitScrollCompletion flag and scroll behavior
 */ const $0343eaf78527fd4c$var$handleScrollCompletion = (awaitScrollCompletion, scrollBehavior, element)=>{
    if (awaitScrollCompletion) return scrollBehavior === "smooth" ? $0343eaf78527fd4c$var$waitForScrollCompletion(element) : Promise.resolve(true);
    return true;
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? (0, $kgNLQ.CommentType).INLINE : (0, $kgNLQ.CommentType).GENERAL;
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? (0, $kgNLQ.CommentType).INLINE : (0, $kgNLQ.CommentType).GENERAL;
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(commentThreadElement, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        // For panel navigation, always return Promise when awaitScrollCompletion is true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, commentThreadElement);
    }
    // Use optimized observer to watch for comment thread container creation
    if (commentId) (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    else if (annotationId) (0, $aHcFH.watchForCommentContainerAndScroll)('', annotationId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector(containerId) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(containerId);
    if (existingComment) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(existingComment, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        // Wait for scroll completion when awaitScrollCompletion is true, otherwise return true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, existingComment);
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.querySelector(containerId) : // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
                document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    }
    // we need to click on the annotation in the editor if the comment is not yet rendered
    if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
        targetElement: markElement,
        targetElementID: markElement.id,
        shouldScroll: false
    });
    // Comment not yet rendered, use DOM resolver to watch for it
    (0, $aHcFH.watchForCommentRepliesAndScroll)({
        targetCommentId: commentId,
        onScrollReady: (commentElement)=>{
            commentElement.scrollIntoView({
                behavior: scrollBehavior,
                block: block,
                inline: inline
            });
        },
        markElement: markElement
    });
    return true;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved, previousAnnotationId: previousAnnotationId } = options;
    // Get the mark element for both inline navigation and annotation events
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let markElement = document.getElementById(annotationId);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    // Get the previous comment element for difference-based scrolling
    const previousCommentElement = previousAnnotationId ? // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById(previousAnnotationId) : null;
    // Check if the mark element is in a sticky table header and adjust if needed
    const isInStickyTableHeader = markElement?.closest && markElement.closest('.pm-table-sticky-wrapper');
    if (isInStickyTableHeader && markElement && (0, $6mKj3.expValEquals)('confluence_comment_enable_table_header_navigation', 'isEnabled', true)) // Get the real element from the non-sticky table using getNodeForTableORMacro
    markElement = (0, $aHcFH.getNodeForTableORMacro)(markElement) || markElement;
    if (commentType === 'FOOTER') $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === 'INLINE' && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For standalone navigation (comments panel closed), expand the element if needed
    if (commentType === 'INLINE' && context === "renderer") (0, $aHcFH.checkElementExpand)(markElement, true);
    // Use difference-based scrolling if we have both previous and next elements
    if (previousCommentElement && markElement && previousCommentElement !== markElement && (0, $6mKj3.expValEquals)('confluence_comment_use_kbs_exp', 'isEnabled', true)) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between next and previous comment positions
                const nextRect = markElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = nextRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment with difference-based scrolling
        (0, $aHcFH.scrollToComment)(markElement, previousCommentElement, true, false);
        return true;
    }
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
/**
 * Calculate the height of media comment placeholder to adjust scroll offset.
 * When the media comment placeholder is visible, it pushes the contents of the page down,
 * so we need to scroll a bit less to keep the cursor over the navigation arrow icon.
 */ const $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight = (options)=>{
    const { previousCommentElement: previousCommentElement, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === totalComments - 1;
    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
        return mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
    }
    return 0;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    // Get the next comment element
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const previousCommentElement = document.getElementById(previousMarkerRef);
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        const heightOfMediaCommentSelectedPlaceholder = $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight({
            previousCommentElement: previousCommentElement,
            action: action,
            nextCommentIndex: nextCommentIndex,
            totalComments: totalComments
        });
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions using calculateElementOffset
                // This handles special cases like sticky table headers
                const previousOffset = (0, $aHcFH.calculateElementOffset)(previousCommentElement);
                const nextOffset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const differenceOffset = nextOffset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
/**
 * Wait for a comment marker element to appear in the DOM.
 * Resolves immediately if the element already exists, otherwise waits via MutationObserver until timeout.
 */ const $0343eaf78527fd4c$var$waitForCommentElement = ({ markerRef: markerRef, timeoutMs: timeoutMs })=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const existingElement = document.getElementById(markerRef);
    if (existingElement) return Promise.resolve(existingElement);
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(markerRef);
            if (!element) return;
            observer.disconnect();
            resolve(element);
        });
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            observer.disconnect();
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const fallbackElement = document.getElementById(markerRef);
            resolve(fallbackElement);
        }, timeoutMs);
    });
};
const $0343eaf78527fd4c$export$6591627df1eb1f44 = async ({ markerRef: markerRef, commentId: commentId, timeoutMs: timeoutMs = 3000, getCommentThreadsRemovedByOtherUsers: getCommentThreadsRemovedByOtherUsers })=>{
    let element = null;
    const waitStartedAt = Date.now();
    if (markerRef) element = await $0343eaf78527fd4c$var$waitForCommentElement({
        markerRef: markerRef,
        timeoutMs: timeoutMs
    });
    const annotationWaitMs = Date.now() - waitStartedAt;
    // Read processed state after DOM wait to avoid stale classification.
    const state = (0, $4L9ve.getProcessedCommentsDataState)();
    const rootComment = state.isDataProcessed && markerRef ? state.flatMarkerRefMap[markerRef] : undefined;
    const commentFoundInData = Boolean(rootComment || commentId && state.flatCommentsMap[commentId]);
    const diagnosticsFor = (navigationCategory)=>({
            navigationCategory: navigationCategory,
            annotationFoundInDom: Boolean(element),
            commentFoundInData: commentFoundInData,
            commentsDataLoaded: state.isDataProcessed,
            commentsDataFailed: Boolean(state.error),
            commentsDataCount: state.commentCount,
            annotationWaitMs: annotationWaitMs
        });
    // NOTE - we can't import the official type here due to circular dep concerns
    if (commentId) {
        const commentThreadsRemovedByOtherUsers = getCommentThreadsRemovedByOtherUsers?.();
        if (commentThreadsRemovedByOtherUsers?.[commentId] === 'deleted') return {
            status: "REMOVED_BY_ANOTHER_USER",
            element: undefined,
            diagnostics: diagnosticsFor("COMMENT_REMOVED_BY_ANOTHER_USER")
        };
    }
    if (element) {
        if (rootComment && (0, $kgNLQ.isCommentResolved)(rootComment)) return {
            status: "RESOLVED",
            element: undefined,
            diagnostics: diagnosticsFor("COMMENT_RESOLVED")
        };
        return {
            status: "FOUND_IN_DOM",
            element: element,
            diagnostics: diagnosticsFor(commentFoundInData ? "FOUND" : "ANNOTATION_FOUND_COMMENT_MISSING")
        };
    }
    if (!state.isDataProcessed) return {
        status: "UNKNOWN",
        element: undefined,
        diagnostics: diagnosticsFor(state.error ? "COMMENTS_DATA_ERROR" : "COMMENTS_DATA_NOT_LOADED")
    };
    if (commentFoundInData) return {
        status: "DELETED_CONTENT",
        element: undefined,
        diagnostics: diagnosticsFor("ANNOTATION_MISSING_COMMENT_FOUND")
    };
    return {
        status: "UNKNOWN",
        element: undefined,
        diagnostics: diagnosticsFor(state.error ? "COMMENTS_DATA_ERROR" : "ANNOTATION_AND_COMMENT_MISSING")
    };
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["CommentNavigationStatus"] = $0343eaf78527fd4c$export$368ed1d84e0ae668;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;
module.exports["waitForCommentStatus"] = $0343eaf78527fd4c$export$6591627df1eb1f44;

});

parcelRegister("fJCU9", function(module, exports) {

var $eSa5t = parcelRequire("eSa5t");

var $0e40051270b2c33f$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $0e40051270b2c33f$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($eSa5t)))();
    }
}
module.exports["AnnotationUpdateEvent"] = $0e40051270b2c33f$export$c1c4b33b4e7b1c70;
module.exports["AnnotationUpdateEmitter"] = $0e40051270b2c33f$export$7cc60aa9ef845515;

});

parcelRegister("gczDe", function(module, exports) {

var $cz6eP = parcelRequire("cz6eP");

let $d31fe98ca852fa54$var$rendererEmitter = undefined;
const $d31fe98ca852fa54$export$894d051c63add88c = ()=>{
    if (!$d31fe98ca852fa54$var$rendererEmitter) $d31fe98ca852fa54$var$rendererEmitter = new (0, $cz6eP.AnnotationUpdateEmitter)();
    return $d31fe98ca852fa54$var$rendererEmitter;
};
module.exports["getRendererAnnotationEventEmitter"] = $d31fe98ca852fa54$export$894d051c63add88c;

});

parcelRegister("4L9ve", function(module, exports) {
/**
 * Sweet state store for processed comments data.
 * This store should ONLY be updated by CommentsDataBackgroundLoader.
 * All other consumers should use the state/actions hooks to read data.
 */ 
var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $kgNLQ = parcelRequire("kgNLQ");

const $20eb19f7ec5706e8$export$53ac33307b5acee9 = ()=>({
        lastProcessedData: null,
        allComments: [],
        allFilteredComments: [],
        openInlineComments: [],
        openFooterComments: [],
        resolvedComments: [],
        openComments: [],
        commentsDataMap: {
            inline: {},
            general: {}
        },
        flatCommentsMap: {},
        flatMarkerRefMap: {},
        hasNestedComments: false,
        isDataProcessed: false,
        commentCount: 0,
        hasAnyComments: false,
        error: undefined,
        refetch: undefined
    });
const $20eb19f7ec5706e8$export$e324594224ef24da = {
    /**
	 * Updates all processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 * Note: refetch is set separately via setRefetch, so it's not included here.
	 */ setProcessedData: (data)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...data,
                error: undefined,
                // Keep existing refetch if it exists, don't overwrite it
                refetch: currentState.refetch
            });
        },
    /**
	 * Sets an error state for processed comments data.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setError: (error)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                error: error,
                isDataProcessed: true
            });
        },
    /**
	 * Clears error and resets isDataProcessed to initial values.
	 * Skips setState when already at initial values to avoid unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearErrorAndResetIsDataProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const initialState = $20eb19f7ec5706e8$export$53ac33307b5acee9();
            if (currentState.error === initialState.error && currentState.isDataProcessed === initialState.isDataProcessed) return;
            setState({
                ...currentState,
                error: initialState.error,
                isDataProcessed: initialState.isDataProcessed
            });
        },
    /**
	 * Sets isDataProcessed to true without changing other state.
	 * Only updates if isDataProcessed is currently false to prevent unnecessary re-renders.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setDataToProcessed: ()=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            if (currentState.isDataProcessed) return;
            setState({
                ...currentState,
                isDataProcessed: true
            });
        },
    /**
	 * Sets the refetch function from useAllCommentsData.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ setRefetch: (refetch)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                refetch: refetch
            });
        },
    /**
	 * Clears all processed comments data and resets to initial state.
	 * WARNING: This should ONLY be called by CommentsDataBackgroundLoader.
	 */ clearProcessedData: ()=>({ setState: setState })=>{
            setState($20eb19f7ec5706e8$export$53ac33307b5acee9());
        },
    /**
	 * Processes the raw comments data if it hasn't already been processed and updates the store with
	 * categorized comments. Can be used with output from useAllCommentsData() hook (that is, the full
	 * comments data query result) or the full comments data cache (for when we need to synchronously
	 * process updated cache data).
	 *
	 * Note that for Apollo GQL, if the data hasn't changed then readQuery() will return the same
	 * data reference as the full comment query does. So it is safe to compare data references from
	 * real queries and cache reads to avoid unnecessary reprocessing.
	 *
	 */ // TODO: Verify the data reference behavior for Relay GQL when we start enabling Relay support.
    processCommentsData: ({ data: data, pageMode: pageMode })=>({ setState: setState, getState: getState })=>{
            // Nothing to process if data is null
            if (!data) return null;
            // Don't process the same data twice - if the data reference is the same as the last processed
            const currentState = getState();
            if (currentState.isDataProcessed && currentState.lastProcessedData === data) return null;
            // Filter out null nodes and create array (empty array if no data)
            const allComments = (data?.comments?.nodes || []).filter((node)=>node !== null);
            // Categorize comments using default contentStatus filters
            const contentStatusFilters = (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode);
            const categorizedData = (0, $kgNLQ.categorizeComments)(allComments, contentStatusFilters);
            // Update the store with categorized comments
            setState({
                ...currentState,
                ...categorizedData,
                allComments: allComments,
                lastProcessedData: data,
                error: undefined,
                isDataProcessed: true
            });
            return {
                total: categorizedData.allFilteredComments.length,
                openInline: categorizedData.openInlineComments.length,
                openFooter: categorizedData.openFooterComments.length,
                open: categorizedData.openComments.length,
                resolved: categorizedData.resolvedComments.length,
                totalIncludingReplies: Object.keys(categorizedData.flatCommentsMap).length,
                markerRef: Object.keys(categorizedData.flatMarkerRefMap).length
            };
        }
};
const $20eb19f7ec5706e8$export$4be6ac988c62a591 = (0, $8s9DV.createStore)({
    initialState: $20eb19f7ec5706e8$export$53ac33307b5acee9(),
    actions: $20eb19f7ec5706e8$export$e324594224ef24da,
    name: 'ProcessedCommentsDataStore'
});
const $20eb19f7ec5706e8$export$421cff7071854c91 = (0, $kBr4q.createHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$2919c8d01260d4fe = (0, $kBr4q.createActionsHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$93d43ef0fc9d136b = (0, $kBr4q.createStateHook)($20eb19f7ec5706e8$export$4be6ac988c62a591);
// Non-React utility for accessing store outside of React components
const $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance = (0, $c6StJ.defaultRegistry).getStore($20eb19f7ec5706e8$export$4be6ac988c62a591);
const $20eb19f7ec5706e8$export$db6951977b558d4d = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.storeState.getState();
};
const $20eb19f7ec5706e8$export$ae4b56ccf0bbe776 = ()=>{
    return $20eb19f7ec5706e8$var$processedCommentsDataStoreInstance.actions;
};
module.exports["useProcessedCommentsData"] = $20eb19f7ec5706e8$export$421cff7071854c91;
module.exports["useProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$2919c8d01260d4fe;
module.exports["useProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$93d43ef0fc9d136b;
module.exports["getProcessedCommentsDataState"] = $20eb19f7ec5706e8$export$db6951977b558d4d;
module.exports["getProcessedCommentsDataActions"] = $20eb19f7ec5706e8$export$ae4b56ccf0bbe776;

});

parcelRegister("kgNLQ", function(module, exports) {

var $cD1qu = parcelRequire("cD1qu");


var $jbF1h = parcelRequire("jbF1h");

var $344a24116515d334$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}({});
const $344a24116515d334$export$4883f94fcd5fa7aa = {
    ari: '',
    containerAri: '',
    reactionsCount: 0,
    reactionsSummaryForEmoji: [],
    __typename: 'ReactionsSummaryResponse'
};
const $344a24116515d334$export$99a332599a946905 = '998765432100';
const $344a24116515d334$export$c6a7031105fdebc = (commentData, commentId)=>{
    // Search in retreived comments and their replies
    for (const comment of commentData){
        // Check if this is the comment we're looking for
        if (comment?.id === commentId) return comment;
        // Check if it's in the replies
        if (comment?.replies) {
            const foundReply = comment.replies.find((reply)=>reply?.id === commentId);
            if (foundReply) return foundReply;
        }
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$6ba3a6375d12d24f = (commentData, replyParentId)=>{
    // Search through each root level comment's replies
    for (const comment of commentData){
        // Return this comment if it is the parent of the reply, else check if this comment has replies
        // and if any of them have the matching parentId
        if (comment?.id === replyParentId || comment?.replies.find((reply)=>reply?.id === replyParentId)) return comment;
    }
    // else comment not found
    return undefined;
};
const $344a24116515d334$export$3e4a472ec0de2dc6 = (commentData, markerRef)=>{
    // Search in retrieved comments and their replies
    for (const comment of commentData){
        // Check if this comment's marker ref matches
        const location = comment?.location;
        if (location?.inlineMarkerRef === markerRef) return comment;
    }
    return undefined;
};
const $344a24116515d334$export$499492f953d5abba = (comments, commentId, markerRef, contentStatus)=>{
    if (comments.length === 0) return undefined;
    let foundComment;
    if (commentId) foundComment = $344a24116515d334$export$c6a7031105fdebc(comments, commentId);
    else if (markerRef) foundComment = $344a24116515d334$export$3e4a472ec0de2dc6(comments, markerRef);
    if (!foundComment) return undefined;
    // Filter by contentStatus before returning
    const matchesContentStatusFilter = (comment)=>{
        if (!comment || !comment.contentStatus) return false;
        // Convert comment's contentStatus to uppercase to match GraphQLContentStatus format
        const commentStatus = comment.contentStatus.toUpperCase();
        return contentStatus.includes(commentStatus);
    };
    if (matchesContentStatusFilter(foundComment)) return foundComment;
    return undefined;
};
const $344a24116515d334$export$4d95f4b945556294 = (comment, mutationResult)=>{
    const resolveInlineComment = mutationResult?.data?.resolveInlineComment;
    const mutationStatus = resolveInlineComment?.status ?? false;
    const resolveProperties = resolveInlineComment?.resolveProperties ?? undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$d81a62b32f0e420f = (comment, mutationResult)=>{
    const commentResolutionStates = mutationResult?.data?.confluence_resolveComments?.commentResolutionStates;
    if ((commentResolutionStates?.length ?? 0) > 1) throw new Error('resolveCommentInCacheCallback() only supports one comment resolution state per mutation call');
    const firstResolutionState = commentResolutionStates?.[0] ?? undefined;
    const mutationStatus = firstResolutionState?.status ?? false;
    const partialResolveProperties = firstResolutionState?.resolveProperties ?? undefined;
    // We need to ensure that resolveProperties contains all non-optional properties so we can safely
    // spread it into the comment location resolve properties, so choose defaults for any missing
    // ones.  This is needed because some of the mutations don't request all the properties in their
    // responses.
    const resolveProperties = partialResolveProperties ? {
        resolved: true,
        isDangling: false,
        // These are nullable in the schema, but included to make Typescript happy
        resolvedUser: undefined,
        resolvedFriendlyDate: undefined,
        resolvedTime: undefined,
        // Add any non-null/undefined properties from the mutation result
        ...partialResolveProperties
    } : undefined;
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: mutationStatus,
        resolveProperties: resolveProperties
    });
};
const $344a24116515d334$export$aa65246494e3c3e0 = (comment, mutationResult)=>{
    // (The property is called "commentResolutionStates" but there is only one item per mutation call)
    const commentResolutionStates = mutationResult?.data?.confluence_reopenComment?.commentResolutionStates;
    if (commentResolutionStates) {
        const mutationStatus = commentResolutionStates.status ?? false;
        const partialResolveProperties = commentResolutionStates.resolveProperties ?? undefined;
        // We need to ensure that resolveProperties contains all non-optional properties so we can safely
        // spread it into the comment location resolve properties, so choose defaults for any missing
        // ones. This is needed because some of the mutations don't request all the properties - or even
        // the commentResolutionStates property at all in their responses.
        const resolveProperties = {
            resolved: false,
            isDangling: false,
            // These are nullable in the schema, but included to make Typescript happy
            resolvedUser: undefined,
            resolvedFriendlyDate: undefined,
            resolvedTime: undefined,
            // Add any non-null/undefined properties from the mutation result
            ...partialResolveProperties
        };
        return (0, $jbF1h.resolveCommentInCache)({
            comment: comment,
            mutationStatus: mutationStatus,
            resolveProperties: resolveProperties
        });
    }
    // Else commentResolutionStates wasn't returned - assume failure to reopen
    return (0, $jbF1h.resolveCommentInCache)({
        comment: comment,
        mutationStatus: false,
        resolveProperties: undefined
    });
};
const $344a24116515d334$export$e237bdee87974d46 = (pageMode)=>{
    // On view pages, exclude draft comments
    if (pageMode === (0, $cD1qu.PageMode).VIEW) return [
        'CURRENT',
        'ARCHIVED'
    ];
    // On edit and live pages, include all statuses
    return [
        'CURRENT',
        'ARCHIVED',
        'DRAFT'
    ];
};
const $344a24116515d334$export$70df9f207ee9869d = (comment)=>{
    const location = comment?.location;
    if (location) {
        if ('inlineResolveProperties' in location) return location.inlineResolveProperties?.resolved ?? false;
        else if ('commentResolveProperties' in location) return location.commentResolveProperties?.resolved ?? false;
    }
    return false;
};
const $344a24116515d334$export$6036c2c532b2fa41 = (commentsDataMap)=>{
    try {
        const allGeneralComments = Object.values(commentsDataMap.general);
        // To see if there are nested comments, we need to check whether there are any replies whose parentID is not equal to the parent Comment's ID
        // This is because commentsDataMap.general is a flat map of parent comment --> everything below it
        // But each comment has it's own parent id which may be different from it's top level parent
        return allGeneralComments.some((comment)=>{
            return comment?.replies?.some((reply)=>reply && reply.parentId !== comment.id);
        });
    } catch  {
        // Default to false if somehow something goes wrong
        return false;
    }
};
const $344a24116515d334$export$2fa0b601110c277b = (comments, contentStatusFilters)=>{
    const allFilteredComments = [];
    const openComments = [];
    const openInlineComments = [];
    const openFooterComments = [];
    const resolvedComments = [];
    // Transform array-based data to map structure for legacy compatibility
    const commentsDataMap = {
        inline: {},
        general: {}
    };
    // Build flat map of all comments (including replies) for O(1) lookup by commentId
    const flatCommentsMap = {};
    // Build flat map of inline comments keyed by markerRef for O(1) lookup
    const flatMarkerRefMap = {};
    for (const comment of comments)// Filter by content status, which is a string literal type (that is, a set of allowed
    // strings), so be cautious if the definitions or schema change
    if (comment && contentStatusFilters.includes(comment.contentStatus?.toUpperCase())) {
        allFilteredComments.push(comment);
        // Add comment to flat map by commentId
        if (comment?.id) flatCommentsMap[comment.id] = comment;
        // Add inline parent comment to flatMarkerRefMap by markerRef (only parent comments, not replies)
        if (comment?.location?.type === 'INLINE' && !comment?.parentId) {
            const location = comment.location;
            if (location?.inlineMarkerRef) flatMarkerRefMap[location.inlineMarkerRef] = comment;
        }
        // Add all replies to flat map
        if (comment?.replies) {
            for (const reply of comment.replies)if (reply?.id) flatCommentsMap[reply.id] = reply;
        }
        const isOpen = !$344a24116515d334$export$70df9f207ee9869d(comment);
        const commentType = comment.location?.type === 'INLINE' ? "inline" : "general";
        const commentWithProperties = {
            ...comment,
            type: commentType,
            isOpen: isOpen,
            replies: comment.replies?.filter((reply)=>reply !== null && reply !== undefined).map((reply)=>({
                    ...reply
                }))
        };
        if (isOpen) {
            openComments.push(comment);
            if (comment?.location?.type === 'INLINE') openInlineComments.push(comment);
            else if (comment?.location?.type === 'FOOTER') openFooterComments.push(comment);
        // else unknown or missing location type, do nothing
        } else resolvedComments.push(comment);
        if (comment.location?.type === 'INLINE') {
            const threadKey = 'inlineMarkerRef' in comment.location ? comment.location.inlineMarkerRef || comment.id : comment.id;
            commentsDataMap.inline[threadKey] = commentWithProperties;
        } else if (comment.location?.type === 'FOOTER') commentsDataMap.general[comment.id] = commentWithProperties;
    }
    const hasNestedComments = $344a24116515d334$export$6036c2c532b2fa41(commentsDataMap);
    const commentCount = allFilteredComments.length;
    const hasAnyComments = commentCount > 0;
    return {
        allFilteredComments: allFilteredComments,
        openComments: openComments,
        openInlineComments: openInlineComments,
        openFooterComments: openFooterComments,
        resolvedComments: resolvedComments,
        commentsDataMap: commentsDataMap,
        flatCommentsMap: flatCommentsMap,
        flatMarkerRefMap: flatMarkerRefMap,
        hasNestedComments: hasNestedComments,
        commentCount: commentCount,
        hasAnyComments: hasAnyComments
    };
};
const $344a24116515d334$export$5c24224d7e29c719 = ()=>{
    return {
        context: {
            fetchOptions: {
                ignoreNoNetworkError: true
            }
        }
    };
};
module.exports["CommentType"] = $344a24116515d334$export$ffa1150e6a48f9cd;
module.exports["emptyReactionsSummary"] = $344a24116515d334$export$4883f94fcd5fa7aa;
module.exports["OPTIMISTIC_SAVE_COMMENT_ID"] = $344a24116515d334$export$99a332599a946905;
module.exports["findCommentInData"] = $344a24116515d334$export$c6a7031105fdebc;
module.exports["findRootCommentForReply"] = $344a24116515d334$export$6ba3a6375d12d24f;
module.exports["findAndFilterComment"] = $344a24116515d334$export$499492f953d5abba;
module.exports["resolveInlineCommentInCacheCallback"] = $344a24116515d334$export$4d95f4b945556294;
module.exports["resolveCommentInCacheCallback"] = $344a24116515d334$export$d81a62b32f0e420f;
module.exports["reopenCommentInCacheCallback"] = $344a24116515d334$export$aa65246494e3c3e0;
module.exports["buildDefaultCommentsContentStatusFilters"] = $344a24116515d334$export$e237bdee87974d46;
module.exports["isCommentResolved"] = $344a24116515d334$export$70df9f207ee9869d;
module.exports["categorizeComments"] = $344a24116515d334$export$2fa0b601110c277b;
module.exports["buildMutationContextForNoNetworkError"] = $344a24116515d334$export$5c24224d7e29c719;

});

parcelRegister("jbF1h", function(module, exports) {

var $82R8R = parcelRequire("82R8R");


var $6nYhN = parcelRequire("6nYhN");


var $cozmU = parcelRequire("cozmU");


var $ij4CE = parcelRequire("ij4CE");


var $fFmJj = parcelRequire("fFmJj");







// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/useCommentById.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this function - or at least the cache updating parts for the function
// - into the useAllCommentsData.ts file.
const $bd790562493588ff$var$updateCommentInCacheFragment = (0, $6nYhN.default);
// Fragment for reply comments (matches the replies schema from the main fragment)
const $bd790562493588ff$var$updateReplyInCacheFragment = (0, $82R8R.default);
// Type guard to check if a comment is a top-level comment (has replies field)
const $bd790562493588ff$var$isTopLevelComment = (comment)=>{
    return 'replies' in comment;
};
const $bd790562493588ff$export$8ce65958c48a9ac3 = ()=>{
    const readFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $6nYhN.default),
        fragmentSpec: $bd790562493588ff$var$updateCommentInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const readReplyFragment = (0, $fFmJj.useReadFragmentInterop)({
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    const writeReplyFragment = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentArtifact: (0, $82R8R.default),
        fragmentSpec: $bd790562493588ff$var$updateReplyInCacheFragment,
        __callerPackage__: "comments-data-manager"
    });
    /**
   * Function to update a comment in the Apollo cache.
   * @param mutationResult - The result of the mutation that triggered the cache update
   * @param commentId - ID of the comment to update
   * @param updateCallback - Callback function that receives the current comment data
   *                         and returns the updated comment data
   * @param onError - Optional error callback to handle errors during the update process
   * @param isReply - Whether this comment is a reply (true) or top-level comment (false)
   */ const updateCommentInCache = (0, $cozmU.useCallback)(({ mutationResult: mutationResult, commentId: commentId, updateCallback: updateCallback, onError: onError, isReply: isReply = false })=>{
        if (!commentId) {
            onError?.(new Error('Cannot update comment in cache: comment ID is missing'));
            return;
        }
        try {
            // The fragment ID format for Apollo cache
            const fragmentId = `Comment:${commentId}`;
            let cachedComment = null;
            if (isReply) cachedComment = readReplyFragment({
                id: fragmentId
            });
            else cachedComment = readFragment({
                id: fragmentId
            });
            if (!cachedComment) {
                // (There is a slight chance the comment is not in cache - but the mutation that calls
                // this function would have to completed successfully to call us, so presumably the
                // comment existed then. Thus the only legit reason for it to be missing from the cache
                // now is if another user deleted the comment in between the mutation and this cache
                // update call. That is unlikely, so let's log this as an error and return. If in
                // the future we find the legit use case is happening more often, we can change to a
                // warning instead.)
                onError?.(new Error(`Cannot update comment in cache: comment with ID ${commentId} not found in cache`));
                return;
            }
            // Apply the update callback on a copy of the cached comment
            // (Note that the updateCallback should return a new object, not mutate the original - so
            //  make copies of any nested objects you need to change also)
            const updatedComment = updateCallback({
                ...cachedComment
            }, mutationResult);
            // Write the updated comment back to cache using appropriate fragment
            if (isReply) writeReplyFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
            else writeFragment({
                fragmentId: fragmentId,
                data: updatedComment
            });
        } catch (err) {
            onError?.(new Error(`An error occurred when updating cached comment data: ${err}`));
            return;
        }
    }, [
        readFragment,
        writeFragment,
        readReplyFragment,
        writeReplyFragment
    ]);
    return {
        updateCommentInCache: updateCommentInCache
    };
};
const $bd790562493588ff$export$9e04af313e7174f4 = ({ comment: comment, mutationStatus: mutationStatus, resolveProperties: resolveProperties })=>{
    if (!mutationStatus || !resolveProperties) // Mutation result is missing or incomplete - so just return the comment unchanged
    return comment;
    // Extract isDangling separately since it is handled differently, and exclude __typename since we
    // don't need it and Typescript would complain about it being included in the spread below.
    const { __typename: __typename, isDangling: isDangling, ...otherResolveProperties } = resolveProperties;
    // Defaults for the nullable resolve fields. A partial mutation response (e.g. a reopen that only
    // returns `resolved: false`) leaves these `undefined` in the write data. The interop fragment
    // writer skips `undefined` scalars (setRelayScalarValue), so those fields would be absent in the
    // store and Relay warns "Missing field resolvedFriendlyDate/..." on the next read. Seeding them
    // as explicit `null` (their unresolved value) keeps the resolve-properties record complete; any
    // real value from the mutation response still overrides via the spread below.
    const resolvePropertyDefaults = {
        resolvedUser: null,
        resolvedFriendlyDate: null,
        resolvedTime: null
    };
    // Mark the comment as resolved in the cache, but how to do that depends on the comment type
    const location = comment.location;
    const newLocation = {
        ...location,
        ...'commentResolveProperties' in location ? {
            commentResolveProperties: {
                ...location.commentResolveProperties,
                ...resolvePropertyDefaults,
                ...otherResolveProperties
            }
        } : {},
        ...'inlineResolveProperties' in location ? {
            inlineResolveProperties: {
                ...location.inlineResolveProperties,
                ...resolvePropertyDefaults,
                ...otherResolveProperties,
                isDangling: isDangling
            }
        } : {}
    };
    // @ts-expect-error - FIXME: This error was surfaced after enabling the `typescriptExcludeUndefinedFromNullableUnion`
    // Relay compiler option. Previously, `undefined` was incorrectly included in nullable unions in generated types; this option removes it. The owning team should fix this properly.
    return {
        ...comment,
        location: newLocation
    };
};
const $bd790562493588ff$export$df3d27666bd765d5 = (comment, mutationResult)=>{
    const newBodyValue = mutationResult?.data?.updateComment?.body?.value;
    const updatedBody = {
        ...comment.body,
        // Remember that an empty string is a valid body value, so only skip updating if newBodyValue
        // is null or undefined
        ...newBodyValue || newBodyValue === '' ? {
            value: newBodyValue
        } : {}
    };
    const newVersion = mutationResult?.data?.updateComment?.version;
    const newDisplayName = newVersion?.by?.displayName;
    // If the existing comment's version doesn't have a "by" field, we don't want to add just part
    // of it - so set it to undefined so it won't be included in the updated comment. This probably
    // won't actually ever happen, but it makes Typescript happy just in case.
    const updatedBy = comment.version?.by ? {
        ...comment.version?.by,
        ...newDisplayName ? {
            displayName: newDisplayName
        } : {}
    } : undefined;
    const updatedVersion = {
        ...comment.version,
        ...newVersion?.number ? {
            number: newVersion.number
        } : {},
        ...newVersion?.when ? {
            when: newVersion.when
        } : {},
        ...updatedBy ? {
            by: {
                ...updatedBy
            }
        } : {}
    };
    const baseUpdatedComment = {
        ...comment,
        body: updatedBody,
        version: {
            ...updatedVersion
        }
    };
    // Return with appropriate type casting based on comment type
    return $bd790562493588ff$var$isTopLevelComment(comment) ? baseUpdatedComment : baseUpdatedComment;
};
module.exports["useUpdateCommentInCache"] = $bd790562493588ff$export$8ce65958c48a9ac3;
module.exports["resolveCommentInCache"] = $bd790562493588ff$export$9e04af313e7174f4;
module.exports["updateCommentBodyInCacheCallback"] = $bd790562493588ff$export$df3d27666bd765d5;

});

parcelRegister("82R8R", function(module, exports) {
/**
 * @generated SignedSource<<b6af2e5e8b1c672924f300605e9d9ac3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6ee66e0478f0211a$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v4 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v5 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v6 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheReplyFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "id"
            },
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "permissionType"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "accountId"
                            }
                        ],
                        "type": "KnownUser"
                    },
                    {
                        "concreteType": "Icon",
                        "kind": "LinkedField",
                        "name": "profilePicture",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "path"
                            }
                        ]
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "representation",
                        "value": "ATLAS_DOC_FORMAT"
                    }
                ],
                "concreteType": "DocumentBody",
                "kind": "LinkedField",
                "name": "body",
                "plural": false,
                "selections": v2 /*: any*/ ,
                "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
            },
            {
                "kind": "ScalarField",
                "name": "contentStatus"
            },
            {
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "createdAt",
                "plural": false,
                "selections": v2 /*: any*/ 
            },
            {
                "kind": "ScalarField",
                "name": "createdAtNonLocalized"
            },
            {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "editui"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "name": "location",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "commentResolveProperties",
                                "plural": false,
                                "selections": [
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            }
                        ],
                        "type": "FooterComment"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "inlineMarkerRef"
                            },
                            {
                                "concreteType": "InlineCommentResolveProperties",
                                "kind": "LinkedField",
                                "name": "inlineResolveProperties",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDangling"
                                    },
                                    v3 /*: any*/ ,
                                    v4 /*: any*/ ,
                                    v5 /*: any*/ ,
                                    v6 /*: any*/ 
                                ]
                            },
                            {
                                "kind": "ScalarField",
                                "name": "inlineText"
                            }
                        ],
                        "type": "InlineComment"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "parentId"
            },
            {
                "concreteType": "CommentPermissions",
                "kind": "LinkedField",
                "name": "permissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "isEditable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isRemovable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "isResolvable"
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "number"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$6ee66e0478f0211a$var$node.hash = "d793bb57d64855b11bf515ef7082e802";
var $6ee66e0478f0211a$export$2e2bcd8739ae039 = $6ee66e0478f0211a$var$node;
module.exports["default"] = $6ee66e0478f0211a$export$2e2bcd8739ae039;

});

parcelRegister("6nYhN", function(module, exports) {
/**
 * @generated SignedSource<<776c1b585ba7040195aa55b4ce020277>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1d633d5b65e9f4e8$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v2 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v3 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "type"
    }, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v7 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v7 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v10 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v11 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v12 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v14 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v15 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v16 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v17 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v5 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v13 /*: any*/ ,
                            v14 /*: any*/ ,
                            v15 /*: any*/ ,
                            v16 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v19 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v20 = {
        "kind": "LinkedField",
        "name": "contributors",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            v4 /*: any*/ ,
            v6 /*: any*/ 
        ]
    }, v21 = {
        "kind": "ScalarField",
        "name": "number"
    }, v22 = {
        "kind": "ScalarField",
        "name": "when"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "useUpdateCommentInCacheFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "LinkedField",
                "name": "author",
                "plural": false,
                "selections": [
                    v1 /*: any*/ ,
                    v2 /*: any*/ ,
                    v3 /*: any*/ ,
                    v4 /*: any*/ ,
                    v5 /*: any*/ ,
                    v6 /*: any*/ 
                ]
            },
            v8 /*: any*/ ,
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "container",
                "plural": false,
                "selections": [
                    v0 /*: any*/ 
                ]
            },
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ ,
            v20 /*: any*/ ,
            {
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "replies",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ ,
                            v6 /*: any*/ ,
                            v4 /*: any*/ 
                        ]
                    },
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v17 /*: any*/ ,
                    v18 /*: any*/ ,
                    v19 /*: any*/ ,
                    v20 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "by",
                                "plural": false,
                                "selections": [
                                    v1 /*: any*/ ,
                                    v2 /*: any*/ 
                                ]
                            },
                            v21 /*: any*/ ,
                            v22 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v5 /*: any*/ ,
                            v2 /*: any*/ ,
                            v6 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    v21 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ],
        "type": "Comment"
    };
}();
$1d633d5b65e9f4e8$var$node.hash = "3eaa0227f14e77a83748a865f02fa321";
var $1d633d5b65e9f4e8$export$2e2bcd8739ae039 = $1d633d5b65e9f4e8$var$node;
module.exports["default"] = $1d633d5b65e9f4e8$export$2e2bcd8739ae039;

});

parcelRegister("ij4CE", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $7EPz1 = parcelRequire("7EPz1");


var $9wGTI = parcelRequire("9wGTI");


var $iffSy = parcelRequire("iffSy");


var $bqzdu = parcelRequire("bqzdu");


var $kWvcF = parcelRequire("kWvcF");


var $cjdbm = parcelRequire("cjdbm");


var $81Pid = parcelRequire("81Pid");


var $86okN = parcelRequire("86okN");

// While a Relay-native optimistic layer is active (inside commitMutation's optimisticUpdater/updater),
// route the fragment write onto that layer's store proxy instead of committing permanently, so it
// participates in the disposable layer Relay reverts atomically. writeFragmentShim only uses
// `environment.commitUpdate`, so a thin env shim runs its in-place write against the provided proxy.
// Outside an updater this returns false and the normal permanent write path is used.
function $7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragment, fragmentId, data, variables) {
    const ambientStore = (0, $bqzdu.getAmbientStoreProxy)();
    if (!ambientStore || !fragment) return false;
    const ambientEnv = {
        commitUpdate: (updater)=>updater(ambientStore)
    };
    (0, $kWvcF.writeFragmentShim)(ambientEnv, fragment, fragmentId, data, variables);
    return true;
}
const $7fd39030140cad16$export$6e64625354109aa5 = (data, fragmentArtifact)=>(0, $kWvcF.addTypenameToData)(data, fragmentArtifact);
const $7fd39030140cad16$var$useWriteFragmentInteropRelay = (0, $3u0dr.isReactCompilerActiveV2)() ? function useWriteFragmentInteropRelay(args) {
    const $ = (0, $bDgLe.c)(4);
    const { fragmentSpec: fragmentSpec, __callerPackage__: __callerPackage__ } = args;
    const env = (0, $6SsN4.useRelayEnvironment)();
    let t0;
    if ($[0] !== __callerPackage__ || $[1] !== env || $[2] !== fragmentSpec) {
        t0 = (t1)=>{
            const { data: data, fragmentId: fragmentId, variables: variables } = t1;
            if ((0, $9wGTI.fg)("confluence_relay_migration_diagnostics_enabled")) {
                const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
                (0, $cjdbm.logRelayMigrationDiagnostic)("Fragment access", {
                    phase: "fragment",
                    action: "write",
                    api: "useWriteFragmentInterop",
                    callerPackage: __callerPackage__,
                    fragmentName: fragmentName,
                    fragmentType: fragmentType,
                    fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                    relayEnabled: true
                });
            }
            if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragmentSpec, fragmentId, data, variables)) return;
            (0, $kWvcF.writeFragmentShim)(env, fragmentSpec, fragmentId, data, variables);
        };
        $[0] = __callerPackage__;
        $[1] = env;
        $[2] = fragmentSpec;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : function useWriteFragmentInteropRelay(args) {
    const { fragmentSpec: fragmentSpec, __callerPackage__: __callerPackage__ } = args;
    const env = (0, $6SsN4.useRelayEnvironment)();
    return (0, $cozmU.useCallback)(({ data: data, fragmentId: fragmentId, variables: variables })=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
            const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
            (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
                phase: 'fragment',
                action: 'write',
                api: 'useWriteFragmentInterop',
                callerPackage: __callerPackage__,
                fragmentName: fragmentName,
                fragmentType: fragmentType,
                fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                relayEnabled: true
            });
        }
        if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragmentSpec, fragmentId, data, variables)) return;
        (0, $kWvcF.writeFragmentShim)(env, fragmentSpec, fragmentId, data, variables);
    }, [
        env,
        fragmentSpec,
        __callerPackage__
    ]);
};
const $7fd39030140cad16$var$useWriteFragmentInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useWriteFragmentInteropApollo(args) {
    const $ = (0, $bDgLe.c)(5);
    const { fragmentSpec: fragmentSpec, fragmentArtifact: fragmentArtifact, __callerPackage__: __callerPackage__ } = args;
    const apolloClient = (0, $7EPz1.useApolloClient)();
    let t0;
    if ($[0] !== __callerPackage__ || $[1] !== apolloClient || $[2] !== fragmentArtifact || $[3] !== fragmentSpec) {
        t0 = (t1)=>{
            const { data: data, fragmentId: fragmentId, variables: variables, useAggClient: useAggClient } = t1;
            if ((0, $9wGTI.fg)("confluence_relay_migration_diagnostics_enabled")) {
                const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
                (0, $cjdbm.logRelayMigrationDiagnostic)("Fragment access", {
                    phase: "fragment",
                    action: "write",
                    api: "useWriteFragmentInterop",
                    callerPackage: __callerPackage__,
                    fragmentName: fragmentName,
                    fragmentType: fragmentType,
                    fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                    relayEnabled: false
                });
            }
            const dataToWrite = $7fd39030140cad16$export$6e64625354109aa5(data, fragmentArtifact);
            const client = useAggClient && typeof window !== "undefined" ? window.GLOBAL_APOLLO_AGG_CLIENT : apolloClient;
            if (client) client.writeFragment({
                id: fragmentId,
                fragment: (0, $86okN.toDocumentNode)(fragmentSpec),
                data: dataToWrite,
                variables: variables
            });
        };
        $[0] = __callerPackage__;
        $[1] = apolloClient;
        $[2] = fragmentArtifact;
        $[3] = fragmentSpec;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : function useWriteFragmentInteropApollo(args) {
    const { fragmentSpec: fragmentSpec, fragmentArtifact: fragmentArtifact, __callerPackage__: __callerPackage__ } = args;
    const apolloClient = (0, $7EPz1.useApolloClient)();
    return (0, $cozmU.useCallback)(({ data: data, fragmentId: fragmentId, variables: variables, useAggClient: useAggClient })=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
            const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragmentSpec);
            (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
                phase: 'fragment',
                action: 'write',
                api: 'useWriteFragmentInterop',
                callerPackage: __callerPackage__,
                fragmentName: fragmentName,
                fragmentType: fragmentType,
                fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
                relayEnabled: false
            });
        }
        // Add __typename to data using the fragment artifact's type information
        const dataToWrite = $7fd39030140cad16$export$6e64625354109aa5(data, fragmentArtifact);
        // Guard window for server usage while preserving Apollo as the original write target.
        const client = useAggClient && typeof window !== 'undefined' ? window.GLOBAL_APOLLO_AGG_CLIENT : apolloClient;
        if (client) client.writeFragment({
            id: fragmentId,
            fragment: (0, $86okN.toDocumentNode)(fragmentSpec),
            data: dataToWrite,
            variables: variables
        });
    }, [
        apolloClient,
        fragmentSpec,
        fragmentArtifact,
        __callerPackage__
    ]);
};
function $7fd39030140cad16$export$b3a20d310cac24ba(args) {
    return (0, $iffSy.isRelayEnabled)(args.__callerPackage__, {
        phase: 'fragment'
    }) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fd39030140cad16$var$useWriteFragmentInteropRelay(args) : // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fd39030140cad16$var$useWriteFragmentInteropApollo(args);
}
function $7fd39030140cad16$export$a2dd3f95e566e3ed(options) {
    const { fragmentId: fragmentId, data: data, fragment: fragment, variables: variables, useAggClient: useAggClient, __callerPackage__: __callerPackage__ } = options;
    if (!data) return;
    const source = (0, $iffSy.isRelayEnabled)(__callerPackage__, {
        phase: 'fragment'
    }) ? 'relay' : 'apollo';
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('confluence_relay_migration_diagnostics_enabled')) {
        const { fragmentName: fragmentName, fragmentType: fragmentType } = (0, $81Pid.getRelayFragmentMetadata)(fragment);
        (0, $cjdbm.logRelayMigrationDiagnostic)('Fragment access', {
            phase: 'fragment',
            action: 'write',
            api: 'writeFragmentInterop',
            callerPackage: __callerPackage__,
            fragmentName: fragmentName,
            fragmentType: fragmentType,
            fragmentIdKind: (0, $81Pid.getRelayFragmentIdKind)(fragmentId),
            relayEnabled: source === 'relay'
        });
    }
    if (source === 'relay') {
        const env = window['GLOBAL_RELAY_ENV'];
        if (fragment) {
            if ($7fd39030140cad16$var$writeFragmentOntoAmbientLayerIfActive(fragment, fragmentId, data, variables)) return;
            (0, $kWvcF.writeFragmentShim)(env, fragment, fragmentId, data, variables);
        }
        return;
    }
    const client = useAggClient && typeof window !== 'undefined' ? window['GLOBAL_APOLLO_AGG_CLIENT'] : window['GLOBAL_APOLLO_CLIENT'];
    if (client && fragment) {
        const dataToWrite = (0, $kWvcF.addTypenameToData)(data, fragment);
        client.writeFragment({
            id: fragmentId,
            fragment: (0, $86okN.toDocumentNode)(fragment),
            data: dataToWrite,
            variables: variables
        });
    }
}
module.exports["useWriteFragmentInterop"] = $7fd39030140cad16$export$b3a20d310cac24ba;
module.exports["writeFragmentInterop"] = $7fd39030140cad16$export$a2dd3f95e566e3ed;

});

parcelRegister("g6gor", function(module, exports) {

let $bb89ec37245aaadc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bb89ec37245aaadc$var$load("5J2Yz").then(()=>parcelRequire('gJcNU'));

});

parcelRegister("4HVVm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $8zMP3 = parcelRequire("8zMP3");


var $2VZOl = parcelRequire("2VZOl");


var $8KbKw = parcelRequire("8KbKw");


var $hQm1C = parcelRequire("hQm1C");


var $eqNP8 = parcelRequire("eqNP8");


var $kE2cJ = parcelRequire("kE2cJ");


var $1NBp8 = parcelRequire("1NBp8");


var $39rFu = parcelRequire("39rFu");


var $8Hqv7 = parcelRequire("8Hqv7");


var $6mKj3 = parcelRequire("6mKj3");


var $9OVgK = parcelRequire("9OVgK");


var $gXk3R = parcelRequire("gXk3R");


var $6gETM = parcelRequire("6gETM");


var $8jRXE = parcelRequire("8jRXE");


var $3gyyc = parcelRequire("3gyyc");

const $6a336fa33a376cf7$var$EditPageLoaderInternal = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType, ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader })=>{
    const [prevContentId, setPrevContentId] = (0, $cozmU.useState)(contentId);
    const [prevContentType, setPrevContentType] = (0, $cozmU.useState)(contentType);
    const { referredFromLivePage: referredFromLivePage } = (0, $39rFu.useEditPageLoadingValues)();
    const { loadEditor: setEditPageLoadingValues } = (0, $39rFu.useEditPageLoadingActions)();
    const [livePageTransitionHandled, setLivePageTransitionHandled] = (0, $cozmU.useState)(false);
    // This useEffect allows us to unmount and remount the ClassicEditorContextProvider,
    // NativeCollabLoader, and FullPageEditor when switching from one edit page to another edit page.
    // This is necessary to reset the editor properly for edit -> edit transitions.
    (0, $cozmU.useEffect)(()=>{
        setPrevContentId(contentId);
        setLivePageTransitionHandled(false);
    }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        setPrevContentType(contentType);
    }, [
        contentType
    ]);
    // Be careful when modifying this useEffect as this can break live page -> edit page transitions
    // This effect is a temporary solution to address an issue where the editor does not reset properly when navigating from a live page.
    // The editor tends to hold onto state from the previous page, causing problems when switching between pages if a full unmount doesn't occur.
    // This effects resets the editor by force-unmounting it by showing the loading screen when it detects a transition from a live page.
    (0, $cozmU.useEffect)(()=>{
        // livePageTransitionHandled is used to prevent the editor from showing the loading screen endlessly
        if (referredFromLivePage && !livePageTransitionHandled) {
            setLivePageTransitionHandled(true);
            // Need to reset this property or it'll be retained when the browser back button is used.
            // In that case, it doesn't go through the flow that sets the value again.
            setEditPageLoadingValues({
                referredFromLivePage: undefined
            });
        }
    }, [
        referredFromLivePage,
        livePageTransitionHandled,
        setEditPageLoadingValues
    ]);
    if (contentId !== prevContentId || contentType !== prevContentType || referredFromLivePage && !livePageTransitionHandled) // isLoading is set to true by a state change, which does not happen immediately after content id changes
    // To make sure loading screen shows up immediately after content id changes, compare new content id with the content id in ref
    // This is smilar to how componentWillUpdate works in a classic react component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
    const EditPageWrapper = ClassicEditorContextProviderLoader ?? (({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "edit-page-default-wrapper"
        }, children));
    if ((0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) {
        // Native collab sits inside the container, so it can read fragments of EditorContentUnifiedQuery.
        const editor = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9OVgK.EditorContentContainer), {
            contentId: contentId,
            isLivePage: false,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gXk3R.EditorSpaceDetailProvider), {
            contentId: contentId,
            spaceKey: spaceKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hQm1C.NativeCollabLoader), {
            contentId: contentId,
            spaceKey: spaceKey,
            draftShareId: draftShareId,
            contentType: contentType,
            permissionTokenRefresh: (0, $8KbKw.fetchCollabPermissionToken)(contentId, draftShareId)
        }, (propsFromNativeCollab)=>{
            if (propsFromNativeCollab.subType === 'live' && !propsFromNativeCollab.isOverviewPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                name: (0, $1NBp8.VIEW_PAGE).name,
                params: {
                    contentId: contentId,
                    spaceKey: spaceKey
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jRXE.FullPageEditorLoader), {
                ...propsFromNativeCollab,
                extensionContextProvider: {
                    ClassicEditorContextProvider: ClassicEditorContextProviderLoader
                }
            }));
        })));
        return(// @ts-ignore - the same 'isWithinEditor' error as below
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
            scope: contentId
        }, (0, $3gyyc.isSSRStreaming)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-main"
        }, editor) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Hqv7.FullCycleRenderWrapper), null, editor))));
    }
    return(// @ts-ignore - Property 'isWithinEditor' is missing in type '{ children: Element; }' but required in type '{ children: any; isWithinEditor: any; }'
    // This error was introduced after upgrading to TypeScript 5
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditPageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VZOl.NativeCollabPresenceStateContainer), {
        scope: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hQm1C.NativeCollabLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        permissionTokenRefresh: (0, $8KbKw.fetchCollabPermissionToken)(contentId, draftShareId)
    }, (propsFromNativeCollab)=>{
        if (propsFromNativeCollab.subType === 'live' && !propsFromNativeCollab.isOverviewPage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.VIEW_PAGE).name,
            params: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        });
        return (0, $3gyyc.isSSRStreaming)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "content-main"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jRXE.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        }))) : // This TreeRootForServerPlaceholderWrapper placed here to ensure the proper lookup of the placeholders for
        // SSRed loadables. Due to different component trees between server (EditPageLoader) and client (EditPageLoaderServer)
        // the placeholder ids hierarchy is different. This wrapper terminates the lookup for placeholder ids on the common parent,
        // so it matches on both server and client.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Hqv7.FullCycleRenderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gETM.TreeRootForServerPlaceholderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jRXE.FullPageEditorLoader), {
            ...propsFromNativeCollab,
            extensionContextProvider: {
                ClassicEditorContextProvider: ClassicEditorContextProviderLoader
            }
        })));
    }))));
};
const $6a336fa33a376cf7$export$b6d447abe5222d2c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "edit-page-loader"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6a336fa33a376cf7$var$EditPageLoaderInternal, props));
};
module.exports["EditPageLoader"] = $6a336fa33a376cf7$export$b6d447abe5222d2c;

});

parcelRegister("8zMP3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $65DSU = parcelRequire("65DSU");


var $hZpML = parcelRequire("hZpML");


var $cemw8 = parcelRequire("cemw8");


var $8zKDl = parcelRequire("8zKDl");


var $dAPGk = parcelRequire("dAPGk");

const $5cfe2edd168ef31e$export$b17d024ed060ce0b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $dAPGk.useSuspenseBoundaryName)();
} : ()=>(0, $dAPGk.useSuspenseBoundaryName)();
const $5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader = (0, $3u0dr.isReactCompilerActiveV2)() ? function SuspenseWithDataFetcherReader(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { dataFetcher: dataFetcher, children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function SuspenseWithDataFetcherReader({ dataFetcher: dataFetcher, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
function $5cfe2edd168ef31e$export$553ede96e278ba94({ dataFetcherName: dataFetcherName, fallback: fallback = null, children: children }) {
    // Capture the SSR streaming value on initial render using useRef
    // This ensures the component tree doesn't change when the global variable
    // is deleted during route navigation
    const isSSRStreaming = (0, $cozmU.useRef)(window.__SSR_REACT_STREAMING__);
    // Get the current boundary chain from parent context
    const parentBoundaryChain = (0, $cozmU.useContext)((0, $dAPGk.SuspenseBoundaryNameContext));
    // Create new chain by appending current boundary to parent chain
    const currentBoundaryChain = (0, $cozmU.useMemo)(()=>[
            ...parentBoundaryChain,
            dataFetcherName
        ], [
        parentBoundaryChain,
        dataFetcherName
    ]);
    if (isSSRStreaming.current) {
        const dataFetcher = (0, $8zKDl.getDataFetcherForSuspense)(dataFetcherName, isSSRStreaming.current);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAPGk.SuspenseBoundaryNameContext).Provider, {
            value: currentBoundaryChain
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cemw8.HydrationSafeSuspense), {
            fallback: fallback
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5cfe2edd168ef31e$var$SuspenseWithDataFetcherReader, {
            dataFetcher: dataFetcher
        }, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: `stream-suspense-${dataFetcherName}`
        }, children), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SUSPENSE}/${dataFetcherName}.end`))));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
}
module.exports["SuspenseWithDataFetcher"] = $5cfe2edd168ef31e$export$553ede96e278ba94;

});

parcelRegister("cemw8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1P7Cq = parcelRequire("1P7Cq");

const $28f120e398482486$var$HydrationSafeSuspenseContent = /*#__PURE__*/ (0, $cozmU.memo)(function HydrationSafeSuspenseContent({ children: children, fallback: fallback }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallback
    }, children);
}, (_prevProps, nextProps)=>{
    // Block updates while locked (during hydration)
    return nextProps.isLocked;
});
function $28f120e398482486$export$a0bfcafd6d556141({ fallback: fallback = null, children: children }) {
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($28f120e398482486$var$HydrationSafeSuspenseContent, {
        isLocked: renderServerPlaceholder,
        fallback: fallback
    }, children);
}
module.exports["HydrationSafeSuspense"] = $28f120e398482486$export$a0bfcafd6d556141;

});

parcelRegister("8zKDl", function(module, exports) {
function $2b2227915da27313$export$63116239d47be9ca(dataFetcherName, isSSRStreaming = true) {
    if (!isSSRStreaming || !dataFetcherName) return null;
    return window.__dataFetcherForSuspense__?.[dataFetcherName] ?? null;
}
module.exports["getDataFetcherForSuspense"] = $2b2227915da27313$export$63116239d47be9ca;

});

parcelRegister("2VZOl", function(module, exports) {

var $j8on0 = parcelRequire("j8on0");

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $9HkI0 = parcelRequire("9HkI0");

const $a3221c0e46c131d6$export$cd763072e62a98fa = (0, $j8on0.createContainer)();
const $a3221c0e46c131d6$var$Store = (0, $8s9DV.createStore)({
    containedBy: $a3221c0e46c131d6$export$cd763072e62a98fa,
    initialState: {
        presenceId: ''
    },
    actions: {},
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    presenceId: (0, $9HkI0.v4)()
                });
            }
    }
});
const $a3221c0e46c131d6$export$f529db6cceb299f5 = (0, $kBr4q.createHook)($a3221c0e46c131d6$var$Store);
module.exports["NativeCollabPresenceStateContainer"] = $a3221c0e46c131d6$export$cd763072e62a98fa;
module.exports["useNativeCollabPresenceState"] = $a3221c0e46c131d6$export$f529db6cceb299f5;

});

parcelRegister("8KbKw", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $04e9M = parcelRequire("04e9M");


var $9137z = parcelRequire("9137z");


var $j8hiR = parcelRequire("j8hiR");


var $6mKj3 = parcelRequire("6mKj3");


var $7Sm4c = parcelRequire("7Sm4c");


var $c0rhi = parcelRequire("c0rhi");


var $aMcHK = parcelRequire("aMcHK");


var $6fil2 = parcelRequire("6fil2");


var $lR7wI = parcelRequire("lR7wI");


var $1sAC2 = parcelRequire("1sAC2");

const $6f395e426fb151a0$var$isContentNotFoundError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.message.includes('Invalid content id'));
    return false;
};
const $6f395e426fb151a0$var$shouldRetryUnknownStatusNetworkError = (error)=>{
    const isNetworkError = (0, $6fil2.containsNetworkError)(error);
    const networkError = error?.networkError ?? error;
    const isCausedByAbortError = networkError instanceof (0, $6fil2.NetworkError) && (0, $6fil2.causedByAbortError)(networkError);
    const isOnline = typeof navigator === 'undefined' || navigator.onLine;
    const statusCode = (0, $aMcHK.getStatusCodeError)(error);
    return isNetworkError && !isCausedByAbortError && isOnline && statusCode === undefined;
};
const $6f395e426fb151a0$var$emitRetryCompleted = (outcome)=>{
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            action: 'retryCompleted',
            actionSubject: 'collabPermissionToken',
            source: 'fetchCollabPermissionToken',
            attributes: {
                outcome: outcome
            }
        });
    });
};
const $6f395e426fb151a0$var$getTokenFromQueryResult = (result)=>{
    (0, $9137z.CollabEditProviderMeasures).markMeasureEnd((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
    const token = result.data?.collabToken?.token ?? null; // if token is null, collab service will fall back to permissions service check
    if (token === null && (0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            action: 'nullTokenReturned',
            actionSubject: 'collabPermissionToken',
            source: 'fetchCollabPermissionToken',
            attributes: {
                reason: 'emptyResponse'
            }
        });
    });
    return token;
};
const $6f395e426fb151a0$export$e344958ab47793df = (0, $dOBRD.default)((contentId, draftShareId)=>async ()=>{
        const permissionsTokenState = (0, $1sAC2.nativeCollabPermissionsTokenState).getPermissionsTokenState(contentId);
        if (permissionsTokenState) {
            const { getToken: getToken, isUsedForDraftFetch: isUsedForDraftFetch, isUsedForWSInitialization: isUsedForWSInitialization } = permissionsTokenState;
            // fetchCollabPermissionToken should only return the token if it is valid and has successfully been passed to the getDraft call
            if (isUsedForDraftFetch && !isUsedForWSInitialization) {
                const token = await getToken;
                if (token) {
                    (0, $1sAC2.nativeCollabPermissionsTokenState).setIsUsedForWSInitialization(contentId, true);
                    return token;
                }
            }
        }
        const query = ()=>(0, $c0rhi.queryInterop)({
                query: (0, $lR7wI.default),
                variables: {
                    contentId: contentId,
                    ...draftShareId && {
                        draftShareId: draftShareId
                    }
                },
                fetchPolicy: 'network-only',
                context: {
                    fetchOptions: {
                        // If we have a "no network error" this will never resolve and subsequent calls will
                        // be in limbo. This means we are unable to ever connect to NCS again (requiring a page reset)
                        ignoreNoNetworkError: true
                    }
                },
                __callerPackage__: "native-collab"
            });
        try {
            (0, $9137z.CollabEditProviderMeasures).markMeasureStart((0, $j8hiR.COLLAB_EDIT_PROVIDER_MEASURES).COLLAB_PERMS_TOKEN_FETCH);
            const result = await query();
            return $6f395e426fb151a0$var$getTokenFromQueryResult(result);
        } catch (e) {
            if ((0, $6mKj3.expVal)('platform_editor_retry_collab_token_query', 'isEnabled', false)) {
                if ($6f395e426fb151a0$var$shouldRetryUnknownStatusNetworkError(e)) try {
                    const result = await query();
                    const token = $6f395e426fb151a0$var$getTokenFromQueryResult(result);
                    $6f395e426fb151a0$var$emitRetryCompleted(token === null ? 'emptyResponse' : 'tokenReturned');
                    return token;
                } catch (retryError) {
                    $6f395e426fb151a0$var$emitRetryCompleted('fetchError');
                    e = retryError;
                }
            }
            (0, $7Sm4c.markErrorAsHandled)(e);
            if ($6f395e426fb151a0$var$isContentNotFoundError(e)) // nasty fragile hack, mimic 404 exception which goes through collab-provider, then gets wrapped and emitted and handled in `useError`.
            // collab provider simply emits errors thrown in permissionTokenRefresh directly on its internal channel, so we have to conform to their error type
            // prettier-ignore
            throw {
                message: "Content not found",
                data: {
                    status: 404,
                    code: "INSUFFICIENT_EDITING_PERMISSION",
                    meta: {
                        description: "RESOURCE_DELETED",
                        reason: "RESOURCE_DELETED"
                    }
                }
            };
            else if (e?.networkError?.response?.status === 503) // prettier-ignore
            throw {
                message: "Service unavailable",
                data: {
                    meta: {
                        reason: "RESOURCE_DELETED"
                    }
                }
            }; // temporary hack to ensure draft cannot be edited during tenant migration, but we should throw TENANT_INSTANCE_MAINTENANCE once supported by collab-provider
            if ((0, $6mKj3.expVal)('platform_editor_emit_null_token_event', 'isEnabled', false)) {
                const statusCode = (0, $aMcHK.getStatusCodeError)(e);
                (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
                    client.sendOperationalEvent({
                        action: 'nullTokenReturned',
                        actionSubject: 'collabPermissionToken',
                        source: 'fetchCollabPermissionToken',
                        attributes: {
                            reason: 'fetchError',
                            statusCode: statusCode ?? 'unknown'
                        }
                    });
                });
            }
            return null;
        }
    });
module.exports["fetchCollabPermissionToken"] = $6f395e426fb151a0$export$e344958ab47793df;

});

parcelRegister("9137z", function(module, exports) {

var $kGrzq = parcelRequire("kGrzq");

const $e77725a58fc80757$export$d93492bf620814be = new (0, $kGrzq.BaseMeasures)();
module.exports["CollabEditProviderMeasures"] = $e77725a58fc80757$export$d93492bf620814be;

});

parcelRegister("j8hiR", function(module, exports) {
var $fbca710eb28c4147$export$d0a57beabaefb993 = /*#__PURE__*/ function(COLLAB_EDIT_PROVIDER_MEASURES) {
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH"] = "collabEditProviderAnalyticsFetch";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CREATED"] = "collabEditProviderCreated";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_DISABLED"] = "collabEditProviderDisabled";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT"] = "collabEditProviderInitialized";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRE_CONNECTED"] = "collabEditProviderPreconnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_CONNECTED"] = "collabEditProviderConnected";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_INIT_DOC"] = "collabEditProviderInitDoc";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_FETCH_NCS_DRAFT"] = "collabEditProviderFetchNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT"] = "collabEditProviderPreloadNCSDraft";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_EDIT_PROVIDER_PRELOAD_NCS_DRAFT_TIMEOUT"] = "collabEditProviderPreloadNCSDraftTimeout";
    COLLAB_EDIT_PROVIDER_MEASURES["COLLAB_PERMS_TOKEN_FETCH"] = "collabEditProviderPermsTokenFetch";
    return COLLAB_EDIT_PROVIDER_MEASURES;
}({});
module.exports["COLLAB_EDIT_PROVIDER_MEASURES"] = $fbca710eb28c4147$export$d0a57beabaefb993;

});

parcelRegister("lR7wI", function(module, exports) {
/**
 * @generated SignedSource<<a61063136e57f7cd39e5b8a983d46e87>>
 * @relayHash bd2d61cdca16378a4f1f566700b1fb56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69
const $4abe7e20c4ebe0be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "CollabTokenResponse",
            "kind": "LinkedField",
            "name": "collabToken",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "token"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CollabPermissionTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "bd2d61cdca16378a4f1f566700b1fb56",
            "id": "5d8d52b5f773a7bba3b6756bcb3b14fd5aaf52c1ee303a82c5d4a9aaccc6af69",
            "metadata": {},
            "name": "CollabPermissionTokenQuery",
            "operationKind": "query",
            "text": "query CollabPermissionTokenQuery($contentId:ID!,$draftShareId:String){collabToken(id:$contentId,draftShareId:$draftShareId){token}}"
        }
    };
}();
$4abe7e20c4ebe0be$var$node.hash = "f88c8dd0f4e61065305cc9c5b9a3253b";
var $4abe7e20c4ebe0be$export$2e2bcd8739ae039 = $4abe7e20c4ebe0be$var$node;
module.exports["default"] = $4abe7e20c4ebe0be$export$2e2bcd8739ae039;

});

parcelRegister("1sAC2", function(module, exports) {
class $3f756fb591e8330c$export$88b5d10ee0ed72d9 {
    getPermissionsTokenState(contentId) {
        return this.tokenState[contentId];
    }
    setToken(contentId, tokenPromise = Promise.resolve(null)) {
        // clear any existing tokens/bools in state
        this.tokenState[contentId] = {
            getToken: tokenPromise,
            isUsedForDraftFetch: false,
            isUsedForWSInitialization: false
        };
    }
    setIsUsedForDraftFetch(contentId, isUsedForDraftFetch) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForDraftFetch = isUsedForDraftFetch;
    }
    setIsUsedForWSInitialization(contentId, isUsedForWSInitialization) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].isUsedForWSInitialization = isUsedForWSInitialization;
    }
    setTimestamp(contentId) {
        if (!this.tokenState[contentId]) return;
        this.tokenState[contentId].timestamp = performance.now();
    }
    clearPermissionsTokenState(contentId) {
        if (this.tokenState[contentId]) delete this.tokenState[contentId];
    }
    constructor(){
        this.tokenState = {};
    }
}
const $3f756fb591e8330c$export$8e63d30e585828b3 = new $3f756fb591e8330c$export$88b5d10ee0ed72d9();
module.exports["nativeCollabPermissionsTokenState"] = $3f756fb591e8330c$export$8e63d30e585828b3;

});

parcelRegister("hQm1C", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a8b418da1bc27466$export$871388fb833dfa56 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2M0Zq",
    name: "NativeCollabLoader",
    loader: async ()=>{
        const { NativeCollabComponent: NativeCollabComponent } = await (parcelRequire("7FK3k"));
        return NativeCollabComponent;
    }
});
module.exports["NativeCollabLoader"] = $a8b418da1bc27466$export$871388fb833dfa56;

});

parcelRegister("7FK3k", function(module, exports) {

let $596015d6bc0b7bc0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $596015d6bc0b7bc0$var$load("eF92L"),
    $596015d6bc0b7bc0$var$load("jwMHX"),
    $596015d6bc0b7bc0$var$load("bmOOW"),
    $596015d6bc0b7bc0$var$load("dDiWc"),
    $596015d6bc0b7bc0$var$load("hR9G5"),
    $596015d6bc0b7bc0$var$load("6iTkp"),
    $596015d6bc0b7bc0$var$load("i8sPk"),
    $596015d6bc0b7bc0$var$load("el56J"),
    $596015d6bc0b7bc0$var$load("5zDuS"),
    $596015d6bc0b7bc0$var$load("28Uan"),
    $596015d6bc0b7bc0$var$load("Jyh1v"),
    $596015d6bc0b7bc0$var$load("6TqFw"),
    $596015d6bc0b7bc0$var$load("4qmsu"),
    $596015d6bc0b7bc0$var$load("3o7hb"),
    $596015d6bc0b7bc0$var$load("excC5"),
    $596015d6bc0b7bc0$var$load("cGkFm"),
    $596015d6bc0b7bc0$var$load("20wSi"),
    $596015d6bc0b7bc0$var$load("hhss7"),
    $596015d6bc0b7bc0$var$load("btqFK")
]).then(()=>parcelRequire('03pNx'));

});

parcelRegister("8Hqv7", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7koGn = parcelRequire("7koGn");

const $6f5a0d3cf76b2edb$export$c4004a2b66cea884 = 'ssr-app/render/render-full-cycle';
function $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry() {
    const registry = new Set();
    function register(callback) {
        registry.add(callback);
    }
    function unregister(callback) {
        registry.delete(callback);
    }
    function notifyRenderComplete() {
        registry.forEach((callback)=>callback());
    }
    return {
        register: register,
        unregister: unregister,
        notifyRenderComplete: notifyRenderComplete
    };
}
const $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac = $6f5a0d3cf76b2edb$var$createFullCycleRenderRegistry();
const $6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0 = ({ name: name, children: children })=>{
    const fullCycleSSRState = window.__FULLCYCLE_SSR__;
    const containerRef = (0, $cozmU.useRef)(null);
    const onFullCycleRenderComplete = (0, $cozmU.useCallback)(()=>{
        if (containerRef.current && fullCycleSSRState) {
            const html = (0, $7koGn.sanitizeInputLoadablesForSSR)(containerRef.current.innerHTML);
            fullCycleSSRState.htmlOutput[name] = html;
        }
    }, [
        name,
        fullCycleSSRState
    ]);
    (0, $cozmU.useEffect)(()=>{
        $6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.register(onFullCycleRenderComplete);
        return ()=>$6f5a0d3cf76b2edb$export$b5e41f7d0cd23eac.unregister(onFullCycleRenderComplete);
    }, [
        onFullCycleRenderComplete
    ]);
    return null;
};
const $6f5a0d3cf76b2edb$export$f81c4bd5356d97f8 = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-id": "fullCycleOutput"
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
module.exports["FullCycleRender"] = $6f5a0d3cf76b2edb$export$31f6ed9cad4c2da0;
module.exports["FullCycleRenderWrapper"] = $6f5a0d3cf76b2edb$export$f81c4bd5356d97f8;

});

parcelRegister("7koGn", function(module, exports) {
const $a4af1bafcd952bf9$var$MARKER_REGEX = /<input(?:\s?type="hidden")? data-loadable-(begin|end)="([^"]*)"(?:\sdata-ssr-placeholder-id="([^"]*)")?(?:\sdata-debug-name="([^"]*)")?\s*?(?:\s?type="hidden")?\s*>(?!\s*<\/input>)/g;
function $a4af1bafcd952bf9$export$7400f7b8afb970c2(html) {
    return html.replace($a4af1bafcd952bf9$var$MARKER_REGEX, (inputTag)=>{
        return `${inputTag.slice(0, -1)} />`;
    });
}
module.exports["sanitizeInputLoadablesForSSR"] = $a4af1bafcd952bf9$export$7400f7b8afb970c2;

});

parcelRegister("9OVgK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $g6QPm = parcelRequire("g6QPm");


var $7zWPb = parcelRequire("7zWPb");


var $8bGvp = parcelRequire("8bGvp");


var $1aQ2R = parcelRequire("1aQ2R");


var $6mKj3 = parcelRequire("6mKj3");


var $hvS6g = parcelRequire("hvS6g");


var $7PLO8 = parcelRequire("7PLO8");


var $bQm3c = parcelRequire("bQm3c");

const $a4811e16923f27ab$var$EditorContentReader = ({ contentId: contentId, isLivePage: isLivePage, children: children })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const draftShareId = (0, $7PLO8.getDraftShareIdFromQueryParam)();
    // A seamless live doc transition keeps the previous document on screen instead of suspending the
    // mounted editor if the next document's data is not in the store yet.
    const deferredContentId = (0, $cozmU.useDeferredValue)(contentId);
    // Deferring a document already in the store would only give readers the previous one for a commit.
    const isInStore = environment.check((0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $1aQ2R.default)), (0, $g6QPm.createEditorContentOperationVariables)({
        contentId: contentId,
        cloudId: cloudId,
        draftShareId: draftShareId,
        isLivePage: isLivePage
    }))).status === 'available';
    const readContentId = isInStore ? contentId : deferredContentId;
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $1aQ2R.default), (0, $g6QPm.createEditorContentOperationVariables)({
        contentId: readContentId,
        cloudId: cloudId,
        draftShareId: draftShareId,
        isLivePage: isLivePage
    }), {
        fetchPolicy: 'store-or-network'
    });
    // Leaving a document (unmount or a live doc transition) is when its server state can change
    // behind the store, e.g. by publishing, so the next entry fetches.
    (0, $cozmU.useEffect)(()=>()=>(0, $7zWPb.clearEditorContentFetched)(readContentId), [
        readContentId
    ]);
    const loading = readContentId !== contentId;
    const fragments = (0, $cozmU.useMemo)(()=>(0, $8bGvp.createEditorContentFragments)(data, {
            contentId: contentId,
            loading: loading
        }), [
        data,
        contentId,
        loading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bGvp.EditorContentFragmentsContext).Provider, {
        value: fragments
    }, children);
};
const $a4811e16923f27ab$export$e529cb0d8fa42662 = ({ contentId: contentId, isLivePage: isLivePage, fallback: fallback, children: children })=>{
    if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hvS6g.RelaySuspense), {
        fallback: fallback,
        interactionName: "EditorContentUnifiedQuery"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a4811e16923f27ab$var$EditorContentReader, {
        contentId: contentId,
        isLivePage: isLivePage
    }, children));
};
module.exports["EditorContentContainer"] = $a4811e16923f27ab$export$e529cb0d8fa42662;

});

parcelRegister("8bGvp", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $69682d2fbc90456d$var$getNode = (data)=>data.content?.nodes?.[0];
// Where each fragment's ref is in the operation's data; adding a fragment to the query without a
// selector here fails to compile.
const $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS = {
    contentTypesHeaderFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentTypesHeaderFragment,
    emojiTitleFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.emojiTitleFragment,
    emojiEverSetPropertyFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.emojiEverSetPropertyFragment,
    contentAppearanceFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentAppearanceFragment,
    coverPictureFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.coverPictureFragment,
    titleContentPropertiesFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.titleContentPropertiesFragment,
    contentModeFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.contentModeFragment,
    shareAndRestrictButtonFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.shareAndRestrictButtonFragment,
    editorSpaceDetailFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorSpaceDetailFragment,
    nativeCollabFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.nativeCollabFragment,
    labelsFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.labelsFragment,
    smartCreateFeedbackBannerFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.smartCreateFeedbackBannerFragment,
    favouriteContentFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.favouriteContentFragment,
    migratedRecentlyFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.migratedRecentlyFragment,
    editorByLineFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorByLineFragment,
    devDocsAncestorsFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.devDocsAncestorsFragment,
    editorContentStateFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorContentStateFragment,
    shareAndRestrictButtonPublicLinkFragment: (data)=>data.shareAndRestrictButtonPublicLinkFragment,
    editorByLineContributorsFragment: (data)=>data.editorByLineContributorsFragment,
    editorAvailableContentStatesFragment: (data)=>data.editorAvailableContentStatesFragment,
    editorCollaboratorsFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorCollaboratorsFragment,
    editorAddCommentPermissionFragment: (data)=>$69682d2fbc90456d$var$getNode(data)?.editorAddCommentPermissionFragment,
    editorCollaboratorsListFragment: (data)=>data.editorCollaboratorsListFragment,
    editorAttachmentDownloadPolicyFragment: (data)=>data.editorAttachmentDownloadPolicyFragment
};
const $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_KEYS = Object.keys($69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS);
function $69682d2fbc90456d$var$mapFragments(toFragment) {
    return Object.fromEntries($69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_KEYS.map((key)=>[
            key,
            toFragment(key)
        ]));
}
function $69682d2fbc90456d$export$56cbeadb27426f30(data, { contentId: contentId, loading: loading }) {
    return $69682d2fbc90456d$var$mapFragments((key)=>({
            isProvided: true,
            ref: $69682d2fbc90456d$var$EDITOR_CONTENT_FRAGMENT_SELECTORS[key](data) ?? null,
            contentId: contentId,
            loading: loading
        }));
}
const $69682d2fbc90456d$var$NOT_PROVIDED_FRAGMENTS = $69682d2fbc90456d$var$mapFragments(()=>({
        isProvided: false
    }));
const $69682d2fbc90456d$export$faab0246835c7509 = (0, $cozmU.createContext)($69682d2fbc90456d$var$NOT_PROVIDED_FRAGMENTS);
function $69682d2fbc90456d$export$2e53e9edef0785f2() {
    return (0, $cozmU.useContext)($69682d2fbc90456d$export$faab0246835c7509);
}
module.exports["createEditorContentFragments"] = $69682d2fbc90456d$export$56cbeadb27426f30;
module.exports["EditorContentFragmentsContext"] = $69682d2fbc90456d$export$faab0246835c7509;
module.exports["useEditorContentFragments"] = $69682d2fbc90456d$export$2e53e9edef0785f2;

});

parcelRegister("hvS6g", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $91ZZN = parcelRequire("91ZZN");

const $e332deabb876ffbc$export$c3136e12f209350a = (0, $3u0dr.isReactCompilerActiveV2)() ? function RelaySuspense(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { children: children, fallback: fallback, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== children || $[1] !== fallback || $[2] !== interactionName) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
            fallback: fallback,
            interactionName: interactionName
        }, children);
        $[0] = children;
        $[1] = fallback;
        $[2] = interactionName;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : function RelaySuspense({ children: children, fallback: fallback, interactionName: interactionName }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ZZN.default), {
        fallback: fallback,
        interactionName: interactionName
    }, children);
};
module.exports["RelaySuspense"] = $e332deabb876ffbc$export$c3136e12f209350a;

});

parcelRegister("gXk3R", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5L8uK = parcelRequire("5L8uK");


var $ikQI7 = parcelRequire("ikQI7");

const $f772686e0a22a242$export$2716975253bf9813 = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { contentId: contentId, spaceKey: spaceKey, children: children } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { isProvided: isProvided, loading: loading, data: data } = (0, $ikQI7.useEditorSpaceDetailFragment)(t1);
    if (!isProvided) {
        let t2;
        if ($[2] !== children) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[2] = children;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    const t2 = spaceKey ?? "";
    const t3 = loading ? null : data?.space ?? null;
    let t4;
    if ($[4] !== children || $[5] !== loading || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5L8uK.SpaceDetailProvider), {
            spaceKey: t2,
            loading: loading,
            spaceFragmentRef: t3
        }, children);
        $[4] = children;
        $[5] = loading;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
};
module.exports["EditorSpaceDetailProvider"] = $f772686e0a22a242$export$2716975253bf9813;

});

parcelRegister("5L8uK", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $g02kj = parcelRequire("g02kj");


var $89u2G = parcelRequire("89u2G");

const $549a2aa13cb21b4d$export$63b31887d8275b45 = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, spaceKey: spaceKey, loading: loading, spaceFragmentRef: spaceFragmentRef } = t0;
    const space = (0, $6SsN4.useFragment)((0, $g02kj.SpaceDetailFragment), spaceFragmentRef);
    let t1;
    if ($[0] !== loading || $[1] !== space || $[2] !== spaceKey) {
        t1 = loading || space?.id && (space.key === spaceKey || space.alias === spaceKey) ? {
            spaceKey: spaceKey,
            loading: loading,
            space: space ?? undefined
        } : undefined;
        $[0] = loading;
        $[1] = space;
        $[2] = spaceKey;
        $[3] = t1;
    } else t1 = $[3];
    const value = t1;
    let t2;
    if ($[4] !== children || $[5] !== value) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $89u2G.SpaceDetailContext).Provider, {
            value: value
        }, children);
        $[4] = children;
        $[5] = value;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
module.exports["SpaceDetailProvider"] = $549a2aa13cb21b4d$export$63b31887d8275b45;

});

parcelRegister("g02kj", function(module, exports) {

var $1TFoJ = parcelRequire("1TFoJ");

const $683d1134e7d10071$export$872cafc85037c08d = (0, $1TFoJ.default);
module.exports["SpaceDetailFragment"] = $683d1134e7d10071$export$872cafc85037c08d;

});

parcelRegister("1TFoJ", function(module, exports) {
/**
 * @generated SignedSource<<40f15aa7638ad06f4b52fa8929e5405c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $10cfef4c9a0273b5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeSpaceTypeSettings"
            }
        ],
        "kind": "Fragment",
        "name": "SpaceDetail_space",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v1 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "dataClassificationTags"
            },
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "homepage",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "title"
                    },
                    v1 /*: any*/ 
                ]
            },
            {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "path"
                    }
                ]
            },
            {
                "condition": "includeSpaceTypeSettings",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "SpaceTypeSettings",
                        "kind": "LinkedField",
                        "name": "spaceTypeSettings",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "EnabledContentTypes",
                                "kind": "LinkedField",
                                "name": "enabledContentTypes",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "isLivePagesEnabled"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isWhiteboardsEnabled"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isDatabasesEnabled"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "isSlidesEnabled"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Space"
    };
}();
$10cfef4c9a0273b5$var$node.hash = "eba0e6a9e61153ecb445e3b3118dc653";
var $10cfef4c9a0273b5$export$2e2bcd8739ae039 = $10cfef4c9a0273b5$var$node;
module.exports["default"] = $10cfef4c9a0273b5$export$2e2bcd8739ae039;

});

parcelRegister("89u2G", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $452d11e5a10e2733$export$4ae6180efef498fb = (0, $cozmU.createContext)(undefined);
const $452d11e5a10e2733$export$f21057576bccab98 = ()=>{
    return (0, $cozmU.useContext)($452d11e5a10e2733$export$4ae6180efef498fb);
};
module.exports["SpaceDetailContext"] = $452d11e5a10e2733$export$4ae6180efef498fb;
module.exports["useSpaceDetailContext"] = $452d11e5a10e2733$export$f21057576bccab98;

});

parcelRegister("ikQI7", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $029AP = parcelRequire("029AP");


var $hX2PJ = parcelRequire("hX2PJ");

// The page's space for EditorContentUnifiedQuery, with the fields of useSpaceDetailQuery without
// spaceTypeSettings, so SpaceDetailProvider can share it with useSpaceDetail.
const $4beed8c5917d8bb7$var$editorSpaceDetailFragmentNode = (0, $029AP.default);
function $4beed8c5917d8bb7$export$ae03489c2cf1b179(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { contentId: contentId } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    return (0, $hX2PJ.useEditorContentFragment)("editorSpaceDetailFragment", $4beed8c5917d8bb7$var$editorSpaceDetailFragmentNode, t1);
}
module.exports["useEditorSpaceDetailFragment"] = $4beed8c5917d8bb7$export$ae03489c2cf1b179;

});

parcelRegister("029AP", function(module, exports) {
/**
 * @generated SignedSource<<fbeae3a5648c843fb651c0c086d404d7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $83371ca7123cb1bc$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "catchTo": "RESULT"
    },
    "name": "useEditorSpaceDetailFragment_content",
    "selections": [
        {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "SpaceDetail_space"
                }
            ]
        }
    ],
    "type": "Content"
};
$83371ca7123cb1bc$var$node.hash = "632abb3e0510c45725a5d3a2b20f17b9";
var $83371ca7123cb1bc$export$2e2bcd8739ae039 = $83371ca7123cb1bc$var$node;
module.exports["default"] = $83371ca7123cb1bc$export$2e2bcd8739ae039;

});

parcelRegister("hX2PJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $26Yfd = parcelRequire("26Yfd");


var $8bGvp = parcelRequire("8bGvp");

function $4a4d540a0776d558$var$identity(value) {
    return value;
}
function $4a4d540a0776d558$export$b9f4f60a9d12fe91(key, fragmentNode, t0) {
    const $ = (0, $bDgLe.c)(11);
    const { contentId: contentId, skip: t1, mapData: mapData } = t0;
    const skip = t1 === undefined ? false : t1;
    const fragment = (0, $8bGvp.useEditorContentFragments)()[key];
    const isProvided = fragment.isProvided && fragment.contentId === contentId;
    const result = (0, $6SsN4.useFragment)(fragmentNode, isProvided && !skip ? fragment.ref : null);
    const loading = isProvided && !skip && fragment.loading;
    const stableMapData = (0, $26Yfd.useStableCallback)(mapData ?? $4a4d540a0776d558$var$identity);
    let t2;
    if ($[0] !== result || $[1] !== stableMapData) {
        t2 = result?.ok ? stableMapData(result.value) : undefined;
        $[0] = result;
        $[1] = stableMapData;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== fragmentNode || $[4] !== result) {
        t3 = result?.ok === false ? new Error(`${(0, $eqEJl.getFragment)(fragmentNode).name} field error`, {
            cause: result.errors
        }) : undefined;
        $[3] = fragmentNode;
        $[4] = result;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== isProvided || $[7] !== loading || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            isProvided: isProvided,
            loading: loading,
            data: t2,
            error: t3
        };
        $[6] = isProvided;
        $[7] = loading;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
}
module.exports["useEditorContentFragment"] = $4a4d540a0776d558$export$b9f4f60a9d12fe91;

});

parcelRegister("6gETM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");

const $5ed14ae7f856df1d$export$204c1449657d49fd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
const $5ed14ae7f856df1d$export$ae764d691d5f37c6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3loHF",
    name: "TreeRootForServerPlaceholder",
    loader: async ()=>$5ed14ae7f856df1d$export$204c1449657d49fd,
    _reactTreeRootForServerPlaceholderId: true
});
const $5ed14ae7f856df1d$export$4279728e9b12d235 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5ed14ae7f856df1d$export$ae764d691d5f37c6, null, children);
};
module.exports["TreeRootForServerPlaceholderWrapper"] = $5ed14ae7f856df1d$export$4279728e9b12d235;

});

parcelRegister("8jRXE", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");



const $ba942ead23497767$export$d49c8c8cf1b10f7e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ynpC3",
    name: "FullPageEditorLoader",
    loader: async ()=>{
        // Fetch the outer editor chunk AND the AI-mate @atlassian/conversation-
        // assistant chunk in parallel. Both `import()` calls live inside this
        // LoadablePaint object expression, so LoadableMetaBabelPlugin tags them
        // BOTH with this loadable's id — which causes parcel-reporter-loadable
        // to union both bundle groups into preloadAssets for this loadable.
        // Without the second `import()`, the register chunk that owns modules
        // like platform/…/atlassian-project-status-update-action-renderer/main.tsx
        // (module id 'iuVKP' on CDN / '2xPvv' locally) is not in this
        // loadable's chunk set, and the runtime throws
        //   `Cannot find module 'iuVKP'`
        // when FullPageEditorComponent's compiled
        //   `.then(() => parcelRequire('iuVKP'))` fires.
        const [outer] = await Promise.all([
            (parcelRequire("5T2RE")),
            // eslint-disable-next-line import/dynamic-import-chunkname
            (parcelRequire("ErVgu"))
        ]);
        return outer.FullPageEditorComponent;
    }
});
module.exports["FullPageEditorLoader"] = $ba942ead23497767$export$d49c8c8cf1b10f7e;

});

parcelRegister("5T2RE", function(module, exports) {

let $44944f9ad8577ac1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $44944f9ad8577ac1$var$load("jyXyo"),
    $44944f9ad8577ac1$var$load("bmOOW"),
    $44944f9ad8577ac1$var$load("dDiWc"),
    $44944f9ad8577ac1$var$load("53mVX"),
    $44944f9ad8577ac1$var$load("bncmK"),
    $44944f9ad8577ac1$var$load("l4j2l"),
    $44944f9ad8577ac1$var$load("37v60"),
    $44944f9ad8577ac1$var$load("hUbK8"),
    $44944f9ad8577ac1$var$load("6iTkp"),
    $44944f9ad8577ac1$var$load("2xoIF"),
    $44944f9ad8577ac1$var$load("ce05o"),
    $44944f9ad8577ac1$var$load("6wr18"),
    $44944f9ad8577ac1$var$load("2F69B"),
    $44944f9ad8577ac1$var$load("8Bic8"),
    $44944f9ad8577ac1$var$load("6j0nE"),
    $44944f9ad8577ac1$var$load("16bOI"),
    $44944f9ad8577ac1$var$load("9jF3u"),
    $44944f9ad8577ac1$var$load("dawlK"),
    $44944f9ad8577ac1$var$load("5qdFt"),
    $44944f9ad8577ac1$var$load("xl5Th"),
    $44944f9ad8577ac1$var$load("fb8QM"),
    $44944f9ad8577ac1$var$load("9PRTA"),
    $44944f9ad8577ac1$var$load("2wboY"),
    $44944f9ad8577ac1$var$load("8faB9"),
    $44944f9ad8577ac1$var$load("fU0ae"),
    $44944f9ad8577ac1$var$load("59JAK"),
    $44944f9ad8577ac1$var$load("aVpwX"),
    $44944f9ad8577ac1$var$load("8VUAj"),
    $44944f9ad8577ac1$var$load("uyCHV"),
    $44944f9ad8577ac1$var$load("kftjC"),
    $44944f9ad8577ac1$var$load("gdp0M"),
    $44944f9ad8577ac1$var$load("aUXrB"),
    $44944f9ad8577ac1$var$load("esBxc"),
    $44944f9ad8577ac1$var$load("3pbEq"),
    $44944f9ad8577ac1$var$load("15jTz"),
    $44944f9ad8577ac1$var$load("48F3z"),
    $44944f9ad8577ac1$var$load("jw3eS"),
    $44944f9ad8577ac1$var$load("7SteV"),
    $44944f9ad8577ac1$var$load("jE0Mz"),
    $44944f9ad8577ac1$var$load("9LJFK"),
    $44944f9ad8577ac1$var$load("d66hN"),
    $44944f9ad8577ac1$var$load("aRCaA"),
    $44944f9ad8577ac1$var$load("h3Rq9"),
    $44944f9ad8577ac1$var$load("dqLHj"),
    $44944f9ad8577ac1$var$load("g2wVX"),
    $44944f9ad8577ac1$var$load("cIoRg"),
    $44944f9ad8577ac1$var$load("g7vSH"),
    $44944f9ad8577ac1$var$load("dxcsb"),
    $44944f9ad8577ac1$var$load("ffEVr"),
    $44944f9ad8577ac1$var$load("7IvJj"),
    $44944f9ad8577ac1$var$load("j7JUO"),
    $44944f9ad8577ac1$var$load("cGkFm"),
    $44944f9ad8577ac1$var$load("eF92L"),
    $44944f9ad8577ac1$var$load("jwMHX"),
    $44944f9ad8577ac1$var$load("d0ZRF"),
    $44944f9ad8577ac1$var$load("k507P"),
    $44944f9ad8577ac1$var$load("6w3bl"),
    $44944f9ad8577ac1$var$load("9TOep"),
    $44944f9ad8577ac1$var$load("8iu3F"),
    $44944f9ad8577ac1$var$load("iubLg"),
    $44944f9ad8577ac1$var$load("9o15s"),
    $44944f9ad8577ac1$var$load("hhss7"),
    $44944f9ad8577ac1$var$load("h6rbF"),
    $44944f9ad8577ac1$var$load("jD5ZU"),
    $44944f9ad8577ac1$var$load("7EorR"),
    $44944f9ad8577ac1$var$load("7x00I")
]).then(()=>parcelRequire('h1Y8a'));

});

parcelRegister("34NZw", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d52b69b4dbbb4bb4$export$e6747c633274762a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "UL-jW",
    name: "PageShownPublicLinksEventLoader",
    loader: async ()=>{
        const { PageShownPublicLinksEvent: PageShownPublicLinksEvent } = await (parcelRequire("6Endl"));
        return PageShownPublicLinksEvent;
    }
});
module.exports["PageShownPublicLinksEventLoader"] = $d52b69b4dbbb4bb4$export$e6747c633274762a;

});

parcelRegister("6Endl", function(module, exports) {

let $4d787c5c8e7aefc1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4d787c5c8e7aefc1$var$load("bRqDI"),
    $4d787c5c8e7aefc1$var$load("63zHi")
]).then(()=>parcelRequire('jvel0'));

});

parcelRegister("cZa7r", function(module, exports) {

var $9HkI0 = parcelRequire("9HkI0");


var $cozmU = parcelRequire("cozmU");


var $cz6eP = parcelRequire("cz6eP");


var $fJCU9 = parcelRequire("fJCU9");


var $epbW8 = parcelRequire("epbW8");


var $afGoD = parcelRequire("afGoD");


var $9QIM2 = parcelRequire("9QIM2");


var $gczDe = parcelRequire("gczDe");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $8WQTF = parcelRequire("8WQTF");

const $d99a6317060f344e$export$4162754b616020bc = 3500;
const $d99a6317060f344e$export$39085f26fb4d6afa = /*#__PURE__*/ (0, $cozmU.createContext)({
    selectionProps: null,
    hoverProps: null,
    viewProps: null,
    editorCreateProps: null,
    editorViewProps: null,
    showCreateComponent: false,
    showHighlightActions: false,
    selectionOptions: undefined,
    stepGenerationError: false,
    newlyCreatedAnnotationId: undefined,
    commentSidebarContext: null,
    isOffline: false,
    storedCommentData: null
});
$d99a6317060f344e$export$39085f26fb4d6afa.displayName = 'AnnotationsContext';
const $d99a6317060f344e$export$57d1b2fe9544d93c = /*#__PURE__*/ (0, $cozmU.createContext)(false);
$d99a6317060f344e$export$57d1b2fe9544d93c.displayName = 'AnnotationsOfflineContext';
const $d99a6317060f344e$export$6e641cb791644965 = /*#__PURE__*/ (0, $cozmU.createContext)({
    requestCloseEditorComment: ()=>Promise.resolve(true),
    setEditorCommentCloseGuard: ()=>{},
    setSelectionProps: ()=>{},
    setHoverProps: ()=>{},
    setViewProps: ()=>{},
    setEditorCreateProps: ()=>{},
    setEditorViewProps: ()=>{},
    setShowCreateComponent: ()=>{},
    setShowHighlightActions: ()=>{},
    setSelectionOptions: ()=>{},
    setStepGenerationError: ()=>{},
    setSelectionOptionsForCreateEditor: ()=>{},
    setNewlyCreatedAnnotationId: ()=>{},
    setCommentSidebarContext: ()=>{},
    handleSaveSuccess: ()=>{},
    handleClose: ()=>{},
    setIsOffline: ()=>{},
    setStoredCommentData: ()=>{},
    clearStoredCommentData: ()=>{},
    waitForAnnotationElementAndEmit: ()=>{},
    applyDraftModeRef: {
        current: null
    }
});
$d99a6317060f344e$export$6e641cb791644965.displayName = 'AnnotationDispatchContext';
const $d99a6317060f344e$export$567c82ef93e7d5a1 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
$d99a6317060f344e$export$567c82ef93e7d5a1.displayName = 'AnnotationManagerContext';
const $d99a6317060f344e$export$22e6290b4a8e41d3 = ({ children: children })=>{
    const editorCommentCloseGuardRef = (0, $cozmU.useRef)(()=>Promise.resolve(true));
    const setEditorCommentCloseGuard = (0, $cozmU.useCallback)((guard)=>{
        editorCommentCloseGuardRef.current = guard;
    }, []);
    const [selectionProps, setSelectionProps] = (0, $cozmU.useState)(null);
    const selectionPropsRef = (0, $cozmU.useRef)(null);
    /** Stable ref to applyDraftMode — never cleared, so nudge click can call it synchronously
   *  without waiting for the 100ms selectionchange debounce. */ const applyDraftModeRef = (0, $cozmU.useRef)(null);
    // Keep refs in sync with state — useEffect so it never runs during render
    (0, $cozmU.useEffect)(()=>{
        selectionPropsRef.current = selectionProps;
        if (selectionProps?.applyDraftMode) applyDraftModeRef.current = selectionProps.applyDraftMode;
    }, [
        selectionProps
    ]);
    const [hoverProps, setHoverProps] = (0, $cozmU.useState)(null);
    const [viewProps, setViewProps] = (0, $cozmU.useState)(null);
    const [editorCreateProps, setEditorCreateProps] = (0, $cozmU.useState)(null);
    const [editorViewProps, setEditorViewProps] = (0, $cozmU.useState)(null);
    const editorCreatePropsRef = (0, $cozmU.useRef)(null);
    editorCreatePropsRef.current = editorCreateProps;
    const requestCloseEditorComment = (0, $cozmU.useCallback)(async ()=>{
        const editorCreatePropsAtRequest = editorCreatePropsRef.current;
        const canClose = await editorCommentCloseGuardRef.current();
        if (!canClose) return false;
        if (editorCreatePropsAtRequest) {
            if (!editorCreatePropsAtRequest.onClose) return false;
            editorCreatePropsAtRequest.onClose();
        } else setEditorViewProps(null);
        return true;
    }, []);
    const [showCreateComponent, setShowCreateComponent] = (0, $cozmU.useState)(false);
    const [showHighlightActions, setShowHighlightActions] = (0, $cozmU.useState)(false);
    const [selectionOptions, setSelectionOptions] = (0, $cozmU.useState)();
    const [stepGenerationError, setStepGenerationError] = (0, $cozmU.useState)(false);
    const [newlyCreatedAnnotationId, setNewlyCreatedAnnotationId] = (0, $cozmU.useState)();
    const [commentSidebarContext, setCommentSidebarContext] = (0, $cozmU.useState)(null);
    const [prevContentId, setPrevContentId] = (0, $cozmU.useState)(null);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const annotationManager = (0, $cozmU.useMemo)(// oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    ()=>(0, $9wGTI.fg)('platform_editor_comments_api_manager') ? (0, $cz6eP.createAnnotationManager)() : undefined, []);
    // This is effectively used with editorCreateProps and editorViewProps but we're tracking it independently as it doesn't really tie into the same lifecycle events
    const [isOffline, setIsOffline] = (0, $cozmU.useState)(false);
    // Stored comment data for direct data flow
    const [storedCommentData, setStoredCommentData] = (0, $cozmU.useState)(null);
    // Track active MutationObserver and timeout for cleanup on unmount
    const activeObserverRef = (0, $cozmU.useRef)(null);
    const activeTimeoutRef = (0, $cozmU.useRef)(null);
    /**
   * Waits for an annotation element to appear in the DOM using MutationObserver,
   * then emits annotation selection events. If element doesn't appear within the wait
   * timeout, fails the VIEW_INLINE_COMMENT_EXPERIENCE.
   */ const waitForAnnotationElementAndEmit = (0, $cozmU.useCallback)((annotationId, emitter)=>{
        // Clean up any existing observer/timeout before creating new ones
        if (activeObserverRef.current) activeObserverRef.current.disconnect();
        if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
        // Use MutationObserver to wait for element to appear in DOM
        activeObserverRef.current = new MutationObserver(()=>{
            // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
            const element = document.getElementById(annotationId);
            if (element) {
                if (activeObserverRef.current) activeObserverRef.current.disconnect();
                if (activeTimeoutRef.current) clearTimeout(activeTimeoutRef.current);
                activeObserverRef.current = null;
                activeTimeoutRef.current = null;
                // Emit annotation events and check if listeners exist
                if (emitter.emit((0, $fJCU9.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: element
                })) {
                    emitter.emit((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                        annotationId: annotationId
                    });
                    setNewlyCreatedAnnotationId(annotationId);
                } else // No listeners registered - fail the experience
                experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Failed to emit annotation click')
                });
            }
        });
        // Observe the renderer wrapper for child additions (fallback to document.body for safety)
        const rendererWrapper = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.querySelector('#content .ak-renderer-wrapper') || document.body;
        activeObserverRef.current.observe(rendererWrapper, {
            childList: true,
            subtree: true
        });
        // Fallback: If element doesn't appear within timeout, fail the experience
        // This almost always happens due to super slow re-renders (slow client on large page)
        activeTimeoutRef.current = setTimeout(()=>{
            if (activeObserverRef.current) activeObserverRef.current.disconnect();
            activeObserverRef.current = null;
            activeTimeoutRef.current = null;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                error: new Error(`Annotation element not found in DOM after ${$d99a6317060f344e$export$4162754b616020bc}ms`)
            });
        }, $d99a6317060f344e$export$4162754b616020bc);
    }, [
        experienceTracker,
        setNewlyCreatedAnnotationId
    ]);
    // Cleanup observer and timeout on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (activeObserverRef.current) {
                activeObserverRef.current.disconnect();
                activeObserverRef.current = null;
            }
            if (activeTimeoutRef.current) {
                clearTimeout(activeTimeoutRef.current);
                activeTimeoutRef.current = null;
            }
        };
    }, []);
    // Get rendererActions for renderer mode (always call hook, but only use when feature gate is enabled)
    const rendererActionsHook = (0, $8WQTF.useRendererActions)();
    const rendererActions = rendererActionsHook?.rendererActions;
    (0, $cozmU.useEffect)(()=>{
        const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
        function handleAnnotationFocus({ annotationId: annotationId }) {
            // The fact annotations is an array here is meaningless at this time - Confluence
            // always picks the top annotation
            const focusedAnnotation = annotationId;
            if (!focusedAnnotation) {
                // If there is no running experience -- then this is a noop.
                (0, $4EKKB.selectInlineComment).debug('Renderer emitted event indicating no focused annotation.');
                return;
            }
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.complete({
                pageClass: pageClass,
                entryPoint: 'unknown:RendererFocus',
                annotationId: focusedAnnotation
            });
        }
        // Fired when an annotation is focused (ie. comment navigation, comment click)
        emitter.on((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        return ()=>{
            emitter.off((0, $fJCU9.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, handleAnnotationFocus);
        };
    }, [
        pageClass
    ]);
    const resetProviderState = (0, $cozmU.useCallback)(()=>{
        setSelectionProps(null);
        setHoverProps(null);
        setViewProps(null);
        setEditorCreateProps(null);
        setEditorViewProps(null);
        setShowCreateComponent(false);
        setShowHighlightActions(false);
        setSelectionOptions(undefined);
        setStepGenerationError(false);
        setNewlyCreatedAnnotationId(undefined);
        setCommentSidebarContext(null);
        setStoredCommentData(null);
    }, []);
    // When the content ID changes, reset the provider state
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        if (prevContentId && contentId !== prevContentId) {
            resetProviderState();
            // Deselect any currently selected annotations
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
        }
        setPrevContentId(contentId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId
    ]);
    // Stable ref for selectionOptions — updated synchronously alongside every setSelectionOptions call
    // so handleSaveSuccess always reads the latest step even when its useCallback closure is stale.
    const selectionOptionsRef = (0, $cozmU.useRef)(undefined);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setShowCreateComponent(false);
        setStepGenerationError(false);
        if ((0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false)) selectionOptionsRef.current = undefined;
        setSelectionOptions(undefined);
        if (annotationManager) annotationManager.clearDraft();
        else selectionProps && selectionProps.onClose();
        setSelectionProps(null);
    }, [
        setShowCreateComponent,
        setStepGenerationError,
        setSelectionOptions,
        selectionProps,
        annotationManager
    ]);
    /*
   * NOTE: This function will not be calling setShowCreateComponent because it's
   *       consumers will not be refreshing themselves with new selectionOptions.
   *       It will now be the responsibility of the consumers of this function to call
   *       setShowCreateComponent(true). See SelectionComponent.tsx (~line 132)
   */ const setSelectionOptionsForCreateEditor = (0, $cozmU.useCallback)(({ experienceAttributes: experienceAttributes } = {})=>{
        setShowCreateComponent(false); // Hide an existing create component if it exists
        const annotationId = (0, $9HkI0.v4)();
        // Narrow pageClass to 'renderer' | 'editor' for the experience attributes
        const pageClassAttr = pageClass === 'renderer' ? 'renderer' : 'editor';
        (0, $3YBks.createInlineCommentCompoundExperience).start({
            attributes: {
                pageClass: pageClassAttr,
                commentType: 'inline',
                annotationId: annotationId,
                ...experienceAttributes
            }
        });
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.start();
        let result = undefined;
        if (annotationManager) {
            const startDraftResult = annotationManager.startDraft();
            if (startDraftResult.success) result = startDraftResult.actionResult;
        } else {
            /* selectionPropsRef fallback: selectionProps (React state) may be null immediately
         after a sidebar close due to a render-cycle gap, while the ref holds the last-known
         value. Prefer the ref (updated synchronously) so nudge click always gets the freshest
         value. For experiment-OFF callers, selectionProps is non-null so ref vs state is moot. */ const currentSelectionProps = selectionPropsRef.current ?? selectionProps;
            if (!currentSelectionProps) {
                // selectionProps is not defined. This may occur if a comment sidebar box was just closed, which
                // unsets selectionProps. In this case, we treat this as no-op, and unselect any annotation.
                (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                // We soft-fail create-inline-comment/init experience here to track how often this occurs.
                (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Attempted to create inline comment when no selection was present'));
                return;
            }
            // Reset ref before applyDraftMode so handleSaveSuccess reads the fresh step (COMMENTS-6594).
            if ((0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false)) selectionOptionsRef.current = undefined;
            result = currentSelectionProps.applyDraftMode({
                annotationId: annotationId,
                keepNativeSelection: false
            });
        }
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: result?.inlineNodeTypes ?? [],
            // @ts-ignore
            initialPosition: [
                result?.step?.from,
                result?.step?.to
            ]
        });
        if (result) {
            const newSelectionOptions = {
                step: result.step,
                inlineNodeTypes: result.inlineNodeTypes,
                originalSelection: result.originalSelection,
                numMatches: result.numMatches,
                matchIndex: result.matchIndex,
                createdFrom: (0, $afGoD.CommentCreationLocation).RENDERER,
                pos: result.pos,
                targetNodeType: result.targetNodeType
            };
            // Update ref synchronously BEFORE setSelectionOptions so handleSaveSuccess
            // always reads the latest step even if its closure captured a stale value.
            selectionOptionsRef.current = newSelectionOptions;
            setSelectionOptions(newSelectionOptions);
            // Tell the renderer to close any currently-open comments
            (0, $gczDe.getRendererAnnotationEventEmitter)().emit((0, $fJCU9.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            setShowHighlightActions(false);
        } else {
            setStepGenerationError(true);
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Failed to generate step'));
        }
    }, [
        selectionProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setStepGenerationError,
        annotationManager,
        pageClass
    ]);
    const handleSaveSuccess = (0, $cozmU.useCallback)((annotationId, commentData)=>{
        setStepGenerationError(false);
        setCommentSidebarContext('create');
        // Set stored comment data for direct data flow when experiment is enabled
        if (commentData) setStoredCommentData(commentData);
        let result = false;
        if (annotationManager) {
            const result = annotationManager.applyDraft(annotationId);
            if (result.success && !!result.actionResult?.doc) {
                selectionProps.updateDocument && selectionProps.updateDocument(result.actionResult.doc);
                setNewlyCreatedAnnotationId(annotationId);
            } else throw new Error('Error ocurred when applying the step to the active document');
        } else {
            // When the experiment is on, read from ref to get the latest selectionOptions regardless of
            // closure staleness — the create panel may hold an old handleSaveSuccess reference from before
            // setSelectionOptions was called for the new selection, causing the stale step to be used.
            const currentSelectionOptions = selectionOptions && (0, $6mKj3.expVal)('confluence_inline_comments_fix_stale_selection', 'isEnabled', false) ? selectionOptionsRef.current ?? selectionOptions : selectionOptions;
            // Renderer mode: Try using rendererActions.applyAnnotation() first (similar to editor's annotationManager.applyDraft())
            // This provides more reliable annotation application, matching the editor implementation
            if (rendererActions && currentSelectionOptions?.step) {
                const step = currentSelectionOptions.step;
                // Extract position from step - use pos if available, otherwise use from/to
                const position = currentSelectionOptions.pos ? {
                    to: currentSelectionOptions.pos,
                    from: currentSelectionOptions.pos
                } : {
                    to: step.to,
                    from: step.from
                };
                const annotationResult = rendererActions.applyAnnotation(position, {
                    annotationId: annotationId,
                    annotationType: (0, $epbW8.AnnotationTypes).INLINE_COMMENT
                });
                if (annotationResult && annotationResult.doc) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    if (!storedCommentData) selectionProps.removeDraftMode();
                    selectionProps.updateDocument && selectionProps.updateDocument(annotationResult.doc);
                    waitForAnnotationElementAndEmit(annotationId, emitter);
                } else throw new Error('Error ocurred when applying the step to the active document');
            } else {
                // Fallback to original onCreate method
                // Since we generated the uuid ourselves, we need to replace the document generated with
                // the annotationId that we received from the backend so things line up correctly
                result = selectionProps.onCreate(annotationId);
                if (result) {
                    const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                    if (!storedCommentData) selectionProps.removeDraftMode();
                    selectionProps.updateDocument && selectionProps.updateDocument(result.doc);
                    waitForAnnotationElementAndEmit(annotationId, emitter);
                } else throw new Error('Error ocurred when applying the step to the active document');
            }
        }
    }, [
        annotationManager,
        setStepGenerationError,
        setNewlyCreatedAnnotationId,
        selectionProps,
        setStoredCommentData,
        storedCommentData,
        rendererActions,
        selectionOptions,
        waitForAnnotationElementAndEmit
    ]);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            selectionProps: selectionProps,
            hoverProps: hoverProps,
            viewProps: viewProps,
            editorCreateProps: editorCreateProps,
            editorViewProps: editorViewProps,
            showCreateComponent: showCreateComponent,
            showHighlightActions: showHighlightActions,
            selectionOptions: selectionOptions,
            stepGenerationError: stepGenerationError,
            newlyCreatedAnnotationId: newlyCreatedAnnotationId,
            commentSidebarContext: commentSidebarContext,
            isOffline: isOffline,
            storedCommentData: storedCommentData
        }), [
        selectionProps,
        hoverProps,
        viewProps,
        editorCreateProps,
        editorViewProps,
        showCreateComponent,
        showHighlightActions,
        selectionOptions,
        stepGenerationError,
        newlyCreatedAnnotationId,
        commentSidebarContext,
        isOffline,
        storedCommentData
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            requestCloseEditorComment: requestCloseEditorComment,
            setEditorCommentCloseGuard: setEditorCommentCloseGuard,
            setSelectionProps: setSelectionProps,
            setHoverProps: setHoverProps,
            setViewProps: setViewProps,
            setEditorCreateProps: setEditorCreateProps,
            setEditorViewProps: setEditorViewProps,
            setShowCreateComponent: setShowCreateComponent,
            setShowHighlightActions: setShowHighlightActions,
            setSelectionOptions: setSelectionOptions,
            setStepGenerationError: setStepGenerationError,
            setSelectionOptionsForCreateEditor: setSelectionOptionsForCreateEditor,
            setNewlyCreatedAnnotationId: setNewlyCreatedAnnotationId,
            setCommentSidebarContext: setCommentSidebarContext,
            handleSaveSuccess: handleSaveSuccess,
            handleClose: handleClose,
            setIsOffline: setIsOffline,
            // Stored comment data management functions
            setStoredCommentData: (commentData)=>setStoredCommentData(commentData ?? null),
            clearStoredCommentData: ()=>setStoredCommentData(null),
            waitForAnnotationElementAndEmit: waitForAnnotationElementAndEmit,
            applyDraftModeRef: applyDraftModeRef
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        requestCloseEditorComment,
        setEditorCommentCloseGuard,
        setSelectionProps,
        setHoverProps,
        setViewProps,
        setEditorCreateProps,
        setEditorViewProps,
        setShowCreateComponent,
        setShowHighlightActions,
        setSelectionOptions,
        setStepGenerationError,
        setSelectionOptionsForCreateEditor,
        setNewlyCreatedAnnotationId,
        setCommentSidebarContext,
        handleSaveSuccess,
        handleClose,
        setIsOffline,
        // Stored comment data management functions
        setStoredCommentData,
        waitForAnnotationElementAndEmit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$567c82ef93e7d5a1.Provider, {
        value: annotationManager
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$39085f26fb4d6afa.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$6e641cb791644965.Provider, {
        value: dispatchProviderValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d99a6317060f344e$export$57d1b2fe9544d93c.Provider, {
        value: isOffline
    }, children))));
};
const $d99a6317060f344e$export$ede9be424e8ef89a = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$39085f26fb4d6afa);
};
const $d99a6317060f344e$export$3be336e5c3e78567 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$6e641cb791644965);
};
const $d99a6317060f344e$export$3998d49469d13f97 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$567c82ef93e7d5a1);
};
const $d99a6317060f344e$export$3757730e05e42ee2 = ()=>{
    return (0, $cozmU.useContext)($d99a6317060f344e$export$57d1b2fe9544d93c);
};
module.exports["AnnotationsProvider"] = $d99a6317060f344e$export$22e6290b4a8e41d3;
module.exports["useAnnotations"] = $d99a6317060f344e$export$ede9be424e8ef89a;
module.exports["useAnnotationsDispatch"] = $d99a6317060f344e$export$3be336e5c3e78567;
module.exports["useAnnotationManager"] = $d99a6317060f344e$export$3998d49469d13f97;
module.exports["useAnnotationsIsOffline"] = $d99a6317060f344e$export$3757730e05e42ee2;

});

parcelRegister("afGoD", function(module, exports) {
/**
 * @generated SignedSource<<71be4194137313c8ff0872a3df259dda>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $f8b43d46712cd783$export$cdccd0683766be81 = /*#__PURE__*/ function(CommentCreationLocation) {
    CommentCreationLocation["DATABASE"] = "DATABASE";
    CommentCreationLocation["EDITOR"] = "EDITOR";
    CommentCreationLocation["LIVE"] = "LIVE";
    CommentCreationLocation["RENDERER"] = "RENDERER";
    CommentCreationLocation["WHITEBOARD"] = "WHITEBOARD";
    return CommentCreationLocation;
}({});
var $f8b43d46712cd783$export$f4016897b165b6d5 = /*#__PURE__*/ function(ContentRepresentation) {
    ContentRepresentation["ATLAS_DOC_FORMAT"] = "ATLAS_DOC_FORMAT";
    ContentRepresentation["EDITOR"] = "EDITOR";
    ContentRepresentation["EDITOR2"] = "EDITOR2";
    ContentRepresentation["EXPORT_VIEW"] = "EXPORT_VIEW";
    ContentRepresentation["PLAIN"] = "PLAIN";
    ContentRepresentation["RAW"] = "RAW";
    ContentRepresentation["STORAGE"] = "STORAGE";
    ContentRepresentation["STYLED_VIEW"] = "STYLED_VIEW";
    ContentRepresentation["VIEW"] = "VIEW";
    ContentRepresentation["WIKI"] = "WIKI";
    return ContentRepresentation;
}({});
var $f8b43d46712cd783$export$2dffd0b5373a4389 = /*#__PURE__*/ function(Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    return Platform;
}({});
var $f8b43d46712cd783$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["CommentCreationLocation"] = $f8b43d46712cd783$export$cdccd0683766be81;
module.exports["ContentRepresentation"] = $f8b43d46712cd783$export$f4016897b165b6d5;

});

parcelRegister("9QIM2", function(module, exports) {

var $de2j9 = parcelRequire("de2j9");


var $3jwuS = parcelRequire("3jwuS");


var $dPJCf = parcelRequire("dPJCf");


var $gEtAQ = parcelRequire("gEtAQ");

function $06d23c10422abe2f$export$d9ae12e82c9f2aba() {
    // Note -- this hook does not inform the consumer if they are on a live doc page which
    // is using the editor.
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const isCurrentPageLive = (0, $3jwuS.useIsCurrentPageLive)();
    // useRouteName use RoutesContext which is more reliable than reading window.location.pathname directly.
    const routeName = (0, $dPJCf.useRouteName)({
        selector: (name)=>name
    });
    if (isEditorPage) return 'editor';
    if (isCurrentPageLive) return 'editor';
    const isTinyMCEPage = $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage();
    if (isTinyMCEPage) // TinyMCE pages are not considered editor pages or docs in the context of this hook
    return 'tinyMCE';
    // Pass routeName to isDatabase/isWhiteboard - they will use it to avoid race conditions during SPA transitions
    if ((0, $gEtAQ.isDatabase)(routeName)) return 'database';
    if ((0, $gEtAQ.isWhiteboard)(routeName)) return 'whiteboard';
    if ((0, $gEtAQ.isSlides)(routeName)) return 'slide';
    return 'renderer';
}
function $06d23c10422abe2f$var$__checkIfTinyMCEEditorPage() {
    const possibleTinyMCESelectors = [
        `[data-testid="TinyMCERendererTestId"]`,
        '.tinymce-editor'
    ];
    // This check is only relevant in the context of comment experiences
    // and so if we are in an environment without a document -- we
    // can safely treat it as not a tinymce page.
    if (typeof document === 'undefined') return false;
    const isTinyMCEPage = possibleTinyMCESelectors.some(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    (selector)=>document.querySelector(selector) !== null);
    return isTinyMCEPage;
}
module.exports["usePageClass"] = $06d23c10422abe2f$export$d9ae12e82c9f2aba;

});

parcelRegister("de2j9", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");

const $da4a5d353aff754e$var$isOnEditorPageRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.EDIT_PAGE_V2).name || routeName === (0, $1NBp8.EDIT_BLOG_V2).name || routeName === (0, $1NBp8.EDIT_PAGE_EMBED).name || routeName === (0, $1NBp8.COMPANY_HUB_EDIT).name || routeName === (0, $1NBp8.HUB_EDIT).name || routeName === (0, $1NBp8.EDIT_PAGE_SMART_CREATE).name || routeName === (0, $1NBp8.SPACE_SETTINGS_AGENT_CONTEXT).name
};
const $da4a5d353aff754e$export$90b90ac8ec152a49 = ()=>{
    return (0, $dPJCf.useRouteName)($da4a5d353aff754e$var$isOnEditorPageRouteArgs);
};
module.exports["useIsEditorPage"] = $da4a5d353aff754e$export$90b90ac8ec152a49;

});

parcelRegister("3YBks", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");


var $1A7bE = parcelRequire("1A7bE");

let $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
let $3ac00da98b683ca3$var$runningExperiences = [];
// Note: The soft failure is set on the first soft failure not updated following
let $3ac00da98b683ca3$var$softFailure = undefined;
let $3ac00da98b683ca3$var$publishFailed = false;
let $3ac00da98b683ca3$var$publishSuccessCount = 0;
let $3ac00da98b683ca3$var$commentExperienceContext = {};
function $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug(experienceName) {
    function createInlineCommentExperienceDebug({ error: error, createAnalyticsEvent: createAnalyticsEvent, extraAttributes: extraAttributes }) {
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const experienceAttributes = experienceTracker.getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'error',
                actionSubject: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
                source: experienceName,
                attributes: {
                    ...experienceAttributes,
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
                    ...extraAttributes,
                    error: error.message || String(error),
                    stack: error.stack
                }
            }
        }).fire();
    }
    return createInlineCommentExperienceDebug;
}
const $3ac00da98b683ca3$export$90894e50be2305e9 = {
    start: function createInlineCommentCompoundExperience({ attributes: attributes }) {
        // reset common experience state when starting a new parent experience
        $3ac00da98b683ca3$var$runningExperiences = [
            (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)
        ];
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {};
        $3ac00da98b683ca3$var$softFailure = undefined;
        $3ac00da98b683ca3$var$publishFailed = false;
        $3ac00da98b683ca3$var$publishSuccessCount = 0;
        const compoundTaskId = (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        const context = {
            commentTargetType: attributes.commentTargetType ?? (attributes.commentType === 'block' ? attributes.blockType === 'media' ? 'media' : 'other' : 'text'),
            ...attributes.pageMode ? {
                pageMode: attributes.pageMode
            } : attributes.pageClass === 'renderer' ? {
                pageMode: 'view'
            } : {}
        };
        $3ac00da98b683ca3$var$commentExperienceContext = context;
        experienceTracker.start({
            name: (0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE),
            id: compoundTaskId,
            attributes: {
                ...attributes,
                ...context,
                compoundTaskId: compoundTaskId
            },
            collect: (events, experience)=>{
                (0, $1A7bE.collectAll)(attributes.entryPoint === 'mediaViewerSidebar' ? [
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ] : [
                    (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                    (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
                ])(events, experience);
            }
        });
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...context,
            compoundTaskId: compoundTaskId,
            annotationId: attributes.annotationId,
            pageClass: attributes.pageClass,
            entryPoint: attributes.entryPoint,
            edition: attributes.edition
        };
    },
    getContext: ()=>{
        const experience = (0, $fGzMp.getExperienceTracker)().getExperienceState((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE));
        // An entry point without tracking must not inherit the previous completed attempt.
        return experience && !experience.hasStopped ? {
            ...$3ac00da98b683ca3$var$commentExperienceContext
        } : {};
    },
    debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_EXPERIENCE)),
    addCommonAttributes: (commonAttributes)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes = {
            ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes,
            ...commonAttributes
        };
        for (const runningExperience of $3ac00da98b683ca3$var$runningExperiences)experienceTracker.updateAttributes({
            name: runningExperience,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    attachCommonAttributes: (experienceName)=>{
        const experienceTracker = (0, $fGzMp.getExperienceTracker)();
        experienceTracker.updateAttributes({
            name: experienceName,
            attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
        });
    },
    initExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                timeout: 5000,
                attributes: {
                    ...$3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
                }
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE));
        },
        fail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                error: error
            });
        },
        softFail: (error)=>{
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'init'
            };
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        /**
     * This completes the init experience and starts the draft to publish experience.
     */ complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_INIT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    draftToPublishExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE));
        },
        publishFailed: (error)=>{
            $3ac00da98b683ca3$var$publishFailed = true;
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'publish-failed'
            };
        },
        publishSucceeded: ()=>{
            $3ac00da98b683ca3$var$publishSuccessCount += 1;
        },
        abort: ({ abortReason: abortReason, attributes: attributes })=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: abortReason,
                attributes: attributes
            });
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        stopOnError: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.stopOnError({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        dismissed: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$publishSuccessCount > 0) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish success')
            });
            else if ($3ac00da98b683ca3$var$publishFailed) experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                error: new Error('Draft comment dismissed after publish attempt')
            });
            else experienceTracker.abort({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                reason: 'Draft comment dismissed'
            });
        },
        softFail: (error)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if (!$3ac00da98b683ca3$var$softFailure) $3ac00da98b683ca3$var$softFailure = {
                error: error,
                pointOfFailure: 'multiple-saves-without-error'
            };
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                attributes: {
                    softFailure: error.message
                }
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_DRAFT_TO_PUBLISH_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    },
    attachCommentExperience: {
        start: ()=>{
            $3ac00da98b683ca3$var$runningExperiences.push((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.start({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                // If the view comment does not load in 6 seconds, it's
                // an indicator something has gone wrong.
                timeout: 6000,
                attributes: $3ac00da98b683ca3$var$commonCreateInlineCommentExperiencesAttributes
            });
            $3ac00da98b683ca3$export$90894e50be2305e9.attachCommonAttributes((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE));
        },
        fail: (error, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.fail({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                error: error,
                attributes: attributes
            });
        },
        complete: ()=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            if ($3ac00da98b683ca3$var$softFailure) {
                experienceTracker.succeed({
                    name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                    attributes: {
                        softFailure: $3ac00da98b683ca3$var$softFailure.error.message,
                        pointOfFailure: $3ac00da98b683ca3$var$softFailure.pointOfFailure
                    }
                });
                return;
            }
            experienceTracker.succeed({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)
            });
        },
        debug: $3ac00da98b683ca3$var$getCreateInlineCommentExperienceDebug((0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE)),
        debugPoint: (message, attributes)=>{
            const experienceTracker = (0, $fGzMp.getExperienceTracker)();
            experienceTracker.attachDebugPoint({
                name: (0, $irVI7.CREATE_INLINE_COMMENT_ATTACH_COMMENT_EXPERIENCE),
                message: message,
                attributes: attributes
            });
        }
    }
};
module.exports["createInlineCommentCompoundExperience"] = $3ac00da98b683ca3$export$90894e50be2305e9;

});

parcelRegister("8WQTF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $cozmU.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $cozmU.useState)(null);
    const [pageId, setPageId] = (0, $cozmU.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $cozmU.useState)(undefined);
    const providerValue = (0, $cozmU.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $cozmU.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $cozmU.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});

parcelRegister("cE1Ys", function(module, exports) {

let $934ac080d02920a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $934ac080d02920a7$var$load("TIXGP"),
    $934ac080d02920a7$var$load("fEMSy"),
    $934ac080d02920a7$var$load("1lDWJ"),
    $934ac080d02920a7$var$load("6wr18"),
    $934ac080d02920a7$var$load("6damH"),
    $934ac080d02920a7$var$load("bb3WM"),
    $934ac080d02920a7$var$load("hEj0j"),
    $934ac080d02920a7$var$load("i35vr"),
    $934ac080d02920a7$var$load("1GCFv"),
    $934ac080d02920a7$var$load("32NHR"),
    $934ac080d02920a7$var$load("glmO2"),
    $934ac080d02920a7$var$load("lCkJt"),
    $934ac080d02920a7$var$load("ffEVr"),
    $934ac080d02920a7$var$load("aDjtG")
]).then(()=>parcelRequire('fJXL7'));

});

parcelRegister("ifTtc", function(module, exports) {

let $d4a4a7e33d926272$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d4a4a7e33d926272$var$load("jx2zo"),
    $d4a4a7e33d926272$var$load("6wr18"),
    $d4a4a7e33d926272$var$load("9Q8Ik"),
    $d4a4a7e33d926272$var$load("3FG3M"),
    $d4a4a7e33d926272$var$load("cAbXt"),
    $d4a4a7e33d926272$var$load("irTwo"),
    $d4a4a7e33d926272$var$load("1X4na"),
    $d4a4a7e33d926272$var$load("6XCf4"),
    $d4a4a7e33d926272$var$load("w3Gc8"),
    $d4a4a7e33d926272$var$load("4C4vr"),
    $d4a4a7e33d926272$var$load("gWjIZ"),
    $d4a4a7e33d926272$var$load("1yVM6"),
    $d4a4a7e33d926272$var$load("ffEVr"),
    $d4a4a7e33d926272$var$load("651dU")
]).then(()=>parcelRequire('gDZU2'));

});

parcelRegister("lt6Lx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d5RCH = parcelRequire("d5RCH");


var $1ytiN = parcelRequire("1ytiN");


var $gSgn8 = parcelRequire("gSgn8");


var $8vxJi = parcelRequire("8vxJi");

const $5a5ab99dc3af9e56$var$i18n = (0, $kSwu1.defineMessages)({
    notFound: {
        id: "document-title.not.found",
        defaultMessage: "Page Not Found"
    }
});
const $5a5ab99dc3af9e56$export$8f4c40b84dd15d46 = ({ titlePrefix: titlePrefix = '', contentTitle: contentTitle = '', contentSpace: contentSpace = '', siteTitleOnly: siteTitleOnly = false, notFound: notFound = false, isHomePage: isHomePage = false })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { siteTitle: siteTitle } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            window['__DOCUMENT_TITLE_TAG__'] = '';
        };
    }, []);
    // In the case when page is rendered by SSR, the __DOCUMENT_TITLE_TAG__ will be
    // populated and we can skip document title — but only when this render has no
    // meaningful content to contribute. If contentTitle, titlePrefix, notFound,
    // isHomePage, or siteTitleOnly are set, we must still update the title
    // (e.g. relay race: new page renders before old cleanup effect runs).
    if (window['__DOCUMENT_TITLE_TAG__'] && window['__SSR_RENDERED__'] && // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) return null;
    const title = [
        titlePrefix || (notFound ? intl.formatMessage($5a5ab99dc3af9e56$var$i18n.notFound) : ''),
        siteTitleOnly ? undefined : contentTitle,
        siteTitleOnly ? undefined : contentSpace,
        siteTitle
    ].filter((part)=>part).join(' - ');
    // Don't override an existing title with a less specific one (e.g., don't set "Confluence"
    // when there's already a title with content like "Page Title - Space - Confluence").
    // This prevents components with empty contentTitle from overriding titles set by components
    // with actual content during navigation/rendering transitions.
    // Note: This check happens during render, so it may not catch titles set in the same render cycle,
    // but useLayoutEffect in PageTitle ensures the last component to render wins.
    // A title is considered "specific" if it provides either a contentTitle or a titlePrefix.
    // Pages like the advanced search page pass a titlePrefix (e.g. "Search") without a
    // contentTitle, and we must still allow that title to replace the previous page's title
    // during client-side navigation. notFound, isHomePage, and siteTitleOnly are also
    // meaningful signals that must always be allowed to update the title.
    if (typeof document !== 'undefined' && document.title && !contentTitle && !titlePrefix && !notFound && !isHomePage && !siteTitleOnly) {
        // If contentTitle, titlePrefix, notFound, isHomePage, and siteTitleOnly are all empty/false,
        // we're likely setting a generic title (just siteTitle or siteTitle with space).
        // If there's already a more specific title (3+ parts, or 2 parts where first isn't siteTitle), skip.
        const existingTitleParts = document.title.split(' - ');
        const hasMoreSpecificContent = existingTitleParts.length > 2 || existingTitleParts.length === 2 && existingTitleParts[0] !== siteTitle;
        // Skip if we're trying to set a less specific title when a more specific one exists and it is not the home page
        if (hasMoreSpecificContent && title !== document.title) return null;
    }
    // Set for SSR document title
    window['__DOCUMENT_TITLE_TAG__'] = title;
    if (window.__SSR_REACT_STREAMING__) {
        const inject = (0, $gSgn8.getStreamInject)();
        inject(()=>`document.title=${(0, $8vxJi.stringifyForSSR)(title)}`);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5RCH.PageTitle), {
        title: title
    });
};
module.exports["DocumentContentTitle"] = $5a5ab99dc3af9e56$export$8f4c40b84dd15d46;

});

parcelRegister("9AQbC", function(module, exports) {

let $6fbff4fcbeda7a3d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6fbff4fcbeda7a3d$var$load("ELJez"),
    $6fbff4fcbeda7a3d$var$load("6kXh6"),
    $6fbff4fcbeda7a3d$var$load("kKNsN")
]).then(()=>parcelRequire('1vSpd'));

});

parcelRegister("jYfIJ", function(module, exports) {

let $e89fd0b2fecc9d76$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e89fd0b2fecc9d76$var$load("KsShd"),
    $e89fd0b2fecc9d76$var$load("i8sPk"),
    $e89fd0b2fecc9d76$var$load("bajKf"),
    $e89fd0b2fecc9d76$var$load("lPKve"),
    $e89fd0b2fecc9d76$var$load("TIXGP"),
    $e89fd0b2fecc9d76$var$load("6wr18"),
    $e89fd0b2fecc9d76$var$load("eMviP"),
    $e89fd0b2fecc9d76$var$load("jHqE3"),
    $e89fd0b2fecc9d76$var$load("59YMb"),
    $e89fd0b2fecc9d76$var$load("6j0nE"),
    $e89fd0b2fecc9d76$var$load("lHIG6"),
    $e89fd0b2fecc9d76$var$load("d3PpR"),
    $e89fd0b2fecc9d76$var$load("jEGYW"),
    $e89fd0b2fecc9d76$var$load("fb8QM"),
    $e89fd0b2fecc9d76$var$load("aoih9"),
    $e89fd0b2fecc9d76$var$load("b5HK3"),
    $e89fd0b2fecc9d76$var$load("bAgF6"),
    $e89fd0b2fecc9d76$var$load("hnpcA"),
    $e89fd0b2fecc9d76$var$load("5zDuS"),
    $e89fd0b2fecc9d76$var$load("28Uan"),
    $e89fd0b2fecc9d76$var$load("gpUln"),
    $e89fd0b2fecc9d76$var$load("ceSYH"),
    $e89fd0b2fecc9d76$var$load("4XkVJ"),
    $e89fd0b2fecc9d76$var$load("2j57H"),
    $e89fd0b2fecc9d76$var$load("eNrzL"),
    $e89fd0b2fecc9d76$var$load("hyCrt"),
    $e89fd0b2fecc9d76$var$load("VXbA1"),
    $e89fd0b2fecc9d76$var$load("ffEVr"),
    $e89fd0b2fecc9d76$var$load("gQrOI"),
    $e89fd0b2fecc9d76$var$load("2xoIF"),
    $e89fd0b2fecc9d76$var$load("gA528"),
    $e89fd0b2fecc9d76$var$load("j6RYV")
]).then(()=>parcelRequire('5y7xd'));

});

parcelRegister("b0v5X", function(module, exports) {

let $8037d09befcc7d72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8037d09befcc7d72$var$load("i8sPk"),
    $8037d09befcc7d72$var$load("7k9oy"),
    $8037d09befcc7d72$var$load("6wr18"),
    $8037d09befcc7d72$var$load("1REma"),
    $8037d09befcc7d72$var$load("eosOx"),
    $8037d09befcc7d72$var$load("hafZt"),
    $8037d09befcc7d72$var$load("2EL9y"),
    $8037d09befcc7d72$var$load("9jcs1"),
    $8037d09befcc7d72$var$load("d3PpR"),
    $8037d09befcc7d72$var$load("gpUln"),
    $8037d09befcc7d72$var$load("dnOT2"),
    $8037d09befcc7d72$var$load("bWtlo"),
    $8037d09befcc7d72$var$load("1F9i1"),
    $8037d09befcc7d72$var$load("1kmQo"),
    $8037d09befcc7d72$var$load("2j57H"),
    $8037d09befcc7d72$var$load("lPKve"),
    $8037d09befcc7d72$var$load("jw3eS"),
    $8037d09befcc7d72$var$load("d8cdR"),
    $8037d09befcc7d72$var$load("hyCrt"),
    $8037d09befcc7d72$var$load("7EorR"),
    $8037d09befcc7d72$var$load("jqoep"),
    $8037d09befcc7d72$var$load("44XW6"),
    $8037d09befcc7d72$var$load("hhss7"),
    $8037d09befcc7d72$var$load("1ElkK"),
    $8037d09befcc7d72$var$load("gWjIZ"),
    $8037d09befcc7d72$var$load("VXbA1"),
    $8037d09befcc7d72$var$load("dxcsb"),
    $8037d09befcc7d72$var$load("gQrOI"),
    $8037d09befcc7d72$var$load("9BBvG"),
    $8037d09befcc7d72$var$load("cYv6T"),
    $8037d09befcc7d72$var$load("fdFOR"),
    $8037d09befcc7d72$var$load("11yNG"),
    $8037d09befcc7d72$var$load("gQYVn"),
    $8037d09befcc7d72$var$load("9RGBF"),
    $8037d09befcc7d72$var$load("2iL13"),
    $8037d09befcc7d72$var$load("cpTbC"),
    $8037d09befcc7d72$var$load("fhT77"),
    $8037d09befcc7d72$var$load("jvUhP"),
    $8037d09befcc7d72$var$load("7sOKp"),
    $8037d09befcc7d72$var$load("7Ysw6"),
    $8037d09befcc7d72$var$load("3xL2F"),
    $8037d09befcc7d72$var$load("kMyku"),
    $8037d09befcc7d72$var$load("hG1ar"),
    $8037d09befcc7d72$var$load("5d2zd"),
    $8037d09befcc7d72$var$load("d0ZRF"),
    $8037d09befcc7d72$var$load("k507P"),
    $8037d09befcc7d72$var$load("jZNbu"),
    $8037d09befcc7d72$var$load("1HPRy"),
    $8037d09befcc7d72$var$load("ffEVr"),
    $8037d09befcc7d72$var$load("2xoIF"),
    $8037d09befcc7d72$var$load("dkIUD")
]).then(()=>parcelRequire('l2J3i'));

});

parcelRegister("7vEg5", function(module, exports) {

let $577aa8286d13d09e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $577aa8286d13d09e$var$load("hNOga"),
    $577aa8286d13d09e$var$load("izROg"),
    $577aa8286d13d09e$var$load("4fYzp"),
    $577aa8286d13d09e$var$load("lHX6l"),
    $577aa8286d13d09e$var$load("7Y0AX"),
    $577aa8286d13d09e$var$load("1GCFv"),
    $577aa8286d13d09e$var$load("bAgF6"),
    $577aa8286d13d09e$var$load("7EorR"),
    $577aa8286d13d09e$var$load("jqoep"),
    $577aa8286d13d09e$var$load("aRnD4")
]).then(()=>parcelRequire('fgp6d'));

});

parcelRegister("1AoQw", function(module, exports) {

let $127c6d28a669bf6e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $127c6d28a669bf6e$var$load("bajKf"),
    $127c6d28a669bf6e$var$load("jE0Mz"),
    $127c6d28a669bf6e$var$load("6wr18"),
    $127c6d28a669bf6e$var$load("lHIG6"),
    $127c6d28a669bf6e$var$load("4WTdS"),
    $127c6d28a669bf6e$var$load("2xYWc"),
    $127c6d28a669bf6e$var$load("6XCf4"),
    $127c6d28a669bf6e$var$load("hSDwk"),
    $127c6d28a669bf6e$var$load("d3PpR"),
    $127c6d28a669bf6e$var$load("5qdFt"),
    $127c6d28a669bf6e$var$load("jEGYW"),
    $127c6d28a669bf6e$var$load("fb8QM"),
    $127c6d28a669bf6e$var$load("CfmiU"),
    $127c6d28a669bf6e$var$load("9PRTA"),
    $127c6d28a669bf6e$var$load("bAgF6"),
    $127c6d28a669bf6e$var$load("hnpcA"),
    $127c6d28a669bf6e$var$load("6TqFw"),
    $127c6d28a669bf6e$var$load("ELJez"),
    $127c6d28a669bf6e$var$load("j5wpJ"),
    $127c6d28a669bf6e$var$load("jFbCQ"),
    $127c6d28a669bf6e$var$load("jNdu9"),
    $127c6d28a669bf6e$var$load("7SteV"),
    $127c6d28a669bf6e$var$load("Msrsx"),
    $127c6d28a669bf6e$var$load("211bN"),
    $127c6d28a669bf6e$var$load("59JAK"),
    $127c6d28a669bf6e$var$load("2bJoN"),
    $127c6d28a669bf6e$var$load("ji2ex"),
    $127c6d28a669bf6e$var$load("4XkVJ"),
    $127c6d28a669bf6e$var$load("2j57H"),
    $127c6d28a669bf6e$var$load("lPKve"),
    $127c6d28a669bf6e$var$load("jw3eS"),
    $127c6d28a669bf6e$var$load("1lfcO"),
    $127c6d28a669bf6e$var$load("4U6x6"),
    $127c6d28a669bf6e$var$load("d8cdR"),
    $127c6d28a669bf6e$var$load("hyCrt"),
    $127c6d28a669bf6e$var$load("jqoep"),
    $127c6d28a669bf6e$var$load("44XW6"),
    $127c6d28a669bf6e$var$load("gWjIZ"),
    $127c6d28a669bf6e$var$load("VXbA1"),
    $127c6d28a669bf6e$var$load("8GFi1"),
    $127c6d28a669bf6e$var$load("1yVM6"),
    $127c6d28a669bf6e$var$load("hhss7"),
    $127c6d28a669bf6e$var$load("fHVVl"),
    $127c6d28a669bf6e$var$load("7EorR"),
    $127c6d28a669bf6e$var$load("ffEVr"),
    $127c6d28a669bf6e$var$load("dxcsb"),
    $127c6d28a669bf6e$var$load("gQrOI"),
    $127c6d28a669bf6e$var$load("cS7dz")
]).then(()=>parcelRequire('ec8HN'));

});

parcelRegister("99E45", function(module, exports) {

let $6aa4086548892de5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6aa4086548892de5$var$load("IyjLX").then(()=>parcelRequire('esu8h'));

});

parcelRegister("dVA4j", function(module, exports) {

let $a23c93aed97776be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a23c93aed97776be$var$load("7S9EX").then(()=>parcelRequire('3VmKy'));

});

parcelRegister("hwzJf", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $a0c1672298304318$export$c34c105fee6e8977 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "JsB5i",
    name: "GoToHomeLoader",
    loader: async ()=>(await (parcelRequire("2kNNv"))).GoToHome
});
module.exports["GoToHomeLoader"] = $a0c1672298304318$export$c34c105fee6e8977;

});

parcelRegister("2kNNv", function(module, exports) {

let $1b3413cb4d71dd58$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1b3413cb4d71dd58$var$load("c0lrw").then(()=>parcelRequire('7QGXJ'));

});

parcelRegister("idSff", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d4a3e046810f681f$export$1fe963e8f052ccbb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VM3qQ",
    name: "SiteHomepageRedirectLoader",
    loader: async ()=>(await (parcelRequire("hrkl2"))).SiteHomepageRedirect
});
module.exports["SiteHomepageRedirectLoader"] = $d4a3e046810f681f$export$1fe963e8f052ccbb;

});

parcelRegister("hrkl2", function(module, exports) {

let $cb24bc114e1af585$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cb24bc114e1af585$var$load("cgZOp").then(()=>parcelRequire('kkwpp'));

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    showCreateWithRovo: (0, $hQnHK.SHOW_CREATE_WITH_ROVO_QUERY_PARAM),
    journeyId: 'journeyId',
    rovoAgentId: 'rovoAgentId',
    templateKey: 'templateKey',
    templateId: 'templateId',
    onboardingEntryPoint: 'onboardingEntryPoint',
    cwrWelcome: 'cwrWelcome'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('showCreateWithRovo' in options && options.showCreateWithRovo !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.showCreateWithRovo] = options.showCreateWithRovo;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('rovoAgentId' in options && options.rovoAgentId) queryParams[$e7afa99020494478$var$queryParamKeys.rovoAgentId] = options.rovoAgentId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    if ('templateId' in options && options.templateId) queryParams[$e7afa99020494478$var$queryParamKeys.templateId] = options.templateId;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) return contentType;
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const rovoAgentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.rovoAgentId);
    const onboardingEntryPoint = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.onboardingEntryPoint);
    const cwrWelcome = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cwrWelcome);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const showCreateWithRovoParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.showCreateWithRovo);
    const showCreateWithRovo = showCreateWithRovoParam ? showCreateWithRovoParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    const templateId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateId);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        showCreateWithRovo: showCreateWithRovo,
        journeyId: journeyId,
        rovoAgentId: rovoAgentId,
        onboardingEntryPoint: onboardingEntryPoint,
        templateKey: templateKey,
        templateId: templateId,
        cwrWelcome: cwrWelcome
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$a90803a9f656fd5f = 'showCreateWithRovo';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$57f29eb0a90c2092 = 'initial-background-style';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$bc2f90c007ecd529 = 'rovo';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
const $0037b6bfd6daf741$export$8896acdfcdaf8f6d = 'hideBorder';
const $0037b6bfd6daf741$export$39abeb28b3f870c6 = 'embed';
const $0037b6bfd6daf741$export$f0568a870cb93dbd = 'nativeEmbedView';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["SHOW_CREATE_WITH_ROVO_QUERY_PARAM"] = $0037b6bfd6daf741$export$a90803a9f656fd5f;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["INITIAL_BACKGROUND_STYLE_QUERY_PARAM"] = $0037b6bfd6daf741$export$57f29eb0a90c2092;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["ROVO_PARENT_PRODUCT_QUERY_VALUE"] = $0037b6bfd6daf741$export$bc2f90c007ecd529;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;
module.exports["HIDE_BORDER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8896acdfcdaf8f6d;
module.exports["EMBED_QUERY_PARAM"] = $0037b6bfd6daf741$export$39abeb28b3f870c6;
module.exports["NATIVE_EMBED_VIEW_QUERY_PARAM"] = $0037b6bfd6daf741$export$f0568a870cb93dbd;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("8MiHL", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $664150cfb8454085$export$325f108b642b51d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EdgKX",
    name: "LazyRouteToRightEditor",
    loader: ()=>(parcelRequire("9C4Th"))
});
module.exports["LazyRouteToRightEditor"] = $664150cfb8454085$export$325f108b642b51d;

});

parcelRegister("9C4Th", function(module, exports) {

let $6ffb74d421c83421$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ffb74d421c83421$var$load("4NoAV").then(()=>parcelRequire('kZVh7'));

});

parcelRegister("96RjB", function(module, exports) {

let $6a1e07de5c06842c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a1e07de5c06842c$var$load("4PCFY"),
    $6a1e07de5c06842c$var$load("KsShd"),
    $6a1e07de5c06842c$var$load("knUU4"),
    $6a1e07de5c06842c$var$load("jD3c3"),
    $6a1e07de5c06842c$var$load("i8sPk"),
    $6a1e07de5c06842c$var$load("vYEMr"),
    $6a1e07de5c06842c$var$load("2F69B"),
    $6a1e07de5c06842c$var$load("jHqE3"),
    $6a1e07de5c06842c$var$load("9Lh9g"),
    $6a1e07de5c06842c$var$load("6j0nE"),
    $6a1e07de5c06842c$var$load("9jF3u"),
    $6a1e07de5c06842c$var$load("lHIG6"),
    $6a1e07de5c06842c$var$load("2xYWc"),
    $6a1e07de5c06842c$var$load("d3PpR"),
    $6a1e07de5c06842c$var$load("5qdFt"),
    $6a1e07de5c06842c$var$load("xl5Th"),
    $6a1e07de5c06842c$var$load("fb8QM"),
    $6a1e07de5c06842c$var$load("b5HK3"),
    $6a1e07de5c06842c$var$load("9PRTA"),
    $6a1e07de5c06842c$var$load("1jVx9"),
    $6a1e07de5c06842c$var$load("gpUln"),
    $6a1e07de5c06842c$var$load("ELJez"),
    $6a1e07de5c06842c$var$load("jNdu9"),
    $6a1e07de5c06842c$var$load("7SteV"),
    $6a1e07de5c06842c$var$load("Msrsx"),
    $6a1e07de5c06842c$var$load("211bN"),
    $6a1e07de5c06842c$var$load("59JAK"),
    $6a1e07de5c06842c$var$load("bajKf"),
    $6a1e07de5c06842c$var$load("2j57H"),
    $6a1e07de5c06842c$var$load("lPKve"),
    $6a1e07de5c06842c$var$load("jw3eS"),
    $6a1e07de5c06842c$var$load("d8cdR"),
    $6a1e07de5c06842c$var$load("hyCrt"),
    $6a1e07de5c06842c$var$load("3Kg3S"),
    $6a1e07de5c06842c$var$load("44XW6"),
    $6a1e07de5c06842c$var$load("gWjIZ"),
    $6a1e07de5c06842c$var$load("VXbA1"),
    $6a1e07de5c06842c$var$load("hhss7"),
    $6a1e07de5c06842c$var$load("dxcsb"),
    $6a1e07de5c06842c$var$load("gQrOI"),
    $6a1e07de5c06842c$var$load("2xoIF"),
    $6a1e07de5c06842c$var$load("gA528"),
    $6a1e07de5c06842c$var$load("jE0Mz"),
    $6a1e07de5c06842c$var$load("6wr18"),
    $6a1e07de5c06842c$var$load("jyXyo"),
    $6a1e07de5c06842c$var$load("53mVX"),
    $6a1e07de5c06842c$var$load("ffEVr"),
    $6a1e07de5c06842c$var$load("7EorR"),
    $6a1e07de5c06842c$var$load("aHCaB"),
    $6a1e07de5c06842c$var$load("lwNze")
]).then(()=>parcelRequire('dJsyi'));

});

parcelRegister("6QwJq", function(module, exports) {

let $4fc0fd4079c2e5a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4fc0fd4079c2e5a9$var$load("4PCFY"),
    $4fc0fd4079c2e5a9$var$load("jE0Mz"),
    $4fc0fd4079c2e5a9$var$load("hNOga"),
    $4fc0fd4079c2e5a9$var$load("eMviP"),
    $4fc0fd4079c2e5a9$var$load("jHqE3"),
    $4fc0fd4079c2e5a9$var$load("6j0nE"),
    $4fc0fd4079c2e5a9$var$load("lHIG6"),
    $4fc0fd4079c2e5a9$var$load("1PjZc"),
    $4fc0fd4079c2e5a9$var$load("2be0t"),
    $4fc0fd4079c2e5a9$var$load("7BITa"),
    $4fc0fd4079c2e5a9$var$load("2xYWc"),
    $4fc0fd4079c2e5a9$var$load("5qdFt"),
    $4fc0fd4079c2e5a9$var$load("xl5Th"),
    $4fc0fd4079c2e5a9$var$load("fb8QM"),
    $4fc0fd4079c2e5a9$var$load("b5HK3"),
    $4fc0fd4079c2e5a9$var$load("9PRTA"),
    $4fc0fd4079c2e5a9$var$load("2wboY"),
    $4fc0fd4079c2e5a9$var$load("ELJez"),
    $4fc0fd4079c2e5a9$var$load("6rYhz"),
    $4fc0fd4079c2e5a9$var$load("jNdu9"),
    $4fc0fd4079c2e5a9$var$load("7SteV"),
    $4fc0fd4079c2e5a9$var$load("Msrsx"),
    $4fc0fd4079c2e5a9$var$load("211bN"),
    $4fc0fd4079c2e5a9$var$load("bajKf"),
    $4fc0fd4079c2e5a9$var$load("2j57H"),
    $4fc0fd4079c2e5a9$var$load("lPKve"),
    $4fc0fd4079c2e5a9$var$load("jw3eS"),
    $4fc0fd4079c2e5a9$var$load("d8cdR"),
    $4fc0fd4079c2e5a9$var$load("hyCrt"),
    $4fc0fd4079c2e5a9$var$load("jqoep"),
    $4fc0fd4079c2e5a9$var$load("44XW6"),
    $4fc0fd4079c2e5a9$var$load("VXbA1"),
    $4fc0fd4079c2e5a9$var$load("dxcsb"),
    $4fc0fd4079c2e5a9$var$load("gQrOI"),
    $4fc0fd4079c2e5a9$var$load("2xoIF"),
    $4fc0fd4079c2e5a9$var$load("gA528"),
    $4fc0fd4079c2e5a9$var$load("i8sPk"),
    $4fc0fd4079c2e5a9$var$load("5PKbS"),
    $4fc0fd4079c2e5a9$var$load("6wr18"),
    $4fc0fd4079c2e5a9$var$load("2MV9n"),
    $4fc0fd4079c2e5a9$var$load("dlm6q"),
    $4fc0fd4079c2e5a9$var$load("d3PpR"),
    $4fc0fd4079c2e5a9$var$load("ffEVr"),
    $4fc0fd4079c2e5a9$var$load("7EorR"),
    $4fc0fd4079c2e5a9$var$load("ea3NB"),
    $4fc0fd4079c2e5a9$var$load("koqDJ"),
    $4fc0fd4079c2e5a9$var$load("bmOOW"),
    $4fc0fd4079c2e5a9$var$load("dDiWc"),
    $4fc0fd4079c2e5a9$var$load("hhss7"),
    $4fc0fd4079c2e5a9$var$load("dUTj8"),
    $4fc0fd4079c2e5a9$var$load("5MpJT")
]).then(()=>parcelRequire('7cCRg'));

});

parcelRegister("jmwBy", function(module, exports) {

let $e1895d02f2cb23a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e1895d02f2cb23a0$var$load("i8sPk"),
    $e1895d02f2cb23a0$var$load("1ElkK"),
    $e1895d02f2cb23a0$var$load("bAgF6"),
    $e1895d02f2cb23a0$var$load("211bN"),
    $e1895d02f2cb23a0$var$load("03fWQ")
]).then(()=>parcelRequire('ePNbS'));

});

parcelRegister("lBpK0", function(module, exports) {

let $fba1055177301179$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fba1055177301179$var$load("6wr18"),
    $fba1055177301179$var$load("lRwjQ"),
    $fba1055177301179$var$load("6XCf4"),
    $fba1055177301179$var$load("ffEVr"),
    $fba1055177301179$var$load("gWjIZ"),
    $fba1055177301179$var$load("1yVM6"),
    $fba1055177301179$var$load("iO7VA")
]).then(()=>parcelRequire('4CchY'));

});

parcelRegister("cov6Y", function(module, exports) {

let $905fdc04d0bc106a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $905fdc04d0bc106a$var$load("3cI3U").then(()=>parcelRequire('5CzWQ'));

});

parcelRegister("4A7kr", function(module, exports) {

let $3560358a98e1d1e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3560358a98e1d1e0$var$load("LWh5V"),
    $3560358a98e1d1e0$var$load("eRlPy"),
    $3560358a98e1d1e0$var$load("a8R25"),
    $3560358a98e1d1e0$var$load("lnKog"),
    $3560358a98e1d1e0$var$load("7EorR"),
    $3560358a98e1d1e0$var$load("5n2uM")
]).then(()=>parcelRequire('bexnX'));

});

parcelRegister("lR1Cm", function(module, exports) {

let $fe8fcd7298f5c91b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe8fcd7298f5c91b$var$load("lHNSl").then(()=>parcelRequire('8fbPW'));

});

parcelRegister("hlyKe", function(module, exports) {

let $ca0f59653dc0e0f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca0f59653dc0e0f2$var$load("vlZ5n").then(()=>parcelRequire('i5MLu'));

});

parcelRegister("4AgSW", function(module, exports) {

let $35679f3ca0102d46$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35679f3ca0102d46$var$load("ejYwx").then(()=>parcelRequire('2X92e'));

});

parcelRegister("im0Dk", function(module, exports) {

let $d5cac5d2f54b1d1a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5cac5d2f54b1d1a$var$load("6nNce").then(()=>parcelRequire('iPlli'));

});

parcelRegister("CCF2O", function(module, exports) {

let $074189fecca542b3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $074189fecca542b3$var$load("gI35P").then(()=>parcelRequire('grc8F'));

});

parcelRegister("eYhV2", function(module, exports) {

let $ae6491a247a08493$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ae6491a247a08493$var$load("hMGc2").then(()=>parcelRequire('fOnOH'));

});

parcelRegister("i9cjF", function(module, exports) {

let $d3629f023844a601$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d3629f023844a601$var$load("l0dd5"),
    $d3629f023844a601$var$load("dbQ5m"),
    $d3629f023844a601$var$load("4fYzp"),
    $d3629f023844a601$var$load("bm0oR"),
    $d3629f023844a601$var$load("1GCFv"),
    $d3629f023844a601$var$load("3eyRH"),
    $d3629f023844a601$var$load("h4Nf7"),
    $d3629f023844a601$var$load("3Whaz"),
    $d3629f023844a601$var$load("15jTz"),
    $d3629f023844a601$var$load("48F3z"),
    $d3629f023844a601$var$load("fuOfV"),
    $d3629f023844a601$var$load("jL1Ke"),
    $d3629f023844a601$var$load("5MQ0D"),
    $d3629f023844a601$var$load("cIoRg"),
    $d3629f023844a601$var$load("g7vSH"),
    $d3629f023844a601$var$load("ea3NB"),
    $d3629f023844a601$var$load("6wr18"),
    $d3629f023844a601$var$load("ffEVr"),
    $d3629f023844a601$var$load("59hV4"),
    $d3629f023844a601$var$load("hhss7"),
    $d3629f023844a601$var$load("excC5"),
    $d3629f023844a601$var$load("fwbNS"),
    $d3629f023844a601$var$load("d0ZRF"),
    $d3629f023844a601$var$load("k507P"),
    $d3629f023844a601$var$load("9TOep"),
    $d3629f023844a601$var$load("bncmK"),
    $d3629f023844a601$var$load("7EorR"),
    $d3629f023844a601$var$load("hA2SB"),
    $d3629f023844a601$var$load("8Dgzr")
]).then(()=>parcelRequire('bhsbE'));

});

parcelRegister("fi2Nx", function(module, exports) {

let $b21ab510773f0e7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b21ab510773f0e7f$var$load("eT0Md").then(()=>parcelRequire('y0ZZq'));

});

parcelRegister("6Crlg", function(module, exports) {

let $4d1b803699758c78$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4d1b803699758c78$var$load("1PNUT").then(()=>parcelRequire('8qhuK'));

});

parcelRegister("gYtMe", function(module, exports) {

let $c5b9590ab1806dbf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c5b9590ab1806dbf$var$load("h2HOa").then(()=>parcelRequire('3C4B7'));

});

parcelRegister("WDJHu", function(module, exports) {

let $0b043da80fd3d1e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b043da80fd3d1e5$var$load("hsAS2").then(()=>parcelRequire('6PsK0'));

});

parcelRegister("dG89m", function(module, exports) {

let $9f55850a53f42589$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9f55850a53f42589$var$load("at3xi"),
    $9f55850a53f42589$var$load("diMTQ"),
    $9f55850a53f42589$var$load("iN26T"),
    $9f55850a53f42589$var$load("kBatH"),
    $9f55850a53f42589$var$load("2NgQt")
]).then(()=>parcelRequire('cPinp'));

});

parcelRegister("1FUYn", function(module, exports) {

let $1385d06506603dd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1385d06506603dd2$var$load("2xc83"),
    $1385d06506603dd2$var$load("jE0Mz"),
    $1385d06506603dd2$var$load("6wr18"),
    $1385d06506603dd2$var$load("7ZdE9"),
    $1385d06506603dd2$var$load("9cgaG"),
    $1385d06506603dd2$var$load("6XCf4"),
    $1385d06506603dd2$var$load("59JAK"),
    $1385d06506603dd2$var$load("bajKf"),
    $1385d06506603dd2$var$load("awOLN"),
    $1385d06506603dd2$var$load("4XkVJ"),
    $1385d06506603dd2$var$load("2j57H"),
    $1385d06506603dd2$var$load("lPKve"),
    $1385d06506603dd2$var$load("efUj2"),
    $1385d06506603dd2$var$load("eYxdW"),
    $1385d06506603dd2$var$load("4C4vr"),
    $1385d06506603dd2$var$load("gWjIZ"),
    $1385d06506603dd2$var$load("1yVM6"),
    $1385d06506603dd2$var$load("ffEVr"),
    $1385d06506603dd2$var$load("faxwR")
]).then(()=>parcelRequire('eHKVU'));

});

parcelRegister("gOLqE", function(module, exports) {

let $c3e61b36863e085c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c3e61b36863e085c$var$load("cEJvh"),
    $c3e61b36863e085c$var$load("aOUZr"),
    $c3e61b36863e085c$var$load("6wr18"),
    $c3e61b36863e085c$var$load("iLqgZ"),
    $c3e61b36863e085c$var$load("kwgtb"),
    $c3e61b36863e085c$var$load("i84Fm"),
    $c3e61b36863e085c$var$load("49rXL"),
    $c3e61b36863e085c$var$load("4RHRd"),
    $c3e61b36863e085c$var$load("FJgmQ"),
    $c3e61b36863e085c$var$load("6XCf4"),
    $c3e61b36863e085c$var$load("kmE76"),
    $c3e61b36863e085c$var$load("46phv"),
    $c3e61b36863e085c$var$load("diMTQ"),
    $c3e61b36863e085c$var$load("30iG7"),
    $c3e61b36863e085c$var$load("gWjIZ"),
    $c3e61b36863e085c$var$load("1yVM6"),
    $c3e61b36863e085c$var$load("kBatH"),
    $c3e61b36863e085c$var$load("ffEVr"),
    $c3e61b36863e085c$var$load("gYbv6")
]).then(()=>parcelRequire('9qsRH'));

});

parcelRegister("3VOtu", function(module, exports) {

let $2dcdd92ed453e280$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2dcdd92ed453e280$var$load("83Dnz").then(()=>parcelRequire('1e8Au'));

});

parcelRegister("41kWH", function(module, exports) {

let $2ed780d424535167$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2ed780d424535167$var$load("efUj2"),
    $2ed780d424535167$var$load("6wr18"),
    $2ed780d424535167$var$load("at3xi"),
    $2ed780d424535167$var$load("c831e"),
    $2ed780d424535167$var$load("llcQo"),
    $2ed780d424535167$var$load("5B60W"),
    $2ed780d424535167$var$load("ffEVr"),
    $2ed780d424535167$var$load("eQfDG")
]).then(()=>parcelRequire('9TVBV'));

});

parcelRegister("abZBt", function(module, exports) {

let $76bab79ee38aa9bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $76bab79ee38aa9bf$var$load("6wr18"),
    $76bab79ee38aa9bf$var$load("at3xi"),
    $76bab79ee38aa9bf$var$load("c831e"),
    $76bab79ee38aa9bf$var$load("llcQo"),
    $76bab79ee38aa9bf$var$load("ffEVr"),
    $76bab79ee38aa9bf$var$load("5B60W")
]).then(()=>parcelRequire('kAGh9'));

});

parcelRegister("iJydk", function(module, exports) {
const $ead9af4400b74845$export$f7109619a5e9e0d6 = 'bulkSpacePermissionsScreen';
module.exports["ANALYTICS_SOURCE"] = $ead9af4400b74845$export$f7109619a5e9e0d6;

});

parcelRegister("7siXU", function(module, exports) {
/* AdminSecurityPageWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $1VhsF = parcelRequire("1VhsF");


var $a9aSv = parcelRequire("a9aSv");


var $lfoFx = parcelRequire("lfoFx");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $1BYn9 = parcelRequire("1BYn9");


var $lt6Lx = parcelRequire("lt6Lx");


var $jmjWc = parcelRequire("jmjWc");


var $4VuiN = parcelRequire("4VuiN");


var $dV8WM = parcelRequire("dV8WM");

const $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "40%",
        height: "var(--ds-space-300, 24px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "100%",
        height: "var(--ds-space-200, 16px)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "80%",
        height: "var(--ds-space-200, 16px)"
    })));

const $d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminGlobalV2Loadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "qLEMU",
    name: "ChangeEditionSectionMessageAdminGlobalV2Loadable",
    loader: async ()=>(await (parcelRequire("ihVIW"))).ChangeEditionSectionMessageAdminGlobalV2,
    loading: $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder
});

const $d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminSpaceV2Loadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5GUNJ",
    name: "ChangeEditionSectionMessageAdminSpaceV2Loadable",
    loader: async ()=>(await (parcelRequire("d49my"))).ChangeEditionSectionMessageAdminSpaceV2,
    loading: $d1833dcdda5c7ac3$var$UpsellBannerPlaceholder
});
const $d1833dcdda5c7ac3$var$styles = {
    spinnerContainer: "_4FKVYEyFLW _3iDTPbQ4SZ _37wbyuDIqT",
    headerContainer: "_3iDTPbQ4SZ _37wbyuI7V3 _0rIjykNHnM",
    bannerContainer: "_0rIjykS40j"
};
const $d1833dcdda5c7ac3$export$2491da3a335cfdb = ({ title: title, documentTitle: documentTitle, bannerVariant: bannerVariant = 'global', titleAction: titleAction, fullWidth: fullWidth, children: children })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
    if (isAdminCheckLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d1833dcdda5c7ac3$var$styles.spinnerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "large"
    }));
    if (!isProductAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dV8WM.RestrictedPage), null);
    const banner = isFreeEdition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d1833dcdda5c7ac3$var$styles.bannerContainer
    }, bannerVariant === 'space' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminSpaceV2Loadable, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d1833dcdda5c7ac3$var$ChangeEditionSectionMessageAdminGlobalV2Loadable, null)) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4VuiN.AdminPageLayout), {
        banner: banner,
        fullWidth: fullWidth
    }, documentTitle !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        titlePrefix: documentTitle
    }), title !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d1833dcdda5c7ac3$var$styles.headerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h1",
        size: "large"
    }, title), titleAction), children);
};
module.exports["AdminSecurityPageWrapper"] = $d1833dcdda5c7ac3$export$2491da3a335cfdb;

});

parcelRegister("1BYn9", function(module, exports) {

var $3TDto = parcelRequire("3TDto");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $fWkVZ = parcelRequire("fWkVZ");


var $1JEqL = parcelRequire("1JEqL");


var $jMyy4 = parcelRequire("jMyy4");

const $141bd073c52fec74$export$44f5b9746e66da9 = ()=>{
    const { data: data, error: error, loading: isAdminCheckLoading } = (0, $jMyy4.useQueryInterop)((0, $3TDto.default), {
        __callerPackage__: "current-user"
    });
    if (error) {
        if (!(0, $1uFM6.isUnauthorizedError)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(data);
    const isProductOrSiteAdmin = (0, $1JEqL.getIsProductOrSiteAdminFromQuery)(data);
    return {
        isProductAdmin: isProductAdmin,
        isProductOrSiteAdmin: isProductOrSiteAdmin,
        isAdminCheckLoading: isAdminCheckLoading
    };
};
module.exports["useIsProductAdmin"] = $141bd073c52fec74$export$44f5b9746e66da9;

});

parcelRegister("3TDto", function(module, exports) {
/**
 * @generated SignedSource<<5ad29dfea09a4ca6925d754e625f4e3a>>
 * @relayHash d40e79986defbb74ee71a42460f4e593
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622
const $7c2c3a08c3ad61f2$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        },
        {
            "kind": "ScalarField",
            "name": "isSiteAdmin"
        },
        {
            "kind": "ScalarField",
            "name": "hasUserAccessAdminRole"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d40e79986defbb74ee71a42460f4e593",
            "id": "fe516d70b362da33d2c9dc8e98f7d27b5868b10eb9ecfdd545bfad6f07fa6622",
            "metadata": {},
            "name": "useIsProductAdminUseIsProductAdminQuery",
            "operationKind": "query",
            "text": "query useIsProductAdminUseIsProductAdminQuery{user:confluence_atlassianUser(current:true){id,confluence{operations{operation,targetType}}},isSiteAdmin,hasUserAccessAdminRole}"
        }
    };
}();
$7c2c3a08c3ad61f2$var$node.hash = "179058bf05f0f539ac360b7a899d6923";
var $7c2c3a08c3ad61f2$export$2e2bcd8739ae039 = $7c2c3a08c3ad61f2$var$node;
module.exports["default"] = $7c2c3a08c3ad61f2$export$2e2bcd8739ae039;

});

parcelRegister("fWkVZ", function(module, exports) {
const $b7fc105cb96f63fd$export$7ed4faccc7e85b7f = (queryData)=>Boolean(queryData?.user?.confluence?.operations?.some((o)=>o?.operation === 'administer' && o?.targetType === 'application'));
module.exports["getIsProductAdminFromQuery"] = $b7fc105cb96f63fd$export$7ed4faccc7e85b7f;

});

parcelRegister("1JEqL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $eJhXX = parcelRequire("eJhXX");


var $icMDs = parcelRequire("icMDs");

function $e18808c613ab8370$export$138f02318593ab4(queryData) {
    const userPrivilege = (0, $eJhXX.getUserPrivilegeFromQuery)(queryData);
    return userPrivilege === (0, $icMDs.UserPrivilege).PRODUCT_ADMIN || userPrivilege === (0, $icMDs.UserPrivilege).SITE_ADMIN;
}
module.exports["getIsProductOrSiteAdminFromQuery"] = $e18808c613ab8370$export$138f02318593ab4;

});

parcelRegister("eJhXX", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $fWkVZ = parcelRequire("fWkVZ");


var $w033M = parcelRequire("w033M");


var $icMDs = parcelRequire("icMDs");

function $a7000458c02582d2$export$d036114e4ad5c4c3(queryData) {
    const isSiteAdmin = (0, $w033M.getIsSiteAdminFromQuery)(queryData);
    const isProductAdmin = (0, $fWkVZ.getIsProductAdminFromQuery)(queryData);
    return typeof queryData === 'undefined' ? undefined : isSiteAdmin ? (0, $icMDs.UserPrivilege).SITE_ADMIN : isProductAdmin ? (0, $icMDs.UserPrivilege).PRODUCT_ADMIN : (0, $icMDs.UserPrivilege).NON_ADMIN;
}
module.exports["getUserPrivilegeFromQuery"] = $a7000458c02582d2$export$d036114e4ad5c4c3;

});

parcelRegister("w033M", function(module, exports) {
const $ea2c8f52a33264f1$export$4782acb2cb5b7c11 = (queryData)=>Boolean(queryData?.isSiteAdmin);
module.exports["getIsSiteAdminFromQuery"] = $ea2c8f52a33264f1$export$4782acb2cb5b7c11;

});

parcelRegister("icMDs", function(module, exports) {
var $296e2d91f769f195$export$fa8745fb6d256802 = /*#__PURE__*/ function(UserPrivilege) {
    UserPrivilege["NON_ADMIN"] = "nonAdmin";
    UserPrivilege["PRODUCT_ADMIN"] = "productAdmin";
    UserPrivilege["SITE_ADMIN"] = "siteAdmin";
    return UserPrivilege;
}({});
module.exports["UserPrivilege"] = $296e2d91f769f195$export$fa8745fb6d256802;

});

parcelRegister("4VuiN", function(module, exports) {
/* AdminPageLayout.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

/**
 * Canonical layout for an admin page in Confluence. Every admin-shell
 * page renders inside a centred, max-1024px column with consistent padding.
 */ const $0e52f7509d59c259$var$styles = {
    outer: "_39xV02N91d _1EqgXlN91d _3iDTPbQ4SZ _37wbyuDIqT _4bt5LAnQyn _2WAcuGnQyn",
    inner: "_46hvQmp0Oa _0xmtkoS40j _39xV02N91d _4ouGXIyQC8 _1EqgXljClk _3iDTPbQ4SZ _0aFT5vbt8w"
};
// Matches Mission Control's ContentContainer for consistency.
const $0e52f7509d59c259$var$innerInlineStyle = {
    paddingInlineStart: '112px',
    // Forced px sizing to match Mission Control's ContentContainer padding
    paddingInlineEnd: '112px',
    containerType: 'inline-size',
    containerName: 'AdminPage',
    boxSizing: 'content-box'
};
const $0e52f7509d59c259$var$fullWidthInnerInlineStyle = {
    ...$0e52f7509d59c259$var$innerInlineStyle,
    paddingInlineStart: "var(--ds-space-400, 32px)",
    paddingInlineEnd: "var(--ds-space-400, 32px)",
    paddingBlockStart: "var(--ds-space-400, 32px)",
    maxWidth: 'none'
};
const $0e52f7509d59c259$export$a2627d382ba9038 = ({ children: children, banner: banner, fullWidth: fullWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0e52f7509d59c259$var$styles.outer,
        as: "main"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0e52f7509d59c259$var$styles.inner,
        style: fullWidth ? $0e52f7509d59c259$var$fullWidthInnerInlineStyle : $0e52f7509d59c259$var$innerInlineStyle,
        testId: "admin-page-layout-inner"
    }, banner, children));
module.exports["AdminPageLayout"] = $0e52f7509d59c259$export$a2627d382ba9038;

});

parcelRegister("dV8WM", function(module, exports) {
/* RestrictedPage.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");

var $00f9acf06d9a785a$exports = {};
$00f9acf06d9a785a$exports = new URL("RestrictedContentIcon.39ea6b58.svg", import.meta.url).toString();


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c29d0256b2906de1$var$RestrictedPageContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedPageContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_39xV02do8e _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _0jFU0VuViK",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$CenteredContent = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2fwxA5DIqT",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedMessageTitle = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XghbELmNS _1kk5Tkf7mX",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$var$RestrictedContentImage = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _39xV02b1xp",
            __cmplp.className
        ])
    });
});
const $c29d0256b2906de1$export$4242cfff65d64b16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$RestrictedPageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$RestrictedPageContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$CenteredContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$RestrictedContentImage, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($00f9acf06d9a785a$exports)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c29d0256b2906de1$var$RestrictedMessageTitle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "site-permissions.restricted.page.view.title",
        defaultMessage: "This is a restricted page"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "site-permissions.restricted.page.manual.request.access.from.author",
        defaultMessage: "If you think you should have access, try asking the person who sent you here for help."
    }))));
module.exports["RestrictedPage"] = $c29d0256b2906de1$export$4242cfff65d64b16;

});

parcelRegister("ihVIW", function(module, exports) {

let $d50697483b110818$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d50697483b110818$var$load("6XCf4"),
    $d50697483b110818$var$load("gWjIZ"),
    $d50697483b110818$var$load("1yVM6"),
    $d50697483b110818$var$load("eUAdQ")
]).then(()=>parcelRequire('rN8w9'));

});

parcelRegister("d49my", function(module, exports) {

let $9832e95027fa6944$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9832e95027fa6944$var$load("6XCf4"),
    $9832e95027fa6944$var$load("gWjIZ"),
    $9832e95027fa6944$var$load("1yVM6"),
    $9832e95027fa6944$var$load("gc0jz")
]).then(()=>parcelRequire('cJgGV'));

});

parcelRegister("4ikjJ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");

const $f465330fb8737fdd$var$packageName = "platform-pkg";
const $f465330fb8737fdd$var$packageVersion = "0.0.0-use.local";
const $f465330fb8737fdd$var$noop = (0, $dpsRj.default);
const $f465330fb8737fdd$var$labelPaddingStyles = null;
const $f465330fb8737fdd$var$labelStyles = null;
const $f465330fb8737fdd$var$labelDisabledStyles = null;
const $f465330fb8737fdd$var$radioBaseStyles = null;
const $f465330fb8737fdd$var$radioInteractiveStyles = null;
const $f465330fb8737fdd$var$radioDisabledStyles = null;
const $f465330fb8737fdd$var$radioDisabledCheckedStyles = null;
const $f465330fb8737fdd$var$radioInvalidStyles = null; // Preserve the input's zoom correction and focus outline while cross-fading states.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $f465330fb8737fdd$var$crossFadeStyles = null;
const $f465330fb8737fdd$var$InnerRadio = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Radio(props, ref) {
    const $ = (0, $bDgLe.c)(46);
    let analyticsContext;
    let ariaLabel;
    let ariaLabelledBy;
    let isRequired;
    let label;
    let labelId;
    let name;
    let rest;
    let t0;
    let t1;
    let t2;
    let t3;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ ariaLabel: ariaLabel, "aria-labelledby": ariaLabelledBy, isDisabled: t0, isRequired: isRequired, isInvalid: t1, isChecked: t2, label: label, labelId: labelId, name: name, onChange: t3, value: value, testId: testId, analyticsContext: analyticsContext, ...rest } = props);
        $[0] = props;
        $[1] = analyticsContext;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = isRequired;
        $[5] = label;
        $[6] = labelId;
        $[7] = name;
        $[8] = rest;
        $[9] = t0;
        $[10] = t1;
        $[11] = t2;
        $[12] = t3;
        $[13] = testId;
        $[14] = value;
    } else {
        analyticsContext = $[1];
        ariaLabel = $[2];
        ariaLabelledBy = $[3];
        isRequired = $[4];
        label = $[5];
        labelId = $[6];
        name = $[7];
        rest = $[8];
        t0 = $[9];
        t1 = $[10];
        t2 = $[11];
        t3 = $[12];
        testId = $[13];
        value = $[14];
    }
    const isDisabled = t0 === undefined ? false : t0;
    const isInvalid = t1 === undefined ? false : t1;
    const isChecked = t2 === undefined ? false : t2;
    const onChange = t3 === undefined ? $f465330fb8737fdd$var$noop : t3;
    let t4;
    if ($[15] !== analyticsContext || $[16] !== onChange) {
        t4 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "radio",
            packageName: $f465330fb8737fdd$var$packageName,
            packageVersion: $f465330fb8737fdd$var$packageVersion
        };
        $[15] = analyticsContext;
        $[16] = onChange;
        $[17] = t4;
    } else t4 = $[17];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const t5 = testId && `${testId}--radio-label`;
    const t6 = isDisabled ? "true" : undefined;
    const t7 = isDisabled && "_1UtDYzot27 _0wOv4Qsyl5";
    let t8;
    if ($[18] !== t7) {
        t8 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _1mT5xdRAKS _0hPCNLchRC _1UtDYzy7kJ",
            t7
        ]);
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    const t9 = labelId || ariaLabelledBy;
    const t10 = testId && `${testId}--radio-input`;
    const t11 = isInvalid ? "true" : undefined;
    let t12;
    if ($[20] !== isChecked || $[21] !== isDisabled || $[22] !== isInvalid) {
        t12 = (0, $hekY6.default)([
            "_2XghbEPgdg _30huDKUwEI _0bjKvDaaQb _2xIroY98eZ _497WNwYbGa _2zndICT6kp _23rrnHWkmS _3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _0KLXruG2s3 _2B7VO8YbGa _46tpOU7Cj1 _2rYKcAHKt7 _07ionz6BYM _1XF9ANdnbC _1VJPcaGquZ _1RrJLiBwqQ _2adT7gYbGa _2OWEWsdaW3 _2Gfj6iaaQb _1JM8vvueoN _2jfUf9yaFJ _47eTBtyaFJ _2WYcYGWVPG _0GBAIrogpp _43i6GSTJun",
            (0, $iDrrr.fg)("platform_design_system_selection_radial_fade") && "_23rrnHnc7r _1JM8vvnc7r _1QEw40YbGa _2tbAUcYbGa _3wrwGmYbGa",
            !isDisabled && "_1etv9ykLmD _2tFSPOkLmD _0ZLH27HZdu _2fqI0WXzJH _38a67R4Y4b _0rUt1uXzJH _0IDPPJ4Y4b _4dpqOVqWX3 _42HvB4HKt7 _2bmooNXLOx _3CIMOkXLOx _1SLx5PutHW _1hb6ILPSfI _3i4XoaHKt7 _0oAkhw6BYM",
            isDisabled && "_0wOv4Qsyl5 _46tpOUVrZW _2rYKcAhQC5 _07ionzoM2E",
            isDisabled && isChecked && "_1XF9ANHZdu",
            isInvalid && !isDisabled && "_2rYKcA7j8z _2tFSPO7j8z"
        ]);
        $[20] = isChecked;
        $[21] = isDisabled;
        $[22] = isInvalid;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== ariaLabel || $[25] !== isChecked || $[26] !== isDisabled || $[27] !== isRequired || $[28] !== name || $[29] !== onChangeAnalytics || $[30] !== ref || $[31] !== rest || $[32] !== t10 || $[33] !== t11 || $[34] !== t12 || $[35] !== t9 || $[36] !== value) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            ...rest,
            tabIndex: 0,
            "aria-label": ariaLabel,
            "aria-labelledby": t9,
            checked: isChecked,
            disabled: isDisabled,
            name: name,
            onChange: onChangeAnalytics,
            required: isRequired,
            type: "radio",
            value: value,
            "data-testid": t10,
            "data-invalid": t11,
            ref: ref,
            className: t12
        });
        $[24] = ariaLabel;
        $[25] = isChecked;
        $[26] = isDisabled;
        $[27] = isRequired;
        $[28] = name;
        $[29] = onChangeAnalytics;
        $[30] = ref;
        $[31] = rest;
        $[32] = t10;
        $[33] = t11;
        $[34] = t12;
        $[35] = t9;
        $[36] = value;
        $[37] = t13;
    } else t13 = $[37];
    let t14;
    if ($[38] !== label) {
        t14 = label ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                "_0xmtkoFQfX _46hvQmFQfX _03SyCP1Y8M _0LQT5E1Y8M"
            ]),
            children: label
        }) : null;
        $[38] = label;
        $[39] = t14;
    } else t14 = $[39];
    let t15;
    if ($[40] !== t13 || $[41] !== t14 || $[42] !== t5 || $[43] !== t6 || $[44] !== t8) {
        t15 = /*#__PURE__*/ (0, $8aG6j.jsxs)("label", {
            "data-testid": t5,
            "data-disabled": t6,
            className: t8,
            children: [
                t13,
                t14
            ]
        });
        $[40] = t13;
        $[41] = t14;
        $[42] = t5;
        $[43] = t6;
        $[44] = t8;
        $[45] = t15;
    } else t15 = $[45];
    return t15;
} : function Radio(props, ref) {
    const { ariaLabel: ariaLabel, 'aria-labelledby': ariaLabelledBy, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, labelId: labelId, name: name, onChange: onChange = $f465330fb8737fdd$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $f465330fb8737fdd$var$packageName,
        packageVersion: $f465330fb8737fdd$var$packageVersion
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _1mT5xdRAKS _0hPCNLchRC _1UtDYzy7kJ",
            isDisabled && "_1UtDYzot27 _0wOv4Qsyl5"
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                "aria-labelledby": labelId || ariaLabelledBy,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $hekY6.default)([
                    "_2XghbEPgdg _30huDKUwEI _0bjKvDaaQb _2xIroY98eZ _497WNwYbGa _2zndICT6kp _23rrnHWkmS _3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _1mT5xdRAKS _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _0KLXruG2s3 _2B7VO8YbGa _46tpOU7Cj1 _2rYKcAHKt7 _07ionz6BYM _1XF9ANdnbC _1VJPcaGquZ _1RrJLiBwqQ _2adT7gYbGa _2OWEWsdaW3 _2Gfj6iaaQb _1JM8vvueoN _2jfUf9yaFJ _47eTBtyaFJ _2WYcYGWVPG _0GBAIrogpp _43i6GSTJun",
                    (0, $iDrrr.fg)('platform_design_system_selection_radial_fade') && "_23rrnHnc7r _1JM8vvnc7r _1QEw40YbGa _2tbAUcYbGa _3wrwGmYbGa",
                    !isDisabled && "_1etv9ykLmD _2tFSPOkLmD _0ZLH27HZdu _2fqI0WXzJH _38a67R4Y4b _0rUt1uXzJH _0IDPPJ4Y4b _4dpqOVqWX3 _42HvB4HKt7 _2bmooNXLOx _3CIMOkXLOx _1SLx5PutHW _1hb6ILPSfI _3i4XoaHKt7 _0oAkhw6BYM",
                    isDisabled && "_0wOv4Qsyl5 _46tpOUVrZW _2rYKcAhQC5 _07ionzoM2E",
                    isDisabled && isChecked && "_1XF9ANHZdu",
                    isInvalid && !isDisabled && "_2rYKcA7j8z _2tFSPO7j8z"
                ])
            }),
            label ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    "_0xmtkoFQfX _46hvQmFQfX _03SyCP1Y8M _0LQT5E1Y8M"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $f465330fb8737fdd$var$Radio = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Radio(props, ref) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f465330fb8737fdd$var$InnerRadio, {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function Radio(props, ref) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)($f465330fb8737fdd$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $f465330fb8737fdd$export$2e2bcd8739ae039 = $f465330fb8737fdd$var$Radio;
module.exports["default"] = $f465330fb8737fdd$export$2e2bcd8739ae039;

});

parcelRegister("7akNQ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $a2foB = parcelRequire("a2foB");


var $FKQbh = parcelRequire("FKQbh");


var $iXRmn = parcelRequire("iXRmn");


var $lqtHz = parcelRequire("lqtHz");

const $08beb25a8c4ef160$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
const $08beb25a8c4ef160$export$a4270ab432ac8a58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function FlagsProvider(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, shouldRenderToParent: shouldRenderToParent } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [flags, setFlags] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (id)=>{
            setFlags((current)=>current.slice(0).filter((flag)=>flag.id !== id));
        };
        $[1] = t2;
    } else t2 = $[1];
    const removeFlag = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        };
        $[2] = t3;
    } else t3 = $[2];
    const api = t3;
    let t4;
    if ($[3] !== children) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
            value: api,
            children: children
        });
        $[3] = children;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] !== flags) {
        t5 = flags.map($08beb25a8c4ef160$var$_temp);
        $[5] = flags;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] !== shouldRenderToParent || $[8] !== t5) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
            onDismissed: removeFlag,
            shouldRenderToParent: shouldRenderToParent,
            children: t5
        });
        $[7] = shouldRenderToParent;
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
            children: [
                t4,
                t6
            ]
        });
        $[10] = t4;
        $[11] = t6;
        $[12] = t7;
    } else t7 = $[12];
    return t7;
} : function FlagsProvider({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $cozmU.useState)([]);
    const removeFlag = (0, $cozmU.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $cozmU.useMemo)(()=>({
            showFlag: function show(value) {
                const flag_0 = {
                    ...value,
                    id: value.id || $08beb25a8c4ef160$var$getUniqueId()
                };
                setFlags((current_0)=>{
                    const index = current_0.findIndex((value_0)=>value_0.id === flag_0.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag_0,
                        ...current_0
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current_0
                    ];
                    shallow[index] = flag_0;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag_0.id);
                };
            },
            hideFlag: removeFlag
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iXRmn.FlagContext).Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lqtHz.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag_1)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
                    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
                    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
                        ...restProps,
                        key: flag_1.id
                    });
                })
            })
        ]
    });
};
function $08beb25a8c4ef160$var$_temp(flag_1) {
    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag_1;
    const FlagType = isAutoDismiss ? (0, $a2foB.default) : (0, $FKQbh.default);
    return /*#__PURE__*/ (0, $cozmU.createElement)(FlagType, {
        ...restProps,
        key: flag_1.id
    });
}
module.exports["FlagsProvider"] = $08beb25a8c4ef160$export$a4270ab432ac8a58;

});

parcelRegister("iXRmn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $bbe556224ecd1c1b$export$2eb95677cf2465e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);
module.exports["FlagContext"] = $bbe556224ecd1c1b$export$2eb95677cf2465e1;

});

parcelRegister("6V36D", function(module, exports) {
$parcel$export(module.exports, "VerifiedTeamLozenge", () => (parcelRequire("hVSC8")).VerifiedTeamLozenge);

var $hVSC8 = parcelRequire("hVSC8");


});

parcelRegister("hVSC8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $d2UzA = parcelRequire("d2UzA");


var $lpNn5 = parcelRequire("lpNn5");

const $2e5b5aad519af945$var$i18n = (0, $kSwu1.defineMessages)({
    teamVerifiedLozengeTooltip: {
        id: "permissions-principals.team-verified-lozenge.tooltip",
        defaultMessage: "This team is verified because it is controlled by an organization admin."
    },
    groupVerifiedLozengeTooltip: {
        id: "permissions-principals.group-verified-lozenge.tooltip",
        defaultMessage: "This group is verified because it is controlled by an organization admin."
    }
});
const $2e5b5aad519af945$export$ba3ff7dd3e281a6b = ({ isTeam: isTeam = true, spacing: spacing = 'compact' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: isTeam ? formatMessage($2e5b5aad519af945$var$i18n.teamVerifiedLozengeTooltip) : formatMessage($2e5b5aad519af945$var$i18n.groupVerifiedLozengeTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d2UzA))), {
        label: "verified team",
        color: "var(--ds-icon-accent-blue, #357DE8)",
        size: "small",
        spacing: spacing
    }));
};
module.exports["VerifiedTeamLozenge"] = $2e5b5aad519af945$export$ba3ff7dd3e281a6b;

});

parcelRegister("6MSEP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $9387550ed869acb8$export$4242cfff65d64b16 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "M3-19",
    name: "RestrictedPage",
    loader: async ()=>(await (parcelRequire("fWWWM"))).RestrictedPage
});
module.exports["RestrictedPage"] = $9387550ed869acb8$export$4242cfff65d64b16;

});

parcelRegister("fWWWM", function(module, exports) {

let $b9c9ff6fa1dd4553$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9c9ff6fa1dd4553$var$load("6wr18"),
    $b9c9ff6fa1dd4553$var$load("1VIvy"),
    $b9c9ff6fa1dd4553$var$load("ffEVr"),
    $b9c9ff6fa1dd4553$var$load("d0ZRF"),
    $b9c9ff6fa1dd4553$var$load("k507P"),
    $b9c9ff6fa1dd4553$var$load("b6eef"),
    $b9c9ff6fa1dd4553$var$load("2OcM6"),
    $b9c9ff6fa1dd4553$var$load("hhss7"),
    $b9c9ff6fa1dd4553$var$load("7EorR"),
    $b9c9ff6fa1dd4553$var$load("kUiwW")
]).then(()=>parcelRequire('3kPYw'));

});

parcelRegister("4MnFz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $iXRmn = parcelRequire("iXRmn");

const $878d7a55fd1744f7$export$2879604e6aec4ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error("Unable to find FlagProviderContext");
    return api;
} : function useFlags() {
    const api = (0, $cozmU.useContext)((0, $iXRmn.FlagContext));
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
};
module.exports["useFlags"] = $878d7a55fd1744f7$export$2879604e6aec4ab;

});

parcelRegister("h4TJq", function(module, exports) {

let $c6ee0a8764ac8d79$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c6ee0a8764ac8d79$var$load("6wr18"),
    $c6ee0a8764ac8d79$var$load("251nM"),
    $c6ee0a8764ac8d79$var$load("ffEVr"),
    $c6ee0a8764ac8d79$var$load("coGVA"),
    $c6ee0a8764ac8d79$var$load("RI3SR"),
    $c6ee0a8764ac8d79$var$load("7uWW8")
]).then(()=>parcelRequire('1c1P5'));

});

parcelRegister("go5PI", function(module, exports) {
const $a85703dfa4960dc8$export$6efc679b5f68edbb = 'adminConfiguration';
const $a85703dfa4960dc8$export$29494bfe5045193 = 'https://support.atlassian.com/confluence-cloud/docs/insert-confluence-wiki-markup/';
const $a85703dfa4960dc8$export$d1b15eb7eed612ff = 'https://support.atlassian.com/confluence-cloud/docs/configure-time-and-date-formats/';
const $a85703dfa4960dc8$export$4facdf667af1c221 = 'https://confluence.atlassian.com/x/A41jL';
const $a85703dfa4960dc8$export$c6b232dd07adf3e8 = 'https://support.atlassian.com/confluence-cloud/docs/view-a-page/';
module.exports["ADMIN_CONFIGURATION_ANALYTICS_SOURCE"] = $a85703dfa4960dc8$export$6efc679b5f68edbb;
module.exports["WIKI_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$29494bfe5045193;
module.exports["DATE_TIME_FORMAT_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$d1b15eb7eed612ff;
module.exports["PRESENCE_LEARN_MORE_LINK"] = $a85703dfa4960dc8$export$c6b232dd07adf3e8;

});

parcelRegister("hoI9O", function(module, exports) {

let $caa6ee40622ccd92$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $caa6ee40622ccd92$var$load("coGVA"),
    $caa6ee40622ccd92$var$load("RI3SR"),
    $caa6ee40622ccd92$var$load("hMzlw")
]).then(()=>parcelRequire('lkTIR'));

});

parcelRegister("87xWZ", function(module, exports) {
const $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52 = 'adminDefaultSpaceLogoConfig';
const $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a = [
    '.gif',
    '.jpg',
    '.jpeg',
    '.png',
    '.svg',
    '.webp'
];
module.exports["ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE"] = $9a9bb38d8a0d9d21$export$dd8dbc63482d3d52;
module.exports["ALLOWED_LOGO_FILE_EXTENSIONS"] = $9a9bb38d8a0d9d21$export$a6c9f5ac24569a0a;

});

parcelRegister("iPL9h", function(module, exports) {

let $db6190250983dace$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $db6190250983dace$var$load("lh6fT").then(()=>parcelRequire('f9aTe'));

});

parcelRegister("9VF1g", function(module, exports) {
const $3395fdb7c7788386$export$f57d5d3f8ce40ac2 = 'adminHeaderAndFooterConfig';
const $3395fdb7c7788386$export$6dbb84b06e78ca9 = '/admin/header-and-footer';
module.exports["ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE"] = $3395fdb7c7788386$export$f57d5d3f8ce40ac2;
module.exports["ADMIN_MIGRATION_HEADER_AND_FOOTER_PATH_NAME"] = $3395fdb7c7788386$export$6dbb84b06e78ca9;

});

parcelRegister("b5gED", function(module, exports) {

let $811d148e019371f2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $811d148e019371f2$var$load("6wr18"),
    $811d148e019371f2$var$load("efUj2"),
    $811d148e019371f2$var$load("ffEVr"),
    $811d148e019371f2$var$load("8iU4E")
]).then(()=>parcelRequire('46IN4'));

});

parcelRegister("kzcPl", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");

const $a85fb93a41cf2970$export$e7cba70eb2004729 = 'adminTemplatesAndBlueprints';
const $a85fb93a41cf2970$export$59e8eaf2c1cf7d28 = '/admin/templates-and-blueprints';
const $a85fb93a41cf2970$export$8726b5b334ad0749 = [
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_TEMPLATES_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_PAGE_BLUEPRINTS_LOAD_EXPERIENCE),
    (0, $irVI7.ADMIN_TEMPLATES_AND_BLUEPRINTS_SYSTEM_TEMPLATES_LOAD_EXPERIENCE)
];
module.exports["ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE"] = $a85fb93a41cf2970$export$e7cba70eb2004729;
module.exports["PATH_NAME"] = $a85fb93a41cf2970$export$59e8eaf2c1cf7d28;
module.exports["ADMIN_TEMPLATES_AND_BLUEPRINTS_SUB_EXPERIENCES"] = $a85fb93a41cf2970$export$8726b5b334ad0749;

});

parcelRegister("97Mow", function(module, exports) {

let $6a4a4eaad8eef828$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a4a4eaad8eef828$var$load("dCPNW").then(()=>parcelRequire('bHNfF'));

});

parcelRegister("3Tdyk", function(module, exports) {
const $b18a48086d5c5e91$export$fa039ba6a22ab542 = 'adminNotifications';
module.exports["ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE"] = $b18a48086d5c5e91$export$fa039ba6a22ab542;

});

parcelRegister("kL15w", function(module, exports) {

let $f1c90a8601e68bb1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1c90a8601e68bb1$var$load("ibz38").then(()=>parcelRequire('cgobV'));

});

parcelRegister("1fUU3", function(module, exports) {
const $763ac6d5da789755$export$b6ddaabddf4de465 = 'adminCreateWithRovo';
module.exports["ADMIN_CREATE_WITH_ROVO_ANALYTICS_SOURCE"] = $763ac6d5da789755$export$b6ddaabddf4de465;

});

parcelRegister("51Gk2", function(module, exports) {

let $3a8de008b51a9618$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3a8de008b51a9618$var$load("aOUZr"),
    $3a8de008b51a9618$var$load("6wr18"),
    $3a8de008b51a9618$var$load("2C3m1"),
    $3a8de008b51a9618$var$load("1qfHs"),
    $3a8de008b51a9618$var$load("w3Gc8"),
    $3a8de008b51a9618$var$load("5GZhs"),
    $3a8de008b51a9618$var$load("dbmJd"),
    $3a8de008b51a9618$var$load("cT9w0"),
    $3a8de008b51a9618$var$load("30iG7"),
    $3a8de008b51a9618$var$load("7kZcw"),
    $3a8de008b51a9618$var$load("fGK34"),
    $3a8de008b51a9618$var$load("bYpO4"),
    $3a8de008b51a9618$var$load("2XQL8"),
    $3a8de008b51a9618$var$load("l1wWm"),
    $3a8de008b51a9618$var$load("efUj2"),
    $3a8de008b51a9618$var$load("4C4vr"),
    $3a8de008b51a9618$var$load("7EorR"),
    $3a8de008b51a9618$var$load("jx2zo"),
    $3a8de008b51a9618$var$load("ffEVr"),
    $3a8de008b51a9618$var$load("dcntv")
]).then(()=>parcelRequire('gLYG4'));

});

parcelRegister("8c610", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $3IBnw = parcelRequire("3IBnw");


var $eCryJ = parcelRequire("eCryJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $hvS6g = parcelRequire("hvS6g");


var $iunEP = parcelRequire("iunEP");

const $41d6b394ccc83907$var$renderNothing = ()=>null;
const $41d6b394ccc83907$var$EntitlementReader = ({ queryRef: queryRef, children: children, denied: denied, renderUnavailable: renderUnavailable, onRetry: onRetry })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iunEP.performanceInsightsAccessQuery), queryRef);
    const perfIsEntitled = data.entitlements?.performanceInsights?.isEntitled;
    const error = (0, $cozmU.useMemo)(()=>typeof perfIsEntitled === 'boolean' ? undefined : new Error('Performance Insights entitlement metadata is unavailable'), [
        perfIsEntitled
    ]);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, renderUnavailable(onRetry));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, perfIsEntitled === true ? children : denied);
};
const $41d6b394ccc83907$export$a83cebcd757167fd = ({ children: children, denied: denied = null, loading: loading = null, renderUnavailable: renderUnavailable = $41d6b394ccc83907$var$renderNothing, interactionName: interactionName })=>{
    const { queryRef: queryRef, error: error, isInitialLoading: isInitialLoading, retryVersion: retryVersion, retry: retry } = (0, $iunEP.usePerformanceInsightsAccess)();
    const renderError = (0, $cozmU.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderUnavailable(retry)), [
        renderUnavailable,
        retry
    ]);
    if (isInitialLoading || !queryRef && !error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, loading);
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, renderUnavailable(retry));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCryJ.GenericErrorBoundary), {
        key: retryVersion,
        attribution: (0, $3IBnw.Attribution).INHERIT,
        renderOnError: renderError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hvS6g.RelaySuspense), {
        interactionName: interactionName,
        fallback: loading
    }, queryRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($41d6b394ccc83907$var$EntitlementReader, {
        queryRef: queryRef,
        denied: denied,
        renderUnavailable: renderUnavailable,
        onRetry: retry
    }, children) : loading));
};
module.exports["PerformanceInsightsAccess"] = $41d6b394ccc83907$export$a83cebcd757167fd;

});

parcelRegister("iunEP", function(module, exports) {

var $dxfs9 = parcelRequire("dxfs9");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");

const $1a0314b57ec18d4b$export$e9d330575ba50a2d = (0, $dxfs9.default);
let $1a0314b57ec18d4b$var$controllers = new WeakMap();
const $1a0314b57ec18d4b$var$activeControllers = new Set();
const $1a0314b57ec18d4b$var$createController = (environment)=>{
    // Share request health and reference ownership; entitlement data stays in Relay.
    let snapshot = {
        queryRef: null,
        error: undefined,
        resultVersion: 0,
        retryVersion: 0
    };
    const listeners = new Set();
    let cancelRequest;
    let interval;
    let inFlight = false;
    let generation = 0;
    const publish = (patch)=>{
        snapshot = {
            ...snapshot,
            ...patch
        };
        listeners.forEach((listener)=>listener());
    };
    const fail = (error)=>publish({
            error: error,
            resultVersion: snapshot.resultVersion + 1
        });
    const refresh = ()=>{
        if (inFlight) return;
        inFlight = true;
        const requestGeneration = generation;
        let receivedResponse = false;
        const request = (0, $6SsN4.fetchQuery)(environment, $1a0314b57ec18d4b$export$e9d330575ba50a2d, {}, {
            fetchPolicy: 'network-only'
        }).subscribe({
            next: (data)=>{
                if (requestGeneration !== generation) return;
                receivedResponse = true;
                if (typeof data.entitlements?.performanceInsights?.isEntitled !== 'boolean') {
                    fail(new Error('Performance Insights entitlement metadata is unavailable'));
                    return;
                }
                const queryRef = snapshot.queryRef ?? (0, $6SsN4.loadQuery)(environment, $1a0314b57ec18d4b$export$e9d330575ba50a2d, {}, {
                    fetchPolicy: 'store-only'
                });
                publish({
                    queryRef: queryRef,
                    error: undefined,
                    resultVersion: snapshot.resultVersion + 1
                });
            },
            error: (error)=>{
                if (requestGeneration !== generation) return;
                inFlight = false;
                fail(error);
            },
            complete: ()=>{
                if (requestGeneration !== generation) return;
                inFlight = false;
                if (!receivedResponse) fail(new Error('Performance Insights entitlement lookup returned no result'));
            }
        });
        cancelRequest = ()=>request.unsubscribe();
    };
    const refreshWhenVisible = ()=>{
        if (window.document?.visibilityState === 'visible') refresh();
    };
    const stop = ()=>{
        generation += 1;
        cancelRequest?.();
        cancelRequest = undefined;
        inFlight = false;
        window.clearInterval(interval);
        window.removeEventListener('focus', refreshWhenVisible);
        window.document?.removeEventListener('visibilitychange', refreshWhenVisible);
        snapshot.queryRef?.dispose();
        snapshot = {
            ...snapshot,
            queryRef: null,
            error: undefined
        };
        $1a0314b57ec18d4b$var$activeControllers.delete(controller);
    };
    const controller = {
        getSnapshot: ()=>snapshot,
        subscribe: (listener)=>{
            const firstSubscriber = listeners.size === 0;
            listeners.add(listener);
            if (firstSubscriber) {
                $1a0314b57ec18d4b$var$activeControllers.add(controller);
                interval = window.setInterval(refreshWhenVisible, 60000);
                window.addEventListener('focus', refreshWhenVisible);
                window.document?.addEventListener('visibilitychange', refreshWhenVisible);
            }
            refresh();
            return ()=>{
                listeners.delete(listener);
                if (listeners.size === 0 && $1a0314b57ec18d4b$var$activeControllers.has(controller)) stop();
            };
        },
        retry: ()=>{
            publish({
                retryVersion: snapshot.retryVersion + 1
            });
            refresh();
        },
        dispose: ()=>{
            listeners.clear();
            stop();
        }
    };
    return controller;
};
const $1a0314b57ec18d4b$var$getController = (environment)=>{
    let controller = $1a0314b57ec18d4b$var$controllers.get(environment);
    if (!controller) {
        controller = $1a0314b57ec18d4b$var$createController(environment);
        $1a0314b57ec18d4b$var$controllers.set(environment, controller);
    }
    return controller;
};
const $1a0314b57ec18d4b$export$eecab12ae8ffe1d6 = ()=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const controller = (0, $cozmU.useMemo)(()=>$1a0314b57ec18d4b$var$getController(environment), [
        environment
    ]);
    // New route entry waits for a fresh result even when a mounted sidebar has verified access.
    const entryVersion = (0, $cozmU.useMemo)(()=>controller.getSnapshot().resultVersion, [
        controller
    ]);
    const snapshot = (0, $cozmU.useSyncExternalStore)(controller.subscribe, controller.getSnapshot, controller.getSnapshot);
    return {
        ...snapshot,
        isInitialLoading: snapshot.resultVersion <= entryVersion,
        retry: controller.retry
    };
};
const $1a0314b57ec18d4b$export$11e59ce37d4edb1 = ()=>{
    $1a0314b57ec18d4b$var$activeControllers.forEach((controller)=>controller.dispose());
    $1a0314b57ec18d4b$var$controllers = new WeakMap();
};
module.exports["performanceInsightsAccessQuery"] = $1a0314b57ec18d4b$export$e9d330575ba50a2d;
module.exports["usePerformanceInsightsAccess"] = $1a0314b57ec18d4b$export$eecab12ae8ffe1d6;

});

parcelRegister("dxfs9", function(module, exports) {
/**
 * @generated SignedSource<<ef943d0b0a08f2f66163d19d55e4ee01>>
 * @relayHash d936340f41c48ee7bf66a1c8df1804dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a11c5635f26e65e5bd11b333e2bcfd6e5c957e8b0ce4084e5fc2bde6de2fc04c
const $b6fa1aeeaf1c2e89$var$node = function() {
    var v0 = [
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluencePerformanceInsightsFeature",
                    "kind": "LinkedField",
                    "name": "performanceInsights",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "usePerformanceInsightsAccessQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "usePerformanceInsightsAccessQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "d936340f41c48ee7bf66a1c8df1804dd",
            "id": "a11c5635f26e65e5bd11b333e2bcfd6e5c957e8b0ce4084e5fc2bde6de2fc04c",
            "metadata": {},
            "name": "usePerformanceInsightsAccessQuery",
            "operationKind": "query",
            "text": "query usePerformanceInsightsAccessQuery{entitlements{performanceInsights{isEntitled}}}"
        }
    };
}();
$b6fa1aeeaf1c2e89$var$node.hash = "174143f795f0a9245850edfb8435443f";
var $b6fa1aeeaf1c2e89$export$2e2bcd8739ae039 = $b6fa1aeeaf1c2e89$var$node;
module.exports["default"] = $b6fa1aeeaf1c2e89$export$2e2bcd8739ae039;

});

parcelRegister("1QKcJ", function(module, exports) {

let $158e7d00f90ef8ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $158e7d00f90ef8ec$var$load("LWh5V"),
    $158e7d00f90ef8ec$var$load("krOJz")
]).then(()=>parcelRequire('lMhQj'));

});

parcelRegister("i6ccO", function(module, exports) {
const $5030b4f7b6082c77$export$40d649ebb84b67da = 'spaceReportsSiteSettings';
module.exports["ADMIN_SPACE_REPORT_SCREEN"] = $5030b4f7b6082c77$export$40d649ebb84b67da;

});

parcelRegister("k0EFK", function(module, exports) {

let $e9135b6962471e24$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e9135b6962471e24$var$load("lQHJf").then(()=>parcelRequire('2nzCJ'));

});

parcelRegister("jPtik", function(module, exports) {
const $877d602a9e3b74d4$export$3b900d9a0f807a35 = 'adminConfigureCodeMacro';
const $877d602a9e3b74d4$export$99fd23db6b16a233 = 'Confluence';
const $877d602a9e3b74d4$export$c73844cf6c80166 = 'Java';
module.exports["ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE"] = $877d602a9e3b74d4$export$3b900d9a0f807a35;
module.exports["DEFAULT_THEME_VALUE"] = $877d602a9e3b74d4$export$99fd23db6b16a233;
module.exports["DEFAULT_LANGUAGE_VALUE"] = $877d602a9e3b74d4$export$c73844cf6c80166;

});

parcelRegister("j7zVA", function(module, exports) {

let $deba8a4746fb57bc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $deba8a4746fb57bc$var$load("6wr18"),
    $deba8a4746fb57bc$var$load("lPKve"),
    $deba8a4746fb57bc$var$load("7EorR"),
    $deba8a4746fb57bc$var$load("ffEVr"),
    $deba8a4746fb57bc$var$load("BhLxx")
]).then(()=>parcelRequire('d4Lz2'));

});

parcelRegister("bDmqn", function(module, exports) {

let $8784bb3e0ae634fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8784bb3e0ae634fe$var$load("lMnCe").then(()=>parcelRequire('5XJaz'));

});

parcelRegister("5vGLM", function(module, exports) {
const $18527396bdb04510$export$5ab36823e88567de = 'securityConfiguration';
const $18527396bdb04510$export$40326e81f7c56c6a = 'https://support.atlassian.com/confluence-cloud/docs/hide-external-links-from-search-engines/';
const $18527396bdb04510$export$f7de0eba11e77fd5 = 'https://support.atlassian.com/confluence-cloud/docs/turn-on-privacy-mode-for-analytics-data/';
const $18527396bdb04510$export$8802c1db742ad689 = 2147483647;
module.exports["ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE"] = $18527396bdb04510$export$5ab36823e88567de;
module.exports["EXTERNAL_LINKS_LEARN_MORE_LINK"] = $18527396bdb04510$export$40326e81f7c56c6a;
module.exports["PRIVACY_IN_ANALYTICS_LINK"] = $18527396bdb04510$export$f7de0eba11e77fd5;
module.exports["MAX_SAFE_JAVA_INTEGER"] = $18527396bdb04510$export$8802c1db742ad689;

});

parcelRegister("c9UHw", function(module, exports) {

let $8da24ef350af0e46$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8da24ef350af0e46$var$load("TIXGP"),
    $8da24ef350af0e46$var$load("6wr18"),
    $8da24ef350af0e46$var$load("7Alab"),
    $8da24ef350af0e46$var$load("56Sxu"),
    $8da24ef350af0e46$var$load("eBHUu"),
    $8da24ef350af0e46$var$load("4fYzp"),
    $8da24ef350af0e46$var$load("jx2zo"),
    $8da24ef350af0e46$var$load("ffEVr"),
    $8da24ef350af0e46$var$load("lp1L9")
]).then(()=>parcelRequire('gmEnb'));

});

parcelRegister("bPzXG", function(module, exports) {

let $89d05a5dda95466d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $89d05a5dda95466d$var$load("TIXGP"),
    $89d05a5dda95466d$var$load("6wr18"),
    $89d05a5dda95466d$var$load("lnUVM"),
    $89d05a5dda95466d$var$load("56Sxu"),
    $89d05a5dda95466d$var$load("eBHUu"),
    $89d05a5dda95466d$var$load("ffEVr"),
    $89d05a5dda95466d$var$load("j98o0")
]).then(()=>parcelRequire('dlYPV'));

});

parcelRegister("eZ0aX", function(module, exports) {

let $ae86e617ef0a106b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ae86e617ef0a106b$var$load("6wr18"),
    $ae86e617ef0a106b$var$load("efUj2"),
    $ae86e617ef0a106b$var$load("ffEVr"),
    $ae86e617ef0a106b$var$load("kaFPr")
]).then(()=>parcelRequire('2C4l7'));

});

parcelRegister("dWfBt", function(module, exports) {
const $3252933457ee5bfd$export$1c3a7fb1674ebcd2 = 'adminApplicationNavigator';
const $3252933457ee5bfd$export$59e8eaf2c1cf7d28 = '/admin/application-navigator';
module.exports["ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE"] = $3252933457ee5bfd$export$1c3a7fb1674ebcd2;

});

parcelRegister("hEzsM", function(module, exports) {

let $cda1ae5a474210f5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $cda1ae5a474210f5$var$load("6wr18"),
    $cda1ae5a474210f5$var$load("efUj2"),
    $cda1ae5a474210f5$var$load("ffEVr"),
    $cda1ae5a474210f5$var$load("f4DD6")
]).then(()=>parcelRequire('6JHmj'));

});

parcelRegister("9JmJC", function(module, exports) {
const $3381874ada981275$export$4ad87fa408071f9e = 'adminMacroUsage';
module.exports["ADMIN_MACRO_USAGE_ANALYTICS_SOURCE"] = $3381874ada981275$export$4ad87fa408071f9e;

});

parcelRegister("9c23o", function(module, exports) {

let $6b16d3db77ecac34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6b16d3db77ecac34$var$load("6wr18"),
    $6b16d3db77ecac34$var$load("7ZdE9"),
    $6b16d3db77ecac34$var$load("efUj2"),
    $6b16d3db77ecac34$var$load("ffEVr"),
    $6b16d3db77ecac34$var$load("3YiRE")
]).then(()=>parcelRequire('iR5x9'));

});

parcelRegister("4l9JY", function(module, exports) {
// Server expects the "after" parameter as a string index
const $bd0500c03ad06aff$export$eb9c69e3a09b9217 = '-1';
const $bd0500c03ad06aff$export$5716e8bcb003888d = 20;
const $bd0500c03ad06aff$export$717a6bceadab3608 = 'trashed';
const $bd0500c03ad06aff$export$ee14340141c11674 = 5000;
const $bd0500c03ad06aff$export$43b26519b9b8a3e = 'adminTrashedSpaces';
module.exports["DEFAULT_START_INDEX"] = $bd0500c03ad06aff$export$eb9c69e3a09b9217;
module.exports["DEFAULT_PAGE_SIZE"] = $bd0500c03ad06aff$export$5716e8bcb003888d;
module.exports["SPACE_STATUS_TRASHED"] = $bd0500c03ad06aff$export$717a6bceadab3608;
module.exports["POLL_INTERVAL_MS"] = $bd0500c03ad06aff$export$ee14340141c11674;
module.exports["ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE"] = $bd0500c03ad06aff$export$43b26519b9b8a3e;

});

parcelRegister("6hRE4", function(module, exports) {

let $493df173bc9bfc7a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $493df173bc9bfc7a$var$load("c1IkM"),
    $493df173bc9bfc7a$var$load("7S2Sh"),
    $493df173bc9bfc7a$var$load("knHTK")
]).then(()=>parcelRequire('8CcG8'));

});

parcelRegister("5LuQ6", function(module, exports) {

let $4329439a5417f6ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4329439a5417f6ac$var$load("1jfrR").then(()=>parcelRequire('fz6lB'));

});

parcelRegister("kmD3E", function(module, exports) {

let $ed3428d47a4161e5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ed3428d47a4161e5$var$load("4fYzp"),
    $ed3428d47a4161e5$var$load("iOJdB")
]).then(()=>parcelRequire('452sv'));

});

parcelRegister("434W4", function(module, exports) {
// XMLs or CSVs should be in a zip file
const $b6c44f979bbed03e$export$417e5fe1d0de6e47 = [
    '.zip'
];
const $b6c44f979bbed03e$export$42f152cabc617ec2 = 1500;
const $b6c44f979bbed03e$export$5f9abcd3ce58c0ab = 'adminImportSpaces';
const $b6c44f979bbed03e$export$61387ee612136e90 = 300000;
const $b6c44f979bbed03e$export$9e3220b2979f5262 = 'https://marketplace.atlassian.com/apps/1219672/cloud-migration-assistant-for-confluence';
const $b6c44f979bbed03e$export$ebe1d3a4348867c4 = 'https://confluence.atlassian.com/doc/export-content-to-word-pdf-html-and-xml-139475.html#ExportContenttoWord,PDF,HTMLandXML-ExportmultiplepagestoHTML,XML,orPDF';
module.exports["ALLOWED_FILE_EXTENSIONS"] = $b6c44f979bbed03e$export$417e5fe1d0de6e47;
module.exports["IMPORT_STATUS_CHECK_POLL_INTERVAL_MS"] = $b6c44f979bbed03e$export$42f152cabc617ec2;
module.exports["ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE"] = $b6c44f979bbed03e$export$5f9abcd3ce58c0ab;
module.exports["MEDIA_AUTH_PROVIDER_FIVE_MIN_TIMEOUT"] = $b6c44f979bbed03e$export$61387ee612136e90;
module.exports["CLOUD_MIGRATION_ASSISTANT_LINK"] = $b6c44f979bbed03e$export$9e3220b2979f5262;
module.exports["EXPORT_HELP_LINK"] = $b6c44f979bbed03e$export$ebe1d3a4348867c4;

});

parcelRegister("77WEg", function(module, exports) {

let $5306ae37a566d5cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5306ae37a566d5cc$var$load("6wr18"),
    $5306ae37a566d5cc$var$load("efUj2"),
    $5306ae37a566d5cc$var$load("ffEVr"),
    $5306ae37a566d5cc$var$load("4Z5Uh")
]).then(()=>parcelRequire('f10rR'));

});

parcelRegister("2i0P8", function(module, exports) {
const $ffc87555304a609f$export$8b897d36b093ccf1 = 'adminJiraMacroRepair';
const $ffc87555304a609f$export$ee14340141c11674 = 1000;
const $ffc87555304a609f$export$765b83ed862a0ed = '/wiki/plugins/servlet/applinks/listApplicationLinks';
module.exports["ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE"] = $ffc87555304a609f$export$8b897d36b093ccf1;
module.exports["POLL_INTERVAL_MS"] = $ffc87555304a609f$export$ee14340141c11674;
module.exports["APP_LINKS_URL"] = $ffc87555304a609f$export$765b83ed862a0ed;

});

parcelRegister("aFVWt", function(module, exports) {

let $7c5aadcd663b79ed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c5aadcd663b79ed$var$load("6KDUv").then(()=>parcelRequire('iiqL3'));

});

parcelRegister("ft9Jc", function(module, exports) {
const $5b008143e5994a1d$export$5b9a48b5dd6a4ea2 = 'adminThemes';
module.exports["ADMIN_THEMES_ANALYTICS_SOURCE"] = $5b008143e5994a1d$export$5b9a48b5dd6a4ea2;

});

parcelRegister("kJ6M6", function(module, exports) {

let $f16d43f85f1a97d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f16d43f85f1a97d0$var$load("9TOep"),
    $f16d43f85f1a97d0$var$load("fKQ9j"),
    $f16d43f85f1a97d0$var$load("9BxhS")
]).then(()=>parcelRequire('5JXtG'));

});

parcelRegister("fmC2G", function(module, exports) {
const $2d4e85d5268f55f9$export$546ba186ec91e3c9 = 'adminPdfExport';
const $2d4e85d5268f55f9$export$dec669626e46bbfe = 'https://support.atlassian.com/confluence-cloud/docs/customize-exports-to-pdf/';
module.exports["ADMIN_PDF_EXPORT_ANALYTICS_SOURCE"] = $2d4e85d5268f55f9$export$546ba186ec91e3c9;
module.exports["STYLESHEET_SUPPORT_DOC_URL"] = $2d4e85d5268f55f9$export$dec669626e46bbfe;

});

parcelRegister("3EZ1I", function(module, exports) {

let $2aa47226ac7d961d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2aa47226ac7d961d$var$load("3JOx9"),
    $2aa47226ac7d961d$var$load("6mLKo")
]).then(()=>parcelRequire('jmxIE'));

});

parcelRegister("8Nhaa", function(module, exports) {
const $1ede882b6a23a4b1$export$fa5f102b28968fd8 = 'spaceManager';
module.exports["SPACE_MANAGER_ANALYTICS_SOURCE"] = $1ede882b6a23a4b1$export$fa5f102b28968fd8;

});

parcelRegister("g4AOq", function(module, exports) {

let $bb399332c02cc308$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $bb399332c02cc308$var$load("jx2zo"),
    $bb399332c02cc308$var$load("6wr18"),
    $bb399332c02cc308$var$load("irTwo"),
    $bb399332c02cc308$var$load("ffEVr"),
    $bb399332c02cc308$var$load("2YlyO")
]).then(()=>parcelRequire('753aK'));

});

parcelRegister("5JWNm", function(module, exports) {

let $42dec33a44044f0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $42dec33a44044f0a$var$load("6wr18"),
    $42dec33a44044f0a$var$load("3mFs6"),
    $42dec33a44044f0a$var$load("aD3B2"),
    $42dec33a44044f0a$var$load("181K9"),
    $42dec33a44044f0a$var$load("3yZPW"),
    $42dec33a44044f0a$var$load("at3xi"),
    $42dec33a44044f0a$var$load("cpYhM"),
    $42dec33a44044f0a$var$load("2fgvC"),
    $42dec33a44044f0a$var$load("dbQ5m"),
    $42dec33a44044f0a$var$load("4fYzp"),
    $42dec33a44044f0a$var$load("bm0oR"),
    $42dec33a44044f0a$var$load("c831e"),
    $42dec33a44044f0a$var$load("1GCFv"),
    $42dec33a44044f0a$var$load("6XCf4"),
    $42dec33a44044f0a$var$load("iOfkQ"),
    $42dec33a44044f0a$var$load("2NFUs"),
    $42dec33a44044f0a$var$load("efUj2"),
    $42dec33a44044f0a$var$load("llcQo"),
    $42dec33a44044f0a$var$load("gWjIZ"),
    $42dec33a44044f0a$var$load("1yVM6"),
    $42dec33a44044f0a$var$load("7EorR"),
    $42dec33a44044f0a$var$load("kBatH"),
    $42dec33a44044f0a$var$load("ffEVr"),
    $42dec33a44044f0a$var$load("6gpUD")
]).then(()=>parcelRequire('dTw2J'));

});

parcelRegister("d73E7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $61e340fdd81a37ab$export$eb67fd6afe5bdfc8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7rQv",
    name: "WhiteboardRouteComponentLoader",
    loader: ()=>(parcelRequire("gAett"))
});
module.exports["WhiteboardRouteComponentLoader"] = $61e340fdd81a37ab$export$eb67fd6afe5bdfc8;

});

parcelRegister("gAett", function(module, exports) {

let $c12b3c773b32e4b4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c12b3c773b32e4b4$var$load("gpUln"),
    $c12b3c773b32e4b4$var$load("7IvJj"),
    $c12b3c773b32e4b4$var$load("j7JUO"),
    $c12b3c773b32e4b4$var$load("eF92L"),
    $c12b3c773b32e4b4$var$load("jwMHX"),
    $c12b3c773b32e4b4$var$load("gaUhx"),
    $c12b3c773b32e4b4$var$load("h6rbF"),
    $c12b3c773b32e4b4$var$load("jD5ZU"),
    $c12b3c773b32e4b4$var$load("8Ytws"),
    $c12b3c773b32e4b4$var$load("hNOga"),
    $c12b3c773b32e4b4$var$load("5LPcj"),
    $c12b3c773b32e4b4$var$load("lxIZ8"),
    $c12b3c773b32e4b4$var$load("2F69B"),
    $c12b3c773b32e4b4$var$load("8Bic8"),
    $c12b3c773b32e4b4$var$load("4PCFY"),
    $c12b3c773b32e4b4$var$load("cLCaE"),
    $c12b3c773b32e4b4$var$load("KsShd"),
    $c12b3c773b32e4b4$var$load("d3PpR"),
    $c12b3c773b32e4b4$var$load("jZGfM"),
    $c12b3c773b32e4b4$var$load("53mVX"),
    $c12b3c773b32e4b4$var$load("iXo3l"),
    $c12b3c773b32e4b4$var$load("i8sPk"),
    $c12b3c773b32e4b4$var$load("ftNkH"),
    $c12b3c773b32e4b4$var$load("15jTz"),
    $c12b3c773b32e4b4$var$load("48F3z"),
    $c12b3c773b32e4b4$var$load("7SteV"),
    $c12b3c773b32e4b4$var$load("hyCrt"),
    $c12b3c773b32e4b4$var$load("jE0Mz"),
    $c12b3c773b32e4b4$var$load("1ElkK"),
    $c12b3c773b32e4b4$var$load("gWjIZ"),
    $c12b3c773b32e4b4$var$load("dxA9F"),
    $c12b3c773b32e4b4$var$load("bkMxV"),
    $c12b3c773b32e4b4$var$load("VXbA1"),
    $c12b3c773b32e4b4$var$load("cIoRg"),
    $c12b3c773b32e4b4$var$load("g7vSH"),
    $c12b3c773b32e4b4$var$load("ea3NB"),
    $c12b3c773b32e4b4$var$load("dxcsb"),
    $c12b3c773b32e4b4$var$load("a7sEM"),
    $c12b3c773b32e4b4$var$load("5PKbS"),
    $c12b3c773b32e4b4$var$load("bmOOW"),
    $c12b3c773b32e4b4$var$load("dDiWc"),
    $c12b3c773b32e4b4$var$load("i6pyw"),
    $c12b3c773b32e4b4$var$load("cGkFm"),
    $c12b3c773b32e4b4$var$load("l4j2l"),
    $c12b3c773b32e4b4$var$load("37v60"),
    $c12b3c773b32e4b4$var$load("6iTkp"),
    $c12b3c773b32e4b4$var$load("4Oj5y"),
    $c12b3c773b32e4b4$var$load("gTa3u"),
    $c12b3c773b32e4b4$var$load("d0ZRF"),
    $c12b3c773b32e4b4$var$load("k507P"),
    $c12b3c773b32e4b4$var$load("6wr18"),
    $c12b3c773b32e4b4$var$load("ffEVr"),
    $c12b3c773b32e4b4$var$load("9TOep"),
    $c12b3c773b32e4b4$var$load("bncmK"),
    $c12b3c773b32e4b4$var$load("5dkX4"),
    $c12b3c773b32e4b4$var$load("hhss7"),
    $c12b3c773b32e4b4$var$load("aAWLw"),
    $c12b3c773b32e4b4$var$load("7EorR"),
    $c12b3c773b32e4b4$var$load("jZkQK")
]).then(()=>parcelRequire('ib0d9'));

});

parcelRegister("dkLzn", function(module, exports) {

let $9b520af87b48cf03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9b520af87b48cf03$var$load("hNOga"),
    $9b520af87b48cf03$var$load("8MjiJ"),
    $9b520af87b48cf03$var$load("9V1vV"),
    $9b520af87b48cf03$var$load("4IivY"),
    $9b520af87b48cf03$var$load("2zUQc"),
    $9b520af87b48cf03$var$load("5p243"),
    $9b520af87b48cf03$var$load("6damH"),
    $9b520af87b48cf03$var$load("2F69B"),
    $9b520af87b48cf03$var$load("8Bic8"),
    $9b520af87b48cf03$var$load("4PCFY"),
    $9b520af87b48cf03$var$load("1VIvy"),
    $9b520af87b48cf03$var$load("d0ZRF"),
    $9b520af87b48cf03$var$load("k507P"),
    $9b520af87b48cf03$var$load("bncmK"),
    $9b520af87b48cf03$var$load("5dkX4"),
    $9b520af87b48cf03$var$load("bRqDI"),
    $9b520af87b48cf03$var$load("cLCaE"),
    $9b520af87b48cf03$var$load("KsShd"),
    $9b520af87b48cf03$var$load("4fYzp"),
    $9b520af87b48cf03$var$load("cGkFm"),
    $9b520af87b48cf03$var$load("l4j2l"),
    $9b520af87b48cf03$var$load("37v60"),
    $9b520af87b48cf03$var$load("6iTkp"),
    $9b520af87b48cf03$var$load("4Oj5y"),
    $9b520af87b48cf03$var$load("c831e"),
    $9b520af87b48cf03$var$load("lHX6l"),
    $9b520af87b48cf03$var$load("1GCFv"),
    $9b520af87b48cf03$var$load("d3PpR"),
    $9b520af87b48cf03$var$load("bAgF6"),
    $9b520af87b48cf03$var$load("hnpcA"),
    $9b520af87b48cf03$var$load("i8sPk"),
    $9b520af87b48cf03$var$load("Jyh1v"),
    $9b520af87b48cf03$var$load("w3Gc8"),
    $9b520af87b48cf03$var$load("jrVkD"),
    $9b520af87b48cf03$var$load("8Y23K"),
    $9b520af87b48cf03$var$load("efUj2"),
    $9b520af87b48cf03$var$load("jqoep"),
    $9b520af87b48cf03$var$load("1ElkK"),
    $9b520af87b48cf03$var$load("9TOep"),
    $9b520af87b48cf03$var$load("6wr18"),
    $9b520af87b48cf03$var$load("bmOOW"),
    $9b520af87b48cf03$var$load("dDiWc"),
    $9b520af87b48cf03$var$load("hhss7"),
    $9b520af87b48cf03$var$load("i6pyw"),
    $9b520af87b48cf03$var$load("i1I18"),
    $9b520af87b48cf03$var$load("TIXGP"),
    $9b520af87b48cf03$var$load("7EorR"),
    $9b520af87b48cf03$var$load("dxKHc"),
    $9b520af87b48cf03$var$load("i8lZ0"),
    $9b520af87b48cf03$var$load("iDrFi"),
    $9b520af87b48cf03$var$load("jxGqt"),
    $9b520af87b48cf03$var$load("ffEVr"),
    $9b520af87b48cf03$var$load("iOr1f")
]).then(()=>parcelRequire('58rkb'));

});

parcelRegister("f1vPv", function(module, exports) {

let $aeffa3b9429fe0cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aeffa3b9429fe0cb$var$load("x93hA"),
    $aeffa3b9429fe0cb$var$load("hNOga"),
    $aeffa3b9429fe0cb$var$load("9V1vV"),
    $aeffa3b9429fe0cb$var$load("6damH"),
    $aeffa3b9429fe0cb$var$load("2F69B"),
    $aeffa3b9429fe0cb$var$load("8Bic8"),
    $aeffa3b9429fe0cb$var$load("4PCFY"),
    $aeffa3b9429fe0cb$var$load("1VIvy"),
    $aeffa3b9429fe0cb$var$load("bncmK"),
    $aeffa3b9429fe0cb$var$load("5dkX4"),
    $aeffa3b9429fe0cb$var$load("bRqDI"),
    $aeffa3b9429fe0cb$var$load("cLCaE"),
    $aeffa3b9429fe0cb$var$load("KsShd"),
    $aeffa3b9429fe0cb$var$load("4fYzp"),
    $aeffa3b9429fe0cb$var$load("cGkFm"),
    $aeffa3b9429fe0cb$var$load("l4j2l"),
    $aeffa3b9429fe0cb$var$load("37v60"),
    $aeffa3b9429fe0cb$var$load("4Oj5y"),
    $aeffa3b9429fe0cb$var$load("c831e"),
    $aeffa3b9429fe0cb$var$load("1GCFv"),
    $aeffa3b9429fe0cb$var$load("d3PpR"),
    $aeffa3b9429fe0cb$var$load("bAgF6"),
    $aeffa3b9429fe0cb$var$load("hnpcA"),
    $aeffa3b9429fe0cb$var$load("i8sPk"),
    $aeffa3b9429fe0cb$var$load("Jyh1v"),
    $aeffa3b9429fe0cb$var$load("w3Gc8"),
    $aeffa3b9429fe0cb$var$load("hS8gF"),
    $aeffa3b9429fe0cb$var$load("g8A75"),
    $aeffa3b9429fe0cb$var$load("jmTCk"),
    $aeffa3b9429fe0cb$var$load("bmOOW"),
    $aeffa3b9429fe0cb$var$load("dDiWc"),
    $aeffa3b9429fe0cb$var$load("i6pyw"),
    $aeffa3b9429fe0cb$var$load("TIXGP"),
    $aeffa3b9429fe0cb$var$load("d0ZRF"),
    $aeffa3b9429fe0cb$var$load("k507P"),
    $aeffa3b9429fe0cb$var$load("6iTkp"),
    $aeffa3b9429fe0cb$var$load("6wr18"),
    $aeffa3b9429fe0cb$var$load("7EorR"),
    $aeffa3b9429fe0cb$var$load("9TOep"),
    $aeffa3b9429fe0cb$var$load("hhss7"),
    $aeffa3b9429fe0cb$var$load("gnocL"),
    $aeffa3b9429fe0cb$var$load("gQrOI"),
    $aeffa3b9429fe0cb$var$load("dxKHc"),
    $aeffa3b9429fe0cb$var$load("i8lZ0"),
    $aeffa3b9429fe0cb$var$load("iDrFi"),
    $aeffa3b9429fe0cb$var$load("ffEVr"),
    $aeffa3b9429fe0cb$var$load("kZzff")
]).then(()=>parcelRequire('2rALa'));

});

parcelRegister("7b5PG", function(module, exports) {

let $539e15b1d2d9b290$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $539e15b1d2d9b290$var$load("hyCrt"),
    $539e15b1d2d9b290$var$load("hNOga"),
    $539e15b1d2d9b290$var$load("7fJS0"),
    $539e15b1d2d9b290$var$load("9V1vV"),
    $539e15b1d2d9b290$var$load("6damH"),
    $539e15b1d2d9b290$var$load("lxIZ8"),
    $539e15b1d2d9b290$var$load("2F69B"),
    $539e15b1d2d9b290$var$load("8Bic8"),
    $539e15b1d2d9b290$var$load("4PCFY"),
    $539e15b1d2d9b290$var$load("1VIvy"),
    $539e15b1d2d9b290$var$load("d0ZRF"),
    $539e15b1d2d9b290$var$load("k507P"),
    $539e15b1d2d9b290$var$load("bncmK"),
    $539e15b1d2d9b290$var$load("7EorR"),
    $539e15b1d2d9b290$var$load("5dkX4"),
    $539e15b1d2d9b290$var$load("bRqDI"),
    $539e15b1d2d9b290$var$load("cLCaE"),
    $539e15b1d2d9b290$var$load("KsShd"),
    $539e15b1d2d9b290$var$load("4fYzp"),
    $539e15b1d2d9b290$var$load("cGkFm"),
    $539e15b1d2d9b290$var$load("l4j2l"),
    $539e15b1d2d9b290$var$load("37v60"),
    $539e15b1d2d9b290$var$load("6iTkp"),
    $539e15b1d2d9b290$var$load("4Oj5y"),
    $539e15b1d2d9b290$var$load("c831e"),
    $539e15b1d2d9b290$var$load("1GCFv"),
    $539e15b1d2d9b290$var$load("d3PpR"),
    $539e15b1d2d9b290$var$load("bAgF6"),
    $539e15b1d2d9b290$var$load("8LtYa"),
    $539e15b1d2d9b290$var$load("53mVX"),
    $539e15b1d2d9b290$var$load("iXo3l"),
    $539e15b1d2d9b290$var$load("fky9A"),
    $539e15b1d2d9b290$var$load("i8sPk"),
    $539e15b1d2d9b290$var$load("Jyh1v"),
    $539e15b1d2d9b290$var$load("1t4Ce"),
    $539e15b1d2d9b290$var$load("w3Gc8"),
    $539e15b1d2d9b290$var$load("1lfcO"),
    $539e15b1d2d9b290$var$load("4U6x6"),
    $539e15b1d2d9b290$var$load("4bu4H"),
    $539e15b1d2d9b290$var$load("jE0Mz"),
    $539e15b1d2d9b290$var$load("iEsP0"),
    $539e15b1d2d9b290$var$load("1AybA"),
    $539e15b1d2d9b290$var$load("9TOep"),
    $539e15b1d2d9b290$var$load("6wr18"),
    $539e15b1d2d9b290$var$load("bmOOW"),
    $539e15b1d2d9b290$var$load("dDiWc"),
    $539e15b1d2d9b290$var$load("hhss7"),
    $539e15b1d2d9b290$var$load("i6pyw"),
    $539e15b1d2d9b290$var$load("TIXGP"),
    $539e15b1d2d9b290$var$load("i8lZ0"),
    $539e15b1d2d9b290$var$load("ffEVr"),
    $539e15b1d2d9b290$var$load("bT0I9")
]).then(()=>parcelRequire('1hCZf'));

});

parcelRegister("bwC5h", function(module, exports) {

var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $4b4iP = parcelRequire("4b4iP");

const $864039964f3f4398$var$SpaceRestriction = ({ spaceKey: spaceKey, contentId: contentId, children: children })=>{
    if (!spaceKey) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        contentId: contentId
    }, children);
};
$864039964f3f4398$var$SpaceRestriction.propTypes = {
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).node.isRequired
};
var $864039964f3f4398$export$2e2bcd8739ae039 = $864039964f3f4398$var$SpaceRestriction;
module.exports["default"] = $864039964f3f4398$export$2e2bcd8739ae039;

});

parcelRegister("332hs", function(module, exports) {

let $23836bcb30de9893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23836bcb30de9893$var$load("hmUGS").then(()=>parcelRequire('1azj7'));

});

parcelRegister("iufgB", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $ef29e49aacc3ecbc$export$80e55c7cff6cb8a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "IPyzb",
    name: "CreateContentRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("4QhWH"))).CreateContentRouteComponentWrapper
});
module.exports["CreateContentRouteComponentLoader"] = $ef29e49aacc3ecbc$export$80e55c7cff6cb8a;

});

parcelRegister("4QhWH", function(module, exports) {

let $3869f06ad19b927d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3869f06ad19b927d$var$load("i7NGK"),
    $3869f06ad19b927d$var$load("8iu3F"),
    $3869f06ad19b927d$var$load("6iTkp"),
    $3869f06ad19b927d$var$load("6wr18"),
    $3869f06ad19b927d$var$load("gbDLp"),
    $3869f06ad19b927d$var$load("b6eef"),
    $3869f06ad19b927d$var$load("9TOep"),
    $3869f06ad19b927d$var$load("ffEVr"),
    $3869f06ad19b927d$var$load("excC5"),
    $3869f06ad19b927d$var$load("7IvJj"),
    $3869f06ad19b927d$var$load("j7JUO"),
    $3869f06ad19b927d$var$load("bmOOW"),
    $3869f06ad19b927d$var$load("dDiWc"),
    $3869f06ad19b927d$var$load("d0ZRF"),
    $3869f06ad19b927d$var$load("k507P"),
    $3869f06ad19b927d$var$load("fwbNS"),
    $3869f06ad19b927d$var$load("ckGjo"),
    $3869f06ad19b927d$var$load("5PKbS"),
    $3869f06ad19b927d$var$load("bncmK"),
    $3869f06ad19b927d$var$load("hhss7"),
    $3869f06ad19b927d$var$load("7EorR"),
    $3869f06ad19b927d$var$load("lrKPf")
]).then(()=>parcelRequire('79aVL'));

});

parcelRegister("6CEg5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $9eE57 = parcelRequire("9eE57");

class $dc6daeb5b2d3b455$export$616e8efc277d5c6 extends (0, $cozmU.Component) {
    componentDidMount() {
        const { markBeforeMount: markBeforeMount, subject: subject, subjectId: subjectId } = this.props;
        if (!markBeforeMount) (0, $9eE57.perfMarkStart)({
            subject: subject,
            subjectId: subjectId
        });
    }
    render() {
        return null;
    }
    constructor(props){
        super(props);
        if (props.markBeforeMount) {
            const { subject: subject, subjectId: subjectId } = this.props;
            (0, $9eE57.perfMarkStart)({
                subject: subject,
                subjectId: subjectId
            });
        }
    }
}
$dc6daeb5b2d3b455$export$616e8efc277d5c6.propTypes = {
    subject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    subjectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string,
    markBeforeMount: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).bool
};
$dc6daeb5b2d3b455$export$616e8efc277d5c6.defaultProps = {
    subjectId: '',
    markBeforeMount: false
};
module.exports["PerformanceStart"] = $dc6daeb5b2d3b455$export$616e8efc277d5c6;

});

parcelRegister("4Y6DR", function(module, exports) {

let $39e1eaf9f8edca46$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $39e1eaf9f8edca46$var$load("7k9oy"),
    $39e1eaf9f8edca46$var$load("6wr18"),
    $39e1eaf9f8edca46$var$load("ffEVr"),
    $39e1eaf9f8edca46$var$load("8VHGu")
]).then(()=>parcelRequire('7mbVv'));

});

parcelRegister("ko9Ek", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4cd8f2daf274114d$export$2312ebab360877df = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HinAE",
    // Name is used in next/packages/view-page/src/index.ts must match
    name: "ViewPageRouteComponentLoader",
    loader: async ()=>(await (parcelRequire("23C9t"))).ViewPageRouteComponent
});
module.exports["ViewPageRouteComponentLoader"] = $4cd8f2daf274114d$export$2312ebab360877df;

});

parcelRegister("23C9t", function(module, exports) {

let $17f974bf4af620a0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $17f974bf4af620a0$var$load("el1U6"),
    $17f974bf4af620a0$var$load("2yyll"),
    $17f974bf4af620a0$var$load("hUbK8"),
    $17f974bf4af620a0$var$load("kOHTK"),
    $17f974bf4af620a0$var$load("jZGfM"),
    $17f974bf4af620a0$var$load("8faB9"),
    $17f974bf4af620a0$var$load("fU0ae"),
    $17f974bf4af620a0$var$load("bqdgP"),
    $17f974bf4af620a0$var$load("3Whaz"),
    $17f974bf4af620a0$var$load("esBxc"),
    $17f974bf4af620a0$var$load("3pbEq"),
    $17f974bf4af620a0$var$load("9cVML"),
    $17f974bf4af620a0$var$load("15jTz"),
    $17f974bf4af620a0$var$load("48F3z"),
    $17f974bf4af620a0$var$load("7SteV"),
    $17f974bf4af620a0$var$load("eUsnQ"),
    $17f974bf4af620a0$var$load("9LJFK"),
    $17f974bf4af620a0$var$load("d66hN"),
    $17f974bf4af620a0$var$load("dxA9F"),
    $17f974bf4af620a0$var$load("bkMxV"),
    $17f974bf4af620a0$var$load("aRCaA"),
    $17f974bf4af620a0$var$load("h3Rq9"),
    $17f974bf4af620a0$var$load("cIoRg"),
    $17f974bf4af620a0$var$load("g7vSH"),
    $17f974bf4af620a0$var$load("iWnyc"),
    $17f974bf4af620a0$var$load("ea3NB"),
    $17f974bf4af620a0$var$load("6wr18"),
    $17f974bf4af620a0$var$load("ffEVr"),
    $17f974bf4af620a0$var$load("59hV4"),
    $17f974bf4af620a0$var$load("kJASg"),
    $17f974bf4af620a0$var$load("asCsc"),
    $17f974bf4af620a0$var$load("fYx6U"),
    $17f974bf4af620a0$var$load("botpL"),
    $17f974bf4af620a0$var$load("frgRG"),
    $17f974bf4af620a0$var$load("l4j2l"),
    $17f974bf4af620a0$var$load("37v60"),
    $17f974bf4af620a0$var$load("a7sEM"),
    $17f974bf4af620a0$var$load("koqDJ"),
    $17f974bf4af620a0$var$load("7IvJj"),
    $17f974bf4af620a0$var$load("j7JUO"),
    $17f974bf4af620a0$var$load("cGkFm"),
    $17f974bf4af620a0$var$load("eF92L"),
    $17f974bf4af620a0$var$load("jwMHX"),
    $17f974bf4af620a0$var$load("a8R25"),
    $17f974bf4af620a0$var$load("gaUhx"),
    $17f974bf4af620a0$var$load("5PKbS"),
    $17f974bf4af620a0$var$load("gFeoL"),
    $17f974bf4af620a0$var$load("9TOep"),
    $17f974bf4af620a0$var$load("bncmK"),
    $17f974bf4af620a0$var$load("8iu3F"),
    $17f974bf4af620a0$var$load("fWCBZ"),
    $17f974bf4af620a0$var$load("bmOOW"),
    $17f974bf4af620a0$var$load("dDiWc"),
    $17f974bf4af620a0$var$load("d0ZRF"),
    $17f974bf4af620a0$var$load("k507P"),
    $17f974bf4af620a0$var$load("fwbNS"),
    $17f974bf4af620a0$var$load("hR9G5"),
    $17f974bf4af620a0$var$load("aDgIB"),
    $17f974bf4af620a0$var$load("6iTkp"),
    $17f974bf4af620a0$var$load("gTa3u"),
    $17f974bf4af620a0$var$load("hhss7"),
    $17f974bf4af620a0$var$load("h6rbF"),
    $17f974bf4af620a0$var$load("jD5ZU"),
    $17f974bf4af620a0$var$load("aAWLw"),
    $17f974bf4af620a0$var$load("7EorR"),
    $17f974bf4af620a0$var$load("2dt2D")
]).then(()=>parcelRequire('bkGU6'));

});

parcelRegister("4D2qK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d5ef270b375fd8a7$export$9a7f1112e3576698 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Nmdfv",
    name: "ViewPageLiteLoader",
    loader: async ()=>(await (parcelRequire("9YSXG"))).ViewPageLite
});
module.exports["ViewPageLiteLoader"] = $d5ef270b375fd8a7$export$9a7f1112e3576698;

});

parcelRegister("9YSXG", function(module, exports) {

let $744459e314cf6109$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $744459e314cf6109$var$load("d3PpR"),
    $744459e314cf6109$var$load("i8sPk"),
    $744459e314cf6109$var$load("kfGHh"),
    $744459e314cf6109$var$load("lIiD7"),
    $744459e314cf6109$var$load("b3zRm"),
    $744459e314cf6109$var$load("gaUhx"),
    $744459e314cf6109$var$load("2xoIF"),
    $744459e314cf6109$var$load("ce05o"),
    $744459e314cf6109$var$load("3Wy8Y"),
    $744459e314cf6109$var$load("4B1vY"),
    $744459e314cf6109$var$load("hNOga"),
    $744459e314cf6109$var$load("k0wQ3"),
    $744459e314cf6109$var$load("8MjiJ"),
    $744459e314cf6109$var$load("cLCaE"),
    $744459e314cf6109$var$load("KsShd"),
    $744459e314cf6109$var$load("knUU4"),
    $744459e314cf6109$var$load("lHX6l"),
    $744459e314cf6109$var$load("3Whaz"),
    $744459e314cf6109$var$load("15jTz"),
    $744459e314cf6109$var$load("48F3z"),
    $744459e314cf6109$var$load("jqoep"),
    $744459e314cf6109$var$load("dxA9F"),
    $744459e314cf6109$var$load("bkMxV"),
    $744459e314cf6109$var$load("cIoRg"),
    $744459e314cf6109$var$load("g7vSH"),
    $744459e314cf6109$var$load("59hV4"),
    $744459e314cf6109$var$load("a7sEM"),
    $744459e314cf6109$var$load("1NyWL"),
    $744459e314cf6109$var$load("7IvJj"),
    $744459e314cf6109$var$load("j7JUO"),
    $744459e314cf6109$var$load("bmOOW"),
    $744459e314cf6109$var$load("dDiWc"),
    $744459e314cf6109$var$load("a8R25"),
    $744459e314cf6109$var$load("5PKbS"),
    $744459e314cf6109$var$load("htKpm"),
    $744459e314cf6109$var$load("bncmK"),
    $744459e314cf6109$var$load("5dkX4"),
    $744459e314cf6109$var$load("44XW6"),
    $744459e314cf6109$var$load("eF92L"),
    $744459e314cf6109$var$load("jwMHX"),
    $744459e314cf6109$var$load("d0ZRF"),
    $744459e314cf6109$var$load("k507P"),
    $744459e314cf6109$var$load("6iTkp"),
    $744459e314cf6109$var$load("6wr18"),
    $744459e314cf6109$var$load("16bOI"),
    $744459e314cf6109$var$load("2be0t"),
    $744459e314cf6109$var$load("7SteV"),
    $744459e314cf6109$var$load("jE0Mz"),
    $744459e314cf6109$var$load("1AybA"),
    $744459e314cf6109$var$load("ffEVr"),
    $744459e314cf6109$var$load("9TOep"),
    $744459e314cf6109$var$load("dxcsb"),
    $744459e314cf6109$var$load("cGkFm"),
    $744459e314cf6109$var$load("8iu3F"),
    $744459e314cf6109$var$load("hhss7"),
    $744459e314cf6109$var$load("7EorR"),
    $744459e314cf6109$var$load("1gUNx"),
    $744459e314cf6109$var$load("h9zFU")
]).then(()=>parcelRequire('kcroh'));

});

parcelRegister("1ptJE", function(module, exports) {

let $106f3113c21e55b9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $106f3113c21e55b9$var$load("e00ow"),
    $106f3113c21e55b9$var$load("7Xau5")
]).then(()=>parcelRequire('aUago'));

});

parcelRegister("8pBIa", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("6Evf5")).default);

var $6Evf5 = parcelRequire("6Evf5");


});

parcelRegister("6Evf5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $ep3mz = parcelRequire("ep3mz");


var $hl1Kw = parcelRequire("hl1Kw");


var $3GP6F = parcelRequire("3GP6F");


var $aeLio = parcelRequire("aeLio");


var $jMyy4 = parcelRequire("jMyy4");

parcelRequire("hAOSI");
var $9LzHv = parcelRequire("9LzHv");


var $fJp8a = parcelRequire("fJp8a");

const $4d7eb68e35a8590f$var$dayInMilliseconds = 86400000; // hours*minutes*seconds*milliseconds
const $4d7eb68e35a8590f$var$NO_DATE_DEFINED = -1;
const $4d7eb68e35a8590f$var$ARCHIVED = 'archived';
const $4d7eb68e35a8590f$export$10ab27af88aafb56 = (pastDateStr, currentDate = new Date())=>{
    const pastDate = new Date(pastDateStr);
    // days since creation
    return Math.round((currentDate.getTime() - pastDate.getTime()) / $4d7eb68e35a8590f$var$dayInMilliseconds);
};
const $4d7eb68e35a8590f$var$_getDaysSinceCreated = (node)=>{
    const createdDateStr = node?.history?.createdDate;
    return createdDateStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(createdDateStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$var$_getDaysSinceUpdated = (node)=>{
    const lastUpdatedStr = node?.history?.lastUpdated?.when;
    return lastUpdatedStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(lastUpdatedStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$export$f8668f0d8d89d19c = (currentDate = new Date())=>{
    const hours = currentDate.getHours();
    return hours >= 15 && hours <= 23;
};
const $4d7eb68e35a8590f$export$35de754c0b3b58bd = ()=>{
    if (document && document.visibilityState) return document.visibilityState;
    return 'unset';
};
const $4d7eb68e35a8590f$var$SendTrackViewPageEvent = ({ pageType: pageType, source: source = 'viewPageScreen' })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const featureCodes = (0, $3GP6F.useFeatureCodesInURL)();
    const commentLink = (0, $aeLio.useGetCommentLinkType)();
    const lastFiredKeyRef = (0, $cozmU.useRef)(null);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)((0, $fJp8a.default), {
        variables: {
            contentId: contentId
        },
        __callerPackage__: "confluence-frontend-server"
    });
    const space = data?.content?.nodes?.[0]?.space;
    const fabricEditorSupported = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorSupported;
    const fabricEditorEligibility = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorEligibility;
    if (error || loading || !space) return null;
    const dedupeKey = `${source}:${contentId}`;
    if (lastFiredKeyRef.current === dedupeKey) return null;
    lastFiredKeyRef.current = dedupeKey;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9LzHv.default), {
        action: "viewed",
        actionSubject: "page",
        source: source,
        containerType: "space",
        containerId: space.id,
        objectType: "page",
        objectId: contentId,
        attributes: {
            pageType: pageType,
            daysSinceCreated: $4d7eb68e35a8590f$var$_getDaysSinceCreated(data.content.nodes[0]),
            daysSinceModified: $4d7eb68e35a8590f$var$_getDaysSinceUpdated(data.content.nodes[0]),
            searchReferrer: searchSessionId,
            ...additionalAnalytics,
            isArchivedPage: data.content.nodes[0].status === $4d7eb68e35a8590f$var$ARCHIVED,
            viewedScreenAfter3PM: $4d7eb68e35a8590f$export$f8668f0d8d89d19c(),
            pageVisibility: $4d7eb68e35a8590f$export$35de754c0b3b58bd(),
            fabricEditorEligibility: fabricEditorEligibility,
            fabricEditorSupported: fabricEditorSupported,
            ...featureCodes && featureCodes.from ? {
                from: featureCodes.from
            } : {},
            ...commentLink && {
                commentLink: commentLink
            }
        }
    });
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.propTypes = {
    pageType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'page',
        'blogpost'
    ]),
    source: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'viewPageScreen',
        'mobileWebView'
    ])
};
var $4d7eb68e35a8590f$export$2e2bcd8739ae039 = $4d7eb68e35a8590f$var$SendTrackViewPageEvent;
module.exports["default"] = $4d7eb68e35a8590f$export$2e2bcd8739ae039;

});

parcelRegister("3GP6F", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $KDAt0 = parcelRequire("KDAt0");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");




const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $KDAt0.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $cozmU.useState)(queryParamsFeatureCodes);
    (0, $cozmU.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};
module.exports["useFeatureCodesInURL"] = $9bc3195b956679d5$export$eddc138581adbc11;

});

parcelRegister("lpPVE", function(module, exports) {

var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    FeatureCode["SEND_TO_DESKTOP_EMAIL"] = "SNDDSKEML";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("aeLio", function(module, exports) {

var $dPJCf = parcelRequire("dPJCf");

const $741319b101f491d9$var$useFocusedCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('focusedCommentId');
const $741319b101f491d9$var$useReplyToCommentIdQueryParam = (0, $dPJCf.createSingleQueryParamHook)('replyToComment');
const $741319b101f491d9$export$f4b5305c973a36dc = ()=>{
    const focusedCommentId = $741319b101f491d9$var$useFocusedCommentIdQueryParam();
    const replyToCommentId = $741319b101f491d9$var$useReplyToCommentIdQueryParam();
    if (focusedCommentId) return 'isFocusedComment';
    else if (replyToCommentId) return 'isReplyToComment';
    return undefined;
};
module.exports["useGetCommentLinkType"] = $741319b101f491d9$export$f4b5305c973a36dc;

});

parcelRegister("hAOSI", function(module, exports) {
$parcel$export(module.exports, "default", () => (parcelRequire("9LzHv")).default);

var $9LzHv = parcelRequire("9LzHv");


});

parcelRegister("9LzHv", function(module, exports) {
$parcel$export(module.exports, "default", () => $71c43243f3d11279$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $6b4nE = parcelRequire("6b4nE");


var $lzgC6 = parcelRequire("lzgC6");

const $71c43243f3d11279$var$sendTrackEvent = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const analyticsData = {
        action: props.action,
        actionSubject: props.actionSubject,
        attributes: props.attributes,
        containerId: props.containerId,
        containerType: props.containerType,
        objectId: props.objectId,
        objectType: props.objectType,
        source: props.source
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: analyticsData
    });
    analyticsEvent.fire();
};
function $71c43243f3d11279$var$SendTrackEventComponent(props) {
    const { action: action, actionSubject: actionSubject, attributes: attributes = {}, containerId: containerId, containerType: containerType, objectId: objectId, objectType: objectType, source: source } = props;
    (0, $cozmU.useEffect)(()=>{
        $71c43243f3d11279$var$sendTrackEvent({
            ...props,
            attributes: attributes
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        action,
        actionSubject,
        attributes,
        containerId,
        containerType,
        objectId,
        objectType,
        source
    ]);
    return null;
}
$71c43243f3d11279$var$SendTrackEventComponent.propTypes = {
    action: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    actionSubject: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    containerId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    containerType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    objectId: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    objectType: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).func.isRequired
};
var $71c43243f3d11279$export$2e2bcd8739ae039 = (0, $lzgC6.default)()($71c43243f3d11279$var$SendTrackEventComponent);

});

parcelRegister("fJp8a", function(module, exports) {
/**
 * @generated SignedSource<<a06a8a013af654ab7c26aeab2b65cf59>>
 * @relayHash 32571b6f378434b18a3f7ffd275bf6d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b9659f35a7eec8367641693f458f5b2681600dc7f00ef95a9271421a2154a8c
const $2483e127b5e3d8b1$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "lastUpdated",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "when"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorEligibility"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SendTrackViewPageEventQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SendTrackViewPageEventQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "32571b6f378434b18a3f7ffd275bf6d4",
            "id": "7b9659f35a7eec8367641693f458f5b2681600dc7f00ef95a9271421a2154a8c",
            "metadata": {},
            "name": "SendTrackViewPageEventQuery",
            "operationKind": "query",
            "text": "query SendTrackViewPageEventQuery($contentId:ID){content(id:$contentId){nodes{id,history{createdDate,lastUpdated{when}},metadata{frontend{fabricEditorSupported,fabricEditorEligibility}},space{id},status}}}"
        }
    };
}();
$2483e127b5e3d8b1$var$node.hash = "19847917790449aae265767493366eb2";
var $2483e127b5e3d8b1$export$2e2bcd8739ae039 = $2483e127b5e3d8b1$var$node;
module.exports["default"] = $2483e127b5e3d8b1$export$2e2bcd8739ae039;

});

parcelRegister("agrhv", function(module, exports) {

let $77908f87a29aef82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $77908f87a29aef82$var$load("eOkWq"),
    $77908f87a29aef82$var$load("7EorR"),
    $77908f87a29aef82$var$load("iCuQy")
]).then(()=>parcelRequire('4Shbp'));

});

parcelRegister("i0WZi", function(module, exports) {

let $d1d5fbce5f1704fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d1d5fbce5f1704fa$var$load("ckx79").then(()=>parcelRequire('eGJ8h'));

});

parcelRegister("dY5Vp", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $41efc32f19d16eca$export$aeb070a9ba92094e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "UtR1u",
    name: "LazyQuestions",
    loader: async ()=>(await (parcelRequire("6iFKe"))).Questions
});
module.exports["LazyQuestions"] = $41efc32f19d16eca$export$aeb070a9ba92094e;

});

parcelRegister("6iFKe", function(module, exports) {

let $4964ce1e62f4b545$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4964ce1e62f4b545$var$load("jE0Mz"),
    $4964ce1e62f4b545$var$load("6wr18"),
    $4964ce1e62f4b545$var$load("7NQuo"),
    $4964ce1e62f4b545$var$load("1GCFv"),
    $4964ce1e62f4b545$var$load("59JAK"),
    $4964ce1e62f4b545$var$load("bajKf"),
    $4964ce1e62f4b545$var$load("awOLN"),
    $4964ce1e62f4b545$var$load("4XkVJ"),
    $4964ce1e62f4b545$var$load("2j57H"),
    $4964ce1e62f4b545$var$load("lPKve"),
    $4964ce1e62f4b545$var$load("9w623"),
    $4964ce1e62f4b545$var$load("coGVA"),
    $4964ce1e62f4b545$var$load("RI3SR"),
    $4964ce1e62f4b545$var$load("hhss7"),
    $4964ce1e62f4b545$var$load("7EorR"),
    $4964ce1e62f4b545$var$load("ffEVr"),
    $4964ce1e62f4b545$var$load("5xtwP")
]).then(()=>parcelRequire('gCU3O'));

});

parcelRegister("6tN3O", function(module, exports) {

let $4b7b81e8724185a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4b7b81e8724185a1$var$load("cEJvh"),
    $4b7b81e8724185a1$var$load("6wr18"),
    $4b7b81e8724185a1$var$load("gYJBG"),
    $4b7b81e8724185a1$var$load("6XDEC"),
    $4b7b81e8724185a1$var$load("3T3jd"),
    $4b7b81e8724185a1$var$load("6wKNt"),
    $4b7b81e8724185a1$var$load("4RHRd"),
    $4b7b81e8724185a1$var$load("lHX6l"),
    $4b7b81e8724185a1$var$load("7Y0AX"),
    $4b7b81e8724185a1$var$load("w3Gc8"),
    $4b7b81e8724185a1$var$load("kmE76"),
    $4b7b81e8724185a1$var$load("30iG7"),
    $4b7b81e8724185a1$var$load("7kZcw"),
    $4b7b81e8724185a1$var$load("fGK34"),
    $4b7b81e8724185a1$var$load("bYpO4"),
    $4b7b81e8724185a1$var$load("2XQL8"),
    $4b7b81e8724185a1$var$load("efUj2"),
    $4b7b81e8724185a1$var$load("jqoep"),
    $4b7b81e8724185a1$var$load("4C4vr"),
    $4b7b81e8724185a1$var$load("7EorR"),
    $4b7b81e8724185a1$var$load("ffEVr"),
    $4b7b81e8724185a1$var$load("hLE8r")
]).then(()=>parcelRequire('9Gz8W'));

});

parcelRegister("6wUI6", function(module, exports) {

let $4c11b8ba1598498a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4c11b8ba1598498a$var$load("6wr18"),
    $4c11b8ba1598498a$var$load("6wKNt"),
    $4c11b8ba1598498a$var$load("iOfkQ"),
    $4c11b8ba1598498a$var$load("2NFUs"),
    $4c11b8ba1598498a$var$load("ffEVr"),
    $4c11b8ba1598498a$var$load("2sCab")
]).then(()=>parcelRequire('3GuAz'));

});

parcelRegister("69TVd", function(module, exports) {

let $47bef63a07e3b26b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $47bef63a07e3b26b$var$load("8MjiJ"),
    $47bef63a07e3b26b$var$load("1dHf3"),
    $47bef63a07e3b26b$var$load("6wr18"),
    $47bef63a07e3b26b$var$load("gYJBG"),
    $47bef63a07e3b26b$var$load("6XDEC"),
    $47bef63a07e3b26b$var$load("6wKNt"),
    $47bef63a07e3b26b$var$load("7fveJ"),
    $47bef63a07e3b26b$var$load("cEJvh"),
    $47bef63a07e3b26b$var$load("4RHRd"),
    $47bef63a07e3b26b$var$load("2YNuR"),
    $47bef63a07e3b26b$var$load("4fYzp"),
    $47bef63a07e3b26b$var$load("94qRZ"),
    $47bef63a07e3b26b$var$load("lHX6l"),
    $47bef63a07e3b26b$var$load("7Y0AX"),
    $47bef63a07e3b26b$var$load("kOAbA"),
    $47bef63a07e3b26b$var$load("kmE76"),
    $47bef63a07e3b26b$var$load("5GZhs"),
    $47bef63a07e3b26b$var$load("dbmJd"),
    $47bef63a07e3b26b$var$load("cT9w0"),
    $47bef63a07e3b26b$var$load("30iG7"),
    $47bef63a07e3b26b$var$load("7kZcw"),
    $47bef63a07e3b26b$var$load("fGK34"),
    $47bef63a07e3b26b$var$load("bYpO4"),
    $47bef63a07e3b26b$var$load("2XQL8"),
    $47bef63a07e3b26b$var$load("efUj2"),
    $47bef63a07e3b26b$var$load("jqoep"),
    $47bef63a07e3b26b$var$load("4C4vr"),
    $47bef63a07e3b26b$var$load("7EorR"),
    $47bef63a07e3b26b$var$load("ffEVr"),
    $47bef63a07e3b26b$var$load("6sFkE")
]).then(()=>parcelRequire('1T0Cv'));

});

parcelRegister("bN2xS", function(module, exports) {

let $89563ec0da13b8f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $89563ec0da13b8f1$var$load("6wr18"),
    $89563ec0da13b8f1$var$load("6XDEC"),
    $89563ec0da13b8f1$var$load("3T3jd"),
    $89563ec0da13b8f1$var$load("6wKNt"),
    $89563ec0da13b8f1$var$load("cEJvh"),
    $89563ec0da13b8f1$var$load("4RHRd"),
    $89563ec0da13b8f1$var$load("94qRZ"),
    $89563ec0da13b8f1$var$load("lHX6l"),
    $89563ec0da13b8f1$var$load("7Y0AX"),
    $89563ec0da13b8f1$var$load("w3Gc8"),
    $89563ec0da13b8f1$var$load("kOAbA"),
    $89563ec0da13b8f1$var$load("kmE76"),
    $89563ec0da13b8f1$var$load("30iG7"),
    $89563ec0da13b8f1$var$load("7kZcw"),
    $89563ec0da13b8f1$var$load("fGK34"),
    $89563ec0da13b8f1$var$load("bYpO4"),
    $89563ec0da13b8f1$var$load("2XQL8"),
    $89563ec0da13b8f1$var$load("efUj2"),
    $89563ec0da13b8f1$var$load("jqoep"),
    $89563ec0da13b8f1$var$load("4C4vr"),
    $89563ec0da13b8f1$var$load("7EorR"),
    $89563ec0da13b8f1$var$load("ffEVr"),
    $89563ec0da13b8f1$var$load("bYnOS")
]).then(()=>parcelRequire('3EzW0'));

});

parcelRegister("jK9jP", function(module, exports) {

let $e5f98ab562f00263$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e5f98ab562f00263$var$load("ioTV7").then(()=>parcelRequire('9wYcO'));

});

parcelRegister("lHEvX", function(module, exports) {

let $fccd0a6f72aaa1ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fccd0a6f72aaa1ba$var$load("2QH3d").then(()=>parcelRequire('flSU2'));

});

parcelRegister("kR2MJ", function(module, exports) {

let $f2eaeae8eecea107$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f2eaeae8eecea107$var$load("1qAcJ").then(()=>parcelRequire('66lXR'));

});

parcelRegister("kfsaj", function(module, exports) {

let $ebdb0e68013cc5fc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ebdb0e68013cc5fc$var$load("gkVge"),
    $ebdb0e68013cc5fc$var$load("6wr18"),
    $ebdb0e68013cc5fc$var$load("kVHWO"),
    $ebdb0e68013cc5fc$var$load("LWh5V"),
    $ebdb0e68013cc5fc$var$load("4fYzp"),
    $ebdb0e68013cc5fc$var$load("c831e"),
    $ebdb0e68013cc5fc$var$load("1GCFv"),
    $ebdb0e68013cc5fc$var$load("6XCf4"),
    $ebdb0e68013cc5fc$var$load("l3CW5"),
    $ebdb0e68013cc5fc$var$load("251nM"),
    $ebdb0e68013cc5fc$var$load("gWjIZ"),
    $ebdb0e68013cc5fc$var$load("ffEVr"),
    $ebdb0e68013cc5fc$var$load("1yVM6"),
    $ebdb0e68013cc5fc$var$load("5mKg8")
]).then(()=>parcelRequire('fyrrY'));

});

parcelRegister("l5PUQ", function(module, exports) {
const $794cae3221ca3442$export$ccc7dd6c48bfb65d = 'adminUserAccess';
const $794cae3221ca3442$export$728435b9c77444c = 500;
var $794cae3221ca3442$export$37d3310174fb25af = /*#__PURE__*/ function(PermissionResultType) {
    PermissionResultType["ALLOWED"] = "ALLOWED";
    PermissionResultType["DENIED"] = "DENIED";
    PermissionResultType["INHERITED"] = "INHERITED";
    PermissionResultType["IRRELEVANT"] = "IRRELEVANT";
    return PermissionResultType;
}({});
module.exports["ADMIN_USER_ACCESS_ANALYTICS_SOURCE"] = $794cae3221ca3442$export$ccc7dd6c48bfb65d;
module.exports["SPACE_PERMS_REPORT_POLL_INTERVAL_MS"] = $794cae3221ca3442$export$728435b9c77444c;
module.exports["PermissionResultType"] = $794cae3221ca3442$export$37d3310174fb25af;

});

parcelRegister("11Lo8", function(module, exports) {

let $0bfaa4bf31545584$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bfaa4bf31545584$var$load("kbzD1").then(()=>parcelRequire('aFOyu'));

});

parcelRegister("lIHEz", function(module, exports) {

let $fcff91b324a855a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fcff91b324a855a7$var$load("jx2zo"),
    $fcff91b324a855a7$var$load("6wr18"),
    $fcff91b324a855a7$var$load("irTwo"),
    $fcff91b324a855a7$var$load("llcQo"),
    $fcff91b324a855a7$var$load("kIX5g"),
    $fcff91b324a855a7$var$load("ffEVr"),
    $fcff91b324a855a7$var$load("2jEbr")
]).then(()=>parcelRequire('gaL8X'));

});

parcelRegister("gNw9k", function(module, exports) {

let $c3aa2923e0e0f4e8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c3aa2923e0e0f4e8$var$load("6wKNt"),
    $c3aa2923e0e0f4e8$var$load("6wr18"),
    $c3aa2923e0e0f4e8$var$load("irTwo"),
    $c3aa2923e0e0f4e8$var$load("LWh5V"),
    $c3aa2923e0e0f4e8$var$load("4fYzp"),
    $c3aa2923e0e0f4e8$var$load("kDdlJ"),
    $c3aa2923e0e0f4e8$var$load("aCER5"),
    $c3aa2923e0e0f4e8$var$load("fBohe"),
    $c3aa2923e0e0f4e8$var$load("8iGBb"),
    $c3aa2923e0e0f4e8$var$load("cfsnG"),
    $c3aa2923e0e0f4e8$var$load("11hpF"),
    $c3aa2923e0e0f4e8$var$load("eMRD3"),
    $c3aa2923e0e0f4e8$var$load("hhss7"),
    $c3aa2923e0e0f4e8$var$load("7EorR"),
    $c3aa2923e0e0f4e8$var$load("jx2zo"),
    $c3aa2923e0e0f4e8$var$load("ffEVr"),
    $c3aa2923e0e0f4e8$var$load("1jGw5")
]).then(()=>parcelRequire('8XK0M'));

});

parcelRegister("ihBq6", function(module, exports) {

let $d4f6d7605125313b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d4f6d7605125313b$var$load("6wr18"),
    $d4f6d7605125313b$var$load("efUj2"),
    $d4f6d7605125313b$var$load("ffEVr"),
    $d4f6d7605125313b$var$load("6pFEP")
]).then(()=>parcelRequire('kLdY9'));

});

parcelRegister("3I9Fd", function(module, exports) {

let $2b3cfa2887c53d43$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b3cfa2887c53d43$var$load("fhBYB"),
    $2b3cfa2887c53d43$var$load("fky9A"),
    $2b3cfa2887c53d43$var$load("3Wy8Y"),
    $2b3cfa2887c53d43$var$load("hNOga"),
    $2b3cfa2887c53d43$var$load("izROg"),
    $2b3cfa2887c53d43$var$load("hVmYa"),
    $2b3cfa2887c53d43$var$load("9V1vV"),
    $2b3cfa2887c53d43$var$load("6damH"),
    $2b3cfa2887c53d43$var$load("8PJsv"),
    $2b3cfa2887c53d43$var$load("2F69B"),
    $2b3cfa2887c53d43$var$load("8Bic8"),
    $2b3cfa2887c53d43$var$load("4PCFY"),
    $2b3cfa2887c53d43$var$load("1VIvy"),
    $2b3cfa2887c53d43$var$load("d0ZRF"),
    $2b3cfa2887c53d43$var$load("k507P"),
    $2b3cfa2887c53d43$var$load("bncmK"),
    $2b3cfa2887c53d43$var$load("7EorR"),
    $2b3cfa2887c53d43$var$load("5dkX4"),
    $2b3cfa2887c53d43$var$load("bRqDI"),
    $2b3cfa2887c53d43$var$load("cLCaE"),
    $2b3cfa2887c53d43$var$load("KsShd"),
    $2b3cfa2887c53d43$var$load("50Pg5"),
    $2b3cfa2887c53d43$var$load("4fYzp"),
    $2b3cfa2887c53d43$var$load("cGkFm"),
    $2b3cfa2887c53d43$var$load("l4j2l"),
    $2b3cfa2887c53d43$var$load("37v60"),
    $2b3cfa2887c53d43$var$load("6iTkp"),
    $2b3cfa2887c53d43$var$load("4Oj5y"),
    $2b3cfa2887c53d43$var$load("c831e"),
    $2b3cfa2887c53d43$var$load("1GCFv"),
    $2b3cfa2887c53d43$var$load("koD3t"),
    $2b3cfa2887c53d43$var$load("a8R25"),
    $2b3cfa2887c53d43$var$load("lnKog"),
    $2b3cfa2887c53d43$var$load("d3PpR"),
    $2b3cfa2887c53d43$var$load("bAgF6"),
    $2b3cfa2887c53d43$var$load("hnpcA"),
    $2b3cfa2887c53d43$var$load("i8sPk"),
    $2b3cfa2887c53d43$var$load("Jyh1v"),
    $2b3cfa2887c53d43$var$load("w3Gc8"),
    $2b3cfa2887c53d43$var$load("efUj2"),
    $2b3cfa2887c53d43$var$load("coGVA"),
    $2b3cfa2887c53d43$var$load("9TOep"),
    $2b3cfa2887c53d43$var$load("6wr18"),
    $2b3cfa2887c53d43$var$load("bmOOW"),
    $2b3cfa2887c53d43$var$load("dDiWc"),
    $2b3cfa2887c53d43$var$load("hhss7"),
    $2b3cfa2887c53d43$var$load("i6pyw"),
    $2b3cfa2887c53d43$var$load("TIXGP"),
    $2b3cfa2887c53d43$var$load("dxKHc"),
    $2b3cfa2887c53d43$var$load("i8lZ0"),
    $2b3cfa2887c53d43$var$load("iDrFi"),
    $2b3cfa2887c53d43$var$load("ffEVr"),
    $2b3cfa2887c53d43$var$load("42uV7")
]).then(()=>parcelRequire('i6Ad2'));

});

parcelRegister("6SZpw", function(module, exports) {

let $50376c17e97ae09e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $50376c17e97ae09e$var$load("6iTkp"),
    $50376c17e97ae09e$var$load("6wr18"),
    $50376c17e97ae09e$var$load("7SteV"),
    $50376c17e97ae09e$var$load("jE0Mz"),
    $50376c17e97ae09e$var$load("9TOep"),
    $50376c17e97ae09e$var$load("ffEVr"),
    $50376c17e97ae09e$var$load("2xoIF"),
    $50376c17e97ae09e$var$load("cGkFm"),
    $50376c17e97ae09e$var$load("d0ZRF"),
    $50376c17e97ae09e$var$load("k507P"),
    $50376c17e97ae09e$var$load("hhss7"),
    $50376c17e97ae09e$var$load("7EorR"),
    $50376c17e97ae09e$var$load("ce05o"),
    $50376c17e97ae09e$var$load("kI4kR")
]).then(()=>parcelRequire('2W3Ag'));

});

parcelRegister("jJ3Iz", function(module, exports) {

let $e5c51a93e842a50e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5c51a93e842a50e$var$load("lg3b1"),
    $e5c51a93e842a50e$var$load("6wr18"),
    $e5c51a93e842a50e$var$load("aeljk"),
    $e5c51a93e842a50e$var$load("9TOep"),
    $e5c51a93e842a50e$var$load("7EorR"),
    $e5c51a93e842a50e$var$load("ffEVr"),
    $e5c51a93e842a50e$var$load("lLWTb"),
    $e5c51a93e842a50e$var$load("2zIki")
]).then(()=>parcelRequire('8Htp5'));

});

parcelRegister("lhsIn", function(module, exports) {

let $f7e175ac529b036a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f7e175ac529b036a$var$load("lUNmR").then(()=>parcelRequire('94Gnj'));

});

parcelRegister("lSFxt", function(module, exports) {

let $fededce3c4c97b81$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $fededce3c4c97b81$var$load("3yZPW"),
    $fededce3c4c97b81$var$load("6wr18"),
    $fededce3c4c97b81$var$load("bJkEE"),
    $fededce3c4c97b81$var$load("at3xi"),
    $fededce3c4c97b81$var$load("4fYzp"),
    $fededce3c4c97b81$var$load("c831e"),
    $fededce3c4c97b81$var$load("iOfkQ"),
    $fededce3c4c97b81$var$load("2NFUs"),
    $fededce3c4c97b81$var$load("h2QcJ"),
    $fededce3c4c97b81$var$load("iN26T"),
    $fededce3c4c97b81$var$load("5GZhs"),
    $fededce3c4c97b81$var$load("dbmJd"),
    $fededce3c4c97b81$var$load("cT9w0"),
    $fededce3c4c97b81$var$load("30iG7"),
    $fededce3c4c97b81$var$load("7kZcw"),
    $fededce3c4c97b81$var$load("fGK34"),
    $fededce3c4c97b81$var$load("bYpO4"),
    $fededce3c4c97b81$var$load("efUj2"),
    $fededce3c4c97b81$var$load("251nM"),
    $fededce3c4c97b81$var$load("7EorR"),
    $fededce3c4c97b81$var$load("jx2zo"),
    $fededce3c4c97b81$var$load("ffEVr"),
    $fededce3c4c97b81$var$load("92cXH")
]).then(()=>parcelRequire('bmWlW'));

});

parcelRegister("ejpdO", function(module, exports) {

let $a6b6678ab9eb9ca2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $a6b6678ab9eb9ca2$var$load("hG5oc"),
    $a6b6678ab9eb9ca2$var$load("hMnvy")
]).then(()=>parcelRequire('bn8ZY'));

});

parcelRegister("7Fanm", function(module, exports) {

let $5944692a1afdf533$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5944692a1afdf533$var$load("2xoIF"),
    $5944692a1afdf533$var$load("6wr18"),
    $5944692a1afdf533$var$load("7ZdE9"),
    $5944692a1afdf533$var$load("ftT7k"),
    $5944692a1afdf533$var$load("2C3m1"),
    $5944692a1afdf533$var$load("bAgF6"),
    $5944692a1afdf533$var$load("b3yRn"),
    $5944692a1afdf533$var$load("axf0M"),
    $5944692a1afdf533$var$load("eYxdW"),
    $5944692a1afdf533$var$load("9KCOJ"),
    $5944692a1afdf533$var$load("7EorR"),
    $5944692a1afdf533$var$load("9RiRQ"),
    $5944692a1afdf533$var$load("jt9eA"),
    $5944692a1afdf533$var$load("5pK3l"),
    $5944692a1afdf533$var$load("9UGFj"),
    $5944692a1afdf533$var$load("4bzNN"),
    $5944692a1afdf533$var$load("dtB8f"),
    $5944692a1afdf533$var$load("6vUJB"),
    $5944692a1afdf533$var$load("eqAkJ"),
    $5944692a1afdf533$var$load("3zwpG"),
    $5944692a1afdf533$var$load("4C4vr"),
    $5944692a1afdf533$var$load("ksZv4"),
    $5944692a1afdf533$var$load("jx2zo"),
    $5944692a1afdf533$var$load("ffEVr"),
    $5944692a1afdf533$var$load("aez9w")
]).then(()=>parcelRequire('cjovp'));

});

parcelRegister("itWrA", function(module, exports) {

let $d7484531b704d0e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d7484531b704d0e9$var$load("TIXGP"),
    $d7484531b704d0e9$var$load("6wr18"),
    $d7484531b704d0e9$var$load("iWYiP"),
    $d7484531b704d0e9$var$load("7Alab"),
    $d7484531b704d0e9$var$load("56Sxu"),
    $d7484531b704d0e9$var$load("4fYzp"),
    $d7484531b704d0e9$var$load("7EorR"),
    $d7484531b704d0e9$var$load("jx2zo"),
    $d7484531b704d0e9$var$load("ffEVr"),
    $d7484531b704d0e9$var$load("dpKl1")
]).then(()=>parcelRequire('gTSd0'));

});

parcelRegister("d03lP", function(module, exports) {

let $976ddfec1d659001$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $976ddfec1d659001$var$load("TIXGP"),
    $976ddfec1d659001$var$load("6wr18"),
    $976ddfec1d659001$var$load("iWYiP"),
    $976ddfec1d659001$var$load("lnUVM"),
    $976ddfec1d659001$var$load("56Sxu"),
    $976ddfec1d659001$var$load("ffEVr"),
    $976ddfec1d659001$var$load("c8GnP")
]).then(()=>parcelRequire('145h7'));

});

parcelRegister("gjZQ9", function(module, exports) {

let $be1e63d9dcc8f6f9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $be1e63d9dcc8f6f9$var$load("exvU8").then(()=>parcelRequire('9ZXTU'));

});

parcelRegister("aTktW", function(module, exports) {

let $7edeedb4491b472e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7edeedb4491b472e$var$load("9EI97").then(()=>parcelRequire('ivpO0'));

});

parcelRegister("7PF1e", function(module, exports) {

let $5b3d1d4c3a7b93c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5b3d1d4c3a7b93c3$var$load("2n8AT").then(()=>parcelRequire('cv3PF'));

});

parcelRegister("hSMRQ", function(module, exports) {

let $d04d62d960e85d39$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d04d62d960e85d39$var$load("7k9oy"),
    $d04d62d960e85d39$var$load("jczTu")
]).then(()=>parcelRequire('bnpc5'));

});

parcelRegister("eieXD", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $02af7510cb9721a1$export$99d02219d259eb94);
$parcel$export(module.exports, "Transports", () => (parcelRequire("a2lmi")));

var $fbwmZ = parcelRequire("fbwmZ");


var $dcw8o = parcelRequire("dcw8o");


var $ilRwI = parcelRequire("ilRwI");


var $6NrTk = parcelRequire("6NrTk");


var $eIjjl = parcelRequire("eIjjl");


var $a2lmi = parcelRequire("a2lmi");

var $02af7510cb9721a1$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $02af7510cb9721a1$var$_window = (0, $6NrTk.getGlobalObject)();
if ($02af7510cb9721a1$var$_window.Sentry && $02af7510cb9721a1$var$_window.Sentry.Integrations) $02af7510cb9721a1$var$windowIntegrations = $02af7510cb9721a1$var$_window.Sentry.Integrations;
var $02af7510cb9721a1$export$99d02219d259eb94 = (0, $fbwmZ.__assign)((0, $fbwmZ.__assign)((0, $fbwmZ.__assign)({}, $02af7510cb9721a1$var$windowIntegrations), (0, $ilRwI)), $eIjjl);
 //# sourceMappingURL=index.js.map
$parcel$exportWildcard(module.exports, $dcw8o);

});

parcelRegister("dcw8o", function(module, exports) {
$parcel$export(module.exports, "Severity", () => (parcelRequire("9Sr2t")).Severity);
$parcel$export(module.exports, "addGlobalEventProcessor", () => (parcelRequire("hkv0W")).addGlobalEventProcessor);
$parcel$export(module.exports, "addBreadcrumb", () => (parcelRequire("9HPf3")).addBreadcrumb);
$parcel$export(module.exports, "captureException", () => (parcelRequire("9HPf3")).captureException);
$parcel$export(module.exports, "captureEvent", () => (parcelRequire("9HPf3")).captureEvent);
$parcel$export(module.exports, "captureMessage", () => (parcelRequire("9HPf3")).captureMessage);
$parcel$export(module.exports, "configureScope", () => (parcelRequire("9HPf3")).configureScope);
$parcel$export(module.exports, "getHubFromCarrier", () => (parcelRequire("amM2J")).getHubFromCarrier);
$parcel$export(module.exports, "getCurrentHub", () => (parcelRequire("amM2J")).getCurrentHub);
$parcel$export(module.exports, "Hub", () => (parcelRequire("amM2J")).Hub);
$parcel$export(module.exports, "makeMain", () => (parcelRequire("amM2J")).makeMain);
$parcel$export(module.exports, "Scope", () => (parcelRequire("hkv0W")).Scope);
$parcel$export(module.exports, "Session", () => (parcelRequire("dQl3s")).Session);
$parcel$export(module.exports, "startTransaction", () => (parcelRequire("9HPf3")).startTransaction);
$parcel$export(module.exports, "SDK_VERSION", () => (parcelRequire("a953x")).SDK_VERSION);
$parcel$export(module.exports, "setContext", () => (parcelRequire("9HPf3")).setContext);
$parcel$export(module.exports, "setExtra", () => (parcelRequire("9HPf3")).setExtra);
$parcel$export(module.exports, "setExtras", () => (parcelRequire("9HPf3")).setExtras);
$parcel$export(module.exports, "setTag", () => (parcelRequire("9HPf3")).setTag);
$parcel$export(module.exports, "setTags", () => (parcelRequire("9HPf3")).setTags);
$parcel$export(module.exports, "setUser", () => (parcelRequire("9HPf3")).setUser);
$parcel$export(module.exports, "withScope", () => (parcelRequire("9HPf3")).withScope);
$parcel$export(module.exports, "BrowserClient", () => (parcelRequire("e9HlS")).BrowserClient);
$parcel$export(module.exports, "injectReportDialog", () => (parcelRequire("9whyS")).injectReportDialog);
$parcel$export(module.exports, "eventFromException", () => (parcelRequire("l17tw")).eventFromException);
$parcel$export(module.exports, "eventFromMessage", () => (parcelRequire("l17tw")).eventFromMessage);
$parcel$export(module.exports, "defaultIntegrations", () => (parcelRequire("eAdCn")).defaultIntegrations);
$parcel$export(module.exports, "forceLoad", () => (parcelRequire("eAdCn")).forceLoad);
$parcel$export(module.exports, "init", () => (parcelRequire("eAdCn")).init);
$parcel$export(module.exports, "lastEventId", () => (parcelRequire("eAdCn")).lastEventId);
$parcel$export(module.exports, "onLoad", () => (parcelRequire("eAdCn")).onLoad);
$parcel$export(module.exports, "showReportDialog", () => (parcelRequire("eAdCn")).showReportDialog);
$parcel$export(module.exports, "flush", () => (parcelRequire("eAdCn")).flush);
$parcel$export(module.exports, "close", () => (parcelRequire("eAdCn")).close);
$parcel$export(module.exports, "wrap", () => (parcelRequire("eAdCn")).wrap);
$parcel$export(module.exports, "SDK_NAME", () => (parcelRequire("7iBHc")).SDK_NAME);

var $9Sr2t = parcelRequire("9Sr2t");


var $9HPf3 = parcelRequire("9HPf3");

var $hkv0W = parcelRequire("hkv0W");

var $amM2J = parcelRequire("amM2J");

var $a953x = parcelRequire("a953x");

var $dQl3s = parcelRequire("dQl3s");


var $e9HlS = parcelRequire("e9HlS");


var $9whyS = parcelRequire("9whyS");


var $l17tw = parcelRequire("l17tw");


var $eAdCn = parcelRequire("eAdCn");


var $7iBHc = parcelRequire("7iBHc");

 //# sourceMappingURL=exports.js.map

});

parcelRegister("7iBHc", function(module, exports) {
// TODO: Remove in the next major release and rely only on @sentry/core SDK_VERSION and SdkInfo metadata
var $55077470b8523cd3$export$ca61d37259221480 = 'sentry.javascript.browser'; //# sourceMappingURL=version.js.map
module.exports["SDK_NAME"] = $55077470b8523cd3$export$ca61d37259221480;

});

parcelRegister("eIjjl", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("cEELl")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("51FBI")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("bNfZ4")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("6oUta")).LinkedErrors);
$parcel$export(module.exports, "UserAgent", () => (parcelRequire("aMh6Y")).UserAgent);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lBiNe")).Dedupe);

var $cEELl = parcelRequire("cEELl");


var $51FBI = parcelRequire("51FBI");


var $bNfZ4 = parcelRequire("bNfZ4");


var $6oUta = parcelRequire("6oUta");


var $aMh6Y = parcelRequire("aMh6Y");


var $lBiNe = parcelRequire("lBiNe");

 //# sourceMappingURL=index.js.map

});

parcelRegister("a2lmi", function(module, exports) {
$parcel$export(module.exports, "BaseTransport", () => (parcelRequire("l2hU1")).BaseTransport);
$parcel$export(module.exports, "FetchTransport", () => (parcelRequire("9yqZL")).FetchTransport);
$parcel$export(module.exports, "XHRTransport", () => (parcelRequire("5a5jw")).XHRTransport);
$parcel$export(module.exports, "makeNewFetchTransport", () => (parcelRequire("hu9Hi")).makeNewFetchTransport);
$parcel$export(module.exports, "makeNewXHRTransport", () => (parcelRequire("3FUEv")).makeNewXHRTransport);

var $l2hU1 = parcelRequire("l2hU1");


var $9yqZL = parcelRequire("9yqZL");


var $5a5jw = parcelRequire("5a5jw");


var $hu9Hi = parcelRequire("hu9Hi");


var $3FUEv = parcelRequire("3FUEv");

 //# sourceMappingURL=index.js.map

});

parcelRegister("ir4h8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $ac2J9 = parcelRequire("ac2J9");

const $abc73c6f5c74c436$export$6d558eab13290f59 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
} : ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $cozmU.useContext)((0, $ac2J9.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
module.exports["useRouterLink"] = $abc73c6f5c74c436$export$6d558eab13290f59;

});

parcelRegister("ac2J9", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $b797161b98bd0492$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $cozmU.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $b797161b98bd0492$var$RouterLinkProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { routerLinkComponent: routerLinkComponent, children: children } = t0;
    let t1;
    if ($[0] !== routerLinkComponent) {
        t1 = {
            routerLinkComponent: routerLinkComponent
        };
        $[0] = routerLinkComponent;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== children || $[3] !== t1) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
            value: t1,
            children: children
        });
        $[2] = children;
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)($b797161b98bd0492$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b797161b98bd0492$export$2e2bcd8739ae039 = $b797161b98bd0492$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $b797161b98bd0492$export$2931e0ee690eee88;

});

parcelRegister("gTPfK", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $6057e25d3e7f93e3$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
            const $ = (0, $bDgLe.c)(11);
            let analyticsContext;
            let rest;
            if ($[0] !== t0) {
                ({ analyticsContext: analyticsContext, ...rest } = t0);
                $[0] = t0;
                $[1] = analyticsContext;
                $[2] = rest;
            } else {
                analyticsContext = $[1];
                rest = $[2];
            }
            let t1;
            if ($[3] !== analyticsContext) {
                t1 = {
                    ...defaultData,
                    ...analyticsContext
                };
                $[3] = analyticsContext;
                $[4] = t1;
            } else t1 = $[4];
            const analyticsData = t1;
            const t2 = rest;
            let t3;
            if ($[5] !== ref || $[6] !== t2) {
                t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                    ...t2,
                    ref: ref
                });
                $[5] = ref;
                $[6] = t2;
                $[7] = t3;
            } else t3 = $[7];
            let t4;
            if ($[8] !== analyticsData || $[9] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: analyticsData
                }, t3);
                $[8] = analyticsData;
                $[9] = t3;
                $[10] = t4;
            } else t4 = $[10];
            return t4;
        } : ({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $cozmU.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
                ...rest,
                ref: ref
            }));
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $6057e25d3e7f93e3$export$2e2bcd8739ae039 = $6057e25d3e7f93e3$var$withAnalyticsContext;
module.exports["default"] = $6057e25d3e7f93e3$export$2e2bcd8739ae039;

});

parcelRegister("lrDw7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6a66563ef19581ba$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $cozmU.useRef)(null);
    const setRef = (0, $cozmU.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};
module.exports["useElementRef"] = $6a66563ef19581ba$export$ff879f35a69d56b7;

});

parcelRegister("g3XYx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f8fe10123ae9dc81$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $f8fe10123ae9dc81$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $cozmU.useRef)([]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $f8fe10123ae9dc81$var$getHookDeps(opts));
    return (0, $cozmU.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
module.exports["useRequestAnimationFrame"] = $f8fe10123ae9dc81$export$1775f27e7c8051ca;

});

parcelRegister("4YBSq", function(module, exports) {
/**
 * @generated SignedSource<<9700b2b14bf1783e20ed515703a9c457>>
 * @relayHash f85bb73042ebe75e2cb50dec93f9b7c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139
const $16e983e3bee16ecd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fabricEditorSupported"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "embedded"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "collabService"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subType"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EditContentButtonQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f85bb73042ebe75e2cb50dec93f9b7c4",
            "id": "ea06e652012418baf02c0133f828dbef03e488a63e53403257a821a52af7d139",
            "metadata": {},
            "name": "EditContentButtonQuery",
            "operationKind": "query",
            "text": "query EditContentButtonQuery($contentId:ID!){content(id:$contentId){nodes{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}}}"
        }
    };
}();
$16e983e3bee16ecd$var$node.hash = "94b096c536d2633f3df010c4409c1c2a";
var $16e983e3bee16ecd$export$2e2bcd8739ae039 = $16e983e3bee16ecd$var$node;
module.exports["default"] = $16e983e3bee16ecd$export$2e2bcd8739ae039;

});

parcelRegister("3lWl0", function(module, exports) {
/**
 * @generated SignedSource<<f94631fe88bfaea1f9346228f17314d1>>
 * @relayHash e78f45ef84b0309b46cad2982bdd129a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9
const $34dd87dd4e33f987$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isApprovalsFgOn"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipAvailableContentStates"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldSkipContentStateLastUpdated"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "shouldSkipEditOnlyFields"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "Variable",
        "name": "isDraft",
        "variableName": "isDraft"
    }, v9 = {
        "kind": "ScalarField",
        "name": "name"
    }, v10 = {
        "kind": "ScalarField",
        "name": "color"
    }, v11 = {
        "kind": "ScalarField",
        "name": "restrictionLevel"
    }, v12 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v7 /*: any*/ ,
                {
                    "args": [
                        v8 /*: any*/ 
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        {
                            "condition": "shouldSkipEditOnlyFields",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCallerPermitted"
                                }
                            ]
                        },
                        {
                            "condition": "isApprovalsFgOn",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifierAaid"
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "shouldSkipContentStateLastUpdated",
                    "kind": "Condition",
                    "passingValue": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "format",
                                    "variableName": "format"
                                },
                                v8 /*: any*/ 
                            ],
                            "concreteType": "ConfluenceDate",
                            "kind": "LinkedField",
                            "name": "contentStateLastUpdated",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "shouldSkipAvailableContentStates",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "AvailableContentStates",
                    "kind": "LinkedField",
                    "name": "availableContentStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "customContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ContentState",
                            "kind": "LinkedField",
                            "name": "spaceContentStates",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v7 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "EditorContentStateQuery",
            "selections": v12 /*: any*/ 
        },
        "params": {
            "cacheID": "e78f45ef84b0309b46cad2982bdd129a",
            "id": "d9dbad7f6be18f479464c7740ecc608e88f02669cea51d9e028e75b6b84f4eb9",
            "metadata": {},
            "name": "EditorContentStateQuery",
            "operationKind": "query",
            "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!,$shouldSkipAvailableContentStates:Boolean=false,$shouldSkipEditOnlyFields:Boolean=false){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted@skip(if:$shouldSkipEditOnlyFields),lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId)@skip(if:$shouldSkipAvailableContentStates){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$34dd87dd4e33f987$var$node.hash = "f76426744ff28f16601d3ae4d51a17fb";
var $34dd87dd4e33f987$export$2e2bcd8739ae039 = $34dd87dd4e33f987$var$node;
module.exports["default"] = $34dd87dd4e33f987$export$2e2bcd8739ae039;

});

parcelRegister("8EyOs", function(module, exports) {
/**
 * @generated SignedSource<<dd6200b047aed134b0d9af6a992daf7b>>
 * @relayHash 0c7e59589b279881378fc2baf2dcf71b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb
const $231a29dfed7a7165$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "format"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isDraft",
                            "variableName": "isDraft"
                        }
                    ],
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "contentState",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "format",
                            "variableName": "format"
                        }
                    ],
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "contentStateLastUpdated",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RendererContentStateQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "0c7e59589b279881378fc2baf2dcf71b",
            "id": "0dfd28d4a6a045f36efbb873be6de601dedb01632d322cff86c74287f8c186bb",
            "metadata": {},
            "name": "RendererContentStateQuery",
            "operationKind": "query",
            "text": "query RendererContentStateQuery($contentId:ID!,$isDraft:Boolean!,$format:GraphQLDateFormat){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel},contentStateLastUpdated(format:$format){value}}}"
        }
    };
}();
$231a29dfed7a7165$var$node.hash = "a7f67982771d8fe760ba232b1260bced";
var $231a29dfed7a7165$export$2e2bcd8739ae039 = $231a29dfed7a7165$var$node;
module.exports["default"] = $231a29dfed7a7165$export$2e2bcd8739ae039;

});

parcelRegister("44nNV", function(module, exports) {
/**
 * @generated SignedSource<<886162fb131030e636963e819a221afa>>
 * @relayHash c891ebd5c4e792dc4af4918d6891c449
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b22bfa401eba72523cc9cc01584bfb2d1dff8561a7181892b569846aefed3bb
const $4deb20d71ef1be89$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentAri",
                    "variableName": "contentAri"
                }
            ],
            "concreteType": "AiPlannerConfluenceArtifactByline",
            "kind": "LinkedField",
            "name": "aiplanner_resolveArtifactByConfluenceContentAri",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "planTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "artifactUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AIPlannerSyncBylineQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AIPlannerSyncBylineQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c891ebd5c4e792dc4af4918d6891c449",
            "id": "9b22bfa401eba72523cc9cc01584bfb2d1dff8561a7181892b569846aefed3bb",
            "metadata": {},
            "name": "AIPlannerSyncBylineQuery",
            "operationKind": "query",
            "text": "query AIPlannerSyncBylineQuery($cloudId:String!,$contentAri:String!){aiplanner_resolveArtifactByConfluenceContentAri(cloudId:$cloudId,contentAri:$contentAri){planTitle,artifactUrl}}"
        }
    };
}();
$4deb20d71ef1be89$var$node.hash = "f6755a460763c0da6c43d2a9e189591a";
var $4deb20d71ef1be89$export$2e2bcd8739ae039 = $4deb20d71ef1be89$var$node;
module.exports["default"] = $4deb20d71ef1be89$export$2e2bcd8739ae039;

});

parcelRegister("grspz", function(module, exports) {
const $cdcead6f01277136$export$957229695d10ea4a = (extensionId)=>{
    return extensionId.replace(/[^a-zA-Z0-9-]/g, '-');
};
module.exports["getLocalId"] = $cdcead6f01277136$export$957229695d10ea4a;

});

parcelRegister("568fA", function(module, exports) {
/**
 * @generated SignedSource<<edb2a48d5268bebed303963270db4c3a>>
 * @relayHash b647ff34a22d9e67b3330f440f310bb5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e540b0c89e30ec6f141235a6f4e47d93b9ce22a39faec34b35e59dfd7657f73
const $0dc90704ec36fa39$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current",
                "draft"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "key"
    }, v6 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "name"
            },
            v5 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            }
        ]
    }, v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v9 = {
        "kind": "ScalarField",
        "name": "status"
    }, v10 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v11 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v12 = {
        "kind": "ScalarField",
        "name": "number"
    }, v13 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v14 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v15 = {
        "kind": "ScalarField",
        "name": "when"
    }, v16 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ], v17 = [
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        {
            "kind": "LinkedField",
            "name": "by",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                v14 /*: any*/ 
            ]
        },
        v15 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v16 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentTypesHeaderQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "draftVersion",
                                    "plural": false,
                                    "selections": v17 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b647ff34a22d9e67b3330f440f310bb5",
            "id": "8e540b0c89e30ec6f141235a6f4e47d93b9ce22a39faec34b35e59dfd7657f73",
            "metadata": {},
            "name": "ContentTypesHeaderQuery",
            "operationKind": "query",
            "text": "query ContentTypesHeaderQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}}}"
        }
    };
}();
$0dc90704ec36fa39$var$node.hash = "1e8693f245d726bc820bbd0bffbc0cff";
var $0dc90704ec36fa39$export$2e2bcd8739ae039 = $0dc90704ec36fa39$var$node;
module.exports["default"] = $0dc90704ec36fa39$export$2e2bcd8739ae039;

});

parcelRegister("lPNkm", function(module, exports) {
/**
 * @generated SignedSource<<fcf122e4a0dd12a263fab6061b3a36dd>>
 * @relayHash 19081691cac2c634716f82092efd5e14
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3
const $98f50c7d6961f0d8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        {
            "kind": "ScalarField",
            "name": "js"
        },
        {
            "kind": "ScalarField",
            "name": "css"
        },
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceSettings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "SpaceSettingsMetadata",
                            "kind": "LinkedField",
                            "name": "customHeaderAndFooter",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "header",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                },
                                {
                                    "concreteType": "HtmlMeta",
                                    "kind": "LinkedField",
                                    "name": "footer",
                                    "plural": false,
                                    "selections": v1 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CustomHeaderFooterQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "19081691cac2c634716f82092efd5e14",
            "id": "3d5dc74f8943db901b65da9952c21aedcb442dbab7bde8fc78fddd85434811f3",
            "metadata": {},
            "name": "CustomHeaderFooterQuery",
            "operationKind": "query",
            "text": "query CustomHeaderFooterQuery($spaceKey:String){space(key:$spaceKey){id,settings{customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}}}}"
        }
    };
}();
$98f50c7d6961f0d8$var$node.hash = "deed3f087b4973bd7d276b1389cfb125";
var $98f50c7d6961f0d8$export$2e2bcd8739ae039 = $98f50c7d6961f0d8$var$node;
module.exports["default"] = $98f50c7d6961f0d8$export$2e2bcd8739ae039;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<d76d95039bbf9cae17d368276aebc792>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<5e736080ce8c5ab015a5851e0537f7fa>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("3j8TZ", function(module, exports) {
/**
 * @generated SignedSource<<bcf6371051972dda4e73703ef8d6345b>>
 * @relayHash 44fbfb9d6df590a6ee4e002cd5037220
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01
const $bcd0dbc3bf494067$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "size"
    }, v7 = {
        "kind": "ScalarField",
        "name": "mimeType"
    }, v8 = {
        "kind": "ScalarField",
        "name": "processingStatus"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAt"
    }, v10 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Variable",
                                                            "name": "cloudId",
                                                            "variableName": "cloudId"
                                                        }
                                                    ],
                                                    "concreteType": "MediaItem",
                                                    "kind": "LinkedField",
                                                    "name": "mediaItems",
                                                    "plural": true,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "type"
                                                        },
                                                        {
                                                            "concreteType": "MediaFileDetails",
                                                            "kind": "LinkedField",
                                                            "name": "details",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v6 /*: any*/ ,
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "mediaType"
                                                                },
                                                                v8 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "failReason"
                                                                },
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MediaFilePreview",
                                                                    "kind": "LinkedField",
                                                                    "name": "preview",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "cdnUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileArtifact",
                                                                    "kind": "LinkedField",
                                                                    "name": "artifactsList",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v9 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v5 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "url"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileRepresentations",
                                                                    "kind": "LinkedField",
                                                                    "name": "representations",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "MediaImageRepresentation",
                                                                            "kind": "LinkedField",
                                                                            "name": "image",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "_empty"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "duration"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MediaFileAbuseClassification",
                                                                    "kind": "LinkedField",
                                                                    "name": "abuseClassification",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "classification"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "confidence"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "selections": v10 /*: any*/ 
        },
        "params": {
            "cacheID": "44fbfb9d6df590a6ee4e002cd5037220",
            "id": "3e8b1b354828c70d1a3ff4efd4b04c1bb4b5dbec948132154a057ea3cc5e9c01",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenWithMediaItemsQuery($cloudId:ID!,$contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token},mediaItems(cloudId:$cloudId){id,type,details{name,size,mimeType,mediaType,processingStatus,failReason,createdAt,preview{cdnUrl},artifactsList{createdAt,mimeType,name,processingStatus,size,url},representations{image{_empty}},mediaMetadata{duration},abuseClassification{classification,confidence}}}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$bcd0dbc3bf494067$var$node.hash = "c03e617139295e9107b3907ee1a06cb3";
var $bcd0dbc3bf494067$export$2e2bcd8739ae039 = $bcd0dbc3bf494067$var$node;
module.exports["default"] = $bcd0dbc3bf494067$export$2e2bcd8739ae039;

});

parcelRegister("k5dl6", function(module, exports) {
/**
 * @generated SignedSource<<6dc466aba14c78f3432cf6d35f092a95>>
 * @relayHash 9f9cb3b101c0d783a0151d795ee8a444
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06
const $bff977656480fdfe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "id",
                "variableName": "contentId"
            }
        ],
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
            {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v1 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "type"
                    },
                    {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                            v1 /*: any*/ ,
                            v2 /*: any*/ 
                        ]
                    },
                    v2 /*: any*/ 
                ]
            }
        ]
    }, v4 = [
        {
            "kind": "Variable",
            "name": "commentId",
            "variableName": "commentId"
        },
        {
            "kind": "Literal",
            "name": "depth",
            "value": "ALL"
        },
        {
            "kind": "Literal",
            "name": "type",
            "value": "UNRESOLVED"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "value"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v6 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v8 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v6 /*: any*/ 
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isInlineComment"
    }, v11 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v13 = {
        "kind": "ScalarField",
        "name": "when"
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            },
            {
                "kind": "ScalarField",
                "name": "editui"
            }
        ]
    }, v17 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v20 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v21 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ ,
            v16 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v22 = {
        "alias": "user",
        "args": [
            {
                "kind": "Literal",
                "name": "current",
                "value": true
            }
        ],
        "concreteType": "AtlassianUser",
        "kind": "LinkedField",
        "name": "confluence_atlassianUser",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v12 /*: any*/ ,
            {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "isPrimary"
                    }
                ]
            }
        ],
        "storageKey": "confluence_atlassianUser(current:true)"
    }, v23 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v24 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v12 /*: any*/ 
                ]
            },
            v13 /*: any*/ ,
            v14 /*: any*/ 
        ]
    }, v25 = {
        "kind": "LinkedField",
        "name": "author",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v12 /*: any*/ ,
            v17 /*: any*/ ,
            v18 /*: any*/ ,
            v19 /*: any*/ 
        ]
    }, v26 = {
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replies",
        "plural": true,
        "selections": [
            v1 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            v9 /*: any*/ ,
            v10 /*: any*/ ,
            v11 /*: any*/ ,
            v24 /*: any*/ ,
            v16 /*: any*/ ,
            v25 /*: any*/ 
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v15 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v20 /*: any*/ ,
                                        v21 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v20 /*: any*/ ,
                                v21 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "selections": [
                v3 /*: any*/ ,
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "PaginatedCommentList",
                    "kind": "LinkedField",
                    "name": "comments",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "Comment",
                                    "kind": "LinkedField",
                                    "name": "ancestors",
                                    "plural": true,
                                    "selections": [
                                        v1 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v16 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        v26 /*: any*/ 
                                    ]
                                },
                                v1 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v24 /*: any*/ ,
                                v16 /*: any*/ ,
                                v25 /*: any*/ ,
                                v26 /*: any*/ 
                            ]
                        }
                    ]
                },
                v22 /*: any*/ 
            ]
        },
        "params": {
            "cacheID": "9f9cb3b101c0d783a0151d795ee8a444",
            "id": "97db17732754f14f8a0a3024abfd1a748e416b71742d827d0bfd273f20b59b06",
            "metadata": {},
            "name": "InlineCommentsFocusedInlineCommentQuery",
            "operationKind": "query",
            "text": "query InlineCommentsFocusedInlineCommentQuery($commentId:ID!,$contentId:ID){content(id:$contentId){nodes{id,type,space{id,operations{operation,targetType}},operations{operation,targetType}}},comments(commentId:$commentId,depth:ALL,type:UNRESOLVED){nodes{ancestors{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}},id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},replies{id,body(representation:ATLAS_DOC_FORMAT){value},createdAt{value},createdAtNonLocalized,isInlineComment,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},links{webui,editui},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}}}}},user:confluence_atlassianUser(current:true){id,displayName,photos{value,isPrimary}}}"
        }
    };
}();
$bff977656480fdfe$var$node.hash = "c6bc55705b1b90c4e9cb60ee0b5a4650";
var $bff977656480fdfe$export$2e2bcd8739ae039 = $bff977656480fdfe$var$node;
module.exports["default"] = $bff977656480fdfe$export$2e2bcd8739ae039;

});

parcelRegister("lC6Qd", function(module, exports) {
/**
 * @generated SignedSource<<809e2044c3792f08e4a1f1fd3c386e1c>>
 * @relayHash eca6e9d325c97f4fd5880178ecc63561
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d
const $03de5ecc01e321ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "draftShareId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "draftShareId",
                    "variableName": "draftShareId"
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "cover-picture-id-draft",
                                        "cover-picture-id-published"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "CoverPictureQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "eca6e9d325c97f4fd5880178ecc63561",
            "id": "e2e9338430096a14321d43ffc4d7c87126164ce6f2d44ea4ede01d437b0ec12d",
            "metadata": {},
            "name": "CoverPictureQuery",
            "operationKind": "query",
            "text": "query CoverPictureQuery($contentId:ID,$status:[String],$draftShareId:String){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}}}"
        }
    };
}();
$03de5ecc01e321ee$var$node.hash = "cbe85309884dfe8220661d705f977e0f";
var $03de5ecc01e321ee$export$2e2bcd8739ae039 = $03de5ecc01e321ee$var$node;
module.exports["default"] = $03de5ecc01e321ee$export$2e2bcd8739ae039;

});

parcelRegister("irrTO", function(module, exports) {

var $g6QPm = parcelRequire("g6QPm");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $9o4Fw = parcelRequire("9o4Fw");

const $e1546bd447729439$export$f4a1f447ac6a7a9a = (contentId, useCache = true)=>{
    return (0, $dYU3e.query)({
        query: (0, $9o4Fw.default),
        variables: contentId && (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? {
            ...(0, $g6QPm.createEditorContentUnifiedQueryVariables)({
                contentId: contentId
            }),
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        } : {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            ...!useCache ? {
                cacheBuster: Date.now()
            } : {}
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        // Match Apollo's warm-cache behavior across editor unmounts and subsequent page visits.
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr -- This controls request-scoped cache retention, not rendered output.
        relayQueryPreloadRetention: 'environment',
        __callerPackage__: "content-appearance"
    });
};
module.exports["preloadDraftContentAppearance"] = $e1546bd447729439$export$f4a1f447ac6a7a9a;

});

parcelRegister("flWvL", function(module, exports) {
const $601c87545eb15d39$export$7744ef788ce8060b = (server)=>{
    if (typeof server === 'string') {
        const v = server.toLowerCase();
        if (v === 'compact') return 'compact';
    }
    return 'standard';
};
const $601c87545eb15d39$export$c21c52065fb17015 = (ui)=>ui === 'compact' ? 'COMPACT' : 'STANDARD';
const $601c87545eb15d39$export$9b5b746082006bde = (m)=>m === 'compact' ? 'standard' : 'compact';
const $601c87545eb15d39$export$bc47da214dd10736 = (opts)=>{
    if (opts.isLivePage) return 'CURRENT';
    if (opts.isEditorPage) return 'DRAFT';
    return 'CURRENT';
};
const $601c87545eb15d39$export$7052ab1304ba8160 = (isDraft, isArchived)=>{
    return isArchived ? 'archived' : isDraft ? 'draft' : 'current';
};
module.exports["serverToUiContentMode"] = $601c87545eb15d39$export$7744ef788ce8060b;
module.exports["uiToServerContentMode"] = $601c87545eb15d39$export$c21c52065fb17015;
module.exports["flipContentMode"] = $601c87545eb15d39$export$9b5b746082006bde;
module.exports["resolveContentStatus"] = $601c87545eb15d39$export$bc47da214dd10736;
module.exports["queryStatusFor"] = $601c87545eb15d39$export$7052ab1304ba8160;

});

parcelRegister("joyRP", function(module, exports) {
/**
 * @generated SignedSource<<11e8316517ac59e0b0326a7aa3a855c6>>
 * @relayHash ff452defe6c30c6aef6cb69359d0b5a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad
const $fd020ad5a5ea36ff$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isDraft"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentProperties",
                            "kind": "LinkedField",
                            "name": "contentProperties",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "concreteType": "PublishedContentProperties",
                                            "kind": "LinkedField",
                                            "name": "latest",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isDraft",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "DraftContentProperties",
                                            "kind": "LinkedField",
                                            "name": "draft",
                                            "plural": false,
                                            "selections": v1 /*: any*/ 
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEditorContentModeValueQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ff452defe6c30c6aef6cb69359d0b5a9",
            "id": "34a936a3c8d22258a1afe16bee6383e33250109cc96bccd4cb0241a006a579ad",
            "metadata": {},
            "name": "useEditorContentModeValueQuery",
            "operationKind": "query",
            "text": "query useEditorContentModeValueQuery($contentId:ID!,$isDraft:Boolean!,$status:[String]){content(id:$contentId,status:$status){nodes{id,contentProperties{latest@skip(if:$isDraft){contentMode},draft@include(if:$isDraft){contentMode}}}}}"
        }
    };
}();
$fd020ad5a5ea36ff$var$node.hash = "51a479801516afe1b59a1bbcd1c3f7d5";
var $fd020ad5a5ea36ff$export$2e2bcd8739ae039 = $fd020ad5a5ea36ff$var$node;
module.exports["default"] = $fd020ad5a5ea36ff$export$2e2bcd8739ae039;

});

parcelRegister("kae7O", function(module, exports) {
/**
 * @generated SignedSource<<235e2f4f1cae802c5b7683463fdf34f9>>
 * @relayHash 177df4e8b836b390b9636d650c93a7b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612
const $99e3ac9ccccf9f94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                }
            ]
        }
    ], v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "alias": "pageTitlePublished",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-published"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-published\")"
                        },
                        {
                            "alias": "pageTitleDraft",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "page-title-property-draft"
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": v2 /*: any*/ ,
                            "storageKey": "properties(key:\"page-title-property-draft\")"
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                    "kind": "LinkedField",
                                    "name": "frontend",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "coverPictureWidth"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTitleContentPropertiesForEditorQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "177df4e8b836b390b9636d650c93a7b2",
            "id": "73afdec0b7224f93dd9771ff4d32ef23242471659162b27d31de856f0e22f612",
            "metadata": {},
            "name": "useTitleContentPropertiesForEditorQuery",
            "operationKind": "query",
            "text": "query useTitleContentPropertiesForEditorQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}}}"
        }
    };
}();
$99e3ac9ccccf9f94$var$node.hash = "cdd7743e3348e4dc97a35c6808323ae0";
var $99e3ac9ccccf9f94$export$2e2bcd8739ae039 = $99e3ac9ccccf9f94$var$node;
module.exports["default"] = $99e3ac9ccccf9f94$export$2e2bcd8739ae039;

});

parcelRegister("j25oo", function(module, exports) {
/**
 * @generated SignedSource<<b0ed3f943392beb78acd9d9ea9b42788>>
 * @relayHash 24201b9545ec89a2ece8511e9a2a8999
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c
const $6b1bc0e8ad61af00$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": true,
        "kind": "LocalArgument",
        "name": "includeContentBody"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "condition": "includeContentBody",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "dynamic",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "representation"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useReadTimeQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "24201b9545ec89a2ece8511e9a2a8999",
            "id": "b3c5854ab0548b89c651d5a1e8fc47a2aa65f94c49e96a88597856cd78fc203c",
            "metadata": {},
            "name": "useReadTimeQuery",
            "operationKind": "query",
            "text": "query useReadTimeQuery($contentId:ID,$status:[String],$includeContentBody:Boolean=true){content(id:$contentId,status:$status){nodes{id,type,body@include(if:$includeContentBody){dynamic{value,representation}},operations{operation,targetType}}}}"
        }
    };
}();
$6b1bc0e8ad61af00$var$node.hash = "1de89fa5a6335c6c91c524557c055ef1";
var $6b1bc0e8ad61af00$export$2e2bcd8739ae039 = $6b1bc0e8ad61af00$var$node;
module.exports["default"] = $6b1bc0e8ad61af00$export$2e2bcd8739ae039;

});

parcelRegister("grd6j", function(module, exports) {
/**
 * @generated SignedSource<<eff7d44a3c3325ad9844d6a92fba38bc>>
 * @relayHash f812791104b0d3338eca867ab249c516
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a655ee1f977a9f534301bf4073cd137e9afcf643751bd79aaaac4c541f973511
const $634ac6ca07897c3c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "ContentBodyPerRepresentation",
                            "kind": "LinkedField",
                            "name": "body",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentBody",
                                    "kind": "LinkedField",
                                    "name": "dynamic",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "representation"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BylinePageAdfQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BylinePageAdfQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f812791104b0d3338eca867ab249c516",
            "id": "a655ee1f977a9f534301bf4073cd137e9afcf643751bd79aaaac4c541f973511",
            "metadata": {},
            "name": "BylinePageAdfQuery",
            "operationKind": "query",
            "text": "query BylinePageAdfQuery($contentId:ID,$status:[String]){content(id:$contentId,status:$status){nodes{id,body{dynamic{value,representation}}}}}"
        }
    };
}();
$634ac6ca07897c3c$var$node.hash = "71971ced9613217ef152b156007bcf74";
var $634ac6ca07897c3c$export$2e2bcd8739ae039 = $634ac6ca07897c3c$var$node;
module.exports["default"] = $634ac6ca07897c3c$export$2e2bcd8739ae039;

});

parcelRegister("jGizm", function(module, exports) {

var $2zscg = parcelRequire("2zscg");

const $04d4b8463fee3aa7$var$extensionCache = new WeakMap();
const $04d4b8463fee3aa7$var$isStringArray = (value)=>Array.isArray(value) && value.every((item)=>typeof item === 'string');
/**
 * Most property values (`title`, `key`, `type`, `resource`, `icon`, …) are plain strings
 * rather than JSON, so parsing them unconditionally throws for the majority of the list —
 * around 1,100 caught `SyntaxError`s per pass on a real 143-app payload, which dominates
 * the transform.
 *
 * A JSON document can only open as an object, array, string or number, or be one of the
 * three bare literals. Anything else would have thrown and fallen back to the raw string,
 * so skipping the parse is equivalent.
 *
 * Property values that are not strings are kept verbatim for the same reason: stringifying
 * them for `JSON.parse` throws for anything but a bare literal, so the raw value survives.
 */ const $04d4b8463fee3aa7$var$canStartJsonDocument = (value)=>{
    const firstCharacter = value[0];
    return firstCharacter === '{' || firstCharacter === '[' || firstCharacter === '"' || firstCharacter === '-' || firstCharacter >= '0' && firstCharacter <= '9' || value === 'true' || value === 'false' || value === 'null';
};
const $04d4b8463fee3aa7$var$normalizeProperties = (properties)=>{
    const normalizedProperties = properties.reduce((acc, property)=>{
        if (!property.value || !property.key) return acc;
        if (typeof property.value !== 'string' || !$04d4b8463fee3aa7$var$canStartJsonDocument(property.value.trim())) {
            acc[property.key] = property.value;
            return acc;
        }
        try {
            const jsonValue = JSON.parse(property.value);
            acc[property.key] = jsonValue;
        } catch (_error) {
            acc[property.key] = property.value;
        }
        return acc;
    }, {});
    if ('migratedFrom' in normalizedProperties && !$04d4b8463fee3aa7$var$isStringArray(normalizedProperties.migratedFrom)) {
        const { migratedFrom: _migratedFrom, ...propertiesWithoutInvalidMigratedFrom } = normalizedProperties;
        return propertiesWithoutInvalidMigratedFrom;
    }
    return normalizedProperties;
};
const $04d4b8463fee3aa7$export$9ff84ea1b2ab439c = (extensions)=>{
    if (!extensions || extensions.length === 0) return [];
    if ($04d4b8463fee3aa7$var$extensionCache.has(extensions)) return $04d4b8463fee3aa7$var$extensionCache.get(extensions);
    const result = (extensions || []).flatMap((extension)=>{
        if (!extension) return [];
        if (!extension.environmentKey) return [];
        return [
            {
                id: extension.id,
                appId: extension.appId,
                key: extension.key,
                environmentId: extension.environmentId,
                environmentType: extension.environmentType === (0, $2zscg.ExtensionEnvironment).DEVELOPMENT || extension.environmentType === (0, $2zscg.ExtensionEnvironment).STAGING || extension.environmentType === (0, $2zscg.ExtensionEnvironment).PRODUCTION ? extension.environmentType : (0, $2zscg.ExtensionEnvironment).DEVELOPMENT,
                environmentKey: extension.environmentKey,
                properties: $04d4b8463fee3aa7$var$normalizeProperties(extension.properties),
                license: extension.license ? {
                    ...extension.license,
                    capabilitySet: $04d4b8463fee3aa7$var$mapCapabilitySet(extension.license.capabilitySet)
                } : null,
                userAccess: extension.userAccess ? {
                    hasAccess: extension.userAccess.hasAccess ?? false,
                    enabled: extension.userAccess.enabled ?? false
                } : null,
                type: extension.type,
                installationId: extension.installationId,
                appVersion: extension.appVersion ?? undefined,
                consentUrl: extension.consentUrl ?? undefined,
                remoteInstallationRegion: extension.remoteInstallationRegion ?? undefined,
                migrationKey: extension.migrationKey ?? undefined,
                egress: extension.egress?.flatMap((egress)=>{
                    if (!egress.type || !egress.addresses) return [];
                    return [
                        {
                            type: egress.type,
                            addresses: egress.addresses?.flatMap((address)=>address ?? []),
                            category: egress.category ?? undefined,
                            inScopeEUD: egress.inScopeEUD ?? undefined
                        }
                    ];
                }) ?? undefined,
                sandboxPolicies: extension.sandboxPolicies ?? undefined,
                scopes: extension.scopes ?? undefined,
                installationConfig: extension.installationConfig?.flatMap((config)=>{
                    if (!config?.key || config.value === null) return [];
                    return [
                        {
                            key: config.key,
                            value: config.value
                        }
                    ];
                }) ?? undefined,
                dataClassificationPolicyDecision: {
                    status: extension.hiddenBy === 'APP_ACCESS_RULES' ? 'BLOCKED' : 'ALLOWED'
                }
            }
        ];
    });
    const IS_TESTING_ENV = false;
    if (!IS_TESTING_ENV) $04d4b8463fee3aa7$var$extensionCache.set(extensions, result);
    return result;
};
const $04d4b8463fee3aa7$var$mapCapabilitySet = (capabilitySet)=>{
    switch(capabilitySet){
        case 'CAPABILITY_ADVANCED':
            return 'capabilityAdvanced';
        default:
            return 'capabilityStandard';
    }
};
module.exports["transformPreFilteredExtensions"] = $04d4b8463fee3aa7$export$9ff84ea1b2ab439c;

});

parcelRegister("2zscg", function(module, exports) {
var $a413c718e4c7bf40$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $a413c718e4c7bf40$export$9a2372818e2520c6 = {
    ATTACHMENT_ACTION: 'confluence:attachmentAction',
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    FULL_PAGE: 'confluence:fullPage',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $a413c718e4c7bf40$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    FULL_PAGE: 'jira:fullPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
const $a413c718e4c7bf40$export$586232a3e4271798 = {
    CUSTOM_MERGE_CHECK: 'bitbucket:mergeCheck',
    DYNAMIC_PIPELINES_PROVIDER: 'bitbucket:dynamicPipelinesProvider',
    REPOSITORY_CODE_FILE_VIEWER: 'bitbucket:repoCodeFileViewer',
    REPOSITORY_CODE_OVERVIEW_CARD: 'bitbucket:repoCodeOverviewCard',
    REPOSITORY_CODE_OVERVIEW_ACTION: 'bitbucket:repoCodeOverviewAction',
    REPOSITORY_CODE_OVERVIEW_PANEL: 'bitbucket:repoCodeOverviewPanel',
    REPOSITORY_PULL_REQUEST_CARD: 'bitbucket:repoPullRequestCard',
    REPOSITORY_PULL_REQUEST_ACTION: 'bitbucket:repoPullRequestAction',
    REPOSITORY_PULL_REQUEST_OVERVIEW_PANEL: 'bitbucket:repoPullRequestOverviewPanel',
    REPOSITORY_MAIN_MENU_PAGE: 'bitbucket:repoMainMenuPage',
    REPOSITORY_SETTINGS_MENU_PAGE: 'bitbucket:repoSettingsMenuPage',
    PROJECT_SETTINGS_MENU_PAGE: 'bitbucket:projectSettingsMenuPage',
    WORKSPACE_GLOBAL_PAGE: 'bitbucket:workspaceGlobalPage',
    WORKSPACE_PERSONAL_SETTINGS_PAGE: 'bitbucket:workspacePersonalSettingsPage',
    WORKSPACE_SETTINGS_MENU_PAGE: 'bitbucket:workspaceSettingsMenuPage'
};
const $a413c718e4c7bf40$export$ffcb70f38ee10c0a = {
    FULL_PAGE: 'global:fullPage',
    GLOBAL_UI: 'global:ui'
};
module.exports["ExtensionEnvironment"] = $a413c718e4c7bf40$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $a413c718e4c7bf40$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $a413c718e4c7bf40$export$f06ffa3aa6bfec95;
module.exports["BitbucketExtension"] = $a413c718e4c7bf40$export$586232a3e4271798;
module.exports["GlobalExtension"] = $a413c718e4c7bf40$export$ffcb70f38ee10c0a;

});

parcelRegister("iZ7G7", function(module, exports) {
// Maximum number of JSON.parse iterations to apply to a stringified document.
// In practice the wire shape is at most double-encoded, so 3 iterations gives
// us headroom while still bounding the loop.
const $aa12c5a22e7258c3$var$MAX_DOCUMENT_DECODE_PASSES = 3;
const $aa12c5a22e7258c3$export$c237b35d986a7858 = (document)=>{
    if (document == null) return null;
    let candidate = document;
    for(let pass = 0; pass < $aa12c5a22e7258c3$var$MAX_DOCUMENT_DECODE_PASSES; pass++){
        if (typeof candidate !== 'string') break;
        try {
            candidate = JSON.parse(candidate);
        } catch  {
            return null;
        }
    }
    // Still a string after exhausting all decode passes, or resolved to a
    // non-object primitive (number, boolean, null, etc.) — give up.
    if (typeof candidate !== 'object' || candidate === null) return null;
    return candidate;
};
const $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult = new WeakMap();
const $aa12c5a22e7258c3$export$867137d201e5eab4 = (collabDraftResult)=>{
    if (!collabDraftResult || typeof collabDraftResult !== 'object') return null;
    if ($aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.has(collabDraftResult)) return $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.get(collabDraftResult) ?? null;
    const parsedAdf = $aa12c5a22e7258c3$export$c237b35d986a7858(collabDraftResult.data?.collabDraft?.document);
    $aa12c5a22e7258c3$var$parsedAdfByCollabDraftResult.set(collabDraftResult, parsedAdf);
    return parsedAdf;
};
module.exports["decodeCollabDraftDocument"] = $aa12c5a22e7258c3$export$c237b35d986a7858;
module.exports["parseCollabDraftAdf"] = $aa12c5a22e7258c3$export$867137d201e5eab4;

});

parcelRegister("ceVeI", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $c9f3102bc65ac225$export$2512ab5eef87236d = [
    'attachments',
    'blog-posts',
    'change-history',
    'contributors',
    'detailssummary',
    'iframe',
    'include',
    'pagetree',
    'pagetreesearch',
    'profile',
    'profile-picture',
    'recently-updated',
    'viewpdf',
    'viewxls',
    'widget',
    'contentbylabel',
    'listlabels',
    'popular-labels',
    'tasks-report-macro'
];
const $c9f3102bc65ac225$var$getExperimentValue = (extensionKey)=>{
    switch(extensionKey){
        case 'contributors':
            return (0, $6mKj3.expValEquals)('cc_rewrite_contributors_legacy_macro', 'isEnabled', true);
        case 'blog-posts':
        case 'change-history':
        case 'contentbylabel':
        case 'detailssummary':
        case 'iframe':
        case 'include':
        case 'popular-labels':
        case 'profile':
        case 'profile-picture':
        case 'viewxls':
        case 'viewpdf':
        case 'widget':
            return true;
        case 'listlabels':
            return (0, $6mKj3.expValEquals)('cc_rewrite_listlabels_legacy_macro', 'isEnabled', true);
        case 'pagetree':
            return (0, $6mKj3.expValEquals)('cc_rewrite_pagetree_legacy_macro', 'isEnabled', true);
        case 'pagetreesearch':
            return true;
        case 'recently-updated':
            return (0, $6mKj3.expValEquals)('cc_rewrite_recently_updated_legacy_macro', 'isEnabled', true);
        case 'attachments':
            return (0, $6mKj3.expValEquals)('cc_rewrite_attachments_legacy_macro', 'isEnabled', true);
        case 'tasks-report-macro':
            return (0, $6mKj3.expValEquals)('cc_rewrite_tasks_report_macro', 'isEnabled', true);
        default:
            return false;
    }
};
const $c9f3102bc65ac225$var$isMigratedMacroExtensionKey = (key)=>$c9f3102bc65ac225$export$2512ab5eef87236d.includes(key);
const $c9f3102bc65ac225$export$95a5e4cb1c9fae51 = (extensionKey)=>{
    const overrideList = (0, $1xpoY.default).getStringList('cc_macro_override_to_legacy_renderer', []);
    if (overrideList.includes(extensionKey)) return false;
    if (!$c9f3102bc65ac225$var$isMigratedMacroExtensionKey(extensionKey)) return false;
    return $c9f3102bc65ac225$var$getExperimentValue(extensionKey);
};
module.exports["MIGRATED_MACRO_EXTENSION_KEYS"] = $c9f3102bc65ac225$export$2512ab5eef87236d;
module.exports["isMigratedMacroImplEnabled"] = $c9f3102bc65ac225$export$95a5e4cb1c9fae51;

});

parcelRegister("eZ4zi", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dce38ffecfe5cc1b$var$MINUTE = 60000;
const $dce38ffecfe5cc1b$var$HOUR = 3600000;
const $dce38ffecfe5cc1b$var$DAY = 86400000;
const $dce38ffecfe5cc1b$var$WEEK = 604800000;
const $dce38ffecfe5cc1b$var$MONTH = 2592000000;
const $dce38ffecfe5cc1b$var$YEAR = 31536000000;
const $dce38ffecfe5cc1b$export$5a00511f040384d7 = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    minute: '2-digit'
});
const $dce38ffecfe5cc1b$export$406508d2ca449bd = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
});
const $dce38ffecfe5cc1b$export$d2d0bf9c4d577e53 = (0, $kSwu1.defineMessages)({
    justNow: {
        id: "macro-utils.relative-time-just-now",
        defaultMessage: "just now"
    },
    minutesAgo: {
        id: "macro-utils.relative-time-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    hoursAgo: {
        id: "macro-utils.relative-time-hours-ago",
        defaultMessage: "{hourCount, plural, one {{hourCount} hour ago} other {{hourCount} hours ago}}"
    },
    daysAgo: {
        id: "macro-utils.relative-time-days-ago",
        defaultMessage: "{dayCount, plural, one {{dayCount} day ago} other {{dayCount} days ago}}"
    },
    weeksAgo: {
        id: "macro-utils.relative-time-weeks-ago",
        defaultMessage: "{weekCount, plural, one {{weekCount} week ago} other {{weekCount} weeks ago}}"
    },
    monthsAgo: {
        id: "macro-utils.relative-time-months-ago",
        defaultMessage: "{monthCount, plural, one {{monthCount} month ago} other {{monthCount} months ago}}"
    },
    yearsAgo: {
        id: "macro-utils.relative-time-years-ago",
        defaultMessage: "{yearCount, plural, one {{yearCount} year ago} other {{yearCount} years ago}}"
    },
    justAMomentAgo: {
        id: "macro-utils.relative-time-just-a-moment-ago",
        defaultMessage: "just a moment ago"
    },
    lessThanAMinuteAgo: {
        id: "macro-utils.relative-time-less-than-a-minute-ago",
        defaultMessage: "less than a minute ago"
    },
    aMinuteAgo: {
        id: "macro-utils.relative-time-a-minute-ago",
        defaultMessage: "a minute ago"
    },
    contentReportMinutesAgo: {
        id: "macro-utils.content-report-minutes-ago",
        defaultMessage: "{minuteCount, plural, one {{minuteCount} minute ago} other {{minuteCount} minutes ago}}"
    },
    aboutAnHourAgo: {
        id: "macro-utils.relative-time-about-an-hour-ago",
        defaultMessage: "about an hour ago"
    },
    contentReportHoursAgo: {
        id: "macro-utils.content-report-hours-ago",
        defaultMessage: "{hourCount, plural, one {about {hourCount} hour ago} other {about {hourCount} hours ago}}"
    },
    yesterdayAt: {
        id: "macro-utils.relative-time-yesterday-at",
        defaultMessage: "yesterday at {time}"
    }
});
const $dce38ffecfe5cc1b$var$formatBucketMessage = (bucket, diffMs, intl)=>{
    if (bucket.valueName && bucket.unitMs) {
        const count = bucket.countCalculator ? bucket.countCalculator(diffMs) : Math.floor(diffMs / bucket.unitMs);
        return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message], {
            [bucket.valueName]: count
        });
    }
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53[bucket.message]);
};
const $dce38ffecfe5cc1b$export$bfc1ce7d5853041b = {
    buckets: [
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'justNow'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$HOUR,
            message: 'minutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'hoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$WEEK,
            message: 'daysAgo',
            valueName: 'dayCount',
            unitMs: $dce38ffecfe5cc1b$var$DAY
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MONTH,
            message: 'weeksAgo',
            valueName: 'weekCount',
            unitMs: $dce38ffecfe5cc1b$var$WEEK
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$YEAR,
            message: 'monthsAgo',
            valueName: 'monthCount',
            unitMs: $dce38ffecfe5cc1b$var$MONTH
        },
        {
            maxDiffMs: Number.POSITIVE_INFINITY,
            message: 'yearsAgo',
            valueName: 'yearCount',
            unitMs: $dce38ffecfe5cc1b$var$YEAR
        }
    ]
};
const $dce38ffecfe5cc1b$export$409646d2c0c56892 = {
    buckets: [
        {
            maxDiffMs: 4000,
            message: 'justAMomentAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$MINUTE,
            message: 'lessThanAMinuteAgo'
        },
        {
            maxDiffMs: 2 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aMinuteAgo'
        },
        {
            maxDiffMs: 50 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'contentReportMinutesAgo',
            valueName: 'minuteCount',
            unitMs: $dce38ffecfe5cc1b$var$MINUTE,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$MINUTE)
        },
        {
            maxDiffMs: 90 * $dce38ffecfe5cc1b$var$MINUTE,
            message: 'aboutAnHourAgo'
        },
        {
            maxDiffMs: $dce38ffecfe5cc1b$var$DAY,
            message: 'contentReportHoursAgo',
            valueName: 'hourCount',
            unitMs: $dce38ffecfe5cc1b$var$HOUR,
            countCalculator: (diffMs)=>Math.round(diffMs / $dce38ffecfe5cc1b$var$HOUR)
        }
    ],
    specialCase: ({ timestampMs: timestampMs, nowMs: nowMs, diffMs: diffMs, intl: intl })=>{
        const savedTime = new Date(timestampMs);
        const now = new Date(nowMs);
        if ($dce38ffecfe5cc1b$export$221990270ebfe867(savedTime, now) && diffMs > 5 * $dce38ffecfe5cc1b$var$HOUR) return $dce38ffecfe5cc1b$export$fc16bfc40f160b09(savedTime, intl);
        return null;
    },
    fallback: ({ timestampMs: timestampMs })=>$dce38ffecfe5cc1b$export$359f3c271cd167e3(new Date(timestampMs))
};
const $dce38ffecfe5cc1b$export$e22324fe17cb0dfe = (timestamp, intl, config)=>{
    const nowMs = Date.now();
    const diffMs = nowMs - timestamp;
    if (config.specialCase) {
        const specialResult = config.specialCase({
            timestampMs: timestamp,
            nowMs: nowMs,
            diffMs: diffMs,
            intl: intl
        });
        if (specialResult !== null) return specialResult;
    }
    for (const bucket of config.buckets){
        if (diffMs < bucket.maxDiffMs) return $dce38ffecfe5cc1b$var$formatBucketMessage(bucket, diffMs, intl);
    }
    if (config.fallback) return config.fallback({
        timestampMs: timestamp,
        nowMs: nowMs,
        diffMs: diffMs,
        intl: intl
    });
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
};
const $dce38ffecfe5cc1b$export$493c11ff22f45a24 = (timestamp, intl)=>{
    const now = Date.now();
    const diff = now - timestamp;
    if (diff < $dce38ffecfe5cc1b$var$MINUTE) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.justNow);
    else if (diff < $dce38ffecfe5cc1b$var$HOUR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.minutesAgo, {
        minuteCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MINUTE)
    });
    else if (diff < $dce38ffecfe5cc1b$var$DAY) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.hoursAgo, {
        hourCount: Math.floor(diff / $dce38ffecfe5cc1b$var$HOUR)
    });
    else if (diff < $dce38ffecfe5cc1b$var$WEEK) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.daysAgo, {
        dayCount: Math.floor(diff / $dce38ffecfe5cc1b$var$DAY)
    });
    else if (diff < $dce38ffecfe5cc1b$var$MONTH) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.weeksAgo, {
        weekCount: Math.floor(diff / $dce38ffecfe5cc1b$var$WEEK)
    });
    else if (diff < $dce38ffecfe5cc1b$var$YEAR) return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.monthsAgo, {
        monthCount: Math.floor(diff / $dce38ffecfe5cc1b$var$MONTH)
    });
    else return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yearsAgo, {
        yearCount: Math.floor(diff / $dce38ffecfe5cc1b$var$YEAR)
    });
};
const $dce38ffecfe5cc1b$export$221990270ebfe867 = (date, now)=>{
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    return yesterday.toLocaleDateString() === date.toLocaleDateString();
};
const $dce38ffecfe5cc1b$export$fc16bfc40f160b09 = (date, intl)=>{
    return intl.formatMessage($dce38ffecfe5cc1b$export$d2d0bf9c4d577e53.yesterdayAt, {
        time: $dce38ffecfe5cc1b$export$5a00511f040384d7.format(date)
    });
};
const $dce38ffecfe5cc1b$export$359f3c271cd167e3 = (date)=>{
    return $dce38ffecfe5cc1b$export$406508d2ca449bd.format(date);
};
const $dce38ffecfe5cc1b$export$505b35374c01d686 = (timestamp, intl)=>{
    return $dce38ffecfe5cc1b$export$e22324fe17cb0dfe(timestamp, intl, $dce38ffecfe5cc1b$export$409646d2c0c56892);
};
module.exports["getRelativeTime"] = $dce38ffecfe5cc1b$export$493c11ff22f45a24;
module.exports["formatContentReportEpochTime"] = $dce38ffecfe5cc1b$export$505b35374c01d686;

});

parcelRegister("oDAuM", function(module, exports) {
/**
 * @generated SignedSource<<1c0c89d79fe77d1b063869de36dc5dd5>>
 * @relayHash 29bcc67d3111f4f97c3c431cc81c9399
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53
const $8e0b9375d7694fe5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "29bcc67d3111f4f97c3c431cc81c9399",
            "id": "e6bb19ae6a019c7084d957bb2ca18f4a8866b288d1764e44f293dc9cd1f7ff53",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByIdQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByIdQuery($contentId:ID!){singleContent(id:$contentId){id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}"
        }
    };
}();
$8e0b9375d7694fe5$var$node.hash = "983fd7d5b2c3bedd36acf332a4d2a21e";
var $8e0b9375d7694fe5$export$2e2bcd8739ae039 = $8e0b9375d7694fe5$var$node;
module.exports["default"] = $8e0b9375d7694fe5$export$2e2bcd8739ae039;

});

parcelRegister("7AKam", function(module, exports) {
/**
 * @generated SignedSource<<1bce5b35349cd4550da965c94478b555>>
 * @relayHash 8f72766dbc3288a69e1f166ec6dfe741
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0
const $74df5cfe1a2e5d0a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogSpaceKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "blogTitle"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeBlog"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeRaw"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeSplit"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "postingDay"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawSpaceKey"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "rawTitle"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitSpaceKey"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "splitTitle"
    }, v10 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v11 = {
        "kind": "Literal",
        "name": "type",
        "value": "page"
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v12 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v12 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v14 = [
        {
            "condition": "includeRaw",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "rawContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "rawSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "rawTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeSplit",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "splitContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "splitSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "splitTitle"
                        },
                        v11 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        },
        {
            "condition": "includeBlog",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "blogContent",
                    "args": [
                        v10 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "postingDay",
                            "variableName": "postingDay"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "blogSpaceKey"
                        },
                        {
                            "kind": "Variable",
                            "name": "title",
                            "variableName": "blogTitle"
                        },
                        {
                            "kind": "Literal",
                            "name": "type",
                            "value": "blogpost"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": v13 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v3 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v4 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "selections": v14 /*: any*/ 
        },
        "params": {
            "cacheID": "8f72766dbc3288a69e1f166ec6dfe741",
            "id": "4236b4cf1f397110e6c228b217491c94eb02fc762436d65d8a1a2ac4ef224bd0",
            "metadata": {},
            "name": "usePageIncludeMacroQueryByTitleQuery",
            "operationKind": "query",
            "text": "query usePageIncludeMacroQueryByTitleQuery($rawSpaceKey:String!,$rawTitle:String!,$includeRaw:Boolean!,$splitSpaceKey:String!,$splitTitle:String!,$includeSplit:Boolean!,$blogSpaceKey:String!,$blogTitle:String!,$postingDay:String!,$includeBlog:Boolean!){rawContent:content(spaceKey:$rawSpaceKey,title:$rawTitle,type:\"page\",first:1)@include(if:$includeRaw){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},splitContent:content(spaceKey:$splitSpaceKey,title:$splitTitle,type:\"page\",first:1)@include(if:$includeSplit){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}},blogContent:content(spaceKey:$blogSpaceKey,title:$blogTitle,type:\"blogpost\",postingDay:$postingDay,first:1)@include(if:$includeBlog){nodes{id,title,type,space{key,id},body{atlas_doc_format{value,mediaToken{token}}}}}}"
        }
    };
}();
$74df5cfe1a2e5d0a$var$node.hash = "f95c0a76906580963b7866b01f678dd2";
var $74df5cfe1a2e5d0a$export$2e2bcd8739ae039 = $74df5cfe1a2e5d0a$var$node;
module.exports["default"] = $74df5cfe1a2e5d0a$export$2e2bcd8739ae039;

});

parcelRegister("6K7Y4", function(module, exports) {
const $397b91bd2abb6c3a$export$bcd93dab64989992 = (macroParams)=>{
    const referencedContentId = macroParams?.['_referencedContentId']?.value ?? null;
    const parentId = macroParams?.['_parentId']?.value ?? null;
    // 1. Modern typed parameter (key is "")
    const typedValue = macroParams?.['']?.value?.trim();
    if (typedValue) return {
        location: typedValue,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // 2. Legacy pageTitle (takes precedence over "0")
    const pageTitle = macroParams?.['pageTitle']?.value?.trim();
    if (pageTitle) {
        const spaceKey = macroParams?.['spaceKey']?.value?.trim();
        const location = spaceKey ? `${spaceKey}:${pageTitle}` : pageTitle;
        return {
            location: location,
            referencedContentId: referencedContentId,
            parentId: parentId,
            error: null
        };
    }
    // 3. Legacy untyped default parameter "0"
    const legacyDefault = macroParams?.['0']?.value?.trim();
    if (legacyDefault) return {
        location: legacyDefault,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: null
    };
    // No target configured
    return {
        location: null,
        referencedContentId: referencedContentId,
        parentId: parentId,
        error: 'missing-target'
    };
};
const $397b91bd2abb6c3a$var$extractContentIdFromTypedValue = (value)=>{
    const match = value.match(/confluence-content:\/\/[^/]+\/(\d+)/);
    return match ? match[1] : null;
};
const $397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX = /^(?:([\w]+):)?\/(\d{4}\/\d{2}\/\d{2})\/(.+)$/;
const $397b91bd2abb6c3a$var$isValidSpaceKey = (spaceKey)=>{
    if (!spaceKey) return false;
    if (spaceKey.startsWith('~')) return true;
    return spaceKey.length <= 255 && /^[A-Za-z0-9]+$/.test(spaceKey);
};
const $397b91bd2abb6c3a$var$parseSplitPageCandidate = (location)=>{
    const colonIdx = location.indexOf(':');
    if (colonIdx < 0) return null;
    const spaceKey = location.slice(0, colonIdx);
    const title = location.slice(colonIdx + 1);
    if (!$397b91bd2abb6c3a$var$isValidSpaceKey(spaceKey) || title.startsWith(' ')) return null;
    return {
        spaceKey: spaceKey,
        title: title
    };
};
const $397b91bd2abb6c3a$var$parseBlogPostCandidate = (location, hostSpaceKey)=>{
    const match = location.match($397b91bd2abb6c3a$var$BLOG_POST_LINK_REGEX);
    if (!match) return null;
    const spaceKey = match[1] || hostSpaceKey;
    const postingDay = match[2].replace(/\//g, '-');
    const title = match[3];
    if (!spaceKey || !title) return null;
    return {
        spaceKey: spaceKey,
        title: title,
        postingDay: postingDay
    };
};
const $397b91bd2abb6c3a$export$fc5689613a273ab4 = (parsedTarget, hostSpaceKey)=>{
    if (!parsedTarget.location) return {
        kind: 'missing-target'
    };
    const idFromTyped = $397b91bd2abb6c3a$var$extractContentIdFromTypedValue(parsedTarget.location);
    if (idFromTyped) return {
        kind: 'by-id',
        variables: {
            contentId: idFromTyped
        }
    };
    if (parsedTarget.referencedContentId) return {
        kind: 'by-id',
        variables: {
            contentId: parsedTarget.referencedContentId
        }
    };
    const rawTitle = parsedTarget.location.trim();
    if (!rawTitle) return {
        kind: 'missing-target'
    };
    const splitPageCandidate = $397b91bd2abb6c3a$var$parseSplitPageCandidate(rawTitle);
    const blogPostCandidate = $397b91bd2abb6c3a$var$parseBlogPostCandidate(rawTitle, hostSpaceKey);
    const includeRaw = !!hostSpaceKey;
    if (!includeRaw && !splitPageCandidate && !blogPostCandidate) return {
        kind: 'missing-target'
    };
    return {
        kind: 'by-title',
        variables: {
            rawSpaceKey: hostSpaceKey ?? '',
            rawTitle: rawTitle,
            includeRaw: includeRaw,
            splitSpaceKey: splitPageCandidate?.spaceKey ?? '',
            splitTitle: splitPageCandidate?.title ?? '',
            includeSplit: !!splitPageCandidate,
            blogSpaceKey: blogPostCandidate?.spaceKey ?? '',
            blogTitle: blogPostCandidate?.title ?? '',
            postingDay: blogPostCandidate?.postingDay ?? '',
            includeBlog: !!blogPostCandidate
        }
    };
};
module.exports["parseMacroTarget"] = $397b91bd2abb6c3a$export$bcd93dab64989992;
module.exports["getPageIncludeQueryTarget"] = $397b91bd2abb6c3a$export$fc5689613a273ab4;

});

parcelRegister("3WQHM", function(module, exports) {
/**
 * @generated SignedSource<<0c8b120265868469c872ead7875cb67b>>
 * @relayHash b8d282756f8605833c15b98740640b7c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6056e7251c0f692cdb55af4a64b43ea0ac4323885e99922783306cb737e7d662
const $0db13d9be330dd35$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cqlcontext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        {
            "kind": "Variable",
            "name": "cqlcontext",
            "variableName": "cqlcontext"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "url"
    }, v6 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "kind": "ScalarField",
        "name": "type"
    }, v9 = {
        "kind": "ScalarField",
        "name": "title"
    }, v10 = {
        "kind": "ScalarField",
        "name": "status"
    }, v11 = {
        "kind": "ScalarField",
        "name": "key"
    }, v12 = {
        "kind": "ScalarField",
        "name": "name"
    }, v13 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "kind": "ScalarField",
        "name": "number"
    }, v15 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v16 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v18 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "RecentlyUpdatedMacroQuery",
            "selections": [
                {
                    "alias": "search",
                    "args": v4 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponse",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "Space",
                                            "kind": "LinkedField",
                                            "name": "space",
                                            "plural": false,
                                            "selections": [
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v13 /*: any*/ ,
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "version",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v15 /*: any*/ ,
                                                        v16 /*: any*/ ,
                                                        v17 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v18 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b8d282756f8605833c15b98740640b7c",
            "id": "6056e7251c0f692cdb55af4a64b43ea0ac4323885e99922783306cb737e7d662",
            "metadata": {},
            "name": "RecentlyUpdatedMacroQuery",
            "operationKind": "query",
            "text": "query RecentlyUpdatedMacroQuery($cql:String!,$cqlcontext:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,cqlcontext:$cqlcontext,first:$first,after:$after){nodes{url,lastModified,content{id,type,title,status,space{key,name,id},links{webui},version{number,by{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}},pageInfo{hasNextPage,endCursor}}}"
        }
    };
}();
$0db13d9be330dd35$var$node.hash = "16a339db974455a75784b4ea3351c93b";
var $0db13d9be330dd35$export$2e2bcd8739ae039 = $0db13d9be330dd35$var$node;
module.exports["default"] = $0db13d9be330dd35$export$2e2bcd8739ae039;

});

parcelRegister("8mra2", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $9f74d735080597cb$export$e2092582db731ff4 = 15;
const $9f74d735080597cb$export$31a1864be1d33bad = [
    'page',
    'blogpost',
    'comment',
    'attachment',
    'whiteboard',
    'database',
    'embed',
    'folder'
];
const $9f74d735080597cb$var$TYPE_ALIASES = {
    news: 'blogpost',
    blog: 'blogpost',
    blogs: 'blogpost',
    'blog-post': 'blogpost',
    blogposts: 'blogpost',
    'blog-posts': 'blogpost',
    pages: 'page',
    comments: 'comment',
    attachments: 'attachment'
};
const $9f74d735080597cb$var$SUPPORTED_TYPES = new Set($9f74d735080597cb$export$31a1864be1d33bad);
function $9f74d735080597cb$var$isContentType(type) {
    return $9f74d735080597cb$var$SUPPORTED_TYPES.has(type);
}
function $9f74d735080597cb$var$normalizeType(rawType) {
    const normalized = $9f74d735080597cb$var$TYPE_ALIASES[rawType] ?? rawType;
    return $9f74d735080597cb$var$isContentType(normalized) ? normalized : undefined;
}
function $9f74d735080597cb$var$parseCommaSeparatedValues(value) {
    if (!value) return [];
    const parts = value.split(',');
    const result = [];
    for (const part of parts){
        const trimmed = part.trim();
        if (trimmed.length > 0) result.push(trimmed);
    }
    return result;
}
function $9f74d735080597cb$var$partitionPrefixedValues(values) {
    const result = {
        included: [],
        required: [],
        excluded: []
    };
    for (const value of values){
        if (value.startsWith('+') && value.length > 1) result.required.push(value.slice(1));
        else if (value.startsWith('-') && value.length > 1) result.excluded.push(value.slice(1));
        else result.included.push(value);
    }
    return result;
}
const $9f74d735080597cb$var$SPACE_SCOPE_TOKENS = {
    '@personal': 'space.type = personal',
    '@global': 'space.type != personal'
};
/**
 * CQL predicate for "every space this user can see", used for the `@all` / `*` space params.
 *
 * This MUST be an explicit predicate rather than an omitted space clause. Emitting no space
 * clause produces an unbounded CQL search that diverges from the legacy backend behaviour
 * (which resolved `@all` to the enumerated set of permitted spaces) and renders the macro as
 * an empty "No updates yet" state. See CONFCLOUD-84998.
 */ const $9f74d735080597cb$var$ALL_SPACES_CLAUSE = 'space.type in (global, personal)';
// Match @personal plus @global without enumerating space types, including future types.
const $9f74d735080597cb$var$ALL_SPACE_TYPES_CLAUSE = '(space.type = personal OR space.type != personal)';
/**
 * Resolves the macro `spaces` param into a single CQL space predicate.
 *
 * Always returns a predicate: `buildCql` must never produce a query without a space clause,
 * because an unbounded search does not match the legacy macro behaviour. When the param does
 * not resolve to anything concrete (no param and no host space, or tokens that resolve away)
 * the query falls back to all spaces rather than to an unbounded search.
 */ function $9f74d735080597cb$var$resolveIncludedSpaces(spaceKeys, currentSpaceKey) {
    const resolvedSpaceKeys = [];
    const spaceScopeClauses = new Set();
    let includeFavoriteSpaces = false;
    for (const spaceKey of spaceKeys){
        if (spaceKey === '@all' || spaceKey === '*') return (0, $6mKj3.expValEquals)('confluence_recent_updates_all_space_types', 'isEnabled', true) ? $9f74d735080597cb$var$ALL_SPACE_TYPES_CLAUSE : $9f74d735080597cb$var$ALL_SPACES_CLAUSE;
        if (spaceKey === '@favorite' || spaceKey === '@favourite') {
            includeFavoriteSpaces = true;
            continue;
        }
        if ($9f74d735080597cb$var$SPACE_SCOPE_TOKENS[spaceKey]) {
            spaceScopeClauses.add($9f74d735080597cb$var$SPACE_SCOPE_TOKENS[spaceKey]);
            continue;
        }
        const resolvedSpaceKey = spaceKey === '@self' ? currentSpaceKey : spaceKey;
        if (resolvedSpaceKey) resolvedSpaceKeys.push(resolvedSpaceKey);
    }
    const clauses = [];
    if (resolvedSpaceKeys.length === 1) clauses.push(`space = "${resolvedSpaceKeys[0]}"`);
    else if (resolvedSpaceKeys.length > 1) clauses.push(`space in (${$9f74d735080597cb$var$formatQuotedCqlValues(resolvedSpaceKeys)})`);
    for (const spaceScopeClause of spaceScopeClauses)clauses.push(spaceScopeClause);
    if (includeFavoriteSpaces) clauses.push('space in (favouriteSpaces())');
    return clauses.length > 1 ? `(${clauses.join(' OR ')})` : clauses[0];
}
function $9f74d735080597cb$var$resolveExcludedSpaces(spaceKeys, currentSpaceKey) {
    const excludedSpaceKeys = [];
    const clauses = [];
    for (const spaceKey of spaceKeys){
        if (spaceKey === '@all' || spaceKey === '*') clauses.push((0, $6mKj3.expValEquals)('confluence_recent_updates_all_space_types', 'isEnabled', true) ? `NOT ${$9f74d735080597cb$var$ALL_SPACE_TYPES_CLAUSE}` : 'space.type not in (global, personal)');
        else if (spaceKey === '@self') {
            if (currentSpaceKey) excludedSpaceKeys.push(currentSpaceKey);
        } else if (spaceKey === '@personal') clauses.push('space.type != personal');
        else if (spaceKey === '@global') clauses.push('space.type = personal');
        else if (spaceKey === '@favorite' || spaceKey === '@favourite') clauses.push('space not in (favouriteSpaces())');
        else excludedSpaceKeys.push(spaceKey);
    }
    if (excludedSpaceKeys.length > 0) clauses.unshift(`space not in (${$9f74d735080597cb$var$formatQuotedCqlValues(excludedSpaceKeys)})`);
    return clauses;
}
function $9f74d735080597cb$var$resolveSpaceClause(spaces, currentSpaceKey, enablePrefixedFilters) {
    const configuredSpaceKeys = $9f74d735080597cb$var$parseCommaSeparatedValues(spaces);
    if (configuredSpaceKeys.length === 0) return currentSpaceKey ? `space = "${currentSpaceKey}"` : (0, $6mKj3.expValEquals)('confluence_recent_updates_all_space_types', 'isEnabled', true) ? $9f74d735080597cb$var$ALL_SPACE_TYPES_CLAUSE : $9f74d735080597cb$var$ALL_SPACES_CLAUSE;
    if (!enablePrefixedFilters) return $9f74d735080597cb$var$resolveIncludedSpaces(configuredSpaceKeys, currentSpaceKey) ?? ((0, $6mKj3.expValEquals)('confluence_recent_updates_all_space_types', 'isEnabled', true) ? $9f74d735080597cb$var$ALL_SPACE_TYPES_CLAUSE : $9f74d735080597cb$var$ALL_SPACES_CLAUSE);
    const { included: included, required: required, excluded: excluded } = $9f74d735080597cb$var$partitionPrefixedValues(configuredSpaceKeys);
    const includeClause = $9f74d735080597cb$var$resolveIncludedSpaces(required, currentSpaceKey) ?? $9f74d735080597cb$var$resolveIncludedSpaces(included, currentSpaceKey) ?? ((0, $6mKj3.expValEquals)('confluence_recent_updates_all_space_types', 'isEnabled', true) ? $9f74d735080597cb$var$ALL_SPACE_TYPES_CLAUSE : $9f74d735080597cb$var$ALL_SPACES_CLAUSE);
    const clauses = [
        includeClause,
        ...$9f74d735080597cb$var$resolveExcludedSpaces(excluded, currentSpaceKey)
    ];
    return clauses.length > 1 ? `(${clauses.join(' AND ')})` : clauses[0];
}
function $9f74d735080597cb$var$formatQuotedCqlValues(values) {
    return values.map((v)=>`"${v}"`).join(', ');
}
function $9f74d735080597cb$export$bbd572e80a63521b(max) {
    const parsed = Number(max);
    return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : $9f74d735080597cb$export$e2092582db731ff4;
}
function $9f74d735080597cb$export$6a81e704675faae5(params, spaceClause, enablePrefixedFilters = false) {
    const clauses = [];
    // Content types
    const typeSet = new Set();
    if (params.types) for (const part of $9f74d735080597cb$var$parseCommaSeparatedValues(String(params.types))){
        const normalizedType = $9f74d735080597cb$var$normalizeType(part.toLowerCase());
        if (normalizedType) typeSet.add(normalizedType);
    }
    else for (const t of $9f74d735080597cb$export$31a1864be1d33bad)typeSet.add(t);
    if (typeSet.size > 0) clauses.push(`type in (${[
        ...typeSet
    ].join(', ')})`);
    // Space scope — defaults to the current space
    if (spaceClause) clauses.push(spaceClause);
    // Labels
    if (params.labels) {
        if (enablePrefixedFilters) {
            const { included: included, required: required, excluded: excluded } = $9f74d735080597cb$var$partitionPrefixedValues($9f74d735080597cb$var$parseCommaSeparatedValues(String(params.labels)));
            for (const requiredLabel of required)clauses.push(`label = "${requiredLabel}"`);
            if (included.length > 0) clauses.push(`label in (${$9f74d735080597cb$var$formatQuotedCqlValues(included)})`);
            if (excluded.length > 0) clauses.push(`label not in (${$9f74d735080597cb$var$formatQuotedCqlValues(excluded)})`);
        } else clauses.push(`label in (${$9f74d735080597cb$var$formatQuotedCqlValues($9f74d735080597cb$var$parseCommaSeparatedValues(String(params.labels)))})`);
    }
    // Following users / last modifiers (author param — comma-separated Atlassian account IDs)
    if (params.author) {
        const users = String(params.author).split(',').map((u)=>`"${u.trim()}"`).join(', ');
        // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the feature gate for this change at the developer's request.
        if ((0, $9wGTI.fg)('cc_rewrite_recently_updated_last_modifier')) clauses.push(`lastModifier in (${users})`);
        else clauses.push(`contributor in (${users})`);
    }
    return `${clauses.join(' AND ')} order by lastmodified desc`;
}
function $9f74d735080597cb$export$ae985ad2d8a37df8(params, currentSpaceKey, after = '', enablePrefixedFilters = false) {
    const maxItems = $9f74d735080597cb$export$bbd572e80a63521b(params.max);
    const spaceClause = $9f74d735080597cb$var$resolveSpaceClause(params.spaces, currentSpaceKey, enablePrefixedFilters);
    return {
        cql: $9f74d735080597cb$export$6a81e704675faae5(params, spaceClause, enablePrefixedFilters),
        cqlcontext: '{"contentStatuses":["draft", "current"]}',
        first: maxItems,
        after: after
    };
}
module.exports["buildRecentlyUpdatedQueryVariables"] = $9f74d735080597cb$export$ae985ad2d8a37df8;

});

parcelRegister("30F7c", function(module, exports) {
/**
 * @generated SignedSource<<20904bfa8cc8894f1f41fd4c23de4797>>
 * @relayHash 98854a5bccd4ea4b4cf3114c1778a63a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f4c165001740b0572461dd93e231b3425c566a844e008bc410f5e0b3630c4f05
const $082db8f111d4d391$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        },
        {
            "kind": "ScalarField",
            "name": "isPrimary"
        }
    ], v2 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserEmail",
                    "kind": "LinkedField",
                    "name": "emails",
                    "plural": true,
                    "selections": v1 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "isActive"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useProfileInfoUserContextQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useProfileInfoUserContextQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "98854a5bccd4ea4b4cf3114c1778a63a",
            "id": "f4c165001740b0572461dd93e231b3425c566a844e008bc410f5e0b3630c4f05",
            "metadata": {},
            "name": "useProfileInfoUserContextQuery",
            "operationKind": "query",
            "text": "query useProfileInfoUserContextQuery($userId:ID){user:confluence_atlassianUser(id:$userId){id,photos{value,isPrimary},displayName,emails{value,isPrimary},title,isActive}}"
        }
    };
}();
$082db8f111d4d391$var$node.hash = "cd83aff11b55f855ecd3361dedc3552d";
var $082db8f111d4d391$export$2e2bcd8739ae039 = $082db8f111d4d391$var$node;
module.exports["default"] = $082db8f111d4d391$export$2e2bcd8739ae039;

});

parcelRegister("9OYfw", function(module, exports) {

var $iZ7G7 = parcelRequire("iZ7G7");


var $g6QPm = parcelRequire("g6QPm");


var $6mKj3 = parcelRequire("6mKj3");


var $dYU3e = parcelRequire("dYU3e");


var $l1kdf = parcelRequire("l1kdf");


var $nIvaQ = parcelRequire("nIvaQ");


var $8R0gj = parcelRequire("8R0gj");


var $hNtOj = parcelRequire("hNtOj");


var $27Dus = parcelRequire("27Dus");

function $cb117090d47a4a62$export$1c46f3a5022a1d78(result, draftShareId) {
    return Boolean(result?.errors?.some((err)=>(0, $8R0gj.isDraftSSRPreloadPermissionError)(err?.message))) && // Opening a draft share link grants the user SHARED permission on the BE, but parallel
    // requests can be evaluated before that permission is visible, so a denial here may be a
    // lost race rather than a real restriction. Let the collab connection (which carries the
    // draftShareId) decide instead; a real restriction surfaces as a 403 from NCS.
    !(Boolean(draftShareId) && (0, $6mKj3.expValEquals)('cc_perms_fix_blog_draft_restricted_page_showing', 'isEnabled', true));
}
function $cb117090d47a4a62$export$952cf09a216eb6d(contentId, draftShareId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true,
            ...draftShareId ? {
                draftShareId: draftShareId
            } : undefined
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "load-edit-page"
    }).then(async (result)=>{
        // There is a bug in appolo client (https://github.com/apollographql/react-apollo/issues/3918)
        // that doesn't preserve the result in caches if there is an error in SSR
        // So we need to preserve the error, to be able to verify it later during render phase in SSR
        if ($cb117090d47a4a62$export$1c46f3a5022a1d78(result, draftShareId)) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('edit');
        // There are two reasons to store smart card URLs on the window object:
        // 1. The OTP uses a document snapshot from Confluence that may be outdated and miss recently added or removed smart cards,
        //    so we must reconcile the list of smart cards with the draft content.
        // 2. The draft content stores links with slugs, but the Confluence snapshot does not,
        //    so we need to add slugs sourced from the draft content.
        // Therefore, we extract smart cards from the draft content here, save them on the window object,
        // and later use them to align the Confluence snapshot with the draft content.
        window['__SMART_CARDS_IN_DRAFT__'] = (0, $27Dus.findSmartCardNodesFromDoc)((0, $iZ7G7.parseCollabDraftAdf)(result));
        return result;
    });
}
function $cb117090d47a4a62$export$7c1f00ae06ab82b8(contentId, draftShareId, useCache, status) {
    return (0, $dYU3e.query)({
        query: (0, $l1kdf.NativeCollabQuery),
        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? (0, $g6QPm.createEditorContentUnifiedQueryVariables)({
            contentId: contentId,
            draftShareId: draftShareId,
            status: status
        }) : {
            contentId: contentId,
            ...draftShareId && {
                draftShareId: draftShareId
            },
            status: status ?? [
                'draft',
                'current'
            ]
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        context: {
            single: 'true'
        },
        __callerPackage__: "load-edit-page"
    });
}
module.exports["isCollabDraftPermissionDenied"] = $cb117090d47a4a62$export$1c46f3a5022a1d78;
module.exports["preloadCollabDraftContent"] = $cb117090d47a4a62$export$952cf09a216eb6d;
module.exports["preloadNativeCollab"] = $cb117090d47a4a62$export$7c1f00ae06ab82b8;

});

parcelRegister("l1kdf", function(module, exports) {

var $hrBIS = parcelRequire("hrBIS");

const $c2e596865d8e6fea$export$79b924d780de6f0d = (0, $hrBIS.default);
module.exports["NativeCollabQuery"] = $c2e596865d8e6fea$export$79b924d780de6f0d;

});

parcelRegister("hrBIS", function(module, exports) {
/**
 * @generated SignedSource<<4cf4db12dd73f2ac885d741a3d7c65ba>>
 * @relayHash 4e152ff0861f20bc69927f68972ccc1e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc
const $83575f8369490c15$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "draftShareId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "draftShareId",
            "variableName": "draftShareId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Variable",
            "name": "status",
            "variableName": "status"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "kind": "ScalarField",
        "name": "status"
    }, v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "ncsStepVersion"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v9 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "homepageId"
            }
        ]
    }, v12 = {
        "concreteType": "PaginatedLabelList",
        "kind": "LinkedField",
        "name": "labels",
        "plural": false,
        "selections": [
            {
                "concreteType": "Label",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v2 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "NativeCollabQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v14 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v9 /*: any*/ 
                                    ]
                                },
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "4e152ff0861f20bc69927f68972ccc1e",
            "id": "24bbbff0309d612fd3761eb95cc4e8454341bfb5663a836acebc11c0a54451dc",
            "metadata": {},
            "name": "NativeCollabQuery",
            "operationKind": "query",
            "text": "query NativeCollabQuery($contentId:ID,$draftShareId:String,$status:[String]){content(id:$contentId,draftShareId:$draftShareId,status:$status){nodes{id,type,status,version{number,ncsStepVersion,by{__typename,type,...on KnownUser{accountId}}},history{createdBy{__typename,displayName},createdDate},space{id,name,homepageId},labels{nodes{id,name}},subType}}}"
        }
    };
}();
$83575f8369490c15$var$node.hash = "182a5142c1846497c5e27245efe74033";
var $83575f8369490c15$export$2e2bcd8739ae039 = $83575f8369490c15$var$node;
module.exports["default"] = $83575f8369490c15$export$2e2bcd8739ae039;

});

parcelRegister("27Dus", function(module, exports) {

var $eRwHS = parcelRequire("eRwHS");


var $gVWsk = parcelRequire("gVWsk");


var $6GQtz = parcelRequire("6GQtz");


var $aN0qB = parcelRequire("aN0qB");

function $010c1dfc98319256$export$4d8d014fcb52d0f(doc) {
    if (!(0, $gVWsk.isJSONDocNode)(doc)) return [];
    const cardProvider = new (0, $6GQtz.ConfluenceEditorCardProvider)('custom');
    return (0, $eRwHS.findNodesToPrefetch)(doc, [
        {
            provider: cardProvider,
            maxNodesToPrefetch: (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH).smartCard
        }
    ], (0, $aN0qB.NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT))[0].nodes;
}
module.exports["findSmartCardNodesFromDoc"] = $010c1dfc98319256$export$4d8d014fcb52d0f;

});

parcelRegister("eRwHS", function(module, exports) {
function $d135bda53bcecc47$export$41263783ff0932a8(doc, providers, maxNodesToVisit) {
    // Counter for the total number of visited nodes to limit the traversal.
    let totalVisitedNodesCount = 0;
    // A map to store the results, with the provider name as the key.
    const resultMap = providers.reduce((acc, { provider: provider })=>{
        acc[provider.name] = {
            provider: provider,
            nodes: []
        };
        return acc;
    }, {});
    // It doesn't use `filter` function from `@atlaskit/adf-utils/traverse` because it does not support early stopping.
    // We need to stop traversing when we reach the maximum number of nodes to visit to support large documents.
    // Create a list of providers for which we still need to find nodes.
    const providersToLookup = providers.filter(({ maxNodesToPrefetch: maxNodesToPrefetch })=>maxNodesToPrefetch > 0).map(({ provider: provider, maxNodesToPrefetch: maxNodesToPrefetch })=>({
            provider: provider,
            maxNodesToPrefetch: maxNodesToPrefetch,
            foundNodes: 0
        }));
    // Stack for the depth-first search (DFS), starting with the root document node.
    const nodesToVisit = [
        doc
    ];
    // The loop continues as long as there are nodes to visit, providers to look for,
    // and the visited nodes limit has not been reached.
    while(nodesToVisit.length > 0 && providersToLookup.length > 0 && totalVisitedNodesCount < maxNodesToVisit){
        totalVisitedNodesCount += 1;
        // Pop from the end to maintain DFS order (LIFO - Last In, First Out)
        const currentNode = nodesToVisit.pop();
        if (!currentNode) continue;
        // Using a reverse loop to avoid issues with array mutation (when removing elements).
        for(let i = providersToLookup.length - 1; i >= 0; i--){
            const providerToFind = providersToLookup[i];
            // Check if the current provider supports this node.
            if (providerToFind.provider.isNodeSupported(currentNode)) {
                // If provider supports the node, add it to the result map.
                resultMap[providerToFind.provider.name].nodes.push(currentNode);
                // Increment the count of found nodes for this provider.
                providerToFind.foundNodes += 1;
                // If the provider has found enough nodes, remove it from the lookup list.
                if (providerToFind.foundNodes >= providerToFind.maxNodesToPrefetch) providersToLookup.splice(i, 1);
            }
        }
        // If the current node has children, add them to the stack in reverse order
        // to maintain left-to-right traversal when popping from the stack,
        // because it's LIFO.
        if (currentNode.content) // Push children in reverse order to maintain correct DFS traversal order
        for(let i = currentNode.content.length - 1; i >= 0; i--){
            const node = currentNode.content[i];
            if (node) nodesToVisit.push(node);
        }
    }
    // Return an array of the found nodes, grouped by provider.
    return Object.values(resultMap);
}
module.exports["findNodesToPrefetch"] = $d135bda53bcecc47$export$41263783ff0932a8;

});

parcelRegister("6GQtz", function(module, exports) {

var $6RwwD = parcelRequire("6RwwD");

const $1f40ba7d8e61cd02$var$isTrelloBoardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/b/);
const $1f40ba7d8e61cd02$var$isFigmaFileUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?figma\.com\/(design|board|file|proto|slides)/);
const $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl = (url)=>!!url.match(/^https:\/\/.+\.figma\.site/);
const $1f40ba7d8e61cd02$var$isMiroUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?miro\.com\/app\/board/);
const $1f40ba7d8e61cd02$var$isCanvaUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?canva\.com\/design/);
const $1f40ba7d8e61cd02$var$isLucidUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?lucid\.app\/lucidchart/);
const $1f40ba7d8e61cd02$var$isGoogleSlidesUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/presentation/);
const $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl = (url)=>!!url.match(/^https:\/\/onedrive\.live\.com\/:p/) || !!url.match(/^https:\/\/1drv\.ms\/p/);
const $1f40ba7d8e61cd02$var$isTrelloCardUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?trello\.com\/c/);
const $1f40ba7d8e61cd02$var$isPowerBIUrl = (url)=>!!url.match(/^https:\/\/app\.powerbi\.com\/(groups|reportEmbed)/);
const $1f40ba7d8e61cd02$var$isGoogleDocsUrl = (url)=>!!url.match(/^https:\/\/docs\.google\.com\/document/);
// https://learn.microsoft.com/en-us/onedrive/developer/controls/file-pickers/?view=odsp-graph-online
const $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl = (url)=>!!url.match(/^https:\/\/learn\.microsoft\.com/);
// https://support.google.com/mail/answer/112508?hl=en&co=GENIE.Platform%3DDesktop
const $1f40ba7d8e61cd02$var$isSupportGoogleUrl = (url)=>!!url.match(/^https:\/\/support\.google\.com/);
// https://docs.github.com/en/codespaces
const $1f40ba7d8e61cd02$var$isDocsGithubUrl = (url)=>!!url.match(/^https:\/\/docs\.github\.com/);
const $1f40ba7d8e61cd02$var$isDropboxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?dropbox\.com\/(home|preview|s|sh|sc|t|scl)/);
const $1f40ba7d8e61cd02$var$isBoxUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?box\.com\/(folder|file|notes|integrations|services|s|v)/);
const $1f40ba7d8e61cd02$var$isSlackUrl = (url)=>!!url.match(/^https:\/\/(.*\.)?slack\.com\/(archives|client)/);
const $1f40ba7d8e61cd02$var$isTeamsUrl = (url)=>!!url.match(/^https:\/\/teams\.microsoft\.com\/l\/channel/) || !!url.match(/^https:\/\/teams\.cloud\.microsoft\/l\/channel/);
const $1f40ba7d8e61cd02$var$isLovableAppUrl = (url)=>!!url.match(/^https:\/\/.+\.lovable\.app/);
const $1f40ba7d8e61cd02$var$isReplitAppUrl = (url)=>!!url.match(/^https:\/\/.+\.replit\.app/);
class $1f40ba7d8e61cd02$export$9d24f5da29b1273e extends (0, $6RwwD.EditorCardProvider) {
    getHardCodedAppearance(url) {
        if (this.shouldDisplayAsEmbed(url)) return 'embed';
        if (this.shouldDisplayAsCard(url)) return 'block';
        return super.getHardCodedAppearance(url);
    }
    /**
   * Opt in to honouring an explicitly-requested embed appearance as the default
   * (validated, with a card fallback) for the quick-insert embed flow.
   *
   * The platform only calls this when a link is inserted with a requested embed
   * appearance and the user has no saved preference.
   */ shouldHonorRequestedEmbedAsDefault() {
        return true;
    }
    shouldDisplayAsEmbed(url) {
        return $1f40ba7d8e61cd02$var$isTrelloBoardUrl(url) || $1f40ba7d8e61cd02$var$isFigmaFileUrl(url) || $1f40ba7d8e61cd02$var$isFigmaMakeSiteUrl(url) || $1f40ba7d8e61cd02$var$isMiroUrl(url) || $1f40ba7d8e61cd02$var$isCanvaUrl(url) || $1f40ba7d8e61cd02$var$isLucidUrl(url) || $1f40ba7d8e61cd02$var$isGoogleSlidesUrl(url) || $1f40ba7d8e61cd02$var$isOneDrivePowerPointUrl(url);
    }
    shouldDisplayAsCard(url) {
        return $1f40ba7d8e61cd02$var$isTrelloCardUrl(url) || $1f40ba7d8e61cd02$var$isPowerBIUrl(url) || $1f40ba7d8e61cd02$var$isGoogleDocsUrl(url) || $1f40ba7d8e61cd02$var$isLearnMicrosoftUrl(url) || $1f40ba7d8e61cd02$var$isSupportGoogleUrl(url) || $1f40ba7d8e61cd02$var$isDocsGithubUrl(url) || $1f40ba7d8e61cd02$var$isDropboxUrl(url) || $1f40ba7d8e61cd02$var$isBoxUrl(url) || $1f40ba7d8e61cd02$var$isSlackUrl(url) || $1f40ba7d8e61cd02$var$isTeamsUrl(url) || $1f40ba7d8e61cd02$var$isLovableAppUrl(url) || $1f40ba7d8e61cd02$var$isReplitAppUrl(url);
    }
    constructor(envKey, baseUrlOverride, onResolve, customCardClient, supportedUrlFilter, name){
        super(envKey, baseUrlOverride, 'CONFLUENCE', onResolve, customCardClient, supportedUrlFilter);
        this.name = void 0;
        this.name = name ?? 'editorCardProvider';
    }
}
module.exports["ConfluenceEditorCardProvider"] = $1f40ba7d8e61cd02$export$9d24f5da29b1273e;

});

parcelRegister("aN0qB", function(module, exports) {
// Usually, one screen contains about 2_500 nodes, so 10_000 is more than enough.
const $e5ce665804adc727$export$d723a039341399fc = 10000;
const $e5ce665804adc727$export$109b6787e4cb0d4c = {
    smartCard: 10,
    emoji: 500
};
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT"] = $e5ce665804adc727$export$d723a039341399fc;
module.exports["NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH"] = $e5ce665804adc727$export$109b6787e4cb0d4c;

});

parcelRegister("fExfj", function(module, exports) {

var $92rGz = parcelRequire("92rGz");


var $8FkVw = parcelRequire("8FkVw");

const $6d29423afdca551a$export$eab97d15b1788b8d = $8FkVw;
const $6d29423afdca551a$export$3b4c04cf7dad0e50 = $92rGz;
module.exports["utils"] = $6d29423afdca551a$export$eab97d15b1788b8d;

});

parcelRegister("92rGz", function(module, exports) {

var $1Udvu = parcelRequire("1Udvu");


var $6kV7w = parcelRequire("6kV7w");


var $gG4RG = parcelRequire("gG4RG");


var $4sHaf = parcelRequire("4sHaf");


var $8F9fo = parcelRequire("8F9fo");


var $eCMSo = parcelRequire("eCMSo");

const $feac65a19c55a1da$export$8b13532c81e8ac89 = async (serviceConfig, options = (0, $8F9fo.defaultRequestServiceOptions))=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $4sHaf.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $gG4RG.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $eCMSo.buildCredentials)(secOptions);
    // Get tracing headers from UFO
    const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    const fetchResponse = await fetch(requestUrl, requestOptions);
    const parts = await (0, $1Udvu.meros)(fetchResponse);
    if (fetchResponse.ok && fetchResponse.status !== 204) {
        if (parts[Symbol.asyncIterator] < 'u') // this lets us know that the response is multipart
        //
        // 	((parts as PartsGenerator)[Symbol.asyncIterator] as any) < 'u' came from the `meros` docs:
        //	https://github.com/maraisr/meros/blob/dec4feaa24090b94e8ac42fab1aff38a1e521680/readme.md
        // 	Look for expand section `If the content-type is NOT a multipart, then meros will resolve with the response argument.`
        return {
            isMultipart: true,
            parts: parts
        };
        return {
            isMultipart: false,
            body: await parts.json()
        };
    } else if (fetchResponse.status === 401 && refreshedSecurityProvider) // auth issue - try once
    return refreshedSecurityProvider().then((newSecOptions)=>{
        const retryServiceConfig = {
            url: url,
            securityProvider: ()=>newSecOptions
        };
        return $feac65a19c55a1da$export$8b13532c81e8ac89(retryServiceConfig, options);
    });
    return Promise.reject({
        code: fetchResponse.status,
        reason: fetchResponse.statusText
    });
};
module.exports["requestServiceMultipart"] = $feac65a19c55a1da$export$8b13532c81e8ac89;

});

parcelRegister("1Udvu", function(module, exports) {
async function $16357f97c0090164$export$74e0a034be2368c7(e, t) {
    if (!e.ok || !e.body || e.bodyUsed) return e;
    let n = e.headers.get("content-type");
    if (!n || !~n.indexOf("multipart/")) return e;
    let i = n.indexOf("boundary="), l = "-";
    if (~i) {
        let e = i + 9, t = n.indexOf(";", e);
        l = n.slice(e, t > -1 ? t : void 0).trim().replace(/"/g, "");
    }
    return async function*(e, t, n) {
        let i, l, r, d = new TextDecoder("utf8"), o = e.getReader(), a = !n || !n.multiple, f = t.length, s = "", c = [];
        try {
            let e;
            e: for(; !(e = await o.read()).done;){
                let n = d.decode(e.value, {
                    stream: !0
                });
                i = s.length, s += n;
                let o = n.indexOf(t);
                for(~o ? i += o : i = s.indexOf(t), c = []; ~i;){
                    let e = s.slice(0, i), n = s.slice(i + f);
                    if (l) {
                        let t = e.indexOf("\r\n\r\n") + 4, i = e.lastIndexOf("\r\n", t), l = !1, d = e.slice(t, i > -1 ? void 0 : i), o = String(e.slice(0, t)).trim().split("\r\n"), f = {}, s = o.length;
                        for(; r = o[--s]; r = r.split(": "), f[r.shift().toLowerCase()] = r.join(": "));
                        if (r = f["content-type"], r && ~r.indexOf("application/json")) try {
                            d = JSON.parse(d), l = !0;
                        } catch (e) {}
                        if (r = {
                            headers: f,
                            body: d,
                            json: l
                        }, a ? yield r : c.push(r), "--" === n.slice(0, 2)) break e;
                    } else t = "\r\n" + t, l = f += 2;
                    s = n, i = s.indexOf(t);
                }
                c.length && (yield c);
            }
        } finally{
            c.length && (yield c), await o.cancel();
        }
    }(e.body, `--${l}`, t);
}
module.exports["meros"] = $16357f97c0090164$export$74e0a034be2368c7;

});

parcelRegister("gG4RG", function(module, exports) {
const $e76949c2aa479bf9$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $e76949c2aa479bf9$export$7d6ed858a91629c3 = (secOptions, extraHeaders)=>{
    const headers = {};
    $e76949c2aa479bf9$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $e76949c2aa479bf9$var$addToHeaders(headers, secOptions.headers);
    return headers;
};
module.exports["buildHeaders"] = $e76949c2aa479bf9$export$7d6ed858a91629c3;

});

parcelRegister("4sHaf", function(module, exports) {
const $1060d48a7c3c566e$export$b5cd97dee32de81d = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
module.exports["buildUrl"] = $1060d48a7c3c566e$export$b5cd97dee32de81d;

});

parcelRegister("8F9fo", function(module, exports) {
const $39f3fe1498ecdf1b$export$160dbda113bfad3b = {};
module.exports["defaultRequestServiceOptions"] = $39f3fe1498ecdf1b$export$160dbda113bfad3b;

});

parcelRegister("eCMSo", function(module, exports) {
const $e0f49dd64fe47409$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};
module.exports["buildCredentials"] = $e0f49dd64fe47409$export$2ac26f1ab7eda637;

});

parcelRegister("8FkVw", function(module, exports) {
$parcel$export(module.exports, "extractTracingHeaders", () => (parcelRequire("d42dq")).extractTracingHeaders);
$parcel$export(module.exports, "requestService", () => (parcelRequire("i3nsM")).requestService);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @deprecated Use `import { extractTracingHeaders } from '@atlaskit/util-service-support/extractTracingHeaders'` instead.
 */ 
var $d42dq = parcelRequire("d42dq");


var $i3nsM = parcelRequire("i3nsM");


});

parcelRegister("d42dq", function(module, exports) {
const $4b6ed4b3c47c9806$var$TRACING_RESPONSE_HEADERS = [
    'x-trace-id',
    'atl-request-id'
];
const $4b6ed4b3c47c9806$export$4f34edf253146101 = (response)=>{
    const headers = {};
    for (const name of $4b6ed4b3c47c9806$var$TRACING_RESPONSE_HEADERS){
        const value = response.headers.get(name);
        if (value) headers[name] = value;
    }
    return headers;
};
module.exports["extractTracingHeaders"] = $4b6ed4b3c47c9806$export$4f34edf253146101;

});

parcelRegister("i3nsM", function(module, exports) {

var $6kV7w = parcelRequire("6kV7w");


var $gG4RG = parcelRequire("gG4RG");


var $4sHaf = parcelRequire("4sHaf");


var $d42dq = parcelRequire("d42dq");


var $8F9fo = parcelRequire("8F9fo");


var $eCMSo = parcelRequire("eCMSo");

const $1269a5671963131d$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || (0, $8F9fo.defaultRequestServiceOptions);
    const secOptions = securityProvider && securityProvider();
    const requestUrl = (0, $4sHaf.buildUrl)(url, path, queryParams, secOptions);
    const headers = (0, $gG4RG.buildHeaders)(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $eCMSo.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    // Get tracing headers from UFO
    const tracingHeaders = (0, $6kV7w.getActiveTraceHttpRequestHeaders)(url);
    const requestOptions = {
        ...requestInit,
        // populate headers mainly for the collab provider however
        // other components which uses this util can get the header as well.
        // Those tracing headers shall not incur any issues as long as backends handle them properly
        headers: {
            ...headers,
            ...tracingHeaders
        },
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (options?.reportTracingHeaders) {
            const tracingHeaders = (0, $d42dq.extractTracingHeaders)(response);
            if (Object.keys(tracingHeaders).length > 0) options.reportTracingHeaders(tracingHeaders);
        }
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $1269a5671963131d$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
module.exports["requestService"] = $1269a5671963131d$export$97bfde5a702aaeca;

});

parcelRegister("fh15z", function(module, exports) {

var $3Ww6H = parcelRequire("3Ww6H");


var $cNAch = parcelRequire("cNAch");

class $235e9e63ec7037ae$export$ac1cddfee07ba6ac {
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $cNAch.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $3Ww6H.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
    constructor(experienceId, config){
        this.experienceId = void 0;
        this.config = void 0;
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
}
module.exports["ConcurrentExperience"] = $235e9e63ec7037ae$export$ac1cddfee07ba6ac;

});

parcelRegister("3Ww6H", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $50aee1cd0289a711$export$b4958caff08a0960 = (...args)=>{
    (0, $jmjuG.ufologger).log(...args);
};
module.exports["ufolog"] = $50aee1cd0289a711$export$b4958caff08a0960;

});

parcelRegister("jmjuG", function(module, exports) {
class $fdaa18971c6567c6$var$UFOLogger {
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($fdaa18971c6567c6$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
$fdaa18971c6567c6$var$UFOLogger.UFOprefix = "[ufo\uD83D\uDEF8]";
const $fdaa18971c6567c6$export$4ab84f6f04f6566d = new $fdaa18971c6567c6$var$UFOLogger();
module.exports["ufologger"] = $fdaa18971c6567c6$export$4ab84f6f04f6566d;

});

parcelRegister("cNAch", function(module, exports) {

var $YHNTN = parcelRequire("YHNTN");

class $c65b2e96b7a8c980$export$c00d22927c60484a extends (0, $YHNTN.UFOAbstractExperience) {
}
module.exports["UFOExperience"] = $c65b2e96b7a8c980$export$c00d22927c60484a;

});

parcelRegister("YHNTN", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $dd3JJ = parcelRequire("dd3JJ");


var $gDr1n = parcelRequire("gDr1n");


var $11QNa = parcelRequire("11QNa");


var $i3Cqs = parcelRequire("i3Cqs");


var $8D8OR = parcelRequire("8D8OR");


var $3Ww6H = parcelRequire("3Ww6H");


var $bdTYA = parcelRequire("bdTYA");


var $aNeq3 = parcelRequire("aNeq3");


var $f07wD = parcelRequire("f07wD");


var $e22Cc = parcelRequire("e22Cc");


var $j7Sza = parcelRequire("j7Sza");


var $g8bWJ = parcelRequire("g8bWJ");


var $4MiWC = parcelRequire("4MiWC");


var $DJFHw = parcelRequire("DJFHw");

const $35f46dabe2d905ec$var$getPageVisibleState = ()=>{
    return !(0, $e22Cc.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $f07wD.PageVisibleState).VISIBLE : (0, $f07wD.PageVisibleState).HIDDEN;
};
class $35f46dabe2d905ec$export$d31c89db257648c {
    async transition(newState, timestamp) {
        (0, $3Ww6H.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $g8bWJ.canTransition)(this.state, newState)) {
            (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $j7Sza.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                this.uuid = (0, $03RpJ.default)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = (0, $DJFHw.perfNowOrTimestamp)(timestamp);
                if (!this._isManualStateEnabled()) (0, $11QNa.getGlobalEventStream)().push((0, $8D8OR.unsubscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $3Ww6H.ufolog)('this.parent', this.parent);
                (0, $11QNa.getGlobalEventStream)().push((0, $gDr1n.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $3Ww6H.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $bdTYA.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $j7Sza.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
            (0, $aNeq3.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $3Ww6H.ufolog)('subscribed', this.id);
                (0, $11QNa.getGlobalEventStream)().push((0, $i3Cqs.subscribeEvent)((0, $f07wD.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $f07wD.FMP_MARK) && name !== (0, $f07wD.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $bdTYA.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: (0, $DJFHw.perfNowOrTimestamp)(timestamp)
        });
        this.transition((0, $j7Sza.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $f07wD.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $f07wD.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $bdTYA.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $j7Sza.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $3Ww6H.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $dd3JJ.UFO_EXPERIMENTAL_BUILD_VERSION) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
    constructor(id, config, instanceId = null){
        this.state = (0, $j7Sza.UFOExperienceState).NOT_STARTED;
        this.id = void 0;
        this.instanceId = null;
        // for concurrent
        this.parent = null;
        this.category = null;
        this.type = void 0;
        this.performanceType = void 0;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.featureFlags = void 0;
        this.timings = void 0;
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.handleDoneBind = void 0;
        this.uuid = null;
        this.until = void 0;
        this._until = null;
        this.pageVisibleState = void 0;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.config = void 0;
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $f07wD.PageVisibleState).MIXED;
            (0, $aNeq3.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $35f46dabe2d905ec$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
}
module.exports["UFOAbstractExperience"] = $35f46dabe2d905ec$export$d31c89db257648c;

});

parcelRegister("dd3JJ", function(module, exports) {
// temp solution until we can get it automated
const $79d018f255564301$export$2295b861f318254a = '0.1.5';
module.exports["UFO_EXPERIMENTAL_BUILD_VERSION"] = $79d018f255564301$export$2295b861f318254a;

});

parcelRegister("gDr1n", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $7cdf9804f4fb0f15$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};
module.exports["experiencePayloadEvent"] = $7cdf9804f4fb0f15$export$7c957416596ca127;

});

parcelRegister("f07wD", function(module, exports) {
var $ff3bb8d57004c3c7$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $ff3bb8d57004c3c7$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $ff3bb8d57004c3c7$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $ff3bb8d57004c3c7$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $ff3bb8d57004c3c7$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
const $ff3bb8d57004c3c7$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $ff3bb8d57004c3c7$export$9f2bf58999404c75 = 'fmp';
const $ff3bb8d57004c3c7$export$837e0f79a8056912 = 'inline-response';
module.exports["UFOGlobalEventStreamEventType"] = $ff3bb8d57004c3c7$export$96253c35c37cf96b;
module.exports["PageVisibleState"] = $ff3bb8d57004c3c7$export$a12c67b37a306b13;
module.exports["SUBSCRIBE_ALL"] = $ff3bb8d57004c3c7$export$79bf131685ad41d7;
module.exports["FMP_MARK"] = $ff3bb8d57004c3c7$export$9f2bf58999404c75;
module.exports["INLINE_RESPONSE_MARK"] = $ff3bb8d57004c3c7$export$837e0f79a8056912;

});

parcelRegister("11QNa", function(module, exports) {

var $7Ce5m = parcelRequire("7Ce5m");

const $c1569a93aa4391e4$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < (0, $7Ce5m.MAX_EARLY_QUEUE_LENGTH)) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
module.exports["getGlobalEventStream"] = $c1569a93aa4391e4$export$6123a44dc2384540;

});

parcelRegister("7Ce5m", function(module, exports) {
const $0cc5590ab6f8b46e$export$d8b468db8a225bc9 = 250;
module.exports["MAX_EARLY_QUEUE_LENGTH"] = $0cc5590ab6f8b46e$export$d8b468db8a225bc9;

});

parcelRegister("i3Cqs", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $a239602ece96b732$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["subscribeEvent"] = $a239602ece96b732$export$37863216db4b714d;

});

parcelRegister("8D8OR", function(module, exports) {

var $f07wD = parcelRequire("f07wD");

const $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $f07wD.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
module.exports["unsubscribeEvent"] = $0a3f0389a9961f72$export$ee1a7bd1fc9ea85e;

});

parcelRegister("bdTYA", function(module, exports) {

var $jmjuG = parcelRequire("jmjuG");

const $5c1c0b03503ca679$export$d53d07b6034c4560 = (...args)=>{
    (0, $jmjuG.ufologger).warn(...args);
};
module.exports["ufowarn"] = $5c1c0b03503ca679$export$d53d07b6034c4560;

});

parcelRegister("aNeq3", function(module, exports) {

var $e22Cc = parcelRequire("e22Cc");

class $1043fc05a880bbb3$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
     * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
     * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
     * so for that case, you need to also include code to listen for the pagehide event.
     */ if ((0, $e22Cc.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $1043fc05a880bbb3$export$13e680397ec8f3eb = new $1043fc05a880bbb3$var$VisibilityChangeObserver();
module.exports["visibilityChangeObserver"] = $1043fc05a880bbb3$export$13e680397ec8f3eb;

});

parcelRegister("e22Cc", function(module, exports) {
const $0f617bf44fb531ac$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};
module.exports["isWindowObjectAvailable"] = $0f617bf44fb531ac$export$15e172712955e18f;

});

parcelRegister("j7Sza", function(module, exports) {
const $f267d4a3139d0594$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};
module.exports["UFOExperienceState"] = $f267d4a3139d0594$export$81b70111112841a0;

});

parcelRegister("g8bWJ", function(module, exports) {

var $j7Sza = parcelRequire("j7Sza");

const $59fdb64e04330d55$var$UFOStateAvailableTransitions = {
    [(0, $j7Sza.UFOExperienceState).NOT_STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).STARTED.id]: [
        (0, $j7Sza.UFOExperienceState).IN_PROGRESS.id,
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $j7Sza.UFOExperienceState).BLOCKED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).BLOCKED.id]: [
        (0, $j7Sza.UFOExperienceState).RECOVERED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).RECOVERED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $j7Sza.UFOExperienceState).SUCCEEDED.id,
        (0, $j7Sza.UFOExperienceState).FAILED.id,
        (0, $j7Sza.UFOExperienceState).ABORTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).FAILED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ],
    [(0, $j7Sza.UFOExperienceState).ABORTED.id]: [
        (0, $j7Sza.UFOExperienceState).STARTED.id
    ]
};
const $59fdb64e04330d55$export$178881f329fdb81f = (state1, state2)=>{
    return $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id] && $59fdb64e04330d55$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};
module.exports["canTransition"] = $59fdb64e04330d55$export$178881f329fdb81f;

});

parcelRegister("4MiWC", function(module, exports) {
var $d8444ff033f3362a$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $d8444ff033f3362a$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});
module.exports["ExperienceTypes"] = $d8444ff033f3362a$export$994164cf3ae1cc9a;
module.exports["ExperiencePerformanceTypes"] = $d8444ff033f3362a$export$cc26007c03242fff;

});

parcelRegister("DJFHw", function(module, exports) {
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $2xhEb = parcelRequire("2xhEb");

const $56570a8acedc1b5f$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2xhEb.roundPerfNow)();
};
module.exports["perfNowOrTimestamp"] = $56570a8acedc1b5f$export$c753e8669d30c8ad;

});

parcelRegister("2xhEb", function(module, exports) {
const $a279419ecc31ce6a$export$5f490af6b2b115cf = ()=>~~performance.now();
module.exports["roundPerfNow"] = $a279419ecc31ce6a$export$5f490af6b2b115cf;

});

parcelRegister("yuV6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$2e27ba8337eb718f = '/gateway/api/elements/emoji';
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    const baseUrl = (0, $iDrrr.fg)('use-elements-stargate-emoji-path') ? $378a693b2c26358e$export$2e27ba8337eb718f : $378a693b2c26358e$export$ca6dda5263526f75;
    return `${baseUrl}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
};
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("jQQYu", function(module, exports) {
// Creates a cookie for object-resolver header
const $64671b371f568ec9$export$7892c26d6c7a7447 = (userContext)=>{
    const cookieTarget = 'cloud.session.token';
    return `${cookieTarget}=${userContext}`;
};
module.exports["createCookie"] = $64671b371f568ec9$export$7892c26d6c7a7447;

});

parcelRegister("8Pm8w", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $3xsB6 = parcelRequire("3xsB6");


var $05aaK = parcelRequire("05aaK");


var $79ir6 = parcelRequire("79ir6");


var $916Gd = parcelRequire("916Gd");


var $7GRSG = parcelRequire("7GRSG");


var $cuwGS = parcelRequire("cuwGS");


var $d04Ge = parcelRequire("d04Ge");

const $9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX = /^ari:cloud:blocks:.*:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/(.+)$/;
const $9b0c4608cd445e14$var$mapBlockError = (error)=>{
    switch(error.status){
        case 400:
        case 401:
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 403:
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 404:
            return (0, $79ir6.SyncBlockError).NotFound;
        case 409:
            return (0, $79ir6.SyncBlockError).Conflict;
        case 429:
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 500:
        case 503:
        case 504:
            return (0, $79ir6.SyncBlockError).ServerError;
    }
    return (0, $79ir6.SyncBlockError).Errored;
};
const $9b0c4608cd445e14$var$mapErrorResponseCode = (errorCode)=>{
    switch(errorCode){
        case 'FORBIDDEN':
            return (0, $79ir6.SyncBlockError).Forbidden;
        case 'RESOURCE_NOT_FOUND':
        case 'NOT_FOUND':
            return (0, $79ir6.SyncBlockError).NotFound;
        case 'EntityNotFound':
            return (0, $79ir6.SyncBlockError).EntityNotFound;
        case 'INVALID_REQUEST':
            return (0, $79ir6.SyncBlockError).InvalidRequest;
        case 'CONFLICT':
            return (0, $79ir6.SyncBlockError).Conflict;
        case 'RATE_LIMITED':
            return (0, $79ir6.SyncBlockError).RateLimited;
        case 'SERVER_ERROR':
            return (0, $79ir6.SyncBlockError).ServerError;
        case 'INVALID_CONTENT':
            return (0, $79ir6.SyncBlockError).InvalidContent;
        default:
            return (0, $79ir6.SyncBlockError).Errored;
    }
};
const $9b0c4608cd445e14$export$7a367d6c9621d11 = (blockAri)=>{
    // Validate ARI format and extract resourceId using regex
    // Format: ari:cloud:blocks:{uuid}:synced-block/{product}/{parentId}/{resourceId}
    // The regex captures the full path after synced-block/
    // e.g. ari:cloud:blocks:DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5:synced-block/confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    // should return confluence-page/455232061495/e8cf64e3-1b6e-489b-ad86-8465b0905bb4
    const match = blockAri.match($9b0c4608cd445e14$var$BLOCK_ARI_TO_RESOURCE_ID_REGEX);
    return match?.[1] || null;
};
const $9b0c4608cd445e14$export$bba762cb095b2f42 = (data, resourceId)=>{
    let createdAt;
    if (data.createdAt !== undefined && data.createdAt !== null) try {
        createdAt = new Date(data.createdAt).toISOString();
    } catch  {
        // fallback to undefined
        // as we don't want to block the whole process due to invalid date
        createdAt = undefined;
    }
    return {
        blockInstanceId: data.blockInstanceId,
        content: JSON.parse(data.content),
        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(data.contentUpdatedAt),
        createdAt: createdAt,
        createdBy: data.createdBy,
        product: data.product,
        resourceId: resourceId,
        sourceAri: data.sourceAri,
        status: data.status
    };
};
const $9b0c4608cd445e14$export$17132bdfdc28611c = async (documentAri)=>{
    let response;
    try {
        response = await (0, $05aaK.getReferenceSyncedBlocks)(documentAri);
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return $9b0c4608cd445e14$var$mapBlockError(error);
        return (0, $79ir6.SyncBlockError).Errored;
    }
    const { blocks: blocks, errors: errors } = response || {};
    const blocksInstances = (blocks || []).map((blockContentResponse)=>{
        try {
            const resourceId = $9b0c4608cd445e14$export$7a367d6c9621d11(blockContentResponse.blockAri);
            if (!resourceId) // could not extract resourceId from blockAri, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
            return {
                data: $9b0c4608cd445e14$export$bba762cb095b2f42(blockContentResponse, resourceId),
                resourceId: resourceId
            };
        } catch  {
            // JSON parsing error, return InvalidContent error
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).InvalidContent
                },
                resourceId: blockContentResponse.blockAri
            };
        }
    });
    const errorInstances = (errors || []).map((errorBlock)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: errorBlock.blockAri
        }));
    return [
        ...blocksInstances,
        ...errorInstances
    ];
};
const $9b0c4608cd445e14$export$2837853885c81488 = (blockAri)=>{
    const match = blockAri.match($9b0c4608cd445e14$var$EXTRACT_RESOURCE_ID_FROM_BLOCK_ARI_REGEX);
    return match?.[1];
};
const $9b0c4608cd445e14$export$abdcb5d4d6767e73 = async (cloudId, parentAri, blockNodeIdentifiers, config)=>{
    const blockIdentifiers = blockNodeIdentifiers.map((blockIdentifier)=>({
            blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: cloudId,
                resourceId: blockIdentifier.resourceId
            }),
            blockInstanceId: blockIdentifier.blockInstanceId
        }));
    // Create a set of valid resourceIds for validation
    const validResourceIds = new Set(blockNodeIdentifiers.map((blockNodeIdentifier)=>blockNodeIdentifier.resourceId));
    // Track which resourceIds have been processed
    const processedResourceIds = new Set();
    if (!parentAri) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
            error: {
                type: (0, $79ir6.SyncBlockError).Errored
            },
            resourceId: blockNodeIdentifier.resourceId
        }));
    try {
        const response = await (0, $05aaK.batchRetrieveSyncedBlocks)({
            blockIdentifiers: blockIdentifiers,
            config: config
        });
        const results = [];
        // Process successful blocks
        if (response.success) for (const blockContentResponse of response.success){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(blockContentResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            const { content: content, deletionReason: deletionReason, sourceAri: sourceAri, blockAri: blockAri, contentUpdatedAt: contentUpdatedAt, blockInstanceId: blockInstanceId, product: product, status: status } = blockContentResponse;
            if (!content) {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).NotFound,
                        reason: deletionReason,
                        sourceAri: sourceAri
                    },
                    resourceId: resourceId
                });
                continue;
            }
            try {
                const syncedBlockData = JSON.parse(content);
                results.push({
                    data: {
                        content: syncedBlockData,
                        resourceId: blockAri,
                        contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                        blockInstanceId: blockInstanceId,
                        sourceAri: sourceAri,
                        product: product,
                        status: status,
                        deletionReason: deletionReason
                    },
                    resourceId: resourceId
                });
            } catch  {
                results.push({
                    error: {
                        type: (0, $79ir6.SyncBlockError).Errored,
                        reason: `parsing JSON content response failed for resourceId: ${resourceId} localId: ${blockAri}`
                    },
                    resourceId: resourceId
                });
            }
        }
        // Process errors
        if (response.error) for (const errorResponse of response.error){
            // Extract resourceId from the returned blockAri
            const resourceId = $9b0c4608cd445e14$export$2837853885c81488(errorResponse.blockAri);
            if (!resourceId || !validResourceIds.has(resourceId)) continue;
            processedResourceIds.add(resourceId);
            results.push({
                error: {
                    type: $9b0c4608cd445e14$var$mapErrorResponseCode(errorResponse.code),
                    reason: errorResponse.reason
                },
                resourceId: resourceId
            });
        }
        // Ensure all resourceIds have a result - return NotFound for any missing ones
        for (const blockNodeIdentifier of blockNodeIdentifiers)if (!processedResourceIds.has(blockNodeIdentifier.resourceId)) results.push({
            error: {
                type: (0, $79ir6.SyncBlockError).NotFound
            },
            resourceId: blockNodeIdentifier.resourceId
        });
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockTimeoutError) && (0, $ieeJu.expValEquals)('platform_editor_sync_block_ssr_config', 'isEnabled', true)) return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: (0, $79ir6.SyncBlockError).Aborted,
                    reason: error.message
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
        // If batch request fails, return error for all resourceIds. Capture the HTTP
        // status from `BlockError` so fetch analytics can break failures down by
        // statusCode (EDITOR-7862); undefined for non-HTTP failures. Thread the PII-safe
        // original message/name so the renderer can de-opaque the `errored` bucket.
        return blockNodeIdentifiers.map((blockNodeIdentifier)=>({
                error: {
                    type: error instanceof (0, $05aaK.BlockError) ? $9b0c4608cd445e14$var$mapBlockError(error) : (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...error instanceof (0, $05aaK.BlockError) && {
                        statusCode: error.status
                    },
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: blockNodeIdentifier.resourceId
            }));
    }
};
const $9b0c4608cd445e14$export$13b682467148f88a = async (cloudId, parentAri, parentId, product, data, stepVersion)=>{
    if (!parentAri || !parentId) return data.map((block)=>({
            error: (0, $79ir6.SyncBlockError).Errored,
            resourceId: block.resourceId
        }));
    try {
        // Create a map from blockAri to original resourceId for matching responses
        const blockAriToResourceIdMap = new Map();
        const blocks = data.map((block)=>{
            const blockAri = (0, $3xsB6.generateBlockAri)({
                cloudId: cloudId,
                parentId: parentId,
                product: product,
                resourceId: block.resourceId
            });
            blockAriToResourceIdMap.set(blockAri, block.resourceId);
            return {
                blockAri: blockAri,
                content: JSON.stringify(block.content),
                status: block.status,
                stepVersion: stepVersion
            };
        });
        const response = await (0, $05aaK.updateSyncedBlocks)({
            blocks: blocks
        });
        const results = [];
        // Process successful updates
        if (response.success) {
            const successResourceIds = new Set(response.success.map((block)=>blockAriToResourceIdMap.get(block.blockAri)));
            for (const block of data)if (successResourceIds.has(block.resourceId)) results.push({
                resourceId: block.resourceId
            });
        }
        if (response.error) {
            const errorResourceIds = new Map(response.error.map((err)=>[
                    // Use the map to get the original resourceId
                    blockAriToResourceIdMap.get(err.blockAri) || '',
                    $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                ]));
            for (const block of data){
                const error = errorResourceIds.get(block.resourceId);
                if (error) results.push({
                    error: error,
                    resourceId: block.resourceId
                });
                else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                results.push({
                    error: (0, $79ir6.SyncBlockError).Errored,
                    resourceId: block.resourceId
                });
            }
        }
        return results;
    } catch (error) {
        if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: block.resourceId,
                statusCode: error.status
            }));
        return data.map((block)=>({
                error: (0, $916Gd.stringifyError)(error),
                resourceId: block.resourceId
            }));
    }
};

/**
 * ADFFetchProvider implementation that fetches synced block data from Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFFetchProvider {
    generateResourceIdForReference(sourceId) {
        if (!this.product || !this.parentId) return sourceId;
        return (0, $cuwGS.createResourceIdForReference)(this.product, this.parentId, sourceId);
    }
    // resourceId of the reference synced block.
    // the ARI must be constructed to call the block service API
    async fetchData(resourceId) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        try {
            const blockContentResponse = await (0, $05aaK.getSyncedBlockContent)({
                blockAri: blockAri
            });
            const { content: content, sourceAri: sourceAri, deletionReason: deletionReason, blockInstanceId: blockInstanceId, contentUpdatedAt: contentUpdatedAt, product: product, status: status } = blockContentResponse;
            if (!content) return {
                error: {
                    type: (0, $79ir6.SyncBlockError).NotFound,
                    reason: deletionReason,
                    sourceAri: sourceAri
                },
                resourceId: resourceId
            };
            // Parse the synced block content from the response's content
            const syncedBlockData = JSON.parse(content);
            return {
                data: {
                    content: syncedBlockData,
                    resourceId: blockAri,
                    blockInstanceId: blockInstanceId,
                    // this was the node's localId, but has become the resourceId.
                    contentUpdatedAt: (0, $d04Ge.convertContentUpdatedAt)(contentUpdatedAt),
                    sourceAri: sourceAri,
                    product: product,
                    status: status,
                    deletionReason: deletionReason
                },
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) // Capture the HTTP status so fetch analytics can break failures down by
            // statusCode (EDITOR-7862). Thread the PII-safe original message/name so
            // the renderer can de-opaque failures.
            return {
                error: {
                    type: $9b0c4608cd445e14$var$mapBlockError(error),
                    reason: error.message,
                    statusCode: error.status,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
            return {
                error: {
                    type: (0, $79ir6.SyncBlockError).Errored,
                    reason: error.message,
                    ...(0, $916Gd.getPiiSafeOriginalError)(error)
                },
                resourceId: resourceId
            };
        }
    }
    async fetchReferences(referenceResourceId) {
        try {
            const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
                cloudId: this.cloudId,
                resourceId: referenceResourceId
            });
            const response = await (0, $05aaK.getReferenceSyncedBlocksByBlockAri)({
                blockAri: blockAri
            });
            const locationScopeOf = (documentAri)=>(0, $7GRSG.getFieldAwareLocationScope)({
                    documentAri: documentAri,
                    hostAri: this.parentAri,
                    productType: (0, $3xsB6.getProductFromSourceAri)(documentAri)
                });
            const references = [];
            response.references.forEach((reference)=>{
                references.push({
                    ...reference,
                    hasAccess: true,
                    onSameDocument: this.parentAri === reference.documentAri,
                    ...locationScopeOf(reference.documentAri)
                });
            });
            response.errors.forEach((reference)=>{
                if (reference.code === 'FORBIDDEN') references.push({
                    blockAri: reference.blockAri,
                    documentAri: reference.documentAri,
                    hasAccess: false,
                    onSameDocument: false,
                    ...locationScopeOf(reference.documentAri)
                });
            });
            return {
                references: references
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error)
            };
            return {
                error: (0, $79ir6.SyncBlockError).Errored
            };
        }
    }
    /**
   * Batch fetches multiple synced blocks by their resource IDs.
   * @param blockNodeIdentifiers - Array of block node identifiers to fetch
   * @param config - Optional batch fetch configuration
   * @returns Array of SyncBlockInstance results
   */ async batchFetchData(blockNodeIdentifiers, config) {
        return await $9b0c4608cd445e14$export$abdcb5d4d6767e73(this.cloudId, this.parentAri, blockNodeIdentifiers, config);
    }
    /**
   * Subscribes to real-time updates for a specific block using GraphQL WebSocket subscriptions.
   * @param resourceId - The resource ID of the block to subscribe to
   * @param onUpdate - Callback function invoked when the block is updated
   * @param onError - Optional callback function invoked on subscription errors
   * @returns Unsubscribe function to stop receiving updates
   */ subscribeToBlockUpdates(resourceId, onUpdate, onError, onComplete) {
        const blockAri = (0, $3xsB6.generateBlockAriFromReference)({
            cloudId: this.cloudId,
            resourceId: resourceId
        });
        // Track the real unsubscribe fn once the dynamic import resolves
        let unsubscribe;
        let cancelled = false;
        // Dynamically import blockSubscription so that graphql-ws is NOT pulled
        // into the SSR/preload bundle that imports this subpath.
        (parcelRequire("6kZ2a")).then(({ subscribeToBlockUpdates: subscribeToBlockUpdatesWS })=>{
            if (cancelled) return;
            unsubscribe = subscribeToBlockUpdatesWS(blockAri, (parsedData)=>{
                // Convert ParsedBlockSubscriptionData to SyncBlockInstance
                const syncBlockInstance = {
                    data: {
                        content: parsedData.content,
                        resourceId: parsedData.blockAri,
                        blockInstanceId: parsedData.blockInstanceId,
                        sourceAri: parsedData.sourceAri,
                        product: parsedData.product,
                        createdAt: parsedData.createdAt,
                        contentUpdatedAt: parsedData.contentUpdatedAt,
                        createdBy: parsedData.createdBy,
                        status: parsedData.status
                    },
                    resourceId: parsedData.resourceId
                };
                onUpdate(syncBlockInstance);
            }, onError, onComplete);
        }).catch((err)=>{
            if (cancelled) return;
            onError?.(err instanceof Error ? err : new Error('Failed to load subscription module'));
        });
        // Return an unsubscribe fn that works whether the import has resolved or not
        return ()=>{
            cancelled = true;
            unsubscribe?.();
        };
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product }){
        this.cloudId = void 0;
        this.parentAri = void 0;
        this.parentId = void 0;
        this.product = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
    }
}
/**
 * ADFWriteProvider implementation that writes synced block data to Block Service API
 */ class $9b0c4608cd445e14$var$BlockServiceADFWriteProvider {
    async writeData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            const status = data.status;
            await (0, $05aaK.updateSyncedBlock)({
                blockAri: blockAri,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    async createData(data) {
        if (!this.parentAri || !this.parentId) return {
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const { resourceId: resourceId } = data;
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        const status = 'unpublished';
        try {
            await (0, $05aaK.createSyncedBlock)({
                blockAri: blockAri,
                blockInstanceId: data.blockInstanceId,
                sourceAri: this.parentAri,
                product: this.product,
                content: JSON.stringify(data.content),
                stepVersion: stepVersion,
                status: status
            });
            return {
                resourceId: resourceId
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                resourceId: resourceId,
                statusCode: error.status
            };
            return {
                error: (0, $916Gd.stringifyError)(error),
                resourceId: resourceId
            };
        }
    }
    // soft deletes the source synced block
    async deleteData(resourceId, deleteReason) {
        if (!this.parentId) return {
            resourceId: resourceId,
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        const blockAri = (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId,
            product: this.product,
            resourceId: resourceId
        });
        try {
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockNotFoundError) && this.parentAri) return this.deleteOrphanBlock({
                blockAri: blockAri,
                resourceId: resourceId,
                parentAri: this.parentAri,
                deleteReason: deleteReason
            });
            if (error instanceof (0, $05aaK.BlockError)) {
                if (error.status === 404) // User should not be blocked by not_found error when deleting,
                // hence returns successful result for 404 error
                return {
                    resourceId: resourceId,
                    success: true
                };
                return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    statusCode: error.status
                };
            }
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // The block is an orphan (e.g. from a copied page) — it doesn't exist in Block Service.
    // Block Service uses soft-deletes, so we must first create the block then delete it,
    // ensuring a deletion-reason record is stored (used to display errors in reference blocks).
    async deleteOrphanBlock({ blockAri: blockAri, resourceId: resourceId, parentAri: parentAri, deleteReason: deleteReason }) {
        try {
            const stepVersion = this.getVersion ? await this.getVersion() : undefined;
            try {
                await (0, $05aaK.createSyncedBlock)({
                    blockAri: blockAri,
                    blockInstanceId: resourceId,
                    sourceAri: parentAri,
                    product: this.product,
                    content: '[]',
                    stepVersion: stepVersion
                });
            } catch (createError) {
                // "Conditional check failed" means the block already exists in Block Service.
                // This can happen when an orphan block is copied and pasted — a reference block repair
                // in the backend may have already created it. We can proceed directly to delete it.
                if (createError instanceof Error && createError.message.includes('Conditional check failed')) ;
                else if (createError instanceof (0, $05aaK.BlockError)) return {
                    resourceId: resourceId,
                    success: false,
                    error: $9b0c4608cd445e14$var$mapBlockError(createError),
                    statusCode: createError.status
                };
                else return {
                    resourceId: resourceId,
                    success: false,
                    error: (0, $916Gd.stringifyError)(createError)
                };
            }
            await (0, $05aaK.deleteSyncedBlock)({
                blockAri: blockAri,
                deleteReason: deleteReason
            });
            return {
                resourceId: resourceId,
                success: true,
                error: undefined
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                resourceId: resourceId,
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                resourceId: resourceId,
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    // the sourceId is the resourceId of the source synced block.
    generateResourceIdForReference(sourceId) {
        return (0, $cuwGS.createResourceIdForReference)(this.product, this.parentId || '', sourceId);
    }
    generateResourceId() {
        return crypto.randomUUID();
    }
    generateBlockAri(resourceId) {
        return (0, $3xsB6.generateBlockAri)({
            cloudId: this.cloudId,
            parentId: this.parentId || '',
            product: this.product,
            resourceId: resourceId
        });
    }
    async updateReferenceData(blocks, noContent) {
        if (!this.parentAri) return {
            success: false,
            error: (0, $79ir6.SyncBlockError).Errored
        };
        try {
            await (0, $05aaK.updateReferenceSyncedBlockOnDocument)({
                documentAri: this.parentAri,
                blocks: blocks.map((block)=>({
                        blockAri: (0, $3xsB6.generateBlockAriFromReference)({
                            cloudId: this.cloudId,
                            resourceId: block.resourceId
                        }),
                        blockInstanceId: block.localId
                    })),
                noContent: noContent
            });
            return {
                success: true
            };
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return {
                success: false,
                error: $9b0c4608cd445e14$var$mapBlockError(error),
                statusCode: error.status
            };
            return {
                success: false,
                error: (0, $916Gd.stringifyError)(error)
            };
        }
    }
    async writeDataBatch(data) {
        if (!this.parentAri || !this.parentId) return data.map((block)=>({
                error: (0, $79ir6.SyncBlockError).Errored,
                resourceId: block.resourceId
            }));
        const stepVersion = this.getVersion ? await this.getVersion() : undefined;
        try {
            // Create a map from blockAri to original resourceId for matching responses
            const blockAriToResourceIdMap = new Map();
            const blocks = data.map((block)=>{
                const blockAri = this.generateBlockAri(block.resourceId);
                blockAriToResourceIdMap.set(blockAri, block.resourceId);
                return {
                    blockAri: blockAri,
                    content: JSON.stringify(block.content),
                    status: block.status,
                    stepVersion: stepVersion
                };
            });
            const response = await (0, $05aaK.updateSyncedBlocks)({
                blocks: blocks
            });
            const results = [];
            // Process successful updates
            if (response.success) {
                const successBlocks = new Map(response.success.map((block)=>[
                        blockAriToResourceIdMap.get(block.blockAri),
                        block
                    ]));
                for (const block of data){
                    const successBlock = successBlocks.get(block.resourceId);
                    if (successBlock) results.push({
                        resourceId: block.resourceId,
                        status: successBlock.status
                    });
                }
            }
            if (response.error) {
                const errorResourceIds = new Map(response.error.map((err)=>[
                        // Use the map to get the original resourceId
                        blockAriToResourceIdMap.get(err.blockAri) || '',
                        $9b0c4608cd445e14$var$mapErrorResponseCode(err.code)
                    ]));
                for (const block of data){
                    const error = errorResourceIds.get(block.resourceId);
                    if (error) {
                        if (error !== (0, $79ir6.SyncBlockError).NotFound) results.push({
                            error: error,
                            resourceId: block.resourceId
                        });
                    } else if (!results.some((r)=>r.resourceId === block.resourceId)) // If not in success or error lists, mark as errored
                    results.push({
                        error: (0, $79ir6.SyncBlockError).Errored,
                        resourceId: block.resourceId
                    });
                }
            }
            return results;
        } catch (error) {
            if (error instanceof (0, $05aaK.BlockError)) return data.map((block)=>({
                    error: $9b0c4608cd445e14$var$mapBlockError(error),
                    resourceId: block.resourceId,
                    statusCode: error.status
                }));
            return data.map((block)=>({
                    error: (0, $916Gd.stringifyError)(error),
                    resourceId: block.resourceId
                }));
        }
    }
    constructor({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion }){
        this.cloudId = void 0;
        this.parentId = void 0;
        this.getVersion = void 0;
        this.product = void 0;
        this.parentAri = void 0;
        this.cloudId = cloudId;
        this.parentAri = parentAri;
        this.parentId = parentId;
        this.product = product;
        this.getVersion = getVersion;
    }
}
const $9b0c4608cd445e14$var$createBlockServiceAPIProviders = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product
        }),
        writeProvider: new $9b0c4608cd445e14$var$BlockServiceADFWriteProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        })
    };
};
const $9b0c4608cd445e14$export$ec654f5ac7e6d976 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product, getVersion: getVersion })=>{
    return (0, $cozmU.useMemo)(()=>{
        return $9b0c4608cd445e14$var$createBlockServiceAPIProviders({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product,
            getVersion: getVersion
        });
    }, [
        cloudId,
        parentAri,
        parentId,
        product,
        getVersion
    ]);
};
const $9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product })=>{
    return {
        fetchProvider: new $9b0c4608cd445e14$var$BlockServiceADFFetchProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product
        }),
        writeProvider: undefined
    };
};
const $9b0c4608cd445e14$export$1e67317f82b65067 = ({ cloudId: cloudId, parentAri: parentAri, parentId: parentId, product: product })=>(0, $cozmU.useMemo)(()=>$9b0c4608cd445e14$var$createBlockServiceFetchOnlyAPIProvider({
            cloudId: cloudId,
            parentAri: parentAri,
            parentId: parentId,
            product: product
        }), [
        cloudId,
        parentAri,
        parentId,
        product
    ]);
module.exports["batchFetchData"] = $9b0c4608cd445e14$export$abdcb5d4d6767e73;
module.exports["useMemoizedBlockServiceAPIProviders"] = $9b0c4608cd445e14$export$ec654f5ac7e6d976;

});

parcelRegister("3xsB6", function(module, exports) {
/* eslint-disable require-unicode-regexp */ 
var $4o0zT = parcelRequire("4o0zT");


var $EBNuL = parcelRequire("EBNuL");

const $a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX = /ari:cloud:blocks:[^:]+:synced-block\/([a-zA-Z0-9-]+)/;
const $a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX = /ari:cloud:jira:.*/;
const $a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX = /ari:cloud:confluence:.*/;
const $a2c616dead6b3b85$export$e79189cdb9940bc5 = ({ cloudId: cloudId, parentId: parentId, product: product, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${product}/${parentId}/${resourceId}`;
};
const $a2c616dead6b3b85$export$92a2331f8a9ed841 = ({ cloudId: cloudId, resourceId: resourceId })=>{
    return `ari:cloud:blocks:${cloudId}:synced-block/${resourceId}`;
};
const $a2c616dead6b3b85$export$3f0878b0afe5a2c0 = (ari)=>{
    const match = ari.match($a2c616dead6b3b85$var$GET_LOCAL_ID_FROM_BLOCK_RESOURCE_ID_REGEX);
    if (match?.[1]) return match[1];
    throw new Error(`Invalid block ARI: ${ari}`);
};
const $a2c616dead6b3b85$export$36d45714d1e88dec = ({ documentAri: documentAri, hostAri: hostAri })=>{
    if (documentAri === hostAri) return 'same-document';
    const location = (0, $EBNuL.parseJiraFieldLocation)({
        ari: documentAri
    });
    const hostLocation = (0, $EBNuL.parseJiraFieldLocation)({
        ari: hostAri
    });
    if (!location || !hostLocation || location.issueAri !== hostLocation.issueAri) return 'elsewhere';
    return location.fieldId === hostLocation.fieldId ? 'same-document' : 'same-parent-document';
};
const $a2c616dead6b3b85$export$c10656f449ea0fb5 = (ari)=>{
    if (!ari && (0, $4o0zT.isExperimentEnabled)('platform_editor_blocks_patch_11')) return undefined;
    const jiraMatch = ari?.search($a2c616dead6b3b85$var$JIRA_SOURCE_ARI_REGEX);
    if (jiraMatch !== -1) return 'jira-work-item';
    const confluenceMatch = ari?.search($a2c616dead6b3b85$var$CONFLUENCE_SOURCE_ARI_REGEX);
    if (confluenceMatch !== -1) return 'confluence-page';
    return undefined;
};
module.exports["generateBlockAri"] = $a2c616dead6b3b85$export$e79189cdb9940bc5;
module.exports["generateBlockAriFromReference"] = $a2c616dead6b3b85$export$92a2331f8a9ed841;
module.exports["getLocationScope"] = $a2c616dead6b3b85$export$36d45714d1e88dec;
module.exports["getProductFromSourceAri"] = $a2c616dead6b3b85$export$c10656f449ea0fb5;

});

parcelRegister("EBNuL", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX = /ari:cloud:jira:([^:]+):issue\/(\d+)/;
const $059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX = /ari:cloud:jira:([^:]+):issuefieldvalue\/([^/]+)\/([^/]+)/;
const $059546548da04295$export$e7d6f26185793d4f = ({ cloudId: cloudId, workItemId: workItemId })=>{
    return `ari:cloud:jira:${cloudId}:issue/${workItemId}`;
};
const $059546548da04295$var$getFieldValueAriParts = (ari)=>{
    const match = ari.match($059546548da04295$var$JIRA_ISSUE_FIELD_VALUE_ARI_REGEX);
    if (match?.[1] && match[2] && match[3]) return {
        cloudId: match[1],
        issueId: match[2],
        fieldId: match[3]
    };
    return undefined;
};
const $059546548da04295$export$3ee1e41ffca0b1ff = ({ ari: ari })=>{
    const match = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (match?.[2]) return match[2];
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return fieldValueParts.issueId;
    throw new Error(`Invalid Jira work item ARI: ${ari}`);
};
const $059546548da04295$export$9d29a8e91440be5c = ({ ari: ari })=>{
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    if (fieldValueParts) return $059546548da04295$export$e7d6f26185793d4f({
        cloudId: fieldValueParts.cloudId,
        workItemId: fieldValueParts.issueId
    });
    return ari;
};
const $059546548da04295$export$335defc86b234ea0 = 'description';
const $059546548da04295$var$toJiraFieldLocation = ({ cloudId: cloudId, fieldId: fieldId, issueId: issueId })=>({
        fieldId: fieldId,
        issueAri: $059546548da04295$export$e7d6f26185793d4f({
            cloudId: cloudId,
            workItemId: issueId
        })
    });
const $059546548da04295$export$decd92eb8dd00bf5 = ({ ari: ari })=>{
    const workItemMatch = ari.match($059546548da04295$var$JIRA_WORK_ITEM_ARI_REGEX);
    if (workItemMatch?.[1] && workItemMatch[2]) return $059546548da04295$var$toJiraFieldLocation({
        cloudId: workItemMatch[1],
        fieldId: $059546548da04295$export$335defc86b234ea0,
        issueId: workItemMatch[2]
    });
    const fieldValueParts = $059546548da04295$var$getFieldValueAriParts(ari);
    return fieldValueParts && $059546548da04295$var$toJiraFieldLocation(fieldValueParts);
};
module.exports["getJiraIssueAriFromSourceAri"] = $059546548da04295$export$9d29a8e91440be5c;
module.exports["JIRA_DESCRIPTION_FIELD_ID"] = $059546548da04295$export$335defc86b234ea0;
module.exports["parseJiraFieldLocation"] = $059546548da04295$export$decd92eb8dd00bf5;

});

parcelRegister("05aaK", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $48FpT = parcelRequire("48FpT");

const $59e004c7d849e8bb$export$f426a9918d7f49b3 = (response)=>{
    const content = response.content;
    return typeof content === 'string';
};
const $59e004c7d849e8bb$export$571f6abc3f4e5951 = async (documentAri)=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery(documentAri),
        operationName: $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetDocumentReferenceBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getDocumentReferenceBlocks;
};
const $59e004c7d849e8bb$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $59e004c7d849e8bb$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_DOCUMENT_REFERENCE_BLOCKS';
const $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_BLOCK';
const $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_DELETE_BLOCK';
const $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_CREATE_BLOCK';
const $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_UPDATE_DOCUMENT_REFERENCES';
const $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_RETRIEVE_BLOCKS';
const $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_REFERENCES';
const $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_BLOCK';
const $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_BATCH_UPDATE_BLOCKS';
const $59e004c7d849e8bb$var$buildGetDocumentReferenceBlocksQuery = (documentAri)=>`query ${$59e004c7d849e8bb$var$GET_DOCUMENT_REFERENCE_BLOCKS_OPERATION_NAME} {
	blockService_getDocumentReferenceBlocks(documentAri: ${JSON.stringify(documentAri)}) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
const $59e004c7d849e8bb$var$buildGetBlockQuery = (blockAri)=>`query ${$59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME} {
	blockService_getBlock(blockAri: ${JSON.stringify(blockAri)}) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
const $59e004c7d849e8bb$var$buildUpdateBlockMutation = (blockAri, content, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `content: ${JSON.stringify(content)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME} {
	blockService_updateBlock(input: { ${inputArgs} }) {
		__typename
	}
}`;
};
const $59e004c7d849e8bb$var$buildDeleteBlockMutation = (blockAri, deletionReason)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`
    ];
    if (deletionReason !== undefined) inputParts.push(`deletionReason: ${JSON.stringify(deletionReason)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME} {
	blockService_deleteBlock(input: { ${inputArgs} }) {
		deleted
	}
}`;
};
/**
 * Converts product string to GraphQL enum format
 * 'confluence-page' -> 'CONFLUENCE_PAGE'
 * 'jira-work-item' -> 'JIRA_WORK_ITEM'
 */ const $59e004c7d849e8bb$var$convertProductToGraphQLEnum = (product)=>{
    switch(product){
        case 'confluence-page':
            return 'CONFLUENCE_PAGE';
        case 'jira-work-item':
            return 'JIRA_WORK_ITEM';
        default:
            {
                const exhaustiveCheck = product;
                throw new Error(`Unsupported product: ${exhaustiveCheck}`);
            }
    }
};
const $59e004c7d849e8bb$var$buildCreateBlockMutation = (blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status)=>{
    const inputParts = [
        `blockAri: ${JSON.stringify(blockAri)}`,
        `blockInstanceId: ${JSON.stringify(blockInstanceId)}`,
        `content: ${JSON.stringify(content)}`,
        `product: ${$59e004c7d849e8bb$var$convertProductToGraphQLEnum(product)}`,
        `sourceAri: ${JSON.stringify(sourceAri)}`
    ];
    if (stepVersion !== undefined) inputParts.push(`stepVersion: ${stepVersion}`);
    if (status !== undefined) inputParts.push(`status: ${JSON.stringify(status)}`);
    const inputArgs = inputParts.join(', ');
    return `mutation ${$59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME} {
	blockService_createBlock(input: { ${inputArgs} }) {
		blockAri
		blockInstanceId
		content
		contentUpdatedAt
		createdAt
		createdBy
		deletionReason
		product
		sourceAri
		status
		version
	}
}`;
};
const $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation = (documentAri, blocks, noContent)=>{
    const blocksArray = blocks.map((block)=>`{ blockAri: ${JSON.stringify(block.blockAri)}, blockInstanceId: ${JSON.stringify(block.blockInstanceId)} }`).join(', ');
    const inputArgs = `documentAri: ${JSON.stringify(documentAri)}, blocks: [${blocksArray}], noContent: ${noContent}`;
    return `mutation ${$59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME} {
	blockService_updateDocumentReferences(input: { ${inputArgs} }) {
		blocks {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			product
			sourceAri
			status
			version
		}
		errors {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery = (blockAris)=>{
    const blockArisArray = blockAris.map((ari)=>JSON.stringify(ari)).join(', ');
    const inputArgs = `blockAris: [${blockArisArray}]`;
    return `query ${$59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME} {
	blockService_batchRetrieveBlocks(input: { ${inputArgs} }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildGetBlockReferencesQuery = (blockAri)=>{
    return `query ${$59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME} {
	blockService_getReferences(blockAri: ${JSON.stringify(blockAri)}) {
		references {
			blockAri
			blockInstanceId
			createdAt
			createdBy
			documentAri
		}
		errors {
			blockAri
			code${(0, $4o0zT.isExperimentEnabled)('platform_editor_blocks_patch_11') ? '\n\t\t\tdocumentAri' : ''}
			reason
		}
	}
}`;
};
const $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation = (blocks)=>{
    const blocksArray = blocks.map((block)=>{
        const inputParts = [
            `blockAri: ${JSON.stringify(block.blockAri)}`,
            `content: ${JSON.stringify(block.content)}`
        ];
        if (block.stepVersion !== undefined) inputParts.push(`stepVersion: ${block.stepVersion}`);
        if (block.status !== undefined) inputParts.push(`status: ${JSON.stringify(block.status)}`);
        return `{ ${inputParts.join(', ')} }`;
    }).join(', ');
    return `mutation ${$59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME} {
	blockService_batchUpdateBlocks(input: { blocks: [${blocksArray}] }) {
		success {
			blockAri
			blockInstanceId
			content
			contentUpdatedAt
			createdAt
			createdBy
			deletionReason
			product
			sourceAri
			status
			version
		}
		error {
			blockAri
			code
			reason
		}
	}
}`;
};
class $59e004c7d849e8bb$export$e47a0a94b0998697 extends Error {
    constructor(status){
        super(`Block error`), this.status = status;
    }
}
class $59e004c7d849e8bb$export$f5a00468af285e38 extends Error {
    constructor(){
        super('Block not found in Block Service');
        this.name = 'BlockNotFoundError';
    }
}
class $59e004c7d849e8bb$export$b5687000eb0902be extends Error {
    constructor(){
        super('Block request timed out');
        this.name = 'BlockTimeoutError';
    }
}
const $59e004c7d849e8bb$export$fab66d51cc0c1a7 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getBlock) throw new Error('No data returned from GraphQL query');
    return result.data.blockService_getBlock;
};
const $59e004c7d849e8bb$export$48a4f565308f4741 = async ({ blockIdentifiers: blockIdentifiers, config: config })=>{
    const blockAris = blockIdentifiers.map((blockIdentifier)=>blockIdentifier.blockAri);
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchRetrieveBlocksQuery(blockAris),
        operationName: $59e004c7d849e8bb$var$BATCH_RETRIEVE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchRetrieveBlocks`;
    // undefined or 0 or negative means no timeout,
    // We don't enforce a minimum timeout for simplicity
    const fetchPromise = (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    const timeoutMs = config?.timeoutMs ?? 0;
    const response = await (timeoutMs > 0 ? Promise.race([
        fetchPromise,
        new Promise((_, reject)=>setTimeout(()=>reject(new $59e004c7d849e8bb$export$b5687000eb0902be()), timeoutMs))
    ]) : fetchPromise);
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchRetrieveBlocks) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_batchRetrieveBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
const $59e004c7d849e8bb$export$cbbc86409cac3ee5 = async ({ blockAri: blockAri, deleteReason: deleteReason })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildDeleteBlockMutation(blockAri, deleteReason),
        operationName: $59e004c7d849e8bb$var$DELETE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockDeleteBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) {
        const allNotFound = result.errors.every((e)=>e.extensions?.errorType === 'RESOURCE_NOT_FOUND');
        if (allNotFound) // Throw BlockNotFoundError so the caller can create the block first then retry the delete.
        // Block Service uses soft-deletes: the entry must exist before deletion so a deletion-reason
        // is stored (used to display errors in reference blocks).
        throw new $59e004c7d849e8bb$export$f5a00468af285e38();
        throw new Error(result.errors.map((e)=>e.message).join(', '));
    }
    const isDeleted = result.data?.blockService_deleteBlock?.deleted;
    if (!isDeleted) throw new Error('Block deletion failed; deleted flag is false');
};
const $59e004c7d849e8bb$export$d5bf0c5618431e5e = async ({ blockAri: blockAri, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateBlockMutation(blockAri, content, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$UPDATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
};
const $59e004c7d849e8bb$export$fbc30658d812c800 = async ({ blockAri: blockAri, blockInstanceId: blockInstanceId, sourceAri: sourceAri, product: product, content: content, stepVersion: stepVersion, status: status })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildCreateBlockMutation(blockAri, blockInstanceId, content, product, sourceAri, stepVersion, status),
        operationName: $59e004c7d849e8bb$var$CREATE_BLOCK_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockCreateBlock`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_createBlock) throw new Error('No data returned from GraphQL mutation');
    return result.data.blockService_createBlock;
};
const $59e004c7d849e8bb$export$59c7369fa04bcba1 = async ({ documentAri: documentAri, blocks: blocks, noContent: noContent = true })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildUpdateDocumentReferencesMutation(documentAri, blocks, noContent),
        operationName: $59e004c7d849e8bb$var$UPDATE_DOCUMENT_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockUpdateDocumentReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData),
        keepalive: true
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!noContent) {
        if (!result.data?.blockService_updateDocumentReferences) throw new Error('No data returned from GraphQL mutation');
        return result.data.blockService_updateDocumentReferences;
    }
};
const $59e004c7d849e8bb$export$75f5aeff9ce22a33 = async ({ blockAri: blockAri })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildGetBlockReferencesQuery(blockAri),
        operationName: $59e004c7d849e8bb$var$GET_BLOCK_REFERENCES_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockGetReferences`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_getReferences) throw new Error('No data returned from GraphQL query');
    const graphqlResponse = result.data.blockService_getReferences;
    return {
        blockAri: blockAri,
        references: graphqlResponse.references || [],
        errors: graphqlResponse.errors || []
    };
};
const $59e004c7d849e8bb$export$a9e53fa4329b5ed2 = async ({ blocks: blocks })=>{
    const bodyData = {
        query: $59e004c7d849e8bb$var$buildBatchUpdateBlocksMutation(blocks),
        operationName: $59e004c7d849e8bb$var$BATCH_UPDATE_BLOCKS_OPERATION_NAME
    };
    const url = `${$59e004c7d849e8bb$var$GRAPHQL_ENDPOINT}?operation=editorSyncedBlockBatchUpdateBlocks`;
    const response = await (0, $48FpT.fetchWithRetry)(url, {
        method: 'POST',
        headers: $59e004c7d849e8bb$var$COMMON_HEADERS,
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new $59e004c7d849e8bb$export$e47a0a94b0998697(response.status);
    const result = await response.json();
    if (result.errors && result.errors.length > 0) throw new Error(result.errors.map((e)=>e.message).join(', '));
    if (!result.data?.blockService_batchUpdateBlocks) throw new Error('No data returned from GraphQL mutation');
    const graphqlResponse = result.data.blockService_batchUpdateBlocks;
    return {
        success: graphqlResponse.success,
        error: graphqlResponse.error
    };
};
module.exports["getReferenceSyncedBlocks"] = $59e004c7d849e8bb$export$571f6abc3f4e5951;
module.exports["BlockError"] = $59e004c7d849e8bb$export$e47a0a94b0998697;
module.exports["BlockNotFoundError"] = $59e004c7d849e8bb$export$f5a00468af285e38;
module.exports["BlockTimeoutError"] = $59e004c7d849e8bb$export$b5687000eb0902be;
module.exports["getSyncedBlockContent"] = $59e004c7d849e8bb$export$fab66d51cc0c1a7;
module.exports["batchRetrieveSyncedBlocks"] = $59e004c7d849e8bb$export$48a4f565308f4741;
module.exports["deleteSyncedBlock"] = $59e004c7d849e8bb$export$cbbc86409cac3ee5;
module.exports["updateSyncedBlock"] = $59e004c7d849e8bb$export$d5bf0c5618431e5e;
module.exports["createSyncedBlock"] = $59e004c7d849e8bb$export$fbc30658d812c800;
module.exports["updateReferenceSyncedBlockOnDocument"] = $59e004c7d849e8bb$export$59c7369fa04bcba1;
module.exports["getReferenceSyncedBlocksByBlockAri"] = $59e004c7d849e8bb$export$75f5aeff9ce22a33;
module.exports["updateSyncedBlocks"] = $59e004c7d849e8bb$export$a9e53fa4329b5ed2;

});

parcelRegister("48FpT", function(module, exports) {
const $fc075454b76b2577$var$MAX_RETRY_DELAY = 30000;
const $fc075454b76b2577$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $fc075454b76b2577$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $fc075454b76b2577$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $fc075454b76b2577$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $fc075454b76b2577$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $fc075454b76b2577$export$cffaac380b94df26;

});

parcelRegister("79ir6", function(module, exports) {
var $2ca041ce04439e9b$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    // attempt to create block that already exists
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    // content is not a valid JSON
    SyncBlockError["Offline"] = "offline";
    SyncBlockError["Unpublished"] = "unpublished";
    // request was aborted, typically due to client timeout
    SyncBlockError["Aborted"] = "aborted";
    // block does not exist on this site (e.g. cross-site reference or hard deleted)
    SyncBlockError["EntityNotFound"] = "entity_not_found";
    return SyncBlockError;
}({});
const $2ca041ce04439e9b$export$7486a7adf8b0d591 = 'Data provider not set';
class $2ca041ce04439e9b$export$ca0858d4f5eeeac extends Error {
    constructor(message = $2ca041ce04439e9b$export$7486a7adf8b0d591){
        super(message);
        this.isProviderNotReadyError = true;
        this.name = 'ProviderNotReadyError';
        // Restore prototype chain so instanceof works after transpilation.
        Object.setPrototypeOf(this, $2ca041ce04439e9b$export$ca0858d4f5eeeac.prototype);
    }
}
const $2ca041ce04439e9b$export$7ba508051f94701f = (error)=>{
    if (error instanceof $2ca041ce04439e9b$export$ca0858d4f5eeeac) return true;
    if (typeof error === 'object' && error !== null && error.isProviderNotReadyError === true) return true;
    return error instanceof Error && error.message === $2ca041ce04439e9b$export$7486a7adf8b0d591;
};
module.exports["SyncBlockError"] = $2ca041ce04439e9b$export$686dd843fdf311d4;
module.exports["ProviderNotReadyError"] = $2ca041ce04439e9b$export$ca0858d4f5eeeac;
module.exports["isProviderNotReadyError"] = $2ca041ce04439e9b$export$7ba508051f94701f;

});

parcelRegister("916Gd", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $79ir6 = parcelRequire("79ir6");

const $5f570f8dd9ccb4e4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $5f570f8dd9ccb4e4$export$74ce7fda6da1109 = (error)=>{
    if (error instanceof Error) return {
        ...error.message && {
            originalMessage: error.message
        },
        ...error.name && {
            originalName: error.name
        }
    };
    return {};
};
const $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS = new Set(Object.values((0, $79ir6.SyncBlockError)));
const $5f570f8dd9ccb4e4$export$3bf11deac13e0617 = (error)=>{
    if (error && $5f570f8dd9ccb4e4$var$SYNC_BLOCK_ERROR_REASONS.has(error)) return error;
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$78792f4ddc3998e8 = (error, statusCode)=>{
    return {
        reason: $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error),
        ...statusCode !== undefined && {
            statusCode: statusCode
        }
    };
};
const $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b = new Set([
    'source_deleted',
    'source_unpublished',
    'source_unsynced',
    'source_not_found',
    'permission_denied',
    'unauthenticated',
    // Mirror the benign write-path enum equivalents so already-classified errors are
    // treated consistently.
    'not_found',
    'forbidden',
    'unpublished',
    // `offline` is an expected client connectivity state, not a read-path system failure:
    // the error component is rendered for the offline experience, so it should not inflate
    // the true error rate. It still emits `reason` (so its volume can be inspected) but is
    // excluded from true-error counts.
    'offline'
]);
/**
 * Ordered list of substring matchers mapping known free-text fetch/subscribe error
 * strings to a categorical {@link SyncBlockFetchErrorReason}. Each entry is a list of
 * lowercase needles; if ANY needle is found (case-insensitively) in the raw `error`
 * string, the entry's reason is used. Order matters: more specific entries must precede
 * more general ones.
 *
 * Plain `String.includes` substring matching is used deliberately instead of `RegExp`:
 * it sidesteps the `require-unicode-regexp` lint rule AND the declaration build's lower
 * compile target (which rejects the regex `u` flag with TS1501), while being faster and
 * easier to read. Doing this classification in code (rather than in dashboard SQL) keeps
 * the buckets versioned with the source strings that produce them (EDITOR-7862).
 */ const $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS = [
    // Benign: source-state transitions (deletionReason values + free text).
    [
        [
            'source-document-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-deleted'
        ],
        'source_deleted'
    ],
    [
        [
            'source-block-unpublished'
        ],
        'source_unpublished'
    ],
    [
        [
            'source-block-unsynced'
        ],
        'source_unsynced'
    ],
    [
        [
            'does not exist'
        ],
        'source_not_found'
    ],
    [
        [
            'unpublished'
        ],
        'source_unpublished'
    ],
    // Working-as-designed permission outcomes.
    [
        [
            'unauthenticated'
        ],
        'unauthenticated'
    ],
    [
        [
            'not permitted to read synced block'
        ],
        'permission_denied'
    ],
    [
        [
            'bulk permission check failed'
        ],
        'permission_denied'
    ],
    [
        [
            'permission denied'
        ],
        'permission_denied'
    ],
    // Genuine system failures.
    [
        [
            'reconnection failed after'
        ],
        'websocket_exhausted'
    ],
    // `reconnect to the subscription` (not a bare `reconnect`) avoids false positives on
    // unrelated DB/GraphQL "reconnect" messages while still matching the WS-drop string.
    [
        [
            'websocket',
            'reconnect to the subscription',
            'subscription terminated'
        ],
        'websocket_drop'
    ],
    [
        [
            '429',
            'rate limit',
            'rate-limit',
            'ratelimit'
        ],
        'rate_limited'
    ],
    // `econnrefused`/`econnreset` (not a bare `econn`, which would also match `reconnect`).
    [
        [
            'network',
            'failed to fetch',
            'econnrefused',
            'econnreset',
            'timed out',
            'timeout'
        ],
        'network'
    ],
    [
        [
            'data provider not set'
        ],
        'data_provider_not_ready'
    ]
];
const $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55 = (error)=>{
    const enumReason = $5f570f8dd9ccb4e4$export$3bf11deac13e0617(error);
    if (enumReason !== 'unknown') return enumReason;
    if (error) {
        const haystack = error.toLowerCase();
        for (const [needles, reason] of $5f570f8dd9ccb4e4$var$FETCH_REASON_MATCHERS){
            if (needles.some((needle)=>haystack.includes(needle))) return reason;
        }
    }
    return 'unknown';
};
const $5f570f8dd9ccb4e4$export$4ae89cef01c11c46 = (error, statusCode, deferred)=>{
    const reason = $5f570f8dd9ccb4e4$export$b7fb09a58aa76c55(error);
    return {
        reason: reason,
        // A deferred (tab-hidden) exhaustion is benign regardless of reason bucket.
        benign: deferred === true || $5f570f8dd9ccb4e4$export$9bd766f5cc31fe3b.has(reason),
        ...statusCode !== undefined && {
            statusCode: statusCode
        },
        ...deferred === true && {
            deferred: true
        }
    };
};
function $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d(actionSubjectId, error, resourceId, sourceProduct, attribution, sourceLocation) {
    return {
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            },
            ...attribution?.reason && {
                reason: attribution.reason
            },
            ...attribution?.statusCode !== undefined && {
                statusCode: attribution.statusCode
            },
            // `benign` is only present on fetch/subscribe attribution (EDITOR-7862). It is a
            // boolean (never UGC); the `'benign' in attribution` check both guards the
            // write-path attribution (which has no `benign`) and narrows the union so
            // `attribution.benign` is accessible.
            ...attribution && 'benign' in attribution && {
                benign: attribution.benign
            },
            // `deferred` is only present on fetch/subscribe attribution, and only when a
            // tab-hidden exhaustion was deferred rather than surfaced. Boolean, never UGC.
            ...attribution && 'deferred' in attribution && attribution.deferred === true && {
                deferred: true
            }
        }
    };
}
const $5f570f8dd9ccb4e4$export$94dcd08406353dba = (error, resourceId, sourceProduct, attribution)=>// Branch on attribution presence so each call resolves to a concrete overload: with
    // attribution it hits the fetch overload (wider `reason`); without it, the
    // no-attribution overload. Both produce a fetch event regardless.
    attribution ? $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct, attribution) : $5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$c5131f589148b9d3 = (error, resourceId, sourceProduct, sourceLocation)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error, resourceId, sourceProduct, undefined, sourceLocation);
const $5f570f8dd9ccb4e4$export$adc2363832f8735d = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$154595d209a77913 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$5d2f0c264cf49280 = (error, resourceId, sourceProduct, attribution, sourceLocation)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error, resourceId, sourceProduct, attribution, sourceLocation);
const $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2 = (error, resourceId, sourceProduct, attribution)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error, resourceId, sourceProduct, attribution);
const $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$5665a31a69693485 = (resourceId, sourceProduct, context)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_SOURCE_INFO_ORPHANED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...context?.hasPendingDeletion !== undefined && {
                hasPendingDeletion: context.hasPendingDeletion
            },
            ...context?.hasSubscribers !== undefined && {
                hasSubscribers: context.hasSubscribers
            }
        }
    });
const $5f570f8dd9ccb4e4$export$82f9608c8438ecb2 = (rescheduleCount, resourceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ERROR,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CACHE_DELETION_FORCED,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            rescheduleCount: rescheduleCount,
            ...resourceId && {
                resourceId: resourceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a = (error, resourceId, sourceProduct)=>$5f570f8dd9ccb4e4$export$999ed1af1b20ac2d((0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH_REFERENCES, error, resourceId, sourceProduct);
const $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76 = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            blockInstanceId: blockInstanceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$6611683c2e3e50db = (resourceId, blockInstanceId, sourceProduct, sourceLocation)=>({
        action: (0, $krYZG.ACTION).FETCHED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            }
        }
    });
const $5f570f8dd9ccb4e4$export$5b8e0915870366d0 = (resourceId, sourceProduct, sourceLocation)=>{
    return {
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).BODIED_SYNCED_BLOCK,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            }
        }
    };
};
const $5f570f8dd9ccb4e4$export$23e42fbf8039414c = (resourceId, blockInstanceId, sourceProduct, enrichment, sourceLocation)=>({
        action: (0, $krYZG.ACTION).INSERTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.inputMethod && {
                inputMethod: enrichment.inputMethod
            },
            ...enrichment?.createdEmpty !== undefined && {
                createdEmpty: enrichment.createdEmpty
            },
            ...enrichment?.nodeTypes?.length && {
                nodeTypes: enrichment.nodeTypes
            },
            ...sourceLocation && {
                sourceLocation: sourceLocation
            }
        }
    });
const $5f570f8dd9ccb4e4$export$c76f6dd50db89cda = (resourceId, blockInstanceId, sourceProduct)=>({
        action: (0, $krYZG.ACTION).ADDED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_ADD_CONTENT,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...blockInstanceId && {
                blockInstanceId: blockInstanceId
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$f2b4214fae56af83 = (resourceId, hasReference, sourceProduct)=>({
        action: (0, $krYZG.ACTION).UPDATED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...hasReference !== undefined && {
                hasReference: hasReference
            },
            ...sourceProduct && {
                sourceProduct: sourceProduct
            }
        }
    });
const $5f570f8dd9ccb4e4$export$2283f5d682476cde = (resourceId, sourceProduct, enrichment)=>({
        action: (0, $krYZG.ACTION).DELETED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE,
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            resourceId: resourceId,
            ...sourceProduct && {
                sourceProduct: sourceProduct
            },
            ...enrichment?.blockInstanceId && {
                blockInstanceId: enrichment.blockInstanceId
            },
            ...enrichment?.deletionReason && {
                deletionReason: enrichment.deletionReason
            },
            ...enrichment?.mechanism && {
                mechanism: enrichment.mechanism
            }
        }
    });
module.exports["stringifyError"] = $5f570f8dd9ccb4e4$export$7fc2c997455452c8;
module.exports["getPiiSafeOriginalError"] = $5f570f8dd9ccb4e4$export$74ce7fda6da1109;
module.exports["buildErrorAttribution"] = $5f570f8dd9ccb4e4$export$78792f4ddc3998e8;
module.exports["buildFetchErrorAttribution"] = $5f570f8dd9ccb4e4$export$4ae89cef01c11c46;
module.exports["fetchErrorPayload"] = $5f570f8dd9ccb4e4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $5f570f8dd9ccb4e4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $5f570f8dd9ccb4e4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $5f570f8dd9ccb4e4$export$154595d209a77913;
module.exports["createErrorPayload"] = $5f570f8dd9ccb4e4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $5f570f8dd9ccb4e4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $5f570f8dd9ccb4e4$export$e40ed1768baf5d1e;
module.exports["sourceInfoOrphanedPayload"] = $5f570f8dd9ccb4e4$export$5665a31a69693485;
module.exports["cacheDeletionForcedPayload"] = $5f570f8dd9ccb4e4$export$82f9608c8438ecb2;
module.exports["fetchReferencesErrorPayload"] = $5f570f8dd9ccb4e4$export$ebf3ba305f3f0e1a;
module.exports["fetchSuccessPayload"] = $5f570f8dd9ccb4e4$export$b20c56c32ea6ad76;
module.exports["getSourceInfoSuccessPayload"] = $5f570f8dd9ccb4e4$export$6611683c2e3e50db;
module.exports["createSuccessPayload"] = $5f570f8dd9ccb4e4$export$5b8e0915870366d0;
module.exports["createSuccessOperationalPayload"] = $5f570f8dd9ccb4e4$export$23e42fbf8039414c;
module.exports["addContentSuccessPayload"] = $5f570f8dd9ccb4e4$export$c76f6dd50db89cda;
module.exports["updateSuccessPayload"] = $5f570f8dd9ccb4e4$export$f2b4214fae56af83;
module.exports["deleteSuccessPayload"] = $5f570f8dd9ccb4e4$export$2283f5d682476cde;

});

parcelRegister("7GRSG", function(module, exports) {

var $4o0zT = parcelRequire("4o0zT");


var $3xsB6 = parcelRequire("3xsB6");


var $EBNuL = parcelRequire("EBNuL");

const $23c76758ad9684b4$export$63fea0488f1f3b79 = (productType)=>productType === 'jira-work-item' && (0, $4o0zT.isExperimentEnabled)('editor_synced_blocks_jira_custom_rich_text');
const $23c76758ad9684b4$export$6f2c88a8b48b006f = ({ documentAri: documentAri, hostAri: hostAri, productType: productType })=>hostAri !== undefined && $23c76758ad9684b4$export$63fea0488f1f3b79(productType) ? {
        locationScope: (0, $3xsB6.getLocationScope)({
            documentAri: documentAri,
            hostAri: hostAri
        })
    } : undefined;
const $23c76758ad9684b4$export$406c316e26a555c = (sourceAri)=>{
    if (!sourceAri || !$23c76758ad9684b4$export$63fea0488f1f3b79((0, $3xsB6.getProductFromSourceAri)(sourceAri))) return undefined;
    const location = (0, $EBNuL.parseJiraFieldLocation)({
        ari: sourceAri
    });
    if (!location) return undefined;
    return location.fieldId === (0, $EBNuL.JIRA_DESCRIPTION_FIELD_ID) ? 'description' : 'custom-field';
};
module.exports["getFieldAwareLocationScope"] = $23c76758ad9684b4$export$6f2c88a8b48b006f;
module.exports["getSourceLocation"] = $23c76758ad9684b4$export$406c316e26a555c;

});

parcelRegister("cuwGS", function(module, exports) {

var $kcJaM = parcelRequire("kcJaM");

const $dfc9aeca876e07dc$var$isSyncBlockProduct = (product)=>{
    return (0, $kcJaM.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $dfc9aeca876e07dc$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$dfc9aeca876e07dc$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
const $dfc9aeca876e07dc$export$cf5895b3b46faf63 = (product, contentId, uuid)=>{
    return `${product}/${contentId}/${uuid}`;
};
module.exports["parseResourceId"] = $dfc9aeca876e07dc$export$8aafdd7901afa57f;
module.exports["createResourceIdForReference"] = $dfc9aeca876e07dc$export$cf5895b3b46faf63;

});

parcelRegister("kcJaM", function(module, exports) {
const $d6e2f975e4365dc3$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $d6e2f975e4365dc3$export$c05408ef703373ad;

});

parcelRegister("d04Ge", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX = /^(confluence-page|jira-work-item)\/([^/]+)/;
const $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal = (content, options)=>{
    let normalizedContent;
    content.forEach((contentNode, index)=>{
        if (!contentNode) {
            normalizedContent?.push(contentNode);
            return;
        }
        const hasAnnotationMark = contentNode.marks?.some((mark)=>mark.type === 'annotation');
        const shouldConvertPanelC1 = options.convertPanelC1ToPanel && contentNode.type === 'panel_c1';
        const childContent = contentNode.content ? $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(contentNode.content, options) : undefined;
        const hasContentChanged = childContent !== undefined && childContent !== contentNode.content;
        if (!hasAnnotationMark && !shouldConvertPanelC1 && !hasContentChanged) {
            normalizedContent?.push(contentNode);
            return;
        }
        if (!normalizedContent) normalizedContent = content.slice(0, index);
        const normalizedNode = {
            ...contentNode
        };
        if (shouldConvertPanelC1) normalizedNode.type = 'panel';
        if (hasAnnotationMark) {
            const marks = contentNode.marks?.filter((mark)=>mark.type !== 'annotation');
            if (marks && marks.length > 0) normalizedNode.marks = marks;
            else delete normalizedNode.marks;
        }
        if (hasContentChanged && childContent) normalizedNode.content = childContent;
        normalizedContent.push(normalizedNode);
    });
    return normalizedContent ?? content;
};
const $acebaa6737646e6e$export$19bb1d88f473b9c5 = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: false
    });
};
const $acebaa6737646e6e$export$b223a7607ed061dc = (content)=>{
    return $acebaa6737646e6e$var$normalizeSyncBlockJSONContentInternal(content, {
        convertPanelC1ToPanel: true
    });
};
const $acebaa6737646e6e$export$aafb32b192c8228c = (node)=>{
    const content = node.content.toJSON();
    return {
        blockInstanceId: node.attrs.localId,
        content: content ? $acebaa6737646e6e$export$b223a7607ed061dc(content) : content,
        resourceId: node.attrs.resourceId
    };
};
const $acebaa6737646e6e$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $acebaa6737646e6e$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $acebaa6737646e6e$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $acebaa6737646e6e$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$acebaa6737646e6e$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined);
};
const $acebaa6737646e6e$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match($acebaa6737646e6e$var$GET_CONTENT_ID_AND_PRODUCT_REGEX);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
const $acebaa6737646e6e$export$31cbe0bed21e05b1 = (resourceId)=>{
    if (!resourceId) return undefined;
    try {
        return $acebaa6737646e6e$export$2cf4a74c3e18f31a(resourceId).sourceProduct;
    } catch  {
        return undefined;
    }
};
const $acebaa6737646e6e$export$4c6687d128f55da5 = (contentUpdatedAt)=>{
    if (typeof contentUpdatedAt === 'number') try {
        return new Date(contentUpdatedAt).toISOString();
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["normalizeSyncBlockJSONContent"] = $acebaa6737646e6e$export$b223a7607ed061dc;
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $acebaa6737646e6e$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $acebaa6737646e6e$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $acebaa6737646e6e$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $acebaa6737646e6e$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $acebaa6737646e6e$export$2cf4a74c3e18f31a;
module.exports["getSourceProductFromResourceIdSafe"] = $acebaa6737646e6e$export$31cbe0bed21e05b1;
module.exports["convertContentUpdatedAt"] = $acebaa6737646e6e$export$4c6687d128f55da5;

});

parcelRegister("6kZ2a", function(module, exports) {

let $49d3f462ce18e6f7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $49d3f462ce18e6f7$var$load("d0ZRF"),
    $49d3f462ce18e6f7$var$load("k507P"),
    $49d3f462ce18e6f7$var$load("cp9QV")
]).then(()=>parcelRequire('kRm6Y'));

});

parcelRegister("6oMcp", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX = /ari:cloud:confluence:[^:]+:(page|blogpost)\/(\d+)/;
const $0dfedb71521ac678$export$3c54cf45dfed84ea = ({ pageId: pageId, cloudId: cloudId, pageType: pageType })=>{
    return `ari:cloud:confluence:${cloudId}:${pageType}/${pageId}`;
};
const $0dfedb71521ac678$export$2ee4e689bde04de2 = ({ ari: ari })=>{
    const match = ari.match($0dfedb71521ac678$var$CONFLUENCE_PAGE_ARI_REGEX);
    if (match?.[2]) return {
        type: match[1],
        id: match[2]
    };
    throw new Error(`Invalid page ARI: ${ari}`);
};
module.exports["getConfluencePageAri"] = $0dfedb71521ac678$export$3c54cf45dfed84ea;
module.exports["getPageIdAndTypeFromConfluencePageAri"] = $0dfedb71521ac678$export$2ee4e689bde04de2;

});

parcelRegister("gb05o", function(module, exports) {
/**
 * Error codes for synced blocks preloading
 * Used for tracking and monitoring errors during SSR preload phase
 */ const $dcd4a25c1def153c$export$f10410d219e3ec29 = {
    /**
   * Occurs when the fetch operation returns fewer results than requested.
   * This indicates incomplete data retrieval or potential data loss.
   * Included in error: list of missing block identifiers
   */ FETCH_INCOMPLETE: 'SYNCED_BLOCKS_FETCH_INCOMPLETE',
    /**
   * Occurs when the batch fetch operation throws an error during execution.
   * This indicates a network error, timeout, or API failure.
   * Included in error: resource IDs that failed to fetch
   */ BATCH_FETCH_FAILED: 'SYNCED_BLOCKS_BATCH_FETCH_FAILED',
    /**
   * Occurs when the fetch operation times out without returning results.
   * This is specific to the bulk fetch operation with a configurable timeout.
   */ FETCH_TIMEOUT: 'SYNCED_BLOCKS_FETCH_TIMEOUT'
};
module.exports["SyncedBlocksSSRErrorCodeMap"] = $dcd4a25c1def153c$export$f10410d219e3ec29;

});

parcelRegister("2yWJZ", function(module, exports) {

var $2khPJ = parcelRequire("2khPJ");

const $7f640ed30a5677e6$export$62a80b577b02c670 = 'ai_mate_agent';
const $7f640ed30a5677e6$export$eaedd3c4d259c3db = 'f3a534d9-1498-e0d4-8b50-e058a8fb8156';
const $7f640ed30a5677e6$export$d4e191820de5cb9e = $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$cf40b355c500b3f7 = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
const $7f640ed30a5677e6$export$84f2221dfd1486e2 = 'SYSTEM';
const $7f640ed30a5677e6$export$d54b716922cade63 = (value)=>{
    const trimmed = value?.trim();
    return trimmed ? trimmed : undefined;
};
const $7f640ed30a5677e6$export$4529494ee013eb50 = ({ agentId: agentId, agentNamedId: agentNamedId })=>$7f640ed30a5677e6$export$d54b716922cade63(agentId) === $7f640ed30a5677e6$export$eaedd3c4d259c3db || $7f640ed30a5677e6$export$d54b716922cade63(agentNamedId) === $7f640ed30a5677e6$export$62a80b577b02c670;
const $7f640ed30a5677e6$export$71c4912d3c1bf3e3 = (value)=>{
    const normalizedValue = $7f640ed30a5677e6$export$d54b716922cade63(value);
    if (!normalizedValue) return undefined;
    if (!normalizedValue.includes('ari:')) return normalizedValue;
    try {
        return $7f640ed30a5677e6$export$d54b716922cade63((0, $2khPJ.IdentityUserAri).parse(normalizedValue).userId);
    } catch  {
        return undefined;
    }
};
module.exports["ROVO_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$62a80b577b02c670;
module.exports["ROVO_AGENT_UUID"] = $7f640ed30a5677e6$export$eaedd3c4d259c3db;
module.exports["DEFAULT_AGENT_NAMED_ID"] = $7f640ed30a5677e6$export$d4e191820de5cb9e;
module.exports["DEFAULT_AGENT_UUID"] = $7f640ed30a5677e6$export$cf40b355c500b3f7;
module.exports["DEFAULT_AGENT_CREATOR_TYPE"] = $7f640ed30a5677e6$export$84f2221dfd1486e2;
module.exports["trimToUndefined"] = $7f640ed30a5677e6$export$d54b716922cade63;
module.exports["isDefaultRovoChat"] = $7f640ed30a5677e6$export$4529494ee013eb50;
module.exports["normalizeAccountIdFromIdentityAri"] = $7f640ed30a5677e6$export$71c4912d3c1bf3e3;

});

parcelRegister("5CUwy", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $gXfti = parcelRequire("gXfti");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $3uzFB = parcelRequire("3uzFB");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default),
            __callerPackage__: "loom-utils"
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId)=>{
    if (!userId) return "not-permitted";
    const variables = (0, $3uzFB.getLoomUserPermissionQueryVariables)(cloudId, userId);
    try {
        const { data: data, error: error } = await (0, $c0rhi.queryInterop)({
            query: (0, $3uzFB.LoomUserPermissionQuery),
            variables: variables,
            errorPolicy: 'all',
            interopApolloAggClient: true,
            __callerPackage__: "loom-utils"
        });
        if (error) throw error;
        return (0, $3uzFB.hasExactLoomUserPermission)(data, variables) ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    // No preloader counterpart needed: setCrossJoinSuccess is a runtime-only action
    // triggered after a user completes the interactive cross-join flow (navigates to
    // Loom, gets provisioned, and returns). This cannot occur during SSR. The
    // window.__SSR_LOOM_ENTRY_POINT__ write updates the cached signal so that
    // useLoomEntryPointVariant sees CO_USE on subsequent client-side navigations
    // without re-running the permissions fetch — same pattern as crossFlowSuccessCheck.
    setCrossJoinSuccess: ()=>({ setState: setState })=>{
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
            window.__SSR_LOOM_ENTRY_POINT__ = {
                entryPointVariant: 'CO_USE'
            };
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $gXfti.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $8s9DV.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $kBr4q.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $kBr4q.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("3uzFB", function(module, exports) {

var $keH2u = parcelRequire("keH2u");

const $9ee481529bbe8b4d$export$a4bb6b905bc500e2 = (0, $keH2u.default);
const $9ee481529bbe8b4d$export$8d50de945dbf45ca = (cloudId, userId)=>({
        principalId: `ari:cloud:identity::user/${userId}`,
        loomResourceId: `ari:cloud:loom::site/${cloudId}`
    });
const $9ee481529bbe8b4d$export$b048e9c33b8e482 = (data, variables)=>{
    const matchingRows = data?.bulkPermitted?.filter((row)=>row?.principalId === variables.principalId && row?.resourceId === variables.loomResourceId && row?.permissionId === 'write') ?? [];
    if (matchingRows.length < 1) return false;
    return matchingRows.every((row)=>row?.permitted === true);
};
module.exports["LoomUserPermissionQuery"] = $9ee481529bbe8b4d$export$a4bb6b905bc500e2;
module.exports["getLoomUserPermissionQueryVariables"] = $9ee481529bbe8b4d$export$8d50de945dbf45ca;
module.exports["hasExactLoomUserPermission"] = $9ee481529bbe8b4d$export$b048e9c33b8e482;

});

parcelRegister("keH2u", function(module, exports) {
/**
 * @generated SignedSource<<f506d70b5432de24b8eac90a42245624>>
 * @relayHash 7d65699b292f3495b83e6d7366aa23df
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 44dd65d9f59cd0156391eb7142ed652780a02e2d8da4803fd8394da5092527b8
const $ebcff904befcd9cb$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "loomResourceId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "principalId"
    }, v2 = {
        "args": [
            {
                "kind": "Literal",
                "name": "permissionIds",
                "value": [
                    "write"
                ]
            },
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "principalIds.0",
                        "variableName": "principalId"
                    }
                ],
                "kind": "ListValue",
                "name": "principalIds"
            },
            {
                "items": [
                    {
                        "kind": "Variable",
                        "name": "resourceIds.0",
                        "variableName": "loomResourceId"
                    }
                ],
                "kind": "ListValue",
                "name": "resourceIds"
            }
        ],
        "concreteType": "BulkPermittedResponse",
        "kind": "LinkedField",
        "name": "bulkPermitted",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "principalId"
            },
            {
                "kind": "ScalarField",
                "name": "resourceId"
            },
            {
                "kind": "ScalarField",
                "name": "permissionId"
            },
            {
                "kind": "ScalarField",
                "name": "permitted"
            }
        ]
    }, v3 = [
        v2 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "loomUserPermissionQuery",
            "selections": [
                v2 /*: any*/ ,
                {
                    "kind": "InlineDataFragmentSpread",
                    "name": "loomPersonalization_permission",
                    "selections": v3 /*: any*/ ,
                    "argumentDefinitions": [
                        {
                            "kind": "RootArgument",
                            "name": "loomResourceId"
                        },
                        {
                            "kind": "RootArgument",
                            "name": "principalId"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "loomUserPermissionQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "7d65699b292f3495b83e6d7366aa23df",
            "id": "44dd65d9f59cd0156391eb7142ed652780a02e2d8da4803fd8394da5092527b8",
            "metadata": {},
            "name": "loomUserPermissionQuery",
            "operationKind": "query",
            "text": "query loomUserPermissionQuery($principalId:String!,$loomResourceId:String!){bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted},...loomPersonalization_permission}fragment loomPersonalization_permission on Query{bulkPermitted(principalIds:[$principalId],resourceIds:[$loomResourceId],permissionIds:[\"write\"]){principalId,resourceId,permissionId,permitted}}"
        }
    };
}();
$ebcff904befcd9cb$var$node.hash = "6960ac36f33e1fcc4b0302c4cf32aae6";
var $ebcff904befcd9cb$export$2e2bcd8739ae039 = $ebcff904befcd9cb$var$node;
module.exports["default"] = $ebcff904befcd9cb$export$2e2bcd8739ae039;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<c76309ebecc567e6d2035e662ccfac45>>
 * @relayHash 079ff2d8b9d5ae3ff6e21263b139d2b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7c22267004bc2fd98425f3cabd602d7426662a324fb451ca2cea2f794671999f
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = {
        "concreteType": "ConfluenceTenantContext",
        "kind": "LinkedField",
        "name": "confluence_tenantContext",
        "plural": false,
        "selections": [
            {
                "concreteType": "LicensedProduct",
                "kind": "LinkedField",
                "name": "licensedProducts",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "licenseStatus"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "productKey"
                    }
                ]
            }
        ]
    }, v1 = [
        v0 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "InlineDataFragmentSpread",
                    "name": "loomPersonalization_tenant",
                    "selections": v1 /*: any*/ ,
                    "argumentDefinitions": []
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "079ff2d8b9d5ae3ff6e21263b139d2b8",
            "id": "7c22267004bc2fd98425f3cabd602d7426662a324fb451ca2cea2f794671999f",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}},...loomPersonalization_tenant}fragment loomPersonalization_tenant on Query{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "1993131921e1f069e2bc354ee5138882";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<13773984c152b0614a23977ed3fe74fa>>
 * @relayHash 758204416ec1c35eb472dcfba934fb83
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0c6c3e4f5926df2b58c96ecf077a734ea0bc76bb3687c7a2a84f0fbf32b22c73
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeMeetingRecorderEligibility"
        }
    ], v1 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            }
        ],
        "concreteType": "ConfluenceLoomEntryPoints",
        "kind": "LinkedField",
        "name": "confluence_loomEntryPoints",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isLoomEntryPointsEnabled"
            }
        ]
    }, v2 = [
        {
            "kind": "Variable",
            "name": "siteId",
            "variableName": "cloudId"
        }
    ], v3 = {
        "condition": "includeMeetingRecorderEligibility",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "args": v2 /*: any*/ ,
                "concreteType": "LoomSettings",
                "kind": "LinkedField",
                "name": "loom_settings",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "meetingRecordingsAvailable"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "meetingNotesEligible"
                    }
                ]
            },
            {
                "args": v2 /*: any*/ ,
                "concreteType": "LoomConnectedCalendar",
                "kind": "LinkedField",
                "name": "loom_connectedCalendars",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "guid"
                    }
                ]
            }
        ]
    }, v4 = [
        v1 /*: any*/ ,
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                {
                    "kind": "InlineDataFragmentSpread",
                    "name": "loomPersonalization_entryPoints",
                    "selections": v4 /*: any*/ ,
                    "argumentDefinitions": [
                        {
                            "kind": "RootArgument",
                            "name": "cloudId"
                        },
                        {
                            "kind": "RootArgument",
                            "name": "includeMeetingRecorderEligibility"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "758204416ec1c35eb472dcfba934fb83",
            "id": "0c6c3e4f5926df2b58c96ecf077a734ea0bc76bb3687c7a2a84f0fbf32b22c73",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!,$includeMeetingRecorderEligibility:Boolean!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid},...loomPersonalization_entryPoints}fragment loomPersonalization_entryPoints on Query{confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled},loom_settings(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){meetingRecordingsAvailable,meetingNotesEligible}\n  loom_connectedCalendars(siteId:$cloudId)@include(if:$includeMeetingRecorderEligibility){guid}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "c3947215a2ac45ccf65d991a69c73b63";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("8wyJO", function(module, exports) {

var $ibGN4 = parcelRequire("ibGN4");


var $3V1KT = parcelRequire("3V1KT");

const $01eec1a417789222$export$17ab88ef0193bb4 = (data)=>{
    if (!data) return data;
    if ($01eec1a417789222$var$isConfluenceContentReactions(data)) return data?.confluence_contentReactionsSummary?.contentReactionsSummary?.[0];
    if ($01eec1a417789222$var$isContentReactions(data)) return data?.content?.nodes?.[0]?.contentReactionsSummary;
    if ($01eec1a417789222$var$isCommentReactions(data)) return data?.comments?.nodes?.[0]?.reactionsSummary;
};
const $01eec1a417789222$var$isConfluenceContentReactions = (data)=>Boolean(data.confluence_contentReactionsSummary);
const $01eec1a417789222$var$isContentReactions = (data)=>Boolean(data.content);
const $01eec1a417789222$var$isCommentReactions = (data)=>Boolean(data.comments);
const $01eec1a417789222$var$getReactionsContentQuery = ()=>{
    return 0, $3V1KT.ReactionsContentQuery;
};
const $01eec1a417789222$export$d765e1092b1f36ff = (isComment, contentId, containerId)=>{
    const query = isComment ? (0, $ibGN4.ReactionsCommentsQuery) : $01eec1a417789222$var$getReactionsContentQuery();
    const queryVariables = isComment ? {
        contentId: contentId,
        containerId: containerId
    } : {
        contentId: contentId
    };
    return {
        query: query,
        queryVariables: queryVariables
    };
};
module.exports["getReactionsSummary"] = $01eec1a417789222$export$17ab88ef0193bb4;
module.exports["getReactionsQueryInfo"] = $01eec1a417789222$export$d765e1092b1f36ff;

});

parcelRegister("ibGN4", function(module, exports) {

var $bcPqk = parcelRequire("bcPqk");


var $hMpSP = parcelRequire("hMpSP");

const $0c4d3fd1a40dc0de$export$ea32e9ef3caf8ce7 = (0, $hMpSP.default);
const $0c4d3fd1a40dc0de$export$c0002d0cc70e364a = (0, $bcPqk.default);
module.exports["ReactionsCommentsQuery"] = $0c4d3fd1a40dc0de$export$c0002d0cc70e364a;

});

parcelRegister("bcPqk", function(module, exports) {
/**
 * @generated SignedSource<<d1f71583f1da07d7d25964da546e340a>>
 * @relayHash cbefab13307a82cf7144a0c0749ceeba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce
const $6247a0815b189874$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "containerId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "contentStatus",
                    "value": [
                        "DRAFT",
                        "CURRENT"
                    ]
                }
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "containerId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        },
                                        v2 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ReactionsCommentsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "cbefab13307a82cf7144a0c0749ceeba",
            "id": "856749e0bcac9514035b3ed1c7488b61824433724d4eda1d05cbcff973b7dcce",
            "metadata": {},
            "name": "ReactionsCommentsQuery",
            "operationKind": "query",
            "text": "query ReactionsCommentsQuery($contentId:ID!,$containerId:ID!){comments(commentId:$contentId,contentStatus:[DRAFT,CURRENT]){nodes{id,reactionsSummary(pageId:$containerId,contentType:\"page\",childType:\"comment\"){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}}}"
        }
    };
}();
$6247a0815b189874$var$node.hash = "44a0a66242011ccb75c569988c203697";
var $6247a0815b189874$export$2e2bcd8739ae039 = $6247a0815b189874$var$node;
module.exports["default"] = $6247a0815b189874$export$2e2bcd8739ae039;

});

parcelRegister("hMpSP", function(module, exports) {
/**
 * @generated SignedSource<<eb7ea3f49a5750a597b7cccc9d474194>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $31e432aaf867a396$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "containerId"
            }
        ],
        "kind": "Fragment",
        "name": "ReactionsCommentsQuery_comment",
        "selections": [
            v0 /*: any*/ ,
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "childType",
                        "value": "comment"
                    },
                    {
                        "kind": "Literal",
                        "name": "contentType",
                        "value": "page"
                    },
                    {
                        "kind": "Variable",
                        "name": "pageId",
                        "variableName": "containerId"
                    }
                ],
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "reactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            },
                            v0 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "Comment"
    };
}();
$31e432aaf867a396$var$node.hash = "af213ff403659043868c02fbd688a22c";
var $31e432aaf867a396$export$2e2bcd8739ae039 = $31e432aaf867a396$var$node;
module.exports["default"] = $31e432aaf867a396$export$2e2bcd8739ae039;

});

parcelRegister("9inwL", function(module, exports) {
/**
 * @generated SignedSource<<f8edd74a2bf0cef86303775c92f6818c>>
 * @relayHash f92419f4eae7659107884daf44afe353
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1
const $5791e6e7c338c837$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "missingSpaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "status"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "status"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "missingSpaceKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentPrerequisitesQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "f92419f4eae7659107884daf44afe353",
            "id": "c5083034f862ac3ea960cfc4592f08715470b77981a4653cdbbd9dc1f12df8a1",
            "metadata": {},
            "name": "ContentPrerequisitesQuery",
            "operationKind": "query",
            "text": "query ContentPrerequisitesQuery($contentId:ID!,$missingSpaceKey:Boolean=false,$spaceKey:String,$status:[String]){content(id:$contentId,status:$status){nodes{id,type,space{id,key,alias}}},space(key:$spaceKey)@skip(if:$missingSpaceKey){id,name}}"
        }
    };
}();
$5791e6e7c338c837$var$node.hash = "96ae26a7fa99861b8e368c368e56f6cc";
var $5791e6e7c338c837$export$2e2bcd8739ae039 = $5791e6e7c338c837$var$node;
module.exports["default"] = $5791e6e7c338c837$export$2e2bcd8739ae039;

});

parcelRegister("4uNpa", function(module, exports) {
/**
 * @generated SignedSource<<d7fe2a7a66643bd9c72401c8da9b795f>>
 * @relayHash 81e3b75d8ec7e8341dfb9fe5d7c36fac
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911
const $2411ee21620b66c4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "versionOverride"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "version",
                    "variableName": "versionOverride"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "homepageId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "concreteType": "History",
                            "kind": "LinkedField",
                            "name": "history",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentRedirectQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "81e3b75d8ec7e8341dfb9fe5d7c36fac",
            "id": "9df42f2f20f0917766b188fd5cf2b943f7c14748bf3e7fc1c3a1ae1f61a77911",
            "metadata": {},
            "name": "ContentRedirectQuery",
            "operationKind": "query",
            "text": "query ContentRedirectQuery($contentId:ID,$versionOverride:Int){content(id:$contentId,version:$versionOverride){nodes{id,title,space{id,homepageId,key,alias},history{createdDate}}}}"
        }
    };
}();
$2411ee21620b66c4$var$node.hash = "440c7fc38cc16d750fa69bd87e3ba7c2";
var $2411ee21620b66c4$export$2e2bcd8739ae039 = $2411ee21620b66c4$var$node;
module.exports["default"] = $2411ee21620b66c4$export$2e2bcd8739ae039;

});

parcelRegister("98Fgg", function(module, exports) {
/**
 * @generated SignedSource<<596979161fa6a9082499b62b182667e6>>
 * @relayHash d620f0a6c95731e07148fbdeb928c475
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b7534741235664e1ee2d46f0dcd867c400080533ff68ac74acdc73ddce7c77b7
const $314d226daa5f5ce2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isBlog"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "reuseContent"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "title"
    }, v4 = {
        "kind": "ScalarField",
        "name": "type"
    }, v5 = [
        {
            "condition": "isBlog",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        {
                            "kind": "Literal",
                            "name": "status",
                            "value": [
                                "CURRENT"
                            ]
                        }
                    ],
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "ptpage",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 1
                                }
                            ],
                            "concreteType": "PTPaginatedPageList",
                            "kind": "LinkedField",
                            "name": "nearestAncestors",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PTPageEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "PTPage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "nearestAncestors(first:1)"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "reuseContent",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v4 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "number"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        v4 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "OperationCheckResult",
                                    "kind": "LinkedField",
                                    "name": "operations",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "operation"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "targetType"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadLegacyBridgeQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "d620f0a6c95731e07148fbdeb928c475",
            "id": "b7534741235664e1ee2d46f0dcd867c400080533ff68ac74acdc73ddce7c77b7",
            "metadata": {},
            "name": "preloadLegacyBridgeQuery",
            "operationKind": "query",
            "text": "query preloadLegacyBridgeQuery($contentId:ID!,$isBlog:Boolean!,$reuseContent:Boolean!){ptpage(id:$contentId,status:[CURRENT])@skip(if:$isBlog){id,nearestAncestors(first:1){edges{node{id,title}}}},content(id:$contentId)@skip(if:$reuseContent){nodes{id,type,title,version{number},space{id,key,name,type},operations{operation,targetType}}}}"
        }
    };
}();
$314d226daa5f5ce2$var$node.hash = "3bde364c85660920ab6eee32c19af638";
var $314d226daa5f5ce2$export$2e2bcd8739ae039 = $314d226daa5f5ce2$var$node;
module.exports["default"] = $314d226daa5f5ce2$export$2e2bcd8739ae039;

});

parcelRegister("2rapj", function(module, exports) {
/**
 * @generated SignedSource<<ecf2ccf6da6891e95b8c24bfee1ef6f6>>
 * @relayHash c4c4095c882cb71b80fdf7c511e33e69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1d623029b3f50e0253d05074cea0ec94b1f823ad4c4b61177f50d160b5886b2
const $029fef3d04f7e0c0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "keyString"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        v1 /*: any*/ 
    ], v3 = {
        "args": [
            {
                "kind": "Variable",
                "name": "key",
                "variableName": "keyString"
            }
        ],
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": v2 /*: any*/ 
    }, v4 = {
        "args": [
            {
                "kind": "Variable",
                "name": "entityId",
                "variableName": "key"
            }
        ],
        "concreteType": "RecommendedPagesSpaceStatus",
        "kind": "LinkedField",
        "name": "getRecommendedPagesSpaceStatus",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "recommendedPagesEnabled"
            },
            {
                "kind": "ScalarField",
                "name": "defaultBehavior"
            }
        ]
    }, v5 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "pageId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "title"
    }, v9 = {
        "kind": "ScalarField",
        "name": "type"
    }, v10 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v11 = {
        "alias": "pageStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v13 = {
        "concreteType": "ConfluencePageLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v14 = {
        "kind": "ScalarField",
        "name": "name"
    }, v15 = {
        "concreteType": "ConfluenceSpace",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v1 /*: any*/ ,
            v6 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v14 /*: any*/ 
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v17 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v14 /*: any*/ ,
                    v16 /*: any*/ 
                ]
            }
        ]
    }, v18 = [
        {
            "kind": "Literal",
            "name": "keys",
            "value": [
                "emoji-title-published"
            ]
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "value"
    }, v20 = [
        v6 /*: any*/ ,
        v19 /*: any*/ 
    ], v21 = {
        "kind": "ScalarField",
        "name": "blogPostId"
    }, v22 = {
        "alias": "blogPostStatus",
        "kind": "ScalarField",
        "name": "status"
    }, v23 = {
        "concreteType": "ConfluenceBlogPostLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v24 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v25 = {
        "concreteType": "ConfluenceUserInfo",
        "kind": "LinkedField",
        "name": "owner",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v24 /*: any*/ ,
                    v14 /*: any*/ ,
                    v16 /*: any*/ ,
                    v1 /*: any*/ 
                ]
            },
            v1 /*: any*/ 
        ]
    }, v26 = [
        v6 /*: any*/ ,
        v19 /*: any*/ ,
        v1 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "EndOfPageRecommendationTwgQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluencePageProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v20 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v17 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluenceBlogPostProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v20 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "EndOfPageRecommendationTwgQuery",
            "selections": [
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v1 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v24 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v7 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v10 /*: any*/ ,
                                                                                v11 /*: any*/ ,
                                                                                v13 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluencePageProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluencePage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                v9 /*: any*/ ,
                                                                                v22 /*: any*/ ,
                                                                                v23 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                v25 /*: any*/ ,
                                                                                {
                                                                                    "args": v18 /*: any*/ ,
                                                                                    "concreteType": "ConfluenceBlogPostProperty",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "properties",
                                                                                    "plural": true,
                                                                                    "selections": v26 /*: any*/ ,
                                                                                    "storageKey": "properties(keys:[\"emoji-title-published\"])"
                                                                                }
                                                                            ],
                                                                            "type": "ConfluenceBlogPost"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "TeamCustomFieldValue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "TeamType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v2 /*: any*/ ,
                                                                            "type": "ThirdPartyUser"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "c4c4095c882cb71b80fdf7c511e33e69",
            "id": "e1d623029b3f50e0253d05074cea0ec94b1f823ad4c4b61177f50d160b5886b2",
            "metadata": {},
            "name": "EndOfPageRecommendationTwgQuery",
            "operationKind": "query",
            "text": "query EndOfPageRecommendationTwgQuery($cypherQuery:String!,$first:Int,$key:ID!,$keyString:String!){space(key:$keyString){id},getRecommendedPagesSpaceStatus(entityId:$key){recommendedPagesEnabled,defaultBehavior},graphStore_cypherQueryV2(query:$cypherQuery,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id,data{__typename,...on ConfluencePage{pageId,title,type,subtype,pageStatus:status,links{webUi},space{id,key,alias,name},owner{user{__typename,name,accountId,id},id},properties(keys:[\"emoji-title-published\"]){key,value,id}},...on ConfluenceBlogPost{blogPostId,title,type,blogPostStatus:status,links{webUi},space{id,key,alias,name},owner{user{__typename,name,accountId,id},id},properties(keys:[\"emoji-title-published\"]){key,value,id}},...on Node{__isNode:__typename,id},...on AppUser{id},...on AtlassianAccountUser{id},...on CustomerUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on DevOpsOperationsIncidentDetails{id},...on DevOpsOperationsPostIncidentReviewDetails{id},...on DevOpsProjectDetails{id},...on DevOpsPullRequestDetails{id},...on DevOpsRepository{id},...on DevOpsSecurityVulnerabilityDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}}}}}}}}}"
        }
    };
}();
$029fef3d04f7e0c0$var$node.hash = "fde8f13a8c898c317f96538ff58fec17";
var $029fef3d04f7e0c0$export$2e2bcd8739ae039 = $029fef3d04f7e0c0$var$node;
module.exports["default"] = $029fef3d04f7e0c0$export$2e2bcd8739ae039;

});

parcelRegister("ky8L5", function(module, exports) {
// Shared query config + variable builders for the TWG recs query. Used by both the
// client hook and the SSR preloader so they issue byte-identical variables (needed
// for the client's cache-first read to hit the SSR-primed entry).
// TWG relationship for related Confluence content (spec: CA3).
const $5282e58fea25450f$var$TWG_RELATIONSHIP = 'confluence_content_has_related_confluence_content';
// Relationship from a content node to its authority-score node.
const $5282e58fea25450f$var$TWG_AUTHORITY_RELATIONSHIP = 'confluence_content_has_confluence_content_authority_score';
const $5282e58fea25450f$export$fe20e5d4b8358f61 = 12;
const $5282e58fea25450f$export$5bb8653eb6cf29f = (cloudId)=>`ari:cloud:platform::site/${cloudId}`;
const $5282e58fea25450f$export$46c71f7bb38c3d98 = (cloudId, contentId, contentType)=>`ari:cloud:confluence:${cloudId}:${contentType === 'blogpost' ? 'blogpost' : 'page'}/${contentId}`;
const $5282e58fea25450f$export$7135c395d1f4b359 = (pageAri)=>[
        `MATCH (page {ari: "${pageAri}"})-[:${$5282e58fea25450f$var$TWG_RELATIONSHIP}]->(entity)`,
        `OPTIONAL MATCH (entity)-[:${$5282e58fea25450f$var$TWG_AUTHORITY_RELATIONSHIP}]->(auth)`,
        `RETURN DISTINCT entity, auth`
    ].join('\n');
const $5282e58fea25450f$export$8d8ea6a33dea6f1f = (contentType)=>contentType === 'page' || contentType === 'blogpost';
module.exports["MAX_TWG_RECS"] = $5282e58fea25450f$export$fe20e5d4b8358f61;
module.exports["buildTwgQueryContext"] = $5282e58fea25450f$export$5bb8653eb6cf29f;
module.exports["buildTwgContentAri"] = $5282e58fea25450f$export$46c71f7bb38c3d98;
module.exports["buildTwgRecsCypher"] = $5282e58fea25450f$export$7135c395d1f4b359;
module.exports["isTwgSupportedContentType"] = $5282e58fea25450f$export$8d8ea6a33dea6f1f;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<663f21e6dfcd4d4c24754e54b45772e8>>
 * @relayHash 8b133e3996bec5b3feff733a500f3451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locations"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "locations"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "8b133e3996bec5b3feff733a500f3451",
            "id": "1205b4c053e3bf1a11112543759ae8178f8f0e4161f42e7f549b3c8cdcd56847",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$locations:[String],$contentId:ID,$spaceKey:String){webPanels(location:$location,locations:$locations,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "c9e0e68be80f814df706b6c0d828dae1";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("8G3G6", function(module, exports) {
/**
 * @generated SignedSource<<e1177a1d3670ae73598e531cc663b738>>
 * @relayHash 4454a52ea4ab532f76ee4e80586f3a56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87
const $3a0ab9c788e793cd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentType"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentType",
                    "variableName": "contentType"
                }
            ],
            "concreteType": "CatchupLastViewedTimeResponse",
            "kind": "LinkedField",
            "name": "catchupGetLastViewedTime",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "lastViewedTimeISO"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "4454a52ea4ab532f76ee4e80586f3a56",
            "id": "1b93f6dc06e9898ae5a96da49582122e7834ced458f11ee2b79ed14f9d9b3a87",
            "metadata": {},
            "name": "useDynamicSplitButtonCatchupLastViewedTimeQuery",
            "operationKind": "query",
            "text": "query useDynamicSplitButtonCatchupLastViewedTimeQuery($contentId:ID!,$contentType:CatchupContentType!){catchupGetLastViewedTime(contentId:$contentId,contentType:$contentType){lastViewedTimeISO}}"
        }
    };
}();
$3a0ab9c788e793cd$var$node.hash = "ca230a2a5e683b85178d392f9c872c98";
var $3a0ab9c788e793cd$export$2e2bcd8739ae039 = $3a0ab9c788e793cd$var$node;
module.exports["default"] = $3a0ab9c788e793cd$export$2e2bcd8739ae039;

});

parcelRegister("38Ncj", function(module, exports) {
/**
 * @generated SignedSource<<97620748d8d680bcf5801bcd64a5c19f>>
 * @relayHash 21cebd3db50676fd19d57554f2f4d6fc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904
const $630a58f9ca4672ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isContentTypePublicLinkEligible"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasInheritedRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "hasViewRestrictions"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ]
        },
        {
            "condition": "isContentTypePublicLinkEligible",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "contentId"
                        }
                    ],
                    "concreteType": "PublicLinkPage",
                    "kind": "LinkedField",
                    "name": "publicLinkPage",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "pageStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "accessType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useShareAndRestrictButtonDataQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21cebd3db50676fd19d57554f2f4d6fc",
            "id": "fcc453c87e447898e23b0fd063f4631ca349fe93580bd0dea45de46209594904",
            "metadata": {},
            "name": "useShareAndRestrictButtonDataQuery",
            "operationKind": "query",
            "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus,accessType}}"
        }
    };
}();
$630a58f9ca4672ab$var$node.hash = "336fe7f51ff27baeb231379611028a5d";
var $630a58f9ca4672ab$export$2e2bcd8739ae039 = $630a58f9ca4672ab$var$node;
module.exports["default"] = $630a58f9ca4672ab$export$2e2bcd8739ae039;

});

parcelRegister("MJaSd", function(module, exports) {

var $kgNLQ = parcelRequire("kgNLQ");

const $eeebfa790a4a25a5$export$533048ab2aed5b1a = -1;
// Default empty preload data structure (can be spread and isDataProcessed overridden)
const $eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA = {
    allComments: [],
    allFilteredComments: [],
    openInlineComments: [],
    openFooterComments: [],
    resolvedComments: [],
    openComments: [],
    commentsDataMap: {
        inline: {},
        general: {}
    },
    flatCommentsMap: {},
    hasNestedComments: false,
    commentCount: null,
    hasAnyComments: false,
    isDataProcessed: false
};
const $eeebfa790a4a25a5$export$7cc295d5a932445b = (processedPreloadData, preloadCacheData)=>{
    if (!processedPreloadData.isDataProcessed || !preloadCacheData?.comments) return false;
    const totalCount = preloadCacheData.comments.totalCount;
    // If totalCount is the loading flag, we're still loading
    if (totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a) return false;
    // Calculate loaded comment count (parent comments + replies)
    const loadedCommentCount = preloadCacheData.comments.nodes?.reduce((acc, comment)=>{
        if (!comment) return acc;
        return acc + (comment?.replies?.length || 0) + 1; // parent + reply count
    }, 0) ?? 0;
    // Check if we've loaded all available comments
    return loadedCommentCount === totalCount;
};
const $eeebfa790a4a25a5$export$e229b0e2973dcb38 = (processedCommentsData, preloadCacheData, contentStatus)=>{
    // Check cache value to determine if we're in a loading state (totalCount === -1)
    const isPreloadLoadingFromCache = preloadCacheData?.comments?.totalCount === $eeebfa790a4a25a5$export$533048ab2aed5b1a;
    // Process preload data
    // Don't process if we're loading (check cache value, not loading state)
    let processedPreloadData;
    if (isPreloadLoadingFromCache) processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    else if (preloadCacheData?.comments) {
        if (preloadCacheData.comments.nodes) {
            // This preloader explicitly opts in to reactions above, so its nodes satisfy the legacy
            // Comment model even though Relay correctly makes conditionally selected fields optional.
            const allComments = (preloadCacheData.comments.nodes || []).filter((node)=>node !== null);
            // Filter preload comments by the contentStatus prop (same as CommentsDataBackgroundLoader does)
            // This ensures we only show comments that match the current page's content status
            const categorized = (0, $kgNLQ.categorizeComments)(allComments, contentStatus);
            processedPreloadData = {
                allComments: allComments,
                ...categorized,
                isDataProcessed: true
            };
        } else processedPreloadData = {
            ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
            isDataProcessed: true
        };
    } else processedPreloadData = {
        ...$eeebfa790a4a25a5$var$EMPTY_PRELOAD_DATA,
        isDataProcessed: false
    };
    // Determine which data source to use
    // If ProcessedCommentsDataStore has processed data, use that
    // Otherwise, use the preload query data
    const hasFullData = processedCommentsData.isDataProcessed;
    // Calculate if all data has been preloaded
    const allDataPreloaded = $eeebfa790a4a25a5$export$7cc295d5a932445b(processedPreloadData, preloadCacheData);
    // Dynamically determine the data to return based on current state
    // isDataProcessed always comes from ProcessedCommentsDataStore
    // Only the comment data itself comes from preload when full data isn't available
    const finalData = hasFullData ? processedCommentsData : {
        ...processedCommentsData,
        // Override comment data with preload data, but keep isDataProcessed from store
        ...processedPreloadData,
        isDataProcessed: processedCommentsData.isDataProcessed,
        error: processedCommentsData.error
    };
    return {
        ...finalData,
        // Keep separate vars for preload loading status so we don't have to assert isPreloading && ... everywhere
        isPreloadLoading: isPreloadLoadingFromCache,
        isPreloadDataProcessed: processedPreloadData.isDataProcessed,
        allDataPreloaded: // Indicate whether the preload contained ALL comments
        allDataPreloaded,
        // Indicate whether we're currently using full data or preload data
        isUsingFullData: hasFullData
    };
};
module.exports["PRELOAD_LOADING_FLAG"] = $eeebfa790a4a25a5$export$533048ab2aed5b1a;
module.exports["getPreloadAwareObjectComments"] = $eeebfa790a4a25a5$export$e229b0e2973dcb38;

});

parcelRegister("cQbnm", function(module, exports) {
const $a2901bd3596bb581$export$c6ff0a0df62acf44 = 3;
const $a2901bd3596bb581$export$fa19d42490144c8 = (contentId, includeConversationData = false, includeCommentThreads = false, focusedCommentId, includeFocusedComment = false)=>({
        pageId: contentId,
        contentStatus: [
            'DRAFT',
            'CURRENT',
            'ARCHIVED'
        ],
        first: $a2901bd3596bb581$export$c6ff0a0df62acf44,
        includeCommentReactions: true,
        includeConversationData: includeConversationData,
        includeCommentThreads: includeCommentThreads,
        focusedCommentId: focusedCommentId ?? null,
        includeFocusedComment: includeFocusedComment
    });
module.exports["buildPreloadObjectCommentsQueryVariables"] = $a2901bd3596bb581$export$fa19d42490144c8;

});

parcelRegister("lj2R9", function(module, exports) {
/**
 * @generated SignedSource<<1e72b221db30c6dd58d4a18a3c908cd9>>
 * @relayHash 667db9b1207176451cb2198029bc1794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c
const $0d0305ae4f6822bb$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalCollaboratorCount"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "667db9b1207176451cb2198029bc1794",
            "id": "263c5187fe4d45dd66f4564bd6f052b5aa2b86c867264433913ce3020f843c0c",
            "metadata": {},
            "name": "ViewSpaceExternalCollaboratorsDialogQuery",
            "operationKind": "query",
            "text": "query ViewSpaceExternalCollaboratorsDialogQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
        }
    };
}();
$0d0305ae4f6822bb$var$node.hash = "722ca76340bcbe86e394e6f8663add12";
var $0d0305ae4f6822bb$export$2e2bcd8739ae039 = $0d0305ae4f6822bb$var$node;
module.exports["default"] = $0d0305ae4f6822bb$export$2e2bcd8739ae039;

});

parcelRegister("BrMrN", function(module, exports) {
/**
 * @generated SignedSource<<6f8fac148313e50a2a47839f6fce409e>>
 * @relayHash fd1963a9d2faefb7e31ad7e80c7ff686
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8fb85cfc50d17c92cb1806272faa77a6beba4ed8917f6a91ae784e3059fca725
const $e8059ce1e4b75624$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipLicenseQuery"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "skipSpaceQuery"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "condition": "skipSpaceQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "key",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "SpaceUserMetadata",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isAnonymouslyAuthorized"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "condition": "skipLicenseQuery",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "License",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseConsumingUserCount"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PersistentInviteEligibleQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PersistentInviteEligibleQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "fd1963a9d2faefb7e31ad7e80c7ff686",
            "id": "8fb85cfc50d17c92cb1806272faa77a6beba4ed8917f6a91ae784e3059fca725",
            "metadata": {},
            "name": "PersistentInviteEligibleQuery",
            "operationKind": "query",
            "text": "query PersistentInviteEligibleQuery($spaceKey:String,$skipLicenseQuery:Boolean!,$skipSpaceQuery:Boolean!){space(key:$spaceKey)@skip(if:$skipSpaceQuery){id,currentUser{isAnonymouslyAuthorized}},license@skip(if:$skipLicenseQuery){licenseConsumingUserCount,trialEndDate}}"
        }
    };
}();
$e8059ce1e4b75624$var$node.hash = "364b36bbc5d65271345dded2654a0688";
var $e8059ce1e4b75624$export$2e2bcd8739ae039 = $e8059ce1e4b75624$var$node;
module.exports["default"] = $e8059ce1e4b75624$export$2e2bcd8739ae039;

});

parcelRegister("eKTWO", function(module, exports) {

var $hU1C8 = parcelRequire("hU1C8");


var $jwbRi = parcelRequire("jwbRi");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jMyy4 = parcelRequire("jMyy4");

const $862814430f69e6aa$export$47d4842719bdb071 = (0, $jwbRi.default);
const $862814430f69e6aa$export$aad7e27ed56b51fc = (0, $hU1C8.default);
const $862814430f69e6aa$export$ba9e49b520a30a69 = ({ spaceKey: spaceKey, cloudId: cloudId })=>$862814430f69e6aa$var$useFetchSuggestionCountInternal({
        spaceKey: spaceKey,
        cloudId: cloudId
    });
const $862814430f69e6aa$export$d39f13847aa08df3 = ({ spaceKey: spaceKey, cloudId: cloudId, suggestionCountFragmentRef: suggestionCountFragmentRef })=>{
    const fragmentData = (0, $6SsN4.useFragment)($862814430f69e6aa$export$47d4842719bdb071, suggestionCountFragmentRef);
    return $862814430f69e6aa$var$useFetchSuggestionCountInternal({
        spaceKey: spaceKey,
        cloudId: cloudId
    }, fragmentData);
};
const $862814430f69e6aa$var$useFetchSuggestionCountInternal = ({ spaceKey: spaceKey, cloudId: cloudId }, fragmentData)=>{
    const usesRouteData = fragmentData !== undefined;
    const { data: apolloData, loading: apolloLoading, refetch: apolloRefetch } = (0, $jMyy4.useQueryInterop)($862814430f69e6aa$export$aad7e27ed56b51fc, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: !spaceKey || usesRouteData,
        interopApolloAggClient: true,
        __callerPackage__: "space-curation"
    });
    return (0, $cozmU.useMemo)(()=>{
        const hasChildQueryData = apolloData != null;
        const raw = hasChildQueryData ? apolloData.confluence_remoteObjectSuggestionCount : fragmentData?.confluence_remoteObjectSuggestionCount;
        const isLoading = usesRouteData && !hasChildQueryData ? false : apolloLoading;
        // null data is the suppression signal — this includes the case where the
        // backend returns errors alongside null data (e.g. NotFoundException when
        // the user has been permanently suppressed). Do not gate on apolloError.
        const isSuppressed = !isLoading && raw == null;
        return {
            count: raw ?? 0,
            isLoading: isLoading,
            isSuppressed: isSuppressed,
            refetch: ()=>{
                apolloRefetch();
            }
        };
    }, [
        apolloData,
        apolloLoading,
        apolloRefetch,
        fragmentData,
        usesRouteData
    ]);
};
module.exports["RemoteObjectSuggestionCountQuery"] = $862814430f69e6aa$export$aad7e27ed56b51fc;
module.exports["useFetchSuggestionCount"] = $862814430f69e6aa$export$ba9e49b520a30a69;
module.exports["useFetchSuggestionCountFromFragment"] = $862814430f69e6aa$export$d39f13847aa08df3;

});

parcelRegister("hU1C8", function(module, exports) {
/**
 * @generated SignedSource<<7ed3a2785ef14914cca4babcea9ce45a>>
 * @relayHash 2928057d03b4f5d5a1a268a9759b926b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492
const $41493c5c0e5e4e0b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFetchSuggestionCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "2928057d03b4f5d5a1a268a9759b926b",
            "id": "e2a667fff01500eb3e9307529089fae38f8ffbfdb7afefb552f82585ed918492",
            "metadata": {},
            "name": "useFetchSuggestionCountQuery",
            "operationKind": "query",
            "text": "query useFetchSuggestionCountQuery($cloudId:ID!,$spaceKey:String!){confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}"
        }
    };
}();
$41493c5c0e5e4e0b$var$node.hash = "050919681608acb31690dce800b52bae";
var $41493c5c0e5e4e0b$export$2e2bcd8739ae039 = $41493c5c0e5e4e0b$var$node;
module.exports["default"] = $41493c5c0e5e4e0b$export$2e2bcd8739ae039;

});

parcelRegister("jwbRi", function(module, exports) {
/**
 * @generated SignedSource<<38626ff8705a6c0de9b2d1e6d56973af>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b18ce3bc11082c03$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "cloudId"
        },
        {
            "kind": "RootArgument",
            "name": "spaceKey"
        }
    ],
    "kind": "Fragment",
    "name": "useFetchSuggestionCount_query",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
        }
    ],
    "type": "Query"
};
$b18ce3bc11082c03$var$node.hash = "b4d0196e6c2004ac771cb71891cd74af";
var $b18ce3bc11082c03$export$2e2bcd8739ae039 = $b18ce3bc11082c03$var$node;
module.exports["default"] = $b18ce3bc11082c03$export$2e2bcd8739ae039;

});

parcelRegister("2fQCH", function(module, exports) {
/**
 * @generated SignedSource<<e31e1608eadf975e0262c2451004a807>>
 * @relayHash 17ce0760fa14abe8321ce549d7b66dbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6b4982039896f5856be7fbc3eedca0e2d3e547ff332cc3c0a8801b61e44ba919
const $3b3e50e8050cb646$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "alias"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "didContainUserContent"
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FooterCreateButtonsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "17ce0760fa14abe8321ce549d7b66dbd",
            "id": "6b4982039896f5856be7fbc3eedca0e2d3e547ff332cc3c0a8801b61e44ba919",
            "metadata": {},
            "name": "FooterCreateButtonsQuery",
            "operationKind": "query",
            "text": "query FooterCreateButtonsQuery($spaceKey:String){space(key:$spaceKey){id,key,alias,spaceTypeSettings{enabledContentTypes{isLivePagesEnabled,isWhiteboardsEnabled,isDatabasesEnabled}},didContainUserContent,operations{operation,targetType}}}"
        }
    };
}();
$3b3e50e8050cb646$var$node.hash = "ba2d12ec394251913965e25fa4f52b4b";
var $3b3e50e8050cb646$export$2e2bcd8739ae039 = $3b3e50e8050cb646$var$node;
module.exports["default"] = $3b3e50e8050cb646$export$2e2bcd8739ae039;

});

parcelRegister("gsSsC", function(module, exports) {
/**
 * @generated SignedSource<<22eb52565a522d08d6ca261a792fda3a>>
 * @relayHash 1b389961e5e66b422fc68105162ea2a7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05
const $64636a4927b33bd4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAnonymouslyAuthorized"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1b389961e5e66b422fc68105162ea2a7",
            "id": "8852b3b3e2fe5695e392f9303e5a9bb51e986824492b6578223f976d6e0fdf05",
            "metadata": {},
            "name": "useIsUserViewingSpaceAsAnonQuery",
            "operationKind": "query",
            "text": "query useIsUserViewingSpaceAsAnonQuery($spaceKey:String){space(key:$spaceKey){id,currentUser{isAnonymouslyAuthorized}}}"
        }
    };
}();
$64636a4927b33bd4$var$node.hash = "298be37d19bd8e07f912f849fbe70f5a";
var $64636a4927b33bd4$export$2e2bcd8739ae039 = $64636a4927b33bd4$var$node;
module.exports["default"] = $64636a4927b33bd4$export$2e2bcd8739ae039;

});

parcelRegister("bMpHw", function(module, exports) {

var $cEGBg = parcelRequire("cEGBg");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/navigation/setting/manifest.ts
var $89381d0e9f5eb226$var$navigationSettingAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $cEGBg.NavigationSettingAriResourceOwner),
    resourceType: (0, $cEGBg.NavigationSettingAriResourceType),
    resourceIdSlug: "{firstPartyApp}/{siteId}/{activationId}/{settingId}",
    resourceIdSegmentFormats: {
        firstPartyApp: /[a-z0-9-]{1,100}/,
        siteId: /[a-zA-Z0-9_\-.]{1,255}/,
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        settingId: /[!a-zA-Z0-9\-_.~@:;{}=]+(\/[!a-zA-Z0-9\-_.~@:;{}=]+)*/
    }
};
// src/navigation/setting/index.ts
var $89381d0e9f5eb226$export$d9494d14fa8a72a2 = class _NavigationSettingAri extends (0, $9j37t.RegisteredAri) {
    get firstPartyApp() {
        return this._firstPartyApp;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get settingId() {
        return this._settingId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $89381d0e9f5eb226$var$navigationSettingAriStaticOpts.qualifier,
            platformQualifier: $89381d0e9f5eb226$var$navigationSettingAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $89381d0e9f5eb226$var$navigationSettingAriStaticOpts.resourceOwner,
            resourceType: $89381d0e9f5eb226$var$navigationSettingAriStaticOpts.resourceType,
            resourceId: `${opts.firstPartyApp}/${opts.siteId}/${opts.activationId}/${opts.settingId}`,
            resourceIdSegmentValues: {
                firstPartyApp: opts.firstPartyApp,
                siteId: opts.siteId,
                activationId: opts.activationId,
                settingId: opts.settingId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $89381d0e9f5eb226$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $89381d0e9f5eb226$var$navigationSettingAriStaticOpts);
        return new _NavigationSettingAri(opts);
    }
    getVariables() {
        return {
            firstPartyApp: this.firstPartyApp,
            siteId: this.siteId,
            activationId: this.activationId,
            settingId: this.settingId
        };
    }
    constructor(opts){
        super(opts), this._firstPartyApp = opts.resourceIdSegmentValues.firstPartyApp, this._siteId = opts.resourceIdSegmentValues.siteId, this._activationId = opts.resourceIdSegmentValues.activationId, this._settingId = opts.resourceIdSegmentValues.settingId;
    }
};
module.exports["NavigationSettingAri"] = $89381d0e9f5eb226$export$d9494d14fa8a72a2;

});

parcelRegister("cEGBg", function(module, exports) {
// src/navigation/setting/types.ts
var $936a43f66cf48d67$export$efad67ea8db3f12e = "navigation", $936a43f66cf48d67$export$fd28c74ac3f5b728 = "setting";
module.exports["NavigationSettingAriResourceOwner"] = $936a43f66cf48d67$export$efad67ea8db3f12e;
module.exports["NavigationSettingAriResourceType"] = $936a43f66cf48d67$export$fd28c74ac3f5b728;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<30433c300b34114d28e5a73869e7e5f1>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "ed56952e91ea2d83611b306fd16f1677";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("e5i8U", function(module, exports) {
/**
 * @generated SignedSource<<5a7cafa777379c54dbddb23ee36a1082>>
 * @relayHash e2df23bdc78f713de65477722c69e437
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54
const $352d8776ce9e612e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsDataSpaceRootQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "e2df23bdc78f713de65477722c69e437",
            "id": "a39b7f0aab0b5e8324355dad0345b8cded996fb24379f7510a65f6a6f61c1c54",
            "metadata": {},
            "name": "useSpaceViewsDataSpaceRootQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsDataSpaceRootQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$352d8776ce9e612e$var$node.hash = "cf7ed5a52874f0b9ce129552e428e0b7";
var $352d8776ce9e612e$export$2e2bcd8739ae039 = $352d8776ce9e612e$var$node;
module.exports["default"] = $352d8776ce9e612e$export$2e2bcd8739ae039;

});

parcelRegister("1oGPE", function(module, exports) {
const $00840277cc5ce9b5$export$90091b93f6cf4241 = 80;
const $00840277cc5ce9b5$export$3cf9a7263d7d2d28 = 100; // INITIAL_PAGE_SIZE was previously 160 but we reduced it to 80. Should we also reduce this?
module.exports["INITIAL_PAGE_SIZE"] = $00840277cc5ce9b5$export$90091b93f6cf4241;
module.exports["CHILDREN_PAGE_SIZE"] = $00840277cc5ce9b5$export$3cf9a7263d7d2d28;

});

parcelRegister("9eCf8", function(module, exports) {
/**
 * @generated SignedSource<<65ddc58d625028461cf53f05076a93e9>>
 * @relayHash 661233a47ecadf36bf6b55db313a301e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9
const $b0adf32477ccbbfa$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v6 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v7 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v8 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "title"
    }, v11 = {
        "kind": "ScalarField",
        "name": "status"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v12 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v15 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v16 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "type"
    }, v18 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v19 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v20 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor",
                    "jira-planner-connection"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v9 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v12 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"])"
    }, v21 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v22 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v21 /*: any*/ 
            ]
        }
    ], v23 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v24 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v22 /*: any*/ 
    }, v25 = [
        {
            "alias": "currentPage",
            "args": [
                v5 /*: any*/ ,
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v18 /*: any*/ ,
                                v19 /*: any*/ ,
                                v20 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ 
                            ]
                        }
                    ]
                },
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": v22 /*: any*/ 
                }
            ]
        },
        {
            "args": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ 
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v24 /*: any*/ 
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v9 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v9 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeQuery",
            "selections": v25 /*: any*/ 
        },
        "params": {
            "cacheID": "661233a47ecadf36bf6b55db313a301e",
            "id": "606baac6ffac521e762bb6b0a6f0aebbd60f1bd9366f43f4a561b5a0c55143c9",
            "metadata": {},
            "name": "PageTreeQuery",
            "operationKind": "query",
            "text": "query PageTreeQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},children{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\",\"jira-planner-connection\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$b0adf32477ccbbfa$var$node.hash = "f7e2a69b86e03d256ceaf9a0f482bed1";
var $b0adf32477ccbbfa$export$2e2bcd8739ae039 = $b0adf32477ccbbfa$var$node;
module.exports["default"] = $b0adf32477ccbbfa$export$2e2bcd8739ae039;

});

parcelRegister("fL5TY", function(module, exports) {
/**
 * @generated SignedSource<<e2be3df7e36c1a69e702384a7f29b58e>>
 * @relayHash 32d094adde43b53166e21c73e0e18466
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db
const $b517e71d543026da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "endCursor"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orderBy"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "after",
                    "variableName": "endCursor"
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                },
                {
                    "kind": "Variable",
                    "name": "orderby",
                    "variableName": "orderBy"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "blogpost"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasNextPage"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "blank"
                        },
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "keys",
                                    "value": [
                                        "emoji-title-published",
                                        "emoji-title-draft",
                                        "editor"
                                    ]
                                }
                            ],
                            "concreteType": "PaginatedJsonContentPropertyList",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JsonContentProperty",
                                    "kind": "LinkedField",
                                    "name": "nodes",
                                    "plural": true,
                                    "selections": [
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
                        },
                        {
                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                }
                            ]
                        },
                        {
                            "concreteType": "ContentMetadata",
                            "kind": "LinkedField",
                            "name": "metadata",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "lastModifiedDate"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "createdDate"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BlogTreeRootComponentQuery",
            "selections": v6 /*: any*/ 
        },
        "params": {
            "cacheID": "32d094adde43b53166e21c73e0e18466",
            "id": "8ba3ae6faaa2b1672d7eef93310782aed4bc09c157af62ec4f49eb5fa49b05db",
            "metadata": {},
            "name": "BlogTreeRootComponentQuery",
            "operationKind": "query",
            "text": "query BlogTreeRootComponentQuery($spaceKey:String!,$first:Int,$endCursor:String,$statuses:[String],$orderBy:String){content(spaceKey:$spaceKey,type:\"blogpost\",first:$first,orderby:$orderBy,after:$endCursor,status:$statuses){pageInfo{hasNextPage,endCursor},nodes{id,title,status,blank,properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value}},links{webui},metadata{lastModifiedDate,createdDate}}}}"
        }
    };
}();
$b517e71d543026da$var$node.hash = "d3491fdf4e3b619ed45b83d834c8fb95";
var $b517e71d543026da$export$2e2bcd8739ae039 = $b517e71d543026da$var$node;
module.exports["default"] = $b517e71d543026da$export$2e2bcd8739ae039;

});

parcelRegister("6DMfJ", function(module, exports) {
const $4d5bd09a97238678$export$e3c11860ad35ba05 = [
    'current',
    'draft'
];
const $4d5bd09a97238678$export$70918a400db2b6af = 'VIRTUAL_ROOT_ID';
const $4d5bd09a97238678$export$8ec3d08588d2eeda = 40;
const $4d5bd09a97238678$export$130b26c73bb9d040 = 16;
module.exports["BLOG_STATUSES"] = $4d5bd09a97238678$export$e3c11860ad35ba05;
module.exports["VIRTUAL_ROOT_ID"] = $4d5bd09a97238678$export$70918a400db2b6af;
module.exports["PAGE_SIZE"] = $4d5bd09a97238678$export$8ec3d08588d2eeda;
module.exports["INDENT_PER_LEVEL"] = $4d5bd09a97238678$export$130b26c73bb9d040;

});

parcelRegister("ivyMZ", function(module, exports) {
var $4eb170397cdf11a9$export$bcac0c74873fee96 = /*#__PURE__*/ function(GraphQLPageStatus) {
    GraphQLPageStatus["CURRENT"] = "CURRENT";
    GraphQLPageStatus["DRAFT"] = "DRAFT";
    return GraphQLPageStatus;
}({});
const $4eb170397cdf11a9$export$48ccce95f626ae31 = [
    "CURRENT",
    "DRAFT"
];
module.exports["PAGE_TREE_STATUSES"] = $4eb170397cdf11a9$export$48ccce95f626ae31;

});

parcelRegister("gRzR4", function(module, exports) {
/**
 * @generated SignedSource<<341ba977a22fe8ce5f0b424dc49f2708>>
 * @relayHash b761690351fd38a63053eefb2d1de3c0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2
const $7836e6257492ac35$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "creatorId"
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        }
                    ]
                },
                {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                },
                {
                    "concreteType": "ContentProperties",
                    "kind": "LinkedField",
                    "name": "contentProperties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "DraftContentProperties",
                            "kind": "LinkedField",
                            "name": "draft",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "PublishedContentProperties",
                            "kind": "LinkedField",
                            "name": "latest",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SmartCreateFeedbackBannerQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "b761690351fd38a63053eefb2d1de3c0",
            "id": "8983e89338e9db4549f597c6a2f7f4aa36777c139be8c74459f3b001a0c76de2",
            "metadata": {},
            "name": "SmartCreateFeedbackBannerQuery",
            "operationKind": "query",
            "text": "query SmartCreateFeedbackBannerQuery($contentId:ID!){singleContent(id:$contentId){title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}}"
        }
    };
}();
$7836e6257492ac35$var$node.hash = "da911efda658d22b5292ee38ba4e3f5f";
var $7836e6257492ac35$export$2e2bcd8739ae039 = $7836e6257492ac35$var$node;
module.exports["default"] = $7836e6257492ac35$export$2e2bcd8739ae039;

});

parcelRegister("dd33Q", function(module, exports) {
/**
 * @generated SignedSource<<aa6a269424bc1b4fc1bcb7ed6da5dcee>>
 * @relayHash 10a6e74201e75f7fd05257845e870e22
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2
const $b17ca59e188f1f50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "concreteType": "SpaceTypeSettings",
                    "kind": "LinkedField",
                    "name": "spaceTypeSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "EnabledContentTypes",
                            "kind": "LinkedField",
                            "name": "enabledContentTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isBlogsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isDatabasesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isEmbedsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isLivePagesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isSlidesEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isWhiteboardsEnabled"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "isFoldersEnabled"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceEnabledContentTypesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "10a6e74201e75f7fd05257845e870e22",
            "id": "5f78c38bf43db12554ba0f37ad39b4afd115d6ef16213fadbd51e8708bc161d2",
            "metadata": {},
            "name": "useSpaceEnabledContentTypesQuery",
            "operationKind": "query",
            "text": "query useSpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id,key,spaceTypeSettings{enabledContentTypes{isBlogsEnabled,isDatabasesEnabled,isEmbedsEnabled,isLivePagesEnabled,isSlidesEnabled,isWhiteboardsEnabled,isFoldersEnabled}}}}"
        }
    };
}();
$b17ca59e188f1f50$var$node.hash = "b239b4c898f62763088962d6011df617";
var $b17ca59e188f1f50$export$2e2bcd8739ae039 = $b17ca59e188f1f50$var$node;
module.exports["default"] = $b17ca59e188f1f50$export$2e2bcd8739ae039;

});

parcelRegister("fxqZn", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $d28d5aedb34440f3$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>
</svg>
`;
const $d28d5aedb34440f3$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>
</svg>
`;
const $d28d5aedb34440f3$export$5fc1066e677788d4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BitbucketIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Bitbucket" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $d28d5aedb34440f3$var$svg,
            customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function BitbucketIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Bitbucket', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $d28d5aedb34440f3$var$svg,
        customThemeSvg: $d28d5aedb34440f3$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["BitbucketIcon"] = $d28d5aedb34440f3$export$5fc1066e677788d4;

});

parcelRegister("aR3ec", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $1f4e40c711db0c72$var$styles = {
    root: "_3iDTPbvbI6",
    TEMP_assets: "_0C0F9q1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudLightAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jyBRVV _0C0F9q1qiM",
    inverse: "_36J4jyCl79 _0C0F9qt28M",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$cloudDarkAppearanceMap = {
    brand: "_36J4jyyL8i _0C0F9qyL8i",
    neutral: "_36J4jynrF4 _0C0F9qMlgR",
    inverse: "_36J4jyt28M _0C0F9qCl79",
    legacy: "_36J4jyt28M _0C0F9q2bHZ"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterLightAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM",
    neutral: "_36J4jyBRVV _0C0F9q1qiM _0g0wFMBRVV",
    inverse: "_36J4jyt28M _0C0F9qRvDB _0g0wFMt28M",
    legacy: "_36J4jy2bHZ _0C0F9qt28M _0g0wFM1qiM"
}; /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap = {
    brand: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR",
    neutral: "_36J4jynrF4 _0C0F9qMlgR _0g0wFMnrF4",
    inverse: "_36J4jyMmzW _0C0F9qt28M _0g0wFMMmzW",
    legacy: "_36J4jy2bHZ _0C0F9qRvDB _0g0wFMMlgR"
};
const $1f4e40c711db0c72$var$rovoDarkAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6nrF4 _05MzPYnrF4 _0Yajk0nrF4 _40KAGSnrF4",
    inverse: "_2PY8Z6RvDB _05MzPYRvDB _0Yajk0RvDB _40KAGSRvDB",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
};
const $1f4e40c711db0c72$var$rovoLightAppearanceMap = {
    brand: "_2PY8Z6yL8i _05MzPYyL8i _0Yajk0yL8i _40KAGSyL8i",
    neutral: "_2PY8Z6BRVV _05MzPYBRVV _0Yajk0BRVV _40KAGSBRVV",
    inverse: "_2PY8Z6t28M _05MzPYt28M _0Yajk0t28M _40KAGSt28M",
    legacy: "_2PY8Z62bHZ _05MzPY2bHZ _0Yajk02bHZ _40KAGS2bHZ"
}; /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ 
/* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ const $1f4e40c711db0c72$var$sizeMap = {
    xxsmall: "_0jFU0Vey7F",
    xsmall: "_0jFU0VSPN1",
    small: "_0jFU0VoWWg",
    medium: "_0jFU0VUofl",
    large: "_0jFU0VUF4f",
    xlarge: "_0jFU0VpJKa",
    '12': "_0jFU0VxpxF",
    '16': "_0jFU0Vey7F",
    '20': "_0jFU0VSPN1",
    '24': "_0jFU0VoWWg",
    '32': "_0jFU0VUofl"
};
const $1f4e40c711db0c72$export$be58b4326e23250f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IconWrapper(t0) {
    const $ = (0, $bDgLe.c)(18);
    const { size: t1, label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: t2, iconColor: customIconColor, isAssets: t3, type: t4 } = t0;
    const size = t1 === undefined ? "20" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const isAssets = t3 === undefined ? false : t3;
    const type = t4 === undefined ? "tile" : t4;
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t5 = customIconColor || "initial";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            "--themed-icon-color": t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const t7 = t6;
    const t8 = label ? label : undefined;
    const t9 = label ? "img" : undefined;
    const t10 = label === "" ? true : undefined;
    const t11 = isCustomThemed ? customThemeSvg : svg;
    let t12;
    if ($[2] !== t11) {
        t12 = {
            __html: t11
        };
        $[2] = t11;
        $[3] = t12;
    } else t12 = $[3];
    const t13 = $1f4e40c711db0c72$var$sizeMap[size];
    const t14 = colorMode === "dark" ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance];
    const t15 = type === "rovo" ? colorMode === "dark" ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance];
    let t16;
    if ($[4] !== appearance || $[5] !== isAssets || $[6] !== t13 || $[7] !== t14 || $[8] !== t15) {
        t16 = (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            t13,
            t14,
            t15,
            isAssets && appearance === "brand" && ((0, $iDrrr.fg)("assets-platform-branding") || (0, $iDrrr.fg)("assets-platform-branding-v2")) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ]);
        $[4] = appearance;
        $[5] = isAssets;
        $[6] = t13;
        $[7] = t14;
        $[8] = t15;
        $[9] = t16;
    } else t16 = $[9];
    let t17;
    if ($[10] !== t10 || $[11] !== t12 || $[12] !== t16 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9 || $[16] !== testId) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId,
            style: t7,
            "aria-label": t8,
            role: t9,
            "aria-hidden": t10,
            dangerouslySetInnerHTML: t12,
            className: t16
        });
        $[10] = t10;
        $[11] = t12;
        $[12] = t16;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = t17;
    } else t17 = $[17];
    return t17;
} : function IconWrapper({ size: size = '20', label: label, svg: svg, customThemeSvg: customThemeSvg, testId: userDefinedTestId, appearance: appearance = 'brand', iconColor: customIconColor, isAssets: isAssets = false, type: type = 'tile' }) {
    const testId = userDefinedTestId && `${userDefinedTestId}--wrapper`;
    const isCustomThemed = customThemeSvg && customIconColor;
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            '--themed-icon-color': customIconColor || 'initial'
        },
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        "aria-hidden": label === '' ? true : undefined,
        // This is because the SVG elements are static and will not change, so we get a little performance benefit by
        // bypassing React.
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $hekY6.default)([
            $1f4e40c711db0c72$var$styles.root,
            $1f4e40c711db0c72$var$sizeMap[size],
            colorMode === 'dark' ? $1f4e40c711db0c72$var$dataCenterDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$dataCenterLightAppearanceMap[appearance],
            type === 'rovo' ? colorMode === 'dark' ? $1f4e40c711db0c72$var$rovoDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$rovoLightAppearanceMap[appearance] : colorMode === 'dark' ? $1f4e40c711db0c72$var$cloudDarkAppearanceMap[appearance] : $1f4e40c711db0c72$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === 'brand' && ((0, $iDrrr.fg)('assets-platform-branding') || (0, $iDrrr.fg)('assets-platform-branding-v2')) && $1f4e40c711db0c72$var$styles.TEMP_assets
        ])
    });
};
module.exports["IconWrapper"] = $1f4e40c711db0c72$export$be58b4326e23250f;

});

parcelRegister("hZx6a", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $08074ca1ab8ce06c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>
    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>
</svg>
`;
const $08074ca1ab8ce06c$export$f7857fe64d7161d9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CompassIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Compass" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $08074ca1ab8ce06c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function CompassIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Compass', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $08074ca1ab8ce06c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["CompassIcon"] = $08074ca1ab8ce06c$export$f7857fe64d7161d9;

});

parcelRegister("5k2zo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $ad20b5467f7f9ada$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>
    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>
</svg>
`;
const $ad20b5467f7f9ada$export$9eb74917ea768ed4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GoalsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Goals" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $ad20b5467f7f9ada$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function GoalsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Goals', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $ad20b5467f7f9ada$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["GoalsIcon"] = $ad20b5467f7f9ada$export$9eb74917ea768ed4;

});

parcelRegister("lb2PL", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c420f5a156d6b7cf$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>
</svg>
`;
const $c420f5a156d6b7cf$export$8d789f76fde3e05 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoomIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Loom" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c420f5a156d6b7cf$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function LoomIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Loom', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c420f5a156d6b7cf$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["LoomIcon"] = $c420f5a156d6b7cf$export$8d789f76fde3e05;

});

parcelRegister("8JGXU", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $24d0e9af25866402$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>
</svg>
`;
const $24d0e9af25866402$var$customThemeSvg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>
</svg>
`;
const $24d0e9af25866402$export$4384da9b8b140bf4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TrelloIcon(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { iconColor: iconColor, size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Trello" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== iconColor || $[2] !== label || $[3] !== size || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $24d0e9af25866402$var$svg,
            customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
            iconColor: iconColor,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = iconColor;
        $[2] = label;
        $[3] = size;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function TrelloIcon({ iconColor: iconColor, size: size = 'medium', appearance: appearance = 'brand', label: label = 'Trello', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $24d0e9af25866402$var$svg,
        customThemeSvg: $24d0e9af25866402$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["TrelloIcon"] = $24d0e9af25866402$export$4384da9b8b140bf4;

});

parcelRegister("9NPFC", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


const $60cc37ad75899268$var$tileSizePx = {
    xxsmall: 16,
    xsmall: 20,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
const $60cc37ad75899268$var$styles = {
    root: "_0bjKvD0O7w _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _2O5VijdnbC _4ouGXIdnbC _4kiQYAdnbC _1RrJLit2nV",
    border: "_2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    inset: "_3B3jB1IZbP _0LETLXIZbP _4ACwSfIZbP _2Qxi4nIZbP",
    nonInset: "_49oNbqN91d _1tJeXfN91d _0VARMJN91d _27VeLCN91d _3B3jB1N91d _0LETLXN91d _4ACwSfN91d _2Qxi4nN91d _3G0Ib8iObl"
};
const $60cc37ad75899268$var$sizeMap = {
    xxsmall: "_39xV02ey7F _0jFU0Vey7F _4ya3eEuFDC",
    xsmall: "_39xV02SPN1 _0jFU0VSPN1 _4ya3eExpxF",
    small: "_39xV02oWWg _0jFU0VoWWg _4ya3eEEbN9",
    medium: "_39xV02Uofl _0jFU0VUofl _4ya3eEey7F",
    large: "_39xV02UF4f _0jFU0VUF4f _4ya3eESPN1",
    xlarge: "_39xV02pJKa _0jFU0VpJKa _4ya3eEoWWg"
};
const $60cc37ad75899268$var$insetSizeMap = {
    xxsmall: "_49oNbquFDC _1tJeXfuFDC _0VARMJuFDC _27VeLCuFDC _0mzAWiNKBH _3woHNtNKBH _430i96NKBH _1GBPVvNKBH",
    xsmall: "_49oNbqxpxF _1tJeXfxpxF _0VARMJxpxF _27VeLCxpxF _0mzAWiqBG1 _3woHNtqBG1 _430i96qBG1 _1GBPVvqBG1",
    small: "_49oNbqEbN9 _1tJeXfEbN9 _0VARMJEbN9 _27VeLCEbN9 _0mzAWif9wp _3woHNtf9wp _430i96f9wp _1GBPVvf9wp",
    medium: "_49oNbqey7F _1tJeXfey7F _0VARMJey7F _27VeLCey7F _0mzAWiIRC9 _3woHNtIRC9 _430i96IRC9 _1GBPVvIRC9",
    large: "_49oNbqSPN1 _1tJeXfSPN1 _0VARMJSPN1 _27VeLCSPN1 _0mzAWiPcut _3woHNtPcut _430i96Pcut _1GBPVvPcut",
    xlarge: "_49oNbqoWWg _1tJeXfoWWg _0VARMJoWWg _27VeLCoWWg _0mzAWiY6u9 _3woHNtY6u9 _430i96Y6u9 _1GBPVvY6u9"
};
const $60cc37ad75899268$var$backgroundColorMap = {
    white: "_0KLXrut28M",
    black: "_0KLXru52mJ",
    transparent: "_0KLXrujOvk",
    'color.background.accent.lime.subtlest': "_0KLXruXL80",
    'color.background.accent.lime.subtler': "_0KLXruuKDS",
    'color.background.accent.lime.subtle': "_0KLXruZcd0",
    'color.background.accent.lime.bolder': "_0KLXrubYhN",
    'color.background.accent.red.subtlest': "_0KLXrusDFP",
    'color.background.accent.red.subtler': "_0KLXrubV9i",
    'color.background.accent.red.subtle': "_0KLXru0cUQ",
    'color.background.accent.red.bolder': "_0KLXruQrW1",
    'color.background.accent.orange.subtlest': "_0KLXru2QQR",
    'color.background.accent.orange.subtler': "_0KLXruwJ86",
    'color.background.accent.orange.subtle': "_0KLXruuwVU",
    'color.background.accent.orange.bolder': "_0KLXrux4f7",
    'color.background.accent.yellow.subtlest': "_0KLXru56u3",
    'color.background.accent.yellow.subtler': "_0KLXruLv9B",
    'color.background.accent.yellow.subtle': "_0KLXruC29w",
    'color.background.accent.yellow.bolder': "_0KLXruYB6L",
    'color.background.accent.green.subtlest': "_0KLXruV6wL",
    'color.background.accent.green.subtler': "_0KLXruNUep",
    'color.background.accent.green.subtle': "_0KLXru50ZN",
    'color.background.accent.green.bolder': "_0KLXrude1t",
    'color.background.accent.teal.subtlest': "_0KLXruuBpz",
    'color.background.accent.teal.subtler': "_0KLXrunfgW",
    'color.background.accent.teal.subtle': "_0KLXrufjGw",
    'color.background.accent.teal.bolder': "_0KLXruzHaB",
    'color.background.accent.blue.subtlest': "_0KLXruVva3",
    'color.background.accent.blue.subtler': "_0KLXrup9dS",
    'color.background.accent.blue.subtle': "_0KLXru28sy",
    'color.background.accent.blue.bolder': "_0KLXrutfbE",
    'color.background.accent.purple.subtlest': "_0KLXruB8KG",
    'color.background.accent.purple.subtler': "_0KLXruWOdT",
    'color.background.accent.purple.subtle': "_0KLXruf89Q",
    'color.background.accent.purple.bolder': "_0KLXruhdss",
    'color.background.accent.magenta.subtlest': "_0KLXru8frT",
    'color.background.accent.magenta.subtler': "_0KLXruXM4x",
    'color.background.accent.magenta.subtle': "_0KLXrupmfs",
    'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
    'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
    'color.background.accent.gray.subtler': "_0KLXruG6qS",
    'color.background.accent.gray.subtle': "_0KLXrueZ10",
    'color.background.accent.gray.bolder': "_0KLXrurxgm",
    'color.background.inverse.subtle': "_0KLXruB4sa",
    'color.background.neutral': "_0KLXruDMqu",
    'color.background.neutral.bold': "_0KLXrugozt",
    'color.background.brand.subtlest': "_0KLXrunl7T",
    'color.background.brand.bold': "_0KLXruDM2k",
    'color.background.brand.boldest': "_0KLXru2o0p",
    'color.background.danger': "_0KLXruhH7k",
    'color.background.danger.bold': "_0KLXruqsXs",
    'color.background.warning': "_0KLXruhxIM",
    'color.background.warning.bold': "_0KLXruKLKE",
    'color.background.success': "_0KLXruzaZe",
    'color.background.success.bold': "_0KLXruhbjP",
    'color.background.discovery': "_0KLXru94rk",
    'color.background.discovery.bold': "_0KLXruqjHC",
    'color.background.information': "_0KLXrugNg3",
    'color.background.information.bold': "_0KLXruASYT"
}; /**
    * __Tile__
    *
    * A tile is a rounded square that takes an asset and represents a noun.
    *
    */ 
const $60cc37ad75899268$var$Tile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Tile(props) {
    const $ = (0, $bDgLe.c)(17);
    const { children: children, label: label, size: t0, backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: t1, testId: testId } = props;
    const size = t0 === undefined ? "medium" : t0;
    const isInset = t1 === undefined ? true : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    let t2;
    if ($[0] !== size) {
        t2 = ()=>{
            return;
        };
        $[0] = size;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== children || $[3] !== size) {
        t3 = [
            children,
            size
        ];
        $[2] = children;
        $[3] = size;
        $[4] = t3;
    } else t3 = $[4];
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = label !== "" ? label : undefined;
    const t5 = label !== "" ? "img" : undefined;
    const t6 = $60cc37ad75899268$var$sizeMap[size];
    const t7 = isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset;
    const t8 = isInset && $60cc37ad75899268$var$insetSizeMap[size];
    const t9 = $60cc37ad75899268$var$backgroundColorMap[backgroundColor || "color.background.neutral"];
    const t10 = hasBorder && $60cc37ad75899268$var$styles.border;
    let t11;
    if ($[5] !== t10 || $[6] !== t6 || $[7] !== t7 || $[8] !== t8 || $[9] !== t9) {
        t11 = (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            t6,
            t7,
            t8,
            t9,
            t10
        ]);
        $[5] = t10;
        $[6] = t6;
        $[7] = t7;
        $[8] = t8;
        $[9] = t9;
        $[10] = t11;
    } else t11 = $[10];
    let t12;
    if ($[11] !== children || $[12] !== t11 || $[13] !== t4 || $[14] !== t5 || $[15] !== testId) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: containerRef,
            "data-testid": testId,
            "aria-label": t4,
            role: t5,
            className: t11,
            children: children
        });
        $[11] = children;
        $[12] = t11;
        $[13] = t4;
        $[14] = t5;
        $[15] = testId;
        $[16] = t12;
    } else t12 = $[16];
    return t12;
} : function Tile(props) {
    const { children: children, label: label, size: size = 'medium', backgroundColor: backgroundColor, hasBorder: hasBorder, isInset: isInset = true, testId: testId } = props;
    const containerRef = (0, $cozmU.useRef)(null); // Dev-mode only: validate that raster images passed into the tile
    // are square and retina-compatible (at least 2x the rendered tile size).
    (0, $cozmU.useEffect)(()=>{
        return;
    }, [
        children,
        size
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        ref: containerRef,
        "data-testid": testId,
        "aria-label": label !== '' ? label : undefined,
        role: label !== '' ? 'img' : undefined,
        className: (0, $hekY6.default)([
            $60cc37ad75899268$var$styles.root,
            $60cc37ad75899268$var$sizeMap[size],
            isInset ? $60cc37ad75899268$var$styles.inset : $60cc37ad75899268$var$styles.nonInset,
            isInset && $60cc37ad75899268$var$insetSizeMap[size],
            $60cc37ad75899268$var$backgroundColorMap[backgroundColor || 'color.background.neutral'],
            hasBorder && $60cc37ad75899268$var$styles.border
        ]),
        children: children
    });
};
var $60cc37ad75899268$export$2e2bcd8739ae039 = $60cc37ad75899268$var$Tile;
function $60cc37ad75899268$var$_temp(fn) {
    return fn();
}
module.exports["default"] = $60cc37ad75899268$export$2e2bcd8739ae039;

});

parcelRegister("juGf9", function(module, exports) {

var $3jjX7 = parcelRequire("3jjX7");


var $cuWGz = parcelRequire("cuWGz");

const $ecfa6d495e5c6c71$var$LOOM_ORIGINS = {
    prod: 'https://www.loom.com',
    staging: 'https://stage.loom.com'
};
const $ecfa6d495e5c6c71$var$LOOM_AUTH_ORIGINS = {
    prod: 'https://loom.com',
    staging: 'https://stage.loom.com'
};
const $ecfa6d495e5c6c71$export$4fb22c0479a52850 = ({ bridge: bridge, cloudId: cloudId, environment: environment, interactionSessionId: interactionSessionId, interactionSource: interactionSource, loomSource: loomSource })=>{
    const resolvedEnvironment = environment ?? ((0, $cuWGz.getEnvironment)() === 'prod' ? 'prod' : 'staging');
    const resolvedInteractionSessionId = interactionSessionId ?? (0, $3jjX7.default).getInstance()?.getCurrentInteractionSessionId();
    if (!resolvedInteractionSessionId) throw new Error('Cannot open Loom Meeting Recordings without an interaction session ID.');
    const loomUrl = new URL('/twc/meetings', $ecfa6d495e5c6c71$var$LOOM_ORIGINS[resolvedEnvironment]);
    loomUrl.searchParams.set('origin', window.location.origin);
    loomUrl.searchParams.set('siteId', cloudId);
    loomUrl.searchParams.set('source', loomSource);
    loomUrl.searchParams.set('state', crypto.randomUUID());
    loomUrl.searchParams.set('xpis', window.btoa(JSON.stringify({
        bridge: bridge,
        id: resolvedInteractionSessionId,
        source: interactionSource
    })));
    const authUrl = new URL('/api/auth/atlassian', $ecfa6d495e5c6c71$var$LOOM_AUTH_ORIGINS[resolvedEnvironment]);
    authUrl.searchParams.set('redirect_after', loomUrl.toString());
    return window.open(authUrl.toString());
};
module.exports["openLoomMeetingRecordings"] = $ecfa6d495e5c6c71$export$4fb22c0479a52850;

});

parcelRegister("3jjX7", function(module, exports) {
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $6e6234f2764332e7$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $6e6234f2764332e7$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($6e6234f2764332e7$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$6e6234f2764332e7$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}
module.exports["default"] = $6e6234f2764332e7$export$2e2bcd8739ae039;

});

parcelRegister("cuWGz", function(module, exports) {

var $e66dL = parcelRequire("e66dL");


var $aO6uT = parcelRequire("aO6uT");

function $61987beec044a597$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $aO6uT.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $e66dL.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $aO6uT.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $61987beec044a597$var$classifyComDomain(host);
        case 'net':
            return $61987beec044a597$var$classifyNetDomain(host);
        default:
            return (0, $aO6uT.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $61987beec044a597$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $aO6uT.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $aO6uT.Environment).Staging : (0, $aO6uT.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $aO6uT.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $aO6uT.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $aO6uT.Environment).Staging;
        return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $61987beec044a597$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $aO6uT.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
        return (0, $aO6uT.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $aO6uT.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $aO6uT.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $aO6uT.Environment).Prod;
            return (0, $aO6uT.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $aO6uT.Environment).Development;
        if (host.includes('.staging.')) return (0, $aO6uT.Environment).Staging;
        if (host.includes('.prod.')) return (0, $aO6uT.Environment).Prod;
    }
    return (0, $aO6uT.Environment).Unknown;
}
module.exports["getEnvironment"] = $61987beec044a597$export$57570b1603cf6adb;

});

parcelRegister("e66dL", function(module, exports) {

var $aO6uT = parcelRequire("aO6uT");

const $1c6adf460a912312$export$636c0c57a2ce36e9 = {
    localhost: (0, $aO6uT.Environment).Development,
    '127.0.0.1': (0, $aO6uT.Environment).Development,
    'id.atlassian.com': (0, $aO6uT.Environment).Prod,
    'admin.atlassian.com': (0, $aO6uT.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $aO6uT.Environment).Staging,
    'admin.stg.atlassian.com': (0, $aO6uT.Environment).Staging
};
module.exports["EXACT_HOST_MAP"] = $1c6adf460a912312$export$636c0c57a2ce36e9;

});

parcelRegister("aO6uT", function(module, exports) {
var $cf10c8edb5d48b94$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});
module.exports["Environment"] = $cf10c8edb5d48b94$export$7dc6752a22ab011a;

});

parcelRegister("etoPX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $63a5cd591bbe1860$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>
    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>
    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>
    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>
</svg>
`;
const $63a5cd591bbe1860$export$e23ae35269442b4f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RovoIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Rovo" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $63a5cd591bbe1860$var$svg,
            label: label,
            type: "rovo",
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function RovoIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Rovo', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $63a5cd591bbe1860$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["RovoIcon"] = $63a5cd591bbe1860$export$e23ae35269442b4f;

});

parcelRegister("4Uejl", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jlWUB = parcelRequire("jlWUB");


var $lrDw7 = parcelRequire("lrDw7");


var $7BVQi = parcelRequire("7BVQi");


var $g3XYx = parcelRequire("g3XYx");


var $1U6E9 = parcelRequire("1U6E9");


var $jhrdR = parcelRequire("jhrdR");

/**
 * Parses a CSS time value (e.g. `"0.2s"` or `"200ms"`) and returns milliseconds.
 * Falls back to 0 if the value cannot be parsed.
 */ function $8b8583a0a90649e3$var$parseCSSTimeToMs(value) {
    const parsed = parseFloat(value);
    if (Number.isNaN(parsed)) return 0;
    if (value.endsWith('ms')) return parsed;
    return parsed * 1000;
}
/**
 * Returns `true` if any of the dimension(s) being animated have changed
 * between the previous and next measurements.
 */ function $8b8583a0a90649e3$var$hasDimensionChanged(dimension, prev, next) {
    if (dimension === 'width') return prev.width !== next.width;
    if (dimension === 'height') return prev.height !== next.height;
    return prev.width !== next.width || prev.height !== next.height;
}
/**
 * Returns the CSS `transition-property` / `will-change` value for the
 * given dimension(s).
 */ function $8b8583a0a90649e3$var$getDimensionPropertyList(dimension) {
    if (dimension === 'both') return 'width, height';
    return dimension;
}
const $8b8583a0a90649e3$export$a300664a1a230956 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion } = t0;
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            cleanup: "next-effect"
        };
        $[0] = t1;
    } else t1 = $[0];
    const setTimeout = (0, $1U6E9.useSetTimeout)(t1);
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    let t2;
    if ($[1] !== element) {
        t2 = ()=>{
            if ((0, $jlWUB.isReducedMotion)() || !element) return;
            const rect = element.getBoundingClientRect();
            prevDimensions.current = {
                width: rect.width,
                height: rect.height
            };
        };
        $[1] = element;
        $[2] = t2;
    } else t2 = $[2];
    (0, $jhrdR.useSnapshotBeforeUpdate)(t2);
    let t3;
    if ($[3] !== dimension || $[4] !== duration || $[5] !== easing || $[6] !== element || $[7] !== onFinishMotion || $[8] !== onStartMotion || $[9] !== requestAnimationFrame || $[10] !== setTimeout) {
        t3 = ()=>{
            if (!element) return;
            if ((0, $jlWUB.isReducedMotion)()) {
                onFinishMotion?.();
                return;
            }
            if (!prevDimensions.current) return;
            element.setAttribute("style", "");
            const rect_0 = element.getBoundingClientRect();
            const nextDimensions = {
                width: rect_0.width,
                height: rect_0.height
            };
            if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
                onFinishMotion?.();
                return;
            }
            onStartMotion?.();
            const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
            const newStyles = {
                willChange: propertyList,
                transitionProperty: propertyList,
                transitionDuration: duration,
                boxSizing: "border-box",
                transitionTimingFunction: easing
            };
            if (dimension === "width" || dimension === "both") newStyles.width = `${prevDimensions.current.width}px`;
            if (dimension === "height" || dimension === "both") newStyles.height = `${prevDimensions.current.height}px`;
            Object.assign(element.style, newStyles);
            const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!element) return;
                    if (dimension === "width" || dimension === "both") element.style.width = `${nextDimensions.width}px`;
                    if (dimension === "height" || dimension === "both") element.style.height = `${nextDimensions.height}px`;
                    setTimeout(()=>{
                        if (!element) return;
                        element.setAttribute("style", "");
                        onFinishMotion?.();
                    }, resolvedDuration);
                });
            });
        };
        $[3] = dimension;
        $[4] = duration;
        $[5] = easing;
        $[6] = element;
        $[7] = onFinishMotion;
        $[8] = onStartMotion;
        $[9] = requestAnimationFrame;
        $[10] = setTimeout;
        $[11] = t3;
    } else t3 = $[11];
    (0, $7BVQi.useLayoutEffect)(t3);
    let t4;
    if ($[12] !== setElementRef) {
        t4 = {
            ref: setElementRef
        };
        $[12] = setElementRef;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : ({ dimension: dimension, duration: duration, easing: easing, onFinishMotion: onFinishMotion, onStartMotion: onStartMotion })=>{
    const prevDimensions = (0, $cozmU.useRef)();
    const [element, setElementRef] = (0, $lrDw7.useElementRef)();
    const setTimeout = (0, $1U6E9.useSetTimeout)({
        cleanup: 'next-effect'
    });
    const requestAnimationFrame = (0, $g3XYx.useRequestAnimationFrame)();
    (0, $jhrdR.useSnapshotBeforeUpdate)(()=>{
        if ((0, $jlWUB.isReducedMotion)() || !element) return;
        const rect = element.getBoundingClientRect();
        prevDimensions.current = {
            width: rect.width,
            height: rect.height
        };
    });
    (0, $7BVQi.useLayoutEffect)(()=>{
        if (!element) return;
        if ((0, $jlWUB.isReducedMotion)()) {
            // No motion will ever run, so the element is already at its final dimensions.
            onFinishMotion?.();
            return;
        }
        if (!prevDimensions.current) return;
        // We might already be animating.
        // Because of that we need to expand to the destination dimensions first.
        element.setAttribute('style', '');
        const rect_0 = element.getBoundingClientRect();
        const nextDimensions = {
            width: rect_0.width,
            height: rect_0.height
        };
        if (!$8b8583a0a90649e3$var$hasDimensionChanged(dimension, prevDimensions.current, nextDimensions)) {
            onFinishMotion?.();
            return;
        }
        // Any in-flight transition styles have been cleared and the next ones haven't been applied
        // yet, so the element is at the natural layout it will settle at.
        onStartMotion?.();
        const propertyList = $8b8583a0a90649e3$var$getDimensionPropertyList(dimension);
        const newStyles = {
            willChange: propertyList,
            transitionProperty: propertyList,
            transitionDuration: duration,
            boxSizing: 'border-box',
            transitionTimingFunction: easing
        };
        if (dimension === 'width' || dimension === 'both') newStyles.width = `${prevDimensions.current.width}px`;
        if (dimension === 'height' || dimension === 'both') newStyles.height = `${prevDimensions.current.height}px`;
        Object.assign(element.style, newStyles);
        const resolvedDuration = $8b8583a0a90649e3$var$parseCSSTimeToMs(getComputedStyle(element).transitionDuration);
        // We split this over two animation frames so the DOM has enough time to flush the changes.
        // We are deliberately not skipping this frame if another render happens - if we do the motion doesn't finish properly.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!element) return;
                if (dimension === 'width' || dimension === 'both') element.style.width = `${nextDimensions.width}px`;
                if (dimension === 'height' || dimension === 'both') element.style.height = `${nextDimensions.height}px`;
                setTimeout(()=>{
                    if (!element) return;
                    element.setAttribute('style', '');
                    onFinishMotion?.();
                }, resolvedDuration);
            });
        });
    });
    return {
        ref: setElementRef
    };
};
module.exports["useResizing"] = $8b8583a0a90649e3$export$a300664a1a230956;

});

parcelRegister("jhrdR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7BVQi = parcelRequire("7BVQi");

const $8584e1bffd64d1d0$export$9e95200239cd148b = (cb)=>{
    const isFirstRender = (0, $cozmU.useRef)(true);
    if (!isFirstRender.current) cb();
    (0, $7BVQi.useLayoutEffect)(()=>{
        isFirstRender.current = false;
    }, []);
};
module.exports["useSnapshotBeforeUpdate"] = $8584e1bffd64d1d0$export$9e95200239cd148b;

});

parcelRegister("2pQiO", function(module, exports) {

var $a4RZV = parcelRequire("a4RZV");

function $1295d9cf79f622cc$export$da472ee01c19d92e(experimentName, param, defaultValue) {
    return (0, $a4RZV.expValInternal)(experimentName, param, defaultValue, false);
}
module.exports["UNSAFE_expValNoExposure"] = $1295d9cf79f622cc$export$da472ee01c19d92e;

});

parcelRegister("l90AK", function(module, exports) {
module.exports = JSON.parse("{\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-comment-template.titleForIssueComment\":[{\"type\":0,\"value\":\"Record your screen\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription\":[{\"type\":0,\"value\":\"Try\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription\":[{\"type\":0,\"value\":\"Use video to explain the work\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.loom\":[{\"type\":0,\"value\":\"Loom\"}],\"jira-xflow-loom.placements.in-app.jira-issueview-description-template.titleForIssueDescription\":[{\"type\":0,\"value\":\"Record your screen\"}],\"post-office-template.app-switcher-discovery-section.description.no-translate\":[{\"type\":0,\"value\":\"Post Office app-switcher-discovery-section template message.\"}],\"post-office-template.app-switcher-discovery-section.title.no-translate\":[{\"type\":0,\"value\":\"Jira Software\"}],\"post-office-template.message-template-template.email.body.img.alt.no-translate\":[{\"type\":0,\"value\":\"Description of image\"}],\"post-office-template.message-template.email.subject.no-translate\":[{\"type\":0,\"value\":\"Post Office Test Message from \"},{\"type\":1,\"value\":\"env\"}],\"post-office-template.message-template.microsoft-teams.hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office-template.message-template.notification-drawer.message.no-translate\":[{\"type\":1,\"value\":\"actorName\"},{\"type\":0,\"value\":\" updated your page\"}],\"post-office-template.screen-space-flags.description.no-translate\":[{\"type\":0,\"value\":\"Replace this with a short summary of what this message tells the recipient.\"}],\"post-office-template.screen-space-flags.title.no-translate\":[{\"type\":0,\"value\":\"This is a Post Office Test Message\"}],\"post-office-template.test-message.email.body.hello.no-translate\":[{\"type\":0,\"value\":\"Hi \"},{\"type\":1,\"value\":\"name\"},{\"type\":0,\"value\":\",\"}],\"post-office-template.test-message.email.body.no-translate\":[{\"type\":0,\"value\":\"This is a test message from the \"},{\"type\":1,\"value\":\"env\"},{\"type\":0,\"value\":\" environment.\"}],\"post-office-template.test-message.email.body.regards.no-translate\":[{\"type\":0,\"value\":\"Team Post Office\"}],\"post-office-template.test-message.email.body.signoff.no-translate\":[{\"type\":0,\"value\":\"Regards,\"}],\"post-office-template.test-message.email.unsubscribe.text.no-translate\":[{\"type\":0,\"value\":\"Unsubscribe\"}],\"post-office.components.{component-name}.{location-name}.{message-name}\":[{\"type\":0,\"value\":\"Example\"}],\"post-office.post-office-template.browser-push-body.no-translate\":[{\"type\":0,\"value\":\"You are a lovely\"}],\"post-office.post-office-template.sample-hello-message.no-translate\":[{\"type\":0,\"value\":\"Hello, *This is notification test from post office*\"}],\"post-office.post-office-template.sample-mobile-notification-message.no-translate\":[{\"type\":0,\"value\":\"Hello, this is a mobile push notification test from post office.\"}]}");

});

parcelRegister("azX2I", function(module, exports) {
module.exports = JSON.parse('{"admin-hub.ci-test.message-template-template-hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"ci-generation.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"ci-generation.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"ci-generation.email.body.img.alt":[{"type":0,"value":"This is the alt text for the image"}],"ci-generation.email.body.regards":[{"type":0,"value":"Team Post Office"}],"ci-generation.email.body.signoff":[{"type":0,"value":"Regards,"}],"ci-generation.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"ci-generation.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"post-office.test-message-digest-email-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-email-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-digest-local-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-local-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-digest-threshold-template.test-message.email.body.digest-title":[{"type":0,"value":"You have "},{"type":1,"value":"numberOfMsg"},{"type":0,"value":" new messages!"}],"post-office.test-message-digest-threshold-template.test-message.email.body.message-body":[{"type":1,"value":"defaultMessage"}],"post-office.test-message-microsoft-teams.sample-hello-message":[{"type":0,"value":"Hello, this is test message from Post Office: "},{"type":1,"value":"text"}],"post-office.test-message.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"},{"type":0,"value":"."}],"post-office.test-messages.test-message-config-sets.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-digest-slack-v2.heading.no-translate":[{"type":0,"value":"Post Office Slack digest v2 delivered "},{"type":1,"value":"count"},{"type":0,"value":" messages"}],"post-office.test-messages.test-message-digest-slack-v2.item.no-translate":[{"type":0,"value":"V2 item: "},{"type":1,"value":"message"}],"post-office.test-messages.test-message-lifecycle-email-recipients.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-lifecycle.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-load-test-push-flow-email-mobile-push.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.redacted.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a redacted test mobile push notification from post office."}],"post-office.test-messages.test-message-mobile-push-jira-ugc.sample-mobile-notification-message.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.greeting.no-translate":[{"type":0,"value":"Hello, this is a mobile push notification test from post office."}],"post-office.test-messages.test-message-mobile-push.redacted.greeting.no-translate":[{"type":0,"value":"Hello, this is a redacted mobile push notification test from post office."}],"post-office.test-messages.test-message-no-tracking.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-slack-experiment-exposure.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-message-transform-metadata.sample-hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"post-office.test-messages.test-slack-notification-v2.sample-hello-message.no-translate":[{"type":0,"value":"Post Office Slack digest v2 source: "},{"type":1,"value":"message"}],"post-office.test-slack-notification.sample-hello-message":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"product-store-personal-use-case.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}],"test-message.test-message-email-onboarding-test.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-message.test-message-email-onboarding-test.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-message.test-message-email-onboarding-test.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-message.test-message-email-onboarding-test.test-message.email.body.no-translate":[{"type":0,"value":"This is an test onboarding message for "},{"type":1,"value":"team"},{"type":0,"value":" team from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-message.test-message-email-onboarding-test.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-message.test-message-email-onboarding-test.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-message.test-message-email-onboarding-test.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.app-switcher-discovery-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-discovery-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.app-switcher-upgrade-section.dismiss":[{"type":0,"value":"Dismiss"}],"test-messages.app-switcher-upgrade-section.test-content":[{"type":0,"value":"This is a test message."}],"test-messages.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.in-app-example.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.in-app-notification-comment-rollup.second-comment":[{"type":1,"value":"actor"},{"type":0,"value":" commented on a page"}],"test-messages.in-app-notification-mention-rollup.first-comment":[{"type":1,"value":"reactor"},{"type":0,"value":" mentioned you in a comment"}],"test-messages.in-app-notification-reaction-rollup.many-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"otherActorsCount"},{"type":0,"value":" others reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.one-actor":[{"type":1,"value":"actor1Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification-reaction-rollup.two-actors":[{"type":1,"value":"actor1Name"},{"type":0,"value":" and "},{"type":1,"value":"actor2Name"},{"type":0,"value":" reacted to your page"}],"test-messages.in-app-notification.email-onboarding.body":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":", This is an onboarding test message for "},{"type":1,"value":"team"},{"type":0,"value":" team."}],"test-messages.in-app-notification.email-onboarding.title":[{"type":0,"value":"Welcome!"}],"test-messages.in-app-notification.title":[{"type":0,"value":"Test Notification "},{"type":1,"value":"title"}],"test-messages.jira-navigation-topbar-edition-awareness.hello-world":[{"type":0,"value":"Hello "},{"type":1,"value":"propA"},{"type":0,"value":". Is is a lovely "},{"type":1,"value":"propB"}],"test-messages.post-office-gold-1.description.no-translate":[{"type":0,"value":"Post Office Gold test message."}],"test-messages.post-office-gold-1.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.redacted-email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.team-message-email-ugc.message-template.email.redacted.subject.no-translate":[{"type":0,"value":"Post Office Redacted Test Message from "},{"type":1,"value":"env"}],"test-messages.test-hydrate-user-details.email.aaid-label.no-translate":[{"type":0,"value":"AAID"}],"test-messages.test-hydrate-user-details.email.description.no-translate":[{"type":0,"value":"Post Office resolved the display name from the AAID supplied in messageContext."}],"test-messages.test-hydrate-user-details.email.display-name-label.no-translate":[{"type":0,"value":"Display name"}],"test-messages.test-hydrate-user-details.email.heading.no-translate":[{"type":0,"value":"User hydration succeeded"}],"test-messages.test-hydrate-user-details.email.subject.no-translate":[{"type":0,"value":"Post Office user hydration test"}],"test-messages.test-message-client-generation.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-client-generation.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-client-generation.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-client-generation.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-client-generation.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-client-generation.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-client-generation.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-config-sets.in-app.cs-0.flag.body.no-translate":[{"type":0,"value":"This is the cs-0 test message body"}],"test-messages.test-message-config-sets.in-app.cs-0.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-0)"}],"test-messages.test-message-config-sets.in-app.cs-0.learn-more.no-translate":[{"type":0,"value":"Learn more"}],"test-messages.test-message-config-sets.in-app.cs-1.flag.body.no-translate":[{"type":0,"value":"This is the cs-1 test message body"}],"test-messages.test-message-config-sets.in-app.cs-1.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-1)"}],"test-messages.test-message-config-sets.in-app.cs-2.flag.body.no-translate":[{"type":0,"value":"This is the cs-2 test message body"}],"test-messages.test-message-config-sets.in-app.cs-2.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-2)"}],"test-messages.test-message-config-sets.in-app.cs-chat-app-notification.flag.body.no-translate":[{"type":0,"value":"This is the cs-chat-app-notification test message body"}],"test-messages.test-message-config-sets.in-app.cs-chat-app-notification.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-chat-app-notification)"}],"test-messages.test-message-config-sets.in-app.cs-email.flag.body.no-translate":[{"type":0,"value":"This is the cs-email test message body"}],"test-messages.test-message-config-sets.in-app.cs-email.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-email)"}],"test-messages.test-message-config-sets.in-app.cs-in-app-v2.flag.body.no-translate":[{"type":0,"value":"This is the cs-in-app-v2 test message body"}],"test-messages.test-message-config-sets.in-app.cs-in-app-v2.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-in-app-v2)"}],"test-messages.test-message-config-sets.in-app.cs-in-app.flag.body.no-translate":[{"type":0,"value":"This is the cs-in-app test message body"}],"test-messages.test-message-config-sets.in-app.cs-in-app.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-in-app)"}],"test-messages.test-message-config-sets.in-app.cs-message-objective-fatigue.flag.body.no-translate":[{"type":0,"value":"This is the cs-message-objective-fatigue test message body"}],"test-messages.test-message-config-sets.in-app.cs-message-objective-fatigue.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-message-objective-fatigue)"}],"test-messages.test-message-config-sets.in-app.cs-push-channels.flag.body.no-translate":[{"type":0,"value":"This is the cs-push-channels test message body"}],"test-messages.test-message-config-sets.in-app.cs-push-channels.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message (cs-push-channels)"}],"test-messages.test-message-config-sets.in-app.flag.body.no-translate":[{"type":0,"value":"This is the test message body"}],"test-messages.test-message-config-sets.in-app.flag.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-config-sets.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-config-sets.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-config-sets.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-config-sets.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-config-sets.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-config-sets.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-config-sets.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"Click here to visit Atlassian"}],"test-messages.test-message-config-sets.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-content-diffing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-content-diffing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-content-diffing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-content-diffing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-content-diffing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-content-diffing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-content-diffing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-delivery-control.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-delivery-control.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.body.no-translate":[{"type":1,"value":"body"}],"test-messages.test-message-delivery-control.message-template.in-app-notification.title.no-translate":[{"type":0,"value":"Template Notification "},{"type":1,"value":"title"}],"test-messages.test-message-delivery-control.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-delivery-control.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-delivery-control.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-delivery-control.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-delivery-control.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-credit-requests-table.email.action-unavailable.no-translate":[{"type":0,"value":"Unavailable"}],"test-messages.test-message-digest-credit-requests-table.email.allocate.no-translate":[{"type":0,"value":"Allocate"}],"test-messages.test-message-digest-credit-requests-table.email.heading.no-translate":[{"type":0,"value":"Approve credit requests"}],"test-messages.test-message-digest-credit-requests-table.email.subject.no-translate":[{"offset":0,"options":{"one":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new request for more credits"}]},"other":{"value":[{"type":0,"value":"You have "},{"type":7},{"type":0,"value":" new requests for more credits"}]}},"pluralType":"cardinal","type":6,"value":"requestCount"}],"test-messages.test-message-digest-credit-requests-table.email.summary.empty.no-translate":[{"type":0,"value":"There are no credit requests to review."}],"test-messages.test-message-digest-credit-requests-table.email.summary.many.no-translate":[{"type":1,"value":"firstName"},{"type":0,"value":", "},{"type":1,"value":"secondName"},{"type":0,"value":" and "},{"type":1,"value":"otherCount"},{"type":0,"value":" others from your organization have sent requests to increase their Rovo credit limit."}],"test-messages.test-message-digest-credit-requests-table.email.summary.one.no-translate":[{"type":1,"value":"firstName"},{"type":0,"value":" from your organization has sent a request to increase their Rovo credit limit."}],"test-messages.test-message-digest-credit-requests-table.email.summary.two.no-translate":[{"type":1,"value":"firstName"},{"type":0,"value":" and "},{"type":1,"value":"secondName"},{"type":0,"value":" from your organization have sent requests to increase their Rovo credit limit."}],"test-messages.test-message-digest-credit-requests-table.email.table.aaid.no-translate":[{"type":0,"value":"ID"}],"test-messages.test-message-digest-credit-requests-table.email.table.action.no-translate":[{"type":0,"value":"Action"}],"test-messages.test-message-digest-credit-requests-table.email.table.sequence.no-translate":[{"type":0,"value":"S. No."}],"test-messages.test-message-digest-credit-requests-table.email.table.username.no-translate":[{"type":0,"value":"User"}],"test-messages.test-message-digest-credit-requests-table.email.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-email.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-email.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-email.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-email.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-email.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-email.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-email.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-local.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-local.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-local.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-local.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-local.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-local.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-local.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-reranking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-reranking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-reranking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-reranking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-digest-reranking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-reranking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-reranking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-digest-threshold.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-digest-threshold.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office message from "},{"type":1,"value":"env"}],"test-messages.test-message-digest-threshold.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hey "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-digest-threshold.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. Here is your daily digest (rick) rollup for the "},{"type":1,"value":"site"},{"type":0,"value":" workspace"}],"test-messages.test-message-digest-threshold.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-digest-threshold.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-digest-threshold.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-cdn.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-cdn.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-cdn.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-cdn.test-message.email.body.hello":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-cdn.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-cdn.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-cdn.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-experiment-exposure.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-experiment-exposure.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.button.no-translate":[{"type":0,"value":"Click me!"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-experiment-exposure.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-experiment-exposure.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-high-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-high-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-high-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-high-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-high-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-high-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-high-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-log-dropping.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-log-dropping.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-log-dropping.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-log-dropping.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-log-dropping.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-log-dropping.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-log-dropping.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-low-priority.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-low-priority.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-low-priority.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-low-priority.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-low-priority.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-low-priority.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-low-priority.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-mfc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-mfc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-mfc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-mfc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-mfc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-mfc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-mfc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-email-ugc.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template-template.email.redacted.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-email-ugc.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-email-ugc.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.no-translate":[{"type":0,"value":"This is a redacted test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-email-ugc.test-message.email.redacted.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-email-ugc.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-grouped-recipients.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-grouped-recipients.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-grouped-recipients.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-grouped-recipients.test-message.email.body.hello":[{"type":0,"value":"Hello"}],"test-messages.test-message-grouped-recipients.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-grouped-recipients.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-grouped-recipients.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-comment-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-comment-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-comment-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-mention-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-mention-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-mention-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification-reaction-rollup.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification-reaction-rollup "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification-reaction-rollup.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-in-app-notification.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-in-app-notification.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office test-message-in-app-notification "},{"type":1,"value":"env"}],"test-messages.test-message-in-app-notification.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-in-app-notification.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-in-app-notification.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-in-app-notification.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-in-app-notification.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-inapp-engagement.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-inapp-engagement.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-inapp-engagement.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-inapp-engagement.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-inapp-engagement.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-inapp-engagement.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-inapp-engagement.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-inapp-ep-modal.confirm.no-translate":[{"type":0,"value":"OK"}],"test-messages.test-message-inapp-ep-modal.description.no-translate":[{"type":0,"value":"We\'re also improving how we incorporate the terms you use to define work, so that Jira speaks your language \u2014 no matter what you\'re working on."}],"test-messages.test-message-inapp-ep-modal.read-more.no-translate":[{"type":0,"value":"Read more"}],"test-messages.test-message-inapp-ep-modal.title.no-translate":[{"type":0,"value":"\'Work\' is the new term for items tracked in Jira"}],"test-messages.test-message-inapp-implicit-pendo.description.no-translate":[{"type":0,"value":"Implicit Pendo test message."}],"test-messages.test-message-inapp-implicit-pendo.title.no-translate":[{"type":0,"value":"Conquering "},{"type":1,"value":"planet"},{"type":0,"value":" is "},{"type":1,"value":"status"}],"test-messages.test-message-inapp.description.no-translate":[{"type":0,"value":"Post Office in-app test message."}],"test-messages.test-message-inapp.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-lifecycle-email-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle-email-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-lifecycle-email-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-lifecycle.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-lifecycle.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-lifecycle.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-lifecycle.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-lifecycle.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-lifecycle.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Kind Regards,"}],"test-messages.test-message-lifecycle.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.heading.no-translate":[{"type":0,"value":"Origin Tracing \u2014 Tracked Link Test ("},{"type":1,"value":"env"},{"type":0,"value":")"}],"test-messages.test-message-link-tracking.email.intro.no-translate":[{"type":0,"value":"This email tests Post Office tracked links. Tracked links go through the Post Office redirect service; plain links do not. Click each link and inspect the redirect URL to verify origin tracing."}],"test-messages.test-message-link-tracking.email.tracked-link-atl-origin.no-translate":[{"type":0,"value":"TrackedLink with atlOrigin param"}],"test-messages.test-message-link-tracking.email.tracked-link-atlassian.no-translate":[{"type":0,"value":"TrackedLink to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.tracked-link-external.no-translate":[{"type":0,"value":"TrackedLink to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.tracked-link-pdf.no-translate":[{"type":0,"value":"TrackedLink to PDF"}],"test-messages.test-message-link-tracking.email.tracked-link-tenanted.no-translate":[{"type":0,"value":"TrackedLink to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.tracked-section.no-translate":[{"type":0,"value":"Tracked links"}],"test-messages.test-message-link-tracking.email.unsubscribe.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-link-tracking.email.untracked-link-atl-origin.no-translate":[{"type":0,"value":"Plain link with atlOrigin param"}],"test-messages.test-message-link-tracking.email.untracked-link-atlassian.no-translate":[{"type":0,"value":"Plain link to https://atlassian.com"}],"test-messages.test-message-link-tracking.email.untracked-link-external.no-translate":[{"type":0,"value":"Plain link to https://www.example.com (non-Atlassian)"}],"test-messages.test-message-link-tracking.email.untracked-link-pdf.no-translate":[{"type":0,"value":"Plain link to PDF"}],"test-messages.test-message-link-tracking.email.untracked-link-tenanted.no-translate":[{"type":0,"value":"Plain link to https://hello.atlassian.net/wiki/home (tenanted)"}],"test-messages.test-message-link-tracking.email.untracked-section.no-translate":[{"type":0,"value":"Plain (untracked) links"}],"test-messages.test-message-load-test-pull-screen-space-flags.description.no-translate":[{"type":0,"value":"Synthetic message for GCP staging pull load tests."}],"test-messages.test-message-load-test-pull-screen-space-flags.title.no-translate":[{"type":0,"value":"Post Office GCP load test"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-load-test-push-flow-email-mobile-push.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-marketing.app-switcher-discovery-section.description.no-translate":[{"type":0,"value":"Post Office app-switcher-discovery-section marketing test message."}],"test-messages.test-message-marketing.app-switcher-discovery-section.title.no-translate":[{"type":0,"value":"Jira Software"}],"test-messages.test-message-marketing.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-marketing.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-marketing.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-marketing.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-marketing.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-marketing.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-marketing.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-message-failures.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-message-failures.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-message-failures.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-message-failures.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-message-failures.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-message-failures.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-message-failures.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-microsoft-teams-v2-digest.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"test-messages.test-message-microsoft-teams-v2.message-template.microsoft-teams.hello-message.no-translate":[{"type":0,"value":"Hello, *This is notification test from post office*"}],"test-messages.test-message-narrow-exposure-experiment-v2.description.no-translate":[{"type":0,"value":"This message tests the second narrow-exposure experiment."}],"test-messages.test-message-narrow-exposure-experiment-v2.title.no-translate":[{"type":0,"value":"Post Office narrow-exposure v2 test message"}],"test-messages.test-message-narrow-exposure-experiment.description.no-translate":[{"type":0,"value":"This message is used to test narrow-exposure experiments."}],"test-messages.test-message-narrow-exposure-experiment.title.no-translate":[{"type":0,"value":"Post Office test message"}],"test-messages.test-message-nd-ni-influents-mapper.influents.message-main.no-translate":[{"type":0,"value":"Main line ("},{"type":1,"value":"text"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.action.no-translate":[{"type":0,"value":"Open ("},{"type":1,"value":"emoji"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.entity.no-translate":[{"type":0,"value":"Entity for "},{"type":1,"value":"team"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.path.no-translate":[{"type":0,"value":"Path ("},{"type":1,"value":"team"},{"type":0,"value":")"}],"test-messages.test-message-nd-ni-influents-mapper.ingestion.title.no-translate":[{"type":0,"value":"Team "},{"type":1,"value":"teamName"},{"type":0,"value":" update"}],"test-messages.test-message-no-tracking.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-no-tracking.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-no-tracking.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-no-tracking.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-no-tracking.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-no-tracking.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-no-tracking.test-message.email.body.tracked-link.no-translate":[{"type":0,"value":"This is a TrackedLink that isn\'t being tracked!"}],"test-messages.test-message-no-tracking.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-notifications-platform.message-template.notification-drawer.message.no-translate":[{"type":1,"value":"actorName"},{"type":0,"value":" updated your page"}],"test-messages.test-message-persona-email.message-template-template.email.body.img.alt":[{"type":0,"value":"Description of image"}],"test-messages.test-message-persona-email.message-template.email.subject":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-persona-email.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-persona-email.test-message.email.body.regards":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-persona-email.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message-persona-email.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-raw-recipients.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-raw-recipients.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-raw-recipients.test-message.email.body.greeting.no-translate":[{"type":1,"value":"greeting"}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.name.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-raw-recipients.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi,"}],"test-messages.test-message-raw-recipients.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-raw-recipients.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-raw-recipients.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-raw-recipients.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-tap-ingestion-trigger-subscription.description.no-translate":[{"type":0,"value":"TAP ingestion trigger subscription test message."}],"test-messages.test-message-tap-ingestion-trigger-subscription.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-tap-ingestion-trigger-subscription.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-tap-ingestion-trigger-subscription.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-tap-ingestion-trigger-subscription.title.no-translate":[{"type":0,"value":"This is a Post Office Test Message"}],"test-messages.test-message-transform-metadata.message-template-template.email.body.img.alt.no-translate":[{"type":0,"value":"Description of image"}],"test-messages.test-message-transform-metadata.message-template.email.subject.no-translate":[{"type":0,"value":"Post Office Test Message from "},{"type":1,"value":"env"}],"test-messages.test-message-transform-metadata.test-message.email.body.hello.no-translate":[{"type":0,"value":"Hi "},{"type":1,"value":"name"},{"type":0,"value":","}],"test-messages.test-message-transform-metadata.test-message.email.body.no-translate":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment."}],"test-messages.test-message-transform-metadata.test-message.email.body.regards.no-translate":[{"type":0,"value":"Team Post Office"}],"test-messages.test-message-transform-metadata.test-message.email.body.signoff.no-translate":[{"type":0,"value":"Regards,"}],"test-messages.test-message-transform-metadata.test-message.email.unsubscribe.text.no-translate":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message-triggered.description.no-translate":[{"type":0,"value":"This triggered message tests narrow-exposure experiments."}],"test-messages.test-message-triggered.title.no-translate":[{"type":0,"value":"Post Office triggered test message"}],"test-messages.test-message.app.img.alt.large":[{"type":0,"value":"test image 2"}],"test-messages.test-message.app.img.alt.plant":[{"type":0,"value":"test image 1"}],"test-messages.test-message.email.body":[{"type":0,"value":"This is a test message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"test-messages.test-message.redacted-email.body":[{"type":0,"value":"This is the redacted version of the test email message from the "},{"type":1,"value":"env"},{"type":0,"value":" environment. "},{"type":1,"value":"additionalBody"}],"test-messages.test-message.redacted-email.body.hello":[{"type":0,"value":"Hi Atlassian,"}],"test-messages.test-message.redacted-email.body.img.alt":[{"type":0,"value":"this is the alt for the test-message-email message template"}],"test-messages.test-message.redacted-email.body.signoff":[{"type":0,"value":"Regards,"}],"test-messages.test-message.redacted-email.unsubscribe.text":[{"type":0,"value":"Unsubscribe"}],"wac-global-nav-product-recommendation.hello-world":[{"type":0,"value":"Hello. Is is a lovely"}]}');

});

parcelRegister("gkHoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $be402bcc938fe0c2$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $be402bcc938fe0c2$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("58FyF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bddefb3ed7cf5f3$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $3bddefb3ed7cf5f3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("6OpMl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $d8DK7 = parcelRequire("d8DK7");


var $e4Q12 = parcelRequire("e4Q12");


var $l4yrE = parcelRequire("l4yrE");


var $9ncZd = parcelRequire("9ncZd");


var $9Jo6P = parcelRequire("9Jo6P");

const $8996823a89ed3e69$var$ResourcedEmoji = (props)=>{
    const { emojiId: emojiId, optimisticImageURL: optimisticImageURL } = props;
    (0, $cozmU.useEffect)(()=>{
        if (!emojiId) return;
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).start({
            samplingRate: (0, $l4yrE.SAMPLING_RATE_EMOJI_RENDERED_EXP)
        });
        (0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName).addMetadata({
            source: 'ResourcedEmoji',
            emojiId: emojiId.id,
            isOptimisticImageURL: !!optimisticImageURL
        });
        return ()=>{
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).abort({
                metadata: {
                    source: 'ResourcedEmoji',
                    reason: 'unmount'
                }
            });
        };
    }, [
        emojiId,
        optimisticImageURL
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Jo6P.UfoErrorBoundary), {
        experiences: [
            (0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(props.emojiId.id || props.emojiId.shortName)
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ncZd.ResourcedEmojiComponent), props));
};
var $8996823a89ed3e69$export$2e2bcd8739ae039 = $8996823a89ed3e69$var$ResourcedEmoji;
module.exports["default"] = $8996823a89ed3e69$export$2e2bcd8739ae039;

});

parcelRegister("d8DK7", function(module, exports) {

var $e4Q12 = parcelRequire("e4Q12");


var $53TEx = parcelRequire("53TEx");

const $37720bf73e14576a$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $53TEx.withSampling)((0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
module.exports["sampledUfoRenderedEmoji"] = $37720bf73e14576a$export$71c8cba6f1251ea9;

});

parcelRegister("9ncZd", function(module, exports) {
/* ResourcedEmojiComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $d96oP = parcelRequire("d96oP");


var $gxxZD = parcelRequire("gxxZD");


var $9tfSW = parcelRequire("9tfSW");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $l4yrE = parcelRequire("l4yrE");


var $1Vdnd = parcelRequire("1Vdnd");


var $1FzXO = parcelRequire("1FzXO");


var $iKpb2 = parcelRequire("iKpb2");

const $af933464a9c9fdc1$var$ignoreWrapperStyles = null;
const $af933464a9c9fdc1$var$isMdpiImageURL = (imageURL)=>{
    try {
        return new URL(imageURL, 'https://emoji.invalid').searchParams.get('scale') === 'MDPI';
    } catch  {
        return false;
    }
};
var $af933464a9c9fdc1$var$ResourcedEmojiComponentRenderStatesEnum = /*#__PURE__*/ function(ResourcedEmojiComponentRenderStatesEnum) {
    ResourcedEmojiComponentRenderStatesEnum["INITIAL"] = "INITIAL";
    ResourcedEmojiComponentRenderStatesEnum["FALLBACK"] = "FALLBACK";
    ResourcedEmojiComponentRenderStatesEnum["EMOJI"] = "EMOJI";
    return ResourcedEmojiComponentRenderStatesEnum;
}($af933464a9c9fdc1$var$ResourcedEmojiComponentRenderStatesEnum || {});
const $af933464a9c9fdc1$export$7bfde52eceb3e2f6 = ({ emojiProvider: emojiProvider, emojiId: emojiId, emojiProviderLookupOrder: emojiProviderLookupOrder, showTooltip: showTooltip = false, customFallback: customFallback, fitToHeight: fitToHeight = (0, $l4yrE.defaultEmojiHeight), ignoreWrapper: ignoreWrapper = false, optimistic: optimistic = false, optimisticImageURL: optimisticImageURL, editorEmoji: editorEmoji, pageTitleEmoji: pageTitleEmoji = false, placeholderXcss: placeholderXcss, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    const { shortName: shortName, id: id, fallback: fallback } = emojiId;
    const [emoji, setEmoji] = (0, $cozmU.useState)();
    const [loaded, setLoaded] = (0, $cozmU.useState)(false);
    const [imageLoadError, setImageLoadError] = (0, $cozmU.useState)(false);
    const [failedAdaptiveImageURL, setFailedAdaptiveImageURL] = (0, $cozmU.useState)();
    const [resolvedEmojiProvider, setResolvedEmojiProvider] = (0, $cozmU.useState)();
    const fetchOrGetEmoji = (0, $cozmU.useCallback)(async (_emojiProvider, emojiId, optimisticFetch = false)=>{
        if (!_emojiProvider.fetchByEmojiId) {
            setEmoji(undefined);
            const reason = 'missing fetchByEmojiId interface';
            onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                metadata: {
                    reason: reason,
                    source: 'ResourcedEmojiComponent'
                }
            });
        }
        const foundEmoji = _emojiProvider.fetchByEmojiId(emojiId, optimisticFetch, (0, $iDrrr.fg)('platform_bitbucket_fix_shortname_and_ordering') ? emojiProviderLookupOrder : undefined);
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_START);
        if ((0, $1Vdnd.isPromise)(foundEmoji)) {
            setLoaded(false);
            foundEmoji.then((emoji)=>{
                setEmoji(emoji);
                if (!emoji) {
                    const reason = 'failed to find';
                    onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason); // emoji is undefined
                    (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                        metadata: {
                            reason: reason,
                            source: 'ResourcedEmojiComponent',
                            data: {
                                emoji: {
                                    id: emojiId.id,
                                    shortName: emojiId.shortName
                                }
                            }
                        }
                    });
                }
            }).catch(()=>{
                setEmoji(undefined);
                const reason = 'failed to load';
                onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
                (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
                    metadata: {
                        reason: reason,
                        source: 'ResourcedEmojiComponent',
                        data: {
                            emoji: {
                                id: emojiId.id,
                                shortName: emojiId.shortName
                            }
                        }
                    }
                });
            }).finally(()=>{
                setLoaded(true);
                (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_END);
            });
        } else {
            setEmoji(foundEmoji);
            setLoaded(true);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).mark((0, $9tfSW.UfoEmojiTimings).METADATA_END);
        }
    }, [
        emojiProviderLookupOrder,
        onEmojiLoadFail
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!emojiId) return;
        if (!(0, $1GEKi.hasUfoMarked)((0, $d8DK7.sampledUfoRenderedEmoji)(emojiId), (0, $9tfSW.UfoEmojiTimings).FMP_END)) (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).markFMP();
    }, [
        emojiId
    ]); // Fetching during render means a render React later discards (for example a pass that suspends)
    // still creates a promise whose callbacks set state and schedule yet another render. This layout
    // effect only runs for committed renders, and being pre-paint it keeps the synchronous cache-hit
    // path from flashing the placeholder.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!resolvedEmojiProvider || !emojiId) return;
        fetchOrGetEmoji(resolvedEmojiProvider, emojiId, optimistic);
    }, [
        resolvedEmojiProvider,
        emojiId,
        optimistic,
        fetchOrGetEmoji
    ]); /**
                                                                      * Setting resolved emoji provider for optimistic rendering
                                                                      */ 
    (0, $cozmU.useEffect)(()=>{
        Promise.resolve(emojiProvider).then((emojiProvider)=>{
            setResolvedEmojiProvider(emojiProvider);
        });
    }, [
        emojiProvider
    ]);
    const emojiRenderState = (0, $cozmU.useMemo)(()=>{
        if (!emoji && !loaded && !optimisticImageURL) return "INITIAL";
        else if (!emoji && loaded || imageLoadError) return "FALLBACK";
        return "EMOJI";
    }, [
        emoji,
        loaded,
        optimisticImageURL,
        imageLoadError
    ]);
    const optimisticEmojiDescription = (0, $cozmU.useMemo)(()=>{
        if (optimisticImageURL && emoji && (emoji.type === 'STANDARD' || emoji.type === 'ATLASSIAN') && fitToHeight * Math.max(1, (0, $d96oP.getPixelRatio)()) > 32 && $af933464a9c9fdc1$var$isMdpiImageURL(optimisticImageURL) && (0, $iDrrr.fg)('platform_emoji_adaptive_image_size')) return emoji;
         // reduce blast radius by targeting page title
        if (pageTitleEmoji && optimisticImageURL && (0, $iDrrr.fg)('platform_emoji_prevent_img_src_changing')) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                width: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
         // Keep the optimistic representation stable when catalogue data arrives.
        if (optimisticImageURL) return {
            id: id,
            shortName: shortName,
            fallback: fallback,
            type: '',
            category: '',
            searchable: true,
            representation: {
                height: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                width: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
                imagePath: optimisticImageURL
            }
        };
        if ((0, $iDrrr.fg)('platform_emoji_adaptive_image_size') && emoji && (emoji.type === 'STANDARD' || emoji.type === 'ATLASSIAN') && emoji.representation && 'imagePath' in emoji.representation && emoji.representation.height > 32 && fitToHeight > 0 && fitToHeight * Math.max(1, (0, $d96oP.getPixelRatio)()) <= 32) {
            const imageURL = resolvedEmojiProvider?.getOptimisticImageURL?.({
                id: id,
                shortName: shortName,
                fallback: fallback
            }); // MDPI standard/Atlassian images are 32px. Reuse the provider's URL instead of
            // downloading a larger catalogue image when those pixels already cover the display.
            if (imageURL && imageURL !== failedAdaptiveImageURL && $af933464a9c9fdc1$var$isMdpiImageURL(imageURL)) return {
                ...emoji,
                representation: {
                    imagePath: imageURL,
                    width: 32,
                    height: 32
                },
                altRepresentation: undefined
            };
        }
        return emoji;
    }, [
        emoji,
        optimisticImageURL,
        fallback,
        fitToHeight,
        id,
        shortName,
        pageTitleEmoji,
        resolvedEmojiProvider,
        failedAdaptiveImageURL
    ]);
    const handleOnLoadError = (0, $cozmU.useCallback)((emojiId)=>{
        if ((0, $iDrrr.fg)('platform_emoji_adaptive_image_size') && !optimisticImageURL && optimisticEmojiDescription !== emoji && optimisticEmojiDescription?.representation && 'imagePath' in optimisticEmojiDescription.representation) {
            setFailedAdaptiveImageURL(optimisticEmojiDescription.representation.imagePath);
            return;
        }
        setImageLoadError(true);
        const reason = 'load error';
        onEmojiLoadFail && onEmojiLoadFail(emojiId.id, reason);
        (0, $d8DK7.sampledUfoRenderedEmoji)(emojiId).failure({
            metadata: {
                reason: reason,
                source: 'ResourcedEmojiComponent',
                emojiId: emojiId.id
            }
        });
    }, [
        onEmojiLoadFail,
        optimisticImageURL,
        optimisticEmojiDescription,
        emoji
    ]);
    const handleOnLoadSuccess = (0, $cozmU.useCallback)((emojiId)=>{
        onEmojiLoadSuccess && onEmojiLoadSuccess(emojiId.id);
    }, [
        onEmojiLoadSuccess
    ]); // use width: auto when fitToHeight is defined
    const autoWidth = !!fitToHeight;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gxxZD.EmojiCommonProvider), {
        emojiProvider: resolvedEmojiProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        "data-ssr-placeholder": `emoji-${id ?? shortName}`,
        "data-ssr-placeholder-replace": `emoji-${id ?? shortName}`,
        className: (0, $hekY6.default)([
            ignoreWrapper && "_3iDTPbcK7c"
        ])
    }, emojiRenderState === "INITIAL" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), {
        shortName: shortName,
        showTooltip: showTooltip,
        size: fitToHeight || (0, $l4yrE.defaultEmojiHeight),
        loading: true,
        xcss: placeholderXcss
    }), emojiRenderState === "FALLBACK" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, customFallback || fallback || shortName), emojiRenderState === "EMOJI" && optimisticEmojiDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.default), {
        emoji: optimisticEmojiDescription,
        onLoadError: handleOnLoadError,
        onLoadSuccess: handleOnLoadSuccess,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        autoWidth: autoWidth,
        editorEmoji: editorEmoji
    })));
};
var $af933464a9c9fdc1$export$2e2bcd8739ae039 = $af933464a9c9fdc1$export$7bfde52eceb3e2f6;
module.exports["ResourcedEmojiComponent"] = $af933464a9c9fdc1$export$7bfde52eceb3e2f6;

});

parcelRegister("1GEKi", function(module, exports) {
const $ac4f45f8bd90a0fe$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
module.exports["hasUfoMarked"] = $ac4f45f8bd90a0fe$export$a9be054d2a5cedc0;

});

parcelRegister("1FzXO", function(module, exports) {
/* Emoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $9tfSW = parcelRequire("9tfSW");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $e4Q12 = parcelRequire("e4Q12");


var $7gsaD = parcelRequire("7gsaD");


var $l4yrE = parcelRequire("l4yrE");


var $ie2rI = parcelRequire("ie2rI");


var $bvr9K = parcelRequire("bvr9K");


var $ldPoq = parcelRequire("ldPoq");


var $1kRhf = parcelRequire("1kRhf");


var $3cA9y = parcelRequire("3cA9y");


var $2u6sV = parcelRequire("2u6sV");


var $1UHRU = parcelRequire("1UHRU");

const $9b741b87d47c6c28$var$emojiSpriteContainer = null;
const $9b741b87d47c6c28$var$emojiImageContainer = null;
const $9b741b87d47c6c28$var$handleMouseDown = (props, event)=>{
    // Clicked emoji delete button
    if (event.target instanceof Element && event.target.getAttribute('aria-label') === (0, $l4yrE.deleteEmojiLabel)) return;
    const { emoji: emoji, onSelected: onSelected } = props;
    if (onSelected && (0, $bvr9K.leftClick)(event)) {
        if (props.preventFocusOnMouseDown) event.preventDefault();
        onSelected((0, $ldPoq.toEmojiId)(emoji), emoji, event);
    }
};
const $9b741b87d47c6c28$var$handleKeyDown = (props, event)=>{
    if (!(0, $l4yrE.EMOJI_KEYBOARD_KEYS_SUPPORTED).includes(event.key)) return;
    event.preventDefault();
    event.stopPropagation();
    const { emoji: emoji, onSelected: onSelected, showDelete: showDelete } = props;
    if (onSelected && (event.key === (0, $l4yrE.KeyboardKeys).Enter || event.key === (0, $l4yrE.KeyboardKeys).Space)) onSelected((0, $ldPoq.toEmojiId)(emoji), emoji, event);
    if (showDelete && event.key === (0, $l4yrE.KeyboardKeys).Backspace) (0, $3cA9y.handleDelete)(props, event);
};
const $9b741b87d47c6c28$var$handleMouseMove = (props, event)=>{
    const { emoji: emoji, onMouseMove: onMouseMove } = props;
    if (onMouseMove) onMouseMove((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $9b741b87d47c6c28$var$handleFocus = (props, event)=>{
    const { emoji: emoji, onFocus: onFocus } = props;
    if (onFocus) onFocus((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $9b741b87d47c6c28$export$ce5eef59d8e46687 = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showTooltip: showTooltip, showDelete: showDelete, shouldBeInteractive: shouldBeInteractive = false, tabIndex: tabIndex, onSelected: onSelected, onMouseMove: onMouseMove, onFocus: onFocus, onDelete: onDelete, onLoadError: onLoadError, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, children: children, type: type, editorEmoji: editorEmoji, isDecorative: isDecorative, ...other } = props;
    const intl = (0, $cozmU.useContext)((0, $kSwu1.IntlContext));
    const isAriaLabelEmpty = editorEmoji || isDecorative;
    let ariaLabel;
    if (isAriaLabelEmpty) ariaLabel = undefined;
    else if (intl) ariaLabel = intl.formatMessage((0, $1kRhf.messages).changeEmojiShortnameButtonLabel, {
        shortName: emoji.name ?? emoji.shortName
    });
    else ariaLabel = emoji.shortName;
    const tooltipContent = showTooltip && (0, $ieeJu.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName || emoji.name || undefined : undefined;
    const emojiSpan = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        role: editorEmoji ? undefined : shouldBeInteractive ? 'button' : ariaLabel ? 'img' : 'presentation',
        "aria-label": ariaLabel,
        ref: ref,
        "data-testid": `${type}-emoji-${emoji.shortName}`,
        "data-emoji-type": type,
        tabIndex: shouldBeInteractive ? tabIndex || 0 : undefined,
        className: (0, $hekY6.default)([
            type === 'sprite' ? "_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _3iDTPbvbI6 _1iPKDrNZfY _2hB4kovbI6 _1GBPVvSPN1 _3woHNtSPN1 _2oqNm2t2nV _1XjlOoo126 _0eVgdoo126 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg" : "_0bjKvDzXzM _313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0KLXrujOvk _3iDTPbvbI6 _1RrJLit2nV _23odCivLZJ _1XjlOoo126 _0eVgdoo126 _2LVIB7YvD1 _4jXNFKYvD1 _3JWaHCRAKS _1MkY46YvD1 _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43C1O6y _0hot5EBMeg",
            className
        ]),
        onKeyDown: (event)=>$9b741b87d47c6c28$var$handleKeyDown(props, event),
        onMouseDown: (event)=>{
            $9b741b87d47c6c28$var$handleMouseDown(props, event);
        },
        onMouseEnter: (event)=>{
            $9b741b87d47c6c28$var$handleMouseMove(props, event);
        },
        onFocus: (event)=>{
            $9b741b87d47c6c28$var$handleFocus(props, event);
        },
        title: showTooltip && !(0, $ieeJu.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true) ? emoji.shortName : undefined,
        ...other
    }, children);
    if (tooltipContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipContent,
        isScreenReaderAnnouncementDisabled: true,
        position: "top",
        tag: "span"
    }, emojiSpan);
    return emojiSpan;
});
const $9b741b87d47c6c28$export$56cc48506ff790a = (props)=>{
    const { emoji: emoji } = props; // start emoji rendered experience, it may have already started earlier in ResourcedEmoji or CachingEmoji
    (0, $7gsaD.useSampledUFOComponentExperience)((0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $l4yrE.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'Emoji',
        emojiId: emoji.id
    });
    (0, $cozmU.useEffect)(()=>{
        const ufoExp = (0, $d8DK7.sampledUfoRenderedEmoji)(emoji);
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, 'fmp')) ufoExp.markFMP();
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).MOUNTED_END)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).MOUNTED_END);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // TODO: We always prefer render as image as having accessibility issues with sprite representation
    if ((0, $ie2rI.isSpriteRepresentation)(emoji.representation)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1UHRU.SpriteEmoji), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2u6sV.ImageEmoji), props);
};
var $9b741b87d47c6c28$export$2e2bcd8739ae039 = $9b741b87d47c6c28$export$56cc48506ff790a;
module.exports["EmojiNodeWrapper"] = $9b741b87d47c6c28$export$ce5eef59d8e46687;
module.exports["default"] = $9b741b87d47c6c28$export$2e2bcd8739ae039;

});

parcelRegister("7gsaD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $53TEx = parcelRequire("53TEx");

const $76dc57e6fa0afa99$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $cozmU.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $76dc57e6fa0afa99$export$f959821a7419dee1 = (experience, samplingRate, metadata)=>{
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            (0, $53TEx.withSampling)(experience).abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $76dc57e6fa0afa99$var$useConstructor(()=>{
        (0, $53TEx.withSampling)(experience).start({
            samplingRate: samplingRate
        });
        const isMetadataEmpty = Object.keys(experience.metadata).length === 0;
        if (metadata && isMetadataEmpty) experience.addMetadata(metadata);
    });
    return null;
};
module.exports["useSampledUFOComponentExperience"] = $76dc57e6fa0afa99$export$f959821a7419dee1;

});

parcelRegister("ie2rI", function(module, exports) {
const $74d8240b08e598d0$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
module.exports["isSpriteRepresentation"] = $74d8240b08e598d0$export$a194199d673d75de;

});

parcelRegister("bvr9K", function(module, exports) {
function $72087d0c7cb66425$export$34ebdaf2c517ae75(reactEvent) {
    return reactEvent.button === 0 && !reactEvent.altKey && !reactEvent.ctrlKey && !reactEvent.metaKey && !reactEvent.shiftKey;
}
module.exports["leftClick"] = $72087d0c7cb66425$export$34ebdaf2c517ae75;

});

parcelRegister("1kRhf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $68215d7718b9da32$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    deleteEmojiTooltip: {
        id: "fabric.emoji.delete.tooltip",
        defaultMessage: "Delete"
    },
    deleteEmojiTooltipForScreenreader: {
        id: "fabric.emoji.delete.screenreader.tooltip",
        defaultMessage: "To delete {shortName} emoji, press Backspace"
    },
    deleteEmojiTitle: {
        id: "fabric.emoji.delete.title",
        defaultMessage: "Remove emoji"
    },
    deleteEmojiDescription: {
        id: "fabric.emoji.delete.description",
        defaultMessage: "All existing instances of this emoji will be replaced with {emojiShortName}"
    },
    deleteEmojiLabel: {
        id: "fabric.emoji.delete.label",
        defaultMessage: "Remove"
    },
    addCustomEmojiLabel: {
        id: "fabric.emoji.add.custom.emoji.label",
        defaultMessage: "Add your own emoji"
    },
    emojiPlaceholder: {
        id: "fabric.emoji.placeholder",
        defaultMessage: "e.g. hello"
    },
    emojiNameAriaLabel: {
        id: "fabric.emoji.name.ariaLabel",
        defaultMessage: "Enter a name for the new emoji"
    },
    emojiNameLabel: {
        id: "fabric.emoji.name.label",
        defaultMessage: "Emoji name"
    },
    emojiChooseFileTitle: {
        id: "fabric.emoji.choose.file.title",
        defaultMessage: "Choose file"
    },
    emojiChooseFileDndTitle: {
        id: "fabric.emoji.choose.file.dnd.title",
        defaultMessage: "Select or drop an image"
    },
    emojiChooseFileScreenReaderDescription: {
        id: "fabric.emoji.choose.file.screenReaderDescription",
        defaultMessage: "Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB"
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: "fabric.emoji.select.skin.tone.ariaLabel",
        defaultMessage: "Choose your skin tone, {selectedTone} selected"
    },
    emojiSelectColorButtonAriaLabelText: {
        id: "fabric.emoji.select.color.ariaLabel",
        defaultMessage: "Productivity emoji color selector"
    },
    emojiSelectColorListAriaLabelText: {
        id: "fabric.emoji.select.color.list.ariaLabel",
        defaultMessage: "Productivity emoji colour selector"
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: "fabric.emoji.select.skin.list.ariaLabel",
        defaultMessage: "Skin tone selector"
    },
    emojiImageRequirements: {
        id: "fabric.emoji.image.requirements",
        defaultMessage: "JPG, PNG or GIF. Max size 1 MB."
    },
    emojiPreviewTitle: {
        id: "fabric.emoji.preview.title",
        defaultMessage: "Preview"
    },
    emojiPreview: {
        id: "fabric.emoji.preview",
        defaultMessage: "Your new emoji {emoji} looks great"
    },
    addEmojiLabel: {
        id: "fabric.emoji.add.label",
        defaultMessage: "Add emoji"
    },
    createEmojiWithRovoTitle: {
        id: "fabric.emoji.ai.create.title",
        defaultMessage: "Create an emoji with Rovo"
    },
    createEmojiWithRovoPromptPlaceholder: {
        id: "fabric.emoji.ai.prompt.placeholder",
        defaultMessage: "Describe your emoji..."
    },
    createEmojiWithRovoPromptAriaLabel: {
        id: "fabric.emoji.ai.prompt.ariaLabel",
        defaultMessage: "Describe the emoji you want to generate"
    },
    createEmojiWithRovoGenerateLabel: {
        id: "fabric.emoji.ai.generate.label",
        defaultMessage: "Generate"
    },
    createEmojiWithRovoError: {
        id: "fabric.emoji.ai.error",
        defaultMessage: "Something went wrong. Try a different description."
    },
    retryLabel: {
        id: "fabric.emoji.retry.label",
        defaultMessage: "Retry"
    },
    cancelLabel: {
        id: "fabric.emoji.cancel.label",
        defaultMessage: "Cancel"
    },
    searchPlaceholder: {
        id: "fabric.emoji.search.placeholder",
        defaultMessage: "Search"
    },
    searchLabel: {
        id: "fabric.emoji.search.label",
        defaultMessage: "Emoji name"
    },
    searchResultsStatus: {
        id: "fabric.emoji.search.status.count",
        defaultMessage: "Found {count} emojis"
    },
    searchResultsStatusSeeAll: {
        id: "fabric.emoji.search.status",
        defaultMessage: "Seeing all emojis"
    },
    categoriesSelectorLabel: {
        id: "fabric.emoji.categories.label",
        defaultMessage: "Choose an emoji category"
    },
    categoriesSearchResults: {
        id: "fabric.emoji.categories.search.results",
        defaultMessage: "Search results"
    },
    frequentCategory: {
        id: "fabric.emoji.category.frequent",
        defaultMessage: "Frequent"
    },
    peopleCategory: {
        id: "fabric.emoji.category.people",
        defaultMessage: "People"
    },
    natureCategory: {
        id: "fabric.emoji.category.nature",
        defaultMessage: "Nature"
    },
    foodsCategory: {
        id: "fabric.emoji.category.foods",
        defaultMessage: "Food & Drink"
    },
    activityCategory: {
        id: "fabric.emoji.category.activity",
        defaultMessage: "Activity"
    },
    placesCategory: {
        id: "fabric.emoji.category.places",
        defaultMessage: "Travel & Places"
    },
    objectsCategory: {
        id: "fabric.emoji.category.objects",
        defaultMessage: "Objects"
    },
    symbolsCategory: {
        id: "fabric.emoji.category.symbols",
        defaultMessage: "Symbols"
    },
    flagsCategory: {
        id: "fabric.emoji.category.flags",
        defaultMessage: "Flags"
    },
    productivityCategory: {
        id: "fabric.emoji.category.productivity",
        defaultMessage: "Atlassian & productivity"
    },
    userUploadsCustomCategory: {
        id: "fabric.emoji.category.user.uploads",
        defaultMessage: "Your uploads"
    },
    allUploadsCustomCategory: {
        id: "fabric.emoji.category.all.uploads",
        defaultMessage: "All uploads"
    },
    deleteEmojiFailed: {
        id: "fabric.emoji.error.delete.failed",
        defaultMessage: "Remove failed"
    },
    emojiInvalidImage: {
        id: "fabric.emoji.error.invalid.image",
        defaultMessage: "Selected image is invalid"
    },
    emojiUploadFailed: {
        id: "fabric.emoji.error.upload.failed",
        defaultMessage: "Upload failed"
    },
    emojiUploadTimeout: {
        id: "fabric.emoji.error.upload.timeout",
        defaultMessage: "Upload timed out"
    },
    emojiImageTooBig: {
        id: "fabric.emoji.error.image.too.big",
        defaultMessage: "Selected image is more than 1 MB"
    },
    emojiUnsupportedFileType: {
        id: "fabric.emoji.error.unsupported.file.type",
        defaultMessage: "This file type isn't supported. Select a PNG, JPEG, or GIF to create your emoji."
    },
    emojiDuplicateName: {
        id: "fabric.emoji.error.duplicate.name",
        defaultMessage: "An emoji with this name exists already"
    },
    emojiPickerNoResults: {
        id: "fabric.emoji.picker.no.results",
        defaultMessage: "No results"
    },
    emojiPickerAddCustomEmoji: {
        id: "fabric.emoji.picker.add.custom.emoji",
        defaultMessage: "Add custom emoji"
    },
    emojiPickerTitle: {
        id: "fabric.emoji.picker",
        defaultMessage: "Emoji picker"
    },
    emojiPickerListPanel: {
        id: "fabric.emoji.pickerlist.tabpanel",
        defaultMessage: "Emojis actions and list panel"
    },
    emojiPickerGrid: {
        id: "fabric.emoji.pickerlist.grid",
        defaultMessage: "{showSearchResults, select, true{Search results} other{Emojis}}"
    },
    emojiButtonRoleDescription: {
        id: "fabric.emoji.emojipicker.emoi.roledescription",
        defaultMessage: "emoji button"
    },
    changeEmojiShortnameButtonLabel: {
        id: "fabric.emoji.change.shortname.button.label",
        defaultMessage: "Change emoji, currently {shortName}"
    },
    error: {
        id: "fabric.emoji.emojipicker.error",
        defaultMessage: "Error!"
    }
});
module.exports["messages"] = $68215d7718b9da32$export$defe85febe8b728c;

});

parcelRegister("3cA9y", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ldPoq = parcelRequire("ldPoq");

const $05233230a42f662c$export$471c4c6c1d1a0512 = (props, event)=>{
    const { emoji: emoji, onDelete: onDelete } = props;
    if (onDelete) onDelete((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
module.exports["handleDelete"] = $05233230a42f662c$export$471c4c6c1d1a0512;

});

parcelRegister("2u6sV", function(module, exports) {
/* ImageEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");


var $lpNn5 = parcelRequire("lpNn5");


var $c66dg = parcelRequire("c66dg");


var $kLQGL = parcelRequire("kLQGL");


var $9tfSW = parcelRequire("9tfSW");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $6Y7Xc = parcelRequire("6Y7Xc");


var $2p7KE = parcelRequire("2p7KE");


var $72OmS = parcelRequire("72OmS");


var $ldPoq = parcelRequire("ldPoq");


var $kpf8v = parcelRequire("kpf8v");


var $9qxV9 = parcelRequire("9qxV9");


var $7Ya31 = parcelRequire("7Ya31");


var $1FzXO = parcelRequire("1FzXO");


var $3cA9y = parcelRequire("3cA9y");


var $a5rDX = parcelRequire("a5rDX");

const $7cbdfa334838272a$var$handleImageError = (props, event)=>{
    const { emoji: emoji, onLoadError: onLoadError } = props; // Hide error state (but keep space for it)
    if (event.target) {
        const target = event.target;
        target.style.visibility = 'hidden';
    }
    if (onLoadError) onLoadError((0, $ldPoq.toEmojiId)(emoji), emoji, event);
};
const $7cbdfa334838272a$export$99dfeb9d71c11788 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className, showDelete: showDelete, onLoadSuccess: onLoadSuccess, disableLazyLoad: disableLazyLoad, autoWidth: autoWidth, isDecorative: isDecorative } = props;
    const [ref, inView] = (0, $kLQGL.useInView)({
        triggerOnce: true
    });
    const ufoExp = (0, $cozmU.useMemo)(()=>(0, $d8DK7.sampledUfoRenderedEmoji)(emoji), [
        emoji
    ]);
    const classes = `${(0, $a5rDX.emojiMainStyle)} ${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${(0, $a5rDX.emojiImage)} ${className ? className : ''} ${showDelete ? (0, $a5rDX.deletableEmoji) : ''}`;
    let width;
    let height;
    let src;
    const representation = (0, $c66dg.shouldUseAltRepresentation)(emoji, fitToHeight) ? emoji.altRepresentation : emoji.representation;
    if ((0, $2p7KE.isImageRepresentation)(representation)) {
        src = representation.imagePath;
        width = representation.width;
        height = representation.height;
    } else if ((0, $72OmS.isMediaRepresentation)(representation)) {
        src = representation.mediaPath;
        width = representation.width;
        height = representation.height;
    }
    let sizing = {};
    if (fitToHeight && width && height) {
        const sizingWidth = autoWidth ? 'auto' : fitToHeight / height * width; // Presize image, to prevent reflow due to size changes after loading
        sizing = {
            width: sizingWidth,
            height: fitToHeight
        };
    }
    const onError = (0, $cozmU.useCallback)((event)=>{
        $7cbdfa334838272a$var$handleImageError({
            emoji: props.emoji,
            onLoadError: props.onLoadError
        }, event);
    }, [
        props.emoji,
        props.onLoadError
    ]);
    const onLoad = (0, $cozmU.useCallback)(()=>{
        const mountedMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9tfSW.UfoEmojiTimings).MOUNTED_END); // onload could trigger before onBeforeLoad when emojis in viewport at start, so we need to mark onload start manually.
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_START, mountedMark?.time);
        const loadedStartMark = ufoExp.metrics.marks.find((mark)=>mark.name === (0, $9tfSW.UfoEmojiTimings).ONLOAD_START);
        if (mountedMark && loadedStartMark) ufoExp.addMetadata({
            lazyLoad: loadedStartMark.time > mountedMark.time
        });
         // onload_start
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_END)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_END);
        ufoExp.success({
            metadata: {
                IBSupported: (0, $6Y7Xc.default).supportsIntersectionObserver
            }
        });
        if (onLoadSuccess) onLoadSuccess(emoji);
    }, [
        emoji,
        onLoadSuccess,
        ufoExp
    ]);
    const onBeforeLoad = (0, $cozmU.useCallback)(()=>{
        if (!(0, $1GEKi.hasUfoMarked)(ufoExp, (0, $9tfSW.UfoEmojiTimings).ONLOAD_START)) ufoExp.mark((0, $9tfSW.UfoEmojiTimings).ONLOAD_START);
    }, [
        ufoExp
    ]);
    const onMouseOver = (0, $cozmU.useCallback)((e)=>{
        // only disable tooltip when not on focus
        if (!(0, $1hQ0e.getDocument)()?.activeElement?.contains(e.target)) e.stopPropagation();
    }, []); // because of the lack of browser support of on before load natively, used IntersectionObserver helper hook to mimic the before load time mark for UFO.
    (0, $cozmU.useEffect)(()=>{
        if (inView) onBeforeLoad();
    }, [
        inView,
        onBeforeLoad
    ]);
    const imgAlt = isDecorative ? '' : emoji.name || emoji.shortName || '';
    const emojiNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        loading: disableLazyLoad ? 'eager' : 'lazy',
        src: src,
        key: src,
        alt: imgAlt,
        "data-emoji-short-name": emoji.shortName,
        "data-emoji-id": emoji.id,
        "data-emoji-text": emoji.fallback || emoji.shortName,
        className: "emoji",
        style: {
            visibility: 'visible'
        },
        onError: onError,
        onLoad: onLoad,
        ...sizing,
        "data-vc": "emoji"
    }); // show a tooltip for deletable emoji only on focus
    if (showDelete) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kpf8v.DeletableEmojiTooltipContent), null),
        position: "right-start",
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        "aria-labelledby": `screenreader-emoji-${emoji.id}`,
        type: "image",
        className: classes,
        ref: ref,
        showTooltip: false,
        onMouseOver: onMouseOver
    }, emojiNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Ya31.default), {
        onClick: (event)=>(0, $3cA9y.handleDelete)(props, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9qxV9.DeletableEmojiTooltipContentForScreenReader), {
        emoji: emoji
    })));
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        type: "image",
        className: classes,
        ref: ref
    }, emojiNode));
};
module.exports["ImageEmoji"] = $7cbdfa334838272a$export$99dfeb9d71c11788;

});

parcelRegister("c66dg", function(module, exports) {

var $d96oP = parcelRequire("d96oP");

const $c6cbfe5640e3365a$var$getHeight = (fitToHeight)=>(0, $d96oP.getPixelRatio)() > 1 ? fitToHeight * 2 : fitToHeight;
const $c6cbfe5640e3365a$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && emoji.representation && 'height' in emoji.representation && $c6cbfe5640e3365a$var$getHeight(fitToHeight) > emoji.representation.height);
module.exports["shouldUseAltRepresentation"] = $c6cbfe5640e3365a$export$b7e9058f156d8d19;

});

parcelRegister("kLQGL", function(module, exports) {

var $5sUij = parcelRequire("5sUij");


var $6Y7Xc = parcelRequire("6Y7Xc");

const $195e4aff720550fa$export$2f62ee6831462844 = (options)=>{
    const hookResult = (0, $5sUij.useInView)(options);
    if (!(0, $6Y7Xc.default).supportsIntersectionObserver) // Unsupported, return no `ref` and default `inView` true value
    return [
        undefined,
        true
    ];
    return hookResult;
};
module.exports["useInView"] = $195e4aff720550fa$export$2f62ee6831462844;

});

parcelRegister("5sUij", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

"use client";
var $3fab3c301f36e350$var$__defProp = Object.defineProperty;
var $3fab3c301f36e350$var$__defNormalProp = (obj, key, value)=>key in obj ? $3fab3c301f36e350$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $3fab3c301f36e350$var$__publicField = (obj, key, value)=>$3fab3c301f36e350$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/observe.ts
var $3fab3c301f36e350$var$observerMap = /* @__PURE__ */ new Map();
var $3fab3c301f36e350$var$RootIds = /* @__PURE__ */ new WeakMap();
var $3fab3c301f36e350$var$rootId = 0;
var $3fab3c301f36e350$var$unsupportedValue = void 0;
function $3fab3c301f36e350$export$2ef3a60ee1f37bec(inView) {
    $3fab3c301f36e350$var$unsupportedValue = inView;
}
function $3fab3c301f36e350$var$getRootId(root) {
    if (!root) return "0";
    if ($3fab3c301f36e350$var$RootIds.has(root)) return $3fab3c301f36e350$var$RootIds.get(root);
    $3fab3c301f36e350$var$rootId += 1;
    $3fab3c301f36e350$var$RootIds.set(root, $3fab3c301f36e350$var$rootId.toString());
    return $3fab3c301f36e350$var$RootIds.get(root);
}
function $3fab3c301f36e350$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $3fab3c301f36e350$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $3fab3c301f36e350$var$createObserver(options) {
    const id = $3fab3c301f36e350$var$optionsToId(options);
    let instance = $3fab3c301f36e350$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $3fab3c301f36e350$var$observerMap.set(id, instance);
    }
    return instance;
}
function $3fab3c301f36e350$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $3fab3c301f36e350$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $3fab3c301f36e350$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $3fab3c301f36e350$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $3fab3c301f36e350$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $3fab3c301f36e350$export$a62107ca74432f44 = class extends $cozmU.Component {
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $3fab3c301f36e350$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $cozmU.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
    constructor(props){
        super(props);
        $3fab3c301f36e350$var$__publicField(this, "node", null);
        $3fab3c301f36e350$var$__publicField(this, "_unobserveCb", null);
        $3fab3c301f36e350$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $3fab3c301f36e350$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$3fab3c301f36e350$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
};
function $3fab3c301f36e350$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $cozmU.useState(null);
    const callback = $cozmU.useRef(onChange);
    const [state, setState] = $cozmU.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $cozmU.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $3fab3c301f36e350$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $cozmU.useRef(void 0);
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}
 //# sourceMappingURL=index.mjs.map
module.exports["useInView"] = $3fab3c301f36e350$export$2f62ee6831462844;

});

parcelRegister("6Y7Xc", function(module, exports) {
const $ce7a17dc9ab6d41e$var$result = {
    mac: false,
    supportsIntersectionObserver: false
};
if (typeof navigator !== 'undefined') {
    $ce7a17dc9ab6d41e$var$result.mac = /Mac/.test(navigator.platform);
    $ce7a17dc9ab6d41e$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
}
var $ce7a17dc9ab6d41e$export$2e2bcd8739ae039 = $ce7a17dc9ab6d41e$var$result;
module.exports["default"] = $ce7a17dc9ab6d41e$export$2e2bcd8739ae039;

});

parcelRegister("kpf8v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4S9CC = parcelRequire("4S9CC");


var $1kRhf = parcelRequire("1kRhf");


var $47c2F = parcelRequire("47c2F");

const $62e6710b6e922942$export$4727956877b6f612 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47c2F.ToolTipContentWithKeymap), {
        description: formatMessage((0, $1kRhf.messages).deleteEmojiTooltip),
        keymap: (0, $4S9CC.backspace)
    });
};
module.exports["DeletableEmojiTooltipContent"] = $62e6710b6e922942$export$4727956877b6f612;

});

parcelRegister("4S9CC", function(module, exports) {
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $aokDQ = parcelRequire("aokDQ");

const $05c9bdca5f91550e$export$1ea584ca7009bcc1 = (0, $aokDQ.makeKeyMapWithCommon)('Backspace', 'Backspace');
const $05c9bdca5f91550e$export$8d734690d3a46118 = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
module.exports["backspace"] = $05c9bdca5f91550e$export$1ea584ca7009bcc1;
module.exports["arrowKeysMap"] = $05c9bdca5f91550e$export$8d734690d3a46118;

});

parcelRegister("aokDQ", function(module, exports) {
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $3gg6O = parcelRequire("3gg6O");

function $f45a08709afce394$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace(/Mod/i, 'Ctrl');
    const mac = common.replace(/Mod/i, 'Cmd');
    return (0, $3gg6O.makeKeymap)(description, windows, mac, common);
}
module.exports["makeKeyMapWithCommon"] = $f45a08709afce394$export$7e6b588cc98b34f1;

});

parcelRegister("3gg6O", function(module, exports) {
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ function $53c540ad50774e92$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace(/Mod/i, 'Ctrl'),
        mac: mac.replace(/Mod/i, 'Cmd'),
        common: common
    };
}
module.exports["makeKeymap"] = $53c540ad50774e92$export$d8a7f422d8d42038;

});

parcelRegister("47c2F", function(module, exports) {
/* ToolTipContentWithKeymap.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $eOYxO = parcelRequire("eOYxO");

const $99794ca75c05544d$var$tooltipShortcutStyle = null;
const $99794ca75c05544d$export$c7308f5f9ed494ac = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && (0, $eOYxO.formatShortcut)(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0KLXruB4sa _0Of8r2dnbC _1wydGWdnbC _2Zuz6QFQfX _1ZnuxbFQfX _1iKH5nD0un"
        ])
    }, shortcut)) : null;
});
module.exports["ToolTipContentWithKeymap"] = $99794ca75c05544d$export$c7308f5f9ed494ac;

});

parcelRegister("eOYxO", function(module, exports) {
/**
 * Copied from editor-common: https://bitbucket.org/atlassian/atlassian-frontend/src/d01430a20500d720791d0667fd7cfe25d254f2e3/packages/editor/editor-common/src/keymaps/index.tsx
 */ 
var $6Y7Xc = parcelRequire("6Y7Xc");


var $4S9CC = parcelRequire("4S9CC");

function $eaa3cf1c1fac6b0b$export$384a290f8c265cc5(keymap) {
    let shortcut;
    if ((0, $6Y7Xc.default).mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace(/Cmd/i, '\u2318').replace(/Shift/i, '\u21E7').replace(/Ctrl/i, '\u2303').replace(/Alt/i, '\u2325').replace(/Backspace/i, '\u232B').replace(/Enter/i, '\u23CE');
    else shortcut = keymap.windows.replace(/Backspace/i, '\u232B');
    const keys = shortcut.split('-');
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = (0, $4S9CC.arrowKeysMap)[lastKey.toUpperCase()] || lastKey;
    return keys.join((0, $6Y7Xc.default).mac ? '' : '+');
}
module.exports["formatShortcut"] = $eaa3cf1c1fac6b0b$export$384a290f8c265cc5;

});

parcelRegister("9qxV9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9GVkD = parcelRequire("9GVkD");


var $1kRhf = parcelRequire("1kRhf");

const $1d251284bd364c50$export$d151e4941072147c = ({ emoji: emoji })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
        id: `screenreader-emoji-${emoji.id}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $1kRhf.messages).deleteEmojiTooltipForScreenreader,
        values: {
            shortName: emoji.shortName
        }
    }));
};
module.exports["DeletableEmojiTooltipContentForScreenReader"] = $1d251284bd364c50$export$d151e4941072147c;

});

parcelRegister("7Ya31", function(module, exports) {
/* DeleteButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7ZB0A = parcelRequire("7ZB0A");


var $5avUB = parcelRequire("5avUB");


var $iMnC5 = parcelRequire("iMnC5");


var $l4yrE = parcelRequire("l4yrE");


var $a5rDX = parcelRequire("a5rDX");

const $beda65cbb4bf246c$var$styles = {
    boxWrapperStyle: "_39xV0270UD _0jFU0V70UD"
};
const $beda65cbb4bf246c$var$deleteButton = null;
const $beda65cbb4bf246c$var$refreshedDeleteButton = null; /**
                                     * Test id for wrapper Emoji delete button
                                     */ 
const $beda65cbb4bf246c$export$28fc7374cf1206d4 = 'render-emoji-delete-button';
const $beda65cbb4bf246c$var$DeleteButton = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_0fKRyPnQyn _3iDTPbQ4SZ _1mT5xdWVPG _2IhTon4F84 _4ApkO24F84 _42Yu6B7dHp _2CTNV7dnbC",
            "_2IhTon5UaJ _4ApkO25UaJ",
            (0, $a5rDX.emojiDeleteButton)
        ]),
        "data-testid": $beda65cbb4bf246c$export$28fc7374cf1206d4
    }, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        iconBefore: /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: $beda65cbb4bf246c$var$styles.boxWrapperStyle
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: (0, $l4yrE.deleteEmojiLabel),
            color: "var(--ds-icon, #292A2E)",
            size: "medium"
        })),
        onClick: props.onClick,
        appearance: "subtle-link",
        spacing: "none",
        testId: "emoji-delete-button",
        tabIndex: -1
    }));
};
var $beda65cbb4bf246c$export$2e2bcd8739ae039 = $beda65cbb4bf246c$var$DeleteButton;
module.exports["default"] = $beda65cbb4bf246c$export$2e2bcd8739ae039;

});

parcelRegister("a5rDX", function(module, exports) {
const $86842ff0dedec441$export$8633a0edef8e95dd = 'emoji-common-selected';
const $86842ff0dedec441$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $86842ff0dedec441$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $86842ff0dedec441$export$b06c4aab1d012063 = 'emoji-common-node';
const $86842ff0dedec441$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $86842ff0dedec441$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $86842ff0dedec441$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $86842ff0dedec441$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $86842ff0dedec441$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $86842ff0dedec441$export$b0fe756d87022806 = 'emoji-picker-add-emoji';
module.exports["commonSelectedStyles"] = $86842ff0dedec441$export$8633a0edef8e95dd;
module.exports["selectOnHoverStyles"] = $86842ff0dedec441$export$860109dfd198259b;
module.exports["emojiSprite"] = $86842ff0dedec441$export$1c10634420a08d8a;
module.exports["emojiNodeStyles"] = $86842ff0dedec441$export$b06c4aab1d012063;
module.exports["emojiImage"] = $86842ff0dedec441$export$da61cef1c8919f7c;
module.exports["emojiDeleteButton"] = $86842ff0dedec441$export$b11fa39b56a371f6;
module.exports["emojiMainStyle"] = $86842ff0dedec441$export$11462c0756c24ab6;
module.exports["deletableEmoji"] = $86842ff0dedec441$export$22b19c311e9caa4;
module.exports["placeholder"] = $86842ff0dedec441$export$c7187bbd1a7a9244;

});

parcelRegister("1UHRU", function(module, exports) {
/* SpriteEmoji.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $1FzXO = parcelRequire("1FzXO");


var $a5rDX = parcelRequire("a5rDX");

const $1c04ac8f330413af$export$ef49ddbb198ce334 = (props)=>{
    const { emoji: emoji, fitToHeight: fitToHeight, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const representation = emoji.representation;
    const sprite = representation.sprite;
    const classes = `${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    let sizing = {};
    if (fitToHeight) {
        if ((0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) sizing = {
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
        else sizing = {
            width: `${fitToHeight}px`,
            height: `${fitToHeight}px`,
            minHeight: `${fitToHeight}px`,
            minWidth: `${fitToHeight}px`
        };
    }
    const xPositionInPercent = 100 / (sprite.column - 1) * (representation.xIndex - 0);
    const yPositionInPercent = 100 / (sprite.row - 1) * (representation.yIndex - 0);
    const style = {
        backgroundImage: `url(${sprite.url})`,
        backgroundPosition: `${xPositionInPercent}% ${yPositionInPercent}%`,
        backgroundSize: `${sprite.column * 100}% ${sprite.row * 100}%`,
        ...sizing
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ $cozmU.createElement((0, $1FzXO.EmojiNodeWrapper), {
        ...props,
        type: "sprite",
        className: classes
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $a5rDX.emojiSprite),
        style: style
    })));
};
module.exports["SpriteEmoji"] = $1c04ac8f330413af$export$ef49ddbb198ce334;

});

parcelRegister("iKpb2", function(module, exports) {
/* EmojiPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $ieeJu = parcelRequire("ieeJu");


var $l4yrE = parcelRequire("l4yrE");


var $dprMh = parcelRequire("dprMh");


var $a5rDX = parcelRequire("a5rDX");

const $60c089d6c9d8e0bd$var$placeholderContainer = null;
const $60c089d6c9d8e0bd$var$EmojiPlaceholder = (props)=>{
    const { shortName: shortName, size: size = (0, $l4yrE.defaultEmojiHeight), showTooltip: showTooltip, representation: representation, loading: loading = false, xcss: xcss } = props;
    let scaledWidth;
    let scaledHeight;
    if (representation && size) {
        const width = representation.width;
        const height = representation.height;
        if (width && height) {
            scaledWidth = size / height * width;
            scaledHeight = size;
        }
    }
    const width = scaledWidth || size;
    const height = scaledHeight || size;
    const style = (0, $ieeJu.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? {
        fill: 'f7f7f7',
        minWidth: `${0, $l4yrE.defaultDenseEmojiHeight}px`,
        minHeight: `${0, $l4yrE.defaultDenseEmojiHeight}px`
    } : {
        fill: 'f7f7f7',
        minWidth: `${width}px`,
        width: `${width}px`,
        height: `${height}px`
    };
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-testid": (0, $dprMh.emojiPlaceholderTestId)(shortName),
        "aria-busy": loading,
        role: "status",
        "aria-label": shortName,
        className: (0, $hekY6.default)([
            "_313842A17z _0adFHsdnbC _1DCdHiA17z _2XsHFMdnbC _0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _1mT5xdRAKS _3iDTPbvbI6 _0KLXru9r67 _1RrJLit2nV _1ANEUSLRg7 _2fwxA5DIqT",
            [
                (0, $a5rDX.placeholder),
                xcss
            ].join(' ')
        ]),
        style: style,
        title: showTooltip ? shortName : ''
    });
};
var $60c089d6c9d8e0bd$export$2e2bcd8739ae039 /**
                                  * @deprecated Use `import { emojiPlaceholderTestId } from '@atlaskit/emoji/emoji-placeholder'` instead.
                                  */  = $60c089d6c9d8e0bd$var$EmojiPlaceholder;
module.exports["default"] = $60c089d6c9d8e0bd$export$2e2bcd8739ae039;

});

parcelRegister("dprMh", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ const $79e8257d19df66c1$export$73987987fac5266b = (shortName)=>`emoji-placeholder-${shortName}`;
module.exports["emojiPlaceholderTestId"] = $79e8257d19df66c1$export$73987987fac5266b;

});

parcelRegister("fGXGw", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");


var $bl5yp = parcelRequire("bl5yp");

function $3ba3c538e2294e67$var$acceptDrop(event) {
    // if the event is already prevented the event we don't need to do anything
    if (event.defaultPrevented) return;
    // Using "move" as the drop effect as that uses the standard
    // cursor. Doing this so the user doesn't think they are dropping
    // on the page
    // Note: using "none" will not allow a "drop" to occur, so we are using "move"
    if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
    // cancel the default browser behaviour
    // doing this will tell the browser that we have handled the drop
    event.preventDefault();
}
let $3ba3c538e2294e67$var$unbindEvents = null;
/**
 * Block drag operations outside of `@atlaskit/pragmatic-drag-and-drop`
 */ function $3ba3c538e2294e67$var$start() {
    $3ba3c538e2294e67$var$cleanup();
    $3ba3c538e2294e67$var$unbindEvents = (0, $cbY7C.bindAll)(window, [
        {
            type: 'dragover',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'dragenter',
            listener: $3ba3c538e2294e67$var$acceptDrop
        },
        {
            type: 'drop',
            listener (event) {
                // our lifecycle manager already prevents events, but just being super safe
                event.preventDefault();
                // not setting dropEffect, as `drop.dropEffect` has already been published to the user
                // (lifecycle-manager binds events in the capture phase)
                // we don't need to wait for "dragend", and "dragend" might not even happen,
                // such as when the draggable has been removed during a drag.
                $3ba3c538e2294e67$var$cleanup();
            }
        },
        {
            type: 'dragend',
            listener: $3ba3c538e2294e67$var$cleanup
        },
        ...(0, $bl5yp.getBindingsForBrokenDrags)({
            onDragEnd: $3ba3c538e2294e67$var$cleanup
        })
    ], // being clear that these are added in the bubble phase
    {
        capture: false
    });
}
function $3ba3c538e2294e67$var$cleanup() {
    $3ba3c538e2294e67$var$unbindEvents?.();
    $3ba3c538e2294e67$var$unbindEvents = null;
}
/**
 * TODO: for next major, we could look at do the following:
 *
 * ```diff
 * - preventUnhandled.start();
 * - preventUnhandled.stop();
 * + const stop = preventUnhandled();
 * ```
 */ function $3ba3c538e2294e67$var$stop() {
    /**
	 * if `stop()` is called in a `"drop"` event, then `event.preventDefault()` won't be called.
	 * Our `"drop"` listener calls `event.preventDefault()` for handled drop events
	 * ("drop" events caused by dropping over a drop target)
	 * `preventUnhandled()` causes every element to become a drop target (according to the browser)
	 *
	 * To opt out of the default behaviour for a `"drop"` event, we need to make sure
	 * that we cancel it.
	 *
	 * The `"drop"` event listener in core is in the `capture` phase, so people calling
	 * `preventUnhandled.stop()` in `onDrop()` will remove the `"drop"` event listener in this
	 * file before it has the chance to cancel the event.
	 *
	 * Being sneaky and using the `window.event` global to sniff out the current event
	 */ if (window.event?.type === 'drop') window.event?.preventDefault();
    $3ba3c538e2294e67$var$cleanup();
}
const $3ba3c538e2294e67$export$453c0582481cc59d = {
    start: $3ba3c538e2294e67$var$start,
    stop: $3ba3c538e2294e67$var$stop
};
module.exports["preventUnhandled"] = $3ba3c538e2294e67$export$453c0582481cc59d;

});

parcelRegister("gOVqR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aGLvf = parcelRequire("aGLvf");

const $58edf92bb5fbac7d$var$supportsUploadFeature = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
const $58edf92bb5fbac7d$export$482903c4ce3f5633 = ()=>{
    const context = (0, $cozmU.useContext)((0, $aGLvf.EmojiContext));
    // Hooks API
    const [isUploadSupported, setIsUploadSupported] = (0, $cozmU.useState)(false);
    if (!context) throw new Error('useEmoji must be used within EmojiContext');
    const { emojiProvider: emojiProvider } = context.emoji;
    (0, $cozmU.useEffect)(()=>{
        if ($58edf92bb5fbac7d$var$supportsUploadFeature(emojiProvider)) {
            const checkIfUploadIsSupported = async ()=>{
                try {
                    const supported = await emojiProvider.isUploadSupported();
                    setIsUploadSupported(supported);
                    return true;
                } catch (error) {
                    return false;
                }
            };
            checkIfUploadIsSupported();
        }
    }, [
        emojiProvider
    ]);
    return {
        emojiProvider: emojiProvider,
        isUploadSupported: isUploadSupported
    };
};
module.exports["useEmoji"] = $58edf92bb5fbac7d$export$482903c4ce3f5633;

});

parcelRegister("6vxzB", function(module, exports) {
const $70a5b093cb3b548a$export$c30017717ce2168e = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local",
            ...attributes
        }
    });
module.exports["createEvent"] = $70a5b093cb3b548a$export$c30017717ce2168e;

});

parcelRegister("8tMWQ", function(module, exports) {
/**
 * Used for store failure metadata for analytics
 * @param error The error could be a service error with {code, reason} or an Error
 * @returns any
 */ const $2cfa8eb58ac7a222$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};
module.exports["extractErrorInfo"] = $2cfa8eb58ac7a222$export$74aaf4784c2edb2c;

});

parcelRegister("asQaT", function(module, exports) {

var $6vxzB = parcelRequire("6vxzB");

const $002167777178fde4$export$ccd0c8bcbda28b7a = (emoji)=>(source)=>{
        return (0, $6vxzB.createEvent)('operational', 'failed', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
module.exports["recordFailedEmoji"] = $002167777178fde4$export$ccd0c8bcbda28b7a;

});

parcelRegister("25bJi", function(module, exports) {

var $6vxzB = parcelRequire("6vxzB");

const $7aea967cf124fb1b$export$3125c3f60f61a0a9 = (emoji)=>(source)=>{
        return (0, $6vxzB.createEvent)('operational', 'succeeded', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji?.id,
            emojiType: emoji?.type,
            emojiCategory: emoji?.category
        });
    };
module.exports["recordSucceededEmoji"] = $7aea967cf124fb1b$export$3125c3f60f61a0a9;

});

parcelRegister("jLKkm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1GEKi = parcelRequire("1GEKi");


var $d8DK7 = parcelRequire("d8DK7");


var $e4Q12 = parcelRequire("e4Q12");


var $7gsaD = parcelRequire("7gsaD");


var $l4yrE = parcelRequire("l4yrE");


var $fZ1dq = parcelRequire("fZ1dq");


var $6cRgO = parcelRequire("6cRgO");


var $1FzXO = parcelRequire("1FzXO");


var $gGeSk = parcelRequire("gGeSk");


var $9Jo6P = parcelRequire("9Jo6P");

const $1bfa3672d7898975$export$e81207f376d36133 = (props)=>{
    // Optimisation to only render CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
    // start emoji rendered experience, it may have already started earlier in `ResourcedEmoji`.
    (0, $7gsaD.useSampledUFOComponentExperience)((0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $l4yrE.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'CachingEmoji',
        emojiId: emoji.id
    });
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $1GEKi.hasUfoMarked)((0, $d8DK7.sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, $d8DK7.sampledUfoRenderedEmoji)(emoji).markFMP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiNode = ()=>{
        if ((0, $fZ1dq.isMediaEmoji)(emoji)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cRgO.CachingMediaEmoji), {
            emoji: emoji,
            placeholderSize: placeholderSize,
            ...restProps
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1bfa3672d7898975$var$StandardEmoji, {
            emoji: emoji,
            ...restProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Jo6P.UfoErrorBoundary), {
        experiences: [
            (0, $e4Q12.ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
        ]
    }, emojiNode());
};
const $1bfa3672d7898975$var$StandardEmoji = (props)=>{
    const { emoji: emoji, ...restProps } = props;
    const [imageLoadError, setImageLoadError] = (0, $cozmU.useState)(false);
    const handleLoadError = (_emojiId)=>{
        setImageLoadError(true);
    };
    if (imageLoadError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gGeSk.default), {
        emoji: emoji,
        ...restProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.default), {
        emoji: emoji,
        onLoadError: handleLoadError,
        ...restProps
    });
};
const $1bfa3672d7898975$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)($1bfa3672d7898975$export$e81207f376d36133);
var $1bfa3672d7898975$export$2e2bcd8739ae039 = $1bfa3672d7898975$var$_default_1;
module.exports["default"] = $1bfa3672d7898975$export$2e2bcd8739ae039;

});

parcelRegister("6cRgO", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gOVqR = parcelRequire("gOVqR");


var $9tfSW = parcelRequire("9tfSW");


var $8tMWQ = parcelRequire("8tMWQ");


var $d8DK7 = parcelRequire("d8DK7");


var $l3Ofr = parcelRequire("l3Ofr");


var $1FzXO = parcelRequire("1FzXO");


var $iKpb2 = parcelRequire("iKpb2");

const $99e2ad1a227dfe6b$export$aa961da7639f7a98 = (props)=>{
    const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
    const { shortName: shortName, representation: representation } = emoji;
    const [cachedEmoji, setCachedEmoji] = (0, $cozmU.useState)();
    const [inValidImage, setInvalidImage] = (0, $cozmU.useState)(false);
    const { emojiProvider: emojiProvider } = (0, $gOVqR.useEmoji)();
    const loadEmoji = (0, $cozmU.useCallback)((emojiProvider)=>{
        (0, $l3Ofr.default)('Loading image via media cache', emoji.shortName);
        (0, $d8DK7.sampledUfoRenderedEmoji)(emoji).mark((0, $9tfSW.UfoEmojiTimings).MEDIA_START);
        emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
            setCachedEmoji(cachedEmoji);
            setInvalidImage(false);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emoji).mark((0, $9tfSW.UfoEmojiTimings).MEDIA_END);
        }).catch((error)=>{
            setCachedEmoji(undefined);
            setInvalidImage(true);
            (0, $d8DK7.sampledUfoRenderedEmoji)(emoji).failure({
                metadata: {
                    error: (0, $8tMWQ.extractErrorInfo)(error),
                    reason: 'failed to load media emoji',
                    source: 'CachingMediaEmoji',
                    emojiId: emoji.id
                }
            });
        });
    }, [
        emoji
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (emojiProvider) loadEmoji(emojiProvider);
    }, [
        emojiProvider,
        loadEmoji
    ]);
    const handleLoadError = (_emojiId)=>{
        (0, $d8DK7.sampledUfoRenderedEmoji)(_emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'CachingMediaEmoji',
                emojiId: _emojiId.id
            }
        });
        setInvalidImage(true);
    };
    if (cachedEmoji && !inValidImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.default), {
        ...restProps,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        emoji: cachedEmoji,
        onLoadError: handleLoadError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKpb2.default), {
        size: fitToHeight || placeholderSize,
        shortName: shortName,
        showTooltip: showTooltip,
        representation: representation
    });
};
module.exports["CachingMediaEmoji"] = $99e2ad1a227dfe6b$export$aa961da7639f7a98;

});

parcelRegister("gGeSk", function(module, exports) {
/* EmojiFallback.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1FzXO = parcelRequire("1FzXO");


var $a5rDX = parcelRequire("a5rDX");

const $ff7054dcfd0496ff$var$emojiFallbackStyles = null;
const $ff7054dcfd0496ff$export$e3a226c1c0d61870 = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const { fallback: fallback, shortName: shortName } = emoji;
    const classes = `${(0, $a5rDX.emojiNodeStyles)} ${selected ? (0, $a5rDX.commonSelectedStyles) : ''} ${selectOnHover ? (0, $a5rDX.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1FzXO.EmojiNodeWrapper), {
        type: "image",
        ...props,
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _37wbyuDIqT _0hPCNLDIqT"
        ])
    }, fallback || shortName)));
};
var $ff7054dcfd0496ff$export$2e2bcd8739ae039 = $ff7054dcfd0496ff$export$e3a226c1c0d61870;
module.exports["default"] = $ff7054dcfd0496ff$export$2e2bcd8739ae039;

});

parcelRegister("lBoXQ", function(module, exports) {
/* EmojiPreviewComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4o0zT = parcelRequire("4o0zT");


var $6LE4D = parcelRequire("6LE4D");


var $jLKkm = parcelRequire("jLKkm");

const $5103a64cbf38c21b$var$emojiName = null;
const $5103a64cbf38c21b$var$emojiShortName = null;
const $5103a64cbf38c21b$var$preview = null;
const $5103a64cbf38c21b$var$previewImg = null;
const $5103a64cbf38c21b$var$previewText = null;
const $5103a64cbf38c21b$var$EmojiPreviewComponentLegacy = ({ emoji: emoji })=>{
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0Of8r2uFDC _1ZnuxbuFDC _1wydGWuFDC _2Zuz6QuFDC _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9LRg7 _0jFU0VUofl _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _39xV02Uofl _2yHzK9dnbC _3j6ezTdnbC _3i7n2adnbC _26yOTxdnbC _3skfARdnbC _3natBxdnbC _1FPnnJdnbC _1vJRcjdnbC _0mzAWiUofl _0LOdDvUofl _430i96Uofl _03qA4iUofl _27LRgcOLYo _4tayJvOLYo _3LOhKmdnbC _3M4DpidnbC _2smhYldnbC _42LJStdnbC _43vhjeRAKS _4snuQ5715P _3vDJ5g715P _0ywjPhx5FZ _40IPznUofl _3jqVQ5Uofl _0vcmbtvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $jLKkm.default), {
        key: emoji.id || emoji.shortName,
        emoji: emoji
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _4xdlr0DIqT _313842Ll21 _2XsHFMuFDC _1EqgXlyt6F _39xV02yt6F _2O5Vij7dHp _3YEZNO7dHp"
        ])
    }, emoji.name && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7 _09eJsYAv7U"
        ])
    }, emoji.name), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1UtDYzZpcK _26BoRw7dHp _1DCdHiLl21 _1wydGWFQfX _39HuIbz8Lp _1ANEUSLRg7 _2plNSKmnOE _1GZd6Uy7kJ"
        ])
    }, emoji.shortName)));
};
const $5103a64cbf38c21b$var$previewImageNext = null;
const $5103a64cbf38c21b$var$EmojiPreviewComponentNext = ({ emoji: emoji })=>/*#__PURE__*/ $cozmU.createElement((0, $6LE4D.PickerItemContent), {
        avatar: /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                "_3iDTPbvbI6 _39xV02Uofl _2yHzK9dnbC _3j6ezTdnbC _3i7n2adnbC _26yOTxdnbC _3skfARdnbC _3natBxdnbC _1FPnnJdnbC _1vJRcjdnbC _0mzAWiUofl _0LOdDvUofl _430i96Uofl _03qA4iUofl _27LRgcOLYo _4tayJvOLYo _3LOhKmdnbC _3M4DpidnbC _2smhYldnbC _42LJStdnbC _43vhjeRAKS _4snuQ5715P _3vDJ5g715P _0ywjPhx5FZ _40IPznUofl _3jqVQ5Uofl _0vcmbtvLZJ",
                "_3iDTPbQ4SZ"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $jLKkm.default), {
            key: emoji.id || emoji.shortName,
            emoji: emoji
        })),
        title: emoji.name ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7 _09eJsYAv7U"
            ])
        }, emoji.name) : emoji.shortName,
        subtext: emoji.name ? emoji.shortName : undefined
    });
const $5103a64cbf38c21b$export$222c91bd2db2d158 = (props)=>(0, $4o0zT.isExperimentEnabled)('platform_editor_mentions_email_search') ? /*#__PURE__*/ $cozmU.createElement($5103a64cbf38c21b$var$EmojiPreviewComponentNext, props) : /*#__PURE__*/ $cozmU.createElement($5103a64cbf38c21b$var$EmojiPreviewComponentLegacy, props);
module.exports["EmojiPreviewComponent"] = $5103a64cbf38c21b$export$222c91bd2db2d158;

});

parcelRegister("6LE4D", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");

const $59b6cb7188eaf4ea$export$8d8335496490a5f = 50;
const $59b6cb7188eaf4ea$var$styles = {
    row: "_4bt5LAnQyn _2WAcuGnQyn _2sNsIgmnOE _3iDTPbQ4SZ _0hPCNLDIqT _24h04i2Njc _3TGfC9HnLE _0jFU0VN91d _39xV02N91d _0Of8r2gVvo _1wydGWgVvo _2Zuz6Q8HPE _1Znuxb8HPE",
    avatar: "_3iDTPbQ4SZ _3YEZNOdnbC",
    text: "_3iDTPbQ4SZ _0aFT5vbt8w _42d1HAFQfX _2O5Vij7dHp _3YEZNO7dHp _1bHrqEdnbC _4ouGXIdnbC _2XsHFM8HPE",
    label: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7",
    subtext: "_2sNsIg7NXe _1UtDYzZpcK",
    muted: "_1YKVNsXvJ3"
};
const $59b6cb7188eaf4ea$export$2ff6ac96122e8aa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { avatar: avatar, title: title, subtext: subtext, after: after, isMuted: t1 } = t0;
    const isMuted = t1 === undefined ? false : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $59b6cb7188eaf4ea$var$styles.row
        ]);
        $[0] = t2;
    } else t2 = $[0];
    const t3 = isMuted && $59b6cb7188eaf4ea$var$styles.muted;
    let t4;
    if ($[1] !== t3) {
        t4 = (0, $hekY6.default)([
            $59b6cb7188eaf4ea$var$styles.avatar,
            t3
        ]);
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== avatar || $[4] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t4,
            children: avatar
        });
        $[3] = avatar;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const t6 = isMuted && $59b6cb7188eaf4ea$var$styles.muted;
    let t7;
    if ($[6] !== t6) {
        t7 = (0, $hekY6.default)([
            $59b6cb7188eaf4ea$var$styles.text,
            t6
        ]);
        $[6] = t6;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== title) {
        t8 = typeof title === "string" ? title && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                $59b6cb7188eaf4ea$var$styles.label
            ]),
            children: title
        }) : title;
        $[8] = title;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== subtext) {
        t9 = subtext && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                $59b6cb7188eaf4ea$var$styles.label,
                $59b6cb7188eaf4ea$var$styles.subtext
            ]),
            children: subtext
        });
        $[10] = subtext;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t7 || $[13] !== t8 || $[14] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t7,
            children: [
                t8,
                t9
            ]
        });
        $[12] = t7;
        $[13] = t8;
        $[14] = t9;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== after || $[17] !== t10 || $[18] !== t5) {
        t11 = /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
            className: t2,
            children: [
                t5,
                t10,
                after
            ]
        });
        $[16] = after;
        $[17] = t10;
        $[18] = t5;
        $[19] = t11;
    } else t11 = $[19];
    return t11;
} : ({ avatar: avatar, title: title, subtext: subtext, after: after, isMuted: isMuted = false })=>/*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
        className: (0, $hekY6.default)([
            $59b6cb7188eaf4ea$var$styles.row
        ]),
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                className: (0, $hekY6.default)([
                    $59b6cb7188eaf4ea$var$styles.avatar,
                    isMuted && $59b6cb7188eaf4ea$var$styles.muted
                ]),
                children: avatar
            }),
            /*#__PURE__*/ (0, $8aG6j.jsxs)("div", {
                className: (0, $hekY6.default)([
                    $59b6cb7188eaf4ea$var$styles.text,
                    isMuted && $59b6cb7188eaf4ea$var$styles.muted
                ]),
                children: [
                    typeof title === 'string' ? title && /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                        className: (0, $hekY6.default)([
                            $59b6cb7188eaf4ea$var$styles.label
                        ]),
                        children: title
                    }) : title,
                    subtext && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                        className: (0, $hekY6.default)([
                            $59b6cb7188eaf4ea$var$styles.label,
                            $59b6cb7188eaf4ea$var$styles.subtext
                        ]),
                        children: subtext
                    })
                ]
            }),
            after
        ]
    });
module.exports["PICKER_ITEM_HEIGHT"] = $59b6cb7188eaf4ea$export$8d8335496490a5f;
module.exports["PickerItemContent"] = $59b6cb7188eaf4ea$export$2ff6ac96122e8aa0;

});

parcelRegister("9ivsj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $dX6FL = parcelRequire("dX6FL");


var $jlWUB = parcelRequire("jlWUB");

const $68c74ae30c005fed$export$c537e63161742ce3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
            const mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
            const onChange = (event)=>setPrefersReducedMotion(event.matches);
            return (0, $cbY7C.bind)(mediaQueryList, {
                type: "change",
                listener: onChange
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    return prefersReducedMotion;
} : ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $cozmU.useState)((0, $jlWUB.isReducedMotion));
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $dX6FL.isMatchMediaAvailable)()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cbY7C.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
module.exports["useIsReducedMotion"] = $68c74ae30c005fed$export$c537e63161742ce3;

});

parcelRegister("lkYE1", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");

//      
var $f88a81f3886ec3a5$var$charCodeOfDot = ".".charCodeAt(0);
var $f88a81f3886ec3a5$var$reEscapeChar = /\\(\\)?/g;
var $f88a81f3886ec3a5$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f88a81f3886ec3a5$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f88a81f3886ec3a5$var$charCodeOfDot) result.push("");
    string.replace($f88a81f3886ec3a5$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f88a81f3886ec3a5$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f88a81f3886ec3a5$var$keysCache = {};
var $f88a81f3886ec3a5$var$keysRegex = /[.[\]]+/;
var $f88a81f3886ec3a5$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f88a81f3886ec3a5$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f88a81f3886ec3a5$var$keysCache[key] = key.split($f88a81f3886ec3a5$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f88a81f3886ec3a5$var$keysCache[key] = $f88a81f3886ec3a5$var$stringToPath(key);
    }
    return $f88a81f3886ec3a5$var$keysCache[key];
};
//      
var $f88a81f3886ec3a5$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f88a81f3886ec3a5$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f88a81f3886ec3a5$var$_toPropertyKey(arg) {
    var key = $f88a81f3886ec3a5$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f88a81f3886ec3a5$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f88a81f3886ec3a5$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $1eVGO.default)(current, [
                key
            ].map($f88a81f3886ec3a5$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $eb3ax.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f88a81f3886ec3a5$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f88a81f3886ec3a5$var$setInRecursor(state, 0, $f88a81f3886ec3a5$var$toPath(key), value1, destroyArrays);
};
var $f88a81f3886ec3a5$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f88a81f3886ec3a5$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f88a81f3886ec3a5$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(values, name);
    var error = $f88a81f3886ec3a5$export$c52e5867d5879e24(errors, name);
    if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) error = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f88a81f3886ec3a5$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f88a81f3886ec3a5$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f88a81f3886ec3a5$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f88a81f3886ec3a5$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f88a81f3886ec3a5$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f88a81f3886ec3a5$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f88a81f3886ec3a5$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$41e855cb628c1b55, $f88a81f3886ec3a5$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f88a81f3886ec3a5$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f88a81f3886ec3a5$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f88a81f3886ec3a5$var$subscriptionFilter(result, state, previousState, subscription, $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3, $f88a81f3886ec3a5$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f88a81f3886ec3a5$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f88a81f3886ec3a5$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f88a81f3886ec3a5$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f88a81f3886ec3a5$export$83d89fbfd8236492 = "4.20.10";
var $f88a81f3886ec3a5$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f88a81f3886ec3a5$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f88a81f3886ec3a5$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f88a81f3886ec3a5$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f88a81f3886ec3a5$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f88a81f3886ec3a5$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f88a81f3886ec3a5$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f88a81f3886ec3a5$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f88a81f3886ec3a5$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $eb3ax.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $eb3ax.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $eb3ax.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $eb3ax.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $eb3ax.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f88a81f3886ec3a5$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f88a81f3886ec3a5$export$e6bdf135a54e021b,
                    shallowEqual: $f88a81f3886ec3a5$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $eb3ax.default)({}, state.formState.values)); // clone to avoid writing
            if ($f88a81f3886ec3a5$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f88a81f3886ec3a5$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f88a81f3886ec3a5$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $eb3ax.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f88a81f3886ec3a5$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f88a81f3886ec3a5$export$735bebc8ffabf28a]) {
                    var existing = $f88a81f3886ec3a5$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f88a81f3886ec3a5$export$735bebc8ffabf28a] = error[$f88a81f3886ec3a5$export$735bebc8ffabf28a];
                    merged = $f88a81f3886ec3a5$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f88a81f3886ec3a5$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f88a81f3886ec3a5$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f88a81f3886ec3a5$var$notify(fieldSubscriber, fieldState, lastFieldState, $f88a81f3886ec3a5$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f88a81f3886ec3a5$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $eb3ax.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f88a81f3886ec3a5$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f88a81f3886ec3a5$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f88a81f3886ec3a5$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f88a81f3886ec3a5$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f88a81f3886ec3a5$var$notify(state.subscribers, nextFormState, lastFormState, $f88a81f3886ec3a5$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $eb3ax.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $eb3ax.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key), $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f88a81f3886ec3a5$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f88a81f3886ec3a5$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f88a81f3886ec3a5$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.values, name) === $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f88a81f3886ec3a5$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f88a81f3886ec3a5$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $eb3ax.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f88a81f3886ec3a5$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f88a81f3886ec3a5$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $eb3ax.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f88a81f3886ec3a5$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f88a81f3886ec3a5$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f88a81f3886ec3a5$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f88a81f3886ec3a5$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}
module.exports["getIn"] = $f88a81f3886ec3a5$export$c52e5867d5879e24;
module.exports["FORM_ERROR"] = $f88a81f3886ec3a5$export$97cd7fc25dd32915;
module.exports["fieldSubscriptionItems"] = $f88a81f3886ec3a5$export$41e855cb628c1b55;
module.exports["formSubscriptionItems"] = $f88a81f3886ec3a5$export$f1ff97b9d1c7a3c3;
module.exports["version"] = $f88a81f3886ec3a5$export$83d89fbfd8236492;
module.exports["createForm"] = $f88a81f3886ec3a5$export$f681a8129d2e9d28;

});

parcelRegister("19ZlF", function(module, exports) {

var $lkYE1 = parcelRequire("lkYE1");

//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $0d863840e9077425$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $0d863840e9077425$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $0d863840e9077425$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lkYE1.getIn)(errors, input.name);
    });
};
//      
var $0d863840e9077425$var$noop = function noop() {};
var $0d863840e9077425$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $0d863840e9077425$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $0d863840e9077425$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $0d863840e9077425$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $0d863840e9077425$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($0d863840e9077425$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$0d863840e9077425$export$2e2bcd8739ae039 = $0d863840e9077425$var$createDecorator;
module.exports["default"] = $0d863840e9077425$export$2e2bcd8739ae039;

});

parcelRegister("lSFbL", function(module, exports) {

var $2itBe = parcelRequire("2itBe");

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $fede975c1f302c4c$var$set(object, path, value) {
    return object == null ? object : $2itBe(object, path, value);
}
module.exports = $fede975c1f302c4c$var$set;

});

parcelRegister("4Qc44", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5936b606760a760$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $e5936b606760a760$export$2e2bcd8739ae039 = (0, $cozmU.forwardRef);

});

parcelRegister("2uDbg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $lmzCg = parcelRequire("lmzCg");


var $8c6io = parcelRequire("8c6io");


var $2hGAN = parcelRequire("2hGAN");


var $cAK2R = parcelRequire("cAK2R");


var $kbRVk = parcelRequire("kbRVk");

const $5e9458ef4430c05f$var$checkboxStyles = {
    root: "_30huDKYbGa _1xC2CJsLaB _2xIroY98eZ _497WNwYbGa _2zndICT6kp _39xV02N91d _0jFU0VN91d _034jHtYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _1YKVNsdnbC"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $5e9458ef4430c05f$export$48513f6b9f8ce62d = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Checkbox(t0, ref) {
    const $ = (0, $bDgLe.c)(59);
    let analyticsContext;
    let className;
    let isCheckedProp;
    let isRequired;
    let label;
    let name;
    let onChangeProps;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let testId;
    let value;
    let xcss;
    if ($[0] !== t0) {
        ({ isChecked: isCheckedProp, isDisabled: t1, isInvalid: t2, defaultChecked: t3, isIndeterminate: t4, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = className;
        $[3] = isCheckedProp;
        $[4] = isRequired;
        $[5] = label;
        $[6] = name;
        $[7] = onChangeProps;
        $[8] = rest;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = testId;
        $[14] = value;
        $[15] = xcss;
    } else {
        analyticsContext = $[1];
        className = $[2];
        isCheckedProp = $[3];
        isRequired = $[4];
        label = $[5];
        name = $[6];
        onChangeProps = $[7];
        rest = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        testId = $[13];
        value = $[14];
        xcss = $[15];
    }
    const isDisabled = t1 === undefined ? false : t1;
    const isInvalid = t2 === undefined ? false : t2;
    const defaultChecked = t3 === undefined ? false : t3;
    const isIndeterminate = t4 === undefined ? false : t4;
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    let t5;
    if ($[16] !== onChangeProps) {
        t5 = (e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        };
        $[16] = onChangeProps;
        $[17] = t5;
    } else t5 = $[17];
    const onChange = t5;
    let t6;
    if ($[18] !== analyticsContext || $[19] !== onChange) {
        t6 = {
            fn: onChange,
            action: "changed",
            analyticsData: analyticsContext,
            componentName: "checkbox",
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        };
        $[18] = analyticsContext;
        $[19] = onChange;
        $[20] = t6;
    } else t6 = $[20];
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t6);
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]);
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    let t7;
    if ($[21] !== internalRef || $[22] !== isIndeterminate) {
        t7 = ()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        };
        $[21] = internalRef;
        $[22] = isIndeterminate;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== isIndeterminate) {
        t8 = [
            isIndeterminate
        ];
        $[24] = isIndeterminate;
        $[25] = t8;
    } else t8 = $[25];
    (0, $cozmU.useEffect)(t7, t8);
    const t9 = label;
    const t10 = rest.id ? `${rest.id}-label` : undefined;
    const t11 = testId && `${testId}--checkbox-label`;
    let t12;
    if ($[26] !== className) {
        t12 = (0, $hekY6.default)([
            $5e9458ef4430c05f$var$checkboxStyles.root,
            className
        ]);
        $[26] = className;
        $[27] = t12;
    } else t12 = $[27];
    const t13 = isInvalid ? "true" : undefined;
    const t14 = testId && `${testId}--hidden-checkbox`;
    const t15 = isInvalid ? "true" : undefined;
    let t16;
    if ($[28] !== isChecked || $[29] !== isDisabled || $[30] !== isRequired || $[31] !== mergedRefs || $[32] !== name || $[33] !== onChangeAnalytics || $[34] !== rest || $[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== value) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            className: t12,
            onChange: onChangeAnalytics,
            "aria-invalid": t13,
            "data-testid": t14,
            "data-invalid": t15
        });
        $[28] = isChecked;
        $[29] = isDisabled;
        $[30] = isRequired;
        $[31] = mergedRefs;
        $[32] = name;
        $[33] = onChangeAnalytics;
        $[34] = rest;
        $[35] = t12;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = value;
        $[40] = t16;
    } else t16 = $[40];
    let t17;
    if ($[41] !== isChecked || $[42] !== isIndeterminate) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        });
        $[41] = isChecked;
        $[42] = isIndeterminate;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== isRequired || $[45] !== label) {
        t18 = label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
            children: [
                label,
                isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
            ]
        });
        $[44] = isRequired;
        $[45] = label;
        $[46] = t18;
    } else t18 = $[46];
    let t19;
    if ($[47] !== isChecked || $[48] !== isDisabled || $[49] !== isIndeterminate || $[50] !== isInvalid || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== t17 || $[55] !== t18 || $[56] !== t9 || $[57] !== xcss) {
        t19 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
            isDisabled: isDisabled,
            isChecked: isChecked,
            isIndeterminate: isIndeterminate,
            isInvalid: isInvalid,
            label: t9,
            id: t10,
            testId: t11,
            xcss: xcss,
            children: [
                t16,
                t17,
                t18
            ]
        });
        $[47] = isChecked;
        $[48] = isDisabled;
        $[49] = isIndeterminate;
        $[50] = isInvalid;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = t17;
        $[55] = t18;
        $[56] = t9;
        $[57] = xcss;
        $[58] = t19;
    } else t19 = $[58];
    return t19;
} : function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $cozmU.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $cozmU.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $cozmU.useRef)(null);
    const mergedRefs = (0, $lmzCg.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $cozmU.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $2hGAN.default), {
        isDisabled: isDisabled,
        isChecked: isChecked,
        isIndeterminate: isIndeterminate,
        isInvalid: isInvalid,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $hekY6.default)([
                    $5e9458ef4430c05f$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8c6io.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cAK2R.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kbRVk.default), {})
                ]
            })
        ]
    });
}));
$5e9458ef4430c05f$export$48513f6b9f8ce62d.displayName = 'Checkbox'; // keep the default export for backwards compatibility
var $5e9458ef4430c05f$export$2e2bcd8739ae039 = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["Checkbox"] = $5e9458ef4430c05f$export$48513f6b9f8ce62d;
module.exports["default"] = $5e9458ef4430c05f$export$2e2bcd8739ae039;

});

parcelRegister("8c6io", function(module, exports) {
/* checkbox-icon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");

const $ef6550583d45a5c6$var$svgStyles = {
    root: "_1xC2CJsLaB _4bt5LAnQyn _2WAcuGnQyn _23rrnHXVX0 _0bjKvDKxmn _32BiAhDfsT _1pp6NdYbGa _1UtDYzQPq5 _1rdFvh1XeA _3e6OgrLl21",
    rect: "_23rrnHFqy6 _4gxJYwNvrM _4e1TYvUkr1"
}; // Cross-fade colors and glyphs without moving the input or focus outline.
// Semantic tokens keep SVG colors, borders and indicators aligned with input motion.
// Preserve non-spatial transitions for reduced motion, per the LDR:
// https://hello.atlassian.net/wiki/spaces/DST/pages/7402790985
const $ef6550583d45a5c6$var$motionStyles = {
    root: "_23rrnHnc7r",
    selected: "_1YKVNs7dHp",
    glyph: "_23rrnHnc7r _1YKVNsdnbC _3wrwGmYbGa",
    border: "_23rrnHnc7r"
};
function $ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked, motionState) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
        fill: "inherit",
        className: (0, $hekY6.default)([
            motionState && $ef6550583d45a5c6$var$motionStyles.glyph,
            motionState === 'visible' && $ef6550583d45a5c6$var$motionStyles.selected
        ])
    });
    if (isChecked) return /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
        fill: "inherit",
        className: (0, $hekY6.default)([
            motionState && $ef6550583d45a5c6$var$motionStyles.glyph,
            motionState === 'visible' && $ef6550583d45a5c6$var$motionStyles.selected
        ])
    });
     // No icon
    return null;
}
const $ef6550583d45a5c6$var$CheckboxIcon = /*#__PURE__*/ (0, $cozmU.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const hasMotion = (0, $iDrrr.fg)('platform_design_system_selection_radial_fade');
    const icon = (0, $cozmU.useMemo)(()=>$ef6550583d45a5c6$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        role: "presentation",
        className: (0, $hekY6.default)([
            $ef6550583d45a5c6$var$svgStyles.root,
            hasMotion && $ef6550583d45a5c6$var$motionStyles.root
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5",
                    className: (0, $hekY6.default)([
                        $ef6550583d45a5c6$var$svgStyles.rect,
                        hasMotion && $ef6550583d45a5c6$var$motionStyles.border
                    ])
                }),
                hasMotion ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
                    children: [
                        $ef6550583d45a5c6$var$getIcon(false, true, isChecked && !isIndeterminate ? 'visible' : 'hidden'),
                        $ef6550583d45a5c6$var$getIcon(true, false, isIndeterminate ? 'visible' : 'hidden')
                    ]
                }) : icon
            ]
        })
    });
});
var $ef6550583d45a5c6$export$2e2bcd8739ae039 = $ef6550583d45a5c6$var$CheckboxIcon;
module.exports["default"] = $ef6550583d45a5c6$export$2e2bcd8739ae039;

});

parcelRegister("2hGAN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1634ca3e0554fde5$var$baseStyles = null;
const $1634ca3e0554fde5$var$textLabelLayoutStyles = null; // Checked/Indeterminate state
const $1634ca3e0554fde5$var$checkedStyles = null; // Invalid state - must override hover/active to maintain red border
const $1634ca3e0554fde5$var$invalidStyles = null; // Disabled state - must override hover/active to maintain disabled appearance
const $1634ca3e0554fde5$var$disabledStyles = null; // Disabled + Checked/Indeterminate
const $1634ca3e0554fde5$var$disabledCheckedStyles = null;
const $1634ca3e0554fde5$var$Label = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Label(t0) {
    const $ = (0, $bDgLe.c)(13);
    const { children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss } = t0;
    const t1 = label && "_2mHwu8RsfN _2iEGP2a3NQ";
    const t2 = (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4";
    const t3 = isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi";
    const t4 = isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r";
    const t5 = isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E";
    let t6;
    if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4 || $[4] !== t5 || $[5] !== xcss) {
        t6 = (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            t1,
            t2,
            t3,
            t4,
            t5,
            xcss
        ]);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
        $[3] = t4;
        $[4] = t5;
        $[5] = xcss;
        $[6] = t6;
    } else t6 = $[6];
    const t7 = isDisabled || undefined;
    let t8;
    if ($[7] !== children || $[8] !== id || $[9] !== t6 || $[10] !== t7 || $[11] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
            className: t6,
            "data-testid": testId,
            "data-disabled": t7,
            id: id,
            children: children
        });
        $[7] = children;
        $[8] = id;
        $[9] = t6;
        $[10] = t7;
        $[11] = testId;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
} : function Label({ children: children, isDisabled: isDisabled, isChecked: isChecked, isIndeterminate: isIndeterminate, isInvalid: isInvalid, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("label", {
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _3iDTPbgBM8 _3kOVpyUfmU _21ioM3BY1A _49q2va7Cj1 _0ZqVxaHKt7 _3b00HoYbGa _3jFxiYjOvk _1UtDYzy7kJ _0wOv4Q18ZR _1q8flZXzJH _4slB72qWX3 _01wY7FutHW _0R5xzg9r67 _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            label && "_2mHwu8RsfN _2iEGP2a3NQ",
            (isChecked || isIndeterminate) && "_49q2vakLmD _0ZqVxakLmD _3jFxiY6BYM _4slB72XLOx _1IEstyXLOx _01wY7FutHW _0R5xzg9r67 _2m1JOU6BYM _1ixXUak5Cz _4dUVtQTxK4 _2o2XD9TxK4",
            isInvalid && "_0ZqVxanod9 _1IEstynod9 _0R5xzgnod9 _4dUVtQBvTi",
            isDisabled && "_49q2vaVrZW _0ZqVxaVrZW _1UtDYzot27 _0wOv4Qsyl5 _4slB72VrZW _1IEstyVrZW _01wY7FVrZW _0R5xzgVrZW _1ixXUak5Cz _4dUVtQ5l5r _2o2XD95l5r",
            isDisabled && (isChecked || isIndeterminate) && "_3jFxiYoM2E _0D4MlqoM2E _2m1JOUoM2E",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
};
var $1634ca3e0554fde5$export$2e2bcd8739ae039 = $1634ca3e0554fde5$var$Label;
module.exports["default"] = $1634ca3e0554fde5$export$2e2bcd8739ae039;

});

parcelRegister("cAK2R", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $4870a5341200be20$var$labelTextStyles = null;
const $4870a5341200be20$var$LabelText = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LabelText(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t1,
            children: children
        });
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function LabelText({ children: children }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            "_1xC2CJvmHw _4xdlr0DIqT"
        ]),
        children: children
    });
};
var $4870a5341200be20$export$2e2bcd8739ae039 = $4870a5341200be20$var$LabelText;
module.exports["default"] = $4870a5341200be20$export$2e2bcd8739ae039;

});

parcelRegister("kbRVk", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $126a273b3177dba3$var$requiredIndicatorStyles = null;
const $126a273b3177dba3$var$RequiredIndicator = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RequiredIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                "_1UtDYzAyGJ _0LQT5EFQfX"
            ]),
            children: "*"
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function RequiredIndicator() {
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            "_1UtDYzAyGJ _0LQT5EFQfX"
        ]),
        children: "*"
    });
};
var $126a273b3177dba3$export$2e2bcd8739ae039 = $126a273b3177dba3$var$RequiredIndicator;
module.exports["default"] = $126a273b3177dba3$export$2e2bcd8739ae039;

});

parcelRegister("e3Wrf", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $iDrrr = parcelRequire("iDrrr");

const $f7ddda300dd34381$var$packageName = "platform-pkg";
const $f7ddda300dd34381$var$packageVersion = "0.0.0-use.local";
const $f7ddda300dd34381$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $f7ddda300dd34381$var$packageName,
    packageVersion: $f7ddda300dd34381$var$packageVersion
};
const $f7ddda300dd34381$var$lineHeightBase = 20;
const $f7ddda300dd34381$var$lineHeightCompact = 16;
const $f7ddda300dd34381$var$compactVerticalPadding = 2;
const $f7ddda300dd34381$var$verticalPadding = 6;
const $f7ddda300dd34381$var$borderWidth = 2;
const $f7ddda300dd34381$var$baseStyles = null;
const $f7ddda300dd34381$var$inputMotionStyles = {
    legacy: "_23rrnH5Vpu",
    base: "_23rrnHGIwA"
};
const $f7ddda300dd34381$var$finessePlaceholderStyles = null;
const $f7ddda300dd34381$var$appearanceStyles = {
    standard: "_3hxITi6wH8 _1mHXSFHKt7 _3OEoix7Cj1 _39nh0ghQC5 _2jpXBkVrZW _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _0tVs2sXJux _3JVwBfXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM _2UNgvCnXvL _1LO7QkVrZW",
    subtle: "_3hxITi6wH8 _1mHXSFjOvk _3OEoixjOvk _31SgFAHKt7 _2zr3nGqWX3 _3LfWyLFQfX _2vsVfZFQfX _2DQpWtXJux _0SosFGXJux _1CDq3qgVvo _2FTXAcgVvo _3JVwBfXJux _0tVs2sXJux _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _1mHXSFjOvk _3OEoixjOvk _31SgFAjOvk _2zr3nGjOvk _3LfWyLFQfX _0SosFGgVvo _2vsVfZFQfX _2DQpWtgVvo _1CDq3qgVvo _3JVwBfgVvo _2FTXAcgVvo _0tVs2sgVvo _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
};
const $f7ddda300dd34381$var$atomicBaseStyles = null;
const $f7ddda300dd34381$var$atomicAppearanceStyles = {
    standard: "_3hxITi6wH8 _3vBAKHHKt7 _0KLXru7Cj1 _094NDRhQC5 _0QAuWQVrZW _31SgFAHKt7 _2zr3nGqWX3 _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    subtle: "_3hxITi6wH8 _3vBAKHjOvk _0KLXrujOvk _31SgFAHKt7 _2zr3nGqWX3 _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
    none: "_3hxITiYbGa _3vBAKHjOvk _0KLXrujOvk _31SgFAjOvk _2zr3nGjOvk _0xkEdpjOvk _1iy5hxjOvk _0ui43Cw5zn"
};
const $f7ddda300dd34381$var$atomicInlinePaddingStyles = {
    bordered: "_0LQT5EXJux _03SyCPXJux",
    borderless: "_0LQT5EgVvo _03SyCPgVvo"
};
const $f7ddda300dd34381$var$atomicInvalidStyles = null; // iOS Safari automatically zooms into form inputs on focus when the font size is less than 16px.
// To prevent this zoom behaviour on touch devices with small viewports, the textarea uses font.body (default),
// and font.body.large (16px) for touch devices (pointer: coarse) with screens narrower than 30rem.
// @see: https://medium.com/@rares.popescu/2-ways-to-avoid-the-automatic-zoom-in-on-input-fields-8a71479e542e
const $f7ddda300dd34381$var$fontStyles = {
    default: "_2sNsIgmnOE _1gitD220Hp",
    monospace: "_2sNsIgmnOE _0WKd3Gfx9v _1gitD220Hp _3n0EfXdh5F"
}; // Density padding is selected directly from React props.
const $f7ddda300dd34381$var$atomicDensityStyles = {
    compact: "_46hvQmFQfX _0xmtkoFQfX",
    default: "_46hvQmgVvo _0xmtkogVvo"
};
const $f7ddda300dd34381$var$resizeStyles = {
    horizontal: "_2HIj7GD4qA",
    vertical: "_2HIj7GbI28",
    auto: "_2HIj7GZSoF",
    smart: "_2HIj7GYbGa",
    none: "_2HIj7GYbGa"
};
const $f7ddda300dd34381$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $f7ddda300dd34381$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $f7ddda300dd34381$var$InnerTextArea = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(69);
    const ourRef = (0, $cozmU.useRef)(null);
    let onBlur;
    let onChange;
    let onFocus;
    let rest;
    let style;
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    let t9;
    let testId;
    let value;
    if ($[0] !== props) {
        ({ resize: t0, appearance: t1, isCompact: t2, isRequired: t3, isReadOnly: t4, isDisabled: t5, isInvalid: t6, isMonospaced: t7, minimumRows: t8, testId: testId, maxHeight: t9, onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props);
        $[0] = props;
        $[1] = onBlur;
        $[2] = onChange;
        $[3] = onFocus;
        $[4] = rest;
        $[5] = style;
        $[6] = t0;
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
        $[14] = t8;
        $[15] = t9;
        $[16] = testId;
        $[17] = value;
    } else {
        onBlur = $[1];
        onChange = $[2];
        onFocus = $[3];
        rest = $[4];
        style = $[5];
        t0 = $[6];
        t1 = $[7];
        t2 = $[8];
        t3 = $[9];
        t4 = $[10];
        t5 = $[11];
        t6 = $[12];
        t7 = $[13];
        t8 = $[14];
        t9 = $[15];
        testId = $[16];
        value = $[17];
    }
    const resize = t0 === undefined ? "smart" : t0;
    const appearance = t1 === undefined ? "standard" : t1;
    const isCompact = t2 === undefined ? false : t2;
    const isRequired = t3 === undefined ? false : t3;
    const isReadOnly = t4 === undefined ? false : t4;
    const isDisabled = t5 === undefined ? false : t5;
    const isInvalid = t6 === undefined ? false : t6;
    const isMonospaced = t7 === undefined ? false : t7;
    const minimumRows = t8 === undefined ? 2 : t8;
    const maxHeight = t9 === undefined ? "50vh" : t9;
    const isInputMotionEnabled = (0, $iDrrr.fg)("platform-dst-motion-uplift-input");
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = appearance === "none" ? 2 : 1;
    let t10;
    if ($[18] !== resize) {
        t10 = ()=>{
            const el = ourRef.current;
            if (resize === "smart" && el) $f7ddda300dd34381$var$setSmartHeight(el);
        };
        $[18] = resize;
        $[19] = t10;
    } else t10 = $[19];
    let t11;
    if ($[20] !== resize || $[21] !== value) {
        t11 = [
            resize,
            value
        ];
        $[20] = resize;
        $[21] = value;
        $[22] = t11;
    } else t11 = $[22];
    (0, $cozmU.useEffect)(t10, t11);
    let t12;
    if ($[23] !== onBlur) {
        t12 = {
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: "blurred",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[23] = onBlur;
        $[24] = t12;
    } else t12 = $[24];
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t12);
    let t13;
    if ($[25] !== onFocus) {
        t13 = {
            fn: (event_0)=>{
                onFocus && onFocus(event_0);
            },
            action: "focused",
            ...$f7ddda300dd34381$var$analyticsParams
        };
        $[25] = onFocus;
        $[26] = t13;
    } else t13 = $[26];
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    let t14;
    if ($[27] !== ref) {
        t14 = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === "object") ref.current = elementRef;
            if (ref && typeof ref === "function") ref(elementRef);
        };
        $[27] = ref;
        $[28] = t14;
    } else t14 = $[28];
    const getTextAreaRef = t14;
    let t15;
    if ($[29] !== onChange || $[30] !== resize) {
        t15 = (e)=>{
            const el_0 = ourRef.current;
            if (resize === "smart" && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
            onChange && onChange(e);
        };
        $[29] = onChange;
        $[30] = resize;
        $[31] = t15;
    } else t15 = $[31];
    const handleOnChange = t15;
    const t16 = (0, $iDrrr.fg)("platform-textarea-atomic-styles") ? undefined : isInvalid || undefined;
    const t17 = (0, $iDrrr.fg)("platform-textarea-atomic-styles") ? undefined : isCompact || undefined;
    const t18 = testId ? testId : undefined;
    let t19;
    if ($[32] !== t16 || $[33] !== t17 || $[34] !== t18) {
        t19 = {
            "data-invalid": t16,
            "data-compact": t17,
            "data-testid": t18
        };
        $[32] = t16;
        $[33] = t17;
        $[34] = t18;
        $[35] = t19;
    } else t19 = $[35];
    const controlProps = t19;
    let t20;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = !(0, $iDrrr.fg)("platform-textarea-atomic-styles") && "_22P5CgPgdP _2Ombu6q5bj";
        $[36] = t20;
    } else t20 = $[36];
    const t21 = (0, $hekY6.default)([
        (0, $iDrrr.fg)("platform-textarea-atomic-styles") ? "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _2OUyjtYbGa _1UtDYzy7kJ _1T2N03wPeg _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3AxjleKGUX _3MV4MUot27" : "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
        !isInputMotionEnabled && $f7ddda300dd34381$var$inputMotionStyles.legacy,
        isInputMotionEnabled && isInteractive && $f7ddda300dd34381$var$inputMotionStyles.base,
        (0, $iDrrr.fg)("platform-dst-tokens-finesse") && "_3AxjleZpcK",
        (0, $iDrrr.fg)("platform-textarea-atomic-styles") ? $f7ddda300dd34381$var$atomicAppearanceStyles[appearance] : $f7ddda300dd34381$var$appearanceStyles[appearance],
        (0, $iDrrr.fg)("platform-textarea-atomic-styles") && $f7ddda300dd34381$var$atomicInlinePaddingStyles[appearance === "none" ? "borderless" : "bordered"],
        (0, $iDrrr.fg)("platform-textarea-atomic-styles") && isInvalid && "_3vBAKHnod9 _0KLXru7Cj1 _2OUyjtFKgL _31SgFAnod9 _2zr3nGqWX3 _4t1qm2FKgL _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
        $f7ddda300dd34381$var$fontStyles[isMonospaced ? "monospace" : "default"],
        (0, $iDrrr.fg)("platform-textarea-atomic-styles") && $f7ddda300dd34381$var$atomicDensityStyles[isCompact ? "compact" : "default"],
        $f7ddda300dd34381$var$resizeStyles[resize],
        t20
    ]);
    let t22;
    if ($[37] !== isCompact || $[38] !== style?.font) {
        t22 = (0, $iDrrr.fg)("platform-textarea-atomic-styles") && !style?.font && {
            lineHeight: isCompact ? $f7ddda300dd34381$var$lineHeightCompact / 14 : $f7ddda300dd34381$var$lineHeightBase / 14
        };
        $[37] = isCompact;
        $[38] = style?.font;
        $[39] = t22;
    } else t22 = $[39];
    let t23;
    if ($[40] !== borderHeight || $[41] !== isCompact || $[42] !== minimumRows) {
        t23 = (0, $iDrrr.fg)("platform-textarea-atomic-styles") && {
            minHeight: `${(isCompact ? $f7ddda300dd34381$var$lineHeightCompact : $f7ddda300dd34381$var$lineHeightBase) * minimumRows + (isCompact ? $f7ddda300dd34381$var$compactVerticalPadding : $f7ddda300dd34381$var$verticalPadding) * 2 + borderHeight * 2}px`
        };
        $[40] = borderHeight;
        $[41] = isCompact;
        $[42] = minimumRows;
        $[43] = t23;
    } else t23 = $[43];
    const t24 = $f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2;
    let t25;
    if ($[44] !== t24) {
        t25 = (0, $9aYkv.default)(t24, "px");
        $[44] = t24;
        $[45] = t25;
    } else t25 = $[45];
    const t26 = $f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2;
    let t27;
    if ($[46] !== t26) {
        t27 = (0, $9aYkv.default)(t26, "px");
        $[46] = t26;
        $[47] = t27;
    } else t27 = $[47];
    let t28;
    if ($[48] !== maxHeight || $[49] !== style || $[50] !== t22 || $[51] !== t23 || $[52] !== t25 || $[53] !== t27) {
        t28 = {
            ...t22,
            ...t23,
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": t25,
            "--_eorxnz": t27
        };
        $[48] = maxHeight;
        $[49] = style;
        $[50] = t22;
        $[51] = t23;
        $[52] = t25;
        $[53] = t27;
        $[54] = t28;
    } else t28 = $[54];
    let t29;
    if ($[55] !== controlProps || $[56] !== getTextAreaRef || $[57] !== handleOnChange || $[58] !== isDisabled || $[59] !== isReadOnly || $[60] !== isRequired || $[61] !== minimumRows || $[62] !== onBlurWithAnalytics || $[63] !== onFocusWithAnalytics || $[64] !== rest || $[65] !== t21 || $[66] !== t28 || $[67] !== value) {
        t29 = /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            ...rest,
            className: t21,
            style: t28
        });
        $[55] = controlProps;
        $[56] = getTextAreaRef;
        $[57] = handleOnChange;
        $[58] = isDisabled;
        $[59] = isReadOnly;
        $[60] = isRequired;
        $[61] = minimumRows;
        $[62] = onBlurWithAnalytics;
        $[63] = onFocusWithAnalytics;
        $[64] = rest;
        $[65] = t21;
        $[66] = t28;
        $[67] = value;
        $[68] = t29;
    } else t29 = $[68];
    return t29;
} : (props, ref)=>{
    const ourRef = (0, $cozmU.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const isInputMotionEnabled = (0, $iDrrr.fg)('platform-dst-motion-uplift-input');
    const isInteractive = !isDisabled && !isReadOnly;
    const borderHeight = (0, $cozmU.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $cozmU.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $f7ddda300dd34381$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event_0)=>{
            onFocus && onFocus(event_0);
        },
        action: 'focused',
        ...$f7ddda300dd34381$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $cozmU.useCallback)((e)=>{
        const el_0 = ourRef.current;
        if (resize === 'smart' && el_0) $f7ddda300dd34381$var$setSmartHeight(el_0);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': (0, $iDrrr.fg)('platform-textarea-atomic-styles') ? undefined : isInvalid || undefined,
        'data-compact': (0, $iDrrr.fg)('platform-textarea-atomic-styles') ? undefined : isCompact || undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $hekY6.default)([
            (0, $iDrrr.fg)('platform-textarea-atomic-styles') ? "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _2OUyjtYbGa _1UtDYzy7kJ _1T2N03wPeg _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3AxjleKGUX _3MV4MUot27" : "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2O5Vij7dHp _3YEZNO7dHp _1bHrqEN91d _0bjKvDKTcp _2sNsIgmnOE _2xIroY98eZ _497WNwYbGa _2zndICT6kp _4bt5LAIZbP _2WAcuGIZbP _2V7sgONvrM _3iDTPbvLZJ _24h04i2Njc _39xV02N91d _4ouGXIdnbC _1EqgXlN91d _1mT5xdRAKS _1UtDYzy7kJ _1T2N03wPeg _2IasYonod9 _03v5H87Cj1 _32yk65FKgL _24bGaTot27 _02aXbKsyl5 _0OS5PY7dHp _1kg4OzZqHV _3tCyJvYbGa _2DoaPjYbGa _3pNDujnod9 _1cY5OfqWX3 _0sBZ7MFKgL _30pU6CVrZW _3AxjleKGUX _3MV4MUot27 _1yFQeXQWvZ _3TNCtG1AUN _3OInhJnXvL _1xHRfPutHW _4skx3vPhRM",
            !isInputMotionEnabled && $f7ddda300dd34381$var$inputMotionStyles.legacy,
            isInputMotionEnabled && isInteractive && $f7ddda300dd34381$var$inputMotionStyles.base,
            (0, $iDrrr.fg)('platform-dst-tokens-finesse') && "_3AxjleZpcK",
            (0, $iDrrr.fg)('platform-textarea-atomic-styles') ? $f7ddda300dd34381$var$atomicAppearanceStyles[appearance] : $f7ddda300dd34381$var$appearanceStyles[appearance],
            (0, $iDrrr.fg)('platform-textarea-atomic-styles') && $f7ddda300dd34381$var$atomicInlinePaddingStyles[appearance === 'none' ? 'borderless' : 'bordered'],
            (0, $iDrrr.fg)('platform-textarea-atomic-styles') && isInvalid && "_3vBAKHnod9 _0KLXru7Cj1 _2OUyjtFKgL _31SgFAnod9 _2zr3nGqWX3 _4t1qm2FKgL _0xkEdpnXvL _1iy5hxutHW _0ui43CPhRM",
            $f7ddda300dd34381$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            (0, $iDrrr.fg)('platform-textarea-atomic-styles') && $f7ddda300dd34381$var$atomicDensityStyles[isCompact ? 'compact' : 'default'],
            $f7ddda300dd34381$var$resizeStyles[resize],
            !(0, $iDrrr.fg)('platform-textarea-atomic-styles') && "_22P5CgPgdP _2Ombu6q5bj"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Runtime density must override the mobile font shorthand, which sorts after atomic longhands.
            ...(0, $iDrrr.fg)('platform-textarea-atomic-styles') && !style?.font && {
                lineHeight: isCompact ? $f7ddda300dd34381$var$lineHeightCompact / 14 : $f7ddda300dd34381$var$lineHeightBase / 14
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Minimum row height is calculated from runtime props.
            ...(0, $iDrrr.fg)('platform-textarea-atomic-styles') && {
                minHeight: `${(isCompact ? $f7ddda300dd34381$var$lineHeightCompact : $f7ddda300dd34381$var$lineHeightBase) * minimumRows + (isCompact ? $f7ddda300dd34381$var$compactVerticalPadding : $f7ddda300dd34381$var$verticalPadding) * 2 + borderHeight * 2}px`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightCompact * minimumRows + $f7ddda300dd34381$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $9aYkv.default)($f7ddda300dd34381$var$lineHeightBase * minimumRows + $f7ddda300dd34381$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $f7ddda300dd34381$var$TextArea = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
            ref: ref,
            ...props
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($f7ddda300dd34381$var$InnerTextArea, {
        ref: ref,
        ...props
    })));
$f7ddda300dd34381$var$TextArea.displayName = 'TextArea';
var $f7ddda300dd34381$export$2e2bcd8739ae039 = $f7ddda300dd34381$var$TextArea;
module.exports["default"] = $f7ddda300dd34381$export$2e2bcd8739ae039;

});

parcelRegister("kLlYX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::80e1615540ac9d82a9937150e7cfa4ab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f1d93fa86ac2ebd2$var$_react = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f1d93fa86ac2ebd2$var$_iconNew = $f1d93fa86ac2ebd2$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f1d93fa86ac2ebd2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/page-live-doc
 * Usage guidance:
 * Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f1d93fa86ac2ebd2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $f1d93fa86ac2ebd2$var$_react.default.createElement($f1d93fa86ac2ebd2$var$_iconNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$f1d93fa86ac2ebd2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $f1d93fa86ac2ebd2$var$_default = module.exports.default = $f1d93fa86ac2ebd2$var$PageLiveDocIcon;

});

parcelRegister("b5sDq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7c17957e788935e20cad1a731882f109>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81265fa4dab37321$var$_react = $81265fa4dab37321$var$_interopRequireDefault((parcelRequire("cozmU")));

var $81265fa4dab37321$var$_iconNew = $81265fa4dab37321$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $81265fa4dab37321$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DiagramSymbolMindMap".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/diagram-symbol-mind-map
 * Usage guidance:
 * Reserved for mind map diagram symbol.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $81265fa4dab37321$var$DiagramSymbolMindMapIcon = (props)=>/*#__PURE__*/ $81265fa4dab37321$var$_react.default.createElement($81265fa4dab37321$var$_iconNew.default, Object.assign({
        name: "DiagramSymbolMindMapIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12 13.5h2.5v-2H12zM1.5 9H4V7H1.5zM12 4.5h2.5v-2H12zm4 .125C16 5.385 15.384 6 14.625 6h-2.75c-.76 0-1.375-.616-1.375-1.375V4.25h-1a.5.5 0 0 0-.5.5v6.5a.5.5 0 0 0 .5.5h1v-.375c0-.76.616-1.375 1.375-1.375h2.75c.76 0 1.375.616 1.375 1.375v2.25c0 .76-.616 1.375-1.375 1.375h-2.75c-.76 0-1.375-.616-1.375-1.375v-.375h-1a2 2 0 0 1-2-2v-2.5h-2v.375c0 .76-.616 1.375-1.375 1.375h-2.75C.615 10.5 0 9.884 0 9.125v-2.25C0 6.115.616 5.5 1.375 5.5h2.75c.76 0 1.375.616 1.375 1.375v.375h2v-2.5a2 2 0 0 1 2-2h1v-.375c0-.76.616-1.375 1.375-1.375h2.75l.14.007c.694.07 1.235.656 1.235 1.368z"/>`
    }, props));
$81265fa4dab37321$var$DiagramSymbolMindMapIcon.displayName = 'DiagramSymbolMindMapIcon';
var $81265fa4dab37321$var$_default = module.exports.default = $81265fa4dab37321$var$DiagramSymbolMindMapIcon;

});

parcelRegister("1LXnB", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $69NJe = parcelRequire("69NJe");

const $12a75cc47e499450$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props.offscreen || $[1] !== props.setWidth) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
            setWidth: props.setWidth,
            offscreen: props.offscreen
        });
        $[0] = props.offscreen;
        $[1] = props.setWidth;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $69NJe.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
module.exports["WidthObserver"] = $12a75cc47e499450$export$b2ad68b9bc407b80;

});

parcelRegister("69NJe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1zgpZ = parcelRequire("1zgpZ");

const $00e8152189e344b1$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { setWidth: setWidth, offscreen: offscreen } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            threshold: 0
        };
        $[0] = t1;
    } else t1 = $[0];
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)(t1);
    let t2;
    if ($[1] !== setWidth) {
        t2 = ()=>{
            if (typeof window === "undefined") return null;
            return new ResizeObserver((entries)=>{
                if (!Array.isArray(entries) || !entries.length) return;
                const { width: width } = entries[0].contentRect;
                setWidth(Math.round(width));
            });
        };
        $[1] = setWidth;
        $[2] = t2;
    } else t2 = $[2];
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(t2);
    let t3;
    let t4;
    if ($[3] !== inView || $[4] !== offscreen || $[5] !== target) {
        t3 = ()=>{
            const { current: currentObserver } = observer;
            const resizeObserver = currentObserver();
            if (resizeObserver === null) return;
            if (target) {
                if (inView || offscreen) resizeObserver.observe(target);
                else resizeObserver.unobserve(target);
            }
            return ()=>{
                resizeObserver.disconnect();
            };
        };
        t4 = [
            target,
            inView,
            offscreen
        ];
        $[3] = inView;
        $[4] = offscreen;
        $[5] = target;
        $[6] = t3;
        $[7] = t4;
    } else {
        t3 = $[6];
        t4 = $[7];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t3, t4);
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            display: "block",
            width: "100%",
            position: "absolute"
        };
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== inViewRef) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            style: t5,
            ref: inViewRef
        });
        $[9] = inViewRef;
        $[10] = t6;
    } else t6 = $[10];
    return t6;
} : ({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $1zgpZ.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});
module.exports["WidthDetectorObserver"] = $00e8152189e344b1$export$ff983d2a2b6112ea;

});

parcelRegister("1zgpZ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $cbd0258ef583969a$export$2f62ee6831462844 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useInView(t0) {
    const $ = (0, $bDgLe.c)(14);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const options = t1;
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            inView: false,
            entry: undefined,
            target: undefined
        };
        $[2] = t2;
    } else t2 = $[2];
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(t2);
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    let t3;
    if ($[3] !== root || $[4] !== rootMargin || $[5] !== threshold) {
        t3 = (node)=>{
            observerInstance.current = new IntersectionObserver((entries)=>{
                if (entries && entries.length) {
                    const intersection = entries[0];
                    const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                    if (intersectionRatio >= 0) {
                        const numericThreshold = typeof threshold === "number" ? threshold : 0;
                        let inView = intersectionRatio >= numericThreshold;
                        if (isIntersecting !== undefined) inView = inView && isIntersecting;
                        setState({
                            inView: inView,
                            entry: intersection,
                            target: node
                        });
                    }
                }
            }, {
                threshold: threshold,
                root: root,
                rootMargin: rootMargin
            });
            if (ref.current) observerInstance.current.unobserve(ref.current);
            if (node) observerInstance.current.observe(node);
            ref.current = node;
        };
        $[3] = root;
        $[4] = rootMargin;
        $[5] = threshold;
        $[6] = t3;
    } else t3 = $[6];
    const setRef = t3;
    let t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>()=>{
                if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
            };
        t5 = [];
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t4, t5);
    let t6;
    if ($[9] !== setRef || $[10] !== state.entry || $[11] !== state.inView || $[12] !== state.target) {
        t6 = [
            setRef,
            state.inView,
            state.target,
            state.entry
        ];
        $[9] = setRef;
        $[10] = state.entry;
        $[11] = state.inView;
        $[12] = state.target;
        $[13] = t6;
    } else t6 = $[13];
    return t6;
} : function useInView(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
};
module.exports["useInView"] = $cbd0258ef583969a$export$2f62ee6831462844;

});

parcelRegister("mr7nI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0437174526e2cd74$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0437174526e2cd74$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $3yGK6.default)(2, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var dateToCompare = (0, $dkBOe.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("fhdGv", function(module, exports) {
/* Status.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lzgC6 = parcelRequire("lzgC6");


var $aCJyI = parcelRequire("aCJyI");


var $ftY7H = parcelRequire("ftY7H");


var $jDboD = parcelRequire("jDboD");


var $fB42n = parcelRequire("fB42n");

function $ba35a2a9fe36df5b$var$_defineProperty(e, r, t) {
    return (r = $ba35a2a9fe36df5b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $ba35a2a9fe36df5b$var$_toPropertyKey(t) {
    var i = $ba35a2a9fe36df5b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $ba35a2a9fe36df5b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $ba35a2a9fe36df5b$var$MAX_WIDTH = 200; /**
                        * This is to account for a bug in android chromium and should be removed
                        * when the editor fixes its focus handling with respect to Status.
                        *
                        * See DSP-7701 for additional context.
                        */ 
const $ba35a2a9fe36df5b$var$inlineBlockStyles = null; // Bound the Lozenge to its parent while keeping short statuses content-sized.
const $ba35a2a9fe36df5b$var$constrainedToParentStyles = null; // eg. Version/4.0 Chrome/95.0.4638.50
const $ba35a2a9fe36df5b$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/.test(window.navigator.userAgent);
class $ba35a2a9fe36df5b$var$StatusInternal extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    render() {
        const { text: text, color: color, style: style, role: role, onClick: onClick, isBold: isBold, isConstrainedToParent: isConstrainedToParent } = this.props;
        if (text.trim().length === 0) return null;
        const appearance = (0, $fB42n.getLozengeAppearance)(color); // Note: ommitted data-local-id attribute to avoid copying/pasting the same localId
        return /*#__PURE__*/ $cozmU.createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: (0, $hekY6.default)([
                $ba35a2a9fe36df5b$var$isAndroidChromium && "_0ReY56US2K _3HdVfPey7F _3pS3pEt2nV",
                isConstrainedToParent && "_3iDTPbvbI6 _1EqgXlN91d",
                "status-lozenge-span"
            ]),
            onClick: onClick,
            onKeyDown: onClick ? this.handleKeyDown : undefined,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            tabIndex: onClick ? -1 : undefined,
            "data-node-type": "status",
            "data-color": (0, $fB42n.normalizeColor)(color),
            "data-style": style,
            role: role
        }, /*#__PURE__*/ $cozmU.createElement((0, $aCJyI.default), {
            appearance: appearance,
            maxWidth: $ba35a2a9fe36df5b$var$MAX_WIDTH,
            isBold: isBold
        }, text));
    }
    constructor(...args){
        super(...args);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "hoverStartTime", 0);
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseEnter", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleMouseLeave", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleKeyDown", (e)=>{
            const { onClick: onClick } = this.props;
            if (onClick && (e.key === 'Enter' || e.key === ' ')) {
                e.preventDefault();
                onClick(e);
            }
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleFocus", (_e)=>{
            this.hoverStartTime = Date.now();
        });
        $ba35a2a9fe36df5b$var$_defineProperty(this, "handleBlur", (_e)=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $jDboD.ANALYTICS_HOVER_DELAY) && onHover) onHover();
            this.hoverStartTime = 0;
        });
    }
}
$ba35a2a9fe36df5b$var$_defineProperty($ba35a2a9fe36df5b$var$StatusInternal, "displayName", 'StatusInternal');
const $ba35a2a9fe36df5b$export$96e9906d6d93a972 = (0, $lzgC6.default)({
    onClick: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'clicked',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    },
    onHover: (createEvent, props)=>{
        const { localId: localId } = props;
        return (0, $ftY7H.createStatusAnalyticsAndFire)(createEvent)({
            action: 'hovered',
            actionSubject: 'statusLozenge',
            attributes: {
                localId: localId
            }
        });
    }
})($ba35a2a9fe36df5b$var$StatusInternal);
module.exports["Status"] = $ba35a2a9fe36df5b$export$96e9906d6d93a972;

});

parcelRegister("ftY7H", function(module, exports) {
const $63d299faa378dc1a$export$d821aa4c8afb384e = 'fabric-elements';
const $63d299faa378dc1a$var$packageName = "platform-pkg";
const $63d299faa378dc1a$var$packageVersion = "0.0.0-use.local";
const $63d299faa378dc1a$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        const statusPayload = {
            ...payload,
            eventType: 'ui'
        };
        if (!statusPayload.attributes) statusPayload.attributes = {};
        statusPayload.attributes.packageName = $63d299faa378dc1a$var$packageName;
        statusPayload.attributes.packageVersion = $63d299faa378dc1a$var$packageVersion;
        statusPayload.attributes.componentName = 'status';
        const event = createAnalyticsEvent(statusPayload);
        event.fire($63d299faa378dc1a$export$d821aa4c8afb384e);
        return event;
    };
module.exports["createStatusAnalyticsAndFire"] = $63d299faa378dc1a$export$aa98853957f9f5aa;

});

parcelRegister("jDboD", function(module, exports) {
const $92130f7ce8b5e3de$export$7452d7062a4d0634 = 1000;
module.exports["ANALYTICS_HOVER_DELAY"] = $92130f7ce8b5e3de$export$7452d7062a4d0634;

});

parcelRegister("fB42n", function(module, exports) {

var $2pQiO = parcelRequire("2pQiO");

const $7f74d498381e9123$export$c6adb6b4e776f0d5 = [
    'neutral',
    'purple',
    'blue',
    'red',
    'yellow',
    'green'
];
const $7f74d498381e9123$export$ccac7cd631a2cc0f = [
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime — named `green` renders identically
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange — named `yellow` renders identically
    '#FDD0EC' // Magenta
];
const $7f74d498381e9123$export$acfdfc8c64e6747 = 'neutral';
const $7f74d498381e9123$export$645e10b5a408e986 = {
    neutral: 'neutral',
    purple: 'discovery',
    blue: 'information',
    red: 'danger',
    yellow: 'warning',
    green: 'success'
};
const $7f74d498381e9123$export$692279d423b4caab = "var(--ds-icon, #292A2E)";
const $7f74d498381e9123$export$56d196d2844d1ca1 = {
    neutral: {
        appearance: 'neutral',
        labelKey: 'neutralColor',
        swatch: {
            backgroundColor: "var(--ds-background-neutral, #0515240F)",
            borderColor: "var(--ds-border, #0B120E24)"
        }
    },
    blue: {
        appearance: 'accent-blue',
        labelKey: 'blueColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
            borderColor: "var(--ds-border-accent-blue-subtle, #8FB8F6)"
        }
    },
    '#B3F5FF': {
        appearance: 'accent-teal',
        labelKey: 'tealColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
            borderColor: "var(--ds-border-accent-teal-subtle, #9DD9EE)"
        }
    },
    '#ABF5D1': {
        appearance: 'accent-green',
        labelKey: 'greenColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
            borderColor: "var(--ds-border-accent-green-subtle, #7EE2B8)"
        }
    },
    '#D3F1A7': {
        appearance: 'accent-lime',
        labelKey: 'limeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
            borderColor: "var(--ds-border-accent-lime-subtle, #B3DF72)"
        }
    },
    '#FFF0B3': {
        appearance: 'accent-yellow',
        labelKey: 'yellowColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
            borderColor: "var(--ds-border-accent-yellow-subtle, #EED12B)"
        }
    },
    '#FCE4A6': {
        appearance: 'accent-orange',
        labelKey: 'orangeColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
            borderColor: "var(--ds-border-accent-orange-subtle, #FBC828)"
        }
    },
    red: {
        appearance: 'accent-red',
        labelKey: 'redColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
            borderColor: "var(--ds-border-accent-red-subtle, #FD9891)"
        }
    },
    '#FDD0EC': {
        appearance: 'accent-magenta',
        labelKey: 'magentaColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
            borderColor: "var(--ds-border-accent-magenta-subtle, #F797D2)"
        }
    },
    purple: {
        appearance: 'accent-purple',
        labelKey: 'purpleColor',
        swatch: {
            backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
            borderColor: "var(--ds-border-accent-purple-subtle, #D8A0F7)"
        }
    },
    yellow: {
        appearance: 'accent-orange',
        labelKey: 'yellowColor'
    },
    green: {
        appearance: 'accent-lime',
        labelKey: 'greenColor'
    }
};
const $7f74d498381e9123$export$d42d7c94d7629c23 = [
    'neutral',
    // Gray
    'blue',
    // Blue
    '#B3F5FF',
    // Teal
    '#ABF5D1',
    // Green
    '#D3F1A7',
    // Lime
    '#FFF0B3',
    // Yellow
    '#FCE4A6',
    // Orange
    'red',
    // Red
    '#FDD0EC',
    // Magenta
    'purple' // Purple
];
const $7f74d498381e9123$export$ee5a21461d1db57c = (color)=>$7f74d498381e9123$export$c6adb6b4e776f0d5.includes(color);
const $7f74d498381e9123$export$4cde5df63f53f473 = (color)=>color.startsWith('#') ? color.toUpperCase() : color;
const $7f74d498381e9123$var$specFor = (color)=>$7f74d498381e9123$export$56d196d2844d1ca1[$7f74d498381e9123$export$4cde5df63f53f473(color)];
const $7f74d498381e9123$export$4bc90a066e1dabc3 = (color)=>$7f74d498381e9123$var$specFor(color)?.labelKey ?? 'neutralColor';
const $7f74d498381e9123$export$13752f03fbf881b8 = (swatchValue, selectedColor)=>{
    if (!selectedColor) return false;
    if ($7f74d498381e9123$export$4cde5df63f53f473(swatchValue) === $7f74d498381e9123$export$4cde5df63f53f473(selectedColor)) return true;
    // A swatch also counts as selected when it renders the same hue under a different
    // id — legacy named `green`/`yellow` share the Lime/Orange swatches. Unknown values
    // have no spec, so they never collide on the neutral fallback.
    const swatchAppearance = $7f74d498381e9123$var$specFor(swatchValue)?.appearance;
    return swatchAppearance !== undefined && swatchAppearance === $7f74d498381e9123$var$specFor(selectedColor)?.appearance;
};
const $7f74d498381e9123$export$4d9e331cafeacb9d = (color)=>{
    const isUpdateStatusColorsEnabled = (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false) || (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_update_status_colors_jira', 'isEnabled', false);
    // Named colours are recoloured only by the experiment, so they must never reach the
    // hex mapping below.
    if ($7f74d498381e9123$export$ee5a21461d1db57c(color)) return isUpdateStatusColorsEnabled ? $7f74d498381e9123$export$56d196d2844d1ca1[color].appearance : $7f74d498381e9123$export$645e10b5a408e986[color];
    return $7f74d498381e9123$var$specFor(color)?.appearance ?? $7f74d498381e9123$export$acfdfc8c64e6747;
};
module.exports["SWATCH_ICON_COLOR"] = $7f74d498381e9123$export$692279d423b4caab;
module.exports["COLORS"] = $7f74d498381e9123$export$56d196d2844d1ca1;
module.exports["PICKER_SWATCHES"] = $7f74d498381e9123$export$d42d7c94d7629c23;
module.exports["normalizeColor"] = $7f74d498381e9123$export$4cde5df63f53f473;
module.exports["getColorLabelKey"] = $7f74d498381e9123$export$4bc90a066e1dabc3;
module.exports["isSwatchSelected"] = $7f74d498381e9123$export$13752f03fbf881b8;
module.exports["getLozengeAppearance"] = $7f74d498381e9123$export$4d9e331cafeacb9d;

});

parcelRegister("2buHA", function(module, exports) {

var $2DBsV = parcelRequire("2DBsV");

function $004d94a28e8e7a45$export$e6e9c38db7e6b0b1(fallbackText) {
    return (0, $2DBsV.isSingleEmoji)(fallbackText) ? undefined : '\uFFFD';
}
module.exports["getEmojiCustomFallback"] = $004d94a28e8e7a45$export$e6e9c38db7e6b0b1;

});

parcelRegister("2DBsV", function(module, exports) {
const $cdd07b0bc87acc5f$var$SINGLE_EMOJI_REGEX = // Regular expression to match a single emoji character
RegExp("^(\\p{Emoji_Presentation}(?:[\\u{1F3FB}-\\u{1F3FF}])?|\\p{Extended_Pictographic}\\u{FE0F}(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)*|\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?(?:\\u{200D}\\p{Extended_Pictographic}\\u{FE0F}?(?:[\\u{1F3FB}-\\u{1F3FF}])?)+|\\p{Regional_Indicator}\\p{Regional_Indicator})$", "u");
function $cdd07b0bc87acc5f$export$1d677781db73ff20(fallbackText) {
    return $cdd07b0bc87acc5f$var$SINGLE_EMOJI_REGEX.test(fallbackText ?? '');
}
module.exports["isSingleEmoji"] = $cdd07b0bc87acc5f$export$1d677781db73ff20;

});

parcelRegister("2O2Zk", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $373e836c88a63247$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    emojiNodeLabel: {
        id: "fabric.emoji.label",
        defaultMessage: "Emoji"
    }
});
module.exports["messages"] = $373e836c88a63247$export$defe85febe8b728c;

});

parcelRegister("dDpOM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $1aedaca47fa21d78$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $1aedaca47fa21d78$var$PanelErrorGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z",
            fill: "currentColor"
        })
    });
};
const $1aedaca47fa21d78$export$76fa6c311f4e2871 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($1aedaca47fa21d78$var$PanelErrorGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($1aedaca47fa21d78$var$PanelErrorGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelErrorIcon"] = $1aedaca47fa21d78$export$76fa6c311f4e2871;

});

parcelRegister("jA0E3", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $a579bb9ddad96162$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $a579bb9ddad96162$var$PanelInfoGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z",
            fill: "currentColor"
        })
    });
};
const $a579bb9ddad96162$export$2187dc2d495c3efc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($a579bb9ddad96162$var$PanelInfoGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($a579bb9ddad96162$var$PanelInfoGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelInfoIcon"] = $a579bb9ddad96162$export$2187dc2d495c3efc;

});

parcelRegister("564fr", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $276a71e22fa0e942$var$iconStyles = null;
const $276a71e22fa0e942$var$PanelNoteGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z",
            fill: "currentColor"
        })
    });
};
const $276a71e22fa0e942$export$d4f894f0c3f0db6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(6);
    const t0 = props.label ? "img" : undefined;
    const t1 = props.label ? props.label : undefined;
    const t2 = props.label ? undefined : true;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)($276a71e22fa0e942$var$PanelNoteGlyph, {
            role: "presentation"
        });
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    let t5;
    if ($[2] !== t0 || $[3] !== t1 || $[4] !== t2) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t0,
            "aria-label": t1,
            "aria-hidden": t2,
            className: t3,
            children: t4
        });
        $[2] = t0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t5;
    } else t5 = $[5];
    return t5;
} : (props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: props.label ? 'img' : undefined,
        "aria-label": props.label ? props.label : undefined,
        "aria-hidden": props.label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($276a71e22fa0e942$var$PanelNoteGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelNoteIcon"] = $276a71e22fa0e942$export$d4f894f0c3f0db6;

});

parcelRegister("30pGv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $5ac0d457a06bc975$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $5ac0d457a06bc975$var$PanelSuccessGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z",
            fill: "currentColor"
        })
    });
};
const $5ac0d457a06bc975$export$a5a5162e21242c3c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($5ac0d457a06bc975$var$PanelSuccessGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($5ac0d457a06bc975$var$PanelSuccessGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelSuccessIcon"] = $5ac0d457a06bc975$export$a5a5162e21242c3c;

});

parcelRegister("6MmtN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $532129d0e2b29baf$var$iconStyles = null; // Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $532129d0e2b29baf$var$PanelWarningGlyph = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { role: role } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== role) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            role: role,
            children: t1
        });
        $[1] = role;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ role: role })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: role,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z",
            fill: "currentColor"
        })
    });
};
const $532129d0e2b29baf$export$246c5468186717b7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { label: label } = t0;
    const t1 = label ? "img" : undefined;
    const t2 = label ? label : undefined;
    const t3 = label ? undefined : true;
    let t4;
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]);
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)($532129d0e2b29baf$var$PanelWarningGlyph, {
            role: "presentation"
        });
        $[0] = t4;
        $[1] = t5;
    } else {
        t4 = $[0];
        t5 = $[1];
    }
    let t6;
    if ($[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            role: t1,
            "aria-label": t2,
            "aria-hidden": t3,
            className: t4,
            children: t5
        });
        $[2] = t1;
        $[3] = t2;
        $[4] = t3;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : ({ label: label })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _3YEZNOdnbC _1O5n5yYbGa"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($532129d0e2b29baf$var$PanelWarningGlyph, {
            role: "presentation"
        })
    });
};
module.exports["PanelWarningIcon"] = $532129d0e2b29baf$export$246c5468186717b7;

});

parcelRegister("aHoC6", function(module, exports) {
$parcel$export(module.exports, "default", () => $7fc71b9d8c80c48f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $5X6fy = parcelRequire("5X6fy");


var $7Y8M5 = parcelRequire("7Y8M5");


var $iDrrr = parcelRequire("iDrrr");


var $5o4s6 = parcelRequire("5o4s6");


var $4G6PK = parcelRequire("4G6PK");


var $95Vjg = parcelRequire("95Vjg");


var $ihn0W = parcelRequire("ihn0W");


var $hNvnn = parcelRequire("hNvnn");

function $7fc71b9d8c80c48f$export$2e2bcd8739ae039({ layout: layout, width: width, height: height, containerWidth: containerWidth = width, isLoading: isLoading = false, pctWidth: pctWidth, size: size, className: className, children: propsChildren, nodeType: nodeType = 'mediaSingle', fullWidthMode: fullWidthMode, lineLength: editorWidth, hasFallbackContainer: hasFallbackContainer = true, handleMediaSingleRef: handleMediaSingleRef, isInsideOfInlineExtension: isInsideOfInlineExtension = false, dataAttributes: dataAttributes, isInRenderer: isInRenderer = false }) {
    const isPixelWidth = size?.widthType === 'pixel';
    let mediaSingleWidth = size?.width || pctWidth;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(propsChildren);
    if (!mediaSingleWidth && (0, $ihn0W.shouldAddDefaultWrappedWidth)(layout, width, editorWidth)) // if width is not available, set to half of editor width
    mediaSingleWidth = isPixelWidth ? editorWidth / 2 : 50;
    // When width is not set we have an absolute height for a given embed.
    // When both width and height are set we use them to determine ratio and use that to define
    // embed height in relation to whatever width of an dom element is in runtime.
    const isHeightOnly = width === undefined;
    // Preserve the absolute height before it is scaled below, so we can fall back to it if the
    // pixel-width computation yields a non-finite value (e.g. editorWidth/lineLength is 0 or
    // undefined in some host renderers such as Jira issue view).
    const absoluteHeight = height;
    if (mediaSingleWidth) {
        const pxWidth = (0, $95Vjg.getMediaSinglePixelWidth)(mediaSingleWidth, editorWidth, size?.widthType, (0, $4G6PK.MEDIA_SINGLE_GUTTER_SIZE));
        if (isHeightOnly) width = pxWidth - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
        else if (width !== undefined) {
            height = height / width * pxWidth;
            width = pxWidth;
        }
    } else if (isHeightOnly) // No mediaSingleWidth can be found on already existing pages with existing embeds
    // It's ok to use Embed specific width, because width can be not set only in embed card.
    // This value will be used only in the case of non `wide` and non `full-width` cases inside MediaSingleDimensionHelper.
    width = (0, $7Y8M5.DEFAULT_EMBED_CARD_WIDTH) - (0, $7Y8M5.akEditorMediaResizeHandlerPaddingWide);
    // Media wrapper controls the height of the box.
    // We can define this height
    // - via height directly
    // - via paddingBottom (if we have both height and width) which is a css trick to represent a ratio
    let mediaWrapperHeight;
    let paddingBottom;
    if (isHeightOnly) mediaWrapperHeight = height;
    else if (width !== undefined && !Number.isFinite(height / width * 100)) // The aspect-ratio (padding-bottom) trick collapses to 0 when the ratio is non-finite,
    // which happens when the resolved pixel width is 0/NaN (e.g. editorWidth/lineLength is
    // unavailable in the host renderer). Fall back to the embed's absolute height so the box
    // keeps a usable height instead of collapsing.
    // For embedCard nodes the `height` prop is the iframe height only; the normal ratio path
    // adds 32px for the embed header (see `calc(... + 32px)` below), so add it here too to
    // avoid clipping the header.
    mediaWrapperHeight = Number.isFinite(absoluteHeight) ? absoluteHeight + (nodeType === 'embedCard' ? 32 : 0) : undefined;
    else if (width !== undefined) {
        const mediaWrapperRatio = height / width * 100;
        paddingBottom = `${mediaWrapperRatio.toFixed(3)}%`;
        if (nodeType === 'embedCard') // we want to set ratio of whole box (including header) buy knowing ratio of iframe itself
        // For some reason importing `embedHeaderHeight` from '@atlaskit/smart-card' breaks
        // packages/editor/editor-core/src/plugins/table/__tests__/unit/toolbar.ts 🤷‍️, but we have a test
        // that uses imported value, so it's should be good.
        paddingBottom = `calc(${paddingBottom} + 32px)`;
    }
    const [media, caption] = children;
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        ref: handleMediaSingleRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $hNvnn.MediaSingleDimensionHelper)({
            width: width,
            layout: layout,
            containerWidth: containerWidth,
            mediaSingleWidth: mediaSingleWidth,
            fullWidthMode: fullWidthMode,
            isExtendedResizeExperienceOn: isPixelWidth,
            isInsideOfInlineExtension: isInsideOfInlineExtension,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            isInRenderer: isInRenderer && (0, $iDrrr.fg)('media-perf-uplift-mutation-fix')
        }),
        "data-layout": layout,
        "data-width": mediaSingleWidth,
        "data-width-type": size?.widthType || 'percentage',
        "data-node-type": nodeType,
        "data-vc": "media-single",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($5X6fy)))('rich-media-item mediaSingleView-content-wrap', `image-${layout}`, className, {
            'is-loading': isLoading,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        }),
        ...dataAttributes,
        ...(0, $5o4s6.VcMediaWrapperProps)
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $hNvnn.MediaWrapper), {
        hasFallbackContainer: hasFallbackContainer,
        height: mediaWrapperHeight,
        paddingBottom: paddingBottom
    }, media), caption);
}

});

parcelRegister("95Vjg", function(module, exports) {
/**
 * Convert media node width to pixel
 *
 * for legacy experience, image is aligned inside resize handle bar with a gap. So gutterOffset is used to for this use case.
 * for new experience, image is aligned with resize handle bar, so gutterOffset is 0
 *
 * @param width - media single node width
 * @param editorWidth - width of editor
 * @param widthType - width type is defined in the adf document for mediaSingle node, and it is associated with the `width`
 * @param gutterOffset - resize handle bar offset, determines whether align with resize handle bar
 * @returns pixel number for media single node
 */ function $69e3419be6a9274a$export$a6f4ec2edd25b07e(width, editorWidth, widthType = 'percentage', gutterOffset = 0) {
    if (widthType === 'pixel') return width;
    return Math.ceil((editorWidth + gutterOffset) * (width / 100) - gutterOffset);
}
module.exports["getMediaSinglePixelWidth"] = $69e3419be6a9274a$export$a6f4ec2edd25b07e;

});

parcelRegister("hNvnn", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8qft0 = parcelRequire("8qft0");


var $h9Lux = parcelRequire("h9Lux");


var $5y9Nl = parcelRequire("5y9Nl");


var $fuDKy = parcelRequire("fuDKy");

function $640d411acbc53708$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $640d411acbc53708$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
function $640d411acbc53708$var$getWidthIfFullWidthMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorFullWidthLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullWidthLayoutWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$var$getWidthIfDefaultMode(originalWidth, containerWidth, isInsideOfInlineExtension) {
    if (isInsideOfInlineExtension) return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? `${Math.min(containerWidth, (0, $7Y8M5.akEditorDefaultLayoutWidth))}px` : `${originalWidth}px`;
    return originalWidth > (0, $7Y8M5.akEditorFullPageMaxWidth) ? '100%' : `${originalWidth}px`;
}
function $640d411acbc53708$export$326222fa0d211f8e(layout, width, containerWidth = 0, fullWidthMode, isResized, isInsideOfInlineExtension) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return isInsideOfInlineExtension ? (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`) : (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth, isInsideOfInlineExtension) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth, isInsideOfInlineExtension);
    }
}
function $640d411acbc53708$export$e4db998a333a342e(layout, width, containerWidth = 0, fullWidthMode, isResized) {
    switch(layout){
        case 'align-start':
        case 'align-end':
        case 'wrap-right':
        case 'wrap-left':
            return width > containerWidth / 2 ? 'calc(50% - 12px)' : `${width}px`;
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth, Infinity, `${containerWidth}px`);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return isResized ? `${width}px` : fullWidthMode ? $640d411acbc53708$var$getWidthIfFullWidthMode(width, containerWidth) : $640d411acbc53708$var$getWidthIfDefaultMode(width, containerWidth);
    }
}
function $640d411acbc53708$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
function $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout) {
    switch(layout){
        case 'wide':
            return `min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width))`;
        case 'full-width':
            return `min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width))`;
        default:
            return 'var(--ak-editor-max-container-width)';
    }
}
function $640d411acbc53708$var$isImageAligned(layout) {
    switch(layout){
        case 'align-end':
            return 'margin-right: 0';
        case 'align-start':
            return 'margin-left: 0';
        default:
            return '';
    }
}
/**
 * Can't use `.attrs` to handle highly dynamic styles because we are still
 * supporting `styled-components` v1.
 * @param root0
 * @param root0.containerWidth
 * @param root0.fullWidthMode
 * @param root0.isResized
 * @param root0.layout
 * @param root0.mediaSingleWidth
 * @param root0.width
 * @param root0.isExtendedResizeExperienceOn
 * @param root0.isNestedNode
 * @param root0.isInsideOfInlineExtension
 * @param root0.isInRenderer
 * @example
 */ // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
var $640d411acbc53708$var$_ref = {
    name: "1il1ars",
    styles: "@container ak-renderer-wrapper (min-width: 1px){max-width:100cqw;}"
};
var $640d411acbc53708$var$_ref2 = {
    name: "1bxycju",
    styles: "min-width:100%"
};
const $640d411acbc53708$export$2b2737a2ef2f5b46 = ({ containerWidth: containerWidth = 0, fullWidthMode: fullWidthMode, isResized: isResized, layout: layout, mediaSingleWidth: mediaSingleWidth, width: width, isExtendedResizeExperienceOn: // original media width
isExtendedResizeExperienceOn, isNestedNode: isNestedNode = false, isInsideOfInlineExtension: isInsideOfInlineExtension = false, isInRenderer: isInRenderer = false })=>{
    const calculatedWidth = (0, $fuDKy.roundToClosestEvenPxValue)(isExtendedResizeExperienceOn ? `${mediaSingleWidth || width}px` : mediaSingleWidth ? (0, $5y9Nl.calcResizedWidth)(layout, width || 0, containerWidth) : $640d411acbc53708$export$326222fa0d211f8e(layout, width || 0, containerWidth, fullWidthMode, isResized, isInsideOfInlineExtension));
    const cssMaxWidth = isExtendedResizeExperienceOn ? 'var(--ak-editor-max-container-width)' : $640d411acbc53708$var$calcMaxCssForPercentageTypeMedia(layout);
    // jest warning: JSDOM version (22) doesn't support the new @container CSS rule
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    return /*#__PURE__*/ (0, $lOiVq.css)("tr &,[data-layout-column] &,[data-node-type='expand'] &,[data-panel-type] &,li &,[data-prosemirror-node-name='bodiedSyncBlock'] &,[data-prosemirror-node-name='syncBlock'] &,[data-sync-block-renderer] &,[data-bodied-sync-block] &{max-width:100%;}width:", calculatedWidth, ";", layout === 'full-width' && /* This causes issues for new experience where we don't strip layout attributes
   when copying top-level node and pasting into a table/layout,
   because full-width layout will remain, causing node to be edge-to-edge */ !isExtendedResizeExperienceOn && $640d411acbc53708$var$_ref2, " ", isInRenderer ? $640d411acbc53708$var$_ref : `max-width: ${cssMaxWidth};`, " ", isExtendedResizeExperienceOn && `&[class*='is-resizing'] {
    .new-file-experience-wrapper {
      box-shadow: none !important;
    }

    ${!isNestedNode && (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
      transform: translateX(-50%);`}
  }`, " &:not(.is-resizing){transition:width 100ms ease-in;}float:", $640d411acbc53708$var$float(layout), ";margin:", $640d411acbc53708$var$calcMargin(layout), ";&[class*='not-resizing']{", isNestedNode ? /* Make nested node appear responsive when resizing table cell */ `max-width: 100%;` : (0, $8qft0.nonWrappedLayouts).includes(layout) && `margin-left: 50%;
        transform: translateX(-50%);`, ";}", $640d411acbc53708$var$isImageAligned(layout), ";");
};
const $640d411acbc53708$var$RenderFallbackContainer = ({ hasFallbackContainer: hasFallbackContainer, paddingBottom: paddingBottom, height: height })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation
    (0, $lOiVq.css)(hasFallbackContainer ? `
  &::after {
    content: '';
    display: block;
    ${height ? `height: ${height}px;` : paddingBottom ? `padding-bottom: ${paddingBottom};` : ''}

    /* Fixes extra padding problem in Firefox */
    font-size: 0;
    line-height: 0;
  }
  ` : '', ";");
const $640d411acbc53708$export$9e3fd9f6215dd7b6 = (props)=>/*#__PURE__*/ (0, $lOiVq.css)("position:relative;", $640d411acbc53708$var$RenderFallbackContainer(props), "&>figure{position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}&>div:not([data-media-badges='true']){position:", props.hasFallbackContainer ? 'absolute' : 'relative', ";height:100%;width:100%;}& * [data-mark-annotation-type='inlineComment']{width:100%;height:100%;}&[data-node-type='embedCard']>div{width:100%;}[data-node-type='media']{position:static!important;height:auto!important;>div{position:absolute;height:100%;}}");
const $640d411acbc53708$export$542000db99cecf28 = ({ children: children, ...rest })=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: $640d411acbc53708$export$9e3fd9f6215dd7b6(rest)
    }, children);
$640d411acbc53708$export$542000db99cecf28.displayName = 'WrapperMediaSingle';
const $640d411acbc53708$export$e18e95249d813157 = ({ borderColor: borderColor })=>{
    const borderRadius = "var(--ds-radius-large, 8px)";
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            inset: '0px',
            border: `0.5px solid ${borderColor}`,
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    });
};
module.exports["MediaSingleDimensionHelper"] = $640d411acbc53708$export$2b2737a2ef2f5b46;
module.exports["MediaWrapper"] = $640d411acbc53708$export$542000db99cecf28;
module.exports["MediaBorderGapFiller"] = $640d411acbc53708$export$e18e95249d813157;

});

parcelRegister("5y9Nl", function(module, exports) {

var $h9Lux = parcelRequire("h9Lux");

function $a736c0097336f0f5$export$d48e8f24f681763e(layout, width, containerWidth = 0) {
    switch(layout){
        case 'wide':
            return (0, $h9Lux.calcWideWidth)(containerWidth);
        case 'full-width':
            return (0, $h9Lux.calcBreakoutWidth)(layout, containerWidth);
        default:
            return `${width}px`;
    }
}
module.exports["calcResizedWidth"] = $a736c0097336f0f5$export$d48e8f24f681763e;

});

parcelRegister("fuDKy", function(module, exports) {
/**
 * Reduces the given CSS width value to the next lowest even pixel value if the value is in px.
 * This is to mitigate subpixel rendering issues of embedded smart links.
 *
 * @param widthValue CSS width value to be rounded
 * @returns Reduced CSS width value where px value given, or otherwise the original value
 * @example
 */ // widthValue could be a string in px, rem or percentage, e.g. "800px", "100%", etc.
function $e6d228c4639d9fdf$export$c832331b07480714(widthValue) {
    try {
        if (widthValue.endsWith('px')) {
            const pxWidth = parseInt(widthValue.slice(0, -2));
            return `${pxWidth - pxWidth % 2}px`;
        }
        return widthValue;
    } catch  {
        return widthValue;
    }
}
module.exports["roundToClosestEvenPxValue"] = $e6d228c4639d9fdf$export$c832331b07480714;

});

parcelRegister("iIYTj", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $cbY7C = parcelRequire("cbY7C");


var $7YvXl = parcelRequire("7YvXl");


var $bI14T = parcelRequire("bI14T");


var $imtNr = parcelRequire("imtNr");


var $4Vdlk = parcelRequire("4Vdlk");


var $1bRPL = parcelRequire("1bRPL");


var $deUyp = parcelRequire("deUyp");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $7jfHQ = parcelRequire("7jfHQ");

var $a1a722d55501d95d$export$89741becde3d0e54 = /*#__PURE__*/ function(SMART_LINK_DRAG_TYPES) {
    SMART_LINK_DRAG_TYPES["EDITOR"] = "smart-link-from-editor";
    SMART_LINK_DRAG_TYPES["RENDERER"] = "smart-link-from-renderer";
    return SMART_LINK_DRAG_TYPES;
}({});
var $a1a722d55501d95d$export$a4a3cf1d43312764 = /*#__PURE__*/ function(SMART_LINK_APPEARANCE) {
    SMART_LINK_APPEARANCE["INLINE"] = "inline";
    SMART_LINK_APPEARANCE["BLOCK"] = "block";
    SMART_LINK_APPEARANCE["EMBED"] = "embed";
    return SMART_LINK_APPEARANCE;
}({});
function $a1a722d55501d95d$export$ac5f6dc1cb5b8db6(type) {
    return type === "smart-link-from-editor" || type === "smart-link-from-renderer";
} /**
   * Checks if a ProseMirror node type is a smart link card.
   */ 
function $a1a722d55501d95d$export$250eee508686c799(nodeType) {
    return nodeType === 'inlineCard' || nodeType === 'blockCard' || nodeType === 'embedCard';
}
const $a1a722d55501d95d$var$idleState = {
    type: 'idle'
};
const $a1a722d55501d95d$var$draggingState = {
    type: 'dragging'
};
const $a1a722d55501d95d$var$styles = {
    preview: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _4c065U1Y8M _2Y7lL42ADO _3hxITi6wH8 _3vBAKH9r67 _0KLXrulfZc _1EqgXle7g8 _2OUyjtGk8v",
    previewText: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    draggableBlock: "_0wOv4QAxrc"
};
const $a1a722d55501d95d$var$previewIconStyles = null;
const $a1a722d55501d95d$var$draggableInlineStyles = null;
const $a1a722d55501d95d$var$SmartLinkDragPreview = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDragPreview(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { title: title, url: url, iconUrl: iconUrl } = t0;
    let t1;
    if ($[0] !== iconUrl) {
        t1 = iconUrl && /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: iconUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV025zaO _0jFU0V5zaO _3YEZNOdnbC"
            ])
        });
        $[0] = iconUrl;
        $[1] = t1;
    } else t1 = $[1];
    const t2 = title || url;
    let t3;
    if ($[2] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "span",
            xcss: $a1a722d55501d95d$var$styles.previewText,
            children: t2
        });
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t1 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a1a722d55501d95d$var$styles.preview,
            children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                alignBlock: "center",
                space: "space.075",
                children: [
                    t1,
                    t3
                ]
            })
        });
        $[4] = t1;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SmartLinkDragPreview({ title: title, url: url, iconUrl: iconUrl }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a1a722d55501d95d$var$styles.preview,
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075",
            children: [
                iconUrl && /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
                    src: iconUrl,
                    alt: "",
                    className: (0, $hekY6.default)([
                        "_39xV025zaO _0jFU0V5zaO _3YEZNOdnbC"
                    ])
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    as: "span",
                    xcss: $a1a722d55501d95d$var$styles.previewText,
                    children: title || url
                })
            ]
        })
    });
};
function $a1a722d55501d95d$var$getIconUrl(details) {
    if (details?.data && 'icon' in details.data && typeof details?.data?.icon === 'string') return details.data.icon;
    const objectIconUrl = (0, $7jfHQ.getObjectIconUrl)(details);
    if (objectIconUrl) return objectIconUrl;
     // Confluence/Jira content-type specific icons (page, blog, whiteboard, issue, etc.)
    if (details?.entityData && 'iconUrl' in details.entityData && typeof details.entityData.iconUrl === 'string') return details.entityData.iconUrl;
     // Fallback to provider/generator icon (product logo)
    if (typeof details?.meta?.generator?.icon?.url === 'string') return details.meta.generator.icon.url;
    return undefined;
} /**
   * Inner component that handles the actual drag behavior.
   * Must be rendered within a SmartCardProvider context.
   */ 
const $a1a722d55501d95d$var$SmartLinkDraggableInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDraggableInner(t0) {
    const $ = (0, $bDgLe.c)(35);
    const { url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: t1, children: children } = t0;
    const isChangeboardTarget = t1 === undefined ? false : t1;
    const ref = (0, $cozmU.useRef)(null);
    const { store: store } = (0, $bI14T.useSmartLinkContext)();
    const [state, setState] = (0, $cozmU.useState)($a1a722d55501d95d$var$idleState);
    let t2;
    if ($[0] !== appearance || $[1] !== propTitle || $[2] !== source || $[3] !== store || $[4] !== url) {
        t2 = (targetEl)=>({
                element: targetEl,
                getInitialData: ()=>{
                    const cardState = store.getState()[url];
                    const details = cardState?.details;
                    const title = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details);
                    const iconUrl = $a1a722d55501d95d$var$getIconUrl(details);
                    return {
                        type: source,
                        url: url,
                        title: title,
                        iconUrl: iconUrl,
                        appearance: appearance
                    };
                },
                onGenerateDragPreview: (t3)=>{
                    const { nativeSetDragImage: nativeSetDragImage } = t3;
                    const cardState_0 = store.getState()[url];
                    const details_0 = cardState_0?.details;
                    const title_0 = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details_0);
                    const iconUrl_0 = $a1a722d55501d95d$var$getIconUrl(details_0);
                    (0, $deUyp.setCustomNativeDragPreview)({
                        getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                            x: "16px",
                            y: "8px"
                        }),
                        render (t4) {
                            const { container: container } = t4;
                            setState({
                                type: "preview",
                                container: container,
                                title: title_0,
                                iconUrl: iconUrl_0
                            });
                            return ()=>setState($a1a722d55501d95d$var$draggingState);
                        },
                        nativeSetDragImage: nativeSetDragImage
                    });
                },
                onDragStart: ()=>setState($a1a722d55501d95d$var$draggingState),
                onDrop: ()=>setState($a1a722d55501d95d$var$idleState)
            });
        $[0] = appearance;
        $[1] = propTitle;
        $[2] = source;
        $[3] = store;
        $[4] = url;
        $[5] = t2;
    } else t2 = $[5];
    const getDragConfig = t2;
    let t3;
    if ($[6] !== appearance || $[7] !== getDragConfig) {
        t3 = ()=>{
            const el = ref.current;
            if (!el) return;
            let cleanupDraggable = null;
            let observer = null;
            if (appearance !== "inline") {
                const setupSmartElementLink = ()=>{
                    el.querySelectorAll("[data-smart-element-link]").forEach($a1a722d55501d95d$var$_temp);
                };
                setupSmartElementLink();
                observer = new MutationObserver(setupSmartElementLink);
                observer.observe(el, {
                    childList: true,
                    subtree: true
                });
            }
            const unbindPointerDown = (0, $cbY7C.bind)(el, {
                type: "pointerdown",
                listener: (event)=>{
                    const selectionAtPointerDown = window.getSelection();
                    if (appearance === "inline" && selectionAtPointerDown?.type === "Range" && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                    cleanupDraggable?.();
                    const target = event.target;
                    let dragTarget = el;
                    if (appearance === "inline") {
                        const targetElement = target instanceof Element ? target : null;
                        const hostInlineCardRoot = el.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]");
                        const inlineCardRoot = targetElement?.closest("[data-prosemirror-node-name=\"inlineCard\"][draggable=\"true\"]") ?? null;
                        const closestInlineAnchor = targetElement?.closest("a[href], [data-smart-element-link]") ?? null;
                        if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                        else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                    } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                    cleanupDraggable = (0, $4Vdlk.draggable)(getDragConfig(dragTarget));
                }
            });
            return ()=>{
                cleanupDraggable?.();
                unbindPointerDown();
                observer?.disconnect();
            };
        };
        $[6] = appearance;
        $[7] = getDragConfig;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== appearance || $[10] !== getDragConfig || $[11] !== propTitle || $[12] !== source || $[13] !== store || $[14] !== url) {
        t4 = [
            url,
            propTitle,
            appearance,
            source,
            store,
            getDragConfig
        ];
        $[9] = appearance;
        $[10] = getDragConfig;
        $[11] = propTitle;
        $[12] = source;
        $[13] = store;
        $[14] = url;
        $[15] = t4;
    } else t4 = $[15];
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[16] !== state.container || $[17] !== state.iconUrl || $[18] !== state.title || $[19] !== state.type || $[20] !== url) {
        t5 = state.type === "preview" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDragPreview, {
            title: state.title,
            url: url,
            iconUrl: state.iconUrl
        }), state.container) : null;
        $[16] = state.container;
        $[17] = state.iconUrl;
        $[18] = state.title;
        $[19] = state.type;
        $[20] = url;
        $[21] = t5;
    } else t5 = $[21];
    const preview = t5;
    if (appearance === "inline") {
        const t6 = isChangeboardTarget ? "smart-link-draggable-changeboard" : undefined;
        let t7;
        if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $hekY6.default)([
                "_0wOv4QAxrc _3iDTPbS8kF"
            ]);
            $[22] = t7;
        } else t7 = $[22];
        let t8;
        if ($[23] !== children || $[24] !== t6 || $[25] !== t7) {
            t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": t6,
                className: t7,
                children: children
            });
            $[23] = children;
            $[24] = t6;
            $[25] = t7;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== preview || $[28] !== t8) {
            t9 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: [
                    t8,
                    preview
                ]
            });
            $[27] = preview;
            $[28] = t8;
            $[29] = t9;
        } else t9 = $[29];
        return t9;
    }
    let t6;
    if ($[30] !== children) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            ref: ref,
            xcss: $a1a722d55501d95d$var$styles.draggableBlock,
            testId: "smart-link-draggable-block",
            children: children
        });
        $[30] = children;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[32] !== preview || $[33] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: [
                t6,
                preview
            ]
        });
        $[32] = preview;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    return t7;
} : function SmartLinkDraggableInner({ url: url, title: propTitle, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget = false, children: children }) {
    const ref = (0, $cozmU.useRef)(null);
    const { store: store } = (0, $bI14T.useSmartLinkContext)();
    const [state, setState] = (0, $cozmU.useState)($a1a722d55501d95d$var$idleState); // Store the draggable config so we can re-register on different elements
    // when the browser picks a child as the drag target.
    const getDragConfig = (0, $cozmU.useCallback)((targetEl)=>({
            element: targetEl,
            getInitialData: ()=>{
                const cardState = store.getState()[url];
                const details = cardState?.details;
                const title = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details);
                const iconUrl = $a1a722d55501d95d$var$getIconUrl(details);
                return {
                    type: source,
                    url: url,
                    title: title,
                    iconUrl: iconUrl,
                    appearance: appearance
                };
            },
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const cardState_0 = store.getState()[url];
                const details_0 = cardState_0?.details;
                const title_0 = propTitle || (0, $7YvXl.extractSmartLinkTitle)(details_0);
                const iconUrl_0 = $a1a722d55501d95d$var$getIconUrl(details_0);
                (0, $deUyp.setCustomNativeDragPreview)({
                    getOffset: (0, $1bRPL.pointerOutsideOfPreview)({
                        x: '16px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        setState({
                            type: 'preview',
                            container: container,
                            title: title_0,
                            iconUrl: iconUrl_0
                        });
                        return ()=>setState($a1a722d55501d95d$var$draggingState);
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            onDragStart: ()=>setState($a1a722d55501d95d$var$draggingState),
            onDrop: ()=>setState($a1a722d55501d95d$var$idleState)
        }), [
        url,
        propTitle,
        appearance,
        source,
        store
    ]);
    // On pointerdown, determine the drag element and register it with Pragmatic DnD.
    // Uses pointerdown because the drag source may not exist at mount time as smart cards resolve.
    // For inline cards inside ProseMirror, prefer the inner anchor because the browser fires
    // dragstart from that element rather than from the inline card wrapper.
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const inlineCardRootSelector = '[data-prosemirror-node-name="inlineCard"][draggable="true"]'; // In contentEditable editors (ProseMirror), the browser may pick a child
        // element (e.g., an <a> tag) as the drag target instead of our element.
        // On pointerdown, we find the likely drag target and register draggable()
        // on it so pragmatic-drag-and-drop recognizes the drag.
        let cleanupDraggable = null; // In contentEditable="true" contexts (block/embed cards), the browser treats
        // the smart-element-link as editable text rather than a draggable element.
        // Not needed for inline cards since the wrapper is already not editable
        let observer = null;
        if (appearance !== "inline") {
            const setupSmartElementLink = ()=>{
                el.querySelectorAll('[data-smart-element-link]').forEach((link)=>{
                    link.contentEditable = 'false';
                    link.setAttribute('draggable', 'true');
                });
            };
            setupSmartElementLink();
            observer = new MutationObserver(setupSmartElementLink);
            observer.observe(el, {
                childList: true,
                subtree: true
            });
        }
        const unbindPointerDown = (0, $cbY7C.bind)(el, {
            type: 'pointerdown',
            listener: (event)=>{
                const selectionAtPointerDown = window.getSelection();
                if (appearance === "inline" && selectionAtPointerDown?.type === 'Range' && selectionAtPointerDown.toString().length > 0) selectionAtPointerDown.removeAllRanges();
                cleanupDraggable?.();
                const target = event.target; // Find the nearest draggable ancestor within the card to match
                // the element the browser will use as the dragstart target.
                let dragTarget = el;
                if (appearance === "inline") {
                    const targetElement = target instanceof Element ? target : null;
                    const hostInlineCardRoot = el.closest(inlineCardRootSelector);
                    const inlineCardRoot = targetElement?.closest(inlineCardRootSelector) ?? null;
                    const closestInlineAnchor = targetElement?.closest('a[href], [data-smart-element-link]') ?? null;
                    if (closestInlineAnchor instanceof HTMLElement && (el.contains(closestInlineAnchor) || hostInlineCardRoot instanceof HTMLElement && hostInlineCardRoot.contains(closestInlineAnchor))) dragTarget = closestInlineAnchor;
                    else if (inlineCardRoot instanceof HTMLElement && hostInlineCardRoot instanceof HTMLElement && inlineCardRoot === hostInlineCardRoot) dragTarget = inlineCardRoot;
                } else dragTarget = target instanceof HTMLElement && el.contains(target) ? target : el;
                cleanupDraggable = (0, $4Vdlk.draggable)(getDragConfig(dragTarget));
            }
        });
        return ()=>{
            cleanupDraggable?.();
            unbindPointerDown();
            observer?.disconnect();
        };
    }, [
        url,
        propTitle,
        appearance,
        source,
        store,
        getDragConfig
    ]);
    const preview = state.type === 'preview' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDragPreview, {
        title: state.title,
        url: url,
        iconUrl: state.iconUrl
    }), state.container) : null; // Use span with inline display for inline cards to preserve text flow.
    if (appearance === "inline") return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: ref,
                "data-testid": "smart-link-draggable-inline",
                "data-spotlight-target": isChangeboardTarget ? 'smart-link-draggable-changeboard' : undefined,
                className: (0, $hekY6.default)([
                    "_0wOv4QAxrc _3iDTPbS8kF"
                ]),
                children: children
            }),
            preview
        ]
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                ref: ref,
                xcss: $a1a722d55501d95d$var$styles.draggableBlock,
                testId: "smart-link-draggable-block",
                children: children
            }),
            preview
        ]
    });
};
/**
 * Wraps a smart link card to make it draggable into the content tree.
 * Extracts the resolved title and icon from the smart link data store at drag start time.
 * Falls back to rendering children directly when the feature flag is off or url is missing.
 */ function $a1a722d55501d95d$var$_temp(link) {
    link.contentEditable = "false";
    link.setAttribute("draggable", "true");
}
const $a1a722d55501d95d$export$c67c8f76ce4436c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SmartLinkDraggable(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children } = t0;
    if (!url || !(0, $imtNr.isSafeUrl)(url)) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== appearance || $[3] !== children || $[4] !== isChangeboardTarget || $[5] !== source || $[6] !== title || $[7] !== url) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDraggableInner, {
            url: url,
            title: title,
            appearance: appearance,
            source: source,
            isChangeboardTarget: isChangeboardTarget,
            children: children
        });
        $[2] = appearance;
        $[3] = children;
        $[4] = isChangeboardTarget;
        $[5] = source;
        $[6] = title;
        $[7] = url;
        $[8] = t1;
    } else t1 = $[8];
    return t1;
} : function SmartLinkDraggable({ url: url, title: title, appearance: appearance, source: source, isChangeboardTarget: isChangeboardTarget, children: children }) {
    if (!url || !(0, $imtNr.isSafeUrl)(url)) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($a1a722d55501d95d$var$SmartLinkDraggableInner, {
        url: url,
        title: title,
        appearance: appearance,
        source: source,
        isChangeboardTarget: isChangeboardTarget,
        children: children
    });
};
module.exports["SMART_LINK_DRAG_TYPES"] = $a1a722d55501d95d$export$89741becde3d0e54;
module.exports["SMART_LINK_APPEARANCE"] = $a1a722d55501d95d$export$a4a3cf1d43312764;
module.exports["isSmartLinkDrag"] = $a1a722d55501d95d$export$ac5f6dc1cb5b8db6;
module.exports["SmartLinkDraggable"] = $a1a722d55501d95d$export$c67c8f76ce4436c;

});

parcelRegister("1bRPL", function(module, exports) {

var $dJ9DS = parcelRequire("dJ9DS");


var $fYxCA = parcelRequire("fYxCA");


var $beJwy = parcelRequire("beJwy");

function $c244e860353a6e68$export$427e20518819fabc(point) {
    return function getOffset({ container: container }) {
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on touch devices**
		 *
		 * _On iOS_
		 *
		 * Safari will set the transparent border color to be black
		 *
		 * `iOS@18.4.1` on May 7th 2025:
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a
		 *   black border
		 * - The `<body>` text or background color does not change the black border color
		 *
		 * While dragging, the drag preview will shift under the center of the users pointer.
		 * So if you start at {x: 0, y: 0} (top left), almost immediately the preview will move
		 * to be under the middle of the users pointer.
		 *
		 * _On Android_
		 *
		 * Chrome will put the center of the drag preview under the users pointer immediately.
		 *
		 * Tested on `Chrome@137` on `Android 14` on June 20th 2025
		 *
		 * _What we do_
		 *
		 * We don't add the transparent border
		 *
		 * - Avoid the black color on iOS
		 * - It isn't needed on Android anyway as the preview will be under the center
		 *   of the users pointer
		 *
		 * We put the center of the drag preview under the users pointer
		 *
		 * - Avoids the drag preview quickly moving from a top corner to be centered under
		 *   the users pointer on iOS
		 * - It will be under the center on Android no matter what we do
		 *
		 * We previously had a isTouchDevice() check, but it felt safer for now
		 * to have a more targeted check, as these are the devices that have been
		 * tested on.
		 */ if ((0, $fYxCA.isSafariOnIOS)() || (0, $dJ9DS.isAndroid)()) return (0, $beJwy.centerUnderPointer)({
            container: container
        });
        Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}
module.exports["pointerOutsideOfPreview"] = $c244e860353a6e68$export$427e20518819fabc;

});

parcelRegister("fYxCA", function(module, exports) {

var $gEZCs = parcelRequire("gEZCs");


var $kc8B9 = parcelRequire("kc8B9");

const $e0d278f731546dca$export$52fc40c68fea4952 = (0, $gEZCs.once)(function isSafariOnIOS() {
    return (0, $kc8B9.isSafari)() && 'ontouchend' in document;
});
module.exports["isSafariOnIOS"] = $e0d278f731546dca$export$52fc40c68fea4952;

});

parcelRegister("beJwy", function(module, exports) {
const $d5bf326c593d3c52$export$81d8e72a15eef435 = function centerUnderPointer({ container: container }) {
    const rect = container.getBoundingClientRect();
    return {
        x: rect.width / 2,
        y: rect.height / 2
    };
};
module.exports["centerUnderPointer"] = $d5bf326c593d3c52$export$81d8e72a15eef435;

});

parcelRegister("deUyp", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $kc8B9 = parcelRequire("kc8B9");


var $f0WuI = parcelRequire("f0WuI");


var $7nhOg = parcelRequire("7nhOg");


var $fbx9a = parcelRequire("fbx9a");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $0a7192879c73e22c$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $0a7192879c73e22c$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $0a7192879c73e22c$var$defaultOffset }) {
    const container = document.createElement('div');
    // Using popover="manual" to place the element in the browser's top layer.
    // This ensures the drag preview container is visually on top of everything else,
    // including elements using z-index and other stacking contexts.
    // "manual" means no light dismiss — we manage the lifecycle ourselves.
    // This element is only created for a single frame for the browser to take a
    // photo of it, and then it is destroyed.
    // Falls back to position:fixed + maxZIndex when the popover API is not available.
    // Note: the popover attribute must be set before the element is in the DOM.
    // `.showPopover()` is called further below after the element is appended to the body.
    if ((0, $fbx9a.supportsPopover)()) // eslint-disable-next-line @atlaskit/design-system/no-native-popover-or-dialog -- paints the drag preview above the page; it never takes Escape or closes on an outside press
    container.setAttribute('popover', 'manual');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        ...(0, $fbx9a.supportsPopover)() ? // needs to be overridden by our top / left values
        (0, $7nhOg.popoverResetUserAgentStyles) : {
            // Fallback: using maximum possible z-index so that this element
            // will always be on top of other positioned content.
            zIndex: (0, $f0WuI.maxZIndex)
        },
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    // `.showPopover()` must be called after the element is in the DOM.
    if ((0, $fbx9a.supportsPopover)()) container.showPopover();
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ /**
		 * Update: this bug fix is no longer needed in `Safari@26.4` (and maybe earlier)
		 * We can remove it in a future release
		 */ if ((0, $kc8B9.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        // No need to call `.hidePopover()`.
        // Removing the element from the DOM dismisses the popover
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $4Vdlk.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}
module.exports["setCustomNativeDragPreview"] = $0a7192879c73e22c$export$52d889c66db0f96e;

});

parcelRegister("7jfHQ", function(module, exports) {
const $dc3179d69ab4f7dc$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
module.exports["getObjectIconUrl"] = $dc3179d69ab4f7dc$export$bcf275804417edda;

});

parcelRegister("jZuR8", function(module, exports) {

var $fLtAn = parcelRequire("fLtAn");

const $bbb41cf47ef9db08$export$143af22820ae9de = (baseUriWithNoTrailingSlash = '')=>(0, $fLtAn.currentSiteCloudIdService).get(baseUriWithNoTrailingSlash);
module.exports["getCurrentSiteCloudId"] = $bbb41cf47ef9db08$export$143af22820ae9de;

});

parcelRegister("fLtAn", function(module, exports) {

var $aPG8c = parcelRequire("aPG8c");


var $dWxvX = parcelRequire("dWxvX");

const $aff19b92c38e9221$export$b4b75b5ce5d33ae5 = (0, $dWxvX.getCurrentSiteCloudIdLocalStorageKey)();
const $aff19b92c38e9221$export$1956112846aa829e = new (0, $aPG8c.CurrentSiteCloudIdService)();
module.exports["currentSiteCloudIdService"] = $aff19b92c38e9221$export$1956112846aa829e;

});

parcelRegister("aPG8c", function(module, exports) {
parcelRequire("6YrB3");
var $f9XbP = parcelRequire("f9XbP");


var $j39Hd = parcelRequire("j39Hd");


var $70pj3 = parcelRequire("70pj3");


var $8RXRs = parcelRequire("8RXRs");


var $jcfU0 = parcelRequire("jcfU0");

const $e53a9d084474949f$var$smartCardStorage = new (0, $f9XbP.StorageClient)((0, $8RXRs.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE);
class $e53a9d084474949f$export$a15da722a3b05509 {
    readStoredCloudId(baseUriWithNoTrailingSlash = '') {
        try {
            const cloudId = $e53a9d084474949f$var$smartCardStorage.getItem((0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash));
            if (typeof cloudId !== 'string' || !cloudId || cloudId === 'undefined') return undefined;
            return cloudId;
        } catch  {
            return undefined;
        }
    }
    writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId) {
        if (!cloudId) return;
        try {
            $e53a9d084474949f$var$smartCardStorage.setItemWithExpiry((0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash), cloudId, (0, $8RXRs.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_TTL_MS);
        } catch  {
        // Quota, private-mode, SSR, etc. — same intent as personalization-service.
        }
    }
    ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash) {
        const baseUri = (0, $jcfU0.normalizeBaseUri)(baseUriWithNoTrailingSlash);
        const existing = this.tenantInfoInflightPromises.get(baseUri);
        if (existing) return existing;
        const promise = (async ()=>{
            try {
                const response = await (0, $j39Hd.request)('get', `${baseUri}/_edge/tenant_info`);
                const cloudId = response?.cloudId;
                if (cloudId) this.writeStoredCloudId(baseUri, cloudId);
                return cloudId ? cloudId : this.readStoredCloudId(baseUri);
            } catch  {
                return this.readStoredCloudId(baseUri);
            } finally{
                this.tenantInfoInflightPromises.delete(baseUri);
            }
        })();
        this.tenantInfoInflightPromises.set(baseUri, promise);
        return promise;
    }
    /** Pure synchronous read scoped to the given base URI. */ getStoredCloudId(baseUriWithNoTrailingSlash = '') {
        return this.readStoredCloudId(baseUriWithNoTrailingSlash);
    }
    /** Writes tenant cloud id for tests or callers that intentionally warm storage before edge resolves. */ persistStoredCloudId(cloudId, baseUriWithNoTrailingSlash = '') {
        this.writeStoredCloudId(baseUriWithNoTrailingSlash, cloudId);
    }
    async get(baseUriWithNoTrailingSlash = '') {
        const fromStorage = this.readStoredCloudId(baseUriWithNoTrailingSlash);
        if (fromStorage) return fromStorage;
        return this.ensureTenantInfoInflightStarted(baseUriWithNoTrailingSlash);
    }
    /** Clears session pin and persisted storage so the next {@link get} is a fresh tenant_info fetch. */ clearCache() {
        this.tenantInfoInflightPromises.clear();
    }
    constructor(){
        this.tenantInfoInflightPromises = new Map();
    }
}
module.exports["CurrentSiteCloudIdService"] = $e53a9d084474949f$export$a15da722a3b05509;

});

parcelRegister("70pj3", function(module, exports) {

var $8RXRs = parcelRequire("8RXRs");


var $jcfU0 = parcelRequire("jcfU0");

function $9ab1e04492b578dd$export$87f317e381996380(baseUriWithNoTrailingSlash = '') {
    return `${(0, $8RXRs.currentSiteCloudIdConstants).CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX}${encodeURIComponent((0, $jcfU0.normalizeBaseUri)(baseUriWithNoTrailingSlash))}`;
}
module.exports["cloudIdStorageItemKey"] = $9ab1e04492b578dd$export$87f317e381996380;

});

parcelRegister("8RXRs", function(module, exports) {
const $144f2fcd8359dd2a$export$a05eb2f7d4daba17 = {
    SMART_CARD_STORAGE_SCOPE: 'smart-card-social-proof',
    CURRENT_SITE_CLOUD_ID_STORAGE_ITEM_KEY_PREFIX: 'site-cloud-id:v1:',
    CURRENT_SITE_CLOUD_ID_TTL_MS: 86400000
};
module.exports["currentSiteCloudIdConstants"] = $144f2fcd8359dd2a$export$a05eb2f7d4daba17;

});

parcelRegister("jcfU0", function(module, exports) {
function $b9978992253e250c$export$d01aa4af38c023bb(baseUriWithNoTrailingSlash = '') {
    return baseUriWithNoTrailingSlash.replace(/\/$/, '');
}
module.exports["normalizeBaseUri"] = $b9978992253e250c$export$d01aa4af38c023bb;

});

parcelRegister("dWxvX", function(module, exports) {

var $70pj3 = parcelRequire("70pj3");


var $8RXRs = parcelRequire("8RXRs");

const $67e1c748f74c28e2$export$dea1a8bc5840f118 = (baseUriWithNoTrailingSlash = '')=>`${(0, $8RXRs.currentSiteCloudIdConstants).SMART_CARD_STORAGE_SCOPE}_${(0, $70pj3.cloudIdStorageItemKey)(baseUriWithNoTrailingSlash)}`;
module.exports["getCurrentSiteCloudIdLocalStorageKey"] = $67e1c748f74c28e2$export$dea1a8bc5840f118;

});

parcelRegister("ipz0N", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $ebRBT = parcelRequire("ebRBT");

// `grayBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `grayBold` directly with `gray`.
const $c358709489b4576e$var$FileIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$c358709489b4576e$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $c358709489b4576e$export$2e2bcd8739ae039 = $c358709489b4576e$var$FileIconWithColor;
module.exports["default"] = $c358709489b4576e$export$2e2bcd8739ae039;

});

parcelRegister("f49me", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $ebRBT = parcelRequire("ebRBT");

// `purpleBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `purpleBold` directly with `purple`.
const $3736b97729106be6$var$ChartBarIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$3736b97729106be6$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $3736b97729106be6$export$2e2bcd8739ae039 = $3736b97729106be6$var$ChartBarIconWithColor;
module.exports["default"] = $3736b97729106be6$export$2e2bcd8739ae039;

});

parcelRegister("jBJvN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $ebRBT = parcelRequire("ebRBT");

// `greenBold` is used while `platform_lp_non_bold_large_sl_icon` is off.
// Clean up in NAVX-5752: https://hello.jira.atlassian.cloud/browse/NAVX-5752
// When that gate is cleaned up, replace `greenBold` directly with `green`.
const $a7d4397f4d39d7f1$var$ListBulletedIconWithColor = (0, $ebRBT.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$a7d4397f4d39d7f1$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $a7d4397f4d39d7f1$export$2e2bcd8739ae039 = $a7d4397f4d39d7f1$var$ListBulletedIconWithColor;
module.exports["default"] = $a7d4397f4d39d7f1$export$2e2bcd8739ae039;

});

parcelRegister("iMQz5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $4hmAW = parcelRequire("4hmAW");

const $6e22e7dea691eafe$var$BranchObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BranchObject({ label: label = 'Branch', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $6e22e7dea691eafe$export$2e2bcd8739ae039 = $6e22e7dea691eafe$var$BranchObject;
module.exports["default"] = $6e22e7dea691eafe$export$2e2bcd8739ae039;

});

parcelRegister("f7FiQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $gIfnJ = parcelRequire("gIfnJ");


var $gEyoZ = parcelRequire("gEyoZ");

const $b8829d8a161753f9$var$BranchObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BranchObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Branch" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BranchObjectTile({ label: label = 'Branch', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gIfnJ))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $b8829d8a161753f9$export$2e2bcd8739ae039 = $b8829d8a161753f9$var$BranchObjectTile;
module.exports["default"] = $b8829d8a161753f9$export$2e2bcd8739ae039;

});

parcelRegister("gEyoZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $bB0i2 = parcelRequire("bB0i2");


var $9NPFC = parcelRequire("9NPFC");

/**
 * __Object tile base__
 *
 * An object tile represents an Atlassian-specific content type.
 *
 */ const $e64fa8a7fc69b505$var$ObjectTileBase = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ObjectTileBase(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { label: t1, size: t2, testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon } = t0;
    const label = t1 === undefined ? "" : t1;
    const size = t2 === undefined ? "medium" : t2;
    const validSizes = [
        "xsmall",
        "small",
        "medium",
        "large",
        "xlarge"
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(", ")}`);
    let t3;
    if ($[0] !== Icon || $[1] !== color || $[2] !== label || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            shouldScale: true
        });
        $[0] = Icon;
        $[1] = color;
        $[2] = label;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== backgroundColor || $[6] !== size || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
            label: "",
            backgroundColor: backgroundColor,
            size: size,
            children: t3
        });
        $[5] = backgroundColor;
        $[6] = size;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function ObjectTileBase({ label: label = '', size: size = 'medium', testId: testId, color: color, backgroundColor: backgroundColor, icon: Icon }) {
    // Validate that size is a valid `ObjectTileSize` (and won't allow Tile's `xxsmall` size to be passed)
    const validSizes = [
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ];
    (0, $bB0i2.default)(validSizes.includes(size), `ObjectTile: size "${size}" is not valid. Valid sizes are: ${validSizes.join(', ')}`);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9NPFC.default), {
        label: "",
        backgroundColor: backgroundColor,
        size: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            label: label,
            color: color,
            testId: testId,
            // @ts-expect-error - Internal, undocumented prop
            shouldScale: true
        })
    });
};
var $e64fa8a7fc69b505$export$2e2bcd8739ae039 = $e64fa8a7fc69b505$var$ObjectTileBase;
module.exports["default"] = $e64fa8a7fc69b505$export$2e2bcd8739ae039;

});

parcelRegister("39Mwn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $4hmAW = parcelRequire("4hmAW");

const $29a7acb65f94e0ba$var$CommitObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CommitObject({ label: label = 'Commit', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $29a7acb65f94e0ba$export$2e2bcd8739ae039 = $29a7acb65f94e0ba$var$CommitObject;
module.exports["default"] = $29a7acb65f94e0ba$export$2e2bcd8739ae039;

});

parcelRegister("6gVpf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lepke = parcelRequire("lepke");


var $gEyoZ = parcelRequire("gEyoZ");

const $90d14fc97efa5c87$var$CommitObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommitObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Commit" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CommitObjectTile({ label: label = 'Commit', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lepke))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $90d14fc97efa5c87$export$2e2bcd8739ae039 = $90d14fc97efa5c87$var$CommitObjectTile;
module.exports["default"] = $90d14fc97efa5c87$export$2e2bcd8739ae039;

});

parcelRegister("gITbz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $4hmAW = parcelRequire("4hmAW");

const $d9b76c60fcca1e74$var$PullRequestObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PullRequestObject({ label: label = 'Pull Request', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $d9b76c60fcca1e74$export$2e2bcd8739ae039 = $d9b76c60fcca1e74$var$PullRequestObject;
module.exports["default"] = $d9b76c60fcca1e74$export$2e2bcd8739ae039;

});

parcelRegister("lvsY2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hQhpy = parcelRequire("hQhpy");


var $gEyoZ = parcelRequire("gEyoZ");

const $c843d2b7ba70d597$var$PullRequestObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PullRequestObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Pull Request" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PullRequestObjectTile({ label: label = 'Pull Request', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hQhpy))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $c843d2b7ba70d597$export$2e2bcd8739ae039 = $c843d2b7ba70d597$var$PullRequestObjectTile;
module.exports["default"] = $c843d2b7ba70d597$export$2e2bcd8739ae039;

});

parcelRegister("3CYX0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $4hmAW = parcelRequire("4hmAW");

const $ff9912959f94fce6$var$CodeObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Code" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function CodeObject({ label: label = 'Code', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $ff9912959f94fce6$export$2e2bcd8739ae039 = $ff9912959f94fce6$var$CodeObject;
module.exports["default"] = $ff9912959f94fce6$export$2e2bcd8739ae039;

});

parcelRegister("2z1Cx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6YkHb = parcelRequire("6YkHb");


var $gEyoZ = parcelRequire("gEyoZ");

const $3fba6eb33cac86c2$var$CodeObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CodeObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Code" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function CodeObjectTile({ label: label = 'Code', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6YkHb))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $3fba6eb33cac86c2$export$2e2bcd8739ae039 = $3fba6eb33cac86c2$var$CodeObjectTile;
module.exports["default"] = $3fba6eb33cac86c2$export$2e2bcd8739ae039;

});

parcelRegister("fHe6f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $4hmAW = parcelRequire("4hmAW");

const $344e992330cc90e5$var$BugObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function BugObject({ label: label = 'Bug', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $344e992330cc90e5$export$2e2bcd8739ae039 = $344e992330cc90e5$var$BugObject;
module.exports["default"] = $344e992330cc90e5$export$2e2bcd8739ae039;

});

parcelRegister("ix7Nw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6spAz = parcelRequire("6spAz");


var $gEyoZ = parcelRequire("gEyoZ");

const $e3c6782640cca582$var$BugObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BugObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Bug" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BugObjectTile({ label: label = 'Bug', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6spAz))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $e3c6782640cca582$export$2e2bcd8739ae039 = $e3c6782640cca582$var$BugObjectTile;
module.exports["default"] = $e3c6782640cca582$export$2e2bcd8739ae039;

});

parcelRegister("ahlZa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $4hmAW = parcelRequire("4hmAW");

const $4e5aedb3fb5b2488$var$ChangesObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: "var(--ds-icon-accent-yellow, #B38600)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ChangesObject({ label: label = 'Changes', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: "var(--ds-icon-accent-yellow, #B38600)"
    });
};
var $4e5aedb3fb5b2488$export$2e2bcd8739ae039 = $4e5aedb3fb5b2488$var$ChangesObject;
module.exports["default"] = $4e5aedb3fb5b2488$export$2e2bcd8739ae039;

});

parcelRegister("lfmf4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lCTy3 = parcelRequire("lCTy3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d8f6dc54ca6872bb$var$ChangesObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChangesObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Changes" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)";
    const t3 = isBold ? "color.background.accent.yellow.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ChangesObjectTile({ label: label = 'Changes', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lCTy3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-yellow, #B38600)",
        backgroundColor: isBold ? 'color.background.accent.yellow.subtle' : undefined
    });
};
var $d8f6dc54ca6872bb$export$2e2bcd8739ae039 = $d8f6dc54ca6872bb$var$ChangesObjectTile;
module.exports["default"] = $d8f6dc54ca6872bb$export$2e2bcd8739ae039;

});

parcelRegister("6MsAF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $4hmAW = parcelRequire("4hmAW");

const $caa0390e0439cdc5$var$EpicObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: "var(--ds-icon-accent-purple, #AF59E1)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function EpicObject({ label: label = 'Epic', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: "var(--ds-icon-accent-purple, #AF59E1)"
    });
};
var $caa0390e0439cdc5$export$2e2bcd8739ae039 = $caa0390e0439cdc5$var$EpicObject;
module.exports["default"] = $caa0390e0439cdc5$export$2e2bcd8739ae039;

});

parcelRegister("bht3M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7vAVv = parcelRequire("7vAVv");


var $gEyoZ = parcelRequire("gEyoZ");

const $ff1c12598ed3ba74$var$EpicObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EpicObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Epic" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)";
    const t3 = isBold ? "color.background.accent.purple.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function EpicObjectTile({ label: label = 'Epic', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7vAVv))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-purple, #AF59E1)",
        backgroundColor: isBold ? 'color.background.accent.purple.subtle' : undefined
    });
};
var $ff1c12598ed3ba74$export$2e2bcd8739ae039 = $ff1c12598ed3ba74$var$EpicObjectTile;
module.exports["default"] = $ff1c12598ed3ba74$export$2e2bcd8739ae039;

});

parcelRegister("38zdI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $4hmAW = parcelRequire("4hmAW");

const $021e642953ecdf56$var$IncidentObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function IncidentObject({ label: label = 'Incident', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $021e642953ecdf56$export$2e2bcd8739ae039 = $021e642953ecdf56$var$IncidentObject;
module.exports["default"] = $021e642953ecdf56$export$2e2bcd8739ae039;

});

parcelRegister("tBrWH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $ipvL3 = parcelRequire("ipvL3");


var $gEyoZ = parcelRequire("gEyoZ");

const $d409ccda82578191$var$IncidentObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function IncidentObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Incident" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function IncidentObjectTile({ label: label = 'Incident', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $d409ccda82578191$export$2e2bcd8739ae039 = $d409ccda82578191$var$IncidentObjectTile;
module.exports["default"] = $d409ccda82578191$export$2e2bcd8739ae039;

});

parcelRegister("cVpj0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $4hmAW = parcelRequire("4hmAW");

const $c45be7d7373a5bd1$var$ProblemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: "var(--ds-icon-accent-red, #C9372C)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function ProblemObject({ label: label = 'Problem', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: "var(--ds-icon-accent-red, #C9372C)"
    });
};
var $c45be7d7373a5bd1$export$2e2bcd8739ae039 = $c45be7d7373a5bd1$var$ProblemObject;
module.exports["default"] = $c45be7d7373a5bd1$export$2e2bcd8739ae039;

});

parcelRegister("e9ExL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $7EFpK = parcelRequire("7EFpK");


var $gEyoZ = parcelRequire("gEyoZ");

const $70d7bc77e47e0fe4$var$ProblemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ProblemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Problem" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)";
    const t3 = isBold ? "color.background.accent.red.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function ProblemObjectTile({ label: label = 'Problem', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7EFpK))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-red, #C9372C)",
        backgroundColor: isBold ? 'color.background.accent.red.subtle' : undefined
    });
};
var $70d7bc77e47e0fe4$export$2e2bcd8739ae039 = $70d7bc77e47e0fe4$var$ProblemObjectTile;
module.exports["default"] = $70d7bc77e47e0fe4$export$2e2bcd8739ae039;

});

parcelRegister("S7fVP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $4hmAW = parcelRequire("4hmAW");

const $ae65607ca2739f04$var$WorkItemObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function WorkItemObject({ label: label = 'Work Item', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $ae65607ca2739f04$export$2e2bcd8739ae039 = $ae65607ca2739f04$var$WorkItemObject;
module.exports["default"] = $ae65607ca2739f04$export$2e2bcd8739ae039;

});

parcelRegister("2hwbE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iRFKG = parcelRequire("iRFKG");


var $gEyoZ = parcelRequire("gEyoZ");

const $0c8c4b462cd0e972$var$WorkItemObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function WorkItemObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Work Item" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function WorkItemObjectTile({ label: label = 'Work Item', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $0c8c4b462cd0e972$export$2e2bcd8739ae039 = $0c8c4b462cd0e972$var$WorkItemObjectTile;
module.exports["default"] = $0c8c4b462cd0e972$export$2e2bcd8739ae039;

});

parcelRegister("bvjEB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $4hmAW = parcelRequire("4hmAW");

const $1e23ddd70a37a65a$var$StoryObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Story" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: "var(--ds-icon-accent-green, #22A06B)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function StoryObject({ label: label = 'Story', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: "var(--ds-icon-accent-green, #22A06B)"
    });
};
var $1e23ddd70a37a65a$export$2e2bcd8739ae039 = $1e23ddd70a37a65a$var$StoryObject;
module.exports["default"] = $1e23ddd70a37a65a$export$2e2bcd8739ae039;

});

parcelRegister("bnm2b", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $jrU5N = parcelRequire("jrU5N");


var $gEyoZ = parcelRequire("gEyoZ");

const $54244c8cd22493dc$var$StoryObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function StoryObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Story" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)";
    const t3 = isBold ? "color.background.accent.green.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function StoryObjectTile({ label: label = 'Story', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jrU5N))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-green, #22A06B)",
        backgroundColor: isBold ? 'color.background.accent.green.subtle' : undefined
    });
};
var $54244c8cd22493dc$export$2e2bcd8739ae039 = $54244c8cd22493dc$var$StoryObjectTile;
module.exports["default"] = $54244c8cd22493dc$export$2e2bcd8739ae039;

});

parcelRegister("jMFOf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $4hmAW = parcelRequire("4hmAW");

const $08adce465a629da4$var$SubtaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function SubtaskObject({ label: label = 'Subtask', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $08adce465a629da4$export$2e2bcd8739ae039 = $08adce465a629da4$var$SubtaskObject;
module.exports["default"] = $08adce465a629da4$export$2e2bcd8739ae039;

});

parcelRegister("h3uhG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $lSw2p = parcelRequire("lSw2p");


var $gEyoZ = parcelRequire("gEyoZ");

const $35e12172f066a32d$var$SubtaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function SubtaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Subtask" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function SubtaskObjectTile({ label: label = 'Subtask', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lSw2p))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $35e12172f066a32d$export$2e2bcd8739ae039 = $35e12172f066a32d$var$SubtaskObjectTile;
module.exports["default"] = $35e12172f066a32d$export$2e2bcd8739ae039;

});

parcelRegister("a5G9M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $4hmAW = parcelRequire("4hmAW");

const $dcf12dc0efc2d892$var$TaskObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Task" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TaskObject({ label: label = 'Task', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $dcf12dc0efc2d892$export$2e2bcd8739ae039 = $dcf12dc0efc2d892$var$TaskObject;
module.exports["default"] = $dcf12dc0efc2d892$export$2e2bcd8739ae039;

});

parcelRegister("glDuG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iAaYd = parcelRequire("iAaYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $41a316049a2a2c13$var$TaskObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TaskObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Task" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function TaskObjectTile({ label: label = 'Task', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iAaYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $41a316049a2a2c13$export$2e2bcd8739ae039 = $41a316049a2a2c13$var$TaskObjectTile;
module.exports["default"] = $41a316049a2a2c13$export$2e2bcd8739ae039;

});

parcelRegister("ai0Ge", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $d4GYd = parcelRequire("d4GYd");


var $gEyoZ = parcelRequire("gEyoZ");

const $36820b590bf4d8fd$var$BlogObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BlogObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Blog" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)";
    const t3 = isBold ? "color.background.accent.blue.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function BlogObjectTile({ label: label = 'Blog', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-blue, #357DE8)",
        backgroundColor: isBold ? 'color.background.accent.blue.subtle' : undefined
    });
};
var $36820b590bf4d8fd$export$2e2bcd8739ae039 = $36820b590bf4d8fd$var$BlogObjectTile;
module.exports["default"] = $36820b590bf4d8fd$export$2e2bcd8739ae039;

});

parcelRegister("7pJjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $4hmAW = parcelRequire("4hmAW");

const $5d24b7fd99811061$var$PageLiveDocObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: "var(--ds-icon-accent-magenta, #CD519D)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageLiveDocObject({ label: label = 'Page Live Doc', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: "var(--ds-icon-accent-magenta, #CD519D)"
    });
};
var $5d24b7fd99811061$export$2e2bcd8739ae039 = $5d24b7fd99811061$var$PageLiveDocObject;
module.exports["default"] = $5d24b7fd99811061$export$2e2bcd8739ae039;

});

parcelRegister("dipyx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gEyoZ = parcelRequire("gEyoZ");

const $5d01faeb97b0ed22$var$PageLiveDocObjectTile = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageLiveDocObjectTile(t0) {
    const $ = (0, $bDgLe.c)(7);
    const { label: t1, size: size, testId: testId, isBold: isBold } = t0;
    const label = t1 === undefined ? "Page Live Doc" : t1;
    const t2 = isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)";
    const t3 = isBold ? "color.background.accent.magenta.subtle" : undefined;
    let t4;
    if ($[0] !== isBold || $[1] !== label || $[2] !== size || $[3] !== t2 || $[4] !== t3 || $[5] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
            label: label,
            size: size,
            testId: testId,
            isBold: isBold,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            color: t2,
            backgroundColor: t3
        });
        $[0] = isBold;
        $[1] = label;
        $[2] = size;
        $[3] = t2;
        $[4] = t3;
        $[5] = testId;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : function PageLiveDocObjectTile({ label: label = 'Page Live Doc', size: size, testId: testId, isBold: isBold }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gEyoZ.default), {
        label: label,
        size: size,
        testId: testId,
        isBold: isBold,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
        color: isBold ? "var(--ds-icon, #292A2E)" : "var(--ds-icon-accent-magenta, #CD519D)",
        backgroundColor: isBold ? 'color.background.accent.magenta.subtle' : undefined
    });
};
var $5d01faeb97b0ed22$export$2e2bcd8739ae039 = $5d01faeb97b0ed22$var$PageLiveDocObjectTile;
module.exports["default"] = $5d01faeb97b0ed22$export$2e2bcd8739ae039;

});

parcelRegister("2zVsi", function(module, exports) {
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $70b08b83582e8047$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
module.exports["functionWithCondition"] = $70b08b83582e8047$export$af3c0e82a18fc057;

});

parcelRegister("7LPcf", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $367262c04ca8598b$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd?.['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonOwnedBy"] = $367262c04ca8598b$export$19ee667f3f7a6ec3;

});

parcelRegister("9EREa", function(module, exports) {

var $2GG3F = parcelRequire("2GG3F");

const $9cbb96c910c4c39f$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $9cbb96c910c4c39f$export$c471ae5fddcf1392;

});

parcelRegister("303LV", function(module, exports) {
$parcel$export(module.exports, "default", () => $22f44c32aa84ec90$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

function $22f44c32aa84ec90$var$n() {
    return $22f44c32aa84ec90$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $22f44c32aa84ec90$var$n.apply(this, arguments);
}
const $22f44c32aa84ec90$var$r = [
    "children",
    "options"
], $22f44c32aa84ec90$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $22f44c32aa84ec90$var$o = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    class: "className",
    for: "htmlFor"
}), $22f44c32aa84ec90$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $22f44c32aa84ec90$var$c = [
    "style",
    "script",
    "pre"
], $22f44c32aa84ec90$var$i = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $22f44c32aa84ec90$var$u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $22f44c32aa84ec90$var$l = /\n{2,}$/, $22f44c32aa84ec90$var$s = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $22f44c32aa84ec90$var$f = /^ *> ?/gm, $22f44c32aa84ec90$var$_ = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $22f44c32aa84ec90$var$d = /^ {2,}\n/, $22f44c32aa84ec90$var$p = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/, $22f44c32aa84ec90$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $22f44c32aa84ec90$var$h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $22f44c32aa84ec90$var$g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $22f44c32aa84ec90$var$m = /^(?:\n *)*\n/, $22f44c32aa84ec90$var$k = /\r\n?/g, $22f44c32aa84ec90$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $22f44c32aa84ec90$var$q = /^\[\^([^\]]+)]/, $22f44c32aa84ec90$var$v = /\f/g, $22f44c32aa84ec90$var$b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $22f44c32aa84ec90$var$$ = /^\s*?\[(x|\s)\]/, $22f44c32aa84ec90$var$S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $22f44c32aa84ec90$var$E = /^([^\n]+)\n *(=|-)\2{2,} *\n/, $22f44c32aa84ec90$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $22f44c32aa84ec90$var$R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $22f44c32aa84ec90$var$B = /^<!--[\s\S]*?(?:-->)/, $22f44c32aa84ec90$var$L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $22f44c32aa84ec90$var$O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $22f44c32aa84ec90$var$j = /^\{.*\}$/, $22f44c32aa84ec90$var$C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $22f44c32aa84ec90$var$I = /^<([^ >]+[:@\/][^ >]+)>/, $22f44c32aa84ec90$var$T = /-([a-z])?/gi, $22f44c32aa84ec90$var$M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $22f44c32aa84ec90$var$w = /^[^\n]+(?:  \n|\n{2,})/, $22f44c32aa84ec90$var$D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $22f44c32aa84ec90$var$F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $22f44c32aa84ec90$var$Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $22f44c32aa84ec90$var$N = /\t/g, $22f44c32aa84ec90$var$G = /(^ *\||\| *$)/g, $22f44c32aa84ec90$var$U = /^ *:-+: *$/, $22f44c32aa84ec90$var$V = /^ *:-+ *$/, $22f44c32aa84ec90$var$H = /^ *-+: *$/, $22f44c32aa84ec90$var$Q = (e)=>`(?=[\\s\\S]+?\\1${e ? "\\1" : ""})`, $22f44c32aa84ec90$var$W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $22f44c32aa84ec90$var$J = RegExp(`^([*_])\\1${$22f44c32aa84ec90$var$Q(1)}${$22f44c32aa84ec90$var$W}\\1\\1(?!\\1)`), $22f44c32aa84ec90$var$K = RegExp(`^([*_])${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1(?!\\1)`), $22f44c32aa84ec90$var$X = RegExp(`^(==)${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1`), $22f44c32aa84ec90$var$Y = RegExp(`^(~~)${$22f44c32aa84ec90$var$Q(0)}${$22f44c32aa84ec90$var$W}\\1`), $22f44c32aa84ec90$var$ee = /^(:[a-zA-Z0-9-_]+:)/, $22f44c32aa84ec90$var$ne = /^\\([^0-9A-Za-z\s])/, $22f44c32aa84ec90$var$re = /\\([^0-9A-Za-z\s])/g, $22f44c32aa84ec90$var$te = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $22f44c32aa84ec90$var$oe = /^\n+/, $22f44c32aa84ec90$var$ae = /^([ \t]*)/, $22f44c32aa84ec90$var$ce = /(?:^|\n)( *)$/, $22f44c32aa84ec90$var$ie = "(?:\\d+\\.)", $22f44c32aa84ec90$var$ue = "(?:[*+-])";
function $22f44c32aa84ec90$var$le(e) {
    return "( *)(" + (1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue) + ") +";
}
const $22f44c32aa84ec90$var$se = $22f44c32aa84ec90$var$le(1), $22f44c32aa84ec90$var$fe = $22f44c32aa84ec90$var$le(2);
function $22f44c32aa84ec90$var$_e(e) {
    return RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$se : $22f44c32aa84ec90$var$fe));
}
const $22f44c32aa84ec90$var$de = $22f44c32aa84ec90$var$_e(1), $22f44c32aa84ec90$var$pe = $22f44c32aa84ec90$var$_e(2);
function $22f44c32aa84ec90$var$ye(e) {
    return RegExp("^" + (1 === e ? $22f44c32aa84ec90$var$se : $22f44c32aa84ec90$var$fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $22f44c32aa84ec90$var$he = $22f44c32aa84ec90$var$ye(1), $22f44c32aa84ec90$var$ge = $22f44c32aa84ec90$var$ye(2);
function $22f44c32aa84ec90$var$me(e) {
    const n = 1 === e ? $22f44c32aa84ec90$var$ie : $22f44c32aa84ec90$var$ue;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $22f44c32aa84ec90$var$ke = $22f44c32aa84ec90$var$me(1), $22f44c32aa84ec90$var$xe = $22f44c32aa84ec90$var$me(2);
function $22f44c32aa84ec90$var$qe(e, n) {
    const r = 1 === n, t = r ? $22f44c32aa84ec90$var$ke : $22f44c32aa84ec90$var$xe, o = r ? $22f44c32aa84ec90$var$he : $22f44c32aa84ec90$var$ge, a = r ? $22f44c32aa84ec90$var$de : $22f44c32aa84ec90$var$pe;
    return {
        t: (e)=>a.test(e),
        o: $22f44c32aa84ec90$var$je(function(e, n) {
            const r = $22f44c32aa84ec90$var$ce.exec(n.prevCapture);
            return r && (n.list || !n.inline && !n.simple) ? t.exec(e = r[1] + e) : null;
        }),
        i: 1,
        u (e, n, t) {
            const c = r ? +e[2] : void 0, i = e[0].replace($22f44c32aa84ec90$var$l, "\n").match(o);
            let u = !1;
            return {
                items: i.map(function(e, r) {
                    const o = a.exec(e)[0].length, c = RegExp("^ {1," + o + "}", "gm"), l = e.replace(c, "").replace(a, ""), s = r === i.length - 1, f = -1 !== l.indexOf("\n\n") || s && u;
                    u = f;
                    const _ = t.inline, d = t.list;
                    let p;
                    t.list = !0, f ? (t.inline = !1, p = $22f44c32aa84ec90$var$Se(l) + "\n\n") : (t.inline = !0, p = $22f44c32aa84ec90$var$Se(l));
                    const y = n(p, t);
                    return t.inline = _, t.list = d, y;
                }),
                ordered: r,
                start: c
            };
        },
        l: (n, r, t)=>e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, o) {
                return e("li", {
                    key: o
                }, r(n, t));
            }))
    };
}
const $22f44c32aa84ec90$var$ve = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $22f44c32aa84ec90$var$be = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $22f44c32aa84ec90$var$$e(e) {
    return "string" == typeof e;
}
function $22f44c32aa84ec90$var$Se(e) {
    let n = e.length;
    for(; n > 0 && e[n - 1] <= " ";)n--;
    return e.slice(0, n);
}
function $22f44c32aa84ec90$var$ze(e, n) {
    return e.startsWith(n);
}
function $22f44c32aa84ec90$var$Ee(e, n, r) {
    if (Array.isArray(r)) {
        for(let n = 0; n < r.length; n++)if ($22f44c32aa84ec90$var$ze(e, r[n])) return !0;
        return !1;
    }
    return r(e, n);
}
function $22f44c32aa84ec90$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $22f44c32aa84ec90$var$Re(e) {
    return $22f44c32aa84ec90$var$H.test(e) ? "right" : $22f44c32aa84ec90$var$U.test(e) ? "center" : $22f44c32aa84ec90$var$V.test(e) ? "left" : null;
}
function $22f44c32aa84ec90$var$Be(e, n, r, t) {
    const o = r.inTable;
    r.inTable = !0;
    let a = [
        []
    ], c = "";
    function i() {
        if (!c) return;
        const e = a[a.length - 1];
        e.push.apply(e, n(c, r)), c = "";
    }
    return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((e, n, r)=>{
        "|" === e.trim() && (i(), t) ? 0 !== n && n !== r.length - 1 && a.push([]) : c += e;
    }), i(), r.inTable = o, a;
}
function $22f44c32aa84ec90$var$Le(e, n, r) {
    r.inline = !0;
    const t = e[2] ? e[2].replace($22f44c32aa84ec90$var$G, "").split("|").map($22f44c32aa84ec90$var$Re) : [], o = e[3] ? function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $22f44c32aa84ec90$var$Be(e, n, r, !0);
        });
    }(e[3], n, r) : [], a = $22f44c32aa84ec90$var$Be(e[1], n, r, !!o.length);
    return r.inline = !1, o.length ? {
        align: t,
        cells: o,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $22f44c32aa84ec90$var$Oe(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $22f44c32aa84ec90$var$je(e) {
    return e.inline = 1, e;
}
function $22f44c32aa84ec90$var$Ce(e) {
    return $22f44c32aa84ec90$var$je(function(n, r) {
        return r.inline ? e.exec(n) : null;
    });
}
function $22f44c32aa84ec90$var$Ie(e) {
    return $22f44c32aa84ec90$var$je(function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    });
}
function $22f44c32aa84ec90$var$Te(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $22f44c32aa84ec90$var$Me(e) {
    return $22f44c32aa84ec90$var$je(function(n) {
        return e.exec(n);
    });
}
const $22f44c32aa84ec90$var$we = /(javascript|vbscript|data(?!:image)):/i;
function $22f44c32aa84ec90$export$3e2338ea76b578c9(e) {
    try {
        const n = decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "");
        if ($22f44c32aa84ec90$var$we.test(n)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $22f44c32aa84ec90$var$Fe(e) {
    return e ? e.replace($22f44c32aa84ec90$var$re, "$1") : e;
}
function $22f44c32aa84ec90$var$Pe(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !0, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $22f44c32aa84ec90$var$Ze(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !1, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $22f44c32aa84ec90$var$Ne(e, n, r) {
    const t = r.inline || !1;
    r.inline = !1;
    const o = e(n, r);
    return r.inline = t, o;
}
const $22f44c32aa84ec90$var$Ge = (e, n, r)=>({
        children: $22f44c32aa84ec90$var$Pe(n, e[2], r)
    });
function $22f44c32aa84ec90$var$Ue() {
    return {};
}
function $22f44c32aa84ec90$var$Ve() {
    return null;
}
function $22f44c32aa84ec90$var$He(...e) {
    return e.filter(Boolean).join(" ");
}
function $22f44c32aa84ec90$var$Qe(e, n, r) {
    let t = e;
    const o = n.split(".");
    for(; o.length && (t = t[o[0]], void 0 !== t);)o.shift();
    return t || r;
}
function $22f44c32aa84ec90$export$69f434acfbdb0b32(r = "", t = {}) {
    t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $22f44c32aa84ec90$var$n({}, $22f44c32aa84ec90$var$a, t.namedCodesToUnicode) : $22f44c32aa84ec90$var$a;
    const l = t.slugify || $22f44c32aa84ec90$export$c383cdd2a518017a, G = t.sanitizer || $22f44c32aa84ec90$export$3e2338ea76b578c9, U = t.createElement || $cozmU.createElement, V = [
        $22f44c32aa84ec90$var$s,
        $22f44c32aa84ec90$var$y,
        $22f44c32aa84ec90$var$h,
        t.enforceAtxHeadings ? $22f44c32aa84ec90$var$z : $22f44c32aa84ec90$var$S,
        $22f44c32aa84ec90$var$E,
        $22f44c32aa84ec90$var$M,
        $22f44c32aa84ec90$var$ke,
        $22f44c32aa84ec90$var$xe
    ], H = [
        ...V,
        $22f44c32aa84ec90$var$w,
        $22f44c32aa84ec90$var$A,
        $22f44c32aa84ec90$var$B,
        $22f44c32aa84ec90$var$O
    ];
    function Q(e, n) {
        for(let r = 0; r < e.length; r++)if (e[r].test(n)) return !0;
        return !1;
    }
    function W(e, r, ...o) {
        const a = $22f44c32aa84ec90$var$Qe(t.overrides, e + ".props", {});
        return U(function(e, n) {
            const r = $22f44c32aa84ec90$var$Qe(n, e);
            return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $22f44c32aa84ec90$var$Qe(n, e + ".component", e) : e;
        }(e, t.overrides), $22f44c32aa84ec90$var$n({}, r, a, {
            className: $22f44c32aa84ec90$var$He(null == r ? void 0 : r.className, a.className) || void 0
        }), ...o);
    }
    function re(e) {
        e = e.replace($22f44c32aa84ec90$var$b, "");
        let n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $22f44c32aa84ec90$var$Z.test(e));
        const r = fe(se(n ? e : $22f44c32aa84ec90$var$Se(e).replace($22f44c32aa84ec90$var$oe, "") + "\n\n", {
            inline: n
        }));
        for(; $22f44c32aa84ec90$var$$e(r[r.length - 1]) && !r[r.length - 1].trim();)r.pop();
        if (null === t.wrapper) return r;
        const o = t.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || t.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? W("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return U(o, {
            key: "outer"
        }, a);
    }
    function ce(e, n) {
        if (!n || !n.trim()) return null;
        const r = n.match($22f44c32aa84ec90$var$u);
        return r ? r.reduce(function(n, r) {
            const t = r.indexOf("=");
            if (-1 !== t) {
                const a = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($22f44c32aa84ec90$var$L) && (e = e.replace($22f44c32aa84ec90$var$T, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, t)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(t + 1).trim()), u = $22f44c32aa84ec90$var$o[a] || a;
                if ("ref" === u) return n;
                const l = n[u] = function(e, n, r, t) {
                    return "style" === n ? (function(e) {
                        const n = [];
                        let r = "", t = !1, o = !1, a = "";
                        if (!e) return n;
                        for(let c = 0; c < e.length; c++){
                            const i = e[c];
                            if ('"' !== i && "'" !== i || t || (o ? i === a && (o = !1, a = "") : (o = !0, a = i)), "(" === i && r.endsWith("url") ? t = !0 : ")" === i && t && (t = !1), ";" !== i || o || t) r += i;
                            else {
                                const e = r.trim();
                                if (e) {
                                    const r = e.indexOf(":");
                                    if (r > 0) {
                                        const t = e.slice(0, r).trim(), o = e.slice(r + 1).trim();
                                        n.push([
                                            t,
                                            o
                                        ]);
                                    }
                                }
                                r = "";
                            }
                        }
                        const c = r.trim();
                        if (c) {
                            const e = c.indexOf(":");
                            if (e > 0) {
                                const r = c.slice(0, e).trim(), t = c.slice(e + 1).trim();
                                n.push([
                                    r,
                                    t
                                ]);
                            }
                        }
                        return n;
                    })(r).reduce(function(n, [r, o]) {
                        return n[r.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t(o, e, r), n;
                    }, {}) : -1 !== $22f44c32aa84ec90$var$i.indexOf(n) ? t($22f44c32aa84ec90$var$Fe(r), e, n) : (r.match($22f44c32aa84ec90$var$j) && (r = $22f44c32aa84ec90$var$Fe(r.slice(1, r.length - 1))), "true" === r || "false" !== r && r);
                }(e, a, c, G);
                "string" == typeof l && ($22f44c32aa84ec90$var$A.test(l) || $22f44c32aa84ec90$var$O.test(l)) && (n[u] = re(l.trim()));
            } else "style" !== r && (n[$22f44c32aa84ec90$var$o[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    const ie = [], ue = {}, le = {
        0: {
            t: [
                ">"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$s),
            i: 1,
            u (e, n, r) {
                const [, t, o] = e[0].replace($22f44c32aa84ec90$var$f, "").match($22f44c32aa84ec90$var$_);
                return {
                    alert: t,
                    children: n(o, r)
                };
            },
            l (e, n, r) {
                const t = {
                    key: r.key
                };
                return e.alert && (t.className = "markdown-alert-" + l(e.alert.toLowerCase(), $22f44c32aa84ec90$export$c383cdd2a518017a), e.children.unshift({
                    attrs: {},
                    children: [
                        {
                            type: "27",
                            text: e.alert
                        }
                    ],
                    noInnerParse: !0,
                    type: "11",
                    tag: "header"
                })), W("blockquote", t, n(e.children, r));
            }
        },
        1: {
            t: [
                "  "
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$d),
            i: 1,
            u: $22f44c32aa84ec90$var$Ue,
            l: (e, n, r)=>W("br", {
                    key: r.key
                })
        },
        2: {
            t: [
                "--",
                "__",
                "**",
                "- ",
                "* ",
                "_ "
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$p),
            i: 1,
            u: $22f44c32aa84ec90$var$Ue,
            l: (e, n, r)=>W("hr", {
                    key: r.key
                })
        },
        3: {
            t: [
                "    "
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$h),
            i: 0,
            u: (e)=>({
                    lang: void 0,
                    text: $22f44c32aa84ec90$var$Fe($22f44c32aa84ec90$var$Se(e[0].replace(/^ {4}/gm, "")))
                }),
            l: (e, r, t)=>W("pre", {
                    key: t.key
                }, W("code", $22f44c32aa84ec90$var$n({}, e.attrs, {
                    className: e.lang ? "lang-" + e.lang : ""
                }), e.text))
        },
        4: {
            t: [
                "```",
                "~~~"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$y),
            i: 0,
            u: (e)=>({
                    attrs: ce("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            t: [
                "`"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$g),
            i: 3,
            u: (e)=>({
                    text: $22f44c32aa84ec90$var$Fe(e[2])
                }),
            l: (e, n, r)=>W("code", {
                    key: r.key
                }, e.text)
        },
        6: {
            t: [
                "[^"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$x),
            i: 0,
            u: (e)=>(ie.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            l: $22f44c32aa84ec90$var$Ve
        },
        7: {
            t: [
                "[^"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$q),
            i: 1,
            u: (e)=>({
                    target: "#" + l(e[1], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    text: e[1]
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href")
                }, W("sup", {
                    key: r.key
                }, e.text))
        },
        8: {
            t: [
                "[ ]",
                "[x]"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$$),
            i: 1,
            u: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            l: (e, n, r)=>W("input", {
                    checked: e.completed,
                    key: r.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            t: [
                "#"
            ],
            o: $22f44c32aa84ec90$var$Te(t.enforceAtxHeadings ? $22f44c32aa84ec90$var$z : $22f44c32aa84ec90$var$S),
            i: 1,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Pe(n, e[2], r),
                    id: l(e[2], $22f44c32aa84ec90$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            l: (e, n, r)=>W("h" + e.level, {
                    id: e.id,
                    key: r.key
                }, n(e.children, r))
        },
        10: {
            t: (e)=>{
                const n = e.indexOf("\n");
                return n > 0 && n < e.length - 1 && ("=" === e[n + 1] || "-" === e[n + 1]);
            },
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$E),
            i: 1,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Pe(n, e[1], r),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$A),
            i: 1,
            u (e, n, r) {
                const [, t] = e[3].match($22f44c32aa84ec90$var$ae), o = RegExp("^" + t, "gm"), a = e[3].replace(o, ""), i = Q(H, a) ? $22f44c32aa84ec90$var$Ne : $22f44c32aa84ec90$var$Pe, u = e[1].toLowerCase(), l = -1 !== $22f44c32aa84ec90$var$c.indexOf(u), s = (l ? u : e[1]).trim(), f = {
                    attrs: ce(s, e[2]),
                    noInnerParse: l,
                    tag: s
                };
                if (r.inAnchor = r.inAnchor || "a" === u, l) f.text = e[3];
                else {
                    const e = r.inHTML;
                    r.inHTML = !0, f.children = i(n, a, r), r.inHTML = e;
                }
                return r.inAnchor = !1, f;
            },
            l: (e, r, t)=>W(e.tag, $22f44c32aa84ec90$var$n({
                    key: t.key
                }, e.attrs), e.text || (e.children ? r(e.children, t) : ""))
        },
        13: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$O),
            i: 1,
            u (e) {
                const n = e[1].trim();
                return {
                    attrs: ce(n, e[2] || ""),
                    tag: n
                };
            },
            l: (e, r, t)=>W(e.tag, $22f44c32aa84ec90$var$n({}, e.attrs, {
                    key: t.key
                }))
        },
        12: {
            t: [
                "\x3c!--"
            ],
            o: $22f44c32aa84ec90$var$Me($22f44c32aa84ec90$var$B),
            i: 1,
            u: ()=>({}),
            l: $22f44c32aa84ec90$var$Ve
        },
        14: {
            t: [
                "!["
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$be),
            i: 1,
            u: (e)=>({
                    alt: $22f44c32aa84ec90$var$Fe(e[1]),
                    target: $22f44c32aa84ec90$var$Fe(e[2]),
                    title: $22f44c32aa84ec90$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("img", {
                    key: r.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: G(e.target, "img", "src")
                })
        },
        15: {
            t: [
                "["
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$ve),
            i: 3,
            u: (e, n, r)=>({
                    children: $22f44c32aa84ec90$var$Ze(n, e[1], r),
                    target: $22f44c32aa84ec90$var$Fe(e[2]),
                    title: $22f44c32aa84ec90$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href"),
                    title: e.title
                }, n(e.children, r))
        },
        16: {
            t: [
                "<"
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$I),
            i: 0,
            u (e) {
                let n = e[1], r = !1;
                return -1 !== n.indexOf("@") && -1 === n.indexOf("//") && (r = !0, n = n.replace("mailto:", "")), {
                    children: [
                        {
                            text: n,
                            type: "27"
                        }
                    ],
                    target: r ? "mailto:" + n : n,
                    type: "15"
                };
            }
        },
        17: {
            t: (e, n)=>!n.inAnchor && !t.disableAutoLink && ($22f44c32aa84ec90$var$ze(e, "http://") || $22f44c32aa84ec90$var$ze(e, "https://")),
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$C),
            i: 0,
            u: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        20: $22f44c32aa84ec90$var$qe(W, 1),
        33: $22f44c32aa84ec90$var$qe(W, 2),
        19: {
            t: [
                "\n"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$m),
            i: 3,
            u: $22f44c32aa84ec90$var$Ue,
            l: ()=>"\n"
        },
        21: {
            o: $22f44c32aa84ec90$var$je(function(e, n) {
                if (n.inline || n.simple || n.inHTML && -1 === e.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
                let r = "", t = 0;
                for(;;){
                    const n = e.indexOf("\n", t), o = e.slice(t, -1 === n ? void 0 : n + 1);
                    if (Q(V, o)) break;
                    if (r += o, -1 === n || !o.trim()) break;
                    t = n + 1;
                }
                const o = $22f44c32aa84ec90$var$Se(r);
                return "" === o ? null : [
                    r,
                    ,
                    o
                ];
            }),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("p", {
                    key: r.key
                }, n(e.children, r))
        },
        22: {
            t: [
                "["
            ],
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$D),
            i: 0,
            u: (e)=>(ue[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            l: $22f44c32aa84ec90$var$Ve
        },
        23: {
            t: [
                "!["
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$F),
            i: 0,
            u: (e)=>({
                    alt: e[1] ? $22f44c32aa84ec90$var$Fe(e[1]) : void 0,
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("img", {
                    key: r.key,
                    alt: e.alt,
                    src: G(ue[e.ref].target, "img", "src"),
                    title: ue[e.ref].title
                }) : null
        },
        24: {
            t: (e)=>"[" === e[0] && -1 === e.indexOf("]("),
            o: $22f44c32aa84ec90$var$Ce($22f44c32aa84ec90$var$P),
            i: 0,
            u: (e, n, r)=>({
                    children: n(e[1], r),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("a", {
                    key: r.key,
                    href: G(ue[e.ref].target, "a", "href"),
                    title: ue[e.ref].title
                }, n(e.children, r)) : W("span", {
                    key: r.key
                }, e.fallbackChildren)
        },
        25: {
            t: [
                "|"
            ],
            o: $22f44c32aa84ec90$var$Te($22f44c32aa84ec90$var$M),
            i: 1,
            u: $22f44c32aa84ec90$var$Le,
            l (e, n, r) {
                const t = e;
                return W("table", {
                    key: r.key
                }, W("thead", null, W("tr", null, t.header.map(function(e, o) {
                    return W("th", {
                        key: o,
                        style: $22f44c32aa84ec90$var$Oe(t, o)
                    }, n(e, r));
                }))), W("tbody", null, t.cells.map(function(e, o) {
                    return W("tr", {
                        key: o
                    }, e.map(function(e, o) {
                        return W("td", {
                            key: o,
                            style: $22f44c32aa84ec90$var$Oe(t, o)
                        }, n(e, r));
                    }));
                })));
            }
        },
        27: {
            o: $22f44c32aa84ec90$var$je(function(e, n) {
                let r;
                return $22f44c32aa84ec90$var$ze(e, ":") && (r = $22f44c32aa84ec90$var$ee.exec(e)), r || $22f44c32aa84ec90$var$te.exec(e);
            }),
            i: 4,
            u (e) {
                const n = e[0];
                return {
                    text: -1 === n.indexOf("&") ? n : n.replace($22f44c32aa84ec90$var$R, (e, n)=>t.namedCodesToUnicode[n] || e)
                };
            },
            l: (e)=>e.text
        },
        28: {
            t: [
                "**",
                "__"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$J),
            i: 2,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("strong", {
                    key: r.key
                }, n(e.children, r))
        },
        29: {
            t: (e)=>{
                const n = e[0];
                return ("*" === n || "_" === n) && e[1] !== n;
            },
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$K),
            i: 3,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("em", {
                    key: r.key
                }, n(e.children, r))
        },
        30: {
            t: [
                "\\"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$ne),
            i: 1,
            u: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            t: [
                "=="
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$X),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("mark", {
                    key: r.key
                }, n(e.children, r))
        },
        32: {
            t: [
                "~~"
            ],
            o: $22f44c32aa84ec90$var$Ie($22f44c32aa84ec90$var$Y),
            i: 3,
            u: $22f44c32aa84ec90$var$Ge,
            l: (e, n, r)=>W("del", {
                    key: r.key
                }, n(e.children, r))
        }
    };
    !0 === t.disableParsingRawHTML && (delete le[11], delete le[13]);
    const se = function(e) {
        var n = Object.keys(e);
        function r(t, o) {
            var a = [];
            if (o.prevCapture = o.prevCapture || "", t.trim()) for(; t;)for(var c = 0; c < n.length;){
                var i = n[c], u = e[i];
                if (!u.t || $22f44c32aa84ec90$var$Ee(t, o, u.t)) {
                    var l = u.o(t, o);
                    if (l && l[0]) {
                        t = t.substring(l[0].length);
                        var s = u.u(l, r, o);
                        o.prevCapture += l[0], s.type || (s.type = i), a.push(s);
                        break;
                    }
                    c++;
                } else c++;
            }
            return o.prevCapture = "", a;
        }
        return n.sort(function(n, r) {
            return e[n].i - e[r].i || (n < r ? -1 : 1);
        }), function(e, n) {
            return r(function(e) {
                return e.replace($22f44c32aa84ec90$var$k, "\n").replace($22f44c32aa84ec90$var$v, "").replace($22f44c32aa84ec90$var$N, "    ");
            }(e), n);
        };
    }(le), fe = function(e, n) {
        return function r(t, o = {}) {
            if (Array.isArray(t)) {
                const e = o.key, n = [];
                let a = !1;
                for(let e = 0; e < t.length; e++){
                    o.key = e;
                    const c = r(t[e], o), i = $22f44c32aa84ec90$var$$e(c);
                    i && a ? n[n.length - 1] += c : null !== c && n.push(c), a = i;
                }
                return o.key = e, n;
            }
            return function(r, t, o) {
                const a = e[r.type].l;
                return n ? n(()=>a(r, t, o), r, t, o) : a(r, t, o);
            }(t, r, o);
        };
    }(le, t.renderRule), _e = re(r);
    return ie.length ? W("div", null, _e, W("footer", {
        key: "footer"
    }, ie.map(function(e) {
        return W("div", {
            id: l(e.identifier, $22f44c32aa84ec90$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, fe(se(e.footnote, {
            inline: !0
        })));
    }))) : _e;
}
var $22f44c32aa84ec90$export$2e2bcd8739ae039 = (n)=>{
    let { children: t, options: o } = n, a = function(e, n) {
        if (null == e) return {};
        var r, t, o = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (o[r] = e[r]);
        return o;
    }(n, $22f44c32aa84ec90$var$r);
    return $cozmU.cloneElement($22f44c32aa84ec90$export$69f434acfbdb0b32(null == t ? "" : t, o), a);
};
 //# sourceMappingURL=index.modern.js.map

});

parcelRegister("d4O2g", function(module, exports) {

var $1kPn4 = parcelRequire("1kPn4");

const $b61bca3ca7bdd7f0$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd?.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $1kPn4.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $1kPn4.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
module.exports["extractImage"] = $b61bca3ca7bdd7f0$export$4c753a1297cb9805;

});

parcelRegister("lXmY5", function(module, exports) {

var $hiX3M = parcelRequire("hiX3M");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $652810c159b94aae$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.ari || (0, $8YE7G.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $hiX3M.extractAri)(data);
};
module.exports["extractSmartLinkAri"] = $652810c159b94aae$export$16b02be3e2bb31ad;

});

parcelRegister("cLyLO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $b816614c9f5e4543$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $htsh0.extractPersonCreatedBy)(response.data);
};
module.exports["extractSmartLinkAuthorGroup"] = $b816614c9f5e4543$export$41fc716e1bc2dc90;

});

parcelRegister("htsh0", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $94cdde39bec9c233$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd?.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $9EREa.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $9EREa.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $94cdde39bec9c233$export$a66235cba0c9d11a;

});

parcelRegister("ddzkt", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $htsh0 = parcelRequire("htsh0");


var $kAdyG = parcelRequire("kAdyG");

const $8118f7b98ace9299$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $htsh0.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
module.exports["extractSmartLinkCreatedBy"] = $8118f7b98ace9299$export$242875b46118beb2;

});

parcelRegister("cbT5r", function(module, exports) {

var $04wHu = parcelRequire("04wHu");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $0016e53066bcc8e1$export$7a685df468cbf38f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.createdAt;
    return response?.data && (0, $04wHu.extractDateCreated)(response.data);
};
module.exports["extractSmartLinkCreatedOn"] = $0016e53066bcc8e1$export$7a685df468cbf38f;

});

parcelRegister("04wHu", function(module, exports) {
const $cb783639b44cd885$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd?.['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};
module.exports["extractDateCreated"] = $cb783639b44cd885$export$e1226a5e0bbbf862;

});

parcelRegister("e1RBl", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $JTvZe = parcelRequire("JTvZe");


var $kAdyG = parcelRequire("kAdyG");

const $0ec810a5f5f35d9a$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $JTvZe.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
module.exports["extractSmartLinkModifiedBy"] = $0ec810a5f5f35d9a$export$7f099a839071a190;

});

parcelRegister("JTvZe", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd?.['atlassian:updatedBy'];
    if (updatedBy) return (0, $9EREa.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $a5f06d98edfcf1aa$export$8a2d1ed7e6f336f0;

});

parcelRegister("ltT9o", function(module, exports) {

var $hltP6 = parcelRequire("hltP6");


var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $42cf6b151797d39e$export$75047940e157fd1f = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $hltP6.extractDateUpdated)(response.data);
};
module.exports["extractSmartLinkModifiedOn"] = $42cf6b151797d39e$export$75047940e157fd1f;

});

parcelRegister("hltP6", function(module, exports) {
const $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd?.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $57fe09cd1e375acc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("3ewaO", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $jMcHR = parcelRequire("jMcHR");


var $kAdyG = parcelRequire("kAdyG");

const $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $8YE7G.extractEntity)(response)?.url;
    return (0, $jMcHR.extractLink)(response?.data);
};
module.exports["extractSmartLinkUrl"] = $15d3ac0a1a1c5122$export$7ba9b12c6a1b73de;

});

parcelRegister("hoB2R", function(module, exports) {

var $8YE7G = parcelRequire("8YE7G");


var $kAdyG = parcelRequire("kAdyG");

const $dedbbfb6fd3975a3$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entity = (0, $8YE7G.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkDownloadUrl"] = $dedbbfb6fd3975a3$export$96ed4c1b14ac210a;

});

parcelRegister("dSs0x", function(module, exports) {

var $fcaWu = parcelRequire("fcaWu");

const $8838e9e9c5b34afb$export$736a7b9a8e50ca01 = (previewUrl, { hostProduct: hostProduct, themeState: themeState })=>{
    try {
        const url = new URL(previewUrl);
        if (themeState) url.searchParams.append('themeState', (0, $fcaWu.themeObjectToString)(themeState));
        if (hostProduct) url.searchParams.set('hostProduct', hostProduct);
        return url.href;
    } catch  {
        return previewUrl;
    }
};
const $8838e9e9c5b34afb$export$4470f298c61a79da = (previewUrl, themeState)=>$8838e9e9c5b34afb$export$736a7b9a8e50ca01(previewUrl, {
        themeState: themeState
    });
module.exports["getPreviewUrlWithEmbedContext"] = $8838e9e9c5b34afb$export$736a7b9a8e50ca01;
module.exports["getPreviewUrlWithTheme"] = $8838e9e9c5b34afb$export$4470f298c61a79da;

});

parcelRegister("di1bl", function(module, exports) {
const $7def949369507160$export$9b7e6a102056a387 = (isTrusted)=>{
    if (isTrusted) return undefined;
    const sandboxPermissions = 'allow-downloads allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts';
    return sandboxPermissions;
};
module.exports["getIframeSandboxAttribute"] = $7def949369507160$export$9b7e6a102056a387;

});

parcelRegister("gJj3k", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $19zon = parcelRequire("19zon");


var $f24cK = parcelRequire("f24cK");


var $bhs2L = parcelRequire("bhs2L");


var $7oSFe = parcelRequire("7oSFe");

const $5b6c9e2393a4e885$var$LazyEmbeddedConfluencePage = /*#__PURE__*/ (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-LtNtQ9", ()=>(0, $bhs2L.loadEmbeddedConfluencePage)().then((Page)=>({
            default: Page
        }))));
const $5b6c9e2393a4e885$export$b32b5f1ee4493319 = ({ childRef: childRef, className: className, extensionKey: extensionKey, ...props })=>{
    const confluencePageData = (0, $19zon.useConfluencePageData)(props.src || '', extensionKey || '');
    const InjectedPage = (0, $f24cK.useEmbeddedConfluencePage)();
    const Page = InjectedPage ?? $5b6c9e2393a4e885$var$LazyEmbeddedConfluencePage;
    const fallbackIframe = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("iframe", {
        className: className,
        ...props,
        ref: childRef,
        title: props.title
    });
    // Conditional rendering: Page component for lp-cc-embed URLs, iframe for everything else
    return confluencePageData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: fallbackIframe
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Page, {
        hostname: confluencePageData.hostname,
        spaceKey: confluencePageData.spaceKey,
        contentId: confluencePageData.contentId,
        parentProduct: confluencePageData.parentProduct,
        hash: confluencePageData.hash,
        mode: confluencePageData.mode,
        locale: confluencePageData.locale,
        iframeRef: childRef,
        onLoad: props.onLoad,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        sandbox: props.sandbox,
        allowedFeatures: confluencePageData.allowedFeatures,
        themeState: confluencePageData.themeStateObject,
        userInfo: confluencePageData.userInfo
    })) : fallbackIframe;
};
module.exports["IFrame"] = $5b6c9e2393a4e885$export$b32b5f1ee4493319;

});

parcelRegister("19zon", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $k4lqb = parcelRequire("k4lqb");


var $jIrdU = parcelRequire("jIrdU");

var $0848f0766ba8a46c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
var $0848f0766ba8a46c$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
var $0848f0766ba8a46c$export$dc091dbfc779121b = /*#__PURE__*/ function(CONFLUENCE_EXTENSION_KEYS) {
    CONFLUENCE_EXTENSION_KEYS["PAGE"] = "integration-confluence-object-provider";
    CONFLUENCE_EXTENSION_KEYS["CANVAS"] = "canvas-native-object-provider";
    return CONFLUENCE_EXTENSION_KEYS;
}({});
const $0848f0766ba8a46c$export$10fb2803bc7b79fc = (url, extensionKey)=>{
    const parsedData = (0, $cozmU.useMemo)(()=>{
        if (!url || typeof url !== 'string' || !url.startsWith('http://') && !url.startsWith('https://') || !extensionKey || !Object.values($0848f0766ba8a46c$export$dc091dbfc779121b).find((key)=>key === extensionKey)) return undefined;
        let urlObj;
        try {
            urlObj = new URL(url);
        } catch  {
            return undefined;
        }
        const { searchParams: searchParams, hash: hash } = urlObj;
        const hostname = searchParams?.get('hostname') || '';
        const contentId = searchParams?.get('contentId') || '';
        const spaceKey = searchParams?.get('spaceKey') || '';
        // Early return for invalid URLs
        if (!contentId || !hostname) return undefined;
        const themeState = searchParams?.get('themeState') || '';
        const themeMode = searchParams?.get('themeMode');
        const enableInlineComments = searchParams?.get('enableInlineComments') === 'true';
        const enablePageComments = searchParams?.get('enablePageComments') === 'true';
        const userId = searchParams?.get('userId') || '';
        const userIdType = searchParams?.get('userInfo') || undefined;
        const parentProduct = searchParams?.get('parentProduct') || '';
        const inlineComments = enableInlineComments ? [
            'inline-comments'
        ] : [];
        const pageComments = enablePageComments ? [
            'page-comments'
        ] : [];
        // Calculate theme state object here
        let calculatedThemeStateObject;
        if (themeState) calculatedThemeStateObject = (0, $jIrdU.themeStringToObject)(decodeURIComponent(themeState));
        else if (themeMode) calculatedThemeStateObject = {
            colorMode: themeMode
        };
        const calculatedUserInfo = userId && userIdType ? {
            userId: userId,
            userIdType: userIdType
        } : undefined;
        return {
            hostname: hostname,
            spaceKey: spaceKey,
            contentId: contentId,
            parentProduct: parentProduct,
            userInfo: calculatedUserInfo,
            hash: hash || '',
            enableInlineComments: enableInlineComments,
            enablePageComments: enablePageComments,
            themeStateObject: calculatedThemeStateObject,
            allowedFeatures: {
                edit: [
                    'delete-draft'
                ],
                view: [
                    'byline-contributors',
                    'byline-extensions',
                    'page-reactions',
                    ...pageComments,
                    ...inlineComments
                ]
            },
            mode: "view",
            locale: 'en'
        };
    }, [
        url,
        extensionKey
    ]);
    // Handle theme side effect - only when theme object changes
    (0, $cozmU.useEffect)(()=>{
        if (parsedData?.themeStateObject) (0, $k4lqb.setGlobalTheme)(parsedData.themeStateObject);
    }, [
        parsedData?.themeStateObject
    ]);
    return parsedData;
};
module.exports["useConfluencePageData"] = $0848f0766ba8a46c$export$10fb2803bc7b79fc;

});

parcelRegister("f24cK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $aa21c625d0c25974$var$EmbeddedConfluencePageContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $aa21c625d0c25974$export$542af7a009641f95 = $aa21c625d0c25974$var$EmbeddedConfluencePageContext.Provider;
const $aa21c625d0c25974$export$95a59d66783a54b3 = ()=>(0, $cozmU.useContext)($aa21c625d0c25974$var$EmbeddedConfluencePageContext);
module.exports["useEmbeddedConfluencePage"] = $aa21c625d0c25974$export$95a59d66783a54b3;

});

parcelRegister("bhs2L", function(module, exports) {
/**
 * Async factory for the Confluence embed `Page` component.
 *
 * Kept in its own module so `@atlaskit/embedded-confluence/page` is a dynamic
 * import only — hosts that never render a Confluence embed URL do not
 * download this chunk.
 */ 
async function $b32c583ef23c7f79$export$61cc2a15eefecd0b() {
    const { Page: Page } = await (parcelRequire("dpuny"));
    return Page;
}
module.exports["loadEmbeddedConfluencePage"] = $b32c583ef23c7f79$export$61cc2a15eefecd0b;

});

parcelRegister("dpuny", function(module, exports) {

let $9c352cc30cb9c1ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9c352cc30cb9c1ef$var$load("5PKbS"),
    $9c352cc30cb9c1ef$var$load("6wr18"),
    $9c352cc30cb9c1ef$var$load("bm0AN"),
    $9c352cc30cb9c1ef$var$load("9TOep"),
    $9c352cc30cb9c1ef$var$load("7k9oy"),
    $9c352cc30cb9c1ef$var$load("ffEVr"),
    $9c352cc30cb9c1ef$var$load("hhss7"),
    $9c352cc30cb9c1ef$var$load("24IOT")
]).then(()=>parcelRequire('jpl1A'));

});

parcelRegister("cuq2s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $q9Cpn = parcelRequire("q9Cpn");

const $cc5224b9f28cd9ed$export$a54013f0d02a8f82 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, locale: t1, fetchTranslations: fetchTranslations } = t0;
    const incomingLocale = t1 === undefined ? (0, $q9Cpn.DEFAULT_LOCALE) : t1;
    const [messages, setMessages] = (0, $cozmU.useState)();
    let t2;
    if ($[0] !== incomingLocale) {
        t2 = (0, $q9Cpn.normalizeLocale)(incomingLocale);
        $[0] = incomingLocale;
        $[1] = t2;
    } else t2 = $[1];
    const locale = t2;
    let t3;
    let t4;
    if ($[2] !== fetchTranslations || $[3] !== locale) {
        t3 = ()=>{
            const loadTranslations = async ()=>{
                const localeMessages = await fetchTranslations(locale);
                setMessages(localeMessages);
            };
            loadTranslations();
        };
        t4 = [
            fetchTranslations,
            locale
        ];
        $[2] = fetchTranslations;
        $[3] = locale;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (!messages) return null;
    let t5;
    if ($[6] !== children || $[7] !== locale || $[8] !== messages) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: locale,
            messages: messages,
            defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
        }, children);
        $[6] = children;
        $[7] = locale;
        $[8] = messages;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ children: children, locale: incomingLocale = (0, $q9Cpn.DEFAULT_LOCALE), fetchTranslations: fetchTranslations })=>{
    const [messages, setMessages] = (0, $cozmU.useState)();
    const locale = (0, $cozmU.useMemo)(()=>(0, $q9Cpn.normalizeLocale)(incomingLocale), [
        incomingLocale
    ]);
    (0, $cozmU.useEffect)(()=>{
        const loadTranslations = async ()=>{
            const localeMessages = await fetchTranslations(locale);
            setMessages(localeMessages);
        };
        loadTranslations();
    }, [
        fetchTranslations,
        locale
    ]);
    if (!messages) return null;
    // Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
    // They will not function correctly due to a lack of I18n context.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale,
        messages: messages,
        defaultLocale: (0, $q9Cpn.DEFAULT_LOCALE)
    }, children);
};
module.exports["I18nProvider"] = $cc5224b9f28cd9ed$export$a54013f0d02a8f82;

});

parcelRegister("q9Cpn", function(module, exports) {
const $bacd93d5d71e2df6$var$DEFAULT_LANGUAGE = 'en';
const $bacd93d5d71e2df6$var$DEFAULT_REGION = 'US';
const $bacd93d5d71e2df6$export$1af4c7e47ad72f44 = `${$bacd93d5d71e2df6$var$DEFAULT_LANGUAGE}-${$bacd93d5d71e2df6$var$DEFAULT_REGION}`;
const $bacd93d5d71e2df6$var$languageToLongLocaleCode = {
    cs: 'cs-CZ',
    da: 'da-DK',
    de: 'de-DE',
    en: 'en-US',
    es: 'es-ES',
    fi: 'fi-FI',
    fr: 'fr-FR',
    hu: 'hu-HU',
    it: 'it-IT',
    ja: 'ja-JP',
    ko: 'ko-KR',
    // Both `no` and `nb` language codes refer to Norwegian. Refer both to long locale code as `no-NO`
    no: 'no-NO',
    nb: 'no-NO',
    nl: 'nl-NL',
    pl: 'pl-PL',
    ru: 'ru-RU',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN'
};
const $bacd93d5d71e2df6$export$dca0327c9b9c6498 = (locale)=>{
    if (!locale) return $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
    const match = /([a-z]*)[_-]?([A-Z]*)/i.exec(locale);
    if (!match) throw Error('Unable to get language and country from the supplied locale.');
    const [, language, region] = match;
    const normalizedLanguage = (language ?? '').toLowerCase();
    const normalizedRegion = (region ?? '').toUpperCase();
    if (normalizedLanguage && normalizedRegion) return [
        normalizedLanguage,
        normalizedRegion
    ].join('-');
    const longLocaleCode = $bacd93d5d71e2df6$var$languageToLongLocaleCode[normalizedLanguage];
    return longLocaleCode ?? $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
};
module.exports["DEFAULT_LOCALE"] = $bacd93d5d71e2df6$export$1af4c7e47ad72f44;
module.exports["normalizeLocale"] = $bacd93d5d71e2df6$export$dca0327c9b9c6498;

});

parcelRegister("bVevd", function(module, exports) {
var $3914485ee940289d$export$816ef638e478449a = /*#__PURE__*/ function(EMBEDDED_CONFLUENCE_MODE) {
    EMBEDDED_CONFLUENCE_MODE["EDIT_MODE"] = "edit";
    EMBEDDED_CONFLUENCE_MODE["VIEW_MODE"] = "view";
    return EMBEDDED_CONFLUENCE_MODE;
}({});
module.exports["EMBEDDED_CONFLUENCE_MODE"] = $3914485ee940289d$export$816ef638e478449a;

});

parcelRegister("bIcvA", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $jKLZ2 = parcelRequire("jKLZ2");

const $1ec3abac0f6c1bfe$export$865423e6f8e2e839 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)((0, $jKLZ2.PerformanceMetricsContext));
} : ()=>{
    return (0, $cozmU.useContext)((0, $jKLZ2.PerformanceMetricsContext));
};
module.exports["usePerformanceMetrics"] = $1ec3abac0f6c1bfe$export$865423e6f8e2e839;

});

parcelRegister("jKLZ2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $67682ba06b731a04$export$57c7d895214badd4 = /*#__PURE__*/ (0, $cozmU.createContext)({
    isInitialized: false,
    cancelIframeLoadMetrics: ()=>{},
    markIframeLoadMetrics: ()=>{},
    setContentType: ()=>{}
});
module.exports["PerformanceMetricsContext"] = $67682ba06b731a04$export$57c7d895214badd4;

});

parcelRegister("gyfUL", function(module, exports) {

var $fcaWu = parcelRequire("fcaWu");

const $8eb929a208703a52$export$6e43e60d51b79331 = (themeState)=>{
    const themeString = (0, $fcaWu.themeObjectToString)(themeState);
    return encodeURIComponent(themeString);
};
module.exports["themeStateObjectToQueryString"] = $8eb929a208703a52$export$6e43e60d51b79331;

});

parcelRegister("c1Kdq", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $b2f43b4ca89bcf94$export$38df542ff03a4183 = (id)=>{
    return id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID);
};
module.exports["isConfluenceGenerator"] = $b2f43b4ca89bcf94$export$38df542ff03a4183;

});

parcelRegister("4ZxtP", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $4dbfd7f5dbf19ca5$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd?.['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $9EREa.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $9EREa.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};
module.exports["extractMembers"] = $4dbfd7f5dbf19ca5$export$6281d080d62a0719;

});

parcelRegister("6CHZa", function(module, exports) {

var $9EREa = parcelRequire("9EREa");

const $e6695a46069ee43e$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd?.['atlassian:assignedTo'];
    if (assignedTo) return (0, $9EREa.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};
module.exports["extractPersonAssignedTo"] = $e6695a46069ee43e$export$38a0979ebf273662;

});

parcelRegister("3Xkfu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kkFbH = parcelRequire("kkFbH");


var $fBqzD = parcelRequire("fBqzD");


var $iMQz5 = parcelRequire("iMQz5");


var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $gITbz = parcelRequire("gITbz");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");


var $a5G9M = parcelRequire("a5G9M");


var $S7fVP = parcelRequire("S7fVP");


var $hhrxw = parcelRequire("hhrxw");


var $kku4L = parcelRequire("kku4L");


var $g0csk = parcelRequire("g0csk");


var $2A177 = parcelRequire("2A177");


var $2GG3F = parcelRequire("2GG3F");


var $jrSlu = parcelRequire("jrSlu");


var $c1Kdq = parcelRequire("c1Kdq");


var $kAdyG = parcelRequire("kAdyG");

const $f1ce3764841d3d06$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $f1ce3764841d3d06$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $f1ce3764841d3d06$var$getEmptyJsonLd = ()=>$f1ce3764841d3d06$var$emptyData;
const $f1ce3764841d3d06$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $f1ce3764841d3d06$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $f1ce3764841d3d06$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];

const $f1ce3764841d3d06$var$getBlogIconWrapped = ()=>(parcelRequire("6kJW0")).default;

const $f1ce3764841d3d06$var$getDocumentIcon = ()=>(parcelRequire("9v3GN")).default;

const $f1ce3764841d3d06$var$getFileIcon = ()=>(parcelRequire("4Emmj")).default;

const $f1ce3764841d3d06$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("dGdE6")).default;

const $f1ce3764841d3d06$var$getPresentationIcon = ()=>(parcelRequire("b5Dss")).default;

const $f1ce3764841d3d06$var$getSpreadsheetIcon = ()=>(parcelRequire("7vzLW")).default;
const $f1ce3764841d3d06$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $c1Kdq.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $f1ce3764841d3d06$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: opts.showIconLabel ? 'live document' : '',
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $f1ce3764841d3d06$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
        label: opts.showIconLabel ? 'file' : '',
        testId: "file-icon"
    });
};
const $f1ce3764841d3d06$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $f1ce3764841d3d06$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: opts.showIconLabel ? 'blog' : '',
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $f1ce3764841d3d06$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: opts.showIconLabel ? 'document' : '',
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $f1ce3764841d3d06$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: opts.showIconLabel ? 'presentation' : '',
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $f1ce3764841d3d06$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: opts.showIconLabel ? 'spreadsheet' : '',
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: opts.showIconLabel ? 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $f1ce3764841d3d06$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: opts.showIconLabel ? 'document' : '',
                    testId: "document-icon"
                });
            }
    }
};
const $f1ce3764841d3d06$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
        label: "Task",
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $hhrxw.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $hhrxw.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: "Task",
                    testId: "jira-task-icon"
                });
            case 0, $hhrxw.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: "Sub-task",
                    testId: "jira-subtask-icon"
                });
            case 0, $hhrxw.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: "Story",
                    testId: "jira-story-icon"
                });
            case 0, $hhrxw.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: "Bug",
                    testId: "jira-bug-icon"
                });
            case 0, $hhrxw.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: "Epic",
                    testId: "jira-epic-icon"
                });
            case 0, $hhrxw.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: "Incident",
                    testId: "jira-incident-icon"
                });
            case 0, $hhrxw.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: "Service request",
                    testId: "jira-service-request-icon"
                });
            case 0, $hhrxw.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: "Change",
                    testId: "jira-change-icon"
                });
            case 0, $hhrxw.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: "Problem",
                    testId: "jira-problem-icon"
                });
            case 0, $hhrxw.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $f1ce3764841d3d06$var$typeToIcon = (type, opts)=>{
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: "commit",
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: "project",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: "pull request",
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: "reference",
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: "repository",
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: "goal",
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $f1ce3764841d3d06$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $f1ce3764841d3d06$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $f1ce3764841d3d06$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $jrSlu.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $f1ce3764841d3d06$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $f1ce3764841d3d06$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $f1ce3764841d3d06$var$extractIconFromDocument(type, opts);
        default:
            return type ? $f1ce3764841d3d06$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $f1ce3764841d3d06$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        provider: (0, $2A177.extractProvider)(jsonLd),
        fileFormat: $f1ce3764841d3d06$var$extractFileFormat(jsonLd),
        taskType: $f1ce3764841d3d06$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$f1ce3764841d3d06$var$extractorPriorityMap[b] - $f1ce3764841d3d06$var$extractorPriorityMap[a])[0];
        return $f1ce3764841d3d06$var$extractIconByType(highestPriorityType, opts);
    } else return $f1ce3764841d3d06$var$extractIconByType(type, opts);
};
const $f1ce3764841d3d06$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $hhrxw.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $hhrxw.JIRA_GENERATOR_ID)) return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $f1ce3764841d3d06$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $f1ce3764841d3d06$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        const entityIcon = (0, $kku4L.extractEntityIcon)(response);
        if (entityIcon) return [
            entityIcon.url,
            entityIcon.label
        ];
        const provider = (0, $g0csk.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $f1ce3764841d3d06$var$extractInlineIcon(response?.data || $f1ce3764841d3d06$var$getEmptyJsonLd(), showLabel);
};
module.exports["extractSmartLinkInlineIcon"] = $f1ce3764841d3d06$export$643db2ee2409e635;

});

parcelRegister("jrSlu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $hhrxw = parcelRequire("hhrxw");


var $l8WFq = parcelRequire("l8WFq");























const $73d439951cf388f8$var$getLazyIcons = ()=>({
        [(0, $hhrxw.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("9v3GN")))
        },
        [(0, $hhrxw.IconType).Audio]: {
            default: ()=>(parcelRequire("kPWC0"))
        },
        [(0, $hhrxw.IconType).Code]: {
            default: ()=>(parcelRequire("7nVQ2"))
        },
        [(0, $hhrxw.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Folder]: {
            default: ()=>(parcelRequire("9VLzs"))
        },
        [(0, $hhrxw.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("4Emmj")))
        },
        [(0, $hhrxw.IconType).Image]: {
            default: ()=>(parcelRequire("j9LJx"))
        },
        [(0, $hhrxw.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("b5Dss")))
        },
        [(0, $hhrxw.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("7vzLW")))
        },
        [(0, $hhrxw.IconType).Video]: {
            default: ()=>(parcelRequire("96zb4"))
        },
        [(0, $hhrxw.IconType).Archive]: {
            default: ()=>(parcelRequire("8KvsV"))
        },
        [(0, $hhrxw.IconType).Executable]: {
            default: ()=>(parcelRequire("kKj89"))
        },
        [(0, $hhrxw.IconType).GIF]: {
            default: ()=>(parcelRequire("1N5Ke"))
        },
        [(0, $hhrxw.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("7KlQ2"))
        },
        [(0, $hhrxw.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("4D6tQ"))
        },
        [(0, $hhrxw.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("30pMN"))
        },
        [(0, $hhrxw.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("hbVly"))
        },
        [(0, $hhrxw.IconType).MSExcel]: {
            default: ()=>(parcelRequire("5eRas"))
        },
        [(0, $hhrxw.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("bmQsw"))
        },
        [(0, $hhrxw.IconType).MSWord]: {
            default: ()=>(parcelRequire("3tCrI"))
        },
        [(0, $hhrxw.IconType).PDF]: {
            default: ()=>(parcelRequire("eiZGU"))
        },
        [(0, $hhrxw.IconType).Sketch]: {
            default: ()=>(parcelRequire("ldRXm"))
        }
    });
const $73d439951cf388f8$var$getTypeToIconMap = (fileFormat)=>{
    const iconDescriptor = (0, $l8WFq.default)(fileFormat);
    if (!iconDescriptor?.icon) return null;
    const lazyIcons = $73d439951cf388f8$var$getLazyIcons();
    return [
        lazyIcons[iconDescriptor.icon]?.default,
        iconDescriptor.label ?? ''
    ];
};
const $73d439951cf388f8$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $73d439951cf388f8$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
        __loadable_id__: "hbd6r",
        name: "Icon",
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    const descriptorLabel = icon[1] || '';
    const label = showIconLabel ?? true ? descriptorLabel : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
        testId: "document-file-format-icon",
        label: label
    });
};
module.exports["getIconForFileType"] = $73d439951cf388f8$export$4d685c85ebc7a1e3;

});

parcelRegister("l8WFq", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $eb169b73453c71b7$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $hhrxw.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $hhrxw.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $hhrxw.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $hhrxw.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $hhrxw.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $hhrxw.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $hhrxw.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $hhrxw.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $hhrxw.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $hhrxw.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $hhrxw.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $hhrxw.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $hhrxw.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $hhrxw.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $hhrxw.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $hhrxw.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $hhrxw.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $eb169b73453c71b7$export$2e2bcd8739ae039 = $eb169b73453c71b7$var$extractFileFormatIcon;
module.exports["default"] = $eb169b73453c71b7$export$2e2bcd8739ae039;

});

parcelRegister("kPWC0", function(module, exports) {

let $f2b60935c73a6c05$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f2b60935c73a6c05$var$load("gkVge"),
    $f2b60935c73a6c05$var$load("hLbGw")
]).then(()=>parcelRequire('hyaPI'));

});

parcelRegister("7nVQ2", function(module, exports) {

let $56078bdb4bba4b6f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56078bdb4bba4b6f$var$load("kDfOJ").then(()=>parcelRequire('gMML3'));

});

parcelRegister("9VLzs", function(module, exports) {

let $73ae5688c13ac7f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $73ae5688c13ac7f1$var$load("6wr18"),
    $73ae5688c13ac7f1$var$load("ffEVr"),
    $73ae5688c13ac7f1$var$load("iN2uJ")
]).then(()=>parcelRequire('giuMD'));

});

parcelRegister("j9LJx", function(module, exports) {

let $df23e277716dc04b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $df23e277716dc04b$var$load("6wr18"),
    $df23e277716dc04b$var$load("ffEVr"),
    $df23e277716dc04b$var$load("6aZeI")
]).then(()=>parcelRequire('4b38C'));

});

parcelRegister("96zb4", function(module, exports) {

let $6a0ff61f5e39486f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6a0ff61f5e39486f$var$load("6wr18"),
    $6a0ff61f5e39486f$var$load("ffEVr"),
    $6a0ff61f5e39486f$var$load("8TGE7")
]).then(()=>parcelRequire('8aT6O'));

});

parcelRegister("8KvsV", function(module, exports) {

let $65eb06ff5571b2cc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $65eb06ff5571b2cc$var$load("5JWJI").then(()=>parcelRequire('iqehY'));

});

parcelRegister("kKj89", function(module, exports) {

let $f1a6f16f6403b629$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f1a6f16f6403b629$var$load("aQ5uu").then(()=>parcelRequire('3OVVx'));

});

parcelRegister("1N5Ke", function(module, exports) {

let $14ded2ce3ce05390$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $14ded2ce3ce05390$var$load("geXPZ").then(()=>parcelRequire('EhIdb'));

});

parcelRegister("7KlQ2", function(module, exports) {

let $5a3dc4e9d091ba35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5a3dc4e9d091ba35$var$load("b4nm1").then(()=>parcelRequire('hmd8r'));

});

parcelRegister("4D6tQ", function(module, exports) {

let $35efd4ccf002d2a8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35efd4ccf002d2a8$var$load("jfYeU").then(()=>parcelRequire('lLxTI'));

});

parcelRegister("30pMN", function(module, exports) {

let $23055fbb4908668b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $23055fbb4908668b$var$load("kYkz1").then(()=>parcelRequire('kUQwC'));

});

parcelRegister("hbVly", function(module, exports) {

let $c83ff29c592bd62f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c83ff29c592bd62f$var$load("5kI0b").then(()=>parcelRequire('1G3Dq'));

});

parcelRegister("5eRas", function(module, exports) {

let $3d078090de5174e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3d078090de5174e1$var$load("3i44s").then(()=>parcelRequire('1kVaD'));

});

parcelRegister("bmQsw", function(module, exports) {

let $846a710eb4b35adb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $846a710eb4b35adb$var$load("4QwAJ").then(()=>parcelRequire('aeJll'));

});

parcelRegister("3tCrI", function(module, exports) {

let $2881e71a7d44971f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2881e71a7d44971f$var$load("fHlIz").then(()=>parcelRequire('8If3N'));

});

parcelRegister("eiZGU", function(module, exports) {

let $a6a299b1e4e47c5f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a6a299b1e4e47c5f$var$load("aaRXj").then(()=>parcelRequire('8B1YK'));

});

parcelRegister("ldRXm", function(module, exports) {

let $f734aa7c232eacf4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f734aa7c232eacf4$var$load("6OMo6").then(()=>parcelRequire('AzmWu'));

});

parcelRegister("6kJW0", function(module, exports) {

var $iW3KC = parcelRequire("iW3KC");


var $ai0Ge = parcelRequire("ai0Ge");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $616e4ede6f48d352$var$BlogIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $iW3KC.default), (0, $ai0Ge.default));
$616e4ede6f48d352$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $616e4ede6f48d352$export$2e2bcd8739ae039 = $616e4ede6f48d352$var$BlogIconWithColor;
module.exports["default"] = $616e4ede6f48d352$export$2e2bcd8739ae039;

});

parcelRegister("eqhrF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hhrxw = parcelRequire("hhrxw");

const $ef7997acb045a8f6$var$isIconSizeLarge = (size)=>size && [
        (0, $hhrxw.SmartLinkSize).Large,
        (0, $hhrxw.SmartLinkSize).XLarge
    ].includes(size);
const $ef7997acb045a8f6$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($ef7997acb045a8f6$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ObjectIcon, props);
    };
};
module.exports["renderIconPerSize"] = $ef7997acb045a8f6$export$28dd5ad82647c000;

});

parcelRegister("9v3GN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $hMaHH = parcelRequire("hMaHH");


var $9D4WS = parcelRequire("9D4WS");

const $fc0d527adbaaccfa$var$PageIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))), 'blueBold');
$fc0d527adbaaccfa$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $fc0d527adbaaccfa$export$2e2bcd8739ae039 = $fc0d527adbaaccfa$var$PageIconWithColor;
module.exports["default"] = $fc0d527adbaaccfa$export$2e2bcd8739ae039;

});

parcelRegister("9D4WS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lSQgn = parcelRequire("lSQgn");


var $6nWVS = parcelRequire("6nWVS");

const $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $eb6ec3e0096439cb$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $6nWVS.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                color: $eb6ec3e0096439cb$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};
module.exports["renderIconTile"] = $eb6ec3e0096439cb$export$87c3646d0e299cfe;

});

parcelRegister("6nWVS", function(module, exports) {

var $hhrxw = parcelRequire("hhrxw");

const $7fb62870d007a2a2$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $hhrxw.SmartLinkSize).Small:
        case (0, $hhrxw.SmartLinkSize).Medium:
            return undefined;
        case (0, $hhrxw.SmartLinkSize).XLarge:
        case (0, $hhrxw.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};
module.exports["transformSmartLinkSizeToIconTileSize"] = $7fb62870d007a2a2$export$3acc3fb10995f020;

});

parcelRegister("4Emmj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $kkFbH = parcelRequire("kkFbH");


var $9D4WS = parcelRequire("9D4WS");

const $30795df12c6626e4$var$FileIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), 'grayBold');
$30795df12c6626e4$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $30795df12c6626e4$export$2e2bcd8739ae039 = $30795df12c6626e4$var$FileIconWithColor;
module.exports["default"] = $30795df12c6626e4$export$2e2bcd8739ae039;

});

parcelRegister("dGdE6", function(module, exports) {

var $7pJjg = parcelRequire("7pJjg");


var $dipyx = parcelRequire("dipyx");


var $eqhrF = parcelRequire("eqhrF");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $c10f705a5270d647$var$LiveDocumentIconWithColor = (0, $eqhrF.renderIconPerSize)((0, $7pJjg.default), (0, $dipyx.default));
$c10f705a5270d647$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $c10f705a5270d647$export$2e2bcd8739ae039 = $c10f705a5270d647$var$LiveDocumentIconWithColor;
module.exports["default"] = $c10f705a5270d647$export$2e2bcd8739ae039;

});

parcelRegister("b5Dss", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $gJ798 = parcelRequire("gJ798");


var $9D4WS = parcelRequire("9D4WS");

// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $77093538826d7e25$var$ChartBarIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($gJ798))), 'purpleBold');
$77093538826d7e25$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $77093538826d7e25$export$2e2bcd8739ae039 = $77093538826d7e25$var$ChartBarIconWithColor;
module.exports["default"] = $77093538826d7e25$export$2e2bcd8739ae039;

});

parcelRegister("7vzLW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $3fO5l = parcelRequire("3fO5l");


var $9D4WS = parcelRequire("9D4WS");

const $7d25c80ed1a76c0d$var$ListBulletedIconWithColor = (0, $9D4WS.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3fO5l))), 'greenBold');
$7d25c80ed1a76c0d$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $7d25c80ed1a76c0d$export$2e2bcd8739ae039 = $7d25c80ed1a76c0d$var$ListBulletedIconWithColor;
module.exports["default"] = $7d25c80ed1a76c0d$export$2e2bcd8739ae039;

});

parcelRegister("9f1Yt", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");

const $ec1ab019c54e6386$var$useContextMemoized = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useContextMemoized(reactContext) {
    const $ = (0, $bDgLe.c)(4);
    const value = (0, $cozmU.useContext)(reactContext);
    let t0;
    if ($[0] !== reactContext.Consumer || $[1] !== reactContext.Provider || $[2] !== value) {
        t0 = {
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        };
        $[0] = reactContext.Consumer;
        $[1] = reactContext.Provider;
        $[2] = value;
        $[3] = t0;
    } else t0 = $[3];
    const context = t0;
    return context;
} : function useContextMemoized(reactContext) {
    const value = (0, $cozmU.useContext)(reactContext);
    const context = (0, $cozmU.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
};
const $ec1ab019c54e6386$export$10e9cca30e50f657 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $ec1ab019c54e6386$var$useContextMemoized((0, $cMyWi.SmartCardContext));
} : ()=>$ec1ab019c54e6386$var$useContextMemoized((0, $cMyWi.SmartCardContext));
module.exports["useSmartCardContext"] = $ec1ab019c54e6386$export$10e9cca30e50f657;

});

parcelRegister("11zX6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $fa07988e74fc1b7d$export$8f5a73ba0d077b01 = 32;
class $fa07988e74fc1b7d$export$3482036c37e627f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    componentDidMount() {
        window.addEventListener('message', this.messageCallback);
    }
    componentWillUnmount() {
        window.removeEventListener('message', this.messageCallback);
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.messageCallback = (event)=>{
            const { embedIframeRef: embedIframeRef } = this.props;
            const isFromExpectedIframe = embedIframeRef.current && event.source === embedIframeRef.current.contentWindow;
            const isStringData = typeof event.data === 'string';
            if (isFromExpectedIframe && isStringData) try {
                const data = JSON.parse(event.data);
                if (data.method === 'resize' && typeof data.height === 'number') this.onEmbedHeightChange({
                    height: data.height
                });
            } catch (e) {}
        };
        this.onEmbedHeightChange = (data)=>{
            const { onHeightUpdate: onHeightUpdate } = this.props;
            const height = data.height + $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
            onHeightUpdate(height);
        };
    }
}
module.exports["embedHeaderHeight"] = $fa07988e74fc1b7d$export$8f5a73ba0d077b01;
module.exports["EmbedResizeMessageListener"] = $fa07988e74fc1b7d$export$3482036c37e627f4;

});

parcelRegister("gbf0M", function(module, exports) {
const $5ba4766046c2d106$export$1de3504963fc32f2 = (datasource, url)=>{
    return {
        type: 'blockCard',
        attrs: {
            url: url,
            datasource: datasource
        }
    };
};
module.exports["buildDatasourceAdf"] = $5ba4766046c2d106$export$1de3504963fc32f2;

});

parcelRegister("3u1Hp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $lPEt0 = parcelRequire("lPEt0");


var $bI14T = parcelRequire("bI14T");


var $j39Hd = parcelRequire("j39Hd");


var $c7dFC = parcelRequire("c7dFC");

const $adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE = 50;
const $adf5b0efff0513f5$export$f82fcd766a8daa7f = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$40b1dd31340bd5c2 = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$15cd58682efec5a5 = new (0, $lPEt0.LRUMap)($adf5b0efff0513f5$var$URL_RESPONSE_CACHE_SIZE);
const $adf5b0efff0513f5$export$5e074c0b68e2ce03 = 20;
const $adf5b0efff0513f5$export$7d812bb756889442 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(13);
    const { connections: t0 } = (0, $bI14T.useSmartLinkContext)();
    const { client: client } = t0;
    const resolverUrl = (0, $c7dFC.useResolverUrl)(client);
    const cachedRequest = $adf5b0efff0513f5$var$_temp;
    const uncachedRequest = $adf5b0efff0513f5$var$_temp2;
    let t1;
    if ($[0] !== resolverUrl) {
        t1 = async (datasourceId, data_1, t2)=>{
            const force_0 = t2 === undefined ? false : t2;
            return cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $adf5b0efff0513f5$export$f82fcd766a8daa7f, force_0);
        };
        $[0] = resolverUrl;
        $[1] = t1;
    } else t1 = $[1];
    const getDatasourceDetails = t1;
    let t2;
    if ($[2] !== resolverUrl) {
        t2 = async (datasourceId_0, data_2, t3)=>{
            const force_1 = t3 === undefined ? false : t3;
            return cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $adf5b0efff0513f5$export$40b1dd31340bd5c2, force_1);
        };
        $[2] = resolverUrl;
        $[3] = t2;
    } else t2 = $[3];
    const getDatasourceData = t2;
    let t3;
    if ($[4] !== resolverUrl) {
        t3 = async (data_3, t4)=>{
            const force_2 = t4 === undefined ? false : t4;
            const resolvedCacheIdKey = "datasourceId" in data_3 ? data_3.datasourceId : data_3.integrationKey;
            if (!resolvedCacheIdKey) throw new Error("No target was supplied to retrieve actions for");
            return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $adf5b0efff0513f5$export$15cd58682efec5a5, force_2);
        };
        $[4] = resolverUrl;
        $[5] = t3;
    } else t3 = $[5];
    const getDatasourceActionsAndPermissions = t3;
    let t4;
    if ($[6] !== resolverUrl) {
        t4 = async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`);
        $[6] = resolverUrl;
        $[7] = t4;
    } else t4 = $[7];
    const executeAtomicAction = t4;
    const invalidateDatasourceDataCacheByAri = $adf5b0efff0513f5$var$_temp3;
    let t5;
    if ($[8] !== executeAtomicAction || $[9] !== getDatasourceActionsAndPermissions || $[10] !== getDatasourceData || $[11] !== getDatasourceDetails) {
        t5 = {
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        };
        $[8] = executeAtomicAction;
        $[9] = getDatasourceActionsAndPermissions;
        $[10] = getDatasourceData;
        $[11] = getDatasourceDetails;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ()=>{
    const { connections: { client: client } } = (0, $bI14T.useSmartLinkContext)();
    const resolverUrl = (0, $c7dFC.useResolverUrl)(client);
    const cachedRequest = async (cacheKeyId, data, url, lruMap, force)=>{
        const cacheKeyData = {
            ...data,
            // Sort fields to use cached version of response regardless of the order
            ...'fields' in data ? {
                fields: [
                    ...data.fields || []
                ].sort()
            } : {},
            ...'fieldKeys' in data ? {
                fieldKeys: [
                    ...data.fieldKeys || []
                ].sort()
            } : {}
        };
        const cacheKey = JSON.stringify({
            cacheKeyId: cacheKeyId,
            cacheKeyData: cacheKeyData
        });
        if (force) lruMap.delete(cacheKey);
        let responsePromise = lruMap.get(cacheKey);
        if (responsePromise) return responsePromise;
        const headers = {
            /**
       * This header exists to enable the backend to process relative time, eg: "today", with respect to user timezone.
       * eg: used in "confluence-object-provider" to process confluence SLLV requests to filter data for relative time.
       */ 'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
        };
        try {
            responsePromise = (0, $j39Hd.request)('post', url, data, headers, [
                200,
                201,
                202,
                203,
                204
            ]);
            lruMap.set(cacheKey, responsePromise);
            return await responsePromise;
        } catch (e) {
            lruMap.delete(cacheKey);
            throw e;
        }
    };
    const uncachedRequest = async (data_0, url_0)=>{
        const responsePromise_0 = (0, $j39Hd.request)('post', url_0, data_0, undefined, [
            200,
            201,
            202,
            203,
            204
        ]);
        return responsePromise_0;
    };
    const getDatasourceDetails = (0, $cozmU.useCallback)(async (datasourceId, data_1, force_0 = false)=>cachedRequest(datasourceId, data_1, `${resolverUrl}/datasource/${datasourceId}/fetch/details`, $adf5b0efff0513f5$export$f82fcd766a8daa7f, force_0), [
        resolverUrl
    ]);
    const getDatasourceData = (0, $cozmU.useCallback)(async (datasourceId_0, data_2, force_1 = false)=>cachedRequest(datasourceId_0, data_2, `${resolverUrl}/datasource/${datasourceId_0}/fetch/data`, $adf5b0efff0513f5$export$40b1dd31340bd5c2, force_1), [
        resolverUrl
    ]);
    const getDatasourceActionsAndPermissions = (0, $cozmU.useCallback)(async (data_3, force_2 = false)=>{
        const resolvedCacheIdKey = 'datasourceId' in data_3 ? data_3.datasourceId : data_3.integrationKey;
        // This is just to prevent empty string being passed up to ORS and causing issues.
        if (!resolvedCacheIdKey) throw new Error('No target was supplied to retrieve actions for');
        return cachedRequest(resolvedCacheIdKey, data_3, `${resolverUrl}/actions`, $adf5b0efff0513f5$export$15cd58682efec5a5, force_2);
    }, [
        resolverUrl
    ]);
    const executeAtomicAction = (0, $cozmU.useCallback)(async (data_4)=>uncachedRequest(data_4, `${resolverUrl}/actions/execute`), [
        resolverUrl
    ]);
    const invalidateDatasourceDataCacheByAri = (0, $cozmU.useCallback)((ari)=>{
        $adf5b0efff0513f5$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
            const response = await value;
            const targetFound = response.data.items.some((item)=>{
                return item['ari']?.data === ari;
            });
            if (targetFound) $adf5b0efff0513f5$export$40b1dd31340bd5c2.delete(key);
        });
    }, []);
    return (0, $cozmU.useMemo)(()=>({
            getDatasourceDetails: getDatasourceDetails,
            getDatasourceData: getDatasourceData,
            getDatasourceActionsAndPermissions: getDatasourceActionsAndPermissions,
            executeAtomicAction: executeAtomicAction,
            invalidateDatasourceDataCacheByAri: invalidateDatasourceDataCacheByAri
        }), [
        getDatasourceDetails,
        getDatasourceData,
        getDatasourceActionsAndPermissions,
        executeAtomicAction,
        invalidateDatasourceDataCacheByAri
    ]);
};
async function $adf5b0efff0513f5$var$_temp(cacheKeyId, data, url, lruMap, force) {
    const cacheKeyData = {
        ...data,
        ..."fields" in data ? {
            fields: [
                ...data.fields || []
            ].sort()
        } : {},
        ..."fieldKeys" in data ? {
            fieldKeys: [
                ...data.fieldKeys || []
            ].sort()
        } : {}
    };
    const cacheKey = JSON.stringify({
        cacheKeyId: cacheKeyId,
        cacheKeyData: cacheKeyData
    });
    if (force) lruMap.delete(cacheKey);
    let responsePromise = lruMap.get(cacheKey);
    if (responsePromise) return responsePromise;
    const headers = {
        "origin-timezone": Intl?.DateTimeFormat().resolvedOptions().timeZone
    };
    try {
        responsePromise = (0, $j39Hd.request)("post", url, data, headers, [
            200,
            201,
            202,
            203,
            204
        ]);
        lruMap.set(cacheKey, responsePromise);
        return await responsePromise;
    } catch (t0) {
        const e = t0;
        lruMap.delete(cacheKey);
        throw e;
    }
}
async function $adf5b0efff0513f5$var$_temp2(data_0, url_0) {
    const responsePromise_0 = (0, $j39Hd.request)("post", url_0, data_0, undefined, [
        200,
        201,
        202,
        203,
        204
    ]);
    return responsePromise_0;
}
function $adf5b0efff0513f5$var$_temp3(ari) {
    $adf5b0efff0513f5$export$40b1dd31340bd5c2.forEach(async (value, key)=>{
        const response = await value;
        const targetFound = response.data.items.some((item)=>item.ari?.data === ari);
        if (targetFound) $adf5b0efff0513f5$export$40b1dd31340bd5c2.delete(key);
    });
}
module.exports["DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE"] = $adf5b0efff0513f5$export$5e074c0b68e2ce03;
module.exports["useDatasourceClientExtension"] = $adf5b0efff0513f5$export$7d812bb756889442;

});

parcelRegister("ez93V", function(module, exports) {

var $aqP4n = parcelRequire("aqP4n");

function $1d3bee4bc8d0b319$export$945a571f3b658bf(userData) {
    return userData[0, $aqP4n.uniqueKey] ?? null;
}
module.exports["extractClosestEdge"] = $1d3bee4bc8d0b319$export$945a571f3b658bf;

});

parcelRegister("aqP4n", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 

const $03a217ae6d97834d$export$4032e2468b38573b = Symbol('closestEdge');
module.exports["uniqueKey"] = $03a217ae6d97834d$export$4032e2468b38573b;

});

parcelRegister("endUL", function(module, exports) {

var $aqP4n = parcelRequire("aqP4n");

const $027caaee38fbe080$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
function $027caaee38fbe080$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $027caaee38fbe080$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [(0, $aqP4n.uniqueKey)]: addClosestEdge
    };
}
module.exports["attachClosestEdge"] = $027caaee38fbe080$export$f0cafff222395e89;

});

parcelRegister("cIWiw", function(module, exports) {
// In order to disable the native drag preview you can
// use `event.dataTransfer.setDragImage()` to set a small
// invisible image as the drag preview.
// There are alternative techniques,
// (eg setting opacity to in onGenerateDragPreview and then 1 in onDragStart)
// but the technique in this file worked best across browsers and platforms
// Here we are preloading the image so that it is ready for the first drag.
// Even though the image is base64 encoded, the browser queues an async task
// to decode the image. The image needs to be decoded before it can be used
const $8d2daf016c36a388$var$tinyTransparentImage = (()=>{
    // SSR safe
    if (typeof window === 'undefined') return null;
    // Image generated by: https://png-pixel.com/
    // It is a 1x1 transparent gif
    // It is the smallest possible transparent image we could find that works on all platforms
    // Note: using an encoded SVG would be nicer code, but it doesn't work on iOS
    const img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
    return img;
})();
function $8d2daf016c36a388$export$c588cb30ff3b876e({ nativeSetDragImage: nativeSetDragImage }) {
    if (nativeSetDragImage && $8d2daf016c36a388$var$tinyTransparentImage) nativeSetDragImage($8d2daf016c36a388$var$tinyTransparentImage, 0, 0);
}
module.exports["disableNativeDragPreview"] = $8d2daf016c36a388$export$c588cb30ff3b876e;

});

parcelRegister("1Ltep", function(module, exports) {
$parcel$export(module.exports, "default", () => $1490daf4e920e8da$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $1490daf4e920e8da$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("2iY37", function(module, exports) {
$parcel$export(module.exports, "default", () => $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $1Ltep = parcelRequire("1Ltep");


var $WeoLw = parcelRequire("WeoLw");


var $3yGK6 = parcelRequire("3yGK6");

function $1adbd7c5d1b8dbaa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    return (0, $1Ltep.default)(date).getTime() === (0, $WeoLw.default)(date).getTime();
}

});

parcelRegister("WeoLw", function(module, exports) {
$parcel$export(module.exports, "default", () => $0af0962005736f62$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $0af0962005736f62$export$2e2bcd8739ae039(dirtyDate) {
    (0, $3yGK6.default)(1, arguments);
    var date = (0, $dkBOe.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("f21H2", function(module, exports) {

var $2xwXF = parcelRequire("2xwXF");


var $9H66G = parcelRequire("9H66G");


var $dz9dk = parcelRequire("dz9dk");

/**
 * Returns the resolved destination URL for a Smart Link, with cross-product analytics
 * parameters appended when applicable.
 *
 * This is the same URL that SmartCard would navigate to when clicked. Use this as an `href`
 * wherever you render a link to a Smart Link URL outside of the SmartCard component itself
 * (e.g. toolbar buttons, overlays).
 *
 * Falls back to the raw `url` when:
 * - The link has not yet resolved
 * - The link is not a first-party Atlassian link
 *
 * @example
 * const href = useSmartLinkDestinationUrl(url);
 *
 * Use as <a href={href} target="_blank">Open link</a>
 */ const $4f8ab10692e6efbc$export$30500dfe8339eafd = (url)=>{
    const state = (0, $9H66G.useSmartCardState)(url);
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapper)({
        details: state.details
    });
    const resolvedUrl = (0, $2xwXF.getClickUrl)(url, state.details);
    return appendCrossProductAnalyticsParams(resolvedUrl);
};
module.exports["useSmartLinkDestinationUrl"] = $4f8ab10692e6efbc$export$30500dfe8339eafd;

});

parcelRegister("FCr1g", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6cFsl = parcelRequire("6cFsl");


var $gTPfK = parcelRequire("gTPfK");


var $5vxGz = parcelRequire("5vxGz");


var $gP3OS = parcelRequire("gP3OS");


var $f9V4A = parcelRequire("f9V4A");


var $9zzXV = parcelRequire("9zzXV");


var $8PMs6 = parcelRequire("8PMs6");

const $7e29c9d08f4780f4$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $7e29c9d08f4780f4$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    (0, $6cFsl.di)((0, $8PMs6.useLinkWarningModal));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $8PMs6.useLinkWarningModal)();
    const Link = enableResolve ? (0, $f9V4A.HyperlinkWithSmartLinkResolver) : (0, $gP3OS.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5vxGz.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Link, {
        href: href,
        testId: testId,
        isLinkComponent: isLinkComponent,
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zzXV.default), linkWarningModalProps));
};
const $7e29c9d08f4780f4$export$56ff87f78018e459 = (0, $gTPfK.default)($7e29c9d08f4780f4$var$PACKAGE_DATA)($7e29c9d08f4780f4$var$LinkUrl);
var $7e29c9d08f4780f4$export$2e2bcd8739ae039 = $7e29c9d08f4780f4$export$56ff87f78018e459;
module.exports["default"] = $7e29c9d08f4780f4$export$2e2bcd8739ae039;
module.exports["LinkUrl"] = $7e29c9d08f4780f4$export$56ff87f78018e459;

});

parcelRegister("5vxGz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $gBjHb = parcelRequire("gBjHb");

const $0dac8e28bd4768d5$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};
module.exports["LinkAnalyticsContext"] = $0dac8e28bd4768d5$export$9458cdec663b9ff1;

});

parcelRegister("gP3OS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $i1t43 = parcelRequire("i1t43");


var $4U66S = parcelRequire("4U66S");

const $e65fa6f33c1f6a41$var$Anchor = (0, $4U66S.withLinkClickedEvent)('a');
const $e65fa6f33c1f6a41$export$8c0773eab230d49e = (0, $4U66S.withLinkClickedEvent)((0, $i1t43.default));
const $e65fa6f33c1f6a41$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $e65fa6f33c1f6a41$export$8c0773eab230d49e : $e65fa6f33c1f6a41$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $e65fa6f33c1f6a41$export$2e2bcd8739ae039 = $e65fa6f33c1f6a41$var$Hyperlink;
module.exports["default"] = $e65fa6f33c1f6a41$export$2e2bcd8739ae039;

});

parcelRegister("4U66S", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3tPPd = parcelRequire("3tPPd");


var $eTTRx = parcelRequire("eTTRx");

const $95965a2043984aeb$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $95965a2043984aeb$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $3tPPd.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $eTTRx.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$95965a2043984aeb$var$getDisplayName(WrappedComponent)})`;
    return Component;
}
module.exports["withLinkClickedEvent"] = $95965a2043984aeb$export$263352d59c0c5966;

});

parcelRegister("f9V4A", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $kSwu1 = parcelRequire("kSwu1");


var $1QgxA = parcelRequire("1QgxA");


var $bILQy = parcelRequire("bILQy");


var $ghRKQ = parcelRequire("ghRKQ");


var $i1cin = parcelRequire("i1cin");


var $1smAh = parcelRequire("1smAh");


var $74G10 = parcelRequire("74G10");


var $iTXC0 = parcelRequire("iTXC0");


var $bBlRc = parcelRequire("bBlRc");


var $gP3OS = parcelRequire("gP3OS");

const $8c346d0f6a4e60f0$var$HyperlinkFallbackComponent = ()=>null;
const $8c346d0f6a4e60f0$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $i1cin.default)(props?.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1smAh.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DefaultComponent, props);
    };
const $8c346d0f6a4e60f0$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { state: state } = (0, $ghRKQ.default)({
        href: props.href || ''
    });
    const thirdPartyARI = (0, $bILQy.getThirdPartyARI)(state?.details);
    const firstPartyIdentifier = (0, $1QgxA.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $bBlRc.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI);
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = state?.status === 'resolved' && fire3PClickEvent;
    const onClick = (0, $cozmU.useCallback)((e)=>{
        // button === 0 is left-click, see
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        if (shouldFire3PClickEvent && e?.button === 0) fire3PClickEvent?.();
        onClickCallback?.(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const onAuxClick = (0, $cozmU.useCallback)((e)=>{
        // isAuxClick guards against Windows right-clicks firing onAuxClick with button === 2.
        if ((0, $74G10.isAuxClick)(e) && shouldFire3PClickEvent) fire3PClickEvent?.({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    const onContextMenu = (0, $cozmU.useCallback)((_e)=>{
        if (shouldFire3PClickEvent) fire3PClickEvent?.({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        shouldFire3PClickEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gP3OS.default), {
        ...props,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu
    });
};
const $8c346d0f6a4e60f0$export$1fdb4f77fe528a52 = (0, $9EOlJ.withErrorBoundary)($8c346d0f6a4e60f0$var$withValidator((0, $kSwu1.injectIntl)((0, $iTXC0.default)($8c346d0f6a4e60f0$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $gP3OS.default)), {
    FallbackComponent: $8c346d0f6a4e60f0$var$HyperlinkFallbackComponent
});
module.exports["HyperlinkWithSmartLinkResolver"] = $8c346d0f6a4e60f0$export$1fdb4f77fe528a52;

});

parcelRegister("ghRKQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $6Vsq4 = parcelRequire("6Vsq4");


var $a2fMD = parcelRequire("a2fMD");


var $e0XNb = parcelRequire("e0XNb");


var $6kVBl = parcelRequire("6kVBl");


var $iUTeb = parcelRequire("iUTeb");


var $h5RL7 = parcelRequire("h5RL7");


var $fXZFy = parcelRequire("fXZFy");


var $fggeM = parcelRequire("fggeM");


var $9H66G = parcelRequire("9H66G");


var $ctCbd = parcelRequire("ctCbd");

const $050418cc7e2bcf13$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $cozmU.useState)(()=>(0, $03RpJ.default)());
    const state = (0, $9H66G.useSmartCardState)(href);
    const definitionId = (0, $h5RL7.getDefinitionId)(state.details);
    const extensionKey = (0, $fXZFy.getExtensionKey)(state.details);
    const resourceType = (0, $fggeM.getResourceType)(state.details);
    const actions = (0, $iUTeb.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $ctCbd.useScheduledRegister)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $cozmU.useEffect)(()=>{
        (0, $6kVBl.mark)(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            (0, $a2fMD.create)(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.hyperlink.resolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                duration: (0, $e0XNb.getMeasure)(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError' && state.error?.name !== 'InvalidUrlError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $050418cc7e2bcf13$export$2e2bcd8739ae039 = $050418cc7e2bcf13$var$useResolveHyperlink;
module.exports["default"] = $050418cc7e2bcf13$export$2e2bcd8739ae039;

});

parcelRegister("ctCbd", function(module, exports) {
/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 
var $cozmU = parcelRequire("cozmU");

const $20ef44f951ebdbd7$var$batchQueue = new Map();
const $20ef44f951ebdbd7$var$batchTimeouts = new Map();
const $20ef44f951ebdbd7$var$BATCH_DELAY = 250;
const $20ef44f951ebdbd7$var$executeBatch = (hostname)=>{
    const items = $20ef44f951ebdbd7$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $20ef44f951ebdbd7$var$batchQueue.delete(hostname);
    $20ef44f951ebdbd7$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $20ef44f951ebdbd7$var$addToBatch = (hostname, item)=>{
    if (!$20ef44f951ebdbd7$var$batchQueue.has(hostname)) $20ef44f951ebdbd7$var$batchQueue.set(hostname, []);
    $20ef44f951ebdbd7$var$batchQueue.get(hostname).push(item);
    if ($20ef44f951ebdbd7$var$batchTimeouts.has(hostname)) clearTimeout($20ef44f951ebdbd7$var$batchTimeouts.get(hostname));
    $20ef44f951ebdbd7$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $20ef44f951ebdbd7$var$executeBatch(hostname);
    }, $20ef44f951ebdbd7$var$BATCH_DELAY));
};
const $20ef44f951ebdbd7$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $cozmU.useRef)(false);
    const scheduledRegister = (0, $cozmU.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $20ef44f951ebdbd7$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};
module.exports["useScheduledRegister"] = $20ef44f951ebdbd7$export$db80d61271e4d5af;

});

parcelRegister("i1cin", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cMyWi = parcelRequire("cMyWi");


var $37IZ6 = parcelRequire("37IZ6");

const $28358ca6314c1f35$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $cozmU.useContext)((0, $cMyWi.SmartCardContext));
    return hasSmartCardProvider && (0, $37IZ6.shouldResolveUrl)(href);
};
var $28358ca6314c1f35$export$2e2bcd8739ae039 = $28358ca6314c1f35$var$useResolveHyperlinkValidator;
module.exports["default"] = $28358ca6314c1f35$export$2e2bcd8739ae039;

});

parcelRegister("37IZ6", function(module, exports) {
const $bb6836473cabc3cc$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $bb6836473cabc3cc$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $bb6836473cabc3cc$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
module.exports["shouldResolveUrl"] = $bb6836473cabc3cc$export$aa45d36a96427452;

});

parcelRegister("iTXC0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

/**
 * HOC to wrap component with IntlProvider if not available
 */ const $e4973c7a2a00742d$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props);
        return props?.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            locale: "en"
        }, content);
    };
var $e4973c7a2a00742d$export$2e2bcd8739ae039 = $e4973c7a2a00742d$var$withIntlProvider;
module.exports["default"] = $e4973c7a2a00742d$export$2e2bcd8739ae039;

});

parcelRegister("9zzXV", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $i1t43 = parcelRequire("i1t43");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $aRGok = parcelRequire("aRGok");


var $dM7c5 = parcelRequire("dM7c5");

const $9f95697db7fee4b3$var$breakWordsCss = null;
const $9f95697db7fee4b3$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $aRGok.default), null, isOpen && /*#__PURE__*/ $cozmU.createElement((0, $7aRdF.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $cozmU.createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $jq995.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).check_this_link))), /*#__PURE__*/ $cozmU.createElement((0, $fEPJS.default), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1ANEUS77fC _3W2Oc84hR5"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $cozmU.createElement((0, $eQiT1.default), null, /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).go_back)), /*#__PURE__*/ $cozmU.createElement((0, $7ZB0A.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.IntlProvider), {
        locale: "en"
    }, content);
};
const $9f95697db7fee4b3$var$_default_1 = (0, $kSwu1.injectIntl)($9f95697db7fee4b3$var$WarningModal, {
    enforceContext: false
});
var $9f95697db7fee4b3$export$2e2bcd8739ae039 = $9f95697db7fee4b3$var$_default_1;
module.exports["default"] = $9f95697db7fee4b3$export$2e2bcd8739ae039;

});

parcelRegister("8PMs6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $e6CqH = parcelRequire("e6CqH");


var $6GOAK = parcelRequire("6GOAK");

const $3eb490168d2cba0d$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $3eb490168d2cba0d$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $cozmU.useState)(null);
    const [url, setUrl] = (0, $cozmU.useState)(null);
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $6GOAK.ANALYTICS_CHANNEL));
    };
    /**
   * It checks and warns if a link text is a URL and different from an actual link destination
   */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $e6CqH.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $3eb490168d2cba0d$var$toUrl(href, window.location.origin);
        const linkTextUrl = $3eb490168d2cba0d$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};
module.exports["useLinkWarningModal"] = $3eb490168d2cba0d$export$32b76c003683c2ec;

});

parcelRegister("e6CqH", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $tALAR = parcelRequire("tALAR");


var $imtNr = parcelRequire("imtNr");


var $euPFX = parcelRequire("euPFX");

const $5b5c826438957f10$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $5b5c826438957f10$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
const $5b5c826438957f10$var$linkify = new (0, $tALAR.default)();
$5b5c826438957f10$var$linkify.add('sourcetree:', 'http:');
$5b5c826438957f10$var$linkify.add('jamfselfservice:', 'http:');
$5b5c826438957f10$var$linkify.add('notes:', 'http:');
$5b5c826438957f10$var$tlds.push($5b5c826438957f10$var$tlds2Char);
$5b5c826438957f10$var$linkify.tlds($5b5c826438957f10$var$tlds, false);
const $5b5c826438957f10$var$normaliseLinkHref = (url)=>{
    const match = $5b5c826438957f10$var$getLinkMatch(url);
    return match && match.url || null;
};
const $5b5c826438957f10$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = (0, $euPFX.linkifyMatch)(str);
    if (!match || !match.length) match = $5b5c826438957f10$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
function $5b5c826438957f10$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ((0, $imtNr.isSafeUrl)(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $5b5c826438957f10$var$normaliseLinkHref(urlWithoutNewlines);
}
module.exports["normalizeUrl"] = $5b5c826438957f10$export$6535eb414fa2c8b6;

});

parcelRegister("euPFX", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ const $e29ab90269c111d6$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $e29ab90269c111d6$export$6f7d7761b97f967 = (text)=>{
    const matches = [];
    if (!$e29ab90269c111d6$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($e29ab90269c111d6$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($e29ab90269c111d6$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos = end;
        } else break;
    }
    return matches;
};
module.exports["linkifyMatch"] = $e29ab90269c111d6$export$6f7d7761b97f967;

});

parcelRegister("kpg4X", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $kC6NK = parcelRequire("kC6NK");

const $277e2498b554872e$export$56ccbea3229cc4c3 = async (isProductInUnitsRollout)=>{
    // 1. Units GA killswitch, then this product's own rollout gate.
    if (!((0, $iDrrr.fg)('cc-units-ga') && isProductInUnitsRollout())) return false;
    // 2. This organisation's actual units state, read from AGG once per page load.
    const { boundaryEnforced: boundaryEnforced, endUsersLaunched: endUsersLaunched } = await (0, $kC6NK.getUnitsRolloutSettings)();
    return endUsersLaunched && boundaryEnforced;
};
module.exports["shouldUseUnitCompliantApi"] = $277e2498b554872e$export$56ccbea3229cc4c3;

});

parcelRegister("kC6NK", function(module, exports) {
/**
 * Reads where the current organisation is in the units migration from AGG.
 *
 * It takes two queries, because the settings are keyed by org id and the browser only knows the
 * host it is served from: first resolve the host to an org id, then read that org's unit settings.
 *
 * Only `shouldUseUnitCompliantApi` should need this - see that file for how the result is used.
 */ 
var $j39Hd = parcelRequire("j39Hd");


var $9uAJX = parcelRequire("9uAJX");

const $09ebff3e34cc36dc$var$AGG_URL = '/gateway/api/graphql';
/**
 * The operation names are the ones `@atlaskit/link-datasource` already sends from production, and
 * they are deliberately kept as they are now that the caller has moved into this package: AGG side
 * observability - dashboards, per operation traffic and rate limiting - is keyed off them, so
 * renaming them would silently orphan it.
 */ const $09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME = 'link_datasource_tenantContext';
const $09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME = 'link_datasource_unitSettings';
/**
 * `Query.admin_unitSettings` is keyed by org id, which the browser does not know, so the org id
 * is resolved from the host the product is currently served from.
 */ const $09ebff3e34cc36dc$var$tenantContextQuery = `
	query ${$09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME}($hostNames: [String!]) {
		tenantContexts(hostNames: $hostNames) {
			orgId
		}
	}
`;
/**
 * `admin_unitSettings` exposes both flags of the rollout and is callable with the session of the
 * end user, so no opt-in directive or admin OAuth scope is needed from the browser.
 */ const $09ebff3e34cc36dc$var$unitsRolloutSettingsQuery = `
	query ${$09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME}($orgId: ID!) {
		admin_unitSettings(orgId: $orgId) {
			boundaryEnforced
			endUsersLaunched
		}
	}
`;
/**
 * When the rollout settings cannot be resolved we keep the pre-isolation behaviour, which is
 * what every org gets today while the unit settings are unset. The settings are only
 * written when an org is activated - they are not backfilled - so `null` is expected for orgs
 * that have not been activated yet and must be read as `false`.
 */ const $09ebff3e34cc36dc$var$DEFAULT_SETTINGS = {
    boundaryEnforced: false,
    endUsersLaunched: false
};
/**
 * AGG answers with a 200 and an `errors` array for query level failures, so those have to be
 * turned into a rejection explicitly rather than being read as an empty response.
 */ const $09ebff3e34cc36dc$var$requestGraphQL = async (operationName, query, variables)=>{
    const response = await (0, $j39Hd.request)('post', $09ebff3e34cc36dc$var$AGG_URL, {
        operationName: operationName,
        query: query,
        variables: variables
    });
    if (response?.errors?.length) {
        const messages = response.errors.map((error)=>error?.message).filter(Boolean).join(', ');
        throw new Error(`${operationName} failed: ${messages || 'unknown error'}`);
    }
    return response?.data ?? undefined;
};
const $09ebff3e34cc36dc$var$fetchOrgId = async ()=>{
    const hostName = typeof window !== 'undefined' ? window.location?.hostname : undefined;
    if (!hostName) return undefined;
    const data = await $09ebff3e34cc36dc$var$requestGraphQL($09ebff3e34cc36dc$var$TENANT_CONTEXT_OPERATION_NAME, $09ebff3e34cc36dc$var$tenantContextQuery, {
        hostNames: [
            hostName
        ]
    });
    for (const tenantContext of data?.tenantContexts ?? []){
        if (tenantContext?.orgId) return tenantContext.orgId;
    }
    return undefined;
};
const $09ebff3e34cc36dc$var$fetchUnitsRolloutSettings = async ()=>{
    const orgId = await $09ebff3e34cc36dc$var$fetchOrgId();
    if (!orgId) return $09ebff3e34cc36dc$var$DEFAULT_SETTINGS;
    const data = await $09ebff3e34cc36dc$var$requestGraphQL($09ebff3e34cc36dc$var$UNITS_ROLLOUT_SETTINGS_OPERATION_NAME, $09ebff3e34cc36dc$var$unitsRolloutSettingsQuery, {
        orgId: orgId
    });
    const settings = data?.admin_unitSettings;
    return {
        boundaryEnforced: settings?.boundaryEnforced ?? false,
        endUsersLaunched: settings?.endUsersLaunched ?? false
    };
};
const $09ebff3e34cc36dc$export$2523e3b63c956620 = ()=>{
    if (!(0, $9uAJX.cache).promise) (0, $9uAJX.cache).promise = $09ebff3e34cc36dc$var$fetchUnitsRolloutSettings().catch(()=>{
        (0, $9uAJX.cache).promise = undefined;
        return $09ebff3e34cc36dc$var$DEFAULT_SETTINGS;
    });
    return (0, $9uAJX.cache).promise;
};
module.exports["getUnitsRolloutSettings"] = $09ebff3e34cc36dc$export$2523e3b63c956620;

});

parcelRegister("9uAJX", function(module, exports) {
const $6f4e12ab20c1322c$export$69a3209f1a06c04d = {};
module.exports["cache"] = $6f4e12ab20c1322c$export$69a3209f1a06c04d;

});

parcelRegister("k5sGX", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9fa87e3de3aa88c$export$2e2bcd8739ae039);

var $jO73f = parcelRequire("jO73f");


var $3yGK6 = parcelRequire("3yGK6");


var $kr6hK = parcelRequire("kr6hK");

function $e9fa87e3de3aa88c$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $3yGK6.default)(1, arguments);
    var additionalDigits = (0, $kr6hK.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $e9fa87e3de3aa88c$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $e9fa87e3de3aa88c$var$parseYear(dateStrings.date, additionalDigits);
        date = $e9fa87e3de3aa88c$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $e9fa87e3de3aa88c$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $e9fa87e3de3aa88c$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $e9fa87e3de3aa88c$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $e9fa87e3de3aa88c$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $e9fa87e3de3aa88c$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $e9fa87e3de3aa88c$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $e9fa87e3de3aa88c$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($e9fa87e3de3aa88c$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($e9fa87e3de3aa88c$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $e9fa87e3de3aa88c$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $e9fa87e3de3aa88c$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $e9fa87e3de3aa88c$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($e9fa87e3de3aa88c$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $e9fa87e3de3aa88c$var$parseDateUnit(captures[1]);
    var month = $e9fa87e3de3aa88c$var$parseDateUnit(captures[2]) - 1;
    var day = $e9fa87e3de3aa88c$var$parseDateUnit(captures[3]);
    var week = $e9fa87e3de3aa88c$var$parseDateUnit(captures[4]);
    var dayOfWeek = $e9fa87e3de3aa88c$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$e9fa87e3de3aa88c$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $e9fa87e3de3aa88c$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$e9fa87e3de3aa88c$var$validateDate(year, month, day) || !$e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $e9fa87e3de3aa88c$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $e9fa87e3de3aa88c$var$parseTime(timeString) {
    var captures = timeString.match($e9fa87e3de3aa88c$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[1]);
    var minutes = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[2]);
    var seconds = $e9fa87e3de3aa88c$var$parseTimeUnit(captures[3]);
    if (!$e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute) + seconds * 1000;
}
function $e9fa87e3de3aa88c$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function $e9fa87e3de3aa88c$var$parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match($e9fa87e3de3aa88c$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$e9fa87e3de3aa88c$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $jO73f.millisecondsInHour) + minutes * (0, $jO73f.millisecondsInMinute));
}
function $e9fa87e3de3aa88c$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $e9fa87e3de3aa88c$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $e9fa87e3de3aa88c$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $e9fa87e3de3aa88c$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($e9fa87e3de3aa88c$var$daysInMonths[month] || ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 29 : 28));
}
function $e9fa87e3de3aa88c$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($e9fa87e3de3aa88c$var$isLeapYearIndex(year) ? 366 : 365);
}
function $e9fa87e3de3aa88c$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $e9fa87e3de3aa88c$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $e9fa87e3de3aa88c$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("jO73f", function(module, exports) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $e6b828148d99ab2b$export$dfd9b671c89acc8e = 7;
var $e6b828148d99ab2b$export$3913210603d8e9ae = 365.2425;
var $e6b828148d99ab2b$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $e6b828148d99ab2b$export$91246f0b9bd9beff = 60000;
var $e6b828148d99ab2b$export$7f72910d6dfd237a = 3600000;
var $e6b828148d99ab2b$export$397c2d5776aa9055 = 1000;
var $e6b828148d99ab2b$export$4dec998e48f9c246 = -$e6b828148d99ab2b$export$81caae6e1cc7a622;
var $e6b828148d99ab2b$export$f2f5ae5a8e2d8f9f = 60;
var $e6b828148d99ab2b$export$3c58128db900d44e = 3;
var $e6b828148d99ab2b$export$80d7e435f744f319 = 12;
var $e6b828148d99ab2b$export$4db7641526e3241f = 4;
var $e6b828148d99ab2b$export$698aec755e92c695 = 3600;
var $e6b828148d99ab2b$export$a77c1a7ebebe2a5a = 60;
var $e6b828148d99ab2b$export$815a9362476d2fe3 = $e6b828148d99ab2b$export$698aec755e92c695 * 24;
var $e6b828148d99ab2b$export$34804a017b31e2fe = $e6b828148d99ab2b$export$815a9362476d2fe3 * 7;
var $e6b828148d99ab2b$export$7271e9e3478110d1 = $e6b828148d99ab2b$export$815a9362476d2fe3 * $e6b828148d99ab2b$export$3913210603d8e9ae;
var $e6b828148d99ab2b$export$8e6600bbdee7dabb = $e6b828148d99ab2b$export$7271e9e3478110d1 / 12;
var $e6b828148d99ab2b$export$be1dccf2de902d31 = $e6b828148d99ab2b$export$8e6600bbdee7dabb * 3;
module.exports["millisecondsInMinute"] = $e6b828148d99ab2b$export$91246f0b9bd9beff;
module.exports["millisecondsInHour"] = $e6b828148d99ab2b$export$7f72910d6dfd237a;
module.exports["millisecondsInSecond"] = $e6b828148d99ab2b$export$397c2d5776aa9055;

});

parcelRegister("3vMGL", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $bdgrV = parcelRequire("bdgrV");


var $gcCeq = parcelRequire("gcCeq");


var $a7dWT = parcelRequire("a7dWT");

const $a25ace4035d13584$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>getDays(weekStartDay, 'short');
    const getDaysLong = (weekStartDay = 0)=>getDays(weekStartDay, 'long');
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $bdgrV.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
     * Safari has a bug that returns the wrong month for years 2005 and before.
     * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
     * Not all the months fail in each year. To ensure the correct output,
     * we select 2020 as the base year for the whole date,
     * then we replace in the result the original input year
     */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $a7dWT.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
     * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
     * We fix it by detecting the real time with getHours method
     */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    let intlLocale;
    const getFirstDayOfWeek = ()=>{
        if (!intlLocale) intlLocale = new Intl.Locale(normalizedLocale);
        const weekInfo = (0, $gcCeq.getWeekInfo)(intlLocale);
        // Intl uses ISO weekdays (1 = Monday … 7 = Sunday).
        // Calendar / getDays* use JS weekdays (0 = Sunday … 6 = Saturday).
        return weekInfo.firstDay % 7;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts,
        getFirstDayOfWeek: getFirstDayOfWeek
    };
};
module.exports["createLocalizationProvider"] = $a25ace4035d13584$export$ea56ca58f08ffa52;

});

parcelRegister("5vwoh", function(module, exports) {
const $f2dacbe0eea831b8$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');
module.exports["normalizeLocale"] = $f2dacbe0eea831b8$export$dca0327c9b9c6498;

});

parcelRegister("bdgrV", function(module, exports) {

var $5vwoh = parcelRequire("5vwoh");


var $kGZoG = parcelRequire("kGZoG");


var $8w4cs = parcelRequire("8w4cs");


var $cafP2 = parcelRequire("cafP2");

const $8d32407758572e3f$var$INVALID_DATE = new Date(NaN);
const $8d32407758572e3f$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $8d32407758572e3f$var$INVARIANT_DATE = (0, $cafP2.toDate)($8d32407758572e3f$var$INVARIANT);
const $8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $8d32407758572e3f$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $8d32407758572e3f$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $8d32407758572e3f$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $8d32407758572e3f$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $5vwoh.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($8d32407758572e3f$var$INVARIANT_DATE);
    const shortDate = $8d32407758572e3f$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($8d32407758572e3f$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $8d32407758572e3f$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($8d32407758572e3f$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $8d32407758572e3f$var$stripExtras(date).match($8d32407758572e3f$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $8d32407758572e3f$var$INVALID_DATE;
        const dateParts = $8d32407758572e3f$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $8w4cs.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $kGZoG.isValid)(normalizedDate)) return $8d32407758572e3f$var$INVALID_DATE;
        return (0, $cafP2.toDate)(normalizedDate);
    };
};
module.exports["createDateParser"] = $8d32407758572e3f$export$cfa2ef2687faeda2;

});

parcelRegister("kGZoG", function(module, exports) {

var $aDvYS = parcelRequire("aDvYS");

const $8985e2fc067d563b$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = (0, $aDvYS.getDaysInMonth)(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
module.exports["isValid"] = $8985e2fc067d563b$export$1ea939691cdc45b8;

});

parcelRegister("aDvYS", function(module, exports) {

var $6NKSh = parcelRequire("6NKSh");

const $e96e8b0ab312aaba$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && (0, $6NKSh.isLeapYear)(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
module.exports["getDaysInMonth"] = $e96e8b0ab312aaba$export$f645ddd439eb259d;

});

parcelRegister("6NKSh", function(module, exports) {
const $04f001925dc3d06f$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
module.exports["isLeapYear"] = $04f001925dc3d06f$export$553d7fa8e3805fc0;

});

parcelRegister("8w4cs", function(module, exports) {

var $9tavx = parcelRequire("9tavx");

const $7e5174e81eb823af$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = (0, $9tavx.toDateObj)(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};
module.exports["normalizeDate"] = $7e5174e81eb823af$export$fcc71269590ba0a8;

});

parcelRegister("9tavx", function(module, exports) {
const $4b828859bff16031$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
module.exports["toDateObj"] = $4b828859bff16031$export$abe96da78d4f59dd;

});

parcelRegister("cafP2", function(module, exports) {
const $70268879eaf1b092$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
module.exports["toDate"] = $70268879eaf1b092$export$e67a095c620b86fe;

});

parcelRegister("gcCeq", function(module, exports) {
// Regional exceptions from Unicode CLDR 48; all other regions use Monday.
// https://github.com/unicode-org/cldr-json/blob/48.0.0/cldr-json/cldr-core/supplemental/weekData.json
const $afacfd87857de827$var$firstDays = {
    AF: 6,
    AG: 7,
    AS: 7,
    BD: 7,
    BH: 6,
    BR: 7,
    BS: 7,
    BT: 7,
    BW: 7,
    BZ: 7,
    CA: 7,
    CO: 7,
    DJ: 6,
    DM: 7,
    DO: 7,
    DZ: 6,
    EG: 6,
    ET: 7,
    GT: 7,
    GU: 7,
    HK: 7,
    HN: 7,
    ID: 7,
    IL: 7,
    IN: 7,
    IQ: 6,
    IR: 6,
    IS: 7,
    JM: 7,
    JO: 6,
    JP: 7,
    KE: 7,
    KH: 7,
    KR: 7,
    KW: 6,
    LA: 7,
    LY: 6,
    MH: 7,
    MM: 7,
    MO: 7,
    MT: 7,
    MV: 5,
    MX: 7,
    MZ: 7,
    NI: 7,
    NP: 7,
    OM: 6,
    PA: 7,
    PE: 7,
    PH: 7,
    PK: 7,
    PR: 7,
    PT: 7,
    PY: 7,
    QA: 6,
    SA: 7,
    SD: 6,
    SG: 7,
    SV: 7,
    SY: 6,
    TH: 7,
    TT: 7,
    TW: 7,
    UM: 7,
    US: 7,
    VE: 7,
    VI: 7,
    WS: 7,
    YE: 7,
    ZA: 7,
    ZW: 7
};
// Only regular territories may override a locale's region (CLDR 48 region validity data).
// https://github.com/unicode-org/cldr/blob/release-48/common/validity/region.xml
const $afacfd87857de827$var$regularRegions = new Set([
    'AC AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF',
    'BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH',
    'CI CK CL CM CN CO CP CQ CR CU CV CW CX CY CZ DE DG DJ DK DM DO DZ',
    'EA EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI',
    'GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU IC ID IE IL IM',
    'IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA',
    'LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO',
    'MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU',
    'NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW',
    'SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TA',
    'TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM US UY UZ',
    'VA VC VE VG VI VN VU WF WS XK YE YT ZA ZM ZW'
].join(' ').split(' '));
// Read only Unicode keywords, excluding other extensions and private-use subtags.
const $afacfd87857de827$var$getUnicodeKeyword = (locale, key)=>{
    const extensions = locale.toString().split('-');
    const start = extensions.indexOf('u');
    const privateUse = extensions.indexOf('x');
    if (start === -1 || privateUse !== -1 && privateUse < start) return undefined;
    for(let index = start + 1; index < extensions.length; index++){
        if (extensions[index].length === 1) break;
        if (extensions[index] === key) {
            const value = [];
            while(extensions[index + 1]?.length > 2)value.push(extensions[++index]);
            return value.join('-');
        }
    }
    return undefined;
};
// Canonicalize aliases before rejecting unknown, private-use, and macroregion overrides.
const $afacfd87857de827$var$getOverrideRegion = (value)=>{
    if (!value) return undefined;
    const region = new Intl.Locale(`und-${value}`).region;
    return region && $afacfd87857de827$var$regularRegions.has(region) ? region : undefined;
};
const $afacfd87857de827$export$837830ce0c77272 = (locale)=>{
    if (typeof locale.getWeekInfo === 'function') return locale.getWeekInfo();
    const legacyWeekInfo = locale.weekInfo;
    if (legacyWeekInfo) return legacyWeekInfo;
    const regionOverride = $afacfd87857de827$var$getOverrideRegion($afacfd87857de827$var$getUnicodeKeyword(locale, 'rg')?.match(/^([a-z]{2}|[0-9]{3})zzzz$/)?.[1]);
    const subdivision = $afacfd87857de827$var$getOverrideRegion($afacfd87857de827$var$getUnicodeKeyword(locale, 'sd')?.match(/^([a-z]{2}|[0-9]{3})[a-z0-9]+$/)?.[1]);
    const region = regionOverride || locale.region || subdivision || locale.maximize().region || '001';
    const preferredDay = [
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat',
        'sun'
    ].indexOf($afacfd87857de827$var$getUnicodeKeyword(locale, 'fw') || '');
    const firstDay = preferredDay !== -1 ? preferredDay + 1 : !regionOverride && locale.calendar === 'iso8601' ? 1 : $afacfd87857de827$var$firstDays[region] || 1;
    return {
        firstDay: firstDay
    };
};
module.exports["getWeekInfo"] = $afacfd87857de827$export$837830ce0c77272;

});

parcelRegister("a7dWT", function(module, exports) {
const $13d20959c22b69ba$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});
module.exports["toFormattedParts"] = $13d20959c22b69ba$export$9b7ca29af37c192;

});

parcelRegister("jrCh2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e27e3a4c5ffdab0c$export$2e2bcd8739ae039);
function $e27e3a4c5ffdab0c$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("9Rq82", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1P2f3 = parcelRequire("1P2f3");

'use strict';
function $72dd54e799957753$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $72dd54e799957753$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $72dd54e799957753$var$_typeof(o);
}
function $72dd54e799957753$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $72dd54e799957753$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $72dd54e799957753$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $72dd54e799957753$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $72dd54e799957753$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $72dd54e799957753$var$_toPropertyKey(arg) {
    var key = $72dd54e799957753$var$_toPrimitive(arg, "string");
    return $72dd54e799957753$var$_typeof(key) === "symbol" ? key : String(key);
}
function $72dd54e799957753$var$_toPrimitive(input, hint) {
    if ($72dd54e799957753$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($72dd54e799957753$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $72dd54e799957753$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $9VDwT = parcelRequire("9VDwT");

var $72dd54e799957753$var$_require$codes = $9VDwT.codes, $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT = $72dd54e799957753$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $72dd54e799957753$var$ERR_INVALID_ARG_TYPE = $72dd54e799957753$var$_require$codes.ERR_INVALID_ARG_TYPE, $72dd54e799957753$var$ERR_INVALID_ARG_VALUE = $72dd54e799957753$var$_require$codes.ERR_INVALID_ARG_VALUE, $72dd54e799957753$var$ERR_INVALID_RETURN_VALUE = $72dd54e799957753$var$_require$codes.ERR_INVALID_RETURN_VALUE, $72dd54e799957753$var$ERR_MISSING_ARGS = $72dd54e799957753$var$_require$codes.ERR_MISSING_ARGS;

var $9OEKu = parcelRequire("9OEKu");


var $7T2Y0 = parcelRequire("7T2Y0");

var $72dd54e799957753$var$inspect = $7T2Y0.inspect;



var $72dd54e799957753$require$_require$types = $7T2Y0.types;
var $72dd54e799957753$var$isPromise = $72dd54e799957753$require$_require$types.isPromise, $72dd54e799957753$var$isRegExp = $72dd54e799957753$require$_require$types.isRegExp;

var $72dd54e799957753$var$objectAssign = (parcelRequire("fnK1J"))();

var $72dd54e799957753$var$objectIs = (parcelRequire("aKQxr"))();

var $72dd54e799957753$var$RegExpPrototypeTest = (parcelRequire("2BPyg"))('RegExp.prototype.test');
var $72dd54e799957753$var$errorCache = new Map();
var $72dd54e799957753$var$isDeepEqual;
var $72dd54e799957753$var$isDeepStrictEqual;
var $72dd54e799957753$var$parseExpressionAt;
var $72dd54e799957753$var$findNodeAround;
var $72dd54e799957753$var$decoder;

function $72dd54e799957753$var$lazyLoadComparison() {
    var comparison = (parcelRequire("ilKc6"));
    $72dd54e799957753$var$isDeepEqual = comparison.isDeepEqual;
    $72dd54e799957753$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $72dd54e799957753$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $72dd54e799957753$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $72dd54e799957753$var$escapeFn = function escapeFn(str) {
    return $72dd54e799957753$var$meta[str.charCodeAt(0)];
};
var $72dd54e799957753$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $72dd54e799957753$var$assert = module.exports = $72dd54e799957753$var$ok;
var $72dd54e799957753$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $72dd54e799957753$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $9OEKu(obj);
}
function $72dd54e799957753$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($72dd54e799957753$var$warned === false) {
            $72dd54e799957753$var$warned = true;
            var warn = $1P2f3.emitWarning ? $1P2f3.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $72dd54e799957753$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $9OEKu(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$72dd54e799957753$var$assert.fail = $72dd54e799957753$var$fail;
// The AssertionError is defined in internal/error.
$72dd54e799957753$var$assert.AssertionError = $9OEKu;
function $72dd54e799957753$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $9OEKu({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $72dd54e799957753$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $72dd54e799957753$var$innerOk.apply(void 0, [
        $72dd54e799957753$var$ok,
        args.length
    ].concat(args));
}
$72dd54e799957753$var$assert.ok = $72dd54e799957753$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $72dd54e799957753$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$72dd54e799957753$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$72dd54e799957753$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if (!$72dd54e799957753$var$isDeepEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$72dd54e799957753$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if ($72dd54e799957753$var$isDeepEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $72dd54e799957753$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if (!$72dd54e799957753$var$isDeepStrictEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$72dd54e799957753$var$assert.notDeepStrictEqual = $72dd54e799957753$var$notDeepStrictEqual;
function $72dd54e799957753$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
    if ($72dd54e799957753$var$isDeepStrictEqual(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $72dd54e799957753$var$notDeepStrictEqual
    });
}
$72dd54e799957753$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$72dd54e799957753$var$objectIs(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$72dd54e799957753$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $72dd54e799957753$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($72dd54e799957753$var$objectIs(actual, expected)) $72dd54e799957753$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $72dd54e799957753$var$Comparison = /*#__PURE__*/ $72dd54e799957753$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $72dd54e799957753$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $72dd54e799957753$var$isRegExp(obj[key]) && $72dd54e799957753$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $72dd54e799957753$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$72dd54e799957753$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $72dd54e799957753$var$Comparison(actual, keys);
            var b = new $72dd54e799957753$var$Comparison(expected, keys, actual);
            var err = new $9OEKu({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $72dd54e799957753$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $72dd54e799957753$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($72dd54e799957753$var$isRegExp(expected)) return $72dd54e799957753$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($72dd54e799957753$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $9OEKu({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $72dd54e799957753$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($72dd54e799957753$var$isDeepEqual === undefined) $72dd54e799957753$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $72dd54e799957753$var$isRegExp(expected[key]) && $72dd54e799957753$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $72dd54e799957753$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $72dd54e799957753$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $72dd54e799957753$var$NO_EXCEPTION_SENTINEL;
}
function $72dd54e799957753$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $72dd54e799957753$var$isPromise(obj) || obj !== null && $72dd54e799957753$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $72dd54e799957753$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$72dd54e799957753$var$checkIsPromise(resultPromise)) throw new $72dd54e799957753$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($72dd54e799957753$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $72dd54e799957753$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $72dd54e799957753$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($72dd54e799957753$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $72dd54e799957753$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $72dd54e799957753$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $72dd54e799957753$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $72dd54e799957753$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$72dd54e799957753$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $72dd54e799957753$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $72dd54e799957753$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $72dd54e799957753$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $72dd54e799957753$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$72dd54e799957753$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $72dd54e799957753$var$expectsError.apply(void 0, [
        throws,
        $72dd54e799957753$var$getActual(promiseFn)
    ].concat(args));
};
$72dd54e799957753$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $72dd54e799957753$var$waitForActual(promiseFn).then(function(result) {
        return $72dd54e799957753$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$72dd54e799957753$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $72dd54e799957753$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $72dd54e799957753$var$getActual(fn)
    ].concat(args));
};
$72dd54e799957753$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $72dd54e799957753$var$waitForActual(fn).then(function(result) {
        return $72dd54e799957753$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$72dd54e799957753$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($72dd54e799957753$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $72dd54e799957753$var$inspect(err);
        var newErr = new $9OEKu({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $72dd54e799957753$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$72dd54e799957753$var$isRegExp(regexp)) throw new $72dd54e799957753$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $72dd54e799957753$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($72dd54e799957753$var$_typeof(string), " (").concat($72dd54e799957753$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($72dd54e799957753$var$inspect(regexp), ". Input:\n\n").concat($72dd54e799957753$var$inspect(string), "\n"));
        var err = new $9OEKu({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$72dd54e799957753$var$assert.match = function match(string, regexp, message) {
    $72dd54e799957753$var$internalMatch(string, regexp, message, match, 'match');
};
$72dd54e799957753$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $72dd54e799957753$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $72dd54e799957753$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $72dd54e799957753$var$innerOk.apply(void 0, [
        $72dd54e799957753$var$strict,
        args.length
    ].concat(args));
}
$72dd54e799957753$var$assert.strict = $72dd54e799957753$var$objectAssign($72dd54e799957753$var$strict, $72dd54e799957753$var$assert, {
    equal: $72dd54e799957753$var$assert.strictEqual,
    deepEqual: $72dd54e799957753$var$assert.deepStrictEqual,
    notEqual: $72dd54e799957753$var$assert.notStrictEqual,
    notDeepEqual: $72dd54e799957753$var$assert.notDeepStrictEqual
});
$72dd54e799957753$var$assert.strict.strict = $72dd54e799957753$var$assert.strict;

});

parcelRegister("9VDwT", function(module, exports) {
$parcel$export(module.exports, "codes", () => $73a819a63e892b7f$export$e45cb6485273080e, (v) => $73a819a63e892b7f$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $73a819a63e892b7f$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $73a819a63e892b7f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $73a819a63e892b7f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $73a819a63e892b7f$var$_typeof(o);
}
function $73a819a63e892b7f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $73a819a63e892b7f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $73a819a63e892b7f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $73a819a63e892b7f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $73a819a63e892b7f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $73a819a63e892b7f$var$_toPropertyKey(arg) {
    var key = $73a819a63e892b7f$var$_toPrimitive(arg, "string");
    return $73a819a63e892b7f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $73a819a63e892b7f$var$_toPrimitive(input, hint) {
    if ($73a819a63e892b7f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($73a819a63e892b7f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $73a819a63e892b7f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $73a819a63e892b7f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $73a819a63e892b7f$var$_setPrototypeOf(subClass, superClass);
}
function $73a819a63e892b7f$var$_setPrototypeOf(o, p) {
    $73a819a63e892b7f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $73a819a63e892b7f$var$_setPrototypeOf(o, p);
}
function $73a819a63e892b7f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $73a819a63e892b7f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $73a819a63e892b7f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $73a819a63e892b7f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $73a819a63e892b7f$var$_possibleConstructorReturn(this, result);
    };
}
function $73a819a63e892b7f$var$_possibleConstructorReturn(self, call) {
    if (call && ($73a819a63e892b7f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $73a819a63e892b7f$var$_assertThisInitialized(self);
}
function $73a819a63e892b7f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $73a819a63e892b7f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $73a819a63e892b7f$var$_getPrototypeOf(o) {
    $73a819a63e892b7f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $73a819a63e892b7f$var$_getPrototypeOf(o);
}
var $73a819a63e892b7f$var$codes = {};
// Lazy loaded
var $73a819a63e892b7f$var$assert;
var $73a819a63e892b7f$var$util;
function $73a819a63e892b7f$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $73a819a63e892b7f$var$_inherits(NodeError, _Base);
        var _super = $73a819a63e892b7f$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $73a819a63e892b7f$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $73a819a63e892b7f$var$_createClass(NodeError);
    }(Base);
    $73a819a63e892b7f$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $73a819a63e892b7f$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $73a819a63e892b7f$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $73a819a63e892b7f$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $73a819a63e892b7f$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$73a819a63e892b7f$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($73a819a63e892b7f$var$assert === undefined) $73a819a63e892b7f$var$assert = (parcelRequire("9Rq82"));
    $73a819a63e892b7f$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $73a819a63e892b7f$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($73a819a63e892b7f$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($73a819a63e892b7f$var$oneOf(expected, 'type'));
    else {
        var type = $73a819a63e892b7f$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($73a819a63e892b7f$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($73a819a63e892b7f$var$_typeof(actual));
    return msg;
}, TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($73a819a63e892b7f$var$util === undefined) $73a819a63e892b7f$var$util = (parcelRequire("7T2Y0"));
    var inspected = $73a819a63e892b7f$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$73a819a63e892b7f$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($73a819a63e892b7f$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$73a819a63e892b7f$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($73a819a63e892b7f$var$assert === undefined) $73a819a63e892b7f$var$assert = (parcelRequire("9Rq82"));
    $73a819a63e892b7f$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$73a819a63e892b7f$export$e45cb6485273080e = $73a819a63e892b7f$var$codes;

});

parcelRegister("7T2Y0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $1P2f3 = parcelRequire("1P2f3");

var $5bdff89be3748b6d$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $5bdff89be3748b6d$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$5bdff89be3748b6d$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($5bdff89be3748b6d$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($5bdff89be3748b6d$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($5bdff89be3748b6d$var$isNull(x) || !$5bdff89be3748b6d$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $5bdff89be3748b6d$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $1P2f3 !== 'undefined' && $1P2f3.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $1P2f3 === 'undefined') return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($1P2f3.throwDeprecation) throw new Error(msg);
            else if ($1P2f3.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $5bdff89be3748b6d$var$debugs = {};
var $5bdff89be3748b6d$var$debugEnvRegex = /^$/;
var $5bdff89be3748b6d$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$5bdff89be3748b6d$var$debugs[set]) {
        if ($5bdff89be3748b6d$var$debugEnvRegex.test(set)) {
            var pid = $1P2f3.pid;
            $5bdff89be3748b6d$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $5bdff89be3748b6d$var$debugs[set] = function() {};
    }
    return $5bdff89be3748b6d$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $5bdff89be3748b6d$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $5bdff89be3748b6d$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($5bdff89be3748b6d$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($5bdff89be3748b6d$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($5bdff89be3748b6d$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $5bdff89be3748b6d$var$stylizeWithColor;
    return $5bdff89be3748b6d$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $5bdff89be3748b6d$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$5bdff89be3748b6d$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$5bdff89be3748b6d$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $5bdff89be3748b6d$var$stylizeWithColor(str, styleType) {
    var style = $5bdff89be3748b6d$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $5bdff89be3748b6d$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $5bdff89be3748b6d$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $5bdff89be3748b6d$var$stylizeNoColor(str, styleType) {
    return str;
}
function $5bdff89be3748b6d$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $5bdff89be3748b6d$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $5bdff89be3748b6d$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$5bdff89be3748b6d$var$isString(ret)) ret = $5bdff89be3748b6d$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $5bdff89be3748b6d$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $5bdff89be3748b6d$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($5bdff89be3748b6d$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $5bdff89be3748b6d$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($5bdff89be3748b6d$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($5bdff89be3748b6d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($5bdff89be3748b6d$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($5bdff89be3748b6d$var$isError(value)) return $5bdff89be3748b6d$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($5bdff89be3748b6d$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($5bdff89be3748b6d$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($5bdff89be3748b6d$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($5bdff89be3748b6d$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($5bdff89be3748b6d$var$isError(value)) base = ' ' + $5bdff89be3748b6d$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($5bdff89be3748b6d$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $5bdff89be3748b6d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $5bdff89be3748b6d$var$reduceToSingleString(output, base, braces);
}
function $5bdff89be3748b6d$var$formatPrimitive(ctx, value) {
    if ($5bdff89be3748b6d$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($5bdff89be3748b6d$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($5bdff89be3748b6d$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($5bdff89be3748b6d$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($5bdff89be3748b6d$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $5bdff89be3748b6d$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $5bdff89be3748b6d$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($5bdff89be3748b6d$var$hasOwnProperty(value, String(i))) output.push($5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $5bdff89be3748b6d$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$5bdff89be3748b6d$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($5bdff89be3748b6d$var$isNull(recurseTimes)) str = $5bdff89be3748b6d$var$formatValue(ctx, desc.value, null);
            else str = $5bdff89be3748b6d$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($5bdff89be3748b6d$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $5bdff89be3748b6d$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("3xAFV"));
function $5bdff89be3748b6d$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $5bdff89be3748b6d$var$isArray;
function $5bdff89be3748b6d$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $5bdff89be3748b6d$var$isBoolean;
function $5bdff89be3748b6d$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $5bdff89be3748b6d$var$isNull;
function $5bdff89be3748b6d$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $5bdff89be3748b6d$var$isNullOrUndefined;
function $5bdff89be3748b6d$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $5bdff89be3748b6d$var$isNumber;
function $5bdff89be3748b6d$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $5bdff89be3748b6d$var$isString;
function $5bdff89be3748b6d$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $5bdff89be3748b6d$var$isSymbol;
function $5bdff89be3748b6d$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $5bdff89be3748b6d$var$isUndefined;
function $5bdff89be3748b6d$var$isRegExp(re) {
    return $5bdff89be3748b6d$var$isObject(re) && $5bdff89be3748b6d$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $5bdff89be3748b6d$var$isRegExp;
module.exports.types.isRegExp = $5bdff89be3748b6d$var$isRegExp;
function $5bdff89be3748b6d$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $5bdff89be3748b6d$var$isObject;
function $5bdff89be3748b6d$var$isDate(d) {
    return $5bdff89be3748b6d$var$isObject(d) && $5bdff89be3748b6d$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $5bdff89be3748b6d$var$isDate;
module.exports.types.isDate = $5bdff89be3748b6d$var$isDate;
function $5bdff89be3748b6d$var$isError(e) {
    return $5bdff89be3748b6d$var$isObject(e) && ($5bdff89be3748b6d$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $5bdff89be3748b6d$var$isError;
module.exports.types.isNativeError = $5bdff89be3748b6d$var$isError;
function $5bdff89be3748b6d$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $5bdff89be3748b6d$var$isFunction;
function $5bdff89be3748b6d$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $5bdff89be3748b6d$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("hUXoN"));
function $5bdff89be3748b6d$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $5bdff89be3748b6d$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $5bdff89be3748b6d$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $5bdff89be3748b6d$var$timestamp() {
    var d = new Date();
    var time = [
        $5bdff89be3748b6d$var$pad(d.getHours()),
        $5bdff89be3748b6d$var$pad(d.getMinutes()),
        $5bdff89be3748b6d$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $5bdff89be3748b6d$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $5bdff89be3748b6d$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("iuv32"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$5bdff89be3748b6d$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $5bdff89be3748b6d$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $5bdff89be3748b6d$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($5bdff89be3748b6d$var$kCustomPromisifiedSymbol && original[$5bdff89be3748b6d$var$kCustomPromisifiedSymbol]) {
        var fn = original[$5bdff89be3748b6d$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $5bdff89be3748b6d$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($5bdff89be3748b6d$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $5bdff89be3748b6d$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $5bdff89be3748b6d$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $5bdff89be3748b6d$var$kCustomPromisifiedSymbol;
function $5bdff89be3748b6d$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $5bdff89be3748b6d$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $1P2f3.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $1P2f3.nextTick($5bdff89be3748b6d$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $5bdff89be3748b6d$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $5bdff89be3748b6d$var$callbackify;

});

parcelRegister("3xAFV", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $2Xb4T = parcelRequire("2Xb4T");


var $6TAnP = parcelRequire("6TAnP");


var $go4T7 = parcelRequire("go4T7");


var $5RMvC = parcelRequire("5RMvC");

function $2940e712aca02fa7$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2940e712aca02fa7$var$BigIntSupported = typeof BigInt !== 'undefined';
var $2940e712aca02fa7$var$SymbolSupported = typeof Symbol !== 'undefined';
var $2940e712aca02fa7$var$ObjectToString = $2940e712aca02fa7$var$uncurryThis(Object.prototype.toString);
var $2940e712aca02fa7$var$numberValue = $2940e712aca02fa7$var$uncurryThis(Number.prototype.valueOf);
var $2940e712aca02fa7$var$stringValue = $2940e712aca02fa7$var$uncurryThis(String.prototype.valueOf);
var $2940e712aca02fa7$var$booleanValue = $2940e712aca02fa7$var$uncurryThis(Boolean.prototype.valueOf);
if ($2940e712aca02fa7$var$BigIntSupported) var $2940e712aca02fa7$var$bigIntValue = $2940e712aca02fa7$var$uncurryThis(BigInt.prototype.valueOf);
if ($2940e712aca02fa7$var$SymbolSupported) var $2940e712aca02fa7$var$symbolValue = $2940e712aca02fa7$var$uncurryThis(Symbol.prototype.valueOf);
function $2940e712aca02fa7$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $2Xb4T;
module.exports.isGeneratorFunction = $6TAnP;
module.exports.isTypedArray = $5RMvC;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $2940e712aca02fa7$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $2940e712aca02fa7$var$isPromise;
function $2940e712aca02fa7$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $5RMvC(value) || $2940e712aca02fa7$var$isDataView(value);
}
module.exports.isArrayBufferView = $2940e712aca02fa7$var$isArrayBufferView;
function $2940e712aca02fa7$var$isUint8Array(value) {
    return $go4T7(value) === 'Uint8Array';
}
module.exports.isUint8Array = $2940e712aca02fa7$var$isUint8Array;
function $2940e712aca02fa7$var$isUint8ClampedArray(value) {
    return $go4T7(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $2940e712aca02fa7$var$isUint8ClampedArray;
function $2940e712aca02fa7$var$isUint16Array(value) {
    return $go4T7(value) === 'Uint16Array';
}
module.exports.isUint16Array = $2940e712aca02fa7$var$isUint16Array;
function $2940e712aca02fa7$var$isUint32Array(value) {
    return $go4T7(value) === 'Uint32Array';
}
module.exports.isUint32Array = $2940e712aca02fa7$var$isUint32Array;
function $2940e712aca02fa7$var$isInt8Array(value) {
    return $go4T7(value) === 'Int8Array';
}
module.exports.isInt8Array = $2940e712aca02fa7$var$isInt8Array;
function $2940e712aca02fa7$var$isInt16Array(value) {
    return $go4T7(value) === 'Int16Array';
}
module.exports.isInt16Array = $2940e712aca02fa7$var$isInt16Array;
function $2940e712aca02fa7$var$isInt32Array(value) {
    return $go4T7(value) === 'Int32Array';
}
module.exports.isInt32Array = $2940e712aca02fa7$var$isInt32Array;
function $2940e712aca02fa7$var$isFloat32Array(value) {
    return $go4T7(value) === 'Float32Array';
}
module.exports.isFloat32Array = $2940e712aca02fa7$var$isFloat32Array;
function $2940e712aca02fa7$var$isFloat64Array(value) {
    return $go4T7(value) === 'Float64Array';
}
module.exports.isFloat64Array = $2940e712aca02fa7$var$isFloat64Array;
function $2940e712aca02fa7$var$isBigInt64Array(value) {
    return $go4T7(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $2940e712aca02fa7$var$isBigInt64Array;
function $2940e712aca02fa7$var$isBigUint64Array(value) {
    return $go4T7(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $2940e712aca02fa7$var$isBigUint64Array;
function $2940e712aca02fa7$var$isMapToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Map]';
}
$2940e712aca02fa7$var$isMapToString.working = typeof Map !== 'undefined' && $2940e712aca02fa7$var$isMapToString(new Map());
function $2940e712aca02fa7$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $2940e712aca02fa7$var$isMapToString.working ? $2940e712aca02fa7$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $2940e712aca02fa7$var$isMap;
function $2940e712aca02fa7$var$isSetToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Set]';
}
$2940e712aca02fa7$var$isSetToString.working = typeof Set !== 'undefined' && $2940e712aca02fa7$var$isSetToString(new Set());
function $2940e712aca02fa7$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $2940e712aca02fa7$var$isSetToString.working ? $2940e712aca02fa7$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $2940e712aca02fa7$var$isSet;
function $2940e712aca02fa7$var$isWeakMapToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WeakMap]';
}
$2940e712aca02fa7$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $2940e712aca02fa7$var$isWeakMapToString(new WeakMap());
function $2940e712aca02fa7$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $2940e712aca02fa7$var$isWeakMapToString.working ? $2940e712aca02fa7$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $2940e712aca02fa7$var$isWeakMap;
function $2940e712aca02fa7$var$isWeakSetToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WeakSet]';
}
$2940e712aca02fa7$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $2940e712aca02fa7$var$isWeakSetToString(new WeakSet());
function $2940e712aca02fa7$var$isWeakSet(value) {
    return $2940e712aca02fa7$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $2940e712aca02fa7$var$isWeakSet;
function $2940e712aca02fa7$var$isArrayBufferToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$2940e712aca02fa7$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $2940e712aca02fa7$var$isArrayBufferToString(new ArrayBuffer());
function $2940e712aca02fa7$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $2940e712aca02fa7$var$isArrayBufferToString.working ? $2940e712aca02fa7$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $2940e712aca02fa7$var$isArrayBuffer;
function $2940e712aca02fa7$var$isDataViewToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object DataView]';
}
$2940e712aca02fa7$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $2940e712aca02fa7$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $2940e712aca02fa7$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $2940e712aca02fa7$var$isDataViewToString.working ? $2940e712aca02fa7$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $2940e712aca02fa7$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $2940e712aca02fa7$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $2940e712aca02fa7$var$isSharedArrayBufferToString(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $2940e712aca02fa7$var$isSharedArrayBuffer(value) {
    if (typeof $2940e712aca02fa7$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $2940e712aca02fa7$var$isSharedArrayBufferToString.working === 'undefined') $2940e712aca02fa7$var$isSharedArrayBufferToString.working = $2940e712aca02fa7$var$isSharedArrayBufferToString(new $2940e712aca02fa7$var$SharedArrayBufferCopy());
    return $2940e712aca02fa7$var$isSharedArrayBufferToString.working ? $2940e712aca02fa7$var$isSharedArrayBufferToString(value) : value instanceof $2940e712aca02fa7$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $2940e712aca02fa7$var$isSharedArrayBuffer;
function $2940e712aca02fa7$var$isAsyncFunction(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $2940e712aca02fa7$var$isAsyncFunction;
function $2940e712aca02fa7$var$isMapIterator(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $2940e712aca02fa7$var$isMapIterator;
function $2940e712aca02fa7$var$isSetIterator(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $2940e712aca02fa7$var$isSetIterator;
function $2940e712aca02fa7$var$isGeneratorObject(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $2940e712aca02fa7$var$isGeneratorObject;
function $2940e712aca02fa7$var$isWebAssemblyCompiledModule(value) {
    return $2940e712aca02fa7$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $2940e712aca02fa7$var$isWebAssemblyCompiledModule;
function $2940e712aca02fa7$var$isNumberObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$numberValue);
}
module.exports.isNumberObject = $2940e712aca02fa7$var$isNumberObject;
function $2940e712aca02fa7$var$isStringObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$stringValue);
}
module.exports.isStringObject = $2940e712aca02fa7$var$isStringObject;
function $2940e712aca02fa7$var$isBooleanObject(value) {
    return $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$booleanValue);
}
module.exports.isBooleanObject = $2940e712aca02fa7$var$isBooleanObject;
function $2940e712aca02fa7$var$isBigIntObject(value) {
    return $2940e712aca02fa7$var$BigIntSupported && $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$bigIntValue);
}
module.exports.isBigIntObject = $2940e712aca02fa7$var$isBigIntObject;
function $2940e712aca02fa7$var$isSymbolObject(value) {
    return $2940e712aca02fa7$var$SymbolSupported && $2940e712aca02fa7$var$checkBoxedPrimitive(value, $2940e712aca02fa7$var$symbolValue);
}
module.exports.isSymbolObject = $2940e712aca02fa7$var$isSymbolObject;
function $2940e712aca02fa7$var$isBoxedPrimitive(value) {
    return $2940e712aca02fa7$var$isNumberObject(value) || $2940e712aca02fa7$var$isStringObject(value) || $2940e712aca02fa7$var$isBooleanObject(value) || $2940e712aca02fa7$var$isBigIntObject(value) || $2940e712aca02fa7$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $2940e712aca02fa7$var$isBoxedPrimitive;
function $2940e712aca02fa7$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($2940e712aca02fa7$var$isArrayBuffer(value) || $2940e712aca02fa7$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $2940e712aca02fa7$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});

parcelRegister("2Xb4T", function(module, exports) {
'use strict';

var $2269af4a175bb16e$var$hasToStringTag = (parcelRequire("DVsRa"))();

var $2BPyg = parcelRequire("2BPyg");

var $2269af4a175bb16e$var$$toString = $2BPyg('Object.prototype.toString');
var $2269af4a175bb16e$var$isStandardArguments = function isArguments(value) {
    if ($2269af4a175bb16e$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $2269af4a175bb16e$var$$toString(value) === '[object Arguments]';
};
var $2269af4a175bb16e$var$isLegacyArguments = function isArguments(value) {
    if ($2269af4a175bb16e$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $2269af4a175bb16e$var$$toString(value) !== '[object Array]' && $2269af4a175bb16e$var$$toString(value.callee) === '[object Function]';
};
var $2269af4a175bb16e$var$supportsStandardArguments = function() {
    return $2269af4a175bb16e$var$isStandardArguments(arguments);
}();
$2269af4a175bb16e$var$isStandardArguments.isLegacyArguments = $2269af4a175bb16e$var$isLegacyArguments; // for tests
module.exports = $2269af4a175bb16e$var$supportsStandardArguments ? $2269af4a175bb16e$var$isStandardArguments : $2269af4a175bb16e$var$isLegacyArguments;

});

parcelRegister("2BPyg", function(module, exports) {
'use strict';

var $cAbhD = parcelRequire("cAbhD");


var $26J2z = parcelRequire("26J2z");

var $1e670692988d4e8b$var$$indexOf = $26J2z($cAbhD('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $cAbhD(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $1e670692988d4e8b$var$$indexOf(name, '.prototype.') > -1) return $26J2z(intrinsic);
    return intrinsic;
};

});

parcelRegister("6TAnP", function(module, exports) {
'use strict';
var $50541a19d60c8c39$var$toStr = Object.prototype.toString;
var $50541a19d60c8c39$var$fnToStr = Function.prototype.toString;
var $50541a19d60c8c39$var$isFnRegex = /^\s*(?:function)?\*/;

var $50541a19d60c8c39$var$hasToStringTag = (parcelRequire("DVsRa"))();
var $50541a19d60c8c39$var$getProto = Object.getPrototypeOf;
var $50541a19d60c8c39$var$getGeneratorFunc = function() {
    if (!$50541a19d60c8c39$var$hasToStringTag) return false;
    try {
        return Function('return function*() {}')();
    } catch (e) {}
};
var $50541a19d60c8c39$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($50541a19d60c8c39$var$isFnRegex.test($50541a19d60c8c39$var$fnToStr.call(fn))) return true;
    if (!$50541a19d60c8c39$var$hasToStringTag) {
        var str = $50541a19d60c8c39$var$toStr.call(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$50541a19d60c8c39$var$getProto) return false;
    if (typeof $50541a19d60c8c39$var$GeneratorFunction === 'undefined') {
        var generatorFunc = $50541a19d60c8c39$var$getGeneratorFunc();
        $50541a19d60c8c39$var$GeneratorFunction = generatorFunc ? $50541a19d60c8c39$var$getProto(generatorFunc) : false;
    }
    return $50541a19d60c8c39$var$getProto(fn) === $50541a19d60c8c39$var$GeneratorFunction;
};

});

parcelRegister("hUXoN", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("9OEKu", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $1P2f3 = parcelRequire("1P2f3");

'use strict';
function $7258646f9557e685$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7258646f9557e685$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7258646f9557e685$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7258646f9557e685$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7258646f9557e685$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7258646f9557e685$var$_defineProperty(obj, key, value) {
    key = $7258646f9557e685$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7258646f9557e685$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7258646f9557e685$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7258646f9557e685$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7258646f9557e685$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7258646f9557e685$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7258646f9557e685$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7258646f9557e685$var$_toPropertyKey(arg) {
    var key = $7258646f9557e685$var$_toPrimitive(arg, "string");
    return $7258646f9557e685$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7258646f9557e685$var$_toPrimitive(input, hint) {
    if ($7258646f9557e685$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7258646f9557e685$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7258646f9557e685$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $7258646f9557e685$var$_setPrototypeOf(subClass, superClass);
}
function $7258646f9557e685$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7258646f9557e685$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $7258646f9557e685$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $7258646f9557e685$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7258646f9557e685$var$_possibleConstructorReturn(this, result);
    };
}
function $7258646f9557e685$var$_possibleConstructorReturn(self, call) {
    if (call && ($7258646f9557e685$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7258646f9557e685$var$_assertThisInitialized(self);
}
function $7258646f9557e685$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7258646f9557e685$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $7258646f9557e685$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$7258646f9557e685$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $7258646f9557e685$var$_construct(Class, arguments, $7258646f9557e685$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $7258646f9557e685$var$_setPrototypeOf(Wrapper, Class);
    };
    return $7258646f9557e685$var$_wrapNativeSuper(Class);
}
function $7258646f9557e685$var$_construct(Parent, args, Class) {
    if ($7258646f9557e685$var$_isNativeReflectConstruct()) $7258646f9557e685$var$_construct = Reflect.construct.bind();
    else $7258646f9557e685$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $7258646f9557e685$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $7258646f9557e685$var$_construct.apply(null, arguments);
}
function $7258646f9557e685$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7258646f9557e685$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $7258646f9557e685$var$_setPrototypeOf(o, p) {
    $7258646f9557e685$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7258646f9557e685$var$_setPrototypeOf(o, p);
}
function $7258646f9557e685$var$_getPrototypeOf(o) {
    $7258646f9557e685$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7258646f9557e685$var$_getPrototypeOf(o);
}
function $7258646f9557e685$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7258646f9557e685$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7258646f9557e685$var$_typeof(o);
}

var $7T2Y0 = parcelRequire("7T2Y0");

var $7258646f9557e685$var$inspect = $7T2Y0.inspect;

var $9VDwT = parcelRequire("9VDwT");

var $7258646f9557e685$var$ERR_INVALID_ARG_TYPE = $9VDwT.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $7258646f9557e685$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $7258646f9557e685$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $7258646f9557e685$var$blue = '';
var $7258646f9557e685$var$green = '';
var $7258646f9557e685$var$red = '';
var $7258646f9557e685$var$white = '';
var $7258646f9557e685$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $7258646f9557e685$var$kMaxShortLength = 10;
function $7258646f9557e685$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $7258646f9557e685$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $7258646f9557e685$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $7258646f9557e685$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $7258646f9557e685$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $7258646f9557e685$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $7258646f9557e685$var$_typeof(actual) === 'object' && $7258646f9557e685$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $7258646f9557e685$var$kMaxShortLength) {
            if (($7258646f9557e685$var$_typeof(actual) !== 'object' || actual === null) && ($7258646f9557e685$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($7258646f9557e685$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $1P2f3.stderr && $1P2f3.stderr.isTTY ? $1P2f3.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($7258646f9557e685$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($7258646f9557e685$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $7258646f9557e685$var$kReadableOperator[operator] + "\n".concat($7258646f9557e685$var$green, "+ actual").concat($7258646f9557e685$var$white, " ").concat($7258646f9557e685$var$red, "- expected").concat($7258646f9557e685$var$white);
    var skippedMsg = " ".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($7258646f9557e685$var$red, "-").concat($7258646f9557e685$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($7258646f9557e685$var$green, "+").concat($7258646f9557e685$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$7258646f9557e685$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $7258646f9557e685$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($7258646f9557e685$var$green, "+").concat($7258646f9557e685$var$white, " ").concat(actualLine);
                other += "\n".concat($7258646f9557e685$var$red, "-").concat($7258646f9557e685$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white).concat(other, "\n") + "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $7258646f9557e685$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $7258646f9557e685$var$_inherits(AssertionError, _Error);
    var _super = $7258646f9557e685$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $7258646f9557e685$var$_classCallCheck(this, AssertionError);
        if ($7258646f9557e685$var$_typeof(options) !== 'object' || options === null) throw new $7258646f9557e685$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($1P2f3.stderr && $1P2f3.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($1P2f3.stderr && $1P2f3.stderr.getColorDepth && $1P2f3.stderr.getColorDepth() !== 1) {
                    $7258646f9557e685$var$blue = "\x1B[34m";
                    $7258646f9557e685$var$green = "\x1B[32m";
                    $7258646f9557e685$var$white = "\x1B[39m";
                    $7258646f9557e685$var$red = "\x1B[31m";
                } else {
                    $7258646f9557e685$var$blue = '';
                    $7258646f9557e685$var$green = '';
                    $7258646f9557e685$var$white = '';
                    $7258646f9557e685$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($7258646f9557e685$var$_typeof(actual) === 'object' && actual !== null && $7258646f9557e685$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $7258646f9557e685$var$copyError(actual);
                expected = $7258646f9557e685$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $7258646f9557e685$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $7258646f9557e685$var$kReadableOperator[operator];
                var res = $7258646f9557e685$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $7258646f9557e685$var$_typeof(actual) === 'object' && actual !== null) base = $7258646f9557e685$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($7258646f9557e685$var$blue, "...").concat($7258646f9557e685$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $7258646f9557e685$var$inspectValue(actual);
                var other = '';
                var knownOperators = $7258646f9557e685$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($7258646f9557e685$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($7258646f9557e685$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($7258646f9557e685$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($7258646f9557e685$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $7258646f9557e685$var$_possibleConstructorReturn(_this);
    }
    $7258646f9557e685$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $7258646f9557e685$var$inspect(this, $7258646f9557e685$var$_objectSpread($7258646f9557e685$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $7258646f9557e685$var$_wrapNativeSuper(Error), $7258646f9557e685$var$inspect.custom);
module.exports = $7258646f9557e685$var$AssertionError;

});

parcelRegister("fnK1J", function(module, exports) {
'use strict';

var $3yGSv = parcelRequire("3yGSv");

var $b32cb5030c98732b$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $b32cb5030c98732b$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $3yGSv;
    if ($b32cb5030c98732b$var$lacksProperEnumerationOrder()) return $3yGSv;
    if ($b32cb5030c98732b$var$assignHasPendingExceptions()) return $3yGSv;
    return Object.assign;
};

});

parcelRegister("3yGSv", function(module, exports) {
'use strict';

var $2aMTq = parcelRequire("2aMTq");


var $2975cec13e42e027$var$hasSymbols = (parcelRequire("edGXQ"))();

var $blqMe = parcelRequire("blqMe");


var $f8a3L = parcelRequire("f8a3L");

var $2975cec13e42e027$var$$push = $blqMe('Array.prototype.push');
var $2975cec13e42e027$var$$propIsEnumerable = $blqMe('Object.prototype.propertyIsEnumerable');
var $2975cec13e42e027$var$originalGetSymbols = $2975cec13e42e027$var$hasSymbols ? $f8a3L.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $f8a3L(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $f8a3L(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $2aMTq(from);
        var getSymbols = $2975cec13e42e027$var$hasSymbols && ($f8a3L.getOwnPropertySymbols || $2975cec13e42e027$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($2975cec13e42e027$var$$propIsEnumerable(from, key)) $2975cec13e42e027$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($2975cec13e42e027$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});

parcelRegister("2aMTq", function(module, exports) {
'use strict';
var $19527114ab6c974a$var$slice = Array.prototype.slice;

var $9QzFm = parcelRequire("9QzFm");

var $19527114ab6c974a$var$origKeys = Object.keys;

var $19527114ab6c974a$var$keysShim = $19527114ab6c974a$var$origKeys ? function keys(o) {
    return $19527114ab6c974a$var$origKeys(o);
} : (parcelRequire("6NXwY"));
var $19527114ab6c974a$var$originalKeys = Object.keys;
$19527114ab6c974a$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($9QzFm(object)) return $19527114ab6c974a$var$originalKeys($19527114ab6c974a$var$slice.call(object));
            return $19527114ab6c974a$var$originalKeys(object);
        };
    } else Object.keys = $19527114ab6c974a$var$keysShim;
    return Object.keys || $19527114ab6c974a$var$keysShim;
};
module.exports = $19527114ab6c974a$var$keysShim;

});

parcelRegister("9QzFm", function(module, exports) {
'use strict';
var $72b4a2f3cb441a79$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $72b4a2f3cb441a79$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $72b4a2f3cb441a79$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("6NXwY", function(module, exports) {
'use strict';
var $4f457f4760cceef9$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $4f457f4760cceef9$var$has = Object.prototype.hasOwnProperty;
    var $4f457f4760cceef9$var$toStr = Object.prototype.toString;
    var $4f457f4760cceef9$var$isArgs = (parcelRequire("9QzFm")); // eslint-disable-line global-require
    var $4f457f4760cceef9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $4f457f4760cceef9$var$hasDontEnumBug = !$4f457f4760cceef9$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $4f457f4760cceef9$var$hasProtoEnumBug = $4f457f4760cceef9$var$isEnumerable.call(function() {}, 'prototype');
    var $4f457f4760cceef9$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $4f457f4760cceef9$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $4f457f4760cceef9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $4f457f4760cceef9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$4f457f4760cceef9$var$excludedKeys['$' + k] && $4f457f4760cceef9$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $4f457f4760cceef9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $4f457f4760cceef9$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$4f457f4760cceef9$var$hasAutomationEqualityBug) return $4f457f4760cceef9$var$equalsConstructorPrototype(o);
        try {
            return $4f457f4760cceef9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $4f457f4760cceef9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $4f457f4760cceef9$var$toStr.call(object) === '[object Function]';
        var isArguments = $4f457f4760cceef9$var$isArgs(object);
        var isString = isObject && $4f457f4760cceef9$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $4f457f4760cceef9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$4f457f4760cceef9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $4f457f4760cceef9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($4f457f4760cceef9$var$hasDontEnumBug) {
            var skipConstructor = $4f457f4760cceef9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $4f457f4760cceef9$var$dontEnums.length; ++k)if (!(skipConstructor && $4f457f4760cceef9$var$dontEnums[k] === 'constructor') && $4f457f4760cceef9$var$has.call(object, $4f457f4760cceef9$var$dontEnums[k])) theKeys.push($4f457f4760cceef9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $4f457f4760cceef9$var$keysShim;

});

parcelRegister("aKQxr", function(module, exports) {
'use strict';

var $iZo8r = parcelRequire("iZo8r");

module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $iZo8r;
};

});

parcelRegister("iZo8r", function(module, exports) {
'use strict';
var $dd30a53fbc79558f$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($dd30a53fbc79558f$var$numberIsNaN(a) && $dd30a53fbc79558f$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("ilKc6", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $d5be055d9baf98a0$var$_slicedToArray(arr, i) {
    return $d5be055d9baf98a0$var$_arrayWithHoles(arr) || $d5be055d9baf98a0$var$_iterableToArrayLimit(arr, i) || $d5be055d9baf98a0$var$_unsupportedIterableToArray(arr, i) || $d5be055d9baf98a0$var$_nonIterableRest();
}
function $d5be055d9baf98a0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d5be055d9baf98a0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d5be055d9baf98a0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d5be055d9baf98a0$var$_arrayLikeToArray(o, minLen);
}
function $d5be055d9baf98a0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d5be055d9baf98a0$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d5be055d9baf98a0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d5be055d9baf98a0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d5be055d9baf98a0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d5be055d9baf98a0$var$_typeof(o);
}
var $d5be055d9baf98a0$var$regexFlagsSupported = /a/g.flags !== undefined;
var $d5be055d9baf98a0$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $d5be055d9baf98a0$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $d5be055d9baf98a0$var$objectIs = Object.is ? Object.is : (parcelRequire("29nQp"));
var $d5be055d9baf98a0$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $d5be055d9baf98a0$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("ojU0q"));
function $d5be055d9baf98a0$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $d5be055d9baf98a0$var$hasOwnProperty = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.hasOwnProperty);
var $d5be055d9baf98a0$var$propertyIsEnumerable = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $d5be055d9baf98a0$var$objectToString = $d5be055d9baf98a0$var$uncurryThis(Object.prototype.toString);

var $7T2Y0 = parcelRequire("7T2Y0");

var $d5be055d9baf98a0$require$_require$types = $7T2Y0.types;
var $d5be055d9baf98a0$var$isAnyArrayBuffer = $d5be055d9baf98a0$require$_require$types.isAnyArrayBuffer, $d5be055d9baf98a0$var$isArrayBufferView = $d5be055d9baf98a0$require$_require$types.isArrayBufferView, $d5be055d9baf98a0$var$isDate = $d5be055d9baf98a0$require$_require$types.isDate, $d5be055d9baf98a0$var$isMap = $d5be055d9baf98a0$require$_require$types.isMap, $d5be055d9baf98a0$var$isRegExp = $d5be055d9baf98a0$require$_require$types.isRegExp, $d5be055d9baf98a0$var$isSet = $d5be055d9baf98a0$require$_require$types.isSet, $d5be055d9baf98a0$var$isNativeError = $d5be055d9baf98a0$require$_require$types.isNativeError, $d5be055d9baf98a0$var$isBoxedPrimitive = $d5be055d9baf98a0$require$_require$types.isBoxedPrimitive, $d5be055d9baf98a0$var$isNumberObject = $d5be055d9baf98a0$require$_require$types.isNumberObject, $d5be055d9baf98a0$var$isStringObject = $d5be055d9baf98a0$require$_require$types.isStringObject, $d5be055d9baf98a0$var$isBooleanObject = $d5be055d9baf98a0$require$_require$types.isBooleanObject, $d5be055d9baf98a0$var$isBigIntObject = $d5be055d9baf98a0$require$_require$types.isBigIntObject, $d5be055d9baf98a0$var$isSymbolObject = $d5be055d9baf98a0$require$_require$types.isSymbolObject, $d5be055d9baf98a0$var$isFloat32Array = $d5be055d9baf98a0$require$_require$types.isFloat32Array, $d5be055d9baf98a0$var$isFloat64Array = $d5be055d9baf98a0$require$_require$types.isFloat64Array;
function $d5be055d9baf98a0$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $d5be055d9baf98a0$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($d5be055d9baf98a0$var$isNonIndex).concat($d5be055d9baf98a0$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $d5be055d9baf98a0$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $d5be055d9baf98a0$var$ONLY_ENUMERABLE = undefined;
var $d5be055d9baf98a0$var$kStrict = true;
var $d5be055d9baf98a0$var$kLoose = false;
var $d5be055d9baf98a0$var$kNoIterator = 0;
var $d5be055d9baf98a0$var$kIsArray = 1;
var $d5be055d9baf98a0$var$kIsSet = 2;
var $d5be055d9baf98a0$var$kIsMap = 3;
// Check if they have the same source and flags
function $d5be055d9baf98a0$var$areSimilarRegExps(a, b) {
    return $d5be055d9baf98a0$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $d5be055d9baf98a0$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $d5be055d9baf98a0$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $d5be055d9baf98a0$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $d5be055d9baf98a0$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $d5be055d9baf98a0$var$isEqualBoxedPrimitive(val1, val2) {
    if ($d5be055d9baf98a0$var$isNumberObject(val1)) return $d5be055d9baf98a0$var$isNumberObject(val2) && $d5be055d9baf98a0$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($d5be055d9baf98a0$var$isStringObject(val1)) return $d5be055d9baf98a0$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($d5be055d9baf98a0$var$isBooleanObject(val1)) return $d5be055d9baf98a0$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($d5be055d9baf98a0$var$isBigIntObject(val1)) return $d5be055d9baf98a0$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $d5be055d9baf98a0$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $d5be055d9baf98a0$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($d5be055d9baf98a0$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $d5be055d9baf98a0$var$numberIsNaN(val1) && $d5be055d9baf98a0$var$numberIsNaN(val2);
        if ($d5be055d9baf98a0$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $d5be055d9baf98a0$var$_typeof(val1) !== 'object') {
            if (val2 === null || $d5be055d9baf98a0$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $d5be055d9baf98a0$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $d5be055d9baf98a0$var$objectToString(val1);
    var val2Tag = $d5be055d9baf98a0$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val1, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        var keys2 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val2, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$d5be055d9baf98a0$var$isMap(val1) && $d5be055d9baf98a0$var$isMap(val2) || !$d5be055d9baf98a0$var$isSet(val1) && $d5be055d9baf98a0$var$isSet(val2)) return false;
    }
    if ($d5be055d9baf98a0$var$isDate(val1)) {
        if (!$d5be055d9baf98a0$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($d5be055d9baf98a0$var$isRegExp(val1)) {
        if (!$d5be055d9baf98a0$var$isRegExp(val2) || !$d5be055d9baf98a0$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($d5be055d9baf98a0$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($d5be055d9baf98a0$var$isArrayBufferView(val1)) {
        if (!strict && ($d5be055d9baf98a0$var$isFloat32Array(val1) || $d5be055d9baf98a0$var$isFloat64Array(val1))) {
            if (!$d5be055d9baf98a0$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$d5be055d9baf98a0$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val1, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        var _keys2 = $d5be055d9baf98a0$var$getOwnNonIndexProperties(val2, $d5be055d9baf98a0$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kNoIterator, _keys);
    } else if ($d5be055d9baf98a0$var$isSet(val1)) {
        if (!$d5be055d9baf98a0$var$isSet(val2) || val1.size !== val2.size) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsSet);
    } else if ($d5be055d9baf98a0$var$isMap(val1)) {
        if (!$d5be055d9baf98a0$var$isMap(val2) || val1.size !== val2.size) return false;
        return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kIsMap);
    } else if ($d5be055d9baf98a0$var$isAnyArrayBuffer(val1)) {
        if (!$d5be055d9baf98a0$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($d5be055d9baf98a0$var$isBoxedPrimitive(val1) && !$d5be055d9baf98a0$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, $d5be055d9baf98a0$var$kNoIterator);
}
function $d5be055d9baf98a0$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $d5be055d9baf98a0$var$propertyIsEnumerable(val, k);
    });
}
function $d5be055d9baf98a0$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$d5be055d9baf98a0$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($d5be055d9baf98a0$var$propertyIsEnumerable(val1, key)) {
                    if (!$d5be055d9baf98a0$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($d5be055d9baf98a0$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $d5be055d9baf98a0$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $d5be055d9baf98a0$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $d5be055d9baf98a0$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $d5be055d9baf98a0$var$kNoIterator || iterationType === $d5be055d9baf98a0$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $d5be055d9baf98a0$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $d5be055d9baf98a0$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $d5be055d9baf98a0$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($d5be055d9baf98a0$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim) {
    switch($d5be055d9baf98a0$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($d5be055d9baf98a0$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $d5be055d9baf98a0$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $d5be055d9baf98a0$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$d5be055d9baf98a0$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $d5be055d9baf98a0$var$innerDeepEqual(item, curB, false, memo);
}
function $d5be055d9baf98a0$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $d5be055d9baf98a0$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($d5be055d9baf98a0$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$d5be055d9baf98a0$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $d5be055d9baf98a0$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($d5be055d9baf98a0$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$d5be055d9baf98a0$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$d5be055d9baf98a0$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $d5be055d9baf98a0$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $d5be055d9baf98a0$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($d5be055d9baf98a0$var$innerDeepEqual(key1, key2, strict, memo) && $d5be055d9baf98a0$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $d5be055d9baf98a0$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $d5be055d9baf98a0$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $d5be055d9baf98a0$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($d5be055d9baf98a0$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$d5be055d9baf98a0$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$d5be055d9baf98a0$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $d5be055d9baf98a0$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $d5be055d9baf98a0$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($d5be055d9baf98a0$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$d5be055d9baf98a0$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$d5be055d9baf98a0$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$d5be055d9baf98a0$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $d5be055d9baf98a0$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $d5be055d9baf98a0$var$kIsSet) {
        if (!$d5be055d9baf98a0$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $d5be055d9baf98a0$var$kIsMap) {
        if (!$d5be055d9baf98a0$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $d5be055d9baf98a0$var$kIsArray) for(; i < a.length; i++){
        if ($d5be055d9baf98a0$var$hasOwnProperty(a, i)) {
            if (!$d5be055d9baf98a0$var$hasOwnProperty(b, i) || !$d5be055d9baf98a0$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($d5be055d9baf98a0$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$d5be055d9baf98a0$var$hasOwnProperty(b, key) || !$d5be055d9baf98a0$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$d5be055d9baf98a0$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $d5be055d9baf98a0$var$isDeepEqual(val1, val2) {
    return $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, $d5be055d9baf98a0$var$kLoose);
}
function $d5be055d9baf98a0$var$isDeepStrictEqual(val1, val2) {
    return $d5be055d9baf98a0$var$innerDeepEqual(val1, val2, $d5be055d9baf98a0$var$kStrict);
}
module.exports = {
    isDeepEqual: $d5be055d9baf98a0$var$isDeepEqual,
    isDeepStrictEqual: $d5be055d9baf98a0$var$isDeepStrictEqual
};

});

parcelRegister("29nQp", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");


var $26J2z = parcelRequire("26J2z");


var $iZo8r = parcelRequire("iZo8r");


var $aKQxr = parcelRequire("aKQxr");


var $h9z8p = parcelRequire("h9z8p");

var $190eeb03c4f85517$var$polyfill = $26J2z($aKQxr(), Object);
$eGbn7($190eeb03c4f85517$var$polyfill, {
    getPolyfill: $aKQxr,
    implementation: $iZo8r,
    shim: $h9z8p
});
module.exports = $190eeb03c4f85517$var$polyfill;

});

parcelRegister("eGbn7", function(module, exports) {
'use strict';

var $2aMTq = parcelRequire("2aMTq");

var $aafdcf22e1319c4a$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $aafdcf22e1319c4a$var$toStr = Object.prototype.toString;
var $aafdcf22e1319c4a$var$concat = Array.prototype.concat;

var $iFj39 = parcelRequire("iFj39");

var $aafdcf22e1319c4a$var$isFunction = function(fn) {
    return typeof fn === 'function' && $aafdcf22e1319c4a$var$toStr.call(fn) === '[object Function]';
};

var $aafdcf22e1319c4a$var$supportsDescriptors = (parcelRequire("9CFxa"))();
var $aafdcf22e1319c4a$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$aafdcf22e1319c4a$var$isFunction(predicate) || !predicate()) return;
    }
    if ($aafdcf22e1319c4a$var$supportsDescriptors) $iFj39(object, name, value, true);
    else $iFj39(object, name, value);
};
var $aafdcf22e1319c4a$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $2aMTq(map);
    if ($aafdcf22e1319c4a$var$hasSymbols) props = $aafdcf22e1319c4a$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$aafdcf22e1319c4a$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$aafdcf22e1319c4a$var$defineProperties.supportsDescriptors = !!$aafdcf22e1319c4a$var$supportsDescriptors;
module.exports = $aafdcf22e1319c4a$var$defineProperties;

});

parcelRegister("h9z8p", function(module, exports) {
'use strict';

var $aKQxr = parcelRequire("aKQxr");


var $eGbn7 = parcelRequire("eGbn7");

module.exports = function shimObjectIs() {
    var polyfill = $aKQxr();
    $eGbn7(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("ojU0q", function(module, exports) {
'use strict';

var $26J2z = parcelRequire("26J2z");


var $eGbn7 = parcelRequire("eGbn7");


var $5PvCl = parcelRequire("5PvCl");


var $15HFT = parcelRequire("15HFT");


var $99fDU = parcelRequire("99fDU");

var $0491ae3133badd22$var$polyfill = $26J2z($15HFT(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $eGbn7($0491ae3133badd22$var$polyfill, {
    getPolyfill: $15HFT,
    implementation: $5PvCl,
    shim: $99fDU
});
module.exports = $0491ae3133badd22$var$polyfill;

});

parcelRegister("5PvCl", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("15HFT", function(module, exports) {
'use strict';

var $5PvCl = parcelRequire("5PvCl");

module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $5PvCl;
};

});

parcelRegister("99fDU", function(module, exports) {
'use strict';

var $eGbn7 = parcelRequire("eGbn7");


var $15HFT = parcelRequire("15HFT");

/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $15HFT();
    $eGbn7(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});

parcelRegister("nStJY", function(module, exports) {

var $gO7n9 = parcelRequire("gO7n9");


var $jPzTX = parcelRequire("jPzTX");

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $047c686ddfb588a6$var$pick = $jPzTX(function(object, paths) {
    return object == null ? {} : $gO7n9(object, paths);
});
module.exports = $047c686ddfb588a6$var$pick;

});

parcelRegister("gO7n9", function(module, exports) {

var $3Bix5 = parcelRequire("3Bix5");


var $h7loT = parcelRequire("h7loT");

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $c3c708e20cb40f59$var$basePick(object, paths) {
    return $3Bix5(object, paths, function(value, path) {
        return $h7loT(object, path);
    });
}
module.exports = $c3c708e20cb40f59$var$basePick;

});

parcelRegister("8Bx1z", function(module, exports) {
"use strict";
var $643b655b3a668be3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */ function $643b655b3a668be3$var$filter(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $643b655b3a668be3$var$FilterOperator(predicate, thisArg));
    };
}
module.exports.filter = $643b655b3a668be3$var$filter;
var $643b655b3a668be3$var$FilterOperator = function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $643b655b3a668be3$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $643b655b3a668be3$var$FilterSubscriber = function(_super) {
    $643b655b3a668be3$var$__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=filter.js.map

});

parcelRegister("eeWDH", function(module, exports) {
"use strict";
var $a5dfdc0a1bdb1c58$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");


var $kjYch = parcelRequire("kjYch");

/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */ function $a5dfdc0a1bdb1c58$var$take(count) {
    return function(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else return source.lift(new $a5dfdc0a1bdb1c58$var$TakeOperator(count));
    };
}
module.exports.take = $a5dfdc0a1bdb1c58$var$take;
var $a5dfdc0a1bdb1c58$var$TakeOperator = function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5dfdc0a1bdb1c58$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5dfdc0a1bdb1c58$var$TakeSubscriber = function(_super) {
    $a5dfdc0a1bdb1c58$var$__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=take.js.map

});

parcelRegister("atSr0", function(module, exports) {
"use strict";
var $7a16d669c235c821$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */ var $7a16d669c235c821$var$ArgumentOutOfRangeError = function(_super) {
    $7a16d669c235c821$var$__extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error);
module.exports.ArgumentOutOfRangeError = $7a16d669c235c821$var$ArgumentOutOfRangeError; //# sourceMappingURL=ArgumentOutOfRangeError.js.map

});

parcelRegister("34cAP", function(module, exports) {
$parcel$export(module.exports, "toArray", () => $23bb83863f0fc948$export$45b10814cc054894, (v) => $23bb83863f0fc948$export$45b10814cc054894 = v);
var $23bb83863f0fc948$export$45b10814cc054894;
"use strict";

var $7bBVm = parcelRequire("7bBVm");

function $23bb83863f0fc948$var$toArrayReducer(arr, item, index) {
    if (index === 0) return [
        item
    ];
    arr.push(item);
    return arr;
}
function $23bb83863f0fc948$var$toArray() {
    return $7bBVm.reduce($23bb83863f0fc948$var$toArrayReducer, []);
}
$23bb83863f0fc948$export$45b10814cc054894 = $23bb83863f0fc948$var$toArray; //# sourceMappingURL=toArray.js.map

});

parcelRegister("7bBVm", function(module, exports) {
$parcel$export(module.exports, "reduce", () => $53b6fa7559558246$export$533b26079ad0b4b, (v) => $53b6fa7559558246$export$533b26079ad0b4b = v);
var $53b6fa7559558246$export$533b26079ad0b4b;
"use strict";

var $bbCp3 = parcelRequire("bbCp3");


var $lQvgf = parcelRequire("lQvgf");


var $dTFgb = parcelRequire("dTFgb");


var $kPZwo = parcelRequire("kPZwo");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */ function $53b6fa7559558246$var$reduce(accumulator, seed) {
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) return function reduceOperatorFunctionWithSeed(source) {
        return $kPZwo.pipe($bbCp3.scan(accumulator, seed), $lQvgf.takeLast(1), $dTFgb.defaultIfEmpty(seed))(source);
    };
    return function reduceOperatorFunction(source) {
        return $kPZwo.pipe($bbCp3.scan(function(acc, value, index) {
            return accumulator(acc, value, index + 1);
        }), $lQvgf.takeLast(1))(source);
    };
}
$53b6fa7559558246$export$533b26079ad0b4b = $53b6fa7559558246$var$reduce; //# sourceMappingURL=reduce.js.map

});

parcelRegister("bbCp3", function(module, exports) {
"use strict";
var $824e82d9ed0a6633$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */ function $824e82d9ed0a6633$var$scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) hasSeed = true;
    return function scanOperatorFunction(source) {
        return source.lift(new $824e82d9ed0a6633$var$ScanOperator(accumulator, seed, hasSeed));
    };
}
module.exports.scan = $824e82d9ed0a6633$var$scan;
var $824e82d9ed0a6633$var$ScanOperator = function() {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) hasSeed = false;
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $824e82d9ed0a6633$var$ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $824e82d9ed0a6633$var$ScanSubscriber = function(_super) {
    $824e82d9ed0a6633$var$__extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function() {
            return this._seed;
        },
        set: function(value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function(value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        } else return this._tryNext(value);
    };
    ScanSubscriber.prototype._tryNext = function(value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        } catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=scan.js.map

});

parcelRegister("lQvgf", function(module, exports) {
"use strict";
var $fe76b4167e522f00$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $atSr0 = parcelRequire("atSr0");


var $kjYch = parcelRequire("kjYch");

/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */ function $fe76b4167e522f00$var$takeLast(count) {
    return function takeLastOperatorFunction(source) {
        if (count === 0) return new $kjYch.EmptyObservable();
        else return source.lift(new $fe76b4167e522f00$var$TakeLastOperator(count));
    };
}
module.exports.takeLast = $fe76b4167e522f00$var$takeLast;
var $fe76b4167e522f00$var$TakeLastOperator = function() {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) throw new $atSr0.ArgumentOutOfRangeError;
    }
    TakeLastOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fe76b4167e522f00$var$TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $fe76b4167e522f00$var$TakeLastSubscriber = function(_super) {
    $fe76b4167e522f00$var$__extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function(value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) ring.push(value);
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function() {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for(var i = 0; i < total; i++){
                var idx = count++ % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=takeLast.js.map

});

parcelRegister("dTFgb", function(module, exports) {
"use strict";
var $a1e06aced5e020ea$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/* tslint:enable:max-line-length */ /**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */ function $a1e06aced5e020ea$var$defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $a1e06aced5e020ea$var$DefaultIfEmptyOperator(defaultValue));
    };
}
module.exports.defaultIfEmpty = $a1e06aced5e020ea$var$defaultIfEmpty;
var $a1e06aced5e020ea$var$DefaultIfEmptyOperator = function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a1e06aced5e020ea$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a1e06aced5e020ea$var$DefaultIfEmptySubscriber = function(_super) {
    $a1e06aced5e020ea$var$__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=defaultIfEmpty.js.map

});

parcelRegister("lv9Cv", function(module, exports) {
$parcel$export(module.exports, "of", () => $fa73f494791b08e6$export$ba255e9e49e00608, (v) => $fa73f494791b08e6$export$ba255e9e49e00608 = v);
var $fa73f494791b08e6$export$ba255e9e49e00608;
"use strict";

var $hmT2x = parcelRequire("hmT2x");

$fa73f494791b08e6$export$ba255e9e49e00608 = $hmT2x.ArrayObservable.of; //# sourceMappingURL=of.js.map

});

parcelRegister("hrJHY", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $1XTds = parcelRequire("1XTds");

/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */ function delay(delay, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteDelay = $fEWBj.isDate(delay);
    var delayFor = absoluteDelay ? +delay - scheduler.now() : Math.abs(delay);
    return function(source) {
        return source.lift(new DelayOperator(delayFor, scheduler));
    };
}
exports.delay = delay;
var DelayOperator = function() {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var DelaySubscriber = function(_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function(state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while(queue.length > 0 && queue[0].time - scheduler.now() <= 0)queue.shift().notification.observe(destination);
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        } else {
            this.unsubscribe();
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function(scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this,
            destination: this.destination,
            scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function(notification) {
        if (this.errored === true) return;
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) this._schedule(scheduler);
    };
    DelaySubscriber.prototype._next = function(value) {
        this.scheduleNotification($1XTds.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function(err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function() {
        this.scheduleNotification($1XTds.Notification.createComplete());
    };
    return DelaySubscriber;
}($fNVRJ.Subscriber);
var DelayMessage = function() {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}(); //# sourceMappingURL=delay.js.map

});

parcelRegister("zAMIg", function(module, exports) {
$parcel$export(module.exports, "async", () => $06afcdac526dbf67$export$12af436354f1a4f7, (v) => $06afcdac526dbf67$export$12af436354f1a4f7 = v);
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */ var $06afcdac526dbf67$export$12af436354f1a4f7;
"use strict";

var $1HJiA = parcelRequire("1HJiA");


var $fJ8RQ = parcelRequire("fJ8RQ");

$06afcdac526dbf67$export$12af436354f1a4f7 = new $fJ8RQ.AsyncScheduler($1HJiA.AsyncAction); //# sourceMappingURL=async.js.map

});

parcelRegister("fEWBj", function(module, exports) {
$parcel$export(module.exports, "isDate", () => $b6680c598ae7a287$export$871608497c498473, (v) => $b6680c598ae7a287$export$871608497c498473 = v);
var $b6680c598ae7a287$export$871608497c498473;
"use strict";
function $b6680c598ae7a287$var$isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
$b6680c598ae7a287$export$871608497c498473 = $b6680c598ae7a287$var$isDate; //# sourceMappingURL=isDate.js.map

});

parcelRegister("9Hb6D", function(module, exports) {
$parcel$export(module.exports, "merge", () => $70f0bea37c3dd158$export$4950aa0f605343fb, (v) => $70f0bea37c3dd158$export$4950aa0f605343fb = v);
var $70f0bea37c3dd158$export$4950aa0f605343fb;
"use strict";

var $1pK8e = parcelRequire("1pK8e");


var $hmT2x = parcelRequire("hmT2x");


var $lRrDg = parcelRequire("lRrDg");


var $c9SbF = parcelRequire("c9SbF");

/* tslint:enable:max-line-length */ /**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */ function $70f0bea37c3dd158$var$merge() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ($lRrDg.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') concurrent = observables.pop();
    } else if (typeof last === 'number') concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof $1pK8e.Observable) return observables[0];
    return $c9SbF.mergeAll(concurrent)(new $hmT2x.ArrayObservable(observables, scheduler));
}
$70f0bea37c3dd158$export$4950aa0f605343fb = $70f0bea37c3dd158$var$merge; //# sourceMappingURL=merge.js.map

});

parcelRegister("c9SbF", function(module, exports) {
$parcel$export(module.exports, "mergeAll", () => $8da05bbe9f24d995$export$18aef43295bbe906, (v) => $8da05bbe9f24d995$export$18aef43295bbe906 = v);
var $8da05bbe9f24d995$export$18aef43295bbe906;
"use strict";

var $inXGV = parcelRequire("inXGV");


var $lIS42 = parcelRequire("lIS42");

/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */ function $8da05bbe9f24d995$var$mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return $inXGV.mergeMap($lIS42.identity, null, concurrent);
}
$8da05bbe9f24d995$export$18aef43295bbe906 = $8da05bbe9f24d995$var$mergeAll; //# sourceMappingURL=mergeAll.js.map

});

parcelRegister("lIS42", function(module, exports) {
$parcel$export(module.exports, "identity", () => $fd07a50b5336926a$export$f0954fd7d5368655, (v) => $fd07a50b5336926a$export$f0954fd7d5368655 = v);
var $fd07a50b5336926a$export$f0954fd7d5368655;
"use strict";
function $fd07a50b5336926a$var$identity(x) {
    return x;
}
$fd07a50b5336926a$export$f0954fd7d5368655 = $fd07a50b5336926a$var$identity; //# sourceMappingURL=identity.js.map

});

parcelRegister("aK1EY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $7oSFe = parcelRequire("7oSFe");


const $f1b26a0986b97fb7$var$LazyDatasourceTableView = /*#__PURE__*/ (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-Ocxnls", ()=>(parcelRequire("2z3pw")).then((module)=>({
            default: module.DatasourceTableView
        }))));
const $f1b26a0986b97fb7$export$2f5bdb66685d3fb4 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? function DatasourceTableViewWithWrappers(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "datasource-table-view-suspense"
        });
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: t0,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$LazyDatasourceTableView, {
                ...props
            })
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function DatasourceTableViewWithWrappers(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": 'datasource-table-view-suspense'
        }),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($f1b26a0986b97fb7$var$LazyDatasourceTableView, {
            ...props
        })
    });
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
module.exports["DatasourceTableViewWithWrappers"] = $f1b26a0986b97fb7$export$2f5bdb66685d3fb4;

});

parcelRegister("2z3pw", function(module, exports) {

let $1de17ef4fc8d19c0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1de17ef4fc8d19c0$var$load("iAsDQ"),
    $1de17ef4fc8d19c0$var$load("2xoIF"),
    $1de17ef4fc8d19c0$var$load("i7NGK"),
    $1de17ef4fc8d19c0$var$load("6wr18"),
    $1de17ef4fc8d19c0$var$load("9LJFK"),
    $1de17ef4fc8d19c0$var$load("d66hN"),
    $1de17ef4fc8d19c0$var$load("1ElkK"),
    $1de17ef4fc8d19c0$var$load("gWjIZ"),
    $1de17ef4fc8d19c0$var$load("iQvHF"),
    $1de17ef4fc8d19c0$var$load("dxA9F"),
    $1de17ef4fc8d19c0$var$load("bkMxV"),
    $1de17ef4fc8d19c0$var$load("jmTCk"),
    $1de17ef4fc8d19c0$var$load("iWnyc"),
    $1de17ef4fc8d19c0$var$load("ffEVr"),
    $1de17ef4fc8d19c0$var$load("hhss7"),
    $1de17ef4fc8d19c0$var$load("9TOep"),
    $1de17ef4fc8d19c0$var$load("bncmK"),
    $1de17ef4fc8d19c0$var$load("7EorR"),
    $1de17ef4fc8d19c0$var$load("3WGfe")
]).then(()=>parcelRequire('khl4A'));

});

parcelRegister("fbHl6", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7oSFe = parcelRequire("7oSFe");


const $14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy((0, $7oSFe.trackReactLazy)("rl-QQZCbK", ()=>(parcelRequire("cueDJ"))));
const $14d0cd645fed394d$export$f386473e8f104bcb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
                ...props
            })
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($14d0cd645fed394d$var$LazyDatasourceRenderFailedAnalyticsWrapper, {
            ...props
        })
    });
module.exports["LazyLoadedDatasourceRenderFailedAnalyticsWrapper"] = $14d0cd645fed394d$export$f386473e8f104bcb;

});

parcelRegister("cueDJ", function(module, exports) {

let $9173a48e434958c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9173a48e434958c3$var$load("bzl94").then(()=>parcelRequire('j30TZ'));

});

parcelRegister("b2XFx", function(module, exports) {
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $8VfSP = parcelRequire("8VfSP");


var $V3JOP = parcelRequire("V3JOP");


var $gDx2k = parcelRequire("gDx2k");


var $4o0zT = parcelRequire("4o0zT");


var $l8Rhq = parcelRequire("l8Rhq");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $ieeJu = parcelRequire("ieeJu");


var $eaCAt = parcelRequire("eaCAt");

var $krYZG = parcelRequire("krYZG");


var $bI2nS = parcelRequire("bI2nS");

function $4e976cfe241fa7a6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Dynamic padding value that adjusts based on the editor's base font size.
 * When base font size is <= akEditorFullPageDenseFontSize (13px), uses 1px padding.
 * Otherwise, uses default value with token('space.025').
 */ const $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK = `clamp(1px, calc((var(--ak-editor-base-font-size, ${(0, $7Y8M5.akEditorFullPageDefaultFontSize)}px) - ${(0, $7Y8M5.akEditorFullPageDenseFontSize)}px) * 999), ${"var(--ds-space-025, 2px)"})`;
const $4e976cfe241fa7a6$var$containerStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $4e976cfe241fa7a6$var$iconWrapperStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '17px',
    width: '17px'
});
const $4e976cfe241fa7a6$var$hiddenTextStyle = {
    name: "1hr6gib",
    styles: "overflow:hidden;white-space:nowrap;position:absolute;visibility:hidden"
};
const $4e976cfe241fa7a6$var$linkStylesCommon = (0, $buxP3.xcss)({
    position: 'absolute',
    left: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
    paddingBlock: 'space.025',
    paddingInline: 'space.050',
    gap: 'space.025',
    overflow: 'hidden',
    zIndex: 'card',
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: "var(--ds-radius-small, 3px)",
    color: 'color.text.subtle',
    textDecoration: 'none',
    whiteSpace: 'nowrap',
    top: '0px',
    height: '1.2em',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        color: 'color.text.subtle',
        textDecoration: 'none'
    }
});
const $4e976cfe241fa7a6$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY = 45;
const $4e976cfe241fa7a6$var$ICON_WIDTH = 16;
const $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH = 28; // Default open text width in English
const $4e976cfe241fa7a6$var$visitCardLinkAnalytics = (editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $kCECX.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi?.attachAnalyticsEvent((0, $eaCAt.buildVisitedNonHyperLinkPayload)(type.name, inputMethod))(tr);
            dispatch(tr);
        }
        return true;
    };
const $4e976cfe241fa7a6$var$HoverLinkOverlay = ({ children: children, isVisible: isVisible = false, url: url, destinationUrl: destinationUrl, compactPadding: compactPadding = false, editorAnalyticsApi: editorAnalyticsApi, view: view, onClick: onClick, showPanelButton: showPanelButton = false, showPanelButtonIcon: showPanelButtonIcon })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const containerRef = (0, $cozmU.useRef)(null);
    const hoverLinkButtonRef = (0, $cozmU.useRef)(null);
    const hiddenTextRef = (0, $cozmU.useRef)(null);
    const [showLabel, setShowLabel] = (0, $cozmU.useState)(true);
    const [isHovered, setHovered] = (0, $cozmU.useState)(false);
    const openTextWidthRef = (0, $cozmU.useRef)(null);
    const regularPadding = $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK;
    const memoizedHoverLinkStyles = (0, $cozmU.useMemo)(()=>({
            paddingBlock: compactPadding ? '1px' : regularPadding
        }), [
        compactPadding,
        regularPadding
    ]);
    const hoverLinkStyles = (0, $4o0zT.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedHoverLinkStyles : {
        paddingBlock: compactPadding ? '1px' : $4e976cfe241fa7a6$var$DYNAMIC_PADDING_BLOCK
    };
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!isVisible || !isHovered) return;
        const cardWidth = containerRef.current?.offsetWidth;
        const openButtonWidth = hoverLinkButtonRef.current?.offsetWidth;
        // Get the hidden text width
        if (!openTextWidthRef.current) {
            const hiddenText = hiddenTextRef.current;
            if (hiddenText) {
                // Measure the width of the hidden text
                // Temporarily make the element visible to measure its width
                hiddenText.style.visibility = 'hidden';
                hiddenText.style.display = 'inline';
                openTextWidthRef.current = hiddenText.offsetWidth;
                // Reset the hiddenText's display property
                hiddenText.style.display = 'none';
                hiddenText.style.visibility = 'inherit';
            } else openTextWidthRef.current = $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH;
        }
        if (!cardWidth || !openButtonWidth) return;
        const openTextWidth = openTextWidthRef.current || $4e976cfe241fa7a6$var$DEFAULT_OPEN_TEXT_WIDTH;
        let canShowLabel = cardWidth - openTextWidth > $4e976cfe241fa7a6$var$MIN_AVAILABLE_SPACE_WITH_LABEL_OVERLAY + $4e976cfe241fa7a6$var$ICON_WIDTH;
        // When a smart link wraps to multiple lines in a constrained container (e.g. table cell),
        // the hover button can overflow beyond the container bounds. We detect this by comparing
        // the button's right edge to the container's right edge, and hide the label if it overflows.
        if (containerRef.current && hoverLinkButtonRef.current) {
            const containerRight = containerRef.current.getBoundingClientRect().right;
            const buttonRight = hoverLinkButtonRef.current.getBoundingClientRect().right;
            if (buttonRight > containerRight) canShowLabel = false;
        }
        setShowLabel(canShowLabel);
    }, [
        isVisible,
        isHovered
    ]);
    const handleOverlayChange = (isHovered)=>{
        setHovered(isHovered);
        // Reset label visibility on hover start so we can measure if it overflows.
        // Without this, the label stays hidden from a previous hover and won't be re-measured.
        if (isHovered) setShowLabel(true);
    };
    const sendVisitLinkAnalytics = (inputMethod)=>{
        if (editorAnalyticsApi && view) $4e976cfe241fa7a6$var$visitCardLinkAnalytics(editorAnalyticsApi, inputMethod)(view.state, view.dispatch);
    };
    const handleDoubleClick = ()=>{
        if (!showPanelButton) {
            sendVisitLinkAnalytics((0, $krYZG.INPUT_METHOD).DOUBLE_CLICK);
            // Double click opens the link in a new tab
            window.open(destinationUrl ?? url, '_blank');
        }
    };
    const handleClick = (event)=>{
        if (showPanelButton && onClick) onClick(event);
        else sendVisitLinkAnalytics((0, $krYZG.INPUT_METHOD).BUTTON);
    };
    const label = showPanelButton ? formatMessage((0, $bI2nS.messages).previewButtonTitle) : formatMessage((0, $bI2nS.messages).openButtonTitle);
    let icon = null;
    if (showPanelButton && showPanelButtonIcon === 'panel') icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gDx2k))), {
        label: ""
    });
    else if (showPanelButton && showPanelButtonIcon === 'modal') icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
        label: ""
    });
    else icon = /*#__PURE__*/ (0, $lOiVq.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))), {
        label: ""
    });
    return /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        ref: containerRef,
        css: $4e976cfe241fa7a6$var$containerStyles,
        onDoubleClick: handleDoubleClick,
        onMouseEnter: ()=>handleOverlayChange(true),
        onMouseLeave: ()=>handleOverlayChange(false),
        // No-op focus/blur handlers to satisfy a11y/mouse-events-have-key-events rule.
        // The hover overlay is a mouse convenience — keyboard users can access link actions
        // (open, preview) via the floating toolbar that appears on selection.
        onFocus: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined,
        onBlur: (0, $ieeJu.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? ()=>{} : undefined
    }, children, /*#__PURE__*/ (0, $lOiVq.jsx)("span", {
        css: $4e976cfe241fa7a6$var$hiddenTextStyle,
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), {
        ref: hiddenTextRef,
        size: "small",
        maxLines: 1
    }, label)), isHovered && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $l8Rhq.Anchor), {
        ref: hoverLinkButtonRef,
        xcss: $4e976cfe241fa7a6$var$linkStylesCommon,
        href: destinationUrl ?? url,
        target: "_blank",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic paddingBlock value based on experiment flags
        style: hoverLinkStyles,
        onClick: handleClick,
        testId: "inline-card-hoverlink-overlay"
    }, /*#__PURE__*/ (0, $lOiVq.jsx)((0, $3izAL.Box), {
        xcss: $4e976cfe241fa7a6$var$iconWrapperStyles,
        "data-inlinecard-button-overlay": "icon-wrapper-line-height",
        testId: "inline-card-hoverlink-overlay-icon"
    }, icon), showLabel && /*#__PURE__*/ (0, $lOiVq.jsx)((0, $6Pqow.Text), {
        size: "small",
        color: "color.text.subtle",
        maxLines: 1,
        testId: "inline-card-hoverlink-overlay-label"
    }, label)));
};
var $4e976cfe241fa7a6$export$2e2bcd8739ae039 = $4e976cfe241fa7a6$var$HoverLinkOverlay;
module.exports["default"] = $4e976cfe241fa7a6$export$2e2bcd8739ae039;

});

parcelRegister("gybyF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $bI14T = parcelRequire("bI14T");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $apFwO = parcelRequire("apFwO");


var $jINxM = parcelRequire("jINxM");


var $2FmJb = parcelRequire("2FmJb");


var $dM7c5 = parcelRequire("dM7c5");


var $kG7AM = parcelRequire("kG7AM");


var $kfxZm = parcelRequire("kfxZm");


var $cEvdy = parcelRequire("cEvdy");


var $dz9dk = parcelRequire("dz9dk");


var $9H66G = parcelRequire("9H66G");

function $f78fd23812cb38dc$export$a95296ded9241771({ url: url, appearance: appearance, origin: origin, actionOptions: actionOptions, prefetch: prefetch }) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const id = (0, $cozmU.useMemo)(()=>(0, $03RpJ.default)(), []);
    const linkState = (0, $9H66G.useSmartCardState)(url);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $bI14T.useSmartLinkContext)();
    const invokeClientAction = (0, $kfxZm.default)({
        fireEvent: fireEvent
    });
    const resolve = (0, $cEvdy.default)();
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapper)({
        details: linkState.details
    });
    if ((0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && prefetch && !linkState.details) resolve({
        url: url
    });
    if (linkState.details && !actionOptions?.hide) {
        const actions = [];
        const invokeParam = {
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: linkState.details
        };
        const downloadActionProps = (0, $apFwO.extractInvokeDownloadAction)(invokeParam);
        if (downloadActionProps) actions.push((0, $kG7AM.toAction)(downloadActionProps, invokeClientAction, (0, $dM7c5.messages).download, 'download-content'));
        const viewActionProps = (0, $2FmJb.extractInvokeViewAction)({
            ...invokeParam,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        });
        if (viewActionProps) actions.push((0, $kG7AM.toAction)(viewActionProps, invokeClientAction, (0, $dM7c5.messages).view, 'view-content'));
        const previewActionProps = (0, $jINxM.extractInvokePreviewAction)({
            ...invokeParam,
            fireEvent: fireEvent,
            origin: origin,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $iDrrr.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: (destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl)
        });
        if (previewActionProps) actions.push((0, $kG7AM.toAction)(previewActionProps.invokeAction, invokeClientAction, (0, $dM7c5.messages).preview_improved, 'preview-content'));
        return actions;
    }
    return [];
}
module.exports["useSmartLinkActions"] = $f78fd23812cb38dc$export$a95296ded9241771;

});

parcelRegister("kG7AM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $658c5c09596e5d2b$export$9d52be0dab870c7 = (action, invokeClientAction, message, id)=>{
    return {
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), message),
        invoke: ()=>invokeClientAction(action)
    };
};
module.exports["toAction"] = $658c5c09596e5d2b$export$9d52be0dab870c7;

});

parcelRegister("2G2MI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $fodiz = parcelRequire("fodiz");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $gR535 = parcelRequire("gR535");

const $ccec193f181caf27$var$baseStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    cursor: 'pointer'
});
const $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS = [
    'atlassian.com',
    'loom.com',
    'dam-cdn.atl.orangelogic.com',
    'bitbucket.org'
];
const $ccec193f181caf27$export$babb68fb5c212c90 = (url)=>{
    if (!url) return false;
    // Check if URL is valid
    try {
        new URL(url);
    } catch  {
        return false;
    }
    const parsedUrl = new URL(url || '');
    const { hostname: hostname, pathname: pathname, protocol: protocol } = parsedUrl;
    if (protocol === 'data:') return pathname?.startsWith('image/');
    return Boolean(hostname && $ccec193f181caf27$var$NO_EXTERNAL_BADGE_HOSTS.some((host)=>hostname === host || hostname.endsWith(`.${host}`)));
};
const $ccec193f181caf27$export$66bf2ed7a5d4691f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { type: type, url: url } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $gR535.externalMediaMessages).externalMediaFile);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const message = t1;
    if (type !== "external" || $ccec193f181caf27$export$babb68fb5c212c90(url)) return null;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": "external-image-badge"
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== message) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
            label: message
        });
        $[3] = message;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== message || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
            padding: "space.050",
            xcss: $ccec193f181caf27$var$baseStyles,
            tabIndex: 0,
            children: [
                t2,
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: message,
                    position: "top",
                    children: t3
                })
            ]
        });
        $[5] = message;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ type: type, url: url })=>{
    const intl = (0, $kSwu1.useIntl)();
    const message = intl.formatMessage((0, $gR535.externalMediaMessages).externalMediaFile);
    if (type !== 'external' || $ccec193f181caf27$export$babb68fb5c212c90(url)) return null;
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $3izAL.Box), {
        padding: "space.050",
        xcss: $ccec193f181caf27$var$baseStyles,
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                "data-testid": "external-image-badge"
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: message,
                position: "top",
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
                    label: message
                })
            })
        ]
    });
};
module.exports["ExternalImageBadge"] = $ccec193f181caf27$export$66bf2ed7a5d4691f;

});

parcelRegister("gR535", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $211a5f48c385cec9$export$8e36294abfabe45e = (0, $kSwu1.defineMessages)({
    externalMediaFile: {
        id: "fabric.editor.externalMediaFile",
        defaultMessage: "External media file"
    }
});
module.exports["externalMediaMessages"] = $211a5f48c385cec9$export$8e36294abfabe45e;

});

parcelRegister("7UxJ0", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $etJ6B = parcelRequire("etJ6B");

const $a2c23c75d9cad129$export$6a31fc38737d0e58 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, children: children, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex } = t0;
    let t1;
    if ($[0] !== children || $[1] !== extendedResizeOffset || $[2] !== mediaElement || $[3] !== mediaHeight || $[4] !== mediaWidth || $[5] !== useMinimumZIndex) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $etJ6B.BlockNodeBadges), {
            element: mediaElement,
            width: mediaWidth,
            height: mediaHeight,
            extendedResizeOffset: extendedResizeOffset,
            useMinimumZIndex: useMinimumZIndex,
            children: children
        });
        $[0] = children;
        $[1] = extendedResizeOffset;
        $[2] = mediaElement;
        $[3] = mediaHeight;
        $[4] = mediaWidth;
        $[5] = useMinimumZIndex;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : ({ mediaElement: mediaElement, mediaWidth: mediaWidth, mediaHeight: mediaHeight, children: children, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $etJ6B.BlockNodeBadges), {
        element: mediaElement,
        width: mediaWidth,
        height: mediaHeight,
        extendedResizeOffset: extendedResizeOffset,
        useMinimumZIndex: useMinimumZIndex,
        children: children
    });
module.exports["MediaBadges"] = $a2c23c75d9cad129$export$6a31fc38737d0e58;

});

parcelRegister("etJ6B", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");

const $aebd7c0b6385469e$var$BADGE_VISIBILITY_BREAKPOINT = 200;
const $aebd7c0b6385469e$var$containerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: "var(--ds-space-200, 16px)",
    gap: 'space.025',
    zIndex: 'card',
    height: 'fit-content',
    width: 'fit-content',
    margin: 'space.075'
});
// The above styles are used for both editor and renderer, and in renderer the
// document body is the main scroll area. This means it overscrolls the primary
// toolbar, where the z-index is "2". We have to hack in our own z-index less
// than that to ensure our badge appears under the toolbar when scrolled.
const $aebd7c0b6385469e$var$hackedZIndexStyles = (0, $buxP3.xcss)({
    zIndex: '1'
});
const $aebd7c0b6385469e$var$resizeOffsetStyles = (0, $buxP3.xcss)({
    right: 'space.150'
});
const $aebd7c0b6385469e$var$getBadgeVisible = (width, height)=>{
    return width && width < $aebd7c0b6385469e$var$BADGE_VISIBILITY_BREAKPOINT || height && height < $aebd7c0b6385469e$var$BADGE_VISIBILITY_BREAKPOINT ? false : true;
};
const $aebd7c0b6385469e$export$d7fda18776ad9a8d = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    let { children: children, element: element, width: width, height: height, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: t1 } = t0;
    const useMinimumZIndex = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== height || $[1] !== width) {
        t2 = $aebd7c0b6385469e$var$getBadgeVisible(width, height);
        $[0] = height;
        $[1] = width;
        $[2] = t2;
    } else t2 = $[2];
    const [visible, setVisible] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[3] !== element) {
        t3 = ()=>{
            const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
                const [entry] = entries;
                const { width: width_0, height: height_0 } = entry.contentRect;
                setVisible($aebd7c0b6385469e$var$getBadgeVisible(width_0, height_0));
            }));
            if (element) observer.observe(element);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            element
        ];
        $[3] = element;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (typeof children === "function") {
        let t5;
        if ($[6] !== children || $[7] !== visible) {
            t5 = children({
                visible: visible
            });
            $[6] = children;
            $[7] = visible;
            $[8] = t5;
        } else t5 = $[8];
        children = t5;
    }
    if (!(0, $iDrrr.fg)("media-perf-uplift-mutation-fix")) {
        if (!element || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    const t5 = useMinimumZIndex && $aebd7c0b6385469e$var$hackedZIndexStyles;
    const t6 = extendedResizeOffset && $aebd7c0b6385469e$var$resizeOffsetStyles;
    let t7;
    if ($[9] !== t5 || $[10] !== t6) {
        t7 = [
            $aebd7c0b6385469e$var$containerStyles,
            t5,
            t6
        ];
        $[9] = t5;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== children || $[13] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
            as: "div",
            testId: "media-badges",
            "data-media-badges": "true",
            contentEditable: false,
            xcss: t7,
            children: children
        });
        $[12] = children;
        $[13] = t7;
        $[14] = t8;
    } else t8 = $[14];
    return t8;
} : ({ children: children, element: element, width: width, height: height, extendedResizeOffset: extendedResizeOffset, useMinimumZIndex: useMinimumZIndex = false })=>{
    const [visible, setVisible] = (0, $cozmU.useState)($aebd7c0b6385469e$var$getBadgeVisible(width, height));
    (0, $cozmU.useEffect)(()=>{
        const observer = new ResizeObserver((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))((entries)=>{
            const [entry] = entries;
            const { width: width_0, height: height_0 } = entry.contentRect;
            setVisible($aebd7c0b6385469e$var$getBadgeVisible(width_0, height_0));
        }));
        if (element) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        element
    ]);
    if (typeof children === 'function') children = children({
        visible: visible
    });
    // delete this block on cleanup of media-perf-uplift-mutation-fix
    if (!(0, $iDrrr.fg)('media-perf-uplift-mutation-fix')) {
        // becuase it is wrapped in a fragment, React.Children.count(children) will always be 1.
        // That makes this check a source of late mutations that we don't need.
        if (!element || (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) === 0) return null;
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3izAL.Box), {
        as: "div",
        testId: "media-badges",
        "data-media-badges": "true",
        contentEditable: false,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $aebd7c0b6385469e$var$containerStyles,
            useMinimumZIndex && $aebd7c0b6385469e$var$hackedZIndexStyles,
            extendedResizeOffset && $aebd7c0b6385469e$var$resizeOffsetStyles
        ],
        children: children
    });
};
module.exports["BlockNodeBadges"] = $aebd7c0b6385469e$export$d7fda18776ad9a8d;

});

parcelRegister("37hH2", function(module, exports) {

var $cbY7C = parcelRequire("cbY7C");

function $17f0b8c19803a4c1$export$274bb07166a08e06({ onRendered: onRendered }) {
    let resultId;
    let ready = false;
    let intersects = false;
    let element = null;
    let observer;
    let unbindVisibility;
    let destroyed = false;
    const emitted = new Set();
    const updateIntersection = (entries)=>{
        for (const entry of entries)if (entry.target === element) intersects = entry.isIntersecting && entry.intersectionRatio > 0;
    };
    const emit = ()=>{
        if (destroyed || !ready || resultId === undefined || emitted.has(resultId)) return;
        updateIntersection(observer?.takeRecords() ?? []);
        if (!intersects || element?.ownerDocument.visibilityState !== 'visible') return;
        emitted.add(resultId);
        onRendered(resultId);
    };
    const disconnect = ()=>{
        observer?.disconnect();
        observer = undefined;
        unbindVisibility?.();
        unbindVisibility = undefined;
        intersects = false;
    };
    return {
        setResult: (nextResultId)=>{
            if (resultId !== nextResultId) {
                resultId = nextResultId;
                ready = false;
            }
        },
        ready: (renderedResultId)=>{
            if (resultId === renderedResultId) {
                ready = true;
                emit();
            }
        },
        observe: (nextElement)=>{
            if (destroyed || element === nextElement) return;
            disconnect();
            element = nextElement;
            if (element) {
                observer = new IntersectionObserver((entries)=>{
                    updateIntersection(entries);
                    emit();
                }, {
                    // The root property identifies what to observe in the viewport
                    // `null` will use the owning document (most likely the browser window)
                    root: null,
                    // Detect when overlap reaches 0.1% of the element's area
                    threshold: [
                        0,
                        0.001
                    ]
                });
                observer.observe(element);
                unbindVisibility = (0, $cbY7C.bind)(element.ownerDocument, {
                    type: 'visibilitychange',
                    listener: emit
                });
            }
        },
        destroy: ()=>{
            destroyed = true;
            disconnect();
            element = null;
        }
    };
}
module.exports["createRenderedResultTracker"] = $17f0b8c19803a4c1$export$274bb07166a08e06;

});

parcelRegister("czp8P", function(module, exports) {
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $185ef2202d608231$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $185ef2202d608231$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $185ef2202d608231$export$aa000893c5e2b9c2 = {
    // gray
    /** gray - subtle */ ['#091E4224']: "var(--ds-border, #0B120E24)",
    /** gray */ ['#758195']: "var(--ds-border-bold, #7D818A)",
    /** gray - bold */ ['#172B4D']: "var(--ds-text, #292A2E)"
};
module.exports["hexToEditorBorderPaletteColor"] = $185ef2202d608231$export$bad3c41dd33cb4bc;

});

parcelRegister("8quKc", function(module, exports) {
const $4dcbe135fd307b49$export$36acad525b1fb57b = (dimensions = {
    width: '100%',
    height: '100%'
})=>{
    return {
        height: typeof dimensions.height === 'number' ? `${dimensions.height}px` : dimensions.height,
        width: typeof dimensions.width === 'number' ? `${dimensions.width}px` : dimensions.width
    };
};
module.exports["getDimensionsWithDefault"] = $4dcbe135fd307b49$export$36acad525b1fb57b;

});

parcelRegister("1pEse", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $ew4xH = parcelRequire("ew4xH");

const $edacca4f67c5c3ed$export$e6dfd72ab29f8598 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: (0, $ew4xH.wrapperStyles)({
            dimensions: props.dimensions
        }),
        ...props
    }, props.children));
};
module.exports["Wrapper"] = $edacca4f67c5c3ed$export$e6dfd72ab29f8598;

});

parcelRegister("ew4xH", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $lOiVq = parcelRequire("lOiVq");


var $9AILw = parcelRequire("9AILw");

const $b57e90473f867d52$export$491e6397d7c1480b = ({ dimensions: dimensions })=>/*#__PURE__*/ (0, $lOiVq.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.center), "position:relative;background:var(--ds-surface-sunken, #F8F8F8);color:var(--ds-icon, #292A2E);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9AILw.borderRadius), {
        maxHeight: '100%',
        maxWidth: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: dimensions.width,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: dimensions.height
    });
module.exports["wrapperStyles"] = $b57e90473f867d52$export$491e6397d7c1480b;

});

parcelRegister("9AILw", function(module, exports) {
const $1086bc1f8c9770f0$export$3481c78889e8fbe8 = `
  display: flex;
  align-items: center;
  justify-content: center;
`;
const $1086bc1f8c9770f0$export$7a57f79000377ca2 = `
  border-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$a98155aef1bfd63 = `
  border-bottom-left-radius: ${"var(--ds-radius-small, 3px)"};
  border-bottom-right-radius: ${"var(--ds-radius-small, 3px)"};
`;
const $1086bc1f8c9770f0$export$24656b269d8df7d6 = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
module.exports["center"] = $1086bc1f8c9770f0$export$3481c78889e8fbe8;
module.exports["borderRadius"] = $1086bc1f8c9770f0$export$7a57f79000377ca2;

});

parcelRegister("17wiG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $iDrrr = parcelRequire("iDrrr");


var $65DSU = parcelRequire("65DSU");


var $3lbOc = parcelRequire("3lbOc");


var $7oSFe = parcelRequire("7oSFe");

const $7f8f90030369ae01$var$MediaCardContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
const $7f8f90030369ae01$var$CardLoadingWithContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
            ...props,
            interactionName: "media-card-async-loading"
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : ()=>{
    const props = (0, $cozmU.useContext)($7f8f90030369ae01$var$MediaCardContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3lbOc.CardLoading), {
        ...props,
        interactionName: "media-card-async-loading"
    });
};

function $7f8f90030369ae01$var$loadCardWithMediaClient() {
    return (parcelRequire("5Ex62"));
}
const $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "a0IPb",
    name: "MediaCardWithMediaClientLoadable",
    loader: ()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>mod.CardWithMediaClient),
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
});
const $7f8f90030369ae01$var$MediaCardWithMediaClientLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy((0, $7oSFe.trackReactLazy)("rl--H8V5E", ()=>$7f8f90030369ae01$var$loadCardWithMediaClient().then((mod)=>({
            default: mod.CardWithMediaClient
        }))));
const $7f8f90030369ae01$var$CardLoader = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = (0, $iDrrr.fg)("platform_media_react19_support") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "media-card",
            mode: "list"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
            value: props
        }, t0));
        $[2] = props;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
        name: "media-card",
        mode: "list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardContext.Provider, {
        value: props
    }, (0, $iDrrr.fg)('platform_media_react19_support') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$CardLoadingWithContext, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLazy, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7f8f90030369ae01$var$MediaCardWithMediaClientLoadable, props)));
};
$7f8f90030369ae01$var$CardLoader.preload = ()=>{
    if ((0, $iDrrr.fg)('platform_media_react19_support')) $7f8f90030369ae01$var$loadCardWithMediaClient().then(()=>{});
    else $7f8f90030369ae01$var$MediaCardWithMediaClientLoadable.preload?.();
};
var $7f8f90030369ae01$export$2e2bcd8739ae039 = $7f8f90030369ae01$var$CardLoader;
module.exports["default"] = $7f8f90030369ae01$export$2e2bcd8739ae039;

});

parcelRegister("3lbOc", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $97Pj3 = parcelRequire("97Pj3");


var $8quKc = parcelRequire("8quKc");


var $1pEse = parcelRequire("1pEse");

const $9010bd9f06816b06$export$5d25853fd6bdf402 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { dimensions: dimensionsProp, testId: testId, interactionName: interactionName } = t0;
    let t1;
    if ($[0] !== dimensionsProp) {
        t1 = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
        $[0] = dimensionsProp;
        $[1] = t1;
    } else t1 = $[1];
    const dimensions = t1;
    const t2 = testId || "media-card-loading";
    const t3 = interactionName || "media-card-loading";
    let t4;
    if ($[2] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
            interactionName: t3
        });
        $[2] = t3;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== dimensions || $[5] !== t2 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
            "data-testid": t2,
            "data-test-loading": true,
            dimensions: dimensions,
            "data-vc": "media-card-loading"
        }, t4);
        $[4] = dimensions;
        $[5] = t2;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ dimensions: dimensionsProp, testId: testId, interactionName: interactionName })=>{
    const dimensions = (0, $8quKc.getDimensionsWithDefault)(dimensionsProp);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1pEse.Wrapper), {
        "data-testid": testId || 'media-card-loading',
        "data-test-loading": true,
        dimensions: dimensions,
        "data-vc": "media-card-loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97Pj3.LoadingBar), {
        interactionName: interactionName || 'media-card-loading'
    }));
};
module.exports["CardLoading"] = $9010bd9f06816b06$export$5d25853fd6bdf402;

});

parcelRegister("97Pj3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $5EzLH = parcelRequire("5EzLH");

const $9d658d6460d574ed$var$TICK_INTERVAL_MS = 1000;
const $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE = 0.9; /**
                                    * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
                                    * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
                                    * which makes things simpler than doing an `isServer` check or a `null` check.
                                    *
                                    * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
                                    */ 
const $9d658d6460d574ed$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
const $9d658d6460d574ed$var$messages = (0, $kSwu1.defineMessages)({
    loadingBarLabel: {
        id: "fabric.media.loading_bar_label",
        defaultMessage: "Loading"
    }
});
const $9d658d6460d574ed$var$trackStyles = null;
const $9d658d6460d574ed$var$fillStyles = null;
const $9d658d6460d574ed$var$clampToPercent = (progress)=>Math.min(1, Math.max(0, progress)) * 100;
const $9d658d6460d574ed$export$6665614bc5d690f6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { animationDisabled: t1, testId: testId, interactionName: interactionName } = t0;
    const animationDisabled = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    let t2;
    let t3;
    if ($[0] !== interactionContext || $[1] !== interactionName) {
        t2 = ()=>{
            if (interactionContext != null) return interactionContext.hold(interactionName);
        };
        t3 = [
            interactionContext,
            interactionName
        ];
        $[0] = interactionContext;
        $[1] = interactionName;
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    $9d658d6460d574ed$var$useLayoutEffect(t2, t3);
    let t4;
    let t5;
    if ($[4] !== animationDisabled) {
        t4 = ()=>{
            if (animationDisabled) {
                setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
                return;
            }
            intervalRef.current = setInterval(()=>{
                setProgress((prev)=>{
                    if (prev < 0.1) return prev + 0.1;
                    else {
                        if (prev < 0.6) return prev + 0.35;
                        else {
                            if (prev < 0.9) return prev + 0.1;
                        }
                    }
                    clearInterval(intervalRef.current);
                    return prev;
                });
            }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
            return ()=>clearInterval(intervalRef.current);
        };
        t5 = [
            animationDisabled
        ];
        $[4] = animationDisabled;
        $[5] = t4;
        $[6] = t5;
    } else {
        t4 = $[5];
        t5 = $[6];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[7] !== intl) {
        t6 = intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel);
        $[7] = intl;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _1mT5xdWVPG _0Bm75G2ADO _39xV02wOVE _3OE6xYOiLO _0jFU0VZimw _0KLXruDMqu"
        ]);
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== progress) {
        t8 = $9d658d6460d574ed$var$clampToPercent(progress);
        $[10] = progress;
        $[11] = t8;
    } else t8 = $[11];
    const t9 = `${t8}%`;
    let t10;
    if ($[12] !== t9) {
        t10 = {
            width: t9
        };
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VN91d _0KLXruXljP"
        ]);
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== t10) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: t10,
            className: t11
        });
        $[15] = t10;
        $[16] = t12;
    } else t12 = $[16];
    let t13;
    if ($[17] !== progress || $[18] !== t12 || $[19] !== t6 || $[20] !== testId) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "progressbar",
            "aria-valuenow": progress,
            "aria-label": t6,
            "data-testid": testId,
            className: t7
        }, t12);
        $[17] = progress;
        $[18] = t12;
        $[19] = t6;
        $[20] = testId;
        $[21] = t13;
    } else t13 = $[21];
    return t13;
} : ({ animationDisabled: animationDisabled = false, testId: testId, interactionName: interactionName })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? $9d658d6460d574ed$var$STATIC_PROGRESS_VALUE : 0);
    const intervalRef = (0, $cozmU.useRef)();
    const interactionContext = (0, $cozmU.useContext)((0, $5EzLH.default));
    $9d658d6460d574ed$var$useLayoutEffect(()=>{
        if (interactionContext != null) return interactionContext.hold(interactionName);
    }, [
        interactionContext,
        interactionName
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) {
            setProgress($9d658d6460d574ed$var$STATIC_PROGRESS_VALUE);
            return;
        }
        intervalRef.current = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 0.1) return prev + 0.1;
                else if (prev < 0.6) return prev + 0.35;
                else if (prev < 0.9) return prev + 0.1;
                clearInterval(intervalRef.current);
                return prev;
            });
        }, $9d658d6460d574ed$var$TICK_INTERVAL_MS);
        return ()=>clearInterval(intervalRef.current);
    }, [
        animationDisabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "progressbar",
        "aria-valuenow": progress,
        "aria-label": intl.formatMessage($9d658d6460d574ed$var$messages.loadingBarLabel),
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDS5Zs _1mT5xdWVPG _0Bm75G2ADO _39xV02wOVE _3OE6xYOiLO _0jFU0VZimw _0KLXruDMqu"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            width: `${$9d658d6460d574ed$var$clampToPercent(progress)}%`
        },
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VN91d _0KLXruXljP"
        ])
    }));
};
module.exports["LoadingBar"] = $9d658d6460d574ed$export$6665614bc5d690f6;

});

parcelRegister("5Ex62", function(module, exports) {

let $41da5c6aab976b62$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41da5c6aab976b62$var$load("i7NGK"),
    $41da5c6aab976b62$var$load("jwRVQ"),
    $41da5c6aab976b62$var$load("6wr18"),
    $41da5c6aab976b62$var$load("85m75"),
    $41da5c6aab976b62$var$load("cTsbB"),
    $41da5c6aab976b62$var$load("coGVA"),
    $41da5c6aab976b62$var$load("ffEVr"),
    $41da5c6aab976b62$var$load("7EorR"),
    $41da5c6aab976b62$var$load("7gPXS")
]).then(()=>parcelRequire('gnpwR'));

});

parcelRegister("gIMcb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");

const $ebe9a636d79d68b7$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $ebe9a636d79d68b7$export$5bff351c86f56d97 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, clientConfig: clientConfig } = t0;
    let t1;
    if ($[0] !== clientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(clientConfig);
        $[0] = clientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    let t2;
    if ($[2] !== children || $[3] !== mediaClient) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebe9a636d79d68b7$export$ba5d7212f2b4619f.Provider, {
            value: mediaClient
        }, children);
        $[2] = children;
        $[3] = mediaClient;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ebe9a636d79d68b7$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
module.exports["MediaClientContext"] = $ebe9a636d79d68b7$export$ba5d7212f2b4619f;
module.exports["MediaClientProvider"] = $ebe9a636d79d68b7$export$5bff351c86f56d97;

});

parcelRegister("hEt1x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $g9ZnD = parcelRequire("g9ZnD");


var $IY7Mb = parcelRequire("IY7Mb");

const $2ddf178f2decc0e9$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(undefined);
const $2ddf178f2decc0e9$export$57164260bc1f1218 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings } = t0;
    let t1;
    if ($[0] !== mediaClientConfig) {
        t1 = (0, $g9ZnD.getMediaClient)(mediaClientConfig);
        $[0] = mediaClientConfig;
        $[1] = t1;
    } else t1 = $[1];
    const mediaClient = t1;
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    let t2;
    if ($[2] !== mediaClient || $[3] !== settings) {
        t2 = {
            mediaClient: mediaClient,
            settings: settings
        };
        $[2] = mediaClient;
        $[3] = settings;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== children || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
            value: t2
        }, children);
        $[5] = children;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $cozmU.useMemo)(()=>(0, $g9ZnD.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $IY7Mb.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2ddf178f2decc0e9$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $2ddf178f2decc0e9$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $2ddf178f2decc0e9$export$57164260bc1f1218;

});

parcelRegister("IY7Mb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $gYqFD = parcelRequire("gYqFD");

const $a0017e6c99530c15$export$d54af28440a5efc0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const mediaSettings = t1;
    let newSettings;
    if ($[2] !== mediaSettings) {
        newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        $[2] = mediaSettings;
        $[3] = newSettings;
    } else newSettings = $[3];
    const settings = newSettings;
    return settings;
} : (mediaSettings = {})=>{
    const settings = (0, $cozmU.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $gYqFD.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $a0017e6c99530c15$export$d54af28440a5efc0;

});

parcelRegister("gYqFD", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $c55cff04bbd4c82d$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $c55cff04bbd4c82d$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($c55cff04bbd4c82d$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $c55cff04bbd4c82d$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $c55cff04bbd4c82d$export$2d23ed2854ac1650 = $c55cff04bbd4c82d$export$7e209e67b965bc63($c55cff04bbd4c82d$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $c55cff04bbd4c82d$export$2d23ed2854ac1650;

});

parcelRegister("8lZ3h", function(module, exports) {
const $934af7640853e7fb$export$ec1779cb96554e1 = 'media';
module.exports["ANALYTICS_MEDIA_CHANNEL"] = $934af7640853e7fb$export$ec1779cb96554e1;

});

parcelRegister("jmmTp", function(module, exports) {
const $ad0c18c377a101ba$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
module.exports["isFileIdentifier"] = $ad0c18c377a101ba$export$7695387cd66cf5b5;

});

parcelRegister("1tBud", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $j8WB4 = parcelRequire("j8WB4");


var $2mOOd = parcelRequire("2mOOd");


var $717N0 = parcelRequire("717N0");


var $7oSFe = parcelRequire("7oSFe");

const $4cc16dba49469f3f$var$MediaViewer = /*#__PURE__*/ (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-oqo6lj", ()=>(0, $j8WB4.loadMediaViewerChunk)().then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        }))));
const $4cc16dba49469f3f$var$AsyncMediaViewer = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AsyncMediaViewer(props) {
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function AsyncMediaViewer(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2mOOd.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $717N0.MediaViewerPortal), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cc16dba49469f3f$var$MediaViewer, props)));
};
var $4cc16dba49469f3f$export$2e2bcd8739ae039 = $4cc16dba49469f3f$var$AsyncMediaViewer;
module.exports["default"] = $4cc16dba49469f3f$export$2e2bcd8739ae039;

});

parcelRegister("j8WB4", function(module, exports) {
/**
 * The single call site for each lazily loaded chunk that `./preload` warms.
 *
 * Both the render path and the warm-up path must go through these. Repeating an
 * `import()` with the same `webpackChunkName` in two files relies on the two
 * comments staying identical forever; if they drift, the warm-up fetches a
 * different chunk than the one the viewer loads and silently does nothing.
 */ 
const $95a2c082f0d52eb8$export$8d8c2c2be317e2a4 = ()=>(parcelRequire("iAJJp"));

const $95a2c082f0d52eb8$export$457a0a3ac31f3be9 = ()=>(parcelRequire("9ULUz"));
module.exports["loadMediaViewerChunk"] = $95a2c082f0d52eb8$export$8d8c2c2be317e2a4;
module.exports["loadImageViewerChunk"] = $95a2c082f0d52eb8$export$457a0a3ac31f3be9;

});

parcelRegister("iAJJp", function(module, exports) {

let $d88f10131d0783fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d88f10131d0783fa$var$load("i7NGK"),
    $d88f10131d0783fa$var$load("jwRVQ"),
    $d88f10131d0783fa$var$load("6OMo6"),
    $d88f10131d0783fa$var$load("aaRXj"),
    $d88f10131d0783fa$var$load("fHlIz"),
    $d88f10131d0783fa$var$load("4QwAJ"),
    $d88f10131d0783fa$var$load("3i44s"),
    $d88f10131d0783fa$var$load("5kI0b"),
    $d88f10131d0783fa$var$load("kYkz1"),
    $d88f10131d0783fa$var$load("jfYeU"),
    $d88f10131d0783fa$var$load("b4nm1"),
    $d88f10131d0783fa$var$load("geXPZ"),
    $d88f10131d0783fa$var$load("aQ5uu"),
    $d88f10131d0783fa$var$load("6wr18"),
    $d88f10131d0783fa$var$load("60PUI"),
    $d88f10131d0783fa$var$load("1xeJ3"),
    $d88f10131d0783fa$var$load("cTsbB"),
    $d88f10131d0783fa$var$load("coGVA"),
    $d88f10131d0783fa$var$load("9QG12"),
    $d88f10131d0783fa$var$load("RI3SR"),
    $d88f10131d0783fa$var$load("e3OZZ"),
    $d88f10131d0783fa$var$load("2XRLb"),
    $d88f10131d0783fa$var$load("4MePG"),
    $d88f10131d0783fa$var$load("io0qR"),
    $d88f10131d0783fa$var$load("3MJxZ"),
    $d88f10131d0783fa$var$load("cuNBo"),
    $d88f10131d0783fa$var$load("kHMR7"),
    $d88f10131d0783fa$var$load("4Ldt2"),
    $d88f10131d0783fa$var$load("cL682"),
    $d88f10131d0783fa$var$load("gkVge"),
    $d88f10131d0783fa$var$load("jTOhL"),
    $d88f10131d0783fa$var$load("jOE2W"),
    $d88f10131d0783fa$var$load("5JWJI"),
    $d88f10131d0783fa$var$load("ffEVr"),
    $d88f10131d0783fa$var$load("4jXCC")
]).then(()=>parcelRequire('9vMzD'));

});

parcelRegister("9ULUz", function(module, exports) {

let $737e823572a6f247$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $737e823572a6f247$var$load("coGVA"),
    $737e823572a6f247$var$load("jwRVQ"),
    $737e823572a6f247$var$load("eF92L"),
    $737e823572a6f247$var$load("jwMHX"),
    $737e823572a6f247$var$load("6wr18"),
    $737e823572a6f247$var$load("60PUI"),
    $737e823572a6f247$var$load("1xeJ3"),
    $737e823572a6f247$var$load("ffEVr"),
    $737e823572a6f247$var$load("9QG12"),
    $737e823572a6f247$var$load("5gFzn")
]).then(()=>parcelRequire('YVN9i'));

});

parcelRegister("2mOOd", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $imqjG = parcelRequire("imqjG");


var $IQ4Dz = parcelRequire("IQ4Dz");

const $6ffa2f80eb372db6$export$442b7be89436c101 = '#101214';
const $6ffa2f80eb372db6$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(2);
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    const t0 = colorMode !== "dark";
    let t1;
    if ($[0] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
            blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
            invertSpinnerColor: t0
        });
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ()=>{
    const { colorMode: colorMode } = (0, $IQ4Dz.useThemeObserver)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imqjG.default), {
        blankedColor: $6ffa2f80eb372db6$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $6ffa2f80eb372db6$export$2e2bcd8739ae039 = $6ffa2f80eb372db6$var$ModalSpinner;
module.exports["default"] = $6ffa2f80eb372db6$export$2e2bcd8739ae039;

});

parcelRegister("imqjG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $knkYU = parcelRequire("knkYU");

const $75f640d6e866ba35$var$ModalSpinner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knkYU.default), props);
var $75f640d6e866ba35$export$2e2bcd8739ae039 = $75f640d6e866ba35$var$ModalSpinner;
module.exports["default"] = $75f640d6e866ba35$export$2e2bcd8739ae039;

});

parcelRegister("knkYU", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea0f137a8e557bc$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");

const $1ea0f137a8e557bc$var$blanketStyles = null;
const $1ea0f137a8e557bc$var$spinnerStyles = null;
const $1ea0f137a8e557bc$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $1ea0f137a8e557bc$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundColor: blankedColor || $1ea0f137a8e557bc$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $hekY6.default)([
            "_1mT5xdy1CL _2IhTondnbC _3OE6xYdnbC _0Bm75GdnbC _4ApkO2dnbC _42Yu6BEvR7"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        size: "large",
        appearance: invertSpinnerColor || $1ea0f137a8e557bc$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
        testId: 'media-modal-spinner'
    })));

});

parcelRegister("717N0", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cK21K = parcelRequire("cK21K");

const $60b53ae22e9372b5$export$51aee4c01b17acde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
            zIndex: 510
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 510
    }, children);
module.exports["MediaViewerPortal"] = $60b53ae22e9372b5$export$51aee4c01b17acde;

});

parcelRegister("2rEyz", function(module, exports) {

var $opqdo = parcelRequire("opqdo");


var $l7Nkn = parcelRequire("l7Nkn");

const $43d0ef8377571650$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, $l7Nkn.isValidUuid)(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $43d0ef8377571650$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $43d0ef8377571650$export$e24d38cbdf73bc1a = (payload)=>$43d0ef8377571650$var$hasFileAttributesWithFileId(payload) ? (0, $opqdo.produce)(payload, $43d0ef8377571650$var$sanitiseFileId) : payload;
module.exports["sanitiseAnalyticsPayload"] = $43d0ef8377571650$export$e24d38cbdf73bc1a;

});

parcelRegister("6C5HF", function(module, exports) {
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $44324582d2e92be4$export$42c8d07e41ed1e74 = 'media-viewer-popup';
module.exports["mediaViewerPopupClass"] = $44324582d2e92be4$export$42c8d07e41ed1e74;

});

parcelRegister("lNvN4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gIMcb = parcelRequire("gIMcb");


var $hEt1x = parcelRequire("hEt1x");

const $e5ff9295aa55af63$export$8b3e87ea56c3a345 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error("No MediaClient set, use MediaClientProvider or MediaProvider to set one");
    return mediaClient || altMediaClient;
} : ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $gIMcb.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext((0, $hEt1x.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $e5ff9295aa55af63$export$8b3e87ea56c3a345;

});

parcelRegister("4fGOw", function(module, exports) {

var $jx5V5 = parcelRequire("jx5V5");


var $lNvN4 = parcelRequire("lNvN4");

const $dc2272ad9447ddc9$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $jx5V5.useStore)(store, selector, equals);
function $dc2272ad9447ddc9$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $lNvN4.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $dc2272ad9447ddc9$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $dc2272ad9447ddc9$export$8a9cc8c330400af8;

});

parcelRegister("jx5V5", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $e385b0e7bfdc7f87$export$6ccbb43953eebf8);

var $3xeSM = parcelRequire("3xeSM");


var $cozmU = parcelRequire("cozmU");


var $aSzLn = parcelRequire("aSzLn");

var $e385b0e7bfdc7f87$import_meta = Object.assign(Object.create(null), {
    url: "file:///../node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $e385b0e7bfdc7f87$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU)));
const { useSyncExternalStoreWithSelector: $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($aSzLn)));
let $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = false;
const $e385b0e7bfdc7f87$var$identity = (arg)=>arg;
function $e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector = $e385b0e7bfdc7f87$var$identity, equalityFn) {
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$e385b0e7bfdc7f87$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $e385b0e7bfdc7f87$var$didWarnAboutEqualityFn = true;
    }
    const slice = $e385b0e7bfdc7f87$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $e385b0e7bfdc7f87$var$useDebugValue(slice);
    return slice;
}
const $e385b0e7bfdc7f87$var$createImpl = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $3xeSM.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$e385b0e7bfdc7f87$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $e385b0e7bfdc7f87$export$185802fd694ee1f5 = (createState)=>createState ? $e385b0e7bfdc7f87$var$createImpl(createState) : $e385b0e7bfdc7f87$var$createImpl;
var $e385b0e7bfdc7f87$export$2e2bcd8739ae039 = (createState)=>{
    if (($e385b0e7bfdc7f87$import_meta.env ? $e385b0e7bfdc7f87$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $e385b0e7bfdc7f87$export$185802fd694ee1f5(createState);
};

});

parcelRegister("46ZX8", function(module, exports) {
const $d9d47302881512fd$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
module.exports["isExternalImageIdentifier"] = $d9d47302881512fd$export$2782f2fbff82f0c9;

});

parcelRegister("fA65V", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c226a72f375a9da1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    click_to_join: {
        id: "fabric.media.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.media.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    request_access: {
        id: "fabric.media.request_access",
        defaultMessage: "Request access"
    },
    request_access_description: {
        id: "fabric.media.request_access_description",
        defaultMessage: "Request access to {context} view this preview."
    },
    request_access_pending: {
        id: "fabric.media.request_access_pending",
        defaultMessage: "Access pending"
    },
    request_access_pending_description: {
        id: "fabric.media.request_access_pending_description",
        defaultMessage: "Your access request is pending."
    },
    forbidden_description: {
        id: "fabric.media.forbidden_description",
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access."
    },
    request_denied_description: {
        id: "fabric.media.request_denied_description",
        defaultMessage: "Your access request was denied. Contact the site admin if you still need access."
    },
    retry: {
        id: "fabric.media.retry",
        defaultMessage: "Retry"
    },
    failed_to_load: {
        id: "fabric.media.failed_to_load",
        defaultMessage: "Failed to load"
    },
    failed_to_upload: {
        id: "fabric.media.failed_to_upload",
        defaultMessage: "Failed to upload"
    },
    check_internet_connection: {
        id: "fabric.media.check_internet_connection",
        defaultMessage: "Failed to load. Please check your internet connection"
    },
    recent_uploads: {
        id: "fabric.media.recent_uploads",
        defaultMessage: "Recent uploads"
    },
    upload_file: {
        id: "fabric.media.upload_file",
        defaultMessage: "Upload a file"
    },
    drag_and_drop_your_files: {
        id: "fabric.media.drag_and_drop_your_files",
        defaultMessage: "Drag and drop your files anywhere or"
    },
    drag_and_drop_your_files_and_folders: {
        id: "fabric.media.drag_and_drop_your_files_and_folders",
        defaultMessage: "Drag and drop your files and folders anywhere or"
    },
    drop_your_files: {
        id: "fabric.media.drop_your_files",
        defaultMessage: "Drop your files to upload"
    },
    upload: {
        id: "fabric.media.upload",
        defaultMessage: "Upload"
    },
    cancel: {
        id: "fabric.media.cancel",
        defaultMessage: "Cancel"
    },
    delete: {
        id: "fabric.media.delete",
        defaultMessage: "Delete"
    },
    success: {
        id: "fabric.media.success",
        defaultMessage: "Success"
    },
    error: {
        id: "fabric.media.error",
        defaultMessage: "Error"
    },
    search_all_gifs: {
        id: "fabric.media.search_all_gifs",
        defaultMessage: "Search all the GIFs!"
    },
    cant_retrieve_gifs: {
        id: "fabric.media.cant_retrieve_gifs",
        defaultMessage: "Ouch! We could not retrieve any GIFs"
    },
    cant_retrieve_files: {
        id: "fabric.media.cant_retrieve_files",
        defaultMessage: "Ouch! We could not retrieve any files"
    },
    check_your_network: {
        id: "fabric.media.check_your_network",
        defaultMessage: "Check your network connection"
    },
    try_again: {
        id: "fabric.media.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.media.try_another_account",
        defaultMessage: "Try another account"
    },
    no_gifs_found: {
        id: "fabric.media.no_gifs_found",
        defaultMessage: "Hello? Was it me you're looking for?"
    },
    no_gifs_found_suggestion: {
        id: "fabric.media.no_gifs_found_suggestion",
        defaultMessage: "We couldn't find anything for \"{query}\""
    },
    load_more_gifs: {
        id: "fabric.media.load_more_gifs",
        defaultMessage: "Load more GIFs"
    },
    add_account: {
        id: "fabric.media.add_account",
        defaultMessage: "Add account"
    },
    unlink_account: {
        id: "fabric.media.unlink_account",
        defaultMessage: "Unlink Account"
    },
    upload_file_from: {
        id: "fabric.media.upload_file_from",
        defaultMessage: "Upload a file from {name}"
    },
    connect_to: {
        id: "fabric.media.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.media.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.media.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.media.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.media.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.media.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    invalid_permissions: {
        id: "fabric.media.invalid_permissions",
        defaultMessage: "Restricted link"
    },
    invalid_permissions_description: {
        id: "fabric.media.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    select_an_avatar: {
        id: "fabric.media.select_an_avatar",
        defaultMessage: "Select a default avatar"
    },
    upload_an_avatar: {
        id: "fabric.media.upload_an_avatar",
        defaultMessage: "Upload an avatar"
    },
    select_an_avatar_from_all_defaults: {
        id: "fabric.media.select_an_avatar_from_all_defaults",
        defaultMessage: "Select from all default options"
    },
    select_an_avatar_option: {
        id: "fabric.media.select_an_avatar_option",
        defaultMessage: "Default avatar option {number}"
    },
    show_more_avatars_btn_label: {
        id: "fabric.media.show_more_avatars_btn_label",
        defaultMessage: "Show more"
    },
    or_select_default_avatars: {
        id: "fabric.media.or_select_default_avatars",
        defaultMessage: "Upload a photo or select from some default options"
    },
    loading: {
        id: "fabric.media.loading",
        defaultMessage: "Loading..."
    },
    loading_file: {
        id: "fabric.media.loading_file",
        defaultMessage: "Loading file..."
    },
    save: {
        id: "fabric.media.save",
        defaultMessage: "Save"
    },
    or: {
        id: "fabric.media.or",
        defaultMessage: "or"
    },
    upload_photo: {
        id: "fabric.media.upload_photo",
        defaultMessage: "Upload a photo"
    },
    default_avatars: {
        id: "fabric.media.default_avatars",
        defaultMessage: "Default avatars"
    },
    avatar_picker_back_btn_label: {
        id: "fabric.media.avatar_picker_back_btn_label",
        defaultMessage: "Go Back"
    },
    drag_and_drop_images_here: {
        id: "fabric.media.drag_and_drop_images_here",
        defaultMessage: "Drag and drop your images here"
    },
    alt_text: {
        id: "fabric.media.alt_text_label",
        defaultMessage: "Alt text"
    },
    alt_text_description: {
        id: "fabric.media.alt_text_helper_message",
        defaultMessage: "How would you describe the selected image to someone with low vision?"
    },
    image_url_invalid_error: {
        id: "fabric.media.image_url_invalid_error",
        defaultMessage: "Could not load image, the url is invalid."
    },
    image_format_invalid_error: {
        id: "fabric.media.image_format_invalid_error",
        defaultMessage: "Could not load image, the format is invalid."
    },
    image_size_too_large_error: {
        id: "fabric.media.image_size_too_large_error",
        defaultMessage: "Image is too large, must be no larger than {MAX_SIZE_MB}Mb"
    },
    something_went_wrong: {
        id: "fabric.media.something_went_wrong",
        defaultMessage: "Something went wrong."
    },
    might_be_a_hiccup: {
        id: "fabric.media.might_be_a_hiccup",
        defaultMessage: "It might just be a hiccup."
    },
    couldnt_generate_preview: {
        id: "fabric.media.couldnt_generate_preview",
        defaultMessage: "We couldn't generate a preview for this file."
    },
    couldnt_generate_encrypted_entry_preview: {
        id: "fabric.media.couldnt_generate_encrypted_entry_preview",
        defaultMessage: "We can't preview encrypted or password protected files."
    },
    cant_preview_file_type: {
        id: "fabric.media.cant_preview_file_type",
        defaultMessage: "We can't preview this file type."
    },
    item_not_found_in_list: {
        id: "fabric.media.item_not_found_in_list",
        defaultMessage: "The selected item was not found on the list."
    },
    not_found_title: {
        id: "fabric.media.not_found_title",
        defaultMessage: "Uh oh. We can't find this link!"
    },
    not_found_description: {
        id: "fabric.media.not_found_description",
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again."
    },
    no_pdf_artifacts: {
        id: "fabric.media.no_pdf_artifacts",
        defaultMessage: "No PDF artifacts found for this file."
    },
    password_protected_pdf: {
        id: "fabric.media.password_protected_pdf",
        defaultMessage: "This file is password protected."
    },
    password: {
        id: "fabric.media.password",
        defaultMessage: "Password"
    },
    enter_password: {
        id: "fabric.media.enter_password",
        defaultMessage: "Enter password"
    },
    incorrect_password: {
        id: "fabric.media.incorrect_password",
        defaultMessage: "Incorrect password. Please try again."
    },
    submit: {
        id: "fabric.media.submit",
        defaultMessage: "Submit"
    },
    give_feedback: {
        id: "fabric.media.give_feedback",
        defaultMessage: "Give feedback"
    },
    try_downloading_file: {
        id: "fabric.media.try_downloading_file",
        defaultMessage: "Try downloading the file to view it."
    },
    line_count: {
        id: "fabric.media.line_count",
        defaultMessage: "{count, plural, one {# line} other {# lines}}"
    },
    plain_text: {
        id: "fabric.media.plain_text",
        defaultMessage: "Plain text"
    },
    archive_format_not_supported: {
        id: "fabric.media.archive_format_not_supported",
        defaultMessage: "Preview is not available for this file type."
    },
    unsupported_file_format: {
        id: "fabric.media.unsupported_file_format",
        defaultMessage: "Unsupported file format"
    },
    file_too_large_to_preview: {
        id: "fabric.media.file_too_large_to_preview",
        defaultMessage: "File is too large to preview"
    },
    file_too_large_description: {
        id: "fabric.media.file_too_large_description",
        defaultMessage: "Preview isn't available for files of this size."
    },
    webgl_warning_description: {
        id: "fabric.media.webgl_warning_description",
        defaultMessage: "Your browser does not support WebGL. Use a WebGL enabled browser to annotate images."
    },
    unable_to_annotate_image: {
        id: "fabric.media.unable_to_annotate_image",
        defaultMessage: "You're unable to annotate this image"
    },
    learn_more: {
        id: "fabric.media.learn_more",
        defaultMessage: "Learn More"
    },
    accounts: {
        id: "fabric.media.accounts",
        defaultMessage: "Accounts"
    },
    actions: {
        id: "fabric.media.actions",
        defaultMessage: "Actions"
    },
    error_hint_retry: {
        id: "fabric.media.error_hint_retry",
        defaultMessage: "Try again and we'll give it another shot."
    },
    error_hint_critical: {
        id: "fabric.media.error_hint_critical",
        defaultMessage: "If the problem keeps happening contact support."
    },
    close: {
        id: "fabric.media.close",
        defaultMessage: "Close"
    },
    could_not_load_editor: {
        id: "fabric.media.could_not_load_editor",
        defaultMessage: "Ouch! We could not load the editor"
    },
    could_not_save_image: {
        id: "fabric.media.could_not_save_image",
        defaultMessage: "Ouch! We could not save the image"
    },
    could_not_load_link: {
        id: "fabric.media.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    annotate: {
        id: "fabric.media.annotate",
        defaultMessage: "Annotate"
    },
    annotate_tool_arrow: {
        id: "fabric.media.annotate.tool.arrow",
        defaultMessage: "Arrow"
    },
    annotate_tool_text: {
        id: "fabric.media.annotate.tool.text",
        defaultMessage: "Text"
    },
    annotate_tool_shape: {
        id: "fabric.media.annotate.tool.shape",
        defaultMessage: "Shape"
    },
    annotate_tool_brush: {
        id: "fabric.media.annotate.tool.brush",
        defaultMessage: "Brush"
    },
    annotate_tool_blur: {
        id: "fabric.media.annotate.tool.blur",
        defaultMessage: "Blur"
    },
    annotate_tool_line_thickness: {
        id: "fabric.media.annotate.tool.line.thickness",
        defaultMessage: "Line thickness"
    },
    annotate_tool_color: {
        id: "fabric.media.annotate.tool.color",
        defaultMessage: "Color"
    },
    annotate_confirmation_close_anyway: {
        id: "fabric.media.annotate.confirmation.close.anyway",
        defaultMessage: "Close anyway"
    },
    annotate_confirmation_heading: {
        id: "fabric.media.annotate.confirmation.heading",
        defaultMessage: "Unsaved changes"
    },
    annotate_confirmation_content: {
        id: "fabric.media.annotate.confirmation.content",
        defaultMessage: "You have some unsaved changes. Are you sure you want to leave?"
    },
    drop_your_files_here: {
        id: "fabric.media.drop_your_files_here",
        defaultMessage: "Drop your files here"
    },
    share_files_instantly: {
        id: "fabric.media.share_files_instantly",
        defaultMessage: "We'll share them instantly"
    },
    insert_files: {
        id: "fabric.media.insert_files",
        defaultMessage: "Insert {0, plural, one {a file} other {{0} files}}"
    },
    zoom_out: {
        id: "fabric.media.zoom_out",
        defaultMessage: "zoom out"
    },
    zoom_in: {
        id: "fabric.media.zoom_in",
        defaultMessage: "zoom in"
    },
    zoom_to_fit: {
        id: "fabric.media.zoom_to_fit",
        defaultMessage: "Fit to screen"
    },
    zoom_to_fit_with_level: {
        id: "fabric.media.zoom_to_fit_with_level",
        defaultMessage: "{zoomLevel} zoom, fit to screen"
    },
    hide_sidebar: {
        id: "fabric.media.viewer.hide_sidebar",
        defaultMessage: "Hide sidebar"
    },
    show_sidebar: {
        id: "fabric.media.viewer.show_sidebar",
        defaultMessage: "Show sidebar"
    },
    remove_image: {
        id: "fabric.media.remove_image",
        defaultMessage: "Remove image"
    },
    play: {
        id: "fabric.media.play",
        defaultMessage: "Play"
    },
    pause: {
        id: "fabric.media.pause",
        defaultMessage: "Pause"
    },
    disable_fullscreen: {
        id: "fabric.media.disable_fullscreen",
        defaultMessage: "disable fullscreen"
    },
    enable_fullscreen: {
        id: "fabric.media.enable_fullscreen",
        defaultMessage: "enable fullscreen"
    },
    error_loading_file: {
        id: "fabric.media.error_loading_file",
        defaultMessage: "Error loading file"
    },
    error_generating_preview: {
        id: "fabric.media.error_generating_preview",
        defaultMessage: "Error generating preview"
    },
    download: {
        id: "fabric.media.download",
        defaultMessage: "Download"
    },
    download_disabled_security_policy: {
        id: "fabric.media.download_disabled_security_policy",
        defaultMessage: "Download is blocked by your organization's security policy."
    },
    unknown: {
        id: "fabric.media.unknown",
        defaultMessage: "unknown"
    },
    document: {
        id: "fabric.media.document",
        defaultMessage: "document"
    },
    audio: {
        id: "fabric.media.audio",
        defaultMessage: "audio"
    },
    video: {
        id: "fabric.media.video",
        defaultMessage: "video"
    },
    image: {
        id: "fabric.media.image",
        defaultMessage: "image"
    },
    archive: {
        id: "fabric.media.archive",
        defaultMessage: "archive"
    },
    email: {
        id: "fabric.media.email",
        defaultMessage: "email"
    },
    text: {
        id: "fabric.media.text",
        defaultMessage: "text"
    },
    displayThumbnail: {
        id: "fabric.media.display_thumbnail",
        defaultMessage: "Display thumbnail"
    },
    search: {
        id: "fabric.media.search",
        defaultMessage: "search"
    },
    view: {
        id: "fabric.media.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.media.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.media.srclinkunknown",
        defaultMessage: "View Original"
    },
    changeView: {
        id: "fabric.media.change_view",
        defaultMessage: "Change view"
    },
    playbackSpeed: {
        id: "fabric.media.playback_speed",
        defaultMessage: "Playback speed"
    },
    playbackSpeedValue: {
        id: "fabric.media.playback_speed_value",
        defaultMessage: "Playback speed {speed}x"
    },
    video_captions_enable: {
        id: "fabric.media.video_captions_enable",
        defaultMessage: "Closed Captions"
    },
    video_captions_select_captions: {
        id: "fabric.media.video_captions_select_captions",
        defaultMessage: "Select Captions"
    },
    video_captions_upload_captions_form_header: {
        id: "fabric.media.video_captions_upload_captions_form_header",
        defaultMessage: "Upload Captions"
    },
    video_captions_upload_captions_form_language_picker: {
        id: "fabric.media.video_captions_upload_captions_form_language_picker",
        defaultMessage: "Select the file language"
    },
    video_captions_upload_success_description: {
        id: "fabric.media.video_captions_upload_success_description",
        defaultMessage: "The caption was successfully uploaded for this video."
    },
    video_captions_upload_error_description: {
        id: "fabric.media.video_captions_upload_error_description",
        defaultMessage: "The caption failed to upload."
    },
    video_captions_delete_captions_confirmation_header: {
        id: "fabric.media.video_captions_delete_captions_confirmation_header",
        defaultMessage: "Delete Caption"
    },
    video_captions_delete_captions_confirmation_description: {
        id: "fabric.media.video_captions_delete_captions_confirmation_description",
        defaultMessage: "Please confirm that you want to delete this caption."
    },
    video_captions_delete_success_description: {
        id: "fabric.media.video_captions_delete_success_description",
        defaultMessage: "The caption was successfully removed from this video."
    },
    video_captions_delete_error_description: {
        id: "fabric.media.video_captions_delete_error_description",
        defaultMessage: "The caption failed to delete."
    },
    manage_captions: {
        id: "fabric.media.manage_captions",
        defaultMessage: "Manage Captions"
    },
    add_captions: {
        id: "fabric.media.add_captions",
        defaultMessage: "Add Captions"
    },
    skipBackward: {
        id: "fabric.media.skip_backward",
        defaultMessage: "Back 10 seconds"
    },
    skipForward: {
        id: "fabric.media.skip_forward",
        defaultMessage: "Forward 10 seconds"
    },
    sizeOptions: {
        id: "fabric.media.size_options",
        defaultMessage: "Size options"
    },
    fileDisplayOptions: {
        id: "fabric.media.file.display_options",
        defaultMessage: "Display options"
    },
    volumeLevelControlAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "volume"
    },
    volumeMuteButtonAria: {
        id: "fabric.media.volume_level",
        defaultMessage: "mute"
    },
    playbackDefaultSpeed: {
        id: "fabric.media.playback_default_speed",
        defaultMessage: "Default"
    },
    expand: {
        id: "fabric.media.expand",
        defaultMessage: "Expand"
    },
    preview: {
        id: "fabric.media.preview",
        defaultMessage: "Preview"
    },
    creating_preview: {
        id: "fabric.media.creating_preview",
        defaultMessage: "Creating preview..."
    },
    preview_unavailable: {
        id: "fabric.media.preview_unavailable",
        defaultMessage: "Preview unavailable"
    },
    couldnt_load_file: {
        id: "fabric.media.couldnt_load_file",
        defaultMessage: "We couldn't load the file."
    },
    error_429: {
        id: "fabric.media.error_429",
        defaultMessage: "Error 429"
    },
    close_and_reopen: {
        id: "fabric.media.close_and_reopen",
        defaultMessage: "Try closing this file and reopening."
    },
    viewer_rateLimited: {
        id: "fabric.media.viewer_rateLimited",
        defaultMessage: "We're having difficulties loading your file."
    },
    zip_entry_load_fail: {
        id: "fabric.media.zip_entry_load_failed",
        defaultMessage: "We couldn't load that zip file item to preview"
    },
    file_image_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Image {name} is selected"
    },
    file_video_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Video {name} is selected"
    },
    file_audio_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Audio {name} is selected"
    },
    file_doc_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Document {name} is selected"
    },
    file_archive_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "Archive {name} is selected"
    },
    file_unknown_is_selected: {
        id: "fabric.media.file_is_selected",
        defaultMessage: "File {name} is selected"
    },
    open_file_in_viewer: {
        id: "fabric.media.open_file_in_viewer",
        defaultMessage: "Open {name}"
    },
    open_file_in_viewer_aria_label: {
        id: "fabric.media.open_file_in_viewer_aria_label",
        defaultMessage: "Open {name} in fullscreen"
    },
    video_seeker_assistive_text_time_value: {
        id: "fabric.media.video_seeker_assistive_text_time_value",
        defaultMessage: "{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}"
    },
    video_seeker_label_assistive_text: {
        id: "fabric.media.video_seeker_label_assistive_text",
        defaultMessage: "Seek slider"
    },
    abuse_modal_body: {
        id: "fabric.media.abuse_modal_body",
        defaultMessage: "For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content"
    },
    abuse_modal_title: {
        id: "fabric.media.abuse_modal_title",
        defaultMessage: "Warning"
    },
    abuse_modal_submit: {
        id: "fabric.media.abuse_modal_submit",
        defaultMessage: "Proceed with download"
    },
    image_cropper_arrow_keys_label: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.label",
        defaultMessage: "Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image"
    },
    image_cropper_image_moved: {
        id: "media.media-avatar-picker.image-cropper.arrow-keys.action",
        defaultMessage: "You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image"
    },
    image_cropper_zoom_out: {
        id: "media.media-avatar-picker.image-cropper.zoom_out",
        defaultMessage: "Zoom out"
    },
    image_cropper_zoom_in: {
        id: "media.media-avatar-picker.image-cropper.zoom_in",
        defaultMessage: "Zoom in"
    },
    image_cropper_zoom_slider: {
        id: "media.media-avatar-picker.image-cropper.zoom_slider",
        defaultMessage: "set zoom"
    },
    image_placer_img_alt: {
        id: "media.media-avatar-picker.image-placer.image-alt",
        defaultMessage: "Image preview"
    },
    svg_base_alt: {
        id: "media.media-viewer.base-svg.alt",
        defaultMessage: "Svg Image"
    },
    archive_download_label_assistive_text: {
        id: "media.media-viewer.archive-sidebar.wrapper.label_assistive_text",
        defaultMessage: "Download Media"
    }
});
module.exports["messages"] = $c226a72f375a9da1$export$defe85febe8b728c;

});

parcelRegister("25FkG", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

function $b16f7296b5f1849a$export$46209768acd69701(error) {
    const { secondaryError: secondaryError } = error || {};
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.innerError?.message || 'unknown';
    else if (secondaryError) return secondaryError.message;
    return 'unknown';
}
module.exports["getErrorDetail"] = $b16f7296b5f1849a$export$46209768acd69701;

});

parcelRegister("5i0UP", function(module, exports) {
function $49a260b5966a1e1f$export$d559b21acff881a4(error) {
    return error.primaryReason;
}
module.exports["getPrimaryErrorReason"] = $49a260b5966a1e1f$export$d559b21acff881a4;

});

parcelRegister("27DLG", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

function $77704b3c5d0594d8$export$989e1becee2b9994(error) {
    const { secondaryError: secondaryError } = error || {};
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
}
module.exports["getRequestMetadata"] = $77704b3c5d0594d8$export$989e1becee2b9994;

});

parcelRegister("3Kyrj", function(module, exports) {

var $1wzQC = parcelRequire("1wzQC");

function $6e2f50489a58b309$export$41f5c5c623dc1775(error) {
    const { secondaryError: secondaryError } = error;
    if ((0, $1wzQC.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    else if (secondaryError) return 'nativeError';
    else return 'unknown';
}
module.exports["getSecondaryErrorReason"] = $6e2f50489a58b309$export$41f5c5c623dc1775;

});

parcelRegister("cfGuz", function(module, exports) {
class $68852d32006e28ff$export$53fd7f369b617af9 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
module.exports["MediaViewerError"] = $68852d32006e28ff$export$53fd7f369b617af9;

});

parcelRegister("c2smn", function(module, exports) {

var $iC5Q5 = parcelRequire("iC5Q5");


var $hsnIS = parcelRequire("hsnIS");


var $adEwt = parcelRequire("adEwt");

const $a3703bbade11fb84$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $a3703bbade11fb84$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $hsnIS.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $adEwt.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $a3703bbade11fb84$export$836625761e76d373 = {
    mediaInline: false
};
function $a3703bbade11fb84$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $iC5Q5.getGenericFeatureFlag)(flagName, $a3703bbade11fb84$export$836625761e76d373, featureFlags);
}
module.exports["getFeatureFlagKeysAllProducts"] = $a3703bbade11fb84$export$c8bcd5e6111ea1f3;
module.exports["getMediaFeatureFlag"] = $a3703bbade11fb84$export$383e8f51978266d;

});

parcelRegister("iC5Q5", function(module, exports) {

var $2hYl7 = parcelRequire("2hYl7");

function $cf2104adc10a7224$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $2hYl7.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}
module.exports["getGenericFeatureFlag"] = $cf2104adc10a7224$export$f2687d0de19e4973;

});

parcelRegister("2hYl7", function(module, exports) {
// window.localStorage is easier to mock in tests if wrapped in this module
const $8ed9ff59a41a6857$export$d125817a2695dbc9 = (key)=>{
    try {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        return typeof window !== 'undefined' && window.localStorage ? // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};
module.exports["getLocalMediaFeatureFlag"] = $8ed9ff59a41a6857$export$d125817a2695dbc9;

});

parcelRegister("hsnIS", function(module, exports) {
const $642951ddc1f8ae05$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $642951ddc1f8ae05$export$189fe120be7e73fc = ()=>$642951ddc1f8ae05$var$productKeys;
module.exports["getProductKeys"] = $642951ddc1f8ae05$export$189fe120be7e73fc;

});

parcelRegister("adEwt", function(module, exports) {
// Media feature flags - type and defaults defined here in one source of truth
const $55eb57bebd45f4d3$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];
module.exports["supportedProducts"] = $55eb57bebd45f4d3$export$2db74afa1ef496f1;

});

parcelRegister("cvZVo", function(module, exports) {
const $b878f2b45b924d24$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
module.exports["isImageRepresentationReady"] = $b878f2b45b924d24$export$4e33ccde53b4f0bf;

});

parcelRegister("aZfsf", function(module, exports) {
/**
 * Full resolution image fetches started before the viewer opens.
 *
 * `ImageViewer` takes the entry for the file it opens and awaits the same request, so
 * the image downloads once even when the click lands while the warm-up is still
 * downloading.
 *
 * Taking an entry hands over its `AbortController` too. The viewer then owns the
 * download, and closing the viewer aborts it as it aborts the viewer's own request.
 * Entries nobody takes are aborted when they are evicted or expire.
 *
 * Whoever takes the blob creates and revokes its own object URL.
 *
 * Entries are keyed by file, collection and watermark version. The watermark is
 * applied server-side, so a warm-up made before a watermark config change carries
 * the old watermark, and a viewer opened after the change must not take it.
 *
 * The store lives on `globalThis`, not in this module. A bundler can copy a small
 * module into several bundles, each with its own module state, and the warm-up and
 * `ImageViewer` load from different bundles. The shared key gives every copy of this
 * file the same store.
 */ /**
 * How many untaken warm-ups to hold at once. These are full resolution images and can
 * be several megabytes each, so the ceiling is deliberately low: the point is the
 * image the user is about to open, plus a little slack for hovering past one image on
 * the way to another.
 */ const $514b33a0777fba4d$var$MAX_WARMED_IMAGES = 2;
const $514b33a0777fba4d$export$96f8a06367fe92d2 = 30000;
// Versioned, so a later change to `Entry` never reads a store another version wrote.
const $514b33a0777fba4d$var$STORE_KEY = Symbol.for('@atlaskit/media-viewer/warmed-images/v1');
const $514b33a0777fba4d$var$getStore = ()=>{
    const scope = globalThis;
    let store = scope[$514b33a0777fba4d$var$STORE_KEY];
    if (!store) {
        store = new Map();
        scope[$514b33a0777fba4d$var$STORE_KEY] = store;
    }
    return store;
};
/**
 * Listeners report analytics. A throw from one must not break a take, which runs
 * inside `ImageViewer`, or an eviction, which runs inside the next warm-up.
 */ const $514b33a0777fba4d$var$notify = (call)=>{
    try {
        call();
    } catch  {
    // Ignored, see above.
    }
};
const $514b33a0777fba4d$export$6e7c4e4f0cbdf806 = ({ id: id, collectionName: collectionName, watermarkVersion: watermarkVersion })=>// Joined as JSON, because a watermark version can contain any separator character.
    JSON.stringify([
        id,
        collectionName ?? '',
        watermarkVersion ?? ''
    ]);
const $514b33a0777fba4d$export$7d5707133dcb705f = (key)=>$514b33a0777fba4d$var$getStore().has(key);
const $514b33a0777fba4d$export$41822d12dda3d8e3 = ({ id: id, collectionName: collectionName })=>{
    // The file's keys all start with the JSON of its first two parts, minus the closing
    // bracket. JSON quotes each part, so no other file's key can share the prefix.
    const prefix = `${JSON.stringify([
        id,
        collectionName ?? ''
    ]).slice(0, -1)},`;
    return [
        ...$514b33a0777fba4d$var$getStore().keys()
    ].some((key)=>key.startsWith(prefix));
};
const $514b33a0777fba4d$var$removeWarmedImage = (key, outcome)=>{
    const store = $514b33a0777fba4d$var$getStore();
    const entry = store.get(key);
    if (entry) {
        clearTimeout(entry.expiry);
        store.delete(key);
        const onEnd = entry.listener?.onEnd;
        if (outcome && onEnd) $514b33a0777fba4d$var$notify(()=>onEnd(outcome, entry.blob));
    }
    return entry;
};
const $514b33a0777fba4d$var$discardWarmedImage = (key, outcome)=>{
    $514b33a0777fba4d$var$removeWarmedImage(key, outcome)?.controller.abort();
};
const $514b33a0777fba4d$export$34a185d9a1fbb19f = (key, { image: image, controller: controller }, listener)=>{
    const store = $514b33a0777fba4d$var$getStore();
    $514b33a0777fba4d$var$discardWarmedImage(key, 'replaced');
    // `Map` iterates in insertion order, so the first key is the oldest.
    if (store.size >= $514b33a0777fba4d$var$MAX_WARMED_IMAGES) {
        const oldest = store.keys().next().value;
        if (oldest !== undefined) $514b33a0777fba4d$var$discardWarmedImage(oldest, 'evicted');
    }
    const entry = {
        image: image,
        controller: controller,
        listener: listener,
        expiry: setTimeout(()=>$514b33a0777fba4d$var$discardWarmedImage(key, 'expired'), $514b33a0777fba4d$export$96f8a06367fe92d2)
    };
    store.set(key, entry);
    image.then((blob)=>{
        entry.blob = blob;
    }, (error)=>{
        // Every removal except a take aborts the request, and so does closing the
        // viewer after a take. None of those are failures.
        if (controller.signal.aborted) return;
        // Drop a failed warm-up so a later hover can try again. This handler also marks
        // the rejection as handled when nobody takes the warm-up.
        const wasTaken = $514b33a0777fba4d$var$getStore().get(key) !== entry;
        if (!wasTaken) $514b33a0777fba4d$var$removeWarmedImage(key, 'failed');
        const onError = listener?.onError;
        if (onError) $514b33a0777fba4d$var$notify(()=>onError(error, wasTaken));
    });
};
const $514b33a0777fba4d$export$9a8bfd88893fad6a = (key)=>{
    const entry = $514b33a0777fba4d$var$removeWarmedImage(key, 'taken');
    return entry && {
        image: entry.image,
        controller: entry.controller
    };
};
const $514b33a0777fba4d$export$aa3f8cc063752584 = ()=>{
    [
        ...$514b33a0777fba4d$var$getStore().keys()
    ].forEach((key)=>$514b33a0777fba4d$var$discardWarmedImage(key));
};
module.exports["getWarmedImageKey"] = $514b33a0777fba4d$export$6e7c4e4f0cbdf806;
module.exports["hasWarmedImage"] = $514b33a0777fba4d$export$7d5707133dcb705f;
module.exports["hasWarmedImageForFile"] = $514b33a0777fba4d$export$41822d12dda3d8e3;
module.exports["setWarmedImage"] = $514b33a0777fba4d$export$34a185d9a1fbb19f;
module.exports["takeWarmedImage"] = $514b33a0777fba4d$export$9a8bfd88893fad6a;

});

parcelRegister("7l87h", function(module, exports) {
const $c6899e0d6a80ade7$export$e74e3703c1830bfb = true;
const $c6899e0d6a80ade7$export$d9f77e6e2df1dedb = (collectionName)=>({
        collection: collectionName,
        mode: 'fit'
    });
module.exports["IMAGE_VIEWER_FETCH_MAX_RES"] = $c6899e0d6a80ade7$export$e74e3703c1830bfb;
module.exports["getImageViewerRequestParams"] = $c6899e0d6a80ade7$export$d9f77e6e2df1dedb;

});

parcelRegister("gjPL4", function(module, exports) {
const $2cc17340c0c1baf9$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $2cc17340c0c1baf9$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $2cc17340c0c1baf9$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $2cc17340c0c1baf9$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $2cc17340c0c1baf9$export$d87a47989c00f322;
    if (appearance === 'square') return $2cc17340c0c1baf9$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $2cc17340c0c1baf9$export$aeb48196afcd236a;
    return $2cc17340c0c1baf9$export$d87a47989c00f322;
};
module.exports["defaultImageCardDimensions"] = $2cc17340c0c1baf9$export$d87a47989c00f322;
module.exports["getDefaultCardDimensions"] = $2cc17340c0c1baf9$export$ed7b8a4728e9c63;

});

parcelRegister("cOUnF", function(module, exports) {
const $cc00aa0e6eb20f41$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $cc00aa0e6eb20f41$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';
module.exports["fileCardImageViewSelector"] = $cc00aa0e6eb20f41$export$7a6526d4be3b7eb3;

});

parcelRegister("byc2E", function(module, exports) {

var $5bSLb = parcelRequire("5bSLb");


var $jmmTp = parcelRequire("jmmTp");


var $cvZVo = parcelRequire("cvZVo");


var $nfEzS = parcelRequire("nfEzS");


var $2rEyz = parcelRequire("2rEyz");


var $4o0zT = parcelRequire("4o0zT");


var $jX77K = parcelRequire("jX77K");


var $j8WB4 = parcelRequire("j8WB4");


var $7l87h = parcelRequire("7l87h");


var $aZfsf = parcelRequire("aZfsf");

/**
 * Share of warm-ups that report `preloadEnded`, which measures how many warm-ups the
 * viewer takes. `preloadFailed` is never sampled.
 */ const $2653f0e5e0133b7b$var$PRELOAD_ENDED_SAMPLING_RATE = 0.1;
/**
 * A warm-up is speculative, so it doesn't retry a failure with backoff. Retrying a
 * 5xx would add load when the image endpoint is already struggling, and the viewer
 * makes its own request on open anyway. media-client's Edge network-error fallback
 * still applies. `fetchRetry` waits `startTimeoutInMs` even
 * after the last attempt, so it is zero: a failed warm-up a viewer has taken then
 * hands over to the viewer's own request without a pause.
 */ const $2653f0e5e0133b7b$var$WARM_UP_CLIENT_OPTIONS = {
    retryOptions: {
        maxAttempts: 1,
        startTimeoutInMs: 0
    }
};
/** SVGs are rendered by `SvgViewer`, which does not go through the image endpoint. */ const $2653f0e5e0133b7b$var$SVG_MIME_TYPE = 'image/svg+xml';
/**
 * Effective connection types where speculatively downloading a full resolution
 * image costs the user more than the latency it saves.
 */ const $2653f0e5e0133b7b$var$METERED_EFFECTIVE_TYPES = [
    'slow-2g',
    '2g',
    '3g'
];
const $2653f0e5e0133b7b$var$isMeteredConnection = ()=>{
    if (typeof navigator === 'undefined') return false;
    const { connection: connection } = navigator;
    if (!connection) return false;
    return !!connection.saveData || !!connection.effectiveType && $2653f0e5e0133b7b$var$METERED_EFFECTIVE_TYPES.includes(connection.effectiveType);
};
const $2653f0e5e0133b7b$export$c50fda67e674adf9 = ({ getMediaClient: getMediaClient, identifier: identifier, mimeType: mimeType, mediaType: mediaType, fileState: fileState, traceContext: traceContext, onAnalyticsEvent: onAnalyticsEvent })=>{
    // External images need no warm-up: the viewer renders the same `dataURI` the
    // card is already displaying. Checked before the exposure, so neither arm is
    // exposed for them.
    if (!(0, $jmmTp.isFileIdentifier)(identifier)) return;
    if (!(0, $4o0zT.isExperimentEnabled)('platform_media_viewer_preload_on_hover')) return;
    (0, $j8WB4.loadMediaViewerChunk)().catch(()=>{});
    const resolvedMediaType = mediaType ?? (mimeType ? (0, $nfEzS.getMediaTypeFromMimeType)(mimeType) : undefined);
    if (resolvedMediaType !== 'image' || mimeType === $2653f0e5e0133b7b$var$SVG_MIME_TYPE) return;
    (0, $j8WB4.loadImageViewerChunk)().catch(()=>{});
    if (fileState) {
        // `ImageViewer` renders `fileState.preview` directly when one exists
        // (typically a local upload preview) without touching the image endpoint.
        if (!(0, $5bSLb.isErrorFileState)(fileState) && fileState.preview) return;
        // Otherwise it waits for the backend image representation before fetching.
        if (!(0, $cvZVo.isImageRepresentationReady)(fileState)) return;
    }
    if ($2653f0e5e0133b7b$var$isMeteredConnection()) return;
    const mediaClient = getMediaClient();
    const { id: id, collectionName: collectionName } = identifier;
    const warmImage = (watermarkVersion)=>{
        const key = (0, $aZfsf.getWarmedImageKey)({
            id: id,
            collectionName: collectionName,
            watermarkVersion: watermarkVersion
        });
        // An existing entry is either still downloading or already resolved. Either way
        // the viewer can take it, so there is nothing to do. Checked after the version
        // resolves, so repeated hovers still make one request.
        if ((0, $aZfsf.hasWarmedImage)(key)) return;
        const controller = new AbortController();
        const startedAt = Date.now();
        const fileSize = fileState && !(0, $5bSLb.isErrorFileState)(fileState) ? fileState.size : undefined;
        const fileAttributes = {
            fileId: id,
            fileMediatype: resolvedMediaType,
            fileMimetype: mimeType,
            ...fileSize !== undefined && {
                fileSize: fileSize
            }
        };
        const report = (createPayload)=>{
            try {
                // Sanitised here, as every media channel event is, so each caller sends the
                // same masked payload.
                onAnalyticsEvent?.((0, $2rEyz.sanitiseAnalyticsPayload)(createPayload()));
            } catch  {
            // Analytics must never break the warm-up.
            }
        };
        const isSampled = !!onAnalyticsEvent && Math.random() < $2653f0e5e0133b7b$var$PRELOAD_ENDED_SAMPLING_RATE;
        (0, $aZfsf.setWarmedImage)(key, {
            image: mediaClient.getImage(id, (0, $7l87h.getImageViewerRequestParams)(collectionName), controller, (0, $7l87h.IMAGE_VIEWER_FETCH_MAX_RES), traceContext, $2653f0e5e0133b7b$var$WARM_UP_CLIENT_OPTIONS),
            controller: controller
        }, onAnalyticsEvent && {
            onEnd: isSampled ? (outcome, blob)=>report(()=>(0, $jX77K.createPreloadEndedEventPayload)({
                        outcome: outcome,
                        blob: blob,
                        durationMs: Date.now() - startedAt,
                        fileAttributes: fileAttributes,
                        traceContext: traceContext,
                        samplingRate: $2653f0e5e0133b7b$var$PRELOAD_ENDED_SAMPLING_RATE
                    })) : undefined,
            onError: (error, wasTaken)=>report(()=>(0, $jX77K.createPreloadFailedEventPayload)({
                        error: error,
                        wasTaken: wasTaken,
                        durationMs: Date.now() - startedAt,
                        fileAttributes: fileAttributes,
                        traceContext: traceContext
                    }))
        });
    };
    // The key carries the watermark version the image request is made with, so a
    // warm-up made before a watermark config change never reaches a viewer opened after
    // it. If auth fails, the image request would fail too, so only the chunks are warmed
    // and the viewer's own request reports the failure. Called inside a promise, so a
    // throw (say, from an older media-client without the method) can't reach the hover
    // handler that called this.
    Promise.resolve().then(()=>mediaClient.getImageWatermarkVersion(collectionName)).then(warmImage, ()=>{});
};
module.exports["preloadMediaViewer"] = $2653f0e5e0133b7b$export$c50fda67e674adf9;

});

parcelRegister("jX77K", function(module, exports) {

var $25FkG = parcelRequire("25FkG");


var $5i0UP = parcelRequire("5i0UP");


var $27DLG = parcelRequire("27DLG");


var $3Kyrj = parcelRequire("3Kyrj");


var $cfGuz = parcelRequire("cfGuz");

const $d07302cd3f2ad9ed$export$73691aece6b385c6 = ({ error: error, wasTaken: wasTaken, durationMs: durationMs, fileAttributes: fileAttributes, traceContext: traceContext })=>{
    const viewerError = new (0, $cfGuz.MediaViewerError)('preload-image-fetch', error instanceof Error ? error : undefined);
    const requestMetadata = (0, $27DLG.getRequestMetadata)(viewerError);
    return {
        eventType: 'operational',
        actionSubject: 'mediaFile',
        action: 'preloadFailed',
        attributes: {
            status: 'fail',
            failReason: (0, $5i0UP.getPrimaryErrorReason)(viewerError),
            error: (0, $3Kyrj.getSecondaryErrorReason)(viewerError),
            errorDetail: (0, $25FkG.getErrorDetail)(viewerError),
            statusCode: requestMetadata?.statusCode,
            request: requestMetadata,
            fileMimetype: fileAttributes.fileMimetype,
            fileMediatype: fileAttributes.fileMediatype,
            fileAttributes: fileAttributes,
            traceContext: traceContext,
            wasTaken: wasTaken,
            durationMs: durationMs
        }
    };
};
const $d07302cd3f2ad9ed$export$b449648f7a4fa168 = ({ outcome: outcome, blob: blob, durationMs: durationMs, fileAttributes: fileAttributes, traceContext: traceContext, samplingRate: samplingRate })=>({
        eventType: 'operational',
        actionSubject: 'mediaFile',
        action: 'preloadEnded',
        attributes: {
            outcome: outcome,
            resolved: !!blob,
            sizeBytes: blob?.size,
            durationMs: durationMs,
            fileAttributes: fileAttributes,
            traceContext: traceContext,
            isSamplingEnabled: samplingRate < 1,
            samplingRate: samplingRate
        }
    });
module.exports["createPreloadFailedEventPayload"] = $d07302cd3f2ad9ed$export$73691aece6b385c6;
module.exports["createPreloadEndedEventPayload"] = $d07302cd3f2ad9ed$export$b449648f7a4fa168;

});

parcelRegister("8TTbR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $j3UOY = parcelRequire("j3UOY");


var $gWRZb = parcelRequire("gWRZb");

const $75428e9db26defa4$var$DURATION_MIN = 0.5;
const $75428e9db26defa4$var$DURATION_MAX = 1.0;
const $75428e9db26defa4$var$EXTRA_PADDING = 4;
const $75428e9db26defa4$export$ba458cf715b18bd1 = {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
};
const $75428e9db26defa4$export$9f2ec2b609810bce = 'media-filmstrip-list-item';
class $75428e9db26defa4$export$817db220b90d8024 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    get offset() {
        const { offset: offset } = this.props;
        if (!offset) return 0;
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    get minOffset() {
        return 0;
    }
    /**
   * The furthest we can scroll, where the end of the buffer is just in view
   */ get maxOffset() {
        const { bufferWidth: bufferWidth, windowWidth: windowWidth } = this.state;
        return Math.max(this.minOffset, bufferWidth - windowWidth - 1);
    }
    get canGoLeft() {
        return this.offset > this.minOffset;
    }
    get canGoRight() {
        return this.offset < this.maxOffset;
    }
    get transitionDuration() {
        const { animate: animate } = this.props;
        const { windowWidth: windowWidth } = this.state;
        if (!animate) return 0;
        if (Math.abs(this.offset - this.previousOffset) < 1e-6) return $75428e9db26defa4$var$DURATION_MIN;
        else {
            const diff = Math.abs(this.offset - this.previousOffset);
            const relativeOffset = diff / windowWidth;
            const duration = $75428e9db26defa4$var$DURATION_MAX - $75428e9db26defa4$var$DURATION_MIN * relativeOffset;
            return Math.max(Math.min(duration, $75428e9db26defa4$var$DURATION_MAX), $75428e9db26defa4$var$DURATION_MIN);
        }
    }
    initMutationObserver() {
        const { mutationObserver: mutationObserver } = this;
        if (mutationObserver && this.bufferElement) {
            mutationObserver.disconnect();
            mutationObserver.observe(this.bufferElement, $75428e9db26defa4$export$ba458cf715b18bd1);
        }
    }
    // find the child that is cut off on the left edge of the window and change the window offset to
    // start to the left of that child
    getClosestForLeft(offset) {
        const leftWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset));
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (leftWindowEdge >= childBounds.left && leftWindowEdge <= childBounds.right) {
                const newOffset = i === 0 ? childBounds.left : childBounds.right;
                if (newOffset >= $75428e9db26defa4$var$EXTRA_PADDING) return newOffset - $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    // find the child that is cut off on the right edge of the window and change the window offset
    // to finish at start of the next child
    getClosestForRight(offset) {
        const { windowWidth: windowWidth } = this.state;
        const rightWindowEdge = Math.min(this.maxOffset, Math.max(this.minOffset, offset)) + windowWidth;
        for(let i = 0; i < this.childOffsets.length; ++i){
            const childBounds = this.childOffsets[i];
            if (rightWindowEdge >= childBounds.left && rightWindowEdge <= childBounds.right) {
                const newOffset = (i === this.childOffsets.length - 1 ? childBounds.right : childBounds.left) - windowWidth;
                if (newOffset + $75428e9db26defa4$var$EXTRA_PADDING <= this.maxOffset) return newOffset + $75428e9db26defa4$var$EXTRA_PADDING; // show extra padding from the next sibling for aesthetic reasons
                else return newOffset;
            }
        }
        return Math.min(this.maxOffset, Math.max(this.minOffset, offset));
    }
    renderLeftArrow() {
        const { canGoLeft: canGoLeft } = this;
        if (!canGoLeft) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.LeftArrow), {
            onClick: this.handleLeftClick
        });
    }
    renderRightArrow() {
        const { canGoRight: canGoRight } = this;
        if (!canGoRight) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.RightArrow), {
            onClick: this.handleRightClick
        });
    }
    componentDidMount() {
        this.previousOffset = this.offset;
        window.addEventListener('resize', this.handleSizeChange);
    }
    componentWillUnmount() {
        const { mutationObserver: mutationObserver } = this;
        window.removeEventListener('resize', this.handleSizeChange);
        if (mutationObserver) mutationObserver.disconnect();
    }
    componentDidUpdate() {
        this.previousOffset = this.offset;
    }
    render() {
        const { animate: animate, children: children, testId: testId } = this.props;
        const transform = `translateX(${-this.offset}px)`;
        const transitionProperty = animate ? 'transform' : 'none';
        const transitionDuration = `${this.transitionDuration}s`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripViewWrapper), {
            "data-testid": testId
        }, this.renderLeftArrow(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListWrapper), {
            ref: this.handleWindowElementChange,
            onWheel: this.handleScroll,
            onTouchStart: this.handleTouchStart,
            onTouchMove: this.handleTouchMove,
            onTouchEnd: this.handleTouchEnd,
            "data-testid": "filmstrip-list-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripList), {
            ref: this.handleBufferElementChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                transform: transform,
                transitionProperty: transitionProperty,
                transitionDuration: transitionDuration
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, $75428e9db26defa4$var$mapReactChildToReactNode))), this.renderRightArrow());
    }
    constructor(props){
        super(props);
        this.bufferElement = void 0;
        this.windowElement = void 0;
        this.mutationObserver = void 0;
        this.childOffsets = void 0;
        this.previousOffset = 0;
        this.state = {
            bufferWidth: 0,
            windowWidth: 0,
            touchMoveStartPosition: 0,
            isTouchMoveInProgress: false
        };
        this.handleSizeChange = ()=>{
            // get the new widths
            const { windowElement: windowElement, bufferElement: bufferElement } = this;
            let bufferWidth = 0;
            let windowWidth = 0;
            let childOffsets = [];
            if (windowElement && bufferElement) {
                bufferWidth = bufferElement.getBoundingClientRect().width;
                windowWidth = windowElement.getBoundingClientRect().width;
                // we're calculating `left` based on `width` because `rect.left` can be a negative value after resizing the window (considered scrolled??)
                const children = Array.prototype.slice.call(bufferElement.children, 0);
                let left = 0;
                childOffsets = children.map((child, _index)=>{
                    const width = child.getBoundingClientRect().width;
                    const offset = {
                        left: left,
                        right: left + width - 1
                    };
                    left += width;
                    return offset;
                });
            }
            // make sure the state has changed before we update state and notify the integrator
            // (otherwise, since this method() is called in componentDidUpdate() we'll recurse until the stack size is exceeded)
            const { bufferWidth: prevBufferWidth, windowWidth: prevWindowWidth } = this.state;
            if (bufferWidth === prevBufferWidth && windowWidth === prevWindowWidth) // NOTE: we're not checking here if childOffsets has changed... if the children change size but
            // result in the exact same size buffer, we're not going to update, resulting in incorrect navigations
            return;
            // store the widths
            this.setState({
                bufferWidth: bufferWidth,
                windowWidth: windowWidth
            }, ()=>{
                this.childOffsets = childOffsets;
                // notify the integrator
                const { onSize: onSize } = this.props;
                if (onSize) onSize({
                    offset: Math.min(this.maxOffset, this.offset),
                    offsets: childOffsets,
                    width: windowWidth,
                    minOffset: this.minOffset,
                    maxOffset: this.maxOffset
                });
            });
        };
        this.handleWindowElementChange = (windowElement)=>{
            this.windowElement = windowElement;
            this.handleSizeChange();
        };
        this.handleBufferElementChange = (bufferElement)=>{
            if (!bufferElement) return;
            this.bufferElement = bufferElement;
            this.handleSizeChange();
            this.initMutationObserver();
        };
        this.handleMutation = (_mutationList)=>{
            // there are edge cases where the DOM may change outside of the normal React life-cycle
            // https://product-fabric.atlassian.net/browse/MSW-425
            this.handleSizeChange();
        };
        this.handleLeftClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForLeft(this.offset - windowWidth);
                if (newOffset >= this.offset) // if for some reason we tried to scroll left but it didn't scroll or scrolls right instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.max(this.offset - windowWidth, this.minOffset);
                onScroll({
                    direction: 'left',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleRightClick = (event)=>{
            // Stop the click event from bubling up and being handled by other components
            // See https://product-fabric.atlassian.net/browse/MSW-165
            event.stopPropagation();
            const { onScroll: onScroll } = this.props;
            if (onScroll) {
                const { windowWidth: windowWidth } = this.state;
                let newOffset = this.getClosestForRight(this.offset + windowWidth);
                if (newOffset <= this.offset) // if for some reason we tried to scroll right but it didn't scroll or scrolls left instead (can happen when container is too narrow)
                // just try to scroll by the windowWidth
                newOffset = Math.min(this.offset + windowWidth, this.maxOffset);
                onScroll({
                    direction: 'right',
                    offset: newOffset,
                    animate: true
                });
            }
        };
        this.handleScroll = (event)=>{
            const isHorizontalScroll = Math.abs(event.deltaX) > Math.abs(event.deltaY);
            if (!isHorizontalScroll) return;
            // don't actually let the element scroll because we'll fake scrolling with `transform: translateX()`
            event.preventDefault();
            // notify the integrator of the offset change
            const { onScroll: onScroll } = this.props;
            if (onScroll && isHorizontalScroll) {
                const newOffset = Math.max(this.minOffset, Math.min(this.maxOffset, this.offset + event.deltaX));
                onScroll({
                    direction: event.deltaX < 0 ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.handleTouchStart = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: true
            });
        };
        this.handleTouchEnd = (event)=>{
            if (event.touches[0]) this.setState({
                touchMoveStartPosition: event.touches[0].clientX,
                isTouchMoveInProgress: false
            });
        };
        this.handleTouchMove = (event)=>{
            const { onScroll: onScroll } = this.props;
            if (this.state.isTouchMoveInProgress && onScroll) {
                const currentPosition = event.touches[0].clientX;
                const newOffset = this.state.touchMoveStartPosition ? this.offset - (currentPosition - this.state.touchMoveStartPosition) : this.offset;
                onScroll({
                    direction: newOffset > this.offset ? 'left' : 'right',
                    offset: newOffset,
                    animate: false
                });
            }
        };
        this.childOffsets = [];
        try {
            this.mutationObserver = new MutationObserver((0, (/*@__PURE__*/$parcel$interopDefault($j3UOY)))(this.handleMutation, 30, true));
        // eslint-disable-next-line no-unused-vars
        } catch (e) {
        // in the case where we are running on an unsupported browser,
        // or where tests include the FilmstripView but do not mock the MutationObserver - we catch it and handle safely here.
        // NOTE: this won't effect the component, it just means mutations won't be observerd
        }
    }
}
$75428e9db26defa4$export$817db220b90d8024.defaultProps = {
    animate: false,
    offset: 0
};
function $75428e9db26defa4$var$mapReactChildToReactNode(child, index) {
    const key = $75428e9db26defa4$var$isReactElement(child) && child.key || index;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gWRZb.FilmStripListItem), {
        key: key,
        index: key
    }, child);
}
function $75428e9db26defa4$var$isReactElement(child) {
    return !!child.type;
}
module.exports["MediaFilmStripListItemSelector"] = $75428e9db26defa4$export$9f2ec2b609810bce;
module.exports["FilmstripView"] = $75428e9db26defa4$export$817db220b90d8024;

});

parcelRegister("j3UOY", function(module, exports) {
/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */ function $de0a5fa3d60c62bd$var$debounce(func, wait, immediate) {
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
    function later() {
        var last = Date.now() - timestamp;
        if (last < wait && last >= 0) timeout = setTimeout(later, wait - last);
        else {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
            }
        }
    }
    var debounced = function() {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
            result = func.apply(context, args);
            context = args = null;
        }
        return result;
    };
    debounced.clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    debounced.flush = function() {
        if (timeout) {
            result = func.apply(context, args);
            context = args = null;
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return debounced;
}
// Adds compatibility for ES modules
$de0a5fa3d60c62bd$var$debounce.debounce = $de0a5fa3d60c62bd$var$debounce;
module.exports = $de0a5fa3d60c62bd$var$debounce;

});

parcelRegister("gWRZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jXJyv = parcelRequire("jXJyv");

const $8dba4ca83cef8f6b$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowLeftWrapper), props);
const $8dba4ca83cef8f6b$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ShadowRight), props);
const $8dba4ca83cef8f6b$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.ArrowRightWrapper), props);
const $8dba4ca83cef8f6b$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.LeftArrow), props);
const $8dba4ca83cef8f6b$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.RightArrow), props);
const $8dba4ca83cef8f6b$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripViewWrapper), props);
const $8dba4ca83cef8f6b$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListWrapper), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] !== props || $[1] !== ref) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
            ...props,
            ref: ref
        });
        $[0] = props;
        $[1] = ref;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripList), {
        ...props,
        ref: ref
    }));
const $8dba4ca83cef8f6b$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jXJyv.FilmStripListItem), props);
module.exports["LeftArrow"] = $8dba4ca83cef8f6b$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $8dba4ca83cef8f6b$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $8dba4ca83cef8f6b$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $8dba4ca83cef8f6b$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $8dba4ca83cef8f6b$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $8dba4ca83cef8f6b$export$54cfc70c184c0713;

});

parcelRegister("jXJyv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kdlgT = parcelRequire("kdlgT");


var $aRvnq = parcelRequire("aRvnq");


var $iDrrr = parcelRequire("iDrrr");


var $8TTbR = parcelRequire("8TTbR");

const $b735c99c0da4e1ae$var$filmStripViewStyles = null;
const $b735c99c0da4e1ae$var$filmStripListWrapperStyles = null;
const $b735c99c0da4e1ae$var$filmStripListStyles = null;
const $b735c99c0da4e1ae$var$filmStripListItemStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowWrapperMotionStyles = null;
const $b735c99c0da4e1ae$var$arrowLeftWrapperStyles = null;
const $b735c99c0da4e1ae$var$arrowRightWrapperStyles = null;
const $b735c99c0da4e1ae$var$shadowStyles = null;
const $b735c99c0da4e1ae$var$resetButtonStyle = null;
const $b735c99c0da4e1ae$var$shadowLeftStyles = null;
const $b735c99c0da4e1ae$var$shadowRightStyles = null;
const $b735c99c0da4e1ae$var$ShadowLeft = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_3OE6xYdnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$924abd21043fc000 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, onClick: onClick } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]);
        t2 = (0, $iDrrr.fg)("platform_media_filmstrip_arrow_type_fix") ? {
            type: "button"
        } : {};
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== onClick) {
        t3 = (event)=>onClick && onClick(event);
        $[2] = onClick;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            ...t2,
            onClick: t3
        }, children);
        $[4] = children;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_3OE6xY2ADO _20JdpsFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]),
        ...(0, $iDrrr.fg)('platform_media_filmstrip_arrow_type_fix') ? {
            type: 'button'
        } : {},
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _42Yu6B3p0A _0jFU0VN91d _2IhTondnbC _39xV024Jdh _0KLXru9r67",
            "_4ApkO2dnbC"
        ])
    }, children);
const $b735c99c0da4e1ae$export$abf07652016c7e56 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, onClick: onClick } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]);
        t2 = (0, $iDrrr.fg)("platform_media_filmstrip_arrow_type_fix") ? {
            type: "button"
        } : {};
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== onClick) {
        t3 = (event)=>onClick && onClick(event);
        $[2] = onClick;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== children || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            className: t1,
            ...t2,
            onClick: t3
        }, children);
        $[4] = children;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ children: children, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $hekY6.default)([
            "_1mb4UnZqHV _3iDTPbvLZJ",
            "_0bjKvDS5Zs _23rrnHyKLB _1mT5xdWVPG _2IhTon715P _1VJPcakruI _0KLXruoI2d _3iDTPbQ4SZ _0wOv4Q7zJH _2OUyjtGk8v _1UtDYz8ujp _39xV02uNcX _0jFU0VuNcX _37wbyuDIqT _1YKVNsdnbC _2Qxi4nuNcX _27VeLCSPN1 _0clgaMZpcK _1eOmH6hWTW _3sFUREiSCN _0CMRbkjTy9 _3gzVzLY9q9",
            "_4ApkO22ADO _0woc9oFQfX",
            "_23rrnHyKLB _3sFUREiSCN",
            "arrow"
        ]),
        ...(0, $iDrrr.fg)('platform_media_filmstrip_arrow_type_fix') ? {
            type: 'button'
        } : {},
        onClick: (event)=>onClick && onClick(event)
    }, children);
};
const $b735c99c0da4e1ae$export$b39b1b86b48b621f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
            color: "currentColor",
            spacing: "spacious",
            label: "left"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$var$ShadowLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$924abd21043fc000, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        color: "currentColor",
        spacing: "spacious",
        label: "left"
    })));
const $b735c99c0da4e1ae$export$6208675820d4cc50 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { onClick: onClick } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
            color: "currentColor",
            spacing: "spacious",
            label: "right"
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== onClick) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
            onClick: onClick
        }, t1));
        $[1] = onClick;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$a5ffe38c17bbc0a1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b735c99c0da4e1ae$export$abf07652016c7e56, {
        onClick: onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        color: "currentColor",
        spacing: "spacious",
        label: "right"
    })));
const $b735c99c0da4e1ae$export$d37eb83491863cbb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, 'data-testid': dataTestId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _1mT5xdRAKS _0Of8r2FQfX _1ZnuxbdnbC _1wydGWFQfX _2Zuz6QdnbC _4FvuRP7dHp _05i3wkzUZr"
        ])
    }, children);
const $b735c99c0da4e1ae$export$4b7fe5339e3afada = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(9);
    const { children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, "data-testid": dataTestId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== dataTestId || $[3] !== onTouchEnd || $[4] !== onTouchMove || $[5] !== onTouchStart || $[6] !== onWheel || $[7] !== ref) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: ref,
            onWheel: onWheel,
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd,
            "data-testid": dataTestId,
            className: t1
        }, children);
        $[1] = children;
        $[2] = dataTestId;
        $[3] = onTouchEnd;
        $[4] = onTouchMove;
        $[5] = onTouchStart;
        $[6] = onWheel;
        $[7] = ref;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ children: children, onWheel: onWheel, onTouchStart: onTouchStart, onTouchMove: onTouchMove, onTouchEnd: onTouchEnd, 'data-testid': dataTestId }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        onWheel: onWheel,
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd,
        "data-testid": dataTestId,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02OLYo _0Of8r2FQfX _1ZnuxbFQfX _1wydGWFQfX _2Zuz6QFQfX"
        ])
    }, children));
const $b735c99c0da4e1ae$export$710ee13c74b7a1f0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children, style: style } = t0;
    const t1 = ref;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== children || $[2] !== style || $[3] !== t1) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
            ref: t1,
            style: style,
            className: t2
        }, children);
        $[1] = children;
        $[2] = style;
        $[3] = t1;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, style: style }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("ul", {
        ref: ref,
        style: style,
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2AASz _1ZnuxbAASz _1wydGWAASz _2Zuz6QAASz _1kOSYtC67X _0qk6IKBr0D _1ANEUSLRg7 _3iDTPbvbI6"
        ])
    }, children));
const $b735c99c0da4e1ae$export$54cfc70c184c0713 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children, index: index } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== index) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li", {
            className: t1,
            "data-testid": "media-filmstrip-list-item",
            key: index
        }, children);
        $[1] = children;
        $[2] = index;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ children: children, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0aNu0LYbGa _0Of8r2dnbC _1Znuxb1Y8M _1wydGWdnbC _2Zuz6Q1Y8M _3iDTPbvbI6 _1RrJLit2nV _4ya3eEdnbC _3NdKS6dnbC",
            (0, $8TTbR.MediaFilmStripListItemSelector)
        ]),
        "data-testid": "media-filmstrip-list-item",
        key: index
    }, children);
module.exports["ArrowLeftWrapper"] = $b735c99c0da4e1ae$export$924abd21043fc000;
module.exports["ShadowRight"] = $b735c99c0da4e1ae$export$a5ffe38c17bbc0a1;
module.exports["ArrowRightWrapper"] = $b735c99c0da4e1ae$export$abf07652016c7e56;
module.exports["LeftArrow"] = $b735c99c0da4e1ae$export$b39b1b86b48b621f;
module.exports["RightArrow"] = $b735c99c0da4e1ae$export$6208675820d4cc50;
module.exports["FilmStripViewWrapper"] = $b735c99c0da4e1ae$export$d37eb83491863cbb;
module.exports["FilmStripListWrapper"] = $b735c99c0da4e1ae$export$4b7fe5339e3afada;
module.exports["FilmStripList"] = $b735c99c0da4e1ae$export$710ee13c74b7a1f0;
module.exports["FilmStripListItem"] = $b735c99c0da4e1ae$export$54cfc70c184c0713;

});

parcelRegister("4cczm", function(module, exports) {
const $577b7b0c5e75a3c1$export$d821aa4c8afb384e = 'fabric-elements';
const $577b7b0c5e75a3c1$export$af8124aa496797f2 = '_|unknown|_';
module.exports["ELEMENTS_CHANNEL"] = $577b7b0c5e75a3c1$export$d821aa4c8afb384e;
module.exports["UNKNOWN_USER_ID"] = $577b7b0c5e75a3c1$export$af8124aa496797f2;

});

parcelRegister("cLgZp", function(module, exports) {
const $01246376cedc8400$export$4369c812aac99591 = (p)=>!!(p && p.then);
module.exports["isPromise"] = $01246376cedc8400$export$4369c812aac99591;

});

parcelRegister("caelp", function(module, exports) {
const $c573a2458006a7eb$export$43bc8ec87115a7b3 = '__agent-mentions-load-error__';
var $c573a2458006a7eb$export$2102863a3c660c6b = /*#__PURE__*/ function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
    MentionType[MentionType["DISABLED"] = 3] = "DISABLED";
    return MentionType;
}({});
var $c573a2458006a7eb$export$81124e6148ca5db0 = /*#__PURE__*/ function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
    return UserAccessLevel;
}({});
var $c573a2458006a7eb$export$8436e53e45ffe15b = /*#__PURE__*/ function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
    return UserType;
}({});
var $c573a2458006a7eb$export$7afb0727c7d7e8af = /*#__PURE__*/ function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
    return SliNames;
}({});
var $c573a2458006a7eb$export$5c42d9dea6d035c1 = /*#__PURE__*/ function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
    return ComponentNames;
}({});
var $c573a2458006a7eb$export$b52183d5cfb26dc9 = /*#__PURE__*/ function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
    return Actions;
}({});
var $c573a2458006a7eb$export$b8fa67dc54502853 = /*#__PURE__*/ function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
    return MentionNameStatus;
}({});
module.exports["AGENT_MENTION_LOAD_ERROR_ID"] = $c573a2458006a7eb$export$43bc8ec87115a7b3;
module.exports["MentionType"] = $c573a2458006a7eb$export$2102863a3c660c6b;
module.exports["UserAccessLevel"] = $c573a2458006a7eb$export$81124e6148ca5db0;
module.exports["UserType"] = $c573a2458006a7eb$export$8436e53e45ffe15b;
module.exports["SliNames"] = $c573a2458006a7eb$export$7afb0727c7d7e8af;
module.exports["ComponentNames"] = $c573a2458006a7eb$export$5c42d9dea6d035c1;
module.exports["Actions"] = $c573a2458006a7eb$export$b52183d5cfb26dc9;
module.exports["MentionNameStatus"] = $c573a2458006a7eb$export$b8fa67dc54502853;

});

parcelRegister("2SUNK", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b516e3b9bd2f12c$export$2e2bcd8739ae039);
let $1b516e3b9bd2f12c$var$debugEnabled = false;
let $1b516e3b9bd2f12c$var$stacktracesEnabled = false;
function $1b516e3b9bd2f12c$export$748ada60eaf985cc(enable) {
    $1b516e3b9bd2f12c$var$debugEnabled = enable;
}
function $1b516e3b9bd2f12c$export$4f7017086af31c25(enable) {
    $1b516e3b9bd2f12c$var$stacktracesEnabled = enable;
}
function $1b516e3b9bd2f12c$export$2a858f450a2f66d() {
    if ($1b516e3b9bd2f12c$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $1b516e3b9bd2f12c$export$2e2bcd8739ae039(msg, ...args) {
    if ($1b516e3b9bd2f12c$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("4B8nE", function(module, exports) {
const $d00b5c54493e40b2$export$9345d7360ffe0722 = "platform-pkg";
module.exports["packageName"] = $d00b5c54493e40b2$export$9345d7360ffe0722;

});

parcelRegister("iu9yU", function(module, exports) {
const $d5e04dfa126c7e5e$export$91546b032799aa40 = "0.0.0-use.local";
module.exports["packageVersion"] = $d5e04dfa126c7e5e$export$91546b032799aa40;

});

parcelRegister("lUcpS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $k78uC = parcelRequire("k78uC");


var $8IfK6 = parcelRequire("8IfK6");

const $91b0a64470223be6$export$5bf35293e545f20c = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent) {
        t0 = (...t1)=>{
            const params = t1;
            const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
            event.fire((0, $k78uC.EVENT_CHANNEL));
        };
        $[0] = createAnalyticsEvent;
        $[1] = t0;
    } else t0 = $[1];
    const fireEvent = t0;
    let t1;
    if ($[2] !== fireEvent) {
        t1 = {
            fireEvent: fireEvent
        };
        $[2] = fireEvent;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireEvent = (0, $cozmU.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $8IfK6.default)(...params));
        event.fire((0, $k78uC.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $91b0a64470223be6$export$5bf35293e545f20c;

});

parcelRegister("k78uC", function(module, exports) {
const $0de3cce3bcdfa361$export$3f072f06b90c3985 = 'peopleTeams';
module.exports["EVENT_CHANNEL"] = $0de3cce3bcdfa361$export$3f072f06b90c3985;

});

parcelRegister("8IfK6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::378c0a04d2cca8641793d5a92fac3d1a>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen teams-app-internal-analytics
 */ const $fcb00cbaaafbad36$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $fcb00cbaaafbad36$export$2e2bcd8739ae039 = $fcb00cbaaafbad36$var$createEventPayload;
module.exports["default"] = $fcb00cbaaafbad36$export$2e2bcd8739ae039;

});

parcelRegister("cSSWJ", function(module, exports) {
const $e8b102093dcaac45$export$849551cf61929d4f = {
    packageName: "platform-pkg" ?? '',
    packageVersion: "0.0.0-use.local" ?? ''
};
const $e8b102093dcaac45$export$efd16d9cf43b6e97 = 'teamProfileCard';
const $e8b102093dcaac45$export$7611b3e6899481f9 = 'profilecard';
const $e8b102093dcaac45$export$4c23d6e68fa71371 = 'rovoAgentProfilecard';
module.exports["PACKAGE_META_DATA"] = $e8b102093dcaac45$export$849551cf61929d4f;
module.exports["TEAM_SUBJECT"] = $e8b102093dcaac45$export$efd16d9cf43b6e97;
module.exports["USER_SUBJECT"] = $e8b102093dcaac45$export$7611b3e6899481f9;
module.exports["AGENT_SUBJECT"] = $e8b102093dcaac45$export$4c23d6e68fa71371;

});

parcelRegister("4PAHv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $7G50J = parcelRequire("7G50J");


var $hMCZS = parcelRequire("hMCZS");


var $lUcpS = parcelRequire("lUcpS");


var $dSW04 = parcelRequire("dSW04");


var $dRAjC = parcelRequire("dRAjC");


var $4k5Wq = parcelRequire("4k5Wq");


var $kb2tZ = parcelRequire("kb2tZ");


var $hIwXM = parcelRequire("hIwXM");

const $fe1c8bc12e81e628$export$4b013ffffcb40af8 = (props)=>{
    const [agentData, setAgentData] = (0, $cozmU.useState)();
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)();
    const [isPermitted, setIsPermitted] = (0, $cozmU.useState)(true);
    const { fireEvent: fireEvent } = (0, $lUcpS.useAnalyticsEvents)();
    const creatorUserId = (0, $cozmU.useMemo)(()=>agentData?.creator_type === 'CUSTOMER' && agentData.creator ? (0, $dRAjC.getAAIDFromARI)(agentData.creator) : '', [
        agentData?.creator_type,
        agentData?.creator
    ]);
    const navResult = (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: creatorUserId || ''
        },
        cloudId: props.cloudId
    });
    let profileHref = navResult.href;
    const getCreator = (0, $cozmU.useCallback)(async ({ creator_type: creator_type, creator: creator, authoringTeam: authoringTeam })=>{
        try {
            let userCreatorInfo;
            const currentCreatorUserId = creator_type === 'CUSTOMER' && creator ? (0, $dRAjC.getAAIDFromARI)(creator) : undefined;
            if (currentCreatorUserId && props.cloudId) {
                userCreatorInfo = await props.resourceClient.getProfile(props.cloudId, currentCreatorUserId, fireEvent);
                profileHref = (0, $hMCZS.navigateToTeamsApp)({
                    type: 'USER',
                    payload: {
                        userId: currentCreatorUserId
                    },
                    cloudId: props.cloudId
                }).href;
            }
            const creatorInfo = (0, $7G50J.getAgentCreator)({
                creatorType: creator_type,
                authoringTeam: authoringTeam ? {
                    displayName: authoringTeam.displayName ?? '',
                    profileLink: authoringTeam.profileUrl ?? undefined
                } : undefined,
                userCreator: userCreatorInfo ? {
                    name: userCreatorInfo.fullName ?? '',
                    profileLink: (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? profileHref : `/people/${currentCreatorUserId}`
                } : undefined,
                forgeCreator: creator ?? undefined
            });
            return creatorInfo;
        } catch  {
            return undefined;
        }
    }, [
        fireEvent,
        props.cloudId,
        props.resourceClient,
        profileHref
    ]);
    const fetchData = (0, $cozmU.useCallback)(async ()=>{
        setIsLoading(true);
        try {
            const profileResult = await props.resourceClient.getRovoAgentProfile({
                type: 'identity',
                value: props.accountId
            }, fireEvent);
            const profileData = profileResult.restData;
            const creatorInfoProps = {
                creator_type: profileData?.creator_type,
                creator: profileData?.creator || undefined,
                authoringTeam: profileResult.aggData?.authoringTeam ?? undefined
            };
            const agentCreatorInfo = await getCreator(creatorInfoProps);
            setAgentData({
                ...profileData,
                creatorInfo: agentCreatorInfo
            });
        } catch (err) {
            if (err instanceof (0, $dSW04.AgentForbiddenError)) setIsPermitted(false);
            else setError(err);
        } finally{
            setIsLoading(false);
        }
    }, [
        fireEvent,
        getCreator,
        props.accountId,
        props.resourceClient
    ]);
    // Depend on accountId rather than fetchData to avoid a re-fetch loop:
    // agentData changes → creatorUserId → getCreator → fetchData ref changes → useEffect re-fires.
    // Reset state on accountId change so stale data from the previous agent isn't briefly shown.
    (0, $cozmU.useEffect)(()=>{
        setAgentData(undefined);
        setError(undefined);
        setIsLoading(true);
        fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.accountId
    ]);
    const forbiddenAgent = (0, $cozmU.useMemo)(()=>(0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? {
            id: '',
            named_id: '',
            name: props.agentName ?? '',
            description: '\u00A0',
            creator_type: 'CUSTOMER',
            is_default: false,
            actor_type: 'AGENT',
            user_defined_conversation_starters: null,
            favourite: false,
            favourite_count: 0,
            identity_account_id: props.accountId,
            creatorInfo: undefined
        } : undefined, [
        props.agentName,
        props.accountId
    ]);
    if (!isPermitted) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: null,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
                agent: (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') ? forbiddenAgent : {
                    id: '',
                    named_id: '',
                    name: props.agentName ?? '',
                    description: '\u00A0',
                    creator_type: 'CUSTOMER',
                    is_default: false,
                    actor_type: 'AGENT',
                    user_defined_conversation_starters: null,
                    favourite: false,
                    favourite_count: 0,
                    identity_account_id: props.accountId,
                    creatorInfo: undefined
                },
                isLoading: false,
                resourceClient: props.resourceClient,
                cloudId: props.cloudId,
                hideAgentActions: true,
                hideConversationStarters: true,
                hideAiDisclaimer: true,
                hideStarButton: props.hideStarButton,
                showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
                footerComponent: props.footerComponent
            })
        })
    });
    if (error || !isLoading && !agentData) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kb2tZ.AgentProfileCardWrapper), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4k5Wq.default), {
            reload: ()=>{
                fetchData();
            },
            errorType: error || null,
            fireAnalytics: fireEvent
        })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hIwXM.AgentProfileCardLazy), {
            agent: agentData,
            isLoading: isLoading,
            hasError: !!error,
            onConversationStartersClick: props.onConversationStartersClick,
            onChatClick: props.onChatClick,
            addFlag: props.addFlag,
            resourceClient: props.resourceClient,
            cloudId: props.cloudId,
            onDeleteAgent: props.onDeleteAgent,
            hideMoreActions: props.hideMoreActions,
            hideAiDisclaimer: props.hideAiDisclaimer,
            hideConversationStarters: props.hideConversationStarters,
            hideAgentActions: props.hideAgentActions,
            hideStarButton: props.hideStarButton,
            showCreatorNameWithoutLink: props.showCreatorNameWithoutLink,
            footerComponent: props.footerComponent
        })
    });
};
module.exports["AgentProfileCardResourced"] = $fe1c8bc12e81e628$export$4b013ffffcb40af8;

});

parcelRegister("7G50J", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $I7hWB = parcelRequire("I7hWB");


var $i1t43 = parcelRequire("i1t43");


var $NlHoa = parcelRequire("NlHoa");


var $etoPX = parcelRequire("etoPX");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $ieeJu = parcelRequire("ieeJu");


var $lpNn5 = parcelRequire("lpNn5");


var $6h4xM = parcelRequire("6h4xM");


var $i4kCF = parcelRequire("i4kCF");


var $hq9Cp = parcelRequire("hq9Cp");


var $fNIRw = parcelRequire("fNIRw");

const $f5fec235121c7193$var$styles = {
    clickableItem: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    rovoIconWrapper: "_3iDTPbQ4SZ",
    name: "_37wbyuI7V3 _0hPCNLchRC",
    description: "_3SamIHPgdg _3zvHkHdC7N _3W2Oc8wPeg",
    headingWrapper: "_1mT5xdRAKS",
    hiddenIconWrapper: "_313842FQfX"
};
const $f5fec235121c7193$export$7cbebf266a9bcc3c = ({ creatorType: creatorType, authoringTeam: authoringTeam, userCreator: userCreator, forgeCreator: forgeCreator })=>{
    if (creatorType === 'SYSTEM') return {
        type: 'SYSTEM'
    };
    if ((0, $iDrrr.fg)('rovo_agent_support_a2a_avatar') ? (0, $hq9Cp.isForgeAgentByCreatorType)(creatorType) : creatorType === 'FORGE' || creatorType === 'THIRD_PARTY' // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
    ) return {
        // @todo: remove cast in rovo_agent_support_a2a_avatar cleanup
        type: (0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a') ? creatorType : 'FORGE',
        name: forgeCreator ?? ''
    };
    if (creatorType === 'OOTB') return {
        type: 'OOTB'
    };
    if (creatorType === 'CUSTOMER') {
        if (authoringTeam) return {
            type: 'CUSTOMER',
            name: authoringTeam.displayName,
            profileLink: authoringTeam.profileLink ?? ''
        };
        if (!userCreator?.profileLink) return undefined;
        return {
            type: 'CUSTOMER',
            name: userCreator.name,
            profileLink: userCreator.profileLink,
            status: userCreator.status
        };
    }
    return;
};
const $f5fec235121c7193$export$f35b2eeaa7e3db15 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: t1 } = t0;
    const showCreatorNameWithoutLink = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== creator || $[1] !== formatMessage || $[2] !== isLoading || $[3] !== onCreatorLinkClick || $[4] !== showCreatorNameWithoutLink) {
        const getCreatorRender = ()=>{
            if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                    testId: "agent-profile-creator-skeleton",
                    isShimmering: true,
                    height: 18,
                    width: 100
                })
            });
            if (!creator) return null;
            if (creator.type === "SYSTEM" || creator.type === "OOTB") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    testId: "atlassian-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                    label: "",
                    size: "small",
                    appearance: "brand"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
            });
            if (creator.type === "CUSTOMER") {
                const creatorName = `${creator.name} ${creator.status === "inactive" ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ""}`;
                return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                    creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: creator.profileLink,
                        onClick: ()=>onCreatorLinkClick(),
                        target: "_blank"
                    }, creatorName)
                });
            }
            if (creator.type === "REMOTE_A2A") return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            if (creator.type === "THIRD_PARTY" || creator.type === "FORGE") return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: creator.name
            });
            return null;
        };
        t2 = getCreatorRender();
        $[0] = creator;
        $[1] = formatMessage;
        $[2] = isLoading;
        $[3] = onCreatorLinkClick;
        $[4] = showCreatorNameWithoutLink;
        $[5] = t2;
    } else t2 = $[5];
    const creatorRender = t2;
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes");
        $[6] = t3;
    } else t3 = $[6];
    const hideCreatorIcon = t3;
    if ((0, $iDrrr.fg)("jira_improve_agent_profile_for_a2a")) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== "REMOTE_A2A";
        let t4;
        if ($[7] !== creatorRender || $[8] !== showRovoIcon) {
            t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.clickableItem
            }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
                testId: "rovo-icon-wrapper",
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
                appearance: "brand",
                size: "small"
            })) : null, creatorRender) : null;
            $[7] = creatorRender;
            $[8] = showRovoIcon;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== creatorRender) {
        t4 = creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })), creatorRender) : null;
        $[10] = creatorRender;
        $[11] = t4;
    } else t4 = $[11];
    return t4;
} : ({ creator: creator, onCreatorLinkClick: onCreatorLinkClick, isLoading: isLoading, showCreatorNameWithoutLink: showCreatorNameWithoutLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const getCreatorRender = ()=>{
        if (isLoading) return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
                testId: "agent-profile-creator-skeleton",
                isShimmering: true,
                height: 18,
                width: 100
            })
        });
        if (!creator) return null;
        if (creator.type === 'SYSTEM' || creator.type === 'OOTB') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignBlock: "center",
                testId: "atlassian-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                label: "",
                size: "small",
                appearance: "brand"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, "Atlassian"))
        });
        if (creator.type === 'CUSTOMER') {
            const creatorName = `${creator.name} ${creator.status === 'inactive' ? formatMessage((0, $fNIRw.messages).agentDeactivated) : ''}`;
            return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
                creatorNameWithLink: showCreatorNameWithoutLink ? creatorName : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    href: creator.profileLink,
                    onClick: ()=>onCreatorLinkClick(),
                    target: "_blank"
                }, creatorName)
            });
        }
        if (creator.type === 'REMOTE_A2A') return formatMessage((0, $fNIRw.messages).remoteAgentCreatedBy, {
            creatorNameWithLink: creator.name
        });
         // THIRD_PARTY is deprecated in convo-ai, use FORGE instead
        if (creator.type === 'THIRD_PARTY' || creator.type === 'FORGE') return formatMessage((0, $fNIRw.messages).agentCreatedBy, {
            creatorNameWithLink: creator.name
        });
        return null;
    };
    const creatorRender = getCreatorRender();
    const hideCreatorIcon = (0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes');
    if ((0, $iDrrr.fg)('jira_improve_agent_profile_for_a2a')) {
        const showRovoIcon = !hideCreatorIcon && creator?.type !== 'REMOTE_A2A';
        return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.clickableItem
        }, showRovoIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
            testId: "rovo-icon-wrapper",
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
            appearance: "brand",
            size: "small"
        })) : null, creatorRender) : null;
    }
    return creatorRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.clickableItem
    }, !hideCreatorIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.rovoIconWrapper,
        testId: "rovo-icon-wrapper",
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $etoPX.RovoIcon), {
        appearance: "brand",
        size: "small"
    })), creatorRender) : null;
};
const $f5fec235121c7193$export$e02348ba0b01a210 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: t1, renderAdditionalContent: renderAdditionalContent } = t0;
    const showStarButton = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== agentName) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            as: "h2",
            size: "medium"
        }, agentName);
        $[0] = agentName;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage || $[3] !== isHidden) {
        t3 = isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
            label: formatMessage((0, $fNIRw.messages).hiddenIcon)
        })));
        $[2] = formatMessage;
        $[3] = isHidden;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== headingRender || $[6] !== t2 || $[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.075",
            xcss: $f5fec235121c7193$var$styles.headingWrapper
        }, t2, headingRender, t3);
        $[5] = headingRender;
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== agentName || $[10] !== isStarred || $[11] !== onStarToggle || $[12] !== showStarButton) {
        t5 = showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
            isStarred: isStarred,
            handleToggle: onStarToggle,
            agentName: agentName
        });
        $[9] = agentName;
        $[10] = isStarred;
        $[11] = onStarToggle;
        $[12] = showStarButton;
        $[13] = t5;
    } else t5 = $[13];
    let t6;
    if ($[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $f5fec235121c7193$var$styles.name,
            space: "space.100",
            alignBlock: "center"
        }, t4, t5);
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== agentDescription) {
        t7 = !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $f5fec235121c7193$var$styles.description,
            as: "p"
        }, agentDescription);
        $[17] = agentDescription;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== renderAdditionalContent) {
        t8 = !!renderAdditionalContent && renderAdditionalContent();
        $[19] = renderAdditionalContent;
        $[20] = t8;
    } else t8 = $[20];
    let t9;
    if ($[21] !== creatorRender || $[22] !== starCountRender || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.100"
        }, t6, creatorRender, t7, starCountRender, t8);
        $[21] = creatorRender;
        $[22] = starCountRender;
        $[23] = t6;
        $[24] = t7;
        $[25] = t8;
        $[26] = t9;
    } else t9 = $[26];
    return t9;
} : ({ agentName: agentName, agentDescription: agentDescription, creatorRender: creatorRender, starCountRender: starCountRender, headingRender: headingRender, isStarred: isStarred, isHidden: isHidden, onStarToggle: onStarToggle, showStarButton: showStarButton = true, renderAdditionalContent: renderAdditionalContent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $f5fec235121c7193$var$styles.name,
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.075",
        xcss: $f5fec235121c7193$var$styles.headingWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        as: "h2",
        size: "medium"
    }, agentName), headingRender, isHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.hiddenIconWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: formatMessage((0, $fNIRw.messages).hiddenTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6h4xM.HiddenIcon), {
        label: formatMessage((0, $fNIRw.messages).hiddenIcon)
    })))), showStarButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4kCF.StarIconButton), {
        isStarred: isStarred,
        handleToggle: onStarToggle,
        agentName: agentName
    })), creatorRender, !!agentDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f5fec235121c7193$var$styles.description,
        as: "p"
    }, agentDescription), starCountRender, !!renderAdditionalContent && renderAdditionalContent());
};
module.exports["getAgentCreator"] = $f5fec235121c7193$export$7cbebf266a9bcc3c;
module.exports["AgentProfileCreator"] = $f5fec235121c7193$export$f35b2eeaa7e3db15;
module.exports["AgentProfileInfo"] = $f5fec235121c7193$export$e02348ba0b01a210;

});

parcelRegister("6h4xM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bsSbN = parcelRequire("bsSbN");

const $fc7d462f5dd0deaa$export$bce21421c351deb1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bsSbN))), props);
module.exports["HiddenIcon"] = $fc7d462f5dd0deaa$export$bce21421c351deb1;

});

parcelRegister("i4kCF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $6Cex3 = parcelRequire("6Cex3");


var $lbT4j = parcelRequire("lbT4j");


var $iMnC5 = parcelRequire("iMnC5");


var $4ssVW = parcelRequire("4ssVW");

const $fbe2d7b3097e2d22$var$styles = {
    hidden: "_1YKVNsdnbC"
};
const $fbe2d7b3097e2d22$export$703abb8bd2abdfa5 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isStarred: isStarred, handleToggle: handleToggle, visible: t1, agentName: agentName } = t0;
    const visible = t1 === undefined ? true : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const t2 = !visible && $fbe2d7b3097e2d22$var$styles.hidden;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)(t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== isHovered || $[3] !== isStarred) {
        t4 = (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            });
        $[2] = isHovered;
        $[3] = isStarred;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel;
    let t6;
    if ($[5] !== agentName || $[6] !== formatMessage || $[7] !== t5) {
        t6 = formatMessage(t5, {
            agentName: agentName
        });
        $[5] = agentName;
        $[6] = formatMessage;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsHovered(true);
        t8 = ()=>setIsHovered(false);
        $[9] = t7;
        $[10] = t8;
    } else {
        t7 = $[9];
        t8 = $[10];
    }
    let t9;
    if ($[11] !== handleToggle || $[12] !== t4 || $[13] !== t6) {
        t9 = /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: t4,
            label: t6,
            onClick: handleToggle,
            onMouseEnter: t7,
            onMouseLeave: t8
        });
        $[11] = handleToggle;
        $[12] = t4;
        $[13] = t6;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t3 || $[16] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t3
        }, t9);
        $[15] = t3;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ isStarred: isStarred, handleToggle: handleToggle, visible: visible = true, agentName: agentName })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!visible && $fbe2d7b3097e2d22$var$styles.hidden)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (iconProps)=>isStarred || isHovered ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Cex3))), {
                ...iconProps,
                color: "var(--ds-icon-accent-orange, #E06C00)"
            }) : /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbT4j))), {
                ...iconProps,
                color: "var(--ds-icon, #292A2E)"
            }),
        label: formatMessage(isStarred ? (0, $4ssVW.default).removeFromFavouritesLabel : (0, $4ssVW.default).clickToFavouriteLabel, {
            agentName: agentName
        }),
        onClick: handleToggle,
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false)
    }));
};
module.exports["StarIconButton"] = $fbe2d7b3097e2d22$export$703abb8bd2abdfa5;

});

parcelRegister("4ssVW", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $a47d9a7d981bdb91$var$message = (0, $kSwu1.defineMessages)({
    removeFromFavouritesLabel: {
        id: "rovo-chat.browse-agents.remove-from-favourites-label",
        defaultMessage: "Remove {agentName} from favourites"
    },
    clickToFavouriteLabel: {
        id: "rovo-chat.browse-agents.click-to-favourite-label",
        defaultMessage: "Add {agentName} to favourites"
    }
});
var $a47d9a7d981bdb91$export$2e2bcd8739ae039 = $a47d9a7d981bdb91$var$message;
module.exports["default"] = $a47d9a7d981bdb91$export$2e2bcd8739ae039;

});

parcelRegister("hq9Cp", function(module, exports) {
const $84118747f7725463$export$3055eac4de8cbd2b = (creatorType)=>creatorType === 'THIRD_PARTY' || creatorType === 'FORGE' || creatorType === 'REMOTE_A2A';
module.exports["isForgeAgentByCreatorType"] = $84118747f7725463$export$3055eac4de8cbd2b;

});

parcelRegister("fNIRw", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $246a354bdf98d3ad$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    agentCreatedBy: {
        id: "ai-mate.agent-profile-info.created-by",
        defaultMessage: "Rovo Agent by {creatorNameWithLink}"
    },
    remoteAgentCreatedBy: {
        id: "ai-mate.agent-profile-info.agent-by",
        defaultMessage: "Agent by {creatorNameWithLink}"
    },
    agentDeactivated: {
        id: "ai-mate.agent-profile-info.deactivated",
        defaultMessage: "(deactivated)"
    },
    starredCount: {
        id: "ai-mate.agent-profile-info.starred-count",
        defaultMessage: "{count} starred"
    },
    hiddenIcon: {
        id: "ai-mate.agent-profile-info.hidden-icon",
        defaultMessage: "Hidden"
    },
    hiddenTooltip: {
        id: "ai-mate.agent-profile-info.hidden-tooltip",
        defaultMessage: "Agent won't show in search results"
    },
    starAgentTooltip: {
        id: "ai-mate.agent-profile-info.star-agent-tooltip",
        defaultMessage: "Star Agent"
    },
    creatorLabel: {
        id: "ai-mate.agent-profile-info.creator",
        defaultMessage: "Creator"
    }
});
module.exports["messages"] = $246a354bdf98d3ad$export$defe85febe8b728c;

});

parcelRegister("dSW04", function(module, exports) {
class $99c5d70c0df67415$export$a6d78d75d03919f1 extends Error {
    constructor(){
        super('Agent access forbidden');
        this.status = 403;
        this.name = 'AgentForbiddenError';
    }
}
module.exports["AgentForbiddenError"] = $99c5d70c0df67415$export$a6d78d75d03919f1;

});

parcelRegister("dRAjC", function(module, exports) {
const $d2643a1af3062f27$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $d2643a1af3062f27$export$3761e66a04602cbd = (ari)=>{
    return ari.replace($d2643a1af3062f27$export$470b0d72e4fdc43a, '');
};
module.exports["USER_ARI_PREFIX"] = $d2643a1af3062f27$export$470b0d72e4fdc43a;
module.exports["getAAIDFromARI"] = $d2643a1af3062f27$export$3761e66a04602cbd;

});

parcelRegister("4k5Wq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $5avUB = parcelRequire("5avUB");


var $4aRua = parcelRequire("4aRua");


var $eU2tf = parcelRequire("eU2tf");


var $hHYlx = parcelRequire("hHYlx");


var $cSSWJ = parcelRequire("cSSWJ");

const $0f12e30f7425acf6$var$ErrorMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(18);
    let t0;
    if ($[0] !== props.errorType) {
        t0 = props.errorType || {
            reason: "default"
        };
        $[0] = props.errorType;
        $[1] = t0;
    } else t0 = $[1];
    const errorType = t0;
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    let t1;
    let t2;
    if ($[2] !== errorReason || $[3] !== fireAnalytics || $[4] !== hasRetry) {
        t1 = ()=>{
            fireAnalytics("ui.profilecard.rendered.error", {
                hasRetry: hasRetry,
                errorType: errorReason,
                firedAt: Math.round(performance.now()),
                ...(0, $cSSWJ.PACKAGE_META_DATA)
            });
        };
        t2 = [
            errorReason,
            fireAnalytics,
            hasRetry
        ];
        $[2] = errorReason;
        $[3] = fireAnalytics;
        $[4] = hasRetry;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[7] !== errorReason || $[8] !== reload) {
        t3 = ()=>{
            if (errorReason === "NotFound") return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorUserNotFound
                })
            });
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
                children: [
                    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorGeneric
                    }),
                    /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                    reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                        color: "color.text.subtlest",
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                            ...(0, $eU2tf.default).errorRetrySuggestion
                        })
                    })
                ]
            });
        };
        $[7] = errorReason;
        $[8] = reload;
        $[9] = t3;
    } else t3 = $[9];
    const errorContent = t3;
    let t4;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
            label: "icon error"
        });
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== errorContent) {
        t5 = errorContent();
        $[11] = errorContent;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== reload) {
        t6 = reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            onClick: reload,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorTryAgain
            })
        });
        $[13] = reload;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
            testId: "profilecard-error",
            children: [
                t4,
                t5,
                t6
            ]
        });
        $[15] = t5;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : (props)=>{
    const errorType = props.errorType || {
        reason: 'default'
    };
    const errorReason = errorType.reason;
    const { fireAnalytics: fireAnalytics, reload: reload } = props;
    const hasRetry = !!reload;
    (0, $cozmU.useEffect)(()=>{
        fireAnalytics('ui.profilecard.rendered.error', {
            hasRetry: hasRetry,
            errorType: errorReason,
            firedAt: Math.round(performance.now()),
            ...(0, $cSSWJ.PACKAGE_META_DATA)
        });
    }, [
        errorReason,
        fireAnalytics,
        hasRetry
    ]);
    const errorContent = ()=>{
        if (errorReason === 'NotFound') return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hHYlx.ErrorTitle), {
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                ...(0, $eU2tf.default).errorUserNotFound
            })
        });
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorTitle), {
            children: [
                /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorGeneric
                }),
                /*#__PURE__*/ (0, $8aG6j.jsx)("br", {}),
                reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                    color: "color.text.subtlest",
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                        ...(0, $eU2tf.default).errorRetrySuggestion
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $hHYlx.ErrorWrapper), {
        testId: "profilecard-error",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5avUB))), {
                label: "icon error"
            }),
            errorContent(),
            reload && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
                onClick: reload,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $kSwu1.FormattedMessage), {
                    ...(0, $eU2tf.default).errorTryAgain
                })
            })
        ]
    });
};
var $0f12e30f7425acf6$export$2e2bcd8739ae039 = $0f12e30f7425acf6$var$ErrorMessage;
module.exports["default"] = $0f12e30f7425acf6$export$2e2bcd8739ae039;

});

parcelRegister("eU2tf", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fe57f9d19e98fdc0$var$messages = (0, $kSwu1.defineMessages)({
    inactiveAccountMsg: {
        id: "pt.profile-card.inactive.account",
        defaultMessage: "Account deactivated"
    },
    generalDescMsgForDisabledUser: {
        id: "pt.profile-card.general.msg.disabled.user",
        defaultMessage: "You can no longer collaborate with this person."
    },
    inactiveAccountDescMsgNoDate: {
        id: "pt.profile-card.inactive.account.no.date",
        defaultMessage: "Their account has been deactivated."
    },
    inactiveAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.inactive.account.has.date.this.week",
        defaultMessage: "Their account was deactivated this week."
    },
    inactiveAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.inactive.account.has.date.this.month",
        defaultMessage: "Their account was deactivated this month."
    },
    inactiveAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.inactive.account.has.date.last.month",
        defaultMessage: "Their account was deactivated last month."
    },
    inactiveAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.inactive.account.has.date.a.few.months",
        defaultMessage: "Their account has been deactivated for a few months."
    },
    inactiveAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.inactive.account.has.date.several.months",
        defaultMessage: "Their account has been deactivated for several months."
    },
    inactiveAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.inactive.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deactivated for more than a year."
    },
    closedAccountMsg: {
        id: "pt.profile-card.closed.account",
        defaultMessage: "Account deleted"
    },
    closedAccountDescMsgNoDate: {
        id: "pt.profile-card.closed.account.no.date",
        defaultMessage: "Their account has been deleted."
    },
    closedAccountDescMsgHasDateThisWeek: {
        id: "pt.profile-card.closed.account.has.date.this.week",
        defaultMessage: "Their account was deleted this week."
    },
    closedAccountDescMsgHasDateThisMonth: {
        id: "pt.profile-card.closed.account.has.date.this.month",
        defaultMessage: "Their account was deleted this month."
    },
    closedAccountDescMsgHasDateLastMonth: {
        id: "pt.profile-card.closed.account.has.date.last.month",
        defaultMessage: "Their account was deleted last month."
    },
    closedAccountDescMsgHasDateAFewMonths: {
        id: "pt.profile-card.closed.account.has.date.a.few.months",
        defaultMessage: "Their account has been deleted for a few months."
    },
    closedAccountDescMsgHasDateSeveralMonths: {
        id: "pt.profile-card.closed.account.has.date.several.months",
        defaultMessage: "Their account has been deleted for several months."
    },
    closedAccountDescMsgHasDateMoreThanAYear: {
        id: "pt.profile-card.closed.account.has.date.more.than.a.year",
        defaultMessage: "Their account has been deleted for more than a year."
    },
    disabledAccountDefaultName: {
        id: "pt.profile-card.disabled.account.default.name",
        defaultMessage: "Former user"
    },
    teamViewProfile: {
        id: "pt.team-profile-card.team.action.view-profile",
        defaultMessage: "View profile"
    },
    memberCount: {
        id: "pt.team-profile-card.team.member.count",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}"
    },
    memberCountIncludingYou: {
        id: "pt.team-profile-card.team.member.count-including-you",
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you"
    },
    membersMoreThan50: {
        id: "pt.team-profile-card.team.member.many",
        defaultMessage: "Team \u2022 50+ members"
    },
    membersMoreThan50IncludingYou: {
        id: "pt.team-profile-card.team.member.many-including-you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    teamErrorTitle: {
        id: "pt.team-profile-card.error.title",
        defaultMessage: "We\u2019re having trouble retrieving this teams information"
    },
    teamErrorText: {
        id: "pt.team-profile-card.error.suggestion",
        defaultMessage: "Wait a few moments, then try again."
    },
    teamErrorButton: {
        id: "pt.team-profile-card.error.refresh-button",
        defaultMessage: "Try again"
    },
    teamForbiddenErrorStateTitle: {
        id: "pt.team-profile-card.forbidden-error-state.title",
        defaultMessage: "We can\u2019t show you this team"
    },
    teamForbiddenErrorStateDescription: {
        id: "pt.team-profile-card.forbidden-error-state.description",
        defaultMessage: "You don\u2019t have access to view this team."
    },
    managerSectionHeading: {
        id: "pt.team-profile-card.manager.heading",
        defaultMessage: "Manager"
    },
    directReportsSectionHeading: {
        id: "pt.team-profile-card.directReports.heading",
        defaultMessage: "Direct reports"
    },
    teamProfileCardAriaLabel: {
        id: "pt.team-profile-card.aria-label",
        defaultMessage: "More information about this team"
    },
    giveKudosButton: {
        id: "pt.profile-card.give-kudos",
        defaultMessage: "Give kudos"
    },
    // Remove this as part of the FG Cleanup for jfp_a11y_team_profile_card_actions_label
    profileCardMoreIconLabel: {
        id: "pt.profile-card.more-icon-label",
        defaultMessage: "More"
    },
    profileCardMoreIconLabelWithName: {
        id: "pt.profile-card.more-icon-label-with-name",
        defaultMessage: "More actions for {fullName}"
    },
    profileCardMoreReportingLinesLabel: {
        id: "pt.user-profile-card.reporting-lines.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {profile} other {profiles}}"
    },
    profileCardMoreMembersLabel: {
        id: "pt.team.profile-card.members.more-icon-label",
        defaultMessage: "+{count} more {count, plural, one {members} other {members}}"
    },
    archivedLozenge: {
        id: "pt.team-profile-card.archived-lozenge",
        defaultMessage: "Archived"
    },
    errorUserNotFound: {
        id: "pt.profile-card.error.user-not-found",
        defaultMessage: "The user is no longer available for the site"
    },
    errorGeneric: {
        id: "pt.profile-card.error.generic",
        defaultMessage: "Oops, looks like we\u2019re having issues"
    },
    errorRetrySuggestion: {
        id: "pt.profile-card.error.retry-suggestion",
        defaultMessage: "Try again and we\u2019ll give it another shot"
    },
    errorTryAgain: {
        id: "pt.profile-card.error.try-again-button",
        defaultMessage: "Try again"
    },
    errorDialogLabel: {
        id: "pt.profile-card.error.dialog-label",
        defaultMessage: "Profile card error"
    },
    loadingDialogLabel: {
        id: "pt.profile-card.loading.dialog-label",
        defaultMessage: "Loading profile card"
    },
    serviceAccountLabel: {
        id: "pt.profile-card.service-account.label",
        defaultMessage: "SERVICE ACCOUNT"
    },
    botAccountLabel: {
        id: "pt.profile-card.bot-account.label",
        defaultMessage: "APP"
    },
    viewManagerProfile: {
        id: "pt.profile-card.view-manager-profile",
        defaultMessage: "View {name} profile"
    }
});
var $fe57f9d19e98fdc0$export$2e2bcd8739ae039 = $fe57f9d19e98fdc0$var$messages;
module.exports["default"] = $fe57f9d19e98fdc0$export$2e2bcd8739ae039;

});

parcelRegister("hHYlx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");

const $3b2daa1fed2d9894$var$styles = {
    errorWrapper: "_2fwxA5DIqT _0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    errorTitle: "_3138422ADO",
    teamErrorText: "_1UtDYzKGUX _3138422ADO"
};
const $3b2daa1fed2d9894$export$bb27b7e39840238f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            ...props
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.errorWrapper),
        ...props
    });
const $3b2daa1fed2d9894$export$b065fd053267ec81 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props.children) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                color: "color.text",
                children: props.children
            })
        });
        $[0] = props.children;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $3b2daa1fed2d9894$var$styles.errorTitle,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
            color: "color.text",
            children: props.children
        })
    });
const $3b2daa1fed2d9894$export$90d92ccfb27352c6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props.children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t0,
            children: props.children
        });
        $[1] = props.children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($3b2daa1fed2d9894$var$styles.teamErrorText),
        children: props.children
    });
module.exports["ErrorWrapper"] = $3b2daa1fed2d9894$export$bb27b7e39840238f;
module.exports["ErrorTitle"] = $3b2daa1fed2d9894$export$b065fd053267ec81;

});

parcelRegister("kb2tZ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $ieeJu = parcelRequire("ieeJu");

const $d107d3e886647d93$var$styles = {
    wrapper: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d _2OUyjtGk8v",
    wrapperLegacy: "_0bjKvD8fU6 _39xV02wBC3 _0KLXruoI2d"
};
const $d107d3e886647d93$export$2c6604b50c274e6f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $ieeJu.expValEquals)("platform_editor_agent_mentions", "isEnabled", true) && (0, $iDrrr.fg)("platform_editor_agent_mentions_drop_one_fixes") || (0, $iDrrr.fg)("platform_editor_agent_card_fixes")) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $d107d3e886647d93$var$styles.wrapper,
                children: children
            });
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
            children: children
        });
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : ({ children: children })=>{
    if ((0, $ieeJu.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $iDrrr.fg)('platform_editor_agent_mentions_drop_one_fixes') || (0, $iDrrr.fg)('platform_editor_agent_card_fixes')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapper,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $d107d3e886647d93$var$styles.wrapperLegacy,
        children: children
    });
};
module.exports["AgentProfileCardWrapper"] = $d107d3e886647d93$export$2c6604b50c274e6f;

});

parcelRegister("hIwXM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7oSFe = parcelRequire("7oSFe");


const $795534535f4e0b8b$export$ed0ca9c1d49ea0bf = /*#__PURE__*/ (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-7xjQ31", ()=>(parcelRequire("4hRFt"))));
module.exports["AgentProfileCardLazy"] = $795534535f4e0b8b$export$ed0ca9c1d49ea0bf;

});

parcelRegister("4hRFt", function(module, exports) {

let $31f2615003217c72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $31f2615003217c72$var$load("d0ZRF"),
    $31f2615003217c72$var$load("k507P"),
    $31f2615003217c72$var$load("6wr18"),
    $31f2615003217c72$var$load("iYJZz"),
    $31f2615003217c72$var$load("jqoep"),
    $31f2615003217c72$var$load("ea3NB"),
    $31f2615003217c72$var$load("ffEVr"),
    $31f2615003217c72$var$load("7EorR"),
    $31f2615003217c72$var$load("hhss7"),
    $31f2615003217c72$var$load("68aog")
]).then(()=>parcelRequire('ark00'));

});

parcelRegister("jgqX6", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0646b18c90b3a18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3c3I9 = parcelRequire("3c3I9");


var $eYSi7 = parcelRequire("eYSi7");


var $3yGK6 = parcelRequire("3yGK6");


var $2iY37 = parcelRequire("2iY37");

function $e0646b18c90b3a18$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var sign = (0, $eYSi7.default)(dateLeft, dateRight);
    var difference = Math.abs((0, $3c3I9.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $eYSi7.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $2iY37.default)((0, $dkBOe.default)(dirtyDateLeft)) && difference === 1 && (0, $eYSi7.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});

parcelRegister("3c3I9", function(module, exports) {
$parcel$export(module.exports, "default", () => $25355f04f79cc351$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $25355f04f79cc351$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("eYSi7", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae80c86a80ef7d08$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $ae80c86a80ef7d08$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeft = (0, $dkBOe.default)(dirtyDateLeft);
    var dateRight = (0, $dkBOe.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

});

parcelRegister("9wMFw", function(module, exports) {

var $dojlP = parcelRequire("dojlP");

/** Used to generate unique IDs. */ var $6efcdace0fb66c85$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $6efcdace0fb66c85$var$uniqueId(prefix) {
    var id = ++$6efcdace0fb66c85$var$idCounter;
    return $dojlP(prefix) + id;
}
module.exports = $6efcdace0fb66c85$var$uniqueId;

});

parcelRegister("cSuwJ", function(module, exports) {
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $lOiVq = parcelRequire("lOiVq");


var $kSwu1 = parcelRequire("kSwu1");


var $7Y8M5 = parcelRequire("7Y8M5");

function $4a8c68f17b3fe31c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4a8c68f17b3fe31c$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    loading: {
        id: "fabric.editor.expand.loading",
        defaultMessage: "Loading..."
    },
    collapseNode: {
        id: "fabric.editor.collapseNode",
        defaultMessage: "Collapse content"
    },
    expandDefaultTitle: {
        id: "fabric.editor.expandDefaultTitle",
        defaultMessage: "Click here to expand..."
    },
    expandNode: {
        id: "fabric.editor.expandNode",
        defaultMessage: "Expand content"
    },
    expandPlaceholderText: {
        id: "fabric.editor.expandPlaceholder",
        defaultMessage: "Give this expand a title..."
    },
    expandArialabel: {
        id: "fabric.editor.expandAriaLabel",
        defaultMessage: "Give this expand a title"
    },
    // Clean up with platform_editor_expand_content_a11y_2.
    expandBodyAriaLabelOriginal: {
        id: "fabric.editor.expandBodyAriaLabel",
        defaultMessage: "Expand body content"
    },
    expandBodyAriaLabel: {
        id: "editor-common.Expand.expandBodyAriaLabel",
        defaultMessage: "Body content for {title}"
    },
    expandBodyAriaLabelUntitled: {
        id: "editor-common.Expand.expandBodyAriaLabelUntitled",
        defaultMessage: "untitled expand"
    },
    expandBodyAriaDescription: {
        id: "fabric.editor.expandBodyAriaDescription",
        defaultMessage: "Enter the content that will be revealed when this expand is opened."
    },
    expandBodyRoleDescription: {
        id: "fabric.editor.expandBodyRoleDescription",
        defaultMessage: "macro"
    }
});
const $4a8c68f17b3fe31c$export$4eeef63d68e77552 = ({ children: children, expanded: expanded })=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        css: ()=>expanded ? [
                $4a8c68f17b3fe31c$var$expandIconWrapperStyle(),
                $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle
            ] : $4a8c68f17b3fe31c$var$expandIconWrapperStyle()
    }, children);
};
const $4a8c68f17b3fe31c$var$expandIconWrapperStyle = ()=>/*#__PURE__*/ (0, $lOiVq.css)({
        cursor: 'pointer',
        display: 'flex',
        color: "var(--ds-icon, #292A2E)",
        borderRadius: "var(--ds-radius-small, 4px)",
        width: '24px',
        height: '24px',
        '&:hover': {
            background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        svg: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transition: `transform 0.2s ${(0, $7Y8M5.akEditorSwoopCubicBezier)}`
        }
    });
const $4a8c68f17b3fe31c$var$expandIconWrapperExpandedStyle = {
    name: "1uoxr6z",
    styles: "svg{transform:rotate(90deg);}"
};
const $4a8c68f17b3fe31c$export$a7ed6bf20867161a = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};
const $4a8c68f17b3fe31c$export$c67faf67c1185cba = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...otherProps }, ref)=>{
    return /*#__PURE__*/ (0, $lOiVq.jsx)("div", {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        css: $4a8c68f17b3fe31c$export$a7ed6bf20867161a,
        ref: ref,
        ...otherProps
    }, children);
});
module.exports["messages"] = $4a8c68f17b3fe31c$export$defe85febe8b728c;
module.exports["ExpandIconWrapper"] = $4a8c68f17b3fe31c$export$4eeef63d68e77552;
module.exports["expandLayoutWrapperStyle"] = $4a8c68f17b3fe31c$export$a7ed6bf20867161a;
module.exports["ExpandLayoutWrapperWithRef"] = $4a8c68f17b3fe31c$export$c67faf67c1185cba;

});

parcelRegister("i1LnN", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $cOjjv = parcelRequire("cOjjv");


var $fYRS9 = parcelRequire("fYRS9");

const $34611ea31c23d1b7$var$styles = {
    base: "_0Of8r24Jdh _1ZnuxbEwa9 _1wydGW4Jdh _2Zuz6QEwa9 _0bjKvDzXzM _2sNsIgNxAV _4bt5LAIZbP _2WAcuGIZbP _3hxITiYbGa _3iDTPbS8kF _0KLXruTnLi _2NnhnEXpc7 _1UtDYzy7kJ _26BoRwOLYo _3zvHkHwPeg _1ANEUSlpBW"
}; /**
    * __Code__
    *
    * Code highlights short strings of code snippets inline with body text.
    *
    * - [Examples](https://atlassian.design/components/code/examples)
    * - [Code](https://atlassian.design/components/code/code)
    * - [Usage](https://atlassian.design/components/code/usage)
    */ 
const $34611ea31c23d1b7$var$Code = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? function Code(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    let props;
    let testId;
    if ($[0] !== t0) {
        ({ testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = testId;
    } else {
        props = $[1];
        testId = $[2];
    }
    let children;
    let codeBidiWarningLabel;
    let hasBidiWarnings;
    let isBidiWarningTooltipEnabled;
    let otherProps;
    let t1;
    let t2;
    if ($[3] !== props) {
        ({ children: children, codeBidiWarnings: t1, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: t2, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props);
        $[3] = props;
        $[4] = children;
        $[5] = codeBidiWarningLabel;
        $[6] = hasBidiWarnings;
        $[7] = isBidiWarningTooltipEnabled;
        $[8] = otherProps;
        $[9] = t1;
        $[10] = t2;
    } else {
        children = $[4];
        codeBidiWarningLabel = $[5];
        hasBidiWarnings = $[6];
        isBidiWarningTooltipEnabled = $[7];
        otherProps = $[8];
        t1 = $[9];
        t2 = $[10];
    }
    const codeBidiWarnings = t1 === undefined ? true : t1;
    const codeBidiWarningTooltipEnabled = t2 === undefined ? true : t2;
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    let t3;
    if ($[11] !== children || $[12] !== codeBidiWarningLabel || $[13] !== shouldEnableTooltip || $[14] !== shouldShowBidiWarnings) {
        t3 = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $8aG6j.jsx)($34611ea31c23d1b7$var$RenderCodeChildrenWithBidiWarnings, {
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: shouldEnableTooltip,
            children: children
        }) : children;
        $[11] = children;
        $[12] = codeBidiWarningLabel;
        $[13] = shouldEnableTooltip;
        $[14] = shouldShowBidiWarnings;
        $[15] = t3;
    } else t3 = $[15];
    const decoratedChildren = t3;
    let t4;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $34611ea31c23d1b7$var$styles.base
        ]);
        $[16] = t4;
    } else t4 = $[16];
    let t5;
    if ($[17] !== decoratedChildren || $[18] !== otherProps || $[19] !== ref || $[20] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("code", {
            ref: ref,
            "data-testid": testId,
            ...otherProps,
            className: t4,
            children: decoratedChildren
        });
        $[17] = decoratedChildren;
        $[18] = otherProps;
        $[19] = ref;
        $[20] = testId;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
} : function Code({ testId: testId, ...props }, ref) {
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, hasBidiWarnings: hasBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, isBidiWarningTooltipEnabled: isBidiWarningTooltipEnabled, ...otherProps } = props; // Use new props if provided, otherwise fall back to deprecated props
    const shouldShowBidiWarnings = hasBidiWarnings !== undefined ? hasBidiWarnings : codeBidiWarnings;
    const shouldEnableTooltip = isBidiWarningTooltipEnabled !== undefined ? isBidiWarningTooltipEnabled : codeBidiWarningTooltipEnabled;
    const decoratedChildren = shouldShowBidiWarnings ? /*#__PURE__*/ (0, $8aG6j.jsx)($34611ea31c23d1b7$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: shouldEnableTooltip,
        children: children
    }) : children;
    return /*#__PURE__*/ (0, $8aG6j.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        ...otherProps,
        className: (0, $hekY6.default)([
            $34611ea31c23d1b7$var$styles.base
        ]),
        children: decoratedChildren
    });
}));
const $34611ea31c23d1b7$var$RenderCodeChildrenWithBidiWarnings = (0, $gtMdU.isReactCompilerActivePlatform)() ? function RenderCodeChildrenWithBidiWarnings(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled } = t0;
    let t1;
    if ($[0] !== children || $[1] !== codeBidiWarningLabel || $[2] !== codeBidiWarningTooltipEnabled) {
        let t2;
        if ($[4] !== codeBidiWarningLabel || $[5] !== codeBidiWarningTooltipEnabled) {
            t2 = (childNode)=>{
                if (typeof childNode === "string") {
                    const decorated = (0, $cOjjv.default)(childNode, (t3)=>{
                        const { bidiCharacter: bidiCharacter, index: index } = t3;
                        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fYRS9.default), {
                            bidiCharacter: bidiCharacter,
                            label: codeBidiWarningLabel,
                            tooltipEnabled: codeBidiWarningTooltipEnabled
                        }, index);
                    });
                    return decorated;
                }
                if ($34611ea31c23d1b7$var$isReactElement(childNode) && childNode.props.children) {
                    const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(childNode, {
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)(RenderCodeChildrenWithBidiWarnings, {
                            codeBidiWarningLabel: codeBidiWarningLabel,
                            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                            children: childNode.props.children
                        })
                    });
                    return newChildNode;
                }
                return childNode;
            };
            $[4] = codeBidiWarningLabel;
            $[5] = codeBidiWarningTooltipEnabled;
            $[6] = t2;
        } else t2 = $[6];
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, t2);
        $[0] = children;
        $[1] = codeBidiWarningLabel;
        $[2] = codeBidiWarningTooltipEnabled;
        $[3] = t1;
    } else t1 = $[3];
    const replacedChildren = t1;
    let t2;
    if ($[7] !== replacedChildren) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            children: replacedChildren
        });
        $[7] = replacedChildren;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $cOjjv.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fYRS9.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        if ($34611ea31c23d1b7$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $8aG6j.jsx)(RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
                    children: childNode.props.children
                })
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        children: replacedChildren
    });
};
function $34611ea31c23d1b7$var$isReactElement(child) {
    return !!child.type;
}
$34611ea31c23d1b7$var$Code.displayName = 'Code';
var $34611ea31c23d1b7$export$2e2bcd8739ae039 = $34611ea31c23d1b7$var$Code;
module.exports["default"] = $34611ea31c23d1b7$export$2e2bcd8739ae039;

});

parcelRegister("cFVPs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3U8XR = parcelRequire("3U8XR");


var $iTJtk = parcelRequire("iTJtk");


var $9DHhW = parcelRequire("9DHhW");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $96Ikf = parcelRequire("96Ikf");


var $iCEWf = parcelRequire("iCEWf");


var $jLdbZ = parcelRequire("jLdbZ");

const $a12da25560425c44$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $cozmU.useContext)((0, $jU6s6.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $cozmU.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $jLdbZ.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, aiFeatureId: aiFeatureId, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $cozmU.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $3U8XR.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $iCEWf.AISessionState).unset,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).viewed, (0, $iCEWf.AISessionState).error, (0, $iCEWf.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $iCEWf.AISessionState).initiated,
            nextState: (0, $3U8XR.P).union((0, $iCEWf.AISessionState).submitted, (0, $iCEWf.AISessionState).actioned, (0, $iCEWf.AISessionState).adopted, (0, $iCEWf.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $cozmU.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $iTJtk.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $cozmU.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                aiFeatureId: aiFeatureId,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $3U8XR.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $96Ikf.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $3U8XR.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        aiFeatureId,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $cozmU.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $cozmU.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAdopted = (0, $cozmU.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).adopted)) return;
        const event = createAndMergeEventPayload({
            action: 'adopted',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $cozmU.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $iCEWf.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $cozmU.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    const baseReturn = {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIResultAdopted: trackAIResultAdopted,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
    return $a12da25560425c44$var$useStableMethods(baseReturn);
};
/**
 * Returns an object with the same shape as `methods`, but with every method
 * replaced by a stable wrapper that delegates to the latest version. The
 * wrappers are created once on mount; they always read the freshest closure
 * via a ref, so calls observe the same behaviour as calling the unstable
 * methods directly.
 */ function $a12da25560425c44$var$useStableMethods(methods) {
    const ref = (0, $cozmU.useRef)(methods);
    ref.current = methods;
    return (0, $cozmU.useMemo)(()=>{
        const out = {};
        for (const key of Object.keys(ref.current))out[key] = (...args)=>ref.current[key](...args);
        return out;
    // Wrappers always read from `ref.current`; no deps needed.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
module.exports["useAIEventsInstrumentation"] = $a12da25560425c44$export$ddf49ad062368ad2;

});

parcelRegister("3U8XR", function(module, exports) {
const $2d7d8e3cc345803e$var$t = Symbol.for("@ts-pattern/matcher"), $2d7d8e3cc345803e$var$e = Symbol.for("@ts-pattern/isVariadic"), $2d7d8e3cc345803e$var$n = "@ts-pattern/anonymous-select-key", $2d7d8e3cc345803e$var$r = (t)=>Boolean(t && "object" == typeof t), $2d7d8e3cc345803e$var$i = (e)=>e && !!e[$2d7d8e3cc345803e$var$t], $2d7d8e3cc345803e$var$o = (n, s, c)=>{
    if ($2d7d8e3cc345803e$var$i(n)) {
        const e = n[$2d7d8e3cc345803e$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($2d7d8e3cc345803e$var$r(n)) {
        if (!$2d7d8e3cc345803e$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $2d7d8e3cc345803e$var$i(s) && s[$2d7d8e3cc345803e$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$2d7d8e3cc345803e$var$o(t, e[n], c)) && r.every((t, e)=>$2d7d8e3cc345803e$var$o(t, n[e], c)) && (0 === a.length || $2d7d8e3cc345803e$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$2d7d8e3cc345803e$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $2d7d8e3cc345803e$var$i(a = r) && "optional" === a[$2d7d8e3cc345803e$var$t]().matcherType) && $2d7d8e3cc345803e$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $2d7d8e3cc345803e$var$s = (e)=>{
    var n, o, a;
    return $2d7d8e3cc345803e$var$r(e) ? $2d7d8e3cc345803e$var$i(e) ? null != (n = null == (o = (a = e[$2d7d8e3cc345803e$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s) : $2d7d8e3cc345803e$var$c(Object.values(e), $2d7d8e3cc345803e$var$s) : [];
}, $2d7d8e3cc345803e$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $2d7d8e3cc345803e$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$2d7d8e3cc345803e$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $2d7d8e3cc345803e$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $2d7d8e3cc345803e$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$2d7d8e3cc345803e$var$l(t),
        and: (e)=>$2d7d8e3cc345803e$var$m(t, e),
        or: (e)=>$2d7d8e3cc345803e$var$d(t, e),
        select: (e)=>void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t)
    });
}
function $2d7d8e3cc345803e$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$2d7d8e3cc345803e$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$2d7d8e3cc345803e$var$h($2d7d8e3cc345803e$var$l(t)),
        select: (e)=>$2d7d8e3cc345803e$var$h(void 0 === e ? $2d7d8e3cc345803e$var$y(t) : $2d7d8e3cc345803e$var$y(e, t))
    });
}
function $2d7d8e3cc345803e$var$l(e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($2d7d8e3cc345803e$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $2d7d8e3cc345803e$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$s(e),
                matcherType: "optional"
            })
    });
}
const $2d7d8e3cc345803e$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $2d7d8e3cc345803e$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $2d7d8e3cc345803e$var$m(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "and"
            })
    });
}
function $2d7d8e3cc345803e$var$d(...e) {
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$2d7d8e3cc345803e$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$2d7d8e3cc345803e$var$c(e, $2d7d8e3cc345803e$var$s),
                matcherType: "or"
            })
    });
}
function $2d7d8e3cc345803e$var$p(e) {
    return {
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $2d7d8e3cc345803e$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $2d7d8e3cc345803e$var$u({
        [$2d7d8e3cc345803e$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $2d7d8e3cc345803e$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $2d7d8e3cc345803e$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $2d7d8e3cc345803e$var$n
                    ].concat(void 0 === i ? [] : $2d7d8e3cc345803e$var$s(i))
            })
    });
}
function $2d7d8e3cc345803e$var$v(t) {
    return "number" == typeof t;
}
function $2d7d8e3cc345803e$var$b(t) {
    return "string" == typeof t;
}
function $2d7d8e3cc345803e$var$w(t) {
    return "bigint" == typeof t;
}
const $2d7d8e3cc345803e$var$S = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return !0;
})), $2d7d8e3cc345803e$var$O = $2d7d8e3cc345803e$var$S, $2d7d8e3cc345803e$var$j = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length >= t))(e))),
        length: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$m(t, (n = e, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$b(t) && Boolean(t.match(n))))));
        }
    }), $2d7d8e3cc345803e$var$K = $2d7d8e3cc345803e$var$j($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$b)), $2d7d8e3cc345803e$var$x = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$v(e) && e >= t))(e))),
        int: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$v(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$E = $2d7d8e3cc345803e$var$x($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$v)), $2d7d8e3cc345803e$var$A = (t)=>Object.assign($2d7d8e3cc345803e$var$u(t), {
        between: (e, n)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t, e)=>$2d7d8e3cc345803e$var$p((n)=>$2d7d8e3cc345803e$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e < t))(e))),
        gt: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e > t))(e))),
        lte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e <= t))(e))),
        gte: (e)=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, ((t)=>$2d7d8e3cc345803e$var$p((e)=>$2d7d8e3cc345803e$var$w(e) && e >= t))(e))),
        positive: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t > 0))),
        negative: ()=>$2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$m(t, $2d7d8e3cc345803e$var$p((t)=>$2d7d8e3cc345803e$var$w(t) && t < 0)))
    }), $2d7d8e3cc345803e$var$P = $2d7d8e3cc345803e$var$A($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$var$w)), $2d7d8e3cc345803e$var$T = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "boolean" == typeof t;
})), $2d7d8e3cc345803e$var$B = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return "symbol" == typeof t;
})), $2d7d8e3cc345803e$var$_ = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null == t;
})), $2d7d8e3cc345803e$var$k = $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
    return null != t;
}));
var $2d7d8e3cc345803e$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $2d7d8e3cc345803e$var$t,
    optional: $2d7d8e3cc345803e$var$l,
    array: function(...e) {
        return $2d7d8e3cc345803e$var$h({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $2d7d8e3cc345803e$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$2d7d8e3cc345803e$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $2d7d8e3cc345803e$var$f(t, (t)=>$2d7d8e3cc345803e$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $2d7d8e3cc345803e$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $2d7d8e3cc345803e$var$g(t, (t, e)=>{
                                const n = $2d7d8e3cc345803e$var$o(s, e, r), i = $2d7d8e3cc345803e$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$2d7d8e3cc345803e$var$s(e[0]),
                            ...$2d7d8e3cc345803e$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $2d7d8e3cc345803e$var$m,
    union: $2d7d8e3cc345803e$var$d,
    not: function(e) {
        return $2d7d8e3cc345803e$var$u({
            [$2d7d8e3cc345803e$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$2d7d8e3cc345803e$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $2d7d8e3cc345803e$var$p,
    select: $2d7d8e3cc345803e$var$y,
    any: $2d7d8e3cc345803e$var$S,
    _: $2d7d8e3cc345803e$var$O,
    string: $2d7d8e3cc345803e$var$K,
    number: $2d7d8e3cc345803e$var$E,
    bigint: $2d7d8e3cc345803e$var$P,
    boolean: $2d7d8e3cc345803e$var$T,
    symbol: $2d7d8e3cc345803e$var$B,
    nullish: $2d7d8e3cc345803e$var$_,
    nonNullable: $2d7d8e3cc345803e$var$k,
    instanceOf: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $2d7d8e3cc345803e$var$u($2d7d8e3cc345803e$var$p($2d7d8e3cc345803e$export$ce1e7a33533a73d9(t)));
    }
};
class $2d7d8e3cc345803e$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $2d7d8e3cc345803e$var$$ = {
    matched: !1,
    value: void 0
};
function $2d7d8e3cc345803e$export$4659b591c19bdf3d(t) {
    return new $2d7d8e3cc345803e$var$I(t, $2d7d8e3cc345803e$var$$);
}
class $2d7d8e3cc345803e$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$2d7d8e3cc345803e$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $2d7d8e3cc345803e$var$$ : {
            matched: !0,
            value: e(s ? $2d7d8e3cc345803e$var$n in c ? c[$2d7d8e3cc345803e$var$n] : c : this.input, this.input)
        };
        return new $2d7d8e3cc345803e$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $2d7d8e3cc345803e$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $2d7d8e3cc345803e$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $2d7d8e3cc345803e$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $2d7d8e3cc345803e$var$L(t) {
    throw new $2d7d8e3cc345803e$export$6c1467edb54d3773(t);
}
 //# sourceMappingURL=index.js.map
module.exports["P"] = $2d7d8e3cc345803e$export$56c0d5a1e737357d;
module.exports["match"] = $2d7d8e3cc345803e$export$4659b591c19bdf3d;

});

parcelRegister("jU6s6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $1f90c1a79bae927c$export$4f059feb37b5835e = (0, $cozmU.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $1f90c1a79bae927c$export$4f059feb37b5835e;

});

parcelRegister("4dW9D", function(module, exports) {

var $iCEWf = parcelRequire("iCEWf");

const $7545c0c100898f47$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $iCEWf.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $7545c0c100898f47$export$5013b36eeed4ec19;

});

parcelRegister("iCEWf", function(module, exports) {
var $d6416e2c87d11da8$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["adopted"] = "[AIInteraction]:ADOPTED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $d6416e2c87d11da8$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $d6416e2c87d11da8$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $d6416e2c87d11da8$export$7052d5b66e36f60f;

});

parcelRegister("96Ikf", function(module, exports) {
const $3836d38b50a38c42$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $3836d38b50a38c42$export$e053e424fcbfebe9;

});

parcelRegister("jLdbZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1r1cI = parcelRequire("1r1cI");


var $7mJer = parcelRequire("7mJer");


var $iCEWf = parcelRequire("iCEWf");

const $e5d5cfe1f6d4c858$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $cozmU.useRef)(undefined);
    const aiSessionStateRef = (0, $cozmU.useRef)((0, $iCEWf.AISessionState).unset);
    const setAISessionState = (0, $cozmU.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $cozmU.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $cozmU.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $1r1cI.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $7mJer.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $cozmU.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $7mJer.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $e5d5cfe1f6d4c858$export$259576f4e7ac6488;

});

parcelRegister("1r1cI", function(module, exports) {

var $3U8XR = parcelRequire("3U8XR");


var $03RpJ = parcelRequire("03RpJ");

function $d83e4e74e28b2b37$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $3U8XR.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $3U8XR.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, $03RpJ.default)());
}
module.exports["getNewSingleInstrumentationID"] = $d83e4e74e28b2b37$export$cee2a1482be61648;

});

parcelRegister("7mJer", function(module, exports) {

var $1Qi0Q = parcelRequire("1Qi0Q");

var $lnexi = parcelRequire("lnexi");

const $0ca840bf5f9ee98d$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $0ca840bf5f9ee98d$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $0ca840bf5f9ee98d$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $lnexi.setCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $0ca840bf5f9ee98d$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $1Qi0Q.getCookie)($0ca840bf5f9ee98d$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $0ca840bf5f9ee98d$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $0ca840bf5f9ee98d$export$d6fb1caea334c7c7;

});

parcelRegister("jTKfH", function(module, exports) {

var $5rzIE = parcelRequire("5rzIE");

const $93101e1e1df3fd55$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $93101e1e1df3fd55$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $93101e1e1df3fd55$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $93101e1e1df3fd55$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $93101e1e1df3fd55$var$processHttpErrorResponse({
            response: response
        });
        const result = await response.json();
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return result;
    } catch (err) {
        const outcome = err instanceof $93101e1e1df3fd55$var$HttpApiError ? 'httpError' : err instanceof Error && err.name === 'AbortError' ? 'abort' : 'networkError';
        const statusCode = err instanceof $93101e1e1df3fd55$var$HttpApiError ? err.errorAttributes.statusCode : undefined;
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'http',
            method: (options.method ?? 'GET').toUpperCase(),
            route: (0, $5rzIE.normalizeRequestRoute)(path),
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: outcome,
            status: statusCode
        });
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        throw new $93101e1e1df3fd55$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $93101e1e1df3fd55$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $93101e1e1df3fd55$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $93101e1e1df3fd55$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $93101e1e1df3fd55$export$9f229e40eb65abfc;
module.exports["FetchError"] = $93101e1e1df3fd55$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $93101e1e1df3fd55$export$a38d93aa782475f6;

});

parcelRegister("5rzIE", function(module, exports) {
const $40a8b1f594239208$var$listeners = new Set();
const $40a8b1f594239208$var$UUID_SEGMENT_PATTERN = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN = /\/\d+(?=\/|$)/g;
const $40a8b1f594239208$export$eb91308c925b64ce = ()=>{
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') return performance.now();
    return Date.now();
};
const $40a8b1f594239208$export$327998895df08b85 = (startedAt)=>Math.max(0, Math.round($40a8b1f594239208$export$eb91308c925b64ce() - startedAt));
const $40a8b1f594239208$export$c805539eac489f93 = (path)=>{
    try {
        const parsed = new URL(path, 'https://conversation-assistant.invalid');
        return parsed.pathname.replace($40a8b1f594239208$var$UUID_SEGMENT_PATTERN, '{id}').replace($40a8b1f594239208$var$NUMERIC_SEGMENT_PATTERN, '/{id}');
    } catch  {
        return '/unparseable';
    }
};
const $40a8b1f594239208$export$d23c16bc33c579b9 = (listener)=>{
    $40a8b1f594239208$var$listeners.add(listener);
    return ()=>{
        $40a8b1f594239208$var$listeners.delete(listener);
    };
};
const $40a8b1f594239208$export$1914d1896389da95 = ()=>$40a8b1f594239208$var$listeners.size > 0;
const $40a8b1f594239208$export$58e155918d09bf5f = (observation)=>{
    for (const listener of Array.from($40a8b1f594239208$var$listeners))try {
        listener(observation);
    } catch  {
    // Observability must never change the request's result or error behavior.
    }
};
const $40a8b1f594239208$export$ef42b2d680ea8d8d = ()=>{
    $40a8b1f594239208$var$listeners.clear();
};
module.exports["requestObservationNow"] = $40a8b1f594239208$export$eb91308c925b64ce;
module.exports["requestObservationDuration"] = $40a8b1f594239208$export$327998895df08b85;
module.exports["normalizeRequestRoute"] = $40a8b1f594239208$export$c805539eac489f93;
module.exports["subscribeToRequestObservations"] = $40a8b1f594239208$export$d23c16bc33c579b9;
module.exports["hasRequestObservationSubscribers"] = $40a8b1f594239208$export$1914d1896389da95;
module.exports["publishRequestObservation"] = $40a8b1f594239208$export$58e155918d09bf5f;

});

parcelRegister("g93kp", function(module, exports) {
$parcel$export(module.exports, "default", () => $bc101184c63d7a7a$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $3yGK6 = parcelRequire("3yGK6");

function $bc101184c63d7a7a$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $3yGK6.default)(2, arguments);
    return (0, $dkBOe.default)(dateLeft).getTime() - (0, $dkBOe.default)(dateRight).getTime();
}

});

parcelRegister("byLBW", function(module, exports) {
var $86a7cd36e9b99950$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $86a7cd36e9b99950$var$defaultRoundingMethod = 'trunc';
function $86a7cd36e9b99950$export$b6474a47258c1211(method) {
    return method ? $86a7cd36e9b99950$var$roundingMap[method] : $86a7cd36e9b99950$var$roundingMap[$86a7cd36e9b99950$var$defaultRoundingMethod];
}
module.exports["getRoundingMethod"] = $86a7cd36e9b99950$export$b6474a47258c1211;

});

parcelRegister("haiCi", function(module, exports) {

var $jTKfH = parcelRequire("jTKfH");


var $5rzIE = parcelRequire("5rzIE");

const $a406323faf455711$var$extractQueryName = (gqlQuery)=>{
    const operationMatch = gqlQuery.match(/(?:query|mutation)\s+(\w+)/);
    return operationMatch ? operationMatch[1] : undefined;
};
const $a406323faf455711$export$f602b5befecb0b84 = async ({ gqlQuery: gqlQuery, headerOptions: headerOptions, variables: variables, abortController: abortController })=>{
    const startedAt = (0, $5rzIE.hasRequestObservationSubscribers)() ? (0, $5rzIE.requestObservationNow)() : undefined;
    const operation = startedAt === undefined ? undefined : $a406323faf455711$var$extractQueryName(gqlQuery);
    try {
        const response = await fetch('/gateway/api/graphql', {
            headers: {
                'Content-Type': 'application/json',
                ...headerOptions
            },
            method: 'POST',
            body: JSON.stringify({
                query: gqlQuery,
                variables: variables
            }),
            signal: abortController?.signal
        });
        const json = await response.json();
        if (json?.errors?.length) await $a406323faf455711$var$processGqlErrorResponse({
            errors: json.errors,
            gqlQuery: gqlQuery
        });
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'success',
            status: response.status
        });
        return json;
    } catch (err) {
        // GqlApiError is already processed
        if (err instanceof $a406323faf455711$export$ba203f24e0131ba7) {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'graphqlError'
            });
            throw err;
        }
        // Handle abort signal gracefully, it shouldn't be considered an error despite being caught
        if (err instanceof Error && err.name === 'AbortError') {
            if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
                kind: 'graphql',
                method: 'POST',
                operation: operation,
                durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
                outcome: 'abort'
            });
            return {
                // eslint-disable-next-line @atlaskit/platform/no-double-type-assertions -- Existing GraphQL abort baseline: abort returns an empty typed success shape for generic callers.
                data: null,
                errors: undefined
            };
        }
        const originalErrorMessage = err instanceof Error ? err.message : 'Unknown error';
        if (startedAt !== undefined) (0, $5rzIE.publishRequestObservation)({
            kind: 'graphql',
            method: 'POST',
            operation: operation,
            durationMs: (0, $5rzIE.requestObservationDuration)(startedAt),
            outcome: 'networkError'
        });
        throw new (0, $jTKfH.FetchError)(`GraphQL query failed (promise rejected): ${originalErrorMessage}`, {
            errorCode: 'performGqlFetchError'
        });
    }
};
class $a406323faf455711$export$ba203f24e0131ba7 extends Error {
    constructor({ errors: errors, queryName: queryName }){
        const errorsString = errors.map((error)=>error.message).join(', ');
        const errorMessage = `GraphQL API error: ${errorsString}`;
        super(errorMessage);
        this.message = void 0;
        this.errorAttributes = void 0;
        this.message = errorMessage;
        this.name = 'GraphQLError';
        this.errorAttributes = {
            errorCode: 'GqlApiError',
            queryName: queryName,
            rawErrorMessage: errorMessage,
            errors: errorsString
        };
    }
}
const $a406323faf455711$var$processGqlErrorResponse = async ({ errors: errors, gqlQuery: gqlQuery })=>{
    const errorsToThrow = [];
    errors.forEach((error)=>{
        errorsToThrow.push({
            message: error.message,
            status_code: error.extensions.statusCode,
            classification: error.extensions.classification
        });
    });
    throw new $a406323faf455711$export$ba203f24e0131ba7({
        errors: errorsToThrow,
        queryName: $a406323faf455711$var$extractQueryName(gqlQuery)
    });
};
module.exports["performGqlFetch"] = $a406323faf455711$export$f602b5befecb0b84;
module.exports["GqlApiError"] = $a406323faf455711$export$ba203f24e0131ba7;

});

parcelRegister("38vK5", function(module, exports) {

var $4Vdlk = parcelRequire("4Vdlk");


var $50k8e = parcelRequire("50k8e");

const $13b62b9fdabf1049$var$api = (0, $50k8e.makeApi)({
    monitor: (0, $4Vdlk.monitorForElements)
});
const $13b62b9fdabf1049$export$4b66ee8317094cdb = $13b62b9fdabf1049$var$api.autoScroll;
const $13b62b9fdabf1049$export$c9168f41de61f525 = $13b62b9fdabf1049$var$api.autoScrollWindow;
module.exports["autoScrollForElements"] = $13b62b9fdabf1049$export$4b66ee8317094cdb;

});

parcelRegister("50k8e", function(module, exports) {

var $4QfFX = parcelRequire("4QfFX");


var $gEZCs = parcelRequire("gEZCs");


var $bTXWf = parcelRequire("bTXWf");


var $4SoL4 = parcelRequire("4SoL4");


var $1UuSE = parcelRequire("1UuSE");

function $f5382ac96223be68$export$b8fa21320a811083({ monitor: monitor }) {
    const elementRegistry = new Map();
    const windowRegistry = new Set();
    function autoScroll(args) {
        elementRegistry.set(args.element, args);
        const cleanup = (0, $4QfFX.combine)((0, $4SoL4.addScrollableAttribute)(args.element), ()=>elementRegistry.delete(args.element));
        return (0, $gEZCs.once)(cleanup);
    }
    function autoScrollWindow(args = {}) {
        // Putting `args` in a unique object so that
        // each call will create a unique entry, even if a consumer
        // shares the `args` object between calls.
        // Just being safe here.
        const unique = {
            ...args
        };
        windowRegistry.add(unique);
        function cleanup() {
            windowRegistry.delete(unique);
        }
        return (0, $gEZCs.once)(cleanup);
    }
    function findEntry(element) {
        return elementRegistry.get(element) ?? null;
    }
    function getWindowScrollEntries() {
        return Array.from(windowRegistry);
    }
    function onFrame({ latestArgs: latestArgs, underUsersPointer: underUsersPointer, timeSinceLastFrame: timeSinceLastFrame }) {
        (0, $1UuSE.tryScroll)({
            input: latestArgs.location.current.input,
            source: latestArgs.source,
            findEntry: findEntry,
            underUsersPointer: underUsersPointer,
            timeSinceLastFrame: timeSinceLastFrame,
            getWindowScrollEntries: getWindowScrollEntries
        });
    }
    (0, $bTXWf.getScheduler)(monitor).onFrame(onFrame);
    return {
        autoScroll: autoScroll,
        autoScrollWindow: autoScrollWindow
    };
}
module.exports["makeApi"] = $f5382ac96223be68$export$b8fa21320a811083;

});

parcelRegister("bTXWf", function(module, exports) {

var $31Y6I = parcelRequire("31Y6I");


var $5Mj3f = parcelRequire("5Mj3f");

// We keep this map so that "over element" scrolling and "overflow" scrolling
// can leverage the same scheduler.
// The 'monitor' is the key for looking up schedulers
const $d27a3192f501902b$var$schedulers = new Map();
function $d27a3192f501902b$export$5cff7ac265db316a(monitor) {
    const scheduler = $d27a3192f501902b$var$schedulers.get(monitor);
    if (scheduler) // @ts-expect-error: I don't know how to link the DragType generic between the key and the value when the
    // monitor itself is the key
    return scheduler;
    const created = $d27a3192f501902b$var$makeScheduler(monitor);
    $d27a3192f501902b$var$schedulers.set(monitor, created);
    return created;
}
function $d27a3192f501902b$var$makeScheduler(monitor) {
    let state = {
        type: 'idle'
    };
    const callbacks = [];
    function loop(timeLastFrameFinished) {
        if (state.type !== 'running') return;
        const timeSinceLastFrame = timeLastFrameFinished - state.timeLastFrameFinished;
        const { latestArgs: latestArgs } = state;
        // A common starting lookup point for determining
        // which auto scroller should be used, and what should be scrolled.
        const underUsersPointer = (0, $31Y6I.getElementFromPointWithoutHoneypot)({
            x: latestArgs.location.current.input.clientX,
            y: latestArgs.location.current.input.clientY
        });
        (0, $5Mj3f.clearUnusedEngagements)(()=>{
            callbacks.forEach((onFrame)=>onFrame({
                    underUsersPointer: underUsersPointer,
                    latestArgs: latestArgs,
                    timeSinceLastFrame: timeSinceLastFrame
                }));
        });
        state.timeLastFrameFinished = timeLastFrameFinished;
        state.frameId = requestAnimationFrame(loop);
    }
    function reset() {
        if (state.type === 'idle') return;
        cancelAnimationFrame(state.frameId);
        (0, $5Mj3f.clearEngagementHistory)();
        state = {
            type: 'idle'
        };
    }
    function start(args) {
        if (state.type !== 'idle') return;
        state = {
            // Waiting a frame so we can accurately determine `timeSinceLastFrame`.
            type: 'initializing',
            latestArgs: args,
            frameId: requestAnimationFrame((timeLastFrameFinished)=>{
                if (state.type !== 'initializing') return;
                state = {
                    type: 'running',
                    timeLastFrameFinished: timeLastFrameFinished,
                    latestArgs: state.latestArgs,
                    frameId: requestAnimationFrame(loop)
                };
            })
        };
    }
    // this module might have been imported after a drag has started
    // We are starting the auto scroller if we get an update event and
    // the auto scroller has not started yet
    function update(args) {
        if (state.type === 'idle') {
            start(args);
            return;
        }
        state.latestArgs = args;
    }
    // Not exposing a way to stop listening
    monitor({
        onDragStart: start,
        onDropTargetChange: update,
        onDrag: update,
        onDrop: reset
    });
    const api = {
        onFrame (fn) {
            callbacks.push(fn);
        }
    };
    return api;
}
module.exports["getScheduler"] = $d27a3192f501902b$export$5cff7ac265db316a;

});

parcelRegister("5Mj3f", function(module, exports) {
const $b507fa4d63a4635b$var$ledger = new Map();
const $b507fa4d63a4635b$var$requested = new Set();
function $b507fa4d63a4635b$export$8c764c3f2fc3d2d2(element) {
    $b507fa4d63a4635b$export$1cb7cbb266b6f6fa(element);
    const entry = $b507fa4d63a4635b$var$ledger.get(element);
    if (entry) return entry;
    const fresh = {
        timeOfEngagementStart: Date.now()
    };
    $b507fa4d63a4635b$var$ledger.set(element, fresh);
    return fresh;
}
function $b507fa4d63a4635b$export$1cb7cbb266b6f6fa(element) {
    $b507fa4d63a4635b$var$requested.add(element);
}
function $b507fa4d63a4635b$export$991e77dd347f3df1(fn) {
    // make sure previous engagement requests don't linger
    $b507fa4d63a4635b$var$requested.clear();
    // perform the required work
    fn();
    // if engagements where not requested, purge it
    $b507fa4d63a4635b$var$ledger.forEach((_, element)=>{
        if (!$b507fa4d63a4635b$var$requested.has(element)) $b507fa4d63a4635b$var$ledger.delete(element);
    });
    // cleaning up after ourselves
    $b507fa4d63a4635b$var$requested.clear();
}
function $b507fa4d63a4635b$export$13ae770ed39b71ea() {
    $b507fa4d63a4635b$var$ledger.clear();
}
module.exports["markAndGetEngagement"] = $b507fa4d63a4635b$export$8c764c3f2fc3d2d2;
module.exports["clearUnusedEngagements"] = $b507fa4d63a4635b$export$991e77dd347f3df1;
module.exports["clearEngagementHistory"] = $b507fa4d63a4635b$export$13ae770ed39b71ea;

});

parcelRegister("4SoL4", function(module, exports) {
const $35c4ac2061d5f133$export$4b152ab55cad4fd6 = 'data-auto-scrollable';
const $35c4ac2061d5f133$export$aea217a45095ce11 = `[${$35c4ac2061d5f133$export$4b152ab55cad4fd6}="true"]`;
function $35c4ac2061d5f133$export$4ec12fb57dfebd53(element) {
    element.setAttribute($35c4ac2061d5f133$export$4b152ab55cad4fd6, 'true');
    return ()=>element.removeAttribute($35c4ac2061d5f133$export$4b152ab55cad4fd6);
}
module.exports["selector"] = $35c4ac2061d5f133$export$aea217a45095ce11;
module.exports["addScrollableAttribute"] = $35c4ac2061d5f133$export$4ec12fb57dfebd53;

});

parcelRegister("1UuSE", function(module, exports) {

var $9r8oV = parcelRequire("9r8oV");


var $5Mj3f = parcelRequire("5Mj3f");


var $4SoL4 = parcelRequire("4SoL4");


var $j0x5d = parcelRequire("j0x5d");

function $c48f25f499b57242$var$isScrollingAvailable(value) {
    return Boolean(value.top || value.left);
}
function $c48f25f499b57242$var$tryScrollElements({ target: target, input: input, source: source, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, available: available = {
    top: true,
    left: true
} }) {
    // we cannot do any more scrolling
    if (!$c48f25f499b57242$var$isScrollingAvailable(available)) return available;
    // run out of parents to search
    if (!target) return available;
    const element = target.closest((0, $4SoL4.selector));
    // cannot find any more scroll containers
    if (!element) return available;
    const container = findEntry(element);
    // cannot find registration, this is bad.
    // fail and just exit
    if (!container) return available;
    function continueSearchUp() {
        return $c48f25f499b57242$var$tryScrollElements({
            target: element?.parentElement ?? null,
            findEntry: findEntry,
            source: source,
            timeSinceLastFrame: timeSinceLastFrame,
            input: input,
            available: available
        });
    }
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    // Engagement is not marked if scrolling is explicitly not allowed
    if (container.canScroll && !container.canScroll(feedback)) return continueSearchUp();
    // Marking engagement even if no edges are scrollable.
    // We are marking engagement as soon as the element is scrolled over
    const engagement = (0, $5Mj3f.markAndGetEngagement)(element);
    const config = (0, $9r8oV.getInternalConfig)(container.getConfiguration?.(feedback));
    const allowedAxis = container.getAllowedAxis?.(feedback) ?? 'all';
    const scrollBy = (0, $j0x5d.getScrollBy)({
        element: element,
        engagement: engagement,
        input: input,
        timeSinceLastFrame: timeSinceLastFrame,
        allowedAxis: allowedAxis,
        config: config
    });
    // Only allow scrolling in directions that have not already been used
    const scroll = {
        top: 0,
        left: 0
    };
    if (available.top && scrollBy.top !== 0) {
        scroll.top = scrollBy.top;
        // can no longer scroll on the top after this
        available.top = false;
    }
    if (available.left && scrollBy.left !== 0) {
        scroll.left = scrollBy.left;
        // can no longer scroll on the left after this
        available.left = false;
    }
    // Only scroll if there is something to scroll
    if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
    return continueSearchUp();
}
function $c48f25f499b57242$var$tryScrollWindow({ input: input, timeSinceLastFrame: timeSinceLastFrame, available: available, source: source, entries: entries }) {
    const element = document.documentElement;
    const feedback = {
        input: input,
        source: source,
        element: element
    };
    for (const entry of entries){
        // this entry is not allowing scrolling, we need to look for another
        if (entry.canScroll && !entry.canScroll(feedback)) continue;
        // Note: if we had an event for when the user is leaving a tab
        // we _could_ conceptually reset the engagement
        const engagement = (0, $5Mj3f.markAndGetEngagement)(element);
        const config = (0, $9r8oV.getInternalConfig)(entry.getConfiguration?.(feedback));
        const allowedAxis = entry.getAllowedAxis?.(feedback) ?? 'all';
        const scrollBy = (0, $j0x5d.getScrollBy)({
            element: element,
            engagement: engagement,
            input: input,
            config: config,
            allowedAxis: allowedAxis,
            getRect: (element)=>DOMRect.fromRect({
                    y: 0,
                    x: 0,
                    width: element.clientWidth,
                    height: element.clientHeight
                }),
            timeSinceLastFrame: timeSinceLastFrame
        });
        const scroll = {
            top: available.top ? scrollBy.top : 0,
            left: available.left ? scrollBy.left : 0
        };
        // only trigger a scroll if we are actually scrolling
        if (scroll.top !== 0 || scroll.left !== 0) element.scrollBy(scroll);
        break;
    }
}
function $c48f25f499b57242$export$233199807749476d({ input: input, findEntry: findEntry, timeSinceLastFrame: timeSinceLastFrame, source: source, getWindowScrollEntries: getWindowScrollEntries, underUsersPointer: underUsersPointer }) {
    // We are matching browser behaviour and scrolling inner elements
    // before outer ones. So we try to scroll scroller containers before
    // the window.
    const remainder = $c48f25f499b57242$var$tryScrollElements({
        target: underUsersPointer,
        timeSinceLastFrame: timeSinceLastFrame,
        input: input,
        source: source,
        findEntry: findEntry
    });
    // Check if we can do any window scrolling
    if (!$c48f25f499b57242$var$isScrollingAvailable(remainder)) return;
    $c48f25f499b57242$var$tryScrollWindow({
        input: input,
        source: source,
        entries: getWindowScrollEntries(),
        timeSinceLastFrame: timeSinceLastFrame,
        available: remainder
    });
}
module.exports["tryScroll"] = $c48f25f499b57242$export$233199807749476d;

});

parcelRegister("9r8oV", function(module, exports) {
const $a7ed1bcd13597f53$var$baseConfig = {
    startHitboxAtPercentageRemainingOfElement: {
        top: 0.25,
        right: 0.25,
        bottom: 0.25,
        left: 0.25
    },
    maxScrollAtPercentageRemainingOfHitbox: {
        top: 0.5,
        right: 0.5,
        bottom: 0.5,
        left: 0.5
    },
    timeDampeningDurationMs: 400,
    // Too big and it's too easy to trigger auto scrolling
    // Too small and it's too hard 😅
    maxMainAxisHitboxSize: 180
};
/** What the max scroll should be per second. Using "per second" rather than "per frame"
 * as we want a consistent scroll speed regardless of frame rate.
 *
 *
 * I explored trying to make the max scroll speed dynamic based on particular factors.
 * However, it ended up being difficult to find a _perfect_ formula.
 *
 * Likely the perfect answer would involve:
 * - the size of the scrollable element
 * - the size of the scrollable element relative to the screen size
 * - the size of the drag preview
 * - the size of elements being scrolled in scrollable elements (expensive and difficult to compute)
 */ const $a7ed1bcd13597f53$var$maxPixelScrollPerSecond = {
    // What the value would be if we were scrolling at 15px per frame at 60fps.
    // This is the default as it works well for most experiences.
    // In certain scenarios though it can feel a bit slow.
    standard: 900,
    // What the value would be if we were scrolling at 25px per frame at 60fps.
    // This is not the default as it feels too fast for a lot of experiences.
    fast: 1500
};
function $a7ed1bcd13597f53$export$e96028ec7ff9d079(provided) {
    return {
        ...$a7ed1bcd13597f53$var$baseConfig,
        // only allowing limited control over the config at this stage
        maxPixelScrollPerSecond: $a7ed1bcd13597f53$var$maxPixelScrollPerSecond[provided?.maxScrollSpeed ?? 'standard']
    };
}
module.exports["getInternalConfig"] = $a7ed1bcd13597f53$export$e96028ec7ff9d079;

});

parcelRegister("j0x5d", function(module, exports) {

var $4PtQA = parcelRequire("4PtQA");


var $iqmUH = parcelRequire("iqmUH");


var $lIDh1 = parcelRequire("lIDh1");


var $drwMb = parcelRequire("drwMb");


var $75xM4 = parcelRequire("75xM4");


var $jNg3h = parcelRequire("jNg3h");

function $510e86c1df38ba68$var$getRectDefault(element) {
    return element.getBoundingClientRect();
}
function $510e86c1df38ba68$export$6cfa6dfe6898b98f({ element: element, input: input, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, config: config, allowedAxis: allowedAxis, getRect: getRect = $510e86c1df38ba68$var$getRectDefault }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    const clientRect = getRect(element);
    const scrollableEdges = (0, $iqmUH.edges).reduce((map, edge)=>{
        const hitbox = (0, $lIDh1.getOverElementHitbox)[edge]({
            clientRect: clientRect,
            config: config
        });
        const axis = (0, $iqmUH.edgeAxisLookup)[edge];
        // Note: changing the allowed axis during a drag will not
        // reset time dampening. It was decided it would be too
        // complex to implement initially, and we can add it
        // later if needed.
        if (!(0, $75xM4.isAxisAllowed)(axis, allowedAxis)) return map;
        if (!(0, $jNg3h.isWithin)({
            client: client,
            clientRect: hitbox
        })) return map;
        if (!(0, $4PtQA.canScrollOnEdge)[edge](element)) return map;
        map.set(edge, {
            edge: edge,
            hitbox: hitbox
        });
        return map;
    }, new Map());
    const left = (()=>{
        const axis = 'horizontal';
        const leftEdge = scrollableEdges.get('left');
        if (leftEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: leftEdge.edge,
            hitbox: leftEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const rightEdge = scrollableEdges.get('right');
        if (rightEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: rightEdge.edge,
            hitbox: rightEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    const top = (()=>{
        const axis = 'vertical';
        const bottomEdge = scrollableEdges.get('bottom');
        if (bottomEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: bottomEdge.edge,
            hitbox: bottomEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        const topEdge = scrollableEdges.get('top');
        if (topEdge) return (0, $drwMb.getScrollChange)({
            client: client,
            edge: topEdge.edge,
            hitbox: topEdge.hitbox,
            axis: axis,
            timeSinceLastFrame: timeSinceLastFrame,
            engagement: engagement,
            isDistanceDampeningEnabled: true,
            config: config
        });
        return 0;
    })();
    return {
        left: left,
        top: top
    };
}
module.exports["getScrollBy"] = $510e86c1df38ba68$export$6cfa6dfe6898b98f;

});

parcelRegister("4PtQA", function(module, exports) {
const $5318802fe51175c6$export$ccd6d9407403fcad = {
    // Notes:
    //
    // 🌏 Chrome 115.0: uses fractional units for `scrollLeft` and `scrollTop`
    //    (and fractional units don't reach true integer maximum when zoomed in / out)
    // 🍎 Safari 16.5.2: no fractional units
    // 🦊 Firefox 115.0: no fractional units
    // we have some scroll we can move backwards into
    top: (element)=>element.scrollTop > 0,
    // We have some scroll we can move forward into
    right: (element)=>Math.ceil(element.scrollLeft) + element.clientWidth < element.scrollWidth,
    // We have some scroll we can move forwards into
    bottom: (element)=>Math.ceil(element.scrollTop) + element.clientHeight < element.scrollHeight,
    // we have some scroll we can move back into.
    left: (element)=>element.scrollLeft > 0
};
module.exports["canScrollOnEdge"] = $5318802fe51175c6$export$ccd6d9407403fcad;

});

parcelRegister("iqmUH", function(module, exports) {
const $abc8f89ed9b7940d$export$4544a00f8eb65eb2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $abc8f89ed9b7940d$export$7fc144124ccf8292 = {
    top: 'vertical',
    right: 'horizontal',
    bottom: 'vertical',
    left: 'horizontal'
};
module.exports["edges"] = $abc8f89ed9b7940d$export$4544a00f8eb65eb2;
module.exports["edgeAxisLookup"] = $abc8f89ed9b7940d$export$7fc144124ccf8292;

});

parcelRegister("lIDh1", function(module, exports) {

var $eU390 = parcelRequire("eU390");


var $k6QYd = parcelRequire("k6QYd");

function $516f0b1290892600$var$makeGetHitbox({ edge: edge, axis: axis }) {
    return function hitbox({ clientRect: clientRect, config: config }) {
        const { mainAxis: mainAxis, crossAxis: crossAxis } = (0, $eU390.axisLookup)[axis];
        const side = (0, $k6QYd.mainAxisSideLookup)[edge];
        const mainAxisHitboxSize = Math.min(// scale the size of the hitbox down for smaller elements
        config.startHitboxAtPercentageRemainingOfElement[edge] * clientRect[mainAxis.size], // Don't let the hitbox grow too big for big elements
        config.maxMainAxisHitboxSize);
        return DOMRect.fromRect({
            [mainAxis.point]: side === 'start' ? clientRect[mainAxis.point] : clientRect[mainAxis.point] + clientRect[mainAxis.size] - mainAxisHitboxSize,
            [crossAxis.point]: clientRect[crossAxis.point],
            [mainAxis.size]: mainAxisHitboxSize,
            [crossAxis.size]: clientRect[crossAxis.size]
        });
    };
}
const $516f0b1290892600$export$b9a449c20abb0e9 = {
    top: $516f0b1290892600$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'top'
    }),
    right: $516f0b1290892600$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'right'
    }),
    bottom: $516f0b1290892600$var$makeGetHitbox({
        axis: 'vertical',
        edge: 'bottom'
    }),
    left: $516f0b1290892600$var$makeGetHitbox({
        axis: 'horizontal',
        edge: 'left'
    })
};
module.exports["getOverElementHitbox"] = $516f0b1290892600$export$b9a449c20abb0e9;

});

parcelRegister("eU390", function(module, exports) {
const $5b0e1b1531f93246$var$vertical = {
    start: 'top',
    end: 'bottom',
    point: 'y',
    size: 'height'
};
const $5b0e1b1531f93246$var$horizontal = {
    start: 'left',
    end: 'right',
    point: 'x',
    size: 'width'
};
const $5b0e1b1531f93246$export$42e42cdab35a2b96 = {
    vertical: {
        mainAxis: $5b0e1b1531f93246$var$vertical,
        crossAxis: $5b0e1b1531f93246$var$horizontal
    },
    horizontal: {
        mainAxis: $5b0e1b1531f93246$var$horizontal,
        crossAxis: $5b0e1b1531f93246$var$vertical
    }
};
module.exports["axisLookup"] = $5b0e1b1531f93246$export$42e42cdab35a2b96;

});

parcelRegister("k6QYd", function(module, exports) {
const $51fdf9dde687ea21$export$a45c0cd714a4dbaa = {
    top: 'start',
    right: 'end',
    bottom: 'end',
    left: 'start'
};
module.exports["mainAxisSideLookup"] = $51fdf9dde687ea21$export$a45c0cd714a4dbaa;

});

parcelRegister("drwMb", function(module, exports) {

var $eU390 = parcelRequire("eU390");


var $fYr9O = parcelRequire("fYr9O");


var $k6QYd = parcelRequire("k6QYd");

// We want a consistent scroll speed across devices, regardless of framerate
function $4d516d91c431b939$var$getMaxScrollChange({ timeSinceLastFrame: timeSinceLastFrame, config: config }) {
    const targetScrollPerMs = config.maxPixelScrollPerSecond / 1000;
    // Adjusting out target scroll rate to match the frame rate of the target device
    // This will pull the scroll speed down on high frame rate devices
    // so we get a consistent visual scroll speed regardless of device.
    const proposed = Math.ceil(targetScrollPerMs * timeSinceLastFrame);
    // If lots of time as passed since that last frame (such on lower frame rate devices)
    // we don't want the scroll speed to be too fast, otherwise it can feel jumpy
    // We are capping the scroll speed at what it would be if we were hitting 60fps
    const maximum = config.maxPixelScrollPerSecond / 60;
    return Math.min(proposed, maximum);
}
function $4d516d91c431b939$var$getDistanceDampening({ client: client, axis: axis, edge: edge, hitbox: hitbox, config: config }) {
    const { mainAxis: mainAxis } = (0, $eU390.axisLookup)[axis];
    const side = (0, $k6QYd.mainAxisSideLookup)[edge];
    // We want to hit the max speed before the edge of the hitbox
    const maxSpeedBuffer = hitbox[mainAxis.size] * config.maxScrollAtPercentageRemainingOfHitbox[edge];
    if (side === 'end') return (0, $fYr9O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start],
        endOfRange: hitbox[mainAxis.end] - maxSpeedBuffer,
        value: client[mainAxis.point]
    });
    // Moving towards start edge
    const raw = (0, $fYr9O.getPercentageInRange)({
        startOfRange: hitbox[mainAxis.start] + maxSpeedBuffer,
        endOfRange: hitbox[mainAxis.end],
        value: client[mainAxis.point]
    });
    // When moving near start edge
    // - the 'end' edge is where we start scrolling
    // - the 'start' edge is where we reach max speed
    // So we need to invert the percentage when moving backwards
    return 1 - raw;
}
function $4d516d91c431b939$export$470a2ff46db8cee8({ client: client, timeSinceLastFrame: timeSinceLastFrame, engagement: engagement, axis: axis, hitbox: hitbox, edge: edge, isDistanceDampeningEnabled: isDistanceDampeningEnabled, config: config }) {
    // We have two forms of speed dampening:
    // 1. 🗺️ Distance
    // The closer you are to a hitbox edge, the faster the scroll speed will be
    // 2. ⏱️ Time
    // When first entering a scroll container we want to dampening all scrolling
    // This is to prevent super fast auto scrolling when first entering into
    // a scroll container, or when lifting in a scroll container
    const maxScroll = $4d516d91c431b939$var$getMaxScrollChange({
        timeSinceLastFrame: timeSinceLastFrame,
        config: config
    });
    const percentageDistanceDampening = isDistanceDampeningEnabled ? $4d516d91c431b939$var$getDistanceDampening({
        client: client,
        edge: edge,
        hitbox: hitbox,
        axis: axis,
        config: config
    }) : 1;
    // Dampen speed by time
    const percentageThroughTimeDampening = (0, $fYr9O.getPercentageInRange)({
        startOfRange: engagement.timeOfEngagementStart,
        endOfRange: engagement.timeOfEngagementStart + config.timeDampeningDurationMs,
        value: Date.now()
    });
    // Calculate how much of the max scroll we should apply based on dampening
    const percentageOfMaxScroll = percentageDistanceDampening * percentageThroughTimeDampening;
    // We _could_ ease this update (`Math.pow(percentageOfMaxSpeed, 2)`)
    // But linear is feeling really good
    // Always scrolling by at least one pixel, otherwise the scroll does nothing
    const scroll = Math.max(maxScroll * percentageOfMaxScroll, 1);
    const side = (0, $k6QYd.mainAxisSideLookup)[edge];
    // When moving backwards, we will be scrolling backwards
    return side === 'end' ? scroll : -1 * scroll;
}
module.exports["getScrollChange"] = $4d516d91c431b939$export$470a2ff46db8cee8;

});

parcelRegister("fYr9O", function(module, exports) {
function $e40a4c0dcd17caec$export$1a29de000a332d74({ startOfRange: startOfRange, endOfRange: endOfRange, value: value }) {
    // checking inputs
    const isValid = startOfRange < endOfRange;
    if (!isValid) return 0;
    if (value < startOfRange) return 0;
    if (value > endOfRange) return 1;
    const range = endOfRange - startOfRange;
    return (value - startOfRange) / range;
}
module.exports["getPercentageInRange"] = $e40a4c0dcd17caec$export$1a29de000a332d74;

});

parcelRegister("75xM4", function(module, exports) {
function $21de06d925095ccb$export$7120fdbd90bd1292(axis, allowedAxis) {
    return allowedAxis === 'all' || axis === allowedAxis;
}
module.exports["isAxisAllowed"] = $21de06d925095ccb$export$7120fdbd90bd1292;

});

parcelRegister("jNg3h", function(module, exports) {
function $97331151dddf073e$export$cda7a9d4399bf2e3({ client: client, clientRect: clientRect }) {
    return(// is within horizontal bounds
    client.x >= clientRect.x && client.x <= clientRect.x + clientRect.width && // is within vertical bounds
    client.y >= clientRect.y && client.y <= clientRect.y + clientRect.height);
}
module.exports["isWithin"] = $97331151dddf073e$export$cda7a9d4399bf2e3;

});

parcelRegister("8lhhf", function(module, exports) {
const $57d7e56ed333ab64$export$d0e832101df0ac96 = 'com.atlassian.rovo.skill';
const $57d7e56ed333ab64$export$d4f002c79ea2ad20 = 'skill';
const $57d7e56ed333ab64$export$e4d0b30afd49f7df = 'skillTag';
const $57d7e56ed333ab64$export$18f911e214c46d8 = /\/([a-zA-Z0-9-]+)/g;
const $57d7e56ed333ab64$export$aae1b80712c1b67b = `${$57d7e56ed333ab64$export$d4f002c79ea2ad20}:${$57d7e56ed333ab64$export$e4d0b30afd49f7df}`;
const $57d7e56ed333ab64$export$b22d8560058c60e1 = (extensionType, extensionKey)=>{
    return extensionType === $57d7e56ed333ab64$export$d0e832101df0ac96 && extensionKey === $57d7e56ed333ab64$export$aae1b80712c1b67b;
};
const $57d7e56ed333ab64$export$f88fd0c0ee7d509a = (skill)=>{
    return [
        {
            type: 'inlineExtension',
            attrs: {
                extensionKey: $57d7e56ed333ab64$export$aae1b80712c1b67b,
                extensionType: $57d7e56ed333ab64$export$d0e832101df0ac96,
                parameters: skill
            }
        },
        // render an empty space after the skill tag
        {
            type: 'text',
            text: ' '
        }
    ];
};
const $57d7e56ed333ab64$export$a425ebfe740d9932 = (skill)=>({
        type: 'doc',
        version: 1,
        content: [
            {
                type: 'paragraph',
                content: $57d7e56ed333ab64$export$f88fd0c0ee7d509a(skill)
            }
        ]
    });
module.exports["ROVO_SKILL_EXTENSION_TYPE"] = $57d7e56ed333ab64$export$d0e832101df0ac96;
module.exports["ROVO_SKILL_EXTENSION_KEY"] = $57d7e56ed333ab64$export$d4f002c79ea2ad20;
module.exports["ROVO_SKILL_TAG_PATTERN"] = $57d7e56ed333ab64$export$18f911e214c46d8;
module.exports["ROVO_SKILL_COMBINED_EXTENSION_KEY"] = $57d7e56ed333ab64$export$aae1b80712c1b67b;
module.exports["isSkillTagExtension"] = $57d7e56ed333ab64$export$b22d8560058c60e1;
module.exports["createSkillNode"] = $57d7e56ed333ab64$export$f88fd0c0ee7d509a;
module.exports["createSkillAdf"] = $57d7e56ed333ab64$export$a425ebfe740d9932;

});

parcelRegister("fOp0R", function(module, exports) {

var $bUA3T = parcelRequire("bUA3T");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/jira/site/manifest.ts
var $b82eed94c40664a5$var$jiraSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $bUA3T.JiraSiteAriResourceOwner),
    resourceType: (0, $bUA3T.JiraSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/jira/site/index.ts
var $b82eed94c40664a5$export$6c0f81f222d09301 = class _JiraSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $b82eed94c40664a5$var$jiraSiteAriStaticOpts.qualifier,
            platformQualifier: $b82eed94c40664a5$var$jiraSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $b82eed94c40664a5$var$jiraSiteAriStaticOpts.resourceOwner,
            resourceType: $b82eed94c40664a5$var$jiraSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $b82eed94c40664a5$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $b82eed94c40664a5$var$jiraSiteAriStaticOpts);
        return new _JiraSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["JiraSiteAri"] = $b82eed94c40664a5$export$6c0f81f222d09301;

});

parcelRegister("bUA3T", function(module, exports) {
// src/jira/site/types.ts
var $8ac0e5c8b2cbf8ed$export$b7d590981b504412 = "jira", $8ac0e5c8b2cbf8ed$export$886165a991f21644 = "site";
module.exports["JiraSiteAriResourceOwner"] = $8ac0e5c8b2cbf8ed$export$b7d590981b504412;
module.exports["JiraSiteAriResourceType"] = $8ac0e5c8b2cbf8ed$export$886165a991f21644;

});

parcelRegister("9Ha4j", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $29e11ce05e624c9c$var$svg = `<svg height="100%" viewBox="0 0 24 24">
    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>
    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>
</svg>
`;
const $29e11ce05e624c9c$export$3f95fcfdc25a741d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GuardIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Guard" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $29e11ce05e624c9c$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function GuardIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Guard', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $29e11ce05e624c9c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["GuardIcon"] = $29e11ce05e624c9c$export$3f95fcfdc25a741d;

});

parcelRegister("6ojvx", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hBxDy = parcelRequire("hBxDy");

const $59e5036a3fbf2e2e$export$6a671bebd9daad64 = (0, $cozmU.createContext)((0, $hBxDy.ProductEnvironment).PRODUCTION);
module.exports["EnvironmentContext"] = $59e5036a3fbf2e2e$export$6a671bebd9daad64;

});

parcelRegister("hBxDy", function(module, exports) {
var $77348f0599087222$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $77348f0599087222$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $77348f0599087222$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $77348f0599087222$export$beaef1891b3e7ca3;

});

parcelRegister("ix7El", function(module, exports) {
var $04c5b557f78447f3$export$d76ef0f862d061a6 = /*#__PURE__*/ function(GQLExtensionContextsFilterType) {
    GQLExtensionContextsFilterType["Container"] = "CONTAINER";
    GQLExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    GQLExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    GQLExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    GQLExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    return GQLExtensionContextsFilterType;
}({});
const $04c5b557f78447f3$export$1a949ef92fd30eca = (error)=>{
    return error instanceof Error && error.name === 'RelayNetwork' && 'source' in error && Array.isArray(error.source?.errors);
};
const $04c5b557f78447f3$export$8d1c210bc17223c1 = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'GRAPHQL_GATEWAY';
const $04c5b557f78447f3$export$9c0545f564a8227f = (err)=>err.extensions && err.extensions.errorSource && err.extensions.errorSource === 'UNDERLYING_SERVICE';
module.exports["GQLExtensionContextsFilterType"] = $04c5b557f78447f3$export$d76ef0f862d061a6;
module.exports["isRelayNetworkError"] = $04c5b557f78447f3$export$1a949ef92fd30eca;
module.exports["isGQLGatewayError"] = $04c5b557f78447f3$export$8d1c210bc17223c1;
module.exports["isGQLUnderlyingServiceError"] = $04c5b557f78447f3$export$9c0545f564a8227f;

});

parcelRegister("4K6lC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $3d3WW = parcelRequire("3d3WW");

const $a3a18abb8f8abee5$export$d28801614368e543 = 'forge-ui';
const $a3a18abb8f8abee5$export$7329bcdc3edcd90e = (client)=>(event)=>{
        switch(event.eventType){
            case 0, $852mP.UI_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendUIEvent(event));
                break;
            case 0, $852mP.OPERATIONAL_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendOperationalEvent(event));
                break;
            case 0, $852mP.TRACK_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendTrackEvent(event));
                break;
            case 0, $852mP.SCREEN_EVENT_TYPE:
                Promise.resolve(client).then((c)=>c.sendScreenEvent(event));
                break;
        }
    };
/** extract the attributes from event context which should be in the top-level payload */ function $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(contexts) {
    return (contexts.find((obj)=>obj && obj.forgeUIAnalyticsContext) ?? {}).forgeUIAnalyticsContext ?? {};
}
// Merge forgeUIAttributes from outermost to innermost analytics contexts, so child contexts can
// override parent values in the final payload. If an inner context replaces extensionKey, keep the
// previous extensionKey separately so embedded macro events can report it as parentExtensionKey.
function $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(contexts) {
    return contexts.reduce((prev, curr)=>{
        // Only extract attributes passed as an object via the forgeUIAttributes key
        const forgeUIAttributes = curr && curr.forgeUIAttributes && typeof curr.forgeUIAttributes === 'object' ? curr.forgeUIAttributes : {};
        const previousExtensionKey = prev.forgeUIAttributes.extensionKey;
        const nextExtensionKey = forgeUIAttributes.extensionKey;
        const isExtensionKeyOverridden = Boolean(previousExtensionKey && nextExtensionKey && previousExtensionKey !== nextExtensionKey);
        // Capture the first extensionKey that gets replaced by a nested context. That replaced
        // value is the parent macro key once a child renderer context contributes its own key.
        const overriddenExtensionKey = prev.overriddenExtensionKey ?? (isExtensionKeyOverridden ? previousExtensionKey : undefined);
        return {
            forgeUIAttributes: {
                ...prev.forgeUIAttributes,
                ...forgeUIAttributes
            },
            overriddenExtensionKey: overriddenExtensionKey
        };
    }, {
        forgeUIAttributes: {}
    });
}
const $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, client: client, commonAttributes: t1 } = t0;
    let t2;
    if ($[0] !== t1) {
        t2 = t1 === undefined ? {} : t1;
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const commonAttributes = t2;
    let t3;
    if ($[2] !== client || $[3] !== commonAttributes) {
        t3 = (event)=>{
            const { eventType: eventType, data: data } = event.payload;
            const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
            const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
            const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? "unknown";
            const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
            let parentExtensionKey = {};
            if (action === "rendered" && actionSubject === "forge.ui.renderer" && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) parentExtensionKey = {
                parentExtensionKey: overriddenExtensionKey
            };
            else if (action === "rendered" && actionSubject === "forge.ui.bodied_macro_embedded_content" && attributes?.extensionKey && forgeUIAttributes.extensionKey) parentExtensionKey = {
                parentExtensionKey: forgeUIAttributes.extensionKey
            };
            const nestingAnalyticsAttributes = {
                ...forgeUIAttributes,
                ...parentExtensionKey
            };
            const payload = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                ...forgeUIAnalyticsContext,
                source: source,
                attributes: {
                    ...commonAttributes,
                    ...nestingAnalyticsAttributes,
                    ...attributes
                },
                tags: tags
            };
            $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
                eventType: eventType,
                ...payload
            });
        };
        $[2] = client;
        $[3] = commonAttributes;
        $[4] = t3;
    } else t3 = $[4];
    const listenerHandler = t3;
    let t4;
    if ($[5] !== children || $[6] !== listenerHandler) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
            onEvent: listenerHandler,
            channel: $a3a18abb8f8abee5$export$d28801614368e543
        }, children);
        $[5] = children;
        $[6] = listenerHandler;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : ({ children: children, client: client, commonAttributes: commonAttributes = {} })=>{
    const listenerHandler = (event)=>{
        const { eventType: eventType, data: data } = event.payload;
        const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes, tags: tags, source: sourceFromEvent } = data;
        const forgeUIAnalyticsContext = $a3a18abb8f8abee5$var$getPayloadAttributesFromContext(event.context);
        const source = sourceFromEvent ?? forgeUIAnalyticsContext.source ?? 'unknown';
        // Use the merged nested context attributes and add parentExtensionKey for embedded macro
        // events that override extensionKey.
        const { forgeUIAttributes: forgeUIAttributes, overriddenExtensionKey: overriddenExtensionKey } = $a3a18abb8f8abee5$var$getForgeUIAttributesFromContext(event.context);
        let parentExtensionKey = {};
        if (action === 'rendered' && actionSubject === 'forge.ui.renderer' && forgeUIAttributes.isEmbeddedMacro && overriddenExtensionKey) // Child Forge renderer contexts replace extensionKey with the child macro key, so the
        // parent key is the previous extensionKey captured during context merging.
        parentExtensionKey = {
            parentExtensionKey: overriddenExtensionKey
        };
        else if (action === 'rendered' && actionSubject === 'forge.ui.bodied_macro_embedded_content' && attributes?.extensionKey && forgeUIAttributes.extensionKey) // Embedded macro events carry the child macro key on the event attributes, while the
        // surrounding context still carries the parent macro extensionKey.
        parentExtensionKey = {
            parentExtensionKey: forgeUIAttributes.extensionKey
        };
        const nestingAnalyticsAttributes = {
            ...forgeUIAttributes,
            ...parentExtensionKey
        };
        const payload = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            ...forgeUIAnalyticsContext,
            source: source,
            attributes: {
                ...commonAttributes,
                ...nestingAnalyticsAttributes,
                ...attributes
            },
            tags: tags
        };
        $a3a18abb8f8abee5$export$7329bcdc3edcd90e(client)({
            eventType: eventType,
            ...payload
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: listenerHandler,
        channel: $a3a18abb8f8abee5$export$d28801614368e543
    }, children);
};
var $a3a18abb8f8abee5$export$2e2bcd8739ae039 = $a3a18abb8f8abee5$var$ForgeUIAnalyticsListener;
module.exports["FORGE_UI_ANALYTICS_CHANNEL"] = $a3a18abb8f8abee5$export$d28801614368e543;
module.exports["sendEvent"] = $a3a18abb8f8abee5$export$7329bcdc3edcd90e;
module.exports["default"] = $a3a18abb8f8abee5$export$2e2bcd8739ae039;

});

parcelRegister("DIyeF", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $6ojvx = parcelRequire("6ojvx");

const $5577a309d6f3499e$export$b438ce9ad9530ae5 = /*#__PURE__*/ (0, $cozmU.createContext)({
    environment: undefined,
    product: '',
    page: ''
});
const $5577a309d6f3499e$export$163ecee29aa3a8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { value: value, children: children } = t0;
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    let t1;
    let t2;
    if ($[0] !== envFromContext || $[1] !== environment || $[2] !== page || $[3] !== product) {
        t1 = ()=>({
                environment: environment ?? envFromContext,
                product: product,
                page: page
            });
        t2 = [
            page,
            environment,
            envFromContext,
            product
        ];
        $[0] = envFromContext;
        $[1] = environment;
        $[2] = page;
        $[3] = product;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    const memoedValue = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== memoedValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
            value: memoedValue
        }, children);
        $[6] = children;
        $[7] = memoedValue;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ value: value, children: children })=>{
    const envFromContext = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
    const { product: product, page: page, environment: environment } = value;
    const memoedValue = (0, $5xQdV.useMemoOne)(()=>{
        return {
            environment: environment ?? envFromContext,
            product: product,
            page: page
        };
    }, [
        page,
        environment,
        envFromContext,
        product
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5577a309d6f3499e$export$b438ce9ad9530ae5.Provider, {
        value: memoedValue
    }, children);
};
const $5577a309d6f3499e$export$dba2dab0d0f39612 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
} : ()=>{
    return (0, $cozmU.useContext)($5577a309d6f3499e$export$b438ce9ad9530ae5);
};
module.exports["MetricsContext"] = $5577a309d6f3499e$export$b438ce9ad9530ae5;
module.exports["MetricsContextProvider"] = $5577a309d6f3499e$export$163ecee29aa3a8f;
module.exports["useMetricsContext"] = $5577a309d6f3499e$export$dba2dab0d0f39612;

});

parcelRegister("iGKcz", function(module, exports) {
// our service
const $fa265340e5382bcc$var$SERVICE = 'forge-ui';
const $fa265340e5382bcc$export$14ef296862e3705e = (workspaceAri)=>{
    return JSON.stringify({
        atlWorkspaceAri: workspaceAri,
        service: $fa265340e5382bcc$var$SERVICE
    });
};
module.exports["createAtlAttributionHeader"] = $fa265340e5382bcc$export$14ef296862e3705e;

});

parcelRegister("2rD5H", function(module, exports) {

var $iLX84 = parcelRequire("iLX84");


var $iDrrr = parcelRequire("iDrrr");

const $2571750a7eec7dec$var$convertDataClassificationTagsToString = (dataClassificationTagIds)=>{
    return `[
    ${dataClassificationTagIds.map((id)=>`"${id}"`).join(', ')}
  ]`;
};
const $2571750a7eec7dec$export$b4649e379af92913 = (expandAppOwner, moduleTypes, dataClassificationTagIds)=>{
    const modules = moduleTypes?.map((m)=>`"${m}"`) || [
        '$type'
    ];
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!${moduleTypes ? '' : ', $type: String!'}, $locale: String) {
    extensionContexts(contextIds: $contextIds) {
      id
      ${modules.map((m)=>`
        extensionsByType(type: ${m}, locale: $locale ) {
          id
          appId
          key
          ${expandAppOwner ? `appOwner {
            name
          }` : ''}
          environmentId
          environmentType
          environmentKey
          properties
          license {
            active
            type
            supportEntitlementNumber
            trialEndDate
            subscriptionEndDate
            isEvaluation
            billingPeriod
            ccpEntitlementId
            ccpEntitlementSlug
						capabilitySet
            modes
          }
          ${userAccessField}
          type
          appVersion
          installationId
          remoteInstallationRegion
          migrationKey
					installationConfig {
						key
						value
					}
          egress {
            type
            addresses
						category
						inScopeEUD
          }
					sandboxPolicies
					scopes
					consentUrl
					currentUserConsent {
						user {
							aaid
						}
						appEnvironmentVersion {
							id
						}
						consentedAt
					}
					requiresUserConsent
          ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
                dataClassificationPolicyDecision(input: {
                  dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
                }) {
                  status
                }
              ` : ''}
        }`).join('')}
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$23f6ad93bea7724 = (expandAppOwner, dataClassificationTagIds)=>{
    const userAccessField = (0, $iDrrr.fg)('platform-forge-ui-useraccess-in-extension-query') ? `userAccess {
    enabled
    hasAccess
  }` : '';
    const query = `
  query forge_ui_extensionList($contextIds: [ID!]!, $filter: [ExtensionContextsFilter!]!, $locale: String ) {
    extensionContexts(contextIds: $contextIds) {
      id
      extensions(filter: $filter, locale: $locale) @optIn(to: "Access-Narrowing") {
        id
        appId
        key
        ${expandAppOwner ? `appOwner {
          name
        }` : ''}
        environmentId
        environmentType
        environmentKey
        properties
        license {
          active
          type
          supportEntitlementNumber
          trialEndDate
          subscriptionEndDate
          isEvaluation
          billingPeriod
          ccpEntitlementId
          ccpEntitlementSlug
					capabilitySet
          modes
        }
        ${userAccessField}
        type
        appVersion
        installationId
        remoteInstallationRegion
        migrationKey
				installationConfig {
					key
					value
				}
        egress {
          type
          addresses
					category
					inScopeEUD
        }
				sandboxPolicies
				scopes
				consentUrl
				currentUserConsent {
					user {
						aaid
					}
					appEnvironmentVersion {
						id
					}
					consentedAt
				}
				requiresUserConsent
        ${dataClassificationTagIds && dataClassificationTagIds.length > 0 ? `
              dataClassificationPolicyDecision(input: {
                dataClassificationTags: ${$2571750a7eec7dec$var$convertDataClassificationTagsToString(dataClassificationTagIds)}
              }) {
                status
              }
            ` : ''}
      },
    }
  }`;
    return (0, $iLX84.default)`${query}`;
};
const $2571750a7eec7dec$export$54ff27488d768aba = (0, $iLX84.default)`query FetchPreFilteredForgeAppsQuery($cloudId:ID!$context:ConfluenceExtensionRenderingContextInput$includeHidden:Boolean$locale:String$types:[String]){confluence_forgeExtensionsByType(cloudId:$cloudId context:$context includeHidden:$includeHidden locale:$locale types:$types){id appId appVersion appOwner environmentId environmentType environmentKey consentUrl migrationKey userAccess{enabled hasAccess}key properties{key value}egress{addresses category type inScopeEUD}sandboxPolicies scopes license{active capabilitySet billingPeriod ccpEntitlementId ccpEntitlementSlug isEvaluation subscriptionEndDate trialEndDate type}type installationId remoteInstallationRegion hiddenBy}}`;
module.exports["getExtensionListQueryOld"] = $2571750a7eec7dec$export$b4649e379af92913;
module.exports["getExtensionListQuery"] = $2571750a7eec7dec$export$23f6ad93bea7724;
module.exports["FetchPreFilteredForgeAppsQuery"] = $2571750a7eec7dec$export$54ff27488d768aba;

});

parcelRegister("hzmpb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $gGKeL = parcelRequire("gGKeL");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $4o0zT = parcelRequire("4o0zT");


var $4K6lC = parcelRequire("4K6lC");


var $DIyeF = parcelRequire("DIyeF");


var $iGKcz = parcelRequire("iGKcz");


var $ix7El = parcelRequire("ix7El");


var $2rD5H = parcelRequire("2rD5H");


var $jGizm = parcelRequire("jGizm");

const $c7be4ab3ad813948$export$7f11ec46a05c7477 = (cloudId, context, client, types, locale, includeHidden, queryOptions, contextIds = [
    cloudId
])=>{
    const variables = {
        cloudId: cloudId,
        context: context,
        includeHidden: includeHidden ?? false,
        types: types,
        locale: locale
    };
    return {
        variables: variables,
        ...queryOptions,
        client: client,
        /**
     * We don't want to set 'ignore' because that discards errors and we need to inspect
     * them for SLI reporting. We also need 'all' so we don't discard data on errors:http://go/j/AUX-317
     * https://www.apollographql.com/docs/react/data/error-handling/
     */ errorPolicy: 'all',
        context: {
            headers: {
                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)([
                    ...contextIds
                ].sort().join())
            },
            allowOnExternalPage: true
        }
    };
};
const $c7be4ab3ad813948$export$88e0391b02a3c5c9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(28);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions } = t0;
    let t1;
    if ($[0] !== client || $[1] !== cloudId || $[2] !== context || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions || $[6] !== types) {
        t1 = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
        $[0] = client;
        $[1] = cloudId;
        $[2] = context;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const requestOptions = t1;
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    let t2;
    if ($[8] !== data || $[9] !== loading) {
        t2 = $c7be4ab3ad813948$export$55348c7eb6377fe1({
            loading: loading,
            data: data
        });
        $[8] = data;
        $[9] = loading;
        $[10] = t2;
    } else t2 = $[10];
    const extensions = t2;
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t3;
    let t4;
    if ($[11] !== createAnalyticsEvent || $[12] !== extensions || $[13] !== page) {
        t3 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t4 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[11] = createAnalyticsEvent;
        $[12] = extensions;
        $[13] = page;
        $[14] = t3;
        $[15] = t4;
    } else {
        t3 = $[14];
        t4 = $[15];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[16] !== createAnalyticsEvent || $[17] !== error || $[18] !== extensions || $[19] !== page) {
        t5 = ()=>{
            if (!extensions && error && error.graphQLErrors.length > 0) {
                const err_0 = error.graphQLErrors.find($c7be4ab3ad813948$var$_temp);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "usePrefilteredExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t6 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = error;
        $[18] = extensions;
        $[19] = page;
        $[20] = t5;
        $[21] = t6;
    } else {
        t5 = $[20];
        t6 = $[21];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[22] !== extensions) {
        t7 = extensions || [];
        $[22] = extensions;
        $[23] = t7;
    } else t7 = $[23];
    let t8;
    if ($[24] !== error || $[25] !== loading || $[26] !== t7) {
        t8 = {
            error: error,
            extensions: t7,
            loading: loading
        };
        $[24] = error;
        $[25] = loading;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    return t8;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, client: client, queryOptions: queryOptions })=>{
    const requestOptions = $c7be4ab3ad813948$export$7f11ec46a05c7477(cloudId, context, client, types, locale, includeHidden, queryOptions);
    const { error: error, loading: loading, data: data } = (0, $7EPz1.useQuery)((0, $2rD5H.FetchPreFilteredForgeAppsQuery), requestOptions);
    const extensions = $c7be4ab3ad813948$export$55348c7eb6377fe1({
        loading: loading,
        data: data
    });
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && error.graphQLErrors.length > 0) {
            const err_0 = error.graphQLErrors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'usePrefilteredExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        error: error,
        extensions: extensions || [],
        loading: loading
    };
};
const $c7be4ab3ad813948$export$55348c7eb6377fe1 = ({ loading: loading, data: data })=>{
    const extensions = data?.confluence_forgeExtensionsByType || [];
    if (!loading && extensions.length > 0) return (0, $jGizm.transformPreFilteredExtensions)(extensions);
    return null;
};
const $c7be4ab3ad813948$var$legacyFetchRequests = new Map();
const $c7be4ab3ad813948$var$fetchRequestsByEnvironment = new WeakMap();
const $c7be4ab3ad813948$export$f55e1916fecb1860 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(33);
    const { cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, queryOptions: queryOptions } = t0;
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== cloudId || $[1] !== context || $[2] !== environment || $[3] !== includeHidden || $[4] !== locale || $[5] !== queryOptions?.skip || $[6] !== types) {
        t1 = ()=>{
            if (queryOptions?.skip && types.includes("confluence:pageBanner") && (0, $4o0zT.isExperimentEnabled)("confluence_ssr_forge_page_banner")) return;
            let fetchRequests = $c7be4ab3ad813948$var$legacyFetchRequests;
            if ((0, $4o0zT.isExperimentEnabled)("confluence_apollo_free_platform_consumers")) {
                const cachedRequests = $c7be4ab3ad813948$var$fetchRequestsByEnvironment.get(environment);
                if (cachedRequests) fetchRequests = cachedRequests;
                else {
                    fetchRequests = new Map();
                    $c7be4ab3ad813948$var$fetchRequestsByEnvironment.set(environment, fetchRequests);
                }
            }
            const cacheKey = JSON.stringify({
                cloudId: cloudId,
                context: context,
                includeHidden: includeHidden,
                locale: locale,
                types: types
            });
            if (!fetchRequests.has(cacheKey)) {
                const extensions_0 = new Promise((resolve, reject)=>{
                    (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                        cloudId: cloudId,
                        context: context,
                        includeHidden: includeHidden,
                        locale: locale,
                        types: types
                    }, {
                        networkCacheConfig: {
                            metadata: {
                                headers: {
                                    "atl-attribution": (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                                },
                                allowOnExternalPage: true
                            }
                        }
                    }).subscribe({
                        next: (data)=>{
                            resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                                data: data,
                                loading: false
                            }));
                        },
                        error: (error_0)=>{
                            fetchRequests.delete(cacheKey);
                            reject(error_0);
                        }
                    });
                });
                fetchRequests.set(cacheKey, extensions_0);
            }
            fetchRequests.get(cacheKey).then((extensions_1)=>{
                setExtensions(extensions_1);
                setLoading(false);
            }).catch((error_1)=>{
                setError(error_1);
                setLoading(false);
            });
        };
        $[0] = cloudId;
        $[1] = context;
        $[2] = environment;
        $[3] = includeHidden;
        $[4] = locale;
        $[5] = queryOptions?.skip;
        $[6] = types;
        $[7] = t1;
    } else t1 = $[7];
    const t2 = queryOptions?.skip;
    let t3;
    if ($[8] !== cloudId || $[9] !== context || $[10] !== environment || $[11] !== includeHidden || $[12] !== locale || $[13] !== t2 || $[14] !== types) {
        t3 = [
            cloudId,
            context,
            includeHidden,
            locale,
            types,
            environment,
            t2
        ];
        $[8] = cloudId;
        $[9] = context;
        $[10] = environment;
        $[11] = includeHidden;
        $[12] = locale;
        $[13] = t2;
        $[14] = types;
        $[15] = t3;
    } else t3 = $[15];
    (0, $cozmU.useEffect)(t1, t3);
    let t4;
    let t5;
    if ($[16] !== createAnalyticsEvent || $[17] !== extensions || $[18] !== page) {
        t4 = ()=>{
            if (extensions) createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: "succeeded",
                    actionSubject: "forge.ui.webClient",
                    source: page,
                    tags: [
                        "forge"
                    ],
                    attributes: {
                        target: "usePrefilteredExtensionList"
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        };
        t5 = [
            extensions,
            page,
            createAnalyticsEvent
        ];
        $[16] = createAnalyticsEvent;
        $[17] = extensions;
        $[18] = page;
        $[19] = t4;
        $[20] = t5;
    } else {
        t4 = $[19];
        t5 = $[20];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    let t7;
    if ($[21] !== createAnalyticsEvent || $[22] !== error || $[23] !== extensions || $[24] !== page) {
        t6 = ()=>{
            if (!extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
                const err_0 = error.source.errors.find($c7be4ab3ad813948$var$_temp2);
                createAnalyticsEvent({
                    eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                    data: {
                        action: "failed",
                        actionSubject: "forge.ui.webClient",
                        source: page,
                        tags: [
                            "forge"
                        ],
                        attributes: {
                            target: "useExtensionList",
                            errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? "componentApi" : "componentGraphQL" : "uncaught"
                        }
                    }
                }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
            }
        };
        t7 = [
            extensions,
            error,
            page,
            createAnalyticsEvent
        ];
        $[21] = createAnalyticsEvent;
        $[22] = error;
        $[23] = extensions;
        $[24] = page;
        $[25] = t6;
        $[26] = t7;
    } else {
        t6 = $[25];
        t7 = $[26];
    }
    (0, $cozmU.useEffect)(t6, t7);
    let t8;
    if ($[27] !== extensions) {
        t8 = extensions || [];
        $[27] = extensions;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== error || $[30] !== loading || $[31] !== t8) {
        t9 = {
            extensions: t8,
            loading: loading,
            error: error
        };
        $[29] = error;
        $[30] = loading;
        $[31] = t8;
        $[32] = t9;
    } else t9 = $[32];
    return t9;
} : ({ cloudId: cloudId, context: context, includeHidden: includeHidden, locale: locale, types: types, queryOptions: queryOptions })=>{
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const [extensions, setExtensions] = (0, $cozmU.useState)(null);
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const [error, setError] = (0, $cozmU.useState)(undefined);
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (queryOptions?.skip && types.includes('confluence:pageBanner') && (0, $4o0zT.isExperimentEnabled)('confluence_ssr_forge_page_banner')) return;
        let fetchRequests = $c7be4ab3ad813948$var$legacyFetchRequests;
        if ((0, $4o0zT.isExperimentEnabled)('confluence_apollo_free_platform_consumers')) {
            const cachedRequests = $c7be4ab3ad813948$var$fetchRequestsByEnvironment.get(environment);
            if (cachedRequests) fetchRequests = cachedRequests;
            else {
                fetchRequests = new Map();
                $c7be4ab3ad813948$var$fetchRequestsByEnvironment.set(environment, fetchRequests);
            }
        }
        const cacheKey = JSON.stringify({
            cloudId: cloudId,
            context: context,
            includeHidden: includeHidden,
            locale: locale,
            types: types
        });
        if (!fetchRequests.has(cacheKey)) {
            const extensions_0 = new Promise((resolve, reject)=>{
                (0, $6SsN4.fetchQuery)(environment, (0, $gGKeL.default), {
                    cloudId: cloudId,
                    context: // @ts-ignore - the generated types convert GQL Long to a number, which may truncate the id. The type will be changed to string
                    context,
                    includeHidden: includeHidden,
                    locale: locale,
                    types: types
                }, {
                    networkCacheConfig: {
                        metadata: {
                            headers: {
                                'atl-attribution': (0, $iGKcz.createAtlAttributionHeader)(cloudId)
                            },
                            allowOnExternalPage: true
                        }
                    }
                }).subscribe({
                    next: (data)=>{
                        resolve($c7be4ab3ad813948$export$55348c7eb6377fe1({
                            data: data,
                            loading: false
                        }));
                    },
                    error: (error_0)=>{
                        fetchRequests.delete(cacheKey);
                        reject(error_0);
                    }
                });
            });
            fetchRequests.set(cacheKey, extensions_0);
        }
        fetchRequests.get(cacheKey).then((extensions_1)=>{
            setExtensions(extensions_1);
            setLoading(false);
        }).catch((error_1)=>{
            setError(error_1);
            setLoading(false);
        });
    }, [
        cloudId,
        context,
        includeHidden,
        locale,
        types,
        environment,
        queryOptions?.skip
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (extensions) createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'succeeded',
                actionSubject: 'forge.ui.webClient',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'usePrefilteredExtensionList'
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }, [
        extensions,
        page,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (// if hydration of appOwners (non-critical data) fails but we still have the extensions,
        // we shouldn't count this as a bad event
        !extensions && error && (0, $ix7El.isRelayNetworkError)(error)) {
            const err_0 = error.source.errors.find((err)=>(0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err));
            createAnalyticsEvent({
                eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
                data: {
                    action: 'failed',
                    actionSubject: 'forge.ui.webClient',
                    source: page,
                    tags: [
                        'forge'
                    ],
                    attributes: {
                        target: 'useExtensionList',
                        errorName: err_0 ? (0, $ix7El.isGQLUnderlyingServiceError)(err_0) ? 'componentApi' : 'componentGraphQL' : 'uncaught'
                    }
                }
            }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
        }
    }, [
        extensions,
        error,
        page,
        createAnalyticsEvent
    ]);
    return {
        extensions: extensions || [],
        loading: loading,
        error: error
    };
};
function $c7be4ab3ad813948$var$_temp(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
function $c7be4ab3ad813948$var$_temp2(err) {
    return (0, $ix7El.isGQLUnderlyingServiceError)(err) || (0, $ix7El.isGQLGatewayError)(err);
}
module.exports["createUsePrefilteredExtensionListQueryOptions"] = $c7be4ab3ad813948$export$7f11ec46a05c7477;
module.exports["usePrefilteredExtensionList"] = $c7be4ab3ad813948$export$88e0391b02a3c5c9;
module.exports["getPrefilteredExtensionsGQLResult"] = $c7be4ab3ad813948$export$55348c7eb6377fe1;
module.exports["usePrefilteredExtensionListRelay"] = $c7be4ab3ad813948$export$f55e1916fecb1860;

});

parcelRegister("gGKeL", function(module, exports) {
/**
 * @generated SignedSource<<7da5a0cc59e307e949d5c921ecd41a2b>>
 * @relayHash ae8c0df8b458c191f8dbdc3067c4d451
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f5629fcf1f358b362aa590d439d2c0b3b1226aeff22ab5c3341f879647bc9d2c
const $57d2af88a889106f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "context"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeHidden"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locale"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "types"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "key"
    }, v2 = {
        "kind": "ScalarField",
        "name": "type"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "context",
                    "variableName": "context"
                },
                {
                    "kind": "Variable",
                    "name": "includeHidden",
                    "variableName": "includeHidden"
                },
                {
                    "kind": "Variable",
                    "name": "locale",
                    "variableName": "locale"
                },
                {
                    "kind": "Variable",
                    "name": "types",
                    "variableName": "types"
                }
            ],
            "concreteType": "ConfluenceForgeExtension",
            "kind": "LinkedField",
            "name": "confluence_forgeExtensionsByType",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "appId"
                },
                {
                    "kind": "ScalarField",
                    "name": "appVersion"
                },
                {
                    "kind": "ScalarField",
                    "name": "appOwner"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentId"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentType"
                },
                {
                    "kind": "ScalarField",
                    "name": "environmentKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "consentUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "migrationKey"
                },
                {
                    "concreteType": "ConfluenceUserAccess",
                    "kind": "LinkedField",
                    "name": "userAccess",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "enabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hasAccess"
                        }
                    ]
                },
                v1 /*: any*/ ,
                {
                    "concreteType": "KeyValueHierarchyMap",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "ConfluenceExtensionEgressDeclaration",
                    "kind": "LinkedField",
                    "name": "egress",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "addresses"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "category"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "inScopeEUD"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "sandboxPolicies"
                },
                {
                    "kind": "ScalarField",
                    "name": "scopes"
                },
                {
                    "concreteType": "ConfluenceAppInstallationLicense",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "active"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "capabilitySet"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "billingPeriod"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "ccpEntitlementSlug"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEvaluation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "subscriptionEndDate"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "trialEndDate"
                        },
                        v2 /*: any*/ 
                    ]
                },
                v2 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "installationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "remoteInstallationRegion"
                },
                {
                    "kind": "ScalarField",
                    "name": "hiddenBy"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "id": "f5629fcf1f358b362aa590d439d2c0b3b1226aeff22ab5c3341f879647bc9d2c",
            "metadata": {},
            "name": "usePrefilteredExtensionList_forge_ui_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$57d2af88a889106f$var$node.hash = "9988fba56919e313afdb928b7bdb852d";
var $57d2af88a889106f$export$2e2bcd8739ae039 = $57d2af88a889106f$var$node;
module.exports["default"] = $57d2af88a889106f$export$2e2bcd8739ae039;

});

parcelRegister("bLswh", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);
parcelRequire("9iaDP");
var $hBxDy = parcelRequire("hBxDy");

parcelRequire("gwrSD");
var $hcYP2 = parcelRequire("hcYP2");
var $31kME = parcelRequire("31kME");
var $d8yi8 = parcelRequire("d8yi8");


});

parcelRegister("9iaDP", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("hBxDy")).ProductEnvironment);

var $2y56N = parcelRequire("2y56N");


var $hBxDy = parcelRequire("hBxDy");


var $iztBQ = parcelRequire("iztBQ");


var $2zscg = parcelRequire("2zscg");


});

parcelRegister("2y56N", function(module, exports) {
const $43f88a3108220757$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $43f88a3108220757$export$3ee8c58bb87b9685 = [
    ...$43f88a3108220757$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];

});

parcelRegister("iztBQ", function(module, exports) {
const $6db1db68019c99c9$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("gwrSD", function(module, exports) {

var $d8yi8 = parcelRequire("d8yi8");


var $31kME = parcelRequire("31kME");


var $hcYP2 = parcelRequire("hcYP2");


});

parcelRegister("d8yi8", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $487f0b3478e8e725$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $487f0b3478e8e725$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $487f0b3478e8e725$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $487f0b3478e8e725$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $487f0b3478e8e725$export$20b9f6acb0888554(effect) {
    return $487f0b3478e8e725$export$7e816460364ed464(effect) || $487f0b3478e8e725$export$eb5bd7f371e458af(effect) || $487f0b3478e8e725$export$f632ad3064955f31(effect);
}

});

parcelRegister("31kME", function(module, exports) {
const $7d3783c6a9539d7e$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $7d3783c6a9539d7e$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $7d3783c6a9539d7e$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $7d3783c6a9539d7e$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $7d3783c6a9539d7e$export$caa8cab0db5b0a61(effect) {
    return $7d3783c6a9539d7e$export$65d7078e01574f24(effect) || $7d3783c6a9539d7e$export$709a27a9f80556b8(effect) || $7d3783c6a9539d7e$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("hcYP2", function(module, exports) {
// From forge.ts
const $1da5394af23f0a63$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $1da5394af23f0a63$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $1da5394af23f0a63$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $1da5394af23f0a63$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $1da5394af23f0a63$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $1da5394af23f0a63$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $1da5394af23f0a63$export$881df9824c17587a = (extensionContext)=>extensionContext.type === 'confluence:attachmentAction';
const $1da5394af23f0a63$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $1da5394af23f0a63$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $1da5394af23f0a63$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $1da5394af23f0a63$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $1da5394af23f0a63$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("4ewzf", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4K6lC = parcelRequire("4K6lC");


var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");

const $4d5d83f604ebdb2f$export$64f0f7e9be5f8ff = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(15);
    const { analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children } = t0;
    let t1;
    if ($[0] !== page || $[1] !== product) {
        t1 = {
            product: product,
            page: page
        };
        $[0] = page;
        $[1] = product;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== page) {
        t2 = {
            moduleType: page
        };
        $[3] = page;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== analyticsWebClient || $[6] !== children || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K6lC.default), {
            client: analyticsWebClient,
            commonAttributes: t2
        }, children);
        $[5] = analyticsWebClient;
        $[6] = children;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t1 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $DIyeF.MetricsContextProvider), {
            value: t1
        }, t3);
        $[9] = t1;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== environment || $[13] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ojvx.EnvironmentContext).Provider, {
            value: environment
        }, t4);
        $[12] = environment;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
} : ({ analyticsWebClient: analyticsWebClient, environment: environment, product: product, page: page, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ojvx.EnvironmentContext).Provider, {
        value: environment
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $DIyeF.MetricsContextProvider), {
        value: {
            product: product,
            page: page
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K6lC.default), {
        client: analyticsWebClient,
        commonAttributes: {
            moduleType: page
        }
    }, children)));
};
module.exports["ForgeUIExtensionPointProvider"] = $4d5d83f604ebdb2f$export$64f0f7e9be5f8ff;

});

parcelRegister("9cGsb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fbwmZ = parcelRequire("fbwmZ");


var $bAWmc = parcelRequire("bAWmc");


$fbwmZ.__exportStar((parcelRequire("5ixmT")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $6b362a72760d8152$var$InvalidAriError extends Error {
    /**
   * Construct an InvalidAriError given some constraint violations
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
   */ static withConstraintViolations(ariString, violations) {
        return new $6b362a72760d8152$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $6b362a72760d8152$var$InvalidAriError.prototype);
    }
}
module.exports.InvalidAriError = $6b362a72760d8152$var$InvalidAriError;
function $6b362a72760d8152$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $6b362a72760d8152$var$basicCharConstraint = $bAWmc.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $6b362a72760d8152$var$resourceTypeCharConstraints = $bAWmc.pattern(/^[a-z][a-z.-]*$/i);
const $6b362a72760d8152$var$resourceOwnerConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$basicCharConstraint
];
const $6b362a72760d8152$var$resourceTypeConstraints = [
    $bAWmc.lengthBetween(3, 255),
    $6b362a72760d8152$var$resourceTypeCharConstraints
];
const $6b362a72760d8152$var$cloudIdConstraints = [
    $bAWmc.lengthBetween(3, 255)
];
const $6b362a72760d8152$var$siteResourceType = 'site';
const $6b362a72760d8152$var$resourceIdChars = /[\w-._~:@#]/.source;
const $6b362a72760d8152$var$resourceIdConstraints = [
    $bAWmc.pattern(new RegExp(`^${$6b362a72760d8152$var$resourceIdChars}+(/${$6b362a72760d8152$var$resourceIdChars}*)*(;v=${$6b362a72760d8152$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $6b362a72760d8152$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $6b362a72760d8152$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $6b362a72760d8152$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $6b362a72760d8152$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
  * Parse a string as an Ari
  *
  * @param {string} ariString - the string to parse
  * @returns {Ari} the parsed ari
  * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
  */ static parse(ariString) {
        if (!ariString) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $6b362a72760d8152$var$InvalidAriError(ariString);
        return new $6b362a72760d8152$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $6b362a72760d8152$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
   * Converts this Ari to a string.
   */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $6b362a72760d8152$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $6b362a72760d8152$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
   * Converts this object to its json representation
   */ toJSON() {
        return this.toString();
    }
    /**
   * Checks if this context is the same as another context
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
   */ equals(other) {
        return other instanceof $6b362a72760d8152$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
   * This method checks if the current context contains the other context.
   *
   * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
   * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
   *
   * @param {Ari} other
   * @returns {boolean}
   */ contains(other) {
        return this.matches(new $6b362a72760d8152$var$ResourceIdentifier(other));
    }
    /**
   * Checks if this context is the same as or contains the provided context.
   *
   * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
   *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
   *
   * e.g.
   * ```
   * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
   * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
   *
   * @param {Ari} other - the other parameter to match with
   * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
   */ matches(other) {
        return $6b362a72760d8152$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $6b362a72760d8152$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $6b362a72760d8152$var$siteResourceType && !!other.resourceType || $6b362a72760d8152$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $6b362a72760d8152$var$siteResourceType && !cloudId) return new $bAWmc.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $bAWmc.validateField(this, 'resourceOwner', $6b362a72760d8152$var$resourceOwnerConstraints),
            $bAWmc.validateField(this, 'resourceType', $6b362a72760d8152$var$resourceTypeConstraints),
            $bAWmc.validateField(this, 'resourceId', $6b362a72760d8152$var$resourceIdConstraints),
            $bAWmc.validateField(this, 'cloudId', $6b362a72760d8152$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $6b362a72760d8152$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $6b362a72760d8152$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
    /**
   * Create a new Ari
   *
   * Only the resourceOwner is a required field, any other field can be omitted.
   * Older format types are converted on creation
   *
   * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
   * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
   * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
   * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
   *
   * @throws {InvalidAriError} if the provided segments fail to pass validation
   */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $6b362a72760d8152$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
}
module.exports.ResourceIdentifier = $6b362a72760d8152$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parse(ariString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $6b362a72760d8152$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $6b362a72760d8152$var$parseEncoded(encodedAriString) {
    return $6b362a72760d8152$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $6b362a72760d8152$var$parseEncoded;

});

parcelRegister("bAWmc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gkGWr = parcelRequire("gkGWr");

class $871053056dfd3da9$var$LengthConstraint {
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
}
module.exports.LengthConstraint = $871053056dfd3da9$var$LengthConstraint;
class $871053056dfd3da9$var$RegexConstraint {
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
    constructor(regex){
        this.regex = regex;
    }
}
module.exports.RegexConstraint = $871053056dfd3da9$var$RegexConstraint;
class $871053056dfd3da9$var$GeneralValidationError {
    toString() {
        return this.error;
    }
    constructor(error){
        this.error = error;
    }
}
module.exports.GeneralValidationError = $871053056dfd3da9$var$GeneralValidationError;
class $871053056dfd3da9$var$ConstraintViolation {
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
}
module.exports.ConstraintViolation = $871053056dfd3da9$var$ConstraintViolation;
function $871053056dfd3da9$var$lengthBetween(min, max) {
    return new $871053056dfd3da9$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $871053056dfd3da9$var$lengthBetween;
function $871053056dfd3da9$var$pattern(regex) {
    return new $871053056dfd3da9$var$RegexConstraint(regex);
}
module.exports.pattern = $871053056dfd3da9$var$pattern;
function $871053056dfd3da9$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($gkGWr.isDefined);
    return violatedConstraints.length > 0 ? new $871053056dfd3da9$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $871053056dfd3da9$var$validateField;

});

parcelRegister("gkGWr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $be3fd2ee1b486656$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $be3fd2ee1b486656$var$isPresent;
function $be3fd2ee1b486656$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $be3fd2ee1b486656$var$isDefined;
function $be3fd2ee1b486656$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $be3fd2ee1b486656$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $be3fd2ee1b486656$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $be3fd2ee1b486656$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $be3fd2ee1b486656$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $be3fd2ee1b486656$var$hasValueAtKey; //# sourceMappingURL=index.js.map

});

parcelRegister("5ixmT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $199iK = parcelRequire("199iK");

var $3db8846e4ba8de9f$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($3db8846e4ba8de9f$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $3db8846e4ba8de9f$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $3db8846e4ba8de9f$var$AppFamilyAriError;
class $3db8846e4ba8de9f$var$NotAppFamilyAriError extends $3db8846e4ba8de9f$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $3db8846e4ba8de9f$var$NotAppFamilyAriError;
class $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError extends $3db8846e4ba8de9f$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $3db8846e4ba8de9f$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $3db8846e4ba8de9f$var$parseAppAri(ari) {
    return $199iK.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $3db8846e4ba8de9f$var$parseAppAri;
function $3db8846e4ba8de9f$var$createAppAri(json) {
    return new $199iK.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $3db8846e4ba8de9f$var$createAppAri;

});

parcelRegister("199iK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5ixmT = parcelRequire("5ixmT");


var $9cGsb = parcelRequire("9cGsb");


var $bAWmc = parcelRequire("bAWmc");

const $0d5dd8c916c95343$var$versionPrefix = ';v=';
const $0d5dd8c916c95343$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $0d5dd8c916c95343$var$uuidConstraints = [
    $bAWmc.pattern(new RegExp(`^${$0d5dd8c916c95343$var$uuidRegExpString}$`, 'i'))
];
const $0d5dd8c916c95343$var$extensionGroupIdConstraints = [
    $bAWmc.pattern(new RegExp(`^(${$0d5dd8c916c95343$var$uuidRegExpString}|static)$`, 'i'))
];
class $0d5dd8c916c95343$var$AppFamilyAriImpl {
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $5ixmT.AppFamilyAri.resourceOwner) throw new $5ixmT.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$5ixmT.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $5ixmT.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $5ixmT.NotAppFamilyAriError(ari, `resourceType must be one of ${$5ixmT.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $5ixmT.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($0d5dd8c916c95343$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($0d5dd8c916c95343$var$versionPrefix) > versionIndex) throw new $5ixmT.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($0d5dd8c916c95343$var$versionPrefix);
        const segments = mainResourceId.split('/').map($0d5dd8c916c95343$var$stripToUndefined);
        if (segments.length > 4) throw new $5ixmT.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $5ixmT.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType || resourceType === $5ixmT.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $5ixmT.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$5ixmT.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $5ixmT.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$5ixmT.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $5ixmT.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$5ixmT.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $5ixmT.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $5ixmT.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$5ixmT.AppFamilyAri.environmentResourceType}`);
        return new $0d5dd8c916c95343$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $5ixmT.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $bAWmc.validateField(this, 'environmentId', $0d5dd8c916c95343$var$uuidConstraints),
            $bAWmc.validateField(this, 'appId', $0d5dd8c916c95343$var$uuidConstraints),
            $bAWmc.validateField(this, 'extensionGroupId', $0d5dd8c916c95343$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $9cGsb.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $5ixmT.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$0d5dd8c916c95343$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $9cGsb.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $5ixmT.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
    constructor(json){
        this.json = json;
        this.validate();
    }
}
module.exports.AppFamilyAriImpl = $0d5dd8c916c95343$var$AppFamilyAriImpl;
function $0d5dd8c916c95343$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});

parcelRegister("2qJQZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hMaHH = parcelRequire("hMaHH");


var $4hmAW = parcelRequire("4hmAW");

const $f3e0d6c6400f29a4$var$PageObject = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PageObject(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { label: t1, size: size, testId: testId } = t0;
    const label = t1 === undefined ? "Page" : t1;
    let t2;
    if ($[0] !== label || $[1] !== size || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
            label: label,
            size: size,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            color: "var(--ds-icon-accent-blue, #357DE8)"
        });
        $[0] = label;
        $[1] = size;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function PageObject({ label: label = 'Page', size: size, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4hmAW.default), {
        label: label,
        size: size,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        color: "var(--ds-icon-accent-blue, #357DE8)"
    });
};
var $f3e0d6c6400f29a4$export$2e2bcd8739ae039 = $f3e0d6c6400f29a4$var$PageObject;
module.exports["default"] = $f3e0d6c6400f29a4$export$2e2bcd8739ae039;

});

parcelRegister("8BldL", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $f1df1ad831df9f5a$export$6107f09ca09b8b5f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    embeddedParentModalKey: undefined,
    setEmbeddedParentModalKey: ()=>{},
    forwarder: ()=>Promise.resolve()
});
module.exports["EmbeddedModalContext"] = $f1df1ad831df9f5a$export$6107f09ca09b8b5f;

});

parcelRegister("eLuPt", function(module, exports) {
/* ForgeErrorBoundary.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $852mP = parcelRequire("852mP");


var $9DHhW = parcelRequire("9DHhW");


var $1VhsF = parcelRequire("1VhsF");


var $4K6lC = parcelRequire("4K6lC");


var $6ojvx = parcelRequire("6ojvx");

var $DIyeF = parcelRequire("DIyeF");


var $h48r4 = parcelRequire("h48r4");


var $k26hW = parcelRequire("k26hW");

function $b57f2c4814ca99d9$var$_defineProperty(e, r, t) {
    return (r = $b57f2c4814ca99d9$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $b57f2c4814ca99d9$var$_toPropertyKey(t) {
    var i = $b57f2c4814ca99d9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $b57f2c4814ca99d9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class $b57f2c4814ca99d9$var$ForgeErrorBoundary extends (0, $cozmU.Component) {
    componentDidCatch(error, errorInfo) {
        this.setState({
            thrownError: {
                error: error,
                errorInfo: errorInfo
            }
        });
        const { page: page } = this.props;
        const environment = this.props.environment;
        (0, $h48r4.captureAndReportError)({
            error: error,
            errorExtensionDetails: this.props.extension ? {
                type: this.props.extension.type,
                environmentType: this.props.extension.environmentType,
                appOwnerAccountId: this.props.extension.appOwner?.accountId,
                properties: this.props.extension.properties,
                id: this.props.extension?.id
            } : undefined,
            errorInfo: errorInfo,
            page: page,
            environment: environment
        });
        if (!(error instanceof (0, $k26hW.APIError))) this.props.createAnalyticsEvent({
            eventType: (0, $852mP.OPERATIONAL_EVENT_TYPE),
            data: {
                action: 'failed',
                actionSubject: 'forge.ui.renderer',
                source: page,
                tags: [
                    'forge'
                ],
                attributes: {
                    target: 'errorBoundary',
                    errorName: error.name
                }
            }
        }).fire((0, $4K6lC.FORGE_UI_ANALYTICS_CHANNEL));
    }
    render() {
        const { thrownError: thrownError } = this.state;
        if (!thrownError) return this.props.children;
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "ForgeErrorBoundary"
        }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "error",
            title: "Error rendering app"
        }, thrownError.error.message));
    }
    constructor(...args){
        super(...args);
        $b57f2c4814ca99d9$var$_defineProperty(this, "state", {
            thrownError: undefined
        });
    }
}
const $b57f2c4814ca99d9$var$withAnalyticsContext = (Component)=>({ extension: extension, children: children })=>{
        const { page: page, environment: envFromContext } = (0, $DIyeF.useMetricsContext)();
        const environment = (0, $cozmU.useContext)((0, $6ojvx.EnvironmentContext));
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
        return /*#__PURE__*/ $cozmU.createElement(Component, {
            environment: envFromContext ?? environment,
            extension: extension,
            page: page,
            createAnalyticsEvent: createAnalyticsEvent
        }, children);
    };
const $b57f2c4814ca99d9$var$_default_1 = $b57f2c4814ca99d9$var$withAnalyticsContext($b57f2c4814ca99d9$var$ForgeErrorBoundary);
var $b57f2c4814ca99d9$export$2e2bcd8739ae039 = $b57f2c4814ca99d9$var$_default_1;
module.exports["default"] = $b57f2c4814ca99d9$export$2e2bcd8739ae039;

});

parcelRegister("k26hW", function(module, exports) {
class $0e4aafd74f221aa2$export$3e5b797e39668f84 extends Error {
    constructor(message){
        super(message);
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $0e4aafd74f221aa2$export$3e5b797e39668f84.prototype);
    }
}
module.exports["APIError"] = $0e4aafd74f221aa2$export$3e5b797e39668f84;

});

parcelRegister("4BZVV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $d5gEx = parcelRequire("d5gEx");


var $8yKod = parcelRequire("8yKod");


var $cIUmi = parcelRequire("cIUmi");


var $fTCJP = parcelRequire("fTCJP");


var $6FQr4 = parcelRequire("6FQr4");


var $DIyeF = parcelRequire("DIyeF");


var $iUEMs = parcelRequire("iUEMs");


var $ix7El = parcelRequire("ix7El");


var $f53nH = parcelRequire("f53nH");


var $lCGo1 = parcelRequire("lCGo1");


var $gKVSw = parcelRequire("gKVSw");


var $8BldL = parcelRequire("8BldL");


var $lWtBU = parcelRequire("lWtBU");


var $4v1ex = parcelRequire("4v1ex");


var $kKOjD = parcelRequire("kKOjD");

let $931bc75652dbffc6$var$cachedPostRobotSend;

const $931bc75652dbffc6$var$getPostRobotSend = ()=>{
    if ($931bc75652dbffc6$var$cachedPostRobotSend !== undefined) $931bc75652dbffc6$var$cachedPostRobotSend;
    if (typeof window === 'undefined') return null;
    try {
        $931bc75652dbffc6$var$cachedPostRobotSend = (parcelRequire("9rzZK")).postRobotSend;
    } catch (_) {
        $931bc75652dbffc6$var$cachedPostRobotSend = null;
    }
    return $931bc75652dbffc6$var$cachedPostRobotSend;
};
// Container for supporting inline macros
const $931bc75652dbffc6$var$MacroExtensionContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { isInline: isInline, children: children } = t0;
    const inlineEnabled = (0, $iDrrr.fg)("platform_forge_ui_embedded_inline_macro") && isInline;
    const t1 = inlineEnabled ? "inline-block" : "block";
    const t2 = inlineEnabled ? "middle" : "";
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            display: t1,
            verticalAlign: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-forge-extension-container": "true",
            "data-testid": "ForgeExtensionContainer",
            style: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ isInline: isInline, children: children })=>{
    const inlineEnabled = (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') && isInline;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-forge-extension-container": "true",
        "data-testid": "ForgeExtensionContainer",
        style: {
            display: inlineEnabled ? 'inline-block' : 'block',
            verticalAlign: inlineEnabled ? 'middle' : ''
        }
    }, children);
};
const $931bc75652dbffc6$var$getLoadingComponent = (loadingComponent)=>{
    if (loadingComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, loadingComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lCGo1.Loader), null);
};
const $931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { extensionId: extensionId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== extensionId || $[2] !== source) {
        t1 = ()=>{
            const { extensionKey: extensionKey } = (0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId);
            (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
                source: source,
                extensionKey: extensionKey
            });
        };
        t2 = [
            createAnalyticsEvent,
            extensionId,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = extensionId;
        $[2] = source;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ extensionId: extensionId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: source } = (0, $DIyeF.useMetricsContext)();
    (0, $cozmU.useEffect)(()=>{
        const { extensionKey: extensionKey } = (0, $cIUmi.extensionIdToAnalyticsAttributes)(extensionId);
        (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
            source: source,
            extensionKey: extensionKey
        });
    }, [
        createAnalyticsEvent,
        extensionId,
        source
    ]);
    return null;
};
const $931bc75652dbffc6$var$EmbeddedMacroRendererInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    const { extensionId: extensionId, contextIds: contextIds, loadingComponent: loadingComponent, createGetContextToken: createGetContextToken, extensionData: extensionData, embeddedParentLocalId: embeddedParentLocalId, localId: localId, extensionPayload: extensionPayload, isInCustomUI: isInCustomUI, embeddedMacroParentType: embeddedMacroParentType, isInline: isInline, isMigrated: isMigrated, entryPoint: entryPoint, customBridge: customBridge, ...rest } = props;
    const [embeddedParentModalKey, setEmbeddedParentModalKey] = (0, $cozmU.useState)(undefined);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            {
                type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    "xen:macro"
                ]
            }
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== contextIds) {
        t1 = {
            contextIds: contextIds,
            filter: t0
        };
        $[1] = contextIds;
        $[2] = t1;
    } else t1 = $[2];
    const { extensions: extensions, loading: loading } = (0, $f53nH.useExtensionListRelay)(t1);
    const extension = extensions?.find((ext)=>ext.id === extensionId);
    const queryCompleted = extensions !== undefined;
    const notInstalled = queryCompleted && !extension && (0, $iDrrr.fg)("platform_validate_embedded_macro_installation");
    if (loading || !queryCompleted) {
        let t2;
        if ($[3] !== loadingComponent) {
            t2 = $931bc75652dbffc6$var$getLoadingComponent(loadingComponent);
            $[3] = loadingComponent;
            $[4] = t2;
        } else t2 = $[4];
        return t2;
    }
    if (notInstalled) {
        let t2;
        if ($[5] !== extensionId) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWtBU.ExtensionNotInstalled), {
                extensionId: extensionId
            });
            $[5] = extensionId;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    if (!extension) return null;
    const contentId = extensionData?.content?.id;
    const resolvedEmbeddedMacroParentType = embeddedMacroParentType ?? (isInCustomUI ? "CustomUI" : "UIKit");
    let getContextToken = props.getContextToken;
    if (createGetContextToken) getContextToken = createGetContextToken(extension);
    else if (getContextToken && (0, $iDrrr.fg)("forge-ui-bridge-core-reset")) {
        const innerGetContextToken = getContextToken;
        getContextToken = (options)=>innerGetContextToken({
                contextIdsOverride: options?.contextIdsOverride ?? contextIds,
                extensionOverride: {
                    extension: extension,
                    localId: localId
                }
            });
    }
    const isEmbeddedUIKitInCustomUI = (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type") ? embeddedMacroParentType === "CustomUI" && !(0, $8yKod.isCustomUI)(extension, entryPoint) : isInCustomUI && !(0, $8yKod.isCustomUI)(extension, entryPoint);
    const embeddedMacroType = (0, $8yKod.isCustomUI)(extension, entryPoint) ? "CustomUI" : "UIKit";
    const t2 = getContextToken;
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type");
        $[7] = t3;
    } else t3 = $[7];
    const forgeRendererProps = {
        ...rest,
        customBridge: customBridge,
        contextIds: contextIds,
        extension: extension,
        loadingComponent: loadingComponent,
        getContextToken: t2,
        extensionData: extensionData,
        embeddedParentLocalId: embeddedParentLocalId,
        localId: localId,
        extensionPayload: extensionPayload,
        entryPoint: entryPoint,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        isEmbeddedMacro: !t3,
        embeddedMacroParentType: (0, $iDrrr.fg)("platform_forge_ui_refactor_macro_parent_type") ? resolvedEmbeddedMacroParentType : undefined,
        height: extension.properties?.viewportSize && (0, $iDrrr.fg)("platform_forge_ui_embedded_inline_macro") ? (0, $gKVSw.calculateViewportSizeHeight)(extension.properties.viewportSize) : undefined
    };
    if (isEmbeddedUIKitInCustomUI && (0, $iDrrr.fg)("platform_forge_ui_uikit_modal_in_custom_ui_parent")) {
        const postRobotSend = $931bc75652dbffc6$var$getPostRobotSend();
        let t4;
        if ($[8] !== customBridge?.setEmbeddedMacroModalForgeDoc) {
            t4 = (0, $iDrrr.fg)("forge-ui-bridge-core-reset") && customBridge?.setEmbeddedMacroModalForgeDoc;
            $[8] = customBridge?.setEmbeddedMacroModalForgeDoc;
            $[9] = t4;
        } else t4 = $[9];
        const uiKitModalForwarder = t4;
        const forwarder = uiKitModalForwarder ? (t5)=>{
            const { data: data } = t5;
            return uiKitModalForwarder(undefined, data);
        } : (0, $iUEMs.createMessageForwarder)("setEmbeddedMacroModalForgeDoc", {
            embeddedMacroExtensionDetails: undefined,
            embeddedMacroLocalId: localId,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            isEmbeddedMacroModal: true,
            sourceAppId: extension?.appId ?? "",
            sourceEnvironmentId: extension?.environmentKey,
            sourceInstallationId: extension?.installationId
        }, postRobotSend, embeddedParentLocalId, {
            appId: extension?.appId ?? "",
            id: extension?.id ?? "",
            installationId: extension?.installationId
        });
        let t6;
        if ($[10] !== embeddedParentModalKey || $[11] !== forwarder) {
            t6 = {
                embeddedParentModalKey: embeddedParentModalKey,
                setEmbeddedParentModalKey: setEmbeddedParentModalKey,
                forwarder: forwarder
            };
            $[10] = embeddedParentModalKey;
            $[11] = forwarder;
            $[12] = t6;
        } else t6 = $[12];
        let t7;
        if ($[13] !== extensionId) {
            t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
                extensionId: extensionId
            });
            $[13] = extensionId;
            $[14] = t7;
        } else t7 = $[14];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
            extension: extension
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroType: embeddedMacroType,
            embeddedMacroParentType: resolvedEmbeddedMacroParentType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BldL.EmbeddedModalContext).Provider, {
            value: t6
        }, t7, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps))));
    }
    let t4;
    if ($[15] !== extensionId) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionId: extensionId
        });
        $[15] = extensionId;
        $[16] = t4;
    } else t4 = $[16];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        isInline: isInline,
        isMigrated: isMigrated,
        embeddedMacroType: embeddedMacroType,
        embeddedMacroParentType: resolvedEmbeddedMacroParentType
    }, t4, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps)));
} : (props)=>{
    const { extensionId: extensionId, contextIds: contextIds, loadingComponent: loadingComponent, createGetContextToken: createGetContextToken, extensionData: extensionData, embeddedParentLocalId: embeddedParentLocalId, localId: localId, extensionPayload: extensionPayload, isInCustomUI: isInCustomUI, embeddedMacroParentType: embeddedMacroParentType, isInline: isInline, isMigrated: isMigrated, entryPoint: entryPoint, customBridge: customBridge, ...rest } = props;
    const [embeddedParentModalKey, setEmbeddedParentModalKey] = (0, $cozmU.useState)(undefined);
    const { extensions: extensions, loading: loading } = (0, $f53nH.useExtensionListRelay)({
        contextIds: contextIds,
        filter: [
            {
                type: (0, $ix7El.GQLExtensionContextsFilterType).ExtensionType,
                value: [
                    'xen:macro'
                ]
            }
        ]
    });
    const extension = extensions?.find((ext)=>ext.id === extensionId);
    const queryCompleted = extensions !== undefined;
    const notInstalled = queryCompleted && !extension && (0, $iDrrr.fg)('platform_validate_embedded_macro_installation');
    if (loading || !queryCompleted) return $931bc75652dbffc6$var$getLoadingComponent(loadingComponent);
    if (notInstalled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lWtBU.ExtensionNotInstalled), {
        extensionId: extensionId
    });
    if (!extension) return null;
    const contentId = extensionData?.content?.id;
    const resolvedEmbeddedMacroParentType = embeddedMacroParentType ?? (isInCustomUI ? 'CustomUI' : 'UIKit');
    let getContextToken = props.getContextToken;
    // createGetContextToken is the FAUS version of useGetContextToken — it is used for embedded
    // macros with a Custom UI bodied parent.
    if (createGetContextToken) getContextToken = createGetContextToken(extension);
    else if (getContextToken && (0, $iDrrr.fg)('forge-ui-bridge-core-reset')) {
        // For embedded macros with a UI Kit parent, getContextToken is
        // passed in by Confluence rather than constructed here.
        // We inject the embedded macro's
        // contextIds, extension, and localId — so bridge calls that uses getContextToken(invoke,
        // realtime, etc.) use the embedded macro's context, not the parent's.
        const innerGetContextToken = getContextToken;
        getContextToken = (options)=>innerGetContextToken({
                contextIdsOverride: options?.contextIdsOverride ?? contextIds,
                extensionOverride: {
                    extension: extension,
                    localId: localId
                }
            });
    }
    const isEmbeddedUIKitInCustomUI = (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? embeddedMacroParentType === 'CustomUI' && !(0, $8yKod.isCustomUI)(extension, entryPoint) : isInCustomUI && !(0, $8yKod.isCustomUI)(extension, entryPoint);
    const embeddedMacroType = (0, $8yKod.isCustomUI)(extension, entryPoint) ? 'CustomUI' : 'UIKit';
    const forgeRendererProps = {
        ...rest,
        customBridge: customBridge,
        contextIds: contextIds,
        extension: extension,
        loadingComponent: loadingComponent,
        getContextToken: getContextToken,
        extensionData: extensionData,
        embeddedParentLocalId: embeddedParentLocalId,
        localId: localId,
        extensionPayload: extensionPayload,
        entryPoint: entryPoint,
        isEmbeddedUIKitInCustomUI: isEmbeddedUIKitInCustomUI,
        isEmbeddedMacro: !(0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type'),
        embeddedMacroParentType: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? resolvedEmbeddedMacroParentType : undefined,
        height: extension.properties?.viewportSize && (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') ? (0, $gKVSw.calculateViewportSizeHeight)(extension.properties.viewportSize) : undefined
    };
    if (isEmbeddedUIKitInCustomUI && (0, $iDrrr.fg)('platform_forge_ui_uikit_modal_in_custom_ui_parent')) {
        const postRobotSend = $931bc75652dbffc6$var$getPostRobotSend(); // This prop is used to determine if the embedded macro is rendered within a Custom UI macro. Since the EmbeddedMacroRenderer is only used for rendering macros within Custom UI, we can set this to true.
        const uiKitModalForwarder = (0, $iDrrr.fg)('forge-ui-bridge-core-reset') && customBridge?.['setEmbeddedMacroModalForgeDoc'];
        const forwarder = uiKitModalForwarder ? ({ data: data })=>uiKitModalForwarder(undefined, data) : (0, $iUEMs.createMessageForwarder)('setEmbeddedMacroModalForgeDoc', {
            embeddedMacroExtensionDetails: undefined,
            embeddedMacroLocalId: localId,
            extension: extension,
            extensionData: extensionData,
            extensionPayload: extensionPayload,
            isEmbeddedMacroModal: true,
            sourceAppId: extension?.appId ?? '',
            sourceEnvironmentId: extension?.environmentKey,
            sourceInstallationId: extension?.installationId
        }, postRobotSend, embeddedParentLocalId, {
            appId: extension?.appId ?? '',
            id: extension?.id ?? '',
            installationId: extension?.installationId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
            extension: extension
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroType: embeddedMacroType,
            embeddedMacroParentType: resolvedEmbeddedMacroParentType
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8BldL.EmbeddedModalContext).Provider, {
            value: {
                embeddedParentModalKey: embeddedParentModalKey,
                setEmbeddedParentModalKey: setEmbeddedParentModalKey,
                forwarder: forwarder
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionId: extensionId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps))));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kKOjD.ReservedHeightWrapper), {
        extension: extension
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        isInline: isInline,
        isMigrated: isMigrated,
        embeddedMacroType: embeddedMacroType,
        embeddedMacroParentType: resolvedEmbeddedMacroParentType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRenderedAnalyticsTrigger, {
        extensionId: extensionId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4v1ex.ForgeUIRenderer), forgeRendererProps)));
};
const $931bc75652dbffc6$export$329644bef0dce3f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRendererInner, props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.isInline || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$MacroExtensionContainer, {
            isInline: props.isInline
        }, t0));
        $[2] = props.isInline;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.AtlassianRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$MacroExtensionContainer, {
        isInline: props.isInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($931bc75652dbffc6$var$EmbeddedMacroRendererInner, props)));
};
module.exports["EmbeddedMacroRenderer"] = $931bc75652dbffc6$export$329644bef0dce3f7;

});

parcelRegister("fTCJP", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5xQdV = parcelRequire("5xQdV");


var $gBjHb = parcelRequire("gBjHb");

const $7e5b733cbcedd00c$export$2067d1940da125b6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, isInline: isInline, isMigrated: isMigrated, embeddedMacroParentType: embeddedMacroParentType, embeddedMacroType: embeddedMacroType, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== contentId || $[1] !== embeddedMacroParentType || $[2] !== embeddedMacroType || $[3] !== isInline || $[4] !== isMigrated) {
        t1 = ()=>({
                forgeUIAttributes: {
                    contentId: contentId,
                    isEmbeddedMacro: true,
                    ...isInline !== undefined ? {
                        isInline: isInline
                    } : {},
                    ...isMigrated ? {
                        isMigrated: isMigrated
                    } : {},
                    embeddedMacroParentType: embeddedMacroParentType,
                    embeddedMacroType: embeddedMacroType
                }
            });
        t2 = [
            contentId,
            isInline,
            isMigrated,
            embeddedMacroParentType,
            embeddedMacroType
        ];
        $[0] = contentId;
        $[1] = embeddedMacroParentType;
        $[2] = embeddedMacroType;
        $[3] = isInline;
        $[4] = isMigrated;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    const data = (0, $5xQdV.useMemoOne)(t1, t2);
    let t3;
    if ($[7] !== children || $[8] !== data) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: data
        }, children);
        $[7] = children;
        $[8] = data;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ contentId: contentId, isInline: isInline, isMigrated: isMigrated, embeddedMacroParentType: embeddedMacroParentType, embeddedMacroType: embeddedMacroType, children: children })=>{
    const data = (0, $5xQdV.useMemoOne)(()=>({
            forgeUIAttributes: {
                contentId: contentId,
                isEmbeddedMacro: true,
                ...isInline !== undefined ? {
                    isInline: isInline
                } : {},
                ...isMigrated ? {
                    isMigrated: isMigrated
                } : {},
                embeddedMacroParentType: embeddedMacroParentType,
                embeddedMacroType: embeddedMacroType
            }
        }), [
        contentId,
        isInline,
        isMigrated,
        embeddedMacroParentType,
        embeddedMacroType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: data
    }, children);
};
module.exports["ForgeUIEmbeddedMacroAnalyticsContext"] = $7e5b733cbcedd00c$export$2067d1940da125b6;

});

parcelRegister("gKVSw", function(module, exports) {
const $16b1ea7c28597489$var$macroHeights = {
    small: '112px',
    medium: '262px',
    default: '262px',
    large: '524px',
    xlarge: '1048px'
};
const $16b1ea7c28597489$export$d27eb2c49eeaf1b4 = (size)=>{
    return $16b1ea7c28597489$var$macroHeights[size ?? 'default'];
};
module.exports["calculateViewportSizeHeight"] = $16b1ea7c28597489$export$d27eb2c49eeaf1b4;

});

parcelRegister("lWtBU", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $4aRua = parcelRequire("4aRua");


var $1VhsF = parcelRequire("1VhsF");


var $6FQr4 = parcelRequire("6FQr4");

const $bb155dfc087093a5$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "forge.ui.extension.not.installed.title",
        defaultMessage: "App not available"
    },
    message: {
        id: "forge.ui.extension.not.installed.message",
        defaultMessage: "We can't display this content because the app isn't installed. Contact your administrator to install it."
    }
});
const $bb155dfc087093a5$export$8fa4e6bbdc2e95d1 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { extensionId: extensionId } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== extensionId) {
        t1 = ()=>{
            (0, $6FQr4.trackEmbeddedMacroRejected)(createAnalyticsEvent, {
                source: "forgeUIRenderer",
                extensionId: extensionId,
                reason: "not_installed"
            });
        };
        t2 = [
            createAnalyticsEvent,
            extensionId
        ];
        $[0] = createAnalyticsEvent;
        $[1] = extensionId;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[4] !== intl) {
        t3 = intl.formatMessage($bb155dfc087093a5$var$messages.title);
        $[4] = intl;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bb155dfc087093a5$var$messages.message));
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: t3,
            appearance: "warning",
            testId: "extension-not-installed"
        }, t4);
        $[7] = t3;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
} : ({ extensionId: extensionId })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        (0, $6FQr4.trackEmbeddedMacroRejected)(createAnalyticsEvent, {
            source: 'forgeUIRenderer',
            extensionId: extensionId,
            reason: 'not_installed'
        });
    }, [
        createAnalyticsEvent,
        extensionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        title: intl.formatMessage($bb155dfc087093a5$var$messages.title),
        appearance: "warning",
        testId: "extension-not-installed"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $bb155dfc087093a5$var$messages.message)));
};
module.exports["ExtensionNotInstalled"] = $bb155dfc087093a5$export$8fa4e6bbdc2e95d1;

});

parcelRegister("kKOjD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $8yKod = parcelRequire("8yKod");


var $gKVSw = parcelRequire("gKVSw");

const $8b08db13a4c8c729$export$eea1b756e7867f29 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const { extension: extension, children: children, isInlinePresentation: t1 } = t0;
    const isInlinePresentation = t1 === undefined ? false : t1;
    const extensionViewportSize = extension?.properties?.viewportSize;
    if (extensionViewportSize && (0, $iDrrr.fg)("confluence_forge_early_render_reserve_height") && !isInlinePresentation) {
        let t2;
        if ($[0] !== extensionViewportSize) {
            t2 = (0, $gKVSw.calculateViewportSizeHeight)(extensionViewportSize);
            $[0] = extensionViewportSize;
            $[1] = t2;
        } else t2 = $[1];
        const viewportSizeHeight = t2;
        if ((0, $8yKod.isCustomUI)(extension)) {
            let t3;
            if ($[2] !== viewportSizeHeight) {
                t3 = {
                    height: viewportSizeHeight
                };
                $[2] = viewportSizeHeight;
                $[3] = t3;
            } else t3 = $[3];
            let t4;
            if ($[4] !== children || $[5] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    style: t3,
                    "data-testid": "reserved-height-wrapper-custom-ui"
                }, children);
                $[4] = children;
                $[5] = t3;
                $[6] = t4;
            } else t4 = $[6];
            return t4;
        } else {
            let t3;
            if ($[7] !== viewportSizeHeight) {
                t3 = {
                    minHeight: viewportSizeHeight
                };
                $[7] = viewportSizeHeight;
                $[8] = t3;
            } else t3 = $[8];
            let t4;
            if ($[9] !== children || $[10] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    style: t3,
                    "data-testid": "reserved-height-wrapper-uikit"
                }, children);
                $[9] = children;
                $[10] = t3;
                $[11] = t4;
            } else t4 = $[11];
            return t4;
        }
    }
    let t2;
    if ($[12] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[12] = children;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
} : ({ extension: extension, children: children, isInlinePresentation: isInlinePresentation = false })=>{
    const extensionViewportSize = extension?.properties?.viewportSize;
    // Only apply reserved height if the feature flag is on AND viewportSize is defined
    if (extensionViewportSize && (0, $iDrrr.fg)('confluence_forge_early_render_reserve_height') && !isInlinePresentation) {
        const viewportSizeHeight = (0, $gKVSw.calculateViewportSizeHeight)(extensionViewportSize);
        // Custom UI extensions have full support for viewportSize, leading to a strict height.
        // UI Kit 2 extensions, while they can define viewportSize in their manifest, primarily
        // have dynamic sizing. This means viewportSize is not a strict constraint for them as it
        // is for Custom UI. Using minHeight based on a manifest-defined viewportSize is therefore
        // a best-effort approach to proactively reserve space. This aims to reduce layout shift
        // while still allowing the extension to grow dynamically if its content requires more space.
        if ((0, $8yKod.isCustomUI)(extension)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                height: viewportSizeHeight
            },
            "data-testid": "reserved-height-wrapper-custom-ui"
        }, children);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                minHeight: viewportSizeHeight
            },
            "data-testid": "reserved-height-wrapper-uikit"
        }, children);
    }
    // If FF is off, or if viewportSize is undefined, render children directly
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
};
module.exports["ReservedHeightWrapper"] = $8b08db13a4c8c729$export$eea1b756e7867f29;

});

parcelRegister("5pkPF", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $cgTkH = parcelRequire("cgTkH");



var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $amotT = parcelRequire("amotT");



var $hA0li = parcelRequire("hA0li");


var $eoR7w = parcelRequire("eoR7w");

var $3eff726f85d07655$export$bb38bb9a1161268 = 'unmounted';
var $3eff726f85d07655$export$84cbff306f539230 = 'exited';
var $3eff726f85d07655$export$df38205c966be359 = 'entering';
var $3eff726f85d07655$export$78e9e6e3e014d60a = 'entered';
var $3eff726f85d07655$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $3eff726f85d07655$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $cgTkH.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $3eff726f85d07655$export$84cbff306f539230;
                _this.appearStatus = $3eff726f85d07655$export$df38205c966be359;
            } else initialStatus = $3eff726f85d07655$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $3eff726f85d07655$export$bb38bb9a1161268;
        else initialStatus = $3eff726f85d07655$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $3eff726f85d07655$export$bb38bb9a1161268) return {
            status: $3eff726f85d07655$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $3eff726f85d07655$export$df38205c966be359 && status !== $3eff726f85d07655$export$78e9e6e3e014d60a) nextStatus = $3eff726f85d07655$export$df38205c966be359;
            } else if (status === $3eff726f85d07655$export$df38205c966be359 || status === $3eff726f85d07655$export$78e9e6e3e014d60a) nextStatus = $3eff726f85d07655$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $3eff726f85d07655$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $eoR7w.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $3eff726f85d07655$export$84cbff306f539230) this.setState({
            status: $3eff726f85d07655$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $amotT.default).disabled) {
            this.safeSetState({
                status: $3eff726f85d07655$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $3eff726f85d07655$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $3eff726f85d07655$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $amotT.default).disabled) {
            this.safeSetState({
                status: $3eff726f85d07655$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $3eff726f85d07655$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $3eff726f85d07655$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $3eff726f85d07655$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1eVGO.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hA0li.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component);
$3eff726f85d07655$var$Transition.contextType = (0, $hA0li.default);
$3eff726f85d07655$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $3eff726f85d07655$var$noop() {}
$3eff726f85d07655$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $3eff726f85d07655$var$noop,
    onEntering: $3eff726f85d07655$var$noop,
    onEntered: $3eff726f85d07655$var$noop,
    onExit: $3eff726f85d07655$var$noop,
    onExiting: $3eff726f85d07655$var$noop,
    onExited: $3eff726f85d07655$var$noop
};
$3eff726f85d07655$var$Transition.UNMOUNTED = $3eff726f85d07655$export$bb38bb9a1161268;
$3eff726f85d07655$var$Transition.EXITED = $3eff726f85d07655$export$84cbff306f539230;
$3eff726f85d07655$var$Transition.ENTERING = $3eff726f85d07655$export$df38205c966be359;
$3eff726f85d07655$var$Transition.ENTERED = $3eff726f85d07655$export$78e9e6e3e014d60a;
$3eff726f85d07655$var$Transition.EXITING = $3eff726f85d07655$export$4aacc83d4d59139f;
var $3eff726f85d07655$export$2e2bcd8739ae039 = $3eff726f85d07655$var$Transition;
module.exports["default"] = $3eff726f85d07655$export$2e2bcd8739ae039;

});

parcelRegister("amotT", function(module, exports) {
$parcel$export(module.exports, "default", () => $78aef2ed8b5cba44$export$2e2bcd8739ae039);
var $78aef2ed8b5cba44$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("hA0li", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccc6107deb85fdd7$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

var $ccc6107deb85fdd7$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext(null);

});

parcelRegister("eoR7w", function(module, exports) {
var $a7bc833148928009$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};
module.exports["forceReflow"] = $a7bc833148928009$export$7d26bbb1236dafd6;

});

parcelRegister("fuSOM", function(module, exports) {

var $eRn3r = parcelRequire("eRn3r");


var $lA6N5 = parcelRequire("lA6N5");


const $cb5189150b488f78$var$LazyLinkPickerComponent = (0, $eRn3r.lazyForPaint)(()=>(parcelRequire("80d0N")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })));
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $cb5189150b488f78$var$_default_1 = (0, $lA6N5.composeLinkPicker)($cb5189150b488f78$var$LazyLinkPickerComponent);
var $cb5189150b488f78$export$2e2bcd8739ae039 = $cb5189150b488f78$var$_default_1;
module.exports["default"] = $cb5189150b488f78$export$2e2bcd8739ae039;

});

parcelRegister("lA6N5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $eRn3r = parcelRequire("eRn3r");


var $gBjHb = parcelRequire("gBjHb");


var $kJo8F = parcelRequire("kJo8F");


var $eg7eG = parcelRequire("eg7eG");


var $fCO8c = parcelRequire("fCO8c");


var $k5YvC = parcelRequire("k5YvC");


var $lg1Gp = parcelRequire("lg1Gp");

const $12f35d08bde2472f$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $12f35d08bde2472f$export$a2495bb1f182689d = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: (0, $kJo8F.COMPONENT_NAME),
    source: (0, $kJo8F.COMPONENT_NAME)
};
const $12f35d08bde2472f$var$DefaultRootComponent = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $12f35d08bde2472f$var$fixedWidthContainerStyles = null;
const $12f35d08bde2472f$var$FixedWidthContainer = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02oEu0"
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "dialog",
            "aria-modal": "false",
            "aria-label": "link-picker",
            ...props,
            className: t0
        });
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02oEu0"
        ])
    });
};
const $12f35d08bde2472f$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $12f35d08bde2472f$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: $12f35d08bde2472f$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eg7eG.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lg1Gp.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $kJo8F.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($12f35d08bde2472f$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fCO8c.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eRn3r.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $k5YvC.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RootComponent, {
            ...props,
            "data-testid": $12f35d08bde2472f$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props)))))))));
    });
};
module.exports["composeLinkPicker"] = $12f35d08bde2472f$export$922eb685ceb4a294;

});

parcelRegister("kJo8F", function(module, exports) {
const $001c95c8c9eb30f1$export$85183a312807388d = 'media';
const $001c95c8c9eb30f1$export$fc44104665f4d1e5 = 'linkPicker';
const $001c95c8c9eb30f1$export$452f1062ecf44be7 = 5;
const $001c95c8c9eb30f1$export$bf31a09f182d5584 = 342;
const $001c95c8c9eb30f1$export$542fb16962bf430c = '290px';
module.exports["ANALYTICS_CHANNEL"] = $001c95c8c9eb30f1$export$85183a312807388d;
module.exports["COMPONENT_NAME"] = $001c95c8c9eb30f1$export$fc44104665f4d1e5;
module.exports["RECENT_SEARCH_LIST_SIZE"] = $001c95c8c9eb30f1$export$452f1062ecf44be7;
module.exports["LINK_PICKER_WIDTH_IN_PX"] = $001c95c8c9eb30f1$export$bf31a09f182d5584;
module.exports["LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK"] = $001c95c8c9eb30f1$export$542fb16962bf430c;

});

parcelRegister("eg7eG", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $gt5Em = parcelRequire("gt5Em");

const $c7635a085ba363f5$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $c7635a085ba363f5$export$3285420c698bc605 = /*#__PURE__*/ (0, $cozmU.createContext)($c7635a085ba363f5$export$c07727f5eddb98f);
const $c7635a085ba363f5$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $cozmU.useRef)((0, $03RpJ.default)());
    (0, $cozmU.useEffect)(()=>{
        (0, $gt5Em.startUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
        return ()=>(0, $gt5Em.abortUfoExperience)((0, $gt5Em.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c7635a085ba363f5$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $c7635a085ba363f5$export$36ecc935abdc3636 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
} : ()=>(0, $cozmU.useContext)($c7635a085ba363f5$export$3285420c698bc605);
module.exports["LinkPickerSessionProvider"] = $c7635a085ba363f5$export$2f19832fd2d620ca;
module.exports["useLinkPickerSessionId"] = $c7635a085ba363f5$export$36ecc935abdc3636;

});

parcelRegister("gt5Em", function(module, exports) {

var $fh15z = parcelRequire("fh15z");


var $4MiWC = parcelRequire("4MiWC");

const $64cb77453c568c86$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $64cb77453c568c86$var$ufoExperiences = {
    [$64cb77453c568c86$export$f9c7780c574346a2.mounted]: new (0, $fh15z.ConcurrentExperience)($64cb77453c568c86$export$f9c7780c574346a2.mounted, {
        type: (0, $4MiWC.ExperienceTypes).Load,
        performanceType: (0, $4MiWC.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $64cb77453c568c86$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $64cb77453c568c86$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $64cb77453c568c86$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $64cb77453c568c86$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};
module.exports["ufoExperience"] = $64cb77453c568c86$export$f9c7780c574346a2;
module.exports["startUfoExperience"] = $64cb77453c568c86$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $64cb77453c568c86$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $64cb77453c568c86$export$8dda83bafca11b77;
module.exports["abortUfoExperience"] = $64cb77453c568c86$export$b1021040eb94cdca;

});

parcelRegister("fCO8c", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $gt5Em = parcelRequire("gt5Em");


var $kJo8F = parcelRequire("kJo8F");


var $779pE = parcelRequire("779pE");


var $eg7eG = parcelRequire("eg7eG");


var $aRBFH = parcelRequire("aRBFH");


var $f3GZb = parcelRequire("f3GZb");

const $96adf85769963d68$export$e926676385687eaf = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== linkPickerSessionId) {
        t1 = (error, info)=>{
            createAnalyticsEvent((0, $779pE.default)("ui.linkPicker.unhandledErrorCaught", {
                browserInfo: window?.navigator?.userAgent || "unknown",
                error: error.toString(),
                componentStack: info?.componentStack ?? ""
            })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
            (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
        };
        $[0] = createAnalyticsEvent;
        $[1] = linkPickerSessionId;
        $[2] = t1;
    } else t1 = $[2];
    const handleError = t1;
    let t2;
    if ($[3] !== children || $[4] !== handleError) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
            onError: handleError,
            ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
        }, children);
        $[3] = children;
        $[4] = handleError;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : function ErrorBoundary({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $eg7eG.useLinkPickerSessionId)();
    const handleError = (0, $cozmU.useCallback)((error, info)=>{
        // Fire Analytics event
        createAnalyticsEvent((0, $779pE.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: window?.navigator?.userAgent || 'unknown',
            error: error.toString(),
            componentStack: info?.componentStack ?? ''
        })).fire((0, $kJo8F.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $gt5Em.failUfoExperience)((0, $gt5Em.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRBFH.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $f3GZb.ErrorBoundaryFallback)
    }, children);
};
module.exports["ErrorBoundary"] = $96adf85769963d68$export$e926676385687eaf;

});

parcelRegister("779pE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8ad800c149f887c26cf6e1c701c20ed0>>
 * @codegenCommand afm workspace @atlaskit/link-picker codegen-analytics
 */ function $eafc2c5357085519$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $eafc2c5357085519$export$2e2bcd8739ae039 = $eafc2c5357085519$var$createEventPayload;
module.exports["default"] = $eafc2c5357085519$export$2e2bcd8739ae039;

});

parcelRegister("aRBFH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

class $baa71a56a1d588bd$export$688779ac61ee945f extends (0, $cozmU.Component) {
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorComponent, null);
        return children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["BaseErrorBoundary"] = $baa71a56a1d588bd$export$688779ac61ee945f;

});

parcelRegister("f3GZb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $kJo8F = parcelRequire("kJo8F");


var $bXDzR = parcelRequire("bXDzR");


var $k3ncb = parcelRequire("k3ncb");


var $dOXsL = parcelRequire("dOXsL");

const $66e5302c045c6e9e$var$errorBoundaryFallbackStyles = null;
const $66e5302c045c6e9e$var$messages = (0, $kSwu1.defineMessages)({
    heading: {
        defaultMessage: "Something went wrong!",
        id: "fabric.linkPicker.unhandledError.heading"
    },
    description: {
        defaultMessage: "Try reloading the page.",
        id: "fabric.linkPicker.unhandledError.description"
    }
});
const $66e5302c045c6e9e$export$8a28b7e38e4685dd = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== intl) {
        t0 = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
        $[0] = intl;
        $[1] = t0;
    } else t0 = $[1];
    const header = t0;
    let t1;
    if ($[2] !== intl) {
        t1 = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
        $[2] = intl;
        $[3] = t1;
    } else t1 = $[3];
    const description = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== description || $[6] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
            "data-testid": "link-picker-root-error-boundary-ui",
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
            header: header,
            renderImage: $66e5302c045c6e9e$var$_temp,
            description: description
        }));
        $[5] = description;
        $[6] = header;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const header = intl.formatMessage($66e5302c045c6e9e$var$messages.heading);
    const description = intl.formatMessage($66e5302c045c6e9e$var$messages.description);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: (0, $kJo8F.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $hekY6.default)([
            "_2sNsIgd8bj"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $k3ncb.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null),
        description: description
    }));
};
function $66e5302c045c6e9e$var$_temp() {
    return /*#__PURE__*/ $cozmU.createElement((0, $bXDzR.GenericErrorSVG), null);
}
module.exports["ErrorBoundaryFallback"] = $66e5302c045c6e9e$export$8a28b7e38e4685dd;

});

parcelRegister("bXDzR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $efcb4a3aca6e9417$var$SIZE = 96;
const $efcb4a3aca6e9417$var$genericErrorStyles = null;
const $efcb4a3aca6e9417$export$e54420a1a27457a4 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ]);
        t1 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#fff",
            d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
        });
        t2 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
        });
        t3 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
        });
        t4 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
        });
        t5 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#B7B9BE",
            d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
        });
        t6 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
            clipRule: "evenodd"
        });
        t7 = /*#__PURE__*/ $cozmU.createElement("path", {
            fill: "#DDDEE1",
            fillRule: "evenodd",
            d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
            clipRule: "evenodd"
        });
        $[0] = t0;
        $[1] = t1;
        $[2] = t2;
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
        $[6] = t6;
        $[7] = t7;
    } else {
        t0 = $[0];
        t1 = $[1];
        t2 = $[2];
        t3 = $[3];
        t4 = $[4];
        t5 = $[5];
        t6 = $[6];
        t7 = $[7];
    }
    let t8;
    if ($[8] !== props) {
        t8 = /*#__PURE__*/ $cozmU.createElement("svg", {
            viewBox: "0 0 96 96",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            ...props,
            className: t0
        }, t1, t2, t3, t4, t5, t6, t7);
        $[8] = props;
        $[9] = t8;
    } else t8 = $[9];
    return t8;
} : (props)=>{
    return /*#__PURE__*/ $cozmU.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $hekY6.default)([
            "_39xV02JgOI _0jFU0VJgOI _3iDTPbvLZJ"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};
module.exports["GenericErrorSVG"] = $efcb4a3aca6e9417$export$e54420a1a27457a4;

});

parcelRegister("k3ncb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $4ez2K = parcelRequire("4ez2K");


var $4aRua = parcelRequire("4aRua");

const $abc7c062eda24665$var$styles = {
    containerV2: "_0Of8r2NHnM _1Znuxbp0Oa _2Zuz6Qp0Oa _1wydGWS40j _2fwxA5DIqT",
    whiteSpaceNormal: "_1ANEUSzUZr"
};
const $abc7c062eda24665$export$fddf379e22a74b00 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { testId: testId, header: header, description: description, action: action, renderImage: renderImage } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, $abc7c062eda24665$var$styles.whiteSpaceNormal);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== renderImage) {
        t2 = renderImage?.();
        $[1] = renderImage;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== header) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "small",
            as: "h2"
        }, header);
        $[3] = header;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== description) {
        t4 = description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            as: "p",
            color: "color.text"
        }, description);
        $[5] = description;
        $[6] = t4;
    } else t4 = $[6];
    const t5 = action && action;
    let t6;
    if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== testId) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            xcss: t1,
            testId: testId,
            direction: "column",
            alignItems: "center",
            gap: "space.200"
        }, t2, t3, t4, t5);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = testId;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        xcss: (0, $w6R6I.cx)($abc7c062eda24665$var$styles.containerV2, $abc7c062eda24665$var$styles.whiteSpaceNormal),
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage?.(), /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};
module.exports["EmptyState"] = $abc7c062eda24665$export$fddf379e22a74b00;

});

parcelRegister("dOXsL", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $1bc658963d2888d5$var$minHeightComponentStyles = null;
const $1bc658963d2888d5$export$42134e2a251518b3 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLFlnN _37wbyuDIqT _4kiQYAjtAN",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});
module.exports["MinHeightContainer"] = $1bc658963d2888d5$export$42134e2a251518b3;

});

parcelRegister("k5YvC", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $dOXsL = parcelRequire("dOXsL");

const $9e6da8c9bb613998$var$styles = null;
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $9e6da8c9bb613998$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
         /**
       * Without tabs
       */ 
        if (plugins?.length === 1) return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $9e6da8c9bb613998$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $9e6da8c9bb613998$export$d96e921133238c41 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    const minHeight = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ]);
        $[2] = t1;
    } else t1 = $[2];
    const t2 = props.name || "link-picker-loading";
    let t3;
    if ($[3] !== t2) {
        t3 = /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            testId: "link-picker.component-loading-indicator",
            interactionName: t2,
            size: "medium"
        });
        $[3] = t2;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== minHeight || $[6] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
            minHeight: minHeight,
            "data-testid": "link-picker-root-loader-boundary-ui",
            className: t1
        }, t3);
        $[5] = minHeight;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : (props)=>{
    const minHeight = $9e6da8c9bb613998$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $cozmU.createElement((0, $dOXsL.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $hekY6.default)([
            "_0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};
module.exports["LoaderFallback"] = $9e6da8c9bb613998$export$d96e921133238c41;

});

parcelRegister("lg1Gp", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $Vh5j9 = parcelRequire("Vh5j9");

const $f169ae6f19f5b49d$export$54320b51a950d54a = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $Vh5j9.LazyMessagesProvider), null, children);
};
module.exports["MessagesProvider"] = $f169ae6f19f5b49d$export$54320b51a950d54a;

});

parcelRegister("Vh5j9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $64VTj = parcelRequire("64VTj");


var $935R1 = parcelRequire("935R1");


var $2H5my = parcelRequire("2H5my");

const $550b5e1058020e28$export$d013d33430f9fb4b = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            defaultMessages: (0, $935R1.default),
            loaderFn: (0, $2H5my.fetchMessagesForLocale)
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        defaultMessages: (0, $935R1.default),
        loaderFn: (0, $2H5my.fetchMessagesForLocale)
    }, children);
};
module.exports["LazyMessagesProvider"] = $550b5e1058020e28$export$d013d33430f9fb4b;

});

parcelRegister("2H5my", function(module, exports) {

var $b3upr = parcelRequire("b3upr");

const $d0c1d8c70ea117ba$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $b3upr.locales)) {
            const messages = await (0, $b3upr.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};
module.exports["fetchMessagesForLocale"] = $d0c1d8c70ea117ba$export$2b153a2030b0feb2;

});

parcelRegister("b3upr", function(module, exports) {

























const $f5a6a4ca12953b28$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("cocSb")),
    da: ()=>(parcelRequire("8hHUq")),
    de: ()=>(parcelRequire("6xY5a")),
    en_GB: ()=>(parcelRequire("3WzYA")),
    en_ZZ: ()=>(parcelRequire("7p3RA")),
    en: ()=>Promise.resolve((parcelRequire("935R1"))),
    es: ()=>(parcelRequire("1ijPU")),
    fi: ()=>(parcelRequire("hgktU")),
    fr: ()=>(parcelRequire("2X88N")),
    hu: ()=>(parcelRequire("gVpg0")),
    it: ()=>(parcelRequire("iDF1E")),
    ja: ()=>(parcelRequire("94sol")),
    ko: ()=>(parcelRequire("kaacA")),
    nb: ()=>(parcelRequire("6fz2I")),
    nl: ()=>(parcelRequire("jA2SL")),
    pl: ()=>(parcelRequire("hzJqW")),
    pt_BR: ()=>(parcelRequire("hoKfB")),
    ru: ()=>(parcelRequire("imEOn")),
    sv: ()=>(parcelRequire("cGIqm")),
    th: ()=>(parcelRequire("5e2PY")),
    tr: ()=>(parcelRequire("11CPA")),
    uk: ()=>(parcelRequire("hRtvo")),
    vi: ()=>(parcelRequire("9PM3y")),
    zh_TW: ()=>(parcelRequire("5ZmT8")),
    zh: ()=>(parcelRequire("iDdpg"))
};
module.exports["locales"] = $f5a6a4ca12953b28$export$df1c34db1371eeed;

});

parcelRegister("cocSb", function(module, exports) {

let $9051b633a19cf27b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9051b633a19cf27b$var$load("1JYrd"),
    $9051b633a19cf27b$var$load("cip6w"),
    $9051b633a19cf27b$var$load("gAG2n"),
    $9051b633a19cf27b$var$load("3feYV"),
    $9051b633a19cf27b$var$load("cwjU2"),
    $9051b633a19cf27b$var$load("7rL7C"),
    $9051b633a19cf27b$var$load("3Ff1R"),
    $9051b633a19cf27b$var$load("423Ga")
]).then(()=>parcelRequire('ksVtB'));

});

parcelRegister("8hHUq", function(module, exports) {

let $6081f8b0ed39508c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $6081f8b0ed39508c$var$load("30242"),
    $6081f8b0ed39508c$var$load("3qBwQ"),
    $6081f8b0ed39508c$var$load("cYGDU"),
    $6081f8b0ed39508c$var$load("7Q1SM"),
    $6081f8b0ed39508c$var$load("33Iaa"),
    $6081f8b0ed39508c$var$load("1RSxn"),
    $6081f8b0ed39508c$var$load("blA7x"),
    $6081f8b0ed39508c$var$load("gJroP")
]).then(()=>parcelRequire('1VdaT'));

});

parcelRegister("6xY5a", function(module, exports) {

let $4c446e418128a786$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $4c446e418128a786$var$load("15aAJ"),
    $4c446e418128a786$var$load("8rREG"),
    $4c446e418128a786$var$load("dgXJL"),
    $4c446e418128a786$var$load("7JdzX"),
    $4c446e418128a786$var$load("6681T"),
    $4c446e418128a786$var$load("ghT31"),
    $4c446e418128a786$var$load("3dn3H"),
    $4c446e418128a786$var$load("cYXvt")
]).then(()=>parcelRequire('h2ceo'));

});

parcelRegister("3WzYA", function(module, exports) {

let $2df2b1fbf4a55ea0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2df2b1fbf4a55ea0$var$load("l5BBd"),
    $2df2b1fbf4a55ea0$var$load("93ASN"),
    $2df2b1fbf4a55ea0$var$load("htu5t"),
    $2df2b1fbf4a55ea0$var$load("24LNf"),
    $2df2b1fbf4a55ea0$var$load("6Hcvs"),
    $2df2b1fbf4a55ea0$var$load("lM2G0"),
    $2df2b1fbf4a55ea0$var$load("iYQCc"),
    $2df2b1fbf4a55ea0$var$load("nBJth")
]).then(()=>parcelRequire('6VGGT'));

});

parcelRegister("7p3RA", function(module, exports) {

let $563ddd59fb0fa745$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $563ddd59fb0fa745$var$load("bbv9t"),
    $563ddd59fb0fa745$var$load("9fQoJ"),
    $563ddd59fb0fa745$var$load("lTboH"),
    $563ddd59fb0fa745$var$load("cnlNg"),
    $563ddd59fb0fa745$var$load("d3Phe"),
    $563ddd59fb0fa745$var$load("lTP5S"),
    $563ddd59fb0fa745$var$load("lASLx"),
    $563ddd59fb0fa745$var$load("bIXgz")
]).then(()=>parcelRequire('glan9'));

});

parcelRegister("1ijPU", function(module, exports) {

let $0f16dbf23003f2e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $0f16dbf23003f2e3$var$load("7p4je"),
    $0f16dbf23003f2e3$var$load("8SZbD"),
    $0f16dbf23003f2e3$var$load("iE05k"),
    $0f16dbf23003f2e3$var$load("9Uf61"),
    $0f16dbf23003f2e3$var$load("3Yk1e"),
    $0f16dbf23003f2e3$var$load("jZqyp"),
    $0f16dbf23003f2e3$var$load("5lJyy"),
    $0f16dbf23003f2e3$var$load("9w9df")
]).then(()=>parcelRequire('jIUdy'));

});

parcelRegister("hgktU", function(module, exports) {

let $c913d17b53ae571b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c913d17b53ae571b$var$load("1jQRQ"),
    $c913d17b53ae571b$var$load("5pOQA"),
    $c913d17b53ae571b$var$load("5GSny"),
    $c913d17b53ae571b$var$load("fJSEb"),
    $c913d17b53ae571b$var$load("ajzkj"),
    $c913d17b53ae571b$var$load("kIcDP"),
    $c913d17b53ae571b$var$load("eyysG"),
    $c913d17b53ae571b$var$load("27gvR")
]).then(()=>parcelRequire('j6sWj'));

});

parcelRegister("2X88N", function(module, exports) {

let $2267680e8ed7bae6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2267680e8ed7bae6$var$load("km37l"),
    $2267680e8ed7bae6$var$load("gbksI"),
    $2267680e8ed7bae6$var$load("j2X7f"),
    $2267680e8ed7bae6$var$load("9TeWr"),
    $2267680e8ed7bae6$var$load("kUZ7k"),
    $2267680e8ed7bae6$var$load("8e8NT"),
    $2267680e8ed7bae6$var$load("dJQL7"),
    $2267680e8ed7bae6$var$load("czj6d")
]).then(()=>parcelRequire('6POS4'));

});

parcelRegister("gVpg0", function(module, exports) {

let $c5258fc18afd6137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c5258fc18afd6137$var$load("lTbXI"),
    $c5258fc18afd6137$var$load("a98cw"),
    $c5258fc18afd6137$var$load("e40mE"),
    $c5258fc18afd6137$var$load("fOGnR"),
    $c5258fc18afd6137$var$load("cDQOq"),
    $c5258fc18afd6137$var$load("gznax"),
    $c5258fc18afd6137$var$load("8upye"),
    $c5258fc18afd6137$var$load("GlmUM")
]).then(()=>parcelRequire('5BZIn'));

});

parcelRegister("iDF1E", function(module, exports) {

let $038072583318b171$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $038072583318b171$var$load("iUyZj"),
    $038072583318b171$var$load("4PDaO"),
    $038072583318b171$var$load("lMhbw"),
    $038072583318b171$var$load("8nEeY"),
    $038072583318b171$var$load("kLZKK"),
    $038072583318b171$var$load("2gIpG"),
    $038072583318b171$var$load("c7GMc"),
    $038072583318b171$var$load("bnhJ1")
]).then(()=>parcelRequire('dkwKE'));

});

parcelRegister("94sol", function(module, exports) {

let $69aa82c635856cdf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $69aa82c635856cdf$var$load("kPlMQ"),
    $69aa82c635856cdf$var$load("ervs7"),
    $69aa82c635856cdf$var$load("8CX31"),
    $69aa82c635856cdf$var$load("fzzMQ"),
    $69aa82c635856cdf$var$load("33S6H"),
    $69aa82c635856cdf$var$load("iZiNp"),
    $69aa82c635856cdf$var$load("kFae4"),
    $69aa82c635856cdf$var$load("iZWpE")
]).then(()=>parcelRequire('4VLhA'));

});

parcelRegister("kaacA", function(module, exports) {

let $eadca7b8b0c7e43e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $eadca7b8b0c7e43e$var$load("iT2sv"),
    $eadca7b8b0c7e43e$var$load("iMMtn"),
    $eadca7b8b0c7e43e$var$load("23VWs"),
    $eadca7b8b0c7e43e$var$load("3gNEO"),
    $eadca7b8b0c7e43e$var$load("93obY"),
    $eadca7b8b0c7e43e$var$load("6Bgnb"),
    $eadca7b8b0c7e43e$var$load("6Y9jE"),
    $eadca7b8b0c7e43e$var$load("cUTaY")
]).then(()=>parcelRequire('gVcgA'));

});

parcelRegister("6fz2I", function(module, exports) {

let $48cf538efc08928f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $48cf538efc08928f$var$load("lyPpF"),
    $48cf538efc08928f$var$load("eX5n7"),
    $48cf538efc08928f$var$load("aiYuN"),
    $48cf538efc08928f$var$load("gvylW"),
    $48cf538efc08928f$var$load("bxfRe"),
    $48cf538efc08928f$var$load("43PKJ"),
    $48cf538efc08928f$var$load("ed6s8"),
    $48cf538efc08928f$var$load("lAuJd")
]).then(()=>parcelRequire('6B7wN'));

});

parcelRegister("jA2SL", function(module, exports) {

let $e4139d7ff7455fb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e4139d7ff7455fb3$var$load("iN3cj"),
    $e4139d7ff7455fb3$var$load("3nHdy"),
    $e4139d7ff7455fb3$var$load("gDEvm"),
    $e4139d7ff7455fb3$var$load("80OLx"),
    $e4139d7ff7455fb3$var$load("1EVcg"),
    $e4139d7ff7455fb3$var$load("fqoiV"),
    $e4139d7ff7455fb3$var$load("96q1k"),
    $e4139d7ff7455fb3$var$load("XQtfV")
]).then(()=>parcelRequire('6e51k'));

});

parcelRegister("hzJqW", function(module, exports) {

let $ccb8f2b7f0b31592$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ccb8f2b7f0b31592$var$load("eC1OL"),
    $ccb8f2b7f0b31592$var$load("ilL9c"),
    $ccb8f2b7f0b31592$var$load("64nco"),
    $ccb8f2b7f0b31592$var$load("e4s0V"),
    $ccb8f2b7f0b31592$var$load("28EXy"),
    $ccb8f2b7f0b31592$var$load("dHzvE"),
    $ccb8f2b7f0b31592$var$load("7RZp5"),
    $ccb8f2b7f0b31592$var$load("leyTH")
]).then(()=>parcelRequire('guLr4'));

});

parcelRegister("hoKfB", function(module, exports) {

let $caa88dfb824256c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $caa88dfb824256c7$var$load("4NJ49"),
    $caa88dfb824256c7$var$load("bfOZL"),
    $caa88dfb824256c7$var$load("jLbRX"),
    $caa88dfb824256c7$var$load("4dPO1"),
    $caa88dfb824256c7$var$load("gg8tK"),
    $caa88dfb824256c7$var$load("1SbqQ"),
    $caa88dfb824256c7$var$load("eF54W"),
    $caa88dfb824256c7$var$load("3hnPt")
]).then(()=>parcelRequire('9NY5A'));

});

parcelRegister("imEOn", function(module, exports) {

let $d5e9f05f0f1966b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d5e9f05f0f1966b0$var$load("g9gkE"),
    $d5e9f05f0f1966b0$var$load("jYdbS"),
    $d5e9f05f0f1966b0$var$load("6ncWv"),
    $d5e9f05f0f1966b0$var$load("ltrgi"),
    $d5e9f05f0f1966b0$var$load("fu25G"),
    $d5e9f05f0f1966b0$var$load("di9bz"),
    $d5e9f05f0f1966b0$var$load("iQGcz"),
    $d5e9f05f0f1966b0$var$load("ar4uw")
]).then(()=>parcelRequire('l7nLc'));

});

parcelRegister("cGIqm", function(module, exports) {

let $93cbddf8b86b3fc5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $93cbddf8b86b3fc5$var$load("jhikU"),
    $93cbddf8b86b3fc5$var$load("f0i3H"),
    $93cbddf8b86b3fc5$var$load("bvBAp"),
    $93cbddf8b86b3fc5$var$load("69YlM"),
    $93cbddf8b86b3fc5$var$load("cyTsc"),
    $93cbddf8b86b3fc5$var$load("iL6r3"),
    $93cbddf8b86b3fc5$var$load("kXCsp"),
    $93cbddf8b86b3fc5$var$load("disCG")
]).then(()=>parcelRequire('ijDRq'));

});

parcelRegister("5e2PY", function(module, exports) {

let $3ce075fd9818b53d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3ce075fd9818b53d$var$load("e2Idi").then(()=>parcelRequire('fC7VU'));

});

parcelRegister("11CPA", function(module, exports) {

let $0bf4017cfd787023$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0bf4017cfd787023$var$load("3gdIo").then(()=>parcelRequire('4USSX'));

});

parcelRegister("hRtvo", function(module, exports) {

let $d00e46120947d0cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d00e46120947d0cd$var$load("1uCJj").then(()=>parcelRequire('dWB8a'));

});

parcelRegister("9PM3y", function(module, exports) {

let $728e27781bf035cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $728e27781bf035cb$var$load("crqMH").then(()=>parcelRequire('qL2MH'));

});

parcelRegister("5ZmT8", function(module, exports) {

let $45c4675def33c250$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $45c4675def33c250$var$load("d91RK"),
    $45c4675def33c250$var$load("f7hfJ"),
    $45c4675def33c250$var$load("QI1kr"),
    $45c4675def33c250$var$load("brdRT"),
    $45c4675def33c250$var$load("lWBlc"),
    $45c4675def33c250$var$load("ZkI53"),
    $45c4675def33c250$var$load("s2EmI"),
    $45c4675def33c250$var$load("jc0YL")
]).then(()=>parcelRequire('ayAwo'));

});

parcelRegister("iDdpg", function(module, exports) {

let $d90644c3b275ca0d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d90644c3b275ca0d$var$load("708J7"),
    $d90644c3b275ca0d$var$load("kVqUf"),
    $d90644c3b275ca0d$var$load("2IMxh"),
    $d90644c3b275ca0d$var$load("j03Pa"),
    $d90644c3b275ca0d$var$load("kke1I"),
    $d90644c3b275ca0d$var$load("dJQNS"),
    $d90644c3b275ca0d$var$load("gOwMq"),
    $d90644c3b275ca0d$var$load("6GfaN")
]).then(()=>parcelRequire('3x4gn'));

});

parcelRegister("80d0N", function(module, exports) {

let $5d386ab3c6d16b34$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5d386ab3c6d16b34$var$load("d0ZRF"),
    $5d386ab3c6d16b34$var$load("k507P"),
    $5d386ab3c6d16b34$var$load("6iTkp"),
    $5d386ab3c6d16b34$var$load("6wr18"),
    $5d386ab3c6d16b34$var$load("ffEVr"),
    $5d386ab3c6d16b34$var$load("7EorR"),
    $5d386ab3c6d16b34$var$load("9TOep"),
    $5d386ab3c6d16b34$var$load("hhss7"),
    $5d386ab3c6d16b34$var$load("gnocL")
]).then(()=>parcelRequire('8mHp9'));

});

parcelRegister("erHVE", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $786700e92aa2b215$export$31b2b7ff910ba1f3 = new (0, $kCECX.PluginKey)('editorToolbarPluginKey');
module.exports["editorToolbarPluginKey"] = $786700e92aa2b215$export$31b2b7ff910ba1f3;

});

parcelRegister("bR6es", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $b2jdX = parcelRequire("b2jdX");


var $gMrzi = parcelRequire("gMrzi");


var $jEaFE = parcelRequire("jEaFE");


var $2Wuyj = parcelRequire("2Wuyj");

const $726c97f63f4e2017$var$styles = {
    toolbarBase: "_0bjKvDKTcp _2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    toolbar: "_0KLXruoI2d _0jFU0VnlTt _1Znuxb1Y8M _2Zuz6Q1Y8M _2OUyjtGk8v",
    toolbarResponsive: "_2YLqiK5zaO",
    primaryToolbar: "_0KLXrulfZc _4kiQYAUofl",
    toolbarSeparator: "_3RwxbwnlTt",
    hiddenSelectors: "_13h9R7YbGa _2XhVcfYbGa _2kQ26MYbGa",
    hiddenSelectorsPatch: "_2jRqDdYbGa"
};
const $726c97f63f4e2017$export$4c260019440d418f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(19);
    const { children: children, label: label, actionSubjectId: actionSubjectId, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== actionSubjectId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Wuyj.ViewEventEmitter), {
            actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: actionSubjectId
        });
        $[1] = actionSubjectId;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children || $[4] !== label || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            xcss: t1,
            "aria-label": label,
            testId: testId,
            "data-toolbar-type": "inline",
            children: [
                t2,
                children
            ]
        });
        $[3] = children;
        $[4] = label;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    const toolbar = t3;
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        let t4;
        if ($[8] !== ariaControls || $[9] !== ariaLabel || $[10] !== childComponentSelector || $[11] !== dom || $[12] !== handleEscape || $[13] !== handleFocus || $[14] !== isShortcutToFocusToolbar || $[15] !== toolbar) {
            t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
                childComponentSelector: childComponentSelector,
                dom: dom,
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                handleFocus: handleFocus,
                ariaControls: ariaControls,
                ariaLabel: ariaLabel,
                children: toolbar
            });
            $[8] = ariaControls;
            $[9] = ariaLabel;
            $[10] = childComponentSelector;
            $[11] = dom;
            $[12] = handleEscape;
            $[13] = handleFocus;
            $[14] = isShortcutToFocusToolbar;
            $[15] = toolbar;
            $[16] = t4;
        } else t4 = $[16];
        wrappedToolbar = t4;
    }
    let t4;
    if ($[17] !== wrappedToolbar) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveWrapper), {
            children: wrappedToolbar
        });
        $[17] = wrappedToolbar;
        $[18] = t4;
    } else t4 = $[18];
    return t4;
} : ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.toolbar, $726c97f63f4e2017$var$styles.toolbarResponsive, $726c97f63f4e2017$var$styles.hiddenSelectors, $726c97f63f4e2017$var$styles.toolbarSeparator, $726c97f63f4e2017$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2Wuyj.ViewEventEmitter), {
                actionSubject: (0, $2Wuyj.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $b2jdX.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jEaFE.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveWrapper), {
        children: wrappedToolbar
    });
};
const $726c97f63f4e2017$export$7469f9986edfc2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children, breakpointPreset: breakpointPreset, testId: testId } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t1,
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        });
        $[1] = children;
        $[2] = testId;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== breakpointPreset || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveContainer), {
            breakpointPreset: breakpointPreset,
            children: t2
        });
        $[4] = breakpointPreset;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ({ children: children, breakpointPreset: breakpointPreset, testId: testId })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gMrzi.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($726c97f63f4e2017$var$styles.toolbarBase, $726c97f63f4e2017$var$styles.primaryToolbar, $726c97f63f4e2017$var$styles.hiddenSelectors),
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        })
    });
};
module.exports["Toolbar"] = $726c97f63f4e2017$export$4c260019440d418f;
module.exports["PrimaryToolbar"] = $726c97f63f4e2017$export$7469f9986edfc2;

});

parcelRegister("gMrzi", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $2pQiO = parcelRequire("2pQiO");


var $iMnC5 = parcelRequire("iMnC5");

const $a746760df070e426$var$styles = {
    responsiveContainer: "_39xV02N91d _0u2WMmrU95 _3n40gWGjUA _3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _3C3owgYbGa _4t1h0mYbGa _3jMGqTYbGa _0FIqsbYbGa",
    responsiveContainerFullPage: "_39xV02E6Kk _3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _3C3owgYbGa _4t1h0mYbGa _3jMGqTYbGa _0FIqsbYbGa",
    fullpage: "_1rq8jLYbGa _0aYpZQvLZJ _2uUPwdYbGa _0032uovLZJ _3WuWXSYbGa _1hfhOsvLZJ _1UwYfAYbGa _12th9UvLZJ _3EFhkHvLZJ _39JjOcvLZJ _0L5H27vLZJ _34STP7vLZJ",
    fullpageUpdated: "_3x54HuYbGa _01WCBwvLZJ _3mkwgcYbGa _4sC1oWvLZJ _2uUPwdYbGa _0032uovLZJ _3MV8sXYbGa _3aN3WvvLZJ _3B0hPZvLZJ _0BUt8zvLZJ _2cnEzDvLZJ _3JK20ivLZJ",
    reduced: "_1mdU70YbGa _3gHiHXvLZJ _3cgyzIvLZJ _1gaO6tYbGa _2cYx2vvLZJ _1CnDTDvLZJ _2CNPNSYbGa _0j4V1pvLZJ _2afuuivLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jiraIssue: "_2I6R9qYbGa _3d33AUvLZJ _3DyQwZvLZJ _3U0x9yYbGa _3UVUXivLZJ _1pEq9LvLZJ _2nGSpMYbGa _41Ji6pvLZJ _149pM8vLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    jsmComment: "_1QRAXcYbGa _1AFPIdvLZJ _4mq0TavLZJ _1ZCm13YbGa _0NVVnzvLZJ _2GrInovLZJ _36lPUiYbGa _3QZ1XdvLZJ _39lxztvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    confluenceComment: "_2KtBBnYbGa _0PCBjdvLZJ _0vF73WvLZJ _2BIo24YbGa _0AeybuvLZJ _0PYKuevLZJ _2Y6dwmYbGa _4oeWH5vLZJ _40xblwvLZJ _1YIAQDYbGa _1nd9NrvLZJ _0xzigGvLZJ",
    responsiveRulesWrapper: "_3a6JJVvLZJ _3kAwDdvLZJ _40ffbvvLZJ _4BExMVvLZJ _2l4xMaYbGa _32vblKYbGa _1U3CxmYbGa _4tvqstYbGa _0cHb2BYbGa _3hCVfsvLZJ _1ZeYDsYbGa _1PZiqKvLZJ _11yBoBYbGa _0obMtNvLZJ _1aaAVJYbGa _4cWoU5vLZJ _223UMPYbGa _3X9hbPvLZJ _2ZXGV7YbGa _4aIPGovLZJ"
};
const $a746760df070e426$var$presetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpage,
    reduced: $a746760df070e426$var$styles.reduced,
    'jira-issue': $a746760df070e426$var$styles.jiraIssue,
    'jsm-comment': $a746760df070e426$var$styles.jsmComment,
    'confluence-comment': $a746760df070e426$var$styles.confluenceComment
};
const $a746760df070e426$var$updatedPresetStyleMap = {
    fullpage: $a746760df070e426$var$styles.fullpageUpdated
};
const $a746760df070e426$export$e60a4704009a0009 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, breakpointPreset: breakpointPreset } = t0;
    const isUpdatedConfig = breakpointPreset === "fullpage" && (0, $2pQiO.UNSAFE_expValNoExposure)("platform_editor_ai_content_suggested_edits", "isEnabled", false);
    const t1 = breakpointPreset === "fullpage" ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer;
    const t2 = isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset];
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = (0, $w6R6I.cx)(t1, t2);
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: t3,
            children: children
        });
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = breakpointPreset === 'fullpage' && (0, $2pQiO.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(breakpointPreset === 'fullpage' ? $a746760df070e426$var$styles.responsiveContainerFullPage : $a746760df070e426$var$styles.responsiveContainer, isUpdatedConfig ? $a746760df070e426$var$updatedPresetStyleMap[breakpointPreset] : $a746760df070e426$var$presetStyleMap[breakpointPreset]),
        children: children
    });
}; /**
    * A wrapper that supports responsiveness with media queries. It needs to used together with Show component
    */ 
const $a746760df070e426$export$fa6e408d6a7d6214 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $a746760df070e426$var$styles.responsiveRulesWrapper,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        xcss: $a746760df070e426$var$styles.responsiveRulesWrapper,
        children: children
    });
};
module.exports["ResponsiveContainer"] = $a746760df070e426$export$e60a4704009a0009;
module.exports["ResponsiveWrapper"] = $a746760df070e426$export$fa6e408d6a7d6214;

});

parcelRegister("jEaFE", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1hQ0e = parcelRequire("1hQ0e");

const $3dd4b47fb9e5cae4$export$881345eb2554ea9e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls } = t0;
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== childComponentSelector || $[1] !== dom || $[2] !== handleEscape || $[3] !== handleFocus || $[4] !== isShortcutToFocusToolbar) {
        t1 = ()=>{
            if (!wrapperRef.current) return;
            const { current: element } = wrapperRef;
            const getFocusableElements = ()=>{
                if (!element) return [];
                const focusableSelectors = [
                    "button:not([disabled])",
                    "[role=\"button\"]:not([disabled])",
                    "[tabindex]:not([tabindex=\"-1\"])"
                ].join(",");
                const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
                return allFocusable.filter((el)=>{
                    if (el.closest("[data-keyboard-navigation-independent]")) return false;
                    if (!el.closest(`${childComponentSelector}`)) return false;
                    let currentEl = el;
                    while(currentEl && currentEl !== element){
                        const computedStyle = window.getComputedStyle(currentEl);
                        if (computedStyle.display === "none" || computedStyle.visibility === "hidden") return false;
                        currentEl = currentEl.parentElement;
                    }
                    return true;
                });
            };
            const moveFocus = (direction)=>{
                const focusableElements = getFocusableElements();
                if (focusableElements.length === 0) return;
                const doc = (0, $1hQ0e.getDocument)();
                const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
                let nextIndex;
                if (currentIndex === -1) nextIndex = 0;
                else if (direction === "right") nextIndex = (currentIndex + 1) % focusableElements.length;
                else nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
                focusableElements[nextIndex]?.focus();
            };
            const handleTab = ()=>{
                const focusableElements_0 = getFocusableElements();
                if (focusableElements_0.length === 0) return;
                const doc_0 = (0, $1hQ0e.getDocument)();
                let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
                if (index < 0) index = 0;
                focusableElements_0.forEach($3dd4b47fb9e5cae4$var$_temp);
                focusableElements_0[index].setAttribute("tabindex", "0");
            };
            const handleKeyDown = (event)=>{
                const targetElement = event.target;
                if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
                if (targetElement instanceof HTMLElement && targetElement.closest("[data-keyboard-navigation-independent]")) return;
                bb96: switch(event.key){
                    case "Escape":
                        handleEscape(event);
                        break bb96;
                    case "ArrowLeft":
                        event.preventDefault();
                        moveFocus("left");
                        break bb96;
                    case "ArrowRight":
                        event.preventDefault();
                        moveFocus("right");
                        break bb96;
                    case "Tab":
                        handleTab();
                        break bb96;
                    default:
                }
            };
            const globalKeyDownHandler = (event_0)=>{
                if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
            };
            element?.addEventListener("keydown", handleKeyDown);
            dom?.addEventListener("keydown", globalKeyDownHandler);
            return ()=>{
                element?.removeEventListener("keydown", handleKeyDown);
                dom?.removeEventListener("keydown", globalKeyDownHandler);
            };
        };
        t2 = [
            wrapperRef,
            childComponentSelector,
            dom,
            isShortcutToFocusToolbar,
            handleFocus,
            handleEscape
        ];
        $[0] = childComponentSelector;
        $[1] = dom;
        $[2] = handleEscape;
        $[3] = handleFocus;
        $[4] = isShortcutToFocusToolbar;
        $[5] = t1;
        $[6] = t2;
    } else {
        t1 = $[5];
        t2 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[7] !== ariaControls || $[8] !== ariaLabel || $[9] !== children) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: "custom-key-handler-wrapper",
            ref: wrapperRef,
            role: "toolbar",
            "aria-label": ariaLabel,
            "aria-controls": ariaControls,
            children: children
        });
        $[7] = ariaControls;
        $[8] = ariaLabel;
        $[9] = children;
        $[10] = t3;
    } else t3 = $[10];
    return t3;
} : ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                // Independent containers own their key handling and tab stops.
                if (el.closest('[data-keyboard-navigation-independent]')) return false;
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $1hQ0e.getDocument)();
            const currentIndex = focusableElements.findIndex((el_0)=>el_0 === doc?.activeElement);
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            focusableElements[nextIndex]?.focus();
        };
        const handleTab = ()=>{
            const focusableElements_0 = getFocusableElements();
            if (focusableElements_0.length === 0) return;
            const doc_0 = (0, $1hQ0e.getDocument)();
            let index = doc_0?.activeElement ? focusableElements_0.findIndex((el_1)=>el_1 === doc_0?.activeElement) : 0;
            if (index < 0) index = 0;
            focusableElements_0.forEach((el_2)=>el_2.setAttribute('tabindex', '-1'));
            focusableElements_0[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && targetElement.closest('[data-keyboard-navigation-independent]')) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event_0)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event_0)) handleFocus(event_0);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element?.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom?.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element?.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom?.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};
function $3dd4b47fb9e5cae4$var$_temp(el_2) {
    return el_2.setAttribute("tabindex", "-1");
}
module.exports["ToolbarKeyboardNavigationProvider"] = $3dd4b47fb9e5cae4$export$881345eb2554ea9e;

});

parcelRegister("2Wuyj", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $b2jdX = parcelRequire("b2jdX");

const $171e330111381e98$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $171e330111381e98$export$58d0f383acf77599 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { actionSubjectId: actionSubjectId, actionSubject: actionSubject } = t0;
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    let t1;
    let t2;
    if ($[0] !== actionSubject || $[1] !== actionSubjectId || $[2] !== fireAnalyticsEvent) {
        t1 = ()=>{
            if (isMountedRef.current) return;
            isMountedRef.current = true;
            const payload = {
                action: "viewed",
                actionSubject: actionSubject,
                actionSubjectId: actionSubjectId,
                eventType: "ui"
            };
            fireAnalyticsEvent && fireAnalyticsEvent(payload);
        };
        t2 = [
            actionSubjectId,
            actionSubject,
            fireAnalyticsEvent
        ];
        $[0] = actionSubject;
        $[1] = actionSubjectId;
        $[2] = fireAnalyticsEvent;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $cozmU.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $b2jdX.useToolbarUI)();
    (0, $cozmU.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};
module.exports["ACTION_SUBJECT"] = $171e330111381e98$export$7525482b5931e326;
module.exports["ViewEventEmitter"] = $171e330111381e98$export$58d0f383acf77599;

});

parcelRegister("isuYJ", function(module, exports) {

var $d5Ozc = parcelRequire("d5Ozc");

function $a1048cda8104f400$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $d5Ozc.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}
module.exports["conditionalHooksFactory"] = $a1048cda8104f400$export$691e93bad45e6f07;

});

parcelRegister("d5Ozc", function(module, exports) {
const $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] = globalThis[$dacf5aee5e6a9a5a$export$3c82709bf1b7e3a] || new WeakMap();
module.exports["CACHE_MAP_KEY"] = $dacf5aee5e6a9a5a$export$3c82709bf1b7e3a;

});

parcelRegister("dhtsm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32f92d4b4659c87427bca36d4cc14c22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ab3b6586bd7bdc0$var$_react = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("cozmU")));

var $9ab3b6586bd7bdc0$var$_iconNew = $9ab3b6586bd7bdc0$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $9ab3b6586bd7bdc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/field-text
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ab3b6586bd7bdc0$var$FieldTextIcon = (props)=>/*#__PURE__*/ $9ab3b6586bd7bdc0$var$_react.default.createElement($9ab3b6586bd7bdc0$var$_iconNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$9ab3b6586bd7bdc0$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $9ab3b6586bd7bdc0$var$_default = module.exports.default = $9ab3b6586bd7bdc0$var$FieldTextIcon;

});

parcelRegister("5ZJRm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");



class $928d71b7a1b056f3$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.mounted = true;
        if (!this.state.Browser) Promise.all([
            (parcelRequire("gLZqH")),
            (parcelRequire("lkjuR"))
        ]).then(([mediaClient, browserModule])=>{
            // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
            $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
            });
        });
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser
        };
    }
}
$928d71b7a1b056f3$export$3ce634ac4a869e2c.displayName = 'AsyncBrowser';
$928d71b7a1b056f3$export$3ce634ac4a869e2c.Browser = void 0;
module.exports["BrowserLoader"] = $928d71b7a1b056f3$export$3ce634ac4a869e2c;

});

parcelRegister("gLZqH", function(module, exports) {

let $c360afc884decf86$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c360afc884decf86$var$load("RI3SR").then(()=>parcelRequire('g0fSg'));

});

parcelRegister("lkjuR", function(module, exports) {

let $f86a96de0bbbcbde$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f86a96de0bbbcbde$var$load("coGVA"),
    $f86a96de0bbbcbde$var$load("jwRVQ"),
    $f86a96de0bbbcbde$var$load("789Z9"),
    $f86a96de0bbbcbde$var$load("20wSi"),
    $f86a96de0bbbcbde$var$load("5ouIR")
]).then(()=>parcelRequire('e7T2P'));

});

parcelRegister("b3nqj", function(module, exports) {
const $39262f9932c4c2bd$export$245097525aef1262 = 'sli';
const $39262f9932c4c2bd$export$c724588856bbfbcf = 'smart';
const $39262f9932c4c2bd$export$990f5c29478a61aa = 'atlassian.fabric.mention';
module.exports["SLI_EVENT_TYPE"] = $39262f9932c4c2bd$export$245097525aef1262;
module.exports["SMART_EVENT_TYPE"] = $39262f9932c4c2bd$export$c724588856bbfbcf;

});

parcelRegister("dJKHF", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $c171ae8007140e98$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === (0, $caelp.UserType)[(0, $caelp.UserType).APP];
}
module.exports["isAppMention"] = $c171ae8007140e98$export$eb590c844d13454c;

});

parcelRegister("jymSm", function(module, exports) {

var $caelp = parcelRequire("caelp");

function $9c55ebf48e033037$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === (0, $caelp.UserType)[(0, $caelp.UserType).TEAM];
}
module.exports["isTeamMention"] = $9c55ebf48e033037$export$803b1379348dbfd5;

});

parcelRegister("fKJ7J", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $65facb8c38219af1$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    tableScrollRegion: {
        id: "fabric.editor.tableScrollRegion",
        defaultMessage: "Table scroll region"
    },
    tableOptions: {
        id: "fabric.editor.tableOptions",
        defaultMessage: "Table options"
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeIncreaseScreenReaderInformation",
        defaultMessage: "Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: "fabric.editor.tableResizeDecreaseScreenReaderInformation",
        defaultMessage: "Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}."
    },
    headerRow: {
        id: "fabric.editor.headerRow",
        defaultMessage: "Header row"
    },
    headerColumn: {
        id: "fabric.editor.headerColumn",
        defaultMessage: "Header column"
    },
    numberedColumn: {
        id: "fabric.editor.numberedColumn",
        defaultMessage: "Numbered column"
    },
    collapseTable: {
        id: "fabric.editor.collapseTable",
        defaultMessage: "Collapse table"
    },
    resizeTable: {
        id: "fabric.editor.tables.resizeTable",
        defaultMessage: "Resize table"
    },
    insertColumn: {
        id: "fabric.editor.insertColumn",
        defaultMessage: "Insert column right"
    },
    addColumnLeft: {
        id: "fabric.editor.addColumnLeft",
        defaultMessage: "Add column left"
    },
    addColumnRight: {
        id: "fabric.editor.addColumnRight",
        defaultMessage: "Add column right"
    },
    insertColumnDrag: {
        id: "fabric.editor.insertColumnDrag",
        defaultMessage: "Insert column"
    },
    removeColumns: {
        id: "fabric.editor.removeColumns",
        defaultMessage: "Delete {0, plural, one {column} other {columns}}"
    },
    insertRow: {
        id: "fabric.editor.insertRow",
        defaultMessage: "Insert row below"
    },
    addRowAbove: {
        id: "fabric.editor.addRowAbove",
        defaultMessage: "Add row above"
    },
    addRowBelow: {
        id: "fabric.editor.addRowBelow",
        defaultMessage: "Add row below"
    },
    moveColumnLeft: {
        id: "fabric.editor.moveColumnLeft",
        defaultMessage: "Move {0, plural, one {column} other {columns}} left"
    },
    moveColumnLeftHelpDialogLabel: {
        id: "fabric.editor.moveColumnLeftHelpDialogLabel",
        defaultMessage: "Move column left"
    },
    moveColumnRight: {
        id: "fabric.editor.moveColumnRight",
        defaultMessage: "Move {0, plural, one {column} other {columns}} right"
    },
    moveColumnRightHelpDialogLabel: {
        id: "fabric.editor.moveColumnRightHelpDialogLabel",
        defaultMessage: "Move column right"
    },
    moveRowUp: {
        id: "fabric.editor.moveRowUp",
        defaultMessage: "Move {0, plural, one {row} other {rows}} up"
    },
    moveRowUpHelpDialogLabel: {
        id: "fabric.editor.moveRowUpHelpDialogLabel",
        defaultMessage: "Move row up"
    },
    moveRowDown: {
        id: "fabric.editor.moveDownDown",
        defaultMessage: "Move {0, plural, one {row} other {rows}} down"
    },
    moveRowDownHelpDialogLabel: {
        id: "fabric.editor.moveRowDownHelpDialogLabel",
        defaultMessage: "Move row down"
    },
    insertRowDrag: {
        id: "fabric.editor.insertRowDrag",
        defaultMessage: "Insert row"
    },
    removeRows: {
        id: "fabric.editor.removeRows",
        defaultMessage: "Delete {0, plural, one {row} other {rows}}"
    },
    rowNumbers: {
        id: "fabrid.editor.rowNumbers",
        defaultMessage: "Row numbers"
    },
    numberedRows: {
        id: "fabrid.editor.numberedRows",
        defaultMessage: "Numbered rows"
    },
    rowsAreInserted: {
        id: "fabric.editor.rowsAreInserted",
        defaultMessage: "{count, plural, one {A row has been} other {{count} rows have been}} inserted"
    },
    rowsAreRemoved: {
        id: "fabric.editor.rowsAreRemoved",
        defaultMessage: "{count, plural, one {The row has been} other {{count} rows have been}} removed"
    },
    rowSelected: {
        id: "fabric.editor.rowSelected",
        defaultMessage: "Row {index} of {total} selected"
    },
    rowMovedUp: {
        id: "fabric.editor.rowMovedUp",
        defaultMessage: "Row moved up to {index} of {total}"
    },
    rowMovedDown: {
        id: "fabric.editor.rowMovedDown",
        defaultMessage: "Row moved down to {index} of {total}"
    },
    columnsAreInserted: {
        id: "fabric.editor.columnsAreInserted",
        defaultMessage: "{count, plural, one {A column has been} other {{count} columns have been}} inserted"
    },
    columnsAreRemoved: {
        id: "fabric.editor.columnsAreRemoved",
        defaultMessage: "{count, plural, one {The column has been} other {{count} columns have been}} removed"
    },
    columnSelected: {
        id: "fabric.editor.columnSelected",
        defaultMessage: "Column {index} of {total} selected"
    },
    columnMovedLeft: {
        id: "fabric.editor.columnMovedLeft",
        defaultMessage: "Column moved left to {index} of {total}"
    },
    columnMovedRight: {
        id: "fabric.editor.columnMovedRight",
        defaultMessage: "Column moved right to {index} of {total}"
    },
    cellOptions: {
        id: "fabric.editor.cellOptions",
        defaultMessage: "Cell options"
    },
    confirmDeleteLinkedModalOKButton: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalOKButton",
        defaultMessage: "Delete"
    },
    confirmDeleteLinkedModalMessage: {
        id: "fabric.editor.tables.confirmDeleteLinkedModalMessage",
        defaultMessage: "Deleting {nodeName} will break anything connected to it."
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: "fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix",
        defaultMessage: "Deleting"
    },
    confirmModalCheckboxLabel: {
        id: "fabric.editor.floatingToolbar.confirmModalCheckboxLabel",
        defaultMessage: "Also delete connected elements"
    },
    deleteElementTitle: {
        id: "fabric.editor.extension.deleteElementTitle",
        defaultMessage: "Delete element"
    },
    unnamedSource: {
        id: "fabric.editor.extension.sourceNoTitledName",
        defaultMessage: "this element"
    },
    adjustColumns: {
        id: "fabric.editor.tables.adjustColumn",
        defaultMessage: "Adjust column"
    },
    cornerControl: {
        id: "fabric.editor.cornerControl",
        defaultMessage: "Highlight table"
    },
    cellBackground: {
        id: "fabric.editor.cellBackground",
        defaultMessage: "Cell background"
    },
    cellAlignment: {
        id: "fabric.editor.table.cellAlignment",
        defaultMessage: "Alignment"
    },
    cellAlignmentTop: {
        id: "fabric.editor.table.cellAlignmentTop",
        defaultMessage: "Top"
    },
    cellAlignmentMiddle: {
        id: "fabric.editor.table.cellAlignmentMiddle",
        defaultMessage: "Middle"
    },
    cellAlignmentBottom: {
        id: "fabric.editor.table.cellAlignmentBottom",
        defaultMessage: "Bottom"
    },
    backgroundColor: {
        id: "fabric.editor.backgroundColor",
        defaultMessage: "Background color"
    },
    mergeCells: {
        id: "fabric.editor.mergeCells",
        defaultMessage: "Merge cells"
    },
    splitCell: {
        id: "fabric.editor.splitCell",
        defaultMessage: "Split cell"
    },
    clearCells: {
        id: "fabric.editor.clearCells",
        defaultMessage: "Clear {0, plural, one {cell} other {cells}}"
    },
    sortColumnASC: {
        id: "fabric.editor.sortColumnASC",
        defaultMessage: "Sort column A \u2192 Z"
    },
    sortColumnDESC: {
        id: "fabric.editor.sortColumnDESC",
        defaultMessage: "Sort column Z \u2192 A"
    },
    sortColumnIncreasing: {
        id: "fabric.editor.sortColumnIncreasing",
        defaultMessage: "Sort increasing"
    },
    sortColumnDecreasing: {
        id: "fabric.editor.sortColumnDecreasing",
        defaultMessage: "Sort decreasing"
    },
    canNotSortTable: {
        id: "fabric.editor.canNotSortTable",
        defaultMessage: "\u26A0\uFE0F You can't sort a table with merged cells"
    },
    canNotSortTableNoIcon: {
        id: "fabric.editor.canNotSortTableNoIcon",
        defaultMessage: "You can't sort a table with merged cells"
    },
    canNotMoveColumnLeftWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveColumnLeftWithMergedCells",
        defaultMessage: "You can't move a column left with merged cells"
    },
    canNotMoveColumnRightWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveColumnRightWithMergedCells",
        defaultMessage: "You can't move a column right with merged cells"
    },
    canNotMoveRowDownWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveRowDownWithMergedCells",
        defaultMessage: "You can't move a row down with merged cells"
    },
    canNotMoveRowUpWithMergedCells: {
        id: "editor-common.messages.table.canNotMoveRowUpWithMergedCells",
        defaultMessage: "You can't move a row up with merged cells"
    },
    distributeColumns: {
        id: "fabric.editor.distributeColumns",
        defaultMessage: "Distribute columns"
    },
    fitToContent: {
        id: "fabric.editor.fitToContent",
        defaultMessage: "Fit to content"
    },
    lockColumnWidths: {
        id: "fabric.editor.lockColumns",
        defaultMessage: "Fixed column widths"
    },
    rowControl: {
        id: "fabric.editor.rowControl",
        defaultMessage: "Highlight row"
    },
    rowDragHandle: {
        id: "fabric.editor.rowDragHandle",
        defaultMessage: "Row options"
    },
    dragHandleZone: {
        id: "fabric.editor.dragHandleZone",
        defaultMessage: "Activate drag handle zone"
    },
    columnDragHandle: {
        id: "fabric.editor.columnDragHandle",
        defaultMessage: "Column options"
    },
    fullWidthLabel: {
        id: "fabric.editor.tableFullWidthLabel",
        defaultMessage: "Full-width"
    },
    startedColumnResize: {
        id: "fabric.editor.tables.startedColumnResize",
        defaultMessage: "Started column resize"
    },
    focusedOtherResize: {
        id: "fabric.editor.tables.otherResize",
        defaultMessage: "{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}"
    },
    changedColumnWidth: {
        id: "fabric.editor.tables.columnWidth",
        defaultMessage: "{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}"
    },
    columnResizeStop: {
        id: "fabric.editor.tables.resizeStop",
        defaultMessage: "Stopped resize"
    },
    columnResizeOverflow: {
        id: "fabric.editor.tables.columnResizeOverflow",
        defaultMessage: "You can only resize this column while the table has a scroll bar."
    },
    columnResizeLast: {
        id: "fabric.editor.tables.columnResizeLast",
        defaultMessage: "You can only resize this column to the left."
    },
    tableAlignmentOptions: {
        id: "fabric.editor.tableAlignmentOptions",
        defaultMessage: "Alignment options"
    },
    alignTableCenter: {
        id: "fabric.editor.alignTableCenter",
        defaultMessage: "Align center"
    },
    alignTableLeft: {
        id: "fabric.editor.alignTableLeft",
        defaultMessage: "Align left"
    }
});
module.exports["messages"] = $65facb8c38219af1$export$defe85febe8b728c;

});

parcelRegister("g4Dow", function(module, exports) {

var $NRi3o = parcelRequire("NRi3o");

class $bcf6771165225992$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        (0, $NRi3o.fireSmartLinkEvent)({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
module.exports["SmartLinkEvents"] = $bcf6771165225992$export$b91e0203b928470c;

});

parcelRegister("NRi3o", function(module, exports) {

var $6GOAK = parcelRequire("6GOAK");

const $43c279dc5065c317$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $6GOAK.ANALYTICS_CHANNEL));
};
module.exports["fireSmartLinkEvent"] = $43c279dc5065c317$export$2a123f7ee48a122c;

});

parcelRegister("19KQj", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $cozmU = parcelRequire("cozmU");


var $g4Dow = parcelRequire("g4Dow");


function $dc3ded826fe771fd$export$ed70996d478e16d3() {
    /**
   * this utility maybe extended in the future to include
   * more contextual info about SLs
   */ const events = (0, $cozmU.useMemo)(()=>new (0, $g4Dow.SmartLinkEvents)(), []);
    return events;
}
module.exports["useSmartLinkEvents"] = $dc3ded826fe771fd$export$ed70996d478e16d3;

});

parcelRegister("8zgL4", function(module, exports) {

var $79D42 = parcelRequire("79D42");


var $j6gAQ = parcelRequire("j6gAQ");


var $jSNLM = parcelRequire("jSNLM");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $63ce9773a8ff0858$var$map(collection, iteratee) {
    var func = $1ScXu(collection) ? $79D42 : $jSNLM;
    return func(collection, $j6gAQ(iteratee, 3));
}
module.exports = $63ce9773a8ff0858$var$map;

});

parcelRegister("jSNLM", function(module, exports) {

var $bNHBU = parcelRequire("bNHBU");


var $9pMwd = parcelRequire("9pMwd");

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e799aab2808214b2$var$baseMap(collection, iteratee) {
    var index = -1, result = $9pMwd(collection) ? Array(collection.length) : [];
    $bNHBU(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $e799aab2808214b2$var$baseMap;

});

parcelRegister("iXlTL", function(module, exports) {

var $2SUNK = parcelRequire("2SUNK");


var $dvMxu = parcelRequire("dvMxu");

const $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS = 20;
class $f6b0f26d443249fd$export$8576ba1ed2760927 extends (0, $dvMxu.AbstractResource) {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2SUNK.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2SUNK.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $f6b0f26d443249fd$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2SUNK.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
module.exports["AbstractMentionResource"] = $f6b0f26d443249fd$export$8576ba1ed2760927;

});

parcelRegister("dvMxu", function(module, exports) {
class $5c4239d07c0ef4c8$export$4529f10aed0950d4 {
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
    constructor(){
        this.changeListeners = void 0;
        this.errListeners = void 0;
        this.infoListeners = void 0;
        this.allResultsListeners = void 0;
        this.analyticsListeners = void 0;
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
}
module.exports["AbstractResource"] = $5c4239d07c0ef4c8$export$4529f10aed0950d4;

});

parcelRegister("gQEZd", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4414baec8e12e18$export$2e2bcd8739ae039);

var $dkBOe = parcelRequire("dkBOe");


var $7D31j = parcelRequire("7D31j");


var $3yGK6 = parcelRequire("3yGK6");

function $c4414baec8e12e18$export$2e2bcd8739ae039(date, options) {
    var _options$format, _options$representati;
    (0, $3yGK6.default)(1, arguments);
    var originalDate = (0, $dkBOe.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, $7D31j.default)(originalDate.getDate(), 2);
        var month = (0, $7D31j.default)(originalDate.getMonth() + 1, 2);
        var year = (0, $7D31j.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, $7D31j.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, $7D31j.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, $7D31j.default)(originalDate.getHours(), 2);
        var minute = (0, $7D31j.default)(originalDate.getMinutes(), 2);
        var second = (0, $7D31j.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

});

parcelRegister("i1agE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::251f5452f3f0754765959a05130502fa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1e048e4b12a2678$var$_react = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("cozmU")));

var $d1e048e4b12a2678$var$_iconNew = $d1e048e4b12a2678$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $d1e048e4b12a2678$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/warning-outline
 * Usage guidance:
 * Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1e048e4b12a2678$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $d1e048e4b12a2678$var$_react.default.createElement($d1e048e4b12a2678$var$_iconNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$d1e048e4b12a2678$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $d1e048e4b12a2678$var$_default = module.exports.default = $d1e048e4b12a2678$var$WarningOutlineIcon;

});

parcelRegister("aOjGz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::630f7862dea052120b01b06315f58212>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7dedd806b3dd6402$var$_react = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("cozmU")));

var $7dedd806b3dd6402$var$_iconNew = $7dedd806b3dd6402$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $7dedd806b3dd6402$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/spaces
 * Usage guidance:
 * Reserved for use for Jira Projects for now. This will replace the Jira rocket.
 * 
 * More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7dedd806b3dd6402$var$SpacesIcon = (props)=>/*#__PURE__*/ $7dedd806b3dd6402$var$_react.default.createElement($7dedd806b3dd6402$var$_iconNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.497A5.98 5.98 0 0 1 11 13.196a5.98 5.98 0 0 1-4.608.584 29.4 29.4 0 0 0 3.858-1.882 29.4 29.4 0 0 0 3.559-2.401"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.424 2.308-.447.377-.013.751.017 1.083.126.338.111.678.32.888.685.354.613.152 1.296-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.396c-.444.413-.954.837-1.517 1.263a29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.581c-.65.275-1.272.505-1.85.683h-.003q-.28.087-.548.158c-.783.206-1.511.318-2.116.288-.505-.024-1.114-.161-1.49-.63l-.052-.068-.07-.11-.07-.138a1.6 1.6 0 0 1-.078-.973c.071-.342.231-.68.431-1 .35-.56.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.5a6 6 0 0 0-.698.878c-.147.235-.213.407-.236.516l-.004.046c.048.022.155.056.37.066.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34a4.5 4.5 0 0 0 1.24 2.396C5.986 10.743 7.347 10.11 8.75 9.3s2.63-1.673 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36c-.306.01-.68.066-1.111.165q.233.306.432.648.196.341.342.695c.394-.424.665-.789.816-1.081.098-.192.121-.302.127-.355l-.041-.018c-.106-.035-.288-.063-.565-.054" clip-rule="evenodd"/>`
    }, props));
$7dedd806b3dd6402$var$SpacesIcon.displayName = 'SpacesIcon';
var $7dedd806b3dd6402$var$_default = module.exports.default = $7dedd806b3dd6402$var$SpacesIcon;

});

parcelRegister("7JHs4", function(module, exports) {

var $7cOM2 = parcelRequire("7cOM2");

const $7a6b4c41eab74d34$export$4ed794c7d557e96c = (skillAri)=>(0, $7cOM2.RovoSkillAri).check(skillAri);
module.exports["isCustomSkill"] = $7a6b4c41eab74d34$export$4ed794c7d557e96c;

});

parcelRegister("7cOM2", function(module, exports) {

var $5Qmva = parcelRequire("5Qmva");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/rovo/skill/manifest.ts
var $53f10a0782e7c469$var$rovoSkillAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5Qmva.RovoSkillAriResourceOwner),
    resourceType: (0, $5Qmva.RovoSkillAriResourceType),
    resourceIdSlug: "activation/{activationId}/{skillId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        skillId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/rovo/skill/index.ts
var $53f10a0782e7c469$export$600deb9b76723b82 = class _RovoSkillAri extends (0, $9j37t.RegisteredAri) {
    get activationId() {
        return this._activationId;
    }
    get skillId() {
        return this._skillId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $53f10a0782e7c469$var$rovoSkillAriStaticOpts.qualifier,
            platformQualifier: $53f10a0782e7c469$var$rovoSkillAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $53f10a0782e7c469$var$rovoSkillAriStaticOpts.resourceOwner,
            resourceType: $53f10a0782e7c469$var$rovoSkillAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.skillId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                skillId: opts.skillId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $53f10a0782e7c469$var$rovoSkillAriStaticOpts);
        return new _RovoSkillAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $53f10a0782e7c469$var$rovoSkillAriStaticOpts);
        return new _RovoSkillAri(opts);
    }
    getVariables() {
        return {
            activationId: this.activationId,
            skillId: this.skillId
        };
    }
    constructor(opts){
        super(opts), this._activationId = opts.resourceIdSegmentValues.activationId, this._skillId = opts.resourceIdSegmentValues.skillId;
    }
};
module.exports["RovoSkillAri"] = $53f10a0782e7c469$export$600deb9b76723b82;

});

parcelRegister("5Qmva", function(module, exports) {
// src/rovo/skill/types.ts
var $4413436cecb8e596$export$81cd1bc4e5b170fb = "rovo", $4413436cecb8e596$export$91ee5cc73270e65d = "skill";
module.exports["RovoSkillAriResourceOwner"] = $4413436cecb8e596$export$81cd1bc4e5b170fb;
module.exports["RovoSkillAriResourceType"] = $4413436cecb8e596$export$91ee5cc73270e65d;

});

parcelRegister("9OqBj", function(module, exports) {
const $e3eab036398f830e$export$3056677f7f7d8f5d = {
    LIME: {
        default: "var(--ds-border-accent-lime, #6A9A23)",
        icon: "var(--ds-icon-accent-lime, #6A9A23)"
    },
    RED: {
        default: "var(--ds-border-accent-red, #E2483D)",
        icon: "var(--ds-icon-accent-red, #C9372C)"
    },
    ORANGE: {
        default: "var(--ds-border-accent-orange, #E06C00)",
        icon: "var(--ds-icon-accent-orange, #E06C00)"
    },
    YELLOW: {
        default: "var(--ds-border-accent-yellow, #B38600)",
        icon: "var(--ds-icon-accent-yellow, #B38600)"
    },
    GREEN: {
        default: "var(--ds-border-accent-green, #22A06B)",
        icon: "var(--ds-icon-accent-green, #22A06B)"
    },
    TEAL: {
        default: "var(--ds-border-accent-teal, #2898BD)",
        icon: "var(--ds-icon-accent-teal, #2898BD)"
    },
    BLUE: {
        default: "var(--ds-border-accent-blue, #357DE8)",
        icon: "var(--ds-icon-accent-blue, #357DE8)"
    },
    PURPLE: {
        default: "var(--ds-border-accent-purple, #AF59E1)",
        icon: "var(--ds-icon-accent-purple, #AF59E1)"
    },
    MAGENTA: {
        default: "var(--ds-border-accent-magenta, #CD519D)",
        icon: "var(--ds-icon-accent-magenta, #CD519D)"
    },
    GRAY: {
        default: "var(--ds-border-accent-gray, #7D818A)",
        icon: "var(--ds-icon-accent-gray, #7D818A)"
    },
    DEFAULT: {
        default: "var(--ds-border, #0B120E24)",
        inverse: "var(--ds-border-inverse, #FFFFFF)",
        icon: "var(--ds-icon-subtle, #505258)"
    }
};
const $e3eab036398f830e$export$dbc6cfecd630bcea = (color, invertColors)=>{
    if (color) {
        const colorObject = $e3eab036398f830e$export$3056677f7f7d8f5d[color];
        const colorType = invertColors ? 'inverse' : 'default';
        return colorObject?.[colorType] ?? colorObject?.default ?? "var(--ds-border, #0B120E24)";
    }
    return invertColors ? "var(--ds-border-inverse, #FFFFFF)" : "var(--ds-border, #0B120E24)";
};
const $e3eab036398f830e$export$bb417e0702eb86b5 = (color, invertColors)=>{
    if (color) {
        const colorObject = $e3eab036398f830e$export$3056677f7f7d8f5d[color];
        if (invertColors && color === 'DEFAULT') return "var(--ds-icon-inverse, #FFFFFF)";
        return colorObject?.icon ?? "var(--ds-icon-subtle, #505258)";
    }
    return invertColors ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon-subtle, #505258)";
};
module.exports["SKILL_COLOR_MAP"] = $e3eab036398f830e$export$3056677f7f7d8f5d;
module.exports["getIconColor"] = $e3eab036398f830e$export$bb417e0702eb86b5;

});

parcelRegister("9MCKh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");






































const $d0265bb51b10f57e$export$dce8bc0f04f0d915 = {
    skill: ()=>(parcelRequire("d7YwR")),
    assets: ()=>Promise.resolve((parcelRequire("437ur"))),
    add: ()=>Promise.resolve((parcelRequire("gFEZF"))),
    'chart-bar-line': ()=>(parcelRequire("kU1Yt")),
    'ai-generative-text': ()=>(parcelRequire("44fpQ")),
    'work-item': ()=>Promise.resolve((parcelRequire("iRFKG"))),
    'lock-locked': ()=>Promise.resolve((parcelRequire("4efpo"))),
    'chart-pie': ()=>(parcelRequire("e8Ghu")),
    plan: ()=>(parcelRequire("fhtzK")),
    settings: ()=>Promise.resolve((parcelRequire("11OF7"))),
    'project-status': ()=>(parcelRequire("duNV8")),
    'merge-success': ()=>(parcelRequire("3pUsI")),
    'person-add': ()=>(parcelRequire("1ORsb")),
    'people-group': ()=>Promise.resolve((parcelRequire("fBqzD"))),
    'person-added': ()=>(parcelRequire("1VVw9")),
    login: ()=>(parcelRequire("lp0Ka")),
    'ai-generative-text-summary': ()=>Promise.resolve((parcelRequire("f0b2F"))),
    transition: ()=>(parcelRequire("lPrvY")),
    board: ()=>Promise.resolve((parcelRequire("4MdqE"))),
    release: ()=>Promise.resolve((parcelRequire("2F2yY"))),
    'app-switcher': ()=>(parcelRequire("gfpxd")),
    search: ()=>Promise.resolve((parcelRequire("hAgam"))),
    'playlist-add': ()=>(parcelRequire("lJQ5X")),
    'playlist-remove': ()=>(parcelRequire("bYXrx")),
    summary: ()=>Promise.resolve((parcelRequire("f0b2F"))),
    clock: ()=>Promise.resolve((parcelRequire("5ZtfK"))),
    'ai-generative-chapters': ()=>(parcelRequire("62FON")),
    talent: ()=>(parcelRequire("j74pS")),
    incident: ()=>Promise.resolve((parcelRequire("ipvL3"))),
    form: ()=>(parcelRequire("e3rWd")),
    ticket: ()=>(parcelRequire("fS7mD")),
    alert: ()=>(parcelRequire("hBRNG")),
    pulse: ()=>(parcelRequire("4SYP6")),
    'text-lengthen': ()=>Promise.resolve((parcelRequire("2xJ2w"))),
    'ai-generative-cleanup': ()=>(parcelRequire("ivYfD")),
    survey: ()=>(parcelRequire("eNJEs")),
    'text-review': ()=>(parcelRequire("9ImZK"))
};
const $d0265bb51b10f57e$export$ca2f546e21dcce87 = $d0265bb51b10f57e$export$dce8bc0f04f0d915.skill;
const $d0265bb51b10f57e$export$f7883dcc9f65479a = Object.fromEntries(Object.entries($d0265bb51b10f57e$export$dce8bc0f04f0d915).map(([key, loader])=>[
        key,
        (0, $cozmU.lazy)(loader)
    ]));
const $d0265bb51b10f57e$export$78596fa6083c04d1 = $d0265bb51b10f57e$export$f7883dcc9f65479a.skill;
module.exports["skillIcon"] = $d0265bb51b10f57e$export$dce8bc0f04f0d915;
module.exports["defaultIcon"] = $d0265bb51b10f57e$export$ca2f546e21dcce87;
module.exports["skillIconMap"] = $d0265bb51b10f57e$export$f7883dcc9f65479a;
module.exports["DefaultSkillIcon"] = $d0265bb51b10f57e$export$78596fa6083c04d1;

});

parcelRegister("d7YwR", function(module, exports) {

let $98eae1a14b896567$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98eae1a14b896567$var$load("ji2ex").then(()=>parcelRequire('h5LaW'));

});

parcelRegister("kU1Yt", function(module, exports) {

let $f37a91b0c5a24fd5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f37a91b0c5a24fd5$var$load("hrkGn").then(()=>parcelRequire('5kuIA'));

});

parcelRegister("44fpQ", function(module, exports) {

let $2f637e6c42f731d0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2f637e6c42f731d0$var$load("5k22f").then(()=>parcelRequire('9V507'));

});

parcelRegister("e8Ghu", function(module, exports) {

let $a4b29c33d05c1a9b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4b29c33d05c1a9b$var$load("c6nMJ").then(()=>parcelRequire('eVhjN'));

});

parcelRegister("fhtzK", function(module, exports) {

let $b1ff629eca57471a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1ff629eca57471a$var$load("i1I18").then(()=>parcelRequire('dIT3V'));

});

parcelRegister("duNV8", function(module, exports) {

let $9d34ccdd49f0003a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d34ccdd49f0003a$var$load("bSZcP").then(()=>parcelRequire('6fcYF'));

});

parcelRegister("3pUsI", function(module, exports) {

let $27cf81197ca52259$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27cf81197ca52259$var$load("3GLMP").then(()=>parcelRequire('bAdTB'));

});

parcelRegister("1ORsb", function(module, exports) {

let $1533ecb52c97b893$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1533ecb52c97b893$var$load("kBatH").then(()=>parcelRequire('am3XR'));

});

parcelRegister("1VVw9", function(module, exports) {

let $1687bb1e68c06fb7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $1687bb1e68c06fb7$var$load("iN26T").then(()=>parcelRequire('4s4Os'));

});

parcelRegister("lp0Ka", function(module, exports) {

let $f94c827133a4a8ea$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f94c827133a4a8ea$var$load("85Ack").then(()=>parcelRequire('hPGQU'));

});

parcelRegister("lPrvY", function(module, exports) {

let $fe43b4375d61c3d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fe43b4375d61c3d3$var$load("jjuzw").then(()=>parcelRequire('iJGPY'));

});

parcelRegister("gfpxd", function(module, exports) {

let $bd41dab43722c8d5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd41dab43722c8d5$var$load("dnVmf").then(()=>parcelRequire('9ib3C'));

});

parcelRegister("lJQ5X", function(module, exports) {

let $fd3635f2e5aabac0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fd3635f2e5aabac0$var$load("glmO2").then(()=>parcelRequire('3yAls'));

});

parcelRegister("bYXrx", function(module, exports) {

let $8b93687e70d55260$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8b93687e70d55260$var$load("32NHR").then(()=>parcelRequire('e3DmL'));

});

parcelRegister("62FON", function(module, exports) {

let $46635e3aa0f21791$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $46635e3aa0f21791$var$load("8GFi1").then(()=>parcelRequire('dQeg1'));

});

parcelRegister("j74pS", function(module, exports) {

let $dea218c262683901$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $dea218c262683901$var$load("iWYx4").then(()=>parcelRequire('f1G8J'));

});

parcelRegister("e3rWd", function(module, exports) {

let $a3b7046b3b58e574$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a3b7046b3b58e574$var$load("cXTJH").then(()=>parcelRequire('bFnmR'));

});

parcelRegister("fS7mD", function(module, exports) {

let $b8e19c809ca15790$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8e19c809ca15790$var$load("kMmm1").then(()=>parcelRequire('2ZUqo'));

});

parcelRegister("hBRNG", function(module, exports) {

let $cd1f9ffc4306ed9a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd1f9ffc4306ed9a$var$load("k25pB").then(()=>parcelRequire('QrYx2'));

});

parcelRegister("4SYP6", function(module, exports) {

let $38eb62ceae487952$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38eb62ceae487952$var$load("aWKP7").then(()=>parcelRequire('dK3CB'));

});

parcelRegister("ivYfD", function(module, exports) {

let $d7a9dbdfd2c52ad4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7a9dbdfd2c52ad4$var$load("2bJoN").then(()=>parcelRequire('7Jde4'));

});

parcelRegister("eNJEs", function(module, exports) {

let $ac690dbfdd63bd67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac690dbfdd63bd67$var$load("bGOwY").then(()=>parcelRequire('2WCju'));

});

parcelRegister("9ImZK", function(module, exports) {

let $712a0f72ca3115b0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $712a0f72ca3115b0$var$load("k6TzV").then(()=>parcelRequire('4u3xL'));

});

parcelRegister("2xJ2w", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::545a5230e1758b11e8d6f8fdfc7eca86>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1da199c7b96e9bc5$var$_react = $1da199c7b96e9bc5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $1da199c7b96e9bc5$var$_iconNew = $1da199c7b96e9bc5$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $1da199c7b96e9bc5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextLengthen".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-lengthen
 * Usage guidance:
 * Lengthening text content with Atlassian Intelligence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1da199c7b96e9bc5$var$TextLengthenIcon = (props)=>/*#__PURE__*/ $1da199c7b96e9bc5$var$_react.default.createElement($1da199c7b96e9bc5$var$_iconNew.default, Object.assign({
        name: "TextLengthenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 2.5H1V1h14zm0 4.167H1v-1.5h14zm0 4.166H1v-1.5h14zM8 15H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$1da199c7b96e9bc5$var$TextLengthenIcon.displayName = 'TextLengthenIcon';
var $1da199c7b96e9bc5$var$_default = module.exports.default = $1da199c7b96e9bc5$var$TextLengthenIcon;

});

parcelRegister("9DTaz", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $281f0207d5f06906$export$eb38a1b15192a777 = (helpText, description)=>{
    const availableHelpText = typeof helpText === 'string' && helpText.trim() ? helpText : '';
    if ((0, $iDrrr.fg)('chat_skill_helptext_enabled') && availableHelpText) return availableHelpText;
    const availableDescription = typeof description === 'string' ? description : '';
    return availableDescription || availableHelpText;
};
module.exports["resolveSkillDisplayDescription"] = $281f0207d5f06906$export$eb38a1b15192a777;

});

parcelRegister("k9SFD", function(module, exports) {

var $drRzc = parcelRequire("drRzc");

const $00f984e1ee672b7a$var$getAppType = (userType)=>userType === 'APP' || userType === 'AGENT' ? 'agent' : 'user';
const $00f984e1ee672b7a$var$enrichMentionNodeData = (mention, data)=>({
        ...data,
        appType: data?.appType ?? $00f984e1ee672b7a$var$getAppType(mention.userType)
    });
const $00f984e1ee672b7a$var$toMentionNode = ({ id: id, userType: userType })=>({
        attrs: {
            id: id,
            // NodeDataProvider uses an ADF node internally, so normalize the runtime-only value.
            userType: userType === 'AGENT' ? 'APP' : userType
        },
        type: 'mention'
    });
const $00f984e1ee672b7a$var$isMentionNode = (node)=>node.type === 'mention' && node.attrs !== undefined && 'id' in node.attrs && typeof node.attrs.id === 'string';
const $00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX = 'mention-node-data-provider';
let $00f984e1ee672b7a$var$subscriptionKeyCounter = 0;
const $00f984e1ee672b7a$var$cacheMentionData = (cache, mentions)=>{
    mentions.forEach((mention)=>{
        if (mention.isPlaceholder || !mention.avatarUrl) {
            cache.delete(mention.id);
            return;
        }
        cache.set(mention.id, {
            avatarUrl: mention.avatarUrl,
            appType: mention.appType
        });
    });
};
class $00f984e1ee672b7a$export$d2331d8e30b7662 extends (0, $drRzc.NodeDataProvider) {
    isNodeSupported(node) {
        return $00f984e1ee672b7a$var$isMentionNode(node) && node.attrs.userType !== 'SPECIAL';
    }
    nodeDataKey(node) {
        return node.attrs.id;
    }
    async fetchNodesData(nodes) {
        const accountIds = Array.from(new Set(nodes.map(({ attrs: attrs })=>attrs.id)));
        const dataByAccountId = await this.enqueueFetch(accountIds);
        return nodes.map(({ attrs: attrs })=>$00f984e1ee672b7a$var$enrichMentionNodeData(attrs, dataByAccountId[attrs.id]));
    }
    getMentionData(mention, callback) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) {
            callback({
                data: $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData)
            });
            return;
        }
        this.getData($00f984e1ee672b7a$var$toMentionNode(mention), callback);
    }
    getMentionDataFromCache(mention) {
        const resolvedData = this.resolveMentionNodeDataFromCache(mention);
        if (resolvedData) return $00f984e1ee672b7a$var$enrichMentionNodeData(mention, resolvedData);
        const data = this.getNodeDataFromCache($00f984e1ee672b7a$var$toMentionNode(mention))?.data;
        return data ? $00f984e1ee672b7a$var$enrichMentionNodeData(mention, data) : undefined;
    }
    connect(mentionResource) {
        if (this.lastMentionResource && this.lastMentionResource !== mentionResource) {
            this.emittedMentionCache.clear();
            this.resetCache();
        }
        this.lastMentionResource = mentionResource;
        if (this.abortControllerRef.current.signal.aborted) this.abortControllerRef.current = new AbortController();
        let isDisconnected = false;
        let subscribedMentionProvider;
        mentionResource.then((mentionProvider)=>{
            if (isDisconnected) return;
            subscribedMentionProvider = mentionProvider;
            mentionProvider.subscribe(this.subscriptionKey, (mentions)=>{
                $00f984e1ee672b7a$var$cacheMentionData(this.emittedMentionCache, mentions);
            });
        }).catch(()=>undefined);
        return ()=>{
            isDisconnected = true;
            this.abortControllerRef.current.abort();
            subscribedMentionProvider?.unsubscribe(this.subscriptionKey);
            subscribedMentionProvider = undefined;
        };
    }
    resolveMentionNodeDataFromCache(mention) {
        return this.resolveMentionNodeData?.(mention) ?? this.emittedMentionCache.get(mention.id);
    }
    enqueueFetch(accountIds) {
        const result = new Promise((resolve, reject)=>{
            this.queuedFetches.push({
                accountIds: accountIds,
                reject: reject,
                resolve: resolve
            });
        });
        if (!this.isFlushScheduled) {
            this.isFlushScheduled = true;
            Promise.resolve().then(()=>this.flushFetches());
        }
        return result;
    }
    async flushFetches() {
        this.isFlushScheduled = false;
        const queuedFetches = this.queuedFetches;
        this.queuedFetches = [];
        const accountIds = Array.from(new Set(queuedFetches.flatMap((request)=>request.accountIds)));
        try {
            const data = await this.fetchMentionNodeData(accountIds, this.abortControllerRef.current.signal);
            queuedFetches.forEach(({ resolve: resolve })=>resolve(data));
        } catch (error) {
            queuedFetches.forEach(({ reject: reject })=>reject(error));
        }
    }
    constructor(fetchMentionNodeData, resolveMentionNodeData){
        super(), this.fetchMentionNodeData = fetchMentionNodeData, this.resolveMentionNodeData = resolveMentionNodeData;
        this.name = 'mentionNodeDataProvider';
        this.abortControllerRef = {
            current: new AbortController()
        };
        this.emittedMentionCache = new Map();
        this.subscriptionKey = `${$00f984e1ee672b7a$var$SUBSCRIPTION_KEY_PREFIX}:${++$00f984e1ee672b7a$var$subscriptionKeyCounter}`;
        this.lastMentionResource = void 0;
        this.queuedFetches = [];
        this.isFlushScheduled = false;
    }
}
module.exports["MentionNodeDataProvider"] = $00f984e1ee672b7a$export$d2331d8e30b7662;

});

parcelRegister("b6fxF", function(module, exports) {
/* UserProfileCardForMention.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $lQV5m = parcelRequire("lQV5m");


var $cK21K = parcelRequire("cK21K");


var $iMnC5 = parcelRequire("iMnC5");


var $jp2Q3 = parcelRequire("jp2Q3");


var $bPFqZ = parcelRequire("bPFqZ");


var $d5gEx = parcelRequire("d5gEx");


var $1koI0 = parcelRequire("1koI0");


var $g0RaX = parcelRequire("g0RaX");


var $3Z1Pc = parcelRequire("3Z1Pc");


var $fxdou = parcelRequire("fxdou");


var $9zU5G = parcelRequire("9zU5G");

const $0b67b0fc1e6d3033$var$ENTRY_POINT_ID = 'user-profile-card-for-mention';
const $0b67b0fc1e6d3033$var$mentionPopupStyles = {
    hidden: "_0fKRyPnQyn _1pp6NdYbGa"
};
function $0b67b0fc1e6d3033$var$PopperContent({ entryPointReference: entryPointReference, entryPointErrorFallback: entryPointErrorFallback, cloudId: cloudId, testId: testId, agent: agent, customerCardDataLoader: customerCardDataLoader, isReduced: isReduced }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bPFqZ.InternalEntryPointContainer), {
        id: $0b67b0fc1e6d3033$var$ENTRY_POINT_ID,
        entryPointReference: entryPointReference,
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
            isReduced: isReduced
        }),
        errorFallback: entryPointErrorFallback,
        runtimeProps: {
            cloudId: cloudId,
            testId: testId,
            agent: agent,
            customerCardDataLoader: customerCardDataLoader,
            isReduced: isReduced
        }
    });
} /**
   * Props common to both render paths.
   */ 
function $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8(props) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d5gEx.AtlassianRelayEnvironmentProvider), {
        children: /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$UserProfileCardForMentionInner, {
            ...props
        })
    });
} /** Inner implementation of {@link UserProfileCardForMention}. */ 
function $0b67b0fc1e6d3033$var$UserProfileCardForMentionInner({ userId: userId, cloudId: cloudId, orgId: orgId, viewerId: viewerId, children: children, referenceElement: referenceElement, placement: placement = 'bottom-start', shouldFitViewport: shouldFitViewport = false, trigger: trigger, testId: testId, agent: agent, isReduced: isReduced, analyticsAttributes: analyticsAttributes, prefilledProfileData: prefilledProfileData, customerCardDataLoader: customerCardDataLoader, onOpen: onOpen }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const onErrorBoundary = (0, $cozmU.useCallback)(()=>{
        (0, $g0RaX.getPageTime)();
    }, []);
    const entryPointErrorFallback = (0, $cozmU.useCallback)((_props)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $3Z1Pc.CardError), {
            testId: testId
        }), [
        testId
    ]);
    const [entryPointReference, setEntryPointReference] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!referenceElement || !userId || !cloudId || !orgId || !viewerId) return;
        const reference = (0, $6SsN4.loadEntryPoint)(environmentProvider, (0, $1koI0.entryPoint), {
            userId: userId,
            cloudId: cloudId,
            orgId: orgId,
            viewerId: viewerId,
            isReduced: isReduced
        });
        setEntryPointReference(reference);
        return ()=>{
            reference.dispose();
            setEntryPointReference(null);
        };
    }, [
        referenceElement,
        userId,
        cloudId,
        orgId,
        viewerId,
        isReduced,
        environmentProvider
    ]); // Both render paths require these identifiers to make a valid API call. Bail out to
    // the plain children (mention chip without a card) when any are missing - the editor
    // path also needs this guard before its popper renders.
    if (!userId || !cloudId || !orgId || !viewerId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
    if (!referenceElement) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9zU5G.UserProfileCardWithTrigger), {
        userId: userId,
        cloudId: cloudId,
        orgId: orgId,
        viewerId: viewerId,
        shouldFitViewport: shouldFitViewport,
        placement: placement,
        trigger: trigger,
        testId: testId,
        agent: agent,
        isReduced: isReduced,
        analyticsAttributes: analyticsAttributes,
        prefilledProfileData: prefilledProfileData,
        customerCardDataLoader: customerCardDataLoader,
        onOpen: onOpen,
        shouldRenderToParent: false,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
                onError: onErrorBoundary,
                fallback: null,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cK21K.default), {
                    zIndex: (0, $jp2Q3.layers).modal(),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lQV5m.Popper), {
                        referenceElement: referenceElement,
                        placement: placement,
                        children: ({ ref: ref, style: style, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                                ref: ref,
                                style: style,
                                xcss: isReferenceHidden ? $0b67b0fc1e6d3033$var$mentionPopupStyles.hidden : undefined,
                                testId: testId ? `${testId}--mention-popup` : undefined,
                                children: entryPointReference ? /*#__PURE__*/ (0, $8aG6j.jsx)($0b67b0fc1e6d3033$var$PopperContent, {
                                    entryPointReference: entryPointReference,
                                    entryPointErrorFallback: entryPointErrorFallback,
                                    cloudId: cloudId,
                                    testId: testId,
                                    agent: agent,
                                    customerCardDataLoader: customerCardDataLoader,
                                    isReduced: isReduced
                                }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxdou.CardLoading), {
                                    isReduced: isReduced
                                })
                            })
                    })
                })
            })
        ]
    });
}
module.exports["UserProfileCardForMention"] = $0b67b0fc1e6d3033$export$b3a703a1f8ebb0c8;

});

parcelRegister("lg0Hb", function(module, exports) {

var $ez9fa = parcelRequire("ez9fa");


var $gUmQU = parcelRequire("gUmQU");

const $78af8633c33c3f87$export$4150d0293f9ac9ed = (agentName)=>agentName?.trim() || undefined;
const $78af8633c33c3f87$export$debbb3e2f01c56b0 = ({ scope: scope, agentName: agentName, hasContext: hasContext, hasResetDate: hasResetDate })=>{
    const showsResetDate = hasResetDate && (0, $ez9fa.canScopeShowResetDate)(scope);
    if (scope === 'AGENT' && $78af8633c33c3f87$export$4150d0293f9ac9ed(agentName)) {
        if (hasContext) return showsResetDate ? (0, $gUmQU.messages).agentDepletedWithContextAndResetDate : (0, $gUmQU.messages).agentDepletedWithContext;
        return showsResetDate ? (0, $gUmQU.messages).agentDepletedWithResetDate : (0, $gUmQU.messages).agentDepletedWithoutResetDate;
    }
    if (hasContext) return showsResetDate ? (0, $gUmQU.messages).depletedWithContextAndResetDate : (0, $gUmQU.messages).depletedWithContext;
    return showsResetDate ? (0, $gUmQU.messages).depletedWithResetDate : (0, $gUmQU.messages).depletedWithoutResetDate;
};
module.exports["normalizeAgentName"] = $78af8633c33c3f87$export$4150d0293f9ac9ed;
module.exports["getDepletedDescriptor"] = $78af8633c33c3f87$export$debbb3e2f01c56b0;

});

parcelRegister("i8pw6", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $ez9fa = parcelRequire("ez9fa");


var $9Zo8c = parcelRequire("9Zo8c");


var $8pmO0 = parcelRequire("8pmO0");


var $9N9hR = parcelRequire("9N9hR");


var $6fXuK = parcelRequire("6fXuK");


var $gUmQU = parcelRequire("gUmQU");


var $lg0Hb = parcelRequire("lg0Hb");


var $fdZrn = parcelRequire("fdZrn");


var $fhLSq = parcelRequire("fhLSq");

const $3c7e4baf4eb733c4$var$styles = {
    requestLink: "_3xtjKN0Rl6"
};
const $3c7e4baf4eb733c4$var$surfaceMessages = (0, $kSwu1.defineMessages)({
    resetDate: {
        id: "rovo-credits.internal.credits-surface.resetDate",
        defaultMessage: "Resets {resetDate}."
    },
    requestCredits: {
        id: "rovo-credits.internal.credits-surface.requestCredits",
        defaultMessage: "Request credits"
    },
    title: {
        id: "rovo-credits.internal.credits-surface.title",
        defaultMessage: "Rovo credits"
    }
});
const $3c7e4baf4eb733c4$var$Surface = ({ state: state, resetDate: resetDate, agentName: agentName, onDismiss: onDismiss, onError: onError, children: children })=>{
    const intl = (0, $kSwu1.useIntl)();
    const request = (0, $8pmO0.useCreditsRequestContext)();
    const { formatMessage: formatMessage } = intl;
    const isWarning = state.balanceState === 'warning';
    const variant = `${state.balanceState}-${state.depletionBehavior}-${state.scope}`;
    const previousVariant = (0, $cozmU.useRef)(variant);
    const { isDismissed: isDismissed, dismissBanner: dismissBanner, showBanner: showBanner } = (0, $fdZrn.useDismissalPersistence)(isWarning, onError);
    (0, $cozmU.useEffect)(()=>{
        if (variant !== previousVariant.current && isDismissed) showBanner();
        previousVariant.current = variant;
    }, [
        variant,
        isDismissed,
        showBanner
    ]);
    if (state.depletionBehavior === null || isDismissed) return null;
    const { scope: scope } = state;
    const formattedResetDate = (0, $ez9fa.canScopeShowResetDate)(scope) ? (0, $6fXuK.formatResetDate)(intl, resetDate ?? state.resetDate) : undefined;
    const canRequestCredits = state.canRequestCredits === true && (0, $ez9fa.canScopeRequestCredits)(scope) && !request?.isUnavailable;
    const trimmedAgentName = (0, $lg0Hb.normalizeAgentName)(agentName);
    const dismiss = ()=>{
        dismissBanner();
        onDismiss?.();
    };
    const description = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage(isWarning ? (0, $gUmQU.messages).warningWithoutResetDate : (0, $lg0Hb.getDepletedDescriptor)({
        scope: scope,
        agentName: trimmedAgentName,
        hasContext: false,
        hasResetDate: false
    }), {
        agentName: trimmedAgentName
    })), formattedResetDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($3c7e4baf4eb733c4$var$surfaceMessages.resetDate, {
        resetDate: formattedResetDate
    })) : null), canRequestCredits ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fhLSq.RequestCreditsAction), {
        isUnderlined: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $3c7e4baf4eb733c4$var$styles.requestLink
    }, formatMessage($3c7e4baf4eb733c4$var$surfaceMessages.requestCredits))) : null);
    const details = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, description, isWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: dismiss
    }, formatMessage((0, $gUmQU.messages).dismissBanner)) : null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children({
        title: formatMessage($3c7e4baf4eb733c4$var$surfaceMessages.title),
        formattedResetDate: formattedResetDate,
        canRequestCredits: canRequestCredits,
        scope: scope,
        agentName: trimmedAgentName,
        isWarning: isWarning,
        dismiss: dismiss,
        description: description,
        details: details
    }));
};
const $3c7e4baf4eb733c4$export$d521bd4abb92d03b = (props)=>{
    const credits = (0, $9N9hR.useCreditsStateContext)();
    if (credits?.bannerState == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zo8c.RovoCreditsIntlProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3c7e4baf4eb733c4$var$Surface, {
        ...props,
        state: credits.bannerState
    }));
};
module.exports["CreditsSurface"] = $3c7e4baf4eb733c4$export$d521bd4abb92d03b;

});

parcelRegister("6fXuK", function(module, exports) {
const $49af3a264000c385$export$ecb62445e03e0279 = (intl, resetDate)=>{
    if (resetDate === undefined || !Number.isFinite(resetDate) || resetDate <= 0 || Number.isNaN(new Date(resetDate).getTime())) return undefined;
    return intl.formatDate(resetDate, {
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
    });
};
module.exports["formatResetDate"] = $49af3a264000c385$export$ecb62445e03e0279;

});

parcelRegister("fdZrn", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1iTIy = parcelRequire("1iTIy");


var $1hpbj = parcelRequire("1hpbj");

const $d5481950e337f659$export$80dfbfdce4ada1a2 = 'rovo-credits-banner-dismissed';
let $d5481950e337f659$var$dismissalStorage = null;
const $d5481950e337f659$var$getDismissalStorage = (onError)=>{
    if ($d5481950e337f659$var$dismissalStorage === null) $d5481950e337f659$var$dismissalStorage = (0, $1hpbj.getBrowserLocalStorage)(onError);
    return $d5481950e337f659$var$dismissalStorage;
};
const $d5481950e337f659$var$readStoredDismissal = (onError)=>{
    return (0, $1hpbj.readLocalStorageItem)($d5481950e337f659$var$getDismissalStorage(onError), $d5481950e337f659$export$80dfbfdce4ada1a2, onError) === 'true';
};
const $d5481950e337f659$var$storeDismissal = (onError)=>{
    (0, $1hpbj.writeLocalStorageItem)($d5481950e337f659$var$getDismissalStorage(onError), $d5481950e337f659$export$80dfbfdce4ada1a2, 'true', onError, {
        reportBlocked: (0, $1iTIy.isCreditsDegradationUiEnabled)()
    });
};
const $d5481950e337f659$var$clearStoredDismissal = (onError)=>{
    (0, $1hpbj.removeLocalStorageItem)($d5481950e337f659$var$getDismissalStorage(onError), $d5481950e337f659$export$80dfbfdce4ada1a2, onError);
};
const $d5481950e337f659$var$canListenForStorageEvents = ()=>typeof window !== 'undefined' && typeof window.addEventListener === 'function' && typeof window.removeEventListener === 'function';
const $d5481950e337f659$var$isDismissalStorageEvent = (event, storage)=>{
    // `storage.storage` is the native Storage captured before browser storage controls install
    // their window.localStorage proxy, so it is reference-equal to `StorageEvent.storageArea`.
    // If that stops holding, cross-tab dismissal sync fails silently.
    if (event.storageArea !== storage.storage) return false;
    // `localStorage.clear()` emits `key === null`, so re-read the dismissal key.
    return event.key === $d5481950e337f659$export$80dfbfdce4ada1a2 || event.key === null;
};
const $d5481950e337f659$export$be7b726a6238587c = (isDismissible, onError)=>{
    const [isBannerDismissed, setIsBannerDismissed] = (0, $cozmU.useState)(()=>isDismissible && $d5481950e337f659$var$readStoredDismissal(onError));
    const hasAppliedStoredDismissalRef = (0, $cozmU.useRef)(isDismissible);
    const applyStoredDismissal = (0, $cozmU.useCallback)(()=>{
        setIsBannerDismissed($d5481950e337f659$var$readStoredDismissal(onError));
    }, [
        onError
    ]);
    // Dismissal only applies to dismissible warning banners. When the banner
    // becomes non-dismissible, clear storage so depleted banners cannot be hidden.
    (0, $cozmU.useEffect)(()=>{
        if (isDismissible) {
            if (!hasAppliedStoredDismissalRef.current) {
                applyStoredDismissal();
                hasAppliedStoredDismissalRef.current = true;
            }
            return;
        }
        hasAppliedStoredDismissalRef.current = false;
        setIsBannerDismissed(false);
        $d5481950e337f659$var$clearStoredDismissal(onError);
    }, [
        isDismissible,
        onError,
        applyStoredDismissal
    ]);
    // Browser `storage` events fire in other tabs, so this keeps banner
    // visibility aligned across open Rovo chat tabs.
    (0, $cozmU.useEffect)(()=>{
        if (!isDismissible || !$d5481950e337f659$var$canListenForStorageEvents()) return;
        const browserStorage = $d5481950e337f659$var$getDismissalStorage(onError);
        if (browserStorage === null) return;
        const handleCrossTabStorageEvent = (event)=>{
            if ($d5481950e337f659$var$isDismissalStorageEvent(event, browserStorage)) applyStoredDismissal();
        };
        window.addEventListener('storage', handleCrossTabStorageEvent);
        return ()=>{
            window.removeEventListener('storage', handleCrossTabStorageEvent);
        };
    }, [
        isDismissible,
        onError,
        applyStoredDismissal
    ]);
    // Memoized so consumers can safely list these in effect deps.
    const dismissBanner = (0, $cozmU.useCallback)(()=>{
        setIsBannerDismissed(true);
        $d5481950e337f659$var$storeDismissal(onError);
    }, [
        onError
    ]);
    const showBanner = (0, $cozmU.useCallback)(()=>{
        setIsBannerDismissed(false);
        $d5481950e337f659$var$clearStoredDismissal(onError);
    }, [
        onError
    ]);
    const isDismissedForCurrentBanner = isDismissible && isBannerDismissed;
    return {
        isDismissed: isDismissedForCurrentBanner,
        dismissBanner: dismissBanner,
        showBanner: showBanner
    };
};
module.exports["useDismissalPersistence"] = $d5481950e337f659$export$be7b726a6238587c;

});

parcelRegister("fhLSq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $hBYtq = parcelRequire("hBYtq");


var $8pmO0 = parcelRequire("8pmO0");


var $9N9hR = parcelRequire("9N9hR");

const $ea37701110d5c382$var$styles = {
    underlined: "_3xtjKN0Rl6",
    action: "_2sNsIgmnOE _2V7sgOdnbC _4c065UPgdg _2Y7lL4Pgdg _3iDTPbS8kF _0KLXrujOvk _1UtDYzM7Tp _0wOv4Q7zJH"
};
const $ea37701110d5c382$export$74f2a192aba6d1fa = ({ children: children, isUnderlined: isUnderlined = false })=>{
    const request = (0, $8pmO0.useCreditsRequestContext)();
    const state = (0, $9N9hR.useCreditsStateContext)()?.bannerState;
    if (request?.isUnavailable) return null;
    const method = state?.requestMethod;
    if (method?.mode === 'REDIRECT_URL') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: method.redirectUrl,
        target: "_blank",
        rel: "noopener noreferrer"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($ea37701110d5c382$var$styles.action, isUnderlined && $ea37701110d5c382$var$styles.underlined),
        isDisabled: !request || request.isPending,
        onClick: request?.start
    }, children);
};
module.exports["RequestCreditsAction"] = $ea37701110d5c382$export$74f2a192aba6d1fa;

});

parcelRegister("i6ZUk", function(module, exports) {

var $15uL0 = parcelRequire("15uL0");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/identity/team/manifest.ts
var $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $15uL0.IdentityTeamAriResourceOwner),
    resourceType: (0, $15uL0.IdentityTeamAriResourceType),
    resourceIdSlug: "{teamId}",
    resourceIdSegmentFormats: {
        teamId: /[a-zA-Z0-9.\-_~]+/
    }
};
// src/identity/team/index.ts
var $d2f8cf1894db7ef9$export$33bbb2d79e520118 = class _IdentityTeamAri extends (0, $9j37t.RegisteredAri) {
    get teamId() {
        return this._teamId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts.qualifier,
            platformQualifier: $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts.resourceOwner,
            resourceType: $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts.resourceType,
            resourceId: `${opts.teamId}`,
            resourceIdSegmentValues: {
                teamId: opts.teamId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $d2f8cf1894db7ef9$var$identityTeamAriStaticOpts);
        return new _IdentityTeamAri(opts);
    }
    getVariables() {
        return {
            teamId: this.teamId
        };
    }
    constructor(opts){
        super(opts), this._teamId = opts.resourceIdSegmentValues.teamId;
    }
};
module.exports["IdentityTeamAri"] = $d2f8cf1894db7ef9$export$33bbb2d79e520118;

});

parcelRegister("15uL0", function(module, exports) {
// src/identity/team/types.ts
var $0cae1dd2c8cb7865$export$49beddf48ffb3f35 = "identity", $0cae1dd2c8cb7865$export$b2079a2a841afe32 = "team";
module.exports["IdentityTeamAriResourceOwner"] = $0cae1dd2c8cb7865$export$49beddf48ffb3f35;
module.exports["IdentityTeamAriResourceType"] = $0cae1dd2c8cb7865$export$b2079a2a841afe32;

});

parcelRegister("5NB3T", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $28d3424ad2043b12$export$5229ffea355cfdf6 = (0, $kSwu1.defineMessages)({
    alignment: {
        id: "fabric.editor.alignment",
        defaultMessage: "Text alignment"
    },
    alignLeft: {
        id: "fabric.editor.alignLeft",
        defaultMessage: "Align left"
    },
    alignCenter: {
        id: "fabric.editor.alignCenter",
        defaultMessage: "Align center"
    },
    alignRight: {
        id: "fabric.editor.alignRight",
        defaultMessage: "Align right"
    }
});
module.exports["alignmentMessages"] = $28d3424ad2043b12$export$5229ffea355cfdf6;

});

parcelRegister("5YDZX", function(module, exports) {
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE = 'data-block-controls-suppression';
const $d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR = `[${$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE}]`;
const $d9d643acafd25457$export$7a4820babe675d08 = {
    [$d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_ATTRIBUTE]: 'true'
};
const $d9d643acafd25457$export$8d5d08f345eecbf1 = (target)=>target instanceof Element && target.closest($d9d643acafd25457$var$BLOCK_CONTROLS_SUPPRESSION_SELECTOR) !== null;
module.exports["blockControlsSuppressionProps"] = $d9d643acafd25457$export$7a4820babe675d08;
module.exports["isBlockControlsSuppressionTarget"] = $d9d643acafd25457$export$8d5d08f345eecbf1;

});

parcelRegister("bwuOg", function(module, exports) {
const $74d2fe053a191110$export$85183a312807388d = 'media';
const $74d2fe053a191110$export$60efea3f80310017 = 'wide';
module.exports["ANALYTICS_CHANNEL"] = $74d2fe053a191110$export$85183a312807388d;
module.exports["DATASOURCE_DEFAULT_LAYOUT"] = $74d2fe053a191110$export$60efea3f80310017;

});

parcelRegister("6PfjN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen link-analytics
 */ const $43bfeda8ce4963c3$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $43bfeda8ce4963c3$export$2e2bcd8739ae039 = $43bfeda8ce4963c3$var$createEventPayload;
module.exports["default"] = $43bfeda8ce4963c3$export$2e2bcd8739ae039;

});

parcelRegister("liM9D", function(module, exports) {
const $805653e9c9be0b26$export$3f072f06b90c3985 = 'media';
module.exports["EVENT_CHANNEL"] = $805653e9c9be0b26$export$3f072f06b90c3985;

});

parcelRegister("lqRBm", function(module, exports) {
/* eslint-disable compat/compat */ const $b136b9ae0024c8d8$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);
module.exports["runWhenIdle"] = $b136b9ae0024c8d8$export$51d09170c61ebe04;

});

parcelRegister("8hDyr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2iGHk = parcelRequire("2iGHk");


var $9DHhW = parcelRequire("9DHhW");


var $bI14T = parcelRequire("bI14T");


var $6PfjN = parcelRequire("6PfjN");


var $liM9D = parcelRequire("liM9D");


var $lqRBm = parcelRequire("lqRBm");


const $e5274b30bf01d8e7$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $bI14T.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $lqRBm.runWhenIdle)(()=>{
                        (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $lqRBm.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("2n1eW"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $2iGHk.default)((0, $liM9D.EVENT_CHANNEL))((0, $6PfjN.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};
module.exports["useSmartLinkLifecycleAnalytics"] = $e5274b30bf01d8e7$export$612752b1e088a45e;

});

parcelRegister("2n1eW", function(module, exports) {

let $1b9eb0fa697f5658$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1b9eb0fa697f5658$var$load("i7NGK"),
    $1b9eb0fa697f5658$var$load("d0ZRF"),
    $1b9eb0fa697f5658$var$load("k507P"),
    $1b9eb0fa697f5658$var$load("6iTkp"),
    $1b9eb0fa697f5658$var$load("axcf5")
]).then(()=>parcelRequire('3hbWh'));

});

parcelRegister("fDAOo", function(module, exports) {
$parcel$export(module.exports, "default", () => $b6270d9b7fedaa79$export$2e2bcd8739ae039);

var $kr6hK = parcelRequire("kr6hK");


var $58FyF = parcelRequire("58FyF");


var $3yGK6 = parcelRequire("3yGK6");

function $b6270d9b7fedaa79$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $3yGK6.default)(2, arguments);
    var amount = (0, $kr6hK.default)(dirtyAmount);
    return (0, $58FyF.default)(dirtyDate, amount * 12);
}

});

parcelRegister("3xwCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5429223205b4172af0cbd0d2ddcaa04>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $293dc2808d336068$var$_react = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("cozmU")));

var $293dc2808d336068$var$_iconNew = $293dc2808d336068$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $293dc2808d336068$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pencil
 * Usage guidance:
 * Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $293dc2808d336068$var$PencilIcon = (props)=>/*#__PURE__*/ $293dc2808d336068$var$_react.default.createElement($293dc2808d336068$var$_iconNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$293dc2808d336068$var$PencilIcon.displayName = 'PencilIcon';
var $293dc2808d336068$var$_default = module.exports.default = $293dc2808d336068$var$PencilIcon;

});

parcelRegister("f6VI9", function(module, exports) {

var $9DTaz = parcelRequire("9DTaz");

const $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES = new Set([
    'WorkItemWorkflowContextMinion',
    'JiraWorkItemCreateMinion',
    'JiraPermissionsSkill',
    'JiraNavigationMinion'
]);
/**
 * Rovo Space conversations support Anthropic skills plus a small set of
 * Stratus skills that provide the Jira capabilities required in that context.
 */ function $ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node) {
    return node.source === 'ANTHROPIC' || node.source === 'STRATUS' && Boolean(node.name && $ae2233479ab8cd62$var$ROVO_SPACE_ALLOWED_STRATUS_SKILL_NAMES.has(node.name));
}
function $ae2233479ab8cd62$export$db36004670a5626e(node) {
    return node?.__typename === 'GraphIntegrationSkillDirectoryItem';
}
function $ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node) {
    return node?.__typename === 'ConvoAiSkill';
}
function $ae2233479ab8cd62$export$74ea09dd5afceb60(node) {
    if (!node || node.__typename !== 'GraphIntegrationSkillDirectoryItem') return null;
    const displayName = node.integrationKey?.displayName ?? '';
    const tagDisplayNames = node.tags?.map((t)=>t.displayName) ?? [];
    const displayDescription = node.description ?? '';
    const trimmedDescription = displayDescription.length > 150 ? `${displayDescription.slice(0, 147)}...` : displayDescription;
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] ?? '',
        name: node.name ?? '',
        description: trimmedDescription,
        iconName: node.iconUrl?.split('name/')?.[1],
        product: displayName ? displayName.charAt(0).toUpperCase() + displayName.slice(1) : '',
        ...node.integrationKey?.key ? {
            productKey: node.integrationKey.key
        } : {},
        productIconUrl: node.integrationKey?.iconUrl ?? '',
        ...node.color ? {
            color: node.color
        } : {},
        ...tagDisplayNames.length > 0 ? {
            tags: [
                ...tagDisplayNames
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$fd76a94f4a001a14(node) {
    if (!node || node.__typename !== 'ConvoAiSkill') return null;
    const primaryIntegration = node.integrations?.[0];
    const productKey = primaryIntegration?.key ?? node.integrationKeys?.[0];
    let productDisplayName = '';
    let productIconUrl = '';
    // If the skill has integrations, else use the legacy integrationKeys.
    if (primaryIntegration) {
        productDisplayName = primaryIntegration.displayName ?? '';
        productIconUrl = primaryIntegration.iconUrl ?? '';
    } else {
        const product = node.integrationKeys?.[0] ?? '';
        productDisplayName = product ? product.charAt(0).toUpperCase() + product.slice(1) : '';
    }
    return {
        id: node.id,
        slug: node.slashCommand?.split('/')?.[1] || node.name || '',
        name: node.displayName ?? node.name ?? '',
        description: node.description ?? '',
        helpText: (0, $9DTaz.resolveSkillDisplayDescription)(node.helpText, node.description),
        iconName: node.iconKey || node.iconUrl?.split('name/')?.[1],
        product: productDisplayName,
        ...productKey ? {
            productKey: productKey
        } : {},
        productIconUrl: productIconUrl,
        ...node.color ? {
            color: node.color
        } : {},
        ...node.tags && node.tags.length > 0 ? {
            tags: [
                ...node.tags
            ]
        } : {}
    };
}
function $ae2233479ab8cd62$export$2cffb029ea623d71(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$db36004670a5626e(edge?.node) ? $ae2233479ab8cd62$export$74ea09dd5afceb60(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$554aac7da67453f5(edges) {
    if (!edges) return [];
    return edges.map((edge)=>$ae2233479ab8cd62$export$7d1ba2a7b9e1a07(edge?.node) ? $ae2233479ab8cd62$export$fd76a94f4a001a14(edge.node) : null).filter((skill)=>skill !== null);
}
function $ae2233479ab8cd62$export$faef8b68e529d4a7(edges, options = {}) {
    if (!edges) return [];
    return edges.map((edge)=>{
        const node = edge?.node;
        if (!node || !node.__typename) return null;
        // Route to appropriate parser based on typename
        if ($ae2233479ab8cd62$export$db36004670a5626e(node)) {
            // Legacy directory items do not expose the source needed to establish
            // eligibility for a Rovo Space conversation.
            if (options.restrictToRovoSpaceSkills) return null;
            return $ae2233479ab8cd62$export$74ea09dd5afceb60(node);
        }
        if ($ae2233479ab8cd62$export$7d1ba2a7b9e1a07(node)) {
            if (options.restrictToRovoSpaceSkills && !$ae2233479ab8cd62$var$isSkillAllowedInRovoSpace(node)) return null;
            return $ae2233479ab8cd62$export$fd76a94f4a001a14(node);
        }
        return null;
    }).filter((skill)=>skill !== null);
}
module.exports["parseSkillNode"] = $ae2233479ab8cd62$export$74ea09dd5afceb60;
module.exports["parseConvoAiSkillEdges"] = $ae2233479ab8cd62$export$554aac7da67453f5;
module.exports["parseUniversalSkillEdges"] = $ae2233479ab8cd62$export$faef8b68e529d4a7;

});

parcelRegister("aJNFh", function(module, exports) {

var $f6VI9 = parcelRequire("f6VI9");

const $71f78acdff7635c4$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
/**
 * Unified GraphQL query — convoai_availableSkills.
 */ const $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY = `
  query ConvoAiAvailableSkillsQuery(
    $first: Int
    $cloudId: ID!
  ) {
    convoai_availableSkills(
      first: $first
      cloudId: $cloudId
    )
    @optIn(to: "ConvoAiAvailableSkills")
    {
      edges {
        node {
          __typename
          ... on ConvoAiSkill {
            id
            name
            description
            displayName
            slashCommand
						helpText
            iconUrl
            iconKey
            color
            source
            tags
            category
            integrationKeys
          }
        }
      }
      errors {
        message
      }
    }
  }
`;
/**
 * Session-level cache for fetched skills.
 * Keyed by `${cloudId}` to avoid redundant network requests.
 * Skills are cached for the lifetime of the page (matching Relay store behavior).
 * A page refresh will fetch fresh data.
 */ const $71f78acdff7635c4$var$skillsCache = new Map();
function $71f78acdff7635c4$export$e6cf70cf6554c856() {
    $71f78acdff7635c4$var$skillsCache.clear();
}
/**
 * Fetch skills using the new unified convoai_availableSkills endpoint.
 */ async function $71f78acdff7635c4$var$fetchSkillsUnified(cloudId) {
    const response = await fetch($71f78acdff7635c4$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify({
            query: $71f78acdff7635c4$var$UNIFIED_SKILLS_QUERY,
            variables: {
                cloudId: cloudId,
                first: 150
            }
        })
    });
    if (!response.ok) return [];
    const json = await response.json();
    if (json.errors?.length || json.data?.convoai_availableSkills?.errors?.length) return [];
    const edges = json.data?.convoai_availableSkills?.edges;
    return (0, $f6VI9.parseConvoAiSkillEdges)(edges);
}
async function $71f78acdff7635c4$export$268d57ae88e7df66(cloudId) {
    const cacheKey = cloudId;
    const cached = $71f78acdff7635c4$var$skillsCache.get(cacheKey);
    if (cached) return cached;
    try {
        const skills = await $71f78acdff7635c4$var$fetchSkillsUnified(cloudId);
        $71f78acdff7635c4$var$skillsCache.set(cacheKey, skills);
        return skills;
    } catch  {
        // Silently fail — the insert menu will just not show skills
        return [];
    }
}
module.exports["clearSkillsCache"] = $71f78acdff7635c4$export$e6cf70cf6554c856;
module.exports["fetchSkills"] = $71f78acdff7635c4$export$268d57ae88e7df66;

});

parcelRegister("aIn0d", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $i1t43 = parcelRequire("i1t43");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $10I6z = parcelRequire("10I6z");

const $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $5f85a79aee555eb3$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $5f85a79aee555eb3$export$e0542ba0c737fe5c = ({ onLinkClick: onLinkClick, withLink: withLink = false })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const disclaimerContent = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.subtlest"
    }, formatMessage((0, $10I6z.i18n).disclaimerMessage));
    if (withLink) return /*#__PURE__*/ $cozmU.createElement((0, $i1t43.default), {
        appearance: "subtle",
        href: $5f85a79aee555eb3$var$AI_DISCLAIMER_LINK,
        target: "_blank",
        onClick: onLinkClick
    }, disclaimerContent);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($5f85a79aee555eb3$var$styles.text)
    }, disclaimerContent);
};
module.exports["AIDisclaimer"] = $5f85a79aee555eb3$export$e0542ba0c737fe5c;

});

parcelRegister("10I6z", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $1ae8fb340800d3e1$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    disclaimerMessage: {
        id: "ai-disclaimer.disclaimerMessage",
        defaultMessage: "Uses AI. Verify results."
    }
});
module.exports["i18n"] = $1ae8fb340800d3e1$export$a7357cdd1f0b0168;

});

parcelRegister("kWSTb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9feda705e9481f913d0df858359ce6d6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f403cd42107c74dc$var$_react = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("cozmU")));

var $f403cd42107c74dc$var$_iconNew = $f403cd42107c74dc$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $f403cd42107c74dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeSlides".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/ai-generative-slides
 * Usage guidance:
 * Reserved for Confluence Slides
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f403cd42107c74dc$var$AiGenerativeSlidesIcon = (props)=>/*#__PURE__*/ $f403cd42107c74dc$var$_react.default.createElement($f403cd42107c74dc$var$_iconNew.default, Object.assign({
        name: "AiGenerativeSlidesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 10V3.5H0V2h8v1.5H2.5V10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5H15V10a2 2 0 0 1-2 2h-1.376l1.822 2.139-1.142.972L9.654 12H8.75v3h-1.5v-3h-.903l-2.65 3.111-1.143-.972L4.376 12H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M13.115.009a.75.75 0 0 1 .541.378l.05.106.4 1.102c.051.138.16.248.3.299l1.1.4a.75.75 0 0 1 0 1.411l-1.1.401a.5.5 0 0 0-.3.3l-.4 1.1a.75.75 0 0 1-1.411 0l-.401-1.1a.5.5 0 0 0-.3-.3l-1.1-.4a.75.75 0 0 1-.485-.59L10 3l.009-.116a.75.75 0 0 1 .484-.59l1.102-.4a.5.5 0 0 0 .299-.3l.4-1.1.05-.107A.75.75 0 0 1 12.999 0z"/>`
    }, props));
$f403cd42107c74dc$var$AiGenerativeSlidesIcon.displayName = 'AiGenerativeSlidesIcon';
var $f403cd42107c74dc$var$_default = module.exports.default = $f403cd42107c74dc$var$AiGenerativeSlidesIcon;

});

parcelRegister("2eX69", function(module, exports) {

var $e9nC3 = parcelRequire("e9nC3");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $5BnIc = parcelRequire("5BnIc");


var $9C5oc = parcelRequire("9C5oc");


var $h45y6 = parcelRequire("h45y6");

const $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $a45798977a968ec1$var$singleLineTruncatedText = (text, length = $a45798977a968ec1$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $9C5oc.default)(singleLineText, length);
};
class $a45798977a968ec1$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $a45798977a968ec1$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $5BnIc.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $a45798977a968ec1$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h45y6.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            onCancel: this.props.onCancel,
            locale: this.props.locale,
            anonymousFeedback: (0, $iDrrr.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef,
            dialogRef: this.props.dialogRef,
            disableSubmitButton: this.props.disableSubmitButton,
            ...(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                enrolInResearchLink: this.props.enrolInResearchLink,
                canBeContactedLink: this.props.canBeContactedLink
            },
            showRequiredFieldsSummary: this.props.showRequiredFieldsSummary
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $5BnIc.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $e9nC3.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}
$a45798977a968ec1$export$2e2bcd8739ae039.defaultProps = {
    locale: 'en',
    url: '/gateway/api',
    shouldGetEntitlementDetails: true,
    canBeContactedFieldId: 'customfield_10043',
    canBeContactedAgreeValue: [
        {
            id: '10109'
        }
    ],
    canBeContactedDeclineValue: [
        {
            id: '10111'
        }
    ],
    additionalFields: [],
    customerNameFieldId: 'customfield_10045',
    customerNameDefaultValue: 'unknown',
    descriptionFieldId: 'description',
    descriptionDefaultValue: '',
    enrollInResearchFieldId: 'customfield_10044',
    enrollInResearchAgreeValue: [
        {
            id: '10110'
        }
    ],
    enrollInResearchDeclineValue: [
        {
            id: '10112'
        }
    ],
    summaryFieldId: 'summary',
    summaryDefaultValue: '',
    summaryTruncateLength: 100,
    timeoutOnSubmit: 700,
    typeFieldId: 'customfield_10042',
    typeBugDefaultValue: {
        id: '10105'
    },
    typeCommentDefaultValue: {
        id: '10106'
    },
    typeSuggestionDefaultValue: {
        id: '10107'
    },
    typeQuestionDefaultValue: {
        id: '10108'
    },
    typeEmptyDefaultValue: {
        id: 'empty'
    },
    showTypeField: true,
    showDefaultTextFields: true,
    anonymousFeedback: false,
    onClose: ()=>{},
    onSubmit: ()=>{}
};
module.exports["default"] = $a45798977a968ec1$export$2e2bcd8739ae039;

});

parcelRegister("5BnIc", function(module, exports) {
const $db292a71bf6452ef$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);
module.exports["isApiGatewayUrl"] = $db292a71bf6452ef$export$f0f6fc934288a17c;

});

parcelRegister("9C5oc", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c5409c9e56ee67a$export$2e2bcd8739ae039);
function $0c5409c9e56ee67a$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("h45y6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2uDbg = parcelRequire("2uDbg");


var $7BfeF = parcelRequire("7BfeF");


var $dUI0h = parcelRequire("dUI0h");


var $2Nu0e = parcelRequire("2Nu0e");


var $dTHYM = parcelRequire("dTHYM");


var $dQLwo = parcelRequire("dQLwo");


var $hpa99 = parcelRequire("hpa99");


var $i1t43 = parcelRequire("i1t43");


var $fEPJS = parcelRequire("fEPJS");


var $7aRdF = parcelRequire("7aRdF");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");


var $iDrrr = parcelRequire("iDrrr");


var $1VhsF = parcelRequire("1VhsF");


var $6wGOF = parcelRequire("6wGOF");


var $e3Wrf = parcelRequire("e3Wrf");


var $5r21M = parcelRequire("5r21M");


var $hTUp6 = parcelRequire("hTUp6");

const $dcf72f8838f67ff8$var$LinkWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            paddingInlineStart: "var(--ds-space-300, 24px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginInlineStart: "var(--ds-space-050, 4px)"
        }
    }, children);
};
const $dcf72f8838f67ff8$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onCancel: onCancel, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, canBeContactedLink: canBeContactedLink, enrolInResearchLabel: enrolInResearchLabel, enrolInResearchLink: enrolInResearchLink, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef, dialogRef: dialogRef, disableSubmitButton: disableSubmitButton, showRequiredFieldsSummary: showRequiredFieldsSummary = true })=>{
    const [canBeContacted, setCanBeContacted] = (0, $cozmU.useState)(false);
    const [description, setDescription] = (0, $cozmU.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $cozmU.useState)(false);
    const [type, setType] = (0, $cozmU.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $cozmU.useState)(false);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isTypeSelected = ()=>type !== 'empty';
    const validateType = (value)=>showTypeField && (!value || value === 'empty') ? formatMessage((0, $5r21M.messages).validationErrorTypeRequired) : undefined;
    const validateDescription = (value)=>{
        if (!showDefaultTextFields || hasDescriptionDefaultValue) return undefined;
        return !value || !value.trim() ? formatMessage((0, $5r21M.messages).validationErrorDescriptionRequired) : undefined;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleCancel = (...args)=>{
        onCancel?.(...args);
        // Forward every arg the click handler received so consumers retain the full
        // pre-change runtime contract (originating event + Atlaskit UI analytics event).
        onClose(...args);
    };
    const canShowTextField = isTypeSelected() || !showTypeField;
    const isDisabled = isSubmitting || disableSubmitButton;
    const getFieldLabels = (record)=>({
            bug: record?.bug?.fieldLabel || formatMessage((0, $5r21M.messages).formBugLabel),
            comment: record?.comment?.fieldLabel || formatMessage((0, $5r21M.messages).formCommentLabel),
            suggestion: record?.suggestion?.fieldLabel || formatMessage((0, $5r21M.messages).formSuggestionLabel),
            question: record?.question?.fieldLabel || formatMessage((0, $5r21M.messages).formQuestionLabel),
            empty: record?.empty?.fieldLabel || formatMessage((0, $5r21M.messages).formEmptyLabel),
            not_relevant: record?.not_relevant?.fieldLabel || formatMessage((0, $5r21M.messages).formNotRelevantLabel),
            not_accurate: record?.not_accurate?.fieldLabel || formatMessage((0, $5r21M.messages).formNotAccurateLabel),
            too_slow: record?.too_slow?.fieldLabel || formatMessage((0, $5r21M.messages).formTooSlowLabel),
            unhelpful_links: record?.unhelpful_links?.fieldLabel || formatMessage((0, $5r21M.messages).formUnhelpfulLinksLabel),
            other: record?.other?.fieldLabel || formatMessage((0, $5r21M.messages).formOtherLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty?.selectOptionLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $cozmU.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    const renderContactLabelAppify = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelAppifyWithResponse;
    };
    const renderContactLabel = ()=>{
        if ((0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements')) return (0, $5r21M.messages).canBeContactedLabelWithResponseWithoutLink;
        return (0, $5r21M.messages).canBeContactedLabelWithResponse;
    };
    const requiredFieldsSummary = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text-subtle, #505258)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            marginBottom: "var(--ds-space-300, 24px)"
        }
    }, formatMessage((0, $5r21M.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpa99.RequiredAsterisk), null));
    const feedbackIsAnonymous = // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("p", null, formatMessage((0, $5r21M.messages).feedbackIsAnonymous));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aRdF.default), {
        ref: dialogRef,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef,
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            try {
                await onSubmit({
                    canBeContacted: canBeContacted,
                    description: description,
                    enrollInResearchGroup: enrollInResearchGroup,
                    type: type
                });
            } finally{
                setIsSubmitting(false);
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).feedbackTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, showRequiredFieldsSummary && requiredFieldsSummary, feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "topic",
        id: "topic",
        label: selectLabel || formatMessage((0, $5r21M.messages).selectionOptionDefaultLabel),
        isRequired: true,
        validate: validateType
    }, ({ fieldProps: { id: id, ...restProps }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6wGOF.default), {
            ...restProps,
            value: selectOptions.find((opt)=>opt.value === type) ?? null,
            onChange: (option)=>{
                if (!option || option instanceof Array) return;
                setType(option.value);
                restProps.onChange?.(option.value);
            },
            menuPosition: "fixed",
            options: selectOptions,
            shouldPreventEscapePropagation: true,
            // @ts-ignore
            ref: focusRef,
            placeholder: getDefaultPlaceholder(feedbackGroupLabels),
            inputId: id,
            isInvalid: !!error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $5r21M.messages).defaultCustomTextAreaLabel),
        isRequired: true,
        name: "description",
        id: "description",
        validate: validateDescription
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...fieldProps,
            name: "foo",
            minimumRows: 6,
            placeholder: summaryPlaceholder || undefined,
            onChange: (e)=>{
                setDescription(e.target.value);
                fieldProps.onChange(e.target.value);
            },
            value: description
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dQLwo.MessageWrapper), null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7BfeF.ErrorMessage), null, error)))), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Nu0e.Fieldset), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).optInOptionsLegend)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "can-be-contacted"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $iDrrr.fg)('product-terminology-refresh') ? renderContactLabelAppify() : renderContactLabel(),
                ...!(0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && {
                    values: {
                        a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }
            }),
            onChange: (event)=>setCanBeContacted(event.target.checked)
        }), canBeContactedLabel && canBeContactedLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, canBeContactedLink), !canBeContactedLabel && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
            href: "https://www.atlassian.com/legal/privacy-policy",
            target: "_blank"
        }, formatMessage((0, $5r21M.messages).privacyPolicy))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: "enroll-in-research-group"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            ...fieldProps,
            "aria-describedby": undefined,
            label: enrolInResearchLabel || formatMessage((0, $5r21M.messages).enrolInResearchLabel),
            onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
        }), enrolInResearchLabel && enrolInResearchLink && (0, $iDrrr.fg)('jfp_a11y_team_feedback_collector_nested_elements') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$LinkWrapper, null, enrolInResearchLink)))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: 'anonymousFeedback'
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
            title: formatMessage((0, $5r21M.messages).feedbackIsAnonymousTitle),
            appearance: 'information'
        }, feedbackIsAnonymous))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleCancel
    }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "primary",
        type: "submit",
        isDisabled: isSubmitting || isDisabled,
        testId: "feedbackCollectorSubmitBtn"
    }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $5r21M.messages).submitButtonLabel)))));
};
const $dcf72f8838f67ff8$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTUp6.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dcf72f8838f67ff8$var$FeedbackForm, props));
};
var $dcf72f8838f67ff8$export$2e2bcd8739ae039 = $dcf72f8838f67ff8$var$FeedbackFormWithIntl;
module.exports["default"] = $dcf72f8838f67ff8$export$2e2bcd8739ae039;

});

parcelRegister("5r21M", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0eef762dd50d9f91$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    feedbackTitle: {
        id: "feedback-collector.feedback-title",
        defaultMessage: "Share your thoughts"
    },
    enrolInResearchLabel: {
        id: "feedback-collector.enrol-in-research.label",
        defaultMessage: "I'd like to participate in product research"
    },
    canBeContactedLabelWithResponse: {
        id: "feedback-collector.can-be-contacted.label-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian products and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    privacyPolicy: {
        id: "feedback-collector.privacy-policy",
        defaultMessage: "Atlassian Privacy Policy"
    },
    summaryPlaceholder: {
        id: "feedback-collector.summary-placeholder",
        defaultMessage: "Let us know what's on your mind"
    },
    formCommentLabel: {
        id: "feedback-collector.form.comment.label",
        defaultMessage: "Let us know what's on your mind"
    },
    submitButtonLabel: {
        id: "feedback-collector.submit-button.label",
        defaultMessage: "Send feedback"
    },
    cancelButtonLabel: {
        id: "feedback-collector.cancel-button.label",
        defaultMessage: "Cancel"
    },
    giveFeedback: {
        id: "proforma-form-builder.give-feedback",
        defaultMessage: "Give feedback"
    },
    formBugLabel: {
        id: "feedback-collector.form.bug.label",
        defaultMessage: "Describe the bug or issue"
    },
    formSuggestionLabel: {
        id: "feedback-collector.form.suggestion.label",
        defaultMessage: "Let us know what you'd like to improve"
    },
    formQuestionLabel: {
        id: "feedback-collector.form.question.label",
        defaultMessage: "What would you like to know?"
    },
    formEmptyLabel: {
        id: "feedback-collector.form.empty.label",
        defaultMessage: "Select an option"
    },
    formNotRelevantLabel: {
        id: "feedback-collector.form.not-relevant.label",
        defaultMessage: "Wasn't relevant"
    },
    formNotAccurateLabel: {
        id: "feedback-collector.form.not-accurate.label",
        defaultMessage: "Wasn't accurate"
    },
    formTooSlowLabel: {
        id: "feedback-collector.form.too-slow.label",
        defaultMessage: "Too slow"
    },
    formUnhelpfulLinksLabel: {
        id: "feedback-collector.form.unhelpful-links.label",
        defaultMessage: "Unhelpful links"
    },
    formOtherLabel: {
        id: "feedback-collector.form.other.label",
        defaultMessage: "Other"
    },
    selectionOptionQuestionLabel: {
        id: "feedback-collector.option.question.label",
        defaultMessage: "Ask a question"
    },
    selectionOptionCommentLabel: {
        id: "feedback-collector.option.comment.label",
        defaultMessage: "Leave a comment"
    },
    selectionOptionBugLabel: {
        id: "feedback-collector.option.bug.label",
        defaultMessage: "Report a bug"
    },
    selectionOptionSuggestionLabel: {
        id: "feedback-collector.option.suggestion.label",
        defaultMessage: "Suggest an improvement"
    },
    selectionOptionDefaultLabel: {
        id: "feedback-collector.option.default.label",
        defaultMessage: "Select feedback"
    },
    selectionOptionDefaultPlaceholder: {
        id: "feedback-collector.option.default.placeholder",
        defaultMessage: "Choose one"
    },
    feedbackIconLabel: {
        id: "proforma-form-builder.feedback-icon-label",
        defaultMessage: "Feedback"
    },
    feedbackSuccessFlagDescription: {
        id: "feedback-collector.success-flag.description",
        defaultMessage: "Your valuable feedback helps us continually improve our products."
    },
    feedbackSuccessFlagTitle: {
        id: "feedback-collector.success-flag.title",
        defaultMessage: "Thanks!"
    },
    feedbackIsAnonymousTitle: {
        id: "feedback-collector.anonymous.title",
        defaultMessage: "Anonymous feedback"
    },
    feedbackIsAnonymous: {
        id: "feedback-collector.anonymous",
        defaultMessage: "This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback"
    },
    requiredFieldsSummary: {
        id: "feedback-collector.required.fields.summary",
        defaultMessage: "Required fields are marked with an asterisk"
    },
    defaultCustomTextAreaLabel: {
        id: "feedback-collector.default.custom.textarea.label",
        defaultMessage: "What's on your mind?"
    },
    canBeContactedLabelAppifyWithResponse: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the <a>Atlassian Privacy Policy</a>."
    },
    canBeContactedLabelAppifyWithResponseWithoutLink: {
        id: "feedback-collector.can-be-contacted.label-appify-with-response-without-link",
        defaultMessage: "Yes, Atlassian teams can reply to my feedback and ask for more details about my experience to improve Atlassian apps and services. Without this, I won't get a response. I acknowledge the Atlassian Privacy Policy."
    },
    feedbackSuccessFlagDescriptionAppify: {
        id: "feedback-collector.success-flag.description-appify",
        defaultMessage: "Your valuable feedback helps us continually improve our apps."
    },
    validationErrorTypeRequired: {
        id: "feedback-collector.validation.type.required",
        defaultMessage: "Please select a feedback type"
    },
    validationErrorDescriptionRequired: {
        id: "feedback-collector.validation.description.required",
        defaultMessage: "Please provide a description"
    },
    optInOptionsLegend: {
        id: "feedback-collector.opt-in.options.legend",
        defaultMessage: "Atlassian opt-in options"
    }
});
module.exports["messages"] = $0eef762dd50d9f91$export$defe85febe8b728c;

});

parcelRegister("hTUp6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $b2A1s = parcelRequire("b2A1s");

const $fb8b4f9502ba72fc$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $b2A1s.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};
module.exports["IntlProviderWithResolvedMessages"] = $fb8b4f9502ba72fc$export$f793de1293176fe6;

});

parcelRegister("b2A1s", function(module, exports) {
const $e1a3f1d7e16f1235$var$isNestedMessagesModule = (value)=>'default' in value && typeof value.default === 'object' && value.default !== null;
const $e1a3f1d7e16f1235$var$unwrapMessages = (messages)=>{
    const defaultExport = messages.default;
    return $e1a3f1d7e16f1235$var$isNestedMessagesModule(defaultExport) ? defaultExport.default : defaultExport;
};





























const $e1a3f1d7e16f1235$var$messagesLoaders = {
    cs: ()=>(parcelRequire("gR4U1")),
    da: ()=>(parcelRequire("f1jrk")),
    de: ()=>(parcelRequire("aOLRB")),
    en: ()=>(parcelRequire("6kEFl")),
    en_GB: ()=>(parcelRequire("bjsxN")),
    en_ZZ: ()=>(parcelRequire("9DhD6")),
    es: ()=>(parcelRequire("ddpWy")),
    fi: ()=>(parcelRequire("5XvgX")),
    fr: ()=>(parcelRequire("cZf5E")),
    hr: ()=>(parcelRequire("CsODP")),
    hu: ()=>(parcelRequire("hPRyr")),
    it: ()=>(parcelRequire("z7zpe")),
    ja: ()=>(parcelRequire("8pzcT")),
    ko: ()=>(parcelRequire("1I2b8")),
    nb: ()=>(parcelRequire("gPBz3")),
    nl: ()=>(parcelRequire("78iTh")),
    pl: ()=>(parcelRequire("gHYE1")),
    pt_BR: ()=>(parcelRequire("9qN1z")),
    ru: ()=>(parcelRequire("dNwJi")),
    sl: ()=>(parcelRequire("fXweJ")),
    sr_RS: ()=>(parcelRequire("nFTVL")),
    sr_YR: ()=>(parcelRequire("bsw4B")),
    sv: ()=>(parcelRequire("97qPc")),
    th: ()=>(parcelRequire("bZmWu")),
    tr: ()=>(parcelRequire("aspSd")),
    uk: ()=>(parcelRequire("kWvvj")),
    vi: ()=>(parcelRequire("c5Sph")),
    zh: ()=>(parcelRequire("ecWO0")),
    zh_TW: ()=>(parcelRequire("dpkEO"))
};
const $e1a3f1d7e16f1235$var$getMessages = async (locale)=>{
    const loadMessages = $e1a3f1d7e16f1235$var$messagesLoaders[locale];
    if (!loadMessages) return undefined;
    try {
        const messages = await loadMessages();
        return $e1a3f1d7e16f1235$var$unwrapMessages(messages);
    } catch  {
        return undefined;
    }
};
const $e1a3f1d7e16f1235$export$d0a3169680473b6c = async (locale)=>{
    const localeKey = locale.replace('-', '_');
    const messages = await $e1a3f1d7e16f1235$var$getMessages(localeKey);
    return messages ?? $e1a3f1d7e16f1235$var$getMessages(localeKey.split(/[-_]/)[0]);
};
module.exports["getMessagesForLocale"] = $e1a3f1d7e16f1235$export$d0a3169680473b6c;

});

parcelRegister("gR4U1", function(module, exports) {

let $c455661dc243c654$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c455661dc243c654$var$load("iGnEn").then(()=>parcelRequire('6S4lG'));

});

parcelRegister("f1jrk", function(module, exports) {

let $aef60752586d2f07$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $aef60752586d2f07$var$load("81CwI").then(()=>parcelRequire('9Q7ky'));

});

parcelRegister("aOLRB", function(module, exports) {

let $7e03b39534ef9cf9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7e03b39534ef9cf9$var$load("coMdg").then(()=>parcelRequire('4ELWT'));

});

parcelRegister("6kEFl", function(module, exports) {

let $49c427b32ae5dc71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $49c427b32ae5dc71$var$load("4t3GG").then(()=>parcelRequire('aPmYJ'));

});

parcelRegister("bjsxN", function(module, exports) {

let $83c79c54c6feadd2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $83c79c54c6feadd2$var$load("lJDHR").then(()=>parcelRequire('fYO3Z'));

});

parcelRegister("9DhD6", function(module, exports) {

let $70356e70b5fecfa6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $70356e70b5fecfa6$var$load("izI99").then(()=>parcelRequire('fcttw'));

});

parcelRegister("ddpWy", function(module, exports) {

let $99f09d110267a62d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $99f09d110267a62d$var$load("3LmH0").then(()=>parcelRequire('iTEZG'));

});

parcelRegister("5XvgX", function(module, exports) {

let $456ab880bb5ad2de$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $456ab880bb5ad2de$var$load("9nUzh").then(()=>parcelRequire('jCyLN'));

});

parcelRegister("cZf5E", function(module, exports) {

let $9746e31b2d06b6ef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9746e31b2d06b6ef$var$load("b0H0M").then(()=>parcelRequire('sjYCD'));

});

parcelRegister("CsODP", function(module, exports) {

let $0739e6f0f7a8ce09$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0739e6f0f7a8ce09$var$load("rlX60").then(()=>parcelRequire('kdtG9'));

});

parcelRegister("hPRyr", function(module, exports) {

let $cfc0bde35e1c9468$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cfc0bde35e1c9468$var$load("8XGfa").then(()=>parcelRequire('9cMV0'));

});

parcelRegister("z7zpe", function(module, exports) {

let $0699244176860d72$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0699244176860d72$var$load("kX4YP").then(()=>parcelRequire('65zeK'));

});

parcelRegister("8pzcT", function(module, exports) {

let $61fbf7e9b29a6824$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $61fbf7e9b29a6824$var$load("cYuG5").then(()=>parcelRequire('amjcb'));

});

parcelRegister("1I2b8", function(module, exports) {

let $13eb9721d58dad03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $13eb9721d58dad03$var$load("5bV9Q").then(()=>parcelRequire('3z1HI'));

});

parcelRegister("gPBz3", function(module, exports) {

let $c40e8c41f36f3f1d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c40e8c41f36f3f1d$var$load("gjrov").then(()=>parcelRequire('ePp5T'));

});

parcelRegister("78iTh", function(module, exports) {

let $5317ef0d88303541$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5317ef0d88303541$var$load("ekD3q").then(()=>parcelRequire('3sPeQ'));

});

parcelRegister("gHYE1", function(module, exports) {

let $c29fb436da7f42d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c29fb436da7f42d1$var$load("CRIov").then(()=>parcelRequire('21Pza'));

});

parcelRegister("9qN1z", function(module, exports) {

let $6ddc91febcf834c3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6ddc91febcf834c3$var$load("kLzqf").then(()=>parcelRequire('2YIPE'));

});

parcelRegister("dNwJi", function(module, exports) {

let $a0b93d651cd2386e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a0b93d651cd2386e$var$load("89F7K").then(()=>parcelRequire('lXD2K'));

});

parcelRegister("fXweJ", function(module, exports) {

let $b9e55f3b28230681$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9e55f3b28230681$var$load("5ZUDB").then(()=>parcelRequire('16fIE'));

});

parcelRegister("nFTVL", function(module, exports) {

let $0472a6c8d6c4c707$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0472a6c8d6c4c707$var$load("h2pVk").then(()=>parcelRequire('byreT'));

});

parcelRegister("bsw4B", function(module, exports) {

let $857b304eeac06c5e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $857b304eeac06c5e$var$load("hKNph").then(()=>parcelRequire('diuUZ'));

});

parcelRegister("97qPc", function(module, exports) {

let $6a39935eb8b824b7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a39935eb8b824b7$var$load("bEB1L").then(()=>parcelRequire('57pGr'));

});

parcelRegister("bZmWu", function(module, exports) {

let $8ba730127f966548$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ba730127f966548$var$load("1DxcO").then(()=>parcelRequire('grvEM'));

});

parcelRegister("aspSd", function(module, exports) {

let $79d096d1d3432597$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $79d096d1d3432597$var$load("4KHc0").then(()=>parcelRequire('13DVp'));

});

parcelRegister("kWvvj", function(module, exports) {

let $f3f1a976fda4a8c1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f3f1a976fda4a8c1$var$load("fWsCx").then(()=>parcelRequire('im5if'));

});

parcelRegister("c5Sph", function(module, exports) {

let $8ce027b238ed199c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8ce027b238ed199c$var$load("eVExC").then(()=>parcelRequire('1U1j1'));

});

parcelRegister("ecWO0", function(module, exports) {

let $a57fcd3be5a7543a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a57fcd3be5a7543a$var$load("BGq3S").then(()=>parcelRequire('kBazV'));

});

parcelRegister("dpkEO", function(module, exports) {

let $9c2da245872fb648$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c2da245872fb648$var$load("1BBYh").then(()=>parcelRequire('3tROA'));

});

parcelRegister("206E4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $aR3ec = parcelRequire("aR3ec");

// `height` is set to 100% to allow the SVG to scale with the parent element
const $c3df761541b2068a$var$svg = `<svg height="100%" viewBox="0 0 48 48">
    <rect width="48" height="48" fill="var(--tile-color,#dddee1)" rx="12"/>
    <path fill="var(--icon-color, #101214)" d="m24.127 17.587-4.788 17.87 12.654 3.39 4.788-17.87z"/>
    <path fill="var(--icon-color, #101214)" d="M22.078 13.65 17.93 29.11H13V10h14.077v4.984z"/>
</svg>
`;
const $c3df761541b2068a$export$76a76378b46fc395 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ArtifactsIcon(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { size: t1, appearance: t2, label: t3, testId: testId } = t0;
    const size = t1 === undefined ? "medium" : t1;
    const appearance = t2 === undefined ? "brand" : t2;
    const label = t3 === undefined ? "Artifacts" : t3;
    let t4;
    if ($[0] !== appearance || $[1] !== label || $[2] !== size || $[3] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
            svg: $c3df761541b2068a$var$svg,
            label: label,
            appearance: appearance,
            size: size,
            testId: testId
        });
        $[0] = appearance;
        $[1] = label;
        $[2] = size;
        $[3] = testId;
        $[4] = t4;
    } else t4 = $[4];
    return t4;
} : function ArtifactsIcon({ size: size = 'medium', appearance: appearance = 'brand', label: label = 'Artifacts', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aR3ec.IconWrapper), {
        svg: $c3df761541b2068a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
};
module.exports["ArtifactsIcon"] = $c3df761541b2068a$export$76a76378b46fc395;

});

parcelRegister("lvJqX", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6JrSr = parcelRequire("6JrSr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $cEipP = parcelRequire("cEipP");

const $7c29b2adacb89176$var$styles = {
    contentStyles: "_4bt5LAIZbP _2WAcuGIZbP _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _1EqgXlhPwX _0NUa3rhPwX",
    rootStyles: "_3iDTPbvbI6 _1EqgXlN91d _4GplSjDF1i _2fqI0W7iY9",
    pressableStyles: "_0bjKvDKTcp _2sNsIgmnOE _4c065UPgdg _2Y7lL4Pgdg _3iDTPbccYA _0KLXru66of _1UtDYzZpcK _1ANEUSLRg7 _1mT5xdRAKS _0hPCNLQame _1EqgXlN91d _0jFU0VIZbP _39xV02IZbP _1RrJLiQame _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8"
};
const $7c29b2adacb89176$var$iconColor = {
    connectivity: "_2bHMMpZFWO",
    confirmation: "_2bHMMpfyEX",
    info: "_2bHMMpTNil",
    warning: "_2bHMMpspgB",
    error: "_2bHMMp7j8z"
}; /**
    * __Inline message__
    *
    * An inline message lets users know when important information is available or when an action is required.
    *
    * - [Examples](https://atlassian.design/components/inline-message/examples)
    * - [Code](https://atlassian.design/components/inline-message/code)
    * - [Usage](https://atlassian.design/components/inline-message/usage)
    *
    * @example
    *
    * ```jsx
    * const Component = () => (
    *   <InlineMessage
    *    title="Inline Message Title Example"
    *    secondaryText="Secondary Text"
    *   >
    *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
    *   </InlineMessage>
    * );
    * ```
    */ 
const $7c29b2adacb89176$var$InlineMessage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { placement: t1, secondaryText: t2, title: t3, appearance: t4, spacing: t5, children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements } = t0;
    const placement = t1 === undefined ? "bottom-start" : t1;
    const secondaryText = t2 === undefined ? "" : t2;
    const title = t3 === undefined ? "" : t3;
    const appearance = t4 === undefined ? "connectivity" : t4;
    const spacing = t5 === undefined ? "spacious" : t5;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    let t6;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsOpen($7c29b2adacb89176$var$_temp);
        };
        $[0] = t6;
    } else t6 = $[0];
    const toggleDialog = t6;
    let t7;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>setIsOpen(false);
        $[1] = t7;
    } else t7 = $[1];
    const onCloseDialog = t7;
    const t8 = $7c29b2adacb89176$var$iconColor[appearance];
    let t9;
    if ($[2] !== t8) {
        t9 = (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            t8
        ]);
        $[2] = t8;
        $[3] = t9;
    } else t9 = $[3];
    let t10;
    if ($[4] !== children) {
        t10 = ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $7c29b2adacb89176$var$styles.contentStyles,
                children: children
            });
        $[4] = children;
        $[5] = t10;
    } else t10 = $[5];
    const t11 = testId && `${testId}--popup`;
    let t12;
    if ($[6] !== appearance || $[7] !== iconLabel || $[8] !== id || $[9] !== isOpen || $[10] !== secondaryText || $[11] !== spacing || $[12] !== testId || $[13] !== title) {
        t12 = (t13)=>{
            const { ref: ref, ...triggerProps } = t13;
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                ...triggerProps,
                ref: ref,
                id: id,
                "data-ds--inline-message--button": true,
                onClick: toggleDialog,
                testId: testId && `${testId}--button`,
                xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                    as: "span",
                    space: "space.050",
                    alignBlock: "center",
                    children: [
                        /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cEipP.default), {
                            isOpen: isOpen,
                            appearance: appearance,
                            label: iconLabel,
                            spacing: spacing
                        }),
                        /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                            as: "span",
                            space: "space.100",
                            children: [
                                title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    weight: "medium",
                                    testId: testId && `${testId}--title`,
                                    children: title
                                }),
                                secondaryText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                    weight: "medium",
                                    color: "color.text.subtlest",
                                    maxLines: 1,
                                    testId: testId && `${testId}--text`,
                                    children: secondaryText
                                })
                            ]
                        })
                    ]
                })
            });
        };
        $[6] = appearance;
        $[7] = iconLabel;
        $[8] = id;
        $[9] = isOpen;
        $[10] = secondaryText;
        $[11] = spacing;
        $[12] = testId;
        $[13] = title;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== fallbackPlacements || $[16] !== id || $[17] !== isOpen || $[18] !== placement || $[19] !== t10 || $[20] !== t11 || $[21] !== t12) {
        t13 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            onClose: onCloseDialog,
            content: t10,
            isOpen: isOpen,
            placement: placement,
            testId: t11,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: t12
        });
        $[15] = fallbackPlacements;
        $[16] = id;
        $[17] = isOpen;
        $[18] = placement;
        $[19] = t10;
        $[20] = t11;
        $[21] = t12;
        $[22] = t13;
    } else t13 = $[22];
    let t14;
    if ($[23] !== t13 || $[24] !== t9 || $[25] !== testId) {
        t14 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            "data-testid": testId,
            className: t9,
            children: t13
        });
        $[23] = t13;
        $[24] = t9;
        $[25] = testId;
        $[26] = t14;
    } else t14 = $[26];
    return t14;
} : ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const id = (0, $6JrSr.useId)();
    const toggleDialog = (0, $cozmU.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $cozmU.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            $7c29b2adacb89176$var$styles.rootStyles,
            $7c29b2adacb89176$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4n1IT.Popup), {
            onClose: onCloseDialog,
            content: ()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                    xcss: $7c29b2adacb89176$var$styles.contentStyles,
                    children: children
                }),
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--popup`,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                    ...triggerProps,
                    ref: ref,
                    id: id,
                    "data-ds--inline-message--button": true,
                    onClick: toggleDialog,
                    testId: testId && `${testId}--button`,
                    xcss: $7c29b2adacb89176$var$styles.pressableStyles,
                    "aria-expanded": isOpen,
                    children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                        as: "span",
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cEipP.default), {
                                isOpen: isOpen,
                                appearance: appearance,
                                label: iconLabel,
                                spacing: spacing
                            }),
                            /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $1l0kj.Inline), {
                                as: "span",
                                space: "space.100",
                                children: [
                                    title && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: "medium",
                                        testId: testId && `${testId}--title`,
                                        children: title
                                    }),
                                    secondaryText && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4aRua.Text), {
                                        weight: "medium",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        testId: testId && `${testId}--text`,
                                        children: secondaryText
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $7c29b2adacb89176$export$2e2bcd8739ae039 = $7c29b2adacb89176$var$InlineMessage;
function $7c29b2adacb89176$var$_temp(oldState) {
    return !oldState;
}
module.exports["default"] = $7c29b2adacb89176$export$2e2bcd8739ae039;

});

parcelRegister("cEipP", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $axHIJ = parcelRequire("axHIJ");

const $fe4d2a60aea58684$var$iconColor = {
    connectivity: "_1UtDYzZFWO",
    confirmation: "_1UtDYzfyEX",
    info: "_1UtDYzTNil",
    warning: "_1UtDYzspgB",
    error: "_1UtDYz7j8z"
};
const $fe4d2a60aea58684$var$iconWrapperStyles = null;
const $fe4d2a60aea58684$var$iconColorStyles = null; /**
                               * __Selected icon__
                               *
                               * The selected icon is used as the primary interactive element for the dialog.
                               * Can be used with or without supporting text.
                               */ 
const $fe4d2a60aea58684$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $axHIJ.typesMapping);
    return /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _3iDTPbQ4SZ _0hPCNLDIqT",
            $fe4d2a60aea58684$var$iconColor[appearance],
            isOpen && "_1UtDYzDF1i"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            spacing: spacing
        })
    });
};
var $fe4d2a60aea58684$export$2e2bcd8739ae039 = $fe4d2a60aea58684$var$SelectedIcon;
module.exports["default"] = $fe4d2a60aea58684$export$2e2bcd8739ae039;

});

parcelRegister("axHIJ", function(module, exports) {

var $24dy7 = parcelRequire("24dy7");


var $fodiz = parcelRequire("fodiz");


var $chu6R = parcelRequire("chu6R");


var $lMGh1 = parcelRequire("lMGh1");

const $0c91ff1a933c23ee$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($chu6R))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($fodiz))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($24dy7))),
        defaultLabel: 'error inline message'
    }
};
module.exports["typesMapping"] = $0c91ff1a933c23ee$export$4d111645c0b39d5d;

});

parcelRegister("kgHuu", function(module, exports) {
$parcel$export(module.exports, "Targets", () => (parcelRequire("3qdJ0")).Targets);

var $6ROIE = parcelRequire("6ROIE");


var $3qdJ0 = parcelRequire("3qdJ0");


});

parcelRegister("6ROIE", function(module, exports) {
class $f31eace768ed80b8$export$a5e53d1dcbd6eb61 {
    constructor(options){
        Object.assign(this, options);
        Object.freeze(this);
    }
}
module.exports["CrossFlowExtensions"] = $f31eace768ed80b8$export$a5e53d1dcbd6eb61;

});

parcelRegister("5O8nX", function(module, exports) {

var $ilC9E = parcelRequire("ilC9E");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/townsquare/project/manifest.ts
var $43a820726e3539da$var$townsquareProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $ilC9E.TownsquareProjectAriResourceOwner),
    resourceType: (0, $ilC9E.TownsquareProjectAriResourceType),
    resourceIdSlug: "{projectUuid}",
    resourceIdSegmentFormats: {
        projectUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/project/index.ts
var $43a820726e3539da$export$41215e8d01921e7d = class _TownsquareProjectAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get projectUuid() {
        return this._projectUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $43a820726e3539da$var$townsquareProjectAriStaticOpts.qualifier,
            platformQualifier: $43a820726e3539da$var$townsquareProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $43a820726e3539da$var$townsquareProjectAriStaticOpts.resourceOwner,
            resourceType: $43a820726e3539da$var$townsquareProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectUuid}`,
            resourceIdSegmentValues: {
                projectUuid: opts.projectUuid
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $43a820726e3539da$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $43a820726e3539da$var$townsquareProjectAriStaticOpts);
        return new _TownsquareProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectUuid: this.projectUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._projectUuid = opts.resourceIdSegmentValues.projectUuid;
    }
};
module.exports["TownsquareProjectAri"] = $43a820726e3539da$export$41215e8d01921e7d;

});

parcelRegister("ilC9E", function(module, exports) {
// src/townsquare/project/types.ts
var $d5b7c8e3ddea6aee$export$a258bc824c789b17 = "townsquare", $d5b7c8e3ddea6aee$export$aa8900dadffaa32a = "project";
module.exports["TownsquareProjectAriResourceOwner"] = $d5b7c8e3ddea6aee$export$a258bc824c789b17;
module.exports["TownsquareProjectAriResourceType"] = $d5b7c8e3ddea6aee$export$aa8900dadffaa32a;

});

parcelRegister("lRhY3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $bc35f8d5f81a3a68$var$noop = (props)=>{};
const $bc35f8d5f81a3a68$export$5f5debba1692bf40 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(5);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                open: $bc35f8d5f81a3a68$var$noop,
                close: $bc35f8d5f81a3a68$var$noop,
                setPanelWidth: $bc35f8d5f81a3a68$var$noop
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== context.close || $[2] !== context.open || $[3] !== context.setPanelWidth) {
        t0 = {
            open: context.open,
            close: context.close,
            setPanelWidth: context.setPanelWidth
        };
        $[1] = context.close;
        $[2] = context.open;
        $[3] = context.setPanelWidth;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (!context) return {
        open: $bc35f8d5f81a3a68$var$noop,
        close: $bc35f8d5f81a3a68$var$noop,
        setPanelWidth: $bc35f8d5f81a3a68$var$noop
    };
    return {
        open: context.open,
        close: context.close,
        setPanelWidth: context.setPanelWidth
    };
};
module.exports["usePreviewPanelsActions"] = $bc35f8d5f81a3a68$export$5f5debba1692bf40;

});

parcelRegister("3Ap09", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cha5E = parcelRequire("cha5E");


var $63gyv = parcelRequire("63gyv");


var $7ssWV = parcelRequire("7ssWV");

const $4db84584556d15be$var$noop = ()=>{};
const $4db84584556d15be$var$initialState = {
    // Configured when opening a panel.
    panel: null,
    onOpen: $4db84584556d15be$var$noop,
    onClose: $4db84584556d15be$var$noop
};
const $4db84584556d15be$export$f473d225913e225d = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $4db84584556d15be$var$previewPanelsReducer = (state, action)=>{
    switch(action.type){
        case 'CLOSE':
            // Action explicitly called in order to close the active panel.
            action.onClose?.();
            state.panel && state?.onPreviewPanelClose?.(state.panel);
            return {
                ...state,
                panel: null,
                onOpen: $4db84584556d15be$var$noop,
                onClose: $4db84584556d15be$var$noop
            };
        case 'OPEN':
            // Action explicitly called in order to open a new panel.
            const { params: params } = action;
            // If the panel is already open, do nothing.
            if (state.panel?.id === params.panel.id) return state;
            /*
      	When opening a new preview panel, if the current panel is of the same type we don't
      	want to close the panel, but rather swap out the content. If the panel types don't match
      	we close the current panel and open the new one.
      	ex: A Goals panel is already open, and user tries to open a different Goals panel.
      	Parent Products must pass their preview panel close functions to the Preview Panel provider
      	via the `onPreviewPanelClose` prop.
      */ if (state.panel && !(0, $7ssWV.doPreviewPanelTypesMatch)(state.panel, params.panel)) // Close the active panel.
            state.onPreviewPanelClose?.(state.panel);
            state.panel && state.onClose();
            // Open the new panel.
            params.onOpen?.();
            state?.onPreviewPanelOpen?.(params.panel);
            return {
                ...state,
                panel: params.panel,
                onOpen: params.onOpen || $4db84584556d15be$var$initialState.onOpen,
                onClose: params.onClose || $4db84584556d15be$var$initialState.onClose
            };
        default:
            return state;
    }
};
const $4db84584556d15be$export$65ae37e9c61321f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth } = t0;
    let t1;
    if ($[0] !== initialWidth) {
        t1 = (0, $cha5E.expVal)("nin_glance_panel", "isEnabled", false) ? {
            initialWidth: initialWidth
        } : undefined;
        $[0] = initialWidth;
        $[1] = t1;
    } else t1 = $[1];
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)(t1);
    let t2;
    if ($[2] !== initialPanel) {
        t2 = initialPanel ? {
            panel: initialPanel
        } : {};
        $[2] = initialPanel;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== onPreviewPanelClose || $[5] !== onPreviewPanelOpen || $[6] !== t2) {
        t3 = {
            ...$4db84584556d15be$var$initialState,
            ...t2,
            onPreviewPanelOpen: onPreviewPanelOpen,
            onPreviewPanelClose: onPreviewPanelClose
        };
        $[4] = onPreviewPanelClose;
        $[5] = onPreviewPanelOpen;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, t3);
    let t4;
    if ($[8] !== onPanelWidthChanged || $[9] !== parentProduct || $[10] !== state) {
        t4 = (width)=>{
            onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
        };
        $[8] = onPanelWidthChanged;
        $[9] = parentProduct;
        $[10] = state;
        $[11] = t4;
    } else t4 = $[11];
    const setPanelWidth = t4;
    let t5;
    if ($[12] !== onPanelClosed) {
        t5 = (onClose)=>{
            dispatch?.({
                type: "CLOSE",
                onClose: onClose
            });
            onPanelClosed();
        };
        $[12] = onPanelClosed;
        $[13] = t5;
    } else t5 = $[13];
    const close = t5;
    let t6;
    if ($[14] !== onPanelOpened) {
        t6 = (params)=>{
            dispatch?.({
                type: "OPEN",
                params: params
            });
            onPanelOpened(params.width);
        };
        $[14] = onPanelOpened;
        $[15] = t6;
    } else t6 = $[15];
    const open = t6;
    let t7;
    if ($[16] !== close || $[17] !== open || $[18] !== panelWidth || $[19] !== setPanelWidth || $[20] !== state) {
        t7 = {
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        };
        $[16] = close;
        $[17] = open;
        $[18] = panelWidth;
        $[19] = setPanelWidth;
        $[20] = state;
        $[21] = t7;
    } else t7 = $[21];
    const context = t7;
    let t8;
    if ($[22] !== children || $[23] !== context) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
            value: context
        }, children);
        $[22] = children;
        $[23] = context;
        $[24] = t8;
    } else t8 = $[24];
    return t8;
} : ({ onPreviewPanelOpen: onPreviewPanelOpen, onPreviewPanelClose: onPreviewPanelClose, parentProduct: parentProduct, children: children, initialPanel: initialPanel, initialWidth: initialWidth })=>{
    const { panelWidth: panelWidth, onPanelClosed: onPanelClosed, onPanelOpened: onPanelOpened, onPanelWidthChanged: onPanelWidthChanged } = (0, $63gyv.usePanelWidth)((0, $cha5E.expVal)('nin_glance_panel', 'isEnabled', false) ? {
        initialWidth: initialWidth
    } : undefined);
    const [state, dispatch] = (0, $cozmU.useReducer)($4db84584556d15be$var$previewPanelsReducer, {
        ...$4db84584556d15be$var$initialState,
        ...initialPanel ? {
            panel: initialPanel
        } : {},
        onPreviewPanelOpen: onPreviewPanelOpen,
        onPreviewPanelClose: onPreviewPanelClose
    });
    const setPanelWidth = (0, $cozmU.useCallback)((width)=>{
        onPanelWidthChanged(width, state.panel?.product, state.panel?.type, parentProduct);
    }, [
        onPanelWidthChanged,
        parentProduct,
        state
    ]);
    const close = (0, $cozmU.useCallback)((onClose)=>{
        dispatch?.({
            type: 'CLOSE',
            onClose: onClose
        });
        onPanelClosed();
    }, [
        dispatch,
        onPanelClosed
    ]);
    const open = (0, $cozmU.useCallback)((params)=>{
        dispatch?.({
            type: 'OPEN',
            params: params
        });
        onPanelOpened(params.width);
    }, [
        dispatch,
        onPanelOpened
    ]);
    const context = (0, $cozmU.useMemo)(()=>({
            state: state,
            open: open,
            close: close,
            width: panelWidth,
            setPanelWidth: setPanelWidth
        }), [
        close,
        panelWidth,
        open,
        setPanelWidth,
        state
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4db84584556d15be$export$f473d225913e225d.Provider, {
        value: context
    }, children);
};
const $4db84584556d15be$export$609db4be92d0fad8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
} : ()=>{
    return (0, $cozmU.useContext)($4db84584556d15be$export$f473d225913e225d);
};
module.exports["PreviewPanelsProvider"] = $4db84584556d15be$export$65ae37e9c61321f9;
module.exports["usePreviewPanelsContext"] = $4db84584556d15be$export$609db4be92d0fad8;

});

parcelRegister("63gyv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $55fM8 = parcelRequire("55fM8");


var $9DHhW = parcelRequire("9DHhW");


var $7y9ez = parcelRequire("7y9ez");

const $4ad8ebf5df3a3b12$export$82b270f291af5a5 = ({ initialWidth: initialWidth } = {})=>{
    const [defaultWidth, setDefaultWidth] = (0, $cozmU.useState)((0, $7y9ez.getDefaultPanelWidth));
    const [panelWidth, setPanelWidth] = (0, $cozmU.useState)(initialWidth ?? defaultWidth);
    const [manuallyResized, setManuallyResized] = (0, $cozmU.useState)(false);
    const [panelOpen, setPanelOpen] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onPanelWidthChanged = (0, $cozmU.useCallback)((newPanelWidth, panelProduct, panelType, parentProduct)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: panelProduct,
                source: 'preview-panel',
                action: 'resize',
                actionSubject: 'resizer',
                actionSubjectId: 'previewPanelResizer',
                attributes: {
                    initialPanelWidth: panelWidth,
                    newPanelWidth: newPanelWidth,
                    newWidthSmaller: newPanelWidth < panelWidth,
                    parentProduct: parentProduct,
                    panelType: panelType,
                    windowWidth: window.innerWidth,
                    windowHeight: window.innerHeight
                }
            }
        }).fire();
        setPanelWidth(newPanelWidth);
        setManuallyResized(true);
    }, [
        createAnalyticsEvent,
        panelWidth
    ]);
    const onPanelOpened = (0, $cozmU.useCallback)((openWidth)=>{
        const width = openWidth ?? (manuallyResized ? panelWidth : defaultWidth);
        setPanelWidth(width);
        setPanelOpen(true);
    }, [
        defaultWidth,
        manuallyResized,
        panelWidth
    ]);
    const onPanelClosed = (0, $cozmU.useCallback)(()=>{
        setPanelOpen(false);
    }, []);
    // getDefaultPanelWidth does not dependencies related to this hook
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const windowResizeListener = (0, $cozmU.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
        if (!panelOpen) {
            setDefaultWidth((0, $7y9ez.getDefaultPanelWidth)());
            setManuallyResized(false);
        }
    }, 500), [
        panelOpen
    ]);
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bind)(window, {
            type: 'resize',
            listener: windowResizeListener
        });
        return ()=>{
            unbind();
        };
    }, [
        windowResizeListener
    ]);
    return {
        panelWidth: panelWidth,
        onPanelWidthChanged: onPanelWidthChanged,
        onPanelOpened: onPanelOpened,
        onPanelClosed: onPanelClosed
    };
};
module.exports["usePanelWidth"] = $4ad8ebf5df3a3b12$export$82b270f291af5a5;

});

parcelRegister("7y9ez", function(module, exports) {
const $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH = 400;
const $c1ed100d044a4357$var$PANEL_MAX_WIDTH = 1000;
const $c1ed100d044a4357$var$MINIMUM_WIDTH = 1800;
const $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO = 0.3;
const $c1ed100d044a4357$export$29ceecbfeef33bfc = ()=>{
    const windowWidth = window.innerWidth;
    let width = $c1ed100d044a4357$var$PANEL_DEFAULT_WIDTH;
    if (windowWidth >= $c1ed100d044a4357$var$MINIMUM_WIDTH) {
        const proposedPanelWidth = Math.round(windowWidth * $c1ed100d044a4357$var$PANEL_TO_WINDOW_WITH_RATIO);
        width = proposedPanelWidth < $c1ed100d044a4357$var$PANEL_MAX_WIDTH ? proposedPanelWidth : $c1ed100d044a4357$var$PANEL_MAX_WIDTH;
    }
    return width;
};
module.exports["getDefaultPanelWidth"] = $c1ed100d044a4357$export$29ceecbfeef33bfc;

});

parcelRegister("7ssWV", function(module, exports) {

var $99V2N = parcelRequire("99V2N");

const $2fea0aef81deca52$export$eb89e687f2b278d7 = (currPanel, nextPanel)=>{
    // if both panels have their types set, we will check if they match
    if (currPanel?.type && nextPanel?.type) return currPanel.type === nextPanel.type;
    // else check against both panels' ari values
    if (currPanel?.ari && nextPanel?.ari) try {
        const currAri = (0, $99V2N.AnyAri).parse(currPanel.ari);
        const nextAri = (0, $99V2N.AnyAri).parse(nextPanel.ari);
        // ex: `${'confluence'}-${'page'}`, `${'confluence'}-${'blogpost'}`, `${'jira'}-${'project'}`, etc.
        return `${currAri.resourceOwner}-${currAri.resourceType}` === `${nextAri.resourceOwner}-${nextAri.resourceType}`;
    } catch (error) {
        // If parsing fails, we assume the ARI values do not match.
        return false;
    }
    // If neither panel has a type or ari, we assume they do not match.
    return false;
};
module.exports["doPreviewPanelTypesMatch"] = $2fea0aef81deca52$export$eb89e687f2b278d7;

});

parcelRegister("5WTxQ", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $dinVW = parcelRequire("dinVW");


var $2oyXR = parcelRequire("2oyXR");


var $biqj4 = parcelRequire("biqj4");

const $e01be1a23d2a446d$var$styles = {
    wrapper: "_0jFU0VN91d _0KLXrulfZc"
};
const $e01be1a23d2a446d$export$9520f072db304aa0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, testId: testId } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== children || $[1] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
                testId: testId
            }, children);
            $[0] = children;
            $[1] = testId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== children || $[4] !== testId) {
        const panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $e01be1a23d2a446d$var$styles.wrapper,
            testId: testId
        }, children);
        t1 = (0, $iDrrr.fg)("a11y_40234_preview_panel_focus_on_open") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $biqj4.PanelFocusLock), {
            isFocusLockEnabled: false
        }, panel) : panel;
        $[3] = children;
        $[4] = testId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ({ children: children, testId: testId })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2oyXR.PanelContainer), {
        testId: testId
    }, children);
    const panel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $e01be1a23d2a446d$var$styles.wrapper,
        testId: testId
    }, children);
    return (0, $iDrrr.fg)('a11y_40234_preview_panel_focus_on_open') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $biqj4.PanelFocusLock), {
        isFocusLockEnabled: false
    }, panel) : panel;
};
module.exports["PreviewPanel"] = $e01be1a23d2a446d$export$9520f072db304aa0;

});

parcelRegister("2oyXR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $biqj4 = parcelRequire("biqj4");

const $6ccdb3d7b226a54f$var$styles = {
    wrapper: "_0jFU0VN91d _0KLXrulfZc _3iDTPbQ4SZ _0aFT5vbt8w _1mT5xdRAKS",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC"
}; /**
    * The PanelContainer component provides a standardized container for displaying content
    * in a side panel layout. It follows the design system patterns and integrates
    * with the navigation system for consistent styling and behavior.
    *
    * Compose it with a fixed `PanelHeader` / `PanelFooter` and a scrollable `PanelContent`
    * (wrapping `PanelSubheader` and `PanelBody`).
    *
    * For resizable panels, use the `PanelSplitter` from `@atlaskit/navigation-system/layout/panel-splitter`
    * alongside the `Panel` slot from `@atlaskit/navigation-system/layout/panel`.
    */ 
const $6ccdb3d7b226a54f$export$7c4d2b536147788a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelContainer(t0) {
    const $ = (0, $bDgLe.c)(8);
    const { children: children, testId: testId, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    let t2;
    if ($[0] !== children) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $6ccdb3d7b226a54f$var$styles.content,
            children: children
        });
        $[0] = children;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== t2 || $[3] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "section",
            testId: testId,
            xcss: $6ccdb3d7b226a54f$var$styles.wrapper,
            children: t2
        });
        $[2] = t2;
        $[3] = testId;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isFocusLockEnabled || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $biqj4.PanelFocusLock), {
            isFocusLockEnabled: isFocusLockEnabled,
            children: t3
        });
        $[5] = isFocusLockEnabled;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
} : function PanelContainer({ children: children, testId: testId, isFocusLockEnabled: isFocusLockEnabled = false }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $biqj4.PanelFocusLock), {
        isFocusLockEnabled: isFocusLockEnabled,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "section",
            testId: testId,
            xcss: $6ccdb3d7b226a54f$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $6ccdb3d7b226a54f$var$styles.content,
                children: children
            })
        })
    });
};
module.exports["PanelContainer"] = $6ccdb3d7b226a54f$export$7c4d2b536147788a;

});

parcelRegister("biqj4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $1enXm = parcelRequire("1enXm");


var $1hQ0e = parcelRequire("1hQ0e");

// box model so PanelContainer's own height/flex styles work exactly as if this wrapper
// were not there. This avoids breaking resize and full-height layouts.
const $2153848f433e7d96$var$contentsStyle = {
    display: 'contents'
};
const $2153848f433e7d96$var$containerStyles = null; /**
                               * Module-level count of currently-mounted PanelFocusLock instances.
                               *
                               * Used to suppress the return-focus restore when one panel is replaced by
                               * another (e.g. Jira admin sidebar swaps Sidebar A → Sidebar B by changing
                               * the Provider component, which unmounts/remounts PanelFocusLock). Without
                               * this guard, the unmounting panel's queued double-rAF restore would fire
                               * AFTER the new panel's autofocus, snapping focus back to the original
                               * trigger while a replacement panel is on screen.
                               *
                               * The counter is decremented synchronously on cleanup BEFORE the new
                               * instance's mount effect runs, then re-checked inside the deferred restore.
                               * If another instance has mounted by the time the double-rAF fires, the
                               * restore is skipped.
                               */ 
let $2153848f433e7d96$var$panelFocusLockMountCount = 0; /**
                                   * Module-level handoff for the "previously focused" element across an
                                   * unmount → mount swap.
                                   *
                                   * When one PanelFocusLock unmounts and is immediately replaced by another
                                   * because a button INSIDE the unmounting panel triggered the swap (e.g.
                                   * Sidebar A's footer "Add spaces" button opens Sidebar B), the replacement's
                                   * mount effect sees `document.activeElement === document.body` because the
                                   * previously-focused element lived inside the panel that just unmounted.
                                   * Without a handoff, the replacement would capture `body` as its "previously
                                   * focused" snapshot and on close would restore focus to nothing / blur.
                                   *
                                   * The unmounting instance writes its own previously-focused snapshot here,
                                   * and the next mounting instance reads + clears it. The handoff is used
                                   * ONLY when the replacement's `document.activeElement` is `body` (or null) —
                                   * meaning focus disappeared because it lived inside the unmounting panel.
                                   * If `document.activeElement` is a real element (e.g. the user clicked a
                                   * different page-level trigger to open this panel), that element wins
                                   * because it's a more accurate "where focus came from" signal than the
                                   * previous panel's snapshot. Cleared either by the next mount or by the
                                   * deferred restore when no replacement appears, so a stale value can't leak
                                   * across unrelated open cycles.
                                   */ 
let $2153848f433e7d96$var$pendingPreviouslyFocused = null; /**
                                                          * Selector for all focusable elements inside a container, in LTR tab order.
                                                          */ 
const $2153848f433e7d96$var$FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    'details > summary',
    'audio[controls]',
    'video[controls]'
].join(', ');
const $2153848f433e7d96$export$85d112ac7df5c04f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelFocusLock(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { children: children, isFocusLockEnabled: t1 } = t0;
    const isFocusLockEnabled = t1 === undefined ? false : t1;
    const containerRef = (0, $cozmU.useRef)(null);
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const doc = (0, $1hQ0e.getDocument)();
            $2153848f433e7d96$var$pendingPreviouslyFocused = null;
            const activeElement = doc?.activeElement ?? null;
            const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
            const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
            const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
            const handoffIsAttached = !!$2153848f433e7d96$var$pendingPreviouslyFocused && !!doc?.body?.contains($2153848f433e7d96$var$pendingPreviouslyFocused);
            previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? $2153848f433e7d96$var$pendingPreviouslyFocused : activeElement;
            $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount + 1;
            return ()=>{
                $2153848f433e7d96$var$panelFocusLockMountCount = $2153848f433e7d96$var$panelFocusLockMountCount - 1;
                $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current;
                const toFocus = previouslyFocusedRef.current;
                setTimeout(()=>{
                    setTimeout(()=>{
                        if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                        toFocus?.focus();
                    }, 0);
                }, 0);
            };
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[2] !== isFocusLockEnabled) {
        t4 = ()=>{
            if (isFocusLockEnabled) return;
            const container = containerRef.current;
            if (!container) return;
            const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
            if (firstFocusable) firstFocusable.focus({
                preventScroll: true
            });
        };
        t5 = [
            isFocusLockEnabled
        ];
        $[2] = isFocusLockEnabled;
        $[3] = t4;
        $[4] = t5;
    } else {
        t4 = $[3];
        t5 = $[4];
    }
    (0, $cozmU.useEffect)(t4, t5);
    if (isFocusLockEnabled) {
        let t6;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t6 = {
                style: $2153848f433e7d96$var$contentsStyle
            };
            $[5] = t6;
        } else t6 = $[5];
        let t7;
        if ($[6] !== children) {
            t7 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
                autoFocus: true,
                returnFocus: false,
                lockProps: t6,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
                    ref: containerRef,
                    style: $2153848f433e7d96$var$contentsStyle,
                    children: children
                })
            });
            $[6] = children;
            $[7] = t7;
        } else t7 = $[7];
        return t7;
    }
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_0jFU0VN91d"
        ]);
        $[8] = t6;
    } else t6 = $[8];
    let t7;
    if ($[9] !== children || $[10] !== t6) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: containerRef,
            className: t6,
            children: children
        });
        $[9] = children;
        $[10] = t6;
        $[11] = t7;
    } else t7 = $[11];
    return t7;
} : function PanelFocusLock({ children: children, isFocusLockEnabled: isFocusLockEnabled = false }) {
    const containerRef = (0, $cozmU.useRef)(null); // Capture the element that was focused before the panel opened so we can
    // restore focus to it when the panel closes — regardless of which close
    // path is taken (X button, footer Close, programmatic close, etc.).
    const previouslyFocusedRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        // Determine the element focus should return to when this panel closes.
        //
        // Default: use the element that was focused at the moment we mount —
        // this is the natural "page trigger" the user just clicked.
        //
        // Edge case (handoff): when one panel unmounts and is immediately
        // replaced by another because a button INSIDE the previous panel
        // triggered the swap (e.g. Sidebar A's footer "Add spaces" button
        // opens Sidebar B), focus has nowhere to go: the trigger button just
        // unmounted with the previous panel, so `document.activeElement`
        // falls back to `body`. In that specific case we adopt the previous
        // panel's snapshot via the module-level handoff slot — it's typically
        // the original page-level trigger that opened the chain.
        //
        // Edge case (StrictMode): in development, React double-invokes
        // effects (setup → cleanup → setup). The second setup runs AFTER
        // Effect 2 below has already moved focus to our own first focusable,
        // so `document.activeElement` is inside our own container — but the
        // DOM was never actually unmounted, so the focused element is still
        // attached. We treat this case the same as body: the user never
        // "came from" our own input, so we should fall back to the handoff
        // (which was just set by Pass 1's cleanup). Without this guard,
        // `previouslyFocused` would be set to our own first focusable, and
        // on close `focus()` would target an element that is by then detached.
        //
        // Always clear the handoff slot regardless of whether we used it, so
        // a stale value can't leak forward into an unrelated future mount.
        const doc = (0, $1hQ0e.getDocument)();
        const handoff = $2153848f433e7d96$var$pendingPreviouslyFocused;
        $2153848f433e7d96$var$pendingPreviouslyFocused = null;
        const activeElement = doc?.activeElement ?? null;
        const activeIsBodyOrNull = !activeElement || activeElement === doc?.body;
        const activeIsInsideOwnContainer = !!activeElement && !!containerRef.current?.contains(activeElement);
        const shouldUseHandoff = activeIsBodyOrNull || activeIsInsideOwnContainer;
        const handoffIsAttached = !!handoff && !!doc?.body?.contains(handoff);
        previouslyFocusedRef.current = shouldUseHandoff && handoffIsAttached ? handoff : activeElement;
        $2153848f433e7d96$var$panelFocusLockMountCount += 1;
        return ()=>{
            $2153848f433e7d96$var$panelFocusLockMountCount -= 1; // Hand our snapshot off in case a replacement instance is about to
            // mount in the same commit — it will consume this and use it as its
            // own return-focus target, preserving the original trigger across the
            // swap. The slot is cleared either by the next mount or by the
            // deferred restore below if no replacement appears.
            $2153848f433e7d96$var$pendingPreviouslyFocused = previouslyFocusedRef.current; // Capture the target locally so it survives even if something else
            // mutates the ref between now and when the deferred callback fires.
            const toFocus = previouslyFocusedRef.current; // Restore focus on unmount (panel close). Two chained `setTimeout(0)`
            // ensure this fires after react-focus-lock's own deactivation logic
            // when the lock is active, and after React has finished applying any
            // commit that mounted a replacement panel.
            //
            // We use setTimeout rather than requestAnimationFrame here because
            // the latter is unreliable under jsdom + the React 18 concurrent
            // scheduler in unit tests: rAF callbacks scheduled inside a passive
            // effect cleanup don't always flush even when `jest.runAllTimers`
            // is called inside an `act` block (the scheduler uses MessageChannel,
            // which fake timers don't drive). setTimeout(0) flushes reliably with
            // both fake and real timers.
            setTimeout(()=>{
                setTimeout(()=>{
                    // Skip restore if another PanelFocusLock instance has mounted in
                    // the meantime — e.g. a sidebar swap where the consumer unmounts
                    // the current panel and mounts a replacement. The new instance's
                    // autofocus already moved focus into the replacement; restoring
                    // here would yank focus back to this panel's previously-focused
                    // element (typically the original page trigger) and visibly steal
                    // focus away from the replacement panel.
                    if ($2153848f433e7d96$var$panelFocusLockMountCount > 0) return;
                     // We're the last one out — clear the handoff so a future,
                    // unrelated panel open doesn't inherit a stale snapshot.
                    $2153848f433e7d96$var$pendingPreviouslyFocused = null;
                    toFocus?.focus();
                }, 0);
            }, 0);
        };
    }, []);
    // When the lock is NOT enabled, handle auto-focus ourselves — do NOT use
    // react-focus-lock even in disabled mode as it causes layout recalculations
    // that causes animation jank when the panel is inside a CSS transform animation
    // (e.g. SlideIn from @atlaskit/motion).
    (0, $cozmU.useEffect)(()=>{
        if (isFocusLockEnabled) return;
        const container = containerRef.current;
        if (!container) return;
         // Focus synchronously in useEffect (post-paint) with preventScroll to avoid
        // the browser calling scrollIntoView on a mid-animation element.
        const firstFocusable = container.querySelector($2153848f433e7d96$var$FOCUSABLE_SELECTOR);
        if (firstFocusable) firstFocusable.focus({
            preventScroll: true
        });
    }, [
        isFocusLockEnabled
    ]); // When the lock IS enabled, use react-focus-lock for both autoFocus and the trap.
    if (isFocusLockEnabled) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1enXm.default), {
        autoFocus: true,
        returnFocus: false,
        lockProps: {
            style: $2153848f433e7d96$var$contentsStyle
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            ref: containerRef,
            style: $2153848f433e7d96$var$contentsStyle,
            children: children
        })
    });
     // Default (no lock): plain wrapper div, auto-focus handled by useEffect above.
    // We deliberately avoid react-focus-lock here to prevent animation jank.
    // height: 100% ensures PanelContainer's own height: 100% resolves correctly.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        ref: containerRef,
        className: (0, $hekY6.default)([
            "_0jFU0VN91d"
        ]),
        children: children
    });
};
module.exports["PanelFocusLock"] = $2153848f433e7d96$export$85d112ac7df5c04f;

});

parcelRegister("kMhHg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $aio9r = parcelRequire("aio9r");


var $2Emkv = parcelRequire("2Emkv");

const $f9d4da2be7611286$var$panelSystemStyles = {
    fillParent: "_0jFU0VN91d _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $f9d4da2be7611286$export$cda5e69749e7aeee = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles } = t0;
    const bodyRef = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== analyticsAttributes || $[1] !== analyticsClient || $[2] !== panelType || $[3] !== parentProduct) {
        t1 = ()=>{
            if (analyticsClient) {
                analyticsClient.sendTrackEvent({
                    action: "viewed",
                    actionSubject: "preview-panel",
                    actionSubjectId: "preview-panel-view",
                    source: "preview-panel",
                    attributes: {
                        parentProduct: parentProduct,
                        panelType: panelType,
                        ...(0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                            fireExperimentExposure: false
                        }) ? analyticsAttributes : {}
                    }
                });
                analyticsClient?.startUIViewedEvent();
            }
        };
        t2 = [
            analyticsClient,
            parentProduct,
            panelType,
            analyticsAttributes
        ];
        $[0] = analyticsAttributes;
        $[1] = analyticsClient;
        $[2] = panelType;
        $[3] = parentProduct;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    if ($[6] !== children || $[7] !== consumerStyles) {
        t3 = (0, $iDrrr.fg)("ads-panel-system-gpp") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
            ref: bodyRef
        }, children);
        $[6] = children;
        $[7] = consumerStyles;
        $[8] = t3;
    } else t3 = $[8];
    const panelBodyContent = t3;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t4;
        if ($[9] !== panelBodyContent) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
                spacing: "none"
            }, panelBodyContent);
            $[9] = panelBodyContent;
            $[10] = t4;
        } else t4 = $[10];
        const wrappedBody = t4;
        let t5;
        if ($[11] !== analyticsAttributes || $[12] !== analyticsClient || $[13] !== panelType || $[14] !== parentProduct || $[15] !== wrappedBody) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
                containerRef: bodyRef,
                analyticsClient: analyticsClient,
                parentProduct: parentProduct,
                panelType: panelType,
                analyticsAttributes: analyticsAttributes
            }, wrappedBody);
            $[11] = analyticsAttributes;
            $[12] = analyticsClient;
            $[13] = panelType;
            $[14] = parentProduct;
            $[15] = wrappedBody;
            $[16] = t5;
        } else t5 = $[16];
        return t5;
    }
    let t4;
    if ($[17] !== analyticsAttributes || $[18] !== analyticsClient || $[19] !== panelBodyContent || $[20] !== panelType || $[21] !== parentProduct) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, panelBodyContent);
        $[17] = analyticsAttributes;
        $[18] = analyticsClient;
        $[19] = panelBodyContent;
        $[20] = panelType;
        $[21] = parentProduct;
        $[22] = t4;
    } else t4 = $[22];
    return t4;
} : ({ children: children, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes, styles: consumerStyles })=>{
    const bodyRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (analyticsClient) {
            analyticsClient.sendTrackEvent({
                action: 'viewed',
                actionSubject: 'preview-panel',
                actionSubjectId: 'preview-panel-view',
                source: 'preview-panel',
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    // Availability check only — this decides whether to decorate the preview-panel
                    // "viewed" track event with analyticsAttributes, NOT whether the user is
                    // accessing the Capacity planning experience. We therefore read the GA
                    // experiment WITHOUT firing a Statsig exposure (fireExperimentExposure: false);
                    // exposure is fired at the point the user actually opens the Capacity
                    // experience, keeping the GA experiment's population clean.
                    //
                    // The OR still short-circuits: when the legacy EAP gate is ON, the GA experiment is
                    // never read at all. EAP customers remain unconditionally enabled.
                    ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
            // https://developer.atlassian.com/platform/analytics-pipeline/guides/deep-dive/cloud-mau/
            // Fires at most once per hour, per product.
            // Requires tenantInfo and userInfo to be set
            analyticsClient?.startUIViewedEvent();
        }
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    // ignoring the rule as we have so many consumers of this that we need to be able to pass in styles
    /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ const panelBodyContent = (0, $iDrrr.fg)('ads-panel-system-gpp') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($f9d4da2be7611286$var$panelSystemStyles.fillParent, !!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)(!!consumerStyles && consumerStyles),
        ref: bodyRef
    }, children); /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ 
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        const wrappedBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aio9r.PanelBody), {
            spacing: "none"
        }, panelBodyContent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
            containerRef: bodyRef,
            analyticsClient: analyticsClient,
            parentProduct: parentProduct,
            panelType: panelType,
            analyticsAttributes: analyticsAttributes
        }, wrappedBody);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Emkv.PreviewPanelSniffer), {
        containerRef: bodyRef,
        analyticsClient: analyticsClient,
        parentProduct: parentProduct,
        panelType: panelType,
        analyticsAttributes: analyticsAttributes
    }, panelBodyContent);
};
module.exports["PreviewPanelBody"] = $f9d4da2be7611286$export$cda5e69749e7aeee;

});

parcelRegister("aio9r", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");

const $d35068f09c7abc33$var$styles = {
    body: "_2O5Vij7dHp _3zvHkHdC7N _1mT5xdRAKS",
    defaultSpacing: "_4c065UPgdg _0LQT5ENHnM _03SyCPNHnM"
}; /**
    * The PanelBody component provides the main content area for panels
    * with consistent styling and scroll behavior.
    */ 
const $d35068f09c7abc33$export$3ac6fba5a6f84a87 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelBody(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { children: children, spacing: t1, testId: testId } = t0;
    const spacing = t1 === undefined ? "default" : t1;
    const t2 = spacing === "default" && $d35068f09c7abc33$var$styles.defaultSpacing;
    let t3;
    if ($[0] !== t2) {
        t3 = (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, t2);
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== children || $[3] !== t3 || $[4] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            xcss: t3,
            children: children
        });
        $[2] = children;
        $[3] = t3;
        $[4] = testId;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : function PanelBody({ children: children, spacing: spacing = 'default', testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        xcss: (0, $w6R6I.cx)($d35068f09c7abc33$var$styles.body, spacing === 'default' && $d35068f09c7abc33$var$styles.defaultSpacing),
        children: children
    });
};
module.exports["PanelBody"] = $d35068f09c7abc33$export$3ac6fba5a6f84a87;

});

parcelRegister("2Emkv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $75ef0261b167901c$export$93a96f69a5c679de = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes } = t0;
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    let t1;
    if ($[0] !== containerRef) {
        t1 = (event, contentSizePayload)=>{
            if (contentSizePayload.type !== "contentSize" || typeof contentSizePayload.width !== "number" || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== "number" || contentSizePayload.height <= 0) return false;
            const panelIframe = containerRef.current?.querySelector("iframe");
            const panelIframeWindow = panelIframe?.contentWindow;
            if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
            if (event.origin && event.origin !== "null" && panelIframe?.src) try {
                const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
                if (event.origin !== iframeOrigin) return false;
            } catch  {
                return false;
            }
            return true;
        };
        $[0] = containerRef;
        $[1] = t1;
    } else t1 = $[1];
    const isValidContentSizeMessage = t1;
    let t2;
    if ($[2] !== analyticsAttributes || $[3] !== analyticsClient || $[4] !== panelType || $[5] !== parentProduct) {
        t2 = (t3)=>{
            const { clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth } = t3;
            if (!analyticsClient || hasSentOverflowEventRef.current) return;
            hasSentOverflowEventRef.current = true;
            const overflowPx = typeof clientWidth === "number" && typeof scrollWidth === "number" ? Math.max(scrollWidth - clientWidth, 0) : undefined;
            analyticsClient.sendOperationalEvent({
                action: "detected",
                actionSubject: "layoutOverflow",
                actionSubjectId: "preview-panel-horizontal-overflow",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType,
                    detectionMethod: detectionMethod,
                    clientWidth: clientWidth,
                    scrollWidth: scrollWidth,
                    overflowPx: overflowPx,
                    ...(0, $iDrrr.fg)("add_capacity_tab_to_the_board_horizontal_nav") || (0, $cXtTj.default).getExperimentValue("individual_capacity_planning_ga", "isEnabled", false, {
                        fireExperimentExposure: false
                    }) ? analyticsAttributes : {}
                }
            });
        };
        $[2] = analyticsAttributes;
        $[3] = analyticsClient;
        $[4] = panelType;
        $[5] = parentProduct;
        $[6] = t2;
    } else t2 = $[6];
    const sendOverflowEvent = t2;
    let t3;
    let t4;
    if ($[7] !== containerRef || $[8] !== sendOverflowEvent) {
        t3 = ()=>{
            const bodyElement = containerRef.current;
            if (!bodyElement || typeof ResizeObserver === "undefined") return;
            const detectBodyOverflow = ()=>{
                const clientWidth_0 = bodyElement.clientWidth;
                const scrollWidth_0 = bodyElement.scrollWidth;
                if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                    detectionMethod: "body-observer",
                    clientWidth: clientWidth_0,
                    scrollWidth: scrollWidth_0
                });
            };
            detectBodyOverflow();
            const observer = new ResizeObserver(detectBodyOverflow);
            observer.observe(bodyElement);
            return ()=>{
                observer.disconnect();
            };
        };
        t4 = [
            containerRef,
            sendOverflowEvent
        ];
        $[7] = containerRef;
        $[8] = sendOverflowEvent;
        $[9] = t3;
        $[10] = t4;
    } else {
        t3 = $[9];
        t4 = $[10];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    let t6;
    if ($[11] !== containerRef || $[12] !== isValidContentSizeMessage || $[13] !== sendOverflowEvent) {
        t5 = ()=>{
            const handleMessage = (event_0)=>{
                const contentSizePayload_0 = event_0.data;
                if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
                const panelIframe_0 = containerRef.current?.querySelector("iframe");
                const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
                const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
                if (typeof clientWidth_1 !== "number" || contentSizePayload_0.width <= clientWidth_1) return;
                sendOverflowEvent({
                    detectionMethod: "iframe-content-size-message",
                    clientWidth: clientWidth_1,
                    scrollWidth: contentSizePayload_0.width
                });
            };
            return (0, $cbY7C.bind)(window, {
                type: "message",
                listener: handleMessage
            });
        };
        t6 = [
            containerRef,
            isValidContentSizeMessage,
            sendOverflowEvent
        ];
        $[11] = containerRef;
        $[12] = isValidContentSizeMessage;
        $[13] = sendOverflowEvent;
        $[14] = t5;
        $[15] = t6;
    } else {
        t5 = $[14];
        t6 = $[15];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[16] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[16] = children;
        $[17] = t7;
    } else t7 = $[17];
    return t7;
} : ({ children: children, containerRef: containerRef, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, analyticsAttributes: analyticsAttributes })=>{
    const hasSentOverflowEventRef = (0, $cozmU.useRef)(false);
    const isValidContentSizeMessage = (0, $cozmU.useCallback)((event, contentSizePayload)=>{
        if (contentSizePayload.type !== 'contentSize' || typeof contentSizePayload.width !== 'number' || contentSizePayload.width <= 0 || typeof contentSizePayload.height !== 'number' || contentSizePayload.height <= 0) return false;
        const panelIframe = containerRef.current?.querySelector('iframe');
        const panelIframeWindow = panelIframe?.contentWindow;
        if (!panelIframeWindow || event.source !== panelIframeWindow) return false;
        // If both origins are known, ensure the message comes from the iframe's origin.
        if (event.origin && event.origin !== 'null' && panelIframe?.src) try {
            const iframeOrigin = new URL(panelIframe.src, window.location.href).origin;
            if (event.origin !== iframeOrigin) return false;
        } catch  {
            return false;
        }
        return true;
    }, [
        containerRef
    ]);
    const sendOverflowEvent = (0, $cozmU.useCallback)(({ clientWidth: clientWidth, detectionMethod: detectionMethod, scrollWidth: scrollWidth })=>{
        if (!analyticsClient || hasSentOverflowEventRef.current) return;
        hasSentOverflowEventRef.current = true;
        const overflowPx = typeof clientWidth === 'number' && typeof scrollWidth === 'number' ? Math.max(scrollWidth - clientWidth, 0) : undefined;
        analyticsClient.sendOperationalEvent({
            action: 'detected',
            actionSubject: 'layoutOverflow',
            actionSubjectId: 'preview-panel-horizontal-overflow',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType,
                detectionMethod: detectionMethod,
                clientWidth: clientWidth,
                scrollWidth: scrollWidth,
                overflowPx: overflowPx,
                // Availability check only — this decides whether to decorate the overflow
                // operational event with analyticsAttributes, NOT whether the user is
                // accessing the Capacity planning experience. We therefore read the GA
                // experiment WITHOUT firing a Statsig exposure
                // (fireExperimentExposure: false); exposure is fired at the point the user
                // actually opens the Capacity experience, keeping the GA experiment's
                // population clean.
                //
                // The OR still short-circuits: when the legacy EAP gate is ON the experiment
                // is never read at all. EAP customers remain unconditionally enabled.
                ...(0, $iDrrr.fg)('add_capacity_tab_to_the_board_horizontal_nav') || (0, $cXtTj.default).getExperimentValue('individual_capacity_planning_ga', 'isEnabled', false, {
                    fireExperimentExposure: false
                }) ? analyticsAttributes : {}
            }
        });
    }, [
        analyticsClient,
        parentProduct,
        panelType,
        analyticsAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        const bodyElement = containerRef.current;
        if (!bodyElement || typeof ResizeObserver === 'undefined') return;
        const detectBodyOverflow = ()=>{
            const clientWidth_0 = bodyElement.clientWidth;
            const scrollWidth_0 = bodyElement.scrollWidth;
            if (scrollWidth_0 > clientWidth_0) sendOverflowEvent({
                detectionMethod: 'body-observer',
                clientWidth: clientWidth_0,
                scrollWidth: scrollWidth_0
            });
        };
        detectBodyOverflow();
        const observer = new ResizeObserver(detectBodyOverflow);
        observer.observe(bodyElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        sendOverflowEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        const handleMessage = (event_0)=>{
            const contentSizePayload_0 = event_0.data;
            if (!isValidContentSizeMessage(event_0, contentSizePayload_0)) return;
            const panelIframe_0 = containerRef.current?.querySelector('iframe');
            const iframeClientWidth = panelIframe_0?.clientWidth ?? 0;
            const clientWidth_1 = iframeClientWidth > 0 ? iframeClientWidth : containerRef.current?.clientWidth;
            if (typeof clientWidth_1 !== 'number' || contentSizePayload_0.width <= clientWidth_1) return;
            sendOverflowEvent({
                detectionMethod: 'iframe-content-size-message',
                clientWidth: clientWidth_1,
                scrollWidth: contentSizePayload_0.width
            });
        };
        return (0, $cbY7C.bind)(window, {
            type: 'message',
            listener: handleMessage
        });
    }, [
        containerRef,
        isValidContentSizeMessage,
        sendOverflowEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
module.exports["PreviewPanelSniffer"] = $75ef0261b167901c$export$93a96f69a5c679de;

});

parcelRegister("fE1YT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $kdlgT = parcelRequire("kdlgT");


var $l3wuH = parcelRequire("l3wuH");


var $V3JOP = parcelRequire("V3JOP");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");


var $7ZpVx = parcelRequire("7ZpVx");


var $i68yG = parcelRequire("i68yG");


var $7ZxlY = parcelRequire("7ZxlY");


var $1jpZo = parcelRequire("1jpZo");


var $Emr0i = parcelRequire("Emr0i");


var $7Yky3 = parcelRequire("7Yky3");

const $30b8761d1cee2886$export$e1ea1fbf111a14fe = (url, paramToRemove)=>{
    try {
        const urlObj = new URL(url);
        urlObj.searchParams.delete(paramToRemove);
        return urlObj.toString();
    } catch  {
        // If URL parsing fails, return the original URL
        return url;
    }
};
const $30b8761d1cee2886$var$styles = {
    header: "_3vBAKH9r67 _0LQT5ENHnM _03SyCPNHnM _46hvQm5zaO _0xmtko5zaO _2yjt2x6wH8 _4auqkJNvrM _0jFU0VmdCj",
    childWrapper: "_2O5Vij7dHp",
    titleRegion: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _37wbyuI7V3 _2O5Vij7dHp _4ouGXIdnbC"
};
const $30b8761d1cee2886$export$426d4171de44bac0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(73);
    const { children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions, spacing: spacing } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $iDrrr.fg)("platform_preview_panels_cross_app_interaction");
        $[0] = t1;
    } else t1 = $[0];
    const enableCrossMAUUsage = t1;
    const t2 = parentProduct ?? "unknown";
    let t3;
    if ($[1] !== t2) {
        t3 = {
            bridge: "preview-panels",
            product: t2
        };
        $[1] = t2;
        $[2] = t3;
    } else t3 = $[2];
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)(t3);
    let t4;
    if ($[3] !== analyticsClient || $[4] !== onClose || $[5] !== panelType || $[6] !== parentProduct) {
        t4 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-close",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onClose?.();
        };
        $[3] = analyticsClient;
        $[4] = onClose;
        $[5] = panelType;
        $[6] = parentProduct;
        $[7] = t4;
    } else t4 = $[7];
    const onPanelClose = t4;
    let t5;
    if ($[8] !== analyticsClient || $[9] !== buildUrlWithAnalyticsParams || $[10] !== onOpenInNewTab || $[11] !== panelType || $[12] !== parentProduct || $[13] !== url) {
        t5 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "preview-panel-open-in-new-window",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onOpenInNewTab?.();
            if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels")) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, "previewPanels"));
        };
        $[8] = analyticsClient;
        $[9] = buildUrlWithAnalyticsParams;
        $[10] = onOpenInNewTab;
        $[11] = panelType;
        $[12] = parentProduct;
        $[13] = url;
        $[14] = t5;
    } else t5 = $[14];
    const onOpenInNewWindow = t5;
    let t6;
    if ($[15] !== analyticsClient || $[16] !== onNavigateBack || $[17] !== panelType || $[18] !== parentProduct) {
        t6 = ()=>{
            analyticsClient?.sendTrackEvent({
                action: "clicked",
                actionSubject: "button",
                actionSubjectId: "preview-panel-navigate-back",
                source: "preview-panel",
                attributes: {
                    parentProduct: parentProduct,
                    panelType: panelType
                }
            });
            onNavigateBack?.();
        };
        $[15] = analyticsClient;
        $[16] = onNavigateBack;
        $[17] = panelType;
        $[18] = parentProduct;
        $[19] = t6;
    } else t6 = $[19];
    const onPanelNavigateBack = t6;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t7;
        if ($[20] !== formatMessage || $[21] !== onNavigateBack || $[22] !== onPanelNavigateBack || $[23] !== testId) {
            t7 = onNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
                label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
                onClick: onPanelNavigateBack,
                testId: testId && `${testId}.navigate-back-button`,
                appearance: "default"
            });
            $[20] = formatMessage;
            $[21] = onNavigateBack;
            $[22] = onPanelNavigateBack;
            $[23] = testId;
            $[24] = t7;
        } else t7 = $[24];
        let t8;
        if ($[25] !== children) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $30b8761d1cee2886$var$styles.titleRegion
            }, children);
            $[25] = children;
            $[26] = t8;
        } else t8 = $[26];
        let t9;
        if ($[27] !== formatMessage || $[28] !== onOpenInNewWindow || $[29] !== testId || $[30] !== url) {
            t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
                label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
                onClick: onOpenInNewWindow,
                testId: testId && `${testId}.open-in-new-window-button`,
                appearance: "subtle"
            });
            $[27] = formatMessage;
            $[28] = onOpenInNewWindow;
            $[29] = testId;
            $[30] = url;
            $[31] = t9;
        } else t9 = $[31];
        let t10;
        if ($[32] !== formatMessage || $[33] !== onClose || $[34] !== onPanelClose || $[35] !== testId) {
            t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
                onClick: onPanelClose,
                testId: testId && `${testId}.close-button`,
                label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
            });
            $[32] = formatMessage;
            $[33] = onClose;
            $[34] = onPanelClose;
            $[35] = testId;
            $[36] = t10;
        } else t10 = $[36];
        let t11;
        if ($[37] !== moreActions || $[38] !== t10 || $[39] !== t9) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, t9, moreActions, t10);
            $[37] = moreActions;
            $[38] = t10;
            $[39] = t9;
            $[40] = t11;
        } else t11 = $[40];
        let t12;
        if ($[41] !== t11 || $[42] !== t7 || $[43] !== t8 || $[44] !== testId) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
                testId: testId
            }, t7, t8, t11);
            $[41] = t11;
            $[42] = t7;
            $[43] = t8;
            $[44] = testId;
            $[45] = t12;
        } else t12 = $[45];
        return t12;
    }
    let t7;
    if ($[46] !== formatMessage || $[47] !== onNavigateBack || $[48] !== onPanelNavigateBack || $[49] !== testId) {
        t7 = onNavigateBack && (0, $iDrrr.fg)("jivtech-1920-back-navigation-gpp") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: $30b8761d1cee2886$var$_temp,
            label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
            onClick: onPanelNavigateBack,
            testId: testId && `${testId}.navigate-back-button`
        });
        $[46] = formatMessage;
        $[47] = onNavigateBack;
        $[48] = onPanelNavigateBack;
        $[49] = testId;
        $[50] = t7;
    } else t7 = $[50];
    let t8;
    if ($[51] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $30b8761d1cee2886$var$styles.childWrapper,
            spread: "space-between",
            alignBlock: "center",
            space: "space.100"
        }, children);
        $[51] = children;
        $[52] = t8;
    } else t8 = $[52];
    let t9;
    if ($[53] !== formatMessage || $[54] !== onOpenInNewWindow || $[55] !== testId || $[56] !== url) {
        t9 = url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
            label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
            onClick: onOpenInNewWindow,
            testId: testId && `${testId}.open-in-new-window-button`
        });
        $[53] = formatMessage;
        $[54] = onOpenInNewWindow;
        $[55] = testId;
        $[56] = url;
        $[57] = t9;
    } else t9 = $[57];
    let t10;
    if ($[58] !== formatMessage || $[59] !== onClose || $[60] !== onPanelClose || $[61] !== spacing || $[62] !== testId) {
        t10 = onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            ...spacing === "compact" ? {
                appearance: "subtle",
                spacing: spacing
            } : {},
            icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                    ...iconProps_0,
                    size: spacing === "compact" ? "medium" : "small"
                }),
            label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
            onClick: onPanelClose,
            testId: testId && `${testId}.close-button`,
            role: "button"
        });
        $[58] = formatMessage;
        $[59] = onClose;
        $[60] = onPanelClose;
        $[61] = spacing;
        $[62] = testId;
        $[63] = t10;
    } else t10 = $[63];
    let t11;
    if ($[64] !== moreActions || $[65] !== t10 || $[66] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
            gap: "space.100"
        }, t9, moreActions, t10);
        $[64] = moreActions;
        $[65] = t10;
        $[66] = t9;
        $[67] = t11;
    } else t11 = $[67];
    let t12;
    if ($[68] !== t11 || $[69] !== t7 || $[70] !== t8 || $[71] !== testId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            xcss: $30b8761d1cee2886$var$styles.header,
            testId: testId,
            alignBlock: "center",
            space: "space.100"
        }, t7, t8, t11);
        $[68] = t11;
        $[69] = t7;
        $[70] = t8;
        $[71] = testId;
        $[72] = t12;
    } else t12 = $[72];
    return t12;
} : ({ children: children, onClose: onClose, onOpenInNewTab: onOpenInNewTab, onNavigateBack: onNavigateBack, testId: testId, url: url, analyticsClient: analyticsClient, parentProduct: parentProduct, panelType: panelType, moreActions: moreActions, spacing: spacing })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const enableCrossMAUUsage = (0, $iDrrr.fg)('platform_preview_panels_cross_app_interaction');
    const buildUrlWithAnalyticsParams = (0, $aIlZA.default)({
        bridge: 'preview-panels',
        product: parentProduct ?? 'unknown'
    });
    const onPanelClose = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-close',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onClose?.();
    };
    const onOpenInNewWindow = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'preview-panel-open-in-new-window',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onOpenInNewTab?.();
        if (url) window.open(enableCrossMAUUsage ? buildUrlWithAnalyticsParams($30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels')) : $30b8761d1cee2886$export$e1ea1fbf111a14fe(url, 'previewPanels'));
    };
    const onPanelNavigateBack = ()=>{
        analyticsClient?.sendTrackEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'preview-panel-navigate-back',
            source: 'preview-panel',
            attributes: {
                parentProduct: parentProduct,
                panelType: panelType
            }
        });
        onNavigateBack?.();
    };
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1jpZo.PanelHeader), {
        testId: testId
    }, onNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`,
        appearance: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $30b8761d1cee2886$var$styles.titleRegion
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZxlY.PanelActionGroup), null, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`,
        appearance: "subtle"
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i68yG.PanelActionClose), {
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $30b8761d1cee2886$var$styles.header,
        testId: testId,
        alignBlock: "center",
        space: "space.100"
    }, onNavigateBack && (0, $iDrrr.fg)('jivtech-1920-back-navigation-gpp') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelNavigateBackLabel),
        onClick: onPanelNavigateBack,
        testId: testId && `${testId}.navigate-back-button`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        xcss: $30b8761d1cee2886$var$styles.childWrapper,
        spread: "space-between",
        alignBlock: "center",
        space: "space.100"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        gap: "space.100"
    }, url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Yky3.PreviewPanelNewTabLink), {
        label: formatMessage((0, $Emr0i.default).previewPanelOpenInNewWindowLabel),
        onClick: onOpenInNewWindow,
        testId: testId && `${testId}.open-in-new-window-button`
    }), moreActions, onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        ...spacing === 'compact' ? {
            appearance: 'subtle',
            spacing: spacing
        } : {},
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_0,
                size: spacing === 'compact' ? 'medium' : 'small'
            }),
        label: formatMessage((0, $Emr0i.default).previewPanelCloseButtonLabel),
        onClick: onPanelClose,
        testId: testId && `${testId}.close-button`,
        role: "button"
    })));
};
function $30b8761d1cee2886$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))), {
        ...iconProps,
        size: "small"
    });
}
module.exports["PreviewPanelHeader"] = $30b8761d1cee2886$export$426d4171de44bac0;

});

parcelRegister("7ZpVx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $7WEaj = parcelRequire("7WEaj");


var $7vK9E = parcelRequire("7vK9E");

const $2efd2cd3ca9e912b$export$2a18e3520151503 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(43);
    const { children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, "aria-label": ariaLabel, "aria-haspopup": ariaHaspopup, "aria-expanded": ariaExpanded, icon: icon, label: label, appearance: t1, spacing: t2 } = t0;
    const appearance = t1 === undefined ? "subtle" : t1;
    const spacing = t2 === undefined ? "default" : t2;
    if (icon && href) {
        const t3 = ref;
        const t4 = onClick;
        const t5 = label || ariaLabel;
        let t6;
        if ($[0] !== appearance || $[1] !== ariaExpanded || $[2] !== ariaHaspopup || $[3] !== href || $[4] !== icon || $[5] !== rel || $[6] !== spacing || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== target || $[11] !== testId) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7WEaj.default), {
                ref: t3,
                href: href,
                onClick: t4,
                testId: testId,
                target: target,
                rel: rel,
                icon: icon,
                label: t5,
                appearance: appearance,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                isTooltipDisabled: false,
                spacing: spacing
            });
            $[0] = appearance;
            $[1] = ariaExpanded;
            $[2] = ariaHaspopup;
            $[3] = href;
            $[4] = icon;
            $[5] = rel;
            $[6] = spacing;
            $[7] = t3;
            $[8] = t4;
            $[9] = t5;
            $[10] = target;
            $[11] = testId;
            $[12] = t6;
        } else t6 = $[12];
        return t6;
    }
    if (icon) {
        const t3 = ref;
        const t4 = onClick;
        const t5 = label || ariaLabel;
        let t6;
        if ($[13] !== appearance || $[14] !== ariaExpanded || $[15] !== ariaHaspopup || $[16] !== icon || $[17] !== spacing || $[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== testId) {
            t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ref: t3,
                onClick: t4,
                testId: testId,
                icon: icon,
                label: t5,
                appearance: appearance,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                isTooltipDisabled: false,
                spacing: spacing
            });
            $[13] = appearance;
            $[14] = ariaExpanded;
            $[15] = ariaHaspopup;
            $[16] = icon;
            $[17] = spacing;
            $[18] = t3;
            $[19] = t4;
            $[20] = t5;
            $[21] = testId;
            $[22] = t6;
        } else t6 = $[22];
        return t6;
    }
    if (href) {
        const t3 = ref;
        const t4 = onClick;
        let t5;
        if ($[23] !== ariaExpanded || $[24] !== ariaHaspopup || $[25] !== ariaLabel || $[26] !== children || $[27] !== href || $[28] !== rel || $[29] !== t3 || $[30] !== t4 || $[31] !== target || $[32] !== testId) {
            t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                ref: t3,
                href: href,
                onClick: t4,
                testId: testId,
                target: target,
                rel: rel,
                "aria-label": ariaLabel,
                "aria-haspopup": ariaHaspopup,
                "aria-expanded": ariaExpanded,
                children: children
            });
            $[23] = ariaExpanded;
            $[24] = ariaHaspopup;
            $[25] = ariaLabel;
            $[26] = children;
            $[27] = href;
            $[28] = rel;
            $[29] = t3;
            $[30] = t4;
            $[31] = target;
            $[32] = testId;
            $[33] = t5;
        } else t5 = $[33];
        return t5;
    }
    const t3 = ref;
    const t4 = onClick;
    let t5;
    if ($[34] !== appearance || $[35] !== ariaExpanded || $[36] !== ariaHaspopup || $[37] !== ariaLabel || $[38] !== children || $[39] !== t3 || $[40] !== t4 || $[41] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
            ref: t3,
            onClick: t4,
            testId: testId,
            "aria-label": ariaLabel,
            "aria-haspopup": ariaHaspopup,
            "aria-expanded": ariaExpanded,
            appearance: appearance,
            children: children
        });
        $[34] = appearance;
        $[35] = ariaExpanded;
        $[36] = ariaHaspopup;
        $[37] = ariaLabel;
        $[38] = children;
        $[39] = t3;
        $[40] = t4;
        $[41] = testId;
        $[42] = t5;
    } else t5 = $[42];
    return t5;
} : ({ children: children, onClick: onClick, href: href, testId: testId, target: target, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHaspopup, 'aria-expanded': ariaExpanded, icon: icon, label: label, appearance: appearance = 'subtle', spacing: spacing = 'default' }, ref)=>{
    if (icon && href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7WEaj.default), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (icon) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        icon: icon,
        label: label || ariaLabel,
        appearance: appearance,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        isTooltipDisabled: false,
        spacing: spacing
    });
    if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        ref: ref,
        href: href,
        onClick: onClick,
        testId: testId,
        target: target,
        rel: rel,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        children: children
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ad7Ou.default), {
        ref: ref,
        onClick: onClick,
        testId: testId,
        "aria-label": ariaLabel,
        "aria-haspopup": ariaHaspopup,
        "aria-expanded": ariaExpanded,
        appearance: appearance,
        children: children
    });
});
module.exports["PanelAction"] = $2efd2cd3ca9e912b$export$2a18e3520151503;

});

parcelRegister("i68yG", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $l3wuH = parcelRequire("l3wuH");


var $7ZpVx = parcelRequire("7ZpVx");

const $837042f62dde5900$export$75d0a5a5f71a1ab1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label } = t0;
    let t1;
    if ($[0] !== onBeforeClose || $[1] !== onClick) {
        t1 = async (event, analyticsEvent)=>{
            if (onBeforeClose) {
                const canClose = await onBeforeClose();
                if (!canClose) return;
            }
            if (onClick) onClick(event, analyticsEvent);
        };
        $[0] = onBeforeClose;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const handleClick = t1;
    const t2 = label || "Close panel";
    let t3;
    if ($[3] !== handleClick || $[4] !== ref || $[5] !== t2 || $[6] !== testId) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZpVx.PanelAction), {
            ref: ref,
            onClick: handleClick,
            testId: testId,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: t2,
            spacing: "compact",
            appearance: "subtle"
        });
        $[3] = handleClick;
        $[4] = ref;
        $[5] = t2;
        $[6] = testId;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
} : ({ onClick: onClick, onBeforeClose: onBeforeClose, testId: testId, label: label }, ref)=>{
    const handleClick = async (event, analyticsEvent)=>{
        if (onBeforeClose) {
            const canClose = await onBeforeClose();
            if (!canClose) return;
        }
        if (onClick) onClick(event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZpVx.PanelAction), {
        ref: ref,
        onClick: handleClick,
        testId: testId,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: label || 'Close panel',
        spacing: "compact",
        appearance: "subtle"
    });
});
module.exports["PanelActionClose"] = $837042f62dde5900$export$75d0a5a5f71a1ab1;

});

parcelRegister("7ZxlY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $2d2f9566579f7703$var$styles = {
    group: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT"
}; /**
    * The PanelActionGroup component provides a container for grouping
    * panel actions together with consistent spacing and layout.
    */ 
const $2d2f9566579f7703$export$9546bd4ca18522f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelActionGroup(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children || $[1] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            testId: testId,
            xcss: $2d2f9566579f7703$var$styles.group,
            children: children
        });
        $[0] = children;
        $[1] = testId;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : function PanelActionGroup({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        testId: testId,
        xcss: $2d2f9566579f7703$var$styles.group,
        children: children
    });
};
module.exports["PanelActionGroup"] = $2d2f9566579f7703$export$9546bd4ca18522f9;

});

parcelRegister("1jpZo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");

const $2747dc4177a5f32c$var$styles = {
    header: "_0jFU0V36Ow _3iDTPbQ4SZ _0hPCNLDIqT _0LQT5EkG2W _03SyCPkG2W _46hvQm5zaO _0xmtko5zaO",
    headerContent: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _39xV02N91d"
}; /**
    * The PanelHeader component provides a standardized header area for panels
    * containing the title, actions, and other header-specific content.
    * It automatically organizes content into left (back button + title) and right (actions) sections
    * using flexbox layout. Place PanelActionGroup as the last child to position it on the right.
    */ 
const $2747dc4177a5f32c$export$968713404ca1c9aa = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelHeader(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children, testId: testId } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $2747dc4177a5f32c$var$styles.headerContent,
            children: children
        });
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1 || $[3] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            as: "header",
            testId: testId,
            xcss: $2747dc4177a5f32c$var$styles.header,
            children: t1
        });
        $[2] = t1;
        $[3] = testId;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function PanelHeader({ children: children, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
        as: "header",
        testId: testId,
        xcss: $2747dc4177a5f32c$var$styles.header,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $4ez2K.Flex), {
            xcss: $2747dc4177a5f32c$var$styles.headerContent,
            children: children
        })
    });
};
module.exports["PanelHeader"] = $2747dc4177a5f32c$export$968713404ca1c9aa;

});

parcelRegister("Emr0i", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e1da37ec0a029195$var$_default_1 = (0, $kSwu1.defineMessages)({
    previewPanelCloseButtonLabel: {
        id: "navigation.preview-panel.preview-panel-header.close-button-label",
        defaultMessage: "Close"
    },
    previewPanelExpandActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-expand.expand-action-label",
        defaultMessage: "Expand"
    },
    previewPanelNewTabActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-new-tab.new-tab-action-label",
        defaultMessage: "Open in new tab"
    },
    previewPanelMoreDropdownActionLabel: {
        id: "navigation.preview-panel.preview-panel-action-variants.preview-panel-more-dropdown.more-dropdown-action-label",
        defaultMessage: "More"
    },
    previewPanelOpenInNewWindowLabel: {
        id: "navigation.preview-panel.preview-panel-header.open-in-new-window-label",
        defaultMessage: "Open in new window"
    },
    previewPanelNavigateBackLabel: {
        id: "navigation.preview-panel.preview-panel-header.navigate-back-label",
        defaultMessage: "Go back to previous panel"
    }
});
var $e1da37ec0a029195$export$2e2bcd8739ae039 = $e1da37ec0a029195$var$_default_1;
module.exports["default"] = $e1da37ec0a029195$export$2e2bcd8739ae039;

});

parcelRegister("7Yky3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $V3JOP = parcelRequire("V3JOP");


var $Emr0i = parcelRequire("Emr0i");


var $6GBgL = parcelRequire("6GBgL");

const $3d98d316d4b42e83$export$d05dda6f1d91eaad = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage || $[1] !== label) {
        t1 = label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel);
        $[0] = formatMessage;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== analyticsContext || $[4] !== href || $[5] !== onClick || $[6] !== t1 || $[7] !== testId) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
            label: t1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext
        });
        $[3] = analyticsContext;
        $[4] = href;
        $[5] = onClick;
        $[6] = t1;
        $[7] = testId;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ href: href, label: label, onClick: onClick, testId: testId, analyticsContext: analyticsContext })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GBgL.PreviewPanelAction), {
        label: label || formatMessage((0, $Emr0i.default).previewPanelNewTabActionLabel),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext
    });
};
module.exports["PreviewPanelNewTabLink"] = $3d98d316d4b42e83$export$d05dda6f1d91eaad;

});

parcelRegister("6GBgL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $7WEaj = parcelRequire("7WEaj");


var $iDrrr = parcelRequire("iDrrr");


var $7ZpVx = parcelRequire("7ZpVx");

const $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function PreviewPanelAction(t0, ref) {
    const $ = (0, $bDgLe.c)(22);
    const { icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        if (analyticsContext || href) {
            let t1;
            if ($[0] !== analyticsContext || $[1] !== href || $[2] !== icon || $[3] !== label || $[4] !== onClick || $[5] !== ref || $[6] !== testId) {
                t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    href: href,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    target: "_blank",
                    ref: ref,
                    role: "button"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                    icon: icon,
                    label: label,
                    onClick: onClick,
                    testId: testId,
                    analyticsContext: analyticsContext,
                    appearance: "subtle",
                    ref: ref,
                    role: "button"
                });
                $[0] = analyticsContext;
                $[1] = href;
                $[2] = icon;
                $[3] = label;
                $[4] = onClick;
                $[5] = ref;
                $[6] = testId;
                $[7] = t1;
            } else t1 = $[7];
            return t1;
        }
        let t1;
        if ($[8] !== icon || $[9] !== label || $[10] !== onClick || $[11] !== ref || $[12] !== testId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
                ref: ref,
                icon: icon,
                label: label,
                onClick: onClick,
                testId: testId,
                appearance: "subtle"
            });
            $[8] = icon;
            $[9] = label;
            $[10] = onClick;
            $[11] = ref;
            $[12] = testId;
            $[13] = t1;
        } else t1 = $[13];
        return t1;
    }
    let t1;
    if ($[14] !== analyticsContext || $[15] !== href || $[16] !== icon || $[17] !== label || $[18] !== onClick || $[19] !== ref || $[20] !== testId) {
        t1 = href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        $[14] = analyticsContext;
        $[15] = href;
        $[16] = icon;
        $[17] = label;
        $[18] = onClick;
        $[19] = ref;
        $[20] = testId;
        $[21] = t1;
    } else t1 = $[21];
    return t1;
} : function PreviewPanelAction({ icon: icon, label: label, onClick: onClick, href: href, testId: testId, analyticsContext: analyticsContext }, ref) {
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) {
        if (analyticsContext || href) return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            href: href,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            target: "_blank",
            ref: ref,
            role: "button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            analyticsContext: analyticsContext,
            appearance: "subtle",
            ref: ref,
            role: "button"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZpVx.PanelAction), {
            ref: ref,
            icon: icon,
            label: label,
            onClick: onClick,
            testId: testId,
            appearance: "subtle"
        });
    }
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7WEaj.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        href: href,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        target: "_blank",
        ref: ref,
        role: "button"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: icon,
        label: label,
        onClick: onClick,
        testId: testId,
        analyticsContext: analyticsContext,
        appearance: "subtle",
        ref: ref,
        role: "button"
    });
});
module.exports["PreviewPanelAction"] = $e48bc72cc4b3f1f2$export$a37cb5f447b2cf16;

});

parcelRegister("bRCqW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $aMRlV = parcelRequire("aMRlV");

const $33c23c71035fcd90$export$92a58681483f4529 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { title: title, icon: icon, color: color } = t0;
    if ((0, $iDrrr.fg)("ads-panel-system-gpp")) {
        let t1;
        if ($[0] !== icon || $[1] !== title) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
                icon: icon
            }, title);
            $[0] = icon;
            $[1] = title;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== color || $[4] !== title) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold",
            maxLines: 1,
            color: color
        }, title);
        $[3] = color;
        $[4] = title;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== icon || $[7] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, icon, t1);
        $[6] = icon;
        $[7] = t1;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : ({ title: title, icon: icon, color: color })=>{
    if ((0, $iDrrr.fg)('ads-panel-system-gpp')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aMRlV.PanelTitle), {
        icon: icon
    }, title);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "bold",
        maxLines: 1,
        color: color
    }, title));
};
module.exports["PreviewPanelTitle"] = $33c23c71035fcd90$export$92a58681483f4529;

});

parcelRegister("aMRlV", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $I7hWB = parcelRequire("I7hWB");


var $iMnC5 = parcelRequire("iMnC5");

const $4105ecb3e4516dff$var$styles = {
    title: "_3iDTPbQ4SZ _0hPCNLDIqT _2O5Vij7dHp",
    titleText: "_0LQT5E1Y8M",
    icon: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV029DVM _0jFU0V9DVM"
}; /**
    * The PanelTitle component provides a standardized title display for panels
    * with optional icon support and consistent typography.
    */ 
const $4105ecb3e4516dff$export$86de09faaa70680d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function PanelTitle(t0) {
    const $ = (0, $bDgLe.c)(9);
    const { children: children, icon: icon, testId: testId } = t0;
    let t1;
    if ($[0] !== icon) {
        t1 = icon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
            xcss: $4105ecb3e4516dff$var$styles.icon,
            children: icon
        });
        $[0] = icon;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $4105ecb3e4516dff$var$styles.titleText
        ]);
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                size: "small",
                as: "h2",
                children: children
            })
        });
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== t1 || $[6] !== t3 || $[7] !== testId) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
            testId: testId,
            xcss: $4105ecb3e4516dff$var$styles.title,
            children: [
                t1,
                t3
            ]
        });
        $[5] = t1;
        $[6] = t3;
        $[7] = testId;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : function PanelTitle({ children: children, icon: icon, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $iMnC5.Box), {
        testId: testId,
        xcss: $4105ecb3e4516dff$var$styles.title,
        children: [
            icon && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iMnC5.Box), {
                xcss: $4105ecb3e4516dff$var$styles.icon,
                children: icon
            }),
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $4105ecb3e4516dff$var$styles.titleText
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $I7hWB.default), {
                    size: "small",
                    as: "h2",
                    children: children
                })
            })
        ]
    });
};
module.exports["PanelTitle"] = $4105ecb3e4516dff$export$86de09faaa70680d;

});

parcelRegister("dWfVs", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $eFO72 = parcelRequire("eFO72");


var $l0P92 = parcelRequire("l0P92");


var $77Mp1 = parcelRequire("77Mp1");


var $4vTOw = parcelRequire("4vTOw");


var $12FeT = parcelRequire("12FeT");


var $kf8A1 = parcelRequire("kf8A1");


var $lPJNC = parcelRequire("lPJNC");


var $kAKjI = parcelRequire("kAKjI");


var $eC4ZY = parcelRequire("eC4ZY");


var $4Y1Z5 = parcelRequire("4Y1Z5");


var $4o0zT = parcelRequire("4o0zT");


var $4aRua = parcelRequire("4aRua");


var $8lhhf = parcelRequire("8lhhf");


var $7JHs4 = parcelRequire("7JHs4");


var $9DTaz = parcelRequire("9DTaz");


var $9OqBj = parcelRequire("9OqBj");


var $9MCKh = parcelRequire("9MCKh");

const $ad58f4ad7597918e$var$DEFAULT_CATEGORY = 'AI';
const $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH = 150;
const $ad58f4ad7597918e$var$PRODUCT_ATTRIBUTIONS = {
    confluence: {
        name: (0, $lPJNC.messages).previewAttributionConfluence,
        icon: (0, $l0P92.ConfluenceAttributionIcon)
    },
    jira: {
        name: (0, $lPJNC.messages).previewAttributionJira,
        icon: (0, $12FeT.JiraAttributionIcon)
    },
    jsm: {
        name: (0, $lPJNC.messages).previewAttributionJiraServiceManagement,
        icon: (0, $kf8A1.JiraServiceManagementAttributionIcon)
    },
    talent: {
        name: (0, $lPJNC.messages).previewAttributionTalent,
        icon: (0, $eC4ZY.TalentAttributionIcon)
    },
    studio: {
        name: (0, $lPJNC.messages).previewAttributionStudio,
        icon: (0, $kAKjI.StudioAttributionIcon)
    },
    assets: {
        name: (0, $lPJNC.messages).previewAttributionAssets,
        icon: (0, $eFO72.AssetsAttributionIcon)
    },
    focus: {
        name: (0, $lPJNC.messages).previewAttributionFocus,
        icon: (0, $4vTOw.FocusAttributionIcon)
    },
    trello: {
        name: (0, $lPJNC.messages).previewAttributionTrello,
        icon: (0, $4Y1Z5.TrelloAttributionIcon)
    },
    feedback: {
        name: (0, $lPJNC.messages).previewAttributionFeedback,
        icon: (0, $77Mp1.FeedbackAttributionIcon)
    }
};
// Atlassian skills whose product is not in PRODUCT_ATTRIBUTIONS, or that have no product, are
// attributed to Atlassian.
const $ad58f4ad7597918e$var$DEFAULT_ATTRIBUTION = {
    name: (0, $lPJNC.messages).previewAttributionAtlassian
};
// Custom skills are authored by users rather than by a product, so they have no attribution.
const $ad58f4ad7597918e$var$getSkillAttribution = (skill)=>{
    if ((0, $7JHs4.isCustomSkill)(skill.id)) return undefined;
    return skill.productKey && $ad58f4ad7597918e$var$PRODUCT_ATTRIBUTIONS[skill.productKey] || $ad58f4ad7597918e$var$DEFAULT_ATTRIBUTION;
};
const $ad58f4ad7597918e$var$DEFAULT_BETA_LOZENGE = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
    color: "color.text.subtle",
    size: "small"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
    defaultMessage: "Beta",
    id: "fabric.editor.quickInsert.skill.beta"
}));
/**
 * Truncate description to a maximum length.
 * Used to keep insert menu items readable when skill descriptions are long.
 */ function $ad58f4ad7597918e$var$truncateDescription(description) {
    if (description.length <= $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH) return description;
    return description.slice(0, $ad58f4ad7597918e$var$MAX_DESCRIPTION_LENGTH).trim() + "\u2026";
}
/**
 * Returns the skill-specific icon with its configured color.
 * Falls back to the default skill icon if no match is found.
 */ const $ad58f4ad7597918e$var$getLegacySkillIcon = (skill)=>{
    const iconName = skill.iconName;
    const loadIcon = iconName && (0, $9MCKh.skillIcon)[iconName] ? (0, $9MCKh.skillIcon)[iconName] : (0, $9MCKh.defaultIcon);
    const iconColor = (0, $9OqBj.getIconColor)(skill.color);
    return async ()=>{
        const { default: Icon } = await loadIcon();
        const IconComponent = Icon;
        const ColoredSkillIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
            const $ = (0, $bDgLe.c)(2);
            let t0;
            if ($[0] !== props) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                    ...props,
                    color: iconColor
                });
                $[0] = props;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        } : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                ...props,
                color: iconColor
            });
        return {
            default: ColoredSkillIcon
        };
    };
};
function $ad58f4ad7597918e$export$a01f1ff56cba4b1c(skills, options = {}) {
    const { onAction: onAction, categories: categories = [
        $ad58f4ad7597918e$var$DEFAULT_CATEGORY
    ], priority: priority, getLozenge: getLozenge, nodes: nodes, isHidden: isHidden } = options;
    const showSlashPreviews = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command');
    const quickInsertModules = skills.map((skill)=>{
        const keywords = [
            skill.slug,
            skill.product,
            skill.name,
            'skill',
            'skills'
        ].filter((k)=>typeof k === 'string' && k.length > 0);
        const description = (0, $9DTaz.resolveSkillDisplayDescription)(skill.helpText, skill.description);
        let preview;
        if (showSlashPreviews) {
            const attribution = skill.productKey ? $ad58f4ad7597918e$var$PRODUCT_ATTRIBUTIONS[skill.productKey] : undefined;
            preview = attribution ? {
                attribution: attribution
            } : skill.product ? {
                attribution: {
                    name: skill.product
                }
            } : {};
        }
        return {
            key: skill.slug,
            ...isHidden && {
                isHidden: ()=>isHidden(skill)
            },
            title: skill.name,
            description: showSlashPreviews ? description : $ad58f4ad7597918e$var$truncateDescription(description),
            keywords: keywords,
            categories: categories,
            ...priority !== undefined && {
                priority: priority
            },
            icon: $ad58f4ad7597918e$var$getLegacySkillIcon(skill),
            ...getLozenge && {
                lozenge: getLozenge(skill)
            },
            ...preview && {
                preview: preview
            },
            action: async ()=>onAction?.(skill)
        };
    });
    return {
        title: 'Rovo Skills',
        description: 'AI-powered skills from Rovo',
        type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
        key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
        icons: {
            '16': (0, $9MCKh.defaultIcon),
            '24': (0, $9MCKh.defaultIcon),
            '48': (0, $9MCKh.defaultIcon)
        },
        modules: {
            quickInsert: quickInsertModules,
            ...nodes && {
                nodes: nodes
            }
        }
    };
}
const $ad58f4ad7597918e$export$8a18dddc0824814c = (skill)=>{
    const iconName = skill.iconName;
    const loadIcon = iconName && (0, $9MCKh.skillIcon)[iconName] ? (0, $9MCKh.skillIcon)[iconName] : (0, $9MCKh.defaultIcon);
    const iconColor = (0, $9OqBj.getIconColor)(skill.color);
    const loadColoredIcon = async ()=>{
        const { default: Icon } = await loadIcon();
        const IconComponent = Icon;
        const ColoredSkillIcon = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
            const $ = (0, $bDgLe.c)(2);
            let t0;
            if ($[0] !== props) {
                t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                    ...props,
                    color: iconColor
                });
                $[0] = props;
                $[1] = t0;
            } else t0 = $[1];
            return t0;
        } : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(IconComponent, {
                ...props,
                color: iconColor
            });
        return {
            default: ColoredSkillIcon
        };
    };
    let coloredIconPromise;
    return ()=>coloredIconPromise ?? (coloredIconPromise = loadColoredIcon());
};
function $ad58f4ad7597918e$export$d76981760c7a9606(skills, options = {}) {
    const { onAction: onAction, categories: categories = [
        $ad58f4ad7597918e$var$DEFAULT_CATEGORY
    ], priority: priority, getLozenge: getLozenge, nodes: nodes, manifestTitle: manifestTitle = 'Rovo Skills', isHidden: isHidden } = options;
    const quickInsertModules = skills.map((skill)=>{
        const keywords = [
            skill.slug,
            skill.product,
            skill.name,
            'skill',
            'skills'
        ].filter((k)=>typeof k === 'string' && k.length > 0);
        const description = (0, $9DTaz.resolveSkillDisplayDescription)(skill.helpText, skill.description);
        const attribution = $ad58f4ad7597918e$var$getSkillAttribution(skill);
        const preview = attribution ? {
            attribution: attribution
        } : {};
        const isBeta = skill.tags?.some((tag)=>tag.toLowerCase() === 'beta') ?? false;
        const lozenge = getLozenge ? getLozenge(skill) : isBeta ? $ad58f4ad7597918e$var$DEFAULT_BETA_LOZENGE : undefined;
        return {
            key: skill.slug,
            ...isHidden && {
                isHidden: ()=>isHidden(skill)
            },
            title: skill.name,
            description: description,
            keywords: keywords,
            categories: categories,
            ...priority !== undefined && {
                priority: priority
            },
            icon: $ad58f4ad7597918e$export$8a18dddc0824814c(skill),
            ...lozenge != null && {
                lozenge: lozenge
            },
            preview: preview,
            // The inserted skill node stores the skill as its parameters.
            parameters: skill,
            action: async ()=>onAction?.(skill)
        };
    });
    return {
        title: manifestTitle,
        description: 'AI-powered skills from Rovo',
        type: (0, $8lhhf.ROVO_SKILL_EXTENSION_TYPE),
        key: (0, $8lhhf.ROVO_SKILL_EXTENSION_KEY),
        icons: {
            '16': (0, $9MCKh.defaultIcon),
            '24': (0, $9MCKh.defaultIcon),
            '48': (0, $9MCKh.defaultIcon)
        },
        modules: {
            quickInsert: quickInsertModules,
            ...nodes && {
                nodes: nodes
            }
        }
    };
}
module.exports["buildLegacySkillsManifest"] = $ad58f4ad7597918e$export$a01f1ff56cba4b1c;
module.exports["buildSkillsManifest"] = $ad58f4ad7597918e$export$d76981760c7a9606;

});

parcelRegister("eFO72", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $7a41c4a098b40cd5$export$eab7e91d6eae906d = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.assetsIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.assetsIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["AssetsAttributionIcon"] = $7a41c4a098b40cd5$export$eab7e91d6eae906d;

});

parcelRegister("77Mp1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $39d7754f75f501a2$export$eaefbf91173053e3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.feedbackIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.feedbackIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["FeedbackAttributionIcon"] = $39d7754f75f501a2$export$eaefbf91173053e3;

});

parcelRegister("4vTOw", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $51057c117d6b3cf0$export$bb16d24a5f324787 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.focusIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.focusIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["FocusAttributionIcon"] = $51057c117d6b3cf0$export$bb16d24a5f324787;

});

parcelRegister("kf8A1", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $ef9ef8e0b2966579$export$37a58834dc468642 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.jiraServiceManagementIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.jiraServiceManagementIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["JiraServiceManagementAttributionIcon"] = $ef9ef8e0b2966579$export$37a58834dc468642;

});

parcelRegister("kAKjI", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $5a71999f39a60520$export$50579c1ab700a1c7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.studioIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.studioIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["StudioAttributionIcon"] = $5a71999f39a60520$export$50579c1ab700a1c7;

});

parcelRegister("eC4ZY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $b8ceecf1eeb2f45c$export$b99e3c9c5f0fd3a9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.talentIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.talentIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["TalentAttributionIcon"] = $b8ceecf1eeb2f45c$export$b99e3c9c5f0fd3a9;

});

parcelRegister("4Y1Z5", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $kp580 = parcelRequire("kp580");

const $1305ea0307dfc20c$export$fb9cd815a9f94154 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("img", {
            src: (0, $kp580.trelloIcon),
            alt: "",
            width: 16,
            height: 16
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : ()=>/*#__PURE__*/ (0, $8aG6j.jsx)("img", {
        src: (0, $kp580.trelloIcon),
        alt: "",
        width: 16,
        height: 16
    });
module.exports["TrelloAttributionIcon"] = $1305ea0307dfc20c$export$fb9cd815a9f94154;

});

parcelRegister("lcdOS", function(module, exports) {
const $0106bf84dde07759$export$2e244b47ccb558c7 = 'com.atlassian.confluence.macro.core';
const $0106bf84dde07759$export$9db27a61eed15469 = 'user-profile-preview';
module.exports["PEOPLE_ENTITY_EXTENSION_TYPE"] = $0106bf84dde07759$export$2e244b47ccb558c7;
module.exports["PEOPLE_ENTITY_MANIFEST_KEY"] = $0106bf84dde07759$export$9db27a61eed15469;

});

parcelRegister("1KE0S", function(module, exports) {
// Confluence persists extension nodes through its core macro storage format.
const $91c5734600a10f8b$export$aac69e62a880a73a = 'com.atlassian.confluence.macro.core';
const $91c5734600a10f8b$export$1a7c2d24fdc7b414 = 'knowledge-card';
module.exports["KNOWLEDGE_CARD_EXTENSION_TYPE"] = $91c5734600a10f8b$export$aac69e62a880a73a;
module.exports["KNOWLEDGE_CARD_MANIFEST_KEY"] = $91c5734600a10f8b$export$1a7c2d24fdc7b414;

});

parcelRegister("fxbF1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8123c7d174e08dae4e5d4a014122c25>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4f2fba9f65c2ddf$var$_react = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("cozmU")));

var $b4f2fba9f65c2ddf$var$_iconNew = $b4f2fba9f65c2ddf$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $b4f2fba9f65c2ddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "History".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/history
 * Usage guidance:
 * Reserved for history and recent
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b4f2fba9f65c2ddf$var$HistoryIcon = (props)=>/*#__PURE__*/ $b4f2fba9f65c2ddf$var$_react.default.createElement($b4f2fba9f65c2ddf$var$_iconNew.default, Object.assign({
        name: "HistoryIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1.5 8A6.5 6.5 0 1 0 8 1.5a6.36 6.36 0 0 0-4.651 2.005l1.298.26a.75.75 0 0 1-.09 1.483l-3.25.25A.75.75 0 0 1 .5 4.75V1.5l.013-.137a.75.75 0 0 1 1.456-.079l.34 1.138A7.86 7.86 0 0 1 8 0a8 8 0 1 1-8 8zm7.25-4.25v4.389l2.219 1.775-.938 1.172-2.5-2A.75.75 0 0 1 7.25 8.5V3.75z"/>`
    }, props));
$b4f2fba9f65c2ddf$var$HistoryIcon.displayName = 'HistoryIcon';
var $b4f2fba9f65c2ddf$var$_default = module.exports.default = $b4f2fba9f65c2ddf$var$HistoryIcon;

});

parcelRegister("i8aB6", function(module, exports) {
/* eslint-disable perfectionist/sort-object-types */ 
var $cozmU = parcelRequire("cozmU");


var $34VCg = parcelRequire("34VCg");

const $89c606f0d1f4dfb4$export$fade2d05a6320d49 = ({ id: id, component: component, type: type, performanceType: performanceType })=>{
    const ufoExperience = (0, $cozmU.useRef)(new (0, $34VCg.UFOExperience)(id, {
        type: type,
        performanceType: performanceType,
        platform: {
            component: component
        }
    }));
    const start = (0, $cozmU.useCallback)((startTime)=>{
        return ufoExperience.current.start(startTime);
    }, []);
    const success = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.success(config);
    }, []);
    const mark = (0, $cozmU.useCallback)((name, timestamp)=>{
        ufoExperience.current.mark(name, timestamp);
    }, []);
    const addMetadata = (0, $cozmU.useCallback)((data)=>{
        ufoExperience.current.addMetadata(data);
    }, []);
    const markFMP = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markFMP(timestamp);
    }, []);
    const markInlineResponse = (0, $cozmU.useCallback)((timestamp)=>{
        ufoExperience.current.markInlineResponse(timestamp);
    }, []);
    const failure = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.failure(config);
    }, []);
    const abort = (0, $cozmU.useCallback)((config)=>{
        return ufoExperience.current.abort(config);
    }, []);
    return {
        start: start,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        addMetadata: addMetadata,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};
module.exports["useUFOExperience"] = $89c606f0d1f4dfb4$export$fade2d05a6320d49;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$9df55620e365effa = ()=>{
    const { isLoggedIn: isLoggedIn, hasConfluenceUser: hasConfluenceUser } = (0, $bQm3c.useSessionData)();
    return isLoggedIn && !hasConfluenceUser;
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useIsAuthenticatedWithoutConfluenceUser"] = $30f02aa82d7102bc$export$9df55620e365effa;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("hYoU4", function(module, exports) {

var $nStJY = parcelRequire("nStJY");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $cf3a2c4e252823d7$export$79b973328ab6a08a = {
    collabEditProvider: null,
    collabEditInitialized: false,
    hasInitialDraft: false,
    isDraftSyncPending: false,
    collabEditConnected: false
};
const $cf3a2c4e252823d7$export$e324594224ef24da = {
    setCollabEditProvider: (collabEditProvider)=>({ setState: setState })=>{
            setState({
                collabEditProvider: collabEditProvider
            });
        },
    setCollabEditInitialized: (collabEditInitialized)=>({ setState: setState })=>{
            setState({
                collabEditInitialized: collabEditInitialized
            });
        },
    setHasInitialDraft: (hasInitialDraft)=>({ setState: setState })=>{
            setState({
                hasInitialDraft: hasInitialDraft
            });
        },
    setIsDraftSyncPending: // PGXT-3849 Remove this if we update lodash to 5.0+ and use debounce.pending() instead
    (isDraftSyncPending)=>({ setState: setState })=>{
            setState({
                isDraftSyncPending: isDraftSyncPending
            });
        },
    setCollabEditConnected: (collabEditConnected)=>({ setState: setState })=>{
            setState({
                collabEditConnected: collabEditConnected
            });
        },
    resetNativeCollabState: ()=>({ setState: setState })=>{
            setState({
                collabEditProvider: null,
                collabEditInitialized: false,
                hasInitialDraft: false,
                isDraftSyncPending: false,
                collabEditConnected: false
            });
        }
};
const $cf3a2c4e252823d7$export$a3d4598f4626641c = (0, $8s9DV.createStore)({
    initialState: {
        ...$cf3a2c4e252823d7$export$79b973328ab6a08a
    },
    actions: $cf3a2c4e252823d7$export$e324594224ef24da,
    name: 'nativeCollabState'
});
const $cf3a2c4e252823d7$export$8af37259b4604092 = (0, $j8on0.createContainer)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    onInit: ()=>async ({ dispatch: dispatch }, { initialCollabState: initialCollabState })=>{
            initialCollabState?.collabEditProvider && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditProvider(initialCollabState?.collabEditProvider));
            initialCollabState?.collabEditInitialized && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditInitialized(initialCollabState?.collabEditInitialized));
            initialCollabState?.hasInitialDraft && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setHasInitialDraft(initialCollabState?.hasInitialDraft));
            initialCollabState?.isDraftSyncPending && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setIsDraftSyncPending(initialCollabState?.isDraftSyncPending));
            initialCollabState?.collabEditConnected && dispatch($cf3a2c4e252823d7$export$e324594224ef24da.setCollabEditConnected(initialCollabState?.collabEditConnected));
        }
});
const $cf3a2c4e252823d7$export$b01c6ac62a4aed2c = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditProvider', 'collabEditInitialized', 'hasInitialDraft')
});
const $cf3a2c4e252823d7$export$3f0287ea828df991 = (0, $kBr4q.createActionsHook)($cf3a2c4e252823d7$export$a3d4598f4626641c);
const $cf3a2c4e252823d7$export$31e00ebc52451b8e = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'isDraftSyncPending')
});
const $cf3a2c4e252823d7$export$4bfbf4dd405bc207 = (0, $kBr4q.createHook)($cf3a2c4e252823d7$export$a3d4598f4626641c, {
    selector: (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($nStJY)))(state, 'collabEditConnected')
});
module.exports["useNativeCollabState"] = $cf3a2c4e252823d7$export$b01c6ac62a4aed2c;
module.exports["useNativeCollabActions"] = $cf3a2c4e252823d7$export$3f0287ea828df991;
module.exports["useNativeCollabDraftSync"] = $cf3a2c4e252823d7$export$31e00ebc52451b8e;
module.exports["useNativeCollabConnected"] = $cf3a2c4e252823d7$export$4bfbf4dd405bc207;

});

parcelRegister("4tOXV", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $w6R6I = parcelRequire("w6R6I");


var $fZAJP = parcelRequire("fZAJP");

const $05ef07480c610d29$export$9ac100e40613ea10 = ()=>{
    let userAgent = '';
    if (window?.__SSR_USER_AGENT__) userAgent = window.__SSR_USER_AGENT__;
    else userAgent = window?.navigator?.userAgent ?? '';
    return userAgent.indexOf('Mac') > -1;
};
const $05ef07480c610d29$var$styles = {
    flexCenter: "_4c065UFQfX _3iDTPbQ4SZ _0hPCNLDIqT",
    base: "_0bjKvDKxmn _4c065UFQfX _2Y7lL42ADO _3iDTPbvbI6 _2XsHFMFQfX _0adFHsFQfX",
    contentBefore: "_2XsHFM1Y8M _0adFHsPgdg",
    darkBackground: "_0KLXrueZ10",
    lightBackground: "_0KLXrumhAQ"
};
const $05ef07480c610d29$var$i18n = (0, $kSwu1.defineMessages)({
    keyboardShortcutShift: {
        id: "shortcuts.shift",
        defaultMessage: "Shift"
    },
    keyboardShortcutCtrl: {
        id: "shortcuts.ctrl",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandWin: {
        id: "shortcuts.cmd.win",
        defaultMessage: "Ctrl"
    },
    keyboardShortcutCommandMac: {
        id: "shortcuts.cmd.mac",
        defaultMessage: "Cmd"
    },
    keyboardShortcutOptionMac: {
        id: "shortcuts.opt.mac",
        defaultMessage: "Opt"
    },
    keyboardShortcutOptionWin: {
        id: "shortcuts.opt.win",
        defaultMessage: "Alt"
    },
    keyboardShortcutPlus: {
        id: "shortcuts.plus",
        defaultMessage: "+"
    },
    keyboardShortcutMinus: {
        id: "shortcuts.minus",
        defaultMessage: "-"
    },
    keyboardShortcutEnter: {
        id: "shortcuts.enter",
        defaultMessage: "Enter"
    },
    keyboardShortcutMeta: {
        id: "shortcuts.meta",
        defaultMessage: "Meta"
    }
});
const $05ef07480c610d29$var$processKey = (key, formatMessage)=>{
    const mac = $05ef07480c610d29$export$9ac100e40613ea10();
    const lowerCaseKey = key.toLowerCase();
    switch(lowerCaseKey){
        case 'shift':
            return '\u21E7';
        // ⇧
        case 'cmd':
        case 'mod':
            return mac ? '\u2318' // ⌘
             : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCommandWin);
        case 'ctrl':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutCtrl);
        case 'opt':
        case 'option':
            return mac ? formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionMac) : formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutOptionWin);
        case 'enter':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutEnter);
        case 'meta':
            return formatMessage($05ef07480c610d29$var$i18n.keyboardShortcutMeta);
        case 'uparrow':
            return '\u2191';
        // ↑
        case 'downarrow':
            return '\u2193';
        // ↓
        case 'leftarrow':
            return '\u2190';
        // ←
        case 'rightarrow':
            return '\u2192';
        // →
        case 'plus':
            return '+';
        case 'minus':
            return '-';
        default:
            return key;
    }
};
const $05ef07480c610d29$var$getShortcutStrings = (accelerator, formatMessage)=>{
    const shortcutKeys = accelerator.includes(' ') ? accelerator.split(' ') : accelerator.split('+');
    return shortcutKeys.map((key)=>{
        const processedKey = $05ef07480c610d29$var$processKey(key, formatMessage);
        if (processedKey.length === 1) return processedKey.toUpperCase();
        else return processedKey;
    });
};
const $05ef07480c610d29$export$7571b974b8c6ca70 = (accelerator, formatMessage)=>{
    return $05ef07480c610d29$var$getShortcutStrings(accelerator, formatMessage).join(' ');
};
const $05ef07480c610d29$export$7005a48098466b5d = (t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { shortcut: shortcut, contentBefore: contentBefore, isEditorShortcut: isEditorShortcut, isTooltip: t1 } = t0;
    const isTooltip = t1 === undefined ? false : t1;
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const intl = (0, $kSwu1.useIntl)();
    let T0;
    let t2;
    let t3;
    let t4;
    let t5;
    if ($[0] !== areKeyboardShortcutsEnabled || $[1] !== contentBefore || $[2] !== intl.formatMessage || $[3] !== isEditorShortcut || $[4] !== isTooltip || $[5] !== shortcut) {
        const shortcutStrings = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        const shouldRenderShortcutSegment = areKeyboardShortcutsEnabled || isEditorShortcut;
        T0 = (0, $iMnC5.Box);
        t2 = "span";
        t3 = $05ef07480c610d29$var$styles.flexCenter;
        t4 = contentBefore;
        t5 = shouldRenderShortcutSegment && shortcutStrings.map((shortcutSegment, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: `${shortcutSegment}-${index}`,
                xcss: (0, $w6R6I.cx)($05ef07480c610d29$var$styles.base, Boolean(contentBefore) && $05ef07480c610d29$var$styles.contentBefore, isTooltip ? $05ef07480c610d29$var$styles.darkBackground : $05ef07480c610d29$var$styles.lightBackground)
            }, shortcutSegment));
        $[0] = areKeyboardShortcutsEnabled;
        $[1] = contentBefore;
        $[2] = intl.formatMessage;
        $[3] = isEditorShortcut;
        $[4] = isTooltip;
        $[5] = shortcut;
        $[6] = T0;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else {
        T0 = $[6];
        t2 = $[7];
        t3 = $[8];
        t4 = $[9];
        t5 = $[10];
    }
    let t6;
    if ($[11] !== T0 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            as: t2,
            xcss: t3
        }, t4, t5);
        $[11] = T0;
        $[12] = t2;
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
        $[16] = t6;
    } else t6 = $[16];
    return t6;
}; /**
    * Converts shortcut strings like "ctrl+[" to an array of strings like ["Ctrl", "["].
    *
    * This is used for mapping the shortcut constants in `confluence-shortcuts.ts` to the
    * format expected by the ADS Tooltip `shortcut` prop.
    *
    * It checks if keyboard shortcuts are enabled and returns undefined if they are not.
    *
    * @example
    * ```
    * const shortcut = useShortcutStrings({ shortcut: 'ctrl+[' });
    * <Tooltip content="My tooltip" shortcut={shortcut} />
    * ```
    */ 
const $05ef07480c610d29$export$e84ae736f9706c5d = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { shortcut: shortcut, isEditorShortcut: t1 } = t0;
    const isEditorShortcut = t1 === undefined ? false : t1;
    const intl = (0, $kSwu1.useIntl)();
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    if (!shortcut) return;
    let t2;
    if ($[0] !== intl.formatMessage || $[1] !== shortcut) {
        t2 = $05ef07480c610d29$var$getShortcutStrings(shortcut, intl.formatMessage);
        $[0] = intl.formatMessage;
        $[1] = shortcut;
        $[2] = t2;
    } else t2 = $[2];
    const shortcutStrings = t2;
    const shouldDisplayShortcut = areKeyboardShortcutsEnabled || isEditorShortcut;
    if (!shouldDisplayShortcut) return;
    return shortcutStrings;
};
module.exports["isMac"] = $05ef07480c610d29$export$9ac100e40613ea10;
module.exports["getShortcutString"] = $05ef07480c610d29$export$7571b974b8c6ca70;
module.exports["ShortcutVisualizer"] = $05ef07480c610d29$export$7005a48098466b5d;
module.exports["useShortcutStrings"] = $05ef07480c610d29$export$e84ae736f9706c5d;

});

parcelRegister("fZAJP", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3y1ko = parcelRequire("3y1ko");

let $640354b193201be7$var$inflightPromise = null;
const $640354b193201be7$var$updaters = new Set();
const $640354b193201be7$export$130f87a5d53e682d = ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { isLoggedIn: isLoggedIn, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const [enabled, setEnabled] = (0, $cozmU.useState)(window.__SHORTCUT_ENABLED__ ?? false);
    let t0;
    let t1;
    if ($[0] !== isLicensed || $[1] !== isLoggedIn) {
        t0 = ()=>{
            if (typeof window.__SHORTCUT_ENABLED__ !== "boolean") {
                if (!$640354b193201be7$var$inflightPromise) $640354b193201be7$var$inflightPromise = isLoggedIn && isLicensed ? (0, $3y1ko.fetchShortcutEnabledState)() : Promise.resolve(false);
                $640354b193201be7$var$inflightPromise.then(setEnabled);
            }
            $640354b193201be7$var$updaters.add(setEnabled);
            return ()=>{
                $640354b193201be7$var$updaters.delete(setEnabled);
            };
        };
        t1 = [
            isLoggedIn,
            isLicensed
        ];
        $[0] = isLicensed;
        $[1] = isLoggedIn;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    const notify = $640354b193201be7$var$_temp;
    const t2 = Boolean(enabled);
    let t3;
    if ($[4] !== t2) {
        t3 = [
            t2,
            notify
        ];
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    return t3;
};
async function $640354b193201be7$var$_temp(enabled_0) {
    try {
        const res = await (0, $f7B1p.cfetch)("/wiki/rest/confluenceshortcuts/latest/enabled", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                enabled: enabled_0
            })
        });
        if (res.ok) {
            const newEnabled = await res.text() === "true";
            window.__SHORTCUT_ENABLED__ = newEnabled;
            $640354b193201be7$var$updaters.forEach((updater)=>updater(newEnabled));
        }
    } catch (t0) {
        const e = t0;
        (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Error updating keyboard shortcuts enabled state: ${e.message}`), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        });
    }
}
module.exports["useKeyboardShortcutsEnabled"] = $640354b193201be7$export$130f87a5d53e682d;

});

parcelRegister("aJv6Q", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4PPzL = parcelRequire("4PPzL");


var $hSqtY = parcelRequire("hSqtY");

function $1d5814e83a6e1177$export$f0c7a449e0cfaec7(errorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $4PPzL.ErrorBoundary), errorBoundaryProps);
}
function $1d5814e83a6e1177$export$c5425be6daeb353e(transparentErrorBoundaryProps) {
    return $1d5814e83a6e1177$export$e54e24a14e23c644((0, $hSqtY.TransparentErrorBoundary), transparentErrorBoundaryProps);
}
function $1d5814e83a6e1177$export$e54e24a14e23c644(BoundaryComponent, boundaryProps) {
    return function(WrappedComponent) {
        return (wrappedProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BoundaryComponent, boundaryProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, wrappedProps));
    };
}
module.exports["withErrorBoundary"] = $1d5814e83a6e1177$export$f0c7a449e0cfaec7;
module.exports["withTypedErrorBoundary"] = $1d5814e83a6e1177$export$e54e24a14e23c644;
module.exports["withTransparentErrorBoundary"] = $1d5814e83a6e1177$export$c5425be6daeb353e;

});

parcelRegister("gnkil", function(module, exports) {
// Note: When modifying shortcut settings, make sure to test across all input fields on the page.
// Some input fields may not have shortcuts fully disabled, which could cause conflicts with shortcuts.
// Ensure that the new shortcuts do not interfere with normal input field operations.
// When making change in this file, make sure the corresponding tab in @confluence/keyboard-shortcuts-dialog is also updated
// Shortcuts for editor2
const $e13bb5c64c0a0eec$export$170fefa3f8a9258a = {
    PUBLISH: 'mod+enter',
    PUBLISH_WITH_COMMENT: 'mod+shift+enter',
    EDIT: 'e',
    PREVIEW: 'mod+shift+e',
    UNDO: 'mod+z',
    REDO: 'mod+shift+z',
    FIND_REPLACE: 'mod+f'
};
const $e13bb5c64c0a0eec$export$1cbe44c5850db728 = 'mod+s';
const $e13bb5c64c0a0eec$export$73148f05a63f43f = 'command+enter';
const $e13bb5c64c0a0eec$export$67c56ed34ece0f2a = 'mod+enter';
const $e13bb5c64c0a0eec$export$c19d729632cce38f = 'b';
const $e13bb5c64c0a0eec$export$e896f39257754358 = 'c';
const $e13bb5c64c0a0eec$export$c9d367283380f242 = 'f';
const $e13bb5c64c0a0eec$export$44da7c32f8b979f6 = 'm';
const $e13bb5c64c0a0eec$export$f10fe393178b1b45 = 'k';
const $e13bb5c64c0a0eec$export$3837d28de95f38e = 'e';
const $e13bb5c64c0a0eec$export$99088c948bf0270f = 'r';
const $e13bb5c64c0a0eec$export$ddb528ae2130e6f3 = 'w';
const $e13bb5c64c0a0eec$export$95a205588c16f013 = 's';
const $e13bb5c64c0a0eec$export$f7fab4391dadca28 = 'l';
const $e13bb5c64c0a0eec$export$2f62883c954429eb = 't';
const $e13bb5c64c0a0eec$export$96f161bee6b4340d = 'n';
const $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172 = 'p';
const $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031 = 'g f';
const $e13bb5c64c0a0eec$export$b947af6524920798 = 'g g';
const $e13bb5c64c0a0eec$export$53e346b715d2b7c7 = 'g d';
const $e13bb5c64c0a0eec$export$8cb32cdc75719ad2 = 'g n';
const $e13bb5c64c0a0eec$export$b4842d8ad92c38a3 = 'g r';
const $e13bb5c64c0a0eec$export$298e62593d4ef85 = 'g s';
const $e13bb5c64c0a0eec$export$5d4720de35488ecb = 'g s';
const $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7 = 'g o';
const $e13bb5c64c0a0eec$export$f5473855a7a167a7 = 'g c';
const $e13bb5c64c0a0eec$export$cee4257b1a828f0d = '/';
const $e13bb5c64c0a0eec$export$159e447a25b21930 = '[';
const $e13bb5c64c0a0eec$export$922297bddc2a63e6 = 'mod+z';
const $e13bb5c64c0a0eec$export$420825475f86fe8d = 'left';
const $e13bb5c64c0a0eec$export$db9252a2db2b8e9e = 'right';
const $e13bb5c64c0a0eec$export$faa4136cec2aa7a0 = '?';
const $e13bb5c64c0a0eec$export$362c0171844ea600 = 'a';
const $e13bb5c64c0a0eec$export$5d80e625aa457659 = ']';
const $e13bb5c64c0a0eec$export$cc9bab4159e8aec9 = 'e';
const $e13bb5c64c0a0eec$export$285e80cf6c078ba6 = 'mod+shift+e';
const $e13bb5c64c0a0eec$export$8d0081a3f70f258c = 'ctrl+.';
const $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14 = 'ctrl+,';
const $e13bb5c64c0a0eec$export$de4065c6a68e4031 = 'mod+option+c';
const $e13bb5c64c0a0eec$export$b5f3b4e8358360b3 = 'ctrl+shift+d';
const $e13bb5c64c0a0eec$export$9cee57908df99565 = 'ctrl+option+n';
const $e13bb5c64c0a0eec$export$b0a212f4fb6d9350 = 'mod+shift+u';
const $e13bb5c64c0a0eec$export$986cc862e5f6eec1 = 'mod+option+r';
const $e13bb5c64c0a0eec$export$d3b6b270c6770b4f = 'ctrl+option+r';
const $e13bb5c64c0a0eec$export$adb85b0fd79d17f8 = 'ctrl+]';
const $e13bb5c64c0a0eec$export$1822b04007c39b0c = 'mod+option+shift+b';
const $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99 = 'ctrl+option+c';
const $e13bb5c64c0a0eec$export$f5ba0af3c65d3125 = 'meta+alt+c';
const $e13bb5c64c0a0eec$export$c372eed375f60e68 = 'ctrl+shift+/';
const $e13bb5c64c0a0eec$export$406fcfa6807667 = 'ctrl+[';
const $e13bb5c64c0a0eec$export$4ec29504bd71f204 = 'ctrl+option+f';
const $e13bb5c64c0a0eec$export$4148526d63a5bc01 = 'mod+option+o';
const $e13bb5c64c0a0eec$export$b7088d9be4883093 = 'ctrl+option+z';
const $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c = 'alt+shift+z';
const $e13bb5c64c0a0eec$export$2bdd2e57d23976c4 = 'mod+option+h';
const $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899 = 'mod+option+g';
const $e13bb5c64c0a0eec$export$18a9bb0de7844bb6 = 'mod+option+8';
const $e13bb5c64c0a0eec$export$3fe2d0f3fe115364 = 'mod+option+v';
const $e13bb5c64c0a0eec$export$a3e38cca130cbc49 = 'mod+option+w';
const $e13bb5c64c0a0eec$export$a769ea2ac46f94da = 'ctrl+option+w';
const $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd = 'mod+option+s';
const $e13bb5c64c0a0eec$export$4bc8c55d04859f5a = 'ctrl+shift+i';
const $e13bb5c64c0a0eec$export$1f53991bf9b208a0 = 'ctrl+option+a';
const $e13bb5c64c0a0eec$export$650d7b87402f841f = 'ctrl+option+t';
const $e13bb5c64c0a0eec$export$dc2c2f2eed832016 = 'meta+alt+t';
const $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d = 'mod+.';
const $e13bb5c64c0a0eec$export$c252fe6b173dfad3 = 'ctrl+meta+.';
const $e13bb5c64c0a0eec$export$a1552937ff7cca64 = 'mod+option+k';
const $e13bb5c64c0a0eec$export$f7727b957c03a88b = 'mod+option+e';
const $e13bb5c64c0a0eec$export$f0043475aa91a151 = 'alt+meta+x';
module.exports["EDITOR2_SHORTCUTS"] = $e13bb5c64c0a0eec$export$170fefa3f8a9258a;
module.exports["BROWSER_SAVE_SHORTCUT"] = $e13bb5c64c0a0eec$export$1cbe44c5850db728;
module.exports["COMMENT_EDITOR_SHORTCUT"] = $e13bb5c64c0a0eec$export$73148f05a63f43f;
module.exports["INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$67c56ed34ece0f2a;
module.exports["BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$c19d729632cce38f;
module.exports["GLOBAL_CREATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$e896f39257754358;
module.exports["STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$c9d367283380f242;
module.exports["CREATE_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$44da7c32f8b979f6;
module.exports["LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f10fe393178b1b45;
module.exports["EDIT_SHORTCUT"] = $e13bb5c64c0a0eec$export$3837d28de95f38e;
module.exports["PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$99088c948bf0270f;
module.exports["WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddb528ae2130e6f3;
module.exports["SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$95a205588c16f013;
module.exports["LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7fab4391dadca28;
module.exports["VIEW_ATTACHMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$2f62883c954429eb;
module.exports["NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$96f161bee6b4340d;
module.exports["PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$ef9cfcdc2a9ff172;
module.exports["SUBMIT_FEEDBACK_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0bc8e18b9c1c031;
module.exports["NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$b947af6524920798;
module.exports["GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$53e346b715d2b7c7;
module.exports["NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$8cb32cdc75719ad2;
module.exports["GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b4842d8ad92c38a3;
module.exports["GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$298e62593d4ef85;
module.exports["SPACE_OVERVIEW_SHORTCUT_NAV_3"] = $e13bb5c64c0a0eec$export$5d4720de35488ecb;
module.exports["SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$9a4b5405eaaa0bd7;
module.exports["AI_MATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$f5473855a7a167a7;
module.exports["NAVIGATION_SLASH_SHORTCUT"] = $e13bb5c64c0a0eec$export$cee4257b1a828f0d;
module.exports["SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$159e447a25b21930;
module.exports["UNDO_SHORTCUT"] = $e13bb5c64c0a0eec$export$922297bddc2a63e6;
module.exports["PREV_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$420825475f86fe8d;
module.exports["NEXT_TEMPLATE_SHORTCUT"] = $e13bb5c64c0a0eec$export$db9252a2db2b8e9e;
module.exports["HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$faa4136cec2aa7a0;
module.exports["AUTOMATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$362c0171844ea600;
module.exports["TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER"] = $e13bb5c64c0a0eec$export$5d80e625aa457659;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_EDIT"] = $e13bb5c64c0a0eec$export$cc9bab4159e8aec9;
module.exports["LIVE_PAGE_MODE_SWITCH_TO_VIEW"] = $e13bb5c64c0a0eec$export$285e80cf6c078ba6;
module.exports["UNIVERSAL_NEXT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$8d0081a3f70f258c;
module.exports["UNIVERSAL_PREV_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$d9b4e2a8acc45d14;
module.exports["UNIVERSAL_OPEN_COMMENT_EDITOR"] = $e13bb5c64c0a0eec$export$de4065c6a68e4031;
module.exports["UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT"] = $e13bb5c64c0a0eec$export$b5f3b4e8358360b3;
module.exports["UNIVERSAL_CREATE_NOTE_SHORTCUT"] = $e13bb5c64c0a0eec$export$9cee57908df99565;
module.exports["UNIVERSAL_NEXT_UNREAD_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$b0a212f4fb6d9350;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT"] = $e13bb5c64c0a0eec$export$986cc862e5f6eec1;
module.exports["UNIVERSAL_PRESENTATION_MODE_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$d3b6b270c6770b4f;
module.exports["UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT"] = $e13bb5c64c0a0eec$export$adb85b0fd79d17f8;
module.exports["UNIVERSAL_BLOG_SHORTCUT"] = $e13bb5c64c0a0eec$export$1822b04007c39b0c;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$5dd7c1bb4d898f99;
module.exports["UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$f5ba0af3c65d3125;
module.exports["UNIVERSAL_HELP_SHORTCUT"] = $e13bb5c64c0a0eec$export$c372eed375f60e68;
module.exports["UNIVERSAL_SIDE_NAVIGATION_SHORTCUT"] = $e13bb5c64c0a0eec$export$406fcfa6807667;
module.exports["UNIVERSAL_STAR_BUTTON_SHORTCUT"] = $e13bb5c64c0a0eec$export$4ec29504bd71f204;
module.exports["UNIVERSAL_NOTIFICATIONS_SHORTCUT"] = $e13bb5c64c0a0eec$export$4148526d63a5bc01;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$b7088d9be4883093;
module.exports["UNIVERSAL_NAVIGATION_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$e14ed0c2460e0a5c;
module.exports["UNIVERSAL_GO_HOME_SHORTCUT"] = $e13bb5c64c0a0eec$export$2bdd2e57d23976c4;
module.exports["UNIVERSAL_GO_TO_RECENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$e3a3f5ea05a3d899;
module.exports["UNIVERSAL_GO_TO_STARRED_SHORTCUT"] = $e13bb5c64c0a0eec$export$18a9bb0de7844bb6;
module.exports["UNIVERSAL_SPACE_OVERVIEW_SHORTCUT"] = $e13bb5c64c0a0eec$export$3fe2d0f3fe115364;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$a3e38cca130cbc49;
module.exports["UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI"] = $e13bb5c64c0a0eec$export$a769ea2ac46f94da;
module.exports["UNIVERSAL_SHARE_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$ddfbfebfa9c821fd;
module.exports["UNIVERSAL_OPEN_DETAILS_PANEL_SHORTCUT"] = $e13bb5c64c0a0eec$export$4bc8c55d04859f5a;
module.exports["UNIVERSAL_LABELS_SHORTCUT"] = $e13bb5c64c0a0eec$export$1f53991bf9b208a0;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$650d7b87402f841f;
module.exports["UNIVERSAL_VIEW_ATTACHMENTS_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$dc2c2f2eed832016;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_MAC"] = $e13bb5c64c0a0eec$export$1a9b1a10dcf9f02d;
module.exports["UNIVERSAL_AI_MATE_SHORTCUT_WIN"] = $e13bb5c64c0a0eec$export$c252fe6b173dfad3;
module.exports["UNIVERSAL_LINK_TO_THIS_PAGE_SHORTCUT"] = $e13bb5c64c0a0eec$export$a1552937ff7cca64;
module.exports["UNIVERSAL_SELECT_COMMENT_SHORTCUT"] = $e13bb5c64c0a0eec$export$f7727b957c03a88b;
module.exports["UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT"] = $e13bb5c64c0a0eec$export$f0043475aa91a151;

});

parcelRegister("iXzFq", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");

const $71e3d8e13a87be5f$var$getLegacyActionUrl = (redirectToEditor, contentId)=>{
    if (redirectToEditor) return `${0, $jlIaF.CONTEXT_PATH}/pages/resumedraft.action?draftId=${contentId}`;
    return `${0, $jlIaF.CONTEXT_PATH}/pages/viewpage.action?pageId=${contentId}`;
};
const $71e3d8e13a87be5f$export$11b68a3633074ac0 = ({ contentType: contentType, contentSubType: contentSubType = null, contentId: contentId, spaceKey: spaceKey, redirectToEditor: redirectToEditor = false, useLegacyActionUrl: useLegacyActionUrl = false })=>{
    if (!contentId) return null;
    // assume all page sub types will only redirect to view page
    // can refactor to be more specific if needed
    if (contentType === 'page' && contentSubType !== null) return (0, $1NBp8.VIEW_PAGE).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    if (contentType === 'page' && useLegacyActionUrl) return $71e3d8e13a87be5f$var$getLegacyActionUrl(redirectToEditor, contentId);
    if (contentType === 'page' && redirectToEditor) return (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        spaceKey: spaceKey,
        contentType: 'pages',
        contentId: contentId
    });
    if (contentType === 'blogpost' && redirectToEditor) return (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        spaceKey: spaceKey,
        contentId: contentId,
        contentType: 'blog'
    });
    switch(contentType){
        case 'page':
            return (0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'blogpost':
            return (0, $1NBp8.VIEW_BLOG).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'whiteboard':
            return (0, $1NBp8.WHITEBOARD_BOARD).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'database':
            return (0, $1NBp8.DATABASE_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'slide':
            return (0, $1NBp8.SLIDES_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'embed':
            return (0, $1NBp8.EMBED_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
        case 'folder':
            return (0, $1NBp8.FOLDER_VIEW).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            });
    }
    return null;
};
module.exports["getUrlForContentType"] = $71e3d8e13a87be5f$export$11b68a3633074ac0;

});

parcelRegister("7CX60", function(module, exports) {

var $lyqUH = parcelRequire("lyqUH");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/townsquare/goal/manifest.ts
var $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    resourceOwner: (0, $lyqUH.TownsquareGoalAriResourceOwner),
    resourceType: (0, $lyqUH.TownsquareGoalAriResourceType),
    resourceIdSlug: "{goalUuid}",
    resourceIdSegmentFormats: {
        goalUuid: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/townsquare/goal/index.ts
var $58d9ec349b8fda63$export$e45ea1bd9a289a4f = class _TownsquareGoalAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get goalUuid() {
        return this._goalUuid;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts.qualifier,
            platformQualifier: $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts.resourceOwner,
            resourceType: $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts.resourceType,
            resourceId: `${opts.goalUuid}`,
            resourceIdSegmentValues: {
                goalUuid: opts.goalUuid
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $58d9ec349b8fda63$var$townsquareGoalAriStaticOpts);
        return new _TownsquareGoalAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            goalUuid: this.goalUuid
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.cloudId || "", this._goalUuid = opts.resourceIdSegmentValues.goalUuid;
    }
};
module.exports["TownsquareGoalAri"] = $58d9ec349b8fda63$export$e45ea1bd9a289a4f;

});

parcelRegister("lyqUH", function(module, exports) {
// src/townsquare/goal/types.ts
var $fb11a66b9944d017$export$947838268868cc57 = "townsquare", $fb11a66b9944d017$export$935b9c2af9d62e80 = "goal";
module.exports["TownsquareGoalAriResourceOwner"] = $fb11a66b9944d017$export$947838268868cc57;
module.exports["TownsquareGoalAriResourceType"] = $fb11a66b9944d017$export$935b9c2af9d62e80;

});

parcelRegister("28WJb", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $3Ap09 = parcelRequire("3Ap09");

const $065389573511adac$export$5351114e92b31bc6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(4);
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    let t0;
    if ($[0] !== context.setPanelWidth || $[1] !== context.state.panel || $[2] !== context.width) {
        t0 = {
            ...context.state.panel,
            width: context.width,
            setWidth: context.setPanelWidth
        };
        $[0] = context.setPanelWidth;
        $[1] = context.state.panel;
        $[2] = context.width;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : ()=>{
    const context = (0, $3Ap09.usePreviewPanelsContext)();
    if (context?.state.panel == null) return null;
    return {
        ...context.state.panel,
        width: context.width,
        setWidth: context.setPanelWidth
    };
};
module.exports["useCurrentPreviewPanel"] = $065389573511adac$export$5351114e92b31bc6;

});

parcelRegister("8OpiN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::48df6a4b08988964a6c19ca298fb7fa6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66a69eb8c574d02b$var$_react = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("cozmU")));

var $66a69eb8c574d02b$var$_iconNew = $66a69eb8c574d02b$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $66a69eb8c574d02b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObject".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-object
 * Usage guidance:
 * Reserved for representing objects in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66a69eb8c574d02b$var$AssetsObjectIcon = (props)=>/*#__PURE__*/ $66a69eb8c574d02b$var$_react.default.createElement($66a69eb8c574d02b$var$_iconNew.default, Object.assign({
        name: "AssetsObjectIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 3a.5.5 0 0 0-.5-.5h-2.5v3.75a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75V2.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5zM7 5.5h2v-3H7zm8 7.5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$66a69eb8c574d02b$var$AssetsObjectIcon.displayName = 'AssetsObjectIcon';
var $66a69eb8c574d02b$var$_default = module.exports.default = $66a69eb8c574d02b$var$AssetsObjectIcon;

});

parcelRegister("df5DJ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $99V2N = parcelRequire("99V2N");

var $9jEqd = parcelRequire("9jEqd");

var $hG4SA = parcelRequire("hG4SA");


var $6i6Hm = parcelRequire("6i6Hm");

const $3d79566ecfd5a94d$var$SITE_RESOURCE_TYPE = 'site';
const $3d79566ecfd5a94d$var$siteIdOf = (siteIdOrAri)=>{
    try {
        const ari = (0, $99V2N.AnyAri).parse(siteIdOrAri);
        return ari.resourceType === $3d79566ecfd5a94d$var$SITE_RESOURCE_TYPE ? ari.resourceId : siteIdOrAri;
    } catch  {
        return siteIdOrAri;
    }
};
const $3d79566ecfd5a94d$var$createSiteAri = (siteAriType, siteId)=>{
    try {
        return siteAriType.create({
            siteId: siteId
        }).toString();
    } catch  {
        return '';
    }
};
const $3d79566ecfd5a94d$var$getAppSiteAri = (siteIdOrAri, siteAriType)=>{
    const siteId = $3d79566ecfd5a94d$var$siteIdOf(siteIdOrAri);
    if (!(0, $iDrrr.fg)('townsquare_goal_project_site_aris')) // Pre-migration behaviour: site ARIs are passed through untouched, bare site ids
    // are turned into the deprecated townsquare-owned site ARI.
    return siteId === siteIdOrAri ? $3d79566ecfd5a94d$var$createSiteAri((0, $6i6Hm.TownsquareSiteAri), siteId) : siteIdOrAri;
    return $3d79566ecfd5a94d$var$createSiteAri(siteAriType, siteId);
};
const $3d79566ecfd5a94d$export$20d6ddd0cf2f686b = (siteIdOrAri)=>$3d79566ecfd5a94d$var$getAppSiteAri(siteIdOrAri, (0, $9jEqd.GoalSiteAri));
const $3d79566ecfd5a94d$export$565bf3b5b10d78e9 = (siteIdOrAri)=>$3d79566ecfd5a94d$var$getAppSiteAri(siteIdOrAri, (0, $hG4SA.ProjectSiteAri));
module.exports["getGoalSiteAri"] = $3d79566ecfd5a94d$export$20d6ddd0cf2f686b;
module.exports["getProjectSiteAri"] = $3d79566ecfd5a94d$export$565bf3b5b10d78e9;

});

parcelRegister("9jEqd", function(module, exports) {

var $ei2P9 = parcelRequire("ei2P9");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/goal/site/manifest.ts
var $6c853e59257dbecf$var$goalSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $ei2P9.GoalSiteAriResourceOwner),
    resourceType: (0, $ei2P9.GoalSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/goal/site/index.ts
var $6c853e59257dbecf$export$25f6e07f2c803459 = class _GoalSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6c853e59257dbecf$var$goalSiteAriStaticOpts.qualifier,
            platformQualifier: $6c853e59257dbecf$var$goalSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $6c853e59257dbecf$var$goalSiteAriStaticOpts.resourceOwner,
            resourceType: $6c853e59257dbecf$var$goalSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $6c853e59257dbecf$var$goalSiteAriStaticOpts);
        return new _GoalSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $6c853e59257dbecf$var$goalSiteAriStaticOpts);
        return new _GoalSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["GoalSiteAri"] = $6c853e59257dbecf$export$25f6e07f2c803459;

});

parcelRegister("ei2P9", function(module, exports) {
// src/goal/site/types.ts
var $a674efe79f341c4b$export$856c52490bfaa1d5 = "goal", $a674efe79f341c4b$export$21b302361b3c545e = "site";
module.exports["GoalSiteAriResourceOwner"] = $a674efe79f341c4b$export$856c52490bfaa1d5;
module.exports["GoalSiteAriResourceType"] = $a674efe79f341c4b$export$21b302361b3c545e;

});

parcelRegister("hG4SA", function(module, exports) {

var $5isyS = parcelRequire("5isyS");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/project/site/manifest.ts
var $cdea24de3f27642d$var$projectSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $5isyS.ProjectSiteAriResourceOwner),
    resourceType: (0, $5isyS.ProjectSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/project/site/index.ts
var $cdea24de3f27642d$export$ac5d12d294f83be4 = class _ProjectSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $cdea24de3f27642d$var$projectSiteAriStaticOpts.qualifier,
            platformQualifier: $cdea24de3f27642d$var$projectSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $cdea24de3f27642d$var$projectSiteAriStaticOpts.resourceOwner,
            resourceType: $cdea24de3f27642d$var$projectSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $cdea24de3f27642d$var$projectSiteAriStaticOpts);
        return new _ProjectSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $cdea24de3f27642d$var$projectSiteAriStaticOpts);
        return new _ProjectSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["ProjectSiteAri"] = $cdea24de3f27642d$export$ac5d12d294f83be4;

});

parcelRegister("5isyS", function(module, exports) {
// src/project/site/types.ts
var $3db4c9e7774a7202$export$9eea0d5b157c61be = "project", $3db4c9e7774a7202$export$cbe80ac90c61c70d = "site";
module.exports["ProjectSiteAriResourceOwner"] = $3db4c9e7774a7202$export$9eea0d5b157c61be;
module.exports["ProjectSiteAriResourceType"] = $3db4c9e7774a7202$export$cbe80ac90c61c70d;

});

parcelRegister("6i6Hm", function(module, exports) {

var $4Yksf = parcelRequire("4Yksf");


var $9j37t = parcelRequire("9j37t");


var $glA79 = parcelRequire("glA79");

// src/townsquare/site/manifest.ts
var $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $4Yksf.TownsquareSiteAriResourceOwner),
    resourceType: (0, $4Yksf.TownsquareSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/townsquare/site/index.ts
var $49499eaaef8ec6c2$export$87ae3de5f1f7725a = class _TownsquareSiteAri extends (0, $9j37t.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts.qualifier,
            platformQualifier: $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts.resourceOwner,
            resourceType: $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $glA79.AriParser).fromOpts(derivedOpts, $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $glA79.AriParser).fromString(maybeAri, $49499eaaef8ec6c2$var$townsquareSiteAriStaticOpts);
        return new _TownsquareSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts), this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};
module.exports["TownsquareSiteAri"] = $49499eaaef8ec6c2$export$87ae3de5f1f7725a;

});

parcelRegister("4Yksf", function(module, exports) {
// src/townsquare/site/types.ts
var $39eca1dd131685dd$export$9ee8c46ef1f3e6a8 = "townsquare", $39eca1dd131685dd$export$44737bde24f3bac1 = "site";
module.exports["TownsquareSiteAriResourceOwner"] = $39eca1dd131685dd$export$9ee8c46ef1f3e6a8;
module.exports["TownsquareSiteAriResourceType"] = $39eca1dd131685dd$export$44737bde24f3bac1;

});

parcelRegister("4slsU", function(module, exports) {

var $7CX60 = parcelRequire("7CX60");

var $5O8nX = parcelRequire("5O8nX");

var $6i6Hm = parcelRequire("6i6Hm");

function $4caae11b2ff1f088$export$3ae2d1e732b25194(entity, ari) {
    try {
        if (entity === 'goal') return (0, $7CX60.TownsquareGoalAri).parse(ari).siteId;
        if (entity === 'project') return (0, $5O8nX.TownsquareProjectAri).parse(ari).siteId;
        if (entity === 'site') return (0, $6i6Hm.TownsquareSiteAri).parse(ari).siteId;
    } catch (error) {
        //TODO: send error metrics/monitoring https://product-fabric.atlassian.net/browse/TC-13492
        //We try to extract the siteId manually: ari:cloud:townsquare:${siteId}:{entity}/{uuid}
        if (entity === 'goal' || entity === 'project') return ari.split(':')[3] ?? '';
    }
    return '';
}
module.exports["getSiteId"] = $4caae11b2ff1f088$export$3ae2d1e732b25194;

});

parcelRegister("fvoKJ", function(module, exports) {

var $6i6Hm = parcelRequire("6i6Hm");

const $e160175aa6804997$export$792aeacb7990bc6 = (containerId)=>{
    // we wrap in a try/catch incase there are any issues with creating the site ari
    try {
        return (0, $6i6Hm.TownsquareSiteAri).create({
            siteId: containerId
        }).toString();
    } catch  {
        return '';
    }
};
module.exports["getSiteAri"] = $e160175aa6804997$export$792aeacb7990bc6;

});

parcelRegister("1w4hj", function(module, exports) {
class $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37 {
    static extractErrorMessage(error) {
        if (error instanceof Error) return $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
        else return $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
    }
}
$7d33ebf4b0fcc5c6$export$7edca8cfa9634e37.redactSensitiveInfo = (str)=>{
    const redacted = str// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]')// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    .replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
    return redacted;
};
module.exports["ErrorUtils"] = $7d33ebf4b0fcc5c6$export$7edca8cfa9634e37;

});

parcelRegister("7ZL6d", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $96bd972ec1007d07$export$480e55f805d7990f = (0, $kSwu1.defineMessages)({
    // Event hub messages
    eventHubfallbackSuggestedTitle: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitle",
        defaultMessage: "Page title"
    },
    eventHubfallbackSuggestedTitlePrefix: {
        id: "fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix",
        defaultMessage: "Page"
    },
    // Toolbar messages
    aiToolbarTitle: {
        id: "fabric.editor.ai.toolbar.titleText",
        defaultMessage: "Atlassian Intelligence"
    },
    improveWritingToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.improveWriting.title",
        defaultMessage: "Improve writing"
    },
    improveWritingToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.improveWriting.tooltip",
        defaultMessage: "Tell Atlassian Intelligence to improve the writing of your selection"
    },
    askAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askAI.title",
        defaultMessage: "Ask AI"
    },
    askRovoToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.title",
        defaultMessage: "Ask Rovo"
    },
    askRovoToolbarRemixAppTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.title",
        defaultMessage: "Edit"
    },
    askRovoToolbarImageTitle: {
        id: "fabric.editor.ai.toolbar.askRovo.image.title",
        defaultMessage: "Edit image"
    },
    moreRovoOptionsMenuLabel: {
        id: "fabric.editor.ai.toolbar.moreRovoOptions.label",
        defaultMessage: "More Rovo options"
    },
    askRovoAiSplitButtonLabel: {
        id: "fabric.editor.ai.toolbar.askRovoAiSplitButton.label",
        defaultMessage: "Ask Rovo AI"
    },
    askAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    askAIToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand",
        defaultMessage: "Ask AI {key}+'"
    },
    askRovoToolbarIconTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand",
        defaultMessage: "Ask Rovo {key}+'"
    },
    askRovoToolbarRemixAppTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.remixApp.tooltip.quickCommand",
        defaultMessage: "Edit {key}+'"
    },
    askRovoToolbarImageTooltipQuickCommand: {
        id: "fabric.editor.ai.toolbar.askRovo.image.tooltip.quickCommand",
        defaultMessage: "Edit image {key}+'"
    },
    tryAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.tryAI.title",
        defaultMessage: "Try AI"
    },
    tryAIToolbarIconTooltip: {
        id: "fabric.editor.ai.toolbar.tryAI.tooltip",
        defaultMessage: "Open Atlassian Intelligence"
    },
    simplifiedAIToolbarIconTitle: {
        id: "fabric.editor.ai.toolbar.simplifiedAI.title",
        defaultMessage: "AI"
    },
    rovoToolbarDropdownChevronLabel: {
        id: "fabric.editor.ai.toolbar.rovoDropdownChevron.label",
        defaultMessage: "More Ask Rovo options"
    },
    summarizeToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.summarize.title",
        defaultMessage: "Summarize"
    },
    translateToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.translate.title",
        defaultMessage: "Translate"
    },
    translateOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.translateOptions.label",
        defaultMessage: "Translate options"
    },
    spellingAndGrammarToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.spellingAndGrammar.title",
        defaultMessage: "Fix spelling and grammar"
    },
    makeLongerToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeLonger.title",
        defaultMessage: "Make longer"
    },
    makeShorterToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.makeShorter.title",
        defaultMessage: "Make shorter"
    },
    changeToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.changeTone.title",
        defaultMessage: "Change tone"
    },
    changeToneOptionsIconLabel: {
        id: "fabric.editor.ai.toolbar.changeToneOptions.title",
        defaultMessage: "Change tone options"
    },
    moreProfessionalToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreProfessionalTone.title",
        defaultMessage: "More professional"
    },
    moreCasualToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreCasualTone.title",
        defaultMessage: "More casual"
    },
    moreEmpatheticToneToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.moreEmpatheticTone.title",
        defaultMessage: "More empathetic"
    },
    adjustLengthToolbarDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.adjustLength.title",
        defaultMessage: "Adjust length"
    },
    DefineDropdownIconTitle: {
        id: "fabric.editor.ai.toolbar.DefineDropdownIconTitle.title",
        defaultMessage: "Define"
    },
    // Prebuilt messages
    atlasGenerateContentConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription",
        defaultMessage: "Generates content to be inserted into the update"
    },
    atlasSummarizePageConfigItemDescription: {
        id: "fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription",
        defaultMessage: "Summarizes the content of the update"
    },
    confluenceChangeToneSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Change tone"
    },
    confluenceRewriteSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Rewrite"
    },
    confluenceTranslateSelectionToolbarDropdownMenuTitle: {
        id: "fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle",
        defaultMessage: "Translate"
    },
    // AI Panel Action items messages
    actionItemsPageTitle: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageTitle",
        defaultMessage: "Action items panel (Beta)"
    },
    actionItemsPageDescription: {
        id: "fabric.editor.ai.ai-panels.actionItemsPageDescription",
        defaultMessage: "Use Atlassian Intelligence to find action items and display in a panel"
    },
    // AI Panel Summarise page messages
    summarizePageTitle: {
        id: "fabric.editor.ai.ai-panels.summarizePageTitle",
        defaultMessage: "Page summary panel (Beta)"
    },
    summarisePageDescription: {
        id: "fabric.editor.ai.ai-panels.summarizePageDescription",
        defaultMessage: "Use Atlassian Intelligence to summarize this page and display in a panel"
    },
    // Agent messages
    agentsDropdownTitle: {
        id: "rovo.agents.dropdown.title",
        defaultMessage: "Agents"
    },
    agentsViewAgentsLabel: {
        id: "rovo.agents.dropdown.viewAgents.label",
        defaultMessage: "View all agents"
    },
    // Error messages
    unhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.unhandledErrorMessage",
        defaultMessage: "We're having trouble. Close the dialog and try again."
    },
    cmdPaletteUnhandledErrorMessage: {
        id: "fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage",
        defaultMessage: "We're having issues and can't generate a response right now. Try again later."
    },
    markdownErrorMessage: {
        id: "fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage",
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again."
    },
    // Prompt Builder messages
    promptbuilderAriaLabel: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel",
        defaultMessage: "Ask Atlassian Intelligence"
    },
    promptBuilderFromButton: {
        id: "fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit",
        defaultMessage: "Generate"
    },
    // AI Smart button messages
    aiSmartButtonDynamicSurfaceSelectedContent: {
        id: "fabric.editor.ai.ai-smart-button.context.reference",
        defaultMessage: "Selected content"
    },
    // Telepointer
    aiPlannerTelepointer: {
        id: "fabric.editor.ai.telepointer.planner",
        defaultMessage: "Planner"
    },
    aiRovoTelepointer: {
        id: "fabric.editor.ai.telepointer.rovo",
        defaultMessage: "Rovo"
    },
    // On-paste menu messages
    pasteMenuActionsTitle: {
        id: "fabric.editor.ai.paste-menu.section-title",
        defaultMessage: "Actions"
    },
    // Block menu messages
    blockMenuNestedMenuTitle: {
        id: "fabric.editor.ai.config.item.blockMenuNestedMenu.title",
        defaultMessage: "View more actions"
    },
    // Smartlink action messages
    smartlinkListKeyTopics: {
        id: "fabric.editor.ai.smartlink.action.listKeyTopics",
        defaultMessage: "List key topics"
    },
    smartlinkListKeyThemes: {
        id: "fabric.editor.ai.smartlink.action.listKeyThemes",
        defaultMessage: "List key themes"
    },
    smartlinkExtractInsights: {
        id: "fabric.editor.ai.smartlink.action.extractInsights",
        defaultMessage: "Extract insights"
    },
    smartlinkExtractUserQuotes: {
        id: "fabric.editor.ai.smartlink.action.extractUserQuotes",
        defaultMessage: "Extract user quotes"
    },
    smartlinkAddDecisions: {
        id: "fabric.editor.ai.smartlink.action.addDecisions",
        defaultMessage: "Add decisions"
    },
    smartlinkDefineActionItems: {
        id: "fabric.editor.ai.smartlink.action.defineActionItems",
        defaultMessage: "Define action items"
    },
    smartlinkSummarizeChanges: {
        id: "fabric.editor.ai.smartlink.action.summarizeChanges",
        defaultMessage: "Summarize changes"
    },
    smartlinkAddRelatedWorkItems: {
        id: "fabric.editor.ai.smartlink.action.addRelatedWorkItems",
        defaultMessage: "Add related work items"
    },
    smartlinkListTodos: {
        id: "fabric.editor.ai.smartlink.action.listTodos",
        defaultMessage: "List to-dos"
    },
    smartlinkResolutionErrorDescription: {
        id: "fabric.editor.ai.smartlink.resolution-error.description",
        defaultMessage: "This link failed to resolve."
    }
});
module.exports["aiMessages"] = $96bd972ec1007d07$export$480e55f805d7990f;

});

parcelRegister("c5jT4", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $kSwu1 = parcelRequire("kSwu1");

const $fb80bfa16650ce97$export$21be832820f3e6e6 = (0, $kSwu1.defineMessages)({
    aupViolationMessage: {
        id: "fabric.editor.ai.experience.aupViolationMessage",
        defaultMessage: "Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <link>Acceptable Use Policy</link> if needed. If the problem persists, consider trying a different prompt or content."
    },
    documentInsertError: {
        id: "fabric.editor.ai.experience-application.documentInsertError",
        defaultMessage: "We're having trouble inserting the response. Close the dialog and try again."
    },
    tokenLimitExceeded: {
        id: "fabric.editor.ai.experience-application.tokenLimitExceeded",
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again."
    },
    rateLimitEnforced: {
        id: "fabric.editor.ai.experience-application.rateLimitEnforced",
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>."
    },
    apiError: {
        id: "fabric.editor.ai.experience.apiError",
        defaultMessage: "We couldn\u2019t get a response, please try again."
    },
    elevateDisabledGenerateError: {
        id: "fabric.editor.ai.experience.elevateDisabledGenetateError",
        defaultMessage: "Free generate is disabled in Elevate at this time."
    },
    internalServerError: {
        id: "fabric.editor.ai.experience.internalServerError",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <link>check the status of AI</link>."
    },
    inputTooShortError: {
        id: "fabric.editor.ai.experience.inputTooShortError",
        defaultMessage: "The content is too short to summarize. Please add more and try again."
    },
    hipaaContentError: {
        id: "fabric.editor.ai.experience.hipaaContentError",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again."
    },
    adfStreamingError: {
        id: "fabric.editor.ai.experience.adfStreamingError",
        defaultMessage: "Our apologies, we couldn't get a response."
    },
    aifcAupViolationMessage: {
        id: "fabric.editor.ai.experience.aifcAupViolationMessage",
        defaultMessage: "Content does not comply with our <link>Acceptable Use Policy</link>."
    },
    aifcApiError: {
        id: "fabric.editor.ai.experience.aifcApiError",
        defaultMessage: "An unknown error occurred."
    },
    aifcApiErrorRetry: {
        id: "fabric.editor.ai.experience.aifcApiErrorRetry",
        defaultMessage: "An unknown error occurred. Please reload and try again."
    },
    aifcTokenLimitExceeded: {
        id: "fabric.editor.ai.experience.aifcTokenLimitExceeded",
        defaultMessage: "There\u2019s too much content to process. Select less content and try again."
    },
    aifcInputTooShortError: {
        id: "fabric.editor.ai.experience.aifcInputTooShortError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    },
    aifcHipaaContentError: {
        id: "fabric.editor.ai.experience.aifcHipaaContentError",
        defaultMessage: "Your content contains links to HIPAA restricted content. Remove links and try again."
    },
    aifcRateLimitEnforced: {
        id: "fabric.editor.ai.experience.aifcRateLimitEnforced",
        defaultMessage: "You\u2019ve reached the <link>maximum number of requests</link>. Try again in 5 minutes."
    },
    aifcInternalServerError: {
        id: "fabric.editor.ai.experience.aifcInternalServerError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response. Try again in 5 minutes or <link>check Rovo status</link>."
    },
    aifcAdfStreamingError: {
        id: "fabric.editor.ai.experience.aifcAdfStreamingError",
        defaultMessage: "Our apologies, we couldn\u2019t get a response."
    },
    noTextualContentError: {
        id: "fabric.editor.ai.experience.noTextualContentError",
        defaultMessage: "More content needed to complete your request. Please select more content and try again."
    }
});
module.exports["aiFailedStateMessages"] = $fb80bfa16650ce97$export$21be832820f3e6e6;

});

parcelRegister("eToX6", function(module, exports) {
/**
 * Utility functions for detecting and working with preview panels
 */ // Types for preview panel detection
// Preview panel indicators
const $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
/**
 * Gets URL search parameters safely
 */ const $cf00e918e2c1556d$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $cf00e918e2c1556d$export$5c3b154013d00c5f = (searchParams)=>{
    return searchParams.has($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $cf00e918e2c1556d$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $cf00e918e2c1556d$export$cd88bef28d20da33 = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $cf00e918e2c1556d$var$getUrlSearchParams(currentSearch);
            if (currentParams && $cf00e918e2c1556d$export$5c3b154013d00c5f(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};
const $cf00e918e2c1556d$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};
module.exports["hasPreviewPanelIndicators"] = $cf00e918e2c1556d$export$5c3b154013d00c5f;
module.exports["isInPreviewPanel"] = $cf00e918e2c1556d$export$cd88bef28d20da33;
module.exports["isInIframe"] = $cf00e918e2c1556d$export$9f140ed41af5108c;

});

parcelRegister("koEBx", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $eJlpI = parcelRequire("eJlpI");

const $6173d76fe85d4dd6$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? function ChromelessEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "chromeless",
            AppearanceComponent: (0, $eJlpI.default)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function ChromelessEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "chromeless",
        AppearanceComponent: (0, $eJlpI.default)
    });
};
module.exports["ChromelessEditor"] = $6173d76fe85d4dd6$export$5252bd745392dcde;

});

parcelRegister("9EemN", function(module, exports) {
/*global define:false */ /**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.5
 * @url craig.is/killing/mice
 */ (function(window1, document1, undefined) {
    // Check if mousetrap is used inside browser, if not, return
    if (!window1) return;
    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */ var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };
    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */ var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */ var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };
    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */ var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };
    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */ var _REVERSE_MAP;
    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */ for(var i = 1; i < 20; ++i)_MAP[111 + i] = 'f' + i;
    /**
     * loop through to map numbers on the numeric keypad
     */ for(i = 0; i <= 9; ++i)// This needs to use a string cause otherwise since 0 is falsey
    // mousetrap will never fire for numpad 0 pressed as part of a keydown
    // event.
    //
    // @see https://github.com/ccampbell/mousetrap/pull/258
    _MAP[i + 96] = i.toString();
    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */ function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }
        object.attachEvent('on' + type, callback);
    }
    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */ function _characterFromEvent(e) {
        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);
            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) character = character.toLowerCase();
            return character;
        }
        // for non keypress events the special maps are needed
        if (_MAP[e.which]) return _MAP[e.which];
        if (_KEYCODE_MAP[e.which]) return _KEYCODE_MAP[e.which];
        // if it is not in the special map
        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }
    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */ function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }
    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */ function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) modifiers.push('shift');
        if (e.altKey) modifiers.push('alt');
        if (e.ctrlKey) modifiers.push('ctrl');
        if (e.metaKey) modifiers.push('meta');
        return modifiers;
    }
    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */ function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }
        e.returnValue = false;
    }
    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */ function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }
        e.cancelBubble = true;
    }
    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */ function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }
    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */ function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for(var key in _MAP){
                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) continue;
                if (_MAP.hasOwnProperty(key)) _REVERSE_MAP[_MAP[key]] = key;
            }
        }
        return _REVERSE_MAP;
    }
    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */ function _pickBestAction(key, modifiers, action) {
        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) action = 'keydown';
        return action;
    }
    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */ function _keysFromString(combination) {
        if (combination === '+') return [
            '+'
        ];
        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }
    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */ function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];
        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            // normalize key names
            if (_SPECIAL_ALIASES[key]) key = _SPECIAL_ALIASES[key];
            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }
            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) modifiers.push(key);
        }
        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);
        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }
    function _belongsTo(element, ancestor) {
        if (element === null || element === document1) return false;
        if (element === ancestor) return true;
        return _belongsTo(element.parentNode, ancestor);
    }
    function Mousetrap(targetElement) {
        var self = this;
        targetElement = targetElement || document1;
        if (!(self instanceof Mousetrap)) return new Mousetrap(targetElement);
        /**
         * element to attach key events to
         *
         * @type {Element}
         */ self.target = targetElement;
        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */ self._callbacks = {};
        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */ self._directMap = {};
        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */ var _sequenceLevels = {};
        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */ var _resetTimer;
        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */ var _ignoreNextKeyup = false;
        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */ var _ignoreNextKeypress = false;
        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */ var _nextExpectedAction = false;
        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */ function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};
            var activeSequences = false, key;
            for(key in _sequenceLevels){
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }
            if (!activeSequences) _nextExpectedAction = false;
        }
        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */ function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;
            // if there are no events related to this keycode
            if (!self._callbacks[character]) return [];
            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) modifiers = [
                character
            ];
            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for(i = 0; i < self._callbacks[character].length; ++i){
                callback = self._callbacks[character][i];
                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) continue;
                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) continue;
                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) self._callbacks[character].splice(i, 1);
                    matches.push(callback);
                }
            }
            return matches;
        }
        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */ function _fireCallback(callback, e, combo, sequence) {
            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) return;
            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }
        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */ self._handleKey = function(character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;
            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for(i = 0; i < callbacks.length; ++i)if (callbacks[i].seq) maxLevel = Math.max(maxLevel, callbacks[i].level);
            // loop through matching callbacks for this key event
            for(i = 0; i < callbacks.length; ++i){
                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {
                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) continue;
                    processedSequenceCallback = true;
                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }
                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) _resetSequences(doNotReset);
            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };
        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */ function _handleKeyEvent(e) {
            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') e.which = e.keyCode;
            var character = _characterFromEvent(e);
            // no character found then stop
            if (!character) return;
            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }
            self.handleKey(character, _eventModifiers(e), e);
        }
        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */ function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }
        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */ function _bindSequence(combo, keys, callback, action) {
            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;
            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */ function _increaseSequence(nextAction) {
                return function() {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }
            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */ function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);
                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') _ignoreNextKeyup = _characterFromEvent(e);
                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }
            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for(var i = 0; i < keys.length; ++i){
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }
        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */ function _bindSingle(combination, callback, action, sequenceName, level) {
            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;
            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');
            var sequence = combination.split(' ');
            var info;
            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }
            info = _getKeyInfo(combination, action);
            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];
            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, {
                type: info.action
            }, sequenceName, combination, level);
            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }
        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */ self._bindMultiple = function(combinations, callback, action) {
            for(var i = 0; i < combinations.length; ++i)_bindSingle(combinations[i], callback, action);
        };
        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }
    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */ Mousetrap.prototype.bind = function(keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [
            keys
        ];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };
    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */ Mousetrap.prototype.unbind = function(keys, action) {
        var self = this;
        return self.bind.call(self, keys, function() {}, action);
    };
    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */ Mousetrap.prototype.trigger = function(keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) self._directMap[keys + ':' + action]({}, keys);
        return self;
    };
    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */ Mousetrap.prototype.reset = function() {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };
    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */ Mousetrap.prototype.stopCallback = function(e, element) {
        var self = this;
        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) return false;
        if (_belongsTo(element, self.target)) return false;
        // Events originating from a shadow DOM are re-targetted and `e.target` is the shadow host,
        // not the initial event target in the shadow tree. Note that not all events cross the
        // shadow boundary.
        // For shadow trees with `mode: 'open'`, the initial event target is the first element in
        // the event’s composed path. For shadow trees with `mode: 'closed'`, the initial event
        // target cannot be obtained.
        if ('composedPath' in e && typeof e.composedPath === 'function') {
            // For open shadow trees, update `element` so that the following check works.
            var initialEventTarget = e.composedPath()[0];
            if (initialEventTarget !== e.target) element = initialEventTarget;
        }
        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };
    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */ Mousetrap.prototype.handleKey = function() {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };
    /**
     * allow custom key mappings
     */ Mousetrap.addKeycodes = function(object) {
        for(var key in object)if (object.hasOwnProperty(key)) _MAP[key] = object[key];
        _REVERSE_MAP = null;
    };
    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */ Mousetrap.init = function() {
        var documentMousetrap = Mousetrap(document1);
        for(var method in documentMousetrap)if (method.charAt(0) !== '_') Mousetrap[method] = function(method) {
            return function() {
                return documentMousetrap[method].apply(documentMousetrap, arguments);
            };
        }(method);
    };
    Mousetrap.init();
    // expose mousetrap to the global object
    window1.Mousetrap = Mousetrap;
    // expose as a common js module
    if (module.exports) module.exports = Mousetrap;
    // expose mousetrap as an AMD module
    if (typeof define === 'function' && define.amd) define(function() {
        return Mousetrap;
    });
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

});

parcelRegister("8bRAb", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $4o0zT = parcelRequire("4o0zT");


var $dWfVs = parcelRequire("dWfVs");


var $aJNFh = parcelRequire("aJNFh");


var $2TWQD = parcelRequire("2TWQD");

async function $22de9e431e2baedb$export$af16a73460e35e28(cloudId, config) {
    const allSkills = await (0, $aJNFh.fetchSkills)(cloudId);
    const filteredSkills = (0, $2TWQD.filterSkills)(allSkills, config);
    const buildManifest = (0, $4o0zT.isExperimentEnabled)('platform_editor_slash_command') ? (0, $dWfVs.buildSkillsManifest) : (0, $dWfVs.buildLegacySkillsManifest);
    return buildManifest(filteredSkills, {
        isHidden: config.isHidden,
        // Skills should appear below native editor elements in the slash menu.
        // A high priority value (lower importance) ensures native items rank
        // higher when search scores are equal.
        priority: config.priority ?? 9000,
        onAction: (skill)=>{
            config.onAnalyticsEvent?.({
                action: (0, $krYZG.ACTION).INSERTED,
                actionSubject: (0, $krYZG.ACTION_SUBJECT).TYPEAHEAD,
                actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
                attributes: {
                    skillSlug: skill.slug,
                    skillName: skill.name,
                    isAiSkill: true
                },
                eventType: (0, $krYZG.EVENT_TYPE).TRACK
            });
            return config.onSkillSelected?.(`/${skill.slug}`, skill);
        }
    });
}
module.exports["createRovoSkillsExtensionManifest"] = $22de9e431e2baedb$export$af16a73460e35e28;

});

parcelRegister("2TWQD", function(module, exports) {
function $e8e957862ffce1cf$export$757808344f89f413(skills, config) {
    if (config.showAllSkills) return skills;
    const allowedSlugs = config.allowedSkills ?? [];
    if (allowedSlugs.length === 0) return [];
    const skillsBySlug = new Map(skills.map((skill)=>[
            skill.slug,
            skill
        ]));
    return allowedSlugs.map((slug)=>skillsBySlug.get(slug)).filter((skill)=>skill !== undefined);
}
module.exports["filterSkills"] = $e8e957862ffce1cf$export$757808344f89f413;

});

parcelRegister("7rOWN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2sp5n = parcelRequire("2sp5n");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $eVG6Y = parcelRequire("eVG6Y");


var $dWoVg = parcelRequire("dWoVg");


var $iwIwp = parcelRequire("iwIwp");


var $99TtX = parcelRequire("99TtX");


var $1NFwk = parcelRequire("1NFwk");


var $9F0bu = parcelRequire("9F0bu");


var $85cI7 = parcelRequire("85cI7");


var $7tMWI = parcelRequire("7tMWI");


var $8iBLq = parcelRequire("8iBLq");


var $aaqIB = parcelRequire("aaqIB");

/**
 * IDs of the MAUI-specific experiences (the AI "Remix"/malleable diagram flow).
 *
 * These are gated on the `cc-maui-experiment` experiment rather than the
 * product-specific non-MAUI rollout gates, so that a rollback of
 * `cc-maui-experiment` disables the MAUI experiences without affecting generic
 * native embeds (Pages, Databases, Slides, non-MAUI Whiteboards).
 *
 * `MauiWhiteboardExperienceManifest` only matches whiteboard URLs with
 * `isRemixDiagram=true` (i.e. diagrams created via the MAUI flow). When it is
 * disabled, such URLs fall through to the generic `WhiteboardExperienceManifest`
 * (which matches the same whiteboard path without the `isRemixDiagram` param), so
 * the board still renders as a plain native-embed whiteboard.
 */ const $ab76b84281e6545b$var$mauiExperienceIds = new Set([
    (0, $9F0bu.MAUI_EXPERIENCE_MANIFEST_ID),
    (0, $85cI7.MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID)
]);
const $ab76b84281e6545b$var$allExperiences = [
    (0, $eVG6Y.ArtifactsExperienceManifest),
    (0, $dWoVg.AvpvizExperienceManifest),
    (0, $1NFwk.DBEntryExperienceManifest),
    (0, $99TtX.DBExperienceManifest),
    (0, $9F0bu.MauiExperienceManifest),
    (0, $7tMWI.PageExperienceManifest),
    (0, $8iBLq.SlideExperienceManifest),
    // MauiWhiteboardExperienceManifest must come before WhiteboardExperienceManifest
    // so its more specific isUrlMatch (requiring isRemixDiagram=true) is checked first.
    (0, $85cI7.MauiWhiteboardExperienceManifest),
    (0, $aaqIB.WhiteboardExperienceManifest)
];
const $ab76b84281e6545b$var$gatedExperiences = $ab76b84281e6545b$var$allExperiences.map((experience)=>({
        ...experience,
        isUrlMatch: (url)=>{
            if ($ab76b84281e6545b$var$mauiExperienceIds.has(experience.id)) return (0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && experience.isUrlMatch(url);
            // Feature-flag names must remain static literals for static feature-flag tooling.
            return ((0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience') || (0, $iDrrr.fg)('platform_native_embeds_rollout_all_products') || (0, $iDrrr.fg)('platform_native_embeds_rollout_jira_non_maui')) && experience.isUrlMatch(url);
        }
    }));
// Register all experience manifests at module-load time.
// This is intentionally module-level (not inside a React lifecycle) because the
// facade must be available before any child embed loads.
(0, $iwIwp.getNativeEmbedFacade)().setup({
    experiences: $ab76b84281e6545b$var$gatedExperiences
});

const $ab76b84281e6545b$var$createRenderFn = (isPublishedPage, api, renderOverlay, analyticsPageContext)=>async ()=>{
        const { default: Ui } = await (parcelRequire("jOx93"));
        return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Ui, {
                ...props,
                api: api,
                isPublishedPage: isPublishedPage,
                renderOverlay: renderOverlay,
                analyticsPageContext: analyticsPageContext
            });
    };
const $ab76b84281e6545b$export$622e7486b3a76ca4 = (isPublishedPage, api, cardClient, renderOverlay, analyticsPageContext)=>{
    // Wire up the CardClient for short-link URL resolution when provided.
    // This is a separate call from setup() because the CardClient may not be
    // available at module-load time when setup() is called.
    if (cardClient) (0, $iwIwp.getNativeEmbedFacade)().setCardClient(cardClient);
    return {
        title: 'Native Embed',
        type: (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE),
        key: (0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY),
        description: 'Embed native Atlassian content',
        modules: {
            nodes: {
                default: {
                    type: 'extension',
                    render: $ab76b84281e6545b$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                    // @ts-expect-error This option is experimental and not reflected in the manifest type definition
                    __hideFrame: true
                },
                ...Object.fromEntries((0, $iwIwp.getNativeEmbedFacade)().getAllExperienceIds().map((experienceId)=>[
                        experienceId,
                        {
                            type: 'extension',
                            render: $ab76b84281e6545b$var$createRenderFn(isPublishedPage, api, renderOverlay, analyticsPageContext),
                            __hideFrame: true
                        }
                    ]))
            }
        }
    };
};
module.exports["createManifest"] = $ab76b84281e6545b$export$622e7486b3a76ca4;

});

parcelRegister("eVG6Y", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $206E4 = parcelRequire("206E4");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $iPlb2 = parcelRequire("iPlb2");


var $17Umy = parcelRequire("17Umy");


var $f67nD = parcelRequire("f67nD");

const $df8c795159f25904$var$ArtifactsEmbedIcon = ({ label: label, testId: testId })=>/*#__PURE__*/ $cozmU.createElement((0, $206E4.ArtifactsIcon), {
        label: label,
        size: "24",
        testId: testId
    });
$df8c795159f25904$var$ArtifactsEmbedIcon.displayName = 'ArtifactsEmbedIcon';
const $df8c795159f25904$var$artifactsIcons = [
    $df8c795159f25904$var$ArtifactsEmbedIcon
];
const $df8c795159f25904$var$UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'; /**
                                                                                             * Claims Artifacts app URLs in either of two forms:
                                                                                             *
                                                                                             *   `<host>/artifacts/<artifactId>/*`
                                                                                             *   `<host>/apps/<installationId>/<artifactId>/*?smartlink=artifact`
                                                                                             *
                                                                                             * Only the path and query components participate in matching. The URL origin
                                                                                             * and fragment are intentionally ignored.
                                                                                             */ 
const $df8c795159f25904$var$ARTIFACT_URL_PATTERNS = [
    new RegExp(`/artifacts/${$df8c795159f25904$var$UUID}(?:[/?#].*)?$`),
    new RegExp(`/apps/${$df8c795159f25904$var$UUID}/${$df8c795159f25904$var$UUID}/[^?#]*\\?(?:[^#]*&)?smartlink=artifact`)
];
const $df8c795159f25904$var$isArtifactsUrl = (url)=>// Gated behind the Forge UI artifact Confluence integration flag: the Artifacts
    // experience only claims URLs when the flag is enabled.
    (0, $iDrrr.fg)('platform_forge_ui_artifact_confluence_integration') && $df8c795159f25904$var$ARTIFACT_URL_PATTERNS.some((pattern)=>pattern.test(url)); /**
                                                                                                                      * Experience manifest for an Artifacts embed.
                                                                                                                      * Registered via `getNativeEmbedFacade().setup({ experiences: [...] })` in
                                                                                                                      * `@atlassian/native-embeds-editor-extension`.
                                                                                                                      */ 
const $df8c795159f25904$export$d40f5b752a00056c = {
    id: (0, $f67nD.ARTIFACTS_EXPERIENCE_MANIFEST_ID),
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $df8c795159f25904$var$isArtifactsUrl,
    isActive: ()=>true,
    // Route through the Smart Card / linking-platform resolver so the embed renders
    // via `<Card appearance="embed">` (EmbedFrameWrapper uses `useBasicIframe: false`).
    // Requires the Object Resolver Service to resolve Artifacts share URLs and return a
    // `preview`. Set to `false` to render a basic iframe directly from `transformUrl`.
    resolveViaLinkingPlatform: true,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures)
    ]),
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // Identifies the native embed view to the Artifacts app.
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    uiConfig: {
        // Header edit button intentionally disabled for now. Re-add an `editButton`
        // entry here (using `swapArtifactsRoute`) to restore the inline edit flow.
        headerControls: {},
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>(0, $iDrrr.fg)('platform_forge_ui_artifact_confluence_integration') ? /*#__PURE__*/ $cozmU.createElement((0, $17Umy.ArtifactsLoadingOverlay), props) : /*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $df8c795159f25904$var$artifactsIcons,
                testId: props.testId
            }),
        titleIcon: $df8c795159f25904$var$ArtifactsEmbedIcon,
        // Use the linking-platform-resolved icon (the artifact's own icon) in the
        // header, falling back to ArtifactsEmbedIcon until it resolves.
        useResolvedTitleIcon: true,
        appearance: 'overlay',
        waitForContentReady: false
    }
};
module.exports["ArtifactsExperienceManifest"] = $df8c795159f25904$export$d40f5b752a00056c;

});

parcelRegister("hjJUc", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d31de4816ebba09$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");


var $bJ0qH = parcelRequire("bJ0qH");


var $39SCI = parcelRequire("39SCI");

function $3d31de4816ebba09$export$2e2bcd8739ae039(props) {
    if (props.variant === 'simple-bar') {
        const { variant: _variant, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39SCI.default), rest);
    }
    const { variant: _variant, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bJ0qH.default), rest);
}

});

parcelRegister("bJ0qH", function(module, exports) {
$parcel$export(module.exports, "default", () => $5675a156d46f0f78$export$2e2bcd8739ae039);
/* icon-carousel-variant.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $g3Ghj = parcelRequire("g3Ghj");


var $bUupk = parcelRequire("bUupk");


var $7lIlR = parcelRequire("7lIlR");


var $cr8hb = parcelRequire("cr8hb");

const $5675a156d46f0f78$var$containerStyles = null;
const $5675a156d46f0f78$var$innerStyles = null;
const $5675a156d46f0f78$var$progressBarWrapperStyles = null;
const $5675a156d46f0f78$var$defaultIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
function $5675a156d46f0f78$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId }) {
    const progress = (0, $cr8hb.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0KLXrunmFW"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $7lIlR.default), {
        animationDisabled: animationDisabled,
        icons: icons ?? $5675a156d46f0f78$var$defaultIcons,
        testId: testId ? `${testId}--${0, $g3Ghj.SLIDE_MORPH_TEST_ID_SUFFIX}` : undefined,
        cycleDirection: "right"
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02lyjw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bUupk.default), {
        ariaLabel: "Loading",
        testId: testId ? `${testId}--${0, $g3Ghj.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    }))));
}

});

parcelRegister("h5uPL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::85bf979e8232abe8de3866571ef3fc76>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c70ad24a32d9055c$var$_react = $c70ad24a32d9055c$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c70ad24a32d9055c$var$_iconNew = $c70ad24a32d9055c$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $c70ad24a32d9055c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sticker".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/sticker
 * Usage guidance:
 * Used for sticker tool in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c70ad24a32d9055c$var$StickerIcon = (props)=>/*#__PURE__*/ $c70ad24a32d9055c$var$_react.default.createElement($c70ad24a32d9055c$var$_iconNew.default, Object.assign({
        name: "StickerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-1.998 12.687L6 14c0-1.102.223-2.153.627-3.11a8 8 0 0 1 7.56-4.888A6.5 6.5 0 0 0 8 1.5m5.413 6.026a6.5 6.5 0 0 0-5.404 3.947 6.5 6.5 0 0 0-.483 1.94zM0 8a8 8 0 0 1 15.899-1.277.75.75 0 0 1-.21.65l-8.317 8.315a.75.75 0 0 1-.649.21A8 8 0 0 1 0 8" clip-rule="evenodd"/>`
    }, props));
$c70ad24a32d9055c$var$StickerIcon.displayName = 'StickerIcon';
var $c70ad24a32d9055c$var$_default = module.exports.default = $c70ad24a32d9055c$var$StickerIcon;

});

parcelRegister("g3Ghj", function(module, exports) {
const $f9469b1871c63b69$export$422c871edd75db5 = 'progress-bar';
const $f9469b1871c63b69$export$eb09afb535a4cb18 = 'slide-morph';
const $f9469b1871c63b69$export$7442c4c7574447bc = 50;
module.exports["PROGRESS_BAR_TEST_ID_SUFFIX"] = $f9469b1871c63b69$export$422c871edd75db5;
module.exports["SLIDE_MORPH_TEST_ID_SUFFIX"] = $f9469b1871c63b69$export$eb09afb535a4cb18;
module.exports["STATIC_PROGRESS_VALUE"] = $f9469b1871c63b69$export$7442c4c7574447bc;

});

parcelRegister("bUupk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e9ce3cf2ba109470$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $e9ce3cf2ba109470$var$MIN_VALUE = 0;
const $e9ce3cf2ba109470$var$MAX_VALUE = 100;
const $e9ce3cf2ba109470$var$containerStyles = null;
const $e9ce3cf2ba109470$var$barStyles = null; /**
                         * This is a progress bar component that was built to match the atlaskit component `@atlaskit/progress-bar`.
                         * We couldn't use the atlaskit component due to the colour requirements for this progress bar not being supported,
                         * hence, a custom component was required.
                         */ 
function $e9ce3cf2ba109470$export$2e2bcd8739ae039({ ariaLabel: ariaLabel, testId: testId, value: value = 0 }) {
    const valueParsed = Math.max($e9ce3cf2ba109470$var$MIN_VALUE, Math.min(value, $e9ce3cf2ba109470$var$MAX_VALUE));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        role: "progressbar",
        "aria-label": ariaLabel,
        "aria-valuemin": $e9ce3cf2ba109470$var$MIN_VALUE,
        "aria-valuenow": valueParsed,
        "aria-valuemax": $e9ce3cf2ba109470$var$MAX_VALUE,
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VZimw _1mT5xdRAKS _0KLXruDMqu"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        style: {
            width: `${valueParsed}%`
        },
        "data-testid": `${testId}--progress-value-bar`,
        className: (0, $hekY6.default)([
            "_0bjKvDS5Zs _23rrnHUdC3 _3iDTPbvLZJ _0jFU0VZimw _1mT5xdWVPG _0KLXruXljP"
        ])
    }));
}

});

parcelRegister("7lIlR", function(module, exports) {
$parcel$export(module.exports, "default", () => $948620dedd13543d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9NPFC = parcelRequire("9NPFC");


var $kVbnn = parcelRequire("kVbnn");


var $fEVaZ = parcelRequire("fEVaZ");

// so we override the background via a wrapper targeting the tile's root <span>.
const $948620dedd13543d$var$tileWrapperStyles = null;
function $948620dedd13543d$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, testId: testId, cycleDirection: cycleDirection = 'right' }) {
    const iconsWithProps = icons.map((Icon)=>(props)=>/*#__PURE__*/ $cozmU.createElement(Icon, {
                color: "var(--ds-icon-subtle, #505258)",
                ...props
            }));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_0FoN3I7Cj1"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        label: "",
        backgroundColor: "color.background.neutral",
        hasBorder: true,
        size: "xlarge",
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $fEVaZ.default), {
        animationDisabled: animationDisabled,
        icons: iconsWithProps,
        cycleDirection: cycleDirection,
        testId: testId ? `${testId}--${0, $kVbnn.ICON_CYCLER_TEST_ID_SUFFIX}` : undefined
    })));
}

});

parcelRegister("kVbnn", function(module, exports) {
const $b041427678c4fb7b$export$a87bbf852b8799e2 = 'icon-cycler';
module.exports["ICON_CYCLER_TEST_ID_SUFFIX"] = $b041427678c4fb7b$export$a87bbf852b8799e2;

});

parcelRegister("fEVaZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $fded74c4bd3b5f47$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $fded74c4bd3b5f47$var$ICON_CYCLE_DELAY_MS = 900;
const $fded74c4bd3b5f47$var$ICON_CYCLE_TRANSITION_MS = 400;
const $fded74c4bd3b5f47$var$ICON_CYCLE_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
const $fded74c4bd3b5f47$var$enteringAnimations = {
    left: "_1mT5xdRAKS _1gBibyJfTW",
    right: "_1mT5xdRAKS _1gBibyn5Jh"
};
const $fded74c4bd3b5f47$var$exitingAnimations = {
    left: "_1mT5xdWVPG _1gBibyGowt",
    right: "_1mT5xdWVPG _1gBiby958d"
};
const $fded74c4bd3b5f47$var$commonAnimationStyles = null;
const $fded74c4bd3b5f47$var$containerStyles = null;
const $fded74c4bd3b5f47$var$iconSlotStyles = null; /**
                              * Cycles through a list of icon components with a vertical slide transition.
                              *
                              * Each icon is shown for ICON_CYCLE_DELAY_MS, then the current icon slides
                              * out upward while the next icon slides in from below over ICON_CYCLE_TRANSITION_MS.
                              */ 
function $fded74c4bd3b5f47$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, icons: icons, cycleDirection: cycleDirection = 'left', testId: testId }) {
    const [currentIndex, setCurrentIndex] = (0, $cozmU.useState)(0);
    const [isTransitioning, setIsTransitioning] = (0, $cozmU.useState)(false);
    const timerRef = (0, $cozmU.useRef)(null);
    const nextIndex = (currentIndex + 1) % icons.length;
    const scheduleNextTransition = (0, $cozmU.useCallback)(()=>{
        timerRef.current = setTimeout(()=>{
            setIsTransitioning(true);
        }, $fded74c4bd3b5f47$var$ICON_CYCLE_DELAY_MS);
    }, []);
    const handleAnimationEnd = (0, $cozmU.useCallback)(()=>{
        setIsTransitioning(false);
        setCurrentIndex((prev)=>(prev + 1) % icons.length);
    }, [
        icons.length
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled || icons.length <= 1) return;
        if (!isTransitioning) scheduleNextTransition();
        return ()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        };
    }, [
        animationDisabled,
        icons.length,
        isTransitioning,
        scheduleNextTransition
    ]);
    if (icons.length === 0) return null;
    const CurrentIcon = icons[currentIndex];
    const NextIcon = icons[nextIndex];
    if (animationDisabled || icons.length === 1 || !isTransitioning) return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CurrentIcon, {
        label: ""
    })));
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            "_0nFVCGpFbM _43vdfTBhmJ _3Y6bKpgRhm",
            $fded74c4bd3b5f47$var$exitingAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $cozmU.createElement(CurrentIcon, {
        label: ""
    })), /*#__PURE__*/ $cozmU.createElement("div", {
        onAnimationEnd: handleAnimationEnd,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
            "_0nFVCGpFbM _43vdfTBhmJ _3Y6bKpgRhm",
            $fded74c4bd3b5f47$var$enteringAnimations[cycleDirection]
        ])
    }, /*#__PURE__*/ $cozmU.createElement(NextIcon, {
        label: ""
    })));
}

});

parcelRegister("cr8hb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $g3Ghj = parcelRequire("g3Ghj");

function $e3f0b09e8c39256e$export$966e81c93dd9c110(animationDisabled) {
    const [progress, setProgress] = (0, $cozmU.useState)(animationDisabled ? (0, $g3Ghj.STATIC_PROGRESS_VALUE) : 0);
    (0, $cozmU.useEffect)(()=>{
        if (animationDisabled) return;
        const interval = setInterval(()=>{
            setProgress((prev)=>{
                if (prev < 10) return prev + 10;
                if (prev < 60) return prev + 35;
                if (prev < 90) return prev + 10;
                return prev;
            });
        }, 1000);
        return ()=>clearInterval(interval);
    }, [
        animationDisabled
    ]);
    return progress;
}
module.exports["useFakeProgress"] = $e3f0b09e8c39256e$export$966e81c93dd9c110;

});

parcelRegister("39SCI", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f0a885121af4f63$export$2e2bcd8739ae039);
/* simple-bar-variant.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $g3Ghj = parcelRequire("g3Ghj");


var $bUupk = parcelRequire("bUupk");


var $cr8hb = parcelRequire("cr8hb");

const $4f0a885121af4f63$var$messages = (0, $kSwu1.defineMessages)({
    loadingLabel: {
        id: "native-embeds-core.common.loading-overlay.simple-bar-variant.loadingLabel",
        defaultMessage: "Loading"
    }
});
const $4f0a885121af4f63$var$containerStyles = null;
const $4f0a885121af4f63$var$blanketStyles = null;
const $4f0a885121af4f63$var$progressBarWrapperStyles = null;
function $4f0a885121af4f63$export$2e2bcd8739ae039({ animationDisabled: animationDisabled = false, showBlanket: showBlanket = false, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const progress = (0, $cr8hb.useFakeProgress)(animationDisabled);
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _3iDTPbQ4SZ _0hPCNLz9WS _37wbyuDIqT _0xmtko8HPE _0KLXrunmFW _42Yu6B7dHp"
        ])
    }, showBlanket && /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_49OCfRdnbC _1mT5xdWVPG _0KLXruA5lS"
        ])
    }), /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_39xV02wOVE _1mT5xdRAKS _42Yu6B7dHp"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $bUupk.default), {
        ariaLabel: formatMessage($4f0a885121af4f63$var$messages.loadingLabel),
        testId: testId ? `${testId}--${0, $g3Ghj.PROGRESS_BAR_TEST_ID_SUFFIX}` : undefined,
        value: progress
    })));
}

});

parcelRegister("1xINT", function(module, exports) {

var $gqUuL = parcelRequire("gqUuL");


var $fcaWu = parcelRequire("fcaWu");

const $d5e4138f0844ba8b$export$6f4b285026a87b72 = ()=>{
    const theme = (0, $gqUuL.getGlobalTheme)();
    if (Object.keys(theme).length === 0) return undefined;
    return (0, $fcaWu.themeObjectToString)(theme);
};
module.exports["getInitialThemeParam"] = $d5e4138f0844ba8b$export$6f4b285026a87b72;

});

parcelRegister("iPlb2", function(module, exports) {
/**
 * Core features that are supported by all native embeds.
 *
 * All native embed must either support the feature or respond in
 * the feature handshake that its not supported.
 */ const $9ebc30870bad8c95$export$189dc4df3d8f1369 = {
    /** When agreed, the parent sends selected-change events to the child when the embed's selection state changes. */ SelectedChange: 'selected-change',
    /** When agreed, the parent sends view-mode-change events to the child when the embed switches between regular and maximize (e.g. full screen). */ ViewModeChange: 'view-mode-change',
    /** When agreed, the parent sends header-visibility-change events to the child when the host native embed controls/chrome visibility changes. */ HeaderVisibilityChange: 'header-visibility-change',
    /** When agreed, the child captures click events and notifies the host via the bridge. */ NotifyHostClick: 'notify-host-click',
    /** When agreed, the child can request the host to toggle the full-screen dialog. */ ToggleFullScreen: 'toggle-full-screen',
    /**
	 * When agreed, the child can request the host to resize the embed container. */ RequestResize: 'request-resize',
    /**
	 * When agreed, the host sends `on-full-screen-changed` events to the child whenever
	 * the inline full-screen preview opens or closes WITHOUT remounting the iframe.
	 *
	 * This handshake is only ever negotiated when the host runs the shared-iframe
	 * code path (i.e. `Element.prototype.moveBefore` is supported). On any other
	 * host path the embed is torn down and re-created across the full-screen
	 * toggle, so a child has no need for this event.
	 */ NoRefreshFullScreenPreview: 'no-refresh-full-screen-preview',
    /**
	 * When agreed, the child sends a `content-ready` event to the host once its
	 * content is fully rendered and visible to the user. The host holds its own
	 * loading overlay visible until this event fires (or a safety timeout elapses),
	 * preventing a flash of the child's internal loading state between the iframe
	 * `load` event and the child's first painted frame.
	 *
	 * Only negotiated for embed types that set `waitForContentReady: true` in their
	 * `uiConfig`.
	 */ ContentReady: 'content-ready'
};
const $9ebc30870bad8c95$export$75135a796fe6e3e2 = Object.values($9ebc30870bad8c95$export$189dc4df3d8f1369);
module.exports["NativeEmbedCoreFeature"] = $9ebc30870bad8c95$export$189dc4df3d8f1369;
module.exports["allNativeEmbedCoreFeatures"] = $9ebc30870bad8c95$export$75135a796fe6e3e2;

});

parcelRegister("17Umy", function(module, exports) {
/* artifacts-loading-overlay.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $206E4 = parcelRequire("206E4");

const $6e91acaebdb4574d$var$messages = (0, $kSwu1.defineMessages)({
    loading: {
        id: "native-embeds-artifacts-experience.artifacts-loading-overlay.loading",
        defaultMessage: "Loading Artifacts"
    }
});
// Match Forge Gateway's LogoLoader, which remains visible inside the iframe after load.
// Compiled provides keyframes; the rest of the styling uses the ADS CSS API.
const $6e91acaebdb4574d$var$pulse = null;
const $6e91acaebdb4574d$var$styles = {
    container: "_49OCfRdnbC _1mT5xdWVPG _0KLXrulfZc _42Yu6B7dHp",
    logo: "_1mT5xdWVPG _2IhTon715P _3OE6xY715P _39xV02Uofl _0jFU0VUofl _1VJPcaEK1G",
    animated: "_1gBibyYcFF _0nFVCGFSlo _43vdfTN8t6 _03m2nySHWH _0LqqFdYbGa"
};
function $6e91acaebdb4574d$export$caa57a40130134b8({ animationDisabled: animationDisabled = false, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": testId,
        role: "status",
        className: (0, $hekY6.default)([
            $6e91acaebdb4574d$var$styles.container
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $6e91acaebdb4574d$var$styles.logo,
            !animationDisabled && $6e91acaebdb4574d$var$styles.animated
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $206E4.ArtifactsIcon), {
        label: formatMessage($6e91acaebdb4574d$var$messages.loading),
        size: "32"
    })));
}
module.exports["ArtifactsLoadingOverlay"] = $6e91acaebdb4574d$export$caa57a40130134b8;

});

parcelRegister("f67nD", function(module, exports) {

var $8fPlA = parcelRequire("8fPlA");

const $abb3595e1b1957dc$export$9721a12c6baf7e39 = (0, $8fPlA.experienceManifestId)('artifacts');
module.exports["ARTIFACTS_EXPERIENCE_MANIFEST_ID"] = $abb3595e1b1957dc$export$9721a12c6baf7e39;

});

parcelRegister("8fPlA", function(module, exports) {
const $63ee794f4378af50$export$32c943c51c185af3 = (s)=>s;
module.exports["experienceManifestId"] = $63ee794f4378af50$export$32c943c51c185af3;

});

parcelRegister("dWoVg", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $gJ798 = parcelRequire("gJ798");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $1xINT = parcelRequire("1xINT");


var $iPlb2 = parcelRequire("iPlb2");


var $051UC = parcelRequire("051UC");


var $APSqQ = parcelRequire("APSqQ");


var $6fkvA = parcelRequire("6fkvA");


var $kljdr = parcelRequire("kljdr");

const $9f7493673e5a94a1$var$UUID = '[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}';
const $9f7493673e5a94a1$var$AVPVIZ_CHART_URL_PATTERN = new RegExp(`/(?:avpviz|dashboards)/c/${$9f7493673e5a94a1$var$UUID}/w/${$9f7493673e5a94a1$var$UUID}/d/${$9f7493673e5a94a1$var$UUID}/(?:chart|widget)/${$9f7493673e5a94a1$var$UUID}/?(?:[?#].*)?$`);
const $9f7493673e5a94a1$var$isAvpvizChartUrl = (url)=>(0, $iDrrr.fg)('platform_avp_viz_confluence_native_embed') && $9f7493673e5a94a1$var$AVPVIZ_CHART_URL_PATTERN.test(url); /**
                                                                                                                                          * Experience manifest for a shared AVPViz chart.
                                                                                                                                          *
                                                                                                                                          * This claims only canonical shared chart URLs while its rollout gate is enabled.
                                                                                                                                          * The linking-platform resolver supplies the title and preview used by the host overlay.
                                                                                                                                          */ 
const $9f7493673e5a94a1$export$c3e28fef372cacbf = {
    id: (0, $kljdr.AVPVIZ_EXPERIENCE_MANIFEST_ID),
    enforceQueryParams: true,
    queryParams: {
        nativeEmbedView: 'true',
        hideBorder: 'true'
    },
    handleChildCommands: (_experience, _command)=>{},
    isUrlMatch: $9f7493673e5a94a1$var$isAvpvizChartUrl,
    isActive: ()=>true,
    resolveViaLinkingPlatform: true,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures),
        (0, $6fkvA.DATA_FETCH_FEATURE)
    ]),
    transformUrl: (url)=>{
        const urlObj = new URL(url);
        urlObj.searchParams.set('hideBorder', 'true');
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    uiConfig: {
        headerControls: {
            hideTitle: true,
            renderBeforeActions: (context)=>/*#__PURE__*/ $cozmU.createElement((0, $APSqQ.DataFetchControlLoader), {
                    key: "avpviz-data-fetch",
                    context: context
                })
        },
        showBorder: false,
        frameElevation: 'raised',
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $051UC.ChartLoading), props),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gJ798))),
        useResolvedTitleIcon: true,
        appearance: 'overlay'
    }
};
module.exports["AvpvizExperienceManifest"] = $9f7493673e5a94a1$export$c3e28fef372cacbf;

});

parcelRegister("051UC", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $84YHF = parcelRequire("84YHF");

const $2e254595b1730971$var$BAR_HEIGHTS = [
    '15%',
    '40%',
    '60%',
    '35%',
    '80%',
    '50%',
    '25%'
];
const $2e254595b1730971$var$styles = {
    container: "_49OCfRdnbC _2mHwu88HPE _4c065UNHnM _2Y7lL4NHnM _1mT5xdWVPG _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _24h04i2Njc",
    plot: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLz9WS _2O5Vij7dHp _4kiQYAdnbC"
}; // Match avp/services/viz/src/components/ChartSkeleton.tsx so the iframe handoff does not jump.
function $2e254595b1730971$export$54cd1f09c6562ed4({ animationDisabled: animationDisabled = false, testId: testId }) {
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2e254595b1730971$var$styles.container,
        testId: testId,
        role: "progressbar",
        "aria-label": intl.formatMessage((0, $84YHF.default).loading)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "55%",
        height: "16px",
        isShimmering: !animationDisabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
        width: "35%",
        height: "12px",
        isShimmering: !animationDisabled
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2e254595b1730971$var$styles.plot
    }, $2e254595b1730971$var$BAR_HEIGHTS.map((height)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            key: height,
            width: "100%",
            height: height,
            isShimmering: !animationDisabled
        }))));
}
module.exports["ChartLoading"] = $2e254595b1730971$export$54cd1f09c6562ed4;

});

parcelRegister("84YHF", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $946a7725bafd8ae2$var$messages = (0, $kSwu1.defineMessages)({
    loading: {
        id: "native-embeds-avpviz-experience.chart-loading.loading",
        defaultMessage: "Loading chart"
    }
});
var $946a7725bafd8ae2$export$2e2bcd8739ae039 = $946a7725bafd8ae2$var$messages;
module.exports["default"] = $946a7725bafd8ae2$export$2e2bcd8739ae039;

});

parcelRegister("APSqQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6fkvA = parcelRequire("6fkvA");


var $9soEG = parcelRequire("9soEG");


var $7oSFe = parcelRequire("7oSFe");


const $68dfff91b3efb8dc$var$DataFetchControl = /*#__PURE__*/ (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-dVyhVv", ()=>(parcelRequire("454yA")).then(({ DataFetchControl: Control })=>({
            default: Control
        }))));
function $68dfff91b3efb8dc$export$f867216d9f21fe02({ context: context }) {
    const [isSupported, setSupported] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setSupported(false);
        let active = true;
        (0, $9soEG.waitForChannelFeature)(context, (0, $6fkvA.DATA_FETCH_FEATURE)).then((isAgreed)=>{
            if (active && isAgreed) setSupported(true);
        });
        return ()=>{
            active = false;
        };
    }, [
        context
    ]);
    if (!isSupported) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($68dfff91b3efb8dc$var$DataFetchControl, {
        context: context
    }));
}
module.exports["DataFetchControlLoader"] = $68dfff91b3efb8dc$export$f867216d9f21fe02;

});

parcelRegister("6fkvA", function(module, exports) {
/** Versioned, experience-specific contract shared by the host toolbar and Bifrost. */ const $689d776b80be738c$export$5f6fb5a569dae094 = 'avpviz-data-fetch-v1';
const $689d776b80be738c$export$cce5500a87bf39e1 = 'avpviz:data-fetch';
const $689d776b80be738c$export$d039c3e3dcef8d1 = 'avpviz:data-fetch-state';
function $689d776b80be738c$export$782a962ac4ec75a6(value) {
    return value === 'STATIC' || value === 'DYNAMIC';
}
function $689d776b80be738c$export$34a0f66872eb4b34(value) {
    if (!value || typeof value !== 'object') return false;
    const command = value;
    return command.type === $689d776b80be738c$export$cce5500a87bf39e1 && typeof command.sessionId === 'string' && command.sessionId.length > 0 && (command.action === 'connect' || command.action === 'disconnect' || command.action === 'set' && $689d776b80be738c$export$782a962ac4ec75a6(command.strategy));
}
function $689d776b80be738c$export$7495b2fc7fbc23fc(value) {
    if (!value || typeof value !== 'object') return false;
    const state = value;
    return state.type === $689d776b80be738c$export$d039c3e3dcef8d1 && typeof state.sessionId === 'string' && $689d776b80be738c$export$782a962ac4ec75a6(state.requestedStrategy) && (state.displayedStrategy === null || $689d776b80be738c$export$782a962ac4ec75a6(state.displayedStrategy)) && Array.isArray(state.availableStrategies) && state.availableStrategies.every($689d776b80be738c$export$782a962ac4ec75a6) && [
        'loading',
        'ready',
        'error'
    ].includes(String(state.status)) && typeof state.isSaving === 'boolean' && (state.error === null || state.error === 'save-failed' || state.error === 'fetch-failed');
}
module.exports["DATA_FETCH_FEATURE"] = $689d776b80be738c$export$5f6fb5a569dae094;
module.exports["DATA_FETCH_COMMAND"] = $689d776b80be738c$export$cce5500a87bf39e1;
module.exports["isDataFetchState"] = $689d776b80be738c$export$7495b2fc7fbc23fc;

});

parcelRegister("9soEG", function(module, exports) {
function $b7869a325b53d497$export$4ab0b77c7c67ad3(context, feature) {
    if (!context.supportedFeatures || !context.onChildCommand) return Promise.resolve(false);
    return context.supportedFeatures.then((features)=>features.has(feature));
}
module.exports["waitForChannelFeature"] = $b7869a325b53d497$export$4ab0b77c7c67ad3;

});

parcelRegister("454yA", function(module, exports) {

let $2f8b29f32b86ab54$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2f8b29f32b86ab54$var$load("6wr18"),
    $2f8b29f32b86ab54$var$load("kmE76"),
    $2f8b29f32b86ab54$var$load("ffEVr"),
    $2f8b29f32b86ab54$var$load("jgaRb"),
    $2f8b29f32b86ab54$var$load("04IbP")
]).then(()=>parcelRequire('cNaCj'));

});

parcelRegister("kljdr", function(module, exports) {

var $8fPlA = parcelRequire("8fPlA");

const $b14058f365e47627$export$9000ddb06e520b63 = (0, $8fPlA.experienceManifestId)('avpviz');
module.exports["AVPVIZ_EXPERIENCE_MANIFEST_ID"] = $b14058f365e47627$export$9000ddb06e520b63;

});

parcelRegister("iwIwp", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6Iq0g = parcelRequire("6Iq0g");


var $h2POc = parcelRequire("h2POc");

/**
 * Matches Confluence short-link URLs of the form /wiki/x/<token>.
 * These URLs do not map to a specific experience until resolved via ORS.
 */ const $3b2da6bf08d8f744$var$CONFLUENCE_SHORT_LINK_PATTERN = /\/wiki\/x\/[^/]+/;
let $3b2da6bf08d8f744$var$nativeEmbedFacade;
function $3b2da6bf08d8f744$export$31739795deb20347() {
    if (!$3b2da6bf08d8f744$var$nativeEmbedFacade) $3b2da6bf08d8f744$var$nativeEmbedFacade = new $3b2da6bf08d8f744$export$3aace7af5e09b157((0, $6Iq0g.getExperienceManifestRegistry)(), (0, $h2POc.getSurfaceService)());
    return $3b2da6bf08d8f744$var$nativeEmbedFacade;
}





class $3b2da6bf08d8f744$export$3aace7af5e09b157 {
    /**
   * Registers an experience manifest so it can be matched by URL via {@link resolveManifestForUrl}.
   */ registerExperienceManifest(manifest) {
        this.experienceManifestRegistry.registerExperienceManifest(manifest);
    }
    /**
   * One-shot convenience method that registers experience manifests and
   * optionally configures the host surface in a single call.
   *
   * Prefer `setup()` over calling `registerExperienceManifest` /
   * `setSurface` individually — it makes the configuration declarative,
   * validates inputs eagerly, and guards against accidental double-setup.
   *
   * The low-level methods remain available for advanced use cases
   * (conditional registration, dynamic surface changes, etc.).
   *
   * @param config - The setup configuration.
   * @param config.experiences - Non-empty array of experience manifests to register.
   * @param config.surface - Optional surface configuration.
   *
   * Logs a warning and returns early if `setup()` has already been called.
   *
   * @example
   * ```ts
   * import { getNativeEmbedFacade } from '@atlassian/native-embeds-core';
   *
   * getNativeEmbedFacade().setup({
   *   experiences: [WhiteboardExperienceManifest, DBExperienceManifest],
   * });
   * ```
   */ setup(config) {
        if (this.isSetUp) {
            // eslint-disable-next-line no-console
            console.warn("NativeEmbedFacade.setup() has already been called. This call will be ignored. Use the low-level registerExperienceManifest() and setSurface() methods if you need to modify configuration after initial setup.");
            return;
        }
        for (const manifest of config.experiences)this.registerExperienceManifest(manifest);
        if (config.surface) this.setSurface(config.surface);
        if (config.cardClient) this.cardClient = config.cardClient;
        this.isSetUp = true;
    }
    /**
   * Sets the {@link CardClient} instance used for short-link URL resolution.
   *
   * This is useful when the `CardClient` is not available at the time `setup()`
   * is called (e.g. when the facade is initialised at module-load time before
   * the card provider is ready). Calling this after `setup()` replaces any
   * previously configured client.
   *
   * @param cardClient - The CardClient instance to use for ORS requests.
   */ setCardClient(cardClient) {
        this.cardClient = cardClient;
    }
    /**
   * Synchronous function that verifies if the URL matches any registered experience, and returns the experience ID if it does.
   * @param url - The URL to get the experience from.
   * @returns
   */ getExperienceIdFromUrl(url) {
        return this.experienceManifestRegistry.getExperienceIdFromUrl(url);
    }
    /**
   * Async variant of {@link getExperienceIdFromUrl} that handles Confluence
   * short-link URLs (e.g. `/wiki/x/<token>`).
   *
   * When the URL is a Confluence short link and a `cardClient` has been
   * configured (via `setup({ cardClient })` or `setCardClient()`), this method
   * resolves the short link to its canonical URL via the Object Resolver
   * Service and then matches the expanded URL against registered experience
   * manifests.
   *
   * Falls back to the synchronous {@link getExperienceIdFromUrl} for all
   * non-short-link URLs, or when no `cardClient` is available.
   *
   * @param url - The URL to resolve and match.
   * @returns The matched experience manifest ID, or `undefined` if no match.
   */ async getExperienceIdFromUrlAsync(url) {
        // Fast path: direct synchronous match (works for all non-short-link URLs)
        const syncResult = this.experienceManifestRegistry.getExperienceIdFromUrl(url);
        if (syncResult) return syncResult;
        // Expand Confluence short links via ORS when a cardClient is available
        const expandedUrl = await this.expandShortLink(url);
        if (!expandedUrl) return undefined;
        return this.experienceManifestRegistry.getExperienceIdFromUrl(expandedUrl);
    }
    /**
   * If `url` is a Confluence short link and a `cardClient` is configured,
   * resolves it to its canonical expanded URL via the Object Resolver Service.
   *
   * Returns `undefined` when:
   * - both native embed rollout gates (`platform_native_embeds_rollout_non_maui_experience` and
   *   `platform_native_embeds_rollout_all_products`) are off,
   * - the URL is not a short link,
   * - no `cardClient` is available, or
   * - resolution fails or returns the same URL.
   */ async expandShortLink(url) {
        if (!((0, $iDrrr.fg)('platform_native_embeds_rollout_non_maui_experience') || (0, $iDrrr.fg)('platform_native_embeds_rollout_all_products'))) return undefined;
        const isShortLink = $3b2da6bf08d8f744$var$CONFLUENCE_SHORT_LINK_PATTERN.test(url);
        if (!isShortLink || !this.cardClient) return undefined;
        try {
            const response = await this.cardClient.fetchData(url);
            const data = response?.data;
            if (!data || typeof data !== 'object') return undefined;
            const resolvedUrl = data['url'];
            if (typeof resolvedUrl === 'string' && resolvedUrl !== url) return resolvedUrl;
            // url can also be an object with an @id (JsonLd Link type)
            if (resolvedUrl && typeof resolvedUrl === 'object') {
                const id = resolvedUrl['@id'];
                if (typeof id === 'string' && id !== url) return id;
            }
        } catch  {
        // Short-link expansion is best-effort; fall through to return undefined.
        }
        return undefined;
    }
    /**
   * Synchronous function that returns the manifest for a URL if it matches any registered experience.
   * Uses `isUrlMatch` to find the matching manifest.
   * @param url - The URL to get the manifest for.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestByUrl(url) {
        return this.experienceManifestRegistry.getManifestByUrl(url);
    }
    /**
   * Synchronous function that returns the manifest for a given experience ID.
   * @param id - The experience manifest ID to look up.
   * @returns The matching manifest, or undefined if no match is found.
   */ getManifestById(id) {
        return this.experienceManifestRegistry.getManifestById(id);
    }
    /**
   * Returns a list of all registered experience IDs.
   */ getAllExperienceIds() {
        return this.experienceManifestRegistry.getAllExperienceIds();
    }
    /**
   * Register or replace the active host surface.
   *
   * The surface provides capabilities that differ per host (editor, renderer,
   * etc.). The {@link Surface} interface will grow as new surface concerns
   * are identified.
   *
   * - Replaces any previously registered surface (last-write-wins).
   * - Pass `null` to clear the surface (e.g. on unmount).
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this.surfaceService.setSurface(surface);
    }
    /**
   * Finds the matching manifest for a URL and creates an experience.
   * Title metadata will be resolved later by Smart Card.
   *
   * When the URL is a Confluence short link (e.g. `/wiki/x/<token>`) and a
   * `cardClient` has been configured, the short link is expanded to its
   * canonical URL via the Object Resolver Service before manifest matching.
   * The experience is created with the expanded URL.
   */ async createExperienceForUrl(url) {
        // Reject non-URL strings early. macroParams.url may contain prose text
        // with an embedded link rather than a bare URL (e.g. after a bad paste).
        try {
            new URL(url);
        } catch  {
            return undefined;
        }
        const resolvedUrl = await this.expandShortLink(url) ?? url;
        const manifest = this.experienceManifestRegistry.getManifestByUrl(resolvedUrl);
        if (!manifest) return undefined;
        const urlMeta = {
            url: resolvedUrl,
            title: ''
        };
        // Lazy import — ExperienceService transitively pulls in
        // rovo-content-bridge-api which uses uuid/randomBytes. Keeping it out of
        // the static import graph prevents the SSR pre-compile crash.
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        const experience = getExperienceService().registerExperience({
            manifest: manifest,
            urlMeta: urlMeta
        });
        return {
            experience: experience,
            manifest: manifest
        };
    }
    /**
   * Unregister an experience and dispose its event listeners.
   *
   * Call when the embed is removed from the host surface (e.g. editor node
   * deleted, component unmount). This prevents memory leaks from stale
   * listener references.
   *
   * Safe to call with an ID that was never registered — it's a no-op.
   */ async destroyExperience(experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().unregisterExperience(experienceId);
    }
    /** Notify the child embed that its selection state changed. */ async sendSelectedChange(experienceId, selected) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().sendSelectedChange(experienceId, selected);
    }
    /** Notify the child embed that the embedded content should be read. */ async sendReadContent(experienceId) {
        if (!(0, $iDrrr.fg)('maui_remixable_page_native_embeds')) return undefined;
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        return getExperienceService().sendReadContent(experienceId);
    }
    /** Register `aliasId` as a secondary ID for `experienceId`. Overwrites any previous mapping for `aliasId`. */ async addAlias(aliasId, experienceId) {
        const { getExperienceService: getExperienceService } = await (parcelRequire("eoNlM"));
        getExperienceService().addAlias(aliasId, experienceId);
    }
    constructor(experienceManifestRegistry, surfaceService){
        this.experienceManifestRegistry = void 0;
        this.surfaceService = void 0;
        this.cardClient = void 0;
        this.isSetUp = false;
        this.experienceManifestRegistry = experienceManifestRegistry;
        this.surfaceService = surfaceService;
    }
}
module.exports["getNativeEmbedFacade"] = $3b2da6bf08d8f744$export$31739795deb20347;

});

parcelRegister("6Iq0g", function(module, exports) {

var $c6zyu = parcelRequire("c6zyu");

let $7626500f872d820e$var$experienceService;
function $7626500f872d820e$export$1b2983209f90e067() {
    if ($7626500f872d820e$var$experienceService) return $7626500f872d820e$var$experienceService;
    $7626500f872d820e$var$experienceService = new $7626500f872d820e$export$21c7ca9c95b7ce6b((0, $c6zyu.getNativeEmbedCommentSupportStore)());
    return $7626500f872d820e$var$experienceService;
}
class $7626500f872d820e$export$21c7ca9c95b7ce6b {
    registerExperienceManifest(experienceManifest) {
        this.experienceManifests.push(experienceManifest);
        this.commentSupport.register(experienceManifest.id, experienceManifest.comments?.enabled === true);
    }
    safeIsUrlMatch(experience, url) {
        try {
            return experience.isUrlMatch(url);
        } catch  {
            return false;
        }
    }
    getExperienceIdFromUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url))?.id;
    }
    getManifestByUrl(url) {
        return this.experienceManifests.find((experience)=>this.safeIsUrlMatch(experience, url));
    }
    getManifestById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    getAllExperienceIds() {
        return this.experienceManifests.map((experience)=>experience.id);
    }
    async getExperienceById(id) {
        return this.experienceManifests.find((experience)=>experience.id === id);
    }
    constructor(commentSupport = new (0, $c6zyu.NativeEmbedCommentSupportStore)()){
        this.commentSupport = commentSupport;
        this.experienceManifests = [];
    }
}
module.exports["getExperienceManifestRegistry"] = $7626500f872d820e$export$1b2983209f90e067;

});

parcelRegister("c6zyu", function(module, exports) {

var $dfHaf = parcelRequire("dfHaf");

class $8e6c3e877675aabd$export$836557ee8d1dea33 {
    register(experienceId, enabled) {
        // Match the manifest registry: the first registration for an experience wins.
        if (this.capabilities.has(experienceId)) return;
        this.capabilities.set(experienceId, enabled);
        // Missing and explicitly disabled both resolve to false. Keep the snapshot stable.
        if (enabled) {
            this.snapshot = (0, $dfHaf.createNativeEmbedCommentSupport)(this.capabilities);
            this.listeners.forEach((listener)=>listener());
        }
    }
    constructor(){
        this.capabilities = new Map();
        this.snapshot = (0, $dfHaf.noNativeEmbedCommentSupport);
        this.listeners = new Set();
        this.getSnapshot = ()=>this.snapshot;
        this.subscribe = (listener)=>{
            this.listeners.add(listener);
            return ()=>{
                this.listeners.delete(listener);
            };
        };
    }
}
const $8e6c3e877675aabd$var$commentSupportStore = new $8e6c3e877675aabd$export$836557ee8d1dea33();
const $8e6c3e877675aabd$export$56ec1c299a522ea9 = ()=>$8e6c3e877675aabd$var$commentSupportStore;
module.exports["NativeEmbedCommentSupportStore"] = $8e6c3e877675aabd$export$836557ee8d1dea33;
module.exports["getNativeEmbedCommentSupportStore"] = $8e6c3e877675aabd$export$56ec1c299a522ea9;

});

parcelRegister("dfHaf", function(module, exports) {

var $2sp5n = parcelRequire("2sp5n");

const $4d8159fe49bf0947$export$1159198a8da29746 = ()=>false;
const $4d8159fe49bf0947$export$c100616865a311ef = (capabilities)=>{
    // Own the map so neither later registration nor caller mutation changes this snapshot.
    const snapshot = new Map(capabilities);
    return (node)=>{
        const { extensionType: extensionType, extensionKey: extensionKey } = node.attrs;
        return node.type.name === 'extension' && extensionType === (0, $2sp5n.NATIVE_EMBED_EXTENSION_TYPE) && typeof extensionKey === 'string' && extensionKey.startsWith(`${(0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY)}:`) && snapshot.get(extensionKey.slice((0, $2sp5n.NATIVE_EMBED_EXTENSION_KEY).length + 1)) === true;
    };
};
module.exports["noNativeEmbedCommentSupport"] = $4d8159fe49bf0947$export$1159198a8da29746;
module.exports["createNativeEmbedCommentSupport"] = $4d8159fe49bf0947$export$c100616865a311ef;

});

parcelRegister("h2POc", function(module, exports) {
let $761c278f71652274$var$surfaceServiceInstance;
function $761c278f71652274$export$a019fb3db45daa2b() {
    if (!$761c278f71652274$var$surfaceServiceInstance) $761c278f71652274$var$surfaceServiceInstance = new $761c278f71652274$export$f9308bd8ae7f0c97();
    return $761c278f71652274$var$surfaceServiceInstance;
}
class $761c278f71652274$export$f9308bd8ae7f0c97 {
    /**
   * Register or replace the active host surface.
   *
   * @param surface - The surface configuration, or `null` to clear.
   */ setSurface(surface) {
        this._surface = surface;
    }
    /**
   * Returns the currently active surface, or `null` if none is set.
   */ getSurface() {
        return this._surface;
    }
    constructor(){
        this._surface = null;
    }
}
module.exports["getSurfaceService"] = $761c278f71652274$export$a019fb3db45daa2b;

});

parcelRegister("eoNlM", function(module, exports) {

let $a7b996873e1209d3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7b996873e1209d3$var$load("9njOW").then(()=>parcelRequire('ddI8y'));

});

parcelRegister("99TtX", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $8fPlA = parcelRequire("8fPlA");


var $dx0Kw = parcelRequire("dx0Kw");

const $0232ad9c82d62a25$export$6dc7663b60a7f493 = (0, $8fPlA.experienceManifestId)('database');
const $0232ad9c82d62a25$var$isDatabaseUrl = (url)=>{
    return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null;
};
const $0232ad9c82d62a25$var$isDatabaseEntryUrl = (url)=>{
    try {
        return $0232ad9c82d62a25$var$isDatabaseUrl(url) && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $0232ad9c82d62a25$var$isDatabaseNonEntryUrl = (url)=>{
    return $0232ad9c82d62a25$var$isDatabaseUrl(url) && !$0232ad9c82d62a25$var$isDatabaseEntryUrl(url);
};
const $0232ad9c82d62a25$export$3db4c20f17f55c0a = {
    ...(0, $dx0Kw.dbSharedManifestFields),
    id: $0232ad9c82d62a25$export$6dc7663b60a7f493,
    isUrlMatch: $0232ad9c82d62a25$var$isDatabaseNonEntryUrl,
    parameterDefaults: {
        alwaysShowTitle: true
    },
    uiConfig: {
        ...(0, $dx0Kw.dbSharedUiConfig),
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    ...(0, $dx0Kw.getDbToolbarItems)()
                ],
                moreItems: (0, $dx0Kw.dbMoreItems)
            })
    }
};
module.exports["DBExperienceManifest"] = $0232ad9c82d62a25$export$3db4c20f17f55c0a;

});

parcelRegister("dx0Kw", function(module, exports) {
/* shared.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $4MdqE = parcelRequire("4MdqE");


var $lBKFk = parcelRequire("lBKFk");


var $k0CUL = parcelRequire("k0CUL");


var $1bzO2 = parcelRequire("1bzO2");


var $k9wGn = parcelRequire("k9wGn");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $hjJUc = parcelRequire("hjJUc");


var $iPlb2 = parcelRequire("iPlb2");

const $95d7871f626fca16$var$dbIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1bzO2))),
    (0, (/*@__PURE__*/$parcel$interopDefault($k0CUL))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4MdqE)))
];
const $95d7871f626fca16$var$dbHandleChildCommands = (_experience, _command)=>{};
const $95d7871f626fca16$var$dbTransformUrl = (url, _isFullScreen)=>{
    const urlObj = new URL(url);
    urlObj.searchParams.set('presentationMode', 'nativeEmbedEditorPlugin');
    return urlObj.toString();
};
const $95d7871f626fca16$var$dbRenderLoadingComponent = (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
        animationDisabled: props.animationDisabled,
        icons: $95d7871f626fca16$var$dbIcons,
        testId: props.testId
    });
const $95d7871f626fca16$export$8f59efcb9ee755ea = ()=>{
    const itemsBeforeUpdate = [
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
    ];
    const itemsAfterUpdate = [
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT
    ];
    return (0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? itemsAfterUpdate : itemsBeforeUpdate;
};
const $95d7871f626fca16$export$828ffb167e211671 = [
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
]; /**
                                                                                                                                                                         * Returns the "More options" dropdown items for the DB Entry embed.
                                                                                                                                                                         *
                                                                                                                                                                         * The "Always show title" toggle is gated on the `databases-native-embeds-v2`
                                                                                                                                                                         * experiment: it is only included when the experiment is enabled. Evaluated
                                                                                                                                                                         * lazily (rather than at module-load time) because the manifest is registered
                                                                                                                                                                         * before Statsig is bootstrapped.
                                                                                                                                                                         */ 
const $95d7871f626fca16$export$c84eb7789dc18 = ()=>{
    const items = [];
    if ((0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true)) items.push((0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE);
    items.push((0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY, (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE);
    return items;
};
const $95d7871f626fca16$export$2ef16a6e7258368a = {
    editorToolbarHandlers: {},
    renderLoadingComponent: $95d7871f626fca16$var$dbRenderLoadingComponent,
    titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
    appearance: 'minimal',
    showHeader: false,
    showBorder: false,
    waitForContentReady: true
};
const $95d7871f626fca16$export$28b94c65c51f8734 = {
    allowVerticalResize: true,
    isActive: ()=>true,
    handleChildCommands: $95d7871f626fca16$var$dbHandleChildCommands,
    lockResizeAspectRatio: ()=>false,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    transformUrl: $95d7871f626fca16$var$dbTransformUrl
};
module.exports["getDbToolbarItems"] = $95d7871f626fca16$export$8f59efcb9ee755ea;
module.exports["dbMoreItems"] = $95d7871f626fca16$export$828ffb167e211671;
module.exports["getDbEntryMoreItems"] = $95d7871f626fca16$export$c84eb7789dc18;
module.exports["dbSharedUiConfig"] = $95d7871f626fca16$export$2ef16a6e7258368a;
module.exports["dbSharedManifestFields"] = $95d7871f626fca16$export$28b94c65c51f8734;

});

parcelRegister("1NFwk", function(module, exports) {

var $ljOiP = parcelRequire("ljOiP");


var $ieeJu = parcelRequire("ieeJu");


var $anBbz = parcelRequire("anBbz");


var $8fPlA = parcelRequire("8fPlA");


var $dx0Kw = parcelRequire("dx0Kw");

const $2b4557ff3d43825b$var$isDbEntryV2Enabled = ()=>(0, $anBbz.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $ieeJu.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
/**
 * Returns the parameter defaults for the DB Entry embed.
 *
 * When v2 is enabled (see {@link isDbEntryV2Enabled}), new entry embeds
 * default to having the title visible (`alwaysShowTitle: true`),
 * matching the regular DB embed behaviour. Otherwise no override is
 * applied.
 */ const $2b4557ff3d43825b$var$getDbEntryParameterDefaults = ()=>$2b4557ff3d43825b$var$isDbEntryV2Enabled() ? {
        alwaysShowTitle: true
    } : {};
const $2b4557ff3d43825b$export$a8c9f0f28b60cece = (0, $8fPlA.experienceManifestId)('database-entry');
const $2b4557ff3d43825b$var$isDatabaseEntryUrl = (url)=>{
    try {
        return url.match(/\/wiki\/spaces\/~?[\d\w]+\/database\/\d+(\?.*)?$/) !== null && new URL(url).searchParams.has('entryId');
    } catch  {
        return false;
    }
};
const $2b4557ff3d43825b$export$b0c2faa0f9dece58 = {
    ...(0, $dx0Kw.dbSharedManifestFields),
    id: $2b4557ff3d43825b$export$a8c9f0f28b60cece,
    isUrlMatch: $2b4557ff3d43825b$var$isDatabaseEntryUrl,
    get parameterDefaults () {
        return $2b4557ff3d43825b$var$getDbEntryParameterDefaults();
    },
    uiConfig: {
        ...(0, $dx0Kw.dbSharedUiConfig),
        get appearance () {
            return $2b4557ff3d43825b$var$isDbEntryV2Enabled() ? 'overlay' : 'minimal';
        },
        get showBorder () {
            return $2b4557ff3d43825b$var$isDbEntryV2Enabled();
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    ...(0, $dx0Kw.getDbToolbarItems)()
                ],
                moreItems: (0, $dx0Kw.getDbEntryMoreItems)()
            })
    }
};
module.exports["DBEntryExperienceManifest"] = $2b4557ff3d43825b$export$b0c2faa0f9dece58;

});

parcelRegister("9F0bu", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $6Ec6w = parcelRequire("6Ec6w");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $cha5E = parcelRequire("cha5E");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $gqUuL = parcelRequire("gqUuL");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");


var $iPlb2 = parcelRequire("iPlb2");

const $d2e69b3762c8c591$export$b0111d5aa9d78690 = (0, $8fPlA.experienceManifestId)('maui');
const $d2e69b3762c8c591$var$MAUI_DEFAULT_WIDTH_KILLSWITCH = 'native_embeds_maui_default_width_killswitch';
const $d2e69b3762c8c591$var$isMauiUrl = (url)=>/\/remix\/ui\/[A-Za-z0-9_-]+/.test(url); /**
                                                                                      * Rollout control for commenting on MAUI charts and visualisations.
                                                                                      *
                                                                                      * Fires the experiment exposure: the editor only evaluates the toolbar actions
                                                                                      * and view-mode items for toolbars that show Comment. Confluence's renderer check
                                                                                      * (`isExtensionCommentsExperienceEnabled`) reads the same experiment; keep them
                                                                                      * in sync.
                                                                                      *
                                                                                      * Fails closed, so a Statsig client that has not initialised yet leaves the
                                                                                      * Comment action out of the toolbar rather than showing an action that cannot
                                                                                      * anchor a thread.
                                                                                      */ 
const $d2e69b3762c8c591$var$isCommentsOnChartsEnabled = ()=>{
    try {
        return (0, $cha5E.expVal)('cc_maui_comments_on_charts_exp', 'isEnabled', false);
    } catch  {
        return false;
    }
}; /**
    * Experience manifest for a MAUI embed.
    * Register with getNativeEmbedFacade().registerExperienceManifest(MauiExperienceManifest),
    * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
    */ 
const $d2e69b3762c8c591$export$f519d88de7ad4d5e = {
    allowMaxWidth: true,
    comments: {
        enabled: true
    },
    id: $d2e69b3762c8c591$export$b0111d5aa9d78690,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $d2e69b3762c8c591$var$isMauiUrl,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    lockResizeAspectRatio: ()=>!(0, $iDrrr.fg)('cc_maui_resize'),
    narrowEmbedThreshold: 50,
    parameterDefaults: {
        get width () {
            return (0, $iDrrr.fg)($d2e69b3762c8c591$var$MAUI_DEFAULT_WIDTH_KILLSWITCH) ? 760 : undefined;
        }
    },
    shouldFocusOnClick: (_url, _meta, options)=>!(0, $4o0zT.isExperimentEnabled)('cc_maui_editing_experience') || options?.isSelected !== true,
    transformUrl: (url, _isFullScreen, options)=>{
        const urlObj = new URL(url);
        const { colorMode: colorMode } = (0, $gqUuL.getGlobalTheme)();
        if (colorMode) urlObj.searchParams.set('theme', colorMode);
        if ((0, $iDrrr.fg)('cc_maui_client_platform')) urlObj.searchParams.set('clientPlatform', 'web');
         // When the host Confluence page is in edit mode, forward an
        // `enable-edits=` query param (empty value) so the embedded MAUI app
        // can render its edit-only affordances.
        if (options?.isEditMode) urlObj.searchParams.set('enable-edits', '');
        return urlObj.toString();
    },
    // remove this when MAUI is onboarded to the Linking Platform. This is here to allow testing before it is onboarded.
    resolveViaLinkingPlatform: false,
    uiConfig: {
        get deferRenderedEventUntilVisible () {
            return (0, $4o0zT.isExperimentEnabled)('platform_maui_retention_analytics');
        },
        getRenderedResultId: (source)=>{
            try {
                const version = new URL(source, 'https://native-embeds.invalid').pathname.match(/\/remix\/ui\/([^/]+)/)?.[1];
                return version ? decodeURIComponent(version) : undefined;
            } catch  {
                return undefined;
            }
        },
        trackViewed: true,
        // Holds core's loading state until the app reports its first painted frame; the iframe's
        // `load` event fires while the app is still starting. The reveal in `editor-common` waits on
        // that signal. A getter, because the manifest is a module constant and the gate is read per
        // render. Applies to every MAUI embed; an app that never sends the signal keeps its overlay
        // until core's 10s timeout.
        get waitForContentReady () {
            return (0, $iDrrr.fg)('aifc_page_create_defer_generated_visuals');
        },
        showBorder: false,
        showExpandButton: false,
        renderLoadingComponent: (props)=>{
            return /*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                variant: "simple-bar",
                animationDisabled: props.animationDisabled,
                showBlanket: props.source === 'ai-edit',
                testId: props.testId
            });
        },
        editorToolbarActions: ()=>{
            const showComment = (0, $iDrrr.fg)('cc_maui_annotations_on_extensions') && $d2e69b3762c8c591$var$isCommentsOnChartsEnabled();
            return (0, $ljOiP.createEditorToolbarActions)({
                customActions: {},
                items: [
                    ...(0, $iDrrr.fg)('cc-maui-phase-2') ? (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    ...(0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? (0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).BORDER,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EXPAND,
                    // With Comment, match the media toolbar: Copy and Delete move into the
                    // "More options" menu, which follows Comment with no separator.
                    ...showComment ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COMMENT
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                    ]
                ],
                moreItems: showComment ? [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ] : [],
                // Size the menu like media's, for MAUI charts only.
                compactMoreItems: showComment
            });
        },
        editorToolbarHandlers: {
            onAskRovoClick: (_parameters, context)=>{
                const editorApi = context?.editorApi; // Stage the embed as the inline-Rovo streaming target. The overlay
                // is NOT triggered here — `RovoPromptScreenWithLogic.onSubmit`
                // promotes this on prompt submit. `expValEquals` (NOT NoExposure)
                // because this toolbar click is the designated `cc-maui-experiment`
                // exposure point.
                if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-experiment + cc-maui-phase-2); will simplify post-rollout
                (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) && (0, $iDrrr.fg)('cc-maui-phase-2')) {
                    const localId = context?.selectedNodeLocalId;
                    if (localId) editorApi?.aiExperience?.actions?.stageInlineRovoStreaming?.(localId);
                }
                editorApi?.aiExperience?.actions?.openAIModal?.({
                    invokedFrom: 'floatingToolbar'
                });
            }
        },
        fullScreenDialogControls: {
            hideOpenInNewTab: true,
            hideTitleIcon: true
        },
        headerControls: {
            hideMoreMenu: true,
            hideTitle: true
        },
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ec6w))),
        appearance: 'overlay',
        // Comment also shows when viewing a live page, under the same rollout as edit mode.
        viewModeEditorToolbarItems: ()=>(0, $iDrrr.fg)('cc_maui_annotations_on_extensions') && $d2e69b3762c8c591$var$isCommentsOnChartsEnabled() ? [
                (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COMMENT
            ] : []
    }
};
module.exports["MAUI_EXPERIENCE_MANIFEST_ID"] = $d2e69b3762c8c591$export$b0111d5aa9d78690;
module.exports["MauiExperienceManifest"] = $d2e69b3762c8c591$export$f519d88de7ad4d5e;

});

parcelRegister("85cI7", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $5FKld = parcelRequire("5FKld");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $8fPlA = parcelRequire("8fPlA");


var $iPlb2 = parcelRequire("iPlb2");

const $ec6282bd715404c7$export$7bda1cade81459d3 = (0, $8fPlA.experienceManifestId)('maui-whiteboard'); /**
                                                                                                                      * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                                      * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                                      * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                                      * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                                      */ 
const $ec6282bd715404c7$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $ec6282bd715404c7$var$ROVO_REMIX_TITLE_KILLSWITCH = 'platform_native_embed_rovo_remix_title';
const $ec6282bd715404c7$var$ROVO_STREAMING_GENERATION_QUERY_PARAM = 'rovoStreamingGeneration';
const $ec6282bd715404c7$var$REMIX_WHITEBOARD_LOADING_CONFIG = 'platform_remix_whiteboard_loading';
const $ec6282bd715404c7$var$ROVO_STREAMING_RECEIVER_QUERY_PARAM = 'rovoReceiverId';
const $ec6282bd715404c7$var$GENERATING_OVERLAY_FAIL_OPEN_MS = 60000;
const $ec6282bd715404c7$var$RELATIVE_URL_PARSE_BASE = 'https://native-embeds.invalid';
const $ec6282bd715404c7$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
]; /**
                                                                                              * Captures the whiteboard resource id from a Confluence whiteboard URL. Numeric
                                                                                              * ids and UUIDs are both in use.
                                                                                              */ 
// eslint-disable-next-line require-unicode-regexp
const $ec6282bd715404c7$var$WHITEBOARD_RESOURCE_ID_REGEX = /\/whiteboard\/([^/?#]+)/; /**
                                                                 * A whiteboard embed's identity is its content id. The space segment is vanity
                                                                 * (the rendered canvas URL is `/canvas-embed/whiteboard/{referenceId}` and has no
                                                                 * space key), and the streaming params are transient, so neither changes which
                                                                 * board is being shown.
                                                                 *
                                                                 * Scoped to the MAUI experience on purpose. The in-editor Remix finalize keeps
                                                                 * `isRemixDiagram=true` on the rewritten URL, so both the streaming and finalized
                                                                 * URLs still match this manifest — which `main.tsx` registers ahead of the generic
                                                                 * whiteboard one — and identity resolves from here on both sides of the rewrite.
                                                                 *
                                                                 * The paste path is deliberately not covered: `buildMovedUrl` strips
                                                                 * `isRemixDiagram`, so its finalized URL falls through to the generic `whiteboard`
                                                                 * manifest, which has no identity and therefore keeps the existing URL-keyed
                                                                 * teardown. That path's reload is already largely masked because the move fires on
                                                                 * the tick after paste, while the board is still loading. Extending identity to
                                                                 * the generic manifest would change behaviour for every non-MAUI Confluence
                                                                 * whiteboard embed, which is not worth it for this fix.
                                                                 */ 
const $ec6282bd715404c7$var$getWhiteboardContentIdentity = (url)=>{
    const resourceId = $ec6282bd715404c7$var$WHITEBOARD_RESOURCE_ID_REGEX.exec(url)?.[1];
    if (!resourceId) return undefined;
    try {
        return `whiteboard:${decodeURIComponent(resourceId)}`;
    } catch  {
        return `whiteboard:${resourceId}`;
    }
};
const $ec6282bd715404c7$var$isMauiWhiteboardUrl = (url)=>{
    const isWhiteboardPath = url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?"));
    if (!isWhiteboardPath) return false;
    try {
        return new URL(url).searchParams.get('isRemixDiagram') === 'true';
    } catch  {
        return false;
    }
}; /**
    * Reads search params from either an absolute embed URL or a relative iframe
    * src such as `/canvas-embed/whiteboard/...`. The placeholder base is only
    * used by `URL` to parse relative URLs; absolute URLs keep their own origin
    * and nothing is requested from this host.
    */ 
const $ec6282bd715404c7$var$getSearchParamFromEmbedUrl = (url, param)=>{
    try {
        return new URL(url, $ec6282bd715404c7$var$RELATIVE_URL_PARSE_BASE).searchParams.get(param);
    } catch  {
        return null;
    }
};
const $ec6282bd715404c7$var$resolveGeneratingOverlayHold = ({ experience: experience, url: url })=>{
    if (!(0, $2pQiO.UNSAFE_expValNoExposure)($ec6282bd715404c7$var$REMIX_WHITEBOARD_LOADING_CONFIG, 'value', false)) return undefined;
    const receiverId = $ec6282bd715404c7$var$getSearchParamFromEmbedUrl(url, $ec6282bd715404c7$var$ROVO_STREAMING_RECEIVER_QUERY_PARAM);
    const generationId = $ec6282bd715404c7$var$getSearchParamFromEmbedUrl(url, $ec6282bd715404c7$var$ROVO_STREAMING_GENERATION_QUERY_PARAM);
    if (!receiverId) return undefined;
    const holdKey = generationId ? receiverId + ':' + generationId : receiverId;
    const matchesGeneration = (event)=>generationId === null || event.generationId === generationId;
    const matchesContentReadyGeneration = (event)=>matchesGeneration(event) || generationId !== null && event.generationId === undefined;
    return {
        key: holdKey,
        subscribeToFirstContentPaint: (start)=>{
            let started = false;
            let cleanedUp = false;
            let unsubscribeFirstContentPainted;
            const startOnce = ()=>{
                if (started || cleanedUp) return;
                started = true;
                start();
            };
            unsubscribeFirstContentPainted = experience.on('first-content-painted', (event)=>{
                if (matchesGeneration(event)) startOnce();
            }, {
                replayLast: true
            });
            return ()=>{
                cleanedUp = true;
                unsubscribeFirstContentPainted?.();
            };
        },
        subscribeToRelease: (release)=>{
            let released = false;
            let cleanedUp = false;
            let failOpenTimeout;
            let unsubscribeStreamComplete;
            let unsubscribeContentReady;
            const releaseOnce = ()=>{
                if (released || cleanedUp) return;
                released = true;
                if (failOpenTimeout !== undefined) {
                    clearTimeout(failOpenTimeout);
                    failOpenTimeout = undefined;
                }
                release();
            };
            const cleanup = ()=>{
                if (cleanedUp) return;
                cleanedUp = true;
                if (failOpenTimeout !== undefined) {
                    clearTimeout(failOpenTimeout);
                    failOpenTimeout = undefined;
                }
                unsubscribeStreamComplete?.();
                unsubscribeContentReady?.();
            };
            try {
                unsubscribeStreamComplete = experience.on('stream-complete', (event)=>{
                    if (matchesGeneration(event)) releaseOnce();
                }, {
                    replayLast: true
                });
                if (!released) // Keep content-ready as a compatibility fallback for older Canvas
                // deploys that do not emit stream-complete yet.
                unsubscribeContentReady = experience.on('content-ready', (event)=>{
                    if (matchesContentReadyGeneration(event)) releaseOnce();
                }, {
                    replayLast: true
                });
                if (!released) failOpenTimeout = setTimeout(()=>{
                    releaseOnce();
                }, $ec6282bd715404c7$var$GENERATING_OVERLAY_FAIL_OPEN_MS);
            } catch (error) {
                cleanup();
                throw error;
            }
            return cleanup;
        }
    };
};
const $ec6282bd715404c7$var$shouldHideRovoRemixTitle = (url)=>{
    // Killswitch: platform_native_embed_rovo_remix_title
    // false (default) = hide intermediary Rovo remix titles; true = rollback
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$ROVO_REMIX_TITLE_KILLSWITCH, 'value', false)) return false;
    return $ec6282bd715404c7$var$getSearchParamFromEmbedUrl(url, 'parentProduct') === 'rovo';
}; /**
    * Experience manifest for a MAUI whiteboard embed — a whiteboard created through
    * the MAUI (remix diagram) flow.
    *
    * Register with getNativeEmbedFacade().registerExperience(MauiWhiteboardExperienceManifest)
    * to obtain an Experience for EmbedFrameUI.
    */ 
const $ec6282bd715404c7$export$72612bab14c2e7fe = {
    id: $ec6282bd715404c7$export$7bda1cade81459d3,
    getContentIdentity: $ec6282bd715404c7$var$getWhiteboardContentIdentity,
    isUrlMatch: $ec6282bd715404c7$var$isMauiWhiteboardUrl,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures),
        (0, $5FKld.WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE)
    ]),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $cXtTj.default).getExperimentValue($ec6282bd715404c7$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true'); // Default the parent product for MAUI whiteboards when the native embed
        // URL doesn't already specify one. native-embeds-core re-applies this
        // onto the ORS-resolved iframe src (which otherwise defaults to
        // `smartlink`). An existing value (e.g. `rovo`) is preserved.
        if (!urlObj.searchParams.has('parentProduct')) urlObj.searchParams.set('parentProduct', 'nativeEmbedDiagram');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        trackViewed: true,
        isAskRovoEnabled: ()=>(0, $iDrrr.fg)('cc-maui-phase-2'),
        resolveGeneratingOverlayHold: $ec6282bd715404c7$var$resolveGeneratingOverlayHold,
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    ...(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX_VARIANT
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        headerControls: {
            hideTitle: ({ url: url })=>$ec6282bd715404c7$var$shouldHideRovoRemixTitle(url)
        },
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $ec6282bd715404c7$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        appearance: 'overlay',
        waitForContentReady: true
    },
    handleChildCommands: (_experience, _cmd)=>{}
};
module.exports["MAUI_WHITEBOARD_EXPERIENCE_MANIFEST_ID"] = $ec6282bd715404c7$export$7bda1cade81459d3;
module.exports["MauiWhiteboardExperienceManifest"] = $ec6282bd715404c7$export$72612bab14c2e7fe;

});

parcelRegister("5FKld", function(module, exports) {
const $0debf512440368ae$export$2e20e907dc949166 = 'whiteboard-viewport-alignment';
const $0debf512440368ae$export$47b7df6411961030 = 'whiteboard-viewport-alignment-change';
function $0debf512440368ae$export$ac67ecac1191542d(alignment) {
    switch(alignment){
        case 'left':
        case 'wrap-left':
            return 'left';
        case 'center':
            return 'center';
        case 'right':
        case 'wrap-right':
            return 'right';
    }
}
module.exports["WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE"] = $0debf512440368ae$export$2e20e907dc949166;
module.exports["WHITEBOARD_VIEWPORT_ALIGNMENT_CHANGE_COMMAND"] = $0debf512440368ae$export$47b7df6411961030;
module.exports["normalizeWhiteboardViewportAlignment"] = $0debf512440368ae$export$ac67ecac1191542d;

});

parcelRegister("7tMWI", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kLlYX = parcelRequire("kLlYX");


var $gC2EJ = parcelRequire("gC2EJ");


var $hMaHH = parcelRequire("hMaHH");


var $4GyjL = parcelRequire("4GyjL");


var $d4GYd = parcelRequire("d4GYd");


var $UL6rM = parcelRequire("UL6rM");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");


var $iPlb2 = parcelRequire("iPlb2");

const $f5f0a9f7a4b49836$export$7870b2bb7b39809b = (0, $8fPlA.experienceManifestId)('page');
const $f5f0a9f7a4b49836$var$pageIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
    (0, (/*@__PURE__*/$parcel$interopDefault($gC2EJ))),
    (0, (/*@__PURE__*/$parcel$interopDefault($UL6rM))),
    (0, (/*@__PURE__*/$parcel$interopDefault($4GyjL)))
]; // Match page URLs: /wiki/spaces/<key>/pages/<id>
// Match blog URLs: /wiki/spaces/<key>/blog/<id> or /wiki/spaces/<key>/blog/<year>/<month>/<day>/<id>
const $f5f0a9f7a4b49836$var$pagePathPattern = /\/wiki\/spaces\/[^/]+\/(pages\/\d+|blog\/(\d+\/){0,3}\d+)/;
const $f5f0a9f7a4b49836$var$pageShortLinkUrlPattern = /^https:\/\/[^/?#]+\/wiki\/x\/[A-Za-z0-9_-]+\/?(?:[?#].*)?$/;
const $f5f0a9f7a4b49836$var$isPageUrl = (url)=>$f5f0a9f7a4b49836$var$pagePathPattern.test(url) || $f5f0a9f7a4b49836$var$pageShortLinkUrlPattern.test(url);
const $f5f0a9f7a4b49836$var$isEditUrl = (url)=>/\/wiki\/spaces\/[^/]+\/(pages|blog)\/(edit-embed|edit-v2)\/\d+/.test(url); // PGXT-10098: keep blog icons correct before resolved metadata is available.
const $f5f0a9f7a4b49836$var$blogPathPattern = /\/wiki\/spaces\/[^/]+\/blog\//;
const $f5f0a9f7a4b49836$var$isBlogUrl = (url)=>{
    try {
        return $f5f0a9f7a4b49836$var$blogPathPattern.test(new URL(url).pathname);
    } catch  {
        return $f5f0a9f7a4b49836$var$blogPathPattern.test(url);
    }
};
const $f5f0a9f7a4b49836$var$resolveTitleIcon = (meta, url)=>{
    if (meta.documentType === 'schema:DigitalDocument') return 0, (/*@__PURE__*/$parcel$interopDefault($kLlYX));
    if (meta.documentType === 'schema:BlogPosting' || $f5f0a9f7a4b49836$var$isBlogUrl(url)) return 0, (/*@__PURE__*/$parcel$interopDefault($d4GYd));
    return 0, (/*@__PURE__*/$parcel$interopDefault($hMaHH));
}; /**
    * Experience manifest for a page embed.
    * Register with getNativeEmbedFacade().registerExperienceManifest(PageExperienceManifest),
    * then call getNativeEmbedFacade().createExperienceForUrl(url) to obtain an Experience for EmbedFrameUI.
    */ 
const $f5f0a9f7a4b49836$export$f85d1a9111fa6dfc = {
    enforceQueryParams: true,
    id: $f5f0a9f7a4b49836$export$7870b2bb7b39809b,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: $f5f0a9f7a4b49836$var$isPageUrl,
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    isActive: ()=>true,
    shouldFocusOnClick: (url, meta)=>{
        // Don't steal focus for live docs (documentType === 'schema:DigitalDocument')
        if (meta.documentType === 'schema:DigitalDocument') return false;
         // Don't steal focus when the page is in edit mode
        if ($f5f0a9f7a4b49836$var$isEditUrl(url)) return false;
        return true;
    },
    transformUrl: (url, _isFullScreen)=>{
        const urlObj = new URL(url);
        urlObj.searchParams.set('sample-param', 'true');
        return urlObj.toString();
    },
    uiConfig: {
        showHeader: (_meta, url)=>!$f5f0a9f7a4b49836$var$isEditUrl(url),
        headerControls: {
            editButton: {
                show: (meta)=>meta.documentType !== 'schema:DigitalDocument',
                // Don't show edit button for live docs
                onSwitchToEditing: (currentUrl, originalUrl)=>{
                    const url = new URL(currentUrl); // Detect whether this is originally a blog URL. The iframe's internal
                    // SPA router may resolve blog URLs (e.g. /blog/2026/04/29/<id>) to
                    // their canonical /pages/<id> form, so iframeSrc (currentUrl) may
                    // show /pages/<id> even for blogs. We check the originalUrl (the URL
                    // before iframe navigation) to detect blogs reliably; fall back to
                    // the current URL when no originalUrl is provided.
                    const contentIsBlog = $f5f0a9f7a4b49836$var$isBlogUrl(originalUrl ?? currentUrl);
                    if (contentIsBlog) {
                        // Blogs use /blog/edit-v2/<id> because there is no /blog/edit-embed/ route,
                        // which would cause a redirect that strips native embed query params.
                        // Extract the content ID from either the blog URL or the resolved /pages/<id> URL.
                        const blogMatch = url.pathname.match(/\/blog\/(?:\d+\/\d+\/\d+\/)?(\d+)(?:\/[^/]*)?$/);
                        const pagesMatch = url.pathname.match(/\/pages\/(\d+)/);
                        const contentId = blogMatch?.[1] ?? pagesMatch?.[1];
                        if (contentId) // Replace the path portion after /spaces/<key>/ with /blog/edit-v2/<id>
                        url.pathname = url.pathname.replace(/\/spaces\/([^/]+)\/.*$/, `/spaces/$1/blog/edit-v2/${contentId}`);
                    } else // Pages use /pages/edit-embed/<id> (dedicated embedded editor route).
                    url.pathname = url.pathname.replace(/\/pages\/(\d+)/, '/pages/edit-embed/$1');
                    url.searchParams.set('initialAllowedFeatures', 'delete-draft');
                    return url.toString();
                },
                onSwitchToViewing: (currentUrl, _originalUrl)=>{
                    const url = new URL(currentUrl); // Reverse the edit URL transforms back to view URLs
                    url.pathname = url.pathname.replace(/\/pages\/edit-embed\/(\d+)/, '/pages/$1').replace(/\/blog\/edit-v2\/(\d+)/, '/blog/$1');
                    url.searchParams.delete('initialAllowedFeatures');
                    return url.toString();
                }
            }
        },
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    ...(0, $iDrrr.fg)('maui_remixable_page_native_embeds') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).REMIX
                    ] : [],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $f5f0a9f7a4b49836$var$pageIcons,
                testId: props.testId
            }),
        resolveTitleIcon: $f5f0a9f7a4b49836$var$resolveTitleIcon,
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
        appearance: 'overlay'
    }
};
module.exports["PageExperienceManifest"] = $f5f0a9f7a4b49836$export$f85d1a9111fa6dfc;

});

parcelRegister("8iBLq", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $8kONW = parcelRequire("8kONW");


var $kWSTb = parcelRequire("kWSTb");


var $fZ5ji = parcelRequire("fZ5ji");


var $bYNUA = parcelRequire("bYNUA");


var $cFvoT = parcelRequire("cFvoT");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $iDrrr = parcelRequire("iDrrr");


var $anBbz = parcelRequire("anBbz");


var $hjJUc = parcelRequire("hjJUc");


var $8fPlA = parcelRequire("8fPlA");


var $iPlb2 = parcelRequire("iPlb2");

const $dc247be55b77c9b0$var$slideIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bYNUA))),
    (0, (/*@__PURE__*/$parcel$interopDefault($cFvoT))),
    (0, (/*@__PURE__*/$parcel$interopDefault($fZ5ji)))
];
const $dc247be55b77c9b0$export$7f3e59c853b03788 = (0, $8fPlA.experienceManifestId)('slide'); /**
                                                                                                  * Experience manifest for a slide embed.
                                                                                                  * Register with getNativeEmbedFacade().registerExperience(SlideExperienceManifest)
                                                                                                  * to obtain a Experience for EmbedFrameUI.
                                                                                                  */ 
const $dc247be55b77c9b0$export$513ec3204bdf9ec = {
    id: $dc247be55b77c9b0$export$7f3e59c853b03788,
    handleChildCommands: (_experience, _cmd)=>{},
    isUrlMatch: (url)=>(0, $8kONW.isConfluenceSlideUrl)(url) && !(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true),
    supportedFeatures: new Set((0, $iPlb2.allNativeEmbedCoreFeatures)),
    queryParams: {
        disableCanvasScroll: 'true'
    },
    isActive: ()=>!(0, $iDrrr.fg)('cc-mui-slides-opted-out') && (0, $anBbz.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true),
    // Slides have a 16:9 canvas; set the default embed dimensions to 16:10 with a little extra height cause it looks nicer.
    parameterDefaults: {
        width: 960,
        height: 600
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    // BUILTIN_TOOLBAR_KEYS.ASK_ROVO, // Removed until correct context from embed is provided https://product-fabric.atlassian.net/browse/CNS-29056
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL
                    ] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT_URL,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $dc247be55b77c9b0$var$slideIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
        appearance: 'overlay'
    }
};
module.exports["SlideExperienceManifest"] = $dc247be55b77c9b0$export$513ec3204bdf9ec;

});

parcelRegister("fZ5ji", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cb7bb57bd8240848dd583248edb04670>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ba30ac06fca117d5$var$_react = $ba30ac06fca117d5$var$_interopRequireDefault((parcelRequire("cozmU")));

var $ba30ac06fca117d5$var$_iconNew = $ba30ac06fca117d5$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $ba30ac06fca117d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoMiniplayer".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/video-miniplayer
 * Usage guidance:
 * Reserved for picture-in-picture functionality for videos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ba30ac06fca117d5$var$VideoMiniplayerIcon = (props)=>/*#__PURE__*/ $ba30ac06fca117d5$var$_react.default.createElement($ba30ac06fca117d5$var$_iconNew.default, Object.assign({
        name: "VideoMiniplayerIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm4.75 4a.75.75 0 0 1 .75-.75h4.75a.75.75 0 0 1 .75.75v2.75a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75z" clip-rule="evenodd"/>`
    }, props));
$ba30ac06fca117d5$var$VideoMiniplayerIcon.displayName = 'VideoMiniplayerIcon';
var $ba30ac06fca117d5$var$_default = module.exports.default = $ba30ac06fca117d5$var$VideoMiniplayerIcon;

});

parcelRegister("bYNUA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6aaf5db72242d392e688c8c721d1e0da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8b8c03b563f282f7$var$_react = $8b8c03b563f282f7$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8b8c03b563f282f7$var$_iconNew = $8b8c03b563f282f7$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8b8c03b563f282f7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/video-play-circle
 * Usage guidance:
 * Known uses: play video in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8b8c03b563f282f7$var$VideoPlayCircleIcon = (props)=>/*#__PURE__*/ $8b8c03b563f282f7$var$_react.default.createElement($8b8c03b563f282f7$var$_iconNew.default, Object.assign({
        name: "VideoPlayCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m5-2.694c0-.808.866-1.32 1.574-.931l4.958 2.722a1.062 1.062 0 0 1 0 1.862l-4.958 2.722A1.063 1.063 0 0 1 5 10.75zm1.5.74v3.965l3.611-1.983z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 10.01V6.046l3.611 1.983z"/>`
    }, props));
$8b8c03b563f282f7$var$VideoPlayCircleIcon.displayName = 'VideoPlayCircleIcon';
var $8b8c03b563f282f7$var$_default = module.exports.default = $8b8c03b563f282f7$var$VideoPlayCircleIcon;

});

parcelRegister("aaqIB", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $b5sDq = parcelRequire("b5sDq");


var $h5uPL = parcelRequire("h5uPL");


var $jxqsh = parcelRequire("jxqsh");


var $bDjVc = parcelRequire("bDjVc");


var $k9wGn = parcelRequire("k9wGn");


var $ljOiP = parcelRequire("ljOiP");


var $5FKld = parcelRequire("5FKld");


var $iDrrr = parcelRequire("iDrrr");


var $hjJUc = parcelRequire("hjJUc");


var $1xINT = parcelRequire("1xINT");


var $8fPlA = parcelRequire("8fPlA");


var $iPlb2 = parcelRequire("iPlb2");


var $7wdoX = parcelRequire("7wdoX");

const $af71dcb44dbd21c6$export$571bdd0f87630d48 = (0, $8fPlA.experienceManifestId)('whiteboard'); /**
                                                                                                            * Dynamic-config killswitch for sending `disableCanvasScroll` conditionally in
                                                                                                            * legacy full screen. Default `false` = change enabled (param omitted from the
                                                                                                            * legacy full-screen URL so the blown-up board scrolls); set to `true` to roll
                                                                                                            * back to the pre-EPS8-40 behavior (param sent everywhere).
                                                                                                            */ 
const $af71dcb44dbd21c6$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH = 'platform_native_embed_legacy_fs_canvas_scroll';
const $af71dcb44dbd21c6$var$whiteboardIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
    (0, (/*@__PURE__*/$parcel$interopDefault($b5sDq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($jxqsh))),
    (0, (/*@__PURE__*/$parcel$interopDefault($h5uPL)))
];
const $af71dcb44dbd21c6$var$isWhiteboardUrl = (url)=>// @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
    url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>\\d+)(\\?\\/)?")) || url.match(RegExp("\\/wiki\\/spaces\\/?.*\\/whiteboard\\/(?<resourceId>[0-9a-fA-F]{8}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{4}\\b-[0-9a-fA-F]{12})(\\?\\/)?")); /**
                                                                                                                                                                                                                                     * Experience manifest for a whiteboard embed.
                                                                                                                                                                                                                                     * Register with getNativeEmbedFacade().registerExperience(WhiteboardExperienceManifest)
                                                                                                                                                                                                                                     * to obtain a Experience for EmbedFrameUI.
                                                                                                                                                                                                                                     */ 
const $af71dcb44dbd21c6$export$257420b954ccf94c = {
    id: $af71dcb44dbd21c6$export$571bdd0f87630d48,
    handleChildCommands: (_experience, cmd)=>{
        switch(cmd.type){
            case (0, $7wdoX.NativeEmbedChildCommandType).FreezeFrameResponse:
                break;
            case (0, $7wdoX.NativeEmbedChildCommandType).UnfreezeFrameResponse:
                break;
        }
    },
    isUrlMatch: $af71dcb44dbd21c6$var$isWhiteboardUrl,
    supportedFeatures: new Set([
        ...(0, $iPlb2.allNativeEmbedCoreFeatures),
        (0, $5FKld.WHITEBOARD_VIEWPORT_ALIGNMENT_FEATURE)
    ]),
    // Thunk so the killswitch is read at URL-build time (after Statsig init), and
    // so the conditional behavior is gated at its source: when rolled back the
    // manifest emits the pre-EPS8-40 plain-string value, which `resolveQueryParams`
    // passes through unchanged at every build site.
    //
    // `disableCanvasScroll` is correct inline (and in shared-iframe full screen,
    // which reuses the inline URL) but makes the blown-up board feel broken in the
    // legacy full-screen iframe, so by default it is omitted from that build site
    // only. `hideCursors` applies everywhere (plain string === appliesTo: 'always').
    queryParams: ()=>{
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const rolledBack = (0, $cXtTj.default).getExperimentValue($af71dcb44dbd21c6$var$LEGACY_FS_CANVAS_SCROLL_KILLSWITCH, 'value', false);
        return rolledBack ? {
            disableCanvasScroll: 'true',
            hideCursors: 'true'
        } : {
            disableCanvasScroll: {
                value: 'true',
                appliesTo: 'exceptLegacyFullscreen'
            },
            hideCursors: 'true'
        };
    },
    transformUrl: (url, isFullScreen)=>{
        const urlObj = new URL(url);
        if (!isFullScreen) urlObj.searchParams.set('hideBorder', 'true');
         // this is used to identify the native embed view in the whiteboard app
        urlObj.searchParams.set('nativeEmbedView', 'true');
        const initialTheme = (0, $1xINT.getInitialThemeParam)();
        if (initialTheme) urlObj.searchParams.set('themeState', initialTheme);
        return urlObj.toString();
    },
    isActive: ()=>{
        return true;
    },
    uiConfig: {
        editorToolbarActions: ()=>(0, $ljOiP.createEditorToolbarActions)({
                items: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ASK_ROVO,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SUMMARISE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EMBED,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).EDIT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ],
                    // BUILTIN_TOOLBAR_KEYS.BORDER, // Border option is yet to be implemented.
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALIGNMENT,
                    ...(0, $iDrrr.fg)('cc-maui-toolbar-separators-update-jira') ? [] : [
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).OPEN_IN_NEW_WINDOW,
                        (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).SEPARATOR
                    ]
                ],
                moreItems: [
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).ALWAYS_SHOW_TITLE,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).COPY,
                    (0, $k9wGn.BUILTIN_TOOLBAR_KEYS).DELETE
                ]
            }),
        editorToolbarHandlers: {},
        renderLoadingComponent: (props)=>/*#__PURE__*/ $cozmU.createElement((0, $hjJUc.default), {
                animationDisabled: props.animationDisabled,
                icons: $af71dcb44dbd21c6$var$whiteboardIcons,
                testId: props.testId
            }),
        titleIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
        appearance: 'overlay',
        waitForContentReady: true
    }
};
module.exports["WhiteboardExperienceManifest"] = $af71dcb44dbd21c6$export$257420b954ccf94c;

});

parcelRegister("7wdoX", function(module, exports) {
var $3d7fb527228d62f2$export$e02855afa78b2d37 = /*#__PURE__*/ function(NativeEmbedCommandType) {
    NativeEmbedCommandType["FreezeFrameRequest"] = "freezeFrameRequest";
    NativeEmbedCommandType["UnfreezeFrame"] = "unfreezeFrame";
    return NativeEmbedCommandType;
}({});
var $3d7fb527228d62f2$export$f17561b95ea7b258 = /*#__PURE__*/ function(NativeEmbedChildCommandType) {
    NativeEmbedChildCommandType["FreezeFrameResponse"] = "freezeFrameResponse";
    NativeEmbedChildCommandType["UnfreezeFrameResponse"] = "unfreezeFrameResponse";
    return NativeEmbedChildCommandType;
}({});
module.exports["NativeEmbedChildCommandType"] = $3d7fb527228d62f2$export$f17561b95ea7b258;

});

parcelRegister("jOx93", function(module, exports) {

let $e6cc65bb48d31d5b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e6cc65bb48d31d5b$var$load("6wr18"),
    $e6cc65bb48d31d5b$var$load("b5HK3"),
    $e6cc65bb48d31d5b$var$load("9njOW"),
    $e6cc65bb48d31d5b$var$load("ceSYH"),
    $e6cc65bb48d31d5b$var$load("1AybA"),
    $e6cc65bb48d31d5b$var$load("7EorR"),
    $e6cc65bb48d31d5b$var$load("ffEVr"),
    $e6cc65bb48d31d5b$var$load("bY4kf")
]).then(()=>parcelRequire('htIUR'));

});

parcelRegister("cOau5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9iGS2 = parcelRequire("9iGS2");


var $F4YLX = parcelRequire("F4YLX");

const $831f4393e6328081$export$8c5d88a1b5304a38 = ({ contentId: contentId, isCommentContext: isCommentContext = false })=>{
    const baseExtension = (0, $9iGS2.getRedactionExtension)();
    const baseNodes = baseExtension.modules.nodes ?? {};
    return {
        ...baseExtension,
        modules: {
            ...baseExtension.modules,
            nodes: {
                ...baseNodes,
                default: {
                    ...baseNodes.default,
                    render: async ()=>(args)=>{
                            const node = args.node;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $F4YLX.TourableRedactionExtensionLoader), {
                                contentId: contentId,
                                extensionNode: node,
                                isCommentContext: isCommentContext
                            });
                        }
                }
            }
        }
    };
};
module.exports["createTourableRedactionExtension"] = $831f4393e6328081$export$8c5d88a1b5304a38;

});

parcelRegister("9iGS2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8Iwqw = parcelRequire("8Iwqw");


var $2W6JM = parcelRequire("2W6JM");

const $18242b0ae588a593$var$EXTENSION_TYPE = 'com.atlassian.guard-premium';
const $18242b0ae588a593$export$fd010a581322717b = (getSpotlightKey)=>({
        [$18242b0ae588a593$var$EXTENSION_TYPE]: ()=>{
            if (getSpotlightKey) {
                const key = getSpotlightKey();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
                    name: `redaction-marker-${key}`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2W6JM.RedactionMarker), null));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2W6JM.RedactionMarker), null);
        }
    });

const $18242b0ae588a593$export$12bebc06194b8864 = ()=>{
    return {
        title: 'Redaction',
        type: $18242b0ae588a593$var$EXTENSION_TYPE,
        key: 'redaction',
        description: 'Inserts redacted block.',
        icons: {
            '48': ()=>(parcelRequire("b4ALZ"))
        },
        modules: {
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>(0, $2W6JM.RedactionMarker),
                    // Redacted content must not be copyable; hide the copy button
                    // from the selection toolbar (delete-only).
                    hideCopyButton: true
                }
            }
        }
    };
};
module.exports["getRedactionExtension"] = $18242b0ae588a593$export$12bebc06194b8864;

});

parcelRegister("2W6JM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $GqOIS = parcelRequire("GqOIS");

const $41ad4d5eece5004a$var$redactionBarStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    aspectRatio: '3.4/1',
    height: '1lh',
    '@supports not (height: 1lh)': {
        height: '1.5em'
    },
    backgroundColor: 'color.background.neutral.bold.pressed',
    verticalAlign: 'middle',
    position: 'relative',
    // Redacted content must not be selectable/copyable.
    userSelect: 'none'
});
function $41ad4d5eece5004a$export$5d1828a8b51af09e() {
    if ((0, $iDrrr.fg)('platform_editor_redaction_shared_scribble')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $GqOIS.ScribbleBar), {
        background: "light"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "span",
        xcss: $41ad4d5eece5004a$var$redactionBarStyles
    });
}
module.exports["RedactionMarker"] = $41ad4d5eece5004a$export$5d1828a8b51af09e;

});

parcelRegister("GqOIS", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /**
 * `ScribbleBar` - the single "redacted" visual primitive.
 *
 * Renders an inline hand-drawn scribble that stands in for redacted content.
 * The stored text/ADF is already masked by the backend; this component only
 * makes the mask look intentional, branded, and accessible.
 *
 * Behavior (goal state, from Jono's PoC + the shipped Rovo Chat token):
 *   - Several SVG wavy strokes drawn left-to-right on mount (pen-scribble motion).
 *   - Respects `prefers-reduced-motion`: strokes render statically, no animation.
 *   - On hover/focus the strokes recolor to `color.background.accent.gray.bolder`
 *     and a Guard icon fades in as an affordance that the span is an intentional
 *     redaction. The darker fill keeps the icon legible on top of the strokes.
 *   - Wrapped in a two-line tooltip: "Redacted by your organization. / Powered
 *     by Atlassian Guard."
 *   - Always carries an accessible label so screen readers announce it.
 *
 * Ported from the Rovo Chat redaction token. Tuning lives in `./params` and the
 * stroke geometry in `./geometry`.
 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $9Ha4j = parcelRequire("9Ha4j");


var $2sQTo = parcelRequire("2sQTo");


var $6oxxi = parcelRequire("6oxxi");


var $caEjt = parcelRequire("caEjt");

const $0859956edfd5b2de$var$styles = {
    container: "_30huDKYbGa _0bjKvDcjp5 _034jHtYbGa _313842Pgdg _0adFHsPgdg _1DCdHiPgdg _2XsHFMPgdg _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _0KLXrujOvk _1UtDYzy7kJ _1mT5xdRAKS _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0jFU0VMmFU _3v5uP0RvL4 _1RrJLit2nV _0wOv4Q18ZR _20VacPYbGa _1ubuxonXvL _1NDpvb6wH8 _2wtOC9vc3e _34b3D2FQfX",
    svg: "_4bt5LAYvD1 _2WAcuGYvD1 _1mT5xdWVPG _2IhTonPgdg _4ApkO2Pgdg _0Bm75GPgdg _3OE6xYPgdg _1pp6NdYbGa _4e1TYv98eZ _3Z9K0wb8VS _1kOSYtKgXx _0qk6IKUtCU",
    svgActive: "_4e1TYvrxgm",
    icon: "_3iDTPbccYA _1mT5xdRAKS _42Yu6B7dHp _1VJPcaqBji _1YKVNsdnbC _3Z9K0wb8VS _1kOSYt9v2r _0qk6IKUtCU",
    iconActive: "_1YKVNs7dHp"
};
function $0859956edfd5b2de$var$prefersReducedMotion() {
    return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
} /**
   * Measures the container and drives the sequential stroke draw animation.
   * Ported from the Rovo Chat redaction token.
   */ 
function $0859956edfd5b2de$var$useScribbleAnimationInternal(activationDelay) {
    const containerRef = (0, $cozmU.useRef)(null);
    const pathRefs = (0, $cozmU.useRef)([]);
    const [pathData, setPathData] = (0, $cozmU.useState)([]);
    const [svgDims, setSvgDims] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const rafId = requestAnimationFrame(()=>{
            const { width: width, height: height } = el.getBoundingClientRect();
            const w = width || el.offsetWidth;
            const h = height || el.offsetHeight;
            if (w > 0 && h > 0) {
                setSvgDims({
                    w: w,
                    h: h
                });
                setPathData((0, $6oxxi.generateStrokes)(w, h));
            }
        });
        return ()=>cancelAnimationFrame(rafId);
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!pathData.length || !svgDims) return;
        const paths = pathRefs.current.filter((p)=>p !== null);
        if (!paths.length) return;
        const lengths = paths.map((p)=>p.getTotalLength()); // Reduced motion: render every stroke fully drawn, skip animation.
        if ($0859956edfd5b2de$var$prefersReducedMotion()) {
            paths.forEach((p)=>{
                p.style.strokeDasharray = 'none';
                p.style.strokeDashoffset = '0';
            });
            return;
        }
        paths.forEach((p, i)=>{
            p.style.strokeDasharray = String(lengths[i]);
            p.style.strokeDashoffset = String(lengths[i]);
        });
        let animRafId;
        const timerId = setTimeout(()=>{
            const strokeDuration = (0, $caEjt.PARAMS).duration / paths.length;
            const startTime = performance.now();
            const tick = (now)=>{
                const elapsed = now - startTime;
                let stillAnimating = false;
                paths.forEach((p, i)=>{
                    const strokeElapsed = elapsed - i * strokeDuration;
                    if (strokeElapsed < 0) {
                        p.style.strokeDashoffset = String(lengths[i]);
                        stillAnimating = true;
                    } else if (strokeElapsed >= strokeDuration) p.style.strokeDashoffset = '0';
                    else {
                        const localT = strokeElapsed / strokeDuration;
                        const progress = 1 - (1 - localT) ** 2;
                        p.style.strokeDashoffset = String(lengths[i] * (1 - progress));
                        stillAnimating = true;
                    }
                });
                if (stillAnimating) animRafId = requestAnimationFrame(tick);
            };
            animRafId = requestAnimationFrame(tick);
        }, activationDelay);
        return ()=>{
            clearTimeout(timerId); // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- animRafId may be unset
            if (animRafId) cancelAnimationFrame(animRafId);
        };
    }, [
        pathData,
        svgDims,
        activationDelay
    ]);
    return {
        containerRef: containerRef,
        pathRefs: pathRefs,
        pathData: pathData,
        svgDims: svgDims
    };
}
const $0859956edfd5b2de$export$168ed64195daae62 = ({ label: label, delay: delay = (0, $caEjt.PARAMS).delay })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const accessibleLabel = label ?? formatMessage((0, $2sQTo.messages).redactedTokenA11y);
    const { containerRef: containerRef, pathRefs: pathRefs, pathData: pathData, svgDims: svgDims } = $0859956edfd5b2de$var$useScribbleAnimationInternal(delay); // Tracked separately: the editor reclaims focus after a click, and that blur
    // must not drop the hover state.
    const [isHovered, setIsHovered] = (0, $cozmU.useState)(false);
    const [isFocused, setIsFocused] = (0, $cozmU.useState)(false);
    const isActive = isHovered || isFocused; // A pointer press focuses the button too, but that focus must not count as
    // activation: once the pointer leaves, the bar would stay active as if it had
    // been selected. Selection is the editor's job (its node-selection ring is
    // independent of this button) and in a read-only renderer there is nothing to
    // select, so only hover and keyboard focus activate the bar. Set on mousedown
    // (which precedes focus) and cleared once the focus event has been classified.
    const isPointerFocusRef = (0, $cozmU.useRef)(false);
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, formatMessage((0, $2sQTo.messages).redactedTooltipLine1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, formatMessage((0, $2sQTo.messages).redactedTooltipLine2)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: tooltipContent,
        position: "top"
    }, ({ ref: tooltipRef, onFocus: onTooltipFocus, onBlur: onTooltipBlur, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
            ...tooltipProps,
            type: "button",
            ref: (node)=>{
                containerRef.current = node;
                tooltipRef(node); // A bar that mounts under the pointer gets no mouseenter.
                if (node?.matches(':hover')) setIsHovered(true);
            },
            // tooltip trigger: it is keyboard-focusable by default (no
            // `tabIndex` on a non-interactive node), so keyboard users can reach
            // the tooltip (redaction reason / "Powered by Atlassian Guard") and
            // the Guard-icon affordance that pointer users get on hover.
            "aria-label": accessibleLabel,
            "data-testid": "guard-scribble-bar",
            // hover ring and overlay. No effect outside the editor.
            "data-inline-extension-layout": "flow",
            onMouseEnter: ()=>setIsHovered(true),
            onMouseLeave: ()=>setIsHovered(false),
            onMouseDown: ()=>{
                isPointerFocusRef.current = true;
            },
            onMouseUp: ()=>{
                // Covers a press on an already-focused button, where no focus event fires.
                isPointerFocusRef.current = false;
            },
            onFocus: (event)=>{
                onTooltipFocus(event);
                if (isPointerFocusRef.current) {
                    isPointerFocusRef.current = false;
                    return;
                }
                setIsFocused(true);
            },
            onBlur: (event)=>{
                onTooltipBlur(event);
                setIsFocused(false);
            },
            className: (0, $hekY6.default)([
                $0859956edfd5b2de$var$styles.container
            ])
        }, svgDims && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
            width: svgDims.w,
            height: svgDims.h,
            viewBox: `0 0 ${svgDims.w} ${svgDims.h}`,
            "data-testid": "guard-scribble-strokes",
            "aria-hidden": "true",
            focusable: "false",
            className: (0, $hekY6.default)([
                $0859956edfd5b2de$var$styles.svg,
                isActive && $0859956edfd5b2de$var$styles.svgActive
            ])
        }, pathData.map((d, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
                key: i,
                ref: (el)=>{
                    pathRefs.current[i] = el;
                },
                d: d,
                fill: "none",
                strokeLinecap: "round",
                strokeWidth: (0, $6oxxi.EFFECTIVE_STROKE_WIDTH)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                $0859956edfd5b2de$var$styles.icon,
                isActive && $0859956edfd5b2de$var$styles.iconActive
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Ha4j.GuardIcon), {
            appearance: "brand",
            size: "xxsmall",
            label: ""
        }))));
};
const $0859956edfd5b2de$export$6cdf261c0c5add35 = ()=>{
    // useRef (not useMemo) guarantees a stable wrapper identity across renders.
    const wrapper = (0, $cozmU.useRef)({
        ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createRef()
    });
    return wrapper.current;
};
module.exports["ScribbleBar"] = $0859956edfd5b2de$export$168ed64195daae62;

});

parcelRegister("2sQTo", function(module, exports) {
/**
 * Centralised i18n descriptors for `@atlassian/guard-redaction-ui`.
 *
 * Consumers should not redefine these strings — they are shared across all
 * Guard redaction surfaces so a translation change lands in one place.
 */ 
var $kSwu1 = parcelRequire("kSwu1");

const $3ccfb95ec5aea942$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    redactedByOrganization: {
        id: "guard-redaction-ui.enforcement.redacted",
        defaultMessage: "Redacted by your organization"
    },
    blockedByOrganization: {
        id: "guard-redaction-ui.enforcement.blocked",
        defaultMessage: "Blocked by your organization"
    },
    blockedBodyGeneric: {
        id: "guard-redaction-ui.block.body.generic",
        defaultMessage: "This was blocked by your organization\u2019s data security policy."
    },
    blockedBodyResponse: {
        id: "guard-redaction-ui.block.body.response",
        defaultMessage: "The response was blocked by your organization\u2019s data security policy."
    },
    traceId: {
        id: "guard-redaction-ui.block.trace-id",
        defaultMessage: "Trace ID: {traceId}"
    },
    redactedTokenA11y: {
        id: "guard-redaction-ui.scribble.a11y",
        defaultMessage: "Redacted content"
    },
    redactedTooltipLine1: {
        id: "guard-redaction-ui.scribble.tooltip.line1",
        defaultMessage: "Redacted by your organization."
    },
    redactedTooltipLine2: {
        id: "guard-redaction-ui.scribble.tooltip.line2",
        defaultMessage: "Powered by Atlassian Guard."
    },
    flagTitle: {
        id: "guard-redaction-ui.flag.title",
        defaultMessage: "Redacted by your organization"
    },
    flagDescriptionSingular: {
        id: "guard-redaction-ui.flag.description.singular",
        defaultMessage: "Sensitive information was detected in the {location} and has been redacted."
    },
    flagDescriptionPlural: {
        id: "guard-redaction-ui.flag.description.plural",
        defaultMessage: "{count} sensitive items were detected in the {location} and have been redacted."
    },
    flagRemoveRedaction: {
        id: "guard-redaction-ui.flag.action.remove-redaction",
        defaultMessage: "Remove redaction"
    },
    flagRemoveRedactions: {
        id: "guard-redaction-ui.flag.action.remove-redactions",
        defaultMessage: "Remove redactions"
    },
    flagLearnMore: {
        id: "guard-redaction-ui.flag.action.learn-more",
        defaultMessage: "Learn more"
    },
    flagIconLabel: {
        id: "guard-redaction-ui.flag.icon.label",
        defaultMessage: "Atlassian Guard"
    },
    flagLocationPageBody: {
        id: "guard-redaction-ui.flag.location.page-body",
        defaultMessage: "page body"
    },
    flagLocationPageTitle: {
        id: "guard-redaction-ui.flag.location.page-title",
        defaultMessage: "page title"
    },
    flagLocationComment: {
        id: "guard-redaction-ui.flag.location.comment",
        defaultMessage: "comment"
    },
    flagLocationIssueDescription: {
        id: "guard-redaction-ui.flag.location.issue-description",
        defaultMessage: "description"
    },
    flagLocationIssueSummary: {
        id: "guard-redaction-ui.flag.location.issue-summary",
        defaultMessage: "summary"
    },
    flagLocationCustomField: {
        id: "guard-redaction-ui.flag.location.custom-field",
        defaultMessage: "custom field"
    }
});
module.exports["messages"] = $3ccfb95ec5aea942$export$defe85febe8b728c;

});

parcelRegister("6oxxi", function(module, exports) {
/**
 * Stroke geometry for the `ScribbleBar`: pure functions from the bar's size to
 * SVG path strings, kept out of the component so containment is unit testable.
 *
 * A cubic bezier stays within the convex hull of its control points, so keeping
 * every point half a stroke (plus wiggle) inside the per-edge insets keeps the
 * drawn ink inside them too.
 */ 
var $caEjt = parcelRequire("caEjt");

const $3a5557d9ea064e0e$export$a35b1a25efe697a5 = Math.max(20 * (0, $caEjt.PARAMS).strokeWidth, 6);
const $3a5557d9ea064e0e$var$HALF_STROKE = $3a5557d9ea064e0e$export$a35b1a25efe697a5 / 2;
const $3a5557d9ea064e0e$export$e6bd8832925633b8 = (0, $caEjt.PARAMS).insetTop + $3a5557d9ea064e0e$var$HALF_STROKE + (0, $caEjt.PARAMS).wiggle;
const $3a5557d9ea064e0e$export$2f878cc6c7c44381 = (0, $caEjt.PARAMS).insetBottom + $3a5557d9ea064e0e$var$HALF_STROKE + (0, $caEjt.PARAMS).wiggle;
const $3a5557d9ea064e0e$export$e0b66c24764c59ce = (0, $caEjt.PARAMS).insetX + $3a5557d9ea064e0e$var$HALF_STROKE;
const $3a5557d9ea064e0e$var$REFERENCE_LINE_HEIGHT = 20;
const $3a5557d9ea064e0e$var$clamp = (value, min, max)=>Math.min(Math.max(value, min), max);
const $3a5557d9ea064e0e$var$random = (amplitude)=>(Math.random() * 2 - 1) * amplitude;
const $3a5557d9ea064e0e$var$cubic = (p0, p1, p2, p3, t)=>{
    const u = 1 - t;
    return u * u * u * p0 + 3 * u * u * t * p1 + 3 * u * t * t * p2 + t * t * t * p3;
};
const $3a5557d9ea064e0e$export$59704e2c1673d200 = (s, x)=>{
    const leftToRight = s.x0 <= s.x3;
    const target = $3a5557d9ea064e0e$var$clamp(x, Math.min(s.x0, s.x3), Math.max(s.x0, s.x3));
    let lo = 0;
    let hi = 1;
    for(let i = 0; i < 24; i++){
        const mid = (lo + hi) / 2;
        const xm = $3a5557d9ea064e0e$var$cubic(s.x0, s.cx1x, s.cx2x, s.x3, mid);
        if (xm < target === leftToRight) lo = mid;
        else hi = mid;
    }
    const t = (lo + hi) / 2;
    return $3a5557d9ea064e0e$var$cubic(s.y, s.cx1y, s.cx2y, s.y, t);
};
const $3a5557d9ea064e0e$var$serialize = ({ x0: x0, y: y, cx1x: cx1x, cx1y: cx1y, cx2x: cx2x, cx2y: cx2y, x3: x3 }, dy)=>`M ${x0.toFixed(2)} ${(y + dy).toFixed(2)} C ${cx1x.toFixed(2)} ${(cx1y + dy).toFixed(2)} ${cx2x.toFixed(2)} ${(cx2y + dy).toFixed(2)} ${x3.toFixed(2)} ${(y + dy).toFixed(2)}`;
function $3a5557d9ea064e0e$export$d510b227ac2107c1(width, height) {
    const count = Math.max(Math.round((0, $caEjt.PARAMS).strokeCount * (height / $3a5557d9ea064e0e$var$REFERENCE_LINE_HEIGHT)), 1);
    // Allowed range for stroke center lines; collapses to the middle for tiny boxes.
    const bandTop = Math.min($3a5557d9ea064e0e$export$e6bd8832925633b8, height / 2);
    const bandBottom = Math.max(height - $3a5557d9ea064e0e$export$2f878cc6c7c44381, bandTop);
    const xStart = Math.min($3a5557d9ea064e0e$export$e0b66c24764c59ce, width / 2);
    const xEnd = Math.max(width - $3a5557d9ea064e0e$export$e0b66c24764c59ce, width / 2);
    const capJitter = Math.min((0, $caEjt.PARAMS).capJitter, (xEnd - xStart) / 4);
    const strokes = Array.from({
        length: count
    }, (_, i)=>{
        const t = count === 1 ? 0.5 : i / (count - 1);
        const yBase = bandTop + t * (bandBottom - bandTop);
        const isEdge = i === 0 || i === count - 1;
        const y = $3a5557d9ea064e0e$var$clamp(yBase + $3a5557d9ea064e0e$var$random(isEdge ? (0, $caEjt.PARAMS).edgeJitter : (0, $caEjt.PARAMS).jitter), bandTop, bandBottom);
        const cx1y = y + $3a5557d9ea064e0e$var$random((0, $caEjt.PARAMS).wiggle);
        const cx2y = y + $3a5557d9ea064e0e$var$random((0, $caEjt.PARAMS).wiggle);
        const left = xStart + Math.random() * capJitter;
        const right = xEnd - Math.random() * capJitter;
        const span = right - left;
        const leftToRight = i % 2 === 0;
        const x0 = leftToRight ? left : right;
        const x3 = leftToRight ? right : left;
        const nearX = left + span * (0.3 + $3a5557d9ea064e0e$var$random((0, $caEjt.PARAMS).drift));
        const farX = left + span * (0.7 + $3a5557d9ea064e0e$var$random((0, $caEjt.PARAMS).drift));
        const cx1x = leftToRight ? nearX : farX;
        const cx2x = leftToRight ? farX : nearX;
        return {
            x0: x0,
            y: y,
            cx1x: cx1x,
            cx1y: cx1y,
            cx2x: cx2x,
            cx2y: cx2y,
            x3: x3
        };
    });
    // Shift the stack so the ink above and below the Guard icon is centered on it.
    const iconHalf = Math.min((0, $caEjt.PARAMS).iconSize / 2, (xEnd - xStart) / 2);
    const samples = Array.from({
        length: 5
    }, (_, i)=>width / 2 - iconHalf + i * iconHalf / 2);
    const localYs = strokes.flatMap((s)=>samples.map((x)=>$3a5557d9ea064e0e$export$59704e2c1673d200(s, x)));
    const localCenter = (Math.min(...localYs) + Math.max(...localYs)) / 2;
    const wanted = height / 2 + (0, $caEjt.PARAMS).iconOffset - localCenter;
    // Clamp so the convex hull stays within the band.
    const hullYs = strokes.flatMap((s)=>[
            s.y,
            s.cx1y,
            s.cx2y
        ]);
    const minShift = bandTop - (0, $caEjt.PARAMS).wiggle - Math.min(...hullYs);
    const maxShift = bandBottom + (0, $caEjt.PARAMS).wiggle - Math.max(...hullYs);
    const dy = minShift <= maxShift ? $3a5557d9ea064e0e$var$clamp(wanted, minShift, maxShift) : (minShift + maxShift) / 2;
    return strokes.map((s)=>$3a5557d9ea064e0e$var$serialize(s, dy));
}
module.exports["EFFECTIVE_STROKE_WIDTH"] = $3a5557d9ea064e0e$export$a35b1a25efe697a5;
module.exports["generateStrokes"] = $3a5557d9ea064e0e$export$d510b227ac2107c1;

});

parcelRegister("caEjt", function(module, exports) {
/**
 * Tuning for the hand-drawn scribble; stroke geometry lives in `./geometry`.
 * Distances are px relative to the bar's box. The editor's inline extension
 * lozenge sits ~2.2px above the box top and ~0.7px above its bottom for 16px
 * body text, which is what the vertical insets are measured against.
 */ const $dafb46552dbcb184$export$f80c391eaed27b3 = {
    duration: 800,
    delay: 400,
    cascadeOffset: 10,
    strokeWidth: 0.4,
    strokeCount: 5,
    wiggle: 1.5,
    jitter: 1.5,
    edgeJitter: 0.5,
    drift: 0.08,
    capJitter: 1,
    insetX: 0,
    insetTop: -2.65,
    insetBottom: 0.2,
    iconSize: 12,
    iconOffset: -1.425
};
module.exports["PARAMS"] = $dafb46552dbcb184$export$f80c391eaed27b3;

});

parcelRegister("b4ALZ", function(module, exports) {

let $80fc97cf3f3f4d02$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80fc97cf3f3f4d02$var$load("gCHto").then(()=>parcelRequire('47bbw'));

});

parcelRegister("kycWk", function(module, exports) {
// Extension
const $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1 = 'com.atlassian.guard-premium';
const $a7399ed0bcbe7ac9$export$d20f6356992396b7 = 'false';
var $a7399ed0bcbe7ac9$export$80edbf15fa61a4db = /*#__PURE__*/ function(MessageType) {
    MessageType["Engagement"] = "engagement";
    MessageType["Transactional"] = "transactional";
    return MessageType;
}({});
var $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a = /*#__PURE__*/ function(RedactionsTourSteps) {
    RedactionsTourSteps[RedactionsTourSteps["FIRST"] = 0] = "FIRST";
    RedactionsTourSteps[RedactionsTourSteps["SECOND"] = 1] = "SECOND";
    return RedactionsTourSteps;
}({});
var $a7399ed0bcbe7ac9$export$f5d398bf946a6bf8 = /*#__PURE__*/ function(RedactionTourStepSource) {
    RedactionTourStepSource["bodyRedaction"] = "bodyRedaction";
    RedactionTourStepSource["titleRedaction"] = "titleRedaction";
    return RedactionTourStepSource;
}({});
const $a7399ed0bcbe7ac9$export$4d54b6650166caf9 = {
    REDACTION: 'redactions-tour-redaction',
    DETAILS_BUTTON: 'redactions-tour-details-button'
};
const $a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX = 'redactions-tour:';
const $a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX = 'object-sidebar-tour-target:';
const $a7399ed0bcbe7ac9$export$4ac8baee730e0515 = {
    REDACTION_EXTENSION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}redaction-extension`,
    TITLE_REDACTION: `${$a7399ed0bcbe7ac9$var$REDACTIONS_TOUR_TARGET_PREFIX}title-redaction`,
    // Note: SpotlightTarget already exist on this element, so we must target that one
    SIDEBAR_DETAILS_BUTTON: `${$a7399ed0bcbe7ac9$var$OBJECT_SIDEBAR_TOUR_TARGET_PREFIX}sidebar-details-button`
};
const $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f = 'https://support.atlassian.com/confluence-cloud/docs/how-redaction-works/';
module.exports["REDACTION_EXTENSION_TYPE"] = $a7399ed0bcbe7ac9$export$ebe904a0bbf57df1;
module.exports["IS_DISMISSED_FLAG"] = $a7399ed0bcbe7ac9$export$d20f6356992396b7;
module.exports["MessageType"] = $a7399ed0bcbe7ac9$export$80edbf15fa61a4db;
module.exports["RedactionsTourSteps"] = $a7399ed0bcbe7ac9$export$ca2bc0ed0fbb9a2a;
module.exports["RedactionTourStepSource"] = $a7399ed0bcbe7ac9$export$f5d398bf946a6bf8;
module.exports["REDACTIONS_TOUR_MESSAGE_IDS"] = $a7399ed0bcbe7ac9$export$4d54b6650166caf9;
module.exports["REDACTIONS_TOUR_TARGETS"] = $a7399ed0bcbe7ac9$export$4ac8baee730e0515;
module.exports["READ_MORE_URL"] = $a7399ed0bcbe7ac9$export$765a9736cc8e2d1f;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $e6fvz = parcelRequire("e6fvz");


var $cozmU = parcelRequire("cozmU");


var $2OQaT = parcelRequire("2OQaT");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $3FO8k = parcelRequire("3FO8k");

const $6fc4b7bb962289cc$export$75d6c00965e77c = (0, $e6fvz.default);
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $cozmU.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const personalization = (0, $cozmU.useContext)((0, $2OQaT.OnboardingPersonalizationContext));
    // Compare key values so inline arrays do not invalidate the filtered result on every render.
    const serializedKeys = (0, $cozmU.useMemo)(()=>JSON.stringify(Array.isArray(key) ? key : [
            key
        ]), [
        key
    ]);
    const keys = (0, $cozmU.useMemo)(()=>JSON.parse(serializedKeys), [
        serializedKeys
    ]);
    const hasPersonalization = !!personalization && keys.every((item)=>personalization.keys.includes(item));
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    const { data: data, error: error, loading: loading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $3FO8k.default), {
        variables: {
            key: hasPersonalization ? [
                ...personalization.keys
            ] : key
        },
        skip: skipQuery,
        __callerPackage__: "onboarding-helpers"
    });
    const filteredData = (0, $cozmU.useMemo)(()=>data && hasPersonalization ? {
            onboardingState: data.onboardingState?.filter((item)=>keys.includes(item.key)) ?? null
        } : data, [
        data,
        hasPersonalization,
        keys
    ]);
    const refetchRequestedKeys = (0, $cozmU.useCallback)((vars)=>refetch({
            key: keys,
            ...vars
        }), [
        refetch,
        keys
    ]);
    return {
        data: filteredData,
        error: error,
        loading: loading,
        refetch: hasPersonalization ? refetchRequestedKeys : refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("e6fvz", function(module, exports) {
/**
 * @generated SignedSource<<2e96995cd41622171f58df93d4ef5369>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6eba286460e57a30$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": {
        "plural": true,
        "throwOnFieldError": true
    },
    "name": "onboardingState_state",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ],
    "type": "OnboardingState"
};
$6eba286460e57a30$var$node.hash = "da011c9ee7ee2f3537016ecf931bb29c";
var $6eba286460e57a30$export$2e2bcd8739ae039 = $6eba286460e57a30$var$node;
module.exports["default"] = $6eba286460e57a30$export$2e2bcd8739ae039;

});

parcelRegister("2OQaT", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $ba20d15733355e18$export$9bb9b7f6216e0638 = (0, $cozmU.createContext)(undefined);
module.exports["OnboardingPersonalizationContext"] = $ba20d15733355e18$export$9bb9b7f6216e0638;

});

parcelRegister("cbOce", function(module, exports) {
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("2BAFx", function(module, exports) {
class $d32907502a426d2e$var$DialogKeyState {
    get nextKey() {
        return this._nextKey++;
    }
    set nextKey(newKey) {
        if (newKey > this._nextKey) this._nextKey = newKey;
    }
    constructor(){
        this._nextKey = 0;
    }
}
const $d32907502a426d2e$export$2e170616461fb3b6 = new $d32907502a426d2e$var$DialogKeyState();
module.exports["dialogKeyState"] = $d32907502a426d2e$export$2e170616461fb3b6;

});

parcelRegister("4hCFw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $6SsN4 = parcelRequire("6SsN4");


var $w6R6I = parcelRequire("w6R6I");


var $cXtTj = parcelRequire("cXtTj");


var $7akNQ = parcelRequire("7akNQ");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $fNTq8 = parcelRequire("fNTq8");


var $cFVPs = parcelRequire("cFVPs");


var $bBIvl = parcelRequire("bBIvl");


var $5JhlM = parcelRequire("5JhlM");


var $d5gEx = parcelRequire("d5gEx");


var $gZFfs = parcelRequire("gZFfs");


var $i8aB6 = parcelRequire("i8aB6");


var $a7t2v = parcelRequire("a7t2v");


var $lgull = parcelRequire("lgull");


var $iTtzC = parcelRequire("iTtzC");

const $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE = 'SMARTLINK';
const $2795fb4dc781be1d$var$DEFAULT_MAX_LINES = 4;
const $2795fb4dc781be1d$var$styles = {
    container: "_2sNsIg7NXe"
};
const $2795fb4dc781be1d$var$getContentTypeParam = (contentType)=>contentType === 'page' ? 'PAGE' : contentType === 'blogpost' ? 'BLOGPOST' : null;
const $2795fb4dc781be1d$var$getAnalyticsConfig = (props)=>({
        product: 'confluence',
        subproduct: 'confluence',
        source: 'confluencePage',
        aiFeatureName: 'aiSnippet',
        proactiveGeneratedAI: 1,
        userGeneratedAI: 0,
        additionalAttributes: {
            contentId: props.contentId,
            contentType: props.contentType,
            from: props.from ?? $2795fb4dc781be1d$var$ANALYTICS_FROM_CODE,
            productAttributionOverride: 'confluence'
        },
        enablePlatformEvents: true,
        skipAISessionValidation: true
    }); /**
     * Main AI Snippet component. Fetches the AI snippet data from the server and displays it.
     * If the snippet data type is not supported, it will display the fallback component.
     * If the AI snippet data is not found or another error occurs it will display the AISnippet component,
     * but with the fallback text in place of the response text.
     *
     * @param contentId - The content ID of the AI snippet
     * @param contentType - The content type of the AI snippet
     * @param cloudId - The cloud ID of the AI snippet
     * @param fallbackText - The text to display if the AI snippet fails to load
     * @param fallbackComponent - The component to display if the AI snippet is not supported
     * @param source [optional] - The source for where the AI snippet was triggered from defaults to 'smartlink'
     * @param onLoadComplete [optional] - The callback function that executes when loading has completed
     * @returns
     */ 
const $2795fb4dc781be1d$export$1b2af18ca4bb327b = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $fNTq8.AIEventsInstrumentationProvider), {
        config: $2795fb4dc781be1d$var$getAnalyticsConfig(props)
    }, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$ac90160f7ae1e32f, props));
};
const $2795fb4dc781be1d$export$ac90160f7ae1e32f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId, fallbackText: fallbackText, fallbackComponent: fallbackComponent, userId: userId, displayName: displayName, source: source = 'smartlink', maxLines: maxLines = $2795fb4dc781be1d$var$DEFAULT_MAX_LINES, isHidden: isHidden = false, onLoadComplete: onLoadComplete, showFooter: showFooter, showAwareness: showAwareness })=>{
    const [queryRef, loadQuery] = (0, $6SsN4.useQueryLoader)((0, $iTtzC.default));
    const isLoadingRef = (0, $cozmU.useRef)(true);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $cFVPs.useAIEventsInstrumentation)();
    const { start: start, success: success, failure: failure } = (0, $i8aB6.useUFOExperience)({
        id: 'ai-snippet-load',
        component: 'ai-snippet',
        type: (0, $gZFfs.ExperienceTypes).Load,
        performanceType: (0, $gZFfs.ExperiencePerformanceTypes).InlineResult
    });
    const contentTypeParam = $2795fb4dc781be1d$var$getContentTypeParam(contentType);
    const isValidQuery = contentType && cloudId && contentId && contentTypeParam;
    const isEnabledForJira = (0, $iDrrr.fg)('jira-cc-ai-snippet-gate');
    const isTrackingEnabled = (0, $cXtTj.default).getExperimentValue('cc-ai-snippet-experiment-tracking', 'isEnabled', false);
    (0, $cozmU.useEffect)(()=>{
        if (!isHidden) trackAIInteractionInit();
        return ()=>{
            if (isLoadingRef.current && !isHidden) trackAIInteractionDismiss();
        }; // Only on component mount/unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $cozmU.useEffect)(()=>{
        isLoadingRef.current = !queryRef;
        if (queryRef) {
            if (isTrackingEnabled) success();
            onLoadComplete?.();
        }
    }, [
        queryRef,
        onLoadComplete,
        success,
        isTrackingEnabled
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isValidQuery) // Skip query if we don't have valid params as we'll just return the fallback component
        return;
        if (isTrackingEnabled) start();
        loadQuery({
            contentId: contentId,
            contentType: contentTypeParam,
            cloudId: cloudId,
            includeMe: isEnabledForJira
        });
    }, [
        contentId,
        contentTypeParam,
        cloudId,
        loadQuery,
        isValidQuery,
        isEnabledForJira,
        start,
        isTrackingEnabled
    ]);
    if (!isValidQuery) return fallbackComponent;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
            text: fallbackText,
            contentId: contentId,
            showFooter: false,
            showAwareness: showAwareness,
            source: source,
            isHidden: isHidden,
            maxLines: maxLines
        }),
        onError: (error)=>{
            if (!isHidden) {
                if (isTrackingEnabled) failure({
                    metadata: {
                        errorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                        errorMessage: error.message || 'Unknown error'
                    }
                });
                trackAIResultError({
                    aiErrorCode: 'extensions' in error ? error.extensions?.statusCode || 500 : 999,
                    aiErrorMessage: error.message || 'Unknown error'
                });
            }
        }
    }, /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($2795fb4dc781be1d$var$styles.container)
    }, /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null)
    }, queryRef ? /*#__PURE__*/ $cozmU.createElement((0, $lgull.AISnippetLoader), {
        queryRef: queryRef,
        fallbackText: fallbackText,
        contentId: contentId,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        showFooter: showFooter,
        showAwareness: showAwareness
    }) : /*#__PURE__*/ $cozmU.createElement((0, $bBIvl.AIStreamLoading), null))));
    return /*#__PURE__*/ $cozmU.createElement((0, $7akNQ.FlagsProvider), null, isEnabledForJira ? content : /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $2795fb4dc781be1d$var$SNIPPET_ENTRYPOINT_ID,
        userId: userId,
        displayName: displayName
    }, content));
};
const $2795fb4dc781be1d$export$c9a07cebec67e951 = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement((0, $d5gEx.RelayEnvironmentProvider), null, /*#__PURE__*/ $cozmU.createElement($2795fb4dc781be1d$export$1b2af18ca4bb327b, props));
};
module.exports["AISnippetWithRelayEnvironment"] = $2795fb4dc781be1d$export$c9a07cebec67e951;

});

parcelRegister("fNTq8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jU6s6 = parcelRequire("jU6s6");


var $4dW9D = parcelRequire("4dW9D");


var $jLdbZ = parcelRequire("jLdbZ");

const $8a30b5a238fd1faa$var$validateAIEventsConfig = (config)=>{
    if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
};
const $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8 = ({ children: children, config: config })=>{
    const { refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = (0, $jLdbZ.useAIInstrumentationSetup)(config.singleInstrumentationID);
    const contextValue = (0, $cozmU.useMemo)(()=>{
        $8a30b5a238fd1faa$var$validateAIEventsConfig(config);
        return {
            config: {
                ...(0, $4dW9D.defaultAIEventsInstrumentationConfigValues),
                ...config,
                product: config.product.toLowerCase()
            },
            refreshSingleInstrumentationID: refreshSingleInstrumentationID,
            getSingleInstrumentationID: getSingleInstrumentationID,
            setAISessionState: setAISessionState,
            getAISessionState: getAISessionState
        };
    }, [
        config,
        refreshSingleInstrumentationID,
        getSingleInstrumentationID,
        setAISessionState,
        getAISessionState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jU6s6.AIEventsInstrumentationContext).Provider, {
        value: contextValue
    }, children);
};
module.exports["AIEventsInstrumentationProvider"] = $8a30b5a238fd1faa$export$b5d4bc85dfbaa4f8;

});

parcelRegister("bBIvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $7m1U4 = parcelRequire("7m1U4");

const $b089d8c6b56c64f6$var$styles = (0, $buxP3.xcss)({
    color: 'color.text.subtle'
});
const $b089d8c6b56c64f6$var$i18n = (0, $kSwu1.defineMessages)({
    generatingSummaryText: {
        id: "ai-stream-loading.title",
        defaultMessage: "AI is working..."
    },
    generatingSummaryAnimationAlt: {
        id: "ai-stream-loading.generation-animation",
        defaultMessage: "Generating"
    }
});
const $b089d8c6b56c64f6$export$47a62cbf3ee79fef = ({ padding: padding = 'space.300', titleMessage: titleMessage })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const title = titleMessage ?? $b089d8c6b56c64f6$var$i18n.generatingSummaryText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        padding: padding,
        xcss: $b089d8c6b56c64f6$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7m1U4.GeneratingStreamAnimation), {
        alt: formatMessage($b089d8c6b56c64f6$var$i18n.generatingSummaryAnimationAlt)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), title)));
};
module.exports["AIStreamLoading"] = $b089d8c6b56c64f6$export$47a62cbf3ee79fef;

});

parcelRegister("7m1U4", function(module, exports) {
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $cozmU = parcelRequire("cozmU");

const $c344a4b7f3959518$export$3709887a1be0e305 = ({ alt: alt })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
module.exports["GeneratingStreamAnimation"] = $c344a4b7f3959518$export$3709887a1be0e305;

});

parcelRegister("5JhlM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF = 'customfield_10047';
const $2eafd2f31cb677aa$export$f906c21bacdb2d8e = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $2eafd2f31cb677aa$export$e9e654940dee103b = ({ children: children, entrypointId: entrypointId, locale: locale, feedbackContextId: feedbackContextId = $2eafd2f31cb677aa$var$FEEDBACK_CONTEXT_CF, feedbackContext: feedbackContext = {}, userId: userId, displayName: displayName })=>{
    const { locale: intlLocale } = (0, $kSwu1.useIntl)();
    const feedbackContextString = Object.entries(feedbackContext).map(([key, value])=>`${key}: ${JSON.stringify(value)}`).join(' ');
    const contextValue = (0, $cozmU.useMemo)(()=>({
            entrypointId: entrypointId,
            feedbackContextId: feedbackContextId,
            feedbackContext: feedbackContextString,
            locale: locale || intlLocale,
            userId: userId,
            displayName: displayName
        }), [
        entrypointId,
        feedbackContextId,
        feedbackContextString,
        locale,
        intlLocale,
        userId,
        displayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2eafd2f31cb677aa$export$f906c21bacdb2d8e.Provider, {
        value: contextValue
    }, children);
};
const $2eafd2f31cb677aa$export$ff3deb4415ee32e3 = ()=>{
    const context = (0, $cozmU.useContext)($2eafd2f31cb677aa$export$f906c21bacdb2d8e);
    if (context === undefined) throw new Error('useAIFeedbackProperties must be used within a AIFeedbackPropertiesProvider');
    return context;
};
module.exports["AIFeedbackPropertiesProvider"] = $2eafd2f31cb677aa$export$e9e654940dee103b;
module.exports["useAIFeedbackProperties"] = $2eafd2f31cb677aa$export$ff3deb4415ee32e3;

});

parcelRegister("a7t2v", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $303LV = parcelRequire("303LV");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $cFVPs = parcelRequire("cFVPs");


var $cAiYt = parcelRequire("cAiYt");


var $aIn0d = parcelRequire("aIn0d");


var $cHkK6 = parcelRequire("cHkK6");


var $5GgqH = parcelRequire("5GgqH");

const $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME = 3000;
const $24521ba341a214c8$var$sanitizeMarkdown = (text)=>{
    if (!text) return '';
    return text.replace(/={4,}/g, '===') // h1 headers
    .replace(/-{4,}/g, '---'); // h2 headers
};
const $24521ba341a214c8$export$3cf37822a11d3ff3 = ({ text: text, contentId: contentId, showFooter: showFooter = true, showAwareness: showAwareness = false, source: source, isHidden: isHidden, maxLines: maxLines, renderAsMarkdown: renderAsMarkdown = true })=>{
    const ref = (0, $cozmU.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $5GgqH.usePopupDwellTime)(ref, 250);
    const { trackAIResultView: trackAIResultView, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $cFVPs.useAIEventsInstrumentation)();
    // This is needed to keep the snippet value in scope when running the unmount effect
    const snippetValueRef = (0, $cozmU.useRef)(text);
    const handleLikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('up');
    }, [
        trackAIFeedbackSubmit
    ]);
    const handleDislikeClicked = (0, $cozmU.useCallback)(()=>{
        trackAIFeedbackSubmit('down');
    }, [
        trackAIFeedbackSubmit
    ]);
    (0, $cozmU.useEffect)(()=>{
        const currentText = snippetValueRef.current;
        return ()=>{
            const dwellTime = getDwellTime();
            if (!isHidden) {
                if (showFooter && currentText && dwellTime >= $24521ba341a214c8$var$MAU_CRITERIA_DWELL_TIME) trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: true
                    }
                });
                else trackAIResultView({
                    attributes: {
                        dwellTime: dwellTime,
                        source: source,
                        wasShownAIContent: showFooter && !!currentText
                    },
                    doesNotMeetMAUCriteria: true
                });
            }
        };
    // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        ref: ref
    }, showAwareness && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAiYt.AIAwareness), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        maxLines: maxLines
    }, renderAsMarkdown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $303LV.default), {
        options: {
            disableParsingRawHTML: true
        }
    }, $24521ba341a214c8$var$sanitizeMarkdown(text || '')) : text || ''), showFooter && text && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aIn0d.AIDisclaimer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cHkK6.AIFeedbackComponent), {
        contentId: contentId,
        onLikeClicked: handleLikeClicked,
        onDislikeClicked: handleDislikeClicked
    })));
};
module.exports["AISnippetContent"] = $24521ba341a214c8$export$3cf37822a11d3ff3;

});

parcelRegister("cAiYt", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $w6R6I = parcelRequire("w6R6I");


var $etoPX = parcelRequire("etoPX");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $4aRua = parcelRequire("4aRua");


var $1kxSE = parcelRequire("1kxSE");

const $b6dbb4b671decd4a$var$styles = {
    text: "_00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8"
};
const $b6dbb4b671decd4a$export$fde99ed387d90f1 = ({ variant: variant = 'summary' })=>{
    const MESSAGE_MAP = {
        summary: (0, $1kxSE.i18n).rovoAwarenessMessage,
        define: (0, $1kxSE.i18n).rovoAwarenessDefineMessage
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = MESSAGE_MAP[variant];
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($b6dbb4b671decd4a$var$styles.text)
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ $cozmU.createElement((0, $etoPX.RovoIcon), {
        size: "xxsmall",
        appearance: "brand"
    }), /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage(message))));
};
module.exports["AIAwareness"] = $b6dbb4b671decd4a$export$fde99ed387d90f1;

});

parcelRegister("1kxSE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $c8fb6889a2026e6c$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    rovoAwarenessMessage: {
        id: "ai-awareness.rovoAwarenessMessage",
        defaultMessage: "Summary by Rovo"
    },
    rovoAwarenessDefineMessage: {
        id: "ai-awareness-define.message",
        defaultMessage: "Definition by Rovo"
    }
});
module.exports["i18n"] = $c8fb6889a2026e6c$export$a7357cdd1f0b0168;

});

parcelRegister("cHkK6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7ZB0A = parcelRequire("7ZB0A");


var $2eX69 = parcelRequire("2eX69");


var $4MnFz = parcelRequire("4MnFz");


var $chu6R = parcelRequire("chu6R");


var $i1t43 = parcelRequire("i1t43");


var $iDrrr = parcelRequire("iDrrr");


var $3izAL = parcelRequire("3izAL");


var $kz1Yj = parcelRequire("kz1Yj");


var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $5JhlM = parcelRequire("5JhlM");


var $gecH2 = parcelRequire("gecH2");

const $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $2e66c8b5b2928379$var$i18n = (0, $kSwu1.defineMessages)({
    flagTitle: {
        id: "quick-summary.feedback.flag.title",
        defaultMessage: "Thanks!"
    },
    flagDescription: {
        id: "quick-summary.feedback.flag.description",
        defaultMessage: "We appreciate you taking the time to send this feedback."
    },
    likeTooltip: {
        id: "quick-summary.like.tooltip",
        defaultMessage: "Helpful"
    },
    dislikeTooltip: {
        id: "quick-summary.dislike.tooltip",
        defaultMessage: "Not helpful"
    },
    feedbackTitle: {
        id: "quick-summary.feedback.title",
        defaultMessage: "Help us improve Atlassian Intelligence"
    },
    feedbackSummaryTitle: {
        id: "quick-summary.feedback.summary.title",
        defaultMessage: "Tell us about your experience"
    },
    feedbackSummaryPlaceholder: {
        id: "quick-summary.feedback.summary.placeholder",
        defaultMessage: "What did Atlassian Intelligence do well? What could be improved?"
    },
    canContactText: {
        id: "quick-summary.feedback.can-contact.label",
        defaultMessage: "Atlassian can contact me about this feedback. See our {privacyPolicyLink}."
    },
    privacyPolicyLink: {
        id: "quick-summary.feedback.privacy-policy.link",
        defaultMessage: "privacy policy"
    },
    improveAtlassianText: {
        id: "quick-summary.feedback.improve-atlassian",
        defaultMessage: "I\u2019d like to help improve Atlassian products by joining the {researchGroupLink}."
    },
    improveAtlassianTextAppify: {
        id: "quick-summary.feedback.improve-atlassian-appify",
        defaultMessage: "I\u2019d like to help improve Atlassian apps by joining the {researchGroupLink}."
    },
    researchGroupLink: {
        id: "quick-summary.feedback.research-group.link",
        defaultMessage: "Atlassian Research Group"
    }
});
const $2e66c8b5b2928379$var$PrivacyPolicyLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.privacyPolicyLink));
const $2e66c8b5b2928379$var$ResearchGroupLink = ({ link: link })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
        target: "_blank",
        href: link
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2e66c8b5b2928379$var$i18n.researchGroupLink));
const $2e66c8b5b2928379$var$CanContactLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$2e66c8b5b2928379$var$i18n.canContactText,
        values: {
            privacyPolicyLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$PrivacyPolicyLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_PRIVACY_POLICY
            })
        }
    });
};
const $2e66c8b5b2928379$var$EnrolLabel = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $iDrrr.fg)('product-terminology-refresh') ? $2e66c8b5b2928379$var$i18n.improveAtlassianTextAppify : $2e66c8b5b2928379$var$i18n.improveAtlassianText,
        values: {
            researchGroupLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$ResearchGroupLink, {
                link: $2e66c8b5b2928379$var$LINK_TO_RESEARCH_GROUP
            })
        }
    });
};
const $2e66c8b5b2928379$var$DislikeIconWrapperXCSS = (0, $buxP3.xcss)({
    transform: 'rotate(180deg)'
});
const $2e66c8b5b2928379$var$ButtonWrapperXCSS = (0, $buxP3.xcss)({
    height: '24px',
    width: '24px'
});
const $2e66c8b5b2928379$export$f9f34317e5bc3551 = ({ contentId: contentId, onLikeClicked: onLikeClicked, onDislikeClicked: onDislikeClicked })=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isFeedbackOpen, setIsFeedbackOpen] = (0, $cozmU.useState)(false);
    const feedbackCollectorProperties = (0, $5JhlM.useAIFeedbackProperties)();
    const [sentiment, setSentiment] = (0, $cozmU.useState)('');
    const [hasGoodFeedbackBeenSubmitted, setHasGoodFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const [hasBadFeedbackBeenSubmitted, setHasBadFeedbackBeenSubmitted] = (0, $cozmU.useState)(false);
    const feedbackContextString = `contentId: ${contentId} sentiment: ${sentiment}${feedbackCollectorProperties.feedbackContext.length > 0 ? ` ${feedbackCollectorProperties.feedbackContext}` : ''}`;
    const showFeedbackFlag = ()=>{
        showFlag({
            title: formatMessage($2e66c8b5b2928379$var$i18n.flagTitle),
            description: formatMessage($2e66c8b5b2928379$var$i18n.flagDescription),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($chu6R))), {
                spacing: "spacious",
                color: "var(--ds-icon-success, #6A9A23)",
                label: "success"
            }),
            isAutoDismiss: true
        });
    };
    const handleLikeClicked = ()=>{
        onLikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('good');
    };
    const handleDislikeClicked = ()=>{
        onDislikeClicked?.();
        setIsFeedbackOpen(true);
        setSentiment('bad');
    };
    const onFeedbackSubmit = ()=>{
        showFeedbackFlag();
        setIsFeedbackOpen(false);
        if (sentiment === 'good') {
            setHasGoodFeedbackBeenSubmitted(true);
            setHasBadFeedbackBeenSubmitted(false);
        } else {
            setHasBadFeedbackBeenSubmitted(true);
            setHasGoodFeedbackBeenSubmitted(false);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        role: "none",
        onClick: (e)=>e.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.likeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasGoodFeedbackBeenSubmitted
        }),
        onClick: handleLikeClicked,
        testId: "feedback-like-button",
        isDisabled: hasGoodFeedbackBeenSubmitted
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        hideTooltipOnMouseDown: true,
        content: formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2e66c8b5b2928379$var$ButtonWrapperXCSS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        "aria-label": formatMessage($2e66c8b5b2928379$var$i18n.dislikeTooltip),
        spacing: "none",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2e66c8b5b2928379$var$DislikeIconWrapperXCSS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gecH2.ThumbIcon), {
            isSelected: hasBadFeedbackBeenSubmitted
        })),
        onClick: handleDislikeClicked,
        testId: "feedback-dislike-button",
        isDisabled: hasBadFeedbackBeenSubmitted
    }))), isFeedbackOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eX69.default), {
        locale: feedbackCollectorProperties.locale,
        onSubmit: onFeedbackSubmit,
        onClose: ()=>setIsFeedbackOpen(false),
        atlassianAccountId: feedbackCollectorProperties.userId,
        name: feedbackCollectorProperties.displayName,
        entrypointId: feedbackCollectorProperties.entrypointId,
        summaryPlaceholder: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryPlaceholder),
        additionalFields: [
            {
                id: feedbackCollectorProperties.feedbackContextId,
                value: feedbackContextString
            }
        ],
        feedbackTitle: formatMessage($2e66c8b5b2928379$var$i18n.feedbackTitle),
        showTypeField: false,
        customTextAreaLabel: formatMessage($2e66c8b5b2928379$var$i18n.feedbackSummaryTitle),
        canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$CanContactLabel, null),
        enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2e66c8b5b2928379$var$EnrolLabel, null)
    })));
};
module.exports["AIFeedbackComponent"] = $2e66c8b5b2928379$export$f9f34317e5bc3551;

});

parcelRegister("gecH2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $c8bBH = parcelRequire("c8bBH");

const $62e24cf344a5b8b1$export$ec2ba0e929740f73 = ({ isSelected: isSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8bBH))), {
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon-subtle, #505258)",
        label: ""
    });
module.exports["ThumbIcon"] = $62e24cf344a5b8b1$export$ec2ba0e929740f73;

});

parcelRegister("5GgqH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $44sV7 = parcelRequire("44sV7");

const $518681ac338b53b3$export$15dda63faa44a0df = (ref, interval = 500)=>{
    const isOnScreen = (0, $44sV7.useOnScreen)(ref);
    const dwellTimeRef = (0, $cozmU.useRef)(0);
    (0, $cozmU.useEffect)(()=>{
        const incremental = setInterval(()=>{
            if (isOnScreen) dwellTimeRef.current += interval;
        }, interval);
        return ()=>{
            clearInterval(incremental);
        };
    }, [
        isOnScreen,
        interval
    ]);
    const getDwellTime = ()=>dwellTimeRef.current;
    return {
        getDwellTime: getDwellTime
    };
};
module.exports["usePopupDwellTime"] = $518681ac338b53b3$export$15dda63faa44a0df;

});

parcelRegister("44sV7", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb = (ref)=>{
    const [isIntersecting, setIntersecting] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!ref.current) return;
        const observer = new IntersectionObserver(([entry])=>setIntersecting(entry.isIntersecting));
        if (ref.current) observer.observe(ref.current);
        return ()=>{
            if (observer) observer.disconnect();
        };
    });
    return isIntersecting;
};
module.exports["useOnScreen"] = $9f61f2cd2c8e0202$export$edb9b52ab3f1abbb;

});

parcelRegister("lgull", function(module, exports) {

var $iTtzC = parcelRequire("iTtzC");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $iDrrr = parcelRequire("iDrrr");


var $5JhlM = parcelRequire("5JhlM");


var $a7t2v = parcelRequire("a7t2v");

const $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID = '55dba3ae-58fa-41e0-828b-1e30fe66c0ba';
const $a1264e7348edcdb0$export$f50b64530422ea99 = ({ contentId: contentId, fallbackText: fallbackText, queryRef: queryRef, source: source, isHidden: isHidden, maxLines: maxLines, showFooter: showFooter, showAwareness: showAwareness })=>{
    const data = (0, $6SsN4.usePreloadedQuery)((0, $iTtzC.default), queryRef);
    const aiSnippetText = data?.confluence_latestKnowledgeGraphObjectV2?.objectData;
    const content = /*#__PURE__*/ $cozmU.createElement((0, $a7t2v.AISnippetContent), {
        text: aiSnippetText || fallbackText,
        contentId: contentId,
        showFooter: !!aiSnippetText && showFooter,
        showAwareness: !!aiSnippetText && showAwareness,
        source: source,
        isHidden: isHidden,
        maxLines: maxLines,
        renderAsMarkdown: !!aiSnippetText
    });
    if ((0, $iDrrr.fg)('jira-cc-ai-snippet-gate')) return /*#__PURE__*/ $cozmU.createElement((0, $5JhlM.AIFeedbackPropertiesProvider), {
        entrypointId: $a1264e7348edcdb0$var$SNIPPET_ENTRYPOINT_ID,
        userId: data?.me?.user?.accountId,
        displayName: data?.me?.user?.name
    }, content);
    return content;
};
module.exports["AISnippetLoader"] = $a1264e7348edcdb0$export$f50b64530422ea99;

});

parcelRegister("iTtzC", function(module, exports) {
/**
 * @generated SignedSource<<77586322f750ae0b68f16053ceaefeac>>
 * @relayHash 83b5f9dcca400199c020ae8cd7e6e7c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40
const $34c51f4beec18331$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentType"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeMe"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "args": [
            {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
            },
            {
                "kind": "Variable",
                "name": "contentId",
                "variableName": "contentId"
            },
            {
                "kind": "Variable",
                "name": "contentType",
                "variableName": "contentType"
            },
            {
                "kind": "Literal",
                "name": "objectType",
                "value": "snippet_v2"
            }
        ],
        "concreteType": "KnowledgeGraphObjectResponseV2",
        "kind": "LinkedField",
        "name": "confluence_latestKnowledgeGraphObjectV2",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "objectData"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "aiSnippetLoaderQuery",
            "selections": [
                v5 /*: any*/ ,
                {
                    "condition": "includeMe",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "AuthenticationContext",
                            "kind": "LinkedField",
                            "name": "me",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "user",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8b58eeaebb38ad38241e0152019eb289a93c640b57ebbf0774ddd0706e3cda40",
            "metadata": {},
            "name": "aiSnippetLoaderQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$34c51f4beec18331$var$node.hash = "9d618230ccff7c19cd4e4fee2e2c0a2c";
var $34c51f4beec18331$export$2e2bcd8739ae039 = $34c51f4beec18331$var$node;
module.exports["default"] = $34c51f4beec18331$export$2e2bcd8739ae039;

});

parcelRegister("di8q4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


var $crLHf = parcelRequire("crLHf");


const $7f6506f09fa8c3c7$export$836160481278e63f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "CUFGb",
    name: "LazyEmojiComponentLoader",
    _vcPlaceholderIgnored: true,
    loader: async ()=>(await (parcelRequire("gzhYv"))).EmojiComponent,
    loading: (props)=>props.emoji ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $crLHf.EmojiPlaceholder), props) : null
});
module.exports["LazyEmojiComponentLoader"] = $7f6506f09fa8c3c7$export$836160481278e63f;

});

parcelRegister("crLHf", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $57p4j = parcelRequire("57p4j");

const $e2c8b616e1533245$var$skeletonWrapperStyles = null;
const $e2c8b616e1533245$var$emojiSkeletonStyles = null;
const $e2c8b616e1533245$export$9fc60f86d5a6479f = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const PLACEHOLDER_SIZE = props.height || 26;
    let t0;
    if ($[0] !== PLACEHOLDER_SIZE || $[1] !== props.loadingMargin) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
            entranceDirection: "left"
        }, (animationProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                ...animationProps,
                "data-testid": "emoji-placeholder",
                "data-css-target": "emoji-placeholder",
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _39Ohv4YbGa _1SdfoHYbGa"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                style: {
                    width: `${PLACEHOLDER_SIZE}px`,
                    height: `${PLACEHOLDER_SIZE}px`,
                    margin: props.loadingMargin
                },
                className: (0, $hekY6.default)([
                    "_2uo31fGsB2 _0bjKvDzXzM _2XghbEPgdg _3iDTPbvbI6 _0Of8r2Pgdg"
                ])
            })));
        $[0] = PLACEHOLDER_SIZE;
        $[1] = props.loadingMargin;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
module.exports["EmojiPlaceholder"] = $e2c8b616e1533245$export$9fc60f86d5a6479f;

});

parcelRegister("gzhYv", function(module, exports) {

let $c0fddba6a224810c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c0fddba6a224810c$var$load("eF92L"),
    $c0fddba6a224810c$var$load("jwMHX"),
    $c0fddba6a224810c$var$load("d0ZRF"),
    $c0fddba6a224810c$var$load("k507P"),
    $c0fddba6a224810c$var$load("gFeoL"),
    $c0fddba6a224810c$var$load("6wr18"),
    $c0fddba6a224810c$var$load("4Ldt2"),
    $c0fddba6a224810c$var$load("ffEVr"),
    $c0fddba6a224810c$var$load("b3zRm"),
    $c0fddba6a224810c$var$load("20wSi"),
    $c0fddba6a224810c$var$load("bmOOW"),
    $c0fddba6a224810c$var$load("dDiWc"),
    $c0fddba6a224810c$var$load("eXIg7"),
    $c0fddba6a224810c$var$load("6KGrg")
]).then(()=>parcelRequire('1dhEU'));

});

parcelRegister("7lu50", function(module, exports) {
// old definition from tysy - not a real query being used
const $a928a12ca5fd59f3$export$adaf854818ff0d42 = (queryData)=>{
    return queryData?.entitlements?.externalCollaborator.isEntitled;
};
module.exports["getExternalCollaboratorEntitlementFromQuery"] = $a928a12ca5fd59f3$export$adaf854818ff0d42;

});

parcelRegister("9fywD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");

const $43aed8c383cce8da$var$i18n = (0, $kSwu1.defineMessages)({
    externalUserLozengeText: {
        id: "external-collab-ui.user-guest-lozenge",
        defaultMessage: "Guest"
    },
    guestUserTooltip: {
        id: "external-collab-ui.user-guest-lozenge.tooltip",
        defaultMessage: "Guests can only access certain spaces and have limited access to user info."
    }
});
const $43aed8c383cce8da$export$4de00d985a23014d = {
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.guestUserTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $43aed8c383cce8da$var$i18n.externalUserLozengeText)),
    appearance: 'default',
    isBold: false
};
const $43aed8c383cce8da$export$aa87bb37f13b8b5 = ()=>{
    const { text: text, appearance: appearance, isBold: isBold } = $43aed8c383cce8da$export$4de00d985a23014d;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: appearance,
        isBold: isBold
    }, text);
};
module.exports["ExternalUserLozengeProps"] = $43aed8c383cce8da$export$4de00d985a23014d;
module.exports["ExternalUserLozenge"] = $43aed8c383cce8da$export$aa87bb37f13b8b5;

});

parcelRegister("6AroL", function(module, exports) {
function $4cbb5ba451601f11$var$e(e) {
    this.message = e;
}
$4cbb5ba451601f11$var$e.prototype = new Error, $4cbb5ba451601f11$var$e.prototype.name = "InvalidCharacterError";
var $4cbb5ba451601f11$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $4cbb5ba451601f11$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $4cbb5ba451601f11$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($4cbb5ba451601f11$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $4cbb5ba451601f11$var$r(t);
    }
}
function $4cbb5ba451601f11$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $4cbb5ba451601f11$var$o(e, r) {
    if ("string" != typeof e) throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($4cbb5ba451601f11$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $4cbb5ba451601f11$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$4cbb5ba451601f11$export$b9721ef022f71a68.prototype = new Error, $4cbb5ba451601f11$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $4cbb5ba451601f11$export$2e2bcd8739ae039 = $4cbb5ba451601f11$var$o;
 //# sourceMappingURL=jwt-decode.esm.js.map
module.exports["default"] = $4cbb5ba451601f11$export$2e2bcd8739ae039;

});

parcelRegister("bumSD", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $5hJlu = parcelRequire("5hJlu");


var $bp86Z = parcelRequire("bp86Z");

const $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH = '/gateway/api/directory/graphql';
const $226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG = {
    url: $226eb0cd9c5c41b1$var$DIRECTORY_GRAPHQL_PATH,
    cacheSize: 100,
    cacheMaxAge: 300000 // - 5 minutes
};
const $226eb0cd9c5c41b1$export$441fd008df03d370 = (0, $dOBRD.default)((cloudId, _)=>{
    const profileClientConfig = {
        ...$226eb0cd9c5c41b1$var$USER_PROFILE_CONFIG,
        productIdentifier: 'confluence',
        cloudId: cloudId
    };
    return new (0, $5hJlu.ProfileClient)(profileClientConfig, {
        userClient: new (0, $bp86Z.UserProfileClientForConfluence)(profileClientConfig)
    });
});
module.exports["getProfileClient"] = $226eb0cd9c5c41b1$export$441fd008df03d370;

});

parcelRegister("bp86Z", function(module, exports) {

var $34knR = parcelRequire("34knR");


var $9fywD = parcelRequire("9fywD");


var $7lu50 = parcelRequire("7lu50");


var $ldOrZ = parcelRequire("ldOrZ");


var $2A84u = parcelRequire("2A84u");


var $9jSPN = parcelRequire("9jSPN");


var $c0rhi = parcelRequire("c0rhi");

class $e0ed8187aad1d5de$export$8e0680112f77975e extends (0, $34knR.default) {
    async makeRequest(cloudId, userId) {
        // Note because we are only subclassing "makeRequest()", we are still using UserProfileClient's
        // default "getProfile()" function - which means we automatically get the standard
        // UserProfileClient caching of the full user profile data, including our added properties
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).start();
        const UserProfileClientForConfluencePromise = (0, $c0rhi.queryInterop)({
            query: (0, $2A84u.UserProfileClientForConfluenceQuery),
            variables: {
                userId: userId
            },
            __callerPackage__: "profile"
        });
        // If the standard user data query fails, we want to reject the returned promise because there
        // won't be any data for the caller to make a useful ProfileCard.  But if the standard user
        // data query succeeds but External Collaboration data query fails, we want to still display
        // the ProfileCard with the standard user data (that is, we don't want to reject).  In order to
        // do this, we can't use "Promise.all()" because it will return immediately when any of its
        // requests fail.  Instead we need to wait until all of the requests complete or fail, and that
        // means using "Promise.allSettled()", which has a much more complicated return object.
        const [userProfileClientForConfluenceQueryResult, standardUserDataResult] = await Promise.allSettled([
            UserProfileClientForConfluencePromise,
            super.makeRequest(cloudId, userId)
        ]);
        if (standardUserDataResult.status === 'rejected') {
            (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
                customData: {
                    success: false
                }
            });
            return Promise.reject(standardUserDataResult.reason);
        }
        // If the External Collaboration query was successful and External Collaboration is entitled
        // and this user is an External user, then add our custom Lozenge to the standard user profile
        // data
        const customLozenges = [];
        if (userProfileClientForConfluenceQueryResult.status === 'fulfilled') {
            const confluenceUserResponse = userProfileClientForConfluenceQueryResult.value.data;
            if ((0, $7lu50.getExternalCollaboratorEntitlementFromQuery)(confluenceUserResponse) && confluenceUserResponse?.user?.confluence?.permissionType === (0, $ldOrZ.SitePermissionType).EXTERNAL) customLozenges.push({
                ...(0, $9fywD.ExternalUserLozengeProps),
                key: 'ExternalUserLozenge'
            });
        }
        (0, $9jSPN.PROFILE_CARD_QUERY_METRIC).stop({
            customData: {
                success: true
            }
        });
        return {
            ...standardUserDataResult.value,
            customLozenges: customLozenges
        };
    }
}
module.exports["UserProfileClientForConfluence"] = $e0ed8187aad1d5de$export$8e0680112f77975e;

});

parcelRegister("ldOrZ", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $0709253cacc9fe3a$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $0709253cacc9fe3a$export$8995abb8169b2cb8;

});

parcelRegister("2A84u", function(module, exports) {

var $ay9Uu = parcelRequire("ay9Uu");

const $ab1c6257ac115bcc$export$8322eea6a290b246 = (0, $ay9Uu.default);
module.exports["UserProfileClientForConfluenceQuery"] = $ab1c6257ac115bcc$export$8322eea6a290b246;

});

parcelRegister("ay9Uu", function(module, exports) {
/**
 * @generated SignedSource<<c8072e566be2615c9f169051b183f1d7>>
 * @relayHash e3b7fcde55b949bf8d80bddd9a0ac180
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d
const $bb661b120eec94ae$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": false
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "userId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Entitlements",
            "kind": "LinkedField",
            "name": "entitlements",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ExternalCollaboratorFeature",
                    "kind": "LinkedField",
                    "name": "externalCollaborator",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEntitled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserProfileClientForConfluenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e3b7fcde55b949bf8d80bddd9a0ac180",
            "id": "ee7894fc24fdc7e2f211db85d0b9ca04c99930331a3373b4aec2e287d771850d",
            "metadata": {},
            "name": "UserProfileClientForConfluenceQuery",
            "operationKind": "query",
            "text": "query UserProfileClientForConfluenceQuery($userId:ID){user:confluence_atlassianUser(current:false,id:$userId){id,confluence{permissionType}},entitlements{externalCollaborator{isEntitled}}}"
        }
    };
}();
$bb661b120eec94ae$var$node.hash = "f636f7ede64e4c0d1757767b061d53b5";
var $bb661b120eec94ae$export$2e2bcd8739ae039 = $bb661b120eec94ae$var$node;
module.exports["default"] = $bb661b120eec94ae$export$2e2bcd8739ae039;

});

parcelRegister("9jSPN", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $5487d57e41530957$export$c2710940b43dcf08 = (0, $lSOAM.createCustomMetric)({
    key: (0, $fd6g2.PROFILE_CARD_QUERY_CUSTOM_KEY)
});
module.exports["PROFILE_CARD_QUERY_METRIC"] = $5487d57e41530957$export$c2710940b43dcf08;

});

parcelRegister("bedVD", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");

const $e4e11ee9fe4a88c9$var$i18n = (0, $kSwu1.defineMessages)({
    follow: {
        id: "profile.card.follow",
        defaultMessage: "Follow"
    },
    unfollow: {
        id: "profile.card.unfollow",
        defaultMessage: "Unfollow"
    },
    followTooltip: {
        id: "profile.card.follow.tooltip",
        defaultMessage: "See activity in feed"
    },
    unfollowTooltip: {
        id: "profile.card.unfollow.tooltip",
        defaultMessage: "Stop seeing activity in feed"
    }
});
const $e4e11ee9fe4a88c9$export$d258f317c876c5dc = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { followed: followed } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== followed || $[1] !== intl) {
        t1 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollowTooltip : $e4e11ee9fe4a88c9$var$i18n.followTooltip);
        $[0] = followed;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== followed || $[4] !== intl) {
        t2 = intl.formatMessage(followed ? $e4e11ee9fe4a88c9$var$i18n.unfollow : $e4e11ee9fe4a88c9$var$i18n.follow);
        $[3] = followed;
        $[4] = intl;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, t2);
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            position: "bottom",
            testId: "feed-follow-tooltip"
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
module.exports["FeedFollow"] = $e4e11ee9fe4a88c9$export$d258f317c876c5dc;

});

parcelRegister("4GlQ9", function(module, exports) {

var $k7Nop = parcelRequire("k7Nop");


var $hOSkW = parcelRequire("hOSkW");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $bQm3c = parcelRequire("bQm3c");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");

const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery = (0, $hOSkW.default);
const $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation = (0, $k7Nop.default);
const $e2d6f47b8e3454eb$var$isUserHasNoAccessError = (error)=>error?.graphQLErrors?.some((gqlError)=>gqlError?.path?.includes('getFeedUserConfig') && gqlError?.message?.includes('User not permitted to access Confluence'));
let $e2d6f47b8e3454eb$export$8631e45fce8db7c6 = false;
function $e2d6f47b8e3454eb$export$438df56e0ed352e6() {
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { data: data, loading: queryLoading, error: feedConfigError } = (0, $jMyy4.useQueryInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery, {
        skip: !isLicensed || $e2d6f47b8e3454eb$export$8631e45fce8db7c6,
        onError: (error)=>$e2d6f47b8e3454eb$export$8631e45fce8db7c6 = $e2d6f47b8e3454eb$var$isUserHasNoAccessError(error),
        __callerPackage__: "profile"
    });
    const [mutateFeedFollow, { error: mutationError }] = (0, $308Wd.useMutationInterop)($e2d6f47b8e3454eb$var$useFeedFollowFeedFollowMutation, {
        refetchQueries: [
            {
                query: $e2d6f47b8e3454eb$var$useFeedFollowFeedFollowQuery
            }
        ],
        __callerPackage__: "profile"
    });
    const followedUsersRaw = data?.getFeedUserConfig?.accountIds;
    const followedUsers = (0, $cozmU.useMemo)(()=>followedUsersRaw?.map((id)=>id ?? null) ?? [], [
        followedUsersRaw
    ]);
    const getToggleFollowUser = (0, $cozmU.useCallback)((accountId, following, source)=>async ()=>{
            if (!accountId) return;
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'feedFollow',
                    source: source,
                    attributes: {
                        id: accountId,
                        settingType: 'user',
                        actionType: following ? 'unfollow' : 'follow'
                    }
                }
            }).fire();
            try {
                if (following) await mutateFeedFollow({
                    variables: {
                        unfollow: [
                            accountId
                        ]
                    }
                });
                else await mutateFeedFollow({
                    variables: {
                        follow: [
                            accountId
                        ]
                    }
                });
            } catch  {
            // noop since the hook consumer logs the error through <ErrorDisplay>
            // mutateFeedFollow() has the potential to throw an error;
            // since we do not provide an onError callback to the useMutation hook
            // we need to catch the error here as a safety net.
            }
        }, [
        mutateFeedFollow,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            renderFeedFollow: !(queryLoading || feedConfigError || $e2d6f47b8e3454eb$export$8631e45fce8db7c6) && isLicensed,
            loading: queryLoading,
            getToggleFollowUser: getToggleFollowUser,
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            followedUsers: followedUsers
        }), [
        queryLoading,
        feedConfigError,
        isLicensed,
        getToggleFollowUser,
        mutationError,
        followedUsers
    ]);
}
module.exports["useFeedFollow"] = $e2d6f47b8e3454eb$export$438df56e0ed352e6;

});

parcelRegister("k7Nop", function(module, exports) {
/**
 * @generated SignedSource<<faabaa80182918f5d00c229b25800acb>>
 * @relayHash 564d8ad9d36377c3d791529bbbb8a24b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c
const $2274f77c1a29b092$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "follow"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "unfollow"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "followUsers",
                            "variableName": "follow"
                        },
                        {
                            "kind": "Variable",
                            "name": "unfollowUsers",
                            "variableName": "unfollow"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "SetFeedUserConfigPayload",
            "kind": "LinkedField",
            "name": "setFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "564d8ad9d36377c3d791529bbbb8a24b",
            "id": "5d32fc5b6758b0cdbd537bc59e7432e83998cce61163ae34755c64a402dc367c",
            "metadata": {},
            "name": "useFeedFollowFeedFollowMutation",
            "operationKind": "mutation",
            "text": "mutation useFeedFollowFeedFollowMutation($follow:[ID],$unfollow:[ID]){setFeedUserConfig(input:{followUsers:$follow,unfollowUsers:$unfollow}){success}}"
        }
    };
}();
$2274f77c1a29b092$var$node.hash = "7ecf9b28db7400fffab67e3a3c52027c";
var $2274f77c1a29b092$export$2e2bcd8739ae039 = $2274f77c1a29b092$var$node;
module.exports["default"] = $2274f77c1a29b092$export$2e2bcd8739ae039;

});

parcelRegister("hOSkW", function(module, exports) {
/**
 * @generated SignedSource<<597a7b2d7b3333c8532a887f4cdcbd48>>
 * @relayHash bc87c04b481deeaeaae914ab875dc44e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b
const $eeb53afb4cc8b670$var$node = function() {
    var v0 = [
        {
            "concreteType": "FollowingFeedGetUserConfig",
            "kind": "LinkedField",
            "name": "getFeedUserConfig",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountIds"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useFeedFollowFeedFollowQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "bc87c04b481deeaeaae914ab875dc44e",
            "id": "11f28c2ff5a1dd7dd27036b76ee213cfc4cc4dc180b6462f1906390361cc096b",
            "metadata": {},
            "name": "useFeedFollowFeedFollowQuery",
            "operationKind": "query",
            "text": "query useFeedFollowFeedFollowQuery{getFeedUserConfig{accountIds}}"
        }
    };
}();
$eeb53afb4cc8b670$var$node.hash = "73bdcd7f6c8309a4d0a16e77fd4c5fed";
var $eeb53afb4cc8b670$export$2e2bcd8739ae039 = $eeb53afb4cc8b670$var$node;
module.exports["default"] = $eeb53afb4cc8b670$export$2e2bcd8739ae039;

});

parcelRegister("eLV9q", function(module, exports) {
$parcel$export(module.exports, "useGetNavigateToTeamsApp", () => (parcelRequire("eWzPA")).useGetNavigateToTeamsApp);

var $eWzPA = parcelRequire("eWzPA");


});

parcelRegister("eWzPA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");

const $8c3fac113683eb0d$export$bb1230c0e6efa9dc = ()=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const getNavigateToTeamsApp = (navActionPayload, shouldOpenInSameTab)=>{
        return (0, $hMCZS.navigateToTeamsApp)({
            hostProduct: 'confluence',
            orgId: orgId,
            cloudId: cloudId,
            userHasNav4Enabled: true,
            shouldOpenInSameTab: shouldOpenInSameTab,
            ...navActionPayload
        });
    };
    return (0, $cozmU.useCallback)(getNavigateToTeamsApp, [
        cloudId,
        orgId
    ]);
};
module.exports["useGetNavigateToTeamsApp"] = $8c3fac113683eb0d$export$bb1230c0e6efa9dc;

});

parcelRegister("bSvtO", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");

const $45ca38ec521afdf7$var$initialState = {
    hasContentChanged: false,
    isCommentContentReady: false
};
const $45ca38ec521afdf7$export$53ac33307b5acee9 = ()=>({
        hasContentChanged: false,
        isCommentContentReady: false
    });
const $45ca38ec521afdf7$export$e324594224ef24da = {
    onChange: (hasChanges)=>({ setState: setState })=>{
            setState({
                hasContentChanged: hasChanges
            });
        },
    resetContentChanged: ()=>({ setState: setState })=>{
            setState({
                hasContentChanged: false
            });
        },
    onCommentContentReady: ()=>({ setState: setState })=>{
            setState({
                isCommentContentReady: true
            });
        }
};
const $45ca38ec521afdf7$var$CommentsContentStore = (0, $8s9DV.createStore)({
    initialState: $45ca38ec521afdf7$var$initialState,
    actions: $45ca38ec521afdf7$export$e324594224ef24da,
    name: 'CommentsContentStore'
});
const $45ca38ec521afdf7$export$ef1bfc0b6758ca67 = (0, $kBr4q.createHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$e2038e591f93e866 = (0, $kBr4q.createActionsHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$1756d05b0495e6b = (0, $kBr4q.createStateHook)($45ca38ec521afdf7$var$CommentsContentStore);
const $45ca38ec521afdf7$export$dbffca2f0193dbd0 = ()=>(0, $c6StJ.defaultRegistry).getStore($45ca38ec521afdf7$var$CommentsContentStore).storeState.getState();
module.exports["useCommentsContentActions"] = $45ca38ec521afdf7$export$e2038e591f93e866;
module.exports["useCommentsContentState"] = $45ca38ec521afdf7$export$1756d05b0495e6b;
module.exports["getCommentsContentState"] = $45ca38ec521afdf7$export$dbffca2f0193dbd0;

});

parcelRegister("cMvMc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f2899d935411e961$export$fb31a121515f224d = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "_Vqh0",
    name: "CommentWarningDialog",
    loader: async ()=>(await (parcelRequire("7NKS7"))).CommentWarningDialog
});
module.exports["CommentWarningDialog"] = $f2899d935411e961$export$fb31a121515f224d;

});

parcelRegister("7NKS7", function(module, exports) {

let $5ae177c72d819b7b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5ae177c72d819b7b$var$load("hhss7"),
    $5ae177c72d819b7b$var$load("cqNU4")
]).then(()=>parcelRequire('9c4UU'));

});

parcelRegister("hcnuR", function(module, exports) {
const $62bc818b780bdfc1$export$68a914b05fdf9ed1 = (classification)=>{
    const isNonProductionBuild = typeof classification === 'function' ? classification() : classification;
    return isNonProductionBuild !== undefined ? {
        isNonProductionBuild: isNonProductionBuild
    } : {};
};
module.exports["getNonProductionBuildAnalyticsAttributes"] = $62bc818b780bdfc1$export$68a914b05fdf9ed1;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("8ld8H", function(module, exports) {

var $eSuZj = parcelRequire("eSuZj");


var $68uaC = parcelRequire("68uaC");

const $ca70a3574c04adc8$var$BRANCH_COOKIE = 'useFrontendBranch';
const $ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE = 'bifrost-override';
const $ca70a3574c04adc8$var$isActiveBranchCookie = (value)=>{
    if (!value || value === 'off') return false;
    const override = JSON.parse(value);
    if (!override || typeof override !== 'object' || Array.isArray(override)) return undefined;
    const version = override?.['cc-fe-bifrost']?.version ?? override?.version;
    if (version === undefined) return false;
    return typeof version === 'string' ? Boolean(version && version !== 'off' && version !== 'CLASSIC-off-off') : undefined;
};
const $ca70a3574c04adc8$export$89ba981936f5422e = ()=>{
    try {
        const { RELEASE_TRACK: RELEASE_TRACK } = (0, $eSuZj.getBuildInfo)();
        if (RELEASE_TRACK === 'dev' || RELEASE_TRACK === 'staging') return true;
        if (![
            'prod',
            'hello',
            'canary'
        ].includes(RELEASE_TRACK)) return undefined;
        if (window.__SSR_RENDERED__) {
            let bifrostOverride;
            try {
                bifrostOverride = (0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BIFROST_OVERRIDE_COOKIE);
            } catch  {
            // Fall back to the frontend branch cookie if the Bifrost cookie cannot be read.
            }
            if (bifrostOverride) return $ca70a3574c04adc8$var$isActiveBranchCookie(bifrostOverride);
        }
        const branchVersion = (0, $68uaC.Cookies).get($ca70a3574c04adc8$var$BRANCH_COOKIE);
        return Boolean(branchVersion && branchVersion !== 'off');
    } catch  {
        return undefined;
    }
};
module.exports["getConfluenceNonProductionBuild"] = $ca70a3574c04adc8$export$89ba981936f5422e;

});

parcelRegister("foQ4a", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $19052bf55936e796$export$e581bd1f88227e0a = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isExternalCollaborator: accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
    };
};
module.exports["useIsExternalCollaborator"] = $19052bf55936e796$export$e581bd1f88227e0a;

});

parcelRegister("8aF6s", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $cozmU = parcelRequire("cozmU");


var $2BAFx = parcelRequire("2BAFx");

const $ff30daea9524db5f$var$onChildClose = (key, ...args)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        setState({
            stack: state.stack.map((frame)=>frame === childFrame ? {
                    ...frame,
                    alive: false
                } : frame)
        });
    };
const $ff30daea9524db5f$var$onChildCloseComplete = (key, ...args)=>({ getState: getState, setState: setState })=>{
        // A child dialog called its onCloseComplete prop
        const state = getState();
        // Find the stack frame for the respective child
        const childFrame = state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        setState({
            stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
        });
    };
const $ff30daea9524db5f$var$actions = {
    showModal: (componentClass, originalProps, children)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const onClose = (...args)=>dispatch($ff30daea9524db5f$var$onChildClose(key, ...args));
            const onCloseComplete = (...args)=>dispatch($ff30daea9524db5f$var$onChildCloseComplete(key, ...args));
            const component = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(componentClass, {
                ...props,
                onClose: onClose,
                onCloseComplete: onCloseComplete
            }, children);
            const state = getState();
            setState({
                stack: [
                    ...state.stack,
                    {
                        key: key,
                        component: component,
                        alive: true,
                        originalProps: {
                            onClose: props?.onClose,
                            onCloseComplete: props?.onCloseComplete
                        }
                    }
                ]
            });
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return onClose;
        }
};
const $ff30daea9524db5f$var$store = (0, $8s9DV.createStore)({
    initialState: {
        stack: []
    },
    actions: $ff30daea9524db5f$var$actions,
    name: 'DialogsStore'
});
/**
 * This is a work around to enforce the type requirement for the modal component.
 * For some reason the types don't resolve correctly in the bound actions
 */ const $ff30daea9524db5f$var$getTypedActions = (actions)=>{
    const showModal = (component, originalProps)=>{
        actions.showModal(component, originalProps);
    };
    return {
        showModal: showModal
    };
};
const $ff30daea9524db5f$var$useDialogActions = (0, $kBr4q.createActionsHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$f3af872d774d3d3f = ()=>{
    const actions = $ff30daea9524db5f$var$useDialogActions();
    return (0, $cozmU.useMemo)(()=>$ff30daea9524db5f$var$getTypedActions(actions), [
        actions
    ]);
};
const $ff30daea9524db5f$var$useDialogsStore = (0, $kBr4q.createHook)($ff30daea9524db5f$var$store);
const $ff30daea9524db5f$export$ecef86e74aed0d6b = ()=>{
    const [state, actions] = $ff30daea9524db5f$var$useDialogsStore();
    return (0, $cozmU.useMemo)(()=>({
            state: state,
            ...$ff30daea9524db5f$var$getTypedActions(actions)
        }), [
        actions,
        state
    ]);
};
module.exports["useDialogs"] = $ff30daea9524db5f$export$f3af872d774d3d3f;
module.exports["useDialogsState"] = $ff30daea9524db5f$export$ecef86e74aed0d6b;

});

parcelRegister("dM9Vt", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $22d4578a6c7da18e$export$8484e44035e07bd7 = new (0, $kCECX.PluginKey)('slashRemixPlaceholder');
module.exports["slashRemixPlaceholderKey"] = $22d4578a6c7da18e$export$8484e44035e07bd7;

});

parcelRegister("83Z6R", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7EPz1 = parcelRequire("7EPz1");


var $6SsN4 = parcelRequire("6SsN4");


var $7m1pr = parcelRequire("7m1pr");


var $zXpxJ = parcelRequire("zXpxJ");


var $iffSy = parcelRequire("iffSy");


var $7q7rs = parcelRequire("7q7rs");


var $7M67g = parcelRequire("7M67g");


var $86okN = parcelRequire("86okN");


var $iF5wn = parcelRequire("iF5wn");

/**
 * Coerce an unknown thrown value into an ApolloErrorInterop, so a rejection carries Apollo's
 * `graphQLErrors` / `networkError` fields on both branches. Mirrors the helper in
 * `useLazyQueryInterop`.
 */ function $b847dc1d37d68706$var$toApolloError(err) {
    if ((0, $7m1pr.isRelayError)(err)) return err;
    const networkError = err instanceof Error ? err : new Error(String(err));
    return new (0, $7m1pr.RelayError)({
        networkError: networkError
    });
}
function $b847dc1d37d68706$export$dcf9d4e77de27956(query, options) {
    const operationName = (0, $7M67g.getRelayOperationName)(query);
    if ((0, $iffSy.isRelayEnabled)(options?.__callerPackage__, {
        operationName: operationName,
        phase: 'lazy'
    })) // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options);
    // eslint-disable-next-line react-hooks/rules-of-hooks -- Apollo/Relay route is branch-stable for a given caller package.
    return $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo(query, options);
}
const $b847dc1d37d68706$var$useLazyQueryPromiseInteropApollo = (0, $3u0dr.isReactCompilerActiveV2)() ? function useLazyQueryPromiseInteropApollo(query, options) {
    const $ = (0, $bDgLe.c)(13);
    const resolversRef = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== query) {
        t0 = (0, $86okN.toDocumentNode)(query);
        $[0] = query;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== options) {
        t1 = options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        };
        $[2] = options;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== t0 || $[5] !== t1) {
        t2 = [
            t0,
            t1
        ];
        $[4] = t0;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const [doQuery, t3] = (0, $7EPz1.useLazyQuery)(...t2);
    const { data: data, error: error } = t3;
    let t4;
    let t5;
    if ($[7] !== data || $[8] !== error) {
        t4 = ()=>{
            if (data) resolversRef.current?.resolve?.(data);
            if (error) resolversRef.current?.reject?.(error);
        };
        t5 = [
            data,
            error
        ];
        $[7] = data;
        $[8] = error;
        $[9] = t4;
        $[10] = t5;
    } else {
        t4 = $[9];
        t5 = $[10];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[11] !== doQuery) {
        t6 = (vars)=>{
            let resolve;
            let reject;
            const promise = new Promise((res, rej)=>{
                resolve = res;
                reject = rej;
            });
            resolversRef.current = {
                resolve: resolve,
                reject: reject
            };
            doQuery(vars);
            return promise;
        };
        $[11] = doQuery;
        $[12] = t6;
    } else t6 = $[12];
    return t6;
} : function useLazyQueryPromiseInteropApollo(query, options) {
    const resolversRef = (0, $cozmU.useRef)();
    /**
   * NOTE: Using `onCompleted` and `onError` callbacks does not work as expected due to Apollo bug which is present in both v2 and v3 - https://github.com/apollographql/apollo-client/issues/9338
   */ // Interop-only fetch policies must be translated or they reach Apollo untranslated and silently
    // degrade to its default cache behaviour. That matters for `'no-store'` specifically: Apollo's
    // `'no-cache'` is its exact equivalent, and without this mapping a query that is correct today
    // would start writing to the cache.
    const [doQuery, { data: data, error: error }] = (0, $7EPz1.useLazyQuery)(...[
        (0, $86okN.toDocumentNode)(query),
        options && {
            ...options,
            fetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.fetchPolicy),
            ...options.nextFetchPolicy ? {
                nextFetchPolicy: (0, $7q7rs.mapFetchPolicyForApollo)(options.nextFetchPolicy)
            } : {}
        }
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (data) resolversRef.current?.resolve?.(data);
        if (error) resolversRef.current?.reject?.(error);
    }, [
        data,
        error
    ]);
    return (0, $cozmU.useCallback)((vars)=>{
        let resolve;
        let reject;
        const promise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        // @ts-expect-error `resolve` and `reject` *will* be assigned via the Promise constructor, but TS can't guarantee that. This should be replaced with `Promise.withResolvers` once out jest setup properly supports that
        resolversRef.current = {
            resolve: resolve,
            reject: reject
        };
        doQuery(vars);
        return promise;
    }, [
        doQuery
    ]);
};
function $b847dc1d37d68706$var$useLazyQueryPromiseInteropRelay(query, options) {
    // Validate before any hook call so the throw isn't masked by useRelayEnvironment().
    if (!('params' in query)) throw new Error(`[Relay migration] unsupported tagged node provided for operation "${(0, $7M67g.getRelayOperationName)(query) ?? 'unknown'}". Please make sure you generated Relay artifacts for your operation`);
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const operationName = (0, $7M67g.getRelayOperationName)(query) ?? undefined;
    const hookVariables = (0, $iF5wn.useMemoObj)(options?.variables, options?.__callerPackage__, {
        operationName: operationName,
        phase: 'memo'
    });
    // Read through refs rather than closing over these directly, so the returned callback keeps a
    // `[environment, query]` dependency list. Every current caller drives it from a `useEffect`
    // dependency array, so a new identity per render would re-fire the query on each render.
    // `context` in particular is usually an inline object and would change identity every time.
    const latestOptionsRef = (0, $cozmU.useRef)(options);
    latestOptionsRef.current = options;
    const hookVariablesRef = (0, $cozmU.useRef)(hookVariables);
    hookVariablesRef.current = hookVariables;
    return (0, $cozmU.useCallback)((callOptions)=>{
        const hookOptions = latestOptionsRef.current;
        // Per-call options win over hook-level ones, and variables merge rather than replace —
        // matching Apollo, which merges the variables handed to its lazy `doQuery` over the ones
        // given to the hook.
        const variables = {
            ...hookVariablesRef.current,
            ...callOptions?.variables
        };
        // Shared with `queryInterop` so the fetch-policy mapping and the `noStore` derivation have
        // one home. `noStore` is load-bearing for this hook specifically: `PagePanelContentQuery`
        // runs through it and is one of the operations whose response carries two `Content` objects
        // sharing an id, so a missed flag reintroduces the record collision.
        return (0, $zXpxJ.executeRelayQuery)({
            environment: environment,
            query: query,
            variables: variables,
            fetchPolicy: callOptions?.fetchPolicy ?? hookOptions?.fetchPolicy,
            errorPolicy: callOptions?.errorPolicy ?? hookOptions?.errorPolicy ?? 'none',
            context: callOptions?.context ?? hookOptions?.context
        }).then((result)=>{
            // Diverges from `queryInterop`, which hands `{ data, error }` back: this hook mirrors
            // Apollo's promise, which rejects. Under `errorPolicy: 'all'` a result carries both
            // data and error, and Apollo's effect resolves before it rejects — a promise settles
            // once — so data being present means resolve.
            if (result.error && result.data === undefined) throw result.error;
            return result.data;
        }).catch((err)=>{
            // Reject with an ApolloErrorInterop on both branches, so callers can read
            // `graphQLErrors` / `networkError` without knowing which branch ran.
            throw $b847dc1d37d68706$var$toApolloError(err);
        });
    }, [
        environment,
        query
    ]);
}
module.exports["useLazyQueryPromiseInterop"] = $b847dc1d37d68706$export$dcf9d4e77de27956;

});

parcelRegister("cLo2u", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $bDgLe.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("kOUwv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $d684465712516a35$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $d684465712516a35$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $d684465712516a35$export$2d97e7bb018b0cfb = (0, $8s9DV.createStore)({
    initialState: $d684465712516a35$var$initialState,
    actions: $d684465712516a35$var$actions,
    name: 'siteTraitsStore'
});
const $d684465712516a35$export$c84f691b170cbee3 = (0, $kBr4q.createHook)($d684465712516a35$export$2d97e7bb018b0cfb);
const $d684465712516a35$export$2aca02eeb1d46515 = (0, $kBr4q.createActionsHook)($d684465712516a35$export$2d97e7bb018b0cfb);
async function $d684465712516a35$var$fetchSiteTraitsData(cloudId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $d684465712516a35$var$hasFetched = false;
function $d684465712516a35$export$f1fbc6ad89f91b89() {
    $d684465712516a35$var$hasFetched = false;
}
function $d684465712516a35$var$getSiteTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.site);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.site);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $d684465712516a35$export$fcebe75065597a98({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $cozmU.useMemo)(()=>$d684465712516a35$var$getSiteTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $d684465712516a35$export$c84f691b170cbee3();
    const { accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $cozmU.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($d684465712516a35$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId) return;
        $d684465712516a35$var$hasFetched = true;
        storeActions.start();
        $d684465712516a35$var$fetchSiteTraitsData(cloudId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteTraits"] = $d684465712516a35$export$fcebe75065597a98;

});

parcelRegister("9Z1sw", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $eq95w = parcelRequire("eq95w");


var $cozmU = parcelRequire("cozmU");


var $ah4BL = parcelRequire("ah4BL");


var $bavCP = parcelRequire("bavCP");


var $8wW9d = parcelRequire("8wW9d");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$WebPanelLocationBatchContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $0aea74171df1eb15$export$784950ebf49d8a5f = (location)=>{
    const $ = (0, $bDgLe.c)(3);
    const batchContext = (0, $cozmU.useContext)($0aea74171df1eb15$var$WebPanelLocationBatchContext);
    let t0;
    if ($[0] !== batchContext || $[1] !== location) {
        t0 = batchContext?.locations.includes(location) ? batchContext.getResultForLocation(location) : null;
        $[0] = batchContext;
        $[1] = location;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $0aea74171df1eb15$var$getUniqueLocations = (locations)=>Array.from(new Set(locations.filter(Boolean)));
const $0aea74171df1eb15$var$groupPanelsByLocation = (webPanels)=>{
    const panelsByLocation = new Map();
    webPanels?.forEach((panel)=>{
        if (panel?.location) {
            const panels = panelsByLocation.get(panel.location) ?? [];
            panels.push(panel);
            panelsByLocation.set(panel.location, panels);
        }
    });
    return panelsByLocation;
};
const $0aea74171df1eb15$var$getWebPanelLocationVariables = ({ location: location, locations: locations, contentIdentifier: contentIdentifier, spaceIdentifier: spaceIdentifier })=>{
    const selectedLocations = locations ?? (location ? [
        location
    ] : []);
    const locationVariables = selectedLocations.length > 1 ? {
        location: null,
        locations: selectedLocations
    } : {
        location: selectedLocations[0]
    };
    return {
        ...locationVariables,
        ...contentIdentifier != null ? {
            contentId: contentIdentifier
        } : {},
        ...contentIdentifier == null && spaceIdentifier != null ? {
            spaceKey: spaceIdentifier
        } : {}
    };
};
const $0aea74171df1eb15$var$useWebPanelLocationIdentifiers = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    let t0;
    let t1;
    if ($[0] !== contentId || $[1] !== getQueryParams || $[2] !== spaceKey) {
        const queryParams = getQueryParams();
        t0 = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, "spaceKey") || (0, $c3Qwv.getSingleParam)(queryParams, "key");
        t1 = contentId || (0, $c3Qwv.getSingleParam)(queryParams, "pageId");
        $[0] = contentId;
        $[1] = getQueryParams;
        $[2] = spaceKey;
        $[3] = t0;
        $[4] = t1;
    } else {
        t0 = $[3];
        t1 = $[4];
    }
    let t2;
    if ($[5] !== t0 || $[6] !== t1) {
        t2 = {
            spaceIdentifier: t0,
            contentIdentifier: t1
        };
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { children: children, locationName: locationName, panels: panels } = t0;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    let t1;
    let t2;
    if ($[0] !== panels) {
        t1 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("web-panel", (panels ?? []).map($0aea74171df1eb15$var$_temp2));
        };
        t2 = [
            panels
        ];
        $[0] = panels;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useEffect)(t1, t2);
    if (!panelHasContent) return children;
    const t3 = `web-panel-${locationName}`;
    let t4;
    if ($[3] !== children || $[4] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: t3
        }, children);
        $[3] = children;
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
};
const $0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { panel: panel } = t0;
    let t1;
    if ($[0] !== panel.completeKey || $[1] !== panel.html) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
            panelId: panel.completeKey,
            html: panel.html,
            panelLocation: (0, $eSLr0.ATL_GENERAL)
        });
        $[0] = panel.completeKey;
        $[1] = panel.html;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
}, (prevProps, nextProps)=>prevProps.panel.completeKey === nextProps.panel.completeKey);
const $0aea74171df1eb15$var$WebPanelLocationBatchContextProvider = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { data: data, loading: loading, error: error, locations: locations, children: children } = t0;
    data?.webPanels;
    const t1 = data?.webPanels;
    let t2;
    if ($[0] !== t1) {
        t2 = $0aea74171df1eb15$var$groupPanelsByLocation(t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    const panelsByLocation = t2;
    let t3;
    if ($[2] !== data || $[3] !== error || $[4] !== loading || $[5] !== panelsByLocation) {
        t3 = (location)=>({
                data: data ? {
                    webPanels: panelsByLocation.get(location) ?? []
                } : data,
                loading: loading,
                error: error
            });
        $[2] = data;
        $[3] = error;
        $[4] = loading;
        $[5] = panelsByLocation;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== locations || $[8] !== t3) {
        t4 = {
            locations: locations,
            getResultForLocation: t3
        };
        $[7] = locations;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const contextValue = t4;
    let t5;
    if ($[10] !== children || $[11] !== contextValue) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContext.Provider, {
            value: contextValue
        }, children);
        $[10] = children;
        $[11] = contextValue;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
};
const $0aea74171df1eb15$export$2c530b46a1768809 = (t0)=>{
    const $ = (0, $bDgLe.c)(16);
    const { locations: locations, children: children } = t0;
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    let t1;
    if ($[0] !== locations) {
        t1 = locations.join("\0");
        $[0] = locations;
        $[1] = t1;
    } else t1 = $[1];
    const locationsKey = t1;
    let t2;
    if ($[2] !== locationsKey) {
        t2 = $0aea74171df1eb15$var$getUniqueLocations(locationsKey.split("\0"));
        $[2] = locationsKey;
        $[3] = t2;
    } else t2 = $[3];
    const uniqueLocations = t2;
    let t3;
    if ($[4] !== contentIdentifier || $[5] !== spaceIdentifier || $[6] !== uniqueLocations) {
        t3 = $0aea74171df1eb15$var$getWebPanelLocationVariables({
            locations: uniqueLocations,
            contentIdentifier: contentIdentifier,
            spaceIdentifier: spaceIdentifier
        });
        $[4] = contentIdentifier;
        $[5] = spaceIdentifier;
        $[6] = uniqueLocations;
        $[7] = t3;
    } else t3 = $[7];
    const variables = t3;
    if (spaceIdentifier === "byDraft" || uniqueLocations.length === 0) {
        let t4;
        if ($[8] !== children) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
            $[8] = children;
            $[9] = t4;
        } else t4 = $[9];
        return t4;
    }
    let t4;
    if ($[10] !== children || $[11] !== uniqueLocations) {
        t4 = (t5)=>{
            const { data: data, loading: loading, error: error } = t5;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$WebPanelLocationBatchContextProvider, {
                data: data,
                loading: loading,
                error: error,
                locations: uniqueLocations
            }, children);
        };
        $[10] = children;
        $[11] = uniqueLocations;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t4 || $[14] !== variables) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
            query: $0aea74171df1eb15$export$d97dfe528d83a912,
            variables: variables,
            fetchPolicy: "cache-first",
            __callerPackage__: "web-panel-location"
        }, t4);
        $[13] = t4;
        $[14] = variables;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const { spaceIdentifier: spaceIdentifier, contentIdentifier: contentIdentifier } = $0aea74171df1eb15$var$useWebPanelLocationIdentifiers();
    const batchResult = $0aea74171df1eb15$export$784950ebf49d8a5f(location);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $cozmU.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const variables = $0aea74171df1eb15$var$getWebPanelLocationVariables({
        location: location,
        contentIdentifier: contentIdentifier,
        spaceIdentifier: spaceIdentifier
    });
    (0, $cozmU.useEffect)(()=>{
        if (batchResult?.loading || batchResult?.error || !batchResult?.data || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResult,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const renderWebPanels = ({ data: data, error: error })=>{
        if (!renderWhenLoading) {
            if (error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        const shouldMemoizeAtlGeneralWebPanel = location === (0, $eSLr0.ATL_GENERAL);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return shouldMemoizeAtlGeneralWebPanel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0aea74171df1eb15$var$MemoizedAtlGeneralWebPanel, {
                key: panel.completeKey,
                panel: panel
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html,
                panelLocation: location
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, batchResult ? renderWebPanels(batchResult) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted,
        __callerPackage__: "web-panel-location"
    }, renderWebPanels));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
function $0aea74171df1eb15$var$_temp2(panel_0) {
    return panel_0.completeKey;
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["useWebPanelLocationBatchResult"] = $0aea74171df1eb15$export$784950ebf49d8a5f;
module.exports["WebPanelLocationBatchProvider"] = $0aea74171df1eb15$export$2c530b46a1768809;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("1eaCJ", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $1kHsc = parcelRequire("1kHsc");

function $03574d8c2683228e$export$4962f3898bd5c829(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { name: name, attributes: attributes } = t0;
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== experienceTracker || $[2] !== name) {
        t1 = ()=>experienceTracker.succeed({
                name: name,
                attributes: attributes
            });
        t2 = [
            name,
            attributes,
            experienceTracker
        ];
        $[0] = attributes;
        $[1] = experienceTracker;
        $[2] = name;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceSuccess"] = $03574d8c2683228e$export$4962f3898bd5c829;

});

parcelRegister("3QyBm", function(module, exports) {

var $1xpoY = parcelRequire("1xpoY");

const $e9dc2b5b8bc8054b$export$888fec185e58bf9c = (location, items)=>{
    const locationsToHideConnectApps = (0, $1xpoY.default).getStringList('confluence_frontend_hidden_extension_points', []);
    const loc = Array.isArray(location) ? location[0] : location;
    if (locationsToHideConnectApps.includes(loc)) items = items.filter((item)=>!item?.completeKey?.startsWith('com.atlassian.plugins.atlassian-connect-plugin:'));
    return items;
};
module.exports["filterConnectAppsFromExtensionPoints"] = $e9dc2b5b8bc8054b$export$888fec185e58bf9c;

});

parcelRegister("iqPSe", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $gH1Fi = parcelRequire("gH1Fi");


var $ep3mz = parcelRequire("ep3mz");


var $eSLr0 = parcelRequire("eSLr0");

const $c50a10795e04dcb9$var$backgroundPanelStyles = null;
function $c50a10795e04dcb9$export$bbe14c99ac0820b3(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { html: html, panelId: panelId, panelLocation: panelLocation } = t0;
    const containerRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    const dimensionsRef = (0, $gH1Fi.useExtensionDimensions)(panelLocation === (0, $eSLr0.ATL_GENERAL) ? (0, $eSLr0.ATL_GENERAL) : undefined, panelId, contentId || spaceKey || "");
    let t2;
    if ($[0] !== dimensionsRef) {
        t2 = (element)=>{
            containerRef.current = element;
            dimensionsRef(element);
        };
        $[0] = dimensionsRef;
        $[1] = t2;
    } else t2 = $[1];
    const panelRef = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            (0, $brpfO.evalLegacyConnectInlineScripts)(container);
        };
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== html || $[4] !== panelId) {
        t4 = [
            html,
            panelId
        ];
        $[3] = html;
        $[4] = panelId;
        $[5] = t4;
    } else t4 = $[5];
    (0, $cozmU.useLayoutEffect)(t3, t4);
    let t5;
    if ($[6] !== html) {
        t5 = {
            __html: html
        };
        $[6] = html;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== panelLocation) {
        t6 = (0, $hekY6.default)([
            panelLocation === (0, $eSLr0.ATL_GENERAL) && (0, $6mKj3.expValEquals)("cc_connect_zero_size_panel_loading", "isEnabled", true) && "_26MP2EdnbC _17clSqdnbC _0raUWmdnbC _01sz4AdnbC _2gfv3OYbGa _3a7tHVYbGa _0RAJRlYbGa _2ecqNIYbGa"
        ]);
        $[8] = panelLocation;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== panelRef || $[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            ref: panelRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: t5,
            className: t6
        });
        $[10] = panelRef;
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
}
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("gH1Fi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1P7Cq = parcelRequire("1P7Cq");


var $7W9kD = parcelRequire("7W9kD");

const $46bdebab359d4884$export$8adc0cb9461bf99f = (source, extensionId, contextKey)=>{
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const cleanup = (0, $cozmU.useRef)(undefined);
    // The observation belongs to this page context, even when React reuses its DOM node.
    const observationContext = (0, $cozmU.useMemo)(()=>({
            source: source,
            extensionId: extensionId,
            contextKey: contextKey
        }), [
        source,
        extensionId,
        contextKey
    ]);
    return (0, $cozmU.useCallback)((element)=>{
        const { source: source, extensionId: extensionId } = observationContext;
        cleanup.current?.();
        cleanup.current = undefined;
        if (!renderServerPlaceholder && element && source && extensionId) cleanup.current = (0, $7W9kD.observeExtensionDimensions)(element, source, extensionId);
    }, [
        observationContext,
        renderServerPlaceholder
    ]);
};
module.exports["useExtensionDimensions"] = $46bdebab359d4884$export$8adc0cb9461bf99f;

});

parcelRegister("jyPfN", function(module, exports) {

var $foQ4a = parcelRequire("foQ4a");

const $10d1e40b190a4139$export$5a38a817745a0c6f = ()=>{
    const { isExternalCollaborator: isExternalCollaborator } = (0, $foQ4a.useIsExternalCollaborator)();
    return {
        canViewUserProfile: !isExternalCollaborator
    };
};
module.exports["useViewUserProfile"] = $10d1e40b190a4139$export$5a38a817745a0c6f;

});

parcelRegister("dD7ks", function(module, exports) {
$parcel$export(module.exports, "useNavigateToTeamsApp", () => (parcelRequire("4N3op")).useNavigateToTeamsApp);

var $4N3op = parcelRequire("4N3op");


});

parcelRegister("4N3op", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");

const $bf6b29a56d69bf9f$export$520a42ab062954ec = (navActionPayload, shouldOpenInSameTab)=>{
    const { cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    return (0, $hMCZS.navigateToTeamsApp)({
        push: push,
        hostProduct: 'confluence',
        orgId: orgId,
        cloudId: cloudId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["useNavigateToTeamsApp"] = $bf6b29a56d69bf9f$export$520a42ab062954ec;

});

parcelRegister("a6t12", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kNIYN = parcelRequire("kNIYN");


var $9DHhW = parcelRequire("9DHhW");


var $hSs5g = parcelRequire("hSs5g");


var $9zU5G = parcelRequire("9zU5G");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jyPfN = parcelRequire("jyPfN");


var $jlIaF = parcelRequire("jlIaF");


var $bQm3c = parcelRequire("bQm3c");


var $gqqjz = parcelRequire("gqqjz");

parcelRequire("6OL2O");
var $5t3NX = parcelRequire("5t3NX");

parcelRequire("dD7ks");
var $4N3op = parcelRequire("4N3op");


var $bedVD = parcelRequire("bedVD");


var $l7wqU = parcelRequire("l7wqU");


var $4GlQ9 = parcelRequire("4GlQ9");


var $bumSD = parcelRequire("bumSD");


var $4qzKl = parcelRequire("4qzKl");


var $gj42z = parcelRequire("gj42z");


var $hL7lZ = parcelRequire("hL7lZ");

const $3d0f3ea3171aff68$var$i18n = (0, $kSwu1.defineMessages)({
    viewProfile: {
        id: "profile.card.viewProfile",
        defaultMessage: "View profile"
    }
});
const $3d0f3ea3171aff68$export$98f80b73da7beaf4 = ({ push: push, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: ()=>(0, $4qzKl.getAtlassianPeopleProfileUrlAsync)(userId).then(push),
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, '', (0, $jlIaF.CONTEXT_PATH))
    });
const $3d0f3ea3171aff68$export$4f94384af0327320 = ({ navigate: navigate, url: url })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3d0f3ea3171aff68$var$i18n.viewProfile),
        id: 'view-profile',
        callback: navigate,
        shouldRender: (userData)=>{
            // missing/deleted/corrupted users don't return any data or status
            if (!userData) return false;
            return userData.status && userData.status !== 'inactive';
        },
        link: url
    });
const $3d0f3ea3171aff68$export$d114163e55e8b2c5 = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, userId: userId, followedUsers: followedUsers })=>{
    const followed = !!(userId && followedUsers?.includes(userId));
    return {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        }),
        id: 'feed-follow-user',
        callback: getToggleFollowUser(userId, followed, 'profileCard'),
        shouldRender: (userData)=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId && userData?.status === 'active'
    };
};
const $3d0f3ea3171aff68$export$ba990269c861f33b = ({ loggedInUserId: loggedInUserId, getToggleFollowUser: getToggleFollowUser, renderFeedFollow: renderFeedFollow, followedRef: followedRef, userId: userId })=>({
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l7wqU.FeedFollowAction), {
            userId: userId
        }),
        id: 'feed-follow-user',
        callback: ()=>getToggleFollowUser(userId, followedRef.current, 'profileCard')(),
        shouldRender: ()=>renderFeedFollow && Boolean(userId) && userId !== loggedInUserId
    });
const $3d0f3ea3171aff68$export$59abd6feb7dc8540 = ({ position: position = 'bottom-start', userId: userId, isAnonymous: isAnonymous = false, canViewProfile: canViewProfile = true, children: children, trigger: trigger = 'hover', fullName: fullName, disabledAriaAttributes: disabledAriaAttributes, onVisibilityChange: onVisibilityChange, offset: offset, ariaLabel: ariaLabel, agent: agent, agentInvokedBy: agentInvokedBy, agentJobTitle: agentJobTitle, fullWidthTrigger: fullWidthTrigger })=>{
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const { userId: loggedInUserId, cloudId: cloudId, featureFlags: featureFlags, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportingLines = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'LANDING'
    });
    const getReportingLinesUserProfile = (clickedUserId)=>(0, $5t3NX.getNavigateToTeamsApp)(orgId || '', {
            type: 'USER',
            payload: {
                userId: clickedUserId
            }
        });
    const userProfile = (0, $4N3op.useNavigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId || ''
        }
    });
    const reportingLinesProfileUrl = reportingLines.href;
    const { feedConfigError: feedConfigError, followedUsers: followedUsers, getToggleFollowUser: getToggleFollowUser, mutationError: mutationError, renderFeedFollow: renderFeedFollow } = (0, $4GlQ9.useFeedFollow)();
    const viewProfileAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$4f94384af0327320({
            navigate: userProfile.onNavigate,
            url: userProfile.href
        }), [
        userProfile
    ]);
    const followUserAction = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$d114163e55e8b2c5({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            userId: userId,
            followedUsers: followedUsers
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId,
        followedUsers
    ]);
    // The card snapshots the actions, so the follow callback reads the latest follow state
    // from this ref (updated on every render) instead of a value captured when the action
    // was built. This keeps repeated follow/unfollow toggles in the correct direction.
    const followedRef = (0, $cozmU.useRef)(false);
    followedRef.current = !!(userId && followedUsers?.includes(userId));
    const followUserActionNext = (0, $cozmU.useMemo)(()=>$3d0f3ea3171aff68$export$ba990269c861f33b({
            loggedInUserId: loggedInUserId,
            getToggleFollowUser: getToggleFollowUser,
            renderFeedFollow: renderFeedFollow,
            followedRef: followedRef,
            userId: userId
        }), [
        loggedInUserId,
        getToggleFollowUser,
        renderFeedFollow,
        userId
    ]);
    // Should display profile?
    if (isAnonymous || !canViewProfile || !userId || !loggedInUserId || !hasViewUserProfilePermission) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    const reportingLinesClickCallback = (clickedUserId_0)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'profileCardWrapper',
                action: 'clicked',
                actionSubject: 'viewProfile',
                actionSubjectId: 'userProfileCard',
                attributes: {
                    clickTarget: 'userReportingLine'
                }
            }
        }).fire();
        getReportingLinesUserProfile(clickedUserId_0).onNavigate();
        return false;
    };
    const isConfirmedExternalAgent = Boolean(agent && (0, $hL7lZ.isMcpAgentJobTitle)(agentJobTitle) && (0, $6mKj3.expValEquals)('cc_external_agent_profile_card', 'isEnabled', true));
    if (isConfirmedExternalAgent || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('people-teams_migrate-user-profile-card') || (0, $6mKj3.expValEquals)('pt_user_profile_card_migration_exp', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedConfigError,
        mutationError: mutationError,
        showErrorFlag: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9zU5G.UserProfileCardWithTrigger), {
        cloudId: cloudId,
        orgId: orgId || '',
        userId: userId,
        viewerId: loggedInUserId,
        placement: position,
        offset: offset,
        trigger: trigger,
        fullWidthTrigger: fullWidthTrigger,
        agentInvokedBy: agentInvokedBy,
        actions: [
            followUserActionNext
        ],
        isAgent: Boolean(agent),
        agent: agent ? {
            ...agent,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags)
        } : undefined,
        ...disabledAriaAttributes ? {} : {
            ariaLabel: ariaLabel
        },
        testId: "profileCardTrigger"
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
            feedConfigError: feedConfigError,
            mutationError: mutationError,
            showErrorFlag: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSs5g.default), {
            cloudId: cloudId,
            userId: userId,
            resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
            position: position,
            trigger: trigger,
            actions: [
                viewProfileAction,
                followUserAction
            ],
            reportingLinesProfileUrl: reportingLinesProfileUrl,
            onReportingLinesClick: (user)=>reportingLinesClickCallback(user.accountIdentifier),
            addFlag: (flag)=>flags.showFlag(flag),
            prepopulatedData: {
                fullName: fullName
            },
            disabledAriaAttributes: disabledAriaAttributes,
            onVisibilityChange: onVisibilityChange,
            offset: offset,
            testId: "profileCardTrigger",
            viewingUserId: loggedInUserId,
            ...disabledAriaAttributes ? {} : {
                ariaLabel: ariaLabel
            }
        }, children)));
};
module.exports["ProfileCardWrapper"] = $3d0f3ea3171aff68$export$59abd6feb7dc8540;

});

parcelRegister("6OL2O", function(module, exports) {
$parcel$export(module.exports, "getNavigateToTeamsApp", () => (parcelRequire("5t3NX")).getNavigateToTeamsApp);

var $5t3NX = parcelRequire("5t3NX");


});

parcelRegister("5t3NX", function(module, exports) {

var $hMCZS = parcelRequire("hMCZS");

const $57c6b51502cb940c$export$cfadab73fb247145 = (orgId, navActionPayload, shouldOpenInSameTab)=>{
    return (0, $hMCZS.navigateToTeamsApp)({
        hostProduct: 'confluence',
        orgId: orgId,
        userHasNav4Enabled: true,
        shouldOpenInSameTab: shouldOpenInSameTab,
        ...navActionPayload
    });
};
module.exports["getNavigateToTeamsApp"] = $57c6b51502cb940c$export$cfadab73fb247145;

});

parcelRegister("l7wqU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");

const $460a3972eab8fd69$export$38809e1c08e05a16 = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { userId: userId } = t0;
    const { followedUsers: followedUsers } = (0, $4GlQ9.useFeedFollow)();
    let t1;
    if ($[0] !== followedUsers || $[1] !== userId) {
        t1 = userId && followedUsers?.includes(userId);
        $[0] = followedUsers;
        $[1] = userId;
        $[2] = t1;
    } else t1 = $[2];
    const followed = !!t1;
    let t2;
    if ($[3] !== followed) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bedVD.FeedFollow), {
            followed: followed
        });
        $[3] = followed;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["FeedFollowAction"] = $460a3972eab8fd69$export$38809e1c08e05a16;

});

parcelRegister("4qzKl", function(module, exports) {
// TODO: remove once @confluence-classic/confluence-urls is added to next

var $jlIaF = parcelRequire("jlIaF");

const $7b986e69785602e5$export$3b6a64cfeda8b00 = (accountId, src, context = '')=>{
    if (!accountId) return '';
    return `${context}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$5f1a0e9946984804 = async (accountId, src)=>{
    if (!accountId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/${accountId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$cb80ef5511478588 = (teamId, src, context = '')=>{
    if (!teamId) return '';
    return `${context}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
const $7b986e69785602e5$export$470c1413f7223a06 = async (teamId, src)=>{
    if (!teamId) return '';
    return `${0, $jlIaF.CONTEXT_PATH}/people/team/${teamId}?ref=confluence${src ? `&src=${encodeURIComponent(src)}` : ''}`;
};
// Replacement for the getAttributeNames DOM API since it's not supported by IE
const $7b986e69785602e5$var$getAttributeNames = (element)=>Array.from(element.attributes).map((attribute)=>attribute.name);
// Return only DOM elements that have the data-account-id attribute
const $7b986e69785602e5$var$withAccountId = (element)=>element.getAttribute('data-account-id');
// Returns React props that can be used to recreate a DOM element
const $7b986e69785602e5$var$getReactPropsFromDOMElement = (element)=>{
    const attributeToProp = {
        class: 'className'
    };
    const props = {};
    $7b986e69785602e5$var$getAttributeNames(element).forEach((attribute)=>{
        props[attributeToProp[attribute] || attribute] = element.getAttribute(attribute);
    });
    props.dangerouslySetInnerHTML = {
        __html: element.innerHTML
    };
    return props;
};
function $7b986e69785602e5$export$a98860edfb97e545(userElements) {
    return userElements.filter($7b986e69785602e5$var$withAccountId).map((element)=>{
        const props = $7b986e69785602e5$var$getReactPropsFromDOMElement(element);
        // Set this attribute to stop the old user profile hovers from binding
        props['data-user-hover-bound'] = 'true';
        // Ensure that links go to the same location as the profile card
        props.href = $7b986e69785602e5$export$3b6a64cfeda8b00(props['data-account-id'], null);
        const placeholder = window.document.createElement('span');
        if (!element.parentNode) return {};
        element.parentNode.replaceChild(placeholder, element);
        return {
            props: props,
            placeholder: placeholder
        };
    });
}
module.exports["getAtlassianPeopleProfileUrl"] = $7b986e69785602e5$export$3b6a64cfeda8b00;
module.exports["getAtlassianPeopleProfileUrlAsync"] = $7b986e69785602e5$export$5f1a0e9946984804;
module.exports["getTeamUrl"] = $7b986e69785602e5$export$cb80ef5511478588;
module.exports["replaceUserElementsWithPlaceholders"] = $7b986e69785602e5$export$a98860edfb97e545;

});

parcelRegister("gj42z", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kSwu1 = parcelRequire("kSwu1");


var $b3j2Y = parcelRequire("b3j2Y");


var $gqqjz = parcelRequire("gqqjz");

const $3ade761a05c1a959$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    followMutationErrorTitle: {
        id: "profile.card.feed.follow.mutation.error.title",
        defaultMessage: "We\u2019re having trouble doing that"
    },
    followMutationErrorDescription: {
        id: "profile.card.feed.follow.mutation.error.description",
        defaultMessage: "Try following or unfollowing this user again "
    }
});
const $3ade761a05c1a959$export$cb92340e76dc7cda = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { feedConfigError: feedConfigError, mutationError: mutationError, showErrorFlag: showErrorFlag } = t0;
    let t1;
    if ($[0] !== feedConfigError) {
        t1 = feedConfigError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: feedConfigError
        }) : null;
        $[0] = feedConfigError;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== mutationError || $[3] !== showErrorFlag) {
        t2 = mutationError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: mutationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flags)=>{
            if (showErrorFlag) flags.showErrorFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3ade761a05c1a959$export$a7357cdd1f0b0168.followMutationErrorDescription)
            });
            return null;
        })) : null;
        $[2] = mutationError;
        $[3] = showErrorFlag;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["FeedFollowErrorDisplay"] = $3ade761a05c1a959$export$cb92340e76dc7cda;

});

parcelRegister("hL7lZ", function(module, exports) {

var $5qqDD = parcelRequire("5qqDD");

const $86dc8408bc6a6ace$export$7ddee5b97e00b19 = (jobTitle)=>jobTitle === (0, $5qqDD.DCR3P_AGENT_JOB_TITLE) || jobTitle === (0, $5qqDD.CIMD_MCP_AGENT_JOB_TITLE);
module.exports["isMcpAgentJobTitle"] = $86dc8408bc6a6ace$export$7ddee5b97e00b19;

});

parcelRegister("g8bbY", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $6ohxN = parcelRequire("6ohxN");


var $bGjLa = parcelRequire("bGjLa");

const $ed6d952ef1a68788$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CommentEditor(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
            ...props,
            appearance: "comment",
            AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
        });
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function CommentEditor(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6ohxN.CoreEditor), {
        ...props,
        appearance: "comment",
        AppearanceComponent: (0, $bGjLa.CommentEditorWithIntl)
    });
};
module.exports["CommentEditor"] = $ed6d952ef1a68788$export$4153d6fbc2386422;

});

parcelRegister("94aYC", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $6mKj3 = parcelRequire("6mKj3");


var $1a6Dn = parcelRequire("1a6Dn");


var $4aXCv = parcelRequire("4aXCv");

const $bb1528dd9e2e2374$var$CONTAINERS = [
    (0, $1a6Dn.FloatingBannerStateContainer)
];
const $bb1528dd9e2e2374$var$FloatingBannerHeightReaderWithHooks = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { children: children } = t0;
    const height = (0, $4aXCv.useFloatingBannerHeight)();
    let t1;
    if ($[0] !== height) {
        t1 = {
            getFloatingHeight: ()=>height
        };
        $[0] = height;
        $[1] = t1;
    } else t1 = $[1];
    const state = t1;
    let t2;
    if ($[2] !== children || $[3] !== state) {
        t2 = children(state);
        $[2] = children;
        $[3] = state;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2);
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
const $bb1528dd9e2e2374$export$19b8626304e68695 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = t0;
    if ((0, $6mKj3.expValEquals)("confluence_banner_store_migration", "isEnabled", true)) {
        let t1;
        if ($[0] !== children) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bb1528dd9e2e2374$var$FloatingBannerHeightReaderWithHooks, null, children);
            $[0] = children;
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    let t1;
    if ($[2] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: $bb1528dd9e2e2374$var$CONTAINERS
        }, (state)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state)));
        $[2] = children;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
module.exports["FloatingBannerHeightReader"] = $bb1528dd9e2e2374$export$19b8626304e68695;

});

parcelRegister("1a6Dn", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $20Ava = parcelRequire("20Ava");


var $hrAmX = parcelRequire("hrAmX");


var $a4dgs = parcelRequire("a4dgs");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $a4dgs.BaseStateContainer) {
    constructor(props = {}){
        super();
        this.state = {
            floatingBanners: []
        };
        // Capture the backing at construction so writes and reads cannot diverge after a flag change.
        this.storeBacked = void 0;
        this.unsubscribeFromStore = null;
        this.pendingNotify = null;
        this.showFloating = (name, height)=>{
            if (this.storeBacked) {
                (0, $20Ava.showFloatingBanner)(name, height);
                return;
            }
            // The lookup has to happen inside the updater: updates queued in the same microtask are
            // applied in sequence, so an index resolved beforehand would already be stale.
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index === -1) return {
                    ...state,
                    floatingBanners: [
                        ...state.floatingBanners,
                        {
                            name: name,
                            height: height
                        }
                    ]
                };
                if (state.floatingBanners[index].height !== height) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    // Replace rather than mutate, so the previous state keeps the old height.
                    newArray[index] = {
                        name: name,
                        height: height
                    };
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.hideFloating = (name)=>{
            if (this.storeBacked) {
                (0, $20Ava.hideFloatingBanner)(name);
                return;
            }
            this.setState((state)=>{
                const index = (0, $hrAmX.findBanner)(name, state.floatingBanners);
                if (index > -1) {
                    const newArray = [
                        ...state.floatingBanners
                    ];
                    newArray.splice(index, 1);
                    return {
                        ...state,
                        floatingBanners: newArray
                    };
                }
                return undefined;
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
        /** Short-lived legacy adapters must detach; hook consumers do not create an adapter. */ this.destroy = ()=>{
            this.unsubscribeFromStore?.();
            this.unsubscribeFromStore = null;
        };
        this.scheduleNotify = ()=>{
            if (this.pendingNotify) return;
            this.pendingNotify = Promise.resolve().then(()=>{
                this.pendingNotify = null;
                return this.notifyListeners();
            });
        };
        this.state = props.initialState ?? {
            floatingBanners: []
        };
        this.storeBacked = (0, $6mKj3.expValEquals)('confluence_banner_store_migration', 'isEnabled', true);
        if (this.storeBacked) {
            (0, $20Ava.seedFloatingBanners)(this.state.floatingBanners);
            this.state = {
                floatingBanners: (0, $20Ava.getFloatingBanners)()
            };
            this.unsubscribeFromStore = (0, $20Ava.subscribeToFloatingBanners)(()=>{
                this.state = {
                    floatingBanners: (0, $20Ava.getFloatingBanners)()
                };
                this.scheduleNotify();
            });
        }
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("20Ava", function(module, exports) {
const $c17615dceb29a4ad$var$NO_FLOATING_BANNERS = Object.freeze([]);
let $c17615dceb29a4ad$var$floatingBanners = $c17615dceb29a4ad$var$NO_FLOATING_BANNERS;
const $c17615dceb29a4ad$var$listeners = new Set();
let $c17615dceb29a4ad$var$pending = [];
let $c17615dceb29a4ad$var$pendingFlush = null;
const $c17615dceb29a4ad$export$9601ef6a4137b54f = ()=>$c17615dceb29a4ad$var$floatingBanners;
const $c17615dceb29a4ad$export$8cceb204fc79b9a = (listener)=>{
    $c17615dceb29a4ad$var$listeners.add(listener);
    return ()=>$c17615dceb29a4ad$var$listeners.delete(listener);
};
const $c17615dceb29a4ad$var$commit = (next)=>{
    $c17615dceb29a4ad$var$floatingBanners = next;
    Array.from($c17615dceb29a4ad$var$listeners).forEach((listener)=>listener());
};
const $c17615dceb29a4ad$var$enqueue = (mutation)=>{
    $c17615dceb29a4ad$var$pending.push(mutation);
    if ($c17615dceb29a4ad$var$pendingFlush) return;
    $c17615dceb29a4ad$var$pendingFlush = Promise.resolve().then(()=>{
        $c17615dceb29a4ad$var$pendingFlush = null;
        const queued = $c17615dceb29a4ad$var$pending;
        $c17615dceb29a4ad$var$pending = [];
        let next = $c17615dceb29a4ad$var$floatingBanners;
        for (const mutate of queued)next = mutate(next) ?? next;
        if (next !== $c17615dceb29a4ad$var$floatingBanners) $c17615dceb29a4ad$var$commit(next);
    });
};
const $c17615dceb29a4ad$export$88af26db9e2da3ec = (name, height)=>{
    $c17615dceb29a4ad$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return [
            ...current,
            {
                name: name,
                height: height
            }
        ];
        if (current[index].height === height) return undefined;
        const next = [
            ...current
        ];
        next[index] = {
            name: name,
            height: height
        };
        return next;
    });
};
const $c17615dceb29a4ad$export$32b15174cd740c3b = (name)=>{
    $c17615dceb29a4ad$var$enqueue((current)=>{
        const index = current.findIndex((banner)=>banner.name === name);
        if (index === -1) return undefined;
        const next = [
            ...current
        ];
        next.splice(index, 1);
        return next;
    });
};
const $c17615dceb29a4ad$export$48341d3794cc50ca = (initial)=>{
    if ($c17615dceb29a4ad$var$floatingBanners.length === 0 && initial.length > 0) $c17615dceb29a4ad$var$commit([
        ...initial
    ]);
};
const $c17615dceb29a4ad$export$3f62fcce50d282d1 = ()=>{
    $c17615dceb29a4ad$var$floatingBanners = $c17615dceb29a4ad$var$NO_FLOATING_BANNERS;
    $c17615dceb29a4ad$var$listeners.clear();
    $c17615dceb29a4ad$var$pending = [];
    $c17615dceb29a4ad$var$pendingFlush = null;
};
module.exports["getFloatingBanners"] = $c17615dceb29a4ad$export$9601ef6a4137b54f;
module.exports["subscribeToFloatingBanners"] = $c17615dceb29a4ad$export$8cceb204fc79b9a;
module.exports["showFloatingBanner"] = $c17615dceb29a4ad$export$88af26db9e2da3ec;
module.exports["hideFloatingBanner"] = $c17615dceb29a4ad$export$32b15174cd740c3b;
module.exports["seedFloatingBanners"] = $c17615dceb29a4ad$export$48341d3794cc50ca;

});

parcelRegister("4aXCv", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $jxpvN = parcelRequire("jxpvN");


var $20Ava = parcelRequire("20Ava");

const $38326cf9f96fcd4c$var$EMPTY_FLOATING_BANNERS = Object.freeze([]);
function $38326cf9f96fcd4c$export$bdb8807d0c5e784b() {
    const { suppressed: suppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    const getSnapshot = $38326cf9f96fcd4c$var$_temp2;
    const height_0 = (0, $cozmU.useSyncExternalStore)((0, $20Ava.subscribeToFloatingBanners), getSnapshot, getSnapshot);
    return suppressed ? 0 : height_0;
}
function $38326cf9f96fcd4c$var$_temp2() {
    return (0, $20Ava.getFloatingBanners)().reduce($38326cf9f96fcd4c$var$_temp, 0);
}
function $38326cf9f96fcd4c$var$_temp(height, banner) {
    return height + banner.height;
}
function $38326cf9f96fcd4c$export$aa6c04f1b3649c17() {
    const $ = (0, $bDgLe.c)(2);
    const { suppressed: suppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    let t0;
    if ($[0] !== suppressed) {
        t0 = ()=>suppressed ? $38326cf9f96fcd4c$var$EMPTY_FLOATING_BANNERS : (0, $20Ava.getFloatingBanners)();
        $[0] = suppressed;
        $[1] = t0;
    } else t0 = $[1];
    const getSnapshot = t0;
    return (0, $cozmU.useSyncExternalStore)((0, $20Ava.subscribeToFloatingBanners), getSnapshot, getSnapshot);
}
function $38326cf9f96fcd4c$export$8eb70413c836f97c(name) {
    const $ = (0, $bDgLe.c)(3);
    const { suppressed: suppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    let t0;
    if ($[0] !== name || $[1] !== suppressed) {
        t0 = ()=>{
            if (suppressed) return 0;
            const banners = (0, $20Ava.getFloatingBanners)();
            const index = banners.findIndex((banner)=>banner.name === name);
            return index === -1 ? 0 : banners.slice(0, index).reduce($38326cf9f96fcd4c$var$_temp3, 0);
        };
        $[0] = name;
        $[1] = suppressed;
        $[2] = t0;
    } else t0 = $[2];
    const getSnapshot = t0;
    return (0, $cozmU.useSyncExternalStore)((0, $20Ava.subscribeToFloatingBanners), getSnapshot, getSnapshot);
}
function $38326cf9f96fcd4c$var$_temp3(height, banner_0) {
    return height + banner_0.height;
}
function $38326cf9f96fcd4c$export$3897001029dae2d8() {
    const $ = (0, $bDgLe.c)(2);
    const { suppressed: suppressed } = (0, $cozmU.useContext)((0, $jxpvN.BannerContext));
    let t0;
    if ($[0] !== suppressed) {
        t0 = {
            showFloating: (name, height)=>{
                if (!suppressed) (0, $20Ava.showFloatingBanner)(name, height);
            },
            hideFloating: (name_0)=>{
                if (!suppressed) (0, $20Ava.hideFloatingBanner)(name_0);
            }
        };
        $[0] = suppressed;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
}
module.exports["useFloatingBannerHeight"] = $38326cf9f96fcd4c$export$bdb8807d0c5e784b;
module.exports["useFloatingBannerEntries"] = $38326cf9f96fcd4c$export$aa6c04f1b3649c17;

});

parcelRegister("8WfxO", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = ()=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $cozmU.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $cozmU.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const batchResult = (0, $9Z1sw.useWebPanelLocationBatchResult)(location);
    const batchResultData = batchResult?.data;
    const batchResultError = batchResult?.error;
    const batchResultLoading = batchResult?.loading;
    const completedBatchResultKeyRef = (0, $cozmU.useRef)(null);
    const baseOptions = {
        variables: variables,
        skip: Boolean(batchResult),
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    // Keep watching query for home route to avoid VC90 regression
    const useNoFurtherUpdate = location !== (0, $eSLr0.DASHBOARD_SECONDARY);
    const { loading: loading, data: data, error: error } = useNoFurtherUpdate ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        __callerPackage__: "web-panel-location"
    }) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy,
        __callerPackage__: "web-panel-location"
    });
    const result = batchResult ?? {
        loading: loading,
        data: data,
        error: error
    };
    (0, $cozmU.useEffect)(()=>{
        if (batchResultLoading || batchResultError || !batchResultData || !onCompleted) return;
        const batchResultKey = `${contentIdentifier || ''}:${spaceIdentifier || ''}:${location}`;
        if (completedBatchResultKeyRef.current !== batchResultKey) {
            completedBatchResultKeyRef.current = batchResultKey;
            onCompleted();
        }
    }, [
        batchResultData,
        batchResultError,
        batchResultLoading,
        contentIdentifier,
        location,
        onCompleted,
        spaceIdentifier
    ]);
    const panels = (result.data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: result.loading,
        error: result.error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("7VJPz", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8jDil = parcelRequire("8jDil");

var $5FMVr = parcelRequire("5FMVr");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $1lyRS = parcelRequire("1lyRS");

const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $8jDil.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $5FMVr.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1lyRS.SmartButtonLoader), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("5kjCz", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $dOBRD.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("4KFTW", function(module, exports) {

var $2bAZx = parcelRequire("2bAZx");


var $5kjCz = parcelRequire("5kjCz");

function $38a1fdadc870189c$export$ed05b2901e9d7d22({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name, timeout: timeout }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).start({
            attributes: attributes,
            name: name,
            timeout: timeout,
            id: attributes?.macroId || contentId
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name,
        timeout
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStart"] = $38a1fdadc870189c$export$ed05b2901e9d7d22;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $cozmU.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $cozmU.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("1lyRS", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("gy2By"))).SmartButton
});
module.exports["SmartButtonLoader"] = $16e92128cf9491a8$export$32d8d71ddecea49c;

});

parcelRegister("gy2By", function(module, exports) {

let $c0c1d794e20a6336$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $c0c1d794e20a6336$var$load("excC5"),
    $c0c1d794e20a6336$var$load("6wr18"),
    $c0c1d794e20a6336$var$load("4938u"),
    $c0c1d794e20a6336$var$load("hhss7"),
    $c0c1d794e20a6336$var$load("2xKrc"),
    $c0c1d794e20a6336$var$load("ffEVr"),
    $c0c1d794e20a6336$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("lOeVN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $8aF6s = parcelRequire("8aF6s");


var $jmjWc = parcelRequire("jmjWc");

function $926167cc1656a619$export$4be696be8a3bff13(props) {
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const propsRef = (0, $cozmU.useRef)();
    propsRef.current = props;
    return (0, $cozmU.useCallback)(()=>showModal($926167cc1656a619$var$FeedbackCollectorLoader, propsRef.current), [
        showModal
    ]);
}

const $926167cc1656a619$var$FeedbackCollectorLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "nSIir",
    name: "FeedbackCollectorLoader",
    loader: async ()=>(await (parcelRequire("5E8QK"))).FeedbackCollector
});
module.exports["useFeedbackCollector"] = $926167cc1656a619$export$4be696be8a3bff13;

});

parcelRegister("5E8QK", function(module, exports) {

let $41c78d93fde5dc21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41c78d93fde5dc21$var$load("4nZ85"),
    $41c78d93fde5dc21$var$load("hhss7"),
    $41c78d93fde5dc21$var$load("kHXvF"),
    $41c78d93fde5dc21$var$load("bUC6C")
]).then(()=>parcelRequire('cz7bE'));

});

parcelRegister("bflGB", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EemN = parcelRequire("9EemN");

parcelRequire("1syzX");


var $l65Bo = parcelRequire("l65Bo");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");


var $1k6sE = parcelRequire("1k6sE");


var $4q9NN = parcelRequire("4q9NN");

if (typeof window !== 'undefined') {
    // allow to track events on specific elements
    const originalStopCallback = (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback;
    // Note here should be function instead of arrow function as we want to preserve the context of this
    (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).prototype.stopCallback = function(...[e, element, combo]) {
        // Prompt inputs such as Ask Rovo also use ProseMirror. Allow editor commands,
        // but let Mousetrap suppress shortcuts for characters being typed into them.
        const isTypingInEditor = 'isContentEditable' in element && element.isContentEditable === true && e.key?.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
        let allowedElements = (0, $1k6sE.MOUSETRAP_ALLOWED_ELEMENTS);
        if (element.classList.contains((0, $1k6sE.PROSEMIRROR_FOCUSED_CLASS)) && isTypingInEditor && (0, $6mKj3.expVal)('cc_ai_growth_remix_prevent_shortcuts', 'isEnabled', false)) allowedElements = allowedElements.filter((className)=>className !== (0, $1k6sE.PROSEMIRROR_FOCUSED_CLASS));
        const isAllowed = allowedElements.some((className)=>element.classList.contains(className));
        const isAllowedInModal = (0, $1k6sE.MOUSETRAP_ALLOWED_MODALS).map((className)=>element.closest(`.${className}`)).some((truthful)=>truthful);
        return isAllowed || isAllowedInModal ? false : originalStopCallback.call(this, e, element, combo);
    };
}
const $299ae5ea83dc6310$var$ALLOWED_MIN_TIME = 150;
var $299ae5ea83dc6310$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["Confluence"] = "Confluence";
    ShortcutType["Forge"] = "Forge";
    return ShortcutType;
}({});
class $299ae5ea83dc6310$export$d29b063d6e86bfeb extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        this.checkConflictThenBindAccelerator(accelerator, shortcutType);
    }
    componentDidUpdate(prevProps) {
        const { accelerator: prevAccelerator } = prevProps;
        const { accelerator: accelerator, shortcutType: shortcutType = "Confluence" } = this.props;
        const prevAccelerators = this.getAccelerators(prevAccelerator);
        // Using JSON.stringify to compare because accelerator may be a list of strings
        if (JSON.stringify(prevAccelerator) !== JSON.stringify(accelerator)) {
            this.unbindAccelerators(prevAccelerators);
            this.checkConflictThenBindAccelerator(accelerator, shortcutType);
        }
    }
    componentWillUnmount() {
        const { accelerator: accelerator } = this.props;
        const accelerators = this.getAccelerators(accelerator);
        this.unbindAccelerators(accelerators);
    }
    getAccelerators(accelerator) {
        return Array.isArray(accelerator) ? accelerator : [
            accelerator
        ];
    }
    getShortcutConflicts(accelerators) {
        return accelerators.map((a)=>({
                accelerator: a,
                conflictType: $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a]
            })).filter((o)=>o.conflictType);
    }
    isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts) {
        return shortcutType === "Confluence" && shortcutConflicts.every((o)=>o.conflictType === "Forge");
    }
    checkConflictThenBindAccelerator(accelerator, shortcutType) {
        const accelerators = this.getAccelerators(accelerator);
        const shortcutConflicts = this.getShortcutConflicts(accelerators);
        if (!shortcutConflicts.length) this.bindAccelerators(accelerators, shortcutType);
        else if (this.isConfluenceShortcutAndAllConflictsAreForgeShortcuts(shortcutType, shortcutConflicts)) {
            shortcutConflicts.forEach((c)=>(0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(c.accelerator));
            this.bindAccelerators(accelerators, shortcutType);
        }
    }
    bindAccelerators(accelerators, shortcutType) {
        accelerators.forEach((a)=>{
            if (a.includes('+') && shortcutType !== "Forge" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal === 'function') // bindGlobal allows shortcut to work when a input field is focused, see https://github.com/ccampbell/mousetrap/blob/master/plugins/global-bind/README.md
            // This allows user to use shortcut to publish the page when focusing on editor title
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bindGlobal(a, this._call);
            else (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).bind(a, this._call);
            $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a] = shortcutType;
        });
    }
    unbindAccelerators(accelerators) {
        accelerators.forEach((a)=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($9EemN))).unbind(a);
            delete $299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners[a];
        });
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        this.listeners = {};
        this.lastFired = 0;
        this._call = (e, combo)=>{
            // User can only fire a shortcut event in every 150ms
            // This can avoid a part of sequence being recognized as a single key shortcut
            // eg: "s" will be triggered when user enters "g s" without this
            const now = Date.now();
            if (now - this.lastFired >= $299ae5ea83dc6310$var$ALLOWED_MIN_TIME) {
                if (this.props.allowInDialog || !(0, $l65Bo.isDialogShown)()) {
                    this.lastFired = now;
                    this.props.listener(e, combo);
                }
            }
        };
    }
}
$299ae5ea83dc6310$export$d29b063d6e86bfeb.defaultProps = {
    allowInDialog: false,
    shortcutType: "Confluence"
};
$299ae5ea83dc6310$export$d29b063d6e86bfeb.listeners = {};
const $299ae5ea83dc6310$var$ShortcutListenerFC = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    let accelerator;
    let deprecatedAccelerator;
    let flags;
    let listener;
    let otherProps;
    if ($[0] !== t0) {
        ({ flags: flags, deprecatedAccelerator: deprecatedAccelerator, accelerator: accelerator, listener: listener, ...otherProps } = t0);
        $[0] = t0;
        $[1] = accelerator;
        $[2] = deprecatedAccelerator;
        $[3] = flags;
        $[4] = listener;
        $[5] = otherProps;
    } else {
        accelerator = $[1];
        deprecatedAccelerator = $[2];
        flags = $[3];
        listener = $[4];
        otherProps = $[5];
    }
    let t1;
    if ($[6] !== accelerator || $[7] !== deprecatedAccelerator || $[8] !== flags || $[9] !== listener) {
        t1 = (e, combo)=>{
            (0, $4q9NN.maybeShowDeprecatedShortcutFlag)({
                flags: flags,
                acceleratorTriggered: combo,
                accelerator: accelerator,
                deprecatedAccelerator: deprecatedAccelerator
            });
            listener(e, combo);
        };
        $[6] = accelerator;
        $[7] = deprecatedAccelerator;
        $[8] = flags;
        $[9] = listener;
        $[10] = t1;
    } else t1 = $[10];
    const deprecatedListener = t1;
    let t2;
    if ($[11] !== deprecatedAccelerator || $[12] !== deprecatedListener || $[13] !== otherProps) {
        t2 = deprecatedAccelerator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: deprecatedAccelerator,
            listener: deprecatedListener,
            ...otherProps
        });
        $[11] = deprecatedAccelerator;
        $[12] = deprecatedListener;
        $[13] = otherProps;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== accelerator || $[16] !== listener || $[17] !== otherProps) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($299ae5ea83dc6310$export$d29b063d6e86bfeb, {
            accelerator: accelerator,
            listener: listener,
            ...otherProps
        });
        $[15] = accelerator;
        $[16] = listener;
        $[17] = otherProps;
        $[18] = t3;
    } else t3 = $[18];
    let t4;
    if ($[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t2, t3);
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
};
const $299ae5ea83dc6310$export$52e6eadeebf8c534 = (0, $7aRa9.withFlags)($299ae5ea83dc6310$var$ShortcutListenerFC);
module.exports["ShortcutType"] = $299ae5ea83dc6310$export$99058db374262376;
module.exports["ShortcutListener"] = $299ae5ea83dc6310$export$52e6eadeebf8c534;

});

parcelRegister("1syzX", function(module, exports) {
/**
 * adds a bindGlobal method to Mousetrap that allows you to
 * bind specific keyboard shortcuts that will still work
 * inside a text input field
 *
 * usage:
 * Mousetrap.bindGlobal('ctrl+s', _saveChanges);
 */ /* global Mousetrap:true */ (function(Mousetrap1) {
    if (!Mousetrap1) return;
    var _globalCallbacks = {};
    var _originalStopCallback = Mousetrap1.prototype.stopCallback;
    Mousetrap1.prototype.stopCallback = function(e, element, combo, sequence) {
        var self = this;
        if (self.paused) return true;
        if (_globalCallbacks[combo] || _globalCallbacks[sequence]) return false;
        return _originalStopCallback.call(self, e, element, combo);
    };
    Mousetrap1.prototype.bindGlobal = function(keys, callback, action) {
        var self = this;
        self.bind(keys, callback, action);
        if (keys instanceof Array) {
            for(var i = 0; i < keys.length; i++)_globalCallbacks[keys[i]] = true;
            return;
        }
        _globalCallbacks[keys] = true;
    };
    Mousetrap1.init();
})(typeof Mousetrap !== "undefined" ? Mousetrap : undefined);

});

parcelRegister("l65Bo", function(module, exports) {
// we'd like to be able to check if the dialog is displaying right now
const $0afa19b4dc37db45$export$f0b76e53a3d1db73 = ()=>{
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const portals = Array.from(document.getElementsByClassName('atlaskit-portal')).filter((portal)=>portal.firstChild);
    const isAtlaskitDialogShown = Boolean(portals.filter((item)=>item.querySelectorAll('[role="dialog"]').length).length);
    const isLoomRecorderDialogShown = Boolean(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.getElementById('loom-sdk-record-overlay-shadow-root-id')?.shadowRoot?.getElementById('preview-recording'));
    return isAtlaskitDialogShown || isLoomRecorderDialogShown;
};
module.exports["isDialogShown"] = $0afa19b4dc37db45$export$f0b76e53a3d1db73;

});

parcelRegister("1k6sE", function(module, exports) {

var $gnkil = parcelRequire("gnkil");


var $9aQ0J = parcelRequire("9aQ0J");

const $ca7c59da1dc6c0fe$export$d05888cf23195902 = 'shortcuts-are-allowed';
const $ca7c59da1dc6c0fe$export$ccca490433ac184a = 'shortcuts-are-allowed-in-modal';
const $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e = 'ProseMirror-focused';
const $ca7c59da1dc6c0fe$export$95466aa5e4023a13 = [
    $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e,
    $ca7c59da1dc6c0fe$export$d05888cf23195902
];
const $ca7c59da1dc6c0fe$export$eca1f9acdad825ae = [
    $ca7c59da1dc6c0fe$export$ccca490433ac184a
];
const $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7 = Object.values($gnkil).reduce((0, $9aQ0J.getShortcutValues), []);
module.exports["ALLOW_SHORTCUTS_CLASS"] = $ca7c59da1dc6c0fe$export$d05888cf23195902;
module.exports["ALLOW_SHORTCUTS_CLASS_IN_MODAL"] = $ca7c59da1dc6c0fe$export$ccca490433ac184a;
module.exports["PROSEMIRROR_FOCUSED_CLASS"] = $ca7c59da1dc6c0fe$export$e97f6b5e579dc7e;
module.exports["MOUSETRAP_ALLOWED_ELEMENTS"] = $ca7c59da1dc6c0fe$export$95466aa5e4023a13;
module.exports["MOUSETRAP_ALLOWED_MODALS"] = $ca7c59da1dc6c0fe$export$eca1f9acdad825ae;
module.exports["RESERVED_SHORTCUTS"] = $ca7c59da1dc6c0fe$export$a6834c81db6fbcc7;

});

parcelRegister("9aQ0J", function(module, exports) {
const $a5d5607ba4daeddb$export$58cbf3bcb054e9cd = (accumulated, current)=>{
    if (typeof current === 'string') accumulated.push(current);
    else if (typeof current === 'object') accumulated.push(...Object.values(current).reduce($a5d5607ba4daeddb$export$58cbf3bcb054e9cd, []));
    return accumulated;
};
module.exports["getShortcutValues"] = $a5d5607ba4daeddb$export$58cbf3bcb054e9cd;

});

parcelRegister("4q9NN", function(module, exports) {
/* DeprecatedShortcutFlag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $i1t43 = parcelRequire("i1t43");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $4tOXV = parcelRequire("4tOXV");

const $3c4669a4d8882aac$var$i18n = (0, $kSwu1.defineMessages)({
    deprecatedShortcutFlagTitle: {
        id: "shortcuts.deprecated-shortcut-flag.title",
        defaultMessage: "This shortcut is about to change"
    },
    deprecatedShortcutFlagDescription: {
        id: "shortcuts.deprecated-shortcut-flag.description",
        defaultMessage: "Shortcuts are switching to a <supportLink>universal format</supportLink>. <inline>{oldShortcut} will now be {newShortcut}</inline>"
    },
    remindMeLaterButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.remind-me-later",
        defaultMessage: "Remind me later"
    },
    dontTellMeAgainButton: {
        id: "shortcuts.deprecated-shortcut-flag.button.dont-tell-me-again",
        defaultMessage: "Don\u2019t tell me again"
    }
});
const $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK = 'https://support.atlassian.com/confluence-cloud/docs/keyboard-shortcuts-markdown-and-autocomplete/';
const $3c4669a4d8882aac$var$shortcutSentenceCss = null;
const $3c4669a4d8882aac$var$getShortcutDescription = ({ oldShortcut: oldShortcut, newShortcut: newShortcut, acceleratorTriggered: acceleratorTriggered })=>{
    let newS = Array.isArray(newShortcut) ? newShortcut[0] : newShortcut; // ShortcutListener allows for multiple accelerators to be specified for one callback.  Ex. ["a", "mod+9"].
    // If any of those are triggerred, the callback will activate.
    // This makes it a little tricky to figure out what accelerator to recommend as a replacement.
    // Ex. deprecatedAccelerator: ["a", "b"], accelerator: ["mod+a", "mod+b"]
    // - If multiple accelerators are available in `newShortcut`, we default to the first one.
    // - However, if an equal number of accelerators are available in `oldShortcut` and `newShortcut`,
    //   then we look for the accelerator corresponding with the one that was actually triggered,
    //   based on array index.
    if (Array.isArray(oldShortcut) && Array.isArray(newShortcut) && oldShortcut.length === newShortcut.length) {
        const triggeredIndex = oldShortcut.indexOf(acceleratorTriggered);
        if (triggeredIndex >= 0 && triggeredIndex < newShortcut.length) newS = newShortcut[triggeredIndex];
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagDescription,
        values: {
            supportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $3c4669a4d8882aac$var$KEYBOARD_SHORTCUTS_SUPPORT_LINK
                }, chunks),
            oldShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: acceleratorTriggered
            }),
            newShortcut: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                shortcut: newS
            }),
            inline: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: (0, $hekY6.default)([
                        "_2mHwu8FQfX _3iDTPbQ4SZ _0hPCNLDIqT"
                    ])
                }, chunks)
        }
    });
};
const $3c4669a4d8882aac$var$FOREVER = 'forever';
const $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID = 'deprecatedShortcutFlag';
const $3c4669a4d8882aac$var$shouldShowDeprecationFlag = ()=>{
    const hiddenUntilTime = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL) || '';
    if (hiddenUntilTime === $3c4669a4d8882aac$var$FOREVER) return false;
    else if (hiddenUntilTime !== '') {
        const hiddenUntilTimeInMs = Number(hiddenUntilTime);
        if (!isNaN(hiddenUntilTimeInMs)) return Date.now() > hiddenUntilTimeInMs;
    }
    return true;
};
const $3c4669a4d8882aac$export$799f01f4b30e66c7 = ({ flags: flags, acceleratorTriggered: acceleratorTriggered, accelerator: accelerator, deprecatedAccelerator: deprecatedAccelerator })=>{
    if ($3c4669a4d8882aac$var$shouldShowDeprecationFlag()) flags.showFlag({
        id: $3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.deprecatedShortcutFlagTitle),
        description: $3c4669a4d8882aac$var$getShortcutDescription({
            oldShortcut: deprecatedAccelerator,
            newShortcut: accelerator,
            acceleratorTriggered: acceleratorTriggered
        }),
        type: 'success',
        close: 'never',
        // Needed to bypass the flags.hideAllFlags() that happens on some page transitions.
        actions: [
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.remindMeLaterButton),
                onClick: ()=>{
                    // Hide the prompt for 7 days.
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, Date.now() + 1000 * 60 * 60 * 24 * 7);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            },
            {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $3c4669a4d8882aac$var$i18n.dontTellMeAgainButton),
                onClick: ()=>{
                    (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL, $3c4669a4d8882aac$var$FOREVER);
                    flags.hideFlag($3c4669a4d8882aac$var$DEPRECATED_SHORTCUT_FLAG_ID);
                }
            }
        ]
    });
};
module.exports["maybeShowDeprecatedShortcutFlag"] = $3c4669a4d8882aac$export$799f01f4b30e66c7;

});

parcelRegister("fZvv3", function(module, exports) {

var $coD4j = parcelRequire("coD4j");

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $ba44fcbbb2d24900$var$castFunction(value) {
    return typeof value == 'function' ? value : $coD4j;
}
module.exports = $ba44fcbbb2d24900$var$castFunction;

});

parcelRegister("jIDse", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $89bON = parcelRequire("89bON");


var $IQ4Dz = parcelRequire("IQ4Dz");


var $iRKv3 = parcelRequire("iRKv3");

const $cbf4e122dd89063e$var$BACKGROUND_LIGHTNESS_MAX = 35;
const $cbf4e122dd89063e$var$TEXT_LIGHTNESS_MIN = 90;
const $cbf4e122dd89063e$export$f11b6ab43332cfcf = (lightModeColor)=>{
    if (lightModeColor === '#FFFFFF') return (0, $89bON.getTokenValue)('elevation.surface.overlay', '#1D2125');
    else {
        const lightnessPercentage = (0, $iRKv3.getLightnessPercentage)(lightModeColor);
        if (lightnessPercentage === undefined) return lightModeColor;
        return lightnessPercentage > $cbf4e122dd89063e$var$BACKGROUND_LIGHTNESS_MAX ? (0, $iRKv3.reduceLightness)(lightModeColor, $cbf4e122dd89063e$var$BACKGROUND_LIGHTNESS_MAX) : lightModeColor;
    }
};
const $cbf4e122dd89063e$export$c17d6b0d1b5d5ab6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (isSSRProductInDarkMode)=>{
    const $ = (0, $bDgLe.c)(8);
    const isSpaAkThemeInDarkMode = (0, $IQ4Dz.useThemeObserver)().colorMode === "dark";
    const shouldEvaluateLightness = isSpaAkThemeInDarkMode;
    let t0;
    if ($[0] !== shouldEvaluateLightness) {
        t0 = (backgroundColor)=>shouldEvaluateLightness ? $cbf4e122dd89063e$export$f11b6ab43332cfcf(backgroundColor) : backgroundColor;
        $[0] = shouldEvaluateLightness;
        $[1] = t0;
    } else t0 = $[1];
    const getDarkModeCompatibleBackgroundColor = t0;
    let t1;
    if ($[2] !== shouldEvaluateLightness) {
        t1 = (textColor)=>shouldEvaluateLightness ? (0, $iRKv3.increaseLightness)(textColor, $cbf4e122dd89063e$var$TEXT_LIGHTNESS_MIN) : textColor;
        $[2] = shouldEvaluateLightness;
        $[3] = t1;
    } else t1 = $[3];
    const getDarkModeCompatibleTextColor = t1;
    let t2;
    if ($[4] !== getDarkModeCompatibleBackgroundColor || $[5] !== getDarkModeCompatibleTextColor || $[6] !== shouldEvaluateLightness) {
        t2 = {
            shouldEvaluateBackgroundLightness: shouldEvaluateLightness,
            getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor,
            getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor
        };
        $[4] = getDarkModeCompatibleBackgroundColor;
        $[5] = getDarkModeCompatibleTextColor;
        $[6] = shouldEvaluateLightness;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (isSSRProductInDarkMode)=>{
    const isSpaAkThemeInDarkMode = (0, $IQ4Dz.useThemeObserver)().colorMode === 'dark';
    const shouldEvaluateLightness = isSpaAkThemeInDarkMode;
    const getDarkModeCompatibleBackgroundColor = (0, $cozmU.useCallback)((backgroundColor)=>{
        return shouldEvaluateLightness ? $cbf4e122dd89063e$export$f11b6ab43332cfcf(backgroundColor) : backgroundColor;
    }, [
        shouldEvaluateLightness
    ]);
    const getDarkModeCompatibleTextColor = (0, $cozmU.useCallback)((textColor)=>{
        return shouldEvaluateLightness ? (0, $iRKv3.increaseLightness)(textColor, $cbf4e122dd89063e$var$TEXT_LIGHTNESS_MIN) : textColor;
    }, [
        shouldEvaluateLightness
    ]);
    return {
        shouldEvaluateBackgroundLightness: shouldEvaluateLightness,
        getDarkModeCompatibleBackgroundColor: getDarkModeCompatibleBackgroundColor,
        getDarkModeCompatibleTextColor: getDarkModeCompatibleTextColor
    };
};
module.exports["useDarkModeColors"] = $cbf4e122dd89063e$export$c17d6b0d1b5d5ab6;

});

parcelRegister("iRKv3", function(module, exports) {
const $8fc3f1a6584fae2a$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $8fc3f1a6584fae2a$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (_m, r, g, b)=>r + r + g + g + b + b);
const $8fc3f1a6584fae2a$var$rgbFromHex = (input)=>{
    const fullHex = $8fc3f1a6584fae2a$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $8fc3f1a6584fae2a$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $8fc3f1a6584fae2a$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $8fc3f1a6584fae2a$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $8fc3f1a6584fae2a$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $8fc3f1a6584fae2a$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $8fc3f1a6584fae2a$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $8fc3f1a6584fae2a$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $8fc3f1a6584fae2a$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $8fc3f1a6584fae2a$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $8fc3f1a6584fae2a$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $8fc3f1a6584fae2a$var$rgbToLch = (rgb)=>$8fc3f1a6584fae2a$var$labToLch($8fc3f1a6584fae2a$var$xyzToLab($8fc3f1a6584fae2a$var$rgbToXyz(rgb)));
const $8fc3f1a6584fae2a$var$lchToRgb = (lch)=>$8fc3f1a6584fae2a$var$xyzToRgb($8fc3f1a6584fae2a$var$labToXyz($8fc3f1a6584fae2a$var$lchToLab(lch)));
const $8fc3f1a6584fae2a$export$f38e45b0889fb431 = (hexColor)=>{
    const rgb = $8fc3f1a6584fae2a$var$rgbFromHex(hexColor);
    if (rgb === null) return undefined;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $8fc3f1a6584fae2a$var$rgbToLch(rgb);
    return lch.l;
};
const $8fc3f1a6584fae2a$var$modifyLightness = (hexColor, percent, getShouldModifyLightness)=>{
    const rgb = $8fc3f1a6584fae2a$var$rgbFromHex(hexColor);
    if (rgb === null) return hexColor;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $8fc3f1a6584fae2a$var$rgbToLch(rgb);
    if (getShouldModifyLightness(lch.l)) lch.l = $8fc3f1a6584fae2a$var$clamp(percent, 0, 100);
    return $8fc3f1a6584fae2a$var$rgbToHex($8fc3f1a6584fae2a$var$lchToRgb(lch));
};
const $8fc3f1a6584fae2a$export$5ec9a60e757390f1 = (hexColor, capPercent)=>{
    return $8fc3f1a6584fae2a$var$modifyLightness(hexColor, capPercent, (lightnessValue)=>lightnessValue > capPercent);
};
const $8fc3f1a6584fae2a$export$16d9f224c1d58542 = (hexColor, minPercent)=>{
    return $8fc3f1a6584fae2a$var$modifyLightness(hexColor, minPercent, (lightnessValue)=>lightnessValue < minPercent);
};
module.exports["getLightnessPercentage"] = $8fc3f1a6584fae2a$export$f38e45b0889fb431;
module.exports["reduceLightness"] = $8fc3f1a6584fae2a$export$5ec9a60e757390f1;
module.exports["increaseLightness"] = $8fc3f1a6584fae2a$export$16d9f224c1d58542;

});

parcelRegister("LI9nv", function(module, exports) {

module.exports = (parcelRequire("gFnRy"));

});

parcelRegister("gFnRy", function(module, exports) {

var $7aPLP = parcelRequire("7aPLP");


var $bNHBU = parcelRequire("bNHBU");


var $fZvv3 = parcelRequire("fZvv3");


var $1ScXu = parcelRequire("1ScXu");

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $c222fc52732a8568$var$forEach(collection, iteratee) {
    var func = $1ScXu(collection) ? $7aPLP : $bNHBU;
    return func(collection, $fZvv3(iteratee));
}
module.exports = $c222fc52732a8568$var$forEach;

});

parcelRegister("1PPDm", function(module, exports) {
"use strict";
var $15629b4bdedac47d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @name catchError
 */ function $15629b4bdedac47d$var$catchError(selector) {
    return function catchErrorOperatorFunction(source) {
        var operator = new $15629b4bdedac47d$var$CatchOperator(selector);
        var caught = source.lift(operator);
        return operator.caught = caught;
    };
}
module.exports.catchError = $15629b4bdedac47d$var$catchError;
var $15629b4bdedac47d$var$CatchOperator = function() {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $15629b4bdedac47d$var$CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $15629b4bdedac47d$var$CatchSubscriber = function(_super) {
    $15629b4bdedac47d$var$__extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            } catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add($863V0.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=catchError.js.map

});

parcelRegister("1xJn2", function(module, exports) {
"use strict";
var $11fc112c79ff43c4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $aRdp2 = parcelRequire("aRdp2");


var $iMtch = parcelRequire("iMtch");

/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */ function $11fc112c79ff43c4$var$distinctUntilChanged(compare, keySelector) {
    return function(source) {
        return source.lift(new $11fc112c79ff43c4$var$DistinctUntilChangedOperator(compare, keySelector));
    };
}
module.exports.distinctUntilChanged = $11fc112c79ff43c4$var$distinctUntilChanged;
var $11fc112c79ff43c4$var$DistinctUntilChangedOperator = function() {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $11fc112c79ff43c4$var$DistinctUntilChangedSubscriber = function(_super) {
    $11fc112c79ff43c4$var$__extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') this.compare = compare;
    }
    DistinctUntilChangedSubscriber.prototype.compare = function(x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function(value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = $aRdp2.tryCatch(this.keySelector)(value);
            if (key === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        }
        var result = false;
        if (this.hasKey) {
            result = $aRdp2.tryCatch(this.compare)(this.key, key);
            if (result === $iMtch.errorObject) return this.destination.error($iMtch.errorObject.e);
        } else this.hasKey = true;
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=distinctUntilChanged.js.map

});

parcelRegister("ebEo2", function(module, exports) {
"use strict";
var $a5416bba69d7cff3$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");

/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $a5416bba69d7cff3$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $a5416bba69d7cff3$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $a5416bba69d7cff3$var$skipWhile;
var $a5416bba69d7cff3$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5416bba69d7cff3$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5416bba69d7cff3$var$SkipWhileSubscriber = function(_super) {
    $a5416bba69d7cff3$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=skipWhile.js.map

});

parcelRegister("c7Xul", function(module, exports) {
"use strict";
var $8d4448aad9d90f95$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hmcLb = parcelRequire("hmcLb");


var $863V0 = parcelRequire("863V0");

/* tslint:enable:max-line-length */ /**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */ function $8d4448aad9d90f95$var$switchMap(project, resultSelector) {
    return function switchMapOperatorFunction(source) {
        return source.lift(new $8d4448aad9d90f95$var$SwitchMapOperator(project, resultSelector));
    };
}
module.exports.switchMap = $8d4448aad9d90f95$var$switchMap;
var $8d4448aad9d90f95$var$SwitchMapOperator = function() {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $8d4448aad9d90f95$var$SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $8d4448aad9d90f95$var$SwitchMapSubscriber = function(_super) {
    $8d4448aad9d90f95$var$__extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function(result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) innerSubscription.unsubscribe();
        this.add(this.innerSubscription = $863V0.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function() {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ SwitchMapSubscriber.prototype._unsubscribe = function() {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    SwitchMapSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        else this.destination.next(innerValue);
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}($hmcLb.OuterSubscriber); //# sourceMappingURL=switchMap.js.map

});

parcelRegister("1mLOG", function(module, exports) {
"use strict";
var $0fecefdacae1f75b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

function $0fecefdacae1f75b$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $0fecefdacae1f75b$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $0fecefdacae1f75b$var$timeInterval;
var $0fecefdacae1f75b$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $0fecefdacae1f75b$var$TimeInterval;
var $0fecefdacae1f75b$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $0fecefdacae1f75b$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0fecefdacae1f75b$var$TimeIntervalSubscriber = function(_super) {
    $0fecefdacae1f75b$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $0fecefdacae1f75b$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=timeInterval.js.map

});

parcelRegister("cmyqT", function(module, exports) {
"use strict";
var $90023fbe608f4f3c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $zAMIg = parcelRequire("zAMIg");


var $fEWBj = parcelRequire("fEWBj");


var $fNVRJ = parcelRequire("fNVRJ");


var $a6ieS = parcelRequire("a6ieS");

/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $90023fbe608f4f3c$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    var absoluteTimeout = $fEWBj.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $90023fbe608f4f3c$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $a6ieS.TimeoutError()));
    };
}
module.exports.timeout = $90023fbe608f4f3c$var$timeout;
var $90023fbe608f4f3c$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $90023fbe608f4f3c$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $90023fbe608f4f3c$var$TimeoutSubscriber = function(_super) {
    $90023fbe608f4f3c$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($fNVRJ.Subscriber); //# sourceMappingURL=timeout.js.map

});

parcelRegister("a6ieS", function(module, exports) {
"use strict";
var $75a89ccb17a412ff$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $75a89ccb17a412ff$var$TimeoutError = function(_super) {
    $75a89ccb17a412ff$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $75a89ccb17a412ff$var$TimeoutError; //# sourceMappingURL=TimeoutError.js.map

});

parcelRegister("4Otfs", function(module, exports) {
"use strict";
var $3812850d794e9fac$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $gGP9M = parcelRequire("gGP9M");


var $371EO = parcelRequire("371EO");

/**
 * @class BehaviorSubject<T>
 */ var $3812850d794e9fac$var$BehaviorSubject = function(_super) {
    $3812850d794e9fac$var$__extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    /** @deprecated internal use only */ BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        if (this.hasError) throw this.thrownError;
        else if (this.closed) throw new $371EO.ObjectUnsubscribedError();
        else return this._value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}($gGP9M.Subject);
module.exports.BehaviorSubject = $3812850d794e9fac$var$BehaviorSubject; //# sourceMappingURL=BehaviorSubject.js.map

});

parcelRegister("1SPMi", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3d3WW = parcelRequire("3d3WW");


var $iTJtk = parcelRequire("iTJtk");


var $hcnuR = parcelRequire("hcnuR");


var $bQm3c = parcelRequire("bQm3c");


var $1P7Cq = parcelRequire("1P7Cq");


var $2SowE = parcelRequire("2SowE");


var $8ld8H = parcelRequire("8ld8H");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
    const nonProductionBuildAnalyticsAttributes = (0, $cozmU.useMemo)(()=>(0, $hcnuR.getNonProductionBuildAnalyticsAttributes)(()=>renderServerPlaceholder ? undefined : (0, $8ld8H.getConfluenceNonProductionBuild)()), [
        renderServerPlaceholder
    ]);
    const handleEvent = (0, $cozmU.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            if (nonProductionBuildAnalyticsAttributes.isNonProductionBuild !== undefined) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, nonProductionBuildAnalyticsAttributes);
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source,
        nonProductionBuildAnalyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: handleEvent,
        channel: (0, $iTJtk.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("7EIq6", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dd33Q = parcelRequire("dd33Q");


var $9Pmcg = parcelRequire("9Pmcg");


var $6SsN4 = parcelRequire("6SsN4");


var $jtuBN = parcelRequire("jtuBN");


var $idOQ2 = parcelRequire("idOQ2");

const $649b778bbd82b1bb$var$spaceEnabledContentTypesFragment = (0, $9Pmcg.default);
function $649b778bbd82b1bb$export$67a7293b6dfe9c76(spaceFragmentRef) {
    const $ = (0, $bDgLe.c)(2);
    const space = (0, $6SsN4.useFragment)($649b778bbd82b1bb$var$spaceEnabledContentTypesFragment, spaceFragmentRef);
    const t0 = space.spaceTypeSettings?.enabledContentTypes;
    let t1;
    if ($[0] !== t0) {
        t1 = $649b778bbd82b1bb$var$getEnabledContentTypes(t0, false);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
}
const $649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery = (0, $dd33Q.default);
function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $idOQ2.useDefaultSpacesForCreate)({
        skip: spaceKey !== undefined,
        variables: {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        }
    });
    const spaceEnabledContentTypesQueryOptions = {
        errorPolicy: 'all',
        skip: !spaceKey && !defaultSpaceKeyData,
        variables: {
            spaceKey: spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id
        }
    };
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)($649b778bbd82b1bb$var$useSpaceEnabledContentTypesQuery, {
        ...spaceEnabledContentTypesQueryOptions,
        __callerPackage__: "create-blank-fabric-page"
    });
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    return $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, isDefaultSpaceKeyLoading || isAnyContentTypesLoading);
}
function $649b778bbd82b1bb$var$getEnabledContentTypes(enabledContentTypes, loading) {
    const hasUndefinedContentTypes = enabledContentTypes === undefined || Object.values(enabledContentTypes).some((type)=>type === undefined);
    const isLoading = loading || hasUndefinedContentTypes;
    return {
        isCreateWhiteboardEnabled: Boolean(enabledContentTypes?.isWhiteboardsEnabled),
        isCreateBlogEnabled: Boolean(enabledContentTypes?.isBlogsEnabled),
        isCreateDatabaseEnabled: Boolean(enabledContentTypes?.isDatabasesEnabled),
        isCreateSmartLinkEnabled: Boolean(enabledContentTypes?.isEmbedsEnabled),
        isCreateLiveDocEnabled: Boolean(enabledContentTypes?.isLivePagesEnabled),
        isCreateFolderEnabled: Boolean(enabledContentTypes?.isFoldersEnabled),
        isCreateSlidesEnabled: Boolean(enabledContentTypes?.isSlidesEnabled),
        isLoading: isLoading
    };
}
module.exports["useSpaceEnabledContentTypesFragment"] = $649b778bbd82b1bb$export$67a7293b6dfe9c76;
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("9Pmcg", function(module, exports) {
/**
 * @generated SignedSource<<6a622c3ccbbe286fe0564af388855ebd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e1a2866ab6e1d474$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useSpaceEnabledContentTypes_space",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "concreteType": "SpaceTypeSettings",
            "kind": "LinkedField",
            "name": "spaceTypeSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "EnabledContentTypes",
                    "kind": "LinkedField",
                    "name": "enabledContentTypes",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isBlogsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isDatabasesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isEmbedsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isLivePagesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isSlidesEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isWhiteboardsEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isFoldersEnabled"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Space"
};
$e1a2866ab6e1d474$var$node.hash = "b4c0be9fdc8089ef19cf4d9ec776f16e";
var $e1a2866ab6e1d474$export$2e2bcd8739ae039 = $e1a2866ab6e1d474$var$node;
module.exports["default"] = $e1a2866ab6e1d474$export$2e2bcd8739ae039;

});

parcelRegister("idOQ2", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $3l9Bn = parcelRequire("3l9Bn");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $6mKj3 = parcelRequire("6mKj3");


var $9HB34 = parcelRequire("9HB34");


var $dDAsV = parcelRequire("dDAsV");


var $iLgzu = parcelRequire("iLgzu");


var $ge2sX = parcelRequire("ge2sX");


var $bQm3c = parcelRequire("bQm3c");

// Reuse the same operation and fields for the create menu, selector, and template gallery.
const $ada51a459bf40037$var$defaultSpacesForCreateQuery = (0, $3l9Bn.default);
const $ada51a459bf40037$var$missingCloudIdError = new Error('Cannot load default spaces from AGG without a Confluence cloud ID');
const $ada51a459bf40037$var$unavailableDefaultSpacesError = new Error('AGG default spaces are unavailable; check the confluence_default_spaces_graphql gate');
const $ada51a459bf40037$var$toQueryVariables = (cloudId, variables)=>({
        cloudId: cloudId,
        promotedSpaceKeys: variables?.promotedSpaceKey ? [
            variables.promotedSpaceKey
        ] : [],
        promotedSpacesLimit: variables?.promotedSpacesLimit ?? 10,
        otherSpacesLimit: variables?.otherSpacesLimit ?? 10
    });
// Relay fetchQuery writes to the store, but network-only ensures no-cache callers receive fresh data.
const $ada51a459bf40037$var$toRelayFetchPolicy = (fetchPolicy)=>fetchPolicy === undefined || fetchPolicy === 'cache-first' ? 'store-or-network' : 'network-only';
const $ada51a459bf40037$var$toLegacySpace = ({ key: key, name: name })=>({
        id: key,
        text: name
    });
const $ada51a459bf40037$var$toLegacyData = (spaces)=>({
        experimentalPromotedSpaces: {
            nodes: [
                ...spaces.promotedSpaces.spaces,
                ...spaces.otherSpaces.spaces
            ].map($ada51a459bf40037$var$toLegacySpace),
            matchedPromotedSpaces: spaces.matchedPromotedSpaces.spaces.map($ada51a459bf40037$var$toLegacySpace),
            __typename: 'ExperimentalPromotedSpaces'
        }
    });
const $ada51a459bf40037$var$useAggDefaultSpaces = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { cloudId: cloudId, skip: skip, variables: variables, onError: onError, fetchPolicy: fetchPolicy } = t0;
    const promotedSpaceKey = variables?.promotedSpaceKey;
    const promotedSpacesLimit = variables?.promotedSpacesLimit;
    const otherSpacesLimit = variables?.otherSpacesLimit;
    let t1;
    if ($[0] !== cloudId || $[1] !== otherSpacesLimit || $[2] !== promotedSpaceKey || $[3] !== promotedSpacesLimit) {
        t1 = $ada51a459bf40037$var$toQueryVariables(cloudId, {
            promotedSpaceKey: promotedSpaceKey,
            promotedSpacesLimit: promotedSpacesLimit,
            otherSpacesLimit: otherSpacesLimit
        });
        $[0] = cloudId;
        $[1] = otherSpacesLimit;
        $[2] = promotedSpaceKey;
        $[3] = promotedSpacesLimit;
        $[4] = t1;
    } else t1 = $[4];
    const queryVariables = t1;
    let t2;
    if ($[5] !== fetchPolicy) {
        t2 = $ada51a459bf40037$var$toRelayFetchPolicy(fetchPolicy);
        $[5] = fetchPolicy;
        $[6] = t2;
    } else t2 = $[6];
    const relayFetchPolicy = t2;
    const [result, setResult] = (0, $cozmU.useState)();
    let t3;
    let t4;
    if ($[7] !== onError || $[8] !== queryVariables || $[9] !== relayFetchPolicy || $[10] !== skip) {
        t3 = ()=>{
            if (skip) return;
            const subscription = (0, $6SsN4.fetchQuery)((0, $9HB34.getRelayEnvironment)(), $ada51a459bf40037$var$defaultSpacesForCreateQuery, queryVariables, {
                fetchPolicy: relayFetchPolicy
            }).subscribe({
                next: (data)=>setResult({
                        variables: queryVariables,
                        fetchPolicy: relayFetchPolicy,
                        data: data
                    }),
                error: (error)=>{
                    setResult({
                        variables: queryVariables,
                        fetchPolicy: relayFetchPolicy,
                        error: error
                    });
                    onError?.(error);
                }
            });
            return ()=>subscription.unsubscribe();
        };
        t4 = [
            onError,
            queryVariables,
            relayFetchPolicy,
            skip
        ];
        $[7] = onError;
        $[8] = queryVariables;
        $[9] = relayFetchPolicy;
        $[10] = skip;
        $[11] = t3;
        $[12] = t4;
    } else {
        t3 = $[11];
        t4 = $[12];
    }
    (0, $cozmU.useEffect)(t3, t4);
    if (skip) {
        let t5;
        if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                data: undefined,
                loading: false,
                error: undefined
            };
            $[13] = t5;
        } else t5 = $[13];
        return t5;
    }
    if (result?.variables !== queryVariables || result.fetchPolicy !== relayFetchPolicy) {
        let t5;
        if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
            t5 = {
                data: undefined,
                loading: true,
                error: undefined
            };
            $[14] = t5;
        } else t5 = $[14];
        return t5;
    }
    let t5;
    if ($[15] !== result.data || $[16] !== result.error) {
        t5 = {
            data: result.data,
            loading: false,
            error: result.error
        };
        $[15] = result.data;
        $[16] = result.error;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
};
const $ada51a459bf40037$var$useDefaultSpacesForCreateWithExperiment = (isAggEnabled, t0)=>{
    const $ = (0, $bDgLe.c)(17);
    const { skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const t1 = skip || !cloudId || !isAggEnabled;
    let t2;
    if ($[0] !== cloudId || $[1] !== fetchPolicy || $[2] !== onError || $[3] !== t1 || $[4] !== variables) {
        t2 = {
            cloudId: cloudId,
            skip: t1,
            variables: variables,
            onError: onError,
            fetchPolicy: fetchPolicy
        };
        $[0] = cloudId;
        $[1] = fetchPolicy;
        $[2] = onError;
        $[3] = t1;
        $[4] = variables;
        $[5] = t2;
    } else t2 = $[5];
    const aggResult = $ada51a459bf40037$var$useAggDefaultSpaces(t2);
    const t3 = skip || isAggEnabled;
    let t4;
    if ($[6] !== fetchPolicy || $[7] !== onError || $[8] !== t3 || $[9] !== variables) {
        t4 = {
            skip: t3,
            onError: onError,
            variables: variables,
            fetchPolicy: fetchPolicy
        };
        $[6] = fetchPolicy;
        $[7] = onError;
        $[8] = t3;
        $[9] = variables;
        $[10] = t4;
    } else t4 = $[10];
    const restResult = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t4);
    if (!isAggEnabled) return restResult;
    let t5;
    if ($[11] !== aggResult.data) {
        t5 = aggResult.data?.confluence_defaultSpaces ? $ada51a459bf40037$var$toLegacyData(aggResult.data.confluence_defaultSpaces) : undefined;
        $[11] = aggResult.data;
        $[12] = t5;
    } else t5 = $[12];
    const t6 = skip ? undefined : !cloudId ? $ada51a459bf40037$var$missingCloudIdError : aggResult.error ?? (aggResult.data?.confluence_defaultSpaces === null ? $ada51a459bf40037$var$unavailableDefaultSpacesError : undefined);
    let t7;
    if ($[13] !== aggResult.loading || $[14] !== t5 || $[15] !== t6) {
        t7 = {
            data: t5,
            loading: aggResult.loading,
            error: t6
        };
        $[13] = aggResult.loading;
        $[14] = t5;
        $[15] = t6;
        $[16] = t7;
    } else t7 = $[16];
    return t7;
};
const $ada51a459bf40037$export$be8c223b5ba023bf = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const params = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_default_spaces_graphql", "isEnabled", true);
        $[2] = t2;
    } else t2 = $[2];
    return $ada51a459bf40037$var$useDefaultSpacesForCreateWithExperiment(t2, params);
};
const $ada51a459bf40037$export$bf59898fac256899 = async ({ variables: variables, fetchPolicy: fetchPolicy } = {})=>{
    if (!(0, $6mKj3.expValEquals)('confluence_default_spaces_graphql', 'isEnabled', true)) return (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: variables,
        fetchPolicy: fetchPolicy
    });
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    if (!cloudId) throw $ada51a459bf40037$var$missingCloudIdError;
    const data = await (0, $6SsN4.fetchQuery)((0, $9HB34.getRelayEnvironment)(), $ada51a459bf40037$var$defaultSpacesForCreateQuery, $ada51a459bf40037$var$toQueryVariables(cloudId, variables), {
        fetchPolicy: fetchPolicy === 'network-only' ? 'network-only' : 'store-or-network'
    }).toPromise();
    if (!data?.confluence_defaultSpaces) throw $ada51a459bf40037$var$unavailableDefaultSpacesError;
    return {
        data: $ada51a459bf40037$var$toLegacyData(data.confluence_defaultSpaces)
    };
};
module.exports["useDefaultSpacesForCreate"] = $ada51a459bf40037$export$be8c223b5ba023bf;
module.exports["getDefaultSpacesForCreate"] = $ada51a459bf40037$export$bf59898fac256899;

});

parcelRegister("3l9Bn", function(module, exports) {
/**
 * @generated SignedSource<<65aa05400383c7a5ee3f3d8425207095>>
 * @relayHash 7d06535456c9d2141ca210b8d25ff802
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 982f9fe2ba3699920aaf981e5dd43474fb140f73d247765e842e033acbc8a0d9
const $c5ca30d5a6d63d34$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "otherSpacesLimit"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "promotedSpaceKeys"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "promotedSpacesLimit"
    }, v4 = [
        {
            "concreteType": "ConfluenceDefaultSpace",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ], v5 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "otherSpacesLimit",
                    "variableName": "otherSpacesLimit"
                },
                {
                    "kind": "Variable",
                    "name": "promotedSpaceKeys",
                    "variableName": "promotedSpaceKeys"
                },
                {
                    "kind": "Variable",
                    "name": "promotedSpacesLimit",
                    "variableName": "promotedSpacesLimit"
                }
            ],
            "concreteType": "ConfluenceDefaultSpaces",
            "kind": "LinkedField",
            "name": "confluence_defaultSpaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceDefaultSpaceResults",
                    "kind": "LinkedField",
                    "name": "matchedPromotedSpaces",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceDefaultSpaceResults",
                    "kind": "LinkedField",
                    "name": "promotedSpaces",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                },
                {
                    "concreteType": "ConfluenceDefaultSpaceResults",
                    "kind": "LinkedField",
                    "name": "otherSpaces",
                    "plural": false,
                    "selections": v4 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "defaultSpacesForCreateQuery",
            "selections": v5 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "defaultSpacesForCreateQuery",
            "selections": v5 /*: any*/ 
        },
        "params": {
            "cacheID": "7d06535456c9d2141ca210b8d25ff802",
            "id": "982f9fe2ba3699920aaf981e5dd43474fb140f73d247765e842e033acbc8a0d9",
            "metadata": {},
            "name": "defaultSpacesForCreateQuery",
            "operationKind": "query",
            "text": "query defaultSpacesForCreateQuery($cloudId:ID!,$promotedSpaceKeys:[String],$promotedSpacesLimit:Int,$otherSpacesLimit:Int){confluence_defaultSpaces(cloudId:$cloudId,promotedSpaceKeys:$promotedSpaceKeys,promotedSpacesLimit:$promotedSpacesLimit,otherSpacesLimit:$otherSpacesLimit){matchedPromotedSpaces{spaces{id,key,name}},promotedSpaces{spaces{id,key,name}},otherSpaces{spaces{id,key,name}}}}"
        }
    };
}();
$c5ca30d5a6d63d34$var$node.hash = "051a6dfeb5ad1a6654485dc46ce9bab5";
var $c5ca30d5a6d63d34$export$2e2bcd8739ae039 = $c5ca30d5a6d63d34$var$node;
module.exports["default"] = $c5ca30d5a6d63d34$export$2e2bcd8739ae039;

});

parcelRegister("dDAsV", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $jaPWl = parcelRequire("jaPWl");

const $accffb80f429232b$export$bdbe5e70ac4420b8 = async ({ variables: variables, fetchPolicy: fetchPolicy })=>{
    const promotedSpacesLimit = variables && variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables && variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables && variables.promotedSpaceKey || '';
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        variables: variables || {},
        fetchPolicy: fetchPolicy,
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        }
    });
    return {
        data: result.data
    };
};
module.exports["experimentalPromotedSpacesQuery"] = $accffb80f429232b$export$bdbe5e70ac4420b8;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("kDja4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUvcQ = parcelRequire("dUvcQ");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory',
    'digitalTeammate'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $cozmU.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'aiFirstCreation':
                return true;
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $cozmU.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dUvcQ.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("dUvcQ", function(module, exports) {

var $7FQjS = parcelRequire("7FQjS");

function $c3d67b941c4ebe95$export$470e5c2be1411c89(name) {
    return (0, $7FQjS.resolveBooleanFlag)(name);
}
module.exports["getBooleanFF"] = $c3d67b941c4ebe95$export$470e5c2be1411c89;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("bMPhU", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $7SV4J = parcelRequire("7SV4J");


var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $89u2G = parcelRequire("89u2G");


var $jMyy4 = parcelRequire("jMyy4");

const $337a96ad81fe0f87$export$a1e0cd72fc64ef6 = (spaceKey)=>{
    const $ = (0, $bDgLe.c)(8);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    spaceKey = spaceKey ?? pageContextSpaceKey;
    const sharedDetail = (0, $cozmU.useContext)((0, $89u2G.SpaceDetailContext));
    let t0;
    if ($[0] !== sharedDetail?.spaceKey || $[1] !== spaceKey) {
        t0 = Boolean(spaceKey) && sharedDetail?.spaceKey === spaceKey && (0, $6mKj3.expValEquals)("confluence_editor_content_unified_query", "isEnabled", true);
        $[0] = sharedDetail?.spaceKey;
        $[1] = spaceKey;
        $[2] = t0;
    } else t0 = $[2];
    const canUseSharedDetail = t0;
    let t1;
    if ($[3] !== spaceKey) {
        t1 = {
            spaceKey: spaceKey
        };
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    const t2 = !spaceKey || canUseSharedDetail;
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = {
            variables: t1,
            skip: t2
        };
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $7SV4J.default), {
        ...t3,
        __callerPackage__: "space-utils"
    });
    if (canUseSharedDetail) return sharedDetail?.space?.homepage?.id || undefined;
    return data?.space?.homepage?.id || undefined;
};
module.exports["useSpaceHomepageId"] = $337a96ad81fe0f87$export$a1e0cd72fc64ef6;

});

parcelRegister("7SV4J", function(module, exports) {
/**
 * @generated SignedSource<<9c89aa0352f7d1dca5a5a1271100cc40>>
 * @relayHash be53943df43514309a4d7c908c1c0fa2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5
const $6972c51ac50ce9bf$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ]
                },
                v1 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "be53943df43514309a4d7c908c1c0fa2",
            "id": "7bddba1f887c4974b84a89ddfe7491d20491eb2f970c97f0a6324caf87eee3e5",
            "metadata": {},
            "name": "useSpaceHomepageIdSpaceHomepageIdQuery",
            "operationKind": "query",
            "text": "query useSpaceHomepageIdSpaceHomepageIdQuery($spaceKey:String){space(key:$spaceKey){homepage{id},id}}"
        }
    };
}();
$6972c51ac50ce9bf$var$node.hash = "008609f21691e19f9c101d43e2e78e81";
var $6972c51ac50ce9bf$export$2e2bcd8739ae039 = $6972c51ac50ce9bf$var$node;
module.exports["default"] = $6972c51ac50ce9bf$export$2e2bcd8739ae039;

});

parcelRegister("8a9Dm", function(module, exports) {
const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("fuLIO", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $cozmU = parcelRequire("cozmU");


var $3KymM = parcelRequire("3KymM");


var $kSwu1 = parcelRequire("kSwu1");


var $4aRua = parcelRequire("4aRua");


var $gXfti = parcelRequire("gXfti");


var $7m1pr = parcelRequire("7m1pr");


var $bavCP = parcelRequire("bavCP");


var $1xpoY = parcelRequire("1xpoY");


var $eczvQ = parcelRequire("eczvQ");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $6mEZ3 = parcelRequire("6mEZ3");


var $8pcS0 = parcelRequire("8pcS0");


var $kRAnY = parcelRequire("kRAnY");


var $ld6xp = parcelRequire("ld6xp");


var $iKSlH = parcelRequire("iKSlH");


var $gHCIk = parcelRequire("gHCIk");


var $92uc5 = parcelRequire("92uc5");


var $6Cce7 = parcelRequire("6Cce7");


var $eqB7W = parcelRequire("eqB7W");


var $b1ypt = parcelRequire("b1ypt");


var $hp2SH = parcelRequire("hp2SH");


var $7W8i8 = parcelRequire("7W8i8");


var $5kjCz = parcelRequire("5kjCz");


var $jONcl = parcelRequire("jONcl");


var $bQm3c = parcelRequire("bQm3c");


var $c0rhi = parcelRequire("c0rhi");


var $7Q4pL = parcelRequire("7Q4pL");


var $aEc9Q = parcelRequire("aEc9Q");


var $euF5O = parcelRequire("euF5O");


var $4BMhZ = parcelRequire("4BMhZ");


var $b7V26 = parcelRequire("b7V26");

/**
 * Checks whether an extension node is a plain text macro or not.
 *
 * The node at this point may not indicate what it's content type is, so a
 * reliable way is to check for the `__bodyContent` property, which exists
 * on plain text macros.
 *
 * @param node Extension node to check
 */ const $b65e5cf2eec587a5$var$isPlainTextMacro = (node)=>node.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) && Boolean(node?.parameters?.macroParams?.__bodyContent);
/**
 * All bodied extensions are rich text.
 *
 * @param node Extension node to check
 */ const $b65e5cf2eec587a5$var$isRichTextMacro = (node)=>node.type === (0, $8pcS0.BODIED_EXTENSION_TYPE);
const $b65e5cf2eec587a5$var$convertADFContentToStorageQuery = async (contentId, content)=>{
    const result = await (0, $c0rhi.queryInterop)({
        query: (0, $6Cce7.ContentConverterQuery),
        variables: (0, $92uc5.getContentConverterVariables)({
            content: content,
            contentId: contentId
        }),
        __callerPackage__: "fabric-extension-legacy-macro-renderer"
    });
    return result.data?.contentConverter?.value ?? '';
};
function $b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView({ isInEditorRendererView: isInEditorRendererView, node: node, extensionKey: extensionKey }) {
    return isInEditorRendererView && (0, $kRAnY.is2PBodiedExtension)({
        extensionKey: extensionKey,
        extensionType: node.type
    });
}
function $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension({ contentId: contentId, node: node, extensionKey: extensionKey }) {
    const hasParent = !!node?.parameters?.macroParams?._parentId?.value;
    const hasSameParent = node?.parameters?.macroParams?._parentId?.value === contentId;
    return (0, $kRAnY.is2PBodiedExtension)({
        extensionKey: extensionKey,
        extensionType: node.type
    }) && hasParent && !!contentId && !hasSameParent;
}
function $b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(props) {
    const { extensionKey: extensionKey } = props;
    return Boolean(!(0, $ld6xp.canUseMultiMacroQuery)(extensionKey, $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension(props)) || $b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView(props));
}
class $b65e5cf2eec587a5$export$a7d233751dc2a8c9 extends (0, $cozmU.Component) {
    componentDidMount() {
        this.setMacroData();
        this.setUFOEventMacroDisplayStatus();
    }
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.contentId !== nextProps.contentId || !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(this.props?.node?.parameters, nextProps?.node?.parameters) || (nextProps.references || this.props.references) && this.props.references !== nextProps.references || this.state.hasBodyBeenFetched !== nextState.hasBodyBeenFetched || this.state.body !== nextState.body;
    }
    componentDidUpdate() {
        this.setMacroData();
    }
    componentWillUnmount() {
        const { node: node, mode: mode, contentId: contentId } = this.props;
        const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
        (0, $5kjCz.stopJIRAMacro)(mode, contentId, name, attributes);
    }
    /**
   * Parses the rich text macro's body and sets the state with it.
   */ async setRichTextMacroBody() {
        const { contentId: contentId, node: node } = this.props;
        // Get the ADF content of the node
        const content = node?.content || [];
        try {
            // Unfortunately, vendor add ons expect storage format. We need to convert
            // the ADF to the appropriate format.
            let body;
            // only use conversion query in two scenarios
            //   1. if not using macros query where body storage format is already provided.
            //   2. If macro is using in editor renderer view, we need to update the body for this singular macro
            //      using the multi macro query would refetch for all macros on the page, re-rendering them all.
            if ($b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(this.props)) body = await $b65e5cf2eec587a5$var$convertADFContentToStorageQuery(contentId, content);
            this.setState({
                body: body,
                hasBodyBeenFetched: true
            });
        } catch (error) {
            this.logger.error`${error}`; //tslint:disable-line
        }
    }
    /**
   * Parses the plain text macro's body and sets the state with it.
   *
   * Even though it's plain text, we don't actually need to set state. This
   * could be done in the renderer, but because we're converting rich text
   * macro's body to storage format, the mechanism for passing in the body is
   * `this.setState`. This will change in the future if we start passing
   * adf in our `getMacroBody` calls (and then this can be cleaned up).
   */ setPlainTextMacroBody() {
        const { node: node } = this.props;
        const body = node?.parameters?.macroParams?.__bodyContent?.value || '';
        this.setState({
            body: body,
            hasBodyBeenFetched: true
        });
    }
    setMacroData() {
        const { node: node } = this.props;
        // 1. Node is null, which means we won't render anything.
        // 2. If macro is using in editor renderer view, we need to refetch the body on update
        //    because the parameters might have changed due to user interaction in the macros edit mode.
        if (!node || $b65e5cf2eec587a5$var$isRichTextMacro(node) && this.state.hasBodyBeenFetched && !$b65e5cf2eec587a5$var$isMacroUsingInEditorRendererView(this.props)) return;
        if ($b65e5cf2eec587a5$var$isPlainTextMacro(node)) this.setPlainTextMacroBody();
        else if ($b65e5cf2eec587a5$var$isRichTextMacro(node)) this.setRichTextMacroBody();
        else // It's neither, so just render the component
        this.setState({
            hasBodyBeenFetched: true
        });
    }
    setUFOEventMacroDisplayStatus() {
        const extensionKey = this.props.extensionKey;
        if (!extensionKey) return;
        const parts = extensionKey.split('-');
        const pascalCaseString = parts.map((part)=>{
            if (part.length === 0) return '';
            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        }).join('');
        (0, $gXfti.addUFOCustomData)({
            [`is${pascalCaseString}MacroDisplayed`]: true
        });
    }
    // Use parent id if the macro source is different than the current page.
    // Critical for having the include-page macro load properly
    getContentId(adf, contentId) {
        const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
        return parentId || contentId;
    }
    render() {
        const mode = window.location.pathname.startsWith('/wiki/pdf/') ? 'pdf' : this.props.mode;
        const { hasBodyBeenFetched: hasBodyBeenFetched } = this.state;
        const node = this.props.node;
        if (!node) return null;
        if (!hasBodyBeenFetched) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
            node: node,
            isRenderer: mode === (0, $5kjCz.RENDERER)
        });
        const adf = (0, $6mEZ3.extensionToADF)(node);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $euF5O.LegacyMacroRendererContext).Consumer, null, ({ shouldRefetchMacroQuery: shouldRefetchMacroQuery })=>// In edit mode the editor renders this component outside of the main app, therefore
            // the Apollo client has to be provided here too
            // only use the multi macro query if this macro is not inside another, such as a page include
            // since that means it will not have been fetched by the multi macro query
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3KymM.ApolloProvider), {
                client: (0, $hp2SH.getApolloClient)()
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
                value: (0, $fGzMp.getExperienceTracker)()
            }, this.determineQuery({
                ...this.props,
                mode: mode,
                adf: adf,
                shouldRefetchMacroQuery: shouldRefetchMacroQuery
            }))));
    }
    constructor(_props){
        super(_props);
        this.logger = (0, $7W8i8.getLogger)('LegacyMacroRendererQuery');
        /**
     * Return a query for both contentRenderer and macroBodyRenderer.
     */ this.getQueryForMacroContentAndBodyForPossibleFrontendRendering = ({ adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, shouldRefetchMacroQuery: shouldRefetchMacroQuery, noOverlay: noOverlay, isPreviewMode: isPreviewMode })=>{
            const renderPageIncludeError = (pageTitle)=>{
                return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                    className: "error"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $7Q4pL.i18n).highlightedPageIncludeRenderedError)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $7Q4pL.i18n).nonhighlightedPageIncludeRenderedError,
                    values: {
                        pageTitle: pageTitle
                    }
                })));
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $eqB7W.default),
                variables: {
                    adf: (0, $gHCIk.serializeExtensionADF)(adf),
                    // The template editor passes a "0" as contentId by default,
                    // in this scenario we do NOT want to pass a contentId at all into the query.
                    // Not passing the correct contentId can make some macros fail to load
                    ...contentId !== '0' ? {
                        contentId: this.getContentId(adf, contentId)
                    } : {},
                    mode: mode && mode.toUpperCase()
                },
                // Used when multiple instances of PageContentRenderer cause conflicting IDs in macroRenderedOutput. This forces
                // a refetch when rendering subsequent PageContentRenderer instances so that a new ID is present in
                // macroRenderedOutput. 'cache-first' is Apollo's default fetchPolicy.
                fetchPolicy: shouldRefetchMacroQuery ? 'no-cache' : 'cache-first',
                // Some macros take a long time to render, they should not hold up the rendering of other things
                context: {
                    throttle: true,
                    allowOnExternalPage: true
                },
                skip: Boolean(macroRenderedOutputFromSSR) || Boolean(macroOutput),
                __callerPackage__: "fabric-extension-legacy-macro-renderer"
            }, ({ data: data, loading: loading, error: error })=>{
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRenderedOutput: data?.macroBodyRenderer?.value,
                    macroRepresentation: data?.macroBodyRenderer?.representation || 'view',
                    mediaToken: data?.macroBodyRenderer?.mediaToken?.token,
                    node: node,
                    webresource: data?.macroBodyRenderer?.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode,
                    isConnectMacro: this.props.isConnectMacro
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    showSpinner: !!data,
                    node: node,
                    isRenderer: mode === (0, $5kjCz.RENDERER)
                });
                if (error || !data || !data.macroBodyRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BMhZ.LegacyMacroRendererError), {
                    error: error,
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // Make it possible to execute AC JS functions locally.
                // The hostOrigin should match browser host
                let macroRenderedOutput = data.macroBodyRenderer?.value;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7V26.PageIncludeContext).Consumer, null, ({ listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes })=>{
                    const { isCircularRef: isCircularRef, prevPageTitle: prevPageTitle } = $b65e5cf2eec587a5$export$ddad0aee336d9e1(listOfRenderedPageIncludeNodes);
                    if (isCircularRef) return renderPageIncludeError(prevPageTitle);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b65e5cf2eec587a5$var$PageIncludeContextProvider, {
                        contentId: contentId,
                        node: this.props.node,
                        listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                        contentId: contentId,
                        experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                        adf: adf,
                        attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                        references: references,
                        multiBodiedExtensionActions: multiBodiedExtensionActions,
                        macroRenderedOutput: macroRenderedOutput,
                        macroRepresentation: data.macroBodyRenderer?.representation || 'view',
                        mediaToken: data?.macroBodyRenderer?.mediaToken?.token,
                        node: node,
                        webresource: data.macroBodyRenderer?.webResourceDependencies,
                        mode: mode,
                        body: this.state.body,
                        parameters: (0, $6mEZ3.getParametersString)(node),
                        featureFlags: featureFlags,
                        spaceKey: spaceKey,
                        noOverlay: noOverlay,
                        isPreviewMode: isPreviewMode,
                        isConnectMacro: this.props.isConnectMacro
                    }));
                });
            });
        };
        this.getQueryForMacroContentFromBackend = ({ adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, shouldRefetchMacroQuery: shouldRefetchMacroQuery, noOverlay: noOverlay, isPreviewMode: isPreviewMode })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bavCP.QueryInterop), {
                query: (0, $b1ypt.default),
                variables: {
                    adf: (0, $gHCIk.serializeExtensionADF)(adf),
                    contentId: contentId,
                    mode: mode && mode.toUpperCase()
                },
                // Used when multiple instances of PageContentRenderer cause conflicting IDs in macroRenderedOutput. This forces
                // a refetch when rendering subsequent PageContentRenderer instances so that a new ID is present in
                // macroRenderedOutput. 'cache-first' is Apollo's default fetchPolicy.
                fetchPolicy: shouldRefetchMacroQuery ? 'no-cache' : 'cache-first',
                // Some macros take a long time to render, they should not hold up the rendering of other things
                context: {
                    throttle: true,
                    allowOnExternalPage: true
                },
                skip: Boolean(macroRenderedOutputFromSSR) || Boolean(macroOutput),
                __callerPackage__: "fabric-extension-legacy-macro-renderer"
            }, ({ data: data, loading: loading, error: error })=>{
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: data?.contentRenderer?.html,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: "view",
                    webresource: data?.contentRenderer?.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode,
                    isConnectMacro: this.props.isConnectMacro
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    showSpinner: !!data,
                    node: node,
                    isRenderer: mode === (0, $5kjCz.RENDERER)
                });
                if (error || !data || !data.contentRenderer) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BMhZ.LegacyMacroRendererError), {
                    error: error,
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // Make it possible to execute AC JS functions locally.
                // The hostOrigin should match browser host
                let contentRenderedHtml = data.contentRenderer.html;
                // assume we have data here
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: contentRenderedHtml,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: "view",
                    webresource: data.contentRenderer.webResourceDependencies,
                    mode: mode,
                    body: this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    noOverlay: noOverlay,
                    isPreviewMode: isPreviewMode,
                    isConnectMacro: this.props.isConnectMacro
                });
            });
        };
        this.getQueryForMacros = (args)=>{
            const { adf: adf, contentId: contentId, extensionKey: extensionKey, mode: mode, node: node, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, featureFlags: featureFlags, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, noOverlay: noOverlay, isConnectMacro: isConnectMacro } = args;
            const macroId = node.parameters?.macroMetadata?.macroId?.value;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iKSlH.MultiMacroQuerySubscriber), {
                contentId: contentId,
                macroId: macroId
            }, ({ renderedMacro: renderedMacro, loading: loading, error: error, complete: complete })=>{
                // if the multi macro query is complete and there were no errors
                // that means we are inserting a new macro in the editor or have
                // just published the page in which case the new macro data
                // will not be available on the backend to render yet so use
                // the old queries to render instead
                if (complete && !renderedMacro && !error) return this.determineQuery(args, true);
                // render LegacyMacroRendererComponent without query data if macro has been
                // SSR'd and macro output already exists or when macroOutput
                // exists which contains the entire html string needed to render the macro
                if (macroRenderedOutputFromSSR || macroOutput) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: renderedMacro?.value,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: renderedMacro?.macroRenderedRepresentation || 'view',
                    webresource: renderedMacro?.webResource,
                    mode: mode,
                    body: renderedMacro?.macroBodyStorage || this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    macroRenderedOutputFromSSR: macroRenderedOutputFromSSR,
                    macroOutput: macroOutput,
                    spaceKey: spaceKey,
                    noOverlay: noOverlay,
                    mediaToken: renderedMacro?.mediaToken?.token,
                    appKey: renderedMacro?.appKey,
                    isConnectMacro: isConnectMacro,
                    macroBodyStorage: renderedMacro?.macroBodyStorage ?? null
                });
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eczvQ.LegacyMacroRendererShadow), {
                    node: node,
                    isRenderer: mode === (0, $5kjCz.RENDERER)
                });
                if (error || !renderedMacro) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BMhZ.LegacyMacroRendererError), {
                    error: new (0, $7m1pr.RelayError)({
                        errorMessage: `error rendering legacy macro: {$extensionKey}`
                    }),
                    node: node,
                    mode: mode,
                    extensionKey: extensionKey,
                    contentId: contentId
                });
                // Make it possible to execute AC JS functions locally.
                // The hostOrigin should match browser host
                const macroRenderedOutput = renderedMacro?.value;
                // assume we have data here
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aEc9Q.LegacyMacroRendererComponent), {
                    contentId: contentId,
                    experienceName: (0, $5kjCz.getExperienceName)(mode, node),
                    adf: adf,
                    node: node,
                    attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(node),
                    macroRenderedOutput: macroRenderedOutput,
                    references: references,
                    multiBodiedExtensionActions: multiBodiedExtensionActions,
                    macroRepresentation: renderedMacro?.macroRenderedRepresentation || 'view',
                    webresource: renderedMacro?.webResource,
                    mode: mode,
                    body: renderedMacro?.macroBodyStorage || this.state.body,
                    parameters: (0, $6mEZ3.getParametersString)(node),
                    featureFlags: featureFlags,
                    noOverlay: noOverlay,
                    mediaToken: renderedMacro?.mediaToken?.token,
                    appKey: renderedMacro?.appKey,
                    isConnectMacro: isConnectMacro,
                    macroBodyStorage: renderedMacro?.macroBodyStorage ?? null
                });
            });
        };
        this.getReferencedContentId = (node)=>{
            return node?.parameters?.macroParams?._referencedContentId?.value || undefined;
        };
        this.determineQuery = (props, doNotUseMultiMacro = false)=>{
            const { extensionKey: extensionKey, node: node } = props;
            if (!doNotUseMultiMacro && (!node?.parameters?.macroParams?._parentId || node.parameters.macroParams._parentId.value === this.props.contentId) && (0, $ld6xp.canUseMultiMacroQuery)(extensionKey, $b65e5cf2eec587a5$var$isIncludePageNested2pBodiedExtension(props))) return this.getQueryForMacros(props);
            const editorMacroADFRendering = (0, $1xpoY.default).getBoolean('confluence_frontend_macro_adf_frontend_render', true);
            return editorMacroADFRendering ? this.getQueryForMacroContentAndBodyForPossibleFrontendRendering(props) : this.getQueryForMacroContentFromBackend(props);
        };
        const state = {
            body: '',
            hasBodyBeenFetched: false
        };
        // Check condition upfront to avoid unnecessary state updates
        // Otherwise it will make component to always render the shadow which breaks SSR result
        // Basically repeat of setMacroData logic for the initial render
        const { node: _node } = _props;
        if ($b65e5cf2eec587a5$var$isPlainTextMacro(_node)) {
            state.body = _node?.parameters?.macroParams?.__bodyContent?.value || '';
            state.hasBodyBeenFetched = true;
        } else if ($b65e5cf2eec587a5$var$isRichTextMacro(_node)) {
            if (!$b65e5cf2eec587a5$var$shouldConvertBodyToStorageFormat(_props)) state.hasBodyBeenFetched = true;
        } else state.hasBodyBeenFetched = true;
        this.state = state;
    }
}
const $b65e5cf2eec587a5$export$ddad0aee336d9e1 = (listOfRenderedPageIncludeNodes)=>{
    if (listOfRenderedPageIncludeNodes?.length) {
        // Keep reference so that we can render the previous page title in error message
        let prevRenderedNode;
        const pageIncludeNodeIds = new Set();
        let pageIncludeNodeAlreadyRendered = false;
        for (const pageIncludeNode of listOfRenderedPageIncludeNodes){
            if (pageIncludeNode?.extensionKey !== 'include') continue;
            prevRenderedNode = pageIncludeNode;
            const id = pageIncludeNode?.parameters?.macroMetadata?.macroId?.value;
            if (id) {
                if (pageIncludeNodeIds.has(id)) {
                    pageIncludeNodeAlreadyRendered = true;
                    break;
                } else pageIncludeNodeIds.add(id);
            }
        }
        // indicate that this page has already been included, to avoid infinite loop
        if (pageIncludeNodeAlreadyRendered) {
            const prevReferencedNodePageTitle = prevRenderedNode?.parameters?.macroParams?.['']?.value;
            return {
                isCircularRef: true,
                prevPageTitle: prevReferencedNodePageTitle
            };
        }
    }
    return {
        isCircularRef: false,
        prevPageTitle: null
    };
};
const $b65e5cf2eec587a5$var$PageIncludeContextProvider = ({ contentId: contentId, node: node, listOfRenderedPageIncludeNodes: listOfRenderedPageIncludeNodes, children: children })=>{
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const renderedPageIncludeNodes = [
            ...listOfRenderedPageIncludeNodes,
            {
                ...node,
                parentContentId: contentId
            }
        ];
        return {
            listOfRenderedPageIncludeNodes: renderedPageIncludeNodes
        };
    }, [
        listOfRenderedPageIncludeNodes,
        node,
        contentId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b7V26.PageIncludeContext).Provider, {
        value: contextValue
    }, children);
};
const $b65e5cf2eec587a5$export$1609bcb5ce6c9dd9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((props)=>{
    const { featureFlags: featureFlags } = (0, $bQm3c.useSessionData)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b65e5cf2eec587a5$export$a7d233751dc2a8c9, {
        featureFlags: featureFlags,
        ...props
    });
}, (prevProps, nextProps)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(prevProps, nextProps));
const $b65e5cf2eec587a5$export$c0b18e27c7eefe80 = (0, $jONcl.debounceRender)($b65e5cf2eec587a5$export$1609bcb5ce6c9dd9, 10000);
module.exports["LegacyMacroRendererQuery"] = $b65e5cf2eec587a5$export$1609bcb5ce6c9dd9;
module.exports["DebouncedLegacyMacroRendererQuery"] = $b65e5cf2eec587a5$export$c0b18e27c7eefe80;

});

parcelRegister("kRAnY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1tdlM = parcelRequire("1tdlM");


var $6mKj3 = parcelRequire("6mKj3");


var $j0gZR = parcelRequire("j0gZR");


var $daIZK = parcelRequire("daIZK");

const $ecf08ec6a3fe0bb1$export$3edb28f707c97620 = ({ extensionKey: extensionKey, extensionType: extensionType })=>(0, $j0gZR.is1PMacro)(extensionKey || '') && extensionType === 'bodiedExtension';
const $ecf08ec6a3fe0bb1$export$99128e639bf2cee5 = ({ extensionKey: extensionKey, extensionType: extensionType })=>!(0, $j0gZR.is1PMacro)(extensionKey || '') && extensionType === 'bodiedExtension';
const $ecf08ec6a3fe0bb1$export$8166325a9a095a58 = ({ getExtensionHandlers: getExtensionHandlers, isLivePage: isLivePage, contentId: contentId, spaceKey: spaceKey, getHeadingLinkPath: getHeadingLinkPath, extensionProviders: extensionProviders })=>{
    const combinedExtensionProvider = (0, $cozmU.useMemo)(()=>isLivePage && extensionProviders?.length ? (0, $1tdlM.default)(extensionProviders) : undefined, [
        isLivePage,
        extensionProviders
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (isLivePage) {
            const rendererExtensionHandlers = getExtensionHandlers?.({
                contentId: contentId,
                spaceKey: spaceKey,
                isInEditorRendererView: true,
                getHeadingLinkPath: getHeadingLinkPath
            });
            return {
                rendererExtensionHandlers: (0, $6mKj3.expValEquals)('confluence_live_page_migrated_bodied_macro_h11n', 'isEnabled', true) ? (0, $daIZK.withMigratedMacroRendererView)(rendererExtensionHandlers, combinedExtensionProvider) : rendererExtensionHandlers,
                isAllowedToUseRendererView: (node)=>{
                    return $ecf08ec6a3fe0bb1$export$99128e639bf2cee5({
                        extensionKey: node.attrs?.extensionKey,
                        extensionType: node.type
                    });
                },
                showUpdated1PBodiedExtensionUI: (node)=>$ecf08ec6a3fe0bb1$export$3edb28f707c97620({
                        extensionKey: node.attrs?.extensionKey,
                        extensionType: node.type
                    })
            };
        }
        return undefined;
    }, [
        getExtensionHandlers,
        isLivePage,
        contentId,
        spaceKey,
        getHeadingLinkPath,
        combinedExtensionProvider
    ]);
};
module.exports["is2PBodiedExtension"] = $ecf08ec6a3fe0bb1$export$99128e639bf2cee5;
module.exports["useExtensionRendererViewOptions"] = $ecf08ec6a3fe0bb1$export$8166325a9a095a58;

});

parcelRegister("j0gZR", function(module, exports) {
const $fa4d787503d7b919$export$1bf1a639d38d3f44 = (macro)=>$fa4d787503d7b919$export$4b1d56e1a5f9d339.has(macro);
const $fa4d787503d7b919$export$4b1d56e1a5f9d339 = new Set([
    'toc',
    'children',
    'livesearch',
    'recently-updated',
    'details',
    'jlol',
    'jira',
    'pagetree',
    'anchor',
    'contentbylabel',
    'create-from-template',
    'roadmap',
    'blog-posts',
    'excerpt',
    'attachments',
    'profile',
    'include',
    'content-report-table',
    'detailssummary',
    'tasks-report-macro',
    'excerpt-include',
    'iframe',
    'listlabels',
    'profile-picture',
    'change-history',
    'pagetreesearch',
    'widget',
    'decisionreport',
    'viewpdf',
    'contributors',
    'gadget',
    'popular-labels',
    'jirachart',
    'toc-zone',
    'portfolioforjiraplan',
    'viewppt',
    'viewxls',
    'recently-updated-dashboard',
    'spaces',
    'index',
    'contributors-summary',
    'userlister',
    'gallery',
    'viewdoc',
    'chart',
    'related-labels',
    'jiraroadmap'
]);
module.exports["is1PMacro"] = $fa4d787503d7b919$export$1bf1a639d38d3f44;

});

parcelRegister("daIZK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cd8tA = parcelRequire("cd8tA");


var $apAmb = parcelRequire("apAmb");


var $8pcS0 = parcelRequire("8pcS0");

// Forge extension type (EXTENSION_NAMESPACE in @atlaskit/xen-editor-provider). Kept local because
// EXTENSION_TYPE is coupled to content-renderer's SSR handler.
const $bc426a3d8d60138f$var$FORGE_EXTENSION_TYPE = 'com.atlassian.ecosystem';
const $bc426a3d8d60138f$export$f940e3ef18bb79e5 = (node, manifest)=>{
    if (node.extensionType !== (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE || manifest?.type !== $bc426a3d8d60138f$var$FORGE_EXTENSION_TYPE) return false;
    const { extensionKey: extensionKey } = node;
    const hasMigrationKey = Boolean(manifest.migrationKey);
    return hasMigrationKey && manifest.connectModuleKey === extensionKey || hasMigrationKey && manifest.dynamicConnectModuleKey === extensionKey || Boolean(manifest.migratedFrom?.includes(extensionKey)) || manifest.key === extensionKey;
};
const $bc426a3d8d60138f$var$MigrationAwareRendererViewMacro = ({ node: node, doc: doc, extensionProvider: extensionProvider, renderRendererView: renderRendererView })=>{
    const { extensionType: extensionType, extensionKey: extensionKey } = node;
    const [status, setStatus] = (0, $cozmU.useState)('pending');
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        setStatus('pending');
        Promise.resolve().then(()=>extensionProvider.getExtension(extensionType, extensionKey)).then((manifest)=>{
            if (!cancelled) setStatus($bc426a3d8d60138f$export$f940e3ef18bb79e5({
                extensionType: extensionType,
                extensionKey: extensionKey
            }, manifest) ? 'migrated' : 'not-migrated');
        }, ()=>{
            if (!cancelled) setStatus('not-migrated');
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        extensionProvider,
        extensionType,
        extensionKey
    ]);
    const ProviderNodeRenderer = (0, $cozmU.useMemo)(()=>status === 'migrated' ? (0, $cd8tA.getNodeRenderer)(extensionProvider, extensionType, extensionKey) : undefined, [
        status,
        extensionProvider,
        extensionType,
        extensionKey
    ]);
    if (status === 'pending') // Avoid rendering the legacy Connect macro first and then swapping it for the Forge one
    return null;
    if (ProviderNodeRenderer) // Same path ExtensionComponent takes for non renderer-view extensions: the provider does the
    // Connect -> Forge (h11n) swap, matching the view page and the classic editor.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ProviderNodeRenderer, {
        node: node,
        showUnknownMacroPlaceholder: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderRendererView(node, doc));
};
const $bc426a3d8d60138f$export$84325884fa84be50 = (rendererExtensionHandlers, extensionProvider)=>{
    const macroCoreHandler = rendererExtensionHandlers?.[(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE];
    if (!rendererExtensionHandlers || !macroCoreHandler || !extensionProvider) return rendererExtensionHandlers;
    const renderRendererView = (0, $apAmb.getExtensionRenderer)(macroCoreHandler);
    const migrationAwareMacroCoreHandler = (node, doc)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc426a3d8d60138f$var$MigrationAwareRendererViewMacro, {
            key: `${node.extensionType}:${node.extensionKey}:${node.localId ?? ''}`,
            node: node,
            doc: doc,
            extensionProvider: extensionProvider,
            renderRendererView: renderRendererView
        });
    return {
        ...rendererExtensionHandlers,
        [(0, $8pcS0.EXTENSION_TYPE).MACRO_CORE]: migrationAwareMacroCoreHandler
    };
};
module.exports["withMigratedMacroRendererView"] = $bc426a3d8d60138f$export$84325884fa84be50;

});

parcelRegister("jONcl", function(module, exports) {
// Code taken from https://github.com/podefr/react-debounce-render/tree/master aka react-debounce-render package
// In order to prevent a new package from being added to the AFM project, the code was copied and pasted here since it is lightweight.

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");


var $aH9xZ = parcelRequire("aH9xZ");

const $3dbf040db5bfac2c$export$437fb41b7a687949 = (ComponentToDebounce, wait, debounceArgs)=>{
    class DebouncedContainer extends (0, $cozmU.Component) {
        shouldComponentUpdate() {
            this.updateDebounced();
            return false;
        }
        componentWillUnmount() {
            this.updateDebounced.cancel();
        }
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ComponentToDebounce, this.props);
        }
        constructor(...args){
            super(...args);
            /* oxlint-disable-next-line react-js/sort-comp */ // eslint-disable-next-line react/sort-comp
            this.updateDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(this.forceUpdate, wait, debounceArgs);
        }
    }
    DebouncedContainer.displayName = `debounceRender(${ComponentToDebounce.displayName || ComponentToDebounce.name || 'Component'})`;
    return (0, (/*@__PURE__*/$parcel$interopDefault($aH9xZ)))(DebouncedContainer, ComponentToDebounce);
};
module.exports["debounceRender"] = $3dbf040db5bfac2c$export$437fb41b7a687949;

});

parcelRegister("7Q4pL", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $71fb7e5ab8464496$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    highlightedPageIncludeRenderedError: {
        id: "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.highlightedPageIncludeError",
        defaultMessage: "Unable to render { include }"
    },
    nonhighlightedPageIncludeRenderedError: {
        id: "fabric-extension-legacy-macro-renderer.legacy-macro-renderer-query.nonhighlightedPageIncludeRenderedError",
        defaultMessage: " Already included page \u201C{pageTitle}\u201D, stopping."
    }
});
module.exports["i18n"] = $71fb7e5ab8464496$export$a7357cdd1f0b0168;

});

parcelRegister("aEc9Q", function(module, exports) {
/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 
var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $b8pma = parcelRequire("b8pma");


var $ah4BL = parcelRequire("ah4BL");


var $dPlMJ = parcelRequire("dPlMJ");


var $jAI8J = parcelRequire("jAI8J");


var $itU2t = parcelRequire("itU2t");


var $1eD4P = parcelRequire("1eD4P");


var $1xpoY = parcelRequire("1xpoY");


var $9wGTI = parcelRequire("9wGTI");


var $lW5tg = parcelRequire("lW5tg");


var $6mKj3 = parcelRequire("6mKj3");


var $jNKuq = parcelRequire("jNKuq");


var $3DNeP = parcelRequire("3DNeP");


var $bQm3c = parcelRequire("bQm3c");


var $8Lx5S = parcelRequire("8Lx5S");


var $cpjd2 = parcelRequire("cpjd2");


var $brpfO = parcelRequire("brpfO");


var $hEeUR = parcelRequire("hEeUR");


var $989nU = parcelRequire("989nU");


var $hBmKH = parcelRequire("hBmKH");


var $KcDWk = parcelRequire("KcDWk");


var $bYtfC = parcelRequire("bYtfC");


var $4EZgW = parcelRequire("4EZgW");


var $iaRmR = parcelRequire("iaRmR");


var $8wppk = parcelRequire("8wppk");


var $6AplS = parcelRequire("6AplS");


var $hMRhJ = parcelRequire("hMRhJ");


var $5LTS4 = parcelRequire("5LTS4");


var $hHZWk = parcelRequire("hHZWk");


var $7W8i8 = parcelRequire("7W8i8");


var $5kjCz = parcelRequire("5kjCz");


var $bX5uj = parcelRequire("bX5uj");


var $8eAX8 = parcelRequire("8eAX8");


var $fgbpl = parcelRequire("fgbpl");


var $8pcS0 = parcelRequire("8pcS0");


var $3Btfb = parcelRequire("3Btfb");


var $giS6h = parcelRequire("giS6h");


var $8cOoD = parcelRequire("8cOoD");


var $iQhLj = parcelRequire("iQhLj");


var $jShOo = parcelRequire("jShOo");


var $7lgkH = parcelRequire("7lgkH");


var $gnzsm = parcelRequire("gnzsm");


var $5Gfuv = parcelRequire("5Gfuv");


var $l4pUK = parcelRequire("l4pUK");


var $9L50P = parcelRequire("9L50P");


var $4BMhZ = parcelRequire("4BMhZ");


var $aQw7y = parcelRequire("aQw7y");


var $brT00 = parcelRequire("brT00");


var $78b5K = parcelRequire("78b5K");


var $4OwbJ = parcelRequire("4OwbJ");


var $goE1t = parcelRequire("goE1t");

// The rendered HTML currently outputs a div that contains a macro id attribute
// `data-macro-id="XYZ"`. We can parse that and get the ID
const $34a09ee48ab537fd$var$idFromStorageFormat = /data-macro-id="([0-9a-fA-F-]+?)"/;
// this will be fallback pattern in case div does not contain the macro id attribute.
// Parse in from data variable in the script tag.Pattern looks like `\\\"macro.id\\\":\\\"XYZ\\\"`
const $34a09ee48ab537fd$var$idFromADF = /macro\.id\\":\\"([0-9a-fA-F-]+?)\\"/;
const $34a09ee48ab537fd$var$originFromOutput = /"origin"\s*:\s*"(https?:\/\/[^"]+)"/;
const $34a09ee48ab537fd$var$logger = (0, $7W8i8.getLogger)('LegacyMacroRenderer');
const $34a09ee48ab537fd$var$Overlay = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "legacy-macro-overlay",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            top: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            bottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            left: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            right: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            cursor: 'default',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            zIndex: 2
        }
    });
/**
 * CEMS-919 and HOT-84603
 * ---------
 * Current implementation of the Team Calendars Plugin does not account for
 * a SPA transition. It only loads the calendars once and forgets about
 * re-initializing them once the page is unmounted. For this, we need to
 * invoke the assets when necessary and initialize the calendars. Also reference:
 * confluence-frontend-server/src/components/ContentBody/ContentBodyDefaultComponent.js
 * @private
 */ const $34a09ee48ab537fd$var$initializeCalendarIfNeeded = async (extensionKey, isBodied, macroRenderedOutput)=>{
    const isCalendarMacro = extensionKey === 'calendar' || isBodied && macroRenderedOutput?.includes('data-macro-name="calendar"');
    if (!isCalendarMacro || (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)) return;
    (0, $cpjd2.requireLegacyWRM)((0, $8eAX8.teamCalendarWRM)(), ()=>{
        try {
            window.require('tc/init-resources').requireResources();
        } catch (err) {
            $34a09ee48ab537fd$var$logger.error(err);
        }
    }, ()=>{
        $34a09ee48ab537fd$var$logger.error`Error loading team calendar WRM!`;
    });
};
const $34a09ee48ab537fd$var$getMacroId = (adf, macroRenderedOutput)=>{
    const idFromNode = adf?.attrs?.parameters?.macroMetadata?.macroId?.value || adf?.attrs?.localId;
    if (idFromNode) return idFromNode;
    let matches = $34a09ee48ab537fd$var$idFromStorageFormat.exec(macroRenderedOutput || '');
    if (matches?.[1]) return matches[1];
    matches = $34a09ee48ab537fd$var$idFromADF.exec(macroRenderedOutput || '');
    if (matches?.[1]) return matches[1];
    $34a09ee48ab537fd$var$logger.error`Cannot find macro id from ${macroRenderedOutput}`;
    return '';
};
const $34a09ee48ab537fd$export$f72fde323a57bd3e = (macroRenderedOutput)=>{
    const matches = $34a09ee48ab537fd$var$originFromOutput.exec(macroRenderedOutput || '');
    return matches?.[1] || '';
};
const $34a09ee48ab537fd$var$getConnectAddonKeyFromMacroOutput = (macroRenderedOutput)=>typeof macroRenderedOutput === 'string' ? macroRenderedOutput.match(/"addon_key"\s*:\s*"([^"]+)"/)?.[1] ?? macroRenderedOutput.match(/addon_key\\":\\"([^"]+)\\"/)?.[1] : undefined;
const $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM = [
    'include',
    'contentbylabel',
    'children',
    'content-report-table',
    'index',
    'pagetree',
    'tasks-report-macro',
    'recently-updated-dashboard',
    'recently-updated',
    'toc'
];
const $34a09ee48ab537fd$var$UFO3PSegmentWrapper = ({ children: children, extensionKey: extensionKey })=>{
    const isFirstPartyExtension = (0, $cozmU.useMemo)(()=>{
        const trimmedExtensions = new Set((0, $1xpoY.default).getString('confluence_1p_extensions', '').split(',').map((item)=>item.trim()));
        return trimmedExtensions.has(extensionKey);
    }, [
        extensionKey
    ]);
    if (isFirstPartyExtension) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
        name: `extension-${extensionKey}`
    }, children);
};
const $34a09ee48ab537fd$export$a5c44bbb70ae7ae6 = (0, $3Btfb.withNavigationPolicy)(({ adf: adf, macroRepresentation: macroRepresentation, macroRenderedOutput: macroRenderedOutput, mode: mode, node: node, contentId: contentId, attributes: attributes, experienceName: experienceName, featureFlags: featureFlags, webresource: webresource, body: body, parameters: parameters, navigationPolicy: navigationPolicy, references: references, multiBodiedExtensionActions: multiBodiedExtensionActions, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR, macroOutput: macroOutput, spaceKey: spaceKey, providers: providers, mediaToken: mediaToken, noOverlay: noOverlay, isWithinEditor: isWithinEditor, isPreviewMode: isPreviewMode, appKey: appKey, isConnectMacro: isConnectMacro, macroBodyStorage: macroBodyStorage, getHeadingLinkPath: getHeadingLinkPath })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isInline = adf.type === (0, $8pcS0.INLINE_EXTENSION_TYPE);
    const isMultiBodied = adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE);
    const extensionKey = adf?.attrs?.extensionKey || '';
    const scriptContainer = (0, $cozmU.useRef)(null);
    if (!macroRenderedOutput) macroRenderedOutput = '';
    if (extensionKey && macroRenderedOutput) {
        // If a Tiny page with Style Macro gets converted to Fabric, need to Scope the CSS
        // When in edit mode, the <style> tag don't have data-macro-name="style" attribute, so need to pass a different regex
        if (extensionKey === 'style') macroRenderedOutput = (0, $6AplS.scopeCSS)(macroRenderedOutput, (0, $6AplS.mainContentSelector), /(<style[^>]*>)((.|\n|\r)*?)(<\/style>)/gm).contentWithScopedCSS;
        else // Other extensionKeys could have nested Style Macro
        macroRenderedOutput = (0, $6AplS.scopeCSS)(macroRenderedOutput, (0, $6AplS.mainContentSelector)).contentWithScopedCSS;
    }
    const { getPresetMinHeight: getPresetMinHeight, getPresetHeight: getPresetHeight } = (0, $4EZgW.useMacroHeightPreset)(mode === (0, $5kjCz.RENDERER));
    const { viewportHeight: viewportHeight } = (0, $bYtfC.useConnectExtensionViewportSize)(node);
    const isNestedLcmHierarchy = (0, $cozmU.useContext)((0, $hBmKH.NestedLcmHierarchyContext));
    const shouldHideOverlay = (0, $aQw7y.useShouldHideOverlay)(extensionKey, (0, $fgbpl.isBodiedExtension)(adf.type));
    /**
   * Callback to be triggered when web resources are resolved.
   * This is to make sure certain macros e.g. Gadget Macro only to render output after web resources loaded.
   * For more context of the issue: https://hello.atlassian.net/wiki/spaces/~462393321/pages/1007234825/Debugging+Legacy+Jira+gadgets+within+Connie
   * https://jira.atlassian.com/browse/CONFCLOUD-70573
   */ const [delayedOutput, setDelayedOutput] = (0, $cozmU.useState)(extensionKey === 'gadget' ? '' : macroRenderedOutput);
    const [container, setContainer] = (0, $cozmU.useState)(null);
    const embeddedProps = (0, $1eD4P.useReactProps_DO_NOT_USE)();
    (0, $78b5K.useShimLegacyMacroLinks)({
        container: container,
        shimUrl: navigationPolicy.shimUrl,
        enabled: Boolean(navigationPolicy.routePolicy && embeddedProps?.navigationPolicy?.shimUrl && mode === (0, $5kjCz.RENDERER) && !isWithinEditor && $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM.includes(extensionKey) && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_ep_shim_macro_links_v2'))
    });
    const [isMacroResourcesLoaded, setIsMacroResourcesLoaded] = (0, $cozmU.useState)(false);
    const unknownMacroPortals = (0, $l4pUK.useUnknownMacroPortal)({
        container: container,
        macroBodyStorage: macroBodyStorage ?? null
    });
    const { eventHandlers: externalLinkEventHandlers, onSetLinkTarget: onSetLinkTarget } = (0, $jNKuq.useExternalLinkHandlers)();
    // Patch links in the raw server-rendered HTML, which bypass the ADF renderer.
    (0, $cozmU.useLayoutEffect)(()=>{
        if (!container || !(container instanceof HTMLElement) || macroRepresentation === 'atlas_doc_format') return;
        (0, $3DNeP.ensureExternalLinksOpenInNewTab)(container);
    }, [
        container,
        delayedOutput,
        macroRepresentation
    ]);
    // Measure block and bodied Connect macros after their resources and output have loaded.
    const isRendererExtension = mode === (0, $5kjCz.RENDERER) && (adf.type === (0, $8pcS0.REGULAR_EXTENSION_TYPE) || adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE));
    const isMacroLoaded = container && isMacroResourcesLoaded && delayedOutput;
    (0, $cozmU.useEffect)(()=>{
        if (container) {
            const loadMacroResources = async ()=>{
                const isDPModuleDefined = (0, $8cOoD.checkIsDPModuleDefined)();
                if (!isDPModuleDefined) {
                    const isViewPage = mode === (0, $5kjCz.RENDERER);
                    await (0, $8cOoD.loadDataProviderModule)({
                        logger: $34a09ee48ab537fd$var$logger,
                        isViewPage: isViewPage,
                        createAnalyticsEvent: createAnalyticsEvent
                    });
                }
                if (isMultiBodied) await (0, $iQhLj.defineMacroModule)({
                    logger: $34a09ee48ab537fd$var$logger
                });
                await (0, $8eAX8.loadMacroWebResources)(webresource, macroRenderedOutputFromSSR, macroOutput, ()=>{
                    if (delayedOutput !== macroRenderedOutput) setDelayedOutput(macroRenderedOutput);
                }, scriptContainer?.current);
                setIsMacroResourcesLoaded(true);
            };
            loadMacroResources();
            (0, $brpfO.evalLegacyConnectInlineScripts)(container);
            $34a09ee48ab537fd$var$initializeCalendarIfNeeded(extensionKey, (0, $fgbpl.isBodiedExtension)(adf.type), macroRenderedOutput);
        }
    }, [
        webresource,
        extensionKey,
        macroRenderedOutput,
        delayedOutput,
        container,
        scriptContainer,
        macroRenderedOutputFromSSR,
        macroOutput,
        mode,
        createAnalyticsEvent,
        isMultiBodied,
        adf.type
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!isMacroLoaded || !isRendererExtension || !isConnectMacro || !container) return;
        return (0, $lW5tg.observeContentMacroDimensions)(container, 'connect', extensionKey, ({ height: height, width: width })=>{
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'legacyMacroRenderer',
                    action: 'render',
                    actionSubject: 'connectMacro',
                    attributes: {
                        extensionKey: extensionKey,
                        height: height,
                        width: width
                    }
                }
            }).fire();
        });
    }, [
        container,
        contentId,
        extensionKey,
        createAnalyticsEvent,
        isMacroLoaded,
        isRendererExtension,
        isConnectMacro
    ]);
    // Add instrumentation for WRM keys from data-wrm-key in webresource.tags.js
    // If extension is dependent on WRM resources, store WRM keys and extension key in window.__WRM_KEYS__
    (0, $cozmU.useEffect)(()=>{
        const wrmKeys = (0, $4OwbJ.parseWrmKeysFromTagsJs)(webresource?.tags?.js ?? null) || [];
        if (window && wrmKeys.length > 0) {
            if (!window.__WRM_KEYS__) window.__WRM_KEYS__ = {};
            const existingJsKeys = window.__WRM_KEYS__['js'] ?? [];
            const existingExtensionKeys = window.__WRM_KEYS__['extension'] ?? [];
            window.__WRM_KEYS__['js'] = [
                ...new Set([
                    ...existingJsKeys,
                    ...wrmKeys
                ])
            ];
            window.__WRM_KEYS__['extension'] = [
                ...new Set([
                    ...existingExtensionKeys,
                    extensionKey
                ])
            ];
        }
    }, [
        webresource,
        extensionKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (appKey && window) {
            if (!window.__APP_KEYS__) window.__APP_KEYS__ = [];
            window.__APP_KEYS__ = [
                ...new Set([
                    ...window.__APP_KEYS__,
                    appKey
                ])
            ];
        }
    }, [
        appKey
    ]);
    (0, $brT00.useLinkIntercept)(extensionKey ?? '', container, mode === (0, $5kjCz.EDITOR) || isWithinEditor);
    const macroId = $34a09ee48ab537fd$var$getMacroId(adf, macroRenderedOutput);
    const macroOrigin = $34a09ee48ab537fd$export$f72fde323a57bd3e(macroRenderedOutput);
    (0, $goE1t.useMacroSLOExperienceTracking)({
        contentId: contentId,
        delayedOutput: delayedOutput,
        extensionKey: extensionKey,
        isConnectMacro: isConnectMacro,
        isRendererMode: mode === (0, $5kjCz.RENDERER),
        macroId: macroId,
        macroOutput: macroOutput,
        macroRenderedOutputFromSSR: macroRenderedOutputFromSSR
    });
    const ssredElement = (0, $KcDWk.useSSRedLegacyMacroElement)(macroId);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isSiteAdmin = (0, $8Lx5S.useIsAdmin)();
    const connectAppKey = typeof appKey === 'string' && appKey.length > 0 && appKey !== 'unknown' ? appKey : $34a09ee48ab537fd$var$getConnectAddonKeyFromMacroOutput(macroRenderedOutput);
    const connectEosBanner = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    connectAppKey && (0, $9wGTI.fg)('customer-messaging-iframe-banner-enabled') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dPlMJ.ConnectEosBanner), {
        appKey: connectAppKey,
        cloudId: cloudId,
        moduleType: "dynamicContentMacros",
        isSystemApp: (0, $jAI8J.isSystemApp)(connectAppKey),
        isSiteAdmin: isSiteAdmin
    }) : null;
    (0, $cozmU.useEffect)(()=>{
        // `appKey` from the GraphQL response can be the sentinel string "unknown"
        // (or empty/undefined). Fall back to the Connect `addon_key` parsed from
        // the rendered macro payload — that is the identifier embedded FAUS uses
        // to build the `fetchAppKeyFromEmbeddedFAUS_<addon_key>` channel name.
        const isValidAppKey = typeof appKey === 'string' && appKey.length > 0 && appKey !== 'unknown';
        const addonKeyCandidate = $34a09ee48ab537fd$var$getConnectAddonKeyFromMacroOutput(macroRenderedOutput);
        const bridgeIdentifier = isValidAppKey ? appKey : addonKeyCandidate;
        const hasBridgeIdentifier = typeof bridgeIdentifier === 'string' && bridgeIdentifier.length > 0;
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (!(0, $9wGTI.fg)('forge_nbm_set_frame_ancestors') || !hasBridgeIdentifier) return undefined;
        let cleanupListener;
        let observer;
        let registeredIframe = null;
        const registerWithIframeWindow = (iframe)=>{
            const targetWindow = iframe?.contentWindow;
            if (!targetWindow) return false;
            cleanupListener?.();
            cleanupListener = (0, $8wppk.registerEmbeddedFausAppKeyListener)(bridgeIdentifier, macroOrigin, macroId, targetWindow);
            return Boolean(cleanupListener);
        };
        const attachIframeLoadListener = (iframe)=>{
            const onLoad = ()=>{
                if (registeredIframe === iframe) registerWithIframeWindow(iframe);
            };
            iframe.addEventListener('load', onLoad);
            return ()=>iframe.removeEventListener('load', onLoad);
        };
        let cleanupIframeLoadListener;
        const syncIframeRegistration = ()=>{
            const iframe = container instanceof HTMLElement ? container.querySelector('iframe') : null;
            if (iframe === registeredIframe) return;
            cleanupIframeLoadListener?.();
            cleanupIframeLoadListener = undefined;
            registeredIframe = iframe;
            if (!iframe) {
                cleanupListener?.();
                cleanupListener = undefined;
                return;
            }
            registerWithIframeWindow(iframe);
            cleanupIframeLoadListener = attachIframeLoadListener(iframe);
        };
        if (container instanceof HTMLElement) {
            syncIframeRegistration();
            observer = new MutationObserver((mutations)=>{
                const iframeChanged = mutations.some(({ addedNodes: addedNodes, removedNodes: removedNodes })=>[
                        ...Array.from(addedNodes),
                        ...Array.from(removedNodes)
                    ].some((node)=>node instanceof HTMLIFrameElement || node instanceof Element && node.querySelector('iframe') !== null));
                if (iframeChanged) syncIframeRegistration();
            });
            observer.observe(container, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            observer?.disconnect();
            cleanupIframeLoadListener?.();
            cleanupListener?.();
        };
    }, [
        container,
        macroId,
        appKey,
        macroOrigin,
        macroRenderedOutput
    ]);
    const nodeProps = {
        ref: setContainer
    };
    const macroDataProps = {
        'data-fabric-macro': macroId,
        'data-macro-body': body || '',
        'data-macro-parameters': parameters || '',
        'data-node-type': extensionKey === 'include' ? 'include' : undefined
    };
    // Use parent id if the macro source is different than the current page
    const getContentId = (adf, contentId)=>{
        const parentId = adf?.attrs?.parameters?.macroParams?._parentId?.value;
        return parentId || contentId;
    };
    const { getExtensionHandlers: getExtensionHandlers } = providers;
    const effectiveContentId = getContentId(adf, contentId);
    const extensionHandlers = getExtensionHandlers ? getExtensionHandlers({
        adf: macroRepresentation == 'atlas_doc_format' ? macroRenderedOutputFromSSR || macroOutput || macroRenderedOutput : adf,
        contentId: effectiveContentId,
        spaceKey: spaceKey,
        macroRenderedOutput: macroRenderedOutputFromSSR || macroOutput || macroRenderedOutput,
        shouldIncludeMacroWithReferencesHandlers: true,
        referentialityDataSourceProvider: new (0, $itU2t.DataSourceProvider)(),
        mediaToken: mediaToken
    }) : {};
    // Legacy macro containers can emit server TOC placeholders instead of invoking
    // the frontend extension handler. Hydrate matching nested TOCs with the page ADF.
    const shouldHydrateNestedLegacyToc = mode === (0, $5kjCz.RENDERER) && (extensionKey === 'section' || (0, $fgbpl.isBodiedExtension)(adf.type) && (0, $6mKj3.expValEquals)('toc_macro_receive_full_page_headings_exp', 'isEnabled', true));
    const elementProps = {
        adf: adf,
        isInline: isInline,
        contentId: effectiveContentId,
        mode: mode,
        extensionKey: extensionKey,
        nodeProps: nodeProps,
        macroRepresentation: macroRepresentation,
        macroDataProps: macroDataProps,
        macroRenderedOutput: delayedOutput,
        extensionHandlers: extensionHandlers,
        mediaToken: mediaToken,
        headingIdPrefix: extensionKey === 'include' ? macroId : undefined,
        ssredElement: ssredElement,
        delayIframe: false,
        height: viewportHeight
    };
    if (mode === (0, $5kjCz.RENDERER) || mode === (0, $5kjCz.PDF)) {
        try {
            const macroId = attributes?.macroId ? attributes.macroId : '';
            const type = attributes?.type ? attributes.type : 'none';
            // on view page it will send macro load event
            // it will help to alert in case of multiple rendering of macro
            // event name: macro renderer (client)
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'renderer',
                    actionSubject: 'macro',
                    source: 'legacyMacroRenderer',
                    attributes: {
                        mode: mode,
                        extensionKey: extensionKey,
                        macroId: macroId,
                        contentId: contentId,
                        type: type
                    }
                }
            }).fire();
        } catch (err) {
            $34a09ee48ab537fd$var$logger.error`An error occurred while firing the analytics event for legacyMacroRendererComponent: ${err}`;
        }
        const finalExtensionKey = attributes?.extensionKey || extensionKey;
        /**
     * https://product-fabric.atlassian.net/browse/CCP-1798
     * If macroRenderedOutputFromSSR or macroOuput are passed as a prop, they will be used for SPA rehydration (rather
     * than the MacroContentQuery). macroRenderedOutputFromSSR / macroOutput already have JS/CSS coming from ContentUnifiedQuery,
     * so here we use the base components of LegacyMacroRendererComponent, but instead
     * render FabricLegacyMacrosServerRenderer, which sets JS/CSS internally.
     * https://product-fabric.atlassian.net/browse/DLRN-3182
     * If macroOutput exists, it contains the full html (as a string) required to render the macro.
     */ if (macroRenderedOutputFromSSR || macroOutput) {
            const macroDefaultProps = {
                node: node,
                references: references,
                contentId: effectiveContentId,
                spaceKey: spaceKey || '',
                mode: (0, $5kjCz.RENDERER),
                extensionKey: extensionKey,
                attributes: attributes,
                isConnectMacro: isConnectMacro
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
                extensionKey: finalExtensionKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
                name: "LegacyMacroRendererComponentResourcesSSR",
                hold: !isMacroResourcesLoaded
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9L50P.LegacyMacroReferenceListener), {
                references: references,
                macroContainer: container
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
                extensionKey: finalExtensionKey,
                contentId: contentId,
                node: node
            }), connectEosBanner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $989nU.FabricLegacyMacrosServerRenderer), {
                renderedByProvider: true,
                activateIframes: isNestedLcmHierarchy,
                releaseEmptyMacrosToManifest: isNestedLcmHierarchy,
                macroRenderedOutput: macroRenderedOutputFromSSR,
                macroDefaultProps: macroDefaultProps,
                containerRef: setContainer,
                macroOutput: macroOutput
            }), shouldHydrateNestedLegacyToc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7lgkH.NestedLegacyTocHydrator), {
                container: container,
                sectionNode: adf,
                contentId: effectiveContentId,
                spaceKey: spaceKey,
                references: references
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHZWk.LegacyUserElementsHover), {
                node: container
            }), // WS-3295 - DO NOT REMOVE THIS LOADER
            // We need to load the legacy editor here to allow users to create/edit/view comments with the attachments macro
            extensionKey === 'attachments' && !isPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Consumer, null, ({ EditorLoaderLoader: EditorLoaderLoader })=>{
                // isWithinEditor will be true if the attachments macro is within a macro
                // that itself is being rendered in the editor, e.g., excerpt-include.
                return !isWithinEditor && !isPreviewMode && EditorLoaderLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorLoaderLoader, null);
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
                name: experienceName,
                contentId: contentId,
                extensionKey: extensionKey,
                mode: mode,
                attributes: attributes
            })));
        }
        // TODO: Detect TeamCalendar macro and enusre hold timing is correct for it
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
            extensionKey: finalExtensionKey
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "LegacyMacroRendererComponentResourcesNonSSR",
            hold: !isMacroResourcesLoaded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9L50P.LegacyMacroReferenceListener), {
            references: references,
            macroContainer: container
        }), isMultiBodied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jShOo.MultiBodiedExtensionHandler), {
            macroId: macroId,
            macroParams: parameters,
            editorActions: multiBodiedExtensionActions,
            readonly: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: `${webresource?.tags?.css || ''}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                display: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5LTS4.ExtensionLoadingComplete), {
            extensionKey: finalExtensionKey,
            contentId: contentId,
            node: node
        }), connectEosBanner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
            renderedByProvider: true,
            ...elementProps,
            macroRenderedOutput: $34a09ee48ab537fd$var$MACROS_TO_URL_SHIM.includes(extensionKey) ? navigationPolicy.shimHtmlUrls(delayedOutput) : delayedOutput
        }), unknownMacroPortals, shouldHydrateNestedLegacyToc && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7lgkH.NestedLegacyTocHydrator), {
            container: container,
            sectionNode: adf,
            contentId: effectiveContentId,
            spaceKey: spaceKey,
            references: references
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hHZWk.LegacyUserElementsHover), {
            node: container
        }), // WS-3295 - DO NOT REMOVE THIS LOADER
        // We need to load the legacy editor here to allow users to create/edit/view comments with the attachments macro
        extensionKey === 'attachments' && !isPreviewMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hMRhJ.RendererExtensionContext).Consumer, null, ({ EditorLoaderLoader: EditorLoaderLoader })=>{
            // isWithinEditor will be true if the attachments macro is within a macro
            // that itself is being rendered in the editor, e.g., excerpt-include.
            return !isWithinEditor && EditorLoaderLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(EditorLoaderLoader, null);
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: "js-container",
            ref: scriptContainer,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                display: 'none'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: experienceName,
            contentId: contentId,
            extensionKey: extensionKey,
            mode: mode,
            attributes: attributes
        })));
    }
    let parsedDelayedOutput;
    let parseError;
    let component;
    try {
        if (macroRepresentation === 'atlas_doc_format') {
            parsedDelayedOutput = JSON.parse(delayedOutput);
            component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hEeUR.ADFRenderer), {
                document: parsedDelayedOutput,
                contentId: getContentId(adf, contentId),
                featureFlags: featureFlags ?? {},
                extensionHandlers: extensionHandlers,
                mediaToken: mediaToken,
                appearance: "full-width",
                eventHandlers: externalLinkEventHandlers,
                onSetLinkTarget: onSetLinkTarget,
                allowHeadingAnchorLinks: extensionKey === 'include' ? {
                    allowNestedHeaderLinks: true,
                    getHeadingLink: (headingId)=>(0, $gnzsm.createHeadingLink)(getHeadingLinkPath, headingId) ?? (typeof window !== 'undefined' ? new URL(`#${encodeURIComponent(headingId)}`, window.location.href).toString() : `#${encodeURIComponent(headingId)}`)
                } : undefined,
                headingIdPrefix: extensionKey === 'include' ? macroId : undefined
            });
        }
    } catch (e) {
        parseError = e;
        $34a09ee48ab537fd$var$logger.error`An error occurred while parsing adf output: ${delayedOutput}`;
        component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BMhZ.LegacyMacroRendererError), {
            error: parseError,
            node: node,
            mode: mode,
            extensionKey: extensionKey,
            contentId: contentId
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$var$UFO3PSegmentWrapper, {
        extensionKey: extensionKey
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "LegacyMacroRendererComponentResourcesFabric",
        hold: !isMacroResourcesLoaded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        dangerouslySetInnerHTML: {
            __html: `${webresource?.tags?.css || ''}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    }), isMultiBodied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jShOo.MultiBodiedExtensionHandler), {
        macroId: macroId,
        macroParams: parameters,
        editorActions: multiBodiedExtensionActions
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iaRmR.LegacyMacroStyledElement), {
        renderedByProvider: true,
        ...elementProps,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: getPresetMinHeight?.(extensionKey) === undefined && getPresetHeight?.(extensionKey) === undefined && viewportHeight && // The draw.io experiment is checked first so draw.io presets its height even when the Connect preset gate is off
        ((0, $5Gfuv.isDrawioExtensionKey)(extensionKey) && (0, $6mKj3.expVal)('confluence_preset_height_migrated_drawio', 'isEnabled', false) || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_connect_macro_preset_height')) ? {
            minHeight: `${viewportHeight}px`
        } : null
    }, noOverlay || shouldHideOverlay || isMultiBodied ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$var$Overlay, null), connectEosBanner, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9L50P.LegacyMacroReferenceListener), {
        references: references,
        macroContainer: container
    }), macroRepresentation === 'atlas_doc_format' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "macro-adf-renderer",
        ref: setContainer
    }, component) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: setContainer,
        dangerouslySetInnerHTML: {
            __html: `${delayedOutput}`
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bX5uj.MacroExperienceSuccess), {
        name: experienceName,
        contentId: contentId,
        extensionKey: extensionKey,
        mode: mode,
        attributes: attributes
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        key: "js-container",
        ref: scriptContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            display: 'none'
        }
    })));
});
const $34a09ee48ab537fd$export$b43db7dd8b06a124 = (props)=>{
    const rendererExtensionProviders = (0, $cozmU.useContext)((0, $hMRhJ.RendererExtensionContext));
    const classicEditorExtensionProviders = (0, $cozmU.useContext)((0, $giS6h.ClassicEditorContext));
    const isWithinEditor = classicEditorExtensionProviders?.isWithinEditor ?? false;
    const providers = {
        ...classicEditorExtensionProviders,
        ...rendererExtensionProviders
    };
    const propsWithProviders = {
        ...props,
        providers: providers,
        isWithinEditor: isWithinEditor,
        getHeadingLinkPath: props.getHeadingLinkPath ?? classicEditorExtensionProviders?.getHeadingLinkPath
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($34a09ee48ab537fd$export$a5c44bbb70ae7ae6, propsWithProviders);
};
module.exports["LegacyMacroRendererComponent"] = $34a09ee48ab537fd$export$b43db7dd8b06a124;

});

parcelRegister("dPlMJ", function(module, exports) {
/* ConnectEosBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $cXtTj = parcelRequire("cXtTj");


var $lvJqX = parcelRequire("lvJqX");


var $1VhsF = parcelRequire("1VhsF");


var $jtT80 = parcelRequire("jtT80");


var $7dBf8 = parcelRequire("7dBf8");


var $7OuPp = parcelRequire("7OuPp");


var $lEfEl = parcelRequire("lEfEl");

function $3d63ea7a98a3f43b$var$_defineProperty(e, r, t) {
    return (r = $3d63ea7a98a3f43b$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $3d63ea7a98a3f43b$var$_toPropertyKey(t) {
    var i = $3d63ea7a98a3f43b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $3d63ea7a98a3f43b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $3d63ea7a98a3f43b$export$4f5b90a6ce229aa1 = 'customer-messaging-iframe-banner-dismiss-days';
const $3d63ea7a98a3f43b$export$5b9fb60c3fa87c1a = 'customer_messaging_apps_blocked_by_atlassian';
const $3d63ea7a98a3f43b$export$461103d5504d4d8b = 'connect-eos-banner_dismissed';
const $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS = 'SUCCESS';
const $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS = 'BLOCKED';
const $3d63ea7a98a3f43b$export$9d00c95780551685 = 30;
const $3d63ea7a98a3f43b$export$10cefe68e4bb6b44 = 86400000;
const $3d63ea7a98a3f43b$export$a916575f88d9889f = 'customer-messaging-iframe-banner-enabled';
const $3d63ea7a98a3f43b$export$35fbf2628e8debb2 = 'customer_messaging_iframes_phase_2';
const $3d63ea7a98a3f43b$export$61abdb4e3a264073 = 'customer_messaging_iframes_phase_3';
const $3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED = 'customer-messaging-is-dev-canary';
const $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL = 'https://developer.atlassian.com/cloud/jira/platform/developer-canary-program/';
const $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL = 'https://developer.atlassian.com/platform/forge/changelog/';
const $3d63ea7a98a3f43b$var$DEFAULT_LOCALE = 'en';
const $3d63ea7a98a3f43b$var$defaultIntlCache = (0, $kSwu1.createIntlCache)();
const $3d63ea7a98a3f43b$var$defaultIntl = (0, $kSwu1.createIntl)({
    locale: $3d63ea7a98a3f43b$var$DEFAULT_LOCALE
}, $3d63ea7a98a3f43b$var$defaultIntlCache);
const $3d63ea7a98a3f43b$var$containerStyles = {
    marginBottom: '8px'
};
const $3d63ea7a98a3f43b$var$devCanaryMessageStyles = null;
function $3d63ea7a98a3f43b$export$e6e73547b6ec2430(appKey) {
    return `${appKey}-${$3d63ea7a98a3f43b$export$461103d5504d4d8b}`;
}
class $3d63ea7a98a3f43b$var$ConnectEosBannerComponent extends $cozmU.PureComponent {
    _getDismissDurationMs() {
        const days = (0, $cXtTj.default).getExperiment($3d63ea7a98a3f43b$export$4f5b90a6ce229aa1, {
            fireExperimentExposure: false
        }).get('value', $3d63ea7a98a3f43b$export$9d00c95780551685);
        return (typeof days === 'number' && days > 0 ? days : $3d63ea7a98a3f43b$export$9d00c95780551685) * $3d63ea7a98a3f43b$export$10cefe68e4bb6b44;
    }
    _isDismissed() {
        if (typeof window === 'undefined') return false;
        const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey);
        const storedItem = (0, $7dBf8.AtlBrowserStorageLocal).getItem(dismissStorageKey);
        if (!storedItem) return false;
        let dismissedAt;
        try {
            const parsedItem = JSON.parse(storedItem);
            dismissedAt = parsedItem.value;
        } catch (e) {
            (0, $7OuPp.logger).warn('Failed to parse Connect EOS banner dismissal', {
                key: dismissStorageKey,
                error: e
            });
            return false;
        }
        if (!dismissedAt) return false;
        const dismissedTimestamp = Number(dismissedAt);
        if (isNaN(dismissedTimestamp)) return false;
        return Date.now() - dismissedTimestamp < this._getDismissDurationMs();
    }
    _shouldShowBanner() {
        // Don't show if the main feature gate is not enabled
        if (!(0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$export$a916575f88d9889f)) return false;
         // Don't show for system apps
        if (this.props.isSystemApp) return false;
        if (this._isBlockedByAtlassian()) return false;
        const phaseGate = this._getPhaseGate();
        if (phaseGate && !(0, $cXtTj.default).checkGate(phaseGate)) return false;
         // Don't show if previously dismissed (within configured dismiss duration)
        if (this.state.dismissed) return false;
        return true;
    }
    _getMigrationCohort() {
        const migration = this.props.connectToForgeMigration;
        if (!migration?.defined) return 'UNDECLARED';
        switch(migration.willMigrateToForgeBeforeEOS){
            case 'NO':
            case 'YES':
            case 'UNDECIDED':
                return migration.willMigrateToForgeBeforeEOS;
            default:
                return 'UNDECIDED';
        }
    }
    _getPhaseGate() {
        switch(this._getMigrationCohort()){
            case 'NO':
                return undefined;
            case 'YES':
                return $3d63ea7a98a3f43b$export$61abdb4e3a264073;
            case 'UNDECLARED':
            case 'UNDECIDED':
            default:
                return $3d63ea7a98a3f43b$export$35fbf2628e8debb2;
        }
    }
    _isBlockedByAtlassian() {
        const blockedAppKeys = (0, $cXtTj.default).getExperiment($3d63ea7a98a3f43b$export$5b9fb60c3fa87c1a, {
            fireExperimentExposure: false
        }).get('value', []);
        return Array.isArray(blockedAppKeys) && typeof this.props.appKey === 'string' && blockedAppKeys.includes(this.props.appKey);
    }
    _isProd() {
        if (typeof window === 'undefined') return false;
        return window.location.hostname.endsWith('.atlassian.net');
    }
    _isSiteAdmin() {
        return this.props.isSiteAdmin ?? false;
    }
    _isDevCanary() {
        return (0, $cXtTj.default).checkGate($3d63ea7a98a3f43b$var$FEATURE_GATE_DEV_CANARY_ENABLED);
    }
    _getConnectedAppsUrl() {
        const cloudId = this.props.cloudId ?? (typeof document !== 'undefined' ? document.querySelector('meta[name="ajs-cloud-id"]')?.content : undefined) ?? undefined;
        const adminHost = this._isProd() ? 'admin.atlassian.com' : 'admin.stg.atlassian.com';
        if (!cloudId) return undefined;
        return `https://${adminHost}/s/${cloudId}/user-connected-apps/tab/installed`;
    }
    _getMessageBody() {
        const { appName: appName } = this.props;
        const isSiteAdmin = this._isSiteAdmin();
        const connectedAppsUrl = this._getConnectedAppsUrl();
        const migrationGuideUrl = this.props.connectToForgeMigration?.migrationGuideUrl?.trim();
        const cohort = this._getMigrationCohort();
        const messageCohort = cohort !== 'UNDECLARED' && !migrationGuideUrl ? 'UNDECLARED' : cohort;
        const messages = {
            UNDECLARED: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).undeclaredAdmin : (0, $lEfEl.connectEosBannerMessages).undeclaredNonAdmin,
            NO: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).noAdmin : (0, $lEfEl.connectEosBannerMessages).noNonAdmin,
            UNDECIDED: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).undecidedAdmin : (0, $lEfEl.connectEosBannerMessages).undecidedNonAdmin,
            YES: isSiteAdmin ? (0, $lEfEl.connectEosBannerMessages).yesAdmin : (0, $lEfEl.connectEosBannerMessages).yesNonAdmin
        };
        const connectedApps = (chunks)=>/*#__PURE__*/ $cozmU.createElement("strong", null, connectedAppsUrl ? /*#__PURE__*/ $cozmU.createElement("a", {
                href: connectedAppsUrl
            }, chunks) : /*#__PURE__*/ $cozmU.createElement("span", null, chunks));
        const migrationGuide = (chunks)=>migrationGuideUrl ? /*#__PURE__*/ $cozmU.createElement("a", {
                href: migrationGuideUrl,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks) : /*#__PURE__*/ $cozmU.createElement("span", null, chunks);
        const strong = (chunks)=>/*#__PURE__*/ $cozmU.createElement("strong", null, chunks);
        return /*#__PURE__*/ $cozmU.createElement("p", null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...messages[messageCohort],
            values: {
                appName: appName ?? '',
                hasAppName: Boolean(appName),
                strong: strong,
                connectedApps: connectedApps,
                migrationGuide: migrationGuide
            }
        }));
    }
    _getDevCanaryMessageBody() {
        if (!this._isDevCanary()) return null;
        const developerCanaryProgram = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$DEVELOPER_CANARY_PROGRAM_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        const forgeChangelog = (chunks)=>/*#__PURE__*/ $cozmU.createElement("a", {
                href: $3d63ea7a98a3f43b$var$FORGE_CHANGELOG_URL,
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks);
        return /*#__PURE__*/ $cozmU.createElement("p", {
            className: (0, $hekY6.default)([
                "_313842Pgdg"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $lEfEl.connectEosBannerMessages).devCanaryMessage,
            values: {
                developerCanaryProgram: developerCanaryProgram,
                forgeChangelog: forgeChangelog
            }
        }));
    }
    _getDismissAction() {
        return /*#__PURE__*/ $cozmU.createElement((0, $jtT80.default), {
            onClick: this._dismiss,
            key: "dismiss"
        }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $lEfEl.connectEosBannerMessages).dismiss));
    }
    getSectionWarningBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-banner",
            style: $3d63ea7a98a3f43b$var$containerStyles
        }, /*#__PURE__*/ $cozmU.createElement((0, $1VhsF.default), {
            appearance: "warning"
        }, this._getMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    getInlineBanner() {
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "connect-eos-v2-banner"
        }, /*#__PURE__*/ $cozmU.createElement((0, $lvJqX.default), {
            appearance: "warning",
            secondaryText: (this.props.intl ?? $3d63ea7a98a3f43b$var$defaultIntl).formatMessage((0, $lEfEl.connectEosBannerMessages).inlineSecondaryText)
        }, this._getMessageBody(), this._getDevCanaryMessageBody(), this._getDismissAction()));
    }
    render() {
        if (!this._shouldShowBanner()) return null;
        const banner = this.props.moduleType === 'webPanels' ? this.getInlineBanner() : this.getSectionWarningBanner();
        if (!this.props.intl) return /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.RawIntlProvider), {
            value: $3d63ea7a98a3f43b$var$defaultIntl
        }, banner);
        return banner;
    }
    constructor(props){
        super(props);
        $3d63ea7a98a3f43b$var$_defineProperty(this, "_dismiss", ()=>{
            const dismissedAt = Date.now();
            const storedItem = JSON.stringify({
                value: dismissedAt
            });
            const dismissStorageKey = $3d63ea7a98a3f43b$export$e6e73547b6ec2430(this.props.appKey); // @browser-storage setter
            (0, $7dBf8.AtlBrowserStorageLocal).setItem(dismissStorageKey, storedItem).then((result)=>{
                if (result?.status && result.status !== $3d63ea7a98a3f43b$var$BSC_SUCCESS_STATUS && result.status !== $3d63ea7a98a3f43b$var$BSC_BLOCKED_STATUS) (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    result: result
                });
            }).catch((error)=>{
                (0, $7OuPp.logger).warn('Failed to persist Connect EOS banner dismissal', {
                    key: dismissStorageKey,
                    error: error
                });
            });
            this.setState({
                dismissed: true
            });
        });
        this.state = {
            dismissed: this._isDismissed()
        };
    }
}
$3d63ea7a98a3f43b$var$_defineProperty($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, "defaultProps", {
    isSystemApp: false,
    moduleType: ''
});
const $3d63ea7a98a3f43b$export$70b82b13309d5477 = (0, $kSwu1.injectIntl)($3d63ea7a98a3f43b$var$ConnectEosBannerComponent, {
    enforceContext: false
});
module.exports["ConnectEosBanner"] = $3d63ea7a98a3f43b$export$70b82b13309d5477;

});

parcelRegister("7OuPp", function(module, exports) {
/* eslint-disable */ // @ts-nocheck

var $jDYJM = parcelRequire("jDYJM");

class $8825011921e30ce8$var$LoggerController {
    isDebugEnabled() {
        return this.debugEnabled;
    }
    isInfoEnabled() {
        return this.infoEnabled;
    }
    constructor(){
        this.debugEnabled = false;
        this.infoEnabled = true;
    }
}
/**
 * This class serves two purposes:
 *   - It provides the ability for products to register their implementations
 *     of LoggerAPI for use by the connect front end code.
 *   - It provides the LoggerAPI implementation that connect front end code
 *     should use. This implementation delegates to the registered LoggerAPI
 *     implementation. This class should be used within the connect front end
 *     code as follows:
 *
 *     import logger from '../adaptors/logger/LoggerAdaptor';
 *
 *     logger.info('My message', extraStuffOfInterest, etc, ...);
 */ class $8825011921e30ce8$var$LoggerAdaptor {
    /**
   * Implementation of AnalyticsRegistry#registerAnalyticsAPI().
   */ registerLoggerAPI(loggerAPI) {
        this.loggerAPI = loggerAPI;
    }
    /**
   * Implementation of LoggerAPI#debug() for use by connect-module-core code.
   */ debug(message, ...optionalParams) {
        try {
            if (this.loggerController.isDebugEnabled()) this.loggerAPI.debug.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#info() for use by connect-module-core code.
   */ info(message, ...optionalParams) {
        try {
            if (this.loggerController.isInfoEnabled()) this.loggerAPI.info.apply(this.loggerAPI, arguments);
        } catch (exception) {
        // Ignore
        }
    }
    /**
   * Implementation of LoggerAPI#warn() for use by connect-module-core code.
   */ warn(message, ...optionalParams) {
        try {
            this.loggerAPI.warn.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.warn || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    /**
   * Implementation of LoggerAPI#error() for use by connect-module-core code.
   */ error(message, ...optionalParams) {
        try {
            this.loggerAPI.error.apply(this.loggerAPI, arguments);
        } catch (exception) {
            const logger = console.error || console.log;
            if (logger) logger.apply(logger, arguments);
        }
    }
    constructor(){
        this.loggerController = void 0;
        this.loggerAPI = (0, $jDYJM.default);
        this.loggerController = new $8825011921e30ce8$var$LoggerController();
        window._loggerController = this.loggerController;
    }
}
const $8825011921e30ce8$export$af88d00dbe7f521 = new $8825011921e30ce8$var$LoggerAdaptor();
module.exports["logger"] = $8825011921e30ce8$export$af88d00dbe7f521;

});

parcelRegister("jDYJM", function(module, exports) {
$parcel$export(module.exports, "default", () => $14ab1827b564829e$export$2e2bcd8739ae039);
/* eslint-disable */ // @ts-nocheck
class $14ab1827b564829e$var$DefaultLoggerAPI {
    debug(message, ...optionalParams) {
        console.debug.apply(console, arguments);
    }
    info(message, ...optionalParams) {
        console.info.apply(console, arguments);
    }
    warn(message, ...optionalParams) {
        console.warn.apply(console, arguments);
    }
    error(message, ...optionalParams) {
        console.error.apply(console, arguments);
    }
}
var $14ab1827b564829e$export$2e2bcd8739ae039 = new $14ab1827b564829e$var$DefaultLoggerAPI();

});

parcelRegister("lEfEl", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e33f058366d031a5$export$db71c19e7db05343 = (0, $kSwu1.defineMessages)({
    undeclaredAdmin: {
        id: "connect-module-core.modules.app.undeclaredAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    undeclaredNonAdmin: {
        id: "connect-module-core.modules.app.undeclaredNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. To explore your options, contact your site admin."
    },
    noAdmin: {
        id: "connect-module-core.modules.app.noAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027; after that, the vendor <migrationGuide><strong>will discontinue supporting it as well</strong></migrationGuide>. Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    noNonAdmin: {
        id: "connect-module-core.modules.app.noNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. To explore your options, contact your site admin."
    },
    undecidedAdmin: {
        id: "connect-module-core.modules.app.undecidedAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. <migrationGuide><strong>Learn more</strong></migrationGuide> about the vendor's plans to migrate app users (including you). Check <connectedApps>Connected apps</connectedApps> to see what options are available for all similar apps."
    },
    undecidedNonAdmin: {
        id: "connect-module-core.modules.app.undecidedNonAdmin",
        defaultMessage: "{hasAppName, select, true {The <strong>{appName}</strong> app} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. <migrationGuide><strong>Learn more</strong></migrationGuide> about the vendor's plans to migrate app users (including you). To explore your options, contact your site admin."
    },
    yesAdmin: {
        id: "connect-module-core.modules.app.yesAdmin",
        defaultMessage: "{hasAppName, select, true {This version of <strong>{appName}</strong>} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. The app developer is creating a new version; read about their <migrationGuide>migration plans for app users</migrationGuide>."
    },
    yesNonAdmin: {
        id: "connect-module-core.modules.app.yesNonAdmin",
        defaultMessage: "{hasAppName, select, true {This version of <strong>{appName}</strong>} other {This app}} is running on a platform we\u2019ll no longer support after January 2027. The app developer is creating a new version; read about their <migrationGuide>migration plans for app users</migrationGuide>."
    },
    devCanaryMessage: {
        id: "connect-module-core.eos.devCanaryMessage",
        defaultMessage: "You're seeing this message because your tenant is enrolled in the <developerCanaryProgram>Developer Canary Program</developerCanaryProgram>. For updates on when this goes live in production, watch the <forgeChangelog>Forge changelog</forgeChangelog>."
    },
    dismiss: {
        id: "connect-module-core.eos.dismiss",
        defaultMessage: "Dismiss"
    },
    inlineSecondaryText: {
        id: "connect-module-core.eos.inlineSecondaryText",
        defaultMessage: "This app might stop working soon"
    }
});
module.exports["connectEosBannerMessages"] = $e33f058366d031a5$export$db71c19e7db05343;

});

parcelRegister("jAI8J", function(module, exports) {
/**
 * Set of system app addon keys.
 * These are special built-in applications that are part of the system.
 */ const $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS = new Set([
    'jira-slack-integration',
    'com.atlassian.servicedesk.embedded',
    'com.atlassian.servicedesk.embedded.moderate',
    'stspg-jira-ops',
    'com.atlassian.jira.spreadsheets',
    'atlassian-outlook-integration',
    'com.codebarrel.addons.automation',
    'com.codebarrel.addons.automation.moderate',
    'opsgenie-jira-adapter',
    'opsgenie-jira-adapter.moderate',
    'halp.com',
    'halp.moderate.com',
    'msteams-jira',
    'com.atlassian.atlas.jira',
    'cello',
    'msteams-confluence',
    'opsgenie-incident-timeline-lab',
    'com.addonengine.analytics'
]);
function $252ad196ad9bae6b$export$4d755424ce1abae9(addonKey) {
    return $252ad196ad9bae6b$var$SYSTEM_APP_ADDON_KEYS.has(addonKey);
}
module.exports["isSystemApp"] = $252ad196ad9bae6b$export$4d755424ce1abae9;

});

parcelRegister("5LTS4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $ep3mz = parcelRequire("ep3mz");


var $6VdZc = parcelRequire("6VdZc");


var $4JC0x = parcelRequire("4JC0x");


var $1xpoY = parcelRequire("1xpoY");


var $bF1aY = parcelRequire("bF1aY");


var $h8C1D = parcelRequire("h8C1D");


var $kksmx = parcelRequire("kksmx");

const $ebb4d303074e1a0c$var$NOT_SSRED = 'none';
const $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED = 'ssr-blocked';
// Limit performance tracking for only top 10 extensions on initial load.
// The value is semi-arbitrary, as this is +2 to the number of extensions
// we attempt to SSR on initial load - this will give us an idea how the
// non-SSRed extensions are performing.
// This will lead to ~39% more tracking events send overall, comparing to
// 50/50 rollout we had before, but will prevent from sending huge amount
// of events for individual pages with a lot of extensions.
const $ebb4d303074e1a0c$var$TRACKING_LIMIT = 10;
const $ebb4d303074e1a0c$var$isBlocklisted = (ssrPreloadFailure)=>ssrPreloadFailure?.startsWith('blocklist') ? $ebb4d303074e1a0c$var$NOT_SSRED_BLOCKED : $ebb4d303074e1a0c$var$NOT_SSRED;
// This check is being made only upon initial render, and therefore is sufficient for
// checking whether element (in our case the marker) appears above the fold when rendered.
const $ebb4d303074e1a0c$var$isMarkerAboveTheFold = (el)=>{
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return(// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
};
const $ebb4d303074e1a0c$var$getPerformanceEntry = (entryName)=>{
    if (performance && typeof performance.getEntriesByName === 'function') return performance.getEntriesByName(entryName);
    return [];
};
const $ebb4d303074e1a0c$export$64e91845ba744516 = ({ node: node, contentId: contentId, extensionKey: extensionKey })=>{
    const [{ routeName: routeName }] = (0, $ep3mz.usePageState)();
    const { localId: localId } = node;
    const macroId = node.parameters?.macroMetadata?.macroId?.value;
    const extensionBlocklist = (0, $1xpoY.default).getString('confluence-extensions-server-render-blocklist', '');
    const markerRef = (0, $cozmU.useRef)(null);
    const { extensionIndex: extensionIndex, isUnsupportedExtension: isUnsupportedExtension } = (0, $h8C1D.useExtensionIndex)(macroId);
    const doNotTrackExtension = extensionIndex === (0, $h8C1D.UNKNOWN_INDEX) || extensionIndex >= $ebb4d303074e1a0c$var$TRACKING_LIMIT;
    (0, $cozmU.useEffect)(()=>{
        // NOTE: as of now, this metric is tailored to monitoring the performance of extensions
        // on initial load. We're not planning to use this metric in any way on transitions yet
        // thus we don't want to spam analytics with the data we don't use.
        if (doNotTrackExtension || !(0, $6VdZc.isInitial)()) return;
        // WARN: Complexity alert! The logic of fmp/tti/duration calculation is convoluted
        // here because of several reasons. Due to the timing of creating performance marks
        // that we use here, we may report extension timing *before* TTI measure is evaluated,
        // since TTI measure is waiting for several page segments. Thus on initial load we have
        // to rely on other reference points, that are available before extensions are rendered.
        const pageTTI = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('rendererRendered.end')?.pop()?.startTime : $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric:tti')?.pop()?.duration;
        const pageFMP = (0, $6VdZc.isInitial)() ? $ebb4d303074e1a0c$var$getPerformanceEntry('CFP-63.ssr-ttr')?.pop()?.startTime : pageTTI;
        const clientRouteStart = $ebb4d303074e1a0c$var$getPerformanceEntry('browser-metric.start')?.pop()?.startTime;
        const ssrPreloadFailure = (0, $4JC0x.getPreloadFailures)(macroId) || '';
        const ssrGeneralFailure = (0, $4JC0x.getGeneralFailures)() || '';
        const isExtensionSSRed = (0, $6VdZc.isInitial)() ? (0, $kksmx.getExtensionSSRMark)(macroId) || $ebb4d303074e1a0c$var$isBlocklisted(ssrPreloadFailure) : $ebb4d303074e1a0c$var$NOT_SSRED;
        // On transition we cannot reliably expect that "browser-metric:tti" measure is there
        // before macro rendering. Thus, use routing start as a base point for extension performance
        // measurement on transition. Note that FMP=TTI on transition.
        const startTime = ((0, $6VdZc.isInitial)() ? pageFMP : clientRouteStart) ?? 0;
        const customData = {
            isExtensionSSRed: isExtensionSSRed,
            extensionIndex: extensionIndex,
            extensionKey: extensionKey,
            contentId: contentId,
            pageFMP: pageFMP ?? 0,
            pageTTI: pageTTI ?? 0,
            isATF: $ebb4d303074e1a0c$var$isMarkerAboveTheFold(markerRef.current),
            ssrPreloadFailure: isUnsupportedExtension ? 'unsupportedContentInternalExtension' : ssrPreloadFailure || ssrGeneralFailure,
            clientRouteStart: clientRouteStart ?? 0,
            hydratable: window?.__HYDRATABLE__ || false,
            hydrationFailed: window?.__HYDRATION_FAILED__ || false
        };
        const metric = (0, $bF1aY.LEGACY_EXTENSION_LOADING_METRIC)(`${extensionKey}.${contentId}.${localId}`);
        metric.start({
            startTime: startTime
        });
        metric.stop({
            customData: customData
        });
    }, [
        doNotTrackExtension,
        extensionBlocklist,
        extensionKey,
        extensionIndex,
        isUnsupportedExtension,
        routeName,
        localId,
        contentId,
        macroId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ref: markerRef
    });
};
module.exports["ExtensionLoadingComplete"] = $ebb4d303074e1a0c$export$64e91845ba744516;

});

parcelRegister("4JC0x", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $98c2a7811aa5a89d$export$fe853ff85807a350 = new Map();
let $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
const $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState = (0, $dOBRD.default)(()=>{
    const rootQueryList = window?.__APOLLO_STATE__?.ROOT_QUERY || {};
    return Object.keys(rootQueryList).filter((query)=>query.startsWith('macroBodyRenderer'));
});
function $98c2a7811aa5a89d$var$isMacroPreloaded(macroId) {
    const preloadedMacros = $98c2a7811aa5a89d$var$getListOfPreloadedMacrosFromApolloState();
    return preloadedMacros.some((preloaded)=>preloaded.includes(macroId));
}
const $98c2a7811aa5a89d$export$1441f92d09a5c3ee = ()=>window.__SSR_RENDERED__ && !!window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
function $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl() {
    const cacheMismatches = $98c2a7811aa5a89d$var$getPreloadCacheMismatches();
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (cacheMismatches.length == 0 && (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0)) return;
    const failedMacros = {};
    function addFailed(reason, macroId, extensionKey) {
        failedMacros[macroId] = {
            reason: reason,
            extensionKey: extensionKey
        };
    }
    Object.entries(reportedFails).forEach(([keyAndId, reason])=>{
        if (keyAndId === 'general') return;
        const [extensionKey, macroId] = keyAndId.split(':');
        if (reason === 'timeout') {
            if ($98c2a7811aa5a89d$var$isMacroPreloaded(macroId)) addFailed('falseTimeouts', macroId, extensionKey);
            else addFailed('trueTimeouts', macroId, extensionKey);
        } else addFailed(reason, macroId, extensionKey);
    });
    cacheMismatches.forEach(([macroId, extensionKey])=>addFailed('cacheMismatch', macroId, extensionKey));
    return failedMacros;
}
function $98c2a7811aa5a89d$export$622ff65a4d6eaaaf() {
    if (!$98c2a7811aa5a89d$export$576fafc5561e06f5) $98c2a7811aa5a89d$export$576fafc5561e06f5 = {
        value: $98c2a7811aa5a89d$var$getPreloadFailedMacrosImpl()
    };
    return $98c2a7811aa5a89d$export$576fafc5561e06f5.value;
}
function $98c2a7811aa5a89d$export$de5406af81980582() {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
}
function $98c2a7811aa5a89d$export$3288a79f0c713f52(macroId) {
    const failedMacros = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf();
    return failedMacros?.[macroId]?.reason;
}
function $98c2a7811aa5a89d$export$34734b475a3fd7b9() {
    const reportedFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__ || {};
    if (!reportedFails || typeof reportedFails !== 'object' || Object.keys(reportedFails).length === 0) return;
    return reportedFails?.['general'];
}
function $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd(macroId, extensionKey) {
    $98c2a7811aa5a89d$export$576fafc5561e06f5 = null;
    $98c2a7811aa5a89d$export$fe853ff85807a350.set(macroId, extensionKey || '');
    window['__MISSING_DATA_MACROS__'] = window['__MISSING_DATA_MACROS__'] || [];
    window['__MISSING_DATA_MACROS__'].push(macroId);
}
function $98c2a7811aa5a89d$var$getPreloadCacheMismatches() {
    return [
        ...$98c2a7811aa5a89d$export$fe853ff85807a350
    ].filter(([macroId])=>$98c2a7811aa5a89d$var$isMacroPreloaded(macroId));
}
module.exports["macrosPreloadPerformed"] = $98c2a7811aa5a89d$export$1441f92d09a5c3ee;
module.exports["getPreloadFailedMacros"] = $98c2a7811aa5a89d$export$622ff65a4d6eaaaf;
module.exports["getPreloadFailures"] = $98c2a7811aa5a89d$export$3288a79f0c713f52;
module.exports["getGeneralFailures"] = $98c2a7811aa5a89d$export$34734b475a3fd7b9;
module.exports["markMissingMacroData"] = $98c2a7811aa5a89d$export$4d6ac53bc9b1b8bd;

});

parcelRegister("bF1aY", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $63112e910a0def69$export$841f5507db609445 = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.LEGACY_EXTENSION_LOADING_CUSTOM_KEY)
});
module.exports["LEGACY_EXTENSION_LOADING_METRIC"] = $63112e910a0def69$export$841f5507db609445;

});

parcelRegister("h8C1D", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $llqlc = parcelRequire("llqlc");


var $8pcS0 = parcelRequire("8pcS0");

const $028a91b33dee434b$export$7affafe0528b70b1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    indexes: new Map()
});
const $028a91b33dee434b$var$extractExtensions = (adf)=>(0, $llqlc.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
const $028a91b33dee434b$export$e4ac003417d6dace = 'UNKNOWN';
const $028a91b33dee434b$export$981cab9712b3b1a3 = ({ document: document, children: children })=>{
    const indexes = (0, $cozmU.useMemo)(()=>{
        const extensions = $028a91b33dee434b$var$extractExtensions(document);
        return new Map(extensions.map((node, idx)=>{
            window['unsupportedExtension'] = window['unsupportedExtension'] || {};
            if (node.attrs?.parameters?.nestedContent?.content && node.attrs.extensionKey === '__confluenceADFMigrationUnsupportedContentInternalExtension__') node.attrs.parameters.nestedContent.content.forEach((each)=>{
                window['unsupportedExtension'][each.attrs?.parameters?.macroMetadata?.macroId?.value] = idx;
            });
            return [
                node.attrs?.parameters?.macroMetadata?.macroId?.value,
                idx
            ];
        }));
    }, [
        document
    ]);
    const value = (0, $cozmU.useMemo)(()=>({
            indexes: indexes
        }), [
        indexes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($028a91b33dee434b$export$7affafe0528b70b1.Provider, {
        value: value
    }, children);
};
const $028a91b33dee434b$export$ea9830505fbaa6ad = (macroId)=>{
    const { indexes: indexes } = (0, $cozmU.useContext)($028a91b33dee434b$export$7affafe0528b70b1);
    let index = indexes.get(macroId);
    const unsupportedExtensions = window['unsupportedExtension'];
    let isUnsupportedExtension = false;
    if (unsupportedExtensions && unsupportedExtensions[macroId]) {
        index = unsupportedExtensions[macroId];
        isUnsupportedExtension = true;
    }
    return {
        extensionIndex: typeof index === 'number' ? index : $028a91b33dee434b$export$e4ac003417d6dace,
        isUnsupportedExtension: isUnsupportedExtension
    };
};
module.exports["UNKNOWN_INDEX"] = $028a91b33dee434b$export$e4ac003417d6dace;
module.exports["ExtrensionIndexProvider"] = $028a91b33dee434b$export$981cab9712b3b1a3;
module.exports["useExtensionIndex"] = $028a91b33dee434b$export$ea9830505fbaa6ad;

});

parcelRegister("kksmx", function(module, exports) {
const $e82f7a932bbd9bed$export$66373c7c22b9de3c = '__LEGACY_MACRO_SSRED__';
const $e82f7a932bbd9bed$export$583da28e18e772e3 = (macroOutput, macroData)=>{
    if (macroOutput) return 'ssr-new';
    else if (macroData) return 'ssr-exp';
    return 'ssr-legacy';
};
const $e82f7a932bbd9bed$export$90da570939dfebac = (macroId)=>window[$e82f7a932bbd9bed$export$66373c7c22b9de3c]?.[macroId];
const $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c = ({ macroId: macroId, renderType: renderType })=>{
    return null;
};
module.exports["getRenderType"] = $e82f7a932bbd9bed$export$583da28e18e772e3;
module.exports["getExtensionSSRMark"] = $e82f7a932bbd9bed$export$90da570939dfebac;
module.exports["ExtensionSSRMark"] = $e82f7a932bbd9bed$export$b0e8f73fcaf60c5c;

});

parcelRegister("hHZWk", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $jlIaF = parcelRequire("jlIaF");


var $a6t12 = parcelRequire("a6t12");


var $4qzKl = parcelRequire("4qzKl");

/**
 * This component processes the DOM Node for ContentBody, Likes, & CommentBody to find all User Mentions
 * and User Links and replaces them with a React Element for @atlaskit/profilecard
 */ const $fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS = [
    'a.user-mention',
    'a.confluence-userlink',
    'a.userLogoLink',
    'span.user-hover-trigger',
    'img.confluence-userlink'
];
class $fe7178b75f06350f$export$549ba0a29911d5ee extends (0, $cozmU.Component) {
    shouldComponentUpdate(nextProps) {
        return nextProps.node !== this.props.node;
    }
    getLegacyUserElements() {
        const { node: node } = this.props;
        if (!node) return [];
        return Array.from(node.querySelectorAll($fe7178b75f06350f$var$LEGACY_USER_ELEMENT_SELECTORS.join(',')));
    }
    render() {
        return (0, $4qzKl.replaceUserElementsWithPlaceholders)(this.getLegacyUserElements()).map((item)=>this.renderPortal(item));
    }
    constructor(...args){
        super(...args);
        this.renderPortal = (item)=>{
            const { position: position } = this.props;
            const userId = item.props['data-account-id'];
            item.props.href = (0, $4qzKl.getAtlassianPeopleProfileUrl)(item.props['data-account-id'], null, (0, $jlIaF.CONTEXT_PATH));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fe7178b75f06350f$export$b688bc1b9fd324b6, {
                placeholder: item.placeholder
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: !userId,
                userId: userId,
                position: position
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", item.props, item.props.children))), item.placeholder);
        };
    }
}
function $fe7178b75f06350f$export$b688bc1b9fd324b6(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { placeholder: placeholder, children: children } = t0;
    let t1;
    let t2;
    if ($[0] !== placeholder) {
        t1 = ()=>{
            const markPlaceholderIgnored = (e)=>{
                if (e?.tagName === "SPAN") {
                    e.setAttribute("data-ssr-placeholder-ignored", "true");
                    Array.from(e.children).forEach((child)=>markPlaceholderIgnored(child));
                }
            };
            markPlaceholderIgnored(placeholder);
        };
        t2 = [
            placeholder
        ];
        $[0] = placeholder;
        $[1] = t1;
        $[2] = t2;
    } else {
        t1 = $[1];
        t2 = $[2];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
}
module.exports["LegacyUserElementsHover"] = $fe7178b75f06350f$export$549ba0a29911d5ee;

});

parcelRegister("8eAX8", function(module, exports) {

var $k5ycH = parcelRequire("k5ycH");


var $cpjd2 = parcelRequire("cpjd2");


var $8n9tL = parcelRequire("8n9tL");


var $64KID = parcelRequire("64KID");


var $9fLxI = parcelRequire("9fLxI");

const $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES = [
    'wr!com.atlassian.confluence.plugins.confluence-view-file-macro:view-file-macro-resources'
];
const $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES = [
    'wr!confluence.web.resources:view-content',
    'wr!confluence.macros.advanced:get-more'
];
const $d0091e97ce884599$export$1d71148f13231a96 = ()=>[
        // transitional and implicit dependencies
        'wrc!com.atlassian.confluence.extra.team-calendars:amd',
        'wrc!com.atlassian.confluence.extra.team-calendars:user-timezone-setup',
        // editor context
        'wrc!com.atlassian.confluence.extra.team-calendars:calendar-init-editor',
        // macro-browser (not loaded by macro browser for some reason)
        'wrc!com.atlassian.confluence.extra.team-calendars:macro-browser-web-resources'
    ];
function $d0091e97ce884599$export$c3c980ae518bc695(webresources, macroRenderedOutputFromSSR, macroOutput, callback, scriptContainer, unavailableCallback) {
    const defaultWrmResources = $d0091e97ce884599$var$MACRO_DEFAULT_WRM_RESOURCES;
    const staticConnectWrmResources = $d0091e97ce884599$var$MACRO_STATIC_CONNECT_WRM_RESOURCES;
    let deps = [], jsTags;
    if (macroRenderedOutputFromSSR || macroOutput) deps = [
        ...defaultWrmResources
    ];
    else {
        if (!webresources) return Promise.resolve();
        jsTags = webresources?.tags?.js ?? null;
        const contexts = !jsTags || !scriptContainer ? webresources.contexts && webresources.contexts.map((context)=>`wrc!${context}`) || [] : [];
        const keys = !jsTags || !scriptContainer ? webresources.keys && webresources.keys.map((key)=>`wr!${key}`) || [] : [];
        deps = [
            ...defaultWrmResources,
            ...staticConnectWrmResources,
            ...contexts,
            ...keys
        ];
    }
    return new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)(deps, ()=>{
            // Callback
            if (callback) callback();
            if (scriptContainer && jsTags) (0, $k5ycH.loadResources)(scriptContainer, jsTags).then(resolve);
            else resolve();
        }, ()=>{
            // Unavailable Callback
            // eslint-disable-next-line no-console
            console.error(`Cannot loadMacroWebResources: ${deps}`);
            if (unavailableCallback) unavailableCallback();
        });
    });
}
function $d0091e97ce884599$export$a144665563142e() {
    let macrosMetadataCache = null;
    const macrosMetadataSpaceAwareCache = {};
    return async function metadataLoader() {
        const spaceKey = $d0091e97ce884599$var$getSpaceKey();
        if (spaceKey) {
            if (!macrosMetadataSpaceAwareCache[spaceKey]) macrosMetadataSpaceAwareCache[spaceKey] = $d0091e97ce884599$var$fetchMacroMetadata(spaceKey);
            return macrosMetadataSpaceAwareCache[spaceKey];
        }
        if (!macrosMetadataCache) macrosMetadataCache = $d0091e97ce884599$var$fetchMacroMetadata();
        return macrosMetadataCache;
    };
}
function $d0091e97ce884599$var$getSpaceKey() {
    const pageUrl = window.location.toString();
    const match = (0, $8n9tL.findAndMatchRoute)((0, $64KID.namedRoutes), pageUrl);
    // There's a race condition when the space key is not yet available in AJS upon
    // calling metadataLoader, therefore we fallback to the space key in the URL.
    return window.AJS?.Meta?.get('space-key') || match?.params?.spaceKey;
}
function $d0091e97ce884599$var$fetchMacroMetadata(spaceKey) {
    return (0, $9fLxI.getExtensionManifest)({
        spaceKey: spaceKey
    }).then((manifest)=>{
        const macros = manifest?.macros || [];
        return macros;
    });
}
module.exports["teamCalendarWRM"] = $d0091e97ce884599$export$1d71148f13231a96;
module.exports["loadMacroWebResources"] = $d0091e97ce884599$export$c3c980ae518bc695;
module.exports["createMetadataLoader"] = $d0091e97ce884599$export$a144665563142e;

});

parcelRegister("k5ycH", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $l6Xaz = parcelRequire("l6Xaz");

const $980b898db1533800$var$logger = (0, $7W8i8.getLogger)('wrm');
function $980b898db1533800$export$d3d08d944062d7e(container, tags, // Process tags as an array of links when linksMode = true
// We don't have tags info in CustomHeaderFooter.
linksMode = false) {
    if (!tags.length) return Promise.resolve();
    const fragment = window.document.createDocumentFragment();
    const promises = (0, $l6Xaz.parseScriptTags)(tags, linksMode).map(({ src: src, ...attributes })=>new Promise((resolve, reject)=>{
            if (window.document.querySelector(`script[data-wrm-key='${attributes['data-wrm-key']}']`)) // next/packages/content-renderer/src/TinyMCEServerFullRenderer.tsx will put script as defer to <head>
            // We don't want to re-initialize those scripts when rehydrate
            resolve(null);
            else {
                const scriptElement = window.document.createElement('script');
                scriptElement.async = false;
                scriptElement.src = src;
                scriptElement.onload = resolve;
                scriptElement.onerror = reject;
                Object.keys(attributes).forEach((attributeKey)=>scriptElement.setAttribute(attributeKey, attributes[attributeKey]));
                fragment.appendChild(scriptElement);
            }
        }));
    container.appendChild(fragment);
    return Promise.all(promises).catch((...args)=>{});
}
module.exports["loadResources"] = $980b898db1533800$export$d3d08d944062d7e;

});

parcelRegister("fgbpl", function(module, exports) {

var $8pcS0 = parcelRequire("8pcS0");

const $aba988feb2cb54c3$export$b05e83f63451e97 = (extensionType)=>{
    return [
        (0, $8pcS0.BODIED_EXTENSION_TYPE),
        (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)
    ].indexOf(extensionType) >= 0;
};
module.exports["isBodiedExtension"] = $aba988feb2cb54c3$export$b05e83f63451e97;

});

parcelRegister("3Btfb", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4o1RV = parcelRequire("4o1RV");

function $fa7a566b22788032$export$a039e57df2bba181(InnerComponent) {
    function WithNavigationPolicy(props) {
        const $ = (0, $bDgLe.c)(3);
        const navigationPolicy = (0, $4o1RV.useNavigationPolicy)();
        const t0 = props;
        let t1;
        if ($[0] !== navigationPolicy || $[1] !== t0) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InnerComponent, {
                ...t0,
                navigationPolicy: navigationPolicy
            });
            $[0] = navigationPolicy;
            $[1] = t0;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    WithNavigationPolicy.displayName = `withNavigationPolicy(${InnerComponent.displayName || InnerComponent.name})`;
    return WithNavigationPolicy;
}
module.exports["withNavigationPolicy"] = $fa7a566b22788032$export$a039e57df2bba181;

});

parcelRegister("giS6h", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a6c7790f33c3e831$export$bbe9955f93d6ed27 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({});
module.exports["ClassicEditorContext"] = $a6c7790f33c3e831$export$bbe9955f93d6ed27;

});

parcelRegister("8cOoD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $cpjd2 = parcelRequire("cpjd2");


var $gEtAQ = parcelRequire("gEtAQ");


var $fySJw = parcelRequire("fySJw");


var $3LvmY = parcelRequire("3LvmY");

const $198de0e1d1f1ab22$export$f1a6c160e5107221 = 'dataProvider';
const $198de0e1d1f1ab22$export$57b0f508e89cfdbb = ({ connectHost: connectHost })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const isViewPage = (0, $gEtAQ.isViewPage)();
        $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
            connectHost: connectHost,
            createAnalyticsEvent: createAnalyticsEvent,
            isViewPage: isViewPage
        });
    }, [
        connectHost,
        createAnalyticsEvent
    ]);
    return null;
};
const $198de0e1d1f1ab22$export$594716b2dbd4f0f9 = ()=>!!window['connectHost']?.isModuleDefined($198de0e1d1f1ab22$export$f1a6c160e5107221);
const $198de0e1d1f1ab22$export$eb1900d465fb2cb9 = ({ connectHost: connectHost, createAnalyticsEvent: createAnalyticsEvent, isViewPage: isViewPage })=>{
    const isDPModuleDefined = $198de0e1d1f1ab22$export$594716b2dbd4f0f9();
    const dataProviderModule = {
        emitToDataProvider: async (...args)=>{
            const data = args.length > 1 ? args[0] : null;
            const sendResponse = args.length > 1 ? args[args.length - 1] : args[0];
            const context = sendResponse?._context;
            const fragmentLocalId = context?.extension?.options?.productContext?.['macro.fragmentLocalId'];
            const extensionKey = context?.extension?.key;
            const event = (0, $3LvmY.getReceivedConnectRefDataEvent)({
                isViewPage: isViewPage,
                extensionKey: extensionKey
            });
            createAnalyticsEvent(event).fire();
            if (!extensionKey) throw Error('Missing Connect app extensionKey while transferring data.');
            const connectDataListener = (0, $fySJw.getConnectDataListener)();
            const status = await connectDataListener.transfer(extensionKey, fragmentLocalId, data, createAnalyticsEvent, isViewPage);
            return sendResponse(status);
        }
    };
    if (!isDPModuleDefined) connectHost.defineModule($198de0e1d1f1ab22$export$f1a6c160e5107221, dataProviderModule);
};
const $198de0e1d1f1ab22$export$8738a87451e0e0f8 = async ({ logger: logger, isViewPage: isViewPage, createAnalyticsEvent: createAnalyticsEvent })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            $198de0e1d1f1ab22$export$eb1900d465fb2cb9({
                connectHost: connectHost,
                createAnalyticsEvent: createAnalyticsEvent,
                isViewPage: isViewPage
            });
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for dataProvider!`;
            resolve();
        });
    });
};
module.exports["DataProviderModule"] = $198de0e1d1f1ab22$export$57b0f508e89cfdbb;
module.exports["checkIsDPModuleDefined"] = $198de0e1d1f1ab22$export$594716b2dbd4f0f9;
module.exports["loadDataProviderModule"] = $198de0e1d1f1ab22$export$8738a87451e0e0f8;

});

parcelRegister("fySJw", function(module, exports) {

var $2XKS9 = parcelRequire("2XKS9");


var $dc2v6 = parcelRequire("dc2v6");


var $3LvmY = parcelRequire("3LvmY");


var $1AM4E = parcelRequire("1AM4E");

let $8e595456ec3aa5d5$var$connectDataListener;


class $8e595456ec3aa5d5$var$ConnectDataListener {
    init({ emit: emit }) {
        this.emit = emit;
    }
    static async validate(extensionKey, data) {
        const { validateSchema: validateSchema, DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("31KN8"));
        if (!data.eventData) throw new DataTransferValidationError({
            message: "Passed data is missing 'eventData'."
        });
        const keys = Object.keys(data.eventData);
        if (keys.length !== 1) throw new DataTransferValidationError({
            message: "'eventData' should only include a single key. The key should be same with 'refDataSchema.outputType'."
        });
        const connectMacroKeyRefOutputTypeMap = await (0, $dc2v6.getConnectMacroKeyRefOutputTypeMap)();
        if (!connectMacroKeyRefOutputTypeMap.has(extensionKey)) // This is a case that shouldn't really happen. Throwing a regular error instead of DataTransferValidationError
        // because this error is not related to what the vendor emitted data.
        throw new Error('extensionKey is not found in the macro metadata.');
        if (connectMacroKeyRefOutputTypeMap.get(extensionKey) !== keys[0]) throw new DataTransferValidationError({
            message: `'eventData' should contain 'refDataSchema.outputType' defined in the app manifest (${connectMacroKeyRefOutputTypeMap.get(extensionKey)}).`
        });
        validateSchema(keys[0], data.eventData[keys[0]]);
    }
    async transfer(extensionKey, localId, data, createAnalyticsEvent, isViewPage) {
        if (this.emit && localId && data) {
            const transfer = {
                extensionKey: extensionKey,
                localId: localId,
                data: data,
                isViewPage: isViewPage
            };
            const isTrackable = (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).isTrackable(transfer);
            let didStartExperience = false;
            const shouldTrack = isTrackable;
            const { DataTransferValidationError: DataTransferValidationError } = await (parcelRequire("31KN8"));
            try {
                await $8e595456ec3aa5d5$var$ConnectDataListener.validate(extensionKey, data);
            } catch (e) {
                const event = (0, $3LvmY.getValidationFailedEvent)({
                    isViewPage: isViewPage,
                    extensionKey: extensionKey,
                    error: e
                });
                createAnalyticsEvent(event).fire();
                if (shouldTrack && !didStartExperience && !(e instanceof DataTransferValidationError)) {
                    (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                    didStartExperience = true;
                }
                if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).fail(e instanceof Error ? e : String(e));
                if (e instanceof DataTransferValidationError) return {
                    status: (0, $2XKS9.ConnectDataTransferStatus).Error,
                    message: e.message,
                    module: 'data_provider',
                    errors: e.errors
                };
                throw e;
            }
            if (shouldTrack && !didStartExperience) {
                (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).start(transfer);
                didStartExperience = true;
            }
            this.emit(localId, data.eventData);
            if (didStartExperience) (0, $1AM4E.ConnectReferentialityExperienceTrackerSupport).succeed();
            return {
                status: (0, $2XKS9.ConnectDataTransferStatus).Success,
                message: 'Data accepted and emitted',
                module: 'data_provider'
            };
        }
        return {
            status: (0, $2XKS9.ConnectDataTransferStatus).Error,
            message: 'There was an issue accepting the data',
            module: 'data_provider'
        };
    }
    constructor(){
        this.emit = void 0;
    }
}
const $8e595456ec3aa5d5$export$605049a72d9f563 = ()=>{
    if (!$8e595456ec3aa5d5$var$connectDataListener) $8e595456ec3aa5d5$var$connectDataListener = new $8e595456ec3aa5d5$var$ConnectDataListener();
    return $8e595456ec3aa5d5$var$connectDataListener;
};
module.exports["getConnectDataListener"] = $8e595456ec3aa5d5$export$605049a72d9f563;

});

parcelRegister("2XKS9", function(module, exports) {
var $606590dfce3163d6$export$f9f405499e653992 = /*#__PURE__*/ function(ConnectDataTransferStatus) {
    ConnectDataTransferStatus["Success"] = "Success";
    ConnectDataTransferStatus["Error"] = "Error";
    return ConnectDataTransferStatus;
}({});
module.exports["ConnectDataTransferStatus"] = $606590dfce3163d6$export$f9f405499e653992;

});

parcelRegister("dc2v6", function(module, exports) {

var $3IXUB = parcelRequire("3IXUB");

let $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
let $a1018373af446f97$var$initialized = false;
async function $a1018373af446f97$var$createMacroKeyRefOutputTypeMap() {
    const macros = await (0, $3IXUB.getMacroMetaData)();
    const result = macros.filter((macro)=>macro.refDataSchema != null).map((macro)=>[
            macro.macroName,
            macro.refDataSchema.outputType
        ]);
    return new Map(result);
}
async function $a1018373af446f97$export$9fde119d071a7062() {
    // used this initialized variable because I was seeing that connectMacroKeyRefOutputTypeMap may
    // be null errors otherwise
    if (!$a1018373af446f97$var$initialized) {
        $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap = await $a1018373af446f97$var$createMacroKeyRefOutputTypeMap();
        $a1018373af446f97$var$initialized = true;
    }
    return $a1018373af446f97$var$connectMacroKeyRefOutputTypeMap;
}
module.exports["getConnectMacroKeyRefOutputTypeMap"] = $a1018373af446f97$export$9fde119d071a7062;

});

parcelRegister("3IXUB", function(module, exports) {

var $8eAX8 = parcelRequire("8eAX8");


var $6OgRG = parcelRequire("6OgRG");


var $l21Jh = parcelRequire("l21Jh");

const $a3d4cd842e4cfa1b$var$loadMacroMetadata = (0, $8eAX8.createMetadataLoader)();
function $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4(browserConfig) {
    return (0, $l21Jh.autoConvert)($a3d4cd842e4cfa1b$export$82582a527779c20, browserConfig);
}
const $a3d4cd842e4cfa1b$export$82582a527779c20 = async ()=>{
    const macros = await $a3d4cd842e4cfa1b$var$loadMacroMetadata();
    const isAllowed = (0, $6OgRG.isAllowedWithFeatureFlags)();
    return macros.filter((macroMetadata)=>{
        if (macroMetadata.hidden) return false;
        return isAllowed(macroMetadata);
    });
};
module.exports["getAutoConverter"] = $a3d4cd842e4cfa1b$export$e08f75a9d86fcdf4;
module.exports["getMacroMetaData"] = $a3d4cd842e4cfa1b$export$82582a527779c20;

});

parcelRegister("6OgRG", function(module, exports) {
// This blocklist should reflect what is in https://pug.jira-dev.com/wiki/spaces/AEC/pages/3239608672/Macro+blocklist so if you want to add or remove something, please remember to update the page.
const $38fb99c52e3447fe$var$blocklist = {
    align: true,
    bgcolor: true,
    center: true,
    cheese: true,
    clickable: true,
    code: true,
    colgroup: true,
    column: true,
    'content-by-user': true,
    copyright: true,
    'create-space-button': true,
    div: true,
    expand: true,
    'fancy-bullets': true,
    'google-drive-docs': true,
    'google-drive-sheets': true,
    'google-drive-slides': true,
    favpages: true,
    'gadget-b7a6531b1c147f2e175f1209bed5c0ad': true,
    'gadget-01c2ed272e88f7333da124a03a481477': true,
    'gadget-d2450e06a9a285cf57eedb2d502d9d65b964eb847382938b6c57809bac2261bb': true,
    'global-reports': true,
    highlight: true,
    htmlcomment: true,
    im: true,
    img: true,
    info: true,
    junitreport: true,
    li: true,
    loremipsum: true,
    lozenge: true,
    multimedia: true,
    navmap: true,
    network: true,
    noformat: true,
    note: true,
    ol: true,
    OneDrive: true,
    p: true,
    panel: true,
    pre: true,
    'privacy-policy': true,
    'privacy-mark': true,
    'recently-used-labels': true,
    'reg-tm': true,
    rollover: true,
    roundrect: true,
    search: true,
    section: true,
    sm: true,
    'space-attachments': true,
    'space-details': true,
    span: true,
    status: true,
    strike: true,
    style: true,
    table: true,
    tbody: true,
    td: true,
    th: true,
    thead: true,
    tr: true,
    'trello-board': true,
    'trello-card': true,
    tip: true,
    tm: true,
    ul: true,
    warning: true
};
function $38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, blocklistOverrides = {}) {
    const key = macroMetadata.alternateId || (macroMetadata.id ? macroMetadata.id.replace('macro-', '') : macroMetadata.macroName);
    return blocklistOverrides.hasOwnProperty(key) ? blocklistOverrides[key] : Boolean($38fb99c52e3447fe$var$blocklist[key]);
}
function $38fb99c52e3447fe$export$1dba5c5d55fad37f() {
    const overrides = {};
    return (macroMetadata)=>!$38fb99c52e3447fe$export$1c6721fad2c8cfa0(macroMetadata, overrides);
}
async function $38fb99c52e3447fe$export$f38acf7431de7e2b(macroBrowser) {
    const originalList = [
        ...macroBrowser.metadataList
    ];
    // Currently no FF info is needed to create the blocklist but if it was, need to pass featureFlagClient to isAllowedWithFeatureFlags()
    const isAllowed = $38fb99c52e3447fe$export$1dba5c5d55fad37f();
    macroBrowser.metadataList = macroBrowser.metadataList.filter(isAllowed);
    /**
	 * Bring blocklisted items back so they show up elsewhere
	 */ return function restore() {
        macroBrowser.metadataList = originalList;
    };
}
module.exports["isAllowedWithFeatureFlags"] = $38fb99c52e3447fe$export$1dba5c5d55fad37f;
module.exports["applyBlocklist"] = $38fb99c52e3447fe$export$f38acf7431de7e2b;

});

parcelRegister("l21Jh", function(module, exports) {

var $3CRZ9 = parcelRequire("3CRZ9");


var $8PZXE = parcelRequire("8PZXE");

const $159df558ca333321$var$noop = ()=>null;
const $159df558ca333321$export$65b04260b3a15835 = async (loadMacroMetadata, browserConfig)=>{
    const { contentId: contentId } = browserConfig;
    if (!contentId) return $159df558ca333321$var$noop;
    const [jiraAutoConvert, connectAddonAutoConvert] = await Promise.all([
        (0, $3CRZ9.createJiraConverter)(contentId),
        (0, $8PZXE.createConnectAddonConverter)(loadMacroMetadata, contentId)
    ]);
    return (link)=>jiraAutoConvert(link) || connectAddonAutoConvert(link);
};
module.exports["autoConvert"] = $159df558ca333321$export$65b04260b3a15835;

});

parcelRegister("3CRZ9", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $1i7uI = parcelRequire("1i7uI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

function $3fcae9e87e9104a7$var$convertLink(link, defaultJiraMacroAttributes) {
    const noop = ()=>{};
    const legacyHandler = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).require('confluence/jim/editor-plugins/jira-paste-link');
    // jira paste handler needs object in this format
    const uri = {
        source: link
    };
    const jimPasteHandlerResult = legacyHandler.pasteHandler(uri, null, noop);
    if (!jimPasteHandlerResult || !jimPasteHandlerResult.params) return null;
    /**
	 * use JSON.parse , JSON.stringify to deeply clone object, avoid any reference
	 */ const macroAttributes = JSON.parse(JSON.stringify(defaultJiraMacroAttributes));
    if (!macroAttributes.attrs.parameters) macroAttributes.attrs.parameters = {};
    macroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(jimPasteHandlerResult.params);
    return macroAttributes;
}
async function $3fcae9e87e9104a7$export$2264c7423a8e6d34(contentId) {
    const placeholderMacro = {
        macroDefinition: {
            name: 'jira'
        },
        contentId: contentId
    };
    let jiraADFNode = null;
    try {
        // fetch ADF structure of JIM, and modify it to provide to editor later
        jiraADFNode = await (0, $foRF9.fetchMacroAttributes)(placeholderMacro);
    } catch (error) {
        // The placeholder endpoint does not honour a share token, so it 404s for these viewers.
        // Letting it reject would take the whole extension provider down with it.
        const isAccessLinkViewer = Boolean((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location?.pathname && (0, $1NBp8.ACCESS_LINK).match((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location.pathname)) && (0, $6mKj3.expValEquals)('access_link_m2', 'isEnabled', true);
        if (!isAccessLinkViewer) throw error;
    }
    if (!jiraADFNode) return ()=>null;
    const resolvedJiraADFNode = jiraADFNode;
    return (link)=>$3fcae9e87e9104a7$var$convertLink(link, resolvedJiraADFNode);
}
module.exports["createJiraConverter"] = $3fcae9e87e9104a7$export$2264c7423a8e6d34;

});

parcelRegister("foRF9", function(module, exports) {

var $aoRTi = parcelRequire("aoRTi");


var $8pcS0 = parcelRequire("8pcS0");


var $fgbpl = parcelRequire("fgbpl");


var $aMlgD = parcelRequire("aMlgD");


var $6mEZ3 = parcelRequire("6mEZ3");

const $5faed47790e8728c$var$isBlueprint = (contentId)=>!/^[0-9]+$/.test(contentId);
const $5faed47790e8728c$export$74ec65bf601b5f8c = async (options)=>{
    const { macroDefinition: macroDefinition, contentId: contentId, selectedMacro: selectedMacro, intl: intl } = options;
    const results = await (0, $aoRTi.experimentalMacroPlaceholderADFQuery)({
        variables: {
            contentId: $5faed47790e8728c$var$isBlueprint(contentId) ? '0' : contentId ?? '0',
            macroDefinition: JSON.stringify(macroDefinition)
        }
    });
    let placeholderAdf;
    try {
        if (results?.data) placeholderAdf = JSON.parse(results?.data?.experimentalMacroPlaceholderADF?.json);
    } catch  {
        // eslint-disable-next-line no-console
        console.error('Error getting placeholder ADF');
    }
    // A failed request resolves to an empty `json`, so the parse above throws and leaves this unset.
    // Continuing would build an `attrs`-less node and crash in `formatAsMacroAttributes` instead,
    // which reads as a macro bug rather than the failed fetch it actually is.
    if (!placeholderAdf) throw new Error('Macro placeholder ADF unavailable');
    const adf = {
        ...placeholderAdf
    };
    if ((0, $fgbpl.isBodiedExtension)(adf.type)) {
        if (selectedMacro) // Copy the macro contents into the adf node
        adf.content = selectedMacro.content;
        else if (!adf.content || adf.content.length === 0) {
            if (adf.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.EMPTY_ADF_CONTENT);
            if (adf.type === (0, $8pcS0.MULTI_BODIED_EXTENSION_TYPE)) adf.content = (0, $8pcS0.MULTI_BODIED_INITIAL_CONTENT);
        }
    }
    const macroAttributes = (0, $6mEZ3.formatAsMacroAttributes)(adf);
    if (intl) {
        const macroTitleOverride = (0, $aMlgD.getMacroTitleOverride)(macroDefinition.name, intl);
        if (macroTitleOverride && macroAttributes.attrs.parameters?.macroMetadata) macroAttributes.attrs.parameters.macroMetadata.title = macroTitleOverride;
    }
    return macroAttributes;
};
module.exports["fetchMacroAttributes"] = $5faed47790e8728c$export$74ec65bf601b5f8c;

});

parcelRegister("aoRTi", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $aBfpe = parcelRequire("aBfpe");


var $hBkCm = parcelRequire("hBkCm");

const $fef05c831d419c6c$export$145bdd0c11f23103 = async ({ variables: variables })=>{
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: '/wiki/rest/internal/1.0/macro/placeholder',
        method: 'POST',
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        body: JSON.stringify({
            macro: JSON.parse(variables.macroDefinition),
            contentId: variables.contentId
        }),
        parseResponseOnError: (error)=>{
            if ((0, $hBkCm.BadStatusError).isBadStatusError(error)) return {
                __badStatusError: true
            };
            throw error;
        },
        parseResult: (json)=>{
            if (json && typeof json === 'object' && '__badStatusError' in json) return {
                experimentalMacroPlaceholderADF: {
                    json: ''
                }
            };
            return {
                experimentalMacroPlaceholderADF: {
                    json: JSON.stringify(json)
                }
            };
        },
        variables: variables
    });
    return {
        data: result.data
    };
};
module.exports["experimentalMacroPlaceholderADFQuery"] = $fef05c831d419c6c$export$145bdd0c11f23103;

});

parcelRegister("8PZXE", function(module, exports) {

var $foRF9 = parcelRequire("foRF9");


var $6mEZ3 = parcelRequire("6mEZ3");

/*
This script adds autoconvert handlers to the confluence editor.

It executes on editor initialisation, registering the handlers defined in the original add-on descriptors of whatever
add-ons are installed. Each one is associated with a particular macro (although a macro can be associated with many
handlers.

On pattern match, the each handler will be asked if they match and will be processed by the first matching handler.
The macro object is then created, using the matched uri and the information already existing in the JS context, and
the macro is inserted into the editor.
*/ const $44631a970962135a$var$TRELLO_MACRO_NAME = 'trello-card';
const $44631a970962135a$var$escapePattern = (str)=>{
    return str.replace(/[\-\[\]\/\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
};
const $44631a970962135a$var$replaceAll = (find, replace, str)=>{
    return str.replace(new RegExp(find, 'g'), replace);
};
const $44631a970962135a$var$convertPatternToRegex = (pattern)=>{
    // Consolidate any double up wildcards
    while(pattern.indexOf('{}{}') !== -1)pattern = pattern.replace('{}{}', '{}');
    // build a regex from the defined autoconvert pattern
    pattern = $44631a970962135a$var$escapePattern(pattern);
    pattern = $44631a970962135a$var$replaceAll('{}', '[^/]*?', pattern);
    // eslint-disable-next-line prefer-template
    pattern = '^' + pattern + '$';
    return pattern;
};
const $44631a970962135a$var$isPatternSafe = (pattern)=>{
    const patternBlockList = [
        'http://',
        'https://',
        'http://{}',
        'https://{}',
        'http://{}.{}',
        'https://{}.{}',
        'http://{}.{}.{}',
        'https://{}.{}.{}'
    ];
    // check the url pattern is not banned
    return patternBlockList.every((bannedPattern)=>bannedPattern !== pattern);
};
const $44631a970962135a$var$hasAutoconvertData = (macro)=>{
    return macro.autoconvertData && macro.autoconvertData.urlParameter && macro.autoconvertData.patterns;
};
const $44631a970962135a$var$getADFNodeForMacros = async (macros, contentId)=>{
    const macroAttributesArray = await Promise.all(Array.from(macros).map((macroName)=>(0, $foRF9.fetchMacroAttributes)({
            macroDefinition: {
                name: macroName
            },
            contentId: contentId
        })));
    return macroAttributesArray.reduce((accu, macroAttributes)=>{
        accu[macroAttributes.attrs.extensionKey] = macroAttributes;
        return accu;
    }, {});
};
const $44631a970962135a$var$convertLink = (link, autoconvertDefs, macroAttributesMap)=>{
    const matchedAcd = autoconvertDefs.find((acd)=>{
        return !!link.match(acd.matcher);
    });
    if (matchedAcd) {
        const { macroName: macroName, urlParameter: urlParameter } = matchedAcd;
        const params = {};
        params[urlParameter] = link;
        const macroAttributes = macroAttributesMap[macroName];
        const convertedMacroAttributes = JSON.parse(JSON.stringify(macroAttributes));
        convertedMacroAttributes.attrs.text = `${urlParameter} = ${link}`;
        convertedMacroAttributes.attrs.extensionKey = macroName;
        if (!convertedMacroAttributes.attrs.parameters) convertedMacroAttributes.attrs.parameters = {};
        convertedMacroAttributes.attrs.parameters.macroParams = (0, $6mEZ3.wrapMacroParams)(params);
        return convertedMacroAttributes;
    } else return null;
};
async function $44631a970962135a$export$13c25ccf87e8cca2(loadMacroMetadata, contentId) {
    const autoconvertDefs = [];
    const macros = await loadMacroMetadata();
    // this object contains name of macros which have correct autoconvertData
    const filteredMacros = new Set();
    macros.forEach((macro)=>{
        if (// Don't convert any new Trello links to Trello macro due to new Trello smart links
        !$44631a970962135a$var$hasAutoconvertData(macro) || macro.macroName === $44631a970962135a$var$TRELLO_MACRO_NAME) return;
        // only macro with autoconvertData can be converted
        macro.autoconvertData.patterns.forEach((pattern)=>{
            if ($44631a970962135a$var$isPatternSafe(pattern)) {
                const acd = {
                    macroName: macro.macroName,
                    urlParameter: macro.autoconvertData.urlParameter,
                    matcher: $44631a970962135a$var$convertPatternToRegex(pattern)
                };
                filteredMacros.add(acd.macroName);
                autoconvertDefs.push(acd);
            }
        });
    });
    const macroAttributes = await $44631a970962135a$var$getADFNodeForMacros(filteredMacros, contentId);
    return (link)=>$44631a970962135a$var$convertLink(link, autoconvertDefs, macroAttributes);
}
module.exports["createConnectAddonConverter"] = $44631a970962135a$export$13c25ccf87e8cca2;

});

parcelRegister("3LvmY", function(module, exports) {
const $a60398d8d7606d16$export$16d909a88d49df97 = ({ isViewPage: isViewPage, extensionKey: extensionKey, error: error })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'failed',
            actionSubject: 'connectRefEventDataValidation',
            attributes: {
                extensionKey: extensionKey,
                message: error.message
            }
        }
    };
};
const $a60398d8d7606d16$export$f472af28e6312d6e = ({ isViewPage: isViewPage, extensionKey: extensionKey })=>{
    return {
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: isViewPage ? 'viewPageScreen' : 'editPageScreen',
            action: 'received',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: extensionKey
            }
        }
    };
};
module.exports["getValidationFailedEvent"] = $a60398d8d7606d16$export$16d909a88d49df97;
module.exports["getReceivedConnectRefDataEvent"] = $a60398d8d7606d16$export$f472af28e6312d6e;

});

parcelRegister("1AM4E", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $b8656fd966301400$var$getError = (messageOrError)=>{
    if (messageOrError instanceof Error) return messageOrError;
    return new Error(messageOrError);
};
const $b8656fd966301400$export$9e19abdf0a0245fe = new class ConnectReferentialityExperienceTrackerSupport {
    isTrackable(transfer) {
        return Boolean(transfer?.extensionKey) && Boolean(transfer?.localId) && Boolean(transfer?.data);
    }
    start(transfer) {
        (0, $fGzMp.getExperienceTracker)().start({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            attributes: {
                extensionKey: transfer?.extensionKey,
                isViewPage: transfer?.isViewPage
            }
        });
    }
    succeed() {
        (0, $fGzMp.getExperienceTracker)().succeed({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE)
        });
    }
    fail(messageOrError) {
        (0, $fGzMp.getExperienceTracker)().fail({
            name: (0, $irVI7.CONNECT_REFERENTIALITY_EXPERIENCE),
            error: $b8656fd966301400$var$getError(messageOrError)
        });
    }
}();
module.exports["ConnectReferentialityExperienceTrackerSupport"] = $b8656fd966301400$export$9e19abdf0a0245fe;

});

parcelRegister("31KN8", function(module, exports) {

let $2345c2ebf53cd779$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2345c2ebf53cd779$var$load("iEvs6").then(()=>parcelRequire('bppNh'));

});

parcelRegister("iQhLj", function(module, exports) {
/* eslint-disable no-console */ 
var $6mKj3 = parcelRequire("6mKj3");


var $cpjd2 = parcelRequire("cpjd2");

class $172ec9aa4291f34d$export$65a835712c7fb845 {
    static init(hostAPI, logger) {
        if (this.macroActions === null) {
            const getMacroId = (arg)=>{
                const macroId = arg?._context?.extension?.options?.productContext?.['macro.id'];
                if (!macroId) throw new Error('No macro ID found in the call.');
                return macroId;
            };
            const getEditorAction = (methodName, macroId)=>{
                const cachedMacro = this.macrosCache.get(macroId);
                if (typeof cachedMacro?.actions?.[methodName] !== 'function') throw new Error('Failed to execute this method. Please ensure that you are calling this method from within a multi-body extension inside your Connect application.');
                return cachedMacro.actions[methodName];
            };
            const assertNotReadonly = (macroId)=>{
                const cachedMacro = this.macrosCache.get(macroId);
                if (cachedMacro && cachedMacro.readonly) throw new Error('This method is not allowed in view mode');
                return true;
            };
            /**
       * Adding extra param to function ({returnPromise: true}) to let Connect know that
       * it returns Promise
       */ const prepareModuleFunction = (moduleFn)=>{
                return Object.assign(moduleFn, {
                    returnsPromise: true
                });
            };
            this.macroActions = {
                addBody: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const addChild = getEditorAction('addChild', macroId);
                        return Promise.resolve(addChild());
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                removeBody: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || typeof args[0] !== 'number') throw new Error('The removeBody method expects an index number as its argument.');
                        const [index, context] = args;
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const removeChild = getEditorAction('removeChild', macroId);
                        return Promise.resolve(removeChild(index));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                showBody: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || typeof args[0]?.body !== 'number' || typeof args[0]?.frame !== 'number') throw new Error('The showBody method expects an object with body and frame properties as its argument.');
                        const [indexes, context] = args;
                        const macroId = getMacroId(context);
                        const changeActive = getEditorAction('changeActive', macroId);
                        return Promise.resolve(changeActive(indexes.body, {
                            selection: 'end'
                        }));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                getBodyCount: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        const getChildrenCount = getEditorAction('getChildrenCount', macroId);
                        return Promise.resolve(getChildrenCount());
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                getParameters: prepareModuleFunction((...args)=>{
                    try {
                        const context = args[args.length - 1];
                        const macroId = getMacroId(context);
                        const cachedMacro = this.macrosCache.get(macroId);
                        if (!cachedMacro) throw new Error('Failed to execute this method. Please ensure that you are calling this method from within a multi-body extension inside your Connect application.');
                        return Promise.resolve(JSON.parse(cachedMacro.parameters));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                }),
                updateParameters: prepareModuleFunction((...args)=>{
                    try {
                        if (args.length !== 2 || !args[0] || typeof args[0] !== 'object') throw new Error('The updateParameters method expects an object with macro parameters as its argument.');
                        const [parameters, context] = args;
                        const macroId = getMacroId(context);
                        assertNotReadonly(macroId);
                        const updateParameters = getEditorAction('updateParameters', macroId);
                        // The platform `updateParameters` now spreads its argument directly
                        // into `node.attrs.parameters` (instead of nesting it under
                        // `macroParams`). Behind the Native Tabs feature gate we use
                        // the new shape; outside the gate we wrap the Connect macro's
                        // parameters in `{ macroParams }` so the final node-attr shape
                        // matches the pre-change behaviour and existing Connect macros
                        // keep working.
                        const payload = (0, $6mKj3.expVal)('confluence_native_tabs_experiment', 'isEnabled', false) ? parameters : {
                            macroParams: parameters
                        };
                        return Promise.resolve(updateParameters(payload));
                    } catch (e) {
                        logger.warn(e.toString());
                        return Promise.reject(e);
                    }
                })
            };
        }
        if (!hostAPI.isModuleDefined(this.macroName)) hostAPI.defineModule(this.macroName, this.macroActions);
    }
    static register(macroId, macroParams, editorActions, readonly) {
        if (!this.macrosCache.has(macroId)) this.macrosCache.set(macroId, {
            actions: editorActions,
            parameters: macroParams,
            readonly: readonly
        });
    }
    static deregister(macroId) {
        if (this.macrosCache.has(macroId)) this.macrosCache.delete(macroId);
    }
    static cleanCache() {
        this.macrosCache.clear();
    }
}
$172ec9aa4291f34d$export$65a835712c7fb845.macroName = 'macro';
$172ec9aa4291f34d$export$65a835712c7fb845.macroActions = null;
$172ec9aa4291f34d$export$65a835712c7fb845.macrosCache = new Map();
const $172ec9aa4291f34d$export$f3a2903499008e78 = async ({ logger: logger })=>{
    await new Promise((resolve)=>{
        (0, $cpjd2.requireLegacyWRM)([
            'wr!confluence.web.resources:querystring',
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            const connectHost = window['connectHost'];
            if (!connectHost) {
                logger.error`ConnectHost is not available to init macro module`;
                resolve();
                return;
            }
            $172ec9aa4291f34d$export$65a835712c7fb845.init(connectHost, logger);
            resolve();
        }, ()=>{
            logger.error`Error loading WRM for macro module!`;
            resolve();
        });
    });
};
module.exports["ConnectMacroModule"] = $172ec9aa4291f34d$export$65a835712c7fb845;
module.exports["defineMacroModule"] = $172ec9aa4291f34d$export$f3a2903499008e78;

});

parcelRegister("jShOo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $iQhLj = parcelRequire("iQhLj");

const $24172b2397b2d142$export$13124d26de07dad1 = ({ macroId: macroId, macroParams: macroParams, editorActions: editorActions, readonly: readonly = false })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!editorActions) {
            (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`No editor actions has been provided to MultiBodiedExtensionHandler for macro ${macroId}.`), {
                attribution: (0, $3IBnw.Attribution).ECOSYSTEM
            });
            return;
        }
        (0, $iQhLj.ConnectMacroModule).register(macroId, macroParams, editorActions, readonly);
        return ()=>{
            (0, $iQhLj.ConnectMacroModule).deregister(macroId);
        };
    }, [
        macroId,
        macroParams,
        editorActions,
        readonly
    ]);
    return null;
};
module.exports["MultiBodiedExtensionHandler"] = $24172b2397b2d142$export$13124d26de07dad1;

});

parcelRegister("7lgkH", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $9rgEf = parcelRequire("9rgEf");


var $6mKj3 = parcelRequire("6mKj3");


var $ep3mz = parcelRequire("ep3mz");


var $5kjCz = parcelRequire("5kjCz");


var $bQm3c = parcelRequire("bQm3c");


var $dwS6P = parcelRequire("dwS6P");

// The legacy server-side TOC plugin looks for this class and mutates the DOM via jQuery.
// We use it only to find the original server-rendered node, then replace that node entirely
// with a neutral mount node so the legacy plugin no longer owns the DOM subtree.
const $dc91df7f3e8c95ce$var$LEGACY_TOC_SELECTOR = '.client-side-toc-macro[data-macro-id]';
// This selector is for the replacement mount node we create ourselves after swapping out the
// legacy server-rendered TOC node. It lets subsequent effect runs find and reuse the
// frontend-owned node instead of trying to replace the original server-rendered TOC again.
const $dc91df7f3e8c95ce$var$HYDRATED_TOC_MOUNT_SELECTOR = '[data-fe-toc-mount="true"][data-macro-id]';
/**
 * Walk the migrated section ADF to find the nested TOC node that matches the server-rendered
 * TOC node we discovered in the DOM. That lets us preserve the original TOC params when we
 * re-render it on the frontend.
 */ const $dc91df7f3e8c95ce$var$findNestedTocNodeByMacroId = (node, macroId)=>{
    if (!node || !macroId) return null;
    const nodeMacroId = node?.attrs?.parameters?.macroMetadata?.macroId?.value;
    if (node?.attrs?.extensionKey === 'toc' && nodeMacroId === macroId) return node;
    for (const child of node?.content || []){
        const nestedMatch = $dc91df7f3e8c95ce$var$findNestedTocNodeByMacroId(child, macroId);
        if (nestedMatch) return nestedMatch;
    }
    const nestedContent = node?.attrs?.parameters?.nestedContent;
    if (nestedContent) return $dc91df7f3e8c95ce$var$findNestedTocNodeByMacroId(nestedContent, macroId);
    return null;
};
const $dc91df7f3e8c95ce$export$37d8cb6da62a6bbd = (t0)=>{
    const $ = (0, $bDgLe.c)(27);
    const { container: container, sectionNode: sectionNode, contentId: contentId, spaceKey: spaceKey, references: references } = t0;
    const pageDocument = (0, $cozmU.useContext)((0, $9rgEf.PageDocumentContext));
    const [pageContentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== contentId || $[1] !== pageContentId || $[2] !== pageDocument) {
        t1 = (!contentId || contentId !== pageContentId) && (0, $6mKj3.expValEquals)("toc_macro_receive_full_page_headings_exp", "isEnabled", true) ? undefined : pageDocument;
        $[0] = contentId;
        $[1] = pageContentId;
        $[2] = pageDocument;
        $[3] = t1;
    } else t1 = $[3];
    const fullPageDocument = t1;
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[4] = t2;
    } else t2 = $[4];
    const [tocMounts, setTocMounts] = (0, $cozmU.useState)(t2);
    let t3;
    let t4;
    if ($[5] !== container || $[6] !== fullPageDocument || $[7] !== sectionNode) {
        t3 = ()=>{
            if (!container || !fullPageDocument) {
                setTocMounts([]);
                return;
            }
            const nextTocMounts = [];
            container.querySelectorAll(`${$dc91df7f3e8c95ce$var$LEGACY_TOC_SELECTOR}, ${$dc91df7f3e8c95ce$var$HYDRATED_TOC_MOUNT_SELECTOR}`).forEach((tocElement)=>{
                const macroId = tocElement.dataset.macroId || "";
                const tocNode = $dc91df7f3e8c95ce$var$findNestedTocNodeByMacroId(sectionNode, macroId);
                if (!macroId || !tocNode) return;
                let mountNode;
                if (tocElement.dataset.feTocMount === "true") mountNode = tocElement;
                else {
                    mountNode = document.createElement("div");
                    mountNode.dataset.feTocMount = "true";
                    mountNode.dataset.macroId = macroId;
                    tocElement.parentNode?.replaceChild(mountNode, tocElement);
                }
                nextTocMounts.push({
                    macroId: macroId,
                    mountNode: mountNode,
                    tocNode: tocNode
                });
            });
            setTocMounts(nextTocMounts);
        };
        t4 = [
            container,
            fullPageDocument,
            sectionNode
        ];
        $[5] = container;
        $[6] = fullPageDocument;
        $[7] = sectionNode;
        $[8] = t3;
        $[9] = t4;
    } else {
        t3 = $[8];
        t4 = $[9];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    if (!fullPageDocument || tocMounts.length === 0) return null;
    let t5;
    if ($[10] !== cloudId || $[11] !== contentId || $[12] !== fullPageDocument || $[13] !== references || $[14] !== spaceKey || $[15] !== tocMounts || $[16] !== userId) {
        let t6;
        if ($[18] !== cloudId || $[19] !== contentId || $[20] !== fullPageDocument || $[21] !== references || $[22] !== spaceKey || $[23] !== userId) {
            t6 = (t7)=>{
                const { macroId: macroId_0, mountNode: mountNode_0, tocNode: tocNode_0 } = t7;
                const macroDefaultProps = {
                    node: tocNode_0,
                    references: references,
                    contentId: contentId || "",
                    spaceKey: spaceKey || "",
                    mode: (0, $5kjCz.RENDERER),
                    extensionKey: "toc",
                    attributes: {
                        macroId: macroId_0,
                        extensionKey: "toc"
                    }
                };
                return /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dwS6P.TableOfContentsLoader), {
                    adf: fullPageDocument,
                    cloudId: cloudId || "",
                    userId: userId || "",
                    macroDefaultProps: macroDefaultProps,
                    isInEditMode: false
                }), mountNode_0, macroId_0);
            };
            $[18] = cloudId;
            $[19] = contentId;
            $[20] = fullPageDocument;
            $[21] = references;
            $[22] = spaceKey;
            $[23] = userId;
            $[24] = t6;
        } else t6 = $[24];
        t5 = tocMounts.map(t6);
        $[10] = cloudId;
        $[11] = contentId;
        $[12] = fullPageDocument;
        $[13] = references;
        $[14] = spaceKey;
        $[15] = tocMounts;
        $[16] = userId;
        $[17] = t5;
    } else t5 = $[17];
    let t6;
    if ($[25] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t5);
        $[25] = t5;
        $[26] = t6;
    } else t6 = $[26];
    return t6;
};
module.exports["NestedLegacyTocHydrator"] = $dc91df7f3e8c95ce$export$37d8cb6da62a6bbd;

});

parcelRegister("9rgEf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $730c064714609652$export$4842845a3bdb74f6 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $730c064714609652$export$aa899bf2529ccb2 = $730c064714609652$export$4842845a3bdb74f6.Provider;
module.exports["PageDocumentContext"] = $730c064714609652$export$4842845a3bdb74f6;
module.exports["PageDocumentProvider"] = $730c064714609652$export$aa899bf2529ccb2;

});

parcelRegister("dwS6P", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $f07e1d0389c2db40$export$4b3001e460e8e078 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CSP7X",
    name: "TableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("sFU68"))).TableOfContents
});

const $f07e1d0389c2db40$export$fa76cea84aad7618 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "JVXm_",
    name: "LazyTableOfContentsLoader",
    loader: async ()=>(await (parcelRequire("sFU68"))).TableOfContents
});
module.exports["TableOfContentsLoader"] = $f07e1d0389c2db40$export$4b3001e460e8e078;
module.exports["LazyTableOfContentsLoader"] = $f07e1d0389c2db40$export$fa76cea84aad7618;

});

parcelRegister("sFU68", function(module, exports) {

let $05631edcbabebe2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $05631edcbabebe2e$var$load("7Rf3l"),
    $05631edcbabebe2e$var$load("aRCaA"),
    $05631edcbabebe2e$var$load("h3Rq9"),
    $05631edcbabebe2e$var$load("eF92L"),
    $05631edcbabebe2e$var$load("jwMHX"),
    $05631edcbabebe2e$var$load("gaUhx"),
    $05631edcbabebe2e$var$load("fWCBZ"),
    $05631edcbabebe2e$var$load("6wr18"),
    $05631edcbabebe2e$var$load("5EJB0"),
    $05631edcbabebe2e$var$load("bqdgP"),
    $05631edcbabebe2e$var$load("i7NGK"),
    $05631edcbabebe2e$var$load("ffEVr"),
    $05631edcbabebe2e$var$load("fYx6U"),
    $05631edcbabebe2e$var$load("botpL"),
    $05631edcbabebe2e$var$load("excC5"),
    $05631edcbabebe2e$var$load("8bEF3"),
    $05631edcbabebe2e$var$load("gRItA"),
    $05631edcbabebe2e$var$load("l4j2l"),
    $05631edcbabebe2e$var$load("37v60"),
    $05631edcbabebe2e$var$load("cGkFm"),
    $05631edcbabebe2e$var$load("f6ZVy"),
    $05631edcbabebe2e$var$load("20wSi"),
    $05631edcbabebe2e$var$load("bmOOW"),
    $05631edcbabebe2e$var$load("dDiWc"),
    $05631edcbabebe2e$var$load("d0ZRF"),
    $05631edcbabebe2e$var$load("k507P"),
    $05631edcbabebe2e$var$load("fwbNS"),
    $05631edcbabebe2e$var$load("ckGjo"),
    $05631edcbabebe2e$var$load("gFeoL"),
    $05631edcbabebe2e$var$load("6iTkp"),
    $05631edcbabebe2e$var$load("hhss7"),
    $05631edcbabebe2e$var$load("aAWLw"),
    $05631edcbabebe2e$var$load("jjWia")
]).then(()=>parcelRequire('c8BWz'));

});

parcelRegister("gnzsm", function(module, exports) {
const $fb43f474e41c0e5b$export$5a7bc2ce53981a17 = (getHeadingLinkPath, headingId)=>{
    const path = getHeadingLinkPath?.();
    if (!path) return undefined;
    // `window.location` is not available during SSR; heading links are only meaningful client-side.
    if (typeof window.location === 'undefined') return undefined;
    const url = new URL(window.location.origin + path);
    url.hash = encodeURIComponent(headingId);
    return url.toString();
};
module.exports["createHeadingLink"] = $fb43f474e41c0e5b$export$5a7bc2ce53981a17;

});

parcelRegister("l4pUK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $euF5O = parcelRequire("euF5O");


var $5Qu6D = parcelRequire("5Qu6D");

const $e8626124813ef422$var$AC_NS = 'ac-xml-namespace';
/**
 * Parses macroBodyStorage XML and returns the document.
 * Wraps in a root element with namespace declarations so ac:/ri: prefixed tags are valid XML.
 */ function $e8626124813ef422$var$parseStorageXml(storageXml) {
    if (!storageXml) return null;
    try {
        const wrapped = `<root xmlns:ac="${$e8626124813ef422$var$AC_NS}" xmlns:ri="${$e8626124813ef422$var$AC_NS}">${storageXml}</root>`;
        const doc = new DOMParser().parseFromString(wrapped, 'text/xml');
        // DOMParser does not throw on parse errors — it returns a document containing
        // a <parsererror> element. Detect and discard these silently.
        if (doc.querySelector('parsererror')) return null;
        return doc;
    } catch  {
        return null;
    }
}
/**
 * Recursively renders a storage XML node as React nodes.
 * - <ac:structured-macro> → <UnknownMacroPlaceholder> with recursive children
 * - <ac:parameter> → skipped (metadata, not body content)
 * - <ac:rich-text-body> / <ac:plain-text-body> → recurse into children
 * - Text/CDATA nodes → plain text string
 * - Everything else → recurse into children
 */ function $e8626124813ef422$var$renderStorageNode(node, key) {
    // TEXT_NODE (3) and CDATA_SECTION_NODE (4) both contain plain text content
    if (node.nodeType === Node.TEXT_NODE || node.nodeType === Node.CDATA_SECTION_NODE) return node.textContent?.trim() || null;
    if (node.nodeType !== Node.ELEMENT_NODE) return null;
    const el = node;
    // Skip parameter nodes — metadata only, not body content
    if (el.localName === 'parameter') return null;
    // Structured macro → render as a nested UnknownMacroPlaceholder
    if (el.localName === 'structured-macro') {
        const macroName = el.getAttributeNS($e8626124813ef422$var$AC_NS, 'name') ?? 'unknown';
        const children = $e8626124813ef422$var$renderStorageChildren(el);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Qu6D.UnknownMacroPlaceholder), {
            key: key,
            macroTitle: macroName
        }, children);
    }
    // For all other elements (rich-text-body, plain-text-body, p, etc.) recurse into children
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
        key: key
    }, $e8626124813ef422$var$renderStorageChildren(el));
}
function $e8626124813ef422$var$renderStorageChildren(node) {
    const children = [];
    node.childNodes.forEach((child, i)=>{
        const rendered = $e8626124813ef422$var$renderStorageNode(child, i);
        if (rendered !== null) children.push(rendered);
    });
    return children.length ? children : null;
}
/**
 * Builds React children for the Nth top-level <ac:structured-macro> in the storage document.
 * macroBodyStorage is the body content of the outer macro — each top-level structured-macro
 * in it corresponds to one wysiwyg-unknown-macro img in the rendered HTML, in document order.
 * If there are no top-level structured-macros (plain body content), render everything directly.
 */ function $e8626124813ef422$var$buildBodyForImg(doc, imgIndex) {
    const topLevelMacros = [];
    doc.documentElement.childNodes.forEach((child)=>{
        if (child.nodeType === Node.ELEMENT_NODE && child.localName === 'structured-macro') topLevelMacros.push(child);
    });
    if (topLevelMacros.length > 0) {
        const macro = topLevelMacros[imgIndex];
        if (!macro) return null;
        return $e8626124813ef422$var$renderStorageChildren(macro);
    }
    // No top-level structured-macros — storage is plain body content, render directly.
    // Only for the first img (index 0) since there's only one body.
    if (imgIndex === 0) return $e8626124813ef422$var$renderStorageChildren(doc.documentElement);
    return null;
}
/**
 * Extracts the macro name from a wysiwyg-unknown-macro img src URL.
 * The src contains a `name=` query parameter with the macro name.
 * Returns null if not found
 */ function $e8626124813ef422$var$getMacroNameFromImg(img) {
    try {
        const url = new URL(img.src, window.location.origin);
        return url.searchParams.get('name');
    } catch  {
        return null;
    }
}
function $e8626124813ef422$export$1172566723f24fd4({ container: container, macroBodyStorage: macroBodyStorage }) {
    const { shouldRenderUnknownMacro: shouldRenderUnknownMacro } = (0, $cozmU.useContext)((0, $euF5O.LegacyMacroRendererContext));
    const [portalTargets, setPortalTargets] = (0, $cozmU.useState)([]);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldRenderUnknownMacro || !container || !macroBodyStorage) return;
        const imgs = container.querySelectorAll('img.wysiwyg-unknown-macro');
        if (!imgs.length) return;
        const doc = $e8626124813ef422$var$parseStorageXml(macroBodyStorage);
        if (!doc) return;
        const targets = [];
        imgs.forEach((img, imgIndex)=>{
            const title = $e8626124813ef422$var$getMacroNameFromImg(img);
            if (!title) return;
            const body = $e8626124813ef422$var$buildBodyForImg(doc, imgIndex);
            if (body === null) return;
            // Replace each img with a div that becomes the portal target.
            // This preserves the surrounding HTML tree structure completely.
            const placeholder = document.createElement('div');
            img.replaceWith(placeholder);
            targets.push({
                el: placeholder,
                title: title,
                body: body
            });
        });
        setPortalTargets(targets);
        return ()=>{
            setPortalTargets([]);
        };
    }, [
        container,
        macroBodyStorage,
        shouldRenderUnknownMacro
    ]);
    if (!portalTargets.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, portalTargets.map(({ el: el, title: title, body: body }, i)=>/*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Qu6D.UnknownMacroPlaceholder), {
            macroTitle: title
        }, body), el, String(i))));
}
module.exports["useUnknownMacroPortal"] = $e8626124813ef422$export$1172566723f24fd4;

});

parcelRegister("euF5O", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $914eacf4cf3bd652$export$26c05f52dcf7c5f2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    shouldRefetchMacroQuery: false
});
module.exports["LegacyMacroRendererContext"] = $914eacf4cf3bd652$export$26c05f52dcf7c5f2;

});

parcelRegister("5Qu6D", function(module, exports) {
/* UnknownMacroPlaceholder.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");

const $0508843a879c075e$var$wrapperStyles = null;
const $0508843a879c075e$var$labelStyles = null;
const $0508843a879c075e$var$bodyStyles = null;
function $0508843a879c075e$export$414b5225f50e455b({ macroTitle: macroTitle, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_1mT5xdRAKS _313842NHnM"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            "_2OUyjtcDWF _2C2kUQKxmn _1Lz9loKxmn _41LZZBMRGa _2XsHFM5zaO _0adFHsFQfX _2Zuz6QFQfX _1ZnuxbFQfX _0Of8r2Ll21 _1wydGWLl21 _1mT5xdWVPG _2IhTonOHDs"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "small"
    }, macroTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _4FKVYE1Y8M _4bt5LAYvD1 _2WAcuGYvD1 _2OUyjtcDWF _2XsHFMFQfX _0adFHsFQfX _1DCdHi2ADO _313842Va5s _1EqgXlN91d"
        ])
    }, children));
}
module.exports["UnknownMacroPlaceholder"] = $0508843a879c075e$export$414b5225f50e455b;

});

parcelRegister("9L50P", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1i7uI = parcelRequire("1i7uI");


var $9DHhW = parcelRequire("9DHhW");


var $gEtAQ = parcelRequire("gEtAQ");

const $b1fc10dfab719594$var$extractExtensionKey = (extensionId)=>{
    const split = extensionId.split('__');
    if (split.length === 3) return split[1];
    return 'UNKOWN_EXTENSION_KEY';
};
const $b1fc10dfab719594$var$sendReferenceData = (references, extensionId, createAnalyticsEvent)=>{
    const eventName = 'data_provider';
    const addonFilter = {
        id: extensionId
    };
    const eventData = {
        eventData: references
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            containerType: 'page',
            objectType: 'connectAddon',
            source: (0, $gEtAQ.isViewPage)() ? 'viewPageScreen' : 'editPageScreen',
            action: 'broadcasted',
            actionSubject: 'connectRefEventData',
            attributes: {
                extensionKey: $b1fc10dfab719594$var$extractExtensionKey(extensionId)
            }
        }
    });
    analyticsEvent.fire();
    // @ts-ignore
    (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).connectHost.broadcastEvent(eventName, addonFilter, eventData);
};
const $b1fc10dfab719594$export$b2f0fd57401a56fe = ({ references: references, macroContainer: macroContainer })=>{
    const [extensionId, setExtensionId] = (0, $cozmU.useState)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        if (extensionId && Array.isArray(references) && references.length > 0) $b1fc10dfab719594$var$sendReferenceData(references, extensionId, createAnalyticsEvent);
    }, [
        references,
        extensionId,
        createAnalyticsEvent
    ]);
    const listeningForInitialization = (0, $cozmU.useCallback)((event)=>{
        if (event.data?.type !== 'event_query' || !event.data?.eid || !event.data?.args?.includes?.('data_provider')) return;
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const iframeEl = document.getElementById(event.data.eid);
        if (iframeEl && macroContainer?.contains?.(iframeEl)) setExtensionId(event.data.eid);
    }, [
        macroContainer,
        setExtensionId
    ]);
    // Starts listening for macro initialization
    (0, $cozmU.useEffect)(()=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).addEventListener('message', listeningForInitialization);
        return ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).removeEventListener('message', listeningForInitialization);
        };
    }, [
        listeningForInitialization
    ]);
    return null;
};
module.exports["LegacyMacroReferenceListener"] = $b1fc10dfab719594$export$b2f0fd57401a56fe;

});

parcelRegister("4BMhZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iMnC5 = parcelRequire("iMnC5");


var $lMGh1 = parcelRequire("lMGh1");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");

const $bd422ab26f8348d3$export$99a6d9338f38339e = ({ error: error, mode: mode, extensionKey: extensionKey, node: node, contentId: contentId })=>{
    const attributes = (0, $5kjCz.getMacroAttributesFromADFNode)(node);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hUS75.MacroExperienceStop), {
        extensionKey: extensionKey,
        error: error || Error(`Unable to render ${extensionKey}`),
        mode: mode,
        attributes: attributes,
        contentId: contentId,
        name: (0, $5kjCz.getExperienceName)(mode, node),
        source: "LegacyMacroRendererError"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: 5,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 200,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: "var(--ds-space-050, 4px)"
        },
        "data-testid": "legacy-macro-renderer-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "fabric-extension-legacy-macro-renderer.legacymacrorenderer.error",
        defaultMessage: "Failed to get macro details"
    }))));
};
module.exports["LegacyMacroRendererError"] = $bd422ab26f8348d3$export$99a6d9338f38339e;

});

parcelRegister("aQw7y", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3jwuS = parcelRequire("3jwuS");


var $j0gZR = parcelRequire("j0gZR");


var $1xpoY = parcelRequire("1xpoY");

const $9d7353a17557989b$export$27f1b40a08e363aa = (extensionKey, isBodiedExtension)=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    return (0, $cozmU.useMemo)(()=>{
        if (!extensionKey) return false;
        const is2PNonBodied = !(0, $j0gZR.is1PMacro)(extensionKey) && !isBodiedExtension;
        if (is2PNonBodied || isLivePage) return true;
        const extensionsToHideOverlays = (0, $1xpoY.default).getStringList('confluence_frontend_extension_overlay_removal_list', []);
        if (extensionsToHideOverlays.length === 0) return false;
        if (extensionsToHideOverlays[0] === 'ALLOW_ALL') return true;
        const extensionKeys = extensionsToHideOverlays.map((ext)=>ext.trim().toLowerCase());
        return extensionKeys.includes(extensionKey.toLowerCase());
    }, [
        extensionKey,
        isLivePage,
        isBodiedExtension
    ]);
};
module.exports["useShouldHideOverlay"] = $9d7353a17557989b$export$27f1b40a08e363aa;

});

parcelRegister("brT00", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1xpoY = parcelRequire("1xpoY");

const $622a0e8eee3d2f68$var$canOpenInNewTab = (href)=>{
    if (!href) // e.g., "Refresh" link in jira issue macro
    return false;
    const url = new URL(href);
    if (url.origin !== window.location.origin) return true;
    else if (url.pathname.includes('/wiki/rest/api')) return false;
    else if (url.pathname.includes('changes.action')) // e.g., "Show More" link in the recently updated macro
    return false;
    else if (url.pathname.includes('confirmattachmentremoval.action')) // e.g., "Delete" link in the attachments macro
    return false;
    else if (url.pathname.includes('.action')) // Most .action links should open in a new tab
    return true;
    else return true;
};
const $622a0e8eee3d2f68$export$5f4b0c82ca04cc0c = (extensionKey, container, isEditor)=>{
    const extensionsToOpenLinksInNewTab = (0, $cozmU.useMemo)(()=>{
        const extensionSet = new Set();
        if (!isEditor) return extensionSet;
        const allowlist = (0, $1xpoY.default).getStringList('confluence_frontend_macro_links_new_tab_allowlist', []);
        allowlist.map((ext)=>ext.trim().toLowerCase()).forEach((ext)=>ext && extensionSet.add(ext));
        return extensionSet;
    }, [
        isEditor
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Short circuit if we're not in the editor or the container is falsey
        if (!isEditor || !container) return;
        // Only intercept links in the FF allowlist
        if (!extensionsToOpenLinksInNewTab?.has(extensionKey.toLowerCase())) return;
        function interceptLinkClick(ev) {
            const anchor = ev?.target;
            // Only intercept clicks on anchor tags
            if (anchor?.tagName !== 'A') return;
            if (!$622a0e8eee3d2f68$var$canOpenInNewTab(anchor.href)) return;
            ev.preventDefault();
            window.open(anchor.href, '_blank', 'noopener, noreferrer');
        }
        container.addEventListener('click', interceptLinkClick);
        return ()=>{
            // Remove the event listener when the component unmounts
            container.removeEventListener('click', interceptLinkClick);
        };
    }, [
        container,
        extensionsToOpenLinksInNewTab,
        extensionKey,
        isEditor
    ]);
};
module.exports["useLinkIntercept"] = $622a0e8eee3d2f68$export$5f4b0c82ca04cc0c;

});

parcelRegister("78b5K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $4e3f9bd15d15e68b$var$observedContainers = new WeakSet();
function $4e3f9bd15d15e68b$export$4fda4c6da8145997(container, shimUrl) {
    $4e3f9bd15d15e68b$var$observedContainers.add(container);
    const rewrite = (anchor)=>{
        for(let parent = anchor.parentElement; parent && parent !== container; parent = parent.parentElement){
            if ($4e3f9bd15d15e68b$var$observedContainers.has(parent)) return;
        }
        const href = anchor.getAttribute('href');
        if (!container.contains(anchor) || !href || href.startsWith('#') || anchor.target === '_self' || anchor.closest('.ProseMirror, [contenteditable="true"], [data-smart-link-container]')) return;
        const converted = shimUrl(anchor.href);
        if (converted !== anchor.href) anchor.setAttribute('href', converted);
    };
    const scan = (node)=>{
        if (node instanceof HTMLAnchorElement) rewrite(node);
        node.querySelectorAll('a[href]').forEach(rewrite);
    };
    const observer = new MutationObserver((records)=>{
        const added = new Set();
        const changed = new Set();
        for (const record of records)if (record.type === 'attributes' && record.target instanceof HTMLAnchorElement) changed.add(record.target);
        else record.addedNodes.forEach((node)=>{
            if (node instanceof Element && container.contains(node)) added.add(node);
        });
        for (const node of added){
            let parent = node.parentElement;
            while(parent && parent !== container && !added.has(parent))parent = parent.parentElement;
            if (!parent || !added.has(parent)) scan(node);
        }
        changed.forEach(rewrite);
    });
    observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            'href'
        ]
    });
    scan(container);
    return ()=>{
        observer.disconnect();
        $4e3f9bd15d15e68b$var$observedContainers.delete(container);
    };
}
function $4e3f9bd15d15e68b$export$be33a9338c4b74cc({ container: container, shimUrl: shimUrl, enabled: enabled }) {
    (0, $cozmU.useEffect)(()=>{
        if (!container || !enabled) return;
        return $4e3f9bd15d15e68b$export$4fda4c6da8145997(container, shimUrl);
    }, [
        container,
        shimUrl,
        enabled
    ]);
}
module.exports["useShimLegacyMacroLinks"] = $4e3f9bd15d15e68b$export$be33a9338c4b74cc;

});

parcelRegister("4OwbJ", function(module, exports) {
/**
 * Extract all data-wrm-key attribute values from webresource.tags.js.
 * Handles script tags like <script ... data-wrm-key="confluence.web.resources:event" ...></script>
 * and returns a string[] of the keys (e.g. ["confluence.web.resources:event", "confluence.web.resources:connect-helper", ...]).
 */ const $7466b2401803d953$export$c00afb1bef80592 = (tagsJs)=>{
    if (!tagsJs || typeof tagsJs !== 'string') return [];
    const keys = [];
    const pattern = /data-wrm-key=["']([^"']+)["']/g;
    let match;
    while((match = pattern.exec(tagsJs)) !== null)keys.push(match[1]);
    return keys;
};
module.exports["parseWrmKeysFromTagsJs"] = $7466b2401803d953$export$c00afb1bef80592;

});

parcelRegister("goE1t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $8nJmU = parcelRequire("8nJmU");


var $3tQpd = parcelRequire("3tQpd");

const $551fe95be1481ef7$export$8af47b3ba0f9b00e = ({ contentId: contentId, delayedOutput: delayedOutput, extensionKey: extensionKey, isConnectMacro: isConnectMacro, isRendererMode: isRendererMode, macroId: macroId, macroOutput: macroOutput, macroRenderedOutputFromSSR: macroRenderedOutputFromSSR })=>{
    const connectStaticMacroRenderExperienceResolved = (0, $cozmU.useRef)(false);
    const officeMacroRenderExperienceResolved = (0, $cozmU.useRef)(false);
    const isUsingServerRenderedMacroOutput = Boolean(macroRenderedOutputFromSSR || macroOutput);
    const hasOfficeMacroRenderedOutput = Boolean(delayedOutput || macroRenderedOutputFromSSR || macroOutput);
    (0, $cozmU.useEffect)(()=>{
        if (connectStaticMacroRenderExperienceResolved.current || !isRendererMode || isUsingServerRenderedMacroOutput) return;
        const connectStaticMacroRenderData = {
            contentId: contentId,
            extensionKey: extensionKey,
            macroId: macroId,
            isConnectMacro: isConnectMacro,
            macroRenderedOutput: delayedOutput
        };
        if (!(0, $6mKj3.expVal)('confluence_frontend_macro_slo_metrics', 'isEnabled', false)) return;
        let shouldTrackConnectStaticMacroRender = false;
        try {
            shouldTrackConnectStaticMacroRender = (0, $3tQpd.ConnectStaticMacroExperienceTrackerSupport).isTrackable(connectStaticMacroRenderData);
        } catch  {
            shouldTrackConnectStaticMacroRender = false;
        }
        if (!shouldTrackConnectStaticMacroRender) return;
        try {
            (0, $3tQpd.ConnectStaticMacroExperienceTrackerSupport).start(connectStaticMacroRenderData);
            (0, $3tQpd.ConnectStaticMacroExperienceTrackerSupport).succeed();
        } catch  {
        // Telemetry must never block or alter macro rendering behaviour.
        } finally{
            connectStaticMacroRenderExperienceResolved.current = true;
        }
    }, [
        contentId,
        delayedOutput,
        extensionKey,
        isConnectMacro,
        isRendererMode,
        isUsingServerRenderedMacroOutput,
        macroId
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (officeMacroRenderExperienceResolved.current || !isRendererMode || !(0, $6mKj3.expVal)('confluence_frontend_macro_slo_metrics', 'isEnabled', false)) return;
        const officeMacroRenderData = {
            macroName: extensionKey
        };
        let shouldTrackOfficeMacroRender = false;
        try {
            shouldTrackOfficeMacroRender = (0, $8nJmU.OfficeMacroExperienceTrackerSupport).isTrackable(officeMacroRenderData);
        } catch  {
            shouldTrackOfficeMacroRender = false;
        }
        if (!shouldTrackOfficeMacroRender) return;
        if (!hasOfficeMacroRenderedOutput) return;
        try {
            (0, $8nJmU.OfficeMacroExperienceTrackerSupport).start(officeMacroRenderData);
            (0, $8nJmU.OfficeMacroExperienceTrackerSupport).succeed();
        } catch  {
        // Telemetry must never block or alter macro rendering behaviour.
        } finally{
            officeMacroRenderExperienceResolved.current = true;
        }
    }, [
        extensionKey,
        hasOfficeMacroRenderedOutput,
        isRendererMode
    ]);
};
module.exports["useMacroSLOExperienceTracking"] = $551fe95be1481ef7$export$8af47b3ba0f9b00e;

});

parcelRegister("3tQpd", function(module, exports) {

var $irVI7 = parcelRequire("irVI7");


var $fGzMp = parcelRequire("fGzMp");

const $1b852b955f0d2b30$var$containsIframe = (macroRenderedOutput)=>/<iframe(?:\s|>)/i.test(macroRenderedOutput);
const $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience = (track)=>{
    try {
        track();
    } catch  {
    // Telemetry must never block or alter macro rendering behaviour.
    }
};
const $1b852b955f0d2b30$export$7437d350c23fca93 = new class ConnectStaticMacroExperienceTrackerSupport {
    isTrackable(data) {
        const outputContainsIframe = typeof data?.macroRenderedOutput === 'string' ? $1b852b955f0d2b30$var$containsIframe(data.macroRenderedOutput) : false;
        return Boolean(data?.isConnectMacro && data?.macroRenderedOutput && !outputContainsIframe);
    }
    start(data) {
        $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().start({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_RENDER_EXPERIENCE),
                attributes: {
                    contentId: data?.contentId,
                    extensionKey: data?.extensionKey,
                    macroId: data?.macroId
                }
            });
        });
    }
    succeed() {
        $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_RENDER_EXPERIENCE)
            });
        });
    }
    fail(error) {
        $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_RENDER_EXPERIENCE),
                error: error
            });
        });
    }
    abort(reason) {
        $1b852b955f0d2b30$var$safelyTrackConnectStaticMacroExperience(()=>{
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.CONNECT_STATIC_MACRO_RENDER_EXPERIENCE),
                reason: reason
            });
        });
    }
}();
module.exports["ConnectStaticMacroExperienceTrackerSupport"] = $1b852b955f0d2b30$export$7437d350c23fca93;

});

parcelRegister("b7V26", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $3ff9e0546f2c245a$export$1b5865c105cfe12d = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    listOfRenderedPageIncludeNodes: []
});
module.exports["PageIncludeContext"] = $3ff9e0546f2c245a$export$1b5865c105cfe12d;

});

parcelRegister("bD3fd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::57a3a98d1c0cdf17dca67c7ba0624f0f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8775da7cfc706ac1$var$_react = $8775da7cfc706ac1$var$_interopRequireDefault((parcelRequire("cozmU")));

var $8775da7cfc706ac1$var$_iconNew = $8775da7cfc706ac1$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $8775da7cfc706ac1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Jira".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/jira
 * Usage guidance:
 * Representing JIRA
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8775da7cfc706ac1$var$JiraIcon = (props)=>/*#__PURE__*/ $8775da7cfc706ac1$var$_react.default.createElement($8775da7cfc706ac1$var$_iconNew.default, Object.assign({
        name: "JiraIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7 1.25A.75.75 0 0 1 7.75.5h7a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-1.625A2.6 2.6 0 0 1 12 8.747v3.003a.75.75 0 0 1-.75.75H9.625a2.6 2.6 0 0 1-1.125-.253v3.003a.75.75 0 0 1-.75.75H6.125A2.625 2.625 0 0 1 3.5 13.375V12.5h-.875A2.625 2.625 0 0 1 0 9.875V8.25a.75.75 0 0 1 .75-.75h3.003A2.6 2.6 0 0 1 3.5 6.375V4.75A.75.75 0 0 1 4.25 4h3.003A2.6 2.6 0 0 1 7 2.875zM9.625 4h1.625a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125H14V2H8.5v.875C8.5 3.496 9.004 4 9.625 4m.875 1.5H5v.875C5 6.996 5.504 7.5 6.125 7.5H7.75a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125h.875zM7 9H1.5v.875c0 .621.504 1.125 1.125 1.125H4.25a.75.75 0 0 1 .75.75v1.625c0 .621.504 1.125 1.125 1.125H7z" clip-rule="evenodd"/>`
    }, props));
$8775da7cfc706ac1$var$JiraIcon.displayName = 'JiraIcon';
var $8775da7cfc706ac1$var$_default = module.exports.default = $8775da7cfc706ac1$var$JiraIcon;

});

parcelRegister("c2cyb", function(module, exports) {
/* TemplateIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7zsi1 = parcelRequire("7zsi1");


var $arQY7 = parcelRequire("arQY7");


var $cJ0FD = parcelRequire("cJ0FD");


var $kkFbH = parcelRequire("kkFbH");


var $dAyZN = parcelRequire("dAyZN");


var $8nXYN = parcelRequire("8nXYN");

const $41adb9ebadfabbfe$var$iconWrapperStyles = null;
const $41adb9ebadfabbfe$var$imageWrapperStyles = null;
const $41adb9ebadfabbfe$var$InjectedTemplateIcon = ({ template: template, isDisabled: isDisabled = false, size: size = 'medium' })=>{
    if (template.iconURL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-avatar",
        className: (0, $hekY6.default)([
            "_4xdlr0chRC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        appearance: "square",
        size: size,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _3iDTPbQ4SZ _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7zsi1.AvatarContent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        src: template.iconURL || '',
        srcDark: template.darkModeIconURL || ''
    })))));
    else if (template.styleClass) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dAyZN.TemplateLegacyIcon), {
        size: size,
        template: template
    });
    else // Ideally, this code will never be used. However, if the BE response is missing an iconURL for some reason,
    // this will return an icon with a grey background color that looks like the icon for 3rd party templates.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8nXYN.DefaultIcon), {
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
        spacing: "spacious",
        color: "var(--ds-icon-inverse, #FFFFFF)",
        label: ""
    }));
};
// The avatar-item component, which actually renders TemplateIcon, passes a backgroundColor
// prop to the TemplateIcon. The TemplateIcon and InjectedTemplateIcon disregard this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $41adb9ebadfabbfe$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template && prevProps.isDisabled === nextProps.isDisabled && prevProps.size === nextProps.size;
};
const $41adb9ebadfabbfe$export$17f8b5fdc0dde895 = /*#__PURE__*/ (0, $cozmU.memo)($41adb9ebadfabbfe$var$InjectedTemplateIcon, $41adb9ebadfabbfe$var$areEqual);
module.exports["TemplateIcon"] = $41adb9ebadfabbfe$export$17f8b5fdc0dde895;

});

parcelRegister("dAyZN", function(module, exports) {
/* TemplateLegacyIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $c41888ccf34d17d9$var$smallBackgroundSize = null;
const $c41888ccf34d17d9$var$mediumBackgroundSize = null;
const $c41888ccf34d17d9$var$largeBackgroundSize = null;
const $c41888ccf34d17d9$var$smallSize = null;
const $c41888ccf34d17d9$var$mediumSize = null;
const $c41888ccf34d17d9$var$largeSize = null;
const $c41888ccf34d17d9$var$styles = {
    classIconWrapperStyles: "_0aNu0LYbGa",
    classIconStyles: "_0bjKvDzXzM",
    iconStyles: "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
};
const $c41888ccf34d17d9$var$backgroundSizeMapping = {
    small: $c41888ccf34d17d9$var$smallBackgroundSize,
    medium: $c41888ccf34d17d9$var$mediumBackgroundSize,
    large: $c41888ccf34d17d9$var$largeBackgroundSize
};
const $c41888ccf34d17d9$var$sizeMapping = {
    small: $c41888ccf34d17d9$var$smallSize,
    medium: $c41888ccf34d17d9$var$mediumSize,
    large: $c41888ccf34d17d9$var$largeSize
}; // The avatar-item component, which actually renders TemplateLegacyIcon, passes a backgroundColor
// prop to the TemplateLegacyIcon. The TemplateLegacyIcon disregards this backgroundColor
// prop. Therefore, we can ignore the backgroundColor prop for memoization.
const $c41888ccf34d17d9$var$areEqual = (prevProps, nextProps)=>{
    return prevProps.template === nextProps.template;
};
const $c41888ccf34d17d9$export$7da270837ef49506 = /*#__PURE__*/ (0, $cozmU.memo)(({ template: template, size: size = 'medium' })=>{
    const styleClass = template.styleClass || '';
    const itemModuleCompleteKey = template.itemModuleCompleteKey || '';
    const blueprintModuleCompleteKey = template.blueprintModuleCompleteKey || '';
    const contentBlueprintId = template.contentBlueprintId || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("li" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            $c41888ccf34d17d9$var$styles.classIconWrapperStyles,
            "template"
        ]),
        "data-item-module-complete-key": itemModuleCompleteKey,
        "data-blueprint-module-complete-key": blueprintModuleCompleteKey,
        "data-content-blueprint-id": contentBlueprintId,
        "data-testid": "template-icon-legacy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $c41888ccf34d17d9$var$styles.iconStyles,
            "_2QcWTwbGuW _2SqxC464sR _2JgCDVNDbq",
            "_2QcWTwLoGj _2SqxC4BE2a _2JgCDVoynL",
            $c41888ccf34d17d9$var$styles.classIconStyles,
            styleClass
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeSize),
            "--_10y2yj4": (0, $9aYkv.default)($c41888ccf34d17d9$var$smallBackgroundSize),
            "--_b7jail": (0, $9aYkv.default)($c41888ccf34d17d9$var$mediumBackgroundSize),
            "--_w9udt4": (0, $9aYkv.default)($c41888ccf34d17d9$var$largeBackgroundSize)
        }
    }));
}, $c41888ccf34d17d9$var$areEqual);
module.exports["TemplateLegacyIcon"] = $c41888ccf34d17d9$export$7da270837ef49506;

});

parcelRegister("8nXYN", function(module, exports) {
/* TemplateIconStyles.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $cozmU = parcelRequire("cozmU");

const $978a137b0603779d$var$defaultIconCss = null;
const $978a137b0603779d$var$smallSize = null;
const $978a137b0603779d$var$mediumSize = null;
const $978a137b0603779d$var$largeSize = null;
const $978a137b0603779d$var$iconStyles = null;
const $978a137b0603779d$var$sizeMapping = {
    small: $978a137b0603779d$var$smallSize,
    medium: $978a137b0603779d$var$mediumSize,
    large: $978a137b0603779d$var$largeSize
};
const $978a137b0603779d$export$d206ce4c12e8ddf6 = ({ children: children, size: size = 'medium' })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "template-icon-default",
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _0Of8r21Y8M _2fwxA5DIqT _0KLXrurxgm",
            "_2QcWTwbGuW _2SqxC464sR _2JgCDVNDbq",
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _24h04i2Njc _0adFHs1Y8M _3YEZNOdnbC _2O5VijdnbC _4xdlr0chRC _2OUyjtYbGa"
        ]),
        style: {
            "--_1sqmkfg": (0, $9aYkv.default)($978a137b0603779d$var$smallSize),
            "--_1clui7k": (0, $9aYkv.default)($978a137b0603779d$var$mediumSize),
            "--_1ok9ig": (0, $9aYkv.default)($978a137b0603779d$var$largeSize)
        }
    }, children);
};
module.exports["DefaultIcon"] = $978a137b0603779d$export$d206ce4c12e8ddf6;

});

parcelRegister("6Ywr0", function(module, exports) {

var $3d5UI = parcelRequire("3d5UI");

function $bb082ed2371b78b6$export$dfb0c4efd029859d(module) {
    try {
        window.require(module);
        return true;
    } catch (err) {
        return false;
    }
}
function $bb082ed2371b78b6$export$2b551419a2839406({ listener: listener, module: module, interval: interval = 250 }, callback) {
    (0, $3d5UI.waitForGlobal)({
        listener: `wait-for-required-module ${module}`,
        globalProperty: 'require'
    }, ()=>{
        if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
            callback();
            return;
        }
        const waitForRequiredModuleInterval = setInterval(()=>{
            if ($bb082ed2371b78b6$export$dfb0c4efd029859d(module)) {
                clearInterval(waitForRequiredModuleInterval);
                callback();
            }
        }, interval);
    });
}
module.exports["isRequiredModuleLoaded"] = $bb082ed2371b78b6$export$dfb0c4efd029859d;
module.exports["waitForRequiredModule"] = $bb082ed2371b78b6$export$2b551419a2839406;

});

parcelRegister("10Oe6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $dOBRD = parcelRequire("dOBRD");


var $5cryL = parcelRequire("5cryL");


var $iacta = parcelRequire("iacta");


var $ae5hk = parcelRequire("ae5hk");

const $f4c21c880d0229da$var$i18n = (0, $kSwu1.defineMessages)({
    featuredCategoryName: {
        id: "template-utils.featured.category.name",
        defaultMessage: "Featured"
    },
    myTemplatesCategoryName: {
        id: "template-utils.my-templates.category.name",
        defaultMessage: "My Templates"
    },
    starredCategoryName: {
        id: "template-utils.starred.category.name",
        defaultMessage: "Starred"
    },
    promotedCategoryName: {
        id: "template-utils.promoted.category.name",
        defaultMessage: "Promoted"
    }
});
const $f4c21c880d0229da$export$612b286afa12407b = '00000000-0000-0000-0000-000000000001';
const $f4c21c880d0229da$export$3b0b898c62947fee = (templateId)=>!/^[0-9]+$/.test(templateId);
const $f4c21c880d0229da$export$47ee581a4caa8fa2 = (templateId)=>!templateId || templateId === '';
const $f4c21c880d0229da$export$13d482a11efa2b43 = (template)=>{
    return template?.blueprintModuleCompleteKey || template?.templateId || template?.itemModuleCompleteKey || '';
};
const $f4c21c880d0229da$export$c095b4283dffab05 = (template)=>{
    return template.contentBlueprintId || template.templateId || '';
};
const $f4c21c880d0229da$export$3abed2086f3435f9 = (template)=>{
    if (!template) return null;
    if (template.templateType === 'blueprint' && template.hasGlobalBlueprintContent && template.contentBlueprintId !== $f4c21c880d0229da$export$612b286afa12407b) return template.blueprintModuleCompleteKey ?? null;
    return $f4c21c880d0229da$export$c095b4283dffab05(template);
};
const $f4c21c880d0229da$export$f19afdee92cfd543 = (templates, selectedSortOrder)=>{
    const nonFeaturedTemplates = [];
    const promotedTemplates = [];
    const customTemplates = [];
    templates.forEach((template)=>{
        if (template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')) {
            if (!template.categoryIds.includes((0, $iacta.FEATURED_CATEGORY_ID))) template.categoryIds.push((0, $iacta.FEATURED_CATEGORY_ID));
            // We want to show all promoted templates first, regardless of
            // whether or not the template is custom
            if (template.categoryIds.includes('template.category.promoted')) promotedTemplates.push(template);
            else customTemplates.push(template);
        } else nonFeaturedTemplates.push(template);
    });
    // If alphabetical sort is on, we don't care to show featured categories first
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) return [
        ...promotedTemplates,
        ...customTemplates,
        ...nonFeaturedTemplates
    ];
    else return templates;
};
const $f4c21c880d0229da$export$6d6fdbfe01edf136 = (templates, currentUserId, additionalTemplateIdsList)=>{
    templates.forEach((t)=>{
        const isStarredTemplateOrCreatedByCurrentUser = t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || // checks for recently unstarred templates that we still want to display
        additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(t)) || t.author === currentUserId;
        if (isStarredTemplateOrCreatedByCurrentUser && !t.categoryIds.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) t.categoryIds.push((0, $iacta.MY_TEMPLATES_CATEGORY_ID));
    });
};
const $f4c21c880d0229da$export$dea26c1eb71953eb = (templates)=>templates?.filter((template)=>template.categoryIds.includes('template.category.promoted') || template.categoryIds.includes('template.category.custom')).length;
const $f4c21c880d0229da$export$e4f285fe1dc6eb6 = (templates, currentUserId)=>templates?.filter((template)=>template.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || template.author === currentUserId).length;
const $f4c21c880d0229da$export$c5981f9aba761c29 = (availableCategories, lastSelectedCategoryIds)=>availableCategories.filter((category)=>lastSelectedCategoryIds.includes(category.id)).map((category)=>category.id);
const $f4c21c880d0229da$export$cdc91788760e8bf8 = (0, $dOBRD.default)((templates, additionalTemplateIdsList)=>{
    return templates.filter((t)=>t.categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || additionalTemplateIdsList.has($f4c21c880d0229da$export$3abed2086f3435f9(t)));
});
const $f4c21c880d0229da$export$1caa21769d3bff9a = (templates, categoryIds, selectedSortOrder, currentUserId, additionalTemplateIdsList)=>{
    if (!categoryIds.length) return templates;
    if (categoryIds?.includes((0, $iacta.MY_TEMPLATES_CATEGORY_ID))) $f4c21c880d0229da$export$6d6fdbfe01edf136(templates, currentUserId, additionalTemplateIdsList);
    const isFeaturedCategorySelected = categoryIds?.includes((0, $iacta.FEATURED_CATEGORY_ID));
    const templatesToBeFiltered = isFeaturedCategorySelected ? $f4c21c880d0229da$export$f19afdee92cfd543(templates, selectedSortOrder) : templates;
    return templatesToBeFiltered?.filter((template)=>template?.categoryIds?.some((categoryId)=>categoryIds?.includes(categoryId) || additionalTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template))));
};
const $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter = (categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList)=>{
    const isRecentlyUnstarred = additionalUnstarredTemplateIdsList && additionalUnstarredTemplateIdsList?.has($f4c21c880d0229da$export$3abed2086f3435f9(template));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName)) && isFavourite || isRecentlyUnstarred) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.starredCategoryName));
    else if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName)) && isPromoted) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.promotedCategoryName));
    const isFeaturedCategoryTemplate = categoryIds.includes('template.category.promoted') || categoryIds.includes('template.category.custom');
    const isMyTemplatesCategoryTemplate = categoryIds.includes((0, $iacta.STARRED_CATEGORY_ID)) || author === currentUserId;
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName)) && isFeaturedCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.featuredCategoryName));
    if (!keywords.includes(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName)) && isMyTemplatesCategoryTemplate) keywords.push(intl.formatMessage($f4c21c880d0229da$var$i18n.myTemplatesCategoryName));
    const keywordsIncludesSearchQuery = (keyword)=>keyword?.toLowerCase().includes(lowercaseQuery);
    return keywords.some(keywordsIncludesSearchQuery);
};
const $f4c21c880d0229da$export$698b1171e770b401 = (query, intl, currentUserId, additionalUnstarredTemplateIdsList)=>{
    return (template)=>{
        const lowercaseQuery = query.toLowerCase();
        const name = template.name || '';
        const description = template.description || '';
        const author = template.author || '';
        const keywords = template.keywords || [];
        const categoryIds = template.categoryIds || [];
        const isFavourite = template.isFavourite || false;
        const isPromoted = template.isPromoted || false;
        const blueprintAuthor = template.blueprintModuleCompleteKey ? author : '';
        const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId, additionalUnstarredTemplateIdsList);
        return name.toLowerCase().includes(lowercaseQuery) || description.toLowerCase().includes(lowercaseQuery) || blueprintAuthor.toLowerCase().includes(lowercaseQuery) || keywordsIncludeSearchQuery;
    };
};
const $f4c21c880d0229da$export$bf559da1453b0f39 = (0, $dOBRD.default)((templates, intl, currentUserId, searchQuery, additionalUnstarredTemplateIdsList)=>{
    if (searchQuery) {
        const searchQueryFilter = $f4c21c880d0229da$export$698b1171e770b401(searchQuery, intl, currentUserId, additionalUnstarredTemplateIdsList);
        templates = templates.filter(searchQueryFilter);
    }
    return templates;
});
const $f4c21c880d0229da$export$23b29992d53f1142 = (template, intl, currentUserId, searchQuery)=>{
    if (!searchQuery) return {
        searchQueryMatchesTitle: false,
        searchQueryMatchesDescription: false,
        searchQueryMatchesAuthor: false,
        searchQueryMatchesKeywords: false
    };
    const lowercaseQuery = searchQuery.toLowerCase();
    const name = template.name || '';
    const description = template.description || '';
    const author = template.author || '';
    const keywords = template.keywords || [];
    const categoryIds = template.categoryIds || [];
    const isFavourite = template.isFavourite;
    const isPromoted = template.isPromoted;
    const keywordsIncludeSearchQuery = $f4c21c880d0229da$var$getTemplateSearchQueryKeywordsFilter(categoryIds, keywords, lowercaseQuery, intl, author, isFavourite, isPromoted, template, currentUserId);
    return {
        searchQueryMatchesTitle: name.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesDescription: description.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesAuthor: author.toLowerCase().includes(lowercaseQuery),
        searchQueryMatchesKeywords: keywordsIncludeSearchQuery
    };
};
const $f4c21c880d0229da$export$16f4535f1b52f11d = (0, $dOBRD.default)((templates, includeEditorTutorialTemplate, selectedSortOrder)=>{
    // filter out null templates
    const nonNullTemplates = templates.filter((template)=>!!template);
    const tutorialIndex = nonNullTemplates.findIndex((element)=>// only one should appear at the same time
        element.blueprintModuleCompleteKey === (0, $5cryL.EDITOR_ONBOARDING_BLUEPRINT_KEY_LIVE_DOCS_ENABLED));
    if (tutorialIndex === -1) return nonNullTemplates;
    const tutorial = nonNullTemplates[tutorialIndex];
    // Remove the editor tutorial template if it shouldn't be included
    if (!includeEditorTutorialTemplate) {
        nonNullTemplates.splice(tutorialIndex, 1);
        return nonNullTemplates;
    }
    // If the sorting order is not alphabetical
    if (selectedSortOrder !== (0, $ae5hk.SortOrders).ALPHABETICAL_SORT) {
        // Remove the tutorial template, and then add it to the front.
        nonNullTemplates.splice(tutorialIndex, 1);
        nonNullTemplates.unshift(tutorial);
    }
    return nonNullTemplates;
});
const $f4c21c880d0229da$export$9b34fbf9a069b426 = (0, $dOBRD.default)((templates, allowList)=>{
    if (!allowList.length) return templates;
    return templates.filter((template)=>allowList.includes($f4c21c880d0229da$export$13d482a11efa2b43(template)));
});
const $f4c21c880d0229da$export$d444d78112a48f41 = (template)=>{
    if (template.blueprintModuleCompleteKey) return {
        idType: 'blueprint',
        id: template.blueprintModuleCompleteKey
    };
    if (template.templateId) return {
        idType: 'template',
        id: template.templateId
    };
    return {
        idType: 'other',
        id: template.itemModuleCompleteKey
    };
};
const $f4c21c880d0229da$export$9fd27f38e4a8e848 = (templates, favouritedTemplatesList)=>{
    // filter out null templates
    const filteredTemplates = templates.filter((template)=>!!template);
    if (!favouritedTemplatesList) return filteredTemplates;
    return filteredTemplates.map((template)=>{
        const isFavourite = favouritedTemplatesList.some((favouritedTemplateId)=>favouritedTemplateId === $f4c21c880d0229da$export$3abed2086f3435f9(template));
        // avoid re-adding starred category to a template that has already been starred
        const categoryIds = template.categoryIds.filter((category)=>category !== (0, $iacta.STARRED_CATEGORY_ID));
        if (isFavourite) categoryIds.push((0, $iacta.STARRED_CATEGORY_ID));
        return {
            ...template,
            isFavourite: isFavourite,
            categoryIds: categoryIds
        };
    });
};
module.exports["BLOG_CONTENT_BLUEPRINT_ID"] = $f4c21c880d0229da$export$612b286afa12407b;
module.exports["isBlueprint"] = $f4c21c880d0229da$export$3b0b898c62947fee;
module.exports["getTemplateKey"] = $f4c21c880d0229da$export$13d482a11efa2b43;
module.exports["getTemplateId"] = $f4c21c880d0229da$export$c095b4283dffab05;
module.exports["getTemplateIdForUserPreferences"] = $f4c21c880d0229da$export$3abed2086f3435f9;
module.exports["getFeaturedCategoryCount"] = $f4c21c880d0229da$export$dea26c1eb71953eb;
module.exports["getMyTemplatesCategoryCount"] = $f4c21c880d0229da$export$e4f285fe1dc6eb6;
module.exports["getExistingCategoryIds"] = $f4c21c880d0229da$export$c5981f9aba761c29;
module.exports["filterTemplatesByCategoryIds"] = $f4c21c880d0229da$export$1caa21769d3bff9a;
module.exports["filterTemplatesBySearchQuery"] = $f4c21c880d0229da$export$bf559da1453b0f39;
module.exports["getSearchQueryMatches"] = $f4c21c880d0229da$export$23b29992d53f1142;
module.exports["filterEditorTutorialTemplate"] = $f4c21c880d0229da$export$16f4535f1b52f11d;
module.exports["filterTemplatesByAllowList"] = $f4c21c880d0229da$export$9b34fbf9a069b426;
module.exports["getTemplateIdAttributesForAnalytics"] = $f4c21c880d0229da$export$d444d78112a48f41;
module.exports["updateFavouriteTemplates"] = $f4c21c880d0229da$export$9fd27f38e4a8e848;

});

parcelRegister("iacta", function(module, exports) {

var $dOBRD = parcelRequire("dOBRD");

const $1c68435f253b2047$export$b1a62972d9cddd78 = 'template.category.featured';
const $1c68435f253b2047$export$5aacf8f53708daf0 = 'template.category.my-templates';
const $1c68435f253b2047$export$c2a29eb4a43ff314 = 'template.category.starred';
const $1c68435f253b2047$export$d01d2d40a80eb4a1 = (0, $dOBRD.default)((templates, categories, mandatoryCategoryIdToShow = '')=>{
    const categoryIdToCountMap = {};
    for (const template of templates)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    for (const categoryId of template.categoryIds){
        if (!categoryId) continue;
        if (!categoryIdToCountMap[categoryId]) categoryIdToCountMap[categoryId] = 0;
        categoryIdToCountMap[categoryId]++;
    }
    const countedCategories = [];
    for (const category of categories){
        if (!category?.id || !category?.name) continue;
        const count = categoryIdToCountMap[category.id];
        const shouldForceShowCategory = category.id === mandatoryCategoryIdToShow;
        if (count || shouldForceShowCategory) countedCategories.push({
            id: category.id,
            name: category.name,
            count: count
        });
    }
    return countedCategories;
});
const $1c68435f253b2047$export$b36f54982a81becd = (categoryId, categories)=>{
    return Object.values(categories).some((existingCategory)=>existingCategory.id === categoryId);
};
module.exports["FEATURED_CATEGORY_ID"] = $1c68435f253b2047$export$b1a62972d9cddd78;
module.exports["MY_TEMPLATES_CATEGORY_ID"] = $1c68435f253b2047$export$5aacf8f53708daf0;
module.exports["STARRED_CATEGORY_ID"] = $1c68435f253b2047$export$c2a29eb4a43ff314;
module.exports["getCountedCategories"] = $1c68435f253b2047$export$d01d2d40a80eb4a1;
module.exports["isCategoryIdInCategories"] = $1c68435f253b2047$export$b36f54982a81becd;

});

parcelRegister("ae5hk", function(module, exports) {
var $5ff79979c9f78c44$export$edd0ae81c67ebc59 = /*#__PURE__*/ function(SortOrders) {
    SortOrders["RELEVANCY_SORT"] = "web.item.sorting.scheme.relevancy";
    SortOrders["ALPHABETICAL_SORT"] = "web.item.sorting.scheme.alphabetical";
    return SortOrders;
}({});
module.exports["SortOrders"] = $5ff79979c9f78c44$export$edd0ae81c67ebc59;

});

parcelRegister("4eJH6", function(module, exports) {
var $7dcc17f1ea6ba5ae$export$b573856c46cc9357 = /*#__PURE__*/ function(CalendarView) {
    CalendarView["dayGridMonth"] = "dayGridMonth";
    CalendarView["timeGridWeek"] = "timeGridWeek";
    CalendarView["listMonth"] = "listMonth";
    CalendarView["list"] = "list";
    CalendarView["timeline"] = "timeline";
    return CalendarView;
}({});
var $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8 = /*#__PURE__*/ function(CalendarViewPreference) {
    CalendarViewPreference["month"] = "month";
    CalendarViewPreference["agendaWeek"] = "agendaWeek";
    CalendarViewPreference["basicDay"] = "basicDay";
    CalendarViewPreference["timeline"] = "timeline";
    return CalendarViewPreference;
}({});
module.exports["CalendarView"] = $7dcc17f1ea6ba5ae$export$b573856c46cc9357;
module.exports["CalendarViewPreference"] = $7dcc17f1ea6ba5ae$export$2f3a5af09227bbc8;

});

parcelRegister("9oxdN", function(module, exports) {

var $h1PDd = parcelRequire("h1PDd");


var $iaK3p = parcelRequire("iaK3p");


var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $fEmGS = parcelRequire("fEmGS");


var $l1uFv = parcelRequire("l1uFv");


var $7W8i8 = parcelRequire("7W8i8");


var $bQm3c = parcelRequire("bQm3c");


var $17wUi = parcelRequire("17wUi");

const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $iaK3p.default);
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $h1PDd.default);
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (_, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    if (!newMarkedFeature) return;
    const cachedFeatureData = (0, $l1uFv.readQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        __callerPackage__: "feature-discovery"
    });
    if (!cachedFeatureData?.featureDiscovery) return;
    (0, $fEmGS.writeQueryInterop)({
        query: $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery,
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        },
        __callerPackage__: "feature-discovery"
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $17wUi.confluenceSessionStorageInstance).getItem(`${featureKey}-featureDiscoveryOverride`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $jMyy4.useQueryInterop)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery,
        __callerPackage__: "feature-discovery"
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $308Wd.useMutationInterop)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache,
        __callerPackage__: "feature-discovery"
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $cozmU.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};
module.exports["useFeatureDiscovery"] = $112f5732a615f62f$export$6de1a7573792d1a9;

});

parcelRegister("h1PDd", function(module, exports) {
/**
 * @generated SignedSource<<de9fe90553f5e4890bae7c7ad707e3ad>>
 * @relayHash 7e3a97b41907f84e881bf7535b1379ce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081
const $fca31db58911eb73$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "featureKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pluginKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "featureKey",
                    "variableName": "featureKey"
                },
                {
                    "kind": "Variable",
                    "name": "pluginKey",
                    "variableName": "pluginKey"
                }
            ],
            "concreteType": "FeatureDiscoveryPayload",
            "kind": "LinkedField",
            "name": "markFeatureDiscovered",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7e3a97b41907f84e881bf7535b1379ce",
            "id": "aded1ac8c4d8c5f52bbd0e95ce0857860d2f9ccb92e721ad18f7b30caef06081",
            "metadata": {},
            "name": "useFeatureDiscoveryMarkFeatureDiscoveredMutation",
            "operationKind": "mutation",
            "text": "mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!,$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey,pluginKey:$pluginKey){pluginKey,featureKey}}"
        }
    };
}();
$fca31db58911eb73$var$node.hash = "55ae5a7186fb2a98e37da374a9b9784e";
var $fca31db58911eb73$export$2e2bcd8739ae039 = $fca31db58911eb73$var$node;
module.exports["default"] = $fca31db58911eb73$export$2e2bcd8739ae039;

});

parcelRegister("2O7Qv", function(module, exports) {

var $a33Aa = parcelRequire("a33Aa");

/**
 * Finds the `segment-start:<metricKey>` and `segment-end:<metricKey>` custom
 * marks in the provided marks array and converts them into a UFO custom timing
 * entry keyed as `wf/react/<metricKey>`.
 */ function $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interactionId, marks, metricKey) {
    let startTime;
    let endTime;
    for (const mark of marks){
        if (mark.type !== 'custom') continue;
        if (mark.name === `segment-start:${metricKey}`) startTime = mark.time;
        else if (mark.name === `segment-end:${metricKey}`) endTime = mark.time;
    }
    if (typeof startTime === 'number' && typeof endTime === 'number') (0, $a33Aa.addCustomTiming)(interactionId, [], {
        [`wf/react/${metricKey}`]: {
            startTime: startTime,
            endTime: endTime
        }
    });
}
function $7bc5b7230c0461d4$export$46796e5c908ea08e(metricKey) {
    const interaction = (0, $a33Aa.getActiveInteraction)();
    if (interaction) $7bc5b7230c0461d4$var$addCustomTimingsFromMarks(interaction.id, interaction.marks, metricKey);
}
module.exports["addCustomTimingForMetric"] = $7bc5b7230c0461d4$export$46796e5c908ea08e;

});

parcelRegister("ipqo7", function(module, exports) {

var $8VCvx = parcelRequire("8VCvx");

const $989e58fe30d54eff$var$backgroundColorMessages = (0, $8VCvx.backgroundPaletteTooltipMessages).light;
const $989e58fe30d54eff$var$createTabColorAppearance = ({ backgroundColor: backgroundColor, backgroundColorHovered: backgroundColorHovered, borderColor: borderColor, textColor: textColor, swatchBackgroundColor: swatchBackgroundColor = backgroundColor, labelMessage: labelMessage, activeBackgroundColor: activeBackgroundColor, activeBorderColor: activeBorderColor = borderColor, activeTextColor: activeTextColor })=>({
        swatch: {
            backgroundColor: swatchBackgroundColor,
            labelMessage: labelMessage
        },
        tabPill: {
            inactive: {
                backgroundColor: backgroundColor,
                backgroundColorHovered: backgroundColorHovered,
                borderColor: borderColor,
                textColor: textColor
            },
            active: {
                backgroundColor: activeBackgroundColor,
                borderColor: activeBorderColor,
                textColor: activeTextColor
            }
        }
    });
const $989e58fe30d54eff$export$15f93407aad64edb = {
    'blue-subtlest': {
        panelColor: '#DEEBFF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#DEEBFF'],
                backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue, #1558BC)",
                activeBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
                activeTextColor: "var(--ds-text-accent-blue-bolder, #123263)"
            })
        }
    },
    'blue-subtler': {
        panelColor: '#B3D4FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B3D4FF'],
                backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue, #1558BC)",
                activeBackgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
                activeTextColor: "var(--ds-text-accent-blue-bolder, #123263)"
            })
        }
    },
    'blue-subtle': {
        panelColor: '#ADCBFB',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ADCBFB'],
                backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue-bolder, #123263)",
                activeBackgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ADCBFB'],
                backgroundColor: "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
                backgroundColorHovered: "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
                borderColor: "var(--ds-border-accent-blue, #357DE8)",
                textColor: "var(--ds-text-accent-blue-bolder, #123263)",
                activeBackgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'teal-subtlest': {
        panelColor: '#E6FCFF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E6FCFF'],
                backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal, #206A83)",
                activeBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
                activeTextColor: "var(--ds-text-accent-teal-bolder, #164555)"
            })
        }
    },
    'teal-subtler': {
        panelColor: '#B3F5FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B3F5FF'],
                backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal, #206A83)",
                activeBackgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
                activeTextColor: "var(--ds-text-accent-teal-bolder, #164555)"
            })
        }
    },
    'teal-subtle': {
        panelColor: '#B1E4F7',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B1E4F7'],
                backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal-bolder, #164555)",
                activeBackgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B1E4F7'],
                backgroundColor: "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
                backgroundColorHovered: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
                borderColor: "var(--ds-border-accent-teal, #2898BD)",
                textColor: "var(--ds-text-accent-teal-bolder, #164555)",
                activeBackgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'green-subtlest': {
        panelColor: '#E3FCEF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3FCEF'],
                backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green, #216E4E)",
                activeBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
                activeTextColor: "var(--ds-text-accent-green-bolder, #164B35)"
            })
        }
    },
    'green-subtler': {
        panelColor: '#ABF5D1',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#ABF5D1'],
                backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green, #216E4E)",
                activeBackgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
                activeTextColor: "var(--ds-text-accent-green-bolder, #164B35)"
            })
        }
    },
    'green-subtle': {
        panelColor: '#97EDC9',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#97EDC9'],
                backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green-bolder, #164B35)",
                activeBackgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#97EDC9'],
                backgroundColor: "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
                backgroundColorHovered: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
                borderColor: "var(--ds-border-accent-green, #22A06B)",
                textColor: "var(--ds-text-accent-green-bolder, #164B35)",
                activeBackgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'lime-subtlest': {
        panelColor: '#EFFFD6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFFFD6'],
                backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime, #4C6B1F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
                activeTextColor: "var(--ds-text-accent-lime-bolder, #37471F)"
            })
        }
    },
    'lime-subtler': {
        panelColor: '#D3F1A7',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#D3F1A7'],
                backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime, #4C6B1F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
                activeTextColor: "var(--ds-text-accent-lime-bolder, #37471F)"
            })
        }
    },
    'lime-subtle': {
        panelColor: '#BDE97C',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#BDE97C'],
                backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#BDE97C'],
                backgroundColor: "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
                backgroundColorHovered: "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
                borderColor: "var(--ds-border-accent-lime, #6A9A23)",
                textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
                activeBackgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'yellow-subtlest': {
        panelColor: '#FFFAE6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFFAE6'],
                backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow, #7F5F01)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
                activeTextColor: "var(--ds-text-accent-yellow-bolder, #533F04)"
            })
        }
    },
    'yellow-subtler': {
        panelColor: '#FFF0B3',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFF0B3'],
                backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow, #7F5F01)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
                activeTextColor: "var(--ds-text-accent-yellow-bolder, #533F04)"
            })
        }
    },
    'yellow-subtle': {
        panelColor: '#EFDD4E',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFDD4E'],
                backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EFDD4E'],
                backgroundColor: "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
                backgroundColorHovered: "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
                borderColor: "var(--ds-border-accent-yellow, #B38600)",
                textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
                activeBackgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'orange-subtlest': {
        panelColor: '#FFF5DB',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFF5DB'],
                backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange, #9E4C00)",
                activeBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
                activeTextColor: "var(--ds-text-accent-orange-bolder, #693200)"
            })
        }
    },
    'orange-subtler': {
        panelColor: '#FCE4A6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCE4A6'],
                backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange, #9E4C00)",
                activeBackgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
                activeTextColor: "var(--ds-text-accent-orange-bolder, #693200)"
            })
        }
    },
    'orange-subtle': {
        panelColor: '#FBD779',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FBD779'],
                backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange-bolder, #693200)",
                activeBackgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FBD779'],
                backgroundColor: "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
                backgroundColorHovered: "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
                borderColor: "var(--ds-border-accent-orange, #E06C00)",
                textColor: "var(--ds-text-accent-orange-bolder, #693200)",
                activeBackgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'red-subtlest': {
        panelColor: '#FFEBE6',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFEBE6'],
                backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red, #AE2E24)",
                activeBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                activeTextColor: "var(--ds-text-accent-red-bolder, #5D1F1A)"
            })
        }
    },
    'red-subtler': {
        panelColor: '#FFBDAD',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFBDAD'],
                backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red, #AE2E24)",
                activeBackgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
                activeTextColor: "var(--ds-text-accent-red-bolder, #5D1F1A)"
            })
        }
    },
    'red-subtle': {
        panelColor: '#FFB8B2',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFB8B2'],
                backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
                activeBackgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFB8B2'],
                backgroundColor: "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
                backgroundColorHovered: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
                borderColor: "var(--ds-border-accent-red, #E2483D)",
                textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
                activeBackgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'magenta-subtlest': {
        panelColor: '#FFECF8',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FFECF8'],
                backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta, #943D73)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
                activeTextColor: "var(--ds-text-accent-magenta-bolder, #50253F)"
            })
        }
    },
    'magenta-subtler': {
        panelColor: '#FDD0EC',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FDD0EC'],
                backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta, #943D73)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
                activeTextColor: "var(--ds-text-accent-magenta-bolder, #50253F)"
            })
        }
    },
    'magenta-subtle': {
        panelColor: '#FCB6E1',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCB6E1'],
                backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#FCB6E1'],
                backgroundColor: "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
                backgroundColorHovered: "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
                borderColor: "var(--ds-border-accent-magenta, #CD519D)",
                textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
                activeBackgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'purple-subtlest': {
        panelColor: '#EAE6FF',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#EAE6FF'],
                backgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple, #803FA5)",
                activeBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
                activeTextColor: "var(--ds-text-accent-purple-bolder, #48245D)"
            })
        }
    },
    'purple-subtler': {
        panelColor: '#C0B6F2',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#C0B6F2'],
                backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple, #803FA5)",
                activeBackgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
                activeTextColor: "var(--ds-text-accent-purple-bolder, #48245D)"
            })
        }
    },
    'purple-subtle': {
        panelColor: '#E3BDFA',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3BDFA'],
                backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
                activeBackgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#E3BDFA'],
                backgroundColor: "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
                backgroundColorHovered: "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
                borderColor: "var(--ds-border-accent-purple, #AF59E1)",
                textColor: "var(--ds-text-accent-purple-bolder, #48245D)",
                activeBackgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    },
    'gray-subtler': {
        panelColor: '#F4F5F7',
        appearances: {
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#F4F5F7'],
                backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray, #505258)",
                activeBackgroundColor: "var(--ds-background-accent-gray-subtle, #8C8F97)",
                activeTextColor: "var(--ds-text-accent-gray-bolder, #1E1F21)"
            })
        }
    },
    'gray-subtle': {
        panelColor: '#B7B9BE',
        appearances: {
            legacy: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B7B9BE'],
                backgroundColor: "var(--ds-background-accent-gray-subtle, #8C8F97)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
                activeBackgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            }),
            standard: $989e58fe30d54eff$var$createTabColorAppearance({
                labelMessage: $989e58fe30d54eff$var$backgroundColorMessages['#B7B9BE'],
                backgroundColor: "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
                backgroundColorHovered: "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
                borderColor: "var(--ds-border-accent-gray, #7D818A)",
                textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
                activeBackgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
                activeTextColor: "var(--ds-text-inverse, #FFFFFF)"
            })
        }
    }
};
const $989e58fe30d54eff$var$tabColorDefinitionsByKey = $989e58fe30d54eff$export$15f93407aad64edb;
const $989e58fe30d54eff$var$panelColorToTabColor = new Map(Object.entries($989e58fe30d54eff$export$15f93407aad64edb).map(([colorKey, definition])=>[
        definition.panelColor.toLowerCase(),
        colorKey
    ]));
const $989e58fe30d54eff$export$6cb7a3ac5d38a331 = (color, appearanceMode = 'legacy')=>{
    const appearances = $989e58fe30d54eff$export$15f93407aad64edb[color].appearances;
    return appearanceMode === 'legacy' ? appearances.legacy ?? appearances.standard : appearances.standard;
};
const $989e58fe30d54eff$export$f020e6c7ee6351cc = (color)=>{
    if (typeof color !== 'string') return undefined;
    return $989e58fe30d54eff$var$tabColorDefinitionsByKey[color]?.panelColor;
};
const $989e58fe30d54eff$export$dba9f85b52f8dfa0 = (panelColor)=>{
    if (typeof panelColor !== 'string') return undefined;
    return $989e58fe30d54eff$var$panelColorToTabColor.get(panelColor.toLowerCase());
};
module.exports["getTabColorAppearance"] = $989e58fe30d54eff$export$6cb7a3ac5d38a331;
module.exports["getPanelColorForTabColor"] = $989e58fe30d54eff$export$f020e6c7ee6351cc;
module.exports["getTabColorForPanelColor"] = $989e58fe30d54eff$export$dba9f85b52f8dfa0;

});

parcelRegister("j4RIK", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cdc6aab464c1fae2$export$6122306715c85017 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qKe_8",
    name: "PageTreeMacroHandler",
    loader: async ()=>(await (parcelRequire("Lr0re"))).PageTreeMacroRenderer
});
module.exports["PageTreeMacroHandler"] = $cdc6aab464c1fae2$export$6122306715c85017;

});

parcelRegister("Lr0re", function(module, exports) {

let $08e956be5c7c66e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $08e956be5c7c66e3$var$load("6w3bl"),
    $08e956be5c7c66e3$var$load("9TOep"),
    $08e956be5c7c66e3$var$load("3PgFB")
]).then(()=>parcelRequire('hD0Hb'));

});

parcelRegister("dF6Hu", function(module, exports) {
const $c19c056402cab920$export$aacbed104b7824d = {
    version: 1,
    type: 'doc',
    content: []
};
const $c19c056402cab920$export$92be905df4143632 = (adf)=>({
        version: 1,
        type: 'doc',
        content: adf
    });
const $c19c056402cab920$export$d287f5fb15383464 = (adfString)=>{
    try {
        const parsed = JSON.parse(adfString ?? '');
        return Array.isArray(parsed.content) ? $c19c056402cab920$export$92be905df4143632(parsed.content) : $c19c056402cab920$export$aacbed104b7824d;
    } catch  {
        return $c19c056402cab920$export$aacbed104b7824d;
    }
};
const $c19c056402cab920$export$6952557fbb0fdd5b = (adf)=>({
        content: {
            nodes: [
                {
                    body: {
                        dynamic: {
                            representation: 'atlas_doc_format',
                            value: JSON.stringify({
                                content: adf,
                                type: 'doc'
                            })
                        }
                    }
                }
            ]
        }
    });
module.exports["createNestedAdfDocument"] = $c19c056402cab920$export$92be905df4143632;
module.exports["parseNestedAdfDocument"] = $c19c056402cab920$export$d287f5fb15383464;
module.exports["createNestedRendererData"] = $c19c056402cab920$export$6952557fbb0fdd5b;

});

parcelRegister("ZJvdP", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $543e3a9ad9cfc398$export$3ad73c971369d052 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sYDyD",
    name: "PageIncludeMacroHandler",
    loader: async ()=>(await (parcelRequire("gIDv4"))).PageIncludeMacroRenderer
});
module.exports["PageIncludeMacroHandler"] = $543e3a9ad9cfc398$export$3ad73c971369d052;

});

parcelRegister("gIDv4", function(module, exports) {

let $c2bf65516d0474fe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2bf65516d0474fe$var$load("5h4De").then(()=>parcelRequire('doY9Y'));

});

parcelRegister("kvJHJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $gXfti = parcelRequire("gXfti");


var $knAY5 = parcelRequire("knAY5");


var $78QFu = parcelRequire("78QFu");



var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $N1nBh = parcelRequire("N1nBh");


var $3YpC9 = parcelRequire("3YpC9");


var $6VdZc = parcelRequire("6VdZc");


var $lXYVJ = parcelRequire("lXYVJ");


var $8W4Gr = parcelRequire("8W4Gr");


var $2O7Qv = parcelRequire("2O7Qv");


var $18R9N = parcelRequire("18R9N");

const $d2938061b4a1e388$var$noop = ()=>{};
const $d2938061b4a1e388$var$EMBEDDED_PREFIX = 'embedded-';
const $d2938061b4a1e388$var$PageSegmentLoadEndComponent = /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    const { customData: customData = {}, onComplete: onComplete = $d2938061b4a1e388$var$noop, stopTime: stopTime, timing: timing, augmentCustomDataAfterComplete: augmentCustomDataAfterComplete } = props;
    const isEmbedded = (0, $18R9N.useIsEmbeddedTracking)();
    // The discriminated union of Props guarantees that exactly one of `metricKey` or `metric`
    // is provided, so resolvedKey is always a defined string at runtime.
    const resolvedKey = props.metricKey ?? props.metric.key;
    const prefixedKey = isEmbedded ? `${$d2938061b4a1e388$var$EMBEDDED_PREFIX}${resolvedKey}` : resolvedKey;
    // Capture before onComplete or a deferred paint callback can start another interaction.
    const binding = props.metric ? (0, $8W4Gr.getPageSegmentUFOBinding)(props.metric) : undefined;
    const stopTimeRef = (0, $cozmU.useRef)(stopTime);
    const customDataRef = (0, $cozmU.useRef)(customData);
    const augmentCustomDataAfterCompleteRef = (0, $cozmU.useRef)(augmentCustomDataAfterComplete);
    stopTimeRef.current = stopTime;
    customDataRef.current = customData;
    augmentCustomDataAfterCompleteRef.current = augmentCustomDataAfterComplete;
    const handleSegmentLoadEnd = (0, $cozmU.useCallback)(()=>{
        onComplete();
        let finalCustomData;
        if (augmentCustomDataAfterCompleteRef.current) finalCustomData = augmentCustomDataAfterCompleteRef.current(customDataRef.current);
        else finalCustomData = customDataRef.current;
        const data = {
            ...finalCustomData,
            viewTransitionSource: (0, $lXYVJ.getViewTransitionSource)(),
            ...typeof stopTimeRef.current === 'number' ? {
                stopTime: stopTimeRef.current
            } : {},
            previousRoute: (0, $6VdZc.browserMetricsState).previousRoute,
            previousContentId: (0, $6VdZc.browserMetricsState).previousContentId,
            pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
        };
        // An imperative start has no embedded context; retain its captured key and owner.
        if (binding && (binding.key === prefixedKey || binding.key === resolvedKey)) // Preserve React end-mark timing; stopTime is metadata on this API.
        (0, $8W4Gr.reportPageSegmentEndToUFO)(binding, {
            customData: data
        });
        else {
            (0, $knAY5.addUFOCustomMark)(`${(0, $3YpC9.PAGE_SEGMENT_MARK_PREFIX_END)}:${prefixedKey}`);
            (0, $2O7Qv.addCustomTimingForMetric)(prefixedKey);
            (0, $gXfti.addUFOCustomData)(data);
        }
    }, [
        binding,
        onComplete,
        prefixedKey,
        resolvedKey
    ]);
    (0, $N1nBh.usePerformanceAction)(handleSegmentLoadEnd, timing);
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
const $d2938061b4a1e388$export$a267cdf45880b07b = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).BACKBONE
})($d2938061b4a1e388$var$PageSegmentLoadEndComponent);
module.exports["PageSegmentLoadEnd"] = $d2938061b4a1e388$export$a267cdf45880b07b;

});

parcelRegister("N1nBh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

var $4fef2d066feab689$export$6a673e74e98cdf55 = /*#__PURE__*/ function(ActionTiming) {
    /**
   * This will perform the given action at a scheduled time after the
   * component has painted.
   *
   * This is the default behavior.
   */ ActionTiming["DEFAULT"] = "DEFAULT";
    /**
   * This will perform the given action at the next animation frame (after the
   * component has been painted).
   */ ActionTiming["PAINT"] = "PAINT";
    /**
   * This will perform the given action at the moment its render function
   * fires.
   *
   * NOTE: This is called _within_ the render body, making it unpure. The
   * component is memoized, so it will fire this only once for a given set
   * of props. Be careful when using this, since it is unsafe.
   */ ActionTiming["RENDER_BODY"] = "RENDER_BODY";
    return ActionTiming;
}({});
const $4fef2d066feab689$export$454639fd58f598bd = (action, timing = "DEFAULT")=>{
    // The "RENDER_BODY" mark timing
    if (timing === "RENDER_BODY") action();
    // The "PAINT" mark timing
    (0, $cozmU.useLayoutEffect)(()=>{
        if (timing === "PAINT") {
            const frameRequest = requestAnimationFrame(()=>{
                action();
            });
            return ()=>{
                cancelAnimationFrame(frameRequest);
            };
        }
    }, [
        action,
        timing
    ]);
    // The "DEFAULT" mark timing
    (0, $cozmU.useEffect)(()=>{
        if (timing === "DEFAULT") action();
    }, [
        action,
        timing
    ]);
};
module.exports["ActionTiming"] = $4fef2d066feab689$export$6a673e74e98cdf55;
module.exports["usePerformanceAction"] = $4fef2d066feab689$export$454639fd58f598bd;

});

parcelRegister("lXYVJ", function(module, exports) {

var $1C3B1 = parcelRequire("1C3B1");

let $3ef2d7a9f25e0216$var$transitionSource;
const $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5 = (source)=>{
    $3ef2d7a9f25e0216$var$transitionSource = source;
};
const $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0 = ()=>{
    return $3ef2d7a9f25e0216$var$transitionSource || (0, $1C3B1.UNKNOWN);
};
const $3ef2d7a9f25e0216$export$6dffe64fdadf1e02 = ()=>{
    $3ef2d7a9f25e0216$var$transitionSource = undefined;
};
module.exports["setViewTransitionSource"] = $3ef2d7a9f25e0216$export$4ccb82300cb7b0b5;
module.exports["getViewTransitionSource"] = $3ef2d7a9f25e0216$export$3b6f05860d0a7cb0;
module.exports["resetViewTransitionSource"] = $3ef2d7a9f25e0216$export$6dffe64fdadf1e02;

});

parcelRegister("1C3B1", function(module, exports) {
const $f3fed16e32582dfc$export$f32efcfda8942c38 = 'PAGE_TREE_ITEM_CLICK';
const $f3fed16e32582dfc$export$e20b00d7fdb37fd5 = 'RECENT_DROPDOWN_ITEM_CLICK';
const $f3fed16e32582dfc$export$861af28956854f4d = 'EDITOR_UPDATE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$3a68be40f6a0cf8d = 'EDITOR_UPDATE_SHORTCUT_KEY_PRESS';
const $f3fed16e32582dfc$export$14ad6d5644be3ef2 = 'EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK';
const $f3fed16e32582dfc$export$26bf8dd7a8a304a2 = 'EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS';
const $f3fed16e32582dfc$export$35f8dbb53e30cb83 = 'EDITOR_CLOSE_BUTTON_CLICK';
const $f3fed16e32582dfc$export$56128408995abf4c = 'RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$c6abfcd7964138ae = 'DISCOVER_ITEM_ON_HOME_PAGE_CLICK';
const $f3fed16e32582dfc$export$78244dbb77cfa6b6 = 'UNKNOWN';
module.exports["PAGE_TREE_ITEM_CLICK"] = $f3fed16e32582dfc$export$f32efcfda8942c38;
module.exports["EDITOR_UPDATE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$861af28956854f4d;
module.exports["EDITOR_UPDATE_SHORTCUT_KEY_PRESS"] = $f3fed16e32582dfc$export$3a68be40f6a0cf8d;
module.exports["EDITOR_UPDATE_BUTTON_IN_MODAL_CLICK"] = $f3fed16e32582dfc$export$14ad6d5644be3ef2;
module.exports["EDITOR_UPDATE_SHORTCUT_IN_MODAL_PRESS"] = $f3fed16e32582dfc$export$26bf8dd7a8a304a2;
module.exports["EDITOR_CLOSE_BUTTON_CLICK"] = $f3fed16e32582dfc$export$35f8dbb53e30cb83;
module.exports["RECENT_WORK_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$56128408995abf4c;
module.exports["DISCOVER_ITEM_ON_HOME_PAGE_CLICK"] = $f3fed16e32582dfc$export$c6abfcd7964138ae;
module.exports["UNKNOWN"] = $f3fed16e32582dfc$export$78244dbb77cfa6b6;

});

parcelRegister("18R9N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $6b4f0c0629e8427f$export$fda153f959d0066f = /*#__PURE__*/ (0, $cozmU.createContext)(false);
const $6b4f0c0629e8427f$export$b6c7102a78eb7f7f = ()=>(0, $cozmU.useContext)($6b4f0c0629e8427f$export$fda153f959d0066f);
module.exports["EmbeddedConfluenceTrackingContext"] = $6b4f0c0629e8427f$export$fda153f959d0066f;
module.exports["useIsEmbeddedTracking"] = $6b4f0c0629e8427f$export$b6c7102a78eb7f7f;

});

parcelRegister("3h37U", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $koEBx = parcelRequire("koEBx");


var $d7j1D = parcelRequire("d7j1D");


var $2lPWP = parcelRequire("2lPWP");


var $8MmI7 = parcelRequire("8MmI7");

const $706a470437238efe$export$5252bd745392dcde = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(8);
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new (0, $2lPWP.JSONTransformer)();
        $[0] = t0;
    } else t0 = $[0];
    const transformer = t0;
    const { preset: preset } = (0, $8MmI7.usePresetByFeatures)("chromeless", features);
    let t1;
    if ($[1] !== onChange) {
        t1 = (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        };
        $[1] = onChange;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== defaultValue || $[4] !== isDisabled || $[5] !== preset || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $koEBx.ChromelessEditor), {
            disabled: isDisabled,
            defaultValue: defaultValue,
            preset: preset,
            onChange: t1
        }));
        $[3] = defaultValue;
        $[4] = isDisabled;
        $[5] = preset;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled } = props.forgeDoc.props;
    const transformer = (0, $cozmU.useMemo)(()=>new (0, $2lPWP.JSONTransformer)(), []);
    const { preset: preset } = (0, $8MmI7.usePresetByFeatures)('chromeless', features);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $koEBx.ChromelessEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onChange: (editorView)=>{
            const jsonDocNode = transformer.encode(editorView.state.doc);
            onChange?.(jsonDocNode);
        }
    }));
};
module.exports["ChromelessEditor"] = $706a470437238efe$export$5252bd745392dcde;

});

parcelRegister("8MmI7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $dVPAB = parcelRequire("dVPAB");


var $9Qt8c = parcelRequire("9Qt8c");


var $k1GzU = parcelRequire("k1GzU");

const $d7b2d2844e329581$export$cdae2f05238f63a2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (appearance, features)=>{
    const $ = (0, $bDgLe.c)(5);
    const memoisedFeatures = (0, $k1GzU.useMemoisedFeatures)(features);
    let t0;
    if ($[0] !== appearance || $[1] !== memoisedFeatures) {
        t0 = (builder)=>(0, $9Qt8c.createPreset)(builder, appearance, memoisedFeatures);
        $[0] = appearance;
        $[1] = memoisedFeatures;
        $[2] = t0;
    } else t0 = $[2];
    let t1;
    if ($[3] !== memoisedFeatures) {
        t1 = [
            memoisedFeatures
        ];
        $[3] = memoisedFeatures;
        $[4] = t1;
    } else t1 = $[4];
    const preset = (0, $dVPAB.usePreset)(t0, t1);
    return preset;
} : (appearance, features)=>{
    const memoisedFeatures = (0, $k1GzU.useMemoisedFeatures)(features);
    const preset = (0, $dVPAB.usePreset)((builder)=>(0, $9Qt8c.createPreset)(builder, appearance, memoisedFeatures), [
        memoisedFeatures
    ]);
    return preset;
};
module.exports["usePresetByFeatures"] = $d7b2d2844e329581$export$cdae2f05238f63a2;

});

parcelRegister("9Qt8c", function(module, exports) {

var $3HCXM = parcelRequire("3HCXM");


var $1171P = parcelRequire("1171P");


var $7Upsh = parcelRequire("7Upsh");


var $lK9Pz = parcelRequire("lK9Pz");


var $fKdaf = parcelRequire("fKdaf");


var $bkj40 = parcelRequire("bkj40");


var $e6Dq9 = parcelRequire("e6Dq9");


var $1ZhW4 = parcelRequire("1ZhW4");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $5tMpU = parcelRequire("5tMpU");


var $5HQgD = parcelRequire("5HQgD");


var $hFvHs = parcelRequire("hFvHs");


var $hYOOW = parcelRequire("hYOOW");


var $hHtwA = parcelRequire("hHtwA");


var $gkbos = parcelRequire("gkbos");


var $grjTL = parcelRequire("grjTL");


var $d1HsG = parcelRequire("d1HsG");

const $7be6a40f5b04921d$var$shouldShow = (option)=>{
    // if option is not defined, return false
    if (option === undefined) return false;
    return option;
};
const $7be6a40f5b04921d$export$b956d067c5bcf6b = (builder, appearance, features)=>{
    const defaultFeatures = {
        blockType: true,
        textFormatting: true,
        list: true,
        insertBlock: true,
        textColor: true,
        hyperLink: true,
        quickInsert: true,
        codeBlock: true
    };
    // if `features` is not defined, set all options to true
    // if `features` is provided, only options that are set to true by the developer will render. This is so any new plugin additions made by us will not be rendered by default as the developer has intentionally only set certain options to appear
    const enabledPlugins = features ?? defaultFeatures;
    return builder.add((0, $7Upsh.default)).maybeAdd((0, $fKdaf.blockTypePlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.blockType)) // allows for different text tags(paragraphs, heading levels) and quote blocks to be added
    .add((0, $lK9Pz.betterTypeHistoryPlugin)) // required for paste plugin
    .add([
        (0, $hYOOW.pastePlugin),
        {}
    ]) // allows links to be converted to hyper link on paste
    .add((0, $d1HsG.typeAheadPlugin)).maybeAdd((0, $hHtwA.quickInsertPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.quickInsert)) // allows for `/` to insert nodes from a menu
    .maybeAdd((0, $grjTL.textFormattingPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.textFormatting)).maybeAdd((0, $gkbos.textColorPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.textColor)).maybeAdd((0, $hFvHs.listPlugin), $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.list)) // required for `-` to insert lists
    .maybeAdd([
        (0, $1171P.toolbarListsIndentationPlugin),
        // adds the list indentation section to the toolbar
        {
            showIndentationButtons: false,
            allowHeadingAndParagraphIndentation: false
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.list)).add((0, $1ZhW4.copyButtonPlugin)) // required for floating toolbar plugins
    .add((0, $e273U.editorDisabledPlugin)) // required for floating toolbar and `disabled` prop
    .add((0, $2QN3e.decorationsPlugin)) // required for floating toolbar
    .add((0, $5tMpU.floatingToolbarPlugin)) // required for toolbar to appear under links
    .maybeAdd([
        (0, $3HCXM.hyperlinkPlugin),
        // allows for hyper link to be added to text
        {
            editorAppearance: appearance,
            lpLinkPicker: true
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.hyperLink)).add((0, $e6Dq9.compositionPlugin)) // required for codeblock
    .maybeAdd([
        (0, $bkj40.default),
        {}
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.codeBlock)).maybeAdd([
        (0, $5HQgD.insertBlockPlugin),
        // this controls the last set of toolbar insertions(link, codeblock and quote block)
        {
            appearance: appearance
        }
    ], $7be6a40f5b04921d$var$shouldShow(enabledPlugins?.insertBlock));
};
module.exports["createPreset"] = $7be6a40f5b04921d$export$b956d067c5bcf6b;

});

parcelRegister("k1GzU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

const $12df64cf02a24e7a$var$featuresAreEqual = (_previousFeatures, _currentFeatures)=>{
    // If both are references point to the same object, return true
    if (_previousFeatures === _currentFeatures) return true;
    const previousFeatures = _previousFeatures || {};
    const currentFeatures = _currentFeatures || {};
    if (Object.keys(previousFeatures).length !== Object.keys(currentFeatures).length) return false;
    // if any properties has changed, return false
    for(const key in previousFeatures){
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousFeatures[key], currentFeatures[key])) return false;
    }
    return true;
};
const $12df64cf02a24e7a$export$67693d05a6051899 = (features)=>{
    const previousFeatures = (0, $cozmU.useRef)();
    const shouldUpdate = !$12df64cf02a24e7a$var$featuresAreEqual(previousFeatures.current, features);
    if (shouldUpdate) previousFeatures.current = features;
    return previousFeatures.current;
};
module.exports["useMemoisedFeatures"] = $12df64cf02a24e7a$export$67693d05a6051899;

});

parcelRegister("dYD92", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $g8bbY = parcelRequire("g8bbY");


var $d7j1D = parcelRequire("d7j1D");


var $iMnC5 = parcelRequire("iMnC5");


var $8MmI7 = parcelRequire("8MmI7");

const $05cce7c0e751361c$export$4153d6fbc2386422 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(17);
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $8MmI7.usePresetByFeatures)("comment", features);
    const wrapperRef = (0, $cozmU.useRef)(null);
    let t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const element = wrapperRef.current;
            if (!element) return;
            return (0, $cbY7C.bind)(element, {
                type: "keypress",
                listener: $05cce7c0e751361c$var$_temp
            });
        };
        t1 = [];
        $[0] = t0;
        $[1] = t1;
    } else {
        t0 = $[0];
        t1 = $[1];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[2] !== editorApi?.core.actions || $[3] !== onSave) {
        t2 = onSave ? ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onSave?.(jsonDocNode);
            });
        } : undefined;
        $[2] = editorApi?.core.actions;
        $[3] = onSave;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== onCancel) {
        t3 = onCancel ? ()=>onCancel() : undefined;
        $[5] = onCancel;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== editorApi?.core.actions || $[8] !== onChange) {
        t4 = ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode_0)=>{
                onChange?.(jsonDocNode_0);
            });
        };
        $[7] = editorApi?.core.actions;
        $[8] = onChange;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== defaultValue || $[11] !== isDisabled || $[12] !== preset || $[13] !== t2 || $[14] !== t3 || $[15] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: wrapperRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8bbY.CommentEditor), {
            disabled: isDisabled,
            defaultValue: defaultValue,
            preset: preset,
            onSave: t2,
            onCancel: t3,
            onChange: t4
        })));
        $[10] = defaultValue;
        $[11] = isDisabled;
        $[12] = preset;
        $[13] = t2;
        $[14] = t3;
        $[15] = t4;
        $[16] = t5;
    } else t5 = $[16];
    return t5;
} : (props)=>{
    const { onChange: onChange, defaultValue: defaultValue, features: features, isDisabled: isDisabled, onSave: onSave, onCancel: onCancel } = props.forgeDoc.props;
    const { preset: preset, editorApi: editorApi } = (0, $8MmI7.usePresetByFeatures)('comment', features);
    const wrapperRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const element = wrapperRef.current;
        if (!element) return;
        return (0, $cbY7C.bind)(element, {
            type: 'keypress',
            listener: (e)=>e.stopImmediatePropagation()
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: wrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g8bbY.CommentEditor), {
        disabled: isDisabled,
        defaultValue: defaultValue,
        preset: preset,
        onSave: onSave ? ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode)=>{
                onSave?.(jsonDocNode);
            });
        } : undefined,
        onCancel: onCancel ? ()=>onCancel() : undefined,
        onChange: ()=>{
            editorApi?.core.actions.requestDocument((jsonDocNode_0)=>{
                onChange?.(jsonDocNode_0);
            });
        }
    })));
};
function $05cce7c0e751361c$var$_temp(e) {
    return e.stopImmediatePropagation();
}
module.exports["CommentEditor"] = $05cce7c0e751361c$export$4153d6fbc2386422;

});

parcelRegister("qeywr", function(module, exports) {
/* adf-renderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $jTt8P = parcelRequire("jTt8P");


var $eNbr2 = parcelRequire("eNbr2");


var $lNvN4 = parcelRequire("lNvN4");


var $4o0zT = parcelRequire("4o0zT");


var $iDrrr = parcelRequire("iDrrr");


var $hRnS5 = parcelRequire("hRnS5");


var $6t2Zs = parcelRequire("6t2Zs");


var $a005x = parcelRequire("a005x");


var $6BvLK = parcelRequire("6BvLK");


var $HHXWG = parcelRequire("HHXWG");


var $fTOZ6 = parcelRequire("fTOZ6");


var $67Hav = parcelRequire("67Hav");


var $4BZVV = parcelRequire("4BZVV");


var $9XnlZ = parcelRequire("9XnlZ");


var $gFIer = parcelRequire("gFIer");


var $4G9b9 = parcelRequire("4G9b9");


var $35FNt = parcelRequire("35FNt");


var $2Ni8p = parcelRequire("2Ni8p");

const $108ec996f4c4b6a3$export$1aac8cfda4bbc254 = 10;
const $108ec996f4c4b6a3$var$EMPTY_EXTENSION_VIEW_DATA = Object.freeze({});
const $108ec996f4c4b6a3$var$baseRendererFontStyles = null;
const $108ec996f4c4b6a3$var$makeProductMacroCoreHandlerWithBaseFontStyles = (productHandlerEntry)=>{
    const wrapProductHandler = (productHandler)=>{
        return (extensionProps, doc)=>{
            const result = productHandler(extensionProps, doc);
            if (result == null) return result;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            , {
                style: {
                    '--ak-renderer-base-font-size': '16px'
                },
                className: (0, $hekY6.default)([
                    "_4ya3eEb9Wl"
                ])
            }, result);
        };
    };
    return typeof productHandlerEntry === 'function' ? wrapProductHandler(productHandlerEntry) : {
        ...productHandlerEntry,
        render: wrapProductHandler(productHandlerEntry.render)
    };
};
const $108ec996f4c4b6a3$var$filterInvalidMediaUrls = (appDomainName, egressServices, adfDocument)=>{
    const invalidUrls = new Set();
    const visitors = {
        media: (node)=>{
            const url = node?.attrs?.url;
            if (url && !egressServices.some((service)=>(0, $HHXWG.isValidImageUrl)(url, service, appDomainName))) {
                invalidUrls.add(url);
                return {
                    ...node,
                    attrs: {
                        ...node.attrs,
                        // Remove the URL so it fails to load
                        // We use a space because an empty string causes an infinite loading spinner
                        url: ' '
                    }
                };
            }
        }
    };
    const filteredDocument = (0, $jTt8P.traverse)(adfDocument, visitors);
    return {
        filteredDocument: filteredDocument ? filteredDocument : adfDocument,
        invalidUrls: Array.from(invalidUrls)
    };
};
const $108ec996f4c4b6a3$var$useSupportsMedia = ()=>{
    try {
        (0, $lNvN4.useMediaClient)();
        return true; // eslint-disable-next-line no-unused-vars
    } catch (e) {
        // Throws if no MediaClientProvider is found
        return false;
    }
}; // Module-level cache keyed on `cloudId:userId` — created once per page load, reused across all extensions
const $108ec996f4c4b6a3$var$emojiProviderCache = new Map();
const $108ec996f4c4b6a3$export$2d71cf17ec7ade05 = (cloudId, userId)=>{
    if (!(0, $iDrrr.fg)('platform_forge_ui_custom_emoji_ui_kit_adf_renderer') || !cloudId) return undefined;
    const cacheKey = `${cloudId}:${userId ?? ''}`;
    const cached = $108ec996f4c4b6a3$var$emojiProviderCache.get(cacheKey);
    if (cached) return cached;
    const emojiProvider = (0, $4G9b9.getEmojiProvider)(cloudId, userId ?? null);
    $108ec996f4c4b6a3$var$emojiProviderCache.set(cacheKey, emojiProvider);
    return emojiProvider;
}; // Reads the current value of a provider off a ProviderFactory without leaving a lingering
// subscription. Returns `undefined` when the factory or provider is absent.
const $108ec996f4c4b6a3$var$getProviderFromFactory = (factory, name)=>{
    if (!factory) return undefined;
    const noop = ()=>{};
    const provider = factory.subscribe(name, noop);
    factory.unsubscribe(name, noop);
    return provider;
}; // Reads a single provider off the first supplied source factory that exposes it, returning a
// spreadable `{ [name]: provider }` fragment (or `undefined` when no source has it). When several
// sources expose the same provider, earlier sources win.
const $108ec996f4c4b6a3$var$pickProvider = (name, ...sources)=>{
    const source = sources.find((factory)=>factory?.hasProvider(name));
    return source ? {
        [name]: $108ec996f4c4b6a3$var$getProviderFromFactory(source, name)
    } : undefined;
}; // Builds the single ProviderFactory handed to the nested renderer: the custom emoji provider passed
// in directly, plus the task-decision and context-identifier providers copied off the host factory
// (never mutating it) so action items inside a bodied macro body can persist their checked state.
const $108ec996f4c4b6a3$var$mergeNestedDataProviders = (hostDataProviders, emojiProvider, nestedAdfMediaProvider)=>(0, $eNbr2.default).create({
        ...emojiProvider ? {
            emojiProvider: emojiProvider
        } : {},
        // Action items (checklist toggle) need BOTH providers to persist their checked state:
        // - taskDecisionProvider performs the actual write (toggleTask -> backend mutation).
        // - contextIdentifierProvider supplies the objectId that ResourcedTaskItem resolves into the
        //   objectAri key for that write. Without it the provider has no target to persist against, so
        //   ResourcedTaskItem falls back to local-only state and the toggle is lost on refresh.
        ...$108ec996f4c4b6a3$var$pickProvider('taskDecisionProvider', hostDataProviders),
        ...$108ec996f4c4b6a3$var$pickProvider('contextIdentifierProvider', hostDataProviders),
        ...nestedAdfMediaProvider ? {
            mediaProvider: nestedAdfMediaProvider
        } : {}
    });
const $108ec996f4c4b6a3$export$a504d7ec22d4b3f4 = ({ bridge: bridge, cloudId: cloudId, customBridgeMethods: customBridgeMethods, customBridge: customBridge, getContextToken: getContextToken, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers, dataProviders: hostDataProviders, nestedAdfMediaProvider: nestedAdfMediaProvider, userId: userId })=>{
    const dataProviderFactory = $108ec996f4c4b6a3$var$mergeNestedDataProviders(hostDataProviders, $108ec996f4c4b6a3$export$2d71cf17ec7ade05(cloudId, userId), nestedAdfMediaProvider);
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($108ec996f4c4b6a3$export$c334f442ba514f7d, {
            bridge: bridge,
            cloudId: cloudId,
            dataProviders: dataProviderFactory,
            getContextToken: getContextToken,
            extensionData: extensionData,
            forgeMacroExtensions: forgeMacroExtensions,
            customBridgeMethods: customBridgeMethods,
            customBridge: customBridge,
            isEditing: isEditing,
            productContextIds: productContextIds,
            productExtensionHandlers: productExtensionHandlers,
            userId: userId,
            ...props
        });
}; // Retain the generic UI Kit renderer for text, links, media and Forge extension nodes. Only
// macro.core nodes use Confluence's handler, and this factory is reached only for gated nesting.
const $108ec996f4c4b6a3$var$makeNestedADFRenderer = (dependencies, nestingDepth)=>{
    if (nestingDepth >= $108ec996f4c4b6a3$export$1aac8cfda4bbc254) return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($108ec996f4c4b6a3$export$c334f442ba514f7d, {
            ...dependencies,
            ...props,
            nestingDepth: nestingDepth
        });
};
// its own content context and the host's macro.core handler.
const $108ec996f4c4b6a3$var$EmbeddedMacroWithNestedHandler = ({ autoConvertLink: autoConvertLink, contentIdOverride: contentIdOverride, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, nestingDepth: nestingDepth, productExtensionHandlers: productExtensionHandlers, ...embeddedMacroProps })=>{
    const { accountId: accountId, bridge: bridge, cloudId: cloudId, contextIds: contextIds, customBridge: customBridge, customBridgeMethods: customBridgeMethods, extensionData: extensionData, getContextToken: getContextToken } = embeddedMacroProps;
    const augmentedExtensionData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            ...extensionData,
            autoConvertLink: autoConvertLink,
            ...contentIdOverride ? {
                content: {
                    ...extensionData.content,
                    id: contentIdOverride
                }
            } : {}
        }), [
        extensionData,
        autoConvertLink,
        contentIdOverride
    ]);
    const nestedProductExtensionHandlers = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        const macroCoreHandler = productExtensionHandlers?.['com.atlassian.confluence.macro.core'];
        return macroCoreHandler ? {
            'com.atlassian.confluence.macro.core': macroCoreHandler
        } : undefined;
    }, [
        productExtensionHandlers
    ]);
    const nestedComponents = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>({
            AdfRenderer: $108ec996f4c4b6a3$var$makeNestedADFRenderer({
                bridge: bridge,
                cloudId: cloudId,
                customBridge: customBridge,
                customBridgeMethods: customBridgeMethods,
                extensionData: augmentedExtensionData,
                forgeMacroExtensions: forgeMacroExtensions,
                getContextToken: // Carry the original host getter to descendants. EmbeddedMacroRenderer binds it to
                // each macro's runtime; chaining those bindings would pin grandchildren to an ancestor.
                getContextToken,
                isEditing: isEditing,
                productContextIds: contextIds,
                productExtensionHandlers: nestedProductExtensionHandlers,
                userId: accountId
            }, nestingDepth)
        }), [
        accountId,
        augmentedExtensionData,
        bridge,
        cloudId,
        contextIds,
        customBridge,
        customBridgeMethods,
        forgeMacroExtensions,
        getContextToken,
        isEditing,
        nestingDepth,
        nestedProductExtensionHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BZVV.EmbeddedMacroRenderer), {
        ...embeddedMacroProps,
        components: nestedComponents,
        extensionData: augmentedExtensionData
    });
}; /**
    * The AdfRenderer component provides a way to render a valid ADF document, using the same renderer that Atlassian uses internally to render ADF content in Confluence pages, Jira work items, and so on.
    * It allows you to replace node types that are unsupported in the context of a Forge app with replacement content, or remove them entirely.
    * See [Atlassian Document Format](/cloud/jira/platform/apis/document/structure/) for information on valid nodes.
    *
    * This component uses [@atlaskit/renderer](https://www.npmjs.com/package/@atlaskit/renderer) under the hood.
    *
    * Visit [Renderer editor](https://atlaskit.atlassian.com/examples/editor/renderer/basic) for a comprehensive list of different ADF document examples
    */ 
const $108ec996f4c4b6a3$var$makeExtensionHandlers = ({ bridge: bridge, cloudId: cloudId, embeddedMacroCustomBridgeMethods: embeddedMacroCustomBridgeMethods, customBridge: customBridge, nestedRendererDependencies: nestedRendererDependencies, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, getContextToken: getContextToken, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers = {}, userId: userId })=>{
    const forgeMacroHandler = (props)=>{
        const { localId: localId, parameters: parameters } = props;
        const isMigrated = parameters?.isMigrated;
        const autoConvertLink = parameters?.autoConvertLink;
        const isInline = (0, $iDrrr.fg)('platform_forge_ui_embedded_inline_macro') && parameters?.layout === 'inlineExtension'; // Extract config from extension parameters (can be in guestParams or config)
        const config = parameters.guestParams || parameters.config;
        const extensionPayload = {
            config: config,
            isEditing: isEditing
        };
        const extensionProperties = parameters.extensionProperties;
        const embeddedMacroContext = parameters.embeddedMacroContext ?? extensionProperties;
        const extensionId = parameters.extensionId ?? extensionProperties?.extension?.id;
        if (!embeddedMacroContext || !extensionId) return null;
        const { accountId: accountId, cloudId: cloudId, contextIds: contextIds, extensionData: embeddedExtensionData } = embeddedMacroContext;
        const contentId = extensionData?.content?.id; // Template ADF can retain content.id = "0" after a page is created.
        // Preserve child macro context and only refresh the host page ID.
        const contentIdOverride = (0, $iDrrr.fg)('platform_forge_nested_macro_current_context') && embeddedExtensionData?.content?.id === '0' && contentId && contentId !== '0' ? contentId : undefined; // Supplied only when pcs_3804532_nested_render_support is enabled. Keep the existing
        // renderer path below unchanged for the control cohort.
        if (nestedRendererDependencies) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($108ec996f4c4b6a3$var$EmbeddedMacroWithNestedHandler, {
            accountId: accountId,
            cloudId: cloudId,
            contextIds: contextIds,
            extensionId: extensionId,
            extensionData: embeddedExtensionData,
            contentIdOverride: contentIdOverride,
            extensionPayload: extensionPayload,
            localId: localId,
            product: "confluence",
            extensionViewData: $108ec996f4c4b6a3$var$EMPTY_EXTENSION_VIEW_DATA,
            bridge: bridge,
            customBridgeMethods: embeddedMacroCustomBridgeMethods,
            customBridge: customBridge,
            getContextToken: getContextToken,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroParentType: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? 'UIKit' : undefined,
            autoConvertLink: autoConvertLink,
            forgeMacroExtensions: forgeMacroExtensions,
            isEditing: isEditing,
            nestingDepth: nestedRendererDependencies.nestingDepth + 1,
            productExtensionHandlers: nestedRendererDependencies.productExtensionHandlers
        });
        const augmentedExtensionData = {
            ...embeddedExtensionData,
            autoConvertLink: autoConvertLink,
            ...contentIdOverride ? {
                content: {
                    ...embeddedExtensionData.content,
                    id: contentIdOverride
                }
            } : {}
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BZVV.EmbeddedMacroRenderer), {
            accountId: accountId,
            cloudId: cloudId,
            contextIds: contextIds,
            extensionId: extensionId,
            extensionData: augmentedExtensionData,
            extensionPayload: extensionPayload,
            localId: localId,
            product: "confluence",
            extensionViewData: $108ec996f4c4b6a3$var$EMPTY_EXTENSION_VIEW_DATA,
            bridge: bridge,
            customBridgeMethods: embeddedMacroCustomBridgeMethods,
            customBridge: customBridge,
            getContextToken: getContextToken,
            isInline: isInline,
            isMigrated: isMigrated,
            embeddedMacroParentType: (0, $iDrrr.fg)('platform_forge_ui_refactor_macro_parent_type') ? 'UIKit' : undefined
        });
    };
    const baseExtensionHandlers = {
        'com.atlassian.ecosystem': forgeMacroHandler
    };
    const productMacroCoreHandlerEntry = productExtensionHandlers['com.atlassian.confluence.macro.core'];
    const productMacroCoreHandler = productMacroCoreHandlerEntry ? $108ec996f4c4b6a3$var$makeProductMacroCoreHandlerWithBaseFontStyles(productMacroCoreHandlerEntry) : productMacroCoreHandlerEntry;
    const renderProductMacroCoreHandler = typeof productMacroCoreHandler === 'function' ? productMacroCoreHandler : productMacroCoreHandler?.render;
    const renderProductMacroCore = (props, doc)=>renderProductMacroCoreHandler?.(props, doc) ?? null;
    const renderProductMacroCoreWithAnalytics = (props, doc)=>{
        const result = renderProductMacroCore(props, doc);
        if (!result) return result;
        const isInline = props.type === 'inlineExtension';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a005x.ForgeUIBodiedMacroEmbeddedContentAnalytics), {
            contentId: extensionData?.content?.id,
            embeddedMacroParentType: "UIKit",
            embeddedMacroType: "productMacroCore",
            extensionKey: props.extensionKey,
            isInline: isInline
        }, result);
    };
    const renderProductCoreHandlerOrForgeMacroHandler = (props, doc)=>{
        if (forgeMacroExtensions !== undefined) {
            if (forgeMacroExtensions === null) return null;
            const migratedForgeExtension = (0, $35FNt.getMigratedForgeMacroExtension)(forgeMacroExtensions, props.extensionKey);
            if (migratedForgeExtension) {
                const parameters = (0, $35FNt.createForgeParametersForConnectMacro)({
                    accountId: userId,
                    cloudId: cloudId,
                    extension: migratedForgeExtension,
                    extensionData: extensionData,
                    productContextIds: productContextIds,
                    props: props
                });
                if (!parameters) return null;
                const result = forgeMacroHandler({
                    ...props,
                    parameters: {
                        ...parameters,
                        isMigrated: true
                    }
                }, doc);
                return result;
            }
            if (!productMacroCoreHandler) return null;
            return renderProductMacroCoreWithAnalytics(props, doc);
        }
        if (!productMacroCoreHandler) return null;
        return renderProductMacroCoreWithAnalytics(props, doc);
    };
    const productMigrationHandler = productExtensionHandlers?.['com.atlassian.confluence.migration'];
    const renderProductMigrationHandler = typeof productMigrationHandler === 'function' ? productMigrationHandler : productMigrationHandler?.render;
    const renderProductMigrationWithAnalytics = (props, doc)=>{
        const result = renderProductMigrationHandler?.(props, doc) ?? null;
        if (!result) return result;
        const isInline = props.type === 'inlineExtension';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a005x.ForgeUIBodiedMacroEmbeddedContentAnalytics), {
            contentId: extensionData?.content?.id,
            embeddedMacroParentType: "UIKit",
            embeddedMacroType: "productMigration",
            extensionKey: props.extensionKey,
            isInline: isInline
        }, result);
    };
    const productMigrationHandlerWithAnalytics = productMigrationHandler ? renderProductMigrationWithAnalytics : productMigrationHandler;
    return {
        ...baseExtensionHandlers,
        'com.atlassian.confluence.macro.core': renderProductCoreHandlerOrForgeMacroHandler,
        ...productMigrationHandlerWithAnalytics && {
            'com.atlassian.confluence.migration': productMigrationHandlerWithAnalytics
        }
    };
};
const $108ec996f4c4b6a3$export$c334f442ba514f7d = (props)=>{
    const supportsMedia = $108ec996f4c4b6a3$var$useSupportsMedia();
    const { egress: egress, properties: properties, appDomainName: appDomainName, forgeEnvironment: forgeEnvironment, appId: appId, openNewTabAsPopupWindow: openNewTabAsPopupWindow } = (0, $cozmU.useContext)((0, $fTOZ6.RendererContext));
    const imagesEgressService = (0, $gFIer.useEgressPermissionService)('IMAGES', egress);
    const mediaEgressService = (0, $gFIer.useEgressPermissionService)('MEDIA', egress);
    const { bridge: bridge, cloudId: cloudId, customBridgeMethods: embeddedMacroCustomBridgeMethods, customBridge: customBridge, dataProviders: dataProviders, extensionData: extensionData, forgeMacroExtensions: forgeMacroExtensions, isEditing: isEditing, getContextToken: getContextToken, productContextIds: productContextIds, productExtensionHandlers: productExtensionHandlers, nestingDepth: nestingDepth = 0, userId: userId } = props;
    const { onNavigate: onNavigate, getModalJsx: getModalJsx } = (0, $67Hav.useNavigation)({
        extension: {
            egress: egress,
            properties: properties
        },
        appId: appId,
        onNavigate: bridge?.onNavigate,
        openNewTabAsPopupWindow: openNewTabAsPopupWindow
    });
    const { document: adfDocument, documentWithoutMedia: documentWithoutMedia, ...adfRendererProps } = props.forgeDoc.props;
    const isNestedExtensionTableWidthFixEnabled = (0, $iDrrr.fg)('platform_forge_nested_table_width_fix'); // The client provides both the document with media and without media, as it doesn't know whether the MediaClientProvider is present
    // Then, in the parent product, we can decide whether to render the document with media or without media
    // A product-supplied nestedAdfMediaProvider also counts as media support, so hosts without an
    // ancestor MediaClientContext (e.g. the Confluence editor) keep media. Provider check first to
    // limit experiment exposure.
    const hasProductMediaProvider = !!dataProviders?.hasProvider('mediaProvider') && (0, $4o0zT.isExperimentEnabled)('platform_media_token_nested_macro');
    const doc = !(supportsMedia || hasProductMediaProvider) && documentWithoutMedia ? documentWithoutMedia : adfDocument;
    const { nestedExtensionTableMinWidth: nestedExtensionTableMinWidth } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>isNestedExtensionTableWidthFixEnabled ? (0, $2Ni8p.getNestedExtensionTableAnalysis)(doc) : {
            containsExtension: false,
            nestedExtensionTableMinWidth: undefined
        }, [
        doc,
        isNestedExtensionTableWidthFixEnabled
    ]);
    const { extensionContainerWidth: extensionContainerWidth, rendererContainerRef: rendererContainerRef } = (0, $2Ni8p.useForgeExtensionContainerWidth)(nestedExtensionTableMinWidth !== undefined);
    const nestedExtensionTableWidth = (0, $2Ni8p.getNestedExtensionTableWidth)(nestedExtensionTableMinWidth, extensionContainerWidth);
    const nestedExtensionRendererMinWidth = nestedExtensionTableWidth ? nestedExtensionTableWidth + (0, $2Ni8p.NESTED_EXTENSION_TABLE_INLINE_START_OFFSET) : undefined;
    const rendererWidth = Math.max(extensionContainerWidth ?? 0, nestedExtensionRendererMinWidth ?? 0);
    (0, $2Ni8p.useNestedExtensionTableWidth)(rendererContainerRef, nestedExtensionTableWidth);
    const rendererContainerStyle = rendererWidth ? {
        width: `${rendererWidth}px`
    } : undefined;
    const { filteredDocument: filteredDocument, invalidUrls: invalidUrls } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>doc ? $108ec996f4c4b6a3$var$filterInvalidMediaUrls(appDomainName, [
            imagesEgressService,
            mediaEgressService
        ], doc) : {
            filteredDocument: undefined,
            invalidUrls: []
        }, [
        appDomainName,
        doc,
        imagesEgressService,
        mediaEgressService
    ]);
    const rendererDocument = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>filteredDocument && nestedExtensionTableWidth ? (0, $2Ni8p.resizeNestedExtensionTables)(filteredDocument, nestedExtensionTableWidth) : filteredDocument, [
        filteredDocument,
        nestedExtensionTableWidth
    ]);
    if (!doc || !rendererDocument) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    const renderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hRnS5.RendererActionsContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t2Zs.default), {
        ...adfRendererProps,
        ...isNestedExtensionTableWidthFixEnabled && {
            appearance: 'full-width',
            UNSTABLE_allowTableAlignment: true,
            UNSTABLE_allowTableResizing: true,
            allowFixedColumnWidthOption: true
        },
        allowCustomPanels: true,
        dataProviders: dataProviders,
        eventHandlers: {
            link: {
                onClick: (e)=>{
                    e.preventDefault();
                    adfRendererProps?.eventHandlers?.link?.onClick?.(e, e.currentTarget.href);
                    onNavigate({
                        type: 'same-tab',
                        url: (0, $9XnlZ.sanitizeUrl)(e.currentTarget.href)
                    });
                }
            }
        },
        document: rendererDocument,
        extensionHandlers: $108ec996f4c4b6a3$var$makeExtensionHandlers({
            bridge: bridge,
            cloudId: cloudId,
            embeddedMacroCustomBridgeMethods: embeddedMacroCustomBridgeMethods,
            customBridge: customBridge,
            extensionData: extensionData,
            forgeMacroExtensions: forgeMacroExtensions,
            isEditing: isEditing,
            getContextToken: getContextToken,
            productContextIds: productContextIds,
            productExtensionHandlers: productExtensionHandlers,
            userId: userId,
            ...(0, $iDrrr.fg)('pcs_3804532_nested_render_support') && {
                nestedRendererDependencies: {
                    nestingDepth: nestingDepth,
                    productExtensionHandlers: productExtensionHandlers
                }
            }
        })
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, forgeEnvironment === 'DEVELOPMENT' && invalidUrls.map((url)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6BvLK.EgressErrorMessage), {
            key: url,
            url: url
        })), getModalJsx(), isNestedExtensionTableWidthFixEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: rendererContainerRef,
        style: rendererContainerStyle
    }, renderer) : renderer);
};
module.exports["makeADFRenderer"] = $108ec996f4c4b6a3$export$a504d7ec22d4b3f4;
module.exports["AdfRenderer"] = $108ec996f4c4b6a3$export$c334f442ba514f7d;

});

parcelRegister("a005x", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $DIyeF = parcelRequire("DIyeF");


var $fTCJP = parcelRequire("fTCJP");


var $6FQr4 = parcelRequire("6FQr4");

const $8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { extensionKey: extensionKey, source: source } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const analyticsSource = source ?? page;
    let t1;
    let t2;
    if ($[0] !== analyticsSource || $[1] !== createAnalyticsEvent || $[2] !== extensionKey) {
        t1 = ()=>{
            (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
                source: analyticsSource,
                extensionKey: extensionKey
            });
        };
        t2 = [
            analyticsSource,
            createAnalyticsEvent,
            extensionKey
        ];
        $[0] = analyticsSource;
        $[1] = createAnalyticsEvent;
        $[2] = extensionKey;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return null;
} : ({ extensionKey: extensionKey, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { page: page } = (0, $DIyeF.useMetricsContext)();
    const analyticsSource = source ?? page;
    (0, $cozmU.useEffect)(()=>{
        (0, $6FQr4.trackBodiedMacroEmbeddedContent)(createAnalyticsEvent, {
            source: analyticsSource,
            extensionKey: extensionKey
        });
    }, [
        analyticsSource,
        createAnalyticsEvent,
        extensionKey
    ]);
    return null;
};
const $8c747d61f3d69552$export$22c58ed2c6d282da = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { children: children, contentId: contentId, embeddedMacroParentType: t1, embeddedMacroType: t2, extensionKey: extensionKey, isInline: isInline, source: source } = t0;
    const embeddedMacroParentType = t1 === undefined ? "UIKit" : t1;
    const embeddedMacroType = t2 === undefined ? "productMacroCore" : t2;
    let t3;
    if ($[0] !== extensionKey || $[1] !== source) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger, {
            extensionKey: extensionKey,
            source: source
        });
        $[0] = extensionKey;
        $[1] = source;
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== children || $[4] !== contentId || $[5] !== embeddedMacroParentType || $[6] !== embeddedMacroType || $[7] !== isInline || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
            contentId: contentId,
            embeddedMacroParentType: embeddedMacroParentType,
            embeddedMacroType: embeddedMacroType,
            isInline: isInline
        }, t3, children);
        $[3] = children;
        $[4] = contentId;
        $[5] = embeddedMacroParentType;
        $[6] = embeddedMacroType;
        $[7] = isInline;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ children: children, contentId: contentId, embeddedMacroParentType: embeddedMacroParentType = 'UIKit', embeddedMacroType: embeddedMacroType = 'productMacroCore', extensionKey: extensionKey, isInline: isInline, source: source })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fTCJP.ForgeUIEmbeddedMacroAnalyticsContext), {
        contentId: contentId,
        embeddedMacroParentType: embeddedMacroParentType,
        embeddedMacroType: embeddedMacroType,
        isInline: isInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8c747d61f3d69552$var$EmbeddedMacroRenderedAnalyticsTrigger, {
        extensionKey: extensionKey,
        source: source
    }), children);
};
module.exports["ForgeUIBodiedMacroEmbeddedContentAnalytics"] = $8c747d61f3d69552$export$22c58ed2c6d282da;

});

parcelRegister("4G9b9", function(module, exports) {

var $kwzZh = parcelRequire("kwzZh");

const $24a0bc86fd9eb2ae$export$8210f5f78c0bcf27 = (cloudId, userId)=>new (0, $kwzZh.default)({
        providers: [
            {
                url: '/gateway/api/emoji/standard'
            },
            {
                url: '/gateway/api/emoji/atlassian'
            },
            {
                url: `/gateway/api/emoji/${cloudId}/site`
            }
        ],
        currentUser: userId ? {
            id: userId
        } : undefined
    }).getEmojiProvider();
module.exports["getEmojiProvider"] = $24a0bc86fd9eb2ae$export$8210f5f78c0bcf27;

});

parcelRegister("35FNt", function(module, exports) {
const $28462bf0a1463e2a$var$FORGE_MACRO_MODULE_TYPE = 'xen:macro';
const $28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT = '/static/';
const $28462bf0a1463e2a$export$10e34576c0b0b7c2 = (extensionId)=>{
    if (!extensionId) return;
    const staticModuleKeyIndex = extensionId.indexOf($28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT);
    if (staticModuleKeyIndex === -1) return;
    return extensionId.slice(staticModuleKeyIndex + $28462bf0a1463e2a$var$STATIC_MODULE_KEY_SEGMENT.length);
};
const $28462bf0a1463e2a$export$157b3a147b626a8d = (forgeMacroExtensions, extensionKey)=>{
    if (!extensionKey || !forgeMacroExtensions) return;
    return forgeMacroExtensions.find((extension)=>extension.type === $28462bf0a1463e2a$var$FORGE_MACRO_MODULE_TYPE && Boolean(extension.migrationKey) && $28462bf0a1463e2a$export$10e34576c0b0b7c2(extension.id) === extensionKey);
};
const $28462bf0a1463e2a$export$2d02be23603c7977 = (extension)=>{
    if (extension?.properties?.layout === 'inline') return 'inlineExtension';
    return undefined;
};
const $28462bf0a1463e2a$export$32ee00d981bcfb18 = ({ accountId: accountId, cloudId: cloudId, extension: extension, extensionData: extensionData, productContextIds: productContextIds, props: props })=>{
    if (!cloudId || !productContextIds || !accountId) return;
    const parameters = {
        ...props.parameters ?? {}
    };
    const guestParams = {
        ...parameters.guestParams ?? {}
    };
    Object.entries(parameters.macroParams ?? {}).forEach(([key, macroParam])=>{
        if (typeof guestParams[key] === 'undefined') guestParams[key] = macroParam?.value;
    });
    return {
        ...parameters,
        embeddedMacroContext: {
            ...parameters.embeddedMacroContext,
            accountId: parameters.embeddedMacroContext?.accountId ?? accountId,
            cloudId: parameters.embeddedMacroContext?.cloudId ?? cloudId,
            contextIds: parameters.embeddedMacroContext?.contextIds ?? productContextIds,
            extensionData: parameters.embeddedMacroContext?.extensionData ?? extensionData
        },
        extensionId: parameters.extensionId ?? extension.id,
        extensionTitle: parameters.extensionTitle ?? (typeof extension.properties?.title === 'string' ? extension.properties.title : undefined),
        guestParams: guestParams,
        layout: parameters.layout ?? $28462bf0a1463e2a$export$2d02be23603c7977(extension)
    };
};
module.exports["getMigratedForgeMacroExtension"] = $28462bf0a1463e2a$export$157b3a147b626a8d;
module.exports["createForgeParametersForConnectMacro"] = $28462bf0a1463e2a$export$32ee00d981bcfb18;

});

parcelRegister("2Ni8p", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $b7e4f66189f2b64b$var$FORGE_EXTENSION_CONTAINER_SELECTOR = '[data-forge-extension-container]';
const $b7e4f66189f2b64b$var$MIN_TABLE_COLUMN_WIDTH_WITH_EXTENSION = 160;
// Ignore subpixel differences from zoom and layout rounding to avoid ResizeObserver churn.
const $b7e4f66189f2b64b$var$CONTAINER_WIDTH_TOLERANCE_PX = 1;
const $b7e4f66189f2b64b$var$STYLE_LENGTH_TOLERANCE_PX = 0.5;
const $b7e4f66189f2b64b$export$6624bbff07c1eebb = 32;
const $b7e4f66189f2b64b$var$isExtensionNode = (node)=>node.type === 'extension' || node.type === 'bodiedExtension' || node.type === 'inlineExtension';
const $b7e4f66189f2b64b$var$getTableColumnCount = (tableNode)=>{
    if (!Array.isArray(tableNode.content)) return 0;
    return tableNode.content.reduce((maxColumns, row)=>{
        if (row.type !== 'tableRow' || !Array.isArray(row.content)) return maxColumns;
        const columns = row.content.reduce((count, cell)=>{
            const colspan = typeof cell.attrs?.colspan === 'number' ? cell.attrs.colspan : 1;
            return count + colspan;
        }, 0);
        return Math.max(maxColumns, columns);
    }, 0);
};
const $b7e4f66189f2b64b$export$ad52afba6f15d589 = (node)=>{
    if (!node || typeof node !== 'object') return {
        containsExtension: false
    };
    const adfNode = node;
    const childAnalyses = adfNode.content?.map($b7e4f66189f2b64b$export$ad52afba6f15d589) ?? [];
    const containsExtension = $b7e4f66189f2b64b$var$isExtensionNode(adfNode) || childAnalyses.some((analysis)=>analysis.containsExtension);
    const childMinWidth = Math.max(0, ...childAnalyses.map((analysis)=>analysis.nestedExtensionTableMinWidth ?? 0));
    if (adfNode.type !== 'table' || !containsExtension) return {
        containsExtension: containsExtension,
        nestedExtensionTableMinWidth: childMinWidth || undefined
    };
    const columnCount = $b7e4f66189f2b64b$var$getTableColumnCount(adfNode);
    const currentWidth = typeof adfNode.attrs?.width === 'number' ? adfNode.attrs.width : 0;
    const minWidth = columnCount * $b7e4f66189f2b64b$var$MIN_TABLE_COLUMN_WIDTH_WITH_EXTENSION;
    return {
        containsExtension: containsExtension,
        nestedExtensionTableMinWidth: Math.max(childMinWidth, currentWidth, minWidth) || undefined
    };
};
const $b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal = (node, tableWidth)=>{
    const resizedChildren = node.content?.map((child)=>$b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal(child, tableWidth));
    const containsExtension = $b7e4f66189f2b64b$var$isExtensionNode(node) || Boolean(resizedChildren?.some((child)=>child.containsExtension));
    const resizedContent = resizedChildren?.map((child)=>child.node);
    const resizedNode = resizedContent ? {
        ...node,
        content: resizedContent
    } : node;
    if (node.type !== 'table' || !containsExtension) return {
        containsExtension: containsExtension,
        node: resizedNode
    };
    const currentWidth = typeof node.attrs?.width === 'number' ? node.attrs.width : 0;
    return {
        containsExtension: containsExtension,
        node: {
            ...resizedNode,
            attrs: {
                ...node.attrs,
                width: Math.max(currentWidth, tableWidth)
            }
        }
    };
};
const $b7e4f66189f2b64b$export$1677922b5cecc89e = (node, tableWidth)=>$b7e4f66189f2b64b$var$resizeNestedExtensionTablesInternal(node, tableWidth).node;
const $b7e4f66189f2b64b$export$c258ed5f7aead2c7 = (minWidth, extensionContainerWidth)=>minWidth ? // never reads back equal in setImportantStyles and the MutationObserver loops forever.
    Math.ceil(Math.max(minWidth, (extensionContainerWidth ?? 0) - $b7e4f66189f2b64b$export$6624bbff07c1eebb)) : undefined;
const $b7e4f66189f2b64b$export$4d03f4495375fd0f = (enabled)=>{
    const rendererContainerRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [extensionContainerWidth, setExtensionContainerWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!enabled) {
            setExtensionContainerWidth(undefined);
            return;
        }
        const rendererContainer = rendererContainerRef.current;
        const extensionContainer = rendererContainer?.closest($b7e4f66189f2b64b$var$FORGE_EXTENSION_CONTAINER_SELECTOR);
        if (!rendererContainer || !extensionContainer) return;
        // Nested ADF can inherit a narrower saved width than the Forge host. Expand only when the
        // host currently offers more space, preserving the renderer width in every other case.
        const updateWidth = ()=>{
            const availableWidth = extensionContainer.getBoundingClientRect().width;
            const parentWidth = rendererContainer.parentElement?.getBoundingClientRect().width ?? 0;
            setExtensionContainerWidth(availableWidth > parentWidth + $b7e4f66189f2b64b$var$CONTAINER_WIDTH_TOLERANCE_PX ? Math.round(availableWidth) : undefined);
        };
        updateWidth();
        if (typeof ResizeObserver === 'undefined') return;
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(extensionContainer);
        if (rendererContainer.parentElement) resizeObserver.observe(rendererContainer.parentElement);
        return ()=>resizeObserver.disconnect();
    }, [
        enabled
    ]);
    return {
        extensionContainerWidth: extensionContainerWidth,
        rendererContainerRef: rendererContainerRef
    };
};
// Browsers may serialize a written length with less precision than it was set with.
// Both values are CSS strings such as '3897.02px'; parseFloat strips the unit, and non-lengths like
// 'none' become NaN so they only match exactly.
const $b7e4f66189f2b64b$var$isStyleValueCurrent = (current, expected)=>current === expected || Math.abs(Number.parseFloat(current) - Number.parseFloat(expected)) < $b7e4f66189f2b64b$var$STYLE_LENGTH_TOLERANCE_PX;
const $b7e4f66189f2b64b$var$setImportantStyles = (element, styles)=>{
    const isCurrent = Object.entries(styles).every(([property, value])=>$b7e4f66189f2b64b$var$isStyleValueCurrent(element.style.getPropertyValue(property), value) && element.style.getPropertyPriority(property) === 'important');
    if (isCurrent) return;
    // cloneNode preserves attributes, including inline styles. Update the detached declaration so
    // the live element is mutated once without discarding unrelated Atlaskit styles.
    const nextStyle = element.cloneNode(false).style;
    Object.entries(styles).forEach(([property, value])=>{
        nextStyle.setProperty(property, value, 'important');
    });
    element.style.cssText = nextStyle.cssText;
};
const $b7e4f66189f2b64b$export$ab610de09e5e6264 = (rendererContainerRef, tableWidth)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (!tableWidth) return;
        const rendererContainer = rendererContainerRef.current;
        if (!rendererContainer) return;
        const applyTableWidth = ()=>{
            const tableContainers = rendererContainer.querySelectorAll('.pm-table-container');
            const width = `${tableWidth}px`;
            tableContainers.forEach((tableContainer)=>{
                const table = tableContainer.querySelector('table');
                const tableWrapper = tableContainer.querySelector('.pm-table-wrapper');
                const styleContainer = tableContainer.closest('[role="none"]');
                if (styleContainer) $b7e4f66189f2b64b$var$setImportantStyles(styleContainer, {
                    width: width,
                    'max-width': 'none',
                    'margin-inline-start': `${$b7e4f66189f2b64b$export$6624bbff07c1eebb}px`,
                    'margin-inline-end': '0px'
                });
                $b7e4f66189f2b64b$var$setImportantStyles(tableContainer, {
                    width: width,
                    'max-width': 'none'
                });
                if (tableWrapper) $b7e4f66189f2b64b$var$setImportantStyles(tableWrapper, {
                    width: width
                });
                if (table) $b7e4f66189f2b64b$var$setImportantStyles(table, {
                    width: width
                });
            });
        };
        applyTableWidth();
        const animationFrameId = typeof requestAnimationFrame === 'undefined' ? undefined : requestAnimationFrame(applyTableWidth);
        const mutationObserver = typeof MutationObserver === 'undefined' ? undefined : new MutationObserver(applyTableWidth);
        mutationObserver?.observe(rendererContainer, {
            attributeFilter: [
                'style'
            ],
            attributes: true,
            subtree: true
        });
        if (typeof ResizeObserver === 'undefined') return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            mutationObserver?.disconnect();
        };
        const resizeObserver = new ResizeObserver(applyTableWidth);
        resizeObserver.observe(rendererContainer);
        return ()=>{
            if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
            mutationObserver?.disconnect();
            resizeObserver.disconnect();
        };
    }, [
        rendererContainerRef,
        tableWidth
    ]);
};
module.exports["NESTED_EXTENSION_TABLE_INLINE_START_OFFSET"] = $b7e4f66189f2b64b$export$6624bbff07c1eebb;
module.exports["getNestedExtensionTableAnalysis"] = $b7e4f66189f2b64b$export$ad52afba6f15d589;
module.exports["resizeNestedExtensionTables"] = $b7e4f66189f2b64b$export$1677922b5cecc89e;
module.exports["getNestedExtensionTableWidth"] = $b7e4f66189f2b64b$export$c258ed5f7aead2c7;
module.exports["useForgeExtensionContainerWidth"] = $b7e4f66189f2b64b$export$4d03f4495375fd0f;
module.exports["useNestedExtensionTableWidth"] = $b7e4f66189f2b64b$export$ab610de09e5e6264;

});

parcelRegister("8Ksv7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $11414ac1857ca883$export$cfa4ed6e2f4ad26 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lJE6O",
    name: "BlogPostsMacroHandler",
    loader: async ()=>(await (parcelRequire("9NQd4"))).BlogPostsMacroRenderer
});
module.exports["BlogPostsMacroHandler"] = $11414ac1857ca883$export$cfa4ed6e2f4ad26;

});

parcelRegister("9NQd4", function(module, exports) {

let $72313076fc737797$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $72313076fc737797$var$load("3eyRH"),
    $72313076fc737797$var$load("d0ZRF"),
    $72313076fc737797$var$load("k507P"),
    $72313076fc737797$var$load("6w3bl"),
    $72313076fc737797$var$load("1GCFv"),
    $72313076fc737797$var$load("28h7Y")
]).then(()=>parcelRequire('5iRsI'));

});

parcelRegister("jJli4", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $f9KPY = parcelRequire("f9KPY");


const $7549d063fe593b21$export$2800e3d415e59020 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8zrD8",
    name: "ExcerptIncludeLoader",
    loader: async ()=>(await (parcelRequire("2rflu"))).ExcerptInclude,
    // Component shadow is a subset of ExcerptIncludeProps so this would generate a TS error here as Loadable
    // expects the prop types to match.
    // @ts-expect-error
    loading: (0, $f9KPY.ExcerptIncludeComponentShadow)
});
module.exports["ExcerptIncludeLoader"] = $7549d063fe593b21$export$2800e3d415e59020;

});

parcelRegister("f9KPY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lOkIA = parcelRequire("lOkIA");


var $dhEYL = parcelRequire("dhEYL");

class $747c563e4499b240$export$8f88facf076a2d46 extends (0, $cozmU.PureComponent) {
    render() {
        const { shouldPanelBeDisplayed: shouldPanelBeDisplayed, targetContentTitle: targetContentTitle } = this.props;
        return shouldPanelBeDisplayed ? // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "data-testid": "excerpt-include-panel",
            style: (0, $dhEYL.panel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: (0, $dhEYL.panelHeader)
        }, targetContentTitle || // eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-FormattedMessage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            id: "editor.excerpt.include.panel.title.loading"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            style: (0, $dhEYL.panelBody)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        }))) : // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium",
            style: {
                minHeight: 100
            }
        });
    }
}
module.exports["ExcerptIncludeComponentShadow"] = $747c563e4499b240$export$8f88facf076a2d46;

});

parcelRegister("lOkIA", function(module, exports) {
/* CenteredSpinner.js generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $6b4nE = parcelRequire("6b4nE");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");

function $fe0e56b204487583$var$_defineProperty(e, r, t) {
    return (r = $fe0e56b204487583$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $fe0e56b204487583$var$_toPropertyKey(t) {
    var i = $fe0e56b204487583$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $fe0e56b204487583$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $fe0e56b204487583$export$57732b6846a8df7c = {
    small: 12,
    medium: 26,
    large: 36
};
const $fe0e56b204487583$var$wrapperStyles = null;
const $fe0e56b204487583$var$spinnerStyles = null;
class $fe0e56b204487583$export$a2638930496865a0 extends (0, $cozmU.PureComponent) {
    render() {
        const { style: style, size: size } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            style: style,
            "data-test-id": "wrapper-spinner",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-test-id": "spinner",
            style: {
                marginLeft: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`,
                marginTop: `${-$fe0e56b204487583$export$57732b6846a8df7c[size] / 2}px`
            },
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _3OE6xY715P _2IhTon715P _42Yu6BgtVO"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: $fe0e56b204487583$export$57732b6846a8df7c[size]
        })));
    }
}
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "displayName", 'CenteredSpinner');
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "propTypes", {
    /**
   * custom spinner style
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object,
    /**
   * Size of spinner
   */ size: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).oneOf([
        'small',
        'medium',
        'large'
    ])
});
$fe0e56b204487583$var$_defineProperty($fe0e56b204487583$export$a2638930496865a0, "defaultProps", {
    size: 'small'
});
module.exports["CenteredSpinner"] = $fe0e56b204487583$export$a2638930496865a0;

});

parcelRegister("dhEYL", function(module, exports) {
const $9b021e0aba5455d5$export$21f42ab9b6679f44 = {
    display: 'block',
    // DEBUGGING
    borderWidth: "var(--ds-border-width, 1px)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    borderImage: 'initial'
};
const $9b021e0aba5455d5$export$92937d9937dc7ce9 = {
    display: 'block',
    // DEBUGGING
    backgroundColor: "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    minWidth: '128px',
    padding: "var(--ds-space-100, 8px)",
    font: "var(--ds-font-body-large, normal 400 16px/24px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $9b021e0aba5455d5$export$d763905bda51ef54 = {
    display: 'block',
    // DEBUGGING
    minWidth: '128px',
    borderWidth: `${"var(--ds-border-width, 1px)"} 0px 0px 0px`,
    borderStyle: 'solid',
    borderColor: "var(--ds-border, #0B120E24)",
    padding: "var(--ds-space-100, 8px)"
};
const $9b021e0aba5455d5$export$99e3f651fb62ec86 = {
    color: "var(--ds-text-subtlest, #6B6E76)",
    paddingLeft: "var(--ds-space-050, 4px)"
};
module.exports["panel"] = $9b021e0aba5455d5$export$21f42ab9b6679f44;
module.exports["panelHeader"] = $9b021e0aba5455d5$export$92937d9937dc7ce9;
module.exports["panelBody"] = $9b021e0aba5455d5$export$d763905bda51ef54;
module.exports["panelHeaderExcerpt"] = $9b021e0aba5455d5$export$99e3f651fb62ec86;

});

parcelRegister("2rflu", function(module, exports) {

let $1c6a01b4f1549c0d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1c6a01b4f1549c0d$var$load("fWCBZ"),
    $1c6a01b4f1549c0d$var$load("6iTkp"),
    $1c6a01b4f1549c0d$var$load("6wr18"),
    $1c6a01b4f1549c0d$var$load("5EJB0"),
    $1c6a01b4f1549c0d$var$load("ffEVr"),
    $1c6a01b4f1549c0d$var$load("9TOep"),
    $1c6a01b4f1549c0d$var$load("excC5"),
    $1c6a01b4f1549c0d$var$load("gRItA"),
    $1c6a01b4f1549c0d$var$load("9tNcH")
]).then(()=>parcelRequire('c6u22'));

});

parcelRegister("7bpSh", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $9dee672aff5abe3d$export$c4ffab2abecc9a7c = (0, $cozmU.createContext)(null);
module.exports["ContentModeFragmentContext"] = $9dee672aff5abe3d$export$c4ffab2abecc9a7c;

});

parcelRegister("e1Stz", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $36f7db2a9cac59c0$export$7cf7439e5d7797c5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ymRP0",
    name: "PagePropertiesReportRenderer",
    loader: async ()=>(await (parcelRequire("dfWWC"))).PagePropertiesReportRenderer
});
module.exports["PagePropertiesReportRenderer"] = $36f7db2a9cac59c0$export$7cf7439e5d7797c5;

});

parcelRegister("dfWWC", function(module, exports) {

let $9a6a663cb16e25fa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9a6a663cb16e25fa$var$load("efUj2"),
    $9a6a663cb16e25fa$var$load("eF92L"),
    $9a6a663cb16e25fa$var$load("jwMHX"),
    $9a6a663cb16e25fa$var$load("6w3bl"),
    $9a6a663cb16e25fa$var$load("6wr18"),
    $9a6a663cb16e25fa$var$load("hhss7"),
    $9a6a663cb16e25fa$var$load("ffEVr"),
    $9a6a663cb16e25fa$var$load("dnwTC")
]).then(()=>parcelRequire('3Jp28'));

});

parcelRegister("l7BGZ", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $076f2e82bb035170$export$b5586d12ffc2e1b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Qw8xt",
    name: "LiveSearchLoader",
    loader: async ()=>(await (parcelRequire("jr0ai"))).LiveSearch
});

const $076f2e82bb035170$export$e7e4bc50f3fd132e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cgOQy",
    name: "LazyLiveSearchLoader",
    loader: async ()=>(await (parcelRequire("jr0ai"))).LiveSearch
});
module.exports["LiveSearchLoader"] = $076f2e82bb035170$export$b5586d12ffc2e1b;
module.exports["LazyLiveSearchLoader"] = $076f2e82bb035170$export$e7e4bc50f3fd132e;

});

parcelRegister("jr0ai", function(module, exports) {

let $e260aabc3919be7e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e260aabc3919be7e$var$load("d0ZRF"),
    $e260aabc3919be7e$var$load("k507P"),
    $e260aabc3919be7e$var$load("6wr18"),
    $e260aabc3919be7e$var$load("jYRaq"),
    $e260aabc3919be7e$var$load("7G12e"),
    $e260aabc3919be7e$var$load("io0qR"),
    $e260aabc3919be7e$var$load("ffEVr"),
    $e260aabc3919be7e$var$load("9TOep"),
    $e260aabc3919be7e$var$load("bncmK"),
    $e260aabc3919be7e$var$load("7EorR"),
    $e260aabc3919be7e$var$load("hhss7"),
    $e260aabc3919be7e$var$load("2IX0x")
]).then(()=>parcelRequire('jF1MT'));

});

parcelRegister("202oG", function(module, exports) {

var $2lPWP = parcelRequire("2lPWP");

function $2cfd9ea7d82f1add$export$dbad71934afee167(node, headingIds) {
    if (!node?.content?.length) return;
    // We are not use node.textContent here, because we would like to handle cases where
    // headings only contain inline blocks like emoji, status and date.
    const nodeContent = node.content.reduce((acc, currentNode)=>acc.concat($2cfd9ea7d82f1add$var$getText(currentNode) || ''), '').trim().replace(/\s/g, '-');
    if (!nodeContent) return;
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(nodeContent, headingIds);
}
const $2cfd9ea7d82f1add$var$getText = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : ''}]`;
};
function $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter = 0) {
    if (counter === 0 && !headingIds.has(baseId)) {
        headingIds.add(baseId);
        return baseId;
    } else if (counter !== 0) {
        const headingId = `${baseId}.${counter}`;
        if (!headingIds.has(headingId)) {
            headingIds.add(headingId);
            return headingId;
        }
    }
    return $2cfd9ea7d82f1add$var$getUniqueHeadingId(baseId, headingIds, counter + 1);
}
const $2cfd9ea7d82f1add$var$HEADINGS = new Set([
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6'
]);
function* $2cfd9ea7d82f1add$var$getHeadingIds() {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    const editorElement = document.getElementById('ak-editor-textarea');
    const children = editorElement?.getElementsByTagName('*') ?? [];
    const headingIds = new Set();
    const editorTransformer = new (0, $2lPWP.JSONTransformer)();
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($2cfd9ea7d82f1add$var$HEADINGS.has(child.tagName)) {
            const pmNode = child.pmViewDesc?.node;
            if (!pmNode) continue;
            // Copied from TOC
            const adf = editorTransformer.encode(pmNode);
            let adfObject = adf;
            if (typeof adf === 'string') try {
                adfObject = JSON.parse(adf);
            } catch (err) {
            // Swallow the error as ADF format error handling is expected to be done earlier,
            // in the component that renders the entire content
            }
            const headingId = $2cfd9ea7d82f1add$export$dbad71934afee167(adfObject, headingIds);
            if (!headingId) continue;
            yield [
                headingId,
                child,
                pmNode
            ];
        }
    }
}
const $2cfd9ea7d82f1add$export$817005c72dc2688 = ()=>{
    const headingIdToElement = new Map();
    for (const [headingId, child, _] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        headingIdToElement.set(headingId, child);
        // A bit inefficient, but there's sometimes a discrepancy between the hashed ID and the generated ID. The least impactful solution is to just add both.
        headingIdToElement.set(encodeURIComponent(headingId), child);
    }
    return headingIdToElement;
};
const $2cfd9ea7d82f1add$export$e2a78e613c648859 = (node)=>{
    for (const [headingId, _, pmNode] of $2cfd9ea7d82f1add$var$getHeadingIds()){
        if (node === pmNode) return headingId;
    }
    return undefined;
};
module.exports["getHeadingId"] = $2cfd9ea7d82f1add$export$dbad71934afee167;
module.exports["getHeadingIdsToElements"] = $2cfd9ea7d82f1add$export$817005c72dc2688;
module.exports["getHeadingIdForNode"] = $2cfd9ea7d82f1add$export$e2a78e613c648859;

});

parcelRegister("iNIw3", function(module, exports) {
const $2008359fb3515e18$export$38c6526d67de94bb = 'xen:macro';
const $2008359fb3515e18$export$8d4b803281599c6a = 'com.atlassian.ecosystem';
const $2008359fb3515e18$export$d7168699755008a = 'com.atlassian.confluence.macro.core';
const $2008359fb3515e18$export$46fc26821adc3495 = 'connectAddon';
const $2008359fb3515e18$export$95077f102dafd025 = 'migratedServerP2Addon';
const $2008359fb3515e18$export$981e47da3e2dfc13 = 'bodiedExtension';
const $2008359fb3515e18$export$4506b39eefa6dc94 = 'multiBodiedExtension';
const $2008359fb3515e18$export$d2cde58d8ae019a9 = 'forge.ui.extension';
const $2008359fb3515e18$export$bf4c163a4c708db1 = 'forgeDocUpdated';
const $2008359fb3515e18$export$973a451c50b864fd = 'atlassianMacroOutputType';
const $2008359fb3515e18$export$3551f8d01dfac8f1 = 'atlassianForgeInlineBodied';
module.exports["MODULE_NAME"] = $2008359fb3515e18$export$38c6526d67de94bb;
module.exports["EXTENSION_NAMESPACE"] = $2008359fb3515e18$export$8d4b803281599c6a;
module.exports["P2_OR_CONNECT_CONFLUENCE_MACRO_EXTENSION_TYPE"] = $2008359fb3515e18$export$d7168699755008a;
module.exports["CONNECT_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$46fc26821adc3495;
module.exports["MIGRATED_SERVER_P2_ADDON_ACTION_SUBJECT"] = $2008359fb3515e18$export$95077f102dafd025;
module.exports["EXTENSION_TYPE_MULTI_BODIED"] = $2008359fb3515e18$export$4506b39eefa6dc94;
module.exports["FORGE_EXTENSION"] = $2008359fb3515e18$export$d2cde58d8ae019a9;
module.exports["FORGE_DOC_UPDATED_EVENT"] = $2008359fb3515e18$export$bf4c163a4c708db1;
module.exports["MACRO_OUTPUT_TYPE_PARAM"] = $2008359fb3515e18$export$973a451c50b864fd;
module.exports["FORGE_INLINE_BODIED_PARAM"] = $2008359fb3515e18$export$3551f8d01dfac8f1;

});

parcelRegister("2igSQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dUI0h = parcelRequire("dUI0h");


var $2xdp1 = parcelRequire("2xdp1");


var $kwjRd = parcelRequire("kwjRd");


var $idCCS = parcelRequire("idCCS");

const $f852cc0c808326c8$export$cdee65ffaf9b2fb7 = ({ parameters: parameters })=>{
    // https://github.com/final-form/react-final-form/issues/103
    // If users name variables using numbers it breaks the form
    // hacky fix added a $ character in front
    const inputName = `$${parameters?.name}`;
    const inputPlaceholder = `${parameters?.placeholder || parameters?.name}`;
    // . [ or ] in the variable name causes Final Form to throw an error
    const validInputName = inputName.replace(/[`.\[\]\/]/gi, '');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableInputWrapper), null, parameters?.type === (0, $2xdp1.MULTI_LINES_TYPE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableTextareaInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            display: 'inline-block',
            width: '100%'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.TemplateVariableInputFieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            margin: '0px 0px'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
        name: validInputName,
        defaultValue: ""
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idCCS.TemplateVariableInputComponent), {
            ...fieldProps,
            parameters: parameters,
            inputName: validInputName,
            placeholder: inputPlaceholder
        })))));
};
module.exports["TemplateVariableInput"] = $f852cc0c808326c8$export$cdee65ffaf9b2fb7;

});

parcelRegister("2xdp1", function(module, exports) {

var $55ggG = parcelRequire("55ggG");

const $df54c7f294e74661$export$178c63c1bbc65458 = (0, $55ggG.i18n).templateVariableDefault.defaultMessage;
const $df54c7f294e74661$export$ae3b897442224943 = 'text';
const $df54c7f294e74661$export$a43e313f04be91d7 = 'textarea';
const $df54c7f294e74661$export$22c50a44ec8aa5dd = 'select';
const $df54c7f294e74661$export$d1952e7dbe0fefc9 = 5;
const $df54c7f294e74661$export$777b44f8413b254e = 100;
module.exports["defaultVariableName"] = $df54c7f294e74661$export$178c63c1bbc65458;
module.exports["TEXT_TYPE"] = $df54c7f294e74661$export$ae3b897442224943;
module.exports["MULTI_LINES_TYPE"] = $df54c7f294e74661$export$a43e313f04be91d7;
module.exports["LIST_TYPE"] = $df54c7f294e74661$export$22c50a44ec8aa5dd;
module.exports["ROWS_DEFAULT"] = $df54c7f294e74661$export$d1952e7dbe0fefc9;
module.exports["COLUMNS_DEFAULT"] = $df54c7f294e74661$export$777b44f8413b254e;

});

parcelRegister("55ggG", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $446fbea06bd2a31f$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    propertyPanelVariableDisplayString: {
        id: "template-variable.property.panel.variable.display.string",
        defaultMessage: "Text"
    },
    propertyPanelVariableDisplayStringTooltip: {
        id: "template-variable.property.panel.variable.display.string.tooltip",
        defaultMessage: "Single line text input field."
    },
    propertyPanelVariableDisplayTextArea: {
        id: "template-variable.property.panel.variable.display.textarea",
        defaultMessage: "Multi-line Text"
    },
    propertyPanelVariableDisplayTextAreaTooltip: {
        id: "template-variable.property.panel.variable.display.textarea.tooltip",
        defaultMessage: "Multi-line text input field."
    },
    propertyPanelVariableDisplayList: {
        id: "template-variable.property.panel.variable.display.list",
        defaultMessage: "List"
    },
    propertyPanelVariableDisplayListTooltip: {
        id: "template-variable.property.panel.variable.display.list.tooltip",
        defaultMessage: "Drop down list."
    },
    templateEditorChangingVariableDialogTitle: {
        id: "template-variable.template.editor.changing.variable.dialog.title",
        defaultMessage: "Edit template variable"
    },
    templateEditorVariableNameField: {
        id: "template-variable.template.editor.variable.name.field",
        defaultMessage: "Variable name"
    },
    propertyPanelVariableDisplayTextAreaRowsTooltip: {
        id: "template-variable.property.panel.variable.textarea.rows.tooltip",
        defaultMessage: "Number of rows to display for the field."
    },
    propertyPanelVariableDisplayTextAreaColumnsTooltip: {
        id: "template-variable.property.panel.variable.textarea.columns.tooltip",
        defaultMessage: "Number of columns to display for the field."
    },
    propertyPanelVariableListValuesTooltip: {
        id: "template-variable.property.panel.variable.list.values.tooltip",
        defaultMessage: "Enter each item for the list, separating each with a comma."
    },
    templateEditorVariableListFieldPlaceholder: {
        id: "template-variable.template.editor.variable.list.field.placeholder",
        defaultMessage: "option 1, option 2, option 3"
    },
    templateEditorVariableSaveButtonLabel: {
        id: "template-variable.template.editor.variable.save.button.label",
        defaultMessage: "Save"
    },
    templateVariableDefault: {
        id: "template-variable.template.editor.variable.name.default",
        defaultMessage: "variable_name"
    }
});
module.exports["i18n"] = $446fbea06bd2a31f$export$a7357cdd1f0b0168;

});

parcelRegister("kwjRd", function(module, exports) {
/* SharedComponents.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $f809923cf8cfa046$export$4af78215734bfe2b = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842B0rP _1DCdHi5zaO _1wydGWFQfX _3iDTPbvbI6",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$59d0bfd82baefce0 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEV9lr _0bjKvDXPZg _0KLXruVva3",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$8eff3c6bf5b8c758 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3W2Oc84hR5 _1UtDYzy7kJ _1kk5TkzUZr",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$b4ff36272a61159f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_4FKVYEV9lr _0bjKvD7Zry _1UtDYzKGUX _0KLXruVva3 _3W2Oc84hR5",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e3cad7a6d45ce703 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _1EqgXlN91d _1ANEUSzUZr",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$e9df20cb66227872 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _1EqgXlN91d _1mT5xdRAKS _1RrJLiBwqQ",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$bdc3c19374266b98 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_25VRdPZqHV",
            __cmplp.className
        ])
    });
});
const $f809923cf8cfa046$export$c996e1cc40266f34 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFMFQfX",
            __cmplp.className
        ])
    });
});
module.exports["TemplateVariableInputWrapper"] = $f809923cf8cfa046$export$4af78215734bfe2b;
module.exports["TemplateVariableNameWrapper"] = $f809923cf8cfa046$export$59d0bfd82baefce0;
module.exports["TemplateVariableName"] = $f809923cf8cfa046$export$8eff3c6bf5b8c758;
module.exports["TemplateVariableType"] = $f809923cf8cfa046$export$b4ff36272a61159f;
module.exports["TemplateVariableInputFieldWrapper"] = $f809923cf8cfa046$export$e3cad7a6d45ce703;
module.exports["TemplateVariableTextareaInputFieldWrapper"] = $f809923cf8cfa046$export$e9df20cb66227872;
module.exports["ButtonStyle"] = $f809923cf8cfa046$export$bdc3c19374266b98;
module.exports["DropDownInputWrapper"] = $f809923cf8cfa046$export$c996e1cc40266f34;

});

parcelRegister("idCCS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7sJoX = parcelRequire("7sJoX");


var $e3Wrf = parcelRequire("e3Wrf");


var $4yg9g = parcelRequire("4yg9g");


var $3GNtk = parcelRequire("3GNtk");


var $5SGpQ = parcelRequire("5SGpQ");


var $lpNn5 = parcelRequire("lpNn5");


var $kwjRd = parcelRequire("kwjRd");


var $2xdp1 = parcelRequire("2xdp1");

const $ab3c5e793706abd9$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    invalidVariableNameError: {
        id: "template-variable.description.invalid.variable.name",
        defaultMessage: "This template contains a variable using invalid character(s) (. , [ , ], /). Please have the template owner remove these characters from the variable to use it."
    }
});
const $ab3c5e793706abd9$var$generateDropdownOptionsList = (options)=>options ? options.map((option)=>({
            label: option,
            value: option
        })) : [];
const $ab3c5e793706abd9$var$styles = {
    option: (provided)=>({
            ...provided,
            wordBreak: 'break-word'
        })
};
const $ab3c5e793706abd9$var$checkTemplateVariableValidity = (variableName)=>{
    const invalidVariableCharacters = [
        '.',
        '[',
        ']',
        '/'
    ];
    return invalidVariableCharacters.some((invalidVariableCharacter)=>variableName?.includes(invalidVariableCharacter));
};
const $ab3c5e793706abd9$export$25a5c8174bd010d5 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    const parameterOptions = parameters.params && parameters.params.options;
    const options = (0, $cozmU.useMemo)(()=>$ab3c5e793706abd9$var$generateDropdownOptionsList(parameterOptions), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        parameterOptions
    ]);
    const onChangeHandler = (0, $cozmU.useMemo)(()=>(option)=>{
            onChange(option.value);
        }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: hasInvalidVariableName
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        // eslint-disable-next-line @atlaskit/design-system/enforce-inline-styles-in-select
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.DropDownInputWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3GNtk.PopupSelect), {
        options: options,
        placeholder: `${value || placeholder}`,
        onChange: onChangeHandler,
        target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kwjRd.ButtonStyle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5SGpQ.default), {
                ref: ref,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                    label: "dropdown icon",
                    size: "small"
                }),
                isSelected: isOpen,
                isDisabled: parameters.isDisabled
            }, `${value || placeholder}`)),
        popperProps: {
            placement: 'auto',
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: 'clippingParents'
                    }
                }
            ]
        },
        maxMenuHeight: 200,
        maxMenuWidth: 200,
        searchThreshold: 10,
        // eslint-disable-next-line @atlaskit/design-system/enforce-inline-styles-in-select
        styles: $ab3c5e793706abd9$var$styles,
        value: {
            label: value,
            value: value
        }
    })));
};
const $ab3c5e793706abd9$export$b9055edfa32ac8b4 = ({ onChange: onChange, value: value, inputName: inputName, parameters: parameters, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
            ...tooltipProps,
            testId: "text-field-input",
            name: inputName,
            onChange: onChange,
            value: value || '',
            placeholder: placeholder,
            isDisabled: hasInvalidVariableName,
            width: 200,
            isCompact: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4yg9g.default), {
        testId: "text-field-input",
        name: inputName,
        onChange: onChange,
        value: value || '',
        placeholder: placeholder,
        isDisabled: parameters?.isDisabled,
        width: 200,
        isCompact: true
    }));
};
const $ab3c5e793706abd9$export$9a5caaaacb4c92d3 = ({ parameters: parameters, onChange: onChange, value: value, placeholder: placeholder })=>{
    const intl = (0, $kSwu1.useIntl)();
    // We are passing in placeholder as the validity check b/c it hasn't been stripped of . [ or ]
    const hasInvalidVariableName = $ab3c5e793706abd9$var$checkTemplateVariableValidity(placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, hasInvalidVariableName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: intl.formatMessage($ab3c5e793706abd9$export$a7357cdd1f0b0168.invalidVariableNameError)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
            ...tooltipProps,
            testId: "text-area-input",
            onChange: onChange,
            value: value || '',
            minimumRows: parameters.params && parameters.params.rows || 1,
            cols: parameters.params && parameters.params.columns || 30,
            resize: "vertical",
            isDisabled: hasInvalidVariableName,
            placeholder: placeholder
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e3Wrf.default), {
        testId: "text-area-input",
        onChange: onChange,
        value: value || '',
        minimumRows: parameters.params && parameters.params.rows || 1,
        cols: parameters.params && parameters.params.columns || 30,
        resize: "vertical",
        isDisabled: parameters?.isDisabled,
        placeholder: placeholder
    }));
};
const $ab3c5e793706abd9$export$f57c870ff73570c7 = (props)=>{
    const { parameters: parameters } = props;
    switch(parameters.type){
        case 0, $2xdp1.LIST_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$25a5c8174bd010d5, props);
        case 0, $2xdp1.MULTI_LINES_TYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$9a5caaaacb4c92d3, props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ab3c5e793706abd9$export$b9055edfa32ac8b4, props);
    }
};
module.exports["TemplateVariableInputComponent"] = $ab3c5e793706abd9$export$f57c870ff73570c7;

});

parcelRegister("d33vY", function(module, exports) {

var $9xhvY = parcelRequire("9xhvY");

const $b72a988e4c96b227$var$materialize = (intl, messages)=>Object.values(messages).reduce((keywords, descriptor)=>{
        const keyword = intl.formatMessage(descriptor);
        if (keyword.trim().length > 0) keywords.push(keyword);
        return keywords;
    }, []);
const $b72a988e4c96b227$export$9e9e689df24bb863 = (intl)=>$b72a988e4c96b227$var$materialize(intl, (0, $9xhvY.titleKeywordMessages));
const $b72a988e4c96b227$export$481c14b1f52fc674 = (intl)=>$b72a988e4c96b227$var$materialize(intl, (0, $9xhvY.contentKeywordMessages));
module.exports["getTitleKeywords"] = $b72a988e4c96b227$export$9e9e689df24bb863;
module.exports["getContentKeywords"] = $b72a988e4c96b227$export$481c14b1f52fc674;

});

parcelRegister("9xhvY", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ae3f7d6d0e7de18b$export$650dc367698d00c6 = (0, $kSwu1.defineMessages)({
    meeting: {
        id: "meeting-signal-instrumentation.title-keyword.meeting",
        defaultMessage: "meeting"
    },
    meetings: {
        id: "meeting-signal-instrumentation.title-keyword.meetings",
        defaultMessage: "meetings"
    },
    sync: {
        id: "meeting-signal-instrumentation.title-keyword.sync",
        defaultMessage: "sync"
    },
    standup: {
        id: "meeting-signal-instrumentation.title-keyword.standup",
        defaultMessage: "standup"
    },
    dailyStandup: {
        id: "meeting-signal-instrumentation.title-keyword.daily-standup",
        defaultMessage: "daily standup"
    },
    huddle: {
        id: "meeting-signal-instrumentation.title-keyword.huddle",
        defaultMessage: "huddle"
    },
    checkIn: {
        id: "meeting-signal-instrumentation.title-keyword.check-in",
        defaultMessage: "check-in"
    },
    oneOnOne: {
        id: "meeting-signal-instrumentation.title-keyword.one-on-one",
        defaultMessage: "1:1"
    },
    kickoff: {
        id: "meeting-signal-instrumentation.title-keyword.kickoff",
        defaultMessage: "kickoff"
    },
    review: {
        id: "meeting-signal-instrumentation.title-keyword.review",
        defaultMessage: "review"
    },
    demo: {
        id: "meeting-signal-instrumentation.title-keyword.demo",
        defaultMessage: "demo"
    },
    showcase: {
        id: "meeting-signal-instrumentation.title-keyword.showcase",
        defaultMessage: "showcase"
    },
    workingSession: {
        id: "meeting-signal-instrumentation.title-keyword.working-session",
        defaultMessage: "working session"
    },
    officeHours: {
        id: "meeting-signal-instrumentation.title-keyword.office-hours",
        defaultMessage: "office hours"
    },
    townHall: {
        id: "meeting-signal-instrumentation.title-keyword.town-hall",
        defaultMessage: "town hall"
    },
    allHands: {
        id: "meeting-signal-instrumentation.title-keyword.all-hands",
        defaultMessage: "all hands"
    },
    leadershipSync: {
        id: "meeting-signal-instrumentation.title-keyword.leadership-sync",
        defaultMessage: "leadership sync"
    },
    staffMeeting: {
        id: "meeting-signal-instrumentation.title-keyword.staff-meeting",
        defaultMessage: "staff meeting"
    },
    teamMeeting: {
        id: "meeting-signal-instrumentation.title-keyword.team-meeting",
        defaultMessage: "team meeting"
    },
    customerCall: {
        id: "meeting-signal-instrumentation.title-keyword.customer-call",
        defaultMessage: "customer call"
    },
    discoveryCall: {
        id: "meeting-signal-instrumentation.title-keyword.discovery-call",
        defaultMessage: "discovery call"
    },
    designReview: {
        id: "meeting-signal-instrumentation.title-keyword.design-review",
        defaultMessage: "design review"
    },
    architectureReview: {
        id: "meeting-signal-instrumentation.title-keyword.architecture-review",
        defaultMessage: "architecture review"
    },
    backlogRefinement: {
        id: "meeting-signal-instrumentation.title-keyword.backlog-refinement",
        defaultMessage: "backlog refinement"
    },
    agenda: {
        id: "meeting-signal-instrumentation.title-keyword.agenda",
        defaultMessage: "agenda"
    },
    meetingAgenda: {
        id: "meeting-signal-instrumentation.title-keyword.meeting-agenda",
        defaultMessage: "meeting agenda"
    },
    meetingNotes: {
        id: "meeting-signal-instrumentation.title-keyword.meeting-notes",
        defaultMessage: "meeting notes"
    },
    discussionTopics: {
        id: "meeting-signal-instrumentation.title-keyword.discussion-topics",
        defaultMessage: "discussion topics"
    },
    discussion: {
        id: "meeting-signal-instrumentation.title-keyword.discussion",
        defaultMessage: "discussion"
    },
    decisions: {
        id: "meeting-signal-instrumentation.title-keyword.decisions",
        defaultMessage: "decisions"
    },
    decisionLog: {
        id: "meeting-signal-instrumentation.title-keyword.decision-log",
        defaultMessage: "decision log"
    },
    attendees: {
        id: "meeting-signal-instrumentation.title-keyword.attendees",
        defaultMessage: "attendees"
    },
    participants: {
        id: "meeting-signal-instrumentation.title-keyword.participants",
        defaultMessage: "participants"
    },
    outcomes: {
        id: "meeting-signal-instrumentation.title-keyword.outcomes",
        defaultMessage: "outcomes"
    },
    parkingLot: {
        id: "meeting-signal-instrumentation.title-keyword.parking-lot",
        defaultMessage: "parking lot"
    }
});
const $ae3f7d6d0e7de18b$export$50c58b2d87c2deae = (0, $kSwu1.defineMessages)({
    letsSync: {
        id: "meeting-signal-instrumentation.content-keyword.lets-sync",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "let's sync"
    },
    letsDiscuss: {
        id: "meeting-signal-instrumentation.content-keyword.lets-discuss",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "let's discuss"
    },
    letsReview: {
        id: "meeting-signal-instrumentation.content-keyword.lets-review",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "let's review"
    },
    scheduleAMeeting: {
        id: "meeting-signal-instrumentation.content-keyword.schedule-a-meeting",
        defaultMessage: "schedule a meeting"
    },
    scheduleACall: {
        id: "meeting-signal-instrumentation.content-keyword.schedule-a-call",
        defaultMessage: "schedule a call"
    },
    bookTime: {
        id: "meeting-signal-instrumentation.content-keyword.book-time",
        defaultMessage: "book time"
    },
    findTime: {
        id: "meeting-signal-instrumentation.content-keyword.find-time",
        defaultMessage: "find time"
    },
    calendarInvite: {
        id: "meeting-signal-instrumentation.content-keyword.calendar-invite",
        defaultMessage: "calendar invite"
    },
    invite: {
        id: "meeting-signal-instrumentation.content-keyword.invite",
        defaultMessage: "invite"
    },
    joinTheMeeting: {
        id: "meeting-signal-instrumentation.content-keyword.join-the-meeting",
        defaultMessage: "join the meeting"
    },
    joinTheCall: {
        id: "meeting-signal-instrumentation.content-keyword.join-the-call",
        defaultMessage: "join the call"
    },
    zoom: {
        id: "meeting-signal-instrumentation.content-keyword.zoom",
        defaultMessage: "Zoom"
    },
    googleMeet: {
        id: "meeting-signal-instrumentation.content-keyword.google-meet",
        defaultMessage: "Google Meet"
    },
    microsoftTeams: {
        id: "meeting-signal-instrumentation.content-keyword.microsoft-teams",
        defaultMessage: "Microsoft Teams"
    },
    webex: {
        id: "meeting-signal-instrumentation.content-keyword.webex",
        defaultMessage: "Webex"
    },
    recap: {
        id: "meeting-signal-instrumentation.content-keyword.recap",
        defaultMessage: "recap"
    },
    meetingSummary: {
        id: "meeting-signal-instrumentation.content-keyword.meeting-summary",
        defaultMessage: "meeting summary"
    },
    summary: {
        id: "meeting-signal-instrumentation.content-keyword.summary",
        defaultMessage: "summary"
    },
    asDiscussed: {
        id: "meeting-signal-instrumentation.content-keyword.as-discussed",
        defaultMessage: "as discussed"
    },
    followUp: {
        id: "meeting-signal-instrumentation.content-keyword.follow-up",
        defaultMessage: "follow up"
    },
    followUpHyphenated: {
        id: "meeting-signal-instrumentation.content-keyword.follow-up-hyphenated",
        defaultMessage: "follow-up"
    },
    decisionsMade: {
        id: "meeting-signal-instrumentation.content-keyword.decisions-made",
        defaultMessage: "decisions made"
    },
    takeaways: {
        id: "meeting-signal-instrumentation.content-keyword.takeaways",
        defaultMessage: "takeaways"
    },
    owners: {
        id: "meeting-signal-instrumentation.content-keyword.owners",
        defaultMessage: "owners"
    },
    discussionNotes: {
        id: "meeting-signal-instrumentation.content-keyword.discussion-notes",
        defaultMessage: "discussion notes"
    }
});
module.exports["titleKeywordMessages"] = $ae3f7d6d0e7de18b$export$650dc367698d00c6;
module.exports["contentKeywordMessages"] = $ae3f7d6d0e7de18b$export$50c58b2d87c2deae;

});

parcelRegister("aLdKz", function(module, exports) {
const $86ad379a82c4233e$var$escapeRegExp = (value)=>value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const $86ad379a82c4233e$var$BOUNDARY_START = '(?<![\\p{L}\\p{N}])';
const $86ad379a82c4233e$var$BOUNDARY_END = '(?![\\p{L}\\p{N}])';
const $86ad379a82c4233e$var$keywordRegExpCache = new WeakMap();
const $86ad379a82c4233e$var$buildKeywordPattern = (keyword)=>{
    const trimmed = keyword.trim();
    if (!trimmed) return null;
    return $86ad379a82c4233e$var$escapeRegExp(trimmed).replace(/\\?\s+/g, '\\s+');
};
const $86ad379a82c4233e$var$buildKeywordsRegExp = (keywords)=>{
    const cached = $86ad379a82c4233e$var$keywordRegExpCache.get(keywords);
    if (cached !== undefined) return cached;
    const patterns = keywords.reduce((result, keyword)=>{
        const pattern = $86ad379a82c4233e$var$buildKeywordPattern(keyword);
        if (pattern) result.push(pattern);
        return result;
    }, []);
    const regExp = patterns.length ? new RegExp(`${$86ad379a82c4233e$var$BOUNDARY_START}(?:${patterns.join('|')})${$86ad379a82c4233e$var$BOUNDARY_END}`, 'iu') : null;
    $86ad379a82c4233e$var$keywordRegExpCache.set(keywords, regExp);
    return regExp;
};
const $86ad379a82c4233e$export$f03a029d529b865c = (text, keywords)=>{
    if (!text || keywords.length === 0) return false;
    return $86ad379a82c4233e$var$buildKeywordsRegExp(keywords)?.test(text) ?? false;
};
module.exports["matchMeetingSignal"] = $86ad379a82c4233e$export$f03a029d529b865c;

});

parcelRegister("k6kVI", function(module, exports) {
/**
 * Template ID fragments for Confluence meeting templates.
 *
 * A template matches when its ID contains one of these fragments. The check ignores letter case.
 * Sprint Review is not in the list because Confluence has no matching template ID.
 */ const $643c77d21a6f0edd$var$MEETING_TEMPLATE_KEY_FRAGMENTS = [
    'meeting-notes',
    'recurring-meeting-minutes',
    '1-on-1-meeting',
    'daily-stand-up',
    'sprint-planning-meeting',
    'retrospective',
    'project-kickoff',
    'projectplan'
];
const $643c77d21a6f0edd$export$d5913fcea085e5c2 = (template)=>{
    const id = template?.id;
    if (!id) return false;
    const normalised = id.toLowerCase();
    return $643c77d21a6f0edd$var$MEETING_TEMPLATE_KEY_FRAGMENTS.some((fragment)=>normalised.includes(fragment));
};
module.exports["matchesMeetingTemplate"] = $643c77d21a6f0edd$export$d5913fcea085e5c2;

});

parcelRegister("jn9ek", function(module, exports) {
const $2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'third party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Edited 1st party blueprint has an error' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message) === 'Content created or updated with invalid arguments: Invalid space key specified.' && String(originalError?.response?.status) === '500';
};
const $2f7d9ade7a6b90fb$var$_isExceededRateError = (error)=>{
    const { originalError: originalError } = error;
    return String(originalError?.message).includes('rate limit exceeded');
};
const $2f7d9ade7a6b90fb$export$9ae592643c1ef19b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadThirdPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$af33641014b57bba = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isBadEditedFirstPartyBlueprintError);
};
const $2f7d9ade7a6b90fb$export$b6b21a057779c53b = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isInvalidSpaceKeyError);
};
const $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08 = (error)=>{
    return !!error?.graphQLErrors?.some($2f7d9ade7a6b90fb$var$_isExceededRateError);
};
const $2f7d9ade7a6b90fb$export$69408b85ed2a0e77 = (error)=>{
    if (error && 'graphQLErrors' in error) {
        const originalError = error.graphQLErrors?.[0]?.originalError;
        return originalError?.traceId || '';
    }
    return '';
};
module.exports["isBadThirdPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$9ae592643c1ef19b;
module.exports["isBadEditedFirstPartyBlueprintError"] = $2f7d9ade7a6b90fb$export$af33641014b57bba;
module.exports["isInvalidSpaceKeyError"] = $2f7d9ade7a6b90fb$export$b6b21a057779c53b;
module.exports["isRateExceededError"] = $2f7d9ade7a6b90fb$export$66b6e2f5ed3b8e08;
module.exports["getTraceIdFromApolloError"] = $2f7d9ade7a6b90fb$export$69408b85ed2a0e77;

});

parcelRegister("eDhGx", function(module, exports) {

var $4EPzQ = parcelRequire("4EPzQ");

const $aebb4f1677ca9e0c$var$parseAdf = (adf)=>{
    if (!adf) return null;
    if (typeof adf === 'string') try {
        return JSON.parse(adf);
    } catch  {
        return null;
    }
    return adf;
};
const $aebb4f1677ca9e0c$export$dfcbbff917a117e2 = (adf)=>{
    const doc = $aebb4f1677ca9e0c$var$parseAdf(adf);
    if (!doc) return '';
    const text = (0, $4EPzQ.reduce)(// Best-effort: the parsed value is treated as an ADFEntity for traversal.
    doc, (acc, node)=>{
        if (node.type === 'text' && typeof node.text === 'string') return `${acc}${node.text} `;
        return acc;
    }, '');
    return text.replace(/\s+/g, ' ').trim();
};
module.exports["adfToPlainText"] = $aebb4f1677ca9e0c$export$dfcbbff917a117e2;

});

parcelRegister("hl0fg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $9b206d933744c82f$export$42c02f33970a2afa = ()=>{
    const isClient = typeof window === 'object';
    const getSize = ()=>{
        return {
            width: isClient ? window.innerWidth : 0,
            height: isClient ? window.innerHeight : 0
        };
    };
    const [windowSize, setWindowSize] = (0, $cozmU.useState)(getSize);
    (0, $cozmU.useEffect)(()=>{
        const handleResize = (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(()=>{
            setWindowSize(getSize());
        }, 200);
        window.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            handleResize.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return windowSize;
};
module.exports["useWindowSize"] = $9b206d933744c82f$export$42c02f33970a2afa;

});

parcelRegister("9FtrC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d4962e1f9a762d77743dc0513d1a5d8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $709ec86ec7839cbd$var$_react = $709ec86ec7839cbd$var$_interopRequireDefault((parcelRequire("cozmU")));

var $709ec86ec7839cbd$var$_iconNew = $709ec86ec7839cbd$var$_interopRequireDefault((parcelRequire("QJ7O4")));
function $709ec86ec7839cbd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignContentBottom".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/align-content-bottom
 * Usage guidance:
 * Used for aligning bottom edges of content in Whiteboards
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $709ec86ec7839cbd$var$AlignContentBottomIcon = (props)=>/*#__PURE__*/ $709ec86ec7839cbd$var$_react.default.createElement($709ec86ec7839cbd$var$_iconNew.default, Object.assign({
        name: "AlignContentBottomIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 14.5h16V16H0zM4.38 13C3.62 13 3 12.38 3 11.63V2.38C3 1.62 3.62 1 4.38 1h1.5c.76 0 1.38.62 1.38 1.38v9.25c0 .76-.62 1.38-1.37 1.38zm.13-1.5h1.25v-9H4.5zm5.62 1.5c-.76 0-1.37-.62-1.37-1.37V7.38c0-.76.62-1.37 1.38-1.37h1.5C12.39 6 13 6.62 13 7.38v4.25c0 .76-.62 1.38-1.37 1.38zm.13-1.5h1.25v-4h-1.25z" clip-rule="evenodd"/>`
    }, props));
$709ec86ec7839cbd$var$AlignContentBottomIcon.displayName = 'AlignContentBottomIcon';
var $709ec86ec7839cbd$var$_default = module.exports.default = $709ec86ec7839cbd$var$AlignContentBottomIcon;

});

parcelRegister("3Xfhj", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bf3492583e212e7a$export$cf8a0a38543b2f6c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EfLS5",
    loader: async ()=>(await (parcelRequire("bGImc"))).PageContentRendererFabric,
    name: 'PageContentRendererFabric'
});

const $bf3492583e212e7a$export$43e0568dbf658f88 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VZbpe",
    loader: async ()=>(await (parcelRequire("eBICl"))).PageContentRendererTiny,
    name: 'PageContentRendererTiny'
});
module.exports["PageContentRendererFabric"] = $bf3492583e212e7a$export$cf8a0a38543b2f6c;
module.exports["PageContentRendererTiny"] = $bf3492583e212e7a$export$43e0568dbf658f88;

});

parcelRegister("bGImc", function(module, exports) {

let $88260656c63156ff$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $88260656c63156ff$var$load("knUU4"),
    $88260656c63156ff$var$load("16bOI"),
    $88260656c63156ff$var$load("jNdu9"),
    $88260656c63156ff$var$load("hyCrt"),
    $88260656c63156ff$var$load("aRCaA"),
    $88260656c63156ff$var$load("h3Rq9"),
    $88260656c63156ff$var$load("jwRVQ"),
    $88260656c63156ff$var$load("eF92L"),
    $88260656c63156ff$var$load("jwMHX"),
    $88260656c63156ff$var$load("6Qybl"),
    $88260656c63156ff$var$load("4PCFY"),
    $88260656c63156ff$var$load("fxlto"),
    $88260656c63156ff$var$load("2be0t"),
    $88260656c63156ff$var$load("jZGfM"),
    $88260656c63156ff$var$load("bqdgP"),
    $88260656c63156ff$var$load("aVpwX"),
    $88260656c63156ff$var$load("15jTz"),
    $88260656c63156ff$var$load("48F3z"),
    $88260656c63156ff$var$load("7SteV"),
    $88260656c63156ff$var$load("jE0Mz"),
    $88260656c63156ff$var$load("1AybA"),
    $88260656c63156ff$var$load("eUsnQ"),
    $88260656c63156ff$var$load("9LJFK"),
    $88260656c63156ff$var$load("d66hN"),
    $88260656c63156ff$var$load("dxA9F"),
    $88260656c63156ff$var$load("bkMxV"),
    $88260656c63156ff$var$load("cIoRg"),
    $88260656c63156ff$var$load("g7vSH"),
    $88260656c63156ff$var$load("ea3NB"),
    $88260656c63156ff$var$load("dxcsb"),
    $88260656c63156ff$var$load("6wr18"),
    $88260656c63156ff$var$load("ffEVr"),
    $88260656c63156ff$var$load("59hV4"),
    $88260656c63156ff$var$load("kJASg"),
    $88260656c63156ff$var$load("asCsc"),
    $88260656c63156ff$var$load("fYx6U"),
    $88260656c63156ff$var$load("botpL"),
    $88260656c63156ff$var$load("l4j2l"),
    $88260656c63156ff$var$load("37v60"),
    $88260656c63156ff$var$load("a7sEM"),
    $88260656c63156ff$var$load("7IvJj"),
    $88260656c63156ff$var$load("j7JUO"),
    $88260656c63156ff$var$load("cGkFm"),
    $88260656c63156ff$var$load("ckVWI"),
    $88260656c63156ff$var$load("bmOOW"),
    $88260656c63156ff$var$load("dDiWc"),
    $88260656c63156ff$var$load("d0ZRF"),
    $88260656c63156ff$var$load("k507P"),
    $88260656c63156ff$var$load("gaUhx"),
    $88260656c63156ff$var$load("5PKbS"),
    $88260656c63156ff$var$load("gFeoL"),
    $88260656c63156ff$var$load("9TOep"),
    $88260656c63156ff$var$load("bncmK"),
    $88260656c63156ff$var$load("8iu3F"),
    $88260656c63156ff$var$load("fWCBZ"),
    $88260656c63156ff$var$load("6iTkp"),
    $88260656c63156ff$var$load("gTa3u"),
    $88260656c63156ff$var$load("hhss7"),
    $88260656c63156ff$var$load("h6rbF"),
    $88260656c63156ff$var$load("jD5ZU"),
    $88260656c63156ff$var$load("aAWLw"),
    $88260656c63156ff$var$load("7EorR"),
    $88260656c63156ff$var$load("kNILH")
]).then(()=>parcelRequire('8ThhQ'));

});

parcelRegister("eBICl", function(module, exports) {

let $aa2721801d966478$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $aa2721801d966478$var$load("gRItA"),
    $aa2721801d966478$var$load("bncmK"),
    $aa2721801d966478$var$load("8iu3F"),
    $aa2721801d966478$var$load("j3lvX"),
    $aa2721801d966478$var$load("bm0oR"),
    $aa2721801d966478$var$load("3eyRH"),
    $aa2721801d966478$var$load("3Whaz"),
    $aa2721801d966478$var$load("15jTz"),
    $aa2721801d966478$var$load("48F3z"),
    $aa2721801d966478$var$load("5MQ0D"),
    $aa2721801d966478$var$load("cIoRg"),
    $aa2721801d966478$var$load("g7vSH"),
    $aa2721801d966478$var$load("jL1Ke"),
    $aa2721801d966478$var$load("fuOfV"),
    $aa2721801d966478$var$load("ea3NB"),
    $aa2721801d966478$var$load("6wr18"),
    $aa2721801d966478$var$load("ffEVr"),
    $aa2721801d966478$var$load("59hV4"),
    $aa2721801d966478$var$load("20wSi"),
    $aa2721801d966478$var$load("d0ZRF"),
    $aa2721801d966478$var$load("k507P"),
    $aa2721801d966478$var$load("fwbNS"),
    $aa2721801d966478$var$load("1T63O"),
    $aa2721801d966478$var$load("h4Nf7"),
    $aa2721801d966478$var$load("9TOep"),
    $aa2721801d966478$var$load("fWCBZ"),
    $aa2721801d966478$var$load("hhss7"),
    $aa2721801d966478$var$load("7EorR"),
    $aa2721801d966478$var$load("e9VVN")
]).then(()=>parcelRequire('ixmFo'));

});

parcelRegister("6m0us", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9wGTI = parcelRequire("9wGTI");

function $bc133074e939e7bd$var$clearStaticMacroStore(store) {
    store.html.clear();
    store.errors.clear();
    store.resultMetadata.clear();
    store.fullyLoaded = false;
    store.draftSyncCount = 0;
    store.lastMountDraftSyncCount.clear();
    store.presentAtLoad.clear();
    store.insertionRefetchStarted.clear();
    store.insertionRefetchGaveUp.clear();
    store.lastGuestParams.clear();
    store.pendingDraftSyncCallbacks.clear();
}
function $bc133074e939e7bd$var$createStaticMacroStore() {
    return {
        html: new Map(),
        errors: new Map(),
        resultMetadata: new Map(),
        nextResultVersion: 0,
        fullyLoaded: false,
        draftSyncCount: 0,
        lastMountDraftSyncCount: new Map(),
        presentAtLoad: new Set(),
        insertionRefetchStarted: new Set(),
        insertionRefetchGaveUp: new Set(),
        lastGuestParams: new Map(),
        pendingDraftSyncCallbacks: new Map(),
        draftSyncRequestScheduled: false
    };
}
/**
 * Builds two sets of extensionKeys by reading the preloaded extensions from
 * window.__SSR_FORGE_EXTENSIONS__:
 *  - staticKeys: keys that resolve to a Forge macro with staticView support
 *    (has a `static` property, e.g. `properties.static`).
 *  - knownKeys: every recognized/adopted key, static or not.
 *
 * Each extension contributes its own `key` (native/same-key adoption) plus any legacy
 * Connect macro keys listed in its `properties.migratedFrom` (alias-based adoption, where
 * the Forge module key differs from the original Connect macro key it replaces).
 *
 * This lets an untouched Connect-shaped node's legacy extensionKey resolve to eligibility
 * instantly via `knownKeys`/`staticKeys`, without waiting for the bulk staticMacros query.
 */ function $bc133074e939e7bd$var$buildExtensionKeySets() {
    const staticKeys = new Set();
    const knownKeys = new Set();
    try {
        const extensions = window.__SSR_FORGE_EXTENSIONS__?.['xen:macro']?.extensions ?? [];
        for (const ext of extensions){
            if (!ext?.key) continue;
            const isStatic = ext?.properties?.static != null;
            const migratedFrom = ext?.properties?.migratedFrom;
            const keysForExtension = [
                ext.key
            ];
            if (Array.isArray(migratedFrom)) {
                for (const legacyKey of migratedFrom)if (typeof legacyKey === 'string') keysForExtension.push(legacyKey);
            }
            for (const key of keysForExtension){
                knownKeys.add(key);
                if (isStatic) staticKeys.add(key);
            }
        }
    } catch  {
    // Defensive: if window access fails, return empty sets (all macros fall back to
    // waiting for the bulk query / iframe)
    }
    return {
        staticKeys: staticKeys,
        knownKeys: knownKeys
    };
}
const $bc133074e939e7bd$var$StaticMacroStoreContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
function $bc133074e939e7bd$export$fe63a9c79eca4b07({ children: children, contentId: contentId }) {
    const storeRef = (0, $cozmU.useRef)($bc133074e939e7bd$var$createStaticMacroStore());
    const storeContentIdRef = (0, $cozmU.useRef)(contentId);
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (contentId !== storeContentIdRef.current && (0, $9wGTI.fg)('conf_frontend_static_macro_perf')) {
        storeContentIdRef.current = contentId;
        $bc133074e939e7bd$var$clearStaticMacroStore(storeRef.current);
    }
    const listenersRef = (0, $cozmU.useRef)(new Map()); // localId -> listener callbacks
    const fullyLoadedListenersRef = (0, $cozmU.useRef)(new Set());
    const getExtensionKeySets = (0, $cozmU.useCallback)(()=>$bc133074e939e7bd$var$buildExtensionKeySets(), []);
    const subscribe = (0, $cozmU.useCallback)((localId, cb)=>{
        const listeners = listenersRef.current;
        if (!listeners.has(localId)) listeners.set(localId, new Set());
        listeners.get(localId).add(cb);
        fullyLoadedListenersRef.current.add(cb);
        return ()=>{
            listeners.get(localId)?.delete(cb);
            fullyLoadedListenersRef.current.delete(cb);
        };
    }, []);
    const register = (0, $cozmU.useCallback)((localId_0, html, options)=>{
        const store = storeRef.current;
        if (store.html.has(localId_0) && !options?.force) return;
        store.html.set(localId_0, html);
        // A forced (refetch) registration supersedes any previous error for this localId too.
        if (options?.force) store.errors.delete(localId_0);
        store.resultMetadata.set(localId_0, {
            attempt: options?.attempt ?? 'initial',
            version: store.nextResultVersion++
        });
        listenersRef.current.get(localId_0)?.forEach((cb_0)=>cb_0({
                type: 'static-macro-result'
            }));
    }, []);
    const registerError = (0, $cozmU.useCallback)((localId_1, errorCode, options_0)=>{
        const store_0 = storeRef.current;
        if (store_0.errors.has(localId_1) && !options_0?.force) return;
        store_0.errors.set(localId_1, errorCode);
        if (options_0?.force) store_0.html.delete(localId_1);
        store_0.resultMetadata.set(localId_1, {
            attempt: options_0?.attempt ?? 'initial',
            version: store_0.nextResultVersion++
        });
        listenersRef.current.get(localId_1)?.forEach((cb_1)=>cb_1({
                type: 'static-macro-result'
            }));
    }, []);
    const markFullyLoaded = (0, $cozmU.useCallback)(()=>{
        storeRef.current.fullyLoaded = true;
        fullyLoadedListenersRef.current.forEach((cb_2)=>cb_2({
                type: 'fully-loaded'
            }));
    }, []);
    const isStaticExtension = (0, $cozmU.useCallback)((extensionKey)=>getExtensionKeySets().staticKeys.has(extensionKey), [
        getExtensionKeySets
    ]);
    const isKnownExtension = (0, $cozmU.useCallback)((extensionKey_0)=>getExtensionKeySets().knownKeys.has(extensionKey_0), [
        getExtensionKeySets
    ]);
    const hasMountedBefore = (0, $cozmU.useCallback)((localId_2)=>storeRef.current.lastMountDraftSyncCount.has(localId_2), []);
    const markMounted = (0, $cozmU.useCallback)((localId_3)=>{
        const store_1 = storeRef.current;
        store_1.lastMountDraftSyncCount.set(localId_3, store_1.draftSyncCount);
    }, []);
    const hasDraftSyncedSinceLastMount = (0, $cozmU.useCallback)((localId_4)=>{
        const store_2 = storeRef.current;
        const countAtLastMount = store_2.lastMountDraftSyncCount.get(localId_4);
        return countAtLastMount !== undefined && store_2.draftSyncCount > countAtLastMount;
    }, []);
    const markPresentAtLoad = (0, $cozmU.useCallback)((localId_5)=>{
        storeRef.current.presentAtLoad.add(localId_5);
    }, []);
    const wasPresentAtLoad = (0, $cozmU.useCallback)((localId_6)=>storeRef.current.presentAtLoad.has(localId_6), []);
    const rememberGuestParams = (0, $cozmU.useCallback)((localId_7, serializedGuestParams)=>{
        const lastGuestParams = storeRef.current.lastGuestParams;
        const previous = lastGuestParams.get(localId_7);
        lastGuestParams.set(localId_7, serializedGuestParams);
        return previous;
    }, []);
    const notifyRefetchExhausted = (0, $cozmU.useCallback)((localId_8, attempt)=>{
        if (attempt === 'insertion') storeRef.current.insertionRefetchGaveUp.add(localId_8);
        listenersRef.current.get(localId_8)?.forEach((cb_3)=>cb_3({
                type: 'refetch-exhausted'
            }));
    }, []);
    const refetchTriggerRef = (0, $cozmU.useRef)(null);
    const triggerRefetch = (0, $cozmU.useCallback)((localId_9, attempt_0)=>{
        refetchTriggerRef.current?.(localId_9, attempt_0);
    }, []);
    const setRefetchTrigger = (0, $cozmU.useCallback)((fn)=>{
        refetchTriggerRef.current = fn;
    }, []);
    const draftSyncRequesterRef = (0, $cozmU.useRef)(null);
    const setDraftSyncRequester = (0, $cozmU.useCallback)((fn_0)=>{
        draftSyncRequesterRef.current = fn_0;
    }, []);
    const requestDraftSync = (0, $cozmU.useCallback)(()=>{
        const store_3 = storeRef.current;
        if (store_3.draftSyncRequestScheduled) return;
        store_3.draftSyncRequestScheduled = true;
        queueMicrotask(()=>{
            store_3.draftSyncRequestScheduled = false;
            draftSyncRequesterRef.current?.();
        });
    }, []);
    const deferUntilDraftSync = (0, $cozmU.useCallback)((localId_10, callback)=>{
        const callbacks = storeRef.current.pendingDraftSyncCallbacks;
        const pending = {
            callback: callback,
            registeredAt: performance.now()
        };
        callbacks.set(localId_10, pending);
        return ()=>{
            if (callbacks.get(localId_10) === pending) callbacks.delete(localId_10);
        };
    }, []);
    const notifyDraftSyncCompleted = (0, $cozmU.useCallback)((syncStartedAt)=>{
        const store_4 = storeRef.current;
        store_4.draftSyncCount++;
        const isSyncStartAware = syncStartedAt !== undefined && // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the gate for this change at the developer's request.
        (0, $9wGTI.fg)('forge_static_macros_ux_imp');
        const ready = [];
        store_4.pendingDraftSyncCallbacks.forEach(({ callback: callback_0, registeredAt: registeredAt }, localId_11)=>{
            if (isSyncStartAware && syncStartedAt < registeredAt) return;
            ready.push(callback_0);
            store_4.pendingDraftSyncCallbacks.delete(localId_11);
        });
        if (isSyncStartAware && store_4.pendingDraftSyncCallbacks.size > 0) requestDraftSync();
        ready.forEach((callback_1)=>callback_1());
    }, [
        requestDraftSync
    ]);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            storeRef: storeRef,
            subscribe: subscribe,
            register: register,
            registerError: registerError,
            markFullyLoaded: markFullyLoaded,
            isStaticExtension: isStaticExtension,
            isKnownExtension: isKnownExtension,
            hasMountedBefore: hasMountedBefore,
            markMounted: markMounted,
            hasDraftSyncedSinceLastMount: hasDraftSyncedSinceLastMount,
            markPresentAtLoad: markPresentAtLoad,
            wasPresentAtLoad: wasPresentAtLoad,
            rememberGuestParams: rememberGuestParams,
            triggerRefetch: triggerRefetch,
            notifyRefetchExhausted: notifyRefetchExhausted,
            deferUntilDraftSync: deferUntilDraftSync,
            notifyDraftSyncCompleted: notifyDraftSyncCompleted,
            setRefetchTrigger: setRefetchTrigger,
            requestDraftSync: requestDraftSync,
            setDraftSyncRequester: setDraftSyncRequester
        }), [
        storeRef,
        subscribe,
        register,
        registerError,
        markFullyLoaded,
        isStaticExtension,
        isKnownExtension,
        hasMountedBefore,
        markMounted,
        hasDraftSyncedSinceLastMount,
        markPresentAtLoad,
        wasPresentAtLoad,
        rememberGuestParams,
        triggerRefetch,
        notifyRefetchExhausted,
        deferUntilDraftSync,
        notifyDraftSyncCompleted,
        setRefetchTrigger,
        requestDraftSync,
        setDraftSyncRequester
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        value: (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp') ? contextValue : null
    }, children);
}
const $bc133074e939e7bd$export$ae4400d9e980652e = (0, $3u0dr.isReactCompilerActiveV2)() ? function useStaticMacroStoreContext() {
    return (0, $cozmU.useContext)($bc133074e939e7bd$var$StaticMacroStoreContext);
} : function useStaticMacroStoreContext() {
    return (0, $cozmU.useContext)($bc133074e939e7bd$var$StaticMacroStoreContext);
};
const $bc133074e939e7bd$export$519dc241c1a942d0 = (0, $3u0dr.isReactCompilerActiveV2)() ? function ResetStaticMacroStoreContext(t0) {
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
            value: null
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : function ResetStaticMacroStoreContext({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bc133074e939e7bd$var$StaticMacroStoreContext.Provider, {
        value: null
    }, children);
};
module.exports["StaticMacroStoreProvider"] = $bc133074e939e7bd$export$fe63a9c79eca4b07;
module.exports["useStaticMacroStoreContext"] = $bc133074e939e7bd$export$ae4400d9e980652e;
module.exports["ResetStaticMacroStoreContext"] = $bc133074e939e7bd$export$519dc241c1a942d0;

});

parcelRegister("id4ij", function(module, exports) {
function $21c1903a8ac50cbe$export$f25538161b7e9c17(element) {
    let top = element.offsetTop;
    while(element.offsetParent){
        element = element.offsetParent;
        top += element.offsetTop;
    }
    return top;
}
function $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container) {
    if (!element) return false;
    container = container || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.scrollingElement || // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.body.parentNode;
    if (!container) return false;
    const height = element.offsetHeight;
    const top = $21c1903a8ac50cbe$export$f25538161b7e9c17(element);
    const containerTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(container) + container.scrollTop;
    const containerHeight = container.offsetHeight;
    return top >= containerTop && top + height <= containerTop + containerHeight;
}
function $21c1903a8ac50cbe$export$e41e80160bed5714(node) {
    // @ts-ignore
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    if (!node || node === document) return null;
    const nodeStyle = window.getComputedStyle(node);
    if (node.scrollHeight > node.clientHeight && node.style.overflow !== 'hidden' && nodeStyle.overflow !== 'visible') return node;
    else return $21c1903a8ac50cbe$export$e41e80160bed5714(node.parentNode);
}
function $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2(element, container) {
    container = container || $21c1903a8ac50cbe$export$e41e80160bed5714(element);
    if (!element || !container || $21c1903a8ac50cbe$export$7cc0e9dd2435cb30(element, container)) return;
    container.scrollTop = $21c1903a8ac50cbe$export$f25538161b7e9c17(element) - $21c1903a8ac50cbe$export$f25538161b7e9c17(container) - container.clientHeight / 2;
}
function $21c1903a8ac50cbe$export$abe5643cba19555f(element) {
    return element.getBoundingClientRect();
}
function $21c1903a8ac50cbe$export$4c0864c7defafad3(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top, bottom: bottom } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    const bottomIsVisible = 0 <= bottom && bottom <= viewportHeight;
    const isBiggerThanViewPort = top <= 0 && 0 <= bottom && bottom >= viewportHeight;
    return topIsVisible || bottomIsVisible || isBiggerThanViewPort;
}
function $21c1903a8ac50cbe$export$4acade851e875ad4(element, documentObject) {
    const docEl = documentObject ? documentObject.documentElement : window.document.documentElement;
    if (!element || !docEl) return;
    const boundaries = element.getBoundingClientRect();
    const { top: top } = boundaries;
    const viewportHeight = docEl.offsetHeight;
    const topIsVisible = 0 <= top && top < viewportHeight;
    return topIsVisible;
}
function $21c1903a8ac50cbe$export$5513bf0589d602a4(targetDomElementId, htmlMarkup) {
    // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    let el = document.getElementById(targetDomElementId);
    if (!el) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.createElement('div');
        el.setAttribute('id', targetDomElementId);
        el.setAttribute('style', 'display: none');
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        document.body.appendChild(el);
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        el = document.getElementById(targetDomElementId);
    }
    if (!el) return;
    el.innerHTML = '';
    if (htmlMarkup) {
        // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
        const range = document.createRange();
        const fragment = range.createContextualFragment(htmlMarkup);
        el.appendChild(fragment);
    }
}
module.exports["getElementTop"] = $21c1903a8ac50cbe$export$f25538161b7e9c17;
module.exports["isElementInViewport"] = $21c1903a8ac50cbe$export$7cc0e9dd2435cb30;
module.exports["scrollElementToViewCenter"] = $21c1903a8ac50cbe$export$c3e8c6d4b3b72bf2;
module.exports["getElementBounds"] = $21c1903a8ac50cbe$export$abe5643cba19555f;
module.exports["isPartOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4c0864c7defafad3;
module.exports["isTopOfElementStillInViewPort"] = $21c1903a8ac50cbe$export$4acade851e875ad4;
module.exports["replaceDomElementContent"] = $21c1903a8ac50cbe$export$5513bf0589d602a4;

});

parcelRegister("3vuEo", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $kcIQr = parcelRequire("kcIQr");


var $lW5tg = parcelRequire("lW5tg");


var $ep3mz = parcelRequire("ep3mz");


var $1P7Cq = parcelRequire("1P7Cq");

const $e701977e7769884e$var$MeasuredForgeMacro = (0, $3u0dr.isReactCompilerActiveV2)() ? function MeasuredForgeMacro(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { extensionKey: extensionKey, children: children } = t0;
    const elementRef = (0, $cozmU.useRef)(null);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId } = t1;
    const isSSROrHydrating = (0, $1P7Cq.useIsSSROrHydrating)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    let t2;
    if ($[0] !== createEvent || $[1] !== extensionKey || $[2] !== isSSROrHydrating) {
        t2 = ()=>{
            const element = elementRef.current;
            if (!element || isSSROrHydrating) return;
            return (0, $lW5tg.observeContentMacroDimensions)(element, "forge", extensionKey, (t3)=>{
                const { height: height, width: width } = t3;
                createEvent({
                    type: "sendOperationalEvent",
                    data: {
                        source: "forgeMacroRenderer",
                        action: "render",
                        actionSubject: "forgeMacro",
                        attributes: {
                            extensionKey: extensionKey,
                            height: height,
                            width: width
                        }
                    }
                }).fire();
            });
        };
        $[0] = createEvent;
        $[1] = extensionKey;
        $[2] = isSSROrHydrating;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== contentId || $[5] !== createEvent || $[6] !== extensionKey || $[7] !== isSSROrHydrating) {
        t3 = [
            contentId,
            extensionKey,
            isSSROrHydrating,
            createEvent
        ];
        $[4] = contentId;
        $[5] = createEvent;
        $[6] = extensionKey;
        $[7] = isSSROrHydrating;
        $[8] = t3;
    } else t3 = $[8];
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== children) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: elementRef
        }, children);
        $[9] = children;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : function MeasuredForgeMacro({ extensionKey: extensionKey, children: children }) {
    const elementRef = (0, $cozmU.useRef)(null);
    const [{ contentId: contentId }] = (0, $ep3mz.usePageState)();
    const isSSROrHydrating = (0, $1P7Cq.useIsSSROrHydrating)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const element = elementRef.current;
        if (!element || isSSROrHydrating) return;
        return (0, $lW5tg.observeContentMacroDimensions)(element, 'forge', extensionKey, ({ height: height, width: width })=>{
            createEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'forgeMacroRenderer',
                    action: 'render',
                    actionSubject: 'forgeMacro',
                    attributes: {
                        extensionKey: extensionKey,
                        height: height,
                        width: width
                    }
                }
            }).fire();
        });
    }, [
        contentId,
        extensionKey,
        isSSROrHydrating,
        createEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: elementRef
    }, children);
};
function $e701977e7769884e$export$8c6fe207fa6bd8f9(isEditing) {
    return !isEditing && (0, $lW5tg.getContentMacroMeasurementScope)().forge;
}
const $e701977e7769884e$export$7092560617ba9fd4 = (0, $3u0dr.isReactCompilerActiveV2)() ? function ForgeMacroMeasurements(props) {
    const $ = (0, $bDgLe.c)(4);
    if (props.nodeType !== "extension" && props.nodeType !== "bodiedExtension" || !props.extensionKey || !$e701977e7769884e$export$8c6fe207fa6bd8f9(props.isEditing)) {
        let t0;
        if ($[0] !== props.children) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
            $[0] = props.children;
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    let t0;
    if ($[2] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e701977e7769884e$var$MeasuredForgeMacro, props);
        $[2] = props;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : function ForgeMacroMeasurements(props) {
    if (props.nodeType !== 'extension' && props.nodeType !== 'bodiedExtension' || !props.extensionKey || !$e701977e7769884e$export$8c6fe207fa6bd8f9(props.isEditing)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e701977e7769884e$var$MeasuredForgeMacro, props);
};
module.exports["ForgeMacroMeasurements"] = $e701977e7769884e$export$7092560617ba9fd4;

});

parcelRegister("huSww", function(module, exports) {
/* ForgeMacro.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $lfoFx = parcelRequire("lfoFx");


var $9wGTI = parcelRequire("9wGTI");


var $1XIV5 = parcelRequire("1XIV5");


var $6m0us = parcelRequire("6m0us");

const $689e73fff1c3c213$var$spinnerWrapperStyles = null; // How long a newly inserted macro waits for its insertion to be saved before falling back to the iframe.
const $689e73fff1c3c213$export$2f424e2ddf9f9c81 = 30000;
const $689e73fff1c3c213$export$9b14103f777dfdef = 30000;
function $689e73fff1c3c213$var$getNestedMacroLocalIds(node) {
    const localIds = new Set();
    const visit = (nodes)=>{
        const childNodes = Array.isArray(nodes) ? nodes : typeof nodes === 'object' && nodes !== null && Array.isArray(nodes.content) ? nodes.content : [];
        childNodes.forEach((child)=>{
            const type = typeof child.type === 'string' ? child.type : child.type?.name;
            if ([
                'extension',
                'bodiedExtension',
                'inlineExtension'
            ].includes(type)) {
                const localId = child.localId ?? child.attrs?.localId ?? child.parameters?.localId ?? child.attrs?.parameters?.localId;
                if (localId) localIds.add(localId);
            }
            visit(child.content);
        });
    };
    visit(node?.content);
    return Array.from(localIds);
}
function $689e73fff1c3c213$export$7914a38f4e6c4db9(isEditing, isLivePage) {
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) return undefined;
    return (node, renderFn)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($689e73fff1c3c213$export$4dada8c8c9499dbf, {
            ...$689e73fff1c3c213$export$f7f0bb6d998169d8(node),
            renderIframe: ()=>renderFn({
                    references: []
                }),
            isEditing: isEditing,
            isLivePage: isLivePage
        });
} /** The `ForgeMacro` props derived from an ADF extension node, shared by every handler that renders it. */ 
function $689e73fff1c3c213$export$f7f0bb6d998169d8(node) {
    // Untouched Connect macros keep extensionType `com.atlassian.confluence.macro.core` and are
    // keyed in `confluence_staticMacros` by `parameters.macroMetadata.macroId`, not `localId`.
    const isConnectShapedNode = node?.extensionType === 'com.atlassian.confluence.macro.core';
    return {
        localId: isConnectShapedNode ? node?.parameters?.macroMetadata?.macroId?.value : node?.localId ?? node?.parameters?.localId,
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        extensionKey: node?.extensionKey?.split('/').at(-1),
        guestParams: node?.parameters?.guestParams || node?.parameters?.config,
        isConnectShapedNode: isConnectShapedNode,
        nestedMacroLocalIds: $689e73fff1c3c213$var$getNestedMacroLocalIds(node)
    };
}
function $689e73fff1c3c213$export$4dada8c8c9499dbf({ localId: localId, extensionKey: extensionKey, guestParams: guestParams, renderIframe: renderIframe, isEditing: isEditing, isLivePage: isLivePage, isConnectShapedNode: isConnectShapedNode, nestedMacroLocalIds: nestedMacroLocalIds = [], preloadedHtml: preloadedHtml }) {
    const ctx = (0, $6m0us.useStaticMacroStoreContext)();
    const store = ctx?.storeRef.current;
    const [, forceUpdate] = (0, $cozmU.useReducer)((n)=>n + 1, 0);
    const [isRefetching, setIsRefetching] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const readyEventEmittedRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(false); // Check if this extension supports staticView, based on preloaded extension data.
    // extensionsLoaded is true when __SSR_FORGE_EXTENSIONS__ has been populated.
    //
    // Native Forge extensions resolve via their own extensionKey (ctx.isStaticExtension).
    // Connect-shaped nodes resolve against the SAME preloaded data using their legacy
    // extensionKey — matched either via the adopted extension's own key (same-key adoption)
    // or its migratedFrom aliases (different-key adoption) — so a Connect-shaped node whose
    // adopted extension is confirmed non-static can fall back to the iframe immediately, once
    // extensions have loaded, without waiting for the bulk staticMacros query at all.
    //
    // If no match is found yet (extensions not loaded, or genuinely unrecognized), treat the
    // node as "maybe static" and rely on store.fullyLoaded below: a Connect-shaped node is
    // never newly inserted, so a missing static result once the bulk query completes means it
    // isn't static.
    const isKnownStaticExtension = !!extensionKey && !!ctx?.isStaticExtension(extensionKey);
    const isKnownNonStaticExtension = !!isConnectShapedNode && !!extensionKey && !!ctx?.isKnownExtension(extensionKey) && !isKnownStaticExtension;
    const hasStaticResult = !!localId && (!!store?.html.has(localId) || !!store?.errors.has(localId));
    const mightBeStaticConnectMacro = !!isConnectShapedNode && !isKnownNonStaticExtension && (!store?.fullyLoaded || hasStaticResult);
    const isStatic = isKnownStaticExtension || mightBeStaticConnectMacro;
    const extensionsLoaded = !!window.__SSR_FORGE_EXTENSIONS__?.['xen:macro']?.extensions?.length;
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId) return;
        const handleUpdate = ({ type: type })=>{
            // Only an update for this macro completes a refetch. Bulk-query completion must not end a
            // pending refetch started by a parameter change.
            if (type !== 'fully-loaded') setIsRefetching(false);
            forceUpdate();
        };
        const unsubscribe = ctx.subscribe(localId, handleUpdate); // Data may have already arrived before we subscribed — check immediately.
        if (store?.html.has(localId) || store?.errors.has(localId)) handleUpdate({
            type: 'static-macro-result'
        });
        else if (store?.fullyLoaded) handleUpdate({
            type: 'fully-loaded'
        });
        return unsubscribe;
    }, [
        ctx,
        localId,
        forceUpdate,
        store
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (ctx && localId && !ctx.storeRef.current?.fullyLoaded) ctx.markPresentAtLoad(localId);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // The bridge sends one request and, if it brings back no HTML, one retry. The spinner stops when
    // either returns a result or both come back empty.
    const startPostEditRefetch = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!ctx || !localId) return;
        setIsRefetching(true);
        ctx.triggerRefetch(localId, 'edit');
    }, [
        ctx,
        localId
    ]);
    const deferPostEditRefetchUntilDraftSync = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!ctx || !localId) return undefined;
        return ctx.deferUntilDraftSync(localId, startPostEditRefetch);
    }, [
        ctx,
        localId,
        startPostEditRefetch
    ]);
    const showSpinnerAndDeferRefetchUntilDraftSync = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (!ctx || !localId) return undefined;
        setIsRefetching(true);
        const spinnerTimeoutId = setTimeout(()=>setIsRefetching(false), $689e73fff1c3c213$export$9b14103f777dfdef);
        const removeDeferredRefetch = ctx.deferUntilDraftSync(localId, ()=>{
            clearTimeout(spinnerTimeoutId);
            startPostEditRefetch();
        });
        ctx.requestDraftSync();
        return ()=>{
            removeDeferredRefetch();
            clearTimeout(spinnerTimeoutId);
        };
    }, [
        ctx,
        localId,
        startPostEditRefetch
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic) return undefined;
        if (!isEditing || !isLivePage) return undefined;
         // Editors can remount node views without any change, e.g. while loading. Only a remount after
        // a draft sync, such as finishing a body edit, means the macro may have changed.
        const isRemountAfterDraftSync = ctx.hasMountedBefore(localId) && ctx.hasDraftSyncedSinceLastMount(localId);
        ctx.markMounted(localId);
        if (!isRemountAfterDraftSync) return undefined;
        if (nestedMacroLocalIds.length > 0) {
            startPostEditRefetch();
            return undefined;
        }
        const removeDeferredRefetch = deferPostEditRefetchUntilDraftSync(); // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the gate for this change at the developer's request.
        if ((0, $9wGTI.fg)('forge_static_macros_ux_imp')) ctx.requestDraftSync();
        return removeDeferredRefetch; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const guestParamsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(undefined);
    const serializedGuestParams = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>JSON.stringify(guestParams ?? null), [
        guestParams
    ]);
    const errorCode = localId ? store?.errors.get(localId) : undefined;
    const html = (localId ? store?.html.get(localId) : undefined) ?? (localId && errorCode === undefined ? preloadedHtml : undefined);
    const resultMetadata = localId ? store?.resultMetadata.get(localId) : undefined;
    (0, $1XIV5.useStaticMacroRenderAnalytics)({
        html: html,
        errorCode: errorCode,
        result: resultMetadata,
        isEditing: Boolean(isEditing),
        isLivePage: Boolean(isLivePage)
    }); // Signal cc-puppeteer that this static macro has finished rendering.
    // cc-puppeteer's waitForAllExtensionReadyEvents() waits for EXTENSION_READY from every
    // Forge extension it finds in the ADF (regardless of emitsReadyEvent manifest declaration).
    // Without this signal, the full 10s timeout is consumed on every PDF export with a static macro.
    // Guarded by a ref so it only fires once per ForgeMacro instance.
    (0, $cozmU.useEffect)(()=>{
        if (html && localId && !readyEventEmittedRef.current) {
            readyEventEmittedRef.current = true;
            window.postMessage({
                source: 'forge-extension',
                type: 'EXTENSION_READY',
                localId: localId
            }, window.location.origin);
        }
    }, [
        html,
        localId
    ]); // When a config changes, we want to trigger a re-render.
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic || !isEditing) return undefined;
        const serialized = serializedGuestParams; // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the gate for this change at the developer's request.
        if ((0, $9wGTI.fg)('forge_static_macros_ux_imp')) {
            const prev = ctx.rememberGuestParams(localId, serialized); // Skip on first render for this macro instance — only refetch on subsequent changes.
            if (prev === undefined || prev === serialized) return undefined; // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- The rule only detects cleanups returned at the top level of the effect.
            return showSpinnerAndDeferRefetchUntilDraftSync();
        } else {
            const prev = guestParamsRef.current;
            guestParamsRef.current = serialized; // Skip on first render for this macro instance — only refetch on subsequent changes.
            if (prev === undefined || prev === serialized) return undefined; // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- The rule only detects cleanups returned at the top level of the effect.
            return deferPostEditRefetchUntilDraftSync();
        }
    }, [
        ctx,
        localId,
        isStatic,
        isEditing,
        serializedGuestParams,
        deferPostEditRefetchUntilDraftSync,
        showSpinnerAndDeferRefetchUntilDraftSync
    ]);
    const isFullyLoaded = !!store?.fullyLoaded;
    (0, $cozmU.useEffect)(()=>{
        if (!ctx || !localId || !isStatic || !isEditing) return undefined;
        if (!isFullyLoaded) return undefined;
        if (html !== undefined || errorCode !== undefined) return undefined; // Macros that were on the page when it loaded weren't inserted. Without a result, they're not static.
        if (ctx.wasPresentAtLoad(localId)) return undefined;
        const currentStore = ctx.storeRef.current;
        if (!currentStore || currentStore.insertionRefetchGaveUp.has(localId) || currentStore.insertionRefetchStarted.has(localId)) return undefined;
         // Don't request anything until the insertion has been saved. If the request and its retry come
        // back empty, the store marks the insertion as given up.
        const giveUpTimeoutId = setTimeout(()=>{
            currentStore.insertionRefetchGaveUp.add(localId);
            forceUpdate();
        }, $689e73fff1c3c213$export$2f424e2ddf9f9c81);
        const removeDeferredRefetch = ctx.deferUntilDraftSync(localId, ()=>{
            clearTimeout(giveUpTimeoutId);
            currentStore.insertionRefetchStarted.add(localId);
            ctx.triggerRefetch(localId, 'insertion');
        }); // eslint-disable-next-line confluence-feature-gating/no-new-feature-gates -- Retain the gate for this change at the developer's request.
        if ((0, $9wGTI.fg)('forge_static_macros_ux_imp')) ctx.requestDraftSync();
        return ()=>{
            removeDeferredRefetch();
            clearTimeout(giveUpTimeoutId);
        };
    }, [
        ctx,
        localId,
        isStatic,
        isEditing,
        isFullyLoaded,
        html,
        errorCode,
        forceUpdate
    ]);
    if (!ctx || !localId || !store) return renderIframe();
    if (isRefetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }));
    if (html) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "forge-static-macro-content",
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
    if (errorCode) return renderIframe();
     // Once the query is fully loaded, any macro without html/error is not a static macro → iframe.
    // Also fall back immediately if we KNOW this extension doesn't support staticView —
    // only treat !isStatic as definitive when extensions have actually been loaded.
    // If extensions aren't loaded yet, show spinner and wait (preloader may still be in-flight).
    const isAwaitingInsertedContent = isStatic && isEditing && !ctx.wasPresentAtLoad(localId) && !store.insertionRefetchGaveUp.has(localId);
    if ((store.fullyLoaded || extensionsLoaded && !isStatic) && !isAwaitingInsertedContent) return renderIframe();
     // Extension supports staticView but data hasn't arrived yet — show spinner briefly.
    // Use the same testid as the iframe loader so cc-puppeteer waits for it to disappear.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "forge-app-loading-spinner",
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small"
    }));
}
module.exports["createForgeMacroExtensionHandler"] = $689e73fff1c3c213$export$7914a38f4e6c4db9;
module.exports["ForgeMacro"] = $689e73fff1c3c213$export$4dada8c8c9499dbf;
module.exports["getForgeMacroNodeProps"] = $689e73fff1c3c213$export$f7f0bb6d998169d8;

});

parcelRegister("1XIV5", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kcIQr = parcelRequire("kcIQr");

const $a0009ac6b88376d4$export$b3b7b4b4f7dc8ee9 = (0, $3u0dr.isReactCompilerActiveV2)() ? function useStaticMacroRenderAnalytics(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { html: html, errorCode: errorCode, result: result, isEditing: isEditing, isLivePage: isLivePage } = t0;
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = new Set();
        $[0] = t1;
    } else t1 = $[0];
    const reportedResultVersionsRef = (0, $cozmU.useRef)(t1);
    let t2;
    let t3;
    if ($[1] !== createEvent || $[2] !== html || $[3] !== isEditing || $[4] !== isLivePage || $[5] !== result) {
        t2 = ()=>{
            if (!html || !result || reportedResultVersionsRef.current.has(result.version)) return;
            reportedResultVersionsRef.current.add(result.version);
            createEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "forgeStaticMacro",
                    action: "rendered",
                    actionSubject: "staticMacro",
                    attributes: {
                        attempt: result.attempt,
                        renderMode: "static",
                        isEditing: isEditing,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        t3 = [
            createEvent,
            html,
            isEditing,
            isLivePage,
            result
        ];
        $[1] = createEvent;
        $[2] = html;
        $[3] = isEditing;
        $[4] = isLivePage;
        $[5] = result;
        $[6] = t2;
        $[7] = t3;
    } else {
        t2 = $[6];
        t3 = $[7];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[8] !== createEvent || $[9] !== errorCode || $[10] !== html || $[11] !== isEditing || $[12] !== isLivePage || $[13] !== result) {
        t4 = ()=>{
            if (!errorCode || html || !result || reportedResultVersionsRef.current.has(result.version)) return;
            reportedResultVersionsRef.current.add(result.version);
            createEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "forgeStaticMacro",
                    action: "failed",
                    actionSubject: "staticMacro",
                    attributes: {
                        attempt: result.attempt,
                        renderMode: "iframe-fallback",
                        errorCode: errorCode,
                        isEditing: isEditing,
                        isLivePage: isLivePage
                    }
                }
            }).fire();
        };
        t5 = [
            createEvent,
            errorCode,
            html,
            isEditing,
            isLivePage,
            result
        ];
        $[8] = createEvent;
        $[9] = errorCode;
        $[10] = html;
        $[11] = isEditing;
        $[12] = isLivePage;
        $[13] = result;
        $[14] = t4;
        $[15] = t5;
    } else {
        t4 = $[14];
        t5 = $[15];
    }
    (0, $cozmU.useEffect)(t4, t5);
} : function useStaticMacroRenderAnalytics({ html: html, errorCode: errorCode, result: result, isEditing: isEditing, isLivePage: isLivePage }) {
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const reportedResultVersionsRef = (0, $cozmU.useRef)(new Set());
    (0, $cozmU.useEffect)(()=>{
        if (!html || !result || reportedResultVersionsRef.current.has(result.version)) return;
        reportedResultVersionsRef.current.add(result.version);
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'forgeStaticMacro',
                action: 'rendered',
                actionSubject: 'staticMacro',
                attributes: {
                    attempt: result.attempt,
                    renderMode: 'static',
                    isEditing: isEditing,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        createEvent,
        html,
        isEditing,
        isLivePage,
        result
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!errorCode || html || !result || reportedResultVersionsRef.current.has(result.version)) return;
        reportedResultVersionsRef.current.add(result.version);
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'forgeStaticMacro',
                action: 'failed',
                actionSubject: 'staticMacro',
                attributes: {
                    attempt: result.attempt,
                    renderMode: 'iframe-fallback',
                    errorCode: errorCode,
                    isEditing: isEditing,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        createEvent,
        errorCode,
        html,
        isEditing,
        isLivePage,
        result
    ]);
};
module.exports["useStaticMacroRenderAnalytics"] = $a0009ac6b88376d4$export$b3b7b4b4f7dc8ee9;

});

parcelRegister("2HGN8", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jMyy4 = parcelRequire("jMyy4");


var $g6QPm = parcelRequire("g6QPm");


var $6mKj3 = parcelRequire("6mKj3");


var $hYoU4 = parcelRequire("hYoU4");


var $8VcPj = parcelRequire("8VcPj");


var $1d2ww = parcelRequire("1d2ww");


var $iWKHx = parcelRequire("iWKHx");

const $652df36b21c46ede$var$ContentAppearanceContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    contentAppearance: {
        appearance: (0, $1d2ww.ContentAppearanceType).DEFAULT,
        version: 0
    },
    setContentAppearance: ()=>{},
    contentAppearanceLoading: false
});
const $652df36b21c46ede$export$53c04435be7a0acf = ({ contentId: contentId, children: children })=>{
    const [contentAppearanceOverride, setContentAppearanceOverride] = (0, $cozmU.useState)();
    // Clear the override state when navigating to a different page
    (0, $cozmU.useEffect)(()=>{
        setContentAppearanceOverride(undefined);
    }, [
        contentId
    ]);
    const [{ collabEditProvider: collabEditProvider }] = (0, $hYoU4.useNativeCollabState)();
    // Subscribe to metadata:changed events to update the content appearance for collaborators
    (0, $cozmU.useEffect)(()=>{
        if (!collabEditProvider) return;
        const handleMetadataChanged = (metadata)=>{
            const editorWidth = metadata?.editorWidth;
            const widthValue = editorWidth?.value;
            const version = editorWidth?.version;
            if (widthValue && version !== undefined) setContentAppearanceOverride((currentAppearance)=>{
                if (!currentAppearance || version > currentAppearance.version) return {
                    appearance: widthValue,
                    version: version
                };
                else return currentAppearance;
            });
        };
        collabEditProvider.on('metadata:changed', handleMetadataChanged);
        return ()=>{
            collabEditProvider.off('metadata:changed', handleMetadataChanged);
        };
    }, [
        collabEditProvider
    ]);
    /*
  	Previous check was:
  	const draftAppearanceQuery = getContentAppearanceQuery(ContentAppearancePropertyKey.DRAFT);
  	which always returns contentAppearanceQuery
  */ const contentAppearanceFragmentResult = (0, $iWKHx.useContentAppearanceFragment)({
        contentId: contentId
    });
    const contentAppearanceQueryResult = (0, $jMyy4.useQueryInterop)((0, $8VcPj.contentAppearanceQuery), {
        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? (0, $g6QPm.createEditorContentUnifiedQueryVariables)({
            contentId: contentId
        }) : {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ]
        },
        skip: contentAppearanceFragmentResult.isProvided,
        __callerPackage__: "content-appearance"
    });
    // The query error is not read here, so a field error only reads as no data.
    const { data: initialContentAppearanceData, loading: initialContentAppearanceLoading } = contentAppearanceFragmentResult.isProvided ? contentAppearanceFragmentResult : contentAppearanceQueryResult;
    const context = (0, $cozmU.useMemo)(()=>{
        const initialContentAppearance = (0, $8VcPj.getContentAppearanceFromQueryData)(initialContentAppearanceData, (0, $1d2ww.ContentAppearancePropertyKey).DRAFT);
        // Under certain circumstances due to a previous bug with the content appearance during legacy editor autoconvert, an incorrect value may have been sent to collab service.
        // In this circumstance favour the initial content appearance value.
        const shouldUseInitial = contentAppearanceOverride && initialContentAppearance && contentAppearanceOverride.version === initialContentAppearance.version && contentAppearanceOverride.appearance !== initialContentAppearance.appearance;
        return {
            contentAppearance: shouldUseInitial ? initialContentAppearance : contentAppearanceOverride || initialContentAppearance,
            setContentAppearance: setContentAppearanceOverride,
            contentAppearanceLoading: initialContentAppearanceLoading
        };
    }, [
        initialContentAppearanceData,
        initialContentAppearanceLoading,
        contentAppearanceOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($652df36b21c46ede$var$ContentAppearanceContext.Provider, {
        value: context
    }, children);
};
const $652df36b21c46ede$export$c3c73be39a08fc97 = ({ children: children })=>{
    const context = $652df36b21c46ede$export$4cedbdf2fdf3340d();
    return children(context);
};
const $652df36b21c46ede$export$4cedbdf2fdf3340d = ()=>{
    return (0, $cozmU.useContext)($652df36b21c46ede$var$ContentAppearanceContext);
};
module.exports["ContentAppearanceContextProvider"] = $652df36b21c46ede$export$53c04435be7a0acf;
module.exports["ContentAppearanceContextConsumer"] = $652df36b21c46ede$export$c3c73be39a08fc97;
module.exports["useContentAppearance"] = $652df36b21c46ede$export$4cedbdf2fdf3340d;

});

parcelRegister("iWKHx", function(module, exports) {

var $du0Wl = parcelRequire("du0Wl");


var $hX2PJ = parcelRequire("hX2PJ");

// contentAppearanceQuery's selection for EditorContentUnifiedQuery; same fields and arguments, so
// both share the store records.
const $601c9a426bba81df$var$contentAppearanceFragmentNode = (0, $du0Wl.default);
function $601c9a426bba81df$export$b18453d9384e8a39({ contentId: contentId }) {
    return (0, $hX2PJ.useEditorContentFragment)('contentAppearanceFragment', $601c9a426bba81df$var$contentAppearanceFragmentNode, {
        contentId: contentId,
        mapData: (value)=>({
                content: {
                    nodes: [
                        value
                    ]
                }
            })
    });
}
module.exports["useContentAppearanceFragment"] = $601c9a426bba81df$export$b18453d9384e8a39;

});

parcelRegister("du0Wl", function(module, exports) {
/**
 * @generated SignedSource<<87be75ee1cfa743bf5cd7e035cd8d377>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2a49da7a6e3bc95e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": {
            "catchTo": "RESULT"
        },
        "name": "useContentAppearanceFragment_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": "appearanceDraft",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "content-appearance-draft"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(key:\"content-appearance-draft\")"
            }
        ],
        "type": "Content"
    };
}();
$2a49da7a6e3bc95e$var$node.hash = "c645e0efb6456131245a0289a6ac421a";
var $2a49da7a6e3bc95e$export$2e2bcd8739ae039 = $2a49da7a6e3bc95e$var$node;
module.exports["default"] = $2a49da7a6e3bc95e$export$2e2bcd8739ae039;

});

parcelRegister("2zdC2", function(module, exports) {
"use strict";
var $1de968d0bde0a175$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $fNVRJ = parcelRequire("fNVRJ");


var $zAMIg = parcelRequire("zAMIg");

/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */ function $1de968d0bde0a175$var$debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = $zAMIg.async;
    return function(source) {
        return source.lift(new $1de968d0bde0a175$var$DebounceTimeOperator(dueTime, scheduler));
    };
}
module.exports.debounceTime = $1de968d0bde0a175$var$debounceTime;
var $1de968d0bde0a175$var$DebounceTimeOperator = function() {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1de968d0bde0a175$var$DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1de968d0bde0a175$var$DebounceTimeSubscriber = function(_super) {
    $1de968d0bde0a175$var$__extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function(value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule($1de968d0bde0a175$var$dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function() {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function() {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function() {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}($fNVRJ.Subscriber);
function $1de968d0bde0a175$var$dispatchNext(subscriber) {
    subscriber.debouncedNext();
} //# sourceMappingURL=debounceTime.js.map

});

parcelRegister("dmKyV", function(module, exports) {
$parcel$export(module.exports, "WRM", () => (parcelRequire("1UB3e")).default);
$parcel$export(module.exports, "withWRMDependencies", () => (parcelRequire("6u5YI")).default);

var $1UB3e = parcelRequire("1UB3e");


var $6u5YI = parcelRequire("6u5YI");


});

parcelRegister("1UB3e", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 */ const $1647c2fd90c2cc68$var$WRM = {
    require (dependencies, callback) {
        return new Promise((resolve)=>{
            (0, $cpjd2.requireLegacyWRM)(dependencies, (modules)=>{
                resolve(modules);
                if (callback) callback(modules);
            }, ()=>{});
        });
    }
};
var $1647c2fd90c2cc68$export$2e2bcd8739ae039 = $1647c2fd90c2cc68$var$WRM;
module.exports["default"] = $1647c2fd90c2cc68$export$2e2bcd8739ae039;

});

parcelRegister("6u5YI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cpjd2 = parcelRequire("cpjd2");

/**
 * ========================================================
 * DEPRECATED, DO NOT MOVE THIS FILE TO NEXT.
 * Refactor your component to use @confluence/wrm directly.
 * ========================================================
 *
 * withWRMDependencies is a decorator for loading WRM dependencies.
 *
 * It's a helper which besides loading dependencies will also hide the component
 * while the dependencies are not loaded avoiding FOUC and weird behaviours.
 *
 * usage:
 *
 * withWRMDependencies('wr!mypluginkey')(
 *  class MyComponent extends Component {}
 * )
 *
 * or
 *
 * withWRMDependencies(['wrc!myContext', 'wr!myWebResource'])(
 *  class MyComponent extends Component {}
 * )
 */ function $4b8a2e9a57493429$var$withWRMDependencies(dependencies, options) {
    const configs = {
        isBlocking: true,
        ...options
    };
    return (BaseComponent)=>{
        class WRMComponent extends (0, $cozmU.Component) {
            componentDidMount() {
                this.mounted = true;
                if (dependencies && dependencies.length > 0) (0, $cpjd2.requireLegacyWRM)(dependencies, this.markAsLoaded, ()=>{});
                else this.markAsLoaded();
            }
            componentWillUnmount() {
                this.mounted = false;
            }
            render() {
                const { dependenciesLoaded: dependenciesLoaded } = this.state;
                if (dependenciesLoaded || !configs.isBlocking) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BaseComponent, {
                    ...this.props,
                    wrmDependenciesLoaded: dependenciesLoaded
                });
                else return null;
            }
            constructor(...args){
                super(...args);
                this.state = {
                    dependenciesLoaded: false
                };
                this.markAsLoaded = ()=>{
                    if (this.mounted) this.setState({
                        dependenciesLoaded: true
                    });
                };
            }
        }
        WRMComponent.displayName = `WRMComponent(${BaseComponent.displayName || BaseComponent.name})`;
        return WRMComponent;
    };
}
var $4b8a2e9a57493429$export$2e2bcd8739ae039 = $4b8a2e9a57493429$var$withWRMDependencies;
module.exports["default"] = $4b8a2e9a57493429$export$2e2bcd8739ae039;

});

parcelRegister("fBjVq", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $3141cf32c54bf764$var$RendererLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AfRhk",
    // Name needs to match the one in next/packages/view-page/src/index.ts
    name: "ClassicRendererLoader",
    loader: ()=>(parcelRequire("dlQMs"))
});
var $3141cf32c54bf764$export$2e2bcd8739ae039 = $3141cf32c54bf764$var$RendererLoader;
module.exports["default"] = $3141cf32c54bf764$export$2e2bcd8739ae039;

});

parcelRegister("dlQMs", function(module, exports) {

let $9b862dab151ea9af$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9b862dab151ea9af$var$load("el1U6"),
    $9b862dab151ea9af$var$load("2yyll"),
    $9b862dab151ea9af$var$load("hUbK8"),
    $9b862dab151ea9af$var$load("6Qybl"),
    $9b862dab151ea9af$var$load("fxlto"),
    $9b862dab151ea9af$var$load("kOHTK"),
    $9b862dab151ea9af$var$load("jZGfM"),
    $9b862dab151ea9af$var$load("8faB9"),
    $9b862dab151ea9af$var$load("fU0ae"),
    $9b862dab151ea9af$var$load("bqdgP"),
    $9b862dab151ea9af$var$load("3Whaz"),
    $9b862dab151ea9af$var$load("esBxc"),
    $9b862dab151ea9af$var$load("3pbEq"),
    $9b862dab151ea9af$var$load("9cVML"),
    $9b862dab151ea9af$var$load("15jTz"),
    $9b862dab151ea9af$var$load("48F3z"),
    $9b862dab151ea9af$var$load("7SteV"),
    $9b862dab151ea9af$var$load("1AybA"),
    $9b862dab151ea9af$var$load("eUsnQ"),
    $9b862dab151ea9af$var$load("9LJFK"),
    $9b862dab151ea9af$var$load("d66hN"),
    $9b862dab151ea9af$var$load("dxA9F"),
    $9b862dab151ea9af$var$load("bkMxV"),
    $9b862dab151ea9af$var$load("aRCaA"),
    $9b862dab151ea9af$var$load("h3Rq9"),
    $9b862dab151ea9af$var$load("cIoRg"),
    $9b862dab151ea9af$var$load("g7vSH"),
    $9b862dab151ea9af$var$load("ea3NB"),
    $9b862dab151ea9af$var$load("6wr18"),
    $9b862dab151ea9af$var$load("ffEVr"),
    $9b862dab151ea9af$var$load("59hV4"),
    $9b862dab151ea9af$var$load("kJASg"),
    $9b862dab151ea9af$var$load("asCsc"),
    $9b862dab151ea9af$var$load("fYx6U"),
    $9b862dab151ea9af$var$load("botpL"),
    $9b862dab151ea9af$var$load("frgRG"),
    $9b862dab151ea9af$var$load("l4j2l"),
    $9b862dab151ea9af$var$load("37v60"),
    $9b862dab151ea9af$var$load("a7sEM"),
    $9b862dab151ea9af$var$load("koqDJ"),
    $9b862dab151ea9af$var$load("7IvJj"),
    $9b862dab151ea9af$var$load("j7JUO"),
    $9b862dab151ea9af$var$load("cGkFm"),
    $9b862dab151ea9af$var$load("eF92L"),
    $9b862dab151ea9af$var$load("jwMHX"),
    $9b862dab151ea9af$var$load("bmOOW"),
    $9b862dab151ea9af$var$load("dDiWc"),
    $9b862dab151ea9af$var$load("d0ZRF"),
    $9b862dab151ea9af$var$load("k507P"),
    $9b862dab151ea9af$var$load("fwbNS"),
    $9b862dab151ea9af$var$load("a8R25"),
    $9b862dab151ea9af$var$load("gaUhx"),
    $9b862dab151ea9af$var$load("5PKbS"),
    $9b862dab151ea9af$var$load("gFeoL"),
    $9b862dab151ea9af$var$load("9TOep"),
    $9b862dab151ea9af$var$load("bncmK"),
    $9b862dab151ea9af$var$load("8iu3F"),
    $9b862dab151ea9af$var$load("fWCBZ"),
    $9b862dab151ea9af$var$load("6iTkp"),
    $9b862dab151ea9af$var$load("gTa3u"),
    $9b862dab151ea9af$var$load("hhss7"),
    $9b862dab151ea9af$var$load("h6rbF"),
    $9b862dab151ea9af$var$load("jD5ZU"),
    $9b862dab151ea9af$var$load("aAWLw"),
    $9b862dab151ea9af$var$load("7EorR"),
    $9b862dab151ea9af$var$load("8CeYz")
]).then(()=>parcelRequire('djmKw'));

});

parcelRegister("eDAGu", function(module, exports) {

var $2c1Wz = parcelRequire("2c1Wz");


var $i7t6K = parcelRequire("i7t6K");

let $7ca3f558dc62e54e$var$pe = null;
const $7ca3f558dc62e54e$var$getObserver = ()=>{
    if ($7ca3f558dc62e54e$var$pe !== null) return $7ca3f558dc62e54e$var$pe;
    $7ca3f558dc62e54e$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).LongTask) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask].push(entry);
            if (entry.entryType === (0, $2c1Wz.PerformanceObserverEntryTypes).Event) (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).Event].push(entry);
        });
    });
    return $7ca3f558dc62e54e$var$pe;
};
const $7ca3f558dc62e54e$export$231c167ad8c908df = ()=>{
    if ($7ca3f558dc62e54e$var$pe) {
        // Disconnect the observer if it's already set up
        $7ca3f558dc62e54e$var$pe.disconnect();
        $7ca3f558dc62e54e$var$pe = null;
    }
    for (const type of Object.values((0, $2c1Wz.PerformanceObserverEntryTypes)))$7ca3f558dc62e54e$var$getObserver().observe({
        type: type,
        buffered: true
    });
};
module.exports["startLightHouseObservers"] = $7ca3f558dc62e54e$export$231c167ad8c908df;

});

parcelRegister("lTjel", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $94ecb5e99e218b76$export$b602c35a55c29946 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "-DYr1",
    name: "ErrorAppLoader",
    loader: async ()=>(await (parcelRequire("1E17N"))).ErrorApp
});
module.exports["ErrorAppLoader"] = $94ecb5e99e218b76$export$b602c35a55c29946;

});

parcelRegister("aFgFx", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");




var $a2zQR = parcelRequire("a2zQR");

async function $457aeee54b862c4a$export$b1c9c77d4871a337(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey),
        $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $457aeee54b862c4a$var$preloadContentData(contentId, spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $a2zQR.default),
        variables: {
            contentId: contentId,
            spaceKey: spaceKey
        },
        __callerPackage__: "confluence-embeds"
    });
}
async function $457aeee54b862c4a$var$preloadContentTree(contentId, spaceKey) {}
module.exports["preloadEmbedData"] = $457aeee54b862c4a$export$b1c9c77d4871a337;

});

parcelRegister("kyd3u", function(module, exports) {

var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $xwvlW = parcelRequire("xwvlW");


var $fHLuR = parcelRequire("fHLuR");


var $6mKj3 = parcelRequire("6mKj3");



var $9ycGg = parcelRequire("9ycGg");




var $1xpoY = parcelRequire("1xpoY");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");

function $7f1954fc7a2cd99f$export$c628356b573f8241({ isUnpublishedDraft: isUnpublishedDraft, spaceKey: spaceKey, contentId: contentId }) {
    const queries = [
        // Under the experiment the editor byline reads EditorContentUnifiedQuery.
        ...(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? [] : [
            (0, $dYU3e.query)({
                query: (0, $fxLAA.default),
                variables: {
                    contentId: contentId,
                    spaceKey: spaceKey,
                    versionOverride: null,
                    embeddedContentRender: null,
                    limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                    ...(0, $6mKj3.expValEquals)('confluence_classification_level_v2', 'isEnabled', true) ? {
                        useClassificationLevelV2: true
                    } : {},
                    includeDevDocsBylineConnection: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment') || (0, $6mKj3.isExperimentEnabled)('confluence_dev_docs'),
                    useObjectHeaderFragment: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_obj_header_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                    includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                    ...isUnpublishedDraft && {
                        status: [
                            'draft'
                        ]
                    }
                },
                __callerPackage__: "content-header"
            })
        ],
        (0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        })
    ];
    // The editor collaborators byline reads EditorContentUnifiedQuery.
    if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) {
        if (contentId && spaceKey && (0, $6mKj3.expValEquals)('dual_agent_avatar_card', 'isEnabled', true)) {
            const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
            if (cloudId) queries.push((0, $fHLuR.preloadContentOwnershipCollaborators)({
                cloudId: cloudId,
                contentId: contentId,
                spaceKey: spaceKey
            }));
        }
    }
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}
module.exports["preloadEditorByLineData"] = $7f1954fc7a2cd99f$export$c628356b573f8241;

});

parcelRegister("ddSqr", function(module, exports) {

var $5rHrW = parcelRequire("5rHrW");


var $wPrRK = parcelRequire("wPrRK");


var $dYU3e = parcelRequire("dYU3e");


var $lyWac = parcelRequire("lyWac");


var $cRQNp = parcelRequire("cRQNp");


var $eP7b6 = parcelRequire("eP7b6");


var $9HhEw = parcelRequire("9HhEw");

function $1b23138cfdb36f61$export$77aa43a33b3d905d(contentId) {
    // This preloader is shared by the public-link and access-link routes and always fires the
    // external-share queries. When access_link_m2 is on, the render-side components
    // correctly switch to ContentHeaderUnifiedQuery, so these preloads go unused for access-link
    // viewers. Aligning the preloader with the GA access-link path is tracked in CCPERMS-7263.
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $eP7b6.default),
            variables: {
                contentId: contentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "content-header"
        }),
        (0, $dYU3e.query)({
            query: (0, $9HhEw.default),
            variables: {
                contentId: contentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "content-header"
        }),
        (0, $cRQNp.preloadReadTime)({
            contentId: contentId,
            includeContentBody: true,
            useCache: true
        }),
        (0, $wPrRK.slowQueryGuard)('preloadContentAnalyticsViewers', ()=>(0, $5rHrW.preloadContentAnalyticsViewers)(contentId), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT))
    ]);
}
module.exports["preloadContentTitleWithByLineExternal"] = $1b23138cfdb36f61$export$77aa43a33b3d905d;

});

parcelRegister("6YxJf", function(module, exports) {

var $hGIXv = parcelRequire("hGIXv");

const $3050fc659ed4bb43$export$4be2eb0104d640dc = async ()=>{
    return (0, $hGIXv.preloadPostOfficePlacementWithSessionContext)('confluence-home-banner');
};
module.exports["preloadPostOfficeConfluenceHomeBanner"] = $3050fc659ed4bb43$export$4be2eb0104d640dc;

});

parcelRegister("iujy9", function(module, exports) {
/**
 * @generated SignedSource<<6bf0e1a50f8992ea9d07f341c336c62c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b5846c5488337040$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "watchContentHeaderTemplateDataContentFragment",
    "selections": [
        {
            "concreteType": "ContentMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "sourceTemplateEntityId"
                }
            ]
        }
    ],
    "type": "Content"
};
$b5846c5488337040$var$node.hash = "ef4f3064f901b2dcf745ba396c56f142";
var $b5846c5488337040$export$2e2bcd8739ae039 = $b5846c5488337040$var$node;



var $fFmJj = parcelRequire("fFmJj");

const $a95c3ab6a4f11e9d$var$contentHeaderTemplateDataFragment = (0, $b5846c5488337040$export$2e2bcd8739ae039);
const $a95c3ab6a4f11e9d$var$CACHE_RETRY_INTERVAL_MS = 100;
const $a95c3ab6a4f11e9d$var$MAX_CACHE_READ_ATTEMPTS = 50;
const $a95c3ab6a4f11e9d$var$readTemplateData = (contentId)=>{
    try {
        const data = (0, $fFmJj.readFragmentInterop)({
            id: `Content:${contentId}`,
            fragment: $a95c3ab6a4f11e9d$var$contentHeaderTemplateDataFragment,
            __callerPackage__: "content-header"
        });
        const sourceTemplateEntityId = data?.metadata?.sourceTemplateEntityId;
        return sourceTemplateEntityId === undefined ? {
            status: 'pending'
        } : {
            status: 'ready',
            sourceTemplateEntityId: sourceTemplateEntityId
        };
    } catch  {
        return {
            status: 'pending'
        };
    }
};
const $a95c3ab6a4f11e9d$export$389493eddb34bcab = (contentId, onTemplateData)=>{
    let attempt = 0;
    let timeoutId;
    let unsubscribed = false;
    const read = ()=>{
        if (unsubscribed) return;
        attempt += 1;
        const result = $a95c3ab6a4f11e9d$var$readTemplateData(contentId);
        if (result.status === 'ready') {
            onTemplateData(result.sourceTemplateEntityId);
            return;
        }
        if (attempt < $a95c3ab6a4f11e9d$var$MAX_CACHE_READ_ATTEMPTS) timeoutId = setTimeout(read, $a95c3ab6a4f11e9d$var$CACHE_RETRY_INTERVAL_MS);
    };
    read();
    return {
        unsubscribe: ()=>{
            unsubscribed = true;
            if (timeoutId !== undefined) clearTimeout(timeoutId);
        }
    };
};
module.exports["watchContentHeaderTemplateData"] = $a95c3ab6a4f11e9d$export$389493eddb34bcab;

});

parcelRegister("h3nb6", function(module, exports) {
/* eslint-disable no-restricted-syntax */ 
var $cozmU = parcelRequire("cozmU");


var $64KID = parcelRequire("64KID");


var $kE2cJ = parcelRequire("kE2cJ");


var $jmjWc = parcelRequire("jmjWc");


const $e9270d50e13c4524$export$58ad04e57ec143c3 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "DOtt7",
    name: "RedirectLegacyCopyPageLoader",
    loader: async ()=>(await (parcelRequire("k1GeI"))).RedirectLegacyCopyPage
});
$e9270d50e13c4524$export$58ad04e57ec143c3.NAVIGATION_PARAMS = ()=>false;






const $1547fdfac1788133$export$70a5a4ee184a1106 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "hF4WF",
    name: "RedirectLegacyViewPageLoader",
    loader: async ()=>(await (parcelRequire("eMS5h"))).RedirectLegacyViewPage
});
$1547fdfac1788133$export$70a5a4ee184a1106.NAVIGATION_PARAMS = ()=>false;




/* eslint-disable check-multiple-entry-point-exports/check-multiple-entry-point-exports */ // These are routes shared between SSR and SPA

var $jiFpb = parcelRequire("jiFpb");


var $4lJOK = parcelRequire("4lJOK");


var $hDf9e = parcelRequire("hDf9e");


var $hkCxu = parcelRequire("hkCxu");


var $k1285 = parcelRequire("k1285");


var $SwMnm = parcelRequire("SwMnm");




var $jiJCD = parcelRequire("jiJCD");





var $bEYte = parcelRequire("bEYte");


var $kJOOQ = parcelRequire("kJOOQ");

parcelRequire("1i7uI");


var $aTWRz = parcelRequire("aTWRz");

var $iyEDi = parcelRequire("iyEDi");

const $8012954d5e28a430$export$33ab8fb3f76d8b14 = ()=>{
    const location = (0, $bEYte.useSelector)((0, $iyEDi.getLocation));
    const dispatch = (0, $bEYte.useDispatch)();
    (0, $cozmU.useEffect)(()=>{
        const { query: query, pathname: pathname } = location;
        let contentType;
        if (pathname.indexOf('/createpage.action') !== -1 || pathname.indexOf('/createpage-entervariables.action') !== -1) contentType = 'pages';
        else if (pathname.indexOf('/createblogpost.action') !== -1) contentType = 'blog';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        let spaceKey;
        if (typeof query.spaceKey !== 'undefined' && query.spaceKey) spaceKey = query.spaceKey;
        else if (typeof query.draftId !== 'undefined' && /^[0-9]+$/.test(query.draftId)) spaceKey = 'byDraft';
        else {
            dispatch((0, $kJOOQ.replace)({
                pathname: (0, $aTWRz.CONTEXT_PATH)
            }));
            return;
        }
        const newQuery = {};
        Object.keys(query).filter((param)=>param !== 'spaceKey').forEach((param)=>newQuery[param] = query[param]);
        const nextLocation = {
            ...location,
            pathname: `${(0, $aTWRz.CONTEXT_PATH)}/spaces/${spaceKey}/${contentType}/create`,
            query: newQuery,
            search: (0, $jiJCD.format)({
                query: newQuery
            })
        };
        dispatch((0, $kJOOQ.replace)(nextLocation));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return null;
};
$8012954d5e28a430$export$33ab8fb3f76d8b14.NAVIGATION_PARAMS = ()=>false;






var $lFjPc = parcelRequire("lFjPc");


var $aVKfT = parcelRequire("aVKfT");

const $d553d8b4da7f3160$export$25552d6a584e1fb8 = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    // Construct the module id from URL params to match the format expected by ForgeGlobalSettingsExtensionPoint
    // Format: ari:cloud:ecosystem::extension/{appId}/{envId}/static/{moduleKey}
    // This matches against app.id in the Forge extensions list
    const id = `ari:cloud:ecosystem::extension/${appId}/${envId}/static/${forgeManifestRoute}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aVKfT.ForgeGlobalSettingsExtensionPoint), {
        key: id,
        id: id
    });
};
$d553d8b4da7f3160$export$25552d6a584e1fb8.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeApps'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $5d42f987126d0d25$var$AdminForgeAppsRedirect = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "vKaNx",
    name: "AdminForgeAppsRedirect",
    loader: async ()=>(await (parcelRequire("imDYW"))).AdminForgeAppsRedirect
});
const $5d42f987126d0d25$export$1eaead8b8e68953c = ({ params: params, query: query })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5d42f987126d0d25$var$AdminForgeAppsRedirect, {
        params: params,
        query: query
    });
};
$5d42f987126d0d25$export$1eaead8b8e68953c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminForgeAppsRedirect'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $aF1vZ = parcelRequire("aF1vZ");


var $9wGTI = parcelRequire("9wGTI");


var $6X8o4 = parcelRequire("6X8o4");


var $ge2sX = parcelRequire("ge2sX");

const $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aF1vZ.AdvancedSearch), null);
$f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f.NAVIGATION_PARAMS = ()=>{
    // Client routes render after session bootstrap has resolved.
    const sessionData = (0, $ge2sX.getSessionData)();
    const isRovoEnabled = (0, $6X8o4.isResolved)(sessionData) && (0, $6X8o4.getValue)(sessionData)?.isRovoEnabled;
    return {
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        Screen: (0, $9wGTI.fg)('unified_search_in_confluence') ? null : {
            screenEvent: {
                name: 'advancedSearchScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true,
            fillContainer: // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            (isRovoEnabled || (0, $9wGTI.fg)('unified_search_in_confluence')) && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            !(0, $9wGTI.fg)('confluence_rovo_search_opt_out')
        }
    };
};












const $f9284ca1d97b2b7a$export$32926c3a37851958 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Rr_Hq",
    name: "BetaFeaturesSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("fxOEJ"))).BetaFeaturesSiteSettingsPage
});


const $7949c11e9e78d917$export$39279dc1d0cb138f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9284ca1d97b2b7a$export$32926c3a37851958), null);
$7949c11e9e78d917$export$39279dc1d0cb138f.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'betaFeaturesScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });








var $8g7sM = parcelRequire("8g7sM");




var $bUMKD = parcelRequire("bUMKD");


var $78QFu = parcelRequire("78QFu");

const $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f = ({ params: { contentId: contentId, externalToken: externalToken }, hash: hash })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUMKD.ExternalSharePageLoader), {
        contentId: contentId === 'undefined' ? undefined : contentId,
        shareToken: externalToken,
        queryHash: hash,
        ContentRenderer: (0, $8g7sM.default)
    });
$b4ceb88d52b227e6$export$2f64eafbbfb5bb9f.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: true,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                routeName: name
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $2a1308b9f924bd74$export$dceb5680f254ba0d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4i8AJ",
    name: "ForgeGlobalPageExtensionPoint",
    loader: async ()=>(await (parcelRequire("dOgQ2"))).GlobalPage
});


const $88f9531119605f50$export$a0e2b6c59fd25a4e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2a1308b9f924bd74$export$dceb5680f254ba0d), {
        key: `${appId}-${envId}-${forgeManifestRoute}`,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$88f9531119605f50$export$a0e2b6c59fd25a4e.NAVIGATION_PARAMS = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'globalPageScreen',
                id: appId,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};












const $5651b1434c6bae88$var$SitePermissions = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "8YbJt",
    name: "SitePermissions",
    loader: async ()=>(await (parcelRequire("4R1NE"))).SitePermissions
});
const $5651b1434c6bae88$export$72e24cb8f0330a61 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5651b1434c6bae88$var$SitePermissions, null);
$5651b1434c6bae88$export$72e24cb8f0330a61.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












var $1NBp8 = parcelRequire("1NBp8");





var $d9tcB = parcelRequire("d9tcB");

function $5340377d047d37c6$export$3c0681f7b17941c4(routeMatch) {
    if (routeMatch?.name === (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name || routeMatch?.name === (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name && // Hub Dashboard aka Consolidated Settings (https://hello.atlassian.net/wiki/spaces/CLI/pages/4111377280/Project+Poster+Hub+Dashboard) uses /admin/permissions/hub without the tab param and doesn't use the site admin nav there:
    routeMatch?.params?.tab) {
        // https://hello.atlassian.net/wiki/spaces/~701217e532d6bdc7846948a0f4e8afe31a122/pages/3993181421/Company+Hub+-+Beta+Tag+Removal
        // documents the product and design folks of Company Hub want Hub permissions to be among the site admin screens of the product,
        // specifically next to permissions-related screens such as Global permissions, Space permissions, Analytics permissions, etc in
        // the Security section.
        const sessionData = (0, $6X8o4.getValue)((0, $ge2sX.getSessionData)());
        // But for non-site admins the site admin side nav is pretty much empty and, more importantly, there are no other
        // permissions-related screens there. Then Hub permissions in the site admin side nav can only make sense to site admins.
        if (sessionData?.accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS) return true;
    }
    return false;
}



var $9HNv5 = parcelRequire("9HNv5");







var $agglT = parcelRequire("agglT");


const $b11848dc615e604f$export$b212d6e1ccf8d345 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uZr6h",
    loader: async ()=>(await (parcelRequire("eXz7x"))).CompanyHubSettingsPage,
    name: 'CompanyHubSettingsPage'
});



var $8NC5Z = parcelRequire("8NC5Z");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");




var $2Uf3N = parcelRequire("2Uf3N");










var $6mKj3 = parcelRequire("6mKj3");















var $iquRY = parcelRequire("iquRY");


const $3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "3C38l",
    name: "SpacePermissionsSettingsRouteComponent",
    loader: async ()=>(parcelRequire("6ZGi9"))
});
const $3dace45d43821ccc$var$DEFAULT_TAB = 'users';
const $3dace45d43821ccc$export$c4e68572e7b94bc6 = ({ name: routeName, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } })=>{
    //
    // Warning:
    // "Hub permissions" is a customization of "Space permissions" predating RBAC so
    // "Hub permissions" is to be used in the Company Hub-type of space and
    // "Space permissions" or RBAC are to be used in all other types of space!
    //
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (tab === 'public-links' && (0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_ACCESS_LINKS).name,
        params: {
            spaceKey: spaceKey
        }
    });
    if (isCompanyHub) {
        if (routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
            params: {
                tab: 'users'
            }
        });
    } else {
        //RBAC Milestone 2 Redirect Logic in case users try to access via url
        const isSpacePermissionsTab = tab === 'users' || tab === 'groups' || tab === 'guests';
        if (isSpacePermissionsTab && isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_MEMBERS).name,
            params: {
                spaceKey: spaceKey
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3dace45d43821ccc$var$SpacePermissionsSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$3dace45d43821ccc$export$c4e68572e7b94bc6.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name, params: { spaceKey: spaceKey, tab: tab = $3dace45d43821ccc$var$DEFAULT_TAB } } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: tab === 'public-links' ? 'spacePermissionsPublicLinksScreen' : `${tab}SpacePermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: $3dace45d43821ccc$var$getSideNav(routeMatch),
            spaceKey: spaceKey
        }
    };
};
const $3dace45d43821ccc$var$getSideNav = (routeMatch)=>(0, $cEgMD.isCompanyHubSpaceKey)(routeMatch.params.spaceKey) && (0, $5340377d047d37c6$export$3c0681f7b17941c4)(routeMatch) ? (0, $lFjPc.ADMIN_HOME_ID) : (0, $lFjPc.CONTAINER_ADMIN_HOME_ID);









const $94454e5f287d76d5$export$a9d78c41686becfd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "2UE21",
    loader: async ()=>(await (parcelRequire("5R2Ic"))).SpaceRoleManagementPage,
    name: 'SpaceRoleManagementPage'
});

















const $f9fff28badc7670c$export$214350c926cc60f2 = ({ name: routeName, params: { spaceKey: spaceKey } })=>{
    const { isRbacEnabled: isRbacEnabled, loading: loading } = (0, $iquRY.useSpaceRoleMode)();
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    if (isCompanyHub && routeName !== (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_COMPANY_HUB_PERMISSIONS).name,
        params: {
            tab: 'users'
        }
    });
    if (!loading && !isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94454e5f287d76d5$export$a9d78c41686becfd), {
        spaceKey: spaceKey
    });
};
$f9fff28badc7670c$export$214350c926cc60f2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceMembersScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });





/**
 * The routes "Company Hub settings > Users" and "Hub permissions" in the Confluence app.
 * `AdminCompanyHubPermissionsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute({ params: params, ...props }) {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (isSiteAdmin && shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHubPermissions"
    });
    if (!params.tab) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).USERS
    });
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    if (isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f9fff28badc7670c$export$214350c926cc60f2), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dace45d43821ccc$export$c4e68572e7b94bc6), {
        ...props,
        params: {
            spaceKey: spaceKey,
            ...params
        }
    });
}
$ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name, params: params } = routeMatch;
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = (0, $5340377d047d37c6$export$3c0681f7b17941c4)(routeMatch) ? (0, $lFjPc.ADMIN_HOME_ID) : (0, $lFjPc.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: `${params.tab || 'consolidated'}HubPermissionsScreen`,
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: navView,
            spaceKey: spaceKey
        }
    };
};
const $ce2a2ee7f6871785$export$eeb7368e8bf944ac = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($ce2a2ee7f6871785$var$ConfluenceAppHubPermissionsRoute);


















const $4fa13b181dc663ad$var$CustomizeNavigation = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Ss1hK",
    name: "CustomizeNavigation",
    loader: async ()=>(await (parcelRequire("fna4p"))).CustomizeNavigation
});
const $4fa13b181dc663ad$export$3206f56dd9eda6e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fa13b181dc663ad$var$CustomizeNavigation, null);
$4fa13b181dc663ad$export$3206f56dd9eda6e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'customizeNavigationScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });
const $4fa13b181dc663ad$export$5744f34ed241a45c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$4fa13b181dc663ad$export$5744f34ed241a45c.NAVIGATION_PARAMS = ()=>false;









const $9dff8dc763109b25$export$a4a7c409f3d3e524 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LLjB-",
    name: "GlobalAutomationRoute",
    loader: async ()=>(await (parcelRequire("9cEOX"))).Automation
});
$9dff8dc763109b25$export$a4a7c409f3d3e524.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalAutomationRoute'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $3e17cd15ad9a2d77$var$UserDetails = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4otHM",
    name: "UserDetails",
    loader: async ()=>(await (parcelRequire("dDPgH"))).UserDetails
});
const $3e17cd15ad9a2d77$export$ef0ae9b94af7599 = ({ params: { accountId: accountId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3e17cd15ad9a2d77$var$UserDetails, {
        accountId: accountId
    });
$3e17cd15ad9a2d77$export$ef0ae9b94af7599.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsUserDetailsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $a311429dbe08f666$export$6b6e4f47fea5bdb9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w4gXW",
    name: "ViewPagePdfExportLoader",
    loader: async ()=>(await (parcelRequire("g6l3K"))).ViewPagePdfExportPage
});


parcelRequire("4Yv1J");
var $f5aR2 = parcelRequire("f5aR2");

parcelRequire("crTA1");
var $iqZzD = parcelRequire("iqZzD");

const $de365c057d45c0f8$export$d4d3fe32e0af1ab9 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a311429dbe08f666$export$6b6e4f47fea5bdb9), {
        contentId: String(contentId),
        spaceKey: String(spaceKey)
    })));
$de365c057d45c0f8$export$d4d3fe32e0af1ab9.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                contentId: contentId,
                routeName: name,
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            }
        },
        MainLayout: {
            enableNavigation: false,
            spaceKey: spaceKey
        }
    });






var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");

parcelRequire("4Yv1J");


parcelRequire("crTA1");


const $cdc5bb1b4ce25ace$export$f10520cd46ef45dd = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $djZz9.SpaceOverviewLoader), {
        spaceKey: String(spaceKey)
    })));
$cdc5bb1b4ce25ace$export$f10520cd46ef45dd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                routeName: name,
                contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'pdfExportScreen'
            },
            spaceKey: spaceKey
        },
        MainLayout: {
            enableNavigation: false
        }
    });












var $56QzY = parcelRequire("56QzY");


const $24a857c7c96255d7$var$PeopleDirectory = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zWQBJ",
    name: "PeopleDirectory",
    loader: async ()=>(await (parcelRequire("3anUZ"))).PeopleDirectory
});
const $24a857c7c96255d7$export$c7bf94fd367d52ef = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($24a857c7c96255d7$var$PeopleDirectory, null);
$24a857c7c96255d7$export$c7bf94fd367d52ef.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            name: 'inProdPeopleDirectory',
            attributes: {
                navdexPointType: (0, $56QzY.START_TOUCH)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};












const $a6aaee7eaacb3bc0$export$1696ac6f866195be = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MGscQ",
    name: "MarketplaceRoute",
    loader: async ()=>(await (parcelRequire("eKukX"))).Marketplace
});
$a6aaee7eaacb3bc0$export$1696ac6f866195be.NAVIGATION_PARAMS = ({ name: name })=>{
    let eventName = '';
    let navView = (0, $lFjPc.PRODUCT_HOME_ID);
    if (name === (0, $1NBp8.MARKETPLACE_FIND_APPS).name) {
        eventName = 'marketplaceFindApps';
        navView = (0, $lFjPc.PRODUCT_HOME_ID);
    } else if (name === (0, $1NBp8.MARKETPLACE_APP_REQUESTS).name) {
        eventName = 'marketplaceAppRequests';
        navView = (0, $lFjPc.ADMIN_HOME_ID);
    } else if ((0, $1NBp8.MARKETPLACE_MANAGE_PROMOTIONS).name) {
        eventName = 'marketplacePromotions';
        navView = (0, $lFjPc.ADMIN_HOME_ID);
    }
    return {
        Screen: {
            screenEvent: {
                name: eventName,
                id: eventName
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};












const $3dce15286068fd34$export$f2df3d24f362ca75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "QJy0w",
    name: "ForgeSpacePageExtensionPoint",
    loader: async ()=>(await (parcelRequire("d6uSg"))).SpacePage
});


parcelRequire("crTA1");


const $e20a45805838a7c5$export$16cbc228d727cb5e = ({ params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3dce15286068fd34$export$f2df3d24f362ca75), {
        key: appId + envId + forgeManifestRoute,
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    }));
};
$e20a45805838a7c5$export$16cbc228d727cb5e.NAVIGATION_PARAMS = ({ name: name, params: { appId: appId, envId: envId, forgeManifestRoute: forgeManifestRoute, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId,
                    forgeManifestRoute: forgeManifestRoute
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "zXYF3",
    name: "SpaceSettingsForgeAppsRouteComponent",
    loader: ()=>(parcelRequire("7oqPI"))
});
const $70d1956925899c9e$export$21a09e0ddc77eafe = ({ params: { appId: appId, forgeManifestRoute: forgeManifestRoute, envId: envId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($70d1956925899c9e$var$SpaceSettingsForgeAppsRouteComponent, {
        spaceKey: spaceKey,
        appId: appId,
        envId: envId,
        forgeManifestRoute: forgeManifestRoute
    });
$70d1956925899c9e$export$21a09e0ddc77eafe.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, appId: appId, envId: envId } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsForgeApps',
                id: spaceKey,
                attributes: {
                    appId: appId,
                    envId: envId
                }
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZLKey",
    name: "SpaceSettingsArchiveSpaceRouteComponent",
    loader: ()=>(parcelRequire("anIt2"))
});
const $3d2592d831aaf97c$export$c5e406a0947cdc56 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3d2592d831aaf97c$var$SpaceSettingsArchiveSpaceRouteComponent, {
        spaceKey: spaceKey
    });
$3d2592d831aaf97c$export$c5e406a0947cdc56.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsArchiveSpace',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "dJgx9",
    name: "SpaceSettingsContentStateRouteComponent",
    loader: ()=>(parcelRequire("bNraL"))
});
const $ada82682e35c0989$export$9cf7aa4fa48eb220 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ada82682e35c0989$var$SpaceSettingsContentStateRouteComponent, {
        spaceKey: spaceKey
    });
$ada82682e35c0989$export$9cf7aa4fa48eb220.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsContentState',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z-Bup",
    name: "SpaceSettingsRelatedPagesRouteComponent",
    loader: async ()=>(await (parcelRequire("5UYZp"))).SpaceSettingsRelatedPagesRouteComponent
});
const $5fd2607ebf0fb934$export$50efde5a87cc8957 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5fd2607ebf0fb934$var$SpaceSettingsRelatedPagesRouteComponent, {
        spaceKey: spaceKey
    });
$5fd2607ebf0fb934$export$50efde5a87cc8957.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsRelatedPages',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iFso2",
    name: "SpaceSettingsEditFeaturesRouteComponent",
    loader: async ()=>(await (parcelRequire("6NpxL"))).SpaceSettingsEditFeaturesRouteComponent
});
const $c991c60ce35a3f45$export$769dfef0447f3a55 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($c991c60ce35a3f45$var$SpaceSettingsEditFeaturesRouteComponent, {
        spaceKey: spaceKey
    });
$c991c60ce35a3f45$export$769dfef0447f3a55.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsEditFeatures',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });






var $feuG2 = parcelRequire("feuG2");




parcelRequire("crTA1");


const $ae6364090fd3faa0$export$45c01163cd56b3a2 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $feuG2.LazySpaceDetailsPage), {
        spaceKey: spaceKey
    }));
};
$ae6364090fd3faa0$export$45c01163cd56b3a2.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: (0, $feuG2.SPACE_SETTINGS_DETAILS_ANALYTICS_SOURCE)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID)
        }
    });









const $bd0ed31e3ea4d2cc$export$6e087ccb94d5f2ed = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "K9oKK",
    name: "AgentContextPageLoader",
    loader: async ()=>(await (parcelRequire("6fbdJ"))).AgentContextPage
});









var $wtSEP = parcelRequire("wtSEP");


var $bQm3c = parcelRequire("bQm3c");

parcelRequire("crTA1");


const $d79bba560e75ebc3$export$5cb7b3311cd85f89 = ({ params: { spaceKey: spaceKey } })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isAIEarlyAccessEnabled: isAIEarlyAccessEnabled } = (0, $bQm3c.useSessionData)();
    if (!isAdminHubAIEnabled || !isAIEarlyAccessEnabled || !(0, $6mKj3.expValEquals)('cc_space_agents_md_context', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd0ed31e3ea4d2cc$export$6e087ccb94d5f2ed), {
        spaceKey: spaceKey
    }));
};
$d79bba560e75ebc3$export$5cb7b3311cd85f89.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'agenticSpaceInstructions'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });












const $ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EJBqs",
    name: "SpaceLookAndFeelSettingsRouteComponent",
    loader: async ()=>(parcelRequire("7s77i"))
});
const $ea3042d7dfb4b938$export$9ebf5b01b0356442 = ({ params: { spaceKey: spaceKey, tab: tab } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ea3042d7dfb4b938$var$SpaceLookAndFeelSettingsRouteComponent, {
        spaceKey: spaceKey,
        tab: tab
    });
};
$ea3042d7dfb4b938$export$9ebf5b01b0356442.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingLookAndFeelPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });












var $8dwdz = parcelRequire("8dwdz");

parcelRequire("crTA1");



const $6079beeead36a4aa$var$ArchivedPagesListContainer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "mIHzp",
    name: "ArchivedPagesListContainer",
    loader: async ()=>(await (parcelRequire("dDcra"))).ArchivedPagesListContainer
});
const $6079beeead36a4aa$export$77792abc2bfae7a1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6079beeead36a4aa$var$ArchivedPagesListContainer, {
        spaceKey: spaceKey
    }));
};
$6079beeead36a4aa$export$77792abc2bfae7a1.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    return {
        Screen: {
            screenEvent: {
                name: 'spaceArchivedPages',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            enableNavigation: !isMobile
        }
    };
};












const $b162f5655e630145$export$9fe8c29db9617eb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "uRwN3",
    name: "ContentIntelligenceLoader",
    loader: async ()=>(await (parcelRequire("a2qY6"))).ContentIntelligenceRouter
});








parcelRequire("crTA1");


const $2593d4b17876c400$export$a3041cafa4dd68cd = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_content_intelligence', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b162f5655e630145$export$9fe8c29db9617eb), {
        spaceKey: spaceKey
    }));
};
$2593d4b17876c400$export$a3041cafa4dd68cd.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_content_intelligence', 'isEnabled', false)) return false;
    return {
        Screen: {
            screenEvent: {
                name: 'spaceSuggestionsScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    };
};












const $9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EYcHq",
    name: "SpaceSettingsDataClassificationRouteComponent",
    loader: ()=>(parcelRequire("knHrR"))
});
const $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9ad8ac092b3ce6dd$var$SpaceSettingsDataClassificationRouteComponent, {
        spaceKey: spaceKey
    });
$9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsDataClassification',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $0db33795337c2a26$var$SpaceSettingsWatermarkConfigurationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oooFg",
    name: "SpaceSettingsWatermarkConfigurationRouteComponent",
    loader: ()=>(parcelRequire("8VPuN"))
});
const $0db33795337c2a26$export$2bb331cf926ecae2 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0db33795337c2a26$var$SpaceSettingsWatermarkConfigurationRouteComponent, {
        spaceKey: spaceKey
    });
$0db33795337c2a26$export$2bb331cf926ecae2.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsWatermarkConfiguration',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });





parcelRequire("bDjCi");
var $ltKTq = parcelRequire("ltKTq");
var $bDjCi = parcelRequire("bDjCi");

const $e84d6ad8839aa142$export$355693d248632c9a = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bDjCi.LazyTeamCalendars), {
        calendarContext: (0, $ltKTq.CALENDAR_CONTEXT).MY_CALENDARS
    });
};
$e84d6ad8839aa142$export$355693d248632c9a.NAVIGATION_PARAMS = ({ spaceKey: spaceKey })=>({
        Screen: {
            screenEvent: {
                name: 'myCalendarsScreen',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey
        }
    });











parcelRequire("bDjCi");



const $116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "tO6zv",
    name: "SpaceTeamCalendarsRouteComponent",
    loader: ()=>(parcelRequire("h1QnW"))
});
const $116a232d5237eb91$export$c1ba174e1a668b1a = ({ params: { subCalendarId: subCalendarId } })=>{
    const calendarContext = subCalendarId ? (0, $ltKTq.CALENDAR_CONTEXT).SPACE_SUBCALENDAR : (0, $ltKTq.CALENDAR_CONTEXT).SPACE_CALENDARS;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($116a232d5237eb91$var$SpaceTeamCalendarsRouteComponent, {
        subCalendarId: subCalendarId,
        calendarContext: calendarContext
    });
};
$116a232d5237eb91$export$c1ba174e1a668b1a.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, subCalendarId: subCalendarId } })=>{
    return {
        Screen: {
            screenEvent: {
                name: 'spaceTeamCalendarsScreen',
                id: spaceKey,
                attributes: {
                    isSingleCalendar: !!subCalendarId
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};












const $8089a5c0318e4300$export$d299494231e51197 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XYKgm",
    name: "LazySpaceDirectory",
    loader: async ()=>(await (parcelRequire("e9iBv"))).SpaceDirectory
});


const $6b9376eebbcdd446$export$e2f6c7ec524fdd6a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8089a5c0318e4300$export$d299494231e51197), null);
$6b9376eebbcdd446$export$e2f6c7ec524fdd6a.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDirectoryScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });





















const $bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EHSjL",
    name: "SpaceSettingsLandingPageRouteComponent",
    loader: ()=>(parcelRequire("lEzA0"))
});
const $bdfe305fbc319d8d$export$b0e13503df86295 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).name,
        params: {
            spaceKey: spaceKey,
            tab: 'users'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bdfe305fbc319d8d$var$SpaceSettingsLandingPageRouteComponent, {
        spaceKey: spaceKey
    });
};
$bdfe305fbc319d8d$export$b0e13503df86295.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsLandingPage',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });









var $6O2BV = parcelRequire("6O2BV");


var $iMnC5 = parcelRequire("iMnC5");


var $lTECB = parcelRequire("lTECB");


var $ep3mz = parcelRequire("ep3mz");


var $3d5UI = parcelRequire("3d5UI");





var $7EX8o = parcelRequire("7EX8o");

parcelRequire("4Yv1J");



var $4H46k = parcelRequire("4H46k");


var $9pOEz = parcelRequire("9pOEz");

const $6c697104f01a0e5d$var$EmbeddedSpaceOverview = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $6c697104f01a0e5d$var$SpaceOverview = ({ spaceKey: spaceKey, onExperienceResolved: onExperienceResolved })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $djZz9.SpaceOverviewSwitcherLoader), {
        spaceKey: spaceKey,
        onExperienceResolved: onExperienceResolved
    });
};
const $6c697104f01a0e5d$export$495cec58911c040d = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const [spaceOverviewExperience, setSpaceOverviewExperience] = (0, $cozmU.useState)('unknown');
    const contentId = contextContentId ?? '';
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        (0, $3d5UI.waitForGlobal)({
            listener: 'SpaceOverviewRouteComponent.tsx',
            globalProperty: 'AJS.Meta.set'
        }, ()=>{
            window.AJS.Meta.set('content-id-alt', contentId);
        });
        return ()=>{
            window.AJS?.Meta?.set?.('content-id-alt', undefined);
        };
    }, [
        contentId
    ]);
    const component = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c697104f01a0e5d$var$EmbeddedSpaceOverview, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c697104f01a0e5d$var$SpaceOverview, {
        spaceKey: spaceKey,
        onExperienceResolved: setSpaceOverviewExperience
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), {
        attributes: {
            spaceOverviewExperience: spaceOverviewExperience
        }
    }));
};
var $6c697104f01a0e5d$export$2e2bcd8739ae039 = $6c697104f01a0e5d$export$495cec58911c040d;


const $8290afb66ac54848$export$200c90655ff1c697 = (0, $4lJOK.getSpaceOverviewRoute)((0, $6c697104f01a0e5d$export$495cec58911c040d));





















const $0b1718e5f1e38843$export$26b856d756d6b8dc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "h8KkD",
    name: "HubRendererLoader",
    loader: async ()=>(await (parcelRequire("g6gor"))).HubRendererComponent
});








parcelRequire("4Yv1J");









const $f6b27607b6d81126$var$EmbeddedHubRenderer = ({ spaceKey: spaceKey, contentId: contentId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        padding: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7EX8o.EmbeddedViewPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        showHeaderButtons: false
    }));
};
const $f6b27607b6d81126$export$964c57d73cd4c096 = ({ spaceKey: spaceKey })=>{
    const [contextContentId] = (0, $ep3mz.usePageContentId)();
    const contentId = contextContentId ?? '';
    const component = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f6b27607b6d81126$var$EmbeddedHubRenderer, {
        contentId: contentId,
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b1718e5f1e38843$export$26b856d756d6b8dc), {
        spaceKey: spaceKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9pOEz.CommentContextWrapper), null, component)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null));
};
const $f6b27607b6d81126$export$d8819c37d45ffdfc = (0, $hDf9e.getCompanyHubRoute)((0, $6c697104f01a0e5d$export$495cec58911c040d));


























/**
 * The route "Company Hub settings > Analytics" in the Confluence app.
 * `CompanyHubAnalyticsRoute` wraps this one to implement the Company Hub pseudo app.
 */ function $b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute() {
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
        featureName: "companyHub"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), {
        tab: (0, $agglT.CompanyHubSettingsPageTabsType).ANALYTICS
    });
}
$b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute.NAVIGATION_PARAMS = ()=>{
    const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
    const navView = (0, $lFjPc.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubAnalytics'
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_ANALYTICS).name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $b5f6e0dacae3f98e$export$ccf9c625603cc873 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($b5f6e0dacae3f98e$var$ConfluenceAppHubAnalyticsRoute);









var $eXODy = parcelRequire("eXODy");





var $4HVVm = parcelRequire("4HVVm");


var $ak57N = parcelRequire("ak57N");


var $34NZw = parcelRequire("34NZw");


var $5vi32 = parcelRequire("5vi32");














var $cZa7r = parcelRequire("cZa7r");








var $3gyyc = parcelRequire("3gyyc");

const $0e80cf500c4229e5$var$EditPageContent = ({ contentId: contentId, spaceKey: spaceKey, draftShareId: draftShareId, contentType: contentType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4HVVm.EditPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    });
const $0e80cf500c4229e5$export$5cc0e8d070ec38e9 = ({ params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam }, query: query, pathname: pathname })=>{
    const draftShareId = typeof query?.draftShareId === 'string' ? query.draftShareId : undefined;
    // editRouteTypeParam !== contentType !== pageType
    // editContentType is blog or pages
    // contentType is blogpost or page
    // pageType is blog or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldRedirectCompanyHubEditRoute = isCompanyHub && (0, $1NBp8.COMPANY_HUB_EDIT).pattern !== pathname;
    if (shouldRedirectCompanyHubEditRoute) // The company hub edit route should handle upsell scenarios and other cases
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.COMPANY_HUB_EDIT).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZa7r.AnnotationsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $3gyyc.isSSRStreaming)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0e80cf500c4229e5$var$EditPageContent, {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ak57N.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4HVVm.EditPageLoader), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })));
};
$0e80cf500c4229e5$export$5cc0e8d070ec38e9.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentType: editRouteTypeParam } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const isPageLikeContent = editRouteTypeParam === 'pages' || editRouteTypeParam === 'blog';
    const isBlog = editRouteTypeParam === 'blog';
    // editRouteTypeParam !== contentType
    // editRouteTypeParam is blog or pages
    // contentType is blogpost or page
    const contentType = editRouteTypeParam === 'blog' ? 'blogpost' : 'page';
    let viewId = (0, $lFjPc.CONTAINER_HOME_ID);
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) viewId = (0, $lFjPc.PRODUCT_HOME_ID);
    else if (isBlog) viewId = (0, $lFjPc.CONTAINER_HOME_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $56QzY.END)
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: false,
            isViewPage: true,
            isEdit: true
        }
    };
};


const $1f7939e43bf6965f$export$335f265b0f783405 = (0, $hkCxu.getCompanyHubEditRoute)((0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9));












var $hjUDQ = parcelRequire("hjUDQ");


var $eX4up = parcelRequire("eX4up");

















var $6gbpH = parcelRequire("6gbpH");


var $7f6xB = parcelRequire("7f6xB");


var $cbvYp = parcelRequire("cbvYp");




const $ca035e1fc91a5c2a$export$b1a4eb0063bc2123 = ({ params: { contentId: contentId, contentType: editRouteTypeParam } })=>{
    const sessionData = (0, $bQm3c.useSessionData)();
    // Don't render until session data is available to prevent context errors
    if (!sessionData) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6gbpH.HubEditorWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cbvYp.ConfluenceDependenciesProvider), {
        mode: (0, $hjUDQ.ExtensionMode).EDITOR,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7f6xB.HeadingLinksStyleWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eX4up.default), {
        contentId: contentId,
        product: "CONFLUENCE",
        hasEditPermission: true,
        viewMode: "edit",
        userPreferencesProvider: undefined,
        isLoomPluginEnabled: false,
        editorPluginAIOptions: undefined,
        editorPluginAIDefinitionsEnabled: false,
        editorPluginAIDefinitionsConfig: undefined,
        isDesktop: false,
        contextPanelOptions: undefined,
        getExtensionHeight: undefined,
        __rendererExtensionOptions: undefined,
        PropsProvider: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34NZw.PageShownPublicLinksEventLoader), {
        contentId: contentId,
        isPage: editRouteTypeParam === 'page',
        isEditPage: true
    })))));
};
$ca035e1fc91a5c2a$export$b1a4eb0063bc2123.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    const contentType = 'page';
    const viewId = (0, $lFjPc.PRODUCT_HOME_ID);
    const screenEventName = 'companyHubEditorScreen';
    const screenIsInSpace = false;
    return {
        Screen: {
            screenEvent: {
                name: screenEventName,
                id: spaceKey,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)(),
                    navdexPointType: (0, $56QzY.END),
                    screenIsInSpace: screenIsInSpace
                }
            },
            pageState: {
                routeName: routeName,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType
            },
            showPremiumOnboarding: showPremiumOnboarding
        },
        MainLayout: {
            navView: viewId,
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};


const $437f27e114bb0121$export$29545d7913f7e4d9 = (0, $k1285.getCompanyHubEditorRoute)((0, $ca035e1fc91a5c2a$export$b1a4eb0063bc2123));


















/**
 * The route "Company Hub settings" in the Confluence app.
 * `CompanyHubSettingsRoute` wraps this one to implement the Company Hub pseudo app.
 */ const $dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b11848dc615e604f$export$b212d6e1ccf8d345), null);
$dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute.NAVIGATION_PARAMS = ()=>{
    const navView = (0, $lFjPc.COMPANY_HUB_SETTINGS_ID);
    return {
        Screen: {
            screenEvent: {
                name: 'companyHubSettingsScreen',
                attributes: {
                    // Company Hub hides its space from the user, doesn't refer to its page
                    // as such, is rather presented to the user as "a new surface", and thus
                    // doesn't constitute space usage from the perspective of the user.
                    screenIsInSpace: false
                }
            },
            pageState: {
                routeName: (0, $1NBp8.COMPANY_HUB_SETTINGS).name,
                spaceKey: (0, $cEgMD.getCompanyHubSpaceKey)()
            }
        },
        MainLayout: {
            navView: navView
        }
    };
};
const $dbfb738401d21a8a$export$5df4bb70a888e6ef = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($dbfb738401d21a8a$var$ConfluenceAppHubSettingsRoute);

















parcelRequire("crTA1");



const $3ae3b5e6a32b9f05$var$SpacePages = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Mg0yj",
    name: "SpacePages",
    loader: async ()=>(await (parcelRequire("cE1Ys"))).SpacePages
});
const $3ae3b5e6a32b9f05$export$64ef8a59e56631d4 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3ae3b5e6a32b9f05$var$SpacePages, null));
};
$3ae3b5e6a32b9f05$export$64ef8a59e56631d4.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spacePagesScreen',
                attributes: {
                    navigationLayer: 'container',
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            disableMinWidth: true
        }
    });








parcelRequire("crTA1");





const $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazySpaceBlogRedirect), null));
$5fbf62dcc2c7f9c7$export$59ba7d1ff575355e.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'blogHomeScreen'
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $604611f3b9c6a1bd$export$6fe611e4bd8a9f83 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "KbMaW",
    name: 'ManagePagesLoader',
    loader: async ()=>{
        return (await (parcelRequire("ifTtc"))).ManagePagesV2;
    }
});






var $lt6Lx = parcelRequire("lt6Lx");




parcelRequire("crTA1");


const $95e685c28d9f350e$export$690ececaf2f5ac01 = ({ params: { spaceKey: spaceKey } })=>{
    if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $604611f3b9c6a1bd$export$6fe611e4bd8a9f83), {
        spaceKey: spaceKey
    }));
};
$95e685c28d9f350e$export$690ececaf2f5ac01.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceBulkTools',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1mKe4",
    name: "TemplateMigrationPreviewLoader",
    loader: async ()=>(await (parcelRequire("9AQbC"))).TemplateMigrationPreview
});


const $a310d6589e3c6137$export$2549ad5558b468ce = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c51c7f4fbe27db1f$export$e8ec235e2dc3d2c4), {
        templateId: contentId
    });
$a310d6589e3c6137$export$2549ad5558b468ce.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'templateMigrationPreviewScreen'
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false
    });












const $ab6a74840300f72c$export$8cf1c696fd3c0922 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-xoDL",
    name: "TemplateEditorLoader",
    loader: async ()=>{
        const { TemplateEditor: TemplateEditor } = await (parcelRequire("jYfIJ"));
        return TemplateEditor;
    }
});


function $db60bab822fccf44$var$getId(params) {
    const { contentId: contentId, pluginKey: pluginKey, moduleKey: moduleKey } = params;
    return !contentId && moduleKey ? `${pluginKey}:${moduleKey}` : contentId;
}
const $db60bab822fccf44$export$b015e9e7191a93bd = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab6a74840300f72c$export$8cf1c696fd3c0922), {
        templateId: id,
        spaceKey: spaceKey
    }));
};
$db60bab822fccf44$export$b015e9e7191a93bd.NAVIGATION_PARAMS = ({ params: params })=>{
    const id = $db60bab822fccf44$var$getId(params);
    const { spaceKey: spaceKey } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'editTemplatePageScreen',
                id: id || ''
            },
            pageState: {
                contentId: id,
                spaceKey: spaceKey
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    };
};









const $e6c819a73b1c7672$export$70238cd3868b67c9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gd8xC",
    name: "Onboarding",
    loader: async ()=>(await (parcelRequire("b0v5X"))).Onboarding
});



var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");

const $52219feed318a69e$export$329ee42b27a3306e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).CE_MAU
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e6c819a73b1c7672$export$70238cd3868b67c9), null));
$52219feed318a69e$export$329ee42b27a3306e.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'onboardingContainerScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: false
    });















const $9c31020ce936d864$export$e63bb7d08a16e003 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "krpYG",
    name: "NewContentHistory",
    loader: async ()=>(await (parcelRequire("7vEg5"))).NewContentHistory
});








const $48c85dee1e05da94$var$parseVersionParam = (value)=>{
    if (!value || Array.isArray(value)) return undefined;
    const parsedValue = parseInt(value, 10);
    return isNaN(parsedValue) ? undefined : parsedValue;
};
const $48c85dee1e05da94$var$ContentHistoryRouteComponent = ({ params: { spaceKey: spaceKey, contentId: contentId }, query: query })=>{
    const version1 = $48c85dee1e05da94$var$parseVersionParam(query?.version1);
    const version2 = $48c85dee1e05da94$var$parseVersionParam(query?.version2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c31020ce936d864$export$e63bb7d08a16e003), {
        contentId: contentId,
        spaceKey: spaceKey,
        ClassicEditorContextProviderLoader: (0, $6O2BV.ClassicEditorContextProviderLoader),
        version1: version1,
        version2: version2
    }));
};
$48c85dee1e05da94$var$ContentHistoryRouteComponent.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, contentSlug: contentSlug } })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    return {
        Screen: {
            screenEvent: {
                name: isCompanyHub ? 'hubHistoryScreen' : 'pageHistoryScreen',
                id: contentId
            },
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                contentSlug: contentSlug
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: isCompanyHub ? (0, $lFjPc.COMPANY_HUB_SETTINGS_ID) : (0, $lFjPc.CONTAINER_HOME_ID)
        }
    };
};
const $48c85dee1e05da94$export$e510023ce2e8f364 = (0, $2Uf3N.getCompanyHubPseudoAppRoute)($48c85dee1e05da94$var$ContentHistoryRouteComponent, (route)=>(0, $cEgMD.isCompanyHubSpaceKey)(route?.params?.spaceKey));












const $64e99ecf69e59c34$export$9defecaf7509c9ff = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "NjYCL",
    name: "TemplateGalleryLoader",
    loader: async ()=>(await (parcelRequire("1AoQw"))).TemplateGallery
});


const $0f81c6a8d9931e4d$export$e2ed88affe37abdc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64e99ecf69e59c34$export$9defecaf7509c9ff), null);
$0f81c6a8d9931e4d$export$e2ed88affe37abdc.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'templateGalleryScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });









const $eedda2b5abe28404$export$25901255b411dbc4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hLwu8",
    name: "MacroRendererPageLoader",
    loader: async ()=>(await (parcelRequire("99E45"))).MacroRendererPage
});


parcelRequire("4Yv1J");


const $fcdf58a0a381c832$export$29b5dbba9b9e21d8 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eedda2b5abe28404$export$25901255b411dbc4), {
        contentId: contentId,
        ContentExtensionsProvider: (0, $f5aR2.ContentExtensionsProvider)
    });
};
$fcdf58a0a381c832$export$29b5dbba9b9e21d8.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId } })=>({
        Screen: {
            screenEvent: {
                name: 'mobileMacroRendererScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                routeName: name,
                contentId: contentId
            }
        },
        MainLayout: false // No navigation layout needed for mobile app view
    });









const $7b810fd40f00ac37$var$MobileAppTakeoverPageLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "oLwa7",
    name: "MobileAppTakeoverPageLoader",
    loader: async ()=>(await (parcelRequire("dVA4j"))).MobileAppTakeoverPage
});
const $7b810fd40f00ac37$export$1a98ae7373202607 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7b810fd40f00ac37$var$MobileAppTakeoverPageLoader, null);
$7b810fd40f00ac37$export$1a98ae7373202607.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'mobileTakeoverPage'
            }
        },
        MainLayout: false
    });









var $hwzJf = parcelRequire("hwzJf");


var $idSff = parcelRequire("idSff");

const $75f6c666a9c742b2$export$e5707bd7e32dbf9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idSff.SiteHomepageRedirectLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hwzJf.GoToHomeLoader), null));
$75f6c666a9c742b2$export$e5707bd7e32dbf9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'wikiScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });

















const $4625b8b3d160569d$export$48d3d184aade51b1 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hwzJf.GoToHomeLoader), null);
$4625b8b3d160569d$export$48d3d184aade51b1.NAVIGATION_PARAMS = ({ name: name })=>({
        Screen: {
            screenEvent: {
                name: 'homeScreen',
                attributes: {
                    navdexPointType: (0, $56QzY.START_TOUCH)
                }
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            editorPreloader: (0, $eXODy.getEditorPreloader)
        }
    });














const $92a0e12da2d6b5f0$export$bf305e48a79a981b = {
    attributes: {
        navdexPointType: (0, $56QzY.END)
    }
};









var $c3Qwv = parcelRequire("c3Qwv");


var $jlIaF = parcelRequire("jlIaF");





var $bZSO8 = parcelRequire("bZSO8");


var $hBkCm = parcelRequire("hBkCm");

var $f7B1p = parcelRequire("f7B1p");





var $5ZqQS = parcelRequire("5ZqQS");

// RedirectOldCreatePage uses this placeholder when a draft link has no space key.
const $597ca67d1959a56a$var$BY_DRAFT_SPACE_KEY = 'byDraft';
const $597ca67d1959a56a$var$REDIRECT_SOURCE = 'legacyCreateRouteRedirect';
const $597ca67d1959a56a$export$6f3460dcc145deec = ({ contentType: contentType, spaceKey: spaceKey, query: query })=>{
    const rawDraftId = (0, $c3Qwv.getSingleParam)(query, 'draftId');
    const draftId = rawDraftId && /^[0-9]+$/.test(rawDraftId) ? rawDraftId : undefined;
    const isByDraft = !spaceKey || spaceKey === $597ca67d1959a56a$var$BY_DRAFT_SPACE_KEY;
    if (draftId) return {
        draft: {
            draftId: draftId,
            draftShareId: (0, $c3Qwv.getSingleParam)(query, 'draftShareId'),
            spaceKey: isByDraft ? undefined : spaceKey,
            contentType: contentType
        }
    };
    if (isByDraft) // A byDraft link without a usable draft id has nothing to open or create.
    return {
        href: (0, $1NBp8.WIKI).toUrl()
    };
    if (contentType === 'blog') return {
        href: (0, $bZSO8.buildCreationLink)({
            contentType: 'blog',
            spaceKey: spaceKey,
            source: $597ca67d1959a56a$var$REDIRECT_SOURCE
        })
    };
    return {
        href: (0, $bZSO8.buildCreationLink)({
            contentType: 'page',
            spaceKey: spaceKey,
            parentPageId: (0, $c3Qwv.getSingleParam)(query, 'parentPageId') || (0, $c3Qwv.getSingleParam)(query, 'fromPageId'),
            title: (0, $c3Qwv.getSingleParam)(query, 'title'),
            source: $597ca67d1959a56a$var$REDIRECT_SOURCE
        })
    };
};
const $597ca67d1959a56a$var$getDraftEditUrl = ({ draftId: draftId, draftShareId: draftShareId, spaceKey: spaceKey, isBlog: isBlog })=>(isBlog ? (0, $1NBp8.EDIT_BLOG_V2) : (0, $1NBp8.EDIT_PAGE_V2)).toUrl({
        contentType: isBlog ? 'blog' : 'pages',
        spaceKey: spaceKey,
        contentId: draftId
    }, {
        query: draftShareId ? {
            draftShareId: draftShareId
        } : {}
    });
const $597ca67d1959a56a$export$9e26d5351b15c70e = async ({ draftId: draftId, draftShareId: draftShareId, spaceKey: spaceKey, contentType: contentType })=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${(0, $jlIaF.CONTEXT_PATH)}/rest/api/content/${draftId}?status=draft&expand=space`);
        const draft = await response.json();
        const draftSpaceKey = draft?.space?.key;
        if (draftSpaceKey) return $597ca67d1959a56a$var$getDraftEditUrl({
            draftId: draftId,
            draftShareId: draftShareId,
            spaceKey: draftSpaceKey,
            isBlog: draft.type === 'blogpost'
        });
    } catch (error) {
        // Not found or no permission is expected for stale links; report anything else.
        if (!(error instanceof (0, $hBkCm.BadStatusError))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).EDITOR_CORE
        });
    }
    // Without the lookup, fall back to what the URL says. edit-v2 shows its own error if the draft
    // cannot be opened (a draftShareId may also grant access the lookup did not have).
    return spaceKey ? $597ca67d1959a56a$var$getDraftEditUrl({
        draftId: draftId,
        draftShareId: draftShareId,
        spaceKey: spaceKey,
        isBlog: contentType === 'blog'
    }) : (0, $1NBp8.WIKI).toUrl();
};
const $597ca67d1959a56a$var$LegacyCreateDraftRedirect = ({ draftId: draftId, draftShareId: draftShareId, spaceKey: spaceKey, contentType: contentType })=>{
    const [href, setHref] = (0, $cozmU.useState)(null);
    (0, $cozmU.useEffect)(()=>{
        let isCancelled = false;
        $597ca67d1959a56a$export$9e26d5351b15c70e({
            draftId: draftId,
            draftShareId: draftShareId,
            spaceKey: spaceKey,
            contentType: contentType
        }).then((url)=>{
            if (!isCancelled) setHref(url);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        draftId,
        draftShareId,
        spaceKey,
        contentType
    ]);
    return href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: href,
        reason: $597ca67d1959a56a$var$REDIRECT_SOURCE
    }) : null;
};
const $597ca67d1959a56a$export$d1b5d935f2f34af4 = ({ contentType: contentType, spaceKey: spaceKey, query: query })=>{
    const target = $597ca67d1959a56a$export$6f3460dcc145deec({
        contentType: contentType,
        spaceKey: spaceKey,
        query: query
    });
    return 'draft' in target ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($597ca67d1959a56a$var$LegacyCreateDraftRedirect, target.draft) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: target.href,
        reason: $597ca67d1959a56a$var$REDIRECT_SOURCE
    });
};


const $c3c08e13adc00b49$export$daeca97aa431dd80 = ({ params: { spaceKey: spaceKey }, query: query })=>(0, $6mKj3.expValEquals)('confluence_redirect_legacy_create', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $597ca67d1959a56a$export$d1b5d935f2f34af4), {
        contentType: "blog",
        spaceKey: spaceKey,
        query: query
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "blogpost"
    });
$c3c08e13adc00b49$export$daeca97aa431dd80.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>// The redirect renders no screen of its own, like the other redirect routes.
    (0, $6mKj3.expValEquals)('confluence_redirect_legacy_create', 'isEnabled', true) ? false : {
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    };













const $93e08279e521422d$export$92431fd1ef2a3e02 = ({ params: { spaceKey: spaceKey }, query: query })=>(0, $6mKj3.expValEquals)('confluence_redirect_legacy_create', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $597ca67d1959a56a$export$d1b5d935f2f34af4), {
        contentType: "page",
        spaceKey: spaceKey,
        query: query
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazySpaceCreatePage), {
        contentType: "page"
    });
$93e08279e521422d$export$92431fd1ef2a3e02.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>// The redirect renders no screen of its own, like the other redirect routes.
    (0, $6mKj3.expValEquals)('confluence_redirect_legacy_create', 'isEnabled', true) ? false : {
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    };






var $8MiHL = parcelRequire("8MiHL");














const $2807fe6645e49e0b$export$6a3218472cdf374a = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>// Every page opens in the Fabric editor, so skip the tiny-vs-fabric router and its metadata query.
    (0, $6mKj3.expValEquals)('confluence_redirect_legacy_edit', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.EDIT_PAGE_V2).name,
        params: {
            spaceKey: spaceKey,
            contentType: 'pages',
            contentId: contentId
        },
        reason: "legacyEditRouteRedirect"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "pages",
        contentId: contentId,
        spaceKey: spaceKey
    });
$2807fe6645e49e0b$export$6a3218472cdf374a.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>// The redirect renders no screen of its own, like the other redirect routes.
    (0, $6mKj3.expValEquals)('confluence_redirect_legacy_edit', 'isEnabled', true) ? false : {
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b).attributes,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: false
    };




















const $cdf2efa932a544ee$export$657999c2675036a8 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>// Every blog post opens in the Fabric editor, so skip the tiny-vs-fabric router and its metadata query.
    (0, $6mKj3.expValEquals)('confluence_redirect_legacy_edit', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.EDIT_BLOG_V2).name,
        params: {
            spaceKey: spaceKey,
            contentType: 'blog',
            contentId: contentId
        },
        reason: "legacyEditRouteRedirect"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MiHL.LazyRouteToRightEditor), {
        contentType: "blog",
        contentId: contentId,
        spaceKey: spaceKey
    });
$cdf2efa932a544ee$export$657999c2675036a8.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>// The redirect renders no screen of its own, like the other redirect routes.
    (0, $6mKj3.expValEquals)('confluence_redirect_legacy_edit', 'isEnabled', true) ? false : {
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageScreen',
                id: contentId,
                attributes: {
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'blogpost'
            }
        },
        MainLayout: false
    };













const $9ba53981e2ca7f45$export$a835caedc175b18 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "c8AJW",
    name: "EmbeddedEditPageLoader",
    loader: async ()=>(await (parcelRequire("96RjB"))).EmbeddedEditPage
});



const $dde5e37bf0f94188$export$a338f76d183c610 = ({ params: { contentId: contentId, spaceKey: spaceKey }, query: { draftShareId: draftShareId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9ba53981e2ca7f45$export$a835caedc175b18), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: String(draftShareId),
        contentType: "page"
    }));
$dde5e37bf0f94188$export$a338f76d183c610.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageEmbedScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });












const $91e544e3fd3704c7$export$bae7b470830e7536 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EbSw2",
    name: "SmartCreatePageEditorLoader",
    loader: async ()=>(await (parcelRequire("6QwJq"))).SmartCreatePageEditorDataWrapper
});



const $bb42a89ba72dd22d$export$997e52ba9fce325c = ({ params: { contentId: contentId }, query: { iframeHostProduct: iframeHostProduct, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId } })=>{
    const iframeHostProductParam = typeof iframeHostProduct === 'string' ? iframeHostProduct : undefined;
    const sharedFeaturesInstrumentationIdParam = typeof sharedFeaturesInstrumentationId === 'string' ? sharedFeaturesInstrumentationId : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6O2BV.ClassicEditorContextProviderLoader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91e544e3fd3704c7$export$bae7b470830e7536), {
        key: contentId,
        contentId: contentId,
        iframeHostProduct: iframeHostProductParam,
        sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationIdParam
    }));
};
$bb42a89ba72dd22d$export$997e52ba9fce325c.NAVIGATION_PARAMS = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            showPremiumOnboarding: false,
            screenEvent: {
                name: 'editPageSmartCreateScreen',
                id: contentId,
                ...(0, $92a0e12da2d6b5f0$export$bf305e48a79a981b)
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'page'
            }
        },
        MainLayout: false,
        BannerContext: {
            includeTopNav: false
        }
    });





const $819b80c2c59a2565$var$AI_PLANNER_BRIDGE_NAVIGATION_PARAMS = {
    Screen: {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'aiPlannerConfluenceBridgeScreen'
        }
    },
    MainLayout: false,
    BannerContext: {
        includeTopNav: false
    }
};

const $819b80c2c59a2565$export$bb48d26d51801617 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "VA3-t",
    name: "AIPlannerConfluenceBridgeRoute",
    loader: async ()=>(await (parcelRequire("jmwBy"))).AIPlannerConfluenceBridgeRoute
});
$819b80c2c59a2565$export$bb48d26d51801617.NAVIGATION_PARAMS = ()=>$819b80c2c59a2565$var$AI_PLANNER_BRIDGE_NAVIGATION_PARAMS;












const $d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xxPa8",
    name: "SpaceSettingsAutomationRouteComponent",
    loader: ()=>(parcelRequire("lBpK0"))
});
const $d6b8391ba067d418$export$3e7656e40361b9c3 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d6b8391ba067d418$var$SpaceSettingsAutomationRouteComponent, {
        spaceKey: spaceKey
    });
$d6b8391ba067d418$export$3e7656e40361b9c3.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingAutomationRoute',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $90cab0c9e6efa470$export$c5b2c959a5ee5a4a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Lsv8X",
    name: "ConnectSpaceCustomContentListView",
    loader: async ()=>(await (parcelRequire("cov6Y"))).ConnectSpaceCustomContentListView
});


const $25fdeb0a789de125$export$1045fc666c352ae6 = ({ params: { spaceKey: spaceKey, type: type } })=>{
    const [stateKey, setStateKey] = (0, $cozmU.useState)(history?.state?.key || Math.random());
    // Updating a key state and reload ConnectSpaceCustomContentListView component.
    //
    // Connect Apps can have an inner history state (created with AP.history), which add
    // hashtag to URL (for example: #!state1)
    // When user navigates to this route again the URL is reset to initial state and
    // hashtag is removed, but inner app does not get any notifications about that and
    // don't reset inner app state.
    //
    // To fix this issue we are listening history.state.key, and when it's changed
    // (user create a new entry in history) refresh component
    (0, $cozmU.useEffect)(()=>{
        // We rely on history.state.key that is not documented, but major browsers have it
        if (history?.state?.key) setStateKey(history.state.key);
        else if (!history?.state?._AP) setStateKey(Math.random());
    /* eslint-disable react-hooks/exhaustive-deps */ }, [
        history?.state,
        setStateKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90cab0c9e6efa470$export$c5b2c959a5ee5a4a), {
        spaceKey: spaceKey,
        type: type,
        key: stateKey
    });
};
$25fdeb0a789de125$export$1045fc666c352ae6.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, type: type } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceCustomContent',
                id: spaceKey,
                attributes: {
                    type: type
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });









const $ae3041c2a586590e$export$cc376322db18bf6e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sjwPy",
    name: "CustomContentOnPageComponentLoader",
    loader: async ()=>(await (parcelRequire("4A7kr"))).CustomContentOnPageComponent
});





const $4af991445198673b$export$80477c996ae74379 = ({ params: { contentId: contentId, spaceKey: spaceKey, type: type } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ae3041c2a586590e$export$cc376322db18bf6e), {
        contentId: contentId,
        spaceKey: spaceKey,
        type: type === 'undefined' ? '' : type
    });
};
$4af991445198673b$export$80477c996ae74379.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentOnPage',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $95bd051929613722$export$f536037c46d4c012 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9X2ye",
    name: "CustomContentView",
    loader: async ()=>(await (parcelRequire("lR1Cm"))).CustomContentView
});


const $c7473af47fe3192c$export$b836ebd0f49cc9f5 = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95bd051929613722$export$f536037c46d4c012), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$c7473af47fe3192c$export$b836ebd0f49cc9f5.NAVIGATION_PARAMS = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'customContentView',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $0960da40109465b4$var$PublicLinksSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rP97Y",
    name: "PublicLinksSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("hlyKe"))
});
const $0960da40109465b4$export$af4daa43ca1332b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0960da40109465b4$var$PublicLinksSettingsPageRouteComponent, null);
$0960da40109465b4$export$af4daa43ca1332b9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'publicLinksSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $d86fe9bfb21b5293$var$AnonymousAccessSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7xkbS",
    name: "AnonymousAccessSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("4AgSW"))
});
const $d86fe9bfb21b5293$export$1d391e6d67538b19 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d86fe9bfb21b5293$var$AnonymousAccessSettingsPageRouteComponent, null);
$d86fe9bfb21b5293$export$1d391e6d67538b19.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'anonymousAccessSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $4fabe80bae5e8d04$var$SpaceManagementPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VdX74",
    name: "SpaceManagementPageRouteComponent",
    loader: async ()=>(parcelRequire("im0Dk"))
});
const $4fabe80bae5e8d04$export$fd1cbd536f2e61b4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4fabe80bae5e8d04$var$SpaceManagementPageRouteComponent, null);
$4fabe80bae5e8d04$export$fd1cbd536f2e61b4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceManagementScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $25cfc5c41bd5d05f$var$SpaceDefaultsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "PWywz",
    name: "SpaceDefaultsPageRouteComponent",
    loader: async ()=>(parcelRequire("CCF2O"))
});
const $25cfc5c41bd5d05f$export$5425f152a964e2a4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25cfc5c41bd5d05f$var$SpaceDefaultsPageRouteComponent, null);
$25cfc5c41bd5d05f$export$5425f152a964e2a4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceDefaultsPermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $815c579597235468$var$SpaceRolesPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Jbnxb",
    name: "SpaceRolesPageRouteComponent",
    loader: async ()=>(parcelRequire("eYhV2"))
});
const $815c579597235468$export$3d75421a82ac4ef3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($815c579597235468$var$SpaceRolesPageRouteComponent, null);
$815c579597235468$export$3d75421a82ac4ef3.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'spaceRolesScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $139f96c2577c166d$var$SitePermissionsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Y2xVK",
    name: "SitePermissionsPageRouteComponent",
    loader: async ()=>(parcelRequire("i9cjF"))
});
const $139f96c2577c166d$export$29c72ea3332ea2cc = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($139f96c2577c166d$var$SitePermissionsPageRouteComponent, null);
$139f96c2577c166d$export$29c72ea3332ea2cc.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'sitePermissionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $e5c5bd5a8c7b0d6f$var$GuestsSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vk7Ko",
    name: "GuestsSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("fi2Nx"))
});
const $e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e5c5bd5a8c7b0d6f$var$GuestsSettingsPageRouteComponent, null);
$e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'guestsSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $9cf8f85dda9fbba2$var$AppsPermissionsSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HIGKF",
    name: "AppsPermissionsSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("6Crlg"))
});
const $9cf8f85dda9fbba2$export$74dc62432aba2eaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($9cf8f85dda9fbba2$var$AppsPermissionsSettingsPageRouteComponent, null);
$9cf8f85dda9fbba2$export$74dc62432aba2eaa.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'appPermissionsSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $862979a48c317517$var$JsmAccessSettingsPageRouteComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1MuLn",
    name: "JsmAccessSettingsPageRouteComponent",
    loader: async ()=>(parcelRequire("gYtMe"))
});
const $862979a48c317517$export$bc6803ac9d998199 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($862979a48c317517$var$JsmAccessSettingsPageRouteComponent, null);
$862979a48c317517$export$bc6803ac9d998199.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'jsmAccessSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $95bdd88deead3c11$export$ecc44bd892306adb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "00c23",
    name: "ContactAdministratorRoute",
    loader: async ()=>(await (parcelRequire("WDJHu"))).ContactAdministratorPage
});
$95bdd88deead3c11$export$ecc44bd892306adb.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            screenEvent: {
                name: 'contactAdministratorScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    };
};













const $1fb601398675b5a1$var$RoleBasedAccessControlHubRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "FJbMa",
    name: "RoleBasedAccessControlHubRouteComponent",
    loader: async ()=>(parcelRequire("dG89m"))
});
const $1fb601398675b5a1$export$23838e4b7dc196e5 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1fb601398675b5a1$var$RoleBasedAccessControlHubRouteComponent, null);
};
$1fb601398675b5a1$export$23838e4b7dc196e5.NAVIGATION_PARAMS = (routeMatch)=>{
    const { name: name } = routeMatch;
    return {
        Screen: {
            screenEvent: {
                name: 'roleBasedAccessControlHubScreen'
            },
            pageState: {
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};












const $e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LCRNu",
    name: "AdminAnnouncementBannerRenderer",
    loader: async ()=>(await (parcelRequire("1FUYn"))).AdminAnnouncementBannerRenderer
});
const $e77b8eed9c4fe03f$export$81a4ecf687c4a61b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e77b8eed9c4fe03f$var$AdminAnnouncementBannerRenderer, null);
};
$e77b8eed9c4fe03f$export$81a4ecf687c4a61b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminAnnouncementBannerRenderer'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });















const $36a63e56cd2b2984$var$AdminCenterPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yN5_D",
    name: "AdminCenterPage",
    loader: async ()=>(await (parcelRequire("gOLqE"))).AdminCenterPage
});
const $36a63e56cd2b2984$export$60c1a30975370191 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($36a63e56cd2b2984$var$AdminCenterPage, null);
$36a63e56cd2b2984$export$60c1a30975370191.NAVIGATION_PARAMS = ()=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenter',
                attributes: {
                    edition: edition
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};














parcelRequire("crTA1");



const $015145ca08e6a13a$var$AdminCenterSpacePage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "1dPKI",
    name: "AdminCenterSpacePage",
    loader: async ()=>(await (parcelRequire("gOLqE"))).AdminCenterSpacePage
});
const $015145ca08e6a13a$export$bd929b984ffc4a9 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($015145ca08e6a13a$var$AdminCenterSpacePage, {
        spaceKey: spaceKey
    }));
};
$015145ca08e6a13a$export$bd929b984ffc4a9.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    return {
        Screen: {
            screenEvent: {
                name: 'adminCenterSpace',
                id: spaceKey,
                attributes: {
                    edition: edition
                }
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID)
        }
    };
};















var $euL71 = parcelRequire("euL71");

const $6f06338c7fe23a44$export$44bc7d6c094dc951 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition === (0, $euL71.ConfluenceEdition).PREMIUM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CENTER).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
};
$6f06338c7fe23a44$export$44bc7d6c094dc951.NAVIGATION_PARAMS = ()=>false;












const $e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HYdso",
    name: "SpaceSettingsExportSpaceUnavailableRouteComponent",
    loader: ()=>(parcelRequire("3VOtu"))
});
const $e2d8d9818dde6381$export$1d1f8d0ef7c7a185 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2d8d9818dde6381$var$SpaceSettingsExportSpaceUnavailableRouteComponent, {
        spaceKey: spaceKey
    });
$e2d8d9818dde6381$export$1d1f8d0ef7c7a185.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsExportSpaceUnavailable',
                id: spaceKey
            },
            pageState: {
                spaceKey: spaceKey,
                routeName: name
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $55b7ec62080e1638$export$405a6cc8f1c994c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LzFeC",
    loader: async ()=>(await (parcelRequire("41kWH"))).BulkSpacePermissionsPage,
    name: 'BulkSpacePermissionsPage'
});






const $fe2917192dc4f6b9$export$db2035bfb5892b74 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VMbza",
    loader: async ()=>(await (parcelRequire("abZBt"))).BulkAccessManagementPage,
    name: 'BulkAccessManagementPage'
});



var $iJydk = parcelRequire("iJydk");


var $7siXU = parcelRequire("7siXU");




const $4255a2123073399b$export$a1ed7a563d6f8c80 = ()=>{
    const { isRbacEnabled: isRbacEnabled } = (0, $iquRY.useSpaceRoleMode)();
    if (!isRbacEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        bannerVariant: "space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55b7ec62080e1638$export$405a6cc8f1c994c8), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        bannerVariant: "space"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fe2917192dc4f6b9$export$db2035bfb5892b74), null));
};
$4255a2123073399b$export$a1ed7a563d6f8c80.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $iJydk.ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });














parcelRequire("bDjCi");
var $e8WZK = parcelRequire("e8WZK");
var $eHqQb = parcelRequire("eHqQb");

const $d1361d4d835db3f1$export$5164e66822dc5aec = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eHqQb.LazyTeamCalendarSiteSettingsPage), null);
};
$d1361d4d835db3f1$export$5164e66822dc5aec.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $e8WZK.ADMIN_TEAM_CALENDARS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $4VuiN = parcelRequire("4VuiN");

/* AdminControls.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $kSwu1 = parcelRequire("kSwu1");





var $4ez2K = parcelRequire("4ez2K");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $1l0kj = parcelRequire("1l0kj");


var $I7hWB = parcelRequire("I7hWB");


var $4ikjJ = parcelRequire("4ikjJ");


var $ad7Ou = parcelRequire("ad7Ou");


var $i1t43 = parcelRequire("i1t43");


var $dTHYM = parcelRequire("dTHYM");


var $dUI0h = parcelRequire("dUI0h");


var $j7cLK = parcelRequire("j7cLK");


var $V3JOP = parcelRequire("V3JOP");


var $hMCZS = parcelRequire("hMCZS");


var $9DHhW = parcelRequire("9DHhW");


var $lfoFx = parcelRequire("lfoFx");


var $7akNQ = parcelRequire("7akNQ");











var $1kHsc = parcelRequire("1kHsc");

parcelRequire("6V36D");
var $hVSC8 = parcelRequire("hVSC8");


var $1BYn9 = parcelRequire("1BYn9");


var $6MSEP = parcelRequire("6MSEP");








var $fEPJS = parcelRequire("fEPJS");


var $eQiT1 = parcelRequire("eQiT1");


var $9Umtx = parcelRequire("9Umtx");


var $jq995 = parcelRequire("jq995");





var $7joZr = parcelRequire("7joZr");








var $lsxnT = parcelRequire("lsxnT");

/**
 * @generated SignedSource<<854134a3a69b1d840cfbb29220ff4613>>
 * @relayHash f9b10ce854bd3b612917f0d940680b5b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f61aa3a25666da7daba04ef61b2c17cddfcb8277a20e02879d3acd04ad2a3aff
const $dab459a150882bfc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateTeamAdminControlsSettingsPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "selections": [
                {
                    "concreteType": "ConfluenceMutationApi",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "ConfluenceUpdateTeamAdminControlsSettingsPayload",
                            "kind": "LinkedField",
                            "name": "updateTeamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        },
                                        v6 /*: any*/ 
                                    ]
                                },
                                v6 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f9b10ce854bd3b612917f0d940680b5b",
            "id": "f61aa3a25666da7daba04ef61b2c17cddfcb8277a20e02879d3acd04ad2a3aff",
            "metadata": {},
            "name": "useConfluenceSiteTeamConfigurationsMutation",
            "operationKind": "mutation",
            "text": "mutation useConfluenceSiteTeamConfigurationsMutation($input:ConfluenceTeamAdminControlsMode!){confluence{updateTeamAdminControlsSettings(input:$input){success,errors{message,extensions{statusCode,errorType,__typename,...on BulkMutationErrorExtension{id}},__typename},__typename}}}"
        }
    };
}();
$dab459a150882bfc$var$node.hash = "cb12cbeaf9954a0e8247aceccec6df18";
var $dab459a150882bfc$export$2e2bcd8739ae039 = $dab459a150882bfc$var$node;


/**
 * @generated SignedSource<<68ede829ccd8475ef7718dac6a1a3df6>>
 * @relayHash 39d6a72d5b5b54c388e853287b5b83d9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bcdafa25a8ff8d9dade01defb15b8941be3356093ed52cf164bb281b32a6ceb4
const $4ee2724dd2a3884a$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceQueryApi",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
                {
                    "concreteType": "ConfluenceSiteConfiguration",
                    "kind": "LinkedField",
                    "name": "siteConfiguration",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceTeamAdminControlsSettings",
                            "kind": "LinkedField",
                            "name": "teamAdminControlsSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "teamAdminControlsMode"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "39d6a72d5b5b54c388e853287b5b83d9",
            "id": "bcdafa25a8ff8d9dade01defb15b8941be3356093ed52cf164bb281b32a6ceb4",
            "metadata": {},
            "name": "useConfluenceSiteTeamConfigurationsQuery",
            "operationKind": "query",
            "text": "query useConfluenceSiteTeamConfigurationsQuery{confluence{siteConfiguration{teamAdminControlsSettings{teamAdminControlsMode}}}}"
        }
    };
}();
$4ee2724dd2a3884a$var$node.hash = "dc96564c26929e9d164a8c5239b5e482";
var $4ee2724dd2a3884a$export$2e2bcd8739ae039 = $4ee2724dd2a3884a$var$node;






var $308Wd = parcelRequire("308Wd");


var $jMyy4 = parcelRequire("jMyy4");





var $7Sm4c = parcelRequire("7Sm4c");


var $irVI7 = parcelRequire("irVI7");








var $4MnFz = parcelRequire("4MnFz");


var $eh6Ml = parcelRequire("eh6Ml");


var $24dy7 = parcelRequire("24dy7");

const $b453cb24cea38560$var$i18nFlags = (0, $kSwu1.defineMessages)({
    successTitle: {
        id: "team-admin-controls.flag.success.title",
        defaultMessage: "Settings saved"
    },
    errorTitle: {
        id: "team-admin-controls.flag.error.title",
        defaultMessage: "Error"
    },
    errorDescription: {
        id: "team-admin-controls.flag.error.description",
        defaultMessage: "Something went wrong. Please try again."
    }
});
const $b453cb24cea38560$export$b8f59813a918ec2 = ()=>{
    const { showFlag: showFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const showSuccessFlag = ()=>{
        showFlag({
            id: `team-admin-controls-success-${Date.now()}`,
            title: formatMessage($b453cb24cea38560$var$i18nFlags.successTitle),
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                label: formatMessage($b453cb24cea38560$var$i18nFlags.successTitle)
            })
        });
    };
    const showErrorFlag = ()=>{
        showFlag({
            id: `team-admin-controls-error-${Date.now()}`,
            title: formatMessage($b453cb24cea38560$var$i18nFlags.errorTitle),
            description: formatMessage($b453cb24cea38560$var$i18nFlags.errorDescription),
            isAutoDismiss: true,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                label: formatMessage($b453cb24cea38560$var$i18nFlags.errorTitle)
            })
        });
    };
    return {
        showSuccessFlag: showSuccessFlag,
        showErrorFlag: showErrorFlag
    };
};


var $44851797bb5ee99f$export$640f4d7e68eecbe5 = /*#__PURE__*/ function(ConfluenceTeamAdminControlsMode) {
    ConfluenceTeamAdminControlsMode["ALL_TEAMS"] = "ALL_TEAMS";
    ConfluenceTeamAdminControlsMode["VERIFIED_TEAMS"] = "VERIFIED_TEAMS";
    ConfluenceTeamAdminControlsMode["NO_TEAMS"] = "NO_TEAMS";
    ConfluenceTeamAdminControlsMode["MEMBER_MANAGED_TEAMS"] = "MEMBER_MANAGED_TEAMS";
    return ConfluenceTeamAdminControlsMode;
}({});
const $44851797bb5ee99f$var$ConfluenceSiteConfigurationQuery = (0, $4ee2724dd2a3884a$export$2e2bcd8739ae039);
const $44851797bb5ee99f$var$UpdateTeamAdminControlsSettingsMutation = (0, $dab459a150882bfc$export$2e2bcd8739ae039);
const $44851797bb5ee99f$export$6c26751b3fc2f7e9 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showErrorFlag: showErrorFlag, showSuccessFlag: showSuccessFlag } = (0, $b453cb24cea38560$export$b8f59813a918ec2)();
    const { data: data, loading: siteConfigurationLoading, error: siteConfigurationError } = (0, $jMyy4.useQueryInterop)($44851797bb5ee99f$var$ConfluenceSiteConfigurationQuery, {
        fetchPolicy: 'network-only',
        __callerPackage__: "team-admin-controls"
    });
    const [runMutation, { loading: updateTeamAdminControlsSettingsLoading }] = (0, $308Wd.useMutationInterop)($44851797bb5ee99f$var$UpdateTeamAdminControlsSettingsMutation, {
        __callerPackage__: "team-admin-controls"
    });
    async function updateTeamAdminControlsSettings(newTeamAdminControlsMode) {
        await runMutation({
            variables: {
                input: newTeamAdminControlsMode
            }
        }).catch((error)=>{
            (0, $7Sm4c.markErrorAsHandled)(error);
            showErrorFlag();
            experienceTracker.fail({
                name: (0, $irVI7.TEAM_ADMIN_CONTROLS_UPDATE_EXPERIENCE),
                error: error
            });
        });
        showSuccessFlag();
        experienceTracker.succeed({
            name: (0, $irVI7.TEAM_ADMIN_CONTROLS_UPDATE_EXPERIENCE)
        });
    }
    const currentTeamAdminControlsMode = data?.confluence?.siteConfiguration?.teamAdminControlsSettings?.teamAdminControlsMode;
    return {
        siteConfigurationLoading: siteConfigurationLoading,
        siteConfigurationError: siteConfigurationError,
        currentTeamAdminControlsMode: currentTeamAdminControlsMode,
        updateTeamAdminControlsSettings: updateTeamAdminControlsSettings,
        updateTeamAdminControlsSettingsLoading: updateTeamAdminControlsSettingsLoading
    };
};


const $14c1e67c9ac9a79b$var$i18n = (0, $kSwu1.defineMessages)({
    mayLoseAccessFrictionModalTitle: {
        id: "team-admin-controls.friction-modal.lose-some-access-title",
        defaultMessage: "Member-managed teams will lose access"
    },
    noTeamsFrictionModalTitle: {
        id: "team-admin-controls.friction-modal.no-teams-title",
        defaultMessage: "Teams will lose access"
    },
    mayLoseAccessFrictionModalBody: {
        id: "team-admin-controls.friction-modal.lose-some-access-body",
        defaultMessage: "Limiting the use of <b>open teams</b> to may cause unintended loss of access that is already configured across your site."
    },
    loseAccessFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.lose-some-access-body-additional",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    willLoseAccessFrictionModalBody: {
        id: "team-admin-controls.friction-modal.no-teams-body",
        defaultMessage: "Any member-managed teams currently assigned access on this site will lose that access."
    },
    noTeamsFrictionModalBody: {
        id: "team-admin-controls.friction-modal.no-teams-body",
        defaultMessage: "Any teams currently assigned access on this site will lose that access."
    },
    noTeamsFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.no-teams-body-additional",
        defaultMessage: "<b>This can\u2019t be undone.</b>"
    },
    verifiedTeamsFrictionModalBody: {
        id: "team-admin-controls.friction-modal.verified-teams-body",
        defaultMessage: "Atlassian team is a collection of users that are part of your real-world team. Limiting the use teams to <b>only verified</b> may cause unintended loss of access across your site."
    },
    verifiedTeamsFrictionModalBodyAdditional: {
        id: "team-admin-controls.friction-modal.verified-teams-body-additional",
        defaultMessage: "<b>You can restore this later.</b>"
    },
    frictionModalContinueButton: {
        id: "team-admin-controls.friction-modal.continue-button",
        defaultMessage: "Continue"
    },
    frictionModalCancelButton: {
        id: "team-admin-controls.friction-modal.cancel-button",
        defaultMessage: "Cancel"
    }
});
const $14c1e67c9ac9a79b$export$fe53eaaf4efb0181 = ({ title: title, onConfirm: onConfirm, onClose: onClose, width: width = 'small', teamAccessType: teamAccessType })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const modalText = (0, $cozmU.useMemo)(()=>{
        switch(teamAccessType){
            case (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.willLoseAccessFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.loseAccessFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    })
                };
            case (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.noTeamsFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    })
                };
            default:
                return {
                    title: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalTitle),
                    body: formatMessage($14c1e67c9ac9a79b$var$i18n.mayLoseAccessFrictionModalBody, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    }),
                    bodyAdditional: formatMessage($14c1e67c9ac9a79b$var$i18n.loseAccessFrictionModalBodyAdditional, {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    })
                };
        }
    }, [
        teamAccessType,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Modal, {
        width: width,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Umtx.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jq995.default), {
        appearance: "warning"
    }, title ?? modalText.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fEPJS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, " ", modalText.body), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, modalText.bodyAdditional))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eQiT1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7joZr.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: ()=>onClose()
    }, formatMessage($14c1e67c9ac9a79b$var$i18n.frictionModalCancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "warning",
        onClick: ()=>onConfirm()
    }, formatMessage($14c1e67c9ac9a79b$var$i18n.frictionModalContinueButton)))));
};



const $4cdac1dfe86e0470$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "team-admin-controls.admin-controls.page.title",
        defaultMessage: "Teams"
    },
    manageTeamsButton: {
        id: "team-admin-controls.admin-controls.page.manage-teams-button",
        defaultMessage: "Manage teams"
    },
    description1: {
        id: "team-admin-controls.admin-controls.page.description1",
        defaultMessage: "Decide whether users on your site can assign access to teams (for example, by adding a team to a space and assigning it specific access). When enabled, users can assign access to teams, in addition to groups and individual users."
    },
    description2: {
        id: "team-admin-controls.admin-controls.page.description2",
        defaultMessage: "Atlassian teams let you collaborate quickly and easily with your project team across most Atlassian apps by sharing important links and resources, easily notifying all members, tracking work across apps on the team profile, and more. <link>Learn more about teams</link>"
    },
    radioGroupLabel: {
        id: "team-admin-controls.admin-controls.page.radio-group-label",
        defaultMessage: "Which teams can be assigned access?"
    },
    radioGroupOption1: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-1",
        defaultMessage: "All teams"
    },
    radioGroupOption2: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-2",
        defaultMessage: "Only admin-managed teams"
    },
    radioGroupOption3: {
        id: "team-admin-controls.admin-controls.page.radio-group-option-3",
        defaultMessage: "No teams can be assigned access"
    },
    radioGroupDescription1: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-1",
        defaultMessage: "Both admin-managed and member-managed teams"
    },
    radioGroupDescription2: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-2",
        defaultMessage: "All admin-managed teams will be marked with a blue check. <link>More about admin-managed teams</link>"
    },
    radioGroupDescription3: {
        id: "team-admin-controls.admin-controls.page.radio-group-description-3",
        defaultMessage: "Access can only be assigned to groups and individual users"
    },
    membershipControlRadioGroupLabel: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-label",
        defaultMessage: "Membership control"
    },
    membershipControlRadioGroupOption1: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-option-1",
        defaultMessage: "Allow teams that anyone can join"
    },
    membershipControlRadioGroupOption2: {
        id: "team-admin-controls.admin-controls.page.membership-control-radio-group-option-2",
        defaultMessage: "Only allow teams that require approval to join"
    },
    saveButton: {
        id: "team-admin-controls.admin-controls.page.save-button",
        defaultMessage: "Save"
    },
    cancelButton: {
        id: "team-admin-controls.admin-controls.page.cancel-button",
        defaultMessage: "Cancel"
    }
});
const $4cdac1dfe86e0470$var$styles = {
    description: "_2xTnZxyFLW",
    radioGroupDescription: "_0GTcwRVa5s"
};
const $4cdac1dfe86e0470$var$membershipControlRadioOptions = [
    {
        value: 'open-membership',
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupOption1)
    },
    {
        value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS,
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupOption2)
    }
];
const $4cdac1dfe86e0470$export$997e23a0aec74966 = 'https://support.atlassian.com/platform-experiences/docs/teams-in-confluence-permissions/';
const $4cdac1dfe86e0470$var$AdminControlsContent = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { cloudId: cloudId, orgId: orgId, edition: edition } = (0, $bQm3c.useSessionData)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const { href: href } = (0, $hMCZS.navigateToTeamsApp)({
        type: 'LANDING',
        cloudId: cloudId,
        orgId: orgId,
        userHasNav4Enabled: true
    });
    const onClickManageTeams = ()=>{
        window.open(href, '_blank');
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'clicked manage teams button'
            }
        }).fire();
    };
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { siteConfigurationLoading: siteConfigurationLoading, currentTeamAdminControlsMode: currentTeamAdminControlsMode, updateTeamAdminControlsSettings: updateTeamAdminControlsSettings, updateTeamAdminControlsSettingsLoading: updateTeamAdminControlsSettingsLoading } = (0, $44851797bb5ee99f$export$6c26751b3fc2f7e9)();
    const [hasChanged, setHasChanged] = (0, $cozmU.useState)(false);
    const [membershipControlType, setMembershipControlType] = (0, $cozmU.useState)('open-membership');
    const [lastSavedMembershipControlType, setLastSavedMembershipControlType] = (0, $cozmU.useState)('open-membership');
    const [showFrictionModal, setShowFrictionModal] = (0, $cozmU.useState)(false);
    const [selectedTeamAccessType, setSelectedTeamAccessType] = (0, $cozmU.useState)(undefined); // Track the last saved mode locally to avoid stale server data affecting shouldShowFrictionModal
    const [lastSavedMode, setLastSavedMode] = (0, $cozmU.useState)(undefined);
    (0, $cozmU.useEffect)(()=>{
        if (!siteConfigurationLoading && currentTeamAdminControlsMode) {
            if (currentTeamAdminControlsMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS) {
                setSelectedTeamAccessType((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS);
                setLastSavedMode((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS);
                const membershipControlTypeValue = (0, $6mKj3.expVal)('confluence_frontend_perms_teams_ga_fast_follow', 'isEnabled', false) ? (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS : 'open-membership';
                setMembershipControlType(membershipControlTypeValue);
                setLastSavedMembershipControlType(membershipControlTypeValue);
            } else {
                setSelectedTeamAccessType(currentTeamAdminControlsMode);
                setLastSavedMode(currentTeamAdminControlsMode);
            }
        }
    }, [
        siteConfigurationLoading,
        currentTeamAdminControlsMode
    ]);
    const onTeamAccessTypeChange = (value)=>{
        setHasChanged(value !== lastSavedMode);
        setSelectedTeamAccessType(value);
        if (value !== (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS) setMembershipControlType(lastSavedMembershipControlType);
    };
    const onMembershipControlTypeChange = (value)=>{
        setHasChanged(value !== lastSavedMembershipControlType);
        setMembershipControlType(value);
    }; // We want to show the friction modal only when there is possible access loss:
    // so going from All teams -> Verified/No teams, or Verified -> No teams
    // Going from No teams -> any level above will result in access gain so we don't show the modal.
    // We use lastSavedMode (local state) instead of currentTeamAdminControlsMode (server state)
    // to avoid stale data issues after a save.
    const shouldShowFrictionModal = (0, $cozmU.useCallback)(()=>{
        if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS) return true;
        else if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS && selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS) return true;
        else if (lastSavedMode === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS) return false;
        return false;
    }, [
        lastSavedMode,
        selectedTeamAccessType
    ]);
    const onSaveClick = ()=>{
        if (shouldShowFrictionModal()) setShowFrictionModal(true);
        else onConfirmFrictionModal();
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'saved team access type',
                attributes: {
                    teamAccessType: selectedTeamAccessType || '(empty)',
                    membershipControlType: membershipControlType
                }
            }
        }).fire();
    };
    const onConfirmFrictionModal = async ()=>{
        setShowFrictionModal(false);
        experienceTracker.start({
            name: 'updateTeamAdminControlsSettings'
        });
        if (selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS && membershipControlType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS) {
            await updateTeamAdminControlsSettings((0, $44851797bb5ee99f$export$640f4d7e68eecbe5).MEMBER_MANAGED_TEAMS);
            setLastSavedMembershipControlType(membershipControlType);
            setMembershipControlType(membershipControlType);
        } else {
            await updateTeamAdminControlsSettings(selectedTeamAccessType);
            setLastSavedMembershipControlType('open-membership');
            setMembershipControlType('open-membership');
        }
        setLastSavedMode(selectedTeamAccessType);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'adminControls',
                actionSubject: 'adminControls',
                action: 'confirmed friction modal',
                attributes: {
                    teamAccessType: selectedTeamAccessType,
                    membershipControlType: membershipControlType
                }
            }
        }).fire();
        setHasChanged(false);
    };
    if (!isProductAdmin || edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), null);
    const onCancel = ()=>{
        setHasChanged(false);
        setShowFrictionModal(false);
        setSelectedTeamAccessType(lastSavedMode);
        setMembershipControlType(lastSavedMembershipControlType);
    };
    return siteConfigurationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, showFrictionModal && selectedTeamAccessType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14c1e67c9ac9a79b$export$fe53eaaf4efb0181), {
        width: "medium",
        teamAccessType: selectedTeamAccessType,
        onConfirm: ()=>onConfirmFrictionModal(),
        onClose: ()=>setShowFrictionModal(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large"
    }, formatMessage($4cdac1dfe86e0470$var$i18n.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        appearance: "default",
        onClick: ()=>onClickManageTeams()
    }, formatMessage($4cdac1dfe86e0470$var$i18n.manageTeamsButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.200",
        xcss: $4cdac1dfe86e0470$var$styles.description
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($4cdac1dfe86e0470$var$i18n.description1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage($4cdac1dfe86e0470$var$i18n.description2, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                href: $4cdac1dfe86e0470$export$997e23a0aec74966,
                target: "_blank"
            }, chunks)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        paddingBlockStart: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dTHYM.default), {
        onSubmit: ()=>{
            // TODO: Implement save functionality
            return Promise.resolve();
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.200",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupLabel)), siteConfigurationLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "teamAccessType",
            defaultValue: currentTeamAdminControlsMode ?? undefined
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.100",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption1),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignInline: "start",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption2),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).VERIFIED_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignInline: "start",
                alignBlock: "center",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hVSC8.VerifiedTeamLozenge), {
                spacing: "none"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription2, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: $4cdac1dfe86e0470$export$997e23a0aec74966,
                        target: "_blank"
                    }, chunks)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...fieldProps,
                value: (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS,
                label: formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupOption3),
                onChange: (e)=>onTeamAccessTypeChange(e.target.value),
                isChecked: selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).NO_TEAMS
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignInline: "start",
                space: "space.050",
                xcss: $4cdac1dfe86e0470$var$styles.radioGroupDescription
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                size: "small",
                color: "color.text.subtlest"
            }, formatMessage($4cdac1dfe86e0470$var$i18n.radioGroupDescription3))))), selectedTeamAccessType === (0, $44851797bb5ee99f$export$640f4d7e68eecbe5).ALL_TEAMS && (0, $6mKj3.expVal)('confluence_frontend_perms_teams_ga_fast_follow', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "small"
        }, formatMessage($4cdac1dfe86e0470$var$i18n.membershipControlRadioGroupLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dUI0h.default), {
            name: "membershipControlType",
            defaultValue: membershipControlType
        }, ({ fieldProps: membershipFieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
                space: "space.150",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...membershipFieldProps,
                value: $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].value,
                label: $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].label,
                onChange: (e)=>onMembershipControlTypeChange(e.target.value),
                isChecked: membershipControlType === $4cdac1dfe86e0470$var$membershipControlRadioOptions[0].value
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ikjJ.default), {
                ...membershipFieldProps,
                value: $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].value,
                label: $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].label,
                onChange: (e)=>onMembershipControlTypeChange(e.target.value),
                isChecked: membershipControlType === $4cdac1dfe86e0470$var$membershipControlRadioOptions[1].value
            }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j7cLK.FormFooter), {
            align: "start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            type: "submit",
            isDisabled: !hasChanged,
            isLoading: updateTeamAdminControlsSettingsLoading,
            appearance: "primary",
            onClick: ()=>onSaveClick()
        }, formatMessage($4cdac1dfe86e0470$var$i18n.saveButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            type: "button",
            appearance: "subtle",
            onClick: onCancel,
            isDisabled: !hasChanged
        }, formatMessage($4cdac1dfe86e0470$var$i18n.cancelButton)))))))));
};
const $4cdac1dfe86e0470$export$c6013ec0ca71e14e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4cdac1dfe86e0470$var$AdminControlsContent, null));


const $7793a666921a34a3$export$ee12bdabe55b87f5 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4VuiN.AdminPageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4cdac1dfe86e0470$export$c6013ec0ca71e14e), null));
};
$7793a666921a34a3$export$ee12bdabe55b87f5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminTeamControlsSettings'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $f1b6649640833ae0$export$acaa2dba3cb8a594 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "sV2io",
    name: "LazyConfigurationPage",
    loader: async ()=>(await (parcelRequire("h4TJq"))).ConfigurationPage
});



var $go5PI = parcelRequire("go5PI");




const $daea30cdb73fa105$export$9a9547459861b1d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1b6649640833ae0$export$acaa2dba3cb8a594), null);
$daea30cdb73fa105$export$9a9547459861b1d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $go5PI.ADMIN_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $26ef48198c7a4b22$export$c666402e8e189c20 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XqQyJ",
    name: "LazyDefaultSpaceLogoConfigPage",
    loader: async ()=>(await (parcelRequire("hoI9O"))).DefaultSpaceLogoConfigPage
});



var $87xWZ = parcelRequire("87xWZ");




const $cf2a30228181ae7a$export$12cd952fb663f2a5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $26ef48198c7a4b22$export$c666402e8e189c20), null);
$cf2a30228181ae7a$export$12cd952fb663f2a5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $87xWZ.ADMIN_DEFAULT_SPACE_LOGO_CONFIG_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $0035ce34a536ea29$export$b15e4e022e4cf20b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Gs9zR",
    name: "LazyHeaderAndFooterPage",
    loader: async ()=>(await (parcelRequire("iPL9h"))).HeaderAndFooterPage
});



var $9VF1g = parcelRequire("9VF1g");




const $d9d1782c5d23f713$export$66aaa3e4fa4fb446 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0035ce34a536ea29$export$b15e4e022e4cf20b), null);
$d9d1782c5d23f713$export$66aaa3e4fa4fb446.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9VF1g.ADMIN_MIGRATION_HEADER_AND_FOOTER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $20670991d47ae85d$export$eeb35ce919747456 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "g_FZa",
    name: "LazyTemplatesAndBlueprintsPage",
    loader: async ()=>(await (parcelRequire("b5gED"))).TemplatesAndBlueprintsPage
});



var $kzcPl = parcelRequire("kzcPl");




const $3de5f90ca85ac387$export$fb8cddd2e05884ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $20670991d47ae85d$export$eeb35ce919747456), null);
$3de5f90ca85ac387$export$fb8cddd2e05884ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $kzcPl.ADMIN_MIGRATION_TEMPLATES_AND_BLUEPRINTS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });










// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 



var $3Tdyk = parcelRequire("3Tdyk");


const $ee7f717a6b819a49$export$9be270b9ed22878c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "v1sq_",
    name: "LazyNotificationsSiteSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("97Mow"))).NotificationsSiteSettingsPage
});


const $5035325f0c8b9a13$export$65794158c09a379 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ee7f717a6b819a49$export$9be270b9ed22878c), null);
$5035325f0c8b9a13$export$65794158c09a379.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $3Tdyk.ADMIN_NOTIFICATIONS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });















const $9611af456809fa37$export$ed3910c19b60b97e = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "YLxm0",
    name: "LazyCreateWithRovoPage",
    loader: async ()=>(await (parcelRequire("kL15w"))).CreateWithRovoPage
});



var $1fUU3 = parcelRequire("1fUU3");

const $ccbb2c9664b7c084$export$f201f4e6a65cd2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9611af456809fa37$export$ed3910c19b60b97e), null);
$ccbb2c9664b7c084$export$f201f4e6a65cd2.ROUTE_NAME = (0, $1NBp8.ADMIN_CREATE_WITH_ROVO).name;
$ccbb2c9664b7c084$export$f201f4e6a65cd2.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $1fUU3.ADMIN_CREATE_WITH_ROVO_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });



























const $4a6faff2aaf4384e$export$26695507154f3759 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6TCL1",
    name: "PerformanceInsightsPage",
    loader: async ()=>(await (parcelRequire("51Gk2"))).PerformanceInsightsPage
});












var $1VhsF = parcelRequire("1VhsF");


var $jtT80 = parcelRequire("jtT80");









var $8c610 = parcelRequire("8c610");

const $0660c01cbae08147$var$messages = (0, $kSwu1.defineMessages)({
    loading: {
        id: "confluence-frontend-server.performance-insights.access.loading",
        defaultMessage: "Checking access to Performance Monitoring"
    },
    unavailable: {
        id: "confluence-frontend-server.performance-insights.access.unavailable",
        defaultMessage: "Performance Monitoring is unavailable"
    },
    retry: {
        id: "confluence-frontend-server.performance-insights.access.retry",
        defaultMessage: "Retry"
    },
    description: {
        id: "confluence-frontend-server.performance-insights.access.description",
        defaultMessage: "We couldn\u2019t check your access. Try again."
    }
});
const $0660c01cbae08147$var$AccessLoading = ()=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        label: intl.formatMessage($0660c01cbae08147$var$messages.loading)
    }));
};
const $0660c01cbae08147$var$AccessUnavailable = ({ onRetry: onRetry })=>{
    const intl = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1VhsF.default), {
        appearance: "warning",
        title: intl.formatMessage($0660c01cbae08147$var$messages.unavailable),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jtT80.default), {
                key: "retry",
                onClick: onRetry
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0660c01cbae08147$var$messages.retry))
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $0660c01cbae08147$var$messages.description)));
};
const $0660c01cbae08147$var$renderUnavailable = (onRetry)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0660c01cbae08147$var$AccessUnavailable, {
        onRetry: onRetry
    });
const $0660c01cbae08147$export$402ab54d0de5b175 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8c610.PerformanceInsightsAccess), {
        denied: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), {
            showSuperAdminGateway: false
        }),
        loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0660c01cbae08147$var$AccessLoading, null),
        renderUnavailable: $0660c01cbae08147$var$renderUnavailable,
        interactionName: "PerformanceInsightsRouteEntitlement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a6faff2aaf4384e$export$26695507154f3759), null));


const $50fb216eea7c3440$var$USER_SETUP_DETAIL_ROUTE_NAMES = new Set([
    (0, $1NBp8.PERFORMANCE_INSIGHTS_NETWORK_SPEED).name,
    (0, $1NBp8.PERFORMANCE_INSIGHTS_CPU_CORES).name,
    (0, $1NBp8.PERFORMANCE_INSIGHTS_NETWORK_PROTOCOL).name,
    (0, $1NBp8.PERFORMANCE_INSIGHTS_OPERATING_SYSTEM).name
]);
const $50fb216eea7c3440$var$resolveTab = ({ legacyTab: legacyTab, routeName: routeName, tab: tab })=>{
    if ($50fb216eea7c3440$var$USER_SETUP_DETAIL_ROUTE_NAMES.has(routeName) || tab === 'user-setup') return 'user-setup';
    if (tab === 'overview' || tab === undefined && legacyTab === 'overview') return 'overview';
    if (tab === 'content-metrics' || tab === undefined && legacyTab === 'content-metrics') return 'content-metrics';
    return 'load-times';
};
const $50fb216eea7c3440$export$66e6ee80c1ffed5a = ()=>{
    const { isProductAdmin: isProductAdmin, isAdminCheckLoading: isAdminCheckLoading } = (0, $1BYn9.useIsProductAdmin)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (isAdminCheckLoading) return null;
    if (isProductAdmin && (0, $6mKj3.expValEquals)('cc-perf-insights-monitoring', 'isEnabled', true) && (0, $6mKj3.expValEquals)('cc-enterprise-entitlement-checks', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0660c01cbae08147$export$402ab54d0de5b175), null);
    const canAccessPerformanceInsights = isProductAdmin && edition === (0, $euL71.ConfluenceEdition).PREMIUM && (0, $6mKj3.expValEquals)('cc-perf-insights-monitoring', 'isEnabled', true);
    return canAccessPerformanceInsights ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4a6faff2aaf4384e$export$26695507154f3759), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), null);
};
$50fb216eea7c3440$export$66e6ee80c1ffed5a.NAVIGATION_PARAMS = ({ name: name, params: { tab: tab }, query: query })=>{
    const legacyTab = Array.isArray(query.tab) ? query.tab[0] : query.tab;
    const resolvedTab = $50fb216eea7c3440$var$resolveTab({
        legacyTab: legacyTab,
        routeName: name,
        tab: tab
    });
    return {
        Screen: {
            screenEvent: {
                name: 'performanceInsightsScreen',
                attributes: {
                    tab: resolvedTab
                }
            },
            pageState: {
                routeName: name,
                tab: resolvedTab
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};














var $i6ccO = parcelRequire("i6ccO");


const $13b2a397a1cc2782$export$bac0713ec898bd76 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CRbee",
    name: "LazySpaceReportsSiteSettings",
    loader: async ()=>(await (parcelRequire("1QKcJ"))).SpaceReports
});


const $ba2c2ff5f89f0551$export$2667c61817b129fd = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $13b2a397a1cc2782$export$bac0713ec898bd76), null);
$ba2c2ff5f89f0551$export$2667c61817b129fd.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $i6ccO.ADMIN_SPACE_REPORT_SCREEN)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $a1651aa6544b68ec$export$d90af831494c8387 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "HbgyC",
    name: "LazyCodeMacroConfigurationPage",
    loader: async ()=>(await (parcelRequire("k0EFK"))).ConfigureCodeMacroPage
});



var $jPtik = parcelRequire("jPtik");




const $2e9a50b174f89446$export$761483e0f415164e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1651aa6544b68ec$export$d90af831494c8387), null);
$2e9a50b174f89446$export$761483e0f415164e.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $jPtik.ADMIN_CONFIGURE_CODE_MACRO_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











const $0fb617f0ce9f4007$export$8984debadcec9d93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CUSTOMIZE_NAVIGATION).name
    });
$0fb617f0ce9f4007$export$8984debadcec9d93.NAVIGATION_PARAMS = ()=>false;















const $2ce4a32a2c9693ca$export$302da857ce3de1de = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "rig9z",
    name: "AccessRequestSettingsPageLoader",
    loader: async ()=>(await (parcelRequire("j7zVA"))).AccessRequestSettingsPage
});














const $640b7346d02500f9$var$i18n = (0, $kSwu1.defineMessages)({
    pageTitle: {
        id: "access-requests.admin-controls.settings-page.route-title",
        defaultMessage: "Access requests"
    }
});
const $640b7346d02500f9$var$AdminAccessRequestsRouteComponent = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const pageTitle = formatMessage($640b7346d02500f9$var$i18n.pageTitle);
    // Access requests are not available on Free edition, and the nav item is hidden
    // there — block direct navigation to the URL too.
    if (edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MSEP.RestrictedPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7siXU.AdminSecurityPageWrapper), {
        documentTitle: pageTitle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ce4a32a2c9693ca$export$302da857ce3de1de), null));
};
$640b7346d02500f9$var$AdminAccessRequestsRouteComponent.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'productAdminAccessRequestsSettingsScreen'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });
const $640b7346d02500f9$export$e43d8e128566b1eb = $640b7346d02500f9$var$AdminAccessRequestsRouteComponent;









const $545b6e8effa8c8db$export$a21466da6a7c3088 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9Xsqa",
    name: "LazySecurityConfigurationPage",
    loader: async ()=>(await (parcelRequire("bDmqn"))).SecurityConfigurationPage
});



var $5vGLM = parcelRequire("5vGLM");




const $7fe52c8ec8c71cab$export$b882bc9c4e633e9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $545b6e8effa8c8db$export$a21466da6a7c3088), null);
$7fe52c8ec8c71cab$export$b882bc9c4e633e9b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $5vGLM.ADMIN_SECURITY_CONFIGURATION_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $4af95de4de8abb48$export$c1761e3376ce94d1 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Wm-3z",
    name: "AccessLinkSiteAdminControlsLoader",
    loader: async ()=>(await (parcelRequire("c9UHw"))).AccessLinkSiteAdminControls
});





const $ebbc45da5498e408$export$968567891972d6d4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4af95de4de8abb48$export$c1761e3376ce94d1), null);
$ebbc45da5498e408$export$968567891972d6d4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'siteSettingsAccessLinksScreen'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












var $dPJCf = parcelRequire("dPJCf");








const $d9741d166e932512$export$2b380a73df3593c8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "pkFJl",
    name: "AccessLinkSiteAdminConfigurationLoader",
    loader: async ()=>(await (parcelRequire("bPzXG"))).SiteConfigPage
});





const $30cc72374591e2a1$export$ac0bb92ad015adc6 = ()=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const handleBack = (0, $cozmU.useCallback)(()=>push((0, $1NBp8.ADMIN_ACCESS_LINKS).toUrl()), [
        push
    ]);
    if (!(0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d9741d166e932512$export$2b380a73df3593c8), {
        onBack: handleBack
    });
};
$30cc72374591e2a1$export$ac0bb92ad015adc6.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'siteSettingsAccessLinksConfigurationScreen'
            }
        },
        sideNavigationId: (0, $lFjPc.ADMIN_HOME_ID),
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $78ef366567be569a$export$80059957d731c042 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "w8ZSB",
    name: "LazyApplicationNavigatorPage",
    loader: async ()=>(await (parcelRequire("eZ0aX"))).ApplicationNavigatorPage
});



var $dWfBt = parcelRequire("dWfBt");




const $98f73671c286928d$export$55ff18e8dde17771 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $78ef366567be569a$export$80059957d731c042), null);
$98f73671c286928d$export$55ff18e8dde17771.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $dWfBt.ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b750d916e554f7df$export$93a51467d25d0499 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "84mIg",
    name: "LazyMacroUsagePage",
    loader: async ()=>(await (parcelRequire("hEzsM"))).MacroUsagePage
});



var $9JmJC = parcelRequire("9JmJC");




const $2395a25321aca708$export$1e71122b3eac56e4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b750d916e554f7df$export$93a51467d25d0499), null);
$2395a25321aca708$export$1e71122b3eac56e4.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $9JmJC.ADMIN_MACRO_USAGE_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b1c56f7f0cd3abfc$export$db3288808f1d2cee = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "TlnkG",
    name: "LazyTrashedSpacesPage",
    loader: async ()=>(await (parcelRequire("9c23o"))).TrashedSpacesPage
});



var $4l9JY = parcelRequire("4l9JY");




const $b9260b374d11ae03$export$154b40ed25137a69 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b1c56f7f0cd3abfc$export$db3288808f1d2cee), null);
$b9260b374d11ae03$export$154b40ed25137a69.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $4l9JY.ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });





















const $2cc036891fb5d716$var$AdminConfluenceChatsIntegrationComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "EPuLA",
    name: "AdminConfluenceChatsIntegrationComponent",
    loader: async ()=>(parcelRequire("6hRE4"))
});
const $2cc036891fb5d716$export$2e4708beaaa8ed13 = ()=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('twcg-2215-confluence-chats-integration-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cc036891fb5d716$var$AdminConfluenceChatsIntegrationComponent, null);
};
$2cc036891fb5d716$export$2e4708beaaa8ed13.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminConfluenceChatsIntegrationScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












var $7Snc9 = parcelRequire("7Snc9");


const $db04f75f13f6a54c$var$ConfluenceMsTeamsSignInConfirmationComponent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Cw2vj",
    name: "ConfluenceMsTeamsSignInConfirmationComponent",
    loader: async ()=>(parcelRequire("5LuQ6"))
});
const $db04f75f13f6a54c$export$946acfb57ab420fd = ({ query: query })=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('confluence-msteams-signin-confirmation-migration')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Snc9.NotFound), null);
    const successValue = typeof query.successValue === 'string' ? query.successValue : undefined;
    const baseUrl = typeof query.baseUrl === 'string' ? query.baseUrl : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db04f75f13f6a54c$var$ConfluenceMsTeamsSignInConfirmationComponent, {
        successValue: successValue,
        baseUrl: baseUrl
    });
};
// Shown inside a small sign-in popup, not the main Confluence chrome — no nav/breadcrumb to set,
// matching the pattern other chromeless routes (e.g. `ActionRedirectLegacyRoute`) use.
$db04f75f13f6a54c$export$946acfb57ab420fd.NAVIGATION_PARAMS = ()=>false;









const $b17503f7798017b5$export$2ed44b7640eeeaea = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "X7LBt",
    name: "LazyImportSpacesPage",
    loader: async ()=>(await (parcelRequire("kmD3E"))).ImportSpacesPage
});



var $434W4 = parcelRequire("434W4");




const $d9481fcbb25a62a6$export$6078cc5c61cdb00c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b17503f7798017b5$export$2ed44b7640eeeaea), null);
$d9481fcbb25a62a6$export$6078cc5c61cdb00c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $434W4.ADMIN_IMPORT_SPACES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $856e303ba52ed6c6$export$f522a213bf45cbaf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "s23-1",
    name: "LazyJiraMacroRepairPage",
    loader: async ()=>(await (parcelRequire("77WEg"))).JiraMacroRepairPage
});



var $2i0P8 = parcelRequire("2i0P8");




const $3ed31ec1d64e85a3$export$1162e5a60ee7576b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $856e303ba52ed6c6$export$f522a213bf45cbaf), null);
$3ed31ec1d64e85a3$export$1162e5a60ee7576b.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $2i0P8.ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $c621c947d336edb6$export$39b0a52384de05d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "MZ13C",
    name: "LazyThemesPage",
    loader: async ()=>(await (parcelRequire("aFVWt"))).ThemesPage
});



var $ft9Jc = parcelRequire("ft9Jc");




const $95678b1264993b8d$export$cdc2bb4346e935c9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c621c947d336edb6$export$39b0a52384de05d), null);
$95678b1264993b8d$export$cdc2bb4346e935c9.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $ft9Jc.ADMIN_THEMES_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $94ac68953a95a3c6$export$def53ea7cb291102 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "4g9eZ",
    name: "LazyPdfExportPage",
    loader: async ()=>(await (parcelRequire("kJ6M6"))).PdfExportPage
});



var $fmC2G = parcelRequire("fmC2G");




const $d726f64aa7b98b71$export$81e12ffb7d442c0c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94ac68953a95a3c6$export$def53ea7cb291102), null);
$d726f64aa7b98b71$export$81e12ffb7d442c0c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $fmC2G.ADMIN_PDF_EXPORT_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $9f03bd3fce1c6524$export$e1745bf2bc7b6d75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "e-VGC",
    name: "LazyWatermarkConfigurationPage",
    loader: async ()=>(await (parcelRequire("3EZ1I"))).WatermarkConfigurationPage
});





const $1cb4912c670744a4$export$ee4273463a3d48ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9f03bd3fce1c6524$export$e1745bf2bc7b6d75), null);
$1cb4912c670744a4$export$ee4273463a3d48ad.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminWatermarkConfiguration'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









var $8Nhaa = parcelRequire("8Nhaa");




const $b39b3b8c8cb41baf$export$9334d2c8540310e3 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ge6Hg",
    name: "SpaceManagerLoader",
    loader: async ()=>(await (parcelRequire("g4AOq"))).SpaceManager
});


const $244c44f585122129$export$986d179bc3f7f637 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b39b3b8c8cb41baf$export$9334d2c8540310e3), null);
$244c44f585122129$export$986d179bc3f7f637.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $8Nhaa.SPACE_MANAGER_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });













const $d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9HaD7",
    name: "LazyDefaultSpacePermissionsPage",
    loader: async ()=>(await (parcelRequire("5JWNm"))).DefaultSpacePermissionsPage
});
const $d3d38e453fe82603$export$6b4028c8cfa4e9e1 = (routeMatch)=>{
    const { params: { tab: tab } } = routeMatch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d3d38e453fe82603$var$LazyDefaultSpacePermissionsPage, {
        activeTab: tab
    });
};
$d3d38e453fe82603$export$6b4028c8cfa4e9e1.NAVIGATION_PARAMS = (routeMatch)=>({
        Screen: {
            screenEvent: {
                name: 'siteSpacePermissionsScreen',
                attributes: {
                    tab: routeMatch.params.tab
                }
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











const $09759410f0cf9b55$export$e7dd35a659f967b8 = ({ params: { key: key, spaceKey: spaceKey }, query: query })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: key || spaceKey,
            query: query
        }
    });
};
$09759410f0cf9b55$export$e7dd35a659f967b8.NAVIGATION_PARAMS = ()=>false;











function $26b63860644dba7c$export$7bc70d297bcfbf4f(extra) {
    const redirectComponent = ({ query: query })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.HOME).name,
            params: {
                query: {
                    ...query,
                    ...extra
                }
            }
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}











const $7cf8f51aa88b9ccf$export$df2de76576f721a1 = ({ pathname: pathname, search: search, query: query })=>{
    if (query['unmatched-route']) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Snc9.NotFound), null);
    search = search.startsWith('?') ? `${search}&unmatched-route=true` : `?unmatched-route=true`;
    return(//Redirect for .action pages that forces a full page reload
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    }));
};
$7cf8f51aa88b9ccf$export$df2de76576f721a1.NAVIGATION_PARAMS = ()=>false;











const $0a13ad86816c36c0$export$cdc5cf7d787e5e31 = ({ pathname: pathname, search: search, query: query })=>{
    const { draftId: draftId } = query;
    if (typeof draftId !== 'string' || !/^[0-9]+$/.test(draftId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.WIKI).name
    });
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: `${pathname}${search}`,
        forceReload: true
    });
};
$0a13ad86816c36c0$export$cdc5cf7d787e5e31.NAVIGATION_PARAMS = ()=>false;









var $bcVE2 = parcelRequire("bcVE2");





var $jxpvN = parcelRequire("jxpvN");

const $a474944cbbe3347a$var$bannerContextValue = {
    includeTopNav: false
};
const $a474944cbbe3347a$export$300afabe53226c5d = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jxpvN.BannerContext).Provider, {
        value: $a474944cbbe3347a$var$bannerContextValue
    }, children);






var $d73E7 = parcelRequire("d73E7");

const $09a888bb83dd7791$var$isEmbeddedWhiteboard = ({ query: query })=>(0, $bcVE2.isEmbeddedWhiteboardMode)({
        parentProduct: query.parentProduct,
        presentationMode: query.presentationMode
    });
const $09a888bb83dd7791$export$d584a39bdee41574 = (match)=>{
    const { params: { contentId: contentId, spaceKey: spaceKey } } = match;
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    });
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ($09a888bb83dd7791$var$isEmbeddedWhiteboard(match) && (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a474944cbbe3347a$export$300afabe53226c5d), null, element);
    return element;
};
$09a888bb83dd7791$export$d584a39bdee41574.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey }, query: { focusedCommentId: focusedCommentId, focusedMentionId: focusedMentionId, parentProduct: parentProduct, presentationMode: presentationMode } })=>({
        Screen: {
            screenEvent: {
                name: 'whiteboardScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    focusedCommentId: focusedCommentId,
                    focusedMentionId: focusedMentionId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'whiteboard',
                routeName: routeName
            }
        },
        MainLayout: (0, $bcVE2.isEmbeddedWhiteboardMode)({
            parentProduct: parentProduct,
            presentationMode: presentationMode
        }) && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache') ? false : {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });


// Slides route — renders the whiteboard shell in slides mode.
// Downstream whiteboard components now derive slides mode from the route name
// (SLIDES_VIEW) rather than from a ?slides=true query param, so no query-param
// bridge is needed.













const $4e31866782374d42$var$isEmbeddedWhiteboard = ({ query: query })=>(0, $bcVE2.isEmbeddedWhiteboardMode)({
        parentProduct: query.parentProduct,
        presentationMode: query.presentationMode
    });
const $4e31866782374d42$export$3a64ee6cc47e86a4 = (match)=>{
    const { params: { contentId: contentId, spaceKey: spaceKey } } = match;
    const isEmbeddedMode = $4e31866782374d42$var$isEmbeddedWhiteboard(match);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d73E7.WhiteboardRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        isEmbeddedWhiteboard: isEmbeddedMode
    });
    if (isEmbeddedMode) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a474944cbbe3347a$export$300afabe53226c5d), null, element);
    return element;
};
$4e31866782374d42$export$3a64ee6cc47e86a4.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey }, query: { focusedCommentId: focusedCommentId, focusedMentionId: focusedMentionId, parentProduct: parentProduct, presentationMode: presentationMode } })=>({
        Screen: {
            screenEvent: {
                name: 'slideScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    focusedCommentId: focusedCommentId,
                    focusedMentionId: focusedMentionId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'slide',
                routeName: routeName
            }
        },
        MainLayout: (0, $bcVE2.isEmbeddedWhiteboardMode)({
            parentProduct: parentProduct,
            presentationMode: presentationMode
        }) ? false : {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });












const $47326de99f5119ec$export$cdb01b3d24a21485 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "OUrjG",
    name: "FolderContainerLoader",
    loader: async ()=>(await (parcelRequire("dkLzn"))).FolderContainer
});


const $6e131d5d0e81b5af$export$110a009c083fc1fc = ({ params: { contentId: contentId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $47326de99f5119ec$export$cdb01b3d24a21485), {
        contentId: contentId
    });
$6e131d5d0e81b5af$export$110a009c083fc1fc.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>({
        Screen: {
            screenEvent: {
                name: 'folderScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentSlug: contentSlug,
                contentType: 'folder',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });












const $1f4e11c8ff1e70c5$export$e1cd63b567cc2910 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LWjU2",
    name: "EmbedRouteLoader",
    loader: async ()=>(await (parcelRequire("f1vPv"))).EmbedContainer
});





parcelRequire("crTA1");





const $a86e8bdaaaef979c$export$1a870b21a11af9ae = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910), {
        contentId: contentId,
        spaceKey: spaceKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "EmbedViewRoute"
    }));
$a86e8bdaaaef979c$export$1a870b21a11af9ae.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'smartLinkEmbedPageScreen',
                id: contentId,
                attributes: {
                    contentId: contentId,
                    contentType: 'embed'
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'embed',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });









const $ff966974ac17a8ae$export$d5b2cc659cf7a894 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "K1tWi",
    name: "DatabaseContainerLoader",
    loader: async ()=>(await (parcelRequire("7b5PG"))).DatabaseContainer
});






var $bwC5h = parcelRequire("bwC5h");




const $b443bc65ee980e3b$export$2b633aba04c212bb = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bwC5h.default), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ff966974ac17a8ae$export$d5b2cc659cf7a894), {
        contentId: contentId,
        spaceKey: spaceKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "DatabaseViewRoute"
    }));
$b443bc65ee980e3b$export$2b633aba04c212bb.NAVIGATION_PARAMS = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'databaseScreen',
                id: contentId,
                attributes: {
                    contentId: contentId
                }
            },
            pageState: {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: 'database',
                routeName: routeName
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: true
        }
    });


















var $1P7Cq = parcelRequire("1P7Cq");




const $88d3e4eaff5b722d$var$SpaceIndexOverview = ({ spaceKey: spaceKey, query: query })=>{
    const isSSROrHydrating = (0, $1P7Cq.useIsSSROrHydrating)();
    if ((0, $6mKj3.expValEquals)('confluence_react_streaming_all_routes', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $djZz9.SpaceOverviewSwitcherLoader), {
        spaceKey: spaceKey
    }), !isSSROrHydrating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey,
            query: query
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_OVERVIEW).name,
        params: {
            spaceKey: spaceKey,
            query: query
        }
    });
};
const $88d3e4eaff5b722d$export$4c4704aeef10cf08 = (0, $4lJOK.getSpaceOverviewRoute)($88d3e4eaff5b722d$var$SpaceIndexOverview);









const $79a774581f86de14$export$e7975a21b41d4767 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "hYSgM",
    name: "LazyLoader",
    loader: ()=>(parcelRequire("332hs"))
});









var $iufgB = parcelRequire("iufgB");







var $6CEg5 = parcelRequire("6CEg5");




const $4da47b9dcf27590f$export$9af206dbb2b6a483 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iufgB.CreateContentRouteComponentLoader), {
        preloadWhiteboardRouteComponent: (0, $d73E7.WhiteboardRouteComponentLoader).preload,
        preloadDatabaseRouteComponent: (0, $ff966974ac17a8ae$export$d5b2cc659cf7a894).preload,
        preloadPageAndBlogRouteComponent: (0, $79a774581f86de14$export$e7975a21b41d4767).preload,
        preloadSmartLinkEmbedRouteComponent: (0, $1f4e11c8ff1e70c5$export$e1cd63b567cc2910).preload
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6CEg5.PerformanceStart), {
        subject: "PageTree",
        subjectId: "newContentRendered"
    }));
$4da47b9dcf27590f$export$9af206dbb2b6a483.NAVIGATION_PARAMS = ({ name: routeName, params: { spaceKey: spaceKey, contentType: createRouteTypeParam }, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence;
    // spaceKey comes from query object while on creation route
    const currentSpaceKey = spaceKey || query?.spaceKey;
    const isPageLikeContent = createRouteTypeParam === 'page' || createRouteTypeParam === 'blog';
    return {
        Screen: {
            screenEvent: {
                name: 'createContentScreen'
            },
            pageState: {
                spaceKey: currentSpaceKey,
                routeName: routeName
            },
            showPremiumOnboarding: isPageLikeContent ? showPremiumOnboarding : false
        },
        MainLayout: {
            // CREATE_CONTENT route can return an undefined spaceKey during creation so we render a loading screen
            navView: query.spaceKey ? (0, $lFjPc.CONTAINER_HOME_ID) : (0, $lFjPc.CONTAINER_HOME_LOADING_ID),
            spaceKey: currentSpaceKey,
            editorPreloader: isPageLikeContent ? (0, $eXODy.getEditorPreloader) : undefined,
            disableMinWidth: true,
            isViewPage: true,
            isEdit: true
        }
    };
};


















const $5b463946eccb17c7$export$7bd9ae6d5c998c1f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "78c05",
    name: "SplitPageResultsLoader",
    loader: async ()=>(await (parcelRequire("4Y6DR"))).SplitPageResults
});


const $f39a8f3c45c29808$export$5fb3818945ba48e4 = ({ params: params })=>{
    const { contentId: contentId, spaceKey: spaceKey } = params;
    if (!(0, $6mKj3.expValEquals)('confluence-page-splitter', 'isEnabled', 'Test')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $wtSEP.NotFound), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5b463946eccb17c7$export$7bd9ae6d5c998c1f), {
        spaceKey: spaceKey,
        contentId: contentId
    });
};
$f39a8f3c45c29808$export$5fb3818945ba48e4.NAVIGATION_PARAMS = ({ name: name, params: params })=>{
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    if (!(0, $6mKj3.expValEquals)('confluence-page-splitter', 'isEnabled', 'Test')) return false;
    return {
        Screen: {
            screenEvent: {
                name: 'pageSplitScreen',
                id: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: 'page',
                contentSlug: contentSlug || ''
            },
            showPremiumOnboarding: false
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            isViewPage: false
        }
    };
};






var $1xpoY = parcelRequire("1xpoY");


var $6jrkJ = parcelRequire("6jrkJ");


var $cbQWR = parcelRequire("cbQWR");























var $ko9Ek = parcelRequire("ko9Ek");




















var $4D2qK = parcelRequire("4D2qK");





const $37eba1df63470b23$export$f574cd97f97b4d34 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "XaRNl",
    name: "ViewPageLiteHeaderLoader",
    loader: async ()=>(await (parcelRequire("1ptJE"))).ViewPageLiteHeader
});


parcelRequire("8pBIa");
var $6Evf5 = parcelRequire("6Evf5");

parcelRequire("4Yv1J");


parcelRequire("crTA1");





const $92d3732f6f6decb7$export$e537bc4c45dc607c = ({ name: routeName, params: { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } })=>{
    const isPage = routeName === (0, $1NBp8.VIEW_PAGE).name;
    const isBlog = routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || routeName === (0, $1NBp8.VIEW_BLOG).name;
    let contentType;
    // any one of VIEW_BLOG_DATE_LEGACY, VIEW_BLOG or VIEW_PAGE route can end up here from ViewPageOrBlogRoute
    if (isBlog) contentType = 'blogpost';
    else if (isPage) contentType = 'page';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        screenEvent: {
            name: 'viewPageScreen',
            id: contentId,
            attributes: {
                isPublicView: false,
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            objectType: contentType,
            objectId: contentId
        },
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            routeName: routeName,
            contentSlug: contentSlug,
            isLite: true,
            contentType: contentType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $37eba1df63470b23$export$f574cd97f97b4d34), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f5aR2.ContentExtensionsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4D2qK.ViewPageLiteLoader), {
        spaceKey: spaceKey,
        contentId: contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Evf5.default), {
        pageType: contentType
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyDwellTime), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConsumptionViewedAndCompletedEventTracker), {
        spaceKey: spaceKey,
        source: "ViewPageLiteRoute"
    }));
};



var $lJlG6 = parcelRequire("lJlG6");

function $7a7b7faa4141aa1d$var$isLite(query) {
    return Boolean(query?.lite);
}
function $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() {
    return window?.__SSR_RENDERED__ && window?.__DELAYED_CONTENT_REDIRECTION__?.contentSlug || '';
}
const $7a7b7faa4141aa1d$export$51ff3cc323c1250d = (props)=>{
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { name: name, params: params, query: query } = props;
    const { contentId: contentId, spaceKey: spaceKey } = params;
    const isViewPage = name === (0, $1NBp8.VIEW_PAGE).name;
    if ($7a7b7faa4141aa1d$var$isLite(query)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92d3732f6f6decb7$export$e537bc4c45dc607c), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ko9Ek.ViewPageRouteComponentLoader), {
        spaceKey: spaceKey,
        contentId: contentId,
        isMobile: isMobile,
        isPage: isViewPage,
        // TODO: When we have a new `<MobileAppViewPageLoader />` component for the mobile app, update this component to
        //   pass `isMobileApp` here as an additional prop, and inside the component, check if `isMobileApp` is true and
        //   if so, use the new `<MobileAppViewPageLoader />` component
        // https://product-fabric.atlassian.net/browse/REACT-8691
        isEmbeddedConfluence: isEmbeddedConfluence || isMobileApp
    }));
};
$7a7b7faa4141aa1d$export$51ff3cc323c1250d.NAVIGATION_PARAMS = ({ name: name, params: params, query: query })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isMobileApp = (0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const showPremiumOnboarding = !isEmbeddedConfluence && !isMobileApp;
    const { contentId: contentId, spaceKey: spaceKey, contentSlug: contentSlug } = params;
    const isViewBlog = name === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name || name === (0, $1NBp8.VIEW_BLOG).name;
    const contentType = isViewBlog ? 'blogpost' : 'page';
    if ($7a7b7faa4141aa1d$var$isLite(query)) return false;
    // Use contentSlug from SSR delayed-redirection if available
    const correctContentSlug = $7a7b7faa4141aa1d$var$parseContentSlugFromSSR() || contentSlug || '';
    return {
        Screen: {
            screenEvent: {
                name: 'viewPageScreen',
                id: contentId,
                attributes: {
                    isPublicView: false,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                },
                objectType: contentType,
                objectId: contentId
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                contentId: contentId,
                contentType: contentType,
                contentSlug: correctContentSlug
            },
            showPremiumOnboarding: showPremiumOnboarding,
            deferPageRestrictions: (0, $cbQWR.canDeferPageRestrictions)({
                name: name,
                query: query
            }) && !isEmbeddedConfluence && !isMobileApp && !(0, $6jrkJ.getSuperAdminClaim)() && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_restrictions_on_demand') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey,
            editorPreloader: (0, $eXODy.getEditorPreloader),
            isViewPage: true
        }
    };
};









const $674c97fafa39ddaa$export$c8774699c65926c8 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "djuV7",
    name: "TopicHomepage",
    loader: async ()=>(await (parcelRequire("agrhv"))).TopicHomepageComponent
});














const $ad7e3274b7fede14$export$54f890efdb9a624 = ({ params: { topicId: topicId } })=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('confluence_enable_ai_topics_homepage')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $674c97fafa39ddaa$export$c8774699c65926c8), {
        topicId: topicId
    });
};
$ad7e3274b7fede14$export$54f890efdb9a624.NAVIGATION_PARAMS = ({ params: { topicId: topicId } })=>({
        Screen: {
            screenEvent: {
                name: 'topicsScreen'
            },
            pageState: {
                topicId: topicId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            topicId: topicId
        }
    });












const $44ff6e33806985ff$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ULKKd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("i0WZi"))
});
const $44ff6e33806985ff$export$384dd5b6b76557b1 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey
    });
};
const $44ff6e33806985ff$export$9f80bcb940c350e6 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($44ff6e33806985ff$var$QuestionsRouteComponent, {
        spaceKey: spaceKey,
        openCreateQuestionModal: true
    });
};
$44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'questionsScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });
$44ff6e33806985ff$export$9f80bcb940c350e6.NAVIGATION_PARAMS = $44ff6e33806985ff$export$384dd5b6b76557b1.NAVIGATION_PARAMS;






var $dY5Vp = parcelRequire("dY5Vp");




const $281ce5bf20714bdc$export$aea18e9fd89afe15 = ({ params: { spaceKey: spaceKey, questionId: questionId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dY5Vp.LazyQuestions), {
        spaceKey: spaceKey,
        questionId: questionId
    });
};
$281ce5bf20714bdc$export$aea18e9fd89afe15.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'questionScreen',
                questionId: questionId
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    });









const $34607f68a2922062$export$5d828b79b8aa9d27 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "y34AA",
    name: "SiteAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("6tN3O"))).SiteAnalyticsPage
});

















const $63dcc013c61b21bf$export$ccfda76403f5bd22 = ({ params: { tab: tab } })=>{
    if (tab === 'activity' && !(0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Snc9.NotFound), null);
    if (tab === 'users' && (0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SITE_ANALYTICS).name,
        params: {
            tab: 'activity'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $34607f68a2922062$export$5d828b79b8aa9d27), null);
};
$63dcc013c61b21bf$export$ccfda76403f5bd22.NAVIGATION_PARAMS = ({ name: name, params: { tab: tab } })=>{
    if (tab === 'activity' && !(0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false) || tab === 'users' && (0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) return false;
    return {
        Screen: {
            pageState: {
                routeName: name,
                tab: tab === 'activity' ? 'users' : tab
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};









const $421f3eadd830fd14$export$6dd852c6aabadfda = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "rTAZ6",
    name: "SitePermissionsPageLoader",
    loader: async ()=>(await (parcelRequire("6wUI6"))).SitePermissionsPage
});





const $2dd41eaa3836b7ed$export$7ed59daacefa1324 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $421f3eadd830fd14$export$6dd852c6aabadfda), null);
};
$2dd41eaa3836b7ed$export$7ed59daacefa1324.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'instanceAnalyticsPermissions'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $b925f878325ca863$export$1c22a22c4bc3d8e9 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "D9x42",
    name: "PageAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("69TVd"))).PageAnalyticsPage
});





const $2ddeeae61cd450c5$export$77b30b491c5d0ee0 = ({ params: { contentId: contentId } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b925f878325ca863$export$1c22a22c4bc3d8e9), {
        contentId: contentId
    });
};
$2ddeeae61cd450c5$export$77b30b491c5d0ee0.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey, contentId: contentId, tab: tab } })=>({
        Screen: {
            // screenEvent will be handled in the page components
            pageState: {
                spaceKey: spaceKey,
                contentId: contentId,
                tab: tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $lFjPc.CONTAINER_HOME_ID)
        }
    });









const $9c22efa8f8a6df7c$export$5c0ffde074fc4758 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VV9sG",
    name: "SpaceAnalyticsPageLoader",
    loader: async ()=>(await (parcelRequire("bN2xS"))).SpaceAnalyticsPage
});

















parcelRequire("crTA1");


const $e76c2474e57ea114$export$af7907eff44c835f = ({ params: { spaceKey: spaceKey, tab: tab } })=>{
    if (tab === 'activity' && !(0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7Snc9.NotFound), null);
    if (tab === 'users' && (0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_ANALYTICS).name,
        params: {
            spaceKey: spaceKey,
            tab: 'activity'
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqZzD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9c22efa8f8a6df7c$export$5c0ffde074fc4758), {
        spaceKey: spaceKey
    }));
};
$e76c2474e57ea114$export$af7907eff44c835f.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey, tab: tab } })=>{
    if (tab === 'activity' && !(0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false) || tab === 'users' && (0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false)) return false;
    return {
        Screen: {
            pageState: {
                routeName: name,
                spaceKey: spaceKey,
                tab: tab === 'activity' ? 'users' : tab
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID)
        }
    };
};














const $4a724484ea837e6c$export$703d82918dc06325 = ({ params: { spaceKey: spaceKey } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $1NBp8.SPACE_PERMISSIONS_SETTINGS).toUrl({
            spaceKey: spaceKey,
            tab: 'analytics'
        })
    });
$4a724484ea837e6c$export$703d82918dc06325.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceAnalyticsPermissions',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            spaceKey: spaceKey,
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID)
        }
    });












const $b819de32c6839e12$var$LazySpaceLegacyContentRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Fm82P",
    name: "LazySpaceLegacyContentRouteComponent",
    loader: async ()=>(await (parcelRequire("jK9jP"))).SpaceLegacyContentRouteComponent
});
const $b819de32c6839e12$export$f983b39883686021 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b819de32c6839e12$var$LazySpaceLegacyContentRouteComponent, {
        spaceKey: spaceKey
    });
};
$b819de32c6839e12$export$f983b39883686021.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'legacyContentScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });





















const $baeceeb2053ed280$var$LazySpaceAvatarsSettingsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6fQBw",
    name: "LazySpaceAvatarsSettingsRouteComponent",
    loader: async ()=>(await (parcelRequire("lHEvX"))).SpaceAvatarsSettingsRouteComponent
});
const $baeceeb2053ed280$export$232f775b06326172 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_approvals_eap', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($baeceeb2053ed280$var$LazySpaceAvatarsSettingsRouteComponent, {
        spaceKey: spaceKey
    });
};
$baeceeb2053ed280$export$232f775b06326172.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'avatarsSettingsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });





















const $1a46d2ab385e41f3$var$LazySpaceStatusAndApprovalsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "szUQW",
    name: "LazySpaceStatusAndApprovalsRouteComponent",
    loader: async ()=>(await (parcelRequire("kR2MJ"))).SpaceStatusAndApprovalsRouteComponent
});
const $1a46d2ab385e41f3$export$905b6f7e554c11f5 = ({ params: { spaceKey: spaceKey } })=>{
    if (!(0, $6mKj3.expVal)('confluence_approvals_eap', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.SPACE_SETTINGS_LANDING_PAGE).name,
        params: {
            spaceKey: spaceKey
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a46d2ab385e41f3$var$LazySpaceStatusAndApprovalsRouteComponent, {
        spaceKey: spaceKey
    });
};
$1a46d2ab385e41f3$export$905b6f7e554c11f5.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            pageState: {
                spaceKey: spaceKey
            },
            screenEvent: {
                name: 'statusAndApprovalsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });












const $e1b3581d111cffc5$export$d563a43e58d8e249 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nNYrs",
    name: "LazyUserAccessPage",
    loader: async ()=>(await (parcelRequire("kfsaj"))).UserAccessPage
});



var $l5PUQ = parcelRequire("l5PUQ");

const $c4bba5ee88869a52$export$45dbe3e1239d2b94 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e1b3581d111cffc5$export$d563a43e58d8e249), null);
$c4bba5ee88869a52$export$45dbe3e1239d2b94.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: (0, $l5PUQ.ADMIN_USER_ACCESS_ANALYTICS_SOURCE)
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });






var $6b4nE = parcelRequire("6b4nE");








const $69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EoQbw",
    name: "LazyExportSpaceRouteComponent",
    loader: async ()=>(await (parcelRequire("11Lo8"))).ExportSpaceRouteComponent
});
const $69b9df17dc76bcc3$export$4d1bd2808cfd2f38 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($69b9df17dc76bcc3$var$LazyExportSpaceRouteComponent, {
        spaceKey: spaceKey
    });
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.propTypes = {
    params: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).shape({
        spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).string.isRequired
    }).isRequired
};
$69b9df17dc76bcc3$export$4d1bd2808cfd2f38.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'ExportSpaceScreen'
            },
            pageState: {
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey,
            disableMinWidth: true
        }
    });












const $8e1d38472579226f$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "yT4rd",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("i0WZi"))
});
const $8e1d38472579226f$export$6cff3d6e80ecc64 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8e1d38472579226f$var$QuestionsRouteComponent, {
        isGlobalPage: true
    });
};
$8e1d38472579226f$export$6cff3d6e80ecc64.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionsScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });












const $a488bad1e68dd6a7$var$QuestionsRouteComponent = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "6VNHf",
    name: "QuestionsRouteComponent",
    loader: ()=>(parcelRequire("i0WZi"))
});
const $a488bad1e68dd6a7$export$5c0c86e79c0609bd = ({ params: { questionId: questionId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a488bad1e68dd6a7$var$QuestionsRouteComponent, {
        questionId: questionId,
        spaceKey: spaceKey,
        isGlobalPage: true
    });
};
$a488bad1e68dd6a7$export$5c0c86e79c0609bd.NAVIGATION_PARAMS = ({ params: { questionId: questionId } })=>({
        Screen: {
            screenEvent: {
                name: 'globalQuestionScreen',
                questionId: questionId
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });








// Avoid re-exports in favor of direct imports or entry-point files




const $ce2cb80274e3a560$export$67d9d65bd2b4815 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "PsbBz",
    name: "ImporterDashboardLoader",
    loader: async ()=>(await (parcelRequire("lIHEz"))).ImporterDashboard
});


const $e2dae4d283de07f2$export$abf2f9d0f3a44f9c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce2cb80274e3a560$export$67d9d65bd2b4815), null);
$e2dae4d283de07f2$export$abf2f9d0f3a44f9c.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'IMPORTER_STATUS_DASHBOARD'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });









const $95bf1213cdd8988b$export$989c0e84e4723f09 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "e5N_k",
    name: "LazyNBMPage",
    loader: async ()=>(await (parcelRequire("gNw9k"))).NBMPage
});





const $0a6ea19b0fb236e1$export$e644f8e819f9f36 = ({ params: { scanId: scanId } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $95bf1213cdd8988b$export$989c0e84e4723f09), {
        scanId: scanId
    });
$0a6ea19b0fb236e1$export$e644f8e819f9f36.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'adminNBMMigration'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });





















const $7aaac7874fe19fe9$export$d63d9de6ed1ff74c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZgfPd",
    name: "StorageManagementPageLoader",
    loader: async ()=>{
        return (await (parcelRequire("ihBq6"))).StorageManagementPage;
    }
});


const $b58455d150841055$export$a7249be2cb7572db = ()=>{
    if (!(0, $9wGTI.fg)('confluence_storage_management_page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CONFIGURATION).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7aaac7874fe19fe9$export$d63d9de6ed1ff74c), null);
};
$b58455d150841055$export$a7249be2cb7572db.ROUTE_NAME = (0, $1NBp8.ADMIN_STORAGE_MANAGEMENT).name;
$b58455d150841055$export$a7249be2cb7572db.NAVIGATION_PARAMS = ()=>{
    return {
        Screen: {
            screenEvent: {
                name: 'adminStorageManagementScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    };
};












const $2eac21f7c787ce68$export$e9527e3d8dc95465 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "2Y2rY",
    name: "AttachmentsPageLoader",
    loader: async ()=>(await (parcelRequire("3I9Fd"))).AttachmentsPage
});


const $167b5527ac95ab07$export$fd9e136112feb41f = ({ params: { contentId: contentId, spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eac21f7c787ce68$export$e9527e3d8dc95465), {
        contentId: contentId,
        spaceKey: spaceKey
    });
};
$167b5527ac95ab07$export$fd9e136112feb41f.NAVIGATION_PARAMS = ({ name: routeName, params: params })=>{
    const { spaceKey: spaceKey, contentId: contentId } = params;
    return {
        Screen: {
            screenEvent: {
                name: 'attachmentsPage',
                id: contentId
            },
            pageState: {
                routeName: routeName,
                contentId: contentId,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_HOME_ID),
            spaceKey: spaceKey
        }
    };
};












const $04345605d1454f1c$export$445b3236f9b51df = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qw_9Z",
    name: "ChatLoader",
    loader: async ()=>(await (parcelRequire("6SZpw"))).Chat
});











const $123d32deac7bf460$export$4fc17ec31b01e987 = ()=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('rovo_search_chat_convergence')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04345605d1454f1c$export$445b3236f9b51df), null);
};
$123d32deac7bf460$export$4fc17ec31b01e987.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'chatScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID)
        }
    });





















const $fd49b5c0edd0f211$var$InferredProjectPage = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "0utsc",
    name: "InferredProjectPage",
    loader: async ()=>(await (parcelRequire("jJ3Iz"))).InferredProjectPage
});
const $fd49b5c0edd0f211$export$8d789824df52a6bc = ()=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('confluence_inferred_project_page_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fd49b5c0edd0f211$var$InferredProjectPage, null);
};
$fd49b5c0edd0f211$export$8d789824df52a6bc.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: 'inferredProjectPageScreen'
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.PRODUCT_HOME_ID),
            disableMinWidth: true
        }
    });












const $c07bb757e3ef4c47$export$8fc14d22356d64d4 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "DN5QL",
    name: "LazyPermissionsExportPage",
    loader: async ()=>(await (parcelRequire("lhsIn"))).PermissionsExportPage
});


const $6deffcd0919e3152$var$PERMISSIONS_EXPORT_ANALYTICS_SOURCE = 'adminPermissionsExport';
const $6deffcd0919e3152$export$9dc6a62d8cf9ae06 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c07bb757e3ef4c47$export$8fc14d22356d64d4), null);
$6deffcd0919e3152$export$9dc6a62d8cf9ae06.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $6deffcd0919e3152$var$PERMISSIONS_EXPORT_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });
























const $1c99ee2f9e6230fc$export$a1aaf5446f2374eb = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "DKV9I",
    name: "LazyAssignRolesPage",
    loader: async ()=>(await (parcelRequire("lSFxt"))).AssignRolesPage
});


const $5fcbb229533ae7f5$var$PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE = 'adminPermissionsCombinations';
const $5fcbb229533ae7f5$export$2cdfcdcf001693ff = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    // Free sites can't manage space permissions, so the Transition to roles page is
    // not available even when the tenant is mid-transition (a previously paid Free site).
    if (edition === (0, $euL71.ConfluenceEdition).FREE) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.ADMIN_CENTER).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1c99ee2f9e6230fc$export$a1aaf5446f2374eb), null);
};
$5fcbb229533ae7f5$export$2cdfcdcf001693ff.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $5fcbb229533ae7f5$var$PERMISSIONS_COMBINATIONS_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });












const $6581a5926a1ce066$export$9950ebbef62306b5 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "5bwAU",
    name: "LazySystemOperationsPage",
    loader: async ()=>(await (parcelRequire("ejpdO"))).SystemOperationsPage
});


const $7fda056324955ad3$var$SYSTEM_OPERATIONS_ANALYTICS_SOURCE = 'adminSystemOperations';
const $7fda056324955ad3$export$26979a3c4ac291c5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6581a5926a1ce066$export$9950ebbef62306b5), null);
$7fda056324955ad3$export$26979a3c4ac291c5.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $7fda056324955ad3$var$SYSTEM_OPERATIONS_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











var $92IuX = parcelRequire("92IuX");



const $beac86ab997501a9$var$AUDIT_LOG_ANALYTICS_SOURCE = 'audit-log';
const $beac86ab997501a9$export$b6dab1e8a8b6a66d = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92IuX.AuditLogLoader), null);
$beac86ab997501a9$export$b6dab1e8a8b6a66d.NAVIGATION_PARAMS = ()=>({
        Screen: {
            screenEvent: {
                name: $beac86ab997501a9$var$AUDIT_LOG_ANALYTICS_SOURCE
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.ADMIN_HOME_ID)
        }
    });











parcelRequire("4Yv1J");


const $4afa1bc9a87a9b40$export$58816268cacd10b6 = (0, $SwMnm.getAccessLinkRoute)({
    ContextProvider: (0, $f5aR2.ContentExtensionsProvider),
    NotFound: $wtSEP.NotFound,
    ClassicEditorContextProviderLoader: // A live doc reached through an access link mounts the live editor, which needs extension-v1
    // context. Injected here for the same reason `ContextProvider` is: it lives in a classic package
    // that `ssr-app` and `external-share` cannot import.
    $6O2BV.ClassicEditorContextProviderLoader
});












const $588899442361c83f$export$c445ef06d03a3a71 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "9TGJG",
    name: "AccessLinkSpaceAdminControlsLoader",
    loader: async ()=>(await (parcelRequire("itWrA"))).AccessLinkSpaceAdminControls
});


const $306fa1afbc47dc82$export$9357b91a8ce986c5 = ({ params: { spaceKey: spaceKey } })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $588899442361c83f$export$c445ef06d03a3a71), {
        spaceKey: spaceKey
    });
};
$306fa1afbc47dc82$export$9357b91a8ce986c5.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsAccessLinksScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });
























const $425aeba0958814d7$export$bcccc707e876610d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "GL8A5",
    name: "AccessLinkSpaceAdminConfigurationLoader",
    loader: async ()=>(await (parcelRequire("d03lP"))).SpaceConfigPage
});


const $b81de96a75fad070$export$e64a7ea2c0613adc = ({ params: { spaceKey: spaceKey } })=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const handleBack = (0, $cozmU.useCallback)(()=>push((0, $1NBp8.SPACE_SETTINGS_ACCESS_LINKS).toUrl({
            spaceKey: spaceKey
        })), [
        push,
        spaceKey
    ]);
    if (!(0, $6mKj3.expValEquals)('shareable_links_m0', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
        name: (0, $1NBp8.HOME).name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $425aeba0958814d7$export$bcccc707e876610d), {
        onBack: handleBack,
        spaceKey: spaceKey
    });
};
$b81de96a75fad070$export$e64a7ea2c0613adc.NAVIGATION_PARAMS = ({ name: name, params: { spaceKey: spaceKey } })=>({
        Screen: {
            screenEvent: {
                name: 'spaceSettingsAccessLinksConfigurationScreen',
                id: spaceKey
            },
            pageState: {
                routeName: name,
                spaceKey: spaceKey
            }
        },
        MainLayout: {
            navView: (0, $lFjPc.CONTAINER_ADMIN_HOME_ID),
            spaceKey: spaceKey
        }
    });


function $c6a4b2258628a516$var$redirect(name) {
    const redirectComponent = ({ params: params = {} })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: name,
            params: params
        });
    redirectComponent.NAVIGATION_PARAMS = ()=>false;
    return redirectComponent;
}
const $c6a4b2258628a516$export$4d9abfe5519d76c6 = (0, $jiFpb.processNavigationParams)({
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).BASE.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).WIKI.name),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).WIKI.name]: (0, $75f6c666a9c742b2$export$e5707bd7e32dbf9b),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).HOME.name]: (0, $4625b8b3d160569d$export$48d3d184aade51b1),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MOBILE_TAKEOVER_PAGE.name]: (0, $7b810fd40f00ac37$export$1a98ae7373202607),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MOBILE_MACRO_RENDERER.name]: (0, $fcdf58a0a381c832$export$29b5dbba9b9e21d8),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).TEMPLATE_GALLERY.name]: (0, $0f81c6a8d9931e4d$export$e2ed88affe37abdc),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_PAGE.name]: (0, $2807fe6645e49e0b$export$6a3218472cdf374a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_BLOG.name]: (0, $cdf2efa932a544ee$export$657999c2675036a8),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_PAGE_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_BLOG_V2.name]: (0, $0e80cf500c4229e5$export$5cc0e8d070ec38e9),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_PAGE_EMBED.name]: (0, $dde5e37bf0f94188$export$a338f76d183c610),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_PAGE_SMART_CREATE.name]: (0, $bb42a89ba72dd22d$export$997e52ba9fce325c),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).AI_PLANNER_CONFLUENCE_BRIDGE.name]: (0, $819b80c2c59a2565$export$bb48d26d51801617),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CREATE_CONTENT.name]: (0, $4da47b9dcf27590f$export$9af206dbb2b6a483),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CREATE_PAGE.name]: (0, $93e08279e521422d$export$92431fd1ef2a3e02),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CREATE_BLOG.name]: (0, $c3c08e13adc00b49$export$daeca97aa431dd80),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CREATE_PAGE_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CREATE_BLOG_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CREATE_PAGE_VARIABLES_ACTION_LEGACY.name]: (0, $8012954d5e28a430$export$33ab8fb3f76d8b14),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).RESUME_DRAFT_LEGACY.name]: (0, $0a13ad86816c36c0$export$cdc5cf7d787e5e31),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).COPY_PAGE_LEGACY.name]: (0, $e9270d50e13c4524$export$58ad04e57ec143c3),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).DASHBOARD_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPA_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).INDEX_ACTION_LEGACY.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).HOME.name),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).VIEW_PAGE_ACTION_LEGACY.name]: (0, $1547fdfac1788133$export$70a5a4ee184a1106),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_INDEX_ACTION_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    // it should be after "INDEX_ACTION_LEGACY", and can't be the last one, as it will brake navigation to space settings
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ACTION_REDIRECT_LEGACY.name]: (0, $7cf8f51aa88b9ccf$export$df2de76576f721a1),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_DIRECTORY.name]: (0, $6b9376eebbcdd446$export$e2f6c7ec524fdd6a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW_REDIRECT_LEGACY.name]: (0, $09759410f0cf9b55$export$e7dd35a659f967b8),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_INDEX.name]: (0, $88d3e4eaff5b722d$export$4c4704aeef10cf08),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_OVERVIEW.name]: (0, $8290afb66ac54848$export$200c90655ff1c697),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).HUB_EDIT.name]: (0, $437f27e114bb0121$export$29545d7913f7e4d9),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).COMPANY_HUB.name]: (0, $f6b27607b6d81126$export$d8819c37d45ffdfc),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).COMPANY_HUB_ANALYTICS.name]: (0, $b5f6e0dacae3f98e$export$ccf9c625603cc873),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).COMPANY_HUB_EDIT.name]: (0, $1f7939e43bf6965f$export$335f265b0f783405),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).COMPANY_HUB_SETTINGS.name]: (0, $dbfb738401d21a8a$export$5df4bb70a888e6ef),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).GLOBAL_PAGE_FORGE.name]: (0, $88f9531119605f50$export$a0e2b6c59fd25a4e),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_PAGES.name]: (0, $3ae3b5e6a32b9f05$export$64ef8a59e56631d4),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).VIEW_PAGE.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PAGE_SPLIT.name]: (0, $f39a8f3c45c29808$export$5fb3818945ba48e4),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).BLOG_HOME.name]: (0, $5fbf62dcc2c7f9c7$export$59ba7d1ff575355e),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).VIEW_BLOG_DATE_LEGACY.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).VIEW_BLOG.name]: (0, $7a7b7faa4141aa1d$export$51ff3cc323c1250d),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).WHITEBOARD_HOME.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_PAGES.name),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).WHITEBOARD_BOARD.name]: (0, $09a888bb83dd7791$export$d584a39bdee41574),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SLIDES_VIEW.name]: (0, $4e31866782374d42$export$3a64ee6cc47e86a4),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).DATABASE_VIEW.name]: (0, $b443bc65ee980e3b$export$2b633aba04c212bb),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EMBED_VIEW.name]: (0, $a86e8bdaaaef979c$export$1a870b21a11af9ae),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).FOLDER_VIEW.name]: (0, $6e131d5d0e81b5af$export$110a009c083fc1fc),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CONTACT_ADMINISTRATOR.name]: (0, $95bdd88deead3c11$export$ecc44bd892306adb),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_CALENDARS.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_CALENDARS_SUBCALENDAR.name]: (0, $116a232d5237eb91$export$c1ba174e1a668b1a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).DISCOVER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: ''
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ALL_UPDATES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 0
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).POPULAR.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        feed: 1,
        feedType: 'POPULAR'
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MY_WORK_HOME.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MY_WORK_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).RECENT_DRAFTS.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 2
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MY_WORK_RECENT.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1,
        filter: 'WORKED_ON'
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).RECENT_PAGES.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 1
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MY_RECENTLY_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).RECENT_VISITED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 0
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MY_SAVED_FOR_LATER.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).RECENT_SAVED.name]: (0, $26b63860644dba7c$export$7bc70d297bcfbf4f)({
        recentTab: 3
    }),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).TEMPLATE_MIGRATION_PREVIEW.name]: (0, $a310d6589e3c6137$export$2549ad5558b468ce),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_BLUEPRINT.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EDIT_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CREATE_TEMPLATE_SPACE.name]: (0, $db60bab822fccf44$export$b015e9e7191a93bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADVANCED_SEARCH.name]: (0, $f2fc7f6fc64d8f4e$export$dbb0a9dfd98720f),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).EXTERNAL_SHARE.name]: (0, $b4ceb88d52b227e6$export$2f64eafbbfb5bb9f),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ACCESS_LINK.name]: (0, $4afa1bc9a87a9b40$export$58816268cacd10b6),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PEOPLE_DIRECTORY.name]: (0, $24a857c7c96255d7$export$c7bf94fd367d52ef),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MARKETPLACE_APP_REQUESTS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MARKETPLACE_MANAGE_PROMOTIONS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MARKETPLACE_FIND_APPS.name]: (0, $a6aaee7eaacb3bc0$export$1696ac6f866195be),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CONTENT_HISTORY.name]: (0, $48c85dee1e05da94$export$e510023ce2e8f364),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ONBOARDING.name]: (0, $52219feed318a69e$export$329ee42b27a3306e),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_GLOBAL_AUTOMATION.name]: (0, $9dff8dc763109b25$export$a4a7c409f3d3e524),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS.name]: (0, $5651b1434c6bae88$export$72e24cb8f0330a61),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HUB_PERMISSIONS.name]: (0, $ce2a2ee7f6871785$export$eeb7368e8bf944ac),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_COMPANY_HOME_BUILDER.name]: (0, $4fa13b181dc663ad$export$5744f34ed241a45c),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_CUSTOMIZE_NAVIGATION.name]: (0, $4fa13b181dc663ad$export$3206f56dd9eda6e),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NEW_GLOBAL_PERMISSIONS_USER_DETAILS.name]: (0, $3e17cd15ad9a2d77$export$ef0ae9b94af7599),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_EDIT_EXTERNAL_SHARING.name]: (0, $0960da40109465b4$export$af4daa43ca1332b9),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_ANONYMOUS_ACCESS.name]: (0, $d86fe9bfb21b5293$export$1d391e6d67538b19),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SPACE_MANAGEMENT.name]: (0, $4fabe80bae5e8d04$export$fd1cbd536f2e61b4),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SPACE_DEFAULTS.name]: (0, $25cfc5c41bd5d05f$export$5425f152a964e2a4),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_GUESTS.name]: (0, $e5c5bd5a8c7b0d6f$export$16c169bdc6cd5ebe),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_APP_PERMISSIONS.name]: (0, $9cf8f85dda9fbba2$export$74dc62432aba2eaa),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_JSM_ACCESS.name]: (0, $862979a48c317517$export$bc6803ac9d998199),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SPACE_ROLES.name]: (0, $815c579597235468$export$3d75421a82ac4ef3),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SITE_PERMISSIONS.name]: (0, $139f96c2577c166d$export$29c72ea3332ea2cc),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS_REDIRECT.name]: (0, $5d42f987126d0d25$export$1eaead8b8e68953c),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_FORGE_APPS.name]: (0, $d553d8b4da7f3160$export$25552d6a584e1fb8),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_BETA_FEATURES.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NEW_FEATURES.name]: (0, $7949c11e9e78d917$export$39279dc1d0cb138f),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NOTIFICATIONS.name]: (0, $5035325f0c8b9a13$export$65794158c09a379),
    [(0, $ccbb2c9664b7c084$export$f201f4e6a65cd2).ROUTE_NAME]: (0, $ccbb2c9664b7c084$export$f201f4e6a65cd2),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS_CPU_CORES.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS_NETWORK_SPEED.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS_NETWORK_PROTOCOL.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS_OPERATING_SYSTEM.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PERFORMANCE_INSIGHTS.name]: (0, $50fb216eea7c3440$export$66e6ee80c1ffed5a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SITE_ANALYTICS.name]: (0, $63dcc013c61b21bf$export$ccfda76403f5bd22),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SITE_ANALYTICS_PERMISSIONS.name]: (0, $2dd41eaa3836b7ed$export$7ed59daacefa1324),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS.name]: (0, $e76c2474e57ea114$export$af7907eff44c835f),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_ANALYTICS_PERMISSIONS.name]: (0, $4a724484ea837e6c$export$703d82918dc06325),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PAGE_ANALYTICS.name]: (0, $2ddeeae61cd450c5$export$77b30b491c5d0ee0),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_ARCHIVED_PAGES.name]: (0, $6079beeead36a4aa$export$77792abc2bfae7a1),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SUGGESTIONS.name]: (0, $2593d4b17876c400$export$a3041cafa4dd68cd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_BULK_TOOLS.name]: (0, $95e685c28d9f350e$export$690ececaf2f5ac01),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name]: (0, $bdfe305fbc319d8d$export$b0e13503df86295),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE_ALT.name]: $c6a4b2258628a516$var$redirect(// oxlint-disable-next-line eslint-core/no-restricted-syntax
    (0, $64KID.namedRoutes).SPACE_SETTINGS_LANDING_PAGE.name),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_FORGE_APPS.name]: (0, $e20a45805838a7c5$export$16cbc228d727cb5e),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_CUSTOM_CONTENT_LIST.name]: (0, $25fdeb0a789de125$export$1045fc666c352ae6),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_FORGE_APPS.name]: (0, $70d1956925899c9e$export$21a09e0ddc77eafe),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ARCHIVE_SPACE.name]: (0, $3d2592d831aaf97c$export$c5e406a0947cdc56),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDITOR_CONVERSION.name]: $c6a4b2258628a516$var$redirect((0, $64KID.namedRoutes).SPACE_SETTINGS.name),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AUTOMATION.name]: (0, $d6b8391ba067d418$export$3e7656e40361b9c3),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS_AND_STATUS.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_CONTENT_STATE.name]: (0, $ada82682e35c0989$export$9cf7aa4fa48eb220),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DATA_CLASSIFICATION.name]: (0, $9ad8ac092b3ce6dd$export$4b1ffbf66f0e44ca),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_WATERMARK_CONFIGURATION.name]: (0, $0db33795337c2a26$export$2bb331cf926ecae2),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT_SPACE_UNAVAILABLE.name]: (0, $e2d8d9818dde6381$export$1d1f8d0ef7c7a185),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EXPORT.name]: (0, $69b9df17dc76bcc3$export$4d1bd2808cfd2f38),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_LEGACY_CONTENT.name]: (0, $b819de32c6839e12$export$f983b39883686021),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AVATARS.name]: (0, $baeceeb2053ed280$export$232f775b06326172),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_STATUS_AND_APPROVALS.name]: (0, $1a46d2ab385e41f3$export$905b6f7e554c11f5),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_RELATED_PAGES.name]: (0, $5fd2607ebf0fb934$export$50efde5a87cc8957),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_EDIT_FEATURES.name]: (0, $c991c60ce35a3f45$export$769dfef0447f3a55),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_AGENT_CONTEXT.name]: (0, $d79bba560e75ebc3$export$5cb7b3311cd85f89),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_DETAILS.name]: (0, $ae6364090fd3faa0$export$45c01163cd56b3a2),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_NATIVE.name]: (0, $44ff6e33806985ff$export$384dd5b6b76557b1),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_QUESTIONS_ASK_NATIVE.name]: (0, $44ff6e33806985ff$export$9f80bcb940c350e6),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_QUESTION_NATIVE.name]: (0, $281ce5bf20714bdc$export$aea18e9fd89afe15),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).QUESTIONS_NATIVE.name]: (0, $8e1d38472579226f$export$6cff3d6e80ecc64),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).QUESTION_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).QUESTIONS_TOPICS_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).QUESTIONS_TOPIC_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).QUESTIONS_EXPERTS_NATIVE.name]: (0, $a488bad1e68dd6a7$export$5c0c86e79c0609bd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).MY_CALENDAR.name]: (0, $e84d6ad8839aa142$export$355693d248632c9a),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PDF_EXPORT_PAGE.name]: (0, $de365c057d45c0f8$export$d4d3fe32e0af1ab9),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PDF_EXPORT_SPACE.name]: (0, $cdc5bb1b4ce25ace$export$f10520cd46ef45dd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CUSTOM_CONTENTS_ON_PAGE_LIST.name]: (0, $4af991445198673b$export$80477c996ae74379),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CUSTOM_CONTENT_VIEW.name]: (0, $c7473af47fe3192c$export$b836ebd0f49cc9f5),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_PERMISSIONS_SETTINGS.name]: (0, $3dace45d43821ccc$export$c4e68572e7b94bc6),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ACCESS_LINKS.name]: (0, $306fa1afbc47dc82$export$9357b91a8ce986c5),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_SETTINGS_ACCESS_LINKS_CONFIGURATION.name]: (0, $b81de96a75fad070$export$e64a7ea2c0613adc),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ROLE_BASED_ACCESS_CONTROL_HUB.name]: (0, $1fb601398675b5a1$export$23838e4b7dc196e5),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_LOOK_AND_FEEL_SETTINGS.name]: (0, $ea3042d7dfb4b938$export$9ebf5b01b0356442),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_ANNOUNCEMENT_BANNER_RENDERER.name]: (0, $e77b8eed9c4fe03f$export$81a4ecf687c4a61b),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_MANAGER.name]: (0, $244c44f585122129$export$986d179bc3f7f637),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).USER_ACCESS.name]: (0, $c4bba5ee88869a52$export$45dbe3e1239d2b94),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_CENTER.name]: (0, $36a63e56cd2b2984$export$60c1a30975370191),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_CENTER_SPACE.name]: (0, $015145ca08e6a13a$export$bd929b984ffc4a9),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SETTINGS.name]: (0, $6f06338c7fe23a44$export$44bc7d6c094dc951),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_BULK_PERMISSIONS.name]: (0, $4255a2123073399b$export$a1ed7a563d6f8c80),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SITE_SPACE_PERMISSIONS.name]: (0, $d3d38e453fe82603$export$6b4028c8cfa4e9e1),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CALENDARS.name]: (0, $d1361d4d835db3f1$export$5164e66822dc5aec),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_TEAM_CONTROLS.name]: (0, $7793a666921a34a3$export$ee12bdabe55b87f5),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_CONFIGURATION.name]: (0, $daea30cdb73fa105$export$9a9547459861b1d),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_DEFAULT_SPACE_LOGO.name]: (0, $cf2a30228181ae7a$export$12cd952fb663f2a5),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_HEADER_AND_FOOTER.name]: (0, $d9d1782c5d23f713$export$66aaa3e4fa4fb446),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_TEMPLATES_AND_BLUEPRINTS.name]: (0, $3de5f90ca85ac387$export$fb8cddd2e05884ff),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_CODE_MACRO_CONFIGURATION.name]: (0, $2e9a50b174f89446$export$761483e0f415164e),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_COLOR_SCHEME.name]: (0, $0fb617f0ce9f4007$export$8984debadcec9d93),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_ACCESS_REQUESTS.name]: (0, $640b7346d02500f9$export$e43d8e128566b1eb),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SECURITY_CONFIGURATION.name]: (0, $7fe52c8ec8c71cab$export$b882bc9c4e633e9b),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_ACCESS_LINKS.name]: (0, $ebbc45da5498e408$export$968567891972d6d4),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_ACCESS_LINKS_CONFIGURATION.name]: (0, $30cc72374591e2a1$export$ac0bb92ad015adc6),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SPACE_REPORTS.name]: (0, $ba2c2ff5f89f0551$export$2667c61817b129fd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_APPLICATION_NAVIGATOR.name]: (0, $98f73671c286928d$export$55ff18e8dde17771),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_TRASHED_SPACES.name]: (0, $b9260b374d11ae03$export$154b40ed25137a69),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_CONFLUENCE_CHATS_INTEGRATION.name]: (0, $2cc036891fb5d716$export$2e4708beaaa8ed13),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CONFLUENCE_MSTEAMS_SIGNIN_CONFIRMATION.name]: (0, $db04f75f13f6a54c$export$946acfb57ab420fd),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_IMPORT_SPACES.name]: (0, $d9481fcbb25a62a6$export$6078cc5c61cdb00c),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_JIRA_MACRO_REPAIR.name]: (0, $3ed31ec1d64e85a3$export$1162e5a60ee7576b),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_MACRO_USAGE.name]: (0, $2395a25321aca708$export$1e71122b3eac56e4),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_THEMES.name]: (0, $95678b1264993b8d$export$cdc2bb4346e935c9),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_PDF_EXPORT.name]: (0, $d726f64aa7b98b71$export$81e12ffb7d442c0c),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_WATERMARK_CONFIGURATION.name]: (0, $1cb4912c670744a4$export$ee4273463a3d48ad),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_SCANS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_SCAN.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_UNVERIFIED.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_UNSUPPORTED.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_RUN_TRANSFORMATIONS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_NBM_MIGRATION_TRANSFORMATIONS.name]: (0, $0a6ea19b0fb236e1$export$e644f8e819f9f36),
    [(0, $b58455d150841055$export$a7249be2cb7572db).ROUTE_NAME]: (0, $b58455d150841055$export$a7249be2cb7572db),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).SPACE_MEMBERS.name]: (0, $f9fff28badc7670c$export$214350c926cc60f2),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).TOPICS.name]: (0, $ad7e3274b7fede14$export$54f890efdb9a624),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).IMPORTER_STATUS_DASHBOARD.name]: (0, $e2dae4d283de07f2$export$abf2f9d0f3a44f9c),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ATTACHMENTS_PAGE.name]: (0, $167b5527ac95ab07$export$fd9e136112feb41f),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).CHAT.name]: (0, $123d32deac7bf460$export$4fc17ec31b01e987),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).INFERRED_PROJECT_PAGE.name]: (0, $fd49b5c0edd0f211$export$8d789824df52a6bc),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).INFERRED_PROJECT_PAGE_WITH_ARI.name]: (0, $fd49b5c0edd0f211$export$8d789824df52a6bc),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PERMISSIONS_EXPORT.name]: (0, $6deffcd0919e3152$export$9dc6a62d8cf9ae06),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).PERMISSIONS_COMBINATIONS.name]: (0, $5fcbb229533ae7f5$export$2cdfcdcf001693ff),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).ADMIN_SYSTEM_OPERATIONS.name]: (0, $7fda056324955ad3$export$26979a3c4ac291c5),
    // oxlint-disable-next-line eslint-core/no-restricted-syntax
    [(0, $64KID.namedRoutes).NEW_AUDIT_LOG.name]: (0, $beac86ab997501a9$export$b6dab1e8a8b6a66d)
});
module.exports["routeComponents"] = $c6a4b2258628a516$export$4d9abfe5519d76c6;

});

parcelRegister("7Snc9", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lFjPc = parcelRequire("lFjPc");


var $iJ8K8 = parcelRequire("iJ8K8");


var $5gmpn = parcelRequire("5gmpn");


var $4H46k = parcelRequire("4H46k");

function $1cae7e3e681988dd$export$271f9f08425019c7() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), {
        screenEvent: {
            name: 'notFoundScreen'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5gmpn.MainLayout), {
        navView: (0, $lFjPc.PRODUCT_HOME_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H46k.LazyConfluenceNotFound), null)));
}
module.exports["NotFound"] = $1cae7e3e681988dd$export$271f9f08425019c7;

});

parcelRegister("bH6Zn", function(module, exports) {

var $bTZ0F = parcelRequire("bTZ0F");

class $2247f8d9b00b1359$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $2247f8d9b00b1359$export$f7dc16cbd16f7bbe = {
    [(0, $bTZ0F.PerformanceObserverEntryTypes).LongTask]: new $2247f8d9b00b1359$export$2c6e86519c9e8188(),
    [(0, $bTZ0F.PerformanceObserverEntryTypes).LayoutShift]: new $2247f8d9b00b1359$export$2c6e86519c9e8188()
};
module.exports["BufferWithMaxLength"] = $2247f8d9b00b1359$export$2c6e86519c9e8188;
module.exports["EntriesBuffer"] = $2247f8d9b00b1359$export$f7dc16cbd16f7bbe;

});

parcelRegister("bTZ0F", function(module, exports) {
// oxlint-disable-next-line eslint/no-redeclare
const $b7dd8cf53c436032$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};
module.exports["PerformanceObserverEntryTypes"] = $b7dd8cf53c436032$export$a4def92db6fc8e17;

});

parcelRegister("cKmxI", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => (parcelRequire("fcvZw")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("idnP4")).useRouterActions);

var $kkBFa = parcelRequire("kkBFa");


var $hSxV5 = parcelRequire("hSxV5");


var $bPYAw = parcelRequire("bPYAw");


var $ebiij = parcelRequire("ebiij");


var $hFkZi = parcelRequire("hFkZi");


var $6GERo = parcelRequire("6GERo");


var $96I48 = parcelRequire("96I48");


var $fcvZw = parcelRequire("fcvZw");


var $idnP4 = parcelRequire("idnP4");


var $4Yqy7 = parcelRequire("4Yqy7");


});

parcelRegister("eCzAr", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("8Dc6h")).default);

var $8Dc6h = parcelRequire("8Dc6h");


var $eJQlm = parcelRequire("eJQlm");


});

parcelRegister("htyBH", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("k9z7m")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("epPJ3")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("9qwq6")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("iL7a3")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("jwQVI")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("jwQVI")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("3UFvg")).isSameRouteMatch);

var $ac1eE = parcelRequire("ac1eE");


var $k9z7m = parcelRequire("k9z7m");


var $epPJ3 = parcelRequire("epPJ3");


var $9qwq6 = parcelRequire("9qwq6");


var $iL7a3 = parcelRequire("iL7a3");


var $jwQVI = parcelRequire("jwQVI");


var $3UFvg = parcelRequire("3UFvg");


});

parcelRegister("3xrKK", function(module, exports) {
parcelRequire("htyBH");
var $jwQVI = parcelRequire("jwQVI");

const $2939fb557696c2f9$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $jwQVI.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("hFkZi", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $iTvlA = parcelRequire("iTvlA");

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $jjIOx = parcelRequire("jjIOx");

parcelRequire("htyBH");
var $jwQVI = parcelRequire("jwQVI");
var $k9z7m = parcelRequire("k9z7m");
var $epPJ3 = parcelRequire("epPJ3");
var $9qwq6 = parcelRequire("9qwq6");
var $iL7a3 = parcelRequire("iL7a3");


var $4NiRC = parcelRequire("4NiRC");

parcelRequire("htyBH");
var $3UFvg = parcelRequire("3UFvg");

const $fbc5c35deb3fef4f$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $fbc5c35deb3fef4f$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $fbc5c35deb3fef4f$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $fbc5c35deb3fef4f$var$stripTrailingSlash(prefix);
        prefix = $fbc5c35deb3fef4f$var$addLeadingSlash(prefix);
        path = $fbc5c35deb3fef4f$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $fbc5c35deb3fef4f$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $fbc5c35deb3fef4f$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$fbc5c35deb3fef4f$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $fbc5c35deb3fef4f$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$fbc5c35deb3fef4f$export$e83e3719fc818ee5(path)) {
        path = $fbc5c35deb3fef4f$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $fbc5c35deb3fef4f$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $fbc5c35deb3fef4f$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $fbc5c35deb3fef4f$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $3UFvg.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $cdc68bbb9513070c$export$36d128238e6b60f5 = {
    action: (0, $jjIOx.DEFAULT_ACTION),
    basePath: '',
    location: (0, $jjIOx.DEFAULT_HISTORY).location,
    history: (0, $jjIOx.DEFAULT_HISTORY),
    match: (0, $jjIOx.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $jjIOx.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $cdc68bbb9513070c$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $jwQVI.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $eb3ax.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $9qwq6.isServerEnvironment)()) dispatch($cdc68bbb9513070c$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $jwQVI.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $fbc5c35deb3fef4f$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $iTvlA.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $eb3ax.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $fbc5c35deb3fef4f$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $fbc5c35deb3fef4f$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $k9z7m.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $iL7a3.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $fbc5c35deb3fef4f$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $fbc5c35deb3fef4f$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $k9z7m.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $iL7a3.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $eb3ax.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $fbc5c35deb3fef4f$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $fbc5c35deb3fef4f$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $eb3ax.default)({}, existingPathParams, params);
            const updatedPath = (0, $epPJ3.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $eb3ax.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $fbc5c35deb3fef4f$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $fbc5c35deb3fef4f$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $cdc68bbb9513070c$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $fbc5c35deb3fef4f$export$2fa6dede99f181e5)(path)) {
                const location = (0, $lI7ls.parsePath)((0, $fbc5c35deb3fef4f$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $jwQVI.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $iTvlA.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $cdc68bbb9513070c$export$1cf0ecab63b1963c = (0, $8s9DV.createStore)({
    initialState: $cdc68bbb9513070c$export$36d128238e6b60f5,
    actions: $cdc68bbb9513070c$var$actions,
    name: 'router'
});
const $cdc68bbb9513070c$export$d6b817abe7a77ea5 = (0, $j8on0.createContainer)($cdc68bbb9513070c$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($cdc68bbb9513070c$var$actions.bootstrapStore(props));
            !(0, $9qwq6.isServerEnvironment)() && dispatch($cdc68bbb9513070c$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $9qwq6.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $cdc68bbb9513070c$export$9569010eab09ae9e = (0, $kBr4q.createHook)($cdc68bbb9513070c$export$1cf0ecab63b1963c);
const $cdc68bbb9513070c$export$ada49399abf7a3a1 = (0, $kBr4q.createActionsHook)($cdc68bbb9513070c$export$1cf0ecab63b1963c);
function $cdc68bbb9513070c$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $kBr4q.createHook)($cdc68bbb9513070c$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $cdc68bbb9513070c$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $c6StJ.defaultRegistry).getStore($cdc68bbb9513070c$export$1cf0ecab63b1963c);
const $cdc68bbb9513070c$export$ebf37f7e180b13a9 = ()=>$cdc68bbb9513070c$export$5ccad187366c8494().storeState.getState();
module.exports["RouterStore"] = $cdc68bbb9513070c$export$1cf0ecab63b1963c;
module.exports["RouterContainer"] = $cdc68bbb9513070c$export$d6b817abe7a77ea5;
module.exports["useRouterStore"] = $cdc68bbb9513070c$export$9569010eab09ae9e;
module.exports["useRouterStoreActions"] = $cdc68bbb9513070c$export$ada49399abf7a3a1;

});

parcelRegister("jjIOx", function(module, exports) {

var $eO7Xs = parcelRequire("eO7Xs");


var $ac1eE = parcelRequire("ac1eE");

const $e1028dcd9b3deb96$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $e1028dcd9b3deb96$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $e1028dcd9b3deb96$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $e1028dcd9b3deb96$export$39607c9878cf5148 = (0, $ac1eE.createLegacyHistory)();
const $e1028dcd9b3deb96$export$1515254c8c90bebb = {
    location: $e1028dcd9b3deb96$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $e1028dcd9b3deb96$export$fa440ddf675c8a93 = 'POP';
module.exports["DEFAULT_MATCH"] = $e1028dcd9b3deb96$export$2de13e891a662beb;
module.exports["DEFAULT_ROUTE"] = $e1028dcd9b3deb96$export$4eadc79233226325;
module.exports["DEFAULT_HISTORY"] = $e1028dcd9b3deb96$export$39607c9878cf5148;
module.exports["DEFAULT_ACTION"] = $e1028dcd9b3deb96$export$fa440ddf675c8a93;

});

parcelRegister("9Nkr4", function(module, exports) {

var $91pEK = parcelRequire("91pEK");


var $RNy7H = parcelRequire("RNy7H");


var $3ct2F = parcelRequire("3ct2F");


var $d9oWA = parcelRequire("d9oWA");


var $97ZVl = parcelRequire("97ZVl");





var $e5SM2 = parcelRequire("e5SM2");


});

parcelRegister("cvj4z", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("aO6HO")).RouterSubscriber);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("j4NNn")).useRouterActions);
$parcel$export(module.exports, "Link", () => (parcelRequire("imtAv")).default);
$parcel$export(module.exports, "RouterStore", () => (parcelRequire("kZkvy")).RouterStore);
$parcel$export(module.exports, "useRouterStoreActions", () => (parcelRequire("kZkvy")).useRouterStoreActions);

parcelRequire("9vmeB");
var $aO6HO = parcelRequire("aO6HO");
var $j4NNn = parcelRequire("j4NNn");

parcelRequire("6BZrm");
var $imtAv = parcelRequire("imtAv");

parcelRequire("bDcGz");
var $lKKkr = parcelRequire("lKKkr");
var $fHQWF = parcelRequire("fHQWF");
var $fEoYr = parcelRequire("fEoYr");
var $bDcGz = parcelRequire("bDcGz");


var $8WqGQ = parcelRequire("8WqGQ");


var $kZkvy = parcelRequire("kZkvy");


var $3yk4a = parcelRequire("3yk4a");

parcelRequire("2Tnfk");
var $jPvl5 = parcelRequire("jPvl5");
var $c7RYO = parcelRequire("c7RYO");
var $2s5nZ = parcelRequire("2s5nZ");


});

parcelRegister("2c1Wz", function(module, exports) {
var $49cc78e79e334ef6$export$a4def92db6fc8e17 = /*#__PURE__*/ function(PerformanceObserverEntryTypes) {
    PerformanceObserverEntryTypes["LayoutShift"] = "layout-shift";
    PerformanceObserverEntryTypes["LongTask"] = "longtask";
    PerformanceObserverEntryTypes["Event"] = "event";
    return PerformanceObserverEntryTypes;
}({});
module.exports["PerformanceObserverEntryTypes"] = $49cc78e79e334ef6$export$a4def92db6fc8e17;

});

parcelRegister("i7t6K", function(module, exports) {

var $2c1Wz = parcelRequire("2c1Wz");

class $4313abb7a0000648$export$2c6e86519c9e8188 {
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
    // Default maxLength is an arbitrary number but it is long enough to capture tasks within the full experience
    // 1000 x 50ms = 50s which should be long enough for every healthy experience
    constructor(maxLength = 1000){
        this.buffer = [];
        this.maxLength = void 0;
        this.full = false;
        this.maxLength = maxLength;
    }
}
const $4313abb7a0000648$export$f7dc16cbd16f7bbe = {
    [(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]: new $4313abb7a0000648$export$2c6e86519c9e8188(),
    [(0, $2c1Wz.PerformanceObserverEntryTypes).Event]: new $4313abb7a0000648$export$2c6e86519c9e8188()
};
// This function is exposed to the window object to be used in the integration tests
// to fail the test if there is a layout shift in the page
const $4313abb7a0000648$var$hadLayoutShift = (predicate)=>{
    const buffer = $4313abb7a0000648$export$f7dc16cbd16f7bbe[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift].buffer;
    return predicate(buffer);
};
window.__hadLayoutShift = $4313abb7a0000648$var$hadLayoutShift;
module.exports["EntriesBuffer"] = $4313abb7a0000648$export$f7dc16cbd16f7bbe;

});

parcelRegister("jiFpb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iJ8K8 = parcelRequire("iJ8K8");


var $5gmpn = parcelRequire("5gmpn");


var $8dwdz = parcelRequire("8dwdz");


var $6pwLK = parcelRequire("6pwLK");

const $6a421125f8ad1b8e$var$routeWithNavigationMapping = new Map();
function $6a421125f8ad1b8e$export$658b4fa209be6b36(match) {
    // We need to ensure all the entries calling processNavigationParams are returning the same RouteWithNavigation instance
    // So that they won't get re-mounted when switching between routes
    const RouteWithNavParams = $6a421125f8ad1b8e$var$routeWithNavigationMapping.get(match.name);
    if (!RouteWithNavParams) return null;
    const { NAVIGATION_PARAMS: NAVIGATION_PARAMS } = RouteWithNavParams;
    if (typeof NAVIGATION_PARAMS !== 'function') return null;
    const isMobile = (0, $8dwdz.shouldShowMobileWeb)();
    const spaceNavParams = NAVIGATION_PARAMS(match);
    const element = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RouteWithNavParams, match);
    if (spaceNavParams === false) return element;
    const { Screen: screen, MainLayout: mainLayout, BannerContext: bannerContext } = spaceNavParams;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), screen, mainLayout === false ? element : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !isMobile,
        ...mainLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pwLK.BannerContextProvider), {
        includeTopNav: bannerContext?.includeTopNav
    }, element)));
}
function $6a421125f8ad1b8e$export$5ce5fb2a75a2a873(routes) {
    for(const name in routes){
        const RouteWithNavParams = routes[name];
        if (typeof RouteWithNavParams.NAVIGATION_PARAMS !== 'function') throw new Error(`Route must define a static NAVIGATION_PARAMS function. ${name} is missing the NAVIGATION_PARAMS function. Please read patterns/routing.md`);
        $6a421125f8ad1b8e$var$routeWithNavigationMapping.set(name, RouteWithNavParams);
        routes[name] = $6a421125f8ad1b8e$export$658b4fa209be6b36;
    }
    return routes;
}
module.exports["processNavigationParams"] = $6a421125f8ad1b8e$export$5ce5fb2a75a2a873;

});

parcelRegister("4lJOK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $cEgMD = parcelRequire("cEgMD");


var $kE2cJ = parcelRequire("kE2cJ");


var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");


var $lFjPc = parcelRequire("lFjPc");


var $1NBp8 = parcelRequire("1NBp8");


var $56QzY = parcelRequire("56QzY");


var $iqPBi = parcelRequire("iqPBi");

function $3dad7419d64a8662$export$3731f94d374dc29b(Component) {
    const SpaceOverviewRoute = (match)=>{
        const { params: { spaceKey: spaceKey = '', contentId: contentId = '' }, query: query } = match;
        if ((0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.COMPANY_HUB).name
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iqPBi.SpaceBase), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: contentId,
            query: query
        }));
    };
    SpaceOverviewRoute.NAVIGATION_PARAMS = ({ params: { spaceKey: spaceKey = '' }, query: { mode: mode = '' } })=>({
            Screen: {
                screenEvent: {
                    name: 'spaceOverviewScreen',
                    id: spaceKey,
                    attributes: {
                        isGlobalMode: mode === 'global',
                        navdexPointType: (0, $56QzY.START_TOUCH),
                        spaceKey: spaceKey
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.SPACE_OVERVIEW).name,
                    contentType: 'page'
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.CONTAINER_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        });
    return SpaceOverviewRoute;
}
const $3dad7419d64a8662$export$2df060b942be85a7 = $3dad7419d64a8662$export$3731f94d374dc29b((0, $djZz9.SpaceOverviewSwitcherLoader));
module.exports["getSpaceOverviewRoute"] = $3dad7419d64a8662$export$3731f94d374dc29b;

});

parcelRegister("hDf9e", function(module, exports) {

var $cozmU = parcelRequire("cozmU");





var $9DHhW = parcelRequire("9DHhW");


var $3d3WW = parcelRequire("3d3WW");


var $1NBp8 = parcelRequire("1NBp8");


var $dPJCf = parcelRequire("dPJCf");


var $bQm3c = parcelRequire("bQm3c");


var $7QM6o = parcelRequire("7QM6o");

const $0d72b6e269966c48$var$isOnCompanyHubRouteArgs = {
    selector: (routeName)=>(0, $1NBp8.COMPANY_HUB).name === routeName
};

const $0d72b6e269966c48$export$83316d703678f96f = ({ children: children })=>{
    const isOnCompanyHubRoute = (0, $dPJCf.useRouteName)($0d72b6e269966c48$var$isOnCompanyHubRouteArgs);
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleAnalyticCaught = (0, $cozmU.useCallback)(async (event, channel)=>{
        if (event?.payload?.action === 'clicked' || event?.payload?.actionSubject === 'smartLink' && event?.payload?.action === 'renderSuccess') await (parcelRequire("jNRDO")).then(async ({ handleEventCaught: handleEventCaught })=>{
            await handleEventCaught(activationId, cloudId, createAnalyticsEvent, event, !!isOnCompanyHubRoute, channel, spaceId);
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        isOnCompanyHubRoute,
        spaceId
    ]);
    if (!isOnCompanyHubRoute) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        channel: "*",
        onEvent: handleAnalyticCaught
    }, children);
};



var $lFjPc = parcelRequire("lFjPc");


var $9HNv5 = parcelRequire("9HNv5");


var $8NC5Z = parcelRequire("8NC5Z");


var $7CeAz = parcelRequire("7CeAz");





var $56QzY = parcelRequire("56QzY");


var $cEgMD = parcelRequire("cEgMD");


var $kE2cJ = parcelRequire("kE2cJ");


var $iJ8K8 = parcelRequire("iJ8K8");


var $djZz9 = parcelRequire("djZz9");


var $6mKj3 = parcelRequire("6mKj3");


var $eqNP8 = parcelRequire("eqNP8");





var $jKzCD = parcelRequire("jKzCD");


var $1P7Cq = parcelRequire("1P7Cq");


var $eCfJ3 = parcelRequire("eCfJ3");


var $2Uf3N = parcelRequire("2Uf3N");

function $8d67d674949172ba$export$d135e6fd61f0ae86(Component) {
    const CompanyHubRoute = ()=>{
        const { isCompanyHubEntryPointEnabled: isCompanyHubEntryPointEnabled, isCompanyHubPublished: isCompanyHubPublished, loading: loading } = (0, $7CeAz.useIsCompanyHubEnabled)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const renderServerPlaceholder = (0, $1P7Cq.useIsSSROrHydrating)();
        const { push: push } = (0, $dPJCf.useRouteActions)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                push((0, $1NBp8.COMPANY_HUB_EDIT).toUrl({}, {
                    query: {
                        redirect: 'first-time',
                        contentId: homepageId
                    }
                }));
            },
            route: (0, $1NBp8.COMPANY_HUB).pattern
        });
        if (isCreatingHub) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        screenEventAttributes.publishedCompanyHub = isCompanyHubPublished;
        if (shouldShowPremiumUpsell) {
            /**
       * SSR compatibility: CompanyHomeBuilderUpsellPage uses UpsellLooknFeel/SectionMessage
       * which lacks SSR support. Rendering during SSR would cause:
       * - Hydration mismatches between server/client renders
       * - Visible layout shift (CLS) during client hydration since SectionMessage
       *   appears at the top of the content area
       *
       * For now, client-side rendering only, until components are refactored for SSR support.
       */ if (renderServerPlaceholder) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
                featureName: "companyHub"
            });
        }
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (!isCompanyHubEntryPointEnabled) {
            // `isCompanyHubEntryPointEnabled` defaults to false until the eligibility data
            // (`frontCoverState` from SPAViewContext) resolves. Redirecting during that window
            // sends eligible users to Home — this happens during SSR and on the first client
            // render in Relay mode, where the read is not synchronously warm the way Apollo is.
            // Wait for the data to load before redirecting. Gated for safe rollout.
            if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kE2cJ.Redirection), {
                name: (0, $1NBp8.HOME).name
            });
        }
        // The only different between SPA and SSR is we don't render space base in SSR
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0d72b6e269966c48$export$83316d703678f96f), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            spaceKey: spaceKey,
            contentId: ""
        }));
    };
    const screenEventAttributes = {
        navdexPointType: (0, $56QzY.START_TOUCH),
        // Company Hub hides its space from the user, doesn't refer to its page
        // as such, is rather presented to the user as "a new surface", and thus
        // doesn't constitute space usage from the perspective of the user.
        screenIsInSpace: false
    };
    /**
   * Warning: Though the function NAVIGATION_PARAMS is invoked during render,
   * each route has its own implementation. Consequently, it cannot invoke
   * hooks or, during route transitions between implementations that invoke
   * different hooks, the rule of hooks to invoke a hook the same number of
   * times during each render would be violated and an error would be thrown
   * by React that would damage the DOM.
   */ CompanyHubRoute.NAVIGATION_PARAMS = ()=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHub',
                    id: spaceKey,
                    // Warning: The value of the analytics event attribute
                    // publishedCompanyHub that ScreenEvent sends will be
                    // inaccurate on initial SPA load without SSR, because
                    // ScreenEvent sends before SPAViewContext has loaded.
                    attributes: screenEventAttributes
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: (0, $iJ8K8.SPACE_OVERVIEW),
                    routeName: (0, $1NBp8.COMPANY_HUB).name
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID),
                spaceKey: spaceKey,
                isViewPage: true
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubRoute);
}
const $8d67d674949172ba$var$CompanyHubOverviewForSSR = (props)=>(0, $6mKj3.expValEquals)('confluence_react_streaming_all_routes', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $djZz9.SpaceOverviewSwitcherLoader), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $djZz9.SpaceOverviewLoader), props);
const $8d67d674949172ba$export$ea13ab632841088 = $8d67d674949172ba$export$d135e6fd61f0ae86($8d67d674949172ba$var$CompanyHubOverviewForSSR);
module.exports["getCompanyHubRoute"] = $8d67d674949172ba$export$d135e6fd61f0ae86;

});

parcelRegister("hkCxu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6mKj3 = parcelRequire("6mKj3");


var $1P7Cq = parcelRequire("1P7Cq");


var $cEgMD = parcelRequire("cEgMD");


var $lFjPc = parcelRequire("lFjPc");


var $jKzCD = parcelRequire("jKzCD");


var $8NC5Z = parcelRequire("8NC5Z");


var $1NBp8 = parcelRequire("1NBp8");


var $9HNv5 = parcelRequire("9HNv5");


var $eqNP8 = parcelRequire("eqNP8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $eCfJ3 = parcelRequire("eCfJ3");








var $5gmpn = parcelRequire("5gmpn");


var $iJ8K8 = parcelRequire("iJ8K8");


var $ak57N = parcelRequire("ak57N");


var $8dwdz = parcelRequire("8dwdz");











var $6pwLK = parcelRequire("6pwLK");

function $ef4380efcf1da8eb$export$b5c57a98f1ddfa55(uri) {
    return uri.includes('/edit-v2/');
}
function $ef4380efcf1da8eb$export$4ceedc3d36a46889(query) {
    const draftShareId = query?.draftShareId;
    return Array.isArray(draftShareId) ? draftShareId?.[0] : draftShareId;
}


const $ec45f4b8e7cc34aa$export$6a3218472cdf374a = ({ name: name, params: { contentId: contentId, spaceKey: spaceKey }, query: query })=>{
    const isCompanyHub = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey);
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)({
        skip: !isCompanyHub
    });
    const contentType = name === (0, $1NBp8.EDIT_PAGE_V2).name || name === (0, $1NBp8.COMPANY_HUB_EDIT).name ? 'page' : 'blogpost';
    const draftShareId = (0, $ef4380efcf1da8eb$export$4ceedc3d36a46889)(query);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6pwLK.BannerContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ak57N.EditPageLoaderServer), {
        contentId: contentId,
        spaceKey: spaceKey,
        draftShareId: draftShareId,
        contentType: contentType
    }));
    //
    // navView
    //
    let navView = (0, $lFjPc.CONTAINER_HOME_ID);
    if (isCompanyHub) {
        if (shouldShowPremiumUpsell) return null;
        else if (name === (0, $1NBp8.COMPANY_HUB_EDIT).name) // CompanyHubEditRoute provides its own Screen and MainLayout.
        return children;
        navView = (0, $lFjPc.PRODUCT_HOME_ID);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJ8K8.Screen), {
        showPremiumOnboarding: false,
        pageState: {
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: contentType
        },
        screenEvent: {
            name: 'editPageScreen',
            id: contentId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5gmpn.MainLayout), {
        enableNavigation: !(0, $8dwdz.shouldShowMobileWeb)(),
        spaceKey: spaceKey,
        navView: navView,
        isEdit: true
    }, children));
};



var $2Uf3N = parcelRequire("2Uf3N");

function $aa6dab5502f2e37f$export$39a78a0252c20555(component) {
    const CompanyHubEditRoute = (routeProps)=>{
        const isSSROrHydrating = (0, $1P7Cq.useIsSSROrHydrating)();
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $cozmU.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // Preserve the server editor branch through hydration before showing a client loading screen.
        if ((isCreatingHub || !queriedContentId && !contentId) && ((0, $6mKj3.expValEquals)('confluence_react_streaming_all_routes', 'isEnabled', true) ? !isSSROrHydrating : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        // Company Hub hides its space from the user, doesn't refer to its page
                        // as such, is rather presented to the user as "a new surface", and thus
                        // doesn't constitute space usage from the perspective of the user.
                        screenIsInSpace: false
                    }
                },
                // When no contentId is passed, Screen.js handles querying it and updating pageState with it.
                // usually, this is done by the Screen.js component, but in this case, we need to do it here
                // because contentId is not getting queried properly on route creation.
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditRoute);
}
const $aa6dab5502f2e37f$export$31ce72eecdb1dd8 = $aa6dab5502f2e37f$export$39a78a0252c20555((0, $ec45f4b8e7cc34aa$export$6a3218472cdf374a));
module.exports["getCompanyHubEditRoute"] = $aa6dab5502f2e37f$export$39a78a0252c20555;

});

parcelRegister("k1285", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $eX4up = parcelRequire("eX4up");


var $cEgMD = parcelRequire("cEgMD");


var $lFjPc = parcelRequire("lFjPc");


var $jKzCD = parcelRequire("jKzCD");


var $8NC5Z = parcelRequire("8NC5Z");


var $1NBp8 = parcelRequire("1NBp8");


var $9HNv5 = parcelRequire("9HNv5");


var $eqNP8 = parcelRequire("eqNP8");


var $ep3mz = parcelRequire("ep3mz");


var $dPJCf = parcelRequire("dPJCf");


var $56QzY = parcelRequire("56QzY");


var $eCfJ3 = parcelRequire("eCfJ3");


var $2Uf3N = parcelRequire("2Uf3N");

function $7c7def46d7360d1a$export$340541672a1ec29f(component) {
    const CompanyHubEditorRoute = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        const [contentId] = (0, $ep3mz.usePageContentId)();
        const [queriedContentId, setQueriedContentId] = (0, $cozmU.useState)(null);
        const { setQueryParams: setQueryParams } = (0, $dPJCf.useRouteActions)();
        const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
        const { isCreatingHub: isCreatingHub, creationError: creationError } = (0, $jKzCD.useCompanyHubOnRouteCreationFlow)({
            onSuccess: (homepageId)=>{
                setQueriedContentId(homepageId);
                setQueryParams({
                    redirect: 'first-time'
                });
            },
            onExists: (homepageId)=>{
                setQueriedContentId(homepageId);
            },
            route: (0, $1NBp8.COMPANY_HUB_EDIT).pattern
        });
        if (creationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eCfJ3.HubErrorPageComponent), {
            error: creationError
        });
        if (shouldShowPremiumUpsell) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9HNv5.CompanyHomeBuilderUpsellPage), {
            featureName: "companyHub"
        });
        // If there is no contentId in SSR then we will just see the FullPageLoadingScreen being rendered
        // So we skip the loading screen component to ensure the HubEditor is rendered instead
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if ((isCreatingHub || !queriedContentId && !contentId) && true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eqNP8.FullPageLoadingScreen), null);
        const Component = component;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...routeProps,
            params: {
                contentId: contentId ?? (queriedContentId || ''),
                spaceKey: spaceKey,
                contentType: 'pages'
            }
        });
    };
    CompanyHubEditorRoute.NAVIGATION_PARAMS = (routeProps)=>{
        const spaceKey = (0, $cEgMD.getCompanyHubSpaceKey)();
        return {
            Screen: {
                screenEvent: {
                    name: 'companyHubEditorScreen',
                    id: spaceKey,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        screenIsInSpace: false
                    }
                },
                pageState: {
                    spaceKey: spaceKey,
                    contentId: routeProps?.query?.contentId
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        };
    };
    return (0, $2Uf3N.getCompanyHubPseudoAppRoute)(CompanyHubEditorRoute);
}
const $7c7def46d7360d1a$export$5c9c0a4930517099 = $7c7def46d7360d1a$export$340541672a1ec29f((0, $eX4up.default));
module.exports["getCompanyHubEditorRoute"] = $7c7def46d7360d1a$export$340541672a1ec29f;

});

parcelRegister("SwMnm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lFjPc = parcelRequire("lFjPc");


var $bUMKD = parcelRequire("bUMKD");


var $6mKj3 = parcelRequire("6mKj3");


var $78QFu = parcelRequire("78QFu");

function $fadd80cba2fb56d8$export$4464cf8f058e6616({ ContextProvider: ContextProvider = (0, $cozmU.Fragment), NotFound: NotFound = (0, $cozmU.Fragment), ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader } = {}) {
    function AccessLinkRoute({ params: { shareToken: shareToken }, hash: hash }) {
        if (!(0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(NotFound, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUMKD.ExternalSharePageLoader), {
            shareToken: shareToken,
            queryHash: hash,
            ClassicEditorContextProviderLoader: ClassicEditorContextProviderLoader
        }));
    }
    AccessLinkRoute.NAVIGATION_PARAMS = ({ name: name })=>({
            Screen: {
                screenEvent: {
                    name: 'viewPageScreen',
                    attributes: {
                        isPublicView: false,
                        isAccessLinkView: true,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                },
                pageState: {
                    routeName: name
                }
            },
            MainLayout: {
                navView: (0, $lFjPc.PRODUCT_HOME_ID)
            }
        });
    return AccessLinkRoute;
}
const $fadd80cba2fb56d8$export$7fef32ef76619e1b = $fadd80cba2fb56d8$export$4464cf8f058e6616();
module.exports["getAccessLinkRoute"] = $fadd80cba2fb56d8$export$4464cf8f058e6616;

});

parcelRegister("8g7sM", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $9FEPa = parcelRequire("9FEPa");

const $c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD = `confluence.fabric.content.renderer.download`;

const $c3f88486f5953222$var$_default_1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cDY9-",
    name: 'ClassicContentRendererLoader',
    loader: async ()=>{
        (0, $9FEPa.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.start`);
        const module = await (parcelRequire("lSd9S"));
        (0, $9FEPa.performanceMarkInProd)(`${$c3f88486f5953222$var$CONTENT_RENDERER_DOWNLOAD}.end`);
        return module;
    }
});
var $c3f88486f5953222$export$2e2bcd8739ae039 = $c3f88486f5953222$var$_default_1;
module.exports["default"] = $c3f88486f5953222$export$2e2bcd8739ae039;

});

parcelRegister("2Uf3N", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmjWc = parcelRequire("jmjWc");


const $44a1291d5f4bf190$export$bbf3d8e57337c75 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xoU6a",
    _reactTreeRootForServerPlaceholderId: true,
    name: 'CompanyHubMainLayout',
    loader: async ()=>(await (parcelRequire("2qfPs"))).CompanyHubMainLayout
});


function $13aed4a881b0bcc1$export$f5fe5ef796a4c528(Wrapped, routeMatchPredicate = ()=>true) {
    const CompanyHubPseudoAppRoute = (props)=>{
        const wrapped = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Wrapped, props);
        if (routeMatchPredicate(props)) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $44a1291d5f4bf190$export$bbf3d8e57337c75), null, wrapped);
        return wrapped;
    };
    CompanyHubPseudoAppRoute.NAVIGATION_PARAMS = (...args)=>{
        const wrappedNavParams = Wrapped.NAVIGATION_PARAMS(...args);
        if (routeMatchPredicate(args[0])) // The Company Hub app-like experience uses its own, doesn't use Confluence's `MainLayout`:
        return typeof wrappedNavParams === 'object' ? {
            ...wrappedNavParams,
            MainLayout: false
        } : false;
        return wrappedNavParams;
    };
    return CompanyHubPseudoAppRoute;
}
module.exports["getCompanyHubPseudoAppRoute"] = $13aed4a881b0bcc1$export$f5fe5ef796a4c528;

});

parcelRegister("cbQWR", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

function $0496f75a09655c3f$export$5fce3f8f63379b78({ name: name, query: query = {} }) {
    return (name === (0, $1NBp8.VIEW_PAGE).name || name === (0, $1NBp8.VIEW_BLOG).name) && !query.lite && !query.versionOverride && !query.version && !query.draftId && !query.draftShareId && !query.embeddedContentRender && !query.embedded && !query.parentProduct;
}
module.exports["canDeferPageRestrictions"] = $0496f75a09655c3f$export$5fce3f8f63379b78;

});

parcelRegister("92IuX", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $cf6f9a67c56b1fae$export$a52edf641f55b288 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "qAAZg",
    name: "AuditLogLoader",
    loader: async ()=>(await (parcelRequire("7Fanm"))).AuditLog
});
module.exports["AuditLogLoader"] = $cf6f9a67c56b1fae$export$a52edf641f55b288;

});

parcelRegister("kkBFa", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eb3ax = parcelRequire("eb3ax");


var $ccS36 = parcelRequire("ccS36");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("htyBH");
var $k9z7m = parcelRequire("k9z7m");


var $fcvZw = parcelRequire("fcvZw");

class $ecd2e3fcbc47ba9f$var$Redirector extends (0, $cozmU.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $lI7ls.createPath)((0, $k9z7m.generateLocationFromPath)(to.path, routeAttributes)) : (0, $lI7ls.createPath)(to) : to;
        const currentPath = (0, $lI7ls.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $ccS36.default)($ecd2e3fcbc47ba9f$var$Redirector, "defaultProps", {
    push: false
});
const $ecd2e3fcbc47ba9f$export$2d8d895a0a0f636e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const [t0, actions] = (0, $fcvZw.useRouter)();
    const { location: location } = t0;
    let t1;
    if ($[0] !== actions || $[1] !== location || $[2] !== props) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecd2e3fcbc47ba9f$var$Redirector, (0, $eb3ax.default)({
            actions: actions,
            location: location
        }, props));
        $[0] = actions;
        $[1] = location;
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const [{ location: location }, actions] = (0, $fcvZw.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ecd2e3fcbc47ba9f$var$Redirector, (0, $eb3ax.default)({
        actions: actions,
        location: location
    }, props));
};

});

parcelRegister("hSxV5", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");


var $hFkZi = parcelRequire("hFkZi");

const $d041ca8faab7d1e5$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hFkZi.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $d041ca8faab7d1e5$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $cozmU.useMemo)(()=>(0, $lI7ls.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d041ca8faab7d1e5$export$55185c17a0fcbe46, (0, $eb3ax.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("bPYAw", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $idnP4 = parcelRequire("idnP4");

const $89e374a8e3383481$export$b371fa9cf762ad06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const actions = (0, $idnP4.useRouterActions)();
    let t1;
    if ($[0] !== actions || $[1] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
        $[0] = actions;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const actions = (0, $idnP4.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
};
$89e374a8e3383481$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("ebiij", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $1eVGO = parcelRequire("1eVGO");


var $cozmU = parcelRequire("cozmU");

parcelRequire("htyBH");
var $9qwq6 = parcelRequire("9qwq6");


var $hFkZi = parcelRequire("hFkZi");

const $a53048aabd17c88e$var$_excluded = [
    "listen"
];
const $a53048aabd17c88e$export$672d721d310ff5f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [state, _ref] = (0, $hFkZi.useRouterStore)();
    const { listen: listen } = _ref;
    let t1;
    if ($[0] !== _ref || $[1] !== children || $[2] !== listen || $[3] !== state) {
        const actions = (0, $1eVGO.default)(_ref, $a53048aabd17c88e$var$_excluded);
        if (!state.unlisten && !(0, $9qwq6.isServerEnvironment)()) listen();
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
        $[0] = _ref;
        $[1] = children;
        $[2] = listen;
        $[3] = state;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children })=>{
    const [state, _ref] = (0, $hFkZi.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $1eVGO.default)(_ref, $a53048aabd17c88e$var$_excluded);
    if (!state.unlisten && !(0, $9qwq6.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
};

});

parcelRegister("6GERo", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $hFkZi = parcelRequire("hFkZi");

const $4de65c525241a249$var$createPathParamHook = (0, $kBr4q.createHook)((0, $hFkZi.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $4de65c525241a249$export$8c8591dcd57728e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $4de65c525241a249$var$createPathParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updatePathParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setPathParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setPathParam) {
        t2 = [
            paramVal,
            setPathParam
        ];
        $[5] = paramVal;
        $[6] = setPathParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $4de65c525241a249$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("96I48", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $hFkZi = parcelRequire("hFkZi");

const $6a16db1a31422dbd$var$createQueryParamHook = (0, $kBr4q.createHook)((0, $hFkZi.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $6a16db1a31422dbd$export$ae316f0eeb712a36 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $6a16db1a31422dbd$var$createQueryParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updateQueryParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setQueryParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setQueryParam) {
        t2 = [
            paramVal,
            setQueryParam
        ];
        $[5] = paramVal;
        $[6] = setQueryParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $6a16db1a31422dbd$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("fcvZw", function(module, exports) {

var $hFkZi = parcelRequire("hFkZi");

const $b110cad1cdf17f37$export$9a302a45f65d0572 = (0, $hFkZi.useRouterStore);
module.exports["useRouter"] = $b110cad1cdf17f37$export$9a302a45f65d0572;

});

parcelRegister("idnP4", function(module, exports) {

var $hFkZi = parcelRequire("hFkZi");

const $d42beb9135fb341f$export$402e82ff1b20594b = (0, $hFkZi.useRouterStoreActions);
module.exports["useRouterActions"] = $d42beb9135fb341f$export$402e82ff1b20594b;

});

parcelRegister("4Yqy7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $hFkZi = parcelRequire("hFkZi");

const $39f15c286baf7d10$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $39f15c286baf7d10$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $39f15c286baf7d10$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(10);
        const [t0, t1] = (0, $hFkZi.useRouterStore)();
        const { action: action, history: history, location: location, match: match, query: query, route: route } = t0;
        const { push: push, replace: replace } = t1;
        let t2;
        if ($[0] !== action || $[1] !== history || $[2] !== location || $[3] !== match || $[4] !== props || $[5] !== push || $[6] !== query || $[7] !== replace || $[8] !== route) {
            t2 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
                action: action,
                history: history,
                location: location,
                match: match,
                push: push,
                query: query,
                replace: replace,
                route: route
            }));
            $[0] = action;
            $[1] = history;
            $[2] = location;
            $[3] = match;
            $[4] = props;
            $[5] = push;
            $[6] = query;
            $[7] = replace;
            $[8] = route;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    } : (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $hFkZi.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("8Dc6h", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("htyBH");
var $jwQVI = parcelRequire("jwQVI");
var $k9z7m = parcelRequire("k9z7m");


var $hFkZi = parcelRequire("hFkZi");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");




const $c4f86f985468509c$export$d8e6abf214c9ec0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (delay)=>{
    const $ = (0, $bDgLe.c)(5);
    const timeoutId = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== delay) {
        t0 = (callback)=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
            timeoutId.current = setTimeout(callback, delay);
        };
        $[0] = delay;
        $[1] = t0;
    } else t0 = $[1];
    const schedule = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            clearTimeout(timeoutId.current);
        };
        $[2] = t1;
    } else t1 = $[2];
    const cancel = t1;
    let t2;
    if ($[3] !== schedule) {
        t2 = {
            schedule: schedule,
            cancel: cancel
        };
        $[3] = schedule;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (delay)=>{
    const timeoutId = (0, $cozmU.useRef)();
    const schedule = (0, $cozmU.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $cozmU.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};





var $6fVzX = parcelRequire("6fVzX");


var $et2nj = parcelRequire("et2nj");



const $648b5a1d497791d1$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $648b5a1d497791d1$var$PREFETCH_DELAY = 225;
const $648b5a1d497791d1$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $1eVGO.default)(_ref, $648b5a1d497791d1$var$_excluded);
    const routerActions = (0, $hFkZi.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $c4f86f985468509c$export$d8e6abf214c9ec0f)($648b5a1d497791d1$var$PREFETCH_DELAY);
    const validLinkType = (0, $6fVzX.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $cozmU.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $lI7ls.createPath)((0, $k9z7m.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $cozmU.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $jwQVI.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $et2nj.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $cozmU.createElement)(validLinkType, (0, $eb3ax.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$648b5a1d497791d1$var$Link.displayName = 'Link';
var $648b5a1d497791d1$export$2e2bcd8739ae039 = $648b5a1d497791d1$var$Link;
module.exports["default"] = $648b5a1d497791d1$export$2e2bcd8739ae039;

});

parcelRegister("eJQlm", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

parcelRequire("cKmxI");
var $fcvZw = parcelRequire("fcvZw");

const $abaddef82b916071$export$7903e4b73fc7d6c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [t0] = (0, $fcvZw.useRouter)();
    const { action: action, location: location, match: match, query: query, route: route } = t0;
    if (!route || !route.component) return null;
    let t1;
    if ($[0] !== action || $[1] !== location || $[2] !== match || $[3] !== query || $[4] !== route) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
            action: action,
            location: location,
            match: match,
            query: query,
            route: route
        });
        $[0] = action;
        $[1] = location;
        $[2] = match;
        $[3] = query;
        $[4] = route;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $fcvZw.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});

parcelRegister("ac1eE", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $7SeeH = parcelRequire("7SeeH");


var $eO7Xs = parcelRequire("eO7Xs");

const $76bbfba75c24c32f$var$hasWindow = ()=>typeof window !== 'undefined';
const $76bbfba75c24c32f$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $76bbfba75c24c32f$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $76bbfba75c24c32f$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $76bbfba75c24c32f$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($7SeeH)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $76bbfba75c24c32f$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $76bbfba75c24c32f$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $76bbfba75c24c32f$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $eb3ax.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $76bbfba75c24c32f$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $76bbfba75c24c32f$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $76bbfba75c24c32f$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
        createHref: (location)=>(0, $lI7ls.createPath)(location)
    } : $76bbfba75c24c32f$var$methodsPlaceholders);
};
module.exports["createLegacyHistory"] = $76bbfba75c24c32f$export$883c3f3b6c000133;

});

parcelRegister("k9z7m", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");


var $4NiRC = parcelRequire("4NiRC");

function $eabfe38de06df22e$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}
module.exports["generateLocationFromPath"] = $eabfe38de06df22e$export$37e0729cc751960b;

});

parcelRegister("epPJ3", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");

const $a7eb8621e301eeac$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
module.exports["generatePath"] = $a7eb8621e301eeac$export$82476f982757e71e;

});

parcelRegister("9qwq6", function(module, exports) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $1P2f3 = parcelRequire("1P2f3");

const $6dcfb0b3fdb0fcc1$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $6dcfb0b3fdb0fcc1$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $1P2f3 !== 'undefined' && $1P2f3.versions != null && $1P2f3.versions.node != null) return true;
    if ($6dcfb0b3fdb0fcc1$var$isJsDomEnvironment()) return true;
    return false;
};
module.exports["isServerEnvironment"] = $6dcfb0b3fdb0fcc1$export$455cc18296abe008;

});

parcelRegister("iL7a3", function(module, exports) {
$parcel$export(module.exports, "default", () => $da822bd664e445bf$export$2e2bcd8739ae039);

var $4NiRC = parcelRequire("4NiRC");


var $eb3ax = parcelRequire("eb3ax");

// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $6XX9c = parcelRequire("6XX9c");

const $d2b6545da2f42c36$var$cache = {};
const $d2b6545da2f42c36$var$cacheLimit = 10000;
let $d2b6545da2f42c36$var$cacheCount = 0;
function $d2b6545da2f42c36$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $d2b6545da2f42c36$var$cache[cacheKey] || ($d2b6545da2f42c36$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6XX9c.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($d2b6545da2f42c36$var$cacheCount < $d2b6545da2f42c36$var$cacheLimit) {
        pathCache[path] = result;
        $d2b6545da2f42c36$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $d2b6545da2f42c36$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $d2b6545da2f42c36$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $d2b6545da2f42c36$export$2e2bcd8739ae039 = $d2b6545da2f42c36$var$matchPath;





/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $80619751575f829b$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $eb3ax.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $80619751575f829b$export$2e2bcd8739ae039 = $80619751575f829b$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $72661a82c5c63ed1$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $72661a82c5c63ed1$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $d2b6545da2f42c36$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $72661a82c5c63ed1$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $80619751575f829b$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $eb3ax.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $72661a82c5c63ed1$export$2e2bcd8739ae039 = $72661a82c5c63ed1$var$execRouteMatching;


const $306d1e727bba178f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $306d1e727bba178f$var$MAX_CACHE_SIZE = 1000;
function $306d1e727bba178f$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$306d1e727bba178f$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $306d1e727bba178f$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($306d1e727bba178f$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $306d1e727bba178f$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $306d1e727bba178f$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $da822bd664e445bf$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $4NiRC.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $306d1e727bba178f$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $72661a82c5c63ed1$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $306d1e727bba178f$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $da822bd664e445bf$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$da822bd664e445bf$var$matchRoute(routes, pathname, queryParams, basePath);
const $da822bd664e445bf$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $da822bd664e445bf$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $da822bd664e445bf$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$da822bd664e445bf$var$matchRoute(routes, pathname, queryParams, basePath);
module.exports["warmupMatchRouteCache"] = $da822bd664e445bf$export$4e76f1d455ef7c95;

});

parcelRegister("jwQVI", function(module, exports) {

var $4NiRC = parcelRequire("4NiRC");


var $jjIOx = parcelRequire("jjIOx");


var $epPJ3 = parcelRequire("epPJ3");


var $iL7a3 = parcelRequire("iL7a3");

const $e37a104447146b46$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $epPJ3.generatePath)(route.path, params);
    const matchedRoute = (0, $iL7a3.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $jjIOx.DEFAULT_MATCH),
        query: query
    };
};
const $e37a104447146b46$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $4NiRC.qs).parse(search);
    const matchedRoute = (0, $iL7a3.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $jjIOx.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $jjIOx.DEFAULT_MATCH)
    };
};
module.exports["createRouterContext"] = $e37a104447146b46$export$faed15f35ddc6f99;
module.exports["findRouterContext"] = $e37a104447146b46$export$a0bd0313cbeabd49;

});

parcelRegister("3UFvg", function(module, exports) {
const $2d96cbc130ddb5fd$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $2d96cbc130ddb5fd$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $2d96cbc130ddb5fd$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $2d96cbc130ddb5fd$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
module.exports["isSameRouteMatch"] = $2d96cbc130ddb5fd$export$5997e70fc4543270;

});

parcelRegister("91pEK", function(module, exports) {

var $97ZVl = parcelRequire("97ZVl");

parcelRequire("hq2yE");
var $hNpL3 = parcelRequire("hNpL3");

const $69181bd2ca549fd5$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $69181bd2ca549fd5$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $97ZVl.getResourceStore)().actions;
    const nextResources = (0, $hNpL3.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $69181bd2ca549fd5$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $97ZVl.getResourceStore)().actions;
    const nextResources = (0, $hNpL3.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $69181bd2ca549fd5$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $97ZVl.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $69181bd2ca549fd5$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $69181bd2ca549fd5$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $69181bd2ca549fd5$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $97ZVl.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $97ZVl.getResourceStore)().actions;
            const nextResources = (0, $hNpL3.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $97ZVl.getResourceStore)().actions.getSafeData();
        }
    };
};

});

parcelRegister("RNy7H", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3ct2F = parcelRequire("3ct2F");

const $0a1b62d34dfcc57c$export$fee1a6213543bd78 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, resource: resource, options: options } = t0;
    const result = (0, $3ct2F.useResource)(resource, options);
    let t1;
    if ($[0] !== children || $[1] !== result) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
        $[0] = children;
        $[1] = result;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, resource: resource, options: options })=>{
    const result = (0, $3ct2F.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
};

});

parcelRegister("3ct2F", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

parcelRequire("fMvIa");
var $hFkZi = parcelRequire("hFkZi");


var $97ZVl = parcelRequire("97ZVl");

const $2549053b6bb87d65$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $97ZVl.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $hFkZi.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $cozmU.useMemo)(()=>(0, $kBr4q.createHook)((0, $hFkZi.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $97ZVl.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $cozmU.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $cozmU.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $cozmU.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $eb3ax.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};
module.exports["useResource"] = $2549053b6bb87d65$export$9f6abfd74295843b;

});

parcelRegister("d9oWA", function(module, exports) {

var $97ZVl = parcelRequire("97ZVl");

const $992f76f5f24d2f55$export$dee7bf9fc0ff48c3 = (fn)=>(0, $97ZVl.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("97ZVl", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");

var $c6StJ = parcelRequire("c6StJ");

parcelRequire("htyBH");
var $9qwq6 = parcelRequire("9qwq6");




parcelRequire("hq2yE");
var $htr8O = parcelRequire("htr8O");

const $1fdc05e75ba2d1af$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $eb3ax.default)({}, slice) : (0, $htr8O.getDefaultStateSlice)();
};
const $1fdc05e75ba2d1af$export$6a0b1779210de0ee = (state)=>state.context;


parcelRequire("hq2yE");
var $8RoZS = parcelRequire("8RoZS");
var $lHNk5 = parcelRequire("lHNk5");
var $iiKpy = parcelRequire("iiKpy");
var $hBrfJ = parcelRequire("hBrfJ");
var $9RVC0 = parcelRequire("9RVC0");
var $lTQd7 = parcelRequire("lTQd7");
var $8Z7ra = parcelRequire("8Z7ra");
var $8jRWn = parcelRequire("8jRWn");
var $dV1xE = parcelRequire("dV1xE");
var $5aFDI = parcelRequire("5aFDI");
var $7kOId = parcelRequire("7kOId");

const $6a54cd4daabb37f7$var$_excluded = [
    "context"
], $6a54cd4daabb37f7$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $6a54cd4daabb37f7$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $iiKpy.deleteResourceState)(type, key));
                dispatch((0, $8RoZS.executeForDependents)(resource, (dependentResource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $iiKpy.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $1eVGO.default)(_getState, $6a54cd4daabb37f7$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $1fdc05e75ba2d1af$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $eb3ax.default)({}, prevSlice, changes, {
                expiresAt: (0, $lTQd7.getExpiresAt)(maxAge),
                accessedAt: (0, $9RVC0.getAccessedAt)()
            });
            dispatch((0, $iiKpy.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $8RoZS.executeForDependents)(resource, (dependentResource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $iiKpy.getResourceState)(type, key));
            if (cached && (0, $8Z7ra.shouldUseCache)(cached)) {
                if ((0, $8Z7ra.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $8jRWn.setSsrDataPromise)(cached);
                    cached = (0, $lTQd7.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $9RVC0.getAccessedAt)();
                dispatch((0, $iiKpy.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($6a54cd4daabb37f7$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $iiKpy.getResourceState)(type, key)) || (0, $htr8O.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $7kOId.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $iiKpy.getPrefetchSlice)(type, key)) || (0, $lHNk5.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8RoZS.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $iiKpy.setResourceState)(type, key, (0, $eb3ax.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $9RVC0.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $8RoZS.executeForDependents)(resource, (dependentResource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $dV1xE.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $iiKpy.getResourceState)(type, key));
            const finalSlice = (0, $eb3ax.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $9RVC0.getAccessedAt)(),
                expiresAt: (0, $lTQd7.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $iiKpy.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $iiKpy.getPrefetchSlice)(type, key)) || (0, $lHNk5.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $8RoZS.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $iiKpy.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $8RoZS.executeForDependents)(resource, (dependentResource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $6a54cd4daabb37f7$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $8RoZS.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $6a54cd4daabb37f7$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $8RoZS.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a54cd4daabb37f7$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $8RoZS.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a54cd4daabb37f7$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $8RoZS.actionWithDependencies)(routerStoreContext.route.resources, resource, $6a54cd4daabb37f7$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($6a54cd4daabb37f7$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $iiKpy.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $iiKpy.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $9qwq6.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $8RoZS.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $8RoZS.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$6a54cd4daabb37f7$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $eb3ax.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $5aFDI.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $1eVGO.default)(_ref, $6a54cd4daabb37f7$var$_excluded2);
                const deserializedError = !error ? null : (0, $hBrfJ.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $eb3ax.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $5aFDI.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $hBrfJ.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $dV1xE.TimeoutError) ? loading : false
                }))
};
const $6a54cd4daabb37f7$export$94f50dade551bd01 = (0, $8s9DV.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $6a54cd4daabb37f7$export$e324594224ef24da,
    name: 'router-resources'
});
const $6a54cd4daabb37f7$export$cc90fb9c37c5589d = (0, $j8on0.createContainer)($6a54cd4daabb37f7$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $6a54cd4daabb37f7$export$fee1a6213543bd78 = (0, $5GOpG.createSubscriber)($6a54cd4daabb37f7$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $1fdc05e75ba2d1af$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $6a54cd4daabb37f7$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $c6StJ.defaultRegistry).getStore($6a54cd4daabb37f7$export$94f50dade551bd01);
const $6a54cd4daabb37f7$export$ac3608e0bb357c7 = (0, $kBr4q.createHook)($6a54cd4daabb37f7$export$94f50dade551bd01, {
    selector: (0, $1fdc05e75ba2d1af$export$c9ed509724feb827)
});
const $6a54cd4daabb37f7$export$98e41a62c9bef75e = (0, $kBr4q.createActionsHook)($6a54cd4daabb37f7$export$94f50dade551bd01);
const $6a54cd4daabb37f7$export$e59f52df235ac7b3 = (0, $kBr4q.createHook)($6a54cd4daabb37f7$export$94f50dade551bd01, {
    selector: (0, $1fdc05e75ba2d1af$export$6a0b1779210de0ee)
});
module.exports["getResourceStore"] = $6a54cd4daabb37f7$export$6f6057d42352becb;
module.exports["useResourceStore"] = $6a54cd4daabb37f7$export$ac3608e0bb357c7;
module.exports["useResourceStoreActions"] = $6a54cd4daabb37f7$export$98e41a62c9bef75e;

});

parcelRegister("e5SM2", function(module, exports) {
const $a42c053e9c00defc$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});

parcelRegister("9vmeB", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => (parcelRequire("aO6HO")).RouterSubscriber);
$parcel$export(module.exports, "useRouter", () => (parcelRequire("6nY8H")).useRouter);
$parcel$export(module.exports, "useRouterActions", () => (parcelRequire("j4NNn")).useRouterActions);

var $8CJk6 = parcelRequire("8CJk6");


var $5ZHAX = parcelRequire("5ZHAX");


var $k8KD8 = parcelRequire("k8KD8");


var $aO6HO = parcelRequire("aO6HO");


var $kZkvy = parcelRequire("kZkvy");


var $33dCY = parcelRequire("33dCY");


var $d7HEO = parcelRequire("d7HEO");


var $6nY8H = parcelRequire("6nY8H");


var $j4NNn = parcelRequire("j4NNn");


var $7wvhg = parcelRequire("7wvhg");


});

parcelRegister("6BZrm", function(module, exports) {
$parcel$export(module.exports, "Link", () => (parcelRequire("imtAv")).default);

var $imtAv = parcelRequire("imtAv");


var $h1RxD = parcelRequire("h1RxD");


});

parcelRegister("bDcGz", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => (parcelRequire("7MFOM")).generateLocationFromPath);
$parcel$export(module.exports, "generatePath", () => (parcelRequire("fEoYr")).generatePath);
$parcel$export(module.exports, "isServerEnvironment", () => (parcelRequire("2kK4E")).isServerEnvironment);
$parcel$export(module.exports, "warmupMatchRouteCache", () => (parcelRequire("aNi3F")).warmupMatchRouteCache);
$parcel$export(module.exports, "findRouterContext", () => (parcelRequire("fHQWF")).findRouterContext);
$parcel$export(module.exports, "createRouterContext", () => (parcelRequire("fHQWF")).createRouterContext);
$parcel$export(module.exports, "isSameRouteMatch", () => (parcelRequire("5l9sO")).isSameRouteMatch);

var $lKKkr = parcelRequire("lKKkr");


var $7MFOM = parcelRequire("7MFOM");


var $fEoYr = parcelRequire("fEoYr");


var $2kK4E = parcelRequire("2kK4E");


var $aNi3F = parcelRequire("aNi3F");


var $fHQWF = parcelRequire("fHQWF");


var $5l9sO = parcelRequire("5l9sO");


});

parcelRegister("8WqGQ", function(module, exports) {
parcelRequire("bDcGz");
var $fHQWF = parcelRequire("fHQWF");

const $6828719e23c31b7d$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $fHQWF.findRouterContext)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};

});

parcelRegister("kZkvy", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $iTvlA = parcelRequire("iTvlA");

var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $c6StJ = parcelRequire("c6StJ");


var $3yk4a = parcelRequire("3yk4a");

parcelRequire("bDcGz");
var $fHQWF = parcelRequire("fHQWF");
var $7MFOM = parcelRequire("7MFOM");
var $fEoYr = parcelRequire("fEoYr");
var $2kK4E = parcelRequire("2kK4E");
var $aNi3F = parcelRequire("aNi3F");


var $4NiRC = parcelRequire("4NiRC");

parcelRequire("bDcGz");
var $5l9sO = parcelRequire("5l9sO");

const $2166f2d465f767ab$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $2166f2d465f767ab$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $2166f2d465f767ab$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $2166f2d465f767ab$var$stripTrailingSlash(prefix);
        prefix = $2166f2d465f767ab$var$addLeadingSlash(prefix);
        path = $2166f2d465f767ab$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $2166f2d465f767ab$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $2166f2d465f767ab$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$2166f2d465f767ab$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $2166f2d465f767ab$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$2166f2d465f767ab$export$e83e3719fc818ee5(path)) {
        path = $2166f2d465f767ab$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($4NiRC)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $2166f2d465f767ab$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $2166f2d465f767ab$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $2166f2d465f767ab$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $5l9sO.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $f479699de2602c3e$export$36d128238e6b60f5 = {
    action: (0, $3yk4a.DEFAULT_ACTION),
    basePath: '',
    location: (0, $3yk4a.DEFAULT_HISTORY).location,
    history: (0, $3yk4a.DEFAULT_HISTORY),
    match: (0, $3yk4a.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $3yk4a.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: []
};
const $f479699de2602c3e$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $fHQWF.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, $eb3ax.default)({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $2kK4E.isServerEnvironment)()) dispatch($f479699de2602c3e$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $fHQWF.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $2166f2d465f767ab$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $iTvlA.batch)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, $eb3ax.default)({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $2166f2d465f767ab$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $2166f2d465f767ab$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $7MFOM.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $aNi3F.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $2166f2d465f767ab$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $2166f2d465f767ab$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $7MFOM.generateLocationFromPath)(route.path, (0, $eb3ax.default)({}, attributes, {
                basePath: basePath
            }));
            (0, $aNi3F.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, $eb3ax.default)({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $2166f2d465f767ab$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $2166f2d465f767ab$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, $eb3ax.default)({}, existingPathParams, params);
            const updatedPath = (0, $fEoYr.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, $eb3ax.default)({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $2166f2d465f767ab$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $2166f2d465f767ab$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $f479699de2602c3e$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $2166f2d465f767ab$export$2fa6dede99f181e5)(path)) {
                const location = (0, $lI7ls.parsePath)((0, $2166f2d465f767ab$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $fHQWF.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $iTvlA.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $f479699de2602c3e$export$1cf0ecab63b1963c = (0, $8s9DV.createStore)({
    initialState: $f479699de2602c3e$export$36d128238e6b60f5,
    actions: $f479699de2602c3e$var$actions,
    name: 'router'
});
const $f479699de2602c3e$export$d6b817abe7a77ea5 = (0, $j8on0.createContainer)($f479699de2602c3e$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($f479699de2602c3e$var$actions.bootstrapStore(props));
            !(0, $2kK4E.isServerEnvironment)() && dispatch($f479699de2602c3e$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $2kK4E.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $f479699de2602c3e$export$9569010eab09ae9e = (0, $kBr4q.createHook)($f479699de2602c3e$export$1cf0ecab63b1963c);
const $f479699de2602c3e$export$ada49399abf7a3a1 = (0, $kBr4q.createActionsHook)($f479699de2602c3e$export$1cf0ecab63b1963c);
function $f479699de2602c3e$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $kBr4q.createHook)($f479699de2602c3e$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $f479699de2602c3e$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $c6StJ.defaultRegistry).getStore($f479699de2602c3e$export$1cf0ecab63b1963c);
const $f479699de2602c3e$export$ebf37f7e180b13a9 = ()=>$f479699de2602c3e$export$5ccad187366c8494().storeState.getState();
module.exports["RouterStore"] = $f479699de2602c3e$export$1cf0ecab63b1963c;
module.exports["RouterContainer"] = $f479699de2602c3e$export$d6b817abe7a77ea5;
module.exports["useRouterStore"] = $f479699de2602c3e$export$9569010eab09ae9e;
module.exports["useRouterStoreActions"] = $f479699de2602c3e$export$ada49399abf7a3a1;

});

parcelRegister("3yk4a", function(module, exports) {

var $eO7Xs = parcelRequire("eO7Xs");


var $lKKkr = parcelRequire("lKKkr");

const $29641cc851fe8a2d$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $29641cc851fe8a2d$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $29641cc851fe8a2d$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $29641cc851fe8a2d$export$39607c9878cf5148 = (0, $lKKkr.createLegacyHistory)();
const $29641cc851fe8a2d$export$1515254c8c90bebb = {
    location: $29641cc851fe8a2d$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $29641cc851fe8a2d$export$fa440ddf675c8a93 = 'POP';
module.exports["DEFAULT_MATCH"] = $29641cc851fe8a2d$export$2de13e891a662beb;
module.exports["DEFAULT_ROUTE"] = $29641cc851fe8a2d$export$4eadc79233226325;
module.exports["DEFAULT_HISTORY"] = $29641cc851fe8a2d$export$39607c9878cf5148;
module.exports["DEFAULT_ACTION"] = $29641cc851fe8a2d$export$fa440ddf675c8a93;

});

parcelRegister("2Tnfk", function(module, exports) {

var $4C2bB = parcelRequire("4C2bB");


var $c7RYO = parcelRequire("c7RYO");


var $2s5nZ = parcelRequire("2s5nZ");


var $bNqcK = parcelRequire("bNqcK");


var $jPvl5 = parcelRequire("jPvl5");





var $gLGm7 = parcelRequire("gLGm7");


});

parcelRegister("9HNv5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d561062df6e47d30$export$4047609c83584c4b = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nCrwB",
    name: "CompanyHomeBuilderUpsellPage",
    loader: async ()=>(await (parcelRequire("eM9mN"))).CompanyHomeBuilderUpsellPage
});
module.exports["CompanyHomeBuilderUpsellPage"] = $d561062df6e47d30$export$4047609c83584c4b;

});

parcelRegister("jKzCD", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $1uFM6 = parcelRequire("1uFM6");


var $cEgMD = parcelRequire("cEgMD");


var $1ytiN = parcelRequire("1ytiN");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $8NC5Z = parcelRequire("8NC5Z");


var $gi8UL = parcelRequire("gi8UL");

function $6d8995f9c98e457c$export$567b73f497a151cb({ onSuccess: onSuccess, onExists: onExists, route: route }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [isCreatingHub, setIsCreatingHub] = (0, $cozmU.useState)(false);
    const [creationError, setCreationError] = (0, $cozmU.useState)(null);
    const { isSiteAdmin: isSiteAdmin, frontCoverState: frontCoverState } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const shouldShowPremiumUpsell = (0, $8NC5Z.useCompanyHubPremiumGate)();
    const isCompanyHubUnset = frontCoverState === (0, $cEgMD.FrontCoverStateEnum).UNSET;
    const hasCreatedHub = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!hasCreatedHub.current) {
            const shouldCreateHub = isCompanyHubUnset && isSiteAdmin && !shouldShowPremiumUpsell && !isCreatingHub;
            if (shouldCreateHub) {
                let wasHubCreated = false;
                setIsCreatingHub(true);
                hasCreatedHub.current = true;
                experienceTracker.start({
                    name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).DEFAULT
                });
                (0, $gi8UL.createCompanyHubSpace)().then(({ didCreateSpace: didCreateSpace, homepageId: homepageId })=>{
                    if (didCreateSpace) {
                        experienceTracker.succeed({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE)
                        });
                        wasHubCreated = true;
                        onSuccess?.(homepageId);
                    } else {
                        experienceTracker.abort({
                            name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                            reason: 'Hub space already exists. Handled by redirecting user to Hub editor without first time experience'
                        });
                        onExists?.(homepageId);
                    }
                }).catch((error)=>{
                    setCreationError(error);
                    if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User has stale admin permissions'
                    });
                    else if ((0, $1uFM6.isUnauthorizedError)(error)) experienceTracker.abort({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        reason: 'User is not authenticated'
                    });
                    else experienceTracker.fail({
                        name: (0, $irVI7.COMPANY_HUB_CREATION_EXPERIENCE),
                        error: error
                    });
                }).finally(()=>{
                    setIsCreatingHub(false);
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            source: 'companyHub',
                            action: 'created',
                            actionSubject: 'onRouteStart',
                            actionSubjectId: 'companyHubOnRouteCreation',
                            attributes: {
                                created: wasHubCreated,
                                route: route
                            }
                        }
                    }).fire();
                });
            }
        }
    }, [
        isCompanyHubUnset,
        isSiteAdmin,
        createAnalyticsEvent,
        shouldShowPremiumUpsell,
        isCreatingHub,
        experienceTracker,
        onSuccess,
        onExists,
        route
    ]);
    return {
        isCreatingHub: isCreatingHub,
        creationError: creationError
    };
}
module.exports["useCompanyHubOnRouteCreationFlow"] = $6d8995f9c98e457c$export$567b73f497a151cb;

});

parcelRegister("eCfJ3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $RfroO = parcelRequire("RfroO");


var $eKMV3 = parcelRequire("eKMV3");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $i1t43 = parcelRequire("i1t43");


var $1NBp8 = parcelRequire("1NBp8");


var $1uFM6 = parcelRequire("1uFM6");


var $gi8UL = parcelRequire("gi8UL");


var $bv42K = parcelRequire("bv42K");


var $8x1Nr = parcelRequire("8x1Nr");

const $3f49c0dd8d66c83c$var$containerStyles = (0, $buxP3.xcss)({
    height: '90vh',
    paddingInline: 'space.200'
});
const $3f49c0dd8d66c83c$export$c09c08db0e42b276 = ({ error: error })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const errorConfig = (0, $cozmU.useMemo)(()=>{
        if ((0, $gi8UL.hasStalePermissionsErrorMessage)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8x1Nr))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceStalePermissionsErrorFlagDescription, {
                a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                        href: "https://support.atlassian.com/confluence-cloud/docs/create-and-customize-a-company-hub",
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, chunks)
            })
        };
        if ((0, $1uFM6.isUnauthorizedError)(error)) return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($8x1Nr))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagDescription, {
                b: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
            }),
            buttonLabel: formatMessage((0, $gi8UL.i18n).createCompanyHubSpacePermissionsErrorFlagButton),
            buttonLink: (0, $1NBp8.ADMIN_NEW_GLOBAL_PERMISSIONS).toUrl()
        };
        return {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($bv42K))),
            title: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagTitle),
            description: formatMessage((0, $gi8UL.i18n).createCompanyHubSpaceErrorFlagDescription)
        };
    }, [
        error,
        formatMessage
    ]);
    const { imageUrl: imageUrl, title: title, description: description, buttonLabel: buttonLabel, buttonLink: buttonLink } = errorConfig;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $3f49c0dd8d66c83c$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $RfroO.default), {
        header: title,
        description: description,
        primaryAction: buttonLabel && buttonLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eKMV3.default), {
            appearance: "primary",
            href: buttonLink
        }, buttonLabel) : undefined,
        imageUrl: imageUrl
    }));
};
module.exports["HubErrorPageComponent"] = $3f49c0dd8d66c83c$export$c09c08db0e42b276;

});

parcelRegister("eX4up", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $jlRK6 = parcelRequire("jlRK6");


var $d7j1D = parcelRequire("d7j1D");


var $dVPAB = parcelRequire("dVPAB");


var $faAj4 = parcelRequire("faAj4");


var $4yccB = parcelRequire("4yccB");


var $c2Doe = parcelRequire("c2Doe");


var $iMnC5 = parcelRequire("iMnC5");


var $b8pma = parcelRequire("b8pma");


var $lfoFx = parcelRequire("lfoFx");


var $bIp5p = parcelRequire("bIp5p");


var $3eDML = parcelRequire("3eDML");


var $ame4Z = parcelRequire("ame4Z");


var $r8hvx = parcelRequire("r8hvx");


var $9tqV4 = parcelRequire("9tqV4");


var $2VrNo = parcelRequire("2VrNo");


var $8NddB = parcelRequire("8NddB");


var $kETeF = parcelRequire("kETeF");


var $jcnIS = parcelRequire("jcnIS");


var $fXxXz = parcelRequire("fXxXz");


var $9YzZs = parcelRequire("9YzZs");


var $2rwbd = parcelRequire("2rwbd");


var $8XweJ = parcelRequire("8XweJ");

const $2105bf85746b7ad8$var$hubEditorStyles = {
    spinnerContainer: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0jFU0VWP8C"
};
const $2105bf85746b7ad8$var$EditorInternal = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(82);
    const intl = (0, $kSwu1.useIntl)();
    const [editorApi, setEditorApi] = (0, $cozmU.useState)(undefined);
    const { editorActions: editorActions, contentId: contentId, userId: userId, cloudId: cloudId, product: product, mediaProvider: mediaProvider, setExternalEditorApi: setExternalEditorApi, additionalExtensionProviders: t0, loadAdditionalExtensionProviders: loadAdditionalExtensionProviders, onExtensionProvidersLoaded: onExtensionProvidersLoaded, PropsProvider: PropsProvider, linkPickerOptions: linkPickerOptions, isEditingLocked: isEditingLocked, isTemplateLocked: isTemplateLocked } = props;
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? [] : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const additionalExtensionProviders = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = new (0, $4yccB.default)();
        $[2] = t2;
    } else t2 = $[2];
    const smartCardClient = t2;
    const { pageMediaConfig: pageMediaConfig } = (0, $r8hvx.useHubContext)();
    const { closeConfigPanel: closeConfigPanel, openConfigPanel: openConfigPanel } = (0, $9tqV4.useHubEditorExtensionConfigPanel)(editorActions);
    const [t3] = (0, $bIp5p.useExtensionsState)();
    const { selectedExtensionLocalId: selectedExtensionLocalId } = t3;
    const { setIsInViewMode: setIsInViewMode, setIsEditingLocked: setIsEditingLocked } = (0, $bIp5p.useExtensionsActions)();
    const { featureFlags: featureFlags } = (0, $r8hvx.useHubContext)();
    let t4;
    if ($[3] !== PropsProvider || $[4] !== contentId || $[5] !== editorActions || $[6] !== intl || $[7] !== openConfigPanel) {
        t4 = {
            contentId: contentId,
            intl: intl,
            PropsProvider: PropsProvider,
            editorActions: editorActions,
            openConfigPanel: openConfigPanel
        };
        $[3] = PropsProvider;
        $[4] = contentId;
        $[5] = editorActions;
        $[6] = intl;
        $[7] = openConfigPanel;
        $[8] = t4;
    } else t4 = $[8];
    const hubExtensionProviders = (0, $jcnIS.useHubExtensionProviders)(t4);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t5;
    let t6;
    if ($[9] !== editorActions || $[10] !== loadAdditionalExtensionProviders || $[11] !== openConfigPanel) {
        t5 = ()=>{
            if (loadAdditionalExtensionProviders && editorActions) loadAdditionalExtensionProviders({
                editorActions: editorActions,
                openConfigPanel: openConfigPanel
            });
        };
        t6 = [
            loadAdditionalExtensionProviders,
            editorActions,
            openConfigPanel
        ];
        $[9] = editorActions;
        $[10] = loadAdditionalExtensionProviders;
        $[11] = openConfigPanel;
        $[12] = t5;
        $[13] = t6;
    } else {
        t5 = $[12];
        t6 = $[13];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t5, t6);
    let t7;
    if ($[14] !== additionalExtensionProviders || $[15] !== hubExtensionProviders) {
        t7 = [
            ...hubExtensionProviders,
            ...additionalExtensionProviders
        ];
        $[14] = additionalExtensionProviders;
        $[15] = hubExtensionProviders;
        $[16] = t7;
    } else t7 = $[16];
    const allExtensionProviders = t7;
    let t8;
    let t9;
    if ($[17] !== allExtensionProviders || $[18] !== onExtensionProvidersLoaded) {
        t8 = ()=>{
            if (onExtensionProvidersLoaded && allExtensionProviders.length > 0) onExtensionProvidersLoaded(allExtensionProviders);
        };
        t9 = [
            onExtensionProvidersLoaded,
            allExtensionProviders
        ];
        $[17] = allExtensionProviders;
        $[18] = onExtensionProvidersLoaded;
        $[19] = t8;
        $[20] = t9;
    } else {
        t8 = $[19];
        t9 = $[20];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t8, t9);
    let t10;
    if ($[21] !== contentId || $[22] !== editorApi || $[23] !== mediaProvider || $[24] !== pageMediaConfig) {
        t10 = {
            contentId: contentId,
            editorAPI: editorApi,
            customMediaProvider: mediaProvider,
            mediaConfig: pageMediaConfig
        };
        $[21] = contentId;
        $[22] = editorApi;
        $[23] = mediaProvider;
        $[24] = pageMediaConfig;
        $[25] = t10;
    } else t10 = $[25];
    const mediaOptions = (0, $2rwbd.useMediaOptions)(t10);
    let t11;
    if ($[26] !== featureFlags || $[27] !== intl || $[28] !== isEditingLocked || $[29] !== isTemplateLocked || $[30] !== linkPickerOptions || $[31] !== mediaOptions || $[32] !== props) {
        t11 = ()=>(0, $9YzZs.createHubEditorPreset)({
                ...props,
                intl: intl,
                mediaOptions: mediaOptions,
                linkPickerOptions: linkPickerOptions,
                featureFlags: featureFlags,
                isEditingLocked: isEditingLocked,
                isTemplateLocked: isTemplateLocked
            });
        $[26] = featureFlags;
        $[27] = intl;
        $[28] = isEditingLocked;
        $[29] = isTemplateLocked;
        $[30] = linkPickerOptions;
        $[31] = mediaOptions;
        $[32] = props;
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== contentId || $[35] !== intl || $[36] !== isEditingLocked || $[37] !== isTemplateLocked || $[38] !== linkPickerOptions || $[39] !== mediaOptions || $[40] !== props.appearance || $[41] !== props.editorPluginAIDefinitionsEnabled || $[42] !== props.editorPluginHubTextColorEnabled || $[43] !== props.hasEditPermission || $[44] !== props.isDesktop || $[45] !== props.isLoomPluginEnabled) {
        t12 = [
            intl,
            props.appearance,
            props.hasEditPermission,
            isEditingLocked,
            isTemplateLocked,
            props.isLoomPluginEnabled,
            props.editorPluginAIDefinitionsEnabled,
            props.editorPluginHubTextColorEnabled,
            props.isDesktop,
            contentId,
            mediaOptions,
            linkPickerOptions
        ];
        $[34] = contentId;
        $[35] = intl;
        $[36] = isEditingLocked;
        $[37] = isTemplateLocked;
        $[38] = linkPickerOptions;
        $[39] = mediaOptions;
        $[40] = props.appearance;
        $[41] = props.editorPluginAIDefinitionsEnabled;
        $[42] = props.editorPluginHubTextColorEnabled;
        $[43] = props.hasEditPermission;
        $[44] = props.isDesktop;
        $[45] = props.isLoomPluginEnabled;
        $[46] = t12;
    } else t12 = $[46];
    const { preset: preset, editorApi: presetEditorApi } = (0, $dVPAB.usePreset)(t11, t12);
    let t13;
    let t14;
    if ($[47] !== setIsInViewMode) {
        t13 = ()=>{
            setIsInViewMode(false);
        };
        t14 = [
            setIsInViewMode
        ];
        $[47] = setIsInViewMode;
        $[48] = t13;
        $[49] = t14;
    } else {
        t13 = $[48];
        t14 = $[49];
    }
    (0, $cozmU.useEffect)(t13, t14);
    let t15;
    let t16;
    if ($[50] !== isEditingLocked || $[51] !== setIsEditingLocked) {
        t15 = ()=>{
            setIsEditingLocked(Boolean(isEditingLocked));
        };
        t16 = [
            setIsEditingLocked,
            isEditingLocked
        ];
        $[50] = isEditingLocked;
        $[51] = setIsEditingLocked;
        $[52] = t15;
        $[53] = t16;
    } else {
        t15 = $[52];
        t16 = $[53];
    }
    (0, $cozmU.useEffect)(t15, t16);
    let t17;
    let t18;
    if ($[54] !== presetEditorApi || $[55] !== setExternalEditorApi) {
        t17 = ()=>{
            setEditorApi(presetEditorApi);
            if (!setExternalEditorApi || !presetEditorApi) return;
            setExternalEditorApi(presetEditorApi);
        };
        t18 = [
            presetEditorApi,
            setExternalEditorApi
        ];
        $[54] = presetEditorApi;
        $[55] = setExternalEditorApi;
        $[56] = t17;
        $[57] = t18;
    } else {
        t17 = $[56];
        t18 = $[57];
    }
    (0, $cozmU.useEffect)(t17, t18);
    let t19;
    if ($[58] !== PropsProvider || $[59] !== additionalExtensionProviders || $[60] !== allExtensionProviders || $[61] !== closeConfigPanel || $[62] !== cloudId || $[63] !== contentId || $[64] !== editorActions || $[65] !== editorApi || $[66] !== formatMessage || $[67] !== hubExtensionProviders.length || $[68] !== isEditingLocked || $[69] !== preset || $[70] !== props || $[71] !== selectedExtensionLocalId || $[72] !== userId) {
        t19 = (linkingFeatures)=>hubExtensionProviders.length > 0 && additionalExtensionProviders.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
                appearance: "full-page",
                ...linkingFeatures,
                ...props,
                disabled: isEditingLocked,
                preset: preset,
                ...allExtensionProviders.length > 0 ? {
                    extensionProviders: allExtensionProviders
                } : {},
                editorActions: editorActions,
                contextPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VrNo.HubEditorConfigPanelEntryPoint), {
                    localId: selectedExtensionLocalId || "",
                    closeConfigPanel: closeConfigPanel,
                    editorActions: editorActions,
                    contentId: contentId,
                    editorApi: editorApi,
                    propsProvider: PropsProvider
                }),
                emojiProvider: (0, $kETeF.getEmojiProvider)({
                    cloudId: cloudId,
                    userId: userId
                })
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
                name: "hub-extensions-loader"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                xcss: $2105bf85746b7ad8$var$hubEditorStyles.spinnerContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: "large",
                label: formatMessage((0, $8XweJ.default).hubStudioLoadingSpinnerLabel)
            })));
        $[58] = PropsProvider;
        $[59] = additionalExtensionProviders;
        $[60] = allExtensionProviders;
        $[61] = closeConfigPanel;
        $[62] = cloudId;
        $[63] = contentId;
        $[64] = editorActions;
        $[65] = editorApi;
        $[66] = formatMessage;
        $[67] = hubExtensionProviders.length;
        $[68] = isEditingLocked;
        $[69] = preset;
        $[70] = props;
        $[71] = selectedExtensionLocalId;
        $[72] = userId;
        $[73] = t19;
    } else t19 = $[73];
    let t20;
    if ($[74] !== cloudId || $[75] !== linkPickerOptions || $[76] !== product || $[77] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8NddB.EditorLinkingFeatures), {
            product: product,
            cloudId: cloudId,
            options: (0, $fXxXz.LINKING_FEATURES_CARD_OPTIONS),
            linkPickerOptions: linkPickerOptions
        }, t19);
        $[74] = cloudId;
        $[75] = linkPickerOptions;
        $[76] = product;
        $[77] = t19;
        $[78] = t20;
    } else t20 = $[78];
    let t21;
    if ($[79] !== product || $[80] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), {
            product: product,
            client: smartCardClient
        }, t20);
        $[79] = product;
        $[80] = t20;
        $[81] = t21;
    } else t21 = $[81];
    return t21;
} : (props)=>{
    const intl = (0, $kSwu1.useIntl)();
    const [editorApi, setEditorApi] = (0, $cozmU.useState)(undefined);
    const { editorActions: editorActions, contentId: contentId, userId: userId, cloudId: cloudId, product: product, mediaProvider: mediaProvider, setExternalEditorApi: setExternalEditorApi, additionalExtensionProviders: additionalExtensionProviders = [], loadAdditionalExtensionProviders: loadAdditionalExtensionProviders, onExtensionProvidersLoaded: onExtensionProvidersLoaded, PropsProvider: PropsProvider, linkPickerOptions: linkPickerOptions, isEditingLocked: isEditingLocked, isTemplateLocked: isTemplateLocked } = props;
    const smartCardClient = (0, $cozmU.useMemo)(()=>new (0, $4yccB.default)(), []);
    const { pageMediaConfig: pageMediaConfig } = (0, $r8hvx.useHubContext)();
    const { closeConfigPanel: closeConfigPanel, openConfigPanel: openConfigPanel } = (0, $9tqV4.useHubEditorExtensionConfigPanel)(editorActions);
    const [{ selectedExtensionLocalId: selectedExtensionLocalId }] = (0, $bIp5p.useExtensionsState)();
    const { setIsInViewMode: setIsInViewMode, setIsEditingLocked: setIsEditingLocked } = (0, $bIp5p.useExtensionsActions)();
    const { featureFlags: featureFlags } = (0, $r8hvx.useHubContext)();
    const hubExtensionProviders = (0, $jcnIS.useHubExtensionProviders)({
        contentId: contentId,
        intl: intl,
        PropsProvider: PropsProvider,
        editorActions: editorActions,
        openConfigPanel: openConfigPanel
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Load additional extension providers when editor is ready; we need to inject
    // editor-specific props
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (loadAdditionalExtensionProviders && editorActions) loadAdditionalExtensionProviders({
            editorActions: editorActions,
            openConfigPanel: openConfigPanel
        });
    }, [
        loadAdditionalExtensionProviders,
        editorActions,
        openConfigPanel
    ]);
    // Combine hub extensions with additional extensions
    const allExtensionProviders = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        return [
            ...hubExtensionProviders,
            ...additionalExtensionProviders
        ];
    }, [
        hubExtensionProviders,
        additionalExtensionProviders
    ]);
    // Notify parent when all extension providers (hub + additional) are available
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        if (onExtensionProvidersLoaded && allExtensionProviders.length > 0) onExtensionProvidersLoaded(allExtensionProviders);
    }, [
        onExtensionProvidersLoaded,
        allExtensionProviders
    ]);
    const mediaOptions = (0, $2rwbd.useMediaOptions)({
        contentId: contentId,
        editorAPI: editorApi,
        customMediaProvider: mediaProvider,
        mediaConfig: pageMediaConfig
    });
    const { preset: preset, editorApi: presetEditorApi } = (0, $dVPAB.usePreset)(()=>{
        return (0, $9YzZs.createHubEditorPreset)({
            ...props,
            intl: intl,
            mediaOptions: mediaOptions,
            linkPickerOptions: linkPickerOptions,
            featureFlags: featureFlags,
            isEditingLocked: isEditingLocked,
            isTemplateLocked: isTemplateLocked
        });
    }, [
        intl,
        props.appearance,
        props.hasEditPermission,
        isEditingLocked,
        isTemplateLocked,
        props.isLoomPluginEnabled,
        props.editorPluginAIDefinitionsEnabled,
        props.editorPluginHubTextColorEnabled,
        props.isDesktop,
        contentId,
        mediaOptions,
        linkPickerOptions
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsInViewMode(false);
    }, [
        setIsInViewMode
    ]); // Shared with extensions so their own edit affordances match the editor's lock.
    (0, $cozmU.useEffect)(()=>{
        setIsEditingLocked(Boolean(isEditingLocked));
    }, [
        setIsEditingLocked,
        isEditingLocked
    ]);
    (0, $cozmU.useEffect)(()=>{
        setEditorApi(presetEditorApi);
        if (!setExternalEditorApi || !presetEditorApi) return;
        setExternalEditorApi(presetEditorApi);
    }, [
        presetEditorApi,
        setExternalEditorApi
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c2Doe.SmartCardProvider), {
        product: product,
        client: smartCardClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8NddB.EditorLinkingFeatures), {
        product: product,
        cloudId: cloudId,
        options: (0, $fXxXz.LINKING_FEATURES_CARD_OPTIONS),
        linkPickerOptions: linkPickerOptions
    }, (linkingFeatures)=>{
        return hubExtensionProviders.length > 0 && additionalExtensionProviders.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jlRK6.ComposableEditor), {
            appearance: "full-page",
            ...linkingFeatures,
            ...props,
            disabled: isEditingLocked,
            preset: preset,
            ...allExtensionProviders.length > 0 ? {
                extensionProviders: allExtensionProviders
            } : {},
            editorActions: editorActions,
            contextPanel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2VrNo.HubEditorConfigPanelEntryPoint), {
                localId: selectedExtensionLocalId || '',
                closeConfigPanel: closeConfigPanel,
                editorActions: editorActions,
                contentId: contentId,
                editorApi: editorApi,
                propsProvider: PropsProvider
            }),
            emojiProvider: (0, $kETeF.getEmojiProvider)({
                cloudId: cloudId,
                userId: userId
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "hub-extensions-loader"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $2105bf85746b7ad8$var$hubEditorStyles.spinnerContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: 'large',
            label: formatMessage((0, $8XweJ.default).hubStudioLoadingSpinnerLabel)
        })));
    }));
};
const $2105bf85746b7ad8$var$HubEditor = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eDML.GenericErrorPage), null);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ame4Z.HubErrorBoundary), {
            packageName: "@atlassian/hub-editor",
            id: "hub-editor",
            fallback: t0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $faAj4.default), {
            render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2105bf85746b7ad8$var$EditorInternal, {
                    editorActions: editorActions,
                    ...props
                })
        })));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ame4Z.HubErrorBoundary), {
        packageName: "@atlassian/hub-editor",
        id: "hub-editor",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eDML.GenericErrorPage), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7j1D.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $faAj4.default), {
        render: (editorActions)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2105bf85746b7ad8$var$EditorInternal, {
                editorActions: editorActions,
                ...props
            })
    })));
};
var $2105bf85746b7ad8$export$2e2bcd8739ae039 = $2105bf85746b7ad8$var$HubEditor;
module.exports["default"] = $2105bf85746b7ad8$export$2e2bcd8739ae039;

});

parcelRegister("bUMKD", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $bab760cfbd2a476f$export$efc60a58bfe62d46 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "CsDwr",
    name: "ExternalSharePageLoader",
    loader: async ()=>(await (parcelRequire("5v3yH"))).ExternalSharePage
});
module.exports["ExternalSharePageLoader"] = $bab760cfbd2a476f$export$efc60a58bfe62d46;

});

parcelRegister("6fVzX", function(module, exports) {
const $48e0cec07a1313a2$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $48e0cec07a1313a2$export$855ece989b15eb57 = (type)=>$48e0cec07a1313a2$var$VALID_LINK_TYPES.includes(type) ? type : 'a';
module.exports["getValidLinkType"] = $48e0cec07a1313a2$export$855ece989b15eb57;

});

parcelRegister("et2nj", function(module, exports) {
const $83b16c63dab14b97$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $83b16c63dab14b97$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $a8859dbb9c1926d9$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $83b16c63dab14b97$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $83b16c63dab14b97$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $83b16c63dab14b97$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};
module.exports["handleNavigation"] = $a8859dbb9c1926d9$export$706ad1af8096e280;

});

parcelRegister("9RVC0", function(module, exports) {
const $72f5c0d3161385ca$export$9ccb639b7a119f61 = ()=>Date.now();
module.exports["getAccessedAt"] = $72f5c0d3161385ca$export$9ccb639b7a119f61;

});

parcelRegister("lHNk5", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $ayVUo = parcelRequire("ayVUo");


var $lTQd7 = parcelRequire("lTQd7");


var $e2AvM = parcelRequire("e2AvM");


var $dV1xE = parcelRequire("dV1xE");

const $2e024aa0d080fc95$export$37d3126be6549b13 = 10000;


function $fcd3df9f15446c01$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $eb3ax.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $e2AvM.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $dV1xE.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $lTQd7.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $ayVUo.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $lTQd7.getExpiresAt)((0, $2e024aa0d080fc95$export$37d3126be6549b13))) : resourceMaxAge
    };
}
module.exports["createLoadingSlice"] = $fcd3df9f15446c01$export$dc62515c8f0b52dd;

});

parcelRegister("231PG", function(module, exports) {

var $ayVUo = parcelRequire("ayVUo");

/**
 * Utility method to created async versions of getData functions
 */ const $17dd48841fdc286a$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $17dd48841fdc286a$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $17dd48841fdc286a$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $ayVUo.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $ayVUo.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $ayVUo.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("8RoZS", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $htr8O = parcelRequire("htr8O");


var $iiKpy = parcelRequire("iiKpy");

var $6736a9db7ca34e4c$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $6736a9db7ca34e4c$var$fromEntries = ($6736a9db7ca34e4c$var$_Object$fromEntries = Object.fromEntries) != null ? $6736a9db7ca34e4c$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $6736a9db7ca34e4c$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $6736a9db7ca34e4c$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $6736a9db7ca34e4c$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($6736a9db7ca34e4c$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($6736a9db7ca34e4c$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($6736a9db7ca34e4c$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $6736a9db7ca34e4c$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($6736a9db7ca34e4c$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $6736a9db7ca34e4c$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$6736a9db7ca34e4c$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $6736a9db7ca34e4c$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($6736a9db7ca34e4c$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $6736a9db7ca34e4c$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($6736a9db7ca34e4c$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $6736a9db7ca34e4c$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($6736a9db7ca34e4c$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $6736a9db7ca34e4c$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $6736a9db7ca34e4c$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $6736a9db7ca34e4c$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $iiKpy.getResourceState)(dependencyType, key)) || (0, $htr8O.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $iiKpy.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $eb3ax.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };
module.exports["actionWithDependencies"] = $6736a9db7ca34e4c$export$5f7e1fd85734e71e;
module.exports["mapActionWithDependencies"] = $6736a9db7ca34e4c$export$f71a65c89c987a02;
module.exports["executeForDependents"] = $6736a9db7ca34e4c$export$7d1ffac63c68405d;
module.exports["getDependencies"] = $6736a9db7ca34e4c$export$75915f81f2a6540a;

});

parcelRegister("lTQd7", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $ff173bfb28e1acd4$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $ff173bfb28e1acd4$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $eb3ax.default)({}, slice, {
        expiresAt: $ff173bfb28e1acd4$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;
module.exports["getExpiresAt"] = $ff173bfb28e1acd4$export$b65d7ba7fbf150f1;
module.exports["setExpiresAt"] = $ff173bfb28e1acd4$export$18d1d420fd588368;

});

parcelRegister("e2AvM", function(module, exports) {
const $a38d930b50e2721e$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};
module.exports["generateTimeGuard"] = $a38d930b50e2721e$export$58634b3a58ae66b7;

});

parcelRegister("htr8O", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $9RVC0 = parcelRequire("9RVC0");


var $ayVUo = parcelRequire("ayVUo");


var $lTQd7 = parcelRequire("lTQd7");

/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $a37958bdf929e185$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $cb8a32c52501d499$export$fa8e33c3301e2e94 = ()=>(0, $eb3ax.default)({}, (0, $a37958bdf929e185$export$2df85a734ff5ed27), {
        expiresAt: (0, $lTQd7.getExpiresAt)((0, $ayVUo.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $9RVC0.getAccessedAt)()
    });
module.exports["getDefaultStateSlice"] = $cb8a32c52501d499$export$fa8e33c3301e2e94;

});

parcelRegister("6gRks", function(module, exports) {
const $490d9ab8531b6967$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $490d9ab8531b6967$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$490d9ab8531b6967$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
module.exports["getResourceIdentifier"] = $490d9ab8531b6967$export$c616b176adf9ad4a;
module.exports["getResourceIdentifiers"] = $490d9ab8531b6967$export$cd7fbe7e979df558;

});

parcelRegister("hNpL3", function(module, exports) {

var $6gRks = parcelRequire("6gRks");


var $koXzF = parcelRequire("koXzF");

const $cf4afe494b6c8347$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $koXzF.routeHasResources)(nextRoute)) return [];
    if ((0, $koXzF.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $6gRks.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $6gRks.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};
module.exports["getResourcesForNextLocation"] = $cf4afe494b6c8347$export$7cbbc763e2f3d65d;

});

parcelRegister("7kOId", function(module, exports) {

var $iiKpy = parcelRequire("iiKpy");

const $5571bd0df36ef9b1$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $5571bd0df36ef9b1$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $5571bd0df36ef9b1$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $5571bd0df36ef9b1$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $5571bd0df36ef9b1$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $iiKpy.deleteResourceState)(type, keyTobeDeleted));
    };
module.exports["validateLRUCache"] = $5571bd0df36ef9b1$export$89440b7623c2c75c;

});

parcelRegister("iiKpy", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $eb3ax = parcelRequire("eb3ax");

function $d52de8b966e6efd1$var$_toPropertyKey(t) {
    var i = $d52de8b966e6efd1$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $d52de8b966e6efd1$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $d52de8b966e6efd1$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $d52de8b966e6efd1$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $eb3ax.default)({}, prefetching, {
                [type]: (0, $eb3ax.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $d52de8b966e6efd1$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($d52de8b966e6efd1$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $eb3ax.default)({}, data, {
                [type]: (0, $eb3ax.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $d52de8b966e6efd1$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $d52de8b966e6efd1$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $1eVGO.default)(data, [
            type
        ].map($d52de8b966e6efd1$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $1eVGO.default)(resourceForType, [
                key
            ].map($d52de8b966e6efd1$var$_toPropertyKey));
            setState({
                data: (0, $eb3ax.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };
module.exports["getPrefetchSlice"] = $d52de8b966e6efd1$export$11374758be89e40;
module.exports["setPrefetchSlice"] = $d52de8b966e6efd1$export$1e32615dc8354436;
module.exports["setResourceState"] = $d52de8b966e6efd1$export$704f800f263b050e;
module.exports["getResourceState"] = $d52de8b966e6efd1$export$5fc90c33b03fffb;
module.exports["deleteResourceState"] = $d52de8b966e6efd1$export$d40f35dc5952864b;

});

parcelRegister("koXzF", function(module, exports) {
const $eda442c6180d8a83$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $eda442c6180d8a83$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
module.exports["routeHasResources"] = $eda442c6180d8a83$export$740886389191c640;
module.exports["routeHasChanged"] = $eda442c6180d8a83$export$221027ff1aa38f82;

});

parcelRegister("hBrfJ", function(module, exports) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $cd0b08331022c28a$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $cd0b08331022c28a$var$NonError);
    }
}
const $cd0b08331022c28a$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $cd0b08331022c28a$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $cd0b08331022c28a$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $cd0b08331022c28a$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $cd0b08331022c28a$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $cd0b08331022c28a$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $cd0b08331022c28a$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $cd0b08331022c28a$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $cd0b08331022c28a$var$NonError(value);
};
module.exports["serializeError"] = $cd0b08331022c28a$export$46ff38bc6bdea8fb;
module.exports["deserializeError"] = $cd0b08331022c28a$export$64cddc1e268e9046;

});

parcelRegister("8Z7ra", function(module, exports) {
const $68a9ca20984f3164$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $68a9ca20984f3164$var$isFresh = (resource)=>{
    if ($68a9ca20984f3164$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $68a9ca20984f3164$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($68a9ca20984f3164$var$isFresh(resource)) return true;
    return false;
};
module.exports["isFromSsr"] = $68a9ca20984f3164$export$b25d2963b8a3488a;
module.exports["shouldUseCache"] = $68a9ca20984f3164$export$399de8c43d0ece3c;

});

parcelRegister("8jRWn", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $60e9f087f6ede995$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $eb3ax.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;
module.exports["setSsrDataPromise"] = $60e9f087f6ede995$export$2e4da1b414980956;

});

parcelRegister("dV1xE", function(module, exports) {
class $a221cb6617a20e07$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}
module.exports["TimeoutError"] = $a221cb6617a20e07$export$66d311bf29d5c89c;

});

parcelRegister("5aFDI", function(module, exports) {
const $3c3e2fb015a18dfb$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
module.exports["transformData"] = $3c3e2fb015a18dfb$export$3ceb62baab058c6b;

});

parcelRegister("hq2yE", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("9RVC0")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("lHNk5")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("8RoZS")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("8RoZS")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("8RoZS")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("8RoZS")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("lTQd7")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("lTQd7")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("htr8O")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("hNpL3")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("7kOId")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("iiKpy")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("iiKpy")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("iiKpy")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("iiKpy")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("iiKpy")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("hBrfJ")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("hBrfJ")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("8Z7ra")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("8Z7ra")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("8jRWn")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("dV1xE")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("5aFDI")).transformData);

var $9RVC0 = parcelRequire("9RVC0");


var $lHNk5 = parcelRequire("lHNk5");


var $231PG = parcelRequire("231PG");


var $8RoZS = parcelRequire("8RoZS");


var $lTQd7 = parcelRequire("lTQd7");


var $e2AvM = parcelRequire("e2AvM");


var $htr8O = parcelRequire("htr8O");


var $6gRks = parcelRequire("6gRks");


var $hNpL3 = parcelRequire("hNpL3");


var $7kOId = parcelRequire("7kOId");


var $iiKpy = parcelRequire("iiKpy");


var $koXzF = parcelRequire("koXzF");


var $hBrfJ = parcelRequire("hBrfJ");


var $8Z7ra = parcelRequire("8Z7ra");


var $8jRWn = parcelRequire("8jRWn");


var $dV1xE = parcelRequire("dV1xE");


var $5aFDI = parcelRequire("5aFDI");


});

parcelRegister("8CJk6", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eb3ax = parcelRequire("eb3ax");


var $ccS36 = parcelRequire("ccS36");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("bDcGz");
var $7MFOM = parcelRequire("7MFOM");


var $6nY8H = parcelRequire("6nY8H");

class $64750795b7972098$var$Redirector extends (0, $cozmU.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $lI7ls.createPath)((0, $7MFOM.generateLocationFromPath)(to.path, routeAttributes)) : (0, $lI7ls.createPath)(to) : to;
        const currentPath = (0, $lI7ls.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, $ccS36.default)($64750795b7972098$var$Redirector, "defaultProps", {
    push: false
});
const $64750795b7972098$export$2d8d895a0a0f636e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const [t0, actions] = (0, $6nY8H.useRouter)();
    const { location: location } = t0;
    let t1;
    if ($[0] !== actions || $[1] !== location || $[2] !== props) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($64750795b7972098$var$Redirector, (0, $eb3ax.default)({
            actions: actions,
            location: location
        }, props));
        $[0] = actions;
        $[1] = location;
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
} : (props)=>{
    const [{ location: location }, actions] = (0, $6nY8H.useRouter)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($64750795b7972098$var$Redirector, (0, $eb3ax.default)({
        actions: actions,
        location: location
    }, props));
};

});

parcelRegister("5ZHAX", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");


var $kZkvy = parcelRequire("kZkvy");

const $45d47754d4ad67f0$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kZkvy.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $45d47754d4ad67f0$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $cozmU.useMemo)(()=>(0, $lI7ls.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($45d47754d4ad67f0$export$55185c17a0fcbe46, (0, $eb3ax.default)({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}

});

parcelRegister("k8KD8", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $j4NNn = parcelRequire("j4NNn");

const $ea98b9cde87f8635$export$b371fa9cf762ad06 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    const actions = (0, $j4NNn.useRouterActions)();
    let t1;
    if ($[0] !== actions || $[1] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
        $[0] = actions;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children })=>{
    const actions = (0, $j4NNn.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(actions));
};
$ea98b9cde87f8635$export$b371fa9cf762ad06.displayName = 'RouterActions';

});

parcelRegister("aO6HO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $1eVGO = parcelRequire("1eVGO");


var $cozmU = parcelRequire("cozmU");

parcelRequire("bDcGz");
var $2kK4E = parcelRequire("2kK4E");


var $kZkvy = parcelRequire("kZkvy");

const $7de3c684772f52ab$var$_excluded = [
    "listen"
];
const $7de3c684772f52ab$export$672d721d310ff5f0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const [state, _ref] = (0, $kZkvy.useRouterStore)();
    const { listen: listen } = _ref;
    let t1;
    if ($[0] !== _ref || $[1] !== children || $[2] !== listen || $[3] !== state) {
        const actions = (0, $1eVGO.default)(_ref, $7de3c684772f52ab$var$_excluded);
        if (!state.unlisten && !(0, $2kK4E.isServerEnvironment)()) listen();
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
        $[0] = _ref;
        $[1] = children;
        $[2] = listen;
        $[3] = state;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ children: children })=>{
    const [state, _ref] = (0, $kZkvy.useRouterStore)();
    const { listen: listen } = _ref, actions = (0, $1eVGO.default)(_ref, $7de3c684772f52ab$var$_excluded);
    if (!state.unlisten && !(0, $2kK4E.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(state, actions));
};
module.exports["RouterSubscriber"] = $7de3c684772f52ab$export$672d721d310ff5f0;

});

parcelRegister("33dCY", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $kZkvy = parcelRequire("kZkvy");

const $238c390c92a1ce3e$var$createPathParamHook = (0, $kBr4q.createHook)((0, $kZkvy.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $238c390c92a1ce3e$export$8c8591dcd57728e6 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $238c390c92a1ce3e$var$createPathParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updatePathParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setPathParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setPathParam) {
        t2 = [
            paramVal,
            setPathParam
        ];
        $[5] = paramVal;
        $[6] = setPathParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $238c390c92a1ce3e$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("d7HEO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");


var $kZkvy = parcelRequire("kZkvy");

const $98ddcb3f98ad0748$var$createQueryParamHook = (0, $kBr4q.createHook)((0, $kZkvy.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $98ddcb3f98ad0748$export$ae316f0eeb712a36 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (paramKey)=>{
    const $ = (0, $bDgLe.c)(8);
    let t0;
    if ($[0] !== paramKey) {
        t0 = $98ddcb3f98ad0748$var$createQueryParamHook({
            paramKey: paramKey
        });
        $[0] = paramKey;
        $[1] = t0;
    } else t0 = $[1];
    const [paramVal, routerActions] = t0;
    let t1;
    if ($[2] !== paramKey || $[3] !== routerActions) {
        t1 = (newValue, updateType)=>{
            routerActions.updateQueryParam({
                [paramKey]: newValue
            }, updateType);
        };
        $[2] = paramKey;
        $[3] = routerActions;
        $[4] = t1;
    } else t1 = $[4];
    const setQueryParam = t1;
    let t2;
    if ($[5] !== paramVal || $[6] !== setQueryParam) {
        t2 = [
            paramVal,
            setQueryParam
        ];
        $[5] = paramVal;
        $[6] = setQueryParam;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (paramKey)=>{
    const [paramVal, routerActions] = $98ddcb3f98ad0748$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $cozmU.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("6nY8H", function(module, exports) {

var $kZkvy = parcelRequire("kZkvy");

const $4a638a741202ff87$export$9a302a45f65d0572 = (0, $kZkvy.useRouterStore);
module.exports["useRouter"] = $4a638a741202ff87$export$9a302a45f65d0572;

});

parcelRegister("j4NNn", function(module, exports) {

var $kZkvy = parcelRequire("kZkvy");

const $de350461d6c0d763$export$402e82ff1b20594b = (0, $kZkvy.useRouterStoreActions);
module.exports["useRouterActions"] = $de350461d6c0d763$export$402e82ff1b20594b;

});

parcelRegister("7wvhg", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $kZkvy = parcelRequire("kZkvy");

const $57a3c89bff66d73d$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $57a3c89bff66d73d$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $57a3c89bff66d73d$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
        const $ = (0, $bDgLe.c)(10);
        const [t0, t1] = (0, $kZkvy.useRouterStore)();
        const { action: action, history: history, location: location, match: match, query: query, route: route } = t0;
        const { push: push, replace: replace } = t1;
        let t2;
        if ($[0] !== action || $[1] !== history || $[2] !== location || $[3] !== match || $[4] !== props || $[5] !== push || $[6] !== query || $[7] !== replace || $[8] !== route) {
            t2 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
                action: action,
                history: history,
                location: location,
                match: match,
                push: push,
                query: query,
                replace: replace,
                route: route
            }));
            $[0] = action;
            $[1] = history;
            $[2] = location;
            $[3] = match;
            $[4] = props;
            $[5] = push;
            $[6] = query;
            $[7] = replace;
            $[8] = route;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    } : (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $kZkvy.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, (0, $eb3ax.default)({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("imtAv", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $lI7ls = parcelRequire("lI7ls");


var $cozmU = parcelRequire("cozmU");

parcelRequire("bDcGz");
var $fHQWF = parcelRequire("fHQWF");
var $7MFOM = parcelRequire("7MFOM");


var $kZkvy = parcelRequire("kZkvy");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");




const $f6123e28cc74d57b$export$d8e6abf214c9ec0f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (delay)=>{
    const $ = (0, $bDgLe.c)(5);
    const timeoutId = (0, $cozmU.useRef)();
    let t0;
    if ($[0] !== delay) {
        t0 = (callback)=>{
            if (timeoutId.current) clearTimeout(timeoutId.current);
            timeoutId.current = setTimeout(callback, delay);
        };
        $[0] = delay;
        $[1] = t0;
    } else t0 = $[1];
    const schedule = t0;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            clearTimeout(timeoutId.current);
        };
        $[2] = t1;
    } else t1 = $[2];
    const cancel = t1;
    let t2;
    if ($[3] !== schedule) {
        t2 = {
            schedule: schedule,
            cancel: cancel
        };
        $[3] = schedule;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : (delay)=>{
    const timeoutId = (0, $cozmU.useRef)();
    const schedule = (0, $cozmU.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $cozmU.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};





var $cK9FA = parcelRequire("cK9FA");


var $bHq0V = parcelRequire("bHq0V");



const $d5e13b95edab2cc2$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $d5e13b95edab2cc2$var$PREFETCH_DELAY = 225;
const $d5e13b95edab2cc2$var$Link = /*#__PURE__*/ (0, $cozmU.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, $1eVGO.default)(_ref, $d5e13b95edab2cc2$var$_excluded);
    const routerActions = (0, $kZkvy.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $f6123e28cc74d57b$export$d8e6abf214c9ec0f)($d5e13b95edab2cc2$var$PREFETCH_DELAY);
    const validLinkType = (0, $cK9FA.getValidLinkType)(linkType);
    const [route, setRoute] = (0, $cozmU.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $lI7ls.createPath)((0, $7MFOM.generateLocationFromPath)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $cozmU.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $fHQWF.createRouterContext)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $bHq0V.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $cozmU.createElement)(validLinkType, (0, $eb3ax.default)({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$d5e13b95edab2cc2$var$Link.displayName = 'Link';
var $d5e13b95edab2cc2$export$2e2bcd8739ae039 = $d5e13b95edab2cc2$var$Link;
module.exports["default"] = $d5e13b95edab2cc2$export$2e2bcd8739ae039;

});

parcelRegister("h1RxD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

parcelRequire("9vmeB");
var $6nY8H = parcelRequire("6nY8H");

const $c65c0fe48c146c8d$export$7903e4b73fc7d6c3 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const [t0] = (0, $6nY8H.useRouter)();
    const { action: action, location: location, match: match, query: query, route: route } = t0;
    if (!route || !route.component) return null;
    let t1;
    if ($[0] !== action || $[1] !== location || $[2] !== match || $[3] !== query || $[4] !== route) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
            action: action,
            location: location,
            match: match,
            query: query,
            route: route
        });
        $[0] = action;
        $[1] = location;
        $[2] = match;
        $[3] = query;
        $[4] = route;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
} : ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $6nY8H.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};

});

parcelRegister("lKKkr", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $lI7ls = parcelRequire("lI7ls");


var $7SeeH = parcelRequire("7SeeH");


var $eO7Xs = parcelRequire("eO7Xs");

const $fd61d4c8ffe72819$var$hasWindow = ()=>typeof window !== 'undefined';
const $fd61d4c8ffe72819$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs)))
};
const $fd61d4c8ffe72819$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $fd61d4c8ffe72819$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $fd61d4c8ffe72819$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($7SeeH)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $fd61d4c8ffe72819$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $fd61d4c8ffe72819$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $fd61d4c8ffe72819$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, $eb3ax.default)({
        get location () {
            return currentLocation;
        },
        get length () {
            return $fd61d4c8ffe72819$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $fd61d4c8ffe72819$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $lI7ls.createPath)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $fd61d4c8ffe72819$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eO7Xs))),
        createHref: (location)=>(0, $lI7ls.createPath)(location)
    } : $fd61d4c8ffe72819$var$methodsPlaceholders);
};
module.exports["createLegacyHistory"] = $fd61d4c8ffe72819$export$883c3f3b6c000133;

});

parcelRegister("7MFOM", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");


var $4NiRC = parcelRequire("4NiRC");

function $5aad744e29dba80d$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $4NiRC.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}
module.exports["generateLocationFromPath"] = $5aad744e29dba80d$export$37e0729cc751960b;

});

parcelRegister("fEoYr", function(module, exports) {

var $6XX9c = parcelRequire("6XX9c");

const $b64df6be97c2557a$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $6XX9c.compile)(pattern)(params);
module.exports["generatePath"] = $b64df6be97c2557a$export$82476f982757e71e;

});

parcelRegister("2kK4E", function(module, exports) {
/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $1P2f3 = parcelRequire("1P2f3");

const $1b31305ee778cb0e$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $1b31305ee778cb0e$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $1P2f3 !== 'undefined' && $1P2f3.versions != null && $1P2f3.versions.node != null) return true;
    if ($1b31305ee778cb0e$var$isJsDomEnvironment()) return true;
    return false;
};
module.exports["isServerEnvironment"] = $1b31305ee778cb0e$export$455cc18296abe008;

});

parcelRegister("aNi3F", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dbc7cf12b42c499$export$2e2bcd8739ae039);

var $4NiRC = parcelRequire("4NiRC");


var $eb3ax = parcelRequire("eb3ax");

// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $6XX9c = parcelRequire("6XX9c");

const $a65491a041b5b4e0$var$cache = {};
const $a65491a041b5b4e0$var$cacheLimit = 10000;
let $a65491a041b5b4e0$var$cacheCount = 0;
function $a65491a041b5b4e0$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $a65491a041b5b4e0$var$cache[cacheKey] || ($a65491a041b5b4e0$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $6XX9c.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($a65491a041b5b4e0$var$cacheCount < $a65491a041b5b4e0$var$cacheLimit) {
        pathCache[path] = result;
        $a65491a041b5b4e0$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $a65491a041b5b4e0$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $a65491a041b5b4e0$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $a65491a041b5b4e0$export$2e2bcd8739ae039 = $a65491a041b5b4e0$var$matchPath;





/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $03bb44c31a936060$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, $eb3ax.default)({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $03bb44c31a936060$export$2e2bcd8739ae039 = $03bb44c31a936060$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $3a427a59380bdb41$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $3a427a59380bdb41$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $a65491a041b5b4e0$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $3a427a59380bdb41$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $03bb44c31a936060$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, $eb3ax.default)({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $3a427a59380bdb41$export$2e2bcd8739ae039 = $3a427a59380bdb41$var$execRouteMatching;


const $1b66ba6664274cb1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $1b66ba6664274cb1$var$MAX_CACHE_SIZE = 1000;
function $1b66ba6664274cb1$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$1b66ba6664274cb1$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $1b66ba6664274cb1$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($1b66ba6664274cb1$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $1b66ba6664274cb1$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $1b66ba6664274cb1$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $7dbc7cf12b42c499$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $4NiRC.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $1b66ba6664274cb1$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $3a427a59380bdb41$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $1b66ba6664274cb1$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $7dbc7cf12b42c499$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$7dbc7cf12b42c499$var$matchRoute(routes, pathname, queryParams, basePath);
const $7dbc7cf12b42c499$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $7dbc7cf12b42c499$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $7dbc7cf12b42c499$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$7dbc7cf12b42c499$var$matchRoute(routes, pathname, queryParams, basePath);
module.exports["warmupMatchRouteCache"] = $7dbc7cf12b42c499$export$4e76f1d455ef7c95;

});

parcelRegister("fHQWF", function(module, exports) {

var $4NiRC = parcelRequire("4NiRC");


var $3yk4a = parcelRequire("3yk4a");


var $fEoYr = parcelRequire("fEoYr");


var $aNi3F = parcelRequire("aNi3F");

const $b6f3f0fc046f7aa2$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $fEoYr.generatePath)(route.path, params);
    const matchedRoute = (0, $aNi3F.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $3yk4a.DEFAULT_MATCH),
        query: query
    };
};
const $b6f3f0fc046f7aa2$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $4NiRC.qs).parse(search);
    const matchedRoute = (0, $aNi3F.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $3yk4a.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $3yk4a.DEFAULT_MATCH)
    };
};
module.exports["createRouterContext"] = $b6f3f0fc046f7aa2$export$faed15f35ddc6f99;
module.exports["findRouterContext"] = $b6f3f0fc046f7aa2$export$a0bd0313cbeabd49;

});

parcelRegister("5l9sO", function(module, exports) {
const $3e364132720b27d6$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $3e364132720b27d6$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $3e364132720b27d6$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $3e364132720b27d6$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);
module.exports["isSameRouteMatch"] = $3e364132720b27d6$export$5997e70fc4543270;

});

parcelRegister("4C2bB", function(module, exports) {

var $jPvl5 = parcelRequire("jPvl5");

parcelRequire("fZ3NV");
var $fFk7n = parcelRequire("fFk7n");

const $35bc682839831bf6$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $35bc682839831bf6$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $jPvl5.getResourceStore)().actions;
    const nextResources = (0, $fFk7n.getResourcesForNextLocation)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $35bc682839831bf6$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $jPvl5.getResourceStore)().actions;
    const nextResources = (0, $fFk7n.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $35bc682839831bf6$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $jPvl5.getResourceStore)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $35bc682839831bf6$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $35bc682839831bf6$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $35bc682839831bf6$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $jPvl5.getResourceStore)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $jPvl5.getResourceStore)().actions;
            const nextResources = (0, $fFk7n.getResourcesForNextLocation)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $jPvl5.getResourceStore)().actions.getSafeData();
        }
    };
};

});

parcelRegister("c7RYO", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $2s5nZ = parcelRequire("2s5nZ");

const $8d4002c4c9333d5d$export$fee1a6213543bd78 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, resource: resource, options: options } = t0;
    const result = (0, $2s5nZ.useResource)(resource, options);
    let t1;
    if ($[0] !== children || $[1] !== result) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
        $[0] = children;
        $[1] = result;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ children: children, resource: resource, options: options })=>{
    const result = (0, $2s5nZ.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children(result));
};

});

parcelRegister("2s5nZ", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $cozmU = parcelRequire("cozmU");


var $kBr4q = parcelRequire("kBr4q");

parcelRequire("cvj4z");
var $kZkvy = parcelRequire("kZkvy");


var $jPvl5 = parcelRequire("jPvl5");

const $1c925fd4a4f4a47e$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $jPvl5.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $kZkvy.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $cozmU.useMemo)(()=>(0, $kBr4q.createHook)((0, $kZkvy.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $jPvl5.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $cozmU.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $cozmU.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $cozmU.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $cozmU.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $eb3ax.default)({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};
module.exports["useResource"] = $1c925fd4a4f4a47e$export$9f6abfd74295843b;

});

parcelRegister("bNqcK", function(module, exports) {

var $jPvl5 = parcelRequire("jPvl5");

const $896898fc64e230bd$export$dee7bf9fc0ff48c3 = (fn)=>(0, $jPvl5.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("jPvl5", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $1eVGO = parcelRequire("1eVGO");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

var $5GOpG = parcelRequire("5GOpG");

var $c6StJ = parcelRequire("c6StJ");

parcelRequire("bDcGz");
var $2kK4E = parcelRequire("2kK4E");




parcelRequire("fZ3NV");
var $abmiw = parcelRequire("abmiw");

const $d29544a1b182e469$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, $eb3ax.default)({}, slice) : (0, $abmiw.getDefaultStateSlice)();
};
const $d29544a1b182e469$export$6a0b1779210de0ee = (state)=>state.context;


parcelRequire("fZ3NV");
var $l6MXV = parcelRequire("l6MXV");
var $59XiK = parcelRequire("59XiK");
var $1hI4C = parcelRequire("1hI4C");
var $aezOD = parcelRequire("aezOD");
var $8PAPC = parcelRequire("8PAPC");
var $ejHIX = parcelRequire("ejHIX");
var $gTkjN = parcelRequire("gTkjN");
var $kNFFp = parcelRequire("kNFFp");
var $8MtAf = parcelRequire("8MtAf");
var $4q31l = parcelRequire("4q31l");
var $VL9K0 = parcelRequire("VL9K0");

const $e6fb1709e9cfaa9f$var$_excluded = [
    "context"
], $e6fb1709e9cfaa9f$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $e6fb1709e9cfaa9f$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $1hI4C.deleteResourceState)(type, key));
                dispatch((0, $l6MXV.executeForDependents)(resource, (dependentResource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $1hI4C.deleteResourceState)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, $1eVGO.default)(_getState, $e6fb1709e9cfaa9f$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $d29544a1b182e469$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, $eb3ax.default)({}, prevSlice, changes, {
                expiresAt: (0, $ejHIX.getExpiresAt)(maxAge),
                accessedAt: (0, $8PAPC.getAccessedAt)()
            });
            dispatch((0, $1hI4C.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $l6MXV.executeForDependents)(resource, (dependentResource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $1hI4C.getResourceState)(type, key));
            if (cached && (0, $gTkjN.shouldUseCache)(cached)) {
                if ((0, $gTkjN.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $kNFFp.setSsrDataPromise)(cached);
                    cached = (0, $ejHIX.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $8PAPC.getAccessedAt)();
                dispatch((0, $1hI4C.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $1hI4C.getResourceState)(type, key)) || (0, $abmiw.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $VL9K0.validateLRUCache)(resource, key));
            const loadingSlice = dispatch((0, $1hI4C.getPrefetchSlice)(type, key)) || (0, $59XiK.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $l6MXV.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $1hI4C.setResourceState)(type, key, (0, $eb3ax.default)({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $8PAPC.getAccessedAt)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $l6MXV.executeForDependents)(resource, (dependentResource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $8MtAf.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $1hI4C.getResourceState)(type, key));
            const finalSlice = (0, $eb3ax.default)({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $8PAPC.getAccessedAt)(),
                expiresAt: (0, $ejHIX.getExpiresAt)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $1hI4C.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $1hI4C.getPrefetchSlice)(type, key)) || (0, $59XiK.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $l6MXV.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $1hI4C.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $l6MXV.executeForDependents)(resource, (dependentResource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $e6fb1709e9cfaa9f$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $l6MXV.actionWithDependencies)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $e6fb1709e9cfaa9f$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $l6MXV.actionWithDependencies)(routerStoreContext.route.resources, resource, $e6fb1709e9cfaa9f$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $l6MXV.actionWithDependencies)(routerStoreContext.route.resources, resource, $e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $l6MXV.actionWithDependencies)(routerStoreContext.route.resources, resource, $e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($e6fb1709e9cfaa9f$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $1hI4C.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $1hI4C.deleteResourceState)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $2kK4E.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $l6MXV.mapActionWithDependencies)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $l6MXV.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$e6fb1709e9cfaa9f$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, $eb3ax.default)({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $4q31l.transformData)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, $1eVGO.default)(_ref, $e6fb1709e9cfaa9f$var$_excluded2);
                const deserializedError = !error ? null : (0, $aezOD.deserializeError)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, $eb3ax.default)({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $4q31l.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $aezOD.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $8MtAf.TimeoutError) ? loading : false
                }))
};
const $e6fb1709e9cfaa9f$export$94f50dade551bd01 = (0, $8s9DV.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $e6fb1709e9cfaa9f$export$e324594224ef24da,
    name: 'router-resources'
});
const $e6fb1709e9cfaa9f$export$cc90fb9c37c5589d = (0, $j8on0.createContainer)($e6fb1709e9cfaa9f$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $e6fb1709e9cfaa9f$export$fee1a6213543bd78 = (0, $5GOpG.createSubscriber)($e6fb1709e9cfaa9f$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $d29544a1b182e469$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $e6fb1709e9cfaa9f$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $c6StJ.defaultRegistry).getStore($e6fb1709e9cfaa9f$export$94f50dade551bd01);
const $e6fb1709e9cfaa9f$export$ac3608e0bb357c7 = (0, $kBr4q.createHook)($e6fb1709e9cfaa9f$export$94f50dade551bd01, {
    selector: (0, $d29544a1b182e469$export$c9ed509724feb827)
});
const $e6fb1709e9cfaa9f$export$98e41a62c9bef75e = (0, $kBr4q.createActionsHook)($e6fb1709e9cfaa9f$export$94f50dade551bd01);
const $e6fb1709e9cfaa9f$export$e59f52df235ac7b3 = (0, $kBr4q.createHook)($e6fb1709e9cfaa9f$export$94f50dade551bd01, {
    selector: (0, $d29544a1b182e469$export$6a0b1779210de0ee)
});
module.exports["getResourceStore"] = $e6fb1709e9cfaa9f$export$6f6057d42352becb;
module.exports["useResourceStore"] = $e6fb1709e9cfaa9f$export$ac3608e0bb357c7;
module.exports["useResourceStoreActions"] = $e6fb1709e9cfaa9f$export$98e41a62c9bef75e;

});

parcelRegister("gLGm7", function(module, exports) {
const $c351e41bf6b2ebd2$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};

});

parcelRegister("bv42K", function(module, exports) {
module.exports = new URL("GenericError.cd21964e.svg", import.meta.url).toString();

});

parcelRegister("8x1Nr", function(module, exports) {
module.exports = new URL("RestrictedError.e0fef1fb.svg", import.meta.url).toString();

});

parcelRegister("9tqV4", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kCECX = parcelRequire("kCECX");


var $eYg5X = parcelRequire("eYg5X");


var $bIp5p = parcelRequire("bIp5p");


var $6EuQn = parcelRequire("6EuQn");

const $10b126cdcdd7239e$var$UFOPRESS_EVENT = 'editor-config-panel-edit';
const $10b126cdcdd7239e$export$b3c1b53ec616df30 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (editorActions)=>{
    const $ = (0, $bDgLe.c)(8);
    const { setSelectedExtensionLocalId: setSelectedExtensionLocalId } = (0, $bIp5p.useExtensionsActions)();
    let t0;
    if ($[0] !== editorActions || $[1] !== setSelectedExtensionLocalId) {
        t0 = (localId)=>{
            if (!localId) return;
            const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
            const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
            const editorView = editorActions._privateGetEditorView();
            const selection = editorView?.state?.selection;
            if (selection instanceof (0, $kCECX.NodeSelection)) {
                if ((0, $6EuQn.ALLOWED_EXTENSIONS).includes(extensionType)) {
                    (0, $eYg5X.default)($10b126cdcdd7239e$var$UFOPRESS_EVENT);
                    setSelectedExtensionLocalId(localId);
                }
            } else {
                if (type !== "multiBodiedExtension" || !editorView?.state) return;
                let multiBodiedExtensionPosition = editorView.state.selection.from;
                editorView.state.tr.doc.descendants((node, pos)=>{
                    if (node.attrs?.localId === localId) {
                        multiBodiedExtensionPosition = pos;
                        return;
                    }
                });
                editorView.dispatch(editorView.state.tr?.setSelection?.((0, $kCECX.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
                if ((0, $6EuQn.ALLOWED_EXTENSIONS).includes(extensionType)) {
                    (0, $eYg5X.default)($10b126cdcdd7239e$var$UFOPRESS_EVENT);
                    setSelectedExtensionLocalId(localId);
                }
            }
            !!extensionKey && extensionType;
        };
        $[0] = editorActions;
        $[1] = setSelectedExtensionLocalId;
        $[2] = t0;
    } else t0 = $[2];
    const openConfigPanel = t0;
    let t1;
    if ($[3] !== setSelectedExtensionLocalId) {
        t1 = ()=>{
            setSelectedExtensionLocalId(null);
        };
        $[3] = setSelectedExtensionLocalId;
        $[4] = t1;
    } else t1 = $[4];
    const closeConfigPanel = t1;
    let t2;
    if ($[5] !== closeConfigPanel || $[6] !== openConfigPanel) {
        t2 = {
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel
        };
        $[5] = closeConfigPanel;
        $[6] = openConfigPanel;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (editorActions)=>{
    const { setSelectedExtensionLocalId: setSelectedExtensionLocalId } = (0, $bIp5p.useExtensionsActions)();
    const openConfigPanel = (0, $cozmU.useCallback)((localId)=>{
        if (!localId) return;
        const { attrs: attrs, type: type } = editorActions?.getNodeByLocalId(localId)?.toJSON() || {};
        const { extensionType: extensionType, extensionKey: extensionKey } = attrs || {};
        const editorView = editorActions._privateGetEditorView();
        const selection = editorView?.state?.selection;
        if (selection instanceof (0, $kCECX.NodeSelection)) {
            if ((0, $6EuQn.ALLOWED_EXTENSIONS).includes(extensionType)) {
                (0, $eYg5X.default)($10b126cdcdd7239e$var$UFOPRESS_EVENT);
                setSelectedExtensionLocalId(localId);
            }
        } else {
            if (type !== 'multiBodiedExtension' || !editorView?.state) return;
            // Handle MultiBodiedExtension config panel
            let multiBodiedExtensionPosition = editorView.state.selection.from;
            editorView.state.tr.doc.descendants((node, pos)=>{
                if (node.attrs?.localId === localId) {
                    multiBodiedExtensionPosition = pos;
                    return;
                }
            });
            editorView.dispatch(editorView.state.tr?.setSelection?.((0, $kCECX.NodeSelection).create(editorView.state.tr.doc, multiBodiedExtensionPosition)));
            if ((0, $6EuQn.ALLOWED_EXTENSIONS).includes(extensionType)) {
                (0, $eYg5X.default)($10b126cdcdd7239e$var$UFOPRESS_EVENT);
                setSelectedExtensionLocalId(localId);
            }
        }
        !!extensionKey && extensionType;
    }, [
        setSelectedExtensionLocalId,
        editorActions
    ]);
    const closeConfigPanel = (0, $cozmU.useCallback)(()=>{
        setSelectedExtensionLocalId(null);
    }, [
        setSelectedExtensionLocalId
    ]);
    return (0, $cozmU.useMemo)(()=>({
            openConfigPanel: openConfigPanel,
            closeConfigPanel: closeConfigPanel
        }), [
        openConfigPanel,
        closeConfigPanel
    ]);
};
module.exports["useHubEditorExtensionConfigPanel"] = $10b126cdcdd7239e$export$b3c1b53ec616df30;

});

parcelRegister("2VrNo", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $b8pma = parcelRequire("b8pma");


var $3eDML = parcelRequire("3eDML");


var $ame4Z = parcelRequire("ame4Z");


var $7oSFe = parcelRequire("7oSFe");


const $0e2973feb2ae067a$var$HubEditorConfigPanelLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy((0, $7oSFe.trackReactLazy)("rl-48h6Yt", ()=>(parcelRequire("6Cr27")).then((mod)=>({
            default: mod.HubEditorConfigPanel
        }))));
const $0e2973feb2ae067a$export$99ce0b7d4622b2b7 = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { localId: localId, closeConfigPanel: closeConfigPanel, contentId: contentId, editorActions: editorActions, editorApi: editorApi, propsProvider: propsProvider } = t0;
    if (localId) {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3eDML.GenericErrorPage), {});
            $[0] = t1;
        } else t1 = $[0];
        let t2;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b8pma.default), {
                name: "editor-config-panel-chunk-loader"
            });
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== closeConfigPanel || $[3] !== contentId || $[4] !== editorActions || $[5] !== editorApi || $[6] !== localId || $[7] !== propsProvider) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ame4Z.HubErrorBoundary), {
                id: "hub-editor-config-panel",
                packageName: "@atlassian/hub-editor-config-panel",
                fallback: t1,
                shouldForceError: true,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
                    fallback: t2,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)($0e2973feb2ae067a$var$HubEditorConfigPanelLazy, {
                        localId: localId,
                        closeConfigPanel: closeConfigPanel,
                        contentId: contentId,
                        editorActions: editorActions,
                        editorApi: editorApi,
                        propsProvider: propsProvider
                    })
                })
            });
            $[2] = closeConfigPanel;
            $[3] = contentId;
            $[4] = editorActions;
            $[5] = editorApi;
            $[6] = localId;
            $[7] = propsProvider;
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    return null;
} : ({ localId: localId, closeConfigPanel: closeConfigPanel, contentId: contentId, editorActions: editorActions, editorApi: editorApi, propsProvider: propsProvider })=>{
    if (localId) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ame4Z.HubErrorBoundary), {
        id: "hub-editor-config-panel",
        packageName: "@atlassian/hub-editor-config-panel",
        fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3eDML.GenericErrorPage), {}),
        shouldForceError: true,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $cozmU.Suspense), {
            fallback: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b8pma.default), {
                name: "editor-config-panel-chunk-loader"
            }),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)($0e2973feb2ae067a$var$HubEditorConfigPanelLazy, {
                localId: localId,
                closeConfigPanel: closeConfigPanel,
                contentId: contentId,
                editorActions: editorActions,
                editorApi: editorApi,
                propsProvider: propsProvider
            })
        })
    });
    return null;
}, (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg))));
module.exports["HubEditorConfigPanelEntryPoint"] = $0e2973feb2ae067a$export$99ce0b7d4622b2b7;

});

parcelRegister("8NddB", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $dOBRD = parcelRequire("dOBRD");


var $6RwwD = parcelRequire("6RwwD");


var $cDpdq = parcelRequire("cDpdq");

const $0e60b1a500b568da$export$2a89c15ccab17d33 = (0, $dOBRD.default)((product)=>{
    /**
   * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
   * (only supports Cloud single-issue URLs right now)
   */ const smartLinksBeforeMacros = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
    // Make smart links connect to staging when developing locally.
    const environment = undefined;
    const cardProvider = Promise.resolve(new (0, $6RwwD.EditorCardProvider)(environment, undefined, product));
    // IMPORTANT: If you change the code below, please also update the
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/pastePluginOptions.ts
    // platform/packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/cardPluginOptions.ts
    return {
        provider: cardProvider,
        resolveBeforeMacros: smartLinksBeforeMacros,
        allowBlockCards: true,
        allowEmbeds: true
    };
});
const $0e60b1a500b568da$export$5681a80d8b7b2bfb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (product)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== product) {
        t0 = $0e60b1a500b568da$export$2a89c15ccab17d33(product);
        $[0] = product;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (product)=>{
    return (0, $cozmU.useMemo)(()=>{
        return $0e60b1a500b568da$export$2a89c15ccab17d33(product);
    }, [
        product
    ]);
};
const $0e60b1a500b568da$export$535281304894bcdc = (0, $gtMdU.isReactCompilerActivePlatform)() ? (product, cardOptions)=>{
    const $ = (0, $bDgLe.c)(3);
    const baseSmartLinks = $0e60b1a500b568da$export$5681a80d8b7b2bfb(product);
    let t0;
    if ($[0] !== baseSmartLinks || $[1] !== cardOptions) {
        t0 = {
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        };
        $[0] = baseSmartLinks;
        $[1] = cardOptions;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : (product, cardOptions)=>{
    const baseSmartLinks = $0e60b1a500b568da$export$5681a80d8b7b2bfb(product);
    return (0, $cozmU.useMemo)(()=>({
            linking: {
                smartLinks: {
                    ...baseSmartLinks,
                    ...cardOptions
                }
            }
        }), [
        baseSmartLinks,
        cardOptions
    ]);
};
const $0e60b1a500b568da$export$78db118acf87bd21 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (product, options, cloudId, linkPickerOptions)=>{
    const $ = (0, $bDgLe.c)(15);
    const config = $0e60b1a500b568da$export$535281304894bcdc(product, options);
    let t0;
    if ($[0] !== cloudId || $[1] !== product) {
        t0 = {
            product: product,
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = product;
        $[2] = t0;
    } else t0 = $[2];
    const productConfig = t0;
    const linkPickerProps = (0, $cDpdq.useLinkPickerEditorProps)(undefined, productConfig);
    const linkPickerPlugins = linkPickerOptions?.linkPickerPlugins;
    const t1 = config.linking?.linkPicker;
    let t2;
    if ($[3] !== linkPickerPlugins) {
        t2 = linkPickerPlugins && {
            plugins: linkPickerPlugins
        };
        $[3] = linkPickerPlugins;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== linkPickerProps || $[6] !== t1 || $[7] !== t2) {
        t3 = {
            ...t1,
            ...linkPickerProps,
            ...t2
        };
        $[5] = linkPickerProps;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    const t4 = config.linking?.smartLinks;
    let t5;
    if ($[9] !== t4) {
        t5 = {
            ...t4
        };
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== config.linking || $[12] !== t3 || $[13] !== t5) {
        t6 = {
            linking: {
                ...config.linking,
                linkPicker: t3,
                smartLinks: t5
            }
        };
        $[11] = config.linking;
        $[12] = t3;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
} : (product, options, cloudId, linkPickerOptions)=>{
    const config = $0e60b1a500b568da$export$535281304894bcdc(product, options);
    const productConfig = (0, $cozmU.useMemo)(()=>({
            product: product,
            cloudId: cloudId
        }), [
        product,
        cloudId
    ]);
    const linkPickerProps = (0, $cDpdq.useLinkPickerEditorProps)(undefined, productConfig);
    const linkPickerPlugins = linkPickerOptions?.linkPickerPlugins;
    return (0, $cozmU.useMemo)(()=>({
            linking: {
                ...config.linking,
                linkPicker: {
                    ...config.linking?.linkPicker,
                    ...linkPickerProps,
                    ...linkPickerPlugins && {
                        plugins: linkPickerPlugins
                    }
                },
                smartLinks: {
                    ...config.linking?.smartLinks
                }
            }
        }), [
        config,
        linkPickerProps,
        linkPickerPlugins
    ]);
};
const $0e60b1a500b568da$export$9b0cf83b2bedfd63 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, options: options, cloudId: cloudId, product: t1, linkPickerOptions: linkPickerOptions } = t0;
    const product = t1 === undefined ? "CONFLUENCE" : t1;
    const mergedProps = $0e60b1a500b568da$export$78db118acf87bd21(product, options, cloudId, linkPickerOptions);
    let t2;
    if ($[0] !== children || $[1] !== mergedProps) {
        t2 = children(mergedProps);
        $[0] = children;
        $[1] = mergedProps;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children, options: options, cloudId: cloudId, product: product = 'CONFLUENCE', linkPickerOptions: linkPickerOptions })=>{
    const mergedProps = $0e60b1a500b568da$export$78db118acf87bd21(product, options, cloudId, linkPickerOptions);
    return children(mergedProps);
};
module.exports["EditorLinkingFeatures"] = $0e60b1a500b568da$export$9b0cf83b2bedfd63;

});

parcelRegister("kETeF", function(module, exports) {
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $1UWNP = parcelRequire("1UWNP");


var $kwzZh = parcelRequire("kwzZh");

const $832ae9c6f820540e$var$BASE_URL = '/gateway/api/emoji';
const $832ae9c6f820540e$var$getEmojiConfig = (cloudId, userId, disableUpload, emojiSSRConfig, emojiLoadCallbacks)=>{
    const currentUser = userId ? {
        id: userId
    } : undefined;
    const providers = [
        {
            url: `${$832ae9c6f820540e$var$BASE_URL}/standard`
        },
        {
            url: `${$832ae9c6f820540e$var$BASE_URL}/atlassian`
        }
    ];
    if (cloudId) providers.push({
        url: `${$832ae9c6f820540e$var$BASE_URL}/${cloudId}/site`
    });
    const config = {
        providers: providers,
        allowUpload: !!userId && !disableUpload,
        currentUser: currentUser,
        ...emojiLoadCallbacks || {}
    };
    if (emojiSSRConfig) return {
        ...config,
        ...emojiSSRConfig
    };
    return config;
};
const $832ae9c6f820540e$var$resolverOfMemoize = (extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? '';
    const disableUpload = extraConfig?.disableUpload ?? false;
    const emojiSSRConfigString = extraConfig?.emojiSSRConfig ? JSON.stringify(extraConfig.emojiSSRConfig) : '';
    return `${cloudId}_${userId}_${disableUpload}_${emojiSSRConfigString}`;
};
const $832ae9c6f820540e$var$getEmojiResource = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((extraConfig)=>{
    const cloudId = extraConfig?.cloudId ?? '';
    const userId = extraConfig?.userId ?? undefined;
    const disableUpload = extraConfig?.disableUpload;
    const emojiSSRConfig = extraConfig?.emojiSSRConfig ?? undefined;
    const emojiConfig = $832ae9c6f820540e$var$getEmojiConfig(cloudId, userId, disableUpload, emojiSSRConfig);
    return new (0, $kwzZh.default)(emojiConfig);
}, $832ae9c6f820540e$var$resolverOfMemoize);
const $832ae9c6f820540e$export$8210f5f78c0bcf27 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((extraConfig)=>{
    const emojiResource = $832ae9c6f820540e$var$getEmojiResource(extraConfig);
    return emojiResource.getEmojiProvider();
}, $832ae9c6f820540e$var$resolverOfMemoize);
module.exports["getEmojiProvider"] = $832ae9c6f820540e$export$8210f5f78c0bcf27;

});

parcelRegister("jcnIS", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3cB3o = parcelRequire("3cB3o");


var $FSvRW = parcelRequire("FSvRW");


var $4pfdN = parcelRequire("4pfdN");


var $4pBmf = parcelRequire("4pBmf");


var $hjUDQ = parcelRequire("hjUDQ");


var $6Rsxa = parcelRequire("6Rsxa");


var $6THkE = parcelRequire("6THkE");


var $87QCv = parcelRequire("87QCv");


var $aNrj7 = parcelRequire("aNrj7");


var $bm134 = parcelRequire("bm134");

const $0434f6981cf431fe$export$c7edf67c9c07ecac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(13);
    const { contentId: contentId, intl: intl, PropsProvider: PropsProvider, editorActions: editorActions, openConfigPanel: openConfigPanel } = props;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const [extensionProviders, setExtensionProviders] = (0, $cozmU.useState)(t0);
    const theming = (0, $4pBmf.useHubTheming)();
    const palette = theming?.isAdvancedThemingEnabled ? theming.palette : undefined;
    const isBrandPaletteLocked = theming?.isBrandPaletteLocked;
    const primaryColor = theming?.primaryColor;
    let t1;
    if ($[1] !== PropsProvider || $[2] !== contentId || $[3] !== editorActions || $[4] !== intl || $[5] !== isBrandPaletteLocked || $[6] !== openConfigPanel || $[7] !== palette || $[8] !== primaryColor) {
        t1 = async ()=>{
            const hubExtensionProviders = [];
            const defaultExtensionProviderProps = {
                contentId: contentId,
                propsProvider: PropsProvider,
                mode: (0, $hjUDQ.ExtensionMode).EDITOR,
                defaultParameters: (0, $4pfdN.getHubDefaultParameters)({
                    palette: palette,
                    isBrandPaletteLocked: isBrandPaletteLocked,
                    primaryColor: primaryColor
                })
            };
            const defaultExtensionInstanceProps = {
                editorActions: editorActions,
                openConfigPanel: openConfigPanel,
                intl: intl,
                contentId: contentId
            };
            try {
                const DEFAULT_EXTENSION_PROVIDERS = [
                    (0, $aNrj7.spotlightExtensionProvider),
                    (0, $6THkE.linksMenuExtensionProvider),
                    (0, $3cB3o.cardsExtensionProvider),
                    (0, $FSvRW.carouselExtensionProvider)
                ];
                DEFAULT_EXTENSION_PROVIDERS.forEach(async (extensionProvider)=>{
                    const providerInstance = await extensionProvider(defaultExtensionProviderProps);
                    const provider = await providerInstance(defaultExtensionInstanceProps);
                    hubExtensionProviders.push(provider);
                });
                const sectionExtProviderInstance = await (0, $87QCv.sectionExtensionProvider)({
                    ...defaultExtensionProviderProps,
                    defaultParameters: (0, $4pfdN.getHubDefaultParameters)({
                        palette: palette,
                        element: "section",
                        isBrandPaletteLocked: isBrandPaletteLocked,
                        primaryColor: primaryColor
                    }),
                    getSectionExtensionContents: $bm134.getSectionExtensionContents
                });
                const sectionExtProvider = await sectionExtProviderInstance(defaultExtensionInstanceProps);
                hubExtensionProviders.push(sectionExtProvider);
                const hubElementPlaceholderExtensionProviderInstance = await (0, $6Rsxa.hubElementPlaceholderExtensionProvider)(defaultExtensionInstanceProps);
                hubExtensionProviders.push(hubElementPlaceholderExtensionProviderInstance);
                setExtensionProviders(hubExtensionProviders);
            } catch (t2) {
                const error = t2;
            }
        };
        $[1] = PropsProvider;
        $[2] = contentId;
        $[3] = editorActions;
        $[4] = intl;
        $[5] = isBrandPaletteLocked;
        $[6] = openConfigPanel;
        $[7] = palette;
        $[8] = primaryColor;
        $[9] = t1;
    } else t1 = $[9];
    const loadProviders = t1;
    let t2;
    let t3;
    if ($[10] !== loadProviders) {
        t2 = ()=>{
            loadProviders();
        };
        t3 = [
            loadProviders
        ];
        $[10] = loadProviders;
        $[11] = t2;
        $[12] = t3;
    } else {
        t2 = $[11];
        t3 = $[12];
    }
    (0, $cozmU.useEffect)(t2, t3);
    return extensionProviders;
} : (props)=>{
    const { contentId: contentId, intl: intl, PropsProvider: PropsProvider, editorActions: editorActions, openConfigPanel: openConfigPanel } = props;
    const [extensionProviders, setExtensionProviders] = (0, $cozmU.useState)([]);
    // When advanced theming is enabled, seed new extension instances with
    // palette-backed default colors (e.g. var(--hub-color-primary-200)). Falls
    // back to legacy single-color defaults when the framework isn't mounted.
    const theming = (0, $4pBmf.useHubTheming)();
    const palette = theming?.isAdvancedThemingEnabled ? theming.palette : undefined;
    const isBrandPaletteLocked = theming?.isBrandPaletteLocked;
    const primaryColor = theming?.primaryColor;
    const loadProviders = (0, $cozmU.useCallback)(async ()=>{
        const hubExtensionProviders = [];
        const defaultExtensionProviderProps = {
            contentId: contentId,
            propsProvider: PropsProvider,
            mode: (0, $hjUDQ.ExtensionMode).EDITOR,
            defaultParameters: (0, $4pfdN.getHubDefaultParameters)({
                palette: palette,
                isBrandPaletteLocked: isBrandPaletteLocked,
                primaryColor: primaryColor
            })
        };
        const defaultExtensionInstanceProps = {
            editorActions: editorActions,
            openConfigPanel: openConfigPanel,
            intl: intl,
            contentId: contentId
        };
        try {
            const DEFAULT_EXTENSION_PROVIDERS = [
                (0, $aNrj7.spotlightExtensionProvider),
                (0, $6THkE.linksMenuExtensionProvider),
                (0, $3cB3o.cardsExtensionProvider),
                (0, $FSvRW.carouselExtensionProvider)
            ];
            DEFAULT_EXTENSION_PROVIDERS.forEach(async (extensionProvider)=>{
                const providerInstance = await extensionProvider(defaultExtensionProviderProps);
                const provider = await providerInstance(defaultExtensionInstanceProps);
                hubExtensionProviders.push(provider);
            });
            // section provider — uses the section-specific bg shade (accent.100)
            // when advanced theming is on; otherwise inherits the generic seed.
            const sectionExtProviderInstance = await (0, $87QCv.sectionExtensionProvider)({
                ...defaultExtensionProviderProps,
                defaultParameters: (0, $4pfdN.getHubDefaultParameters)({
                    palette: palette,
                    element: 'section',
                    isBrandPaletteLocked: isBrandPaletteLocked,
                    primaryColor: primaryColor
                }),
                getSectionExtensionContents: $bm134.getSectionExtensionContents
            });
            const sectionExtProvider = await sectionExtProviderInstance(defaultExtensionInstanceProps);
            hubExtensionProviders.push(sectionExtProvider);
            const hubElementPlaceholderExtensionProviderInstance = await (0, $6Rsxa.hubElementPlaceholderExtensionProvider)(defaultExtensionInstanceProps);
            hubExtensionProviders.push(hubElementPlaceholderExtensionProviderInstance);
            setExtensionProviders(hubExtensionProviders);
        } catch (error) {
        // todo: log error to analytics
        }
    }, [
        editorActions,
        openConfigPanel,
        intl,
        PropsProvider,
        contentId,
        palette,
        isBrandPaletteLocked,
        primaryColor
    ]);
    (0, $cozmU.useEffect)(()=>{
        loadProviders();
    }, [
        loadProviders
    ]);
    return extensionProviders;
};
module.exports["useHubExtensionProviders"] = $0434f6981cf431fe$export$c7edf67c9c07ecac;

});

parcelRegister("fXxXz", function(module, exports) {
const $2121ccb7c28b974f$export$c5dfd3b79761d51f = {
    allowDatasource: true
};
const $2121ccb7c28b974f$export$71250061dd993259 = true;
module.exports["LINKING_FEATURES_CARD_OPTIONS"] = $2121ccb7c28b974f$export$c5dfd3b79761d51f;
module.exports["IS_UPLOAD_MEDIA_CONFIG_REQUIRED"] = $2121ccb7c28b974f$export$71250061dd993259;

});

parcelRegister("9YzZs", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $jkcNT = parcelRequire("jkcNT");


var $aMXsk = parcelRequire("aMXsk");

function $8fd9040868868fa3$export$3f6a2f4541d2f102(props) {
    const { intl: intl, mediaOptions: mediaOptions, linkPickerOptions: linkPickerOptions, featureFlags: featureFlags, isEditingLocked: isEditingLocked } = props;
    const isTemplateLocked = Boolean(props.isTemplateLocked);
    const __livePage = false;
    // const editorPluginAIOptions = createPageEditorPluginAIOptions({
    // 	product,
    // 	aiGlobalOptIn: { status: 'disabled', triggerOptInFlow: () => { } },
    // 	PromptEditor: createPromptEditor({
    // 		enableLinks: false,
    // 		linking: {
    // 			smartLinks: { provider: undefined },
    // 		},
    // 		mentionProvider: undefined,
    // 		featureFlags: {},
    // 	}),
    // 	isRovoEnabled: false,
    // });
    return (0, $aMXsk.hubPreset)({
        intl: intl,
        pluginOptions: {
            base: {
                __livePage: __livePage
            },
            helpDialog: {
                imageUploadProviderExists: Boolean(mediaOptions?.provider),
                aiEnabled: false
            },
            hyperlink: {
                linkPicker: {
                    plugins: linkPickerOptions?.linkPickerPlugins || []
                },
                onClickCallback: undefined
            },
            quickInsert: {
                emptyStateHandler: undefined,
                quickInsert: props.quickInsert,
                isTemplateLocked: isTemplateLocked
            },
            placeholder: {
                viewMode: props.viewMode,
                isAIEnabled: false
            },
            selection: {
                __livePage: __livePage
            },
            editorDisabled: {
                disabled: isEditingLocked || undefined
            },
            annotation: {
                annotationManager: undefined,
                createCommentExperience: undefined,
                selectCommentExperience: undefined,
                viewInlineCommentTraceUFOPress: undefined
            },
            tasksAndDecisions: {
                hasEditPermission: props.hasEditPermission,
                requestToEditContent: undefined,
                hasRequestedEditPermission: undefined
            },
            contextPanel: props.contextPanelOptions ? {
                objectSideBar: props.contextPanelOptions.objectSideBar
            } : undefined,
            extension: {
                appearance: props.appearance === 'max' ? 'max' : 'full-page',
                extensionHandlers: props.extensionHandlers,
                __rendererExtensionOptions: props.__rendererExtensionOptions,
                getExtensionHeight: props.getExtensionHeight,
                isTemplateLocked: isTemplateLocked
            },
            card: {
                __livePage: __livePage,
                linkPicker: props.linking?.linkPicker,
                onClickCallback: props.linking?.smartLinks?.onClickCallback
            },
            avatarGroup: {
                collabEdit: undefined
            },
            // ai: editorPluginAIOptions,
            loom: {
                renderButton: ()=>null
            },
            editorViewMode: {
                viewMode: props.viewMode
            },
            // aiDefinitions: props.editorPluginAIDefinitionsConfig,
            selectionMarker: {
                __livePage: __livePage
            },
            engagementPlatform: {
                coordinationClient: {
                    start: ()=>Promise.resolve(false),
                    stop: ()=>Promise.resolve(false)
                }
            },
            selectionExtension: {},
            metrics: {},
            primaryToolbar: {
                contextualFormattingEnabled: true
            },
            selectionToolbar: {
                contextualFormattingEnabled: true
            }
        },
        providers: {
            userPreferencesProvider: props.userPreferencesProvider,
            userPreferencesProviderNext: props.userPreferencesProviderNext,
            cardProvider: props.linking?.smartLinks?.provider,
            contextIdentifierProvider: props.contextIdentifierProvider,
            inlineCommentAnnotationProvider: props.annotationProviders?.inlineComment,
            mediaProvider: mediaOptions?.provider,
            syncMediaProvider: props.media?.syncProvider,
            mentionProvider: props.mentionProvider,
            profilecardProvider: props.mention?.profilecardProvider,
            emojiProvider: props.emojiProvider,
            autoformattingProvider: props.autoformattingProvider,
            taskDecisionProvider: props.taskDecisionProvider
        },
        enabledOptionalPlugins: {
            // Must stay on when locked: dropping it makes `areToolbarFlagsEnabled`
            // false, which downgrades the editor to legacy chrome and renders a full
            // primary toolbar at the top.
            toolbar: true,
            // A locked template has no drag handles to reorder with and no insert
            // menu to add from; the guard plugin refuses both anyway.
            blockControls: !isTemplateLocked,
            insertBlock: !isTemplateLocked,
            hubTemplateLock: isTemplateLocked,
            findReplace: Boolean(props.allowFindReplace),
            loom: props.isLoomPluginEnabled,
            aiDefinitions: props.editorPluginAIDefinitionsEnabled,
            connectivity: props.isDesktop,
            metrics: (0, $iDrrr.fg)('platform_editor_ease_of_use_metrics'),
            codeBlockAdvanced: true,
            selectionExtension: (0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: true
            }),
            // aiExperience: Boolean(props.editorPluginAIOptions?.aiGlobalOptIn?.status !== 'disabled'),
            interaction: true,
            userPreferences: true,
            companyHubTextColor: props.editorPluginHubTextColorEnabled ?? false,
            // This plugin provides support for showing an indicator when we drag and drop components from components panel
            hubExternalInsert: featureFlags?.hub_editor_floating_toolbar ?? false
        }
    });
}
module.exports["createHubEditorPreset"] = $8fd9040868868fa3$export$3f6a2f4541d2f102;

});

parcelRegister("2rwbd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $r8hvx = parcelRequire("r8hvx");


var $fXxXz = parcelRequire("fXxXz");

const $9fce710bde60562d$export$74fedad14355d824 = ({ contentId: contentId, editorAPI: editorAPI, customMediaProvider: customMediaProvider, mediaConfig: mediaConfig })=>{
    const resolver = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        if (!contentId) return;
        const createMediaProvider = ()=>{
            return (0, $r8hvx.getMediaProvider)(mediaConfig?.mediaCollectionName ?? '', mediaConfig?.asapIssuer ?? '', mediaConfig?.mediaToken ?? '', mediaConfig?.mediaUrl ?? '', (0, $fXxXz.IS_UPLOAD_MEDIA_CONFIG_REQUIRED));
        };
        const mediaProvider = createMediaProvider();
        if (mediaProvider) {
            if (editorAPI?.media?.actions) editorAPI.media.actions.setProvider(Promise.resolve(mediaProvider));
            if (resolver.current) resolver.current(mediaProvider);
        }
    }, [
        contentId,
        mediaConfig,
        editorAPI
    ]);
    return (0, $cozmU.useMemo)(()=>{
        const provider = customMediaProvider ?? new Promise((resolve)=>{
            resolver.current = resolve;
        });
        return {
            provider: provider,
            allowMediaSingle: true,
            allowMediaGroup: true,
            allowResizing: true,
            allowLinking: true,
            allowResizingInTables: true,
            allowAltTextOnImages: true,
            allowMediaSingleEditable: true,
            allowRemoteDimensionsFetch: true,
            allowCaptions: true,
            allowLazyLoading: true,
            allowAdvancedToolBarOptions: true,
            allowDropzoneDropLine: true,
            allowTemplatePlaceholders: true,
            featureFlags: {}
        };
    }, [
        customMediaProvider
    ]);
};
module.exports["useMediaOptions"] = $9fce710bde60562d$export$74fedad14355d824;

});

parcelRegister("8XweJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $848606140a75633f$var$_default_1 = (0, $kSwu1.defineMessages)({
    hubStudioLoadingSpinnerLabel: {
        id: "hub-editor.loading-spinner-label",
        defaultMessage: "Loading hub"
    }
});
var $848606140a75633f$export$2e2bcd8739ae039 = $848606140a75633f$var$_default_1;
module.exports["default"] = $848606140a75633f$export$2e2bcd8739ae039;

});

parcelRegister("ayVUo", function(module, exports) {
const $7b09ffcb6b77a96c$export$881d135f98d8d7d0 = 100;
const $7b09ffcb6b77a96c$export$9ab5bdcb8a1d6c34 = false;
const $7b09ffcb6b77a96c$export$12c1dc38ea1692da = 0;
module.exports["DEFAULT_CACHE_MAX_LIMIT"] = $7b09ffcb6b77a96c$export$881d135f98d8d7d0;
module.exports["DEFAULT_RESOURCE_BROWSER_ONLY"] = $7b09ffcb6b77a96c$export$9ab5bdcb8a1d6c34;
module.exports["DEFAULT_RESOURCE_MAX_AGE"] = $7b09ffcb6b77a96c$export$12c1dc38ea1692da;

});

parcelRegister("cK9FA", function(module, exports) {
const $947148201ec260dc$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $947148201ec260dc$export$855ece989b15eb57 = (type)=>$947148201ec260dc$var$VALID_LINK_TYPES.includes(type) ? type : 'a';
module.exports["getValidLinkType"] = $947148201ec260dc$export$855ece989b15eb57;

});

parcelRegister("bHq0V", function(module, exports) {
const $d4fc30302334d642$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $d4fc30302334d642$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $8847e3ab0aa88b0e$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $d4fc30302334d642$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $d4fc30302334d642$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $d4fc30302334d642$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};
module.exports["handleNavigation"] = $8847e3ab0aa88b0e$export$706ad1af8096e280;

});

parcelRegister("8PAPC", function(module, exports) {
const $66dfa8208bd42e69$export$9ccb639b7a119f61 = ()=>Date.now();
module.exports["getAccessedAt"] = $66dfa8208bd42e69$export$9ccb639b7a119f61;

});

parcelRegister("59XiK", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $gD7r0 = parcelRequire("gD7r0");


var $ejHIX = parcelRequire("ejHIX");


var $9ou2L = parcelRequire("9ou2L");


var $8MtAf = parcelRequire("8MtAf");

const $5fd15fe2b7c3d3e5$export$37d3126be6549b13 = 10000;


function $3c1bcb0519a04560$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, $eb3ax.default)({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $9ou2L.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $8MtAf.TimeoutError)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $ejHIX.getExpiresAt)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $gD7r0.DEFAULT_RESOURCE_MAX_AGE));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $ejHIX.getExpiresAt)((0, $5fd15fe2b7c3d3e5$export$37d3126be6549b13))) : resourceMaxAge
    };
}
module.exports["createLoadingSlice"] = $3c1bcb0519a04560$export$dc62515c8f0b52dd;

});

parcelRegister("kP3dg", function(module, exports) {

var $gD7r0 = parcelRequire("gD7r0");

/**
 * Utility method to created async versions of getData functions
 */ const $f28b101a533d77cb$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $f28b101a533d77cb$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $f28b101a533d77cb$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $gD7r0.DEFAULT_RESOURCE_MAX_AGE),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $gD7r0.DEFAULT_CACHE_MAX_LIMIT),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $gD7r0.DEFAULT_RESOURCE_BROWSER_ONLY),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};

});

parcelRegister("l6MXV", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $abmiw = parcelRequire("abmiw");


var $1hI4C = parcelRequire("1hI4C");

var $f5e02408fa722745$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $f5e02408fa722745$var$fromEntries = ($f5e02408fa722745$var$_Object$fromEntries = Object.fromEntries) != null ? $f5e02408fa722745$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $f5e02408fa722745$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $f5e02408fa722745$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $f5e02408fa722745$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($f5e02408fa722745$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($f5e02408fa722745$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($f5e02408fa722745$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $f5e02408fa722745$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($f5e02408fa722745$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $f5e02408fa722745$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$f5e02408fa722745$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $f5e02408fa722745$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($f5e02408fa722745$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $f5e02408fa722745$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($f5e02408fa722745$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $f5e02408fa722745$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($f5e02408fa722745$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $f5e02408fa722745$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $f5e02408fa722745$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $f5e02408fa722745$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $1hI4C.getResourceState)(dependencyType, key)) || (0, $abmiw.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $1hI4C.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, $eb3ax.default)({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };
module.exports["actionWithDependencies"] = $f5e02408fa722745$export$5f7e1fd85734e71e;
module.exports["mapActionWithDependencies"] = $f5e02408fa722745$export$f71a65c89c987a02;
module.exports["executeForDependents"] = $f5e02408fa722745$export$7d1ffac63c68405d;
module.exports["getDependencies"] = $f5e02408fa722745$export$75915f81f2a6540a;

});

parcelRegister("ejHIX", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $a6c4c1bc3da909d9$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $a6c4c1bc3da909d9$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, $eb3ax.default)({}, slice, {
        expiresAt: $a6c4c1bc3da909d9$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;
module.exports["getExpiresAt"] = $a6c4c1bc3da909d9$export$b65d7ba7fbf150f1;
module.exports["setExpiresAt"] = $a6c4c1bc3da909d9$export$18d1d420fd588368;

});

parcelRegister("9ou2L", function(module, exports) {
const $6d6da8f737e3708e$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};
module.exports["generateTimeGuard"] = $6d6da8f737e3708e$export$58634b3a58ae66b7;

});

parcelRegister("abmiw", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");


var $8PAPC = parcelRequire("8PAPC");


var $gD7r0 = parcelRequire("gD7r0");


var $ejHIX = parcelRequire("ejHIX");

/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $22fab916b9fbd836$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $769c3a586f674cb6$export$fa8e33c3301e2e94 = ()=>(0, $eb3ax.default)({}, (0, $22fab916b9fbd836$export$2df85a734ff5ed27), {
        expiresAt: (0, $ejHIX.getExpiresAt)((0, $gD7r0.DEFAULT_RESOURCE_MAX_AGE)),
        accessedAt: (0, $8PAPC.getAccessedAt)()
    });
module.exports["getDefaultStateSlice"] = $769c3a586f674cb6$export$fa8e33c3301e2e94;

});

parcelRegister("k6a2t", function(module, exports) {
const $ea1c27b821238263$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $ea1c27b821238263$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$ea1c27b821238263$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));
module.exports["getResourceIdentifier"] = $ea1c27b821238263$export$c616b176adf9ad4a;
module.exports["getResourceIdentifiers"] = $ea1c27b821238263$export$cd7fbe7e979df558;

});

parcelRegister("fFk7n", function(module, exports) {

var $k6a2t = parcelRequire("k6a2t");


var $904MU = parcelRequire("904MU");

const $b67a4a5ddb48e53d$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $904MU.routeHasResources)(nextRoute)) return [];
    if ((0, $904MU.routeHasChanged)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $k6a2t.getResourceIdentifiers)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $k6a2t.getResourceIdentifier)(resource, nextRouterStoreContext, resourceStoreContext)));
};
module.exports["getResourcesForNextLocation"] = $b67a4a5ddb48e53d$export$7cbbc763e2f3d65d;

});

parcelRegister("VL9K0", function(module, exports) {

var $1hI4C = parcelRequire("1hI4C");

const $0ad9e73537d91699$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $0ad9e73537d91699$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $0ad9e73537d91699$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $0ad9e73537d91699$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $0ad9e73537d91699$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $1hI4C.deleteResourceState)(type, keyTobeDeleted));
    };
module.exports["validateLRUCache"] = $0ad9e73537d91699$export$89440b7623c2c75c;

});

parcelRegister("1hI4C", function(module, exports) {

var $1eVGO = parcelRequire("1eVGO");


var $eb3ax = parcelRequire("eb3ax");

function $0ef9910bed54f85b$var$_toPropertyKey(t) {
    var i = $0ef9910bed54f85b$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $0ef9910bed54f85b$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $0ef9910bed54f85b$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $0ef9910bed54f85b$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, $eb3ax.default)({}, prefetching, {
                [type]: (0, $eb3ax.default)({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $0ef9910bed54f85b$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($0ef9910bed54f85b$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, $eb3ax.default)({}, data, {
                [type]: (0, $eb3ax.default)({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $0ef9910bed54f85b$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $0ef9910bed54f85b$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, $1eVGO.default)(data, [
            type
        ].map($0ef9910bed54f85b$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, $1eVGO.default)(resourceForType, [
                key
            ].map($0ef9910bed54f85b$var$_toPropertyKey));
            setState({
                data: (0, $eb3ax.default)({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };
module.exports["getPrefetchSlice"] = $0ef9910bed54f85b$export$11374758be89e40;
module.exports["setPrefetchSlice"] = $0ef9910bed54f85b$export$1e32615dc8354436;
module.exports["setResourceState"] = $0ef9910bed54f85b$export$704f800f263b050e;
module.exports["getResourceState"] = $0ef9910bed54f85b$export$5fc90c33b03fffb;
module.exports["deleteResourceState"] = $0ef9910bed54f85b$export$d40f35dc5952864b;

});

parcelRegister("904MU", function(module, exports) {
const $68d7d3e5e57e90ba$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $68d7d3e5e57e90ba$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;
module.exports["routeHasResources"] = $68d7d3e5e57e90ba$export$740886389191c640;
module.exports["routeHasChanged"] = $68d7d3e5e57e90ba$export$221027ff1aa38f82;

});

parcelRegister("aezOD", function(module, exports) {
// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $7736fe6ff412453e$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $7736fe6ff412453e$var$NonError);
    }
}
const $7736fe6ff412453e$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $7736fe6ff412453e$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $7736fe6ff412453e$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $7736fe6ff412453e$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $7736fe6ff412453e$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $7736fe6ff412453e$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $7736fe6ff412453e$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $7736fe6ff412453e$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $7736fe6ff412453e$var$NonError(value);
};
module.exports["serializeError"] = $7736fe6ff412453e$export$46ff38bc6bdea8fb;
module.exports["deserializeError"] = $7736fe6ff412453e$export$64cddc1e268e9046;

});

parcelRegister("gTkjN", function(module, exports) {
const $c4c18b33346fd9e9$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $c4c18b33346fd9e9$var$isFresh = (resource)=>{
    if ($c4c18b33346fd9e9$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $c4c18b33346fd9e9$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($c4c18b33346fd9e9$var$isFresh(resource)) return true;
    return false;
};
module.exports["isFromSsr"] = $c4c18b33346fd9e9$export$b25d2963b8a3488a;
module.exports["shouldUseCache"] = $c4c18b33346fd9e9$export$399de8c43d0ece3c;

});

parcelRegister("kNFFp", function(module, exports) {

var $eb3ax = parcelRequire("eb3ax");

const $f248b4707601a448$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, $eb3ax.default)({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;
module.exports["setSsrDataPromise"] = $f248b4707601a448$export$2e4da1b414980956;

});

parcelRegister("8MtAf", function(module, exports) {
class $01a659d301bc04d7$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}
module.exports["TimeoutError"] = $01a659d301bc04d7$export$66d311bf29d5c89c;

});

parcelRegister("4q31l", function(module, exports) {
const $337beefdcf0a29ac$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});
module.exports["transformData"] = $337beefdcf0a29ac$export$3ceb62baab058c6b;

});

parcelRegister("fZ3NV", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => (parcelRequire("8PAPC")).getAccessedAt);
$parcel$export(module.exports, "createLoadingSlice", () => (parcelRequire("59XiK")).createLoadingSlice);
$parcel$export(module.exports, "actionWithDependencies", () => (parcelRequire("l6MXV")).actionWithDependencies);
$parcel$export(module.exports, "mapActionWithDependencies", () => (parcelRequire("l6MXV")).mapActionWithDependencies);
$parcel$export(module.exports, "executeForDependents", () => (parcelRequire("l6MXV")).executeForDependents);
$parcel$export(module.exports, "getDependencies", () => (parcelRequire("l6MXV")).getDependencies);
$parcel$export(module.exports, "getExpiresAt", () => (parcelRequire("ejHIX")).getExpiresAt);
$parcel$export(module.exports, "setExpiresAt", () => (parcelRequire("ejHIX")).setExpiresAt);
$parcel$export(module.exports, "getDefaultStateSlice", () => (parcelRequire("abmiw")).getDefaultStateSlice);
$parcel$export(module.exports, "getResourcesForNextLocation", () => (parcelRequire("fFk7n")).getResourcesForNextLocation);
$parcel$export(module.exports, "validateLRUCache", () => (parcelRequire("VL9K0")).validateLRUCache);
$parcel$export(module.exports, "deleteResourceState", () => (parcelRequire("1hI4C")).deleteResourceState);
$parcel$export(module.exports, "getResourceState", () => (parcelRequire("1hI4C")).getResourceState);
$parcel$export(module.exports, "setResourceState", () => (parcelRequire("1hI4C")).setResourceState);
$parcel$export(module.exports, "getPrefetchSlice", () => (parcelRequire("1hI4C")).getPrefetchSlice);
$parcel$export(module.exports, "setPrefetchSlice", () => (parcelRequire("1hI4C")).setPrefetchSlice);
$parcel$export(module.exports, "serializeError", () => (parcelRequire("aezOD")).serializeError);
$parcel$export(module.exports, "deserializeError", () => (parcelRequire("aezOD")).deserializeError);
$parcel$export(module.exports, "shouldUseCache", () => (parcelRequire("gTkjN")).shouldUseCache);
$parcel$export(module.exports, "isFromSsr", () => (parcelRequire("gTkjN")).isFromSsr);
$parcel$export(module.exports, "setSsrDataPromise", () => (parcelRequire("kNFFp")).setSsrDataPromise);
$parcel$export(module.exports, "TimeoutError", () => (parcelRequire("8MtAf")).TimeoutError);
$parcel$export(module.exports, "transformData", () => (parcelRequire("4q31l")).transformData);

var $8PAPC = parcelRequire("8PAPC");


var $59XiK = parcelRequire("59XiK");


var $kP3dg = parcelRequire("kP3dg");


var $l6MXV = parcelRequire("l6MXV");


var $ejHIX = parcelRequire("ejHIX");


var $9ou2L = parcelRequire("9ou2L");


var $abmiw = parcelRequire("abmiw");


var $k6a2t = parcelRequire("k6a2t");


var $fFk7n = parcelRequire("fFk7n");


var $VL9K0 = parcelRequire("VL9K0");


var $1hI4C = parcelRequire("1hI4C");


var $904MU = parcelRequire("904MU");


var $aezOD = parcelRequire("aezOD");


var $gTkjN = parcelRequire("gTkjN");


var $kNFFp = parcelRequire("kNFFp");


var $8MtAf = parcelRequire("8MtAf");


var $4q31l = parcelRequire("4q31l");


});

parcelRegister("6EuQn", function(module, exports) {

var $dBD3L = parcelRequire("dBD3L");


var $gXR7h = parcelRequire("gXR7h");


var $5KWZf = parcelRequire("5KWZf");


var $KDPGa = parcelRequire("KDPGa");


var $5w0mC = parcelRequire("5w0mC");


var $9MYUp = parcelRequire("9MYUp");


var $239dQ = parcelRequire("239dQ");


var $1ovy4 = parcelRequire("1ovy4");


var $bQmwQ = parcelRequire("bQmwQ");


var $6Q9UP = parcelRequire("6Q9UP");

const $bb26d5a7514740fd$export$fe220054b070cbc4 = [
    (0, $9MYUp.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE),
    (0, $5KWZf.SPOTLIGHT_EXTENSION_TYPE),
    (0, $dBD3L.CARDS_EXTENSION_TYPE),
    (0, $bQmwQ.LINKS_MENU_EXTENSION_TYPE),
    (0, $5KWZf.SECTION_EXTENSION_TYPE),
    (0, $KDPGa.SEARCH_EXTENSION_TYPE),
    (0, $gXR7h.carouselExtensionType),
    (0, $5KWZf.RESOURCE_TILES_EXTENSION_TYPE),
    (0, $6Q9UP.CALLOUT_BANNER_EXTENSION_TYPE),
    (0, $1ovy4.JSM_HELP_EXTENSION_TYPE),
    (0, $239dQ.HUB_FORGE_EXTENSION_TYPE),
    (0, $5w0mC.HUB_CONNECT_EXTENSION_TYPE)
];
module.exports["ALLOWED_EXTENSIONS"] = $bb26d5a7514740fd$export$fe220054b070cbc4;

});

parcelRegister("aMXsk", function(module, exports) {

var $a31lS = parcelRequire("a31lS");


var $7eCZG = parcelRequire("7eCZG");


var $dYbu7 = parcelRequire("dYbu7");


var $1CaNG = parcelRequire("1CaNG");


var $gLxaI = parcelRequire("gLxaI");


var $60Pfj = parcelRequire("60Pfj");


var $7Upsh = parcelRequire("7Upsh");


var $cX2jD = parcelRequire("cX2jD");


var $lK9Pz = parcelRequire("lK9Pz");


var $dHFAY = parcelRequire("dHFAY");


var $fKdaf = parcelRequire("fKdaf");


var $9ki8I = parcelRequire("9ki8I");


var $fLS6B = parcelRequire("fLS6B");


var $cud1R = parcelRequire("cud1R");


var $40ukF = parcelRequire("40ukF");


var $5VZEy = parcelRequire("5VZEy");


var $ifkCZ = parcelRequire("ifkCZ");


var $kaUwk = parcelRequire("kaUwk");


var $51qBv = parcelRequire("51qBv");


var $bkj40 = parcelRequire("bkj40");


var $e6Dq9 = parcelRequire("e6Dq9");


var $e4SgJ = parcelRequire("e4SgJ");


var $8PVlW = parcelRequire("8PVlW");


var $lDJPY = parcelRequire("lDJPY");


var $l5MIu = parcelRequire("l5MIu");


var $1ZhW4 = parcelRequire("1ZhW4");


var $f2WDp = parcelRequire("f2WDp");


var $7gk7g = parcelRequire("7gk7g");


var $4y9hw = parcelRequire("4y9hw");


var $2QN3e = parcelRequire("2QN3e");


var $e273U = parcelRequire("e273U");


var $iFdOW = parcelRequire("iFdOW");


var $k7vUa = parcelRequire("k7vUa");


var $47YIB = parcelRequire("47YIB");


var $k8SUN = parcelRequire("k8SUN");


var $3gmKQ = parcelRequire("3gmKQ");


var $h0KOi = parcelRequire("h0KOi");


var $dGnqc = parcelRequire("dGnqc");


var $5tMpU = parcelRequire("5tMpU");


var $4Kyof = parcelRequire("4Kyof");


var $7iL2d = parcelRequire("7iL2d");


var $iVGec = parcelRequire("iVGec");


var $eHllO = parcelRequire("eHllO");


var $laiso = parcelRequire("laiso");


var $1U7Jq = parcelRequire("1U7Jq");


var $6WRJZ = parcelRequire("6WRJZ");


var $3HCXM = parcelRequire("3HCXM");


var $HGu9Y = parcelRequire("HGu9Y");


var $5HQgD = parcelRequire("5HQgD");


var $jT02V = parcelRequire("jT02V");


var $4exuQ = parcelRequire("4exuQ");


var $hFvHs = parcelRequire("hFvHs");


var $jdplc = parcelRequire("jdplc");


var $7gEjc = parcelRequire("7gEjc");


var $5bzSg = parcelRequire("5bzSg");


var $4OMM6 = parcelRequire("4OMM6");


var $jeuMk = parcelRequire("jeuMk");


var $4Bdub = parcelRequire("4Bdub");


var $hYOOW = parcelRequire("hYOOW");


var $1K7sQ = parcelRequire("1K7sQ");


var $f3DNZ = parcelRequire("f3DNZ");


var $hBGxo = parcelRequire("hBGxo");


var $hHtwA = parcelRequire("hHtwA");


var $2hEu6 = parcelRequire("2hEu6");


var $3VDvd = parcelRequire("3VDvd");


var $dvcAA = parcelRequire("dvcAA");


var $3RHCI = parcelRequire("3RHCI");


var $dxDD9 = parcelRequire("dxDD9");


var $fb3SZ = parcelRequire("fb3SZ");


var $drevR = parcelRequire("drevR");


var $ljXAk = parcelRequire("ljXAk");


var $gUZEQ = parcelRequire("gUZEQ");


var $jIG3b = parcelRequire("jIG3b");


var $gkbos = parcelRequire("gkbos");


var $grjTL = parcelRequire("grjTL");


var $1171P = parcelRequire("1171P");


var $4gNvG = parcelRequire("4gNvG");


var $d1HsG = parcelRequire("d1HsG");


var $ctVsO = parcelRequire("ctVsO");


var $abOD2 = parcelRequire("abOD2");


var $cjuKO = parcelRequire("cjuKO");


var $4lpx1 = parcelRequire("4lpx1");


var $5C5Mq = parcelRequire("5C5Mq");


var $lfQQe = parcelRequire("lfQQe");


var $7Krw2 = parcelRequire("7Krw2");


var $7s1mJ = parcelRequire("7s1mJ");


var $lWQ1U = parcelRequire("lWQ1U");


var $771jm = parcelRequire("771jm");


var $ekz2H = parcelRequire("ekz2H");


var $apdxZ = parcelRequire("apdxZ");


var $e9gyG = parcelRequire("e9gyG");


var $6vkVa = parcelRequire("6vkVa");


var $8cJvF = parcelRequire("8cJvF");


var $iaIX4 = parcelRequire("iaIX4");


var $2X43x = parcelRequire("2X43x");


var $50Cc6 = parcelRequire("50Cc6");


var $ggRZd = parcelRequire("ggRZd");


var $6UNH9 = parcelRequire("6UNH9");


var $7iKiU = parcelRequire("7iKiU");


var $8PiK3 = parcelRequire("8PiK3");


var $e6aYN = parcelRequire("e6aYN");


var $3R7tk = parcelRequire("3R7tk");


var $3n1ek = parcelRequire("3n1ek");


var $d12Gs = parcelRequire("d12Gs");


var $aaAHl = parcelRequire("aaAHl");


var $lPi6l = parcelRequire("lPi6l");


var $kfpQF = parcelRequire("kfpQF");


var $kAvtp = parcelRequire("kAvtp");


var $3dDDp = parcelRequire("3dDDp");


var $3FB7u = parcelRequire("3FB7u");


var $5jAJS = parcelRequire("5jAJS");


var $akUNu = parcelRequire("akUNu");


var $gFQSq = parcelRequire("gFQSq");


var $1HUbj = parcelRequire("1HUbj");


var $BxpF2 = parcelRequire("BxpF2");


var $eCrhY = parcelRequire("eCrhY");


var $8zIDz = parcelRequire("8zIDz");


var $fIEjp = parcelRequire("fIEjp");


var $8Kn1J = parcelRequire("8Kn1J");


var $isesA = parcelRequire("isesA");


var $jTMzh = parcelRequire("jTMzh");


var $aXEqL = parcelRequire("aXEqL");


var $5Wjk2 = parcelRequire("5Wjk2");


var $bgFDc = parcelRequire("bgFDc");


var $jOQaR = parcelRequire("jOQaR");


var $bSmYV = parcelRequire("bSmYV");


var $gNOjs = parcelRequire("gNOjs");


var $fntyu = parcelRequire("fntyu");


var $58oEb = parcelRequire("58oEb");


var $7NK0A = parcelRequire("7NK0A");


var $17MYP = parcelRequire("17MYP");


var $eThC5 = parcelRequire("eThC5");


var $d5MkD = parcelRequire("d5MkD");


var $cSnzL = parcelRequire("cSnzL");


var $8ytSX = parcelRequire("8ytSX");


var $g1jxz = parcelRequire("g1jxz");


var $hyfqk = parcelRequire("hyfqk");


var $cELP4 = parcelRequire("cELP4");

function $b9c572bfe9ab6fce$export$b21c20e4234a3291(props) {
    const { intl: intl, providers: providers, enabledOptionalPlugins: enabledOptionalPlugins } = props;
    // We remove all `never` properties from the HubPresetProps.pluginOptions,
    // we need to return them back.
    const pluginOptions = props.pluginOptions;
    return new (0, $a31lS.EditorPresetBuilder)().add([
        (0, $h0KOi.featureFlagsPlugin),
        (0, $3dDDp.featureFlagsPluginOptions)({
            options: pluginOptions.featureFlags
        })
    ]).add([
        (0, $1CaNG.analyticsPlugin),
        (0, $apdxZ.analyticsPluginOptions)({
            options: pluginOptions.analytics
        })
    ]).add((0, $lK9Pz.betterTypeHistoryPlugin)).add([
        (0, $hYOOW.pastePlugin),
        (0, $isesA.pastePluginOptions)({
            options: pluginOptions.paste,
            providers: providers
        })
    ]).add((0, $ifkCZ.default)).add((0, $4Kyof.focusPlugin)).add((0, $e6Dq9.compositionPlugin)).add([
        (0, $lDJPY.contextIdentifierPlugin),
        (0, $7iKiU.contextIdentifierPluginOptions)({
            options: pluginOptions.contextIdentifier,
            providers: providers
        })
    ]).add([
        (0, $7Upsh.default),
        (0, $8cJvF.basePluginOptions)({
            options: pluginOptions.base
        })
    ]).maybeAdd([
        (0, $5C5Mq.userPreferencesPlugin),
        (0, $hyfqk.userPreferencesPluginOptions)({
            providers: providers
        })
    ], Boolean(enabledOptionalPlugins.interaction)).add((0, $2QN3e.decorationsPlugin)).add([
        (0, $d1HsG.typeAheadPlugin),
        (0, $g1jxz.typeAheadPluginOptions)({
            options: pluginOptions.typeAhead
        })
    ]).add((0, $6WRJZ.default)).maybeAdd([
        (0, $4gNvG.toolbarPlugin),
        {
            contextualFormattingEnabled: 'always-inline'
        }
    ], Boolean(enabledOptionalPlugins.toolbar)).add([
        (0, $hBGxo.primaryToolbarPlugin),
        (0, $5Wjk2.primaryToolbarPluginOptions)({
            options: pluginOptions.primaryToolbar
        })
    ]).add((0, $abOD2.undoRedoPlugin)).add([
        (0, $fKdaf.blockTypePlugin),
        (0, $iaIX4.blockTypePluginOptions)({
            options: pluginOptions.blockType
        })
    ]).add((0, $5VZEy.clearMarksOnEmptyDocPlugin)).add([
        (0, $dxDD9.selectionToolbarPlugin),
        (0, $fntyu.selectionToolbarPluginOptions)({
            options: pluginOptions.selectionToolbar,
            providers: providers
        })
    ]).add([
        (0, $3HCXM.hyperlinkPlugin),
        (0, $gFQSq.hyperlinkPluginOptions)({
            options: pluginOptions.hyperlink
        })
    ]).add([
        (0, $grjTL.textFormattingPlugin),
        (0, $cSnzL.textFormattingPluginOptions)({
            options: pluginOptions.textFormatting
        })
    ]).add((0, $lfQQe.widthPlugin)).add([
        (0, $hHtwA.quickInsertPlugin),
        (0, $bgFDc.quickInsertPluginOptions)({
            options: pluginOptions.quickInsert
        })
    ]).add([
        (0, $f3DNZ.placeholderPlugin),
        (0, $jTMzh.placeholderPluginOptions)({
            intl: intl,
            options: pluginOptions.placeholder
        })
    ]).add((0, $cjuKO.unsupportedContentPlugin)).add([
        (0, $e273U.editorDisabledPlugin),
        (0, $3n1ek.editorDisabledPluginOptions)({
            options: pluginOptions.editorDisabled
        })
    ]).add([
        (0, $ljXAk.submitEditorPlugin),
        (0, $7NK0A.submitEditorPluginOptions)({
            options: pluginOptions.submitEditor
        })
    ]).add((0, $1ZhW4.copyButtonPlugin)).add((0, $5tMpU.floatingToolbarPlugin)).maybeAdd((0, $jT02V.interactionPlugin), Boolean(enabledOptionalPlugins.interaction)).add([
        (0, $fb3SZ.selectionPlugin),
        (0, $gNOjs.selectionPluginOptions)({
            options: pluginOptions.selection
        })
    ]).add([
        (0, $bkj40.default),
        (0, $6UNH9.codeBlockPluginOptions)({
            options: pluginOptions.codeBlock
        })
    ]).add((0, $ctVsO.ufoPlugin)).add((0, $7gk7g.dataConsumerPlugin)).add((0, $7eCZG.accessibilityUtilsPlugin)).add((0, $8PVlW.contentInsertionPlugin)).add((0, $cX2jD.batchAttributeUpdatesPlugin)).add([
        (0, $fLS6B.breakoutPlugin),
        (0, $2X43x.breakoutPluginOptions)()
    ]).add((0, $dYbu7.alignmentPlugin)).add([
        (0, $gkbos.textColorPlugin),
        (0, $d5MkD.textColorPluginOptions)({
            options: pluginOptions.textColor,
            // remove the textColorPlugin only when companyHubTextColor plugin is enabled
            isPluginEnabled: !Boolean(enabledOptionalPlugins.companyHubTextColor)
        })
    ]).maybeAdd((0, $7s1mJ.companyHubTextColorPlugin), Boolean(enabledOptionalPlugins.companyHubTextColor)).add((0, $hFvHs.listPlugin)).add((0, $2hEu6.rulePlugin)).add([
        (0, $k8SUN.expandPlugin),
        (0, $kfpQF.expandPluginOptions)()
    ]).add((0, $eHllO.guidelinePlugin)).add([
        (0, $iVGec.gridPlugin),
        (0, $5jAJS.gridPluginOptions)({
            options: pluginOptions.grid
        })
    ]).add([
        (0, $gLxaI.annotationPlugin),
        (0, $e9gyG.annotationPluginOptions)({
            options: pluginOptions.annotation,
            providers: providers
        })
    ]).add([
        (0, $5bzSg.mediaPlugin),
        (0, $8zIDz.mediaPluginOptions)({
            intl: intl,
            providers: providers
        })
    ]).add((0, $7gEjc.mediaInsertPlugin)).add((0, $cud1R.default)).add([
        (0, $k7vUa.emojiPlugin),
        (0, $aaAHl.emojiPluginOptions)({
            options: pluginOptions.emoji,
            providers: providers
        })
    ]).add([
        (0, $gUZEQ.default),
        (0, $17MYP.tablePluginOptions)()
    ]).add([
        (0, $jIG3b.tasksAndDecisionsPlugin),
        (0, $eThC5.tasksAndDecisionsPluginOptions)({
            options: pluginOptions.tasksAndDecisions,
            providers: providers
        })
    ]).add([
        (0, $laiso.helpDialogPlugin),
        (0, $akUNu.helpDialogPluginOptions)({
            options: {
                imageUploadProviderExists: false,
                // aiEnabled: enabledOptionalPlugins.aiExperience,
                aiEnabled: false
            }
        })
    ]).add([
        (0, $jeuMk.default),
        (0, $8Kn1J.panelPluginOptions)({
            options: pluginOptions.panel
        })
    ]).add([
        (0, $l5MIu.contextPanelPlugin),
        (0, $8PiK3.contextPanelPluginOptions)({
            options: pluginOptions.contextPanel
        })
    ]).add([
        (0, $3gmKQ.extensionPlugin),
        (0, $kAvtp.extensionPluginOptions)({
            options: pluginOptions.extension
        })
    ]).add([
        (0, $4y9hw.default),
        (0, $3R7tk.datePluginOptions)({
            options: pluginOptions.date
        })
    ]).add([
        (0, $1K7sQ.default),
        (0, $aXEqL.placeholderTextPluginOptions)({
            options: pluginOptions.placeholderText
        })
    ]).add([
        (0, $4exuQ.layoutPlugin),
        (0, $BxpF2.layoutPluginOptions)()
    ]).add([
        (0, $40ukF.cardPlugin),
        (0, $50Cc6.cardPluginOptions)({
            options: pluginOptions.card,
            providers: providers
        })
    ]).add([
        (0, $f2WDp.customAutoformatPlugin),
        (0, $e6aYN.customAutoformatPluginOptions)({
            options: pluginOptions.customAutoformat,
            providers: providers
        })
    ]).add([
        (0, $drevR.statusPlugin),
        (0, $58oEb.statusPluginOptions)({
            options: pluginOptions.status
        })
    ]).add((0, $HGu9Y.indentationPlugin)).add((0, $3VDvd.scrollIntoViewPlugin)).add([
        (0, $1171P.toolbarListsIndentationPlugin),
        (0, $8ytSX.toolbarListsIndentationPluginOptions)({
            options: pluginOptions.toolbarListsIndentation
        })
    ]).maybeAdd([
        (0, $5HQgD.insertBlockPlugin),
        (0, $1HUbj.insertBlockPluginOptions)()
    ], Boolean(enabledOptionalPlugins.insertBlock)).add([
        (0, $60Pfj.avatarGroupPlugin),
        (0, $6vkVa.avatarGroupPluginOptions)({
            options: pluginOptions.avatarGroup
        })
    ]).maybeAdd([
        (0, $dGnqc.findReplacePlugin),
        (0, $3FB7u.findReplacePluginOptions)({
            options: pluginOptions.findReplace
        })
    ], enabledOptionalPlugins.findReplace).add((0, $9ki8I.borderPlugin)).add((0, $7iL2d.fragmentPlugin)).add((0, $4Bdub.pasteOptionsToolbarPlugin)).add([
        (0, $kaUwk.codeBidiWarningPlugin),
        (0, $ggRZd.codeBidiWarningPluginOptions)()
    ])// .maybeAdd(
    // 	[aiPlugin, aiPluginOptions({ options: pluginOptions.ai })],
    // 	enabledOptionalPlugins.aiExperience,
    // )
    .maybeAdd([
        (0, $jdplc.loomPlugin),
        (0, $eCrhY.loomPluginOptions)({
            options: pluginOptions.loom
        })
    ], enabledOptionalPlugins.loom).add([
        (0, $iFdOW.editorViewModePlugin),
        (0, $d12Gs.editorViewModePluginOptions)({
            options: pluginOptions.editorViewMode
        })
    ])// aiDefinitionsPlugin depends on editorViewModePlugin
    .maybeAdd([
        (0, $7Krw2.aiDefinitionsPlugin),
        (0, $ekz2H.aiDefinitionsPluginOptions)({
            options: pluginOptions.aiDefinitions
        })
    ], enabledOptionalPlugins.aiDefinitions).add([
        (0, $3RHCI.selectionMarkerPlugin),
        (0, $bSmYV.selectionMarkerPluginOptions)({
            options: pluginOptions.selectionMarker
        })
    ]).maybeAdd((0, $dHFAY.blockControlsPlugin), Boolean(enabledOptionalPlugins.blockControls)).add((0, $1U7Jq.highlightPlugin)).add([
        (0, $47YIB.engagementPlatformPlugin),
        (0, $lPi6l.engagementPlatformPluginOptions)({
            options: pluginOptions.engagementPlatform
        })
    ]).maybeAdd((0, $e4SgJ.connectivityPlugin), enabledOptionalPlugins.connectivity).maybeAdd([
        (0, $4OMM6.metricsPlugin),
        (0, $fIEjp.metricsPluginOptions)({
            options: pluginOptions.metrics
        })
    ], enabledOptionalPlugins.metrics).maybeAdd((0, $51qBv.codeBlockAdvancedPlugin), enabledOptionalPlugins.codeBlockAdvanced).maybeAdd([
        (0, $dvcAA.selectionExtensionPlugin),
        (0, $jOQaR.selectionExtensionPluginOptions)({
            options: pluginOptions.selectionExtension
        })
    ], enabledOptionalPlugins.selectionExtension).maybeAdd((0, $lWQ1U.hubExternalInsertPlugin), enabledOptionalPlugins.hubExternalInsert)// Takes no options: its presence is the lock. See hubTemplateLockPlugin.
    .maybeAdd((0, $cELP4.hubTemplateLockPlugin), Boolean(enabledOptionalPlugins.hubTemplateLock)).add((0, $771jm.hubShellPlugin)).add((0, $4lpx1.userIntentPlugin));
}
module.exports["hubPreset"] = $b9c572bfe9ab6fce$export$b21c20e4234a3291;

});

parcelRegister("gD7r0", function(module, exports) {
const $c1b60e317b8b2148$export$881d135f98d8d7d0 = 100;
const $c1b60e317b8b2148$export$9ab5bdcb8a1d6c34 = false;
const $c1b60e317b8b2148$export$12c1dc38ea1692da = 0;
module.exports["DEFAULT_CACHE_MAX_LIMIT"] = $c1b60e317b8b2148$export$881d135f98d8d7d0;
module.exports["DEFAULT_RESOURCE_BROWSER_ONLY"] = $c1b60e317b8b2148$export$9ab5bdcb8a1d6c34;
module.exports["DEFAULT_RESOURCE_MAX_AGE"] = $c1b60e317b8b2148$export$12c1dc38ea1692da;

});

parcelRegister("kaUwk", function(module, exports) {

var $5Ga4m = parcelRequire("5Ga4m");

const $1e6fd84d2484c0b4$export$d7bb9295cdf61833 = ({ config: config, api: api })=>({
        name: 'codeBidiWarning',
        pmPlugins () {
            return [
                {
                    name: 'codeBidiWarning',
                    plugin: (options)=>{
                        return (0, $5Ga4m.createPlugin)(api, options, config ?? {});
                    }
                }
            ];
        }
    });
module.exports["codeBidiWarningPlugin"] = $1e6fd84d2484c0b4$export$d7bb9295cdf61833;

});

parcelRegister("7s1mJ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jj5Xg = parcelRequire("jj5Xg");


var $lH6tf = parcelRequire("lH6tf");


var $fT5ir = parcelRequire("fT5ir");


var $9Kz25 = parcelRequire("9Kz25");


var $CiIZe = parcelRequire("CiIZe");

const $394ca90b950223d6$var$pluginConfig = (textColorConfig)=>{
    if (!textColorConfig || typeof textColorConfig === 'boolean') return undefined;
    return textColorConfig;
};
const $394ca90b950223d6$export$164d98bc1a6b118 = ({ config: textColorConfig, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api?.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Kz25.PrimaryToolbarComponent), {
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            disabled: disabled,
            api: api
        });
    };
    if (isToolbarAIFCEnabled) api?.toolbar?.actions.registerComponents((0, $CiIZe.getToolbarComponents)(api));
    else api?.primaryToolbar?.actions.registerComponent({
        name: 'textColor',
        component: primaryToolbarComponent
    });
    return {
        name: 'companyHubTextColor',
        marks () {
            return [
                {
                    name: 'companyHubTextColor',
                    mark: (0, $jj5Xg.textColor)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'companyHubTextColor',
                    plugin: ({ dispatch: dispatch })=>(0, $fT5ir.createPlugin)(dispatch, $394ca90b950223d6$var$pluginConfig(textColorConfig))
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $fT5ir.pluginKey).getState(editorState);
        },
        actions: {
            changeColor: (color)=>{
                return (0, $lH6tf.changeColor)(color, api?.analytics?.actions);
            }
        },
        primaryToolbarComponent: !api?.primaryToolbar ? primaryToolbarComponent : undefined
    };
};
module.exports["companyHubTextColorPlugin"] = $394ca90b950223d6$export$164d98bc1a6b118;

});

parcelRegister("lWQ1U", function(module, exports) {

var $cf6oG = parcelRequire("cf6oG");

const $13b343b815acf651$export$ff4d2b674c5a359b = ({ api: api })=>({
        name: 'hubExternalInsert',
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $cf6oG.key).getState(editorState);
            return pluginState ? {
                dropTargetPos: pluginState.dropTargetPos
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'hubExternalInsert',
                    plugin: ({ nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $cf6oG.createPlugin)(api, nodeViewPortalProviderAPI);
                    }
                }
            ];
        }
    });
module.exports["hubExternalInsertPlugin"] = $13b343b815acf651$export$ff4d2b674c5a359b;

});

parcelRegister("771jm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $2hH3E = parcelRequire("2hH3E");

const $2ed588dbdf2b5ae3$export$f271121a021219d3 = ()=>({
        name: 'hubShell',
        contentComponent ({ editorView: editorView }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2hH3E.HubShellContentComponent), {
                editorView: editorView
            });
        }
    });
module.exports["hubShellPlugin"] = $2ed588dbdf2b5ae3$export$f271121a021219d3;

});

parcelRegister("ekz2H", function(module, exports) {
function $63bda7e2a288b120$export$13aeab2a71badd1e({ options: options }) {
    // Options not declared here as they are all nested inside hooks, starting with `useEditorPluginAIDefinitionsConfig`.
    return options;
}
module.exports["aiDefinitionsPluginOptions"] = $63bda7e2a288b120$export$13aeab2a71badd1e;

});

parcelRegister("apdxZ", function(module, exports) {
function $04af3dc826dcd9c8$export$bfd53895e8497571({}) {
    return {};
}
module.exports["analyticsPluginOptions"] = $04af3dc826dcd9c8$export$bfd53895e8497571;

});

parcelRegister("e9gyG", function(module, exports) {
function $5a011a881d0671fc$export$b3e029fd31f94f55({ options: options, providers: providers }) {
    if (!providers.inlineCommentAnnotationProvider) return undefined;
    return {
        inlineComment: providers.inlineCommentAnnotationProvider,
        createCommentExperience: options.createCommentExperience,
        selectCommentExperience: {
            selectAnnotation: {
                complete: (annotationId)=>{
                    options.selectCommentExperience?.selectAnnotation.complete({
                        pageClass: 'editor',
                        annotationId: annotationId,
                        entryPoint: 'annotation-change'
                    });
                }
            }
        },
        viewInlineCommentTraceUFOPress: undefined,
        annotationManager: options.annotationManager
    };
}
module.exports["annotationPluginOptions"] = $5a011a881d0671fc$export$b3e029fd31f94f55;

});

parcelRegister("6vkVa", function(module, exports) {
function $ab9fdcc320174221$export$eeaea850bc5c5797({ options: options }) {
    return {
        // When Edit in Context is enabled primaryToolbarComponents is undefined
        // For more details please check
        // https://hello.atlassian.net/wiki/spaces/PCG/pages/2851572180/Editor+toolbar+for+live+pages+and+edit+in+context+projects
        collabEdit: options.collabEdit,
        // originally depends on !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        showAvatarGroup: false
    };
}
module.exports["avatarGroupPluginOptions"] = $ab9fdcc320174221$export$eeaea850bc5c5797;

});

parcelRegister("8cJvF", function(module, exports) {
function $74a64fdcbc288e59$export$a23b3fa66082f163({ options: options }) {
    return {
        allowInlineCursorTarget: true,
        allowScrollGutter: undefined
    };
}
module.exports["basePluginOptions"] = $74a64fdcbc288e59$export$a23b3fa66082f163;

});

parcelRegister("iaIX4", function(module, exports) {
function $e4f13d43a5cb210d$export$817c0e398e6ff750({}) {
    return {
        includeBlockQuoteAsTextstyleOption: true,
        lastNodeMustBeParagraph: false,
        allowBlockType: undefined
    };
}
module.exports["blockTypePluginOptions"] = $e4f13d43a5cb210d$export$817c0e398e6ff750;

});

parcelRegister("2X43x", function(module, exports) {
function $914cf568e023e359$export$3be6b735d5cbc3e6() {
    return {
        allowBreakoutButton: true
    };
}
module.exports["breakoutPluginOptions"] = $914cf568e023e359$export$3be6b735d5cbc3e6;

});

parcelRegister("50Cc6", function(module, exports) {

var $4iudd = parcelRequire("4iudd");

/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $236ac6fe5d915e12$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $236ac6fe5d915e12$export$514131654bb897e2({ options: options, providers: providers }) {
    return {
        allowDatasource: false,
        provider: providers.cardProvider,
        resolveBeforeMacros: $236ac6fe5d915e12$var$SMART_LINKS_BEFORE_MACROS,
        allowBlockCards: true,
        allowEmbeds: true,
        onClickCallback: options.onClickCallback,
        fullWidthMode: false,
        linkPicker: options.linkPicker,
        lpLinkPicker: true,
        editorAppearance: 'full-page',
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage,
        isPageSSRed: Boolean((0, $4iudd.isSSR)() || window.__SSR_RENDERED__),
        CompetitorPrompt: options.CompetitorPrompt
    };
}
module.exports["cardPluginOptions"] = $236ac6fe5d915e12$export$514131654bb897e2;

});

parcelRegister("ggRZd", function(module, exports) {
function $74df3d1bf9d03e75$export$3f0ff0bcf72f4d98() {
    return {
        appearance: 'full-page'
    };
}
module.exports["codeBidiWarningPluginOptions"] = $74df3d1bf9d03e75$export$3f0ff0bcf72f4d98;

});

parcelRegister("6UNH9", function(module, exports) {
function $77761212702e3032$export$74cc43e84bb9c20({}) {
    return {
        allowCopyToClipboard: true,
        useLongPressSelection: false,
        allowCompositionInputOverride: false
    };
}
module.exports["codeBlockPluginOptions"] = $77761212702e3032$export$74cc43e84bb9c20;

});

parcelRegister("7iKiU", function(module, exports) {
function $8c8a0d1870f293c5$export$2c26eb5ff90afcfd({ providers: providers }) {
    return {
        contextIdentifierProvider: providers.contextIdentifierProvider
    };
}
module.exports["contextIdentifierPluginOptions"] = $8c8a0d1870f293c5$export$2c26eb5ff90afcfd;

});

parcelRegister("8PiK3", function(module, exports) {
function $1461db1c8d7b87c4$export$48a60d81b6bb28e3({ options: options }) {
    if (!options) return undefined;
    return {
        objectSideBar: options.objectSideBar
    };
}
module.exports["contextPanelPluginOptions"] = $1461db1c8d7b87c4$export$48a60d81b6bb28e3;

});

parcelRegister("e6aYN", function(module, exports) {
function $011a55ca178e44cf$export$f18d68682e981a91({ providers: providers }) {
    return {
        autoformattingProvider: providers.autoformattingProvider
    };
}
module.exports["customAutoformatPluginOptions"] = $011a55ca178e44cf$export$f18d68682e981a91;

});

parcelRegister("3R7tk", function(module, exports) {
function $59a5e91fe5cc8e4b$export$5598bb2314a53fa8({}) {
    return {
        weekStartDay: undefined
    };
}
module.exports["datePluginOptions"] = $59a5e91fe5cc8e4b$export$5598bb2314a53fa8;

});

parcelRegister("3n1ek", function(module, exports) {
function $bcbb2e696afa1258$export$de47eee62065048e({ options: options }) {
    return {
        initialDisabledState: options?.disabled
    };
}
module.exports["editorDisabledPluginOptions"] = $bcbb2e696afa1258$export$de47eee62065048e;

});

parcelRegister("d12Gs", function(module, exports) {
function $0f06e306ecbec1ef$export$36a79e2b5698697a({ options: options }) {
    return {
        mode: options.viewMode
    };
}
module.exports["editorViewModePluginOptions"] = $0f06e306ecbec1ef$export$36a79e2b5698697a;

});

parcelRegister("aaAHl", function(module, exports) {
function $b4a4dcc6b564a90e$export$7adcaf18ca5c72c4({ providers: providers }) {
    return {
        emojiProvider: providers.emojiProvider
    };
}
module.exports["emojiPluginOptions"] = $b4a4dcc6b564a90e$export$7adcaf18ca5c72c4;

});

parcelRegister("lPi6l", function(module, exports) {
function $9a06a776a7d73ee3$export$128eafe7f843e327({ options: options }) {
    return {
        coordinationClient: options.coordinationClient
    };
}
module.exports["engagementPlatformPluginOptions"] = $9a06a776a7d73ee3$export$128eafe7f843e327;

});

parcelRegister("kfpQF", function(module, exports) {
function $0161774cdd594eee$export$ed53f0c49fce09d6() {
    return {
        allowInsertion: true,
        useLongPressSelection: false,
        appearance: 'full-page',
        allowInteractiveExpand: true,
        __livePage: false
    };
}
module.exports["expandPluginOptions"] = $0161774cdd594eee$export$ed53f0c49fce09d6;

});

parcelRegister("kAvtp", function(module, exports) {
function $d58ebc08dd85125f$export$c18b9102cd0790c9({ options: options }) {
    const isTemplateLocked = Boolean(options.isTemplateLocked);
    return {
        breakoutEnabled: true,
        copyEnabled: !isTemplateLocked,
        deleteEnabled: !isTemplateLocked,
        extensionHandlers: options.extensionHandlers,
        useLongPressSelection: false,
        appearance: options.appearance ?? 'full-page',
        __rendererExtensionOptions: options.__rendererExtensionOptions,
        getExtensionHeight: options.getExtensionHeight
    };
}
module.exports["extensionPluginOptions"] = $d58ebc08dd85125f$export$c18b9102cd0790c9;

});

parcelRegister("3dDDp", function(module, exports) {
function $eed6f969b476c491$export$3bff061e5229a7({}) {
    /**
	 * @private
	 * @deprecated Don't add any new feature flags here!
	 *             If you need a new feature flag, use:
	 *             - {@link editorExperiment} for new experiments.
	 *             - {@link fg} for new feature gates.
	 */ return {
        lpLinkPicker: true,
        tableWithFixedColumnWidthsOption: true,
        tableSelector: true,
        macroInteractionUpdates: true,
        moreElementsInQuickInsertView: true,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: false,
        errorBoundaryDocStructure: false,
        synchronyErrorDocStructure: false,
        enableViewUpdateSubscription: false,
        collabAvatarScroll: false,
        twoLineEditorToolbar: false,
        disableSpellcheckByBrowser: undefined
    };
}
module.exports["featureFlagsPluginOptions"] = $eed6f969b476c491$export$3bff061e5229a7;

});

parcelRegister("3FB7u", function(module, exports) {
function $0b478bd471366f52$export$d9e183f0607e1b5d({}) {
    return {
        // originally depends on !!featureFlags.showAvatarGroupAsPlugin === false && !hasBeforePrimaryToolbar(props.primaryToolbarComponents),
        takeFullWidth: true,
        twoLineEditorToolbar: false
    };
}
module.exports["findReplacePluginOptions"] = $0b478bd471366f52$export$d9e183f0607e1b5d;

});

parcelRegister("5jAJS", function(module, exports) {
function $679bc4e8ddf2dfed$export$c66d0d1462a05bd({}) {
    return {
        shouldCalcBreakoutGridLines: true
    };
}
module.exports["gridPluginOptions"] = $679bc4e8ddf2dfed$export$c66d0d1462a05bd;

});

parcelRegister("akUNu", function(module, exports) {
function $c1b63ea8f9ccb33f$export$2a67100cd9c61f05({ options: options }) {
    return options;
}
module.exports["helpDialogPluginOptions"] = $c1b63ea8f9ccb33f$export$2a67100cd9c61f05;

});

parcelRegister("gFQSq", function(module, exports) {
function $9081b6536eb02b4f$export$ab9ae3984d5aef33({ options: options }) {
    return {
        editorAppearance: 'full-page',
        lpLinkPicker: true,
        linkPicker: options.linkPicker,
        onClickCallback: options.onClickCallback,
        platform: 'web'
    };
}
module.exports["hyperlinkPluginOptions"] = $9081b6536eb02b4f$export$ab9ae3984d5aef33;

});

parcelRegister("1HUbj", function(module, exports) {
function $f79fa31c8674d1dd$export$1e11b615e9dc119e() {
    return {
        allowTables: true,
        allowExpand: true,
        horizontalRuleEnabled: true,
        tableSelectorSupported: true,
        nativeStatusSupported: true,
        showElementBrowserLink: true,
        appearance: 'full-page'
    };
}
module.exports["insertBlockPluginOptions"] = $f79fa31c8674d1dd$export$1e11b615e9dc119e;

});

parcelRegister("BxpF2", function(module, exports) {
function $432691c7c1116ba2$export$33fb6c6592b2cd5f() {
    return {
        allowBreakout: true,
        UNSAFE_addSidebarLayouts: true,
        useLongPressSelection: false,
        UNSAFE_allowSingleColumnLayout: undefined,
        editorAppearance: 'full-page'
    };
}
module.exports["layoutPluginOptions"] = $432691c7c1116ba2$export$33fb6c6592b2cd5f;

});

parcelRegister("eCrhY", function(module, exports) {
function $3cb19dba5c0a4727$export$feaee25faac0c640({ options: options }) {
    return {
        renderButton: options.renderButton,
        shouldShowToolbarButton: undefined
    };
}
module.exports["loomPluginOptions"] = $3cb19dba5c0a4727$export$feaee25faac0c640;

});

parcelRegister("8zIDz", function(module, exports) {

var $8Y2vc = parcelRequire("8Y2vc");

function $bda3a672ea4486c5$export$484123ae56f6fbd9({ intl: intl, providers: providers }) {
    return {
        provider: providers.mediaProvider,
        syncProvider: providers.syncMediaProvider,
        allowMediaSingle: true,
        allowResizing: true,
        allowResizingInTables: true,
        allowLinking: true,
        allowAltTextOnImages: true,
        allowCaptions: true,
        allowMediaInlineImages: true,
        allowPixelResizing: true,
        altTextValidator: (text)=>{
            const storageSupports = RegExp("^([\\p{L}\\p{N},'\\.\\s\\-_\\(\\)]|&amp;[0-9]{2};)*$", "u");
            if (!storageSupports.test(text)) return [
                intl.formatMessage((0, $8Y2vc.i18n).invalidAltText)
            ];
            return [];
        },
        featureFlags: {
            mediaInline: true
        },
        allowLazyLoading: true,
        allowBreakoutSnapPoints: true,
        allowAdvancedToolBarOptions: true,
        allowCommentsOnMedia: true,
        allowDropzoneDropLine: true,
        allowMediaSingleEditable: true,
        allowRemoteDimensionsFetch: true,
        allowMarkingUploadsAsIncomplete: false,
        allowImagePreview: true,
        fullWidthEnabled: false,
        editorAppearance: 'full-page',
        isCopyPasteEnabled: true,
        alignLeftOnInsert: false,
        waitForMediaUpload: true
    };
}
module.exports["mediaPluginOptions"] = $bda3a672ea4486c5$export$484123ae56f6fbd9;

});

parcelRegister("fIEjp", function(module, exports) {
function $64dd438f52997ff4$export$4677177d82484aef({ options: options }) {
    return options;
}
module.exports["metricsPluginOptions"] = $64dd438f52997ff4$export$4677177d82484aef;

});

parcelRegister("8Kn1J", function(module, exports) {
function $73416c62fc01c864$export$c18e432f323b002e({}) {
    return {
        useLongPressSelection: false,
        allowCustomPanel: true,
        allowCustomPanelEdit: true
    };
}
module.exports["panelPluginOptions"] = $73416c62fc01c864$export$c18e432f323b002e;

});

parcelRegister("isesA", function(module, exports) {
/**
 * Supported Jira URLs and Jira Roadmap URLs, GDrive and ODFB will become Smart Links
 * (only supports Cloud single-issue URLs right now)
 */ const $27c18ad3a33d1184$var$SMART_LINKS_BEFORE_MACROS = 'jira,jiraroadmap,google-drive-sheets,google-drive-docs,OneDrive,google-drive-slides'.split(',');
function $27c18ad3a33d1184$export$6b1ad42d09c74964({ providers: providers }) {
    return {
        cardOptions: {
            provider: providers.cardProvider,
            allowBlockCards: true,
            allowDatasource: true,
            allowEmbeds: true,
            resolveBeforeMacros: $27c18ad3a33d1184$var$SMART_LINKS_BEFORE_MACROS
        },
        sanitizePrivateContent: true,
        isFullPage: true
    };
}
module.exports["pastePluginOptions"] = $27c18ad3a33d1184$export$6b1ad42d09c74964;

});

parcelRegister("jTMzh", function(module, exports) {

var $jkcNT = parcelRequire("jkcNT");


var $iU997 = parcelRequire("iU997");

function $92a9daf3ddadf6ba$export$c6841f879d4c8aef({ intl: intl, options: options }) {
    const placeholder = (()=>{
        if (options.viewMode === 'view') return undefined;
        if (!options.isAIEnabled) return intl.formatMessage((0, $iU997.i18n).defaultPlaceholder);
        if ((0, $jkcNT.editorExperiment)('platform_editor_controls', 'variant1')) return intl.formatMessage((0, $iU997.i18n).defaultPlaceholder);
        return intl.formatMessage((0, $iU997.i18n).easyCommandsPlaceholder);
    })();
    return {
        placeholder: placeholder
    };
}
module.exports["placeholderPluginOptions"] = $92a9daf3ddadf6ba$export$c6841f879d4c8aef;

});

parcelRegister("aXEqL", function(module, exports) {
function $40f6d9aa894c5234$export$8b53e6ddc7cf96b4({}) {
    return {};
}
module.exports["placeholderTextPluginOptions"] = $40f6d9aa894c5234$export$8b53e6ddc7cf96b4;

});

parcelRegister("5Wjk2", function(module, exports) {
function $0aff776e39efcf69$export$44901d053a58e418({ options: options }) {
    return {
        contextualFormattingEnabled: options.contextualFormattingEnabled
    };
}
module.exports["primaryToolbarPluginOptions"] = $0aff776e39efcf69$export$44901d053a58e418;

});

parcelRegister("bgFDc", function(module, exports) {
function $6f657f766755e7fa$export$26cff1f2fe9f781b({ options: options }) {
    const isTemplateLocked = Boolean(options?.isTemplateLocked);
    return {
        enableElementBrowser: !isTemplateLocked,
        elementBrowserHelpUrl: '',
        disableDefaultItems: isTemplateLocked,
        headless: isTemplateLocked,
        emptyStateHandler: options?.emptyStateHandler,
        prioritySortingFn: typeof options.quickInsert === 'object' ? options.quickInsert.prioritySortingFn : undefined,
        onInsert: typeof options.quickInsert === 'object' ? options.quickInsert.onInsert : undefined
    };
}
module.exports["quickInsertPluginOptions"] = $6f657f766755e7fa$export$26cff1f2fe9f781b;

});

parcelRegister("jOQaR", function(module, exports) {
function $36ce728f217c6048$export$222c5aa4c9fb0805({ options: options }) {
    return options;
}
module.exports["selectionExtensionPluginOptions"] = $36ce728f217c6048$export$222c5aa4c9fb0805;

});

parcelRegister("bSmYV", function(module, exports) {
function $66a89cabd873c5cc$export$197b78e13e8987d2({ options: options }) {
    return {
        hideCursorOnInit: true
    };
}
module.exports["selectionMarkerPluginOptions"] = $66a89cabd873c5cc$export$197b78e13e8987d2;

});

parcelRegister("gNOjs", function(module, exports) {
function $0007e12533958e13$export$ddc2936355c1da67({ options: options }) {
    return {
        useLongPressSelection: false,
        // @ts-ignore Temporary solution to check for Live Page editor.
        __livePage: options.__livePage
    };
}
module.exports["selectionPluginOptions"] = $0007e12533958e13$export$ddc2936355c1da67;

});

parcelRegister("fntyu", function(module, exports) {
function $b79940cdb8c833b5$export$bc6dcb3c2a6112e1({ options: options, providers: providers }) {
    return {
        preferenceToolbarAboveSelection: false,
        contextualFormattingEnabled: options.contextualFormattingEnabled,
        userPreferencesProvider: providers.userPreferencesProvider
    };
}
module.exports["selectionToolbarPluginOptions"] = $b79940cdb8c833b5$export$bc6dcb3c2a6112e1;

});

parcelRegister("58oEb", function(module, exports) {
function $1fca5eecbf74e87e$export$9d286ea8d36eb908({}) {
    return {
        menuDisabled: false,
        allowZeroWidthSpaceAfter: true
    };
}
module.exports["statusPluginOptions"] = $1fca5eecbf74e87e$export$9d286ea8d36eb908;

});

parcelRegister("7NK0A", function(module, exports) {
function $edd84adbe6a26519$export$3612ff8a6b94af71({}) {
    return undefined;
}
module.exports["submitEditorPluginOptions"] = $edd84adbe6a26519$export$3612ff8a6b94af71;

});

parcelRegister("17MYP", function(module, exports) {
function $4cad62635571ebe1$export$9868b594778cf535() {
    return {
        tableOptions: {
            allowTableResizing: true,
            allowTableAlignment: true,
            allowBackgroundColor: true,
            allowColumnResizing: true,
            allowColumnSorting: true,
            allowDistributeColumns: true,
            allowHeaderColumn: true,
            allowHeaderRow: true,
            allowMergeCells: true,
            allowNumberColumn: true,
            allowNestedTables: true,
            allowControls: true,
            stickyHeaders: true,
            allowAddColumnWithCustomStep: false
        },
        isTableScalingEnabled: true,
        allowContextualMenu: true,
        fullWidthEnabled: false,
        wasFullWidthEnabled: false,
        getEditorFeatureFlags: ()=>({
                tableWithFixedColumnWidthsOption: true,
                tableSelector: true
            }),
        isCommentEditor: false,
        isChromelessEditor: false
    };
}
module.exports["tablePluginOptions"] = $4cad62635571ebe1$export$9868b594778cf535;

});

parcelRegister("eThC5", function(module, exports) {
function $1db1f1afc6b4c645$export$1d23e03c42bfc1ac({ options: options, providers: providers }) {
    return {
        allowNestedTasks: true,
        consumeTabs: true,
        useLongPressSelection: false,
        taskDecisionProvider: providers.taskDecisionProvider,
        hasEditPermission: options.hasEditPermission,
        requestToEditContent: options.requestToEditContent,
        hasRequestedEditPermission: options.hasRequestedEditPermission
    };
}
module.exports["tasksAndDecisionsPluginOptions"] = $1db1f1afc6b4c645$export$1d23e03c42bfc1ac;

});

parcelRegister("d5MkD", function(module, exports) {
function $94706055a8988c96$export$a4eedeb4455295f2({ isPluginEnabled: isPluginEnabled = true }) {
    return {
        toolbarConfig: {
            enabled: isPluginEnabled
        }
    };
}
module.exports["textColorPluginOptions"] = $94706055a8988c96$export$a4eedeb4455295f2;

});

parcelRegister("cSnzL", function(module, exports) {
function $86c5907c8b556041$export$cb883a3a9320698e({}) {
    return {
        responsiveToolbarMenu: true
    };
}
module.exports["textFormattingPluginOptions"] = $86c5907c8b556041$export$cb883a3a9320698e;

});

parcelRegister("8ytSX", function(module, exports) {
function $bdaf1cb09cc59563$export$bd221c449644c740({}) {
    return {
        showIndentationButtons: true,
        allowHeadingAndParagraphIndentation: true
    };
}
module.exports["toolbarListsIndentationPluginOptions"] = $bdaf1cb09cc59563$export$bd221c449644c740;

});

parcelRegister("g1jxz", function(module, exports) {
function $2d0b3f96d253bbc0$export$612ea2d32c3e4c96({}) {
    return {
        isMobile: false
    };
}
module.exports["typeAheadPluginOptions"] = $2d0b3f96d253bbc0$export$612ea2d32c3e4c96;

});

parcelRegister("hyfqk", function(module, exports) {
function $5508e9588d62f557$export$abdb0d09187eec69({ providers: providers }) {
    return {
        userPreferencesProvider: providers.userPreferencesProviderNext,
        initialUserPreferences: undefined
    };
}
module.exports["userPreferencesPluginOptions"] = $5508e9588d62f557$export$abdb0d09187eec69;

});

parcelRegister("cELP4", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $fAG95 = parcelRequire("fAG95");

const $91819ec27f9cabcf$var$signatureOf = (doc)=>{
    const nodes = [];
    doc.forEach((node)=>{
        nodes.push(node);
    });
    return (0, $fAG95.getTopLevelSignature)(nodes);
};
const $91819ec27f9cabcf$export$56a135055230e899 = ({ api: api })=>({
        name: 'hubTemplateLock',
        pmPlugins () {
            return [
                {
                    name: 'hubTemplateLock',
                    plugin: ()=>new (0, $kpCD8.SafePlugin)({
                            view: ()=>{
                                let destroyed = false;
                                // Defer the command until ProseMirror has completed plugin-view setup.
                                queueMicrotask(()=>{
                                    if (!destroyed) api?.core.actions.execute(api?.selection?.commands.hideCursor(true));
                                });
                                return {
                                    destroy: ()=>{
                                        destroyed = true;
                                        api?.core.actions.execute(api?.selection?.commands.hideCursor(false));
                                    }
                                };
                            },
                            // The whole top-level sequence is compared, not just the extension
                            // nodes, so a locked page cannot grow stray paragraphs either.
                            filterTransaction: (tr, state)=>!tr.docChanged || $91819ec27f9cabcf$var$signatureOf(tr.doc) === $91819ec27f9cabcf$var$signatureOf(state.doc)
                        })
                }
            ];
        }
    });
module.exports["hubTemplateLockPlugin"] = $91819ec27f9cabcf$export$56a135055230e899;

});

parcelRegister("5Ga4m", function(module, exports) {

var $7Glgp = parcelRequire("7Glgp");


var $kpCD8 = parcelRequire("kpCD8");


var $8nvEM = parcelRequire("8nvEM");


var $iFduB = parcelRequire("iFduB");


var $13p4p = parcelRequire("13p4p");

const $e33c8cb52afde5db$export$ae829ec7b2625219 = (api, { dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }, { appearance: appearance })=>{
    const intl = getIntl();
    const codeBidiWarningLabel = intl.formatMessage((0, $7Glgp.codeBidiWarningMessages).label);
    const { createPluginState: createPluginState, getPluginState: getPluginState } = (0, $13p4p.pluginFactoryCreator)(nodeViewPortalProviderAPI);
    return new (0, $kpCD8.SafePlugin)({
        key: (0, $iFduB.codeBidiWarningPluginKey),
        state: createPluginState(dispatch, (state)=>{
            if (api?.limitedMode?.sharedState.currentState()?.enabled) return {
                decorationSet: (0, $8nvEM.DecorationSet).empty,
                codeBidiWarningLabel: '',
                tooltipEnabled: false
            };
            return {
                decorationSet: (0, $13p4p.createBidiWarningsDecorationSetFromDoc)({
                    doc: state.doc,
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    tooltipEnabled: true,
                    nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
                }),
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: true
            };
        }),
        props: {
            decorations: (state)=>{
                const { decorationSet: decorationSet } = getPluginState(state);
                return decorationSet;
            }
        }
    });
};
module.exports["createPlugin"] = $e33c8cb52afde5db$export$ae829ec7b2625219;

});

parcelRegister("lH6tf", function(module, exports) {

var $krYZG = parcelRequire("krYZG");


var $eEdSM = parcelRequire("eEdSM");


var $fT5ir = parcelRequire("fT5ir");


var $4rOon = parcelRequire("4rOon");


var $dkuG1 = parcelRequire("dkuG1");


var $lAUnx = parcelRequire("lAUnx");

/**
 * Helper to create a higher order analytics command
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @return Higher order command with analytics logic inside.
 */ function $0555a528cbb73663$var$createWithColorAnalytics(newColor, previousColor, editorAnalyticsApi) {
    return (0, $eEdSM.withAnalytics)(editorAnalyticsApi, {
        action: (0, $krYZG.ACTION).FORMATTED,
        actionSubject: (0, $krYZG.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $krYZG.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $krYZG.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColor.toLowerCase(),
            previousColor: previousColor?.toLowerCase() || ''
        }
    });
}
const $0555a528cbb73663$export$917538e4f4eb20f9 = (color, editorAnalyticsApi)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        if (textColor) {
            const pluginState = (0, $fT5ir.pluginKey).getState(state);
            const activeColor = (0, $4rOon.getActiveColor)(state);
            const withColorAnalytics = $0555a528cbb73663$var$createWithColorAnalytics(color, activeColor, editorAnalyticsApi);
            if (pluginState?.disabled) return false;
            if (color === pluginState?.defaultColor) {
                withColorAnalytics((0, $dkuG1.removeColor)())(state, dispatch);
                return true;
            }
            withColorAnalytics((0, $lAUnx.toggleColor)(color))(state, dispatch);
            return true;
        }
        return false;
    };
module.exports["changeColor"] = $0555a528cbb73663$export$917538e4f4eb20f9;

});

parcelRegister("fT5ir", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $4rOon = parcelRequire("4rOon");


var $cLfUm = parcelRequire("cLfUm");


var $hpWwK = parcelRequire("hpWwK");

function $71fad57c8216033b$var$createInitialPluginState(editorState, pluginConfig) {
    const defaultColor = pluginConfig?.defaultColor || (0, $cLfUm.DEFAULT_COLOR);
    const state = {
        color: (0, $4rOon.getActiveColor)(editorState),
        disabled: (0, $hpWwK.getDisabledState)(editorState),
        defaultColor: defaultColor.color
    };
    return state;
}
var $71fad57c8216033b$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
    return ACTIONS;
}({});
const $71fad57c8216033b$export$18d4026d1ea86bb1 = new (0, $kCECX.PluginKey)('companyHubTextColorPlugin');
function $71fad57c8216033b$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $kpCD8.SafePlugin)({
        key: $71fad57c8216033b$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $71fad57c8216033b$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (tr, pluginState, _, newState) {
                const meta = tr.getMeta($71fad57c8216033b$export$18d4026d1ea86bb1) || {};
                let nextState;
                switch(meta.action){
                    case 0:
                        nextState = {
                            ...pluginState,
                            color: pluginState.defaultColor
                        };
                        break;
                    case 1:
                        nextState = {
                            ...pluginState,
                            color: meta.color,
                            disabled: false
                        };
                        break;
                    case 2:
                        nextState = {
                            ...pluginState,
                            disabled: true
                        };
                        break;
                    default:
                        nextState = {
                            ...pluginState,
                            color: (0, $4rOon.getActiveColor)(newState),
                            disabled: (0, $hpWwK.getDisabledState)(newState)
                        };
                }
                if (pluginState && pluginState.color !== nextState.color || pluginState && pluginState.disabled !== nextState.disabled) {
                    dispatch($71fad57c8216033b$export$18d4026d1ea86bb1, nextState);
                    return nextState;
                }
                return pluginState;
            }
        },
        props: {
            attributes: ()=>({
                    'data-company-hub-text-color-plugin': 'true'
                })
        }
    });
}
module.exports["ACTIONS"] = $71fad57c8216033b$export$92a1a3b7554e9387;
module.exports["pluginKey"] = $71fad57c8216033b$export$18d4026d1ea86bb1;
module.exports["createPlugin"] = $71fad57c8216033b$export$ae829ec7b2625219;

});

parcelRegister("9Kz25", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3k5Tv = parcelRequire("3k5Tv");


var $7qyDa = parcelRequire("7qyDa");

const $2fb70005c3c06c59$export$94516d5cccf573e3 = (0, $kSwu1.injectIntl)(({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled, api: api })=>{
    const { color: color, defaultColor: defaultColor, disabled: textColorDisabled } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'companyHubTextColor'
    ], (states)=>({
            color: states.companyHubTextColorState?.color,
            defaultColor: states.companyHubTextColorState?.defaultColor,
            disabled: states.companyHubTextColorState?.disabled
        }));
    if (color === undefined || defaultColor === undefined) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qyDa.ToolbarCompanyHubTextColor), {
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            disabled: textColorDisabled
        },
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        isReducedSpacing: isReducedSpacing,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $7qyDa.ToolbarType).PRIMARY
    });
});
module.exports["PrimaryToolbarComponent"] = $2fb70005c3c06c59$export$94516d5cccf573e3;

});

parcelRegister("CiIZe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3nacY = parcelRequire("3nacY");


var $hVLmg = parcelRequire("hVLmg");


var $5AKbu = parcelRequire("5AKbu");


var $gUU6c = parcelRequire("gUU6c");

const $a635e27daad1901d$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP),
            parents: [
                {
                    ...(0, $3nacY.TEXT_SECTION),
                    rank: (0, $hVLmg.TEXT_SECTION_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                },
                {
                    type: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $3nacY.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $hVLmg.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5AKbu.ToolbarButtonGroup), null, children)
        },
        {
            type: 'button',
            key: 'company-hub-text-color-button-inline-toolbar',
            parents: [
                {
                    ...(0, $3nacY.TEXT_COLOR_HIGHLIGHT_GROUP),
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gUU6c.CompanyHubTextColorButton), {
                    api: api,
                    parents: parents
                })
        }
    ];
};
module.exports["getToolbarComponents"] = $a635e27daad1901d$export$a758406ca53b86a5;

});

parcelRegister("cf6oG", function(module, exports) {

var $kpCD8 = parcelRequire("kpCD8");


var $kCECX = parcelRequire("kCECX");


var $8nvEM = parcelRequire("8nvEM");


var $4Vdlk = parcelRequire("4Vdlk");


var $arMIH = parcelRequire("arMIH");

const $cf6b6ccb25dee134$var$HUB_EXTENSION_DRAG_TYPE = 'hub-extension';
const $cf6b6ccb25dee134$export$df61b30b684217c0 = new (0, $kCECX.PluginKey)('hubExternalInsert');
const $cf6b6ccb25dee134$var$initialState = {
    decorations: (0, $8nvEM.DecorationSet).empty,
    showCursorDropIndicator: false,
    dropTargetPos: null
};
/**
 * Container node types we deliberately descend INTO when resolving a drop
 * position. When the cursor is over content nested inside one of these
 * containers, we keep the resolved position inside the container instead
 * of clamping it back up to the document root.
 *
 * This is what enables drag-and-drop into:
 *   - layouts (`layoutSection` → `layoutColumn`)
 *   - hub `section` extension (a `multiBodiedExtension` with
 *     `extensionFrame` content holes)
 *   - bodied / nested expand / standard bodiedExtension containers
 *
 * Anything not in this set behaves like a leaf for the purposes of drop
 * resolution — the position is clamped to the nearest ancestor in the set
 * (or to the doc root). This matches the deny-list intuition used by
 * `editor-plugin-block-controls` for in-editor drag-and-drop.
 */ const $cf6b6ccb25dee134$var$DESCEND_INTO_NODES = new Set([
    'doc',
    'layoutSection',
    'layoutColumn',
    'multiBodiedExtension',
    'extensionFrame',
    'bodiedExtension',
    'expand',
    'nestedExpand'
]);
/**
 * Pick the boundary (before or after the child at the given depth) that
 * matches the cursor's vertical position. Reads the block DOM rect
 * directly to avoid calling `coordsAtPos`, which forces a full
 * synchronous layout reflow and is extremely slow when complex React
 * node views are present.
 */ function $cf6b6ccb25dee134$var$pickBoundaryForDepth(editorView, resolvedPos, depth, clientY, rawPos) {
    const blockStart = resolvedPos.before(depth);
    const blockEnd = resolvedPos.after(depth);
    const domNode = editorView.nodeDOM(blockStart);
    if (domNode instanceof HTMLElement) {
        const rect = domNode.getBoundingClientRect();
        const blockMidY = (rect.top + rect.bottom) / 2;
        return clientY < blockMidY ? blockStart : blockEnd;
    }
    // Fallback when the DOM node isn't available (e.g. during transient
    // node-view mount): use the proportional position within the block.
    const blockSize = blockEnd - blockStart;
    const offsetInBlock = rawPos - blockStart;
    return offsetInBlock < blockSize / 2 ? blockStart : blockEnd;
}
/**
 * Resolves a document position from mouse coordinates by using
 * ProseMirror's posAtCoords API and walking inward from the cursor's
 * deepest level outward, picking the **innermost** ancestor that we
 * recognise as a "descend-into" container. This means a drop inside a
 * `layoutColumn` resolves to a position inside the column (not above
 * the whole layout), and a drop inside a hub `section` resolves to a
 * position inside the section's content body.
 *
 * Returns the position at the chosen child boundary (above or below
 * the inner block), or null if the coordinates don't map to a position
 * inside the editor.
 *
 * NOTE: We avoid `coordsAtPos` for the same perf reason as before —
 * `pickBoundaryForDepth()` reads `nodeDOM().getBoundingClientRect()`
 * which is cheap.
 */ function $cf6b6ccb25dee134$var$resolveDropPosition(editorView, clientX, clientY) {
    try {
        const posInfo = editorView.posAtCoords({
            left: clientX,
            top: clientY
        });
        if (!posInfo) return null;
        const rawPos = Math.min(posInfo.pos, editorView.state.doc.content.size);
        const resolvedPos = editorView.state.doc.resolve(rawPos);
        // Walk from the deepest depth INWARD (towards depth 1), stopping
        // at the first ancestor whose parent is a known descend-into
        // container. This is the inverse of the previous `depth >= 1`
        // clamp, which always forced the position up to the document
        // root and prevented drops into layouts / sections / extensions.
        //
        // `resolvedPos.depth` is the parent depth at the cursor; the
        // child sitting at that level lives at `depth + 1`. We walk
        // from the cursor's parent upward, and as soon as we find a
        // parent that is in DESCEND_INTO_NODES we pick the boundary of
        // the child at that level.
        for(let d = resolvedPos.depth; d >= 1; d--){
            const parent = resolvedPos.node(d - 1);
            if ($cf6b6ccb25dee134$var$DESCEND_INTO_NODES.has(parent.type.name)) return $cf6b6ccb25dee134$var$pickBoundaryForDepth(editorView, resolvedPos, d, clientY, rawPos);
        }
        // Cursor is at depth 0 (over the doc itself, e.g. between
        // blocks at the very top). Fall back to the raw position.
        return resolvedPos.pos;
    } catch  {
        return null;
    }
}
function $cf6b6ccb25dee134$export$ae829ec7b2625219(api, nodeViewPortalProviderAPI) {
    // If portal API is missing (e.g. wrong editor wiring), run as no-op so the page doesn't break
    if (!nodeViewPortalProviderAPI || typeof nodeViewPortalProviderAPI.render !== 'function') return new (0, $kpCD8.SafePlugin)({
        key: $cf6b6ccb25dee134$export$df61b30b684217c0,
        state: {
            init: ()=>$cf6b6ccb25dee134$var$initialState,
            apply: (_tr, state)=>state
        },
        props: {
            decorations: (state)=>$cf6b6ccb25dee134$export$df61b30b684217c0.getState(state)?.decorations
        }
    });
    return new (0, $kpCD8.SafePlugin)({
        key: $cf6b6ccb25dee134$export$df61b30b684217c0,
        state: {
            init: ()=>$cf6b6ccb25dee134$var$initialState,
            apply: (tr, currentState, _oldState, newState)=>{
                try {
                    const meta = tr.getMeta($cf6b6ccb25dee134$export$df61b30b684217c0);
                    // If there is no meta for this plugin and the doc hasn't changed,
                    // nothing can affect our state — return early to avoid expensive
                    // decoration teardown/recreation (which involves React portals).
                    if (!meta && !tr.docChanged) return currentState;
                    const showCursorDropIndicator = meta?.showCursorDropIndicator ?? currentState.showCursorDropIndicator;
                    const dropTargetPos = meta?.dropTargetPos !== undefined ? meta.dropTargetPos : currentState.dropTargetPos;
                    // If nothing meaningful changed, keep the current state as-is
                    // to avoid destroying and recreating the React portal decoration.
                    if (showCursorDropIndicator === currentState.showCursorDropIndicator && dropTargetPos === currentState.dropTargetPos && !tr.docChanged) return currentState;
                    let decorations = currentState.decorations;
                    if (tr.docChanged) decorations = decorations.map(tr.mapping, tr.doc);
                    // Only remove and recreate decorations when the indicator
                    // visibility or position actually changed.
                    const indicatorChanged = showCursorDropIndicator !== currentState.showCursorDropIndicator || dropTargetPos !== currentState.dropTargetPos;
                    if (indicatorChanged) {
                        const cursorDecs = (0, $arMIH.findCursorIndicatorDecs)(decorations);
                        if (cursorDecs.length > 0) decorations = decorations.remove(cursorDecs);
                        if (showCursorDropIndicator && dropTargetPos != null) {
                            const clampedPos = Math.min(dropTargetPos, newState.doc.content.size);
                            const resolvedPos = newState.doc.resolve(clampedPos);
                            // Render the indicator at exactly the position the
                            // pointer resolved to. `resolveDropPosition()` has
                            // already placed `dropTargetPos` at a valid child
                            // boundary inside the innermost descend-into
                            // container — the document root, a `layoutColumn`,
                            // a hub `section`, etc. We must therefore read
                            // the surrounding `prevNode` / `nextNode` /
                            // `parentNode` from THAT depth, not from the
                            // document root, otherwise the gap/offset hints
                            // passed to `createCursorIndicatorDecoration` will
                            // describe the wrong siblings and the indicator
                            // will visually misalign inside nested containers.
                            const indicatorDepth = resolvedPos.depth;
                            const parentNode = resolvedPos.node(indicatorDepth);
                            const indexInParent = resolvedPos.index(indicatorDepth);
                            const prevNode = indexInParent > 0 ? parentNode.child(indexInParent - 1) : null;
                            const nextNode = indexInParent < parentNode.childCount ? parentNode.child(indexInParent) : null;
                            // `lineLength` is intentionally NOT passed any more.
                            // The indicator now sizes itself to its container's
                            // natural width via CSS (`left: 0; right: 0` on an
                            // absolute child of a `width: 100%` host). This is
                            // what makes the indicator behave correctly inside
                            // `layoutColumn`s of differing widths and inside
                            // hub `section` extension frames.
                            const dec = (0, $arMIH.createCursorIndicatorDecoration)(clampedPos, nodeViewPortalProviderAPI, prevNode, nextNode, parentNode);
                            decorations = decorations.add(newState.doc, [
                                dec
                            ]);
                        }
                    }
                    return {
                        decorations: decorations,
                        showCursorDropIndicator: showCursorDropIndicator,
                        dropTargetPos: dropTargetPos
                    };
                } catch  {
                    return currentState;
                }
            }
        },
        props: {
            decorations: (state)=>$cf6b6ccb25dee134$export$df61b30b684217c0.getState(state)?.decorations
        },
        view (editorView) {
            let cleanup;
            try {
                // Track pending rAF to throttle onDrag updates to at most once per frame.
                let rafId = null;
                cleanup = (0, $4Vdlk.monitorForElements)({
                    canMonitor: ({ source: source })=>source.data.type === $cf6b6ccb25dee134$var$HUB_EXTENSION_DRAG_TYPE,
                    onDragStart: ({ location: location })=>{
                        const coords = location.current.input;
                        const dropPos = $cf6b6ccb25dee134$var$resolveDropPosition(editorView, coords.clientX, coords.clientY);
                        editorView.dispatch(editorView.state.tr.setMeta($cf6b6ccb25dee134$export$df61b30b684217c0, {
                            showCursorDropIndicator: true,
                            dropTargetPos: dropPos
                        }));
                    },
                    onDrag: ({ location: location })=>{
                        const coords = location.current.input;
                        const clientX = coords.clientX;
                        const clientY = coords.clientY;
                        // Throttle to one update per animation frame to avoid excessive
                        // ProseMirror transactions while the user is dragging.
                        if (rafId != null) cancelAnimationFrame(rafId);
                        rafId = requestAnimationFrame(()=>{
                            rafId = null;
                            const dropPos = $cf6b6ccb25dee134$var$resolveDropPosition(editorView, clientX, clientY);
                            const currentState = $cf6b6ccb25dee134$export$df61b30b684217c0.getState(editorView.state);
                            // Only dispatch if position actually changed to avoid unnecessary updates
                            if (currentState?.dropTargetPos !== dropPos) editorView.dispatch(editorView.state.tr.setMeta($cf6b6ccb25dee134$export$df61b30b684217c0, {
                                dropTargetPos: dropPos
                            }));
                        });
                    },
                    onDrop: ()=>{
                        if (rafId != null) {
                            cancelAnimationFrame(rafId);
                            rafId = null;
                        }
                        // Always ensure the indicator is cleaned up when a drag
                        // ends. The EditorDropTarget's onDrop already clears the
                        // indicator and inserts content in its own transaction,
                        // but we still need this for drags that end outside the
                        // drop target (cancelled or missed). The apply function's
                        // early-return optimisation ensures this is a no-op when
                        // the indicator was already cleared by EditorDropTarget.
                        const currentState = $cf6b6ccb25dee134$export$df61b30b684217c0.getState(editorView.state);
                        if (currentState?.showCursorDropIndicator) editorView.dispatch(editorView.state.tr.setMeta($cf6b6ccb25dee134$export$df61b30b684217c0, {
                            showCursorDropIndicator: false,
                            dropTargetPos: null
                        }));
                    }
                });
            } catch  {}
            return {
                destroy () {
                    try {
                        cleanup?.();
                    } catch  {}
                }
            };
        }
    });
}
module.exports["key"] = $cf6b6ccb25dee134$export$df61b30b684217c0;
module.exports["createPlugin"] = $cf6b6ccb25dee134$export$ae829ec7b2625219;

});

parcelRegister("2hH3E", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9kbTQ = parcelRequire("9kbTQ");


var $57S2y = parcelRequire("57S2y");


var $r8hvx = parcelRequire("r8hvx");


var $a6uUc = parcelRequire("a6uUc");

const $707330b843c278a7$export$6bbf8dcb80fbe27c = ({ editorView: editorView })=>{
    const navbarContainerRef = (0, $cozmU.useRef)(null);
    const [mounted, setMounted] = (0, $cozmU.useState)(false);
    const { isInPreviewMode: isInPreviewMode } = (0, $r8hvx.useHubContext)();
    (0, $cozmU.useEffect)(()=>{
        const pmDom = editorView?.dom;
        if (!pmDom) return;
        const pmParent = pmDom.parentElement;
        if (!pmParent) return;
        // Insert the Navbar wrapper BEFORE the ProseMirror editable div.
        //
        // To make the navbar span the editor's full width (matching how
        // `full-width` layout extensions break out of the line-length
        // constraint), we mirror the structure used by editor breakout marks
        // (see `BreakoutView` in `@atlaskit/editor-plugin-breakout`):
        //
        //   - The outer element is a flex container that centers its child.
        //     `transform: none` neutralises any inherited transforms that
        //     would otherwise interfere with the inner element overflowing
        //     past the line-length-constrained parent.
        //   - The inner element gets a `min-width` matching the breakout
        //     formula. It uses the same CSS variables the editor exposes on
        //     its content container, so the navbar automatically scales with
        //     the editor's full-width layout, the viewport, and the
        //     guttering/context-panel state.
        const navbarOuterEl = document.createElement('div');
        navbarOuterEl.setAttribute('data-hub-shell-navbar', 'true');
        navbarOuterEl.style.display = 'flex';
        navbarOuterEl.style.justifyContent = 'center';
        navbarOuterEl.style.transform = 'none';
        const navbarInnerEl = document.createElement('div');
        // Share the canvas cap, including max appearance, without a separate flag
        // evaluation. Other consumers retain the legacy full-page breakout width.
        navbarInnerEl.style.minWidth = 'min(calc(100cqw - var(--hub-editor-gutter-padding-inline) * 2 - 8px), var(--hub-editor-canvas-max-width, var(--ak-editor--full-width-layout-width)))';
        navbarOuterEl.appendChild(navbarInnerEl);
        pmParent.insertBefore(navbarOuterEl, pmDom);
        navbarContainerRef.current = navbarInnerEl;
        setMounted(true);
        return ()=>{
            navbarOuterEl.remove();
            navbarContainerRef.current = null;
        };
    }, [
        editorView
    ]);
    if (!mounted || !navbarContainerRef.current) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, $9kbTQ.createPortal)(// In preview mode the navbar should be fully interactive so authors
    // can test navigation. In edit mode pointer-events are disabled to
    // prevent accidental navigation while editing.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6uUc.Navbar), {
        isEditMode: !isInPreviewMode
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57S2y.HubBreadcrumbs), null)), navbarContainerRef.current));
};
module.exports["HubShellContentComponent"] = $707330b843c278a7$export$6bbf8dcb80fbe27c;

});

parcelRegister("8Y2vc", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $4911ab1221aefa96$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    invalidAltText: {
        id: "editor-presets-hub.media.alt-text.invalid",
        defaultMessage: "We aren\u2019t able to accept every possible character in Alt text. All Unicode letters and numbers are OK, but these are the only acceptable symbols: , ' . - _ ( )."
    }
});
module.exports["i18n"] = $4911ab1221aefa96$export$a7357cdd1f0b0168;

});

parcelRegister("iU997", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0843f63249b71140$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    easyCommandsPlaceholder: {
        id: "editor-presets-hub.placeholder.easy-commands-placeholder",
        defaultMessage: "Type / for all elements."
    },
    aiPlaceholder: {
        id: "editor-presets-hub.placeholder.ai-placeholder",
        defaultMessage: "Type /ai for Atlassian Intelligence or / to add elements."
    },
    defaultPlaceholder: {
        id: "editor-presets-hub.placeholder.default-placeholder",
        defaultMessage: "Type / to insert elements"
    }
});
module.exports["i18n"] = $0843f63249b71140$export$a7357cdd1f0b0168;

});

parcelRegister("fAG95", function(module, exports) {
/**
 * The shape of a top-level node in a hub page layout that the template lock
 * cares about. Kept structural so the signature can be unit tested without
 * building a ProseMirror document.
 */ const $40262846c97d9181$export$d103a0257b5710e = (nodes)=>nodes.map((node)=>{
        const { extensionKey: extensionKey, localId: localId } = node.attrs ?? {};
        return `${node.type.name}/${extensionKey ?? ''}/${localId ?? ''}`;
    }).join('|');
module.exports["getTopLevelSignature"] = $40262846c97d9181$export$d103a0257b5710e;

});

parcelRegister("iFduB", function(module, exports) {

var $kCECX = parcelRequire("kCECX");

const $1c1ce65b3ebcdf77$export$bdb7e84dad6ef3a = new (0, $kCECX.PluginKey)('codeBidiWarningPlugin');
module.exports["codeBidiWarningPluginKey"] = $1c1ce65b3ebcdf77$export$bdb7e84dad6ef3a;

});

parcelRegister("13p4p", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");

parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $fYRS9 = parcelRequire("fYRS9");


var $cOjjv = parcelRequire("cOjjv");


var $gLqwM = parcelRequire("gLqwM");


var $cI8RZ = parcelRequire("cI8RZ");


var $8nvEM = parcelRequire("8nvEM");


var $iFduB = parcelRequire("iFduB");


var $2XAa3 = parcelRequire("2XAa3");

const $f6bb13725f8284cf$export$a4805b2c1b031d72 = (nodeViewPortalProviderAPI)=>(0, $cI8RZ.pluginFactory)((0, $iFduB.codeBidiWarningPluginKey), (0, $2XAa3.default), {
        onDocChanged: (tr, pluginState)=>{
            if (!tr.steps.find((0, $gLqwM.stepHasSlice))) return pluginState;
            const newBidiWarningsDecorationSet = $f6bb13725f8284cf$export$f1e73511389847e5({
                doc: tr.doc,
                codeBidiWarningLabel: pluginState.codeBidiWarningLabel,
                tooltipEnabled: pluginState.tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI
            });
            return {
                ...pluginState,
                decorationSet: newBidiWarningsDecorationSet
            };
        }
    });
function $f6bb13725f8284cf$export$f1e73511389847e5({ doc: doc, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI }) {
    const bidiCharactersAndTheirPositions = [];
    doc.descendants((node, pos)=>{
        const isTextWithCodeMark = node.type.name === 'text' && node.marks && node.marks.some((mark)=>mark.type.name === 'code');
        if (isTextWithCodeMark) {
            (0, $cOjjv.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
                bidiCharactersAndTheirPositions.push({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    position: pos + index,
                    bidiCharacter: bidiCharacter
                });
            });
            return false;
        }
        const isCodeBlock = node.type.name === 'codeBlock';
        if (isCodeBlock) (0, $cOjjv.default)(node.textContent, ({ bidiCharacter: bidiCharacter, index: index })=>{
            bidiCharactersAndTheirPositions.push({
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                position: pos + index + 1,
                bidiCharacter: bidiCharacter
            });
        });
    });
    // Bidi characters are not expected to commonly appear in code snippets, so recreating the decoration set
    // for documents rather than reusing existing decorations seems a reasonable performance/complexity tradeoff.
    if (bidiCharactersAndTheirPositions.length === 0) return (0, $8nvEM.DecorationSet).empty;
    const newBidiWarningsDecorationSet = (0, $8nvEM.DecorationSet).create(doc, bidiCharactersAndTheirPositions.map(({ position: position, bidiCharacter: bidiCharacter })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const renderKey = (0, $03RpJ.default)();
        return (0, $8nvEM.Decoration).widget(position, (_el)=>$f6bb13725f8284cf$var$renderDOM({
                bidiCharacter: bidiCharacter,
                codeBidiWarningLabel: codeBidiWarningLabel,
                tooltipEnabled: tooltipEnabled,
                nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                renderKey: renderKey
            }), {
            destroy: (_el)=>{
            // removing portalprovider clean up due to a rendering bug
            // with this plugin under React 18. This matches the previous
            // React 16 behaviour which never cleaned up rendering.
            //
            // This will mean CodeBidi instances are not cleaned up, but
            // this is expected to be minimal due to the low frequency of
            // bidi characters in code blocks.
            //
            // We will fix this in a follow up ticket to rewrite the plugin
            // to use pure toDOM -> ED-26540
            // nodeViewPortalProviderAPI.remove(renderKey);
            }
        });
    }));
    return newBidiWarningsDecorationSet;
}
function $f6bb13725f8284cf$var$renderDOM({ bidiCharacter: bidiCharacter, codeBidiWarningLabel: codeBidiWarningLabel, tooltipEnabled: tooltipEnabled, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, renderKey: renderKey }) {
    const element = document.createElement('span');
    nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fYRS9.default), {
            bidiCharacter: bidiCharacter,
            skipChildren: true,
            label: codeBidiWarningLabel,
            tooltipEnabled: tooltipEnabled
        }), element, renderKey);
    return element;
}
module.exports["pluginFactoryCreator"] = $f6bb13725f8284cf$export$a4805b2c1b031d72;
module.exports["createBidiWarningsDecorationSetFromDoc"] = $f6bb13725f8284cf$export$f1e73511389847e5;

});

parcelRegister("4rOon", function(module, exports) {

var $cLfUm = parcelRequire("cLfUm");

const $3bb5f782f18f51c6$export$1c6fa8f53a5fb47f = (state)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = state.selection;
    const { textColor: textColor } = state.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    else state.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $cLfUm.DEFAULT_COLOR).color;
};
module.exports["getActiveColor"] = $3bb5f782f18f51c6$export$1c6fa8f53a5fb47f;

});

parcelRegister("dkuG1", function(module, exports) {

var $5tsXu = parcelRequire("5tsXu");


var $fT5ir = parcelRequire("fT5ir");

const $fbf45ef4bd2aa8fb$export$4a26621adcb675d6 = ()=>(state, dispatch)=>{
        const { schema: schema } = state;
        const { textColor: textColor } = schema.marks;
        const tr = state.tr;
        (0, $5tsXu.removeMark)(textColor)({
            tr: tr
        });
        if (dispatch) dispatch(tr.setMeta((0, $fT5ir.pluginKey), {
            action: (0, $fT5ir.ACTIONS).RESET_COLOR
        }));
        return true;
    };
module.exports["removeColor"] = $fbf45ef4bd2aa8fb$export$4a26621adcb675d6;

});

parcelRegister("lAUnx", function(module, exports) {

var $5tsXu = parcelRequire("5tsXu");


var $bhf6v = parcelRequire("bhf6v");


var $fT5ir = parcelRequire("fT5ir");


var $cLfUm = parcelRequire("cLfUm");


var $hpWwK = parcelRequire("hpWwK");

const $1e41a971fe6a78b9$export$afb561a73dff6672 = (color)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        const tr = state.tr;
        const disabledState = (0, $hpWwK.getDisabledState)(state);
        if (disabledState) {
            if (dispatch) dispatch(tr.setMeta((0, $fT5ir.pluginKey), {
                action: (0, $fT5ir.ACTIONS).DISABLE
            }));
            return false;
        }
        if (dispatch) {
            (0, $cLfUm.overrideMarks).forEach((mark)=>{
                const { marks: marks } = tr.doc.type.schema;
                if (marks[mark]) (0, $5tsXu.removeMark)(marks[mark])({
                    tr: tr
                });
            });
            (0, $bhf6v.toggleMark)(textColor, {
                color: color
            })({
                tr: tr
            });
            dispatch(tr);
        }
        return true;
    };
module.exports["toggleColor"] = $1e41a971fe6a78b9$export$afb561a73dff6672;

});

parcelRegister("cLfUm", function(module, exports) {

var $89bON = parcelRequire("89bON");

const $b7fcef61cccb20d5$export$ccbc17c7832f26ef = [
    'backgroundColor'
];
const $b7fcef61cccb20d5$export$37394b0fa44b998c = {
    color: (0, $89bON.getTokenValue)('color.text'),
    label: 'Default'
};
module.exports["overrideMarks"] = $b7fcef61cccb20d5$export$ccbc17c7832f26ef;
module.exports["DEFAULT_COLOR"] = $b7fcef61cccb20d5$export$37394b0fa44b998c;

});

parcelRegister("hpWwK", function(module, exports) {

var $kzHT3 = parcelRequire("kzHT3");

var $adJV7 = parcelRequire("adJV7");


var $cLfUm = parcelRequire("cLfUm");

const $f1be6582f99aecf7$var$hasLinkMark = ($pos)=>{
    const { doc: { type: { schema: { marks: { link: linkMarkType } } } }, pos: pos } = $pos;
    if (!linkMarkType) return false;
    return $pos.doc.rangeHasMark(pos, Math.min(pos + 1, $pos.doc.content.size), linkMarkType);
};
const $f1be6582f99aecf7$export$4af1020a67b5ec91 = (state)=>{
    const { textColor: textColor } = state.schema.marks;
    if (textColor) {
        const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
        if (empty && !$cursor || $cursor && $f1be6582f99aecf7$var$hasLinkMark($cursor) || (0, $kzHT3.isMarkAllowedInRange)(state.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $cLfUm.overrideMarks).includes(mark.type.name);
        };
        if ((0, $adJV7.isMarkExcluded)(textColor, state.storedMarks?.filter(omitOverrides) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};
module.exports["getDisabledState"] = $f1be6582f99aecf7$export$4af1020a67b5ec91;

});

parcelRegister("7qyDa", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $12XbP = parcelRequire("12XbP");


var $cXCJB = parcelRequire("cXCJB");


var $5tPGk = parcelRequire("5tPGk");


var $4pBmf = parcelRequire("4pBmf");


var $lH6tf = parcelRequire("lH6tf");


var $6lSx6 = parcelRequire("6lSx6");

var $39b0034b97410c1c$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primary";
    ToolbarType["FLOATING"] = "floating";
    return ToolbarType;
}({});
const $39b0034b97410c1c$export$803d4933f12f6ddc = (0, $kSwu1.injectIntl)(({ pluginState: pluginState, editorView: editorView, pluginInjectionApi: pluginInjectionApi, disabled: disabled })=>{
    const blackWhiteColorMap = (0, $5tPGk.createBuiltInColorMap)({
        knownColors: [
            "var(--ds-text-inverse, #FFFFFF)",
            "var(--ds-text, #292A2E)"
        ]
    });
    // Help Hub advanced theming: surface the 22-swatch brand palette
    // (20 palette shades + white + black) in the text-color picker so
    // heading/normal text can use brand colours. Gated on the advanced
    // theming flag via `isAdvancedThemingEnabled` — when OFF (or outside a
    // HubThemingProvider, e.g. cross-host) `useHubTheming()` is undefined
    // and we fall back to the black/white default.
    const theming = (0, $4pBmf.useHubTheming)();
    const builtInColorMap = theming?.isAdvancedThemingEnabled && theming.brandBackgroundColorMap ? theming.brandBackgroundColorMap : blackWhiteColorMap;
    const changeTextColor = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((color)=>{
        if (color && !disabled) (0, $lH6tf.changeColor)(color, pluginInjectionApi?.analytics?.actions)(editorView.state, editorView.dispatch);
        editorView?.focus();
        return false;
    }, [
        disabled,
        editorView,
        pluginInjectionApi?.analytics?.actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12XbP.ToolbarDropdownWrapper), {
        "data-testid": "company-hub-text-color-picker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cXCJB.ColorPicker), {
        analyticsSource: "companyHubToolbarTextColor",
        builtInColorMap: builtInColorMap,
        onChange: changeTextColor,
        value: pluginState.color || pluginState.defaultColor,
        isDisabled: disabled || pluginState.disabled,
        pickerTitle: (0, $6lSx6.messages).colorPickerTitle,
        showCustomPalette: true,
        showTextIcon: true,
        enableBorderLessStyle: true
    }));
});
module.exports["ToolbarType"] = $39b0034b97410c1c$export$a5d11b3163e4b1a5;
module.exports["ToolbarCompanyHubTextColor"] = $39b0034b97410c1c$export$803d4933f12f6ddc;

});

parcelRegister("gUU6c", function(module, exports) {
/* CompanyHubTextColorButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $c2kFl = parcelRequire("c2kFl");


var $7XIuB = parcelRequire("7XIuB");


var $bFSJa = parcelRequire("bFSJa");


var $uyXFl = parcelRequire("uyXFl");


var $9Muxb = parcelRequire("9Muxb");


var $3k5Tv = parcelRequire("3k5Tv");


var $g8ETs = parcelRequire("g8ETs");


var $9Rqjc = parcelRequire("9Rqjc");


var $7Y8M5 = parcelRequire("7Y8M5");


var $imx1A = parcelRequire("imx1A");


var $6t3CY = parcelRequire("6t3CY");


var $WcuYo = parcelRequire("WcuYo");


var $lslMH = parcelRequire("lslMH");


var $b2jdX = parcelRequire("b2jdX");


var $dinVW = parcelRequire("dinVW");


var $89bON = parcelRequire("89bON");


var $xYZ24 = parcelRequire("xYZ24");


var $5tPGk = parcelRequire("5tPGk");


var $4pBmf = parcelRequire("4pBmf");


var $lH6tf = parcelRequire("lH6tf");


var $lpukL = parcelRequire("lpukL");


var $dRHIT = parcelRequire("dRHIT");

const $e2c4bfa16fd24619$var$popupComponentStyles = {
    popupWrapper: "_0bjKvDKxmn _0KLXrulfZc _2OUyjtGk8v _0Of8r28HPE _1Znuxb8HPE _1wydGW8HPE _2Zuz6Q8HPE"
};
const $e2c4bfa16fd24619$var$getHighlightColorIcon = (highlightColor)=>{
    if (highlightColor) return (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)(highlightColor);
    return undefined;
};
const $e2c4bfa16fd24619$var$PopupWithListeners = (0, $9Muxb.default)((0, $7XIuB.default));
const $e2c4bfa16fd24619$export$5738d006e3bc472b = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const buttonRef = (0, $cozmU.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $b2jdX.useToolbarUI)();
    const { editorView: editorView } = (0, $bFSJa.useEditorToolbar)();
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const { color: color, defaultColor: defaultColor, disabled: textColorDisabled, highlightColor: highlightColor } = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'companyHubTextColor',
        'highlight'
    ], (states)=>({
            color: states.companyHubTextColorState?.color,
            defaultColor: states.companyHubTextColorState?.defaultColor,
            disabled: states.companyHubTextColorState?.disabled,
            highlightColor: states.highlightState?.activeColor
        }));
    const blackWhiteColorMap = (0, $cozmU.useMemo)(()=>(0, $5tPGk.createBuiltInColorMap)({
            knownColors: [
                (0, $89bON.getTokenValue)('color.text.inverse'),
                (0, $89bON.getTokenValue)('color.text')
            ]
        }), []); // Help Hub advanced theming: surface the 22-swatch brand palette (20
    // palette shades + white + black) in the text-color picker so heading /
    // normal text can use brand colours. Gated on the advanced theming flag
    // via `isAdvancedThemingEnabled` — when OFF (or outside a
    // HubThemingProvider, e.g. cross-host) `useHubTheming()` is undefined and
    // we fall back to the black/white default.
    const theming = (0, $4pBmf.useHubTheming)();
    const builtInColorMap = theming?.isAdvancedThemingEnabled && theming.brandBackgroundColorMap ? theming.brandBackgroundColorMap : blackWhiteColorMap;
    const getIconColor = (0, $cozmU.useCallback)(()=>{
        if (!color || color === defaultColor) return (0, $89bON.getTokenValue)('color.text');
         // find a matching editor text palette color for the hex color
        // if none is found, return the hex color itself
        return (0, $g8ETs.hexToEditorTextPaletteColor)(color) || color || (0, $89bON.getTokenValue)('color.text');
    }, [
        color,
        defaultColor
    ]);
    const handleColorChange = (0, $cozmU.useCallback)((color_0)=>{
        if (color_0 && !textColorDisabled && editorView?.state && editorView?.dispatch) {
            (0, $lH6tf.changeColor)(color_0, api?.analytics?.actions)(editorView.state, editorView.dispatch);
            editorView.focus();
        }
        setIsOpen(false);
        return false;
    }, [
        textColorDisabled,
        editorView,
        api?.analytics?.actions
    ]);
    const handleInternalClick = (0, $cozmU.useCallback)((evt)=>{
        // Stop propagation of clicks inside the popup to prevent the document click listener from triggering
        // Without this, clicking on RGB/HEX/HSL dropdown would close the popup immediately
        evt.stopPropagation();
    }, []);
    const handleInternalKeyDown = (0, $cozmU.useCallback)((evt_0)=>{
        // Stop propagation of keyboard events inside the popup to prevent the document listener from triggering
        // Support standard keyboard interactions for interactive elements within the popup
        if (evt_0.key === 'Enter' || evt_0.key === ' ') evt_0.stopPropagation();
    }, []);
    const closeMenu = (0, $cozmU.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        setIsOpen,
        isOpen
    ]);
    if (!api?.companyHubTextColor || color === undefined || defaultColor === undefined) return null;
    const iconColor = getIconColor();
    const isDisabled = Boolean(textColorDisabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isOpen && buttonRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e2c4bfa16fd24619$var$PopupWithListeners, {
        target: buttonRef.current,
        zIndex: (0, $7Y8M5.akEditorFloatingOverlapPanelZIndex),
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        alignY: "top",
        alignX: "left",
        handleClickOutside: closeMenu,
        handleEscapeKeydown: closeMenu,
        allowOutOfBounds: true,
        fitHeight: 350,
        fitWidth: 350,
        preventOverflow: true,
        stick: false,
        offset: [
            0,
            10
        ],
        focusTrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyXFl.OutsideClickTargetRefContext).Consumer, null, (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            role: "none",
            "data-test-id": 'company-hub-text-color-picker',
            onClick: handleInternalClick,
            onKeyDown: handleInternalKeyDown,
            ref: setOutsideClickTargetRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            xcss: $e2c4bfa16fd24619$var$popupComponentStyles.popupWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $xYZ24.ColorPickerDropdown), {
            appearance: "embedded",
            analyticsSource: "companyHubToolbarTextColor",
            builtInColorMap: builtInColorMap,
            onChange: handleColorChange,
            value: color || defaultColor,
            pickerTitle: (0, $c2kFl.companyHubTextColorMessages).colorPickerTitle,
            showCustomPalette: true,
            isOpen: true,
            update: ()=>Promise.resolve(null)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpukL.HighlightColorSection), {
            api: api,
            parents: parents
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dRHIT.RemoveColorSection), {
            api: api,
            parents: parents
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lslMH.ToolbarTooltip), {
        content: formatMessage((0, $c2kFl.companyHubTextColorMessages).colorPickerTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6t3CY.ToolbarButton), {
        testId: "company-hub-text-color-toolbar-button",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $WcuYo.ToolbarColorSwatch), {
            highlightColor: $e2c4bfa16fd24619$var$getHighlightColorIcon(highlightColor)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $imx1A.TextColorIcon), {
            label: formatMessage((0, $c2kFl.companyHubTextColorMessages).colorPickerTitle),
            iconColor: iconColor,
            size: 'small',
            isDisabled: isDisabled,
            spacing: 'compact'
        })),
        ref: buttonRef,
        onClick: handleClick,
        isSelected: isOpen,
        isDisabled: isDisabled
    })));
};
module.exports["CompanyHubTextColorButton"] = $e2c4bfa16fd24619$export$5738d006e3bc472b;

});

parcelRegister("arMIH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $03RpJ = parcelRequire("03RpJ");


var $8nvEM = parcelRequire("8nvEM");


var $91TKv = parcelRequire("91TKv");

const $058315dbd776c173$export$b81140debd8a9739 = 'hub-external-insert-cursor';
function $058315dbd776c173$export$f06d6d3dfe4b012f(decorations) {
    return decorations.find(0, 1e9, (spec)=>spec.type === $058315dbd776c173$export$b81140debd8a9739);
}
/** Minimal gap/offset for cursor indicator alignment (first version – constants). */ function $058315dbd776c173$var$getGapAndOffset(_prevNode, _nextNode, _parentNode) {
    if (!_prevNode && _nextNode) return {
        gap: 0,
        offset: 0
    };
    if (_prevNode && !_nextNode) return {
        gap: 0,
        offset: 0
    };
    return {
        gap: 4,
        offset: 0
    };
}
function $058315dbd776c173$export$f9707a82f2564638(pos, nodeViewPortalProviderAPI, prevNode, nextNode, parentNode) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const key = `hub-external-insert-cursor-${(0, $03RpJ.default)()}`;
    const { gap: gap, offset: offset } = $058315dbd776c173$var$getGapAndOffset(prevNode, nextNode, parentNode);
    return (0, $8nvEM.Decoration).widget(pos, ()=>{
        const element = document.createElement('div');
        element.setAttribute('data-hub-external-insert-cursor', 'true');
        element.style.clear = 'unset';
        element.style.display = 'block';
        // `position: relative` makes this host the offset parent of
        // the indicator's `position: absolute` container, so the
        // indicator's `left: 0; right: 0` resolves against this
        // host's natural (container-constrained) width.
        element.style.position = 'relative';
        element.style.width = '100%';
        element.style.setProperty((0, $91TKv.CURSOR_DROP_INDICATOR_OFFSET), `${offset}px`);
        element.style.setProperty((0, $91TKv.CURSOR_DROP_INDICATOR_GAP), `${gap}px`);
        try {
            nodeViewPortalProviderAPI.render(()=>(0, $cozmU.createElement)((0, $91TKv.CursorDropIndicator)), element, key, undefined, true);
        } catch  {}
        return element;
    }, {
        type: $058315dbd776c173$export$b81140debd8a9739,
        destroy: ()=>{
            nodeViewPortalProviderAPI.remove(key);
        }
    });
}
module.exports["findCursorIndicatorDecs"] = $058315dbd776c173$export$f06d6d3dfe4b012f;
module.exports["createCursorIndicatorDecoration"] = $058315dbd776c173$export$f9707a82f2564638;

});

parcelRegister("57S2y", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

parcelRequire("cvj4z");
var $j4NNn = parcelRequire("j4NNn");


var $gBjHb = parcelRequire("gBjHb");


var $33jh4 = parcelRequire("33jh4");


var $dX71b = parcelRequire("dX71b");


var $6cA3O = parcelRequire("6cA3O");


var $lnxfH = parcelRequire("lnxfH");


var $7gqwM = parcelRequire("7gqwM");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $4HuLY = parcelRequire("4HuLY");


var $r8hvx = parcelRequire("r8hvx");


var $6D10p = parcelRequire("6D10p");


var $1hWe9 = parcelRequire("1hWe9");


var $805yB = parcelRequire("805yB");

const $58d98241c60e9c9d$var$styles = {
    container: "_24h04i2Njc _4ouGXIdnbC _1wydGWNHnM _2Zuz6QNHnM _1ZnuxbNHnM _39xV02N91d",
    item: "_2sNsIgmnOE _3iDTPbQ4SZ _24h04i2Njc _4ouGXIdnbC _1EqgXlN91d _0hPCNLDIqT _4xdlr0DIqT _0aFT5v1qpb _313842dnbC",
    separator: "_4c065UFQfX _2Y7lL42ADO _39xV02Jg58 _3YEZNOdnbC _2fwxA5DIqT",
    itemText: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7"
};
const $58d98241c60e9c9d$var$StaticHubParentBreadcrumb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { item: item } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.itemText
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== item.text) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest",
            maxLines: 1
        }, item.text));
        $[1] = item.text;
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": true,
            className: (0, $hekY6.default)([
                $58d98241c60e9c9d$var$styles.separator
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            color: "color.text.subtlest"
        }, "/"));
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $58d98241c60e9c9d$var$styles.item,
            as: "li"
        }, t2, t3);
        $[4] = t2;
        $[5] = t4;
    } else t4 = $[5];
    return t4;
} : ({ item: item })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $58d98241c60e9c9d$var$styles.item,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.itemText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: 'color.text.subtlest',
        maxLines: 1
    }, item.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": true,
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.separator
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, "/")));
};
const $58d98241c60e9c9d$var$StaticHubCurrentBreadcrumb = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { item: item } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.itemText
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== item.text) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $58d98241c60e9c9d$var$styles.item,
            as: "li"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-current": "page",
            className: t1
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            maxLines: 1
        }, item.text)));
        $[1] = item.text;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ item: item })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $58d98241c60e9c9d$var$styles.item,
        as: "li"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-current": "page",
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.itemText
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        maxLines: 1
    }, item.text)));
};
const $58d98241c60e9c9d$export$e610d88d5224ae75 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { itemCount: itemCount } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            (0, $4HuLY.HUB_FEATURES).BREADCRUMBS
        ];
        $[0] = t1;
    } else t1 = $[0];
    const [isBreadcrumbsEnabled] = (0, $4HuLY.useIsHubFeatureEnabled)(t1);
    if (!isBreadcrumbsEnabled) return null;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.container
        ]);
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== itemCount) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lnxfH.default), null, Array.from({
            length: itemCount
        }).map($58d98241c60e9c9d$var$_temp));
        $[2] = itemCount;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t2 || $[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t2
        }, t3);
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    return t4;
} : ({ itemCount: itemCount })=>{
    const [isBreadcrumbsEnabled] = (0, $4HuLY.useIsHubFeatureEnabled)([
        (0, $4HuLY.HUB_FEATURES).BREADCRUMBS
    ]);
    if (!isBreadcrumbsEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lnxfH.default), null, Array.from({
        length: itemCount
    }).map((_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gqwM.default), {
            width: 60,
            key: index
        }))));
};
const $58d98241c60e9c9d$export$cc8c957f0e477af0 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(26);
    const intl = (0, $kSwu1.useIntl)();
    const items = (0, $1hWe9.useHubBreadcrumbItems)();
    const currentItem = items[items.length - 1];
    const { env: t0 } = (0, $r8hvx.useHubContext)();
    const { relativeBaseUrl: relativeBaseUrl } = t0;
    const { push: push } = (0, $j4NNn.useRouterActions)();
    if (!currentItem) return null;
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage((0, $805yB.messages).label);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const label = t1;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage((0, $805yB.messages).showMore);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const ellipsisLabel = t2;
    let t3;
    if ($[4] !== push) {
        t3 = (href)=>(event)=>{
                const isPrimaryClick = "button" in event && event.button === 0;
                const isEnterKey = "key" in event && event.key === "Enter";
                if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
                    event.preventDefault();
                    push(href);
                }
            };
        $[4] = push;
        $[5] = t3;
    } else t3 = $[5];
    const onBreadcrumbItemClick = t3;
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.container
        ]);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== items || $[8] !== onBreadcrumbItemClick || $[9] !== relativeBaseUrl) {
        let t6;
        if ($[11] !== onBreadcrumbItemClick || $[12] !== relativeBaseUrl) {
            t6 = (item, index)=>item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
                    data: {
                        attributes: {
                            itemType: item.id,
                            position: index + 1
                        }
                    },
                    key: item.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cA3O.default), {
                    href: (0, $6D10p.getHubBreadcrumbHref)(relativeBaseUrl, item.href),
                    onClick: onBreadcrumbItemClick(item.href),
                    text: item.text
                })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58d98241c60e9c9d$var$StaticHubParentBreadcrumb, {
                    item: item,
                    key: item.id
                });
            $[11] = onBreadcrumbItemClick;
            $[12] = relativeBaseUrl;
            $[13] = t6;
        } else t6 = $[13];
        t5 = items.slice(0, -1).map(t6);
        $[7] = items;
        $[8] = onBreadcrumbItemClick;
        $[9] = relativeBaseUrl;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[14] !== currentItem || $[15] !== items.length || $[16] !== relativeBaseUrl) {
        t6 = currentItem.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: {
                attributes: {
                    itemType: currentItem.id,
                    position: items.length
                }
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dX71b.default), {
            href: (0, $6D10p.getHubBreadcrumbHref)(relativeBaseUrl, currentItem.href),
            text: currentItem.text
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58d98241c60e9c9d$var$StaticHubCurrentBreadcrumb, {
            item: currentItem
        });
        $[14] = currentItem;
        $[15] = items.length;
        $[16] = relativeBaseUrl;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== ellipsisLabel || $[19] !== label || $[20] !== t5 || $[21] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33jh4.default), {
            ellipsisLabel: ellipsisLabel,
            label: label,
            size: "medium",
            testId: "hub-breadcrumbs"
        }, t5, t6);
        $[18] = ellipsisLabel;
        $[19] = label;
        $[20] = t5;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    let t8;
    if ($[23] !== t4 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "hub-breadcrumbs-container",
            className: t4
        }, t7);
        $[23] = t4;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
} : ()=>{
    const intl = (0, $kSwu1.useIntl)();
    const items = (0, $1hWe9.useHubBreadcrumbItems)();
    const currentItem = items[items.length - 1];
    const { env: { relativeBaseUrl: relativeBaseUrl } } = (0, $r8hvx.useHubContext)();
    const { push: push } = (0, $j4NNn.useRouterActions)();
    if (!currentItem) return null;
    const label = intl.formatMessage((0, $805yB.messages).label);
    const ellipsisLabel = intl.formatMessage((0, $805yB.messages).showMore);
    const onBreadcrumbItemClick = (href)=>(event)=>{
            const isPrimaryClick = 'button' in event && event.button === 0;
            const isEnterKey = 'key' in event && event.key === 'Enter';
            if (!event.defaultPrevented && (isPrimaryClick || isEnterKey) && !event.metaKey && !event.ctrlKey && !event.altKey && !event.shiftKey) {
                // The anchor needs the Hub base path, but browser history adds it on navigation.
                event.preventDefault();
                push(href);
            }
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "hub-breadcrumbs-container",
        className: (0, $hekY6.default)([
            $58d98241c60e9c9d$var$styles.container
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $33jh4.default), {
        ellipsisLabel: ellipsisLabel,
        label: label,
        size: "medium",
        testId: "hub-breadcrumbs"
    }, items.slice(0, -1).map((item, index)=>item.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
            data: {
                attributes: {
                    itemType: item.id,
                    position: index + 1
                }
            },
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6cA3O.default), {
            href: (0, $6D10p.getHubBreadcrumbHref)(relativeBaseUrl, item.href),
            onClick: onBreadcrumbItemClick(item.href),
            text: item.text
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58d98241c60e9c9d$var$StaticHubParentBreadcrumb, {
            item: item,
            key: item.id
        })), currentItem.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: {
            attributes: {
                itemType: currentItem.id,
                position: items.length
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dX71b.default), {
        href: (0, $6D10p.getHubBreadcrumbHref)(relativeBaseUrl, currentItem.href),
        text: currentItem.text
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($58d98241c60e9c9d$var$StaticHubCurrentBreadcrumb, {
        item: currentItem
    })));
};
function $58d98241c60e9c9d$var$_temp(_, index) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7gqwM.default), {
        width: 60,
        key: index
    });
}
module.exports["HubBreadcrumbs"] = $58d98241c60e9c9d$export$cc8c957f0e477af0;

});

parcelRegister("a6uUc", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");

parcelRequire("fMvIa");
var $8Dc6h = parcelRequire("8Dc6h");
var $idnP4 = parcelRequire("idnP4");


var $2lscT = parcelRequire("2lscT");


var $arQY7 = parcelRequire("arQY7");


var $ad7Ou = parcelRequire("ad7Ou");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $l3wuH = parcelRequire("l3wuH");


var $untPk = parcelRequire("untPk");


var $lskrC = parcelRequire("lskrC");


var $7Mix9 = parcelRequire("7Mix9");


var $iFlah = parcelRequire("iFlah");


var $iODl6 = parcelRequire("iODl6");


var $iDrrr = parcelRequire("iDrrr");


var $4n1IT = parcelRequire("4n1IT");


var $iMnC5 = parcelRequire("iMnC5");


var $4ez2K = parcelRequire("4ez2K");


var $jg3tF = parcelRequire("jg3tF");


var $d7SWg = parcelRequire("d7SWg");


var $hhnRo = parcelRequire("hhnRo");


var $4WDWC = parcelRequire("4WDWC");


var $eafQX = parcelRequire("eafQX");


var $51SAu = parcelRequire("51SAu");


var $r8hvx = parcelRequire("r8hvx");


var $gMq3e = parcelRequire("gMq3e");


var $1STAw = parcelRequire("1STAw");


var $ceKKZ = parcelRequire("ceKKZ");


var $hIH5w = parcelRequire("hIH5w");


var $7oSFe = parcelRequire("7oSFe");


const $ee5d7114683e59af$var$MobileMenuOverlay = /*#__PURE__*/ (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-kuPuvu", ()=>(parcelRequire("kPBMe")).then((m)=>({
            default: m.MobileMenuOverlay
        }))));
const $ee5d7114683e59af$var$motionStyles = {
    slideEntering: "_1gBibyJtnr _0nFVCGLrT7 _43vdfTjwM9",
    slideExiting: "_1gBibyMmpp _0nFVCGLrT7 _43vdfTyNAO"
};
const $ee5d7114683e59af$var$styles = {
    navbarStacking: "_1mT5xdRAKS _42Yu6Bbhqd",
    navbar: "_0Of8r2NHnM _1ZnuxbNHnM _1wydGWNHnM _2Zuz6QNHnM",
    navbarUpdated: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    navBarDisabled: "_1pp6NdYbGa",
    logoContainer: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    rightSection: "_2mHwu88HPE _3iDTPbQ4SZ _0hPCNLDIqT _3YEZNOdnbC"
};
const $ee5d7114683e59af$export$42cfbb80f7861e77 = ({ isEditMode: isEditMode = false, isViewportSticky: isViewportSticky = false })=>{
    (0, $6cFsl.di)((0, $iDrrr.fg), (0, $r8hvx.useHubContext), (0, $idnP4.useRouterActions));
    const [isAvatarMenuOpen, setIsAvatarMenuOpen] = (0, $cozmU.useState)(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = (0, $cozmU.useState)(false);
    const [viewportMatches, setViewportMatches] = (0, $cozmU.useState)();
    const navbarRef = (0, $cozmU.useRef)(null);
    const isViewportSwitchEnabled = (0, $iDrrr.fg)('switch-hub-nav-bar');
    const handleViewportChange = (0, $cozmU.useCallback)((event)=>{
        setViewportMatches(event.matches);
        setIsMobileMenuOpen(false);
        setIsAvatarMenuOpen(false);
    }, []);
    const mediaQuery = (0, $jg3tF.UNSAFE_useMediaQuery)('below.sm', isViewportSwitchEnabled ? handleViewportChange : undefined);
    const isBelowSm = (isViewportSwitchEnabled ? viewportMatches : undefined) ?? mediaQuery?.matches ?? false;
    const hubContext = (0, $r8hvx.useHubContext)();
    const { featureFlags: featureFlags, hubType: hubType } = hubContext;
    const { options: navStyle } = (0, $d7SWg.useNavigationStyle)(); // Keep a black/white navbar label legible against the live brand colour. The
    // navbar's day-0 background is the darkest brand shade, so a brand change can
    // invert which of black/white is readable. An explicit colour is left alone.
    // See `hub-auto-text-color`.
    const resolveNavTextColor = (0, $hhnRo.useHubAutoTextColor)('hub-app-shell');
    const navTextColor = resolveNavTextColor({
        backgroundColor: navStyle?.backgroundColor,
        textColor: navStyle?.textColor,
        defaultRef: 'primary.1000'
    });
    const isNavBarUpdated = featureFlags?.hub_component_upgrade ?? false;
    const isLoginButtonContrastGateEnabled = (0, $iDrrr.fg)('hubs_nav_login_button_contrast');
    const isLoginButtonContrastEnabled = isNavBarUpdated && isLoginButtonContrastGateEnabled;
    const isCornerRadiusEnabled = (0, $eafQX.useIsHubCornerRadiusEnabled)(); // A navbar-specific corner radius is Premium. Suppressing it makes the navbar
    // inherit the hub-wide radius, which the backend resets to the 8px default.
    // Only the gated path is neutralised: the legacy path below has no hub-wide
    // value to fall back to, so it keeps applying the saved radius.
    const isCornerRadiusLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const shouldShowMobileNavLinks = isNavBarUpdated && isBelowSm;
    const dynamicStyle = (0, $cozmU.useMemo)(()=>{
        if (!navStyle) return undefined;
        const border = `1px solid ${navStyle.borderColor}`; // Gate ON: always drive from the hub-wide CSS var; pin it locally only when
        // this navbar has an explicit numeric radius, otherwise inherit the global.
        // Gate OFF: legacy fixed px (cornerRadius is always a number here).
        const cornerRadiusStyle = isCornerRadiusEnabled ? {
            borderRadius: navStyle.padding ? `var(${0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR})` : '0',
            ...!isCornerRadiusLocked && navStyle.padding && typeof navStyle.cornerRadius === 'number' ? {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                [(0, $4WDWC.HUB_CORNER_RADIUS_CSS_VAR)]: `${(0, $4WDWC.resolveHubCornerRadius)(navStyle.cornerRadius)}px`
            } : {}
        } : // Gate OFF: legacy fixed px. `cornerRadius` is typed `number | null`; if an
        // unset (null) value ever reaches this branch, fall back to the legacy
        // 8px default (matching the mapper's gate-off coercion) rather than
        // rendering an invalid "nullpx".
        {
            borderRadius: navStyle.padding ? `${navStyle.cornerRadius ?? 8}px` : '0'
        }; // Fixed ("Fixed to top") navbar layout differs by cohort.
        const fixedNavLayoutStyle = isViewportSticky ? {
            // The shell wraps padded fixed navbars in a sticky, background-covered
            // container in view mode. That wrapper owns the top gap so it cannot
            // scroll away; don't add a second offset or margin to the navbar.
            top: '0px'
        } : {
            // The sticky offset provides the top gap when viewport stickiness is disabled.
            top: navStyle.padding && navStyle.fixedAtTop ? "var(--ds-space-300, 24px)" : '0px',
            marginTop: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined
        };
        return {
            backgroundColor: navStyle.backgroundColor,
            color: navTextColor,
            ...cornerRadiusStyle,
            border: navStyle.borderType === 'ALL_BORDER' ? border : 'none',
            // this will be the css 'none' value
            borderBottom: [
                'BOTTOM_BORDER',
                'ALL_BORDER'
            ].includes(navStyle.borderType) ? border : undefined,
            // bottom border is always applied for all borders
            position: navStyle.fixedAtTop ? 'sticky' : 'relative',
            ...fixedNavLayoutStyle,
            marginLeft: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            marginRight: navStyle.padding ? "var(--ds-space-300, 24px)" : undefined,
            // The padded sticky wrapper owns the bottom gap in view mode, keeping
            // that spacing outside its background-covered area while scrolling.
            marginBottom: isViewportSticky && navStyle.padding ? 0 : "var(--ds-space-300, 24px)",
            transition: 'margin 0.3s ease, border-radius 0.3s ease, top 0.3s ease'
        };
    }, [
        navStyle,
        navTextColor,
        isCornerRadiusEnabled,
        isCornerRadiusLocked,
        isViewportSticky
    ]);
    const iconColor = isNavBarUpdated ? navTextColor : undefined;
    const { push: push } = (0, $idnP4.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const logoUrl = hubContext.branding.logo.url;
    const { avatarSrc: avatarSrc, email: email } = hubContext.user;
    const { renderCustomNavActions: renderCustomNavActions, renderRightNavActions: renderRightNavActions } = hubContext;
    const isAnonymousRoute = hubContext.layout?.isAnonymousRoute || false;
    const homePath = isAnonymousRoute ? '/user/login' : '/';
    const isHomeLinkHrefEnabled = (0, $iDrrr.fg)('csm_support_site_home_link_href');
    const handleHomeClick = (0, $cozmU.useCallback)((event_0)=>{
        if (event_0.defaultPrevented || event_0.metaKey || event_0.ctrlKey || event_0.shiftKey || event_0.altKey || 'button' in event_0 && event_0.button !== 0) return;
         // Keep router navigation relative; the href includes the hub base path.
        event_0.preventDefault();
        push(homePath);
    }, [
        homePath,
        push
    ]);
    const handleInboxClick = (0, $cozmU.useCallback)(()=>{
        push(`/user/requests`);
    }, [
        push
    ]);
    const handleProfileClick = (0, $cozmU.useCallback)(()=>{
        setIsAvatarMenuOpen(!isAvatarMenuOpen);
    }, [
        isAvatarMenuOpen
    ]);
    const handleAvatarMenuClose = (0, $cozmU.useCallback)(()=>{
        setIsAvatarMenuOpen(false);
    }, []);
    const handleHamburgerClick = (0, $cozmU.useCallback)(()=>{
        setIsMobileMenuOpen(true);
    }, []);
    const handleMobileMenuClose = (0, $cozmU.useCallback)(()=>{
        setIsMobileMenuOpen(false);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: navbarRef,
        "data-testId": "navbar",
        ...isEditMode ? {
            inert: ''
        } : {},
        xcss: (0, $w6R6I.cx)($ee5d7114683e59af$var$styles.navbarStacking, isNavBarUpdated ? $ee5d7114683e59af$var$styles.navbarUpdated : $ee5d7114683e59af$var$styles.navbar, isEditMode && $ee5d7114683e59af$var$styles.navBarDisabled),
        style: isNavBarUpdated ? dynamicStyle : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ee5d7114683e59af$var$styles.logoContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Dc6h.default), {
        to: homePath,
        ...isHomeLinkHrefEnabled ? {
            href: `${hubContext.env.relativeBaseUrl.replace(/\/$/, '')}${homePath}`,
            onClick: handleHomeClick
        } : {}
    }, logoUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        height: (0, $gMq3e.getHubLogoHeight)(hubType),
        src: logoUrl,
        alt: formatMessage((0, $ceKKZ.default).hubLogo)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: isLoginButtonContrastEnabled ? 'subtle' : 'default',
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($untPk))), {
                ...iconProps,
                color: iconColor
            }),
        label: formatMessage((0, $ceKKZ.default).hubLogo),
        color: navTextColor
    }))), !isAnonymousRoute && email && isNavBarUpdated && !isBelowSm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hIH5w.NavLinks), {
        textColor: navTextColor,
        backgroundColor: navStyle?.backgroundColor
    }), !isAnonymousRoute && email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ee5d7114683e59af$var$styles.rightSection
    }, !isNavBarUpdated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, renderRightNavActions && renderRightNavActions()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lskrC))), {
                ...iconProps_0,
                color: iconColor
            }),
        label: "User requests",
        onClick: handleInboxClick
    })), shouldShowMobileNavLinks ? isMobileMenuOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
                ...iconProps_1,
                color: iconColor
            }),
        label: formatMessage((0, $ceKKZ.default).closeMenu),
        onClick: handleMobileMenuClose
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        icon: (iconProps_2)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Mix9))), {
                ...iconProps_2,
                color: iconColor
            }),
        label: formatMessage((0, $ceKKZ.default).openMenu),
        onClick: handleHamburgerClick
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderCustomNavActions && renderCustomNavActions(iconColor), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2lscT.Profile), {
                ...triggerProps,
                tooltip: "Profile and settings",
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
                    appearance: "circle",
                    size: "medium",
                    src: avatarSrc
                }),
                onClick: handleProfileClick
            }),
        shouldRenderToParent: true,
        placement: "bottom-end",
        isOpen: isAvatarMenuOpen,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1STAw.AvatarMenu), null),
        onClose: handleAvatarMenuClose
    }))), !isAnonymousRoute && !email && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Dc6h.default), {
        to: `/user/login`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: isLoginButtonContrastEnabled ? 'subtle' : 'default'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: isLoginButtonContrastEnabled ? {
            color: navTextColor
        } : undefined
    }, formatMessage((0, $ceKKZ.default).login)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iODl6.default), {
        appear: true
    }, isMobileMenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iFlah.default), {
        enteringAnimationXcss: $ee5d7114683e59af$var$motionStyles.slideEntering,
        exitingAnimationXcss: $ee5d7114683e59af$var$motionStyles.slideExiting
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ee5d7114683e59af$var$MobileMenuOverlay, {
        onClose: handleMobileMenuClose,
        navbarRef: navbarRef
    })))));
};
module.exports["Navbar"] = $ee5d7114683e59af$export$42cfbb80f7861e77;

});

parcelRegister("2XAa3", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8497d9ba474775b$export$2e2bcd8739ae039);
var $f8497d9ba474775b$export$2e2bcd8739ae039 = (pluginState, action)=>{
    return pluginState;
};

});

parcelRegister("6lSx6", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $b8ecbb7b641c04ff$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    colorPickerTitle: {
        id: "companyHub.editor.textColor.pickerTitle",
        defaultMessage: "Text Color"
    }
});
module.exports["messages"] = $b8ecbb7b641c04ff$export$defe85febe8b728c;

});

parcelRegister("lpukL", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hzZPp = parcelRequire("hzZPp");


var $is7KY = parcelRequire("is7KY");


var $evFm2 = parcelRequire("evFm2");


var $3k5Tv = parcelRequire("3k5Tv");


var $9Rqjc = parcelRequire("9Rqjc");


var $74bCf = parcelRequire("74bCf");


var $kwf4Z = parcelRequire("kwf4Z");


var $I7hWB = parcelRequire("I7hWB");


var $eh6Ml = parcelRequire("eh6Ml");


var $9FyRG = parcelRequire("9FyRG");


var $iMnC5 = parcelRequire("iMnC5");


var $dinVW = parcelRequire("dinVW");

const $4359f0ef005af088$var$styles = {
    container: "_2mHwu8gVvo _3138425zaO",
    removeHighlightButton: "_0bjKvDKxmn _2YLqiKFQfX _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67",
    icon: "_3iDTPbvbI6 _2XsHFMA17z"
};
const $4359f0ef005af088$var$TextColorIconDecorator = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { label: label, isSelected: isSelected } = t0;
    let t1;
    if ($[0] !== isSelected || $[1] !== label) {
        t1 = isSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
            color: "var(--ds-icon, #292A2E)",
            label: label
        }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $4359f0ef005af088$var$styles.icon
        }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
            label: label,
            color: "var(--ds-icon, #292A2E)",
            shouldRecommendSmallIcon: true,
            spacing: "spacious",
            size: "small"
        }));
        $[0] = isSelected;
        $[1] = label;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ label: label, isSelected: isSelected })=>{
    const iconColor = "var(--ds-icon, #292A2E)";
    return isSelected ? /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
        color: iconColor,
        label: label
    }) : /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $4359f0ef005af088$var$styles.icon
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($9FyRG))), {
        label: label,
        color: iconColor,
        shouldRecommendSmallIcon: true,
        spacing: "spacious",
        size: "small"
    }));
};
const $4359f0ef005af088$export$586c660b6a27552f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function HighlightColorSection(t0) {
    const $ = (0, $bDgLe.c)(24);
    const { api: api, parents: parents } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [
            "highlight"
        ];
        $[0] = t1;
    } else t1 = $[0];
    const activeColor = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, t1, $4359f0ef005af088$var$_temp);
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    let t2;
    if ($[1] !== api || $[2] !== closeMenu || $[3] !== parents) {
        t2 = (color, event)=>{
            if (api?.highlight?.commands?.changeColor) {
                api.core.actions.execute(api.highlight.commands.changeColor({
                    color: color,
                    inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
                }));
                closeMenu?.(event);
            }
        };
        $[1] = api;
        $[2] = closeMenu;
        $[3] = parents;
        $[4] = t2;
    } else t2 = $[4];
    const handleHighlightColorChange = t2;
    let t3;
    if ($[5] !== activeColor) {
        const isSelected = (color_0)=>color_0.value === activeColor;
        t3 = (0, $evFm2.highlightColorPalette).filter($4359f0ef005af088$var$_temp2).map((color_2)=>({
                ...color_2,
                decorator: /*#__PURE__*/ $cozmU.createElement($4359f0ef005af088$var$TextColorIconDecorator, {
                    label: color_2.label,
                    isSelected: isSelected(color_2)
                })
            }));
        $[5] = activeColor;
        $[6] = t3;
    } else t3 = $[6];
    const colorPalette = t3;
    let t4;
    if ($[7] !== formatMessage) {
        t4 = formatMessage((0, $hzZPp.highlightMessages).highlight);
        $[7] = formatMessage;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
            size: "xxsmall"
        }, t4);
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== handleHighlightColorChange) {
        t6 = (color_3, _, event_0)=>{
            handleHighlightColorChange(color_3, event_0);
        };
        $[11] = handleHighlightColorChange;
        $[12] = t6;
    } else t6 = $[12];
    const t7 = activeColor || null;
    let t8;
    if ($[13] !== colorPalette) {
        t8 = colorPalette || [];
        $[13] = colorPalette;
        $[14] = t8;
    } else t8 = $[14];
    let t9;
    if ($[15] !== t8) {
        t9 = {
            palette: t8,
            hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
        };
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    let t10;
    if ($[17] !== t6 || $[18] !== t7 || $[19] !== t9) {
        t10 = /*#__PURE__*/ $cozmU.createElement((0, $74bCf.default), {
            onClick: t6,
            selectedColor: t7,
            paletteOptions: t9
        });
        $[17] = t6;
        $[18] = t7;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t5) {
        t11 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $4359f0ef005af088$var$styles.container,
            testId: "highlight-color-menu-item"
        }, t5, t10);
        $[21] = t10;
        $[22] = t5;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
} : function HighlightColorSection({ api: api, parents: parents }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const activeColor = (0, $3k5Tv.useSharedPluginStateWithSelector)(api, [
        'highlight'
    ], (states)=>states.highlightState?.activeColor);
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const handleHighlightColorChange = (0, $cozmU.useCallback)((color, event)=>{
        if (api?.highlight?.commands?.changeColor) {
            api.core.actions.execute(api.highlight.commands.changeColor({
                color: color,
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
            }));
            closeMenu?.(event);
        }
    }, [
        api,
        closeMenu,
        parents
    ]);
    const colorPalette = (0, $cozmU.useMemo)(()=>{
        const isSelected = (color_0)=>color_0.value === activeColor;
        return (0, $evFm2.highlightColorPalette).filter((color_1)=>color_1.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR)).map((color_2)=>({
                ...color_2,
                decorator: /*#__PURE__*/ $cozmU.createElement($4359f0ef005af088$var$TextColorIconDecorator, {
                    label: color_2.label,
                    isSelected: isSelected(color_2)
                })
            }));
    }, [
        activeColor
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $4359f0ef005af088$var$styles.container,
        testId: "highlight-color-menu-item"
    }, /*#__PURE__*/ $cozmU.createElement((0, $I7hWB.default), {
        size: "xxsmall"
    }, formatMessage((0, $hzZPp.highlightMessages).highlight)), /*#__PURE__*/ $cozmU.createElement((0, $74bCf.default), {
        onClick: (color_3, _, event_0)=>{
            handleHighlightColorChange(color_3, event_0);
        },
        selectedColor: activeColor || null,
        paletteOptions: {
            palette: colorPalette || [],
            hexToPaletteColor: (0, $9Rqjc.hexToEditorTextBackgroundPaletteColor)
        }
    }));
};
function $4359f0ef005af088$var$_temp2(color_1) {
    return color_1.value !== (0, $evFm2.REMOVE_HIGHLIGHT_COLOR);
}
function $4359f0ef005af088$var$_temp(states) {
    return states.highlightState?.activeColor;
}
module.exports["HighlightColorSection"] = $4359f0ef005af088$export$586c660b6a27552f;

});

parcelRegister("dRHIT", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $hzZPp = parcelRequire("hzZPp");


var $is7KY = parcelRequire("is7KY");


var $evFm2 = parcelRequire("evFm2");


var $kwf4Z = parcelRequire("kwf4Z");


var $4aRua = parcelRequire("4aRua");

const $9fc2c218313bc9ba$var$styles = {
    removeColorButton: "_0bjKvDKxmn _2YLqiKFQfX _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _313842gVvo"
};
const $9fc2c218313bc9ba$export$c6c1c71256ced33c = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { api: api, parents: parents } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    let t1;
    if ($[0] !== api || $[1] !== closeMenu || $[2] !== parents) {
        t1 = (event)=>{
            if (!api) return;
            const defaultColor = api.textColor.sharedState.currentState()?.defaultColor;
            if (!defaultColor) return;
            api.core.actions.execute((t2)=>{
                const { tr: tr } = t2;
                api.textColor.commands.changeColor(defaultColor, (0, $is7KY.getInputMethodFromParentKeys)(parents))({
                    tr: tr
                });
                api.highlight?.commands.changeColor({
                    color: (0, $evFm2.REMOVE_HIGHLIGHT_COLOR),
                    inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
                })({
                    tr: tr
                });
                return tr;
            });
            closeMenu?.(event);
        };
        $[0] = api;
        $[1] = closeMenu;
        $[2] = parents;
        $[3] = t1;
    } else t1 = $[3];
    const onClick = t1;
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $9fc2c218313bc9ba$var$styles.removeColorButton
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== formatMessage) {
        t3 = formatMessage((0, $hzZPp.highlightMessages).removeColor);
        $[5] = formatMessage;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
            weight: "medium"
        }, t3);
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== onClick || $[10] !== t4) {
        t5 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: onClick
        }, t4));
        $[9] = onClick;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const context = (0, $kwf4Z.useToolbarDropdownMenu)();
    const closeMenu = context?.closeMenu;
    const onClick = (event)=>{
        if (!api) return;
        const defaultColor = api.textColor.sharedState.currentState()?.defaultColor;
        if (!defaultColor) return;
        api.core.actions.execute(({ tr: tr })=>{
            api.textColor.commands.changeColor(defaultColor, (0, $is7KY.getInputMethodFromParentKeys)(parents))({
                tr: tr
            });
            api.highlight?.commands.changeColor({
                color: (0, $evFm2.REMOVE_HIGHLIGHT_COLOR),
                inputMethod: (0, $is7KY.getInputMethodFromParentKeys)(parents)
            })({
                tr: tr
            });
            return tr;
        });
        closeMenu?.(event);
    };
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $9fc2c218313bc9ba$var$styles.removeColorButton
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        shouldFitContainer: true,
        appearance: "subtle",
        onClick: onClick
    }, /*#__PURE__*/ $cozmU.createElement((0, $4aRua.Text), {
        weight: "medium"
    }, formatMessage((0, $hzZPp.highlightMessages).removeColor))));
};
module.exports["RemoveColorSection"] = $9fc2c218313bc9ba$export$c6c1c71256ced33c;

});

parcelRegister("91TKv", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $vZEJe = parcelRequire("vZEJe");


var $iMnC5 = parcelRequire("iMnC5");

const $e250cf21d08e0f9e$export$5c1bdc10c885b45b = '--editor-cursor-drop-indicator-offset';
const $e250cf21d08e0f9e$export$386f7807bfc7e1a9 = '--editor-cursor-drop-indicator-gap';
const $e250cf21d08e0f9e$var$styles = {
    container: "_1mT5xdWVPG _3OE6xYdnbC _4ApkO2dnbC _3iDTPbvLZJ _42Yu6BgtVO _1VJPca1Ctc",
    dropIndicator: "_0jFU0VN91d _39xV02N91d _1mT5xdRAKS _3iDTPbvLZJ"
};
const $e250cf21d08e0f9e$export$94ce81ee629276a7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function CursorDropIndicator() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e250cf21d08e0f9e$var$styles.container,
            testId: "hub-external-insert-cursor-drop-indicator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $e250cf21d08e0f9e$var$styles.dropIndicator,
            testId: "hub-external-insert-cursor-drop-indicator-box"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
            edge: "bottom"
        })));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function CursorDropIndicator() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e250cf21d08e0f9e$var$styles.container,
        testId: "hub-external-insert-cursor-drop-indicator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $e250cf21d08e0f9e$var$styles.dropIndicator,
        testId: "hub-external-insert-cursor-drop-indicator-box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $vZEJe.DropIndicator), {
        edge: "bottom"
    })));
};
module.exports["CURSOR_DROP_INDICATOR_OFFSET"] = $e250cf21d08e0f9e$export$5c1bdc10c885b45b;
module.exports["CURSOR_DROP_INDICATOR_GAP"] = $e250cf21d08e0f9e$export$386f7807bfc7e1a9;
module.exports["CursorDropIndicator"] = $e250cf21d08e0f9e$export$94ce81ee629276a7;

});

parcelRegister("lnxfH", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7gqwM = parcelRequire("7gqwM");


var $caqWd = parcelRequire("caqWd");

const $3097a2e680b35ec0$var$styles = {
    nav: "_1EqgXlN91d",
    list: "_3iDTPbQ4SZ _0hPCNLDIqT _3TGfC9HnLE _0aNu0LYbGa _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg"
};
const $3097a2e680b35ec0$var$defaultItems = [
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7gqwM.default), {
        width: 64
    }, "home"),
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7gqwM.default), {
        width: 96
    }, "parent"),
    /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7gqwM.default), {
        width: 80
    }, "current")
]; /**
                                                                                                                                                                                      * __BreadcrumbsSkeleton__
                                                                                                                                                                                      *
                                                                                                                                                                                      * A placeholder skeleton for breadcrumbs while navigation data is loading.
                                                                                                                                                                                      */ 
const $3097a2e680b35ec0$var$BreadcrumbsSkeleton = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BreadcrumbsSkeleton(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { children: children, isShimmering: t1, label: t2, size: t3, testId: testId } = t0;
    const isShimmering = t1 === undefined ? true : t1;
    const label = t2 === undefined ? "Loading breadcrumbs" : t2;
    const size = t3 === undefined ? "medium" : t3;
    const renderedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) > 0 ? children : $3097a2e680b35ec0$var$defaultItems;
    let t4;
    if ($[0] !== isShimmering || $[1] !== size) {
        t4 = {
            isShimmering: isShimmering,
            size: size
        };
        $[0] = isShimmering;
        $[1] = size;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            $3097a2e680b35ec0$var$styles.nav
        ]);
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            $3097a2e680b35ec0$var$styles.list
        ]);
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] !== renderedChildren || $[6] !== testId) {
        t7 = /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
            "aria-hidden": "true",
            "data-testid": testId,
            className: t6,
            children: renderedChildren
        });
        $[5] = renderedChildren;
        $[6] = testId;
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== label || $[9] !== t7) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-busy": "true",
            "aria-label": label,
            className: t5,
            children: t7
        });
        $[8] = label;
        $[9] = t7;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] !== t4 || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $caqWd.BreadcrumbsSkeletonContext).Provider, {
            value: t4,
            children: t8
        });
        $[11] = t4;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    return t9;
} : function BreadcrumbsSkeleton({ children: children, isShimmering: isShimmering = true, label: label = 'Loading breadcrumbs', size: size = 'medium', testId: testId }) {
    const renderedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.count(children) > 0 ? children : $3097a2e680b35ec0$var$defaultItems;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $caqWd.BreadcrumbsSkeletonContext).Provider, {
        value: {
            isShimmering: isShimmering,
            size: size
        },
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-busy": "true",
            "aria-label": label,
            className: (0, $hekY6.default)([
                $3097a2e680b35ec0$var$styles.nav
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
                "aria-hidden": "true",
                "data-testid": testId,
                className: (0, $hekY6.default)([
                    $3097a2e680b35ec0$var$styles.list
                ]),
                children: renderedChildren
            })
        })
    });
};
var $3097a2e680b35ec0$export$2e2bcd8739ae039 = $3097a2e680b35ec0$var$BreadcrumbsSkeleton;
module.exports["default"] = $3097a2e680b35ec0$export$2e2bcd8739ae039;

});

parcelRegister("7gqwM", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");

parcelRequire("cozmU");


var $a9aSv = parcelRequire("a9aSv");


var $7IEOV = parcelRequire("7IEOV");

const $a148696a5738f95d$var$styles = {
    item: "_3iDTPbQ4SZ _0hPCNLDIqT _24h04i2Njc _0jFU0V9DVM _1EqgXlN91d",
    iconWrapper: "_3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _2xTnZxFQfX"
};
const $a148696a5738f95d$var$unboundedStyles = {
    item: "_2QysXmFQfX _2kjhZi2ADO _01IvHGJg58 _1OhcLddnbC _1z9enHKGUX _0y3UDVfzt3 _1wqIxfDIqT"
}; /**
    * __BreadcrumbsSkeletonItem__
    *
    * A placeholder skeleton item for use inside `BreadcrumbsSkeleton`.
    */ 
const $a148696a5738f95d$var$BreadcrumbsSkeletonItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? function BreadcrumbsSkeletonItem(t0) {
    const $ = (0, $bDgLe.c)(11);
    const { hasIcon: hasIcon, width: width } = t0;
    const { isShimmering: isShimmering, size: size } = (0, $7IEOV.useBreadcrumbsSkeleton)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $a148696a5738f95d$var$styles.item,
            $a148696a5738f95d$var$unboundedStyles.item
        ]);
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== hasIcon || $[2] !== isShimmering) {
        t2 = hasIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: (0, $hekY6.default)([
                $a148696a5738f95d$var$styles.iconWrapper
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                height: 16,
                isShimmering: isShimmering,
                width: 16
            })
        }) : null;
        $[1] = hasIcon;
        $[2] = isShimmering;
        $[3] = t2;
    } else t2 = $[3];
    const t3 = size === "small" ? 12 : 14;
    let t4;
    if ($[4] !== isShimmering || $[5] !== t3 || $[6] !== width) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
            height: t3,
            isShimmering: isShimmering,
            width: width
        });
        $[4] = isShimmering;
        $[5] = t3;
        $[6] = width;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsxs)("li", {
            className: t1,
            children: [
                t2,
                t4
            ]
        });
        $[8] = t2;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    return t5;
} : function BreadcrumbsSkeletonItem({ hasIcon: hasIcon, width: width }) {
    const { isShimmering: isShimmering, size: size } = (0, $7IEOV.useBreadcrumbsSkeleton)();
    return /*#__PURE__*/ (0, $8aG6j.jsxs)("li", {
        className: (0, $hekY6.default)([
            $a148696a5738f95d$var$styles.item,
            $a148696a5738f95d$var$unboundedStyles.item
        ]),
        children: [
            hasIcon ? /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                className: (0, $hekY6.default)([
                    $a148696a5738f95d$var$styles.iconWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                    height: 16,
                    isShimmering: isShimmering,
                    width: 16
                })
            }) : null,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $a9aSv.default), {
                height: size === 'small' ? 12 : 14,
                isShimmering: isShimmering,
                width: width
            })
        ]
    });
};
var $a148696a5738f95d$export$2e2bcd8739ae039 = $a148696a5738f95d$var$BreadcrumbsSkeletonItem;
module.exports["default"] = $a148696a5738f95d$export$2e2bcd8739ae039;

});

parcelRegister("6D10p", function(module, exports) {
const $959e4ecadfc481b4$export$657a9453714bdcb9 = (relativeBaseUrl, routePath)=>{
    const basePath = relativeBaseUrl.replace(/\/+$/, '');
    if (/^https?:\/\//.test(routePath)) return routePath;
    if (basePath && (routePath === basePath || routePath.startsWith(`${basePath}/`))) return routePath;
    const path = routePath === '/' ? '' : `/${routePath.replace(/^\/+/, '')}`;
    return `${basePath}${path}` || '/';
};
module.exports["getHubBreadcrumbHref"] = $959e4ecadfc481b4$export$657a9453714bdcb9;

});

parcelRegister("1hWe9", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $33a1809fc814c211$var$HubBreadcrumbsContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $33a1809fc814c211$var$areBreadcrumbsEqual = (currentItems, nextItems)=>currentItems.length === nextItems.length && currentItems.every((item, index)=>{
        const nextItem = nextItems[index];
        return nextItem !== undefined && item.href === nextItem.href && item.id === nextItem.id && item.text === nextItem.text;
    });
const $33a1809fc814c211$export$cf2b9e6505681ebf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
    } else t1 = $[0];
    const [items, setItems] = (0, $cozmU.useState)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (nextItems)=>{
            setItems((currentItems)=>$33a1809fc814c211$var$areBreadcrumbsEqual(currentItems, nextItems) ? currentItems : nextItems);
        };
        $[1] = t2;
    } else t2 = $[1];
    const setBreadcrumbs = t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>setItems([]);
        $[2] = t3;
    } else t3 = $[2];
    const clearBreadcrumbs = t3;
    let t4;
    if ($[3] !== items) {
        t4 = {
            clearBreadcrumbs: clearBreadcrumbs,
            items: items,
            setBreadcrumbs: setBreadcrumbs
        };
        $[3] = items;
        $[4] = t4;
    } else t4 = $[4];
    const value = t4;
    let t5;
    if ($[5] !== children || $[6] !== value) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33a1809fc814c211$var$HubBreadcrumbsContext.Provider, {
            value: value
        }, children);
        $[5] = children;
        $[6] = value;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ children: children })=>{
    const [items, setItems] = (0, $cozmU.useState)([]);
    const setBreadcrumbs = (0, $cozmU.useCallback)((nextItems)=>{
        setItems((currentItems)=>$33a1809fc814c211$var$areBreadcrumbsEqual(currentItems, nextItems) ? currentItems : nextItems);
    }, []);
    const clearBreadcrumbs = (0, $cozmU.useCallback)(()=>setItems([]), []);
    const value = (0, $cozmU.useMemo)(()=>({
            clearBreadcrumbs: clearBreadcrumbs,
            items: items,
            setBreadcrumbs: setBreadcrumbs
        }), [
        clearBreadcrumbs,
        items,
        setBreadcrumbs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33a1809fc814c211$var$HubBreadcrumbsContext.Provider, {
        value: value
    }, children);
};
const $33a1809fc814c211$var$useHubBreadcrumbsContext = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const context = (0, $cozmU.useContext)($33a1809fc814c211$var$HubBreadcrumbsContext);
    if (!context) throw new Error("Hub breadcrumb hooks must be used within HubBreadcrumbsProvider");
    return context;
} : ()=>{
    const context = (0, $cozmU.useContext)($33a1809fc814c211$var$HubBreadcrumbsContext);
    if (!context) throw new Error('Hub breadcrumb hooks must be used within HubBreadcrumbsProvider');
    return context;
};
const $33a1809fc814c211$export$695acbe2b31cd25f = (0, $gtMdU.isReactCompilerActivePlatform)() ? (items)=>{
    const $ = (0, $bDgLe.c)(7);
    const { clearBreadcrumbs: clearBreadcrumbs, setBreadcrumbs: setBreadcrumbs } = $33a1809fc814c211$var$useHubBreadcrumbsContext();
    let t0;
    let t1;
    if ($[0] !== items || $[1] !== setBreadcrumbs) {
        t0 = ()=>{
            setBreadcrumbs(items);
        };
        t1 = [
            items,
            setBreadcrumbs
        ];
        $[0] = items;
        $[1] = setBreadcrumbs;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    let t3;
    if ($[4] !== clearBreadcrumbs) {
        t2 = ()=>()=>{
                clearBreadcrumbs();
            };
        t3 = [
            clearBreadcrumbs
        ];
        $[4] = clearBreadcrumbs;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
} : (items)=>{
    const { clearBreadcrumbs: clearBreadcrumbs, setBreadcrumbs: setBreadcrumbs } = $33a1809fc814c211$var$useHubBreadcrumbsContext();
    (0, $cozmU.useEffect)(()=>{
        setBreadcrumbs(items);
    }, [
        items,
        setBreadcrumbs
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            clearBreadcrumbs();
        }, [
        clearBreadcrumbs
    ]);
};
const $33a1809fc814c211$export$e623729f7cd92c6b = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    return $33a1809fc814c211$var$useHubBreadcrumbsContext().items;
} : ()=>$33a1809fc814c211$var$useHubBreadcrumbsContext().items;
module.exports["useHubBreadcrumbItems"] = $33a1809fc814c211$export$e623729f7cd92c6b;

});

parcelRegister("805yB", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $7b2dc9b0aea56864$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    label: {
        id: "company-hub-common.hub-breadcrumbs.label.non-final",
        defaultMessage: "Breadcrumbs"
    },
    showMore: {
        id: "company-hub-common.hub-breadcrumbs.showMore.non-final",
        defaultMessage: "Show more breadcrumbs"
    }
});
module.exports["messages"] = $7b2dc9b0aea56864$export$defe85febe8b728c;

});

parcelRegister("2lscT", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6alko = parcelRequire("6alko");

const $98c741ba5769fc1f$export$5120f2d0b8d4cab8 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(41);
    let component;
    let href;
    let icon;
    let id;
    let isDisabled;
    let isSelected;
    let labelProp;
    let onBlur;
    let onClick;
    let onFocus;
    let onMouseDown;
    let onMouseEnter;
    let onMouseLeave;
    let onMouseUp;
    let rest;
    let target;
    let testId;
    let theme;
    let tooltip;
    if ($[0] !== props) {
        ({ component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props);
        $[0] = props;
        $[1] = component;
        $[2] = href;
        $[3] = icon;
        $[4] = id;
        $[5] = isDisabled;
        $[6] = isSelected;
        $[7] = labelProp;
        $[8] = onBlur;
        $[9] = onClick;
        $[10] = onFocus;
        $[11] = onMouseDown;
        $[12] = onMouseEnter;
        $[13] = onMouseLeave;
        $[14] = onMouseUp;
        $[15] = rest;
        $[16] = target;
        $[17] = testId;
        $[18] = theme;
        $[19] = tooltip;
    } else {
        component = $[1];
        href = $[2];
        icon = $[3];
        id = $[4];
        isDisabled = $[5];
        isSelected = $[6];
        labelProp = $[7];
        onBlur = $[8];
        onClick = $[9];
        onFocus = $[10];
        onMouseDown = $[11];
        onMouseEnter = $[12];
        onMouseLeave = $[13];
        onMouseUp = $[14];
        rest = $[15];
        target = $[16];
        testId = $[17];
        theme = $[18];
        tooltip = $[19];
    }
    const label = labelProp || (typeof tooltip === "string" ? tooltip : "Your profile and settings");
    let t0;
    if ($[20] !== component || $[21] !== href || $[22] !== icon || $[23] !== id || $[24] !== isDisabled || $[25] !== isSelected || $[26] !== label || $[27] !== onBlur || $[28] !== onClick || $[29] !== onFocus || $[30] !== onMouseDown || $[31] !== onMouseEnter || $[32] !== onMouseLeave || $[33] !== onMouseUp || $[34] !== ref || $[35] !== rest || $[36] !== target || $[37] !== testId || $[38] !== theme || $[39] !== tooltip) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            role: "listitem",
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6alko.IconButton), {
                component: component,
                href: href,
                icon: icon,
                id: id,
                isDisabled: isDisabled,
                isSelected: isSelected,
                label: label,
                onBlur: onBlur,
                onClick: onClick,
                onFocus: onFocus,
                onMouseDown: onMouseDown,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseUp: onMouseUp,
                ref: ref,
                target: target,
                testId: testId,
                theme: theme,
                tooltip: tooltip,
                isTooltipAnnouncementDisabled: true,
                ...rest
            })
        });
        $[20] = component;
        $[21] = href;
        $[22] = icon;
        $[23] = id;
        $[24] = isDisabled;
        $[25] = isSelected;
        $[26] = label;
        $[27] = onBlur;
        $[28] = onClick;
        $[29] = onFocus;
        $[30] = onMouseDown;
        $[31] = onMouseEnter;
        $[32] = onMouseLeave;
        $[33] = onMouseUp;
        $[34] = ref;
        $[35] = rest;
        $[36] = target;
        $[37] = testId;
        $[38] = theme;
        $[39] = tooltip;
        $[40] = t0;
    } else t0 = $[40];
    return t0;
} : (props, ref)=>{
    const { component: component, href: href, icon: icon, id: id, isDisabled: isDisabled, isSelected: isSelected, label: labelProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, theme: theme, tooltip: tooltip, ...rest } = props;
    const label = labelProp || (typeof tooltip === 'string' ? tooltip : 'Your profile and settings');
    return /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
        role: "listitem",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6alko.IconButton), {
            component: component,
            href: href,
            icon: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
            theme: theme,
            tooltip: tooltip,
            isTooltipAnnouncementDisabled: true,
            ...rest
        })
    });
});
module.exports["Profile"] = $98c741ba5769fc1f$export$5120f2d0b8d4cab8;

});

parcelRegister("gMq3e", function(module, exports) {

var $5KWZf = parcelRequire("5KWZf");

const $a3acc295eb36bae5$export$8eeba3862e4455cf = (hubType)=>{
    // Help hubs always use new height
    if (hubType === 'HELP_HUB') return 0, $5KWZf.HUB_LOGO_HEIGHT;
    // CSM hubs always use new height
    if (hubType === 'CUSTOMER_SERVICE') return 0, $5KWZf.HUB_LOGO_HEIGHT;
    // Fallback to legacy height for other hub types
    return 0, $5KWZf.HUB_LOGO_HEIGHT_LEGACY;
};
module.exports["getHubLogoHeight"] = $a3acc295eb36bae5$export$8eeba3862e4455cf;

});

parcelRegister("1STAw", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");

parcelRequire("fMvIa");
var $fcvZw = parcelRequire("fcvZw");


var $9d7Pd = parcelRequire("9d7Pd");


var $kD4eB = parcelRequire("kD4eB");


var $8oBbn = parcelRequire("8oBbn");


var $6IL1T = parcelRequire("6IL1T");


var $8FgJC = parcelRequire("8FgJC");


var $iDrrr = parcelRequire("iDrrr");


var $67z7B = parcelRequire("67z7B");


var $r8hvx = parcelRequire("r8hvx");


var $kE9MM = parcelRequire("kE9MM");


var $dS16R = parcelRequire("dS16R");

const $e8e476bcf8ac50ca$var$styles = {
    menu: "_39xV022k7g"
};
const $e8e476bcf8ac50ca$export$f7f58290278dd286 = ()=>{
    (0, $6cFsl.di)((0, $r8hvx.useHubContext), (0, $iDrrr.fg));
    const hubContext = (0, $r8hvx.useHubContext)();
    const [{ match: match }] = (0, $fcvZw.useRouter)();
    const { user: user, env: env, actions: actions, renderAvatarMenuOptions: renderAvatarMenuOptions, cloudUrl: cloudUrl } = hubContext;
    const { isJiraAdmin: isJiraAdmin } = user;
    const { helpCenterId: helpCenterId, hoistedProjectKey: hoistedProjectKey } = env;
    const { id: pageId } = match.params;
    const { onLogoutClick: onLogoutClick } = actions;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const shouldUseConsumerAvatarMenu = (0, $iDrrr.fg)('enable-jsm-in-hubs');
    const consumerAvatarMenuContent = shouldUseConsumerAvatarMenu && typeof renderAvatarMenuOptions === 'function' ? renderAvatarMenuOptions() : null;
    const csmEditorUrl = (0, $iDrrr.fg)('csm_appification_standalone_navigation') ? `${cloudUrl}/jira/customer-service-management/experiences/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}` : `${cloudUrl}/jira/helpcenter/projects/${hoistedProjectKey}/settings/${helpCenterId}/support-website/edit${pageId ? `/${pageId}` : ''}`;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $e8e476bcf8ac50ca$var$styles.menu
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $6IL1T.default), null, /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), null, /*#__PURE__*/ $cozmU.createElement((0, $kE9MM.AccountDetails), null)), consumerAvatarMenuContent || isJiraAdmin && /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $8oBbn.default), {
        href: csmEditorUrl,
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $dS16R.default).editSite))), /*#__PURE__*/ $cozmU.createElement((0, $8FgJC.default), {
        hasSeparator: true
    }, /*#__PURE__*/ $cozmU.createElement((0, $kD4eB.default), {
        component: (0, $67z7B.default),
        to: `/user/profile`,
        className: "cv-exclude-from-customisation"
    }, formatMessage((0, $dS16R.default).profile)), /*#__PURE__*/ $cozmU.createElement((0, $9d7Pd.default), {
        onClick: onLogoutClick
    }, formatMessage((0, $dS16R.default).logout)))));
};
module.exports["AvatarMenu"] = $e8e476bcf8ac50ca$export$f7f58290278dd286;

});

parcelRegister("ceKKZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $994023d7f92e2ddb$var$_default_1 = (0, $kSwu1.defineMessages)({
    hubLogo: {
        id: "company-hub.hub-app-shell.navbar.hub.logo",
        defaultMessage: "Support home"
    },
    login: {
        id: "company-hub.hub-app-shell.navbar.hub.log-in",
        defaultMessage: "Log in"
    },
    openMenu: {
        id: "company-hub.hub-app-shell.navbar.open-menu.non-final",
        defaultMessage: "Open navigation menu"
    },
    closeMenu: {
        id: "company-hub.hub-app-shell.navbar.close-menu.non-final",
        defaultMessage: "Close navigation menu"
    }
});
var $994023d7f92e2ddb$export$2e2bcd8739ae039 = $994023d7f92e2ddb$var$_default_1;
module.exports["default"] = $994023d7f92e2ddb$export$2e2bcd8739ae039;

});

parcelRegister("hIH5w", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $dk27U = parcelRequire("dk27U");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $7ZB0A = parcelRequire("7ZB0A");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $b8pma = parcelRequire("b8pma");


var $51SAu = parcelRequire("51SAu");


var $r8hvx = parcelRequire("r8hvx");


var $iK7lw = parcelRequire("iK7lw");


var $6DK5X = parcelRequire("6DK5X");


var $fk4YO = parcelRequire("fk4YO");


var $7TPw9 = parcelRequire("7TPw9");


var $59YRu = parcelRequire("59YRu");


var $auieu = parcelRequire("auieu");


var $jDOHN = parcelRequire("jDOHN");


var $i4PiE = parcelRequire("i4PiE");

const $313e1630e2530993$var$styles = {
    countBadge: "_0bjKvDyzSk _0jFU0VSPN1 _4ouGXISPN1 _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0KLXrugozt _1UtDYze5R3 _2Zuz6Q1Y8M _1Znuxb1Y8M",
    siteTreeNavLinks: "_2O5Vij7dHp _3YEZNO7dHp _4ouGXIdnbC"
};
// network request when the data has already been fetched for this hub.
// Only used when hubs_fix_rerendering_bootstrap_page_media is ON.
const $313e1630e2530993$var$requestCountCache = new Map();
const $313e1630e2530993$var$getCacheKey = (cloudUrl, helpCenterAri)=>`${cloudUrl}::${helpCenterAri}`; /**
                                                                                                   * Test-only helper: clears the module-level request count cache so unit tests
                                                                                                   * can simulate a "first mount with no cached data" scenario without resetting
                                                                                                   * the entire jest module registry.
                                                                                                   */ 
const $313e1630e2530993$export$7a00ed33b23e6d4d = ()=>{
    $313e1630e2530993$var$requestCountCache.clear();
};
const $313e1630e2530993$var$NavLinkItems = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(66);
    const { backgroundColor: t1, requestCount: requestCount, textColor: t2 } = t0;
    const backgroundColor = t1 === undefined ? "var(--ds-background-neutral-bold, #292A2E)" : t1;
    const textColor = t2 === undefined ? "var(--ds-text-inverse, #FFFFFF)" : t2;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const { cloudId: cloudId, env: t3, featureFlags: featureFlags } = (0, $r8hvx.useHubContext)();
    const { helpCenterAri: helpCenterAri, hubEditMode: hubEditMode } = t3;
    let t4;
    if ($[0] !== cloudId || $[1] !== featureFlags || $[2] !== helpCenterAri || $[3] !== hubEditMode) {
        t4 = (0, $auieu.getNavigationBarQueryVariables)({
            cloudId: cloudId,
            featureFlags: featureFlags,
            helpCenterAri: helpCenterAri,
            hubEditMode: hubEditMode
        });
        $[0] = cloudId;
        $[1] = featureFlags;
        $[2] = helpCenterAri;
        $[3] = hubEditMode;
        $[4] = t4;
    } else t4 = $[4];
    const navigationBarQueryVariables = t4;
    const { isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled, isTopicsEnabled: isTopicsEnabled } = navigationBarQueryVariables;
    const isPremiumLocked = (0, $51SAu.useShouldShowPremiumUpsell)();
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $dk27U.default), navigationBarQueryVariables);
    const helpCenterById = data?.helpCenter?.helpCenterById;
    const helpCenterRef = helpCenterById?.__typename === "HelpCenter" ? helpCenterById : null;
    const t5 = helpCenterRef?.helpCenterBranding?.navigationBar?.hiddenMenus;
    let t6;
    if ($[5] !== t5) {
        t6 = (0, $6DK5X.getHiddenNavMenus)(t5);
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    const { isPortalsMenuHidden: isPortalsMenuHidden, isTopicsMenuHidden: isTopicsMenuHidden } = t6;
    let t7;
    if ($[7] !== push) {
        t7 = ()=>{
            push("/");
        };
        $[7] = push;
        $[8] = t7;
    } else t7 = $[8];
    const handleHomeClick = t7;
    let t8;
    if ($[9] !== push) {
        t8 = ()=>{
            push("/user/requests");
        };
        $[9] = push;
        $[10] = t8;
    } else t8 = $[10];
    const handleRequestsClick = t8;
    let t9;
    if ($[11] !== push) {
        t9 = ()=>{
            push("/user/approvals");
        };
        $[11] = push;
        $[12] = t9;
    } else t9 = $[12];
    const handleApprovalsClick = t9;
    if (!requestCount || !helpCenterById) return null;
    const t10 = isConfigurableSiteTreeEnabled ? $313e1630e2530993$var$styles.siteTreeNavLinks : undefined;
    const t11 = isConfigurableSiteTreeEnabled ? "center" : undefined;
    let t12;
    if ($[13] !== textColor) {
        t12 = {
            color: textColor
        };
        $[13] = textColor;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== formatMessage) {
        t13 = formatMessage((0, $fk4YO.default).home);
        $[15] = formatMessage;
        $[16] = t13;
    } else t13 = $[16];
    let t14;
    if ($[17] !== handleHomeClick || $[18] !== t12 || $[19] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleHomeClick,
            style: t12
        }, t13);
        $[17] = handleHomeClick;
        $[18] = t12;
        $[19] = t13;
        $[20] = t14;
    } else t14 = $[20];
    let t15;
    if ($[21] !== helpCenterRef || $[22] !== isPortalsMenuHidden || $[23] !== textColor) {
        t15 = !isPortalsMenuHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $59YRu.PortalDropdown), {
            queryRef: helpCenterRef,
            textColor: textColor
        });
        $[21] = helpCenterRef;
        $[22] = isPortalsMenuHidden;
        $[23] = textColor;
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] !== helpCenterRef || $[26] !== isTopicsEnabled || $[27] !== isTopicsMenuHidden || $[28] !== textColor) {
        t16 = isTopicsEnabled && !isTopicsMenuHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4PiE.TopicDropdown), {
            queryRef: helpCenterRef,
            textColor: textColor
        });
        $[25] = helpCenterRef;
        $[26] = isTopicsEnabled;
        $[27] = isTopicsMenuHidden;
        $[28] = textColor;
        $[29] = t16;
    } else t16 = $[29];
    let t17;
    if ($[30] !== textColor) {
        t17 = {
            color: textColor
        };
        $[30] = textColor;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== formatMessage) {
        t18 = formatMessage((0, $fk4YO.default).requests);
        $[32] = formatMessage;
        $[33] = t18;
    } else t18 = $[33];
    let t19;
    if ($[34] !== backgroundColor || $[35] !== requestCount.request || $[36] !== textColor) {
        t19 = requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            style: {
                backgroundColor: textColor,
                color: backgroundColor
            },
            xcss: $313e1630e2530993$var$styles.countBadge
        }, requestCount.request);
        $[34] = backgroundColor;
        $[35] = requestCount.request;
        $[36] = textColor;
        $[37] = t19;
    } else t19 = $[37];
    let t20;
    if ($[38] !== t18 || $[39] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, t18, t19);
        $[38] = t18;
        $[39] = t19;
        $[40] = t20;
    } else t20 = $[40];
    let t21;
    if ($[41] !== handleRequestsClick || $[42] !== t17 || $[43] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleRequestsClick,
            style: t17
        }, t20);
        $[41] = handleRequestsClick;
        $[42] = t17;
        $[43] = t20;
        $[44] = t21;
    } else t21 = $[44];
    let t22;
    if ($[45] !== backgroundColor || $[46] !== formatMessage || $[47] !== handleApprovalsClick || $[48] !== requestCount.approvals || $[49] !== requestCount.pendingApprovals || $[50] !== textColor) {
        t22 = (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
            appearance: "subtle",
            onClick: handleApprovalsClick,
            style: {
                color: textColor
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.075"
        }, formatMessage((0, $fk4YO.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            style: {
                backgroundColor: textColor,
                color: backgroundColor
            },
            xcss: $313e1630e2530993$var$styles.countBadge
        }, requestCount.pendingApprovals)));
        $[45] = backgroundColor;
        $[46] = formatMessage;
        $[47] = handleApprovalsClick;
        $[48] = requestCount.approvals;
        $[49] = requestCount.pendingApprovals;
        $[50] = textColor;
        $[51] = t22;
    } else t22 = $[51];
    let t23;
    if ($[52] !== helpCenterRef || $[53] !== isConfigurableSiteTreeEnabled || $[54] !== isPremiumLocked || $[55] !== textColor) {
        t23 = !isPremiumLocked && (isConfigurableSiteTreeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jDOHN.SiteNavigation), {
            queryRef: helpCenterRef,
            textColor: textColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7TPw9.MoreDropdown), {
            queryRef: helpCenterRef,
            textColor: textColor
        }));
        $[52] = helpCenterRef;
        $[53] = isConfigurableSiteTreeEnabled;
        $[54] = isPremiumLocked;
        $[55] = textColor;
        $[56] = t23;
    } else t23 = $[56];
    let t24;
    if ($[57] !== t10 || $[58] !== t11 || $[59] !== t14 || $[60] !== t15 || $[61] !== t16 || $[62] !== t21 || $[63] !== t22 || $[64] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            testId: "nav-links",
            space: "space.050",
            xcss: t10,
            alignInline: t11
        }, t14, t15, t16, t21, t22, t23);
        $[57] = t10;
        $[58] = t11;
        $[59] = t14;
        $[60] = t15;
        $[61] = t16;
        $[62] = t21;
        $[63] = t22;
        $[64] = t23;
        $[65] = t24;
    } else t24 = $[65];
    return t24;
} : ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", requestCount: requestCount, textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { push: push } = (0, $idnP4.useRouterActions)();
    const { cloudId: cloudId, env: { helpCenterAri: helpCenterAri, hubEditMode: hubEditMode }, featureFlags: featureFlags } = (0, $r8hvx.useHubContext)();
    const navigationBarQueryVariables = (0, $auieu.getNavigationBarQueryVariables)({
        cloudId: cloudId,
        featureFlags: featureFlags,
        helpCenterAri: helpCenterAri,
        hubEditMode: hubEditMode
    });
    const { isConfigurableSiteTreeEnabled: isConfigurableSiteTreeEnabled, isTopicsEnabled: isTopicsEnabled } = navigationBarQueryVariables; // Folders and custom pages are Premium-only, so un-entitled tenants get no
    // entry point to them — from the site tree or the legacy More dropdown.
    const isPremiumLocked = (0, $51SAu.useShouldShowPremiumUpsell)(); // TODO: Use usePreloadedQuery once hub_preload_navigation_bar_query is cleaned up.
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $dk27U.default), navigationBarQueryVariables);
    const helpCenterById = data?.helpCenter?.helpCenterById;
    const helpCenterRef = helpCenterById?.__typename === 'HelpCenter' ? helpCenterById : null;
    const { isPortalsMenuHidden: isPortalsMenuHidden, isTopicsMenuHidden: isTopicsMenuHidden } = (0, $6DK5X.getHiddenNavMenus)(helpCenterRef?.helpCenterBranding?.navigationBar?.hiddenMenus);
    const handleHomeClick = (0, $cozmU.useCallback)(()=>{
        push('/');
    }, [
        push
    ]);
    const handleRequestsClick = (0, $cozmU.useCallback)(()=>{
        push('/user/requests');
    }, [
        push
    ]);
    const handleApprovalsClick = (0, $cozmU.useCallback)(()=>{
        push('/user/approvals');
    }, [
        push
    ]);
    if (!requestCount || !helpCenterById) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        testId: "nav-links",
        space: "space.050",
        xcss: isConfigurableSiteTreeEnabled ? $313e1630e2530993$var$styles.siteTreeNavLinks : undefined,
        alignInline: isConfigurableSiteTreeEnabled ? 'center' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleHomeClick,
        style: {
            color: textColor
        }
    }, formatMessage((0, $fk4YO.default).home)), !isPortalsMenuHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $59YRu.PortalDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), isTopicsEnabled && !isTopicsMenuHidden && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i4PiE.TopicDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleRequestsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $fk4YO.default).requests), requestCount.request > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $313e1630e2530993$var$styles.countBadge
    }, requestCount.request))), (requestCount.approvals > 0 || requestCount.pendingApprovals > 0) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZB0A.default), {
        appearance: "subtle",
        onClick: handleApprovalsClick,
        style: {
            color: textColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.075"
    }, formatMessage((0, $fk4YO.default).approvals), requestCount.pendingApprovals > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: {
            backgroundColor: textColor,
            color: backgroundColor
        },
        xcss: $313e1630e2530993$var$styles.countBadge
    }, requestCount.pendingApprovals))), !isPremiumLocked && (isConfigurableSiteTreeEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jDOHN.SiteNavigation), {
        queryRef: helpCenterRef,
        textColor: textColor
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7TPw9.MoreDropdown), {
        queryRef: helpCenterRef,
        textColor: textColor
    })));
};
const $313e1630e2530993$export$b615cd9717379c80 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { backgroundColor: t1, textColor: t2 } = t0;
    const backgroundColor = t1 === undefined ? "var(--ds-background-neutral-bold, #292A2E)" : t1;
    const textColor = t2 === undefined ? "var(--ds-text-inverse, #FFFFFF)" : t2;
    const { cloudUrl: cloudUrl, env: t3 } = (0, $r8hvx.useHubContext)();
    const { helpCenterAri: helpCenterAri } = t3;
    let t4;
    if ($[0] !== cloudUrl || $[1] !== helpCenterAri) {
        t4 = ()=>(0, $iDrrr.fg)("hubs_fix_rerendering_bootstrap_page_media") ? $313e1630e2530993$var$requestCountCache.get($313e1630e2530993$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null;
        $[0] = cloudUrl;
        $[1] = helpCenterAri;
        $[2] = t4;
    } else t4 = $[2];
    const [requestCount, setRequestCount] = (0, $cozmU.useState)(t4);
    let t5;
    let t6;
    if ($[3] !== cloudUrl || $[4] !== helpCenterAri) {
        t5 = ()=>{
            if ((0, $iDrrr.fg)("hubs_fix_rerendering_bootstrap_page_media")) {
                const cacheKey = $313e1630e2530993$var$getCacheKey(cloudUrl, helpCenterAri);
                const cached = $313e1630e2530993$var$requestCountCache.get(cacheKey);
                (0, $iK7lw.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                    const next = {
                        approvals: data.userRequestsCounts.approvalsCount,
                        pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                        request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                    };
                    $313e1630e2530993$var$requestCountCache.set(cacheKey, next);
                    setRequestCount(next);
                }).catch(()=>{
                    if (cached) return;
                    const fallback = {
                        approvals: 0,
                        pendingApprovals: 0,
                        request: 0
                    };
                    $313e1630e2530993$var$requestCountCache.set(cacheKey, fallback);
                    setRequestCount(fallback);
                });
            } else (0, $iK7lw.getRequestCount)(cloudUrl, helpCenterAri).then((data_0)=>{
                setRequestCount({
                    approvals: data_0.userRequestsCounts.approvalsCount,
                    pendingApprovals: data_0.userRequestsCounts.pendingApprovalsCount,
                    request: data_0.userRequestsCounts.allOpenRequestsCount + data_0.userRequestsCounts.pendingApprovalsCount
                });
            }).catch(()=>{
                setRequestCount({
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                });
            });
        };
        t6 = [
            cloudUrl,
            helpCenterAri
        ];
        $[3] = cloudUrl;
        $[4] = helpCenterAri;
        $[5] = t5;
        $[6] = t6;
    } else {
        t5 = $[5];
        t6 = $[6];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "nav-links-loader"
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== backgroundColor || $[9] !== requestCount || $[10] !== textColor) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
            fallback: t7
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($313e1630e2530993$var$NavLinkItems, {
            textColor: textColor,
            backgroundColor: backgroundColor,
            requestCount: requestCount
        }));
        $[8] = backgroundColor;
        $[9] = requestCount;
        $[10] = textColor;
        $[11] = t8;
    } else t8 = $[11];
    return t8;
} : ({ backgroundColor: backgroundColor = "var(--ds-background-neutral-bold, #292A2E)", textColor: textColor = "var(--ds-text-inverse, #FFFFFF)" })=>{
    const { cloudUrl: cloudUrl, env: { helpCenterAri: helpCenterAri } } = (0, $r8hvx.useHubContext)();
    const [requestCount, setRequestCount] = (0, $cozmU.useState)(()=>(0, $iDrrr.fg)('hubs_fix_rerendering_bootstrap_page_media') ? $313e1630e2530993$var$requestCountCache.get($313e1630e2530993$var$getCacheKey(cloudUrl, helpCenterAri)) ?? null : null);
    (0, $cozmU.useEffect)(()=>{
        if ((0, $iDrrr.fg)('hubs_fix_rerendering_bootstrap_page_media')) {
            const cacheKey = $313e1630e2530993$var$getCacheKey(cloudUrl, helpCenterAri);
            const cached = $313e1630e2530993$var$requestCountCache.get(cacheKey);
            (0, $iK7lw.getRequestCount)(cloudUrl, helpCenterAri).then((data)=>{
                // Always refresh both the request and approvals counts from the
                // latest API response. The Approvals tab is rendered only when
                // `approvals > 0`, so updating to a fresh value of 0 will
                // correctly remove the tab when there is nothing to show.
                const next = {
                    approvals: data.userRequestsCounts.approvalsCount,
                    pendingApprovals: data.userRequestsCounts.pendingApprovalsCount,
                    request: data.userRequestsCounts.allOpenRequestsCount + data.userRequestsCounts.pendingApprovalsCount
                };
                $313e1630e2530993$var$requestCountCache.set(cacheKey, next);
                setRequestCount(next);
            }).catch(()=>{
                if (cached) // Keep showing the cached values on refresh failure.
                return;
                 // fallback count to zero if request count API fails on first load
                const fallback = {
                    approvals: 0,
                    pendingApprovals: 0,
                    request: 0
                };
                $313e1630e2530993$var$requestCountCache.set(cacheKey, fallback);
                setRequestCount(fallback);
            });
        } else (0, $iK7lw.getRequestCount)(cloudUrl, helpCenterAri).then((data_0)=>{
            setRequestCount({
                approvals: data_0.userRequestsCounts.approvalsCount,
                pendingApprovals: data_0.userRequestsCounts.pendingApprovalsCount,
                request: data_0.userRequestsCounts.allOpenRequestsCount + data_0.userRequestsCounts.pendingApprovalsCount
            });
        }).catch(()=>{
            // fallback count to zero if request count API fails
            setRequestCount({
                approvals: 0,
                pendingApprovals: 0,
                request: 0
            });
        });
    }, [
        cloudUrl,
        helpCenterAri
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
            name: "nav-links-loader"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($313e1630e2530993$var$NavLinkItems, {
        textColor: textColor,
        backgroundColor: backgroundColor,
        requestCount: requestCount
    }));
};
module.exports["NavLinks"] = $313e1630e2530993$export$b615cd9717379c80;

});

parcelRegister("caqWd", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $a56148aa6f0ab9b5$export$ea207007e4cd246c = /*#__PURE__*/ (0, $cozmU.createContext)({
    isShimmering: true,
    size: 'medium'
});
module.exports["BreadcrumbsSkeletonContext"] = $a56148aa6f0ab9b5$export$ea207007e4cd246c;

});

parcelRegister("7IEOV", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $caqWd = parcelRequire("caqWd");

const $36b36ea00209802f$export$15d0b942535a287 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBreadcrumbsSkeleton() {
    return (0, $cozmU.useContext)((0, $caqWd.BreadcrumbsSkeletonContext));
} : function useBreadcrumbsSkeleton() {
    return (0, $cozmU.useContext)((0, $caqWd.BreadcrumbsSkeletonContext));
};
module.exports["useBreadcrumbsSkeleton"] = $36b36ea00209802f$export$15d0b942535a287;

});

parcelRegister("6alko", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5SGpQ = parcelRequire("5SGpQ");


var $lpNn5 = parcelRequire("lpNn5");


var $1sXWi = parcelRequire("1sXWi");


var $gpPFD = parcelRequire("gpPFD");

const $9a8122532f332b44$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(48);
    let component;
    let href;
    let icon;
    let id;
    let isDisabled;
    let isSelected;
    let label;
    let onBlur;
    let onClick;
    let onFocus;
    let onMouseDown;
    let onMouseEnter;
    let onMouseLeave;
    let onMouseUp;
    let rest;
    let t0;
    let target;
    let testId;
    let theme;
    let tooltip;
    if ($[0] !== props) {
        ({ icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: t0, ...rest } = props);
        $[0] = props;
        $[1] = component;
        $[2] = href;
        $[3] = icon;
        $[4] = id;
        $[5] = isDisabled;
        $[6] = isSelected;
        $[7] = label;
        $[8] = onBlur;
        $[9] = onClick;
        $[10] = onFocus;
        $[11] = onMouseDown;
        $[12] = onMouseEnter;
        $[13] = onMouseLeave;
        $[14] = onMouseUp;
        $[15] = rest;
        $[16] = t0;
        $[17] = target;
        $[18] = testId;
        $[19] = theme;
        $[20] = tooltip;
    } else {
        component = $[1];
        href = $[2];
        icon = $[3];
        id = $[4];
        isDisabled = $[5];
        isSelected = $[6];
        label = $[7];
        onBlur = $[8];
        onClick = $[9];
        onFocus = $[10];
        onMouseDown = $[11];
        onMouseEnter = $[12];
        onMouseLeave = $[13];
        onMouseUp = $[14];
        rest = $[15];
        t0 = $[16];
        target = $[17];
        testId = $[18];
        theme = $[19];
        tooltip = $[20];
    }
    const isTooltipAnnouncementDisabled = t0 === undefined ? false : t0;
    const themeFromContext = (0, $1sXWi.useTheme)();
    let t1;
    if ($[21] !== theme || $[22] !== themeFromContext) {
        t1 = theme || (0, $gpPFD.getIconButtonTheme)(themeFromContext);
        $[21] = theme;
        $[22] = themeFromContext;
        $[23] = t1;
    } else t1 = $[23];
    let t2;
    if ($[24] !== component || $[25] !== href || $[26] !== icon || $[27] !== id || $[28] !== isDisabled || $[29] !== isSelected || $[30] !== label || $[31] !== onBlur || $[32] !== onClick || $[33] !== onFocus || $[34] !== onMouseDown || $[35] !== onMouseEnter || $[36] !== onMouseLeave || $[37] !== onMouseUp || $[38] !== ref || $[39] !== rest || $[40] !== t1 || $[41] !== target || $[42] !== testId) {
        t2 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SGpQ.default), {
            appearance: "primary",
            "aria-label": label,
            component: component,
            href: href,
            iconBefore: icon,
            id: id,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onBlur: onBlur,
            onClick: onClick,
            onFocus: onFocus,
            onMouseDown: onMouseDown,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseUp: onMouseUp,
            ref: ref,
            target: target,
            testId: testId,
            theme: t1,
            ...rest
        });
        $[24] = component;
        $[25] = href;
        $[26] = icon;
        $[27] = id;
        $[28] = isDisabled;
        $[29] = isSelected;
        $[30] = label;
        $[31] = onBlur;
        $[32] = onClick;
        $[33] = onFocus;
        $[34] = onMouseDown;
        $[35] = onMouseEnter;
        $[36] = onMouseLeave;
        $[37] = onMouseUp;
        $[38] = ref;
        $[39] = rest;
        $[40] = t1;
        $[41] = target;
        $[42] = testId;
        $[43] = t2;
    } else t2 = $[43];
    const button = t2;
    if (tooltip) {
        let t3;
        if ($[44] !== button || $[45] !== isTooltipAnnouncementDisabled || $[46] !== tooltip) {
            t3 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                content: tooltip,
                hideTooltipOnClick: true,
                isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
                children: button
            });
            $[44] = button;
            $[45] = isTooltipAnnouncementDisabled;
            $[46] = tooltip;
            $[47] = t3;
        } else t3 = $[47];
        return t3;
    }
    return button;
} : (props, ref)=>{
    const { icon: icon, label: label, testId: testId, tooltip: tooltip, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, theme: theme, isTooltipAnnouncementDisabled: isTooltipAnnouncementDisabled = false, ...rest } = props;
    const themeFromContext = (0, $1sXWi.useTheme)();
    const button = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5SGpQ.default), {
        appearance: "primary",
        "aria-label": label,
        component: component,
        href: href,
        iconBefore: icon,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-unsafe-style-overrides
        theme: theme || (0, $gpPFD.getIconButtonTheme)(themeFromContext),
        ...rest
    });
    if (tooltip) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: tooltip,
        hideTooltipOnClick: true,
        isScreenReaderAnnouncementDisabled: isTooltipAnnouncementDisabled,
        children: button
    });
    return button;
});
module.exports["IconButton"] = $9a8122532f332b44$export$c25acd513dcc8062;

});

parcelRegister("kE9MM", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $arQY7 = parcelRequire("arQY7");


var $4ez2K = parcelRequire("4ez2K");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $r8hvx = parcelRequire("r8hvx");

const $c0432c8533e4daa6$var$styles = {
    displayName: "_2sNsIgmnOE",
    root: "_0Of8r22ADO _1wydGW2ADO _2Zuz6Q5zaO _1Znuxb5zaO",
    emailText: "_4bt5LAnQyn _2WAcuGnQyn _1ANEUSLRg7 _39HuIbz8Lp _39xV02N91d _3iDTPbvbI6 _1EqgXloaux"
};
const $c0432c8533e4daa6$export$66e04d0aacdb3b2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? ()=>{
    const $ = (0, $bDgLe.c)(15);
    const { user: user } = (0, $r8hvx.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.root
        ]);
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== avatarSrc) {
        t1 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            alignItems: "center",
            justifyContent: "center",
            gap: "space.100"
        }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
            appearance: "circle",
            size: "medium",
            src: avatarSrc
        }));
        $[1] = avatarSrc;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.displayName
        ]);
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== displayName) {
        t3 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t2
        }, displayName);
        $[4] = displayName;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.emailText
        ]);
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== email) {
        t5 = /*#__PURE__*/ $cozmU.createElement("small", {
            className: t4
        }, email);
        $[7] = email;
        $[8] = t5;
    } else t5 = $[8];
    let t6;
    if ($[9] !== t3 || $[10] !== t5) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, t3, t5);
        $[9] = t3;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    let t7;
    if ($[12] !== t1 || $[13] !== t6) {
        t7 = /*#__PURE__*/ $cozmU.createElement("div", {
            className: t0
        }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100"
        }, t1, t6));
        $[12] = t1;
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    return t7;
} : ()=>{
    const { user: user } = (0, $r8hvx.useHubContext)();
    const { avatarSrc: avatarSrc, displayName: displayName, email: email } = user;
    return /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.root
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center",
        justifyContent: "center",
        gap: "space.100"
    }, /*#__PURE__*/ $cozmU.createElement((0, $arQY7.default), {
        appearance: "circle",
        size: "medium",
        src: avatarSrc
    })), /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), null, /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.displayName
        ])
    }, displayName), /*#__PURE__*/ $cozmU.createElement("small", {
        className: (0, $hekY6.default)([
            $c0432c8533e4daa6$var$styles.emailText
        ])
    }, email))));
};
module.exports["AccountDetails"] = $c0432c8533e4daa6$export$66e04d0aacdb3b2;

});

parcelRegister("dk27U", function(module, exports) {
/**
 * @generated SignedSource<<4bed07e061999ed9f22a55e1b1401214>>
 * @relayHash 9167ad897bae8a64894ef8308ea351f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bd4ffde441f81fd5ca2ec83f6bbb63d9b154db45cf924d5ae6ad4da647ebd7c
const $02e557899f4f35e0$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "hubAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isConfigurableSiteTreeEnabled"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isDraft"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideNavMenusEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isTopicsEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "portalsFilter"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "hubAri"
        },
        {
            "kind": "Variable",
            "name": "isDraft",
            "variableName": "isDraft"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v10 = [
        {
            "kind": "Variable",
            "name": "portalsFilter",
            "variableName": "portalsFilter"
        }
    ], v11 = {
        "condition": "isHideNavMenusEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "HelpCenterBranding",
                "kind": "LinkedField",
                "name": "helpCenterBranding",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterNavigationBar",
                        "kind": "LinkedField",
                        "name": "navigationBar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "hiddenMenus"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "id"
    }, v13 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v14 = [
        v12 /*: any*/ ,
        {
            "concreteType": "HelpCenterPageName",
            "kind": "LinkedField",
            "name": "name",
            "plural": false,
            "selections": v13 /*: any*/ 
        }
    ], v15 = {
        "kind": "InlineFragment",
        "selections": v14 /*: any*/ ,
        "type": "HelpCenterPage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            v12 /*: any*/ 
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "kind": "FragmentSpread",
                                            "name": "portalDropdown_AtlassianHubAppShell"
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "topicDropdown_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "moreDropdown_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "siteNavigation_AtlassianHubAppShell"
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "navLinksQuery",
            "selections": [
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "HelpCenterQueryApi",
                    "kind": "LinkedField",
                    "name": "helpCenter",
                    "plural": false,
                    "selections": [
                        {
                            "args": v8 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "helpCenterById",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "HelpCenterPortals",
                                            "kind": "LinkedField",
                                            "name": "portals",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterPortal",
                                                    "kind": "LinkedField",
                                                    "name": "portalsList",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isTopicsEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "alias": "topicPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "TOPIC"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v14 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"TOPIC\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "alias": "customPages",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "filter",
                                                            "value": {
                                                                "ids": [],
                                                                "type": "CUSTOM"
                                                            }
                                                        }
                                                    ],
                                                    "concreteType": "HelpCenterPage",
                                                    "kind": "LinkedField",
                                                    "name": "pages",
                                                    "plural": true,
                                                    "selections": v14 /*: any*/ ,
                                                    "storageKey": "pages(filter:{\"ids\":[],\"type\":\"CUSTOM\"})"
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isConfigurableSiteTreeEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "HelpCenterSiteTree",
                                                    "kind": "LinkedField",
                                                    "name": "siteTree",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "HelpCenterFolder",
                                                            "kind": "LinkedField",
                                                            "name": "root",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "contents",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "nodes",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v9 /*: any*/ ,
                                                                                v15 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v12 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "HelpCenterFolderName",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "name",
                                                                                            "plural": false,
                                                                                            "selections": v13 /*: any*/ 
                                                                                        },
                                                                                        {
                                                                                            "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "contents",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "nodes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v15 /*: any*/ ,
                                                                                                        v16 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "HelpCenterFolder"
                                                                                },
                                                                                v16 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v12 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v11 /*: any*/ 
                                    ],
                                    "type": "HelpCenter"
                                },
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "7bd4ffde441f81fd5ca2ec83f6bbb63d9b154db45cf924d5ae6ad4da647ebd7c",
            "metadata": {},
            "name": "navLinksQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$02e557899f4f35e0$var$node.hash = "b335d58b621eacf12959f6864e39f900";
var $02e557899f4f35e0$export$2e2bcd8739ae039 = $02e557899f4f35e0$var$node;
module.exports["default"] = $02e557899f4f35e0$export$2e2bcd8739ae039;

});

parcelRegister("fk4YO", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $38732bf3e7790039$var$messages = (0, $kSwu1.defineMessages)({
    downIcon: {
        id: "company-hub.hub-app-shell.navbar.nav-links.down-icon",
        defaultMessage: "Open dropdown"
    },
    home: {
        id: "company-hub.hub-app-shell.navbar.nav-links.home",
        defaultMessage: "Home"
    },
    more: {
        id: "company-hub.hub-app-shell.navbar.nav-links.more",
        defaultMessage: "More"
    },
    openFolderSubmenu: {
        id: "company-hub.hub-app-shell.navbar.nav-links.openFolderSubmenu",
        defaultMessage: "Open folder"
    },
    portals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.portals",
        defaultMessage: "Portals"
    },
    requests: {
        id: "company-hub.hub-app-shell.navbar.nav-links.requests",
        defaultMessage: "Requests"
    },
    approvals: {
        id: "company-hub.hub-app-shell.navbar.nav-links.approvals",
        defaultMessage: "Approvals"
    }
});
var $38732bf3e7790039$export$2e2bcd8739ae039 = $38732bf3e7790039$var$messages;
module.exports["default"] = $38732bf3e7790039$export$2e2bcd8739ae039;

});

parcelRegister("jDOHN", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $j5TDY = parcelRequire("j5TDY");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6SsN4 = parcelRequire("6SsN4");

parcelRequire("fMvIa");
var $idnP4 = parcelRequire("idnP4");


var $w6R6I = parcelRequire("w6R6I");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $32sS3 = parcelRequire("32sS3");


var $fk4YO = parcelRequire("fk4YO");


var $eOe1k = parcelRequire("eOe1k");

const $b95d7135bf311635$var$EMPTY_SITE_NAVIGATION_ITEMS = [];
const $b95d7135bf311635$var$styles = {
    centerSlot: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _1mT5xdRAKS",
    navItemLabel: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _1EqgXlgZxp _39HuIbz8Lp _1ANEUSLRg7",
    trigger: "_0bjKvDKTcp _2sNsIgmnOE _4c065UPgdg _2Y7lL48HPE _3iDTPbccYA _24h04i2Njc _0hPCNLDIqT _17lj8p1Y8M _0jFU0VZ49V _0KLXru66of _1kk5Tkf7mX _1eOmH6o126 _3gzVzLN4oS",
    triggerSelected: "_0KLXruY9q9 _1UtDYzjTy9 _1eOmH6sumd _3gzVzLXsxn",
    measurementViewport: "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d _4bt5LAnQyn _0fKRyPnQyn _1pp6NdYbGa",
    measurementRow: "_2mHwu81Y8M _3iDTPbQ4SZ _39xV02W9qI"
};
const $b95d7135bf311635$var$NavItemLabel = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $b95d7135bf311635$var$styles.navItemLabel
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $b95d7135bf311635$var$styles.navItemLabel
    }, children);
const $b95d7135bf311635$var$NavTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? function NavTrigger(t0, ref) {
    const $ = (0, $bDgLe.c)(25);
    let children;
    let props;
    let t1;
    let t2;
    let t3;
    let t4;
    let textColor;
    if ($[0] !== t0) {
        ({ children: children, iconLabel: t1, isSelected: t2, showIcon: t3, textColor: textColor, truncate: t4, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
        $[7] = textColor;
    } else {
        children = $[1];
        props = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
        textColor = $[7];
    }
    const iconLabel = t1 === undefined ? "" : t1;
    const isSelected = t2 === undefined ? false : t2;
    const showIcon = t3 === undefined ? true : t3;
    const truncate = t4 === undefined ? false : t4;
    const t5 = isSelected ? undefined : textColor;
    let t6;
    if ($[8] !== t5) {
        t6 = {
            color: t5
        };
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const t7 = isSelected && $b95d7135bf311635$var$styles.triggerSelected;
    let t8;
    if ($[10] !== t7) {
        t8 = (0, $w6R6I.cx)($b95d7135bf311635$var$styles.trigger, t7);
        $[10] = t7;
        $[11] = t8;
    } else t8 = $[11];
    let t9;
    if ($[12] !== children || $[13] !== truncate) {
        t9 = truncate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, children) : children;
        $[12] = children;
        $[13] = truncate;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== iconLabel || $[16] !== showIcon) {
        t10 = showIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
            color: "currentColor",
            label: iconLabel
        });
        $[15] = iconLabel;
        $[16] = showIcon;
        $[17] = t10;
    } else t10 = $[17];
    let t11;
    if ($[18] !== props || $[19] !== ref || $[20] !== t10 || $[21] !== t6 || $[22] !== t8 || $[23] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            ...props,
            ref: ref,
            style: t6,
            xcss: t8
        }, t9, t10);
        $[18] = props;
        $[19] = ref;
        $[20] = t10;
        $[21] = t6;
        $[22] = t8;
        $[23] = t9;
        $[24] = t11;
    } else t11 = $[24];
    return t11;
} : function NavTrigger({ children: children, iconLabel: iconLabel = '', isSelected: isSelected = false, showIcon: showIcon = true, textColor: textColor, truncate: truncate = false, ...props }, ref) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...props,
        ref: ref,
        style: {
            color: isSelected ? undefined : textColor
        },
        xcss: (0, $w6R6I.cx)($b95d7135bf311635$var$styles.trigger, isSelected && $b95d7135bf311635$var$styles.triggerSelected)
    }, truncate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, children) : children, showIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        color: "currentColor",
        label: iconLabel
    }));
});
const $b95d7135bf311635$var$getFolderPages = (folder)=>folder.contents.nodes.filter((node)=>node.__typename === 'HelpCenterPage');
const $b95d7135bf311635$var$getPageId = (page)=>{
    try {
        return (0, $32sS3.HelpPageAri).parse(page.id).pageId;
    } catch  {
        return null;
    }
};
const $b95d7135bf311635$var$PageItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { page: page } = t0;
    const { push: push } = (0, $idnP4.useRouterActions)();
    let t1;
    if ($[0] !== page) {
        t1 = $b95d7135bf311635$var$getPageId(page);
        $[0] = page;
        $[1] = t1;
    } else t1 = $[1];
    const pageId = t1;
    if (!pageId) return null;
    let t2;
    if ($[2] !== pageId || $[3] !== push) {
        t2 = ()=>push(`/page/${pageId}`);
        $[2] = pageId;
        $[3] = push;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = page.name?.default ?? "";
    let t4;
    if ($[5] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, t3);
        $[5] = t3;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== t2 || $[8] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
            onClick: t2
        }, t4);
        $[7] = t2;
        $[8] = t4;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ page: page })=>{
    const { push: push } = (0, $idnP4.useRouterActions)();
    const pageId = $b95d7135bf311635$var$getPageId(page);
    if (!pageId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
        onClick: ()=>push(`/page/${pageId}`)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, page.name?.default ?? ''));
};
const $b95d7135bf311635$var$FolderMenuItems = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { pages: pages } = t0;
    let t1;
    if ($[0] !== pages) {
        t1 = pages.map($b95d7135bf311635$var$_temp);
        $[0] = pages;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : ({ pages: pages })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, pages.map((page)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PageItem, {
            key: page.id,
            page: page
        })));
const $b95d7135bf311635$var$PromotedFolderMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { folder: folder, textColor: textColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== folder.name?.default || $[1] !== formatMessage || $[2] !== textColor) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $fk4YO.default).downIcon),
                ref: triggerRef,
                textColor: textColor,
                truncate: true
            }, folder.name?.default ?? "");
        };
        $[0] = folder.name?.default;
        $[1] = formatMessage;
        $[2] = textColor;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== folder) {
        t2 = $b95d7135bf311635$var$getFolderPages(folder);
        $[4] = folder;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$FolderMenuItems, {
            pages: t2
        });
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== t1 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "bottom-start",
            shouldRenderToParent: true,
            trigger: t1
        }, t3);
        $[8] = t1;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
} : ({ folder: folder, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "bottom-start",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $fk4YO.default).downIcon),
                ref: triggerRef,
                textColor: textColor,
                truncate: true
            }, folder.name?.default ?? '')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$FolderMenuItems, {
        pages: $b95d7135bf311635$var$getFolderPages(folder)
    }));
};
const $b95d7135bf311635$var$PromotedPage = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { page: page, textColor: textColor } = t0;
    const { push: push } = (0, $idnP4.useRouterActions)();
    let t1;
    if ($[0] !== page) {
        t1 = $b95d7135bf311635$var$getPageId(page);
        $[0] = page;
        $[1] = t1;
    } else t1 = $[1];
    const pageId = t1;
    if (!pageId) return null;
    let t2;
    if ($[2] !== pageId || $[3] !== push) {
        t2 = ()=>push(`/page/${pageId}`);
        $[2] = pageId;
        $[3] = push;
        $[4] = t2;
    } else t2 = $[4];
    const t3 = page.name?.default ?? "";
    let t4;
    if ($[5] !== t2 || $[6] !== t3 || $[7] !== textColor) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
            onClick: t2,
            showIcon: false,
            textColor: textColor,
            truncate: true
        }, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = textColor;
        $[8] = t4;
    } else t4 = $[8];
    return t4;
} : ({ page: page, textColor: textColor })=>{
    const { push: push } = (0, $idnP4.useRouterActions)();
    const pageId = $b95d7135bf311635$var$getPageId(page);
    if (!pageId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
        onClick: ()=>push(`/page/${pageId}`),
        showIcon: false,
        textColor: textColor,
        truncate: true
    }, page.name?.default ?? '');
};
const $b95d7135bf311635$var$OverflowFolderMenu = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { folder: folder } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== folder.name?.default || $[1] !== formatMessage) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, ...props } = t2;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                ...props,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: formatMessage((0, $fk4YO.default).openFolderSubmenu),
                    size: "small"
                }),
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, folder.name?.default ?? ""));
        };
        $[0] = folder.name?.default;
        $[1] = formatMessage;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== folder) {
        t2 = $b95d7135bf311635$var$getFolderPages(folder);
        $[3] = folder;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$FolderMenuItems, {
            pages: t2
        });
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t1 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            placement: "right-start",
            shouldFlip: true,
            shouldRenderToParent: true,
            trigger: t1
        }, t3);
        $[7] = t1;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
} : ({ folder: folder })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        placement: "right-start",
        shouldFlip: true,
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $is1T6.default), {
                ...props,
                elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    label: formatMessage((0, $fk4YO.default).openFolderSubmenu),
                    size: "small"
                }),
                ref: triggerRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavItemLabel, null, folder.name?.default ?? ''))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$FolderMenuItems, {
        pages: $b95d7135bf311635$var$getFolderPages(folder)
    }));
};
const $b95d7135bf311635$var$OverflowItem = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { item: item } = t0;
    let t1;
    if ($[0] !== item) {
        t1 = item.__typename === "HelpCenterPage" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PageItem, {
            page: item
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$OverflowFolderMenu, {
            folder: item
        });
        $[0] = item;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ item: item })=>item.__typename === 'HelpCenterPage' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PageItem, {
        page: item
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$OverflowFolderMenu, {
        folder: item
    });
const $b95d7135bf311635$export$c14b2ae736940562 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { overflowItems: overflowItems, promotedItems: promotedItems, textColor: textColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (promotedItems.length === 0 && overflowItems.length === 0) return null;
    let t1;
    if ($[0] !== promotedItems || $[1] !== textColor) {
        let t2;
        if ($[3] !== textColor) {
            t2 = (item)=>item.__typename === "HelpCenterFolder" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PromotedFolderMenu, {
                    key: item.id,
                    folder: item,
                    textColor: textColor
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PromotedPage, {
                    key: item.id,
                    page: item,
                    textColor: textColor
                });
            $[3] = textColor;
            $[4] = t2;
        } else t2 = $[4];
        t1 = promotedItems.map(t2);
        $[0] = promotedItems;
        $[1] = textColor;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[5] !== formatMessage || $[6] !== overflowItems || $[7] !== textColor) {
        t2 = overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
            shouldRenderToParent: true,
            trigger: (t3)=>{
                const { triggerRef: triggerRef, ...props } = t3;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                    ...props,
                    iconLabel: formatMessage((0, $fk4YO.default).downIcon),
                    ref: triggerRef,
                    testId: "site-navigation-more",
                    textColor: textColor
                }, formatMessage((0, $fk4YO.default).more));
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, overflowItems.map($b95d7135bf311635$var$_temp2)));
        $[5] = formatMessage;
        $[6] = overflowItems;
        $[7] = textColor;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== t1 || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
} : ({ overflowItems: overflowItems, promotedItems: promotedItems, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (promotedItems.length === 0 && overflowItems.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, promotedItems.map((item)=>item.__typename === 'HelpCenterFolder' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PromotedFolderMenu, {
            key: item.id,
            folder: item,
            textColor: textColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PromotedPage, {
            key: item.id,
            page: item,
            textColor: textColor
        })), overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3vgx3.default), {
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                ...props,
                iconLabel: formatMessage((0, $fk4YO.default).downIcon),
                ref: triggerRef,
                testId: "site-navigation-more",
                textColor: textColor
            }, formatMessage((0, $fk4YO.default).more))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9erVg.default), null, overflowItems.map((item_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$OverflowItem, {
            key: item_0.id,
            item: item_0
        })))));
};
const $b95d7135bf311635$export$42c2afabaf9bb88e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { queryRef: queryRef, textColor: textColor } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const slotRef = (0, $cozmU.useRef)(null);
    const measurementRowRef = (0, $cozmU.useRef)(null);
    const data = (0, $6SsN4.useFragment)((0, $j5TDY.default), queryRef);
    const nodes = data?.siteTree?.root?.contents.nodes;
    let t1;
    if ($[0] !== nodes) {
        t1 = nodes?.filter($b95d7135bf311635$var$_temp3) ?? $b95d7135bf311635$var$EMPTY_SITE_NAVIGATION_ITEMS;
        $[0] = nodes;
        $[1] = t1;
    } else t1 = $[1];
    const items = t1;
    let t2;
    if ($[2] !== items) {
        t2 = {
            items: items,
            measurementRowRef: measurementRowRef,
            slotRef: slotRef
        };
        $[2] = items;
        $[3] = t2;
    } else t2 = $[3];
    const { overflowItems: overflowItems, promotedItems: promotedItems } = (0, $eOe1k.useSiteNavigationOverflow)(t2);
    let t3;
    if ($[4] !== overflowItems || $[5] !== promotedItems || $[6] !== textColor) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$export$c14b2ae736940562, {
            overflowItems: overflowItems,
            promotedItems: promotedItems,
            textColor: textColor
        });
        $[4] = overflowItems;
        $[5] = promotedItems;
        $[6] = textColor;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== items || $[9] !== textColor) {
        let t5;
        if ($[11] !== textColor) {
            t5 = (item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                    "data-site-navigation-item-id": item.id,
                    key: item.id
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
                    iconLabel: "",
                    tabIndex: -1,
                    textColor: textColor,
                    truncate: true
                }, item.name?.default));
            $[11] = textColor;
            $[12] = t5;
        } else t5 = $[12];
        t4 = items.map(t5);
        $[8] = items;
        $[9] = textColor;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[13] !== formatMessage) {
        t5 = formatMessage((0, $fk4YO.default).more);
        $[13] = formatMessage;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== t5 || $[16] !== textColor) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "data-site-navigation-more-item": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
            iconLabel: "",
            tabIndex: -1,
            textColor: textColor
        }, t5));
        $[15] = t5;
        $[16] = textColor;
        $[17] = t6;
    } else t6 = $[17];
    let t7;
    if ($[18] !== t4 || $[19] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "aria-hidden": "true",
            testId: "site-navigation-measurement-viewport",
            xcss: $b95d7135bf311635$var$styles.measurementViewport
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "aria-hidden": "true",
            ref: measurementRowRef,
            testId: "site-navigation-measurement-row",
            xcss: $b95d7135bf311635$var$styles.measurementRow
        }, t4, t6));
        $[18] = t4;
        $[19] = t6;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== t3 || $[22] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: slotRef,
            testId: "nav-links-center-slot",
            xcss: $b95d7135bf311635$var$styles.centerSlot
        }, t3, t7);
        $[21] = t3;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ queryRef: queryRef, textColor: textColor })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const slotRef = (0, $cozmU.useRef)(null);
    const measurementRowRef = (0, $cozmU.useRef)(null);
    const data = (0, $6SsN4.useFragment)((0, $j5TDY.default), queryRef);
    const nodes = data?.siteTree?.root?.contents.nodes;
    const items = (0, $cozmU.useMemo)(()=>nodes?.filter((node)=>node.__typename === 'HelpCenterPage' || node.__typename === 'HelpCenterFolder') ?? $b95d7135bf311635$var$EMPTY_SITE_NAVIGATION_ITEMS, [
        nodes
    ]);
    const { overflowItems: overflowItems, promotedItems: promotedItems } = (0, $eOe1k.useSiteNavigationOverflow)({
        items: items,
        measurementRowRef: measurementRowRef,
        slotRef: slotRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: slotRef,
        testId: "nav-links-center-slot",
        xcss: $b95d7135bf311635$var$styles.centerSlot
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$export$c14b2ae736940562, {
        overflowItems: overflowItems,
        promotedItems: promotedItems,
        textColor: textColor
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        testId: "site-navigation-measurement-viewport",
        xcss: $b95d7135bf311635$var$styles.measurementViewport
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        ref: measurementRowRef,
        testId: "site-navigation-measurement-row",
        xcss: $b95d7135bf311635$var$styles.measurementRow
    }, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "data-site-navigation-item-id": item.id,
            key: item.id
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
            iconLabel: "",
            tabIndex: -1,
            textColor: textColor,
            truncate: true
        }, item.name?.default))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "data-site-navigation-more-item": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$NavTrigger, {
        iconLabel: "",
        tabIndex: -1,
        textColor: textColor
    }, formatMessage((0, $fk4YO.default).more))))));
};
function $b95d7135bf311635$var$_temp(page) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$PageItem, {
        key: page.id,
        page: page
    });
}
function $b95d7135bf311635$var$_temp2(item_0) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b95d7135bf311635$var$OverflowItem, {
        key: item_0.id,
        item: item_0
    });
}
function $b95d7135bf311635$var$_temp3(node) {
    return node.__typename === "HelpCenterPage" || node.__typename === "HelpCenterFolder";
}
module.exports["SiteNavigation"] = $b95d7135bf311635$export$42c2afabaf9bb88e;

});

parcelRegister("gpPFD", function(module, exports) {
const $bd8e48c4edd6c1ef$export$f32bddcb857301f3 = ({ mode: { iconButton: iconButton } })=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                borderRadius: "var(--ds-radius-full, 100%)",
                display: 'flex',
                margin: `0 ${"var(--ds-space-025, 2px)"}`,
                padding: "var(--ds-space-050, 4px)",
                height: 'auto',
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ...iconButton.default,
                ':hover': iconButton.hover,
                ':focus': iconButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                '&&': {
                    ...props.state === 'active' && iconButton.active
                },
                ...props.state === 'selected' && iconButton.selected,
                '> span': {
                    margin: 0
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
module.exports["getIconButtonTheme"] = $bd8e48c4edd6c1ef$export$f32bddcb857301f3;

});

parcelRegister("j5TDY", function(module, exports) {
/**
 * @generated SignedSource<<7a74aadd35812656d4f189fff568b4c0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d51e409169beb237$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "kind": "ScalarField",
            "name": "default"
        }
    ], v3 = {
        "kind": "InlineFragment",
        "selections": [
            v1 /*: any*/ ,
            {
                "concreteType": "HelpCenterPageName",
                "kind": "LinkedField",
                "name": "name",
                "plural": false,
                "selections": v2 /*: any*/ 
            }
        ],
        "type": "HelpCenterPage"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "siteNavigation_AtlassianHubAppShell",
        "selections": [
            {
                "concreteType": "HelpCenterSiteTree",
                "kind": "LinkedField",
                "name": "siteTree",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "HelpCenterFolder",
                        "kind": "LinkedField",
                        "name": "root",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HelpCenterSiteTreeNodeConnection",
                                "kind": "LinkedField",
                                "name": "contents",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                            v0 /*: any*/ ,
                                            v3 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v1 /*: any*/ ,
                                                    {
                                                        "concreteType": "HelpCenterFolderName",
                                                        "kind": "LinkedField",
                                                        "name": "name",
                                                        "plural": false,
                                                        "selections": v2 /*: any*/ 
                                                    },
                                                    {
                                                        "concreteType": "HelpCenterSiteTreeNodeConnection",
                                                        "kind": "LinkedField",
                                                        "name": "contents",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "nodes",
                                                                "plural": true,
                                                                "selections": [
                                                                    v0 /*: any*/ ,
                                                                    v3 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "type": "HelpCenterFolder"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "HelpCenter"
    };
}();
$d51e409169beb237$var$node.hash = "758f2701bd08a1f04afa67c01cd4f843";
var $d51e409169beb237$export$2e2bcd8739ae039 = $d51e409169beb237$var$node;
module.exports["default"] = $d51e409169beb237$export$2e2bcd8739ae039;

});

parcelRegister("eOe1k", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");


var $e9dqk = parcelRequire("e9dqk");

const $6c553aeebda47205$var$getLeftoverWidth = (row, slot)=>{
    const rowWidth = row.getBoundingClientRect().width;
    const gapWidth = Number.parseFloat(window.getComputedStyle(row).columnGap) || Number.parseFloat(window.getComputedStyle(row).gap) || 0;
    const children = Array.from(row.children);
    const siblingWidth = children.filter((child)=>child !== slot).reduce((total, child)=>total + child.getBoundingClientRect().width, 0);
    const gapCount = Math.max(children.length - 1, 0);
    return rowWidth - siblingWidth - gapCount * gapWidth;
};
const $6c553aeebda47205$export$afacae323adcfe97 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { items: items, measurementRowRef: measurementRowRef, slotRef: slotRef } = t0;
    let t1;
    if ($[0] !== items) {
        t1 = ()=>({
                promotedItems: [],
                overflowItems: [
                    ...items
                ]
            });
        $[0] = items;
        $[1] = t1;
    } else t1 = $[1];
    const [split, setSplit] = (0, $cozmU.useState)(t1);
    let t2;
    let t3;
    if ($[2] !== items || $[3] !== measurementRowRef || $[4] !== slotRef) {
        t2 = ()=>{
            const slot = slotRef.current;
            const measurementRow = measurementRowRef.current;
            const row = slot?.parentElement;
            if (!slot || !measurementRow || !row) return;
            let animationFrame = null;
            let hasUsableMeasurement = false;
            const measure = ()=>{
                const itemWidths = Object.fromEntries(Array.from(measurementRow.querySelectorAll("[data-site-navigation-item-id]"), $6c553aeebda47205$var$_temp));
                const moreItem = measurementRow.querySelector("[data-site-navigation-more-item]");
                const gapWidth = Number.parseFloat(window.getComputedStyle(measurementRow).columnGap) || 0;
                const availableWidth = $6c553aeebda47205$var$getLeftoverWidth(row, slot);
                if (availableWidth <= 0) return;
                hasUsableMeasurement = true;
                const next = (0, $e9dqk.splitSiteNavigation)(items, {
                    availableWidth: availableWidth,
                    itemWidths: itemWidths,
                    gapWidth: gapWidth,
                    moreWidth: moreItem?.getBoundingClientRect().width ?? 0
                });
                setSplit((previous)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previous, next) ? previous : next);
            };
            const scheduleMeasurement = ()=>{
                if (!hasUsableMeasurement) {
                    measure();
                    return;
                }
                if (animationFrame === null) animationFrame = requestAnimationFrame(()=>{
                    animationFrame = null;
                    measure();
                });
            };
            measure();
            const observer = new ResizeObserver(scheduleMeasurement);
            observer.observe(row);
            observer.observe(measurementRow);
            return ()=>{
                if (animationFrame !== null) cancelAnimationFrame(animationFrame);
                observer.disconnect();
            };
        };
        t3 = [
            items,
            measurementRowRef,
            slotRef
        ];
        $[2] = items;
        $[3] = measurementRowRef;
        $[4] = slotRef;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useLayoutEffect)(t2, t3);
    return split;
} : ({ items: items, measurementRowRef: measurementRowRef, slotRef: slotRef })=>{
    const [split, setSplit] = (0, $cozmU.useState)(()=>({
            promotedItems: [],
            overflowItems: [
                ...items
            ]
        }));
    (0, $cozmU.useLayoutEffect)(()=>{
        const slot = slotRef.current;
        const measurementRow = measurementRowRef.current;
        const row = slot?.parentElement;
        if (!slot || !measurementRow || !row) return;
        let animationFrame = null;
        let hasUsableMeasurement = false;
        const measure = ()=>{
            const itemWidths = Object.fromEntries(Array.from(measurementRow.querySelectorAll('[data-site-navigation-item-id]'), (element)=>[
                    element.getAttribute('data-site-navigation-item-id') ?? '',
                    element.getBoundingClientRect().width
                ]));
            const moreItem = measurementRow.querySelector('[data-site-navigation-more-item]');
            const gapWidth = Number.parseFloat(window.getComputedStyle(measurementRow).columnGap) || 0;
            // Centering hugs the slot, so leftover width is the row minus Home /
            // Portals / Requests (and their gaps), not the slot's own box.
            const availableWidth = $6c553aeebda47205$var$getLeftoverWidth(row, slot);
            // The navbar row is `display: none` until its responsive breakpoint
            // resolves, so wait until leftover width is usable.
            if (availableWidth <= 0) return;
            hasUsableMeasurement = true;
            const next = (0, $e9dqk.splitSiteNavigation)(items, {
                availableWidth: availableWidth,
                itemWidths: itemWidths,
                gapWidth: gapWidth,
                moreWidth: moreItem?.getBoundingClientRect().width ?? 0
            });
            // Deep-compare so renames (same ids, new names) still update the nav.
            setSplit((previous)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previous, next) ? previous : next);
        };
        // Coalesce resize callbacks after the first usable synchronous measure.
        const scheduleMeasurement = ()=>{
            if (!hasUsableMeasurement) {
                measure();
                return;
            }
            if (animationFrame === null) animationFrame = requestAnimationFrame(()=>{
                animationFrame = null;
                measure();
            });
        };
        // Measure before the browser paints so the first frame already shows the
        // correct split, rather than briefly rendering everything under More.
        measure();
        const observer = new ResizeObserver(scheduleMeasurement);
        observer.observe(row);
        observer.observe(measurementRow);
        return ()=>{
            if (animationFrame !== null) cancelAnimationFrame(animationFrame);
            observer.disconnect();
        };
    }, [
        items,
        measurementRowRef,
        slotRef
    ]);
    return split;
};
function $6c553aeebda47205$var$_temp(element) {
    return [
        element.getAttribute("data-site-navigation-item-id") ?? "",
        element.getBoundingClientRect().width
    ];
}
module.exports["useSiteNavigationOverflow"] = $6c553aeebda47205$export$afacae323adcfe97;

});

parcelRegister("e9dqk", function(module, exports) {
// Allow 1px of sub-pixel rounding so the split does not flap.
const $641217715532bb5f$var$COMPARISON_TOLERANCE = 1;
const $641217715532bb5f$var$getRowWidth = ({ itemWidths: itemWidths, items: items, gapWidth: gapWidth, moreWidth: moreWidth, showMore: showMore })=>{
    const visibleItemCount = items.length + (showMore ? 1 : 0);
    const visibleGapCount = Math.max(visibleItemCount - 1, 0);
    // An unmeasured item is unfittable, so it stays in More.
    const promotedItemWidth = items.reduce((total, { id: id })=>total + (itemWidths[id] ?? Number.MAX_SAFE_INTEGER), 0);
    return promotedItemWidth + (showMore ? moreWidth : 0) + visibleGapCount * gapWidth;
};
const $641217715532bb5f$export$b77a77786b18d4b = (items, measurements)=>{
    const conservativeSplit = {
        promotedItems: [],
        overflowItems: [
            ...items
        ]
    };
    if (measurements.availableWidth === null || items.length === 0) return conservativeSplit;
    const availableWidth = measurements.availableWidth;
    const fits = (candidateItems, showMore)=>$641217715532bb5f$var$getRowWidth({
            ...measurements,
            items: candidateItems,
            showMore: showMore
        }) <= availableWidth + $641217715532bb5f$var$COMPARISON_TOLERANCE;
    // "More" is optional when every item fits.
    if (fits([
        ...items
    ], false)) return {
        promotedItems: [
            ...items
        ],
        overflowItems: []
    };
    // Reserve "More" and promote root items left to right while they still fit beside it.
    const promotedItems = [];
    for (const item of items){
        const candidateItems = [
            ...promotedItems,
            item
        ];
        if (!fits(candidateItems, true)) break;
        promotedItems.push(item);
    }
    return {
        promotedItems: promotedItems,
        overflowItems: items.slice(promotedItems.length)
    };
};
module.exports["splitSiteNavigation"] = $641217715532bb5f$export$b77a77786b18d4b;

});

$parcel$global.rwr("aFBfl", () => { 
var $cozmU = parcelRequire("cozmU");


var $fRQ3t = parcelRequire("fRQ3t");


var $4jxwi = parcelRequire("4jxwi");


var $7D1yr = parcelRequire("7D1yr");


var $gJN0g = parcelRequire("gJN0g");


var $9kbTQ = parcelRequire("9kbTQ");


var $9HkI0 = parcelRequire("9HkI0");


var $65DSU = parcelRequire("65DSU");


var $gXfti = parcelRequire("gXfti");


var $fAsH0 = parcelRequire("fAsH0");


var $lTECB = parcelRequire("lTECB");


var $lJlG6 = parcelRequire("lJlG6");


var $6mKj3 = parcelRequire("6mKj3");


var $cRN1p = parcelRequire("cRN1p");


var $hvG5K = parcelRequire("hvG5K");


var $59ylD = parcelRequire("59ylD");

function $127d9b8e16c6a735$export$a311cb1baa7d2d62() {
    (0, $59ylD.resourceTimingBuffer).start();
}



var $e1XeN = parcelRequire("e1XeN");


var $8NKQ9 = parcelRequire("8NKQ9");


var $04e9M = parcelRequire("04e9M");


var $i7t6K = parcelRequire("i7t6K");


var $2c1Wz = parcelRequire("2c1Wz");

const $dc2c9e680a6dd356$var$MAX_REPORTED_SHIFTS = 50;
// JSON uses at most three UTF-8 bytes per UTF-16 code unit. Bound the detailed
// array to roughly 30 KB even for non-ASCII selectors, plus the small summary.
const $dc2c9e680a6dd356$var$MAX_DETAIL_CHARACTERS = 10000;
function $dc2c9e680a6dd356$var$findFiberNode(domNode) {
    if (!domNode) return undefined;
    const key = Object.keys(domNode).find((k)=>k.startsWith('__reactFiber$'));
    return key ? Reflect.get(domNode, key) : undefined;
}
function $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) {
    let current = fiberNode;
    while(current){
        if (current.memoizedProps?.__boundaryMarker) return current.memoizedProps?.attribution ?? 'unknown';
        current = current.return;
    }
    return 'not-attributed';
}
function $dc2c9e680a6dd356$var$toQuerySelector(node) {
    const path = [];
    if (node instanceof HTMLElement) {
        if (node.tagName) path.push(node.tagName.toLowerCase());
        // DOM IDs can contain user-authored heading text. Never include them.
        if (node.className) path.push(`.${node.className.split(' ').join('.')}`);
        if (node.dataset) Object.entries(node.dataset).forEach(([key, value])=>{
            path.push(`[data-${key}=${value}]`);
        });
    }
    return path.join('');
}
function $dc2c9e680a6dd356$var$toRect(rect) {
    return [
        rect.left,
        rect.top,
        rect.right,
        rect.bottom
    ];
}
function $dc2c9e680a6dd356$var$hasChangedRect({ previousRect: previousRect, currentRect: currentRect }) {
    return previousRect.x !== currentRect.x || previousRect.y !== currentRect.y || previousRect.width !== currentRect.width || previousRect.height !== currentRect.height || previousRect.top !== currentRect.top || previousRect.right !== currentRect.right || previousRect.bottom !== currentRect.bottom || previousRect.left !== currentRect.left;
}
function $dc2c9e680a6dd356$var$assignSessionWindows(records) {
    let current;
    let maxValue = 0;
    let maxSessionRef = null;
    for (const record of records){
        const { shift: shift } = record;
        // Match UFO's lighthouse-metrics/cls eligibility and burst boundaries.
        // UFO currently includes hadRecentInput entries; preserve that flag in
        // the details rather than silently applying a different metric policy.
        // The browser reports at most five sources per shift, so this scan is bounded.
        if (!shift.sources.some($dc2c9e680a6dd356$var$hasChangedRect)) continue;
        const end = shift.startTime + shift.duration;
        if (!current || shift.startTime - current.end > 1000 || end - current.start > 5000) current = {
            ref: (current?.ref ?? 0) + 1,
            start: shift.startTime,
            end: end,
            value: 0
        };
        current.end = end;
        current.value += shift.value;
        record.sessionRef = current.ref;
        if (current.value > maxValue) {
            maxValue = current.value;
            maxSessionRef = current.ref;
        }
    }
    return maxSessionRef;
}
const $dc2c9e680a6dd356$export$36b44777ebe5656d = (experienceName, clsAttributionConfig, { start: start, end: end, type: type, getCLS: getCLS })=>{
    const buffer = (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift];
    const shifts = buffer.buffer.filter((shift)=>shift.startTime >= start && shift.startTime <= end);
    const payload = {
        version: 2,
        totalShift: shifts.reduce((total, shift)=>total + shift.value, 0),
        shiftCount: shifts.length,
        bufferTruncated: buffer.full,
        shifts: [],
        omittedShiftCount: 0
    };
    // Preserve the existing per-experience switch. No DOM/fiber traversal,
    // geometry serialization, or session analysis when details are disabled.
    if (!clsAttributionConfig.includeEntries?.[experienceName]) return payload;
    const { loadType: loadType } = clsAttributionConfig;
    const matchesLoadType = loadType === undefined || (loadType === 'initial' || loadType === 'both') && type === 'page_load' || (loadType === 'transition' || loadType === 'both') && type === 'transition';
    if (!matchesLoadType) return payload;
    const threshold = clsAttributionConfig.clsDetailsThreshold ?? 0;
    // Only read UFO's metric when needed, never the separate attribution buffer.
    // An absent metric cannot satisfy a positive threshold.
    if (threshold > 0) {
        const cls = getCLS?.();
        if (cls === undefined || cls < threshold) return payload;
    }
    shifts.sort((a, b)=>a.startTime - b.startTime);
    const records = shifts.map((shift, index)=>({
            shift: shift,
            shiftRef: index + 1,
            sessionRef: null
        }));
    const maxSessionRef = $dc2c9e680a6dd356$var$assignSessionWindows(records);
    const nodeRefs = new WeakMap();
    let nextNodeRef = 1;
    let detailCharacters = 2;
    // Prefer the largest shifts when the detail budget is exhausted. The
    // summary and window membership always use all retained in-window shifts.
    for (const { shift: shift, shiftRef: shiftRef, sessionRef: sessionRef } of records.sort((a, b)=>b.shift.value - a.shift.value).slice(0, $dc2c9e680a6dd356$var$MAX_REPORTED_SHIFTS)){
        const entry = {
            shiftRef: shiftRef,
            time: shift.startTime - start,
            value: shift.value,
            hadRecentInput: shift.hadRecentInput,
            sessionRef: sessionRef,
            inMaxSession: sessionRef !== null && sessionRef === maxSessionRef,
            // At most five browser-provided sources for each of at most 50 selected shifts.
            sources: shift.sources.map((source)=>{
                let nodeRef = null;
                if (source.node) {
                    nodeRef = nodeRefs.get(source.node) ?? nextNodeRef++;
                    nodeRefs.set(source.node, nodeRef);
                }
                const fiberNode = $dc2c9e680a6dd356$var$findFiberNode(source.node);
                return {
                    nodeRef: nodeRef,
                    attribution: fiberNode ? $dc2c9e680a6dd356$var$attributionByClosestFiberNode(fiberNode) : 'nonReact',
                    element: source.node ? $dc2c9e680a6dd356$var$toQuerySelector(source.node) : 'undefined',
                    previousRect: $dc2c9e680a6dd356$var$toRect(source.previousRect),
                    currentRect: $dc2c9e680a6dd356$var$toRect(source.currentRect),
                    hasInsideShift: source.previousRect.width !== source.currentRect.width || source.previousRect.height !== source.currentRect.height,
                    hasOutsideShift: source.previousRect.x !== source.currentRect.x || source.previousRect.y !== source.currentRect.y
                };
            })
        };
        const characters = JSON.stringify(entry).length + 1;
        if (detailCharacters + characters <= $dc2c9e680a6dd356$var$MAX_DETAIL_CHARACTERS) {
            payload.shifts.push(entry);
            detailCharacters += characters;
        }
    }
    payload.shifts.sort((a, b)=>a.shiftRef - b.shiftRef);
    payload.omittedShiftCount = shifts.length - payload.shifts.length;
    return payload;
};



var $9wGTI = parcelRequire("9wGTI");

const $4f467cf502568ccb$export$2d8f8d64dc343d7b = ()=>{
    if (typeof window === 'undefined' || !window.__HYDRATABLE__) return undefined;
    return {
        successful: !window.__HYDRATION_ERRORS__?.length,
        warningCount: 0,
        minWarningComponentDepth: 0,
        maxWarningComponentDepth: 0
    };
};



var $5ZqQS = parcelRequire("5ZqQS");


var $9eE57 = parcelRequire("9eE57");


var $1xpoY = parcelRequire("1xpoY");


var $kGrzq = parcelRequire("kGrzq");

const $ebf4d3ce910d3665$export$6adfe6668ae1a7f8 = (prefix)=>{
    const filteredMarkers = (window.performance?.getEntriesByType?.('mark') || []).filter((marker)=>marker.name.startsWith(prefix));
    filteredMarkers.sort((a, b)=>a.startTime - b.startTime);
    return filteredMarkers;
};
const $ebf4d3ce910d3665$export$a52fc5851be9b858 = (prefix)=>{
    const measures = new (0, $kGrzq.BaseMeasures)();
    for (const { name: name, startTime: startTime } of $ebf4d3ce910d3665$export$6adfe6668ae1a7f8(prefix)){
        const fieldName = name.replace(/\.start|\.end$/, '').replace(prefix, '');
        // Handle multiple pairs of markers due to re-renders
        if (name.endsWith('.start')) measures.markMeasureStart(fieldName, Math.floor(startTime));
        else measures.markMeasureEnd(fieldName, Math.floor(startTime), true);
    }
    const durations = {};
    for (const [name, { duration: duration }] of Object.entries(measures.getMeasures()))durations[name] = duration;
    return durations;
};


function $316168ab5c690743$export$9dbd6bda36500fa9() {
    const entries = (0, $ebf4d3ce910d3665$export$6adfe6668ae1a7f8)('wf/');
    const startTimes = {};
    const timings = {};
    for (const { name: name, startTime: startTime } of entries){
        if (name.endsWith('.start')) {
            const key = name.slice(0, -6);
            startTimes[key] = startTime;
        } else if (name.endsWith('.end')) {
            const key = name.slice(0, -4);
            if (typeof startTimes[key] === 'number') timings[key] = {
                startTime: startTimes[key],
                endTime: startTime
            };
        }
    }
    return timings;
}



var $6VdZc = parcelRequire("6VdZc");


var $8Lf0D = parcelRequire("8Lf0D");

var $jy3Cx = parcelRequire("jy3Cx");


var $5leFG = parcelRequire("5leFG");

const $2ba6133bff070823$export$8c5248f0cec8446d = new (0, $5leFG.EventBus)();


var $80c67148001d6fe8$var$_JSCacheRate;
class $80c67148001d6fe8$export$aca60c726e4e7838 {
    /**
   * Clear Cache
   *
   * Clears all existing cache entries
   */ static clearCache() {
        this.IDs.reset();
        this.Cache.clear();
    }
    /**
   * Compute Cache Rate
   *
   * Iterates the cache looking for the LRU cache compute
   * and creates a new compute based upon the results of
   * it (if it exists). If not, it'll compute cache rate
   * using a bottom-up iteration of loaded assets
   */ static computeCacheRate(time) {
        let lastKey = '';
        const entries = this.Cache.keys;
        const maxIndex = entries.length - 1;
        for(let i = maxIndex; i > -1; i--){
            const key = entries[i];
            const { time: stopTime } = this.Cache.get(key);
            if (time > stopTime) {
                lastKey = key;
                break;
            }
        }
        let newEntry;
        if (lastKey) newEntry = this.mergeFromLastKey(lastKey, time);
        else newEntry = this.iterateResources(time);
        const ID = $80c67148001d6fe8$export$aca60c726e4e7838.IDs.ID();
        $80c67148001d6fe8$export$aca60c726e4e7838.Cache.set(ID, {
            time: time,
            ...newEntry
        });
        return $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(ID);
    }
    /**
   * Merge From Last Key
   *
   * Combines the LRU cache rate with a cache rate being computed
   */ static mergeFromLastKey(key, time) {
        const { lastIndex: lastIndex, criticalPath: criticalPath } = $80c67148001d6fe8$export$aca60c726e4e7838.Cache.get(key);
        const { lastIndex: newIndex, criticalPath: newCriticalPath } = this.iterateResources(time, lastIndex + 1);
        return {
            lastIndex: newIndex,
            criticalPath: this.merge(criticalPath, newCriticalPath)
        };
    }
    /**
   * Iterate Resources
   *
   * Iterates performance resource timings given a time and from (index)
   * filter. While iterating, this method will accumulate the scripts
   * that have loaded prior to the input time and capture the last index
   * of the final script loaded within that scope
   */ static iterateResources(time, from = 0) {
        const criticalPath = this.criticalPath;
        const resources = window.performance.getEntriesByType('resource');
        const { length: length } = resources;
        let lastIndex = from;
        for(let i = lastIndex; i < length; i++){
            const entry = resources[i];
            if (entry.initiatorType !== 'script' || entry.responseEnd > time) continue;
            lastIndex = i;
            if (entry.transferSize) criticalPath.nonCachedSize += entry.encodedBodySize;
            else {
                criticalPath.cachedCount += 1;
                criticalPath.cachedSize += entry.encodedBodySize;
            }
            criticalPath.totalSize += entry.encodedBodySize;
            criticalPath.scripts.push({
                name: entry.name.split('/').pop() || '',
                start: entry.startTime,
                end: entry.responseEnd,
                size: entry.encodedBodySize
            });
        }
        return {
            criticalPath: criticalPath,
            lastIndex: lastIndex
        };
    }
    /**
   * Critical Path
   *
   * Returns an initialized `CriticalPath` object
   */ static get criticalPath() {
        return {
            scripts: [],
            totalSize: 0,
            cachedCount: 0,
            cachedSize: 0,
            nonCachedSize: 0
        };
    }
    /**
   * Merge
   *
   * Merges the properties of two critical path objects
   */ static merge(cachedCP, newCP) {
        return {
            scripts: cachedCP.scripts.concat(newCP.scripts),
            totalSize: cachedCP.totalSize + newCP.totalSize,
            cachedCount: cachedCP.cachedCount + newCP.cachedCount,
            cachedSize: cachedCP.cachedSize + newCP.cachedSize,
            nonCachedSize: cachedCP.nonCachedSize + newCP.nonCachedSize
        };
    }
}
$80c67148001d6fe8$var$_JSCacheRate = $80c67148001d6fe8$export$aca60c726e4e7838;
$80c67148001d6fe8$export$aca60c726e4e7838.IDs = new (0, $8Lf0D.AutoIncrementingID)();
$80c67148001d6fe8$export$aca60c726e4e7838.Cache = new (0, $jy3Cx.Cache)();
$80c67148001d6fe8$export$aca60c726e4e7838.Listener = (0, $2ba6133bff070823$export$8c5248f0cec8446d).on('page-transition', $80c67148001d6fe8$var$_JSCacheRate.clearCache.bind($80c67148001d6fe8$var$_JSCacheRate));


const $798e13e8b010d13b$export$2ae1dd61fa7d6fb4 = (stop)=>{
    const { criticalPath: { scripts: scripts, totalSize: totalSize, cachedCount: cachedCount, cachedSize: cachedSize, nonCachedSize: nonCachedSize } } = (0, $80c67148001d6fe8$export$aca60c726e4e7838).computeCacheRate(stop);
    return {
        cachedRate: cachedCount / scripts.length * 100,
        count: scripts.length,
        size: totalSize,
        cachedSize: cachedSize,
        nonCachedSize: nonCachedSize,
        sizeBasedCachedRate: cachedSize / (cachedSize + nonCachedSize)
    };
};


const $1f8015dad40e09ac$export$4a5a528f9e4c1e63 = ()=>window.jQuery?.fn?.jquery;


const $8476ac2738811490$export$30c543c9fd9ad97 = ({ stop: stop })=>{
    const customAttributes = {
        initial: (0, $6VdZc.isInitial)(),
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        jqVer: (0, $1f8015dad40e09ac$export$4a5a528f9e4c1e63)()
    };
    return customAttributes;
};


var $lqJ5I = parcelRequire("lqJ5I");




const $8b39c089fbdae2d5$export$96934690d8345a62 = (obj)=>{
    if (typeof obj !== 'object' || !obj) return {};
    const recursivelyBuildCustomValues = (obj)=>{
        const customValues = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (Array.isArray(value)) customValues[key] = value.map((e)=>JSON.stringify(e)).join(',');
            else if (typeof value === 'object' && value) {
                const nestedValues = recursivelyBuildCustomValues(value);
                Object.entries(nestedValues).forEach(([nestedKey, nestedValue])=>{
                    customValues[`${key}:${nestedKey}`] = nestedValue;
                });
            } else {
                if (typeof value === 'number') customValues[key] = Math.round(value);
                else if (typeof value === 'boolean') customValues[key] = value;
                else customValues[key] = String(value);
            }
        });
        return customValues;
    };
    return recursivelyBuildCustomValues(obj);
};


const $894ba807f7f34abc$export$3f2fb183b6cd13c4 = ({})=>{
    // Only track frontend calls, skip during SSR
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    if (typeof window === 'undefined') return {
        frontendTotalOperations: 0,
        apiCsrCount: 0,
        fetchCount: 0
    };
    const stats = (0, $lqJ5I.networkTracker).getStats();
    const pageLoadStats = (0, $lqJ5I.networkTracker).getStatsSincePageLoadStart();
    const navigationType = (0, $6VdZc.browserMetricsState).transitionId === 0 ? 'initial' : 'transition';
    const boundaryNames = Object.keys(pageLoadStats.byBoundary ?? {}).sort();
    const boundaryFirstApiMetrics = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        apiByStreamingBoundary: Object.fromEntries(boundaryNames.map((boundaryName)=>[
                boundaryName,
                {
                    csr: {
                        [navigationType]: {
                            count: pageLoadStats.byBoundary[boundaryName]
                        }
                    }
                }
            ]))
    });
    return {
        frontendTotalOperations: stats.totalOperations,
        apiCsrCount: pageLoadStats.totalOperations,
        fetchCount: window.__FETCH_COUNT__ ?? 0,
        ...boundaryFirstApiMetrics
    };
};


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $4c29a57cb1cefaed$var$isAssets = (x)=>{
    if (typeof x !== 'object' || !x) return false;
    for (const value of Object.values(x)){
        if (typeof value !== 'string') return false;
    }
    return true;
};
const $4c29a57cb1cefaed$var$scriptInitiator = {
    script: true,
    other: true,
    link: true
};
const $4c29a57cb1cefaed$var$criticalChunkPrefixes = {
    'query-preloader': true,
    'translations.en-US': true,
    runtime: true,
    atlaskit: true,
    afp: true,
    static: true,
    vendors: true,
    app: true
};
const $4c29a57cb1cefaed$var$getCachedAssets = ()=>{
    try {
        const assets = JSON.parse((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).CACHED_ASSETS)) || {};
        if (!$4c29a57cb1cefaed$var$isAssets(assets)) return {};
        return assets;
    } catch  {
        return {};
    }
};
const $4c29a57cb1cefaed$var$updateCachedAssets = (assets)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).CACHED_ASSETS, JSON.stringify(assets));
    } catch  {
    // NOOP
    }
};
const $4c29a57cb1cefaed$export$445ccb86da5ca9ca = (endTime)=>{
    const cachedChunks = $4c29a57cb1cefaed$var$getCachedAssets();
    const loadedChunks = {};
    const criticalChunks = {};
    let totalChunkCount = 0;
    performance.getEntriesByType('resource').forEach((entry)=>{
        const { initiatorType: initiatorType, responseEnd: responseEnd, duration: duration, name: name } = entry;
        // Discard non-scripts and scripts that were loaded after the end time
        if (!$4c29a57cb1cefaed$var$scriptInitiator[initiatorType] || responseEnd > endTime) return;
        const chunkName = name.split('/').pop();
        if (!chunkName) return;
        const chunkPrefix = chunkName.split('~').shift();
        if (!chunkPrefix) return;
        // Match loaded chunk name with cached chunk name for all critical chunks
        if ($4c29a57cb1cefaed$var$criticalChunkPrefixes[chunkPrefix]) {
            loadedChunks[chunkPrefix] = chunkName;
            criticalChunks[chunkPrefix] = {
                cached: cachedChunks[chunkPrefix] === chunkName,
                duration: duration
            };
        }
        totalChunkCount++;
    });
    $4c29a57cb1cefaed$var$updateCachedAssets(loadedChunks);
    return {
        criticalChunks: criticalChunks,
        totalChunkCount: totalChunkCount
    };
};

















const $ac2afaf945b706af$var$getElementSelector = (element)=>{
    if (!element || !element.tagName) return 'n/a';
    const selector = `${element.tagName.toLowerCase()}.${element.className?.split(' ').join('.')}`;
    if (element.dataset?.testid) return `${selector}[data-testid="${element.dataset?.testid}"]`;
    return selector;
};
const $ac2afaf945b706af$export$2980a1865b8e55dd = (hydrationErrors)=>{
    let loggingConfig = {};
    try {
        loggingConfig = JSON.parse((0, $1xpoY.default).getString('confluence_hydration_error_logging', '{}'));
    } catch  {
    // no-op, if an error occurs here, there's really nowhere to submit it
    }
    return hydrationErrors.reduce((accumulator, error)=>{
        if (!error.type || !error.msg) return accumulator;
        // Log selectors for mismatched hydration errors. The presense of parentNode or parent
        // depend on actual hydration error / patch used.
        const finalParent = error.parent || error.parentNode;
        if (loggingConfig.selectors && (finalParent || error.child)) {
            if (!accumulator.selectors) accumulator.selectors = '';
            const parent = finalParent ? $ac2afaf945b706af$var$getElementSelector(finalParent) : 'n/a';
            const child = error.child ? $ac2afaf945b706af$var$getElementSelector(error.child) : 'n/a';
            accumulator.selectors += `${parent}->${child}; `;
        }
        // For UNSAFE_TEXT_MISMATCH errors, only track the count
        // Don't log the actual text content as it contains sensitive data
        // Similarly, UNSAFE_CLIENT_MISMATCH and UNSAFE_SERVER_MISMATCH contain user content in text nodes
        if (loggingConfig.errors) {
            if (error.type === 'UNSAFE_TEXT_MISMATCH') accumulator.unsafeTextMismatches = (accumulator.unsafeTextMismatches || 0) + 1;
            else if (error.type === 'UNSAFE_CLIENT_MISMATCH') accumulator.unsafeClientMismatches = (accumulator.unsafeClientMismatches || 0) + 1;
            else if (error.type === 'UNSAFE_SERVER_MISMATCH') accumulator.unsafeServerMismatches = (accumulator.unsafeServerMismatches || 0) + 1;
            else {
                if (!accumulator[error.type]) accumulator[error.type] = '';
                accumulator[error.type] += (accumulator[error.type] ? ' ; ' : '') + error.msg;
            }
        }
        // Add error stack
        if (loggingConfig.stack && error.stack) {
            if (!accumulator.stack) accumulator.stack = '';
            accumulator.stack += `Stack: ${error.stack} \n`;
        }
        return accumulator;
    }, {});
};

const $58d4f470662e1918$export$494b6359b6a45bfd = ()=>{
    const heightChanges = window?.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__;
    const result = {
        initialHeight: window?.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0,
        changes: heightChanges?.length || 0
    };
    if (heightChanges?.length) result.finalHeight = heightChanges[heightChanges.length - 1];
    return result;
};


var $lXQLs = parcelRequire("lXQLs");
/**
 * Normalizes a hydration error type by stripping the "UNSAFE_" prefix.
 *
 * Returns null if the error has no type.
 */ const $ca8fa84470cae806$var$normalizeHydrationErrorType = (error)=>{
    if (!error.type) return null;
    return error.type.startsWith('UNSAFE_') ? error.type.slice(7) : error.type;
};
const $ca8fa84470cae806$export$92d14dc1fbc3f3a3 = (hydrationErrors)=>{
    const counts = {};
    for (const error of hydrationErrors){
        const normalizedType = $ca8fa84470cae806$var$normalizeHydrationErrorType(error);
        if (normalizedType) counts[normalizedType] = (counts[normalizedType] || 0) + 1;
    }
    return counts;
};

const $32c078c7f61fe0e3$export$d966f1e92068ec2e = (stats)=>{
    if (!stats) return {
        totalLinks: 0,
        totalResolved: 0
    };
    const { links: links } = stats;
    let totalLinks = 0;
    let totalResolved = 0;
    Object.values(links).forEach((byAppearance)=>{
        Object.values(byAppearance).forEach(({ total: total, resolved: resolved })=>{
            totalLinks += total;
            totalResolved += resolved;
        });
    });
    return {
        totalLinks: totalLinks,
        totalResolved: totalResolved
    };
};



var $8wW9d = parcelRequire("8wW9d");


var $5w0J2 = parcelRequire("5w0J2");


function $31b0fb0fb1951a4c$var$limitTop10(obj) {
    return Object.fromEntries(Object.entries(obj).sort((a, b)=>b[1] - a[1]).slice(0, 10));
}
const $31b0fb0fb1951a4c$var$sanitizeSsrMeasureName = (value)=>value.replace(/[^\-.\w]/g, '_');
const $31b0fb0fb1951a4c$var$emptySSRDataFetcherStats = ()=>({
        boundaries: [],
        fetchCounts: {}
    });
const $31b0fb0fb1951a4c$var$getSSRDataFetcherStats = (ssrMeasures)=>{
    if (!ssrMeasures) return $31b0fb0fb1951a4c$var$emptySSRDataFetcherStats();
    const stats = $31b0fb0fb1951a4c$var$emptySSRDataFetcherStats();
    const boundaryNames = new Set();
    Object.keys(ssrMeasures).forEach((measureKey)=>{
        const dataFetcherMatch = measureKey.match(/(?:^|\/)dataFetcher:([^/]+)/);
        if (!dataFetcherMatch) return;
        const boundaryName = $31b0fb0fb1951a4c$var$sanitizeSsrMeasureName(dataFetcherMatch[1]);
        const measureLeaf = measureKey.substring(measureKey.lastIndexOf('/') + 1);
        if (measureLeaf?.startsWith('fetch:')) {
            boundaryNames.add(boundaryName);
            stats.fetchCounts[boundaryName] = (stats.fetchCounts[boundaryName] ?? 0) + 1;
        }
    });
    stats.boundaries = Array.from(boundaryNames).sort();
    return stats;
};
const $31b0fb0fb1951a4c$var$getSSRBoundaryFirstApiMetrics = (ssrDataFetcherStats, navigationType)=>(0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        apiByStreamingBoundary: Object.fromEntries(ssrDataFetcherStats.boundaries.map((boundaryName)=>[
                boundaryName,
                {
                    ssr: {
                        [navigationType]: {
                            count: ssrDataFetcherStats.fetchCounts[boundaryName] ?? 0
                        }
                    }
                }
            ]))
    });
const $31b0fb0fb1951a4c$export$7908ff149a3cbadd = ({ stop: stop })=>{
    const isInitialPageLoad = (0, $6VdZc.browserMetricsState).transitionId === 0;
    const isSsrRendered = isInitialPageLoad && Boolean(window.__SSR_RENDERED__);
    const customAttributes = {
        transitionId: (0, $6VdZc.browserMetricsState).transitionId,
        // HTTP protocol used to fetch resources
        // Use multiple domains for http/1.1 users
        // Set in packages/confluence-frontend-server/templates/generator.js
        domainSharding: Boolean(window.__GET_CC_ASSET_URL),
        // HTTP protocol used to fetch resources
        httpProtocol: (0, $lXQLs.getHTTPProtocol)(performance.getEntriesByType('resource')),
        // Add the critical path JS assets size stats
        criticalAssets: (0, $798e13e8b010d13b$export$2ae1dd61fa7d6fb4)(stop),
        // Send stats on expensive queries and unnecessary watches
        apolloDiffStoreStats: (0, $8b39c089fbdae2d5$export$96934690d8345a62)($31b0fb0fb1951a4c$var$limitTop10(window?.__APOLLO_STATS__?.diffStore || {})),
        // Content + non-content 3P app keys for this navigation.
        //
        // Emitted for BOTH initial page loads and SPA transitions, unlike the
        // legacy `connectAppKeys` below which is initial-load only. Experiences
        // that are almost always reached via a transition (`edit-page`,
        // `live-edit`, `confluence-home`) therefore only ever report app keys
        // through this attribute.
        //
        // `connectAppKeys` is intentionally left as-is so existing dashboards
        // keep their current semantics; on an initial page load the two
        // attributes hold identical values.
        ...(0, $6mKj3.expVal)('confluence_app_keys_transition', 'isEnabled', false) ? {
            appKeys: (0, $5w0J2.getAppKeys)()
        } : {}
    };
    const navigationType = isInitialPageLoad ? 'initial' : 'transition';
    const ssrDataFetcherStats = isInitialPageLoad ? $31b0fb0fb1951a4c$var$getSSRDataFetcherStats(window.__SSR_MEASURES__) : $31b0fb0fb1951a4c$var$emptySSRDataFetcherStats();
    Object.assign(customAttributes, {
        navigationType: navigationType,
        renderMode: isSsrRendered ? 'ssr' : 'csr',
        apiSsrCount: isInitialPageLoad ? window.__SSR_OPERATIONS_COUNT__ ?? 0 : 0,
        ...$31b0fb0fb1951a4c$var$getSSRBoundaryFirstApiMetrics(ssrDataFetcherStats, navigationType)
    });
    Object.entries((0, $ebf4d3ce910d3665$export$a52fc5851be9b858)('CFP-63.')).forEach(([fieldName, value])=>{
        customAttributes[`cfp63Durations:${fieldName}`] = value;
    });
    if (isInitialPageLoad) {
        const navigationTimings = window.performance.getEntriesByType('navigation');
        if (navigationTimings.length) {
            // TypeScript isn't returning the proper type for this, so some
            // casting here
            const firstTiming = navigationTimings[0];
            if (firstTiming.transferSize != null) customAttributes.pageLoadedFromCache = firstTiming.transferSize === 0;
        }
        // Record the current version of jQuery
        customAttributes.jqVer = window.jQuery?.fn?.jquery;
        // Record if page is rendered by React SSR service
        customAttributes.ssr = isSsrRendered;
        // Some SSR render errors (e.g.: edit page content area failed to SSR) are considered critical even when window.__SSR_RENDERED__ is true
        customAttributes.ssrHasCriticalError = Boolean(window.__SSR_HAS_CRITICAL_ERROR__);
        customAttributes.ssrTraceId = window.__SSR_TRACE_ID__ ?? '';
        // only send ssr macro metrics if there is at least one macro on the SSRd page
        if (window?.__SSR_MACROS_INFO__) customAttributes.ssrMacrosInfo = window.__SSR_MACROS_INFO__;
        if (window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__) customAttributes.macrosPreloadFails = window?.__SSR_MACRO_PRELOAD_TOPX_FAILS__;
        // Record user clicks and intent to click on SSR placeholder elements
        customAttributes.ssrInteractions = window?.__SSR_INTERACTIONS__ || {};
        // @ts-ignore `__SSR_INTERACTIONS_DURATIONS__` maintains an array of numbers, but browser-metrics doesn't really accept arrays. Might make sense to comma-join the values
        customAttributes.ssrInteractionsDurations = window?.__SSR_INTERACTIONS_DURATIONS__ || {};
        customAttributes.ssrQueryTimeouts = window?.__SSR_QUERY_TIMEOUTS__ || {};
        customAttributes.ssrPartialSuccess = window?.__SSR_PARTIAL_SUCCESS__ || {};
        if (window?.__SSR_STREAM_END__) customAttributes.ssrStreamEnd = window.__SSR_STREAM_END__;
        customAttributes.reactStreaming = window.__SSR_REACT_STREAMING__ || false;
        // Record loadable ids that timed out
        customAttributes.loadableTimeouts = Array.from(new Set(window?.__LOADABLE_TIMEOUTS__ || [])).join(',');
        if (window?.__HYDRATION_ERRORS__) {
            customAttributes.hydrationErrors = (0, $ac2afaf945b706af$export$2980a1865b8e55dd)(window.__HYDRATION_ERRORS__);
            if ((0, $1xpoY.default).getBoolean('confluence_hydration_error_type_logging', false)) customAttributes.hydrationErrorCounts = (0, $ca8fa84470cae806$export$92d14dc1fbc3f3a3)(window.__HYDRATION_ERRORS__);
            if (window.__HYDRATION_ERRORS__.length > 0) (0, $5ZqQS.getMonitoringClient)().incrementCounter('hydrationErrorSessions');
        }
        customAttributes.hydratable = window?.__HYDRATABLE__ || false;
        customAttributes.hydrationFailed = window?.__HYDRATION_FAILED__ || false;
        // Record the number of SSRed elements
        customAttributes.totalSSRedElements = window?.__TOTAL_SSR_ELEMENTS__ || 0;
        if (window?.__SSR_SMARTLINKS_STATS__) customAttributes.ssrSmartLinksStats = (0, $32c078c7f61fe0e3$export$d966f1e92068ec2e)(window.__SSR_SMARTLINKS_STATS__);
        if (window?.__SSR_SHORTCUTS_STATS__) customAttributes.ssrShortcutsStats = window.__SSR_SHORTCUTS_STATS__;
        // Calculates which query is the long pole, as well as its duration
        customAttributes.longPoleQuery = window?.__SSR_LONG_POLE_QUERY__ || {};
        // Node counts from AK renderer, available in fabric only
        customAttributes.rendererNodesCount = window?.__RENDERER_NODES_COUNT__ || {};
        const initialLightNodeMetrics = window.__LIGHT_RENDERER_INITIAL_NODE_METRICS__;
        if (initialLightNodeMetrics) {
            const remaining = initialLightNodeMetrics.getRemainingLightNodes?.(stop);
            if (remaining) {
                customAttributes.lightRemainingCount = remaining.count;
                customAttributes.lightRemainingPct = remaining.percent;
                customAttributes.lightOffscreenUpgradeCount = remaining.offscreenUpgraded;
            }
            customAttributes.lightInitialCount = initialLightNodeMetrics.count;
            customAttributes.lightInitialPct = initialLightNodeMetrics.percent;
            if (initialLightNodeMetrics.fullNodeCountsByReason) Object.assign(customAttributes, (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
                fullInitialCount: initialLightNodeMetrics.fullNodeCountsByReason
            }));
            if (initialLightNodeMetrics.fullBatchTargetPx !== undefined) customAttributes.fullBatchTargetPx = initialLightNodeMetrics.fullBatchTargetPx;
            if (initialLightNodeMetrics.fullBatchTargetViewportRatio !== undefined) customAttributes.fullBatchViewportRatio = initialLightNodeMetrics.fullBatchTargetViewportRatio;
        }
        customAttributes.remoteLocalStorage = window?.__REMOTE_LOCAL_STORAGE__?.length || 0;
        customAttributes.wrmKeys = window?.__WRM_KEYS__ || {};
        // Combine content connect app keys (from LegacyMacroRendererComponent) with
        // non-content 3P app keys (byline/page banner/context menu/web panels/etc.)
        // so both land in the same `connectAppKeys` extra_property. Deduped via a Set.
        customAttributes.connectAppKeys = [
            ...new Set([
                ...window?.__APP_KEYS__ || [],
                ...(0, $8wW9d.getNonContentAppKeys)()
            ])
        ].join(',');
        customAttributes.atlGeneralHeightChanges = (0, $8b39c089fbdae2d5$export$96934690d8345a62)((0, $58d4f470662e1918$export$494b6359b6a45bfd)());
        // Add the caching status of each asset
        const cacheStatus = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cacheStatus: (0, $4c29a57cb1cefaed$export$445ccb86da5ca9ca)(stop)
        });
        for (const [key, value] of Object.entries(cacheStatus))customAttributes[key] = value;
    }
    return customAttributes;
};

const $47229cc534a9628f$export$79c58f8fef22ebf2 = ()=>{
    const customAttributes = {
        ssrRegion: window.__SSR_REGION__ ?? ''
    };
    return customAttributes;
};



var $eSuZj = parcelRequire("eSuZj");


var $lW5tg = parcelRequire("lW5tg");


var $7W9kD = parcelRequire("7W9kD");




const $95bc5307c5397a75$var$countKeys = [
    'version',
    'eligible',
    'matched',
    'mismatched',
    'missingTitle',
    'failed',
    'layoutMeasured',
    'layoutUnavailable',
    'rowIncreased',
    'rowDecreased'
];
function $95bc5307c5397a75$export$8a1fcc0fa89557ab(interaction) {
    const counts = interaction.metaData?.bylineTitleDiagnostics;
    if (interaction.type !== 'page_load' || ![
        'view_page',
        'view-page',
        'live-edit'
    ].includes(interaction.ufoName) || !counts || typeof counts !== 'object') return {};
    try {
        const config = JSON.parse((0, $1xpoY.default).getString('confluence_cls_attribution_config', '{}'));
        const experienceName = interaction.ufoName === 'view_page' ? 'view-page' : interaction.ufoName;
        const included = experienceName === 'view-page' ? config.includeEntries?.['view-page'] ?? config.includeEntries?.view_page : config.includeEntries?.[experienceName];
        if (config.bylineTitleDiagnostics !== true || included !== true || config.loadType !== undefined && ![
            'initial',
            'both'
        ].includes(config.loadType)) return {};
        // Emit only the fixed numeric schema, even if unrelated metadata is attached accidentally.
        const values = counts;
        if (values.version !== 1 || !$95bc5307c5397a75$var$countKeys.every((key)=>Number.isSafeInteger(values[key]) && Number(values[key]) >= 0)) return {};
        return {
            bylineTitleDiagnostics: Object.fromEntries($95bc5307c5397a75$var$countKeys.map((key)=>[
                    key,
                    Number(values[key])
                ]))
        };
    } catch  {
        return {};
    }
}


/**
 * collectPerfProbe — client performance diagnostic covariates for UFO payloads.
 *
 * Purpose: existing metrics (TBT, page-load timings) tell us the main thread was
 * blocked or the load was slow, but not *why*. This module emits a small set of
 * explanatory covariates so the "slow client" bucket can be decomposed into:
 *   (a) slow per-core CPU                → `perfProbe:cpuMs`
 *   (b) GPU / software-rendering fallback → `perfProbe:softwareGL`
 *   (c) HTML buffered upstream (e.g. AV)  → `perfProbe:earlyHtmlToScriptMs`
 *
 * Signals split into two kinds:
 *   - The CPU benchmark (cpuMs): the only expensive signal, so it is measured off
 *     the critical path in idle time and persisted via the Confluence storage
 *     manager (local only) along with the epoch ms it was taken (`perfProbe:t`), so
 *     the initial-load payload can carry the previous load's sample without ever
 *     blocking the current load.
 *   - Cheap per-load reads (softwareGL, earlyHtmlToScriptMs): computed inline when
 *     the payload is generated — never persisted — since a canvas/WebGL probe and a
 *     Performance Timeline read are both trivial.
 *
 * Performance-safety contract: this module must never affect the page it measures.
 * The CPU benchmark only ever runs inside requestIdleCallback — with no timer
 * fallback, so it is simply skipped where that API is unavailable — one small sample
 * per idle slot; every entry point is wrapped so any failure yields an empty object.
 */ 
var $7W8i8 = parcelRequire("7W8i8");







const $dc78d25e9ffa5ac9$var$logger = (0, $7W8i8.getLogger)('collectPerfProbe');
const $dc78d25e9ffa5ac9$var$SCHEMA_VERSION = 1;
// Number of timed runs of the fixed workload; we report the min (contention
// stripped out). Runs one-per-idle-slot so we always yield between samples.
const $dc78d25e9ffa5ac9$var$SAMPLE_COUNT = 5;
// Fixed iteration count. Chosen so a single sample takes a few ms — comfortably
// above performance.now() resolution (which browsers clamp for privacy) yet small
// enough to fit inside a single idle slot. Never adaptive.
const $dc78d25e9ffa5ac9$var$ITERATIONS = 2000000;
const $dc78d25e9ffa5ac9$var$IDLE_TIMEOUT_MS = 60000;
// The CPU benchmark is refreshed at most once every 3 days. The persisted sample is
// kept (never consumed) so every load in between reports the last value; a fresh
// benchmark only runs once the stored sample is at least this old.
const $dc78d25e9ffa5ac9$var$REFRESH_INTERVAL_MS = 259200000;
// Renderer substrings that indicate hardware acceleration is off and WebGL is
// running on a software rasteriser.
const $dc78d25e9ffa5ac9$var$SOFTWARE_RENDERER_HINTS = [
    'swiftshader',
    'llvmpipe',
    'basic render driver',
    'software'
];
const $dc78d25e9ffa5ac9$var$round2 = (n)=>Math.round(n * 100) / 100;
let $dc78d25e9ffa5ac9$var$refreshRunning = false;
let $dc78d25e9ffa5ac9$var$pendingSamples = [];
function $dc78d25e9ffa5ac9$export$7e2d586540f6b439() {
    const payload = {};
    try {
        const stored = $dc78d25e9ffa5ac9$var$readStored();
        if (stored) {
            payload['perfProbe:cpuMs'] = stored.cpuMs;
            payload['perfProbe:t'] = stored.t;
        }
        // Refresh the CPU sample off the critical path, but no more than once every 3
        // days: run only when there is no sample yet or the stored one has aged past
        // the interval. The persisted entry is never cleared here.
        if (!stored || Date.now() - stored.t >= $dc78d25e9ffa5ac9$var$REFRESH_INTERVAL_MS) $dc78d25e9ffa5ac9$var$scheduleRefresh();
    } catch  {
    // never let the CPU covariate affect the payload
    }
    try {
        // Cheap to compute, so read it live rather than persisting it.
        if (typeof document !== 'undefined') payload['perfProbe:softwareGL'] = $dc78d25e9ffa5ac9$var$detectSoftwareGL();
    } catch  {
    // GL probe is best-effort
    }
    try {
        payload['perfProbe:earlyHtmlToScriptMs'] = $dc78d25e9ffa5ac9$var$getEarlyHtmlToScriptMs();
    } catch  {
    // per-load timing is best-effort
    }
    return payload;
}
// --- (a) CPU benchmark: idle sampling + persistence ---------------------------
function $dc78d25e9ffa5ac9$var$scheduleRefresh() {
    if ($dc78d25e9ffa5ac9$var$refreshRunning) return;
    $dc78d25e9ffa5ac9$var$refreshRunning = true;
    $dc78d25e9ffa5ac9$var$pendingSamples = [];
    $dc78d25e9ffa5ac9$var$scheduleNextSample();
}
function $dc78d25e9ffa5ac9$var$scheduleNextSample() {
    $dc78d25e9ffa5ac9$var$requestIdle(()=>{
        if ($dc78d25e9ffa5ac9$var$pendingSamples.length === 0) $dc78d25e9ffa5ac9$var$logger.info`collectPerfProbe: running CPU benchmark — ${$dc78d25e9ffa5ac9$var$SAMPLE_COUNT} samples of ${$dc78d25e9ffa5ac9$var$ITERATIONS} iterations`;
        let sample;
        try {
            sample = $dc78d25e9ffa5ac9$var$runCpuSample();
        } catch  {
            // abandon this cycle; leave any previously stored sample untouched
            $dc78d25e9ffa5ac9$var$refreshRunning = false;
            return;
        }
        $dc78d25e9ffa5ac9$var$pendingSamples.push(sample);
        if ($dc78d25e9ffa5ac9$var$pendingSamples.length < $dc78d25e9ffa5ac9$var$SAMPLE_COUNT) {
            $dc78d25e9ffa5ac9$var$scheduleNextSample();
            return;
        }
        try {
            $dc78d25e9ffa5ac9$var$writeStored({
                v: $dc78d25e9ffa5ac9$var$SCHEMA_VERSION,
                cpuMs: $dc78d25e9ffa5ac9$var$round2(Math.min(...$dc78d25e9ffa5ac9$var$pendingSamples)),
                t: Date.now()
            });
        } catch  {
        // persistence failure is non-fatal
        } finally{
            $dc78d25e9ffa5ac9$var$refreshRunning = false;
        }
    });
}
function $dc78d25e9ffa5ac9$var$runCpuSample() {
    let checksum = 0;
    const start = performance.now();
    for(let i = 0; i < $dc78d25e9ffa5ac9$var$ITERATIONS; i++)// Unsigned 32-bit wrap keeps the checksum a small int and is intrinsic to the
    // fixed workload we're timing; the bitwise op is deliberate here.
    // eslint-disable-next-line no-bitwise
    checksum = checksum * 31 + i >>> 0;
    const elapsed = performance.now() - start;
    globalThis.__ccPerfProbeChecksum = checksum;
    return elapsed;
}
// --- (b) software-rendering probe: cheap inline canvas/WebGL read -------------
function $dc78d25e9ffa5ac9$var$detectSoftwareGL() {
    // Guard browser globals for SSR; callers already gate on `document`, but the
    // access is kept lexically inside the positive guard.
    if (typeof document !== 'undefined') {
        const canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        const gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
        if (!gl) // No hardware-accelerated WebGL path available at all.
        return true;
        let renderer = '';
        const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) renderer = String(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || '');
        // Release the context promptly rather than waiting for GC.
        gl.getExtension('WEBGL_lose_context')?.loseContext();
        const normalized = renderer.toLowerCase();
        // If the renderer string is unavailable (some browsers restrict it) we
        // cannot tell — default to false so we never produce a false (b) positive.
        return $dc78d25e9ffa5ac9$var$SOFTWARE_RENDERER_HINTS.some((hint)=>normalized.includes(hint));
    }
    return false;
}
// --- (c) per-load early-HTML delivery signal: passive timeline read -----------
/**
 * How long after the first HTML byte arrived could the browser first fetch JS?
 *
 *   earlyHtmlToScriptMs = max(0, earliestScript.startTime - navigation.responseStart)
 *
 * The preload scanner initiates a <script> fetch the instant it parses the tag out
 * of the arriving markup, so the earliest script's startTime marks when the early
 * HTML first became actionable — independent of whether that script then resolves
 * from cache or the network.
 *
 * small  → the <head> streamed in right behind the first byte and JS started almost
 *          immediately (healthy streaming).
 * large  → the script-bearing early markup only landed well after the first byte,
 *          i.e. the document was buffered/drip-fed upstream (AV/content-inspection
 *          proxy is the leading suspect on managed fleets) — the "early part of the
 *          HTML reaching the customer late" symptom.
 * 'unknown' → the timeline could not be read (no Performance API, no navigation
 *          entry, no responseStart, or no script resource to anchor on).
 *
 * Anchored on the earliest-started script — the best case. Cache hits are included:
 * a cache hit still means the browser discovered and acted on the tag, and its
 * startTime is the cleanest discovery timestamp (no network download confounding
 * it). A negative delta — a script discovered before responseStart, e.g. via an
 * HTTP 103 Early Hints preload — is floored to 0; that is ultra-healthy delivery,
 * not a defect.
 */ function $dc78d25e9ffa5ac9$var$getEarlyHtmlToScriptMs() {
    if (typeof performance === 'undefined' || typeof performance.getEntriesByType !== 'function') return 'unknown';
    const nav = performance.getEntriesByType('navigation')[0];
    if (!nav || !nav.responseStart) return 'unknown';
    const scripts = performance.getEntriesByType('resource').filter((entry)=>entry.initiatorType === 'script' && entry.startTime > 0);
    if (scripts.length === 0) return 'unknown';
    const earliest = scripts.reduce((a, b)=>a.startTime <= b.startTime ? a : b);
    return Math.round(Math.max(0, earliest.startTime - nav.responseStart));
}
// --- persistence via the sanctioned Confluence storage manager ----------------
// Local-only key (not in PERSISTED_KEYS_ON_SERVER), so nothing syncs to the
// server. The instance is a module singleton initialised at app boot; it may be
// undefined very early, and its own methods no-op during SSR.
function $dc78d25e9ffa5ac9$var$readStored() {
    try {
        const raw = (0, $17wUi.confluenceLocalStorageInstance)?.getItem((0, $1UApO.keys).PERF_PROBE_DIAGNOSTIC);
        if (!raw) return undefined;
        const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
        if (parsed && parsed.v === $dc78d25e9ffa5ac9$var$SCHEMA_VERSION && typeof parsed.cpuMs === 'number' && typeof parsed.t === 'number') return {
            v: parsed.v,
            cpuMs: parsed.cpuMs,
            t: parsed.t
        };
        return undefined;
    } catch  {
        return undefined;
    }
}
function $dc78d25e9ffa5ac9$var$writeStored(value) {
    try {
        (0, $17wUi.confluenceLocalStorageInstance)?.setItem((0, $1UApO.keys).PERF_PROBE_DIAGNOSTIC, JSON.stringify(value));
    } catch  {
    // quota / disabled storage — non-fatal
    }
}
function $dc78d25e9ffa5ac9$var$requestIdle(callback) {
    // In Confluence bundles `window` is replaced at build time and always exists, so a
    // `typeof window` check is not a valid SSR guard — probe the specific API instead
    // (Confluence SSR rule §2). Only run the benchmark when requestIdleCallback is
    // available: we never want to schedule the compute workload on a timer that could
    // fire while the main thread is busy. No fallback — if it's unavailable, the sample
    // is simply skipped.
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback, {
        timeout: $dc78d25e9ffa5ac9$var$IDLE_TIMEOUT_MS
    });
}


const $65f6d9e9d3e9996f$export$3def7672244bab0c = ()=>{
    const ssrTTRMark = performance?.getEntriesByName('CFP-63.ssr-ttr');
    if (!ssrTTRMark || !ssrTTRMark[0]) return undefined;
    // rounded to the nearest integer as the VC component log only uses integers as keys
    return Math.round(ssrTTRMark[0].startTime);
};
const $65f6d9e9d3e9996f$export$bf7408e83532dcd0 = ()=>{
    if (!window.__SSR_MEASURES__) return [];
    const ssrTimings = Object.keys(window.__SSR_MEASURES__).map((key)=>{
        return {
            label: key,
            data: window.__SSR_MEASURES__[key]
        };
    });
    return ssrTimings || [];
};


const $535b2ac93dbeac9a$export$4ace2d93f0a81ca0 = ()=>typeof window === 'undefined' ? 'na' : window.__SSR_STICKY_VERSION_STATE__ ?? 'na';


const $18160efac3c2d8a9$export$8f5840779a8ebb97 = (interaction, otherMetadataFromSessionData)=>{
    let fmpPatch = {};
    if (interaction.type === 'page_load') {
        Object.entries((0, $316168ab5c690743$export$9dbd6bda36500fa9)()).forEach(([key, value])=>{
            interaction.customTimings.push({
                labelStack: [],
                data: {
                    [key]: value
                }
            });
        });
        // In UFO realm, there's seemingly a bug causing `metric:fmp` to be populated in ~10-15%
        // of cases probably due to some race condition. Adding it here as a fallback until
        // investigation with #help-devinfra-fe-observability is completed.
        // Covered by ticket https://product-fabric.atlassian.net/browse/CCP-7117
        const fmpTime = (0, $65f6d9e9d3e9996f$export$3def7672244bab0c)();
        if (fmpTime) fmpPatch = {
            'metric:fmp': fmpTime
        };
    } else if (interaction.type === 'transition') {
        // For transitions, FMP is tracked via the UFOTransitionMarkFMP component which places
        // an 'fmp' custom mark on the interaction. We read the mark time and compute the
        // relative FMP as the offset from interaction start.
        const fmpMark = interaction.marks.find((mark)=>mark.type === 'custom' && mark.name === 'fmp');
        if (fmpMark) fmpPatch = {
            'metric:fmp': Math.round(fmpMark.time - interaction.start)
        };
    }
    const buildInfoData = (0, $eSuZj.getBuildInfo)();
    const buildInfo = {};
    if (buildInfoData) Object.keys(buildInfoData).forEach((item)=>{
        const newKey = `buildInfo:${item}`;
        buildInfo[newKey] = buildInfoData[item];
    });
    const data = {
        ...(0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $8476ac2738811490$export$30c543c9fd9ad97)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $894ba807f7f34abc$export$3f2fb183b6cd13c4)({
            stop: interaction.end,
            start: interaction.start,
            key: interaction.ufoName
        }),
        ...(0, $47229cc534a9628f$export$79c58f8fef22ebf2)(),
        ...buildInfo,
        ...otherMetadataFromSessionData,
        ...(0, $95bc5307c5397a75$export$8a1fcc0fa89557ab)(interaction),
        'stickyVersions:state': (0, $535b2ac93dbeac9a$export$4ace2d93f0a81ca0)(),
        postOfficeAssetsDisplayed: window.__PO_ASSET_DISPLAYED__,
        ...(0, $lW5tg.getContentMacroDimensions)(interaction.type),
        ...interaction.type === 'page_load' || interaction.type === 'transition' ? (0, $7W9kD.getExtensionDimensions)() : {},
        // Client performance diagnostic covariates (cpuMs, softwareGL,
        // scriptStartAfterHtml). Initial load only — the signals explain
        // device/environment causes of a slow first load, not transitions.
        ...interaction.type === 'page_load' ? (0, $dc78d25e9ffa5ac9$export$7e2d586540f6b439)() : {}
    };
    return {
        ...fmpPatch,
        confluence: data
    };
};




var $7A3xy = parcelRequire("7A3xy");




function $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) {
    return !!traceId && /^[a-z0-9]+$/i.test(traceId) && traceId.length >= 16;
}
function $9d8d828ea9fa0be5$export$47cd5ebc723ead8d() {
    const traceId = window.__SSR_TRACE_ID__;
    const traceSampled = window.__SSR_TRACE_SAMPLED__;
    // Only enable trace propagation if the trace is sampled unless the gate disables this check.
    // Keep per-request unique traceIds for prod traffic until we have the x-request-id solution.
    // See: https://hello.atlassian.net/wiki/spaces/~71202065d425fcbfb345c9a5639940cc3845bb/pages/4187050054/Trace+Propagation+Across+an+Experience
    if (!traceSampled) {
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (!(0, $9wGTI.fg)('confluence_disable_ufo_trace_sampling_check')) return;
    }
    const validTraceId = $9d8d828ea9fa0be5$export$29dd34cf1269f6da(traceId) ? traceId : undefined;
    const validSpanId = validTraceId ? validTraceId.substring(validTraceId.length - 16) : undefined;
    // If the traceId is invalid, we ignore it and don't set the trace context.
    // This would fallback to default behavior where trace context is not propagated.
    if (validTraceId && validSpanId) (0, $7A3xy.setActiveTrace)(validTraceId, validSpanId, '' /* trace type param is unused */ );
}


const $7d85b53d694de3c0$export$5fc9317dcf7889c3 = {
    sanitiseEndpoints: (url)=>url,
    mapResources: (url)=>url,
    hasTimingHeaders: (url)=>url.includes('graphql')
};


const $30ba73f8286a8f5a$export$69f5225124bf14a6 = {
    typingMethod: 'timeout',
    kind: {
        hover: 0,
        legacy: 0,
        typing: 0,
        press: 1,
        page_load: 1,
        transition: 1,
        generic: 0
    },
    rates: {
        unknown: 1000
    },
    removeInteractionsUFOPrefixes: true,
    enableEditorLnvHandler: true,
    autoGeneratedRate: 1000,
    rules: [],
    awaitBM3TTI: [],
    ufoNameOverrides: {},
    killswitch: [],
    segmentPrefix: 'ufo-',
    enabled: true,
    doNotAbortActivePressInteraction: [],
    doNotAbortActivePressInteractionOnTransition: [],
    enableCompleteUsingDoubleRAF: true,
    capability: {
        feature_flag_access: 1,
        react_profiler: 1
    },
    namePrefix: 'ufo-',
    removePageSegmentsUFOPrefixes: false
};
const $30ba73f8286a8f5a$var$getConfig = (configName)=>{
    try {
        return JSON.parse((0, $1xpoY.default).getString(configName, ''));
    } catch  {
        // TODO: AFO-4167: Change the fallback to be `{}` once we have a stable config for FedRamp environment
        return $30ba73f8286a8f5a$export$69f5225124bf14a6;
    }
};
function $30ba73f8286a8f5a$var$runConfigureSsrTiming() {
    (0, $e1XeN.configure)({
        getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
        // from confluence/next/packages/browser-metrics/src/initializeBrowserMetrics.ts
        // TODO: add correct functions to `getTimings` and `getFeatureFlags`
        getTimings: ()=>null,
        getFeatureFlags: ()=>null
    });
}
function $30ba73f8286a8f5a$export$6381c51f97ce9880({ shard: shard, cloudId: cloudId }) {
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    const config = (0, $9wGTI.fg)('ufo-use-statsig-config-confluence-new') ? $30ba73f8286a8f5a$var$getConfig('confluence_ufo_config') : $30ba73f8286a8f5a$export$69f5225124bf14a6;
    if (!config?.enabled) return;
    (0, $hvG5K.configure)((0, $7d85b53d694de3c0$export$5fc9317dcf7889c3));
    (0, $127d9b8e16c6a735$export$a311cb1baa7d2d62)();
    $30ba73f8286a8f5a$var$runConfigureSsrTiming();
    (0, $9d8d828ea9fa0be5$export$47cd5ebc723ead8d)();
    const perfPushExperienceRates = {
        'view-page': 1,
        'edit-page': 1,
        'live-edit': 1,
        'space-overview': 1,
        'confluence-home': 1,
        'advanced-search': 1,
        'unified-search': 1,
        'embedded-view-page': 1,
        'embedded-live-edit': 1,
        'edit-page-embed': 1,
        'whiteboard-view-page': 1,
        'database-view-page': 1,
        'public-link-shared-page': 1,
        'folder-page': 1
    };
    const assetsConfig = {
        classification: {
            all: true,
            allAtlassian: ({ entry: entry })=>entry.name.includes('atl-paas.net/') || entry.name.includes('cloudfront') && entry.name.includes('batch.js'),
            preloaded: ({ entry: entry, SSRDoneTime: SSRDoneTime })=>Boolean(SSRDoneTime && entry.startTime <= SSRDoneTime)
        }
    };
    (0, $cRN1p.init)((0, $04e9M.getAnalyticsWebClient)(), {
        postInteractionLog: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        extraInteractionMetrics: {
            enabled: true,
            rates: perfPushExperienceRates
        },
        enableSegmentHighlighting: false,
        enableAdditionalPerformanceMarks: false,
        shouldCalculateLighthouseMetricsFromTTAI: true,
        manuallyTrackReactProfilerMounts: true,
        product: 'confluence',
        population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown'),
        region: shard || 'unknown',
        ...config,
        getReactHydrationStats: $4f467cf502568ccb$export$2d8f8d64dc343d7b,
        // vc config must come after ...config spread to prevent the Statsig dynamic config
        // from overwriting locally-controlled settings (e.g. enabledVCRevisions).
        vc: {
            ...config?.vc,
            enabled: true,
            heatmapSize: 200,
            oldDomUpdates: false,
            selectorConfig: {
                id: false,
                role: false,
                className: true,
                testId: true
            },
            devToolsEnabled: (0, $1xpoY.default).isKillSwitchOn('confluence_enable_ttvc_devtool'),
            enabledVCRevisions: {
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                all: (0, $9wGTI.fg)('ufo_disable_ttvc_v4') ? [] : [
                    'fy26.04'
                ]
            },
            includeSSRInV3: true,
            includeSSRRatio: true,
            trackLayoutShiftOffenders: false
        },
        minorInteractions: [
            'space-navigation-hover',
            'hover-page-card'
        ],
        ssr: {
            getSSRDoneTime: $65f6d9e9d3e9996f$export$3def7672244bab0c,
            getSSRTimings: $65f6d9e9d3e9996f$export$bf7408e83532dcd0
        },
        additionalPayloadData: (interaction)=>(0, $18160efac3c2d8a9$export$8f5840779a8ebb97)(interaction, {
                cloudId: cloudId,
                isShardPreProd: shard ? shard.startsWith('conf-prod-us-preprod') : false,
                layoutShiftWithAttribution: (0, $dc2c9e680a6dd356$export$36b44777ebe5656d)(interaction.ufoName, $30ba73f8286a8f5a$var$getConfig('confluence_cls_attribution_config'), {
                    start: interaction.start,
                    end: interaction.end,
                    type: interaction.type,
                    getCLS: ()=>(0, $8NKQ9.getPPSMetrics)(interaction)['metric:cls']
                })
            }),
        extraSearchPageInteraction: {
            enabled: true,
            searchPageMetricName: 'unified_search',
            searchPageRoute: '/wiki/search'
        },
        enableBetterPageVisibilityApi: true,
        assetsConfig: assetsConfig
    });
    // When client-side TTVC calculation is disabled, the __on_ufo_vc_debug_data_ready callback
    // is never called (no VC calculators run). Listen for UFO_FINISH_INTERACTION instead to
    // ensure __TTVC_READY__ is set and Apollo stats are still reported on interaction completion.
    if (typeof window !== 'undefined') window.addEventListener('UFO_FINISH_INTERACTION', ()=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if (!(0, $9wGTI.fg)('ufo_disable_ttvc_v4')) return;
        $30ba73f8286a8f5a$var$reportApolloDiffStoreStats();
        // @ts-ignore
        window.__TTVC_READY__ = true;
    }, {
        once: true
    });
}
// Helper: report Apollo diffStore stats to monitoring
function $30ba73f8286a8f5a$var$reportApolloDiffStoreStats() {
    const apolloStats = window['__APOLLO_STATS__'];
    if (apolloStats?.diffStore) {
        const monitoringClient = (0, $5ZqQS.getMonitoringClient)();
        const entries = Object.entries(apolloStats?.diffStore).sort((a, b)=>b[1] - a[1]).slice(0, 10);
        for (const [query, value] of entries)// cc_fe_telemetry_apolloDiffStore in SFX
        monitoringClient.gauge(`apolloDiffStore`, value, [
            `query:${query}`
        ]);
    }
}
// UFO library invokes this callback once VC debug data is available.
// https://hello.atlassian.net/wiki/spaces/APD/pages/5398802024/RUNBOOK+Emitting+and+receiving+TTVC+debug+data+from+UFO
if (typeof window !== 'undefined') // @ts-ignore
window.__on_ufo_vc_debug_data_ready = function() {
    // When TTVC v4 client-side calculation is active (flag off), Apollo stats fire here.
    // When it's disabled (flag on), they fire via UFO_FINISH_INTERACTION instead.
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('ufo_disable_ttvc_v4')) $30ba73f8286a8f5a$var$reportApolloDiffStoreStats();
    // This is to inform external tools/tests that page finished loading and "performance measured" events were emitted.
    // @ts-ignore
    window.__TTVC_READY__ = true;
};



var $eFgM7 = parcelRequire("eFgM7");







function $e8bac4b2464d29b3$export$77f9905a9b9e760d(_sessionData) {
    (0, $eFgM7.init)({
        getAnalyticsWebClient: (0, $04e9M.getAnalyticsWebClient)(),
        experiences: {
            'edit-page': {
                enabled: true
            },
            'live-edit': {
                enabled: true
            }
        },
        population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown')
    });
}






var $cXtTj = parcelRequire("cXtTj");


var $8RwKN = parcelRequire("8RwKN");




















var $hpjl4 = parcelRequire("hpjl4");

const $b48399af2cf0b1aa$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $hpjl4.JS_LOAD_START))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $hpjl4.JS_LOAD_END))) return {
            name: mark.substring(0, mark.indexOf((0, $hpjl4.JS_LOAD_END))),
            type: 'end'
        };
        return null;
    }
};



var $lCTbz = parcelRequire("lCTbz");




// used for page-load and page-segment-load events
const $a7aad5d0a1d87072$export$eb13033bc77c7e96 = [
    'confluence.ssr.page-statuses',
    'nav4_confluence_global_links',
    'confluence_frontend_statlas_redirect',
    'cc_mohiti_restricted_content_screen_ab_exp',
    'cc_perms_ga_access_requests'
];
const $a7aad5d0a1d87072$export$e669174961337a38 = [];



var $78QFu = parcelRequire("78QFu");

const $105e628ab69b7692$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const clsData = {
        score: 0,
        nodeCounts: {}
    };
    const allLayoutShifts = buffer.getAll();
    const layoutShifts = allLayoutShifts.filter(// Filter for layoutShifts within start and stop time and if entry had no recent user input (which can cause CLS)
    (entry)=>entry.startTime >= start && entry.startTime <= stop && !entry.hadRecentInput);
    const sessionWindows = [];
    let currentWindow = null;
    // Record CLS offenderes by node type
    layoutShifts.forEach((layoutShift)=>{
        layoutShift.sources.forEach((source)=>{
            const { node: node } = source;
            const nodeKey = `${node?.localName || '-'}(:)${node?.className || '-'}`;
            const count = clsData.nodeCounts[nodeKey];
            if (count > 0) clsData.nodeCounts[nodeKey] += 1;
            else clsData.nodeCounts[nodeKey] = 1;
        });
    });
    // Group layout shifts into session windows and calculate score
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric rounded to 4 decimal places
    clsData.score = Math.round(maxScore * 10000) / 10000;
    return clsData;
};


const $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $f69af1ee3d00be57$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    // and overlap with the start and stop window in any way
    (entry)=>entry.startTime <= stop && entry.duration > $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // accumulate observed tbt even when the entry's duration is outside the stop window
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $f69af1ee3d00be57$var$MAX_ACCEPTABLE_TASK_DURATION;
        // accumulate total tbt within start and stop window
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });


const $35573fd923792093$export$f878c419d6dfad3e = 10;
const $35573fd923792093$var$getEstimatedP98LongestInteraction = (interactionEvents)=>{
    const sortedInteractions = [
        ...interactionEvents
    ].sort((a, b)=>b.duration - a.duration);
    sortedInteractions.splice($35573fd923792093$export$f878c419d6dfad3e);
    // If we have an usually high number of interactions,
    // ignore the longest interaction and take the next one.
    // https://web.dev/articles/inp#what-is-inp -> "Details on how INP is calculated"
    const p98Index = Math.min(sortedInteractions.length - 1, Math.floor(interactionEvents.length / 50));
    return {
        p98: sortedInteractions[p98Index],
        interactionCount: sortedInteractions.length
    };
};
const $35573fd923792093$export$6693a9916ea977ef = (start, stop, buffer)=>{
    const inpData = {
        score: 0,
        interactionCounts: {}
    };
    const allEvents = buffer.getAll();
    const interactionEvents = allEvents.filter((entry)=>entry.startTime >= start && entry.startTime <= stop && entry.entryType !== 'first-input' && //@ts-ignore for some reason our Typecheck says this property doesn't exist but its in the reference https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEventTiming
        entry.interactionId);
    if (interactionEvents.length) {
        const { p98: p98, interactionCount: interactionCount } = $35573fd923792093$var$getEstimatedP98LongestInteraction(interactionEvents);
        inpData.score = p98.duration;
        inpData.interactionCounts = interactionCount;
    }
    return inpData;
};








// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 




const $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $6947188617eea69c$export$b7f047fd73089148 = (start, stop, buffer)=>buffer.getAll().filter(// filter entries that are long tasks (greater than MAX_ACCEPTABLE_TASK_DURATION)
    (entry)=>entry.duration > $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((longTaskTiming, entry)=>{
        longTaskTiming += entry.duration - $6947188617eea69c$var$MAX_ACCEPTABLE_TASK_DURATION;
        return longTaskTiming;
    }, 0);






var $eDAGu = parcelRequire("eDAGu");

const $21a76cadeda71c1e$export$1391212d75b2ee65 = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $21a76cadeda71c1e$export$b46cecdf698e4bb5 = async ({ start: start, stop: stop })=>{
    // PerformanceObserver is not deterministic in reporting entries, so a 500ms delay is needed
    // 500ms was tested in Jira and it captured enough data without causing a volume drop in reported events
    await $21a76cadeda71c1e$export$1391212d75b2ee65(500);
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]);
    const longTaskTiming = (0, $6947188617eea69c$export$b7f047fd73089148)(start, stop, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    const metrics = {
        'metric:tbt': Math.round(tbt.total),
        // sum of blocking time for long tasks within the 'start' and 'stop' time
        'metric:tbt:observed': Math.round(tbt.observed),
        // sum of blocking time for long tasks that might end beyond the 'stop' time
        'metric:cls': cls.score,
        'metric:clsNodeCounts': cls.nodeCounts,
        'metric:longTaskTiming': Math.round(longTaskTiming)
    };
    return metrics;
};


const $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS = 8000;
const $834cc9c1e99eabd0$export$d4724968c3d7ea5 = async ({ start: start, stop: stop })=>{
    const webVitalsAttributes = {
        uuid: (0, $78QFu.getUniquePageLoadId)().uuid ?? ''
    };
    // wait for 8 seconds to calculate CLS to account for macros causing page layout shifts
    await (0, $21a76cadeda71c1e$export$1391212d75b2ee65)($834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS);
    const cls = (0, $105e628ab69b7692$export$fc6227831ee7c7)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LayoutShift]);
    // for slow pages, TTI is marked too early which causes TBT numbers to be inaccurate so we extend the stop time
    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
    const inp = (0, $35573fd923792093$export$6693a9916ea977ef)(start, stop + $834cc9c1e99eabd0$var$EXTEND_STOP_TIME_MS, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).Event]);
    webVitalsAttributes['metric:inpForInitialLoad'] = inp.score;
    webVitalsAttributes['metric:clsForInitialLoad'] = cls.score;
    webVitalsAttributes['metric:clsOffendersForInitialLoad'] = cls.nodeCounts;
    webVitalsAttributes['metric:tbtForInitialLoad'] = Math.round(tbt.total); // sum of blocking time for long tasks within the 'start' and 'stop' time
    return webVitalsAttributes;
};





const $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d = (sessionData)=>{
    const { cloudId: cloudId, environment: environment, shard: shard } = sessionData;
    const plugins = [];
    plugins.push((0, $21a76cadeda71c1e$export$b46cecdf698e4bb5));
    /**
	 * https://product-fabric.atlassian.net/browse/CCP-1320
	 * Remove unused attributes in page-segment-load event
	 */ const buildInfo = (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
        buildInfo: (0, $eSuZj.getBuildInfo)()
    });
    /**
	 * Data to be added to all events.
	 */ const allEventConfig = {
        custom: (0, $8b39c089fbdae2d5$export$96934690d8345a62)({
            cloudId: cloudId,
            environment: environment,
            shard: shard,
            ssr: Boolean(window.__SSR_RENDERED__)
        }),
        featureFlags: (0, $a7aad5d0a1d87072$export$e669174961337a38),
        sfxEvents: {
            activeTab: (0, $lCTbz.PageVisibleFields).pageVisibleState
        },
        plugins: plugins
    };
    /**
	 * Data to be added to only page-load events.
	 */ const pageLoadEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $31b0fb0fb1951a4c$export$7908ff149a3cbadd),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2),
            (0, $894ba807f7f34abc$export$3f2fb183b6cd13c4)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96)
    };
    /**
	 * Data to be added to only custom events.
	 */ const pageSegmentLoadEventConfig = {
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97),
            (0, $47229cc534a9628f$export$79c58f8fef22ebf2)
        ],
        histogram: {
            initial: {
                fmp: '1000_2000_2500_3000_4000_5000',
                tti: '2000_2500_3000_3500_4000_5000_6000'
            },
            transition: {
                fmp: '500_1000_1500_2000_2500_3000',
                tti: '1000_1500_2000_2500_3000_4000'
            }
        },
        // page-segment-load type event will include allEventConfig.featureFlags + the following list.
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96),
        enableBundleEvalTimings: false
    };
    const customEventConfig = {
        custom: buildInfo,
        plugins: [
            (0, $8476ac2738811490$export$30c543c9fd9ad97)
        ]
    };
    const webVitalsConfig = {
        custom: buildInfo,
        enabled: true,
        plugins: [
            (0, $834cc9c1e99eabd0$export$d4724968c3d7ea5)
        ],
        // Undefined timeout defaults to 30000ms, increasing timeout here on Cypress tests to prevent flakiness.
        timeout: window?.Cypress ? undefined : 10000,
        ttciEnabled: false,
        featureFlags: (0, $a7aad5d0a1d87072$export$eb13033bc77c7e96)
    };
    return {
        all: allEventConfig,
        [(0, $lCTbz.BMEventsType).PAGE_LOAD]: pageLoadEventConfig,
        [(0, $lCTbz.BMEventsType).PAGE_SEGMENT_LOAD]: pageSegmentLoadEventConfig,
        [(0, $lCTbz.BMEventsType).CUSTOM]: customEventConfig,
        [(0, $lCTbz.BMEventsType).WEB_VITALS]: webVitalsConfig
    };
};





let $ae045ed661bc53ec$var$isBrowserMetricsInitialized = false;
const $ae045ed661bc53ec$var$logger = (0, $7W8i8.getLogger)('initializeBrowserMetrics');
const $ae045ed661bc53ec$var$criticalAssetsList = [
    'app',
    'atl',
    'runtime',
    'vendors',
    'ssr-scripts',
    'stable_vendors',
    'query-preloader',
    'browser-not-supported'
];
function $ae045ed661bc53ec$var$mapResources(url) {
    return $ae045ed661bc53ec$var$criticalAssetsList.find((asset)=>url.includes(`/${asset}.`)) || 'ignored';
}

const $ae045ed661bc53ec$export$efcab8bd082cbc1f = (sessionData)=>{
    if (!$ae045ed661bc53ec$var$isBrowserMetricsInitialized) {
        const { shard: shard } = sessionData;
        const getAnalyticsWebClientPromise = (0, $04e9M.getAnalyticsWebClient)();
        const product = (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence';
        (parcelRequire("cG9jM")).then((ufo)=>ufo.setup(sessionData, getAnalyticsWebClientPromise)).catch((error)=>{
            $ae045ed661bc53ec$var$logger.error`Fail to import UFO client: ${error}`;
        });
        (0, $eDAGu.startLightHouseObservers)();
        (0, $8RwKN.browserMetrics).init({
            info: {
                app: {
                    framework: {
                        name: 'react',
                        version: (0, $cozmU.version)
                    },
                    version: {
                        web: (0, $eSuZj.getBuildInfo)().FRONTEND_VERSION,
                        ssr: window.__SSR_BUILD__
                    }
                },
                hostname: window.location.hostname,
                product: product,
                population: (0, $1xpoY.default).getString('cc_ufo_group', 'unknown'),
                region: shard
            },
            plugins: {
                featureFlags: {
                    client: Promise.resolve({
                        getValue: (featureFlagKey)=>{
                            // Using `FeatureGates.checkGate` here to avoid triggering exposure tracking
                            return (0, $cXtTj.default).checkGate(featureFlagKey);
                        }
                    })
                },
                resourceTimings: {
                    mapResources: $ae045ed661bc53ec$var$mapResources,
                    // Not interested in fetch requests as we have already marked wf/
                    sanitiseEndpoints: ()=>'ignored'
                },
                bundleEvalTimings: $b48399af2cf0b1aa$export$1a2bb347935fc536
            },
            endpoints: {
                eventPipelineClient: getAnalyticsWebClientPromise
            },
            events: (0, $eaeb1ca3a97f458a$export$e3f9d1444e2c5f5d)(sessionData),
            ssr: {
                getDoneMark: ()=>(0, $9eE57.getMark)('CFP-63.ssr-ttr') ?? null,
                getTimings: ()=>window.__SSR_MEASURES__ || {}
            },
            enableReactUFOTracker: true
        });
        $ae045ed661bc53ec$var$isBrowserMetricsInitialized = true;
    }
};



var $KcDWk = parcelRequire("KcDWk");


var $fcgrS = parcelRequire("fcgrS");


var $iC5L0 = parcelRequire("iC5L0");


var $hp2SH = parcelRequire("hp2SH");


var $eHj6r = parcelRequire("eHj6r");

function $ca1d37ec2e96c685$export$c25b3a02c2d5dc72() {
    return 0, $eHj6r.apolloCache;
}



var $gKr8t = parcelRequire("gKr8t");



function $0b6b84530a4d34b5$export$b4a2d416bf2548b() {
    return 0, $gKr8t.apolloAGGCache;
}



var $9HB34 = parcelRequire("9HB34");


var $ezH4I = parcelRequire("ezH4I");

var $byLFK = parcelRequire("byLFK");


var $hZpML = parcelRequire("hZpML");





var $cMvQV = parcelRequire("cMvQV");


var $9j59h = parcelRequire("9j59h");




var $lTjel = parcelRequire("lTjel");









/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 


const $db1172108b431747$export$bc237d627614fc48 = `!function(e,t){const n=t.__SSR_INTERACTIONS__={},i=t.__SSR_INTERACTIONS_DURATIONS__={},o=t.__SSR_EVENT_LISTENERS__=[];Array.from(e.getElementsByClassName("ssrMouseEvent")).forEach((t=>{t.previousSibling&&((t,s)=>{if(!t||!s)return;const r=e=>{if(!e)return!1;if(e.disabled)return!0;let t=!1;for(let n=0;n<e.childNodes.length;n++)if(r(e.childNodes[n])){t=!0;break}return t};if(r(t)){var c;const n=e.createElement("div");n.style.cssText="display: inline-block; position: relative;",n.setAttribute("data-testid","".concat(s,"_CLICK_CONTAINER"));const i=e.createElement("div");i.style.cssText="content: ''; position: absolute; top: 0; left: 0; bottom: 0; right: 0;",i.setAttribute("data-testid","".concat(s,"_CLICK_AREA")),null===(c=t.parentElement)||void 0===c||c.replaceChild(n,t),n.append(t),n.append(i),t=i}const a=e=>{n[e]=!0,i[e]=[...i[e]||[],performance.now()]};let l,d=!1;const u=()=>{a("".concat(s,"_CLICK"))},_=()=>{d=!0,l=setTimeout((function(){d&&(a("".concat(s,"_HOVER")),d=!1)}),100)},E=()=>{l&&clearTimeout(l),d=!1};t.addEventListener("click",u,!0),t.addEventListener("mouseenter",_),t.addEventListener("mouseleave",E),o.push([t,"click",u,!0]),o.push([t,"mouseenter",_,void 0]),o.push([t,"mouseleave",E,void 0])})(t.previousSibling,t.value)}))}(document,window);`;


const $c07037197fae7cb7$export$a6f691eaa46471c3 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $db1172108b431747$export$bc237d627614fc48)}}`
        }
    });
};



var $bDgLe = parcelRequire("bDgLe");










const $ab36569cbfed18a7$export$857c9d19bfa05cb5 = (t0)=>{
    const $ = (0, $bDgLe.c)(1);
    if (!window.__SSR_INLINE_COMMENT_MARKS__ || window.__SSR_INLINE_COMMENT_MARKS__ && window.__SSR_INLINE_COMMENT_MARKS__.length < 1) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: "inline-comments-script",
            "data-testid": "inline-comments-script",
            "data-marks": window.__SSR_INLINE_COMMENT_MARKS__,
            "data-focused": window.__SSR_FOCUSED_INLINE_COMMENTS__
        });
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};


const $2eff8a40a60fa79f$export$708921e5c63e07ae = (t0)=>{
    const $ = (0, $bDgLe.c)(1);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab36569cbfed18a7$export$857c9d19bfa05cb5), null);
        $[0] = t1;
    } else t1 = $[0];
    return t1;
};








function $a6e2c333ce8dee1c$export$d2cb5cf8969d339e() {
    const script = `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.start");` + // Accessing clientHeight causes the browser to perform a synchronous layout recalculation.
    // While this doesn't directly trigger a "paint" operation, it increases the likelihood of one
    // occurring shortly afterward. This means it is less likely that users will see a partially
    // painted screen while the browser processes imported JavaScript modules.
    `window.document.documentElement.clientHeight;` + `window.performance.mark("${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_FORCE_LAYOUT}.end")`;
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: script
        }
    });
}


const $8714b2bec379cfae$export$bd148a921cde8da1 = ()=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6e2c333ce8dee1c$export$d2cb5cf8969d339e), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c07037197fae7cb7$export$a6f691eaa46471c3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2eff8a40a60fa79f$export$708921e5c63e07ae), null), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_SSR_SCRIPTS}.end`), !window.__SSR_REACT_STREAMING__ && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            // Suppress error when performance API failed.
            // Note: in MicrosoftEdge version 18 and prior, performance.measure(name, startMark, endMark) API will throw SyntaxError if startMark is undefined.
            // That's why wrap with try catch statement.
            __html: 'if(window["__SSR_RENDERED__"]){try{window.performance.mark("CFP-63.ssr-ttr");window.performance.measure("browser-metric:fmp",undefined,"CFP-63.ssr-ttr")}catch(e){}}'
        }
    }));
};







/* eslint-disable react/no-danger -- when updating this component, consider replacing dangerous jsx properties */ 



var $iDrrr = parcelRequire("iDrrr");

const $08436a2f9d11149e$export$cc97c2566f53fd12 = 'data-scrollbar-harmonisation';


function $50800b842657c8fb$export$879bd7480c95c3a0(input) {
    const resolvedGates = typeof input === 'object' && input !== null ? input : undefined;
    const isGateEnabled = resolvedGates ? resolvedGates.isEnabled : (0, $iDrrr.fg)('platform_dst_scrollbar_harmonisation');
    const shouldEnable = typeof input === 'boolean' ? input : isGateEnabled;
    if (!shouldEnable) return {};
    return {
        [(0, $08436a2f9d11149e$export$cc97c2566f53fd12)]: ''
    };
}
var $50800b842657c8fb$export$2e2bcd8739ae039 = $50800b842657c8fb$export$879bd7480c95c3a0;






var $koUFz = parcelRequire("koUFz");


var $9eS5w = parcelRequire("9eS5w");

const $932b9916adc5c98b$export$e628ea48b560f375 = (colorMode, contrastMode)=>{
    if (colorMode !== 'auto' && contrastMode !== 'auto') return undefined;
    const setColorMode = colorMode === 'auto' ? `\n  try {
    const darkModeMql = window.matchMedia('${0, $9eS5w.darkModeMediaQuery}');
    const colorMode = darkModeMql.matches ? 'dark' : 'light';
    document.documentElement.setAttribute('${0, $koUFz.COLOR_MODE_ATTRIBUTE}', colorMode);
  } catch (e) {}` : '';
    const setContrastMode = contrastMode === 'auto' && (0, $iDrrr.fg)('platform_increased-contrast-themes') ? `\n  try {
    const contrastModeMql = window.matchMedia('${0, $9eS5w.moreContrastMediaQuery}');
    const contrastMode = contrastModeMql.matches ? 'more' : 'no-preference';
    document.documentElement.setAttribute('${0, $koUFz.CONTRAST_MODE_ATTRIBUTE}', contrastMode);
  } catch (e) {}` : '';
    return `(() => {${setColorMode}${setContrastMode}})()`;
};
var $932b9916adc5c98b$export$2e2bcd8739ae039 = $932b9916adc5c98b$export$e628ea48b560f375;



var $9gVcL = parcelRequire("9gVcL");


var $8BCWr = parcelRequire("8BCWr");


var $58u2L = parcelRequire("58u2L");

class $60061fec709c0fa4$export$f9bc2ffe605f0ec0 {
    setThemeStateBasedOnSavedThemeState(theme) {
        // If theme is undefined, no reason to set that in themeState as it's not actually a theme (just Original)
        if (theme) this.themeState = {
            ...this.getThemeState(),
            ...theme,
            typography: 'typography'
        };
    }
    getThemeState() {
        return this.themeState;
    }
    async getThemeStylesScript() {
        // Generates an array of styles
        if (this.getThemeState().colorMode) {
            const modifiedThemeState = {
                ...this.getThemeState(),
                typography: 'typography'
            };
            const themeStyles = await (0, $9gVcL.getThemeStyles)(modifiedThemeState);
            // Add a stylesheet for each theme being used
            return themeStyles.map((theme)=>{
                const attributes = Object.entries(theme.attrs).map(([key, value])=>`${key}="${value}"`);
                return `<style ${attributes}>${theme.css}</style>`;
            }).join('');
        } else return '';
    }
    getSSRAutoColorModeScript() {
        // Creates and returns the script used to set the html attributes if the user choose 'auto'
        const currentColorMode = this.getThemeState().colorMode;
        if (currentColorMode === 'auto') {
            const nonceValue = window.__SSR_NONCE_VALUE__;
            const scriptContent = (0, $932b9916adc5c98b$export$e628ea48b560f375)(currentColorMode);
            return nonceValue !== undefined ? `<script nonce="${nonceValue}">${scriptContent}</script>` : `<script>${scriptContent}</script>`;
        } else return '';
    }
    getThemeHtmlAttrsScript({ forceAuto: forceAuto = false } = {}) {
        // Simple script to add theme attributes to HTML tag based on users codeMode selection
        const currentThemeState = this.getThemeState();
        if (currentThemeState.colorMode) {
            const themeAttrs = (0, $8BCWr.getThemeHtmlAttrs)(currentThemeState);
            if (currentThemeState.colorMode === 'auto' || forceAuto) /*
               If the colorMode is auto, we don't want to just default to "light" because if the user's
               browser setting is "dark", this would set the "data-color-mode" to "light" and then set
               again with "dark" with the script from getSSRAutoColorModeScript(). Removing the "data-color-mode"
               setAttribute for "auto" makes sure that it is only set once by the getSSRAutoColorModeScript()
             */ delete themeAttrs['data-color-mode'];
            const attributeSetters = Object.entries(themeAttrs).map(([attr, value])=>`document?.documentElement?.setAttribute("${attr}", "${value}");`).join('');
            return `try { ${attributeSetters} } catch (e) {}`;
        } else return '';
    }
    getScrollbarHarmonisationHtmlAttrsScript() {
        // Simple script to add scrollbar harmonisation attributes to the HTML tag based on the gate
        const scrollbarAttrs = (0, $50800b842657c8fb$export$879bd7480c95c3a0)();
        if (Object.keys(scrollbarAttrs).length === 0) return '';
        const attributeSetters = Object.entries(scrollbarAttrs).map(([attr, value])=>`document?.documentElement?.setAttribute("${attr}", "${value}");`).join('');
        return `try { ${attributeSetters} } catch (e) {}`;
    }
    constructor(){
        this.themeState = void 0;
        // If colorMode doesn't get set, you don't want to return anything
        this.themeState = (0, $58u2L.getDefaultTheme)();
    }
}


const $cad415a4c0599362$export$fd920a796bc0c5e = new (0, $60061fec709c0fa4$export$f9bc2ffe605f0ec0)();



var $bj5fB = parcelRequire("bj5fB");

const $ef8ede6c338f8be6$export$6838ff380832204f = ({ uri: uri })=>{
    const nonceValue = window.__SSR_NONCE_VALUE__;
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)(uri);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
        ...nonceValue !== undefined ? {
            nonce: nonceValue
        } : {},
        dangerouslySetInnerHTML: {
            __html: `if(window["__SSR_RENDERED__"]){${(0, $cad415a4c0599362$export$fd920a796bc0c5e).getThemeHtmlAttrsScript({
                forceAuto: isMobileApp
            })}${(0, $cad415a4c0599362$export$fd920a796bc0c5e).getScrollbarHarmonisationHtmlAttrsScript()}}`
        }
    });
};


const $d847caf3274d14b7$export$f3385cdc6645f7e3 = ({ uri: uri })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.start`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef8ede6c338f8be6$export$6838ff380832204f), {
        uri: uri
    }), (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_THEME_INIT}.end`));







const $799291abed68198f$export$640957ec8f6fdf34 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.start`), children, (0, $hZpML.perfMark)(`${(0, $hZpML.WATERFALL_INITIAL_MEASURES).HTML_REACT_ROOT}.end`));
};



var $igNpi = parcelRequire("igNpi");





var $3IHUl = parcelRequire("3IHUl");


var $1z9oK = parcelRequire("1z9oK");








var $9SZCg = parcelRequire("9SZCg");


var $eqEJl = parcelRequire("eqEJl");

function $327999b9823f79d3$export$eb1f6bb5cb9748d3() {
    // The eligible route/reader records exposure. Bootstrap also runs on unrelated SSR routes.
    if (!(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_exp_personalization_contract', 'isEnabled', true)) return;
    const environment = (0, $9HB34.getRelayEnvironment)();
    const owner = (0, $igNpi.getOrCreatePersonalizationQueryOwner)(environment);
    for (const variables of window.__PERSONALIZATION_QUERY_VARIABLES__ ?? [])owner.preload(variables, undefined, true);
    if (!window.__SSR_REACT_STREAMING__) return;
    const { text: text, id: id } = (0, $eqEJl.getRequest)((0, $9SZCg.default)).params;
    const operation = text ? (0, $3IHUl.createIdentifierFromQuery)(text) : `id:${id}`;
    const stream = (0, $1z9oK.getClientStream)('relay');
    const onResult = (event)=>{
        if (event.type !== 'result' || event.operation !== operation) return;
        // The network listener has cached the response. Replaying through the existing environment
        // normalizes streamed records; no response cache or transport is introduced here.
        owner.preload(event.variables);
    };
    stream.addListener(onResult);
    owner.setHydrationCleanup(()=>stream.removeListener(onResult));
}






var $kEZox = parcelRequire("kEZox");

















var $1ydBT = parcelRequire("1ydBT");




function $6fa2bb018c065af1$export$598e33c4effb27e4() {
    if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_preloaded_query') || !(0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false)) return;
    const environment = (0, $9HB34.getRelayEnvironment)();
    const owner = (0, $kEZox.getOrCreateConversationQueryOwner)(environment);
    if (window.__CONVERSATION_QUERY_VARIABLES__) owner.preload(window.__CONVERSATION_QUERY_VARIABLES__);
    if (!window.__SSR_REACT_STREAMING__) return;
    // The existing Relay network listener caches each response before this listener runs.
    // loadQuery can therefore consume the streamed response without a browser request, even
    // when the initial __RELAY_STORE__ snapshot preceded this boundary's response.
    const { text: text, id: id } = (0, $1ydBT.default).params;
    const operation = text ? (0, $3IHUl.createIdentifierFromQuery)(text) : `id:${id}`;
    const stream = (0, $1z9oK.getClientStream)('relay');
    const onResult = (event)=>{
        if (event.type !== 'result' || event.operation !== operation) return;
        const { pageId: pageId } = event.variables;
        if (typeof pageId !== 'string') return;
        owner.preload({
            ...event.variables,
            pageId: pageId
        });
    };
    stream.addListener(onResult);
    owner.setHydrationCleanup(()=>stream.removeListener(onResult));
}



var $irVI7 = parcelRequire("irVI7");


var $dYU3e = parcelRequire("dYU3e");


var $emNvf = parcelRequire("emNvf");

function $c63485f681d81d31$export$693b572d94b96722() {
    return (0, $dYU3e.query)({
        query: (0, $emNvf.default),
        __callerPackage__: "page-layout"
    });
}


















var $dGmBZ = parcelRequire("dGmBZ");


var $i1Dx5 = parcelRequire("i1Dx5");

function $29a9b31003a013cc$export$52cb4f0de2920e5f() {
    if ((0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_preloaded_query') || !(0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false) && !(0, $6mKj3.expVal)('confluence_exp_space_nav_combined_links', 'isEnabled', false)) return;
    const environment = (0, $9HB34.getRelayEnvironment)();
    const owner = (0, $i1Dx5.getOrCreateSpaceNavigationQueryOwner)(environment);
    if (window.__SPACE_NAVIGATION_QUERY_VARIABLES__) owner.preload(window.__SPACE_NAVIGATION_QUERY_VARIABLES__);
    if (!window.__SSR_REACT_STREAMING__) return;
    // The existing Relay network listener caches each response before this listener runs.
    // loadQuery can therefore consume the streamed response without a browser request, even
    // when the initial __RELAY_STORE__ snapshot preceded this boundary's response.
    const { text: text, id: id } = (0, $dGmBZ.default).params;
    const operation = text ? (0, $3IHUl.createIdentifierFromQuery)(text) : `id:${id}`;
    const stream = (0, $1z9oK.getClientStream)('relay');
    const onResult = (event)=>{
        if (event.type !== 'result' || event.operation !== operation) return;
        const { cloudId: cloudId, spaceKey: spaceKey, isLicensed: isLicensed } = event.variables;
        if (typeof cloudId !== 'string' || typeof spaceKey !== 'string' || typeof isLicensed !== 'boolean') return;
        owner.preload({
            ...event.variables,
            cloudId: cloudId,
            spaceKey: spaceKey,
            isLicensed: isLicensed
        });
    };
    stream.addListener(onResult);
    owner.setHydrationCleanup(()=>stream.removeListener(onResult));
}



var $8U3Mq = parcelRequire("8U3Mq");








var $lyWac = parcelRequire("lyWac");


var $xwvlW = parcelRequire("xwvlW");








var $bPDOf = parcelRequire("bPDOf");


var $3FO8k = parcelRequire("3FO8k");

const $07b476ef513689d8$export$e5077e9c81abf107 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
        },
        __callerPackage__: "onboarding-helpers"
    });
};



var $hAiCi = parcelRequire("hAiCi");





var $74VX5 = parcelRequire("74VX5");

const $b7ee762a3100e127$export$18585825cd8ca022 = ()=>{
    return (0, $dYU3e.queryAgg)({
        query: (0, $74VX5.default),
        __callerPackage__: "app-navigation"
    });
};


async function $a6a4fe9083f3db22$export$d46e9819bcc1eb51() {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    const topNavigationPromises = [
        (0, $dYU3e.query)({
            query: (0, $hAiCi.default),
            __callerPackage__: "app-navigation"
        })
    ];
    topNavigationPromises.push((0, $07b476ef513689d8$export$e5077e9c81abf107)());
    if (userId) topNavigationPromises.push((0, $b7ee762a3100e127$export$18585825cd8ca022)());
    return (0, $lyWac.waitForAllReturnWhenError)(topNavigationPromises);
}


function $1d20c0a68123b7f2$export$2d0f6d5aa0911699() {
    return (0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)();
}









/**
 * @generated SignedSource<<4578650f7a6fe4e1474f11e8181e051b>>
 * @relayHash 21354ce056af321d3c9a22d041061cbd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 995f0038c2de9764a22d6b1084f25ff437d0af79bc8d777102ec6b571d9ec00a
const $bc8b67b6774afb22$var$node = function() {
    var v0 = [
        {
            "concreteType": "SiteOperations",
            "kind": "LinkedField",
            "name": "siteOperations",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "userProfile"
                },
                {
                    "kind": "ScalarField",
                    "name": "application"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadOperationsQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadOperationsQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "21354ce056af321d3c9a22d041061cbd",
            "id": "995f0038c2de9764a22d6b1084f25ff437d0af79bc8d777102ec6b571d9ec00a",
            "metadata": {},
            "name": "preloadOperationsQuery",
            "operationKind": "query",
            "text": "query preloadOperationsQuery{siteOperations{userProfile,application}}"
        }
    };
}();
$bc8b67b6774afb22$var$node.hash = "abad04e66f2fedacc515f8a26b1558e3";
var $bc8b67b6774afb22$export$2e2bcd8739ae039 = $bc8b67b6774afb22$var$node;


async function $969a3e14c27be3bd$export$9930aa21f1e6a4e3() {
    const { userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!userId) return;
    return (0, $dYU3e.query)({
        query: (0, $bc8b67b6774afb22$export$2e2bcd8739ae039),
        __callerPackage__: "site-operations"
    });
}



var $eiCiP = parcelRequire("eiCiP");


var $9fLxI = parcelRequire("9fLxI");





var $eqB7W = parcelRequire("eqB7W");


var $b1ypt = parcelRequire("b1ypt");

function $88b2ba3b9422ec6a$export$3837c35a0d92ab93() {
    const macroParams = window['__LEGACY_MACRO_PARAMS__'] || [];
    window['__LEGACY_MACRO_PARAMS__'] = [];
    // eslint-disable-next-line check-preloaders/no-promise-all
    return Promise.all(macroParams.map(({ isMacroContentAndBody: isMacroContentAndBody, ...rest })=>{
        return isMacroContentAndBody ? (0, $dYU3e.query)({
            query: (0, $eqB7W.default),
            variables: rest,
            context: {
                single: true
            },
            __callerPackage__: "fabric-extension-handlers"
        }) : (0, $dYU3e.query)({
            query: (0, $b1ypt.default),
            variables: rest,
            context: {
                single: true
            },
            __callerPackage__: "fabric-extension-handlers"
        });
    }));
}






var $iHLZT = parcelRequire("iHLZT");


var $l6Xaz = parcelRequire("l6Xaz");


var $d1d56 = parcelRequire("d1d56");

async function $821e100427ee88aa$export$ce64f7b5556cdb62({ preloadSuperBatchForSSR: preloadSuperBatchForSSR = false } = {}) {
    if (preloadSuperBatchForSSR) {
        const superbatchData = await (0, $dYU3e.query)({
            query: (0, $d1d56.default),
            __callerPackage__: "wrm"
        });
        const resourceList = superbatchData?.data?.internalFrontendResource?.resourceList || [];
        const { js: js, css: css } = resourceList.reduce((acc, resource)=>{
            const html = (0, $l6Xaz.convertSuperBatchResourceToTags)(resource);
            acc[resource.type].push(html);
            return acc;
        }, {
            js: [],
            css: []
        });
        (0, $iHLZT.superbatchJSRecorder).add((0, $l6Xaz.removeJquery)(js.join('\n')));
        (0, $iHLZT.superbatchCSSRecorder).add(css.join('\n'));
    } else if (!window.__SUPERBATCH_REQUESTED__) return (0, $dYU3e.query)({
        query: (0, $d1d56.default),
        __callerPackage__: "wrm"
    });
    return Promise.resolve();
}



var $fkeeB = parcelRequire("fkeeB");


var $8SjBl = parcelRequire("8SjBl");


var $9WAeG = parcelRequire("9WAeG");


var $f7B1p = parcelRequire("f7B1p");


var $3mugH = parcelRequire("3mugH");


var $d6NtA = parcelRequire("d6NtA");


var $60cDW = parcelRequire("60cDW");


var $cgNzK = parcelRequire("cgNzK");

const $29df517881fdeca7$export$c2d188ccf9271ffd = 'CookiePreferencesQuery';
const $29df517881fdeca7$var$preloadCookiePreferencesForBanner = async ()=>{
    if (window.__COOKIE_CONSENT_PREFERENCES__) return window.__COOKIE_CONSENT_PREFERENCES__;
    const { cookiesConsentToken: cookiesConsentToken, cookiesFallbackToken: cookiesFallbackToken, userId: userId, perimeter: perimeter, isBifrostIcRequest: isBifrostIcRequest, environment: environment } = (0, $60cDW.getSSRRenderInputs)();
    // If the consent token cookie exists (user has already set their preferences), there is no need to
    // fetch the preferences from ConsentHub.
    if (cookiesConsentToken) {
        window.__COOKIE_CONSENT_PREFERENCES__ = {
            consentToken: cookiesConsentToken,
            ...cookiesFallbackToken ? {
                fallbackConsentToken: cookiesFallbackToken
            } : {}
        };
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (!userId) {
        // For anonymous users, if only the fallback token exists (the primary consent token has
        // expired but the long-lived fallback is still present), include the fallback as a consent
        // signal so that SSR and client hydration make consistent banner visibility decisions.
        const anonymousConsentToken = (0, $8SjBl.serializeConsents)({});
        if (!anonymousConsentToken && !cookiesFallbackToken) {
            window.__COOKIE_CONSENT_PREFERENCES__ = null;
            return window.__COOKIE_CONSENT_PREFERENCES__;
        }
        window.__COOKIE_CONSENT_PREFERENCES__ = {
            ...anonymousConsentToken ? {
                consentToken: anonymousConsentToken
            } : {},
            ...cookiesFallbackToken ? {
                fallbackConsentToken: cookiesFallbackToken
            } : {}
        };
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (perimeter === 'fedramp-moderate' || isBifrostIcRequest === true) {
        window.__COOKIE_CONSENT_PREFERENCES__ = null;
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    if (!environment) {
        window.__COOKIE_CONSENT_PREFERENCES__ = null;
        (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Cannot preload Cookie Consent Preferences: missing environment'));
        return window.__COOKIE_CONSENT_PREFERENCES__;
    }
    const hostEnv = environment === 'PRODUCTION' ? 'prod' : 'staging';
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:CookieConsentPreferences', async ()=>{
        let result = null;
        const isLocalPillar = (0, $d6NtA.isLocal)();
        const url = isLocalPillar ? '/gateway/api/consenthub/session/user/consents/cookies' : `https://atl-preferences-center-elb.${hostEnv}.atl-paas.net/rest/user/${userId}/consents/cookies`;
        try {
            const res = await (0, $f7B1p.cfetch)(url, (0, $cgNzK.constructCompatibleRequestInit)({
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                    ...Boolean(undefined) && Boolean(undefined) && !isLocalPillar ? {
                        'x-ssr-service-name': 'atl-preferences-center'
                    } : {}
                },
                credentials: 'include'
            }));
            if (!res.ok) throw new Error(`Cannot load Cookie Consent Preferences: ${res.statusText}`);
            result = await res.json();
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Fetching cookie preferences failed: ${e.message}`));
        }
        if (result && Object.keys(result).length) {
            window.__COOKIE_CONSENT_PREFERENCES__ = Object.assign({}, result, {
                fallbackConsentToken: cookiesFallbackToken
            });
            return window.__COOKIE_CONSENT_PREFERENCES__;
        } else {
            window.__COOKIE_CONSENT_PREFERENCES__ = null;
            return window.__COOKIE_CONSENT_PREFERENCES__;
        }
    });
};
const $29df517881fdeca7$var$getCookiePreferencesForBanner = ()=>{
    if (window.__COOKIE_CONSENT_PREFERENCES__ !== undefined) return Promise.resolve(window.__COOKIE_CONSENT_PREFERENCES__);
    if (!window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__) window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__ = $29df517881fdeca7$var$preloadCookiePreferencesForBanner().finally(()=>{
        window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__ = null;
    });
    return window.__COOKIE_CONSENT_PREFERENCES_PRELOAD_PROMISE__;
};
const $29df517881fdeca7$export$990c5eb6cb59ce1c = async ()=>{
    const cookiePreferences = await $29df517881fdeca7$var$getCookiePreferencesForBanner();
    if (window.__PRELOADED_COOKIE_PREFERENCES__ === undefined) {
        const { prefs: prefs } = (0, $fkeeB.initializePreferencesData)(cookiePreferences ?? undefined);
        window.__PRELOADED_COOKIE_PREFERENCES__ = prefs ?? null;
    }
    return cookiePreferences;
};








parcelRequire("8nle6");
var $5SzHz = parcelRequire("5SzHz");





var $eS4vC = parcelRequire("eS4vC");

// When firing preload functions we don't have experience tracker started thus we can only annotate the request through URL match
function $df23aac6d1130849$export$7388eaba0b85ff24(exp) {
    window['GLOBAL_FALLBACK_ATL_EXP'] = exp;
}













var $lesra = parcelRequire("lesra");




/**
 * @generated SignedSource<<665e9f622479d8b8a25b05a0d8f0fe94>>
 * @relayHash fe3341ed930f93ccf29cba79d0a71a5f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fd2b05a3bb62454654b6b992f1679f4ed4910edc57ce1d395f4c143c40888dc2
const $83b1dd2d3bda0ead$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isNotLicensed"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "suggestion"
    }, v2 = {
        "kind": "ScalarField",
        "name": "dismissalDateTime"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = [
        {
            "condition": "isNotLicensed",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "UserPreferences",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "shouldShowCardOnPageTreeHover"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedRecommendedUserSettingsDismissTimestamp"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "userSpacesNotifiedOfExternalCollab"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "favouriteTemplateEntityIds"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "homePagesDisplayView"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedType"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "feedTab"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "recentFilter"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "missionControlOverview"
                        },
                        {
                            "concreteType": "MissionControlMetricSuggestionState",
                            "kind": "LinkedField",
                            "name": "missionControlMetricSuggestions",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                },
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "ConfluenceEditorSettings",
                            "kind": "LinkedField",
                            "name": "confluenceEditorSettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "toolbarDockingInitialPosition"
                                }
                            ]
                        },
                        {
                            "concreteType": "MissionControlFeatureDiscoverySuggestionState",
                            "kind": "LinkedField",
                            "name": "missionControlFeatureDiscoverySuggestions",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ ,
                                v2 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "globalPageCardAppearancePreference"
                        },
                        {
                            "concreteType": "HomeWidget",
                            "kind": "LinkedField",
                            "name": "homeWidgets",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "state"
                                },
                                v3 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHomeOnboardingDismissed"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "theme"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "watchMyOwnContent"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "commentsPanelSorting"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCommentsPanelAutomaticSummariesEnabled"
                        },
                        v3 /*: any*/ 
                    ]
                }
            ]
        },
        {
            "concreteType": "DiscoveredFeature",
            "kind": "LinkedField",
            "name": "featureDiscovery",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "pluginKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "featureKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "userKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "date"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "UserSettingsQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "UserSettingsQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "fe3341ed930f93ccf29cba79d0a71a5f",
            "id": "fd2b05a3bb62454654b6b992f1679f4ed4910edc57ce1d395f4c143c40888dc2",
            "metadata": {},
            "name": "UserSettingsQuery",
            "operationKind": "query",
            "text": "query UserSettingsQuery($isNotLicensed:Boolean!){userPreferences@skip(if:$isNotLicensed){shouldShowCardOnPageTreeHover,feedRecommendedUserSettingsDismissTimestamp,userSpacesNotifiedOfExternalCollab,favouriteTemplateEntityIds,homePagesDisplayView,feedType,feedTab,recentFilter,missionControlOverview,missionControlMetricSuggestions{suggestion,value,dismissalDateTime},confluenceEditorSettings{toolbarDockingInitialPosition},missionControlFeatureDiscoverySuggestions{suggestion,dismissalDateTime},globalPageCardAppearancePreference,homeWidgets{id,state,__typename},isHomeOnboardingDismissed,theme,watchMyOwnContent,commentsPanelSorting,isCommentsPanelAutomaticSummariesEnabled,__typename},featureDiscovery{pluginKey,featureKey,userKey,date}}"
        }
    };
}();
$83b1dd2d3bda0ead$var$node.hash = "3c17a61cf39923f903a643933ae0bf4d";
var $83b1dd2d3bda0ead$export$2e2bcd8739ae039 = $83b1dd2d3bda0ead$var$node;









var $arxGM = parcelRequire("arxGM");


var $dBy7h = parcelRequire("dBy7h");

const $fb5b21f5b81a7b59$export$8ff552280f2680c = async ()=>{
    const { cloudId: cloudId, activationId: activationId, userId: userId } = (0, $xwvlW.getPreloaderFnContext)();
    // Can only fetch shared theme when we have all required params
    if (!userId || !cloudId || !activationId) return null;
    try {
        const workspaceAri = (0, $dBy7h.getWorkspaceARI)({
            cloudId: cloudId,
            activationId: activationId
        });
        const response = await (0, $dYU3e.queryAgg)({
            query: (0, $arxGM.default),
            variables: {
                workspaceAri: workspaceAri,
                accountId: userId
            },
            __callerPackage__: "preload-storage-queries"
        });
        const theme = response?.data?.settings_userPreferencesResolved?.theme;
        return theme === undefined ? null : theme;
    } catch  {
        // Errors are handled by waitForAllReturnWhenError in the parent function
        return null;
    }
};


const $96ee7afaced2313e$export$758dd268a3743917 = 'default';
const $96ee7afaced2313e$export$e0e94d96f49a1aa = async ({ themeState: themeState })=>{
    const { isLicensed: isLicensed, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    // Apply themeState immediately if provided via query param (always defined for embedded pages)
    if (themeState) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(decodeURIComponent(themeState)));
    // Always fetch user settings
    // When shared-user-preferences flag is on, also fetch the workspace theme from AGG in parallel
    const userSettingsPromise = (0, $dYU3e.query)({
        query: (0, $83b1dd2d3bda0ead$export$2e2bcd8739ae039),
        variables: {
            isNotLicensed: !isLicensed
        },
        __callerPackage__: "preload-storage-queries"
    });
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    const sharedThemePromise = (0, $9wGTI.fg)('shared-user-preferences') ? (0, $fb5b21f5b81a7b59$export$8ff552280f2680c)() : Promise.resolve(null);
    await (0, $lyWac.waitForAllReturnWhenError)([
        userSettingsPromise,
        sharedThemePromise
    ]);
    const userSettingsResponse = await userSettingsPromise;
    const workspaceTheme = await sharedThemePromise;
    const response = userSettingsResponse;
    const legacyTheme = response?.data?.userPreferences?.theme;
    let theme;
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('shared-user-preferences')) // Empty theme returned from API means there is no preference set, which should be treated as default (Auto color mode)
    theme = workspaceTheme === '' ? $96ee7afaced2313e$export$758dd268a3743917 : workspaceTheme;
    else theme = legacyTheme;
    // Apply user preference theme only when no themeState is provided (prevents flicker from mismatch)
    if (!themeState && theme) (0, $cad415a4c0599362$export$fd920a796bc0c5e).setThemeStateBasedOnSavedThemeState((0, $lesra.getEffectiveThemeState)(theme));
    return response;
};



var $kyH1y = parcelRequire("kyH1y");

var $2khPJ = parcelRequire("2khPJ");

















var $iQzVo = parcelRequire("iQzVo");


var $gikGR = parcelRequire("gikGR");


var $ljH80 = parcelRequire("ljH80");


var $iGpO4 = parcelRequire("iGpO4");


var $7N8s0 = parcelRequire("7N8s0");

const $29e73fd15ceba733$export$9865c9c16b8cbabb = async (userId)=>{
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!(0, $9wGTI.fg)('twcg-1489-cc-3p-connector-onboarding-rollout')) return;
    const { isRovoEnabled: isRovoEnabled, orgId: orgId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isRovoEnabled) return;
    // Always preload onboarding state first. It is lightweight and tells us
    // whether the more expensive AGG queries are still needed.
    const onboardingResult = await (0, $dYU3e.queryAgg)({
        query: (0, $gikGR.default),
        variables: {},
        __callerPackage__: "experiment-twcg-1489-cc-3p-connector-onboarding"
    }).catch(()=>null);
    // Extract the enrolment date and skip the AGG queries when the experiment
    // is past its active window.
    const enrolmentDateStr = onboardingResult?.data?.userPreferences?.onboardingState?.find((entry)=>entry.key === (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).ENROLMENT_DATE)?.value ?? undefined;
    if (!(0, $7N8s0.isWithinEnrolmentWindow)(enrolmentDateStr)) return;
    // The sidebar is the only remaining promo surface. Once it has been dismissed
    // (on its own or as part of 'both') nothing can render, so skip the AGG queries.
    const promoDismissed = onboardingResult?.data?.userPreferences?.onboardingState?.find((entry)=>entry.key === (0, $iQzVo.TWCG_1489_CONNECTOR_ONBOARDING).PROMO_DISMISSED)?.value;
    if (promoDismissed === 'sidebar' || promoDismissed === 'both') return;
    // Within the window — fire the AGG queries in parallel.
    const tasks = [];
    if (userId) tasks.push((0, $dYU3e.queryAgg)({
        query: (0, $ljH80.default),
        variables: {
            userId: userId
        },
        __callerPackage__: "experiment-twcg-1489-cc-3p-connector-onboarding"
    }));
    if (orgId && cloudId) tasks.push((0, $dYU3e.queryAgg)({
        query: (0, $iGpO4.default),
        variables: {
            orgId: orgId,
            resourceId: cloudId,
            first: 75
        },
        __callerPackage__: "experiment-twcg-1489-cc-3p-connector-onboarding"
    }));
    if (tasks.length > 0) await (0, $lyWac.waitForAllReturnWhenError)(tasks);
};






var $dBcar = parcelRequire("dBcar");




const $e0b364cfa44ad6fc$export$6c6d6d173d015704 = ()=>(0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                ...(0, $dBcar.NAV_EXPERIMENT_ONBOARDING_KEYS)
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });












var $d9tcB = parcelRequire("d9tcB");


var $cwUrm = parcelRequire("cwUrm");


var $4YUBg = parcelRequire("4YUBg");


var $4vyfK = parcelRequire("4vyfK");





var $8dUjs = parcelRequire("8dUjs");

const $0253e305bf4bf030$export$8b5d8927d613430e = async ()=>{
    const { edition: edition, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const { webItemParams: webItemParams } = (0, $8dUjs.getGlobalAppsParams)({
        edition: edition,
        accessStatus: accessStatus
    });
    return (0, $4vyfK.preloadWebItemLocation)(webItemParams);
};



var $hPkGG = parcelRequire("hPkGG");

const $34aa8f5c495a6ba2$export$3efc211209d16247 = async ()=>{
    const { cloudId: cloudId, userId: userId, activationId: activationId, accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const promises = [
        (0, $0253e305bf4bf030$export$8b5d8927d613430e)()
    ];
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (userId && !(0, $9wGTI.fg)('navx-global-side-nav-confluence')) promises.push((0, $dYU3e.queryAgg)({
        query: (0, $hPkGG.default),
        context: {
            headers: {
                'Atl-Client-Name': 'confluence-frontend'
            }
        },
        variables: {
            entityAri: (0, $kyH1y.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            ownerAri: (0, $2khPJ.IdentityUserAri).create({
                userId: userId
            }).toString()
        },
        __callerPackage__: "side-navigation"
    }));
    // Preload the GRS invited-app-shortcuts recommendations
    // query for the LEGACY nav via interop (queryAgg → Apollo AGG cache), so the render-time
    // `useQueryInterop` read in `LegacyInvitedAppShortcutsRecommendations` hits the SSR-seeded cache
    // with no second network request. GSN preloads this operation separately via platform Relay
    // (`preloadInvitedAppShortcutsRecommendationsQuery`).
    if (userId && cloudId && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    !(0, $9wGTI.fg)('navx-global-side-nav-confluence')) promises.push((0, $dYU3e.queryAgg)({
        query: (0, $4YUBg.default),
        variables: (0, $cwUrm.buildInvitedAppShortcutsRecommendationsVariables)(cloudId),
        __callerPackage__: "side-navigation"
    }));
    if (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) promises.push((0, $e0b364cfa44ad6fc$export$6c6d6d173d015704)());
    if (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS) promises.push((0, $29e73fd15ceba733$export$9865c9c16b8cbabb)(userId ?? undefined));
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
};






var $aQN68 = parcelRequire("aQN68");

async function $e44b2547c6a8e817$export$dfd129d3c3f4c561() {
    return (0, $dYU3e.query)({
        query: (0, $aQN68.default),
        __callerPackage__: "side-navigation"
    });
}









var $cbHql = parcelRequire("cbHql");

const $da1fd1e44d7582fe$export$b4f1825d0b62630d = ()=>(0, $dYU3e.query)({
        query: (0, $cbHql.default),
        __callerPackage__: "editor-presets"
    });



var $iUV81 = parcelRequire("iUV81");


var $9sGCn = parcelRequire("9sGCn");


var $3y1ko = parcelRequire("3y1ko");



















const $9c2bd2b1923ffb30$export$20203945a91bbda3 = ()=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { userId: userId, accessStatus: accessStatus } = preloadedSessionContext;
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const tasks = [];
    if (isLicensed && userId) tasks.push((0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: Object.values((0, $dBcar.CREATE_WITH_ROVO_ANNOUNCEMENT_SPLASH))
        },
        __callerPackage__: "onboarding-helpers"
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $hXDOc = parcelRequire("hXDOc");


var $kM8fE = parcelRequire("kM8fE");


var $g277M = parcelRequire("g277M");



var $cbQWR = parcelRequire("cbQWR");


var $gVWsk = parcelRequire("gVWsk");





var $c9US3 = parcelRequire("c9US3");


var $cUB5n = parcelRequire("cUB5n");

const $8e973d66a6eb555b$export$15cc693b68c3c062 = (contentNodes, onInvalidDocument)=>{
    const contentNode = contentNodes?.[0];
    const contentId = contentNode && 'id' in contentNode ? contentNode.id : undefined;
    const dynamicBody = contentNode?.body?.dynamic;
    const adfString = dynamicBody?.value;
    if (typeof contentId === 'string' && contentId.length > 0 && dynamicBody?.representation === 'atlas_doc_format' && typeof adfString === 'string' && adfString.length > 0 && (0, $6mKj3.expValEquals)('cc-proj-xl-use-shared-adf-parsing', 'isEnabled', true)) {
        const parsedAdf = (0, $c9US3.parseContentNodesAdf)(contentNodes);
        if ((0, $gVWsk.isJSONDocNode)(parsedAdf)) {
            (0, $cUB5n.seedContentBodyAdfCache)(contentId, adfString, parsedAdf);
            return parsedAdf;
        }
        if (parsedAdf !== null) onInvalidDocument(contentId);
    }
    return null;
};



var $wPrRK = parcelRequire("wPrRK");











var $kkLBe = parcelRequire("kkLBe");


var $kquO1 = parcelRequire("kquO1");


var $7Z6Kn = parcelRequire("7Z6Kn");


var $hpnxK = parcelRequire("hpnxK");


var $7Sm4c = parcelRequire("7Sm4c");


var $f9opb = parcelRequire("f9opb");

var $jgc4t = parcelRequire("jgc4t");
/**
 * @generated SignedSource<<50f1cb7a295cf9e1010ca838e7a49777>>
 * @relayHash db9c8e8da31ba9b30f24fc5c1554a7dd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8d7748de22660109e27b6307d9ec4951f237651a6511f76db91b50a9219c0c41
const $aa72a6013de18737$var$node = function() {
    var v0 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "agentSessionsPropertyKey"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "autohighlightsEntityAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "autohighlightsWorkspaceId"
    }, v3 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "externalLabelsAri"
    }, v5 = {
        "defaultValue": "",
        "kind": "LocalArgument",
        "name": "externalLabelsCloudId"
    }, v6 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "fetchAgentSessionsMarker"
    }, v7 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAgentTrustReceiptData"
    }, v8 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAudioContent"
    }, v9 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutohighlights"
    }, v10 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeAutomationDiscoveries"
    }, v11 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeBylineContributors"
    }, v12 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeClassification"
    }, v13 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeConnectionAncestors"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeader"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeContentHeaderAccess"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeExternalLabels"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFabricEditorEligibility"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeReactions"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRendererAssetsCustomChrome"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRendererAssetsMedia"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRestrictionAncestors"
    }, v22 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRestrictions"
    }, v23 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRovoMentionIdentity"
    }, v24 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeSmartCreateFeedback"
    }, v25 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "isSSR"
    }, v26 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "preloadLabels"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v28 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useClassificationLevelV2"
    }, v29 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useContentModeFragment"
    }, v30 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "useNewContentTopper"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "versionOverride"
    }, v32 = [
        {
            "kind": "Variable",
            "name": "spaceKey",
            "variableName": "spaceKey"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "versionOverride"
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "id"
    }, v34 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v35 = {
        "kind": "ScalarField",
        "name": "type"
    }, v36 = {
        "kind": "ScalarField",
        "name": "status"
    }, v37 = [
        {
            "kind": "ScalarField",
            "name": "contentMode"
        }
    ], v38 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            {
                "concreteType": "PublishedContentProperties",
                "kind": "LinkedField",
                "name": "latest",
                "plural": false,
                "selections": v37 /*: any*/ 
            },
            {
                "concreteType": "DraftContentProperties",
                "kind": "LinkedField",
                "name": "draft",
                "plural": false,
                "selections": v37 /*: any*/ 
            }
        ]
    }, v39 = {
        "kind": "ScalarField",
        "name": "name"
    }, v40 = {
        "kind": "ScalarField",
        "name": "color"
    }, v41 = {
        "args": [
            {
                "kind": "Literal",
                "name": "isDraft",
                "value": false
            }
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v39 /*: any*/ ,
            v40 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "restrictionLevel"
            }
        ],
        "storageKey": "contentState(isDraft:false)"
    }, v42 = {
        "kind": "ScalarField",
        "name": "value"
    }, v43 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "USER_FRIENDLY"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "contentStateLastUpdated",
        "plural": false,
        "selections": [
            v42 /*: any*/ 
        ],
        "storageKey": "contentStateLastUpdated(format:\"USER_FRIENDLY\")"
    }, v44 = {
        "kind": "ScalarField",
        "name": "title"
    }, v45 = {
        "kind": "ScalarField",
        "name": "key"
    }, v46 = {
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v39 /*: any*/ ,
            v45 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "alias"
            },
            v35 /*: any*/ 
        ]
    }, v47 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v48 = [
        v45 /*: any*/ ,
        v42 /*: any*/ 
    ], v49 = {
        "alias": "smartFolderProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "smartFolderProperties"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": v48 /*: any*/ 
            }
        ],
        "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    }, v50 = {
        "kind": "ScalarField",
        "name": "contentTypeModified"
    }, v51 = {
        "kind": "ScalarField",
        "name": "number"
    }, v52 = {
        "kind": "ScalarField",
        "name": "friendlyWhen"
    }, v53 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v54 = [
        v53 /*: any*/ 
    ], v55 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": v54 /*: any*/ 
    }, v56 = {
        "kind": "ScalarField",
        "name": "when"
    }, v57 = {
        "kind": "ScalarField",
        "name": "confRev"
    }, v58 = [
        {
            "kind": "ScalarField",
            "name": "coverPictureWidth"
        }
    ], v59 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                "kind": "LinkedField",
                "name": "frontend",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "fabricEditorSupported"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "embedded"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "collabService"
                    },
                    {
                        "condition": "useNewContentTopper",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": v58 /*: any*/ 
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "lastModifiedDate"
            }
        ]
    }, v60 = {
        "kind": "ScalarField",
        "name": "representation"
    }, v61 = {
        "concreteType": "Version",
        "kind": "LinkedField",
        "name": "version",
        "plural": false,
        "selections": [
            v51 /*: any*/ 
        ]
    }, v62 = {
        "kind": "ScalarField",
        "name": "js"
    }, v63 = {
        "kind": "ScalarField",
        "name": "css"
    }, v64 = {
        "concreteType": "WebResourceTags",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
            v62 /*: any*/ ,
            v63 /*: any*/ 
        ]
    }, v65 = [
        v64 /*: any*/ 
    ], v66 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "dynamic",
                "plural": false,
                "selections": [
                    v60 /*: any*/ ,
                    v42 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "content",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            v61 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "WebResourceDependencies",
                        "kind": "LinkedField",
                        "name": "webresource",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "SuperBatchWebResources",
                                "kind": "LinkedField",
                                "name": "superbatch",
                                "plural": false,
                                "selections": v65 /*: any*/ 
                            },
                            v64 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v67 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v33 /*: any*/ ,
                v45 /*: any*/ ,
                v42 /*: any*/ ,
                v61 /*: any*/ 
            ]
        }
    ], v68 = {
        "alias": "appearancePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "content-appearance-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v67 /*: any*/ ,
        "storageKey": "properties(key:\"content-appearance-published\")"
    }, v69 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-published",
                    "emoji-title-published",
                    "editor",
                    "import-source",
                    "imported-page-modified-date"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v67 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"])"
    }, v70 = {
        "alias": "pageTitlePublished",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-published"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v67 /*: any*/ ,
        "storageKey": "properties(key:\"page-title-property-published\")"
    }, v71 = {
        "alias": "pageTitleDraft",
        "args": [
            {
                "kind": "Literal",
                "name": "key",
                "value": "page-title-property-draft"
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v67 /*: any*/ ,
        "storageKey": "properties(key:\"page-title-property-draft\")"
    }, v72 = {
        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
        "kind": "LinkedField",
        "name": "frontend",
        "plural": false,
        "selections": v58 /*: any*/ 
    }, v73 = {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
            v72 /*: any*/ 
        ]
    }, v74 = {
        "alias": "coverPictureProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "cover-picture-id-draft",
                    "cover-picture-id-published"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": v67 /*: any*/ ,
        "storageKey": "properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])"
    }, v75 = {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
    }, v76 = {
        "kind": "ScalarField",
        "name": "hasRestrictions"
    }, v77 = {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
    }, v78 = [
        {
            "kind": "Literal",
            "name": "orderBy",
            "value": {
                "direction": "ASCENDING",
                "sortField": "LABELLING_CREATIONDATE"
            }
        }
    ], v79 = {
        "kind": "ScalarField",
        "name": "count"
    }, v80 = {
        "kind": "ScalarField",
        "name": "label"
    }, v81 = {
        "kind": "ScalarField",
        "name": "prefix"
    }, v82 = {
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "contentReactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    v79 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    },
                    v33 /*: any*/ 
                ]
            }
        ]
    }, v83 = [
        {
            "kind": "Literal",
            "name": "key",
            "value": "emoji-title-published"
        }
    ], v84 = {
        "alias": "emoji",
        "args": v83 /*: any*/ ,
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v33 /*: any*/ ,
                    v42 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(key:\"emoji-title-published\")"
    }, v85 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v86 = [
        v53 /*: any*/ ,
        v85 /*: any*/ 
    ], v87 = {
        "kind": "ScalarField",
        "name": "webui"
    }, v88 = {
        "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            v87 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "base"
            }
        ]
    }, v89 = {
        "alias": "audioProperties",
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v42 /*: any*/ ,
                    v45 /*: any*/ 
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"editor\"])"
    }, v90 = {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "ancestors",
        "plural": true,
        "selections": [
            v33 /*: any*/ ,
            v44 /*: any*/ ,
            v76 /*: any*/ ,
            {
                "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    v87 /*: any*/ 
                ]
            }
        ]
    }, v91 = {
        "kind": "ScalarField",
        "name": "createdDate"
    }, v92 = [
        {
            "kind": "ScalarField",
            "name": "generatedBy"
        }
    ], v93 = {
        "concreteType": "PublishedContentProperties",
        "kind": "LinkedField",
        "name": "latest",
        "plural": false,
        "selections": v92 /*: any*/ 
    }, v94 = {
        "concreteType": "ContentProperties",
        "kind": "LinkedField",
        "name": "contentProperties",
        "plural": false,
        "selections": [
            v93 /*: any*/ 
        ]
    }, v95 = {
        "concreteType": "ContentBodyPerRepresentation",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": [
            {
                "concreteType": "ContentBody",
                "kind": "LinkedField",
                "name": "atlas_doc_format",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "EmbeddedMediaToken",
                        "kind": "LinkedField",
                        "name": "mediaToken",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "token"
                            }
                        ]
                    }
                ]
            }
        ]
    }, v96 = {
        "condition": "fetchAgentSessionsMarker",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "alias": "agentSessionsMarker",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "key",
                        "variableName": "agentSessionsPropertyKey"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v67 /*: any*/ 
            }
        ]
    }, v97 = [
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "spaceKey"
        }
    ], v98 = {
        "concreteType": "Theme",
        "kind": "LinkedField",
        "name": "theme",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "themeKey"
            },
            v39 /*: any*/ 
        ]
    }, v99 = {
        "kind": "ScalarField",
        "name": "background"
    }, v100 = {
        "kind": "ScalarField",
        "name": "backgroundColor"
    }, v101 = {
        "kind": "ScalarField",
        "name": "backgroundImage"
    }, v102 = {
        "kind": "ScalarField",
        "name": "backgroundPosition"
    }, v103 = {
        "kind": "ScalarField",
        "name": "backgroundSize"
    }, v104 = {
        "kind": "ScalarField",
        "name": "backgroundRepeat"
    }, v105 = {
        "kind": "ScalarField",
        "name": "backgroundOrigin"
    }, v106 = {
        "kind": "ScalarField",
        "name": "backgroundClip"
    }, v107 = {
        "kind": "ScalarField",
        "name": "backgroundAttachment"
    }, v108 = {
        "kind": "ScalarField",
        "name": "backgroundBlendMode"
    }, v109 = {
        "concreteType": "ScreenLookAndFeel",
        "kind": "LinkedField",
        "name": "screen",
        "plural": false,
        "selections": [
            v99 /*: any*/ ,
            v100 /*: any*/ ,
            v101 /*: any*/ ,
            v102 /*: any*/ ,
            v103 /*: any*/ ,
            v104 /*: any*/ ,
            v105 /*: any*/ ,
            v106 /*: any*/ ,
            v107 /*: any*/ ,
            v108 /*: any*/ ,
            {
                "concreteType": "LayerScreenLookAndFeel",
                "kind": "LinkedField",
                "name": "layer",
                "plural": false,
                "selections": [
                    v99 /*: any*/ ,
                    v100 /*: any*/ ,
                    v101 /*: any*/ ,
                    v102 /*: any*/ ,
                    v103 /*: any*/ ,
                    v104 /*: any*/ ,
                    v105 /*: any*/ ,
                    v106 /*: any*/ ,
                    v107 /*: any*/ ,
                    v108 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "width"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "height"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "gutterTop"
            },
            {
                "kind": "ScalarField",
                "name": "gutterRight"
            },
            {
                "kind": "ScalarField",
                "name": "gutterBottom"
            },
            {
                "kind": "ScalarField",
                "name": "gutterLeft"
            }
        ]
    }, v110 = {
        "kind": "ScalarField",
        "name": "padding"
    }, v111 = {
        "kind": "ScalarField",
        "name": "borderRadius"
    }, v112 = {
        "concreteType": "ContainerLookAndFeel",
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v99 /*: any*/ ,
            v100 /*: any*/ ,
            v101 /*: any*/ ,
            v102 /*: any*/ ,
            v103 /*: any*/ ,
            v104 /*: any*/ ,
            v105 /*: any*/ ,
            v106 /*: any*/ ,
            v107 /*: any*/ ,
            v108 /*: any*/ ,
            v110 /*: any*/ ,
            v111 /*: any*/ 
        ]
    }, v113 = {
        "concreteType": "SpaceSettings",
        "kind": "LinkedField",
        "name": "settings",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "routeOverrideEnabled"
            }
        ]
    }, v114 = {
        "concreteType": "SpaceUserMetadata",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isAnonymouslyAuthorized"
            }
        ]
    }, v115 = [
        {
            "kind": "ScalarField",
            "name": "html"
        },
        v62 /*: any*/ ,
        v63 /*: any*/ ,
        {
            "concreteType": "SpaUnfriendlyMacro",
            "kind": "LinkedField",
            "name": "spaUnfriendlyMacros",
            "plural": true,
            "selections": [
                v39 /*: any*/ 
            ]
        }
    ], v116 = {
        "condition": "includeRendererAssetsCustomChrome",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "SpaceSettings",
                "kind": "LinkedField",
                "name": "settings",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "SpaceSettingsMetadata",
                        "kind": "LinkedField",
                        "name": "customHeaderAndFooter",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "header",
                                "plural": false,
                                "selections": v115 /*: any*/ 
                            },
                            {
                                "concreteType": "HtmlMeta",
                                "kind": "LinkedField",
                                "name": "footer",
                                "plural": false,
                                "selections": v115 /*: any*/ 
                            }
                        ]
                    }
                ]
            }
        ]
    }, v117 = {
        "condition": "includeRendererAssetsMedia",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "MediaConfiguration",
                "kind": "LinkedField",
                "name": "mediaConfiguration",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "clientId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "fileStoreUrl"
                    }
                ]
            }
        ]
    }, v118 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 1
        },
        {
            "kind": "Literal",
            "name": "input",
            "value": {
                "creatorTypes": [
                    "ROVO_CHAT"
                ]
            }
        },
        {
            "kind": "Literal",
            "name": "product",
            "value": "confluence"
        }
    ], v119 = {
        "kind": "ScalarField",
        "name": "identityAccountId"
    }, v120 = [
        {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "autohighlightsEntityAri"
        },
        {
            "kind": "Variable",
            "name": "workspaceId",
            "variableName": "autohighlightsWorkspaceId"
        }
    ], v121 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "externalLabelsCloudId"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "externalLabelsAri"
        }
    ], v122 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v123 = [
        v122 /*: any*/ ,
        v53 /*: any*/ 
    ], v124 = {
        "kind": "LinkedField",
        "name": "by",
        "plural": false,
        "selections": v123 /*: any*/ 
    }, v125 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v33 /*: any*/ ,
                v45 /*: any*/ ,
                v42 /*: any*/ 
            ]
        }
    ], v126 = {
        "kind": "ScalarField",
        "name": "sourceTemplateEntityId"
    }, v127 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v128 = [
        v122 /*: any*/ ,
        v35 /*: any*/ ,
        v53 /*: any*/ ,
        v127 /*: any*/ ,
        v85 /*: any*/ 
    ], v129 = {
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v123 /*: any*/ 
    }, v130 = [
        v75 /*: any*/ ,
        v76 /*: any*/ ,
        v77 /*: any*/ 
    ], v131 = [
        v122 /*: any*/ ,
        v53 /*: any*/ ,
        v85 /*: any*/ 
    ], v132 = [
        v33 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "guideline"
        },
        {
            "kind": "ScalarField",
            "name": "guidelineADF"
        },
        {
            "kind": "ScalarField",
            "name": "description"
        },
        v40 /*: any*/ ,
        v39 /*: any*/ ,
        v36 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "selections": [
                {
                    "args": v32 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "spaceHomepage",
                    "plural": false,
                    "selections": [
                        v33 /*: any*/ ,
                        v34 /*: any*/ ,
                        v35 /*: any*/ ,
                        v36 /*: any*/ ,
                        v38 /*: any*/ ,
                        v41 /*: any*/ ,
                        v43 /*: any*/ ,
                        v44 /*: any*/ ,
                        v46 /*: any*/ ,
                        v47 /*: any*/ ,
                        v49 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v50 /*: any*/ ,
                                v51 /*: any*/ ,
                                v52 /*: any*/ ,
                                v55 /*: any*/ ,
                                v56 /*: any*/ ,
                                v57 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "draftVersion",
                            "plural": false,
                            "selections": [
                                v50 /*: any*/ ,
                                v51 /*: any*/ ,
                                v52 /*: any*/ ,
                                v55 /*: any*/ ,
                                v56 /*: any*/ 
                            ]
                        },
                        v59 /*: any*/ ,
                        v66 /*: any*/ ,
                        v68 /*: any*/ ,
                        v69 /*: any*/ ,
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ViewPageCommentsPanelPermission_content"
                                    }
                                ],
                                "type": "Content"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "commentsPanelPermission"
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "ArchivedPageBannerV2Status_content"
                                    }
                                ],
                                "type": "Content"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "archivedPageBannerStatusFragment"
                        },
                        {
                            "condition": "useContentModeFragment",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ContentModeFragmentProvider_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "viewPageContentMode"
                                }
                            ]
                        },
                        {
                            "condition": "includeBylineContributors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeConnectionAncestors",
                                                        "variableName": "includeConnectionAncestors"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "useNewContentTopper",
                                                        "variableName": "useNewContentTopper"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "ContentTitleWithByLine_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentTitleWithByLine"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "useTitleContentPropertiesForPublishedPage_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "rendererTitleContentProperties"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "CoverPictureQuery_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "rendererCoverPicture"
                                }
                            ]
                        },
                        {
                            "condition": "includeAutomationDiscoveries",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "MeetingNotesAutomationDiscoveryFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "meetingNotesAutomationDiscoveryFragment"
                                }
                            ]
                        },
                        {
                            "condition": "includeContentHeader",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeAccessButton",
                                                        "variableName": "includeContentHeaderAccess"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeFabricEditorEligibility",
                                                        "variableName": "includeFabricEditorEligibility"
                                                    },
                                                    {
                                                        "kind": "Variable",
                                                        "name": "includeSmartCreateFeedback",
                                                        "variableName": "includeSmartCreateFeedback"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "ContentHeader_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentHeaderFragment"
                                }
                            ]
                        },
                        {
                            "condition": "useNewContentTopper",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v70 /*: any*/ ,
                                            v71 /*: any*/ ,
                                            v73 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "titleContentProperties"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v74 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "coverPicture"
                                },
                                v70 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRestrictions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v75 /*: any*/ ,
                                            v76 /*: any*/ ,
                                            v77 /*: any*/ ,
                                            v44 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "shareAndRestrictButtonData"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v75 /*: any*/ ,
                                            v77 /*: any*/ ,
                                            v76 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "pageRestrictionsContext"
                                }
                            ]
                        },
                        {
                            "condition": "preloadLabels",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageLabelsContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "viewPageLabels"
                                },
                                {
                                    "args": v78 /*: any*/ ,
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        v79 /*: any*/ ,
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v33 /*: any*/ ,
                                                v80 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v81 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                }
                            ]
                        },
                        {
                            "condition": "includeReactions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v82 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "reactionsContent"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ReactionsContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "reactionsContentFragment"
                                }
                            ]
                        },
                        {
                            "condition": "includeAudioContent",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v44 /*: any*/ ,
                                            v47 /*: any*/ ,
                                            v84 /*: any*/ ,
                                            {
                                                "concreteType": "History",
                                                "kind": "LinkedField",
                                                "name": "history",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "createdBy",
                                                        "plural": false,
                                                        "selections": v86 /*: any*/ 
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "ownedBy",
                                                        "plural": false,
                                                        "selections": v86 /*: any*/ 
                                                    }
                                                ]
                                            },
                                            v88 /*: any*/ ,
                                            v89 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "audioContent"
                                },
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "AudioContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "audioContentFragment"
                                }
                            ]
                        },
                        {
                            "condition": "includeRestrictionAncestors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v90 /*: any*/ 
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "pageRestrictionsContextAncestors"
                                }
                            ]
                        },
                        {
                            "condition": "includeClassification",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Variable",
                                                        "name": "useClassificationLevelV2",
                                                        "variableName": "useClassificationLevelV2"
                                                    }
                                                ],
                                                "kind": "FragmentSpread",
                                                "name": "BylineClassification_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "bylineClassificationFragment"
                                }
                            ]
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "PageContentRenderer_content"
                                    }
                                ],
                                "type": "Content"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "pageContentRendererFragment"
                        },
                        {
                            "condition": "includeAgentTrustReceiptData",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v91 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v54 /*: any*/ 
                                        }
                                    ]
                                },
                                v94 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRendererAssetsMedia",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v95 /*: any*/ ,
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "rendererAssetsMedia"
                                }
                            ]
                        },
                        {
                            "condition": "isSSR",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ViewPageExtensionsAndRendererAssetsContentFragment_content"
                                            }
                                        ],
                                        "type": "Content"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "rendererAssetsMacroOutput"
                                }
                            ]
                        },
                        v96 /*: any*/ 
                    ]
                },
                {
                    "args": v97 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v33 /*: any*/ ,
                        v98 /*: any*/ ,
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        v109 /*: any*/ ,
                                        v112 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v113 /*: any*/ ,
                        v114 /*: any*/ ,
                        v116 /*: any*/ ,
                        {
                            "condition": "includeContentHeader",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "fragment": {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "kind": "FragmentSpread",
                                                "name": "ContentHeader_space"
                                            }
                                        ],
                                        "type": "Space"
                                    },
                                    "kind": "AliasedInlineFragmentSpread",
                                    "name": "contentHeaderFragment"
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "ContentTitle_space"
                        },
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "kind": "FragmentSpread",
                                        "name": "PageContentRenderer_space"
                                    }
                                ],
                                "type": "Space"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "pageContentRendererFragment"
                        }
                    ]
                },
                v117 /*: any*/ ,
                {
                    "condition": "includeRovoMentionIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v118 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AgentStudioAssistant",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v119 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeAutohighlights",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v120 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "preloadAutohighlightsQuery_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "autohighlightsQueryFragment"
                        }
                    ]
                },
                {
                    "condition": "includeExternalLabels",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "fragment": {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v121 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "useExternalLabels_query"
                                    }
                                ],
                                "type": "Query"
                            },
                            "kind": "AliasedInlineFragmentSpread",
                            "name": "externalLabelsFragment"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v27 /*: any*/ ,
                v31 /*: any*/ ,
                v23 /*: any*/ ,
                v3 /*: any*/ ,
                v25 /*: any*/ ,
                v20 /*: any*/ ,
                v19 /*: any*/ ,
                v30 /*: any*/ ,
                v26 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v11 /*: any*/ ,
                v13 /*: any*/ ,
                v10 /*: any*/ ,
                v8 /*: any*/ ,
                v18 /*: any*/ ,
                v22 /*: any*/ ,
                v21 /*: any*/ ,
                v12 /*: any*/ ,
                v28 /*: any*/ ,
                v14 /*: any*/ ,
                v24 /*: any*/ ,
                v15 /*: any*/ ,
                v17 /*: any*/ ,
                v29 /*: any*/ ,
                v9 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v16 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "selections": [
                {
                    "args": v32 /*: any*/ ,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "spaceHomepage",
                    "plural": false,
                    "selections": [
                        v33 /*: any*/ ,
                        v34 /*: any*/ ,
                        v35 /*: any*/ ,
                        v36 /*: any*/ ,
                        v38 /*: any*/ ,
                        v41 /*: any*/ ,
                        v43 /*: any*/ ,
                        v44 /*: any*/ ,
                        v46 /*: any*/ ,
                        v47 /*: any*/ ,
                        v49 /*: any*/ ,
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                v50 /*: any*/ ,
                                v51 /*: any*/ ,
                                v52 /*: any*/ ,
                                v124 /*: any*/ ,
                                v56 /*: any*/ ,
                                v57 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "draftVersion",
                            "plural": false,
                            "selections": [
                                v50 /*: any*/ ,
                                v51 /*: any*/ ,
                                v52 /*: any*/ ,
                                v124 /*: any*/ ,
                                v56 /*: any*/ 
                            ]
                        },
                        v59 /*: any*/ ,
                        v66 /*: any*/ ,
                        v68 /*: any*/ ,
                        v69 /*: any*/ ,
                        {
                            "condition": "includeBylineContributors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "alias": "emojiTitlePublished",
                                    "args": v83 /*: any*/ ,
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v67 /*: any*/ ,
                                    "storageKey": "properties(key:\"emoji-title-published\")"
                                },
                                {
                                    "alias": "editorProperty",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "editor"
                                        }
                                    ],
                                    "concreteType": "PaginatedJsonContentPropertyList",
                                    "kind": "LinkedField",
                                    "name": "properties",
                                    "plural": false,
                                    "selections": v125 /*: any*/ ,
                                    "storageKey": "properties(key:\"editor\")"
                                },
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        v72 /*: any*/ ,
                                        v126 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "Space",
                                    "kind": "LinkedField",
                                    "name": "space",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "homepageId"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v91 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v128 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v128 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "lastOwnedBy",
                                            "plural": false,
                                            "selections": v128 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v35 /*: any*/ ,
                                                v85 /*: any*/ ,
                                                v127 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v94 /*: any*/ ,
                                v70 /*: any*/ ,
                                v71 /*: any*/ ,
                                v74 /*: any*/ ,
                                {
                                    "condition": "includeConnectionAncestors",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "ancestors",
                                            "plural": true,
                                            "selections": [
                                                v33 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                {
                                                    "concreteType": "History",
                                                    "kind": "LinkedField",
                                                    "name": "history",
                                                    "plural": false,
                                                    "selections": [
                                                        v129 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "keys",
                                                            "value": [
                                                                "devdocsProperties",
                                                                "smartFolderProperties"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "PaginatedJsonContentPropertyList",
                                                    "kind": "LinkedField",
                                                    "name": "properties",
                                                    "plural": false,
                                                    "selections": v125 /*: any*/ ,
                                                    "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "includeAutomationDiscoveries",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ContentMetadata",
                                    "kind": "LinkedField",
                                    "name": "metadata",
                                    "plural": false,
                                    "selections": [
                                        v126 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "includeContentHeader",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "condition": "includeFabricEditorEligibility",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "ContentMetadata",
                                            "kind": "LinkedField",
                                            "name": "metadata",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                                                    "kind": "LinkedField",
                                                    "name": "frontend",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fabricEditorEligibility"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "contentHash"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeSmartCreateFeedback",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "creatorId"
                                        },
                                        {
                                            "concreteType": "History",
                                            "kind": "LinkedField",
                                            "name": "history",
                                            "plural": false,
                                            "selections": [
                                                v91 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "ContentProperties",
                                            "kind": "LinkedField",
                                            "name": "contentProperties",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "DraftContentProperties",
                                                    "kind": "LinkedField",
                                                    "name": "draft",
                                                    "plural": false,
                                                    "selections": v92 /*: any*/ 
                                                },
                                                v93 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "includeContentHeaderAccess",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v130 /*: any*/ 
                                }
                            ]
                        },
                        {
                            "condition": "useNewContentTopper",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v70 /*: any*/ ,
                                v71 /*: any*/ ,
                                v73 /*: any*/ ,
                                v74 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRestrictions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": v130 /*: any*/ 
                        },
                        {
                            "condition": "preloadLabels",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v78 /*: any*/ ,
                                    "concreteType": "PaginatedLabelList",
                                    "kind": "LinkedField",
                                    "name": "labels",
                                    "plural": false,
                                    "selections": [
                                        v79 /*: any*/ ,
                                        {
                                            "concreteType": "Label",
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                                v122 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v80 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v81 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "storageKey": "labels(orderBy:{\"direction\":\"ASCENDING\",\"sortField\":\"LABELLING_CREATIONDATE\"})"
                                }
                            ]
                        },
                        {
                            "condition": "includeReactions",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v82 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeAudioContent",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v84 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": v131 /*: any*/ 
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "ownedBy",
                                            "plural": false,
                                            "selections": v131 /*: any*/ 
                                        }
                                    ]
                                },
                                v88 /*: any*/ ,
                                v89 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRestrictionAncestors",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v90 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeClassification",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "ClassificationLevelDetails",
                                    "kind": "LinkedField",
                                    "name": "classificationLevelDetails",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "condition": "useClassificationLevelV2",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentDataClassificationLevel",
                                                    "kind": "LinkedField",
                                                    "name": "classificationLevel",
                                                    "plural": false,
                                                    "selections": v132 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "useClassificationLevelV2",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "ContentDataClassificationLevel",
                                                    "kind": "LinkedField",
                                                    "name": "classificationLevelV2",
                                                    "plural": false,
                                                    "selections": v132 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "featureEnabled"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "source"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isReclassificationPermitted"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "canManageSpaceSettings"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "classificationControlSetting"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "userOverrideSetting"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "includeAgentTrustReceiptData",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        v91 /*: any*/ ,
                                        v129 /*: any*/ 
                                    ]
                                },
                                v94 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "includeRendererAssetsMedia",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                v95 /*: any*/ 
                            ]
                        },
                        {
                            "condition": "isSSR",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToFormattedBody",
                                    "kind": "LinkedField",
                                    "name": "macroRenderedOutput",
                                    "plural": true,
                                    "selections": [
                                        v45 /*: any*/ ,
                                        {
                                            "concreteType": "FormattedBody",
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": false,
                                            "selections": [
                                                v42 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                {
                                                    "concreteType": "WebResourceDependencies",
                                                    "kind": "LinkedField",
                                                    "name": "webresource",
                                                    "plural": false,
                                                    "selections": v65 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        v96 /*: any*/ 
                    ]
                },
                {
                    "args": v97 /*: any*/ ,
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                        v33 /*: any*/ ,
                        v98 /*: any*/ ,
                        {
                            "concreteType": "LookAndFeel",
                            "kind": "LinkedField",
                            "name": "lookAndFeel",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "headings",
                                    "plural": true,
                                    "selections": v48 /*: any*/ 
                                },
                                {
                                    "concreteType": "ContentLookAndFeel",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContainerLookAndFeel",
                                            "kind": "LinkedField",
                                            "name": "header",
                                            "plural": false,
                                            "selections": [
                                                v99 /*: any*/ ,
                                                v107 /*: any*/ ,
                                                v108 /*: any*/ ,
                                                v106 /*: any*/ ,
                                                v100 /*: any*/ ,
                                                v101 /*: any*/ ,
                                                v105 /*: any*/ ,
                                                v102 /*: any*/ ,
                                                v104 /*: any*/ ,
                                                v103 /*: any*/ ,
                                                v111 /*: any*/ ,
                                                v110 /*: any*/ 
                                            ]
                                        },
                                        v109 /*: any*/ ,
                                        v112 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        v113 /*: any*/ ,
                        v114 /*: any*/ ,
                        v116 /*: any*/ 
                    ]
                },
                v117 /*: any*/ ,
                {
                    "condition": "includeRovoMentionIdentity",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v118 /*: any*/ ,
                            "concreteType": "AgentStudioAgentsConnection",
                            "kind": "LinkedField",
                            "name": "agentStudio_getAgents",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "AgentStudioAgentEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "AgentStudioAssistant",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v119 /*: any*/ ,
                                                v33 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeAutohighlights",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "concreteType": "KnowledgeDiscoveryQueryApi",
                            "kind": "LinkedField",
                            "name": "knowledgeDiscovery",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v120 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "keyPhrases",
                                    "plural": false,
                                    "selections": [
                                        v122 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "KnowledgeDiscoveryKeyPhrase",
                                                    "kind": "LinkedField",
                                                    "name": "nodes",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "keyPhrase"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "KnowledgeDiscoveryKeyPhraseConnection"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                }
                                            ],
                                            "type": "QueryError"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "condition": "includeExternalLabels",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": v121 /*: any*/ ,
                            "concreteType": "ConfluenceExternalLabel",
                            "kind": "LinkedField",
                            "name": "confluence_externalLabels",
                            "plural": true,
                            "selections": [
                                v33 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "kind"
                                },
                                v39 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "db9c8e8da31ba9b30f24fc5c1554a7dd",
            "id": "8d7748de22660109e27b6307d9ec4951f237651a6511f76db91b50a9219c0c41",
            "metadata": {},
            "name": "ContentUnifiedWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query ContentUnifiedWithSpaceKeyQuery($spaceKey:String!,$versionOverride:Int,$includeRovoMentionIdentity:Boolean=false,$cloudId:String=\"\",$isSSR:Boolean=false,$includeRendererAssetsMedia:Boolean=false,$includeRendererAssetsCustomChrome:Boolean=false,$useNewContentTopper:Boolean=false,$preloadLabels:Boolean=false,$agentSessionsPropertyKey:String=\"\",$fetchAgentSessionsMarker:Boolean=false,$includeAgentTrustReceiptData:Boolean=false,$includeBylineContributors:Boolean=false,$includeConnectionAncestors:Boolean=false,$includeAutomationDiscoveries:Boolean=false,$includeAudioContent:Boolean=false,$includeReactions:Boolean=false,$includeRestrictions:Boolean=false,$includeRestrictionAncestors:Boolean=false,$includeClassification:Boolean=false,$useClassificationLevelV2:Boolean=false,$includeContentHeader:Boolean=false,$includeSmartCreateFeedback:Boolean=false,$includeContentHeaderAccess:Boolean=false,$includeFabricEditorEligibility:Boolean=false,$useContentModeFragment:Boolean=false,$includeAutohighlights:Boolean=false,$autohighlightsEntityAri:String,$autohighlightsWorkspaceId:String,$includeExternalLabels:Boolean=false,$externalLabelsCloudId:ID=\"\",$externalLabelsAri:ID=\"\"){mediaConfiguration@include(if:$includeRendererAssetsMedia){clientId,fileStoreUrl},agentStudio_getAgents(cloudId:$cloudId,product:\"confluence\",first:1,input:{creatorTypes:[ROVO_CHAT]})@include(if:$includeRovoMentionIdentity)@optIn(to:\"AgentStudio\"){edges{node{identityAccountId,id}}},...preloadAutohighlightsQuery_query_deyB3@include(if:$includeAutohighlights),...useExternalLabels_query_2n00s0@include(if:$includeExternalLabels),spaceHomepage(spaceKey:$spaceKey,version:$versionOverride){...ViewPageCommentsPanelPermission_content,id,operations{operation,targetType},type,status,...ArchivedPageBannerV2Status_content,contentProperties{latest{contentMode},draft{contentMode}},...ContentModeFragmentProvider_content@include(if:$useContentModeFragment),contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value},...ContentTitleWithByLine_content_1jvjSB@include(if:$includeBylineContributors)\n    ...useTitleContentPropertiesForPublishedPage_content@include(if:$includeBylineContributors)\n    ...CoverPictureQuery_content@include(if:$includeBylineContributors),...MeetingNotesAutomationDiscoveryFragment_content@include(if:$includeAutomationDiscoveries),title,space{id,name,key,alias,type},subType,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when,confRev,when@include(if:$includeAgentTrustReceiptData)},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},...ContentHeader_content_1bw81T@include(if:$includeContentHeader),metadata{frontend{fabricEditorSupported,embedded,collabService,coverPictureWidth@include(if:$useNewContentTopper)},lastModifiedDate},id@include(if:$useNewContentTopper)\n    pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    pageTitleDraft:properties(key:\"page-title-property-draft\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}}\n    metadata@include(if:$useNewContentTopper){frontend{coverPictureWidth}}\n    coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"])@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},id@include(if:$includeRestrictions)\n    hasInheritedRestrictions@include(if:$includeRestrictions)\n    hasRestrictions@include(if:$includeRestrictions)\n    hasViewRestrictions@include(if:$includeRestrictions)\n    title@include(if:$includeRestrictions),...ViewPageLabelsContentFragment_content@include(if:$preloadLabels)\n    labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING})@include(if:$preloadLabels){count,nodes{id,label,name,prefix}},id@include(if:$includeReactions)\n    contentReactionsSummary@include(if:$includeReactions){reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}\n    ...ReactionsContentFragment_content@include(if:$includeReactions),id@include(if:$includeAudioContent)\n    title@include(if:$includeAudioContent)\n    subType@include(if:$includeAudioContent)\n    emoji:properties(key:\"emoji-title-published\")@include(if:$includeAudioContent){nodes{id,value}}\n    history@include(if:$includeAudioContent){createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}}\n    links@include(if:$includeAudioContent){webui,base}\n    audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"])@include(if:$includeAudioContent){nodes{value,key}}\n    ...AudioContentFragment_content@include(if:$includeAudioContent),id@include(if:$includeRestrictionAncestors)\n    ancestors@include(if:$includeRestrictionAncestors){id,title,hasRestrictions,links{webui}},...BylineClassification_content_4MZOe@include(if:$includeClassification),...PageContentRenderer_content,body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}},history@include(if:$includeAgentTrustReceiptData){createdDate,createdBy{__typename,displayName}}\n    contentProperties@include(if:$includeAgentTrustReceiptData){latest{generatedBy}},body@include(if:$includeRendererAssetsMedia){atlas_doc_format{mediaToken{token}}}\n    ...ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent@include(if:$includeRendererAssetsMedia),...ViewPageExtensionsAndRendererAssetsContentFragment_content@include(if:$isSSR),agentSessionsMarker:properties(key:$agentSessionsPropertyKey)@include(if:$fetchAgentSessionsMarker){nodes{id,key,value,version{number}}}},space(key:$spaceKey){id@include(if:$includeRendererAssetsCustomChrome)\n    settings@include(if:$includeRendererAssetsCustomChrome){customHeaderAndFooter{header{html,js,css,spaUnfriendlyMacros{name}},footer{html,js,css,spaUnfriendlyMacros{name}}}},...ContentHeader_space@include(if:$includeContentHeader),...ContentTitle_space,...PageContentRenderer_space,id,theme{themeKey,name},lookAndFeel{content{screen{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,layer{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,width,height},gutterTop,gutterRight,gutterBottom,gutterLeft},container{background,backgroundColor,backgroundImage,backgroundPosition,backgroundSize,backgroundRepeat,backgroundOrigin,backgroundClip,backgroundAttachment,backgroundBlendMode,padding,borderRadius}}},settings{routeOverrideEnabled},currentUser{isAnonymouslyAuthorized}}}fragment ArchivedPageBannerV2Status_content on Content{id,status}fragment AudioContentFragment_content on Content{id,title,subType,emoji:properties(key:\"emoji-title-published\"){nodes{id,value}},history{createdBy{__typename,displayName,profilePicture{path}},ownedBy{__typename,displayName,profilePicture{path}}},links{webui,base},audioProperties:properties(keys:[\"emoji-title-published\",\"editor\"]){nodes{value,key}}}fragment ByLine_content_1jvjSB on Content{...useReadTime_content,id,type,subType,history{createdDate,createdBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},ownedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},lastOwnedBy{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}}},version{by{__typename,type,displayName,...on KnownUser{accountId},profilePicture{path}},friendlyWhen,when,number,contentTypeModified},contentProperties{latest{generatedBy}},...RendererContentState_content,pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{coverPictureWidth@include(if:$useNewContentTopper)}},ancestors@include(if:$includeConnectionAncestors){id,title,type,subType,history{createdBy{__typename,displayName}},properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"]){nodes{id,key,value}}}}fragment BylineClassification_content_4MZOe on Content{id,title,type,status,operations{operation,targetType},space{id,name,key,alias},...useContentClassification_content_4MZOe}fragment ContentHeader_content_1bw81T on Content{id,type,subType,title,status,metadata{lastModifiedDate,frontend{fabricEditorSupported}},...useFabricEligibilityMigrationQuery_content@include(if:$includeFabricEditorEligibility),...SmartCreateFeedbackBanner_content@include(if:$includeSmartCreateFeedback),...ContentTypesHeader_content,...EditContentButton_content,...useShareAndRestrictButtonData_content@include(if:$includeContentHeaderAccess)}fragment ContentHeader_space on Space{id,theme{themeKey}}fragment ContentModeFragmentProvider_content on Content{id,contentProperties{latest{contentMode},draft{contentMode}}}fragment ContentTitleWithByLine_content_1jvjSB on Content{...ContentTitle_content_2SjeOj,...ByLine_content_1jvjSB,...ArchivedPageBannerV2Status_content,...MeetingNotesAutomationDiscoveryFragment_content}fragment ContentTitle_content_2SjeOj on Content{id,type,title,appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},emojiTitlePublished:properties(key:\"emoji-title-published\"){nodes{id,key,value,version{number}}},pageTitlePublished:properties(key:\"page-title-property-published\")@include(if:$useNewContentTopper){nodes{id,key,value,version{number}}},editorProperty:properties(key:\"editor\"){nodes{id,key,value}},metadata{frontend{fabricEditorSupported,coverPictureWidth@include(if:$useNewContentTopper)}},space{id,name,homepageId}}fragment ContentTitle_space on Space{id,theme{themeKey},lookAndFeel{headings{key,value},content{header{background,backgroundAttachment,backgroundBlendMode,backgroundClip,backgroundColor,backgroundImage,backgroundOrigin,backgroundPosition,backgroundRepeat,backgroundSize,borderRadius,padding}}}}fragment ContentTypesHeader_content on Content{id,title,operations{operation,targetType},space{id,name,key,alias},type,subType,status,smartFolderProperties:properties(keys:[\"smartFolderProperties\"]){nodes{key,value}},version{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when},draftVersion{contentTypeModified,number,friendlyWhen,by{__typename,displayName},when}}fragment CoverPictureQuery_content on Content{id,coverPictureProperties:properties(keys:[\"cover-picture-id-draft\",\"cover-picture-id-published\"]){nodes{id,key,value,version{number}}}}fragment EditContentButton_content on Content{id,type,operations{operation,targetType},metadata{frontend{fabricEditorSupported,embedded,collabService}},subType,space{id,key}}fragment MeetingNotesAutomationDiscoveryFragment_content on Content{id,title,body{dynamic{value}},metadata{sourceTemplateEntityId}}fragment PageContentRenderer_content on Content{id,title,type,status,version{confRev,number},metadata{lastModifiedDate},body{dynamic{representation,value,content{id,version{number}},webresource{superbatch{tags{js,css}},tags{js,css}}}},appearancePublished:properties(key:\"content-appearance-published\"){nodes{id,key,value,version{number}}},properties(keys:[\"cover-picture-id-published\",\"emoji-title-published\",\"editor\",\"import-source\",\"imported-page-modified-date\"]){nodes{id,key,value,version{number}}}}fragment PageContentRenderer_space on Space{id,theme{themeKey}}fragment ReactionsContentFragment_content on Content{id,contentReactionsSummary{reactionsCount,ari,containerAri,reactionsSummaryForEmoji{emojiId,count,reacted,id}}}fragment RendererContentState_content on Content{id,contentState(isDraft:false){id,name,color,restrictionLevel},contentStateLastUpdated(format:USER_FRIENDLY){value}}fragment SmartCreateFeedbackBanner_content on Content{title,id,type,creatorId,version{number},history{createdDate},contentProperties{draft{generatedBy},latest{generatedBy}}}fragment ViewPageCommentsPanelPermission_content on Content{id,operations{operation,targetType}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_content on Content{macroRenderedOutput{key,value{value,representation,webresource{tags{js,css}}}}}fragment ViewPageExtensionsAndRendererAssetsContentFragment_mediaContent on Content{id,body{atlas_doc_format{mediaToken{token}}}}fragment ViewPageLabelsContentFragment_content on Content{id,type,status,operations{operation,targetType},space{id},labels(orderBy:{sortField:LABELLING_CREATIONDATE,direction:ASCENDING}){count,nodes{__typename,id,label,name,prefix}}}fragment preloadAutohighlightsQuery_query_deyB3 on Query{knowledgeDiscovery{keyPhrases(entityAri:$autohighlightsEntityAri,workspaceId:$autohighlightsWorkspaceId)@optIn(to:\"KnowledgeDiscovery Get Key Phrases\"){__typename,...on KnowledgeDiscoveryKeyPhraseConnection{nodes{keyPhrase,category}},...on QueryError{message}}}}fragment useContentClassification_content_4MZOe on Content{id,classificationLevelDetails{classificationLevel@skip(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},classificationLevelV2@include(if:$useClassificationLevelV2){id,guideline,guidelineADF,description,color,name,status},featureEnabled,source,isReclassificationPermitted,canManageSpaceSettings,classificationControlSetting,userOverrideSetting}}fragment useExternalLabels_query_2n00s0 on Query{confluence_externalLabels(cloudId:$externalLabelsCloudId,id:$externalLabelsAri){id,kind,name}}fragment useFabricEligibilityMigrationQuery_content on Content{id,metadata{frontend{fabricEditorEligibility,contentHash}}}fragment useReadTime_content on Content{id,type,body{dynamic{value,representation}},operations{operation,targetType}}fragment useShareAndRestrictButtonData_content on Content{id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title}fragment useTitleContentPropertiesForPublishedPage_content on Content{id,pageTitlePublished:properties(key:\"page-title-property-published\"){nodes{id,key,value,version{number}}},pageTitleDraft:properties(key:\"page-title-property-draft\"){nodes{id,key,value,version{number}}},metadata{frontend{coverPictureWidth}}}"
        }
    };
}();
$aa72a6013de18737$var$node.hash = "b89fedb00bc4157b127083cb7f10e104";
var $aa72a6013de18737$export$2e2bcd8739ae039 = $aa72a6013de18737$var$node;


var $3qGQ7 = parcelRequire("3qGQ7");








var $2GGOW = parcelRequire("2GGOW");





var $fEmGS = parcelRequire("fEmGS");





var $hNtOj = parcelRequire("hNtOj");




/** A 403 on the root `space` field only nulls that field; the content still comes back. */ const $1acff4ea84553836$var$isSpaceScopedError = (error)=>error.path?.[0] === 'space';
const $1acff4ea84553836$var$isContentScopedError = (error)=>error.path?.[0] === 'content';
const $1acff4ea84553836$var$isPathlessError = (error)=>!error.path?.length;
/** Preserve page access when only known optional fields reject the viewer. */ function $1acff4ea84553836$var$filterContentFieldErrors(result, requestedContentId, resolvedContentId) {
    if (result.errors?.some((error)=>error.path?.[0] === 'agentStudio_getAgents') && (0, $6mKj3.expValEquals)('platform_editor_mention_rovo', 'isEnabled', true)) {
        // An optional identity lookup must not prevent the content from rendering.
        const errors = result.errors.filter((error)=>{
            if (error.path?.[0] !== 'agentStudio_getAgents') return true;
            (0, $3mugH.ssrPrepareErrorsClient).submitError(error, {
                attribution: 'rovo-mention-identity',
                path: error.path,
                extensions: error.extensions
            });
            (0, $7Sm4c.markErrorAsHandled)(error);
            return false;
        });
        result = {
            ...result,
            errors: errors,
            hasErrors: errors.length > 0
        };
    }
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (result.errors?.length && (0, $9wGTI.fg)('confluence_shared_content_permission_errors')) {
        const errors = result.errors.filter((error)=>{
            if ((0, $hpnxK.isContentAutohighlightsError)(error, requestedContentId, resolvedContentId)) {
                if (!(0, $7Z6Kn.isExpectedAutohighlightsError)(error)) // Preserve visibility of the optional failure without failing the page preload.
                (0, $3mugH.ssrPrepareErrorsClient).submitError(error, {
                    attribution: 'autohighlights',
                    path: error.path,
                    extensions: error.extensions
                });
                (0, $7Sm4c.markErrorAsHandled)(error);
                return false;
            }
            if ((0, $hpnxK.classifyContentPermissionError)(error, requestedContentId, resolvedContentId) === 'optional-permission') {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return false;
            }
            return true;
        });
        return {
            ...result,
            errors: errors,
            hasErrors: errors.length > 0
        };
    }
    if (!requestedContentId || requestedContentId !== resolvedContentId || !result.errors?.length || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) return result;
    const errors = result.errors.filter((error)=>{
        if ((0, $hpnxK.isUnsupportedCustomerAccountFieldError)(error)) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            return false;
        }
        return true;
    });
    return {
        ...result,
        errors: errors,
        hasErrors: errors.length > 0
    };
}
function $1acff4ea84553836$var$processContentPreloadPermissionError(result, isAccessLinkRoute) {
    result?.errors?.forEach((error)=>{
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('confluence_shared_content_permission_errors')) {
            // Optional failures have already been filtered with the requested content identity.
            const scope = (0, $hpnxK.classifyContentPermissionError)(error, undefined, undefined);
            if ((scope === 'content-permission' || scope === 'unscoped-permission') && !(isAccessLinkRoute && $1acff4ea84553836$var$isSpaceScopedError(error))) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('view', error);
            return;
        }
        // The "Cannot find space" condition is handled by redirecting to the correct space
        // even if error is not propagated to ContentPrerequisites where it is normally handled.
        if ((0, $2GGOW.isUnauthorizedError)(error)) {
            // An access-link viewer has no space membership by design, so a space-scoped 403 must
            // not blank a page whose content resolved.
            if (isAccessLinkRoute && $1acff4ea84553836$var$isSpaceScopedError(error)) return;
            if ($1acff4ea84553836$var$isContentScopedError(error) || $1acff4ea84553836$var$isPathlessError(error)) (0, $hNtOj.ssrPermissionsErrorHandler).markSSRPreloadPermissionError('view', error);
        }
    });
}
const $1acff4ea84553836$export$dba3e11e87da376f = (data)=>({
        content: data?.spaceHomepage ? {
            nodes: [
                data?.spaceHomepage
            ],
            // @ts-ignore
            __typename: 'PaginatedContentListWithChild'
        } : null,
        space: data?.space || null
    });
function $1acff4ea84553836$export$97ce9ab4bdd6b3fc({ contentId: contentId, spaceKey: spaceKey, isBlog: isBlog, versionOverride: versionOverride = null, userId: userId, cloudId: cloudId, agentSessionsEnabled: agentSessionsEnabled = false, autohighlightsQueryVariables: autohighlightsQueryVariables, externalLabelsQueryVariables: externalLabelsQueryVariables, rovoActivationQueryVariables: rovoActivationQueryVariables, includeRendererAssetsDsp: includeRendererAssetsDsp = false, rendererAssetsDspAction: rendererAssetsDspAction, hasDocumentContractAnalyticsByline: hasDocumentContractAnalyticsByline = false, hasDocumentContractContentHeader: hasDocumentContractContentHeader = false, includeRendererAssetsMedia: includeRendererAssetsMedia = false, includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome = false, isAccessLinkRoute: isAccessLinkRoute = false, hasAnalyticsBylineGateReason: hasAnalyticsBylineGateReason = false }) {
    window.performance.mark('CFP-63.preloadContent.start');
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const shouldUseContentHeaderFragment = hasDocumentContractContentHeader && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_header_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseFabricEligibilityFragment = shouldUseContentHeaderFragment && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_fabric_eligibility_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    // Space overview
    if (spaceKey && !contentId) // Keep includeBylineContributors disabled for both this fetch and the cache write below.
    // The homepage ID is not known yet, so the space-key query has no root contentContributors
    // field. Enabling it on the page-query write would require data this preload cannot supply.
    return (0, $dYU3e.query)({
        query: (0, $aa72a6013de18737$export$2e2bcd8739ae039),
        variables: {
            ...(0, $3qGQ7.createContentUnifiedWithSpaceKeyQueryVariables)({
                userId: userId,
                cloudId: cloudId,
                spaceKey: spaceKey,
                versionOverride: versionOverride,
                isSSR: isSSR,
                includeRendererAssetsMedia: includeRendererAssetsMedia,
                includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome,
                agentSessionsUserId: agentSessionsEnabled ? userId : undefined,
                // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
                includeConnectionAncestors: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment'),
                includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                autohighlightsQueryVariables: autohighlightsQueryVariables
            }),
            ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
                useContentModeFragment: true
            } : {}
        },
        errorPolicy: 'all',
        __callerPackage__: "content-body"
    }).then((result)=>{
        // Record the end mark and timestamp to track *both* duration of preloading
        // and timestamp of the moment when preloading finished
        window.performance.mark('CFP-63.preloadContent.end');
        window.performance.mark('CFP-63.preloadContentEnd');
        const data = result?.data;
        const homepageId = data?.spaceHomepage?.id;
        result = $1acff4ea84553836$var$filterContentFieldErrors(result, homepageId, homepageId);
        if (homepageId) {
            // update result with transformed data
            result.data = $1acff4ea84553836$export$dba3e11e87da376f(data);
            (0, $fEmGS.writeQueryInterop)({
                query: (0, $jgc4t.default),
                variables: {
                    ...(0, $3qGQ7.createContentUnifiedQueryVariables)({
                        userId: userId,
                        cloudId: cloudId,
                        contentId: homepageId,
                        spaceKey: spaceKey,
                        versionOverride: versionOverride,
                        isSSR: isSSR,
                        includeRendererAssetsMedia: includeRendererAssetsMedia,
                        includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome,
                        agentSessionsUserId: agentSessionsEnabled ? userId : undefined,
                        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
                        includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
                        includeConnectionAncestors: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment'),
                        includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                        includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                        includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                        includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
                        autohighlightsQueryVariables: autohighlightsQueryVariables
                    }),
                    ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
                        useContentModeFragment: true
                    } : {}
                },
                data: {
                    ...result.data
                },
                __callerPackage__: "content-body"
            });
        }
        $1acff4ea84553836$var$processContentPreloadPermissionError(result, isAccessLinkRoute);
        return {
            result: result,
            hasErrors: result?.hasErrors
        };
    });
    const chooseContentUnifiedQuery = isBlog ? (0, $f9opb.default) : (0, $jgc4t.default);
    const queryVariables = isBlog ? {
        ...(0, $3qGQ7.createContentBlogUnifiedQueryVariables)({
            userId: userId,
            cloudId: cloudId,
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            includeRendererAssetsMedia: includeRendererAssetsMedia,
            includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome,
            preloadLabels: isSSR,
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
            includeBylineContributors: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            includeAutomationDiscoveries: (0, $9wGTI.fg)('cc_automations_discovery_nudges'),
            includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeAnalyticsByline: hasDocumentContractAnalyticsByline && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_analytics_byline_frag_reader') && !hasAnalyticsBylineGateReason && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeContentHeader: shouldUseContentHeaderFragment,
            includeSmartCreateFeedback: shouldUseContentHeaderFragment && !versionOverride && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_smart_create_banner_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeContentHeaderAccess: shouldUseContentHeaderFragment && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeFabricEditorEligibility: shouldUseFabricEligibilityFragment,
            includeContentHeaderPublicLink: shouldUseContentHeaderFragment && !isBlog && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeRendererAssetsDsp: // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeRendererAssetsDsp,
            rendererAssetsDspAction: rendererAssetsDspAction,
            autohighlightsQueryVariables: autohighlightsQueryVariables
        }),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
            useContentModeFragment: true
        } : {}
    } : {
        ...(0, $3qGQ7.createContentUnifiedQueryVariables)({
            userId: userId,
            cloudId: cloudId,
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: versionOverride,
            isSSR: isSSR,
            includeRendererAssetsMedia: includeRendererAssetsMedia,
            includeRendererAssetsCustomChrome: includeRendererAssetsCustomChrome,
            preloadLabels: isSSR,
            agentSessionsUserId: agentSessionsEnabled ? userId : undefined,
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            includeAgentTrustReceiptData: (0, $9wGTI.fg)('cc_sparks_agent_trust_receipt'),
            includeBylineContributors: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeConnectionAncestors: (0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment'),
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            includeAutomationDiscoveries: (0, $9wGTI.fg)('cc_automations_discovery_nudges'),
            includeMetadata: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeClassification: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_classification_context_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeReactions: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeAudioContent: !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeAnalyticsByline: hasDocumentContractAnalyticsByline && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_analytics_byline_frag_reader') && !hasAnalyticsBylineGateReason && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeContentHeader: shouldUseContentHeaderFragment,
            includeSmartCreateFeedback: shouldUseContentHeaderFragment && !versionOverride && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_smart_create_banner_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeContentHeaderAccess: shouldUseContentHeaderFragment && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeFabricEditorEligibility: shouldUseFabricEligibilityFragment,
            includeContentHeaderPublicLink: shouldUseContentHeaderFragment && !isBlog && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false),
            includeRendererAssetsDsp: // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            includeRendererAssetsDsp,
            rendererAssetsDspAction: rendererAssetsDspAction,
            autohighlightsQueryVariables: autohighlightsQueryVariables,
            externalLabelsQueryVariables: // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            externalLabelsQueryVariables,
            rovoActivationQueryVariables: // @ts-ignore -- Downstream packages are checked against the last generated content-unified-query declaration.
            rovoActivationQueryVariables
        }),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? {
            useContentModeFragment: true
        } : {}
    };
    return (0, $dYU3e.query)({
        query: chooseContentUnifiedQuery,
        variables: queryVariables,
        errorPolicy: 'all',
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr -- This controls request-scoped cache retention, not rendered output.
        ...(0, $6mKj3.expVal)('confluence_relay_vp_preload_retention', 'isEnabled', false) ? {
            relayQueryPreloadRetention: 'environment'
        } : {},
        __callerPackage__: "content-body"
    }).then((result)=>{
        // Record the end mark and timestamp to track *both* duration of preloading
        // and timestamp of the moment when preloading finished
        window.performance.mark('CFP-63.preloadContent.end');
        window.performance.mark('CFP-63.preloadContentEnd');
        result = $1acff4ea84553836$var$filterContentFieldErrors(result, contentId, result?.data?.content?.nodes?.[0]?.id);
        if ((0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) && (0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) {
            // The document route can omit ContentTypesHeaderQuery, including its restriction
            // classification side effect. Short links obfuscate the URL's space key, so use
            // the content-scoped error to retain the real denial reason before rendering.
            const isSpaceRestricted = result?.errors?.some((error)=>$1acff4ea84553836$var$isContentScopedError(error) && error.message?.includes('Space is restricted'));
            window['__SPACE_RESTRICTED_ERROR__'] = isSpaceRestricted ? contentId : null;
        }
        $1acff4ea84553836$var$processContentPreloadPermissionError(result, isAccessLinkRoute);
        return {
            result: result,
            hasErrors: result?.hasErrors
        };
    });
}



var $furnK = parcelRequire("furnK");


var $9L8Ms = parcelRequire("9L8Ms");


var $lcQ5b = parcelRequire("lcQ5b");





var $b2p4s = parcelRequire("b2p4s");

const $6dc053709e1de01d$export$4a518872c59a5d22 = ({ contentId: contentId, draftShareId: draftShareId })=>{
    return (0, $dYU3e.query)({
        query: (0, $b2p4s.default),
        variables: {
            contentId: contentId,
            draftShareId: draftShareId,
            status: [
                'draft'
            ]
        },
        __callerPackage__: "content-prerequisites"
    });
};


/**
 * @generated SignedSource<<885a27c54d7500501eef4e04e6ba3fb2>>
 * @relayHash 12f44a09d0c20a1af0e3999bad35cb1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 497edb9e81fd65ef7a41b7536d40bfbb59a6d6907f2d3365cfe1404fd4030fcf
const $034d91236594c738$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "smartLinksFromDraft"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        }
    ], v2 = [
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "ScalarField",
                    "name": "url"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "kind": "ScalarField",
                    "name": "emojiTitle"
                },
                {
                    "kind": "ScalarField",
                    "name": "canView"
                },
                {
                    "kind": "ScalarField",
                    "name": "product"
                },
                {
                    "kind": "ScalarField",
                    "name": "resourceType"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "iconUrl"
                },
                {
                    "kind": "ScalarField",
                    "name": "resolved"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusText"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusAppearance"
                }
            ]
        }
    ], v3 = [
        {
            "condition": "smartLinksFromDraft",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSmartLinkList",
                    "kind": "LinkedField",
                    "name": "contentSmartLinks",
                    "plural": false,
                    "selections": v2 /*: any*/ 
                }
            ]
        },
        {
            "condition": "smartLinksFromDraft",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedSmartLinkList",
                    "kind": "LinkedField",
                    "name": "confluence_contentSmartLinksForDraft",
                    "plural": false,
                    "selections": v2 /*: any*/ 
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "12f44a09d0c20a1af0e3999bad35cb1b",
            "id": "497edb9e81fd65ef7a41b7536d40bfbb59a6d6907f2d3365cfe1404fd4030fcf",
            "metadata": {},
            "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
            "operationKind": "query",
            "text": "query preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery($contentId:ID!,$smartLinksFromDraft:Boolean=false){contentSmartLinks(id:$contentId)@skip(if:$smartLinksFromDraft){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved,statusText,statusAppearance}},confluence_contentSmartLinksForDraft(id:$contentId)@include(if:$smartLinksFromDraft){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved,statusText,statusAppearance}}}"
        }
    };
}();
$034d91236594c738$var$node.hash = "0f70fb226e9d3bbec8e2c784f91a3086";
var $034d91236594c738$export$2e2bcd8739ae039 = $034d91236594c738$var$node;









var $8tmcF = parcelRequire("8tmcF");

















var $jhATi = parcelRequire("jhATi");


var $hR977 = parcelRequire("hR977");

const $7da0fb3e82be6868$export$c5bb6d638f1fa69c = (node)=>{
    return node?.['__typename'] === 'InlineSmartLink';
};
const $7da0fb3e82be6868$var$parseSmartlinksResponse = (res, isDraft)=>{
    if (isDraft) return res?.data?.confluence_contentSmartLinksForDraft?.nodes || [];
    return res?.data?.contentSmartLinks?.nodes || [];
};
const $7da0fb3e82be6868$export$7df91b88e675cedb = (res, isDraft = false)=>{
    const content = $7da0fb3e82be6868$var$parseSmartlinksResponse(res, isDraft);
    // filter to only inline smartlins and limit to the max number of smartlinks allowed per call by ORS
    const inputSmartLinks = content.filter($7da0fb3e82be6868$export$c5bb6d638f1fa69c).slice(0, 50);
    return inputSmartLinks.filter((node)=>!!node).map((node)=>{
        return {
            appearance: 'inline',
            resourceUrl: node?.url,
            title: node?.title,
            emojiTitle: node?.emojiTitle,
            canView: node?.canView,
            product: node?.product,
            resourceType: node?.resourceType,
            subType: node?.subType,
            iconUrl: node?.iconUrl,
            resolved: node?.resolved,
            statusText: node?.statusText,
            statusAppearance: node?.statusAppearance
        };
    });
};



var $3y0Sn = parcelRequire("3y0Sn");



var $cS4kb = parcelRequire("cS4kb");

const $9eb88ac593a96a41$export$92162a33dbbd338d = 250;
const $9eb88ac593a96a41$export$5fc2ebe451bbe5aa = 350;
const $9eb88ac593a96a41$export$83d9e8edcbcda504 = 1;
const $9eb88ac593a96a41$export$c048e241ec0ff835 = 50;
const $9eb88ac593a96a41$export$604acd6b31b9e629 = (0, $034d91236594c738$export$2e2bcd8739ae039);
const $9eb88ac593a96a41$var$getContentSmartLinksORSMeasureName = ()=>{
    const queryBoundary = (0, $g277M.getQueryBoundary)();
    if (!queryBoundary || queryBoundary === 'default') return 'ssr-app/prepare/preloadQuery/fetch:contentSmartLinksORS';
    return `ssr-app/prepare/preloadQuery/dataFetcher:${queryBoundary}/fetch:contentSmartLinksORS`;
};
const $9eb88ac593a96a41$export$3b6cf89022ccdd35 = async (contentId, isDraft = false)=>{
    const smartLinksRes = await (0, $dYU3e.query)({
        query: (0, $034d91236594c738$export$2e2bcd8739ae039),
        variables: {
            contentId: contentId,
            smartLinksFromDraft: isDraft
        },
        __callerPackage__: "content-smartlinks"
    });
    return (0, $7da0fb3e82be6868$export$7df91b88e675cedb)(smartLinksRes, isDraft);
};
const $9eb88ac593a96a41$export$d966f1e92068ec2e = (orsCalls, smartLinks, resolvedSmartLinks, fetchTimeout)=>{
    const resolvedLinks = resolvedSmartLinks.reduce((acc, { status: status, body: body })=>{
        if (status === 504) acc[body?.data?.url] = 'timeout';
        if (status === 200) acc[body?.data?.url] = 'resolved';
        return acc;
    }, {});
    return {
        fetch: orsCalls.length,
        fetchTimeout: fetchTimeout,
        links: smartLinks.reduce((acc, { resourceUrl: resourceUrl, appearance: appearance, product: product })=>{
            const linkType = product || (0, $cS4kb.getLinkType)(resourceUrl);
            if (!acc?.[linkType]?.[appearance]) acc[linkType] = {
                [appearance]: {
                    total: 0,
                    timeout: 0,
                    resolved: 0
                }
            };
            acc[linkType][appearance].total++;
            if (resolvedLinks[resourceUrl]) {
                if (resolvedLinks[resourceUrl] === 'timeout') acc[linkType][appearance].timeout++;
                if (resolvedLinks[resourceUrl] === 'resolved') acc[linkType][appearance].resolved++;
            }
            return acc;
        }, {})
    };
};
async function $9eb88ac593a96a41$export$6ef3ef384e337a5(links, timeout, batchTimeout, fetchTimeout, shouldSkipTimeGuard) {
    if (links.length === 0) return [];
    const { customURLs: customURLs, userContext: userContext } = (0, $60cDW.getSSRRenderInputs)();
    const objectResolverURL = (0, $d6NtA.isLocal)() ? '/gateway/api/object-resolver/resolve/batch' : customURLs?.['object-resolver-service'];
    const firstLink = links[0].resourceUrl;
    const type = (0, $cS4kb.getLinkType)(firstLink);
    const task = async ()=>{
        try {
            // ORS only expects resourceURL and appearance, otherwise it throws a 400 for any unrecognized fields
            // GQL can return any number of fields (title, emoji, resolved state, etc) but ORS should only accept
            // resourceURL and appearance
            const sanitizedLinksForORS = links.map(({ resourceUrl: resourceUrl, appearance: appearance })=>({
                    resourceUrl: resourceUrl,
                    appearance: appearance
                }));
            const res = await (0, $jhATi.fetchORSForSSR)({
                // Despite the API has a timeout it does not respect it. It can easily go over time.
                url: `${objectResolverURL}?timeout=${timeout}`,
                body: JSON.stringify(sanitizedLinksForORS),
                userContext: userContext
            });
            if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
            return res.json();
        } catch (e) {
            (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error(`Smart link content ORS call failed: ${e.message}`));
        }
        return [];
    };
    if (shouldSkipTimeGuard) return task();
    return (0, $8tmcF.timeGuard)(task, ()=>{
        fetchTimeout[type] = fetchTimeout[type] || 0;
        fetchTimeout[type]++;
        return [];
    }, batchTimeout);
}
const $9eb88ac593a96a41$export$dc2d6742e80fba3c = async (contentId, isDraft = false)=>{
    const smartLinks = await $9eb88ac593a96a41$export$3b6cf89022ccdd35(contentId, isDraft);
    if (!smartLinks?.length) return;
    // How long a single ORS resolution can take
    const timeout = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_max_time', $9eb88ac593a96a41$export$92162a33dbbd338d);
    // How long a batch of ORS resolution can take
    const batchTimeout = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_batch_max_time', $9eb88ac593a96a41$export$5fc2ebe451bbe5aa);
    // How many links should be packed in a batch
    const min = (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_min_batch_count', $9eb88ac593a96a41$export$83d9e8edcbcda504);
    const max = Math.max(min, (0, $1xpoY.default).getNumber('confluence_ssr_content_smart_link_max_batch_count', $9eb88ac593a96a41$export$c048e241ec0ff835));
    const { resolvedFromGql: resolvedFromGql, linksForORS: linksForORS } = (0, $3y0Sn.partitionResolvedLinks)(smartLinks);
    // format resolved links to match that of getInitialState
    const gqlResolvedState = (0, $3y0Sn.buildResolvedSmartLinkState)(resolvedFromGql);
    const gqlStats = {
        totalLinks: smartLinks.length,
        resolvedFromGqlCount: resolvedFromGql?.length,
        resolvedJiraFromGqlCount: resolvedFromGql?.filter((link)=>link.product === 'jira').length,
        linksForORSCount: linksForORS?.length,
        skippedORS: linksForORS?.length === 0
    };
    const orsCalls = [];
    const fetchTimeout = {};
    let resolvedSmartLinks = [];
    if (linksForORS.length > 0) await (0, $9WAeG.SSRMeasures).run($9eb88ac593a96a41$var$getContentSmartLinksORSMeasureName(), async ()=>{
        let smartLinksBatches = (0, $cS4kb.groupSmartLinksByHostname)(linksForORS);
        smartLinksBatches = (0, $cS4kb.mergeSmallThirdPartyBatches)(smartLinksBatches, min);
        smartLinksBatches = (0, $cS4kb.splitLinksIntoBatches)(smartLinksBatches, max);
        for (const smartLinksBatch of smartLinksBatches)orsCalls.push($9eb88ac593a96a41$export$6ef3ef384e337a5(smartLinksBatch, timeout, batchTimeout, fetchTimeout));
        // eslint-disable-next-line check-preloaders/no-promise-all
        resolvedSmartLinks = (await Promise.all(orsCalls)).flat();
    });
    const titles = {};
    for (const link of linksForORS)if (link.title) titles[link.resourceUrl] = link.title;
    if (Object.keys(titles).length > 0) window['__SSR_SMARTLINKS_TITLES__'] = titles;
    // Format response to fit SmartCard Provider storeOptions initial state
    // Save correctly formatted response to window obj so it can be used on SSR and SPA (no duplicate calls)
    // Merge GraphQL-resolved state with ORS-resolved state
    window['__SSR_SMARTLINKS__'] = {
        ...gqlResolvedState,
        ...(0, $hR977.getInitialState)(resolvedSmartLinks)
    };
    window['__SSR_SMARTLINKS_STATS__'] = {
        ...$9eb88ac593a96a41$export$d966f1e92068ec2e(orsCalls, smartLinks, resolvedSmartLinks, fetchTimeout),
        gql: gqlStats
    };
};



var $4zhNK = parcelRequire("4zhNK");


var $fyUox = parcelRequire("fyUox");


var $gKMkU = parcelRequire("gKMkU");


var $hu6Tz = parcelRequire("hu6Tz");


var $iV8Fk = parcelRequire("iV8Fk");





var $ld6xp = parcelRequire("ld6xp");


var $dOBRD = parcelRequire("dOBRD");


var $llqlc = parcelRequire("llqlc");


var $2y2x3 = parcelRequire("2y2x3");


var $2K3wo = parcelRequire("2K3wo");


var $4XbfY = parcelRequire("4XbfY");


var $hSTGC = parcelRequire("hSTGC");





var $8pcS0 = parcelRequire("8pcS0");





var $6mEZ3 = parcelRequire("6mEZ3");








var $92uc5 = parcelRequire("92uc5");


var $8mIlz = parcelRequire("8mIlz");


var $6Cce7 = parcelRequire("6Cce7");










const $cd2d56ef117b2819$export$e87714e2a0c200ee = 8;
const $cd2d56ef117b2819$export$717eaf20c85e91ca = 'confluence-extensions-server-render-blocklist';


// Instead of gating the static constant, we will filter out Calendars here unless the flag is enabled
const $64a1b8a95751bd5c$var$knownExtensionSet = new Set((0, $8pcS0.serverRenderedExtensions).filter((ext)=>ext !== (0, $8pcS0.EXTENSION_KEY).TEAM_CALENDARS || (0, $6mKj3.expValEquals)('cc-engagement-team-calendar-macro-afm-migration', 'isEnabled', true)));
const $64a1b8a95751bd5c$var$getMacroId = (node)=>node.attrs?.parameters?.macroMetadata?.macroId?.value;
const $64a1b8a95751bd5c$var$extractExtensions = (adf)=>(0, $llqlc.filter)(adf, (node)=>(0, $8pcS0.supportedExtensions).has(node.type));
// Excerpt Include's resolved ADF is serialized in macroOutput, outside the host ADF traversal.
// Only preload bodyless Children nodes with an explicit source page; do not follow references.
const $64a1b8a95751bd5c$var$getIncludedChildren = (extensions, contentId, limit)=>{
    const children = [];
    const seen = new Set();
    for (const extension of extensions){
        if (extension.attrs?.extensionType !== (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE || extension.attrs?.extensionKey !== (0, $8pcS0.EXTENSION_KEY).EXCERPT_INCLUDE) continue;
        const output = extension.attrs?.parameters?.macroOutput;
        if (typeof output !== 'string') continue;
        try {
            const document = JSON.parse(output);
            if (document?.type !== 'doc' || document.version !== 1 || !Array.isArray(document.content)) continue;
            for (const node of $64a1b8a95751bd5c$var$extractExtensions(document)){
                const parentId = node.attrs?.parameters?.macroParams?._parentId?.value;
                if (node.type !== 'extension' || node.attrs?.extensionType !== (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE || node.attrs?.extensionKey !== (0, $8pcS0.EXTENSION_KEY).CHILDREN || typeof parentId !== 'string' || !parentId || parentId === contentId || !$64a1b8a95751bd5c$var$getMacroId(node) || node.attrs?.parameters?.macroOutput) continue;
                const key = JSON.stringify(node);
                if (!seen.has(key)) {
                    seen.add(key);
                    children.push(node);
                    if (children.length === limit) return children;
                }
            }
        } catch  {
        // Invalid/legacy HTML output keeps the existing client fallback.
        }
    }
    return children;
};
const $64a1b8a95751bd5c$var$augmentWithMarks = (marks)=>{
    if (!marks?.length) return {};
    const fragments = marks.filter((mark)=>mark.type === 'fragment');
    if (fragments.length) return {
        fragmentLocalId: fragments[0].attrs.localId
    };
    return {};
};
const $64a1b8a95751bd5c$var$blocklistCache = new Map();
const $64a1b8a95751bd5c$export$80c99e8065c92427 = ()=>$64a1b8a95751bd5c$var$blocklistCache.clear();
const $64a1b8a95751bd5c$var$isBlocklisted = (blocklist, extensionKey)=>{
    if (blocklist.length === 0) return false;
    if ($64a1b8a95751bd5c$var$blocklistCache.has(extensionKey)) return $64a1b8a95751bd5c$var$blocklistCache.get(extensionKey);
    const isBlocked = blocklist.length > 0 && blocklist.some((block)=>{
        try {
            const blockRegex = new RegExp(block, 'ig');
            return blockRegex.test(extensionKey);
        } catch  {
            // Malformed regex/input, consider extension being not blocked
            return false;
        }
    });
    $64a1b8a95751bd5c$var$blocklistCache.set(extensionKey, isBlocked);
    return isBlocked;
};
// The rule of excluding extensions from querying in the prepare phase of SSR are the following:
//  - extension should be located at the top of the page, assuming extensions returned by the
//    adf-utils/filter are in the order from top to down of the page;
//  - extension should be common/legacy, i.e. of type "com.atlassian.confluence.macro.core";
//  - extension should not be a part of those we have a special handling in SPA (excepting children macro);
//  - extensions shouldn't have an output in a content query.
const $64a1b8a95751bd5c$var$byExcluded = (excludeExtensionIdSet, numberOfExtensionsToSSR = 0)=>(node, index)=>{
        const { parameters: parameters, extensionKey: extensionKey, extensionType: extensionType } = node.attrs || {};
        return index < numberOfExtensionsToSSR && extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE && (!$64a1b8a95751bd5c$var$knownExtensionSet.has(extensionKey) || extensionKey === 'children') && !parameters.macroOutput && !excludeExtensionIdSet.has($64a1b8a95751bd5c$var$getMacroId(node));
    };
const $64a1b8a95751bd5c$var$getSchema = (0, $dOBRD.default)(()=>(0, $4XbfY.getSchemaBasedOnStage)((0, $2y2x3.ADFStages).STAGE_0));
const $64a1b8a95751bd5c$var$createMacroQueryParamsProvider = (documentADF)=>{
    // This code (both `getRendererDocument` and `getRendererNodeContent`) inspired by `renderDocument`
    // function in `platform/packages/editor/renderer/src/render-document.ts`
    // Here we convert the `content` of our adf node to renderer/editor/ProseMirror node,
    // which ensures `content` in preloader and in SSR render would match and would not cause apollo cache mismatch.
    const getRendererDocument = (0, $dOBRD.default)(()=>{
        const schema = $64a1b8a95751bd5c$var$getSchema();
        const validDocumentADF = (0, $2K3wo.validateADFEntity)(schema, documentADF);
        const pnDoc = schema.nodeFromJSON(validDocumentADF);
        return {
            version: 1,
            type: 'doc',
            content: pnDoc.content.toJSON()
        };
    });
    const getRendererNodeContent = (macroId)=>{
        const rendererDocument = getRendererDocument();
        const [rendererNode] = (0, $llqlc.filter)(rendererDocument, (n)=>$64a1b8a95751bd5c$var$getMacroId(n) === macroId);
        return rendererNode.content || [];
    };
    return (node)=>{
        const requestADF = (0, $6mEZ3.extensionToADF)(node);
        requestADF.attrs = {
            ...requestADF.attrs,
            ...$64a1b8a95751bd5c$var$augmentWithMarks(node.marks)
        };
        if (requestADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) requestADF.content = getRendererNodeContent($64a1b8a95751bd5c$var$getMacroId(node));
        delete requestADF.attrs.layout;
        return {
            ...requestADF,
            type: node.type
        };
    };
};
const $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionKeys, extensionsBlocklist)=>{
    if (renderOnlyExtensionKeys?.length === 0 && !(0, $6mKj3.expValEquals)('cc_excerpt_nested_renderer_cls', 'isEnabled', true)) return {};
    // NOTE: prealod is not a type. It was created with a typo https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/confluence_frontend_prealod_macro_timeout
    const macroTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_prealod_macro_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const blocklistedExtensions = extensionsBlocklist.split(',').map((extensionName)=>extensionName.trim()).filter(Boolean);
    // Catch error if contentNodes is empty
    if (!contentNodes || !contentNodes[0]) return {
        general: 'contentNodesEmpty'
    };
    // Leave early when there's TinyMCE or borked content
    if (contentNodes[0].body.dynamic?.representation !== 'atlas_doc_format') return {};
    // Exclude extensions that are included into the content response as we don't need
    // to load any data for these extensions.
    const excludeExtensionIdSet = new Set((contentNodes[0].macroRenderedOutput || []).map((ext)=>ext.key));
    // While contentNodes[0].body.dynamic.value should be defined in all valid cases,
    // and should it not, the experience for the user will be broken anyway, we want
    // to swallow the parse failure, skip macros preloading and let SPA handle the case,
    // as SPA already have proper experience tracking.
    const documentADF = (0, $c9US3.parseContentNodesAdf)(contentNodes);
    if (!documentADF) return;
    const candidateExtensions = (0, $hSTGC.collectExtensionNodes)(documentADF).filter((node)=>(0, $8pcS0.supportedExtensions).has(node.type));
    const toMacroQueryParams = $64a1b8a95751bd5c$var$createMacroQueryParamsProvider(documentADF);
    const preloadLimit = numberOfExtensionsToSSR || (0, $cd2d56ef117b2819$export$e87714e2a0c200ee);
    const selectedExtensions = candidateExtensions.filter($64a1b8a95751bd5c$var$byExcluded(excludeExtensionIdSet, preloadLimit));
    let includedChildren = [];
    if (selectedExtensions.length < preloadLimit && candidateExtensions.some((node)=>node.attrs?.extensionType === (0, $8pcS0.EXTENSION_TYPE).MACRO_CORE && node.attrs?.extensionKey === (0, $8pcS0.EXTENSION_KEY).EXCERPT_INCLUDE && typeof node.attrs?.parameters?.macroOutput === 'string') && (0, $6mKj3.expValEquals)('cc_excerpt_nested_renderer_cls', 'isEnabled', true)) // Keep existing host preloads first and share their request budget and timeout.
    includedChildren = $64a1b8a95751bd5c$var$getIncludedChildren(candidateExtensions.slice(0, preloadLimit), contentId, preloadLimit - selectedExtensions.length);
    const extensions = selectedExtensions.filter((node)=>!renderOnlyExtensionKeys || renderOnlyExtensionKeys.includes(node?.attrs?.extensionKey)).map((node)=>({
            adf: toMacroQueryParams(node),
            contentId: contentId
        }));
    // Included Children are absent from the host batch, even when Children normally
    // uses batching. Match the client's individual query against the source page.
    extensions.push(...includedChildren.map((node)=>({
            adf: toMacroQueryParams(node),
            contentId: node.attrs?.parameters.macroParams._parentId.value
        })));
    if (numberOfExtensionsToSSR === 0) return extensions.length === 0 ? {} : undefined;
    // eslint-disable-next-line check-preloaders/no-promise-all
    const preloadResult = await Promise.all(extensions.map(async ({ adf: extensionADF, contentId: macroContentId })=>{
        const { isMacroContentAndBody: isMacroContentAndBody, ...variables } = (0, $8mIlz.getMacroQueryVariables)({
            adf: extensionADF,
            contentId: macroContentId
        });
        const attr = extensionADF.attrs;
        const extensionKey = attr?.extensionKey;
        const failure = (reason)=>({
                [`${extensionKey}:${$64a1b8a95751bd5c$var$getMacroId(extensionADF)}`]: reason
            });
        const failureIfNotSuccess = (reason)=>(success)=>success ? undefined : failure(reason);
        // we may block some extensions via feature flags
        if ($64a1b8a95751bd5c$var$isBlocklisted(blocklistedExtensions, extensionKey)) return failure('blocklist');
        let macroBodyPreloadPromise = Promise.resolve(undefined);
        if (extensionADF.type === (0, $8pcS0.BODIED_EXTENSION_TYPE)) macroBodyPreloadPromise = (0, $wPrRK.slowQueryGuard)(`ExtensionContentConverter_${extensionKey || 'unknown'}`, ()=>{
            return (0, $dYU3e.query)({
                variables: (0, $92uc5.getContentConverterVariables)({
                    content: extensionADF.content,
                    contentId: contentId
                }),
                query: (0, $6Cce7.ContentConverterQuery),
                context: {
                    single: true
                },
                __callerPackage__: "fabric-extension-handlers"
            });
        }, macroTimeout).then(failureIfNotSuccess('timeout-macrobody'));
        const macroPreloadPromise = (0, $wPrRK.slowQueryGuard)(`Extension_${extensionKey || 'unknown'}`, ()=>{
            return isMacroContentAndBody ? (0, $dYU3e.query)({
                query: (0, $eqB7W.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "fabric-extension-handlers"
            }) : (0, $dYU3e.query)({
                query: (0, $b1ypt.default),
                variables: variables,
                context: {
                    single: true
                },
                __callerPackage__: "fabric-extension-handlers"
            });
        }, macroTimeout).then(failureIfNotSuccess('timeout'));
        // eslint-disable-next-line check-preloaders/no-promise-all
        const [macroPreloadResult, macroBodyPreloadResult] = await Promise.all([
            macroPreloadPromise,
            macroBodyPreloadPromise
        ]);
        return {
            ...macroPreloadResult,
            ...macroBodyPreloadResult
        };
    }));
    const preloadFailures = preloadResult ? preloadResult.filter((item)=>!!item) : [];
    return Object.assign({}, ...preloadFailures);
};
async function $64a1b8a95751bd5c$export$f860aab1074a1289(contentId, contentNodes, extensionsBlocklist, numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee), renderOnlyExtensionIds) {
    // Function has early return so we extracted it out to avoid setting global in every return
    return window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = await $64a1b8a95751bd5c$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodes, numberOfExtensionsToSSR, renderOnlyExtensionIds, extensionsBlocklist);
}















var $gK2Sc = parcelRequire("gK2Sc");














const $eb281dfded33b271$var$NIL_UUID = '00000000-0000-0000-0000-000000000000';
const $eb281dfded33b271$export$62987d2cbce2773d = (contentNodes)=>{
    try {
        const adf = (0, $c9US3.parseContentNodesAdf)(contentNodes);
        return !!adf && (0, $hSTGC.collectExtensionNodes)(adf).some((node)=>(0, $8pcS0.supportedExtensions).has(node.type));
    } catch  {
        return false;
    }
};
const $eb281dfded33b271$var$failureIfNotSuccess = (reason)=>(success)=>success ? undefined : {
            MacrosQuery_extensions: reason
        };
const $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed = async (contentId, contentNodesOrPromise)=>{
    const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const blocklist = (0, $ld6xp.getEffectiveMultiMacroQueryBlocklist)();
    const isContentNodePromise = typeof contentNodesOrPromise?.then === 'function';
    if (contentNodesOrPromise && !isContentNodePromise) {
        if (!$eb281dfded33b271$export$62987d2cbce2773d(contentNodesOrPromise)) return {};
    }
    const noExtensionsSignal = new Promise((resolve)=>{
        if (isContentNodePromise) contentNodesOrPromise.then((contentNodes)=>{
            if (!$eb281dfded33b271$export$62987d2cbce2773d(contentNodes)) resolve();
        });
    });
    // NOTE: prealod is not a type. It was created with a typo https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/confluence_frontend_prealod_macro_timeout
    const macroTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_prealod_macro_timeout', (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT));
    const macrosQueryTask = ()=>(0, $wPrRK.slowQueryGuard)('MacrosQuery_preload', ()=>(0, $dYU3e.query)({
                variables: {
                    first: (0, $cd2d56ef117b2819$export$e87714e2a0c200ee),
                    staticFirst: (0, $cd2d56ef117b2819$export$e87714e2a0c200ee),
                    contentId: contentId,
                    cloudId: cloudId || $eb281dfded33b271$var$NIL_UUID,
                    blocklist: blocklist
                },
                query: (0, $gK2Sc.default),
                context: {
                    single: true
                },
                __callerPackage__: "fabric-extension-handlers"
            }), macroTimeout, noExtensionsSignal).then($eb281dfded33b271$var$failureIfNotSuccess('timeout-rendered-macros'));
    const preloadResult = await macrosQueryTask();
    return preloadResult ? Object.assign({}, preloadResult) : {};
};
async function $eb281dfded33b271$export$b470c165ef60e727(contentId, contentNodesOrPromise) {
    const topXFailed = await $eb281dfded33b271$var$preloadMacrosSSRAndReturnTopXFailed(contentId, contentNodesOrPromise);
    window['__SSR_MACRO_PRELOAD_TOPX_FAILS__'] = topXFailed;
    return topXFailed;
}



const $7411787db12277fb$var$preloadMacrosSSRQuery = async ({ contentId: contentId, useMultipleMacrosQuery: useMultipleMacrosQuery, contentNodes: contentNodes, numberOfExtensionsToSSR: numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee) })=>{
    if (useMultipleMacrosQuery) return (0, $eb281dfded33b271$export$b470c165ef60e727)(contentId, contentNodes);
    else {
        const legacyBlocklistedExtensions = (0, $1xpoY.default).getString((0, $cd2d56ef117b2819$export$717eaf20c85e91ca), '');
        // if we're using MacrosQuery but this is the call for the old query, we need to
        // check if there are any blocklisted (for the Macros query) macros on the page
        // and attempt to use the old queries to render them instead
        const blocklistedExtensions = (0, $ld6xp.getLegacyIndividualMacroQueryKeys)();
        return (0, $64a1b8a95751bd5c$export$f860aab1074a1289)(contentId, contentNodes, legacyBlocklistedExtensions, numberOfExtensionsToSSR, blocklistedExtensions);
    }
};
const $7411787db12277fb$export$64dcb3aec0dc81b3 = async ({ contentId: contentId, useMultipleMacrosQuery: useMultipleMacrosQuery, contentNodes: contentNodes, numberOfExtensionsToSSR: numberOfExtensionsToSSR = (0, $cd2d56ef117b2819$export$e87714e2a0c200ee) })=>{
    return $7411787db12277fb$var$preloadMacrosSSRQuery({
        contentId: contentId,
        useMultipleMacrosQuery: useMultipleMacrosQuery,
        contentNodes: contentNodes,
        numberOfExtensionsToSSR: numberOfExtensionsToSSR
    });
};



var $7K6Nt = parcelRequire("7K6Nt");


var $1i2qc = parcelRequire("1i2qc");








var $bS81H = parcelRequire("bS81H");

const $151aa4f2ef9a59b5$export$94fce4b5db3cb85f = ()=>'ATTACHMENT_DOWNLOAD';
const $151aa4f2ef9a59b5$export$1b20920d4fbafebb = async (contentId, spaceKey, action, data)=>{
    const isActionEnabledForContent = data?.dataSecurityPolicy?.isActionEnabledForContent ? {
        action: action,
        allowed: data.dataSecurityPolicy.isActionEnabledForContent.allowed || false
    } : null;
    const cacheData = isActionEnabledForContent ? {
        dataSecurityPolicy: {
            isActionEnabledForContent: isActionEnabledForContent
        }
    } : {
        dataSecurityPolicy: null
    };
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $bS81H.default),
        variables: {
            action: action,
            contentId: contentId,
            contentStatus: 'CURRENT',
            contentVersion: 1,
            spaceKey: spaceKey
        },
        data: cacheData,
        __callerPackage__: "fabric-media-support"
    });
};
const $151aa4f2ef9a59b5$export$dc87c93837fe9dba = async (contentId, spaceKey)=>{
    const action = $151aa4f2ef9a59b5$export$94fce4b5db3cb85f();
    const response = await (0, $dYU3e.query)({
        query: (0, $bS81H.default),
        variables: {
            action: action,
            contentId: contentId,
            contentStatus: 'CURRENT',
            contentVersion: 1,
            spaceKey: spaceKey
        },
        __callerPackage__: "fabric-media-support"
    });
    return response;
};



var $aOHMQ = parcelRequire("aOHMQ");


var $iffSy = parcelRequire("iffSy");


var $28DDG = parcelRequire("28DDG");


var $22UVa = parcelRequire("22UVa");


var $1NBp8 = parcelRequire("1NBp8");


var $dhOY2 = parcelRequire("dhOY2");


var $7tT2b = parcelRequire("7tT2b");


var $gSV4C = parcelRequire("gSV4C");


var $8E4P6 = parcelRequire("8E4P6");





var $6P16d = parcelRequire("6P16d");


var $9ycGg = parcelRequire("9ycGg");

parcelRequire("8nle6");



var $gBI6h = parcelRequire("gBI6h");


var $lt4mJ = parcelRequire("lt4mJ");


var $b1n8n = parcelRequire("b1n8n");


var $eSLr0 = parcelRequire("eSLr0");


var $5Rwa0 = parcelRequire("5Rwa0");








var $7Ndnw = parcelRequire("7Ndnw");


var $8CHHT = parcelRequire("8CHHT");


var $bOhti = parcelRequire("bOhti");


var $gDMf3 = parcelRequire("gDMf3");





var $e5EnV = parcelRequire("e5EnV");

function $c44bc7c35ccb995d$export$b39ebabf96e926c8(id) {
    return (0, $dYU3e.query)({
        query: (0, $e5EnV.default),
        variables: {
            id: id
        },
        __callerPackage__: "no-permission"
    });
}


/**
 * @generated SignedSource<<6cfad544b1efb06291d5fcad35698373>>
 * @relayHash e7d986c9db7dfd3a42ef96015dfa9ca2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fec66635336d0d806dec6091a699738ecb8314e2e4abfaa9b3a98e3d7d6f4de4
const $3b467652a5c14364$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadPendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadPendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e7d986c9db7dfd3a42ef96015dfa9ca2",
            "id": "fec66635336d0d806dec6091a699738ecb8314e2e4abfaa9b3a98e3d7d6f4de4",
            "metadata": {},
            "name": "preloadPendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query preloadPendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3b467652a5c14364$var$node.hash = "cdc10e1c835031af29b6e3680fe359e2";
var $3b467652a5c14364$export$2e2bcd8739ae039 = $3b467652a5c14364$var$node;





const $5df28dcef89e2fae$var$PreloadPendingRequestExistsQuery = (0, $3b467652a5c14364$export$2e2bcd8739ae039);
function $5df28dcef89e2fae$export$c898ae6157713bd7(contentId, cloudId, accessRequestedAaid) {
    return (0, $dYU3e.query)({
        query: $5df28dcef89e2fae$var$PreloadPendingRequestExistsQuery,
        variables: {
            accessRequestedAaid: accessRequestedAaid,
            cloudId: cloudId,
            contentId: contentId
        },
        __callerPackage__: "no-permission"
    });
}









var $6jrkJ = parcelRequire("6jrkJ");


var $hiC7Y = parcelRequire("hiC7Y");

async function $9388622078562d65$export$8a2490b7cfbfffb0() {
    const { isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn || !(0, $6jrkJ.getSuperAdminClaim)()) return;
    return (0, $dYU3e.query)({
        query: (0, $hiC7Y.default),
        __callerPackage__: "super-admin"
    });
}



var $3U5ab = parcelRequire("3U5ab");










async function $e85a231992f6246b$export$2563ff426f0d0b3b() {
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
            ]
        },
        __callerPackage__: "experiment-omnibar"
    });
}



var $jsQRz = parcelRequire("jsQRz");





var $eDV4X = parcelRequire("eDV4X");


var $fD4xZ = parcelRequire("fD4xZ");

function $4e24c7560d847d2b$export$1c5f808d33dd5bee({ contentId: contentId }) {
    if (!contentId) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $fD4xZ.default),
        variables: {
            contentId: contentId,
            status: (0, $eDV4X.ALLOWED_CONTENT_STATUSES)
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "labels"
    });
}



var $jkwMx = parcelRequire("jkwMx");








var $9xoMO = parcelRequire("9xoMO");


var $fbp8i = parcelRequire("fbp8i");




const $ae623fc05873186d$export$c279cfd6dfc47585 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            key: (0, $9wGTI.fg)('confluence_preload_all_onboarding_keys') ? (0, $9xoMO.OnboardingKeysCombined) : (0, $fbp8i.PRELOADED_KEYS)
        },
        __callerPackage__: "onboarding-helpers"
    });
};






var $1swiX = parcelRequire("1swiX");





var $dpyxe = parcelRequire("dpyxe");





var $cRQNp = parcelRequire("cRQNp");


var $3Tnjq = parcelRequire("3Tnjq");


var $2QBQR = parcelRequire("2QBQR");














var $aqBZ0 = parcelRequire("aqBZ0");


var $ccWUN = parcelRequire("ccWUN");


var $gFF2G = parcelRequire("gFF2G");

function $12c3454d795c5c51$export$3ae0996a709f5fba(contentId) {
    if (!contentId) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $gFF2G.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "archive-pages"
    }).then(({ data: data })=>{
        const contentStatus = data?.content?.nodes?.[0]?.status;
        const isContentArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
        if (isContentArchived) return (0, $dYU3e.query)({
            query: (0, $ccWUN.default),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "archive-pages"
        });
        return Promise.resolve();
    });
}


function $d3f749dabb808bb9$export$8114133102d6f1fd(contentId, spaceKey) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fyUox.preloadPageTitleContentProperties)({
            contentId: contentId,
            spaceKey: spaceKey
        }),
        (0, $12c3454d795c5c51$export$3ae0996a709f5fba)(contentId)
    ]);
}



var $4trRg = parcelRequire("4trRg");









var $gad6U = parcelRequire("gad6U");

const $cc003fd311374024$export$7261e64a95ae02eb = (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $gad6U.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only',
        __callerPackage__: "audio"
    });
};


/**
 * Preloads approval data for SSR.
 */ // oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports

var $c0rhi = parcelRequire("c0rhi");





var $lKLmX = parcelRequire("lKLmX");


var $iOp5s = parcelRequire("iOp5s");

function $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86({ cloudId: cloudId, contentId: contentId, contentStatus: contentStatus, spaceKey: spaceKey }) {
    const otherContentStatus = contentStatus === 'CURRENT' ? 'DRAFT' : 'CURRENT';
    return (0, $c0rhi.queryInterop)({
        query: (0, $lKLmX.default),
        errorPolicy: 'all',
        variables: {
            cloudId: cloudId,
            contentId: contentId,
            contentStatus: contentStatus,
            otherContentStatus: otherContentStatus,
            transitionType: null,
            spaceKey: spaceKey,
            includeApprovalsBetaFeatures: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true),
            includeApprovalExpirationConfig: (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true) && (0, $6mKj3.expValEquals)('confluence_approvals_expiration', 'isEnabled', true),
            // Must match ApprovalsProvider's variables so the preloaded result is reused.
            includeOtherModeReviewDetails: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_approvals_banner_updates_exp', 'isEnabled', true)
        },
        __callerPackage__: "approvals"
    }).then((result)=>{
        (0, $iOp5s.markApprovalsDisabledErrorAsHandled)(result.error);
        return result;
    });
}



var $3HGWr = parcelRequire("3HGWr");


var $cHjca = parcelRequire("cHjca");


var $2ZE45 = parcelRequire("2ZE45");























var $c5JFM = parcelRequire("c5JFM");


var $i8Ofl = parcelRequire("i8Ofl");
















var $bjG4U = parcelRequire("bjG4U");

async function $ca9b583531d24796$export$c254be46c9b2d6cd({ cloudId: cloudId, activationId: activationId, contentId: contentId, spaceKey: spaceKey, isLoggedIn: isLoggedIn, accessStatus: accessStatus, isBlog: isBlog, isAdminHubAIEnabled: isAdminHubAIEnabled, groups: groups }) {
    if (!window.GLOBAL_RELAY_ENV) return undefined;
    const included = {};
    if (groups.loom && isLoggedIn && (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_loom_reader')) included.loom = {
        includeMeetingRecorderEligibility: false
    };
    if (groups.recommendations && isLoggedIn && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_recs_reader') && !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_eop_recs_twg_source_exp', 'isEnabled', true)) included.recommendations = {
        experience: ''
    };
    if (groups.onboarding && (accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_onboarding_reader') && (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) included.onboarding = {
        keys: []
    };
    if (groups.omnibar && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_onboarding_reader') && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('cc-ai-growth-preload-omnibar')) included.omnibar = {
        keys: [
            (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN
        ]
    };
    if (groups.catchup && isAdminHubAIEnabled && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_catchup_reader')) included.catchup = true;
    if (groups.presence && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_presence_reader')) included.presence = true;
    if (!Object.keys(included).length || !(0, $6mKj3.expVal)('confluence_exp_personalization_contract', 'isEnabled', false)) return undefined;
    if (included.loom) included.loom.includeMeetingRecorderEligibility = (0, $c5JFM.isMeetingRecorderEligibilityEnabled)();
    if (included.recommendations) included.recommendations.experience = (0, $6mKj3.expVal)('cc_ai_discovery_linked_pages_on_related_pages', 'experience', 'end_of_page_v5');
    if (included.onboarding) // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    included.onboarding.keys = (0, $9wGTI.fg)('confluence_preload_all_onboarding_keys') ? (0, $9xoMO.OnboardingKeysCombined) : (0, $fbp8i.PRELOADED_KEYS);
    const variables = (0, $bjG4U.buildViewPagePersonalizationVariables)({
        cloudId: cloudId,
        contentId: contentId,
        spaceKey: spaceKey,
        isBlog: isBlog
    }, included);
    const environment = window.GLOBAL_RELAY_ENV;
    const execution = (0, $igNpi.getOrCreatePersonalizationQueryOwner)(environment).preload(variables, {
        force: true,
        metadata: {
            headers: (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
        }
    });
    await execution.ready;
    if (execution.disposed || execution.failed || execution.errors.some(({ path: path })=>!path?.length)) return {
        status: 'failed'
    };
    const data = environment.lookup(execution.operation.fragment).data;
    if (!data) return {
        status: 'failed'
    };
    return {
        status: 'loaded',
        data: data,
        variables: variables,
        errors: execution.errors
    };
}
function $ca9b583531d24796$export$9b8f4488ec408d1a(result, include, fields) {
    if (result?.status !== 'loaded' || result.variables[include] !== true || !fields.every((field)=>result.data[field] !== undefined) || result.errors.some(({ path: path })=>!path?.length || fields.includes(path[0]))) return false;
    const variables = {
        ...result.variables,
        includeLoom: false,
        includeRecommendations: false,
        includeOnboardingState: false,
        includeAIFloatingContextMenu: false,
        includePresenceSettings: false,
        [include]: true
    };
    const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $9SZCg.default)), variables);
    return window.GLOBAL_RELAY_ENV?.check(operation).status === 'available';
}



var $3P2g3 = parcelRequire("3P2g3");

function $c4fff5dbedf707af$export$a6683a337f045a3d(result) {
    if (!result || result.status === 'loaded' && !result.variables.includeLoom) return undefined;
    if (result.status === 'failed' || !result.data.loom) return {
        retryLegacy: true
    };
    try {
        return (0, $3P2g3.readLoomPersonalizationInputs)(result.data.loom, result.errors.some(({ path: path })=>[
                'confluence_loomEntryPoints',
                'loom_settings',
                'loom_connectedCalendars'
            ].includes(String(path?.[0]))));
    } catch  {
        return {
            retryLegacy: true
        };
    }
}


const $74a3014e04345b66$export$a1e3459e1c2dacd8 = ()=>{
    const participantStatuses = [];
    return {
        schedule: (participant, createTask)=>{
            participantStatuses.push({
                participant: participant,
                status: 'scheduled'
            });
            return createTask();
        },
        skip: (participant)=>{
            participantStatuses.push({
                participant: participant,
                status: 'skipped'
            });
        },
        getParticipantStatuses: ()=>participantStatuses
    };
};


const $445d6fd463fd83fa$var$DEFAULT_PRELOAD_RECOMMENDATION_TIMEOUT = 700;
const $445d6fd463fd83fa$var$createPreloadContentTask = (contentId, isBlog, spaceKey, cloudId, activationId, isLoggedIn, isLicensed, isRovoButtonEnabled, contentNodesPromiseResolve, bridgeContentPromiseResolve, userId, agentSessionsEnabled, isAccessLinkRoute, shouldUseRouteOwnedMedia = false, shouldUseRouteOwnedDsp = false, shouldUseRouteOwnedCustomChrome = false, deferRestrictions = false, includeRestrictionAncestors = false, hasAnalyticsBylineGateReason = false)=>{
    const autohighlightsQueryVariables = isLoggedIn && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? (0, $hu6Tz.getAutohighlightsQueryVariables)({
        contentId: contentId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: isBlog ? 'blogpost' : 'page'
    }) : undefined;
    // Managed (external) labels: warm the `useExternalLabels_query` spread on
    // `ContentUnifiedQuery` when the managed-labels feature is on.
    const externalLabelsQueryVariables = cloudId && contentId && (0, $9wGTI.fg)('confluence_managed_external_labels_endpoint') ? {
        cloudId: cloudId,
        ari: (0, $jkwMx.buildExternalLabelsAri)(cloudId, contentId, isBlog ? 'blogpost' : 'page')
    } : undefined;
    const rovoActivationQueryVariables = !isBlog && isLoggedIn && isLicensed && userId && cloudId && isRovoButtonEnabled && // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    (0, $9wGTI.fg)('confluence_rovo_agent_session_nudges') ? {
        cloudId: cloudId
    } : undefined;
    const dspAction = shouldUseRouteOwnedDsp ? (0, $151aa4f2ef9a59b5$export$94fce4b5db3cb85f)() : undefined;
    return (0, $kkLBe.prepareGuardExceptionTask)('Content', ()=>(0, $1acff4ea84553836$export$97ce9ab4bdd6b3fc)({
            contentId: contentId,
            isBlog: isBlog,
            spaceKey: spaceKey,
            userId: userId,
            ...isLoggedIn && cloudId && (0, $6mKj3.expValEquals)('platform_editor_mention_rovo', 'isEnabled', true) ? {
                cloudId: cloudId
            } : {},
            agentSessionsEnabled: agentSessionsEnabled,
            isAccessLinkRoute: // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            isAccessLinkRoute,
            // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            hasDocumentContractAnalyticsByline: true,
            hasAnalyticsBylineGateReason: // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            hasAnalyticsBylineGateReason,
            // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            hasDocumentContractContentHeader: true,
            ...autohighlightsQueryVariables ? {
                autohighlightsQueryVariables: autohighlightsQueryVariables
            } : {},
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            ...externalLabelsQueryVariables ? {
                externalLabelsQueryVariables: externalLabelsQueryVariables
            } : {},
            // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            includeRendererAssetsMedia: shouldUseRouteOwnedMedia,
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            ...dspAction ? {
                includeRendererAssetsDsp: true,
                rendererAssetsDspAction: dspAction
            } : {},
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            ...shouldUseRouteOwnedCustomChrome ? {
                includeRendererAssetsCustomChrome: true
            } : {},
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            ...rovoActivationQueryVariables ? {
                rovoActivationQueryVariables: rovoActivationQueryVariables
            } : {}
        }).then(async ({ result: result, hasErrors: hasErrors })=>{
            const contentNodes = result?.data?.content?.nodes;
            const boundaryParsedAdf = hasErrors ? null : (0, $8e973d66a6eb555b$export$15cc693b68c3c062)(contentNodes, (invalidContentId)=>{
                (0, $3mugH.ssrPrepareErrorsClient).submitError(new Error('Skipped shared ADF cache warm-up: invalid ADF document structure'), {
                    contentId: invalidContentId,
                    cloudId: cloudId,
                    isBlog: isBlog,
                    reason: 'invalid-adf-document-structure'
                });
            });
            contentNodesPromiseResolve?.(contentNodes);
            bridgeContentPromiseResolve?.(hasErrors ? undefined : contentNodes?.[0]);
            const content = result?.data?.content?.nodes?.[0];
            if (deferRestrictions && (hasErrors || !content || content.id !== contentId || content.subType === 'live' || content.subType === undefined || content.status !== 'current' && content.status !== 'archived')) await (0, $lyWac.waitForAllReturnWhenError)((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, includeRestrictionAncestors));
            if (shouldUseRouteOwnedMedia) {
                if (hasErrors) await (0, $1i2qc.preloadMediaToken)(contentId, cloudId);
                else try {
                    await (0, $1i2qc.primeMediaTokenFromRouteData)(contentId, result?.data);
                } catch (error) {
                    (0, $3mugH.ssrPrepareErrorsClient).submitError(error instanceof Error ? error : new Error('Failed to seed the media token cache from route data'), {
                        contentId: contentId,
                        cloudId: cloudId,
                        isBlog: isBlog,
                        reason: 'route-owned-media-cache-prime-failed'
                    });
                    await (0, $1i2qc.preloadMediaToken)(contentId, cloudId);
                }
            }
            if (shouldUseRouteOwnedDsp && dspAction) {
                if (hasErrors) await (0, $151aa4f2ef9a59b5$export$dc87c93837fe9dba)(contentId, spaceKey);
                else await (0, $151aa4f2ef9a59b5$export$1b20920d4fbafebb)(contentId, spaceKey, dspAction, result?.data);
            }
            if (shouldUseRouteOwnedCustomChrome) {
                if (hasErrors) await (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey);
                else (0, $iV8Fk.primeCustomHeaderAndFooterFromRouteData)(spaceKey, result?.data);
            }
            // Report the content query's own errors as SSR prepare errors. `preloadContent` runs with
            // `errorPolicy: 'all'`, so a failing content query resolves rather than rejecting, and this
            // task resolves with its follow-up preloads instead of the query result — so nothing ever
            // inspected `result.errors`, and a page whose body failed to load reached the renderer with
            // nothing logged anywhere. Passing the settled result (rather than a task) is intentional:
            // `waitForAllReturnWhenError` reads the `{ hasErrors, errors }` shape that `query()`
            // resolves with, and skips the expected shapes (restricted page, not found) that `query()`
            // has already marked as handled — so only unexpected failures are reported.
            await (0, $lyWac.waitForAllReturnWhenError)(result);
            if (hasErrors) {
                const restrictedPageTasks = [
                    (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey),
                    (0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId),
                    (0, $6dc053709e1de01d$export$4a518872c59a5d22)({
                        contentId: contentId,
                        draftShareId: window.location.search.match(/draftShareId=(.*?)(#|&|$)/)?.[1] ?? ''
                    })
                ];
                // Preload the pending-access-request check so the restricted-content screen can
                // render the resolved title/message during SSR instead of blanking them
                if (userId && cloudId && (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_mohiti_restricted_content_screen_ab_exp', 'isEnabled', true)) restrictedPageTasks.push((0, $wPrRK.slowQueryGuard)('preloadPendingRequestExists', ()=>(0, $5df28dcef89e2fae$export$c898ae6157713bd7)(contentId, cloudId, userId), (0, $wPrRK.SLOW_QUERY_DEFAULT_TIMEOUT)));
                return (0, $lyWac.waitForAllReturnWhenError)(restrictedPageTasks);
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            } else var error;
        }, async (error)=>{
            // A failed document request must not remove the old restrictions preload.
            contentNodesPromiseResolve?.(undefined);
            bridgeContentPromiseResolve?.(undefined);
            if (deferRestrictions) await (0, $lyWac.waitForAllReturnWhenError)((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, includeRestrictionAncestors));
            throw error;
        }));
};
const $445d6fd463fd83fa$var$createContentMainTasks = (params)=>{
    const { spaceKey: spaceKey, contentId: contentId, username: username, edition: edition, isPrevEditRoute: isPrevEditRoute, isBlog: isBlog, isEmbeddedConfluence: isEmbeddedConfluence, cloudId: cloudId, activationId: activationId, isLoggedIn: isLoggedIn, isLicensed: isLicensed, isRovoButtonEnabled: isRovoButtonEnabled, contentNodesPromiseResolve: contentNodesPromiseResolve, contentNodesPromise: contentNodesPromise, bridgeContentPromiseResolve: bridgeContentPromiseResolve, bridgeContentPromise: bridgeContentPromise, isInitialLoad: isInitialLoad, userId: userId, agentSessionsEnabled: agentSessionsEnabled, isAccessLinkRoute: isAccessLinkRoute, isBridgeContentReuseEligible: isBridgeContentReuseEligible, shouldUseRouteOwnedDsp: shouldUseRouteOwnedDsp, shouldUseRouteOwnedCustomChrome: shouldUseRouteOwnedCustomChrome, hasAnalyticsBylineGateReason: hasAnalyticsBylineGateReason, routeAssetsCoordinator: routeAssetsCoordinator } = params;
    const shouldUseReadTimeFragment = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_body_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedPageMetadataBanner = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_metadata_banner_preload_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedMedia = !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_media_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) && !(0, $6mKj3.expVal)('confluence_media_token_preload_agg_query', 'isEnabled', false);
    return [
        (0, $furnK.preloadContentHeader)({
            spaceKey: spaceKey,
            contentId: contentId,
            isBlog: isBlog,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            useNewContentTopper: true,
            isContentTypePublicLinkEligible: !isBlog,
            isEmbeddedConfluence: isEmbeddedConfluence,
            hasDocumentContractMetadata: true,
            hasDocumentContractClassification: true,
            hasDocumentContractBody: true,
            hasDocumentContractAnalyticsByline: true,
            hasDocumentContractContentHeader: true,
            // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
            includeRendererAssetsMedia: shouldUseRouteOwnedMedia,
            // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
            shouldPreloadPageMetadataBanner: !shouldUseRouteOwnedPageMetadataBanner,
            deferRestrictions: params.deferRestrictions
        }),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_title_byline_frag_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? [] : [
            (0, $d3f749dabb808bb9$export$8114133102d6f1fd)(contentId, spaceKey),
            (0, $fyUox.preloadPageTitleContentProperties)({
                contentId: contentId,
                spaceKey: spaceKey
            })
        ],
        routeAssetsCoordinator.schedule('macro-ssr', ()=>(0, $kkLBe.prepareGuardExceptionTask)('Macros', ()=>(0, $7411787db12277fb$export$64dcb3aec0dc81b3)({
                    contentId: contentId,
                    useMultipleMacrosQuery: true,
                    contentNodes: contentNodesPromise
                }))),
        routeAssetsCoordinator.schedule('macro-data', ()=>(0, $kkLBe.prepareGuardExceptionTask)('MacroData', ()=>(0, $7K6Nt.preloadMacroData)({
                    contentNodes: contentNodesPromise,
                    context: {
                        contentId: contentId,
                        spaceKey: spaceKey
                    },
                    route: 'view'
                }))),
        routeAssetsCoordinator.schedule('content', ()=>$445d6fd463fd83fa$var$createPreloadContentTask(contentId, isBlog, spaceKey, cloudId || '', activationId, isLoggedIn, isLicensed, isRovoButtonEnabled, contentNodesPromiseResolve, bridgeContentPromiseResolve, userId, agentSessionsEnabled, isAccessLinkRoute, shouldUseRouteOwnedMedia, shouldUseRouteOwnedDsp, shouldUseRouteOwnedCustomChrome, params.deferRestrictions, edition === (0, $2QBQR.CONFLUENCE_EDITION).FREE, hasAnalyticsBylineGateReason)),
        ...!(0, $1xpoY.default).isKillSwitchOn('confluence_frontend_view_page_relay_fragment_dedup') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? [] : [
            (0, $gBI6h.preloadPageStatusQuery)(contentId)
        ],
        // The unified content owner settles before we decide whether the bridge needs content.
        ...isBridgeContentReuseEligible && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $iffSy.isRelayEnabled)('@confluence/content-body', {
            operationName: 'ContentUnifiedQuery',
            phase: 'preload'
        }) && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $iffSy.isRelayEnabled)('@confluence/view-page-common', {
            operationName: 'ContentUnifiedQuery',
            phase: 'component'
        }) && (0, $6mKj3.expVal)('confluence_exp_legacy_bridge_content_reuse', 'isEnabled', false) ? [
            bridgeContentPromise.then((content)=>(0, $lt4mJ.preloadLegacyBridge)({
                    contentId: contentId,
                    isBlog: isBlog,
                    reuseContent: (0, $b1n8n.isReusableLegacyBridgeContent)(content, contentId)
                }))
        ] : [
            (0, $lt4mJ.preloadLegacyBridge)({
                contentId: contentId,
                isBlog: isBlog
            })
        ],
        ...shouldUseReadTimeFragment ? [] : [
            (0, $cRQNp.preloadReadTime)({
                contentId: contentId,
                includeContentBody: false,
                useCache: true
            })
        ],
        // SmartLinks are only preloaded on initial load, never on transitions.
        ...isInitialLoad ? [
            routeAssetsCoordinator.schedule('smart-links', ()=>(0, $9eb88ac593a96a41$export$dc2d6742e80fba3c)(contentId))
        ] : (routeAssetsCoordinator.skip('smart-links'), [])
    ];
};
const $445d6fd463fd83fa$export$9503d022471fff24 = async (match, url, isTransition = false, previousMatch = null, /**
 * Route-specific behaviour for callers that delegate here. `isAccessLinkRoute` is set by
 * `preloadAccessLinkRoute`, which knows what route it is without having to inspect the URL.
 */ options = {})=>{
    const { isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled, activationId: activationId } = (0, $xwvlW.getPreloaderFnContext)();
    const hasAnalyticsBylineGateReason = Boolean((0, $6P16d.getAnalyticsBylineGateReason)({
        edition: edition,
        isLoggedIn: isLoggedIn,
        accessStatus: accessStatus,
        userId: userId
    }));
    const tasks = [];
    // following functions will be triggered after we load data
    const postLoadingTasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const isInitialLoad = !isTransition;
    const personalizationInput = {
        cloudId: cloudId,
        activationId: activationId,
        contentId: contentId,
        spaceKey: spaceKey,
        isLoggedIn: isLoggedIn,
        accessStatus: accessStatus,
        isBlog: isBlog,
        isAdminHubAIEnabled: isAdminHubAIEnabled
    };
    // Only these small, route-blocking selections share a completion boundary.
    const personalization = (0, $ca9b583531d24796$export$c254be46c9b2d6cd)({
        ...personalizationInput,
        groups: {
            loom: true,
            presence: true,
            onboarding: true,
            omnibar: true
        }
    });
    const deferRestrictions = (0, $cbQWR.canDeferPageRestrictions)(match) && !options.isAccessLinkRoute && !isEmbeddedConfluence && !(0, $lJlG6.isMobileApp_DO_NOT_USE)() && !(0, $6jrkJ.getSuperAdminClaim)() && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_restrictions_on_demand') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedMedia = !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_media_reader') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) && !(0, $6mKj3.expVal)('confluence_media_token_preload_agg_query', 'isEnabled', false);
    const shouldUseRouteOwnedDsp = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_dsp_reader') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const shouldUseRouteOwnedCustomChrome = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_custom_chrome_reader') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    // Route preloaders cannot use useAIRovoButtonEnablement, so mirror its product-level
    // eligibility inputs to keep preload and hydrated query behavior aligned.
    const isRovoButtonEnabled = isAdminHubAIEnabled && isRovoLLMEnabled;
    const shouldUseRouteOwnedForgeExtensionList = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_forge_extension_list_reader') && // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false);
    const routeAssetsCoordinator = (0, $74a3014e04345b66$export$a1e3459e1c2dacd8)();
    // This guard schedules server-only preload work; it does not alter the React tree.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isReactSsr = Boolean(undefined);
    const shouldPreloadNavigation = !isEmbeddedConfluence && (isInitialLoad || (0, $1swiX.shouldPreloadNavigationForTransition)(previousMatch));
    const shouldPreloadBylineConnections = isReactSsr && isInitialLoad && isLoggedIn && Boolean(cloudId) && Boolean(contentId) && // The existing byline UI owns exposure for this experiment.
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', true);
    // Get isArchived from cached page data
    const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
    // Don't preload queries that will be updated by editor if previous route is edit_page
    const isPrevEditRoute = previousMatch?.name === (0, $1NBp8.EDIT_PAGE_V2).name || previousMatch?.name === (0, $1NBp8.EDIT_BLOG_V2).name || previousMatch?.name === (0, $1NBp8.COMPANY_HUB_EDIT).name || previousMatch?.name === (0, $1NBp8.HUB_EDIT).name;
    if (isPrevEditRoute && isTransition) // Preload for edit -> view transition
    return (0, $furnK.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        isBlog: isBlog,
        username: username,
        edition: edition,
        isPrevEditRoute: isPrevEditRoute,
        useNewContentTopper: true,
        isEmbeddedConfluence: isEmbeddedConfluence,
        isContentTypePublicLinkEligible: !isBlog,
        hasDocumentContractMetadata: true,
        hasDocumentContractClassification: true,
        // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
        hasDocumentContractAnalyticsByline: true,
        hasDocumentContractContentHeader: true,
        // @ts-ignore -- Downstream packages are checked against the last generated content-body declaration.
        includeRendererAssetsMedia: shouldUseRouteOwnedMedia
    });
    // ViewPageGateway wraps the entire page and renders nothing until useIsSuperAdmin settles, so
    // this has to resolve before render or no content is emitted. See preloadIsSuperAdmin for the
    // conditions under which it issues a request; it is a no-op for everyone else.
    tasks.push((0, $9388622078562d65$export$8a2490b7cfbfffb0)());
    if (!isPrevEditRoute && !deferRestrictions) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, edition === (0, $2QBQR.CONFLUENCE_EDITION).FREE));
    if (isLoggedIn && edition === (0, $2QBQR.CONFLUENCE_EDITION).PREMIUM && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) tasks.push((0, $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86)({
        cloudId: cloudId,
        contentId: contentId,
        contentStatus: 'CURRENT',
        spaceKey: spaceKey
    }));
    // Content types header (object header) + Unified Share and Restrict Button
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
        const contentTypesHeaderPreloadTasks = [];
        if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_access_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
        if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_obj_header_frag_dedup') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // preload data for whether "unpublished changes" label should show in view page object header
        contentTypesHeaderPreloadTasks.push((0, $4vyfK.preloadWebItemLocation)({
            location: 'page.metadata.banner',
            contentId: contentId
        }));
        // (No need to call preloadPageRestrictionsQuery() here; it will be called by
        //  preloadContentHeader() )
        return contentTypesHeaderPreloadTasks;
    }));
    if (isReactSsr && isInitialLoad) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('byline-apps', ()=>[
            (0, $4vyfK.preloadWebItemLocation)({
                contentId: contentId,
                location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
            }),
            (0, $8CHHT.preloadUseExtensionList)({
                contentId: contentId,
                spaceKey: spaceKey,
                moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
            }).then(// Property keys depend on Forge discovery, not the rest of content-main.
            ()=>(0, $9L8Ms.preloadBylineAppContentProperties)(contentId))
        ]));
    // Content main
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    let bridgeContentPromiseResolve = undefined;
    const bridgeContentPromise = new Promise((resolve)=>{
        bridgeContentPromiseResolve = resolve;
    });
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>{
        const mainTasks = $445d6fd463fd83fa$var$createContentMainTasks({
            spaceKey: spaceKey,
            contentId: contentId,
            username: username,
            edition: edition,
            isPrevEditRoute: isPrevEditRoute,
            isBlog: isBlog,
            isEmbeddedConfluence: isEmbeddedConfluence,
            cloudId: cloudId,
            activationId: activationId,
            isLoggedIn: isLoggedIn,
            isLicensed: isLicensed,
            isRovoButtonEnabled: isRovoButtonEnabled,
            contentNodesPromiseResolve: contentNodesPromiseResolve,
            contentNodesPromise: contentNodesPromise,
            bridgeContentPromiseResolve: bridgeContentPromiseResolve,
            bridgeContentPromise: bridgeContentPromise,
            isInitialLoad: isInitialLoad,
            userId: userId,
            // confluence-feature-gating/inline-usage: must be inlined
            agentSessionsEnabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true),
            isAccessLinkRoute: options.isAccessLinkRoute,
            isBridgeContentReuseEligible: Boolean(spaceKey) && !isBlog && !isEmbeddedConfluence && !options.isAccessLinkRoute && !match.query.versionOverride && !match.query.lite && !match.query.draftShareId && !match.query.embedded && !match.query.parentProduct,
            shouldUseRouteOwnedDsp: shouldUseRouteOwnedDsp,
            shouldUseRouteOwnedCustomChrome: shouldUseRouteOwnedCustomChrome,
            deferRestrictions: deferRestrictions,
            hasAnalyticsBylineGateReason: hasAnalyticsBylineGateReason,
            routeAssetsCoordinator: routeAssetsCoordinator
        });
        if (shouldPreloadBylineConnections) {
            mainTasks.push((0, $3HGWr.preloadIncomingLinksSsrState)({
                cloudId: cloudId,
                contentId: contentId,
                contentType: isBlog ? 'blogpost' : 'page',
                route: 'view'
            }));
            mainTasks.push((0, $cHjca.preloadOutboundBylineSsrState)(contentId, 'view'));
            mainTasks.push((0, $2ZE45.preloadRelatedContentSsrState)({
                cloudId: cloudId,
                activationId: activationId,
                contentId: contentId,
                contentType: isBlog ? 'blogpost' : 'page',
                route: 'view'
            }));
        }
        if (isInitialLoad && isLoggedIn) {
            const preloadRecommendations = ()=>(0, $ca9b583531d24796$export$c254be46c9b2d6cd)({
                    ...personalizationInput,
                    groups: {
                        recommendations: true
                    }
                }).then((result)=>(0, $ca9b583531d24796$export$9b8f4488ec408d1a)(result, 'includeRecommendations', [
                        'getRecommendedPages',
                        'getRecommendedPagesSpaceStatus',
                        'space'
                    ]) ? undefined : (0, $dhOY2.preloadEndOfPageRecommendation)({
                        contentId: contentId,
                        spaceKey: spaceKey,
                        contentType: isBlog ? 'blogpost' : 'page',
                        cloudId: cloudId
                    }));
            const createEndOfPageDataFetcher = ()=>(0, $eS4vC.createDataFetcherForSuspense)('end-of-page-recommendations', ()=>{
                    const endOfPageTasks = [
                        preloadRecommendations()
                    ];
                    if (!isBlog && // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
                    (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence_3p_in_related_content', 'shouldEvaluate', true)) endOfPageTasks.push((0, $kquO1.preloadOutgoingLinks)(contentId));
                    return endOfPageTasks;
                });
            mainTasks.push(createEndOfPageDataFetcher());
        }
        return mainTasks;
    }));
    if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_mode_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) tasks.push((0, $4trRg.preloadContentMode)({
        contentId: contentId,
        isDraft: false,
        useCache: true,
        isArchived: isArchived
    }));
    // Navigation, Page tree and blog tree for blog post
    if (shouldPreloadNavigation) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, isArchived && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_preloaded_query') && (0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false) ? '' : contentId, isLicensed, isBlog, true, previousMatch?.params?.spaceKey));
    else if (!isEmbeddedConfluence) tasks.push((0, $dpyxe.preloadNavigationQuery)(spaceKey, isArchived ? '' : contentId, isBlog));
    // Space details
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    // Inline Comments
    if (match?.query.focusedCommentId && !((0, $iffSy.isRelayEnabled)('@confluence/object-comments', {
        operationName: 'ObjectCommentContainerPreloadObjectCommentsQuery'
    }) && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_query') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false))) tasks.push((0, $aOHMQ.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    // Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_reactions_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) tasks.push((0, $9ycGg.preloadPageReactions)({
            pageId: contentId,
            containerId: spaceKey
        }));
    }
    // Recommendations
    // On initial load these are preloaded inside a suspense data fetcher above, so only transitions
    // need this standalone preload. Recommendations are only
    // preloaded for authenticated users (knowledge_discovery service requires auth).
    if (!isInitialLoad && isLoggedIn) {
        const recommendationsTimeout = (0, $1xpoY.default).getNumber('confluence_frontend_preload_recommendation_timeout', $445d6fd463fd83fa$var$DEFAULT_PRELOAD_RECOMMENDATION_TIMEOUT);
        tasks.push((0, $wPrRK.slowQueryGuard)('preloadEndOfPageRecommendation', ()=>{
            return (0, $dhOY2.preloadEndOfPageRecommendation)({
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: isBlog ? 'blogpost' : 'page',
                cloudId: cloudId
            });
        }, recommendationsTimeout));
    }
    // Stuff only needed for initial load
    if (isInitialLoad) {
        if (!shouldUseRouteOwnedMedia) tasks.push(// We only refresh token when it is about to expire.
        (0, $1i2qc.preloadMediaToken)(contentId, cloudId || ''));
        if (!shouldUseRouteOwnedCustomChrome) tasks.push((0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey));
        if (!shouldUseRouteOwnedDsp) tasks.push((0, $151aa4f2ef9a59b5$export$dc87c93837fe9dba)(contentId, spaceKey));
    }
    // Labels
    if (isTransition && ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_meta_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false))) tasks.push((0, $4e24c7560d847d2b$export$1c5f808d33dd5bee)({
        contentId: contentId
    }));
    // Managed (external) labels are warmed via the `useExternalLabels_query`
    // fragment on `ContentUnifiedQuery` (see `externalLabelsQueryVariables` above),
    // so a dedicated preload task is no longer needed. The legacy label picker's
    // standalone `useExternalLabels` read is `store-or-network`, so it reads that
    // warmed store or falls back to network on dialog open.
    // Preload web panel atl_general
    if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
        contentId: contentId,
        locations: [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ]
    }));
    else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    // Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('ai-floating-context-menu', ()=>(0, $ca9b583531d24796$export$c254be46c9b2d6cd)({
            ...personalizationInput,
            groups: {
                catchup: true
            }
        }).then((result)=>(0, $ca9b583531d24796$export$9b8f4488ec408d1a)(result, 'includeAIFloatingContextMenu', [
                'catchupGetLastViewedTime'
            ]) ? undefined : (0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog))));
    // Preload Audio Listen Button
    if ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_audio_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) tasks.push((0, $cc003fd311374024$export$7261e64a95ae02eb)(contentId));
    const extensionListOptions = (0, $bOhti.getPageExtensionListPreloadOptions)({
        contentId: contentId,
        spaceKey: spaceKey,
        isTransition: isTransition,
        preloadMacros: !shouldUseRouteOwnedForgeExtensionList || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')
    });
    if (extensionListOptions) {
        const extensionListLoader = ()=>(0, $8CHHT.preloadUseExtensionList)(extensionListOptions);
        tasks.push(shouldUseRouteOwnedForgeExtensionList ? routeAssetsCoordinator.schedule('forge-extension-list', extensionListLoader) : extensionListLoader());
    } else if (shouldUseRouteOwnedForgeExtensionList) routeAssetsCoordinator.skip('forge-extension-list');
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        isViewPage: true,
        personalizationInputs: (0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_loom_reader') ? undefined : personalization.then((0, $c4fff5dbedf707af$export$a6683a337f045a3d)),
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId
    }));
    // Only ordinary page/blog views use the combined contract. Wait for content metadata
    // so live pages (and missing/mismatched content) retain the legacy preload.
    if (!options.isAccessLinkRoute && !isEmbeddedConfluence && !(0, $lJlG6.isMobileApp_DO_NOT_USE)() && (match.name === (0, $1NBp8.VIEW_PAGE).name || match.name === (0, $1NBp8.VIEW_BLOG).name || match.name === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name) && // The bootstrap/cache handoff is native Relay; preserve the legacy flow when
    // either query routes to Apollo (including SSR before rollout config is ready).
    (0, $iffSy.isRelayEnabled)('@confluence/team-presence', {
        operationName: 'viewPresenceBootstrapQuery'
    }) && (0, $iffSy.isRelayEnabled)('@confluence/team-presence', {
        operationName: 'ContentHeaderPresenceContentSettingsQuery'
    }) && (0, $6mKj3.expVal)('confluence_exp_view_presence_contract', 'isEnabled', false)) {
        const presenceVariables = {
            cloudId: cloudId,
            contentId: contentId,
            spaceKey: spaceKey
        };
        tasks.push((0, $8E4P6.trackViewPresencePreload)(presenceVariables, async ()=>{
            // Reuse the personalization-owned setting before starting another settings request.
            if (!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_presence_reader')) {
                const result = await personalization;
                if ((0, $ca9b583531d24796$export$9b8f4488ec408d1a)(result, 'includePresenceSettings', [
                    'confluence_teamPresenceContentSetting'
                ])) return;
            }
            const nodes = await contentNodesPromise;
            const content = nodes?.[0];
            return content?.id === contentId && content.subType !== undefined && content.subType !== 'live' ? (0, $8E4P6.preloadViewPresenceBootstrap)(presenceVariables) : (0, $gSV4C.preloadPresenceSettings)({
                cloudId: cloudId,
                spaceKey: spaceKey
            });
        }));
    } else tasks.push((0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_presence_reader') ? (0, $gSV4C.preloadPresenceSettings)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }) : personalization.then((result)=>(0, $ca9b583531d24796$export$9b8f4488ec408d1a)(result, 'includePresenceSettings', [
            'confluence_teamPresenceContentSetting'
        ]) ? undefined : (0, $gSV4C.preloadPresenceSettings)({
            cloudId: cloudId,
            spaceKey: spaceKey
        })));
    // Preload definition autohighlights
    // Only preload autohighlights for authenticated users (knowledge_discovery service requires auth)
    if (isLoggedIn && ((0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false))) tasks.push((0, $gKMkU.preloadAutohighlights)({
        contentId: contentId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: isBlog ? 'blogpost' : 'page'
    }));
    tasks.push((0, $eS4vC.createDataFetcherForSuspense)('object-comments', ()=>[
            // Preload footer comments. SSRing live pages necessitates non-server (i.e. transition)
            // preloading, so enable here too for consistency in the footer component.
            (0, $3U5ab.preloadObjectComments)(contentId, match?.query.focusedCommentId),
            // The conversation query owns this permission data when its fragment reader is enabled.
            ...!(0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_data_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false) ? [] : [
                (0, $jsQRz.preloadAddCommentPermissionCheck)(contentId, [
                    'draft',
                    'current'
                ])
            ]
        ]));
    // Preload onboarding state for view page
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS) && (0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) tasks.push((0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_onboarding_reader') ? (0, $ae623fc05873186d$export$c279cfd6dfc47585)() : personalization.then((result)=>(0, $ca9b583531d24796$export$9b8f4488ec408d1a)(result, 'includeOnboardingState', [
            'onboardingState'
        ]) ? undefined : (0, $ae623fc05873186d$export$c279cfd6dfc47585)()));
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('cc-ai-growth-preload-omnibar')) tasks.push((0, $1xpoY.default).isKillSwitchOn('confluence_vp_personalization_onboarding_reader') ? (0, $e85a231992f6246b$export$2563ff426f0d0b3b)() : personalization.then((result)=>(0, $ca9b583531d24796$export$9b8f4488ec408d1a)(result, 'includeOnboardingState', [
            'onboardingState'
        ]) ? undefined : (0, $e85a231992f6246b$export$2563ff426f0d0b3b)()));
    // The document-owned header supplies the banner fragment in treatment.
    if (isEmbeddedConfluence || Boolean(match.query.versionOverride || match.query.lite || match.query.draftShareId) || (0, $1xpoY.default).isKillSwitchOn('confluence_vp_header_frag_reader') || (0, $1xpoY.default).isKillSwitchOn('confluence_vp_smart_create_banner_frag_reader') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false)) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    else tasks.push(contentNodesPromise.then((nodes)=>{
        const content = nodes?.[0];
        // Live documents and missing/mismatched owner data still need the legacy preload.
        if (content?.id !== contentId || content?.subType === 'live' || !content?.contentHeaderFragment) return (0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId);
        return undefined;
    }));
    const errors = await (0, $lyWac.waitForAllReturnWhenError)(tasks);
    const postLoadingErrors = await (0, $lyWac.waitForAllReturnWhenError)(postLoadingTasks.map((task)=>task()));
    if (errors || postLoadingErrors) return [
        ...errors || [],
        ...postLoadingErrors || []
    ];
};








/**
 * @generated SignedSource<<e1d07984b577db48b7ecdd332628cb11>>
 * @relayHash 9db18599ae8276f38e57885f4b3ed842
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID edafd438720a1dc9f3ad7178421078636892a9a16b7d545d094272279358a150
const $05c40bb113a7d622$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SpaceOverviewIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SpaceOverviewIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9db18599ae8276f38e57885f4b3ed842",
            "id": "edafd438720a1dc9f3ad7178421078636892a9a16b7d545d094272279358a150",
            "metadata": {},
            "name": "SpaceOverviewIdQuery",
            "operationKind": "query",
            "text": "query SpaceOverviewIdQuery($spaceKey:String){space(key:$spaceKey){id,homepageId}}"
        }
    };
}();
$05c40bb113a7d622$var$node.hash = "7fd7786f0088a31ebf4c6fb6bedcf998";
var $05c40bb113a7d622$export$2e2bcd8739ae039 = $05c40bb113a7d622$var$node;


function $12a2f5ca95176b67$export$c390629d140bb37e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $05c40bb113a7d622$export$2e2bcd8739ae039),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "content-types-header"
    }).then((result)=>({
            result: result,
            hasErrors: result.hasErrors
        }));
}









var $7tHGa = parcelRequire("7tHGa");








var $79mss = parcelRequire("79mss");


var $kJOuS = parcelRequire("kJOuS");


var $gSfo4 = parcelRequire("gSfo4");

function $2257f3db82626244$export$fc412545d4d6ad12(contentId, contentStatus) {
    const variables = {
        contentId: contentId,
        lowerCaseContentStatusArray: (0, $gSfo4.getQuerySingleContentStatusArrayVariable)([
            contentStatus
        ])
    };
    if ((0, $6mKj3.expValEquals)('confluence_classification_level_v2', 'isEnabled', true)) return (0, $dYU3e.query)({
        query: (0, $kJOuS.default),
        variables: variables,
        __callerPackage__: "data-classification"
    });
    return (0, $dYU3e.query)({
        query: (0, $79mss.default),
        variables: variables,
        __callerPackage__: "data-classification"
    });
}


async function $c7f6674d8ea135ae$export$137d64ae0bf4fe94(contentId) {
    const queries = [];
    queries.push((0, $2257f3db82626244$export$fc412545d4d6ad12)(contentId, (0, $7tHGa.ContentStatus).CURRENT));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}




































var $d3OVq = parcelRequire("d3OVq");

function $5fc5440e5bdafbe2$export$f73e4f65960ffd6e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $d3OVq.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "space-base"
    });
}












var $cEgMD = parcelRequire("cEgMD");





var $6SSyC = parcelRequire("6SSyC");

function $7df05aa0881398cb$export$ac86736f8ee66015(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $6SSyC.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "screen"
    });
}






var $ixL26 = parcelRequire("ixL26");











var $3hHGU = parcelRequire("3hHGU");


var $jpSPX = parcelRequire("jpSPX");








var $3D1KL = parcelRequire("3D1KL");

function $428e758fdbd08d59$export$9a90cdaf2bd47339({ contentId: contentId, spaceKey: spaceKey }) {
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:pageButtons', async ()=>{
        const tasks = [
            (0, $3D1KL.preloadEditButton)({
                spaceKey: spaceKey,
                contentId: contentId
            })
        ];
        return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    });
}


const $79570d1de8e3464e$export$ba9b2fb7540ef84 = (spaceKey)=>(0, $dYU3e.query)({
        query: (0, $ixL26.default),
        variables: {
            spaceKey: spaceKey,
            excludeOperations: Boolean(!(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey))
        },
        __callerPackage__: "space-overview"
    });
const $79570d1de8e3464e$export$50a212ec809090eb = (spaceKey)=>{
    const { cloudId: cloudId, isRovoEnabled: isRovoEnabled } = (0, $xwvlW.getPreloaderFnContext)();
    if (!(0, $jpSPX.isSmartSpaceOverviewEnabled)({
        spaceKey: spaceKey,
        cloudId: cloudId,
        isRovoEnabled: isRovoEnabled
    })) return Promise.resolve(null);
    return (0, $dYU3e.query)({
        query: (0, $3hHGU.default),
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey
        },
        __callerPackage__: "space-overview"
    });
};
const $79570d1de8e3464e$var$preloadSpaceOverviewQueries = async ({ homepageId: homepageId = '', spaceKey: spaceKey, shouldPreloadClassification: shouldPreloadClassification = true, versionOverride: versionOverride })=>{
    const tasks = [];
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    let contentNodesPromiseResolve = undefined;
    const contentNodesPromise = new Promise((resolve)=>{
        contentNodesPromiseResolve = resolve;
    });
    // This preloader is awaited by the route, so banner discovery finishes before the main layout.
    // Resolve the homepage first so the boot snapshot matches the banner's hydration context.
    const preloadPageExtensions = (contentId)=>{
        const options = (0, $bOhti.getPageExtensionListPreloadOptions)({
            contentId: contentId,
            spaceKey: spaceKey,
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            preloadMacros: (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp'),
            // Company Hub uses its own layout without the page banner.
            includePageBanner: !(0, $cEgMD.isCompanyHubSpaceKey)(spaceKey)
        });
        return options ? (0, $8CHHT.preloadUseExtensionList)(options) : undefined;
    };
    if (homepageId) {
        // If we know the homepageId, preload early
        if (shouldPreloadClassification) tasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(homepageId));
        const pageExtensions = preloadPageExtensions(homepageId);
        if (pageExtensions) tasks.push(pageExtensions);
        tasks.push((0, $kkLBe.prepareGuardExceptionTask)('MacroData', ()=>(0, $7K6Nt.preloadMacroData)({
                contentNodes: contentNodesPromise,
                context: {
                    contentId: homepageId,
                    spaceKey: spaceKey
                },
                route: 'space-overview'
            })));
    }
    const autohighlightsQueryVariables = homepageId && userId && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') && (0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false) ? (0, $hu6Tz.getAutohighlightsQueryVariables)({
        contentId: homepageId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: 'page'
    }) : undefined;
    tasks.push((0, $kkLBe.prepareGuardExceptionTask)('ContentAndMacros', ()=>(0, $1acff4ea84553836$export$97ce9ab4bdd6b3fc)({
            contentId: homepageId,
            spaceKey: spaceKey,
            isBlog: false,
            versionOverride: versionOverride,
            userId: userId,
            ...userId && cloudId && (0, $6mKj3.expValEquals)('platform_editor_mention_rovo', 'isEnabled', true) ? {
                cloudId: cloudId
            } : {},
            // Mirror preloadViewPageRoute so the space-overview homepage preload uses the same
            // ContentUnifiedQuery variable shape (and cache key) as the live ViewPageContainer read.
            // confluence-feature-gating/inline-usage: expValEquals must be inlined at the callsite.
            agentSessionsEnabled: (0, $6mKj3.expValEquals)('cc_ai_agent_mention_from_comment', 'isEnabled', true),
            ...autohighlightsQueryVariables ? {
                autohighlightsQueryVariables: autohighlightsQueryVariables
            } : {}
        }).then(async ({ result: result, hasErrors: hasErrors })=>{
            const preloadedContentId = result?.data?.content?.nodes?.[0]?.id;
            if (hasErrors || homepageId && preloadedContentId !== homepageId) (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`SpaceOverview preload did not produce the expected ContentUnifiedQuery entry; spaceKey=${spaceKey}; requestedHomepageId=${homepageId}; preloadedContentId=${preloadedContentId}; hasErrors=${Boolean(hasErrors)}`), {
                attribution: 'next-space-overview'
            });
            // Report the content query's own errors as SSR prepare errors. `preloadContent` runs
            // with `errorPolicy: 'all'`, so a failing content query resolves rather than rejecting,
            // and this task resolves with its follow-up preloads instead of the query result — so
            // nothing ever inspected `result.errors`. `waitForAllReturnWhenError` skips the
            // expected shapes (restricted page, not found) that `query()` marked as handled.
            await (0, $lyWac.waitForAllReturnWhenError)(result);
            const contentId = homepageId || result?.data?.content?.nodes[0]?.id;
            // in the event that there are errors (no id from result) and the homepageId is not valid (error when loading the space),
            // bypass preloadContentPrereqs since contentId is undefined
            if (!contentId) return;
            contentNodesPromiseResolve?.(result?.data?.content?.nodes);
            const promises = [];
            if (!homepageId) {
                // If we don't know the homepageId, preloadContent will tell us the id
                promises.push((0, $7411787db12277fb$export$64dcb3aec0dc81b3)({
                    contentId: contentId,
                    cloudId: cloudId,
                    useMultipleMacrosQuery: true,
                    contentNodes: result?.data?.content?.nodes
                }));
                const pageExtensions = preloadPageExtensions(contentId);
                if (pageExtensions) promises.push(pageExtensions);
                if (shouldPreloadClassification) tasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(contentId));
                promises.push((0, $7K6Nt.preloadMacroData)({
                    contentNodes: result?.data?.content?.nodes,
                    context: {
                        contentId: contentId,
                        spaceKey: spaceKey
                    },
                    route: 'space-overview'
                }));
            }
            if (hasErrors) promises.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey, {
                versionOverride: versionOverride
            }));
            return (0, $lyWac.waitForAllReturnWhenError)(promises);
        })), (0, $428e758fdbd08d59$export$9a90cdaf2bd47339)({
        contentId: homepageId,
        spaceKey: spaceKey
    }));
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId,
        spaceKey: spaceKey
    }));
    // Navigation (including page tree + blog tree) is preloaded by preloadSpaceOverviewRoute via
    // preloadNavigationTasks, so it is intentionally not preloaded here.
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
async function $79570d1de8e3464e$export$2fae7b45037154b8({ spaceKey: spaceKey, homepageId: homepageId, homepageIdPromise: homepageIdPromise, shouldPreloadScreen: shouldPreloadScreen = true, shouldPreloadClassification: shouldPreloadClassification = true, versionOverride: versionOverride }) {
    const promises = [
        (0, $5fc5440e5bdafbe2$export$f73e4f65960ffd6e)(spaceKey),
        (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey),
        $79570d1de8e3464e$export$50a212ec809090eb(spaceKey)
    ];
    if (shouldPreloadScreen) promises.push((0, $7df05aa0881398cb$export$ac86736f8ee66015)(spaceKey));
    const resolvedHomepageId = homepageId ?? (homepageIdPromise ? await homepageIdPromise : undefined);
    if (resolvedHomepageId) {
        // In some case we append homepageId as a query param. Then preload with it.
        // next/packages/space-overview/src/SpaceOverview.tsx still needs SpaceOverviewQuery but others are not depending on it
        promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey), $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
            homepageId: resolvedHomepageId,
            spaceKey: spaceKey,
            shouldPreloadClassification: shouldPreloadClassification,
            versionOverride: versionOverride
        }));
        if ((0, $6mKj3.expVal)('confluence_preload_share_and_restrict_button_query', 'isEnabled', false)) promises.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(resolvedHomepageId, spaceKey));
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    } else {
        if ((0, $6mKj3.expVal)('confluence_preload_share_and_restrict_button_query', 'isEnabled', false)) // Preload share button data with spaceKey early (before homepageId is known)
        promises.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
        // If we have no information on home id and yet using old query, we need to fetch it first.
        promises.push($79570d1de8e3464e$export$ba9b2fb7540ef84(spaceKey).then((res)=>{
            // Because homepageId was provided by the function caller, it may or may
            // not be out of sync with backend:
            const actualHomepageId = res?.data?.space?.homepage?.id;
            if (actualHomepageId) return $79570d1de8e3464e$var$preloadSpaceOverviewQueries({
                homepageId: actualHomepageId,
                spaceKey: spaceKey,
                shouldPreloadClassification: shouldPreloadClassification,
                versionOverride: versionOverride
            });
        }));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
}











parcelRequire("8nle6");






var $jtfsl = parcelRequire("jtfsl");

function $3c8474b5b6cc7016$export$986e86a20e675444({ accountId: accountId }) {
    return (0, $dYU3e.query)({
        query: (0, $jtfsl.default),
        variables: {
            accountId: accountId
        },
        __callerPackage__: "custom-sites-extensions"
    });
}

















const $de1bf574523c3b16$export$7237b12e4aa9c6c = async ()=>{
    const { activationId: activationId, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    if (activationId && cloudId) return `~HUB-${cloudId}-${activationId}~`;
};













var $c3Qwv = parcelRequire("c3Qwv");




























const $5cdf3a7c2cbff10f$export$2cbe0869fedf40d1 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).TRENDING_PAGES,
                (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).DISMISSED
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};



const $fe22b38e04163065$var$homepageIdPromiseMap = new Map();
const $fe22b38e04163065$var$homepageIdMap = new Map();
const $fe22b38e04163065$var$loadHomepageId = async (spaceKey)=>{
    const { result: result, hasErrors: hasErrors } = await (0, $12a2f5ca95176b67$export$c390629d140bb37e)(spaceKey);
    return !hasErrors && result?.data?.space?.homepageId || null;
};
const $fe22b38e04163065$export$75a73f2fbf5e96e8 = async (match)=>{
    const { spaceKey: spaceKey } = match.params;
    const homepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    if (homepageId) return;
    const homepageIdPromise = $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey) ?? $fe22b38e04163065$var$loadHomepageId(spaceKey);
    // Keep both maps in sync - promises and actual values for synchronous access
    $fe22b38e04163065$var$homepageIdPromiseMap.set(spaceKey, homepageIdPromise);
    return homepageIdPromise.then((homepageId)=>{
        $fe22b38e04163065$var$homepageIdMap.set(spaceKey, homepageId);
    });
};
const $fe22b38e04163065$export$e23682e43b850daa = (match)=>{
    const { spaceKey: spaceKey } = match.params;
};
const $fe22b38e04163065$export$75071d943b36f58f = async (match, previousMatch, _url, pageContextHomepageIdPromise)=>{
    const { cloudId: cloudId, isLicensed: isLicensed, userId: userId, activationId: activationId, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const initialHomepageId = match.query ? (0, $c3Qwv.getSingleParam)(match.query, (0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY) : undefined;
    const tasks = [];
    // SpaceOverview renders ViewPageContainer, so it sits behind the same ViewPageGateway
    // AdminKeyQuery gate as the view page. See preloadIsSuperAdmin for the conditions under which
    // it issues a request; it is a no-op for everyone else.
    tasks.push((0, $9388622078562d65$export$8a2490b7cfbfffb0)());
    const isCompanyHub = match.name === (0, $1NBp8.COMPANY_HUB).name;
    const isReactStreamingEnabled = !isCompanyHub && (0, $6mKj3.expVal)('confluence_space_overview_react_streaming', 'isEnabled', false);
    const companyHubSpaceKey = isCompanyHub ? await (0, $de1bf574523c3b16$export$7237b12e4aa9c6c)() : undefined;
    const versionOverride = companyHubSpaceKey && match.query ? (0, $c3Qwv.getSingleParamInt)(match.query, 'versionOverride') : null;
    const homepageId = initialHomepageId || $fe22b38e04163065$var$homepageIdMap.get(spaceKey ?? companyHubSpaceKey);
    const homepageIdPromise = pageContextHomepageIdPromise ?? $fe22b38e04163065$var$homepageIdPromiseMap.get(spaceKey ?? companyHubSpaceKey);
    let headerContentId = homepageId;
    if (spaceKey) {
        // Consolidated navigation preloading: use the shared helper (page tree + blog tree included)
        // like the view page route, instead of splitting nav queries between this route and
        // preloadSpaceOverview. Company hub has no `spaceKey` route param, so it is naturally excluded
        // here — preserving the prior behaviour where the page tree was not preloaded for company hub.
        const isCrossSpaceTransition = Boolean(previousMatch && previousMatch.params?.spaceKey !== spaceKey);
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (isCrossSpaceTransition) {
            const preloadNavigation = ()=>(0, $dpyxe.preloadNavigationTasks)(spaceKey, // Route-backed readers use the homepage variant even when the homepage ID is known.
                !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_trees_frag_reader') && (0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false) ? '' : homepageId ?? '', isLicensed, false, // space overview is never a blog
                isReactStreamingEnabled, previousMatch?.params?.spaceKey);
            tasks.push(preloadNavigation());
        } else tasks.push((0, $dpyxe.preloadNavigationQuery)(spaceKey, '', false));
    }
    tasks.push((0, $79570d1de8e3464e$export$2fae7b45037154b8)({
        spaceKey: spaceKey ?? companyHubSpaceKey,
        homepageId: homepageId,
        homepageIdPromise: homepageIdPromise,
        shouldPreloadScreen: !pageContextHomepageIdPromise,
        // The matching header boundary owns classification data for streaming routes.
        // @ts-ignore -- Downstream packages are checked against the last generated package declaration.
        shouldPreloadClassification: !isReactStreamingEnabled,
        versionOverride: versionOverride
    }));
    if (homepageId) {
        // Get isArchived from cached page data
        const { isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(homepageId ?? undefined);
        tasks.push((0, $4trRg.preloadContentMode)({
            contentId: homepageId,
            isDraft: true,
            useCache: true,
            isArchived: isArchived
        }));
    }
    tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: homepageId || '',
        contentIdPromise: homepageIdPromise,
        spaceKey: spaceKey ?? companyHubSpaceKey
    }));
    tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    tasks.push((0, $5cdf3a7c2cbff10f$export$2cbe0869fedf40d1)());
    if (isCompanyHub && userId) tasks.push((0, $3c8474b5b6cc7016$export$986e86a20e675444)({
        accountId: userId
    }));
    // Presence Avatar Visibility
    tasks.push((0, $gSV4C.preloadPresenceSettings)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // Restrictions are also consumed outside the content-types-header boundary.
    if (!isCompanyHub && homepageId) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(homepageId, false));
    // Preload definition autohighlights
    // Only preload autohighlights for authenticated users (knowledge_discovery service requires auth)
    if (homepageId && isLoggedIn && (!userId || (0, $1xpoY.default).isKillSwitchOn('confluence_vp_autohighlights_unified_query') || !(0, $6mKj3.expVal)('confluence_exp_vp_document', 'isEnabled', false))) tasks.push((0, $gKMkU.preloadAutohighlights)({
        contentId: homepageId,
        cloudId: cloudId,
        activationId: activationId,
        contentType: 'page'
    }));
    // Preload media token for cover image
    if (homepageId) tasks.push((0, $1i2qc.preloadMediaToken)(homepageId, cloudId));
    if (homepageId) {
        if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
            contentId: homepageId,
            locations: [
                (0, $eSLr0.ATL_GENERAL),
                (0, $eSLr0.ATL_FOOTER)
            ]
        }));
        else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: homepageId,
            location: (0, $eSLr0.ATL_GENERAL)
        }), (0, $5Rwa0.preloadWebPanelLocation)({
            contentId: homepageId,
            location: (0, $eSLr0.ATL_FOOTER)
        }));
    }
    if (!isCompanyHub && !homepageId) {
        if (!isReactStreamingEnabled) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
        //moved chained queries to the bottom to unblock other queries needed to preload & to combine the contentId query
        const resolvedHomepageIdPromise = homepageIdPromise ?? $fe22b38e04163065$var$loadHomepageId(spaceKey);
        await resolvedHomepageIdPromise.then((contentId)=>{
            headerContentId = contentId;
            tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId ?? '', false));
            if (contentId) {
                // Preload web panel atl_general
                if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
                    contentId: contentId,
                    locations: [
                        (0, $eSLr0.ATL_GENERAL),
                        (0, $eSLr0.ATL_FOOTER)
                    ]
                }));
                else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
                    contentId: contentId,
                    location: (0, $eSLr0.ATL_GENERAL)
                }), (0, $5Rwa0.preloadWebPanelLocation)({
                    contentId: contentId,
                    location: (0, $eSLr0.ATL_FOOTER)
                }));
                // Preload media token for cover image
                tasks.push((0, $1i2qc.preloadMediaToken)(contentId, cloudId));
            }
        });
    }
    if (!isCompanyHub) {
        if (isReactStreamingEnabled) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
            const contentTypesHeaderPreloadTasks = [];
            contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(headerContentId));
            if (headerContentId) contentTypesHeaderPreloadTasks.push((0, $c7f6674d8ea135ae$export$137d64ae0bf4fe94)(headerContentId));
            contentTypesHeaderPreloadTasks.push(homepageId ? (0, $gDMf3.preloadShareAndRestrictButtonQuery)(homepageId) : (0, $gDMf3.preloadShareAndRestrictButtonQuery)(undefined, spaceKey));
            return contentTypesHeaderPreloadTasks;
        }));
        else {
            tasks.push((0, $4zhNK.preloadContentTypesHeader)(headerContentId));
            if (homepageId) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(homepageId));
        }
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};
const $fe22b38e04163065$export$d1ef19b00f2c3147 = ()=>{
    $fe22b38e04163065$var$homepageIdMap.clear();
    $fe22b38e04163065$var$homepageIdPromiseMap.clear();
};





var $7A94k = parcelRequire("7A94k");





















/**
 * @generated SignedSource<<c6f52d76f40a36d5184d0bf9735570f1>>
 * @relayHash 692b310473739d80af6d43542c26df31
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 80d9be10877ca72fa849742e6835bc1972fa04172f344617d7d379ae9262fa7b
const $f4ed30693011df84$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "referenceId",
                    "variableName": "id"
                }
            ],
            "kind": "ScalarField",
            "name": "contentIdByReferenceId"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ContentIdByReferenceIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ContentIdByReferenceIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "692b310473739d80af6d43542c26df31",
            "id": "80d9be10877ca72fa849742e6835bc1972fa04172f344617d7d379ae9262fa7b",
            "metadata": {},
            "name": "ContentIdByReferenceIdQuery",
            "operationKind": "query",
            "text": "query ContentIdByReferenceIdQuery($id:String!){contentIdByReferenceId(referenceId:$id)}"
        }
    };
}();
$f4ed30693011df84$var$node.hash = "d1f8ea313ddf642c92d2df2b0f67af0d";
var $f4ed30693011df84$export$2e2bcd8739ae039 = $f4ed30693011df84$var$node;



var $d5h4f = parcelRequire("d5h4f");


var $kwaj3 = parcelRequire("kwaj3");

async function $7ba44aaf109d7b00$export$69c63edd0aeaee0b({ spaceKey: spaceKey, contentId: contentId, skipPageTree: skipPageTree = false }) {
    const preloadPromises = [
        $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey),
        $7ba44aaf109d7b00$var$preloadSpace(spaceKey)
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(preloadPromises);
}
async function $7ba44aaf109d7b00$var$preloadContentData(contentId, spaceKey) {
    const UUIDRegex = /[-]/;
    const isUuidBasedId = UUIDRegex.test(contentId);
    if (isUuidBasedId) await (0, $dYU3e.query)({
        query: (0, $f4ed30693011df84$export$2e2bcd8739ae039),
        variables: {
            id: contentId
        },
        __callerPackage__: "whiteboard-common"
    });
    else await (0, $dYU3e.query)({
        query: (0, $d5h4f.default),
        variables: {
            contentId: contentId,
            spaceKey: // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            spaceKey === '_' && (0, $9wGTI.fg)('cc-cns-28262-fix-bad-space-key-preload') ? null : spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1
        },
        __callerPackage__: "whiteboard-common"
    });
}
async function $7ba44aaf109d7b00$var$preloadSpace(spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $kwaj3.default),
        variables: {
            spaceKey: spaceKey
        },
        __callerPackage__: "whiteboard-common"
    });
}



















var $bcVE2 = parcelRequire("bcVE2");

const $58246c7bb1bd3b0e$var$getSingle = (value)=>Array.isArray(value) ? value[0] : value ?? undefined;
const $58246c7bb1bd3b0e$export$a8738b3e8374c78c = (match)=>{
    const isEmbedded = (0, $bcVE2.isEmbeddedWhiteboardMode)({
        parentProduct: match.query?.parentProduct,
        presentationMode: match.query?.presentationMode
    });
    const parentProduct = $58246c7bb1bd3b0e$var$getSingle(match.query?.parentProduct);
    return {
        isEmbeddedWhiteboardMode: isEmbedded,
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        bypassesMainLayout: isEmbedded && (0, $9wGTI.fg)('confluence_ssr_embedded_whiteboard_preload_cache'),
        parentProduct: parentProduct,
        isSmartLinkEmbed: parentProduct === 'smartLink',
        isRovoEmbed: parentProduct === 'rovo'
    };
};


const $d639d659544153c3$export$a107836a8bcfc0c9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const { bypassesMainLayout: bypassesMainLayout, isSmartLinkEmbed: isSmartLinkEmbed, isRovoEmbed: isRovoEmbed } = (0, $58246c7bb1bd3b0e$export$a8738b3e8374c78c)(match);
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!bypassesMainLayout) {
        if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    }
    // Content types header (object header)
    if (!(bypassesMainLayout && isSmartLinkEmbed)) {
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // Standalone Restrictions button needs to have its data preloaded)
        if (!(bypassesMainLayout && isRovoEmbed)) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    }
    // Unified Share and Restrict Button
    if (!(bypassesMainLayout && (isSmartLinkEmbed || isRovoEmbed))) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    if (!(bypassesMainLayout && isRovoEmbed)) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    tasks.push((0, $7ba44aaf109d7b00$export$69c63edd0aeaee0b)({
        spaceKey: spaceKey,
        contentId: contentId,
        skipPageTree: bypassesMainLayout
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};

























var $c7BJC = parcelRequire("c7BJC");

async function $6ac7363a4b3b3fec$export$de0a909710c86263(spaceKey, contentId) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey),
        $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey)
    ]);
}
async function $6ac7363a4b3b3fec$var$preloadContentData(contentId, spaceKey) {
    await (0, $dYU3e.query)({
        query: (0, $c7BJC.default),
        variables: {
            contentId: contentId,
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            spaceKey: spaceKey === '_' && (0, $9wGTI.fg)('cc-cns-28262-fix-bad-space-key-preload') ? null : spaceKey,
            // The DSP query doesn't currently user the content version value, so using a fixed value
            contentVersion: 1
        },
        __callerPackage__: "confluence-databases"
    });
}
async function $6ac7363a4b3b3fec$var$preloadContentTree(contentId, spaceKey) {}












const $f7a595baa9e6d446$export$f9f9f93ef86bfae1 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
    // (No need to call preloadPageRestrictionsQuery() here; the item's restriction data will be
    //  loaded by preloadDatabaseData() below)
    // Unified Share and Restrict Button
    tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $6ac7363a4b3b3fec$export$de0a909710c86263)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};


















var $1TElT = parcelRequire("1TElT");


var $65pdw = parcelRequire("65pdw");


var $4TRDb = parcelRequire("4TRDb");

const $136b2b02116ae317$var$preloadEditorData = async (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $4TRDb.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "smart-create-page-editor"
    });
};
const $136b2b02116ae317$export$6e1d336ae32be6c2 = async (contentId)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $136b2b02116ae317$var$preloadEditorData(contentId),
        (0, $1TElT.preloadEmojiTitle)(contentId, '', false),
        (0, $65pdw.preloadEditorPageCoverPicture)(contentId, '', false)
    ]);
};


const $ff76ae367134cd26$export$2a230d51c69b591b = async (contentId)=>{
    const { cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $136b2b02116ae317$export$6e1d336ae32be6c2)(contentId),
        (0, $1i2qc.preloadMediaToken)(contentId, cloudId)
    ]);
};
















var $aFgFx = parcelRequire("aFgFx");















const $a17ca091e4cf9f3d$export$18e29f32c47bffc9 = async (match, _url, isTransition = false)=>{
    const { isLicensed: isLicensed } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    if (!isTransition) tasks.push((0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    // Content types header (object header)
    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
    // (No need to call preloadPageRestrictionsQuery() here; the item's restriction data will be
    //  loaded by preloadEmbedData() below)
    tasks.push((0, $4trRg.preloadContentMode)({
        contentId: contentId,
        isDraft: false,
        useCache: true
    }));
    // Unified Share and Restrict Button
    tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    tasks.push((0, $aFgFx.preloadEmbedData)(spaceKey, contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};



var $cvj7x = parcelRequire("cvj7x");





var $fywGr = parcelRequire("fywGr");


var $h8QBE = parcelRequire("h8QBE");













const $8401ee2f6eb43799$export$6316c27636a04811 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                (0, $dBcar.NTH_USER_EMOJI_TITLE_DISCOVERED).EMOJI_TITLE_DISCOVERED
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};











const $4b6107ec1852de14$export$f487e1233221fed9 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};






var $g6QPm = parcelRequire("g6QPm");





var $7PLO8 = parcelRequire("7PLO8");


var $32Xjk = parcelRequire("32Xjk");

const $8332e6e273585306$export$3e6908d03c4e3a25 = (contentId)=>{
    return (0, $dYU3e.query)({
        query: (0, $32Xjk.default),
        variables: (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? (0, $g6QPm.createEditorContentUnifiedQueryVariables)({
            contentId: contentId,
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        }) : {
            contentId: contentId,
            status: [
                'current',
                'draft'
            ],
            draftShareId: (0, $7PLO8.getDraftShareIdFromQueryParam)()
        },
        __callerPackage__: "emoji-title"
    });
};


parcelRequire("8nle6");









var $8R0gj = parcelRequire("8R0gj");




var $kyd3u = parcelRequire("kyd3u");







var $kBkBz = parcelRequire("kBkBz");








async function $a0c935b54d4370ec$export$c6954e5932c9c91f(contentId) {
    const queries = [];
    queries.push((0, $2257f3db82626244$export$fc412545d4d6ad12)(contentId, (0, $7tHGa.ContentStatus).DRAFT));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}



















































var $3gyyc = parcelRequire("3gyyc");


var $euL71 = parcelRequire("euL71");






/**
 * Fire-and-forget warm-up of the third-party connector-config *code chunk* that
 * `useConnectedThirdPartyProductKeys` loads at editor mount (for the
 * third-party quick-insert embed items).
 *
 * Dynamically importing `@atlassian/rovo-connectors-config/hooks` during the
 * edit-route preload — before `FullPageEditorComponent` mounts — means the
 * module and its dependency graph are already fetched, parsed, and evaluated by
 * the time the editor needs them, keeping that JS cost off the hydration
 * critical path.
 *
 * IMPORTANT: this intentionally does NOT call `get3pProductKeys` / issue the
 * connector-config network request. That request is served by a shared
 * stale-while-revalidate cache (`SEARCH_3P_CONFIG`). Firing it here — before the
 * editor mounts — plants a fresh-TTL, still-pending cache entry; the editor-mount
 * hook then sees a "not expired" entry and, because the cache serves the last
 * resolved value during refresh, is handed the previously-persisted (stale)
 * connector list instead of awaiting the fresh response. `useThirdPartyConfig`
 * commits that value once and never re-fetches, so the quick-insert menu gets
 * stuck showing a stale/partial set of apps (e.g. only Figma). Leaving the
 * network request to the editor-mount hook keeps it as the first cache caller,
 * so it awaits fresh data.
 *
 * Client-only: the underlying module assumes a browser environment, so callers
 * must not invoke this during SSR.
 */ 
const $40a9d2820cf67538$export$d8f603dd70536f4f = ()=>{
    (parcelRequire("bKbJ1")).catch(()=>{
    // Best-effort chunk warm-up only. Any failure is swallowed so it can never
    // affect the route transition; the editor-mount hook loads it on demand.
    });
};


const $32e736695aa13b8b$export$8abf4a07f4444858 = (match, url, isTransition = false)=>{
    if (match.name === (0, $1NBp8.COMPANY_HUB_EDIT).name && (0, $6mKj3.expValEquals)('confluence_react_streaming_all_routes', 'isEnabled', true)) return (0, $lyWac.waitForAllReturnWhenError)([
        $32e736695aa13b8b$var$preloadCompanyHubEditRoute(match, url, isTransition)
    ]);
    return $32e736695aa13b8b$var$preloadEditorRoute(match, url, isTransition);
};
const $32e736695aa13b8b$var$preloadCompanyHubEditRoute = async (match, url, isTransition)=>{
    const spaceKey = await (0, $de1bf574523c3b16$export$7237b12e4aa9c6c)();
    if (!spaceKey) return;
    const explicitContentId = match.query?.contentId;
    // Screen resolves the homepage above the editor's content-main boundary. Warm that same
    // query before starting editor preloads, which also need the resolved homepage ID.
    const screenResult = explicitContentId ? undefined : await (0, $7df05aa0881398cb$export$ac86736f8ee66015)(spaceKey);
    const contentId = explicitContentId || screenResult?.data?.space?.homepage?.id;
    if (!contentId) return screenResult;
    return (0, $lyWac.waitForAllReturnWhenError)([
        screenResult,
        $32e736695aa13b8b$var$preloadEditorRoute({
            ...match,
            params: {
                ...match.params,
                spaceKey: spaceKey,
                contentId: contentId
            }
        }, url, isTransition)
    ]);
};
const $32e736695aa13b8b$var$preloadEditorRoute = async (match, _url, isTransition = false)=>{
    const { userId: userId, isLicensed: isLicensed, cloudId: cloudId, activationId: activationId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, edition: edition } = (0, $xwvlW.getPreloaderFnContext)();
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const isBlog = Boolean((0, $kM8fE.matchEditBlog)(_url));
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    const shouldPreloadMentionsProvider = isSSR;
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    const isStreaming = isSSR || (0, $3gyyc.isSSRStreaming)();
    let contentStatePreloadPromise;
    // Under the experiment the content state comes from EditorContentUnifiedQuery.
    if (isSSR && !(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) contentStatePreloadPromise = (0, $cvj7x.preloadEditorDataContentState)({
        contentId: contentId,
        useCache: false,
        isLivePage: false
    });
    if (contentStatePreloadPromise) tasks.push((0, $kkLBe.prepareGuardExceptionTask)('EditorContentState', ()=>contentStatePreloadPromise));
    const preloadPromise = (0, $kkLBe.prepareGuardExceptionTask)('EditorData', ()=>(0, $cvj7x.preloadEditorData)({
            spaceKey: spaceKey,
            contentId: contentId,
            cloudId: cloudId,
            shouldPreloadMentionsProvider: shouldPreloadMentionsProvider,
            useCache: false,
            isBlog: isBlog,
            contentStatePreloadPromise: contentStatePreloadPromise
        }));
    // Called inside the content-main data fetcher on streaming SSR so its query boundary owns it.
    const createEditorContentPreloadTasks = ()=>(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? [
            (0, $kkLBe.prepareGuardExceptionTask)('EditorContentUnifiedQuery', ()=>(0, $kBkBz.preloadEditorContentUnifiedQuery)({
                    contentId: contentId,
                    isLivePage: false
                }))
        ] : [];
    // The restricted page screen shows when the collab draft preload reports a permission error, so
    // its query loads only then, as View Page does after its route query.
    const createRestrictedPagePreloadTasks = ()=>!isTransition && (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? [
            preloadPromise.then(({ isEditRestricted: isEditRestricted })=>isEditRestricted ? (0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId) : undefined)
        ] : [];
    if (isStreaming) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-main', ()=>[
            preloadPromise,
            ...createEditorContentPreloadTasks(),
            ...createRestrictedPagePreloadTasks()
        ]));
    else tasks.push(preloadPromise, ...createEditorContentPreloadTasks(), ...createRestrictedPagePreloadTasks());
    // we dont know if a page is unpublished until we get data back. guess based on the draftShareId being in the url
    const guessIsUnpublishedDraft = Boolean(match?.query?.draftShareId);
    tasks.push((0, $kyd3u.preloadEditorByLineData)({
        isUnpublishedDraft: guessIsUnpublishedDraft,
        spaceKey: spaceKey,
        contentId: contentId
    }));
    // Screen's restrictions provider is outside the header, so preload in the shared route boundary.
    if (isStreaming && (0, $6mKj3.expValEquals)('edit_page_ssr_restrictions', 'isEnabled', true)) tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    if (isStreaming) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('content-types-header', ()=>{
        const contentTypesHeaderPreloadTasks = [];
        if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) contentTypesHeaderPreloadTasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        if (!(0, $6mKj3.expValEquals)('edit_page_ssr_restrictions', 'isEnabled', true)) contentTypesHeaderPreloadTasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
        if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) contentTypesHeaderPreloadTasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
        return contentTypesHeaderPreloadTasks;
    }));
    else {
        if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
        // Unified Share and Restrict Button
        if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    }
    if (isLicensed) {
        tasks.push((0, $fywGr.preloadEditorOnboardingState)());
        tasks.push((0, $h8QBE.preloadLandUsersInEditorWithRevampedBpqa)());
        tasks.push((0, $4b6107ec1852de14$export$f487e1233221fed9)());
        tasks.push((0, $8401ee2f6eb43799$export$6316c27636a04811)());
        // Under the experiment EditorContentUnifiedQuery serves the emoji-ever-set property.
        if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) tasks.push((0, $8332e6e273585306$export$3e6908d03c4e3a25)(contentId));
    }
    (0, $40a9d2820cf67538$export$d8f603dd70536f4f)();
    if (!isSSR && shouldPreloadNavigation) tasks.push((0, $dpyxe.preloadNavigationQuery)(spaceKey, contentId, isBlog));
    if (isTransition) {
        if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
            contentId: contentId,
            locations: [
                (0, $eSLr0.ATL_GENERAL),
                (0, $eSLr0.ATL_FOOTER)
            ]
        }));
        return (0, $lyWac.waitForAllReturnWhenError)(tasks);
    }
    if (isSSR) {
        if (shouldPreloadNavigation) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog, isStreaming));
        tasks.push((0, $1i2qc.preloadMediaToken)(contentId, cloudId), (0, $a0c935b54d4370ec$export$c6954e5932c9c91f)(contentId));
    } else tasks.push((0, $8R0gj.preloadDraft)(contentId));
    // Under the experiment the space comes from EditorContentUnifiedQuery.
    if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    if ((0, $6mKj3.expValEquals)('web_panel_query_batch_call', 'isEnabled', true)) tasks.push((0, $5Rwa0.preloadWebPanelLocations)({
        contentId: contentId,
        locations: [
            (0, $eSLr0.ATL_GENERAL),
            (0, $eSLr0.ATL_FOOTER)
        ]
    }));
    else tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }), (0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_FOOTER)
    }));
    if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) tasks.push((0, $c44bc7c35ccb995d$export$b39ebabf96e926c8)(contentId));
    if (isLoggedIn && edition === (0, $euL71.ConfluenceEdition).PREMIUM && (0, $6mKj3.expValEquals)('confluence_approvals_eap', 'isEnabled', true)) tasks.push((0, $fa8eaa7cdcb1d432$export$2d00200c8fdc5d86)({
        cloudId: cloudId,
        contentId: contentId,
        contentStatus: 'DRAFT',
        spaceKey: spaceKey
    }));
    // Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        activationId: activationId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId
    }));
    // The main layout needs banner discovery before any content-main boundary is rendered.
    const extensionListOptions = (0, $bOhti.getPageExtensionListPreloadOptions)({
        contentId: contentId,
        spaceKey: spaceKey,
        preloadMacros: // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor') || // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')
    });
    if (extensionListOptions) tasks.push((0, $8CHHT.preloadUseExtensionList)(extensionListOptions));
    // Preload Smart Create Feedback Banner
    if (!(0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true)) tasks.push((0, $22UVa.preloadSmartCreateFeedbackBanner)(contentId));
    // Preload Audio Listen Button
    tasks.push((0, $cc003fd311374024$export$7261e64a95ae02eb)(contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};








async function $73df6e46d3afaa7c$export$9c3872cc60e7dbce(match, _url) {
    const { contentId: contentId } = match.params;
    // draftShareId is a query param, not a route param
    const draftShareId = (0, $6mKj3.expValEquals)('cc_perms_fix_blog_draft_restricted_page_showing', 'isEnabled', true) ? match.query?.draftShareId : match.params.draftShareId;
    await (0, $8R0gj.preloadDraft)(contentId, Array.isArray(draftShareId) ? draftShareId[0] : draftShareId);
}









var $2XqLa = parcelRequire("2XqLa");


var $jG2Es = parcelRequire("jG2Es");


var $khheP = parcelRequire("khheP");


var $dC2j7 = parcelRequire("dC2j7");

const $61c2bc00711f31ff$export$e56b81ae74d866fc = (options)=>{
    const variables = (0, $dC2j7.getPreloadAggSpacePagesQueryVariables)(options);
    const { spaceKey: spaceKey, isLoggedIn: isLoggedIn, spaceId: spaceId = '' } = options;
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.queryAgg)({
            query: (0, $khheP.default),
            variables: variables,
            __callerPackage__: "space-pages"
        }),
        ...!spaceId ? [
            (0, $dYU3e.query)({
                query: (0, $2XqLa.default),
                variables: {
                    spaceKey: spaceKey
                },
                __callerPackage__: "space-pages"
            })
        ] : [],
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $jG2Es.default),
                variables: {
                    spaceKey: spaceKey
                },
                __callerPackage__: "space-pages"
            })
        ] : []
    ]);
};






var $yuLaV = parcelRequire("yuLaV");




const $106eac55bed5d4af$export$206b1c2d74bc11a2 = async (match)=>{
    const { userId: userId, isLoggedIn: isLoggedIn, accessStatus: accessStatus, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const { spaceKey: spaceKey } = match.params;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    return (0, $61c2bc00711f31ff$export$e56b81ae74d866fc)({
        cloudId: cloudId,
        spaceKey: spaceKey,
        queryParams: match.query,
        userId: userId,
        isLicensed: isLicensed,
        isLoggedIn: isLoggedIn,
        spaceId: '',
        isWhiteboardEnabled: isWhiteboardsEnabled,
        isDatabaseEnabled: isDatabasesEnabled,
        isSlidesEnabled: isSlidesEnabled
    });
};



var $bFNdd = parcelRequire("bFNdd");


var $aYbn7 = parcelRequire("aYbn7");




var $ddSqr = parcelRequire("ddSqr");



















var $73cd2 = parcelRequire("73cd2");

const $189a8a30ba3005c8$export$517a8e5c755236cc = async ({ shareToken: shareToken, contentId: contentId })=>{
    const sharedContentResult = await (0, $dYU3e.query)({
        query: (0, $73cd2.default),
        variables: {
            shareToken: shareToken,
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        __callerPackage__: "external-share"
    });
    const singleContent = sharedContentResult?.data?.singleContent;
    const resolvedContentId = contentId ?? singleContent?.id;
    const spaceKey = singleContent?.space?.key;
    const isPage = singleContent?.type === 'page';
    if (!resolvedContentId || !isPage) return (0, $lyWac.waitForAllReturnWhenError)([
        Promise.resolve(sharedContentResult)
    ]);
    return (0, $lyWac.waitForAllReturnWhenError)([
        Promise.resolve(sharedContentResult),
        (0, $dYU3e.query)({
            query: (0, $aYbn7.default),
            variables: {
                contentId: resolvedContentId
            },
            context: {
                allowOnExternalPage: true
            },
            __callerPackage__: "external-share"
        }),
        (0, $ddSqr.preloadContentTitleWithByLineExternal)(resolvedContentId),
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        ...spaceKey && (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp') ? [
            (0, $8CHHT.preloadUseExtensionList)({
                contentId: resolvedContentId,
                spaceKey: spaceKey,
                moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
            })
        ] : []
    ]);
};








const $149b2696471ec09e$export$5ff0d8e28a402df2 = async (shareToken)=>{
    const result = await (0, $dYU3e.query)({
        query: (0, $73cd2.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            // Without this the GraphQL middleware silently blocks the request.
            allowOnExternalPage: true
        },
        __callerPackage__: "external-share"
    });
    const singleContent = result?.data?.singleContent;
    const contentId = singleContent?.id;
    const space = singleContent?.space;
    const spaceKey = space?.alias || space?.key;
    if (!contentId || !spaceKey) return undefined;
    return {
        contentId: contentId,
        spaceKey: spaceKey,
        type: singleContent?.type ?? null,
        subType: singleContent?.subType ?? null
    };
};









var $83sfO = parcelRequire("83sfO");














var $fdq4F = parcelRequire("fdq4F");


var $ezNhb = parcelRequire("ezNhb");


var $5WLjq = parcelRequire("5WLjq");





/**
 * The token is resolved to `contentId`/`spaceKey` first because the URL carries neither. Delegating
 * to the same preloader the content type would use off this route keeps the preloaded query
 * variables identical to the ones the rendered components use; a partial match misses the cache and
 * re-requests during render.
 *
 * The live-doc branch needs no `isAccessLinkRoute` equivalent: the only consumer of that option is
 * `preloadContent`, which `preloadLivePageRoute` never calls.
 */ const $1f9d1c86f6a99b0e$var$preloadAccessLinkContent = async (match, url, isTransition, previousMatch)=>{
    const { shareToken: shareToken } = match.params;
    if (!(0, $6mKj3.expValEquals)('access_link_m2', 'isEnabled', true)) return (0, $189a8a30ba3005c8$export$517a8e5c755236cc)({
        shareToken: shareToken
    });
    const content = await (0, $149b2696471ec09e$export$5ff0d8e28a402df2)(shareToken);
    // Whiteboards and anything that is not a page still render through the simplified path.
    if (!content || content.type !== 'page') return (0, $189a8a30ba3005c8$export$517a8e5c755236cc)({
        shareToken: shareToken
    });
    const syntheticParams = {
        ...match.params,
        contentId: content.contentId,
        spaceKey: content.spaceKey
    };
    if (content.subType === (0, $83sfO.LIVE_PAGE_SUBTYPE)) return (0, $iUV81.preloadLivePageRoute)({
        ...match,
        params: syntheticParams
    }, url);
    return (0, $445d6fd463fd83fa$export$9503d022471fff24)({
        ...match,
        params: syntheticParams
    }, url, isTransition, previousMatch, // Lets a space-scoped 403 through rather than showing the restriction screen. A flag, not
    // URL sniffing, so it holds under SSR.
    {
        isAccessLinkRoute: true
    });
};
const $1f9d1c86f6a99b0e$export$5da6d89b949b94fc = (match, url, isTransition = false, previousMatch = null)=>{
    const tasks = [];
    if ((0, $6mKj3.expVal)('shareable_links_m0', 'isEnabled', false)) // Pushed as a task, not awaited: `waitForAllReturnWhenError` only absorbs rejections from
    // promises inside this array, and awaiting would serialise the side-nav preloads below
    // behind the token lookup even when the gate is off.
    tasks.push($1f9d1c86f6a99b0e$var$preloadAccessLinkContent(match, url, isTransition, previousMatch));
    const { accessStatus: accessStatus } = (0, $xwvlW.getPreloaderFnContext)();
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (isLicensed) tasks.push((0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
        const sideNavTasks = [
            (0, $5WLjq.preloadSpacesList)({
                isLicensed: isLicensed
            })
        ];
        if ((0, $6mKj3.expValEquals)('confluence_react_streaming_all_routes', 'isEnabled', true)) sideNavTasks.push((0, $bFNdd.preloadPostOfficeConfluenceSideNav)());
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('navx-global-side-nav-confluence')) {
            sideNavTasks.push((0, $fdq4F.preloadPlatformNavigationQuery)());
            // No-ops unless both cloudId and userId are set.
            sideNavTasks.push((0, $ezNhb.preloadInvitedAppShortcutsRecommendationsQuery)());
        }
        return sideNavTasks;
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};






const $d3b88206c55934ef$export$bd1c07b274fefbd7 = (match)=>(0, $lyWac.waitForAllReturnWhenError)([
        (0, $189a8a30ba3005c8$export$517a8e5c755236cc)({
            shareToken: match.params.externalToken,
            contentId: match.params.contentId === 'undefined' ? undefined : match.params.contentId
        })
    ]);






























const $0ef4e79dd69588ad$export$9f53340e87bacbbd = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    // ContentHistory renders PagePrerequisites, so it sits behind the same ViewPageGateway
    // AdminKeyQuery gate as the view page. See preloadIsSuperAdmin for the conditions under which
    // it issues a request; it is a no-op for everyone else.
    tasks.push((0, $9388622078562d65$export$8a2490b7cfbfffb0)());
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { cloudId: cloudId } = preloadedSessionContext;
    // Since this query is not called in ContentPrerequisites when contentId is
    // missing, we should follow the same reasoning and skip preload when content is
    // missing.
    if (contentId) tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
    // Standalone Restrictions button needs to have its data preloaded
    tasks.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, false));
    // Presence Avatar Visibility
    tasks.push((0, $gSV4C.preloadPresenceSettings)({
        cloudId: cloudId,
        spaceKey: spaceKey
    }));
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if ((0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};












const $29ace679d934655d$export$7cbbf2d30ca863e7 = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    // AttachmentsPage renders PagePrerequisites, so it sits behind the same ViewPageGateway
    // AdminKeyQuery gate as the view page. See preloadIsSuperAdmin for the conditions under which
    // it issues a request; it is a no-op for everyone else.
    tasks.push((0, $9388622078562d65$export$8a2490b7cfbfffb0)());
    // Since this query is not called in ContentPrerequisites when contentId is
    // missing, we should follow the same reasoning and skip preload when content is
    // missing.
    if (contentId) tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey, {
        status: [
            'current',
            'draft',
            'archived'
        ]
    }));
    tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};












var $2XnBq = parcelRequire("2XnBq");


var $c3rPL = parcelRequire("c3rPL");


var $fTRoC = parcelRequire("fTRoC");

const $56598c99b0873296$export$c62ad5a6ea4b44c9 = async ({ cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn })=>{
    if (!(0, $fTRoC.hasStudioPermissionsBaseEligibility)({
        cloudId: cloudId,
        isRovoLLMEnabled: isRovoLLMEnabled,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn
    }) || !(0, $9wGTI.fg)('cc_automations_studio_workspace_capabilities')) return;
    const siteAri = (0, $fTRoC.getStudioWorkspaceLookupSiteAri)(cloudId);
    if (!siteAri) return;
    const workspaceResult = await (0, $dYU3e.queryAgg)({
        query: (0, $2XnBq.default),
        variables: {
            siteAri: siteAri
        },
        relayQueryPreloadRetention: 'environment',
        __callerPackage__: "automation-discovery"
    });
    const studioWorkspaceAri = (0, $fTRoC.getLinkedStudioWorkspaceAri)(workspaceResult.data);
    if (!studioWorkspaceAri) return [
        workspaceResult
    ];
    const capabilitiesResult = await (0, $dYU3e.queryAgg)({
        query: (0, $c3rPL.default),
        variables: {
            workspaceId: studioWorkspaceAri.toString()
        },
        relayQueryPreloadRetention: 'environment',
        __callerPackage__: "automation-discovery"
    });
    return [
        workspaceResult,
        capabilitiesResult
    ];
};












var $gGK1T = parcelRequire("gGK1T");


var $2E1L5 = parcelRequire("2E1L5");

function $434ee60a7b6c6c34$export$b00a1ce9bc36f6f2(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $gGK1T.default),
        variables: {
            contentId: contentId,
            limit: (0, $2E1L5.DEFAULT_CONTRIBUTORS_FETCH_LIMIT)
        },
        __callerPackage__: "content-ownership"
    });
}
















var $duklN = parcelRequire("duklN");


var $8N95V = parcelRequire("8N95V");


var $fDjhq = parcelRequire("fDjhq");


var $7jfZt = parcelRequire("7jfZt");

/**
 * Warms `FolderOverviewChildrenContentQuery` (child history + collaborators) once
 * the overview result is known.
 *
 * This is a chained preload: the enrichment query's `ids` depend on the child ids
 * returned by the first-page query. It runs last so it does not block the
 * independent preloads. The `ids` must match the component's first-render request
 * exactly (order included) or the SSR-warmed store snapshot is treated as
 * incomplete and the columns render blank — see `FolderOverview.tsx`.
 */ async function $fbd9f14d3be2d912$var$preloadChildrenContent(overviewTask, extractChildIds) {
    const { data: data, hasErrors: hasErrors } = await overviewTask;
    if (hasErrors || !data) return;
    const childIds = extractChildIds(data);
    if (childIds.length === 0) return;
    return (0, $dYU3e.query)({
        query: (0, $8N95V.default),
        variables: {
            ids: childIds
        },
        __callerPackage__: "folder"
    });
}
/**
 * Warms the archived banner's queries once the overview result shows the folder is archived.
 *
 * The overview only returns `singleContent.status` when `confluence_archive_folder` is on, so this
 * is a no-op for active folders and when the experiment is off. An archived folder's children
 * stream errors by design, so unlike the children preload this reads `data` even when
 * `hasErrors` is set.
 */ async function $fbd9f14d3be2d912$var$preloadArchivedBanner(overviewTask, contentId, extractStatus) {
    const { data: data } = await overviewTask;
    if (!data || extractStatus(data) !== (0, $aqBZ0.CONTENT_STATUS_ARCHIVED)) return;
    await (0, $12c3454d795c5c51$export$3ae0996a709f5fba)(contentId);
}
async function $fbd9f14d3be2d912$export$238042884af28457(contentId, { cloudId: cloudId, spaceKey: spaceKey } = {}) {
    // Preload the folder header title. `FolderHeader` → `FolderInlineTitle`
    // consumes it via `usePageTitle`, which only fetches on the client; without
    // this the folder title renders empty during SSR.
    const titleQueryTask = (0, $dYU3e.query)({
        query: (0, $duklN.default),
        variables: {
            contentId: contentId
        },
        __callerPackage__: "folder"
    });
    const overviewQueryTask = (0, $dYU3e.query)({
        query: (0, $fDjhq.default),
        // These variables MUST match the ones passed by `useDualStreamPagination`
        // (empty-string fallbacks for cloudId/spaceKey included) so the store
        // snapshot is complete for the component's operation on SSR.
        variables: {
            cloudId: cloudId ?? '',
            parentId: contentId,
            spaceKey: spaceKey ?? '',
            contentId: contentId,
            first: (0, $7jfZt.FETCH_SIZE),
            includeDevDocsSyncStatus: (0, $6mKj3.expVal)('confluence_dev_docs', 'isEnabled', false),
            includeFolderSummary: (0, $6mKj3.expVal)('confluence_folder_summary', 'isEnabled', false),
            includeArchiveFolderSupport: (0, $6mKj3.expVal)('confluence_archive_folder', 'isEnabled', false),
            // The byline render owns exposure; preloading must use the same non-exposing decision.
            // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation -- exposure is recorded when the byline can render
            includeJiraPlannerConnection: (0, $6mKj3.UNSAFE_expValEqualsNoExposure)('ai_planner_icon_with_confluence_folder', 'isEnabled', true)
        },
        __callerPackage__: "folder"
    });
    // Chain the children-content and archived-banner preloads off the overview result.
    const childrenQueryTask = $fbd9f14d3be2d912$var$preloadChildrenContent(overviewQueryTask, (data)=>(0, $7jfZt.getInitialVisibleChildIds)(data.folders, data.content));
    const bannerQueryTask = $fbd9f14d3be2d912$var$preloadArchivedBanner(overviewQueryTask, contentId, (data)=>data.singleContent?.status);
    // `waitForAllReturnWhenError` submits any task errors for observability and
    // resolves to `Error[]` on failure or `undefined` on success — its
    // `Awaited<T>[]` return arm is never produced at runtime, so narrow to the
    // real success/error contract.
    const errors = await (0, $lyWac.waitForAllReturnWhenError)([
        overviewQueryTask,
        titleQueryTask,
        childrenQueryTask,
        bannerQueryTask
    ]);
    return Array.isArray(errors) ? errors : undefined;
}



















var $ieWRE = parcelRequire("ieWRE");


var $84kyw = parcelRequire("84kyw");

const $2c7b09695f067c18$export$d0af89ed4f3cce26 = ({ contentId: contentId, spaceKey: spaceKey, isRovoEnabled: isRovoEnabled })=>{
    if (!contentId || !spaceKey || !isRovoEnabled || (0, $6mKj3.expVal)('confluence_smart_folders_milestone', 'value', 0) < 2) return Promise.resolve([]);
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $ieWRE.default),
            variables: {
                spaceKey: spaceKey
            },
            __callerPackage__: "smart-folder"
        }),
        (0, $dYU3e.query)({
            query: (0, $84kyw.default),
            variables: {
                contentId: contentId
            },
            __callerPackage__: "smart-folder"
        })
    ]);
};


const $ae578b27499cf6ef$export$4286139fad35252 = async (match)=>{
    const { isLicensed: isLicensed, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn, cloudId: cloudId } = (0, $xwvlW.getPreloaderFnContext)();
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    const tasks = [];
    if (contentId) {
        // Core folder data: the dual-stream overview content query, the
        // children-content query, and the folder header title.
        // cloudId + spaceKey are required by the dual-stream content query.
        tasks.push((0, $fbd9f14d3be2d912$export$238042884af28457)(contentId, {
            cloudId: cloudId,
            spaceKey: spaceKey
        }));
        // Fetch content status/redirect — required by FolderPrerequisites
        tasks.push((0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey));
        // Preload the sticky ContentTypesHeader shown at the top of FolderOverview
        tasks.push((0, $4zhNK.preloadContentTypesHeader)(contentId));
        // Warm the ownership/contributors query consumed by BadgeStylePageOwnershipByline in FolderHeader
        tasks.push((0, $434ee60a7b6c6c34$export$b00a1ce9bc36f6f2)(contentId));
        if (spaceKey) // Warm smart-folder enablement + ancestor data used to decide whether the
        // empty-state connection UX can render during SSR.
        tasks.push((0, $2c7b09695f067c18$export$d0af89ed4f3cce26)({
            contentId: contentId,
            spaceKey: spaceKey,
            isRovoEnabled: isRovoEnabled
        }));
        // Warm the Studio permission check that decides whether AutomationsPanelButton renders.
        if ((0, $6mKj3.UNSAFE_expValEqualsNoExposure)('confluence-automations-keep-up-to-date', 'isEnabled', true)) tasks.push((0, $56598c99b0873296$export$c62ad5a6ea4b44c9)({
            cloudId: cloudId,
            isRovoLLMEnabled: isRovoLLMEnabled,
            accessStatus: accessStatus,
            isLoggedIn: isLoggedIn
        }));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};














const $e6a21086b65e01ae$export$878ae3f236acea00 = async (match)=>{
    const tasks = [];
    const { contentId: contentId, spaceKey: spaceKey } = match.params;
    // Preload the Forge extension list so that window.__SSR_FORGE_EXTENSIONS__ is populated
    // before ForgeMacro mounts. Without this, ForgeMacro's isStaticExtension() check returns
    // false (the extension list query hasn't resolved yet), causing it to skip subscribing to
    // the store and render the iframe fallback instead of the static HTML from confluence_staticMacros.
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (contentId && (0, $9wGTI.fg)('conf_frontend_forge_static_macro_mvp')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};










const $d69cc82c95e4501a$export$8172f32d98fe4fa9 = async (cloudId)=>{};


parcelRequire("8nle6");
var $jLyos = parcelRequire("jLyos");








var $5IsL6 = parcelRequire("5IsL6");





























var $iaK3p = parcelRequire("iaK3p");

const $8741a5de3be893c9$export$3764d460af2e353f = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $iaK3p.default),
        __callerPackage__: "feature-discovery"
    });
};








const $69ec3a471529e315$export$34e54806d88e1d6d = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $3FO8k.default),
            variables: {
                key: (0, $dBcar.NTH_USER_AUTO_FOLLOW_SPACES).HAS_AUTO_FOLLOWED_SPACES
            },
            __callerPackage__: "onboarding-helpers"
        }),
        (0, $8741a5de3be893c9$export$3764d460af2e353f)()
    ]);
};















var $Yc1IN = parcelRequire("Yc1IN");


var $g4evd = parcelRequire("g4evd");


var $lNpDX = parcelRequire("lNpDX");


var $d7td2 = parcelRequire("d7td2");

const $f413d4da5ba15b92$export$77a2c40a93849218 = ({ isLoggedIn: isLoggedIn })=>{
    // If the user is not logged in we show the following feed by default
    // so only preload that feed. If the user is logged in preload both
    // feeds and the feed preference
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $xwvlW.getPreloaderFnContext)();
    const followingFeedQuery = (0, $dYU3e.queryAgg)({
        query: (0, $Yc1IN.default),
        variables: {
            first: (0, $6mKj3.expVal)('confluence_home_feed_initial_page_size', 'following_ssr', 5)
        },
        __callerPackage__: "feed"
    });
    // Select the popular-feed query to preload. Decision order MUST mirror
    // `usePopularFeedWithTimeGranularityStorage`'s client-side selection so the
    // SSR-cached response matches the query the client fires on hydration.
    // Otherwise SSR users would suffer a cache miss + re-fetch, negating the
    // latency win for the very users we care most about (first paint).
    //
    //   - V2 (parallel)            when isRovoLLMEnabled
    //   - vanilla V1               otherwise
    const popularFirstCount = 10;
    let popularFeedDataQuery;
    if (isRovoLLMEnabled) // V2 (parallel hydration) — node-level aiProperty, AGG calls cc-smarts
    // in parallel with the Confluence content hop. We only enter this
    // branch when `isRovoLLMEnabled` is true, so the V2 query variable can
    // be passed `true` unconditionally.
    popularFeedDataQuery = (0, $dYU3e.queryAgg)({
        query: (0, $d7td2.default),
        variables: {
            first: popularFirstCount,
            isRovoLLMEnabled: true
        },
        __callerPackage__: "feed"
    });
    else // Vanilla V1 (no AI snippets) — the safe fallback for non-Rovo users,
    // who cannot be served AI snippets at all.
    popularFeedDataQuery = (0, $dYU3e.query)({
        query: (0, $lNpDX.default),
        variables: {
            first: popularFirstCount
        },
        __callerPackage__: "feed"
    });
    const popularFeedQuery = [
        popularFeedDataQuery,
        (0, $dYU3e.query)({
            query: (0, $g4evd.default),
            __callerPackage__: "feed"
        })
    ];
    const tasks = [
        followingFeedQuery
    ];
    if (isLoggedIn) tasks.push(...popularFeedQuery);
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};





var $6YxJf = parcelRequire("6YxJf");



/* eslint-disable import-extensions/file-extension-required */ 

















var $1gy7x = parcelRequire("1gy7x");

const $e192ddb06e08d8ca$export$853a2dce20c9140 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $1gy7x.PERSONALIZED_TEMPLATES_V2_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "experiment-personalized-templates-v2"
    });
};









var $eyUJP = parcelRequire("eyUJP");



const $fe35e2c6f7a7af9b$export$67d796e2874a7983 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $eyUJP.NTH_USER_HOME_ONBOARDING_REVAMP_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "experiment-personalized-templates-v2"
    });
};



var $byPOx = parcelRequire("byPOx");


var $lWFZM = parcelRequire("lWFZM");


var $l57Xv = parcelRequire("l57Xv");


var $c8Y4F = parcelRequire("c8Y4F");

const $6dafd0e2e7720a45$export$3687d58480022124 = (userId, accessStatus)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $byPOx.default),
            __callerPackage__: "experiment-personalized-templates-v2"
        }),
        (0, $dYU3e.query)({
            query: (0, $lWFZM.default),
            __callerPackage__: "experiment-personalized-templates-v2"
        }),
        ...accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS ? [
            (0, $dYU3e.queryAgg)({
                query: (0, $l57Xv.default),
                variables: {
                    accountId: userId || ''
                },
                __callerPackage__: "experiment-personalized-templates-v2"
            })
        ] : [],
        ...accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS ? [
            (0, $e192ddb06e08d8ca$export$853a2dce20c9140)()
        ] : [],
        (0, $fe35e2c6f7a7af9b$export$67d796e2874a7983)(),
        (0, $dYU3e.query)({
            query: (0, $c8Y4F.default),
            __callerPackage__: "experiment-personalized-templates-v2"
        })
    ]);
};











const $c81a9dc13c505c10$export$42b064b77c9ba75f = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                // For the banner and cards
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).SELECTED_TEMPLATES,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_AT,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).DISMISSED_HEADER,
                (0, $dBcar.USE_CASES_NTH_USER_ONBOARDING).VIEWED_HEADER
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};









var $b4VFP = parcelRequire("b4VFP");




const $e5a69db009315bb4$export$f8fb9f2632d64c50 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: [
                (0, $dBcar.ONBOARDING_EXPERIENCES).IS_FOUNDING_ADMIN,
                ...Object.values((0, $b4VFP.HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS))
            ]
        },
        __callerPackage__: "onboarding-helpers"
    });
};






var $2fsJn = parcelRequire("2fsJn");







/**
 * @generated SignedSource<<614722153aca82d9dabeb40fc48ec31c>>
 * @relayHash ddee5bcc7d51d2ed5555d8cc6f48ec88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 28d394c12f422131aed5b9fb5279cc5096ef0d8e677d3789fcf89b22b34d31b6
const $724e41e8cbd5c99e$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "key"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "key",
                    "value": [
                        "templates-collection:isTaggedForTemplatesCollectionExperiment",
                        "templates-collection:isTemplatesSectionDismissed",
                        "onboarding-state:introWorkflow",
                        "onboarding-state:legacy",
                        "onboarding-state:isFoundingAdmin",
                        "onboarding-state:isSampleContentV2SpotlightVisible",
                        "onboarding-state:landOnPath",
                        "onboarding-state:teamSpaceCreated",
                        "onboarding-state:isMoreActionsTourVisible",
                        "onboarding-state:isMoreActionsHintVisible",
                        "onboarding-state:improvedGetStartedPath",
                        "onboarding-state:improvedGetStartedWhiteboardPath",
                        "onboarding-state:nthUserGSPagePath",
                        "onboarding-state:isRedactionsTourVisible",
                        "onboarding-state:xflowSpaceCreated",
                        "onboarding-state:templateOnboardingViewedTime",
                        "onboarding-state:nthUserOnboardingCompletedTimestamp",
                        "onboarding-state:nthUserOnboardingFlagViewed",
                        "onboarding-state:nthUserOnboardingPageViewed",
                        "onboarding-state:nthUserBannerDismissed"
                    ]
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ],
            "storageKey": "onboardingState(key:[\"templates-collection:isTaggedForTemplatesCollectionExperiment\",\"templates-collection:isTemplatesSectionDismissed\",\"onboarding-state:introWorkflow\",\"onboarding-state:legacy\",\"onboarding-state:isFoundingAdmin\",\"onboarding-state:isSampleContentV2SpotlightVisible\",\"onboarding-state:landOnPath\",\"onboarding-state:teamSpaceCreated\",\"onboarding-state:isMoreActionsTourVisible\",\"onboarding-state:isMoreActionsHintVisible\",\"onboarding-state:improvedGetStartedPath\",\"onboarding-state:improvedGetStartedWhiteboardPath\",\"onboarding-state:nthUserGSPagePath\",\"onboarding-state:isRedactionsTourVisible\",\"onboarding-state:xflowSpaceCreated\",\"onboarding-state:templateOnboardingViewedTime\",\"onboarding-state:nthUserOnboardingCompletedTimestamp\",\"onboarding-state:nthUserOnboardingFlagViewed\",\"onboarding-state:nthUserOnboardingPageViewed\",\"onboarding-state:nthUserBannerDismissed\"])"
        },
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "team"
                },
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                v0 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "preloadTemplatesCollectionEligibleQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "preloadTemplatesCollectionEligibleQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "ddee5bcc7d51d2ed5555d8cc6f48ec88",
            "id": "28d394c12f422131aed5b9fb5279cc5096ef0d8e677d3789fcf89b22b34d31b6",
            "metadata": {},
            "name": "preloadTemplatesCollectionEligibleQuery",
            "operationKind": "query",
            "text": "query preloadTemplatesCollectionEligibleQuery{onboardingState(key:[\"templates-collection:isTaggedForTemplatesCollectionExperiment\",\"templates-collection:isTemplatesSectionDismissed\",\"onboarding-state:introWorkflow\",\"onboarding-state:legacy\",\"onboarding-state:isFoundingAdmin\",\"onboarding-state:isSampleContentV2SpotlightVisible\",\"onboarding-state:landOnPath\",\"onboarding-state:teamSpaceCreated\",\"onboarding-state:isMoreActionsTourVisible\",\"onboarding-state:isMoreActionsHintVisible\",\"onboarding-state:improvedGetStartedPath\",\"onboarding-state:improvedGetStartedWhiteboardPath\",\"onboarding-state:nthUserGSPagePath\",\"onboarding-state:isRedactionsTourVisible\",\"onboarding-state:xflowSpaceCreated\",\"onboarding-state:templateOnboardingViewedTime\",\"onboarding-state:nthUserOnboardingCompletedTimestamp\",\"onboarding-state:nthUserOnboardingFlagViewed\",\"onboarding-state:nthUserOnboardingPageViewed\",\"onboarding-state:nthUserBannerDismissed\"]){key,value},confluence_tenantContext{licensedProducts{licenseStatus,productKey}},user:confluence_atlassianUser{id,team,confluence{hasPersonalSpace,space{id,key}}}}"
        }
    };
}();
$724e41e8cbd5c99e$var$node.hash = "2e478de184cf22dbf9c640f31ec7f723";
var $724e41e8cbd5c99e$export$2e2bcd8739ae039 = $724e41e8cbd5c99e$var$node;





const $b7411e454a753e13$var$PreloadTemplatesCollectionEligibleQuery = (0, $724e41e8cbd5c99e$export$2e2bcd8739ae039);
const $b7411e454a753e13$export$61d1d0b9775c631b = ()=>(0, $dYU3e.query)({
        query: $b7411e454a753e13$var$PreloadTemplatesCollectionEligibleQuery,
        __callerPackage__: "home"
    });











const $fedd9a86a97c3653$export$520ec834118606cc = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $3FO8k.default),
        variables: {
            key: Object.values({
                ...(0, $dBcar.ONBOARDING_INTENT_EXPERIENCES),
                ...(0, $dBcar.ONBOARDING_EXPERIENCES)
            })
        },
        __callerPackage__: "onboarding-helpers"
    });
};






var $aSQ2H = parcelRequire("aSQ2H");

const $94117ca0130c8194$export$1cf448b10191509a = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $aSQ2H.default),
        __callerPackage__: "onboarding-helpers"
    });
};





const $b8044be2d73de97b$export$609c06e14413a6a4 = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $fedd9a86a97c3653$export$520ec834118606cc)(),
        (0, $94117ca0130c8194$export$1cf448b10191509a)()
    ]);
};






var $lkQRq = parcelRequire("lkQRq");

function $d85b408e33b913ac$export$d97df32fa415897c({ isLicensed: isLicensed }) {
    if (!isLicensed) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $lkQRq.default),
        __callerPackage__: "home"
    });
}


const $ef1b2e92c64fee29$export$3e66106e6cf0fa15 = ({ isLicensed: isLicensed })=>{
    return (0, $d85b408e33b913ac$export$d97df32fa415897c)({
        isLicensed: isLicensed
    });
};






var $cMfVN = parcelRequire("cMfVN");

function $4f0b16a97f4cdcc7$export$a3d255f35641358b() {
    return (0, $dYU3e.query)({
        query: (0, $cMfVN.default),
        __callerPackage__: "home"
    });
}


parcelRequire("gSgn8");












var $3U2Qo = parcelRequire("3U2Qo");


var $fFEmG = parcelRequire("fFEmG");


var $ka7BG = parcelRequire("ka7BG");


var $kCweT = parcelRequire("kCweT");

function $0d6846b78b55d375$export$8618d910fb9e3443(args) {
    return (0, $lyWac.waitForAllReturnWhenError)([
        $0d6846b78b55d375$var$preloadAgentsWaitingForYourInputSessions(args),
        $0d6846b78b55d375$var$preloadRecentAgentSessions(args)
    ]);
}
/**
 * Preloads the first page of the sessions. Their associations are loaded when rendering.
 */ async function $0d6846b78b55d375$var$preloadAgentsWaitingForYourInputSessions({ cloudId: cloudId, userId: userId }) {
    // SSR preloaders do not receive Admin Hub AI eligibility yet
    if (!(0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'version', 2) && !(0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'version', 3)) return [];
    const { result: rovoActivationResult, rovoActivationId: rovoActivationId } = await $0d6846b78b55d375$var$preloadRovoActivationId(cloudId);
    if (!rovoActivationId) return [
        rovoActivationResult
    ];
    const since = (0, $kCweT.getAgentsWaitingForYourInputSince)();
    const sessionsResult = await (0, $dYU3e.queryAgg)({
        query: (0, $3U2Qo.default),
        variables: (0, $kCweT.getRecentAgentSessionsQueryVariables)({
            first: (0, $kCweT.AGENTS_WAITING_FOR_YOUR_INPUT_PAGE_SIZE),
            rovoActivationId: rovoActivationId,
            since: since,
            userId: userId
        }),
        __callerPackage__: "home"
    });
    return [
        rovoActivationResult,
        sessionsResult
    ];
}
async function $0d6846b78b55d375$var$preloadRecentAgentSessions({ cloudId: cloudId, userId: userId }) {
    if (!(0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'isEnabled', true) || (0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'version', 2) || (0, $6mKj3.expValEquals)('cc_ai_agentic_sessions', 'version', 3)) return [];
    const { result: rovoActivationResult, rovoActivationId: rovoActivationId } = await $0d6846b78b55d375$var$preloadRovoActivationId(cloudId);
    if (!rovoActivationId) return [
        rovoActivationResult
    ];
    const sessionsResult = await (0, $dYU3e.queryAgg)({
        query: (0, $fFEmG.default),
        variables: (0, $kCweT.getRecentAgentSessionsQueryVariables)({
            userId: userId,
            rovoActivationId: rovoActivationId
        }),
        __callerPackage__: "home"
    });
    return [
        rovoActivationResult,
        sessionsResult
    ];
}
async function $0d6846b78b55d375$var$preloadRovoActivationId(cloudId) {
    const result = await (0, $dYU3e.queryAgg)({
        query: (0, $ka7BG.default),
        variables: {
            cloudId: cloudId
        },
        __callerPackage__: "home"
    });
    const data = result.data;
    return {
        result: result,
        rovoActivationId: data?.tenantContexts?.[0]?.activationIdByProduct?.active
    };
}



var $a67vB = parcelRequire("a67vB");


var $y9T5W = parcelRequire("y9T5W");

const $5a0086fce17702fe$var$preloadRecentWork = (args)=>{
    const queryOptions = (0, $a67vB.getRecentWorkQueryOptions)(args);
    if (queryOptions.skip) return Promise.resolve({});
    return (0, $dYU3e.queryAgg)({
        ...queryOptions,
        __callerPackage__: "home"
    });
};
const $5a0086fce17702fe$export$afe654e7a7c068fa = ({ userId: userId, cloudId: cloudId, isLicensed: isLicensed, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false })=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { accessStatus: accessStatus } = preloadedSessionContext;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    const tasks = [
        $5a0086fce17702fe$var$preloadRecentWork({
            cloudId: cloudId,
            isLoggedIn: !!userId,
            isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
            isDatabaseEnabled: isDatabaseEnabled,
            isSlidesEnabled: isSlidesEnabled,
            first: (0, $y9T5W.ALL_RECENT_ITEMS_COUNT_HOME_REFRESH)
        }),
        (0, $f413d4da5ba15b92$export$77a2c40a93849218)({
            isLoggedIn: !!userId
        }),
        (0, $ef1b2e92c64fee29$export$3e66106e6cf0fa15)({
            isLicensed: isLicensed
        }),
        (0, $4f0b16a97f4cdcc7$export$a3d255f35641358b)()
    ];
    if (userId) {
        tasks.push((0, $0d6846b78b55d375$export$8618d910fb9e3443)({
            cloudId: cloudId,
            userId: userId
        }));
        tasks.push((0, $b8044be2d73de97b$export$609c06e14413a6a4)(), (0, $b7411e454a753e13$export$61d1d0b9775c631b)());
        if (isLicensed && canAccessHome) {
            tasks.push((0, $69ec3a471529e315$export$34e54806d88e1d6d)());
            tasks.push((0, $e5a69db009315bb4$export$f8fb9f2632d64c50)());
            tasks.push((0, $c81a9dc13c505c10$export$42b064b77c9ba75f)());
        }
    }
    if (isLicensed && canAccessHome && userId && accessStatus) tasks.push((0, $6dafd0e2e7720a45$export$3687d58480022124)(userId, accessStatus));
    const unifiedSpacePreloader = (0, $2fsJn.preloadPersistentInviteButtonEligible)({
        spaceKey: undefined
    }, false);
    if (unifiedSpacePreloader) // @ts-ignore-next-line
    tasks.push(unifiedSpacePreloader); //type can be undefined, but the surrounding conditional prevents it
    // https://switcheroo.atlassian.com/ui/gates/e8661ed8-caef-4eed-a747-bf4d58be15c9/key/post-office_enable-confluence-home-banner
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (userId && canAccessHome && isLicensed && (0, $9wGTI.fg)('post-office_enable-confluence-home-banner')) {
        // Confluence Home Banner in SSR
        const preloadPostOfficeHomeBanner = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceHomeBanner', async ()=>{
                const result = await (0, $6YxJf.preloadPostOfficeConfluenceHomeBanner)();
                return result ?? {};
            });
        };
        tasks.push(preloadPostOfficeHomeBanner());
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};


















var $igBnm = parcelRequire("igBnm");

const $e4b2bfbed97961bc$export$a8fc7c44e5aafa61 = ({ isLoggedIn: isLoggedIn })=>{
    if (!isLoggedIn) return Promise.resolve({});
    return (0, $dYU3e.query)({
        query: (0, $igBnm.default),
        __callerPackage__: "home"
    });
};



var $k2RxH = parcelRequire("k2RxH");


var $5dcQK = parcelRequire("5dcQK");

const $914eb87cd194adde$export$daee90b6ccc653e0 = ({ cloudId: cloudId, isLoggedIn: isLoggedIn, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled, isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled, isDatabaseEnabled: isDatabaseEnabled })=>{
    const isDatabaseEnabledResolved = isDatabaseEnabled ?? (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.queryAgg)({
            ...(0, $k2RxH.getRecentQueryOptions)({
                pill: 'all',
                cloudId: cloudId,
                endCursor: '',
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isWhiteboardUpdatedEnabled: isWhiteboardUpdatedEnabled,
                isDatabaseEnabled: isDatabaseEnabledResolved,
                // Read without exposure, so it's logged only when the list renders. The page sends the same
                // variables, so it reuses this result.
                include3P: (0, $6mKj3.UNSAFE_expValNoExposure)('confluence_recent_3p_activities', 'isEnabled', false)
            }),
            __callerPackage__: "home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        }),
        ...isLoggedIn ? [
            (0, $dYU3e.query)({
                query: (0, $5dcQK.default),
                __callerPackage__: "home"
            })
        ] : []
    ]);
};










var $1abNy = parcelRequire("1abNy");

const $82a332f3eb0b7b32$var$PAGE_SIZE = 24;
const $82a332f3eb0b7b32$export$9151a9689f071b49 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $1abNy.default),
            variables: {
                limit: $82a332f3eb0b7b32$var$PAGE_SIZE,
                start: 0
            },
            __callerPackage__: "home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};


/* eslint-disable import-extensions/file-extension-required */ 







var $d64J2 = parcelRequire("d64J2");


var $kgC8N = parcelRequire("kgC8N");

const $db48a3960bd53439$export$ef22b7398f0c0746 = ({ isLoggedIn: isLoggedIn })=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $d64J2.default),
            variables: (0, $kgC8N.DRAFTS_QUERY_OPTIONS).variables,
            __callerPackage__: "home"
        }),
        (0, $e4b2bfbed97961bc$export$a8fc7c44e5aafa61)({
            isLoggedIn: isLoggedIn
        })
    ]);
};



var $01STT = parcelRequire("01STT");

const $f65ab46c8acdebd2$var$getSelectedView = (matchParams)=>{
    const view = matchParams?.view;
    return Object.values((0, $01STT.View)).includes(view) ? view : (0, $01STT.View).OVERVIEW;
};
const $f65ab46c8acdebd2$var$preloadSelectedView = ({ cloudId: cloudId, isLicensed: isLicensed, userId: userId, matchParams: matchParams, isWhiteboardViewedEnabled: isWhiteboardViewedEnabled = false, isDatabaseEnabled: isDatabaseEnabled = false, isSlidesEnabled: isSlidesEnabled = false })=>{
    if (!cloudId) return Promise.resolve({});
    const isLoggedIn = Boolean(userId);
    const selectedView = $f65ab46c8acdebd2$var$getSelectedView(matchParams);
    switch(selectedView){
        case (0, $01STT.View).RECENT:
            return (0, $914eb87cd194adde$export$daee90b6ccc653e0)({
                cloudId: cloudId,
                isLoggedIn: isLoggedIn,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isDatabaseEnabled: isDatabaseEnabled
            });
        case (0, $01STT.View).STARRED:
            return (0, $82a332f3eb0b7b32$export$9151a9689f071b49)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).DRAFTS:
            return (0, $db48a3960bd53439$export$ef22b7398f0c0746)({
                isLoggedIn: isLoggedIn
            });
        case (0, $01STT.View).OVERVIEW:
        default:
            return (0, $5a0086fce17702fe$export$afe654e7a7c068fa)({
                userId: userId,
                cloudId: cloudId,
                isLicensed: isLicensed,
                isWhiteboardViewedEnabled: isWhiteboardViewedEnabled,
                isDatabaseEnabled: isDatabaseEnabled,
                isSlidesEnabled: isSlidesEnabled
            });
    }
};
const $f65ab46c8acdebd2$export$ae91664215c56ac5 = (options)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('side-navigation', ()=>{
            const sideNavTasks = [
                (0, $5WLjq.preloadSpacesList)({
                    //preloads left nav
                    isLicensed: options.isLicensed
                })
            ];
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            if ((0, $9wGTI.fg)('navx-global-side-nav-confluence')) {
                sideNavTasks.push((0, $fdq4F.preloadPlatformNavigationQuery)());
                // No-ops unless both cloudId and userId are set.
                sideNavTasks.push((0, $ezNhb.preloadInvitedAppShortcutsRecommendationsQuery)());
            }
            return sideNavTasks;
        }),
        (0, $5IsL6.preloadCreateSpace)({
            isLicensed: options.isLicensed
        }),
        $f65ab46c8acdebd2$var$preloadSelectedView(options)
    ]);
};

















const $179951d621935e1e$export$cefc517f3ae2aa98 = async (match)=>{
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { userId: userId, cloudId: cloudId, accessStatus: accessStatus } = preloadedSessionContext;
    const isDatabasesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('database');
    const isSlidesEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('slide');
    const isWhiteboardsEnabled = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const tasks = [];
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const canAccessHome = accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';
    //All top Navigation preloading is done in next/packages/query-preloaders/src/index.ts
    if (isLicensed && canAccessHome) {
        // MainLayout needs this before rendering, outside the Home content Suspense boundary.
        if (match.name === (0, $1NBp8.HOME).name && userId) tasks.push((0, $d69cc82c95e4501a$export$8172f32d98fe4fa9)(cloudId));
        tasks.push((0, $f65ab46c8acdebd2$export$ae91664215c56ac5)({
            cloudId: cloudId,
            isLicensed: isLicensed,
            userId: userId,
            matchParams: match.params,
            isWhiteboardViewedEnabled: isWhiteboardsEnabled,
            isDatabaseEnabled: isDatabasesEnabled,
            isSlidesEnabled: isSlidesEnabled
        }));
    }
    // Preload current user's personal space metadata for home route consumers(onboarding etc).
    tasks.push((0, $jLyos.preloadPersonalSpaceDetail)());
    tasks.push((0, $bFNdd.preloadPostOfficeConfluenceSideNav)());
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};









var $iwZYw = parcelRequire("iwZYw");

const $dfe1021c2b61fce7$export$eec5c6a2cd111615 = ()=>(0, $dYU3e.query)({
        query: (0, $iwZYw.default),
        __callerPackage__: "admin-announcement-banner"
    });






var $1hmAp = parcelRequire("1hmAp");

const $b5b554d7930e19fd$export$91ccde13a31d1982 = ()=>(0, $dYU3e.query)({
        query: (0, $1hmAp.default),
        __callerPackage__: "storage-enforcement"
    });


const $5368439faec350a5$export$6c7e4784651f052f = async ()=>{
    const { edition: edition } = (0, $xwvlW.getPreloaderFnContext)();
    const upperCaseEdition = edition?.toUpperCase() || '';
    if (upperCaseEdition === 'PREMIUM' || upperCaseEdition === 'STANDARD') return (0, $dfe1021c2b61fce7$export$eec5c6a2cd111615)();
    else if (upperCaseEdition === 'FREE') return (0, $b5b554d7930e19fd$export$91ccde13a31d1982)();
};












var $ctTo0 = parcelRequire("ctTo0");

async function $b018a9de51ee5cc4$export$daad0bec45611c67() {
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $xwvlW.getPreloaderFnContext)();
    if (!isLoggedIn || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_perms_ga_access_requests', 'isEnabled', true)) return;
    return (0, $dYU3e.query)({
        query: (0, $ctTo0.default),
        variables: {
            cloudId: cloudId
        },
        __callerPackage__: "access-requests"
    });
}












var $kdKo9 = parcelRequire("kdKo9");

async function $143cdfd4eb3dc7a0$export$f8ed1334515840af(spaceKey) {
    const result = await (0, $dYU3e.query)({
        query: (0, $kdKo9.default),
        variables: {
            spaceKey: spaceKey
        },
        errorPolicy: 'all',
        // Preloaders are called both on server at initial load AND transition on client-side.
        // On server-side it doesn't matter fetch policy because we only gonna request once.
        // On client-side it must be network-only to get fresh data.
        fetchPolicy: 'network-only',
        __callerPackage__: "restrictions"
    });
    window['__SPACE_RESTRICTED_CHECK_ERROR__'] = false;
    window['__SPACE_NOTFOUND_CHECK_ERROR__'] = false;
    if (result?.errors) result.errors.forEach((error)=>{
        const status_code = error?.extensions?.statusCode;
        if (status_code === 403) {
            window['__SPACE_RESTRICTED_CHECK_ERROR__'] = true;
            (0, $7Sm4c.markErrorAsHandled)(error);
        } else if (status_code === 404 || status_code === 400) {
            window['__SPACE_NOTFOUND_CHECK_ERROR__'] = true;
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
}


const $f7b10b9020854fc7$export$6fb7f9b73aaa748e = async (spaceKey)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $143cdfd4eb3dc7a0$export$f8ed1334515840af)(spaceKey),
        // Any route with a space key can land on RestrictedSpaceScreen, so this belongs here rather
        // than in individual route preloaders. Gating it on __SPACE_RESTRICTED_CHECK_ERROR__ was
        // tried and reverted — that global isn't reliably set by the time this task reads it.
        (0, $b018a9de51ee5cc4$export$daad0bec45611c67)()
    ]);
};


















async function $b4d670122e111714$export$e77946254f7ce879(match) {
    const tasks = [];
    const preloadedSessionContext = (0, $xwvlW.getPreloaderFnContext)();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId, isRovoEnabled: isRovoEnabled } = preloadedSessionContext;
    const isLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    tasks.push((0, $5WLjq.preloadSpacesList)({
        isLicensed: isLicensed
    }));
    const isFullPageSearchEnabled = // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    ((0, $9wGTI.fg)('unified_search_in_confluence') || isRovoEnabled) && !(0, $9wGTI.fg)('confluence_rovo_search_opt_out');
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
}



async function $e80763d537fd4542$export$6aefe8c2dfd7fe98(url) {
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE) || match?.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match?.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $9fLxI.getExtensionManifest)({
            spaceKey: match.params.spaceKey
        }),
        // Under the experiment the editor reads the space from EditorContentUnifiedQuery. Live docs
        // keep the preload: `match` comes from the URL, which is the same for a live doc and a view page.
        ...match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE) && (0, $6mKj3.expValEquals)('confluence_editor_content_unified_query', 'isEnabled', true) ? [] : [
            (0, $5SzHz.preloadSpaceDetail)(match.params.spaceKey)
        ],
        (0, $821e100427ee88aa$export$ce64f7b5556cdb62)(),
        (0, $88b2ba3b9422ec6a$export$3837c35a0d92ab93)()
    ]);
}
async function $e80763d537fd4542$export$57d895781a697848(...args) {
    // All the function calls originated from this entry point are attached to a query boundary.
    // This is used to help us identify fetches fired from components.
    return (0, $g277M.runInQueryBoundary)('default', ()=>{
        return $e80763d537fd4542$var$preloadQueryBasedOnRouteImpl(...args);
    });
}
async function $e80763d537fd4542$var$preloadQueryBasedOnRouteImpl(url, isTransition = false, previousMatch = null, preloadOptions) {
    const commonTasks = [];
    if (isTransition && window.GLOBAL_RELAY_ENV) (0, $igNpi.getPersonalizationQueryOwner)(window.GLOBAL_RELAY_ENV)?.beginPreload();
    if (isTransition && !(0, $1xpoY.default).isKillSwitchOn('confluence_vp_conversation_preloaded_query') && (0, $6mKj3.expVal)('confluence_exp_conversation_contract', 'isEnabled', false)) (0, $kEZox.getConversationQueryOwner)((0, $9HB34.getRelayEnvironment)())?.beginPreload();
    if (isTransition && !(0, $1xpoY.default).isKillSwitchOn('confluence_space_nav_preloaded_query') && (0, $6mKj3.expVal)('confluence_exp_space_nav_contract', 'isEnabled', false)) (0, $8U3Mq.cancelSpaceNavigationQueryPreload)();
    const match = $e80763d537fd4542$var$matchRoute(url);
    if (match?.experience) (0, $df23aac6d1130849$export$7388eaba0b85ff24)(match.experience);
    const isEmbeddedWhiteboard = match?.experience === (0, $irVI7.WHITEBOARD_EXPERIENCE) && (0, $58246c7bb1bd3b0e$export$a8738b3e8374c78c)(match).bypassesMainLayout;
    /**
   * There are synchronous operations in preparing session data.
   * All queries that independent to session data should be fired first.
   */ if (!isTransition) {
        commonTasks.push((0, $29df517881fdeca7$export$990c5eb6cb59ce1c)());
        if (match?.experience === (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE)) // The PDF export route only renders a specific Confluence page's title and content.
        // So, we don't need to fetch data for certain common Confluence features and preferences such as navigation and user settings.
        // Note 1: PDF export is not a SSR capability and also need not support SPA transitions, as it is only accessible via direct URL.
        commonTasks.push(// Remote local storage
        (0, $eiCiP.preloadLocalStorage)(), // Forge UI user profile
        (0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
        else if (isEmbeddedWhiteboard) {
            commonTasks.push((0, $eiCiP.preloadLocalStorage)());
            commonTasks.push((0, $96ee7afaced2313e$export$e0e94d96f49a1aa)({
                themeState: undefined
            }));
            commonTasks.push((0, $3y1ko.preloadShortcutEnabledState)());
        } else if (match?.experience !== (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE)) {
            // external share doesn't have navigation, returns only errors
            commonTasks.push((0, $eiCiP.preloadLocalStorage)(), (0, $5368439faec350a5$export$6c7e4784651f052f)());
            commonTasks.push((0, $c63485f681d81d31$export$693b572d94b96722)());
            commonTasks.push((0, $e44b2547c6a8e817$export$dfd129d3c3f4c561)());
            commonTasks.push((0, $eS4vC.createDataFetcherForSuspense)('top-nav', ()=>[
                    (0, $a6a4fe9083f3db22$export$d46e9819bcc1eb51)(),
                    (0, $1d20c0a68123b7f2$export$2d0f6d5aa0911699)(),
                    (0, $3y1ko.preloadShortcutEnabledState)()
                ]));
            commonTasks.push((0, $34aa8f5c495a6ba2$export$3efc211209d16247)());
            commonTasks.push((0, $da1fd1e44d7582fe$export$b4f1825d0b62630d)());
            commonTasks.push((0, $969a3e14c27be3bd$export$9930aa21f1e6a4e3)());
            const experience = match?.experience;
            commonTasks.push((0, $96ee7afaced2313e$export$e0e94d96f49a1aa)({
                themeState: [
                    (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE),
                    (0, $irVI7.VIEW_PAGE_EXPERIENCE)
                ].includes(experience) ? match?.query?.themeState : undefined
            }));
        }
    }
    if (!match) // Following code are specific to each route.
    // If we don't get a match here then there is nothing interesting
    return Promise.resolve();
    let routeTasks = Promise.resolve();
    const commonRouteTasks = [];
    // Routes can have common data if the route has a space key
    const spaceKey = match?.params?.spaceKey;
    if (spaceKey) commonRouteTasks.push((0, $f7b10b9020854fc7$export$6fb7f9b73aaa748e)(spaceKey));
    // TODO: We should do similar for content id here
    // but currently preloadPageRestrictionsQuery is spread out in each individual route.
    // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
    if (!isEmbeddedWhiteboard && (0, $9wGTI.fg)('aifc_onboarding_ga_enabled')) commonRouteTasks.push((0, $9c2bd2b1923ffb30$export$20203945a91bbda3)());
    if (match.experience === (0, $irVI7.VIEW_PAGE_EXPERIENCE)) {
        const { isLivePage: isLivePageSSR } = (0, $60cDW.getSSRRenderInputs)();
        // On transition or SSR revisit, validate whether we're a live doc. If so, only preload live doc routes, not all view page routes.
        // Prevents unnecessary GQL calls, e.g. ContentUnifiedQuery.
        let isCachedLivePage = false;
        const contentId = match?.params?.contentId;
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        const shouldCheckCachedLivePage = isTransition || Boolean(undefined);
        if (contentId && !isLivePageSSR && shouldCheckCachedLivePage) {
            const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
            isCachedLivePage = subType === 'live' && ((0, $6mKj3.isExperimentEnabled)('platform_editor_preload_live_archived') ? !isArchived : isArchived === false);
        }
        routeTasks = isLivePageSSR || isCachedLivePage ? (0, $iUV81.preloadLivePageRoute)(match, url) : (0, $445d6fd463fd83fa$export$9503d022471fff24)(match, url, isTransition, previousMatch);
    } else if (match.experience === (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE) || match.experience === (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE)) {
        if (preloadOptions?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) routeTasks = (0, $fe22b38e04163065$export$75a73f2fbf5e96e8)(match);
        else {
            const pageContextHomepageIdPromise = (0, $fe22b38e04163065$export$e23682e43b850daa)(match);
            routeTasks = (0, $fe22b38e04163065$export$75071d943b36f58f)(match, previousMatch, url, pageContextHomepageIdPromise);
            if (pageContextHomepageIdPromise) await pageContextHomepageIdPromise;
        }
    } else if (match.experience === (0, $irVI7.WHITEBOARD_EXPERIENCE)) routeTasks = (0, $d639d659544153c3$export$a107836a8bcfc0c9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.DATABASE_EXPERIENCE)) routeTasks = (0, $f7a595baa9e6d446$export$f9f9f93ef86bfae1)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EMBED_EXPERIENCE)) routeTasks = (0, $a17ca091e4cf9f3d$export$18e29f32c47bffc9)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE)) routeTasks = (0, $ff76ae367134cd26$export$2a230d51c69b591b)(match.params.contentId);
    else if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) routeTasks = (0, $32e736695aa13b8b$export$8abf4a07f4444858)(match, url, isTransition);
    else if (match.experience === (0, $irVI7.HOME_EXPERIENCE)) routeTasks = (0, $179951d621935e1e$export$cefc517f3ae2aa98)(match);
    else if (match.experience === (0, $irVI7.SPACE_PAGES_EXPERIENCE)) routeTasks = (0, $106eac55bed5d4af$export$206b1c2d74bc11a2)(match);
    else if (match.experience === (0, $irVI7.CONTENT_HISTORY_EXPERIENCE)) routeTasks = (0, $0ef4e79dd69588ad$export$9f53340e87bacbbd)(match);
    else if (match.experience === (0, $irVI7.ATTACHMENTS_PAGE_EXPERIENCE)) routeTasks = (0, $29ace679d934655d$export$7cbbf2d30ca863e7)(match);
    else if (match.experience === (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE)) routeTasks = (0, $b4d670122e111714$export$e77946254f7ce879)(match);
    else if (match.experience === (0, $irVI7.ACCESS_LINK_EXPERIENCE)) routeTasks = (0, $1f9d1c86f6a99b0e$export$5da6d89b949b94fc)(match, url, isTransition, previousMatch);
    else if (match.experience === (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE)) routeTasks = (0, $d3b88206c55934ef$export$bd1c07b274fefbd7)(match);
    else if (match.experience === (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE)) routeTasks = (0, $e6a21086b65e01ae$export$878ae3f236acea00)(match);
    else if (match.experience === (0, $irVI7.FOLDER_EXPERIENCE)) routeTasks = (0, $ae578b27499cf6ef$export$4286139fad35252)(match);
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $eS4vC.createDataFetcherForSuspense)('default', ()=>[
                routeTasks,
                ...commonRouteTasks
            ]),
        ...commonTasks
    ]).then((errors)=>{
        if (errors) for (const e of errors)(0, $3mugH.ssrPrepareErrorsClient).submitError(e);
    });
}
async function $e80763d537fd4542$export$faa68b5324f40037(pageUrl) {
    const match = $e80763d537fd4542$var$matchRoute(pageUrl);
    if (!match) return;
    if (match.experience === (0, $irVI7.EDIT_PAGE_EXPERIENCE)) return (0, $73df6e46d3afaa7c$export$9c3872cc60e7dbce)(match, pageUrl);
}
function $e80763d537fd4542$var$matchRoute(url) {
    let match;
    let experience;
    if (match = (0, $kM8fE.matchViewPage)(url)) experience = (0, $irVI7.VIEW_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchWhiteboardPage)(url)) experience = (0, $irVI7.WHITEBOARD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpaceOverview)(url)) experience = (0, $irVI7.SPACE_OVERVIEW_EXPERIENCE);
    else if (match = (0, $kM8fE.matchCompanyHub)(url)) experience = (0, $irVI7.FRONT_COVER_LOAD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchHome)(url)) experience = (0, $irVI7.HOME_EXPERIENCE);
    else if (match = (0, $kM8fE.matchFabricEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchExternalShare)(url)) experience = (0, $irVI7.EXTERNAL_SHARE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchAccessLink)(url)) experience = (0, $irVI7.ACCESS_LINK_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSpacePages)(url)) experience = (0, $irVI7.SPACE_PAGES_EXPERIENCE);
    else if (match = (0, $kM8fE.matchContentHistory)(url)) experience = (0, $irVI7.CONTENT_HISTORY_EXPERIENCE);
    else if (match = (0, $kM8fE.matchAttachmentsPage)(url)) experience = (0, $irVI7.ATTACHMENTS_PAGE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbeddedEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchDatabasePage)(url)) experience = (0, $irVI7.DATABASE_EXPERIENCE);
    else if (match = (0, $kM8fE.matchEmbedPage)(url)) experience = (0, $irVI7.EMBED_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSmartCreateEditor)(url)) experience = (0, $irVI7.EDIT_PAGE_SMART_CREATE_LOAD_EXPERIENCE);
    else if (match = (0, $kM8fE.matchSearch)(url)) experience = (0, $irVI7.ADVANCED_SEARCH_EXPERIENCE);
    else if ((0, $kM8fE.matchPdfExport)(url)) {
        match = (0, $kM8fE.matchPdfExport)(url);
        experience = (0, $irVI7.PDF_EXPORT_PAGE_EXPERIENCE);
    } else if (match = (0, $kM8fE.matchFolderPage)(url)) experience = (0, $irVI7.FOLDER_EXPERIENCE);
    return match && {
        ...match,
        experience: experience
    };
}
async function $e80763d537fd4542$export$bd8e570400e2d126() {
    const pageUrl = window.location.toString();
    // Extensions Manifest and extensions data (when preloading is requested for them)
    // are heavy and should not be loaded on server side and embedded into HTML.
    $e80763d537fd4542$export$6aefe8c2dfd7fe98(pageUrl);
    if (window.__SSR_RENDERED__) {
        (0, $6fa2bb018c065af1$export$598e33c4effb27e4)();
        (0, $327999b9823f79d3$export$eb1f6bb5cb9748d3)();
        (0, $29a9b31003a013cc$export$52cb4f0de2920e5f)();
        $e80763d537fd4542$export$faa68b5324f40037(pageUrl);
    } else $e80763d537fd4542$export$57d895781a697848(pageUrl);
}






var $8PKGr = parcelRequire("8PKGr");


var $aXEzU = parcelRequire("aXEzU");





var $dtDUi = parcelRequire("dtDUi");

const $a9dbb7d463eed498$export$5b7b52703d0f3e95 = 'CONFLUENCE_SSR_QUERY_BLOCKED';
const $a9dbb7d463eed498$export$8d8225dd22e8df51 = 'CONFLUENCE_SSR_INTENTIONAL_ABORT';
class $a9dbb7d463eed498$export$20b4bbce022e6891 extends Error {
    constructor(){
        super('SSR intentionally aborted pending Suspense boundaries so the client renders them');
        this.name = 'SSRIntentionalAbortError';
    }
}
class $a9dbb7d463eed498$export$a4b01fceab42247d extends Error {
    constructor(operationName){
        super('Query requires client rendering');
        this.operationName = void 0;
        this.name = 'SSRQueryBlockedError';
        this.operationName = operationName;
    }
}



var $dA1Sn = parcelRequire("dA1Sn");


var $gnYQc = parcelRequire("gnYQc");











var $2DVQX = parcelRequire("2DVQX");


var $7ZzSP = parcelRequire("7ZzSP");


var $3Tw8v = parcelRequire("3Tw8v");


var $9F7Qb = parcelRequire("9F7Qb");


var $6b4nE = parcelRequire("6b4nE");





var $bEYte = parcelRequire("bEYte");


var $kNIYN = parcelRequire("kNIYN");


var $hpWmZ = parcelRequire("hpWmZ");





var $8sZwv = parcelRequire("8sZwv");


var $l08Du = parcelRequire("l08Du");





var $bQm3c = parcelRequire("bQm3c");


var $7zgzO = parcelRequire("7zgzO");


var $bZg9h = parcelRequire("bZg9h");





var $5nuFe = parcelRequire("5nuFe");


var $kwzZh = parcelRequire("kwzZh");


var $7Px0t = parcelRequire("7Px0t");


var $jmjWc = parcelRequire("jmjWc");





var $32x2E = parcelRequire("32x2E");

const $85f7a1bc5069f889$export$e2036a91fb26c8cf = (url)=>{
    /* Extracting Confluence page data from URL because we don't have access to the page context
	 * from the Screen Space Flags placement.
	 *
	 * Sample page URL: wiki/spaces/{spaceKey}/pages/{contentId}/This+is+the+title+of+a+page
	 * Sample blog URL: wiki/spaces/{spaceKey}/blog/2025/04/11/{contentId}/This+is+the+title+of+a+blog+post
	 */ const [, spaceKey, rawContentType, contentId] = url.match(/\/wiki\/spaces\/([^/]+)\/(pages|blog|whiteboard|database)(?:\/\d{4}\/\d{2}\/\d{2})?\/(?:edit-v2\/)?([^/?#]+)/) || [];
    const contentType = rawContentType === 'pages' ? 'page' : rawContentType === 'blog' ? 'blogpost' : rawContentType;
    return {
        spaceKey: spaceKey,
        contentType: contentType,
        contentId: contentId
    };
};






var $8dbvt = parcelRequire("8dbvt");


var $2HQyh = parcelRequire("2HQyh");


var $1AapX = parcelRequire("1AapX");


var $jMyy4 = parcelRequire("jMyy4");


const $3f9566d28d4680fb$export$1d93f080b8c40251 = (skip = false)=>{
    const { contentId: contentId, spaceKey: spaceKey } = (0, $85f7a1bc5069f889$export$e2036a91fb26c8cf)(globalThis.location.href);
    // Get recommendation data
    const { data: recPageData, loading: recPageLoading, error: recPageError } = (0, $jMyy4.useQueryInterop)((0, $2HQyh.default), {
        variables: {
            type: 'page',
            id: contentId ?? '',
            exp: 'end_of_page_v5',
            key: spaceKey ?? '',
            keyString: spaceKey ?? ''
        },
        skip: !contentId || !spaceKey || skip,
        __callerPackage__: "confluence-post-office-provider"
    });
    // Transform/sort data and grab first rec
    const recommendedPage = (0, $cozmU.useMemo)(()=>{
        const rankedPages = $3f9566d28d4680fb$var$transformAndOrderRecs(recPageData?.getRecommendedPages?.recommendedPages);
        return rankedPages?.[0];
    }, [
        recPageData
    ]);
    // Get avatar and name of the page owner
    const { data: hoverPageData, loading: hoverPageLoading, error: hoverPageError } = (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $1AapX.default), {
        variables: {
            id: recommendedPage ? recommendedPage.id : ''
        },
        skip: !recommendedPage || skip,
        __callerPackage__: "confluence-post-office-provider"
    });
    const pageRecommendationData = {
        data: undefined,
        loading: hoverPageLoading || recPageLoading,
        hoverPageError: hoverPageError,
        recPageError: recPageError
    };
    if (hoverPageData?.singleContent?.history?.ownedBy?.displayName && hoverPageData?.singleContent?.history?.ownedBy?.profilePicture?.path && recommendedPage?.links?.webui && recommendedPage?.title.text) pageRecommendationData.data = {
        pageOwner: {
            name: hoverPageData.singleContent.history.ownedBy.displayName,
            avatarUrl: hoverPageData.singleContent.history.ownedBy.profilePicture.path
        },
        page: {
            title: recommendedPage.title.text,
            url: `/wiki${recommendedPage.links.webui}`
        }
    };
    return pageRecommendationData;
};
/**
 * The ordering of recs array is determined by the "ranking" in the backend.
 * Each rec will have a corresponding "strategies" array that can have one or multiple strategies.
 * We want to ensure that we are choosing strategies from each rec in a way that avoids monotony on the UI.
 * To accomplish this, we must first sort the recs array depending on the number of strategies each rec has, in
 * ascending order. We then pass each rec to transformEndOfPageRecContent which helps to choose the strategy, and
 * finally we return the transformed array back to the intial ranking order determind by the backend
 */ const $3f9566d28d4680fb$var$transformAndOrderRecs = (recs)=>{
    if (!recs) return;
    const strategiesCounter = new Map();
    const recsSortedByStrategyCount = [
        ...recs
    ].sort((a, b)=>a.strategy.length > b.strategy.length ? 1 : -1);
    const transformedRecs = recsSortedByStrategyCount.map((rec)=>(0, $8dbvt.transformEndOfPageRecContent)(rec, strategiesCounter));
    // return to initial order
    const pageCards = new Array();
    recs.forEach((rec)=>{
        const el = transformedRecs.find((card)=>card.id === rec.content.id);
        pageCards.push(el);
    });
    return pageCards;
};


/* eslint-disable graphql-relay-compat/no-import-graphql-operations */ /* eslint-disable no-restricted-imports */ 






var $3V1KT = parcelRequire("3V1KT");


var $2OQgp = parcelRequire("2OQgp");











const $e2efe42ead1c53d8$var$INITIAL_REACTED_USER_QUERY_RESULT = {
    data: undefined,
    loading: false,
    error: undefined
};
// Helper function to fetch the specific names of users who reacted to a specific emoji
const $e2efe42ead1c53d8$var$getReactedUsersForEmoji = async (contentId, contentType, emojiId)=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $2OQgp.ReactedUsersQuery),
        variables: {
            contentId: contentId,
            contentType: contentType.toUpperCase(),
            containerId: contentId,
            containerType: contentType.toUpperCase(),
            emojiId: emojiId
        },
        __callerPackage__: "confluence-post-office-provider"
    });
    return data;
};
// Helper function to get unique users who reacted to any emoji
const $e2efe42ead1c53d8$var$getUniqueReactedUsers = async (contentId, contentType, emojiIds)=>{
    const uniqueUsers = {};
    // Process all emojis in parallel to get all unique users
    await Promise.allSettled(// oxlint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- pre-existing pattern, bounded collection
    emojiIds.filter(Boolean).map(async (emojiId)=>{
        const data = await $e2efe42ead1c53d8$var$getReactedUsersForEmoji(contentId, contentType, emojiId);
        // Add all users to the unique users map
        // oxlint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- pre-existing pattern
        for (const user of data?.reactedUsers?.confluencePerson ?? [])if (user?.displayName && user.accountId) uniqueUsers[user.accountId] = user.displayName;
    }));
    return uniqueUsers;
};
const $e2efe42ead1c53d8$export$a35f2f61e0cb4308 = (numberOfReactedUsers, skip = false)=>{
    // Needed for Confluence-required analytic events
    const { userId: userId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { contentId: contentId, contentType: contentType } = (0, $85f7a1bc5069f889$export$e2036a91fb26c8cf)(window.location.href);
    const [reactedUsers, setReactedUsers] = (0, $cozmU.useState)($e2efe42ead1c53d8$var$INITIAL_REACTED_USER_QUERY_RESULT);
    const [uniqueUsersCount, setUniqueUsersCount] = (0, $cozmU.useState)(0);
    // Fetch page author and author's avatar URL
    const { data: spaceHoverPageCardResult, loading: spaceHoverPageCardLoading, error: spaceHoverPageCardError } = (0, $jMyy4.useQueryInterop)((0, $1AapX.default), {
        variables: {
            id: contentId
        },
        skip: !contentId || skip,
        __callerPackage__: "confluence-post-office-provider"
    });
    // Fetch total reactions count and emoji ID summary
    const { data: reactionsContentData, loading: reactionsLoading, error: reactionsError } = (0, $jMyy4.useQueryInterop)((0, $3V1KT.ReactionsContentQuery), {
        variables: {
            contentId: contentId
        },
        skip: !contentId || skip,
        __callerPackage__: "confluence-post-office-provider"
    });
    // Use the emoji ID summary from reactionsContentData to fetch the specific names of users who reacted
    (0, $cozmU.useEffect)(()=>{
        const emojiIds = reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.flatMap((reaction)=>reaction?.emojiId ?? []);
        // Need to put this in a function and then call it because we can't use async/await in useEffect
        const getReactedUsers = async ()=>{
            if (!contentId || !contentType || !emojiIds || reactedUsers.data || reactedUsers.loading) return;
            setReactedUsers({
                loading: true
            });
            try {
                // Get all unique users in parallel
                const uniqueUsers = await $e2efe42ead1c53d8$var$getUniqueReactedUsers(contentId, contentType, emojiIds);
                // Take only the first numberOfReactedUsers users for the reactedUsers state
                const limitedUsers = Object.values(uniqueUsers).slice(0, numberOfReactedUsers);
                // Update state
                setUniqueUsersCount(Object.keys(uniqueUsers).length);
                setReactedUsers({
                    data: limitedUsers,
                    loading: false
                });
            } catch (error) {
                setReactedUsers({
                    loading: false,
                    error: error
                });
            }
        };
        // oxlint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- pre-existing pattern
        getReactedUsers();
    }, [
        contentId,
        contentType,
        reactionsContentData,
        reactedUsers,
        numberOfReactedUsers
    ]);
    // Transform this so that it matches Post Office's expected shape (for use with the ReactionWrapper component)
    const transformedReactionsSummary = (0, $cozmU.useMemo)(()=>({
            reactionsSummary: {
                ari: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.ari || '',
                containerAri: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.containerAri || '',
                reactionsSummaryForEmoji: reactionsContentData?.content?.nodes?.[0]?.contentReactionsSummary?.reactionsSummaryForEmoji?.map((emoji)=>{
                    // Only return emoji objects that have all required non-null values
                    if (emoji?.count != null && emoji?.emojiId != null && emoji?.reacted != null) return {
                        count: emoji.count,
                        emojiId: emoji.emojiId,
                        reacted: emoji.reacted,
                        __typename: 'ReactionsSummaryForEmoji'
                    };
                    return null; // Return null for incomplete emoji data
                }) || [],
                // Provide empty array as fallback if the whole map operation is undefined
                __typename: 'ReactionsSummaryResponse'
            }
        }), [
        reactionsContentData
    ]);
    return {
        data: {
            authorName: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.displayName ?? undefined,
            authorAvatar: spaceHoverPageCardResult?.singleContent?.history?.ownedBy?.profilePicture?.path,
            reactionsCount: uniqueUsersCount,
            reactionsSummary: transformedReactionsSummary,
            reactedUsers: reactedUsers.data,
            userId: userId || undefined,
            activationId: activationId
        },
        loading: spaceHoverPageCardLoading || reactionsLoading || reactedUsers.loading,
        error: spaceHoverPageCardError || reactionsError || reactedUsers.error
    };
};


/**
 * @generated SignedSource<<db24d03892b4eb84461db3d7b4e3b5b9>>
 * @relayHash 0487c8ed319042e967303b02df0519f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9b27b842751d29460eadb80e03954e0925aaa3034a2864705bf9a945859c7c0c
const $10a64ce1003e4484$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudIds"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudIds",
            "variableName": "cloudIds"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "cloudId"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v4 = [
        {
            "kind": "ScalarField",
            "name": "relationshipType"
        }
    ], v5 = {
        "args": [
            {
                "kind": "Literal",
                "name": "relationshipTypes",
                "value": "COLLECTION"
            }
        ],
        "concreteType": "CcpEntitlementRelationship",
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": v4 /*: any*/ ,
        "storageKey": "relatesFromEntitlements(relationshipTypes:\"COLLECTION\")"
    }, v6 = {
        "alias": "enterpriseRelationships",
        "args": [
            {
                "kind": "Literal",
                "name": "relationshipTypes",
                "value": "ENTERPRISE"
            }
        ],
        "concreteType": "CcpEntitlementRelationship",
        "kind": "LinkedField",
        "name": "relatesFromEntitlements",
        "plural": true,
        "selections": v4 /*: any*/ ,
        "storageKey": "relatesFromEntitlements(relationshipTypes:\"ENTERPRISE\")"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "alias": "confluenceEntitlementInfo",
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "alias": "confluenceEntitlementInfo",
                            "args": v3 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "concreteType": "CcpEntitlement",
                                            "kind": "LinkedField",
                                            "name": "entitlement",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "CommerceEntitlementInfoCcp"
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "0487c8ed319042e967303b02df0519f3",
            "id": "9b27b842751d29460eadb80e03954e0925aaa3034a2864705bf9a945859c7c0c",
            "metadata": {},
            "name": "useCurrentPageTemplateDataTwcEligibilityQuery",
            "operationKind": "query",
            "text": "query useCurrentPageTemplateDataTwcEligibilityQuery($cloudIds:[ID!]!){tenantContexts(cloudIds:$cloudIds){cloudId,confluenceEntitlementInfo:entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements(relationshipTypes:\"COLLECTION\"){relationshipType},enterpriseRelationships:relatesFromEntitlements(relationshipTypes:\"ENTERPRISE\"){relationshipType},id}}}}}"
        }
    };
}();
$10a64ce1003e4484$var$node.hash = "6ad66e5687eb8286add54df09b0e2383";
var $10a64ce1003e4484$export$2e2bcd8739ae039 = $10a64ce1003e4484$var$node;






var $6m3nS = parcelRequire("6m3nS");


var $5h1mk = parcelRequire("5h1mk");

const $2fa0ab943df65f81$export$1db5857ce669e9b7 = {
    MEETING_NOTES: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
    PROJECT_PLAN: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
    EOW_STATUS_REPORT: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
    DECISIONS: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
    REQUIREMENTS_RACI: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
    RETROSPECTIVES: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
    BUSINESS_STATUS_UPDATE: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
    ONE_ON_ONE_MEETING: 'com.atlassian.confluence.plugins.confluence-business-blueprints:1-on-1-meeting-blueprint',
    RECURRING_MEETING_MINUTES: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
    PROJECT_STATUS: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint'
};



var $kcIQr = parcelRequire("kcIQr");







var $iujy9 = parcelRequire("iujy9");








var $f7MuR = parcelRequire("f7MuR");

const $56d2014df57e1b35$export$c3f27a0a768c104a = 'twc_xflow_conf_meeting_pages_templates_reminder';
const $56d2014df57e1b35$export$783f3c94b6a1a499 = 'remind';
const $56d2014df57e1b35$export$daee443c5629dac6 = 'dismissed';
const $56d2014df57e1b35$export$63772118c24d0125 = ({ enabled: enabled })=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skip: !enabled
    });
    if (!enabled) return {
        reminder: 'absent',
        error: null
    };
    if (loading) return {
        reminder: 'loading',
        error: null
    };
    if (error) return {
        reminder: 'error',
        error: error
    };
    const reminder = data?.attributes?.find(({ name: name })=>name === $56d2014df57e1b35$export$c3f27a0a768c104a);
    const reminderValue = reminder?.value;
    return {
        reminder: reminderValue === $56d2014df57e1b35$export$783f3c94b6a1a499 || reminderValue === $56d2014df57e1b35$export$daee443c5629dac6 ? reminderValue : reminder ? 'unexpected' : 'absent',
        error: null
    };
};


const $d099b0af2325b383$export$afd4a1b9337ac2c2 = 'twcg-2112-template-view-trigger';
const $d099b0af2325b383$export$54281e223bf51d14 = 'twcg-2112-template-applied-trigger';
// Retain the registered analytics identifier; it no longer controls experiment enrollment.
const $d099b0af2325b383$var$TEMPLATE_XFLOW_ANALYTICS_KEY = 'twcg-2112-twc-xflow-conf-pages-templates';
const $d099b0af2325b383$var$CurrentPageTemplateTwcEligibilityQuery = (0, $10a64ce1003e4484$export$2e2bcd8739ae039);
const $d099b0af2325b383$var$canonicalTemplateKeyBySourceTemplateEntityId = {
    ...Object.values((0, $2fa0ab943df65f81$export$1db5857ce669e9b7)).reduce((mapping, key)=>({
            ...mapping,
            [key]: key
        }), {}),
    'ec8ecc7e-7e4b-4f8a-aa3f-a6a7f2df4ac9': (0, $2fa0ab943df65f81$export$1db5857ce669e9b7).MEETING_NOTES,
    'f7a9afa1-19c0-4558-abd4-f8060829f9fc': (0, $2fa0ab943df65f81$export$1db5857ce669e9b7).PROJECT_PLAN,
    '6873d89c-765f-4677-b370-048005c7470b': (0, $2fa0ab943df65f81$export$1db5857ce669e9b7).EOW_STATUS_REPORT,
    '7edaef4a-329f-47c9-abfe-7e241c9e17ba': (0, $2fa0ab943df65f81$export$1db5857ce669e9b7).DECISIONS,
    'be29e5eb-fbe7-4213-b16f-5fb25b13f2d8': (0, $2fa0ab943df65f81$export$1db5857ce669e9b7).REQUIREMENTS_RACI,
    'f877653e-87e1-4654-a915-3591b3dd0db3': (0, $2fa0ab943df65f81$export$1db5857ce669e9b7).BUSINESS_STATUS_UPDATE,
    '7c19a101-d13e-4d67-870b-279e6342c6bc': (0, $2fa0ab943df65f81$export$1db5857ce669e9b7).RECURRING_MEETING_MINUTES,
    'a2484be7-df58-4f17-a347-2fecb7b22bb9': (0, $2fa0ab943df65f81$export$1db5857ce669e9b7).PROJECT_STATUS
};
const $d099b0af2325b383$export$fdcffc4fc857301d = (sourceTemplateEntityId)=>sourceTemplateEntityId ? $d099b0af2325b383$var$canonicalTemplateKeyBySourceTemplateEntityId[sourceTemplateEntityId] : undefined;
const $d099b0af2325b383$var$isPaidEdition = (edition)=>edition === 'STANDARD' || edition === 'PREMIUM';
const $d099b0af2325b383$export$c27570bca364b692 = ({ shouldCheck: shouldCheck, cloudId: cloudId, data: data, loading: loading, error: error })=>{
    if (!shouldCheck) return 'notRequested';
    if (!cloudId) return 'missing';
    if (loading) return 'loading';
    if (error) return 'failed';
    const tenantContext = data?.tenantContexts?.find((context)=>context?.cloudId === cloudId);
    const relatesFromEntitlements = tenantContext?.confluenceEntitlementInfo?.entitlement?.relatesFromEntitlements;
    if (!tenantContext || !relatesFromEntitlements) return 'missing';
    if (relatesFromEntitlements.some((relationship)=>relationship?.relationshipType === 'COLLECTION')) return 'existingTwcCustomer';
    // Enterprise sites can report PREMIUM in session data; check their entitlement separately.
    const enterpriseRelationships = tenantContext.confluenceEntitlementInfo?.entitlement?.enterpriseRelationships;
    if (!enterpriseRelationships) return 'missing';
    return enterpriseRelationships.some((relationship)=>relationship?.relationshipType === 'ENTERPRISE') ? 'enterpriseCustomer' : 'eligible';
};
const $d099b0af2325b383$export$cb06c0969c9f1bbb = ()=>{
    const { current: href } = (0, $5h1mk.usePostOfficeRoute)();
    const { contentId: contentId } = (0, $85f7a1bc5069f889$export$e2036a91fb26c8cf)(href ?? '');
    const { cloudId: cloudId, edition: edition, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const { fireTrigger: fireTemplateViewTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: $d099b0af2325b383$export$afd4a1b9337ac2c2
    });
    const { fireTrigger: fireTemplateAppliedTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: $d099b0af2325b383$export$54281e223bf51d14
    });
    const [currentPageTemplateData, setCurrentPageTemplateData] = (0, $cozmU.useState)({
        contentId: contentId,
        blueprintModuleCompleteKey: undefined,
        isEligible: false
    });
    const [activeTemplateTrigger, setActiveTemplateTrigger] = (0, $cozmU.useState)();
    const [isTerminallyDismissed, setIsTerminallyDismissed] = (0, $cozmU.useState)(false);
    const eligibilityAnalyticsKeyRef = (0, $cozmU.useRef)();
    const appliedTemplateContentIdRef = (0, $cozmU.useRef)();
    const hasPaidLicensedAccess = $d099b0af2325b383$var$isPaidEdition(edition) && isLicensed;
    const exposedCurrentPageTemplateData = (0, $cozmU.useMemo)(()=>currentPageTemplateData.contentId === contentId ? currentPageTemplateData : {
            contentId: contentId,
            blueprintModuleCompleteKey: undefined,
            isEligible: false
        }, [
        contentId,
        currentPageTemplateData
    ]);
    const shouldCheckTwcEligibility = Boolean(contentId) && hasPaidLicensedAccess && exposedCurrentPageTemplateData.blueprintModuleCompleteKey !== undefined;
    const { data: twcEligibilityData, loading: twcEligibilityLoading, error: twcEligibilityError } = (0, $jMyy4.useQueryInterop)($d099b0af2325b383$var$CurrentPageTemplateTwcEligibilityQuery, {
        variables: {
            cloudIds: cloudId ? [
                cloudId
            ] : []
        },
        skip: !shouldCheckTwcEligibility || !cloudId,
        fetchPolicy: 'cache-first',
        interopApolloAggClient: true,
        __callerPackage__: "confluence-post-office-provider"
    });
    const twcEligibilityDecision = $d099b0af2325b383$export$c27570bca364b692({
        shouldCheck: shouldCheckTwcEligibility,
        cloudId: cloudId,
        data: twcEligibilityData,
        loading: twcEligibilityLoading,
        error: twcEligibilityError
    });
    (0, $cozmU.useEffect)(()=>{
        const blueprintModuleCompleteKey = exposedCurrentPageTemplateData.blueprintModuleCompleteKey;
        const entryPoint = activeTemplateTrigger === 'view' ? 'templateView' : activeTemplateTrigger === 'applied' ? 'templateApplied' : undefined;
        const hasResolvedTwcEligibility = twcEligibilityDecision !== 'notRequested' && twcEligibilityDecision !== 'loading';
        if (contentId && blueprintModuleCompleteKey && entryPoint && hasPaidLicensedAccess && hasResolvedTwcEligibility) {
            const analyticsKey = [
                contentId,
                blueprintModuleCompleteKey,
                entryPoint,
                twcEligibilityDecision
            ].join(':');
            if (eligibilityAnalyticsKeyRef.current !== analyticsKey) {
                eligibilityAnalyticsKeyRef.current = analyticsKey;
                createEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'decided',
                        actionSubject: 'twcTemplateXflowEligibility',
                        source: entryPoint,
                        attributes: {
                            blueprintModuleCompleteKey: blueprintModuleCompleteKey,
                            entryPoint: entryPoint,
                            experimentKey: $d099b0af2325b383$var$TEMPLATE_XFLOW_ANALYTICS_KEY,
                            hasPaidLicensedAccess: hasPaidLicensedAccess,
                            twcEligibilityDecision: twcEligibilityDecision
                        }
                    }
                }).fire();
            }
        }
        if (isTerminallyDismissed || !contentId || !blueprintModuleCompleteKey || twcEligibilityDecision !== 'eligible') {
            // oxlint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- pre-existing pattern
            setCurrentPageTemplateData((current)=>current.isEligible ? {
                    ...current,
                    isEligible: false
                } : current);
            return;
        }
        setCurrentPageTemplateData((current)=>current.contentId === contentId && current.blueprintModuleCompleteKey === blueprintModuleCompleteKey ? {
                ...current,
                isEligible: true
            } : current);
    }, [
        activeTemplateTrigger,
        contentId,
        createEvent,
        exposedCurrentPageTemplateData.blueprintModuleCompleteKey,
        hasPaidLicensedAccess,
        isTerminallyDismissed,
        twcEligibilityDecision
    ]);
    const { reminder: reminderState } = (0, $56d2014df57e1b35$export$63772118c24d0125)({
        enabled: !isTerminallyDismissed && twcEligibilityDecision === 'eligible' && exposedCurrentPageTemplateData.blueprintModuleCompleteKey !== undefined
    });
    const isTemplateXflowSuppressed = isTerminallyDismissed || reminderState === 'dismissed';
    (0, $cozmU.useEffect)(()=>{
        eligibilityAnalyticsKeyRef.current = undefined;
        if (appliedTemplateContentIdRef.current !== contentId) appliedTemplateContentIdRef.current = undefined;
        setCurrentPageTemplateData({
            contentId: contentId,
            blueprintModuleCompleteKey: undefined,
            isEligible: false
        });
        setActiveTemplateTrigger(undefined);
        if (!contentId || !hasPaidLicensedAccess) return;
        const subscription = (0, $iujy9.watchContentHeaderTemplateData)(contentId, (sourceTemplateEntityId)=>{
            if (appliedTemplateContentIdRef.current === contentId) return;
            const blueprintModuleCompleteKey = $d099b0af2325b383$export$fdcffc4fc857301d(sourceTemplateEntityId);
            setCurrentPageTemplateData({
                contentId: contentId,
                blueprintModuleCompleteKey: blueprintModuleCompleteKey,
                isEligible: false
            });
            setActiveTemplateTrigger(blueprintModuleCompleteKey ? 'view' : undefined);
        });
        return ()=>{
            subscription.unsubscribe();
            fireTemplateViewTrigger({
                isActive: false
            });
            fireTemplateAppliedTrigger({
                isActive: false
            });
        };
    }, [
        contentId,
        fireTemplateAppliedTrigger,
        fireTemplateViewTrigger,
        hasPaidLicensedAccess
    ]);
    (0, $cozmU.useEffect)(()=>{
        fireTemplateViewTrigger({
            isActive: twcEligibilityDecision === 'eligible' && activeTemplateTrigger === 'view' && !isTemplateXflowSuppressed
        });
        fireTemplateAppliedTrigger({
            isActive: twcEligibilityDecision === 'eligible' && activeTemplateTrigger === 'applied' && !isTemplateXflowSuppressed
        });
    }, [
        activeTemplateTrigger,
        fireTemplateAppliedTrigger,
        fireTemplateViewTrigger,
        isTemplateXflowSuppressed,
        twcEligibilityDecision
    ]);
    const onTemplateApplied = (0, $cozmU.useCallback)((blueprintModuleCompleteKey)=>{
        if (!contentId || !hasPaidLicensedAccess) {
            setActiveTemplateTrigger(undefined);
            setCurrentPageTemplateData({
                contentId: contentId,
                blueprintModuleCompleteKey: undefined,
                isEligible: false
            });
            return;
        }
        const canonicalTemplateKey = $d099b0af2325b383$export$fdcffc4fc857301d(blueprintModuleCompleteKey);
        appliedTemplateContentIdRef.current = contentId;
        setActiveTemplateTrigger(canonicalTemplateKey ? 'applied' : undefined);
        setCurrentPageTemplateData({
            contentId: contentId,
            blueprintModuleCompleteKey: canonicalTemplateKey,
            isEligible: false
        });
    }, [
        contentId,
        hasPaidLicensedAccess
    ]);
    const dismissForSession = (0, $cozmU.useCallback)(()=>{
        setIsTerminallyDismissed(true);
        fireTemplateViewTrigger({
            isActive: false
        });
        fireTemplateAppliedTrigger({
            isActive: false
        });
    }, [
        fireTemplateAppliedTrigger,
        fireTemplateViewTrigger
    ]);
    return (0, $cozmU.useMemo)(()=>({
            currentPageTemplateData: exposedCurrentPageTemplateData,
            twcEligibilityDecision: twcEligibilityDecision,
            reminderState: reminderState,
            isTerminallyDismissed: isTerminallyDismissed,
            dismissForSession: dismissForSession,
            onTemplateApplied: onTemplateApplied
        }), [
        dismissForSession,
        exposedCurrentPageTemplateData,
        isTerminallyDismissed,
        onTemplateApplied,
        reminderState,
        twcEligibilityDecision
    ]);
};



const $555b5ed6649c2b1e$var$TwcXflowModal = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i4_mn",
    name: "TwcXflowModal",
    loader: async ()=>(await (parcelRequire("664fH"))).default
});
const $555b5ed6649c2b1e$export$50c48a5a1548e4da = ({ children: children })=>{
    const { userId: userId, cloudId: cloudId, locale: locale, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const currentPageTemplateData = (0, $d099b0af2325b383$export$cb06c0969c9f1bbb)();
    const [modalSourceContext, setModalSourceContext] = (0, $cozmU.useState)();
    const openTwcXflowModal = (0, $cozmU.useCallback)((sourceContext)=>{
        setModalSourceContext(sourceContext);
    }, []);
    const closeTwcXflowModal = (0, $cozmU.useCallback)(()=>setModalSourceContext(undefined), []);
    const templateXflow = (0, $cozmU.useMemo)(()=>({
            ...currentPageTemplateData,
            openTwcXflowModal: openTwcXflowModal
        }), [
        currentPageTemplateData,
        openTwcXflowModal
    ]);
    const experimentsContextValue = (0, $cozmU.useMemo)(()=>{
        return {
            templateXflow: templateXflow,
            usePageRecommendationData: $3f9566d28d4680fb$export$1d93f080b8c40251,
            useInlineReactionsData: $e2efe42ead1c53d8$export$a35f2f61e0cb4308,
            getPageDataFromUrl: $85f7a1bc5069f889$export$e2036a91fb26c8cf,
            emojiProvider: (0, $32x2E.getEmojiProvider)((0, $kwzZh.default), {
                userId: userId,
                cloudId: cloudId
            })
        };
    }, [
        userId,
        cloudId,
        templateXflow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5nuFe.ConfluenceExperimentsContext).Provider, {
        value: experimentsContextValue
    }, children, cloudId && modalSourceContext ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($555b5ed6649c2b1e$var$TwcXflowModal, {
        cloudId: cloudId,
        locale: locale,
        onClose: closeTwcXflowModal,
        orgId: orgId ?? undefined,
        sourceComponent: (0, $7Px0t.SOURCE_COMPONENT).TWC_XFLOW_CONFLUENCE_TEMPLATE,
        sourceContext: modalSourceContext
    }) : null);
};






var $3d3WW = parcelRequire("3d3WW");




const $2520ccd04539af0f$var$GASV3_DWELL_TRIGGER_TIME = 40000; // ms
const $2520ccd04539af0f$var$PO_DWELL_TRIGGER_TIME = 60000; // ms
const $2520ccd04539af0f$export$2855524b2284c48 = ({ children: children })=>{
    const { fireTrigger: fireTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)({
        triggerId: 'confluence-page-dwelled'
    });
    const onEvent = (0, $cozmU.useCallback)((event)=>{
        if (event.payload?.data?.action === 'dwelled' && event.payload?.data?.actionSubject === 'page') {
            const dwellTime = event.payload.data.attributes?.dwellTime;
            // Dwell events are triggered at 5, 10, 20, 40, 80s, but we want 60s
            if (event.payload.data.attributes?.finalDwellEvent) fireTrigger({
                isActive: false
            });
            else if (dwellTime && dwellTime >= $2520ccd04539af0f$var$GASV3_DWELL_TRIGGER_TIME && dwellTime <= $2520ccd04539af0f$var$PO_DWELL_TRIGGER_TIME) fireTrigger({
                isActive: true
            });
        }
    }, [
        fireTrigger
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3d3WW.default), {
        onEvent: onEvent,
        channel: "*"
    }, children);
};


const $ec4187ce4872c484$var$ConfluencePostOfficeProvider = ({ children: children })=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId, environment: environment, locale: locale, orgId: orgId, edition: edition } = (0, $bQm3c.useSessionData)();
    const context = (0, $cozmU.useMemo)(()=>({
            current: (0, $bZg9h.sessionToPostOfficeContext)({
                accessStatus: accessStatus,
                activationId: activationId,
                cloudId: cloudId,
                locale: locale,
                orgId: orgId,
                edition: edition
            })
        }), [
        activationId,
        cloudId,
        accessStatus,
        locale,
        orgId,
        edition
    ]);
    const env = (0, $cozmU.useMemo)(()=>({
            env: (0, $bZg9h.transformConfluenceEnvToPostOfficeEnvironment)(environment)
        }), [
        environment
    ]);
    const analyticsClientInstance = (0, $cozmU.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8sZwv.PostOfficeProvider), {
        context: context,
        environment: env,
        analyticsClientInstance: analyticsClientInstance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2520ccd04539af0f$export$2855524b2284c48), null, children));
};
const $ec4187ce4872c484$export$fb465b6e855c1e85 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ec4187ce4872c484$var$ConfluencePostOfficeProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $555b5ed6649c2b1e$export$50c48a5a1548e4da), null, children));
};
const $ec4187ce4872c484$var$ConfluenceRouterListener = ({ children: children })=>{
    const routeContext = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    (0, $l08Du.usePostOfficeRouteUpdate)([
        routeContext.getHref() ?? '',
        routeContext.match?.name ?? ''
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
};
const $ec4187ce4872c484$export$9f8d3084fd3d5fc0 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ec4187ce4872c484$var$ConfluenceRouterListener, null, children);
};






var $8aG6j = parcelRequire("8aG6j");


var $ibNn3 = parcelRequire("ibNn3");


var $6U5eU = parcelRequire("6U5eU");




/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for server side use only
*/ const $38bb2f218e8edc07$export$a5cfae247d8360ef = 'screen-space-flags';


/**
 * This file was automatically generated using "yarn generate:all" command.
 * Please do not edit it manually.
 * 
 * Generate source: local/cli/src/commands/placements/generate-intl-provider.ts
 **/ 
var $l24yD = parcelRequire("l24yD");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bq8Da = parcelRequire("bq8Da");


var $cUcPn = parcelRequire("cUcPn");

// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e22f3c88d35d75f3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e22f3c88d35d75f3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("8kiTx")));
        case 'da':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("jvwR3")));
        case 'de':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("9C8Zx")));
        case 'en-GB':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("8kSZw")));
        case 'en-US':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("7zG2V")));
        case 'en-XA':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("8QId8")));
        case 'en-XB':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("bjwpp")));
        case 'en-ZZ':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("8AKqi")));
        case 'en':
            return $e22f3c88d35d75f3$var$importHelper(await Promise.resolve((parcelRequire("bq8Da"))));
        case 'es':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("7x7cL")));
        case 'et':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("bkYly")));
        case 'fi':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("7wFnr")));
        case 'fr':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("3V1Pb")));
        case 'hr':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("kFouI")));
        case 'hu':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("6ZWRH")));
        case 'it':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("4VFh8")));
        case 'ja':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("cndcR")));
        case 'ko':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("3DkR1")));
        case 'nb':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("9MPOQ")));
        case 'nl':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("hyLnR")));
        case 'pl':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("3oVUn")));
        case 'pt-BR':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("3DFhF")));
        case 'ro':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("jV89E")));
        case 'ru':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("huRSd")));
        case 'sl':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("5u5SF")));
        case 'sr-RS':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("lj2gn")));
        case 'sr-YR':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("jHn1o")));
        case 'sr':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("572Nz")));
        case 'sv':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("3GzWv")));
        case 'th':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("1OBpa")));
        case 'tr':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("f855X")));
        case 'uk':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("ilxmD")));
        case 'vi':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("dMzjg")));
        case 'zh-CN':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("6yFw0")));
        case 'zh-TW':
            return $e22f3c88d35d75f3$var$importHelper(await (parcelRequire("cAlXn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bq8Da));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $dJkmj = parcelRequire("dJkmj");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e6415930b3d4f363$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $e6415930b3d4f363$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("ksfN5")));
        case 'da':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("1WW3i")));
        case 'de':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("8JNw5")));
        case 'en-GB':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("b4Dfp")));
        case 'en-US':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("7N8K6")));
        case 'en-XA':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("caZSr")));
        case 'en-XB':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("7baG8")));
        case 'en-ZZ':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("iG5Z7")));
        case 'en':
            return $e6415930b3d4f363$var$importHelper(await Promise.resolve((parcelRequire("dJkmj"))));
        case 'es':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("z0NfQ")));
        case 'et':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("lay1O")));
        case 'fi':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("c09TU")));
        case 'fr':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("hbyeW")));
        case 'hr':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("ihfOC")));
        case 'hu':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("iTVjy")));
        case 'it':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("jambV")));
        case 'ja':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("bgRQf")));
        case 'ko':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("fkCwb")));
        case 'nb':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("e1R9y")));
        case 'nl':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("8y7KT")));
        case 'pl':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("llaTT")));
        case 'pt-BR':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("bFqV5")));
        case 'ro':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("52S0G")));
        case 'ru':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("9oOUi")));
        case 'sl':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("5NwB0")));
        case 'sr-RS':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("hEUq2")));
        case 'sr-YR':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("7XWIt")));
        case 'sr':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("jFYco")));
        case 'sv':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("5sLxi")));
        case 'th':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("bYnX5")));
        case 'tr':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("fRuEg")));
        case 'uk':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("etig5")));
        case 'vi':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("g9XuR")));
        case 'zh-CN':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("87dWx")));
        case 'zh-TW':
            return $e6415930b3d4f363$var$importHelper(await (parcelRequire("b66vN")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($dJkmj));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $i2fPX = parcelRequire("i2fPX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d79f2b154c851db0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $d79f2b154c851db0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("bRqeA")));
        case 'da':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("9jD1I")));
        case 'de':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("cZ3uF")));
        case 'en-GB':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("dmPno")));
        case 'en-US':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("d63z9")));
        case 'en-XA':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("dYrFI")));
        case 'en-XB':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("fwUrk")));
        case 'en-ZZ':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("aSvJn")));
        case 'en':
            return $d79f2b154c851db0$var$importHelper(await Promise.resolve((parcelRequire("i2fPX"))));
        case 'es':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("hJ4rW")));
        case 'et':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("57BZh")));
        case 'fi':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("48G6M")));
        case 'fr':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("ce9jn")));
        case 'hr':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("8uzv1")));
        case 'hu':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("kvD9W")));
        case 'it':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("8ala4")));
        case 'ja':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("hhTMG")));
        case 'ko':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("j9FdF")));
        case 'nb':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("8DcID")));
        case 'nl':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("g93PL")));
        case 'pl':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("38C5h")));
        case 'pt-BR':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("1j6R2")));
        case 'ro':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("db8Mq")));
        case 'ru':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("dAssT")));
        case 'sl':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("hXhj2")));
        case 'sr-RS':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("ijv9f")));
        case 'sr-YR':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("bwFNp")));
        case 'sr':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("7EuHF")));
        case 'sv':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("824Zb")));
        case 'th':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("3Vtyt")));
        case 'tr':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("bzZRD")));
        case 'uk':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("5PAsW")));
        case 'vi':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("f2STn")));
        case 'zh-CN':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("iNdWn")));
        case 'zh-TW':
            return $d79f2b154c851db0$var$importHelper(await (parcelRequire("7LKZI")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($i2fPX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jn6Vd = parcelRequire("jn6Vd");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8ba4c3dbe149cf45$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8ba4c3dbe149cf45$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("6DVal")));
        case 'da':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("dnviE")));
        case 'de':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("inQF0")));
        case 'en-GB':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("3pSD4")));
        case 'en-US':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("l7JF3")));
        case 'en-XA':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("9EPTJ")));
        case 'en-XB':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("bi9fn")));
        case 'en-ZZ':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("6eRZW")));
        case 'en':
            return $8ba4c3dbe149cf45$var$importHelper(await Promise.resolve((parcelRequire("jn6Vd"))));
        case 'es':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("c5itn")));
        case 'et':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("5Lkat")));
        case 'fi':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("2RTex")));
        case 'fr':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("8UQU8")));
        case 'hr':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4iWGP")));
        case 'hu':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("e6L7b")));
        case 'it':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4JoIz")));
        case 'ja':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("6JOFf")));
        case 'ko':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("84Cal")));
        case 'nb':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("1bYEh")));
        case 'nl':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("28r74")));
        case 'pl':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("gx9jb")));
        case 'pt-BR':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("l8Kdm")));
        case 'ro':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("3TFWR")));
        case 'ru':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("9kURA")));
        case 'sl':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4a06L")));
        case 'sr-RS':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("abJUx")));
        case 'sr-YR':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4t3lo")));
        case 'sr':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("4ESb7")));
        case 'sv':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("5pKn7")));
        case 'th':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("jqAt5")));
        case 'tr':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("2rLoo")));
        case 'uk':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("fiPK2")));
        case 'vi':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("k9ukf")));
        case 'zh-CN':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("9ig6e")));
        case 'zh-TW':
            return $8ba4c3dbe149cf45$var$importHelper(await (parcelRequire("7MsWr")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jn6Vd));
    }
};



var $1Neys = parcelRequire("1Neys");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $e0FlU = parcelRequire("e0FlU");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $95873db9729f07c3$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $95873db9729f07c3$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("eabg7")));
        case 'da':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("jZeAX")));
        case 'de':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("2axJb")));
        case 'en-GB':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("lUsnv")));
        case 'en-US':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("8c7JZ")));
        case 'en-XA':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("abUmM")));
        case 'en-XB':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("eXUz1")));
        case 'en-ZZ':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("fEYiZ")));
        case 'en':
            return $95873db9729f07c3$var$importHelper(await Promise.resolve((parcelRequire("e0FlU"))));
        case 'es':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("5ptAs")));
        case 'et':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("1VQcl")));
        case 'fi':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("4xiJB")));
        case 'fr':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("g7kN0")));
        case 'hr':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("5aDHN")));
        case 'hu':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("6Db5r")));
        case 'it':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("7EnAW")));
        case 'ja':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("1NMC1")));
        case 'ko':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("h7mrz")));
        case 'nb':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("dJrN5")));
        case 'nl':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("kIiRu")));
        case 'pl':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("6cC5U")));
        case 'pt-BR':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("jOK5M")));
        case 'ro':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("3cL9D")));
        case 'ru':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("3sD7h")));
        case 'sl':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("5TuXS")));
        case 'sr-RS':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("7PMPV")));
        case 'sr-YR':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("4fQN1")));
        case 'sr':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("2sOFs")));
        case 'sv':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("aFgC3")));
        case 'th':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("idbW5")));
        case 'tr':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("kY8vo")));
        case 'uk':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("7t28c")));
        case 'vi':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("877yj")));
        case 'zh-CN':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("6J3MX")));
        case 'zh-TW':
            return $95873db9729f07c3$var$importHelper(await (parcelRequire("bjFRG")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($e0FlU));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $17jnj = parcelRequire("17jnj");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1d8c72db0ac48249$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $1d8c72db0ac48249$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("6ClI5")));
        case 'da':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("8hGTN")));
        case 'de':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("kgAWE")));
        case 'en-GB':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("5i55E")));
        case 'en-US':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("6lzM7")));
        case 'en-XA':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("c6grN")));
        case 'en-XB':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("eXr6z")));
        case 'en-ZZ':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("7Waeo")));
        case 'en':
            return $1d8c72db0ac48249$var$importHelper(await Promise.resolve((parcelRequire("17jnj"))));
        case 'es':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("av8hd")));
        case 'et':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("iinO3")));
        case 'fi':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("6aSdw")));
        case 'fr':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("8IdGC")));
        case 'hr':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("5Ljvt")));
        case 'hu':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("h9UHK")));
        case 'it':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("exAVp")));
        case 'ja':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("fkdWp")));
        case 'ko':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("g930E")));
        case 'nb':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("fWgxi")));
        case 'nl':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("fDLGH")));
        case 'pl':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("lTuyI")));
        case 'pt-BR':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("hfwWF")));
        case 'ro':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("iYOer")));
        case 'ru':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("b7HfY")));
        case 'sl':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("e12Gu")));
        case 'sr-RS':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("khLm8")));
        case 'sr-YR':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("bxTdC")));
        case 'sr':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("7zpdc")));
        case 'sv':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("eeoPq")));
        case 'th':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("5Bt1H")));
        case 'tr':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("lMJex")));
        case 'uk':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("8ggZy")));
        case 'vi':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("gOpNc")));
        case 'zh-CN':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("9JALx")));
        case 'zh-TW':
            return $1d8c72db0ac48249$var$importHelper(await (parcelRequire("e2NTg")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($17jnj));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aDXRl = parcelRequire("aDXRl");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $817dacc1d76f8cd5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $817dacc1d76f8cd5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("dhgg6")));
        case 'da':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("4quJN")));
        case 'de':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("4YtW3")));
        case 'en-GB':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("1dXJ4")));
        case 'en-US':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("hpIew")));
        case 'en-XA':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("l91fK")));
        case 'en-XB':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("7OnNX")));
        case 'en-ZZ':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("hnOZU")));
        case 'en':
            return $817dacc1d76f8cd5$var$importHelper(await Promise.resolve((parcelRequire("aDXRl"))));
        case 'es':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("fgbrU")));
        case 'et':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("iT7rO")));
        case 'fi':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("4YZ6d")));
        case 'fr':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("lO34q")));
        case 'hr':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("2LAgN")));
        case 'hu':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("lAEfc")));
        case 'it':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("eVqNW")));
        case 'ja':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("ioF3u")));
        case 'ko':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("1EU5y")));
        case 'nb':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("d50eo")));
        case 'nl':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("5UW3g")));
        case 'pl':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("2qyIm")));
        case 'pt-BR':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("6UYsU")));
        case 'ro':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("5Jp07")));
        case 'ru':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("hjwpd")));
        case 'sl':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("1dgn9")));
        case 'sr-RS':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("ajJkr")));
        case 'sr-YR':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("gIgCg")));
        case 'sr':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("lxn1t")));
        case 'sv':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("3ZONs")));
        case 'th':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("eZukP")));
        case 'tr':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("1Zm20")));
        case 'uk':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("fzP1A")));
        case 'vi':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("5cVsx")));
        case 'zh-CN':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("jDEId")));
        case 'zh-TW':
            return $817dacc1d76f8cd5$var$importHelper(await (parcelRequire("gxVgn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aDXRl));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8DLD7 = parcelRequire("8DLD7");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b29cafa707c395e0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b29cafa707c395e0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("5vdvc")));
        case 'da':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("qEMXn")));
        case 'de':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("5jrVu")));
        case 'en-GB':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("koJIg")));
        case 'en-US':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("aw7Dc")));
        case 'en-XA':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("jXjZI")));
        case 'en-XB':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("db8ly")));
        case 'en-ZZ':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("kTwQy")));
        case 'en':
            return $b29cafa707c395e0$var$importHelper(await Promise.resolve((parcelRequire("8DLD7"))));
        case 'es':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("7lkyB")));
        case 'et':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("dCvJo")));
        case 'fi':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("jTB0l")));
        case 'fr':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("5S1zV")));
        case 'hr':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("5TqnL")));
        case 'hu':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("bvhrU")));
        case 'it':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("58giV")));
        case 'ja':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("6hkl8")));
        case 'ko':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("f8pos")));
        case 'nb':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("ajGUp")));
        case 'nl':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("ixanl")));
        case 'pl':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("lAjmB")));
        case 'pt-BR':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("jWwky")));
        case 'ro':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("3qo0Q")));
        case 'ru':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("k3qFk")));
        case 'sl':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("793El")));
        case 'sr-RS':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("25ZVe")));
        case 'sr-YR':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("2bv7j")));
        case 'sr':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("520hK")));
        case 'sv':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("fRJ7g")));
        case 'th':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("1WZFn")));
        case 'tr':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("eYvVI")));
        case 'uk':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("4aDKk")));
        case 'vi':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("kIThW")));
        case 'zh-CN':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("k618X")));
        case 'zh-TW':
            return $b29cafa707c395e0$var$importHelper(await (parcelRequire("bqSK2")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8DLD7));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $aQHtk = parcelRequire("aQHtk");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ba63a4b1a3bf734f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ba63a4b1a3bf734f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("fMSEy")));
        case 'da':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("3G9it")));
        case 'de':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("aM2FB")));
        case 'en-GB':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("bF4VV")));
        case 'en-US':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("2SbnI")));
        case 'en-XA':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("hDNJd")));
        case 'en-XB':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("3elgK")));
        case 'en-ZZ':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("iYqND")));
        case 'en':
            return $ba63a4b1a3bf734f$var$importHelper(await Promise.resolve((parcelRequire("aQHtk"))));
        case 'es':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("dZkOi")));
        case 'et':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("7Kl9V")));
        case 'fi':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("1jiqi")));
        case 'fr':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("kwgrL")));
        case 'hr':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("9cjc7")));
        case 'hu':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("eY6Xm")));
        case 'it':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("8b476")));
        case 'ja':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("6AL9N")));
        case 'ko':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("TQ212")));
        case 'nb':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("8gBYS")));
        case 'nl':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("h1EBA")));
        case 'pl':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("2rKwb")));
        case 'pt-BR':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("bs9HJ")));
        case 'ro':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("SxP1K")));
        case 'ru':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("848Jl")));
        case 'sl':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("d6B6Y")));
        case 'sr-RS':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("aHbdn")));
        case 'sr-YR':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("lqWIu")));
        case 'sr':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("d7OQl")));
        case 'sv':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("8eV38")));
        case 'th':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("huJQM")));
        case 'tr':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("d65j7")));
        case 'uk':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("7zcwB")));
        case 'vi':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("e2I4y")));
        case 'zh-CN':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("87swa")));
        case 'zh-TW':
            return $ba63a4b1a3bf734f$var$importHelper(await (parcelRequire("bE3B0")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($aQHtk));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $gHvGn = parcelRequire("gHvGn");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1c3c2e9ecd539937$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;




































const $1c3c2e9ecd539937$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("hWly3")));
        case 'da':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("kD2jz")));
        case 'de':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("1w2IL")));
        case 'en-GB':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("8RbOE")));
        case 'en-US':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("63Yel")));
        case 'en-XA':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("5M5pV")));
        case 'en-XB':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("2nT0u")));
        case 'en-ZZ':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("3e8DW")));
        case 'en':
            return $1c3c2e9ecd539937$var$importHelper(await Promise.resolve((parcelRequire("gHvGn"))));
        case 'es':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("7OtJ9")));
        case 'et':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("c9erU")));
        case 'fi':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("jxNdA")));
        case 'fr':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("fdsXl")));
        case 'hr':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("fNRe5")));
        case 'hu':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("kPor2")));
        case 'it':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("2kbU2")));
        case 'ja-JP':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("fZi6C")));
        case 'ja':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("eRwKc")));
        case 'ko':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("yg9gZ")));
        case 'nb':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("zjuWb")));
        case 'nl':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("enIzW")));
        case 'pl':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("8rNKP")));
        case 'pt-BR':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("hzrWy")));
        case 'ro':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("M9Xz5")));
        case 'ru':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("2I4JV")));
        case 'sl':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("026q8")));
        case 'sr-RS':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("46mMR")));
        case 'sr-YR':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("kezJr")));
        case 'sr':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("dsfVu")));
        case 'sv':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("j1a5i")));
        case 'th':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("kuDvi")));
        case 'tr':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("9jMo8")));
        case 'uk':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("hrIu5")));
        case 'vi':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("04ndd")));
        case 'zh-CN':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("gnNML")));
        case 'zh-TW':
            return $1c3c2e9ecd539937$var$importHelper(await (parcelRequire("evz1y")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($gHvGn));
    }
};



var $6XRKH = parcelRequire("6XRKH");


var $4Vy0p = parcelRequire("4Vy0p");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $k2auA = parcelRequire("k2auA");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $03374d02ecd95d7d$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $03374d02ecd95d7d$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("FwuiN")));
        case 'da':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("eNgNU")));
        case 'de':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("lUgKS")));
        case 'en-GB':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("7ThjH")));
        case 'en-US':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("9sv9x")));
        case 'en-XA':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("782SK")));
        case 'en-XB':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("fKkKP")));
        case 'en-ZZ':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("5cj9Q")));
        case 'en':
            return $03374d02ecd95d7d$var$importHelper(await Promise.resolve((parcelRequire("k2auA"))));
        case 'es':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("i1khq")));
        case 'et':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("SNoUr")));
        case 'fi':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("1cRIF")));
        case 'fr':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("dzVtf")));
        case 'hr':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("gRM9j")));
        case 'hu':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("9Mae7")));
        case 'it':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("8qc8Y")));
        case 'ja':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("hENPP")));
        case 'ko':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("h9rEa")));
        case 'nb':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("4Uw1Y")));
        case 'nl':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("a2LSY")));
        case 'pl':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("jTUwT")));
        case 'pt-BR':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("6kNHQ")));
        case 'ro':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("dLmOX")));
        case 'ru':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("aCYfF")));
        case 'sl':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("fWbyw")));
        case 'sr-RS':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("as9ur")));
        case 'sr-YR':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("5x5w9")));
        case 'sr':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("eJkio")));
        case 'sv':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("e1SWB")));
        case 'th':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("e8j4V")));
        case 'tr':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("4ZM8U")));
        case 'uk':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("kljmN")));
        case 'vi':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("eZ572")));
        case 'zh-CN':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("62Cc4")));
        case 'zh-TW':
            return $03374d02ecd95d7d$var$importHelper(await (parcelRequire("8MpM5")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($k2auA));
    }
};



var $cPGgH = parcelRequire("cPGgH");


var $eaqtE = parcelRequire("eaqtE");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $9aKzs = parcelRequire("9aKzs");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3859a8d2f07ca507$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3859a8d2f07ca507$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("8GURh")));
        case 'da':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("4zGtD")));
        case 'de':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("aid6F")));
        case 'en-GB':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("4Clyy")));
        case 'en-US':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("8uQPR")));
        case 'en-XA':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("hOrRF")));
        case 'en-XB':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("2yPxv")));
        case 'en-ZZ':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("2jMAY")));
        case 'en':
            return $3859a8d2f07ca507$var$importHelper(await Promise.resolve((parcelRequire("9aKzs"))));
        case 'es':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("biFM8")));
        case 'et':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("krKp5")));
        case 'fi':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("269w2")));
        case 'fr':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("JEIM5")));
        case 'hr':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("hByEB")));
        case 'hu':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("bUhBn")));
        case 'it':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("lgRkc")));
        case 'ja':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("fqI37")));
        case 'ko':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("6oC6u")));
        case 'nb':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("cnzYU")));
        case 'nl':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("IzJ62")));
        case 'pl':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("9Ze4j")));
        case 'pt-BR':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("6z72A")));
        case 'ro':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("irxYM")));
        case 'ru':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("OrW9M")));
        case 'sl':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("8TWgT")));
        case 'sr-RS':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("h75Oa")));
        case 'sr-YR':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("1MpTu")));
        case 'sr':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("lhybn")));
        case 'sv':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("iMfuZ")));
        case 'th':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("ie2Ua")));
        case 'tr':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("aolZxO")));
        case 'uk':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("4SSNj")));
        case 'vi':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("aXc5k")));
        case 'zh-CN':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("hpKAi")));
        case 'zh-TW':
            return $3859a8d2f07ca507$var$importHelper(await (parcelRequire("2QCge")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($9aKzs));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8l5Vh = parcelRequire("8l5Vh");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5a423455785561de$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $5a423455785561de$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $5a423455785561de$var$importHelper(await (parcelRequire("2S5KU")));
        case 'da':
            return $5a423455785561de$var$importHelper(await (parcelRequire("g4LNg")));
        case 'de':
            return $5a423455785561de$var$importHelper(await (parcelRequire("exKg5")));
        case 'en-GB':
            return $5a423455785561de$var$importHelper(await (parcelRequire("gaFGJ")));
        case 'en-US':
            return $5a423455785561de$var$importHelper(await (parcelRequire("6e45s")));
        case 'en-XA':
            return $5a423455785561de$var$importHelper(await (parcelRequire("32aVk")));
        case 'en-XB':
            return $5a423455785561de$var$importHelper(await (parcelRequire("iiAkf")));
        case 'en-ZZ':
            return $5a423455785561de$var$importHelper(await (parcelRequire("2kve5")));
        case 'en':
            return $5a423455785561de$var$importHelper(await Promise.resolve((parcelRequire("8l5Vh"))));
        case 'es':
            return $5a423455785561de$var$importHelper(await (parcelRequire("avBPq")));
        case 'et':
            return $5a423455785561de$var$importHelper(await (parcelRequire("bRMrv")));
        case 'fi':
            return $5a423455785561de$var$importHelper(await (parcelRequire("9OSuz")));
        case 'fr':
            return $5a423455785561de$var$importHelper(await (parcelRequire("6htpd")));
        case 'hr':
            return $5a423455785561de$var$importHelper(await (parcelRequire("7NeIw")));
        case 'hu':
            return $5a423455785561de$var$importHelper(await (parcelRequire("8lAlf")));
        case 'it':
            return $5a423455785561de$var$importHelper(await (parcelRequire("eqRMq")));
        case 'ja':
            return $5a423455785561de$var$importHelper(await (parcelRequire("fZnKc")));
        case 'ko':
            return $5a423455785561de$var$importHelper(await (parcelRequire("eXwQn")));
        case 'nb':
            return $5a423455785561de$var$importHelper(await (parcelRequire("3HgGd")));
        case 'nl':
            return $5a423455785561de$var$importHelper(await (parcelRequire("iLuVk")));
        case 'pl':
            return $5a423455785561de$var$importHelper(await (parcelRequire("4ECdt")));
        case 'pt-BR':
            return $5a423455785561de$var$importHelper(await (parcelRequire("l5Xon")));
        case 'ro':
            return $5a423455785561de$var$importHelper(await (parcelRequire("2QxFd")));
        case 'ru':
            return $5a423455785561de$var$importHelper(await (parcelRequire("5uSzX")));
        case 'sl':
            return $5a423455785561de$var$importHelper(await (parcelRequire("eUzIC")));
        case 'sr-RS':
            return $5a423455785561de$var$importHelper(await (parcelRequire("4lKDT")));
        case 'sr-YR':
            return $5a423455785561de$var$importHelper(await (parcelRequire("78WuP")));
        case 'sr':
            return $5a423455785561de$var$importHelper(await (parcelRequire("63SLp")));
        case 'sv':
            return $5a423455785561de$var$importHelper(await (parcelRequire("5VwrO")));
        case 'th':
            return $5a423455785561de$var$importHelper(await (parcelRequire("lSRnF")));
        case 'tr':
            return $5a423455785561de$var$importHelper(await (parcelRequire("2QwtB")));
        case 'uk':
            return $5a423455785561de$var$importHelper(await (parcelRequire("cTmP6")));
        case 'vi':
            return $5a423455785561de$var$importHelper(await (parcelRequire("9vcQi")));
        case 'zh-CN':
            return $5a423455785561de$var$importHelper(await (parcelRequire("01AdQ")));
        case 'zh-TW':
            return $5a423455785561de$var$importHelper(await (parcelRequire("8bawX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8l5Vh));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6QKF0 = parcelRequire("6QKF0");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4cc9a871892cf5dd$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $4cc9a871892cf5dd$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("58F0p")));
        case 'da':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("kIii3")));
        case 'de':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("eppSn")));
        case 'en-GB':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("2UIqY")));
        case 'en-US':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("fZuj0")));
        case 'en-XA':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("5TuVS")));
        case 'en-XB':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("fULde")));
        case 'en-ZZ':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("dVNJ2")));
        case 'en':
            return $4cc9a871892cf5dd$var$importHelper(await Promise.resolve((parcelRequire("6QKF0"))));
        case 'es':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("kdH7o")));
        case 'et':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("girve")));
        case 'fi':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("91l9v")));
        case 'fr':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("jrZjR")));
        case 'hr':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("kEqGy")));
        case 'hu':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("9g7V6")));
        case 'it':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("awfIw")));
        case 'ja':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("50HSs")));
        case 'ko':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("k7EOY")));
        case 'nb':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("avOKD")));
        case 'nl':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("8aJGT")));
        case 'pl':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("b2n8Q")));
        case 'pt-BR':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("1FdUP")));
        case 'ro':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("1PBOf")));
        case 'ru':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("ayxE3")));
        case 'sl':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("3yI8C")));
        case 'sr-RS':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("hmA7l")));
        case 'sr-YR':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("8suUU")));
        case 'sr':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("1f1ta")));
        case 'sv':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("gwAcJ")));
        case 'th':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("6odmS")));
        case 'tr':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("dNgup")));
        case 'uk':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("8rgs7")));
        case 'vi':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("aowj5")));
        case 'zh-CN':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("8Mkmm")));
        case 'zh-TW':
            return $4cc9a871892cf5dd$var$importHelper(await (parcelRequire("i9CdS")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6QKF0));
    }
};



var $jWOGk = parcelRequire("jWOGk");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $hExow = parcelRequire("hExow");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b306bc40bc4d5af7$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $b306bc40bc4d5af7$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("7TLih")));
        case 'da':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("7mTau")));
        case 'de':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("aQ5Te")));
        case 'en-GB':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("3mJ4S")));
        case 'en-US':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("ehEnr")));
        case 'en-XA':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("bhKPe")));
        case 'en-XB':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("8aPOA")));
        case 'en-ZZ':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("5c04W")));
        case 'en':
            return $b306bc40bc4d5af7$var$importHelper(await Promise.resolve((parcelRequire("hExow"))));
        case 'es':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("iElhp")));
        case 'et':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("2MSuk")));
        case 'fi':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("gyU53")));
        case 'fr':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("hUMS7")));
        case 'hr':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("eCwrg")));
        case 'hu':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("2vIBs")));
        case 'it':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("ipMGk")));
        case 'ja':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("gre8P")));
        case 'ko':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("ahKBm")));
        case 'nb':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("lpVTB")));
        case 'nl':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("bNzyH")));
        case 'pl':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("9TBwA")));
        case 'pt-BR':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("6Uq1z")));
        case 'ro':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("krNGI")));
        case 'ru':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("eRkHK")));
        case 'sl':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("9X0Cq")));
        case 'sr-RS':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("kgvwa")));
        case 'sr-YR':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("6l3j3")));
        case 'sr':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("h0a3n")));
        case 'sv':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("3Mq6j")));
        case 'th':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("71Rjt")));
        case 'tr':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("cTrN7")));
        case 'uk':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("aUto0")));
        case 'vi':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("jcOzM")));
        case 'zh-CN':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("f9Xq7")));
        case 'zh-TW':
            return $b306bc40bc4d5af7$var$importHelper(await (parcelRequire("e0QjB")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($hExow));
    }
};



var $bq5SV = parcelRequire("bq5SV");


var $7QguR = parcelRequire("7QguR");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $b9HG5 = parcelRequire("b9HG5");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $134e70f7aecb7824$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $134e70f7aecb7824$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("cG81y")));
        case 'da':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("2NyU9")));
        case 'de':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("ietP8")));
        case 'en-GB':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("1eovA")));
        case 'en-US':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("5k7oO")));
        case 'en-XA':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("88KU9")));
        case 'en-XB':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("etvON")));
        case 'en-ZZ':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("9kCgZ")));
        case 'en':
            return $134e70f7aecb7824$var$importHelper(await Promise.resolve((parcelRequire("b9HG5"))));
        case 'es':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("kxQKy")));
        case 'et':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("fqcA7")));
        case 'fi':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("1k6j7")));
        case 'fr':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("8rJtX")));
        case 'hr':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("37RbN")));
        case 'hu':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("bCAVJ")));
        case 'it':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("d3t0X")));
        case 'ja':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("bMGI1")));
        case 'ko':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("8hbyi")));
        case 'nb':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("d1DSE")));
        case 'nl':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("iugLC")));
        case 'pl':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("hAZGJ")));
        case 'pt-BR':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("6gViH")));
        case 'ro':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("69cDb")));
        case 'ru':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("4myJI")));
        case 'sl':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("9cxEo")));
        case 'sr-RS':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("kalAm")));
        case 'sr-YR':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("7Fzov")));
        case 'sr':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("8OFrP")));
        case 'sv':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("5gsuk")));
        case 'th':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("5U4bf")));
        case 'tr':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("44BT5")));
        case 'uk':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("4MR8N")));
        case 'vi':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("6fdO5")));
        case 'zh-CN':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("86TRc")));
        case 'zh-TW':
            return $134e70f7aecb7824$var$importHelper(await (parcelRequire("lKnw1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($b9HG5));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $iwQJq = parcelRequire("iwQJq");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ded7a36a0b579197$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ded7a36a0b579197$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("esDHJ")));
        case 'da':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("9AMHt")));
        case 'de':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("4eLN9")));
        case 'en-GB':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("hkPKW")));
        case 'en-US':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("beYaH")));
        case 'en-XA':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("6ZiaS")));
        case 'en-XB':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("h2Q2Q")));
        case 'en-ZZ':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("bU500")));
        case 'en':
            return $ded7a36a0b579197$var$importHelper(await Promise.resolve((parcelRequire("iwQJq"))));
        case 'es':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("awDKW")));
        case 'et':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("AzXWa")));
        case 'fi':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("eF6Ya")));
        case 'fr':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("dd9cR")));
        case 'hr':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("a1Acb")));
        case 'hu':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("4LZ3t")));
        case 'it':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("9bTeQ")));
        case 'ja':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("5HqKc")));
        case 'ko':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("4uo0N")));
        case 'nb':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("1juUo")));
        case 'nl':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("cwrME")));
        case 'pl':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("8Qg1Z")));
        case 'pt-BR':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("2EI43")));
        case 'ro':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("daXaK")));
        case 'ru':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("e9mhf")));
        case 'sl':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("aoRDp")));
        case 'sr-RS':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("1FZc3")));
        case 'sr-YR':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("3gHqI")));
        case 'sr':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("dtwRs")));
        case 'sv':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("kOGAu")));
        case 'th':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("dRke1")));
        case 'tr':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("4bMpu")));
        case 'uk':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("3QLtk")));
        case 'vi':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("8hTGT")));
        case 'zh-CN':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("bXeCN")));
        case 'zh-TW':
            return $ded7a36a0b579197$var$importHelper(await (parcelRequire("9wqIE")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($iwQJq));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $f5lVB = parcelRequire("f5lVB");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $baf792afd2d6d0ed$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $baf792afd2d6d0ed$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("eJARV")));
        case 'da':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("c8HEb")));
        case 'de':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("3S5og")));
        case 'en-GB':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("1DOsy")));
        case 'en-US':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("5A0e0")));
        case 'en-XA':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("1BlH8")));
        case 'en-XB':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("eIS6p")));
        case 'en-ZZ':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("937y2")));
        case 'en':
            return $baf792afd2d6d0ed$var$importHelper(await Promise.resolve((parcelRequire("f5lVB"))));
        case 'es':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("cn7N4")));
        case 'et':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("7RVtq")));
        case 'fi':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("2C8PW")));
        case 'fr':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("2grYS")));
        case 'hr':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("hPl05")));
        case 'hu':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("2VzBa")));
        case 'it':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("1BrDj")));
        case 'ja':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("11EUE")));
        case 'ko':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("aMBi9")));
        case 'nb':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("27hut")));
        case 'nl':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("6OsG3")));
        case 'pl':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("33ogS")));
        case 'pt-BR':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("cDzdi")));
        case 'ro':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("hTXg4")));
        case 'ru':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("4yGSl")));
        case 'sl':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("67VKj")));
        case 'sr-RS':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("7CdPL")));
        case 'sr-YR':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9fzK8")));
        case 'sr':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9BrJT")));
        case 'sv':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("1tMpf")));
        case 'th':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("5toJp")));
        case 'tr':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9bd4K")));
        case 'uk':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9VH07")));
        case 'vi':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("kPern")));
        case 'zh-CN':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("eCFB3")));
        case 'zh-TW':
            return $baf792afd2d6d0ed$var$importHelper(await (parcelRequire("9Joxq")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($f5lVB));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fnjwM = parcelRequire("fnjwM");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $85b4d2dabc381287$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $85b4d2dabc381287$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("alZ6t")));
        case 'da':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jjI9T")));
        case 'de':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("4CGwT")));
        case 'en-GB':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("hLcE3")));
        case 'en-US':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("b968C")));
        case 'en-XA':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("7AD3N")));
        case 'en-XB':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("lQ73y")));
        case 'en-ZZ':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jdijK")));
        case 'en':
            return $85b4d2dabc381287$var$importHelper(await Promise.resolve((parcelRequire("fnjwM"))));
        case 'es':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("c4QmP")));
        case 'et':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("aJgCR")));
        case 'fi':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("1B4TH")));
        case 'fr':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("hRqHT")));
        case 'hr':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jyUGx")));
        case 'hu':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("bi7ue")));
        case 'it':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("63Oos")));
        case 'ja':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("cPVbs")));
        case 'ko':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("lUbkO")));
        case 'nb':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("fojmp")));
        case 'nl':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("1Im5h")));
        case 'pl':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("b7PuI")));
        case 'pt-BR':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("awCZh")));
        case 'ro':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("fX5Gv")));
        case 'ru':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("5vsDw")));
        case 'sl':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jRjmb")));
        case 'sr-RS':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("bzsYJ")));
        case 'sr-YR':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("jP49l")));
        case 'sr':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("7wWJW")));
        case 'sv':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("2n8d7")));
        case 'th':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("lmH7k")));
        case 'tr':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("6ua4X")));
        case 'uk':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("iFzjG")));
        case 'vi':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("3WTZO")));
        case 'zh-CN':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("fXzfL")));
        case 'zh-TW':
            return $85b4d2dabc381287$var$importHelper(await (parcelRequire("haLUf")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fnjwM));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kDvBY = parcelRequire("kDvBY");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $0b5cba97a6571227$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $0b5cba97a6571227$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("3qG4F")));
        case 'da':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("6vgTR")));
        case 'de':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("5uH1o")));
        case 'en-GB':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("eycDR")));
        case 'en-US':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("71unu")));
        case 'en-XA':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("7QImw")));
        case 'en-XB':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("esvWB")));
        case 'en-ZZ':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("wwoSG")));
        case 'en':
            return $0b5cba97a6571227$var$importHelper(await Promise.resolve((parcelRequire("kDvBY"))));
        case 'es':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("d9FaO")));
        case 'et':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("bcEp6")));
        case 'fi':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("cPisg")));
        case 'fr':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("gKvel")));
        case 'hr':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("iexSm")));
        case 'hu':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("3cwM2")));
        case 'it':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("6rvzd")));
        case 'ja':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("2TrDa")));
        case 'ko':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8bc2h")));
        case 'nb':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("SJxrG")));
        case 'nl':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("bdFPK")));
        case 'pl':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("dn4qr")));
        case 'pt-BR':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("4ukYk")));
        case 'ro':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("7qtmD")));
        case 'ru':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8RiMF")));
        case 'sl':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("lWsSi")));
        case 'sr-RS':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("ftx15")));
        case 'sr-YR':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("4pFQf")));
        case 'sr':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("lq0RK")));
        case 'sv':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("gdfv9")));
        case 'th':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("ifomm")));
        case 'tr':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("d8v7l")));
        case 'uk':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8fuUJ")));
        case 'vi':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8aMn9")));
        case 'zh-CN':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("8TCeu")));
        case 'zh-TW':
            return $0b5cba97a6571227$var$importHelper(await (parcelRequire("iV0ke")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kDvBY));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $eKgSp = parcelRequire("eKgSp");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7b3732ffccb37f07$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7b3732ffccb37f07$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("429nu")));
        case 'da':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lkJRX")));
        case 'de':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lTmRO")));
        case 'en-GB':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("kVSfW")));
        case 'en-US':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lga3Q")));
        case 'en-XA':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("4lqx1")));
        case 'en-XB':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("8ESoT")));
        case 'en-ZZ':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("gWvPm")));
        case 'en':
            return $7b3732ffccb37f07$var$importHelper(await Promise.resolve((parcelRequire("eKgSp"))));
        case 'es':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("9A72q")));
        case 'et':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("gx1CC")));
        case 'fi':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("bBCYv")));
        case 'fr':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("8CdyV")));
        case 'hr':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("dMuHY")));
        case 'hu':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("kMCDP")));
        case 'it':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("dWA2c")));
        case 'ja':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("izvSu")));
        case 'ko':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("7Lxrh")));
        case 'nb':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("jdwgw")));
        case 'nl':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("cHuDH")));
        case 'pl':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("keqsm")));
        case 'pt-BR':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("bKddi")));
        case 'ro':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("eZBaS")));
        case 'ru':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("d2EqJ")));
        case 'sl':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("8yPmT")));
        case 'sr-RS':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lkxV9")));
        case 'sr-YR':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lLCIC")));
        case 'sr':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("lkqfj")));
        case 'sv':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("efFK4")));
        case 'th':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("krC0o")));
        case 'tr':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("9muly")));
        case 'uk':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("apk7s")));
        case 'vi':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("fDi4x")));
        case 'zh-CN':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("gpcYc")));
        case 'zh-TW':
            return $7b3732ffccb37f07$var$importHelper(await (parcelRequire("ib4T9")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($eKgSp));
    }
};



var $gIcFu = parcelRequire("gIcFu");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $lzOvC = parcelRequire("lzOvC");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3976b1c3d1c141aa$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3976b1c3d1c141aa$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("62vgI")));
        case 'da':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("gPR4R")));
        case 'de':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("5g3kR")));
        case 'en-GB':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("c1drX")));
        case 'en-US':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("Sjgmg")));
        case 'en-XA':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("6MB91")));
        case 'en-XB':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("2oCab")));
        case 'en-ZZ':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("hzd9l")));
        case 'en':
            return $3976b1c3d1c141aa$var$importHelper(await Promise.resolve((parcelRequire("lzOvC"))));
        case 'es':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("3t2D5")));
        case 'et':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("2pKAa")));
        case 'fi':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("45Usu")));
        case 'fr':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("bHjty")));
        case 'hr':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("alPmq")));
        case 'hu':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("4M6FR")));
        case 'it':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("iyYoP")));
        case 'ja':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("kZwkd")));
        case 'ko':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("dHoaX")));
        case 'nb':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("3raFD")));
        case 'nl':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("exitT")));
        case 'pl':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("bVXPj")));
        case 'pt-BR':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("c0zow")));
        case 'ro':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("jZhFg")));
        case 'ru':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("fV7bw")));
        case 'sl':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("fPID5")));
        case 'sr-RS':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("fYROS")));
        case 'sr-YR':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("eRbae")));
        case 'sr':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("15Kks")));
        case 'sv':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("6vg3U")));
        case 'th':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("lrnaw")));
        case 'tr':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("9LzqH")));
        case 'uk':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("jbbJk")));
        case 'vi':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("jZeNQ")));
        case 'zh-CN':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("jQ2cU")));
        case 'zh-TW':
            return $3976b1c3d1c141aa$var$importHelper(await (parcelRequire("4HVs6")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lzOvC));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3MCML = parcelRequire("3MCML");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $006c0d260c041464$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $006c0d260c041464$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("1UYll")));
        case 'da':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("cfy8B")));
        case 'de':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("8fs1k")));
        case 'en-GB':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("iNW2L")));
        case 'en-US':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("5BaUx")));
        case 'en-XA':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("EjXsI")));
        case 'en-XB':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("9iJHl")));
        case 'en-ZZ':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("7mKep")));
        case 'en':
            return $006c0d260c041464$var$importHelper(await Promise.resolve((parcelRequire("3MCML"))));
        case 'es':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("eC7ku")));
        case 'et':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("6dFgH")));
        case 'fi':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("bkAt1")));
        case 'fr':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("4EhjA")));
        case 'hr':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("i6ZAF")));
        case 'hu':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("5FTml")));
        case 'it':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("J7ica")));
        case 'ja':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("aHmyb")));
        case 'ko':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("hA64x")));
        case 'nb':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("hXBk8")));
        case 'nl':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("7lT2H")));
        case 'pl':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("duMzc")));
        case 'pt-BR':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("lWweK")));
        case 'ro':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("eEMqZ")));
        case 'ru':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("1proA")));
        case 'sl':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("b5qDX")));
        case 'sr-RS':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("5Y9jh")));
        case 'sr-YR':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("iABnw")));
        case 'sr':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("4nI0d")));
        case 'sv':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("7cr6J")));
        case 'th':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("9Zgbf")));
        case 'tr':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("kmdke")));
        case 'uk':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("3YuhI")));
        case 'vi':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("jE55K")));
        case 'zh-CN':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("jYpMo")));
        case 'zh-TW':
            return $006c0d260c041464$var$importHelper(await (parcelRequire("8DQLz")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3MCML));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $5LXn7 = parcelRequire("5LXn7");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $70f71d801b11c9d6$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $70f71d801b11c9d6$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("lNvx6")));
        case 'da':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("gazYW")));
        case 'de':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("kxeq9")));
        case 'en-GB':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("1IDHd")));
        case 'en-US':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("AT11t")));
        case 'en-XA':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("bmVIy")));
        case 'en-XB':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("c1Sw8")));
        case 'en-ZZ':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("lp3zR")));
        case 'en':
            return $70f71d801b11c9d6$var$importHelper(await Promise.resolve((parcelRequire("5LXn7"))));
        case 'es':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("283aW")));
        case 'et':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("dZ4om")));
        case 'fi':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("3sUkb")));
        case 'fr':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("jBmNc")));
        case 'hr':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("15qwh")));
        case 'hu':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("5PzhD")));
        case 'it':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("7UkhN")));
        case 'ja':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("2tRH7")));
        case 'ko':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("e1zmU")));
        case 'nb':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("87I2q")));
        case 'nl':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("6WREV")));
        case 'pl':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("2sB85")));
        case 'pt-BR':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("hY2q5")));
        case 'ro':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("l5xuT")));
        case 'ru':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("2ksgB")));
        case 'sl':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("9cyWu")));
        case 'sr-RS':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("5UvXI")));
        case 'sr-YR':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("7zFF6")));
        case 'sr':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("6RotY")));
        case 'sv':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("02GWY")));
        case 'th':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("gyLnY")));
        case 'tr':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("37a11")));
        case 'uk':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("gieR4")));
        case 'vi':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("cfoJK")));
        case 'zh-CN':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("7MnUN")));
        case 'zh-TW':
            return $70f71d801b11c9d6$var$importHelper(await (parcelRequire("9u4Zn")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($5LXn7));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2Zd3Q = parcelRequire("2Zd3Q");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c5c9ef5c83558a9$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $7c5c9ef5c83558a9$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("iUZnC")));
        case 'da':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("9N4Up")));
        case 'de':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("1n5UH")));
        case 'en-GB':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("g6ptF")));
        case 'en-US':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("7wcyl")));
        case 'en-XA':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("gRTcM")));
        case 'en-XB':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("hKBiq")));
        case 'en-ZZ':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("3Rtoa")));
        case 'en':
            return $7c5c9ef5c83558a9$var$importHelper(await Promise.resolve((parcelRequire("2Zd3Q"))));
        case 'es':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("l7W0z")));
        case 'et':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("cbXiM")));
        case 'fi':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("sUJqP")));
        case 'fr':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("lzFjf")));
        case 'hr':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("99T91")));
        case 'hu':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("9M8yL")));
        case 'it':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("bKsZA")));
        case 'ja':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("4VyCo")));
        case 'ko':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("2QyXe")));
        case 'nb':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("lKFwf")));
        case 'nl':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("k14ay")));
        case 'pl':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("clUv1")));
        case 'pt-BR':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("btmDe")));
        case 'ro':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("byka9")));
        case 'ru':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("5ydME")));
        case 'sl':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("gGpon")));
        case 'sr-RS':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("9eo1c")));
        case 'sr-YR':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("jKqGZ")));
        case 'sr':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("aK5dI")));
        case 'sv':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("l7CJr")));
        case 'th':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("bODaF")));
        case 'tr':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("kZji1")));
        case 'uk':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("1CKFL")));
        case 'vi':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("bEOB5")));
        case 'zh-CN':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("kKovn")));
        case 'zh-TW':
            return $7c5c9ef5c83558a9$var$importHelper(await (parcelRequire("3LkYB")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2Zd3Q));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $3NgrG = parcelRequire("3NgrG");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3105d7182dae50be$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $3105d7182dae50be$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("7UFKR")));
        case 'da':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("7xrR7")));
        case 'de':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("5x31x")));
        case 'en-GB':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("irJXn")));
        case 'en-US':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("aj07G")));
        case 'en-XA':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("5KdSc")));
        case 'en-XB':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("elzTc")));
        case 'en-ZZ':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("jpvXg")));
        case 'en':
            return $3105d7182dae50be$var$importHelper(await Promise.resolve((parcelRequire("3NgrG"))));
        case 'es':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("iyt6Y")));
        case 'et':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("kGz6V")));
        case 'fi':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("feZ8g")));
        case 'fr':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("Gh97v")));
        case 'hr':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("lQTvq")));
        case 'hu':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("j0D9N")));
        case 'it':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("7u6a1")));
        case 'ja':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("78jBd")));
        case 'ko':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("kk9UR")));
        case 'nb':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("p0vY1")));
        case 'nl':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("5Z0g7")));
        case 'pl':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("5i3XF")));
        case 'pt-BR':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("aVvtu")));
        case 'ro':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("7Fvbt")));
        case 'ru':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("2RDu2")));
        case 'sl':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("c2ndM")));
        case 'sr-RS':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("gUTaH")));
        case 'sr-YR':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("lCWMS")));
        case 'sr':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("hm9Dy")));
        case 'sv':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("3ONYW")));
        case 'th':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("hRI0p")));
        case 'tr':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("gTtok")));
        case 'uk':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("hb44P")));
        case 'vi':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("hX03y")));
        case 'zh-CN':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("fYaiw")));
        case 'zh-TW':
            return $3105d7182dae50be$var$importHelper(await (parcelRequire("6VwSN")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($3NgrG));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $bEUWX = parcelRequire("bEUWX");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $355fa0babacd352f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $355fa0babacd352f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2RLjC")));
        case 'da':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("dGu50")));
        case 'de':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("aOiiW")));
        case 'en-GB':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("funYt")));
        case 'en-US':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("i24EM")));
        case 'en-XA':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("jhXoI")));
        case 'en-XB':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("L5WWk")));
        case 'en-ZZ':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("h0oUr")));
        case 'en':
            return $355fa0babacd352f$var$importHelper(await Promise.resolve((parcelRequire("bEUWX"))));
        case 'es':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("13Wsv")));
        case 'et':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("gVqQl")));
        case 'fi':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("aSf2F")));
        case 'fr':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("iaMoz")));
        case 'hr':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("cpDmt")));
        case 'hu':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("1Crzy")));
        case 'it':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2NSFh")));
        case 'ja':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2Durl")));
        case 'ko':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2fH5g")));
        case 'nb':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("de9J4")));
        case 'nl':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2w5Qd")));
        case 'pl':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("ht60R")));
        case 'pt-BR':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("l8Lmn")));
        case 'ro':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("e07cw")));
        case 'ru':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("jKS37")));
        case 'sl':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("cdolv")));
        case 'sr-RS':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("eDzD9")));
        case 'sr-YR':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("2mx5U")));
        case 'sr':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("1PMkZ")));
        case 'sv':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("hWVm9")));
        case 'th':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("jSqbS")));
        case 'tr':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("1VVPw")));
        case 'uk':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("3xs7D")));
        case 'vi':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("dNusO")));
        case 'zh-CN':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("dilgY")));
        case 'zh-TW':
            return $355fa0babacd352f$var$importHelper(await (parcelRequire("7sfMS")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bEUWX));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $yNAPT = parcelRequire("yNAPT");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $388818403434a675$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $388818403434a675$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $388818403434a675$var$importHelper(await (parcelRequire("at6ge")));
        case 'da':
            return $388818403434a675$var$importHelper(await (parcelRequire("h3LQV")));
        case 'de':
            return $388818403434a675$var$importHelper(await (parcelRequire("iDANl")));
        case 'en-GB':
            return $388818403434a675$var$importHelper(await (parcelRequire("bsAiM")));
        case 'en-US':
            return $388818403434a675$var$importHelper(await (parcelRequire("6lyYa")));
        case 'en-XA':
            return $388818403434a675$var$importHelper(await (parcelRequire("8qi8n")));
        case 'en-XB':
            return $388818403434a675$var$importHelper(await (parcelRequire("6XkOd")));
        case 'en-ZZ':
            return $388818403434a675$var$importHelper(await (parcelRequire("d67Hj")));
        case 'en':
            return $388818403434a675$var$importHelper(await Promise.resolve((parcelRequire("yNAPT"))));
        case 'es':
            return $388818403434a675$var$importHelper(await (parcelRequire("1keZ4")));
        case 'et':
            return $388818403434a675$var$importHelper(await (parcelRequire("2nKnU")));
        case 'fi':
            return $388818403434a675$var$importHelper(await (parcelRequire("gWLXI")));
        case 'fr':
            return $388818403434a675$var$importHelper(await (parcelRequire("1BDAL")));
        case 'hr':
            return $388818403434a675$var$importHelper(await (parcelRequire("jtjTT")));
        case 'hu':
            return $388818403434a675$var$importHelper(await (parcelRequire("e1N2p")));
        case 'it':
            return $388818403434a675$var$importHelper(await (parcelRequire("9lyX3")));
        case 'ja':
            return $388818403434a675$var$importHelper(await (parcelRequire("dTUIP")));
        case 'ko':
            return $388818403434a675$var$importHelper(await (parcelRequire("04MZU")));
        case 'nb':
            return $388818403434a675$var$importHelper(await (parcelRequire("dVWXL")));
        case 'nl':
            return $388818403434a675$var$importHelper(await (parcelRequire("a8PaN")));
        case 'pl':
            return $388818403434a675$var$importHelper(await (parcelRequire("jCefS")));
        case 'pt-BR':
            return $388818403434a675$var$importHelper(await (parcelRequire("9V8bE")));
        case 'ro':
            return $388818403434a675$var$importHelper(await (parcelRequire("1mMbt")));
        case 'ru':
            return $388818403434a675$var$importHelper(await (parcelRequire("1F49G")));
        case 'sl':
            return $388818403434a675$var$importHelper(await (parcelRequire("a7MkY")));
        case 'sr-RS':
            return $388818403434a675$var$importHelper(await (parcelRequire("c736q")));
        case 'sr-YR':
            return $388818403434a675$var$importHelper(await (parcelRequire("fYv7t")));
        case 'sr':
            return $388818403434a675$var$importHelper(await (parcelRequire("5GFdo")));
        case 'sv':
            return $388818403434a675$var$importHelper(await (parcelRequire("aBTMj")));
        case 'th':
            return $388818403434a675$var$importHelper(await (parcelRequire("bDOVy")));
        case 'tr':
            return $388818403434a675$var$importHelper(await (parcelRequire("euBtw")));
        case 'uk':
            return $388818403434a675$var$importHelper(await (parcelRequire("cMpDF")));
        case 'vi':
            return $388818403434a675$var$importHelper(await (parcelRequire("cPYe2")));
        case 'zh-CN':
            return $388818403434a675$var$importHelper(await (parcelRequire("fgCrG")));
        case 'zh-TW':
            return $388818403434a675$var$importHelper(await (parcelRequire("hkOdi")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($yNAPT));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $fyclM = parcelRequire("fyclM");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dd065fd1382b4a2f$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $dd065fd1382b4a2f$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("cGd1k")));
        case 'da':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("3HDjE")));
        case 'de':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("hAAl0")));
        case 'en-GB':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("ky6Rt")));
        case 'en-US':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("aU26J")));
        case 'en-XA':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("4FonW")));
        case 'en-XB':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("6uKj4")));
        case 'en-ZZ':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("3tAQa")));
        case 'en':
            return $dd065fd1382b4a2f$var$importHelper(await Promise.resolve((parcelRequire("fyclM"))));
        case 'es':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("1HVDx")));
        case 'et':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("9CafP")));
        case 'fi':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("6ltLd")));
        case 'fr':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("i16Fe")));
        case 'hr':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("6r2ld")));
        case 'hu':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("kf1O9")));
        case 'it':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("b4nzq")));
        case 'ja':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("ljPEV")));
        case 'ko':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("8KduJ")));
        case 'nb':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("hMJjt")));
        case 'nl':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("40c6r")));
        case 'pl':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("6LxVi")));
        case 'pt-BR':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("7p3Ya")));
        case 'ro':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("dIGoT")));
        case 'ru':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("aX1s8")));
        case 'sl':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("c3rCu")));
        case 'sr-RS':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("dVLoB")));
        case 'sr-YR':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("j5CRW")));
        case 'sr':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("lg8vL")));
        case 'sv':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("9jSrV")));
        case 'th':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("92SVU")));
        case 'tr':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("aghh8")));
        case 'uk':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("kksE6")));
        case 'vi':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("2Di42")));
        case 'zh-CN':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("mhkYP")));
        case 'zh-TW':
            return $dd065fd1382b4a2f$var$importHelper(await (parcelRequire("bAQal")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($fyclM));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $c8Pyb = parcelRequire("c8Pyb");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cecaf353d0a30194$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $cecaf353d0a30194$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("72yBg")));
        case 'da':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("34CHz")));
        case 'de':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("kMKcN")));
        case 'en-GB':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("apltJ")));
        case 'en-US':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("3K0Yv")));
        case 'en-XA':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("djKWK")));
        case 'en-XB':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("01utY")));
        case 'en-ZZ':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("24m3m")));
        case 'en':
            return $cecaf353d0a30194$var$importHelper(await Promise.resolve((parcelRequire("c8Pyb"))));
        case 'es':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("96EuC")));
        case 'et':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("2U42d")));
        case 'fi':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("7Gz2R")));
        case 'fr':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("eJudw")));
        case 'hr':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("jWXSm")));
        case 'hu':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("d0CCF")));
        case 'it':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("hVgMi")));
        case 'ja':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("aqAkV")));
        case 'ko':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("8jPAN")));
        case 'nb':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("hJ1Ua")));
        case 'nl':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("a9ymm")));
        case 'pl':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("dqohW")));
        case 'pt-BR':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("c5L14")));
        case 'ro':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("1xaV8")));
        case 'ru':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("htHe6")));
        case 'sl':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("8xsok")));
        case 'sr-RS':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("id7hU")));
        case 'sr-YR':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("fy3FM")));
        case 'sr':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("5NLRP")));
        case 'sv':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("94DnD")));
        case 'th':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("juHGP")));
        case 'tr':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("a2UWN")));
        case 'uk':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("5PbVc")));
        case 'vi':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("amBbx")));
        case 'zh-CN':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("fkh2h")));
        case 'zh-TW':
            return $cecaf353d0a30194$var$importHelper(await (parcelRequire("40r0l")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($c8Pyb));
    }
};



var $4mlnj = parcelRequire("4mlnj");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $d9Kla = parcelRequire("d9Kla");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a28bd0d7be6a48f1$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $a28bd0d7be6a48f1$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("ktcOp")));
        case 'da':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("iBniq")));
        case 'de':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("9E25K")));
        case 'en-GB':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("6anjp")));
        case 'en-US':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("luucs")));
        case 'en-XA':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("f5joJ")));
        case 'en-XB':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("6nrI0")));
        case 'en-ZZ':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("bxaDU")));
        case 'en':
            return $a28bd0d7be6a48f1$var$importHelper(await Promise.resolve((parcelRequire("d9Kla"))));
        case 'es':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("98EBs")));
        case 'et':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("gE99x")));
        case 'fi':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("hlhL8")));
        case 'fr':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("9yRox")));
        case 'hr':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("lQ8wg")));
        case 'hu':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("jnLzZ")));
        case 'it':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("2C8Xo")));
        case 'ja':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("5h5os")));
        case 'ko':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("ei1op")));
        case 'nb':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("9fvHg")));
        case 'nl':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("hLER0")));
        case 'pl':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("aFnwY")));
        case 'pt-BR':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("0sqpa")));
        case 'ro':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("fVd32")));
        case 'ru':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("bmLRy")));
        case 'sl':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("k3mzK")));
        case 'sr-RS':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("1Uxdk")));
        case 'sr-YR':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("k7AMr")));
        case 'sr':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("kum9N")));
        case 'sv':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("1kfoi")));
        case 'th':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("2UjWQ")));
        case 'tr':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("jaQ6u")));
        case 'uk':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("hMVdN")));
        case 'vi':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("6pAEW")));
        case 'zh-CN':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("kzCrI")));
        case 'zh-TW':
            return $a28bd0d7be6a48f1$var$importHelper(await (parcelRequire("gKRAQ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($d9Kla));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $gK3zM = parcelRequire("gK3zM");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $17036b5e3995711b$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $17036b5e3995711b$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("dC2IS")));
        case 'da':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("aIZAP")));
        case 'de':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("hWcFz")));
        case 'en-GB':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("i96r9")));
        case 'en-US':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("3nia2")));
        case 'en-XA':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("da2r6")));
        case 'en-XB':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("bXNpI")));
        case 'en-ZZ':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("66n3X")));
        case 'en':
            return $17036b5e3995711b$var$importHelper(await Promise.resolve((parcelRequire("gK3zM"))));
        case 'es':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("cpZ6Z")));
        case 'et':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("4ET6R")));
        case 'fi':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("9VSom")));
        case 'fr':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("SDfFq")));
        case 'hr':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("bt1SJ")));
        case 'hu':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("lzChE")));
        case 'it':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("hXmDf")));
        case 'ja':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("aUZ8j")));
        case 'ko':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("1u6AF")));
        case 'nb':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("sImHY")));
        case 'nl':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("fcZIE")));
        case 'pl':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("16P0m")));
        case 'pt-BR':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("7vwBZ")));
        case 'ro':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("cVRT2")));
        case 'ru':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("8JdZ1")));
        case 'sl':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("guipf")));
        case 'sr-RS':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("k0CnR")));
        case 'sr-YR':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("b8ebr")));
        case 'sr':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("6NLKW")));
        case 'sv':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("kh1Vy")));
        case 'th':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("3gqHa")));
        case 'tr':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("gVvdw")));
        case 'uk':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("3vvpd")));
        case 'vi':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("4yDFm")));
        case 'zh-CN':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("9ZMNS")));
        case 'zh-TW':
            return $17036b5e3995711b$var$importHelper(await (parcelRequire("dFCLX")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($gK3zM));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $6HVff = parcelRequire("6HVff");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2c58b23859af77ab$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2c58b23859af77ab$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("2Kd6C")));
        case 'da':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("lw41y")));
        case 'de':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("crUJD")));
        case 'en-GB':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("b1wqV")));
        case 'en-US':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("g6r7n")));
        case 'en-XA':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("3VXaK")));
        case 'en-XB':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("6dDc8")));
        case 'en-ZZ':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("aIzii")));
        case 'en':
            return $2c58b23859af77ab$var$importHelper(await Promise.resolve((parcelRequire("6HVff"))));
        case 'es':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("83hQf")));
        case 'et':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("cQcQk")));
        case 'fi':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("6YyWh")));
        case 'fr':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("5Z7pM")));
        case 'hr':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("2rBOg")));
        case 'hu':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("aVKau")));
        case 'it':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("e0dbW")));
        case 'ja':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("h7c5Y")));
        case 'ko':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("3zn4F")));
        case 'nb':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("6Pqb8")));
        case 'nl':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("f09u8")));
        case 'pl':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("f8znK")));
        case 'pt-BR':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("bKnCl")));
        case 'ro':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("9Tbjf")));
        case 'ru':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("7tpoI")));
        case 'sl':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("1NbHf")));
        case 'sr-RS':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("3HIVY")));
        case 'sr-YR':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("a8ohm")));
        case 'sr':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("ivZD4")));
        case 'sv':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("iSxsK")));
        case 'th':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("RcCEN")));
        case 'tr':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("bgfWq")));
        case 'uk':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("imUvr")));
        case 'vi':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("gCVPz")));
        case 'zh-CN':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("afU4v")));
        case 'zh-TW':
            return $2c58b23859af77ab$var$importHelper(await (parcelRequire("aK9R1")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($6HVff));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $b9hxd = parcelRequire("b9hxd");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8c19776cd00b41d0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8c19776cd00b41d0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("gFZts")));
        case 'da':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("eWItg")));
        case 'de':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("78918")));
        case 'en-GB':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("gJib5")));
        case 'en-US':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("1sFPA")));
        case 'en-XA':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("cwUFF")));
        case 'en-XB':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("6dvF9")));
        case 'en-ZZ':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("csb1s")));
        case 'en':
            return $8c19776cd00b41d0$var$importHelper(await Promise.resolve((parcelRequire("b9hxd"))));
        case 'es':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("bCHa3")));
        case 'et':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("553z6")));
        case 'fi':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("14QYC")));
        case 'fr':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("iTvo8")));
        case 'hr':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("22MCk")));
        case 'hu':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("3W3fm")));
        case 'it':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("5k5XS")));
        case 'ja':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("kGoGQ")));
        case 'ko':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("eyOq1")));
        case 'nb':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("2desL")));
        case 'nl':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("6ruAp")));
        case 'pl':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("gxAUL")));
        case 'pt-BR':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("7xXf0")));
        case 'ro':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("6xmsq")));
        case 'ru':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("lStcL")));
        case 'sl':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("dwuVP")));
        case 'sr-RS':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("9uf6k")));
        case 'sr-YR':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("19tni")));
        case 'sr':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("fI7ZB")));
        case 'sv':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("4QBCK")));
        case 'th':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("lf5sD")));
        case 'tr':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("ewCAm")));
        case 'uk':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("gSOTt")));
        case 'vi':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("9b0w8")));
        case 'zh-CN':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("9ejEW")));
        case 'zh-TW':
            return $8c19776cd00b41d0$var$importHelper(await (parcelRequire("bMYzJ")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($b9hxd));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $lpVVF = parcelRequire("lpVVF");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2293023ccb53b013$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $2293023ccb53b013$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("acziF")));
        case 'da':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("jP4Dk")));
        case 'de':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("g9Mmd")));
        case 'en-GB':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("c8CIX")));
        case 'en-US':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("cLyLc")));
        case 'en-XA':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("6huTR")));
        case 'en-XB':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("02XSw")));
        case 'en-ZZ':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("5CNqE")));
        case 'en':
            return $2293023ccb53b013$var$importHelper(await Promise.resolve((parcelRequire("lpVVF"))));
        case 'es':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("iPbDx")));
        case 'et':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("j3Rl4")));
        case 'fi':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("1uoXH")));
        case 'fr':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("lNTqV")));
        case 'hr':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("6Wm8l")));
        case 'hu':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("iRCg9")));
        case 'it':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("3kGub")));
        case 'ja':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("1QZp2")));
        case 'ko':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("01qRf")));
        case 'nb':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("uwqzU")));
        case 'nl':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("mKEZ8")));
        case 'pl':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("l0rWL")));
        case 'pt-BR':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("4ALsf")));
        case 'ro':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("aBQpk")));
        case 'ru':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("9aVqg")));
        case 'sl':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("6nZlF")));
        case 'sr-RS':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("danHd")));
        case 'sr-YR':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("6G461")));
        case 'sr':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("2OLQd")));
        case 'sv':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("be6SR")));
        case 'th':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("lVSd3")));
        case 'tr':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("cpdri")));
        case 'uk':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("3Bixi")));
        case 'vi':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("3Yuu3")));
        case 'zh-CN':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("k3dTn")));
        case 'zh-TW':
            return $2293023ccb53b013$var$importHelper(await (parcelRequire("56e4D")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($lpVVF));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $03a7D = parcelRequire("03a7D");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $87af2e221c22354b$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $87af2e221c22354b$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("iUFhM")));
        case 'da':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("6kbnv")));
        case 'de':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("isMeM")));
        case 'en-GB':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("6ePtG")));
        case 'en-US':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("8h36A")));
        case 'en-XA':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("iGK1b")));
        case 'en-XB':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("cdt3d")));
        case 'en-ZZ':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("6wWfH")));
        case 'en':
            return $87af2e221c22354b$var$importHelper(await Promise.resolve((parcelRequire("03a7D"))));
        case 'es':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("2Neoq")));
        case 'et':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("enz3X")));
        case 'fi':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("9fEIL")));
        case 'fr':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("2RZTm")));
        case 'hr':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("bm8hE")));
        case 'hu':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("ccxy3")));
        case 'it':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("fF1ow")));
        case 'ja':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("7sapK")));
        case 'ko':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("6tBdX")));
        case 'nb':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("5DiPD")));
        case 'nl':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("4KOk9")));
        case 'pl':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("4IrS3")));
        case 'pt-BR':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("8oujl")));
        case 'ro':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("DIrQ3")));
        case 'ru':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("gZQ9s")));
        case 'sl':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("clvP4")));
        case 'sr-RS':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("KfxtW")));
        case 'sr-YR':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("2z4QG")));
        case 'sr':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("d713K")));
        case 'sv':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("h9naC")));
        case 'th':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("7prL8")));
        case 'tr':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("937zY")));
        case 'uk':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("dclGe")));
        case 'vi':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("kkNoL")));
        case 'zh-CN':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("34TFK")));
        case 'zh-TW':
            return $87af2e221c22354b$var$importHelper(await (parcelRequire("iO9wq")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($03a7D));
    }
};



var $9l5Wa = parcelRequire("9l5Wa");


var $afYui = parcelRequire("afYui");


var $jUaOQ = parcelRequire("jUaOQ");


var $9UiU1 = parcelRequire("9UiU1");

/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $8IaD6 = parcelRequire("8IaD6");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ad24903dddc35718$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $ad24903dddc35718$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("fjK1g")));
        case 'da':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7Cxrz")));
        case 'de':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("gm21G")));
        case 'en-GB':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("f0OVj")));
        case 'en-US':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("baPkP")));
        case 'en-XA':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("acwEe")));
        case 'en-XB':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("1F7Fi")));
        case 'en-ZZ':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("bYaRo")));
        case 'en':
            return $ad24903dddc35718$var$importHelper(await Promise.resolve((parcelRequire("8IaD6"))));
        case 'es':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7o16o")));
        case 'et':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("dlX8d")));
        case 'fi':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("eEXjN")));
        case 'fr':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7Tvwf")));
        case 'hr':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("8G60n")));
        case 'hu':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("iEFhI")));
        case 'it':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("5J4lr")));
        case 'ja':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7TAVK")));
        case 'ko':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("8K6Nr")));
        case 'nb':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7Afq7")));
        case 'nl':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("5gNbS")));
        case 'pl':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("88tHU")));
        case 'pt-BR':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("4LNoh")));
        case 'ro':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("3UJPP")));
        case 'ru':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("8BoSL")));
        case 'sl':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("5bseM")));
        case 'sr-RS':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("8Taz6")));
        case 'sr-YR':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("dSUn6")));
        case 'sr':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("fV2yV")));
        case 'sv':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("7dIJm")));
        case 'th':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("23tal")));
        case 'tr':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("dMbaR")));
        case 'uk':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("hfWR0")));
        case 'vi':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("91jOk")));
        case 'zh-CN':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("f6wto")));
        case 'zh-TW':
            return $ad24903dddc35718$var$importHelper(await (parcelRequire("4PWHz")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($8IaD6));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $kPr2b = parcelRequire("kPr2b");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8d10a33c36e367dc$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $8d10a33c36e367dc$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("4ZWNt")));
        case 'da':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("jmb7g")));
        case 'de':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("lV852")));
        case 'en-GB':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("2N2rV")));
        case 'en-US':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("5q0jV")));
        case 'en-XA':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("kwUKZ")));
        case 'en-XB':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("hhfhU")));
        case 'en-ZZ':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("iboJb")));
        case 'en':
            return $8d10a33c36e367dc$var$importHelper(await Promise.resolve((parcelRequire("kPr2b"))));
        case 'es':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("9Vsjx")));
        case 'et':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("27sh5")));
        case 'fi':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("6oIvE")));
        case 'fr':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("1wxZ1")));
        case 'hr':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("g7Mce")));
        case 'hu':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("d6Xn9")));
        case 'it':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("f1A8G")));
        case 'ja':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("20HRd")));
        case 'ko':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("gi6su")));
        case 'nb':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("fkjiw")));
        case 'nl':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("f86Qv")));
        case 'pl':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("gd6Pb")));
        case 'pt-BR':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("fPpTt")));
        case 'ro':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("jdobf")));
        case 'ru':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("iCCpE")));
        case 'sl':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("hHzOZ")));
        case 'sr-RS':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("g9fh6")));
        case 'sr-YR':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("5wENs")));
        case 'sr':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("4jY0a")));
        case 'sv':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("4ErJP")));
        case 'th':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("dA83e")));
        case 'tr':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("hXgoQ")));
        case 'uk':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("bRXbf")));
        case 'vi':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("dJRZ3")));
        case 'zh-CN':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("1fZEx")));
        case 'zh-TW':
            return $8d10a33c36e367dc$var$importHelper(await (parcelRequire("ahjHi")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($kPr2b));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $ce9f2 = parcelRequire("ce9f2");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c62971c5e7ad3fa5$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $c62971c5e7ad3fa5$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("h4XLq")));
        case 'da':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("aSIuu")));
        case 'de':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("23l4O")));
        case 'en-GB':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("cChEl")));
        case 'en-US':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("f3rj4")));
        case 'en-XA':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("gcN2A")));
        case 'en-XB':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("bzeFj")));
        case 'en-ZZ':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("iaQTW")));
        case 'en':
            return $c62971c5e7ad3fa5$var$importHelper(await Promise.resolve((parcelRequire("ce9f2"))));
        case 'es':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("3VbYR")));
        case 'et':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("66euP")));
        case 'fi':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("dWdh5")));
        case 'fr':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("6L5mq")));
        case 'hr':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("8d9mp")));
        case 'hu':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("6oh7C")));
        case 'it':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("5Ih8N")));
        case 'ja':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("aiIM4")));
        case 'ko':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("ezVJc")));
        case 'nb':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("d5Py7")));
        case 'nl':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("l460a")));
        case 'pl':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("ktgFI")));
        case 'pt-BR':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("5RWbp")));
        case 'ro':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("akrpS")));
        case 'ru':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("9su3t")));
        case 'sl':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("krb0o")));
        case 'sr-RS':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("ax70l")));
        case 'sr-YR':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("Mb2FM")));
        case 'sr':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("5hvFc")));
        case 'sv':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("i9uou")));
        case 'th':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("bqXXX")));
        case 'tr':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("bwbqM")));
        case 'uk':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("d4pv2")));
        case 'vi':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("4im8D")));
        case 'zh-CN':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("8RCWw")));
        case 'zh-TW':
            return $c62971c5e7ad3fa5$var$importHelper(await (parcelRequire("c6FoP")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($ce9f2));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $2N9a7 = parcelRequire("2N9a7");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $aeaec42c95afaea0$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $aeaec42c95afaea0$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("c2txx")));
        case 'da':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("5bfTF")));
        case 'de':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("yv2PF")));
        case 'en-GB':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("5ytEt")));
        case 'en-US':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("84xPc")));
        case 'en-XA':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("g50do")));
        case 'en-XB':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("ldTqI")));
        case 'en-ZZ':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("1P4Bo")));
        case 'en':
            return $aeaec42c95afaea0$var$importHelper(await Promise.resolve((parcelRequire("2N9a7"))));
        case 'es':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("kLuUQ")));
        case 'et':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("17Z99")));
        case 'fi':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("7WGGY")));
        case 'fr':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("jeifm")));
        case 'hr':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("dM9Ko")));
        case 'hu':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("9dS55")));
        case 'it':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("aruux")));
        case 'ja':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("6z61k")));
        case 'ko':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("5kRoJ")));
        case 'nb':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("feR2c")));
        case 'nl':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("4etg2")));
        case 'pl':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("8nZQJ")));
        case 'pt-BR':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("8lFmQ")));
        case 'ro':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("g8jnN")));
        case 'ru':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("jBETK")));
        case 'sl':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("3rMHk")));
        case 'sr-RS':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("dIytw")));
        case 'sr-YR':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("ISfPl")));
        case 'sr':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("9vqSC")));
        case 'sv':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("dcv25")));
        case 'th':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("6DwO1")));
        case 'tr':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("4iphv")));
        case 'uk':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("fxZOi")));
        case 'vi':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("9GOzA")));
        case 'zh-CN':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("dfTVS")));
        case 'zh-TW':
            return $aeaec42c95afaea0$var$importHelper(await (parcelRequire("Nzu2E")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($2N9a7));
    }
};


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
#
# Generate source: local/cli/src/commands/generate-all/i18n-extract.ts
*/ 
var $jZkCD = parcelRequire("jZkCD");




// Helper to automatically handle ESM and non-ESM *.json imports (either is possible depending on the service/product's build configuration)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $05a146ac2e533fa7$var$importHelper = (mod)=>mod && mod.__esModule ? mod.default : mod;



































const $05a146ac2e533fa7$export$720676d8cac8fbb = async (locale)=>{
    const normalizedLocale = (0, $cUcPn.default)(locale);
    switch(normalizedLocale){
        case 'cs':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("6ZT3C")));
        case 'da':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("5cTfJ")));
        case 'de':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("camC3")));
        case 'en-GB':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("a1edG")));
        case 'en-US':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("hozy7")));
        case 'en-XA':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("3sU7B")));
        case 'en-XB':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("ad5pE")));
        case 'en-ZZ':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("lTULb")));
        case 'en':
            return $05a146ac2e533fa7$var$importHelper(await Promise.resolve((parcelRequire("jZkCD"))));
        case 'es':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("dAEiR")));
        case 'et':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("9nH1R")));
        case 'fi':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("kjKfL")));
        case 'fr':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("g2PTm")));
        case 'hr':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("6q5Fg")));
        case 'hu':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("lghd1")));
        case 'it':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("64AMJ")));
        case 'ja':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("a7XXP")));
        case 'ko':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("b5VVj")));
        case 'nb':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("jlOJT")));
        case 'nl':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("hIhOs")));
        case 'pl':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("28Vku")));
        case 'pt-BR':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("2sxxn")));
        case 'ro':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("aRIgT")));
        case 'ru':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("9ciVU")));
        case 'sl':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("5DLSN")));
        case 'sr-RS':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("jMFNQ")));
        case 'sr-YR':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("72eR9")));
        case 'sr':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("8Vo2l")));
        case 'sv':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("8sK49")));
        case 'th':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("jvQHv")));
        case 'tr':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("i2Vpd")));
        case 'uk':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("8qoY9")));
        case 'vi':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("1hFwa")));
        case 'zh-CN':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("4nr8Z")));
        case 'zh-TW':
            return $05a146ac2e533fa7$var$importHelper(await (parcelRequire("kBX89")));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($jZkCD));
    }
};


const $554485f66d5d0ef4$export$d5a462ce7bd04520 = async (locale)=>{
    return Promise.allSettled([
        (0, $e22f3c88d35d75f3$export$720676d8cac8fbb)(locale),
        (0, $e6415930b3d4f363$export$720676d8cac8fbb)(locale),
        (0, $d79f2b154c851db0$export$720676d8cac8fbb)(locale),
        (0, $8ba4c3dbe149cf45$export$720676d8cac8fbb)(locale),
        (0, $1Neys.messagesLoader)(locale),
        (0, $95873db9729f07c3$export$720676d8cac8fbb)(locale),
        (0, $1d8c72db0ac48249$export$720676d8cac8fbb)(locale),
        (0, $817dacc1d76f8cd5$export$720676d8cac8fbb)(locale),
        (0, $b29cafa707c395e0$export$720676d8cac8fbb)(locale),
        (0, $ba63a4b1a3bf734f$export$720676d8cac8fbb)(locale),
        (0, $1c3c2e9ecd539937$export$720676d8cac8fbb)(locale),
        (0, $6XRKH.messagesLoader)(locale),
        (0, $4Vy0p.messagesLoader)(locale),
        (0, $03374d02ecd95d7d$export$720676d8cac8fbb)(locale),
        (0, $cPGgH.messagesLoader)(locale),
        (0, $eaqtE.messagesLoader)(locale),
        (0, $3859a8d2f07ca507$export$720676d8cac8fbb)(locale),
        (0, $5a423455785561de$export$720676d8cac8fbb)(locale),
        (0, $4cc9a871892cf5dd$export$720676d8cac8fbb)(locale),
        (0, $jWOGk.messagesLoader)(locale),
        (0, $b306bc40bc4d5af7$export$720676d8cac8fbb)(locale),
        (0, $bq5SV.messagesLoader)(locale),
        (0, $7QguR.messagesLoader)(locale),
        (0, $134e70f7aecb7824$export$720676d8cac8fbb)(locale),
        (0, $ded7a36a0b579197$export$720676d8cac8fbb)(locale),
        (0, $baf792afd2d6d0ed$export$720676d8cac8fbb)(locale),
        (0, $85b4d2dabc381287$export$720676d8cac8fbb)(locale),
        (0, $0b5cba97a6571227$export$720676d8cac8fbb)(locale),
        (0, $7b3732ffccb37f07$export$720676d8cac8fbb)(locale),
        (0, $gIcFu.messagesLoader)(locale),
        (0, $3976b1c3d1c141aa$export$720676d8cac8fbb)(locale),
        (0, $006c0d260c041464$export$720676d8cac8fbb)(locale),
        (0, $70f71d801b11c9d6$export$720676d8cac8fbb)(locale),
        (0, $7c5c9ef5c83558a9$export$720676d8cac8fbb)(locale),
        (0, $3105d7182dae50be$export$720676d8cac8fbb)(locale),
        (0, $355fa0babacd352f$export$720676d8cac8fbb)(locale),
        (0, $388818403434a675$export$720676d8cac8fbb)(locale),
        (0, $dd065fd1382b4a2f$export$720676d8cac8fbb)(locale),
        (0, $cecaf353d0a30194$export$720676d8cac8fbb)(locale),
        (0, $4mlnj.messagesLoader)(locale),
        (0, $a28bd0d7be6a48f1$export$720676d8cac8fbb)(locale),
        (0, $17036b5e3995711b$export$720676d8cac8fbb)(locale),
        (0, $2c58b23859af77ab$export$720676d8cac8fbb)(locale),
        (0, $8c19776cd00b41d0$export$720676d8cac8fbb)(locale),
        (0, $2293023ccb53b013$export$720676d8cac8fbb)(locale),
        (0, $87af2e221c22354b$export$720676d8cac8fbb)(locale),
        (0, $9l5Wa.messagesLoader)(locale),
        (0, $afYui.messagesLoader)(locale),
        (0, $jUaOQ.messagesLoader)(locale),
        (0, $9UiU1.messagesLoader)(locale),
        (0, $ad24903dddc35718$export$720676d8cac8fbb)(locale),
        (0, $8d10a33c36e367dc$export$720676d8cac8fbb)(locale),
        (0, $c62971c5e7ad3fa5$export$720676d8cac8fbb)(locale),
        (0, $aeaec42c95afaea0$export$720676d8cac8fbb)(locale),
        (0, $05a146ac2e533fa7$export$720676d8cac8fbb)(locale)
    ]).then((results)=>{
        return results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                messages: {
                    ...acc.messages,
                    ...result.value
                },
                errors: [
                    ...acc.errors
                ]
            };
            else if (result.status === 'rejected') return {
                messages: {
                    ...acc.messages
                },
                errors: [
                    ...acc.errors,
                    `Failed to load translations with ${result.reason}`
                ]
            };
            return acc;
        }, {
            messages: {},
            errors: []
        });
    });
};
const $554485f66d5d0ef4$export$b0eee5de066b2bf5 = (Component)=>{
    return (0, $l24yD.withIntlProvider)({
        messagesLoader: $554485f66d5d0ef4$export$d5a462ce7bd04520
    }, Component);
};


const $8872c0aa9b3ed470$export$54a06e3f4a159ad8 = [
    {
        name: 'all',
        when: {
            route: {
                pathname: {
                    matches: '.*'
                }
            }
        }
    },
    {
        name: 'admin/all',
        when: {
            context: {
                product: 'admin'
            }
        }
    },
    {
        name: 'admin/dashboard',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    // Anchored: the dashboard is the AdminHub root and only the root.
                    matches: '^/$'
                }
            }
        }
    },
    {
        name: 'admin/overview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'overview'
                }
            }
        }
    },
    {
        name: 'admin/products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'atlassian-apps'
                }
            }
        }
    },
    {
        name: 'admin/discovered-products',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'shadow-it-apps'
                }
            }
        }
    },
    {
        name: 'admin/domains',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'domains'
                }
            }
        }
    },
    {
        name: 'admin/user-requests',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-requests'
                }
            }
        }
    },
    {
        name: 'admin/user-requests-with-tab-interests',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-requests'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=interests(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'app-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/authentication-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'authentication-policies'
                }
            }
        }
    },
    {
        name: 'admin/users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'users'
                }
            }
        }
    },
    {
        name: 'admin/audit-log',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'audit-log'
                }
            }
        }
    },
    {
        name: 'admin/billing-preview',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing-preview'
                }
            }
        }
    },
    {
        name: 'admin/billing/addapplication',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing/addapplication'
                }
            }
        }
    },
    {
        name: 'admin/billing/addapplication-with-product',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'billing/addapplication'
                },
                search: {
                    matches: '(?:\\?|^|&)product='
                }
            }
        }
    },
    {
        name: 'admin/data-residency',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-residency'
                }
            }
        }
    },
    {
        name: 'admin/encryption',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'encryption'
                }
            }
        }
    },
    {
        name: 'admin/data-security-policies',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'data-security-policies'
                }
            }
        }
    },
    {
        name: 'admin/backups',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'backups'
                }
            }
        }
    },
    {
        name: 'admin/system-health',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'status-hub'
                }
            }
        }
    },
    {
        name: 'admin/performance-monitoring',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    // Anchored: performance-monitoring/* also serves user-setup/:dimension.
                    matches: 'performance-monitoring/?$'
                }
            }
        }
    },
    {
        name: 'admin/rovo',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'rovo'
                }
            }
        }
    },
    {
        name: 'admin/units',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: '(?:^|/)units/[^/]+/?$'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile-tab-apps',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                },
                // Apps is the default tab, so also match when no `tab` param is present.
                search: {
                    matches: '^(?!.*[?&]tab=)|(?:\\?|^|&)tab=apps(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile-tab-users',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=users(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile-tab-groups',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=groups(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile-tab-connections',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=connections(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/unit-profile-tab-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'units/[^/]+/?$'
                },
                search: {
                    matches: '(?:\\?|^|&)tab=settings(?:&|$)'
                }
            }
        }
    },
    {
        name: 'admin/user-access-settings',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-access-settings'
                }
            }
        }
    },
    {
        name: 'admin/user-connected-apps',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'user-connected-apps'
                }
            }
        }
    },
    {
        name: 'admin/changelog',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'changelog'
                }
            }
        }
    },
    {
        name: 'admin/product-insights',
        when: {
            context: {
                product: 'admin'
            },
            route: {
                pathname: {
                    matches: 'product-insights'
                }
            }
        }
    },
    {
        name: 'jira/all',
        when: {
            context: {
                product: 'jira'
            }
        }
    },
    {
        name: 'jira/kanban',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'board'
                }
            }
        }
    },
    {
        name: 'confluence/all',
        when: {
            context: {
                product: 'confluence'
            }
        }
    },
    {
        name: 'confluence/access-links-changeboarding',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^/wiki/admin/(?:center|configuration|access-links(?:/configuration)?)/?$'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-home',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/home'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-welcome',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/welcome'
                }
            }
        }
    },
    {
        name: 'confluence/space-overview',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/[^/]+/overview.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^(?!.*edit).*wiki/spaces/.*/pages.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages-with-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*/pages/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: '^(?!.*edit).*wiki/spaces/.*/blog.*'
                }
            }
        }
    },
    {
        name: 'confluence/blogs-with-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*/blog/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/pages',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/pages/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-content',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/*/.*'
                }
            }
        }
    },
    {
        name: 'confluence/wiki-space-settings',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.+?/settings(/.*)?$'
                }
            }
        }
    },
    {
        name: 'confluence/blogs',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/blog/.*'
                }
            }
        }
    },
    {
        name: 'confluence/all-without-edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/(?!.*/edit-v2/).*'
                }
            }
        }
    },
    {
        name: 'confluence/edit',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/.*edit.*'
                }
            }
        }
    },
    {
        name: 'confluence/whiteboard',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/.*whiteboard.*'
                }
            }
        }
    },
    {
        name: 'confluence/database',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/database/.*'
                }
            }
        }
    },
    {
        name: 'confluence/slides',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/spaces/.*?/slide/.*'
                }
            }
        }
    },
    {
        name: 'pop3/all',
        when: {
            context: {
                product: 'pop3'
            }
        }
    },
    {
        name: 'pop3/send-it',
        when: {
            context: {
                product: 'pop3'
            },
            route: {
                pathname: {
                    matches: 'send-it'
                }
            }
        }
    },
    {
        name: 'trello/all',
        when: {
            context: {
                product: 'trello'
            }
        }
    },
    {
        name: 'jira/queue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'queue'
                }
            }
        }
    },
    {
        name: 'jira/browse',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/software',
        when: {
            context: {
                product: 'jira',
                subproduct: 'software'
            },
            route: {
                pathname: {
                    matches: 'browse'
                }
            }
        }
    },
    {
        name: 'jira/browse/issue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'browse/.*?'
                }
            }
        }
    },
    {
        name: 'jira/issues',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'list'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/changes-list/detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/changes/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/itsm/risk-insights',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/settings/change-management?tab=risk-insights'
                }
            }
        }
    },
    {
        name: 'jira/itsm/incidents-list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*?/section/incidents/custom/.*?'
                }
            }
        }
    },
    {
        name: 'jira/get-started',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/get-started'
                }
            }
        }
    },
    {
        name: 'jira/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'projects/selectedissue',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'projects'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/global-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '/issues'
                },
                search: {
                    matches: '.*filter.*'
                }
            }
        }
    },
    {
        name: 'jira/issues-full-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'issues'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software'
                }
            }
        }
    },
    {
        name: 'jira/rapidboard-board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/secure/RapidBoard\\.jspa$'
                },
                search: {
                    matches: '^(?=.*(?:\\?|^|&)rapidView=)(?!.*(?:\\?|^|&)view=(?:planning(?:\\.nodetail)?|reporting)(?:&|$)).*$'
                }
            }
        }
    },
    {
        name: 'jira/rapidboard-board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/jira/software/c/projects/[^/]+/boards/[^/]+/?$'
                }
            }
        }
    },
    {
        name: 'jira/software-backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/jira/software/projects/[^/]+/boards/[^/]+/backlog/?$'
                }
            }
        }
    },
    {
        name: 'jira/software-boards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/jira/software/projects/[^/]+/boards/[^/]+/?$'
                }
            }
        }
    },
    {
        name: 'jira/polaris',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/polaris'
                }
            }
        }
    },
    {
        name: 'jira/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'backlog'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk'
                }
            }
        }
    },
    {
        name: 'jira/helpcenter',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/helpcenter'
                }
            }
        }
    },
    {
        name: 'jira/ops',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops'
                }
            }
        }
    },
    {
        // JSM Operations Reports (new experience).
        // Route: /jira/ops/reports-new/:spaceId?/:tabId?
        // Matches the bare route and any spaceId/tabId sub-paths.
        name: 'jira/ops/reports-new',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/reports-new'
                }
            }
        }
    },
    {
        // Jira Plans timeline/list view
        name: 'jira/plan/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/timeline'
                }
            }
        }
    },
    {
        // Jira Plans Releases page
        name: 'jira/plan/releases',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/jira/plans/[^/]+/scenarios/[^/]+/releases/?$'
                }
            }
        }
    },
    {
        // Jira Plans calendar view
        name: 'jira/plan/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/calendar'
                }
            }
        }
    },
    {
        // Jira Plans program board
        name: 'jira/plan/program',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*/program'
                }
            }
        }
    },
    {
        // Any pages within Jira Plan
        name: 'jira/plan',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/.*/scenarios/.*'
                }
            }
        }
    },
    {
        name: 'jira/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*(?=.*project)(?=.*setting).*'
                }
            }
        }
    },
    {
        name: 'jira/your-work',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '^/issues/?$'
                }
            }
        }
    },
    {
        name: 'jira/ops/alerts',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-details',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/alerts/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/integration',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/integrations/.*?'
                }
            }
        }
    },
    {
        name: 'jira/ops/team-policies',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/policies'
                }
            }
        }
    },
    {
        name: 'jira/ops/group-detail',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/group-detail'
                }
            }
        }
    },
    {
        name: 'jira/ops/heartbeats',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/heartbeats'
                }
            }
        }
    },
    {
        name: 'jira/ops/who-is-on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/who-is-on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/team/on-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/ops/teams/.*?/on-call'
                }
            }
        }
    },
    {
        name: 'jira/ops/alert-notifications',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/personal/alert-notifications'
                }
            }
        }
    },
    {
        name: 'jira/settings/products/ops/incoming-call',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/settings/products/ops/incoming-call(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/settings/automation',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'settings/automation'
                }
            }
        }
    },
    {
        name: 'jira/for-you',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/for-you'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types(/.*)?'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/settings/request-types/cases',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/settings/request-types/category/cases'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/projects/incidents',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/.*/section/incidents/custom/.*?/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/business/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board'
                }
            }
        }
    },
    {
        name: 'jira/business/board/not/embedded',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/board(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*/boards/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/calendar',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*/boards/.*/calendar(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*/boards/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/timeline',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*/boards/.*/timeline(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-directory',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/[^/]*?$'
                }
            }
        }
    },
    {
        name: 'jira/software/board/not/embedded',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/boards/(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/boards/.*?/backlog'
                }
            }
        }
    },
    {
        name: 'jira/software/backlog',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/boards/.*?/backlog(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/list-detail-view',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: '.*list.*'
                },
                search: {
                    matches: '.*selectedIssue.*'
                }
            }
        }
    },
    {
        name: 'jira/software/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/business/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list'
                }
            }
        }
    },
    {
        name: 'jira/software/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/business/list-project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/list(?!.*\\/embed)'
                }
            }
        }
    },
    {
        // Handles both CMP Software and Business
        name: 'jira/cmp/project-settings/people',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/people'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/access',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/access'
                }
            }
        }
    },
    {
        // Any project route in JSW
        name: 'jira/software/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JSW
        name: 'jira/software/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Any project route in JWM
        name: 'jira/business/project',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?'
                }
            }
        }
    },
    {
        // Any project settings route in JWM
        name: 'jira/business/project-settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/.*?'
                }
            }
        }
    },
    {
        // Project directory
        name: 'jira/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/projects'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/list',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/.+?/list'
                }
            }
        }
    },
    {
        name: 'jira/servicedesk/project-summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        name: 'jira/software/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/[^/]+)?/projects/[^/]+/boards'
                }
            }
        }
    },
    {
        name: 'loom/all',
        when: {
            context: {
                product: 'loom'
            }
        }
    },
    {
        name: 'loom/home',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'home'
                }
            }
        }
    },
    {
        name: 'loom/looms/videos',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'looms/videos'
                }
            }
        }
    },
    {
        name: 'loom/meetings',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'meetings'
                }
            }
        }
    },
    {
        name: 'loom/notifications/all',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'notifications/all'
                }
            }
        }
    },
    {
        name: 'loom/watch-later',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'watch-later'
                }
            }
        }
    },
    {
        name: 'loom/history',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'history'
                }
            }
        }
    },
    {
        name: 'loom/settings/account',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/account'
                }
            }
        }
    },
    {
        name: 'loom/settings/workspace',
        when: {
            context: {
                product: 'loom'
            },
            route: {
                pathname: {
                    matches: 'settings/workspace'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/fields',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/fields'
                }
            }
        }
    },
    {
        name: 'jira/software/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/business/forms/form-builder',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/form/.*?/builder'
                }
            }
        }
    },
    {
        name: 'jira/software/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/business/tmp/project-settings/issue-types',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/core/projects/.*?/settings/issuetypes/.*?'
                }
            }
        }
    },
    {
        name: 'jira/software/cmp/project-issue-navigator',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software/c/projects/.*?/issues(?!.*\\/embed)'
                }
            }
        }
    },
    {
        name: 'jira/cmp/project-settings/project-config/issuelayout',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'plugins/servlet/project-config/.*?/issuelayout'
                }
            }
        }
    },
    {
        name: 'studio/rovo-agents',
        when: {
            context: {
                product: 'atlassianStudio'
            },
            route: {
                pathname: {
                    matches: '/agents(?:/|$)'
                }
            }
        }
    },
    {
        name: 'studio/all',
        when: {
            context: {
                product: 'atlassianStudio'
            }
        }
    },
    {
        name: 'cpq',
        when: {
            context: {
                product: 'cpq'
            }
        }
    },
    {
        name: 'welcome/software',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'welcome/software'
                }
            }
        }
    },
    {
        name: 'bitbucket/all',
        when: {
            context: {
                product: 'bitbucket'
            }
        }
    },
    {
        name: 'bitbucket/home',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'workspace/overview'
                }
            }
        }
    },
    {
        name: 'bitbucket/admin',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'admin'
                }
            }
        }
    },
    {
        name: 'bitbucket/settings',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'workspace/settings'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-requests/new',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/new'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-requests/list',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/?$'
                }
            }
        }
    },
    {
        name: 'bitbucket/pull-request/view',
        when: {
            context: {
                product: 'bitbucket'
            },
            route: {
                pathname: {
                    matches: 'pull-requests/\\d+'
                }
            }
        }
    },
    {
        name: 'jira/rovo-search',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/rovo-search'
                }
            }
        }
    },
    {
        name: 'confluence/rovo-search',
        when: {
            context: {
                product: 'confluence'
            },
            route: {
                pathname: {
                    matches: 'wiki/search'
                }
            }
        }
    },
    {
        name: 'jira/assets/dashboards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    // Dashboard id in product is a UUID (path segment after …/dashboards/)
                    matches: 'jira/assets/dashboards/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}'
                }
            }
        }
    },
    {
        name: 'jira/assets/schemas',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/assets/schemas$'
                }
            }
        }
    },
    {
        // JSM project directory (e.g. .../jira/servicedesk/projects/ACM/summary)
        name: 'jira/servicedesk/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects'
                }
            }
        }
    },
    {
        // Any JSW project route (TMP or CMP)
        name: 'jira/software/projects',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects'
                }
            }
        }
    },
    {
        // JSM project dashboards (e.g. .../jira/servicedesk/projects/ACM/dashboards)
        name: 'jira/servicedesk/dashboards',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/dashboards'
                }
            }
        }
    },
    {
        // JSM virtual agent settings (e.g. .../jira/servicedesk/projects/ACM/settings/virtual-agent)
        name: 'jira/servicedesk/virtual-agent',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/settings/virtual-agent'
                }
            }
        }
    },
    {
        // JSW project settings (e.g. .../jira/software/projects/TT/settings/details)
        name: 'jira/software/settings',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/[^/]+/settings'
                }
            }
        }
    },
    {
        // JSM queue board (e.g. .../jira/servicedesk/projects/ACM/queues/custom/11627/board/19488)
        name: 'jira/servicedesk/board',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/servicedesk/projects/[^/]+/queues/[^/]+/[^/]+/board'
                }
            }
        }
    },
    {
        // JSW project summary (e.g. .../jira/software/projects/MT/summary)
        name: 'jira/software/summary',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/software(/c)?/projects/[^/]+/summary'
                }
            }
        }
    },
    {
        // Jira Plans timeline (e.g. .../jira/plans/123/scenarios/456/timeline)
        name: 'jira/plans',
        when: {
            context: {
                product: 'jira'
            },
            route: {
                pathname: {
                    matches: 'jira/plans/[^/]+/[^/]+/[^/]+/timeline'
                }
            }
        }
    }
];












var $di43e = parcelRequire("di43e");





var $2tp0D = parcelRequire("2tp0D");


var $5KMtM = parcelRequire("5KMtM");


var $enlIM = parcelRequire("enlIM");

const $aca8ff34721ef87d$export$963cdca6c7580c53 = [
    {
        messageTemplateId: 'confluence-ai-audio-player-spotlight-tour',
        // https://switcheroo.atlassian.com/ui/gates/e9b0503b-0486-48e3-a511-123e409058f4/key/confluence_audio_v3_changeboarding
        statsigExperiment: 'confluence_audio_v3_changeboarding',
        statsigParameterName: 'isEnabled',
        statsigTestCohorts: [
            'true'
        ],
        // isEnabled is a boolean, so the string cohort above never matches.
        narrowExposureExperiment: {
            statsigExperiment: 'confluence_audio_v3_changeboarding',
            statsigParameterName: 'isEnabled',
            showCohorts: [
                true
            ],
            dropCohorts: [
                false
            ]
        }
    },
    {
        messageTemplateId: 'rovo-growth-nudge-end-user-highly-connected-apps',
        // https://switcheroo.atlassian.com/ui/gates/f36896ce-14dc-4a48-9888-dd0df3c671e0/key/rovo_nudge_end_user_highly_connected_apps_exp
        statsigExperiment: 'rovo_nudge_end_user_highly_connected_apps_exp',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variant1',
            'variant2'
        ],
        narrowExposureExperiment: {
            statsigExperiment: 'rovo_nudge_end_user_highly_connected_apps_exp',
            statsigParameterName: 'cohort',
            showCohorts: [
                'variant1',
                'variant2'
            ],
            dropCohorts: [
                'control'
            ]
        }
    },
    {
        messageTemplateId: 'cross-flow-product-request-approval',
        // https://switcheroo.atlassian.com/ui/gates/23e1a5f6-5e78-4073-9379-b3bf2583507f/key/pcgrw-522_jpd_invite_toast
        statsigExperiment: 'pcgrw-522_jpd_invite_toast',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'variation'
        ],
        narrowExposureExperiment: {
            statsigExperiment: 'pcgrw-522_jpd_invite_toast',
            statsigParameterName: 'cohort',
            showCohorts: [
                'variation'
            ],
            dropCohorts: [
                'control'
            ]
        }
    },
    {
        messageTemplateId: 'invitations-better-notification-invite-user',
        statsigExperiment: 'twcg-2060-confluence-invite-reminder-flag',
        statsigParameterName: 'cohort',
        statsigTestCohorts: [
            'treatment'
        ],
        narrowExposureExperiment: {
            statsigExperiment: 'twcg-2060-confluence-invite-reminder-flag',
            statsigParameterName: 'cohort',
            showCohorts: [
                'treatment'
            ],
            dropCohorts: [
                'control'
            ]
        }
    }
];





const $07f674d3b901f34e$export$86fac4eb228cc5e9 = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $07f674d3b901f34e$export$60075266d0d5c9c4 = ()=>(0, $cozmU.useContext)($07f674d3b901f34e$export$86fac4eb228cc5e9);


/*
# This file was automatically generated using "yarn generate:all" command.
# Please do not edit it manually.
# These imports are for client side use only
#
# Generate source: local/cli/src/commands/placements/generate-placement-files.ts
*/ 






var $7oSFe = parcelRequire("7oSFe");


































































































































































const $f01d8b4fe148fb27$export$2b14906d8b210372 = {
    'access-links-changeboarding': ()=>(parcelRequire("4Iym9")),
    'admin-hub-app-access-settings-access-message-spotlight': ()=>(parcelRequire("1iTqD")),
    'adminhub-ia-nav-eu-26-onboarding': ()=>(parcelRequire("3hepi")),
    'adminhub-performance-monitoring-first-run': ()=>(parcelRequire("2ZHmQ")),
    'adminhub-platform-usage-m5-spotlight-tour': ()=>(parcelRequire("bV4Ce")),
    'adminhub-rovo-bookmarks-onboarding-spotlight': ()=>(parcelRequire("lxdhr")),
    'adminhub-rovo-chat-button-spotlight': ()=>(parcelRequire("5NUPY")),
    'adminhub-rovo-chat-toggle-spotlight': ()=>(parcelRequire("bB9t0")),
    'adminhub-shd-arb-email-webhook-spotlight-tour': ()=>(parcelRequire("ltw2p")),
    'adminhub-shd-new-notifications-spotlight': ()=>(parcelRequire("8dMQg")),
    'adminhub-system-health-dashboard-app-status-spotlight': ()=>(parcelRequire("9o5o9")),
    'adminhub-system-health-dashboard-app-status-spotlight-v2': ()=>(parcelRequire("3XQ5e")),
    'adminhub-system-health-dashboard-status-hub-spotlight': ()=>(parcelRequire("7PVOs")),
    'adminhub-theme-darkmode': ()=>(parcelRequire("jBG5K")),
    'adminhub-unit-create-ga-spotlight-tour': ()=>(parcelRequire("lMMZS")),
    'adminhub-unit-list-spotlight-tour': ()=>(parcelRequire("gm8IT")),
    'adminhub-unit-list-spotlight-tour-non-vortex': ()=>(parcelRequire("dxgn1")),
    'adminhub-unit-profile-connections-tab-ga-spotlight-tour': ()=>(parcelRequire("lwhBR")),
    'adminhub-unit-profile-groups-tab-spotlight-tour': ()=>(parcelRequire("8Myjm")),
    'adminhub-unit-profile-settings-tab-spotlight-tour': ()=>(parcelRequire("6iDb8")),
    'adminhub-unit-profile-users-tab-ga-spotlight-tour': ()=>(parcelRequire("6BeIK")),
    'adminhub-unit-side-nav-spotlight-tour': ()=>(parcelRequire("hR1bU")),
    'adminhub-units-ga-onboarding-modal': ()=>(parcelRequire("hGNYw")),
    'adminhub-urm-rank-ra-using-ml-spotlight': ()=>(parcelRequire("kS4YW")),
    'agent-profile-reasoning-spotlight': ()=>(parcelRequire("dB5G7")),
    'assets-deeplinking-modal': ()=>(parcelRequire("dBGBb")),
    'assets-osc-onboarding-object-graph-spotlight': ()=>(parcelRequire("ieekc")),
    'cases': ()=>(parcelRequire("f1fGT")),
    'cases-request-types-spotlight': ()=>(parcelRequire("725J8")),
    'cc-changeboarding-block-menu-primary-new': ()=>(parcelRequire("2nOCv")),
    'cc-changeboarding-block-menu-templates': ()=>(parcelRequire("czarH")),
    'cc-changeboarding-block-menu-transform': ()=>(parcelRequire("9F1ix")),
    'cc-changeboarding-synced-blocks': ()=>(parcelRequire("ltiBY")),
    'commerce-subscription-auto-upgrade-ccp': ()=>(parcelRequire("hK21o")),
    'commerce-subscription-auto-upgrade-no-payment-method-ccp': ()=>(parcelRequire("jRxdD")),
    'confluence-3p-connector-nudge': ()=>(parcelRequire("c7WVx")),
    'confluence-agents-spotlights': ()=>(parcelRequire("eGudH")),
    'confluence-ai-audio-player-spotlight-tour': ()=>(parcelRequire("99lIr")),
    'confluence-auto-provisioning-edition-parity-trial-dialog': ()=>(parcelRequire("8NWfU")),
    'confluence-continue-reading-nudge': ()=>(parcelRequire("bem5T")),
    'confluence-create-agent-spotlight': ()=>(parcelRequire("2WwaO")),
    'confluence-edit-with-mcp-discovery': ()=>(parcelRequire("3QAyQ")),
    'confluence-editor-agentic-typeahead-spotlight': ()=>(parcelRequire("hsVRc")),
    'confluence-editor-smart-folder-paste-nudge': ()=>(parcelRequire("3ZUUm")),
    'confluence-editor-smart-links-draggable-changeboard': ()=>(parcelRequire("gTFT7")),
    'confluence-founding-admin-connect-tools-spotlight': ()=>(parcelRequire("3RZNa")),
    'confluence-inline-reactions-mau-nudge': ()=>(parcelRequire("rf1Td")),
    'confluence-inline-reactions-mcu-nudge': ()=>(parcelRequire("lNkfP")),
    'confluence-inline-reactions-nudge': ()=>(parcelRequire("26ETM")),
    'confluence-lovability-survey': ()=>(parcelRequire("fhsoM")),
    'confluence-maui-changeboarding': ()=>(parcelRequire("4wYkW")),
    'confluence-maui-changeboarding-remix-tour': ()=>(parcelRequire("36KuD")),
    'confluence-maui-slides-create-spotlight': ()=>(parcelRequire("izveW")),
    'confluence-maui-slides-edit-spotlight': ()=>(parcelRequire("hywCm")),
    'confluence-maui-slides-modal': ()=>(parcelRequire("kjhgs")),
    'confluence-maui-slides-toolbar-spotlight': ()=>(parcelRequire("f5YQo")),
    'confluence-nudge-for-jira': ()=>(parcelRequire("3nXIr")),
    'confluence-object-sidebar-remix-changeboarding': ()=>(parcelRequire("YKJfe")),
    'confluence-onboarding-flag-to-share': ()=>(parcelRequire("aUEov")),
    'confluence-onboarding-flag-to-share-database': ()=>(parcelRequire("gb8Zj")),
    'confluence-onboarding-flag-to-share-whiteboard': ()=>(parcelRequire("6DFNs")),
    'cpq-user-feedback': ()=>(parcelRequire("70fHu")),
    'cross-flow-product-request': ()=>(parcelRequire("9COO3")),
    'cross-flow-product-request-approval': ()=>(parcelRequire("9AJVN")),
    'edition-benefits-modal': ()=>(parcelRequire("i1rL6")),
    'encryption-policy-page-spotlight': ()=>(parcelRequire("4NlrP")),
    'end-of-trial-extension': ()=>(parcelRequire("94ngV")),
    'ep-migration-external-messages': ()=>(parcelRequire("53lm9")),
    'ep-migration-inapp-1736': ()=>(parcelRequire("8zifP")),
    'ep-migration-inapp-1737': ()=>(parcelRequire("5DyJr")),
    'ep-migration-inapp-2055': ()=>(parcelRequire("cwRNp")),
    'ep-migration-inapp-2270': ()=>(parcelRequire("gi1yN")),
    'ep-migration-inapp-2271': ()=>(parcelRequire("8NEv2")),
    'ep-migration-inapp-3273': ()=>(parcelRequire("33BpE")),
    'ep-migration-inapp-3280': ()=>(parcelRequire("6mMPa")),
    'ep-migration-inapp-3282': ()=>(parcelRequire("cUj4S")),
    'ep-migration-inapp-715': ()=>(parcelRequire("ban89")),
    'ep-migration-jira-ops-team-heartbeats': ()=>(parcelRequire("2ACrS")),
    'example-generated-spotlight-template': ()=>(parcelRequire("gQsfe")),
    'example-screen-space-flags-modal': ()=>(parcelRequire("fPdyF")),
    'invitations-better-notification-invite-user': ()=>(parcelRequire("1x1r6")),
    'jira-agent-sessions-awareness': ()=>(parcelRequire("j0Fng")),
    'jira-assets-schemas-display-name': ()=>(parcelRequire("lCcbG")),
    'jira-auto-upgrade-completion-modal': ()=>(parcelRequire("kEDDE")),
    'jira-business-saved-views-admin-changeboarding-spotlight': ()=>(parcelRequire("kD1fH")),
    'jira-business-saved-views-user-changeboarding-spotlight': ()=>(parcelRequire("76P5l")),
    'jira-filter-refinement-standalone-release-changeboarding': ()=>(parcelRequire("7SG5v")),
    'jira-forms-public-forms-changeboarding': ()=>(parcelRequire("e5Coy")),
    'jira-forms-public-forms-changeboarding-flag': ()=>(parcelRequire("9he98")),
    'jira-fps-to-gnin-cta-changeboarding': ()=>(parcelRequire("8onkz")),
    'jira-glance-panel-navigation-arrows': ()=>(parcelRequire("lTNBf")),
    'jira-gnin-to-fps-cta-changeboarding': ()=>(parcelRequire("4EMsu")),
    'jira-in-context-config-sidebar-changeboarding': ()=>(parcelRequire("gnQbw")),
    'jira-issue-view-loom-image-editing-spotlight': ()=>(parcelRequire("akSrV")),
    'jira-issueview-description-title-final': ()=>(parcelRequire("16nTW")),
    'jira-lovability-fast-snappy-survey': ()=>(parcelRequire("7kiHM")),
    'jira-messaging-research-recruitment': ()=>(parcelRequire("hrhhh")),
    'jira-nl2jql-ai-filter-changeboarding': ()=>(parcelRequire("5CILm")),
    'jira-onboarding-hub-welcome-modal': ()=>(parcelRequire("gBblt")),
    'jira-ops-group-customisation': ()=>(parcelRequire("kseEQ")),
    'jira-ops-reports-changeboarding': ()=>(parcelRequire("2Rcwf")),
    'jira-ops-unified-view-revamp': ()=>(parcelRequire("eSb7b")),
    'jira-pre-dunning-confirm-plan-modal': ()=>(parcelRequire("fZqoY")),
    'jira-project-term-refresh-changeboarding-flag': ()=>(parcelRequire("1jc83")),
    'jira-quick-find-intent-detection-changeboarding': ()=>(parcelRequire("6vo9S")),
    'jira-rovo-spotlight': ()=>(parcelRequire("j33pp")),
    'jira-screen-modal': ()=>(parcelRequire("i3d5p")),
    'jira-side-nav-mature-example-project-space-setup': ()=>(parcelRequire("1O2Fq")),
    'jira-software-backlog-bulk-agents-changeboarding': ()=>(parcelRequire("fkjQo")),
    'jira-software-list-bulk-agent-changeboarding': ()=>(parcelRequire("exz4d")),
    'jira-software-timeline-hide-top-level-changeboarding': ()=>(parcelRequire("4RBQ1")),
    'jira-software-timeline-hierarchy-changeboarding': ()=>(parcelRequire("66n5l")),
    'jira-software-timeline-inline-hierarchy-changeboarding': ()=>(parcelRequire("aKNJU")),
    'jira-space-settings-playbooks-navigation-spotlight': ()=>(parcelRequire("cZ7XF")),
    'jira-sprints-auto-managed-feature-discovery': ()=>(parcelRequire("kBb5k")),
    'jira-timeline-10k-issues-message': ()=>(parcelRequire("5nro8")),
    'jira-work-item-view-native-projects-field': ()=>(parcelRequire("2FIQD")),
    'jsm-edition-awareness-button-popup': ()=>(parcelRequire("fkUqr")),
    'jsm-edition-awareness-premium-upsell-modal': ()=>(parcelRequire("dW3Af")),
    'jsm-project-summary-onboarding': ()=>(parcelRequire("8ii4s")),
    'loom-switcher-onboarding-spotlight': ()=>(parcelRequire("6IexO")),
    'marketing-screen-space-flag-contentful-usecase': ()=>(parcelRequire("25kjh")),
    'message-template-template': ()=>(parcelRequire("hM9MC")),
    'navx-smartlink-full-picture-auth-nudge': ()=>(parcelRequire("hJzUi")),
    'post-office-gold-1': ()=>(parcelRequire("fKEim")),
    'project-pages-revamp-onboarding-spotlight': ()=>(parcelRequire("dEKuw")),
    'ptr-changeboarding-space-navigation-spotlight': ()=>(parcelRequire("ktbmc")),
    'rovo-3p-celebrate-nudge': ()=>(parcelRequire("4ppH6")),
    'rovo-3rd-party-integration-admin-nudge': ()=>(parcelRequire("3JYAC")),
    'rovo-agents-scenario-onboarding': ()=>(parcelRequire("e2h8M")),
    'rovo-button-onboarding-spotlight': ()=>(parcelRequire("jEK0N")),
    'rovo-chat-memory-settings-onboarding-spotlight': ()=>(parcelRequire("lpbUB")),
    'rovo-chat-welcome-spotlight': ()=>(parcelRequire("8vVIH")),
    'rovo-extension-gdocs-definitions-install-cta-flag': ()=>(parcelRequire("75hDZ")),
    'rovo-growth-3p-smartlink-admin-paste-nudge': ()=>(parcelRequire("5gsyW")),
    'rovo-growth-3p-smartlink-paste-nudge': ()=>(parcelRequire("3mkfb")),
    'rovo-growth-nudge-end-user-highly-connected-apps': ()=>(parcelRequire("9g76l")),
    'shared-user-preferences-onboarding': ()=>(parcelRequire("kWOwA")),
    'sharepoint-smartlink-app-migration-test': ()=>(parcelRequire("boBOk")),
    'solcom-create-space-spotlight': ()=>(parcelRequire("1piuw")),
    'starburst-screen-space-flags-twc-welcome-modal': ()=>(parcelRequire("axfdb")),
    'statuspage-navigation-spotlight': ()=>(parcelRequire("8lQWa")),
    'statuspage-navigation-spotlight-v2': ()=>(parcelRequire("kZFpG")),
    'team-wolverine-jira-migration-success': ()=>(parcelRequire("gZ12D")),
    'test-message-config-sets': ()=>(parcelRequire("8tBhH")),
    'test-message-ep-migration': ()=>(parcelRequire("byLio")),
    'test-message-inapp': ()=>(parcelRequire("9J73n")),
    'test-message-inapp-ep-modal': ()=>(parcelRequire("i337n")),
    'test-message-inapp-implicit-pendo': ()=>(parcelRequire("f2t7r")),
    'test-message-load-test-pull-screen-space-flags': ()=>(parcelRequire("hR9tV")),
    'test-message-narrow-exposure-experiment': ()=>(parcelRequire("fwR83")),
    'test-message-narrow-exposure-experiment-v2': ()=>(parcelRequire("d7RkC")),
    'test-message-tap-ingestion-trigger-subscription': ()=>(parcelRequire("kIno2")),
    'test-message-triggered': ()=>(parcelRequire("V1WU6")),
    'test-screen-space-flags-message': ()=>(parcelRequire("9jEC9")),
    'test-simple-ipm-spotlight-page-load': ()=>(parcelRequire("dcKcJ")),
    'twc-conf-sample-page-tour': ()=>(parcelRequire("4V82D")),
    'twc-enablement-modal': ()=>(parcelRequire("6n030")),
    'twc-onboarding-provisioned': ()=>(parcelRequire("5GLk6")),
    'twc-onboarding-provisioned-v2': ()=>(parcelRequire("8GpdS")),
    'twc-xflow-modal-v2': ()=>(parcelRequire("e3Tx6"))
};
const $f01d8b4fe148fb27$export$e30378e28ad3e6ab = {
    'access-links-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-KaPm2N", $f01d8b4fe148fb27$export$2b14906d8b210372['access-links-changeboarding'])),
    'admin-hub-app-access-settings-access-message-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-s_Wk4e", $f01d8b4fe148fb27$export$2b14906d8b210372['admin-hub-app-access-settings-access-message-spotlight'])),
    'adminhub-ia-nav-eu-26-onboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-sJML-k", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-ia-nav-eu-26-onboarding'])),
    'adminhub-performance-monitoring-first-run': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-zBh1SS", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-performance-monitoring-first-run'])),
    'adminhub-platform-usage-m5-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-cd12Aq", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-platform-usage-m5-spotlight-tour'])),
    'adminhub-rovo-bookmarks-onboarding-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-BGOMVM", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-rovo-bookmarks-onboarding-spotlight'])),
    'adminhub-rovo-chat-button-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-Fwmchn", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-rovo-chat-button-spotlight'])),
    'adminhub-rovo-chat-toggle-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-INwEgF", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-rovo-chat-toggle-spotlight'])),
    'adminhub-shd-arb-email-webhook-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-NdPKji", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-shd-arb-email-webhook-spotlight-tour'])),
    'adminhub-shd-new-notifications-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-7axIMi", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-shd-new-notifications-spotlight'])),
    'adminhub-system-health-dashboard-app-status-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-QLNsA9", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-system-health-dashboard-app-status-spotlight'])),
    'adminhub-system-health-dashboard-app-status-spotlight-v2': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-8huyON", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-system-health-dashboard-app-status-spotlight-v2'])),
    'adminhub-system-health-dashboard-status-hub-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-VZKqZ9", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-system-health-dashboard-status-hub-spotlight'])),
    'adminhub-theme-darkmode': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-fMsuOJ", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-theme-darkmode'])),
    'adminhub-unit-create-ga-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-WmLtBW", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-unit-create-ga-spotlight-tour'])),
    'adminhub-unit-list-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-OEsdk0", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-unit-list-spotlight-tour'])),
    'adminhub-unit-list-spotlight-tour-non-vortex': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-A89JQ-", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-unit-list-spotlight-tour-non-vortex'])),
    'adminhub-unit-profile-connections-tab-ga-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-grvANu", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-unit-profile-connections-tab-ga-spotlight-tour'])),
    'adminhub-unit-profile-groups-tab-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-tO_vJj", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-unit-profile-groups-tab-spotlight-tour'])),
    'adminhub-unit-profile-settings-tab-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-XewACI", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-unit-profile-settings-tab-spotlight-tour'])),
    'adminhub-unit-profile-users-tab-ga-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-UFFv0J", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-unit-profile-users-tab-ga-spotlight-tour'])),
    'adminhub-unit-side-nav-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-UM67H5", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-unit-side-nav-spotlight-tour'])),
    'adminhub-units-ga-onboarding-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-tZsI0r", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-units-ga-onboarding-modal'])),
    'adminhub-urm-rank-ra-using-ml-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-JhZVdC", $f01d8b4fe148fb27$export$2b14906d8b210372['adminhub-urm-rank-ra-using-ml-spotlight'])),
    'agent-profile-reasoning-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-mnzy3f", $f01d8b4fe148fb27$export$2b14906d8b210372['agent-profile-reasoning-spotlight'])),
    'assets-deeplinking-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-SfWbBc", $f01d8b4fe148fb27$export$2b14906d8b210372['assets-deeplinking-modal'])),
    'assets-osc-onboarding-object-graph-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-Q6Xk1D", $f01d8b4fe148fb27$export$2b14906d8b210372['assets-osc-onboarding-object-graph-spotlight'])),
    'cases': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-TeSvyc", $f01d8b4fe148fb27$export$2b14906d8b210372['cases'])),
    'cases-request-types-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-DPufRG", $f01d8b4fe148fb27$export$2b14906d8b210372['cases-request-types-spotlight'])),
    'cc-changeboarding-block-menu-primary-new': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-F2Qv7R", $f01d8b4fe148fb27$export$2b14906d8b210372['cc-changeboarding-block-menu-primary-new'])),
    'cc-changeboarding-block-menu-templates': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-9QtiON", $f01d8b4fe148fb27$export$2b14906d8b210372['cc-changeboarding-block-menu-templates'])),
    'cc-changeboarding-block-menu-transform': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-1XLd5P", $f01d8b4fe148fb27$export$2b14906d8b210372['cc-changeboarding-block-menu-transform'])),
    'cc-changeboarding-synced-blocks': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-zqdz10", $f01d8b4fe148fb27$export$2b14906d8b210372['cc-changeboarding-synced-blocks'])),
    'commerce-subscription-auto-upgrade-ccp': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-8aBpfw", $f01d8b4fe148fb27$export$2b14906d8b210372['commerce-subscription-auto-upgrade-ccp'])),
    'commerce-subscription-auto-upgrade-no-payment-method-ccp': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-4KZb7h", $f01d8b4fe148fb27$export$2b14906d8b210372['commerce-subscription-auto-upgrade-no-payment-method-ccp'])),
    'confluence-3p-connector-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-iBEmUI", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-3p-connector-nudge'])),
    'confluence-agents-spotlights': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-8zLOKc", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-agents-spotlights'])),
    'confluence-ai-audio-player-spotlight-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-FKGSgt", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-ai-audio-player-spotlight-tour'])),
    'confluence-auto-provisioning-edition-parity-trial-dialog': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-bOxrwx", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-auto-provisioning-edition-parity-trial-dialog'])),
    'confluence-continue-reading-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-vf5p-P", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-continue-reading-nudge'])),
    'confluence-create-agent-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-RkHCeX", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-create-agent-spotlight'])),
    'confluence-edit-with-mcp-discovery': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-WFluhj", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-edit-with-mcp-discovery'])),
    'confluence-editor-agentic-typeahead-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-BUp63_", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-editor-agentic-typeahead-spotlight'])),
    'confluence-editor-smart-folder-paste-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-CRcMLZ", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-editor-smart-folder-paste-nudge'])),
    'confluence-editor-smart-links-draggable-changeboard': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-o3WOPz", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-editor-smart-links-draggable-changeboard'])),
    'confluence-founding-admin-connect-tools-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-WmL2-q", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-founding-admin-connect-tools-spotlight'])),
    'confluence-inline-reactions-mau-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-L_Zb8o", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-inline-reactions-mau-nudge'])),
    'confluence-inline-reactions-mcu-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-1g1OVd", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-inline-reactions-mcu-nudge'])),
    'confluence-inline-reactions-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-hDojHp", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-inline-reactions-nudge'])),
    'confluence-lovability-survey': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-NDlUQg", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-lovability-survey'])),
    'confluence-maui-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-qc0MDf", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-maui-changeboarding'])),
    'confluence-maui-changeboarding-remix-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl--BptvG", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-maui-changeboarding-remix-tour'])),
    'confluence-maui-slides-create-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-J1R-_B", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-maui-slides-create-spotlight'])),
    'confluence-maui-slides-edit-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-aZEWzU", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-maui-slides-edit-spotlight'])),
    'confluence-maui-slides-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-pPu8mN", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-maui-slides-modal'])),
    'confluence-maui-slides-toolbar-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-2ZRQhf", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-maui-slides-toolbar-spotlight'])),
    'confluence-nudge-for-jira': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-DGhM-a", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-nudge-for-jira'])),
    'confluence-object-sidebar-remix-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-OvhzBL", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-object-sidebar-remix-changeboarding'])),
    'confluence-onboarding-flag-to-share': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-H0znMY", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-onboarding-flag-to-share'])),
    'confluence-onboarding-flag-to-share-database': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ecaQ4y", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-onboarding-flag-to-share-database'])),
    'confluence-onboarding-flag-to-share-whiteboard': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-h6IpKw", $f01d8b4fe148fb27$export$2b14906d8b210372['confluence-onboarding-flag-to-share-whiteboard'])),
    'cpq-user-feedback': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-4FD5tZ", $f01d8b4fe148fb27$export$2b14906d8b210372['cpq-user-feedback'])),
    'cross-flow-product-request': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-m8qZLh", $f01d8b4fe148fb27$export$2b14906d8b210372['cross-flow-product-request'])),
    'cross-flow-product-request-approval': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-nhsQes", $f01d8b4fe148fb27$export$2b14906d8b210372['cross-flow-product-request-approval'])),
    'edition-benefits-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-jdtDxZ", $f01d8b4fe148fb27$export$2b14906d8b210372['edition-benefits-modal'])),
    'encryption-policy-page-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-g5ifXd", $f01d8b4fe148fb27$export$2b14906d8b210372['encryption-policy-page-spotlight'])),
    'end-of-trial-extension': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-L-7tOp", $f01d8b4fe148fb27$export$2b14906d8b210372['end-of-trial-extension'])),
    'ep-migration-external-messages': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-2fVMRR", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-external-messages'])),
    'ep-migration-inapp-1736': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-eioj0m", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-1736'])),
    'ep-migration-inapp-1737': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-jbJuvX", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-1737'])),
    'ep-migration-inapp-2055': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-I-CzgC", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-2055'])),
    'ep-migration-inapp-2270': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-Zvefuu", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-2270'])),
    'ep-migration-inapp-2271': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-p7HeXl", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-2271'])),
    'ep-migration-inapp-3273': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-2OMgAH", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-3273'])),
    'ep-migration-inapp-3280': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-fTyqZV", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-3280'])),
    'ep-migration-inapp-3282': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-tmura9", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-3282'])),
    'ep-migration-inapp-715': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-iT1RL8", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-inapp-715'])),
    'ep-migration-jira-ops-team-heartbeats': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-kOPHUG", $f01d8b4fe148fb27$export$2b14906d8b210372['ep-migration-jira-ops-team-heartbeats'])),
    'example-generated-spotlight-template': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-mMg3oi", $f01d8b4fe148fb27$export$2b14906d8b210372['example-generated-spotlight-template'])),
    'example-screen-space-flags-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-qqTh9s", $f01d8b4fe148fb27$export$2b14906d8b210372['example-screen-space-flags-modal'])),
    'invitations-better-notification-invite-user': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-PpTR4D", $f01d8b4fe148fb27$export$2b14906d8b210372['invitations-better-notification-invite-user'])),
    'jira-agent-sessions-awareness': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-C6fz3e", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-agent-sessions-awareness'])),
    'jira-assets-schemas-display-name': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-90gMD0", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-assets-schemas-display-name'])),
    'jira-auto-upgrade-completion-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-zBrmO7", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-auto-upgrade-completion-modal'])),
    'jira-business-saved-views-admin-changeboarding-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-bkOQpY", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-business-saved-views-admin-changeboarding-spotlight'])),
    'jira-business-saved-views-user-changeboarding-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-07h9ZA", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-business-saved-views-user-changeboarding-spotlight'])),
    'jira-filter-refinement-standalone-release-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-25llnW", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-filter-refinement-standalone-release-changeboarding'])),
    'jira-forms-public-forms-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-oJ5Crt", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-forms-public-forms-changeboarding'])),
    'jira-forms-public-forms-changeboarding-flag': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-BMUgE0", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-forms-public-forms-changeboarding-flag'])),
    'jira-fps-to-gnin-cta-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-PQ3-0W", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-fps-to-gnin-cta-changeboarding'])),
    'jira-glance-panel-navigation-arrows': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-6O8DcG", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-glance-panel-navigation-arrows'])),
    'jira-gnin-to-fps-cta-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-tLldst", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-gnin-to-fps-cta-changeboarding'])),
    'jira-in-context-config-sidebar-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-evnlCF", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-in-context-config-sidebar-changeboarding'])),
    'jira-issue-view-loom-image-editing-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-yHbOI7", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-issue-view-loom-image-editing-spotlight'])),
    'jira-issueview-description-title-final': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-L6-amg", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-issueview-description-title-final'])),
    'jira-lovability-fast-snappy-survey': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-n2vPvW", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-lovability-fast-snappy-survey'])),
    'jira-messaging-research-recruitment': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-4uEa2X", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-messaging-research-recruitment'])),
    'jira-nl2jql-ai-filter-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-rikYO1", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-nl2jql-ai-filter-changeboarding'])),
    'jira-onboarding-hub-welcome-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-p7227P", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-onboarding-hub-welcome-modal'])),
    'jira-ops-group-customisation': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ek7t5r", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-ops-group-customisation'])),
    'jira-ops-reports-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-OVzpN6", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-ops-reports-changeboarding'])),
    'jira-ops-unified-view-revamp': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-7qL17z", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-ops-unified-view-revamp'])),
    'jira-pre-dunning-confirm-plan-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-AJhpU2", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-pre-dunning-confirm-plan-modal'])),
    'jira-project-term-refresh-changeboarding-flag': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-oCqSel", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-project-term-refresh-changeboarding-flag'])),
    'jira-quick-find-intent-detection-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ISECW9", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-quick-find-intent-detection-changeboarding'])),
    'jira-rovo-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-VYvDLu", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-rovo-spotlight'])),
    'jira-screen-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-LBSJh1", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-screen-modal'])),
    'jira-side-nav-mature-example-project-space-setup': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-Jp-NSt", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-side-nav-mature-example-project-space-setup'])),
    'jira-software-backlog-bulk-agents-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-fSkVb0", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-software-backlog-bulk-agents-changeboarding'])),
    'jira-software-list-bulk-agent-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-9m6OOG", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-software-list-bulk-agent-changeboarding'])),
    'jira-software-timeline-hide-top-level-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-1TMT-B", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-software-timeline-hide-top-level-changeboarding'])),
    'jira-software-timeline-hierarchy-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-asAx6T", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-software-timeline-hierarchy-changeboarding'])),
    'jira-software-timeline-inline-hierarchy-changeboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ZolkRo", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-software-timeline-inline-hierarchy-changeboarding'])),
    'jira-space-settings-playbooks-navigation-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-IMOCuD", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-space-settings-playbooks-navigation-spotlight'])),
    'jira-sprints-auto-managed-feature-discovery': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-vnVzms", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-sprints-auto-managed-feature-discovery'])),
    'jira-timeline-10k-issues-message': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-dNQ4Id", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-timeline-10k-issues-message'])),
    'jira-work-item-view-native-projects-field': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-eXQHuH", $f01d8b4fe148fb27$export$2b14906d8b210372['jira-work-item-view-native-projects-field'])),
    'jsm-edition-awareness-button-popup': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-mkmcFy", $f01d8b4fe148fb27$export$2b14906d8b210372['jsm-edition-awareness-button-popup'])),
    'jsm-edition-awareness-premium-upsell-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-3QDvEm", $f01d8b4fe148fb27$export$2b14906d8b210372['jsm-edition-awareness-premium-upsell-modal'])),
    'jsm-project-summary-onboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-XtGB5X", $f01d8b4fe148fb27$export$2b14906d8b210372['jsm-project-summary-onboarding'])),
    'loom-switcher-onboarding-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-sPuJQb", $f01d8b4fe148fb27$export$2b14906d8b210372['loom-switcher-onboarding-spotlight'])),
    'marketing-screen-space-flag-contentful-usecase': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-AAi03U", $f01d8b4fe148fb27$export$2b14906d8b210372['marketing-screen-space-flag-contentful-usecase'])),
    'message-template-template': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ixv_HN", $f01d8b4fe148fb27$export$2b14906d8b210372['message-template-template'])),
    'navx-smartlink-full-picture-auth-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ADGBuv", $f01d8b4fe148fb27$export$2b14906d8b210372['navx-smartlink-full-picture-auth-nudge'])),
    'post-office-gold-1': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-s5xnp1", $f01d8b4fe148fb27$export$2b14906d8b210372['post-office-gold-1'])),
    'project-pages-revamp-onboarding-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-gyXCdj", $f01d8b4fe148fb27$export$2b14906d8b210372['project-pages-revamp-onboarding-spotlight'])),
    'ptr-changeboarding-space-navigation-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-a4EFvE", $f01d8b4fe148fb27$export$2b14906d8b210372['ptr-changeboarding-space-navigation-spotlight'])),
    'rovo-3p-celebrate-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-P-8XI-", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-3p-celebrate-nudge'])),
    'rovo-3rd-party-integration-admin-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-X2Nm0x", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-3rd-party-integration-admin-nudge'])),
    'rovo-agents-scenario-onboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-xNSyVW", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-agents-scenario-onboarding'])),
    'rovo-button-onboarding-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-jEmSBk", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-button-onboarding-spotlight'])),
    'rovo-chat-memory-settings-onboarding-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-pMgAep", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-chat-memory-settings-onboarding-spotlight'])),
    'rovo-chat-welcome-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-0iUXhn", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-chat-welcome-spotlight'])),
    'rovo-extension-gdocs-definitions-install-cta-flag': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-fiM5NG", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-extension-gdocs-definitions-install-cta-flag'])),
    'rovo-growth-3p-smartlink-admin-paste-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-MfU9K2", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-growth-3p-smartlink-admin-paste-nudge'])),
    'rovo-growth-3p-smartlink-paste-nudge': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-T1Utq2", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-growth-3p-smartlink-paste-nudge'])),
    'rovo-growth-nudge-end-user-highly-connected-apps': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-cGFOiC", $f01d8b4fe148fb27$export$2b14906d8b210372['rovo-growth-nudge-end-user-highly-connected-apps'])),
    'shared-user-preferences-onboarding': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-7hYkwg", $f01d8b4fe148fb27$export$2b14906d8b210372['shared-user-preferences-onboarding'])),
    'sharepoint-smartlink-app-migration-test': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-DxBqPb", $f01d8b4fe148fb27$export$2b14906d8b210372['sharepoint-smartlink-app-migration-test'])),
    'solcom-create-space-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-TaaVJ3", $f01d8b4fe148fb27$export$2b14906d8b210372['solcom-create-space-spotlight'])),
    'starburst-screen-space-flags-twc-welcome-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-3QGMyb", $f01d8b4fe148fb27$export$2b14906d8b210372['starburst-screen-space-flags-twc-welcome-modal'])),
    'statuspage-navigation-spotlight': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-Le6A8o", $f01d8b4fe148fb27$export$2b14906d8b210372['statuspage-navigation-spotlight'])),
    'statuspage-navigation-spotlight-v2': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-qM8FBp", $f01d8b4fe148fb27$export$2b14906d8b210372['statuspage-navigation-spotlight-v2'])),
    'team-wolverine-jira-migration-success': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-VZsJvF", $f01d8b4fe148fb27$export$2b14906d8b210372['team-wolverine-jira-migration-success'])),
    'test-message-config-sets': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ab7PlY", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-config-sets'])),
    'test-message-ep-migration': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-j22tCQ", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-ep-migration'])),
    'test-message-inapp': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-Dkrt7F", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-inapp'])),
    'test-message-inapp-ep-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-kpQRDt", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-inapp-ep-modal'])),
    'test-message-inapp-implicit-pendo': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-sGe9q_", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-inapp-implicit-pendo'])),
    'test-message-load-test-pull-screen-space-flags': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-H-f52T", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-load-test-pull-screen-space-flags'])),
    'test-message-narrow-exposure-experiment': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ARZYQx", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-narrow-exposure-experiment'])),
    'test-message-narrow-exposure-experiment-v2': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-ITURsf", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-narrow-exposure-experiment-v2'])),
    'test-message-tap-ingestion-trigger-subscription': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-LsDyLq", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-tap-ingestion-trigger-subscription'])),
    'test-message-triggered': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-4qZ1-k", $f01d8b4fe148fb27$export$2b14906d8b210372['test-message-triggered'])),
    'test-screen-space-flags-message': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-OGuiJE", $f01d8b4fe148fb27$export$2b14906d8b210372['test-screen-space-flags-message'])),
    'test-simple-ipm-spotlight-page-load': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-_KiLK_", $f01d8b4fe148fb27$export$2b14906d8b210372['test-simple-ipm-spotlight-page-load'])),
    'twc-conf-sample-page-tour': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-PczmEc", $f01d8b4fe148fb27$export$2b14906d8b210372['twc-conf-sample-page-tour'])),
    'twc-enablement-modal': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-1zu4SA", $f01d8b4fe148fb27$export$2b14906d8b210372['twc-enablement-modal'])),
    'twc-onboarding-provisioned': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-8do8wE", $f01d8b4fe148fb27$export$2b14906d8b210372['twc-onboarding-provisioned'])),
    'twc-onboarding-provisioned-v2': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-C2VmCs", $f01d8b4fe148fb27$export$2b14906d8b210372['twc-onboarding-provisioned-v2'])),
    'twc-xflow-modal-v2': (0, $cozmU.lazy)((0, $7oSFe.trackReactLazy)("rl-2Mv_-W", $f01d8b4fe148fb27$export$2b14906d8b210372['twc-xflow-modal-v2']))
};
const $f01d8b4fe148fb27$var$messageRenderer = (0, $2tp0D.asMessageRenderer)($f01d8b4fe148fb27$export$e30378e28ad3e6ab, 'screen-space-flags');
const $f01d8b4fe148fb27$export$bce4e5106d86e473 = $f01d8b4fe148fb27$var$messageRenderer.initializeMessageRenderer;
const $f01d8b4fe148fb27$export$2df1250b8f917a59 = $f01d8b4fe148fb27$var$messageRenderer.MessageRenderer;






const $95c6653f43316618$export$e343914da553b968 = ()=>{
    const route = (0, $5h1mk.usePostOfficeRoute)();
    let result = {};
    if (route?.searchParams) result = Object.fromEntries(route.searchParams);
    if (typeof window !== 'undefined' && typeof window.location?.pathname === 'string') result = {
        ...result,
        pathname: window.location.pathname
    };
    return result;
};


// https://switcheroo.atlassian.com/ui/gates/5033fa11-c5cb-4d9a-8b6f-7feaa912386b/key/post-office_enable_narrow-exposure-classic
const $83579a0ad44a68d9$var$NARROW_EXPOSURE_CLASSIC_GATE = 'post-office_enable_narrow-exposure-classic';
// https://switcheroo.atlassian.com/ui/gates/8fd2bfc0-9a54-4a07-b739-0b84c2e6ad44/key/post-office_enable_narrow-exposure-ssf-migration
const $83579a0ad44a68d9$var$NARROW_EXPOSURE_SSF_MIGRATION_GATE = 'post-office_enable_narrow-exposure-ssf-migration';
/** Gives EXPERIMENTAL_MESSAGES entries their narrow exposure config, unless the server sent one. */ const $83579a0ad44a68d9$var$withNarrowExposureConfig = (message)=>{
    if (message.inAppNarrowExposureExperiment) return message;
    const experimentalMessage = (0, $aca8ff34721ef87d$export$963cdca6c7580c53).find((p)=>p.messageTemplateId === message.messageTemplateId);
    return experimentalMessage ? {
        ...message,
        inAppNarrowExposureExperiment: experimentalMessage.narrowExposureExperiment
    } : message;
};
/**
 * Picks the first page-load message to render, checking EXPERIMENTAL_MESSAGES cohorts in rank order.
 */ const $83579a0ad44a68d9$var$selectMessages = (messages, skipConfigCarryingMessages)=>{
    const selectedMessages = [];
    // New experiments in the screen-space-flags placement must be added to the EXPERIMENTAL_MESSAGES list
    for (const message of messages){
        // The classic renderer hides config-carrying messages when its gate is off.
        if (skipConfigCarryingMessages && message.inAppNarrowExposureExperiment) continue;
        const experimentalMessage = (0, $aca8ff34721ef87d$export$963cdca6c7580c53).find((p)=>p.messageTemplateId === message.messageTemplateId);
        if (experimentalMessage) {
            // oxlint-disable-next-line post-office/no-manual-in-app-experiments -- Legacy experiment handling is retained without migration.
            const cohort = (0, $cXtTj.default).getExperimentValue(experimentalMessage.statsigExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                fireExperimentExposure: true
            });
            if (experimentalMessage.statsigAAExperiment) // oxlint-disable-next-line post-office/no-manual-in-app-experiments -- Legacy experiment handling is retained without migration.
            (0, $cXtTj.default).getExperimentValue(experimentalMessage.statsigAAExperiment, experimentalMessage.statsigParameterName, 'not-enrolled', {
                fireExperimentExposure: true
            });
            if (experimentalMessage.statsigTestCohorts.includes(cohort)) {
                selectedMessages.push(message);
                break;
            }
        } else {
            selectedMessages.push(message);
            break;
        }
    }
    return selectedMessages;
};
const $83579a0ad44a68d9$export$f6564e60882bdf90 = ({ initialData: initialData, preloadedInitialData: preloadedInitialData, setPreloadedInitialData: setPreloadedInitialData, jiraFlagsService: jiraFlagsService, reportExpectedError: reportExpectedError, reportUnexpectedError: reportUnexpectedError })=>{
    const injectedMessageTemplates = (0, $07f674d3b901f34e$export$60075266d0d5c9c4)();
    // https://switcheroo.atlassian.com/ui/gates/3088e603-a723-449e-a763-b42e9db2a626/key/post-office_enable_ssf_injected_messages
    const isInjectedMessagesEnabled = (0, $cXtTj.default).checkGate('post-office_enable_ssf_injected_messages');
    const injectedMessageRenderer = (0, $cozmU.useMemo)(()=>injectedMessageTemplates ? (0, $2tp0D.asMessageRenderer)(injectedMessageTemplates, 'screen-space-flags').MessageRenderer : (0, $f01d8b4fe148fb27$export$2df1250b8f917a59), [
        injectedMessageTemplates
    ]);
    const MessageRenderer = isInjectedMessagesEnabled ? injectedMessageRenderer : (0, $f01d8b4fe148fb27$export$2df1250b8f917a59);
    const isEPExternalMessageSSREnabled = (0, $cXtTj.default).checkGate('post-office_enabled_ep_external_message_ssr');
    const isNarrowExposureClassicEnabled = (0, $cXtTj.default).checkGate($83579a0ad44a68d9$var$NARROW_EXPOSURE_CLASSIC_GATE);
    const isRankedFallThroughEnabled = (0, $cXtTj.default).checkGate($83579a0ad44a68d9$var$NARROW_EXPOSURE_SSF_MIGRATION_GATE);
    const [localMessageState, setLocalMessageState] = (0, $cozmU.useState)(()=>{
        const messages = preloadedInitialData?.messages?.length ? preloadedInitialData.messages : undefined;
        const triggeredMessages = preloadedInitialData?.triggeredMessages?.length ? preloadedInitialData.triggeredMessages : undefined;
        return {
            messages: messages,
            triggeredMessages: triggeredMessages
        };
    });
    // Dismissals are stored locally to keep the local state relatively immutable,
    // except unless explicitly refreshed from the server.
    const [dismissedMessageInstanceIds, setDismissedMessageInstanceIds] = (0, $cozmU.useState)([]);
    const filterByDismissed = (0, $cozmU.useCallback)((list)=>list?.filter((msg)=>!dismissedMessageInstanceIds.includes(msg.messageInstanceId)), [
        dismissedMessageInstanceIds
    ]);
    // Filter the messages at runtime to ensure they are always accurate and
    // so we don't need to manage the dismissed messages in the state.
    const { filteredMessages: filteredMessages, filteredTriggeredMessages: filteredTriggeredMessages } = (0, $cozmU.useMemo)(()=>{
        const { messages: messages, triggeredMessages: triggeredMessages } = localMessageState;
        // Dismissing any ranked candidate consumes the whole response, as dismissing the single
        // rendered message did before, so preloaded data and auto-refetch see no remaining messages.
        const isResponseConsumed = isRankedFallThroughEnabled && !!messages?.some((msg)=>dismissedMessageInstanceIds.includes(msg.messageInstanceId));
        return {
            filteredMessages: isResponseConsumed ? [] : filterByDismissed(messages),
            filteredTriggeredMessages: filterByDismissed(triggeredMessages)
        };
    }, [
        localMessageState,
        filterByDismissed,
        isRankedFallThroughEnabled,
        dismissedMessageInstanceIds
    ]);
    const messagesToRender = (0, $cozmU.useMemo)(()=>{
        if (!isRankedFallThroughEnabled) return filteredMessages?.slice(0, 1);
        const candidates = filteredMessages?.map($83579a0ad44a68d9$var$withNarrowExposureConfig);
        const firstMessage = candidates?.[0];
        // Transactional messages are not choreographed. Without an experiment, the first message is
        // guaranteed to show, so do not render the rest to minimise conflicting messages.
        return firstMessage?.messageCategory === 'Transactional' && !firstMessage.inAppNarrowExposureExperiment ? candidates?.slice(0, 1) : candidates;
    }, [
        isRankedFallThroughEnabled,
        filteredMessages
    ]);
    (0, $5KMtM.useInitialData)(initialData);
    const { onMessageDismiss: onMessageDismiss, onMessageClicked: onMessageClicked, onMessageSnooze: onMessageSnooze } = (0, $di43e.useMessagePlacementHooks)();
    const handleDismiss = (0, $cozmU.useCallback)(({ messageInstanceId: messageInstanceId })=>{
        if (messageInstanceId) // dismiss the current message instance
        setDismissedMessageInstanceIds((current)=>[
                ...current,
                messageInstanceId
            ]);
        else // eslint-disable-next-line no-console
        console.error(`A valid messageInstanceId is required to dismiss a message: ${messageInstanceId}`);
    }, []);
    const onDismissed = (0, $cozmU.useCallback)((messageInstanceId)=>{
        handleDismiss({
            messageInstanceId: messageInstanceId
        });
    }, [
        handleDismiss
    ]);
    (0, $cozmU.useEffect)(()=>onMessageDismiss(handleDismiss), [
        onMessageDismiss
    ]);
    (0, $cozmU.useEffect)(()=>onMessageClicked(handleDismiss), [
        onMessageClicked
    ]);
    (0, $cozmU.useEffect)(()=>onMessageSnooze(handleDismiss), [
        onMessageSnooze
    ]);
    (0, $cozmU.useEffect)(()=>{
        // update the preloaded initial data with the accurate filtered messages
        if (typeof setPreloadedInitialData === 'function') {
            if (isEPExternalMessageSSREnabled) setPreloadedInitialData({
                messages: filteredMessages ?? [],
                triggeredMessages: filteredTriggeredMessages ?? []
            });
            else setPreloadedInitialData({
                messages: filteredMessages ?? [],
                triggeredMessages: filteredTriggeredMessages ?? []
            });
        }
    }, [
        filteredMessages,
        filteredTriggeredMessages,
        isEPExternalMessageSSREnabled,
        setPreloadedInitialData
    ]);
    const activeScopes = (0, $ibNn3.usePostOfficeContextScope)({
        scopes: $8872c0aa9b3ed470$export$54a06e3f4a159ad8,
        treatIntersectionAsSame: true
    });
    const searchParams = (0, $95c6653f43316618$export$e343914da553b968)();
    const messagesState = (0, $enlIM.usePlacementApi)('/update-messages', {
        queryParams: {
            ...searchParams,
            updateKey: activeScopes.updateKey ?? ''
        },
        requestOptions: {
            method: 'POST',
            body: JSON.stringify(activeScopes)
        },
        throttleTime: 100,
        autoRefetch: {
            isEnabled: !!activeScopes.updateKey && typeof filteredMessages === 'undefined',
            updateKey: activeScopes.updateKey ?? ''
        }
    });
    (0, $cozmU.useEffect)(()=>{
        const data = messagesState?.data;
        if (!data) return;
        const messages = data.messages ?? [];
        setLocalMessageState((prev)=>({
                ...prev,
                // The shared renderer handles experiment evaluation when migration is enabled.
                messages: isRankedFallThroughEnabled ? messages : $83579a0ad44a68d9$var$selectMessages(messages, !isNarrowExposureClassicEnabled),
                triggeredMessages: data.triggeredMessages ?? []
            }));
    }, [
        messagesState.data,
        isRankedFallThroughEnabled,
        isNarrowExposureClassicEnabled
    ]);
    const content = (0, $cXtTj.default).checkGate('post-office-screen-space-flags-shadow') ? /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $8aG6j.Fragment), {
        children: [
            messagesToRender?.map((msg)=>/*#__PURE__*/ (0, $cozmU.createElement)(MessageRenderer, {
                    ...msg,
                    key: msg.messageInstanceId,
                    id: msg.messageInstanceId,
                    messageInstanceId: msg.messageInstanceId,
                    onDismissed: onDismissed,
                    SuspenseBoundary: (0, $2tp0D.MaybeSuspenseBoundary),
                    jiraFlagsService: jiraFlagsService,
                    onError: reportUnexpectedError,
                    reportExpectedError: reportExpectedError
                })),
            filteredTriggeredMessages?.map((msg)=>/*#__PURE__*/ (0, $cozmU.createElement)(MessageRenderer, {
                    ...msg,
                    key: msg.messageInstanceId,
                    id: msg.messageInstanceId,
                    messageInstanceId: msg.messageInstanceId,
                    onDismissed: onDismissed,
                    SuspenseBoundary: (0, $2tp0D.MaybeSuspenseBoundary),
                    jiraFlagsService: jiraFlagsService,
                    onError: reportUnexpectedError,
                    reportExpectedError: reportExpectedError
                }))
        ]
    }) : null;
    return content;
};


const $d6bfc9609b019bd0$export$c32237a999261c49 = (input)=>(0, $ibNn3.createMatchScopes)({
        scopes: $8872c0aa9b3ed470$export$54a06e3f4a159ad8
    })(input);
const $d6bfc9609b019bd0$export$c60b43809441c5b0 = (0, $554485f66d5d0ef4$export$b0eee5de066b2bf5)((0, $6U5eU.createPlacementComponent)((0, $38bb2f218e8edc07$export$a5cfae247d8360ef), /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $83579a0ad44a68d9$export$f6564e60882bdf90), {
        ...props
    });
}), {
    choreographer: {
        isDefaultEnabled: true // this is the default value, but leaving it as explicitly defined
    }
}));
var $d6bfc9609b019bd0$export$2e2bcd8739ae039 = $d6bfc9609b019bd0$export$c60b43809441c5b0;



var $5vi32 = parcelRequire("5vi32");


var $5kbLE = parcelRequire("5kbLE");











var $gswTK = parcelRequire("gswTK");

const $e71193158df615d9$export$e5ffd38dcf6e5c53 = `/gateway/api/post-office/api/v1/placements/`;
const $e71193158df615d9$export$85c4756977e87c75 = `/gateway/api/post-office/api/v1/placement-preview/`;
const $e71193158df615d9$export$52e362b70e115c68 = ({ returnOverride: returnOverride, eligibleMessages: eligibleMessages, children: children })=>{
    const fetch = (0, $cozmU.useMemo)(()=>{
        if (returnOverride) return $e71193158df615d9$export$fb5156757134712c({
            returnOverride: returnOverride
        });
        return $e71193158df615d9$export$c05392ff95b4319d({
            eligibleMessages: eligibleMessages
        });
    }, [
        eligibleMessages,
        returnOverride
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gswTK.PlacementFetchingProvider), {
        fetch: fetch
    }, children);
};
const $e71193158df615d9$export$fb5156757134712c = ({ returnOverride: returnOverride })=>async ()=>{
        return new Response(JSON.stringify(returnOverride), {
            status: 200,
            statusText: 'ok'
        });
    };
const $e71193158df615d9$export$c05392ff95b4319d = ({ eligibleMessages: eligibleMessages })=>(url, options)=>{
        const finalUrl = url.replace($e71193158df615d9$export$e5ffd38dcf6e5c53, $e71193158df615d9$export$85c4756977e87c75);
        const payload = {
            originalMethod: options?.method || 'GET',
            originalBody: $e71193158df615d9$var$parseBody(options?.body),
            eligibleMessages: eligibleMessages
        };
        return globalThis.fetch(finalUrl, {
            ...options,
            method: 'POST',
            headers: {
                ...options?.headers || {}
            },
            body: $e71193158df615d9$var$stringifyPayload(payload)
        });
    };
const $e71193158df615d9$var$objectHasKeys = (input)=>!!Object.keys(input).length;
const $e71193158df615d9$var$parseBody = (body)=>{
    if (typeof body === 'undefined' || body === null) return undefined;
    try {
        const parsedBody = JSON.parse(body);
        if ($e71193158df615d9$var$objectHasKeys(parsedBody)) return parsedBody;
        throw new Error();
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};
const $e71193158df615d9$var$stringifyPayload = (payload)=>{
    try {
        return JSON.stringify(payload);
    } catch  {
        throw new Error('Unable to parse preview body. Is it a valid object?');
    }
};


const $6712e9ecdde63a04$export$52e362b70e115c68 = (0, $e71193158df615d9$export$52e362b70e115c68);
const $6712e9ecdde63a04$export$c05392ff95b4319d = (0, $e71193158df615d9$export$c05392ff95b4319d);




var $9EOlJ = parcelRequire("9EOlJ");




const $d60c5d3424a92ca3$export$16e97e6603eadea = ({ PlacementComponent: PlacementComponent, placementId: placementId, eligibleMessages: eligibleMessages, errorFallback: errorFallback = null, onError: onError, returnOverride: returnOverride, disableInitialData: disableInitialData })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $9EOlJ.ErrorBoundary), {
        fallback: errorFallback,
        onError: onError,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $6712e9ecdde63a04$export$52e362b70e115c68), {
            eligibleMessages: eligibleMessages,
            returnOverride: returnOverride,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $5kbLE.default), {
                PlacementComponent: PlacementComponent,
                placementId: placementId,
                disableInitialData: disableInitialData
            })
        })
    });
const $d60c5d3424a92ca3$export$46db7cd62b063064 = ({ isEnabled: isEnabled, children: children })=>{
    const { searchParams: searchParams } = (0, $5h1mk.usePostOfficeRoute)();
    const previewId = searchParams?.get('contentfulPreviewId');
    const hasPreviewType = Boolean(searchParams?.get('contentfulPreviewId'));
    const localeForPreview = searchParams?.get('locale');
    const eligibleMessage = [
        {
            messageInstanceId: 'messageInstanceId',
            messageTemplateId: 'marketing-screen-space-flag-contentful-usecase',
            messageCategory: 'Engagement',
            context: {
                id: previewId,
                localeForPreview: localeForPreview
            },
            createdAt: new Date().toString(),
            eventTime: new Date().toString(),
            triggerId: 'triggerId',
            messageCreationType: 'explicit'
        }
    ];
    if (isEnabled && hasPreviewType) return /*#__PURE__*/ (0, $8aG6j.jsx)($d60c5d3424a92ca3$export$16e97e6603eadea, {
        placementId: "screen-space-flags",
        PlacementComponent: (0, $d6bfc9609b019bd0$export$c60b43809441c5b0),
        eligibleMessages: eligibleMessage
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
        children: children
    });
};



var $7ZO1y = parcelRequire("7ZO1y");


var $hGIXv = parcelRequire("hGIXv");


var $b3j2Y = parcelRequire("b3j2Y");








var $8MKuN = parcelRequire("8MKuN");







const $ff5b1beeba4d1714$export$9c1a9b8d86d81805 = ()=>{
    const isSyntheticTenant = (0, $1xpoY.default).getBoolean('confluence_frontend_pollinator_synthetic_tenants', false);
    if (!isSyntheticTenant) return false;
    // Allow Post Office's own Pollinator accounts through (they rely on hitting the
    // Placement API for their own monitoring).
    return !(0, $1xpoY.default).getBoolean('post-office-is-post-office-synthetic-user', false);
};


const $362d8c5d9317edac$export$f6564e60882bdf90 = /*#__PURE__*/ (0, $cozmU.memo)(()=>{
    const [messageErrorToReport, setMessageErrorToReport] = (0, $cozmU.useState)();
    const [preloadedInitialData, setPreloadedInitialData] = (0, $hGIXv.usePlacementPreloadedData)('screen-space-flags/update-messages');
    const memoizedPlacementProps = (0, $cozmU.useMemo)(()=>({
            reportExpectedError: (0, $7Sm4c.markErrorAsHandled),
            reportUnexpectedError: setMessageErrorToReport,
            preloadedInitialData: preloadedInitialData,
            setPreloadedInitialData: setPreloadedInitialData
        }), [
        preloadedInitialData,
        setPreloadedInitialData
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isEmbeddedView = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    if (isEmbeddedView) return null;
    if (!userId) return null;
    // Suppress the placement (and its Placement API request) for non-Post-Office synthetic
    // test tenants, which otherwise generate large volumes of Placement API traffic and
    // trigger Stargate rate-limit alerts.
    if ((0, $ff5b1beeba4d1714$export$9c1a9b8d86d81805)()) return null;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d60c5d3424a92ca3$export$46db7cd62b063064), {
        isEnabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ZO1y.PlacementFetchProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5kbLE.default), {
        placementId: "screen-space-flags",
        // @ts-ignore - Type 'ComponentType<ErrorBoundariedProps<Placement>>' is not assignable to type 'PlacementComponent<LocalPlacementProps>'
        PlacementComponent: (0, $d6bfc9609b019bd0$export$c60b43809441c5b0),
        placementProps: memoizedPlacementProps,
        disableInitialData: true
    }), messageErrorToReport && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: messageErrorToReport
    })));
    return (0, $6mKj3.expVal)('confluence_edit_page_conditional_ufohold_ignore', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8MKuN.ConditionalUfoHoldIgnore), null, content) : content;
});






var $lonEO = parcelRequire("lonEO");


var $kZDrw = parcelRequire("kZDrw");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $f7i8j = parcelRequire("f7i8j");


var $jVK0t = parcelRequire("jVK0t");





var $aDyoj = parcelRequire("aDyoj");







// Data Plugin definition and utility types
const $5cab8e2303c72867$export$a235a73f7b906dce = {
    GetContainers: 'GetContainers',
    GetUsers: 'GetUsers',
    GetSuggestedSiteNames: 'GetSuggestedSiteNames',
    GetAvailableSites: 'GetAvailableSites'
};
const $5cab8e2303c72867$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: 'bitbucket-workspace',
    ATLASSIAN_CLOUD_ID: 'ATLASSIAN_CLOUD_ID',
    JIRA_SOFTWARE_PROJECT: 'JIRA_SOFTWARE_PROJECT'
};
const $5cab8e2303c72867$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: 'ATLASSIAN_ACCOUNT_ID',
    TRELLO_ID: 'TRELLO_ID'
};
const $5cab8e2303c72867$export$4f378ba35c571906 = {
    JIRA_BUSINESS: 'JIRA_BUSINESS',
    JIRA_SERVICE_DESK: 'JIRA_SERVICE_DESK',
    JIRA_SOFTWARE: 'JIRA_SOFTWARE',
    CONFLUENCE: 'CONFLUENCE',
    OPSGENIE: 'OPSGENIE',
    BITBUCKET: 'BITBUCKET',
    STATUSPAGE: 'STATUSPAGE',
    TRELLO: 'TRELLO',
    COMPASS: 'COMPASS'
};



const $62c03eaa9b0b743b$export$76378b0f825c024c = (fetch)=>{
    return [
        (0, $5cab8e2303c72867$export$a235a73f7b906dce).GetContainers,
        fetch
    ];
};
const $62c03eaa9b0b743b$export$8feb7eae83cf8cd5 = (fetch)=>{
    return [
        (0, $5cab8e2303c72867$export$a235a73f7b906dce).GetUsers,
        fetch
    ];
};
const $62c03eaa9b0b743b$export$21d120847be2aff4 = (fetch)=>{
    return [
        (0, $5cab8e2303c72867$export$a235a73f7b906dce).GetSuggestedSiteNames,
        fetch
    ];
};
const $62c03eaa9b0b743b$export$d7c1699c6a2ca18a = (fetch)=>{
    return [
        (0, $5cab8e2303c72867$export$a235a73f7b906dce).GetAvailableSites,
        fetch
    ];
};






var $fKdEy = parcelRequire("fKdEy");

function $3dc98590eeed1246$var$hasSiteSettings(data) {
    return data && typeof data === 'object' && data['siteSettings'] && data['tenant'];
}
const $3dc98590eeed1246$var$getCloudId = async ()=>{
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: (0, $fKdEy.default),
        __callerPackage__: "cross-flow"
    });
    const containers = [];
    if ($3dc98590eeed1246$var$hasSiteSettings(data)) {
        const { siteTitle: siteTitle } = data.siteSettings;
        const tenantId = data.tenant.cloudId;
        containers.push({
            id: tenantId,
            displayName: siteTitle,
            type: (0, $5cab8e2303c72867$export$6e383182a26455ff).ATLASSIAN_CLOUD_ID
        });
    }
    return {
        type: (0, $5cab8e2303c72867$export$6e383182a26455ff).ATLASSIAN_CLOUD_ID,
        containers: containers
    };
};
const $3dc98590eeed1246$export$81d1d40061d190bc = (0, $62c03eaa9b0b743b$export$76378b0f825c024c)($3dc98590eeed1246$var$getCloudId);






const $c394a569c7bfdabb$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await (0, $f7B1p.cfetch)(getUsersUrl, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    idType: (0, $5cab8e2303c72867$export$e391bab95adb8396).ATLASSIAN_ACCOUNT_ID,
                    id: value.id,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $c394a569c7bfdabb$export$7c44908d2777db01 = (0, $62c03eaa9b0b743b$export$8feb7eae83cf8cd5)($c394a569c7bfdabb$var$getUsers);


const $70d683a301b7be27$export$d900e4062895cd7c = ({ children: children })=>{
    const { cloudId: cloudId, locale: locale } = (0, $bQm3c.useSessionData)();
    const analyticWebClient = (0, $cozmU.useMemo)(()=>(0, $04e9M.getAnalyticsWebClient)(), []);
    const isMarketingOptOut = // eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
    document.querySelector("meta[name='ajs-marketing-opt-out']")?.getAttribute('content') === 'true';
    if (isMarketingOptOut) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDyoj.default), {
        cloudId: cloudId,
        analyticsClient: analyticWebClient,
        locale: locale,
        plugins: [
            (0, $c394a569c7bfdabb$export$7c44908d2777db01),
            (0, $3dc98590eeed1246$export$81d1d40061d190bc)
        ]
    }, children);
};



var $d5ap9 = parcelRequire("d5ap9");


var $1ytiN = parcelRequire("1ytiN");





var $3ricL = parcelRequire("3ricL");


var $lsxnT = parcelRequire("lsxnT");











var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $hSHWm = parcelRequire("hSHWm");





const $639a6e255dabf06b$export$96cfefeef4383728 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "mA5-d",
    name: "CoreInvitesLoadable",
    loader: async ()=>(await (parcelRequire("3fP9Q"))).CoreInvites
});



var $koZ31 = parcelRequire("koZ31");







const $8855e66edaf78755$var$INVITE_DIALOG_PARAM = 'inviteDialog';
const $8855e66edaf78755$var$getOpenModalParam = ()=>{
    return new URLSearchParams(window.location.search.substring(1)).get($8855e66edaf78755$var$INVITE_DIALOG_PARAM) || '';
};
function $8855e66edaf78755$export$fd22f9b0c5d723c2(openCoreInvites) {
    (0, $cozmU.useEffect)(()=>{
        if (!window) return;
        if ($8855e66edaf78755$var$getOpenModalParam() !== 'open') return;
        openCoreInvites((0, $koZ31.CoreInvitesSource).OPEN_MODAL_QUERY_PARAM);
        // remove the query param from the URL without reloading the page
        const url = new URL(window.location.href);
        url.searchParams.delete($8855e66edaf78755$var$INVITE_DIALOG_PARAM);
        window.history.replaceState({}, document.title, url.toString());
    }, [
        openCoreInvites
    ]);
}


const $685338b3d2a4b0a3$var$noop = ()=>{
    return undefined;
};
function $685338b3d2a4b0a3$export$2e865a7ec399eb55({ children: children }) {
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [initialInvitees, setInitialInvitees] = (0, $cozmU.useState)([]);
    const [source, setSource] = (0, $cozmU.useState)((0, $koZ31.CoreInvitesSource).UNKNOWN);
    const [showSpotlight, setShowSpotlight] = (0, $cozmU.useState)(false);
    const [productContext, setProductContext] = (0, $cozmU.useState)(undefined);
    const [touchpoint, setTouchpoint] = (0, $cozmU.useState)(undefined);
    const stablePropsRef = (0, $cozmU.useRef)({
        onInviteCompleted: $685338b3d2a4b0a3$var$noop,
        onModalClose: $685338b3d2a4b0a3$var$noop
    });
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const contextualInviteNudgeChoreographer = useChoreographer('cc-contextual-invite-nudge', {
        start: ()=>setShowSpotlight(true),
        stop: ()=>setShowSpotlight(false)
    });
    const { orgId: orgId } = (0, $bQm3c.useSessionData)();
    const handleModalOpen = (0, $cozmU.useCallback)((touchPoint, { onModalClosed: onModalClosed = $685338b3d2a4b0a3$var$noop, onInviteCompleted: onInviteCompleted = $685338b3d2a4b0a3$var$noop, getContextualInviteNudgeProps: getContextualInviteNudgeProps } = {}, initialInvitees = [], productContextMetadata, enablementTouchpoint)=>{
        setInitialInvitees(initialInvitees);
        setSource(touchPoint || (0, $koZ31.CoreInvitesSource).UNKNOWN);
        setProductContext(productContextMetadata);
        setTouchpoint(enablementTouchpoint);
        stablePropsRef.current.onModalClose = onModalClosed;
        stablePropsRef.current.onInviteCompleted = onInviteCompleted;
        setIsOpen(true);
        const shouldShow = getContextualInviteNudgeProps?.()?.showSpotlight;
        if (shouldShow) contextualInviteNudgeChoreographer.startMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setInitialInvitees,
        setSource,
        setIsOpen
    ]);
    const handleModalClose = (0, $cozmU.useCallback)(()=>{
        setSource((0, $koZ31.CoreInvitesSource).UNKNOWN);
        setProductContext(undefined);
        setTouchpoint(undefined);
        // remember the current value for later invocation, since we're about to override it
        const onClosed = stablePropsRef.current.onModalClose;
        stablePropsRef.current.onModalClose = $685338b3d2a4b0a3$var$noop;
        stablePropsRef.current.onInviteCompleted = $685338b3d2a4b0a3$var$noop;
        setIsOpen(false);
        onClosed();
        contextualInviteNudgeChoreographer.stopMessage();
    }, [
        contextualInviteNudgeChoreographer,
        setSource,
        setIsOpen
    ]);
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const failExperienceOnError = (0, $cozmU.useCallback)((error)=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CORE_INVITES_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    const isInvitationsEnabled = (0, $3ricL.isFeatureEnabled)('confluence', 'confluence-invitations');
    const coreInviteContext = (0, $cozmU.useMemo)(()=>({
            openCoreInvites: isInvitationsEnabled ? handleModalOpen : undefined
        }), [
        handleModalOpen,
        isInvitationsEnabled
    ]);
    const displayInfiSpotlight = true;
    const inviteCompletedHandler = (0, $cozmU.useCallback)((result)=>{
        stablePropsRef.current.onInviteCompleted(result);
    }, [
        stablePropsRef
    ]);
    (0, $8855e66edaf78755$export$fd22f9b0c5d723c2)(isInvitationsEnabled ? handleModalOpen : $685338b3d2a4b0a3$var$noop);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSHWm.CoreInvitesContext).Provider, {
        value: coreInviteContext
    }, children, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH,
        onError: failExperienceOnError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $639a6e255dabf06b$export$96cfefeef4383728), {
        initialInvitees: initialInvitees,
        onSendHandler: handleModalClose,
        onCancelHandler: handleModalClose,
        onInviteCompletedHandler: inviteCompletedHandler,
        source: source,
        orgId: orgId,
        displayInfiSpotlight: displayInfiSpotlight,
        showSpotlight: showSpotlight,
        experimentalProductContext: productContext,
        touchpoint: touchpoint
    })));
}



var $hrAmX = parcelRequire("hrAmX");


var $bJX6u = parcelRequire("bJX6u");


var $ktUCG = parcelRequire("ktUCG");


var $brNvA = parcelRequire("brNvA");


var $cryCi = parcelRequire("cryCi");


var $97W74 = parcelRequire("97W74");








var $1i7uI = parcelRequire("1i7uI");





var $dBmJE = parcelRequire("dBmJE");


var $eXODy = parcelRequire("eXODy");


var $iV00x = parcelRequire("iV00x");


var $kCeSx = parcelRequire("kCeSx");


var $gtMdU = parcelRequire("gtMdU");








var $1hQ0e = parcelRequire("1hQ0e");





function $c321319b844a3888$export$4d0b2e184ba12ee7(targetDocument, attribute, controllers) {
    const existingController = controllers.get(targetDocument);
    if (existingController) {
        existingController.references += 1;
        let isReleased = false;
        return ()=>{
            if (isReleased) return;
            isReleased = true;
            existingController.references -= 1;
            if (existingController.references === 0) {
                existingController.release();
                controllers.delete(targetDocument);
            }
        };
    }
    const rootElement = targetDocument.documentElement;
    const controller = {
        references: 1,
        release: ()=>rootElement.removeAttribute(attribute)
    };
    rootElement.setAttribute(attribute, '');
    controllers.set(targetDocument, controller);
    let isReleased = false;
    return ()=>{
        if (isReleased) return;
        isReleased = true;
        controller.references -= 1;
        if (controller.references === 0) {
            controller.release();
            controllers.delete(targetDocument);
        }
    };
}


const $2eb847c66780bfc8$var$controllers = new WeakMap();
function $2eb847c66780bfc8$export$f289ecff4a99e09d(targetDocument) {
    return (0, $c321319b844a3888$export$4d0b2e184ba12ee7)(targetDocument, (0, $08436a2f9d11149e$export$cc97c2566f53fd12), $2eb847c66780bfc8$var$controllers);
}


const $10fd4e7f95cabba0$export$6a82770d3a3903f7 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useScrollbarHarmonisation(isEnabled) {
    const $ = (0, $bDgLe.c)(4);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iDrrr.fg)("platform_dst_scrollbar_harmonisation");
        $[0] = t0;
    } else t0 = $[0];
    const isGateEnabled = t0;
    const shouldEnable = isEnabled ?? isGateEnabled;
    let t1;
    let t2;
    if ($[1] !== shouldEnable) {
        t1 = ()=>{
            if (!shouldEnable) return;
            const targetDocument = (0, $1hQ0e.getDocument)();
            if (!targetDocument) return;
            return (0, $2eb847c66780bfc8$export$f289ecff4a99e09d)(targetDocument);
        };
        t2 = [
            shouldEnable
        ];
        $[1] = shouldEnable;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useScrollbarHarmonisation(isEnabled) {
    const isGateEnabled = (0, $iDrrr.fg)('platform_dst_scrollbar_harmonisation');
    const shouldEnable = isEnabled ?? isGateEnabled;
    (0, $cozmU.useEffect)(()=>{
        if (!shouldEnable) return;
        const targetDocument = (0, $1hQ0e.getDocument)();
        if (!targetDocument) return;
        return (0, $2eb847c66780bfc8$export$f289ecff4a99e09d)(targetDocument);
    }, [
        shouldEnable
    ]);
};






var $7SkLu = parcelRequire("7SkLu");






var $9i4uP = parcelRequire("9i4uP");


var $aXWtB = parcelRequire("aXWtB");





var $kSwu1 = parcelRequire("kSwu1");








var $7aRa9 = parcelRequire("7aRa9");


var $gLUd5 = parcelRequire("gLUd5");











var $gEtAQ = parcelRequire("gEtAQ");


var $jlIaF = parcelRequire("jlIaF");








var $i1t43 = parcelRequire("i1t43");

const $b59268334a98f13b$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    genericSSRErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.generic.message",
        defaultMessage: "Reason: {reason}. "
    },
    branchDeployErrorFlagReason: {
        id: "ssr-render-failure-notification.flag.branch.deploy.message",
        defaultMessage: "Possible outdated branch deploy detected. Your PR changes might not be tested against SSR accurately. "
    },
    runbookLink: {
        id: "ssr-render-failure-notification.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug this failure."
    }
});
const $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4898451942/Branch+Deploys`;
const $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK = `https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4911008649/SSR+Render+Failures`;
const $b59268334a98f13b$export$487f09dcd3f678bf = ({ ssrErrors: ssrErrors, isBranchDeployFailure: isBranchDeployFailure })=>{
    const runbookLink = isBranchDeployFailure ? $b59268334a98f13b$var$BRANCH_DEPLOY_RUNBOOK_LINK : $b59268334a98f13b$var$GENERIC_SSR_FAILURE_RUNBOOK_LINK;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, isBranchDeployFailure ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $b59268334a98f13b$export$a7357cdd1f0b0168.branchDeployErrorFlagReason) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.genericSSRErrorFlagReason,
        values: {
            reason: ssrErrors[0]
        }
    })), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$b59268334a98f13b$export$a7357cdd1f0b0168.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: runbookLink
                }, chunks)
        }
    }));
};











const $5e5853def1ddf657$var$i18n = (0, $kSwu1.defineMessages)({
    hydrationErrorMessage: {
        id: "ssr-render-failure-notification.hydration.flag.message",
        defaultMessage: "To view the hydration mismatches, refer to window.__HYDRATION_ERRORS__ in the browser console."
    },
    runbookLink: {
        id: "ssr-render-failure-notification.hydration.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for information on how to debug the mismatches."
    }
});
const $5e5853def1ddf657$export$7922b21049d03e3b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "flagErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $5e5853def1ddf657$var$i18n.hydrationErrorMessage)), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$5e5853def1ddf657$var$i18n.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: "https://hello.atlassian.net/wiki/spaces/CCPERF/pages/4848884799/Debugging+Hydration+Mismatches"
                }, chunks)
        }
    }));
};


const $008c5cd8cb4c3a95$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    ssrRenderErrorFlagTitle: {
        id: "ssr-render-failure-notification.flag",
        defaultMessage: "This page was NOT SSR RENDERED!"
    },
    hydrationErrorFlagTitle: {
        id: "ssr-render-failure-notification.hydration.flag",
        defaultMessage: "This page was NOT HYDRATED PROPERLY!"
    }
});
const $008c5cd8cb4c3a95$export$475a1abe7cf690a3 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    const hasShownErrorFlagRef = (0, $cozmU.useRef)(false);
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    // we want to exclude testing environments and pollinator tenants from showing the error flag
    const isTestEnvironment = (0, $1xpoY.default).isKillSwitchOn('confluence_frontend_ssr_failure_notification');
    // We only want to show the error flag in the dev/staging environment
    // however, branch deploys on production will default to process.env.CLOUD_ENV = 'branch'
    const isStagingEnvironment = [
        'dev',
        'branch',
        'staging',
        'stg-fedm'
    ].includes("production" ?? '') && environment !== 'PRODUCTION';
    (0, $cozmU.useEffect)(()=>{
        if (!isStagingEnvironment || isTestEnvironment) return;
        // regex to match /spaces/:spaceKey/blogs (blogs overview)
        const blogsOverviewRegex = new RegExp(`^${(0, $jlIaF.CONTEXT_PATH)}/spaces/[^/]+/blogs$`);
        // Helper function to determine if we should skip error checking for certain paths
        const isAllowedPath = (pathname)=>{
            return (0, $gEtAQ.isHomePage)() || (0, $gEtAQ.isViewPage)() || (0, $gEtAQ.isSpaceOverview)() || (0, $gEtAQ.isBlogPage)() || (0, $gEtAQ.isWhiteboard)() || (0, $gEtAQ.isDatabase)() || Boolean((0, $1NBp8.EDIT_PAGE).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_V2).match(pathname)) || Boolean((0, $1NBp8.EDIT_BLOG).match(pathname)) || Boolean((0, $1NBp8.EDIT_BLOG_V2).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_EMBED).match(pathname)) || Boolean(blogsOverviewRegex.test(pathname)) || Boolean((0, $1NBp8.COMPANY_HUB).match(pathname)) || Boolean((0, $1NBp8.COMPANY_HUB_EDIT).match(pathname)) || Boolean((0, $1NBp8.EMBED_VIEW).match(pathname)) || Boolean((0, $1NBp8.EDIT_PAGE_SMART_CREATE).match(pathname)) || Boolean('/'.match(pathname));
        };
        if (isAllowedPath(window.location.pathname)) {
            const showHydrationError = ()=>{
                if (!hasShownErrorFlagRef.current) {
                    flags.showErrorFlag({
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.hydrationErrorFlagTitle),
                        isAutoDismiss: false,
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5e5853def1ddf657$export$7922b21049d03e3b), null)
                    });
                    hasShownErrorFlagRef.current = true;
                }
            };
            if ((0, $1xpoY.default).getBoolean('confluence_frontend_hydration_error_event', false)) window.addEventListener('hydrationError', showHydrationError);
            // sometimes errors exist but the page is still SSRd successfully - we don't want to show the SSR render error flag in this case
            if (window.__SSR_RENDERED__) {
                // if the page is SSRd successfully we check if the page was hydrated successfully, and show a hydration error flag if not
                if (window.__HYDRATION_FAILED__) showHydrationError();
                return ()=>{
                    window.removeEventListener('hydrationError', showHydrationError);
                };
            }
            // COMPILED dev warnings show up on every SSRd page even if the page is SSRd successfully,
            // so we need to filter them out to distinguish from actual errors being reported for local dev ssr
            const ssrErrors = window.__SSR_ERROR__?.filter((err)=>!err.includes('DEV WARNING')) ?? [];
            // on old branch deploys, ssr errors can still be empty but the page might not be SSRd successfully
            const isBranchDeployFailure = (0, $gLUd5.isBranchDeployFn)() && !window.__SSR_RENDERED__ && !ssrErrors?.length;
            if (!hasShownErrorFlagRef.current && (isBranchDeployFailure || ssrErrors.length)) {
                flags.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $008c5cd8cb4c3a95$export$a7357cdd1f0b0168.ssrRenderErrorFlagTitle),
                    isAutoDismiss: false,
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b59268334a98f13b$export$487f09dcd3f678bf), {
                        ssrErrors: ssrErrors,
                        isBranchDeployFailure: isBranchDeployFailure
                    })
                });
                hasShownErrorFlagRef.current = true;
            }
            return ()=>{
                window.removeEventListener('hydrationError', showHydrationError);
            };
        }
    }, [
        isStagingEnvironment,
        flags,
        isTestEnvironment
    ]);
    return null;
});
const $008c5cd8cb4c3a95$export$4e5ff544be3ec09b = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($008c5cd8cb4c3a95$export$475a1abe7cf690a3, null));
};



var $iJELi = parcelRequire("iJELi");


var $8n9tL = parcelRequire("8n9tL");


var $4o1RV = parcelRequire("4o1RV");


var $aFbGo = parcelRequire("aFbGo");


var $64KID = parcelRequire("64KID");











var $4PPzL = parcelRequire("4PPzL");


var $5q601 = parcelRequire("5q601");










const $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION = 50;
const $e7cb2c525109c7cf$export$de3c307012927947 = (start, stop, idleThreshold, buffer)=>{
    const entires = buffer.getAll().filter((entry)=>entry.duration >= $e7cb2c525109c7cf$var$MIN_LONG_TASK_DURATION).map((entry)=>({
            start: entry.startTime,
            stop: entry.startTime + entry.duration
        })).filter((entry)=>entry.stop > start && entry.start < stop).concat([
        // Add a fake entry to simplify the logic below
        {
            start: stop,
            stop: stop
        }
    ]).sort((a, b)=>a.start - b.start);
    let lastStop = start;
    for (const entry of entires){
        if (lastStop + idleThreshold < entry.start) return lastStop;
        lastStop = entry.stop;
    }
    return null;
};









var $lSOAM = parcelRequire("lSOAM");


var $fd6g2 = parcelRequire("fd6g2");

const $682a207fed74bf66$export$e49353726941624a = (0, $lSOAM.createConcurrentCustomMetric)({
    key: (0, $fd6g2.TIME_TO_APP_IDLE_KEY)
});



const $f6158bccfa436061$var$IDLE_THRESHOLD = 3000;
const $f6158bccfa436061$var$RETRY_INTERVAL = $f6158bccfa436061$var$IDLE_THRESHOLD * 2;
const $f6158bccfa436061$var$TIMEOUT_INTERVAL = 300000; // 5 minutes
const $f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT = 1000;
const $f6158bccfa436061$var$performance = window.performance;
const $f6158bccfa436061$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $f6158bccfa436061$var$wainNextIdle = ()=>{
    // eslint-disable-next-line compat/compat -- This has a fallback to requestAnimationFrame if requestIdleCallback is unsupported.
    const onIdleCallback = window.requestIdleCallback || window.requestAnimationFrame;
    const cancelCallback = (id)=>{
        if (onIdleCallback === window.requestIdleCallback) window.cancelIdleCallback(id);
        else window.cancelAnimationFrame(id);
    };
    return new Promise((resolve)=>{
        const callbackId = onIdleCallback(()=>{
            cancelCallback(callbackId);
            resolve();
        });
    });
};
const $f6158bccfa436061$export$560b992b8a813cfb = /*#__PURE__*/ (0, $cozmU.memo)(({})=>{
    const routes = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const routeName = routes.match?.name || '';
    const contentId = routes.match?.params?.contentId || '';
    const transitionId = routes.transitionId || 0;
    (0, $cozmU.useEffect)(()=>{
        const htmlTime = $f6158bccfa436061$var$performance?.getEntriesByName?.('CFP-63.html').pop()?.startTime || 0;
        const isInitialLoad = transitionId === 0;
        const metric = (0, $682a207fed74bf66$export$e49353726941624a)(`${transitionId}-${routeName}-${contentId}`);
        // we have two different 'startTime' variables in this context:
        // 'metricStartTime' - This is used for reporting to the metric and for calculating duration.
        // 'startTime' - This is used as a boundary for idle time calculation. There may be instances where the HTML is ready,
        // but the component is not yet rendered. In such cases, we use the component's first render time as the start boundary.
        const startTime = $f6158bccfa436061$var$performance?.now();
        const metricStartTime = isInitialLoad ? htmlTime : startTime;
        let abortedTime = 0;
        metric.start({
            startTime: metricStartTime
        });
        async function measureTimeToAppIdle() {
            while(true){
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$RETRY_INTERVAL);
                // wait for current long task to complete
                await $f6158bccfa436061$var$wainNextIdle();
                const endTime = $f6158bccfa436061$var$performance?.now();
                // wait to allow performance observer to collect recent entries
                // note that `endTime` somewhat behind after this line, but it's ok
                await $f6158bccfa436061$var$delay($f6158bccfa436061$var$PERFORMANCE_OBSERVER_LATENCY_ADJUSTMENT);
                const idleTime = (0, $e7cb2c525109c7cf$export$de3c307012927947)(startTime, endTime, $f6158bccfa436061$var$IDLE_THRESHOLD, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
                const aborted = abortedTime && (!idleTime || abortedTime < idleTime) ? 'transition' : false;
                const timedOut = endTime - metricStartTime > $f6158bccfa436061$var$TIMEOUT_INTERVAL;
                if (idleTime || timedOut || aborted) {
                    const stopTime = idleTime || endTime;
                    const duration = stopTime - metricStartTime;
                    const tbt = (0, $f69af1ee3d00be57$export$2d6e933b35bd3407)(startTime, stopTime, (0, $i7t6K.EntriesBuffer)[(0, $2c1Wz.PerformanceObserverEntryTypes).LongTask]);
                    const customData = {
                        duration: duration,
                        startTime: metricStartTime,
                        stopTime: stopTime,
                        aborted: aborted,
                        transitionId: transitionId,
                        routeName: routeName,
                        contentId: contentId,
                        timedOut: timedOut,
                        idleThreshold: $f6158bccfa436061$var$IDLE_THRESHOLD,
                        tbtObserved: Math.round(tbt.observed),
                        tbtTotal: Math.round(tbt.total),
                        totalElementsToHydrate: (0, $ezH4I.getTotalHydratedElements)()
                    };
                    metric.stop({
                        stopTime: stopTime,
                        customData: customData
                    });
                    return;
                }
            }
        }
        measureTimeToAppIdle();
        return ()=>{
            abortedTime = $f6158bccfa436061$var$performance?.now();
        };
    }, [
        transitionId,
        routeName,
        contentId
    ]);
    return null;
});







var $iFjdQ = parcelRequire("iFjdQ");




function $192302f00fa5cc0a$export$8c3a984654991d73(routeName) {
    if (!routeName) return;
    switch(routeName){
        // edit route names taken from @confluence/browser-metrics/src/metricKeys.ts
        case (0, $1NBp8.EDIT_PAGE_EMBED).name:
        case (0, $1NBp8.EDIT_PAGE_V2).name:
        case (0, $1NBp8.EDIT_BLOG_V2).name:
        case (0, $1NBp8.EDIT_PAGE).name:
        case (0, $1NBp8.EDIT_BLOG).name:
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureEnd((0, $5q601.EDIT_ROUTE_CHANGE_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_FMP_ACTION));
            (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EDIT_ROUTE_CHANGE_TO_TTI_ACTION));
            return;
        default:
            return;
    }
}



var $jfrcs = parcelRequire("jfrcs");





var $aeSHO = parcelRequire("aeSHO");


var $25MM7 = parcelRequire("25MM7");


var $NAPtM = parcelRequire("NAPtM");


var $iJiK8 = parcelRequire("iJiK8");














var $ikfiQ = parcelRequire("ikfiQ");


const $8bd37d13e213b9df$var$NetworkStatusFlagLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "_Umim",
    name: "NetworkStatusFlagLoader",
    loader: ()=>(parcelRequire("loJVf")).then((module)=>module.NetworkStatusFlagWithFlags)
});
const $8bd37d13e213b9df$export$529640d4682c2 = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const networkStatus = (0, $ikfiQ.useNetworkStatusListenerCache)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let reason;
    bb0: switch(networkStatus){
        case (0, $ikfiQ.ClientNetworkStatus).IP_BLOCKED:
            reason = "IP blocked";
            break bb0;
        case (0, $ikfiQ.ClientNetworkStatus).OFFLINE:
            reason = "Network unavailable";
    }
    if (reason) experienceTracker.abort({
        reason: reason,
        checkForTimeout: false
    });
    let t0;
    if ($[0] !== networkStatus) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8bd37d13e213b9df$var$NetworkStatusFlagLoader, {
            status: networkStatus
        });
        $[0] = networkStatus;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};



var $itS9i = parcelRequire("itS9i");


var $hmRc4 = parcelRequire("hmRc4");


var $8Ss4E = parcelRequire("8Ss4E");








var $hzVuz = parcelRequire("hzVuz");





const $af5e1b3a6aa255af$export$38f39b921d5551c1 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "Bc3Ba",
    name: "Heartbeat",
    loader: async ()=>(await (parcelRequire("hmDFY"))).Heartbeat
});



var $39rFu = parcelRequire("39rFu");











var $9DHhW = parcelRequire("9DHhW");


var $gqqjz = parcelRequire("gqqjz");

const $e4d79357fba42d43$var$i18n = (0, $kSwu1.defineMessages)({
    localStorageQuotaExceededTitle: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.title",
        defaultMessage: "We ran into a problem"
    },
    localStorageQuotaExceededDescription: {
        id: "local-storage-quota-subscriber.flag.quota-exceeded.description",
        // oxlint-disable-next-line eslint-core/no-restricted-syntax
        defaultMessage: "We've noticed an issue that may affect your experience on Confluence. Select \u201CRefresh\u201D below to fix it."
    },
    refreshLocalStorage: {
        id: "local-storage-quota-subscriber.flag.refresh.title",
        defaultMessage: "Refresh"
    }
});
const $e4d79357fba42d43$export$b2c5189af5b5e948 = ({ onWarningShown: onWarningShown })=>{
    const [isOverflown, setIsOverflown] = (0, $cozmU.useState)(false);
    const [wasShown, setWasShown] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        const onQuotaExceeded = ()=>setIsOverflown(true);
        window.addEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        return ()=>{
            setIsOverflown(false);
            window.removeEventListener('local-storage.quota.exceeded', onQuotaExceeded);
        };
    }, [
        setIsOverflown
    ]);
    const clearLocalStorage = ()=>{
        window.localStorage.clear();
        window.location.reload();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'LocalStorageQuotaSubscriber',
                action: 'clicked',
                actionSubject: 'LocalStorageQuotaExceededFlag',
                actionSubjectId: 'localStorageQuotaCleared'
            }
        }).fire();
    };
    const showFlag = (flags)=>{
        if (wasShown) return;
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e4d79357fba42d43$var$i18n.localStorageQuotaExceededDescription),
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $e4d79357fba42d43$var$i18n.refreshLocalStorage),
                    href: '',
                    onClick: ()=>clearLocalStorage()
                }
            ]
        }).then(()=>{
            try {
                const attributes = onWarningShown?.();
                if (attributes) createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        source: 'LocalStorageQuotaSubscriber',
                        action: 'shown',
                        actionSubject: 'LocalStorageQuotaExceededFlag',
                        actionSubjectId: 'localStorageQuotaWarningShown',
                        attributes: attributes
                    }
                }).fire();
            } catch  {
            // Reporting must not prevent the warning's refresh action from working.
            }
        }, ()=>{
        // A warning that failed to be added should not be counted as shown.
        });
        setWasShown(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>{
        if (isOverflown) showFlag(flags);
        return null;
    });
};



var $iMLPM = parcelRequire("iMLPM");





var $7J5Uc = parcelRequire("7J5Uc");

const $0f25e4f8facf0d0e$export$913cb5ed19d2180b = (initialTheme)=>{
    const { initializeTheme: initializeTheme } = (0, $7J5Uc.useThemingActions)();
    (0, $cozmU.useEffect)(()=>{
        initializeTheme(initialTheme);
    // Only execute upon initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};



var $83wRA = parcelRequire("83wRA");


var $cBuRD = parcelRequire("cBuRD");





var $6UYek = parcelRequire("6UYek");











const $852a6819cc9585c3$export$5f8d39834fd61797 = ({ children: children })=>{
    // allow developers to disable strict mode for local development
    const isStrictModeDisabled = false;
    if (isStrictModeDisabled) return children;
    // React.StrictMode usage is enabled via dynamic config or environment variable
    if ((0, $1xpoY.default).getBoolean('confluence_strict_mode_config', false) || false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).StrictMode, null, children);
    else return children;
};



var $2JYae = parcelRequire("2JYae");








var $3WLLD = parcelRequire("3WLLD");








var $ek3aD = parcelRequire("ek3aD");






















var $4aRua = parcelRequire("4aRua");

const $003e065b50dd1979$var$RUNBOOK_URL = 'https://hello.atlassian.net/wiki/spaces/~7120202da6a0b2c4184c0da3ba8ade6d08feaa/pages/5761728624/React+suspense+boundary+errors+run-book';
const $003e065b50dd1979$var$i18n = (0, $kSwu1.defineMessages)({
    outsideBoundaryError: {
        id: "streaming-boundary-error-notification.outside-boundary.message",
        defaultMessage: "Query \"{operationName}\" preloaded in [{expectedBoundaries}] but accessed outside any suspense boundary."
    },
    boundaryMismatchError: {
        id: "streaming-boundary-error-notification.boundary-mismatch.message",
        defaultMessage: "Query \"{operationName}\" preloaded in [{expectedBoundaries}] but accessed in \"{currentBoundaries}\" boundary."
    },
    runbookLink: {
        id: "streaming-boundary-error-notification.runbook.link",
        defaultMessage: "See <runbookLink>this page</runbookLink> for details."
    }
});
const $003e065b50dd1979$export$4f6d1b579f9e99e4 = ({ operationName: operationName, errorType: errorType, args: args })=>{
    const expectedBoundaries = args?.expectedBoundaries?.join(', ') || '';
    const currentBoundaries = args?.currentBoundaries?.join(" \u2192 ") || '';
    const renderMessage = ()=>{
        switch(errorType){
            case 'outside-boundary':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$003e065b50dd1979$var$i18n.outsideBoundaryError,
                    values: {
                        operationName: operationName,
                        expectedBoundaries: expectedBoundaries
                    }
                });
            case 'boundary-mismatch':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$003e065b50dd1979$var$i18n.boundaryMismatchError,
                    values: {
                        operationName: operationName,
                        expectedBoundaries: expectedBoundaries,
                        currentBoundaries: currentBoundaries
                    }
                });
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "queryBoundaryErrorMessage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, renderMessage()), (errorType === 'boundary-mismatch' || errorType === 'outside-boundary') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...$003e065b50dd1979$var$i18n.runbookLink,
        values: {
            runbookLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $i1t43.default), {
                    target: "_blank",
                    href: $003e065b50dd1979$var$RUNBOOK_URL
                }, chunks)
        }
    }));
};


class $82be4d32af71312a$var$BoundaryErrorHandler {
    constructor(flags){
        this.flags = flags;
        this.errorStream = void 0;
        this.cleanup = ()=>{
            if (this.errorStream) this.errorStream.removeListener(this.handleBoundaryError);
        };
        this.handleBoundaryError = (error)=>{
            const flagId = `query-boundary-${error.errorType}-${error.operationName}`;
            let flagTitle = null;
            switch(error.errorType){
                case 'outside-boundary':
                    flagTitle = 'Query Used Outside Suspense Boundary!';
                    break;
                case 'boundary-mismatch':
                    flagTitle = 'Query Boundary Mismatch!';
                    break;
            }
            if (flagTitle) this.flags.showErrorFlag({
                id: flagId,
                title: flagTitle,
                isAutoDismiss: false,
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $003e065b50dd1979$export$4f6d1b579f9e99e4), error)
            });
        };
        if (window.__SSR_REACT_STREAMING__) {
            this.errorStream = (0, $1z9oK.getClientStream)('query-boundary-errors');
            this.errorStream.addListener(this.handleBoundaryError);
        }
    }
}
const $82be4d32af71312a$export$edc06ce642e48a51 = (0, $7aRa9.withFlags)(({ flags: flags })=>{
    (0, $cozmU.useEffect)(()=>{
        if (!window.__SSR_REACT_STREAMING__) return;
        // Create the handler which will automatically set up the listener
        const handler = new $82be4d32af71312a$var$BoundaryErrorHandler(flags);
        return ()=>{
            handler.cleanup();
        };
    }, [
        flags
    ]);
    return null;
});
const $82be4d32af71312a$export$5413c6653c828d95 = ()=>{
    return null;
};












const $875130f53b935742$export$9bfc14d39c192dcd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "Tqz5C",
    name: "InconsistentLicenseFlag",
    loader: async ()=>(await (parcelRequire("l1eT4"))).InconsistentLicenseFlag
});





var $h3nb6 = parcelRequire("h3nb6");


var $7Snc9 = parcelRequire("7Snc9");




var $arkw6 = parcelRequire("arkw6");


var $3j0Cc = parcelRequire("3j0Cc");


var $jwv1p = parcelRequire("jwv1p");


var $eIKcA = parcelRequire("eIKcA");


var $4QflW = parcelRequire("4QflW");





const $a409a9cb99445cc0$var$ShortcutsProvider = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zhDj6",
    name: "ShortcutsProvider",
    loader: ()=>(parcelRequire("gjZQ9"))
});
var $a409a9cb99445cc0$export$2e2bcd8739ae039 = $a409a9cb99445cc0$var$ShortcutsProvider;


















const $1f18aab14ff5333d$export$4a5ef4d351acbcfc = async (url, isTransition)=>{
    const shouldPreload = isTransition || !window.__SSR_RENDERED__;
    let match;
    if (match = (0, $kM8fE.matchHome)(url)) (0, $jwv1p.preloadHome)(match);
    else if ((0, $kM8fE.matchSpaceOverview)(url)) {
        if (shouldPreload) (0, $jwv1p.preloadSpaceOverview)();
    } else if ((0, $kM8fE.matchLivePage)(url) && shouldPreload) {
        if (await (0, $aXEzU.waitUntilStatsigInitialized)()) (0, $jwv1p.preloadLivePagesComponents)();
    } else if ((match = (0, $kM8fE.matchAccessLink)(url)) && shouldPreload) // Neither `matchLivePage` nor `matchViewPage` can match here: they need a VIEW_PAGE match plus
    // cached page data, and an access-link URL carries only a token. So the chunks have to be
    // resolved explicitly, and which set to preload depends on what the token resolves to.
    {
        if (await (0, $aXEzU.waitUntilStatsigInitialized)() && (0, $6mKj3.expValEquals)('access_link_m3', 'isEnabled', true)) {
            const content = await (0, $149b2696471ec09e$export$5ff0d8e28a402df2)(match.params.shareToken);
            if (content?.subType === (0, $83sfO.LIVE_PAGE_SUBTYPE)) (0, $jwv1p.preloadLivePagesComponents)();
            else if (content?.type === 'page') (0, $jwv1p.preloadAccessLinkViewPageComponents)({
                ...match,
                params: {
                    ...match.params,
                    contentId: content.contentId,
                    spaceKey: content.spaceKey
                }
            });
        }
    } else if (match = (0, $kM8fE.matchViewPage)(url)) {
        if (shouldPreload) (0, $jwv1p.preloadViewPageComponents)(match);
    } else if ((0, $kM8fE.matchFabricEditor)(url)) (0, $jwv1p.preloadNativeEditorComponentsPreloader)();
    else if ((0, $kM8fE.matchCreateContent)(url)) (0, $jwv1p.preloadCreateContent)();
    else if ((0, $kM8fE.matchWhiteboardPage)(url)) (0, $jwv1p.preloadWhiteboardPage)();
    else if ((0, $kM8fE.matchSearch)(url)) (0, $jwv1p.preloadSearch)();
};



var $f5Xkw = parcelRequire("f5Xkw");





var $50adebb1075ad3af$export$2e2bcd8739ae039 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "exd9t",
    name: "packages.confluence-frontend-server.src.components.ReduxError.src.index",
    loader: ()=>(parcelRequire("aTktW"))
});


const $126a66f6ad21916b$var$browserHistory = (0, $hmRc4.getBrowserHistory)();
const $126a66f6ad21916b$var$appNamedRoutes = {
    ...(0, $64KID.namedRoutes),
    [(0, $1NBp8.ADMIN_CREATE_WITH_ROVO).name]: (0, $1NBp8.ADMIN_CREATE_WITH_ROVO)
};
function $126a66f6ad21916b$export$86fbec116b87613f({ sessionData: sessionData }) {
    (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance.mark('CFP-63.app-component-render');
    (0, $10fd4e7f95cabba0$export$6a82770d3a3903f7)();
    (0, $cozmU.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).__SSR_ERROR__) (0, $5ZqQS.getMonitoringClient)().submitError(JSON.stringify({
            ssrError: (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).__SSR_ERROR__
        }), {
            // Having '-ssr' suffix to not mix with FE Error detector. Set another dedicated cc-fe-performance detector.
            attribution: 'backbone-ssr'
        });
    }, []);
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const { isDesktop: isDesktop } = (0, $2JYae.useIsDesktop)();
    const { isMobileApp: isMobileApp } = (0, $bj5fB.useIsMobileApp)();
    const isPdfExportRoute = typeof (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))) !== 'undefined' && (0, $1NBp8.PDF_EXPORT_PAGE).match((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location.pathname);
    const { isLoggedIn: isLoggedIn, isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const isRovoEnabled = isRovoLLMEnabled && isLoggedIn && accessStatus !== (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
    // When loading confluence from the mobile app, we need the theme to respect the system color mode of the app.
    // When embedded, respect the theme the embedding product passes in the `themeState` query param (SSR and
    // the embedded page components already do). Otherwise the user's saved Confluence theme is applied after
    // the SPA loads and overrides it (e.g. a dark Jira Docs page flashing to light).
    const embeddedThemeState = new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location.search).get('themeState');
    let initialTheme;
    if (isMobileApp) initialTheme = (0, $3WLLD.mobileAppTheme);
    else if (embeddedThemeState && (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)((0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).location) && (0, $6mKj3.expValEquals)('team-europe-bugfixes-for-jira-docs_sprt', 'isEnabled', true)) initialTheme = (0, $83wRA.getThemeFromQueryParams)({
        themeState: embeddedThemeState
    });
    // Initializing the theme in a non-blocking way, instead of using <ThemeContainer>, so
    // that the app does not flash and re-paint after the SPA loads on top of the SSR page.
    (0, $0f25e4f8facf0d0e$export$913cb5ed19d2180b)(initialTheme);
    // Lite Mode™ check outside of the router
    // For certain pages supporting lite mode some functionality is not needed
    const isLite = (0, $aFbGo.isViewPageLite)();
    // Check if app is being loaded in iFrame
    // We don't want to render the Rovo Chat wrapper if in iFrame
    const isIframe = typeof (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))) !== 'undefined' && (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).self !== (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).top;
    const startPageLoadMetrics = (0, $cozmU.useCallback)((routeName = '', ufoName = routeName, transitionId, contentId = '')=>{
        (0, $jfrcs.startBrowserMetricsPageLoad)(routeName, ufoName, transitionId, contentId);
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $7SkLu.addUFOCustomCohortData)('isDesktop', isDesktop);
        else (0, $gXfti.addUFOCustomData)({
            isDesktop: isDesktop
        });
    }, [
        isDesktop
    ]);
    const onRoute = (0, $cozmU.useCallback)(async (match, transitionId)=>{
        // Reset window.__APOLLO_STATS__ on transition
        (0, $eHj6r.resetApolloStats)();
        // transitionId = 0 when it is initial load, and 0 is falsey
        if (transitionId) {
            // The page can't be rendered by SSR if is a transition
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__SSR_RENDERED__'] = false;
            //hydrateRoot and related logic should not be enabled on transitions
            //as its only for ssr rendered page
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__HYDRATABLE__'] = false;
            (0, $KcDWk.releaseSSRedLegacyMacros)();
            // Delayed content redirection is not needed on transitions
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__DELAYED_CONTENT_REDIRECTION__'] = {};
            if (0, $itS9i.debuggerEnabled) (0, $itS9i.clearAnalyticsDebugger)();
        } else {
            (0, $5ZqQS.getMonitoringClient)().incrementCounter('confluence-spa.react-initialized');
            (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI))).performance.mark('CFP-63.route-manager-initialized');
        }
        (0, $78QFu.setUniquePageLoadId)(match?.name ?? '', match, transitionId, sessionData);
        (0, $8Ss4E.startExperienceForRoute)(match, transitionId, sessionData);
        (0, $2ba6133bff070823$export$8c5248f0cec8446d).stream([
            {
                type: 'page-transition',
                ID: transitionId
            }
        ]);
        const transitionPreloaderCurrentCallbackIDs = (0, $ek3aD.getGlobalTransitionPreloader)().getCurrentRouteCallbackIds();
        // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
        const isSeamlessTransition = (0, $9wGTI.fg)('confluence_frontend_transition_preloading_system') ? transitionPreloaderCurrentCallbackIDs.includes('live_doc_preloading_transition_callback_id') && transitionId !== 0 : false;
        //if the new editor metrics FF is on, start BM here only if the route is not edit page or if it is initial load, or an embedded editor.
        if (!isSeamlessTransition && (!(0, $gEtAQ.isEditPage)(match?.name) || transitionId === 0 || (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)())) {
            (0, $jfrcs.startBrowserMetricsPageLoad)(match?.name ?? '', match?.ufoName, transitionId, match?.params.contentId);
            // oxlint-disable-next-line confluence-feature-gating/no-new-feature-gates
            if ((0, $9wGTI.fg)('platform_ufo_custom_cohort_data_migration')) (0, $7SkLu.addUFOCustomCohortData)('isDesktop', isDesktop);
            else (0, $gXfti.addUFOCustomData)({
                isDesktop: isDesktop
            });
            //If it is an embedded editor, start the BM right here since it does a full page reload
            if ((0, $gEtAQ.isEditPage)(match?.name) && (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)()) {
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_FMP_ACTION));
                (0, $iFjdQ.ExperienceActionMeasures).markMeasureStart((0, $5q601.EMBEDDED_EDIT_TTI_ACTION));
            }
        }
        // add SSR stats to initial page load only
        // we will be utilizing serverTime to track BE perf in Statsig
        if (transitionId === 0) {
            /** @type {Object<string, {startTime: number, duration: number} | undefined>} */ const ssrMeasure = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__SSR_MEASURES__'];
            const serverTime = ssrMeasure ? Object.keys(ssrMeasure).filter((key)=>key.includes('prepare/preloadQuery/fetch')).reduce((total, key)=>total + (ssrMeasure[key]?.duration ?? 0), 0) : 0;
            /** @type {number | undefined} */ const serverCallCount = (0, (/*@__PURE__*/$parcel$interopDefault($1i7uI)))['__FETCH_COUNT__'];
            if (serverTime && serverCallCount) (0, $gXfti.addUFOCustomData)({
                serverTime: serverTime,
                serverCallCount: serverCallCount
            });
        }
        // mark edit experience after transition to new route is complete
        (0, $192302f00fa5cc0a$export$8c3a984654991d73)(match?.name);
        (0, $5ZqQS.getMonitoringClient)().updateContext({
            pageName: match?.name ?? 'unknown',
            transitionId: transitionId,
            product: (0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)() ? 'embeddedConfluence' : 'confluence'
        });
    }, [
        sessionData,
        isDesktop
    ]);
    /**
   * Please note this App is a pure component.
   * This means following components will NOT re-render when user navigates.
   * Please be careful when adding any component that requires router information.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $852a6819cc9585c3$export$5f8d39834fd61797), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).BACKBONE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9i4uP.CreditsProvider), {
        product: "confluence",
        cloudId: cloudId,
        isRovoEnabled: isRovoEnabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iV00x.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $008c5cd8cb4c3a95$export$4e5ff544be3ec09b), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $82be4d32af71312a$export$5413c6653c828d95), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dBmJE.ConnectedRouter), {
        history: $126a66f6ad21916b$var$browserHistory,
        context: (0, $bEYte.ReactReduxContext)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kCeSx.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hzVuz.ExternalShareContextProvider), {
        path: $126a66f6ad21916b$var$browserHistory.location.pathname
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NAPtM.CreateDialogContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39rFu.EditPageLoadingContextProvider), {
        nativeEditorComponentsPreloader: (0, $eXODy.nativeEditorComponentsPreloader),
        livePageComponentsPreloader: (0, $jwv1p.preloadLivePagesComponents)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6UYek.SubscriptionsContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8n9tL.RouteManager), {
        routeComponents: (0, $h3nb6.routeComponents),
        namedRoutes: $126a66f6ad21916b$var$appNamedRoutes,
        notFound: (0, $7Snc9.NotFound),
        onInitialize: onRoute,
        onTransition: onRoute,
        onPreload: $126a66f6ad21916b$var$onPreloadRoute,
        routePolicy: routePolicy,
        setBrowserHistoryListener: (0, $hmRc4.setBrowserHistoryListener),
        startPageLoadMetrics: startPageLoadMetrics
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4QflW.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $af5e1b3a6aa255af$export$38f39b921d5551c1), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cBuRD.NotificationLandedEvent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f6158bccfa436061$export$560b992b8a813cfb), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ec4187ce4872c484$export$9f8d3084fd3d5fc0), null), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJiK8.Dialogs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arkw6.LazyCreateDialogQueryRenderer), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3j0Cc.LazyCreateDialogBlueprintWizardRenderer), null)), !isIframe && isRovoEnabled && !isPdfExportRoute && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aXWtB.ConfluenceConversationAssistant), {
        skipChatUI: true
    }), !isPdfExportRoute && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMLPM.RemixWatcherMount), null)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eIKcA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8bd37d13e213b9df$export$529640d4682c2), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a409a9cb99445cc0$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $50adebb1075ad3af$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iJELi.ConnectSupport), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25MM7.Flags), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $875130f53b935742$export$9bfc14d39c192dcd), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e4d79357fba42d43$export$b2c5189af5b5e948), {
        onWarningShown: (0, $f5Xkw.reportLocalStorageQuotaWarningShown)
    }), !isLite && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aeSHO.CopySpacePermissionsForLegacyNewSpace), null)))));
}
$126a66f6ad21916b$export$86fbec116b87613f.propTypes = {
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired
};
function $126a66f6ad21916b$var$onPreloadRoute({ url: url }, previousMatch, options) {
    (0, $1f18aab14ff5333d$export$4a5ef4d351acbcfc)(url, true);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJS) return;
    (0, $e80763d537fd4542$export$57d895781a697848)(url, true, previousMatch, options);
    if (options?.preloadingMode === (0, $hXDOc.PreloadingMode).onlyJSAndCriticalData) return;
    (0, $e80763d537fd4542$export$6aefe8c2dfd7fe98)(url);
}


class $2652ca00a3968b71$export$2e2bcd8739ae039 extends (0, $cozmU.Component) {
    render() {
        window.performance.mark('CFP-63.root-component-render');
        const { store: store, apolloClient: apolloClient, sessionData: sessionData } = this.props;
        return(// This is at the top because the root-level UnstatedProvider must not re-render
        // otherwise it will lose and recreate its instances
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Provider), {
            inject: [
                new (0, $hrAmX.BannerStateContainer)({
                    initialState: {
                        banners: window.__SSR_BANNERS__
                    }
                }),
                new (0, $bJX6u.ContentStateStateContainer)(window.__SSR_CONTENT_STATE__),
                new (0, $ktUCG.EmojiTitleStateContainer)(window.__SSR_EMOJI_TITLE__)
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lonEO.GraphqlProvider), {
            client: apolloClient
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bEYte.Provider), {
            store: store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f7i8j.SessionDataContext).Provider, {
            value: sessionData
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cryCi.Provider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1ytiN.SPAViewContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1kHsc.ExperienceTrackerContext).Provider, {
            value: (0, $fGzMp.getExperienceTracker)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jVK0t.I18nProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70d683a301b7be27$export$d900e4062895cd7c), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hpWmZ.default), {
            client: (0, $04e9M.getAnalyticsWebClient)()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kZDrw.NavdexListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $97W74.EngagementProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5ap9.ConfluenceAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $685338b3d2a4b0a3$export$2e865a7ec399eb55), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $brNvA.ReattachCommentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ec4187ce4872c484$export$fb465b6e855c1e85), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $126a66f6ad21916b$export$86fbec116b87613f), {
            sessionData: sessionData
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $362d8c5d9317edac$export$f6564e60882bdf90), null))))))))))))))))));
    }
}
$2652ca00a3968b71$export$2e2bcd8739ae039.displayName = 'Root';
$2652ca00a3968b71$export$2e2bcd8739ae039.propTypes = {
    /**
   * Global store
   */ store: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    apolloClient: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired,
    sessionData: (0, (/*@__PURE__*/$parcel$interopDefault($6b4nE))).object.isRequired
};






const $64ffce910ca717e1$var$ErrorType = Object.freeze({
    REMOVE_CHILD_ERROR: 'removeChildError',
    INSERT_BEFORE_ERROR: 'insertBeforeError'
});
function $64ffce910ca717e1$export$d1215808cd22e615() {
    if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function(child) {
            if (child.parentNode !== this) {
                if (console) {
                    console.error('Cannot remove a child from a different parent', child, this);
                    $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(child);
                }
                return child;
            }
            return originalRemoveChild.apply(this, arguments);
        };
        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function(newNode, referenceNode) {
            if (referenceNode && referenceNode.parentNode !== this) {
                if (console) {
                    console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode);
                }
                return newNode;
            }
            return originalInsertBefore.apply(this, arguments);
        };
    }
}
/**
 * Send an analytics event when a 'removeChild' error occurs. This function helps to track the occurrence of this suppressed error.
 * @param {Node} childNode - The node that is attempted to be removed.
 */ function $64ffce910ca717e1$var$sendRemoveChildErrorAnalyticsEvent(childNode) {
    const nodeData = {
        nodeToBeRemoved: $64ffce910ca717e1$var$extractNodeData(childNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.REMOVE_CHILD_ERROR, nodeData);
}
/**
 * Send an analytics event when an 'insertBefore' error occurs.  This function helps to track the occurrence of this suppressed error.
 * @param {Node} referenceNode - The existing node in the DOM tree. The new node is intended to be inserted before this node.
 * @param {Node} newNode - The new node that is attempted to be inserted.
 */ function $64ffce910ca717e1$var$sendInsertBeforeErrorAnalyticsEvent(referenceNode, newNode) {
    const nodeData = {
        newNode: $64ffce910ca717e1$var$extractNodeData(newNode),
        referenceNode: $64ffce910ca717e1$var$extractNodeData(referenceNode)
    };
    $64ffce910ca717e1$var$sendAnalyticsEvent($64ffce910ca717e1$var$ErrorType.INSERT_BEFORE_ERROR, nodeData);
}
function $64ffce910ca717e1$var$sendAnalyticsEvent(action, nodeData) {
    (0, $04e9M.getAnalyticsWebClient)().then((client)=>{
        client.sendOperationalEvent({
            source: 'confluenceFrontendServer',
            actionSubject: 'domManipulationError',
            action: 'error',
            attributes: {
                suppressedError: action,
                ...nodeData
            }
        });
    });
}
function $64ffce910ca717e1$var$extractNodeData(node) {
    if (!node) return {};
    return {
        nodeName: node.nodeName,
        parentElementNodeName: node.parentElement?.nodeName,
        isConnected: node.isConnected
    };
}



var $7LuKf = parcelRequire("7LuKf");







function $55460e99d99202dd$export$841e9db237ec2bdb(rootNode) {
    const walker = document.createTreeWalker(rootNode, NodeFilter.SHOW_COMMENT, {
        acceptNode: (node)=>{
            return node.nodeValue === '$' ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        }
    });
    const suspenseComments = [];
    let currentNode = null;
    while(currentNode = walker.nextNode())suspenseComments.push(currentNode);
    return suspenseComments;
}
function $55460e99d99202dd$export$c4c689e5d93ba5b6(node) {
    // Check if the node itself has data-hydration-shield
    if (node.nodeType === Node.ELEMENT_NODE && node.hasAttribute('data-hydration-shield')) return true;
    // Check if the parent has data-hydration-shield
    const parent = node.parentNode;
    if (parent?.nodeType === Node.ELEMENT_NODE && parent.hasAttribute('data-hydration-shield')) return true;
    return false;
}
function $55460e99d99202dd$export$9efc73f328295609(boundary) {
    let nextNode = boundary.nextSibling;
    // Skip text nodes that are just whitespace
    while(nextNode && nextNode.nodeType === Node.TEXT_NODE && !nextNode.textContent?.trim())nextNode = nextNode.nextSibling;
    // Return the next node if it is an element node
    if (nextNode && nextNode.nodeType === Node.ELEMENT_NODE) return nextNode;
}
function $55460e99d99202dd$export$b5009d2dcc72fd5c(rootNode, root) {
    (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).flushSync(()=>{
        $55460e99d99202dd$export$841e9db237ec2bdb(rootNode).forEach((boundary)=>{
            const node = $55460e99d99202dd$export$9efc73f328295609(boundary);
            if (node && $55460e99d99202dd$export$c4c689e5d93ba5b6(node)) {
                if (!(0, $6mKj3.expVal)('confluence_frontend_skip_activatable_hydration', 'isEnabled', false)) return;
            }
            if (node) root.unstable_scheduleHydration(node);
        });
        root.unstable_scheduleHydration(rootNode);
    });
}


const $201e99cf1dd95227$var$createPhase = (actualDuration, startTime, commitTime)=>{
    const end = performance.now();
    return {
        start: startTime,
        end: end,
        renderMs: commitTime - startTime,
        commitMs: end - commitTime,
        actualRenderMs: actualDuration,
        commits: 1
    };
};
function $201e99cf1dd95227$export$9247250587d7b2df(onComplete) {
    let shell;
    let syncBoundaries;
    let isComplete = false;
    return (_id, _phase, actualDuration, _baseDuration, startTime, commitTime)=>{
        if (isComplete) return;
        const phase = $201e99cf1dd95227$var$createPhase(actualDuration, startTime, commitTime);
        if (!shell) {
            shell = phase;
            queueMicrotask(()=>{
                isComplete = true;
                onComplete({
                    shell: phase,
                    syncBoundaries: syncBoundaries
                });
            });
            return;
        }
        syncBoundaries = syncBoundaries ? {
            start: syncBoundaries.start,
            end: phase.end,
            renderMs: syncBoundaries.renderMs + phase.renderMs,
            commitMs: syncBoundaries.commitMs + phase.commitMs,
            actualRenderMs: syncBoundaries.actualRenderMs + phase.actualRenderMs,
            commits: syncBoundaries.commits + 1
        } : phase;
    };
}



var $8Zvnr = parcelRequire("8Zvnr");


var $hSZic = parcelRequire("hSZic");


var $gx9wu = parcelRequire("gx9wu");

function $f31af9c25e6171d9$export$b3bc47985717b49e(opts = {}) {
    if (!globalThis.__vcObserver) {
        const shouldMockVCObserver = !(0, $8Zvnr.isEnvironmentSupported)();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $hSZic.VCObserverNOOP)() : new (0, $gx9wu.VCObserverWrapper)(opts);
    }
    return globalThis.__vcObserver;
}


const $cff4f803b29c74e8$export$e99e0154cbe3afef = (rootNode)=>{
    const vcObserver = (0, $f31af9c25e6171d9$export$b3bc47985717b49e)();
    vcObserver.setSSRElement(rootNode);
    vcObserver.setReactRootRenderStart();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            vcObserver.setReactRootRenderStop();
        });
    });
};


function $82f3624e89bd584a$export$62028ff70825ead9(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
}





const $c641ec602c55a36e$var$MAX_ERROR_STACK_LENGTH = 100000;
const $c641ec602c55a36e$var$DEFAULT_STACK_LENGTH = 1000;
const $c641ec602c55a36e$export$423e2732e9c54334 = ({ componentStack: componentStack })=>{
    if (!componentStack) return '';
    let loggingConfig = {};
    try {
        loggingConfig = JSON.parse((0, $1xpoY.default).getString('confluence_hydration_error_logging', '{}'));
    } catch (error) {
    // no-op, if an error occurs here, there's really nowhere to submit it
    }
    if (loggingConfig.stack) {
        const errorStackLogLen = loggingConfig.stackLength ?? $c641ec602c55a36e$var$DEFAULT_STACK_LENGTH;
        const clampedErrorStackLog = Math.min($c641ec602c55a36e$var$MAX_ERROR_STACK_LENGTH, errorStackLogLen);
        return componentStack.toString().substring(0, clampedErrorStackLog) ?? '';
    }
    return '';
};



function $301b91f6022f88c3$export$6f190738a936fdf9(error, errorInfo) {
    if (typeof window !== 'undefined' && window.dispatchEvent) window.dispatchEvent(new CustomEvent('hydrationError', {
        detail: {
            error: error.message,
            stack: (0, $c641ec602c55a36e$export$423e2732e9c54334)(errorInfo),
            timestamp: Date.now()
        }
    }));
}



var $awd1Q = parcelRequire("awd1Q");





var $7RVQB = parcelRequire("7RVQB");

let $c4a23b150b65622f$var$translationPromise = null;
async function $c4a23b150b65622f$export$d72c30eb19cf29ca() {
    if ($c4a23b150b65622f$var$translationPromise === null) $c4a23b150b65622f$var$translationPromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_TRANSLATION, ()=>(0, $awd1Q.loadTranslation)((0, $7RVQB.lazyLanguage)));
    return $c4a23b150b65622f$var$translationPromise;
}








function $2430be288db8ba8d$export$7424fb7c300d6ad9() {
    const maxStackSize = (0, $1xpoY.default).getNumber('confluence_frontend_dev_console_max_stack_size', 0);
    // Default value means don't trim stacks.
    if (maxStackSize === 0 || !(0, $cMvQV.isChrome)()) return;
    // The code below takes many hints from React devtools code
    // https://github.com/facebook/react/blob/c80a07509582daadf275f36ffe7a88c3b12e9db4/packages/react-devtools-shared/src/hook.js#L456
    for (const method of [
        'error',
        'warn'
    ]){
        const originalMethod = console[method];
        console[method] = function(...args) {
            if (args.length === 0) return;
            const lastArg = args[args.length - 1];
            // React's custom built component stack strings match "\s{4}in"
            // Chrome's prefix matches "\s{4}at"
            if (typeof lastArg === 'string' && /\s{4}(in|at)\s{1}/.test(lastArg)) {
                const firstArg = args[0];
                const newArgs = args.slice();
                if (args.length > 1 && typeof firstArg === 'string' && firstArg.endsWith('%s')) newArgs[0] = firstArg.slice(0, firstArg.length - 2); // Strip the %s param
                // Create a fake Error so that when we print it we get native source maps. Every
                // browser will print the .stack property of the error and then parse it back for source
                // mapping.
                const fakeError = new Error('');
                // It has to start with ^[\w.]*Error\b to trigger stack formatting.
                fakeError.name = 'Error Component Stack';
                // Overwrite the stack property with the trimmed stack trace.
                fakeError.stack = lastArg.split('\n').slice(0, maxStackSize + 1).join('\n');
                newArgs[newArgs.length - 1] = fakeError;
                // If the developer has React devtools extension installed, it contains its own override logic for console methods,
                // which is downstream of our implementation here. If the extension's "append component stacks" setting is on,
                // then it will end up appending a second stack trace to the one we're providing. Thus we need to force that
                // setting to be off temporarily.
                let originalAppendComponentStack;
                const reactDevtoolsSettings = window.__REACT_DEVTOOLS_GLOBAL_HOOK__?.settings;
                if (reactDevtoolsSettings) {
                    originalAppendComponentStack = reactDevtoolsSettings.appendComponentStack;
                    reactDevtoolsSettings.appendComponentStack = false;
                }
                originalMethod(...newArgs);
                if (reactDevtoolsSettings) reactDevtoolsSettings.appendComponentStack = originalAppendComponentStack;
            } else originalMethod(...args);
        };
    }
}








const $ba6acd3d9f4d6907$export$1efb2e25dea8cbfc = ()=>{
    (0, $6mKj3.expVal)('move_statsig_bootstrap_after_fmp', 'isEnabled', false);
    (0, $6mKj3.expVal)('confluence_media_token_preload_agg_query', 'isEnabled', false);
    (0, $6mKj3.expVal)('confluence_react_streaming_all_routes', 'isEnabled', false);
    (0, $6mKj3.expVal)('confluence_anon_react_streaming', 'isEnabled', false);
    if ((0, $gEtAQ.isSpaceOverview)()) (0, $6mKj3.expVal)('confluence_space_overview_react_streaming', 'isEnabled', false);
    // The server reads this in addLoadableId for streamed pages, so only those pages are exposed.
    if (window.__SSR_REACT_STREAMING__) (0, $6mKj3.expVal)('confluence_ssr_streamed_loadable_preload', 'isEnabled', false);
};


if (window?.performance) {
    window.performance.mark('CFP-63.app');
    window.performance.mark('navigation-fmp.NavigationFMP.start');
    window.performance.mark('side-navigation-fmp.SideNavigationFMP.start');
}
const $67148092cd3543c6$var$logger = (0, $7W8i8.getLogger)('SPAEntry');
// Non-streaming pages use renderToString, which leaves every still-pending Suspense boundary for the
// client without a digest. React reports that as error #419, or in development as renderToString's
// own message.
const $67148092cd3543c6$var$isNonStreamingError419 = (error)=>!window.__SSR_REACT_STREAMING__ && /Minified React error #419|The server used "renderToString" which does not support Suspense/.test(error?.message ?? '');
// Try load translation early if we know locale from SSR
if (window.__SSR_LOCALE__) (0, $c4a23b150b65622f$export$d72c30eb19cf29ca)();


(0, $82f3624e89bd584a$export$62028ff70825ead9)(async function() {
    /**
   * setupUFOGlobalErrorHandler MUST be the first thing executed before any rendering operations.
   * This ensures we catch and track any errors that occur during the app's initialization,
   * including async operations and React rendering. Moving this call later would risk missing
   * early errors.
   * it provides ufo:errors:globalCount is the count of all errors which occurred on the client all up
   */ (0, $fAsH0.default)();
    // When page is being refreshed or redirected from server we run into a condition when redirect
    // url requested from the server and SPA (which resources are loaded via early HTML flush) is
    // being initialized at the same time. We don't want to waste browser resources/make network
    // calls when page is going to be redirected anyway, so bail out early.
    if (document.querySelector(`meta[http-equiv="Refresh"]`)) return;
    const rootNode = document.getElementById('confluence-ui');
    if (window.__HYDRATABLE__) {
        // remove nonce attributes from style tags to support react hydration
        document.querySelectorAll('style[nonce]').forEach((styleTag)=>{
            styleTag.removeAttribute('nonce');
        });
        (0, $dA1Sn.saveFullCycleOutput)();
    }
    const { client: client, aggClient: aggClient } = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).CREATE_APOLLO_CLIENTS, ()=>{
        const apolloClient = (0, $hp2SH.getApolloClient)();
        const apolloAggClient = (0, $gKr8t.getAGGClient)();
        // Initialize the Relay environment alongside the Apollo clients so
        // `window.GLOBAL_RELAY_ENV` is set before any Relay-enabled interop
        // call (including the preloader interop path in
        // `@confluence/query-preloader-tools`). Mirrors how
        // `GLOBAL_APOLLO_AGG_CLIENT` is set during `getAGGClient()`.
        (0, $9HB34.getRelayEnvironment)();
        return {
            client: apolloClient,
            aggClient: apolloAggClient
        };
    });
    let initializeEmbeddedConfluencePromise;
    // @TODO: Update this to use `isMobileApp_DO_NOT_USE()` once we remove the experiment-gate
    if ((0, $lJlG6.isMobileApp_checkGateViaSSR_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("7PF1e"))).initialize();
    else if ((0, $lTECB.isEmbeddedConfluence_DO_NOT_USE)()) initializeEmbeddedConfluencePromise = (await (parcelRequire("hSMRQ"))).initialize();
    let browserNotSupported;
    // Must call this before any browser-helper functions, to ensure user agent has been set first
    (0, $cMvQV.setUserAgent)();
    // Bypass browser compatibility checks in the case of the Confluence native mobile app;
    // it is the responsibility of the mobile app to ensure the rendering of Confluence
    const shouldCheckBrowserCompatibility = !(0, $cMvQV.isNativeMobile)();
    if (shouldCheckBrowserCompatibility) {
        browserNotSupported = (0, $2DVQX.coreBrowserNotSupported)();
        if (browserNotSupported) // oxlint-disable-next-line react-js/no-deprecated
        return void (0, (/*@__PURE__*/$parcel$interopDefault($9kbTQ))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9j59h.BrowserNotSupportedLoader), null), rootNode);
    }
    const sessionDataPromise = (async ()=>{
        const sessionData = await (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_SESSION_DATA, ()=>(0, $aXEzU.getSessionDataAndInitializeStatsig)());
        const { userId: userId, isLicensed: isLicensed, monolithRegion: monolithRegion } = sessionData;
        // Expose synthetic environment flag to the window so downstream consumers
        // can detect it without importing @confluence/statsig-client avoiding possible circular dependencies.
        if ((0, $1xpoY.default).isKillSwitchOn('cc_e2e_stable_ui')) window.__IS_SYNTHETIC_ENV__ = true;
        // Note: this MUST be done before preload queries below
        // in order to ensure performant AGG queries
        (0, $8PKGr.initializeAggRegionSteeringHint)(monolithRegion);
        // If page is SSRed preload data that is only needed for hydration
        // If page is not SSRed, preload all the data.
        (0, $xwvlW.initializePreloaderFnContext)(sessionData);
        (0, $e80763d537fd4542$export$bd8e570400e2d126)();
        try {
            await (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_INITIALIZE_STORAGE_MANAGER, async ()=>{
                // Initialize browser storage controls after Statsig is ready (for proper feature gate evaluation)
                // This must happen before initializeStorageManager
                await (0, $7ZzSP.initializeBootstrapStorage)({
                    userId: userId,
                    cloudId: sessionData.cloudId
                });
                await (0, $17wUi.initializeStorageManager)({
                    userId: userId,
                    isLicensed: isLicensed
                });
                (0, $gnYQc.applyPersistedStatsigOverrides)();
                (0, $ae045ed661bc53ec$export$efcab8bd082cbc1f)(sessionData);
                (0, $30ba73f8286a8f5a$export$6381c51f97ce9880)(sessionData);
                if (!(0, $6mKj3.expVal)('platform_editor_insm_removal', 'isEnabled', false)) (0, $e8bac4b2464d29b3$export$77f9905a9b9e760d)(sessionData);
            });
            return sessionData;
        } catch  {
            // HOT-89887: server is giving 403 errors on an expired token, causing Apollo
            // to throw. Uncaught, the React app wouldn't start, and can't acknowledge
            // messages from the service worker; thus the service worker can't trigger a
            // redirect to the login page; thus user gets stuck at the Confluence logo
            // screen. By catching here, we can at least bootstrap the app and proceed to
            // the redirect.
            //
            // https://jira.atlassian.com/browse/CONFCLOUD-71974: IP allowlisting is
            // causing a 403 scenario similar to HOT-89887 above.
            return (0, $iC5L0.getEmptySessionData)();
        }
    })();
    // Preload loadable id defined in the global __LOADABLE__ array
    // If the page is rendered by React SSR service this promise will be blocking.
    // On normal SPA it is not blocking.
    const preloadLoadablePromise = (0, $hZpML.WaterfallMeasures).run((0, $hZpML.WATERFALL_INITIAL_MEASURES).BOOTSTRAP_LOADABLE, ()=>(0, $byLFK.preloadLoadable)());
    // Preload components/JS chunks as early as possible, when entry point is loaded and
    // route is known, so they'll be ready by the moment when they're actually used.
    (0, $1f18aab14ff5333d$export$4a5ef4d351acbcfc)(window.location.toString(), false);
    Promise.all([
        sessionDataPromise,
        // No-Op if load translation is already called earlier
        (0, $c4a23b150b65622f$export$d72c30eb19cf29ca)(),
        preloadLoadablePromise,
        initializeEmbeddedConfluencePromise
    ]).then(([sessionData])=>{
        // If cloudId is not present in sessionData, we can assume sessionData did not load successfully. Instead of
        // allowing the app to render the red error message, we can render our simplified Error App that fires key analytics
        // events and shows a more pleasing error UI.
        if (sessionData.cloudId === '') {
            let isMobileTakeoverPage = false;
            let isExternalSharePage = false;
            try {
                if (window?.location?.pathname) {
                    isMobileTakeoverPage = Boolean((0, $1NBp8.MOBILE_TAKEOVER_PAGE).match(window.location.pathname));
                    // Users with qm:-scoped guest session tokens (returning external share visitors)
                    // receive tenant: null from SiteInformationQuery because their tokens cannot
                    // authenticate against the tenant GraphQL resolver. This causes cloudId to be
                    // empty even though the session is valid. ExternalSharePage fetches content via
                    // the share token and does not require cloudId, so ErrorAppLoader must not render.
                    isExternalSharePage = Boolean((0, $1NBp8.EXTERNAL_SHARE).match(window.location.pathname)) || Boolean((0, $1NBp8.ACCESS_LINK).match(window.location.pathname));
                }
            } catch  {
                // If anything goes wrong, default to false (don't skip ErrorAppLoader)
                isMobileTakeoverPage = false;
                isExternalSharePage = false;
            }
            if (!isMobileTakeoverPage && !isExternalSharePage) {
                const root = (0, $fRQ3t.createRoot)(rootNode);
                root.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lTjel.ErrorAppLoader), {
                    entryPoint: "confluence-frontend",
                    sessionDataError: (0, $fcgrS.getSessionDataError)()
                }));
                return;
            }
        }
        if (!crypto.randomUUID) crypto.randomUUID = (0, $9HkI0.v4);
        // Redux store
        const store = (0, $3Tw8v.default)();
        (0, $9F7Qb.subscribe)(store);
        // When __APOLLO_STATE__ is available in the global variable it means we are bootstrapping SPA over a SSR rendered page.
        // __APOLLO_STATE__ is the serialized apollo cache that is enough to render everything that has already preloaded in preloadLoadable.
        // We are disabling network so on the first render so the components will read from cache only not firing queries again.
        // See https://github.com/apollographql/apollo-client/issues/4814
        if (window['__APOLLO_STATE__'] || window.__SSR_REACT_STREAMING__) client.disableNetworkFetches = true;
        if (window['__APOLLO_AGG_STATE__'] || window.__SSR_REACT_STREAMING__) aggClient.disableNetworkFetches = true;
        if (typeof window !== 'undefined') window.__CC_REACT_DOM_CONTEXT_PATCH__ = true;
        // Workaround for a race condition between Google Translate and React's DOM reconciliation.
        // Google Translate mutates the DOM by wrapping text nodes in <font> elements, reparenting
        // them under a new parent. When React later tries to removeChild or insertBefore on the
        // original parent, the node is no longer a child of that parent, causing a crash.
        // This patches Node.prototype.removeChild and insertBefore to gracefully handle the
        // mismatch instead of throwing.
        //
        // These patches must be applied unconditionally at startup. An on-demand approach that
        // used a MutationObserver to lazily install the patches only when Google Translate was
        // detected was attempted, but there is a race condition: Google Translate can reparent
        // nodes and trigger React's removeChild/insertBefore before the MutationObserver
        // callback fires to install the patches, so React still crashes.
        //
        // See: https://github.com/facebook/react/issues/11538#issuecomment-417504600
        // See: https://product-fabric.atlassian.net/browse/CCP-2409
        (0, $64ffce910ca717e1$export$d1215808cd22e615)();
        // code for regression drill logic. Systematic way of indentifying and tracking performance regressions in web pages
        // will be used to test out criterion, a new perfomacne tracking software
        // for more info visit https://hello.atlassian.net/wiki/spaces/CVMAI/pages/3761808800/Regression+Drill+Plan
        const delayValueForRegression = (0, $1xpoY.default).getNumber('confluence_frontend_preprod_slow', 0);
        delayValueForRegression;
        /**
     * Emotion has 2 ways of SSR support
     * 1. Render style tags along with the component
     * 2. Extract the styles with createEmotionServer
     * Normally we don't need t client side extraction because all the style tags should be in <head>
     * However with streaming there is no good way to support it.
     * The "css" key here is special it runs the logic of moving all the style tags to <head> before React hydrates on the the client side.
     * Reference: https://github.com/emotion-js/emotion/blob/38db311adf024fe8a24b57c687824c47abbd0957/packages/cache/src/index.ts#L63
     */ const cache = (0, $4jxwi.default)({
            key: 'css'
        });
        const App = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65DSU.default), {
            name: "confluence-root"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d847caf3274d14b7$export$f3385cdc6645f7e3), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7D1yr.C), {
            value: cache
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $799291abed68198f$export$640957ec8f6fdf34), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2652ca00a3968b71$export$2e2bcd8739ae039), {
            store: store,
            apolloClient: client,
            sessionData: sessionData
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8714b2bec379cfae$export$bd148a921cde8da1), null));
        const renderCallback = ()=>{
            // This is important broadcast in Apollo allows hooks that subscribe to the cache to be updated.
            // Broadcast is disabled until here.
            (0, $ca1d37ec2e96c685$export$c25b3a02c2d5dc72)().startBroadcast();
            (0, $0b6b84530a4d34b5$export$b4a2d416bf2548b)().startBroadcast();
            if (window['__APOLLO_STATE__'] || window.__SSR_REACT_STREAMING__) client.disableNetworkFetches = false;
            if (window['__APOLLO_AGG_STATE__'] || window.__SSR_REACT_STREAMING__) aggClient.disableNetworkFetches = false;
            const userAgentParser = new (0, (/*@__PURE__*/$parcel$interopDefault($gJN0g)))(navigator.userAgent);
            const { name: browserName, version: browserVersion } = userAgentParser.getBrowser();
            (0, $7LuKf.initialization)(sessionData, {
                browserName: browserName
            });
            // Inside of cleanUpLoadablePlaceholders function, it delayed cleaning up loadable placeholders.
            (0, $ezH4I.cleanUpLoadablePlaceholders)();
            (0, $KcDWk.releaseUnusedSSRedLegacyMacrosWithDelay)();
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsClient)=>{
                // GASv3 analytics client is initialized inside of initialization() so we
                // must call the analytics client after that function has been called.
                if (shouldCheckBrowserCompatibility) analyticsClient.sendOperationalEvent({
                    source: 'confluenceRoot',
                    action: 'executed',
                    actionSubject: 'browserRuntimeCheck',
                    attributes: {
                        failedCoreBrowserCheck: browserNotSupported,
                        browserName: browserName,
                        browserVersion: browserVersion
                    }
                });
            });
            if (rootNode) (0, $cff4f803b29c74e8$export$e99e0154cbe3afef)(rootNode);
        };
        const reportHydrationPhases = ({ shell: shell, syncBoundaries: syncBoundaries })=>{
            try {
                performance.measure('confluence-hydration:shell', {
                    start: shell.start,
                    end: shell.end
                });
                if (syncBoundaries) performance.measure('confluence-hydration:sync-boundaries', {
                    start: syncBoundaries.start,
                    end: syncBoundaries.end
                });
            } catch  {
            // performance.measure with options is unsupported in older browsers
            }
            const hydrationPhases = {
                // From hydrateRoot to the shell render starting
                queueMs: Math.round(shell.start - window['__HYDRATION_START__']),
                shellRenderMs: Math.round(shell.renderMs),
                shellCommitMs: Math.round(shell.commitMs),
                shellActualRenderMs: Math.round(shell.actualRenderMs),
                syncBoundariesRenderMs: Math.round(syncBoundaries?.renderMs ?? 0),
                syncBoundariesCommitMs: Math.round(syncBoundaries?.commitMs ?? 0),
                syncBoundariesActualRenderMs: Math.round(syncBoundaries?.actualRenderMs ?? 0),
                syncBoundariesCommits: syncBoundaries?.commits ?? 0,
                // From the shell render starting to the last sync boundary commit, including the
                // useEffect callbacks that run between them
                totalMs: Math.round((syncBoundaries ?? shell).end - shell.start)
            };
            (0, $gXfti.addUFOCustomData)({
                hydrationPhases: hydrationPhases
            });
            $67148092cd3543c6$var$logger.debug`Hydration phases: ${JSON.stringify(hydrationPhases)}`;
        };
        // Set before hydrateRoot when hydration phase timing is enabled
        let onHydrationPhaseRender = null;
        const ConcurrentApp = ()=>{
            (0, $cozmU.useEffect)(()=>{
                if (window['__HYDRATION_START__']) $67148092cd3543c6$var$logger.debug`Hydration finished in ${Math.floor(performance.now() - window['__HYDRATION_START__'])}ms`;
                renderCallback();
            }, []);
            if (onHydrationPhaseRender) // Renders no DOM, so the first client render still matches the server output
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Profiler), {
                id: "confluence-hydration-phases",
                onRender: onHydrationPhaseRender
            }, App);
            return App;
        };
        // If there are loadable timeouts, there is a very high chance hydration will also fail
        // Trying to hydrate and failing is more expensive than running createRoot from the start so we skip hydration in this case
        if (window['__LOADABLE_TIMEOUTS__']?.length) window['__HYDRATABLE__'] = false;
        const isHydratable = window['__HYDRATABLE__'];
        // The browser Statsig client is initialized by sessionDataPromise before this callback runs.
        (0, $ba6acd3d9f4d6907$export$1efb2e25dea8cbfc)();
        if (isHydratable) {
            if ((0, $6mKj3.expValEquals)('confluence_frontend_hydration_phase_timing', 'isEnabled', true)) onHydrationPhaseRender = (0, $201e99cf1dd95227$export$9247250587d7b2df)(reportHydrationPhases);
            window['__HYDRATION_START__'] = performance.now();
            window['__HYDRATION_FAILED__'] = false;
            $67148092cd3543c6$var$logger.debug`Starting hydration`;
            const root = (0, $fRQ3t.hydrateRoot)(rootNode, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConcurrentApp, null), {
                onRecoverableError: (error, errorInfo)=>{
                    if (errorInfo?.digest === (0, $a9dbb7d463eed498$export$8d8225dd22e8df51) || errorInfo?.digest === (0, $a9dbb7d463eed498$export$5b7b52703d0f3e95) || $67148092cd3543c6$var$isNonStreamingError419(error)) {
                        $67148092cd3543c6$var$logger.debug`SSR boundary rendered on the client: ${errorInfo?.digest ?? error.message}`;
                        return;
                    }
                    if (window['__HYDRATION_ERRORS__'] && error?.message) window['__HYDRATION_ERRORS__'].push({
                        type: 'ERROR_MESSAGES_FROM_REACT',
                        msg: error.message,
                        stack: (0, $c641ec602c55a36e$export$423e2732e9c54334)(errorInfo)
                    });
                    const { hydrationFailed: hydrationFailed, friendlyMessage: friendlyMessage, docLink: docLink } = (0, $dtDUi.matchHydrationError)(error);
                    if (hydrationFailed) {
                        window['__HYDRATION_FAILED__'] = true;
                        if ((0, $1xpoY.default).getBoolean('confluence_frontend_hydration_error_event', false)) (0, $301b91f6022f88c3$export$6f190738a936fdf9)(error, errorInfo);
                    }
                }
            });
            window.__REACT_ROOT__ = root;
            if (window.__SSR_REACT_STREAMING__) // When streaming is enabled, we can schedule a synchronous hydration for all
            // resolved suspense boundaries in the root node as otherwise there is a
            // performance regression in React 18 that impacts TTAI
            //
            // https://hello.atlassian.net/wiki/spaces/~moates/pages/5497372057/Challenges+with+Selective+Hydration
            //
            // When we move to React 19 we can remove this.
            //
            // @see scheduleSyncHydration
            (0, $55460e99d99202dd$export$b5009d2dcc72fd5c)(rootNode, root);
        } else {
            const concurrentRoot = (0, $fRQ3t.createRoot)(rootNode);
            concurrentRoot.render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ConcurrentApp, null));
        }
    });
});
 }, ["7EorR","eaI3H","hFABq","aZinD","eiF7i","jD5ZU","h6rbF","hhss7","6iTkp","10Qad","4XCbb","9o15s","iubLg","8iu3F","bncmK","ffEVr","9TOep","htKpm","6w3bl","gaUhx","k507P","d0ZRF","dDiWc","bmOOW","jwMHX","eF92L","cGkFm","j7JUO","7IvJj","2yyll","el1U6","a7sEM","37v60","l4j2l","botpL","fYx6U","asCsc","kJASg","1lDWJ","fEMSy","248rq","g7vSH","cIoRg","g2wVX","dqLHj","lIiD7","kfGHh","h3Rq9","aRCaA","bkMxV","dxA9F","d66hN","9LJFK","eUsnQ","7SteV","48F3z","15jTz","3pbEq","esBxc","aUXrB","gdp0M","kftjC","uyCHV","8VUAj","aVpwX","bqdgP","fU0ae","8faB9","gBTXw","5NuZb","6wr18","hUbK8","9NKkm","1QTBI"]);

$parcel$global.rlb("aFBfl")
//# sourceMappingURL=dashboard-spa-container-jquery3.15dd8930.js.map
